export const bigtxt_string : string = ` The Project Gutenberg EBook of The Adventures of Sherlock Holmes
by Sir Arthur Conan Doyle
(#15 in our series by Sir Arthur Conan Doyle)

Copyright laws are changing all over the world. Be sure to check the
copyright laws for your country before downloading or redistributing
this or any other Project Gutenberg eBook.

This header should be the first thing seen when viewing this Project
Gutenberg file.  Please do not remove it.  Do not change or edit the
header without written permission.

Please read the "legal small print," and other information about the
eBook and Project Gutenberg at the bottom of this file.  Included is
important information about your specific rights and restrictions in
how the file may be used.  You can also find out about how to make a
donation to Project Gutenberg, and how to get involved.


**Welcome To The World of Free Plain Vanilla Electronic Texts**

**eBooks Readable By Both Humans and By Computers, Since 1971**

*****These eBooks Were Prepared By Thousands of Volunteers!*****


Title: The Adventures of Sherlock Holmes

Author: Sir Arthur Conan Doyle

Release Date: March, 1999  [EBook #1661]
[Most recently updated: November 29, 2002]

Edition: 12

Language: English

Character set encoding: ASCII

*** START OF THE PROJECT GUTENBERG EBOOK, THE ADVENTURES OF SHERLOCK HOLMES ***




(Additional editing by Jose Menendez)



THE ADVENTURES OF
SHERLOCK HOLMES

BY

SIR ARTHUR CONAN DOYLE

CONTENTS

I.	A Scandal in Bohemia
II.	The Red-Headed League
III.	A Case of Identity
IV.	The Boscombe Valley Mystery
V.	The Five Orange Pips
VI.	The Man with the Twisted Lip
VII.	The Adventure of the Blue Carbuncle
VIII.	The Adventure of the Speckled Band
IX.	The Adventure of the Engineer's Thumb
X.	The Adventure of the Noble Bachelor
XI.	The Adventure of the Beryl Coronet
XII.	The Adventure of the Copper Beeches


ADVENTURE  I.  A SCANDAL IN BOHEMIA

I.


To Sherlock Holmes she is always the woman. I have seldom heard him mention her under any other name. In his eyes she eclipses and predominates the whole of her sex. It was not that he felt any emotion akin to love for Irene Adler. All emotions, and that one particularly, were abhorrent to his cold, precise but admirably balanced mind. He was, I take it, the most perfect reasoning and observing machine that the world has seen, but as a lover he would have placed himself in a false position. He never spoke of the softer passions, save with a gibe and a sneer. They were admirable things for the observer--excellent for drawing the veil from men's motives and actions. But for the trained reasoner to admit such intrusions into his own delicate and finely adjusted temperament was to introduce a distracting factor which might throw a doubt upon all his mental results. Grit in a sensitive instrument, or a crack in one of his own high-power lenses, would not be more disturbing than a strong emotion in a nature such as his. And yet there was but one woman to him, and that woman was the late Irene Adler, of dubious and questionable memory.

I had seen little of Holmes lately. My marriage had drifted us away from each other. My own complete happiness, and the home-centred interests which rise up around the man who first finds himself master of his own establishment, were sufficient to absorb all my attention, while Holmes, who loathed every form of society with his whole Bohemian soul, remained in our lodgings in Baker Street, buried among his old books, and alternating from week to week between cocaine and ambition, the drowsiness of the drug, and the fierce energy of his own keen nature. He was still, as ever, deeply attracted by the study of crime, and occupied his immense faculties and extraordinary powers of observation in following out those clues, and clearing up those mysteries which had been abandoned as hopeless by the official police. From time to time I heard some vague account of his doings: of his summons to Odessa in the case of the Trepoff murder, of his clearing up of the singular tragedy of the Atkinson brothers at Trincomalee, and finally of the mission which he had accomplished so delicately and successfully for the reigning family of Holland. Beyond these signs of his activity, however, which I merely shared with all the readers of the daily press, I knew little of my former friend and companion.

One night--it was on the twentieth of March, 1888--I was returning from a journey to a patient (for I had now returned to civil practice), when my way led me through Baker Street. As I passed the well-remembered door, which must always be associated in my mind with my wooing, and with the dark incidents of the Study in Scarlet, I was seized with a keen desire to see Holmes again, and to know how he was employing his extraordinary powers. His rooms were brilliantly lit, and, even as I looked up, I saw his tall, spare figure pass twice in a dark silhouette against the blind. He was pacing the room swiftly, eagerly, with his head sunk upon his chest and his hands clasped behind him. To me, who knew his every mood and habit, his attitude and manner told their own story. He was at work again. He had risen out of his drug-created dreams and was hot upon the scent of some new problem. I rang the bell and was shown up to the chamber which had formerly been in part my own.

His manner was not effusive. It seldom was; but he was glad, I think, to see me. With hardly a word spoken, but with a kindly eye, he waved me to an armchair, threw across his case of cigars, and indicated a spirit case and a gasogene in the corner. Then he stood before the fire and looked me over in his singular introspective fashion.

"Wedlock suits you," he remarked. "I think, Watson, that you have put on seven and a half pounds since I saw you."

"Seven!" I answered.

"Indeed, I should have thought a little more. Just a trifle more, I fancy, Watson. And in practice again, I observe. You did not tell me that you intended to go into harness."

"Then, how do you know?"

"I see it, I deduce it. How do I know that you have been getting yourself very wet lately, and that you have a most clumsy and careless servant girl?"

"My dear Holmes," said I, "this is too much. You would certainly have been burned, had you lived a few centuries ago. It is true that I had a country walk on Thursday and came home in a dreadful mess, but as I have changed my clothes I can't imagine how you deduce it. As to Mary Jane, she is incorrigible, and my wife has given her notice, but there, again, I fail to see how you work it out."

He chuckled to himself and rubbed his long, nervous hands together.

"It is simplicity itself," said he; "my eyes tell me that on the inside of your left shoe, just where the firelight strikes it, the leather is scored by six almost parallel cuts. Obviously they have been caused by someone who has very carelessly scraped round the edges of the sole in order to remove crusted mud from it. Hence, you see, my double deduction that you had been out in vile weather, and that you had a particularly malignant boot-slitting specimen of the London slavey. As to your practice, if a gentleman walks into my rooms smelling of iodoform, with a black mark of nitrate of silver upon his right forefinger, and a bulge on the right side of his top-hat to show where he has secreted his stethoscope, I must be dull, indeed, if I do not pronounce him to be an active member of the medical profession."

I could not help laughing at the ease with which he explained his process of deduction. "When I hear you give your reasons," I remarked, "the thing always appears to me to be so ridiculously simple that I could easily do it myself, though at each successive instance of your reasoning I am baffled until you explain your process. And yet I believe that my eyes are as good as yours."

"Quite so," he answered, lighting a cigarette, and throwing himself down into an armchair. "You see, but you do not observe. The distinction is clear. For example, you have frequently seen the steps which lead up from the hall to this room."

"Frequently."

"How often?"

"Well, some hundreds of times."

"Then how many are there?"

"How many? I don't know."

"Quite so! You have not observed. And yet you have seen. That is just my point. Now, I know that there are seventeen steps, because I have both seen and observed. By the way, since you are interested in these little problems, and since you are good enough to chronicle one or two of my trifling experiences, you may be interested in this." He threw over a sheet of thick, pink-tinted notepaper which had been lying open upon the table. "It came by the last post," said he. "Read it aloud."

The note was undated, and without either signature or address.

"There will call upon you to-night, at a quarter to eight o'clock," it said, "a gentleman who desires to consult you upon a matter of the very deepest moment. Your recent services to one of the royal houses of Europe have shown that you are one who may safely be trusted with matters which are of an importance which can hardly be exaggerated. This account of you we have from all quarters received. Be in your chamber then at that hour, and do not take it amiss if your visitor wear a mask."

"This is indeed a mystery," I remarked. "What do you imagine that it means?"

"I have no data yet. It is a capital mistake to theorise before one has data. Insensibly one begins to twist facts to suit theories, instead of theories to suit facts. But the note itself. What do you deduce from it?"

I carefully examined the writing, and the paper upon which it was written.

"The man who wrote it was presumably well to do," I remarked, endeavouring to imitate my companion's processes. "Such paper could not be bought under half a crown a packet. It is peculiarly strong and stiff."

"Peculiar--that is the very word," said Holmes. "It is not an English paper at all. Hold it up to the light."

I did so, and saw a large "E" with a small "g," a "P," and a large "G" with a small "t" woven into the texture of the paper.

"What do you make of that?" asked Holmes.

"The name of the maker, no doubt; or his monogram, rather."

"Not at all. The 'G' with the small 't' stands for 'Gesellschaft,' which is the German for 'Company.' It is a customary contraction like our 'Co.' 'P,' of course, stands for 'Papier.' Now for the 'Eg.' Let us glance at our Continental Gazetteer." He took down a heavy brown volume from his shelves. "Eglow, Eglonitz--here we are, Egria. It is in a German-speaking country--in Bohemia, not far from Carlsbad. 'Remarkable as being the scene of the death of Wallenstein, and for its numerous glass-factories and paper-mills.' Ha, ha, my boy, what do you make of that?" His eyes sparkled, and he sent up a great blue triumphant cloud from his cigarette.

"The paper was made in Bohemia," I said.

"Precisely. And the man who wrote the note is a German. Do you note the peculiar construction of the sentence--'This account of you we have from all quarters received.' A Frenchman or Russian could not have written that. It is the German who is so uncourteous to his verbs. It only remains, therefore, to discover what is wanted by this German who writes upon Bohemian paper and prefers wearing a mask to showing his face. And here he comes, if I am not mistaken, to resolve all our doubts."

As he spoke there was the sharp sound of horses' hoofs and grating wheels against the curb, followed by a sharp pull at the bell. Holmes whistled.

"A pair, by the sound," said he. "Yes," he continued, glancing out of the window. "A nice little brougham and a pair of beauties. A hundred and fifty guineas apiece. There's money in this case, Watson, if there is nothing else."

"I think that I had better go, Holmes."

"Not a bit, Doctor. Stay where you are. I am lost without my Boswell. And this promises to be interesting. It would be a pity to miss it."

"But your client--"

"Never mind him. I may want your help, and so may he. Here he comes. Sit down in that armchair, Doctor, and give us your best attention."

A slow and heavy step, which had been heard upon the stairs and in the passage, paused immediately outside the door. Then there was a loud and authoritative tap.

"Come in!" said Holmes.

A man entered who could hardly have been less than six feet six inches in height, with the chest and limbs of a Hercules. His dress was rich with a richness which would, in England, be looked upon as akin to bad taste. Heavy bands of astrakhan were slashed across the sleeves and fronts of his double-breasted coat, while the deep blue cloak which was thrown over his shoulders was lined with flame-coloured silk and secured at the neck with a brooch which consisted of a single flaming beryl. Boots which extended halfway up his calves, and which were trimmed at the tops with rich brown fur, completed the impression of barbaric opulence which was suggested by his whole appearance. He carried a broad-brimmed hat in his hand, while he wore across the upper part of his face, extending down past the cheekbones, a black vizard mask, which he had apparently adjusted that very moment, for his hand was still raised to it as he entered. From the lower part of the face he appeared to be a man of strong character, with a thick, hanging lip, and a long, straight chin suggestive of resolution pushed to the length of obstinacy.

"You had my note?" he asked with a deep harsh voice and a strongly marked German accent. "I told you that I would call." He looked from one to the other of us, as if uncertain which to address.

"Pray take a seat," said Holmes. "This is my friend and colleague, Dr. Watson, who is occasionally good enough to help me in my cases. Whom have I the honour to address?"

"You may address me as the Count Von Kramm, a Bohemian nobleman. I understand that this gentleman, your friend, is a man of honour and discretion, whom I may trust with a matter of the most extreme importance. If not, I should much prefer to communicate with you alone."

I rose to go, but Holmes caught me by the wrist and pushed me back into my chair. "It is both, or none," said he. "You may say before this gentleman anything which you may say to me."

The Count shrugged his broad shoulders. "Then I must begin," said he, "by binding you both to absolute secrecy for two years; at the end of that time the matter will be of no importance. At present it is not too much to say that it is of such weight it may have an influence upon European history."

"I promise," said Holmes.

"And I."

"You will excuse this mask," continued our strange visitor. "The august person who employs me wishes his agent to be unknown to you, and I may confess at once that the title by which I have just called myself is not exactly my own."

"I was aware of it," said Holmes dryly.

"The circumstances are of great delicacy, and every precaution has to be taken to quench what might grow to be an immense scandal and seriously compromise one of the reigning families of Europe. To speak plainly, the matter implicates the great House of Ormstein, hereditary kings of Bohemia."

"I was also aware of that," murmured Holmes, settling himself down in his armchair and closing his eyes.

Our visitor glanced with some apparent surprise at the languid, lounging figure of the man who had been no doubt depicted to him as the most incisive reasoner and most energetic agent in Europe. Holmes slowly reopened his eyes and looked impatiently at his gigantic client.

"If your Majesty would condescend to state your case," he remarked, "I should be better able to advise you."

The man sprang from his chair and paced up and down the room in uncontrollable agitation. Then, with a gesture of desperation, he tore the mask from his face and hurled it upon the ground. "You are right," he cried; "I am the King. Why should I attempt to conceal it?"

"Why, indeed?" murmured Holmes. "Your Majesty had not spoken before I was aware that I was addressing Wilhelm Gottsreich Sigismond von Ormstein, Grand Duke of Cassel-Felstein, and hereditary King of Bohemia."

"But you can understand," said our strange visitor, sitting down once more and passing his hand over his high white forehead, "you can understand that I am not accustomed to doing such business in my own person. Yet the matter was so delicate that I could not confide it to an agent without putting myself in his power. I have come incognito from Prague for the purpose of consulting you."

"Then, pray consult," said Holmes, shutting his eyes once more.

"The facts are briefly these: Some five years ago, during a lengthy visit to Warsaw, I made the acquaintance of the well-known adventuress, Irene Adler. The name is no doubt familiar to you."

"Kindly look her up in my index, Doctor," murmured Holmes without opening his eyes. For many years he had adopted a system of docketing all paragraphs concerning men and things, so that it was difficult to name a subject or a person on which he could not at once furnish information. In this case I found her biography sandwiched in between that of a Hebrew rabbi and that of a staff-commander who had written a monograph upon the deep-sea fishes.

"Let me see!" said Holmes. "Hum! Born in New Jersey in the year 1858. Contralto--hum! La Scala, hum! Prima donna Imperial Opera of Warsaw--yes! Retired from operatic stage--ha! Living in London--quite so! Your Majesty, as I understand, became entangled with this young person, wrote her some compromising letters, and is now desirous of getting those letters back."

"Precisely so. But how--"

"Was there a secret marriage?"

"None."

"No legal papers or certificates?"

"None."

"Then I fail to follow your Majesty. If this young person should produce her letters for blackmailing or other purposes, how is she to prove their authenticity?"

"There is the writing."

"Pooh, pooh! Forgery."

"My private note-paper."

"Stolen."

"My own seal."

"Imitated."

"My photograph."

"Bought."

"We were both in the photograph."

"Oh, dear! That is very bad! Your Majesty has indeed committed an indiscretion."

"I was mad--insane."

"You have compromised yourself seriously."

"I was only Crown Prince then. I was young. I am but thirty now."

"It must be recovered."

"We have tried and failed."

"Your Majesty must pay. It must be bought."

"She will not sell."

"Stolen, then."

"Five attempts have been made. Twice burglars in my pay ransacked her house. Once we diverted her luggage when she travelled. Twice she has been waylaid. There has been no result."

"No sign of it?"

"Absolutely none."

Holmes laughed. "It is quite a pretty little problem," said he.

"But a very serious one to me," returned the King reproachfully.

"Very, indeed. And what does she propose to do with the photograph?"

"To ruin me."

"But how?"

"I am about to be married."

"So I have heard."

"To Clotilde Lothman von Saxe-Meningen, second daughter of the King of Scandinavia. You may know the strict principles of her family. She is herself the very soul of delicacy. A shadow of a doubt as to my conduct would bring the matter to an end."

"And Irene Adler?"

"Threatens to send them the photograph. And she will do it. I know that she will do it. You do not know her, but she has a soul of steel. She has the face of the most beautiful of women, and the mind of the most resolute of men. Rather than I should marry another woman, there are no lengths to which she would not go--none."

"You are sure that she has not sent it yet?"

"I am sure."

"And why?"

"Because she has said that she would send it on the day when the betrothal was publicly proclaimed. That will be next Monday."

"Oh, then we have three days yet," said Holmes with a yawn. "That is very fortunate, as I have one or two matters of importance to look into just at present. Your Majesty will, of course, stay in London for the present?"

"Certainly. You will find me at the Langham under the name of the Count Von Kramm."

"Then I shall drop you a line to let you know how we progress."

"Pray do so. I shall be all anxiety."

"Then, as to money?"

"You have carte blanche."

"Absolutely?"

"I tell you that I would give one of the provinces of my kingdom to have that photograph."

"And for present expenses?"

The King took a heavy chamois leather bag from under his cloak and laid it on the table.

"There are three hundred pounds in gold and seven hundred in notes," he said.

Holmes scribbled a receipt upon a sheet of his note-book and handed it to him.

"And Mademoiselle's address?" he asked.

"Is Briony Lodge, Serpentine Avenue, St. John's Wood."

Holmes took a note of it. "One other question," said he. "Was the photograph a cabinet?"

"It was."

"Then, good-night, your Majesty, and I trust that we shall soon have some good news for you. And good-night, Watson," he added, as the wheels of the royal brougham rolled down the street. "If you will be good enough to call to-morrow afternoon at three o'clock I should like to chat this little matter over with you."

II.


At three o'clock precisely I was at Baker Street, but Holmes had not yet returned. The landlady informed me that he had left the house shortly after eight o'clock in the morning. I sat down beside the fire, however, with the intention of awaiting him, however long he might be. I was already deeply interested in his inquiry, for, though it was surrounded by none of the grim and strange features which were associated with the two crimes which I have already recorded, still, the nature of the case and the exalted station of his client gave it a character of its own. Indeed, apart from the nature of the investigation which my friend had on hand, there was something in his masterly grasp of a situation, and his keen, incisive reasoning, which made it a pleasure to me to study his system of work, and to follow the quick, subtle methods by which he disentangled the most inextricable mysteries. So accustomed was I to his invariable success that the very possibility of his failing had ceased to enter into my head.

It was close upon four before the door opened, and a drunken-looking groom, ill-kempt and side-whiskered, with an inflamed face and disreputable clothes, walked into the room. Accustomed as I was to my friend's amazing powers in the use of disguises, I had to look three times before I was certain that it was indeed he. With a nod he vanished into the bedroom, whence he emerged in five minutes tweed-suited and respectable, as of old. Putting his hands into his pockets, he stretched out his legs in front of the fire and laughed heartily for some minutes.

"Well, really!" he cried, and then he choked and laughed again until he was obliged to lie back, limp and helpless, in the chair.

"What is it?"

"It's quite too funny. I am sure you could never guess how I employed my morning, or what I ended by doing."

"I can't imagine. I suppose that you have been watching the habits, and perhaps the house, of Miss Irene Adler."

"Quite so; but the sequel was rather unusual. I will tell you, however. I left the house a little after eight o'clock this morning in the character of a groom out of work. There is a wonderful sympathy and freemasonry among horsey men. Be one of them, and you will know all that there is to know. I soon found Briony Lodge. It is a bijou villa, with a garden at the back, but built out in front right up to the road, two stories. Chubb lock to the door. Large sitting-room on the right side, well furnished, with long windows almost to the floor, and those preposterous English window fasteners which a child could open. Behind there was nothing remarkable, save that the passage window could be reached from the top of the coach-house. I walked round it and examined it closely from every point of view, but without noting anything else of interest.

"I then lounged down the street and found, as I expected, that there was a mews in a lane which runs down by one wall of the garden. I lent the ostlers a hand in rubbing down their horses, and received in exchange twopence, a glass of half-and-half, two fills of shag tobacco, and as much information as I could desire about Miss Adler, to say nothing of half a dozen other people in the neighbourhood in whom I was not in the least interested, but whose biographies I was compelled to listen to."

"And what of Irene Adler?" I asked.

"Oh, she has turned all the men's heads down in that part. She is the daintiest thing under a bonnet on this planet. So say the Serpentine-mews, to a man. She lives quietly, sings at concerts, drives out at five every day, and returns at seven sharp for dinner. Seldom goes out at other times, except when she sings. Has only one male visitor, but a good deal of him. He is dark, handsome, and dashing, never calls less than once a day, and often twice. He is a Mr. Godfrey Norton, of the Inner Temple. See the advantages of a cabman as a confidant. They had driven him home a dozen times from Serpentine-mews, and knew all about him. When I had listened to all they had to tell, I began to walk up and down near Briony Lodge once more, and to think over my plan of campaign.

"This Godfrey Norton was evidently an important factor in the matter. He was a lawyer. That sounded ominous. What was the relation between them, and what the object of his repeated visits? Was she his client, his friend, or his mistress? If the former, she had probably transferred the photograph to his keeping. If the latter, it was less likely. On the issue of this question depended whether I should continue my work at Briony Lodge, or turn my attention to the gentleman's chambers in the Temple. It was a delicate point, and it widened the field of my inquiry. I fear that I bore you with these details, but I have to let you see my little difficulties, if you are to understand the situation."

"I am following you closely," I answered.

"I was still balancing the matter in my mind when a hansom cab drove up to Briony Lodge, and a gentleman sprang out. He was a remarkably handsome man, dark, aquiline, and moustached--evidently the man of whom I had heard. He appeared to be in a great hurry, shouted to the cabman to wait, and brushed past the maid who opened the door with the air of a man who was thoroughly at home.

"He was in the house about half an hour, and I could catch glimpses of him in the windows of the sitting-room, pacing up and down, talking excitedly, and waving his arms. Of her I could see nothing. Presently he emerged, looking even more flurried than before. As he stepped up to the cab, he pulled a gold watch from his pocket and looked at it earnestly, 'Drive like the devil,' he shouted, 'first to Gross & Hankey's in Regent Street, and then to the Church of St. Monica in the Edgeware Road. Half a guinea if you do it in twenty minutes!'

"Away they went, and I was just wondering whether I should not do well to follow them when up the lane came a neat little landau, the coachman with his coat only half-buttoned, and his tie under his ear, while all the tags of his harness were sticking out of the buckles. It hadn't pulled up before she shot out of the hall door and into it. I only caught a glimpse of her at the moment, but she was a lovely woman, with a face that a man might die for.

" 'The Church of St. Monica, John,' she cried, 'and half a sovereign if you reach it in twenty minutes.'

"This was quite too good to lose, Watson. I was just balancing whether I should run for it, or whether I should perch behind her landau when a cab came through the street. The driver looked twice at such a shabby fare, but I jumped in before he could object. 'The Church of St. Monica,' said I, 'and half a sovereign if you reach it in twenty minutes.' It was twenty-five minutes to twelve, and of course it was clear enough what was in the wind.

"My cabby drove fast. I don't think I ever drove faster, but the others were there before us. The cab and the landau with their steaming horses were in front of the door when I arrived. I paid the man and hurried into the church. There was not a soul there save the two whom I had followed and a surpliced clergyman, who seemed to be expostulating with them. They were all three standing in a knot in front of the altar. I lounged up the side aisle like any other idler who has dropped into a church. Suddenly, to my surprise, the three at the altar faced round to me, and Godfrey Norton came running as hard as he could towards me.

" 'Thank God,' he cried. 'You'll do. Come! Come!'

" 'What then?' I asked.

" 'Come, man, come, only three minutes, or it won't be legal.'

"I was half-dragged up to the altar, and before I knew where I was I found myself mumbling responses which were whispered in my ear, and vouching for things of which I knew nothing, and generally assisting in the secure tying up of Irene Adler, spinster, to Godfrey Norton, bachelor. It was all done in an instant, and there was the gentleman thanking me on the one side and the lady on the other, while the clergyman beamed on me in front. It was the most preposterous position in which I ever found myself in my life, and it was the thought of it that started me laughing just now. It seems that there had been some informality about their license, that the clergyman absolutely refused to marry them without a witness of some sort, and that my lucky appearance saved the bridegroom from having to sally out into the streets in search of a best man. The bride gave me a sovereign, and I mean to wear it on my watch chain in memory of the occasion."

"This is a very unexpected turn of affairs," said I; "and what then?"

"Well, I found my plans very seriously menaced. It looked as if the pair might take an immediate departure, and so necessitate very prompt and energetic measures on my part. At the church door, however, they separated, he driving back to the Temple, and she to her own house. 'I shall drive out in the park at five as usual,' she said as she left him. I heard no more. They drove away in different directions, and I went off to make my own arrangements."

"Which are?"

"Some cold beef and a glass of beer," he answered, ringing the bell. "I have been too busy to think of food, and I am likely to be busier still this evening. By the way, Doctor, I shall want your co-operation."

"I shall be delighted."

"You don't mind breaking the law?"

"Not in the least."

"Nor running a chance of arrest?"

"Not in a good cause."

"Oh, the cause is excellent!"

"Then I am your man."

"I was sure that I might rely on you."

"But what is it you wish?"

"When Mrs. Turner has brought in the tray I will make it clear to you. Now," he said as he turned hungrily on the simple fare that our landlady had provided, "I must discuss it while I eat, for I have not much time. It is nearly five now. In two hours we must be on the scene of action. Miss Irene, or Madame, rather, returns from her drive at seven. We must be at Briony Lodge to meet her."

"And what then?"

"You must leave that to me. I have already arranged what is to occur. There is only one point on which I must insist. You must not interfere, come what may. You understand?"

"I am to be neutral?"

"To do nothing whatever. There will probably be some small unpleasantness. Do not join in it. It will end in my being conveyed into the house. Four or five minutes afterwards the sitting-room window will open. You are to station yourself close to that open window."

"Yes."

"You are to watch me, for I will be visible to you."

"Yes."

"And when I raise my hand--so--you will throw into the room what I give you to throw, and will, at the same time, raise the cry of fire. You quite follow me?"

"Entirely."

"It is nothing very formidable," he said, taking a long cigar-shaped roll from his pocket. "It is an ordinary plumber's smoke-rocket, fitted with a cap at either end to make it self-lighting. Your task is confined to that. When you raise your cry of fire, it will be taken up by quite a number of people. You may then walk to the end of the street, and I will rejoin you in ten minutes. I hope that I have made myself clear?"

"I am to remain neutral, to get near the window, to watch you, and at the signal to throw in this object, then to raise the cry of fire, and to wait you at the corner of the street."

"Precisely."

"Then you may entirely rely on me."

"That is excellent. I think, perhaps, it is almost time that I prepare for the new role I have to play."

He disappeared into his bedroom and returned in a few minutes in the character of an amiable and simple-minded Nonconformist clergyman. His broad black hat, his baggy trousers, his white tie, his sympathetic smile, and general look of peering and benevolent curiosity were such as Mr. John Hare alone could have equalled. It was not merely that Holmes changed his costume. His expression, his manner, his very soul seemed to vary with every fresh part that he assumed. The stage lost a fine actor, even as science lost an acute reasoner, when he became a specialist in crime.

It was a quarter past six when we left Baker Street, and it still wanted ten minutes to the hour when we found ourselves in Serpentine Avenue. It was already dusk, and the lamps were just being lighted as we paced up and down in front of Briony Lodge, waiting for the coming of its occupant. The house was just such as I had pictured it from Sherlock Holmes' succinct description, but the locality appeared to be less private than I expected. On the contrary, for a small street in a quiet neighbourhood, it was remarkably animated. There was a group of shabbily dressed men smoking and laughing in a corner, a scissors-grinder with his wheel, two guardsmen who were flirting with a nurse-girl, and several well-dressed young men who were lounging up and down with cigars in their mouths.

"You see," remarked Holmes, as we paced to and fro in front of the house, "this marriage rather simplifies matters. The photograph becomes a double-edged weapon now. The chances are that she would be as averse to its being seen by Mr. Godfrey Norton, as our client is to its coming to the eyes of his princess. Now the question is, Where are we to find the photograph?"

"Where, indeed?"

"It is most unlikely that she carries it about with her. It is cabinet size. Too large for easy concealment about a woman's dress. She knows that the King is capable of having her waylaid and searched. Two attempts of the sort have already been made. We may take it, then, that she does not carry it about with her."

"Where, then?"

"Her banker or her lawyer. There is that double possibility. But I am inclined to think neither. Women are naturally secretive, and they like to do their own secreting. Why should she hand it over to anyone else? She could trust her own guardianship, but she could not tell what indirect or political influence might be brought to bear upon a business man. Besides, remember that she had resolved to use it within a few days. It must be where she can lay her hands upon it. It must be in her own house."

"But it has twice been burgled."

"Pshaw! They did not know how to look."

"But how will you look?"

"I will not look."

"What then?"

"I will get her to show me."

"But she will refuse."

"She will not be able to. But I hear the rumble of wheels. It is her carriage. Now carry out my orders to the letter."

As he spoke the gleam of the sidelights of a carriage came round the curve of the avenue. It was a smart little landau which rattled up to the door of Briony Lodge. As it pulled up, one of the loafing men at the corner dashed forward to open the door in the hope of earning a copper, but was elbowed away by another loafer, who had rushed up with the same intention. A fierce quarrel broke out, which was increased by the two guardsmen, who took sides with one of the loungers, and by the scissors-grinder, who was equally hot upon the other side. A blow was struck, and in an instant the lady, who had stepped from her carriage, was the centre of a little knot of flushed and struggling men, who struck savagely at each other with their fists and sticks. Holmes dashed into the crowd to protect the lady; but, just as he reached her, he gave a cry and dropped to the ground, with the blood running freely down his face. At his fall the guardsmen took to their heels in one direction and the loungers in the other, while a number of better dressed people, who had watched the scuffle without taking part in it, crowded in to help the lady and to attend to the injured man. Irene Adler, as I will still call her, had hurried up the steps; but she stood at the top with her superb figure outlined against the lights of the hall, looking back into the street.

"Is the poor gentleman much hurt?" she asked.

"He is dead," cried several voices.

"No, no, there's life in him!" shouted another. "But he'll be gone before you can get him to hospital."

"He's a brave fellow," said a woman. "They would have had the lady's purse and watch if it hadn't been for him. They were a gang, and a rough one, too. Ah, he's breathing now."

"He can't lie in the street. May we bring him in, marm?"

"Surely. Bring him into the sitting-room. There is a comfortable sofa. This way, please!"

Slowly and solemnly he was borne into Briony Lodge and laid out in the principal room, while I still observed the proceedings from my post by the window. The lamps had been lit, but the blinds had not been drawn, so that I could see Holmes as he lay upon the couch. I do not know whether he was seized with compunction at that moment for the part he was playing, but I know that I never felt more heartily ashamed of myself in my life than when I saw the beautiful creature against whom I was conspiring, or the grace and kindliness with which she waited upon the injured man. And yet it would be the blackest treachery to Holmes to draw back now from the part which he had intrusted to me. I hardened my heart, and took the smoke-rocket from under my ulster. After all, I thought, we are not injuring her. We are but preventing her from injuring another.

Holmes had sat up upon the couch, and I saw him motion like a man who is in need of air. A maid rushed across and threw open the window. At the same instant I saw him raise his hand and at the signal I tossed my rocket into the room with a cry of "Fire!" The word was no sooner out of my mouth than the whole crowd of spectators, well dressed and ill--gentlemen, ostlers, and servant maids--joined in a general shriek of "Fire!" Thick clouds of smoke curled through the room and out at the open window. I caught a glimpse of rushing figures, and a moment later the voice of Holmes from within assuring them that it was a false alarm. Slipping through the shouting crowd I made my way to the corner of the street, and in ten minutes was rejoiced to find my friend's arm in mine, and to get away from the scene of uproar. He walked swiftly and in silence for some few minutes until we had turned down one of the quiet streets which lead towards the Edgeware Road.

"You did it very nicely, Doctor," he remarked. "Nothing could have been better. It is all right."

"You have the photograph?"

"I know where it is."

"And how did you find out?"

"She showed me, as I told you she would."

"I am still in the dark."

"I do not wish to make a mystery," said he, laughing. "The matter was perfectly simple. You, of course, saw that everyone in the street was an accomplice. They were all engaged for the evening."

"I guessed as much."

"Then, when the row broke out, I had a little moist red paint in the palm of my hand. I rushed forward, fell down, clapped my hand to my face, and became a piteous spectacle. It is an old trick."

"That also I could fathom."

"Then they carried me in. She was bound to have me in. What else could she do? And into her sitting-room, which was the very room which I suspected. It lay between that and her bedroom, and I was determined to see which. They laid me on a couch, I motioned for air, they were compelled to open the window, and you had your chance."

"How did that help you?"

"It was all-important. When a woman thinks that her house is on fire, her instinct is at once to rush to the thing which she values most. It is a perfectly overpowering impulse, and I have more than once taken advantage of it. In the case of the Darlington Substitution Scandal it was of use to me, and also in the Arnsworth Castle business. A married woman grabs at her baby; an unmarried one reaches for her jewel-box. Now it was clear to me that our lady of to-day had nothing in the house more precious to her than what we are in quest of. She would rush to secure it. The alarm of fire was admirably done. The smoke and shouting were enough to shake nerves of steel. She responded beautifully. The photograph is in a recess behind a sliding panel just above the right bell-pull. She was there in an instant, and I caught a glimpse of it as she half drew it out. When I cried out that it was a false alarm, she replaced it, glanced at the rocket, rushed from the room, and I have not seen her since. I rose, and, making my excuses, escaped from the house. I hesitated whether to attempt to secure the photograph at once; but the coachman had come in, and as he was watching me narrowly, it seemed safer to wait. A little over-precipitance may ruin all."

"And now?" I asked.

"Our quest is practically finished. I shall call with the King to-morrow, and with you, if you care to come with us. We will be shown into the sitting-room to wait for the lady, but it is probable that when she comes she may find neither us nor the photograph. It might be a satisfaction to his Majesty to regain it with his own hands."

"And when will you call?"

"At eight in the morning. She will not be up, so that we shall have a clear field. Besides, we must be prompt, for this marriage may mean a complete change in her life and habits. I must wire to the King without delay."

We had reached Baker Street and had stopped at the door. He was searching his pockets for the key when someone passing said:

"Good-night, Mister Sherlock Holmes."

There were several people on the pavement at the time, but the greeting appeared to come from a slim youth in an ulster who had hurried by.

"I've heard that voice before," said Holmes, staring down the dimly lit street. "Now, I wonder who the deuce that could have been."

III.


I slept at Baker Street that night, and we were engaged upon our toast and coffee in the morning when the King of Bohemia rushed into the room.

"You have really got it!" he cried, grasping Sherlock Holmes by either shoulder and looking eagerly into his face.

"Not yet."

"But you have hopes?"

"I have hopes."

"Then, come. I am all impatience to be gone."

"We must have a cab."

"No, my brougham is waiting."

"Then that will simplify matters." We descended and started off once more for Briony Lodge.

"Irene Adler is married," remarked Holmes.

"Married! When?"

"Yesterday."

"But to whom?"

"To an English lawyer named Norton."

"But she could not love him."

"I am in hopes that she does."

"And why in hopes?"

"Because it would spare your Majesty all fear of future annoyance. If the lady loves her husband, she does not love your Majesty. If she does not love your Majesty, there is no reason why she should interfere with your Majesty's plan."

"It is true. And yet--! Well! I wish she had been of my own station! What a queen she would have made!" He relapsed into a moody silence, which was not broken until we drew up in Serpentine Avenue.

The door of Briony Lodge was open, and an elderly woman stood upon the steps. She watched us with a sardonic eye as we stepped from the brougham.

"Mr. Sherlock Holmes, I believe?" said she.

"I am Mr. Holmes," answered my companion, looking at her with a questioning and rather startled gaze.

"Indeed! My mistress told me that you were likely to call. She left this morning with her husband by the 5:15 train from Charing Cross for the Continent."

"What!" Sherlock Holmes staggered back, white with chagrin and surprise. "Do you mean that she has left England?"

"Never to return."

"And the papers?" asked the King hoarsely. "All is lost."

"We shall see." He pushed past the servant and rushed into the drawing-room, followed by the King and myself. The furniture was scattered about in every direction, with dismantled shelves and open drawers, as if the lady had hurriedly ransacked them before her flight. Holmes rushed at the bell-pull, tore back a small sliding shutter, and, plunging in his hand, pulled out a photograph and a letter. The photograph was of Irene Adler herself in evening dress, the letter was superscribed to "Sherlock Holmes, Esq. To be left till called for." My friend tore it open, and we all three read it together. It was dated at midnight of the preceding night and ran in this way:

"MY DEAR MR. SHERLOCK HOLMES,--You really did it very well. You took me in completely. Until after the alarm of fire, I had not a suspicion. But then, when I found how I had betrayed myself, I began to think. I had been warned against you months ago. I had been told that, if the King employed an agent, it would certainly be you. And your address had been given me. Yet, with all this, you made me reveal what you wanted to know. Even after I became suspicious, I found it hard to think evil of such a dear, kind old clergyman. But, you know, I have been trained as an actress myself. Male costume is nothing new to me. I often take advantage of the freedom which it gives. I sent John, the coachman, to watch you, ran upstairs, got into my walking clothes, as I call them, and came down just as you departed.

"Well, I followed you to your door, and so made sure that I was really an object of interest to the celebrated Mr. Sherlock Holmes. Then I, rather imprudently, wished you good-night, and started for the Temple to see my husband.

"We both thought the best resource was flight, when pursued by so formidable an antagonist; so you will find the nest empty when you call to-morrow. As to the photograph, your client may rest in peace. I love and am loved by a better man than he. The King may do what he will without hindrance from one whom he has cruelly wronged. I keep it only to safeguard myself, and to preserve a weapon which will always secure me from any steps which he might take in the future. I leave a photograph which he might care to possess; and I remain, dear Mr. Sherlock Holmes,


"Very truly yours,              
"IRENE NORTON, nee ADLER."

"What a woman--oh, what a woman!" cried the King of Bohemia, when we had all three read this epistle. "Did I not tell you how quick and resolute she was? Would she not have made an admirable queen? Is it not a pity that she was not on my level?"

"From what I have seen of the lady, she seems, indeed, to be on a very different level to your Majesty," said Holmes coldly. "I am sorry that I have not been able to bring your Majesty's business to a more successful conclusion."

"On the contrary, my dear sir," cried the King; "nothing could be more successful. I know that her word is inviolate. The photograph is now as safe as if it were in the fire."

"I am glad to hear your Majesty say so."

"I am immensely indebted to you. Pray tell me in what way I can reward you. This ring--" He slipped an emerald snake ring from his finger and held it out upon the palm of his hand.

"Your Majesty has something which I should value even more highly," said Holmes.

"You have but to name it."

"This photograph!"

The King stared at him in amazement.

"Irene's photograph!" he cried. "Certainly, if you wish it."

"I thank your Majesty. Then there is no more to be done in the matter. I have the honour to wish you a very good morning." He bowed, and, turning away without observing the hand which the King had stretched out to him, he set off in my company for his chambers.

And that was how a great scandal threatened to affect the kingdom of Bohemia, and how the best plans of Mr. Sherlock Holmes were beaten by a woman's wit. He used to make merry over the cleverness of women, but I have not heard him do it of late. And when he speaks of Irene Adler, or when he refers to her photograph, it is always under the honourable title of the woman.

ADVENTURE  II.  THE RED-HEADED LEAGUE


I had called upon my friend, Mr. Sherlock Holmes, one day in the autumn of last year and found him in deep conversation with a very stout, florid-faced, elderly gentleman with fiery red hair. With an apology for my intrusion, I was about to withdraw when Holmes pulled me abruptly into the room and closed the door behind me.

"You could not possibly have come at a better time, my dear Watson," he said cordially.

"I was afraid that you were engaged."

"So I am. Very much so."

"Then I can wait in the next room."

"Not at all. This gentleman, Mr. Wilson, has been my partner and helper in many of my most successful cases, and I have no doubt that he will be of the utmost use to me in yours also."

The stout gentleman half rose from his chair and gave a bob of greeting, with a quick little questioning glance from his small fat-encircled eyes.

"Try the settee," said Holmes, relapsing into his armchair and putting his fingertips together, as was his custom when in judicial moods. "I know, my dear Watson, that you share my love of all that is bizarre and outside the conventions and humdrum routine of everyday life. You have shown your relish for it by the enthusiasm which has prompted you to chronicle, and, if you will excuse my saying so, somewhat to embellish so many of my own little adventures."

"Your cases have indeed been of the greatest interest to me," I observed.

"You will remember that I remarked the other day, just before we went into the very simple problem presented by Miss Mary Sutherland, that for strange effects and extraordinary combinations we must go to life itself, which is always far more daring than any effort of the imagination."

"A proposition which I took the liberty of doubting."

"You did, Doctor, but none the less you must come round to my view, for otherwise I shall keep on piling fact upon fact on you until your reason breaks down under them and acknowledges me to be right. Now, Mr. Jabez Wilson here has been good enough to call upon me this morning, and to begin a narrative which promises to be one of the most singular which I have listened to for some time. You have heard me remark that the strangest and most unique things are very often connected not with the larger but with the smaller crimes, and occasionally, indeed, where there is room for doubt whether any positive crime has been committed. As far as I have heard, it is impossible for me to say whether the present case is an instance of crime or not, but the course of events is certainly among the most singular that I have ever listened to. Perhaps, Mr. Wilson, you would have the great kindness to recommence your narrative. I ask you not merely because my friend Dr. Watson has not heard the opening part but also because the peculiar nature of the story makes me anxious to have every possible detail from your lips. As a rule, when I have heard some slight indication of the course of events, I am able to guide myself by the thousands of other similar cases which occur to my memory. In the present instance I am forced to admit that the facts are, to the best of my belief, unique."

The portly client puffed out his chest with an appearance of some little pride and pulled a dirty and wrinkled newspaper from the inside pocket of his greatcoat. As he glanced down the advertisement column, with his head thrust forward and the paper flattened out upon his knee, I took a good look at the man and endeavoured, after the fashion of my companion, to read the indications which might be presented by his dress or appearance.

I did not gain very much, however, by my inspection. Our visitor bore every mark of being an average commonplace British tradesman, obese, pompous, and slow. He wore rather baggy grey shepherd's check trousers, a not over-clean black frock-coat, unbuttoned in the front, and a drab waistcoat with a heavy brassy Albert chain, and a square pierced bit of metal dangling down as an ornament. A frayed top-hat and a faded brown overcoat with a wrinkled velvet collar lay upon a chair beside him. Altogether, look as I would, there was nothing remarkable about the man save his blazing red head, and the expression of extreme chagrin and discontent upon his features.

Sherlock Holmes' quick eye took in my occupation, and he shook his head with a smile as he noticed my questioning glances. "Beyond the obvious facts that he has at some time done manual labour, that he takes snuff, that he is a Freemason, that he has been in China, and that he has done a considerable amount of writing lately, I can deduce nothing else."

Mr. Jabez Wilson started up in his chair, with his forefinger upon the paper, but his eyes upon my companion.

"How, in the name of good-fortune, did you know all that, Mr. Holmes?" he asked. "How did you know, for example, that I did manual labour. It's as true as gospel, for I began as a ship's carpenter."

"Your hands, my dear sir. Your right hand is quite a size larger than your left. You have worked with it, and the muscles are more developed."

"Well, the snuff, then, and the Freemasonry?"

"I won't insult your intelligence by telling you how I read that, especially as, rather against the strict rules of your order, you use an arc-and-compass breastpin."

"Ah, of course, I forgot that. But the writing?"

"What else can be indicated by that right cuff so very shiny for five inches, and the left one with the smooth patch near the elbow where you rest it upon the desk?"

"Well, but China?"

"The fish that you have tattooed immediately above your right wrist could only have been done in China. I have made a small study of tattoo marks and have even contributed to the literature of the subject. That trick of staining the fishes' scales of a delicate pink is quite peculiar to China. When, in addition, I see a Chinese coin hanging from your watch-chain, the matter becomes even more simple."

Mr. Jabez Wilson laughed heavily. "Well, I never!" said he. "I thought at first that you had done something clever, but I see that there was nothing in it after all."

"I begin to think, Watson," said Holmes, "that I make a mistake in explaining. 'Omne ignotum pro magnifico,' you know, and my poor little reputation, such as it is, will suffer shipwreck if I am so candid. Can you not find the advertisement, Mr. Wilson?"

"Yes, I have got it now," he answered with his thick red finger planted halfway down the column. "Here it is. This is what began it all. You just read it for yourself, sir."

I took the paper from him and read as follows:

"TO THE RED-HEADED LEAGUE: On account of the bequest of the late Ezekiah Hopkins, of Lebanon, Pennsylvania, U. S. A., there is now another vacancy open which entitles a member of the League to a salary of $4 a week for purely nominal services. All red-headed men who are sound in body and mind and above the age of twenty-one years, are eligible. Apply in person on Monday, at eleven o'clock, to Duncan Ross, at the offices of the League, 7 Pope's Court, Fleet Street."

"What on earth does this mean?" I ejaculated after I had twice read over the extraordinary announcement.

Holmes chuckled and wriggled in his chair, as was his habit when in high spirits. "It is a little off the beaten track, isn't it?" said he. "And now, Mr. Wilson, off you go at scratch and tell us all about yourself, your household, and the effect which this advertisement had upon your fortunes. You will first make a note, Doctor, of the paper and the date."

"It is The Morning Chronicle of April 27, 1890. Just two months ago."

"Very good. Now, Mr. Wilson?"

"Well, it is just as I have been telling you, Mr. Sherlock Holmes," said Jabez Wilson, mopping his forehead; "I have a small pawnbroker's business at Coburg Square, near the City. It's not a very large affair, and of late years it has not done more than just give me a living. I used to be able to keep two assistants, but now I only keep one; and I would have a job to pay him but that he is willing to come for half wages so as to learn the business."

"What is the name of this obliging youth?" asked Sherlock Holmes.

"His name is Vincent Spaulding, and he's not such a youth, either. It's hard to say his age. I should not wish a smarter assistant, Mr. Holmes; and I know very well that he could better himself and earn twice what I am able to give him. But, after all, if he is satisfied, why should I put ideas in his head?"

"Why, indeed? You seem most fortunate in having an employe who comes under the full market price. It is not a common experience among employers in this age. I don't know that your assistant is not as remarkable as your advertisement."

"Oh, he has his faults, too," said Mr. Wilson. "Never was such a fellow for photography. Snapping away with a camera when he ought to be improving his mind, and then diving down into the cellar like a rabbit into its hole to develop his pictures. That is his main fault, but on the whole he's a good worker. There's no vice in him."

"He is still with you, I presume?"

"Yes, sir. He and a girl of fourteen, who does a bit of simple cooking and keeps the place clean--that's all I have in the house, for I am a widower and never had any family. We live very quietly, sir, the three of us; and we keep a roof over our heads and pay our debts, if we do nothing more.

"The first thing that put us out was that advertisement. Spaulding, he came down into the office just this day eight weeks, with this very paper in his hand, and he says:

" 'I wish to the Lord, Mr. Wilson, that I was a red-headed man.'

" 'Why that?' I asks.

" 'Why,' says he, 'here's another vacancy on the League of the Red-headed Men. It's worth quite a little fortune to any man who gets it, and I understand that there are more vacancies than there are men, so that the trustees are at their wits' end what to do with the money. If my hair would only change colour, here's a nice little crib all ready for me to step into.'

" 'Why, what is it, then?' I asked. You see, Mr. Holmes, I am a very stay-at-home man, and as my business came to me instead of my having to go to it, I was often weeks on end without putting my foot over the door-mat. In that way I didn't know much of what was going on outside, and I was always glad of a bit of news.

" 'Have you never heard of the League of the Red-headed Men?' he asked with his eyes open.

" 'Never.'

" 'Why, I wonder at that, for you are eligible yourself for one of the vacancies.'

" 'And what are they worth?' I asked.

" 'Oh, merely a couple of hundred a year, but the work is slight, and it need not interfere very much with one's other occupations.'

"Well, you can easily think that that made me prick up my ears, for the business has not been over good for some years, and an extra couple of hundred would have been very handy.

" 'Tell me all about it,' said I.

" 'Well,' said he, showing me the advertisement, 'you can see for yourself that the League has a vacancy, and there is the address where you should apply for particulars. As far as I can make out, the League was founded by an American millionaire, Ezekiah Hopkins, who was very peculiar in his ways. He was himself red-headed, and he had a great sympathy for all red-headed men; so, when he died, it was found that he had left his enormous fortune in the hands of trustees, with instructions to apply the interest to the providing of easy berths to men whose hair is of that colour. From all I hear it is splendid pay and very little to do.'

" 'But,' said I, 'there would be millions of red-headed men who would apply.'

" 'Not so many as you might think,' he answered. 'You see it is really confined to Londoners, and to grown men. This American had started from London when he was young, and he wanted to do the old town a good turn. Then, again, I have heard it is no use your applying if your hair is light red, or dark red, or anything but real bright, blazing, fiery red. Now, if you cared to apply, Mr. Wilson, you would just walk in; but perhaps it would hardly be worth your while to put yourself out of the way for the sake of a few hundred pounds.'

"Now, it is a fact, gentlemen, as you may see for yourselves, that my hair is of a very full and rich tint, so that it seemed to me that if there was to be any competition in the matter I stood as good a chance as any man that I had ever met. Vincent Spaulding seemed to know so much about it that I thought he might prove useful, so I just ordered him to put up the shutters for the day and to come right away with me. He was very willing to have a holiday, so we shut the business up and started off for the address that was given us in the advertisement.

"I never hope to see such a sight as that again, Mr. Holmes. From north, south, east, and west every man who had a shade of red in his hair had tramped into the city to answer the advertisement. Fleet Street was choked with red-headed folk, and Pope's Court looked like a coster's orange barrow. I should not have thought there were so many in the whole country as were brought together by that single advertisement. Every shade of colour they were--straw, lemon, orange, brick, Irish-setter, liver, clay; but, as Spaulding said, there were not many who had the real vivid flame-coloured tint. When I saw how many were waiting, I would have given it up in despair; but Spaulding would not hear of it. How he did it I could not imagine, but he pushed and pulled and butted until he got me through the crowd, and right up to the steps which led to the office. There was a double stream upon the stair, some going up in hope, and some coming back dejected; but we wedged in as well as we could and soon found ourselves in the office."

"Your experience has been a most entertaining one," remarked Holmes as his client paused and refreshed his memory with a huge pinch of snuff. "Pray continue your very interesting statement."

"There was nothing in the office but a couple of wooden chairs and a deal table, behind which sat a small man with a head that was even redder than mine. He said a few words to each candidate as he came up, and then he always managed to find some fault in them which would disqualify them. Getting a vacancy did not seem to be such a very easy matter, after all. However, when our turn came the little man was much more favourable to me than to any of the others, and he closed the door as we entered, so that he might have a private word with us.

" 'This is Mr. Jabez Wilson,' said my assistant, 'and he is willing to fill a vacancy in the League.'

" 'And he is admirably suited for it,' the other answered. 'He has every requirement. I cannot recall when I have seen anything so fine.' He took a step backward, cocked his head on one side, and gazed at my hair until I felt quite bashful. Then suddenly he plunged forward, wrung my hand, and congratulated me warmly on my success.

" 'It would be injustice to hesitate,' said he. 'You will, however, I am sure, excuse me for taking an obvious precaution.' With that he seized my hair in both his hands, and tugged until I yelled with the pain. 'There is water in your eyes,' said he as he released me. 'I perceive that all is as it should be. But we have to be careful, for we have twice been deceived by wigs and once by paint. I could tell you tales of cobbler's wax which would disgust you with human nature.' He stepped over to the window and shouted through it at the top of his voice that the vacancy was filled. A groan of disappointment came up from below, and the folk all trooped away in different directions until there was not a red-head to be seen except my own and that of the manager.

" 'My name,' said he, 'is Mr. Duncan Ross, and I am myself one of the pensioners upon the fund left by our noble benefactor. Are you a married man, Mr. Wilson? Have you a family?'

"I answered that I had not.

"His face fell immediately.

" 'Dear me!' he said gravely, 'that is very serious indeed! I am sorry to hear you say that. The fund was, of course, for the propagation and spread of the red-heads as well as for their maintenance. It is exceedingly unfortunate that you should be a bachelor.'

"My face lengthened at this, Mr. Holmes, for I thought that I was not to have the vacancy after all; but after thinking it over for a few minutes he said that it would be all right.

" 'In the case of another,' said he, 'the objection might be fatal, but we must stretch a point in favour of a man with such a head of hair as yours. When shall you be able to enter upon your new duties?'

" 'Well, it is a little awkward, for I have a business already,' said I.

" 'Oh, never mind about that, Mr. Wilson!' said Vincent Spaulding. 'I should be able to look after that for you.'

" 'What would be the hours?' I asked.

" 'Ten to two.'

"Now a pawnbroker's business is mostly done of an evening, Mr. Holmes, especially Thursday and Friday evening, which is just before pay-day; so it would suit me very well to earn a little in the mornings. Besides, I knew that my assistant was a good man, and that he would see to anything that turned up.

" 'That would suit me very well,' said I. 'And the pay?'

" 'Is $4 a week.'

" 'And the work?'

" 'Is purely nominal.'

" 'What do you call purely nominal?'

" 'Well, you have to be in the office, or at least in the building, the whole time. If you leave, you forfeit your whole position forever. The will is very clear upon that point. You don't comply with the conditions if you budge from the office during that time.'

" 'It's only four hours a day, and I should not think of leaving,' said I.

" 'No excuse will avail,' said Mr. Duncan Ross; 'neither sickness nor business nor anything else. There you must stay, or you lose your billet.'

" 'And the work?'

" 'Is to copy out the Encyclopaedia Britannica. There is the first volume of it in that press. You must find your own ink, pens, and blotting-paper, but we provide this table and chair. Will you be ready to-morrow?'

" 'Certainly,' I answered.

" 'Then, good-bye, Mr. Jabez Wilson, and let me congratulate you once more on the important position which you have been fortunate enough to gain.' He bowed me out of the room and I went home with my assistant, hardly knowing what to say or do, I was so pleased at my own good fortune.

"Well, I thought over the matter all day, and by evening I was in low spirits again; for I had quite persuaded myself that the whole affair must be some great hoax or fraud, though what its object might be I could not imagine. It seemed altogether past belief that anyone could make such a will, or that they would pay such a sum for doing anything so simple as copying out the Encyclopaedia Britannica. Vincent Spaulding did what he could to cheer me up, but by bedtime I had reasoned myself out of the whole thing. However, in the morning I determined to have a look at it anyhow, so I bought a penny bottle of ink, and with a quill-pen, and seven sheets of foolscap paper, I started off for Pope's Court.

"Well, to my surprise and delight, everything was as right as possible. The table was set out ready for me, and Mr. Duncan Ross was there to see that I got fairly to work. He started me off upon the letter A, and then he left me; but he would drop in from time to time to see that all was right with me. At two o'clock he bade me good-day, complimented me upon the amount that I had written, and locked the door of the office after me.

"This went on day after day, Mr. Holmes, and on Saturday the manager came in and planked down four golden sovereigns for my week's work. It was the same next week, and the same the week after. Every morning I was there at ten, and every afternoon I left at two. By degrees Mr. Duncan Ross took to coming in only once of a morning, and then, after a time, he did not come in at all. Still, of course, I never dared to leave the room for an instant, for I was not sure when he might come, and the billet was such a good one, and suited me so well, that I would not risk the loss of it.

"Eight weeks passed away like this, and I had written about Abbots and Archery and Armour and Architecture and Attica, and hoped with diligence that I might get on to the B's before very long. It cost me something in foolscap, and I had pretty nearly filled a shelf with my writings. And then suddenly the whole business came to an end."

"To an end?"

"Yes, sir. And no later than this morning. I went to my work as usual at ten o'clock, but the door was shut and locked, with a little square of cardboard hammered on to the middle of the panel with a tack. Here it is, and you can read for yourself."

He held up a piece of white cardboard about the size of a sheet of note-paper. It read in this fashion:


THE RED-HEADED LEAGUE

IS

DISSOLVED.

October 9, 1890.


Sherlock Holmes and I surveyed this curt announcement and the rueful face behind it, until the comical side of the affair so completely overtopped every other consideration that we both burst out into a roar of laughter.

"I cannot see that there is anything very funny," cried our client, flushing up to the roots of his flaming head. "If you can do nothing better than laugh at me, I can go elsewhere."

"No, no," cried Holmes, shoving him back into the chair from which he had half risen. "I really wouldn't miss your case for the world. It is most refreshingly unusual. But there is, if you will excuse my saying so, something just a little funny about it. Pray what steps did you take when you found the card upon the door?"

"I was staggered, sir. I did not know what to do. Then I called at the offices round, but none of them seemed to know anything about it. Finally, I went to the landlord, who is an accountant living on the ground floor, and I asked him if he could tell me what had become of the Red-headed League. He said that he had never heard of any such body. Then I asked him who Mr. Duncan Ross was. He answered that the name was new to him.

" 'Well,' said I, 'the gentleman at No. 4.'

" 'What, the red-headed man?'

" 'Yes.'

" 'Oh,' said he, 'his name was William Morris. He was a solicitor and was using my room as a temporary convenience until his new premises were ready. He moved out yesterday.'

" 'Where could I find him?'

" 'Oh, at his new offices. He did tell me the address. Yes, 17 King Edward Street, near St. Paul's.'

"I started off, Mr. Holmes, but when I got to that address it was a manufactory of artificial knee-caps, and no one in it had ever heard of either Mr. William Morris or Mr. Duncan Ross."

"And what did you do then?" asked Holmes.

"I went home to Saxe-Coburg Square, and I took the advice of my assistant. But he could not help me in any way. He could only say that if I waited I should hear by post. But that was not quite good enough, Mr. Holmes. I did not wish to lose such a place without a struggle, so, as I had heard that you were good enough to give advice to poor folk who were in need of it, I came right away to you."

"And you did very wisely," said Holmes. "Your case is an exceedingly remarkable one, and I shall be happy to look into it. From what you have told me I think that it is possible that graver issues hang from it than might at first sight appear."

"Grave enough!" said Mr. Jabez Wilson. "Why, I have lost four pound a week."

"As far as you are personally concerned," remarked Holmes, "I do not see that you have any grievance against this extraordinary league. On the contrary, you are, as I understand, richer by some $30, to say nothing of the minute knowledge which you have gained on every subject which comes under the letter A. You have lost nothing by them."

"No, sir. But I want to find out about them, and who they are, and what their object was in playing this prank--if it was a prank--upon me. It was a pretty expensive joke for them, for it cost them two and thirty pounds."

"We shall endeavour to clear up these points for you. And, first, one or two questions, Mr. Wilson. This assistant of yours who first called your attention to the advertisement--how long had he been with you?"

"About a month then."

"How did he come?"

"In answer to an advertisement."

"Was he the only applicant?"

"No, I had a dozen."

"Why did you pick him?"

"Because he was handy and would come cheap."

"At half wages, in fact."

"Yes."

"What is he like, this Vincent Spaulding?"

"Small, stout-built, very quick in his ways, no hair on his face, though he's not short of thirty. Has a white splash of acid upon his forehead."

Holmes sat up in his chair in considerable excitement. "I thought as much," said he. "Have you ever observed that his ears are pierced for earrings?"

"Yes, sir. He told me that a gipsy had done it for him when he was a lad."

"Hum!" said Holmes, sinking back in deep thought. "He is still with you?"

"Oh, yes, sir; I have only just left him."

"And has your business been attended to in your absence?"

"Nothing to complain of, sir. There's never very much to do of a morning."

"That will do, Mr. Wilson. I shall be happy to give you an opinion upon the subject in the course of a day or two. To-day is Saturday, and I hope that by Monday we may come to a conclusion."

"Well, Watson," said Holmes when our visitor had left us, "what do you make of it all?"

"I make nothing of it," I answered frankly. "It is a most mysterious business."

"As a rule," said Holmes, "the more bizarre a thing is the less mysterious it proves to be. It is your commonplace, featureless crimes which are really puzzling, just as a commonplace face is the most difficult to identify. But I must be prompt over this matter."

"What are you going to do, then?" I asked.

"To smoke," he answered. "It is quite a three pipe problem, and I beg that you won't speak to me for fifty minutes." He curled himself up in his chair, with his thin knees drawn up to his hawk-like nose, and there he sat with his eyes closed and his black clay pipe thrusting out like the bill of some strange bird. I had come to the conclusion that he had dropped asleep, and indeed was nodding myself, when he suddenly sprang out of his chair with the gesture of a man who has made up his mind and put his pipe down upon the mantelpiece.

"Sarasate plays at the St. James's Hall this afternoon," he remarked. "What do you think, Watson? Could your patients spare you for a few hours?"

"I have nothing to do to-day. My practice is never very absorbing."

"Then put on your hat and come. I am going through the City first, and we can have some lunch on the way. I observe that there is a good deal of German music on the programme, which is rather more to my taste than Italian or French. It is introspective, and I want to introspect. Come along!"

We travelled by the Underground as far as Aldersgate; and a short walk took us to Saxe-Coburg Square, the scene of the singular story which we had listened to in the morning. It was a poky, little, shabby-genteel place, where four lines of dingy two-storied brick houses looked out into a small railed-in enclosure, where a lawn of weedy grass and a few clumps of faded laurel bushes made a hard fight against a smoke-laden and uncongenial atmosphere. Three gilt balls and a brown board with "JABEZ WILSON" in white letters, upon a corner house, announced the place where our red-headed client carried on his business. Sherlock Holmes stopped in front of it with his head on one side and looked it all over, with his eyes shining brightly between puckered lids. Then he walked slowly up the street, and then down again to the corner, still looking keenly at the houses. Finally he returned to the pawnbroker's, and, having thumped vigorously upon the pavement with his stick two or three times, he went up to the door and knocked. It was instantly opened by a bright-looking, clean-shaven young fellow, who asked him to step in.

"Thank you," said Holmes, "I only wished to ask you how you would go from here to the Strand."

"Third right, fourth left," answered the assistant promptly, closing the door.

"Smart fellow, that," observed Holmes as we walked away. "He is, in my judgment, the fourth smartest man in London, and for daring I am not sure that he has not a claim to be third. I have known something of him before."

"Evidently," said I, "Mr. Wilson's assistant counts for a good deal in this mystery of the Red-headed League. I am sure that you inquired your way merely in order that you might see him."

"Not him."

"What then?"

"The knees of his trousers."

"And what did you see?"

"What I expected to see."

"Why did you beat the pavement?"

"My dear doctor, this is a time for observation, not for talk. We are spies in an enemy's country. We know something of Saxe-Coburg Square. Let us now explore the parts which lie behind it."

The road in which we found ourselves as we turned round the corner from the retired Saxe-Coburg Square presented as great a contrast to it as the front of a picture does to the back. It was one of the main arteries which conveyed the traffic of the City to the north and west. The roadway was blocked with the immense stream of commerce flowing in a double tide inward and outward, while the footpaths were black with the hurrying swarm of pedestrians. It was difficult to realise as we looked at the line of fine shops and stately business premises that they really abutted on the other side upon the faded and stagnant square which we had just quitted.

"Let me see," said Holmes, standing at the corner and glancing along the line, "I should like just to remember the order of the houses here. It is a hobby of mine to have an exact knowledge of London. There is Mortimer's, the tobacconist, the little newspaper shop, the Coburg branch of the City and Suburban Bank, the Vegetarian Restaurant, and McFarlane's carriage-building depot. That carries us right on to the other block. And now, Doctor, we've done our work, so it's time we had some play. A sandwich and a cup of coffee, and then off to violin-land, where all is sweetness and delicacy and harmony, and there are no red-headed clients to vex us with their conundrums."

My friend was an enthusiastic musician, being himself not only a very capable performer but a composer of no ordinary merit. All the afternoon he sat in the stalls wrapped in the most perfect happiness, gently waving his long, thin fingers in time to the music, while his gently smiling face and his languid, dreamy eyes were as unlike those of Holmes the sleuth-hound, Holmes the relentless, keen-witted, ready-handed criminal agent, as it was possible to conceive. In his singular character the dual nature alternately asserted itself, and his extreme exactness and astuteness represented, as I have often thought, the reaction against the poetic and contemplative mood which occasionally predominated in him. The swing of his nature took him from extreme languor to devouring energy; and, as I knew well, he was never so truly formidable as when, for days on end, he had been lounging in his armchair amid his improvisations and his black-letter editions. Then it was that the lust of the chase would suddenly come upon him, and that his brilliant reasoning power would rise to the level of intuition, until those who were unacquainted with his methods would look askance at him as on a man whose knowledge was not that of other mortals. When I saw him that afternoon so enwrapped in the music at St. James's Hall I felt that an evil time might be coming upon those whom he had set himself to hunt down.

"You want to go home, no doubt, Doctor," he remarked as we emerged.

"Yes, it would be as well."

"And I have some business to do which will take some hours. This business at Coburg Square is serious."

"Why serious?"

"A considerable crime is in contemplation. I have every reason to believe that we shall be in time to stop it. But to-day being Saturday rather complicates matters. I shall want your help to-night."

"At what time?"

"Ten will be early enough."

"I shall be at Baker Street at ten."

"Very well. And, I say, Doctor, there may be some little danger, so kindly put your army revolver in your pocket." He waved his hand, turned on his heel, and disappeared in an instant among the crowd.

I trust that I am not more dense than my neighbours, but I was always oppressed with a sense of my own stupidity in my dealings with Sherlock Holmes. Here I had heard what he had heard, I had seen what he had seen, and yet from his words it was evident that he saw clearly not only what had happened but what was about to happen, while to me the whole business was still confused and grotesque. As I drove home to my house in Kensington I thought over it all, from the extraordinary story of the red-headed copier of the Encyclopaedia down to the visit to Saxe-Coburg Square, and the ominous words with which he had parted from me. What was this nocturnal expedition, and why should I go armed? Where were we going, and what were we to do? I had the hint from Holmes that this smooth-faced pawnbroker's assistant was a formidable man--a man who might play a deep game. I tried to puzzle it out, but gave it up in despair and set the matter aside until night should bring an explanation.

It was a quarter-past nine when I started from home and made my way across the Park, and so through Oxford Street to Baker Street. Two hansoms were standing at the door, and as I entered the passage I heard the sound of voices from above. On entering his room, I found Holmes in animated conversation with two men, one of whom I recognised as Peter Jones, the official police agent, while the other was a long, thin, sad-faced man, with a very shiny hat and oppressively respectable frock-coat.

"Ha! Our party is complete," said Holmes, buttoning up his pea-jacket and taking his heavy hunting crop from the rack. "Watson, I think you know Mr. Jones, of Scotland Yard? Let me introduce you to Mr. Merryweather, who is to be our companion in to-night's adventure."

"We're hunting in couples again, Doctor, you see," said Jones in his consequential way. "Our friend here is a wonderful man for starting a chase. All he wants is an old dog to help him to do the running down."

"I hope a wild goose may not prove to be the end of our chase," observed Mr. Merryweather gloomily.

"You may place considerable confidence in Mr. Holmes, sir," said the police agent loftily. "He has his own little methods, which are, if he won't mind my saying so, just a little too theoretical and fantastic, but he has the makings of a detective in him. It is not too much to say that once or twice, as in that business of the Sholto murder and the Agra treasure, he has been more nearly correct than the official force."

"Oh, if you say so, Mr. Jones, it is all right," said the stranger with deference. "Still, I confess that I miss my rubber. It is the first Saturday night for seven-and-twenty years that I have not had my rubber."

"I think you will find," said Sherlock Holmes, "that you will play for a higher stake to-night than you have ever done yet, and that the play will be more exciting. For you, Mr. Merryweather, the stake will be some $30,000; and for you, Jones, it will be the man upon whom you wish to lay your hands."

"John Clay, the murderer, thief, smasher, and forger. He's a young man, Mr. Merryweather, but he is at the head of his profession, and I would rather have my bracelets on him than on any criminal in London. He's a remarkable man, is young John Clay. His grandfather was a royal duke, and he himself has been to Eton and Oxford. His brain is as cunning as his fingers, and though we meet signs of him at every turn, we never know where to find the man himself. He'll crack a crib in Scotland one week, and be raising money to build an orphanage in Cornwall the next. I've been on his track for years and have never set eyes on him yet."

"I hope that I may have the pleasure of introducing you to-night. I've had one or two little turns also with Mr. John Clay, and I agree with you that he is at the head of his profession. It is past ten, however, and quite time that we started. If you two will take the first hansom, Watson and I will follow in the second."

Sherlock Holmes was not very communicative during the long drive and lay back in the cab humming the tunes which he had heard in the afternoon. We rattled through an endless labyrinth of gas-lit streets until we emerged into Farrington Street.

"We are close there now," my friend remarked. "This fellow Merryweather is a bank director, and personally interested in the matter. I thought it as well to have Jones with us also. He is not a bad fellow, though an absolute imbecile in his profession. He has one positive virtue. He is as brave as a bulldog and as tenacious as a lobster if he gets his claws upon anyone. Here we are, and they are waiting for us."

We had reached the same crowded thoroughfare in which we had found ourselves in the morning. Our cabs were dismissed, and, following the guidance of Mr. Merryweather, we passed down a narrow passage and through a side door, which he opened for us. Within there was a small corridor, which ended in a very massive iron gate. This also was opened, and led down a flight of winding stone steps, which terminated at another formidable gate. Mr. Merryweather stopped to light a lantern, and then conducted us down a dark, earth-smelling passage, and so, after opening a third door, into a huge vault or cellar, which was piled all round with crates and massive boxes.

"You are not very vulnerable from above," Holmes remarked as he held up the lantern and gazed about him.

"Nor from below," said Mr. Merryweather, striking his stick upon the flags which lined the floor. "Why, dear me, it sounds quite hollow!" he remarked, looking up in surprise.

"I must really ask you to be a little more quiet!" said Holmes severely. "You have already imperilled the whole success of our expedition. Might I beg that you would have the goodness to sit down upon one of those boxes, and not to interfere?"

The solemn Mr. Merryweather perched himself upon a crate, with a very injured expression upon his face, while Holmes fell upon his knees upon the floor and, with the lantern and a magnifying lens, began to examine minutely the cracks between the stones. A few seconds sufficed to satisfy him, for he sprang to his feet again and put his glass in his pocket.

"We have at least an hour before us," he remarked, "for they can hardly take any steps until the good pawnbroker is safely in bed. Then they will not lose a minute, for the sooner they do their work the longer time they will have for their escape. We are at present, Doctor--as no doubt you have divined--in the cellar of the City branch of one of the principal London banks. Mr. Merryweather is the chairman of directors, and he will explain to you that there are reasons why the more daring criminals of London should take a considerable interest in this cellar at present."

"It is our French gold," whispered the director. "We have had several warnings that an attempt might be made upon it."

"Your French gold?"

"Yes. We had occasion some months ago to strengthen our resources and borrowed for that purpose 30,000 napoleons from the Bank of France. It has become known that we have never had occasion to unpack the money, and that it is still lying in our cellar. The crate upon which I sit contains 2,000 napoleons packed between layers of lead foil. Our reserve of bullion is much larger at present than is usually kept in a single branch office, and the directors have had misgivings upon the subject."

"Which were very well justified," observed Holmes. "And now it is time that we arranged our little plans. I expect that within an hour matters will come to a head. In the meantime Mr. Merryweather, we must put the screen over that dark lantern."

"And sit in the dark?"

"I am afraid so. I had brought a pack of cards in my pocket, and I thought that, as we were a partie carree, you might have your rubber after all. But I see that the enemy's preparations have gone so far that we cannot risk the presence of a light. And, first of all, we must choose our positions. These are daring men, and though we shall take them at a disadvantage, they may do us some harm unless we are careful. I shall stand behind this crate, and do you conceal yourselves behind those. Then, when I flash a light upon them, close in swiftly. If they fire, Watson, have no compunction about shooting them down."

I placed my revolver, cocked, upon the top of the wooden case behind which I crouched. Holmes shot the slide across the front of his lantern and left us in pitch darkness--such an absolute darkness as I have never before experienced. The smell of hot metal remained to assure us that the light was still there, ready to flash out at a moment's notice. To me, with my nerves worked up to a pitch of expectancy, there was something depressing and subduing in the sudden gloom, and in the cold dank air of the vault.

"They have but one retreat," whispered Holmes. "That is back through the house into Saxe-Coburg Square. I hope that you have done what I asked you, Jones?"

"I have an inspector and two officers waiting at the front door."

"Then we have stopped all the holes. And now we must be silent and wait."

What a time it seemed! From comparing notes afterwards it was but an hour and a quarter, yet it appeared to me that the night must have almost gone, and the dawn be breaking above us. My limbs were weary and stiff, for I feared to change my position; yet my nerves were worked up to the highest pitch of tension, and my hearing was so acute that I could not only hear the gentle breathing of my companions, but I could distinguish the deeper, heavier in-breath of the bulky Jones from the thin, sighing note of the bank director. From my position I could look over the case in the direction of the floor. Suddenly my eyes caught the glint of a light.

At first it was but a lurid spark upon the stone pavement. Then it lengthened out until it became a yellow line, and then, without any warning or sound, a gash seemed to open and a hand appeared, a white, almost womanly hand, which felt about in the centre of the little area of light. For a minute or more the hand, with its writhing fingers, protruded out of the floor. Then it was withdrawn as suddenly as it appeared, and all was dark again save the single lurid spark which marked a chink between the stones.

Its disappearance, however, was but momentary. With a rending, tearing sound, one of the broad, white stones turned over upon its side and left a square, gaping hole, through which streamed the light of a lantern. Over the edge there peeped a clean-cut, boyish face, which looked keenly about it, and then, with a hand on either side of the aperture, drew itself shoulder-high and waist-high, until one knee rested upon the edge. In another instant he stood at the side of the hole and was hauling after him a companion, lithe and small like himself, with a pale face and a shock of very red hair.

"It's all clear," he whispered. "Have you the chisel and the bags? Great Scott! Jump, Archie, jump, and I'll swing for it!"

Sherlock Holmes had sprung out and seized the intruder by the collar. The other dived down the hole, and I heard the sound of rending cloth as Jones clutched at his skirts. The light flashed upon the barrel of a revolver, but Holmes' hunting crop came down on the man's wrist, and the pistol clinked upon the stone floor.

"It's no use, John Clay," said Holmes blandly. "You have no chance at all."

"So I see," the other answered with the utmost coolness. "I fancy that my pal is all right, though I see you have got his coat-tails."

"There are three men waiting for him at the door," said Holmes.

"Oh, indeed! You seem to have done the thing very completely. I must compliment you."

"And I you," Holmes answered. "Your red-headed idea was very new and effective."

"You'll see your pal again presently," said Jones. "He's quicker at climbing down holes than I am. Just hold out while I fix the derbies."

"I beg that you will not touch me with your filthy hands," remarked our prisoner as the handcuffs clattered upon his wrists. "You may not be aware that I have royal blood in my veins. Have the goodness, also, when you address me always to say 'sir' and 'please.' "

"All right," said Jones with a stare and a snigger. "Well, would you please, sir, march upstairs, where we can get a cab to carry your Highness to the police-station?"

"That is better," said John Clay serenely. He made a sweeping bow to the three of us and walked quietly off in the custody of the detective.

"Really, Mr. Holmes," said Mr. Merryweather as we followed them from the cellar, "I do not know how the bank can thank you or repay you. There is no doubt that you have detected and defeated in the most complete manner one of the most determined attempts at bank robbery that have ever come within my experience."

"I have had one or two little scores of my own to settle with Mr. John Clay," said Holmes. "I have been at some small expense over this matter, which I shall expect the bank to refund, but beyond that I am amply repaid by having had an experience which is in many ways unique, and by hearing the very remarkable narrative of the Red-headed League."

"You see, Watson," he explained in the early hours of the morning as we sat over a glass of whisky and soda in Baker Street, "it was perfectly obvious from the first that the only possible object of this rather fantastic business of the advertisement of the League, and the copying of the Encyclopaedia, must be to get this not over-bright pawnbroker out of the way for a number of hours every day. It was a curious way of managing it, but, really, it would be difficult to suggest a better. The method was no doubt suggested to Clay's ingenious mind by the colour of his accomplice's hair. The $4 a week was a lure which must draw him, and what was it to them, who were playing for thousands? They put in the advertisement, one rogue has the temporary office, the other rogue incites the man to apply for it, and together they manage to secure his absence every morning in the week. From the time that I heard of the assistant having come for half wages, it was obvious to me that he had some strong motive for securing the situation."

"But how could you guess what the motive was?"

"Had there been women in the house, I should have suspected a mere vulgar intrigue. That, however, was out of the question. The man's business was a small one, and there was nothing in his house which could account for such elaborate preparations, and such an expenditure as they were at. It must, then, be something out of the house. What could it be? I thought of the assistant's fondness for photography, and his trick of vanishing into the cellar. The cellar! There was the end of this tangled clue. Then I made inquiries as to this mysterious assistant and found that I had to deal with one of the coolest and most daring criminals in London. He was doing something in the cellar--something which took many hours a day for months on end. What could it be, once more? I could think of nothing save that he was running a tunnel to some other building.

"So far I had got when we went to visit the scene of action. I surprised you by beating upon the pavement with my stick. I was ascertaining whether the cellar stretched out in front or behind. It was not in front. Then I rang the bell, and, as I hoped, the assistant answered it. We have had some skirmishes, but we had never set eyes upon each other before. I hardly looked at his face. His knees were what I wished to see. You must yourself have remarked how worn, wrinkled, and stained they were. They spoke of those hours of burrowing. The only remaining point was what they were burrowing for. I walked round the corner, saw the City and Suburban Bank abutted on our friend's premises, and felt that I had solved my problem. When you drove home after the concert I called upon Scotland Yard and upon the chairman of the bank directors, with the result that you have seen."

"And how could you tell that they would make their attempt to-night?" I asked.

"Well, when they closed their League offices that was a sign that they cared no longer about Mr. Jabez Wilson's presence--in other words, that they had completed their tunnel. But it was essential that they should use it soon, as it might be discovered, or the bullion might be removed. Saturday would suit them better than any other day, as it would give them two days for their escape. For all these reasons I expected them to come to-night."

"You reasoned it out beautifully," I exclaimed in unfeigned admiration. "It is so long a chain, and yet every link rings true."

"It saved me from ennui," he answered, yawning. "Alas! I already feel it closing in upon me. My life is spent in one long effort to escape from the commonplaces of existence. These little problems help me to do so."

"And you are a benefactor of the race," said I.

He shrugged his shoulders. "Well, perhaps, after all, it is of some little use," he remarked. " 'L'homme c'est rien--l'oeuvre c'est tout,' as Gustave Flaubert wrote to George Sand."

ADVENTURE  III.  A CASE OF IDENTITY


"My dear fellow," said Sherlock Holmes as we sat on either side of the fire in his lodgings at Baker Street, "life is infinitely stranger than anything which the mind of man could invent. We would not dare to conceive the things which are really mere commonplaces of existence. If we could fly out of that window hand in hand, hover over this great city, gently remove the roofs, and peep in at the queer things which are going on, the strange coincidences, the plannings, the cross-purposes, the wonderful chains of events, working through generations, and leading to the most outre results, it would make all fiction with its conventionalities and foreseen conclusions most stale and unprofitable."

"And yet I am not convinced of it," I answered. "The cases which come to light in the papers are, as a rule, bald enough, and vulgar enough. We have in our police reports realism pushed to its extreme limits, and yet the result is, it must be confessed, neither fascinating nor artistic."

"A certain selection and discretion must be used in producing a realistic effect," remarked Holmes. "This is wanting in the police report, where more stress is laid, perhaps, upon the platitudes of the magistrate than upon the details, which to an observer contain the vital essence of the whole matter. Depend upon it, there is nothing so unnatural as the commonplace."

I smiled and shook my head. "I can quite understand your thinking so." I said. "Of course, in your position of unofficial adviser and helper to everybody who is absolutely puzzled, throughout three continents, you are brought in contact with all that is strange and bizarre. But here"--I picked up the morning paper from the ground--"let us put it to a practical test. Here is the first heading upon which I come. 'A husband's cruelty to his wife.' There is half a column of print, but I know without reading it that it is all perfectly familiar to me. There is, of course, the other woman, the drink, the push, the blow, the bruise, the sympathetic sister or landlady. The crudest of writers could invent nothing more crude."

"Indeed, your example is an unfortunate one for your argument," said Holmes, taking the paper and glancing his eye down it. "This is the Dundas separation case, and, as it happens, I was engaged in clearing up some small points in connection with it. The husband was a teetotaler, there was no other woman, and the conduct complained of was that he had drifted into the habit of winding up every meal by taking out his false teeth and hurling them at his wife, which, you will allow, is not an action likely to occur to the imagination of the average story-teller. Take a pinch of snuff, Doctor, and acknowledge that I have scored over you in your example."

He held out his snuffbox of old gold, with a great amethyst in the centre of the lid. Its splendour was in such contrast to his homely ways and simple life that I could not help commenting upon it.

"Ah," said he, "I forgot that I had not seen you for some weeks. It is a little souvenir from the King of Bohemia in return for my assistance in the case of the Irene Adler papers."

"And the ring?" I asked, glancing at a remarkable brilliant which sparkled upon his finger.

"It was from the reigning family of Holland, though the matter in which I served them was of such delicacy that I cannot confide it even to you, who have been good enough to chronicle one or two of my little problems."

"And have you any on hand just now?" I asked with interest.

"Some ten or twelve, but none which present any feature of interest. They are important, you understand, without being interesting. Indeed, I have found that it is usually in unimportant matters that there is a field for the observation, and for the quick analysis of cause and effect which gives the charm to an investigation. The larger crimes are apt to be the simpler, for the bigger the crime the more obvious, as a rule, is the motive. In these cases, save for one rather intricate matter which has been referred to me from Marseilles, there is nothing which presents any features of interest. It is possible, however, that I may have something better before very many minutes are over, for this is one of my clients, or I am much mistaken."

He had risen from his chair and was standing between the parted blinds gazing down into the dull neutral-tinted London street. Looking over his shoulder, I saw that on the pavement opposite there stood a large woman with a heavy fur boa round her neck, and a large curling red feather in a broad-brimmed hat which was tilted in a coquettish Duchess of Devonshire fashion over her ear. From under this great panoply she peeped up in a nervous, hesitating fashion at our windows, while her body oscillated backward and forward, and her fingers fidgeted with her glove buttons. Suddenly, with a plunge, as of the swimmer who leaves the bank, she hurried across the road, and we heard the sharp clang of the bell.

"I have seen those symptoms before," said Holmes, throwing his cigarette into the fire. "Oscillation upon the pavement always means an affaire de coeur. She would like advice, but is not sure that the matter is not too delicate for communication. And yet even here we may discriminate. When a woman has been seriously wronged by a man she no longer oscillates, and the usual symptom is a broken bell wire. Here we may take it that there is a love matter, but that the maiden is not so much angry as perplexed, or grieved. But here she comes in person to resolve our doubts."

As he spoke there was a tap at the door, and the boy in buttons entered to announce Miss Mary Sutherland, while the lady herself loomed behind his small black figure like a full-sailed merchant-man behind a tiny pilot boat. Sherlock Holmes welcomed her with the easy courtesy for which he was remarkable, and, having closed the door and bowed her into an armchair, he looked her over in the minute and yet abstracted fashion which was peculiar to him.

"Do you not find," he said, "that with your short sight it is a little trying to do so much typewriting?"

"I did at first," she answered, "but now I know where the letters are without looking." Then, suddenly realising the full purport of his words, she gave a violent start and looked up, with fear and astonishment upon her broad, good-humoured face. "You've heard about me, Mr. Holmes," she cried, "else how could you know all that?"

"Never mind," said Holmes, laughing; "it is my business to know things. Perhaps I have trained myself to see what others overlook. If not, why should you come to consult me?"

"I came to you, sir, because I heard of you from Mrs. Etherege, whose husband you found so easy when the police and everyone had given him up for dead. Oh, Mr. Holmes, I wish you would do as much for me. I'm not rich, but still I have a hundred a year in my own right, besides the little that I make by the machine, and I would give it all to know what has become of Mr. Hosmer Angel."

"Why did you come away to consult me in such a hurry?" asked Sherlock Holmes, with his finger-tips together and his eyes to the ceiling.

Again a startled look came over the somewhat vacuous face of Miss Mary Sutherland. "Yes, I did bang out of the house," she said, "for it made me angry to see the easy way in which Mr. Windibank--that is, my father--took it all. He would not go to the police, and he would not go to you, and so at last, as he would do nothing and kept on saying that there was no harm done, it made me mad, and I just on with my things and came right away to you."

"Your father," said Holmes, "your stepfather, surely, since the name is different."

"Yes, my stepfather. I call him father, though it sounds funny, too, for he is only five years and two months older than myself."

"And your mother is alive?"

"Oh, yes, mother is alive and well. I wasn't best pleased, Mr. Holmes, when she married again so soon after father's death, and a man who was nearly fifteen years younger than herself. Father was a plumber in the Tottenham Court Road, and he left a tidy business behind him, which mother carried on with Mr. Hardy, the foreman; but when Mr. Windibank came he made her sell the business, for he was very superior, being a traveller in wines. They got $4700 for the goodwill and interest, which wasn't near as much as father could have got if he had been alive."

I had expected to see Sherlock Holmes impatient under this rambling and inconsequential narrative, but, on the contrary, he had listened with the greatest concentration of attention.

"Your own little income," he asked, "does it come out of the business?"

"Oh, no, sir. It is quite separate and was left me by my uncle Ned in Auckland. It is in New Zealand stock, paying 4 1/4 per cent. Two thousand five hundred pounds was the amount, but I can only touch the interest."

"You interest me extremely," said Holmes. "And since you draw so large a sum as a hundred a year, with what you earn into the bargain, you no doubt travel a little and indulge yourself in every way. I believe that a single lady can get on very nicely upon an income of about $60."

"I could do with much less than that, Mr. Holmes, but you understand that as long as I live at home I don't wish to be a burden to them, and so they have the use of the money just while I am staying with them. Of course, that is only just for the time. Mr. Windibank draws my interest every quarter and pays it over to mother, and I find that I can do pretty well with what I earn at typewriting. It brings me twopence a sheet, and I can often do from fifteen to twenty sheets in a day."

"You have made your position very clear to me," said Holmes. "This is my friend, Dr. Watson, before whom you can speak as freely as before myself. Kindly tell us now all about your connection with Mr. Hosmer Angel."

A flush stole over Miss Sutherland's face, and she picked nervously at the fringe of her jacket. "I met him first at the gasfitters' ball," she said. "They used to send father tickets when he was alive, and then afterwards they remembered us, and sent them to mother. Mr. Windibank did not wish us to go. He never did wish us to go anywhere. He would get quite mad if I wanted so much as to join a Sunday-school treat. But this time I was set on going, and I would go; for what right had he to prevent? He said the folk were not fit for us to know, when all father's friends were to be there. And he said that I had nothing fit to wear, when I had my purple plush that I had never so much as taken out of the drawer. At last, when nothing else would do, he went off to France upon the business of the firm, but we went, mother and I, with Mr. Hardy, who used to be our foreman, and it was there I met Mr. Hosmer Angel."

"I suppose," said Holmes, "that when Mr. Windibank came back from France he was very annoyed at your having gone to the ball."

"Oh, well, he was very good about it. He laughed, I remember, and shrugged his shoulders, and said there was no use denying anything to a woman, for she would have her way."

"I see. Then at the gasfitters' ball you met, as I understand, a gentleman called Mr. Hosmer Angel."

"Yes, sir. I met him that night, and he called next day to ask if we had got home all safe, and after that we met him--that is to say, Mr. Holmes, I met him twice for walks, but after that father came back again, and Mr. Hosmer Angel could not come to the house any more."

"No?"

"Well, you know father didn't like anything of the sort. He wouldn't have any visitors if he could help it, and he used to say that a woman should be happy in her own family circle. But then, as I used to say to mother, a woman wants her own circle to begin with, and I had not got mine yet."

"But how about Mr. Hosmer Angel? Did he make no attempt to see you?"

"Well, father was going off to France again in a week, and Hosmer wrote and said that it would be safer and better not to see each other until he had gone. We could write in the meantime, and he used to write every day. I took the letters in in the morning, so there was no need for father to know."

"Were you engaged to the gentleman at this time?"

"Oh, yes, Mr. Holmes. We were engaged after the first walk that we took. Hosmer--Mr. Angel--was a cashier in an office in Leadenhall Street--and--"

"What office?"

"That's the worst of it, Mr. Holmes, I don't know."

"Where did he live, then?"

"He slept on the premises."

"And you don't know his address?"

"No--except that it was Leadenhall Street."

"Where did you address your letters, then?"

"To the Leadenhall Street Post Office, to be left till called for. He said that if they were sent to the office he would be chaffed by all the other clerks about having letters from a lady, so I offered to typewrite them, like he did his, but he wouldn't have that, for he said that when I wrote them they seemed to come from me, but when they were typewritten he always felt that the machine had come between us. That will just show you how fond he was of me, Mr. Holmes, and the little things that he would think of."

"It was most suggestive," said Holmes. "It has long been an axiom of mine that the little things are infinitely the most important. Can you remember any other little things about Mr. Hosmer Angel?"

"He was a very shy man, Mr. Holmes. He would rather walk with me in the evening than in the daylight, for he said that he hated to be conspicuous. Very retiring and gentlemanly he was. Even his voice was gentle. He'd had the quinsy and swollen glands when he was young, he told me, and it had left him with a weak throat, and a hesitating, whispering fashion of speech. He was always well dressed, very neat and plain, but his eyes were weak, just as mine are, and he wore tinted glasses against the glare."

"Well, and what happened when Mr. Windibank, your stepfather, returned to France?"

"Mr. Hosmer Angel came to the house again and proposed that we should marry before father came back. He was in dreadful earnest and made me swear, with my hands on the Testament, that whatever happened I would always be true to him. Mother said he was quite right to make me swear, and that it was a sign of his passion. Mother was all in his favour from the first and was even fonder of him than I was. Then, when they talked of marrying within the week, I began to ask about father; but they both said never to mind about father, but just to tell him afterwards, and mother said she would make it all right with him. I didn't quite like that, Mr. Holmes. It seemed funny that I should ask his leave, as he was only a few years older than me; but I didn't want to do anything on the sly, so I wrote to father at Bordeaux, where the company has its French offices, but the letter came back to me on the very morning of the wedding."

"It missed him, then?"

"Yes, sir; for he had started to England just before it arrived."

"Ha! that was unfortunate. Your wedding was arranged, then, for the Friday. Was it to be in church?"

"Yes, sir, but very quietly. It was to be at St. Saviour's, near King's Cross, and we were to have breakfast afterwards at the St. Pancras Hotel. Hosmer came for us in a hansom, but as there were two of us he put us both into it and stepped himself into a four-wheeler, which happened to be the only other cab in the street. We got to the church first, and when the four-wheeler drove up we waited for him to step out, but he never did, and when the cabman got down from the box and looked there was no one there! The cabman said that he could not imagine what had become of him, for he had seen him get in with his own eyes. That was last Friday, Mr. Holmes, and I have never seen or heard anything since then to throw any light upon what became of him."

"It seems to me that you have been very shamefully treated," said Holmes.

"Oh, no, sir! He was too good and kind to leave me so. Why, all the morning he was saying to me that, whatever happened, I was to be true; and that even if something quite unforeseen occurred to separate us, I was always to remember that I was pledged to him, and that he would claim his pledge sooner or later. It seemed strange talk for a wedding-morning, but what has happened since gives a meaning to it."

"Most certainly it does. Your own opinion is, then, that some unforeseen catastrophe has occurred to him?"

"Yes, sir. I believe that he foresaw some danger, or else he would not have talked so. And then I think that what he foresaw happened."

"But you have no notion as to what it could have been?"

"None."

"One more question. How did your mother take the matter?"

"She was angry, and said that I was never to speak of the matter again."

"And your father? Did you tell him?"

"Yes; and he seemed to think, with me, that something had happened, and that I should hear of Hosmer again. As he said, what interest could anyone have in bringing me to the doors of the church, and then leaving me? Now, if he had borrowed my money, or if he had married me and got my money settled on him, there might be some reason, but Hosmer was very independent about money and never would look at a shilling of mine. And yet, what could have happened? And why could he not write? Oh, it drives me half-mad to think of it, and I can't sleep a wink at night." She pulled a little handkerchief out of her muff and began to sob heavily into it.

"I shall glance into the case for you," said Holmes, rising, "and I have no doubt that we shall reach some definite result. Let the weight of the matter rest upon me now, and do not let your mind dwell upon it further. Above all, try to let Mr. Hosmer Angel vanish from your memory, as he has done from your life."

"Then you don't think I'll see him again?"

"I fear not."

"Then what has happened to him?"

"You will leave that question in my hands. I should like an accurate description of him and any letters of his which you can spare."

"I advertised for him in last Saturday's Chronicle," said she. "Here is the slip and here are four letters from him."

"Thank you. And your address?"

"No. 31 Lyon Place, Camberwell."

"Mr. Angel's address you never had, I understand. Where is your father's place of business?"

"He travels for Westhouse & Marbank, the great claret importers of Fenchurch Street."

"Thank you. You have made your statement very clearly. You will leave the papers here, and remember the advice which I have given you. Let the whole incident be a sealed book, and do not allow it to affect your life."

"You are very kind, Mr. Holmes, but I cannot do that. I shall be true to Hosmer. He shall find me ready when he comes back."

For all the preposterous hat and the vacuous face, there was something noble in the simple faith of our visitor which compelled our respect. She laid her little bundle of papers upon the table and went her way, with a promise to come again whenever she might be summoned.

Sherlock Holmes sat silent for a few minutes with his fingertips still pressed together, his legs stretched out in front of him, and his gaze directed upward to the ceiling. Then he took down from the rack the old and oily clay pipe, which was to him as a counsellor, and, having lit it, he leaned back in his chair, with the thick blue cloud-wreaths spinning up from him, and a look of infinite languor in his face.

"Quite an interesting study, that maiden," he observed. "I found her more interesting than her little problem, which, by the way, is rather a trite one. You will find parallel cases, if you consult my index, in Andover in '77, and there was something of the sort at The Hague last year. Old as is the idea, however, there were one or two details which were new to me. But the maiden herself was most instructive."

"You appeared to read a good deal upon her which was quite invisible to me," I remarked.

"Not invisible but unnoticed, Watson. You did not know where to look, and so you missed all that was important. I can never bring you to realise the importance of sleeves, the suggestiveness of thumb-nails, or the great issues that may hang from a boot-lace. Now, what did you gather from that woman's appearance? Describe it."

"Well, she had a slate-coloured, broad-brimmed straw hat, with a feather of a brickish red. Her jacket was black, with black beads sewn upon it, and a fringe of little black jet ornaments. Her dress was brown, rather darker than coffee colour, with a little purple plush at the neck and sleeves. Her gloves were greyish and were worn through at the right forefinger. Her boots I didn't observe. She had small round, hanging gold earrings, and a general air of being fairly well-to-do in a vulgar, comfortable, easy-going way."

Sherlock Holmes clapped his hands softly together and chuckled.

" 'Pon my word, Watson, you are coming along wonderfully. You have really done very well indeed. It is true that you have missed everything of importance, but you have hit upon the method, and you have a quick eye for colour. Never trust to general impressions, my boy, but concentrate yourself upon details. My first glance is always at a woman's sleeve. In a man it is perhaps better first to take the knee of the trouser. As you observe, this woman had plush upon her sleeves, which is a most useful material for showing traces. The double line a little above the wrist, where the typewritist presses against the table, was beautifully defined. The sewing-machine, of the hand type, leaves a similar mark, but only on the left arm, and on the side of it farthest from the thumb, instead of being right across the broadest part, as this was. I then glanced at her face, and, observing the dint of a pince-nez at either side of her nose, I ventured a remark upon short sight and typewriting, which seemed to surprise her."

"It surprised me."

"But, surely, it was obvious. I was then much surprised and interested on glancing down to observe that, though the boots which she was wearing were not unlike each other, they were really odd ones; the one having a slightly decorated toe-cap, and the other a plain one. One was buttoned only in the two lower buttons out of five, and the other at the first, third, and fifth. Now, when you see that a young lady, otherwise neatly dressed, has come away from home with odd boots, half-buttoned, it is no great deduction to say that she came away in a hurry."

"And what else?" I asked, keenly interested, as I always was, by my friend's incisive reasoning.

"I noted, in passing, that she had written a note before leaving home but after being fully dressed. You observed that her right glove was torn at the forefinger, but you did not apparently see that both glove and finger were stained with violet ink. She had written in a hurry and dipped her pen too deep. It must have been this morning, or the mark would not remain clear upon the finger. All this is amusing, though rather elementary, but I must go back to business, Watson. Would you mind reading me the advertised description of Mr. Hosmer Angel?"

I held the little printed slip to the light.

"Missing," it said, "on the morning of the fourteenth, a gentleman named Hosmer Angel. About five ft. seven in. in height; strongly built, sallow complexion, black hair, a little bald in the centre, bushy, black side-whiskers and moustache; tinted glasses, slight infirmity of speech. Was dressed, when last seen, in black frock-coat faced with silk, black waistcoat, gold Albert chain, and grey Harris tweed trousers, with brown gaiters over elastic-sided boots. Known to have been employed in an office in Leadenhall Street. Anybody bringing--"

"That will do," said Holmes. "As to the letters," he continued, glancing over them, "they are very commonplace. Absolutely no clue in them to Mr. Angel, save that he quotes Balzac once. There is one remarkable point, however, which will no doubt strike you."

"They are typewritten," I remarked.

"Not only that, but the signature is typewritten. Look at the neat little 'Hosmer Angel' at the bottom. There is a date, you see, but no superscription except Leadenhall Street, which is rather vague. The point about the signature is very suggestive--in fact, we may call it conclusive."

"Of what?"

"My dear fellow, is it possible you do not see how strongly it bears upon the case?"

"I cannot say that I do unless it were that he wished to be able to deny his signature if an action for breach of promise were instituted."

"No, that was not the point. However, I shall write two letters, which should settle the matter. One is to a firm in the City, the other is to the young lady's stepfather, Mr. Windibank, asking him whether he could meet us here at six o'clock to-morrow evening. It is just as well that we should do business with the male relatives. And now, Doctor, we can do nothing until the answers to those letters come, so we may put our little problem upon the shelf for the interim."

I had had so many reasons to believe in my friend's subtle powers of reasoning and extraordinary energy in action that I felt that he must have some solid grounds for the assured and easy demeanour with which he treated the singular mystery which he had been called upon to fathom. Once only had I known him to fail, in the case of the King of Bohemia and of the Irene Adler photograph; but when I looked back to the weird business of the Sign of Four, and the extraordinary circumstances connected with the Study in Scarlet, I felt that it would be a strange tangle indeed which he could not unravel.

I left him then, still puffing at his black clay pipe, with the conviction that when I came again on the next evening I would find that he held in his hands all the clues which would lead up to the identity of the disappearing bridegroom of Miss Mary Sutherland.

A professional case of great gravity was engaging my own attention at the time, and the whole of next day I was busy at the bedside of the sufferer. It was not until close upon six o'clock that I found myself free and was able to spring into a hansom and drive to Baker Street, half afraid that I might be too late to assist at the denouement of the little mystery. I found Sherlock Holmes alone, however, half asleep, with his long, thin form curled up in the recesses of his armchair. A formidable array of bottles and test-tubes, with the pungent cleanly smell of hydrochloric acid, told me that he had spent his day in the chemical work which was so dear to him.

"Well, have you solved it?" I asked as I entered.

"Yes. It was the bisulphate of baryta."

"No, no, the mystery!" I cried.

"Oh, that! I thought of the salt that I have been working upon. There was never any mystery in the matter, though, as I said yesterday, some of the details are of interest. The only drawback is that there is no law, I fear, that can touch the scoundrel."

"Who was he, then, and what was his object in deserting Miss Sutherland?"

The question was hardly out of my mouth, and Holmes had not yet opened his lips to reply, when we heard a heavy footfall in the passage and a tap at the door.

"This is the girl's stepfather, Mr. James Windibank," said Holmes. "He has written to me to say that he would be here at six. Come in!"

The man who entered was a sturdy, middle-sized fellow, some thirty years of age, clean-shaven, and sallow-skinned, with a bland, insinuating manner, and a pair of wonderfully sharp and penetrating grey eyes. He shot a questioning glance at each of us, placed his shiny top-hat upon the sideboard, and with a slight bow sidled down into the nearest chair.

"Good-evening, Mr. James Windibank," said Holmes. "I think that this typewritten letter is from you, in which you made an appointment with me for six o'clock?"

"Yes, sir. I am afraid that I am a little late, but I am not quite my own master, you know. I am sorry that Miss Sutherland has troubled you about this little matter, for I think it is far better not to wash linen of the sort in public. It was quite against my wishes that she came, but she is a very excitable, impulsive girl, as you may have noticed, and she is not easily controlled when she has made up her mind on a point. Of course, I did not mind you so much, as you are not connected with the official police, but it is not pleasant to have a family misfortune like this noised abroad. Besides, it is a useless expense, for how could you possibly find this Hosmer Angel?"

"On the contrary," said Holmes quietly; "I have every reason to believe that I will succeed in discovering Mr. Hosmer Angel."

Mr. Windibank gave a violent start and dropped his gloves. "I am delighted to hear it," he said.

"It is a curious thing," remarked Holmes, "that a typewriter has really quite as much individuality as a man's handwriting. Unless they are quite new, no two of them write exactly alike. Some letters get more worn than others, and some wear only on one side. Now, you remark in this note of yours, Mr. Windibank, that in every case there is some little slurring over of the 'e,' and a slight defect in the tail of the 'r.' There are fourteen other characteristics, but those are the more obvious."

"We do all our correspondence with this machine at the office, and no doubt it is a little worn," our visitor answered, glancing keenly at Holmes with his bright little eyes.

"And now I will show you what is really a very interesting study, Mr. Windibank," Holmes continued. "I think of writing another little monograph some of these days on the typewriter and its relation to crime. It is a subject to which I have devoted some little attention. I have here four letters which purport to come from the missing man. They are all typewritten. In each case, not only are the 'e's' slurred and the 'r's' tailless, but you will observe, if you care to use my magnifying lens, that the fourteen other characteristics to which I have alluded are there as well."

Mr. Windibank sprang out of his chair and picked up his hat. "I cannot waste time over this sort of fantastic talk, Mr. Holmes," he said. "If you can catch the man, catch him, and let me know when you have done it."

"Certainly," said Holmes, stepping over and turning the key in the door. "I let you know, then, that I have caught him!"

"What! where?" shouted Mr. Windibank, turning white to his lips and glancing about him like a rat in a trap.

"Oh, it won't do--really it won't," said Holmes suavely. "There is no possible getting out of it, Mr. Windibank. It is quite too transparent, and it was a very bad compliment when you said that it was impossible for me to solve so simple a question. That's right! Sit down and let us talk it over."

Our visitor collapsed into a chair, with a ghastly face and a glitter of moisture on his brow. "It--it's not actionable," he stammered.

"I am very much afraid that it is not. But between ourselves, Windibank, it was as cruel and selfish and heartless a trick in a petty way as ever came before me. Now, let me just run over the course of events, and you will contradict me if I go wrong."

The man sat huddled up in his chair, with his head sunk upon his breast, like one who is utterly crushed. Holmes stuck his feet up on the corner of the mantelpiece and, leaning back with his hands in his pockets, began talking, rather to himself, as it seemed, than to us.

"The man married a woman very much older than himself for her money," said he, "and he enjoyed the use of the money of the daughter as long as she lived with them. It was a considerable sum, for people in their position, and the loss of it would have made a serious difference. It was worth an effort to preserve it. The daughter was of a good, amiable disposition, but affectionate and warm-hearted in her ways, so that it was evident that with her fair personal advantages, and her little income, she would not be allowed to remain single long. Now her marriage would mean, of course, the loss of a hundred a year, so what does her stepfather do to prevent it? He takes the obvious course of keeping her at home and forbidding her to seek the company of people of her own age. But soon he found that that would not answer forever. She became restive, insisted upon her rights, and finally announced her positive intention of going to a certain ball. What does her clever stepfather do then? He conceives an idea more creditable to his head than to his heart. With the connivance and assistance of his wife he disguised himself, covered those keen eyes with tinted glasses, masked the face with a moustache and a pair of bushy whiskers, sunk that clear voice into an insinuating whisper, and doubly secure on account of the girl's short sight, he appears as Mr. Hosmer Angel, and keeps off other lovers by making love himself."

"It was only a joke at first," groaned our visitor. "We never thought that she would have been so carried away."

"Very likely not. However that may be, the young lady was very decidedly carried away, and, having quite made up her mind that her stepfather was in France, the suspicion of treachery never for an instant entered her mind. She was flattered by the gentleman's attentions, and the effect was increased by the loudly expressed admiration of her mother. Then Mr. Angel began to call, for it was obvious that the matter should be pushed as far as it would go if a real effect were to be produced. There were meetings, and an engagement, which would finally secure the girl's affections from turning towards anyone else. But the deception could not be kept up forever. These pretended journeys to France were rather cumbrous. The thing to do was clearly to bring the business to an end in such a dramatic manner that it would leave a permanent impression upon the young lady's mind and prevent her from looking upon any other suitor for some time to come. Hence those vows of fidelity exacted upon a Testament, and hence also the allusions to a possibility of something happening on the very morning of the wedding. James Windibank wished Miss Sutherland to be so bound to Hosmer Angel, and so uncertain as to his fate, that for ten years to come, at any rate, she would not listen to another man. As far as the church door he brought her, and then, as he could go no farther, he conveniently vanished away by the old trick of stepping in at one door of a four-wheeler and out at the other. I think that was the chain of events, Mr. Windibank!"

Our visitor had recovered something of his assurance while Holmes had been talking, and he rose from his chair now with a cold sneer upon his pale face.

"It may be so, or it may not, Mr. Holmes," said he, "but if you are so very sharp you ought to be sharp enough to know that it is you who are breaking the law now, and not me. I have done nothing actionable from the first, but as long as you keep that door locked you lay yourself open to an action for assault and illegal constraint."

"The law cannot, as you say, touch you," said Holmes, unlocking and throwing open the door, "yet there never was a man who deserved punishment more. If the young lady has a brother or a friend, he ought to lay a whip across your shoulders. By Jove!" he continued, flushing up at the sight of the bitter sneer upon the man's face, "it is not part of my duties to my client, but here's a hunting crop handy, and I think I shall just treat myself to--" He took two swift steps to the whip, but before he could grasp it there was a wild clatter of steps upon the stairs, the heavy hall door banged, and from the window we could see Mr. James Windibank running at the top of his speed down the road.

"There's a cold-blooded scoundrel!" said Holmes, laughing, as he threw himself down into his chair once more. "That fellow will rise from crime to crime until he does something very bad, and ends on a gallows. The case has, in some respects, been not entirely devoid of interest."

"I cannot now entirely see all the steps of your reasoning," I remarked.

"Well, of course it was obvious from the first that this Mr. Hosmer Angel must have some strong object for his curious conduct, and it was equally clear that the only man who really profited by the incident, as far as we could see, was the stepfather. Then the fact that the two men were never together, but that the one always appeared when the other was away, was suggestive. So were the tinted spectacles and the curious voice, which both hinted at a disguise, as did the bushy whiskers. My suspicions were all confirmed by his peculiar action in typewriting his signature, which, of course, inferred that his handwriting was so familiar to her that she would recognise even the smallest sample of it. You see all these isolated facts, together with many minor ones, all pointed in the same direction."

"And how did you verify them?"

"Having once spotted my man, it was easy to get corroboration. I knew the firm for which this man worked. Having taken the printed description. I eliminated everything from it which could be the result of a disguise--the whiskers, the glasses, the voice, and I sent it to the firm, with a request that they would inform me whether it answered to the description of any of their travellers. I had already noticed the peculiarities of the typewriter, and I wrote to the man himself at his business address asking him if he would come here. As I expected, his reply was typewritten and revealed the same trivial but characteristic defects. The same post brought me a letter from Westhouse & Marbank, of Fenchurch Street, to say that the description tallied in every respect with that of their employe, James Windibank. Voila tout!"

"And Miss Sutherland?"

"If I tell her she will not believe me. You may remember the old Persian saying, 'There is danger for him who taketh the tiger cub, and danger also for whoso snatches a delusion from a woman.' There is as much sense in Hafiz as in Horace, and as much knowledge of the world."

ADVENTURE IV. THE BOSCOMBE VALLEY MYSTERY


We were seated at breakfast one morning, my wife and I, when the maid brought in a telegram. It was from Sherlock Holmes and ran in this way:

"Have you a couple of days to spare? Have just been wired for from the west of England in connection with Boscombe Valley tragedy. Shall be glad if you will come with me. Air and scenery perfect. Leave Paddington by the 11:15."

"What do you say, dear?" said my wife, looking across at me. "Will you go?"

"I really don't know what to say. I have a fairly long list at present."

"Oh, Anstruther would do your work for you. You have been looking a little pale lately. I think that the change would do you good, and you are always so interested in Mr. Sherlock Holmes' cases."

"I should be ungrateful if I were not, seeing what I gained through one of them," I answered. "But if I am to go, I must pack at once, for I have only half an hour."

My experience of camp life in Afghanistan had at least had the effect of making me a prompt and ready traveller. My wants were few and simple, so that in less than the time stated I was in a cab with my valise, rattling away to Paddington Station. Sherlock Holmes was pacing up and down the platform, his tall, gaunt figure made even gaunter and taller by his long grey travelling-cloak and close-fitting cloth cap.

"It is really very good of you to come, Watson," said he. "It makes a considerable difference to me, having someone with me on whom I can thoroughly rely. Local aid is always either worthless or else biassed. If you will keep the two corner seats I shall get the tickets."

We had the carriage to ourselves save for an immense litter of papers which Holmes had brought with him. Among these he rummaged and read, with intervals of note-taking and of meditation, until we were past Reading. Then he suddenly rolled them all into a gigantic ball and tossed them up onto the rack.

"Have you heard anything of the case?" he asked.

"Not a word. I have not seen a paper for some days."

"The London press has not had very full accounts. I have just been looking through all the recent papers in order to master the particulars. It seems, from what I gather, to be one of those simple cases which are so extremely difficult."

"That sounds a little paradoxical."

"But it is profoundly true. Singularity is almost invariably a clue. The more featureless and commonplace a crime is, the more difficult it is to bring it home. In this case, however, they have established a very serious case against the son of the murdered man."

"It is a murder, then?"

"Well, it is conjectured to be so. I shall take nothing for granted until I have the opportunity of looking personally into it. I will explain the state of things to you, as far as I have been able to understand it, in a very few words.

"Boscombe Valley is a country district not very far from Ross, in Herefordshire. The largest landed proprietor in that part is a Mr. John Turner, who made his money in Australia and returned some years ago to the old country. One of the farms which he held, that of Hatherley, was let to Mr. Charles McCarthy, who was also an ex-Australian. The men had known each other in the colonies, so that it was not unnatural that when they came to settle down they should do so as near each other as possible. Turner was apparently the richer man, so McCarthy became his tenant but still remained, it seems, upon terms of perfect equality, as they were frequently together. McCarthy had one son, a lad of eighteen, and Turner had an only daughter of the same age, but neither of them had wives living. They appear to have avoided the society of the neighbouring English families and to have led retired lives, though both the McCarthys were fond of sport and were frequently seen at the race-meetings of the neighbourhood. McCarthy kept two servants--a man and a girl. Turner had a considerable household, some half-dozen at the least. That is as much as I have been able to gather about the families. Now for the facts.

"On June 3rd, that is, on Monday last, McCarthy left his house at Hatherley about three in the afternoon and walked down to the Boscombe Pool, which is a small lake formed by the spreading out of the stream which runs down the Boscombe Valley. He had been out with his serving-man in the morning at Ross, and he had told the man that he must hurry, as he had an appointment of importance to keep at three. From that appointment he never came back alive.

"From Hatherley Farmhouse to the Boscombe Pool is a quarter of a mile, and two people saw him as he passed over this ground. One was an old woman, whose name is not mentioned, and the other was William Crowder, a game-keeper in the employ of Mr. Turner. Both these witnesses depose that Mr. McCarthy was walking alone. The game-keeper adds that within a few minutes of his seeing Mr. McCarthy pass he had seen his son, Mr. James McCarthy, going the same way with a gun under his arm. To the best of his belief, the father was actually in sight at the time, and the son was following him. He thought no more of the matter until he heard in the evening of the tragedy that had occurred.

"The two McCarthys were seen after the time when William Crowder, the game-keeper, lost sight of them. The Boscombe Pool is thickly wooded round, with just a fringe of grass and of reeds round the edge. A girl of fourteen, Patience Moran, who is the daughter of the lodge-keeper of the Boscombe Valley estate, was in one of the woods picking flowers. She states that while she was there she saw, at the border of the wood and close by the lake, Mr. McCarthy and his son, and that they appeared to be having a violent quarrel. She heard Mr. McCarthy the elder using very strong language to his son, and she saw the latter raise up his hand as if to strike his father. She was so frightened by their violence that she ran away and told her mother when she reached home that she had left the two McCarthys quarrelling near Boscombe Pool, and that she was afraid that they were going to fight. She had hardly said the words when young Mr. McCarthy came running up to the lodge to say that he had found his father dead in the wood, and to ask for the help of the lodge-keeper. He was much excited, without either his gun or his hat, and his right hand and sleeve were observed to be stained with fresh blood. On following him they found the dead body stretched out upon the grass beside the pool. The head had been beaten in by repeated blows of some heavy and blunt weapon. The injuries were such as might very well have been inflicted by the butt-end of his son's gun, which was found lying on the grass within a few paces of the body. Under these circumstances the young man was instantly arrested, and a verdict of 'wilful murder' having been returned at the inquest on Tuesday, he was on Wednesday brought before the magistrates at Ross, who have referred the case to the next Assizes. Those are the main facts of the case as they came out before the coroner and the police-court."

"I could hardly imagine a more damning case," I remarked. "If ever circumstantial evidence pointed to a criminal it does so here."

"Circumstantial evidence is a very tricky thing," answered Holmes thoughtfully. "It may seem to point very straight to one thing, but if you shift your own point of view a little, you may find it pointing in an equally uncompromising manner to something entirely different. It must be confessed, however, that the case looks exceedingly grave against the young man, and it is very possible that he is indeed the culprit. There are several people in the neighbourhood, however, and among them Miss Turner, the daughter of the neighbouring landowner, who believe in his innocence, and who have retained Lestrade, whom you may recollect in connection with the Study in Scarlet, to work out the case in his interest. Lestrade, being rather puzzled, has referred the case to me, and hence it is that two middle-aged gentlemen are flying westward at fifty miles an hour instead of quietly digesting their breakfasts at home."

"I am afraid," said I, "that the facts are so obvious that you will find little credit to be gained out of this case."

"There is nothing more deceptive than an obvious fact," he answered, laughing. "Besides, we may chance to hit upon some other obvious facts which may have been by no means obvious to Mr. Lestrade. You know me too well to think that I am boasting when I say that I shall either confirm or destroy his theory by means which he is quite incapable of employing, or even of understanding. To take the first example to hand, I very clearly perceive that in your bedroom the window is upon the right-hand side, and yet I question whether Mr. Lestrade would have noted even so self-evident a thing as that."

"How on earth--"

"My dear fellow, I know you well. I know the military neatness which characterises you. You shave every morning, and in this season you shave by the sunlight; but since your shaving is less and less complete as we get farther back on the left side, until it becomes positively slovenly as we get round the angle of the jaw, it is surely very clear that that side is less illuminated than the other. I could not imagine a man of your habits looking at himself in an equal light and being satisfied with such a result. I only quote this as a trivial example of observation and inference. Therein lies my metier, and it is just possible that it may be of some service in the investigation which lies before us. There are one or two minor points which were brought out in the inquest, and which are worth considering."

"What are they?"

"It appears that his arrest did not take place at once, but after the return to Hatherley Farm. On the inspector of constabulary informing him that he was a prisoner, he remarked that he was not surprised to hear it, and that it was no more than his deserts. This observation of his had the natural effect of removing any traces of doubt which might have remained in the minds of the coroner's jury."

"It was a confession," I ejaculated.

"No, for it was followed by a protestation of innocence."

"Coming on the top of such a damning series of events, it was at least a most suspicious remark."

"On the contrary," said Holmes, "it is the brightest rift which I can at present see in the clouds. However innocent he might be, he could not be such an absolute imbecile as not to see that the circumstances were very black against him. Had he appeared surprised at his own arrest, or feigned indignation at it, I should have looked upon it as highly suspicious, because such surprise or anger would not be natural under the circumstances, and yet might appear to be the best policy to a scheming man. His frank acceptance of the situation marks him as either an innocent man, or else as a man of considerable self-restraint and firmness. As to his remark about his deserts, it was also not unnatural if you consider that he stood beside the dead body of his father, and that there is no doubt that he had that very day so far forgotten his filial duty as to bandy words with him, and even, according to the little girl whose evidence is so important, to raise his hand as if to strike him. The self-reproach and contrition which are displayed in his remark appear to me to be the signs of a healthy mind rather than of a guilty one."

I shook my head. "Many men have been hanged on far slighter evidence," I remarked.

"So they have. And many men have been wrongfully hanged."

"What is the young man's own account of the matter?"

"It is, I am afraid, not very encouraging to his supporters, though there are one or two points in it which are suggestive. You will find it here, and may read it for yourself."

He picked out from his bundle a copy of the local Herefordshire paper, and having turned down the sheet he pointed out the paragraph in which the unfortunate young man had given his own statement of what had occurred. I settled myself down in the corner of the carriage and read it very carefully. It ran in this way:

"Mr. James McCarthy, the only son of the deceased, was then called and gave evidence as follows: 'I had been away from home for three days at Bristol, and had only just returned upon the morning of last Monday, the 3rd. My father was absent from home at the time of my arrival, and I was informed by the maid that he had driven over to Ross with John Cobb, the groom. Shortly after my return I heard the wheels of his trap in the yard, and, looking out of my window, I saw him get out and walk rapidly out of the yard, though I was not aware in which direction he was going. I then took my gun and strolled out in the direction of the Boscombe Pool, with the intention of visiting the rabbit warren which is upon the other side. On my way I saw William Crowder, the game-keeper, as he had stated in his evidence; but he is mistaken in thinking that I was following my father. I had no idea that he was in front of me. When about a hundred yards from the pool I heard a cry of "Cooee!" which was a usual signal between my father and myself. I then hurried forward, and found him standing by the pool. He appeared to be much surprised at seeing me and asked me rather roughly what I was doing there. A conversation ensued which led to high words and almost to blows, for my father was a man of a very violent temper. Seeing that his passion was becoming ungovernable, I left him and returned towards Hatherley Farm. I had not gone more than 150 yards, however, when I heard a hideous outcry behind me, which caused me to run back again. I found my father expiring upon the ground, with his head terribly injured. I dropped my gun and held him in my arms, but he almost instantly expired. I knelt beside him for some minutes, and then made my way to Mr. Turner's lodge-keeper, his house being the nearest, to ask for assistance. I saw no one near my father when I returned, and I have no idea how he came by his injuries. He was not a popular man, being somewhat cold and forbidding in his manners, but he had, as far as I know, no active enemies. I know nothing further of the matter.'

"The Coroner: Did your father make any statement to you before he died?

"Witness: He mumbled a few words, but I could only catch some allusion to a rat.

"The Coroner: What did you understand by that?

"Witness: It conveyed no meaning to me. I thought that he was delirious.

"The Coroner: What was the point upon which you and your father had this final quarrel?

"Witness: I should prefer not to answer.

"The Coroner: I am afraid that I must press it.

"Witness: It is really impossible for me to tell you. I can assure you that it has nothing to do with the sad tragedy which followed.

"The Coroner: That is for the court to decide. I need not point out to you that your refusal to answer will prejudice your case considerably in any future proceedings which may arise.

"Witness: I must still refuse.

"The Coroner: I understand that the cry of 'Cooee' was a common signal between you and your father?

"Witness: It was.

"The Coroner: How was it, then, that he uttered it before he saw you, and before he even knew that you had returned from Bristol?

"Witness (with considerable confusion): I do not know.

"A Juryman: Did you see nothing which aroused your suspicions when you returned on hearing the cry and found your father fatally injured?

"Witness: Nothing definite.

"The Coroner: What do you mean?

"Witness: I was so disturbed and excited as I rushed out into the open, that I could think of nothing except of my father. Yet I have a vague impression that as I ran forward something lay upon the ground to the left of me. It seemed to me to be something grey in colour, a coat of some sort, or a plaid perhaps. When I rose from my father I looked round for it, but it was gone.

" 'Do you mean that it disappeared before you went for help?'

" 'Yes, it was gone.'

" 'You cannot say what it was?'

" 'No, I had a feeling something was there.'

" 'How far from the body?'

" 'A dozen yards or so.'

" 'And how far from the edge of the wood?'

" 'About the same.'

" 'Then if it was removed it was while you were within a dozen yards of it?'

" 'Yes, but with my back towards it.'

"This concluded the examination of the witness."

"I see," said I as I glanced down the column, "that the coroner in his concluding remarks was rather severe upon young McCarthy. He calls attention, and with reason, to the discrepancy about his father having signalled to him before seeing him, also to his refusal to give details of his conversation with his father, and his singular account of his father's dying words. They are all, as he remarks, very much against the son."

Holmes laughed softly to himself and stretched himself out upon the cushioned seat. "Both you and the coroner have been at some pains," said he, "to single out the very strongest points in the young man's favour. Don't you see that you alternately give him credit for having too much imagination and too little? Too little, if he could not invent a cause of quarrel which would give him the sympathy of the jury; too much, if he evolved from his own inner consciousness anything so outre as a dying reference to a rat, and the incident of the vanishing cloth. No, sir, I shall approach this case from the point of view that what this young man says is true, and we shall see whither that hypothesis will lead us. And now here is my pocket Petrarch, and not another word shall I say of this case until we are on the scene of action. We lunch at Swindon, and I see that we shall be there in twenty minutes."

It was nearly four o'clock when we at last, after passing through the beautiful Stroud Valley, and over the broad gleaming Severn, found ourselves at the pretty little country-town of Ross. A lean, ferret-like man, furtive and sly-looking, was waiting for us upon the platform. In spite of the light brown dustcoat and leather-leggings which he wore in deference to his rustic surroundings, I had no difficulty in recognising Lestrade, of Scotland Yard. With him we drove to the Hereford Arms where a room had already been engaged for us.

"I have ordered a carriage," said Lestrade as we sat over a cup of tea. "I knew your energetic nature, and that you would not be happy until you had been on the scene of the crime."

"It was very nice and complimentary of you," Holmes answered. "It is entirely a question of barometric pressure."

Lestrade looked startled. "I do not quite follow," he said.

"How is the glass? Twenty-nine, I see. No wind, and not a cloud in the sky. I have a caseful of cigarettes here which need smoking, and the sofa is very much superior to the usual country hotel abomination. I do not think that it is probable that I shall use the carriage to-night."

Lestrade laughed indulgently. "You have, no doubt, already formed your conclusions from the newspapers," he said. "The case is as plain as a pikestaff, and the more one goes into it the plainer it becomes. Still, of course, one can't refuse a lady, and such a very positive one, too. She has heard of you, and would have your opinion, though I repeatedly told her that there was nothing which you could do which I had not already done. Why, bless my soul! here is her carriage at the door."

He had hardly spoken before there rushed into the room one of the most lovely young women that I have ever seen in my life. Her violet eyes shining, her lips parted, a pink flush upon her cheeks, all thought of her natural reserve lost in her overpowering excitement and concern.

"Oh, Mr. Sherlock Holmes!" she cried, glancing from one to the other of us, and finally, with a woman's quick intuition, fastening upon my companion, "I am so glad that you have come. I have driven down to tell you so. I know that James didn't do it. I know it, and I want you to start upon your work knowing it, too. Never let yourself doubt upon that point. We have known each other since we were little children, and I know his faults as no one else does; but he is too tender-hearted to hurt a fly. Such a charge is absurd to anyone who really knows him."

"I hope we may clear him, Miss Turner," said Sherlock Holmes. "You may rely upon my doing all that I can."

"But you have read the evidence. You have formed some conclusion? Do you not see some loophole, some flaw? Do you not yourself think that he is innocent?"

"I think that it is very probable."

"There, now!" she cried, throwing back her head and looking defiantly at Lestrade. "You hear! He gives me hopes."

Lestrade shrugged his shoulders. "I am afraid that my colleague has been a little quick in forming his conclusions," he said.

"But he is right. Oh! I know that he is right. James never did it. And about his quarrel with his father, I am sure that the reason why he would not speak about it to the coroner was because I was concerned in it."

"In what way?" asked Holmes.

"It is no time for me to hide anything. James and his father had many disagreements about me. Mr. McCarthy was very anxious that there should be a marriage between us. James and I have always loved each other as brother and sister; but of course he is young and has seen very little of life yet, and--and--well, he naturally did not wish to do anything like that yet. So there were quarrels, and this, I am sure, was one of them."

"And your father?" asked Holmes. "Was he in favour of such a union?"

"No, he was averse to it also. No one but Mr. McCarthy was in favour of it." A quick blush passed over her fresh young face as Holmes shot one of his keen, questioning glances at her.

"Thank you for this information," said he. "May I see your father if I call to-morrow?"

"I am afraid the doctor won't allow it."

"The doctor?"

"Yes, have you not heard? Poor father has never been strong for years back, but this has broken him down completely. He has taken to his bed, and Dr. Willows says that he is a wreck and that his nervous system is shattered. Mr. McCarthy was the only man alive who had known dad in the old days in Victoria."

"Ha! In Victoria! That is important."

"Yes, at the mines."

"Quite so; at the gold-mines, where, as I understand, Mr. Turner made his money."

"Yes, certainly."

"Thank you, Miss Turner. You have been of material assistance to me."

"You will tell me if you have any news to-morrow. No doubt you will go to the prison to see James. Oh, if you do, Mr. Holmes, do tell him that I know him to be innocent."

"I will, Miss Turner."

"I must go home now, for dad is very ill, and he misses me so if I leave him. Good-bye, and God help you in your undertaking." She hurried from the room as impulsively as she had entered, and we heard the wheels of her carriage rattle off down the street.

"I am ashamed of you, Holmes," said Lestrade with dignity after a few minutes' silence. "Why should you raise up hopes which you are bound to disappoint? I am not over-tender of heart, but I call it cruel."

"I think that I see my way to clearing James McCarthy," said Holmes. "Have you an order to see him in prison?"

"Yes, but only for you and me."

"Then I shall reconsider my resolution about going out. We have still time to take a train to Hereford and see him to-night?"

"Ample."

"Then let us do so. Watson, I fear that you will find it very slow, but I shall only be away a couple of hours."

I walked down to the station with them, and then wandered through the streets of the little town, finally returning to the hotel, where I lay upon the sofa and tried to interest myself in a yellow-backed novel. The puny plot of the story was so thin, however, when compared to the deep mystery through which we were groping, and I found my attention wander so continually from the action to the fact, that I at last flung it across the room and gave myself up entirely to a consideration of the events of the day. Supposing that this unhappy young man's story were absolutely true, then what hellish thing, what absolutely unforeseen and extraordinary calamity could have occurred between the time when he parted from his father, and the moment when, drawn back by his screams, he rushed into the glade? It was something terrible and deadly. What could it be? Might not the nature of the injuries reveal something to my medical instincts? I rang the bell and called for the weekly county paper, which contained a verbatim account of the inquest. In the surgeon's deposition it was stated that the posterior third of the left parietal bone and the left half of the occipital bone had been shattered by a heavy blow from a blunt weapon. I marked the spot upon my own head. Clearly such a blow must have been struck from behind. That was to some extent in favour of the accused, as when seen quarrelling he was face to face with his father. Still, it did not go for very much, for the older man might have turned his back before the blow fell. Still, it might be worth while to call Holmes' attention to it. Then there was the peculiar dying reference to a rat. What could that mean? It could not be delirium. A man dying from a sudden blow does not commonly become delirious. No, it was more likely to be an attempt to explain how he met his fate. But what could it indicate? I cudgelled my brains to find some possible explanation. And then the incident of the grey cloth seen by young McCarthy. If that were true the murderer must have dropped some part of his dress, presumably his overcoat, in his flight, and must have had the hardihood to return and to carry it away at the instant when the son was kneeling with his back turned not a dozen paces off. What a tissue of mysteries and improbabilities the whole thing was! I did not wonder at Lestrade's opinion, and yet I had so much faith in Sherlock Holmes' insight that I could not lose hope as long as every fresh fact seemed to strengthen his conviction of young McCarthy's innocence.

It was late before Sherlock Holmes returned. He came back alone, for Lestrade was staying in lodgings in the town.

"The glass still keeps very high," he remarked as he sat down. "It is of importance that it should not rain before we are able to go over the ground. On the other hand, a man should be at his very best and keenest for such nice work as that, and I did not wish to do it when fagged by a long journey. I have seen young McCarthy."

"And what did you learn from him?"

"Nothing."

"Could he throw no light?"

"None at all. I was inclined to think at one time that he knew who had done it and was screening him or her, but I am convinced now that he is as puzzled as everyone else. He is not a very quick-witted youth, though comely to look at and, I should think, sound at heart."

"I cannot admire his taste," I remarked, "if it is indeed a fact that he was averse to a marriage with so charming a young lady as this Miss Turner."

"Ah, thereby hangs a rather painful tale. This fellow is madly, insanely, in love with her, but some two years ago, when he was only a lad, and before he really knew her, for she had been away five years at a boarding-school, what does the idiot do but get into the clutches of a barmaid in Bristol and marry her at a registry office? No one knows a word of the matter, but you can imagine how maddening it must be to him to be upbraided for not doing what he would give his very eyes to do, but what he knows to be absolutely impossible. It was sheer frenzy of this sort which made him throw his hands up into the air when his father, at their last interview, was goading him on to propose to Miss Turner. On the other hand, he had no means of supporting himself, and his father, who was by all accounts a very hard man, would have thrown him over utterly had he known the truth. It was with his barmaid wife that he had spent the last three days in Bristol, and his father did not know where he was. Mark that point. It is of importance. Good has come out of evil, however, for the barmaid, finding from the papers that he is in serious trouble and likely to be hanged, has thrown him over utterly and has written to him to say that she has a husband already in the Bermuda Dockyard, so that there is really no tie between them. I think that that bit of news has consoled young McCarthy for all that he has suffered."

"But if he is innocent, who has done it?"

"Ah! who? I would call your attention very particularly to two points. One is that the murdered man had an appointment with someone at the pool, and that the someone could not have been his son, for his son was away, and he did not know when he would return. The second is that the murdered man was heard to cry 'Cooee!' before he knew that his son had returned. Those are the crucial points upon which the case depends. And now let us talk about George Meredith, if you please, and we shall leave all minor matters until to-morrow."

There was no rain, as Holmes had foretold, and the morning broke bright and cloudless. At nine o'clock Lestrade called for us with the carriage, and we set off for Hatherley Farm and the Boscombe Pool.

"There is serious news this morning," Lestrade observed. "It is said that Mr. Turner, of the Hall, is so ill that his life is despaired of."

"An elderly man, I presume?" said Holmes.

"About sixty; but his constitution has been shattered by his life abroad, and he has been in failing health for some time. This business has had a very bad effect upon him. He was an old friend of McCarthy's, and, I may add, a great benefactor to him, for I have learned that he gave him Hatherley Farm rent free."

"Indeed! That is interesting," said Holmes.

"Oh, yes! In a hundred other ways he has helped him. Everybody about here speaks of his kindness to him."

"Really! Does it not strike you as a little singular that this McCarthy, who appears to have had little of his own, and to have been under such obligations to Turner, should still talk of marrying his son to Turner's daughter, who is, presumably, heiress to the estate, and that in such a very cocksure manner, as if it were merely a case of a proposal and all else would follow? It is the more strange, since we know that Turner himself was averse to the idea. The daughter told us as much. Do you not deduce something from that?"

"We have got to the deductions and the inferences," said Lestrade, winking at me. "I find it hard enough to tackle facts, Holmes, without flying away after theories and fancies."

"You are right," said Holmes demurely; "you do find it very hard to tackle the facts."

"Anyhow, I have grasped one fact which you seem to find it difficult to get hold of," replied Lestrade with some warmth.

"And that is--"

"That McCarthy senior met his death from McCarthy junior and that all theories to the contrary are the merest moonshine."

"Well, moonshine is a brighter thing than fog," said Holmes, laughing. "But I am very much mistaken if this is not Hatherley Farm upon the left."

"Yes, that is it." It was a widespread, comfortable-looking building, two-storied, slate-roofed, with great yellow blotches of lichen upon the grey walls. The drawn blinds and the smokeless chimneys, however, gave it a stricken look, as though the weight of this horror still lay heavy upon it. We called at the door, when the maid, at Holmes' request, showed us the boots which her master wore at the time of his death, and also a pair of the son's, though not the pair which he had then had. Having measured these very carefully from seven or eight different points, Holmes desired to be led to the court-yard, from which we all followed the winding track which led to Boscombe Pool.

Sherlock Holmes was transformed when he was hot upon such a scent as this. Men who had only known the quiet thinker and logician of Baker Street would have failed to recognise him. His face flushed and darkened. His brows were drawn into two hard black lines, while his eyes shone out from beneath them with a steely glitter. His face was bent downward, his shoulders bowed, his lips compressed, and the veins stood out like whipcord in his long, sinewy neck. His nostrils seemed to dilate with a purely animal lust for the chase, and his mind was so absolutely concentrated upon the matter before him that a question or remark fell unheeded upon his ears, or, at the most, only provoked a quick, impatient snarl in reply. Swiftly and silently he made his way along the track which ran through the meadows, and so by way of the woods to the Boscombe Pool. It was damp, marshy ground, as is all that district, and there were marks of many feet, both upon the path and amid the short grass which bounded it on either side. Sometimes Holmes would hurry on, sometimes stop dead, and once he made quite a little detour into the meadow. Lestrade and I walked behind him, the detective indifferent and contemptuous, while I watched my friend with the interest which sprang from the conviction that every one of his actions was directed towards a definite end.

The Boscombe Pool, which is a little reed-girt sheet of water some fifty yards across, is situated at the boundary between the Hatherley Farm and the private park of the wealthy Mr. Turner. Above the woods which lined it upon the farther side we could see the red, jutting pinnacles which marked the site of the rich landowner's dwelling. On the Hatherley side of the pool the woods grew very thick, and there was a narrow belt of sodden grass twenty paces across between the edge of the trees and the reeds which lined the lake. Lestrade showed us the exact spot at which the body had been found, and, indeed, so moist was the ground, that I could plainly see the traces which had been left by the fall of the stricken man. To Holmes, as I could see by his eager face and peering eyes, very many other things were to be read upon the trampled grass. He ran round, like a dog who is picking up a scent, and then turned upon my companion.

"What did you go into the pool for?" he asked.

"I fished about with a rake. I thought there might be some weapon or other trace. But how on earth--"

"Oh, tut, tut! I have no time! That left foot of yours with its inward twist is all over the place. A mole could trace it, and there it vanishes among the reeds. Oh, how simple it would all have been had I been here before they came like a herd of buffalo and wallowed all over it. Here is where the party with the lodge-keeper came, and they have covered all tracks for six or eight feet round the body. But here are three separate tracks of the same feet." He drew out a lens and lay down upon his waterproof to have a better view, talking all the time rather to himself than to us. "These are young McCarthy's feet. Twice he was walking, and once he ran swiftly, so that the soles are deeply marked and the heels hardly visible. That bears out his story. He ran when he saw his father on the ground. Then here are the father's feet as he paced up and down. What is this, then? It is the butt-end of the gun as the son stood listening. And this? Ha, ha! What have we here? Tiptoes! tiptoes! Square, too, quite unusual boots! They come, they go, they come again--of course that was for the cloak. Now where did they come from?" He ran up and down, sometimes losing, sometimes finding the track until we were well within the edge of the wood and under the shadow of a great beech, the largest tree in the neighbourhood. Holmes traced his way to the farther side of this and lay down once more upon his face with a little cry of satisfaction. For a long time he remained there, turning over the leaves and dried sticks, gathering up what seemed to me to be dust into an envelope and examining with his lens not only the ground but even the bark of the tree as far as he could reach. A jagged stone was lying among the moss, and this also he carefully examined and retained. Then he followed a pathway through the wood until he came to the highroad, where all traces were lost.

"It has been a case of considerable interest," he remarked, returning to his natural manner. "I fancy that this grey house on the right must be the lodge. I think that I will go in and have a word with Moran, and perhaps write a little note. Having done that, we may drive back to our luncheon. You may walk to the cab, and I shall be with you presently."

It was about ten minutes before we regained our cab and drove back into Ross, Holmes still carrying with him the stone which he had picked up in the wood.

"This may interest you, Lestrade," he remarked, holding it out. "The murder was done with it."

"I see no marks."

"There are none."

"How do you know, then?"

"The grass was growing under it. It had only lain there a few days. There was no sign of a place whence it had been taken. It corresponds with the injuries. There is no sign of any other weapon."

"And the murderer?"

"Is a tall man, left-handed, limps with the right leg, wears thick-soled shooting-boots and a grey cloak, smokes Indian cigars, uses a cigar-holder, and carries a blunt pen-knife in his pocket. There are several other indications, but these may be enough to aid us in our search."

Lestrade laughed. "I am afraid that I am still a sceptic," he said. "Theories are all very well, but we have to deal with a hard-headed British jury."

"Nous verrons," answered Holmes calmly. "You work your own method, and I shall work mine. I shall be busy this afternoon, and shall probably return to London by the evening train."

"And leave your case unfinished?"

"No, finished."

"But the mystery?"

"It is solved."

"Who was the criminal, then?"

"The gentleman I describe."

"But who is he?"

"Surely it would not be difficult to find out. This is not such a populous neighbourhood."

Lestrade shrugged his shoulders. "I am a practical man," he said, "and I really cannot undertake to go about the country looking for a left-handed gentleman with a game leg. I should become the laughing-stock of Scotland Yard."

"All right," said Holmes quietly. "I have given you the chance. Here are your lodgings. Good-bye. I shall drop you a line before I leave."

Having left Lestrade at his rooms, we drove to our hotel, where we found lunch upon the table. Holmes was silent and buried in thought with a pained expression upon his face, as one who finds himself in a perplexing position.

"Look here, Watson," he said when the cloth was cleared "just sit down in this chair and let me preach to you for a little. I don't know quite what to do, and I should value your advice. Light a cigar and let me expound."

"Pray do so."

"Well, now, in considering this case there are two points about young McCarthy's narrative which struck us both instantly, although they impressed me in his favour and you against him. One was the fact that his father should, according to his account, cry 'Cooee!' before seeing him. The other was his singular dying reference to a rat. He mumbled several words, you understand, but that was all that caught the son's ear. Now from this double point our research must commence, and we will begin it by presuming that what the lad says is absolutely true."

"What of this 'Cooee!' then?"

"Well, obviously it could not have been meant for the son. The son, as far as he knew, was in Bristol. It was mere chance that he was within earshot. The 'Cooee!' was meant to attract the attention of whoever it was that he had the appointment with. But 'Cooee' is a distinctly Australian cry, and one which is used between Australians. There is a strong presumption that the person whom McCarthy expected to meet him at Boscombe Pool was someone who had been in Australia."

"What of the rat, then?"

Sherlock Holmes took a folded paper from his pocket and flattened it out on the table. "This is a map of the Colony of Victoria," he said. "I wired to Bristol for it last night." He put his hand over part of the map. "What do you read?"

"ARAT," I read.

"And now?" He raised his hand.

"BALLARAT."

"Quite so. That was the word the man uttered, and of which his son only caught the last two syllables. He was trying to utter the name of his murderer. So and so, of Ballarat."

"It is wonderful!" I exclaimed.

"It is obvious. And now, you see, I had narrowed the field down considerably. The possession of a grey garment was a third point which, granting the son's statement to be correct, was a certainty. We have come now out of mere vagueness to the definite conception of an Australian from Ballarat with a grey cloak."

"Certainly."

"And one who was at home in the district, for the pool can only be approached by the farm or by the estate, where strangers could hardly wander."

"Quite so."

"Then comes our expedition of to-day. By an examination of the ground I gained the trifling details which I gave to that imbecile Lestrade, as to the personality of the criminal."

"But how did you gain them?"

"You know my method. It is founded upon the observation of trifles."

"His height I know that you might roughly judge from the length of his stride. His boots, too, might be told from their traces."

"Yes, they were peculiar boots."

"But his lameness?"

"The impression of his right foot was always less distinct than his left. He put less weight upon it. Why? Because he limped--he was lame."

"But his left-handedness."

"You were yourself struck by the nature of the injury as recorded by the surgeon at the inquest. The blow was struck from immediately behind, and yet was upon the left side. Now, how can that be unless it were by a left-handed man? He had stood behind that tree during the interview between the father and son. He had even smoked there. I found the ash of a cigar, which my special knowledge of tobacco ashes enables me to pronounce as an Indian cigar. I have, as you know, devoted some attention to this, and written a little monograph on the ashes of 140 different varieties of pipe, cigar, and cigarette tobacco. Having found the ash, I then looked round and discovered the stump among the moss where he had tossed it. It was an Indian cigar, of the variety which are rolled in Rotterdam."

"And the cigar-holder?"

"I could see that the end had not been in his mouth. Therefore he used a holder. The tip had been cut off, not bitten off, but the cut was not a clean one, so I deduced a blunt pen-knife."

"Holmes," I said, "you have drawn a net round this man from which he cannot escape, and you have saved an innocent human life as truly as if you had cut the cord which was hanging him. I see the direction in which all this points. The culprit is--"

"Mr. John Turner," cried the hotel waiter, opening the door of our sitting-room, and ushering in a visitor.

The man who entered was a strange and impressive figure. His slow, limping step and bowed shoulders gave the appearance of decrepitude, and yet his hard, deep-lined, craggy features, and his enormous limbs showed that he was possessed of unusual strength of body and of character. His tangled beard, grizzled hair, and outstanding, drooping eyebrows combined to give an air of dignity and power to his appearance, but his face was of an ashen white, while his lips and the corners of his nostrils were tinged with a shade of blue. It was clear to me at a glance that he was in the grip of some deadly and chronic disease.

"Pray sit down on the sofa," said Holmes gently. "You had my note?"

"Yes, the lodge-keeper brought it up. You said that you wished to see me here to avoid scandal."

"I thought people would talk if I went to the Hall."

"And why did you wish to see me?" He looked across at my companion with despair in his weary eyes, as though his question was already answered.

"Yes," said Holmes, answering the look rather than the words. "It is so. I know all about McCarthy."

The old man sank his face in his hands. "God help me!" he cried. "But I would not have let the young man come to harm. I give you my word that I would have spoken out if it went against him at the Assizes."

"I am glad to hear you say so," said Holmes gravely.

"I would have spoken now had it not been for my dear girl. It would break her heart--it will break her heart when she hears that I am arrested."

"It may not come to that," said Holmes.

"What?"

"I am no official agent. I understand that it was your daughter who required my presence here, and I am acting in her interests. Young McCarthy must be got off, however."

"I am a dying man," said old Turner. "I have had diabetes for years. My doctor says it is a question whether I shall live a month. Yet I would rather die under my own roof than in a gaol."

Holmes rose and sat down at the table with his pen in his hand and a bundle of paper before him. "Just tell us the truth," he said. "I shall jot down the facts. You will sign it, and Watson here can witness it. Then I could produce your confession at the last extremity to save young McCarthy. I promise you that I shall not use it unless it is absolutely needed."

"It's as well," said the old man; "it's a question whether I shall live to the Assizes, so it matters little to me, but I should wish to spare Alice the shock. And now I will make the thing clear to you; it has been a long time in the acting, but will not take me long to tell.

"You didn't know this dead man, McCarthy. He was a devil incarnate. I tell you that. God keep you out of the clutches of such a man as he. His grip has been upon me these twenty years, and he has blasted my life. I'll tell you first how I came to be in his power.

"It was in the early '60's at the diggings. I was a young chap then, hot-blooded and reckless, ready to turn my hand at anything; I got among bad companions, took to drink, had no luck with my claim, took to the bush, and in a word became what you would call over here a highway robber. There were six of us, and we had a wild, free life of it, sticking up a station from time to time, or stopping the wagons on the road to the diggings. Black Jack of Ballarat was the name I went under, and our party is still remembered in the colony as the Ballarat Gang.

"One day a gold convoy came down from Ballarat to Melbourne, and we lay in wait for it and attacked it. There were six troopers and six of us, so it was a close thing, but we emptied four of their saddles at the first volley. Three of our boys were killed, however, before we got the swag. I put my pistol to the head of the wagon-driver, who was this very man McCarthy. I wish to the Lord that I had shot him then, but I spared him, though I saw his wicked little eyes fixed on my face, as though to remember every feature. We got away with the gold, became wealthy men, and made our way over to England without being suspected. There I parted from my old pals and determined to settle down to a quiet and respectable life. I bought this estate, which chanced to be in the market, and I set myself to do a little good with my money, to make up for the way in which I had earned it. I married, too, and though my wife died young she left me my dear little Alice. Even when she was just a baby her wee hand seemed to lead me down the right path as nothing else had ever done. In a word, I turned over a new leaf and did my best to make up for the past. All was going well when McCarthy laid his grip upon me.

"I had gone up to town about an investment, and I met him in Regent Street with hardly a coat to his back or a boot to his foot.

" 'Here we are, Jack,' says he, touching me on the arm; 'we'll be as good as a family to you. There's two of us, me and my son, and you can have the keeping of us. If you don't--it's a fine, law-abiding country is England, and there's always a policeman within hail.'

"Well, down they came to the west country, there was no shaking them off, and there they have lived rent free on my best land ever since. There was no rest for me, no peace, no forgetfulness; turn where I would, there was his cunning, grinning face at my elbow. It grew worse as Alice grew up, for he soon saw I was more afraid of her knowing my past than of the police. Whatever he wanted he must have, and whatever it was I gave him without question, land, money, houses, until at last he asked a thing which I could not give. He asked for Alice.

"His son, you see, had grown up, and so had my girl, and as I was known to be in weak health, it seemed a fine stroke to him that his lad should step into the whole property. But there I was firm. I would not have his cursed stock mixed with mine; not that I had any dislike to the lad, but his blood was in him, and that was enough. I stood firm. McCarthy threatened. I braved him to do his worst. We were to meet at the pool midway between our houses to talk it over.

"When I went down there I found him talking with his son, so I smoked a cigar and waited behind a tree until he should be alone. But as I listened to his talk all that was black and bitter in me seemed to come uppermost. He was urging his son to marry my daughter with as little regard for what she might think as if she were a slut from off the streets. It drove me mad to think that I and all that I held most dear should be in the power of such a man as this. Could I not snap the bond? I was already a dying and a desperate man. Though clear of mind and fairly strong of limb, I knew that my own fate was sealed. But my memory and my girl! Both could be saved if I could but silence that foul tongue. I did it, Mr. Holmes. I would do it again. Deeply as I have sinned, I have led a life of martyrdom to atone for it. But that my girl should be entangled in the same meshes which held me was more than I could suffer. I struck him down with no more compunction than if he had been some foul and venomous beast. His cry brought back his son; but I had gained the cover of the wood, though I was forced to go back to fetch the cloak which I had dropped in my flight. That is the true story, gentlemen, of all that occurred."

"Well, it is not for me to judge you," said Holmes as the old man signed the statement which had been drawn out. "I pray that we may never be exposed to such a temptation."

"I pray not, sir. And what do you intend to do?"

"In view of your health, nothing. You are yourself aware that you will soon have to answer for your deed at a higher court than the Assizes. I will keep your confession, and if McCarthy is condemned I shall be forced to use it. If not, it shall never be seen by mortal eye; and your secret, whether you be alive or dead, shall be safe with us."

"Farewell, then," said the old man solemnly. "Your own deathbeds, when they come, will be the easier for the thought of the peace which you have given to mine." Tottering and shaking in all his giant frame, he stumbled slowly from the room.

"God help us!" said Holmes after a long silence. "Why does fate play such tricks with poor, helpless worms? I never hear of such a case as this that I do not think of Baxter's words, and say, 'There, but for the grace of God, goes Sherlock Holmes.' "

James McCarthy was acquitted at the Assizes on the strength of a number of objections which had been drawn out by Holmes and submitted to the defending counsel. Old Turner lived for seven months after our interview, but he is now dead; and there is every prospect that the son and daughter may come to live happily together in ignorance of the black cloud which rests upon their past.

ADVENTURE  V.  THE FIVE ORANGE PIPS


When I glance over my notes and records of the Sherlock Holmes cases between the years '82 and '90, I am faced by so many which present strange and interesting features that it is no easy matter to know which to choose and which to leave. Some, however, have already gained publicity through the papers, and others have not offered a field for those peculiar qualities which my friend possessed in so high a degree, and which it is the object of these papers to illustrate. Some, too, have baffled his analytical skill, and would be, as narratives, beginnings without an ending, while others have been but partially cleared up, and have their explanations founded rather upon conjecture and surmise than on that absolute logical proof which was so dear to him. There is, however, one of these last which was so remarkable in its details and so startling in its results that I am tempted to give some account of it in spite of the fact that there are points in connection with it which never have been, and probably never will be, entirely cleared up.

The year '87 furnished us with a long series of cases of greater or less interest, of which I retain the records. Among my headings under this one twelve months I find an account of the adventure of the Paradol Chamber, of the Amateur Mendicant Society, who held a luxurious club in the lower vault of a furniture warehouse, of the facts connected with the loss of the British barque Sophy Anderson, of the singular adventures of the Grice Patersons in the island of Uffa, and finally of the Camberwell poisoning case. In the latter, as may be remembered, Sherlock Holmes was able, by winding up the dead man's watch, to prove that it had been wound up two hours before, and that therefore the deceased had gone to bed within that time--a deduction which was of the greatest importance in clearing up the case. All these I may sketch out at some future date, but none of them present such singular features as the strange train of circumstances which I have now taken up my pen to describe.

It was in the latter days of September, and the equinoctial gales had set in with exceptional violence. All day the wind had screamed and the rain had beaten against the windows, so that even here in the heart of great, hand-made London we were forced to raise our minds for the instant from the routine of life and to recognise the presence of those great elemental forces which shriek at mankind through the bars of his civilisation, like untamed beasts in a cage. As evening drew in, the storm grew higher and louder, and the wind cried and sobbed like a child in the chimney. Sherlock Holmes sat moodily at one side of the fireplace cross-indexing his records of crime, while I at the other was deep in one of Clark Russell's fine sea-stories until the howl of the gale from without seemed to blend with the text, and the splash of the rain to lengthen out into the long swash of the sea waves. My wife was on a visit to her mother's, and for a few days I was a dweller once more in my old quarters at Baker Street.

"Why," said I, glancing up at my companion, "that was surely the bell. Who could come to-night? Some friend of yours, perhaps?"

"Except yourself I have none," he answered. "I do not encourage visitors."

"A client, then?"

"If so, it is a serious case. Nothing less would bring a man out on such a day and at such an hour. But I take it that it is more likely to be some crony of the landlady's."

Sherlock Holmes was wrong in his conjecture, however, for there came a step in the passage and a tapping at the door. He stretched out his long arm to turn the lamp away from himself and towards the vacant chair upon which a newcomer must sit.

"Come in!" said he.

The man who entered was young, some two-and-twenty at the outside, well-groomed and trimly clad, with something of refinement and delicacy in his bearing. The streaming umbrella which he held in his hand, and his long shining waterproof told of the fierce weather through which he had come. He looked about him anxiously in the glare of the lamp, and I could see that his face was pale and his eyes heavy, like those of a man who is weighed down with some great anxiety.

"I owe you an apology," he said, raising his golden pince-nez to his eyes. "I trust that I am not intruding. I fear that I have brought some traces of the storm and rain into your snug chamber."

"Give me your coat and umbrella," said Holmes. "They may rest here on the hook and will be dry presently. You have come up from the south-west, I see."

"Yes, from Horsham."

"That clay and chalk mixture which I see upon your toe caps is quite distinctive."

"I have come for advice."

"That is easily got."

"And help."

"That is not always so easy."

"I have heard of you, Mr. Holmes. I heard from Major Prendergast how you saved him in the Tankerville Club scandal."

"Ah, of course. He was wrongfully accused of cheating at cards."

"He said that you could solve anything."

"He said too much."

"That you are never beaten."

"I have been beaten four times--three times by men, and once by a woman."

"But what is that compared with the number of your successes?"

"It is true that I have been generally successful."

"Then you may be so with me."

"I beg that you will draw your chair up to the fire and favour me with some details as to your case."

"It is no ordinary one."

"None of those which come to me are. I am the last court of appeal."

"And yet I question, sir, whether, in all your experience, you have ever listened to a more mysterious and inexplicable chain of events than those which have happened in my own family."

"You fill me with interest," said Holmes. "Pray give us the essential facts from the commencement, and I can afterwards question you as to those details which seem to me to be most important."

The young man pulled his chair up and pushed his wet feet out towards the blaze.

"My name," said he, "is John Openshaw, but my own affairs have, as far as I can understand, little to do with this awful business. It is a hereditary matter; so in order to give you an idea of the facts, I must go back to the commencement of the affair.

"You must know that my grandfather had two sons--my uncle Elias and my father Joseph. My father had a small factory at Coventry, which he enlarged at the time of the invention of bicycling. He was a patentee of the Openshaw unbreakable tire, and his business met with such success that he was able to sell it and to retire upon a handsome competence.

"My uncle Elias emigrated to America when he was a young man and became a planter in Florida, where he was reported to have done very well. At the time of the war he fought in Jackson's army, and afterwards under Hood, where he rose to be a colonel. When Lee laid down his arms my uncle returned to his plantation, where he remained for three or four years. About 1869 or 1870 he came back to Europe and took a small estate in Sussex, near Horsham. He had made a very considerable fortune in the States, and his reason for leaving them was his aversion to the negroes, and his dislike of the Republican policy in extending the franchise to them. He was a singular man, fierce and quick-tempered, very foul-mouthed when he was angry, and of a most retiring disposition. During all the years that he lived at Horsham, I doubt if ever he set foot in the town. He had a garden and two or three fields round his house, and there he would take his exercise, though very often for weeks on end he would never leave his room. He drank a great deal of brandy and smoked very heavily, but he would see no society and did not want any friends, not even his own brother.

"He didn't mind me; in fact, he took a fancy to me, for at the time when he saw me first I was a youngster of twelve or so. This would be in the year 1878, after he had been eight or nine years in England. He begged my father to let me live with him and he was very kind to me in his way. When he was sober he used to be fond of playing backgammon and draughts with me, and he would make me his representative both with the servants and with the tradespeople, so that by the time that I was sixteen I was quite master of the house. I kept all the keys and could go where I liked and do what I liked, so long as I did not disturb him in his privacy. There was one singular exception, however, for he had a single room, a lumber-room up among the attics, which was invariably locked, and which he would never permit either me or anyone else to enter. With a boy's curiosity I have peeped through the keyhole, but I was never able to see more than such a collection of old trunks and bundles as would be expected in such a room.

"One day--it was in March, 1883--a letter with a foreign stamp lay upon the table in front of the colonel's plate. It was not a common thing for him to receive letters, for his bills were all paid in ready money, and he had no friends of any sort. 'From India!' said he as he took it up, 'Pondicherry postmark! What can this be?' Opening it hurriedly, out there jumped five little dried orange pips, which pattered down upon his plate. I began to laugh at this, but the laugh was struck from my lips at the sight of his face. His lip had fallen, his eyes were protruding, his skin the colour of putty, and he glared at the envelope which he still held in his trembling hand, 'K. K. K.!' he shrieked, and then, 'My God, my God, my sins have overtaken me!'

" 'What is it, uncle?' I cried.

" 'Death,' said he, and rising from the table he retired to his room, leaving me palpitating with horror. I took up the envelope and saw scrawled in red ink upon the inner flap, just above the gum, the letter K three times repeated. There was nothing else save the five dried pips. What could be the reason of his overpowering terror? I left the breakfast-table, and as I ascended the stair I met him coming down with an old rusty key, which must have belonged to the attic, in one hand, and a small brass box, like a cashbox, in the other.

" 'They may do what they like, but I'll checkmate them still,' said he with an oath. 'Tell Mary that I shall want a fire in my room to-day, and send down to Fordham, the Horsham lawyer.'

"I did as he ordered, and when the lawyer arrived I was asked to step up to the room. The fire was burning brightly, and in the grate there was a mass of black, fluffy ashes, as of burned paper, while the brass box stood open and empty beside it. As I glanced at the box I noticed, with a start, that upon the lid was printed the treble K which I had read in the morning upon the envelope.

" 'I wish you, John,' said my uncle, 'to witness my will. I leave my estate, with all its advantages and all its disadvantages, to my brother, your father, whence it will, no doubt, descend to you. If you can enjoy it in peace, well and good! If you find you cannot, take my advice, my boy, and leave it to your deadliest enemy. I am sorry to give you such a two-edged thing, but I can't say what turn things are going to take. Kindly sign the paper where Mr. Fordham shows you.'

"I signed the paper as directed, and the lawyer took it away with him. The singular incident made, as you may think, the deepest impression upon me, and I pondered over it and turned it every way in my mind without being able to make anything of it. Yet I could not shake off the vague feeling of dread which it left behind, though the sensation grew less keen as the weeks passed and nothing happened to disturb the usual routine of our lives. I could see a change in my uncle, however. He drank more than ever, and he was less inclined for any sort of society. Most of his time he would spend in his room, with the door locked upon the inside, but sometimes he would emerge in a sort of drunken frenzy and would burst out of the house and tear about the garden with a revolver in his hand, screaming out that he was afraid of no man, and that he was not to be cooped up, like a sheep in a pen, by man or devil. When these hot fits were over, however, he would rush tumultuously in at the door and lock and bar it behind him, like a man who can brazen it out no longer against the terror which lies at the roots of his soul. At such times I have seen his face, even on a cold day, glisten with moisture, as though it were new raised from a basin.

"Well, to come to an end of the matter, Mr. Holmes, and not to abuse your patience, there came a night when he made one of those drunken sallies from which he never came back. We found him, when we went to search for him, face downward in a little green-scummed pool, which lay at the foot of the garden. There was no sign of any violence, and the water was but two feet deep, so that the jury, having regard to his known eccentricity, brought in a verdict of 'suicide.' But I, who knew how he winced from the very thought of death, had much ado to persuade myself that he had gone out of his way to meet it. The matter passed, however, and my father entered into possession of the estate, and of some $14,000, which lay to his credit at the bank."

"One moment," Holmes interposed, "your statement is, I foresee, one of the most remarkable to which I have ever listened. Let me have the date of the reception by your uncle of the letter, and the date of his supposed suicide."

"The letter arrived on March 10, 1883. His death was seven weeks later, upon the night of May 2nd."

"Thank you. Pray proceed."

"When my father took over the Horsham property, he, at my request, made a careful examination of the attic, which had been always locked up. We found the brass box there, although its contents had been destroyed. On the inside of the cover was a paper label, with the initials of K. K. K. repeated upon it, and 'Letters, memoranda, receipts, and a register' written beneath. These, we presume, indicated the nature of the papers which had been destroyed by Colonel Openshaw. For the rest, there was nothing of much importance in the attic save a great many scattered papers and note-books bearing upon my uncle's life in America. Some of them were of the war time and showed that he had done his duty well and had borne the repute of a brave soldier. Others were of a date during the reconstruction of the Southern states, and were mostly concerned with politics, for he had evidently taken a strong part in opposing the carpet-bag politicians who had been sent down from the North.

"Well, it was the beginning of '84 when my father came to live at Horsham, and all went as well as possible with us until the January of '85. On the fourth day after the new year I heard my father give a sharp cry of surprise as we sat together at the breakfast-table. There he was, sitting with a newly opened envelope in one hand and five dried orange pips in the outstretched palm of the other one. He had always laughed at what he called my cock-and-bull story about the colonel, but he looked very scared and puzzled now that the same thing had come upon himself.

" 'Why, what on earth does this mean, John?' he stammered.

"My heart had turned to lead. 'It is K. K. K.,' said I.

"He looked inside the envelope. 'So it is,' he cried. 'Here are the very letters. But what is this written above them?'

" 'Put the papers on the sundial,' I read, peeping over his shoulder.

" 'What papers? What sundial?' he asked.

" 'The sundial in the garden. There is no other,' said I; 'but the papers must be those that are destroyed.'

" 'Pooh!' said he, gripping hard at his courage. 'We are in a civilised land here, and we can't have tomfoolery of this kind. Where does the thing come from?'

" 'From Dundee,' I answered, glancing at the postmark.

" 'Some preposterous practical joke,' said he. 'What have I to do with sundials and papers? I shall take no notice of such nonsense.'

" 'I should certainly speak to the police,' I said.

" 'And be laughed at for my pains. Nothing of the sort.'

" 'Then let me do so?'

" 'No, I forbid you. I won't have a fuss made about such nonsense.'

"It was in vain to argue with him, for he was a very obstinate man. I went about, however, with a heart which was full of forebodings.

"On the third day after the coming of the letter my father went from home to visit an old friend of his, Major Freebody, who is in command of one of the forts upon Portsdown Hill. I was glad that he should go, for it seemed to me that he was farther from danger when he was away from home. In that, however, I was in error. Upon the second day of his absence I received a telegram from the major, imploring me to come at once. My father had fallen over one of the deep chalk-pits which abound in the neighbourhood, and was lying senseless, with a shattered skull. I hurried to him, but he passed away without having ever recovered his consciousness. He had, as it appears, been returning from Fareham in the twilight, and as the country was unknown to him, and the chalk-pit unfenced, the jury had no hesitation in bringing in a verdict of 'death from accidental causes.' Carefully as I examined every fact connected with his death, I was unable to find anything which could suggest the idea of murder. There were no signs of violence, no footmarks, no robbery, no record of strangers having been seen upon the roads. And yet I need not tell you that my mind was far from at ease, and that I was well-nigh certain that some foul plot had been woven round him.

"In this sinister way I came into my inheritance. You will ask me why I did not dispose of it? I answer, because I was well convinced that our troubles were in some way dependent upon an incident in my uncle's life, and that the danger would be as pressing in one house as in another.

"It was in January, '85, that my poor father met his end, and two years and eight months have elapsed since then. During that time I have lived happily at Horsham, and I had begun to hope that this curse had passed away from the family, and that it had ended with the last generation. I had begun to take comfort too soon, however; yesterday morning the blow fell in the very shape in which it had come upon my father."

The young man took from his waistcoat a crumpled envelope, and turning to the table he shook out upon it five little dried orange pips.

"This is the envelope," he continued. "The postmark is London--eastern division. Within are the very words which were upon my father's last message: 'K. K. K.'; and then 'Put the papers on the sundial.' "

"What have you done?" asked Holmes.

"Nothing."

"Nothing?"

"To tell the truth"--he sank his face into his thin, white hands--"I have felt helpless. I have felt like one of those poor rabbits when the snake is writhing towards it. I seem to be in the grasp of some resistless, inexorable evil, which no foresight and no precautions can guard against."

"Tut! tut!" cried Sherlock Holmes. "You must act, man, or you are lost. Nothing but energy can save you. This is no time for despair."

"I have seen the police."

"Ah!"

"But they listened to my story with a smile. I am convinced that the inspector has formed the opinion that the letters are all practical jokes, and that the deaths of my relations were really accidents, as the jury stated, and were not to be connected with the warnings."

Holmes shook his clenched hands in the air. "Incredible imbecility!" he cried.

"They have, however, allowed me a policeman, who may remain in the house with me."

"Has he come with you to-night?"

"No. His orders were to stay in the house."

Again Holmes raved in the air.

"Why did you come to me," he cried, "and, above all, why did you not come at once?"

"I did not know. It was only to-day that I spoke to Major Prendergast about my troubles and was advised by him to come to you."

"It is really two days since you had the letter. We should have acted before this. You have no further evidence, I suppose, than that which you have placed before us--no suggestive detail which might help us?"

"There is one thing," said John Openshaw. He rummaged in his coat pocket, and, drawing out a piece of discoloured, blue-tinted paper, he laid it out upon the table. "I have some remembrance," said he, "that on the day when my uncle burned the papers I observed that the small, unburned margins which lay amid the ashes were of this particular colour. I found this single sheet upon the floor of his room, and I am inclined to think that it may be one of the papers which has, perhaps, fluttered out from among the others, and in that way has escaped destruction. Beyond the mention of pips, I do not see that it helps us much. I think myself that it is a page from some private diary. The writing is undoubtedly my uncle's."

Holmes moved the lamp, and we both bent over the sheet of paper, which showed by its ragged edge that it had indeed been torn from a book. It was headed, "March, 1869," and beneath were the following enigmatical notices:

"4th. Hudson came. Same old platform.

"7th. Set the pips on McCauley, Paramore, and

        John Swain, of St. Augustine.

"9th. McCauley cleared.

"10th. John Swain cleared.

"12th. Visited Paramore. All well."

"Thank you!" said Holmes, folding up the paper and returning it to our visitor. "And now you must on no account lose another instant. We cannot spare time even to discuss what you have told me. You must get home instantly and act."

"What shall I do?"

"There is but one thing to do. It must be done at once. You must put this piece of paper which you have shown us into the brass box which you have described. You must also put in a note to say that all the other papers were burned by your uncle, and that this is the only one which remains. You must assert that in such words as will carry conviction with them. Having done this, you must at once put the box out upon the sundial, as directed. Do you understand?"

"Entirely."

"Do not think of revenge, or anything of the sort, at present. I think that we may gain that by means of the law; but we have our web to weave, while theirs is already woven. The first consideration is to remove the pressing danger which threatens you. The second is to clear up the mystery and to punish the guilty parties."

"I thank you," said the young man, rising and pulling on his overcoat. "You have given me fresh life and hope. I shall certainly do as you advise."

"Do not lose an instant. And, above all, take care of yourself in the meanwhile, for I do not think that there can be a doubt that you are threatened by a very real and imminent danger. How do you go back?"

"By train from Waterloo."

"It is not yet nine. The streets will be crowded, so I trust that you may be in safety. And yet you cannot guard yourself too closely."

"I am armed."

"That is well. To-morrow I shall set to work upon your case."

"I shall see you at Horsham, then?"

"No, your secret lies in London. It is there that I shall seek it."

"Then I shall call upon you in a day, or in two days, with news as to the box and the papers. I shall take your advice in every particular." He shook hands with us and took his leave. Outside the wind still screamed and the rain splashed and pattered against the windows. This strange, wild story seemed to have come to us from amid the mad elements--blown in upon us like a sheet of sea-weed in a gale--and now to have been reabsorbed by them once more.

Sherlock Holmes sat for some time in silence, with his head sunk forward and his eyes bent upon the red glow of the fire. Then he lit his pipe, and leaning back in his chair he watched the blue smoke-rings as they chased each other up to the ceiling.

"I think, Watson," he remarked at last, "that of all our cases we have had none more fantastic than this."

"Save, perhaps, the Sign of Four."

"Well, yes. Save, perhaps, that. And yet this John Openshaw seems to me to be walking amid even greater perils than did the Sholtos."

"But have you," I asked, "formed any definite conception as to what these perils are?"

"There can be no question as to their nature," he answered.

"Then what are they? Who is this K. K. K., and why does he pursue this unhappy family?"

Sherlock Holmes closed his eyes and placed his elbows upon the arms of his chair, with his finger-tips together. "The ideal reasoner," he remarked, "would, when he had once been shown a single fact in all its bearings, deduce from it not only all the chain of events which led up to it but also all the results which would follow from it. As Cuvier could correctly describe a whole animal by the contemplation of a single bone, so the observer who has thoroughly understood one link in a series of incidents should be able to accurately state all the other ones, both before and after. We have not yet grasped the results which the reason alone can attain to. Problems may be solved in the study which have baffled all those who have sought a solution by the aid of their senses. To carry the art, however, to its highest pitch, it is necessary that the reasoner should be able to utilise all the facts which have come to his knowledge; and this in itself implies, as you will readily see, a possession of all knowledge, which, even in these days of free education and encyclopaedias, is a somewhat rare accomplishment. It is not so impossible, however, that a man should possess all knowledge which is likely to be useful to him in his work, and this I have endeavoured in my case to do. If I remember rightly, you on one occasion, in the early days of our friendship, defined my limits in a very precise fashion."

"Yes," I answered, laughing. "It was a singular document. Philosophy, astronomy, and politics were marked at zero, I remember. Botany variable, geology profound as regards the mud-stains from any region within fifty miles of town, chemistry eccentric, anatomy unsystematic, sensational literature and crime records unique, violin-player, boxer, swordsman, lawyer, and self-poisoner by cocaine and tobacco. Those, I think, were the main points of my analysis."

Holmes grinned at the last item. "Well," he said, "I say now, as I said then, that a man should keep his little brain-attic stocked with all the furniture that he is likely to use, and the rest he can put away in the lumber-room of his library, where he can get it if he wants it. Now, for such a case as the one which has been submitted to us to-night, we need certainly to muster all our resources. Kindly hand me down the letter K of the American Encyclopaedia which stands upon the shelf beside you. Thank you. Now let us consider the situation and see what may be deduced from it. In the first place, we may start with a strong presumption that Colonel Openshaw had some very strong reason for leaving America. Men at his time of life do not change all their habits and exchange willingly the charming climate of Florida for the lonely life of an English provincial town. His extreme love of solitude in England suggests the idea that he was in fear of someone or something, so we may assume as a working hypothesis that it was fear of someone or something which drove him from America. As to what it was he feared, we can only deduce that by considering the formidable letters which were received by himself and his successors. Did you remark the postmarks of those letters?"

"The first was from Pondicherry, the second from Dundee, and the third from London."

"From East London. What do you deduce from that?"

"They are all seaports. That the writer was on board of a ship."

"Excellent. We have already a clue. There can be no doubt that the probability--the strong probability--is that the writer was on board of a ship. And now let us consider another point. In the case of Pondicherry, seven weeks elapsed between the threat and its fulfilment, in Dundee it was only some three or four days. Does that suggest anything?"

"A greater distance to travel."

"But the letter had also a greater distance to come."

"Then I do not see the point."

"There is at least a presumption that the vessel in which the man or men are is a sailing-ship. It looks as if they always send their singular warning or token before them when starting upon their mission. You see how quickly the deed followed the sign when it came from Dundee. If they had come from Pondicherry in a steamer they would have arrived almost as soon as their letter. But, as a matter of fact, seven weeks elapsed. I think that those seven weeks represented the difference between the mail-boat which brought the letter and the sailing vessel which brought the writer."

"It is possible."

"More than that. It is probable. And now you see the deadly urgency of this new case, and why I urged young Openshaw to caution. The blow has always fallen at the end of the time which it would take the senders to travel the distance. But this one comes from London, and therefore we cannot count upon delay."

"Good God!" I cried. "What can it mean, this relentless persecution?"

"The papers which Openshaw carried are obviously of vital importance to the person or persons in the sailing-ship. I think that it is quite clear that there must be more than one of them. A single man could not have carried out two deaths in such a way as to deceive a coroner's jury. There must have been several in it, and they must have been men of resource and determination. Their papers they mean to have, be the holder of them who it may. In this way you see K. K. K. ceases to be the initials of an individual and becomes the badge of a society."

"But of what society?"

"Have you never--" said Sherlock Holmes, bending forward and sinking his voice--"have you never heard of the Ku Klux Klan?"

"I never have."

Holmes turned over the leaves of the book upon his knee. "Here it is," said he presently:

" 'Ku Klux Klan. A name derived from the fanciful resemblance to the sound produced by cocking a rifle. This terrible secret society was formed by some ex-Confederate soldiers in the Southern states after the Civil War, and it rapidly formed local branches in different parts of the country, notably in Tennessee, Louisiana, the Carolinas, Georgia, and Florida. Its power was used for political purposes, principally for the terrorising of the negro voters and the murdering and driving from the country of those who were opposed to its views. Its outrages were usually preceded by a warning sent to the marked man in some fantastic but generally recognised shape--a sprig of oak-leaves in some parts, melon seeds or orange pips in others. On receiving this the victim might either openly abjure his former ways, or might fly from the country. If he braved the matter out, death would unfailingly come upon him, and usually in some strange and unforeseen manner. So perfect was the organisation of the society, and so systematic its methods, that there is hardly a case upon record where any man succeeded in braving it with impunity, or in which any of its outrages were traced home to the perpetrators. For some years the organisation flourished in spite of the efforts of the United States government and of the better classes of the community in the South. Eventually, in the year 1869, the movement rather suddenly collapsed, although there have been sporadic outbreaks of the same sort since that date.'

"You will observe," said Holmes, laying down the volume, "that the sudden breaking up of the society was coincident with the disappearance of Openshaw from America with their papers. It may well have been cause and effect. It is no wonder that he and his family have some of the more implacable spirits upon their track. You can understand that this register and diary may implicate some of the first men in the South, and that there may be many who will not sleep easy at night until it is recovered."

"Then the page we have seen--"

"Is such as we might expect. It ran, if I remember right, 'sent the pips to A, B, and C'--that is, sent the society's warning to them. Then there are successive entries that A and B cleared, or left the country, and finally that C was visited, with, I fear, a sinister result for C. Well, I think, Doctor, that we may let some light into this dark place, and I believe that the only chance young Openshaw has in the meantime is to do what I have told him. There is nothing more to be said or to be done to-night, so hand me over my violin and let us try to forget for half an hour the miserable weather and the still more miserable ways of our fellow men."

It had cleared in the morning, and the sun was shining with a subdued brightness through the dim veil which hangs over the great city. Sherlock Holmes was already at breakfast when I came down.

"You will excuse me for not waiting for you," said he; "I have, I foresee, a very busy day before me in looking into this case of young Openshaw's."

"What steps will you take?" I asked.

"It will very much depend upon the results of my first inquiries. I may have to go down to Horsham, after all."

"You will not go there first?"

"No, I shall commence with the City. Just ring the bell and the maid will bring up your coffee."

As I waited, I lifted the unopened newspaper from the table and glanced my eye over it. It rested upon a heading which sent a chill to my heart.

"Holmes," I cried, "you are too late."

"Ah!" said he, laying down his cup, "I feared as much. How was it done?" He spoke calmly, but I could see that he was deeply moved.

"My eye caught the name of Openshaw, and the heading 'Tragedy Near Waterloo Bridge.' Here is the account:

" 'Between nine and ten last night Police-Constable Cook, of the H Division, on duty near Waterloo Bridge, heard a cry for help and a splash in the water. The night, however, was extremely dark and stormy, so that, in spite of the help of several passers-by, it was quite impossible to effect a rescue. The alarm, however, was given, and, by the aid of the water-police, the body was eventually recovered. It proved to be that of a young gentleman whose name, as it appears from an envelope which was found in his pocket, was John Openshaw, and whose residence is near Horsham. It is conjectured that he may have been hurrying down to catch the last train from Waterloo Station, and that in his haste and the extreme darkness he missed his path and walked over the edge of one of the small landing-places for river steamboats. The body exhibited no traces of violence, and there can be no doubt that the deceased had been the victim of an unfortunate accident, which should have the effect of calling the attention of the authorities to the condition of the riverside landing-stages.' "

We sat in silence for some minutes, Holmes more depressed and shaken than I had ever seen him.

"That hurts my pride, Watson," he said at last. "It is a petty feeling, no doubt, but it hurts my pride. It becomes a personal matter with me now, and, if God sends me health, I shall set my hand upon this gang. That he should come to me for help, and that I should send him away to his death--!" He sprang from his chair and paced about the room in uncontrollable agitation, with a flush upon his sallow cheeks and a nervous clasping and unclasping of his long thin hands.

"They must be cunning devils," he exclaimed at last. "How could they have decoyed him down there? The Embankment is not on the direct line to the station. The bridge, no doubt, was too crowded, even on such a night, for their purpose. Well, Watson, we shall see who will win in the long run. I am going out now!"

"To the police?"

"No; I shall be my own police. When I have spun the web they may take the flies, but not before."

All day I was engaged in my professional work, and it was late in the evening before I returned to Baker Street. Sherlock Holmes had not come back yet. It was nearly ten o'clock before he entered, looking pale and worn. He walked up to the sideboard, and tearing a piece from the loaf he devoured it voraciously, washing it down with a long draught of water.

"You are hungry," I remarked.

"Starving. It had escaped my memory. I have had nothing since breakfast."

"Nothing?"

"Not a bite. I had no time to think of it."

"And how have you succeeded?"

"Well."

"You have a clue?"

"I have them in the hollow of my hand. Young Openshaw shall not long remain unavenged. Why, Watson, let us put their own devilish trade-mark upon them. It is well thought of!"

"What do you mean?"

He took an orange from the cupboard, and tearing it to pieces he squeezed out the pips upon the table. Of these he took five and thrust them into an envelope. On the inside of the flap he wrote "S. H. for J. O." Then he sealed it and addressed it to "Captain James Calhoun, Barque Lone Star, Savannah, Georgia."

"That will await him when he enters port," said he, chuckling. "It may give him a sleepless night. He will find it as sure a precursor of his fate as Openshaw did before him."

"And who is this Captain Calhoun?"

"The leader of the gang. I shall have the others, but he first."

"How did you trace it, then?"

He took a large sheet of paper from his pocket, all covered with dates and names.

"I have spent the whole day," said he, "over Lloyd's registers and files of the old papers, following the future career of every vessel which touched at Pondicherry in January and February in '83. There were thirty-six ships of fair tonnage which were reported there during those months. Of these, one, the Lone Star, instantly attracted my attention, since, although it was reported as having cleared from London, the name is that which is given to one of the states of the Union."

"Texas, I think."

"I was not and am not sure which; but I knew that the ship must have an American origin."

"What then?"

"I searched the Dundee records, and when I found that the barque Lone Star was there in January, '85, my suspicion became a certainty. I then inquired as to the vessels which lay at present in the port of London."

"Yes?"

"The Lone Star had arrived here last week. I went down to the Albert Dock and found that she had been taken down the river by the early tide this morning, homeward bound to Savannah. I wired to Gravesend and learned that she had passed some time ago, and as the wind is easterly I have no doubt that she is now past the Goodwins and not very far from the Isle of Wight."

"What will you do, then?"

"Oh, I have my hand upon him. He and the two mates, are as I learn, the only native-born Americans in the ship. The others are Finns and Germans. I know, also, that they were all three away from the ship last night. I had it from the stevedore who has been loading their cargo. By the time that their sailing-ship reaches Savannah the mail-boat will have carried this letter, and the cable will have informed the police of Savannah that these three gentlemen are badly wanted here upon a charge of murder."

There is ever a flaw, however, in the best laid of human plans, and the murderers of John Openshaw were never to receive the orange pips which would show them that another, as cunning and as resolute as themselves, was upon their track. Very long and very severe were the equinoctial gales that year. We waited long for news of the Lone Star of Savannah, but none ever reached us. We did at last hear that somewhere far out in the Atlantic a shattered stern-post of a boat was seen swinging in the trough of a wave, with the letters "L. S." carved upon it, and that is all which we shall ever know of the fate of the Lone Star.

ADVENTURE  VI.  THE MAN WITH THE TWISTED LIP


Isa Whitney, brother of the late Elias Whitney, D.D., Principal of the Theological College of St. George's, was much addicted to opium. The habit grew upon him, as I understand, from some foolish freak when he was at college; for having read De Quincey's description of his dreams and sensations, he had drenched his tobacco with laudanum in an attempt to produce the same effects. He found, as so many more have done, that the practice is easier to attain than to get rid of, and for many years he continued to be a slave to the drug, an object of mingled horror and pity to his friends and relatives. I can see him now, with yellow, pasty face, drooping lids, and pin-point pupils, all huddled in a chair, the wreck and ruin of a noble man.

One night--it was in June, '89--there came a ring to my bell, about the hour when a man gives his first yawn and glances at the clock. I sat up in my chair, and my wife laid her needle-work down in her lap and made a little face of disappointment.

"A patient!" said she. "You'll have to go out."

I groaned, for I was newly come back from a weary day.

We heard the door open, a few hurried words, and then quick steps upon the linoleum. Our own door flew open, and a lady, clad in some dark-coloured stuff, with a black veil, entered the room.

"You will excuse my calling so late," she began, and then, suddenly losing her self-control, she ran forward, threw her arms about my wife's neck, and sobbed upon her shoulder. "Oh, I'm in such trouble!" she cried; "I do so want a little help."

"Why," said my wife, pulling up her veil, "it is Kate Whitney. How you startled me, Kate! I had not an idea who you were when you came in."

"I didn't know what to do, so I came straight to you." That was always the way. Folk who were in grief came to my wife like birds to a light-house.

"It was very sweet of you to come. Now, you must have some wine and water, and sit here comfortably and tell us all about it. Or should you rather that I sent James off to bed?"

"Oh, no, no! I want the doctor's advice and help, too. It's about Isa. He has not been home for two days. I am so frightened about him!"

It was not the first time that she had spoken to us of her husband's trouble, to me as a doctor, to my wife as an old friend and school companion. We soothed and comforted her by such words as we could find. Did she know where her husband was? Was it possible that we could bring him back to her?

It seems that it was. She had the surest information that of late he had, when the fit was on him, made use of an opium den in the farthest east of the City. Hitherto his orgies had always been confined to one day, and he had come back, twitching and shattered, in the evening. But now the spell had been upon him eight-and-forty hours, and he lay there, doubtless among the dregs of the docks, breathing in the poison or sleeping off the effects. There he was to be found, she was sure of it, at the Bar of Gold, in Upper Swandam Lane. But what was she to do? How could she, a young and timid woman, make her way into such a place and pluck her husband out from among the ruffians who surrounded him?

There was the case, and of course there was but one way out of it. Might I not escort her to this place? And then, as a second thought, why should she come at all? I was Isa Whitney's medical adviser, and as such I had influence over him. I could manage it better if I were alone. I promised her on my word that I would send him home in a cab within two hours if he were indeed at the address which she had given me. And so in ten minutes I had left my armchair and cheery sitting-room behind me, and was speeding eastward in a hansom on a strange errand, as it seemed to me at the time, though the future only could show how strange it was to be.

But there was no great difficulty in the first stage of my adventure. Upper Swandam Lane is a vile alley lurking behind the high wharves which line the north side of the river to the east of London Bridge. Between a slop-shop and a gin-shop, approached by a steep flight of steps leading down to a black gap like the mouth of a cave, I found the den of which I was in search. Ordering my cab to wait, I passed down the steps, worn hollow in the centre by the ceaseless tread of drunken feet; and by the light of a flickering oil-lamp above the door I found the latch and made my way into a long, low room, thick and heavy with the brown opium smoke, and terraced with wooden berths, like the forecastle of an emigrant ship.

Through the gloom one could dimly catch a glimpse of bodies lying in strange fantastic poses, bowed shoulders, bent knees, heads thrown back, and chins pointing upward, with here and there a dark, lack-lustre eye turned upon the newcomer. Out of the black shadows there glimmered little red circles of light, now bright, now faint, as the burning poison waxed or waned in the bowls of the metal pipes. The most lay silent, but some muttered to themselves, and others talked together in a strange, low, monotonous voice, their conversation coming in gushes, and then suddenly tailing off into silence, each mumbling out his own thoughts and paying little heed to the words of his neighbour. At the farther end was a small brazier of burning charcoal, beside which on a three-legged wooden stool there sat a tall, thin old man, with his jaw resting upon his two fists, and his elbows upon his knees, staring into the fire.

As I entered, a sallow Malay attendant had hurried up with a pipe for me and a supply of the drug, beckoning me to an empty berth.

"Thank you. I have not come to stay," said I. "There is a friend of mine here, Mr. Isa Whitney, and I wish to speak with him."

There was a movement and an exclamation from my right, and peering through the gloom, I saw Whitney, pale, haggard, and unkempt, staring out at me.

"My God! It's Watson," said he. He was in a pitiable state of reaction, with every nerve in a twitter. "I say, Watson, what o'clock is it?"

"Nearly eleven."

"Of what day?"

"Of Friday, June 19th."

"Good heavens! I thought it was Wednesday. It is Wednesday. What d'you want to frighten a chap for?" He sank his face onto his arms and began to sob in a high treble key.

"I tell you that it is Friday, man. Your wife has been waiting this two days for you. You should be ashamed of yourself!"

"So I am. But you've got mixed, Watson, for I have only been here a few hours, three pipes, four pipes--I forget how many. But I'll go home with you. I wouldn't frighten Kate--poor little Kate. Give me your hand! Have you a cab?"

"Yes, I have one waiting."

"Then I shall go in it. But I must owe something. Find what I owe, Watson. I am all off colour. I can do nothing for myself."

I walked down the narrow passage between the double row of sleepers, holding my breath to keep out the vile, stupefying fumes of the drug, and looking about for the manager. As I passed the tall man who sat by the brazier I felt a sudden pluck at my skirt, and a low voice whispered, "Walk past me, and then look back at me." The words fell quite distinctly upon my ear. I glanced down. They could only have come from the old man at my side, and yet he sat now as absorbed as ever, very thin, very wrinkled, bent with age, an opium pipe dangling down from between his knees, as though it had dropped in sheer lassitude from his fingers. I took two steps forward and looked back. It took all my self-control to prevent me from breaking out into a cry of astonishment. He had turned his back so that none could see him but I. His form had filled out, his wrinkles were gone, the dull eyes had regained their fire, and there, sitting by the fire and grinning at my surprise, was none other than Sherlock Holmes. He made a slight motion to me to approach him, and instantly, as he turned his face half round to the company once more, subsided into a doddering, loose-lipped senility.

"Holmes!" I whispered, "what on earth are you doing in this den?"

"As low as you can," he answered; "I have excellent ears. If you would have the great kindness to get rid of that sottish friend of yours I should be exceedingly glad to have a little talk with you."

"I have a cab outside."

"Then pray send him home in it. You may safely trust him, for he appears to be too limp to get into any mischief. I should recommend you also to send a note by the cabman to your wife to say that you have thrown in your lot with me. If you will wait outside, I shall be with you in five minutes."

It was difficult to refuse any of Sherlock Holmes' requests, for they were always so exceedingly definite, and put forward with such a quiet air of mastery. I felt, however, that when Whitney was once confined in the cab my mission was practically accomplished; and for the rest, I could not wish anything better than to be associated with my friend in one of those singular adventures which were the normal condition of his existence. In a few minutes I had written my note, paid Whitney's bill, led him out to the cab, and seen him driven through the darkness. In a very short time a decrepit figure had emerged from the opium den, and I was walking down the street with Sherlock Holmes. For two streets he shuffled along with a bent back and an uncertain foot. Then, glancing quickly round, he straightened himself out and burst into a hearty fit of laughter.

"I suppose, Watson," said he, "that you imagine that I have added opium-smoking to cocaine injections, and all the other little weaknesses on which you have favoured me with your medical views."

"I was certainly surprised to find you there."

"But not more so than I to find you."

"I came to find a friend."

"And I to find an enemy."

"An enemy?"

"Yes; one of my natural enemies, or, shall I say, my natural prey. Briefly, Watson, I am in the midst of a very remarkable inquiry, and I have hoped to find a clue in the incoherent ramblings of these sots, as I have done before now. Had I been recognised in that den my life would not have been worth an hour's purchase; for I have used it before now for my own purposes, and the rascally Lascar who runs it has sworn to have vengeance upon me. There is a trap-door at the back of that building, near the corner of Paul's Wharf, which could tell some strange tales of what has passed through it upon the moonless nights."

"What! You do not mean bodies?"

"Ay, bodies, Watson. We should be rich men if we had $1000 for every poor devil who has been done to death in that den. It is the vilest murder-trap on the whole riverside, and I fear that Neville St. Clair has entered it never to leave it more. But our trap should be here." He put his two forefingers between his teeth and whistled shrilly--a signal which was answered by a similar whistle from the distance, followed shortly by the rattle of wheels and the clink of horses' hoofs.

"Now, Watson," said Holmes, as a tall dog-cart dashed up through the gloom, throwing out two golden tunnels of yellow light from its side lanterns. "You'll come with me, won't you?"

"If I can be of use."

"Oh, a trusty comrade is always of use; and a chronicler still more so. My room at The Cedars is a double-bedded one."

"The Cedars?"

"Yes; that is Mr. St. Clair's house. I am staying there while I conduct the inquiry."

"Where is it, then?"

"Near Lee, in Kent. We have a seven-mile drive before us."

"But I am all in the dark."

"Of course you are. You'll know all about it presently. Jump up here. All right, John; we shall not need you. Here's half a crown. Look out for me to-morrow, about eleven. Give her her head. So long, then!"

He flicked the horse with his whip, and we dashed away through the endless succession of sombre and deserted streets, which widened gradually, until we were flying across a broad balustraded bridge, with the murky river flowing sluggishly beneath us. Beyond lay another dull wilderness of bricks and mortar, its silence broken only by the heavy, regular footfall of the policeman, or the songs and shouts of some belated party of revellers. A dull wrack was drifting slowly across the sky, and a star or two twinkled dimly here and there through the rifts of the clouds. Holmes drove in silence, with his head sunk upon his breast, and the air of a man who is lost in thought, while I sat beside him, curious to learn what this new quest might be which seemed to tax his powers so sorely, and yet afraid to break in upon the current of his thoughts. We had driven several miles, and were beginning to get to the fringe of the belt of suburban villas, when he shook himself, shrugged his shoulders, and lit up his pipe with the air of a man who has satisfied himself that he is acting for the best.

"You have a grand gift of silence, Watson," said he. "It makes you quite invaluable as a companion. 'Pon my word, it is a great thing for me to have someone to talk to, for my own thoughts are not over-pleasant. I was wondering what I should say to this dear little woman to-night when she meets me at the door."

"You forget that I know nothing about it."

"I shall just have time to tell you the facts of the case before we get to Lee. It seems absurdly simple, and yet, somehow I can get nothing to go upon. There's plenty of thread, no doubt, but I can't get the end of it into my hand. Now, I'll state the case clearly and concisely to you, Watson, and maybe you can see a spark where all is dark to me."

"Proceed, then."

"Some years ago--to be definite, in May, 1884--there came to Lee a gentleman, Neville St. Clair by name, who appeared to have plenty of money. He took a large villa, laid out the grounds very nicely, and lived generally in good style. By degrees he made friends in the neighbourhood, and in 1887 he married the daughter of a local brewer, by whom he now has two children. He had no occupation, but was interested in several companies and went into town as a rule in the morning, returning by the 5:14 from Cannon Street every night. Mr. St. Clair is now thirty-seven years of age, is a man of temperate habits, a good husband, a very affectionate father, and a man who is popular with all who know him. I may add that his whole debts at the present moment, as far as we have been able to ascertain, amount to $88 10s., while he has $220 standing to his credit in the Capital and Counties Bank. There is no reason, therefore, to think that money troubles have been weighing upon his mind.

"Last Monday Mr. Neville St. Clair went into town rather earlier than usual, remarking before he started that he had two important commissions to perform, and that he would bring his little boy home a box of bricks. Now, by the merest chance, his wife received a telegram upon this same Monday, very shortly after his departure, to the effect that a small parcel of considerable value which she had been expecting was waiting for her at the offices of the Aberdeen Shipping Company. Now, if you are well up in your London, you will know that the office of the company is in Fresno Street, which branches out of Upper Swandam Lane, where you found me to-night. Mrs. St. Clair had her lunch, started for the City, did some shopping, proceeded to the company's office, got her packet, and found herself at exactly 4:35 walking through Swandam Lane on her way back to the station. Have you followed me so far?"

"It is very clear."

"If you remember, Monday was an exceedingly hot day, and Mrs. St. Clair walked slowly, glancing about in the hope of seeing a cab, as she did not like the neighbourhood in which she found herself. While she was walking in this way down Swandam Lane, she suddenly heard an ejaculation or cry, and was struck cold to see her husband looking down at her and, as it seemed to her, beckoning to her from a second-floor window. The window was open, and she distinctly saw his face, which she describes as being terribly agitated. He waved his hands frantically to her, and then vanished from the window so suddenly that it seemed to her that he had been plucked back by some irresistible force from behind. One singular point which struck her quick feminine eye was that although he wore some dark coat, such as he had started to town in, he had on neither collar nor necktie.

"Convinced that something was amiss with him, she rushed down the steps--for the house was none other than the opium den in which you found me to-night--and running through the front room she attempted to ascend the stairs which led to the first floor. At the foot of the stairs, however, she met this Lascar scoundrel of whom I have spoken, who thrust her back and, aided by a Dane, who acts as assistant there, pushed her out into the street. Filled with the most maddening doubts and fears, she rushed down the lane and, by rare good-fortune, met in Fresno Street a number of constables with an inspector, all on their way to their beat. The inspector and two men accompanied her back, and in spite of the continued resistance of the proprietor, they made their way to the room in which Mr. St. Clair had last been seen. There was no sign of him there. In fact, in the whole of that floor there was no one to be found save a crippled wretch of hideous aspect, who, it seems, made his home there. Both he and the Lascar stoutly swore that no one else had been in the front room during the afternoon. So determined was their denial that the inspector was staggered, and had almost come to believe that Mrs. St. Clair had been deluded when, with a cry, she sprang at a small deal box which lay upon the table and tore the lid from it. Out there fell a cascade of children's bricks. It was the toy which he had promised to bring home.

"This discovery, and the evident confusion which the cripple showed, made the inspector realise that the matter was serious. The rooms were carefully examined, and results all pointed to an abominable crime. The front room was plainly furnished as a sitting-room and led into a small bedroom, which looked out upon the back of one of the wharves. Between the wharf and the bedroom window is a narrow strip, which is dry at low tide but is covered at high tide with at least four and a half feet of water. The bedroom window was a broad one and opened from below. On examination traces of blood were to be seen upon the windowsill, and several scattered drops were visible upon the wooden floor of the bedroom. Thrust away behind a curtain in the front room were all the clothes of Mr. Neville St. Clair, with the exception of his coat. His boots, his socks, his hat, and his watch--all were there. There were no signs of violence upon any of these garments, and there were no other traces of Mr. Neville St. Clair. Out of the window he must apparently have gone for no other exit could be discovered, and the ominous bloodstains upon the sill gave little promise that he could save himself by swimming, for the tide was at its very highest at the moment of the tragedy.

"And now as to the villains who seemed to be immediately implicated in the matter. The Lascar was known to be a man of the vilest antecedents, but as, by Mrs. St. Clair's story, he was known to have been at the foot of the stair within a very few seconds of her husband's appearance at the window, he could hardly have been more than an accessory to the crime. His defence was one of absolute ignorance, and he protested that he had no knowledge as to the doings of Hugh Boone, his lodger, and that he could not account in any way for the presence of the missing gentleman's clothes.

"So much for the Lascar manager. Now for the sinister cripple who lives upon the second floor of the opium den, and who was certainly the last human being whose eyes rested upon Neville St. Clair. His name is Hugh Boone, and his hideous face is one which is familiar to every man who goes much to the City. He is a professional beggar, though in order to avoid the police regulations he pretends to a small trade in wax vestas. Some little distance down Threadneedle Street, upon the left-hand side, there is, as you may have remarked, a small angle in the wall. Here it is that this creature takes his daily seat, cross-legged with his tiny stock of matches on his lap, and as he is a piteous spectacle a small rain of charity descends into the greasy leather cap which lies upon the pavement beside him. I have watched the fellow more than once before ever I thought of making his professional acquaintance, and I have been surprised at the harvest which he has reaped in a short time. His appearance, you see, is so remarkable that no one can pass him without observing him. A shock of orange hair, a pale face disfigured by a horrible scar, which, by its contraction, has turned up the outer edge of his upper lip, a bulldog chin, and a pair of very penetrating dark eyes, which present a singular contrast to the colour of his hair, all mark him out from amid the common crowd of mendicants and so, too, does his wit, for he is ever ready with a reply to any piece of chaff which may be thrown at him by the passers-by. This is the man whom we now learn to have been the lodger at the opium den, and to have been the last man to see the gentleman of whom we are in quest."

"But a cripple!" said I. "What could he have done single-handed against a man in the prime of life?"

"He is a cripple in the sense that he walks with a limp; but in other respects he appears to be a powerful and well-nurtured man. Surely your medical experience would tell you, Watson, that weakness in one limb is often compensated for by exceptional strength in the others."

"Pray continue your narrative."

"Mrs. St. Clair had fainted at the sight of the blood upon the window, and she was escorted home in a cab by the police, as her presence could be of no help to them in their investigations. Inspector Barton, who had charge of the case, made a very careful examination of the premises, but without finding anything which threw any light upon the matter. One mistake had been made in not arresting Boone instantly, as he was allowed some few minutes during which he might have communicated with his friend the Lascar, but this fault was soon remedied, and he was seized and searched, without anything being found which could incriminate him. There were, it is true, some blood-stains upon his right shirt-sleeve, but he pointed to his ring-finger, which had been cut near the nail, and explained that the bleeding came from there, adding that he had been to the window not long before, and that the stains which had been observed there came doubtless from the same source. He denied strenuously having ever seen Mr. Neville St. Clair and swore that the presence of the clothes in his room was as much a mystery to him as to the police. As to Mrs. St. Clair's assertion that she had actually seen her husband at the window, he declared that she must have been either mad or dreaming. He was removed, loudly protesting, to the police-station, while the inspector remained upon the premises in the hope that the ebbing tide might afford some fresh clue.

"And it did, though they hardly found upon the mud-bank what they had feared to find. It was Neville St. Clair's coat, and not Neville St. Clair, which lay uncovered as the tide receded. And what do you think they found in the pockets?"

"I cannot imagine."

"No, I don't think you would guess. Every pocket stuffed with pennies and half-pennies--421 pennies and 270 half-pennies. It was no wonder that it had not been swept away by the tide. But a human body is a different matter. There is a fierce eddy between the wharf and the house. It seemed likely enough that the weighted coat had remained when the stripped body had been sucked away into the river."

"But I understand that all the other clothes were found in the room. Would the body be dressed in a coat alone?"

"No, sir, but the facts might be met speciously enough. Suppose that this man Boone had thrust Neville St. Clair through the window, there is no human eye which could have seen the deed. What would he do then? It would of course instantly strike him that he must get rid of the tell-tale garments. He would seize the coat, then, and be in the act of throwing it out, when it would occur to him that it would swim and not sink. He has little time, for he has heard the scuffle downstairs when the wife tried to force her way up, and perhaps he has already heard from his Lascar confederate that the police are hurrying up the street. There is not an instant to be lost. He rushes to some secret hoard, where he has accumulated the fruits of his beggary, and he stuffs all the coins upon which he can lay his hands into the pockets to make sure of the coat's sinking. He throws it out, and would have done the same with the other garments had not he heard the rush of steps below, and only just had time to close the window when the police appeared."

"It certainly sounds feasible."

"Well, we will take it as a working hypothesis for want of a better. Boone, as I have told you, was arrested and taken to the station, but it could not be shown that there had ever before been anything against him. He had for years been known as a professional beggar, but his life appeared to have been a very quiet and innocent one. There the matter stands at present, and the questions which have to be solved--what Neville St. Clair was doing in the opium den, what happened to him when there, where is he now, and what Hugh Boone had to do with his disappearance--are all as far from a solution as ever. I confess that I cannot recall any case within my experience which looked at the first glance so simple and yet which presented such difficulties."

While Sherlock Holmes had been detailing this singular series of events, we had been whirling through the outskirts of the great town until the last straggling houses had been left behind, and we rattled along with a country hedge upon either side of us. Just as he finished, however, we drove through two scattered villages, where a few lights still glimmered in the windows.

"We are on the outskirts of Lee," said my companion. "We have touched on three English counties in our short drive, starting in Middlesex, passing over an angle of Surrey, and ending in Kent. See that light among the trees? That is The Cedars, and beside that lamp sits a woman whose anxious ears have already, I have little doubt, caught the clink of our horse's feet."

"But why are you not conducting the case from Baker Street?" I asked.

"Because there are many inquiries which must be made out here. Mrs. St. Clair has most kindly put two rooms at my disposal, and you may rest assured that she will have nothing but a welcome for my friend and colleague. I hate to meet her, Watson, when I have no news of her husband. Here we are. Whoa, there, whoa!"

We had pulled up in front of a large villa which stood within its own grounds. A stable-boy had run out to the horse's head, and springing down, I followed Holmes up the small, winding gravel-drive which led to the house. As we approached, the door flew open, and a little blonde woman stood in the opening, clad in some sort of light mousseline de soie, with a touch of fluffy pink chiffon at her neck and wrists. She stood with her figure outlined against the flood of light, one hand upon the door, one half-raised in her eagerness, her body slightly bent, her head and face protruded, with eager eyes and parted lips, a standing question.

"Well?" she cried, "well?" And then, seeing that there were two of us, she gave a cry of hope which sank into a groan as she saw that my companion shook his head and shrugged his shoulders.

"No good news?"

"None."

"No bad?"

"No."

"Thank God for that. But come in. You must be weary, for you have had a long day."

"This is my friend, Dr. Watson. He has been of most vital use to me in several of my cases, and a lucky chance has made it possible for me to bring him out and associate him with this investigation."

"I am delighted to see you," said she, pressing my hand warmly. "You will, I am sure, forgive anything that may be wanting in our arrangements, when you consider the blow which has come so suddenly upon us."

"My dear madam," said I, "I am an old campaigner, and if I were not I can very well see that no apology is needed. If I can be of any assistance, either to you or to my friend here, I shall be indeed happy."

"Now, Mr. Sherlock Holmes," said the lady as we entered a well-lit dining-room, upon the table of which a cold supper had been laid out, "I should very much like to ask you one or two plain questions, to which I beg that you will give a plain answer."

"Certainly, madam."

"Do not trouble about my feelings. I am not hysterical, nor given to fainting. I simply wish to hear your real, real opinion."

"Upon what point?"

"In your heart of hearts, do you think that Neville is alive?"

Sherlock Holmes seemed to be embarrassed by the question. "Frankly, now!" she repeated, standing upon the rug and looking keenly down at him as he leaned back in a basket-chair.

"Frankly, then, madam, I do not."

"You think that he is dead?"

"I do."

"Murdered?"

"I don't say that. Perhaps."

"And on what day did he meet his death?"

"On Monday."

"Then perhaps, Mr. Holmes, you will be good enough to explain how it is that I have received a letter from him to-day."

Sherlock Holmes sprang out of his chair as if he had been galvanised.

"What!" he roared.

"Yes, to-day." She stood smiling, holding up a little slip of paper in the air.

"May I see it?"

"Certainly."

He snatched it from her in his eagerness, and smoothing it out upon the table he drew over the lamp and examined it intently. I had left my chair and was gazing at it over his shoulder. The envelope was a very coarse one and was stamped with the Gravesend postmark and with the date of that very day, or rather of the day before, for it was considerably after midnight.

"Coarse writing," murmured Holmes. "Surely this is not your husband's writing, madam."

"No, but the enclosure is."

"I perceive also that whoever addressed the envelope had to go and inquire as to the address."

"How can you tell that?"

"The name, you see, is in perfectly black ink, which has dried itself. The rest is of the greyish colour, which shows that blotting-paper has been used. If it had been written straight off, and then blotted, none would be of a deep black shade. This man has written the name, and there has then been a pause before he wrote the address, which can only mean that he was not familiar with it. It is, of course, a trifle, but there is nothing so important as trifles. Let us now see the letter. Ha! there has been an enclosure here!"

"Yes, there was a ring. His signet-ring."

"And you are sure that this is your husband's hand?"

"One of his hands."

"One?"

"His hand when he wrote hurriedly. It is very unlike his usual writing, and yet I know it well."

" 'Dearest do not be frightened. All will come well. There is a huge error which it may take some little time to rectify. Wait in patience.--NEVILLE.' Written in pencil upon the fly-leaf of a book, octavo size, no water-mark. Hum! Posted to-day in Gravesend by a man with a dirty thumb. Ha! And the flap has been gummed, if I am not very much in error, by a person who had been chewing tobacco. And you have no doubt that it is your husband's hand, madam?"

"None. Neville wrote those words."

"And they were posted to-day at Gravesend. Well, Mrs. St. Clair, the clouds lighten, though I should not venture to say that the danger is over."

"But he must be alive, Mr. Holmes."

"Unless this is a clever forgery to put us on the wrong scent. The ring, after all, proves nothing. It may have been taken from him."

"No, no; it is, it is his very own writing!"

"Very well. It may, however, have been written on Monday and only posted to-day."

"That is possible."

"If so, much may have happened between."

"Oh, you must not discourage me, Mr. Holmes. I know that all is well with him. There is so keen a sympathy between us that I should know if evil came upon him. On the very day that I saw him last he cut himself in the bedroom, and yet I in the dining-room rushed upstairs instantly with the utmost certainty that something had happened. Do you think that I would respond to such a trifle and yet be ignorant of his death?"

"I have seen too much not to know that the impression of a woman may be more valuable than the conclusion of an analytical reasoner. And in this letter you certainly have a very strong piece of evidence to corroborate your view. But if your husband is alive and able to write letters, why should he remain away from you?"

"I cannot imagine. It is unthinkable."

"And on Monday he made no remarks before leaving you?"

"No."

"And you were surprised to see him in Swandam Lane?"

"Very much so."

"Was the window open?"

"Yes."

"Then he might have called to you?"

"He might."

"He only, as I understand, gave an inarticulate cry?"

"Yes."

"A call for help, you thought?"

"Yes. He waved his hands."

"But it might have been a cry of surprise. Astonishment at the unexpected sight of you might cause him to throw up his hands?"

"It is possible."

"And you thought he was pulled back?"

"He disappeared so suddenly."

"He might have leaped back. You did not see anyone else in the room?"

"No, but this horrible man confessed to having been there, and the Lascar was at the foot of the stairs."

"Quite so. Your husband, as far as you could see, had his ordinary clothes on?"

"But without his collar or tie. I distinctly saw his bare throat."

"Had he ever spoken of Swandam Lane?"

"Never."

"Had he ever showed any signs of having taken opium?"

"Never."

"Thank you, Mrs. St. Clair. Those are the principal points about which I wished to be absolutely clear. We shall now have a little supper and then retire, for we may have a very busy day to-morrow."

A large and comfortable double-bedded room had been placed at our disposal, and I was quickly between the sheets, for I was weary after my night of adventure. Sherlock Holmes was a man, however, who, when he had an unsolved problem upon his mind, would go for days, and even for a week, without rest, turning it over, rearranging his facts, looking at it from every point of view until he had either fathomed it or convinced himself that his data were insufficient. It was soon evident to me that he was now preparing for an all-night sitting. He took off his coat and waistcoat, put on a large blue dressing-gown, and then wandered about the room collecting pillows from his bed and cushions from the sofa and armchairs. With these he constructed a sort of Eastern divan, upon which he perched himself cross-legged, with an ounce of shag tobacco and a box of matches laid out in front of him. In the dim light of the lamp I saw him sitting there, an old briar pipe between his lips, his eyes fixed vacantly upon the corner of the ceiling, the blue smoke curling up from him, silent, motionless, with the light shining upon his strong-set aquiline features. So he sat as I dropped off to sleep, and so he sat when a sudden ejaculation caused me to wake up, and I found the summer sun shining into the apartment. The pipe was still between his lips, the smoke still curled upward, and the room was full of a dense tobacco haze, but nothing remained of the heap of shag which I had seen upon the previous night.

"Awake, Watson?" he asked.

"Yes."

"Game for a morning drive?"

"Certainly."

"Then dress. No one is stirring yet, but I know where the stable-boy sleeps, and we shall soon have the trap out." He chuckled to himself as he spoke, his eyes twinkled, and he seemed a different man to the sombre thinker of the previous night.

As I dressed I glanced at my watch. It was no wonder that no one was stirring. It was twenty-five minutes past four. I had hardly finished when Holmes returned with the news that the boy was putting in the horse.

"I want to test a little theory of mine," said he, pulling on his boots. "I think, Watson, that you are now standing in the presence of one of the most absolute fools in Europe. I deserve to be kicked from here to Charing Cross. But I think I have the key of the affair now."

"And where is it?" I asked, smiling.

"In the bathroom," he answered. "Oh, yes, I am not joking," he continued, seeing my look of incredulity. "I have just been there, and I have taken it out, and I have got it in this Gladstone bag. Come on, my boy, and we shall see whether it will not fit the lock."

We made our way downstairs as quietly as possible, and out into the bright morning sunshine. In the road stood our horse and trap, with the half-clad stable-boy waiting at the head. We both sprang in, and away we dashed down the London Road. A few country carts were stirring, bearing in vegetables to the metropolis, but the lines of villas on either side were as silent and lifeless as some city in a dream.

"It has been in some points a singular case," said Holmes, flicking the horse on into a gallop. "I confess that I have been as blind as a mole, but it is better to learn wisdom late than never to learn it at all."

In town the earliest risers were just beginning to look sleepily from their windows as we drove through the streets of the Surrey side. Passing down the Waterloo Bridge Road we crossed over the river, and dashing up Wellington Street wheeled sharply to the right and found ourselves in Bow Street. Sherlock Holmes was well known to the force, and the two constables at the door saluted him. One of them held the horse's head while the other led us in.

"Who is on duty?" asked Holmes.

"Inspector Bradstreet, sir."

"Ah, Bradstreet, how are you?" A tall, stout official had come down the stone-flagged passage, in a peaked cap and frogged jacket. "I wish to have a quiet word with you, Bradstreet." "Certainly, Mr. Holmes. Step into my room here." It was a small, office-like room, with a huge ledger upon the table, and a telephone projecting from the wall. The inspector sat down at his desk.

"What can I do for you, Mr. Holmes?"

"I called about that beggarman, Boone--the one who was charged with being concerned in the disappearance of Mr. Neville St. Clair, of Lee."

"Yes. He was brought up and remanded for further inquiries."

"So I heard. You have him here?"

"In the cells."

"Is he quiet?"

"Oh, he gives no trouble. But he is a dirty scoundrel."

"Dirty?"

"Yes, it is all we can do to make him wash his hands, and his face is as black as a tinker's. Well, when once his case has been settled, he will have a regular prison bath; and I think, if you saw him, you would agree with me that he needed it."

"I should like to see him very much."

"Would you? That is easily done. Come this way. You can leave your bag."

"No, I think that I'll take it."

"Very good. Come this way, if you please." He led us down a passage, opened a barred door, passed down a winding stair, and brought us to a whitewashed corridor with a line of doors on each side.

"The third on the right is his," said the inspector. "Here it is!" He quietly shot back a panel in the upper part of the door and glanced through.

"He is asleep," said he. "You can see him very well."

We both put our eyes to the grating. The prisoner lay with his face towards us, in a very deep sleep, breathing slowly and heavily. He was a middle-sized man, coarsely clad as became his calling, with a coloured shirt protruding through the rent in his tattered coat. He was, as the inspector had said, extremely dirty, but the grime which covered his face could not conceal its repulsive ugliness. A broad wheal from an old scar ran right across it from eye to chin, and by its contraction had turned up one side of the upper lip, so that three teeth were exposed in a perpetual snarl. A shock of very bright red hair grew low over his eyes and forehead.

"He's a beauty, isn't he?" said the inspector.

"He certainly needs a wash," remarked Holmes. "I had an idea that he might, and I took the liberty of bringing the tools with me." He opened the Gladstone bag as he spoke, and took out, to my astonishment, a very large bath-sponge.

"He! he! You are a funny one," chuckled the inspector.

"Now, if you will have the great goodness to open that door very quietly, we will soon make him cut a much more respectable figure."

"Well, I don't know why not," said the inspector. "He doesn't look a credit to the Bow Street cells, does he?" He slipped his key into the lock, and we all very quietly entered the cell. The sleeper half turned, and then settled down once more into a deep slumber. Holmes stooped to the water-jug, moistened his sponge, and then rubbed it twice vigorously across and down the prisoner's face.

"Let me introduce you," he shouted, "to Mr. Neville St. Clair, of Lee, in the county of Kent."

Never in my life have I seen such a sight. The man's face peeled off under the sponge like the bark from a tree. Gone was the coarse brown tint! Gone, too, was the horrid scar which had seamed it across, and the twisted lip which had given the repulsive sneer to the face! A twitch brought away the tangled red hair, and there, sitting up in his bed, was a pale, sad-faced, refined-looking man, black-haired and smooth-skinned, rubbing his eyes and staring about him with sleepy bewilderment. Then suddenly realising the exposure, he broke into a scream and threw himself down with his face to the pillow.

"Great heavens!" cried the inspector, "it is, indeed, the missing man. I know him from the photograph."

The prisoner turned with the reckless air of a man who abandons himself to his destiny. "Be it so," said he. "And pray what am I charged with?"

"With making away with Mr. Neville St.-- Oh, come, you can't be charged with that unless they make a case of attempted suicide of it," said the inspector with a grin. "Well, I have been twenty-seven years in the force, but this really takes the cake."

"If I am Mr. Neville St. Clair, then it is obvious that no crime has been committed, and that, therefore, I am illegally detained."

"No crime, but a very great error has been committed," said Holmes. "You would have done better to have trusted you wife."

"It was not the wife; it was the children," groaned the prisoner. "God help me, I would not have them ashamed of their father. My God! What an exposure! What can I do?"

Sherlock Holmes sat down beside him on the couch and patted him kindly on the shoulder.

"If you leave it to a court of law to clear the matter up," said he, "of course you can hardly avoid publicity. On the other hand, if you convince the police authorities that there is no possible case against you, I do not know that there is any reason that the details should find their way into the papers. Inspector Bradstreet would, I am sure, make notes upon anything which you might tell us and submit it to the proper authorities. The case would then never go into court at all."

"God bless you!" cried the prisoner passionately. "I would have endured imprisonment, ay, even execution, rather than have left my miserable secret as a family blot to my children.

"You are the first who have ever heard my story. My father was a schoolmaster in Chesterfield, where I received an excellent education. I travelled in my youth, took to the stage, and finally became a reporter on an evening paper in London. One day my editor wished to have a series of articles upon begging in the metropolis, and I volunteered to supply them. There was the point from which all my adventures started. It was only by trying begging as an amateur that I could get the facts upon which to base my articles. When an actor I had, of course, learned all the secrets of making up, and had been famous in the green-room for my skill. I took advantage now of my attainments. I painted my face, and to make myself as pitiable as possible I made a good scar and fixed one side of my lip in a twist by the aid of a small slip of flesh-coloured plaster. Then with a red head of hair, and an appropriate dress, I took my station in the business part of the city, ostensibly as a match-seller but really as a beggar. For seven hours I plied my trade, and when I returned home in the evening I found to my surprise that I had received no less than 26s. 4d.

"I wrote my articles and thought little more of the matter until, some time later, I backed a bill for a friend and had a writ served upon me for $25. I was at my wit's end where to get the money, but a sudden idea came to me. I begged a fortnight's grace from the creditor, asked for a holiday from my employers, and spent the time in begging in the City under my disguise. In ten days I had the money and had paid the debt.

"Well, you can imagine how hard it was to settle down to arduous work at $2 a week when I knew that I could earn as much in a day by smearing my face with a little paint, laying my cap on the ground, and sitting still. It was a long fight between my pride and the money, but the dollars won at last, and I threw up reporting and sat day after day in the corner which I had first chosen, inspiring pity by my ghastly face and filling my pockets with coppers. Only one man knew my secret. He was the keeper of a low den in which I used to lodge in Swandam Lane, where I could every morning emerge as a squalid beggar and in the evenings transform myself into a well-dressed man about town. This fellow, a Lascar, was well paid by me for his rooms, so that I knew that my secret was safe in his possession.

"Well, very soon I found that I was saving considerable sums of money. I do not mean that any beggar in the streets of London could earn $700 a year--which is less than my average takings--but I had exceptional advantages in my power of making up, and also in a facility of repartee, which improved by practice and made me quite a recognised character in the City. All day a stream of pennies, varied by silver, poured in upon me, and it was a very bad day in which I failed to take $2.

"As I grew richer I grew more ambitious, took a house in the country, and eventually married, without anyone having a suspicion as to my real occupation. My dear wife knew that I had business in the City. She little knew what.

"Last Monday I had finished for the day and was dressing in my room above the opium den when I looked out of my window and saw, to my horror and astonishment, that my wife was standing in the street, with her eyes fixed full upon me. I gave a cry of surprise, threw up my arms to cover my face, and, rushing to my confidant, the Lascar, entreated him to prevent anyone from coming up to me. I heard her voice downstairs, but I knew that she could not ascend. Swiftly I threw off my clothes, pulled on those of a beggar, and put on my pigments and wig. Even a wife's eyes could not pierce so complete a disguise. But then it occurred to me that there might be a search in the room, and that the clothes might betray me. I threw open the window, reopening by my violence a small cut which I had inflicted upon myself in the bedroom that morning. Then I seized my coat, which was weighted by the coppers which I had just transferred to it from the leather bag in which I carried my takings. I hurled it out of the window, and it disappeared into the Thames. The other clothes would have followed, but at that moment there was a rush of constables up the stair, and a few minutes after I found, rather, I confess, to my relief, that instead of being identified as Mr. Neville St. Clair, I was arrested as his murderer.

"I do not know that there is anything else for me to explain. I was determined to preserve my disguise as long as possible, and hence my preference for a dirty face. Knowing that my wife would be terribly anxious, I slipped off my ring and confided it to the Lascar at a moment when no constable was watching me, together with a hurried scrawl, telling her that she had no cause to fear."

"That note only reached her yesterday," said Holmes.

"Good God! What a week she must have spent!"

"The police have watched this Lascar," said Inspector Bradstreet, "and I can quite understand that he might find it difficult to post a letter unobserved. Probably he handed it to some sailor customer of his, who forgot all about it for some days."

"That was it," said Holmes, nodding approvingly; "I have no doubt of it. But have you never been prosecuted for begging?"

"Many times; but what was a fine to me?"

"It must stop here, however," said Bradstreet. "If the police are to hush this thing up, there must be no more of Hugh Boone."

"I have sworn it by the most solemn oaths which a man can take."

"In that case I think that it is probable that no further steps may be taken. But if you are found again, then all must come out. I am sure, Mr. Holmes, that we are very much indebted to you for having cleared the matter up. I wish I knew how you reach your results."

"I reached this one," said my friend, "by sitting upon five pillows and consuming an ounce of shag. I think, Watson, that if we drive to Baker Street we shall just be in time for breakfast."

VII.  THE ADVENTURE OF THE BLUE CARBUNCLE


I had called upon my friend Sherlock Holmes upon the second morning after Christmas, with the intention of wishing him the compliments of the season. He was lounging upon the sofa in a purple dressing-gown, a pipe-rack within his reach upon the right, and a pile of crumpled morning papers, evidently newly studied, near at hand. Beside the couch was a wooden chair, and on the angle of the back hung a very seedy and disreputable hard-felt hat, much the worse for wear, and cracked in several places. A lens and a forceps lying upon the seat of the chair suggested that the hat had been suspended in this manner for the purpose of examination.

"You are engaged," said I; "perhaps I interrupt you."

"Not at all. I am glad to have a friend with whom I can discuss my results. The matter is a perfectly trivial one"--he jerked his thumb in the direction of the old hat--"but there are points in connection with it which are not entirely devoid of interest and even of instruction."

I seated myself in his armchair and warmed my hands before his crackling fire, for a sharp frost had set in, and the windows were thick with the ice crystals. "I suppose," I remarked, "that, homely as it looks, this thing has some deadly story linked on to it--that it is the clue which will guide you in the solution of some mystery and the punishment of some crime."

"No, no. No crime," said Sherlock Holmes, laughing. "Only one of those whimsical little incidents which will happen when you have four million human beings all jostling each other within the space of a few square miles. Amid the action and reaction of so dense a swarm of humanity, every possible combination of events may be expected to take place, and many a little problem will be presented which may be striking and bizarre without being criminal. We have already had experience of such."

"So much so," I remarked, "that of the last six cases which I have added to my notes, three have been entirely free of any legal crime."

"Precisely. You allude to my attempt to recover the Irene Adler papers, to the singular case of Miss Mary Sutherland, and to the adventure of the man with the twisted lip. Well, I have no doubt that this small matter will fall into the same innocent category. You know Peterson, the commissionaire?"

"Yes."

"It is to him that this trophy belongs."

"It is his hat."

"No, no, he found it. Its owner is unknown. I beg that you will look upon it not as a battered billycock but as an intellectual problem. And, first, as to how it came here. It arrived upon Christmas morning, in company with a good fat goose, which is, I have no doubt, roasting at this moment in front of Peterson's fire. The facts are these: about four o'clock on Christmas morning, Peterson, who, as you know, is a very honest fellow, was returning from some small jollification and was making his way homeward down Tottenham Court Road. In front of him he saw, in the gaslight, a tallish man, walking with a slight stagger, and carrying a white goose slung over his shoulder. As he reached the corner of Goodge Street, a row broke out between this stranger and a little knot of roughs. One of the latter knocked off the man's hat, on which he raised his stick to defend himself and, swinging it over his head, smashed the shop window behind him. Peterson had rushed forward to protect the stranger from his assailants; but the man, shocked at having broken the window, and seeing an official-looking person in uniform rushing towards him, dropped his goose, took to his heels, and vanished amid the labyrinth of small streets which lie at the back of Tottenham Court Road. The roughs had also fled at the appearance of Peterson, so that he was left in possession of the field of battle, and also of the spoils of victory in the shape of this battered hat and a most unimpeachable Christmas goose."

"Which surely he restored to their owner?"

"My dear fellow, there lies the problem. It is true that 'For Mrs. Henry Baker' was printed upon a small card which was tied to the bird's left leg, and it is also true that the initials 'H. B.' are legible upon the lining of this hat, but as there are some thousands of Bakers, and some hundreds of Henry Bakers in this city of ours, it is not easy to restore lost property to any one of them."

"What, then, did Peterson do?"

"He brought round both hat and goose to me on Christmas morning, knowing that even the smallest problems are of interest to me. The goose we retained until this morning, when there were signs that, in spite of the slight frost, it would be well that it should be eaten without unnecessary delay. Its finder has carried it off, therefore, to fulfil the ultimate destiny of a goose, while I continue to retain the hat of the unknown gentleman who lost his Christmas dinner."

"Did he not advertise?"

"No."

"Then, what clue could you have as to his identity?"

"Only as much as we can deduce."

"From his hat?"

"Precisely."

"But you are joking. What can you gather from this old battered felt?"

"Here is my lens. You know my methods. What can you gather yourself as to the individuality of the man who has worn this article?"

I took the tattered object in my hands and turned it over rather ruefully. It was a very ordinary black hat of the usual round shape, hard and much the worse for wear. The lining had been of red silk, but was a good deal discoloured. There was no maker's name; but, as Holmes had remarked, the initials "H. B." were scrawled upon one side. It was pierced in the brim for a hat-securer, but the elastic was missing. For the rest, it was cracked, exceedingly dusty, and spotted in several places, although there seemed to have been some attempt to hide the discoloured patches by smearing them with ink.

"I can see nothing," said I, handing it back to my friend.

"On the contrary, Watson, you can see everything. You fail, however, to reason from what you see. You are too timid in drawing your inferences."

"Then, pray tell me what it is that you can infer from this hat?"

He picked it up and gazed at it in the peculiar introspective fashion which was characteristic of him. "It is perhaps less suggestive than it might have been," he remarked, "and yet there are a few inferences which are very distinct, and a few others which represent at least a strong balance of probability. That the man was highly intellectual is of course obvious upon the face of it, and also that he was fairly well-to-do within the last three years, although he has now fallen upon evil days. He had foresight, but has less now than formerly, pointing to a moral retrogression, which, when taken with the decline of his fortunes, seems to indicate some evil influence, probably drink, at work upon him. This may account also for the obvious fact that his wife has ceased to love him."

"My dear Holmes!"

"He has, however, retained some degree of self-respect," he continued, disregarding my remonstrance. "He is a man who leads a sedentary life, goes out little, is out of training entirely, is middle-aged, has grizzled hair which he has had cut within the last few days, and which he anoints with lime-cream. These are the more patent facts which are to be deduced from his hat. Also, by the way, that it is extremely improbable that he has gas laid on in his house."

"You are certainly joking, Holmes."

"Not in the least. Is it possible that even now, when I give you these results, you are unable to see how they are attained?"

"I have no doubt that I am very stupid, but I must confess that I am unable to follow you. For example, how did you deduce that this man was intellectual?"

For answer Holmes clapped the hat upon his head. It came right over the forehead and settled upon the bridge of his nose. "It is a question of cubic capacity," said he; "a man with so large a brain must have something in it."

"The decline of his fortunes, then?"

"This hat is three years old. These flat brims curled at the edge came in then. It is a hat of the very best quality. Look at the band of ribbed silk and the excellent lining. If this man could afford to buy so expensive a hat three years ago, and has had no hat since, then he has assuredly gone down in the world."

"Well, that is clear enough, certainly. But how about the foresight and the moral retrogression?"

Sherlock Holmes laughed. "Here is the foresight," said he putting his finger upon the little disc and loop of the hat-securer. "They are never sold upon hats. If this man ordered one, it is a sign of a certain amount of foresight, since he went out of his way to take this precaution against the wind. But since we see that he has broken the elastic and has not troubled to replace it, it is obvious that he has less foresight now than formerly, which is a distinct proof of a weakening nature. On the other hand, he has endeavoured to conceal some of these stains upon the felt by daubing them with ink, which is a sign that he has not entirely lost his self-respect."

"Your reasoning is certainly plausible."

"The further points, that he is middle-aged, that his hair is grizzled, that it has been recently cut, and that he uses lime-cream, are all to be gathered from a close examination of the lower part of the lining. The lens discloses a large number of hair-ends, clean cut by the scissors of the barber. They all appear to be adhesive, and there is a distinct odour of lime-cream. This dust, you will observe, is not the gritty, grey dust of the street but the fluffy brown dust of the house, showing that it has been hung up indoors most of the time, while the marks of moisture upon the inside are proof positive that the wearer perspired very freely, and could therefore, hardly be in the best of training."

"But his wife--you said that she had ceased to love him."

"This hat has not been brushed for weeks. When I see you, my dear Watson, with a week's accumulation of dust upon your hat, and when your wife allows you to go out in such a state, I shall fear that you also have been unfortunate enough to lose your wife's affection."

"But he might be a bachelor."

"Nay, he was bringing home the goose as a peace-offering to his wife. Remember the card upon the bird's leg."

"You have an answer to everything. But how on earth do you deduce that the gas is not laid on in his house?"

"One tallow stain, or even two, might come by chance; but when I see no less than five, I think that there can be little doubt that the individual must be brought into frequent contact with burning tallow--walks upstairs at night probably with his hat in one hand and a guttering candle in the other. Anyhow, he never got tallow-stains from a gas-jet. Are you satisfied?"

"Well, it is very ingenious," said I, laughing; "but since, as you said just now, there has been no crime committed, and no harm done save the loss of a goose, all this seems to be rather a waste of energy."

Sherlock Holmes had opened his mouth to reply, when the door flew open, and Peterson, the commissionaire, rushed into the apartment with flushed cheeks and the face of a man who is dazed with astonishment.

"The goose, Mr. Holmes! The goose, sir!" he gasped.

"Eh? What of it, then? Has it returned to life and flapped off through the kitchen window?" Holmes twisted himself round upon the sofa to get a fairer view of the man's excited face.

"See here, sir! See what my wife found in its crop!" He held out his hand and displayed upon the centre of the palm a brilliantly scintillating blue stone, rather smaller than a bean in size, but of such purity and radiance that it twinkled like an electric point in the dark hollow of his hand.

Sherlock Holmes sat up with a whistle. "By Jove, Peterson!" said he, "this is treasure trove indeed. I suppose you know what you have got?"

"A diamond, sir? A precious stone. It cuts into glass as though it were putty."

"It's more than a precious stone. It is the precious stone."

"Not the Countess of Morcar's blue carbuncle!" I ejaculated.

"Precisely so. I ought to know its size and shape, seeing that I have read the advertisement about it in The Times every day lately. It is absolutely unique, and its value can only be conjectured, but the reward offered of $1000 is certainly not within a twentieth part of the market price."

"A thousand pounds! Great Lord of mercy!" The commissionaire plumped down into a chair and stared from one to the other of us.

"That is the reward, and I have reason to know that there are sentimental considerations in the background which would induce the Countess to part with half her fortune if she could but recover the gem."

"It was lost, if I remember aright, at the Hotel Cosmopolitan," I remarked.

"Precisely so, on December 22nd, just five days ago. John Horner, a plumber, was accused of having abstracted it from the lady's jewel-case. The evidence against him was so strong that the case has been referred to the Assizes. I have some account of the matter here, I believe." He rummaged amid his newspapers, glancing over the dates, until at last he smoothed one out, doubled it over, and read the following paragraph:

"Hotel Cosmopolitan Jewel Robbery. John Horner, 26, plumber, was brought up upon the charge of having upon the 22nd inst., abstracted from the jewel-case of the Countess of Morcar the valuable gem known as the blue carbuncle. James Ryder, upper-attendant at the hotel, gave his evidence to the effect that he had shown Horner up to the dressing-room of the Countess of Morcar upon the day of the robbery in order that he might solder the second bar of the grate, which was loose. He had remained with Horner some little time, but had finally been called away. On returning, he found that Horner had disappeared, that the bureau had been forced open, and that the small morocco casket in which, as it afterwards transpired, the Countess was accustomed to keep her jewel, was lying empty upon the dressing-table. Ryder instantly gave the alarm, and Horner was arrested the same evening; but the stone could not be found either upon his person or in his rooms. Catherine Cusack, maid to the Countess, deposed to having heard Ryder's cry of dismay on discovering the robbery, and to having rushed into the room, where she found matters as described by the last witness. Inspector Bradstreet, B division, gave evidence as to the arrest of Horner, who struggled frantically, and protested his innocence in the strongest terms. Evidence of a previous conviction for robbery having been given against the prisoner, the magistrate refused to deal summarily with the offence, but referred it to the Assizes. Horner, who had shown signs of intense emotion during the proceedings, fainted away at the conclusion and was carried out of court."

"Hum! So much for the police-court," said Holmes thoughtfully, tossing aside the paper. "The question for us now to solve is the sequence of events leading from a rifled jewel-case at one end to the crop of a goose in Tottenham Court Road at the other. You see, Watson, our little deductions have suddenly assumed a much more important and less innocent aspect. Here is the stone; the stone came from the goose, and the goose came from Mr. Henry Baker, the gentleman with the bad hat and all the other characteristics with which I have bored you. So now we must set ourselves very seriously to finding this gentleman and ascertaining what part he has played in this little mystery. To do this, we must try the simplest means first, and these lie undoubtedly in an advertisement in all the evening papers. If this fail, I shall have recourse to other methods."

"What will you say?"

"Give me a pencil and that slip of paper. Now, then: 'Found at the corner of Goodge Street, a goose and a black felt hat. Mr. Henry Baker can have the same by applying at 6:30 this evening at 221B, Baker Street.' That is clear and concise."

"Very. But will he see it?"

"Well, he is sure to keep an eye on the papers, since, to a poor man, the loss was a heavy one. He was clearly so scared by his mischance in breaking the window and by the approach of Peterson that he thought of nothing but flight, but since then he must have bitterly regretted the impulse which caused him to drop his bird. Then, again, the introduction of his name will cause him to see it, for everyone who knows him will direct his attention to it. Here you are, Peterson, run down to the advertising agency and have this put in the evening papers."

"In which, sir?"

"Oh, in the Globe, Star, Pall Mall, St. James's, Evening News, Standard, Echo, and any others that occur to you."

"Very well, sir. And this stone?"

"Ah, yes, I shall keep the stone. Thank you. And, I say, Peterson, just buy a goose on your way back and leave it here with me, for we must have one to give to this gentleman in place of the one which your family is now devouring."

When the commissionaire had gone, Holmes took up the stone and held it against the light. "It's a bonny thing," said he. "Just see how it glints and sparkles. Of course it is a nucleus and focus of crime. Every good stone is. They are the devil's pet baits. In the larger and older jewels every facet may stand for a bloody deed. This stone is not yet twenty years old. It was found in the banks of the Amoy River in southern China and is remarkable in having every characteristic of the carbuncle, save that it is blue in shade instead of ruby red. In spite of its youth, it has already a sinister history. There have been two murders, a vitriol-throwing, a suicide, and several robberies brought about for the sake of this forty-grain weight of crystallised charcoal. Who would think that so pretty a toy would be a purveyor to the gallows and the prison? I'll lock it up in my strong box now and drop a line to the Countess to say that we have it."

"Do you think that this man Horner is innocent?"

"I cannot tell."

"Well, then, do you imagine that this other one, Henry Baker, had anything to do with the matter?"

"It is, I think, much more likely that Henry Baker is an absolutely innocent man, who had no idea that the bird which he was carrying was of considerably more value than if it were made of solid gold. That, however, I shall determine by a very simple test if we have an answer to our advertisement."

"And you can do nothing until then?"

"Nothing."

"In that case I shall continue my professional round. But I shall come back in the evening at the hour you have mentioned, for I should like to see the solution of so tangled a business."

"Very glad to see you. I dine at seven. There is a woodcock, I believe. By the way, in view of recent occurrences, perhaps I ought to ask Mrs. Hudson to examine its crop."

I had been delayed at a case, and it was a little after half-past six when I found myself in Baker Street once more. As I approached the house I saw a tall man in a Scotch bonnet with a coat which was buttoned up to his chin waiting outside in the bright semicircle which was thrown from the fanlight. Just as I arrived the door was opened, and we were shown up together to Holmes' room.

"Mr. Henry Baker, I believe," said he, rising from his armchair and greeting his visitor with the easy air of geniality which he could so readily assume. "Pray take this chair by the fire, Mr. Baker. It is a cold night, and I observe that your circulation is more adapted for summer than for winter. Ah, Watson, you have just come at the right time. Is that your hat, Mr. Baker?"

"Yes, sir, that is undoubtedly my hat."

He was a large man with rounded shoulders, a massive head, and a broad, intelligent face, sloping down to a pointed beard of grizzled brown. A touch of red in nose and cheeks, with a slight tremor of his extended hand, recalled Holmes' surmise as to his habits. His rusty black frock-coat was buttoned right up in front, with the collar turned up, and his lank wrists protruded from his sleeves without a sign of cuff or shirt. He spoke in a slow staccato fashion, choosing his words with care, and gave the impression generally of a man of learning and letters who had had ill-usage at the hands of fortune.

"We have retained these things for some days," said Holmes, "because we expected to see an advertisement from you giving your address. I am at a loss to know now why you did not advertise."

Our visitor gave a rather shamefaced laugh. "Shillings have not been so plentiful with me as they once were," he remarked. "I had no doubt that the gang of roughs who assaulted me had carried off both my hat and the bird. I did not care to spend more money in a hopeless attempt at recovering them."

"Very naturally. By the way, about the bird, we were compelled to eat it."

"To eat it!" Our visitor half rose from his chair in his excitement.

"Yes, it would have been of no use to anyone had we not done so. But I presume that this other goose upon the sideboard, which is about the same weight and perfectly fresh, will answer your purpose equally well?"

"Oh, certainly, certainly," answered Mr. Baker with a sigh of relief.

"Of course, we still have the feathers, legs, crop, and so on of your own bird, so if you wish--"

The man burst into a hearty laugh. "They might be useful to me as relics of my adventure," said he, "but beyond that I can hardly see what use the disjecta membra of my late acquaintance are going to be to me. No, sir, I think that, with your permission, I will confine my attentions to the excellent bird which I perceive upon the sideboard."

Sherlock Holmes glanced sharply across at me with a slight shrug of his shoulders.

"There is your hat, then, and there your bird," said he. "By the way, would it bore you to tell me where you got the other one from? I am somewhat of a fowl fancier, and I have seldom seen a better grown goose."

"Certainly, sir," said Baker, who had risen and tucked his newly gained property under his arm. "There are a few of us who frequent the Alpha Inn, near the Museum--we are to be found in the Museum itself during the day, you understand. This year our good host, Windigate by name, instituted a goose club, by which, on consideration of some few pence every week, we were each to receive a bird at Christmas. My pence were duly paid, and the rest is familiar to you. I am much indebted to you, sir, for a Scotch bonnet is fitted neither to my years nor my gravity." With a comical pomposity of manner he bowed solemnly to both of us and strode off upon his way.

"So much for Mr. Henry Baker," said Holmes when he had closed the door behind him. "It is quite certain that he knows nothing whatever about the matter. Are you hungry, Watson?"

"Not particularly."

"Then I suggest that we turn our dinner into a supper and follow up this clue while it is still hot."

"By all means."

It was a bitter night, so we drew on our ulsters and wrapped cravats about our throats. Outside, the stars were shining coldly in a cloudless sky, and the breath of the passers-by blew out into smoke like so many pistol shots. Our footfalls rang out crisply and loudly as we swung through the doctors' quarter, Wimpole Street, Harley Street, and so through Wigmore Street into Oxford Street. In a quarter of an hour we were in Bloomsbury at the Alpha Inn, which is a small public-house at the corner of one of the streets which runs down into Holborn. Holmes pushed open the door of the private bar and ordered two glasses of beer from the ruddy-faced, white-aproned landlord.

"Your beer should be excellent if it is as good as your geese," said he.

"My geese!" The man seemed surprised.

"Yes. I was speaking only half an hour ago to Mr. Henry Baker, who was a member of your goose club."

"Ah! yes, I see. But you see, sir, them's not our geese."

"Indeed! Whose, then?"

"Well, I got the two dozen from a salesman in Covent Garden."

"Indeed? I know some of them. Which was it?"

"Breckinridge is his name."

"Ah! I don't know him. Well, here's your good health landlord, and prosperity to your house. Good-night."

"Now for Mr. Breckinridge," he continued, buttoning up his coat as we came out into the frosty air. "Remember, Watson that though we have so homely a thing as a goose at one end of this chain, we have at the other a man who will certainly get seven years' penal servitude unless we can establish his innocence. It is possible that our inquiry may but confirm his guilt; but, in any case, we have a line of investigation which has been missed by the police, and which a singular chance has placed in our hands. Let us follow it out to the bitter end. Faces to the south, then, and quick march!"

We passed across Holborn, down Endell Street, and so through a zigzag of slums to Covent Garden Market. One of the largest stalls bore the name of Breckinridge upon it, and the proprietor a horsey-looking man, with a sharp face and trim side-whiskers was helping a boy to put up the shutters.

"Good-evening. It's a cold night," said Holmes.

The salesman nodded and shot a questioning glance at my companion.

"Sold out of geese, I see," continued Holmes, pointing at the bare slabs of marble.

"Let you have five hundred to-morrow morning."

"That's no good."

"Well, there are some on the stall with the gas-flare."

"Ah, but I was recommended to you."

"Who by?"

"The landlord of the Alpha."

"Oh, yes; I sent him a couple of dozen."

"Fine birds they were, too. Now where did you get them from?"

To my surprise the question provoked a burst of anger from the salesman.

"Now, then, mister," said he, with his head cocked and his arms akimbo, "what are you driving at? Let's have it straight, now."

"It is straight enough. I should like to know who sold you the geese which you supplied to the Alpha."

"Well then, I shan't tell you. So now!"

"Oh, it is a matter of no importance; but I don't know why you should be so warm over such a trifle."

"Warm! You'd be as warm, maybe, if you were as pestered as I am. When I pay good money for a good article there should be an end of the business; but it's 'Where are the geese?' and 'Who did you sell the geese to?' and 'What will you take for the geese?' One would think they were the only geese in the world, to hear the fuss that is made over them."

"Well, I have no connection with any other people who have been making inquiries," said Holmes carelessly. "If you won't tell us the bet is off, that is all. But I'm always ready to back my opinion on a matter of fowls, and I have a fiver on it that the bird I ate is country bred."

"Well, then, you've lost your fiver, for it's town bred," snapped the salesman.

"It's nothing of the kind."

"I say it is."

"I don't believe it."

"D'you think you know more about fowls than I, who have handled them ever since I was a nipper? I tell you, all those birds that went to the Alpha were town bred."

"You'll never persuade me to believe that."

"Will you bet, then?"

"It's merely taking your money, for I know that I am right. But I'll have a sovereign on with you, just to teach you not to be obstinate."

The salesman chuckled grimly. "Bring me the books, Bill," said he.

The small boy brought round a small thin volume and a great greasy-backed one, laying them out together beneath the hanging lamp.

"Now then, Mr. Cocksure," said the salesman, "I thought that I was out of geese, but before I finish you'll find that there is still one left in my shop. You see this little book?"

"Well?"

"That's the list of the folk from whom I buy. D'you see? Well, then, here on this page are the country folk, and the numbers after their names are where their accounts are in the big ledger. Now, then! You see this other page in red ink? Well, that is a list of my town suppliers. Now, look at that third name. Just read it out to me."

"Mrs. Oakshott, 117, Brixton Road--249," read Holmes.

"Quite so. Now turn that up in the ledger."

Holmes turned to the page indicated. "Here you are, 'Mrs. Oakshott, 117, Brixton Road, egg and poultry supplier.' "

"Now, then, what's the last entry?"

" 'December 22nd. Twenty-four geese at 7s. 6d.' "

"Quite so. There you are. And underneath?"

" 'Sold to Mr. Windigate of the Alpha, at 12s.' "

"What have you to say now?"

Sherlock Holmes looked deeply chagrined. He drew a sovereign from his pocket and threw it down upon the slab, turning away with the air of a man whose disgust is too deep for words. A few yards off he stopped under a lamp-post and laughed in the hearty, noiseless fashion which was peculiar to him.

"When you see a man with whiskers of that cut and the 'Pink 'un' protruding out of his pocket, you can always draw him by a bet," said he. "I daresay that if I had put $100 down in front of him, that man would not have given me such complete information as was drawn from him by the idea that he was doing me on a wager. Well, Watson, we are, I fancy, nearing the end of our quest, and the only point which remains to be determined is whether we should go on to this Mrs. Oakshott to-night, or whether we should reserve it for to-morrow. It is clear from what that surly fellow said that there are others besides ourselves who are anxious about the matter, and I should--"

His remarks were suddenly cut short by a loud hubbub which broke out from the stall which we had just left. Turning round we saw a little rat-faced fellow standing in the centre of the circle of yellow light which was thrown by the swinging lamp, while Breckinridge, the salesman, framed in the door of his stall, was shaking his fists fiercely at the cringing figure.

"I've had enough of you and your geese," he shouted. "I wish you were all at the devil together. If you come pestering me any more with your silly talk I'll set the dog at you. You bring Mrs. Oakshott here and I'll answer her, but what have you to do with it? Did I buy the geese off you?"

"No; but one of them was mine all the same," whined the little man.

"Well, then, ask Mrs. Oakshott for it."

"She told me to ask you."

"Well, you can ask the King of Proosia, for all I care. I've had enough of it. Get out of this!" He rushed fiercely forward, and the inquirer flitted away into the darkness.

"Ha! this may save us a visit to Brixton Road," whispered Holmes. "Come with me, and we will see what is to be made of this fellow." Striding through the scattered knots of people who lounged round the flaring stalls, my companion speedily overtook the little man and touched him upon the shoulder. He sprang round, and I could see in the gas-light that every vestige of colour had been driven from his face.

"Who are you, then? What do you want?" he asked in a quavering voice.

"You will excuse me," said Holmes blandly, "but I could not help overhearing the questions which you put to the salesman just now. I think that I could be of assistance to you."

"You? Who are you? How could you know anything of the matter?"

"My name is Sherlock Holmes. It is my business to know what other people don't know."

"But you can know nothing of this?"

"Excuse me, I know everything of it. You are endeavouring to trace some geese which were sold by Mrs. Oakshott, of Brixton Road, to a salesman named Breckinridge, by him in turn to Mr. Windigate, of the Alpha, and by him to his club, of which Mr. Henry Baker is a member."

"Oh, sir, you are the very man whom I have longed to meet," cried the little fellow with outstretched hands and quivering fingers. "I can hardly explain to you how interested I am in this matter."

Sherlock Holmes hailed a four-wheeler which was passing. "In that case we had better discuss it in a cosy room rather than in this wind-swept market-place," said he. "But pray tell me, before we go farther, who it is that I have the pleasure of assisting."

The man hesitated for an instant. "My name is John Robinson," he answered with a sidelong glance.

"No, no; the real name," said Holmes sweetly. "It is always awkward doing business with an alias."

A flush sprang to the white cheeks of the stranger. "Well then," said he, "my real name is James Ryder."

"Precisely so. Head attendant at the Hotel Cosmopolitan. Pray step into the cab, and I shall soon be able to tell you everything which you would wish to know."

The little man stood glancing from one to the other of us with half-frightened, half-hopeful eyes, as one who is not sure whether he is on the verge of a windfall or of a catastrophe. Then he stepped into the cab, and in half an hour we were back in the sitting-room at Baker Street. Nothing had been said during our drive, but the high, thin breathing of our new companion, and the claspings and unclaspings of his hands, spoke of the nervous tension within him.

"Here we are!" said Holmes cheerily as we filed into the room. "The fire looks very seasonable in this weather. You look cold, Mr. Ryder. Pray take the basket-chair. I will just put on my slippers before we settle this little matter of yours. Now, then! You want to know what became of those geese?"

"Yes, sir."

"Or rather, I fancy, of that goose. It was one bird, I imagine in which you were interested--white, with a black bar across the tail."

Ryder quivered with emotion. "Oh, sir," he cried, "can you tell me where it went to?"

"It came here."

"Here?"

"Yes, and a most remarkable bird it proved. I don't wonder that you should take an interest in it. It laid an egg after it was dead--the bonniest, brightest little blue egg that ever was seen. I have it here in my museum."

Our visitor staggered to his feet and clutched the mantelpiece with his right hand. Holmes unlocked his strong-box and held up the blue carbuncle, which shone out like a star, with a cold, brilliant, many-pointed radiance. Ryder stood glaring with a drawn face, uncertain whether to claim or to disown it.

"The game's up, Ryder," said Holmes quietly. "Hold up, man, or you'll be into the fire! Give him an arm back into his chair, Watson. He's not got blood enough to go in for felony with impunity. Give him a dash of brandy. So! Now he looks a little more human. What a shrimp it is, to be sure!"

For a moment he had staggered and nearly fallen, but the brandy brought a tinge of colour into his cheeks, and he sat staring with frightened eyes at his accuser.

"I have almost every link in my hands, and all the proofs which I could possibly need, so there is little which you need tell me. Still, that little may as well be cleared up to make the case complete. You had heard, Ryder, of this blue stone of the Countess of Morcar's?"

"It was Catherine Cusack who told me of it," said he in a crackling voice.

"I see--her ladyship's waiting-maid. Well, the temptation of sudden wealth so easily acquired was too much for you, as it has been for better men before you; but you were not very scrupulous in the means you used. It seems to me, Ryder, that there is the making of a very pretty villain in you. You knew that this man Horner, the plumber, had been concerned in some such matter before, and that suspicion would rest the more readily upon him. What did you do, then? You made some small job in my lady's room--you and your confederate Cusack--and you managed that he should be the man sent for. Then, when he had left, you rifled the jewel-case, raised the alarm, and had this unfortunate man arrested. You then--"

Ryder threw himself down suddenly upon the rug and clutched at my companion's knees. "For God's sake, have mercy!" he shrieked. "Think of my father! Of my mother! It would break their hearts. I never went wrong before! I never will again. I swear it. I'll swear it on a Bible. Oh, don't bring it into court! For Christ's sake, don't!"

"Get back into your chair!" said Holmes sternly. "It is very well to cringe and crawl now, but you thought little enough of this poor Horner in the dock for a crime of which he knew nothing."

"I will fly, Mr. Holmes. I will leave the country, sir. Then the charge against him will break down."

"Hum! We will talk about that. And now let us hear a true account of the next act. How came the stone into the goose, and how came the goose into the open market? Tell us the truth, for there lies your only hope of safety."

Ryder passed his tongue over his parched lips. "I will tell you it just as it happened, sir," said he. "When Horner had been arrested, it seemed to me that it would be best for me to get away with the stone at once, for I did not know at what moment the police might not take it into their heads to search me and my room. There was no place about the hotel where it would be safe. I went out, as if on some commission, and I made for my sister's house. She had married a man named Oakshott, and lived in Brixton Road, where she fattened fowls for the market. All the way there every man I met seemed to me to be a policeman or a detective; and, for all that it was a cold night, the sweat was pouring down my face before I came to the Brixton Road. My sister asked me what was the matter, and why I was so pale; but I told her that I had been upset by the jewel robbery at the hotel. Then I went into the back yard and smoked a pipe and wondered what it would be best to do.

"I had a friend once called Maudsley, who went to the bad, and has just been serving his time in Pentonville. One day he had met me, and fell into talk about the ways of thieves, and how they could get rid of what they stole. I knew that he would be true to me, for I knew one or two things about him; so I made up my mind to go right on to Kilburn, where he lived, and take him into my confidence. He would show me how to turn the stone into money. But how to get to him in safety? I thought of the agonies I had gone through in coming from the hotel. I might at any moment be seized and searched, and there would be the stone in my waistcoat pocket. I was leaning against the wall at the time and looking at the geese which were waddling about round my feet, and suddenly an idea came into my head which showed me how I could beat the best detective that ever lived.

"My sister had told me some weeks before that I might have the pick of her geese for a Christmas present, and I knew that she was always as good as her word. I would take my goose now, and in it I would carry my stone to Kilburn. There was a little shed in the yard, and behind this I drove one of the birds--a fine big one, white, with a barred tail. I caught it, and prying its bill open, I thrust the stone down its throat as far as my finger could reach. The bird gave a gulp, and I felt the stone pass along its gullet and down into its crop. But the creature flapped and struggled, and out came my sister to know what was the matter. As I turned to speak to her the brute broke loose and fluttered off among the others.

" 'Whatever were you doing with that bird, Jem?' says she.

" 'Well,' said I, 'you said you'd give me one for Christmas, and I was feeling which was the fattest.'

" 'Oh,' says she, 'we've set yours aside for you--Jem's bird, we call it. It's the big white one over yonder. There's twenty-six of them, which makes one for you, and one for us, and two dozen for the market.'

" 'Thank you, Maggie,' says I; 'but if it is all the same to you, I'd rather have that one I was handling just now.'

" 'The other is a good three pound heavier,' said she, 'and we fattened it expressly for you.'

" 'Never mind. I'll have the other, and I'll take it now,' said I.

" 'Oh, just as you like,' said she, a little huffed. 'Which is it you want, then?'

" 'That white one with the barred tail, right in the middle of the flock.'

" 'Oh, very well. Kill it and take it with you.'

"Well, I did what she said, Mr. Holmes, and I carried the bird all the way to Kilburn. I told my pal what I had done, for he was a man that it was easy to tell a thing like that to. He laughed until he choked, and we got a knife and opened the goose. My heart turned to water, for there was no sign of the stone, and I knew that some terrible mistake had occurred. I left the bird, rushed back to my sister's, and hurried into the back yard. There was not a bird to be seen there.

" 'Where are they all, Maggie?' I cried.

" 'Gone to the dealer's, Jem.'

" 'Which dealer's?'

" 'Breckinridge, of Covent Garden.'

" 'But was there another with a barred tail?' I asked, 'the same as the one I chose?'

" 'Yes, Jem; there were two barred-tailed ones, and I could never tell them apart.'

"Well, then, of course I saw it all, and I ran off as hard as my feet would carry me to this man Breckinridge; but he had sold the lot at once, and not one word would he tell me as to where they had gone. You heard him yourselves to-night. Well, he has always answered me like that. My sister thinks that I am going mad. Sometimes I think that I am myself. And now--and now I am myself a branded thief, without ever having touched the wealth for which I sold my character. God help me! God help me!" He burst into convulsive sobbing, with his face buried in his hands.

There was a long silence, broken only by his heavy breathing and by the measured tapping of Sherlock Holmes' finger-tips upon the edge of the table. Then my friend rose and threw open the door.

"Get out!" said he.

"What, sir! Oh, Heaven bless you!"

"No more words. Get out!"

And no more words were needed. There was a rush, a clatter upon the stairs, the bang of a door, and the crisp rattle of running footfalls from the street.

"After all, Watson," said Holmes, reaching up his hand for his clay pipe, "I am not retained by the police to supply their deficiencies. If Horner were in danger it would be another thing; but this fellow will not appear against him, and the case must collapse. I suppose that I am commuting a felony, but it is just possible that I am saving a soul. This fellow will not go wrong again; he is too terribly frightened. Send him to gaol now, and you make him a gaol-bird for life. Besides, it is the season of forgiveness. Chance has put in our way a most singular and whimsical problem, and its solution is its own reward. If you will have the goodness to touch the bell, Doctor, we will begin another investigation, in which, also a bird will be the chief feature."

VIII.  THE ADVENTURE OF THE SPECKLED BAND


On glancing over my notes of the seventy odd cases in which I have during the last eight years studied the methods of my friend Sherlock Holmes, I find many tragic, some comic, a large number merely strange, but none commonplace; for, working as he did rather for the love of his art than for the acquirement of wealth, he refused to associate himself with any investigation which did not tend towards the unusual, and even the fantastic. Of all these varied cases, however, I cannot recall any which presented more singular features than that which was associated with the well-known Surrey family of the Roylotts of Stoke Moran. The events in question occurred in the early days of my association with Holmes, when we were sharing rooms as bachelors in Baker Street. It is possible that I might have placed them upon record before, but a promise of secrecy was made at the time, from which I have only been freed during the last month by the untimely death of the lady to whom the pledge was given. It is perhaps as well that the facts should now come to light, for I have reasons to know that there are widespread rumours as to the death of Dr. Grimesby Roylott which tend to make the matter even more terrible than the truth.

It was early in April in the year '83 that I woke one morning to find Sherlock Holmes standing, fully dressed, by the side of my bed. He was a late riser, as a rule, and as the clock on the mantelpiece showed me that it was only a quarter-past seven, I blinked up at him in some surprise, and perhaps just a little resentment, for I was myself regular in my habits.

"Very sorry to knock you up, Watson," said he, "but it's the common lot this morning. Mrs. Hudson has been knocked up, she retorted upon me, and I on you."

"What is it, then--a fire?"

"No; a client. It seems that a young lady has arrived in a considerable state of excitement, who insists upon seeing me. She is waiting now in the sitting-room. Now, when young ladies wander about the metropolis at this hour of the morning, and knock sleepy people up out of their beds, I presume that it is something very pressing which they have to communicate. Should it prove to be an interesting case, you would, I am sure, wish to follow it from the outset. I thought, at any rate, that I should call you and give you the chance."

"My dear fellow, I would not miss it for anything."

I had no keener pleasure than in following Holmes in his professional investigations, and in admiring the rapid deductions, as swift as intuitions, and yet always founded on a logical basis with which he unravelled the problems which were submitted to him. I rapidly threw on my clothes and was ready in a few minutes to accompany my friend down to the sitting-room. A lady dressed in black and heavily veiled, who had been sitting in the window, rose as we entered.

"Good-morning, madam," said Holmes cheerily. "My name is Sherlock Holmes. This is my intimate friend and associate, Dr. Watson, before whom you can speak as freely as before myself. Ha! I am glad to see that Mrs. Hudson has had the good sense to light the fire. Pray draw up to it, and I shall order you a cup of hot coffee, for I observe that you are shivering."

"It is not cold which makes me shiver," said the woman in a low voice, changing her seat as requested.

"What, then?"

"It is fear, Mr. Holmes. It is terror." She raised her veil as she spoke, and we could see that she was indeed in a pitiable state of agitation, her face all drawn and grey, with restless frightened eyes, like those of some hunted animal. Her features and figure were those of a woman of thirty, but her hair was shot with premature grey, and her expression was weary and haggard. Sherlock Holmes ran her over with one of his quick, all-comprehensive glances.

"You must not fear," said he soothingly, bending forward and patting her forearm. "We shall soon set matters right, I have no doubt. You have come in by train this morning, I see."

"You know me, then?"

"No, but I observe the second half of a return ticket in the palm of your left glove. You must have started early, and yet you had a good drive in a dog-cart, along heavy roads, before you reached the station."

The lady gave a violent start and stared in bewilderment at my companion.

"There is no mystery, my dear madam," said he, smiling. "The left arm of your jacket is spattered with mud in no less than seven places. The marks are perfectly fresh. There is no vehicle save a dog-cart which throws up mud in that way, and then only when you sit on the left-hand side of the driver."

"Whatever your reasons may be, you are perfectly correct," said she. "I started from home before six, reached Leatherhead at twenty past, and came in by the first train to Waterloo. Sir, I can stand this strain no longer; I shall go mad if it continues. I have no one to turn to--none, save only one, who cares for me, and he, poor fellow, can be of little aid. I have heard of you, Mr. Holmes; I have heard of you from Mrs. Farintosh, whom you helped in the hour of her sore need. It was from her that I had your address. Oh, sir, do you not think that you could help me, too, and at least throw a little light through the dense darkness which surrounds me? At present it is out of my power to reward you for your services, but in a month or six weeks I shall be married, with the control of my own income, and then at least you shall not find me ungrateful."

Holmes turned to his desk and, unlocking it, drew out a small case-book, which he consulted.

"Farintosh," said he. "Ah yes, I recall the case; it was concerned with an opal tiara. I think it was before your time, Watson. I can only say, madam, that I shall be happy to devote the same care to your case as I did to that of your friend. As to reward, my profession is its own reward; but you are at liberty to defray whatever expenses I may be put to, at the time which suits you best. And now I beg that you will lay before us everything that may help us in forming an opinion upon the matter."

"Alas!" replied our visitor, "the very horror of my situation lies in the fact that my fears are so vague, and my suspicions depend so entirely upon small points, which might seem trivial to another, that even he to whom of all others I have a right to look for help and advice looks upon all that I tell him about it as the fancies of a nervous woman. He does not say so, but I can read it from his soothing answers and averted eyes. But I have heard, Mr. Holmes, that you can see deeply into the manifold wickedness of the human heart. You may advise me how to walk amid the dangers which encompass me."

"I am all attention, madam."

"My name is Helen Stoner, and I am living with my stepfather, who is the last survivor of one of the oldest Saxon families in England, the Roylotts of Stoke Moran, on the western border of Surrey."

Holmes nodded his head. "The name is familiar to me," said he.

"The family was at one time among the richest in England, and the estates extended over the borders into Berkshire in the north, and Hampshire in the west. In the last century, however, four successive heirs were of a dissolute and wasteful disposition, and the family ruin was eventually completed by a gambler in the days of the Regency. Nothing was left save a few acres of ground, and the two-hundred-year-old house, which is itself crushed under a heavy mortgage. The last squire dragged out his existence there, living the horrible life of an aristocratic pauper; but his only son, my stepfather, seeing that he must adapt himself to the new conditions, obtained an advance from a relative, which enabled him to take a medical degree and went out to Calcutta, where, by his professional skill and his force of character, he established a large practice. In a fit of anger, however, caused by some robberies which had been perpetrated in the house, he beat his native butler to death and narrowly escaped a capital sentence. As it was, he suffered a long term of imprisonment and afterwards returned to England a morose and disappointed man.

"When Dr. Roylott was in India he married my mother, Mrs. Stoner, the young widow of Major-General Stoner, of the Bengal Artillery. My sister Julia and I were twins, and we were only two years old at the time of my mother's re-marriage. She had a considerable sum of money--not less than $1000 a year--and this she bequeathed to Dr. Roylott entirely while we resided with him, with a provision that a certain annual sum should be allowed to each of us in the event of our marriage. Shortly after our return to England my mother died--she was killed eight years ago in a railway accident near Crewe. Dr. Roylott then abandoned his attempts to establish himself in practice in London and took us to live with him in the old ancestral house at Stoke Moran. The money which my mother had left was enough for all our wants, and there seemed to be no obstacle to our happiness.

"But a terrible change came over our stepfather about this time. Instead of making friends and exchanging visits with our neighbours, who had at first been overjoyed to see a Roylott of Stoke Moran back in the old family seat, he shut himself up in his house and seldom came out save to indulge in ferocious quarrels with whoever might cross his path. Violence of temper approaching to mania has been hereditary in the men of the family, and in my stepfather's case it had, I believe, been intensified by his long residence in the tropics. A series of disgraceful brawls took place, two of which ended in the police-court, until at last he became the terror of the village, and the folks would fly at his approach, for he is a man of immense strength, and absolutely uncontrollable in his anger.

"Last week he hurled the local blacksmith over a parapet into a stream, and it was only by paying over all the money which I could gather together that I was able to avert another public exposure. He had no friends at all save the wandering gipsies, and he would give these vagabonds leave to encamp upon the few acres of bramble-covered land which represent the family estate, and would accept in return the hospitality of their tents, wandering away with them sometimes for weeks on end. He has a passion also for Indian animals, which are sent over to him by a correspondent, and he has at this moment a cheetah and a baboon, which wander freely over his grounds and are feared by the villagers almost as much as their master.

"You can imagine from what I say that my poor sister Julia and I had no great pleasure in our lives. No servant would stay with us, and for a long time we did all the work of the house. She was but thirty at the time of her death, and yet her hair had already begun to whiten, even as mine has."

"Your sister is dead, then?"

"She died just two years ago, and it is of her death that I wish to speak to you. You can understand that, living the life which I have described, we were little likely to see anyone of our own age and position. We had, however, an aunt, my mother's maiden sister, Miss Honoria Westphail, who lives near Harrow, and we were occasionally allowed to pay short visits at this lady's house. Julia went there at Christmas two years ago, and met there a half-pay major of marines, to whom she became engaged. My stepfather learned of the engagement when my sister returned and offered no objection to the marriage; but within a fortnight of the day which had been fixed for the wedding, the terrible event occurred which has deprived me of my only companion."

Sherlock Holmes had been leaning back in his chair with his eyes closed and his head sunk in a cushion, but he half opened his lids now and glanced across at his visitor.

"Pray be precise as to details," said he.

"It is easy for me to be so, for every event of that dreadful time is seared into my memory. The manor-house is, as I have already said, very old, and only one wing is now inhabited. The bedrooms in this wing are on the ground floor, the sitting-rooms being in the central block of the buildings. Of these bedrooms the first is Dr. Roylott's, the second my sister's, and the third my own. There is no communication between them, but they all open out into the same corridor. Do I make myself plain?"

"Perfectly so."

"The windows of the three rooms open out upon the lawn. That fatal night Dr. Roylott had gone to his room early, though we knew that he had not retired to rest, for my sister was troubled by the smell of the strong Indian cigars which it was his custom to smoke. She left her room, therefore, and came into mine, where she sat for some time, chatting about her approaching wedding. At eleven o'clock she rose to leave me, but she paused at the door and looked back.

" 'Tell me, Helen,' said she, 'have you ever heard anyone whistle in the dead of the night?'

" 'Never,' said I.

" 'I suppose that you could not possibly whistle, yourself, in your sleep?'

" 'Certainly not. But why?'

" 'Because during the last few nights I have always, about three in the morning, heard a low, clear whistle. I am a light sleeper, and it has awakened me. I cannot tell where it came from--perhaps from the next room, perhaps from the lawn. I thought that I would just ask you whether you had heard it.'

" 'No, I have not. It must be those wretched gipsies in the plantation.'

" 'Very likely. And yet if it were on the lawn, I wonder that you did not hear it also.'

" 'Ah, but I sleep more heavily than you.'

" 'Well, it is of no great consequence, at any rate.' She smiled back at me, closed my door, and a few moments later I heard her key turn in the lock."

"Indeed," said Holmes. "Was it your custom always to lock yourselves in at night?"

"Always."

"And why?"

"I think that I mentioned to you that the doctor kept a cheetah and a baboon. We had no feeling of security unless our doors were locked."

"Quite so. Pray proceed with your statement."

"I could not sleep that night. A vague feeling of impending misfortune impressed me. My sister and I, you will recollect, were twins, and you know how subtle are the links which bind two souls which are so closely allied. It was a wild night. The wind was howling outside, and the rain was beating and splashing against the windows. Suddenly, amid all the hubbub of the gale, there burst forth the wild scream of a terrified woman. I knew that it was my sister's voice. I sprang from my bed, wrapped a shawl round me, and rushed into the corridor. As I opened my door I seemed to hear a low whistle, such as my sister described, and a few moments later a clanging sound, as if a mass of metal had fallen. As I ran down the passage, my sister's door was unlocked, and revolved slowly upon its hinges. I stared at it horror-stricken, not knowing what was about to issue from it. By the light of the corridor-lamp I saw my sister appear at the opening, her face blanched with terror, her hands groping for help, her whole figure swaying to and fro like that of a drunkard. I ran to her and threw my arms round her, but at that moment her knees seemed to give way and she fell to the ground. She writhed as one who is in terrible pain, and her limbs were dreadfully convulsed. At first I thought that she had not recognised me, but as I bent over her she suddenly shrieked out in a voice which I shall never forget, 'Oh, my God! Helen! It was the band! The speckled band!' There was something else which she would fain have said, and she stabbed with her finger into the air in the direction of the doctor's room, but a fresh convulsion seized her and choked her words. I rushed out, calling loudly for my stepfather, and I met him hastening from his room in his dressing-gown. When he reached my sister's side she was unconscious, and though he poured brandy down her throat and sent for medical aid from the village, all efforts were in vain, for she slowly sank and died without having recovered her consciousness. Such was the dreadful end of my beloved sister."

"One moment," said Holmes, "are you sure about this whistle and metallic sound? Could you swear to it?"

"That was what the county coroner asked me at the inquiry. It is my strong impression that I heard it, and yet, among the crash of the gale and the creaking of an old house, I may possibly have been deceived."

"Was your sister dressed?"

"No, she was in her night-dress. In her right hand was found the charred stump of a match, and in her left a match-box."

"Showing that she had struck a light and looked about her when the alarm took place. That is important. And what conclusions did the coroner come to?"

"He investigated the case with great care, for Dr. Roylott's conduct had long been notorious in the county, but he was unable to find any satisfactory cause of death. My evidence showed that the door had been fastened upon the inner side, and the windows were blocked by old-fashioned shutters with broad iron bars, which were secured every night. The walls were carefully sounded, and were shown to be quite solid all round, and the flooring was also thoroughly examined, with the same result. The chimney is wide, but is barred up by four large staples. It is certain, therefore, that my sister was quite alone when she met her end. Besides, there were no marks of any violence upon her."

"How about poison?"

"The doctors examined her for it, but without success."

"What do you think that this unfortunate lady died of, then?"

"It is my belief that she died of pure fear and nervous shock, though what it was that frightened her I cannot imagine."

"Were there gipsies in the plantation at the time?"

"Yes, there are nearly always some there."

"Ah, and what did you gather from this allusion to a band--a speckled band?"

"Sometimes I have thought that it was merely the wild talk of delirium, sometimes that it may have referred to some band of people, perhaps to these very gipsies in the plantation. I do not know whether the spotted handkerchiefs which so many of them wear over their heads might have suggested the strange adjective which she used."

Holmes shook his head like a man who is far from being satisfied.

"These are very deep waters," said he; "pray go on with your narrative."

"Two years have passed since then, and my life has been until lately lonelier than ever. A month ago, however, a dear friend, whom I have known for many years, has done me the honour to ask my hand in marriage. His name is Armitage--Percy Armitage--the second son of Mr. Armitage, of Crane Water, near Reading. My stepfather has offered no opposition to the match, and we are to be married in the course of the spring. Two days ago some repairs were started in the west wing of the building, and my bedroom wall has been pierced, so that I have had to move into the chamber in which my sister died, and to sleep in the very bed in which she slept. Imagine, then, my thrill of terror when last night, as I lay awake, thinking over her terrible fate, I suddenly heard in the silence of the night the low whistle which had been the herald of her own death. I sprang up and lit the lamp, but nothing was to be seen in the room. I was too shaken to go to bed again, however, so I dressed, and as soon as it was daylight I slipped down, got a dog-cart at the Crown Inn, which is opposite, and drove to Leatherhead, from whence I have come on this morning with the one object of seeing you and asking your advice."

"You have done wisely," said my friend. "But have you told me all?"

"Yes, all."

"Miss Roylott, you have not. You are screening your stepfather."

"Why, what do you mean?"

For answer Holmes pushed back the frill of black lace which fringed the hand that lay upon our visitor's knee. Five little livid spots, the marks of four fingers and a thumb, were printed upon the white wrist.

"You have been cruelly used," said Holmes.

The lady coloured deeply and covered over her injured wrist. "He is a hard man," she said, "and perhaps he hardly knows his own strength."

There was a long silence, during which Holmes leaned his chin upon his hands and stared into the crackling fire.

"This is a very deep business," he said at last. "There are a thousand details which I should desire to know before I decide upon our course of action. Yet we have not a moment to lose. If we were to come to Stoke Moran to-day, would it be possible for us to see over these rooms without the knowledge of your stepfather?"

"As it happens, he spoke of coming into town to-day upon some most important business. It is probable that he will be away all day, and that there would be nothing to disturb you. We have a housekeeper now, but she is old and foolish, and I could easily get her out of the way."

"Excellent. You are not averse to this trip, Watson?"

"By no means."

"Then we shall both come. What are you going to do yourself?"

"I have one or two things which I would wish to do now that I am in town. But I shall return by the twelve o'clock train, so as to be there in time for your coming."

"And you may expect us early in the afternoon. I have myself some small business matters to attend to. Will you not wait and breakfast?"

"No, I must go. My heart is lightened already since I have confided my trouble to you. I shall look forward to seeing you again this afternoon." She dropped her thick black veil over her face and glided from the room.

"And what do you think of it all, Watson?" asked Sherlock Holmes, leaning back in his chair.

"It seems to me to be a most dark and sinister business."

"Dark enough and sinister enough."

"Yet if the lady is correct in saying that the flooring and walls are sound, and that the door, window, and chimney are impassable, then her sister must have been undoubtedly alone when she met her mysterious end."

"What becomes, then, of these nocturnal whistles, and what of the very peculiar words of the dying woman?"

"I cannot think."

"When you combine the ideas of whistles at night, the presence of a band of gipsies who are on intimate terms with this old doctor, the fact that we have every reason to believe that the doctor has an interest in preventing his stepdaughter's marriage, the dying allusion to a band, and, finally, the fact that Miss Helen Stoner heard a metallic clang, which might have been caused by one of those metal bars that secured the shutters falling back into its place, I think that there is good ground to think that the mystery may be cleared along those lines."

"But what, then, did the gipsies do?"

"I cannot imagine."

"I see many objections to any such theory."

"And so do I. It is precisely for that reason that we are going to Stoke Moran this day. I want to see whether the objections are fatal, or if they may be explained away. But what in the name of the devil!"

The ejaculation had been drawn from my companion by the fact that our door had been suddenly dashed open, and that a huge man had framed himself in the aperture. His costume was a peculiar mixture of the professional and of the agricultural, having a black top-hat, a long frock-coat, and a pair of high gaiters, with a hunting-crop swinging in his hand. So tall was he that his hat actually brushed the cross bar of the doorway, and his breadth seemed to span it across from side to side. A large face, seared with a thousand wrinkles, burned yellow with the sun, and marked with every evil passion, was turned from one to the other of us, while his deep-set, bile-shot eyes, and his high, thin, fleshless nose, gave him somewhat the resemblance to a fierce old bird of prey.

"Which of you is Holmes?" asked this apparition.

"My name, sir; but you have the advantage of me," said my companion quietly.

"I am Dr. Grimesby Roylott, of Stoke Moran."

"Indeed, Doctor," said Holmes blandly. "Pray take a seat."

"I will do nothing of the kind. My stepdaughter has been here. I have traced her. What has she been saying to you?"

"It is a little cold for the time of the year," said Holmes.

"What has she been saying to you?" screamed the old man furiously.

"But I have heard that the crocuses promise well," continued my companion imperturbably.

"Ha! You put me off, do you?" said our new visitor, taking a step forward and shaking his hunting-crop. "I know you, you scoundrel! I have heard of you before. You are Holmes, the meddler."

My friend smiled.

"Holmes, the busybody!"

His smile broadened.

"Holmes, the Scotland Yard Jack-in-office!"

Holmes chuckled heartily. "Your conversation is most entertaining," said he. "When you go out close the door, for there is a decided draught."

"I will go when I have said my say. Don't you dare to meddle with my affairs. I know that Miss Stoner has been here. I traced her! I am a dangerous man to fall foul of! See here." He stepped swiftly forward, seized the poker, and bent it into a curve with his huge brown hands.

"See that you keep yourself out of my grip," he snarled, and hurling the twisted poker into the fireplace he strode out of the room.

"He seems a very amiable person," said Holmes, laughing. "I am not quite so bulky, but if he had remained I might have shown him that my grip was not much more feeble than his own." As he spoke he picked up the steel poker and, with a sudden effort, straightened it out again.

"Fancy his having the insolence to confound me with the official detective force! This incident gives zest to our investigation, however, and I only trust that our little friend will not suffer from her imprudence in allowing this brute to trace her. And now, Watson, we shall order breakfast, and afterwards I shall walk down to Doctors' Commons, where I hope to get some data which may help us in this matter."

It was nearly one o'clock when Sherlock Holmes returned from his excursion. He held in his hand a sheet of blue paper, scrawled over with notes and figures.

"I have seen the will of the deceased wife," said he. "To determine its exact meaning I have been obliged to work out the present prices of the investments with which it is concerned. The total income, which at the time of the wife's death was little short of $1100, is now, through the fall in agricultural prices, not more than $750. Each daughter can claim an income of $250, in case of marriage. It is evident, therefore, that if both girls had married, this beauty would have had a mere pittance, while even one of them would cripple him to a very serious extent. My morning's work has not been wasted, since it has proved that he has the very strongest motives for standing in the way of anything of the sort. And now, Watson, this is too serious for dawdling, especially as the old man is aware that we are interesting ourselves in his affairs; so if you are ready, we shall call a cab and drive to Waterloo. I should be very much obliged if you would slip your revolver into your pocket. An Eley's No. 2 is an excellent argument with gentlemen who can twist steel pokers into knots. That and a tooth-brush are, I think, all that we need."

At Waterloo we were fortunate in catching a train for Leatherhead, where we hired a trap at the station inn and drove for four or five miles through the lovely Surrey lanes. It was a perfect day, with a bright sun and a few fleecy clouds in the heavens. The trees and wayside hedges were just throwing out their first green shoots, and the air was full of the pleasant smell of the moist earth. To me at least there was a strange contrast between the sweet promise of the spring and this sinister quest upon which we were engaged. My companion sat in the front of the trap, his arms folded, his hat pulled down over his eyes, and his chin sunk upon his breast, buried in the deepest thought. Suddenly, however, he started, tapped me on the shoulder, and pointed over the meadows.

"Look there!" said he.

A heavily timbered park stretched up in a gentle slope, thickening into a grove at the highest point. From amid the branches there jutted out the grey gables and high roof-tree of a very old mansion.

"Stoke Moran?" said he.

"Yes, sir, that be the house of Dr. Grimesby Roylott," remarked the driver.

"There is some building going on there," said Holmes; "that is where we are going."

"There's the village," said the driver, pointing to a cluster of roofs some distance to the left; "but if you want to get to the house, you'll find it shorter to get over this stile, and so by the foot-path over the fields. There it is, where the lady is walking."

"And the lady, I fancy, is Miss Stoner," observed Holmes, shading his eyes. "Yes, I think we had better do as you suggest."

We got off, paid our fare, and the trap rattled back on its way to Leatherhead.

"I thought it as well," said Holmes as we climbed the stile, "that this fellow should think we had come here as architects, or on some definite business. It may stop his gossip. Good-afternoon, Miss Stoner. You see that we have been as good as our word."

Our client of the morning had hurried forward to meet us with a face which spoke her joy. "I have been waiting so eagerly for you," she cried, shaking hands with us warmly. "All has turned out splendidly. Dr. Roylott has gone to town, and it is unlikely that he will be back before evening."

"We have had the pleasure of making the doctor's acquaintance," said Holmes, and in a few words he sketched out what had occurred. Miss Stoner turned white to the lips as she listened.

"Good heavens!" she cried, "he has followed me, then."

"So it appears."

"He is so cunning that I never know when I am safe from him. What will he say when he returns?"

"He must guard himself, for he may find that there is someone more cunning than himself upon his track. You must lock yourself up from him to-night. If he is violent, we shall take you away to your aunt's at Harrow. Now, we must make the best use of our time, so kindly take us at once to the rooms which we are to examine."

The building was of grey, lichen-blotched stone, with a high central portion and two curving wings, like the claws of a crab, thrown out on each side. In one of these wings the windows were broken and blocked with wooden boards, while the roof was partly caved in, a picture of ruin. The central portion was in little better repair, but the right-hand block was comparatively modern, and the blinds in the windows, with the blue smoke curling up from the chimneys, showed that this was where the family resided. Some scaffolding had been erected against the end wall, and the stone-work had been broken into, but there were no signs of any workmen at the moment of our visit. Holmes walked slowly up and down the ill-trimmed lawn and examined with deep attention the outsides of the windows.

"This, I take it, belongs to the room in which you used to sleep, the centre one to your sister's, and the one next to the main building to Dr. Roylott's chamber?"

"Exactly so. But I am now sleeping in the middle one."

"Pending the alterations, as I understand. By the way, there does not seem to be any very pressing need for repairs at that end wall."

"There were none. I believe that it was an excuse to move me from my room."

"Ah! that is suggestive. Now, on the other side of this narrow wing runs the corridor from which these three rooms open. There are windows in it, of course?"

"Yes, but very small ones. Too narrow for anyone to pass through."

"As you both locked your doors at night, your rooms were unapproachable from that side. Now, would you have the kindness to go into your room and bar your shutters?"

Miss Stoner did so, and Holmes, after a careful examination through the open window, endeavoured in every way to force the shutter open, but without success. There was no slit through which a knife could be passed to raise the bar. Then with his lens he tested the hinges, but they were of solid iron, built firmly into the massive masonry. "Hum!" said he, scratching his chin in some perplexity, "my theory certainly presents some difficulties. No one could pass these shutters if they were bolted. Well, we shall see if the inside throws any light upon the matter."

A small side door led into the whitewashed corridor from which the three bedrooms opened. Holmes refused to examine the third chamber, so we passed at once to the second, that in which Miss Stoner was now sleeping, and in which her sister had met with her fate. It was a homely little room, with a low ceiling and a gaping fireplace, after the fashion of old country-houses. A brown chest of drawers stood in one corner, a narrow white-counterpaned bed in another, and a dressing-table on the left-hand side of the window. These articles, with two small wicker-work chairs, made up all the furniture in the room save for a square of Wilton carpet in the centre. The boards round and the panelling of the walls were of brown, worm-eaten oak, so old and discoloured that it may have dated from the original building of the house. Holmes drew one of the chairs into a corner and sat silent, while his eyes travelled round and round and up and down, taking in every detail of the apartment.

"Where does that bell communicate with?" he asked at last pointing to a thick bell-rope which hung down beside the bed, the tassel actually lying upon the pillow.

"It goes to the housekeeper's room."

"It looks newer than the other things?"

"Yes, it was only put there a couple of years ago."

"Your sister asked for it, I suppose?"

"No, I never heard of her using it. We used always to get what we wanted for ourselves."

"Indeed, it seemed unnecessary to put so nice a bell-pull there. You will excuse me for a few minutes while I satisfy myself as to this floor." He threw himself down upon his face with his lens in his hand and crawled swiftly backward and forward, examining minutely the cracks between the boards. Then he did the same with the wood-work with which the chamber was panelled. Finally he walked over to the bed and spent some time in staring at it and in running his eye up and down the wall. Finally he took the bell-rope in his hand and gave it a brisk tug.

"Why, it's a dummy," said he.

"Won't it ring?"

"No, it is not even attached to a wire. This is very interesting. You can see now that it is fastened to a hook just above where the little opening for the ventilator is."

"How very absurd! I never noticed that before."

"Very strange!" muttered Holmes, pulling at the rope. "There are one or two very singular points about this room. For example, what a fool a builder must be to open a ventilator into another room, when, with the same trouble, he might have communicated with the outside air!"

"That is also quite modern," said the lady.

"Done about the same time as the bell-rope?" remarked Holmes.

"Yes, there were several little changes carried out about that time."

"They seem to have been of a most interesting character--dummy bell-ropes, and ventilators which do not ventilate. With your permission, Miss Stoner, we shall now carry our researches into the inner apartment."

Dr. Grimesby Roylott's chamber was larger than that of his step-daughter, but was as plainly furnished. A camp-bed, a small wooden shelf full of books, mostly of a technical character, an armchair beside the bed, a plain wooden chair against the wall, a round table, and a large iron safe were the principal things which met the eye. Holmes walked slowly round and examined each and all of them with the keenest interest.

"What's in here?" he asked, tapping the safe.

"My stepfather's business papers."

"Oh! you have seen inside, then?"

"Only once, some years ago. I remember that it was full of papers."

"There isn't a cat in it, for example?"

"No. What a strange idea!"

"Well, look at this!" He took up a small saucer of milk which stood on the top of it.

"No; we don't keep a cat. But there is a cheetah and a baboon."

"Ah, yes, of course! Well, a cheetah is just a big cat, and yet a saucer of milk does not go very far in satisfying its wants, I daresay. There is one point which I should wish to determine." He squatted down in front of the wooden chair and examined the seat of it with the greatest attention.

"Thank you. That is quite settled," said he, rising and putting his lens in his pocket. "Hullo! Here is something interesting!"

The object which had caught his eye was a small dog lash hung on one corner of the bed. The lash, however, was curled upon itself and tied so as to make a loop of whipcord.

"What do you make of that, Watson?"

"It's a common enough lash. But I don't know why it should be tied."

"That is not quite so common, is it? Ah, me! it's a wicked world, and when a clever man turns his brains to crime it is the worst of all. I think that I have seen enough now, Miss Stoner, and with your permission we shall walk out upon the lawn."

I had never seen my friend's face so grim or his brow so dark as it was when we turned from the scene of this investigation. We had walked several times up and down the lawn, neither Miss Stoner nor myself liking to break in upon his thoughts before he roused himself from his reverie.

"It is very essential, Miss Stoner," said he, "that you should absolutely follow my advice in every respect."

"I shall most certainly do so."

"The matter is too serious for any hesitation. Your life may depend upon your compliance."

"I assure you that I am in your hands."

"In the first place, both my friend and I must spend the night in your room."

Both Miss Stoner and I gazed at him in astonishment.

"Yes, it must be so. Let me explain. I believe that that is the village inn over there?"

"Yes, that is the Crown."

"Very good. Your windows would be visible from there?"

"Certainly."

"You must confine yourself to your room, on pretence of a headache, when your stepfather comes back. Then when you hear him retire for the night, you must open the shutters of your window, undo the hasp, put your lamp there as a signal to us, and then withdraw quietly with everything which you are likely to want into the room which you used to occupy. I have no doubt that, in spite of the repairs, you could manage there for one night."

"Oh, yes, easily."

"The rest you will leave in our hands."

"But what will you do?"

"We shall spend the night in your room, and we shall investigate the cause of this noise which has disturbed you."

"I believe, Mr. Holmes, that you have already made up your mind," said Miss Stoner, laying her hand upon my companion's sleeve.

"Perhaps I have."

"Then, for pity's sake, tell me what was the cause of my sister's death."

"I should prefer to have clearer proofs before I speak."

"You can at least tell me whether my own thought is correct, and if she died from some sudden fright."

"No, I do not think so. I think that there was probably some more tangible cause. And now, Miss Stoner, we must leave you for if Dr. Roylott returned and saw us our journey would be in vain. Good-bye, and be brave, for if you will do what I have told you, you may rest assured that we shall soon drive away the dangers that threaten you."

Sherlock Holmes and I had no difficulty in engaging a bedroom and sitting-room at the Crown Inn. They were on the upper floor, and from our window we could command a view of the avenue gate, and of the inhabited wing of Stoke Moran Manor House. At dusk we saw Dr. Grimesby Roylott drive past, his huge form looming up beside the little figure of the lad who drove him. The boy had some slight difficulty in undoing the heavy iron gates, and we heard the hoarse roar of the doctor's voice and saw the fury with which he shook his clinched fists at him. The trap drove on, and a few minutes later we saw a sudden light spring up among the trees as the lamp was lit in one of the sitting-rooms.

"Do you know, Watson," said Holmes as we sat together in the gathering darkness, "I have really some scruples as to taking you to-night. There is a distinct element of danger."

"Can I be of assistance?"

"Your presence might be invaluable."

"Then I shall certainly come."

"It is very kind of you."

"You speak of danger. You have evidently seen more in these rooms than was visible to me."

"No, but I fancy that I may have deduced a little more. I imagine that you saw all that I did."

"I saw nothing remarkable save the bell-rope, and what purpose that could answer I confess is more than I can imagine."

"You saw the ventilator, too?"

"Yes, but I do not think that it is such a very unusual thing to have a small opening between two rooms. It was so small that a rat could hardly pass through."

"I knew that we should find a ventilator before ever we came to Stoke Moran."

"My dear Holmes!"

"Oh, yes, I did. You remember in her statement she said that her sister could smell Dr. Roylott's cigar. Now, of course that suggested at once that there must be a communication between the two rooms. It could only be a small one, or it would have been remarked upon at the coroner's inquiry. I deduced a ventilator."

"But what harm can there be in that?"

"Well, there is at least a curious coincidence of dates. A ventilator is made, a cord is hung, and a lady who sleeps in the bed dies. Does not that strike you?"

"I cannot as yet see any connection."

"Did you observe anything very peculiar about that bed?"

"No."

"It was clamped to the floor. Did you ever see a bed fastened like that before?"

"I cannot say that I have."

"The lady could not move her bed. It must always be in the same relative position to the ventilator and to the rope--or so we may call it, since it was clearly never meant for a bell-pull."

"Holmes," I cried, "I seem to see dimly what you are hinting at. We are only just in time to prevent some subtle and horrible crime."

"Subtle enough and horrible enough. When a doctor does go wrong he is the first of criminals. He has nerve and he has knowledge. Palmer and Pritchard were among the heads of their profession. This man strikes even deeper, but I think, Watson, that we shall be able to strike deeper still. But we shall have horrors enough before the night is over; for goodness' sake let us have a quiet pipe and turn our minds for a few hours to something more cheerful."

About nine o'clock the light among the trees was extinguished, and all was dark in the direction of the Manor House. Two hours passed slowly away, and then, suddenly, just at the stroke of eleven, a single bright light shone out right in front of us.

"That is our signal," said Holmes, springing to his feet; "it comes from the middle window."

As we passed out he exchanged a few words with the landlord, explaining that we were going on a late visit to an acquaintance, and that it was possible that we might spend the night there. A moment later we were out on the dark road, a chill wind blowing in our faces, and one yellow light twinkling in front of us through the gloom to guide us on our sombre errand.

There was little difficulty in entering the grounds, for unrepaired breaches gaped in the old park wall. Making our way among the trees, we reached the lawn, crossed it, and were about to enter through the window when out from a clump of laurel bushes there darted what seemed to be a hideous and distorted child, who threw itself upon the grass with writhing limbs and then ran swiftly across the lawn into the darkness.

"My God!" I whispered; "did you see it?"

Holmes was for the moment as startled as I. His hand closed like a vice upon my wrist in his agitation. Then he broke into a low laugh and put his lips to my ear.

"It is a nice household," he murmured. "That is the baboon."

I had forgotten the strange pets which the doctor affected. There was a cheetah, too; perhaps we might find it upon our shoulders at any moment. I confess that I felt easier in my mind when, after following Holmes' example and slipping off my shoes, I found myself inside the bedroom. My companion noiselessly closed the shutters, moved the lamp onto the table, and cast his eyes round the room. All was as we had seen it in the daytime. Then creeping up to me and making a trumpet of his hand, he whispered into my ear again so gently that it was all that I could do to distinguish the words:

"The least sound would be fatal to our plans."

I nodded to show that I had heard.

"We must sit without light. He would see it through the ventilator."

I nodded again.

"Do not go asleep; your very life may depend upon it. Have your pistol ready in case we should need it. I will sit on the side of the bed, and you in that chair."

I took out my revolver and laid it on the corner of the table.

Holmes had brought up a long thin cane, and this he placed upon the bed beside him. By it he laid the box of matches and the stump of a candle. Then he turned down the lamp, and we were left in darkness.

How shall I ever forget that dreadful vigil? I could not hear a sound, not even the drawing of a breath, and yet I knew that my companion sat open-eyed, within a few feet of me, in the same state of nervous tension in which I was myself. The shutters cut off the least ray of light, and we waited in absolute darkness.

From outside came the occasional cry of a night-bird, and once at our very window a long drawn catlike whine, which told us that the cheetah was indeed at liberty. Far away we could hear the deep tones of the parish clock, which boomed out every quarter of an hour. How long they seemed, those quarters! Twelve struck, and one and two and three, and still we sat waiting silently for whatever might befall.

Suddenly there was the momentary gleam of a light up in the direction of the ventilator, which vanished immediately, but was succeeded by a strong smell of burning oil and heated metal. Someone in the next room had lit a dark-lantern. I heard a gentle sound of movement, and then all was silent once more, though the smell grew stronger. For half an hour I sat with straining ears. Then suddenly another sound became audible--a very gentle, soothing sound, like that of a small jet of steam escaping continually from a kettle. The instant that we heard it, Holmes sprang from the bed, struck a match, and lashed furiously with his cane at the bell-pull.

"You see it, Watson?" he yelled. "You see it?"

But I saw nothing. At the moment when Holmes struck the light I heard a low, clear whistle, but the sudden glare flashing into my weary eyes made it impossible for me to tell what it was at which my friend lashed so savagely. I could, however, see that his face was deadly pale and filled with horror and loathing. He had ceased to strike and was gazing up at the ventilator when suddenly there broke from the silence of the night the most horrible cry to which I have ever listened. It swelled up louder and louder, a hoarse yell of pain and fear and anger all mingled in the one dreadful shriek. They say that away down in the village, and even in the distant parsonage, that cry raised the sleepers from their beds. It struck cold to our hearts, and I stood gazing at Holmes, and he at me, until the last echoes of it had died away into the silence from which it rose.

"What can it mean?" I gasped.

"It means that it is all over," Holmes answered. "And perhaps, after all, it is for the best. Take your pistol, and we will enter Dr. Roylott's room."

With a grave face he lit the lamp and led the way down the corridor. Twice he struck at the chamber door without any reply from within. Then he turned the handle and entered, I at his heels, with the cocked pistol in my hand.

It was a singular sight which met our eyes. On the table stood a dark-lantern with the shutter half open, throwing a brilliant beam of light upon the iron safe, the door of which was ajar. Beside this table, on the wooden chair, sat Dr. Grimesby Roylott clad in a long grey dressing-gown, his bare ankles protruding beneath, and his feet thrust into red heelless Turkish slippers. Across his lap lay the short stock with the long lash which we had noticed during the day. His chin was cocked upward and his eyes were fixed in a dreadful, rigid stare at the corner of the ceiling. Round his brow he had a peculiar yellow band, with brownish speckles, which seemed to be bound tightly round his head. As we entered he made neither sound nor motion.

"The band! the speckled band!" whispered Holmes.

I took a step forward. In an instant his strange headgear began to move, and there reared itself from among his hair the squat diamond-shaped head and puffed neck of a loathsome serpent.

"It is a swamp adder!" cried Holmes; "the deadliest snake in India. He has died within ten seconds of being bitten. Violence does, in truth, recoil upon the violent, and the schemer falls into the pit which he digs for another. Let us thrust this creature back into its den, and we can then remove Miss Stoner to some place of shelter and let the county police know what has happened."

As he spoke he drew the dog-whip swiftly from the dead man's lap, and throwing the noose round the reptile's neck he drew it from its horrid perch and, carrying it at arm's length, threw it into the iron safe, which he closed upon it.

Such are the true facts of the death of Dr. Grimesby Roylott, of Stoke Moran. It is not necessary that I should prolong a narrative which has already run to too great a length by telling how we broke the sad news to the terrified girl, how we conveyed her by the morning train to the care of her good aunt at Harrow, of how the slow process of official inquiry came to the conclusion that the doctor met his fate while indiscreetly playing with a dangerous pet. The little which I had yet to learn of the case was told me by Sherlock Holmes as we travelled back next day.

"I had," said he, "come to an entirely erroneous conclusion which shows, my dear Watson, how dangerous it always is to reason from insufficient data. The presence of the gipsies, and the use of the word 'band,' which was used by the poor girl, no doubt, to explain the appearance which she had caught a hurried glimpse of by the light of her match, were sufficient to put me upon an entirely wrong scent. I can only claim the merit that I instantly reconsidered my position when, however, it became clear to me that whatever danger threatened an occupant of the room could not come either from the window or the door. My attention was speedily drawn, as I have already remarked to you, to this ventilator, and to the bell-rope which hung down to the bed. The discovery that this was a dummy, and that the bed was clamped to the floor, instantly gave rise to the suspicion that the rope was there as a bridge for something passing through the hole and coming to the bed. The idea of a snake instantly occurred to me, and when I coupled it with my knowledge that the doctor was furnished with a supply of creatures from India, I felt that I was probably on the right track. The idea of using a form of poison which could not possibly be discovered by any chemical test was just such a one as would occur to a clever and ruthless man who had had an Eastern training. The rapidity with which such a poison would take effect would also, from his point of view, be an advantage. It would be a sharp-eyed coroner, indeed, who could distinguish the two little dark punctures which would show where the poison fangs had done their work. Then I thought of the whistle. Of course he must recall the snake before the morning light revealed it to the victim. He had trained it, probably by the use of the milk which we saw, to return to him when summoned. He would put it through this ventilator at the hour that he thought best, with the certainty that it would crawl down the rope and land on the bed. It might or might not bite the occupant, perhaps she might escape every night for a week, but sooner or later she must fall a victim.

"I had come to these conclusions before ever I had entered his room. An inspection of his chair showed me that he had been in the habit of standing on it, which of course would be necessary in order that he should reach the ventilator. The sight of the safe, the saucer of milk, and the loop of whipcord were enough to finally dispel any doubts which may have remained. The metallic clang heard by Miss Stoner was obviously caused by her stepfather hastily closing the door of his safe upon its terrible occupant. Having once made up my mind, you know the steps which I took in order to put the matter to the proof. I heard the creature hiss as I have no doubt that you did also, and I instantly lit the light and attacked it."

"With the result of driving it through the ventilator."

"And also with the result of causing it to turn upon its master at the other side. Some of the blows of my cane came home and roused its snakish temper, so that it flew upon the first person it saw. In this way I am no doubt indirectly responsible for Dr. Grimesby Roylott's death, and I cannot say that it is likely to weigh very heavily upon my conscience."

IX.  THE ADVENTURE OF THE ENGINEER'S THUMB


Of all the problems which have been submitted to my friend, Mr. Sherlock Holmes, for solution during the years of our intimacy, there were only two which I was the means of introducing to his notice--that of Mr. Hatherley's thumb, and that of Colonel Warburton's madness. Of these the latter may have afforded a finer field for an acute and original observer, but the other was so strange in its inception and so dramatic in its details that it may be the more worthy of being placed upon record, even if it gave my friend fewer openings for those deductive methods of reasoning by which he achieved such remarkable results. The story has, I believe, been told more than once in the newspapers, but, like all such narratives, its effect is much less striking when set forth en bloc in a single half-column of print than when the facts slowly evolve before your own eyes, and the mystery clears gradually away as each new discovery furnishes a step which leads on to the complete truth. At the time the circumstances made a deep impression upon me, and the lapse of two years has hardly served to weaken the effect.

It was in the summer of '89, not long after my marriage, that the events occurred which I am now about to summarise. I had returned to civil practice and had finally abandoned Holmes in his Baker Street rooms, although I continually visited him and occasionally even persuaded him to forgo his Bohemian habits so far as to come and visit us. My practice had steadily increased, and as I happened to live at no very great distance from Paddington Station, I got a few patients from among the officials. One of these, whom I had cured of a painful and lingering disease, was never weary of advertising my virtues and of endeavouring to send me on every sufferer over whom he might have any influence.

One morning, at a little before seven o'clock, I was awakened by the maid tapping at the door to announce that two men had come from Paddington and were waiting in the consulting-room. I dressed hurriedly, for I knew by experience that railway cases were seldom trivial, and hastened downstairs. As I descended, my old ally, the guard, came out of the room and closed the door tightly behind him.

"I've got him here," he whispered, jerking his thumb over his shoulder; "he's all right."

"What is it, then?" I asked, for his manner suggested that it was some strange creature which he had caged up in my room.

"It's a new patient," he whispered. "I thought I'd bring him round myself; then he couldn't slip away. There he is, all safe and sound. I must go now, Doctor; I have my dooties, just the same as you." And off he went, this trusty tout, without even giving me time to thank him.

I entered my consulting-room and found a gentleman seated by the table. He was quietly dressed in a suit of heather tweed with a soft cloth cap which he had laid down upon my books. Round one of his hands he had a handkerchief wrapped, which was mottled all over with bloodstains. He was young, not more than five-and-twenty, I should say, with a strong, masculine face; but he was exceedingly pale and gave me the impression of a man who was suffering from some strong agitation, which it took all his strength of mind to control.

"I am sorry to knock you up so early, Doctor," said he, "but I have had a very serious accident during the night. I came in by train this morning, and on inquiring at Paddington as to where I might find a doctor, a worthy fellow very kindly escorted me here. I gave the maid a card, but I see that she has left it upon the side-table."

I took it up and glanced at it. "Mr. Victor Hatherley, hydraulic engineer, 16A, Victoria Street (3rd floor)." That was the name, style, and abode of my morning visitor. "I regret that I have kept you waiting," said I, sitting down in my library-chair. "You are fresh from a night journey, I understand, which is in itself a monotonous occupation."

"Oh, my night could not be called monotonous," said he, and laughed. He laughed very heartily, with a high, ringing note, leaning back in his chair and shaking his sides. All my medical instincts rose up against that laugh.

"Stop it!" I cried; "pull yourself together!" and I poured out some water from a caraffe.

It was useless, however. He was off in one of those hysterical outbursts which come upon a strong nature when some great crisis is over and gone. Presently he came to himself once more, very weary and pale-looking.

"I have been making a fool of myself," he gasped.

"Not at all. Drink this." I dashed some brandy into the water, and the colour began to come back to his bloodless cheeks.

"That's better!" said he. "And now, Doctor, perhaps you would kindly attend to my thumb, or rather to the place where my thumb used to be."

He unwound the handkerchief and held out his hand. It gave even my hardened nerves a shudder to look at it. There were four protruding fingers and a horrid red, spongy surface where the thumb should have been. It had been hacked or torn right out from the roots.

"Good heavens!" I cried, "this is a terrible injury. It must have bled considerably."

"Yes, it did. I fainted when it was done, and I think that I must have been senseless for a long time. When I came to I found that it was still bleeding, so I tied one end of my handkerchief very tightly round the wrist and braced it up with a twig."

"Excellent! You should have been a surgeon."

"It is a question of hydraulics, you see, and came within my own province."

"This has been done," said I, examining the wound, "by a very heavy and sharp instrument."

"A thing like a cleaver," said he.

"An accident, I presume?"

"By no means."

"What! a murderous attack?"

"Very murderous indeed."

"You horrify me."

I sponged the wound, cleaned it, dressed it, and finally covered it over with cotton wadding and carbolised bandages. He lay back without wincing, though he bit his lip from time to time.

"How is that?" I asked when I had finished.

"Capital! Between your brandy and your bandage, I feel a new man. I was very weak, but I have had a good deal to go through."

"Perhaps you had better not speak of the matter. It is evidently trying to your nerves."

"Oh, no, not now. I shall have to tell my tale to the police; but, between ourselves, if it were not for the convincing evidence of this wound of mine, I should be surprised if they believed my statement, for it is a very extraordinary one, and I have not much in the way of proof with which to back it up; and, even if they believe me, the clues which I can give them are so vague that it is a question whether justice will be done."

"Ha!" cried I, "if it is anything in the nature of a problem which you desire to see solved, I should strongly recommend you to come to my friend, Mr. Sherlock Holmes, before you go to the official police."

"Oh, I have heard of that fellow," answered my visitor, "and I should be very glad if he would take the matter up, though of course I must use the official police as well. Would you give me an introduction to him?"

"I'll do better. I'll take you round to him myself."

"I should be immensely obliged to you."

"We'll call a cab and go together. We shall just be in time to have a little breakfast with him. Do you feel equal to it?"

"Yes; I shall not feel easy until I have told my story."

"Then my servant will call a cab, and I shall be with you in an instant." I rushed upstairs, explained the matter shortly to my wife, and in five minutes was inside a hansom, driving with my new acquaintance to Baker Street.

Sherlock Holmes was, as I expected, lounging about his sitting-room in his dressing-gown, reading the agony column of The Times and smoking his before-breakfast pipe, which was composed of all the plugs and dottles left from his smokes of the day before, all carefully dried and collected on the corner of the mantelpiece. He received us in his quietly genial fashion, ordered fresh rashers and eggs, and joined us in a hearty meal. When it was concluded he settled our new acquaintance upon the sofa, placed a pillow beneath his head, and laid a glass of brandy and water within his reach.

"It is easy to see that your experience has been no common one, Mr. Hatherley," said he. "Pray, lie down there and make yourself absolutely at home. Tell us what you can, but stop when you are tired and keep up your strength with a little stimulant."

"Thank you," said my patient. "but I have felt another man since the doctor bandaged me, and I think that your breakfast has completed the cure. I shall take up as little of your valuable time as possible, so I shall start at once upon my peculiar experiences."

Holmes sat in his big armchair with the weary, heavy-lidded expression which veiled his keen and eager nature, while I sat opposite to him, and we listened in silence to the strange story which our visitor detailed to us.

"You must know," said he, "that I am an orphan and a bachelor, residing alone in lodgings in London. By profession I am a hydraulic engineer, and I have had considerable experience of my work during the seven years that I was apprenticed to Venner & Matheson, the well-known firm, of Greenwich. Two years ago, having served my time, and having also come into a fair sum of money through my poor father's death, I determined to start in business for myself and took professional chambers in Victoria Street.

"I suppose that everyone finds his first independent start in business a dreary experience. To me it has been exceptionally so. During two years I have had three consultations and one small job, and that is absolutely all that my profession has brought me. My gross takings amount to $27 10s. Every day, from nine in the morning until four in the afternoon, I waited in my little den, until at last my heart began to sink, and I came to believe that I should never have any practice at all.

"Yesterday, however, just as I was thinking of leaving the office, my clerk entered to say there was a gentleman waiting who wished to see me upon business. He brought up a card, too, with the name of 'Colonel Lysander Stark' engraved upon it. Close at his heels came the colonel himself, a man rather over the middle size, but of an exceeding thinness. I do not think that I have ever seen so thin a man. His whole face sharpened away into nose and chin, and the skin of his cheeks was drawn quite tense over his outstanding bones. Yet this emaciation seemed to be his natural habit, and due to no disease, for his eye was bright, his step brisk, and his bearing assured. He was plainly but neatly dressed, and his age, I should judge, would be nearer forty than thirty.

" 'Mr. Hatherley?' said he, with something of a German accent. 'You have been recommended to me, Mr. Hatherley, as being a man who is not only proficient in his profession but is also discreet and capable of preserving a secret.'

"I bowed, feeling as flattered as any young man would at such an address. 'May I ask who it was who gave me so good a character?'

" 'Well, perhaps it is better that I should not tell you that just at this moment. I have it from the same source that you are both an orphan and a bachelor and are residing alone in London.'

" 'That is quite correct,' I answered; 'but you will excuse me if I say that I cannot see how all this bears upon my professional qualifications. I understand that it was on a professional matter that you wished to speak to me?'

" 'Undoubtedly so. But you will find that all I say is really to the point. I have a professional commission for you, but absolute secrecy is quite essential--absolute secrecy, you understand, and of course we may expect that more from a man who is alone than from one who lives in the bosom of his family.'

" 'If I promise to keep a secret,' said I, 'you may absolutely depend upon my doing so.'

"He looked very hard at me as I spoke, and it seemed to me that I had never seen so suspicious and questioning an eye.

" 'Do you promise, then?' said he at last.

" 'Yes, I promise.'

" 'Absolute and complete silence before, during, and after? No reference to the matter at all, either in word or writing?'

" 'I have already given you my word.'

" 'Very good.' He suddenly sprang up, and darting like lightning across the room he flung open the door. The passage outside was empty.

" 'That's all right,' said he, coming back. 'I know that clerks are sometimes curious as to their master's affairs. Now we can talk in safety.' He drew up his chair very close to mine and began to stare at me again with the same questioning and thoughtful look.

"A feeling of repulsion, and of something akin to fear had begun to rise within me at the strange antics of this fleshless man. Even my dread of losing a client could not restrain me from showing my impatience.

" 'I beg that you will state your business, sir,' said I; 'my time is of value.' Heaven forgive me for that last sentence, but the words came to my lips.

" 'How would fifty guineas for a night's work suit you?' he asked.

" 'Most admirably.'

" 'I say a night's work, but an hour's would be nearer the mark. I simply want your opinion about a hydraulic stamping machine which has got out of gear. If you show us what is wrong we shall soon set it right ourselves. What do you think of such a commission as that?'

" 'The work appears to be light and the pay munificent.'

" 'Precisely so. We shall want you to come to-night by the last train.'

" 'Where to?'

" 'To Eyford, in Berkshire. It is a little place near the borders of Oxfordshire, and within seven miles of Reading. There is a train from Paddington which would bring you there at about 11:15.'

" 'Very good.'

" 'I shall come down in a carriage to meet you.'

" 'There is a drive, then?'

" 'Yes, our little place is quite out in the country. It is a good seven miles from Eyford Station.'

" 'Then we can hardly get there before midnight. I suppose there would be no chance of a train back. I should be compelled to stop the night.'

" 'Yes, we could easily give you a shake-down.'

" 'That is very awkward. Could I not come at some more convenient hour?'

" 'We have judged it best that you should come late. It is to recompense you for any inconvenience that we are paying to you, a young and unknown man, a fee which would buy an opinion from the very heads of your profession. Still, of course, if you would like to draw out of the business, there is plenty of time to do so.'

"I thought of the fifty guineas, and of how very useful they would be to me. 'Not at all,' said I, 'I shall be very happy to accommodate myself to your wishes. I should like, however, to understand a little more clearly what it is that you wish me to do.'

" 'Quite so. It is very natural that the pledge of secrecy which we have exacted from you should have aroused your curiosity. I have no wish to commit you to anything without your having it all laid before you. I suppose that we are absolutely safe from eavesdroppers?'

" 'Entirely.'

" 'Then the matter stands thus. You are probably aware that fuller's-earth is a valuable product, and that it is only found in one or two places in England?'

" 'I have heard so.'

" 'Some little time ago I bought a small place--a very small place--within ten miles of Reading. I was fortunate enough to discover that there was a deposit of fuller's-earth in one of my fields. On examining it, however, I found that this deposit was a comparatively small one, and that it formed a link between two very much larger ones upon the right and left--both of them, however, in the grounds of my neighbours. These good people were absolutely ignorant that their land contained that which was quite as valuable as a gold-mine. Naturally, it was to my interest to buy their land before they discovered its true value, but unfortunately I had no capital by which I could do this. I took a few of my friends into the secret, however, and they suggested that we should quietly and secretly work our own little deposit and that in this way we should earn the money which would enable us to buy the neighbouring fields. This we have now been doing for some time, and in order to help us in our operations we erected a hydraulic press. This press, as I have already explained, has got out of order, and we wish your advice upon the subject. We guard our secret very jealously, however, and if it once became known that we had hydraulic engineers coming to our little house, it would soon rouse inquiry, and then, if the facts came out, it would be good-bye to any chance of getting these fields and carrying out our plans. That is why I have made you promise me that you will not tell a human being that you are going to Eyford to-night. I hope that I make it all plain?'

" 'I quite follow you,' said I. 'The only point which I could not quite understand was what use you could make of a hydraulic press in excavating fuller's-earth, which, as I understand, is dug out like gravel from a pit.'

" 'Ah!' said he carelessly, 'we have our own process. We compress the earth into bricks, so as to remove them without revealing what they are. But that is a mere detail. I have taken you fully into my confidence now, Mr. Hatherley, and I have shown you how I trust you.' He rose as he spoke. 'I shall expect you, then, at Eyford at 11:15.'

" 'I shall certainly be there.'

" 'And not a word to a soul.' He looked at me with a last long, questioning gaze, and then, pressing my hand in a cold, dank grasp, he hurried from the room.

"Well, when I came to think it all over in cool blood I was very much astonished, as you may both think, at this sudden commission which had been intrusted to me. On the one hand, of course, I was glad, for the fee was at least tenfold what I should have asked had I set a price upon my own services, and it was possible that this order might lead to other ones. On the other hand, the face and manner of my patron had made an unpleasant impression upon me, and I could not think that his explanation of the fuller's-earth was sufficient to explain the necessity for my coming at midnight, and his extreme anxiety lest I should tell anyone of my errand. However, I threw all fears to the winds, ate a hearty supper, drove to Paddington, and started off, having obeyed to the letter the injunction as to holding my tongue.

"At Reading I had to change not only my carriage but my station. However, I was in time for the last train to Eyford, and I reached the little dim-lit station after eleven o'clock. I was the only passenger who got out there, and there was no one upon the platform save a single sleepy porter with a lantern. As I passed out through the wicket gate, however, I found my acquaintance of the morning waiting in the shadow upon the other side. Without a word he grasped my arm and hurried me into a carriage, the door of which was standing open. He drew up the windows on either side, tapped on the wood-work, and away we went as fast as the horse could go."

"One horse?" interjected Holmes.

"Yes, only one."

"Did you observe the colour?"

"Yes, I saw it by the side-lights when I was stepping into the carriage. It was a chestnut."

"Tired-looking or fresh?"

"Oh, fresh and glossy."

"Thank you. I am sorry to have interrupted you. Pray continue your most interesting statement."

"Away we went then, and we drove for at least an hour. Colonel Lysander Stark had said that it was only seven miles, but I should think, from the rate that we seemed to go, and from the time that we took, that it must have been nearer twelve. He sat at my side in silence all the time, and I was aware, more than once when I glanced in his direction, that he was looking at me with great intensity. The country roads seem to be not very good in that part of the world, for we lurched and jolted terribly. I tried to look out of the windows to see something of where we were, but they were made of frosted glass, and I could make out nothing save the occasional bright blur of a passing light. Now and then I hazarded some remark to break the monotony of the journey, but the colonel answered only in monosyllables, and the conversation soon flagged. At last, however, the bumping of the road was exchanged for the crisp smoothness of a gravel-drive, and the carriage came to a stand. Colonel Lysander Stark sprang out, and, as I followed after him, pulled me swiftly into a porch which gaped in front of us. We stepped, as it were, right out of the carriage and into the hall, so that I failed to catch the most fleeting glance of the front of the house. The instant that I had crossed the threshold the door slammed heavily behind us, and I heard faintly the rattle of the wheels as the carriage drove away.

"It was pitch dark inside the house, and the colonel fumbled about looking for matches and muttering under his breath. Suddenly a door opened at the other end of the passage, and a long, golden bar of light shot out in our direction. It grew broader, and a woman appeared with a lamp in her hand, which she held above her head, pushing her face forward and peering at us. I could see that she was pretty, and from the gloss with which the light shone upon her dark dress I knew that it was a rich material. She spoke a few words in a foreign tongue in a tone as though asking a question, and when my companion answered in a gruff monosyllable she gave such a start that the lamp nearly fell from her hand. Colonel Stark went up to her, whispered something in her ear, and then, pushing her back into the room from whence she had come, he walked towards me again with the lamp in his hand.

" 'Perhaps you will have the kindness to wait in this room for a few minutes,' said he, throwing open another door. It was a quiet, little, plainly furnished room, with a round table in the centre, on which several German books were scattered. Colonel Stark laid down the lamp on the top of a harmonium beside the door. 'I shall not keep you waiting an instant,' said he, and vanished into the darkness.

"I glanced at the books upon the table, and in spite of my ignorance of German I could see that two of them were treatises on science, the others being volumes of poetry. Then I walked across to the window, hoping that I might catch some glimpse of the country-side, but an oak shutter, heavily barred, was folded across it. It was a wonderfully silent house. There was an old clock ticking loudly somewhere in the passage, but otherwise everything was deadly still. A vague feeling of uneasiness began to steal over me. Who were these German people, and what were they doing living in this strange, out-of-the-way place? And where was the place? I was ten miles or so from Eyford, that was all I knew, but whether north, south, east, or west I had no idea. For that matter, Reading, and possibly other large towns, were within that radius, so the place might not be so secluded, after all. Yet it was quite certain, from the absolute stillness, that we were in the country. I paced up and down the room, humming a tune under my breath to keep up my spirits and feeling that I was thoroughly earning my fifty-guinea fee.

"Suddenly, without any preliminary sound in the midst of the utter stillness, the door of my room swung slowly open. The woman was standing in the aperture, the darkness of the hall behind her, the yellow light from my lamp beating upon her eager and beautiful face. I could see at a glance that she was sick with fear, and the sight sent a chill to my own heart. She held up one shaking finger to warn me to be silent, and she shot a few whispered words of broken English at me, her eyes glancing back, like those of a frightened horse, into the gloom behind her.

" 'I would go,' said she, trying hard, as it seemed to me, to speak calmly; 'I would go. I should not stay here. There is no good for you to do.'

" 'But, madam,' said I, 'I have not yet done what I came for. I cannot possibly leave until I have seen the machine.'

" 'It is not worth your while to wait,' she went on. 'You can pass through the door; no one hinders.' And then, seeing that I smiled and shook my head, she suddenly threw aside her constraint and made a step forward, with her hands wrung together. 'For the love of Heaven!' she whispered, 'get away from here before it is too late!'

"But I am somewhat headstrong by nature, and the more ready to engage in an affair when there is some obstacle in the way. I thought of my fifty-guinea fee, of my wearisome journey, and of the unpleasant night which seemed to be before me. Was it all to go for nothing? Why should I slink away without having carried out my commission, and without the payment which was my due? This woman might, for all I knew, be a monomaniac. With a stout bearing, therefore, though her manner had shaken me more than I cared to confess, I still shook my head and declared my intention of remaining where I was. She was about to renew her entreaties when a door slammed overhead, and the sound of several footsteps was heard upon the stairs. She listened for an instant, threw up her hands with a despairing gesture, and vanished as suddenly and as noiselessly as she had come.

"The newcomers were Colonel Lysander Stark and a short thick man with a chinchilla beard growing out of the creases of his double chin, who was introduced to me as Mr. Ferguson.

" 'This is my secretary and manager,' said the colonel. 'By the way, I was under the impression that I left this door shut just now. I fear that you have felt the draught.'

" 'On the contrary,' said I, 'I opened the door myself because I felt the room to be a little close.'

"He shot one of his suspicious looks at me. 'Perhaps we had better proceed to business, then,' said he. 'Mr. Ferguson and I will take you up to see the machine.'

" 'I had better put my hat on, I suppose.'

" 'Oh, no, it is in the house.'

" 'What, you dig fuller's-earth in the house?'

" 'No, no. This is only where we compress it. But never mind that. All we wish you to do is to examine the machine and to let us know what is wrong with it.'

"We went upstairs together, the colonel first with the lamp, the fat manager and I behind him. It was a labyrinth of an old house, with corridors, passages, narrow winding staircases, and little low doors, the thresholds of which were hollowed out by the generations who had crossed them. There were no carpets and no signs of any furniture above the ground floor, while the plaster was peeling off the walls, and the damp was breaking through in green, unhealthy blotches. I tried to put on as unconcerned an air as possible, but I had not forgotten the warnings of the lady, even though I disregarded them, and I kept a keen eye upon my two companions. Ferguson appeared to be a morose and silent man, but I could see from the little that he said that he was at least a fellow-countryman.

"Colonel Lysander Stark stopped at last before a low door, which he unlocked. Within was a small, square room, in which the three of us could hardly get at one time. Ferguson remained outside, and the colonel ushered me in.

" 'We are now,' said he, 'actually within the hydraulic press, and it would be a particularly unpleasant thing for us if anyone were to turn it on. The ceiling of this small chamber is really the end of the descending piston, and it comes down with the force of many tons upon this metal floor. There are small lateral columns of water outside which receive the force, and which transmit and multiply it in the manner which is familiar to you. The machine goes readily enough, but there is some stiffness in the working of it, and it has lost a little of its force. Perhaps you will have the goodness to look it over and to show us how we can set it right.'

"I took the lamp from him, and I examined the machine very thoroughly. It was indeed a gigantic one, and capable of exercising enormous pressure. When I passed outside, however, and pressed down the levers which controlled it, I knew at once by the whishing sound that there was a slight leakage, which allowed a regurgitation of water through one of the side cylinders. An examination showed that one of the india-rubber bands which was round the head of a driving-rod had shrunk so as not quite to fill the socket along which it worked. This was clearly the cause of the loss of power, and I pointed it out to my companions, who followed my remarks very carefully and asked several practical questions as to how they should proceed to set it right. When I had made it clear to them, I returned to the main chamber of the machine and took a good look at it to satisfy my own curiosity. It was obvious at a glance that the story of the fuller's-earth was the merest fabrication, for it would be absurd to suppose that so powerful an engine could be designed for so inadequate a purpose. The walls were of wood, but the floor consisted of a large iron trough, and when I came to examine it I could see a crust of metallic deposit all over it. I had stooped and was scraping at this to see exactly what it was when I heard a muttered exclamation in German and saw the cadaverous face of the colonel looking down at me.

" 'What are you doing there?' he asked.

"I felt angry at having been tricked by so elaborate a story as that which he had told me. 'I was admiring your fuller's-earth,' said I; 'I think that I should be better able to advise you as to your machine if I knew what the exact purpose was for which it was used.'

"The instant that I uttered the words I regretted the rashness of my speech. His face set hard, and a baleful light sprang up in his grey eyes.

" 'Very well,' said he, 'you shall know all about the machine.' He took a step backward, slammed the little door, and turned the key in the lock. I rushed towards it and pulled at the handle, but it was quite secure, and did not give in the least to my kicks and shoves. 'Hullo!' I yelled. 'Hullo! Colonel! Let me out!'

"And then suddenly in the silence I heard a sound which sent my heart into my mouth. It was the clank of the levers and the swish of the leaking cylinder. He had set the engine at work. The lamp still stood upon the floor where I had placed it when examining the trough. By its light I saw that the black ceiling was coming down upon me, slowly, jerkily, but, as none knew better than myself, with a force which must within a minute grind me to a shapeless pulp. I threw myself, screaming, against the door, and dragged with my nails at the lock. I implored the colonel to let me out, but the remorseless clanking of the levers drowned my cries. The ceiling was only a foot or two above my head, and with my hand upraised I could feel its hard, rough surface. Then it flashed through my mind that the pain of my death would depend very much upon the position in which I met it. If I lay on my face the weight would come upon my spine, and I shuddered to think of that dreadful snap. Easier the other way, perhaps; and yet, had I the nerve to lie and look up at that deadly black shadow wavering down upon me? Already I was unable to stand erect, when my eye caught something which brought a gush of hope back to my heart.

"I have said that though the floor and ceiling were of iron, the walls were of wood. As I gave a last hurried glance around, I saw a thin line of yellow light between two of the boards, which broadened and broadened as a small panel was pushed backward. For an instant I could hardly believe that here was indeed a door which led away from death. The next instant I threw myself through, and lay half-fainting upon the other side. The panel had closed again behind me, but the crash of the lamp, and a few moments afterwards the clang of the two slabs of metal, told me how narrow had been my escape.

"I was recalled to myself by a frantic plucking at my wrist, and I found myself lying upon the stone floor of a narrow corridor, while a woman bent over me and tugged at me with her left hand, while she held a candle in her right. It was the same good friend whose warning I had so foolishly rejected.

" 'Come! come!' she cried breathlessly. 'They will be here in a moment. They will see that you are not there. Oh, do not waste the so-precious time, but come!'

"This time, at least, I did not scorn her advice. I staggered to my feet and ran with her along the corridor and down a winding stair. The latter led to another broad passage, and just as we reached it we heard the sound of running feet and the shouting of two voices, one answering the other from the floor on which we were and from the one beneath. My guide stopped and looked about her like one who is at her wit's end. Then she threw open a door which led into a bedroom, through the window of which the moon was shining brightly.

" 'It is your only chance,' said she. 'It is high, but it may be that you can jump it.'

"As she spoke a light sprang into view at the further end of the passage, and I saw the lean figure of Colonel Lysander Stark rushing forward with a lantern in one hand and a weapon like a butcher's cleaver in the other. I rushed across the bedroom, flung open the window, and looked out. How quiet and sweet and wholesome the garden looked in the moonlight, and it could not be more than thirty feet down. I clambered out upon the sill, but I hesitated to jump until I should have heard what passed between my saviour and the ruffian who pursued me. If she were ill-used, then at any risks I was determined to go back to her assistance. The thought had hardly flashed through my mind before he was at the door, pushing his way past her; but she threw her arms round him and tried to hold him back.

" 'Fritz! Fritz!' she cried in English, 'remember your promise after the last time. You said it should not be again. He will be silent! Oh, he will be silent!'

" 'You are mad, Elise!' he shouted, struggling to break away from her. 'You will be the ruin of us. He has seen too much. Let me pass, I say!' He dashed her to one side, and, rushing to the window, cut at me with his heavy weapon. I had let myself go, and was hanging by the hands to the sill, when his blow fell. I was conscious of a dull pain, my grip loosened, and I fell into the garden below.

"I was shaken but not hurt by the fall; so I picked myself up and rushed off among the bushes as hard as I could run, for I understood that I was far from being out of danger yet. Suddenly, however, as I ran, a deadly dizziness and sickness came over me. I glanced down at my hand, which was throbbing painfully, and then, for the first time, saw that my thumb had been cut off and that the blood was pouring from my wound. I endeavoured to tie my handkerchief round it, but there came a sudden buzzing in my ears, and next moment I fell in a dead faint among the rose-bushes.

"How long I remained unconscious I cannot tell. It must have been a very long time, for the moon had sunk, and a bright morning was breaking when I came to myself. My clothes were all sodden with dew, and my coat-sleeve was drenched with blood from my wounded thumb. The smarting of it recalled in an instant all the particulars of my night's adventure, and I sprang to my feet with the feeling that I might hardly yet be safe from my pursuers. But to my astonishment, when I came to look round me, neither house nor garden were to be seen. I had been lying in an angle of the hedge close by the highroad, and just a little lower down was a long building, which proved, upon my approaching it, to be the very station at which I had arrived upon the previous night. Were it not for the ugly wound upon my hand, all that had passed during those dreadful hours might have been an evil dream.

"Half dazed, I went into the station and asked about the morning train. There would be one to Reading in less than an hour. The same porter was on duty, I found, as had been there when I arrived. I inquired of him whether he had ever heard of Colonel Lysander Stark. The name was strange to him. Had he observed a carriage the night before waiting for me? No, he had not. Was there a police-station anywhere near? There was one about three miles off.

"It was too far for me to go, weak and ill as I was. I determined to wait until I got back to town before telling my story to the police. It was a little past six when I arrived, so I went first to have my wound dressed, and then the doctor was kind enough to bring me along here. I put the case into your hands and shall do exactly what you advise."

We both sat in silence for some little time after listening to this extraordinary narrative. Then Sherlock Holmes pulled down from the shelf one of the ponderous commonplace books in which he placed his cuttings.

"Here is an advertisement which will interest you," said he. "It appeared in all the papers about a year ago. Listen to this: 'Lost, on the 9th inst., Mr. Jeremiah Hayling, aged twenty-six, a hydraulic engineer. Left his lodgings at ten o'clock at night, and has not been heard of since. Was dressed in,' etc., etc. Ha! That represents the last time that the colonel needed to have his machine overhauled, I fancy."

"Good heavens!" cried my patient. "Then that explains what the girl said."

"Undoubtedly. It is quite clear that the colonel was a cool and desperate man, who was absolutely determined that nothing should stand in the way of his little game, like those out-and-out pirates who will leave no survivor from a captured ship. Well, every moment now is precious, so if you feel equal to it we shall go down to Scotland Yard at once as a preliminary to starting for Eyford."

Some three hours or so afterwards we were all in the train together, bound from Reading to the little Berkshire village. There were Sherlock Holmes, the hydraulic engineer, Inspector Bradstreet, of Scotland Yard, a plain-clothes man, and myself. Bradstreet had spread an ordnance map of the county out upon the seat and was busy with his compasses drawing a circle with Eyford for its centre.

"There you are," said he. "That circle is drawn at a radius of ten miles from the village. The place we want must be somewhere near that line. You said ten miles, I think, sir."

"It was an hour's good drive."

"And you think that they brought you back all that way when you were unconscious?"

"They must have done so. I have a confused memory, too, of having been lifted and conveyed somewhere."

"What I cannot understand," said I, "is why they should have spared you when they found you lying fainting in the garden. Perhaps the villain was softened by the woman's entreaties."

"I hardly think that likely. I never saw a more inexorable face in my life."

"Oh, we shall soon clear up all that," said Bradstreet. "Well, I have drawn my circle, and I only wish I knew at what point upon it the folk that we are in search of are to be found."

"I think I could lay my finger on it," said Holmes quietly.

"Really, now!" cried the inspector, "you have formed your opinion! Come, now, we shall see who agrees with you. I say it is south, for the country is more deserted there."

"And I say east," said my patient.

"I am for west," remarked the plain-clothes man. "There are several quiet little villages up there."

"And I am for north," said I, "because there are no hills there, and our friend says that he did not notice the carriage go up any."

"Come," cried the inspector, laughing; "it's a very pretty diversity of opinion. We have boxed the compass among us. Who do you give your casting vote to?"

"You are all wrong."

"But we can't all be."

"Oh, yes, you can. This is my point." He placed his finger in the centre of the circle. "This is where we shall find them."

"But the twelve-mile drive?" gasped Hatherley.

"Six out and six back. Nothing simpler. You say yourself that the horse was fresh and glossy when you got in. How could it be that if it had gone twelve miles over heavy roads?"

"Indeed, it is a likely ruse enough," observed Bradstreet thoughtfully. "Of course there can be no doubt as to the nature of this gang."

"None at all," said Holmes. "They are coiners on a large scale, and have used the machine to form the amalgam which has taken the place of silver."

"We have known for some time that a clever gang was at work," said the inspector. "They have been turning out half-crowns by the thousand. We even traced them as far as Reading, but could get no farther, for they had covered their traces in a way that showed that they were very old hands. But now, thanks to this lucky chance, I think that we have got them right enough."

But the inspector was mistaken, for those criminals were not destined to fall into the hands of justice. As we rolled into Eyford Station we saw a gigantic column of smoke which streamed up from behind a small clump of trees in the neighbourhood and hung like an immense ostrich feather over the landscape.

"A house on fire?" asked Bradstreet as the train steamed off again on its way.

"Yes, sir!" said the station-master.

"When did it break out?"

"I hear that it was during the night, sir, but it has got worse, and the whole place is in a blaze."

"Whose house is it?"

"Dr. Becher's."

"Tell me," broke in the engineer, "is Dr. Becher a German, very thin, with a long, sharp nose?"

The station-master laughed heartily. "No, sir, Dr. Becher is an Englishman, and there isn't a man in the parish who has a better-lined waistcoat. But he has a gentleman staying with him, a patient, as I understand, who is a foreigner, and he looks as if a little good Berkshire beef would do him no harm."

The station-master had not finished his speech before we were all hastening in the direction of the fire. The road topped a low hill, and there was a great widespread whitewashed building in front of us, spouting fire at every chink and window, while in the garden in front three fire-engines were vainly striving to keep the flames under.

"That's it!" cried Hatherley, in intense excitement. "There is the gravel-drive, and there are the rose-bushes where I lay. That second window is the one that I jumped from."

"Well, at least," said Holmes, "you have had your revenge upon them. There can be no question that it was your oil-lamp which, when it was crushed in the press, set fire to the wooden walls, though no doubt they were too excited in the chase after you to observe it at the time. Now keep your eyes open in this crowd for your friends of last night, though I very much fear that they are a good hundred miles off by now."

And Holmes' fears came to be realised, for from that day to this no word has ever been heard either of the beautiful woman, the sinister German, or the morose Englishman. Early that morning a peasant had met a cart containing several people and some very bulky boxes driving rapidly in the direction of Reading, but there all traces of the fugitives disappeared, and even Holmes' ingenuity failed ever to discover the least clue as to their whereabouts.

The firemen had been much perturbed at the strange arrangements which they had found within, and still more so by discovering a newly severed human thumb upon a window-sill of the second floor. About sunset, however, their efforts were at last successful, and they subdued the flames, but not before the roof had fallen in, and the whole place been reduced to such absolute ruin that, save some twisted cylinders and iron piping, not a trace remained of the machinery which had cost our unfortunate acquaintance so dearly. Large masses of nickel and of tin were discovered stored in an out-house, but no coins were to be found, which may have explained the presence of those bulky boxes which have been already referred to.

How our hydraulic engineer had been conveyed from the garden to the spot where he recovered his senses might have remained forever a mystery were it not for the soft mould, which told us a very plain tale. He had evidently been carried down by two persons, one of whom had remarkably small feet and the other unusually large ones. On the whole, it was most probable that the silent Englishman, being less bold or less murderous than his companion, had assisted the woman to bear the unconscious man out of the way of danger.

"Well," said our engineer ruefully as we took our seats to return once more to London, "it has been a pretty business for me! I have lost my thumb and I have lost a fifty-guinea fee, and what have I gained?"

"Experience," said Holmes, laughing. "Indirectly it may be of value, you know; you have only to put it into words to gain the reputation of being excellent company for the remainder of your existence."

X.  THE ADVENTURE OF THE NOBLE BACHELOR


The Lord St. Simon marriage, and its curious termination, have long ceased to be a subject of interest in those exalted circles in which the unfortunate bridegroom moves. Fresh scandals have eclipsed it, and their more piquant details have drawn the gossips away from this four-year-old drama. As I have reason to believe, however, that the full facts have never been revealed to the general public, and as my friend Sherlock Holmes had a considerable share in clearing the matter up, I feel that no memoir of him would be complete without some little sketch of this remarkable episode.

It was a few weeks before my own marriage, during the days when I was still sharing rooms with Holmes in Baker Street, that he came home from an afternoon stroll to find a letter on the table waiting for him. I had remained indoors all day, for the weather had taken a sudden turn to rain, with high autumnal winds, and the Jezail bullet which I had brought back in one of my limbs as a relic of my Afghan campaign throbbed with dull persistence. With my body in one easy-chair and my legs upon another, I had surrounded myself with a cloud of newspapers until at last, saturated with the news of the day, I tossed them all aside and lay listless, watching the huge crest and monogram upon the envelope upon the table and wondering lazily who my friend's noble correspondent could be.

"Here is a very fashionable epistle," I remarked as he entered. "Your morning letters, if I remember right, were from a fish-monger and a tide-waiter."

"Yes, my correspondence has certainly the charm of variety," he answered, smiling, "and the humbler are usually the more interesting. This looks like one of those unwelcome social summonses which call upon a man either to be bored or to lie."

He broke the seal and glanced over the contents.

"Oh, come, it may prove to be something of interest, after all."

"Not social, then?"

"No, distinctly professional."

"And from a noble client?"

"One of the highest in England."

"My dear fellow, I congratulate you."

"I assure you, Watson, without affectation, that the status of my client is a matter of less moment to me than the interest of his case. It is just possible, however, that that also may not be wanting in this new investigation. You have been reading the papers diligently of late, have you not?"

"It looks like it," said I ruefully, pointing to a huge bundle in the corner. "I have had nothing else to do."

"It is fortunate, for you will perhaps be able to post me up. I read nothing except the criminal news and the agony column. The latter is always instructive. But if you have followed recent events so closely you must have read about Lord St. Simon and his wedding?"

"Oh, yes, with the deepest interest."

"That is well. The letter which I hold in my hand is from Lord St. Simon. I will read it to you, and in return you must turn over these papers and let me have whatever bears upon the matter. This is what he says:

" 'MY DEAR MR. SHERLOCK HOLMES:--Lord Backwater tells me that I may place implicit reliance upon your judgment and discretion. I have determined, therefore, to call upon you and to consult you in reference to the very painful event which has occurred in connection with my wedding. Mr. Lestrade, of Scotland Yard, is acting already in the matter, but he assures me that he sees no objection to your co-operation, and that he even thinks that it might be of some assistance. I will call at four o'clock in the afternoon, and, should you have any other engagement at that time, I hope that you will postpone it, as this matter is of paramount importance. Yours faithfully,


" 'ST. SIMON.'

"It is dated from Grosvenor Mansions, written with a quill pen, and the noble lord has had the misfortune to get a smear of ink upon the outer side of his right little finger," remarked Holmes as he folded up the epistle.

"He says four o'clock. It is three now. He will be here in an hour."

"Then I have just time, with your assistance, to get clear upon the subject. Turn over those papers and arrange the extracts in their order of time, while I take a glance as to who our client is." He picked a red-covered volume from a line of books of reference beside the mantelpiece. "Here he is," said he, sitting down and flattening it out upon his knee. " 'Lord Robert Walsingham de Vere St. Simon, second son of the Duke of Balmoral.' Hum! 'Arms: Azure, three caltrops in chief over a fess sable. Born in 1846.' He's forty-one years of age, which is mature for marriage. Was Under-Secretary for the colonies in a late administration. The Duke, his father, was at one time Secretary for Foreign Affairs. They inherit Plantagenet blood by direct descent, and Tudor on the distaff side. Ha! Well, there is nothing very instructive in all this. I think that I must turn to you Watson, for something more solid."

"I have very little difficulty in finding what I want," said I, "for the facts are quite recent, and the matter struck me as remarkable. I feared to refer them to you, however, as I knew that you had an inquiry on hand and that you disliked the intrusion of other matters."

"Oh, you mean the little problem of the Grosvenor Square furniture van. That is quite cleared up now--though, indeed, it was obvious from the first. Pray give me the results of your newspaper selections."

"Here is the first notice which I can find. It is in the personal column of the Morning Post, and dates, as you see, some weeks back: 'A marriage has been arranged,' it says, 'and will, if rumour is correct, very shortly take place, between Lord Robert St. Simon, second son of the Duke of Balmoral, and Miss Hatty Doran, the only daughter of Aloysius Doran. Esq., of San Francisco, Cal., U.S.A.' That is all."

"Terse and to the point," remarked Holmes, stretching his long, thin legs towards the fire.

"There was a paragraph amplifying this in one of the society papers of the same week. Ah, here it is: 'There will soon be a call for protection in the marriage market, for the present free-trade principle appears to tell heavily against our home product. One by one the management of the noble houses of Great Britain is passing into the hands of our fair cousins from across the Atlantic. An important addition has been made during the last week to the list of the prizes which have been borne away by these charming invaders. Lord St. Simon, who has shown himself for over twenty years proof against the little god's arrows, has now definitely announced his approaching marriage with Miss Hatty Doran, the fascinating daughter of a California millionaire. Miss Doran, whose graceful figure and striking face attracted much attention at the Westbury House festivities, is an only child, and it is currently reported that her dowry will run to considerably over the six figures, with expectancies for the future. As it is an open secret that the Duke of Balmoral has been compelled to sell his pictures within the last few years, and as Lord St. Simon has no property of his own save the small estate of Birchmoor, it is obvious that the Californian heiress is not the only gainer by an alliance which will enable her to make the easy and common transition from a Republican lady to a British peeress.' "

"Anything else?" asked Holmes, yawning.

"Oh, yes; plenty. Then there is another note in the Morning Post to say that the marriage would be an absolutely quiet one, that it would be at St. George's, Hanover Square, that only half a dozen intimate friends would be invited, and that the party would return to the furnished house at Lancaster Gate which has been taken by Mr. Aloysius Doran. Two days later--that is, on Wednesday last--there is a curt announcement that the wedding had taken place, and that the honeymoon would be passed at Lord Backwater's place, near Petersfield. Those are all the notices which appeared before the disappearance of the bride."

"Before the what?" asked Holmes with a start.

"The vanishing of the lady."

"When did she vanish, then?"

"At the wedding breakfast."

"Indeed. This is more interesting than it promised to be; quite dramatic, in fact."

"Yes; it struck me as being a little out of the common."

"They often vanish before the ceremony, and occasionally during the honeymoon; but I cannot call to mind anything quite so prompt as this. Pray let me have the details."

"I warn you that they are very incomplete."

"Perhaps we may make them less so."

"Such as they are, they are set forth in a single article of a morning paper of yesterday, which I will read to you. It is headed, 'Singular Occurrence at a Fashionable Wedding':

" 'The family of Lord Robert St. Simon has been thrown into the greatest consternation by the strange and painful episodes which have taken place in connection with his wedding. The ceremony, as shortly announced in the papers of yesterday, occurred on the previous morning; but it is only now that it has been possible to confirm the strange rumours which have been so persistently floating about. In spite of the attempts of the friends to hush the matter up, so much public attention has now been drawn to it that no good purpose can be served by affecting to disregard what is a common subject for conversation.

" 'The ceremony, which was performed at St. George's, Hanover Square, was a very quiet one, no one being present save the father of the bride, Mr. Aloysius Doran, the Duchess of Balmoral, Lord Backwater, Lord Eustace and Lady Clara St. Simon (the younger brother and sister of the bridegroom), and Lady Alicia Whittington. The whole party proceeded afterwards to the house of Mr. Aloysius Doran, at Lancaster Gate, where breakfast had been prepared. It appears that some little trouble was caused by a woman, whose name has not been ascertained, who endeavoured to force her way into the house after the bridal party, alleging that she had some claim upon Lord St. Simon. It was only after a painful and prolonged scene that she was ejected by the butler and the footman. The bride, who had fortunately entered the house before this unpleasant interruption, had sat down to breakfast with the rest, when she complained of a sudden indisposition and retired to her room. Her prolonged absence having caused some comment, her father followed her, but learned from her maid that she had only come up to her chamber for an instant, caught up an ulster and bonnet, and hurried down to the passage. One of the footmen declared that he had seen a lady leave the house thus apparelled, but had refused to credit that it was his mistress, believing her to be with the company. On ascertaining that his daughter had disappeared, Mr. Aloysius Doran, in conjunction with the bridegroom, instantly put themselves in communication with the police, and very energetic inquiries are being made, which will probably result in a speedy clearing up of this very singular business. Up to a late hour last night, however, nothing had transpired as to the whereabouts of the missing lady. There are rumours of foul play in the matter, and it is said that the police have caused the arrest of the woman who had caused the original disturbance, in the belief that, from jealousy or some other motive, she may have been concerned in the strange disappearance of the bride.' "

"And is that all?"

"Only one little item in another of the morning papers, but it is a suggestive one."

"And it is--"

"That Miss Flora Millar, the lady who had caused the disturbance, has actually been arrested. It appears that she was formerly a danseuse at the Allegro, and that she has known the bridegroom for some years. There are no further particulars, and the whole case is in your hands now--so far as it has been set forth in the public press."

"And an exceedingly interesting case it appears to be. I would not have missed it for worlds. But there is a ring at the bell, Watson, and as the clock makes it a few minutes after four, I have no doubt that this will prove to be our noble client. Do not dream of going, Watson, for I very much prefer having a witness, if only as a check to my own memory."

"Lord Robert St. Simon," announced our page-boy, throwing open the door. A gentleman entered, with a pleasant, cultured face, high-nosed and pale, with something perhaps of petulance about the mouth, and with the steady, well-opened eye of a man whose pleasant lot it had ever been to command and to be obeyed. His manner was brisk, and yet his general appearance gave an undue impression of age, for he had a slight forward stoop and a little bend of the knees as he walked. His hair, too, as he swept off his very curly-brimmed hat, was grizzled round the edges and thin upon the top. As to his dress, it was careful to the verge of foppishness, with high collar, black frock-coat, white waistcoat, yellow gloves, patent-leather shoes, and light-coloured gaiters. He advanced slowly into the room, turning his head from left to right, and swinging in his right hand the cord which held his golden eyeglasses.

"Good-day, Lord St. Simon," said Holmes, rising and bowing. "Pray take the basket-chair. This is my friend and colleague, Dr. Watson. Draw up a little to the fire, and we will talk this matter over."

"A most painful matter to me, as you can most readily imagine, Mr. Holmes. I have been cut to the quick. I understand that you have already managed several delicate cases of this sort, sir, though I presume that they were hardly from the same class of society."

"No, I am descending."

"I beg pardon."

"My last client of the sort was a king."

"Oh, really! I had no idea. And which king?"

"The King of Scandinavia."

"What! Had he lost his wife?"

"You can understand," said Holmes suavely, "that I extend to the affairs of my other clients the same secrecy which I promise to you in yours."

"Of course! Very right! very right! I'm sure I beg pardon. As to my own case, I am ready to give you any information which may assist you in forming an opinion."

"Thank you. I have already learned all that is in the public prints, nothing more. I presume that I may take it as correct--this article, for example, as to the disappearance of the bride."

Lord St. Simon glanced over it. "Yes, it is correct, as far as it goes."

"But it needs a great deal of supplementing before anyone could offer an opinion. I think that I may arrive at my facts most directly by questioning you."

"Pray do so."

"When did you first meet Miss Hatty Doran?"

"In San Francisco, a year ago."

"You were travelling in the States?"

"Yes."

"Did you become engaged then?"

"No."

"But you were on a friendly footing?"

"I was amused by her society, and she could see that I was amused."

"Her father is very rich?"

"He is said to be the richest man on the Pacific slope."

"And how did he make his money?"

"In mining. He had nothing a few years ago. Then he struck gold, invested it, and came up by leaps and bounds."

"Now, what is your own impression as to the young lady's--your wife's character?"

The nobleman swung his glasses a little faster and stared down into the fire. "You see, Mr. Holmes," said he, "my wife was twenty before her father became a rich man. During that time she ran free in a mining camp and wandered through woods or mountains, so that her education has come from Nature rather than from the schoolmaster. She is what we call in England a tomboy, with a strong nature, wild and free, unfettered by any sort of traditions. She is impetuous--volcanic, I was about to say. She is swift in making up her mind and fearless in carrying out her resolutions. On the other hand, I would not have given her the name which I have the honour to bear"--he gave a little stately cough--"had I not thought her to be at bottom a noble woman. I believe that she is capable of heroic self-sacrifice and that anything dishonourable would be repugnant to her."

"Have you her photograph?"

"I brought this with me." He opened a locket and showed us the full face of a very lovely woman. It was not a photograph but an ivory miniature, and the artist had brought out the full effect of the lustrous black hair, the large dark eyes, and the exquisite mouth. Holmes gazed long and earnestly at it. Then he closed the locket and handed it back to Lord St. Simon.

"The young lady came to London, then, and you renewed your acquaintance?"

"Yes, her father brought her over for this last London season. I met her several times, became engaged to her, and have now married her."

"She brought, I understand, a considerable dowry?"

"A fair dowry. Not more than is usual in my family."

"And this, of course, remains to you, since the marriage is a fait accompli?"

"I really have made no inquiries on the subject."

"Very naturally not. Did you see Miss Doran on the day before the wedding?"

"Yes."

"Was she in good spirits?"

"Never better. She kept talking of what we should do in our future lives."

"Indeed! That is very interesting. And on the morning of the wedding?"

"She was as bright as possible--at least until after the ceremony."

"And did you observe any change in her then?"

"Well, to tell the truth, I saw then the first signs that I had ever seen that her temper was just a little sharp. The incident however, was too trivial to relate and can have no possible bearing upon the case."

"Pray let us have it, for all that."

"Oh, it is childish. She dropped her bouquet as we went towards the vestry. She was passing the front pew at the time, and it fell over into the pew. There was a moment's delay, but the gentleman in the pew handed it up to her again, and it did not appear to be the worse for the fall. Yet when I spoke to her of the matter, she answered me abruptly; and in the carriage, on our way home, she seemed absurdly agitated over this trifling cause."

"Indeed! You say that there was a gentleman in the pew. Some of the general public were present, then?"

"Oh, yes. It is impossible to exclude them when the church is open."

"This gentleman was not one of your wife's friends?"

"No, no; I call him a gentleman by courtesy, but he was quite a common-looking person. I hardly noticed his appearance. But really I think that we are wandering rather far from the point."

"Lady St. Simon, then, returned from the wedding in a less cheerful frame of mind than she had gone to it. What did she do on re-entering her father's house?"

"I saw her in conversation with her maid."

"And who is her maid?"

"Alice is her name. She is an American and came from California with her."

"A confidential servant?"

"A little too much so. It seemed to me that her mistress allowed her to take great liberties. Still, of course, in America they look upon these things in a different way."

"How long did she speak to this Alice?"

"Oh, a few minutes. I had something else to think of."

"You did not overhear what they said?"

"Lady St. Simon said something about 'jumping a claim.' She was accustomed to use slang of the kind. I have no idea what she meant."

"American slang is very expressive sometimes. And what did your wife do when she finished speaking to her maid?"

"She walked into the breakfast-room."

"On your arm?"

"No, alone. She was very independent in little matters like that. Then, after we had sat down for ten minutes or so, she rose hurriedly, muttered some words of apology, and left the room. She never came back."

"But this maid, Alice, as I understand, deposes that she went to her room, covered her bride's dress with a long ulster, put on a bonnet, and went out."

"Quite so. And she was afterwards seen walking into Hyde Park in company with Flora Millar, a woman who is now in custody, and who had already made a disturbance at Mr. Doran's house that morning."

"Ah, yes. I should like a few particulars as to this young lady, and your relations to her."

Lord St. Simon shrugged his shoulders and raised his eyebrows. "We have been on a friendly footing for some years--I may say on a very friendly footing. She used to be at the Allegro. I have not treated her ungenerously, and she had no just cause of complaint against me, but you know what women are, Mr. Holmes. Flora was a dear little thing, but exceedingly hot-headed and devotedly attached to me. She wrote me dreadful letters when she heard that I was about to be married, and, to tell the truth, the reason why I had the marriage celebrated so quietly was that I feared lest there might be a scandal in the church. She came to Mr. Doran's door just after we returned, and she endeavoured to push her way in, uttering very abusive expressions towards my wife, and even threatening her, but I had foreseen the possibility of something of the sort, and I had two police fellows there in private clothes, who soon pushed her out again. She was quiet when she saw that there was no good in making a row."

"Did your wife hear all this?"

"No, thank goodness, she did not."

"And she was seen walking with this very woman afterwards?"

"Yes. That is what Mr. Lestrade, of Scotland Yard, looks upon as so serious. It is thought that Flora decoyed my wife out and laid some terrible trap for her."

"Well, it is a possible supposition."

"You think so, too?"

"I did not say a probable one. But you do not yourself look upon this as likely?"

"I do not think Flora would hurt a fly."

"Still, jealousy is a strange transformer of characters. Pray what is your own theory as to what took place?"

"Well, really, I came to seek a theory, not to propound one. I have given you all the facts. Since you ask me, however, I may say that it has occurred to me as possible that the excitement of this affair, the consciousness that she had made so immense a social stride, had the effect of causing some little nervous disturbance in my wife."

"In short, that she had become suddenly deranged?"

"Well, really, when I consider that she has turned her back--I will not say upon me, but upon so much that many have aspired to without success--I can hardly explain it in any other fashion."

"Well, certainly that is also a conceivable hypothesis," said Holmes, smiling. "And now, Lord St. Simon, I think that I have nearly all my data. May I ask whether you were seated at the breakfast-table so that you could see out of the window?"

"We could see the other side of the road and the Park."

"Quite so. Then I do not think that I need to detain you longer. I shall communicate with you."

"Should you be fortunate enough to solve this problem," said our client, rising.

"I have solved it."

"Eh? What was that?"

"I say that I have solved it."

"Where, then, is my wife?"

"That is a detail which I shall speedily supply."

Lord St. Simon shook his head. "I am afraid that it will take wiser heads than yours or mine," he remarked, and bowing in a stately, old-fashioned manner he departed.

"It is very good of Lord St. Simon to honour my head by putting it on a level with his own," said Sherlock Holmes, laughing. "I think that I shall have a whisky and soda and a cigar after all this cross-questioning. I had formed my conclusions as to the case before our client came into the room."

"My dear Holmes!"

"I have notes of several similar cases, though none, as I remarked before, which were quite as prompt. My whole examination served to turn my conjecture into a certainty. Circumstantial evidence is occasionally very convincing, as when you find a trout in the milk, to quote Thoreau's example."

"But I have heard all that you have heard."

"Without, however, the knowledge of pre-existing cases which serves me so well. There was a parallel instance in Aberdeen some years back, and something on very much the same lines at Munich the year after the Franco-Prussian War. It is one of these cases--but, hullo, here is Lestrade! Good-afternoon, Lestrade! You will find an extra tumbler upon the sideboard, and there are cigars in the box."

The official detective was attired in a pea-jacket and cravat, which gave him a decidedly nautical appearance, and he carried a black canvas bag in his hand. With a short greeting he seated himself and lit the cigar which had been offered to him.

"What's up, then?" asked Holmes with a twinkle in his eye. "You look dissatisfied."

"And I feel dissatisfied. It is this infernal St. Simon marriage case. I can make neither head nor tail of the business."

"Really! You surprise me."

"Who ever heard of such a mixed affair? Every clue seems to slip through my fingers. I have been at work upon it all day."

"And very wet it seems to have made you," said Holmes laying his hand upon the arm of the pea-jacket.

"Yes, I have been dragging the Serpentine."

"In heaven's name, what for?"

"In search of the body of Lady St. Simon."

Sherlock Holmes leaned back in his chair and laughed heartily.

"Have you dragged the basin of Trafalgar Square fountain?" he asked.

"Why? What do you mean?"

"Because you have just as good a chance of finding this lady in the one as in the other."

Lestrade shot an angry glance at my companion. "I suppose you know all about it," he snarled.

"Well, I have only just heard the facts, but my mind is made up."

"Oh, indeed! Then you think that the Serpentine plays no part in the matter?"

"I think it very unlikely."

"Then perhaps you will kindly explain how it is that we found this in it?" He opened his bag as he spoke, and tumbled onto the floor a wedding-dress of watered silk, a pair of white satin shoes and a bride's wreath and veil, all discoloured and soaked in water. "There," said he, putting a new wedding-ring upon the top of the pile. "There is a little nut for you to crack, Master Holmes."

"Oh, indeed!" said my friend, blowing blue rings into the air. "You dragged them from the Serpentine?"

"No. They were found floating near the margin by a park-keeper. They have been identified as her clothes, and it seemed to me that if the clothes were there the body would not be far off."

"By the same brilliant reasoning, every man's body is to be found in the neighbourhood of his wardrobe. And pray what did you hope to arrive at through this?"

"At some evidence implicating Flora Millar in the disappearance."

"I am afraid that you will find it difficult."

"Are you, indeed, now?" cried Lestrade with some bitterness. "I am afraid, Holmes, that you are not very practical with your deductions and your inferences. You have made two blunders in as many minutes. This dress does implicate Miss Flora Millar."

"And how?"

"In the dress is a pocket. In the pocket is a card-case. In the card-case is a note. And here is the very note." He slapped it down upon the table in front of him. "Listen to this: 'You will see me when all is ready. Come at once. F. H. M.' Now my theory all along has been that Lady St. Simon was decoyed away by Flora Millar, and that she, with confederates, no doubt, was responsible for her disappearance. Here, signed with her initials, is the very note which was no doubt quietly slipped into her hand at the door and which lured her within their reach."

"Very good, Lestrade," said Holmes, laughing. "You really are very fine indeed. Let me see it." He took up the paper in a listless way, but his attention instantly became riveted, and he gave a little cry of satisfaction. "This is indeed important," said he.

"Ha! you find it so?"

"Extremely so. I congratulate you warmly."

Lestrade rose in his triumph and bent his head to look. "Why," he shrieked, "you're looking at the wrong side!"

"On the contrary, this is the right side."

"The right side? You're mad! Here is the note written in pencil over here."

"And over here is what appears to be the fragment of a hotel bill, which interests me deeply."

"There's nothing in it. I looked at it before," said Lestrade. " 'Oct. 4th, rooms 8s., breakfast 2s. 6d., cocktail 1s., lunch 2s. 6d., glass sherry, 8d.' I see nothing in that."

"Very likely not. It is most important, all the same. As to the note, it is important also, or at least the initials are, so I congratulate you again."

"I've wasted time enough," said Lestrade, rising. "I believe in hard work and not in sitting by the fire spinning fine theories. Good-day, Mr. Holmes, and we shall see which gets to the bottom of the matter first." He gathered up the garments, thrust them into the bag, and made for the door.

"Just one hint to you, Lestrade," drawled Holmes before his rival vanished; "I will tell you the true solution of the matter. Lady St. Simon is a myth. There is not, and there never has been, any such person."

Lestrade looked sadly at my companion. Then he turned to me, tapped his forehead three times, shook his head solemnly, and hurried away.

He had hardly shut the door behind him when Holmes rose to put on his overcoat. "There is something in what the fellow says about outdoor work," he remarked, "so I think, Watson, that I must leave you to your papers for a little."

It was after five o'clock when Sherlock Holmes left me, but I had no time to be lonely, for within an hour there arrived a confectioner's man with a very large flat box. This he unpacked with the help of a youth whom he had brought with him, and presently, to my very great astonishment, a quite epicurean little cold supper began to be laid out upon our humble lodging-house mahogany. There were a couple of brace of cold woodcock, a pheasant, a pate de foie gras pie with a group of ancient and cobwebby bottles. Having laid out all these luxuries, my two visitors vanished away, like the genii of the Arabian Nights, with no explanation save that the things had been paid for and were ordered to this address.

Just before nine o'clock Sherlock Holmes stepped briskly into the room. His features were gravely set, but there was a light in his eye which made me think that he had not been disappointed in his conclusions.

"They have laid the supper, then," he said, rubbing his hands.

"You seem to expect company. They have laid for five."

"Yes, I fancy we may have some company dropping in," said he. "I am surprised that Lord St. Simon has not already arrived. Ha! I fancy that I hear his step now upon the stairs."

It was indeed our visitor of the afternoon who came bustling in, dangling his glasses more vigorously than ever, and with a very perturbed expression upon his aristocratic features.

"My messenger reached you, then?" asked Holmes.

"Yes, and I confess that the contents startled me beyond measure. Have you good authority for what you say?"

"The best possible."

Lord St. Simon sank into a chair and passed his hand over his forehead.

"What will the Duke say," he murmured, "when he hears that one of the family has been subjected to such humiliation?"

"It is the purest accident. I cannot allow that there is any humiliation."

"Ah, you look on these things from another standpoint."

"I fail to see that anyone is to blame. I can hardly see how the lady could have acted otherwise, though her abrupt method of doing it was undoubtedly to be regretted. Having no mother, she had no one to advise her at such a crisis."

"It was a slight, sir, a public slight," said Lord St. Simon, tapping his fingers upon the table.

"You must make allowance for this poor girl, placed in so unprecedented a position."

"I will make no allowance. I am very angry indeed, and I have been shamefully used."

"I think that I heard a ring," said Holmes. "Yes, there are steps on the landing. If I cannot persuade you to take a lenient view of the matter, Lord St. Simon, I have brought an advocate here who may be more successful." He opened the door and ushered in a lady and gentleman. "Lord St. Simon," said he "allow me to introduce you to Mr. and Mrs. Francis Hay Moulton. The lady, I think, you have already met."

At the sight of these newcomers our client had sprung from his seat and stood very erect, with his eyes cast down and his hand thrust into the breast of his frock-coat, a picture of offended dignity. The lady had taken a quick step forward and had held out her hand to him, but he still refused to raise his eyes. It was as well for his resolution, perhaps, for her pleading face was one which it was hard to resist.

"You're angry, Robert," said she. "Well, I guess you have every cause to be."

"Pray make no apology to me," said Lord St. Simon bitterly.

"Oh, yes, I know that I have treated you real bad and that I should have spoken to you before I went; but I was kind of rattled, and from the time when I saw Frank here again I just didn't know what I was doing or saying. I only wonder I didn't fall down and do a faint right there before the altar."

"Perhaps, Mrs. Moulton, you would like my friend and me to leave the room while you explain this matter?"

"If I may give an opinion," remarked the strange gentleman, "we've had just a little too much secrecy over this business already. For my part, I should like all Europe and America to hear the rights of it." He was a small, wiry, sunburnt man, clean-shaven, with a sharp face and alert manner.

"Then I'll tell our story right away," said the lady. "Frank here and I met in '84, in McQuire's camp, near the Rockies, where Pa was working a claim. We were engaged to each other, Frank and I; but then one day father struck a rich pocket and made a pile, while poor Frank here had a claim that petered out and came to nothing. The richer Pa grew the poorer was Frank; so at last Pa wouldn't hear of our engagement lasting any longer, and he took me away to 'Frisco. Frank wouldn't throw up his hand, though; so he followed me there, and he saw me without Pa knowing anything about it. It would only have made him mad to know, so we just fixed it all up for ourselves. Frank said that he would go and make his pile, too, and never come back to claim me until he had as much as Pa. So then I promised to wait for him to the end of time and pledged myself not to marry anyone else while he lived. 'Why shouldn't we be married right away, then,' said he, 'and then I will feel sure of you; and I won't claim to be your husband until I come back?' Well, we talked it over, and he had fixed it all up so nicely, with a clergyman all ready in waiting, that we just did it right there; and then Frank went off to seek his fortune, and I went back to Pa.

"The next I heard of Frank was that he was in Montana, and then he went prospecting in Arizona, and then I heard of him from New Mexico. After that came a long newspaper story about how a miners' camp had been attacked by Apache Indians, and there was my Frank's name among the killed. I fainted dead away, and I was very sick for months after. Pa thought I had a decline and took me to half the doctors in 'Frisco. Not a word of news came for a year and more, so that I never doubted that Frank was really dead. Then Lord St. Simon came to 'Frisco, and we came to London, and a marriage was arranged, and Pa was very pleased, but I felt all the time that no man on this earth would ever take the place in my heart that had been given to my poor Frank.

"Still, if I had married Lord St. Simon, of course I'd have done my duty by him. We can't command our love, but we can our actions. I went to the altar with him with the intention to make him just as good a wife as it was in me to be. But you may imagine what I felt when, just as I came to the altar rails, I glanced back and saw Frank standing and looking at me out of the first pew. I thought it was his ghost at first; but when I looked again there he was still, with a kind of question in his eyes, as if to ask me whether I were glad or sorry to see him. I wonder I didn't drop. I know that everything was turning round, and the words of the clergyman were just like the buzz of a bee in my ear. I didn't know what to do. Should I stop the service and make a scene in the church? I glanced at him again, and he seemed to know what I was thinking, for he raised his finger to his lips to tell me to be still. Then I saw him scribble on a piece of paper, and I knew that he was writing me a note. As I passed his pew on the way out I dropped my bouquet over to him, and he slipped the note into my hand when he returned me the flowers. It was only a line asking me to join him when he made the sign to me to do so. Of course I never doubted for a moment that my first duty was now to him, and I determined to do just whatever he might direct.

"When I got back I told my maid, who had known him in California, and had always been his friend. I ordered her to say nothing, but to get a few things packed and my ulster ready. I know I ought to have spoken to Lord St. Simon, but it was dreadful hard before his mother and all those great people. I just made up my mind to run away and explain afterwards. I hadn't been at the table ten minutes before I saw Frank out of the window at the other side of the road. He beckoned to me and then began walking into the Park. I slipped out, put on my things, and followed him. Some woman came talking something or other about Lord St. Simon to me--seemed to me from the little I heard as if he had a little secret of his own before marriage also--but I managed to get away from her and soon overtook Frank. We got into a cab together, and away we drove to some lodgings he had taken in Gordon Square, and that was my true wedding after all those years of waiting. Frank had been a prisoner among the Apaches, had escaped, came on to 'Frisco, found that I had given him up for dead and had gone to England, followed me there, and had come upon me at last on the very morning of my second wedding."

"I saw it in a paper," explained the American. "It gave the name and the church but not where the lady lived."

"Then we had a talk as to what we should do, and Frank was all for openness, but I was so ashamed of it all that I felt as if I should like to vanish away and never see any of them again--just sending a line to Pa, perhaps, to show him that I was alive. It was awful to me to think of all those lords and ladies sitting round that breakfast-table and waiting for me to come back. So Frank took my wedding-clothes and things and made a bundle of them, so that I should not be traced, and dropped them away somewhere where no one could find them. It is likely that we should have gone on to Paris to-morrow, only that this good gentleman, Mr. Holmes, came round to us this evening, though how he found us is more than I can think, and he showed us very clearly and kindly that I was wrong and that Frank was right, and that we should be putting ourselves in the wrong if we were so secret. Then he offered to give us a chance of talking to Lord St. Simon alone, and so we came right away round to his rooms at once. Now, Robert, you have heard it all, and I am very sorry if I have given you pain, and I hope that you do not think very meanly of me."

Lord St. Simon had by no means relaxed his rigid attitude, but had listened with a frowning brow and a compressed lip to this long narrative.

"Excuse me," he said, "but it is not my custom to discuss my most intimate personal affairs in this public manner."

"Then you won't forgive me? You won't shake hands before I go?"

"Oh, certainly, if it would give you any pleasure." He put out his hand and coldly grasped that which she extended to him.

"I had hoped," suggested Holmes, "that you would have joined us in a friendly supper."

"I think that there you ask a little too much," responded his Lordship. "I may be forced to acquiesce in these recent developments, but I can hardly be expected to make merry over them. I think that with your permission I will now wish you all a very good-night." He included us all in a sweeping bow and stalked out of the room.

"Then I trust that you at least will honour me with your company," said Sherlock Holmes. "It is always a joy to meet an American, Mr. Moulton, for I am one of those who believe that the folly of a monarch and the blundering of a minister in far-gone years will not prevent our children from being some day citizens of the same world-wide country under a flag which shall be a quartering of the Union Jack with the Stars and Stripes."

"The case has been an interesting one," remarked Holmes when our visitors had left us, "because it serves to show very clearly how simple the explanation may be of an affair which at first sight seems to be almost inexplicable. Nothing could be more natural than the sequence of events as narrated by this lady, and nothing stranger than the result when viewed, for instance, by Mr. Lestrade of Scotland Yard."

"You were not yourself at fault at all, then?"

"From the first, two facts were very obvious to me, the one that the lady had been quite willing to undergo the wedding ceremony, the other that she had repented of it within a few minutes of returning home. Obviously something had occurred during the morning, then, to cause her to change her mind. What could that something be? She could not have spoken to anyone when she was out, for she had been in the company of the bridegroom. Had she seen someone, then? If she had, it must be someone from America because she had spent so short a time in this country that she could hardly have allowed anyone to acquire so deep an influence over her that the mere sight of him would induce her to change her plans so completely. You see we have already arrived, by a process of exclusion, at the idea that she might have seen an American. Then who could this American be, and why should he possess so much influence over her? It might be a lover; it might be a husband. Her young womanhood had, I knew, been spent in rough scenes and under strange conditions. So far I had got before I ever heard Lord St. Simon's narrative. When he told us of a man in a pew, of the change in the bride's manner, of so transparent a device for obtaining a note as the dropping of a bouquet, of her resort to her confidential maid, and of her very significant allusion to claim-jumping--which in miners' parlance means taking possession of that which another person has a prior claim to--the whole situation became absolutely clear. She had gone off with a man, and the man was either a lover or was a previous husband--the chances being in favour of the latter."

"And how in the world did you find them?"

"It might have been difficult, but friend Lestrade held information in his hands the value of which he did not himself know. The initials were, of course, of the highest importance, but more valuable still was it to know that within a week he had settled his bill at one of the most select London hotels."

"How did you deduce the select?"

"By the select prices. Eight shillings for a bed and eightpence for a glass of sherry pointed to one of the most expensive hotels. There are not many in London which charge at that rate. In the second one which I visited in Northumberland Avenue, I learned by an inspection of the book that Francis H. Moulton, an American gentleman, had left only the day before, and on looking over the entries against him, I came upon the very items which I had seen in the duplicate bill. His letters were to be forwarded to 226 Gordon Square; so thither I travelled, and being fortunate enough to find the loving couple at home, I ventured to give them some paternal advice and to point out to them that it would be better in every way that they should make their position a little clearer both to the general public and to Lord St. Simon in particular. I invited them to meet him here, and, as you see, I made him keep the appointment."

"But with no very good result," I remarked. "His conduct was certainly not very gracious."

"Ah, Watson," said Holmes, smiling, "perhaps you would not be very gracious either, if, after all the trouble of wooing and wedding, you found yourself deprived in an instant of wife and of fortune. I think that we may judge Lord St. Simon very mercifully and thank our stars that we are never likely to find ourselves in the same position. Draw your chair up and hand me my violin, for the only problem we have still to solve is how to while away these bleak autumnal evenings."

XI.  THE ADVENTURE OF THE BERYL CORONET


"Holmes," said I as I stood one morning in our bow-window looking down the street, "here is a madman coming along. It seems rather sad that his relatives should allow him to come out alone."

My friend rose lazily from his armchair and stood with his hands in the pockets of his dressing-gown, looking over my shoulder. It was a bright, crisp February morning, and the snow of the day before still lay deep upon the ground, shimmering brightly in the wintry sun. Down the centre of Baker Street it had been ploughed into a brown crumbly band by the traffic, but at either side and on the heaped-up edges of the foot-paths it still lay as white as when it fell. The grey pavement had been cleaned and scraped, but was still dangerously slippery, so that there were fewer passengers than usual. Indeed, from the direction of the Metropolitan Station no one was coming save the single gentleman whose eccentric conduct had drawn my attention.

He was a man of about fifty, tall, portly, and imposing, with a massive, strongly marked face and a commanding figure. He was dressed in a sombre yet rich style, in black frock-coat, shining hat, neat brown gaiters, and well-cut pearl-grey trousers. Yet his actions were in absurd contrast to the dignity of his dress and features, for he was running hard, with occasional little springs, such as a weary man gives who is little accustomed to set any tax upon his legs. As he ran he jerked his hands up and down, waggled his head, and writhed his face into the most extraordinary contortions.

"What on earth can be the matter with him?" I asked. "He is looking up at the numbers of the houses."

"I believe that he is coming here," said Holmes, rubbing his hands.

"Here?"

"Yes; I rather think he is coming to consult me professionally. I think that I recognise the symptoms. Ha! did I not tell you?" As he spoke, the man, puffing and blowing, rushed at our door and pulled at our bell until the whole house resounded with the clanging.

A few moments later he was in our room, still puffing, still gesticulating, but with so fixed a look of grief and despair in his eyes that our smiles were turned in an instant to horror and pity. For a while he could not get his words out, but swayed his body and plucked at his hair like one who has been driven to the extreme limits of his reason. Then, suddenly springing to his feet, he beat his head against the wall with such force that we both rushed upon him and tore him away to the centre of the room. Sherlock Holmes pushed him down into the easy-chair and, sitting beside him, patted his hand and chatted with him in the easy, soothing tones which he knew so well how to employ.

"You have come to me to tell your story, have you not?" said he. "You are fatigued with your haste. Pray wait until you have recovered yourself, and then I shall be most happy to look into any little problem which you may submit to me."

The man sat for a minute or more with a heaving chest, fighting against his emotion. Then he passed his handkerchief over his brow, set his lips tight, and turned his face towards us.

"No doubt you think me mad?" said he.

"I see that you have had some great trouble," responded Holmes.

"God knows I have!--a trouble which is enough to unseat my reason, so sudden and so terrible is it. Public disgrace I might have faced, although I am a man whose character has never yet borne a stain. Private affliction also is the lot of every man; but the two coming together, and in so frightful a form, have been enough to shake my very soul. Besides, it is not I alone. The very noblest in the land may suffer unless some way be found out of this horrible affair."

"Pray compose yourself, sir," said Holmes, "and let me have a clear account of who you are and what it is that has befallen you."

"My name," answered our visitor, "is probably familiar to your ears. I am Alexander Holder, of the banking firm of Holder & Stevenson, of Threadneedle Street."

The name was indeed well known to us as belonging to the senior partner in the second largest private banking concern in the City of London. What could have happened, then, to bring one of the foremost citizens of London to this most pitiable pass? We waited, all curiosity, until with another effort he braced himself to tell his story.

"I feel that time is of value," said he; "that is why I hastened here when the police inspector suggested that I should secure your co-operation. I came to Baker Street by the Underground and hurried from there on foot, for the cabs go slowly through this snow. That is why I was so out of breath, for I am a man who takes very little exercise. I feel better now, and I will put the facts before you as shortly and yet as clearly as I can.

"It is, of course, well known to you that in a successful banking business as much depends upon our being able to find remunerative investments for our funds as upon our increasing our connection and the number of our depositors. One of our most lucrative means of laying out money is in the shape of loans, where the security is unimpeachable. We have done a good deal in this direction during the last few years, and there are many noble families to whom we have advanced large sums upon the security of their pictures, libraries, or plate.

"Yesterday morning I was seated in my office at the bank when a card was brought in to me by one of the clerks. I started when I saw the name, for it was that of none other than--well, perhaps even to you I had better say no more than that it was a name which is a household word all over the earth--one of the highest, noblest, most exalted names in England. I was overwhelmed by the honour and attempted, when he entered, to say so, but he plunged at once into business with the air of a man who wishes to hurry quickly through a disagreeable task.

" 'Mr. Holder,' said he, 'I have been informed that you are in the habit of advancing money.'

" 'The firm does so when the security is good.' I answered.

" 'It is absolutely essential to me,' said he, 'that I should have $50,000 at once. I could, of course, borrow so trifling a sum ten times over from my friends, but I much prefer to make it a matter of business and to carry out that business myself. In my position you can readily understand that it is unwise to place one's self under obligations.'

" 'For how long, may I ask, do you want this sum?' I asked.

" 'Next Monday I have a large sum due to me, and I shall then most certainly repay what you advance, with whatever interest you think it right to charge. But it is very essential to me that the money should be paid at once.'

" 'I should be happy to advance it without further parley from my own private purse,' said I, 'were it not that the strain would be rather more than it could bear. If, on the other hand, I am to do it in the name of the firm, then in justice to my partner I must insist that, even in your case, every businesslike precaution should be taken.'

" 'I should much prefer to have it so,' said he, raising up a square, black morocco case which he had laid beside his chair. 'You have doubtless heard of the Beryl Coronet?'

" 'One of the most precious public possessions of the empire,' said I.

" 'Precisely.' He opened the case, and there, imbedded in soft, flesh-coloured velvet, lay the magnificent piece of jewellery which he had named. 'There are thirty-nine enormous beryls,' said he, 'and the price of the gold chasing is incalculable. The lowest estimate would put the worth of the coronet at double the sum which I have asked. I am prepared to leave it with you as my security.'

"I took the precious case into my hands and looked in some perplexity from it to my illustrious client.

" 'You doubt its value?' he asked.

" 'Not at all. I only doubt--'

" 'The propriety of my leaving it. You may set your mind at rest about that. I should not dream of doing so were it not absolutely certain that I should be able in four days to reclaim it. It is a pure matter of form. Is the security sufficient?'

" 'Ample.'

" 'You understand, Mr. Holder, that I am giving you a strong proof of the confidence which I have in you, founded upon all that I have heard of you. I rely upon you not only to be discreet and to refrain from all gossip upon the matter but, above all, to preserve this coronet with every possible precaution because I need not say that a great public scandal would be caused if any harm were to befall it. Any injury to it would be almost as serious as its complete loss, for there are no beryls in the world to match these, and it would be impossible to replace them. I leave it with you, however, with every confidence, and I shall call for it in person on Monday morning.'

"Seeing that my client was anxious to leave, I said no more but, calling for my cashier, I ordered him to pay over fifty $1000 notes. When I was alone once more, however, with the precious case lying upon the table in front of me, I could not but think with some misgivings of the immense responsibility which it entailed upon me. There could be no doubt that, as it was a national possession, a horrible scandal would ensue if any misfortune should occur to it. I already regretted having ever consented to take charge of it. However, it was too late to alter the matter now, so I locked it up in my private safe and turned once more to my work.

"When evening came I felt that it would be an imprudence to leave so precious a thing in the office behind me. Bankers' safes had been forced before now, and why should not mine be? If so, how terrible would be the position in which I should find myself! I determined, therefore, that for the next few days I would always carry the case backward and forward with me, so that it might never be really out of my reach. With this intention, I called a cab and drove out to my house at Streatham, carrying the jewel with me. I did not breathe freely until I had taken it upstairs and locked it in the bureau of my dressing-room.

"And now a word as to my household, Mr. Holmes, for I wish you to thoroughly understand the situation. My groom and my page sleep out of the house, and may be set aside altogether. I have three maid-servants who have been with me a number of years and whose absolute reliability is quite above suspicion. Another, Lucy Parr, the second waiting-maid, has only been in my service a few months. She came with an excellent character, however, and has always given me satisfaction. She is a very pretty girl and has attracted admirers who have occasionally hung about the place. That is the only drawback which we have found to her, but we believe her to be a thoroughly good girl in every way.

"So much for the servants. My family itself is so small that it will not take me long to describe it. I am a widower and have an only son, Arthur. He has been a disappointment to me, Mr. Holmes--a grievous disappointment. I have no doubt that I am myself to blame. People tell me that I have spoiled him. Very likely I have. When my dear wife died I felt that he was all I had to love. I could not bear to see the smile fade even for a moment from his face. I have never denied him a wish. Perhaps it would have been better for both of us had I been sterner, but I meant it for the best.

"It was naturally my intention that he should succeed me in my business, but he was not of a business turn. He was wild, wayward, and, to speak the truth, I could not trust him in the handling of large sums of money. When he was young he became a member of an aristocratic club, and there, having charming manners, he was soon the intimate of a number of men with long purses and expensive habits. He learned to play heavily at cards and to squander money on the turf, until he had again and again to come to me and implore me to give him an advance upon his allowance, that he might settle his debts of honour. He tried more than once to break away from the dangerous company which he was keeping, but each time the influence of his friend, Sir George Burnwell, was enough to draw him back again.

"And, indeed, I could not wonder that such a man as Sir George Burnwell should gain an influence over him, for he has frequently brought him to my house, and I have found myself that I could hardly resist the fascination of his manner. He is older than Arthur, a man of the world to his finger-tips, one who had been everywhere, seen everything, a brilliant talker, and a man of great personal beauty. Yet when I think of him in cold blood, far away from the glamour of his presence, I am convinced from his cynical speech and the look which I have caught in his eyes that he is one who should be deeply distrusted. So I think, and so, too, thinks my little Mary, who has a woman's quick insight into character.

"And now there is only she to be described. She is my niece; but when my brother died five years ago and left her alone in the world I adopted her, and have looked upon her ever since as my daughter. She is a sunbeam in my house--sweet, loving, beautiful, a wonderful manager and housekeeper, yet as tender and quiet and gentle as a woman could be. She is my right hand. I do not know what I could do without her. In only one matter has she ever gone against my wishes. Twice my boy has asked her to marry him, for he loves her devotedly, but each time she has refused him. I think that if anyone could have drawn him into the right path it would have been she, and that his marriage might have changed his whole life; but now, alas! it is too late--forever too late!

"Now, Mr. Holmes, you know the people who live under my roof, and I shall continue with my miserable story.

"When we were taking coffee in the drawing-room that night after dinner, I told Arthur and Mary my experience, and of the precious treasure which we had under our roof, suppressing only the name of my client. Lucy Parr, who had brought in the coffee, had, I am sure, left the room; but I cannot swear that the door was closed. Mary and Arthur were much interested and wished to see the famous coronet, but I thought it better not to disturb it.

" 'Where have you put it?' asked Arthur.

" 'In my own bureau.'

" 'Well, I hope to goodness the house won't be burgled during the night.' said he.

" 'It is locked up,' I answered.

" 'Oh, any old key will fit that bureau. When I was a youngster I have opened it myself with the key of the box-room cupboard.'

"He often had a wild way of talking, so that I thought little of what he said. He followed me to my room, however, that night with a very grave face.

" 'Look here, dad,' said he with his eyes cast down, 'can you let me have $200?'

" 'No, I cannot!' I answered sharply. 'I have been far too generous with you in money matters.'

" 'You have been very kind,' said he, 'but I must have this money, or else I can never show my face inside the club again.'

" 'And a very good thing, too!' I cried.

" 'Yes, but you would not have me leave it a dishonoured man,' said he. 'I could not bear the disgrace. I must raise the money in some way, and if you will not let me have it, then I must try other means.'

"I was very angry, for this was the third demand during the month. 'You shall not have a farthing from me,' I cried, on which he bowed and left the room without another word.

"When he was gone I unlocked my bureau, made sure that my treasure was safe, and locked it again. Then I started to go round the house to see that all was secure--a duty which I usually leave to Mary but which I thought it well to perform myself that night. As I came down the stairs I saw Mary herself at the side window of the hall, which she closed and fastened as I approached.

" 'Tell me, dad,' said she, looking, I thought, a little disturbed, 'did you give Lucy, the maid, leave to go out to-night?'

" 'Certainly not.'

" 'She came in just now by the back door. I have no doubt that she has only been to the side gate to see someone, but I think that it is hardly safe and should be stopped.'

" 'You must speak to her in the morning, or I will if you prefer it. Are you sure that everything is fastened?'

" 'Quite sure, dad.'

" 'Then, good-night.' I kissed her and went up to my bedroom again, where I was soon asleep.

"I am endeavouring to tell you everything, Mr. Holmes, which may have any bearing upon the case, but I beg that you will question me upon any point which I do not make clear."

"On the contrary, your statement is singularly lucid."

"I come to a part of my story now in which I should wish to be particularly so. I am not a very heavy sleeper, and the anxiety in my mind tended, no doubt, to make me even less so than usual. About two in the morning, then, I was awakened by some sound in the house. It had ceased ere I was wide awake, but it had left an impression behind it as though a window had gently closed somewhere. I lay listening with all my ears. Suddenly, to my horror, there was a distinct sound of footsteps moving softly in the next room. I slipped out of bed, all palpitating with fear, and peeped round the corner of my dressing-room door.

" 'Arthur!' I screamed, 'you villain! you thief! How dare you touch that coronet?'

"The gas was half up, as I had left it, and my unhappy boy, dressed only in his shirt and trousers, was standing beside the light, holding the coronet in his hands. He appeared to be wrenching at it, or bending it with all his strength. At my cry he dropped it from his grasp and turned as pale as death. I snatched it up and examined it. One of the gold corners, with three of the beryls in it, was missing.

" 'You blackguard!' I shouted, beside myself with rage. 'You have destroyed it! You have dishonoured me forever! Where are the jewels which you have stolen?'

" 'Stolen!' he cried.

" 'Yes, thief!' I roared, shaking him by the shoulder.

" 'There are none missing. There cannot be any missing,' said he.

" 'There are three missing. And you know where they are. Must I call you a liar as well as a thief? Did I not see you trying to tear off another piece?'

" 'You have called me names enough,' said he, 'I will not stand it any longer. I shall not say another word about this business, since you have chosen to insult me. I will leave your house in the morning and make my own way in the world.'

" 'You shall leave it in the hands of the police!' I cried half-mad with grief and rage. 'I shall have this matter probed to the bottom.'

" 'You shall learn nothing from me,' said he with a passion such as I should not have thought was in his nature. 'If you choose to call the police, let the police find what they can.'

"By this time the whole house was astir, for I had raised my voice in my anger. Mary was the first to rush into my room, and, at the sight of the coronet and of Arthur's face, she read the whole story and, with a scream, fell down senseless on the ground. I sent the house-maid for the police and put the investigation into their hands at once. When the inspector and a constable entered the house, Arthur, who had stood sullenly with his arms folded, asked me whether it was my intention to charge him with theft. I answered that it had ceased to be a private matter, but had become a public one, since the ruined coronet was national property. I was determined that the law should have its way in everything.

" 'At least,' said he, 'you will not have me arrested at once. It would be to your advantage as well as mine if I might leave the house for five minutes.'

" 'That you may get away, or perhaps that you may conceal what you have stolen,' said I. And then, realising the dreadful position in which I was placed, I implored him to remember that not only my honour but that of one who was far greater than I was at stake; and that he threatened to raise a scandal which would convulse the nation. He might avert it all if he would but tell me what he had done with the three missing stones.

" 'You may as well face the matter,' said I; 'you have been caught in the act, and no confession could make your guilt more heinous. If you but make such reparation as is in your power, by telling us where the beryls are, all shall be forgiven and forgotten.'

" 'Keep your forgiveness for those who ask for it,' he answered, turning away from me with a sneer. I saw that he was too hardened for any words of mine to influence him. There was but one way for it. I called in the inspector and gave him into custody. A search was made at once not only of his person but of his room and of every portion of the house where he could possibly have concealed the gems; but no trace of them could be found, nor would the wretched boy open his mouth for all our persuasions and our threats. This morning he was removed to a cell, and I, after going through all the police formalities, have hurried round to you to implore you to use your skill in unravelling the matter. The police have openly confessed that they can at present make nothing of it. You may go to any expense which you think necessary. I have already offered a reward of $1000. My God, what shall I do! I have lost my honour, my gems, and my son in one night. Oh, what shall I do!"

He put a hand on either side of his head and rocked himself to and fro, droning to himself like a child whose grief has got beyond words.

Sherlock Holmes sat silent for some few minutes, with his brows knitted and his eyes fixed upon the fire.

"Do you receive much company?" he asked.

"None save my partner with his family and an occasional friend of Arthur's. Sir George Burnwell has been several times lately. No one else, I think."

"Do you go out much in society?"

"Arthur does. Mary and I stay at home. We neither of us care for it."

"That is unusual in a young girl."

"She is of a quiet nature. Besides, she is not so very young. She is four-and-twenty."

"This matter, from what you say, seems to have been a shock to her also."

"Terrible! She is even more affected than I."

"You have neither of you any doubt as to your son's guilt?"

"How can we have when I saw him with my own eyes with the coronet in his hands."

"I hardly consider that a conclusive proof. Was the remainder of the coronet at all injured?"

"Yes, it was twisted."

"Do you not think, then, that he might have been trying to straighten it?"

"God bless you! You are doing what you can for him and for me. But it is too heavy a task. What was he doing there at all? If his purpose were innocent, why did he not say so?"

"Precisely. And if it were guilty, why did he not invent a lie? His silence appears to me to cut both ways. There are several singular points about the case. What did the police think of the noise which awoke you from your sleep?"

"They considered that it might be caused by Arthur's closing his bedroom door."

"A likely story! As if a man bent on felony would slam his door so as to wake a household. What did they say, then, of the disappearance of these gems?"

"They are still sounding the planking and probing the furniture in the hope of finding them."

"Have they thought of looking outside the house?"

"Yes, they have shown extraordinary energy. The whole garden has already been minutely examined."

"Now, my dear sir," said Holmes. "is it not obvious to you now that this matter really strikes very much deeper than either you or the police were at first inclined to think? It appeared to you to be a simple case; to me it seems exceedingly complex. Consider what is involved by your theory. You suppose that your son came down from his bed, went, at great risk, to your dressing-room, opened your bureau, took out your coronet, broke off by main force a small portion of it, went off to some other place, concealed three gems out of the thirty-nine, with such skill that nobody can find them, and then returned with the other thirty-six into the room in which he exposed himself to the greatest danger of being discovered. I ask you now, is such a theory tenable?"

"But what other is there?" cried the banker with a gesture of despair. "If his motives were innocent, why does he not explain them?"

"It is our task to find that out," replied Holmes; "so now, if you please, Mr. Holder, we will set off for Streatham together, and devote an hour to glancing a little more closely into details."

My friend insisted upon my accompanying them in their expedition, which I was eager enough to do, for my curiosity and sympathy were deeply stirred by the story to which we had listened. I confess that the guilt of the banker's son appeared to me to be as obvious as it did to his unhappy father, but still I had such faith in Holmes' judgment that I felt that there must be some grounds for hope as long as he was dissatisfied with the accepted explanation. He hardly spoke a word the whole way out to the southern suburb, but sat with his chin upon his breast and his hat drawn over his eyes, sunk in the deepest thought. Our client appeared to have taken fresh heart at the little glimpse of hope which had been presented to him, and he even broke into a desultory chat with me over his business affairs. A short railway journey and a shorter walk brought us to Fairbank, the modest residence of the great financier.

Fairbank was a good-sized square house of white stone, standing back a little from the road. A double carriage-sweep, with a snow-clad lawn, stretched down in front to two large iron gates which closed the entrance. On the right side was a small wooden thicket, which led into a narrow path between two neat hedges stretching from the road to the kitchen door, and forming the tradesmen's entrance. On the left ran a lane which led to the stables, and was not itself within the grounds at all, being a public, though little used, thoroughfare. Holmes left us standing at the door and walked slowly all round the house, across the front, down the tradesmen's path, and so round by the garden behind into the stable lane. So long was he that Mr. Holder and I went into the dining-room and waited by the fire until he should return. We were sitting there in silence when the door opened and a young lady came in. She was rather above the middle height, slim, with dark hair and eyes, which seemed the darker against the absolute pallor of her skin. I do not think that I have ever seen such deadly paleness in a woman's face. Her lips, too, were bloodless, but her eyes were flushed with crying. As she swept silently into the room she impressed me with a greater sense of grief than the banker had done in the morning, and it was the more striking in her as she was evidently a woman of strong character, with immense capacity for self-restraint. Disregarding my presence, she went straight to her uncle and passed her hand over his head with a sweet womanly caress.

"You have given orders that Arthur should be liberated, have you not, dad?" she asked.

"No, no, my girl, the matter must be probed to the bottom."

"But I am so sure that he is innocent. You know what woman's instincts are. I know that he has done no harm and that you will be sorry for having acted so harshly."

"Why is he silent, then, if he is innocent?"

"Who knows? Perhaps because he was so angry that you should suspect him."

"How could I help suspecting him, when I actually saw him with the coronet in his hand?"

"Oh, but he had only picked it up to look at it. Oh, do, do take my word for it that he is innocent. Let the matter drop and say no more. It is so dreadful to think of our dear Arthur in prison!"

"I shall never let it drop until the gems are found--never, Mary! Your affection for Arthur blinds you as to the awful consequences to me. Far from hushing the thing up, I have brought a gentleman down from London to inquire more deeply into it."

"This gentleman?" she asked, facing round to me.

"No, his friend. He wished us to leave him alone. He is round in the stable lane now."

"The stable lane?" She raised her dark eyebrows. "What can he hope to find there? Ah! this, I suppose, is he. I trust, sir, that you will succeed in proving, what I feel sure is the truth, that my cousin Arthur is innocent of this crime."

"I fully share your opinion, and I trust, with you, that we may prove it," returned Holmes, going back to the mat to knock the snow from his shoes. "I believe I have the honour of addressing Miss Mary Holder. Might I ask you a question or two?"

"Pray do, sir, if it may help to clear this horrible affair up."

"You heard nothing yourself last night?"

"Nothing, until my uncle here began to speak loudly. I heard that, and I came down."

"You shut up the windows and doors the night before. Did you fasten all the windows?"

"Yes."

"Were they all fastened this morning?"

"Yes."

"You have a maid who has a sweetheart? I think that you remarked to your uncle last night that she had been out to see him?"

"Yes, and she was the girl who waited in the drawing-room, and who may have heard uncle's remarks about the coronet."

"I see. You infer that she may have gone out to tell her sweetheart, and that the two may have planned the robbery."

"But what is the good of all these vague theories," cried the banker impatiently, "when I have told you that I saw Arthur with the coronet in his hands?"

"Wait a little, Mr. Holder. We must come back to that. About this girl, Miss Holder. You saw her return by the kitchen door, I presume?"

"Yes; when I went to see if the door was fastened for the night I met her slipping in. I saw the man, too, in the gloom."

"Do you know him?"

"Oh, yes! he is the green-grocer who brings our vegetables round. His name is Francis Prosper."

"He stood," said Holmes, "to the left of the door--that is to say, farther up the path than is necessary to reach the door?"

"Yes, he did."

"And he is a man with a wooden leg?"

Something like fear sprang up in the young lady's expressive black eyes. "Why, you are like a magician," said she. "How do you know that?" She smiled, but there was no answering smile in Holmes' thin, eager face.

"I should be very glad now to go upstairs," said he. "I shall probably wish to go over the outside of the house again. Perhaps I had better take a look at the lower windows before I go up."

He walked swiftly round from one to the other, pausing only at the large one which looked from the hall onto the stable lane. This he opened and made a very careful examination of the sill with his powerful magnifying lens. "Now we shall go upstairs," said he at last.

The banker's dressing-room was a plainly furnished little chamber, with a grey carpet, a large bureau, and a long mirror. Holmes went to the bureau first and looked hard at the lock.

"Which key was used to open it?" he asked.

"That which my son himself indicated--that of the cupboard of the lumber-room."

"Have you it here?"

"That is it on the dressing-table."

Sherlock Holmes took it up and opened the bureau.

"It is a noiseless lock," said he. "It is no wonder that it did not wake you. This case, I presume, contains the coronet. We must have a look at it." He opened the case, and taking out the diadem he laid it upon the table. It was a magnificent specimen of the jeweller's art, and the thirty-six stones were the finest that I have ever seen. At one side of the coronet was a cracked edge, where a corner holding three gems had been torn away.

"Now, Mr. Holder," said Holmes, "here is the corner which corresponds to that which has been so unfortunately lost. Might I beg that you will break it off."

The banker recoiled in horror. "I should not dream of trying," said he.

"Then I will." Holmes suddenly bent his strength upon it, but without result. "I feel it give a little," said he; "but, though I am exceptionally strong in the fingers, it would take me all my time to break it. An ordinary man could not do it. Now, what do you think would happen if I did break it, Mr. Holder? There would be a noise like a pistol shot. Do you tell me that all this happened within a few yards of your bed and that you heard nothing of it?"

"I do not know what to think. It is all dark to me."

"But perhaps it may grow lighter as we go. What do you think, Miss Holder?"

"I confess that I still share my uncle's perplexity."

"Your son had no shoes or slippers on when you saw him?"

"He had nothing on save only his trousers and shirt."

"Thank you. We have certainly been favoured with extraordinary luck during this inquiry, and it will be entirely our own fault if we do not succeed in clearing the matter up. With your permission, Mr. Holder, I shall now continue my investigations outside."

He went alone, at his own request, for he explained that any unnecessary footmarks might make his task more difficult. For an hour or more he was at work, returning at last with his feet heavy with snow and his features as inscrutable as ever.

"I think that I have seen now all that there is to see, Mr. Holder," said he; "I can serve you best by returning to my rooms."

"But the gems, Mr. Holmes. Where are they?"

"I cannot tell."

The banker wrung his hands. "I shall never see them again!" he cried. "And my son? You give me hopes?"

"My opinion is in no way altered."

"Then, for God's sake, what was this dark business which was acted in my house last night?"

"If you can call upon me at my Baker Street rooms to-morrow morning between nine and ten I shall be happy to do what I can to make it clearer. I understand that you give me carte blanche to act for you, provided only that I get back the gems, and that you place no limit on the sum I may draw."

"I would give my fortune to have them back."

"Very good. I shall look into the matter between this and then. Good-bye; it is just possible that I may have to come over here again before evening."

It was obvious to me that my companion's mind was now made up about the case, although what his conclusions were was more than I could even dimly imagine. Several times during our homeward journey I endeavoured to sound him upon the point, but he always glided away to some other topic, until at last I gave it over in despair. It was not yet three when we found ourselves in our rooms once more. He hurried to his chamber and was down again in a few minutes dressed as a common loafer. With his collar turned up, his shiny, seedy coat, his red cravat, and his worn boots, he was a perfect sample of the class.

"I think that this should do," said he, glancing into the glass above the fireplace. "I only wish that you could come with me, Watson, but I fear that it won't do. I may be on the trail in this matter, or I may be following a will-o'-the-wisp, but I shall soon know which it is. I hope that I may be back in a few hours." He cut a slice of beef from the joint upon the sideboard, sandwiched it between two rounds of bread, and thrusting this rude meal into his pocket he started off upon his expedition.

I had just finished my tea when he returned, evidently in excellent spirits, swinging an old elastic-sided boot in his hand. He chucked it down into a corner and helped himself to a cup of tea.

"I only looked in as I passed," said he. "I am going right on."

"Where to?"

"Oh, to the other side of the West End. It may be some time before I get back. Don't wait up for me in case I should be late."

"How are you getting on?"

"Oh, so so. Nothing to complain of. I have been out to Streatham since I saw you last, but I did not call at the house. It is a very sweet little problem, and I would not have missed it for a good deal. However, I must not sit gossiping here, but must get these disreputable clothes off and return to my highly respectable self."

I could see by his manner that he had stronger reasons for satisfaction than his words alone would imply. His eyes twinkled, and there was even a touch of colour upon his sallow cheeks. He hastened upstairs, and a few minutes later I heard the slam of the hall door, which told me that he was off once more upon his congenial hunt.

I waited until midnight, but there was no sign of his return, so I retired to my room. It was no uncommon thing for him to be away for days and nights on end when he was hot upon a scent, so that his lateness caused me no surprise. I do not know at what hour he came in, but when I came down to breakfast in the morning there he was with a cup of coffee in one hand and the paper in the other, as fresh and trim as possible.

"You will excuse my beginning without you, Watson," said he, "but you remember that our client has rather an early appointment this morning."

"Why, it is after nine now," I answered. "I should not be surprised if that were he. I thought I heard a ring."

It was, indeed, our friend the financier. I was shocked by the change which had come over him, for his face which was naturally of a broad and massive mould, was now pinched and fallen in, while his hair seemed to me at least a shade whiter. He entered with a weariness and lethargy which was even more painful than his violence of the morning before, and he dropped heavily into the armchair which I pushed forward for him.

"I do not know what I have done to be so severely tried," said he. "Only two days ago I was a happy and prosperous man, without a care in the world. Now I am left to a lonely and dishonoured age. One sorrow comes close upon the heels of another. My niece, Mary, has deserted me."

"Deserted you?"

"Yes. Her bed this morning had not been slept in, her room was empty, and a note for me lay upon the hall table. I had said to her last night, in sorrow and not in anger, that if she had married my boy all might have been well with him. Perhaps it was thoughtless of me to say so. It is to that remark that she refers in this note:

" 'MY DEAREST UNCLE:--I feel that I have brought trouble upon you, and that if I had acted differently this terrible misfortune might never have occurred. I cannot, with this thought in my mind, ever again be happy under your roof, and I feel that I must leave you forever. Do not worry about my future, for that is provided for; and, above all, do not search for me, for it will be fruitless labour and an ill-service to me. In life or in death, I am ever your loving


" 'MARY.'

"What could she mean by that note, Mr. Holmes? Do you think it points to suicide?"

"No, no, nothing of the kind. It is perhaps the best possible solution. I trust, Mr. Holder, that you are nearing the end of your troubles."

"Ha! You say so! You have heard something, Mr. Holmes; you have learned something! Where are the gems?"

"You would not think $1000 apiece an excessive sum for them?"

"I would pay ten."

"That would be unnecessary. Three thousand will cover the matter. And there is a little reward, I fancy. Have you your check-book? Here is a pen. Better make it out for $4000."

With a dazed face the banker made out the required check. Holmes walked over to his desk, took out a little triangular piece of gold with three gems in it, and threw it down upon the table.

With a shriek of joy our client clutched it up.

"You have it!" he gasped. "I am saved! I am saved!"

The reaction of joy was as passionate as his grief had been, and he hugged his recovered gems to his bosom.

"There is one other thing you owe, Mr. Holder," said Sherlock Holmes rather sternly.

"Owe!" He caught up a pen. "Name the sum, and I will pay it."

"No, the debt is not to me. You owe a very humble apology to that noble lad, your son, who has carried himself in this matter as I should be proud to see my own son do, should I ever chance to have one."

"Then it was not Arthur who took them?"

"I told you yesterday, and I repeat to-day, that it was not."

"You are sure of it! Then let us hurry to him at once to let him know that the truth is known."

"He knows it already. When I had cleared it all up I had an interview with him, and finding that he would not tell me the story, I told it to him, on which he had to confess that I was right and to add the very few details which were not yet quite clear to me. Your news of this morning, however, may open his lips."

"For heaven's sake, tell me, then, what is this extraordinary mystery!"

"I will do so, and I will show you the steps by which I reached it. And let me say to you, first, that which it is hardest for me to say and for you to hear: there has been an understanding between Sir George Burnwell and your niece Mary. They have now fled together."

"My Mary? Impossible!"

"It is unfortunately more than possible; it is certain. Neither you nor your son knew the true character of this man when you admitted him into your family circle. He is one of the most dangerous men in England--a ruined gambler, an absolutely desperate villain, a man without heart or conscience. Your niece knew nothing of such men. When he breathed his vows to her, as he had done to a hundred before her, she flattered herself that she alone had touched his heart. The devil knows best what he said, but at least she became his tool and was in the habit of seeing him nearly every evening."

"I cannot, and I will not, believe it!" cried the banker with an ashen face.

"I will tell you, then, what occurred in your house last night. Your niece, when you had, as she thought, gone to your room, slipped down and talked to her lover through the window which leads into the stable lane. His footmarks had pressed right through the snow, so long had he stood there. She told him of the coronet. His wicked lust for gold kindled at the news, and he bent her to his will. I have no doubt that she loved you, but there are women in whom the love of a lover extinguishes all other loves, and I think that she must have been one. She had hardly listened to his instructions when she saw you coming downstairs, on which she closed the window rapidly and told you about one of the servants' escapade with her wooden-legged lover, which was all perfectly true.

"Your boy, Arthur, went to bed after his interview with you but he slept badly on account of his uneasiness about his club debts. In the middle of the night he heard a soft tread pass his door, so he rose and, looking out, was surprised to see his cousin walking very stealthily along the passage until she disappeared into your dressing-room. Petrified with astonishment, the lad slipped on some clothes and waited there in the dark to see what would come of this strange affair. Presently she emerged from the room again, and in the light of the passage-lamp your son saw that she carried the precious coronet in her hands. She passed down the stairs, and he, thrilling with horror, ran along and slipped behind the curtain near your door, whence he could see what passed in the hall beneath. He saw her stealthily open the window, hand out the coronet to someone in the gloom, and then closing it once more hurry back to her room, passing quite close to where he stood hid behind the curtain.

"As long as she was on the scene he could not take any action without a horrible exposure of the woman whom he loved. But the instant that she was gone he realised how crushing a misfortune this would be for you, and how all-important it was to set it right. He rushed down, just as he was, in his bare feet, opened the window, sprang out into the snow, and ran down the lane, where he could see a dark figure in the moonlight. Sir George Burnwell tried to get away, but Arthur caught him, and there was a struggle between them, your lad tugging at one side of the coronet, and his opponent at the other. In the scuffle, your son struck Sir George and cut him over the eye. Then something suddenly snapped, and your son, finding that he had the coronet in his hands, rushed back, closed the window, ascended to your room, and had just observed that the coronet had been twisted in the struggle and was endeavouring to straighten it when you appeared upon the scene."

"Is it possible?" gasped the banker.

"You then roused his anger by calling him names at a moment when he felt that he had deserved your warmest thanks. He could not explain the true state of affairs without betraying one who certainly deserved little enough consideration at his hands. He took the more chivalrous view, however, and preserved her secret."

"And that was why she shrieked and fainted when she saw the coronet," cried Mr. Holder. "Oh, my God! what a blind fool I have been! And his asking to be allowed to go out for five minutes! The dear fellow wanted to see if the missing piece were at the scene of the struggle. How cruelly I have misjudged him!"

"When I arrived at the house," continued Holmes, "I at once went very carefully round it to observe if there were any traces in the snow which might help me. I knew that none had fallen since the evening before, and also that there had been a strong frost to preserve impressions. I passed along the tradesmen's path, but found it all trampled down and indistinguishable. Just beyond it, however, at the far side of the kitchen door, a woman had stood and talked with a man, whose round impressions on one side showed that he had a wooden leg. I could even tell that they had been disturbed, for the woman had run back swiftly to the door, as was shown by the deep toe and light heel marks, while Wooden-leg had waited a little, and then had gone away. I thought at the time that this might be the maid and her sweetheart, of whom you had already spoken to me, and inquiry showed it was so. I passed round the garden without seeing anything more than random tracks, which I took to be the police; but when I got into the stable lane a very long and complex story was written in the snow in front of me.

"There was a double line of tracks of a booted man, and a second double line which I saw with delight belonged to a man with naked feet. I was at once convinced from what you had told me that the latter was your son. The first had walked both ways, but the other had run swiftly, and as his tread was marked in places over the depression of the boot, it was obvious that he had passed after the other. I followed them up and found they led to the hall window, where Boots had worn all the snow away while waiting. Then I walked to the other end, which was a hundred yards or more down the lane. I saw where Boots had faced round, where the snow was cut up as though there had been a struggle, and, finally, where a few drops of blood had fallen, to show me that I was not mistaken. Boots had then run down the lane, and another little smudge of blood showed that it was he who had been hurt. When he came to the highroad at the other end, I found that the pavement had been cleared, so there was an end to that clue.

"On entering the house, however, I examined, as you remember, the sill and framework of the hall window with my lens, and I could at once see that someone had passed out. I could distinguish the outline of an instep where the wet foot had been placed in coming in. I was then beginning to be able to form an opinion as to what had occurred. A man had waited outside the window; someone had brought the gems; the deed had been overseen by your son; he had pursued the thief; had struggled with him; they had each tugged at the coronet, their united strength causing injuries which neither alone could have effected. He had returned with the prize, but had left a fragment in the grasp of his opponent. So far I was clear. The question now was, who was the man and who was it brought him the coronet?

"It is an old maxim of mine that when you have excluded the impossible, whatever remains, however improbable, must be the truth. Now, I knew that it was not you who had brought it down, so there only remained your niece and the maids. But if it were the maids, why should your son allow himself to be accused in their place? There could be no possible reason. As he loved his cousin, however, there was an excellent explanation why he should retain her secret--the more so as the secret was a disgraceful one. When I remembered that you had seen her at that window, and how she had fainted on seeing the coronet again, my conjecture became a certainty.

"And who could it be who was her confederate? A lover evidently, for who else could outweigh the love and gratitude which she must feel to you? I knew that you went out little, and that your circle of friends was a very limited one. But among them was Sir George Burnwell. I had heard of him before as being a man of evil reputation among women. It must have been he who wore those boots and retained the missing gems. Even though he knew that Arthur had discovered him, he might still flatter himself that he was safe, for the lad could not say a word without compromising his own family.

"Well, your own good sense will suggest what measures I took next. I went in the shape of a loafer to Sir George's house, managed to pick up an acquaintance with his valet, learned that his master had cut his head the night before, and, finally, at the expense of six shillings, made all sure by buying a pair of his cast-off shoes. With these I journeyed down to Streatham and saw that they exactly fitted the tracks."

"I saw an ill-dressed vagabond in the lane yesterday evening," said Mr. Holder.

"Precisely. It was I. I found that I had my man, so I came home and changed my clothes. It was a delicate part which I had to play then, for I saw that a prosecution must be avoided to avert scandal, and I knew that so astute a villain would see that our hands were tied in the matter. I went and saw him. At first, of course, he denied everything. But when I gave him every particular that had occurred, he tried to bluster and took down a life-preserver from the wall. I knew my man, however, and I clapped a pistol to his head before he could strike. Then he became a little more reasonable. I told him that we would give him a price for the stones he held--$1000 apiece. That brought out the first signs of grief that he had shown. 'Why, dash it all!' said he, 'I've let them go at six hundred for the three!' I soon managed to get the address of the receiver who had them, on promising him that there would be no prosecution. Off I set to him, and after much chaffering I got our stones at $1000 apiece. Then I looked in upon your son, told him that all was right, and eventually got to my bed about two o'clock, after what I may call a really hard day's work."

"A day which has saved England from a great public scandal," said the banker, rising. "Sir, I cannot find words to thank you, but you shall not find me ungrateful for what you have done. Your skill has indeed exceeded all that I have heard of it. And now I must fly to my dear boy to apologise to him for the wrong which I have done him. As to what you tell me of poor Mary, it goes to my very heart. Not even your skill can inform me where she is now."

"I think that we may safely say," returned Holmes, "that she is wherever Sir George Burnwell is. It is equally certain, too, that whatever her sins are, they will soon receive a more than sufficient punishment."

XII.  THE ADVENTURE OF THE COPPER BEECHES


"To the man who loves art for its own sake," remarked Sherlock Holmes, tossing aside the advertisement sheet of the Daily Telegraph, "it is frequently in its least important and lowliest manifestations that the keenest pleasure is to be derived. It is pleasant to me to observe, Watson, that you have so far grasped this truth that in these little records of our cases which you have been good enough to draw up, and, I am bound to say, occasionally to embellish, you have given prominence not so much to the many causes celebres and sensational trials in which I have figured but rather to those incidents which may have been trivial in themselves, but which have given room for those faculties of deduction and of logical synthesis which I have made my special province."

"And yet," said I, smiling, "I cannot quite hold myself absolved from the charge of sensationalism which has been urged against my records."

"You have erred, perhaps," he observed, taking up a glowing cinder with the tongs and lighting with it the long cherry-wood pipe which was wont to replace his clay when he was in a disputatious rather than a meditative mood--"you have erred perhaps in attempting to put colour and life into each of your statements instead of confining yourself to the task of placing upon record that severe reasoning from cause to effect which is really the only notable feature about the thing."

"It seems to me that I have done you full justice in the matter," I remarked with some coldness, for I was repelled by the egotism which I had more than once observed to be a strong factor in my friend's singular character.

"No, it is not selfishness or conceit," said he, answering, as was his wont, my thoughts rather than my words. "If I claim full justice for my art, it is because it is an impersonal thing--a thing beyond myself. Crime is common. Logic is rare. Therefore it is upon the logic rather than upon the crime that you should dwell. You have degraded what should have been a course of lectures into a series of tales."

It was a cold morning of the early spring, and we sat after breakfast on either side of a cheery fire in the old room at Baker Street. A thick fog rolled down between the lines of dun-coloured houses, and the opposing windows loomed like dark, shapeless blurs through the heavy yellow wreaths. Our gas was lit and shone on the white cloth and glimmer of china and metal, for the table had not been cleared yet. Sherlock Holmes had been silent all the morning, dipping continuously into the advertisement columns of a succession of papers until at last, having apparently given up his search, he had emerged in no very sweet temper to lecture me upon my literary shortcomings.

"At the same time," he remarked after a pause, during which he had sat puffing at his long pipe and gazing down into the fire, "you can hardly be open to a charge of sensationalism, for out of these cases which you have been so kind as to interest yourself in, a fair proportion do not treat of crime, in its legal sense, at all. The small matter in which I endeavoured to help the King of Bohemia, the singular experience of Miss Mary Sutherland, the problem connected with the man with the twisted lip, and the incident of the noble bachelor, were all matters which are outside the pale of the law. But in avoiding the sensational, I fear that you may have bordered on the trivial."

"The end may have been so," I answered, "but the methods I hold to have been novel and of interest."

"Pshaw, my dear fellow, what do the public, the great unobservant public, who could hardly tell a weaver by his tooth or a compositor by his left thumb, care about the finer shades of analysis and deduction! But, indeed, if you are trivial. I cannot blame you, for the days of the great cases are past. Man, or at least criminal man, has lost all enterprise and originality. As to my own little practice, it seems to be degenerating into an agency for recovering lost lead pencils and giving advice to young ladies from boarding-schools. I think that I have touched bottom at last, however. This note I had this morning marks my zero-point, I fancy. Read it!" He tossed a crumpled letter across to me.

It was dated from Montague Place upon the preceding evening, and ran thus:

"DEAR MR. HOLMES:--I am very anxious to consult you as to whether I should or should not accept a situation which has been offered to me as governess. I shall call at half-past ten to-morrow if I do not inconvenience you. Yours faithfully,


"VIOLET HUNTER."

"Do you know the young lady?" I asked.

"Not I."

"It is half-past ten now."

"Yes, and I have no doubt that is her ring."

"It may turn out to be of more interest than you think. You remember that the affair of the blue carbuncle, which appeared to be a mere whim at first, developed into a serious investigation. It may be so in this case, also."

"Well, let us hope so. But our doubts will very soon be solved, for here, unless I am much mistaken, is the person in question."

As he spoke the door opened and a young lady entered the room. She was plainly but neatly dressed, with a bright, quick face, freckled like a plover's egg, and with the brisk manner of a woman who has had her own way to make in the world.

"You will excuse my troubling you, I am sure," said she, as my companion rose to greet her, "but I have had a very strange experience, and as I have no parents or relations of any sort from whom I could ask advice, I thought that perhaps you would be kind enough to tell me what I should do."

"Pray take a seat, Miss Hunter. I shall be happy to do anything that I can to serve you."

I could see that Holmes was favourably impressed by the manner and speech of his new client. He looked her over in his searching fashion, and then composed himself, with his lids drooping and his finger-tips together, to listen to her story.

"I have been a governess for five years," said she, "in the family of Colonel Spence Munro, but two months ago the colonel received an appointment at Halifax, in Nova Scotia, and took his children over to America with him, so that I found myself without a situation. I advertised, and I answered advertisements, but without success. At last the little money which I had saved began to run short, and I was at my wit's end as to what I should do.

"There is a well-known agency for governesses in the West End called Westaway's, and there I used to call about once a week in order to see whether anything had turned up which might suit me. Westaway was the name of the founder of the business, but it is really managed by Miss Stoper. She sits in her own little office, and the ladies who are seeking employment wait in an anteroom, and are then shown in one by one, when she consults her ledgers and sees whether she has anything which would suit them.

"Well, when I called last week I was shown into the little office as usual, but I found that Miss Stoper was not alone. A prodigiously stout man with a very smiling face and a great heavy chin which rolled down in fold upon fold over his throat sat at her elbow with a pair of glasses on his nose, looking very earnestly at the ladies who entered. As I came in he gave quite a jump in his chair and turned quickly to Miss Stoper.

" 'That will do,' said he; 'I could not ask for anything better. Capital! capital!' He seemed quite enthusiastic and rubbed his hands together in the most genial fashion. He was such a comfortable-looking man that it was quite a pleasure to look at him.

" 'You are looking for a situation, miss?' he asked.

" 'Yes, sir.'

" 'As governess?'

" 'Yes, sir.'

" 'And what salary do you ask?'

" 'I had $4 a month in my last place with Colonel Spence Munro.'

" 'Oh, tut, tut! sweating--rank sweating!' he cried, throwing his fat hands out into the air like a man who is in a boiling passion. 'How could anyone offer so pitiful a sum to a lady with such attractions and accomplishments?'

" 'My accomplishments, sir, may be less than you imagine,' said I. 'A little French, a little German, music, and drawing--'

" 'Tut, tut!' he cried. 'This is all quite beside the question. The point is, have you or have you not the bearing and deportment of a lady? There it is in a nutshell. If you have not, you are not fitted for the rearing of a child who may some day play a considerable part in the history of the country. But if you have why, then, how could any gentleman ask you to condescend to accept anything under the three figures? Your salary with me, madam, would commence at $100 a year.'

"You may imagine, Mr. Holmes, that to me, destitute as I was, such an offer seemed almost too good to be true. The gentleman, however, seeing perhaps the look of incredulity upon my face, opened a pocket-book and took out a note.

" 'It is also my custom,' said he, smiling in the most pleasant fashion until his eyes were just two little shining slits amid the white creases of his face, 'to advance to my young ladies half their salary beforehand, so that they may meet any little expenses of their journey and their wardrobe.'

"It seemed to me that I had never met so fascinating and so thoughtful a man. As I was already in debt to my tradesmen, the advance was a great convenience, and yet there was something unnatural about the whole transaction which made me wish to know a little more before I quite committed myself.

" 'May I ask where you live, sir?' said I.

" 'Hampshire. Charming rural place. The Copper Beeches, five miles on the far side of Winchester. It is the most lovely country, my dear young lady, and the dearest old country-house.'

" 'And my duties, sir? I should be glad to know what they would be.'

" 'One child--one dear little romper just six years old. Oh, if you could see him killing cockroaches with a slipper! Smack! smack! smack! Three gone before you could wink!' He leaned back in his chair and laughed his eyes into his head again.

"I was a little startled at the nature of the child's amusement, but the father's laughter made me think that perhaps he was joking.

" 'My sole duties, then,' I asked, 'are to take charge of a single child?'

" 'No, no, not the sole, not the sole, my dear young lady,' he cried. 'Your duty would be, as I am sure your good sense would suggest, to obey any little commands my wife might give, provided always that they were such commands as a lady might with propriety obey. You see no difficulty, heh?'

" 'I should be happy to make myself useful.'

" 'Quite so. In dress now, for example. We are faddy people, you know--faddy but kind-hearted. If you were asked to wear any dress which we might give you, you would not object to our little whim. Heh?'

" 'No,' said I, considerably astonished at his words.

" 'Or to sit here, or sit there, that would not be offensive to you?'

" 'Oh, no.'

" 'Or to cut your hair quite short before you come to us?'

"I could hardly believe my ears. As you may observe, Mr. Holmes, my hair is somewhat luxuriant, and of a rather peculiar tint of chestnut. It has been considered artistic. I could not dream of sacrificing it in this offhand fashion.

" 'I am afraid that that is quite impossible,' said I. He had been watching me eagerly out of his small eyes, and I could see a shadow pass over his face as I spoke.

" 'I am afraid that it is quite essential,' said he. 'It is a little fancy of my wife's, and ladies' fancies, you know, madam, ladies' fancies must be consulted. And so you won't cut your hair?'

" 'No, sir, I really could not,' I answered firmly.

" 'Ah, very well; then that quite settles the matter. It is a pity, because in other respects you would really have done very nicely. In that case, Miss Stoper, I had best inspect a few more of your young ladies.'

"The manageress had sat all this while busy with her papers without a word to either of us, but she glanced at me now with so much annoyance upon her face that I could not help suspecting that she had lost a handsome commission through my refusal.

" 'Do you desire your name to be kept upon the books?' she asked.

" 'If you please, Miss Stoper.'

" 'Well, really, it seems rather useless, since you refuse the most excellent offers in this fashion,' said she sharply. 'You can hardly expect us to exert ourselves to find another such opening for you. Good-day to you, Miss Hunter.' She struck a gong upon the table, and I was shown out by the page.

"Well, Mr. Holmes, when I got back to my lodgings and found little enough in the cupboard, and two or three bills upon the table. I began to ask myself whether I had not done a very foolish thing. After all, if these people had strange fads and expected obedience on the most extraordinary matters, they were at least ready to pay for their eccentricity. Very few governesses in England are getting $100 a year. Besides, what use was my hair to me? Many people are improved by wearing it short and perhaps I should be among the number. Next day I was inclined to think that I had made a mistake, and by the day after I was sure of it. I had almost overcome my pride so far as to go back to the agency and inquire whether the place was still open when I received this letter from the gentleman himself. I have it here and I will read it to you:


" 'The Copper Beeches, near Winchester.

" 'DEAR MISS HUNTER:--Miss Stoper has very kindly given me your address, and I write from here to ask you whether you have reconsidered your decision. My wife is very anxious that you should come, for she has been much attracted by my description of you. We are willing to give $30 a quarter, or $120 a year, so as to recompense you for any little inconvenience which our fads may cause you. They are not very exacting, after all. My wife is fond of a particular shade of electric blue and would like you to wear such a dress indoors in the morning. You need not, however, go to the expense of purchasing one, as we have one belonging to my dear daughter Alice (now in Philadelphia), which would, I should think, fit you very well. Then, as to sitting here or there, or amusing yourself in any manner indicated, that need cause you no inconvenience. As regards your hair, it is no doubt a pity, especially as I could not help remarking its beauty during our short interview, but I am afraid that I must remain firm upon this point, and I only hope that the increased salary may recompense you for the loss. Your duties, as far as the child is concerned, are very light. Now do try to come, and I shall meet you with the dog-cart at Winchester. Let me know your train. Yours faithfully,


" 'JEPHRO RUCASTLE.'

"That is the letter which I have just received, Mr. Holmes, and my mind is made up that I will accept it. I thought, however, that before taking the final step I should like to submit the whole matter to your consideration."

"Well, Miss Hunter, if your mind is made up, that settles the question," said Holmes, smiling.

"But you would not advise me to refuse?"

"I confess that it is not the situation which I should like to see a sister of mine apply for."

"What is the meaning of it all, Mr. Holmes?"

"Ah, I have no data. I cannot tell. Perhaps you have yourself formed some opinion?"

"Well, there seems to me to be only one possible solution. Mr. Rucastle seemed to be a very kind, good-natured man. Is it not possible that his wife is a lunatic, that he desires to keep the matter quiet for fear she should be taken to an asylum, and that he humours her fancies in every way in order to prevent an outbreak?"

"That is a possible solution--in fact, as matters stand, it is the most probable one. But in any case it does not seem to be a nice household for a young lady."

"But the money, Mr. Holmes, the money!"

"Well, yes, of course the pay is good--too good. That is what makes me uneasy. Why should they give you $120 a year, when they could have their pick for $40? There must be some strong reason behind."

"I thought that if I told you the circumstances you would understand afterwards if I wanted your help. I should feel so much stronger if I felt that you were at the back of me."

"Oh, you may carry that feeling away with you. I assure you that your little problem promises to be the most interesting which has come my way for some months. There is something distinctly novel about some of the features. If you should find yourself in doubt or in danger--"

"Danger! What danger do you foresee?"

Holmes shook his head gravely. "It would cease to be a danger if we could define it," said he. "But at any time, day or night, a telegram would bring me down to your help."

"That is enough." She rose briskly from her chair with the anxiety all swept from her face. "I shall go down to Hampshire quite easy in my mind now. I shall write to Mr. Rucastle at once, sacrifice my poor hair to-night, and start for Winchester to-morrow." With a few grateful words to Holmes she bade us both good-night and bustled off upon her way.

"At least," said I as we heard her quick, firm steps descending the stairs, "she seems to be a young lady who is very well able to take care of herself."

"And she would need to be," said Holmes gravely. "I am much mistaken if we do not hear from her before many days are past."

It was not very long before my friend's prediction was fulfilled. A fortnight went by, during which I frequently found my thoughts turning in her direction and wondering what strange side-alley of human experience this lonely woman had strayed into. The unusual salary, the curious conditions, the light duties, all pointed to something abnormal, though whether a fad or a plot, or whether the man were a philanthropist or a villain, it was quite beyond my powers to determine. As to Holmes, I observed that he sat frequently for half an hour on end, with knitted brows and an abstracted air, but he swept the matter away with a wave of his hand when I mentioned it. "Data! data! data!" he cried impatiently. "I can't make bricks without clay." And yet he would always wind up by muttering that no sister of his should ever have accepted such a situation.

The telegram which we eventually received came late one night just as I was thinking of turning in and Holmes was settling down to one of those all-night chemical researches which he frequently indulged in, when I would leave him stooping over a retort and a test-tube at night and find him in the same position when I came down to breakfast in the morning. He opened the yellow envelope, and then, glancing at the message, threw it across to me.

"Just look up the trains in Bradshaw," said he, and turned back to his chemical studies.

The summons was a brief and urgent one.

"Please be at the Black Swan Hotel at Winchester at midday to-morrow," it said. "Do come! I am at my wit's end.


"HUNTER."

"Will you come with me?" asked Holmes, glancing up.

"I should wish to."

"Just look it up, then."

"There is a train at half-past nine," said I, glancing over my Bradshaw. "It is due at Winchester at 11:30."

"That will do very nicely. Then perhaps I had better postpone my analysis of the acetones, as we may need to be at our best in the morning."

By eleven o'clock the next day we were well upon our way to the old English capital. Holmes had been buried in the morning papers all the way down, but after we had passed the Hampshire border he threw them down and began to admire the scenery. It was an ideal spring day, a light blue sky, flecked with little fleecy white clouds drifting across from west to east. The sun was shining very brightly, and yet there was an exhilarating nip in the air, which set an edge to a man's energy. All over the countryside, away to the rolling hills around Aldershot, the little red and grey roofs of the farm-steadings peeped out from amid the light green of the new foliage.

"Are they not fresh and beautiful?" I cried with all the enthusiasm of a man fresh from the fogs of Baker Street.

But Holmes shook his head gravely.

"Do you know, Watson," said he, "that it is one of the curses of a mind with a turn like mine that I must look at everything with reference to my own special subject. You look at these scattered houses, and you are impressed by their beauty. I look at them, and the only thought which comes to me is a feeling of their isolation and of the impunity with which crime may be committed there."

"Good heavens!" I cried. "Who would associate crime with these dear old homesteads?"

"They always fill me with a certain horror. It is my belief, Watson, founded upon my experience, that the lowest and vilest alleys in London do not present a more dreadful record of sin than does the smiling and beautiful countryside."

"You horrify me!"

"But the reason is very obvious. The pressure of public opinion can do in the town what the law cannot accomplish. There is no lane so vile that the scream of a tortured child, or the thud of a drunkard's blow, does not beget sympathy and indignation among the neighbours, and then the whole machinery of justice is ever so close that a word of complaint can set it going, and there is but a step between the crime and the dock. But look at these lonely houses, each in its own fields, filled for the most part with poor ignorant folk who know little of the law. Think of the deeds of hellish cruelty, the hidden wickedness which may go on, year in, year out, in such places, and none the wiser. Had this lady who appeals to us for help gone to live in Winchester, I should never have had a fear for her. It is the five miles of country which makes the danger. Still, it is clear that she is not personally threatened."

"No. If she can come to Winchester to meet us she can get away."

"Quite so. She has her freedom."

"What can be the matter, then? Can you suggest no explanation?"

"I have devised seven separate explanations, each of which would cover the facts as far as we know them. But which of these is correct can only be determined by the fresh information which we shall no doubt find waiting for us. Well, there is the tower of the cathedral, and we shall soon learn all that Miss Hunter has to tell."

The Black Swan is an inn of repute in the High Street, at no distance from the station, and there we found the young lady waiting for us. She had engaged a sitting-room, and our lunch awaited us upon the table.

"I am so delighted that you have come," she said earnestly. "It is so very kind of you both; but indeed I do not know what I should do. Your advice will be altogether invaluable to me."

"Pray tell us what has happened to you."

"I will do so, and I must be quick, for I have promised Mr. Rucastle to be back before three. I got his leave to come into town this morning, though he little knew for what purpose."

"Let us have everything in its due order." Holmes thrust his long thin legs out towards the fire and composed himself to listen.

"In the first place, I may say that I have met, on the whole, with no actual ill-treatment from Mr. and Mrs. Rucastle. It is only fair to them to say that. But I cannot understand them, and I am not easy in my mind about them."

"What can you not understand?"

"Their reasons for their conduct. But you shall have it all just as it occurred. When I came down, Mr. Rucastle met me here and drove me in his dog-cart to the Copper Beeches. It is, as he said, beautifully situated, but it is not beautiful in itself, for it is a large square block of a house, whitewashed, but all stained and streaked with damp and bad weather. There are grounds round it, woods on three sides, and on the fourth a field which slopes down to the Southampton highroad, which curves past about a hundred yards from the front door. This ground in front belongs to the house, but the woods all round are part of Lord Southerton's preserves. A clump of copper beeches immediately in front of the hall door has given its name to the place.

"I was driven over by my employer, who was as amiable as ever, and was introduced by him that evening to his wife and the child. There was no truth, Mr. Holmes, in the conjecture which seemed to us to be probable in your rooms at Baker Street. Mrs. Rucastle is not mad. I found her to be a silent, pale-faced woman, much younger than her husband, not more than thirty, I should think, while he can hardly be less than forty-five. From their conversation I have gathered that they have been married about seven years, that he was a widower, and that his only child by the first wife was the daughter who has gone to Philadelphia. Mr. Rucastle told me in private that the reason why she had left them was that she had an unreasoning aversion to her stepmother. As the daughter could not have been less than twenty, I can quite imagine that her position must have been uncomfortable with her father's young wife.

"Mrs. Rucastle seemed to me to be colourless in mind as well as in feature. She impressed me neither favourably nor the reverse. She was a nonentity. It was easy to see that she was passionately devoted both to her husband and to her little son. Her light grey eyes wandered continually from one to the other, noting every little want and forestalling it if possible. He was kind to her also in his bluff, boisterous fashion, and on the whole they seemed to be a happy couple. And yet she had some secret sorrow, this woman. She would often be lost in deep thought, with the saddest look upon her face. More than once I have surprised her in tears. I have thought sometimes that it was the disposition of her child which weighed upon her mind, for I have never met so utterly spoiled and so ill-natured a little creature. He is small for his age, with a head which is quite disproportionately large. His whole life appears to be spent in an alternation between savage fits of passion and gloomy intervals of sulking. Giving pain to any creature weaker than himself seems to be his one idea of amusement, and he shows quite remarkable talent in planning the capture of mice, little birds, and insects. But I would rather not talk about the creature, Mr. Holmes, and, indeed, he has little to do with my story."

"I am glad of all details," remarked my friend, "whether they seem to you to be relevant or not."

"I shall try not to miss anything of importance. The one unpleasant thing about the house, which struck me at once, was the appearance and conduct of the servants. There are only two, a man and his wife. Toller, for that is his name, is a rough, uncouth man, with grizzled hair and whiskers, and a perpetual smell of drink. Twice since I have been with them he has been quite drunk, and yet Mr. Rucastle seemed to take no notice of it. His wife is a very tall and strong woman with a sour face, as silent as Mrs. Rucastle and much less amiable. They are a most unpleasant couple, but fortunately I spend most of my time in the nursery and my own room, which are next to each other in one corner of the building.

"For two days after my arrival at the Copper Beeches my life was very quiet; on the third, Mrs. Rucastle came down just after breakfast and whispered something to her husband.

" 'Oh, yes,' said he, turning to me, 'we are very much obliged to you, Miss Hunter, for falling in with our whims so far as to cut your hair. I assure you that it has not detracted in the tiniest iota from your appearance. We shall now see how the electric-blue dress will become you. You will find it laid out upon the bed in your room, and if you would be so good as to put it on we should both be extremely obliged.'

"The dress which I found waiting for me was of a peculiar shade of blue. It was of excellent material, a sort of beige, but it bore unmistakable signs of having been worn before. It could not have been a better fit if I had been measured for it. Both Mr. and Mrs. Rucastle expressed a delight at the look of it, which seemed quite exaggerated in its vehemence. They were waiting for me in the drawing-room, which is a very large room, stretching along the entire front of the house, with three long windows reaching down to the floor. A chair had been placed close to the central window, with its back turned towards it. In this I was asked to sit, and then Mr. Rucastle, walking up and down on the other side of the room, began to tell me a series of the funniest stories that I have ever listened to. You cannot imagine how comical he was, and I laughed until I was quite weary. Mrs. Rucastle, however, who has evidently no sense of humour, never so much as smiled, but sat with her hands in her lap, and a sad, anxious look upon her face. After an hour or so, Mr. Rucastle suddenly remarked that it was time to commence the duties of the day, and that I might change my dress and go to little Edward in the nursery.

"Two days later this same performance was gone through under exactly similar circumstances. Again I changed my dress, again I sat in the window, and again I laughed very heartily at the funny stories of which my employer had an immense repertoire, and which he told inimitably. Then he handed me a yellow-backed novel, and moving my chair a little sideways, that my own shadow might not fall upon the page, he begged me to read aloud to him. I read for about ten minutes, beginning in the heart of a chapter, and then suddenly, in the middle of a sentence, he ordered me to cease and to change my dress.

"You can easily imagine, Mr. Holmes, how curious I became as to what the meaning of this extraordinary performance could possibly be. They were always very careful, I observed, to turn my face away from the window, so that I became consumed with the desire to see what was going on behind my back. At first it seemed to be impossible, but I soon devised a means. My hand-mirror had been broken, so a happy thought seized me, and I concealed a piece of the glass in my handkerchief. On the next occasion, in the midst of my laughter, I put my handkerchief up to my eyes, and was able with a little management to see all that there was behind me. I confess that I was disappointed. There was nothing. At least that was my first impression. At the second glance, however, I perceived that there was a man standing in the Southampton Road, a small bearded man in a grey suit, who seemed to be looking in my direction. The road is an important highway, and there are usually people there. This man, however, was leaning against the railings which bordered our field and was looking earnestly up. I lowered my handkerchief and glanced at Mrs. Rucastle to find her eyes fixed upon me with a most searching gaze. She said nothing, but I am convinced that she had divined that I had a mirror in my hand and had seen what was behind me. She rose at once.

" 'Jephro,' said she, 'there is an impertinent fellow upon the road there who stares up at Miss Hunter.'

" 'No friend of yours, Miss Hunter?' he asked.

" 'No, I know no one in these parts.'

" 'Dear me! How very impertinent! Kindly turn round and motion to him to go away.'

" 'Surely it would be better to take no notice.'

" 'No, no, we should have him loitering here always. Kindly turn round and wave him away like that.'

"I did as I was told, and at the same instant Mrs. Rucastle drew down the blind. That was a week ago, and from that time I have not sat again in the window, nor have I worn the blue dress, nor seen the man in the road."

"Pray continue," said Holmes. "Your narrative promises to be a most interesting one."

"You will find it rather disconnected, I fear, and there may prove to be little relation between the different incidents of which I speak. On the very first day that I was at the Copper Beeches, Mr. Rucastle took me to a small outhouse which stands near the kitchen door. As we approached it I heard the sharp rattling of a chain, and the sound as of a large animal moving about.

" 'Look in here!' said Mr. Rucastle, showing me a slit between two planks. 'Is he not a beauty?'

"I looked through and was conscious of two glowing eyes, and of a vague figure huddled up in the darkness.

" 'Don't be frightened,' said my employer, laughing at the start which I had given. 'It's only Carlo, my mastiff. I call him mine, but really old Toller, my groom, is the only man who can do anything with him. We feed him once a day, and not too much then, so that he is always as keen as mustard. Toller lets him loose every night, and God help the trespasser whom he lays his fangs upon. For goodness' sake don't you ever on any pretext set your foot over the threshold at night, for it's as much as your life is worth.'

"The warning was no idle one, for two nights later I happened to look out of my bedroom window about two o'clock in the morning. It was a beautiful moonlight night, and the lawn in front of the house was silvered over and almost as bright as day. I was standing, rapt in the peaceful beauty of the scene, when I was aware that something was moving under the shadow of the copper beeches. As it emerged into the moonshine I saw what it was. It was a giant dog, as large as a calf, tawny tinted, with hanging jowl, black muzzle, and huge projecting bones. It walked slowly across the lawn and vanished into the shadow upon the other side. That dreadful sentinel sent a chill to my heart which I do not think that any burglar could have done.

"And now I have a very strange experience to tell you. I had, as you know, cut off my hair in London, and I had placed it in a great coil at the bottom of my trunk. One evening, after the child was in bed, I began to amuse myself by examining the furniture of my room and by rearranging my own little things. There was an old chest of drawers in the room, the two upper ones empty and open, the lower one locked. I had filled the first two with my linen, and as I had still much to pack away I was naturally annoyed at not having the use of the third drawer. It struck me that it might have been fastened by a mere oversight, so I took out my bunch of keys and tried to open it. The very first key fitted to perfection, and I drew the drawer open. There was only one thing in it, but I am sure that you would never guess what it was. It was my coil of hair.

"I took it up and examined it. It was of the same peculiar tint, and the same thickness. But then the impossibility of the thing obtruded itself upon me. How could my hair have been locked in the drawer? With trembling hands I undid my trunk, turned out the contents, and drew from the bottom my own hair. I laid the two tresses together, and I assure you that they were identical. Was it not extraordinary? Puzzle as I would, I could make nothing at all of what it meant. I returned the strange hair to the drawer, and I said nothing of the matter to the Rucastles as I felt that I had put myself in the wrong by opening a drawer which they had locked.

"I am naturally observant, as you may have remarked, Mr. Holmes, and I soon had a pretty good plan of the whole house in my head. There was one wing, however, which appeared not to be inhabited at all. A door which faced that which led into the quarters of the Tollers opened into this suite, but it was invariably locked. One day, however, as I ascended the stair, I met Mr. Rucastle coming out through this door, his keys in his hand, and a look on his face which made him a very different person to the round, jovial man to whom I was accustomed. His cheeks were red, his brow was all crinkled with anger, and the veins stood out at his temples with passion. He locked the door and hurried past me without a word or a look.

"This aroused my curiosity, so when I went out for a walk in the grounds with my charge, I strolled round to the side from which I could see the windows of this part of the house. There were four of them in a row, three of which were simply dirty, while the fourth was shuttered up. They were evidently all deserted. As I strolled up and down, glancing at them occasionally, Mr. Rucastle came out to me, looking as merry and jovial as ever.

" 'Ah!' said he, 'you must not think me rude if I passed you without a word, my dear young lady. I was preoccupied with business matters.'

"I assured him that I was not offended. 'By the way,' said I, 'you seem to have quite a suite of spare rooms up there, and one of them has the shutters up.'

"He looked surprised and, as it seemed to me, a little startled at my remark.

" 'Photography is one of my hobbies,' said he. 'I have made my dark room up there. But, dear me! what an observant young lady we have come upon. Who would have believed it? Who would have ever believed it?' He spoke in a jesting tone, but there was no jest in his eyes as he looked at me. I read suspicion there and annoyance, but no jest.

"Well, Mr. Holmes, from the moment that I understood that there was something about that suite of rooms which I was not to know, I was all on fire to go over them. It was not mere curiosity, though I have my share of that. It was more a feeling of duty--a feeling that some good might come from my penetrating to this place. They talk of woman's instinct; perhaps it was woman's instinct which gave me that feeling. At any rate, it was there, and I was keenly on the lookout for any chance to pass the forbidden door.

"It was only yesterday that the chance came. I may tell you that, besides Mr. Rucastle, both Toller and his wife find something to do in these deserted rooms, and I once saw him carrying a large black linen bag with him through the door. Recently he has been drinking hard, and yesterday evening he was very drunk; and when I came upstairs there was the key in the door. I have no doubt at all that he had left it there. Mr. and Mrs. Rucastle were both downstairs, and the child was with them, so that I had an admirable opportunity. I turned the key gently in the lock, opened the door, and slipped through.

"There was a little passage in front of me, unpapered and uncarpeted, which turned at a right angle at the farther end. Round this corner were three doors in a line, the first and third of which were open. They each led into an empty room, dusty and cheerless, with two windows in the one and one in the other, so thick with dirt that the evening light glimmered dimly through them. The centre door was closed, and across the outside of it had been fastened one of the broad bars of an iron bed, padlocked at one end to a ring in the wall, and fastened at the other with stout cord. The door itself was locked as well, and the key was not there. This barricaded door corresponded clearly with the shuttered window outside, and yet I could see by the glimmer from beneath it that the room was not in darkness. Evidently there was a skylight which let in light from above. As I stood in the passage gazing at the sinister door and wondering what secret it might veil, I suddenly heard the sound of steps within the room and saw a shadow pass backward and forward against the little slit of dim light which shone out from under the door. A mad, unreasoning terror rose up in me at the sight, Mr. Holmes. My overstrung nerves failed me suddenly, and I turned and ran--ran as though some dreadful hand were behind me clutching at the skirt of my dress. I rushed down the passage, through the door, and straight into the arms of Mr. Rucastle, who was waiting outside.

" 'So,' said he, smiling, 'it was you, then. I thought that it must be when I saw the door open.'

" 'Oh, I am so frightened!' I panted.

" 'My dear young lady! my dear young lady!'--you cannot think how caressing and soothing his manner was--'and what has frightened you, my dear young lady?'

"But his voice was just a little too coaxing. He overdid it. I was keenly on my guard against him.

" 'I was foolish enough to go into the empty wing,' I answered. 'But it is so lonely and eerie in this dim light that I was frightened and ran out again. Oh, it is so dreadfully still in there!'

" 'Only that?' said he, looking at me keenly.

" 'Why, what did you think?' I asked.

" 'Why do you think that I lock this door?'

" 'I am sure that I do not know.'

" 'It is to keep people out who have no business there. Do you see?' He was still smiling in the most amiable manner.

" 'I am sure if I had known--'

" 'Well, then, you know now. And if you ever put your foot over that threshold again'--here in an instant the smile hardened into a grin of rage, and he glared down at me with the face of a demon--'I'll throw you to the mastiff.'

"I was so terrified that I do not know what I did. I suppose that I must have rushed past him into my room. I remember nothing until I found myself lying on my bed trembling all over. Then I thought of you, Mr. Holmes. I could not live there longer without some advice. I was frightened of the house, of the man, of the woman, of the servants, even of the child. They were all horrible to me. If I could only bring you down all would be well. Of course I might have fled from the house, but my curiosity was almost as strong as my fears. My mind was soon made up. I would send you a wire. I put on my hat and cloak, went down to the office, which is about half a mile from the house, and then returned, feeling very much easier. A horrible doubt came into my mind as I approached the door lest the dog might be loose, but I remembered that Toller had drunk himself into a state of insensibility that evening, and I knew that he was the only one in the household who had any influence with the savage creature, or who would venture to set him free. I slipped in in safety and lay awake half the night in my joy at the thought of seeing you. I had no difficulty in getting leave to come into Winchester this morning, but I must be back before three o'clock, for Mr. and Mrs. Rucastle are going on a visit, and will be away all the evening, so that I must look after the child. Now I have told you all my adventures, Mr. Holmes, and I should be very glad if you could tell me what it all means, and, above all, what I should do."

Holmes and I had listened spellbound to this extraordinary story. My friend rose now and paced up and down the room, his hands in his pockets, and an expression of the most profound gravity upon his face.

"Is Toller still drunk?" he asked.

"Yes. I heard his wife tell Mrs. Rucastle that she could do nothing with him."

"That is well. And the Rucastles go out to-night?"

"Yes."

"Is there a cellar with a good strong lock?"

"Yes, the wine-cellar."

"You seem to me to have acted all through this matter like a very brave and sensible girl, Miss Hunter. Do you think that you could perform one more feat? I should not ask it of you if I did not think you a quite exceptional woman."

"I will try. What is it?"

"We shall be at the Copper Beeches by seven o'clock, my friend and I. The Rucastles will be gone by that time, and Toller will, we hope, be incapable. There only remains Mrs. Toller, who might give the alarm. If you could send her into the cellar on some errand, and then turn the key upon her, you would facilitate matters immensely."

"I will do it."

"Excellent! We shall then look thoroughly into the affair. Of course there is only one feasible explanation. You have been brought there to personate someone, and the real person is imprisoned in this chamber. That is obvious. As to who this prisoner is, I have no doubt that it is the daughter, Miss Alice Rucastle, if I remember right, who was said to have gone to America. You were chosen, doubtless, as resembling her in height, figure, and the colour of your hair. Hers had been cut off, very possibly in some illness through which she has passed, and so, of course, yours had to be sacrificed also. By a curious chance you came upon her tresses. The man in the road was undoubtedly some friend of hers--possibly her fiance--and no doubt, as you wore the girl's dress and were so like her, he was convinced from your laughter, whenever he saw you, and afterwards from your gesture, that Miss Rucastle was perfectly happy, and that she no longer desired his attentions. The dog is let loose at night to prevent him from endeavouring to communicate with her. So much is fairly clear. The most serious point in the case is the disposition of the child."

"What on earth has that to do with it?" I ejaculated.

"My dear Watson, you as a medical man are continually gaining light as to the tendencies of a child by the study of the parents. Don't you see that the converse is equally valid. I have frequently gained my first real insight into the character of parents by studying their children. This child's disposition is abnormally cruel, merely for cruelty's sake, and whether he derives this from his smiling father, as I should suspect, or from his mother, it bodes evil for the poor girl who is in their power."

"I am sure that you are right, Mr. Holmes," cried our client. "A thousand things come back to me which make me certain that you have hit it. Oh, let us lose not an instant in bringing help to this poor creature."

"We must be circumspect, for we are dealing with a very cunning man. We can do nothing until seven o'clock. At that hour we shall be with you, and it will not be long before we solve the mystery."

We were as good as our word, for it was just seven when we reached the Copper Beeches, having put up our trap at a wayside public-house. The group of trees, with their dark leaves shining like burnished metal in the light of the setting sun, were sufficient to mark the house even had Miss Hunter not been standing smiling on the door-step.

"Have you managed it?" asked Holmes.

A loud thudding noise came from somewhere downstairs. "That is Mrs. Toller in the cellar," said she. "Her husband lies snoring on the kitchen rug. Here are his keys, which are the duplicates of Mr. Rucastle's."

"You have done well indeed!" cried Holmes with enthusiasm. "Now lead the way, and we shall soon see the end of this black business."

We passed up the stair, unlocked the door, followed on down a passage, and found ourselves in front of the barricade which Miss Hunter had described. Holmes cut the cord and removed the transverse bar. Then he tried the various keys in the lock, but without success. No sound came from within, and at the silence Holmes' face clouded over.

"I trust that we are not too late," said he. "I think, Miss Hunter, that we had better go in without you. Now, Watson, put your shoulder to it, and we shall see whether we cannot make our way in."

It was an old rickety door and gave at once before our united strength. Together we rushed into the room. It was empty. There was no furniture save a little pallet bed, a small table, and a basketful of linen. The skylight above was open, and the prisoner gone.

"There has been some villainy here," said Holmes; "this beauty has guessed Miss Hunter's intentions and has carried his victim off."

"But how?"

"Through the skylight. We shall soon see how he managed it." He swung himself up onto the roof. "Ah, yes," he cried, "here's the end of a long light ladder against the eaves. That is how he did it."

"But it is impossible," said Miss Hunter; "the ladder was not there when the Rucastles went away."

"He has come back and done it. I tell you that he is a clever and dangerous man. I should not be very much surprised if this were he whose step I hear now upon the stair. I think, Watson, that it would be as well for you to have your pistol ready."

The words were hardly out of his mouth before a man appeared at the door of the room, a very fat and burly man, with a heavy stick in his hand. Miss Hunter screamed and shrunk against the wall at the sight of him, but Sherlock Holmes sprang forward and confronted him.

"You villain!" said he, "where's your daughter?"

The fat man cast his eyes round, and then up at the open skylight.

"It is for me to ask you that," he shrieked, "you thieves! Spies and thieves! I have caught you, have I? You are in my power. I'll serve you!" He turned and clattered down the stairs as hard as he could go.

"He's gone for the dog!" cried Miss Hunter.

"I have my revolver," said I.

"Better close the front door," cried Holmes, and we all rushed down the stairs together. We had hardly reached the hall when we heard the baying of a hound, and then a scream of agony, with a horrible worrying sound which it was dreadful to listen to. An elderly man with a red face and shaking limbs came staggering out at a side door.

"My God!" he cried. "Someone has loosed the dog. It's not been fed for two days. Quick, quick, or it'll be too late!"

Holmes and I rushed out and round the angle of the house, with Toller hurrying behind us. There was the huge famished brute, its black muzzle buried in Rucastle's throat, while he writhed and screamed upon the ground. Running up, I blew its brains out, and it fell over with its keen white teeth still meeting in the great creases of his neck. With much labour we separated them and carried him, living but horribly mangled, into the house. We laid him upon the drawing-room sofa, and having dispatched the sobered Toller to bear the news to his wife, I did what I could to relieve his pain. We were all assembled round him when the door opened, and a tall, gaunt woman entered the room.

"Mrs. Toller!" cried Miss Hunter.

"Yes, miss. Mr. Rucastle let me out when he came back before he went up to you. Ah, miss, it is a pity you didn't let me know what you were planning, for I would have told you that your pains were wasted."

"Ha!" said Holmes, looking keenly at her. "It is clear that Mrs. Toller knows more about this matter than anyone else."

"Yes, sir, I do, and I am ready enough to tell what I know."

"Then, pray, sit down, and let us hear it for there are several points on which I must confess that I am still in the dark."

"I will soon make it clear to you," said she; "and I'd have done so before now if I could ha' got out from the cellar. If there's police-court business over this, you'll remember that I was the one that stood your friend, and that I was Miss Alice's friend too.

"She was never happy at home, Miss Alice wasn't, from the time that her father married again. She was slighted like and had no say in anything, but it never really became bad for her until after she met Mr. Fowler at a friend's house. As well as I could learn, Miss Alice had rights of her own by will, but she was so quiet and patient, she was, that she never said a word about them but just left everything in Mr. Rucastle's hands. He knew he was safe with her; but when there was a chance of a husband coming forward, who would ask for all that the law would give him, then her father thought it time to put a stop on it. He wanted her to sign a paper, so that whether she married or not, he could use her money. When she wouldn't do it, he kept on worrying her until she got brain-fever, and for six weeks was at death's door. Then she got better at last, all worn to a shadow, and with her beautiful hair cut off; but that didn't make no change in her young man, and he stuck to her as true as man could be."

"Ah," said Holmes, "I think that what you have been good enough to tell us makes the matter fairly clear, and that I can deduce all that remains. Mr. Rucastle then, I presume, took to this system of imprisonment?"

"Yes, sir."

"And brought Miss Hunter down from London in order to get rid of the disagreeable persistence of Mr. Fowler."

"That was it, sir."

"But Mr. Fowler being a persevering man, as a good seaman should be, blockaded the house, and having met you succeeded by certain arguments, metallic or otherwise, in convincing you that your interests were the same as his."

"Mr. Fowler was a very kind-spoken, free-handed gentleman," said Mrs. Toller serenely.

"And in this way he managed that your good man should have no want of drink, and that a ladder should be ready at the moment when your master had gone out."

"You have it, sir, just as it happened."

"I am sure we owe you an apology, Mrs. Toller," said Holmes, "for you have certainly cleared up everything which puzzled us. And here comes the country surgeon and Mrs. Rucastle, so I think, Watson, that we had best escort Miss Hunter back to Winchester, as it seems to me that our locus standi now is rather a questionable one."

And thus was solved the mystery of the sinister house with the copper beeches in front of the door. Mr. Rucastle survived, but was always a broken man, kept alive solely through the care of his devoted wife. They still live with their old servants, who probably know so much of Rucastle's past life that he finds it difficult to part from them. Mr. Fowler and Miss Rucastle were married, by special license, in Southampton the day after their flight, and he is now the holder of a government appointment in the island of Mauritius. As to Miss Violet Hunter, my friend Holmes, rather to my disappointment, manifested no further interest in her when once she had ceased to be the centre of one of his problems, and she is now the head of a private school at Walsall, where I believe that she has met with considerable success.

*** END OF THE PROJECT GUTENBERG EBOOK, THE ADVENTURES OF SHERLOCK HOLMES ***

This file should be named advsh12h.htm or advsh12h.zip
Corrected EDITIONS of our eBooks get a new NUMBER, advsh13h.txt
VERSIONS based on separate sources get new LETTER, advsh12ah.txt

Project Gutenberg eBooks are often created from several printed
editions, all of which are confirmed as Public Domain in the US
unless a copyright notice is included.  Thus, we usually do not
keep eBooks in compliance with any particular paper edition.

We are now trying to release all our eBooks one year in advance
of the official release dates, leaving time for better editing.
Please be encouraged to tell us about any error or corrections,
even years after the official publication date.

Please note neither this listing nor its contents are final til
midnight of the last day of the month of any such announcement.
The official release date of all Project Gutenberg eBooks is at
Midnight, Central Time, of the last day of the stated month.  A
preliminary version may often be posted for suggestion, comment
and editing by those who wish to do so.

Most people start at our Web sites at:
http://gutenberg.net or
http://promo.net/pg

These Web sites include award-winning information about Project
Gutenberg, including how to donate, how to help produce our new
eBooks, and how to subscribe to our email newsletter (free!).


Those of you who want to download any eBook before announcement
can get to them as follows, and just download by date.  This is
also a good way to get them instantly upon announcement, as the
indexes our cataloguers produce obviously take a while after an
announcement goes out in the Project Gutenberg Newsletter.

http://www.ibiblio.org/gutenberg/etext04 or
ftp://ftp.ibiblio.org/pub/docs/books/gutenberg/etext03

Or /etext03, 02, 01, 00, 99, 98, 97, 96, 95, 94, 93, 92, 92, 91 or 90

Just search by the first five letters of the filename you want,
as it appears in our Newsletters.


Information about Project Gutenberg (one page)

We produce about two million dollars for each hour we work.  The
time it takes us, a rather conservative estimate, is fifty hours
to get any eBook selected, entered, proofread, edited, copyright
searched and analyzed, the copyright letters written, etc.   Our
projected audience is one hundred million readers.  If the value
per text is nominally estimated at one dollar then we produce $2
million dollars per hour in 2002 as we release over 100 new text
files per month:  1240 more eBooks in 2001 for a total of 4000+
We are already on our way to trying for 2000 more eBooks in 2002
If they reach just 1-2% of the world's population then the total
will reach over half a trillion eBooks given away by year's end.

The Goal of Project Gutenberg is to Give Away 1 Trillion eBooks!
This is ten thousand titles each to one hundred million readers,
which is only about 4% of the present number of computer users.

Here is the briefest record of our progress (* means estimated):

eBooks Year Month

    1  1971 July
   10  1991 January
  100  1994 January
 1000  1997 August
 1500  1998 October
 2000  1999 December
 2500  2000 December
 3000  2001 November
 4000  2001 October/November
 6000  2002 December*
 9000  2003 November*
10000  2004 January*


The Project Gutenberg Literary Archive Foundation has been created
to secure a future for Project Gutenberg into the next millennium.

We need your donations more than ever!

As of February, 2002, contributions are being solicited from people
and organizations in: Alabama, Alaska, Arkansas, Connecticut,
Delaware, District of Columbia, Florida, Georgia, Hawaii, Illinois,
Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Massachusetts,
Michigan, Mississippi, Missouri, Montana, Nebraska, Nevada, New
Hampshire, New Jersey, New Mexico, New York, North Carolina, Ohio,
Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South
Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West
Virginia, Wisconsin, and Wyoming.

We have filed in all 50 states now, but these are the only ones
that have responded.

As the requirements for other states are met, additions to this list
will be made and fund raising will begin in the additional states.
Please feel free to ask to check the status of your state.

In answer to various questions we have received on this:

We are constantly working on finishing the paperwork to legally
request donations in all 50 states.  If your state is not listed and
you would like to know if we have added it since the list you have,
just ask.

While we cannot solicit donations from people in states where we are
not yet registered, we know of no prohibition against accepting
donations from donors in these states who approach us with an offer to
donate.

International donations are accepted, but we don't know ANYTHING about
how to make them tax-deductible, or even if they CAN be made
deductible, and don't have the staff to handle it even if there are
ways.

Donations by check or money order may be sent to:

Project Gutenberg Literary Archive Foundation
PMB 113
1739 University Ave.
Oxford, MS 38655-4109

Contact us if you want to arrange for a wire transfer or payment
method other than by check or money order.

The Project Gutenberg Literary Archive Foundation has been approved by
the US Internal Revenue Service as a 501(c)(3) organization with EIN
[Employee Identification Number] 64-622154.  Donations are
tax-deductible to the maximum extent permitted by law.  As fund-raising
requirements for other states are met, additions to this list will be
made and fund-raising will begin in the additional states.

We need your donations more than ever!

You can get up to date donation information online at:

http://www.gutenberg.net/donation.html


***

If you can't reach Project Gutenberg,
you can always email directly to:

Michael S. Hart <hart@pobox.com>

Prof. Hart will answer or forward your message.

We would prefer to send you information by email.


**The Legal Small Print**


(Three Pages)

***START**THE SMALL PRINT!**FOR PUBLIC DOMAIN EBOOKS**START***
Why is this "Small Print!" statement here? You know: lawyers.
They tell us you might sue us if there is something wrong with
your copy of this eBook, even if you got it for free from
someone other than us, and even if what's wrong is not our
fault. So, among other things, this "Small Print!" statement
disclaims most of our liability to you. It also tells you how
you may distribute copies of this eBook if you want to.

*BEFORE!* YOU USE OR READ THIS EBOOK
By using or reading any part of this PROJECT GUTENBERG-tm
eBook, you indicate that you understand, agree to and accept
this "Small Print!" statement. If you do not, you can receive
a refund of the money (if any) you paid for this eBook by
sending a request within 30 days of receiving it to the person
you got it from. If you received this eBook on a physical
medium (such as a disk), you must return it with your request.

ABOUT PROJECT GUTENBERG-TM EBOOKS
This PROJECT GUTENBERG-tm eBook, like most PROJECT GUTENBERG-tm eBooks,
is a "public domain" work distributed by Professor Michael S. Hart
through the Project Gutenberg Association (the "Project").
Among other things, this means that no one owns a United States copyright
on or for this work, so the Project (and you!) can copy and
distribute it in the United States without permission and
without paying copyright royalties. Special rules, set forth
below, apply if you wish to copy and distribute this eBook
under the "PROJECT GUTENBERG" trademark.

Please do not use the "PROJECT GUTENBERG" trademark to market
any commercial products without permission.

To create these eBooks, the Project expends considerable
efforts to identify, transcribe and proofread public domain
works. Despite these efforts, the Project's eBooks and any
medium they may be on may contain "Defects". Among other
things, Defects may take the form of incomplete, inaccurate or
corrupt data, transcription errors, a copyright or other
intellectual property infringement, a defective or damaged
disk or other eBook medium, a computer virus, or computer
codes that damage or cannot be read by your equipment.

LIMITED WARRANTY; DISCLAIMER OF DAMAGES
But for the "Right of Replacement or Refund" described below,
[1] Michael Hart and the Foundation (and any other party you may
receive this eBook from as a PROJECT GUTENBERG-tm eBook) disclaims
all liability to you for damages, costs and expenses, including
legal fees, and [2] YOU HAVE NO REMEDIES FOR NEGLIGENCE OR
UNDER STRICT LIABILITY, OR FOR BREACH OF WARRANTY OR CONTRACT,
INCLUDING BUT NOT LIMITED TO INDIRECT, CONSEQUENTIAL, PUNITIVE
OR INCIDENTAL DAMAGES, EVEN IF YOU GIVE NOTICE OF THE
POSSIBILITY OF SUCH DAMAGES.

If you discover a Defect in this eBook within 90 days of
receiving it, you can receive a refund of the money (if any)
you paid for it by sending an explanatory note within that
time to the person you received it from. If you received it
on a physical medium, you must return it with your note, and
such person may choose to alternatively give you a replacement
copy. If you received it electronically, such person may
choose to alternatively give you a second opportunity to
receive it electronically.

THIS EBOOK IS OTHERWISE PROVIDED TO YOU "AS-IS". NO OTHER
WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, ARE MADE TO YOU AS
TO THE EBOOK OR ANY MEDIUM IT MAY BE ON, INCLUDING BUT NOT
LIMITED TO WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A
PARTICULAR PURPOSE.

Some states do not allow disclaimers of implied warranties or
the exclusion or limitation of consequential damages, so the
above disclaimers and exclusions may not apply to you, and you
may have other legal rights.

INDEMNITY
You will indemnify and hold Michael Hart, the Foundation,
and its trustees and agents, and any volunteers associated
with the production and distribution of Project Gutenberg-tm
texts harmless, from all liability, cost and expense, including
legal fees, that arise directly or indirectly from any of the
following that you do or cause:  [1] distribution of this eBook,
[2] alteration, modification, or addition to the eBook,
or [3] any Defect.

DISTRIBUTION UNDER "PROJECT GUTENBERG-tm"
You may distribute copies of this eBook electronically, or by
disk, book or any other medium if you either delete this
"Small Print!" and all other references to Project Gutenberg,
or:

[1]  Only give exact copies of it.  Among other things, this
     requires that you do not remove, alter or modify the
     eBook or this "small print!" statement.  You may however,
     if you wish, distribute this eBook in machine readable
     binary, compressed, mark-up, or proprietary form,
     including any form resulting from conversion by word
     processing or hypertext software, but only so long as
     *EITHER*:

     [*]  The eBook, when displayed, is clearly readable, and
          does *not* contain characters other than those
          intended by the author of the work, although tilde
          (~), asterisk (*) and underline (_) characters may
          be used to convey punctuation intended by the
          author, and additional characters may be used to
          indicate hypertext links; OR

     [*]  The eBook may be readily converted by the reader at
          no expense into plain ASCII, EBCDIC or equivalent
          form by the program that displays the eBook (as is
          the case, for instance, with most word processors);
          OR

     [*]  You provide, or agree to also provide on request at
          no additional cost, fee or expense, a copy of the
          eBook in its original plain ASCII form (or in EBCDIC
          or other equivalent proprietary form).

[2]  Honor the eBook refund and replacement provisions of this
     "Small Print!" statement.

[3]  Pay a trademark license fee to the Foundation of 20% of the
     gross profits you derive calculated using the method you
     already use to calculate your applicable taxes.  If you
     don't derive profits, no royalty is due.  Royalties are
     payable to "Project Gutenberg Literary Archive Foundation"
     the 60 days following each date you prepare (or were
     legally required to prepare) your annual (or equivalent
     periodic) tax return.  Please contact us beforehand to
     let us know your plans and to work out the details.

WHAT IF YOU *WANT* TO SEND MONEY EVEN IF YOU DON'T HAVE TO?
Project Gutenberg is dedicated to increasing the number of
public domain and licensed works that can be freely distributed
in machine readable form.

The Project gratefully accepts contributions of money, time,
public domain materials, or royalty free copyright licenses.
Money should be paid to the:
"Project Gutenberg Literary Archive Foundation."

If you are interested in contributing scanning equipment or
software or other items, please contact Michael Hart at:
hart@pobox.com

[Portions of this eBook's header and trailer may be reprinted only
when distributed free of all fees.  Copyright (C) 2001, 2002 by
Michael S. Hart.  Project Gutenberg is a TradeMark and may not be
used in any sales of Project Gutenberg eBooks or other materials be
they hardware or software or any other related product without
express permission.]

*END THE SMALL PRINT! FOR PUBLIC DOMAIN EBOOKS*Ver.02/11/02*END*



The Project Gutenberg EBook of History of the United States
by Charles A. Beard and Mary R. Beard

This eBook is for the use of anyone anywhere at no cost and with
almost no restrictions whatsoever.  You may copy it, give it away or
re-use it under the terms of the Project Gutenberg License included
with this eBook or online at www.gutenberg.net


Title: History of the United States

Author: Charles A. Beard and Mary R. Beard

Release Date: October 28, 2005 [EBook #16960]

Language: English

Character set encoding: ISO-8859-1

*** START OF THIS PROJECT GUTENBERG EBOOK HISTORY OF THE UNITED STATES ***




Produced by Curtis Weyant, M and the Online Distributed
Proofreading Team at http://www.pgdp.net







HISTORY

OF THE

UNITED STATES


BY


CHARLES A. BEARD

AND

MARY R. BEARD



New York

THE MACMILLAN COMPANY

1921

_All rights reserved_

COPYRIGHT, 1921,

BY THE MACMILLAN COMPANY.


Set up and electrotyped. Published March, 1921.




Norwood Press

J.S. Cushing Co.--Berwick & Smith Co.

NORWOOD, MASS., U.S.A.




PREFACE


As things now stand, the course of instruction in American history in
our public schools embraces three distinct treatments of the subject.
Three separate books are used. First, there is the primary book, which
is usually a very condensed narrative with emphasis on biographies and
anecdotes. Second, there is the advanced text for the seventh or eighth
grade, generally speaking, an expansion of the elementary book by the
addition of forty or fifty thousand words. Finally, there is the high
school manual. This, too, ordinarily follows the beaten path, giving
fuller accounts of the same events and characters. To put it bluntly, we
do not assume that our children obtain permanent possessions from their
study of history in the lower grades. If mathematicians followed the
same method, high school texts on algebra and geometry would include the
multiplication table and fractions.

There is, of course, a ready answer to the criticism advanced above. It
is that teachers have learned from bitter experience how little history
their pupils retain as they pass along the regular route. No teacher of
history will deny this. Still it is a standing challenge to existing
methods of historical instruction. If the study of history cannot be
made truly progressive like the study of mathematics, science, and
languages, then the historians assume a grave responsibility in adding
their subject to the already overloaded curriculum. If the successive
historical texts are only enlarged editions of the first text--more
facts, more dates, more words--then history deserves most of the sharp
criticism which it is receiving from teachers of science, civics, and
economics.

In this condition of affairs we find our justification for offering a
new high school text in American history. Our first contribution is one
of omission. The time-honored stories of exploration and the
biographies of heroes are left out. We frankly hold that, if pupils know
little or nothing about Columbus, Cortes, Magellan, or Captain John
Smith by the time they reach the high school, it is useless to tell the
same stories for perhaps the fourth time. It is worse than useless. It
is an offense against the teachers of those subjects that are
demonstrated to be progressive in character.

In the next place we have omitted all descriptions of battles. Our
reasons for this are simple. The strategy of a campaign or of a single
battle is a highly technical, and usually a highly controversial, matter
about which experts differ widely. In the field of military and naval
operations most writers and teachers of history are mere novices. To
dispose of Gettysburg or the Wilderness in ten lines or ten pages is
equally absurd to the serious student of military affairs. Any one who
compares the ordinary textbook account of a single Civil War campaign
with the account given by Ropes, for instance, will ask for no further
comment. No youth called upon to serve our country in arms would think
of turning to a high school manual for information about the art of
warfare. The dramatic scene or episode, so useful in arousing the
interest of the immature pupil, seems out of place in a book that
deliberately appeals to boys and girls on the very threshold of life's
serious responsibilities.

It is not upon negative features, however, that we rest our case. It is
rather upon constructive features.

_First._ We have written a topical, not a narrative, history. We have
tried to set forth the important aspects, problems, and movements of
each period, bringing in the narrative rather by way of illustration.

_Second._ We have emphasized those historical topics which help to
explain how our nation has come to be what it is to-day.

_Third._ We have dwelt fully upon the social and economic aspects of our
history, especially in relation to the politics of each period.

_Fourth._ We have treated the causes and results of wars, the problems
of financing and sustaining armed forces, rather than military strategy.
These are the subjects which belong to a history for civilians. These
are matters which civilians can understand--matters which they must
understand, if they are to play well their part in war and peace.

_Fifth._ By omitting the period of exploration, we have been able to
enlarge the treatment of our own time. We have given special attention
to the history of those current questions which must form the subject
matter of sound instruction in citizenship.

_Sixth._ We have borne in mind that America, with all her unique
characteristics, is a part of a general civilization. Accordingly we
have given diplomacy, foreign affairs, world relations, and the
reciprocal influences of nations their appropriate place.

_Seventh._ We have deliberately aimed at standards of maturity. The
study of a mere narrative calls mainly for the use of the memory. We
have aimed to stimulate habits of analysis, comparison, association,
reflection, and generalization--habits calculated to enlarge as well as
inform the mind. We have been at great pains to make our text clear,
simple, and direct; but we have earnestly sought to stretch the
intellects of our readers--to put them upon their mettle. Most of them
will receive the last of their formal instruction in the high school.
The world will soon expect maturity from them. Their achievements will
depend upon the possession of other powers than memory alone. The
effectiveness of their citizenship in our republic will be measured by
the excellence of their judgment as well as the fullness of their
information.

     C.A.B.
     M.R.B.

     NEW YORK CITY,
     February 8, 1921.




=A SMALL LIBRARY IN AMERICAN HISTORY=


_=SINGLE VOLUMES:=_

BASSETT, J.S. _A Short History of the United States_
ELSON, H.W. _History of the United States of America_


_=SERIES:=_

"EPOCHS OF AMERICAN HISTORY," EDITED BY A.B. HART

HART, A.B. _Formation of the Union_
THWAITES, R.G. _The Colonies_
WILSON, WOODROW. _Division and Reunion_

"RIVERSIDE SERIES," EDITED BY W.E. DODD

BECKER, C.L. _Beginnings of the American People_
DODD, W.E. _Expansion and Conflict_
JOHNSON, A. _Union and Democracy_
PAXSON, F.L. _The New Nation_




CONTENTS


PART I. THE COLONIAL PERIOD

CHAPTER                                                           PAGE
    I.  THE GREAT MIGRATION TO AMERICA                               1
          The Agencies of American Colonization                      2
          The Colonial Peoples                                       6
          The Process of Colonization                               12

   II.  COLONIAL AGRICULTURE, INDUSTRY, AND COMMERCE                20
          The Land and the Westward Movement                        20
          Industrial and Commercial Development                     28

  III.  SOCIAL AND POLITICAL PROGRESS                               38
          The Leadership of the Churches                            39
          Schools and Colleges                                      43
          The Colonial Press                                        46
          The Evolution in Political Institutions                   48

   IV.  THE DEVELOPMENT OF COLONIAL NATIONALISM                     56
          Relations with the Indians and the French                 57
          The Effects of Warfare on the Colonies                    61
          Colonial Relations with the British Government            64
          Summary of Colonial Period                                73


PART II. CONFLICT AND INDEPENDENCE

    V.  THE NEW COURSE IN BRITISH IMPERIAL POLICY                   77
          George III and His System                                 77
          George III's Ministers and Their Colonial Policies        79
          Colonial Resistance Forces Repeal                         83
          Resumption of British Revenue and Commercial Policies     87
          Renewed Resistance in America                             90
          Retaliation by the British Government                     93
          From Reform to Revolution in America                      95

   VI.  THE AMERICAN REVOLUTION                                     99
          Resistance and Retaliation                                99
          American Independence                                    101
          The Establishment of Government and the New Allegiance   108
          Military Affairs                                         116
          The Finances of the Revolution                           125
          The Diplomacy of the Revolution                          127
          Peace at Last                                            132
          Summary of the Revolutionary Period                      135


PART III. FOUNDATIONS OF THE UNION AND NATIONAL POLITICS

  VII.  THE FORMATION OF THE CONSTITUTION                          139
          The Promise and the Difficulties of America              139
          The Calling of a Constitutional Convention               143
          The Framing of the Constitution                          146
          The Struggle over Ratification                           157

 VIII.  THE CLASH OF POLITICAL PARTIES                             162
          The Men and Measures of the New Government               162
          The Rise of Political Parties                            168
          Foreign Influences and Domestic Politics                 171

   IX.  THE JEFFERSONIAN REPUBLICANS IN POWER                      186
          Republican Principles and Policies                       186
          The Republicans and the Great West                       188
          The Republican War for Commercial Independence           193
          The Republicans Nationalized                             201
          The National Decisions of Chief Justice Marshall         208
          Summary of Union and National Politics                   212


PART IV. THE WEST AND JACKSONIAN DEMOCRACY

    X.  THE FARMERS BEYOND THE APPALACHIANS                        217
          Preparation for Western Settlement                       217
          The Western Migration and New States                     221
          The Spirit of the Frontier                               228
          The West and the East Meet                               230

   XI.  JACKSONIAN DEMOCRACY                                       238
          The Democratic Movement in the East                      238
          The New Democracy Enters the Arena                       244
          The New Democracy at Washington                          250
          The Rise of the Whigs                                    260
          The Interaction of American and European Opinion         265

  XII.  THE MIDDLE BORDER AND THE GREAT WEST                       271
          The Advance of the Middle Border                         271
          On to the Pacific--Texas and the Mexican War             276
          The Pacific Coast and Utah                               284
          Summary of Western Development and National Politics     292


PART V. SECTIONAL CONFLICT AND RECONSTRUCTION

 XIII.  THE RISE OF THE INDUSTRIAL SYSTEM                          295
          The Industrial Revolution                                296
          The Industrial Revolution and National Politics          307

  XIV.  THE PLANTING SYSTEM AND NATIONAL POLITICS                  316
          Slavery--North and South                                 316
          Slavery in National Politics                             324
          The Drift of Events toward the Irrepressible Conflict    332

   XV.  THE CIVIL WAR AND RECONSTRUCTION                           344
          The Southern Confederacy                                 344
          The War Measures of the Federal Government               350
          The Results of the Civil War                             365
          Reconstruction in the South                              370
          Summary of the Sectional Conflict                        375


PART VI. NATIONAL GROWTH AND WORLD POLITICS

  XVI.  THE POLITICAL AND ECONOMIC EVOLUTION OF THE SOUTH          379
          The South at the Close of the War                        379
          The Restoration of White Supremacy                       382
          The Economic Advance of the South                        389

 XVII.  BUSINESS ENTERPRISE AND THE REPUBLICAN PARTY               401
          Railways and Industry                                    401
          The Supremacy of the Republican Party (1861-1885)        412
          The Growth of Opposition to Republican Rule              417

XVIII.  THE DEVELOPMENT OF THE GREAT WEST                          425
          The Railways as Trail Blazers                            425
          The Evolution of Grazing and Agriculture                 431
          Mining and Manufacturing in the West                     436
          The Admission of New States                              440
          The Influence of the Far West on National Life           443

  XIX.  DOMESTIC ISSUES BEFORE THE COUNTRY (1865-1897)             451
          The Currency Question                                    452
          The Protective Tariff and Taxation                       459
          The Railways and Trusts                                  460
          The Minor Parties and Unrest                             462
          The Sound Money Battle of 1896                           466
          Republican Measures and Results                          472

   XX.  AMERICA A WORLD POWER (1865-1900)                          477
          American Foreign Relations (1865-1898)                   478
          Cuba and the Spanish War                                 485
          American Policies in the Philippines and the Orient      497
          Summary of National Growth and World Politics            504


PART VII. PROGRESSIVE DEMOCRACY AND THE WORLD WAR

  XXI.  THE EVOLUTION OF REPUBLICAN POLICIES (1901-1913)           507
          Foreign Affairs                                          508
          Colonial Administration                                  515
          The Roosevelt Domestic Policies                          519
          Legislative and Executive Activities                     523
          The Administration of President Taft                     527
          Progressive Insurgency and the Election of 1912          530

 XXII.  THE SPIRIT OF REFORM IN AMERICA                            536
          An Age of Criticism                                      536
          Political Reforms                                        538
          Measures of Economic Reform                              546

XXIII.  THE NEW POLITICAL DEMOCRACY                                554
          The Rise of the Woman Movement                           555
          The National Struggle for Woman Suffrage                 562

 XXIV.  INDUSTRIAL DEMOCRACY                                       570
          Cooperation between Employers and Employees              571
          The Rise and Growth of Organized Labor                   575
          The Wider Relations of Organized Labor                   577
          Immigration and Americanization                          582

  XXV.  PRESIDENT WILSON AND THE WORLD WAR                         588
          Domestic Legislation                                     588
          Colonial and Foreign Policies                            592
          The United States and the European War                   596
          The United States at War                                 604
          The Settlement at Paris                                  612
          Summary of Democracy and the World War                   620

APPENDIX                                                           627

A TOPICAL SYLLABUS                                                 645

INDEX                                                              655




MAPS


                                                                   PAGE
The Original Grants (color map)                         _Facing_     4

German and Scotch-Irish Settlements                                  8

Distribution of Population in 1790                                  27

English, French, and Spanish Possessions in America, 1750
      (color map)                                      _Facing_     59

The Colonies at the Time of the Declaration of Independence
      (color map)                                     _Facing_     108

North America according to the Treaty of 1783
      (color map)                                     _Facing_     134

The United States in 1805 (color map)                 _Facing_     193

Roads and Trails into Western Territory (color map)   _Facing_     224

The Cumberland Road                                                233

Distribution of Population in 1830                                 235

Texas and the Territory in Dispute                                 282

The Oregon Country and the Disputed Boundary                       285

The Overland Trails                                                287

Distribution of Slaves in Southern States                          323

The Missouri Compromise                                            326

Slave and Free Soil on the Eve of the Civil War                    335

The United States in 1861 (color map)                 _Facing_     345

Railroads of the United States in 1918                             405

The United States in 1870 (color map)                _Facing_      427

The United States in 1912 (color map)                _Facing_      443

American Dominions in the Pacific (color map)        _Facing_      500

The Caribbean Region (color map)                     _Facing_      592

Battle Lines of the Various Years of the World War                 613

Europe in 1919 (color map)                         _Between_   618-619

     "THE NATIONS OF THE WEST" (popularly called "The
     Pioneers"), designed by A. Stirling Calder and modeled by
     Mr. Calder, F.G.R. Roth, and Leo Lentelli, topped the Arch
     of the Setting Sun at the Panama-Pacific Exposition held at
     San Francisco in 1915. Facing the Court of the Universe
     moves a group of men and women typical of those who have
     made our civilization. From left to right appear the
     French-Canadian, the Alaskan, the Latin-American, the
     German, the Italian, the Anglo-American, and the American
     Indian, squaw and warrior. In the place of honor in the
     center of the group, standing between the oxen on the tongue
     of the prairie schooner, is a figure, beautiful and almost
     girlish, but strong, dignified, and womanly, the Mother of
     To-morrow. Above the group rides the Spirit of Enterprise,
     flanked right and left by the Hopes of the Future in the
     person of two boys. The group as a whole is beautifully
     symbolic of the westward march of American civilization.

[Illustration: _Photograph by Cardinell-Vincent Co., San Francisco_

"THE NATIONS OF THE WEST"]




HISTORY OF THE UNITED STATES




PART I. THE COLONIAL PERIOD




CHAPTER I

THE GREAT MIGRATION TO AMERICA


The tide of migration that set in toward the shores of North America
during the early years of the seventeenth century was but one phase in
the restless and eternal movement of mankind upon the surface of the
earth. The ancient Greeks flung out their colonies in every direction,
westward as far as Gaul, across the Mediterranean, and eastward into
Asia Minor, perhaps to the very confines of India. The Romans, supported
by their armies and their government, spread their dominion beyond the
narrow lands of Italy until it stretched from the heather of Scotland to
the sands of Arabia. The Teutonic tribes, from their home beyond the
Danube and the Rhine, poured into the empire of the Caesars and made the
beginnings of modern Europe. Of this great sweep of races and empires
the settlement of America was merely a part. And it was, moreover, only
one aspect of the expansion which finally carried the peoples, the
institutions, and the trade of Europe to the very ends of the earth.

In one vital point, it must be noted, American colonization differed
from that of the ancients. The Greeks usually carried with them
affection for the government they left behind and sacred fire from the
altar of the parent city; but thousands of the immigrants who came to
America disliked the state and disowned the church of the mother
country. They established compacts of government for themselves and set
up altars of their own. They sought not only new soil to till but also
political and religious liberty for themselves and their children.


THE AGENCIES OF AMERICAN COLONIZATION

It was no light matter for the English to cross three thousand miles of
water and found homes in the American wilderness at the opening of the
seventeenth century. Ships, tools, and supplies called for huge outlays
of money. Stores had to be furnished in quantities sufficient to sustain
the life of the settlers until they could gather harvests of their own.
Artisans and laborers of skill and industry had to be induced to risk
the hazards of the new world. Soldiers were required for defense and
mariners for the exploration of inland waters. Leaders of good judgment,
adept in managing men, had to be discovered. Altogether such an
enterprise demanded capital larger than the ordinary merchant or
gentleman could amass and involved risks more imminent than he dared to
assume. Though in later days, after initial tests had been made, wealthy
proprietors were able to establish colonies on their own account, it was
the corporation that furnished the capital and leadership in the
beginning.

=The Trading Company.=--English pioneers in exploration found an
instrument for colonization in companies of merchant adventurers, which
had long been employed in carrying on commerce with foreign countries.
Such a corporation was composed of many persons of different ranks of
society--noblemen, merchants, and gentlemen--who banded together for a
particular undertaking, each contributing a sum of money and sharing in
the profits of the venture. It was organized under royal authority; it
received its charter, its grant of land, and its trading privileges from
the king and carried on its operations under his supervision and
control. The charter named all the persons originally included in the
corporation and gave them certain powers in the management of its
affairs, including the right to admit new members. The company was in
fact a little government set up by the king. When the members of the
corporation remained in England, as in the case of the Virginia Company,
they operated through agents sent to the colony. When they came over the
seas themselves and settled in America, as in the case of Massachusetts,
they became the direct government of the country they possessed. The
stockholders in that instance became the voters and the governor, the
chief magistrate.

[Illustration: JOHN WINTHROP, GOVERNOR OF THE MASSACHUSETTS BAY
COMPANY]

Four of the thirteen colonies in America owed their origins to the
trading corporation. It was the London Company, created by King James I,
in 1606, that laid during the following year the foundations of Virginia
at Jamestown. It was under the auspices of their West India Company,
chartered in 1621, that the Dutch planted the settlements of the New
Netherland in the valley of the Hudson. The founders of Massachusetts
were Puritan leaders and men of affairs whom King Charles I incorporated
in 1629 under the title: "The governor and company of the Massachusetts
Bay in New England." In this case the law did but incorporate a group
drawn together by religious ties. "We must be knit together as one man,"
wrote John Winthrop, the first Puritan governor in America. Far to the
south, on the banks of the Delaware River, a Swedish commercial company
in 1638 made the beginnings of a settlement, christened New Sweden; it
was destined to pass under the rule of the Dutch, and finally under the
rule of William Penn as the proprietary colony of Delaware.

In a certain sense, Georgia may be included among the "company
colonies." It was, however, originally conceived by the moving spirit,
James Oglethorpe, as an asylum for poor men, especially those imprisoned
for debt. To realize this humane purpose, he secured from King George
II, in 1732, a royal charter uniting several gentlemen, including
himself, into "one body politic and corporate," known as the "Trustees
for establishing the colony of Georgia in America." In the structure of
their organization and their methods of government, the trustees did not
differ materially from the regular companies created for trade and
colonization. Though their purposes were benevolent, their transactions
had to be under the forms of law and according to the rules of business.

=The Religious Congregation.=--A second agency which figured largely in
the settlement of America was the religious brotherhood, or
congregation, of men and women brought together in the bonds of a common
religious faith. By one of the strange fortunes of history, this
institution, founded in the early days of Christianity, proved to be a
potent force in the origin and growth of self-government in a land far
away from Galilee. "And the multitude of them that believed were of one
heart and of one soul," we are told in the Acts describing the Church at
Jerusalem. "We are knit together as a body in a most sacred covenant of
the Lord ... by virtue of which we hold ourselves strictly tied to all
care of each other's good and of the whole," wrote John Robinson, a
leader among the Pilgrims who founded their tiny colony of Plymouth in
1620. The Mayflower Compact, so famous in American history, was but a
written and signed agreement, incorporating the spirit of obedience to
the common good, which served as a guide to self-government until
Plymouth was annexed to Massachusetts in 1691.

[Illustration: THE ORIGINAL GRANTS]

Three other colonies, all of which retained their identity until the eve
of the American Revolution, likewise sprang directly from the
congregations of the faithful: Rhode Island, Connecticut, and New
Hampshire, mainly offshoots from Massachusetts. They were founded by
small bodies of men and women, "united in solemn covenants with the
Lord," who planted their settlements in the wilderness. Not until many a
year after Roger Williams and Anne Hutchinson conducted their followers
to the Narragansett country was Rhode Island granted a charter of
incorporation (1663) by the crown. Not until long after the congregation
of Thomas Hooker from Newtown blazed the way into the Connecticut River
Valley did the king of England give Connecticut a charter of its own
(1662) and a place among the colonies. Half a century elapsed before the
towns laid out beyond the Merrimac River by emigrants from Massachusetts
were formed into the royal province of New Hampshire in 1679.

Even when Connecticut was chartered, the parchment and sealing wax of
the royal lawyers did but confirm rights and habits of self-government
and obedience to law previously established by the congregations. The
towns of Hartford, Windsor, and Wethersfield had long lived happily
under their "Fundamental Orders" drawn up by themselves in 1639; so had
the settlers dwelt peacefully at New Haven under their "Fundamental
Articles" drafted in the same year. The pioneers on the Connecticut
shore had no difficulty in agreeing that "the Scriptures do hold forth a
perfect rule for the direction and government of all men."

=The Proprietor.=--A third and very important colonial agency was the
proprietor, or proprietary. As the name, associated with the word
"property," implies, the proprietor was a person to whom the king
granted property in lands in North America to have, hold, use, and enjoy
for his own benefit and profit, with the right to hand the estate down
to his heirs in perpetual succession. The proprietor was a rich and
powerful person, prepared to furnish or secure the capital, collect the
ships, supply the stores, and assemble the settlers necessary to found
and sustain a plantation beyond the seas. Sometimes the proprietor
worked alone. Sometimes two or more were associated like partners in the
common undertaking.

Five colonies, Maryland, Pennsylvania, New Jersey, and the Carolinas,
owe their formal origins, though not always their first settlements, nor
in most cases their prosperity, to the proprietary system. Maryland,
established in 1634 under a Catholic nobleman, Lord Baltimore, and
blessed with religious toleration by the act of 1649, flourished under
the mild rule of proprietors until it became a state in the American
union. New Jersey, beginning its career under two proprietors, Berkeley
and Carteret, in 1664, passed under the direct government of the crown
in 1702. Pennsylvania was, in a very large measure, the product of the
generous spirit and tireless labors of its first proprietor, the leader
of the Friends, William Penn, to whom it was granted in 1681 and in
whose family it remained until 1776. The two Carolinas were first
organized as one colony in 1663 under the government and patronage of
eight proprietors, including Lord Clarendon; but after more than half a
century both became royal provinces governed by the king.

[Illustration: WILLIAM PENN, PROPRIETOR OF PENNSYLVANIA]


THE COLONIAL PEOPLES

=The English.=--In leadership and origin the thirteen colonies, except
New York and Delaware, were English. During the early days of all, save
these two, the main, if not the sole, current of immigration was from
England. The colonists came from every walk of life. They were men,
women, and children of "all sorts and conditions." The major portion
were yeomen, or small land owners, farm laborers, and artisans. With
them were merchants and gentlemen who brought their stocks of goods or
their fortunes to the New World. Scholars came from Oxford and
Cambridge to preach the gospel or to teach. Now and then the son of an
English nobleman left his baronial hall behind and cast his lot with
America. The people represented every religious faith--members of the
Established Church of England; Puritans who had labored to reform that
church; Separatists, Baptists, and Friends, who had left it altogether;
and Catholics, who clung to the religion of their fathers.

New England was almost purely English. During the years between 1629 and
1640, the period of arbitrary Stuart government, about twenty thousand
Puritans emigrated to America, settling in the colonies of the far
North. Although minor additions were made from time to time, the greater
portion of the New England people sprang from this original stock.
Virginia, too, for a long time drew nearly all her immigrants from
England alone. Not until the eve of the Revolution did other
nationalities, mainly the Scotch-Irish and Germans, rival the English in
numbers.

The populations of later English colonies--the Carolinas, New York,
Pennsylvania, and Georgia--while receiving a steady stream of
immigration from England, were constantly augmented by wanderers from
the older settlements. New York was invaded by Puritans from New England
in such numbers as to cause the Anglican clergymen there to lament that
"free thinking spreads almost as fast as the Church." North Carolina was
first settled toward the northern border by immigrants from Virginia.
Some of the North Carolinians, particularly the Quakers, came all the
way from New England, tarrying in Virginia only long enough to learn how
little they were wanted in that Anglican colony.

=The Scotch-Irish.=--Next to the English in numbers and influence were
the Scotch-Irish, Presbyterians in belief, English in tongue. Both
religious and economic reasons sent them across the sea. Their Scotch
ancestors, in the days of Cromwell, had settled in the north of Ireland
whence the native Irish had been driven by the conqueror's sword. There
the Scotch nourished for many years enjoying in peace their own form of
religion and growing prosperous in the manufacture of fine linen and
woolen cloth. Then the blow fell. Toward the end of the seventeenth
century their religious worship was put under the ban and the export of
their cloth was forbidden by the English Parliament. Within two decades
twenty thousand Scotch-Irish left Ulster alone, for America; and all
during the eighteenth century the migration continued to be heavy.
Although no exact record was kept, it is reckoned that the Scotch-Irish
and the Scotch who came directly from Scotland, composed one-sixth of
the entire American population on the eve of the Revolution.

[Illustration: SETTLEMENTS OF GERMAN AND SCOTCH-IRISH
IMMIGRANTS]

These newcomers in America made their homes chiefly in New Jersey,
Pennsylvania, Maryland, Virginia, and the Carolinas. Coming late upon
the scene, they found much of the land immediately upon the seaboard
already taken up. For this reason most of them became frontier people
settling the interior and upland regions. There they cleared the land,
laid out their small farms, and worked as "sturdy yeomen on the soil,"
hardy, industrious, and independent in spirit, sharing neither the
luxuries of the rich planters nor the easy life of the leisurely
merchants. To their agriculture they added woolen and linen
manufactures, which, flourishing in the supple fingers of their tireless
women, made heavy inroads upon the trade of the English merchants in
the colonies. Of their labors a poet has sung:

        "O, willing hands to toil;
    Strong natures tuned to the harvest-song and bound to the kindly soil;
    Bold pioneers for the wilderness, defenders in the field."

=The Germans.=--Third among the colonists in order of numerical
importance were the Germans. From the very beginning, they appeared in
colonial records. A number of the artisans and carpenters in the first
Jamestown colony were of German descent. Peter Minuit, the famous
governor of New Motherland, was a German from Wesel on the Rhine, and
Jacob Leisler, leader of a popular uprising against the provincial
administration of New York, was a German from Frankfort-on-Main. The
wholesale migration of Germans began with the founding of Pennsylvania.
Penn was diligent in searching for thrifty farmers to cultivate his
lands and he made a special effort to attract peasants from the Rhine
country. A great association, known as the Frankfort Company, bought
more than twenty thousand acres from him and in 1684 established a
center at Germantown for the distribution of German immigrants. In old
New York, Rhinebeck-on-the-Hudson became a similar center for
distribution. All the way from Maine to Georgia inducements were offered
to the German farmers and in nearly every colony were to be found, in
time, German settlements. In fact the migration became so large that
German princes were frightened at the loss of so many subjects and
England was alarmed by the influx of foreigners into her overseas
dominions. Yet nothing could stop the movement. By the end of the
colonial period, the number of Germans had risen to more than two
hundred thousand.

The majority of them were Protestants from the Rhine region, and South
Germany. Wars, religious controversies, oppression, and poverty drove
them forth to America. Though most of them were farmers, there were also
among them skilled artisans who contributed to the rapid growth of
industries in Pennsylvania. Their iron, glass, paper, and woolen mills,
dotted here and there among the thickly settled regions, added to the
wealth and independence of the province.

[Illustration: _From an old print_

A GLIMPSE OF OLD GERMANTOWN]

Unlike the Scotch-Irish, the Germans did not speak the language of the
original colonists or mingle freely with them. They kept to themselves,
built their own schools, founded their own newspapers, and published
their own books. Their clannish habits often irritated their neighbors
and led to occasional agitations against "foreigners." However, no
serious collisions seem to have occurred; and in the days of the
Revolution, German soldiers from Pennsylvania fought in the patriot
armies side by side with soldiers from the English and Scotch-Irish
sections.

=Other Nationalities.=--Though the English, the Scotch-Irish, and the
Germans made up the bulk of the colonial population, there were other
racial strains as well, varying in numerical importance but contributing
their share to colonial life.

From France came the Huguenots fleeing from the decree of the king which
inflicted terrible penalties upon Protestants.

From "Old Ireland" came thousands of native Irish, Celtic in race and
Catholic in religion. Like their Scotch-Irish neighbors to the north,
they revered neither the government nor the church of England imposed
upon them by the sword. How many came we do not know, but shipping
records of the colonial period show that boatload after boatload left
the southern and eastern shores of Ireland for the New World.
Undoubtedly thousands of their passengers were Irish of the native
stock. This surmise is well sustained by the constant appearance of
Celtic names in the records of various colonies.

[Illustration:_From an old print_

OLD DUTCH FORT AND ENGLISH CHURCH NEAR ALBANY]

The Jews, then as ever engaged in their age-long battle for religious
and economic toleration, found in the American colonies, not complete
liberty, but certainly more freedom than they enjoyed in England,
France, Spain, or Portugal. The English law did not actually recognize
their right to live in any of the dominions, but owing to the easy-going
habits of the Americans they were allowed to filter into the seaboard
towns. The treatment they received there varied. On one occasion the
mayor and council of New York forbade them to sell by retail and on
another prohibited the exercise of their religious worship. Newport,
Philadelphia, and Charleston were more hospitable, and there large
Jewish colonies, consisting principally of merchants and their families,
flourished in spite of nominal prohibitions of the law.

Though the small Swedish colony in Delaware was quickly submerged
beneath the tide of English migration, the Dutch in New York continued
to hold their own for more than a hundred years after the English
conquest in 1664. At the end of the colonial period over one-half of the
170,000 inhabitants of the province were descendants of the original
Dutch--still distinct enough to give a decided cast to the life and
manners of New York. Many of them clung as tenaciously to their mother
tongue as they did to their capacious farmhouses or their Dutch ovens;
but they were slowly losing their identity as the English pressed in
beside them to farm and trade.

The melting pot had begun its historic mission.


THE PROCESS OF COLONIZATION

Considered from one side, colonization, whatever the motives of the
emigrants, was an economic matter. It involved the use of capital to pay
for their passage, to sustain them on the voyage, and to start them on
the way of production. Under this stern economic necessity, Puritans,
Scotch-Irish, Germans, and all were alike laid.

=Immigrants Who Paid Their Own Way.=--Many of the immigrants to America
in colonial days were capitalists themselves, in a small or a large way,
and paid their own passage. What proportion of the colonists were able
to finance their voyage across the sea is a matter of pure conjecture.
Undoubtedly a very considerable number could do so, for we can trace the
family fortunes of many early settlers. Henry Cabot Lodge is authority
for the statement that "the settlers of New England were drawn from the
country gentlemen, small farmers, and yeomanry of the mother
country.... Many of the emigrants were men of wealth, as the old lists
show, and all of them, with few exceptions, were men of property and
good standing. They did not belong to the classes from which emigration
is usually supplied, for they all had a stake in the country they left
behind." Though it would be interesting to know how accurate this
statement is or how applicable to the other colonies, no study has as
yet been made to gratify that interest. For the present it is an
unsolved problem just how many of the colonists were able to bear the
cost of their own transfer to the New World.

=Indentured Servants.=--That at least tens of thousands of immigrants
were unable to pay for their passage is established beyond the shadow of
a doubt by the shipping records that have come down to us. The great
barrier in the way of the poor who wanted to go to America was the cost
of the sea voyage. To overcome this difficulty a plan was worked out
whereby shipowners and other persons of means furnished the passage
money to immigrants in return for their promise, or bond, to work for a
term of years to repay the sum advanced. This system was called
indentured servitude.

It is probable that the number of bond servants exceeded the original
twenty thousand Puritans, the yeomen, the Virginia gentlemen, and the
Huguenots combined. All the way down the coast from Massachusetts to
Georgia were to be found in the fields, kitchens, and workshops, men,
women, and children serving out terms of bondage generally ranging from
five to seven years. In the proprietary colonies the proportion of bond
servants was very high. The Baltimores, Penns, Carterets, and other
promoters anxiously sought for workers of every nationality to till
their fields, for land without labor was worth no more than land in the
moon. Hence the gates of the proprietary colonies were flung wide open.
Every inducement was offered to immigrants in the form of cheap land,
and special efforts were made to increase the population by importing
servants. In Pennsylvania, it was not uncommon to find a master with
fifty bond servants on his estate. It has been estimated that two-thirds
of all the immigrants into Pennsylvania between the opening of the
eighteenth century and the outbreak of the Revolution were in bondage.
In the other Middle colonies the number was doubtless not so large; but
it formed a considerable part of the population.

The story of this traffic in white servants is one of the most striking
things in the history of labor. Bondmen differed from the serfs of the
feudal age in that they were not bound to the soil but to the master.
They likewise differed from the negro slaves in that their servitude had
a time limit. Still they were subject to many special disabilities. It
was, for instance, a common practice to impose on them penalties far
heavier than were imposed upon freemen for the same offense. A free
citizen of Pennsylvania who indulged in horse racing and gambling was
let off with a fine; a white servant guilty of the same unlawful conduct
was whipped at the post and fined as well.

The ordinary life of the white servant was also severely restricted. A
bondman could not marry without his master's consent; nor engage in
trade; nor refuse work assigned to him. For an attempt to escape or
indeed for any infraction of the law, the term of service was extended.
The condition of white bondmen in Virginia, according to Lodge, "was
little better than that of slaves. Loose indentures and harsh laws put
them at the mercy of their masters." It would not be unfair to add that
such was their lot in all other colonies. Their fate depended upon the
temper of their masters.

Cruel as was the system in many ways, it gave thousands of people in the
Old World a chance to reach the New--an opportunity to wrestle with fate
for freedom and a home of their own. When their weary years of servitude
were over, if they survived, they might obtain land of their own or
settle as free mechanics in the towns. For many a bondman the gamble
proved to be a losing venture because he found himself unable to rise
out of the state of poverty and dependence into which his servitude
carried him. For thousands, on the contrary, bondage proved to be a real
avenue to freedom and prosperity. Some of the best citizens of America
have the blood of indentured servants in their veins.

=The Transported--Involuntary Servitude.=--In their anxiety to secure
settlers, the companies and proprietors having colonies in America
either resorted to or connived at the practice of kidnapping men, women,
and children from the streets of English cities. In 1680 it was
officially estimated that "ten thousand persons were spirited away" to
America. Many of the victims of the practice were young children, for
the traffic in them was highly profitable. Orphans and dependents were
sometimes disposed of in America by relatives unwilling to support them.
In a single year, 1627, about fifteen hundred children were shipped to
Virginia.

In this gruesome business there lurked many tragedies, and very few
romances. Parents were separated from their children and husbands from
their wives. Hundreds of skilled artisans--carpenters, smiths, and
weavers--utterly disappeared as if swallowed up by death. A few thus
dragged off to the New World to be sold into servitude for a term of
five or seven years later became prosperous and returned home with
fortunes. In one case a young man who was forcibly carried over the sea
lived to make his way back to England and establish his claim to a
peerage.

Akin to the kidnapped, at least in economic position, were convicts
deported to the colonies for life in lieu of fines and imprisonment. The
Americans protested vigorously but ineffectually against this practice.
Indeed, they exaggerated its evils, for many of the "criminals" were
only mild offenders against unduly harsh and cruel laws. A peasant
caught shooting a rabbit on a lord's estate or a luckless servant girl
who purloined a pocket handkerchief was branded as a criminal along with
sturdy thieves and incorrigible rascals. Other transported offenders
were "political criminals"; that is, persons who criticized or opposed
the government. This class included now Irish who revolted against
British rule in Ireland; now Cavaliers who championed the king against
the Puritan revolutionists; Puritans, in turn, dispatched after the
monarchy was restored; and Scotch and English subjects in general who
joined in political uprisings against the king.

=The African Slaves.=--Rivaling in numbers, in the course of time, the
indentured servants and whites carried to America against their will
were the African negroes brought to America and sold into slavery. When
this form of bondage was first introduced into Virginia in 1619, it was
looked upon as a temporary necessity to be discarded with the increase
of the white population. Moreover it does not appear that those planters
who first bought negroes at the auction block intended to establish a
system of permanent bondage. Only by a slow process did chattel slavery
take firm root and become recognized as the leading source of the labor
supply. In 1650, thirty years after the introduction of slavery, there
were only three hundred Africans in Virginia.

The great increase in later years was due in no small measure to the
inordinate zeal for profits that seized slave traders both in Old and in
New England. Finding it relatively easy to secure negroes in Africa,
they crowded the Southern ports with their vessels. The English Royal
African Company sent to America annually between 1713 and 1743 from five
to ten thousand slaves. The ship owners of New England were not far
behind their English brethren in pushing this extraordinary traffic.

As the proportion of the negroes to the free white population steadily
rose, and as whole sections were overrun with slaves and slave traders,
the Southern colonies grew alarmed. In 1710, Virginia sought to curtail
the importation by placing a duty of $5 on each slave. This effort was
futile, for the royal governor promptly vetoed it. From time to time
similar bills were passed, only to meet with royal disapproval. South
Carolina, in 1760, absolutely prohibited importation; but the measure
was killed by the British crown. As late as 1772, Virginia, not daunted
by a century of rebuffs, sent to George III a petition in this vein:
"The importation of slaves into the colonies from the coast of Africa
hath long been considered as a trade of great inhumanity and under its
present encouragement, we have too much reason to fear, will endanger
the very existence of Your Majesty's American dominions.... Deeply
impressed with these sentiments, we most humbly beseech Your Majesty to
remove all those restraints on Your Majesty's governors of this colony
which inhibit their assenting to such laws as might check so very
pernicious a commerce."

All such protests were without avail. The negro population grew by leaps
and bounds, until on the eve of the Revolution it amounted to more than
half a million. In five states--Maryland, Virginia, the two Carolinas,
and Georgia--the slaves nearly equalled or actually exceeded the whites
in number. In South Carolina they formed almost two-thirds of the
population. Even in the Middle colonies of Delaware and Pennsylvania
about one-fifth of the inhabitants were from Africa. To the North, the
proportion of slaves steadily diminished although chattel servitude was
on the same legal footing as in the South. In New York approximately one
in six and in New England one in fifty were negroes, including a few
freedmen.

The climate, the soil, the commerce, and the industry of the North were
all unfavorable to the growth of a servile population. Still, slavery,
though sectional, was a part of the national system of economy. Northern
ships carried slaves to the Southern colonies and the produce of the
plantations to Europe. "If the Northern states will consult their
interest, they will not oppose the increase in slaves which will
increase the commodities of which they will become the carriers," said
John Rutledge, of South Carolina, in the convention which framed the
Constitution of the United States. "What enriches a part enriches the
whole and the states are the best judges of their particular interest,"
responded Oliver Ellsworth, the distinguished spokesman of Connecticut.

=References=

E. Charming, _History of the United States_, Vols. I and II.

J.A. Doyle, _The English Colonies in America_ (5 vols.).

J. Fiske, _Old Virginia and Her Neighbors_ (2 vols.).

A.B. Faust, _The German Element in the United States_ (2 vols.).

H.J. Ford, _The Scotch-Irish in America_.

L. Tyler, _England in America_ (American Nation Series).

R. Usher, _The Pilgrims and Their History_.


=Questions=

1. America has been called a nation of immigrants. Explain why.

2. Why were individuals unable to go alone to America in the beginning?
What agencies made colonization possible? Discuss each of them.

3. Make a table of the colonies, showing the methods employed in their
settlement.

4. Why were capital and leadership so very important in early
colonization?

5. What is meant by the "melting pot"? What nationalities were
represented among the early colonists?

6. Compare the way immigrants come to-day with the way they came in
colonial times.

7. Contrast indentured servitude with slavery and serfdom.

8. Account for the anxiety of companies and proprietors to secure
colonists.

9. What forces favored the heavy importation of slaves?

10. In what way did the North derive advantages from slavery?


=Research Topics=

=The Chartered Company.=--Compare the first and third charters of
Virginia in Macdonald, _Documentary Source Book of American History_,
1606-1898, pp. 1-14. Analyze the first and second Massachusetts charters
in Macdonald, pp. 22-84. Special reference: W.A.S. Hewins, _English
Trading Companies_.

=Congregations and Compacts for Self-government.=--A study of the
Mayflower Compact, the Fundamental Orders of Connecticut and the
Fundamental Articles of New Haven in Macdonald, pp. 19, 36, 39.
Reference: Charles Borgeaud, _Rise of Modern Democracy_, and C.S.
Lobingier, _The People's Law_, Chaps. I-VII.

=The Proprietary System.=--Analysis of Penn's charter of 1681, in
Macdonald, p. 80. Reference: Lodge, _Short History of the English
Colonies in America_, p. 211.

=Studies of Individual Colonies.=--Review of outstanding events in
history of each colony, using Elson, _History of the United States_, pp.
55-159, as the basis.

=Biographical Studies.=--John Smith, John Winthrop, William Penn, Lord
Baltimore, William Bradford, Roger Williams, Anne Hutchinson, Thomas
Hooker, and Peter Stuyvesant, using any good encyclopedia.

=Indentured Servitude.=--In Virginia, Lodge, _Short History_, pp. 69-72;
in Pennsylvania, pp. 242-244. Contemporary account in Callender,
_Economic History of the United States_, pp. 44-51. Special reference:
Karl Geiser, _Redemptioners and Indentured Servants_ (Yale Review, X,
No. 2 Supplement).

=Slavery.=--In Virginia, Lodge, _Short History_, pp. 67-69; in the
Northern colonies, pp. 241, 275, 322, 408, 442.

=The People of the Colonies.=--Virginia, Lodge, _Short History_, pp.
67-73; New England, pp. 406-409, 441-450; Pennsylvania, pp. 227-229,
240-250; New York, pp. 312-313, 322-335.




CHAPTER II

COLONIAL AGRICULTURE, INDUSTRY, AND COMMERCE

THE LAND AND THE WESTWARD MOVEMENT


=The Significance of Land Tenure.=--The way in which land may be
acquired, held, divided among heirs, and bought and sold exercises a
deep influence on the life and culture of a people. The feudal and
aristocratic societies of Europe were founded on a system of landlordism
which was characterized by two distinct features. In the first place,
the land was nearly all held in great estates, each owned by a single
proprietor. In the second place, every estate was kept intact under the
law of primogeniture, which at the death of a lord transferred all his
landed property to his eldest son. This prevented the subdivision of
estates and the growth of a large body of small farmers or freeholders
owning their own land. It made a form of tenantry or servitude
inevitable for the mass of those who labored on the land. It also
enabled the landlords to maintain themselves in power as a governing
class and kept the tenants and laborers subject to their economic and
political control. If land tenure was so significant in Europe, it was
equally important in the development of America, where practically all
the first immigrants were forced by circumstances to derive their
livelihood from the soil.

=Experiments in Common Tillage.=--In the New World, with its broad
extent of land awaiting the white man's plow, it was impossible to
introduce in its entirety and over the whole area the system of lords
and tenants that existed across the sea. So it happened that almost
every kind of experiment in land tenure, from communism to feudalism,
was tried. In the early days of the Jamestown colony, the land, though
owned by the London Company, was tilled in common by the settlers. No
man had a separate plot of his own. The motto of the community was:
"Labor and share alike." All were supposed to work in the fields and
receive an equal share of the produce. At Plymouth, the Pilgrims
attempted a similar experiment, laying out the fields in common and
distributing the joint produce of their labor with rough equality among
the workers.

In both colonies the communistic experiments were failures. Angry at the
lazy men in Jamestown who idled their time away and yet expected regular
meals, Captain John Smith issued a manifesto: "Everyone that gathereth
not every day as much as I do, the next day shall be set beyond the
river and forever banished from the fort and live there or starve." Even
this terrible threat did not bring a change in production. Not until
each man was given a plot of his own to till, not until each gathered
the fruits of his own labor, did the colony prosper. In Plymouth, where
the communal experiment lasted for five years, the results were similar
to those in Virginia, and the system was given up for one of separate
fields in which every person could "set corn for his own particular."
Some other New England towns, refusing to profit by the experience of
their Plymouth neighbor, also made excursions into common ownership and
labor, only to abandon the idea and go in for individual ownership of
the land. "By degrees it was seen that even the Lord's people could not
carry the complicated communist legislation into perfect and wholesome
practice."

=Feudal Elements in the Colonies--Quit Rents, Manors, and
Plantations.=--At the other end of the scale were the feudal elements of
land tenure found in the proprietary colonies, in the seaboard regions
of the South, and to some extent in New York. The proprietor was in fact
a powerful feudal lord, owning land granted to him by royal charter. He
could retain any part of it for his personal use or dispose of it all in
large or small lots. While he generally kept for himself an estate of
baronial proportions, it was impossible for him to manage directly any
considerable part of the land in his dominion. Consequently he either
sold it in parcels for lump sums or granted it to individuals on
condition that they make to him an annual payment in money, known as
"quit rent." In Maryland, the proprietor sometimes collected as high as
$9000 (equal to about $500,000 to-day) in a single year from this
source. In Pennsylvania, the quit rents brought a handsome annual
tribute into the exchequer of the Penn family. In the royal provinces,
the king of England claimed all revenues collected in this form from the
land, a sum amounting to $19,000 at the time of the Revolution. The quit
rent,--"really a feudal payment from freeholders,"--was thus a material
source of income for the crown as well as for the proprietors. Wherever
it was laid, however, it proved to be a burden, a source of constant
irritation; and it became a formidable item in the long list of
grievances which led to the American Revolution.

Something still more like the feudal system of the Old World appeared in
the numerous manors or the huge landed estates granted by the crown, the
companies, or the proprietors. In the colony of Maryland alone there
were sixty manors of three thousand acres each, owned by wealthy men and
tilled by tenants holding small plots under certain restrictions of
tenure. In New York also there were many manors of wide extent, most of
which originated in the days of the Dutch West India Company, when
extensive concessions were made to patroons to induce them to bring over
settlers. The Van Rensselaer, the Van Cortlandt, and the Livingston
manors were so large and populous that each was entitled to send a
representative to the provincial legislature. The tenants on the New
York manors were in somewhat the same position as serfs on old European
estates. They were bound to pay the owner a rent in money and kind; they
ground their grain at his mill; and they were subject to his judicial
power because he held court and meted out justice, in some instances
extending to capital punishment.

The manors of New York or Maryland were, however, of slight consequence
as compared with the vast plantations of the Southern seaboard--huge
estates, far wider in expanse than many a European barony and tilled by
slaves more servile than any feudal tenants. It must not be forgotten
that this system of land tenure became the dominant feature of a large
section and gave a decided bent to the economic and political life of
America.

[Illustration: SOUTHERN PLANTATION MANSION]

=The Small Freehold.=--In the upland regions of the South, however, and
throughout most of the North, the drift was against all forms of
servitude and tenantry and in the direction of the freehold; that is,
the small farm owned outright and tilled by the possessor and his
family. This was favored by natural circumstances and the spirit of the
immigrants. For one thing, the abundance of land and the scarcity of
labor made it impossible for the companies, the proprietors, or the
crown to develop over the whole continent a network of vast estates. In
many sections, particularly in New England, the climate, the stony soil,
the hills, and the narrow valleys conspired to keep the farms within a
moderate compass. For another thing, the English, Scotch-Irish, and
German peasants, even if they had been tenants in the Old World, did not
propose to accept permanent dependency of any kind in the New. If they
could not get freeholds, they would not settle at all; thus they forced
proprietors and companies to bid for their enterprise by selling land in
small lots. So it happened that the freehold of modest proportions
became the cherished unit of American farmers. The people who tilled the
farms were drawn from every quarter of western Europe; but the freehold
system gave a uniform cast to their economic and social life in America.

[Illustration: _From an old print_

A NEW ENGLAND FARMHOUSE]

=Social Effects of Land Tenure.=--Land tenure and the process of western
settlement thus developed two distinct types of people engaged in the
same pursuit--agriculture. They had a common tie in that they both
cultivated the soil and possessed the local interest and independence
which arise from that occupation. Their methods and their culture,
however, differed widely.

The Southern planter, on his broad acres tilled by slaves, resembled the
English landlord on his estates more than he did the colonial farmer who
labored with his own hands in the fields and forests. He sold his rice
and tobacco in large amounts directly to English factors, who took his
entire crop in exchange for goods and cash. His fine clothes,
silverware, china, and cutlery he bought in English markets. Loving the
ripe old culture of the mother country, he often sent his sons to Oxford
or Cambridge for their education. In short, he depended very largely for
his prosperity and his enjoyment of life upon close relations with the
Old World. He did not even need market towns in which to buy native
goods, for they were made on his own plantation by his own artisans who
were usually gifted slaves.

The economic condition of the small farmer was totally different. His
crops were not big enough to warrant direct connection with English
factors or the personal maintenance of a corps of artisans. He needed
local markets, and they sprang up to meet the need. Smiths, hatters,
weavers, wagon-makers, and potters at neighboring towns supplied him
with the rough products of their native skill. The finer goods, bought
by the rich planter in England, the small farmer ordinarily could not
buy. His wants were restricted to staples like tea and sugar, and
between him and the European market stood the merchant. His community
was therefore more self-sufficient than the seaboard line of great
plantations. It was more isolated, more provincial, more independent,
more American. The planter faced the Old East. The farmer faced the New
West.

=The Westward Movement.=--Yeoman and planter nevertheless were alike in
one respect. Their land hunger was never appeased. Each had the eye of
an expert for new and fertile soil; and so, north and south, as soon as
a foothold was secured on the Atlantic coast, the current of migration
set in westward, creeping through forests, across rivers, and over
mountains. Many of the later immigrants, in their search for cheap
lands, were compelled to go to the border; but in a large part the path
breakers to the West were native Americans of the second and third
generations. Explorers, fired by curiosity and the lure of the
mysterious unknown, and hunters, fur traders, and squatters, following
their own sweet wills, blazed the trail, opening paths and sending back
stories of the new regions they traversed. Then came the regular
settlers with lawful titles to the lands they had purchased, sometimes
singly and sometimes in companies.

In Massachusetts, the westward movement is recorded in the founding of
Springfield in 1636 and Great Barrington in 1725. By the opening of the
eighteenth century the pioneers of Connecticut had pushed north and west
until their outpost towns adjoined the Hudson Valley settlements. In New
York, the inland movement was directed by the Hudson River to Albany,
and from that old Dutch center it radiated in every direction,
particularly westward through the Mohawk Valley. New Jersey was early
filled to its borders, the beginnings of the present city of New
Brunswick being made in 1681 and those of Trenton in 1685. In
Pennsylvania, as in New York, the waterways determined the main lines of
advance. Pioneers, pushing up through the valley of the Schuylkill,
spread over the fertile lands of Berks and Lancaster counties, laying
out Reading in 1748. Another current of migration was directed by the
Susquehanna, and, in 1726, the first farmhouse was built on the bank
where Harrisburg was later founded. Along the southern tier of counties
a thin line of settlements stretched westward to Pittsburgh, reaching
the upper waters of the Ohio while the colony was still under the Penn
family.

In the South the westward march was equally swift. The seaboard was
quickly occupied by large planters and their slaves engaged in the
cultivation of tobacco and rice. The Piedmont Plateau, lying back from
the coast all the way from Maryland to Georgia, was fed by two streams
of migration, one westward from the sea and the other southward from the
other colonies--Germans from Pennsylvania and Scotch-Irish furnishing
the main supply. "By 1770, tide-water Virginia was full to overflowing
and the 'back country' of the Blue Ridge and the Shenandoah was fully
occupied. Even the mountain valleys ... were claimed by sturdy pioneers.
Before the Declaration of Independence, the oncoming tide of
home-seekers had reached the crest of the Alleghanies."

[Illustration: DISTRIBUTION OF POPULATION, 1790]

Beyond the mountains pioneers had already ventured, harbingers of an
invasion that was about to break in upon Kentucky and Tennessee. As
early as 1769 that mighty Nimrod, Daniel Boone, curious to hunt
buffaloes, of which he had heard weird reports, passed through the
Cumberland Gap and brought back news of a wonderful country awaiting the
plow. A hint was sufficient. Singly, in pairs, and in groups, settlers
followed the trail he had blazed. A great land corporation, the
Transylvania Company, emulating the merchant adventurers of earlier
times, secured a huge grant of territory and sought profits in quit
rents from lands sold to farmers. By the outbreak of the Revolution
there were several hundred people in the Kentucky region. Like the older
colonists, they did not relish quit rents, and their opposition wrecked
the Transylvania Company. They even carried their protests into the
Continental Congress in 1776, for by that time they were our "embryo
fourteenth colony."


INDUSTRIAL AND COMMERCIAL DEVELOPMENT

Though the labor of the colonists was mainly spent in farming, there was
a steady growth in industrial and commercial pursuits. Most of the
staple industries of to-day, not omitting iron and textiles, have their
beginnings in colonial times. Manufacturing and trade soon gave rise to
towns which enjoyed an importance all out of proportion to their
numbers. The great centers of commerce and finance on the seaboard
originated in the days when the king of England was "lord of these
dominions."

[Illustration: DOMESTIC INDUSTRY: DIPPING TALLOW CANDLES]

=Textile Manufacture as a Domestic Industry.=--Colonial women, in
addition to sharing every hardship of pioneering, often the heavy labor
of the open field, developed in the course of time a national industry
which was almost exclusively their own. Wool and flax were raised in
abundance in the North and South. "Every farm house," says Coman, the
economic historian, "was a workshop where the women spun and wove the
serges, kerseys, and linsey-woolseys which served for the common wear."
By the close of the seventeenth century, New England manufactured cloth
in sufficient quantities to export it to the Southern colonies and to
the West Indies. As the industry developed, mills were erected for the
more difficult process of dyeing, weaving, and fulling, but carding and
spinning continued to be done in the home. The Dutch of New Netherland,
the Swedes of Delaware, and the Scotch-Irish of the interior "were not
one whit behind their Yankee neighbors."

The importance of this enterprise to British economic life can hardly be
overestimated. For many a century the English had employed their fine
woolen cloth as the chief staple in a lucrative foreign trade, and the
government had come to look upon it as an object of special interest and
protection. When the colonies were established, both merchants and
statesmen naturally expected to maintain a monopoly of increasing value;
but before long the Americans, instead of buying cloth, especially of
the coarser varieties, were making it to sell. In the place of
customers, here were rivals. In the place of helpless reliance upon
English markets, here was the germ of economic independence.

If British merchants had not discovered it in the ordinary course of
trade, observant officers in the provinces would have conveyed the news
to them. Even in the early years of the eighteenth century the royal
governor of New York wrote of the industrious Americans to his home
government: "The consequence will be that if they can clothe themselves
once, not only comfortably, but handsomely too, without the help of
England, they who already are not very fond of submitting to government
will soon think of putting in execution designs they have long harboured
in their breasts. This will not seem strange when you consider what sort
of people this country is inhabited by."

=The Iron Industry.=--Almost equally widespread was the art of iron
working--one of the earliest and most picturesque of colonial
industries. Lynn, Massachusetts, had a forge and skilled artisans within
fifteen years after the founding of Boston. The smelting of iron began
at New London and New Haven about 1658; in Litchfield county,
Connecticut, a few years later; at Great Barrington, Massachusetts, in
1731; and near by at Lenox some thirty years after that. New Jersey had
iron works at Shrewsbury within ten years after the founding of the
colony in 1665. Iron forges appeared in the valleys of the Delaware and
the Susquehanna early in the following century, and iron masters then
laid the foundations of fortunes in a region destined to become one of
the great iron centers of the world. Virginia began iron working in the
year that saw the introduction of slavery. Although the industry soon
lapsed, it was renewed and flourished in the eighteenth century.
Governor Spotswood was called the "Tubal Cain" of the Old Dominion
because he placed the industry on a firm foundation. Indeed it seems
that every colony, except Georgia, had its iron foundry. Nails, wire,
metallic ware, chains, anchors, bar and pig iron were made in large
quantities; and Great Britain, by an act in 1750, encouraged the
colonists to export rough iron to the British Islands.

=Shipbuilding.=--Of all the specialized industries in the colonies,
shipbuilding was the most important. The abundance of fir for masts, oak
for timbers and boards, pitch for tar and turpentine, and hemp for rope
made the way of the shipbuilder easy. Early in the seventeenth century a
ship was built at New Amsterdam, and by the middle of that century
shipyards were scattered along the New England coast at Newburyport,
Salem, New Bedford, Newport, Providence, New London, and New Haven.
Yards at Albany and Poughkeepsie in New York built ships for the trade
of that colony with England and the Indies. Wilmington and Philadelphia
soon entered the race and outdistanced New York, though unable to equal
the pace set by New England. While Maryland, Virginia, and South
Carolina also built ships, Southern interest was mainly confined to the
lucrative business of producing ship materials: fir, cedar, hemp, and
tar.

=Fishing.=--The greatest single economic resource of New England outside
of agriculture was the fisheries. This industry, started by hardy
sailors from Europe, long before the landing of the Pilgrims, flourished
under the indomitable seamanship of the Puritans, who labored with the
net and the harpoon in almost every quarter of the Atlantic. "Look,"
exclaimed Edmund Burke, in the House of Commons, "at the manner in
which the people of New England have of late carried on the whale
fishery. Whilst we follow them among the tumbling mountains of ice and
behold them penetrating into the deepest frozen recesses of Hudson's Bay
and Davis's Straits, while we are looking for them beneath the arctic
circle, we hear that they have pierced into the opposite region of polar
cold, that they are at the antipodes and engaged under the frozen
serpent of the south.... Nor is the equinoctial heat more discouraging
to them than the accumulated winter of both poles. We know that, whilst
some of them draw the line and strike the harpoon on the coast of
Africa, others run the longitude and pursue their gigantic game along
the coast of Brazil. No sea but what is vexed by their fisheries. No
climate that is not witness to their toils. Neither the perseverance of
Holland nor the activity of France nor the dexterous and firm sagacity
of English enterprise ever carried this most perilous mode of hard
industry to the extent to which it has been pushed by this recent
people."

The influence of the business was widespread. A large and lucrative
European trade was built upon it. The better quality of the fish caught
for food was sold in the markets of Spain, Portugal, and Italy, or
exchanged for salt, lemons, and raisins for the American market. The
lower grades of fish were carried to the West Indies for slave
consumption, and in part traded for sugar and molasses, which furnished
the raw materials for the thriving rum industry of New England. These
activities, in turn, stimulated shipbuilding, steadily enlarging the
demand for fishing and merchant craft of every kind and thus keeping the
shipwrights, calkers, rope makers, and other artisans of the seaport
towns rushed with work. They also increased trade with the mother
country for, out of the cash collected in the fish markets of Europe and
the West Indies, the colonists paid for English manufactures. So an
ever-widening circle of American enterprise centered around this single
industry, the nursery of seamanship and the maritime spirit.

=Oceanic Commerce and American Merchants.=--All through the eighteenth
century, the commerce of the American colonies spread in every direction
until it rivaled in the number of people employed, the capital engaged,
and the profits gleaned, the commerce of European nations. A modern
historian has said: "The enterprising merchants of New England developed
a network of trade routes that covered well-nigh half the world." This
commerce, destined to be of such significance in the conflict with the
mother country, presented, broadly speaking, two aspects.

On the one side, it involved the export of raw materials and
agricultural produce. The Southern colonies produced for shipping,
tobacco, rice, tar, pitch, and pine; the Middle colonies, grain, flour,
furs, lumber, and salt pork; New England, fish, flour, rum, furs, shoes,
and small articles of manufacture. The variety of products was in fact
astounding. A sarcastic writer, while sneering at the idea of an
American union, once remarked of colonial trade: "What sort of dish will
you make? New England will throw in fish and onions. The middle states,
flax-seed and flour. Maryland and Virginia will add tobacco. North
Carolina, pitch, tar, and turpentine. South Carolina, rice and indigo,
and Georgia will sprinkle the whole composition with sawdust. Such an
absurd jumble will you make if you attempt to form a union among such
discordant materials as the thirteen British provinces."

On the other side, American commerce involved the import trade,
consisting principally of English and continental manufactures, tea, and
"India goods." Sugar and molasses, brought from the West Indies,
supplied the flourishing distilleries of Massachusetts, Rhode Island,
and Connecticut. The carriage of slaves from Africa to the Southern
colonies engaged hundreds of New England's sailors and thousands of
pounds of her capital.

The disposition of imported goods in the colonies, though in part
controlled by English factors located in America, employed also a large
and important body of American merchants like the Willings and Morrises
of Philadelphia; the Amorys, Hancocks, and Faneuils of Boston; and the
Livingstons and Lows of New York. In their zeal and enterprise, they
were worthy rivals of their English competitors, so celebrated for
world-wide commercial operations. Though fully aware of the advantages
they enjoyed in British markets and under the protection of the British
navy, the American merchants were high-spirited and mettlesome, ready to
contend with royal officers in order to shield American interests
against outside interference.

[Illustration: THE DUTCH WEST INDIA WAREHOUSE IN NEW AMSTERDAM
(NEW YORK CITY)]

Measured against the immense business of modern times, colonial commerce
seems perhaps trivial. That, however, is not the test of its
significance. It must be considered in relation to the growth of English
colonial trade in its entirety--a relation which can be shown by a few
startling figures. The whole export trade of England, including that to
the colonies, was, in 1704, $6,509,000. On the eve of the American
Revolution, namely, in 1772, English exports to the American colonies
alone amounted to $6,024,000; in other words, almost as much as the
whole foreign business of England two generations before. At the first
date, colonial trade was but one-twelfth of the English export business;
at the second date, it was considerably more than one-third. In 1704,
Pennsylvania bought in English markets goods to the value of $11,459; in
1772 the purchases of the same colony amounted to $507,909. In short,
Pennsylvania imports increased fifty times within sixty-eight years,
amounting in 1772 to almost the entire export trade of England to the
colonies at the opening of the century. The American colonies were
indeed a great source of wealth to English merchants.

=Intercolonial Commerce.=--Although the bad roads of colonial times made
overland transportation difficult and costly, the many rivers and
harbors along the coast favored a lively water-borne trade among the
colonies. The Connecticut, Hudson, Delaware, and Susquehanna rivers in
the North and the many smaller rivers in the South made it possible for
goods to be brought from, and carried to, the interior regions in little
sailing vessels with comparative ease. Sloops laden with manufactures,
domestic and foreign, collected at some city like Providence, New York,
or Philadelphia, skirted the coasts, visited small ports, and sailed up
the navigable rivers to trade with local merchants who had for exchange
the raw materials which they had gathered in from neighboring farms.
Larger ships carried the grain, live stock, cloth, and hardware of New
England to the Southern colonies, where they were traded for tobacco,
leather, tar, and ship timber. From the harbors along the Connecticut
shores there were frequent sailings down through Long Island Sound to
Maryland, Virginia, and the distant Carolinas.

=Growth of Towns.=--In connection with this thriving trade and industry
there grew up along the coast a number of prosperous commercial centers
which were soon reckoned among the first commercial towns of the whole
British empire, comparing favorably in numbers and wealth with such
ports as Liverpool and Bristol. The statistical records of that time are
mainly guesses; but we know that Philadelphia stood first in size among
these towns. Serving as the port of entry for Pennsylvania, Delaware,
and western Jersey, it had drawn within its borders, just before the
Revolution, about 25,000 inhabitants. Boston was second in rank, with
somewhat more than 20,000 people. New York, the "commercial capital of
Connecticut and old East Jersey," was slightly smaller than Boston, but
growing at a steady rate. The fourth town in size was Charleston, South
Carolina, with about 10,000 inhabitants. Newport in Rhode Island, a
center of rum manufacture and shipping, stood fifth, with a population
of about 7000. Baltimore and Norfolk were counted as "considerable
towns." In the interior, Hartford in Connecticut, Lancaster and York in
Pennsylvania, and Albany in New York, with growing populations and
increasing trade, gave prophecy of an urban America away from the
seaboard. The other towns were straggling villages. Williamsburg,
Virginia, for example, had about two hundred houses, in which dwelt a
dozen families of the gentry and a few score of tradesmen. Inland county
seats often consisted of nothing more than a log courthouse, a prison,
and one wretched inn to house judges, lawyers, and litigants during the
sessions of the court.

The leading towns exercised an influence on colonial opinion all out of
proportion to their population. They were the centers of wealth, for one
thing; of the press and political activity, for another. Merchants and
artisans could readily take concerted action on public questions arising
from their commercial operations. The towns were also centers for news,
gossip, religious controversy, and political discussion. In the market
places the farmers from the countryside learned of British policies and
laws, and so, mingling with the townsmen, were drawn into the main
currents of opinion which set in toward colonial nationalism and
independence.


=References=

J. Bishop, _History of American Manufactures_ (2 vols.).

E.L. Bogart, _Economic History of the United States_.

P.A. Bruce, _Economic History of Virginia_ (2 vols.).

E. Semple, _American History and Its Geographical Conditions_.

W. Weeden, _Economic and Social History of New England_. (2 vols.).


=Questions=

1. Is land in your community parceled out into small farms? Contrast the
system in your community with the feudal system of land tenure.

2. Are any things owned and used in common in your community? Why did
common tillage fail in colonial times?

3. Describe the elements akin to feudalism which were introduced in the
colonies.

4. Explain the success of freehold tillage.

5. Compare the life of the planter with that of the farmer.

6. How far had the western frontier advanced by 1776?

7. What colonial industry was mainly developed by women? Why was it very
important both to the Americans and to the English?

8. What were the centers for iron working? Ship building?

9. Explain how the fisheries affected many branches of trade and
industry.

10. Show how American trade formed a vital part of English business.

11. How was interstate commerce mainly carried on?

12. What were the leading towns? Did they compare in importance with
British towns of the same period?


=Research Topics=

=Land Tenure.=--Coman, _Industrial History_ (rev. ed.), pp. 32-38.
Special reference: Bruce, _Economic History of Virginia_, Vol. I, Chap.
VIII.

=Tobacco Planting in Virginia.=--Callender, _Economic History of the
United States_, pp. 22-28.

=Colonial Agriculture.=--Coman, pp. 48-63. Callender, pp. 69-74.
Reference: J.R.H. Moore, _Industrial History of the American People_,
pp. 131-162.

=Colonial Manufactures.=--Coman, pp. 63-73. Callender, pp. 29-44.
Special reference: Weeden, _Economic and Social History of New England_.

=Colonial Commerce.=--Coman, pp. 73-85. Callender, pp. 51-63, 78-84.
Moore, pp. 163-208. Lodge, _Short History of the English Colonies_, pp.
409-412, 229-231, 312-314.




Chapter III

SOCIAL AND POLITICAL PROGRESS


Colonial life, crowded as it was with hard and unremitting toil, left
scant leisure for the cultivation of the arts and sciences. There was
little money in private purses or public treasuries to be dedicated to
schools, libraries, and museums. Few there were with time to read long
and widely, and fewer still who could devote their lives to things that
delight the eye and the mind. And yet, poor and meager as the
intellectual life of the colonists may seem by way of comparison, heroic
efforts were made in every community to lift the people above the plane
of mere existence. After the first clearings were opened in the forests
those efforts were redoubled, and with lengthening years told upon the
thought and spirit of the land. The appearance, during the struggle with
England, of an extraordinary group of leaders familiar with history,
political philosophy, and the arts of war, government, and diplomacy
itself bore eloquent testimony to the high quality of the American
intellect. No one, not even the most critical, can run through the
writings of distinguished Americans scattered from Massachusetts to
Georgia--the Adamses, Ellsworth, the Morrises, the Livingstons,
Hamilton, Franklin, Washington, Madison, Marshall, Henry, the Randolphs,
and the Pinckneys--without coming to the conclusion that there was
something in American colonial life which fostered minds of depth and
power. Women surmounted even greater difficulties than the men in the
process of self-education, and their keen interest in public issues is
evident in many a record like the _Letters_ of Mrs. John Adams to her
husband during the Revolution; the writings of Mrs. Mercy Otis Warren,
the sister of James Otis, who measured her pen with the British
propagandists; and the patriot newspapers founded and managed by women.


THE LEADERSHIP OF THE CHURCHES

In the intellectual life of America, the churches assumed a role of high
importance. There were abundant reasons for this. In many of the
colonies--Maryland, Pennsylvania, and New England--the religious impulse
had been one of the impelling motives in stimulating immigration. In all
the colonies, the clergy, at least in the beginning, formed the only
class with any leisure to devote to matters of the spirit. They preached
on Sundays and taught school on week days. They led in the discussion of
local problems and in the formation of political opinion, so much of
which was concerned with the relation between church and state. They
wrote books and pamphlets. They filled most of the chairs in the
colleges; under clerical guidance, intellectual and spiritual, the
Americans received their formal education. In several of the provinces
the Anglican Church was established by law. In New England the Puritans
were supreme, notwithstanding the efforts of the crown to overbear their
authority. In the Middle colonies, particularly, the multiplication of
sects made the dominance of any single denomination impossible; and in
all of them there was a growing diversity of faith, which promised in
time a separation of church and state and freedom of opinion.

=The Church of England.=--Virginia was the stronghold of the English
system of church and state. The Anglican faith and worship were
prescribed by law, sustained by taxes imposed on all, and favored by the
governor, the provincial councilors, and the richest planters. "The
Established Church," says Lodge, "was one of the appendages of the
Virginia aristocracy. They controlled the vestries and the ministers,
and the parish church stood not infrequently on the estate of the
planter who built and managed it." As in England, Catholics and
Protestant Dissenters were at first laid under heavy disabilities. Only
slowly and on sufferance were they admitted to the province; but when
once they were even covertly tolerated, they pressed steadily in, until,
by the Revolution, they outnumbered the adherents of the established
order.

The Church was also sanctioned by law and supported by taxes in the
Carolinas after 1704, and in Georgia after that colony passed directly
under the crown in 1754--this in spite of the fact that the majority of
the inhabitants were Dissenters. Against the protests of the Catholics
it was likewise established in Maryland. In New York, too,
notwithstanding the resistance of the Dutch, the Established Church was
fostered by the provincial officials, and the Anglicans, embracing about
one-fifteenth of the population, exerted an influence all out of
proportion to their numbers.

Many factors helped to enhance the power of the English Church in the
colonies. It was supported by the British government and the official
class sent out to the provinces. Its bishops and archbishops in England
were appointed by the king, and its faith and service were set forth by
acts of Parliament. Having its seat of power in the English monarchy, it
could hold its clergy and missionaries loyal to the crown and so
counteract to some extent the independent spirit that was growing up in
America. The Church, always a strong bulwark of the state, therefore had
a political role to play here as in England. Able bishops and far-seeing
leaders firmly grasped this fact about the middle of the eighteenth
century and redoubled their efforts to augment the influence of the
Church in provincial affairs. Unhappily for their plans they failed to
calculate in advance the effect of their methods upon dissenting
Protestants, who still cherished memories of bitter religious conflicts
in the mother country.

=Puritanism in New England.=--If the established faith made for imperial
unity, the same could not be said of Puritanism. The Plymouth Pilgrims
had cast off all allegiance to the Anglican Church and established a
separate and independent congregation before they came to America. The
Puritans, essaying at first the task of reformers within the Church,
soon after their arrival in Massachusetts, likewise flung off their yoke
of union with the Anglicans. In each town a separate congregation was
organized, the male members choosing the pastor, the teachers, and the
other officers. They also composed the voters in the town meeting, where
secular matters were determined. The union of church and government was
thus complete, and uniformity of faith and life prescribed by law and
enforced by civil authorities; but this worked for local autonomy
instead of imperial unity.

The clergy became a powerful class, dominant through their learning and
their fearful denunciations of the faithless. They wrote the books for
the people to read--the famous Cotton Mather having three hundred and
eighty-three books and pamphlets to his credit. In cooperation with the
civil officers they enforced a strict observance of the Puritan
Sabbath--a day of rest that began at six o'clock on Saturday evening and
lasted until sunset on Sunday. All work, all trading, all amusement, and
all worldly conversation were absolutely prohibited during those hours.
A thoughtless maid servant who for some earthly reason smiled in church
was in danger of being banished as a vagabond. Robert Pike, a devout
Puritan, thinking the sun had gone to rest, ventured forth on horseback
one Sunday evening and was luckless enough to have a ray of light strike
him through a rift in the clouds. The next day he was brought into court
and fined for "his ungodly conduct." With persons accused of witchcraft
the Puritans were still more ruthless. When a mania of persecution swept
over Massachusetts in 1692, eighteen people were hanged, one was pressed
to death, many suffered imprisonment, and two died in jail.

Just about this time, however, there came a break in the uniformity of
Puritan rule. The crown and church in England had long looked upon it
with disfavor, and in 1684 King Charles II annulled the old charter of
the Massachusetts Bay Company. A new document issued seven years later
wrested from the Puritans of the colony the right to elect their own
governor and reserved the power of appointment to the king. It also
abolished the rule limiting the suffrage to church members, substituting
for it a simple property qualification. Thus a royal governor and an
official family, certain to be Episcopalian in faith and monarchist in
sympathies, were forced upon Massachusetts; and members of all religious
denominations, if they had the required amount of property, were
permitted to take part in elections. By this act in the name of the
crown, the Puritan monopoly was broken down in Massachusetts, and that
province was brought into line with Connecticut, Rhode Island, and New
Hampshire, where property, not religious faith, was the test for the
suffrage.

=Growth of Religious Toleration.=--Though neither the Anglicans of
Virginia nor the Puritans of Massachusetts believed in toleration for
other denominations, that principle was strictly applied in Rhode
Island. There, under the leadership of Roger Williams, liberty in
matters of conscience was established in the beginning. Maryland, by
granting in 1649 freedom to those who professed to believe in Jesus
Christ, opened its gates to all Christians; and Pennsylvania, true to
the tenets of the Friends, gave freedom of conscience to those "who
confess and acknowledge the one Almighty and Eternal God to be the
creator, upholder, and ruler of the World." By one circumstance or
another, the Middle colonies were thus early characterized by diversity
rather than uniformity of opinion. Dutch Protestants, Huguenots,
Quakers, Baptists, Presbyterians, New Lights, Moravians, Lutherans,
Catholics, and other denominations became too strongly intrenched and
too widely scattered to permit any one of them to rule, if it had
desired to do so. There were communities and indeed whole sections where
one or another church prevailed, but in no colony was a legislature
steadily controlled by a single group. Toleration encouraged diversity,
and diversity, in turn, worked for greater toleration.

The government and faith of the dissenting denominations conspired with
economic and political tendencies to draw America away from the English
state. Presbyterians, Quakers, Baptists, and Puritans had no hierarchy
of bishops and archbishops to bind them to the seat of power in London.
Neither did they look to that metropolis for guidance in interpreting
articles of faith. Local self-government in matters ecclesiastical
helped to train them for local self-government in matters political. The
spirit of independence which led Dissenters to revolt in the Old World,
nourished as it was amid favorable circumstances in the New World, made
them all the more zealous in the defense of every right against
authority imposed from without.


SCHOOLS AND COLLEGES

=Religion and Local Schools.=--One of the first cares of each Protestant
denomination was the education of the children in the faith. In this
work the Bible became the center of interest. The English version was
indeed the one book of the people. Farmers, shopkeepers, and artisans,
whose life had once been bounded by the daily routine of labor, found in
the Scriptures not only an inspiration to religious conduct, but also a
book of romance, travel, and history. "Legend and annal," says John
Richard Green, "war-song and psalm, state-roll and biography, the mighty
voices of prophets, the parables of Evangelists, stories of mission
journeys, of perils by sea and among the heathen, philosophic arguments,
apocalyptic visions, all were flung broadcast over minds unoccupied for
the most part by any rival learning.... As a mere literary monument, the
English version of the Bible remains the noblest example of the English
tongue." It was the King James version just from the press that the
Pilgrims brought across the sea with them.

For the authority of the Established Church was substituted the
authority of the Scriptures. The Puritans devised a catechism based upon
their interpretation of the Bible, and, very soon after their arrival in
America, they ordered all parents and masters of servants to be diligent
in seeing that their children and wards were taught to read religious
works and give answers to the religious questions. Massachusetts was
scarcely twenty years old before education of this character was
declared to be compulsory, and provision was made for public schools
where those not taught at home could receive instruction in reading and
writing.

[Illustration: A PAGE FROM A FAMOUS SCHOOLBOOK


     A In ADAM'S Fall
       We sinned all.

     B Heaven to find,
       The Bible Mind.

     C Christ crucify'd
       For sinners dy'd.

     D The Deluge drown'd
       The Earth around.

     E ELIJAH hid
       by Ravens fed.

     F The judgment made
       FELIX afraid.]



Outside of New England the idea of compulsory education was not regarded
with the same favor; but the whole land was nevertheless dotted with
little schools kept by "dames, itinerant teachers, or local parsons."
Whether we turn to the life of Franklin in the North or Washington in
the South, we read of tiny schoolhouses, where boys, and sometimes
girls, were taught to read and write. Where there were no schools,
fathers and mothers of the better kind gave their children the rudiments
of learning. Though illiteracy was widespread, there is evidence to show
that the diffusion of knowledge among the masses was making steady
progress all through the eighteenth century.

=Religion and Higher Learning.=--Religious motives entered into the
establishment of colleges as well as local schools. Harvard, founded in
1636, and Yale, opened in 1718, were intended primarily to train
"learned and godly ministers" for the Puritan churches of New England.
To the far North, Dartmouth, chartered in 1769, was designed first as a
mission to the Indians and then as a college for the sons of New England
farmers preparing to preach, teach, or practice law. The College of New
Jersey, organized in 1746 and removed to Princeton eleven years later,
was sustained by the Presbyterians. Two colleges looked to the
Established Church as their source of inspiration and support: William
and Mary, founded in Virginia in 1693, and King's College, now Columbia
University, chartered by King George II in 1754, on an appeal from the
New York Anglicans, alarmed at the growth of religious dissent and the
"republican tendencies" of the age. Two colleges revealed a drift away
from sectarianism. Brown, established in Rhode Island in 1764, and the
Philadelphia Academy, forerunner of the University of Pennsylvania,
organized by Benjamin Franklin, reflected the spirit of toleration by
giving representation on the board of trustees to several religious
sects. It was Franklin's idea that his college should prepare young men
to serve in public office as leaders of the people and ornaments to
their country.

=Self-education in America.=--Important as were these institutions of
learning, higher education was by no means confined within their walls.
Many well-to-do families sent their sons to Oxford or Cambridge in
England. Private tutoring in the home was common. In still more families
there were intelligent children who grew up in the great colonial school
of adversity and who trained themselves until, in every contest of mind
and wit, they could vie with the sons of Harvard or William and Mary or
any other college. Such, for example, was Benjamin Franklin, whose
charming autobiography, in addition to being an American classic, is a
fine record of self-education. His formal training in the classroom was
limited to a few years at a local school in Boston; but his
self-education continued throughout his life. He early manifested a zeal
for reading, and devoured, he tells us, his father's dry library on
theology, Bunyan's works, Defoe's writings, Plutarch's _Lives_, Locke's
_On the Human Understanding_, and innumerable volumes dealing with
secular subjects. His literary style, perhaps the best of his time,
Franklin acquired by the diligent and repeated analysis of the
_Spectator_. In a life crowded with labors, he found time to read widely
in natural science and to win single-handed recognition at the hands of
European savants for his discoveries in electricity. By his own efforts
he "attained an acquaintance" with Latin, Italian, French, and Spanish,
thus unconsciously preparing himself for the day when he was to speak
for all America at the court of the king of France.

Lesser lights than Franklin, educated by the same process, were found
all over colonial America. From this fruitful source of native ability,
self-educated, the American cause drew great strength in the trials of
the Revolution.


THE COLONIAL PRESS

=The Rise of the Newspaper.=--The evolution of American democracy into a
government by public opinion, enlightened by the open discussion of
political questions, was in no small measure aided by a free press. That
too, like education, was a matter of slow growth. A printing press was
brought to Massachusetts in 1639, but it was put in charge of an
official censor and limited to the publication of religious works. Forty
years elapsed before the first newspaper appeared, bearing the curious
title, _Public Occurrences Both Foreign and Domestic_, and it had not
been running very long before the government of Massachusetts suppressed
it for discussing a political question.

Publishing, indeed, seemed to be a precarious business; but in 1704
there came a second venture in journalism, _The Boston News-Letter_,
which proved to be a more lasting enterprise because it refrained from
criticizing the authorities. Still the public interest languished. When
Franklin's brother, James, began to issue his _New England Courant_
about 1720, his friends sought to dissuade him, saying that one
newspaper was enough for America. Nevertheless he continued it; and his
confidence in the future was rewarded. In nearly every colony a gazette
or chronicle appeared within the next thirty years or more. Benjamin
Franklin was able to record in 1771 that America had twenty-five
newspapers. Boston led with five. Philadelphia had three: two in English
and one in German.

=Censorship and Restraints on the Press.=--The idea of printing,
unlicensed by the government and uncontrolled by the church, was,
however, slow in taking form. The founders of the American colonies had
never known what it was to have the free and open publication of books,
pamphlets, broadsides, and newspapers. When the art of printing was
first discovered, the control of publishing was vested in clerical
authorities. After the establishment of the State Church in England in
the reign of Elizabeth, censorship of the press became a part of royal
prerogative. Printing was restricted to Oxford, Cambridge, and London;
and no one could publish anything without previous approval of the
official censor. When the Puritans were in power, the popular party,
with a zeal which rivaled that of the crown, sought, in turn, to silence
royalist and clerical writers by a vigorous censorship. After the
restoration of the monarchy, control of the press was once more placed
in royal hands, where it remained until 1695, when Parliament, by
failing to renew the licensing act, did away entirely with the official

censorship. By that time political parties were so powerful and so
active and printing presses were so numerous that official review of all
published matter became a sheer impossibility.

In America, likewise, some troublesome questions arose in connection
with freedom of the press. The Puritans of Massachusetts were no less
anxious than King Charles or the Archbishop of London to shut out from
the prying eyes of the people all literature "not mete for them to
read"; and so they established a system of official licensing for
presses, which lasted until 1755. In the other colonies where there was
more diversity of opinion and publishers could set up in business with
impunity, they were nevertheless constantly liable to arrest for
printing anything displeasing to the colonial governments. In 1721 the
editor of the _Mercury_ in Philadelphia was called before the
proprietary council and ordered to apologize for a political article,
and for a later offense of a similar character he was thrown into jail.
A still more famous case was that of Peter Zenger, a New York publisher,
who was arrested in 1735 for criticising the administration. Lawyers who
ventured to defend the unlucky editor were deprived of their licenses to
practice, and it became necessary to bring an attorney all the way from
Philadelphia. By this time the tension of feeling was high, and the
approbation of the public was forthcoming when the lawyer for the
defense exclaimed to the jury that the very cause of liberty itself, not
that of the poor printer, was on trial! The verdict for Zenger, when it
finally came, was the signal for an outburst of popular rejoicing.
Already the people of King George's province knew how precious a thing
is the freedom of the press.

Thanks to the schools, few and scattered as they were, and to the
vigilance of parents, a very large portion, perhaps nearly one-half, of
the colonists could read. Through the newspapers, pamphlets, and
almanacs that streamed from the types, the people could follow the
course of public events and grasp the significance of political
arguments. An American opinion was in the process of making--an
independent opinion nourished by the press and enriched by discussions
around the fireside and at the taverns. When the day of resistance to
British rule came, government by opinion was at hand. For every person
who could hear the voice of Patrick Henry and Samuel Adams, there were a
thousand who could see their appeals on the printed page. Men who had
spelled out their letters while poring over Franklin's _Poor Richard's
Almanac_ lived to read Thomas Paine's thrilling call to arms.


THE EVOLUTION IN POLITICAL INSTITUTIONS

Two very distinct lines of development appeared in colonial politics.
The one, exalting royal rights and aristocratic privileges, was the
drift toward provincial government through royal officers appointed in
England. The other, leading toward democracy and self-government, was
the growth in the power of the popular legislative assembly. Each
movement gave impetus to the other, with increasing force during the
passing years, until at last the final collision between the two ideals
of government came in the war of independence.

=The Royal Provinces.=--Of the thirteen English colonies eight were
royal provinces in 1776, with governors appointed by the king. Virginia
passed under the direct rule of the crown in 1624, when the charter of
the London Company was annulled. The Massachusetts Bay corporation lost
its charter in 1684, and the new instrument granted seven years later
stripped the colonists of the right to choose their chief executive. In
the early decades of the eighteenth century both the Carolinas were
given the provincial instead of the proprietary form. New Hampshire,
severed from Massachusetts in 1679, and Georgia, surrendered by the
trustees in 1752, went into the hands of the crown. New York,
transferred to the Duke of York on its capture from the Dutch in 1664,
became a province when he took the title of James II in 1685. New
Jersey, after remaining for nearly forty years under proprietors, was
brought directly under the king in 1702. Maryland, Pennsylvania, and
Delaware, although they retained their proprietary character until the
Revolution, were in some respects like the royal colonies, for their
governors were as independent of popular choice as were the appointees
of King George. Only two colonies, Rhode Island and Connecticut,
retained full self-government on the eve of the Revolution. They alone
had governors and legislatures entirely of their own choosing.

The chief officer of the royal province was the governor, who enjoyed
high and important powers which he naturally sought to augment at every
turn. He enforced the laws and, usually with the consent of a council,
appointed the civil and military officers. He granted pardons and
reprieves; he was head of the highest court; he was commander-in-chief
of the militia; he levied troops for defense and enforced martial law in
time of invasion, war, and rebellion. In all the provinces, except
Massachusetts, he named the councilors who composed the upper house of
the legislature and was likely to choose those who favored his claims.
He summoned, adjourned, and dissolved the popular assembly, or the lower
house; he laid before it the projects of law desired by the crown; and
he vetoed measures which he thought objectionable. Here were in America
all the elements of royal prerogative against which Hampden had
protested and Cromwell had battled in England.

[Illustration: THE ROYAL GOVERNOR'S PALACE AT NEW BERNE]

The colonial governors were generally surrounded by a body of
office-seekers and hunters for land grants. Some of them were noblemen
of broken estates who had come to America to improve their fortunes. The
pretensions of this circle grated on colonial nerves, and privileges
granted to them, often at the expense of colonists, did much to deepen
popular antipathy to the British government. Favors extended to
adherents of the Established Church displeased Dissenters. The
reappearance of this formidable union of church and state, from which
they had fled, stirred anew the ancient wrath against that combination.

=The Colonial Assembly.=--Coincident with the drift toward
administration through royal governors was the second and opposite
tendency, namely, a steady growth in the practice of self-government.
The voters of England had long been accustomed to share in taxation and
law-making through representatives in Parliament, and the idea was early
introduced in America. Virginia was only twelve years old (1619) when
its first representative assembly appeared. As the towns of
Massachusetts multiplied and it became impossible for all the members of
the corporation to meet at one place, the representative idea was
adopted, in 1633. The river towns of Connecticut formed a representative
system under their "Fundamental Orders" of 1639, and the entire colony
was given a royal charter in 1662. Generosity, as well as practical
considerations, induced such proprietors as Lord Baltimore and William
Penn to invite their colonists to share in the government as soon as any
considerable settlements were made. Thus by one process or another every
one of the colonies secured a popular assembly.

It is true that in the provision for popular elections, the suffrage was
finally restricted to property owners or taxpayers, with a leaning
toward the freehold qualification. In Virginia, the rural voter had to
be a freeholder owning at least fifty acres of land, if there was no
house on it, or twenty-five acres with a house twenty-five feet square.
In Massachusetts, the voter for member of the assembly under the charter
of 1691 had to be a freeholder of an estate worth forty shillings a year
at least or of other property to the value of forty pounds sterling. In
Pennsylvania, the suffrage was granted to freeholders owning fifty acres
or more of land well seated, twelve acres cleared, and to other persons
worth at least fifty pounds in lawful money.

Restrictions like these undoubtedly excluded from the suffrage a very
considerable number of men, particularly the mechanics and artisans of
the towns, who were by no means content with their position.
Nevertheless, it was relatively easy for any man to acquire a small
freehold, so cheap and abundant was land; and in fact a large proportion
of the colonists were land owners. Thus the assemblies, in spite of the
limited suffrage, acquired a democratic tone.

The popular character of the assemblies increased as they became engaged
in battles with the royal and proprietary governors. When called upon by
the executive to make provision for the support of the administration,
the legislature took advantage of the opportunity to make terms in the
interest of the taxpayers. It made annual, not permanent, grants of
money to pay official salaries and then insisted upon electing a
treasurer to dole it out. Thus the colonists learned some of the
mysteries of public finance, as well as the management of rapacious
officials. The legislature also used its power over money grants to
force the governor to sign bills which he would otherwise have vetoed.

=Contests between Legislatures and Governors.=--As may be imagined, many
and bitter were the contests between the royal and proprietary governors
and the colonial assemblies. Franklin relates an amusing story of how
the Pennsylvania assembly held in one hand a bill for the executive to
sign and, in the other hand, the money to pay his salary. Then, with sly
humor, Franklin adds: "Do not, my courteous reader, take pet at our
proprietary constitution for these our bargain and sale proceedings in
legislation. It is a happy country where justice and what was your own
before can be had for ready money. It is another addition to the value
of money and of course another spur to industry. Every land is not so
blessed."

It must not be thought, however, that every governor got off as easily
as Franklin's tale implies. On the contrary, the legislatures, like
Caesar, fed upon meat that made them great and steadily encroached upon
executive prerogatives as they tried out and found their strength. If
we may believe contemporary laments, the power of the crown in America
was diminishing when it was struck down altogether. In New York, the
friends of the governor complained in 1747 that "the inhabitants of
plantations are generally educated in republican principles; upon
republican principles all is conducted. Little more than a shadow of
royal authority remains in the Northern colonies." "Here," echoed the
governor of South Carolina, the following year, "levelling principles
prevail; the frame of the civil government is unhinged; a governor, if
he would be idolized, must betray his trust; the people have got their
whole administration in their hands; the election of the members of the
assembly is by ballot; not civil posts only, but all ecclesiastical
preferments, are in the disposal or election of the people."

Though baffled by the "levelling principles" of the colonial assemblies,
the governors did not give up the case as hopeless. Instead they evolved
a system of policy and action which they thought could bring the
obstinate provincials to terms. That system, traceable in their letters
to the government in London, consisted of three parts: (1) the royal
officers in the colonies were to be made independent of the legislatures
by taxes imposed by acts of Parliament; (2) a British standing army was
to be maintained in America; (3) the remaining colonial charters were to
be revoked and government by direct royal authority was to be enlarged.

Such a system seemed plausible enough to King George III and to many
ministers of the crown in London. With governors, courts, and an army
independent of the colonists, they imagined it would be easy to carry
out both royal orders and acts of Parliament. This reasoning seemed both
practical and logical. Nor was it founded on theory, for it came fresh
from the governors themselves. It was wanting in one respect only. It
failed to take account of the fact that the American people were growing
strong in the practice of self-government and could dispense with the
tutelage of the British ministry, no matter how excellent it might be or
how benevolent its intentions.


=References=

A.M. Earle, _Home Life in Colonial Days_.

A.L. Cross, _The Anglican Episcopate and the American Colonies_ (Harvard
Studies).

E.G. Dexter, _History of Education in the United States_.

C.A. Duniway, _Freedom of the Press in Massachusetts_.

Benjamin Franklin, _Autobiography_.

E.B. Greene, _The Provincial Governor_ (Harvard Studies).

A.E. McKinley, _The Suffrage Franchise in the Thirteen English Colonies_
(Pennsylvania University Studies).

M.C. Tyler, _History of American Literature during the Colonial Times_
(2 vols.).


=Questions=

1. Why is leisure necessary for the production of art and literature?
How may leisure be secured?

2. Explain the position of the church in colonial life.

3. Contrast the political roles of Puritanism and the Established
Church.

4. How did diversity of opinion work for toleration?

5. Show the connection between religion and learning in colonial times.

6. Why is a "free press" such an important thing to American democracy?

7. Relate some of the troubles of early American publishers.

8. Give the undemocratic features of provincial government.

9. How did the colonial assemblies help to create an independent
American spirit, in spite of a restricted suffrage?

10. Explain the nature of the contests between the governors and the
legislatures.


=Research Topics=

=Religious and Intellectual Life.=--Lodge, _Short History of the English
Colonies_: (1) in New England, pp. 418-438, 465-475; (2) in Virginia,
pp. 54-61, 87-89; (3) in Pennsylvania, pp. 232-237, 253-257; (4) in New
York, pp. 316-321. Interesting source materials in Hart, _American
History Told by Contemporaries_, Vol. II, pp. 255-275, 276-290.

=The Government of a Royal Province, Virginia.=--Lodge, pp. 43-50.
Special Reference: E.B. Greene, _The Provincial Governor_ (Harvard
Studies).

=The Government of a Proprietary Colony, Pennsylvania.=--Lodge, pp.
230-232.

=Government in New England.=--Lodge, pp. 412-417.

=The Colonial Press.=--Special Reference: G.H. Payne, _History of
Journalism in the United States_ (1920).

=Colonial Life in General.=--John Fiske, _Old Virginia and Her
Neighbors_, Vol. II, pp. 174-269; Elson, _History of the United States_,
pp. 197-210.

=Colonial Government in General.=--Elson, pp. 210-216.




CHAPTER IV

THE DEVELOPMENT OF COLONIAL NATIONALISM


It is one of the well-known facts of history that a people loosely
united by domestic ties of a political and economic nature, even a
people torn by domestic strife, may be welded into a solid and compact
body by an attack from a foreign power. The imperative call to common
defense, the habit of sharing common burdens, the fusing force of common
service--these things, induced by the necessity of resisting outside
interference, act as an amalgam drawing together all elements, except,
perhaps, the most discordant. The presence of the enemy allays the most
virulent of quarrels, temporarily at least. "Politics," runs an old
saying, "stops at the water's edge."

This ancient political principle, so well understood in diplomatic
circles, applied nearly as well to the original thirteen American
colonies as to the countries of Europe. The necessity for common
defense, if not equally great, was certainly always pressing. Though it
has long been the practice to speak of the early settlements as founded
in "a wilderness," this was not actually the case. From the earliest
days of Jamestown on through the years, the American people were
confronted by dangers from without. All about their tiny settlements
were Indians, growing more and more hostile as the frontier advanced and
as sharp conflicts over land aroused angry passions. To the south and
west was the power of Spain, humiliated, it is true, by the disaster to
the Armada, but still presenting an imposing front to the British
empire. To the north and west were the French, ambitious, energetic,
imperial in temper, and prepared to contest on land and water the
advance of British dominion in America.


RELATIONS WITH THE INDIANS AND THE FRENCH

=Indian Affairs.=--It is difficult to make general statements about the
relations of the colonists to the Indians. The problem was presented in
different shape in different sections of America. It was not handled
according to any coherent or uniform plan by the British government,
which alone could speak for all the provinces at the same time. Neither
did the proprietors and the governors who succeeded one another, in an
irregular train, have the consistent policy or the matured experience
necessary for dealing wisely with Indian matters. As the difficulties
arose mainly on the frontiers, where the restless and pushing pioneers
were making their way with gun and ax, nearly everything that happened
was the result of chance rather than of calculation. A personal quarrel
between traders and an Indian, a jug of whisky, a keg of gunpowder, the
exchange of guns for furs, personal treachery, or a flash of bad temper
often set in motion destructive forces of the most terrible character.

On one side of the ledger may be set innumerable generous records--of
Squanto and Samoset teaching the Pilgrims the ways of the wilds; of
Roger Williams buying his lands from the friendly natives; or of William
Penn treating with them on his arrival in America. On the other side of
the ledger must be recorded many a cruel and bloody conflict as the
frontier rolled westward with deadly precision. The Pequots on the
Connecticut border, sensing their doom, fell upon the tiny settlements
with awful fury in 1637 only to meet with equally terrible punishment. A
generation later, King Philip, son of Massasoit, the friend of the
Pilgrims, called his tribesmen to a war of extermination which brought
the strength of all New England to the field and ended in his own
destruction. In New York, the relations with the Indians, especially
with the Algonquins and the Mohawks, were marked by periodic and
desperate wars. Virginia and her Southern neighbors suffered as did New
England. In 1622 Opecacano, a brother of Powhatan, the friend of the
Jamestown settlers, launched a general massacre; and in 1644 he
attempted a war of extermination. In 1675 the whole frontier was ablaze.
Nathaniel Bacon vainly attempted to stir the colonial governor to put up
an adequate defense and, failing in that plea, himself headed a revolt
and a successful expedition against the Indians. As the Virginia
outposts advanced into the Kentucky country, the strife with the natives
was transferred to that "dark and bloody ground"; while to the
southeast, a desperate struggle with the Tuscaroras called forth the
combined forces of the two Carolinas and Virginia.

[Illustration: _From an old print._

VIRGINIANS DEFENDING THEMSELVES AGAINST THE INDIANS]

From such horrors New Jersey and Delaware were saved on account of their
geographical location. Pennsylvania, consistently following a policy of
conciliation, was likewise spared until her western vanguard came into
full conflict with the allied French and Indians. Georgia, by clever
negotiations and treaties of alliance, managed to keep on fair terms
with her belligerent Cherokees and Creeks. But neither diplomacy nor
generosity could stay the inevitable conflict as the frontier advanced,
especially after the French soldiers enlisted the Indians in their
imperial enterprises. It was then that desultory fighting became general
warfare.

[Illustration: ENGLISH, FRENCH, AND SPANISH POSSESSIONS IN AMERICA,
1750]

=Early Relations with the French.=--During the first decades of French
exploration and settlement in the St. Lawrence country, the English
colonies, engrossed with their own problems, gave little or no thought
to their distant neighbors. Quebec, founded in 1608, and Montreal, in
1642, were too far away, too small in population, and too slight in
strength to be much of a menace to Boston, Hartford, or New York. It was
the statesmen in France and England, rather than the colonists in
America, who first grasped the significance of the slowly converging
empires in North America. It was the ambition of Louis XIV of France,
rather than the labors of Jesuit missionaries and French rangers, that
sounded the first note of colonial alarm.

Evidence of this lies in the fact that three conflicts between the
English and the French occurred before their advancing frontiers met on
the Pennsylvania border. King William's War (1689-1697), Queen Anne's
War (1701-1713), and King George's War (1744-1748) owed their origins
and their endings mainly to the intrigues and rivalries of European
powers, although they all involved the American colonies in struggles
with the French and their savage allies.

=The Clash in the Ohio Valley.=--The second of these wars had hardly
closed, however, before the English colonists themselves began to be
seriously alarmed about the rapidly expanding French dominion in the
West. Marquette and Joliet, who opened the Lake region, and La Salle,
who in 1682 had gone down the Mississippi to the Gulf, had been followed
by the builders of forts. In 1718, the French founded New Orleans, thus
taking possession of the gateway to the Mississippi as well as the St.
Lawrence. A few years later they built Fort Niagara; in 1731 they
occupied Crown Point; in 1749 they formally announced their dominion
over all the territory drained by the Ohio River. Having asserted this
lofty claim, they set out to make it good by constructing in the years
1752-1754 Fort Le Boeuf near Lake Erie, Fort Venango on the upper
waters of the Allegheny, and Fort Duquesne at the junction of the
streams forming the Ohio. Though they were warned by George Washington,
in the name of the governor of Virginia, to keep out of territory "so
notoriously known to be property of the crown of Great Britain," the
French showed no signs of relinquishing their pretensions.

[Illustration: _From an old print_

BRADDOCK'S RETREAT]

=The Final Phase--the French and Indian War.=--Thus it happened that the
shot which opened the Seven Years' War, known in America as the French
and Indian War, was fired in the wilds of Pennsylvania. There began the
conflict that spread to Europe and even Asia and finally involved
England and Prussia, on the one side, and France, Austria, Spain, and
minor powers on the other. On American soil, the defeat of Braddock in
1755 and Wolfe's exploit in capturing Quebec four years later were the
dramatic features. On the continent of Europe, England subsidized
Prussian arms to hold France at bay. In India, on the banks of the
Ganges, as on the banks of the St. Lawrence, British arms were
triumphant. Well could the historian write: "Conquests equaling in
rapidity and far surpassing in magnitude those of Cortes and Pizarro had
been achieved in the East." Well could the merchants of London declare
that under the administration of William Pitt, the imperial genius of
this world-wide conflict, commerce had been "united with and made to
flourish by war."

From the point of view of the British empire, the results of the war
were momentous. By the peace of 1763, Canada and the territory east of
the Mississippi, except New Orleans, passed under the British flag. The
remainder of the Louisiana territory was transferred to Spain and French
imperial ambitions on the American continent were laid to rest. In
exchange for Havana, which the British had seized during the war, Spain
ceded to King George the colony of Florida. Not without warrant did
Macaulay write in after years that Pitt "was the first Englishman of his
time; and he had made England the first country in the world."


THE EFFECTS OF WARFARE ON THE COLONIES

The various wars with the French and the Indians, trivial in detail as
they seem to-day, had a profound influence on colonial life and on the
destiny of America. Circumstances beyond the control of popular
assemblies, jealous of their individual powers, compelled cooperation
among them, grudging and stingy no doubt, but still cooperation. The
American people, more eager to be busy in their fields or at their
trades, were simply forced to raise and support armies, to learn the
arts of warfare, and to practice, if in a small theater, the science of
statecraft. These forces, all cumulative, drove the colonists, so
tenaciously provincial in their habits, in the direction of nationalism.

=The New England Confederation.=--It was in their efforts to deal with
the problems presented by the Indian and French menace that the
Americans took the first steps toward union. Though there were many
common ties among the settlers of New England, it required a deadly
fear of the Indians to produce in 1643 the New England Confederation,
composed of Massachusetts, Plymouth, Connecticut, and New Haven. The
colonies so united were bound together in "a firm and perpetual league
of friendship and amity for offense and defense, mutual service and
succor, upon all just occasions." They made provision for distributing
the burdens of wars among the members and provided for a congress of
commissioners from each colony to determine upon common policies. For
some twenty years the Confederation was active and it continued to hold
meetings until after the extinction of the Indian peril on the immediate
border.

Virginia, no less than Massachusetts, was aware of the importance of
intercolonial cooperation. In the middle of the seventeenth century, the
Old Dominion began treaties of commerce and amity with New York and the
colonies of New England. In 1684 delegates from Virginia met at Albany
with the agents of New York and Massachusetts to discuss problems of
mutual defense. A few years later the Old Dominion cooperated loyally
with the Carolinas in defending their borders against Indian forays.

=The Albany Plan of Union.=--An attempt at a general colonial union was
made in 1754. On the suggestion of the Lords of Trade in England, a
conference was held at Albany to consider Indian relations, to devise
measures of defense against the French, and to enter into "articles of
union and confederation for the general defense of his Majesty's
subjects and interests in North America as well in time of peace as of
war." New Hampshire, Massachusetts, Connecticut, Rhode Island, New York,
Pennsylvania, and Maryland were represented. After a long discussion, a
plan of union, drafted mainly, it seems, by Benjamin Franklin, was
adopted and sent to the colonies and the crown for approval. The
colonies, jealous of their individual rights, refused to accept the
scheme and the king disapproved it for the reason, Franklin said, that
it had "too much weight in the democratic part of the constitution."
Though the Albany union failed, the document is still worthy of study
because it forecast many of the perplexing problems that were not solved
until thirty-three years afterward, when another convention of which
also Franklin was a member drafted the Constitution of the United
States.

[Illustration: BENJAMIN FRANKLIN]

=The Military Education of the Colonists.=--The same wars that showed
the provincials the meaning of union likewise instructed them in the art
of defending their institutions. Particularly was this true of the last
French and Indian conflict, which stretched all the way from Maine to
the Carolinas and made heavy calls upon them all for troops. The answer,
it is admitted, was far from satisfactory to the British government and
the conduct of the militiamen was far from professional; but thousands
of Americans got a taste, a strong taste, of actual fighting in the
field. Men like George Washington and Daniel Morgan learned lessons that
were not forgotten in after years. They saw what American militiamen
could do under favorable circumstances and they watched British regulars
operating on American soil. "This whole transaction," shrewdly remarked
Franklin of Braddock's campaign, "gave us Americans the first suspicion
that our exalted ideas of the prowess of British regular troops had not
been well founded." It was no mere accident that the Virginia colonel
who drew his sword under the elm at Cambridge and took command of the
army of the Revolution was the brave officer who had "spurned the
whistle of bullets" at the memorable battle in western Pennsylvania.

=Financial Burdens and Commercial Disorder.=--While the provincials were
learning lessons in warfare they were also paying the bills. All the
conflicts were costly in treasure as in blood. King Philip's war left
New England weak and almost bankrupt. The French and Indian struggle was
especially expensive. The twenty-five thousand men put in the field by
the colonies were sustained only by huge outlays of money. Paper
currency streamed from the press and debts were accumulated. Commerce
was driven from its usual channels and prices were enhanced. When the
end came, both England and America were staggering under heavy
liabilities, and to make matters worse there was a fall of prices
accompanied by a commercial depression which extended over a period of
ten years. It was in the midst of this crisis that measures of taxation
had to be devised to pay the cost of the war, precipitating the quarrel
which led to American independence.

=The Expulsion of French Power from North America.=--The effects of the
defeat administered to France, as time proved, were difficult to
estimate. Some British statesmen regarded it as a happy circumstance
that the colonists, already restive under their administration, had no
foreign power at hand to aid them in case they struck for independence.
American leaders, on the other hand, now that the soldiers of King Louis
were driven from the continent, thought that they had no other country
to fear if they cast off British sovereignty. At all events, France,
though defeated, was not out of the sphere of American influence; for,
as events proved, it was the fortunate French alliance negotiated by
Franklin that assured the triumph of American arms in the War of the
Revolution.


COLONIAL RELATIONS WITH THE BRITISH GOVERNMENT

It was neither the Indian wars nor the French wars that finally brought
forth American nationality. That was the product of the long strife
with the mother country which culminated in union for the war of
independence. The forces that created this nation did not operate in the
colonies alone. The character of the English sovereigns, the course of
events in English domestic politics, and English measures of control
over the colonies--executive, legislative, and judicial--must all be
taken into account.

=The Last of the Stuarts.=--The struggles between Charles I (1625-49)
and the parliamentary party and the turmoil of the Puritan regime
(1649-60) so engrossed the attention of Englishmen at home that they had
little time to think of colonial policies or to interfere with colonial
affairs. The restoration of the monarchy in 1660, accompanied by
internal peace and the increasing power of the mercantile classes in the
House of Commons, changed all that. In the reign of Charles II
(1660-85), himself an easy-going person, the policy of regulating trade
by act of Parliament was developed into a closely knit system and
powerful agencies to supervise the colonies were created. At the same
time a system of stricter control over the dominions was ushered in by
the annulment of the old charter of Massachusetts which conferred so
much self-government on the Puritans.

Charles' successor, James II, a man of sterner stuff and jealous of his
authority in the colonies as well as at home, continued the policy thus
inaugurated and enlarged upon it. If he could have kept his throne, he
would have bent the Americans under a harsh rule or brought on in his
dominions a revolution like that which he precipitated at home in 1688.
He determined to unite the Northern colonies and introduce a more
efficient administration based on the pattern of the royal provinces. He
made a martinet, Sir Edmund Andros, governor of all New England, New
York, and New Jersey. The charter of Massachusetts, annulled in the last
days of his brother's reign, he continued to ignore, and that of
Connecticut would have been seized if it had not been spirited away and
hidden, according to tradition, in a hollow oak.

For several months, Andros gave the Northern colonies a taste of
ill-tempered despotism. He wrung quit rents from land owners not
accustomed to feudal dues; he abrogated titles to land where, in his
opinion, they were unlawful; he forced the Episcopal service upon the
Old South Church in Boston; and he denied the writ of _habeas corpus_ to
a preacher who denounced taxation without representation. In the middle
of his arbitrary course, however, his hand was stayed. The news came
that King James had been dethroned by his angry subjects, and the people
of Boston, kindling a fire on Beacon Hill, summoned the countryside to
dispose of Andros. The response was prompt and hearty. The hated
governor was arrested, imprisoned, and sent back across the sea under
guard.

The overthrow of James, followed by the accession of William and Mary
and by assured parliamentary supremacy, had an immediate effect in the
colonies. The new order was greeted with thanksgiving. Massachusetts was
given another charter which, though not so liberal as the first,
restored the spirit if not the entire letter of self-government. In the
other colonies where Andros had been operating, the old course of
affairs was resumed.

=The Indifference of the First Two Georges.=--On the death in 1714 of
Queen Anne, the successor of King William, the throne passed to a
Hanoverian prince who, though grateful for English honors and revenues,
was more interested in Hanover than in England. George I and George II,
whose combined reigns extended from 1714 to 1760, never even learned to
speak the English language, at least without an accent. The necessity of
taking thought about colonial affairs bored both of them so that the
stoutest defender of popular privileges in Boston or Charleston had no
ground to complain of the exercise of personal prerogatives by the king.
Moreover, during a large part of this period, the direction of affairs
was in the hands of an astute leader, Sir Robert Walpole, who betrayed
his somewhat cynical view of politics by adopting as his motto: "Let
sleeping dogs lie." He revealed his appreciation of popular sentiment
by exclaiming: "I will not be the minister to enforce taxes at the
expense of blood." Such kings and such ministers were not likely to
arouse the slumbering resistance of the thirteen colonies across the
sea.

=Control of the Crown over the Colonies.=--While no English ruler from
James II to George III ventured to interfere with colonial matters
personally, constant control over the colonies was exercised by royal
officers acting under the authority of the crown. Systematic supervision
began in 1660, when there was created by royal order a committee of the
king's council to meet on Mondays and Thursdays of each week to consider
petitions, memorials, and addresses respecting the plantations. In 1696
a regular board was established, known as the "Lords of Trade and
Plantations," which continued, until the American Revolution, to
scrutinize closely colonial business. The chief duties of the board were
to examine acts of colonial legislatures, to recommend measures to those
assemblies for adoption, and to hear memorials and petitions from the
colonies relative to their affairs.

The methods employed by this board were varied. All laws passed by
American legislatures came before it for review as a matter of routine.
If it found an act unsatisfactory, it recommended to the king the
exercise of his veto power, known as the royal disallowance. Any person
who believed his personal or property rights injured by a colonial law
could be heard by the board in person or by attorney; in such cases it
was the practice to hear at the same time the agent of the colony so
involved. The royal veto power over colonial legislation was not,
therefore, a formal affair, but was constantly employed on the
suggestion of a highly efficient agency of the crown. All this was in
addition to the powers exercised by the governors in the royal
provinces.

=Judicial Control.=--Supplementing this administrative control over the
colonies was a constant supervision by the English courts of law. The
king, by virtue of his inherent authority, claimed and exercised high
appellate powers over all judicial tribunals in the empire. The right
of appeal from local courts, expressly set forth in some charters, was,
on the eve of the Revolution, maintained in every colony. Any subject in
England or America, who, in the regular legal course, was aggrieved by
any act of a colonial legislature or any decision of a colonial court,
had the right, subject to certain regulations, to carry his case to the
king in council, forcing his opponent to follow him across the sea. In
the exercise of appellate power, the king in council acting as a court
could, and frequently did, declare acts of colonial legislatures duly
enacted and approved, null and void, on the ground that they were
contrary to English law.

=Imperial Control in Operation.=--Day after day, week after week, year
after year, the machinery for political and judicial control over
colonial affairs was in operation. At one time the British governors in
the colonies were ordered not to approve any colonial law imposing a
duty on European goods imported in English vessels. Again, when North
Carolina laid a tax on peddlers, the council objected to it as
"restrictive upon the trade and dispersion of English manufactures
throughout the continent." At other times, Indian trade was regulated in
the interests of the whole empire or grants of lands by a colonial
legislature were set aside. Virginia was forbidden to close her ports to
North Carolina lest there should be retaliation.

In short, foreign and intercolonial trade were subjected to a control
higher than that of the colony, foreshadowing a day when the
Constitution of the United States was to commit to Congress the power to
regulate interstate and foreign commerce and commerce with the Indians.
A superior judicial power, towering above that of the colonies, as the
Supreme Court at Washington now towers above the states, kept the
colonial legislatures within the metes and bounds of established law. In
the thousands of appeals, memorials, petitions, and complaints, and the
rulings and decisions upon them, were written the real history of
British imperial control over the American colonies.

So great was the business before the Lords of Trade that the colonies
had to keep skilled agents in London to protect their interests. As
common grievances against the operation of this machinery of control
arose, there appeared in each colony a considerable body of men, with
the merchants in the lead, who chafed at the restraints imposed on their
enterprise. Only a powerful blow was needed to weld these bodies into a
common mass nourishing the spirit of colonial nationalism. When to the
repeated minor irritations were added general and sweeping measures of
Parliament applying to every colony, the rebound came in the Revolution.

=Parliamentary Control over Colonial Affairs.=--As soon as Parliament
gained in power at the expense of the king, it reached out to bring the
American colonies under its sway as well. Between the execution of
Charles I and the accession of George III, there was enacted an immense
body of legislation regulating the shipping, trade, and manufactures of
America. All of it, based on the "mercantile" theory then prevalent in
all countries of Europe, was designed to control the overseas
plantations in such a way as to foster the commercial and business
interests of the mother country, where merchants and men of finance had
got the upper hand. According to this theory, the colonies of the
British empire should be confined to agriculture and the production of
raw materials, and forced to buy their manufactured goods of England.

_The Navigation Acts._--In the first rank among these measures of
British colonial policy must be placed the navigation laws framed for
the purpose of building up the British merchant marine and navy--arms so
essential in defending the colonies against the Spanish, Dutch, and
French. The beginning of this type of legislation was made in 1651 and
it was worked out into a system early in the reign of Charles II
(1660-85).

The Navigation Acts, in effect, gave a monopoly of colonial commerce to
British ships. No trade could be carried on between Great Britain and
her dominions save in vessels built and manned by British subjects. No
European goods could be brought to America save in the ships of the
country that produced them or in English ships. These laws, which were
almost fatal to Dutch shipping in America, fell with severity upon the
colonists, compelling them to pay higher freight rates. The adverse
effect, however, was short-lived, for the measures stimulated
shipbuilding in the colonies, where the abundance of raw materials gave
the master builders of America an advantage over those of the mother
country. Thus the colonists in the end profited from the restrictive
policy written into the Navigation Acts.

_The Acts against Manufactures._--The second group of laws was
deliberately aimed to prevent colonial industries from competing too
sharply with those of England. Among the earliest of these measures may
be counted the Woolen Act of 1699, forbidding the exportation of woolen
goods from the colonies and even the woolen trade between towns and
colonies. When Parliament learned, as the result of an inquiry, that New
England and New York were making thousands of hats a year and sending
large numbers annually to the Southern colonies and to Ireland, Spain,
and Portugal, it enacted in 1732 a law declaring that "no hats or felts,
dyed or undyed, finished or unfinished" should be "put upon any vessel
or laden upon any horse or cart with intent to export to any place
whatever." The effect of this measure upon the hat industry was almost
ruinous. A few years later a similar blow was given to the iron
industry. By an act of 1750, pig and bar iron from the colonies were
given free entry to England to encourage the production of the raw
material; but at the same time the law provided that "no mill or other
engine for slitting or rolling of iron, no plating forge to work with a
tilt hammer, and no furnace for making steel" should be built in the
colonies. As for those already built, they were declared public
nuisances and ordered closed. Thus three important economic interests of
the colonists, the woolen, hat, and iron industries, were laid under the
ban.

_The Trade Laws._--The third group of restrictive measures passed by the
British Parliament related to the sale of colonial produce. An act of
1663 required the colonies to export certain articles to Great Britain
or to her dominions alone; while sugar, tobacco, and ginger consigned to
the continent of Europe had to pass through a British port paying custom
duties and through a British merchant's hands paying the usual
commission. At first tobacco was the only one of the "enumerated
articles" which seriously concerned the American colonies, the rest
coming mainly from the British West Indies. In the course of time,
however, other commodities were added to the list of enumerated
articles, until by 1764 it embraced rice, naval stores, copper, furs,
hides, iron, lumber, and pearl ashes. This was not all. The colonies
were compelled to bring their European purchases back through English
ports, paying duties to the government and commissions to merchants
again.

_The Molasses Act._--Not content with laws enacted in the interest of
English merchants and manufacturers, Parliament sought to protect the
British West Indies against competition from their French and Dutch
neighbors. New England merchants had long carried on a lucrative trade
with the French islands in the West Indies and Dutch Guiana, where sugar
and molasses could be obtained in large quantities at low prices. Acting
on the protests of English planters in the Barbadoes and Jamaica,
Parliament, in 1733, passed the famous Molasses Act imposing duties on
sugar and molasses imported into the colonies from foreign
countries--rates which would have destroyed the American trade with the
French and Dutch if the law had been enforced. The duties, however, were
not collected. The molasses and sugar trade with the foreigners went on
merrily, smuggling taking the place of lawful traffic.

=Effect of the Laws in America.=--As compared with the strict monopoly
of her colonial trade which Spain consistently sought to maintain, the
policy of England was both moderate and liberal. Furthermore, the
restrictive laws were supplemented by many measures intended to be
favorable to colonial prosperity. The Navigation Acts, for example,
redounded to the advantage of American shipbuilders and the producers
of hemp, tar, lumber, and ship stores in general. Favors in British
ports were granted to colonial producers as against foreign competitors
and in some instances bounties were paid by England to encourage
colonial enterprise. Taken all in all, there is much justification in
the argument advanced by some modern scholars to the effect that the
colonists gained more than they lost by British trade and industrial
legislation. Certainly after the establishment of independence, when
free from these old restrictions, the Americans found themselves
handicapped by being treated as foreigners rather than favored traders
and the recipients of bounties in English markets.

Be that as it may, it appears that the colonists felt little irritation
against the mother country on account of the trade and navigation laws
enacted previous to the close of the French and Indian war. Relatively
few were engaged in the hat and iron industries as compared with those
in farming and planting, so that England's policy of restricting America
to agriculture did not conflict with the interests of the majority of
the inhabitants. The woolen industry was largely in the hands of women
and carried on in connection with their domestic duties, so that it was
not the sole support of any considerable number of people.

As a matter of fact, moreover, the restrictive laws, especially those
relating to trade, were not rigidly enforced. Cargoes of tobacco were
boldly sent to continental ports without even so much as a bow to the
English government, to which duties should have been paid. Sugar and
molasses from the French and Dutch colonies were shipped into New
England in spite of the law. Royal officers sometimes protested against
smuggling and sometimes connived at it; but at no time did they succeed
in stopping it. Taken all in all, very little was heard of "the galling
restraints of trade" until after the French war, when the British
government suddenly entered upon a new course.


SUMMARY OF THE COLONIAL PERIOD

In the period between the landing of the English at Jamestown, Virginia,
in 1607, and the close of the French and Indian war in 1763--a period of
a century and a half--a new nation was being prepared on this continent
to take its place among the powers of the earth. It was an epoch of
migration. Western Europe contributed emigrants of many races and
nationalities. The English led the way. Next to them in numerical
importance were the Scotch-Irish and the Germans. Into the melting pot
were also cast Dutch, Swedes, French, Jews, Welsh, and Irish. Thousands
of negroes were brought from Africa to till Southern fields or labor as
domestic servants in the North.

Why did they come? The reasons are various. Some of them, the Pilgrims
and Puritans of New England, the French Huguenots, Scotch-Irish and
Irish, and the Catholics of Maryland, fled from intolerant governments
that denied them the right to worship God according to the dictates of
their consciences. Thousands came to escape the bondage of poverty in
the Old World and to find free homes in America. Thousands, like the
negroes from Africa, were dragged here against their will. The lure of
adventure appealed to the restless and the lure of profits to the
enterprising merchants.

How did they come? In some cases religious brotherhoods banded together
and borrowed or furnished the funds necessary to pay the way. In other
cases great trading companies were organized to found colonies. Again it
was the wealthy proprietor, like Lord Baltimore or William Penn, who
undertook to plant settlements. Many immigrants were able to pay their
own way across the sea. Others bound themselves out for a term of years
in exchange for the cost of the passage. Negroes were brought on account
of the profits derived from their sale as slaves.

Whatever the motive for their coming, however, they managed to get
across the sea. The immigrants set to work with a will. They cut down
forests, built houses, and laid out fields. They founded churches,
schools, and colleges. They set up forges and workshops. They spun and
wove. They fashioned ships and sailed the seas. They bartered and
traded. Here and there on favorable harbors they established centers of
commerce--Boston, Providence, New York, Philadelphia, Baltimore, and
Charleston. As soon as a firm foothold was secured on the shore line
they pressed westward until, by the close of the colonial period, they
were already on the crest of the Alleghanies.

Though they were widely scattered along a thousand miles of seacoast,
the colonists were united in spirit by many common ties. The major
portion of them were Protestants. The language, the law, and the
literature of England furnished the basis of national unity. Most of the
colonists were engaged in the same hard task; that of conquering a
wilderness. To ties of kinship and language were added ties created by
necessity. They had to unite in defense; first, against the Indians and
later against the French. They were all subjects of the same
sovereign--the king of England. The English Parliament made laws for
them and the English government supervised their local affairs, their
trade, and their manufactures. Common forces assailed them. Common
grievances vexed them. Common hopes inspired them.

Many of the things which tended to unite them likewise tended to throw
them into opposition to the British Crown and Parliament. Most of them
were freeholders; that is, farmers who owned their own land and tilled
it with their own hands. A free soil nourished the spirit of freedom.
The majority of them were Dissenters, critics, not friends, of the
Church of England, that stanch defender of the British monarchy. Each
colony in time developed its own legislature elected by the voters; it
grew accustomed to making laws and laying taxes for itself. Here was a
people learning self-reliance and self-government. The attempts to
strengthen the Church of England in America and the transformation of
colonies into royal provinces only fanned the spirit of independence
which they were designed to quench.

Nevertheless, the Americans owed much of their prosperity to the
assistance of the government that irritated them. It was the protection
of the British navy that prevented Holland, Spain, and France from
wiping out their settlements. Though their manufacture and trade were
controlled in the interests of the mother country, they also enjoyed
great advantages in her markets. Free trade existed nowhere upon the
earth; but the broad empire of Britain was open to American ships and
merchandise. It could be said, with good reason, that the disadvantages
which the colonists suffered through British regulation of their
industry and trade were more than offset by the privileges they enjoyed.
Still that is somewhat beside the point, for mere economic advantage is
not necessarily the determining factor in the fate of peoples. A
thousand circumstances had helped to develop on this continent a nation,
to inspire it with a passion for independence, and to prepare it for a
destiny greater than that of a prosperous dominion of the British
empire. The economists, who tried to prove by logic unassailable that
America would be richer under the British flag, could not change the
spirit of Patrick Henry, Samuel Adams, Benjamin Franklin, or George
Washington.


=References=

G.L. Beer, _Origin of the British Colonial System_ and _The Old Colonial
System_.

A. Bradley, _The Fight for Canada in North America_.

C.M. Andrews, _Colonial Self-Government_ (American Nation Series).

H. Egerton, _Short History of British Colonial Policy_.

F. Parkman, _France and England in North America_ (12 vols.).

R. Thwaites, _France in America_ (American Nation Series).

J. Winsor, _The Mississippi Valley_ and _Cartier to Frontenac_.


=Questions=

1. How would you define "nationalism"?

2. Can you give any illustrations of the way that war promotes
nationalism?

3. Why was it impossible to establish and maintain a uniform policy in
dealing with the Indians?

4. What was the outcome of the final clash with the French?

5. Enumerate the five chief results of the wars with the French and the
Indians. Discuss each in detail.

6. Explain why it was that the character of the English king mattered to
the colonists.

7. Contrast England under the Stuarts with England under the
Hanoverians.

8. Explain how the English Crown, Courts, and Parliament controlled the
colonies.

9. Name the three important classes of English legislation affecting the
colonies. Explain each.

10. Do you think the English legislation was beneficial or injurious to
the colonies? Why?


=Research Topics=

=Rise of French Power in North America.=--Special reference: Francis
Parkman, _Struggle for a Continent_.

=The French and Indian Wars.=--Special reference: W.M. Sloane, _French
War and the Revolution_, Chaps. VI-IX. Parkman, _Montcalm and Wolfe_,
Vol. II, pp. 195-299. Elson, _History of the United States_, pp.
171-196.

=English Navigation Acts.=--Macdonald, _Documentary Source Book_, pp.
55, 72, 78, 90, 103. Coman, _Industrial History_, pp. 79-85.

=British Colonial Policy.=--Callender, _Economic History of the United
States_, pp. 102-108.

=The New England Confederation.=--Analyze the document in Macdonald,
_Source Book_, p. 45. Special reference: Fiske, _Beginnings of New
England_, pp. 140-198.

=The Administration of Andros.=--Fiske, _Beginnings_, pp. 242-278.

=Biographical Studies.=--William Pitt and Sir Robert Walpole. Consult
Green, _Short History of England_, on their policies, using the index.




PART II. CONFLICT AND INDEPENDENCE




CHAPTER V

THE NEW COURSE IN BRITISH IMPERIAL POLICY


On October 25, 1760, King George II died and the British crown passed to
his young grandson. The first George, the son of the Elector of Hanover
and Sophia the granddaughter of James I, was a thorough German who never
even learned to speak the language of the land over which he reigned.
The second George never saw England until he was a man. He spoke English
with an accent and until his death preferred his German home. During
their reign, the principle had become well established that the king did
not govern but acted only through ministers representing the majority in
Parliament.


GEORGE III AND HIS SYSTEM

=The Character of the New King.=--The third George rudely broke the
German tradition of his family. He resented the imputation that he was a
foreigner and on all occasions made a display of his British sympathies.
To the draft of his first speech to Parliament, he added the popular
phrase: "Born and educated in this country, I glory in the name of
Briton." Macaulay, the English historian, certainly of no liking for
high royal prerogative, said of George: "The young king was a born
Englishman. All his tastes and habits, good and bad, were English. No
portion of his subjects had anything to reproach him with.... His age,
his appearance, and all that was known of his character conciliated
public favor. He was in the bloom of youth; his person and address were
pleasing; scandal imputed to him no vice; and flattery might without
glaring absurdity ascribe to him many princely virtues."

Nevertheless George III had been spoiled by his mother, his tutors, and
his courtiers. Under their influence he developed high and mighty
notions about the sacredness of royal authority and his duty to check
the pretensions of Parliament and the ministers dependent upon it. His
mother had dinned into his ears the slogan: "George, be king!" Lord
Bute, his teacher and adviser, had told him that his honor required him
to take an active part in the shaping of public policy and the making of
laws. Thus educated, he surrounded himself with courtiers who encouraged
him in the determination to rule as well as reign, to subdue all
parties, and to place himself at the head of the nation and empire.

[Illustration: _From an old print._

GEORGE III]

=Political Parties and George III.=--The state of the political parties
favored the plans of the king to restore some of the ancient luster of
the crown. The Whigs, who were composed mainly of the smaller
freeholders, merchants, inhabitants of towns, and Protestant
non-conformists, had grown haughty and overbearing through long
continuance in power and had as a consequence raised up many enemies in
their own ranks. Their opponents, the Tories, had by this time given up
all hope of restoring to the throne the direct Stuart line; but they
still cherished their old notions about divine right. With the
accession of George III the coveted opportunity came to them to rally
around the throne again. George received his Tory friends with open
arms, gave them offices, and bought them seats in the House of Commons.

=The British Parliamentary System.=--The peculiarities of the British
Parliament at the time made smooth the way for the king and his allies
with their designs for controlling the entire government. In the first
place, the House of Lords was composed mainly of hereditary nobles whose
number the king could increase by the appointment of his favorites, as
of old. Though the members of the House of Commons were elected by
popular vote, they did not speak for the mass of English people. Great
towns like Leeds, Manchester, and Birmingham, for example, had no
representatives at all. While there were about eight million inhabitants
in Great Britain, there were in 1768 only about 160,000 voters; that is
to say, only about one in every ten adult males had a voice in the
government. Many boroughs returned one or more members to the Commons
although they had merely a handful of voters or in some instances no
voters at all. Furthermore, these tiny boroughs were often controlled by
lords who openly sold the right of representation to the highest bidder.
The "rotten-boroughs," as they were called by reformers, were a public
scandal, but George III readily made use of them to get his friends into
the House of Commons.


GEORGE III'S MINISTERS AND THEIR COLONIAL POLICIES

=Grenville and the War Debt.=--Within a year after the accession of
George III, William Pitt was turned out of office, the king treating him
with "gross incivility" and the crowds shouting "Pitt forever!" The
direction of affairs was entrusted to men enjoying the king's
confidence. Leadership in the House of Commons fell to George Grenville,
a grave and laborious man who for years had groaned over the increasing
cost of government.

The first task after the conclusion of peace in 1763 was the adjustment
of the disordered finances of the kingdom. The debt stood at the highest
point in the history of the country. More revenue was absolutely
necessary and Grenville began to search for it, turning his attention
finally to the American colonies. In this quest he had the aid of a
zealous colleague, Charles Townshend, who had long been in public
service and was familiar with the difficulties encountered by royal
governors in America. These two men, with the support of the entire
ministry, inaugurated in February, 1763, "a new system of colonial
government. It was announced by authority that there were to be no more
requisitions from the king to the colonial assemblies for supplies, but
that the colonies were to be taxed instead by act of Parliament.
Colonial governors and judges were to be paid by the Crown; they were to
be supported by a standing army of twenty regiments; and all the
expenses of this force were to be met by parliamentary taxation."

=Restriction of Paper Money (1763).=--Among the many complaints filed
before the board of trade were vigorous protests against the issuance of
paper money by the colonial legislatures. The new ministry provided a
remedy in the act of 1763, which declared void all colonial laws
authorizing paper money or extending the life of outstanding bills. This
law was aimed at the "cheap money" which the Americans were fond of
making when specie was scarce--money which they tried to force on their
English creditors in return for goods and in payment of the interest and
principal of debts. Thus the first chapter was written in the long
battle over sound money on this continent.

=Limitation on Western Land Sales.=--Later in the same year (1763)
George III issued a royal proclamation providing, among other things,
for the government of the territory recently acquired by the treaty of
Paris from the French. One of the provisions in this royal decree
touched frontiersmen to the quick. The contests between the king's
officers and the colonists over the disposition of western lands had
been long and sharp. The Americans chafed at restrictions on
settlement. The more adventurous were continually moving west and
"squatting" on land purchased from the Indians or simply seized without
authority. To put an end to this, the king forbade all further purchases
from the Indians, reserving to the crown the right to acquire such lands
and dispose of them for settlement. A second provision in the same
proclamation vested the power of licensing trade with the Indians,
including the lucrative fur business, in the hands of royal officers in
the colonies. These two limitations on American freedom and enterprise
were declared to be in the interest of the crown and for the
preservation of the rights of the Indians against fraud and abuses.

=The Sugar Act of 1764.=--King George's ministers next turned their
attention to measures of taxation and trade. Since the heavy debt under
which England was laboring had been largely incurred in the defense of
America, nothing seemed more reasonable to them than the proposition
that the colonies should help to bear the burden which fell so heavily
upon the English taxpayer. The Sugar Act of 1764 was the result of this
reasoning. There was no doubt about the purpose of this law, for it was
set forth clearly in the title: "An act for granting certain duties in
the British colonies and plantations in America ... for applying the
produce of such duties ... towards defraying the expenses of defending,
protecting and securing the said colonies and plantations ... and for
more effectually preventing the clandestine conveyance of goods to and
from the said colonies and plantations and improving and securing the
trade between the same and Great Britain." The old Molasses Act had been
prohibitive; the Sugar Act of 1764 was clearly intended as a revenue
measure. Specified duties were laid upon sugar, indigo, calico, silks,
and many other commodities imported into the colonies. The enforcement
of the Molasses Act had been utterly neglected; but this Sugar Act had
"teeth in it." Special precautions as to bonds, security, and
registration of ship masters, accompanied by heavy penalties, promised
a vigorous execution of the new revenue law.

The strict terms of the Sugar Act were strengthened by administrative
measures. Under a law of the previous year the commanders of armed
vessels stationed along the American coast were authorized to stop,
search, and, on suspicion, seize merchant ships approaching colonial
ports. By supplementary orders, the entire British official force in
America was instructed to be diligent in the execution of all trade and
navigation laws. Revenue collectors, officers of the army and navy, and
royal governors were curtly ordered to the front to do their full duty
in the matter of law enforcement. The ordinary motives for the discharge
of official obligations were sharpened by an appeal to avarice, for
naval officers who seized offenders against the law were rewarded by
large prizes out of the forfeitures and penalties.

=The Stamp Act (1765).=--The Grenville-Townshend combination moved
steadily towards its goal. While the Sugar Act was under consideration
in Parliament, Grenville announced a plan for a stamp bill. The next
year it went through both Houses with a speed that must have astounded
its authors. The vote in the Commons stood 205 in favor to 49 against;
while in the Lords it was not even necessary to go through the formality
of a count. As George III was temporarily insane, the measure received
royal assent by a commission acting as a board of regency. Protests of
colonial agents in London were futile. "We might as well have hindered
the sun's progress!" exclaimed Franklin. Protests of a few opponents in
the Commons were equally vain. The ministry was firm in its course and
from all appearances the Stamp Act hardly roused as much as a languid
interest in the city of London. In fact, it is recorded that the fateful
measure attracted less notice than a bill providing for a commission to
act for the king when he was incapacitated.

The Stamp Act, like the Sugar Act, declared the purpose of the British
government to raise revenue in America "towards defraying the expenses
of defending, protecting, and securing the British colonies and
plantations in America." It was a long measure of more than fifty
sections, carefully planned and skillfully drawn. By its provisions
duties were imposed on practically all papers used in legal
transactions,--deeds, mortgages, inventories, writs, bail bonds,--on
licenses to practice law and sell liquor, on college diplomas, playing
cards, dice, pamphlets, newspapers, almanacs, calendars, and
advertisements. The drag net was closely knit, for scarcely anything
escaped.

=The Quartering Act (1765).=--The ministers were aware that the Stamp
Act would rouse opposition in America--how great they could not
conjecture. While the measure was being debated, a friend of General
Wolfe, Colonel Barre, who knew America well, gave them an ominous
warning in the Commons. "Believe me--remember I this day told you so--"
he exclaimed, "the same spirit of freedom which actuated that people at
first will accompany them still ... a people jealous of their liberties
and who will vindicate them, if ever they should be violated." The
answer of the ministry to a prophecy of force was a threat of force.
Preparations were accordingly made to dispatch a larger number of
soldiers than usual to the colonies, and the ink was hardly dry on the
Stamp Act when Parliament passed the Quartering Act ordering the
colonists to provide accommodations for the soldiers who were to enforce
the new laws. "We have the power to tax them," said one of the ministry,
"and we will tax them."


COLONIAL RESISTANCE FORCES REPEAL

=Popular Opposition.=--The Stamp Act was greeted in America by an
outburst of denunciation. The merchants of the seaboard cities took the
lead in making a dignified but unmistakable protest, agreeing not to
import British goods while the hated law stood upon the books. Lawyers,
some of them incensed at the heavy taxes on their operations and others
intimidated by patriots who refused to permit them to use stamped
papers, joined with the merchants. Aristocratic colonial Whigs, who had
long grumbled at the administration of royal governors, protested
against taxation without their consent, as the Whigs had done in old
England. There were Tories, however, in the colonies as in England--many
of them of the official class--who denounced the merchants, lawyers, and
Whig aristocrats as "seditious, factious and republican." Yet the
opposition to the Stamp Act and its accompanying measure, the Quartering
Act, grew steadily all through the summer of 1765.

In a little while it was taken up in the streets and along the
countryside. All through the North and in some of the Southern colonies,
there sprang up, as if by magic, committees and societies pledged to
resist the Stamp Act to the bitter end. These popular societies were
known as Sons of Liberty and Daughters of Liberty: the former including
artisans, mechanics, and laborers; and the latter, patriotic women. Both
groups were alike in that they had as yet taken little part in public
affairs. Many artisans, as well as all the women, were excluded from the
right to vote for colonial assemblymen.

While the merchants and Whig gentlemen confined their efforts chiefly to
drafting well-phrased protests against British measures, the Sons of
Liberty operated in the streets and chose rougher measures. They stirred
up riots in Boston, New York, Philadelphia, and Charleston when attempts
were made to sell the stamps. They sacked and burned the residences of
high royal officers. They organized committees of inquisition who by
threats and intimidation curtailed the sale of British goods and the use
of stamped papers. In fact, the Sons of Liberty carried their operations
to such excesses that many mild opponents of the stamp tax were
frightened and drew back in astonishment at the forces they had
unloosed. The Daughters of Liberty in a quieter way were making a very
effective resistance to the sale of the hated goods by spurring on
domestic industries, their own particular province being the manufacture
of clothing, and devising substitutes for taxed foods. They helped to
feed and clothe their families without buying British goods.

=Legislative Action against the Stamp Act.=--Leaders in the colonial
assemblies, accustomed to battle against British policies, supported the
popular protest. The Stamp Act was signed on March 22, 1765. On May 30,
the Virginia House of Burgesses passed a set of resolutions declaring
that the General Assembly of the colony alone had the right to lay taxes
upon the inhabitants and that attempts to impose them otherwise were
"illegal, unconstitutional, and unjust." It was in support of these
resolutions that Patrick Henry uttered the immortal challenge: "Caesar
had his Brutus, Charles I his Cromwell, and George III...." Cries of
"Treason" were calmly met by the orator who finished: "George III may
profit by their example. If that be treason, make the most of it."

[Illustration: PATRICK HENRY]

=The Stamp Act Congress.=--The Massachusetts Assembly answered the call
of Virginia by inviting the colonies to elect delegates to a Congress to
be held in New York to discuss the situation. Nine colonies responded
and sent representatives. The delegates, while professing the warmest
affection for the king's person and government, firmly spread on record
a series of resolutions that admitted of no double meaning. They
declared that taxes could not be imposed without their consent, given
through their respective colonial assemblies; that the Stamp Act showed
a tendency to subvert their rights and liberties; that the recent trade
acts were burdensome and grievous; and that the right to petition the
king and Parliament was their heritage. They thereupon made "humble
supplication" for the repeal of the Stamp Act.

The Stamp Act Congress was more than an assembly of protest. It marked
the rise of a new agency of government to express the will of America.
It was the germ of a government which in time was to supersede the
government of George III in the colonies. It foreshadowed the Congress
of the United States under the Constitution. It was a successful attempt
at union. "There ought to be no New England men," declared Christopher
Gadsden, in the Stamp Act Congress, "no New Yorkers known on the
Continent, but all of us Americans."

=The Repeal of the Stamp Act and the Sugar Act.=--The effect of American
resistance on opinion in England was telling. Commerce with the colonies
had been effectively boycotted by the Americans; ships lay idly swinging
at the wharves; bankruptcy threatened hundreds of merchants in London,
Bristol, and Liverpool. Workingmen in the manufacturing towns of England
were thrown out of employment. The government had sown folly and was
reaping, in place of the coveted revenue, rebellion.

Perplexed by the storm they had raised, the ministers summoned to the
bar of the House of Commons, Benjamin Franklin, the agent for
Pennsylvania, who was in London. "Do you think it right," asked
Grenville, "that America should be protected by this country and pay no
part of the expenses?" The answer was brief: "That is not the case; the
colonies raised, clothed, and paid during the last war twenty-five
thousand men and spent many millions." Then came an inquiry whether the
colonists would accept a modified stamp act. "No, never," replied
Franklin, "never! They will never submit to it!" It was next suggested
that military force might compel obedience to law. Franklin had a ready
answer. "They cannot force a man to take stamps.... They may not find a
rebellion; they may, indeed, make one."

The repeal of the Stamp Act was moved in the House of Commons a few days
later. The sponsor for the repeal spoke of commerce interrupted, debts
due British merchants placed in jeopardy, Manchester industries closed,
workingmen unemployed, oppression instituted, and the loss of the
colonies threatened. Pitt and Edmund Burke, the former near the close
of his career, the latter just beginning his, argued cogently in favor
of retracing the steps taken the year before. Grenville refused.
"America must learn," he wailed, "that prayers are not to be brought to
Caesar through riot and sedition." His protests were idle. The Commons
agreed to the repeal on February 22, 1766, amid the cheers of the
victorious majority. It was carried through the Lords in the face of
strong opposition and, on March 18, reluctantly signed by the king, now
restored to his right mind.

In rescinding the Stamp Act, Parliament did not admit the contention of
the Americans that it was without power to tax them. On the contrary, it
accompanied the repeal with a Declaratory Act. It announced that the
colonies were subordinate to the crown and Parliament of Great Britain;
that the king and Parliament therefore had undoubted authority to make
laws binding the colonies in all cases whatsoever; and that the
resolutions and proceedings of the colonists denying such authority were
null and void.

The repeal was greeted by the colonists with great popular
demonstrations. Bells were rung; toasts to the king were drunk; and
trade resumed its normal course. The Declaratory Act, as a mere paper
resolution, did not disturb the good humor of those who again cheered
the name of King George. Their confidence was soon strengthened by the
news that even the Sugar Act had been repealed, thus practically
restoring the condition of affairs before Grenville and Townshend
inaugurated their policy of "thoroughness."


RESUMPTION OF BRITISH REVENUE AND COMMERCIAL POLICIES

=The Townshend Acts (1767).=--The triumph of the colonists was brief.
Though Pitt, the friend of America, was once more prime minister, and
seated in the House of Lords as the Earl of Chatham, his severe illness
gave to Townshend and the Tory party practical control over Parliament.
Unconvinced by the experience with the Stamp Act, Townshend brought
forward and pushed through both Houses of Parliament three measures,
which to this day are associated with his name. First among his
restrictive laws was that of June 29, 1767, which placed the enforcement
of the collection of duties and customs on colonial imports and exports
in the hands of British commissioners appointed by the king, resident in
the colonies, paid from the British treasury, and independent of all
control by the colonists. The second measure of the same date imposed a
tax on lead, glass, paint, tea, and a few other articles imported into
the colonies, the revenue derived from the duties to be applied toward
the payment of the salaries and other expenses of royal colonial
officials. A third measure was the Tea Act of July 2, 1767, aimed at the
tea trade which the Americans carried on illegally with foreigners. This
law abolished the duty which the East India Company had to pay in
England on tea exported to America, for it was thought that English tea
merchants might thus find it possible to undersell American tea
smugglers.

=Writs of Assistance Legalized by Parliament.=--Had Parliament been
content with laying duties, just as a manifestation of power and right,
and neglected their collection, perhaps little would have been heard of
the Townshend Acts. It provided, however, for the strict, even the
harsh, enforcement of the law. It ordered customs officers to remain at
their posts and put an end to smuggling. In the revenue act of June 29,
1767, it expressly authorized the superior courts of the colonies to
issue "writs of assistance," empowering customs officers to enter "any
house, warehouse, shop, cellar, or other place in the British colonies
or plantations in America to search for and seize" prohibited or
smuggled goods.

The writ of assistance, which was a general search warrant issued to
revenue officers, was an ancient device hateful to a people who
cherished the spirit of personal independence and who had made actual
gains in the practice of civil liberty. To allow a "minion of the law"
to enter a man's house and search his papers and premises, was too much
for the emotions of people who had fled to America in a quest for
self-government and free homes, who had braved such hardships to
establish them, and who wanted to trade without official interference.

The writ of assistance had been used in Massachusetts in 1755 to prevent
illicit trade with Canada and had aroused a violent hostility at that
time. In 1761 it was again the subject of a bitter controversy which
arose in connection with the application of a customs officer to a
Massachusetts court for writs of assistance "as usual." This application
was vainly opposed by James Otis in a speech of five hours' duration--a
speech of such fire and eloquence that it sent every man who heard it
away "ready to take up arms against writs of assistance." Otis denounced
the practice as an exercise of arbitrary power which had cost one king
his head and another his throne, a tyrant's device which placed the
liberty of every man in jeopardy, enabling any petty officer to work
possible malice on any innocent citizen on the merest suspicion, and to
spread terror and desolation through the land. "What a scene," he
exclaimed, "does this open! Every man, prompted by revenge, ill-humor,
or wantonness to inspect the inside of his neighbor's house, may get a
writ of assistance. Others will ask it from self-defense; one arbitrary
exertion will provoke another until society is involved in tumult and
blood." He did more than attack the writ itself. He said that Parliament
could not establish it because it was against the British constitution.
This was an assertion resting on slender foundation, but it was quickly
echoed by the people. Then and there James Otis sounded the call to
America to resist the exercise of arbitrary power by royal officers.
"Then and there," wrote John Adams, "the child Independence was born."
Such was the hated writ that Townshend proposed to put into the hands of
customs officers in his grim determination to enforce the law.

=The New York Assembly Suspended.=--In the very month that Townshend's
Acts were signed by the king, Parliament took a still more drastic step.
The assembly of New York, protesting against the "ruinous and
insupportable" expense involved, had failed to make provision for the
care of British troops in accordance with the terms of the Quartering
Act. Parliament therefore suspended the assembly until it promised to
obey the law. It was not until a third election was held that compliance
with the Quartering Act was wrung from the reluctant province. In the
meantime, all the colonies had learned on how frail a foundation their
representative bodies rested.


RENEWED RESISTANCE IN AMERICA

=The Massachusetts Circular (1768).=--Massachusetts, under the
leadership of Samuel Adams, resolved to resist the policy of renewed
intervention in America. At his suggestion the assembly adopted a
Circular Letter addressed to the assemblies of the other colonies
informing them of the state of affairs in Massachusetts and roundly
condemning the whole British program. The Circular Letter declared that
Parliament had no right to lay taxes on Americans without their consent
and that the colonists could not, from the nature of the case, be
represented in Parliament. It went on shrewdly to submit to
consideration the question as to whether any people could be called free
who were subjected to governors and judges appointed by the crown and
paid out of funds raised independently. It invited the other colonies,
in the most temperate tones, to take thought about the common
predicament in which they were all placed.

[Illustration: _From an old print._

SAMUEL ADAMS]

=The Dissolution of Assemblies.=--The governor of Massachusetts, hearing
of the Circular Letter, ordered the assembly to rescind its appeal. On
meeting refusal, he promptly dissolved it. The Maryland, Georgia, and
South Carolina assemblies indorsed the Circular Letter and were also
dissolved at once. The Virginia House of Burgesses, thoroughly aroused,
passed resolutions on May 16, 1769, declaring that the sole right of
imposing taxes in Virginia was vested in its legislature, asserting anew
the right of petition to the crown, condemning the transportation of
persons accused of crimes or trial beyond the seas, and beseeching the
king for a redress of the general grievances. The immediate dissolution
of the Virginia assembly, in its turn, was the answer of the royal
governor.

=The Boston Massacre.=--American opposition to the British authorities
kept steadily rising as assemblies were dissolved, the houses of
citizens searched, and troops distributed in increasing numbers among
the centers of discontent. Merchants again agreed not to import British
goods, the Sons of Liberty renewed their agitation, and women set about
the patronage of home products still more loyally.

On the night of March 5, 1770, a crowd on the streets of Boston began to
jostle and tease some British regulars stationed in the town. Things
went from bad to worse until some "boys and young fellows" began to
throw snowballs and stones. Then the exasperated soldiers fired into the
crowd, killing five and wounding half a dozen more. The day after the
"massacre," a mass meeting was held in the town and Samuel Adams was
sent to demand the withdrawal of the soldiers. The governor hesitated
and tried to compromise. Finding Adams relentless, the governor yielded
and ordered the regulars away.

The Boston Massacre stirred the country from New Hampshire to Georgia.
Popular passions ran high. The guilty soldiers were charged with murder.
Their defense was undertaken, in spite of the wrath of the populace, by
John Adams and Josiah Quincy, who as lawyers thought even the worst

offenders entitled to their full rights in law. In his speech to the
jury, however, Adams warned the British government against its course,
saying, that "from the nature of things soldiers quartered in a populous
town will always occasion two mobs where they will prevent one." Two of
the soldiers were convicted and lightly punished.

=Resistance in the South.=--The year following the Boston Massacre some
citizens of North Carolina, goaded by the conduct of the royal governor,
openly resisted his authority. Many were killed as a result and seven
who were taken prisoners were hanged as traitors. A little later royal
troops and local militia met in a pitched battle near Alamance River,
called the "Lexington of the South."

=The _Gaspee_ Affair and the Virginia Resolutions of 1773.=--On sea as
well as on land, friction between the royal officers and the colonists
broke out into overt acts. While patrolling Narragansett Bay looking for
smugglers one day in 1772, the armed ship, _Gaspee_, ran ashore and was
caught fast. During the night several men from Providence boarded the
vessel and, after seizing the crew, set it on fire. A royal commission,
sent to Rhode Island to discover the offenders and bring them to
account, failed because it could not find a single informer. The very
appointment of such a commission aroused the patriots of Virginia to
action; and in March, 1773, the House of Burgesses passed a resolution
creating a standing committee of correspondence to develop cooperation
among the colonies in resistance to British measures.

=The Boston Tea Party.=--Although the British government, finding the
Townshend revenue act a failure, repealed in 1770 all the duties except
that on tea, it in no way relaxed its resolve to enforce the other
commercial regulations it had imposed on the colonies. Moreover,
Parliament decided to relieve the British East India Company of the
financial difficulties into which it had fallen partly by reason of the
Tea Act and the colonial boycott that followed. In 1773 it agreed to
return to the Company the regular import duties, levied in England, on
all tea transshipped to America. A small impost of three pence, to be
collected in America, was left as a reminder of the principle laid down
in the Declaratory Act that Parliament had the right to tax the
colonists.

This arrangement with the East India Company was obnoxious to the
colonists for several reasons. It was an act of favoritism for one
thing, in the interest of a great monopoly. For another thing, it
promised to dump on the American market, suddenly, an immense amount of
cheap tea and so cause heavy losses to American merchants who had large
stocks on hand. It threatened with ruin the business of all those who
were engaged in clandestine trade with the Dutch. It carried with it an
irritating tax of three pence on imports. In Charleston, Annapolis, New
York, and Boston, captains of ships who brought tea under this act were
roughly handled. One night in December, 1773, a band of Boston citizens,
disguised as Indians, boarded the hated tea ships and dumped the cargo
into the harbor. This was serious business, for it was open, flagrant,
determined violation of the law. As such the British government viewed
it.


RETALIATION BY THE BRITISH GOVERNMENT

=Reception of the News of the Tea Riot.=--The news of the tea riot in
Boston confirmed King George in his conviction that there should be no
soft policy in dealing with his American subjects. "The die is cast," he
stated with evident satisfaction. "The colonies must either triumph or
submit.... If we take the resolute part, they will undoubtedly be very
meek." Lord George Germain characterized the tea party as "the
proceedings of a tumultuous and riotous rabble who ought, if they had
the least prudence, to follow their mercantile employments and not
trouble themselves with politics and government, which they do not
understand." This expressed, in concise form, exactly the sentiments of
Lord North, who had then for three years been the king's chief minister.
Even Pitt, Lord Chatham, was prepared to support the government in
upholding its authority.

=The Five Intolerable Acts.=--Parliament, beginning on March 31, 1774,
passed five stringent measures, known in American history as the five
"intolerable acts." They were aimed at curing the unrest in America. The
_first_ of them was a bill absolutely shutting the port of Boston to
commerce with the outside world. The _second_, following closely,
revoked the Massachusetts charter of 1691 and provided furthermore that
the councilors should be appointed by the king, that all judges should
be named by the royal governor, and that town meetings (except to elect
certain officers) could not be held without the governor's consent. A
_third_ measure, after denouncing the "utter subversion of all lawful
government" in the provinces, authorized royal agents to transfer to
Great Britain or to other colonies the trials of officers or other
persons accused of murder in connection with the enforcement of the law.
The _fourth_ act legalized the quartering of troops in Massachusetts
towns. The _fifth_ of the measures was the Quebec Act, which granted
religious toleration to the Catholics in Canada, extended the boundaries
of Quebec southward to the Ohio River, and established, in this western
region, government by a viceroy.

The intolerable acts went through Parliament with extraordinary
celerity. There was an opposition, alert and informed; but it was
ineffective. Burke spoke eloquently against the Boston port bill,
condemning it roundly for punishing the innocent with the guilty, and
showing how likely it was to bring grave consequences in its train. He
was heard with respect and his pleas were rejected. The bill passed both
houses without a division, the entry "unanimous" being made upon their
journals although it did not accurately represent the state of opinion.
The law destroying the charter of Massachusetts passed the Commons by a
vote of three to one; and the third intolerable act by a vote of four to
one. The triumph of the ministry was complete. "What passed in Boston,"
exclaimed the great jurist, Lord Mansfield, "is the overt act of High
Treason proceeding from our over lenity and want of foresight." The
crown and Parliament were united in resorting to punitive measures.

In the colonies the laws were received with consternation. To the
American Protestants, the Quebec Act was the most offensive. That
project they viewed not as an act of grace or of mercy but as a direct
attempt to enlist French Canadians on the side of Great Britain. The
British government did not grant religious toleration to Catholics
either at home or in Ireland and the Americans could see no good motive
in granting it in North America. The act was also offensive because
Massachusetts, Connecticut, and Virginia had, under their charters,
large claims in the territory thus annexed to Quebec.

To enforce these intolerable acts the military arm of the British
government was brought into play. The commander-in-chief of the armed
forces in America, General Gage, was appointed governor of
Massachusetts. Reinforcements were brought to the colonies, for now King
George was to give "the rebels," as he called them, a taste of strong
medicine. The majesty of his law was to be vindicated by force.


FROM REFORM TO REVOLUTION IN AMERICA

=The Doctrine of Natural Rights.=--The dissolution of assemblies, the
destruction of charters, and the use of troops produced in the colonies
a new phase in the struggle. In the early days of the contest with the
British ministry, the Americans spoke of their "rights as Englishmen"
and condemned the acts of Parliament as unlawful, as violating the
principles of the English constitution under which they all lived. When
they saw that such arguments had no effect on Parliament, they turned
for support to their "natural rights." The latter doctrine, in the form
in which it was employed by the colonists, was as English as the
constitutional argument. John Locke had used it with good effect in
defense of the English revolution in the seventeenth century. American
leaders, familiar with the writings of Locke, also took up his thesis in
the hour of their distress. They openly declared that their rights did
not rest after all upon the English constitution or a charter from the
crown. "Old Magna Carta was not the beginning of all things," retorted
Otis when the constitutional argument failed. "A time may come when
Parliament shall declare every American charter void, but the natural,
inherent, and inseparable rights of the colonists as men and as citizens
would remain and whatever became of charters can never be abolished
until the general conflagration." Of the same opinion was the young and
impetuous Alexander Hamilton. "The sacred rights of mankind," he
exclaimed, "are not to be rummaged for among old parchments or musty
records. They are written as with a sunbeam in the whole volume of human
destiny by the hand of divinity itself, and can never be erased or
obscured by mortal power."

Firm as the American leaders were in the statement and defense of their
rights, there is every reason for believing that in the beginning they
hoped to confine the conflict to the realm of opinion. They constantly
avowed that they were loyal to the king when protesting in the strongest
language against his policies. Even Otis, regarded by the loyalists as a
firebrand, was in fact attempting to avert revolution by winning
concessions from England. "I argue this cause with the greater
pleasure," he solemnly urged in his speech against the writs of
assistance, "as it is in favor of British liberty ... and as it is in
opposition to a kind of power, the exercise of which in former periods
cost one king of England his head and another his throne."

=Burke Offers the Doctrine of Conciliation.=--The flooding tide of
American sentiment was correctly measured by one Englishman at least,
Edmund Burke, who quickly saw that attempts to restrain the rise of
American democracy were efforts to reverse the processes of nature. He
saw how fixed and rooted in the nature of things was the American
spirit--how inevitable, how irresistible. He warned his countrymen that
there were three ways of handling the delicate situation--and only
three. One was to remove the cause of friction by changing the spirit of
the colonists--an utter impossibility because that spirit was grounded
in the essential circumstances of American life. The second was to
prosecute American leaders as criminals; of this he begged his
countrymen to beware lest the colonists declare that "a government
against which a claim of liberty is tantamount to high treason is a
government to which submission is equivalent to slavery." The third and
right way to meet the problem, Burke concluded, was to accept the
American spirit, repeal the obnoxious measures, and receive the colonies
into equal partnership.

=Events Produce the Great Decision.=--The right way, indicated by Burke,
was equally impossible to George III and the majority in Parliament. To
their narrow minds, American opinion was contemptible and American
resistance unlawful, riotous, and treasonable. The correct way, in their
view, was to dispatch more troops to crush the "rebels"; and that very
act took the contest from the realm of opinion. As John Adams said:
"Facts are stubborn things." Opinions were unseen, but marching soldiers
were visible to the veriest street urchin. "Now," said Gouverneur
Morris, "the sheep, simple as they are, cannot be gulled as heretofore."
It was too late to talk about the excellence of the British
constitution. If any one is bewildered by the controversies of modern
historians as to why the crisis came at last, he can clarify his
understanding by reading again Edmund Burke's stately oration, _On
Conciliation with America_.


=References=

G.L. Beer, _British Colonial Policy_ (1754-63).

E. Channing, _History of the United States_, Vol. III.

R. Frothingham, _Rise of the Republic_.

G.E. Howard, _Preliminaries of the Revolution_ (American Nation Series).

J.K. Hosmer, _Samuel Adams_.

J.T. Morse, _Benjamin Franklin_.

M.C. Tyler, _Patrick Henry_.

J.A. Woodburn (editor), _The American Revolution_ (Selections from the
English work by Lecky).


=Questions=

1. Show how the character of George III made for trouble with the
colonies.

2. Explain why the party and parliamentary systems of England favored
the plans of George III.

3. How did the state of English finances affect English policy?

4. Enumerate five important measures of the English government affecting
the colonies between 1763 and 1765. Explain each in detail.

5. Describe American resistance to the Stamp Act. What was the outcome?

6. Show how England renewed her policy of regulation in 1767.

7. Summarize the events connected with American resistance.

8. With what measures did Great Britain retaliate?

9. Contrast "constitutional" with "natural" rights.

10. What solution did Burke offer? Why was it rejected?


=Research Topics=

=Powers Conferred on Revenue Officers by Writs of Assistance.=--See a
writ in Macdonald, _Source Book_, p. 109.

=The Acts of Parliament Respecting America.=--Macdonald, pp. 117-146.
Assign one to each student for report and comment.

=Source Studies on the Stamp Act.=--Hart, _American History Told by
Contemporaries_, Vol. II, pp. 394-412.

=Source Studies of the Townshend Acts.=--Hart, Vol. II, pp. 413-433.

=American Principles.=--Prepare a table of them from the Resolutions of
the Stamp Act Congress and the Massachusetts Circular. Macdonald, pp.
136-146.

=An English Historian's View of the Period.=--Green, _Short History of
England_, Chap. X.

=English Policy Not Injurious to America.=--Callender, _Economic
History_, pp. 85-121.

=A Review of English Policy.=--Woodrow Wilson, _History of the American
People_, Vol. II, pp. 129-170.

=The Opening of the Revolution.=--Elson, _History of the United States_,
pp. 220-235.




CHAPTER VI

THE AMERICAN REVOLUTION


RESISTANCE AND RETALIATION

=The Continental Congress.=--When the news of the "intolerable acts"
reached America, every one knew what strong medicine Parliament was
prepared to administer to all those who resisted its authority. The
cause of Massachusetts became the cause of all the colonies. Opposition
to British policy, hitherto local and spasmodic, now took on a national
character. To local committees and provincial conventions was added a
Continental Congress, appropriately called by Massachusetts on June 17,
1774, at the instigation of Samuel Adams. The response to the summons
was electric. By hurried and irregular methods delegates were elected
during the summer, and on September 5 the Congress duly assembled in
Carpenter's Hall in Philadelphia. Many of the greatest men in America
were there--George Washington and Patrick Henry from Virginia and John
and Samuel Adams from Massachusetts. Every shade of opinion was
represented. Some were impatient with mild devices; the majority favored
moderation.

The Congress drew up a declaration of American rights and stated in
clear and dignified language the grievances of the colonists. It
approved the resistance to British measures offered by Massachusetts and
promised the united support of all sections. It prepared an address to
King George and another to the people of England, disavowing the idea of
independence but firmly attacking the policies pursued by the British
government.

=The Non-Importation Agreement.=--The Congress was not content, however,
with professions of faith and with petitions. It took one revolutionary
step. It agreed to stop the importation of British goods into America,
and the enforcement of this agreement it placed in the hands of local
"committees of safety and inspection," to be elected by the qualified
voters. The significance of this action is obvious. Congress threw
itself athwart British law. It made a rule to bind American citizens and
to be carried into effect by American officers. It set up a state within
the British state and laid down a test of allegiance to the new order.
The colonists, who up to this moment had been wavering, had to choose
one authority or the other. They were for the enforcement of the
non-importation agreement or they were against it. They either bought
English goods or they did not. In the spirit of the toast--"May Britain
be wise and America be free"--the first Continental Congress adjourned
in October, having appointed the tenth of May following for the meeting
of a second Congress, should necessity require.

=Lord North's "Olive Branch."=--When the news of the action of the
American Congress reached England, Pitt and Burke warmly urged a repeal
of the obnoxious laws, but in vain. All they could wring from the prime
minister, Lord North, was a set of "conciliatory resolutions" proposing
to relieve from taxation any colony that would assume its share of
imperial defense and make provision for supporting the local officers of
the crown. This "olive branch" was accompanied by a resolution assuring
the king of support at all hazards in suppressing the rebellion and by
the restraining act of March 30, 1775, which in effect destroyed the
commerce of New England.

=Bloodshed at Lexington and Concord (April 19, 1775).=--Meanwhile the
British authorities in Massachusetts relaxed none of their efforts in
upholding British sovereignty. General Gage, hearing that military
stores had been collected at Concord, dispatched a small force to seize
them. By this act he precipitated the conflict he had sought to avoid.
At Lexington, on the road to Concord, occurred "the little thing" that
produced "the great event." An unexpected collision beyond the thought
or purpose of any man had transferred the contest from the forum to the
battle field.

=The Second Continental Congress.=--Though blood had been shed and war
was actually at hand, the second Continental Congress, which met at
Philadelphia in May, 1775, was not yet convinced that conciliation was
beyond human power. It petitioned the king to interpose on behalf of the
colonists in order that the empire might avoid the calamities of civil
war. On the last day of July, it made a temperate but firm answer to
Lord North's offer of conciliation, stating that the proposal was
unsatisfactory because it did not renounce the right to tax or repeal
the offensive acts of Parliament.

=Force, the British Answer.=--Just as the representatives of America
were about to present the last petition of Congress to the king on
August 23, 1775, George III issued a proclamation of rebellion. This
announcement declared that the colonists, "misled by dangerous and
ill-designing men," were in a state of insurrection; it called on the
civil and military powers to bring "the traitors to justice"; and it
threatened with "condign punishment the authors, perpetrators, and
abettors of such traitorous designs." It closed with the usual prayer:
"God, save the king." Later in the year, Parliament passed a sweeping
act destroying all trade and intercourse with America. Congress was
silent at last. Force was also America's answer.


AMERICAN INDEPENDENCE

=Drifting into War.=--Although the Congress had not given up all hope of
reconciliation in the spring and summer of 1775, it had firmly resolved
to defend American rights by arms if necessary. It transformed the
militiamen who had assembled near Boston, after the battle of Lexington,
into a Continental army and selected Washington as commander-in-chief.
It assumed the powers of a government and prepared to raise money, wage
war, and carry on diplomatic relations with foreign countries.

[Illustration: _From an old print_

SPIRIT OF 1776]

Events followed thick and fast. On June 17, the American militia, by
the stubborn defense of Bunker Hill, showed that it could make British
regulars pay dearly for all they got. On July 3, Washington took command
of the army at Cambridge. In January, 1776, after bitter disappointments
in drumming up recruits for its army in England, Scotland, and Ireland,
the British government concluded a treaty with the Landgrave of
Hesse-Cassel in Germany contracting, at a handsome figure, for thousands
of soldiers and many pieces of cannon. This was the crowning insult to
America. Such was the view of all friends of the colonies on both sides
of the water. Such was, long afterward, the judgment of the conservative
historian Lecky: "The conduct of England in hiring German mercenaries to
subdue the essentially English population beyond the Atlantic made
reconciliation hopeless and independence inevitable." The news of this
wretched transaction in German soldiers had hardly reached America
before there ran all down the coast the thrilling story that Washington
had taken Boston, on March 17, 1776, compelling Lord Howe to sail with
his entire army for Halifax.

=The Growth of Public Sentiment in Favor of Independence.=--Events were
bearing the Americans away from their old position under the British
constitution toward a final separation. Slowly and against their
desires, prudent and honorable men, who cherished the ties that united
them to the old order and dreaded with genuine horror all thought of
revolution, were drawn into the path that led to the great decision. In
all parts of the country and among all classes, the question of the hour
was being debated. "American independence," as the historian Bancroft
says, "was not an act of sudden passion nor the work of one man or one
assembly. It had been discussed in every part of the country by farmers
and merchants, by mechanics and planters, by the fishermen along the
coast and the backwoodsmen of the West; in town meetings and from the
pulpit; at social gatherings and around the camp fires; in county
conventions and conferences or committees; in colonial congresses and
assemblies."

[Illustration: _From an old print_

THOMAS PAINE]

=Paine's "Commonsense."=--In the midst of this ferment of American
opinion, a bold and eloquent pamphleteer broke in upon the hesitating
public with a program for absolute independence, without fears and
without apologies. In the early days of 1776, Thomas Paine issued the
first of his famous tracts, "Commonsense," a passionate attack upon the
British monarchy and an equally passionate plea for American liberty.
Casting aside the language of petition with which Americans had hitherto
addressed George III, Paine went to the other extreme and assailed him
with many a violent epithet. He condemned monarchy itself as a system
which had laid the world "in blood and ashes." Instead of praising the
British constitution under which colonists had been claiming their
rights, he brushed it aside as ridiculous, protesting that it was "owing
to the constitution of the people, not to the constitution of the
government, that the Crown is not as oppressive in England as in
Turkey."

Having thus summarily swept away the grounds of allegiance to the old
order, Paine proceeded relentlessly to an argument for immediate
separation from Great Britain. There was nothing in the sphere of
practical interest, he insisted, which should bind the colonies to the
mother country. Allegiance to her had been responsible for the many wars
in which they had been involved. Reasons of trade were not less weighty
in behalf of independence. "Our corn will fetch its price in any market
in Europe and our imported goods must be paid for, buy them where we
will." As to matters of government, "it is not in the power of Britain
to do this continent justice; the business of it will soon be too
weighty and intricate to be managed with any tolerable degree of
convenience by a power so distant from us and so very ignorant of us."

There is accordingly no alternative to independence for America.
"Everything that is right or natural pleads for separation. The blood of
the slain, the weeping voice of nature cries ''tis time to part.' ...
Arms, the last resort, must decide the contest; the appeal was the
choice of the king and the continent hath accepted the challenge.... The
sun never shone on a cause of greater worth. 'Tis not the affair of a
city, a county, a province or a kingdom, but of a continent.... 'Tis not
the concern of a day, a year or an age; posterity is involved in the
contest and will be more or less affected to the end of time by the
proceedings now. Now is the seed-time of Continental union, faith, and
honor.... O! ye that love mankind! Ye that dare oppose not only the
tyranny, but the tyrant, stand forth.... Let names of Whig and Tory be
extinct. Let none other be heard among us than those of a good citizen,
an open and resolute friend, and a virtuous supporter of the rights of
mankind and of the free and independent states of America." As more than
100,000 copies were scattered broadcast over the country, patriots
exclaimed with Washington: "Sound doctrine and unanswerable reason!"

=The Drift of Events toward Independence.=--Official support for the
idea of independence began to come from many quarters. On the tenth of
February, 1776, Gadsden, in the provincial convention of South Carolina,
advocated a new constitution for the colony and absolute independence
for all America. The convention balked at the latter but went half way
by abolishing the system of royal administration and establishing a
complete plan of self-government. A month later, on April 12, the
neighboring state of North Carolina uttered the daring phrase from which
others shrank. It empowered its representatives in the Congress to
concur with the delegates of the other colonies in declaring
independence. Rhode Island, Massachusetts, and Virginia quickly
responded to the challenge. The convention of the Old Dominion, on May
15, instructed its delegates at Philadelphia to propose the independence
of the United Colonies and to give the assent of Virginia to the act of
separation. When the resolution was carried the British flag on the
state house was lowered for all time.

Meanwhile the Continental Congress was alive to the course of events
outside. The subject of independence was constantly being raised. "Are
we rebels?" exclaimed Wyeth of Virginia during a debate in February.
"No: we must declare ourselves a free people." Others hesitated and
spoke of waiting for the arrival of commissioners of conciliation. "Is
not America already independent?" asked Samuel Adams a few weeks later.
"Why not then declare it?" Still there was uncertainty and delegates
avoided the direct word. A few more weeks elapsed. At last, on May 10,
Congress declared that the authority of the British crown in America
must be suppressed and advised the colonies to set up governments of
their own.

[Illustration: _From an old print_

THOMAS JEFFERSON READING HIS DRAFT OF THE DECLARATION OF
INDEPENDENCE TO THE COMMITTEE OF CONGRESS]

=Independence Declared.=--The way was fully prepared, therefore, when,
on June 7, the Virginia delegation in the Congress moved that "these
united colonies are and of right ought to be free and independent
states." A committee was immediately appointed to draft a formal
document setting forth the reasons for the act, and on July 2 all the
states save New York went on record in favor of severing their political
connection with Great Britain. Two days later, July 4, Jefferson's draft
of the Declaration of Independence, changed in some slight particulars,
was adopted. The old bell in Independence Hall, as it is now known, rang
out the glad tidings; couriers swiftly carried the news to the uttermost
hamlet and farm. A new nation announced its will to have a place among
the powers of the world.

To some documents is given immortality. The Declaration of Independence
is one of them. American patriotism is forever associated with it; but
patriotism alone does not make it immortal. Neither does the vigor of
its language or the severity of its indictment give it a secure place in
the records of time. The secret of its greatness lies in the simple fact
that it is one of the memorable landmarks in the history of a political
ideal which for three centuries has been taking form and spreading
throughout the earth, challenging kings and potentates, shaking down
thrones and aristocracies, breaking the armies of irresponsible power on
battle fields as far apart as Marston Moor and Chateau-Thierry. That
ideal, now so familiar, then so novel, is summed up in the simple
sentence: "Governments derive their just powers from the consent of the
governed."

Written in a "decent respect for the opinions of mankind," to set forth
the causes which impelled the American colonists to separate from
Britain, the Declaration contained a long list of "abuses and
usurpations" which had induced them to throw off the government of King
George. That section of the Declaration has passed into "ancient"
history and is seldom read. It is the part laying down a new basis for
government and giving a new dignity to the common man that has become a
household phrase in the Old World as in the New.

In the more enduring passages there are four fundamental ideas which,
from the standpoint of the old system of government, were the essence of
revolution: (1) all men are created equal and are endowed by their
Creator with certain unalienable rights including life, liberty, and the
pursuit of happiness; (2) the purpose of government is to secure these
rights; (3) governments derive their just powers from the consent of the
governed; (4) whenever any form of government becomes destructive of
these ends it is the right of the people to alter or abolish it and
institute new government, laying its foundations on such principles and
organizing its powers in such form as to them shall seem most likely to
effect their safety and happiness. Here was the prelude to the historic
drama of democracy--a challenge to every form of government and every
privilege not founded on popular assent.


THE ESTABLISHMENT OF GOVERNMENT AND THE NEW ALLEGIANCE

=The Committees of Correspondence.=--As soon as debate had passed into
armed resistance, the patriots found it necessary to consolidate their
forces by organizing civil government. This was readily effected, for
the means were at hand in town meetings, provincial legislatures, and
committees of correspondence. The working tools of the Revolution were
in fact the committees of correspondence--small, local, unofficial
groups of patriots formed to exchange views and create public sentiment.
As early as November, 1772, such a committee had been created in Boston
under the leadership of Samuel Adams. It held regular meetings, sent
emissaries to neighboring towns, and carried on a campaign of education
in the doctrines of liberty.

[Illustration: THE COLONIES OF NORTH AMERICA AT THE TIME OF THE
DECLARATION OF INDEPENDENCE]

Upon local organizations similar in character to the Boston committee
were built county committees and then the larger colonial committees,
congresses, and conventions, all unofficial and representing the
revolutionary elements. Ordinarily the provincial convention was merely
the old legislative assembly freed from all royalist sympathizers and
controlled by patriots. Finally, upon these colonial assemblies was
built the Continental Congress, the precursor of union under the
Articles of Confederation and ultimately under the Constitution of the
United States. This was the revolutionary government set up within the
British empire in America.

=State Constitutions Framed.=--With the rise of these new assemblies of
the people, the old colonial governments broke down. From the royal
provinces the governor, the judges, and the high officers fled in haste,
and it became necessary to substitute patriot authorities. The appeal to
the colonies advising them to adopt a new form of government for
themselves, issued by the Congress in May, 1776, was quickly acted upon.
Before the expiration of a year, Virginia, New Jersey, Pennsylvania,
Delaware, Maryland, Georgia, and New York had drafted new constitutions
as states, not as colonies uncertain of their destinies. Connecticut and
Rhode Island, holding that their ancient charters were equal to their
needs, merely renounced their allegiance to the king and went on as
before so far as the form of government was concerned. South Carolina,
which had drafted a temporary plan early in 1776, drew up a new and more
complete constitution in 1778. Two years later Massachusetts with much
deliberation put into force its fundamental law, which in most of its
essential features remains unchanged to-day.

The new state constitutions in their broad outlines followed colonial
models. For the royal governor was substituted a governor or president
chosen usually by the legislature; but in two instances, New York and
Massachusetts, by popular vote. For the provincial council there was
substituted, except in Georgia, a senate; while the lower house, or
assembly, was continued virtually without change. The old property
restriction on the suffrage, though lowered slightly in some states, was
continued in full force to the great discontent of the mechanics thus
deprived of the ballot. The special qualifications, laid down in several
constitutions, for governors, senators, and representatives, indicated
that the revolutionary leaders were not prepared for any radical
experiments in democracy. The protests of a few women, like Mrs. John
Adams of Massachusetts and Mrs. Henry Corbin of Virginia, against a
government which excluded them from political rights were treated as
mild curiosities of no significance, although in New Jersey women were
allowed to vote for many years on the same terms as men.

By the new state constitutions the signs and symbols of royal power, of
authority derived from any source save "the people," were swept aside
and republican governments on an imposing scale presented for the first
time to the modern world. Copies of these remarkable documents prepared
by plain citizens were translated into French and widely circulated in
Europe. There they were destined to serve as a guide and inspiration to
a generation of constitution-makers whose mission it was to begin the
democratic revolution in the Old World.

=The Articles of Confederation.=--The formation of state constitutions
was an easy task for the revolutionary leaders. They had only to build
on foundations already laid. The establishment of a national system of
government was another matter. There had always been, it must be
remembered, a system of central control over the colonies, but Americans
had had little experience in its operation. When the supervision of the
crown of Great Britain was suddenly broken, the patriot leaders,
accustomed merely to provincial statesmanship, were poorly trained for
action on a national stage.

Many forces worked against those who, like Franklin, had a vision of
national destiny. There were differences in economic interest--commerce
and industry in the North and the planting system of the South. There
were contests over the apportionment of taxes and the quotas of troops
for common defense. To these practical difficulties were added local
pride, the vested rights of state and village politicians in their
provincial dignity, and the scarcity of men with a large outlook upon
the common enterprise.

Nevertheless, necessity compelled them to consider some sort of
federation. The second Continental Congress had hardly opened its work
before the most sagacious leaders began to urge the desirability of a
permanent connection. As early as July, 1775, Congress resolved to go
into a committee of the whole on the state of the union, and Franklin,
undaunted by the fate of his Albany plan of twenty years before, again
presented a draft of a constitution. Long and desultory debates followed
and it was not until late in 1777 that Congress presented to the states
the Articles of Confederation. Provincial jealousies delayed
ratification, and it was the spring of 1781, a few months before the
surrender of Cornwallis at Yorktown, when Maryland, the last of the
states, approved the Articles. This plan of union, though it was all
that could be wrung from the reluctant states, provided for neither a
chief executive nor a system of federal courts. It created simply a
Congress of delegates in which each state had an equal voice and gave it
the right to call upon the state legislatures for the sinews of
government--money and soldiers.

=The Application of Tests of Allegiance.=--As the successive steps were
taken in the direction of independent government, the patriots devised
and applied tests designed to discover who were for and who were against
the new nation in the process of making. When the first Continental
Congress agreed not to allow the importation of British goods, it
provided for the creation of local committees to enforce the rules. Such
agencies were duly formed by the choice of men favoring the scheme, all
opponents being excluded from the elections. Before these bodies those
who persisted in buying British goods were summoned and warned or
punished according to circumstances. As soon as the new state
constitutions were put into effect, local committees set to work in the
same way to ferret out all who were not outspoken in their support of
the new order of things.

[Illustration: MOBBING THE TORIES]

These patriot agencies, bearing different names in different sections,
were sometimes ruthless in their methods. They called upon all men to
sign the test of loyalty, frequently known as the "association test."
Those who refused were promptly branded as outlaws, while some of the
more dangerous were thrown into jail. The prison camp in Connecticut at
one time held the former governor of New Jersey and the mayor of New
York. Thousands were black-listed and subjected to espionage. The
black-list of Pennsylvania contained the names of nearly five hundred
persons of prominence who were under suspicion. Loyalists or Tories who
were bold enough to speak and write against the Revolution were
suppressed and their pamphlets burned. In many places, particularly in
the North, the property of the loyalists was confiscated and the
proceeds applied to the cause of the Revolution.

The work of the official agencies for suppression of opposition was
sometimes supplemented by mob violence. A few Tories were hanged without
trial, and others were tarred and feathered. One was placed upon a cake
of ice and held there "until his loyalty to King George might cool."
Whole families were driven out of their homes to find their way as best
they could within the British lines or into Canada, where the British
government gave them lands. Such excesses were deplored by Washington,
but they were defended on the ground that in effect a civil war, as well
as a war for independence, was being waged.

=The Patriots and Tories.=--Thus, by one process or another, those who
were to be citizens of the new republic were separated from those who
preferred to be subjects of King George. Just what proportion of the
Americans favored independence and what share remained loyal to the
British monarchy there is no way of knowing. The question of revolution
was not submitted to popular vote, and on the point of numbers we have
conflicting evidence. On the patriot side, there is the testimony of a
careful and informed observer, John Adams, who asserted that two-thirds
of the people were for the American cause and not more than one-third
opposed the Revolution at all stages.

On behalf of the loyalists, or Tories as they were popularly known,
extravagant claims were made. Joseph Galloway, who had been a member of
the first Continental Congress and had fled to England when he saw its
temper, testified before a committee of Parliament in 1779 that not
one-fifth of the American people supported the insurrection and that
"many more than four-fifths of the people prefer a union with Great
Britain upon constitutional principles to independence." At the same
time General Robertson, who had lived in America twenty-four years,
declared that "more than two-thirds of the people would prefer the
king's government to the Congress' tyranny." In an address to the king
in that year a committee of American loyalists asserted that "the number
of Americans in his Majesty's army exceeded the number of troops
enlisted by Congress to oppose them."

=The Character of the Loyalists.=--When General Howe evacuated Boston,
more than a thousand people fled with him. This great company, according
to a careful historian, "formed the aristocracy of the province by
virtue of their official rank; of their dignified callings and
professions; of their hereditary wealth and of their culture." The act
of banishment passed by Massachusetts in 1778, listing over 300 Tories,
"reads like the social register of the oldest and noblest families of
New England," more than one out of five being graduates of Harvard
College. The same was true of New York and Philadelphia; namely, that
the leading loyalists were prominent officials of the old order,
clergymen and wealthy merchants. With passion the loyalists fought
against the inevitable or with anguish of heart they left as refugees
for a life of uncertainty in Canada or the mother country.

=Tories Assail the Patriots.=--The Tories who remained in America joined
the British army by the thousands or in other ways aided the royal
cause. Those who were skillful with the pen assailed the patriots in
editorials, rhymes, satires, and political catechisms. They declared
that the members of Congress were "obscure, pettifogging attorneys,
bankrupt shopkeepers, outlawed smugglers, etc." The people and their
leaders they characterized as "wretched banditti ... the refuse and
dregs of mankind." The generals in the army they sneered at as "men of
rank and honor nearly on a par with those of the Congress."

=Patriot Writers Arouse the National Spirit.=--Stung by Tory taunts,
patriot writers devoted themselves to creating and sustaining a public
opinion favorable to the American cause. Moreover, they had to combat
the depression that grew out of the misfortunes in the early days of the
war. A terrible disaster befell Generals Arnold and Montgomery in the
winter of 1775 as they attempted to bring Canada into the revolution--a
disaster that cost 5000 men; repeated calamities harassed Washington in
1776 as he was defeated on Long Island, driven out of New York City, and
beaten at Harlem Heights and White Plains. These reverses were almost
too great for the stoutest patriots.

Pamphleteers, preachers, and publicists rose, however, to meet the needs
of the hour. John Witherspoon, provost of the College of New Jersey,
forsook the classroom for the field of political controversy. The poet,
Philip Freneau, flung taunts of cowardice at the Tories and celebrated
the spirit of liberty in many a stirring poem. Songs, ballads, plays,
and satires flowed from the press in an unending stream. Fast days,
battle anniversaries, celebrations of important steps taken by Congress
afforded to patriotic clergymen abundant opportunities for sermons.
"Does Mr. Wiberd preach against oppression?" anxiously inquired John
Adams in a letter to his wife. The answer was decisive. "The clergy of
every denomination, not excepting the Episcopalian, thunder and lighten
every Sabbath. They pray for Boston and Massachusetts. They thank God
most explicitly and fervently for our remarkable successes. They pray
for the American army."

Thomas Paine never let his pen rest. He had been with the forces of
Washington when they retreated from Fort Lee and were harried from New
Jersey into Pennsylvania. He knew the effect of such reverses on the
army as well as on the public. In December, 1776, he made a second great
appeal to his countrymen in his pamphlet, "The Crisis," the first part
of which he had written while defeat and gloom were all about him. This
tract was a cry for continued support of the Revolution. "These are the
times that try men's souls," he opened. "The summer soldier and the
sunshine patriot will, in this crisis, shrink from the service of his
country; but he that stands it now deserves the love and thanks of men
and women." Paine laid his lash fiercely on the Tories, branding every
one as a coward grounded in "servile, slavish, self-interested fear." He
deplored the inadequacy of the militia and called for a real army. He
refuted the charge that the retreat through New Jersey was a disaster
and he promised victory soon. "By perseverance and fortitude," he
concluded, "we have the prospect of a glorious issue; by cowardice and
submission the sad choice of a variety of evils--a ravaged country, a
depopulated city, habitations without safety and slavery without
hope.... Look on this picture and weep over it." His ringing call to
arms was followed by another and another until the long contest was
over.


MILITARY AFFAIRS

=The Two Phases of the War.=--The war which opened with the battle of
Lexington, on April 19, 1775, and closed with the surrender of
Cornwallis at Yorktown on October 19, 1781, passed through two distinct
phases--the first lasting until the treaty of alliance with France, in
1778, and the second until the end of the struggle. During the first
phase, the war was confined mainly to the North. The outstanding
features of the contest were the evacuation of Boston by the British,
the expulsion of American forces from New York and their retreat through
New Jersey, the battle of Trenton, the seizure of Philadelphia by the
British (September, 1777), the invasion of New York by Burgoyne and his
capture at Saratoga in October, 1777, and the encampment of American
forces at Valley Forge for the terrible winter of 1777-78.

The final phase of the war, opening with the treaty of alliance with
France on February 6, 1778, was confined mainly to the Middle states,
the West, and the South. In the first sphere of action the chief events
were the withdrawal of the British from Philadelphia, the battle of
Monmouth, and the inclosure of the British in New York by deploying
American forces from Morristown, New Jersey, up to West Point. In the
West, George Rogers Clark, by his famous march into the Illinois
country, secured Kaskaskia and Vincennes and laid a firm grip on the
country between the Ohio and the Great Lakes. In the South, the second
period opened with successes for the British. They captured Savannah,
conquered Georgia, and restored the royal governor. In 1780 they seized
Charleston, administered a crushing defeat to the American forces under
Gates at Camden, and overran South Carolina, though meeting reverses at
Cowpens and King's Mountain. Then came the closing scenes. Cornwallis
began the last of his operations. He pursued General Greene far into
North Carolina, clashed with him at Guilford Court House, retired to the
coast, took charge of British forces engaged in plundering Virginia, and
fortified Yorktown, where he was penned up by the French fleet from the
sea and the combined French and American forces on land.

=The Geographical Aspects of the War.=--For the British the theater of
the war offered many problems. From first to last it extended from
Massachusetts to Georgia, a distance of almost a thousand miles. It was
nearly three thousand miles from the main base of supplies and, though
the British navy kept the channel open, transports were constantly
falling prey to daring privateers and fleet American war vessels. The
sea, on the other hand, offered an easy means of transportation between
points along the coast and gave ready access to the American centers of
wealth and population. Of this the British made good use. Though early
forced to give up Boston, they seized New York and kept it until the end
of the war; they took Philadelphia and retained it until threatened by
the approach of the French fleet; and they captured and held both
Savannah and Charleston. Wars, however, are seldom won by the conquest
of cities.

Particularly was this true in the case of the Revolution. Only a small
portion of the American people lived in towns. Countrymen back from the
coast were in no way dependent upon them for a livelihood. They lived on
the produce of the soil, not upon the profits of trade. This very fact
gave strength to them in the contest. Whenever the British ventured far
from the ports of entry, they encountered reverses. Burgoyne was forced
to surrender at Saratoga because he was surrounded and cut off from his
base of supplies. As soon as the British got away from Charleston, they
were harassed and worried by the guerrilla warriors of Marion, Sumter,
and Pickens. Cornwallis could technically defeat Greene at Guilford far
in the interior; but he could not hold the inland region he had invaded.
Sustained by their own labor, possessing the interior to which their
armies could readily retreat, supplied mainly from native resources, the
Americans could not be hemmed in, penned up, and destroyed at one fell
blow.

=The Sea Power.=--The British made good use of their fleet in cutting
off American trade, but control of the sea did not seriously affect the
United States. As an agricultural country, the ruin of its commerce was
not such a vital matter. All the materials for a comfortable though
somewhat rude life were right at hand. It made little difference to a
nation fighting for existence, if silks, fine linens, and chinaware were
cut off. This was an evil to which submission was necessary.

Nor did the brilliant exploits of John Paul Jones and Captain John Barry
materially change the situation. They demonstrated the skill of American
seamen and their courage as fighting men. They raised the rates of
British marine insurance, but they did not dethrone the mistress of the
seas. Less spectacular, and more distinctive, were the deeds of the
hundreds of privateers and minor captains who overhauled British supply
ships and kept British merchantmen in constant anxiety. Not until the
French fleet was thrown into the scale, were the British compelled to
reckon seriously with the enemy on the sea and make plans based upon the
possibilities of a maritime disaster.

=Commanding Officers.=--On the score of military leadership it is
difficult to compare the contending forces in the revolutionary contest.
There is no doubt that all the British commanders were men of experience
in the art of warfare. Sir William Howe had served in America during the
French War and was accounted an excellent officer, a strict
disciplinarian, and a gallant gentleman. Nevertheless he loved ease,
society, and good living, and his expulsion from Boston, his failure to
overwhelm Washington by sallies from his comfortable bases at New York
and Philadelphia, destroyed every shred of his military reputation. John
Burgoyne, to whom was given the task of penetrating New York from
Canada, had likewise seen service in the French War both in America and
Europe. He had, however, a touch of the theatrical in his nature and
after the collapse of his plans and the surrender of his army in 1777,
he devoted his time mainly to light literature. Sir Henry Clinton, who
directed the movement which ended in the capture of Charleston in 1780,
had "learned his trade on the continent," and was regarded as a man of
discretion and understanding in military matters. Lord Cornwallis, whose
achievements at Camden and Guilford were blotted out by his surrender at
Yorktown, had seen service in the Seven Years' War and had undoubted
talents which he afterward displayed with great credit to himself in
India. Though none of them, perhaps, were men of first-rate ability,
they all had training and experience to guide them.

[Illustration: GEORGE WASHINGTON]

The Americans had a host in Washington himself. He had long been
interested in military strategy and had tested his coolness under fire
during the first clashes with the French nearly twenty years before. He
had no doubts about the justice of his cause, such as plagued some of
the British generals. He was a stern but reasonable disciplinarian. He
was reserved and patient, little given to exaltation at success or
depression at reverses. In the dark hour of the Revolution, "what held
the patriot forces together?" asks Beveridge in his _Life of John
Marshall_. Then he answers: "George Washington and he alone. Had he
died or been seriously disabled, the Revolution would have ended....
Washington was the soul of the American cause. Washington was the
government. Washington was the Revolution." The weakness of Congress in
furnishing men and supplies, the indolence of civilians, who lived at
ease while the army starved, the intrigues of army officers against him
such as the "Conway cabal," the cowardice of Lee at Monmouth, even the
treason of Benedict Arnold, while they stirred deep emotions in his
breast and aroused him to make passionate pleas to his countrymen, did
not shake his iron will or his firm determination to see the war through
to the bitter end. The weight of Washington's moral force was
immeasurable.

Of the generals who served under him, none can really be said to have
been experienced military men when the war opened. Benedict Arnold, the
unhappy traitor but brave and daring soldier, was a druggist, book
seller, and ship owner at New Haven when the news of Lexington called
him to battle. Horatio Gates was looked upon as a "seasoned soldier"
because he had entered the British army as a youth, had been wounded at
Braddock's memorable defeat, and had served with credit during the Seven
Years' War; but he was the most conspicuous failure of the Revolution.
The triumph over Burgoyne was the work of other men; and his crushing
defeat at Camden put an end to his military pretensions. Nathanael
Greene was a Rhode Island farmer and smith without military experience
who, when convinced that war was coming, read Caesar's _Commentaries_ and
took up the sword. Francis Marion was a shy and modest planter of South
Carolina whose sole passage at arms had been a brief but desperate brush
with the Indians ten or twelve years earlier. Daniel Morgan, one of the
heroes of Cowpens, had been a teamster with Braddock's army and had seen
some fighting during the French and Indian War, but his military
knowledge, from the point of view of a trained British officer, was
negligible. John Sullivan was a successful lawyer at Durham, New
Hampshire, and a major in the local militia when duty summoned him to
lay down his briefs and take up the sword. Anthony Wayne was a
Pennsylvania farmer and land surveyor who, on hearing the clash of arms,
read a few books on war, raised a regiment, and offered himself for
service. Such is the story of the chief American military leaders, and
it is typical of them all. Some had seen fighting with the French and
Indians, but none of them had seen warfare on a large scale with regular
troops commanded according to the strategy evolved in European
experience. Courage, native ability, quickness of mind, and knowledge of
the country they had in abundance, and in battles such as were fought
during the Revolution all those qualities counted heavily in the
balance.

=Foreign Officers in American Service.=--To native genius was added
military talent from beyond the seas. Baron Steuben, well schooled in
the iron regime of Frederick the Great, came over from Prussia, joined
Washington at Valley Forge, and day after day drilled and manoeuvered the
men, laughing and cursing as he turned raw countrymen into regular
soldiers. From France came young Lafayette and the stern De Kalb, from
Poland came Pulaski and Kosciusko;--all acquainted with the arts of war
as waged in Europe and fitted for leadership as well as teaching.
Lafayette came early, in 1776, in a ship of his own, accompanied by
several officers of wide experience, and remained loyally throughout the
war sharing the hardships of American army life. Pulaski fell at the
siege of Savannah and De Kalb at Camden. Kosciusko survived the American
war to defend in vain the independence of his native land. To these
distinguished foreigners, who freely threw in their lot with American
revolutionary fortunes, was due much of that spirit and discipline which
fitted raw recruits and temperamental militiamen to cope with a military
power of the first rank.

=The Soldiers.=--As far as the British soldiers were concerned their
annals are short and simple. The regulars from the standing army who
were sent over at the opening of the contest, the recruits drummed up
by special efforts at home, and the thousands of Hessians bought
outright by King George presented few problems of management to the
British officers. These common soldiers were far away from home and
enlisted for the war. Nearly all of them were well disciplined and many
of them experienced in actual campaigns. The armies of King George
fought bravely, as the records of Bunker Hill, Brandywine, and Monmouth
demonstrate. Many a man and subordinate officer and, for that matter,
some of the high officers expressed a reluctance at fighting against
their own kin; but they obeyed orders.

The Americans, on the other hand, while they fought with grim
determination, as men fighting for their homes, were lacking in
discipline and in the experience of regular troops. When the war broke
in upon them, there were no common preparations for it. There was no
continental army; there were only local bands of militiamen, many of
them experienced in fighting but few of them "regulars" in the military
sense. Moreover they were volunteers serving for a short time,
unaccustomed to severe discipline, and impatient at the restraints
imposed on them by long and arduous campaigns. They were continually
leaving the service just at the most critical moments. "The militia,"
lamented Washington, "come in, you cannot tell how; go, you cannot tell
where; consume your provisions; exhaust your stores; and leave you at
last at a critical moment."

Again and again Washington begged Congress to provide for an army of
regulars enlisted for the war, thoroughly trained and paid according to
some definite plan. At last he was able to overcome, in part at least,
the chronic fear of civilians in Congress and to wring from that
reluctant body an agreement to grant half pay to all officers and a
bonus to all privates who served until the end of the war. Even this
scheme, which Washington regarded as far short of justice to the
soldiers, did not produce quick results. It was near the close of the
conflict before he had an army of well-disciplined veterans capable of
meeting British regulars on equal terms.

Though there were times when militiamen and frontiersmen did valiant and
effective work, it is due to historical accuracy to deny the
time-honored tradition that a few minutemen overwhelmed more numerous
forces of regulars in a seven years' war for independence. They did
nothing of the sort. For the victories of Bennington, Trenton, Saratoga,
and Yorktown there were the defeats of Bunker Hill, Long Island, White
Plains, Germantown, and Camden. Not once did an army of militiamen
overcome an equal number of British regulars in an open trial by battle.
"To bring men to be well acquainted with the duties of a soldier," wrote
Washington, "requires time.... To expect the same service from raw and
undisciplined recruits as from veteran soldiers is to expect what never
did and perhaps never will happen."

=How the War Was Won.=--Then how did the American army win the war? For
one thing there were delays and blunders on the part of the British
generals who, in 1775 and 1776, dallied in Boston and New York with
large bodies of regular troops when they might have been dealing
paralyzing blows at the scattered bands that constituted the American
army. "Nothing but the supineness or folly of the enemy could have saved
us," solemnly averred Washington in 1780. Still it is fair to say that
this apparent supineness was not all due to the British generals. The
ministers behind them believed that a large part of the colonists were
loyal and that compromise would be promoted by inaction rather than by a
war vigorously prosecuted. Victory by masterly inactivity was obviously
better than conquest, and the slighter the wounds the quicker the
healing. Later in the conflict when the seasoned forces of France were
thrown into the scale, the Americans themselves had learned many things
about the practical conduct of campaigns. All along, the British were
embarrassed by the problem of supplies. Their troops could not forage
with the skill of militiamen, as they were in unfamiliar territory. The
long oversea voyages were uncertain at best and doubly so when the
warships of France joined the American privateers in preying on supply
boats.

The British were in fact battered and worn down by a guerrilla war and
outdone on two important occasions by superior forces--at Saratoga and
Yorktown. Stern facts convinced them finally that an immense army, which
could be raised only by a supreme effort, would be necessary to subdue
the colonies if that hazardous enterprise could be accomplished at all.
They learned also that America would then be alienated, fretful, and the
scene of endless uprisings calling for an army of occupation. That was a
price which staggered even Lord North and George III. Moreover, there
were forces of opposition at home with which they had to reckon.

=Women and the War.=--At no time were the women of America indifferent
to the struggle for independence. When it was confined to the realm of
opinion they did their part in creating public sentiment. Mrs. Elizabeth
Timothee, for example, founded in Charleston, in 1773, a newspaper to
espouse the cause of the province. Far to the north the sister of James
Otis, Mrs. Mercy Warren, early begged her countrymen to rest their case
upon their natural rights, and in influential circles she urged the
leaders to stand fast by their principles. While John Adams was tossing
about with uncertainty at the Continental Congress, his wife was writing
letters to him declaring her faith in "independency."

When the war came down upon the country, women helped in every field. In
sustaining public sentiment they were active. Mrs. Warren with a
tireless pen combatted loyalist propaganda in many a drama and satire.
Almost every revolutionary leader had a wife or daughter who rendered
service in the "second line of defense." Mrs. Washington managed the
plantation while the General was at the front and went north to face the
rigors of the awful winter at Valley Forge--an inspiration to her
husband and his men. The daughter of Benjamin Franklin, Mrs. Sarah
Bache, while her father was pleading the American cause in France, set
the women of Pennsylvania to work sewing and collecting supplies. Even
near the firing line women were to be found, aiding the wounded, hauling
powder to the front, and carrying dispatches at the peril of their
lives.

In the economic sphere, the work of women was invaluable. They harvested
crops without enjoying the picturesque title of "farmerettes" and they
canned and preserved for the wounded and the prisoners of war. Of their
labor in spinning and weaving it is recorded: "Immediately on being cut
off from the use of English manufactures, the women engaged within their
own families in manufacturing various kinds of cloth for domestic use.
They thus kept their households decently clad and the surplus of their
labors they sold to such as chose to buy rather than make for
themselves. In this way the female part of families by their industry
and strict economy frequently supported the whole domestic circle,
evincing the strength of their attachment and the value of their
service."

For their war work, women were commended by high authorities on more
than one occasion. They were given medals and public testimonials even
as in our own day. Washington thanked them for their labors and paid
tribute to them for the inspiration and material aid which they had
given to the cause of independence.


THE FINANCES OF THE REVOLUTION

When the Revolution opened, there were thirteen little treasuries in
America but no common treasury, and from first to last the Congress was
in the position of a beggar rather than a sovereign. Having no authority
to lay and collect taxes directly and knowing the hatred of the
provincials for taxation, it resorted mainly to loans and paper money to
finance the war. "Do you think," boldly inquired one of the delegates,
"that I will consent to load my constituents with taxes when we can send
to the printer and get a wagon load of money, one quire of which will
pay for the whole?"

=Paper Money and Loans.=--Acting on this curious but appealing political
economy, Congress issued in June, 1776, two million dollars in bills of
credit to be redeemed by the states on the basis of their respective
populations. Other issues followed in quick succession. In all about
$241,000,000 of continental paper was printed, to which the several
states added nearly $210,000,000 of their own notes. Then came
interest-bearing bonds in ever increasing quantities. Several millions
were also borrowed from France and small sums from Holland and Spain. In
desperation a national lottery was held, producing meager results. The
property of Tories was confiscated and sold, bringing in about
$16,000,000. Begging letters were sent to the states asking them to
raise revenues for the continental treasury, but the states, burdened
with their own affairs, gave little heed.

=Inflation and Depreciation.=--As paper money flowed from the press, it
rapidly declined in purchasing power until in 1779 a dollar was worth
only two or three cents in gold or silver. Attempts were made by
Congress and the states to compel people to accept the notes at face
value; but these were like attempts to make water flow uphill.
Speculators collected at once to fatten on the calamities of the
republic. Fortunes were made and lost gambling on the prices of public
securities while the patriot army, half clothed, was freezing at Valley
Forge. "Speculation, peculation, engrossing, forestalling," exclaimed
Washington, "afford too many melancholy proofs of the decay of public
virtue. Nothing, I am convinced, but the depreciation of our currency
... aided by stock jobbing and party dissensions has fed the hopes of
the enemy."

=The Patriot Financiers.=--To the efforts of Congress in financing the
war were added the labors of private citizens. Hayn Solomon, a merchant
of Philadelphia, supplied members of Congress, including Madison,
Jefferson, and Monroe, and army officers, like Lee and Steuben, with
money for their daily needs. All together he contributed the huge sum of
half a million dollars to the American cause and died broken in purse,
if not in spirit, a British prisoner of war. Another Philadelphia
merchant, Robert Morris, won for himself the name of the "patriot
financier" because he labored night and day to find the money to meet
the bills which poured in upon the bankrupt government. When his own
funds were exhausted, he borrowed from his friends. Experienced in the
handling of merchandise, he created agencies at important points to
distribute supplies to the troops, thus displaying administrative as
well as financial talents.

[Illustration: ROBERT MORRIS]

Women organized "drives" for money, contributed their plate and their
jewels, and collected from door to door. Farmers took worthless paper in
return for their produce, and soldiers saw many a pay day pass without
yielding them a penny. Thus by the labors and sacrifices of citizens,
the issuance of paper money, lotteries, the floating of loans,
borrowings in Europe, and the impressment of supplies, the Congress
staggered through the Revolution like a pauper who knows not how his
next meal is to be secured but is continuously relieved at a crisis by a
kindly fate.


THE DIPLOMACY OF THE REVOLUTION

When the full measure of honor is given to the soldiers and sailors and
their commanding officers, the civilians who managed finances and
supplies, the writers who sustained the American spirit, and the women
who did well their part, there yet remains the duty of recognizing the
achievements of diplomacy. The importance of this field of activity was
keenly appreciated by the leaders in the Continental Congress. They were
fairly well versed in European history. They knew of the balance of
power and the sympathies, interests, and prejudices of nations and their
rulers. All this information they turned to good account, in opening
relations with continental countries and seeking money, supplies, and
even military assistance. For the transaction of this delicate business,
they created a secret committee on foreign correspondence as early as
1775 and prepared to send agents abroad.

=American Agents Sent Abroad.=--Having heard that France was inclining a
friendly ear to the American cause, the Congress, in March, 1776, sent a
commissioner to Paris, Silas Deane of Connecticut, often styled the
"first American diplomat." Later in the year a form of treaty to be
presented to foreign powers was drawn up, and Franklin, Arthur Lee, and
Deane were selected as American representatives at the court of "His
Most Christian Majesty the King of France." John Jay of New York was
chosen minister to Spain in 1779; John Adams was sent to Holland the
same year; and other agents were dispatched to Florence, Vienna, and
Berlin. The representative selected for St. Petersburg spent two
fruitless years there, "ignored by the court, living in obscurity and
experiencing nothing but humiliation and failure." Frederick the Great,
king of Prussia, expressed a desire to find in America a market for
Silesian linens and woolens, but, fearing England's command of the sea,
he refused to give direct aid to the Revolutionary cause.

=Early French Interest.=--The great diplomatic triumph of the Revolution
was won at Paris, and Benjamin Franklin was the hero of the occasion,
although many circumstances prepared the way for his success. Louis
XVI's foreign minister, Count de Vergennes, before the arrival of any
American representative, had brought to the attention of the king the
opportunity offered by the outbreak of the war between England and her
colonies. He showed him how France could redress her grievances and
"reduce the power and greatness of England"--the empire that in 1763 had
forced upon her a humiliating peace "at the price of our possessions,
of our commerce, and our credit in the Indies, at the price of Canada,
Louisiana, Isle Royale, Acadia, and Senegal." Equally successful in
gaining the king's interest was a curious French adventurer,
Beaumarchais, a man of wealth, a lover of music, and the author of two
popular plays, "Figaro" and "The Barber of Seville." These two men had
already urged upon the king secret aid for America before Deane appeared
on the scene. Shortly after his arrival they made confidential
arrangements to furnish money, clothing, powder, and other supplies to
the struggling colonies, although official requests for them were
officially refused by the French government.

=Franklin at Paris.=--When Franklin reached Paris, he was received only
in private by the king's minister, Vergennes. The French people,
however, made manifest their affection for the "plain republican" in
"his full dress suit of spotted Manchester velvet." He was known among
men of letters as an author, a scientist, and a philosopher of
extraordinary ability. His "Poor Richard" had thrice been translated
into French and was scattered in numerous editions throughout the
kingdom. People of all ranks--ministers, ladies at court, philosophers,
peasants, and stable boys--knew of Franklin and wished him success in
his mission. The queen, Marie Antoinette, fated to lose her head in a
revolution soon to follow, played with fire by encouraging "our dear
republican."

For the king of France, however, this was more serious business. England
resented the presence of this "traitor" in Paris, and Louis had to be
cautious about plunging into another war that might also end
disastrously. Moreover, the early period of Franklin's sojourn in Paris
was a dark hour for the American Revolution. Washington's brilliant
exploit at Trenton on Christmas night, 1776, and the battle with
Cornwallis at Princeton had been followed by the disaster at Brandywine,
the loss of Philadelphia, the defeat at Germantown, and the retirement
to Valley Forge for the winter of 1777-78. New York City and
Philadelphia--two strategic ports--were in British hands; the Hudson
and Delaware rivers were blocked; and General Burgoyne with his British
troops was on his way down through the heart of northern New York,
cutting New England off from the rest of the colonies. No wonder the
king was cautious. Then the unexpected happened. Burgoyne, hemmed in
from all sides by the American forces, his flanks harried, his foraging
parties beaten back, his supplies cut off, surrendered on October 17,
1777, to General Gates, who had superseded General Schuyler in time to
receive the honor.

=Treaties of Alliance and Commerce (1778).=--News of this victory,
placed by historians among the fifteen decisive battles of the world,
reached Franklin one night early in December while he and some friends
sat gloomily at dinner. Beaumarchais, who was with him, grasped at once
the meaning of the situation and set off to the court at Versailles with
such haste that he upset his coach and dislocated his arm. The king and
his ministers were at last convinced that the hour had come to aid the
Revolution. Treaties of commerce and alliance were drawn up and signed
in February, 1778. The independence of the United States was recognized
by France and an alliance was formed to guarantee that independence.
Combined military action was agreed upon and Louis then formally
declared war on England. Men who had, a few short years before, fought
one another in the wilderness of Pennsylvania or on the Plains of
Abraham, were now ranged side by side in a war on the Empire that Pitt
had erected and that George III was pulling down.

=Spain and Holland Involved.=--Within a few months, Spain, remembering
the steady decline of her sea power since the days of the Armada and
hoping to drive the British out of Gibraltar, once more joined the
concert of nations against England. Holland, a member of a league of
armed neutrals formed in protest against British searches on the high
seas, sent her fleet to unite with the forces of Spain, France, and
America to prey upon British commerce. To all this trouble for England
was added the danger of a possible revolt in Ireland, where the spirit
of independence was flaming up.

=The British Offer Terms to America.=--Seeing the colonists about to be
joined by France in a common war on the English empire, Lord North
proposed, in February, 1778, a renewal of negotiations. By solemn
enactment, Parliament declared its intention not to exercise the right
of imposing taxes within the colonies; at the same time it authorized
the opening of negotiations through commissioners to be sent to America.
A truce was to be established, pardons granted, objectionable laws
suspended, and the old imperial constitution, as it stood before the
opening of hostilities, restored to full vigor. It was too late. Events
had taken the affairs of America out of the hands of British
commissioners and diplomats.

=Effects of French Aid.=--The French alliance brought ships of war,
large sums of gold and silver, loads of supplies, and a considerable
body of trained soldiers to the aid of the Americans. Timely as was this
help, it meant no sudden change in the fortunes of war. The British
evacuated Philadelphia in the summer following the alliance, and
Washington's troops were encouraged to come out of Valley Forge. They
inflicted a heavy blow on the British at Monmouth, but the treasonable
conduct of General Charles Lee prevented a triumph. The recovery of
Philadelphia was offset by the treason of Benedict Arnold, the loss of
Savannah and Charleston (1780), and the defeat of Gates at Camden.

The full effect of the French alliance was not felt until 1781, when
Cornwallis went into Virginia and settled at Yorktown. Accompanied by
French troops Washington swept rapidly southward and penned the British
to the shore while a powerful French fleet shut off their escape by sea.
It was this movement, which certainly could not have been executed
without French aid, that put an end to all chance of restoring British
dominion in America. It was the surrender of Cornwallis at Yorktown that
caused Lord North to pace the floor and cry out: "It is all over! It is
all over!" What might have been done without the French alliance lies
hidden from mankind. What was accomplished with the help of French
soldiers, sailors, officers, money, and supplies, is known to all the
earth. "All the world agree," exultantly wrote Franklin from Paris to
General Washington, "that no expedition was ever better planned or
better executed. It brightens the glory that must accompany your name to
the latest posterity." Diplomacy as well as martial valor had its
reward.


PEACE AT LAST

=British Opposition to the War.=--In measuring the forces that led to
the final discomfiture of King George and Lord North, it is necessary to
remember that from the beginning to the end the British ministry at home
faced a powerful, informed, and relentless opposition. There were
vigorous protests, first against the obnoxious acts which precipitated
the unhappy quarrel, then against the way in which the war was waged,
and finally against the futile struggle to retain a hold upon the
American dominions. Among the members of Parliament who thundered
against the government were the first statesmen and orators of the land.
William Pitt, Earl of Chatham, though he deplored the idea of American
independence, denounced the government as the aggressor and rejoiced in
American resistance. Edmund Burke leveled his heavy batteries against
every measure of coercion and at last strove for a peace which, while
giving independence to America, would work for reconciliation rather
than estrangement. Charles James Fox gave the colonies his generous
sympathy and warmly championed their rights. Outside of the circle of
statesmen there were stout friends of the American cause like David
Hume, the philosopher and historian, and Catherine Macaulay, an author
of wide fame and a republican bold enough to encourage Washington in
seeing it through.

Against this powerful opposition, the government enlisted a whole army
of scribes and journalists to pour out criticism on the Americans and
their friends. Dr. Samuel Johnson, whom it employed in this business,
was so savage that even the ministers had to tone down his pamphlets
before printing them. Far more weighty was Edward Gibbon, who was in
time to win fame as the historian of the _Decline and Fall of the Roman
Empire_. He had at first opposed the government; but, on being given a
lucrative post, he used his sharp pen in its support, causing his
friends to ridicule him in these lines:

    "King George, in a fright
     Lest Gibbon should write
       The story of England's disgrace,
     Thought no way so sure
     His pen to secure
       As to give the historian a place."

=Lord North Yields.=--As time wore on, events bore heavily on the side
of the opponents of the government's measures. They had predicted that
conquest was impossible, and they had urged the advantages of a peace
which would in some measure restore the affections of the Americans.
Every day's news confirmed their predictions and lent support to their
arguments. Moreover, the war, which sprang out of an effort to relieve
English burdens, made those burdens heavier than ever. Military expenses
were daily increasing. Trade with the colonies, the greatest single
outlet for British goods and capital, was paralyzed. The heavy debts due
British merchants in America were not only unpaid but postponed into an
indefinite future. Ireland was on the verge of revolution. The French
had a dangerous fleet on the high seas. In vain did the king assert in
December, 1781, that no difficulties would ever make him consent to a
peace that meant American independence. Parliament knew better, and on
February 27, 1782, in the House of Commons was carried an address to the
throne against continuing the war. Burke, Fox, the younger Pitt, Barre,
and other friends of the colonies voted in the affirmative. Lord North
gave notice then that his ministry was at an end. The king moaned:
"Necessity made me yield."

In April, 1782, Franklin received word from the English government that
it was prepared to enter into negotiations leading to a settlement. This
was embarrassing. In the treaty of alliance with France, the United
States had promised that peace should be a joint affair agreed to by
both nations in open conference. Finding France, however, opposed to
some of their claims respecting boundaries and fisheries, the American
commissioners conferred with the British agents at Paris without
consulting the French minister. They actually signed a preliminary peace
draft before they informed him of their operations. When Vergennes
reproached him, Franklin replied that they "had been guilty of
neglecting _bienseance_ [good manners] but hoped that the great work
would not be ruined by a single indiscretion."

=The Terms of Peace (1783).=--The general settlement at Paris in 1783
was a triumph for America. England recognized the independence of the
United States, naming each state specifically, and agreed to boundaries
extending from the Atlantic to the Mississippi and from the Great Lakes
to the Floridas. England held Canada, Newfoundland, and the West Indies
intact, made gains in India, and maintained her supremacy on the seas.
Spain won Florida and Minorca but not the coveted Gibraltar. France
gained nothing important save the satisfaction of seeing England humbled
and the colonies independent.

The generous terms secured by the American commission at Paris called
forth surprise and gratitude in the United States and smoothed the way
for a renewal of commercial relations with the mother country. At the
same time they gave genuine anxiety to European diplomats. "This federal
republic is born a pigmy," wrote the Spanish ambassador to his royal
master. "A day will come when it will be a giant; even a colossus
formidable to these countries. Liberty of conscience and the facility
for establishing a new population on immense lands, as well as the
advantages of the new government, will draw thither farmers and artisans
from all the nations. In a few years we shall watch with grief the
tyrannical existence of the same colossus."

[Illustration: NORTH AMERICA ACCORDING TO THE TREATY OF 1783]


SUMMARY OF THE REVOLUTIONARY PERIOD

The independence of the American colonies was foreseen by many European
statesmen as they watched the growth of their population, wealth, and
power; but no one could fix the hour of the great event. Until 1763 the
American colonists lived fairly happily under British dominion. There
were collisions from time to time, of course. Royal governors clashed
with stiff-necked colonial legislatures. There were protests against the
exercise of the king's veto power in specific cases. Nevertheless, on
the whole, the relations between America and the mother country were
more amicable in 1763 than at any period under the Stuart regime which
closed in 1688.

The crash, when it came, was not deliberately willed by any one. It was
the product of a number of forces that happened to converge about 1763.
Three years before, there had come to the throne George III, a young,
proud, inexperienced, and stubborn king. For nearly fifty years his
predecessors, Germans as they were in language and interest, had allowed
things to drift in England and America. George III decided that he would
be king in fact as well as in name. About the same time England brought
to a close the long and costly French and Indian War and was staggering
under a heavy burden of debt and taxes. The war had been fought partly
in defense of the American colonies and nothing seemed more reasonable
to English statesmen than the idea that the colonies should bear part of
the cost of their own defense. At this juncture there came into
prominence, in royal councils, two men bent on taxing America and
controlling her trade, Grenville and Townshend. The king was willing,
the English taxpayers were thankful for any promise of relief, and
statesmen were found to undertake the experiment. England therefore set
out upon a new course. She imposed taxes upon the colonists, regulated
their trade and set royal officers upon them to enforce the law. This
action evoked protests from the colonists. They held a Stamp Act
Congress to declare their rights and petition for a redress of
grievances. Some of the more restless spirits rioted in the streets,
sacked the houses of the king's officers, and tore up the stamped paper.

Frightened by uprising, the English government drew back and repealed
the Stamp Act. Then it veered again and renewed its policy of
interference. Interference again called forth American protests.
Protests aroused sharper retaliation. More British regulars were sent
over to keep order. More irritating laws were passed by Parliament.
Rioting again appeared: tea was dumped in the harbor of Boston and
seized in the harbor of Charleston. The British answer was more force.
The response of the colonists was a Continental Congress for defense. An
unexpected and unintended clash of arms at Lexington and Concord in the
spring of 1775 brought forth from the king of England a proclamation:
"The Americans are rebels!"

The die was cast. The American Revolution had begun. Washington was made
commander-in-chief. Armies were raised, money was borrowed, a huge
volume of paper currency was issued, and foreign aid was summoned.
Franklin plied his diplomatic arts at Paris until in 1778 he induced
France to throw her sword into the balance. Three years later,
Cornwallis surrendered at Yorktown. In 1783, by the formal treaty of
peace, George III acknowledged the independence of the United States.
The new nation, endowed with an imperial domain stretching from the
Atlantic Ocean to the Mississippi River, began its career among the
sovereign powers of the earth.

In the sphere of civil government, the results of the Revolution were
equally remarkable. Royal officers and royal authorities were driven
from the former dominions. All power was declared to be in the people.
All the colonies became states, each with its own constitution or plan
of government. The thirteen states were united in common bonds under the
Articles of Confederation. A republic on a large scale was instituted.
Thus there was begun an adventure in popular government such as the
world had never seen. Could it succeed or was it destined to break down
and be supplanted by a monarchy? The fate of whole continents hung upon
the answer.


=References=

J. Fiske, _The American Revolution_ (2 vols.).

H. Lodge, _Life of Washington_ (2 vols.).

W. Sumner, _The Financier and the Finances of the American Revolution_.

O. Trevelyan, _The American Revolution_ (4 vols.). A sympathetic account
by an English historian.

M.C. Tyler, _Literary History of the American Revolution_ (2 vols.).

C.H. Van Tyne, _The American Revolution_ (American Nation Series) and
_The Loyalists in the American Revolution_.


=Questions=

1. What was the non-importation agreement? By what body was it adopted?
Why was it revolutionary in character?

2. Contrast the work of the first and second Continental Congresses.

3. Why did efforts at conciliation fail?

4. Trace the growth of American independence from opinion to the sphere
of action.

5. Why is the Declaration of Independence an "immortal" document?

6. What was the effect of the Revolution on colonial governments? On
national union?

7. Describe the contest between "Patriots" and "Tories."

8. What topics are considered under "military affairs"? Discuss each in
detail.

9. Contrast the American forces with the British forces and show how the
war was won.

10. Compare the work of women in the Revolutionary War with their labors
in the World War (1917-18).

11. How was the Revolution financed?

12. Why is diplomacy important in war? Describe the diplomatic triumph
of the Revolution.

13. What was the nature of the opposition in England to the war?

14. Give the events connected with the peace settlement; the terms of
peace.


=Research Topics=

=The Spirit of America.=--Woodrow Wilson, _History of the American
People_, Vol. II, pp. 98-126.

=American Rights.=--Draw up a table showing all the principles laid down
by American leaders in (1) the Resolves of the First Continental
Congress, Macdonald, _Documentary Source Book_, pp. 162-166; (2) the
Declaration of the Causes and the Necessity of Taking Up Arms,
Macdonald, pp. 176-183; and (3) the Declaration of Independence.

=The Declaration of Independence.=--Fiske, _The American Revolution_,
Vol. I, pp. 147-197. Elson, _History of the United States_, pp. 250-254.

=Diplomacy and the French Alliance.=--Hart, _American History Told by
Contemporaries_, Vol. II, pp. 574-590. Fiske, Vol. II, pp. 1-24.
Callender, _Economic History of the United States_, pp. 159-168; Elson,
pp. 275-280.

=Biographical Studies.=--Washington, Franklin, Samuel Adams, Patrick
Henry, Thomas Jefferson--emphasizing the peculiar services of each.

=The Tories.=--Hart, _Contemporaries_, Vol. II, pp. 470-480.

=Valley Forge.=--Fiske, Vol. II, pp. 25-49.

=The Battles of the Revolution.=--Elson, pp. 235-317.

=An English View of the Revolution.=--Green, _Short History of England_,
Chap. X, Sect. 2.

=English Opinion and the Revolution.=--Trevelyan, _The American
Revolution_, Vol. III (or Part 2, Vol. II), Chaps. XXIV-XXVII.




PART III. THE UNION AND NATIONAL POLITICS




CHAPTER VII

THE FORMATION OF THE CONSTITUTION


THE PROMISE AND THE DIFFICULTIES OF AMERICA

The rise of a young republic composed of thirteen states, each governed
by officials popularly elected under constitutions drafted by "the plain
people," was the most significant feature of the eighteenth century. The
majority of the patriots whose labors and sacrifices had made this
possible naturally looked upon their work and pronounced it good. Those
Americans, however, who peered beneath the surface of things, saw that
the Declaration of Independence, even if splendidly phrased, and paper
constitutions, drawn by finest enthusiasm "uninstructed by experience,"
could not alone make the republic great and prosperous or even free. All
around them they saw chaos in finance and in industry and perils for the
immediate future.

=The Weakness of the Articles of Confederation.=--The government under
the Articles of Confederation had neither the strength nor the resources
necessary to cope with the problems of reconstruction left by the war.
The sole organ of government was a Congress composed of from two to
seven members from each state chosen as the legislature might direct and
paid by the state. In determining all questions, each state had one
vote--Delaware thus enjoying the same weight as Virginia. There was no
president to enforce the laws. Congress was given power to select a
committee of thirteen--one from each state--to act as an executive body
when it was not in session; but this device, on being tried out, proved
a failure. There was no system of national courts to which citizens and
states could appeal for the protection of their rights or through which
they could compel obedience to law. The two great powers of government,
military and financial, were withheld. Congress, it is true, could
authorize expenditures but had to rely upon the states for the payment
of contributions to meet its bills. It could also order the
establishment of an army, but it could only request the states to supply
their respective quotas of soldiers. It could not lay taxes nor bring
any pressure to bear upon a single citizen in the whole country. It
could act only through the medium of the state governments.

=Financial and Commercial Disorders.=--In the field of public finance,
the disorders were pronounced. The huge debt incurred during the war was
still outstanding. Congress was unable to pay either the interest or the
principal. Public creditors were in despair, as the market value of
their bonds sank to twenty-five or even ten cents on the dollar. The
current bills of Congress were unpaid. As some one complained, there was
not enough money in the treasury to buy pen and ink with which to record
the transactions of the shadow legislature. The currency was in utter
chaos. Millions of dollars in notes issued by Congress had become mere
trash worth a cent or two on the dollar. There was no other expression
of contempt so forceful as the popular saying: "not worth a
Continental." To make matters worse, several of the states were pouring
new streams of paper money from the press. Almost the only good money in
circulation consisted of English, French, and Spanish coins, and the
public was even defrauded by them because money changers were busy
clipping and filing away the metal. Foreign commerce was unsettled. The
entire British system of trade discrimination was turned against the
Americans, and Congress, having no power to regulate foreign commerce,
was unable to retaliate or to negotiate treaties which it could enforce.
Domestic commerce was impeded by the jealousies of the states, which
erected tariff barriers against their neighbors. The condition of the
currency made the exchange of money and goods extremely difficult, and,
as if to increase the confusion, backward states enacted laws hindering
the prompt collection of debts within their borders--an evil which
nothing but a national system of courts could cure.

=Congress in Disrepute.=--With treaties set at naught by the states, the
laws unenforced, the treasury empty, and the public credit gone, the
Congress of the United States fell into utter disrepute. It called upon
the states to pay their quotas of money into the treasury, only to be
treated with contempt. Even its own members looked upon it as a solemn
futility. Some of the ablest men refused to accept election to it, and
many who did take the doubtful honor failed to attend the sessions.
Again and again it was impossible to secure a quorum for the transaction
of business.

=Troubles of the State Governments.=--The state governments, free to
pursue their own course with no interference from without, had almost as
many difficulties as the Congress. They too were loaded with
revolutionary debts calling for heavy taxes upon an already restive
population. Oppressed by their financial burdens and discouraged by the
fall in prices which followed the return of peace, the farmers of
several states joined in a concerted effort and compelled their
legislatures to issue large sums of paper money. The currency fell in
value, but nevertheless it was forced on unwilling creditors to square
old accounts.

In every part of the country legislative action fluctuated violently.
Laws were made one year only to be repealed the next and reenacted the
third year. Lands were sold by one legislature and the sales were
canceled by its successor. Uncertainty and distrust were the natural
consequences. Men of substance longed for some power that would forbid
states to issue bills of credit, to make paper money legal tender in
payment of debts, or to impair the obligation of contracts. Men heavily
in debt, on the other hand, urged even more drastic action against
creditors.

So great did the discontent of the farmers in New Hampshire become in
1786 that a mob surrounded the legislature, demanding a repeal of the
taxes and the issuance of paper money. It was with difficulty that an
armed rebellion was avoided. In Massachusetts the malcontents, under the
leadership of Daniel Shays, a captain in the Revolutionary army,
organized that same year open resistance to the government of the state.
Shays and his followers protested against the conduct of creditors in
foreclosing mortgages upon the debt-burdened farmers, against the
lawyers for increasing the costs of legal proceedings, against the
senate of the state the members of which were apportioned among the
towns on the basis of the amount of taxes paid, against heavy taxes, and
against the refusal of the legislature to issue paper money. They seized
the towns of Worcester and Springfield and broke up the courts of
justice. All through the western part of the state the revolt spread,
sending a shock of alarm to every center and section of the young
republic. Only by the most vigorous action was Governor Bowdoin able to
quell the uprising; and when that task was accomplished, the state
government did not dare to execute any of the prisoners because they had
so many sympathizers. Moreover, Bowdoin and several members of the
legislature who had been most zealous in their attacks on the insurgents
were defeated at the ensuing election. The need of national assistance
for state governments in times of domestic violence was everywhere
emphasized by men who were opposed to revolutionary acts.

=Alarm over Dangers to the Republic.=--Leading American citizens,
watching the drift of affairs, were slowly driven to the conclusion that
the new ship of state so proudly launched a few years before was
careening into anarchy. "The facts of our peace and independence," wrote
a friend of Washington, "do not at present wear so promising an
appearance as I had fondly painted in my mind. The prejudices,
jealousies, and turbulence of the people at times almost stagger my
confidence in our political establishments; and almost occasion me to
think that they will show themselves unworthy of the noble prize for
which we have contended."

Washington himself was profoundly discouraged. On hearing of Shays's
rebellion, he exclaimed: "What, gracious God, is man that there should
be such inconsistency and perfidiousness in his conduct! It is but the
other day that we were shedding our blood to obtain the constitutions
under which we now live--constitutions of our own choice and making--and
now we are unsheathing our sword to overturn them." The same year he
burst out in a lament over rumors of restoring royal government. "I am
told that even respectable characters speak of a monarchical government
without horror. From thinking proceeds speaking. Hence to acting is
often but a single step. But how irresistible and tremendous! What a
triumph for our enemies to verify their predictions! What a triumph for
the advocates of despotism to find that we are incapable of governing
ourselves!"

=Congress Attempts Some Reforms.=--The Congress was not indifferent to
the events that disturbed Washington. On the contrary it put forth many
efforts to check tendencies so dangerous to finance, commerce,
industries, and the Confederation itself. In 1781, even before the
treaty of peace was signed, the Congress, having found out how futile
were its taxing powers, carried a resolution of amendment to the
Articles of Confederation, authorizing the levy of a moderate duty on
imports. Yet this mild measure was rejected by the states. Two years
later the Congress prepared another amendment sanctioning the levy of
duties on imports, to be collected this time by state officers and
applied to the payment of the public debt. This more limited proposal,
designed to save public credit, likewise failed. In 1786, the Congress
made a third appeal to the states for help, declaring that they had been
so irregular and so negligent in paying their quotas that further
reliance upon that mode of raising revenues was dishonorable and
dangerous.


THE CALLING OF A CONSTITUTIONAL CONVENTION

=Hamilton and Washington Urge Reform.=--The attempts at reform by the
Congress were accompanied by demand for, both within and without that
body, a convention to frame a new plan of government. In 1780, the
youthful Alexander Hamilton, realizing the weakness of the Articles, so
widely discussed, proposed a general convention for the purpose of
drafting a new constitution on entirely different principles. With
tireless energy he strove to bring his countrymen to his view.
Washington, agreeing with him on every point, declared, in a circular
letter to the governors, that the duration of the union would be short
unless there was lodged somewhere a supreme power "to regulate and
govern the general concerns of the confederated republic." The governor
of Massachusetts, disturbed by the growth of discontent all about him,
suggested to the state legislature in 1785 the advisability of a
national convention to enlarge the powers of the Congress. The
legislature approved the plan, but did not press it to a conclusion.

[Illustration: ALEXANDER HAMILTON]

=The Annapolis Convention.=--Action finally came from the South. The
Virginia legislature, taking things into its own hands, called a
conference of delegates at Annapolis to consider matters of taxation and
commerce. When the convention assembled in 1786, it was found that only
five states had taken the trouble to send representatives. The leaders
were deeply discouraged, but the resourceful Hamilton, a delegate from
New York, turned the affair to good account. He secured the adoption of
a resolution, calling upon the Congress itself to summon another
convention, to meet at Philadelphia.

=A National Convention Called (1787).=--The Congress, as tardy as ever,
at last decided in February, 1787, to issue the call. Fearing drastic
changes, however, it restricted the convention to "the sole and express
purpose of revising the Articles of Confederation." Jealous of its own
powers, it added that any alterations proposed should be referred to the
Congress and the states for their approval.

Every state in the union, except Rhode Island, responded to this call.
Indeed some of the states, having the Annapolis resolution before them,
had already anticipated the Congress by selecting delegates before the
formal summons came. Thus, by the persistence of governors,
legislatures, and private citizens, there was brought about the
long-desired national convention. In May, 1787, it assembled in
Philadelphia.

=The Eminent Men of the Convention.=--On the roll of that memorable
convention were fifty-five men, at least half of whom were acknowledged
to be among the foremost statesmen and thinkers in America. Every field
of statecraft was represented by them: war and practical management in
Washington, who was chosen president of the convention; diplomacy in
Franklin, now old and full of honor in his own land as well as abroad;
finance in Alexander Hamilton and Robert Morris; law in James Wilson of
Pennsylvania; the philosophy of government in James Madison, called the
"father of the Constitution." They were not theorists but practical men,
rich in political experience and endowed with deep insight into the
springs of human action. Three of them had served in the Stamp Act
Congress: Dickinson of Delaware, William Samuel Johnson of Connecticut,
and John Rutledge of South Carolina. Eight had been signers of the
Declaration of Independence: Read of Delaware, Sherman of Connecticut,
Wythe of Virginia, Gerry of Massachusetts, Franklin, Robert Morris,
George Clymer, and James Wilson of Pennsylvania. All but twelve had at
some time served in the Continental Congress and eighteen were members
of that body in the spring of 1787. Washington, Hamilton, Mifflin, and
Charles Pinckney had been officers in the Revolutionary army. Seven of
the delegates had gained political experience as governors of states.
"The convention as a whole," according to the historian Hildreth,
"represented in a marked manner the talent, intelligence, and
especially the conservative sentiment of the country."


THE FRAMING OF THE CONSTITUTION

=Problems Involved.=--The great problems before the convention were nine
in number: (1) Shall the Articles of Confederation be revised or a new
system of government constructed? (2) Shall the government be founded on
states equal in power as under the Articles or on the broader and deeper
foundation of population? (3) What direct share shall the people have in
the election of national officers? (4) What shall be the qualifications
for the suffrage? (5) How shall the conflicting interests of the
commercial and the planting states be balanced so as to safeguard the
essential rights of each? (6) What shall be the form of the new
government? (7) What powers shall be conferred on it? (8) How shall the
state legislatures be restrained from their attacks on property rights
such as the issuance of paper money? (9) Shall the approval of all the
states be necessary, as under the Articles, for the adoption and
amendment of the Constitution?

=Revision of the Articles or a New Government?=--The moment the first
problem was raised, representatives of the small states, led by William
Paterson of New Jersey, were on their feet. They feared that, if the
Articles were overthrown, the equality and rights of the states would be
put in jeopardy. Their protest was therefore vigorous. They cited the
call issued by the Congress in summoning the convention which
specifically stated that they were assembled for "the sole and express
purpose of revising the Articles of Confederation." They cited also
their instructions from their state legislatures, which authorized them
to "revise and amend" the existing scheme of government, not to make a
revolution in it. To depart from the authorization laid down by the
Congress and the legislatures would be to exceed their powers, they
argued, and to betray the trust reposed in them by their countrymen.

To their contentions, Randolph of Virginia replied: "When the salvation
of the republic is at stake, it would be treason to our trust not to
propose what we find necessary." Hamilton, reminding the delegates that
their work was still subject to the approval of the states, frankly said
that on the point of their powers he had no scruples. With the issue
clear, the convention cast aside the Articles as if they did not exist
and proceeded to the work of drawing up a new constitution, "laying its
foundations on such principles and organizing its powers in such form"
as to the delegates seemed "most likely to affect their safety and
happiness."

=A Government Founded on States or on People?--The
Compromise.=--Defeated in their attempt to limit the convention to a
mere revision of the Articles, the spokesmen of the smaller states
redoubled their efforts to preserve the equality of the states. The
signal for a radical departure from the Articles on this point was given
early in the sessions when Randolph presented "the Virginia plan." He
proposed that the new national legislature consist of two houses, the
members of which were to be apportioned among the states according to
their wealth or free white population, as the convention might decide.
This plan was vehemently challenged. Paterson of New Jersey flatly
avowed that neither he nor his state would ever bow to such tyranny. As
an alternative, he presented "the New Jersey plan" calling for a
national legislature of one house representing states as such, not
wealth or people--a legislature in which all states, large or small,
would have equal voice. Wilson of Pennsylvania, on behalf of the more
populous states, took up the gauntlet which Paterson had thrown down. It
was absurd, he urged, for 180,000 men in one state to have the same
weight in national counsels as 750,000 men in another state. "The
gentleman from New Jersey," he said, "is candid. He declares his opinion
boldly.... I will be equally candid.... I will never confederate on his
principles." So the bitter controversy ran on through many exciting
sessions.

Greek had met Greek. The convention was hopelessly deadlocked and on the
verge of dissolution, "scarce held together by the strength of a hair,"
as one of the delegates remarked. A crash was averted only by a
compromise. Instead of a Congress of one house as provided by the
Articles, the convention agreed upon a legislature of two houses. In the
Senate, the aspirations of the small states were to be satisfied, for
each state was given two members in that body. In the formation of the
House of Representatives, the larger states were placated, for it was
agreed that the members of that chamber were to be apportioned among the
states on the basis of population, counting three-fifths of the slaves.

=The Question of Popular Election.=--The method of selecting federal
officers and members of Congress also produced an acrimonious debate
which revealed how deep-seated was the distrust of the capacity of the
people to govern themselves. Few there were who believed that no branch
of the government should be elected directly by the voters; still fewer
were there, however, who desired to see all branches so chosen. One or
two even expressed a desire for a monarchy. The dangers of democracy
were stressed by Gerry of Massachusetts: "All the evils we experience
flow from an excess of democracy. The people do not want virtue but are
the dupes of pretended patriots.... I have been too republican
heretofore but have been taught by experience the danger of a leveling
spirit." To the "democratic licentiousness of the state legislatures,"
Randolph sought to oppose a "firm senate." To check the excesses of
popular government Charles Pinckney of South Carolina declared that no
one should be elected President who was not worth $100,000 and that high
property qualifications should be placed on members of Congress and
judges. Other members of the convention were stoutly opposed to such
"high-toned notions of government." Franklin and Wilson, both from
Pennsylvania, vigorously championed popular election; while men like
Madison insisted that at least one part of the government should rest on
the broad foundation of the people.

Out of this clash of opinion also came compromise. One branch, the House
of Representatives, it was agreed, was to be elected directly by the
voters, while the Senators were to be elected indirectly by the state
legislatures. The President was to be chosen by electors selected as the
legislatures of the states might determine, and the judges of the
federal courts, supreme and inferior, by the President and the Senate.

=The Question of the Suffrage.=--The battle over the suffrage was sharp
but brief. Gouverneur Morris proposed that only land owners should be
permitted to vote. Madison replied that the state legislatures, which
had made so much trouble with radical laws, were elected by freeholders.
After the debate, the delegates, unable to agree on any property
limitations on the suffrage, decided that the House of Representatives
should be elected by voters having the "qualifications requisite for
electors of the most numerous branch of the state legislature." Thus
they accepted the suffrage provisions of the states.

=The Balance between the Planting and the Commercial States.=--After the
debates had gone on for a few weeks, Madison came to the conclusion that
the real division in the convention was not between the large and the
small states but between the planting section founded on slave labor and
the commercial North. Thus he anticipated by nearly three-quarters of a
century "the irrepressible conflict." The planting states had neither
the free white population nor the wealth of the North. There were,
counting Delaware, six of them as against seven commercial states.
Dependent for their prosperity mainly upon the sale of tobacco, rice,
and other staples abroad, they feared that Congress might impose
restraints upon their enterprise. Being weaker in numbers, they were
afraid that the majority might lay an unfair burden of taxes upon them.

_Representation and Taxation._--The Southern members of the convention
were therefore very anxious to secure for their section the largest
possible representation in Congress, and at the same time to restrain
the taxing power of that body. Two devices were thought adapted to these
ends. One was to count the slaves as people when apportioning
representatives among the states according to their respective
populations; the other was to provide that direct taxes should be
apportioned among the states, in proportion not to their wealth but to
the number of their free white inhabitants. For obvious reasons the
Northern delegates objected to these proposals. Once more a compromise
proved to be the solution. It was agreed that not all the slaves but
three-fifths of them should be counted for both purposes--representation
and direct taxation.

_Commerce and the Slave Trade._--Southern interests were also involved
in the project to confer upon Congress the power to regulate interstate
and foreign commerce. To the manufacturing and trading states this was
essential. It would prevent interstate tariffs and trade jealousies; it
would enable Congress to protect American manufactures and to break
down, by appropriate retaliations, foreign discriminations against
American commerce. To the South the proposal was menacing because
tariffs might interfere with the free exchange of the produce of
plantations in European markets, and navigation acts might confine the
carrying trade to American, that is Northern, ships. The importation of
slaves, moreover, it was feared might be heavily taxed or immediately
prohibited altogether.

The result of this and related controversies was a debate on the merits
of slavery. Gouverneur Morris delivered his mind and heart on that
subject, denouncing slavery as a nefarious institution and the curse of
heaven on the states in which it prevailed. Mason of Virginia, a
slaveholder himself, was hardly less outspoken, saying: "Slavery
discourages arts and manufactures. The poor despise labor when performed
by slaves. They prevent the migration of whites who really strengthen
and enrich a country."

The system, however, had its defenders. Representatives from South
Carolina argued that their entire economic life rested on slave labor
and that the high death rate in the rice swamps made continuous
importation necessary. Ellsworth of Connecticut took the ground that
the convention should not meddle with slavery. "The morality or wisdom
of slavery," he said, "are considerations belonging to the states. What
enriches a part enriches the whole." To the future he turned an
untroubled face: "As population increases, poor laborers will be so
plenty as to render slaves useless. Slavery in time will not be a speck
in our country." Virginia and North Carolina, already overstocked with
slaves, favored prohibiting the traffic in them; but South Carolina was
adamant. She must have fresh supplies of slaves or she would not
federate.

So it was agreed that, while Congress might regulate foreign trade by
majority vote, the importation of slaves should not be forbidden before
the lapse of twenty years, and that any import tax should not exceed $10
a head. At the same time, in connection with the regulation of foreign
trade, it was stipulated that a two-thirds vote in the Senate should be
necessary in the ratification of treaties. A further concession to the
South was made in the provision for the return of runaway slaves--a
provision also useful in the North, where indentured servants were about
as troublesome as slaves in escaping from their masters.

=The Form of the Government.=--As to the details of the frame of
government and the grand principles involved, the opinion of the
convention ebbed and flowed, decisions being taken in the heat of
debate, only to be revoked and taken again.

_The Executive._--There was general agreement that there should be an
executive branch; for reliance upon Congress to enforce its own laws and
treaties had been a broken reed. On the character and functions of the
executive, however, there were many views. The New Jersey plan called
for a council selected by the Congress; the Virginia plan provided that
the executive branch should be chosen by the Congress but did not state
whether it should be composed of one or several persons. On this matter
the convention voted first one way and then another; finally it agreed
on a single executive chosen indirectly by electors selected as the
state legislatures might decide, serving for four years, subject to
impeachment, and endowed with regal powers in the command of the army
and the navy and in the enforcement of the laws.

_The Legislative Branch--Congress._--After the convention had made the
great compromise between the large and small commonwealths by giving
representation to states in the Senate and to population in the House,
the question of methods of election had to be decided. As to the House
of Representatives it was readily agreed that the members should be
elected by direct popular vote. There was also easy agreement on the
proposition that a strong Senate was needed to check the "turbulence" of
the lower house. Four devices were finally selected to accomplish this
purpose. In the first place, the Senators were not to be chosen directly
by the voters but by the legislatures of the states, thus removing their
election one degree from the populace. In the second place, their term
was fixed at six years instead of two, as in the case of the House. In
the third place, provision was made for continuity by having only
one-third of the members go out at a time while two-thirds remained in
service. Finally, it was provided that Senators must be at least thirty
years old while Representatives need be only twenty-five.

_The Judiciary._--The need for federal courts to carry out the law was
hardly open to debate. The feebleness of the Articles of Confederation
was, in a large measure, attributed to the want of a judiciary to hold
states and individuals in obedience to the laws and treaties of the
union. Nevertheless on this point the advocates of states' rights were
extremely sensitive. They looked with distrust upon judges appointed at
the national capital and emancipated from local interests and
traditions; they remembered with what insistence they had claimed
against Britain the right of local trial by jury and with what
consternation they had viewed the proposal to make colonial judges
independent of the assemblies in the matter of their salaries.
Reluctantly they yielded to the demand for federal courts, consenting at
first only to a supreme court to review cases heard in lower state
courts and finally to such additional inferior courts as Congress might
deem necessary.

_The System of Checks and Balances._--It is thus apparent that the
framers of the Constitution, in shaping the form of government, arranged
for a distribution of power among three branches, executive,
legislative, and judicial. Strictly speaking we might say four branches,
for the legislature, or Congress, was composed of two houses, elected in
different ways, and one of them, the Senate, was made a check on the
President through its power of ratifying treaties and appointments. "The
accumulation of all powers, legislative, executive, and judicial, in the
same hands," wrote Madison, "whether of one, a few, or many, and whether
hereditary, self-appointed, or elective, may justly be pronounced the
very definition of tyranny." The devices which the convention adopted to
prevent such a centralization of authority were exceedingly ingenious
and well calculated to accomplish the purposes of the authors.

The legislature consisted of two houses, the members of which were to be
apportioned on a different basis, elected in different ways, and to
serve for different terms. A veto on all its acts was vested in a
President elected in a manner not employed in the choice of either
branch of the legislature, serving for four years, and subject to
removal only by the difficult process of impeachment. After a law had
run the gantlet of both houses and the executive, it was subject to
interpretation and annulment by the judiciary, appointed by the
President with the consent of the Senate and serving for life. Thus it
was made almost impossible for any political party to get possession of
all branches of the government at a single popular election. As Hamilton
remarked, the friends of good government considered "every institution
calculated to restrain the excess of law making and to keep things in
the same state in which they happen to be at any given period as more
likely to do good than harm."

=The Powers of the Federal Government.=--On the question of the powers
to be conferred upon the new government there was less occasion for a
serious dispute. Even the delegates from the small states agreed with
those from Massachusetts, Pennsylvania, and Virginia that new powers
should be added to those intrusted to Congress by the Articles of
Confederation. The New Jersey plan as well as the Virginia plan
recognized this fact. Some of the delegates, like Hamilton and Madison,
even proposed to give Congress a general legislative authority covering
all national matters; but others, frightened by the specter of
nationalism, insisted on specifying each power to be conferred and
finally carried the day.

_Taxation and Commerce._--There were none bold enough to dissent from
the proposition that revenue must be provided to pay current expenses
and discharge the public debt. When once the dispute over the
apportionment of direct taxes among the slave states was settled, it was
an easy matter to decide that Congress should have power to lay and
collect taxes, duties, imposts, and excises. In this way the national
government was freed from dependence upon stubborn and tardy
legislatures and enabled to collect funds directly from citizens. There
were likewise none bold enough to contend that the anarchy of state
tariffs and trade discriminations should be longer endured. When the
fears of the planting states were allayed and the "bargain" over the
importation of slaves was reached, the convention vested in Congress the
power to regulate foreign and interstate commerce.

_National Defense._--The necessity for national defense was realized,
though the fear of huge military establishments was equally present. The
old practice of relying on quotas furnished by the state legislatures
was completely discredited. As in the case of taxes a direct authority
over citizens was demanded. Congress was therefore given full power to
raise and support armies and a navy. It could employ the state militia
when desirable; but it could at the same time maintain a regular army
and call directly upon all able-bodied males if the nature of a crisis
was thought to require it.

_The "Necessary and Proper" Clause._--To the specified power vested in
Congress by the Constitution, the advocates of a strong national
government added a general clause authorizing it to make all laws
"necessary and proper" for carrying into effect any and all of the
enumerated powers. This clause, interpreted by that master mind, Chief
Justice Marshall, was later construed to confer powers as wide as the
requirements of a vast country spanning a continent and taking its place
among the mighty nations of the earth.

=Restraints on the States.=--Framing a government and endowing it with
large powers were by no means the sole concern of the convention. Its
very existence had been due quite as much to the conduct of the state
legislatures as to the futilities of a paralyzed Continental Congress.
In every state, explains Marshall in his _Life of Washington_, there was
a party of men who had "marked out for themselves a more indulgent
course. Viewing with extreme tenderness the case of the debtor, their
efforts were unceasingly directed to his relief. To exact a faithful
compliance with contracts was, in their opinion, a harsh measure which
the people could not bear. They were uniformly in favor of relaxing the
administration of justice, of affording facilities for the payment of
debts, or of suspending their collection, and remitting taxes."

The legislatures under the dominance of these men had enacted paper
money laws enabling debtors to discharge their obligations more easily.
The convention put an end to such practices by providing that no state
should emit bills of credit or make anything but gold or silver legal
tender in the payment of debts. The state legislatures had enacted laws
allowing men to pay their debts by turning over to creditors land or
personal property; they had repealed the charter of an endowed college
and taken the management from the hands of the lawful trustees; and they
had otherwise interfered with the enforcement of private agreements. The
convention, taking notice of such matters, inserted a clause forbidding
states "to impair the obligation of contracts." The more venturous of
the radicals had in Massachusetts raised the standard of revolt against
the authorities of the state. The convention answered by a brief
sentence to the effect that the President of the United States, to be
equipped with a regular army, would send troops to suppress domestic
insurrections whenever called upon by the legislature or, if it was not
in session, by the governor of the state. To make sure that the
restrictions on the states would not be dead letters, the federal
Constitution, laws, and treaties were made the supreme law of the land,
to be enforced whenever necessary by a national judiciary and executive
against violations on the part of any state authorities.

=Provisions for Ratification and Amendment.=--When the frame of
government had been determined, the powers to be vested in it had been
enumerated, and the restrictions upon the states had been written into
the bond, there remained three final questions. How shall the
Constitution be ratified? What number of states shall be necessary to
put it into effect? How shall it be amended in the future?

On the first point, the mandate under which the convention was sitting
seemed positive. The Articles of Confederation were still in effect.
They provided that amendments could be made only by unanimous adoption
in Congress and the approval of all the states. As if to give force to
this provision of law, the call for the convention had expressly stated
that all alterations and revisions should be reported to Congress for
adoption or rejection, Congress itself to transmit the document
thereafter to the states for their review.

To have observed the strict letter of the law would have defeated the
purposes of the delegates, because Congress and the state legislatures
were openly hostile to such drastic changes as had been made. Unanimous
ratification, as events proved, would have been impossible. Therefore
the delegates decided that the Constitution should be sent to Congress
with the recommendation that it, in turn, transmit the document, not to
the state legislatures, but to conventions held in the states for the
special object of deciding upon ratification. This process was followed.
It was their belief that special conventions would be more friendly than
the state legislatures.

The convention was equally positive in dealing with the problem of the
number of states necessary to establish the new Constitution. Attempts
to change the Articles had failed because amendment required the
approval of every state and there was always at least one recalcitrant
member of the union. The opposition to a new Constitution was
undoubtedly formidable. Rhode Island had even refused to take part in
framing it, and her hostility was deep and open. So the convention cast
aside the provision of the Articles of Confederation which required
unanimous approval for any change in the plan of government; it decreed
that the new Constitution should go into effect when ratified by nine
states.

In providing for future changes in the Constitution itself the
convention also thrust aside the old rule of unanimous approval, and
decided that an amendment could be made on a two-thirds vote in both
houses of Congress and ratification by three-fourths of the states. This
change was of profound significance. Every state agreed to be bound in
the future by amendments duly adopted even in case it did not approve
them itself. America in this way set out upon the high road that led
from a league of states to a nation.


THE STRUGGLE OVER RATIFICATION

On September 17, 1787, the Constitution, having been finally drafted in
clear and simple language, a model to all makers of fundamental law, was
adopted. The convention, after nearly four months of debate in secret
session, flung open the doors and presented to the Americans the
finished plan for the new government. Then the great debate passed to
the people.

=The Opposition.=--Storms of criticism at once descended upon the
Constitution. "Fraudulent usurpation!" exclaimed Gerry, who had refused
to sign it. "A monster" out of the "thick veil of secrecy," declaimed a
Pennsylvania newspaper. "An iron-handed despotism will be the result,"
protested a third. "We, 'the low-born,'" sarcastically wrote a fourth,
"will now admit the 'six hundred well-born' immediately to establish
this most noble, most excellent, and truly divine constitution." The
President will become a king; Congress will be as tyrannical as
Parliament in the old days; the states will be swallowed up; the rights
of the people will be trampled upon; the poor man's justice will be lost
in the endless delays of the federal courts--such was the strain of the
protests against ratification.

[Illustration: AN ADVERTISEMENT OF _The Federalist_]

=Defense of the Constitution.=--Moved by the tempest of opposition,
Hamilton, Madison, and Jay took up their pens in defense of the
Constitution. In a series of newspaper articles they discussed and
expounded with eloquence, learning, and dignity every important clause
and provision of the proposed plan. These papers, afterwards collected
and published in a volume known as _The Federalist_, form the finest
textbook on the Constitution that has ever been printed. It takes its
place, moreover, among the wisest and weightiest treatises on government
ever written in any language in any time. Other men, not so gifted, were
no less earnest in their support of ratification. In private
correspondence, editorials, pamphlets, and letters to the newspapers,
they urged their countrymen to forget their partisanship and accept a
Constitution which, in spite of any defects great or small, was the
only guarantee against dissolution and warfare at home and dishonor and
weakness abroad.

[Illustration: CELEBRATING THE RATIFICATION]

=The Action of the State Conventions.=--Before the end of the year,
1787, three states had ratified the Constitution: Delaware and New
Jersey unanimously and Pennsylvania after a short, though savage,
contest. Connecticut and Georgia followed early the next year. Then came
the battle royal in Massachusetts, ending in ratification in February by
the narrow margin of 187 votes to 168. In the spring came the news that
Maryland and South Carolina were "under the new roof." On June 21, New
Hampshire, where the sentiment was at first strong enough to defeat the
Constitution, joined the new republic, influenced by the favorable
decision in Massachusetts. Swift couriers were sent to carry the news to
New York and Virginia, where the question of ratification was still
undecided. Nine states had accepted it and were united, whether more saw
fit to join or not.

Meanwhile, however, Virginia, after a long and searching debate, had
given her approval by a narrow margin, leaving New York as the next seat
of anxiety. In that state the popular vote for the delegates to the
convention had been clearly and heavily against ratification. Events
finally demonstrated the futility of resistance, and Hamilton by good
judgment and masterly arguments was at last able to marshal a majority
of thirty to twenty-seven votes in favor of ratification.

The great contest was over. All the states, except North Carolina and
Rhode Island, had ratified. "The sloop Anarchy," wrote an ebullient
journalist, "when last heard from was ashore on Union rocks."

=The First Election.=--In the autumn of 1788, elections were held to
fill the places in the new government. Public opinion was overwhelmingly
in favor of Washington as the first President. Yielding to the
importunities of friends, he accepted the post in the spirit of public
service. On April 30, 1789, he took the oath of office at Federal Hall
in New York City. "Long live George Washington, President of the United
States!" cried Chancellor Livingston as soon as the General had kissed
the Bible. The cry was caught by the assembled multitude and given back.
A new experiment in popular government was launched.


=References=

M. Farrand, _The Framing of the Constitution of the United States_.

P.L. Ford, _Essays on the Constitution of the United States_.

_The Federalist_ (in many editions).

G. Hunt, _Life of James Madison_.

A.C. McLaughlin, _The Confederation and the Constitution_ (American
Nation Series).


=Questions=

1. Account for the failure of the Articles of Confederation.

2. Explain the domestic difficulties of the individual states.

3. Why did efforts at reform by the Congress come to naught?

4. Narrate the events leading up to the constitutional convention.

5. Who were some of the leading men in the convention? What had been
their previous training?

6. State the great problems before the convention.

7. In what respects were the planting and commercial states opposed?
What compromises were reached?

8. Show how the "check and balance" system is embodied in our form of
government.

9. How did the powers conferred upon the federal government help cure
the defects of the Articles of Confederation?

10. In what way did the provisions for ratifying and amending the
Constitution depart from the old system?

11. What was the nature of the conflict over ratification?


=Research Topics=

=English Treatment of American Commerce.=--Callender, _Economic History
of the United States_, pp. 210-220.

=Financial Condition of the United States.=--Fiske, _Critical Period of
American History_, pp. 163-186.

=Disordered Commerce.=--Fiske, pp. 134-162.

=Selfish Conduct of the States.=--Callender, pp. 185-191.

=The Failure of the Confederation.=--Elson, _History of the United
States_, pp. 318-326.

=Formation of the Constitution.=--(1) The plans before the convention,
Fiske, pp. 236-249; (2) the great compromise, Fiske, pp. 250-255; (3)
slavery and the convention, Fiske, pp. 256-266; and (4) the frame of
government, Fiske, pp. 275-301; Elson, pp. 328-334.

=Biographical Studies.=--Look up the history and services of the leaders
in the convention in any good encyclopedia.

=Ratification of the Constitution.=--Hart, _History Told by
Contemporaries_, Vol. III, pp. 233-254; Elson, pp. 334-340.

=Source Study.=--Compare the Constitution and Articles of Confederation
under the following heads: (1) frame of government; (2) powers of
Congress; (3) limits on states; and (4) methods of amendment. Every line
of the Constitution should be read and re-read in the light of the
historical circumstances set forth in this chapter.




CHAPTER VIII

THE CLASH OF POLITICAL PARTIES


THE MEN AND MEASURES OF THE NEW GOVERNMENT

=Friends of the Constitution in Power.=--In the first Congress that
assembled after the adoption of the Constitution, there were eleven
Senators, led by Robert Morris, the financier, who had been delegates to
the national convention. Several members of the House of
Representatives, headed by James Madison, had also been at Philadelphia
in 1787. In making his appointments, Washington strengthened the new
system of government still further by a judicious selection of
officials. He chose as Secretary of the Treasury, Alexander Hamilton,
who had been the most zealous for its success; General Knox, head of the
War Department, and Edmund Randolph, the Attorney-General, were likewise
conspicuous friends of the experiment. Every member of the federal
judiciary whom Washington appointed, from the Chief Justice, John Jay,
down to the justices of the district courts, had favored the
ratification of the Constitution; and a majority of them had served as
members of the national convention that framed the document or of the
state ratifying conventions. Only one man of influence in the new
government, Thomas Jefferson, the Secretary of State, was reckoned as a
doubter in the house of the faithful. He had expressed opinions both for
and against the Constitution; but he had been out of the country acting
as the minister at Paris when the Constitution was drafted and ratified.

=An Opposition to Conciliate.=--The inauguration of Washington amid the
plaudits of his countrymen did not set at rest all the political turmoil
which had been aroused by the angry contest over ratification. "The
interesting nature of the question," wrote John Marshall, "the equality
of the parties, the animation produced inevitably by ardent debate had a
necessary tendency to embitter the dispositions of the vanquished and to
fix more deeply in many bosoms their prejudices against a plan of
government in opposition to which all their passions were enlisted." The
leaders gathered around Washington were well aware of the excited state
of the country. They saw Rhode Island and North Carolina still outside
of the union.[1] They knew by what small margins the Constitution had
been approved in the great states of Massachusetts, Virginia, and New
York. They were equally aware that a majority of the state conventions,
in yielding reluctant approval to the Constitution, had drawn a number
of amendments for immediate submission to the states.

=The First Amendments--a Bill of Rights.=--To meet the opposition,
Madison proposed, and the first Congress adopted, a series of amendments
to the Constitution. Ten of them were soon ratified and became in 1791 a
part of the law of the land. These amendments provided, among other
things, that Congress could make no law respecting the establishment of
religion, abridging the freedom of speech or of the press or the right
of the people peaceably to assemble and petition the government for a
redress of grievances. They also guaranteed indictment by grand jury and
trial by jury for all persons charged by federal officers with serious
crimes. To reassure those who still feared that local rights might be
invaded by the federal government, the tenth amendment expressly
provided that the powers not delegated to the United States by the
Constitution, nor prohibited by it to the states, are reserved to the
states respectively or to the people. Seven years later, the eleventh
amendment was written in the same spirit as the first ten, after a
heated debate over the action of the Supreme Court in permitting a
citizen to bring a suit against "the sovereign state" of Georgia. The
new amendment was designed to protect states against the federal
judiciary by forbidding it to hear any case in which a state was sued by
a citizen.

=Funding the National Debt.=--Paper declarations of rights, however,
paid no bills. To this task Hamilton turned all his splendid genius. At
the very outset he addressed himself to the problem of the huge public
debt, daily mounting as the unpaid interest accumulated. In a _Report on
Public Credit_ under date of January 9, 1790, one of the first and
greatest of American state papers, he laid before Congress the outlines
of his plan. He proposed that the federal government should call in all
the old bonds, certificates of indebtedness, and other promises to pay
which had been issued by the Congress since the beginning of the
Revolution. These national obligations, he urged, should be put into one
consolidated debt resting on the credit of the United States; to the
holders of the old paper should be issued new bonds drawing interest at
fixed rates. This process was called "funding the debt." Such a
provision for the support of public credit, Hamilton insisted, would
satisfy creditors, restore landed property to its former value, and
furnish new resources to agriculture and commerce in the form of credit
and capital.

=Assumption and Funding of State Debts.=--Hamilton then turned to the
obligations incurred by the several states in support of the Revolution.
These debts he proposed to add to the national debt. They were to be
"assumed" by the United States government and placed on the same secure
foundation as the continental debt. This measure he defended not merely
on grounds of national honor. It would, as he foresaw, give strength to
the new national government by making all public creditors, men of
substance in their several communities, look to the federal, rather than
the state government, for the satisfaction of their claims.

=Funding at Face Value.=--On the question of the terms of consolidation,
assumption, and funding, Hamilton had a firm conviction. That millions
of dollars' worth of the continental and state bonds had passed out of
the hands of those who had originally subscribed their funds to the
support of the government or had sold supplies for the Revolutionary
army was well known. It was also a matter of common knowledge that a
very large part of these bonds had been bought by speculators at ruinous
figures--ten, twenty, and thirty cents on the dollar. Accordingly, it
had been suggested, even in very respectable quarters, that a
discrimination should be made between original holders and speculative
purchasers. Some who held this opinion urged that the speculators who
had paid nominal sums for their bonds should be reimbursed for their
outlays and the original holders paid the difference; others said that
the government should "scale the debt" by redeeming, not at full value
but at a figure reasonably above the market price. Against the
proposition Hamilton set his face like flint. He maintained that the
government was honestly bound to redeem every bond at its face value,
although the difficulty of securing revenue made necessary a lower rate
of interest on a part of the bonds and the deferring of interest on
another part.

=Funding and Assumption Carried.=--There was little difficulty in
securing the approval of both houses of Congress for the funding of the
national debt at full value. The bill for the assumption of state debts,
however, brought the sharpest division of opinions. To the Southern
members of Congress assumption was a gross violation of states' rights,
without any warrant in the Constitution and devised in the interest of
Northern speculators who, anticipating assumption and funding, had
bought up at low prices the Southern bonds and other promises to pay.
New England, on the other hand, was strongly in favor of assumption;
several representatives from that section were rash enough to threaten a
dissolution of the union if the bill was defeated. To this dispute was
added an equally bitter quarrel over the location of the national
capital, then temporarily at New York City.

[Illustration: FIRST UNITED STATES BANK AT PHILADELPHIA]

A deadlock, accompanied by the most surly feelings on both sides,
threatened the very existence of the young government. Washington and
Hamilton were thoroughly alarmed. Hearing of the extremity to which the
contest had been carried and acting on the appeal from the Secretary of
the Treasury, Jefferson intervened at this point. By skillful management
at a good dinner he brought the opposing leaders together; and thus once
more, as on many other occasions, peace was purchased and the union
saved by compromise. The bargain this time consisted of an exchange of
votes for assumption in return for votes for the capital. Enough
Southern members voted for assumption to pass the bill, and a majority
was mustered in favor of building the capital on the banks of the
Potomac, after locating it for a ten-year period at Philadelphia to
satisfy Pennsylvania members.

=The United States Bank.=--Encouraged by the success of his funding and
assumption measures, Hamilton laid before Congress a project for a great
United States Bank. He proposed that a private corporation be chartered
by Congress, authorized to raise a capital stock of $10,000,000
(three-fourths in new six per cent federal bonds and one-fourth in
specie) and empowered to issue paper currency under proper safeguards.
Many advantages, Hamilton contended, would accrue to the government from
this institution. The price of the government bonds would be increased,
thus enhancing public credit. A national currency would be created of
uniform value from one end of the land to the other. The branches of the
bank in various cities would make easy the exchange of funds so vital to
commercial transactions on a national scale. Finally, through the issue
of bank notes, the money capital available for agriculture and industry
would be increased, thus stimulating business enterprise. Jefferson
hotly attacked the bank on the ground that Congress had no power
whatever under the Constitution to charter such a private corporation.
Hamilton defended it with great cogency. Washington, after weighing all
opinions, decided in favor of the proposal. In 1791 the bill
establishing the first United States Bank for a period of twenty years
became a law.

=The Protective Tariff.=--A third part of Hamilton's program was the
protection of American industries. The first revenue act of 1789, though
designed primarily to bring money into the empty treasury, declared in
favor of the principle. The following year Washington referred to the
subject in his address to Congress. Thereupon Hamilton was instructed to
prepare recommendations for legislative action. The result, after a
delay of more than a year, was his _Report on Manufactures_, another
state paper worthy, in closeness of reasoning and keenness of
understanding, of a place beside his report on public credit. Hamilton
based his argument on the broadest national grounds: the protective
tariff would, by encouraging the building of factories, create a home
market for the produce of farms and plantations; by making the United
States independent of other countries in times of peace, it would double
its security in time of war; by making use of the labor of women and
children, it would turn to the production of goods persons otherwise
idle or only partly employed; by increasing the trade between the North
and South it would strengthen the links of union and add to political
ties those of commerce and intercourse. The revenue measure of 1792 bore
the impress of these arguments.


THE RISE OF POLITICAL PARTIES

=Dissensions over Hamilton's Measures.=--Hamilton's plans, touching
deeply as they did the resources of individuals and the interests of the
states, awakened alarm and opposition. Funding at face value, said his
critics, was a government favor to speculators; the assumption of state
debts was a deep design to undermine the state governments; Congress had
no constitutional power to create a bank; the law creating the bank
merely allowed a private corporation to make paper money and lend it at
a high rate of interest; and the tariff was a tax on land and labor for
the benefit of manufacturers.

Hamilton's reply to this bill of indictment was simple and
straightforward. Some rascally speculators had profited from the funding
of the debt at face value, but that was only an incident in the
restoration of public credit. In view of the jealousies of the states it
was a good thing to reduce their powers and pretensions. The
Constitution was not to be interpreted narrowly but in the full light of
national needs. The bank would enlarge the amount of capital so sorely
needed to start up American industries, giving markets to farmers and
planters. The tariff by creating a home market and increasing
opportunities for employment would benefit both land and labor. Out of
such wise policies firmly pursued by the government, he concluded, were
bound to come strength and prosperity for the new government at home,
credit and power abroad. This view Washington fully indorsed, adding
the weight of his great name to the inherent merits of the measures
adopted under his administration.

=The Sharpness of the Partisan Conflict.=--As a result of the clash of
opinion, the people of the country gradually divided into two parties:
Federalists and Anti-Federalists, the former led by Hamilton, the latter
by Jefferson. The strength of the Federalists lay in the cities--Boston,
Providence, Hartford, New York, Philadelphia, Charleston--among the
manufacturing, financial, and commercial groups of the population who
were eager to extend their business operations. The strength of the
Anti-Federalists lay mainly among the debt-burdened farmers who feared
the growth of what they called "a money power" and planters in all
sections who feared the dominance of commercial and manufacturing
interests. The farming and planting South, outside of the few towns,
finally presented an almost solid front against assumption, the bank,
and the tariff. The conflict between the parties grew steadily in
bitterness, despite the conciliatory and engaging manner in which
Hamilton presented his cause in his state papers and despite the
constant efforts of Washington to soften the asperity of the
contestants.

=The Leadership and Doctrines of Jefferson.=--The party dispute had not
gone far before the opponents of the administration began to look to
Jefferson as their leader. Some of Hamilton's measures he had approved,
declaring afterward that he did not at the time understand their
significance. Others, particularly the bank, he fiercely assailed. More
than once, he and Hamilton, shaking violently with anger, attacked each
other at cabinet meetings, and nothing short of the grave and dignified
pleas of Washington prevented an early and open break between them. In
1794 it finally came. Jefferson resigned as Secretary of State and
retired to his home in Virginia to assume, through correspondence and
negotiation, the leadership of the steadily growing party of opposition.

Shy and modest in manner, halting in speech, disliking the turmoil of
public debate, and deeply interested in science and philosophy,
Jefferson was not very well fitted for the strenuous life of political
contest. Nevertheless, he was an ambitious and shrewd negotiator. He was
also by honest opinion and matured conviction the exact opposite of
Hamilton. The latter believed in a strong, active, "high-toned"
government, vigorously compelling in all its branches. Jefferson looked
upon such government as dangerous to the liberties of citizens and
openly avowed his faith in the desirability of occasional popular
uprisings. Hamilton distrusted the people. "Your people is a great
beast," he is reported to have said. Jefferson professed his faith in
the people with an abandon that was considered reckless in his time.

On economic matters, the opinions of the two leaders were also
hopelessly at variance. Hamilton, while cherishing agriculture, desired
to see America a great commercial and industrial nation. Jefferson was
equally set against this course for his country. He feared the
accumulation of riches and the growth of a large urban working class.
The mobs of great cities, he said, are sores on the body politic;
artisans are usually the dangerous element that make revolutions;
workshops should be kept in Europe and with them the artisans with their
insidious morals and manners. The only substantial foundation for a
republic, Jefferson believed to be agriculture. The spirit of
independence could be kept alive only by free farmers, owning the land
they tilled and looking to the sun in heaven and the labor of their
hands for their sustenance. Trusting as he did in the innate goodness of
human nature when nourished on a free soil, Jefferson advocated those
measures calculated to favor agriculture and to enlarge the rights of
persons rather than the powers of government. Thus he became the
champion of the individual against the interference of the government,
and an ardent advocate of freedom of the press, freedom of speech, and
freedom of scientific inquiry. It was, accordingly, no mere factious
spirit that drove him into opposition to Hamilton.

=The Whisky Rebellion.=--The political agitation of the Anti-Federalists
was accompanied by an armed revolt against the government in 1794. The
occasion for this uprising was another of Hamilton's measures, a law
laying an excise tax on distilled spirits, for the purpose of increasing
the revenue needed to pay the interest on the funded debt. It so
happened that a very considerable part of the whisky manufactured in the
country was made by the farmers, especially on the frontier, in their
own stills. The new revenue law meant that federal officers would now
come into the homes of the people, measure their liquor, and take the
tax out of their pockets. All the bitterness which farmers felt against
the fiscal measures of the government was redoubled. In the western
districts of Pennsylvania, Virginia, and North Carolina, they refused to
pay the tax. In Pennsylvania, some of them sacked and burned the houses
of the tax collectors, as the Revolutionists thirty years before had
mobbed the agents of King George sent over to sell stamps. They were in
a fair way to nullify the law in whole districts when Washington called
out the troops to suppress "the Whisky Rebellion." Then the movement
collapsed; but it left behind a deep-seated resentment which flared up
in the election of several obdurate Anti-Federalist Congressmen from the
disaffected regions.


FOREIGN INFLUENCES AND DOMESTIC POLITICS

=The French Revolution.=--In this exciting period, when all America was
distracted by partisan disputes, a storm broke in Europe--the
epoch-making French Revolution--which not only shook the thrones of the
Old World but stirred to its depths the young republic of the New World.
The first scene in this dramatic affair occurred in the spring of 1789,
a few days after Washington was inaugurated. The king of France, Louis
XVI, driven into bankruptcy by extravagance and costly wars, was forced
to resort to his people for financial help. Accordingly he called, for
the first time in more than one hundred fifty years, a meeting of the
national parliament, the "Estates General," composed of representatives
of the "three estates"--the clergy, nobility, and commoners. Acting
under powerful leaders, the commoners, or "third estate," swept aside
the clergy and nobility and resolved themselves into a national
assembly. This stirred the country to its depths.

[Illustration: _From an old print_

LOUIS XVI IN THE HANDS OF THE MOB]

Great events followed in swift succession. On July 14, 1789, the
Bastille, an old royal prison, symbol of the king's absolutism, was
stormed by a Paris crowd and destroyed. On the night of August 4, the
feudal privileges of the nobility were abolished by the national
assembly amid great excitement. A few days later came the famous
Declaration of the Rights of Man, proclaiming the sovereignty of the
people and the privileges of citizens. In the autumn of 1791, Louis XVI
was forced to accept a new constitution for France vesting the
legislative power in a popular assembly. Little disorder accompanied
these startling changes. To all appearances a peaceful revolution had
stripped the French king of his royal prerogatives and based the
government of his country on the consent of the governed.

=American Influence in France.=--In undertaking their great political
revolt the French had been encouraged by the outcome of the American
Revolution. Officers and soldiers, who had served in the American war,
reported to their French countrymen marvelous tales. At the frugal table
of General Washington, in council with the unpretentious Franklin, or at
conferences over the strategy of war, French noblemen of ancient lineage
learned to respect both the talents and the simple character of the
leaders in the great republican commonwealth beyond the seas. Travelers,
who had gone to see the experiment in republicanism with their own eyes,
carried home to the king and ruling class stories of an astounding
system of popular government.

On the other hand the dalliance with American democracy was regarded by
French conservatives as playing with fire. "When we think of the false
ideas of government and philanthropy," wrote one of Lafayette's aides,
"which these youths acquired in America and propagated in France with so
much enthusiasm and such deplorable success--for this mania of imitation
powerfully aided the Revolution, though it was not the sole cause of
it--we are bound to confess that it would have been better, both for
themselves and for us, if these young philosophers in red-heeled shoes
had stayed at home in attendance on the court."

=Early American Opinion of the French Revolution.=--So close were the
ties between the two nations that it is not surprising to find every
step in the first stages of the French Revolution greeted with applause
in the United States. "Liberty will have another feather in her cap,"
exultantly wrote a Boston editor. "In no part of the globe," soberly
wrote John Marshall, "was this revolution hailed with more joy than in
America.... But one sentiment existed." The main key to the Bastille,
sent to Washington as a memento, was accepted as "a token of the
victory gained by liberty." Thomas Paine saw in the great event "the
first ripe fruits of American principles transplanted into Europe."
Federalists and Anti-Federalists regarded the new constitution of France
as another vindication of American ideals.

=The Reign of Terror.=--While profuse congratulations were being
exchanged, rumors began to come that all was not well in France. Many
noblemen, enraged at the loss of their special privileges, fled into
Germany and plotted an invasion of France to overthrow the new system of
government. Louis XVI entered into negotiations with his brother
monarchs on the continent to secure their help in the same enterprise,
and he finally betrayed to the French people his true sentiments by
attempting to escape from his kingdom, only to be captured and taken
back to Paris in disgrace.

A new phase of the revolution now opened. The working people, excluded
from all share in the government by the first French constitution,
became restless, especially in Paris. Assembling on the Champs de Mars,
a great open field, they signed a petition calling for another
constitution giving them the suffrage. When told to disperse, they
refused and were fired upon by the national guard. This "massacre," as
it was called, enraged the populace. A radical party, known as
"Jacobins," then sprang up, taking its name from a Jacobin monastery in
which it held its sessions. In a little while it became the master of
the popular convention convoked in September, 1792. The monarchy was
immediately abolished and a republic established. On January 21, 1793,
Louis was sent to the scaffold. To the war on Austria, already raging,
was added a war on England. Then came the Reign of Terror, during which
radicals in possession of the convention executed in large numbers
counter-revolutionists and those suspected of sympathy with the
monarchy. They shot down peasants who rose in insurrection against their
rule and established a relentless dictatorship. Civil war followed.
Terrible atrocities were committed on both sides in the name of liberty,
and in the name of monarchy. To Americans of conservative temper it now
seemed that the Revolution, so auspiciously begun, had degenerated into
anarchy and mere bloodthirsty strife.

=Burke Summons the World to War on France.=--In England, Edmund Burke
led the fight against the new French principles which he feared might
spread to all Europe. In his _Reflections on the French Revolution_,
written in 1790, he attacked with terrible wrath the whole program of
popular government; he called for war, relentless war, upon the French
as monsters and outlaws; he demanded that they be reduced to order by
the restoration of the king to full power under the protection of the
arms of European nations.

=Paine's Defense of the French Revolution.=--To counteract the campaign
of hate against the French, Thomas Paine replied to Burke in another of
his famous tracts, _The Rights of Man_, which was given to the American
public in an edition containing a letter of approval from Jefferson.
Burke, said Paine, had been mourning about the glories of the French
monarchy and aristocracy but had forgotten the starving peasants and the
oppressed people; had wept over the plumage and neglected the dying
bird. Burke had denied the right of the French people to choose their
own governors, blandly forgetting that the English government in which
he saw final perfection itself rested on two revolutions. He had boasted
that the king of England held his crown in contempt of the democratic
societies. Paine answered: "If I ask a man in America if he wants a
king, he retorts and asks me if I take him for an idiot." To the charge
that the doctrines of the rights of man were "new fangled," Paine
replied that the question was not whether they were new or old but
whether they were right or wrong. As to the French disorders and
difficulties, he bade the world wait to see what would be brought forth
in due time.

=The Effect of the French Revolution on American Politics.=--The course
of the French Revolution and the controversies accompanying it,
exercised a profound influence on the formation of the first political
parties in America. The followers of Hamilton, now proud of the name
"Federalists," drew back in fright as they heard of the cruel deeds
committed during the Reign of Terror. They turned savagely upon the
revolutionists and their friends in America, denouncing as "Jacobin"
everybody who did not condemn loudly enough the proceedings of the
French Republic. A Massachusetts preacher roundly assailed "the
atheistical, anarchical, and in other respects immoral principles of the
French Republicans"; he then proceeded with equal passion to attack
Jefferson and the Anti-Federalists, whom he charged with spreading false
French propaganda and betraying America. "The editors, patrons, and
abettors of these vehicles of slander," he exclaimed, "ought to be
considered and treated as enemies to their country.... Of all traitors
they are the most aggravatedly criminal; of all villains, they are the
most infamous and detestable."

The Anti-Federalists, as a matter of fact, were generally favorable to
the Revolution although they deplored many of the events associated with
it. Paine's pamphlet, indorsed by Jefferson, was widely read. Democratic
societies, after the fashion of French political clubs, arose in the
cities; the coalition of European monarchs against France was denounced
as a coalition against the very principles of republicanism; and the
execution of Louis XVI was openly celebrated at a banquet in
Philadelphia. Harmless titles, such as "Sir," "the Honorable," and "His
Excellency," were decried as aristocratic and some of the more excited
insisted on adopting the French title, "Citizen," speaking, for example,
of "Citizen Judge" and "Citizen Toastmaster." Pamphlets in defense of
the French streamed from the press, while subsidized newspapers kept the
propaganda in full swing.

=The European War Disturbs American Commerce.=--This battle of wits, or
rather contest in calumny, might have gone on indefinitely in America
without producing any serious results, had it not been for the war
between England and France, then raging. The English, having command of
the seas, claimed the right to seize American produce bound for French
ports and to confiscate American ships engaged in carrying French goods.
Adding fuel to a fire already hot enough, they began to search American
ships and to carry off British-born sailors found on board American
vessels.

=The French Appeal for Help.=--At the same time the French Republic
turned to the United States for aid in its war on England and sent over
as its diplomatic representative "Citizen" Genet, an ardent supporter of
the new order. On his arrival at Charleston, he was greeted with fervor
by the Anti-Federalists. As he made his way North, he was wined and
dined and given popular ovations that turned his head. He thought the
whole country was ready to join the French Republic in its contest with
England. Genet therefore attempted to use the American ports as the base
of operations for French privateers preying on British merchant ships;
and he insisted that the United States was in honor bound to help France
under the treaty of 1778.

=The Proclamation of Neutrality and the Jay Treaty.=--Unmoved by the

rising tide of popular sympathy for France, Washington took a firm
course. He received Genet coldly. The demand that the United States aid
France under the old treaty of alliance he answered by proclaiming the
neutrality of America and warning American citizens against hostile acts
toward either France or England. When Genet continued to hold meetings,
issue manifestoes, and stir up the people against England, Washington
asked the French government to recall him. This act he followed up by
sending the Chief Justice, John Jay, on a pacific mission to England.

The result was the celebrated Jay treaty of 1794. By its terms Great
Britain agreed to withdraw her troops from the western forts where they
had been since the war for independence and to grant certain slight
trade concessions. The chief sources of bitterness--the failure of the
British to return slaves carried off during the Revolution, the seizure
of American ships, and the impressment of sailors--were not touched,
much to the distress of everybody in America, including loyal
Federalists. Nevertheless, Washington, dreading an armed conflict with
England, urged the Senate to ratify the treaty. The weight of his
influence carried the day.

At this, the hostility of the Anti-Federalists knew no bounds. Jefferson
declared the Jay treaty "an infamous act which is really nothing more
than an alliance between England and the Anglo-men of this country,
against the legislature and the people of the United States." Hamilton,
defending it with his usual courage, was stoned by a mob in New York and
driven from the platform with blood streaming from his face. Jay was
burned in effigy. Even Washington was not spared. The House of
Representatives was openly hostile. To display its feelings, it called
upon the President for the papers relative to the treaty negotiations,
only to be more highly incensed by his flat refusal to present them, on
the ground that the House did not share in the treaty-making power.

=Washington Retires from Politics.=--Such angry contests confirmed the
President in his slowly maturing determination to retire at the end of
his second term in office. He did not believe that a third term was
unconstitutional or improper; but, worn out by his long and arduous
labors in war and in peace and wounded by harsh attacks from former
friends, he longed for the quiet of his beautiful estate at Mount
Vernon.

In September, 1796, on the eve of the presidential election, Washington
issued his Farewell Address, another state paper to be treasured and
read by generations of Americans to come. In this address he directed
the attention of the people to three subjects of lasting interest. He
warned them against sectional jealousies. He remonstrated against the
spirit of partisanship, saying that in government "of the popular
character, in government purely elective, it is a spirit not to be
encouraged." He likewise cautioned the people against "the insidious
wiles of foreign influence," saying: "Europe has a set of primary
interests which to us have none or a very remote relation. Hence she
must be engaged in frequent controversies, the causes of which are
essentially foreign to our concerns. Hence, therefore, it would be
unwise in us to implicate ourselves, by artificial ties, in the ordinary
vicissitudes of her politics or the ordinary combinations and collisions
of her friendships or enmities.... Why forego the advantages of so
peculiar a situation?... It is our true policy to steer clear of
permanent alliances with any portion of the foreign world.... Taking
care always to keep ourselves, by suitable establishments, on a
respectable defensive posture, we may safely trust to temporary
alliances for extraordinary emergencies."

=The Campaign of 1796--Adams Elected.=--On hearing of the retirement of
Washington, the Anti-Federalists cast off all restraints. In honor of
France and in opposition to what they were pleased to call the
monarchical tendencies of the Federalists, they boldly assumed the name
"Republican"; the term "Democrat," then applied only to obscure and
despised radicals, had not come into general use. They selected
Jefferson as their candidate for President against John Adams, the
Federalist nominee, and carried on such a spirited campaign that they
came within four votes of electing him.

The successful candidate, Adams, was not fitted by training or opinion
for conciliating a determined opposition. He was a reserved and studious
man. He was neither a good speaker nor a skillful negotiator. In one of
his books he had declared himself in favor of "government by an
aristocracy of talents and wealth"--an offense which the Republicans
never forgave. While John Marshall found him "a sensible, plain, candid,
good-tempered man," Jefferson could see in him nothing but a "monocrat"
and "Anglo-man." Had it not been for the conduct of the French
government, Adams would hardly have enjoyed a moment's genuine
popularity during his administration.

=The Quarrel with France.=--The French Directory, the executive
department established under the constitution of 1795, managed, however,
to stir the anger of Republicans and Federalists alike. It regarded the
Jay treaty as a rebuke to France and a flagrant violation of obligations
solemnly registered in the treaty of 1778. Accordingly it refused to
receive the American minister, treated him in a humiliating way, and
finally told him to leave the country. Overlooking this affront in his
anxiety to maintain peace, Adams dispatched to France a commission of
eminent men with instructions to reach an understanding with the French
Republic. On their arrival, they were chagrined to find, instead of a
decent reception, an indirect demand for an apology respecting the past
conduct of the American government, a payment in cash, and an annual
tribute as the price of continued friendship. When the news of this
affair reached President Adams, he promptly laid it before Congress,
referring to the Frenchmen who had made the demands as "Mr. X, Mr. Y,
and Mr. Z."

This insult, coupled with the fact that French privateers, like the
British, were preying upon American commerce, enraged even the
Republicans who had been loudest in the profession of their French
sympathies. They forgot their wrath over the Jay treaty and joined with
the Federalists in shouting: "Millions for defense, not a cent for
tribute!" Preparations for war were made on every hand. Washington was
once more called from Mount Vernon to take his old position at the head
of the army. Indeed, fighting actually began upon the high seas and went
on without a formal declaration of war until the year 1800. By that time
the Directory had been overthrown. A treaty was readily made with
Napoleon, the First Consul, who was beginning his remarkable career as
chief of the French Republic, soon to be turned into an empire.

=Alien and Sedition Laws.=--Flushed with success, the Federalists
determined, if possible, to put an end to radical French influence in
America and to silence Republican opposition. They therefore passed two
drastic laws in the summer of 1798: the Alien and Sedition Acts.

The first of these measures empowered the President to expel from the
country or to imprison any alien whom he regarded as "dangerous" or "had
reasonable grounds to suspect" of "any treasonable or secret
machinations against the government."

The second of the measures, the Sedition Act, penalized not only those
who attempted to stir up unlawful combinations against the government
but also every one who wrote, uttered, or published "any false,
scandalous, and malicious writing ... against the government of the
United States or either House of Congress, or the President of the
United States, with intent to defame said government ... or to bring
them or either of them into contempt or disrepute." This measure was
hurried through Congress in spite of the opposition and the clear
provision in the Constitution that Congress shall make no law abridging
the freedom of speech or of the press. Even many Federalists feared the
consequences of the action. Hamilton was alarmed when he read the bill,
exclaiming: "Let us not establish a tyranny. Energy is a very different
thing from violence." John Marshall told his friends in Virginia that,
had he been in Congress, he would have opposed the two bills because he
thought them "useless" and "calculated to create unnecessary discontents
and jealousies."

The Alien law was not enforced; but it gave great offense to the Irish
and French whose activities against the American government's policy
respecting Great Britain put them in danger of prison. The Sedition law,
on the other hand, was vigorously applied. Several editors of Republican
newspapers soon found themselves in jail or broken by ruinous fines for
their caustic criticisms of the Federalist President and his policies.
Bystanders at political meetings, who uttered sentiments which, though
ungenerous and severe, seem harmless enough now, were hurried before
Federalist judges and promptly fined and imprisoned. Although the
prosecutions were not numerous, they aroused a keen resentment. The
Republicans were convinced that their political opponents, having
saddled upon the country Hamilton's fiscal system and the British
treaty, were bent on silencing all censure. The measures therefore had
exactly the opposite effect from that which their authors intended.
Instead of helping the Federalist party, they made criticism of it more
bitter than ever.

=The Kentucky and Virginia Resolutions.=--Jefferson was quick to take
advantage of the discontent. He drafted a set of resolutions declaring
the Sedition law null and void, as violating the federal Constitution.
His resolutions were passed by the Kentucky legislature late in 1798,
signed by the governor, and transmitted to the other states for their
consideration. Though receiving unfavorable replies from a number of
Northern states, Kentucky the following year reaffirmed its position and
declared that the nullification of all unconstitutional acts of Congress
was the rightful remedy to be used by the states in the redress of
grievances. It thus defied the federal government and announced a
doctrine hostile to nationality and fraught with terrible meaning for
the future. In the neighboring state of Virginia, Madison led a movement
against the Alien and Sedition laws. He induced the legislature to pass
resolutions condemning the acts as unconstitutional and calling upon the
other states to take proper means to preserve their rights and the
rights of the people.

=The Republican Triumph in 1800.=--Thus the way was prepared for the
election of 1800. The Republicans left no stone unturned in their
efforts to place on the Federalist candidate, President Adams, all the
odium of the Alien and Sedition laws, in addition to responsibility for
approving Hamilton's measures and policies. The Federalists, divided in
councils and cold in their affection for Adams, made a poor campaign.
They tried to discredit their opponents with epithets of "Jacobins" and
"Anarchists"--terms which had been weakened by excessive use. When the
vote was counted, it was found that Adams had been defeated; while the
Republicans had carried the entire South and New York also and secured
eight of the fifteen electoral votes cast by Pennsylvania. "Our beloved
Adams will now close his bright career," lamented a Federalist
newspaper. "Sons of faction, demagogues and high priests of anarchy, now
you have cause to triumph!"

[Illustration: _An old cartoon_

A QUARREL BETWEEN A FEDERALIST AND A REPUBLICAN IN THE HOUSE OF
REPRESENTATIVES]

Jefferson's election, however, was still uncertain. By a curious
provision in the Constitution, presidential electors were required to
vote for two persons without indicating which office each was to fill,
the one receiving the highest number of votes to be President and the
candidate standing next to be Vice President. It so happened that Aaron
Burr, the Republican candidate for Vice President, had received the same
number of votes as Jefferson; as neither had a majority the election was
thrown into the House of Representatives, where the Federalists held the
balance of power. Although it was well known that Burr was not even a
candidate for President, his friends and many Federalists began
intriguing for his election to that high office. Had it not been for the
vigorous action of Hamilton the prize might have been snatched out of
Jefferson's hands. Not until the thirty-sixth ballot on February 17,
1801, was the great issue decided in his favor.[2]


=References=

J.S. Bassett, _The Federalist System_ (American Nation Series).

C.A. Beard, _Economic Origins of Jeffersonian Democracy_.

H. Lodge, _Alexander Hamilton_.

J.T. Morse, _Thomas Jefferson_.


=Questions=

1. Who were the leaders in the first administration under the
Constitution?

2. What step was taken to appease the opposition?

3. Enumerate Hamilton's great measures and explain each in detail.

4. Show the connection between the parts of Hamilton's system.

5. Contrast the general political views of Hamilton and Jefferson.

6. What were the important results of the "peaceful" French Revolution
(1789-92)?

7. Explain the interaction of opinion between France and the United
States.

8. How did the "Reign of Terror" change American opinion?

9. What was the Burke-Paine controversy?

10. Show how the war in Europe affected American commerce and involved
America with England and France.

11. What were American policies with regard to each of those countries?

12. What was the outcome of the Alien and Sedition Acts?


=Research Topics=

=Early Federal Legislation.=--Coman, _Industrial History of the United
States_, pp. 133-156; Elson, _History of the United States_, pp.
341-348.

=Hamilton's Report on Public Credit.=--Macdonald, _Documentary Source
Book_, pp. 233-243.

=The French Revolution.=--Robinson and Beard, _Development of Modern
Europe_, Vol. I, pp. 224-282; Elson, pp. 351-354.

=The Burke-Paine Controversy.=--Make an analysis of Burke's _Reflections
on the French Revolution_ and Paine's _Rights of Man_.

=The Alien and Sedition Acts.=--Macdonald, _Documentary Source Book_,
pp. 259-267; Elson, pp. 367-375.

=Kentucky and Virginia Resolutions.=--Macdonald, pp. 267-278.

=Source Studies.=--Materials in Hart, _American History Told by
Contemporaries_, Vol. III, pp. 255-343.

=Biographical Studies.=--Alexander Hamilton, John Adams, Thomas
Jefferson, and Albert Gallatin.

=The Twelfth Amendment.=--Contrast the provision in the original
Constitution with the terms of the Amendment. _See_ Appendix.

FOOTNOTES:

[1] North Carolina ratified in November, 1789, and Rhode Island in May,
1790.

[2] To prevent a repetition of such an unfortunate affair, the twelfth
amendment of the Constitution was adopted in 1804, changing slightly the
method of electing the President.




CHAPTER IX

THE JEFFERSONIAN REPUBLICANS IN POWER


REPUBLICAN PRINCIPLES AND POLICIES

=Opposition to Strong Central Government.=--Cherishing especially the
agricultural interest, as Jefferson said, the Republicans were in the
beginning provincial in their concern and outlook. Their attachment to
America was, certainly, as strong as that of Hamilton; but they regarded
the state, rather than the national government, as the proper center of
power and affection. Indeed, a large part of the rank and file had been
among the opponents of the Constitution in the days of its adoption.
Jefferson had entertained doubts about it and Monroe, destined to be the
fifth President, had been one of the bitter foes of ratification. The
former went so far in the direction of local autonomy that he exalted
the state above the nation in the Kentucky resolutions of 1798,
declaring the Constitution to be a mere compact and the states competent
to interpret and nullify federal law. This was provincialism with a
vengeance. "It is jealousy, not confidence, which prescribes limited
constitutions," wrote Jefferson for the Kentucky legislature. Jealousy
of the national government, not confidence in it--this is the ideal that
reflected the provincial and agricultural interest.

=Republican Simplicity.=--Every act of the Jeffersonian party during its
early days of power was in accord with the ideals of government which it
professed. It had opposed all pomp and ceremony, calculated to give
weight and dignity to the chief executive of the nation, as symbols of
monarchy and high prerogative. Appropriately, therefore, Jefferson's
inauguration on March 4, 1801, the first at the new capital at
Washington, was marked by extreme simplicity. In keeping with this
procedure he quit the practice, followed by Washington and Adams, of
reading presidential addresses to Congress in joint assembly and adopted
in its stead the plan of sending his messages in writing--a custom that
was continued unbroken until 1913 when President Wilson returned to the
example set by the first chief magistrate.

=Republican Measures.=--The Republicans had complained of a great
national debt as the source of a dangerous "money power," giving
strength to the federal government; accordingly they began to pay it off
as rapidly as possible. They had held commerce in low esteem and looked
upon a large navy as a mere device to protect it; consequently they
reduced the number of warships. They had objected to excise taxes,
particularly on whisky; these they quickly abolished, to the intense
satisfaction of the farmers. They had protested against the heavy cost
of the federal government; they reduced expenses by discharging hundreds
of men from the army and abolishing many offices.

They had savagely criticized the Sedition law and Jefferson refused to
enforce it. They had been deeply offended by the assault on freedom of
speech and press and they promptly impeached Samuel Chase, a justice of
the Supreme Court, who had been especially severe in his attacks upon
offenders under the Sedition Act. Their failure to convict Justice Chase
by a narrow margin was due to no lack of zeal on their part but to the
Federalist strength in the Senate where the trial was held. They had
regarded the appointment of a large number of federal judges during the
last hours of Adams' administration as an attempt to intrench
Federalists in the judiciary and to enlarge the sphere of the national
government. Accordingly, they at once repealed the act creating the new
judgeships, thus depriving the "midnight appointees" of their posts.
They had considered the federal offices, civil and military, as sources
of great strength to the Federalists and Jefferson, though committed to
the principle that offices should be open to all and distributed
according to merit, was careful to fill most of the vacancies as they
occurred with trusted Republicans. To his credit, however, it must be
said that he did not make wholesale removals to find room for party
workers.

The Republicans thus hewed to the line of their general policy of
restricting the weight, dignity, and activity of the national
government. Yet there were no Republicans, as the Federalists asserted,
prepared to urge serious modifications in the Constitution. "If there be
any among us who wish to dissolve this union or to change its republican
form," wrote Jefferson in his first inaugural, "let them stand
undisturbed as monuments of the safety with which error of opinion may
be tolerated where reason is left free to combat it." After reciting the
fortunate circumstances of climate, soil, and isolation which made the
future of America so full of promise, Jefferson concluded: "A wise and
frugal government which shall restrain men from injuring one another,
shall leave them otherwise free to regulate their own pursuits of
industry and improvement and shall not take from the mouth of labour the
bread it has earned. This is the sum of good government; and this is
necessary to close the circle of our felicities."

In all this the Republicans had not reckoned with destiny. In a few
short years that lay ahead it was their fate to double the territory of
the country, making inevitable a continental nation; to give the
Constitution a generous interpretation that shocked many a Federalist;
to wage war on behalf of American commerce; to reestablish the hated
United States Bank; to enact a high protective tariff; to see their
Federalist opponents in their turn discredited as nullifiers and
provincials; to announce high national doctrines in foreign affairs; and
to behold the Constitution exalted and defended against the pretensions
of states by a son of old Virginia, John Marshall, Chief Justice of the
Supreme Court of the United States.


THE REPUBLICANS AND THE GREAT WEST

=Expansion and Land Hunger.=--The first of the great measures which
drove the Republicans out upon this new national course--the purchase
of the Louisiana territory--was the product of circumstances rather than
of their deliberate choosing. It was not the lack of land for his
cherished farmers that led Jefferson to add such an immense domain to
the original possessions of the United States. In the Northwest
territory, now embracing Ohio, Indiana, Illinois, Michigan, Wisconsin,
and a portion of Minnesota, settlements were mainly confined to the
north bank of the Ohio River. To the south, in Kentucky and Tennessee,
where there were more than one hundred thousand white people who had
pushed over the mountains from Virginia and the Carolinas, there were
still wide reaches of untilled soil. The Alabama and Mississippi regions
were vast Indian frontiers of the state of Georgia, unsettled and almost
unexplored. Even to the wildest imagination there seemed to be territory
enough to satisfy the land hunger of the American people for a century
to come.

=The Significance of the Mississippi River.=--At all events the East,
then the center of power, saw no good reason for expansion. The planters
of the Carolinas, the manufacturers of Pennsylvania, the importers of
New York, the shipbuilders of New England, looking to the seaboard and
to Europe for trade, refinements, and sometimes their ideas of
government, were slow to appreciate the place of the West in national
economy. The better educated the Easterners were, the less, it seems,
they comprehended the destiny of the nation. Sons of Federalist fathers
at Williams College, after a long debate decided by a vote of fifteen to
one that the purchase of Louisiana was undesirable.

On the other hand, the pioneers of Kentucky, Ohio, and Tennessee,
unlearned in books, saw with their own eyes the resources of the
wilderness. Many of them had been across the Mississippi and had beheld
the rich lands awaiting the plow of the white man. Down the great river
they floated their wheat, corn, and bacon to ocean-going ships bound for
the ports of the seaboard or for Europe. The land journeys over the
mountain barriers with bulky farm produce, they knew from experience,
were almost impossible, and costly at best. Nails, bolts of cloth, tea,
and coffee could go or come that way, but not corn and bacon. A free
outlet to the sea by the Mississippi was as essential to the pioneers of
the Kentucky region as the harbor of Boston to the merchant princes of
that metropolis.

=Louisiana under Spanish Rule.=--For this reason they watched with deep
solicitude the fortunes of the Spanish king to whom, at the close of the
Seven Years' War, had fallen the Louisiana territory stretching from New
Orleans to the Rocky Mountains. While he controlled the mouth of the
Mississippi there was little to fear, for he had neither the army nor
the navy necessary to resist any invasion of American trade. Moreover,
Washington had been able, by the exercise of great tact, to secure from
Spain in 1795 a trading privilege through New Orleans which satisfied
the present requirements of the frontiersmen even if it did not allay
their fears for the future. So things stood when a swift succession of
events altered the whole situation.

=Louisiana Transferred to France.=--In July, 1802, a royal order from
Spain instructed the officials at New Orleans to close the port to
American produce. About the same time a disturbing rumor, long current,
was confirmed--Napoleon had coerced Spain into returning Louisiana to
France by a secret treaty signed in 1800. "The scalers of the Alps and
conquerors of Venice" now looked across the sea for new scenes of
adventure. The West was ablaze with excitement. A call for war ran
through the frontier; expeditions were organized to prevent the landing
of the French; and petitions for instant action flooded in upon
Jefferson.

=Jefferson Sees the Danger.=--Jefferson, the friend of France and sworn
enemy of England, compelled to choose in the interest of America, never
winced. "The cession of Louisiana and the Floridas by Spain to France,"
he wrote to Livingston, the American minister in Paris, "works sorely on
the United States. It completely reverses all the political relations of
the United States and will form a new epoch in our political course....
There is on the globe one single spot, the possessor of which is our
natural and habitual enemy. It is New Orleans through which the produce
of three-eighths of our territory must pass to market.... France,
placing herself in that door, assumes to us an attitude of defiance.
Spain might have retained it quietly for years. Her pacific
dispositions, her feeble state would induce her to increase our
facilities there.... Not so can it ever be in the hands of France....
The day that France takes possession of New Orleans fixes the sentence
which is to restrain her forever within her low water mark.... It seals
the union of the two nations who in conjunction can maintain exclusive
possession of the ocean. From that moment we must marry ourselves to the
British fleet and nation.... This is not a state of things we seek or
desire. It is one which this measure, if adopted by France, forces on us
as necessarily as any other cause by the laws of nature brings on its
necessary effect."

=Louisiana Purchased.=--Acting on this belief, but apparently seeing
only the Mississippi outlet at stake, Jefferson sent his friend, James
Monroe, to France with the power to buy New Orleans and West Florida.
Before Monroe arrived, the regular minister, Livingston, had already
convinced Napoleon that it would be well to sell territory which might
be wrested from him at any moment by the British sea power, especially
as the war, temporarily stopped by the peace of Amiens, was once more
raging in Europe. Wise as he was in his day, Livingston had at first no
thought of buying the whole Louisiana country. He was simply dazed when
Napoleon offered to sell the entire domain and get rid of the business
altogether. Though staggered by the proposal, he and Monroe decided to
accept. On April 30, they signed the treaty of cession, agreeing to pay
$11,250,000 in six per cent bonds and to discharge certain debts due
French citizens, making in all approximately fifteen millions. Spain
protested, Napoleon's brother fumed, French newspapers objected; but the
deed was done.

=Jefferson and His Constitutional Scruples.=--When the news of this
extraordinary event reached the United States, the people were filled
with astonishment, and no one was more surprised than Jefferson himself.
He had thought of buying New Orleans and West Florida for a small sum,
and now a vast domain had been dumped into the lap of the nation. He was
puzzled. On looking into the Constitution he found not a line
authorizing the purchase of more territory and so he drafted an
amendment declaring "Louisiana, as ceded by France,--a part of the
United States." He had belabored the Federalists for piling up a big
national debt and he could hardly endure the thought of issuing more
bonds himself.

In the midst of his doubts came the news that Napoleon might withdraw
from the bargain. Thoroughly alarmed by that, Jefferson pressed the
Senate for a ratification of the treaty. He still clung to his original
idea that the Constitution did not warrant the purchase; but he lamely
concluded: "If our friends shall think differently, I shall certainly
acquiesce with satisfaction; confident that the good sense of our
country will correct the evil of construction when it shall produce ill
effects." Thus the stanch advocate of "strict interpretation" cut loose
from his own doctrine and intrusted the construction of the Constitution
to "the good sense" of his countrymen.

=The Treaty Ratified.=--This unusual transaction, so favorable to the
West, aroused the ire of the seaboard Federalists. Some denounced it as
unconstitutional, easily forgetting Hamilton's masterly defense of the
bank, also not mentioned in the Constitution. Others urged that, if "the
howling wilderness" ever should be settled, it would turn against the
East, form new commercial connections, and escape from federal control.
Still others protested that the purchase would lead inevitably to the
dominance of a "hotch potch of wild men from the Far West." Federalists,
who thought "the broad back of America" could readily bear Hamilton's
consolidated debt, now went into agonies over a bond issue of less than
one-sixth of that amount. But in vain. Jefferson's party with a high
hand carried the day. The Senate, after hearing the Federalist protest,
ratified the treaty. In December, 1803, the French flag was hauled down
from the old government buildings in New Orleans and the Stars and
Stripes were hoisted as a sign that the land of Coronado, De Soto,
Marquette, and La Salle had passed forever to the United States.

[Illustration: THE UNITED STATES IN 1805]

By a single stroke, the original territory of the United States was more
than doubled. While the boundaries of the purchase were uncertain, it is
safe to say that the Louisiana territory included what is now Arkansas,
Missouri, Iowa, Oklahoma, Kansas, Nebraska, South Dakota, and large
portions of Louisiana, Minnesota, North Dakota, Colorado, Montana, and
Wyoming. The farm lands that the friends of "a little America" on the
seacoast declared a hopeless wilderness were, within a hundred years,
fully occupied and valued at nearly seven billion dollars--almost five
hundred times the price paid to Napoleon.

=Western Explorations.=--Having taken the fateful step, Jefferson wisely
began to make the most of it. He prepared for the opening of the new
country by sending the Lewis and Clark expedition to explore it,
discover its resources, and lay out an overland route through the
Missouri Valley and across the Great Divide to the Pacific. The story of
this mighty exploit, which began in the spring of 1804 and ended in the
autumn of 1806, was set down with skill and pains in the journal of
Lewis and Clark; when published even in a short form, it invited the
forward-looking men of the East to take thought about the western
empire. At the same time Zebulon Pike, in a series of journeys, explored
the sources of the Mississippi River and penetrated the Spanish
territories of the far Southwest. Thus scouts and pioneers continued the
work of diplomats.


THE REPUBLICAN WAR FOR COMMERCIAL INDEPENDENCE

=The English and French Blockades.=--In addition to bringing Louisiana
to the United States, the reopening of the European War in 1803, after a
short lull, renewed in an acute form the commercial difficulties that
had plagued the country all during the administrations of Washington and
Adams. The Republicans were now plunged into the hornets' nest. The
party whose ardent spirits had burned Jay in effigy, stoned Hamilton for
defending his treaty, jeered Washington's proclamation of neutrality,
and spoken bitterly of "timid traders," could no longer take refuge in
criticism. It had to act.

Its troubles took a serious turn in 1806. England, in a determined
effort to bring France to her knees by starvation, declared the coast of
Europe blockaded from Brest to the mouth of the Elbe River. Napoleon
retaliated by his Berlin Decree of November, 1806, blockading the
British Isles--a measure terrifying to American ship owners whose
vessels were liable to seizure by any French rover, though Napoleon had
no navy to make good his proclamation. Great Britain countered with a
still more irritating decree--the Orders in Council of 1807. It modified
its blockade, but in so doing merely authorized American ships not
carrying munitions of war to complete their voyage to the Continent, on
condition of their stopping at a British port, securing a license, and
paying a tax. This, responded Napoleon, was the height of insolence, and
he denounced it as a gross violation of international law. He then
closed the circle of American troubles by issuing his Milan Decree of
December, 1807. This order declared that any ship which complied with
the British rules would be subject to seizure and confiscation by French
authorities.

=The Impressment of Seamen.=--That was not all. Great Britain, in dire
need of men for her navy, adopted the practice of stopping American
ships, searching them, and carrying away British-born sailors found on
board. British sailors were so badly treated, so cruelly flogged for
trivial causes, and so meanly fed that they fled in crowds to the
American marine. In many cases it was difficult to tell whether seamen
were English or American. They spoke the same language, so that language
was no test. Rovers on the deep and stragglers in the ports of both
countries, they frequently had no papers to show their nativity.
Moreover, Great Britain held to the old rule--"Once an Englishman,
always an Englishman"--a doctrine rejected by the United States in
favor of the principle that a man could choose the nation to which he
would give allegiance. British sea captains, sometimes by mistake, and
often enough with reckless indifference, carried away into servitude in
their own navy genuine American citizens. The process itself, even when
executed with all the civilities of law, was painful enough, for it
meant that American ships were forced to "come to," and compelled to
rest submissively under British guns until the searching party had pried
into records, questioned seamen, seized and handcuffed victims. Saints
could not have done this work without raising angry passions, and only
saints could have endured it with patience and fortitude.

Had the enactment of the scenes been confined to the high seas and
knowledge of them to rumors and newspaper stories, American resentment
might not have been so intense; but many a search and seizure was made
in sight of land. British and French vessels patrolled the coasts,
firing on one another and chasing one another in American waters within
the three-mile limit. When, in the summer of 1807, the American frigate
_Chesapeake_ refused to surrender men alleged to be deserters from King
George's navy, the British warship _Leopard_ opened fire, killing three
men and wounding eighteen more--an act which even the British ministry
could hardly excuse. If the French were less frequently the offenders,
it was not because of their tenderness about American rights but because
so few of their ships escaped the hawk-eyed British navy to operate in
American waters.

=The Losses in American Commerce.=--This high-handed conduct on the part
of European belligerents was very injurious to American trade. By their
enterprise, American shippers had become the foremost carriers on the
Atlantic Ocean. In a decade they had doubled the tonnage of American
merchant ships under the American flag, taking the place of the French
marine when Britain swept that from the seas, and supplying Britain with
the sinews of war for the contest with the Napoleonic empire. The
American shipping engaged in foreign trade embraced 363,110 tons in
1791; 669,921 tons in 1800; and almost 1,000,000 tons in 1810. Such was
the enterprise attacked by the British and French decrees. American
ships bound for Great Britain were liable to be captured by French
privateers which, in spite of the disasters of the Nile and Trafalgar,
ranged the seas. American ships destined for the Continent, if they
failed to stop at British ports and pay tribute, were in great danger of
capture by the sleepless British navy and its swarm of auxiliaries.
American sea captains who, in fear of British vengeance, heeded the
Orders in Council and paid the tax were almost certain to fall a prey to
French vengeance, for the French were vigorous in executing the Milan
Decree.

=Jefferson's Policy.=--The President's dilemma was distressing. Both the
belligerents in Europe were guilty of depredations on American commerce.
War on both of them was out of the question. War on France was
impossible because she had no territory on this side of the water which
could be reached by American troops and her naval forces had been
shattered at the battles of the Nile and Trafalgar. War on Great
Britain, a power which Jefferson's followers feared and distrusted, was
possible but not inviting. Jefferson shrank from it. A man of peace, he
disliked war's brazen clamor; a man of kindly spirit, he was startled at
the death and destruction which it brought in its train. So for the
eight years Jefferson steered an even course, suggesting measure after
measure with a view to avoiding bloodshed. He sent, it is true,
Commodore Preble in 1803 to punish Mediterranean pirates preying upon
American commerce; but a great war he evaded with passionate
earnestness, trying in its place every other expedient to protect
American rights.

=The Embargo and Non-intercourse Acts.=--In 1806, Congress passed and
Jefferson approved a non-importation act closing American ports to
certain products from British dominions--a measure intended as a club
over the British government's head. This law, failing in its purpose,
Jefferson proposed and Congress adopted in December, 1807, the Embargo
Act forbidding all vessels to leave American harbors for foreign ports.
France and England were to be brought to terms by cutting off their
supplies.

The result of the embargo was pathetic. England and France refused to
give up search and seizure. American ship owners who, lured by huge
profits, had formerly been willing to take the risk were now restrained
by law to their home ports. Every section suffered. The South and West
found their markets for cotton, rice, tobacco, corn, and bacon
curtailed. Thus they learned by bitter experience the national
significance of commerce. Ship masters, ship builders, longshoremen, and
sailors were thrown out of employment while the prices of foreign goods
doubled. Those who obeyed the law were ruined; violators of the law
smuggled goods into Canada and Florida for shipment abroad.

Jefferson's friends accepted the medicine with a wry face as the only
alternative to supine submission or open war. His opponents, without
offering any solution of their own, denounced it as a contemptible plan
that brought neither relief nor honor. Beset by the clamor that arose on
all sides, Congress, in the closing days of Jefferson's administration,
repealed the Embargo law and substituted a Non-intercourse act
forbidding trade with England and France while permitting it with other
countries--a measure equally futile in staying the depredations on
American shipping.

=Jefferson Retires in Favor of Madison.=--Jefferson, exhausted by
endless wrangling and wounded, as Washington had been, by savage
criticism, welcomed March 4, 1809. His friends urged him to "stay by the
ship" and accept a third term. He declined, saying that election for
life might result from repeated reelection. In following Washington's
course and defending it on principle, he set an example to all his
successors, making the "third term doctrine" a part of American
unwritten law.

His intimate friend, James Madison, to whom he turned over the burdens
of his high office was, like himself, a man of peace. Madison had been a
leader since the days of the Revolution, but in legislative halls and
council chambers, not on the field of battle. Small in stature,
sensitive in feelings, studious in habits, he was no man for the rough
and tumble of practical politics. He had taken a prominent and
distinguished part in the framing and the adoption of the Constitution.
He had served in the first Congress as a friend of Hamilton's measures.
Later he attached himself to Jefferson's fortunes and served for eight
years as his first counselor, the Secretary of State. The principles of
the Constitution, which he had helped to make and interpret, he was now
as President called upon to apply in one of the most perplexing moments
in all American history. In keeping with his own traditions and
following in the footsteps of Jefferson, he vainly tried to solve the
foreign problem by negotiation.

=The Trend of Events.=--Whatever difficulties Madison had in making up
his mind on war and peace were settled by events beyond his own control.
In the spring of 1811, a British frigate held up an American ship near
the harbor of New York and impressed a seaman alleged to be an American
citizen. Burning with resentment, the captain of the _President_, an
American warship, acting under orders, poured several broadsides into
the _Little Belt_, a British sloop, suspected of being the guilty party.
The British also encouraged the Indian chief Tecumseh, who welded
together the Indians of the Northwest under British protection and gave
signs of restlessness presaging a revolt. This sent a note of alarm
along the frontier that was not checked even when, in November,
Tecumseh's men were badly beaten at Tippecanoe by William Henry
Harrison. The Indians stood in the way of the advancing frontier, and it
seemed to the pioneers that, without support from the British in Canada,
the Red Men would soon be subdued.

=Clay and Calhoun.=--While events were moving swiftly and rumors were
flying thick and fast, the mastery of the government passed from the
uncertain hands of Madison to a party of ardent young men in Congress,
dubbed "Young Republicans," under the leadership of two members destined
to be mighty figures in American history: Henry Clay of Kentucky and
John C. Calhoun of South Carolina. The former contended, in a flair of
folly, that "the militia of Kentucky alone are competent to place
Montreal and Upper Canada at your feet." The latter with a light heart
spoke of conquering Canada in a four weeks' campaign. "It must not be
inferred," says Channing, "that in advocating conquest, the Westerners
were actuated merely by desire for land; they welcomed war because they

thought it would be the easiest way to abate Indian troubles. The
savages were supported by the fur-trading interests that centred at
Quebec and London.... The Southerners on their part wished for Florida
and they thought that the conquest of Canada would obviate some Northern
opposition to this acquisition of slave territory." While Clay and
Calhoun, spokesmen of the West and South, were not unmindful of what
Napoleon had done to American commerce, they knew that their followers
still remembered with deep gratitude the aid of the French in the war
for independence and that the embers of the old hatred for George III,
still on the throne, could be readily blown into flame.

=Madison Accepts War as Inevitable.=--The conduct of the British
ministers with whom Madison had to deal did little to encourage him in
adhering to the policy of "watchful waiting." One of them, a high Tory,
believed that all Americans were alike "except that a few are less
knaves than others" and his methods were colored by his belief. On the
recall of this minister the British government selected another no less
high and mighty in his principles and opinions. So Madison became
thoroughly discouraged about the outcome of pacific measures. When the
pressure from Congress upon him became too heavy, he gave way, signing
on June 18, 1812, the declaration of war on Great Britain. In
proclaiming hostilities, the administration set forth the causes which
justified the declaration; namely, the British had been encouraging the
Indians to attack American citizens on the frontier; they had ruined
American trade by blockades; they had insulted the American flag by
stopping and searching our ships; they had illegally seized American
sailors and driven them into the British navy.

=The Course of the War.=--The war lasted for nearly three years without
bringing victory to either side. The surrender of Detroit by General
Hull to the British and the failure of the American invasion of Canada
were offset by Perry's victory on Lake Erie and a decisive blow
administered to British designs for an invasion of New York by way of
Plattsburgh. The triumph of Jackson at New Orleans helped to atone for
the humiliation suffered in the burning of the Capitol by the British.
The stirring deeds of the _Constitution_, the _United States_, and the
_Argus_ on the seas, the heroic death of Lawrence and the victories of a
hundred privateers furnished consolation for those who suffered from the
iron blockade finally established by the British government when it came
to appreciate the gravity of the situation. While men love the annals of
the sea, they will turn to the running battles, the narrow escapes, and
the reckless daring of American sailors in that naval contest with Great
Britain.

All this was exciting but it was inconclusive. In fact, never was a
government less prepared than was that of the United States in 1812. It
had neither the disciplined troops, the ships of war, nor the supplies
required by the magnitude of the military task. It was fortune that
favored the American cause. Great Britain, harassed, worn, and
financially embarrassed by nearly twenty years of fighting in Europe,
was in no mood to gather her forces for a titanic effort in America even
after Napoleon was overthrown and sent into exile at Elba in the spring
of 1814. War clouds still hung on the European horizon and the conflict
temporarily halted did again break out. To be rid of American anxieties
and free for European eventualities, England was ready to settle with
the United States, especially as that could be done without conceding
anything or surrendering any claims.

=The Treaty of Peace.=--Both countries were in truth sick of a war that
offered neither glory nor profit. Having indulged in the usual
diplomatic skirmishing, they sent representatives to Ghent to discuss
terms of peace. After long negotiations an agreement was reached on
Christmas eve, 1814, a few days before Jackson's victory at New Orleans.
When the treaty reached America the people were surprised to find that
it said nothing about the seizure of American sailors, the destruction
of American trade, the searching of American ships, or the support of
Indians on the frontier. Nevertheless, we are told, the people "passed
from gloom to glory" when the news of peace arrived. The bells were
rung; schools were closed; flags were displayed; and many a rousing
toast was drunk in tavern and private home. The rejoicing could
continue. With Napoleon definitely beaten at Waterloo in June, 1815,
Great Britain had no need to impress sailors, search ships, and
confiscate American goods bound to the Continent. Once more the terrible
sea power sank into the background and the ocean was again white with
the sails of merchantmen.


THE REPUBLICANS NATIONALIZED

=The Federalists Discredited.=--By a strange turn of fortune's wheel,
the party of Hamilton, Washington, Adams, the party of the grand nation,
became the party of provincialism and nullification. New England,
finding its shipping interests crippled in the European conflict and
then penalized by embargoes, opposed the declaration of war on Great
Britain, which meant the completion of the ruin already begun. In the
course of the struggle, the Federalist leaders came perilously near to
treason in their efforts to hamper the government of the United States;
and in their desperation they fell back upon the doctrine of
nullification so recently condemned by them when it came from Kentucky.
The Senate of Massachusetts, while the war was in progress, resolved
that it was waged "without justifiable cause," and refused to approve
military and naval projects not connected with "the defense of our
seacoast and soil." A Boston newspaper declared that the union was
nothing but a treaty among sovereign states, that states could decide
for themselves the question of obeying federal law, and that armed
resistance under the banner of a state would not be rebellion or
treason. The general assembly of Connecticut reminded the administration
at Washington that "the state of Connecticut is a free, sovereign, and
independent state." Gouverneur Morris, a member of the convention which
had drafted the Constitution, suggested the holding of another
conference to consider whether the Northern states should remain in the
union.

[Illustration: _From an old cartoon_

NEW ENGLAND JUMPING INTO THE HANDS OF GEORGE III]

In October, 1814, a convention of delegates from Connecticut,
Massachusetts, Rhode Island, and certain counties of New Hampshire and
Vermont was held at Hartford, on the call of Massachusetts. The counsels
of the extremists were rejected but the convention solemnly went on
record to the effect that acts of Congress in violation of the
Constitution are void; that in cases of deliberate, dangerous, and
palpable infractions the state is duty bound to interpose its authority
for the protection of its citizens; and that when emergencies occur the
states must be their own judges and execute their own decisions. Thus
New England answered the challenge of Calhoun and Clay. Fortunately its
actions were not as rash as its words. The Hartford convention merely
proposed certain amendments to the Constitution and adjourned. At the
close of the war, its proposals vanished harmlessly; but the men who
made them were hopelessly discredited.

=The Second United States Bank.=--In driving the Federalists towards
nullification and waging a national war themselves, the Republicans lost
all their old taint of provincialism. Moreover, in turning to measures
of reconstruction called forth by the war, they resorted to the national
devices of the Federalists. In 1816, they chartered for a period of
twenty years a second United States Bank--the institution which
Jefferson and Madison once had condemned as unsound and
unconstitutional. The Constitution remained unchanged; times and
circumstances had changed. Calhoun dismissed the vexed question of
constitutionality with a scant reference to an ancient dispute, while
Madison set aside his scruples and signed the bill.

=The Protective Tariff of 1816.=--The Republicans supplemented the Bank
by another Federalist measure--a high protective tariff. Clay viewed it
as the beginning of his "American system" of protection. Calhoun
defended it on national principles. For this sudden reversal of policy
the young Republicans were taunted by some of their older party
colleagues with betraying the "agricultural interest" that Jefferson had
fostered; but Calhoun refused to listen to their criticisms. "When the
seas are open," he said, "the produce of the South may pour anywhere
into the markets of the Old World.... What are the effects of a war with
a maritime power--with England? Our commerce annihilated ... our
agriculture cut off from its accustomed markets, the surplus of the
farmer perishes on his hands.... The recent war fell with peculiar
pressure on the growers of cotton and tobacco and the other great
staples of the country; and the same state of things will recur in the
event of another war unless prevented by the foresight of this body....
When our manufactures are grown to a certain perfection, as they soon
will be under the fostering care of the government, we shall no longer
experience these evils." With the Republicans nationalized, the
Federalist party, as an organization, disappeared after a crushing
defeat in the presidential campaign of 1816.

=Monroe and the Florida Purchase.=--To the victor in that political
contest, James Monroe of Virginia, fell two tasks of national
importance, adding to the prestige of the whole country and deepening
the sense of patriotism that weaned men away from mere allegiance to
states. The first of these was the purchase of Florida from Spain. The
acquisition of Louisiana let the Mississippi flow "unvexed to the sea";
but it left all the states east of the river cut off from the Gulf,
affording them ground for discontent akin to that which had moved the
pioneers of Kentucky to action a generation earlier. The uncertainty as
to the boundaries of Louisiana gave the United States a claim to West
Florida, setting on foot a movement for occupation. The Florida swamps
were a basis for Indian marauders who periodically swept into the
frontier settlements, and hiding places for runaway slaves. Thus the
sanction of international law was given to punitive expeditions into
alien territory.

The pioneer leaders stood waiting for the signal. It came. President
Monroe, on the occasion of an Indian outbreak, ordered General Jackson
to seize the offenders, in the Floridas, if necessary. The high-spirited
warrior, taking this as a hint that he was to occupy the coveted region,
replied that, if possession was the object of the invasion, he could
occupy the Floridas within sixty days. Without waiting for an answer to
this letter, he launched his expedition, and in the spring of 1818 was
master of the Spanish king's domain to the south.

There was nothing for the king to do but to make the best of the
inevitable by ceding the Floridas to the United States in return for
five million dollars to be paid to American citizens having claims
against Spain. On Washington's birthday, 1819, the treaty was signed. It
ceded the Floridas to the United States and defined the boundary between
Mexico and the United States by drawing a line from the mouth of the
Sabine River in a northwesterly direction to the Pacific. On this
occasion even Monroe, former opponent of the Constitution, forgot to
inquire whether new territory could be constitutionally acquired and
incorporated into the American union. The Republicans seemed far away
from the days of "strict construction." And Jefferson still lived!

=The Monroe Doctrine.=--Even more effective in fashioning the national
idea was Monroe's enunciation of the famous doctrine that bears his
name. The occasion was another European crisis. During the Napoleonic
upheaval and the years of dissolution that ensued, the Spanish colonies
in America, following the example set by their English neighbors in
1776, declared their independence. Unable to conquer them alone, the
king of Spain turned for help to the friendly powers of Europe that
looked upon revolution and republics with undisguised horror.

_The Holy Alliance._--He found them prepared to view his case with
sympathy. Three of them, Austria, Prussia, and Russia, under the
leadership of the Czar, Alexander I, in the autumn of 1815, had entered
into a Holy Alliance to sustain by reciprocal service the autocratic
principle in government. Although the effusive, almost maudlin, language
of the treaty did not express their purpose explicitly, the Alliance was
later regarded as a mere union of monarchs to prevent the rise and
growth of popular government.

The American people thought their worst fears confirmed when, in 1822, a
conference of delegates from Russia, Austria, Prussia, and France met at
Verona to consider, among other things, revolutions that had just broken
out in Spain and Italy. The spirit of the conference is reflected in the
first article of the agreement reached by the delegates: "The high
contracting powers, being convinced that the system of representative
government is equally incompatible with the monarchical principle and
the maxim of the sovereignty of the people with the divine right,
mutually engage in the most solemn manner to use all their efforts to
put an end to the system of representative government in whatever
country it may exist in Europe and to prevent its being introduced in
those countries where it is not yet known." The Czar, who incidentally
coveted the west coast of North America, proposed to send an army to aid
the king of Spain in his troubles at home, thus preparing the way for
intervention in Spanish America. It was material weakness not want of
spirit, that prevented the grand union of monarchs from making open war
on popular government.

_The Position of England._--Unfortunately, too, for the Holy Alliance,
England refused to cooperate. English merchants had built up a large
trade with the independent Latin-American colonies and they protested
against the restoration of Spanish sovereignty, which meant a renewal of
Spain's former trade monopoly. Moreover, divine right doctrines had been
laid to rest in England and the representative principle thoroughly
established. Already there were signs of the coming democratic flood
which was soon to carry the first reform bill of 1832, extending the
suffrage, and sweep on to even greater achievements. British statesmen,
therefore, had to be cautious. In such circumstances, instead of
cooperating with the autocrats of Russia, Austria, and Prussia, they
turned to the minister of the United States in London. The British prime
minister, Canning, proposed that the two countries join in declaring
their unwillingness to see the Spanish colonies transferred to any other
power.

_Jefferson's Advice._--The proposal was rejected; but President Monroe
took up the suggestion with Madison and Jefferson as well as with his
Secretary of State, John Quincy Adams. They favored the plan. Jefferson
said: "One nation, most of all, could disturb us in this pursuit [of
freedom]; she now offers to lead, aid, and accompany us in it. By
acceding to her proposition we detach her from the bands, bring her
mighty weight into the scale of free government and emancipate a
continent at one stroke.... With her on our side we need not fear the
whole world. With her then we should most sedulously cherish a cordial
friendship."

_Monroe's Statement of the Doctrine._--Acting on the advice of trusted
friends, President Monroe embodied in his message to Congress, on
December 2, 1823, a statement of principles now famous throughout the
world as the Monroe Doctrine. To the autocrats of Europe he announced
that he would regard "any attempt on their part to extend their system
to any portion of this hemisphere as dangerous to our peace and safety."
While he did not propose to interfere with existing colonies dependent
on European powers, he ranged himself squarely on the side of those that
had declared their independence. Any attempt by a European power to
oppress them or control their destiny in any manner he characterized as
"a manifestation of an unfriendly disposition toward the United States."
Referring in another part of his message to a recent claim which the
Czar had made to the Pacific coast, President Monroe warned the Old
World that "the American continents, by the free and independent
condition which they have assumed and maintained, are henceforth not to
be considered as subjects for future colonization by any European
powers." The effect of this declaration was immediate and profound. Men
whose political horizon had been limited to a community or state were
led to consider their nation as a great power among the sovereignties of
the earth, taking its part in shaping their international relations.

=The Missouri Compromise.=--Respecting one other important measure of
this period, the Republicans also took a broad view of their obligations
under the Constitution; namely, the Missouri Compromise. It is true,
they insisted on the admission of Missouri as a slave state, balanced
against the free state of Maine; but at the same time they assented to
the prohibition of slavery in the Louisiana territory north of the line
36 o 30'. During the debate on the subject an extreme view had been
presented, to the effect that Congress had no constitutional warrant for
abolishing slavery in the territories. The precedent of the Northwest
Ordinance, ratified by Congress in 1789, seemed a conclusive answer from
practice to this contention; but Monroe submitted the issue to his
cabinet, which included Calhoun of South Carolina, Crawford of Georgia,
and Wirt of Virginia, all presumably adherents to the Jeffersonian
principle of strict construction. He received in reply a unanimous
verdict to the effect that Congress did have the power to prohibit
slavery in the territories governed by it. Acting on this advice he
approved, on March 6, 1820, the bill establishing freedom north of the
compromise line. This generous interpretation of the powers of Congress
stood for nearly forty years, until repudiated by the Supreme Court in
the Dred Scott case.


THE NATIONAL DECISIONS OF CHIEF JUSTICE MARSHALL

=John Marshall, the Nationalist.=--The Republicans in the lower ranges
of state politics, who did not catch the grand national style of their
leaders charged with responsibilities in the national field, were
assisted in their education by a Federalist from the Old Dominion, John
Marshall, who, as Chief Justice of the Supreme Court of the United
States from 1801 to 1835, lost no occasion to exalt the Constitution
above the claims of the provinces. No differences of opinion as to his
political views have ever led even his warmest opponents to deny his
superb abilities or his sincere devotion to the national idea. All will
likewise agree that for talents, native and acquired, he was an ornament
to the humble democracy that brought him forth. His whole career was
American. Born on the frontier of Virginia, reared in a log cabin,
granted only the barest rudiments of education, inured to hardship and
rough life, he rose by masterly efforts to the highest judicial honor
America can bestow.

On him the bitter experience of the Revolution and of later days made a
lasting impression. He was no "summer patriot." He had been a soldier in
the Revolutionary army. He had suffered with Washington at Valley Forge.
He had seen his comrades in arms starving and freezing because the
Continental Congress had neither the power nor the inclination to force
the states to do their full duty. To him the Articles of Confederation
were the symbol of futility. Into the struggle for the formation of the
Constitution and its ratification in Virginia he had thrown himself with
the ardor of a soldier. Later, as a member of Congress, a representative
to France, and Secretary of State, he had aided the Federalists in
establishing the new government. When at length they were driven from
power in the executive and legislative branches of the government, he
was chosen for their last stronghold, the Supreme Court. By historic
irony he administered the oath of office to his bitterest enemy, Thomas
Jefferson; and, long after the author of the Declaration of Independence
had retired to private life, the stern Chief Justice continued to
announce the old Federalist principles from the Supreme Bench.

[Illustration: JOHN MARSHALL]

=Marbury _vs._ Madison--An Act of Congress Annulled.=--He had been in
his high office only two years when he laid down for the first time in
the name of the entire Court the doctrine that the judges have the power
to declare an act of Congress null and void when in their opinion it
violates the Constitution. This power was not expressly conferred on the
Court. Though many able men held that the judicial branch of the
government enjoyed it, the principle was not positively established
until 1803 when the case of Marbury _vs._ Madison was decided. In
rendering the opinion of the Court, Marshall cited no precedents. He
sought no foundations for his argument in ancient history. He rested it
on the general nature of the American system. The Constitution, ran his
reasoning, is the supreme law of the land; it limits and binds all who
act in the name of the United States; it limits the powers of Congress
and defines the rights of citizens. If Congress can ignore its
limitations and trespass upon the rights of citizens, Marshall argued,
then the Constitution disappears and Congress is supreme. Since,
however, the Constitution is supreme and superior to Congress, it is the
duty of judges, under their oath of office, to sustain it against
measures which violate it. Therefore, from the nature of the American
constitutional system the courts must declare null and void all acts
which are not authorized. "A law repugnant to the Constitution," he
closed, "is void and the courts as well as other departments are bound
by that instrument." From that day to this the practice of federal and
state courts in passing upon the constitutionality of laws has remained
unshaken.

This doctrine was received by Jefferson and many of his followers with
consternation. If the idea was sound, he exclaimed, "then indeed is our
Constitution a complete _felo de se_ [legally, a suicide]. For,
intending to establish three departments, coordinate and independent
that they might check and balance one another, it has given, according
to this opinion, to one of them alone the right to prescribe rules for
the government of the others, and to that one, too, which is unelected
by and independent of the nation.... The Constitution, on this
hypothesis, is a mere thing of wax in the hands of the judiciary which
they may twist and shape into any form they please. It should be
remembered, as an axiom of eternal truth in politics, that whatever
power in any government is independent, is absolute also.... A judiciary
independent of a king or executive alone is a good thing; but
independence of the will of the nation is a solecism, at least in a
republican government." But Marshall was mighty and his view prevailed,
though from time to time other men, clinging to Jefferson's opinion,
likewise opposed the exercise by the Courts of the high power of passing
upon the constitutionality of acts of Congress.

=Acts of State Legislatures Declared Unconstitutional.=--Had Marshall
stopped with annulling an act of Congress, he would have heard less
criticism from Republican quarters; but, with the same firmness, he set
aside acts of state legislatures as well, whenever, in his opinion, they
violated the federal Constitution. In 1810, in the case of Fletcher
_vs._ Peck, he annulled an act of the Georgia legislature, informing the
state that it was not sovereign, but "a part of a large empire, ... a
member of the American union; and that union has a constitution ...
which imposes limits to the legislatures of the several states." In the
case of McCulloch _vs._ Maryland, decided in 1819, he declared void an
act of the Maryland legislature designed to paralyze the branches of the
United States Bank established in that state. In the same year, in the
still more memorable Dartmouth College case, he annulled an act of the
New Hampshire legislature which infringed upon the charter received by
the college from King George long before. That charter, he declared, was
a contract between the state and the college, which the legislature
under the federal Constitution could not impair. Two years later he
stirred the wrath of Virginia by summoning her to the bar of the Supreme
Court to answer in a case in which the validity of one of her laws was
involved and then justified his action in a powerful opinion rendered in
the case of Cohens _vs._ Virginia.

All these decisions aroused the legislatures of the states. They passed
sheaves of resolutions protesting and condemning; but Marshall never
turned and never stayed. The Constitution of the United States, he
fairly thundered at them, is the supreme law of the land; the Supreme
Court is the proper tribunal to pass finally upon the validity of the
laws of the states; and "those sovereignties," far from possessing the
right of review and nullification, are irrevocably bound by the
decisions of that Court. This was strong medicine for the authors of the
Kentucky and Virginia Resolutions and for the members of the Hartford
convention; but they had to take it.

=The Doctrine of Implied Powers.=--While restraining Congress in the
Marbury case and the state legislatures in a score of cases, Marshall
also laid the judicial foundation for a broad and liberal view of the
Constitution as opposed to narrow and strict construction. In McCulloch
_vs._ Maryland, he construed generously the words "necessary and proper"
in such a way as to confer upon Congress a wide range of "implied
powers" in addition to their express powers. That case involved, among
other things, the question whether the act establishing the second
United States Bank was authorized by the Constitution. Marshall answered
in the affirmative. Congress, ran his reasoning, has large powers over
taxation and the currency; a bank is of appropriate use in the exercise
of these enumerated powers; and therefore, though not absolutely
necessary, a bank is entirely proper and constitutional. "With respect
to the means by which the powers that the Constitution confers are to be
carried into execution," he said, Congress must be allowed the
discretion which "will enable that body to perform the high duties
assigned to it, in the manner most beneficial to the people." In short,
the Constitution of the United States is not a strait jacket but a
flexible instrument vesting in Congress the powers necessary to meet
national problems as they arise. In delivering this opinion Marshall
used language almost identical with that employed by Lincoln when,
standing on the battle field of a war waged to preserve the nation, he
said that "a government of the people, by the people, for the people
shall not perish from the earth."


SUMMARY OF THE UNION AND NATIONAL POLITICS

During the strenuous period between the establishment of American
independence and the advent of Jacksonian democracy the great American
experiment was under the direction of the men who had launched it. All
the Presidents in that period, except John Quincy Adams, had taken part
in the Revolution. James Madison, the chief author of the Constitution,
lived until 1836. This age, therefore, was the "age of the fathers." It
saw the threatened ruin of the country under the Articles of
Confederation, the formation of the Constitution, the rise of political
parties, the growth of the West, the second war with England, and the
apparent triumph of the national spirit over sectionalism.

The new republic had hardly been started in 1783 before its troubles
began. The government could not raise money to pay its debts or running
expenses; it could not protect American commerce and manufactures
against European competition; it could not stop the continual issues of
paper money by the states; it could not intervene to put down domestic
uprisings that threatened the existence of the state governments.
Without money, without an army, without courts of law, the union under
the Articles of Confederation was drifting into dissolution. Patriots,
who had risked their lives for independence, began to talk of monarchy
again. Washington, Hamilton, and Madison insisted that a new
constitution alone could save America from disaster.

By dint of much labor the friends of a new form of government induced
the Congress to call a national convention to take into account the
state of America. In May, 1787, it assembled at Philadelphia and for
months it debated and wrangled over plans for a constitution. The small
states clamored for equal rights in the union. The large states vowed
that they would never grant it. A spirit of conciliation, fair play, and
compromise saved the convention from breaking up. In addition, there
were jealousies between the planting states and the commercial states.
Here, too, compromises had to be worked out. Some of the delegates
feared the growth of democracy and others cherished it. These factions
also had to be placated. At last a plan of government was drafted--the
Constitution of the United States--and submitted to the states for
approval. Only after a long and acrimonious debate did enough states
ratify the instrument to put it into effect. On April 30, 1789, George
Washington was inaugurated first President.

The new government proceeded to fund the old debt of the nation, assume
the debts of the states, found a national bank, lay heavy taxes to pay
the bills, and enact laws protecting American industry and commerce.
Hamilton led the way, but he had not gone far before he encountered
opposition. He found a formidable antagonist in Jefferson. In time two
political parties appeared full armed upon the scene: the Federalists
and the Republicans. For ten years they filled the country with
political debate. In 1800 the Federalists were utterly vanquished by the
Republicans with Jefferson in the lead.

By their proclamations of faith the Republicans favored the states
rather than the new national government, but in practice they added
immensely to the prestige and power of the nation. They purchased
Louisiana from France, they waged a war for commercial independence
against England, they created a second United States Bank, they enacted
the protective tariff of 1816, they declared that Congress had power to
abolish slavery north of the Missouri Compromise line, and they spread
the shield of the Monroe Doctrine between the Western Hemisphere and
Europe.

Still America was a part of European civilization. Currents of opinion
flowed to and fro across the Atlantic. Friends of popular government in
Europe looked to America as the great exemplar of their ideals. Events
in Europe reacted upon thought in the United States. The French
Revolution exerted a profound influence on the course of political
debate. While it was in the stage of mere reform all Americans favored
it. When the king was executed and a radical democracy set up, American
opinion was divided. When France fell under the military dominion of
Napoleon and preyed upon American commerce, the United States made ready
for war.

The conduct of England likewise affected American affairs. In 1793 war
broke out between England and France and raged with only a slight
intermission until 1815. England and France both ravaged American
commerce, but England was the more serious offender because she had
command of the seas. Though Jefferson and Madison strove for peace, the
country was swept into war by the vehemence of the "Young Republicans,"
headed by Clay and Calhoun.

When the armed conflict was closed, one in diplomacy opened. The
autocratic powers of Europe threatened to intervene on behalf of Spain
in her attempt to recover possession of her Latin-American colonies.
Their challenge to America brought forth the Monroe Doctrine. The powers
of Europe were warned not to interfere with the independence or the
republican policies of this hemisphere or to attempt any new
colonization in it. It seemed that nationalism was to have a peaceful
triumph over sectionalism.


=References=

H. Adams, _History of the United States, 1800-1817_ (9 vols.).

K.C. Babcock, _Rise of American Nationality_ (American Nation Series).

E. Channing, _The Jeffersonian System_ (Same Series).

D.C. Gilman, _James Monroe_.

W. Reddaway, _The Monroe Doctrine_.

T. Roosevelt, _Naval War of 1812_.


=Questions=

1. What was the leading feature of Jefferson's political theory?

2. Enumerate the chief measures of his administration.

3. Were the Jeffersonians able to apply their theories? Give the
reasons.


4. Explain the importance of the Mississippi River to Western farmers.

5. Show how events in Europe forced the Louisiana Purchase.

6. State the constitutional question involved in the Louisiana Purchase.

7. Show how American trade was affected by the European war.

8. Compare the policies of Jefferson and Madison.

9. Why did the United States become involved with England rather than
with France?

10. Contrast the causes of the War of 1812 with the results.

11. Give the economic reasons for the attitude of New England.

12. Give five "nationalist" measures of the Republicans. Discuss each in
detail.

13. Sketch the career of John Marshall.

14. Discuss the case of Marbury _vs._ Madison.

15. Summarize Marshall's views on: (_a_) states' rights; and (_b_) a
liberal interpretation of the Constitution.


=Research Topics=

=The Louisiana Purchase.=--Text of Treaty in Macdonald, _Documentary
Source Book_, pp. 279-282. Source materials in Hart, _American History
Told by Contemporaries_, Vol. III, pp. 363-384. Narrative, Henry Adams,
_History of the United States_, Vol. II, pp. 25-115; Elson, _History of
the United States_, pp. 383-388.

=The Embargo and Non-Intercourse Acts.=--Macdonald, pp. 282-288; Adams,
Vol. IV, pp. 152-177; Elson, pp. 394-405.

=Congress and the War of 1812.=--Adams, Vol. VI, pp. 113-198; Elson, pp.
408-450.

=Proposals of the Hartford Convention.=--Macdonald, pp. 293-302.

=Manufactures and the Tariff of 1816.=--Coman, _Industrial History of
the United States_, pp. 184-194.

=The Second United States Bank.=--Macdonald, pp. 302-306.

=Effect of European War on American Trade.=--Callender, _Economic
History of the United States_, pp. 240-250.

=The Monroe Message.=--Macdonald, pp. 318-320.

=Lewis and Clark Expedition.=--R.G. Thwaites, _Rocky Mountain
Explorations_, pp. 92-187. Schafer, _A History of the Pacific Northwest_
(rev. ed.), pp. 29-61.




PART IV. THE WEST AND JACKSONIAN DEMOCRACY




CHAPTER X

THE FARMERS BEYOND THE APPALACHIANS


The nationalism of Hamilton was undemocratic. The democracy of Jefferson
was, in the beginning, provincial. The historic mission of uniting
nationalism and democracy was in the course of time given to new leaders
from a region beyond the mountains, peopled by men and women from all
sections and free from those state traditions which ran back to the
early days of colonization. The voice of the democratic nationalism
nourished in the West was heard when Clay of Kentucky advocated his
American system of protection for industries; when Jackson of Tennessee
condemned nullification in a ringing proclamation that has taken its
place among the great American state papers; and when Lincoln of
Illinois, in a fateful hour, called upon a bewildered people to meet the
supreme test whether this was a nation destined to survive or to perish.
And it will be remembered that Lincoln's party chose for its banner that
earlier device--Republican--which Jefferson had made a sign of power.
The "rail splitter" from Illinois united the nationalism of Hamilton
with the democracy of Jefferson, and his appeal was clothed in the
simple language of the people, not in the sonorous rhetoric which
Webster learned in the schools.


PREPARATION FOR WESTERN SETTLEMENT

=The West and the American Revolution.=--The excessive attention devoted
by historians to the military operations along the coast has obscured
the role played by the frontier in the American Revolution. The action
of Great Britain in closing western land to easy settlement in 1763 was
more than an incident in precipitating the war for independence.
Americans on the frontier did not forget it; when Indians were employed
by England to defend that land, zeal for the patriot cause set the
interior aflame. It was the members of the western vanguard, like Daniel
Boone, John Sevier, and George Rogers Clark, who first understood the
value of the far-away country under the guns of the English forts, where
the Red Men still wielded the tomahawk and the scalping knife. It was
they who gave the East no rest until their vision was seen by the
leaders on the seaboard who directed the course of national policy. It
was one of their number, a seasoned Indian fighter, George Rogers Clark,
who with aid from Virginia seized Kaskaskia and Vincennes and secured
the whole Northwest to the union while the fate of Washington's army was
still hanging in the balance.

=Western Problems at the End of the Revolution.=--The treaty of peace,
signed with Great Britain in 1783, brought the definite cession of the
coveted territory west to the Mississippi River, but it left unsolved
many problems. In the first place, tribes of resentful Indians in the
Ohio region, even though British support was withdrawn at last, had to
be reckoned with; and it was not until after the establishment of the
federal Constitution that a well-equipped army could be provided to
guarantee peace on the border. In the second place, British garrisons
still occupied forts on Lake Erie pending the execution of the terms of
the treaty of 1783--terms which were not fulfilled until after the
ratification of the Jay treaty twelve years later. In the third place,
Virginia, Connecticut, and Massachusetts had conflicting claims to the
land in the Northwest based on old English charters and Indian treaties.
It was only after a bitter contest that the states reached an agreement
to transfer their rights to the government of the United States,
Virginia executing her deed of cession on March 1, 1784. In the fourth
place, titles to lands bought by individuals remained uncertain in the
absence of official maps and records. To meet this last situation,
Congress instituted a systematic survey of the Ohio country, laying it
out into townships, sections of 640 acres each, and quarter sections. In
every township one section of land was set aside for the support of
public schools.

=The Northwest Ordinance.=--The final problem which had to be solved
before settlement on a large scale could be begun was that of governing
the territory. Pioneers who looked with hungry eyes on the fertile
valley of the Ohio could hardly restrain their impatience. Soldiers of
the Revolution, who had been paid for their services in land warrants
entitling them to make entries in the West, called for action.

Congress answered by passing in 1787 the famous Northwest Ordinance
providing for temporary territorial government to be followed by the
creation of a popular assembly as soon as there were five thousand free
males in any district. Eventual admission to the union on an equal
footing with the original states was promised to the new territories.
Religious freedom was guaranteed. The safeguards of trial by jury,
regular judicial procedure, and _habeas corpus_ were established, in order
that the methods of civilized life might take the place of the
rough-and-ready justice of lynch law. During the course of the debate on
the Ordinance, Congress added the sixth article forbidding slavery and
involuntary servitude.

This Charter of the Northwest, so well planned by the Congress under the
Articles of Confederation, was continued in force by the first Congress
under the Constitution in 1789. The following year its essential
provisions, except the ban on slavery, were applied to the territory
south of the Ohio, ceded by North Carolina to the national government,
and in 1798 to the Mississippi territory, once held by Georgia. Thus it
was settled for all time that "the new colonies were not to be exploited
for the benefit of the parent states (any more than for the benefit of
England) but were to be autonomous and coordinate commonwealths." This
outcome, bitterly opposed by some Eastern leaders who feared the triumph
of Western states over the seaboard, completed the legal steps necessary
by way of preparation for the flood of settlers.

=The Land Companies, Speculators, and Western Land Tenure.=--As in the
original settlement of America, so in the opening of the West, great
companies and single proprietors of large grants early figured. In 1787
the Ohio Land Company, a New England concern, acquired a million and a
half acres on the Ohio and began operations by planting the town of
Marietta. A professional land speculator, J.C. Symmes, secured a million
acres lower down where the city of Cincinnati was founded. Other
individuals bought up soldiers' claims and so acquired enormous holdings
for speculative purposes. Indeed, there was such a rush to make fortunes
quickly through the rise in land values that Washington was moved to cry
out against the "rage for speculating in and forestalling of land on the
North West of the Ohio," protesting that "scarce a valuable spot within
any tolerable distance of it is left without a claimant." He therefore
urged Congress to fix a reasonable price for the land, not "too
exorbitant and burdensome for real occupiers, but high enough to
discourage monopolizers."

Congress, however, was not prepared to use the public domain for the
sole purpose of developing a body of small freeholders in the West. It
still looked upon the sale of public lands as an important source of
revenue with which to pay off the public debt; consequently it thought
more of instant income than of ultimate results. It placed no limit on
the amount which could be bought when it fixed the price at $2 an acre
in 1796, and it encouraged the professional land operator by making the
first installment only twenty cents an acre in addition to the small
registration and survey fee. On such terms a speculator with a few
thousand dollars could get possession of an enormous plot of land. If he
was fortunate in disposing of it, he could meet the installments, which
were spread over a period of four years, and make a handsome profit for
himself. Even when the credit or installment feature was abolished in
1821 and the price of the land lowered to a cash price of $1.75 an acre,
the opportunity for large speculative purchases continued to attract
capital to land ventures.

=The Development of the Small Freehold.=--The cheapness of land and the
scarcity of labor, nevertheless, made impossible the triumph of the huge
estate with its semi-servile tenantry. For about $45 a man could get a
farm of 160 acres on the installment plan; another payment of $80 was
due in forty days; but a four-year term was allowed for the discharge of
the balance. With a capital of from two to three hundred dollars a
family could embark on a land venture. If it had good crops, it could
meet the deferred payments. It was, however, a hard battle at best. Many
a man forfeited his land through failure to pay the final installment;
yet in the end, in spite of all the handicaps, the small freehold of a
few hundred acres at most became the typical unit of Western
agriculture, except in the planting states of the Gulf. Even the lands
of the great companies were generally broken up and sold in small lots.

The tendency toward moderate holdings, so favored by Western conditions,
was also promoted by a clause in the Northwest Ordinance declaring that
the land of any person dying intestate--that is, without any will
disposing of it--should be divided equally among his descendants.
Hildreth says of this provision: "It established the important
republican principle, not then introduced into all the states, of the
equal distribution of landed as well as personal property." All these
forces combined made the wide dispersion of wealth, in the early days of
the nineteenth century, an American characteristic, in marked contrast
with the European system of family prestige and vast estates based on
the law of primogeniture.


THE WESTERN MIGRATION AND NEW STATES

=The People.=--With government established, federal arms victorious over
the Indians, and the lands surveyed for sale, the way was prepared for
the immigrants. They came with a rush. Young New Englanders, weary of
tilling the stony soil of their native states, poured through New York
and Pennsylvania, some settling on the northern bank of the Ohio but
most of them in the Lake region. Sons and daughters of German farmers in
Pennsylvania and many a redemptioner who had discharged his bond of
servitude pressed out into Ohio, Kentucky, Tennessee, or beyond. From
the exhausted fields and the clay hills of the Southern states came
pioneers of English and Scotch-Irish descent, the latter in great
numbers. Indeed one historian of high authority has ventured to say that
"the rapid expansion of the United States from a coast strip to a
continental area is largely a Scotch-Irish achievement." While native
Americans of mixed stocks led the way into the West, it was not long
before immigrants direct from Europe, under the stimulus of company
enterprise, began to filter into the new settlements in increasing
numbers.

The types of people were as various as the nations they represented.
Timothy Flint, who published his entertaining _Recollections_ in 1826,
found the West a strange mixture of all sorts and conditions of people.
Some of them, he relates, had been hunters in the upper world of the
Mississippi, above the falls of St. Anthony. Some had been still farther
north, in Canada. Still others had wandered from the South--the Gulf of
Mexico, the Red River, and the Spanish country. French boatmen and
trappers, Spanish traders from the Southwest, Virginia planters with
their droves of slaves mingled with English, German, and Scotch-Irish
farmers. Hunters, forest rangers, restless bordermen, and squatters,
like the foaming combers of an advancing tide, went first. Then followed
the farmers, masters of the ax and plow, with their wives who shared
every burden and hardship and introduced some of the features of
civilized life. The hunters and rangers passed on to new scenes; the
home makers built for all time.

=The Number of Immigrants.=--There were no official stations on the
frontier to record the number of immigrants who entered the West during
the decades following the American Revolution. But travelers of the time
record that every road was "crowded" with pioneers and their families,
their wagons and cattle; and that they were seldom out of the sound of
the snapping whip of the teamster urging forward his horses or the crack
of the hunter's rifle as he brought down his evening meal. "During the
latter half of 1787," says Coman, "more than nine hundred boats floated
down the Ohio carrying eighteen thousand men, women, and children, and
twelve thousand horses, sheep, and cattle, and six hundred and fifty
wagons." Other lines of travel were also crowded and with the passing
years the flooding tide of home seekers rose higher and higher.

=The Western Routes.=--Four main routes led into the country beyond the
Appalachians. The Genesee road, beginning at Albany, ran almost due west
to the present site of Buffalo on Lake Erie, through a level country. In
the dry season, wagons laden with goods could easily pass along it into
northern Ohio. A second route, through Pittsburgh, was fed by three
eastern branches, one starting at Philadelphia, one at Baltimore, and
another at Alexandria. A third main route wound through the mountains
from Alexandria to Boonesboro in Kentucky and then westward across the
Ohio to St. Louis. A fourth, the most famous of them all, passed through
the Cumberland Gap and by branches extended into the Cumberland valley
and the Kentucky country.

Of these four lines of travel, the Pittsburgh route offered the most
advantages. Pioneers, no matter from what section they came, when once
they were on the headwaters of the Ohio and in possession of a flatboat,
could find a quick and easy passage into all parts of the West and
Southwest. Whether they wanted to settle in Ohio, Kentucky, or western
Tennessee they could find their way down the drifting flood to their
destination or at least to some spot near it. Many people from the South
as well as the Northern and Middle states chose this route; so it came
about that the sons and daughters of Virginia and the Carolinas mingled
with those of New York, Pennsylvania, and New England in the settlement
of the Northwest territory.

=The Methods of Travel into the West.=--Many stories giving exact
descriptions of methods of travel into the West in the early days have
been preserved. The country was hardly opened before visitors from the
Old World and from the Eastern states, impelled by curiosity, made their
way to the very frontier of civilization and wrote books to inform or
amuse the public. One of them, Gilbert Imlay, an English traveler, has
given us an account of the Pittsburgh route as he found it in 1791. "If
a man ... " he writes, "has a family or goods of any sort to remove, his
best way, then, would be to purchase a waggon and team of horses to
carry his property to Redstone Old Fort or to Pittsburgh, according as
he may come from the Northern or Southern states. A good waggon will
cost, at Philadelphia, about $10 ... and the horses about $12 each; they
would cost something more both at Baltimore and Alexandria. The waggon
may be covered with canvass, and if it is the choice of the people, they
may sleep in it of nights with the greatest safety. But if they dislike
that, there are inns of accommodation the whole distance on the
different roads.... The provisions I would purchase in the same manner
[that is, from the farmers along the road]; and by having two or three
camp kettles and stopping every evening when the weather is fine upon
the brink of some rivulet and by kindling a fire they may soon dress
their own food.... This manner of journeying is so far from being
disagreeable that in a fine season it is extremely pleasant." The
immigrant once at Pittsburgh or Wheeling could then buy a flatboat of a
size required for his goods and stock, and drift down the current to his
journey's end.

[Illustration: ROADS AND TRAILS INTO THE WESTERN TERRITORY]

=The Admission of Kentucky and Tennessee.=--When the eighteenth century
drew to a close, Kentucky had a population larger than Delaware, Rhode
Island, or New Hampshire. Tennessee claimed 60,000 inhabitants. In 1792
Kentucky took her place as a state beside her none too kindly parent,
Virginia. The Eastern Federalists resented her intrusion; but they took
some consolation in the admission of Vermont because the balance of
Eastern power was still retained.

As if to assert their independence of old homes and conservative ideas
the makers of Kentucky's first constitution swept aside the landed
qualification on the suffrage and gave the vote to all free white males.
Four years later, Kentucky's neighbor to the south, Tennessee, followed
this step toward a wider democracy. After encountering fierce opposition
from the Federalists, Tennessee was accepted as the sixteenth state.

=Ohio.=--The door of the union had hardly opened for Tennessee when
another appeal was made to Congress, this time from the pioneers in
Ohio. The little posts founded at Marietta and Cincinnati had grown into
flourishing centers of trade. The stream of immigrants, flowing down the
river, added daily to their numbers and the growing settlements all
around poured produce into their markets to be exchanged for "store
goods." After the Indians were disposed of in 1794 and the last British
soldier left the frontier forts under the terms of the Jay treaty of
1795, tiny settlements of families appeared on Lake Erie in the "Western
Reserve," a region that had been retained by Connecticut when she
surrendered her other rights in the Northwest.

At the close of the century, Ohio, claiming a population of more than
50,000, grew discontented with its territorial status. Indeed, two years
before the enactment of the Northwest Ordinance, squatters in that
region had been invited by one John Emerson to hold a convention after
the fashion of the men of Hartford, Windsor, and Wethersfield in old
Connecticut and draft a frame of government for themselves. This true
son of New England declared that men "have an undoubted right to pass
into every vacant country and there to form their constitution and that
from the confederation of the whole United States Congress is not
empowered to forbid them." This grand convention was never held because
the heavy hand of the government fell upon the leaders; but the spirit
of John Emerson did not perish. In November, 1802, a convention chosen
by voters, assembled under the authority of Congress at Chillicothe,
drew up a constitution. It went into force after a popular ratification.
The roll of the convention bore such names as Abbot, Baldwin, Cutler,
Huntington, Putnam, and Sargent, and the list of counties from which
they came included Adams, Fairfield, Hamilton, Jefferson, Trumbull, and
Washington, showing that the new America in the West was peopled and led
by the old stock. In 1803 Ohio was admitted to the union.

=Indiana and Illinois.=--As in the neighboring state, the frontier in
Indiana advanced northward from the Ohio, mainly under the leadership,
however, of settlers from the South--restless Kentuckians hoping for
better luck in a newer country and pioneers from the far frontiers of
Virginia and North Carolina. As soon as a tier of counties swinging
upward like the horns of the moon against Ohio on the east and in the
Wabash Valley on the west was fairly settled, a clamor went up for
statehood. Under the authority of an act of Congress in 1816 the
Indianians drafted a constitution and inaugurated their government at
Corydon. "The majority of the members of the convention," we are told by
a local historian, "were frontier farmers who had a general idea of what
they wanted and had sense enough to let their more erudite colleagues
put it into shape."

Two years later, the pioneers of Illinois, also settled upward from the
Ohio, like Indiana, elected their delegates to draft a constitution.
Leadership in the convention, quite properly, was taken by a man born in
New York and reared in Tennessee; and the constitution as finally
drafted "was in its principal provisions a copy of the then existing
constitutions of Kentucky, Ohio, and Indiana.... Many of the articles
are exact copies in wording although differently arranged and
numbered."

=Louisiana, Mississippi, and Alabama.=--Across the Mississippi to the
far south, clearing and planting had gone on with much bustle and
enterprise. The cotton and sugar lands of Louisiana, opened by French
and Spanish settlers, were widened in every direction by planters with
their armies of slaves from the older states. New Orleans, a good market
and a center of culture not despised even by the pioneer, grew apace. In
1810 the population of lower Louisiana was over 75,000. The time had
come, said the leaders of the people, to fulfill the promise made to
France in the treaty of cession; namely, to grant to the inhabitants of
the territory statehood and the rights of American citizens. Federalists
from New England still having a voice in Congress, if somewhat weaker,
still protested in tones of horror. "I am compelled to declare it as my
deliberate opinion," pronounced Josiah Quincy in the House of
Representatives, "that if this bill [to admit Louisiana] passes, the
bonds of this Union are virtually dissolved ... that as it will be the
right of all, so it will be the duty of some [states] to prepare
definitely for a separation; amicably if they can, violently if they
must.... It is a death blow to the Constitution. It may afterwards
linger; but lingering, its fate will, at no very distant period, be
consummated." Federalists from New York like those from New England had
their doubts about the wisdom of admitting Western states; but the party
of Jefferson and Madison, having the necessary majority, granted the
coveted statehood to Louisiana in 1812.

When, a few years later, Mississippi and Alabama knocked at the doors of
the union, the Federalists had so little influence, on account of their
conduct during the second war with England, that spokesmen from the
Southwest met a kindlier reception at Washington. Mississippi, in 1817,
and Alabama, in 1819, took their places among the United States of
America. Both of them, while granting white manhood suffrage, gave their
constitutions the tone of the old East by providing landed
qualifications for the governor and members of the legislature.

=Missouri.=--Far to the north in the Louisiana purchase, a new
commonwealth was rising to power. It was peopled by immigrants who came
down the Ohio in fleets of boats or crossed the Mississippi from
Kentucky and Tennessee. Thrifty Germans from Pennsylvania, hardy farmers
from Virginia ready to work with their own hands, freemen seeking
freemen's homes, planters with their slaves moving on from worn-out
fields on the seaboard, came together in the widening settlements of the
Missouri country. Peoples from the North and South flowed together,
small farmers and big planters mingling in one community. When their
numbers had reached sixty thousand or more, they precipitated a contest
over their admission to the union, "ringing an alarm bell in the night,"
as Jefferson phrased it. The favorite expedient of compromise with
slavery was brought forth in Congress once more. Maine consequently was
brought into the union without slavery and Missouri with slavery. At the
same time there was drawn westward through the rest of the Louisiana
territory a line separating servitude from slavery.


THE SPIRIT OF THE FRONTIER

=Land Tenure and Liberty.=--Over an immense western area there developed
an unbroken system of freehold farms. In the Gulf states and the lower
Mississippi Valley, it is true, the planter with his many slaves even
led in the pioneer movement; but through large sections of Tennessee and
Kentucky, as well as upper Georgia and Alabama, and all throughout the
Northwest territory the small farmer reigned supreme. In this immense
dominion there sprang up a civilization without caste or class--a body
of people all having about the same amount of this world's goods and
deriving their livelihood from one source: the labor of their own hands
on the soil. The Northwest territory alone almost equaled in area all
the original thirteen states combined, except Georgia, and its system of
agricultural economy was unbroken by plantations and feudal estates. "In
the subdivision of the soil and the great equality of condition," as
Webster said on more than one occasion, "lay the true basis, most
certainly, of popular government." There was the undoubted source of
Jacksonian democracy.

[Illustration: A LOG CABIN--LINCOLN'S BIRTHPLACE]

=The Characteristics of the Western People.=--Travelers into the
Northwest during the early years of the nineteenth century were agreed
that the people of that region were almost uniformly marked by the
characteristics common to an independent yeomanry. A close observer thus
recorded his impressions: "A spirit of adventurous enterprise, a
willingness to go through any hardship to accomplish an object....
Independence of thought and action. They have felt the influence of
these principles from their childhood. Men who can endure anything; that
have lived almost without restraint, free as the mountain air or as the
deer and the buffalo of their forests, and who know they are Americans
all.... An apparent roughness which some would deem rudeness of
manner.... Where there is perfect equality in a neighborhood of people
who know little about each other's previous history or ancestry but
where each is lord of the soil he cultivates. Where a log cabin is all
that the best of families can expect to have for years and of course can
possess few of the external decorations which have so much influence in
creating a diversity of rank in society. These circumstances have laid
the foundation for that equality of intercourse, simplicity of manners,
want of deference, want of reserve, great readiness to make
acquaintances, freedom of speech, indisposition to brook real or
imaginary insults which one witnesses among people of the West."

This equality, this independence, this rudeness so often described by
the traveler as marking a new country, were all accentuated by the
character of the settlers themselves. Traces of the fierce, unsociable,
eagle-eyed, hard-drinking hunter remained. The settlers who followed the
hunter were, with some exceptions, soldiers of the Revolutionary army,
farmers of the "middling order," and mechanics from the towns,--English,
Scotch-Irish, Germans,--poor in possessions and thrown upon the labor of
their own hands for support. Sons and daughters from well-to-do Eastern
homes sometimes brought softer manners; but the equality of life and the
leveling force of labor in forest and field soon made them one in spirit
with their struggling neighbors. Even the preachers and teachers, who
came when the cabins were raised in the clearings and rude churches and
schoolhouses were built, preached sermons and taught lessons that
savored of the frontier, as any one may know who reads Peter
Cartwright's _A Muscular Christian_ or Eggleston's _The Hoosier
Schoolmaster_.


THE WEST AND THE EAST MEET

=The East Alarmed.=--A people so independent as the Westerners and so
attached to local self-government gave the conservative East many a rude
shock, setting gentlemen in powdered wigs and knee breeches agog with
the idea that terrible things might happen in the Mississippi Valley.
Not without good grounds did Washington fear that "a touch of a feather
would turn" the Western settlers away from the seaboard to the
Spaniards; and seriously did he urge the East not to neglect them, lest
they be "drawn into the arms of, or be dependent upon foreigners."
Taking advantage of the restless spirit in the Southwest, Aaron Burr,
having disgraced himself by killing Alexander Hamilton in a duel, laid
wild plans, if not to bring about a secession in that region, at least
to build a state of some kind out of the Spanish dominions adjoining
Louisiana. Frightened at such enterprises and fearing the dominance of
the West, the Federalists, with a few conspicuous exceptions, opposed
equality between the sections. Had their narrow views prevailed, the
West, with its new democracy, would have been held in perpetual tutelage
to the seaboard or perhaps been driven into independence as the thirteen
colonies had been not long before.

=Eastern Friends of the West.=--Fortunately for the nation, there were
many Eastern leaders, particularly from the South, who understood the
West, approved its spirit, and sought to bring the two sections together
by common bonds. Washington kept alive and keen the zeal for Western
advancement which he acquired in his youth as a surveyor. He never grew
tired of urging upon his Eastern friends the importance of the lands
beyond the mountains. He pressed upon the governor of Virginia a project
for a wagon road connecting the seaboard with the Ohio country and was
active in a movement to improve the navigation of the Potomac. He
advocated strengthening the ties of commerce. "Smooth the roads," he
said, "and make easy the way for them, and then see what an influx of
articles will be poured upon us; how amazingly our exports will be
increased by them; and how amply we shall be compensated for any trouble
and expense we may encounter to effect it." Jefferson, too, was
interested in every phase of Western development--the survey of lands,
the exploration of waterways, the opening of trade, and even the
discovery of the bones of prehistoric animals. Robert Fulton, the
inventor of the steamboat, was another man of vision who for many years
pressed upon his countrymen the necessity of uniting East and West by a
canal which would cement the union, raise the value of the public lands,
and extend the principles of confederate and republican government.

=The Difficulties of Early Transportation.=--Means of communication
played an important part in the strategy of all those who sought to
bring together the seaboard and the frontier. The produce of the
West--wheat, corn, bacon, hemp, cattle, and tobacco--was bulky and the
cost of overland transportation was prohibitive. In the Eastern market,
"a cow and her calf were given for a bushel of salt, while a suit of
'store clothes' cost as much as a farm." In such circumstances, the
inhabitants of the Mississippi Valley were forced to ship their produce
over a long route by way of New Orleans and to pay high freight rates
for everything that was brought across the mountains. Scows of from five
to fifty tons were built at the towns along the rivers and piloted down
the stream to the Crescent City. In a few cases small ocean-going
vessels were built to transport goods to the West Indies or to the
Eastern coast towns. Salt, iron, guns, powder, and the absolute
essentials which the pioneers had to buy mainly in Eastern markets were
carried over narrow wagon trails that were almost impassable in the
rainy season.

=The National Road.=--To far-sighted men, like Albert Gallatin, "the
father of internal improvements," the solution of this problem was the
construction of roads and canals. Early in Jefferson's administration,
Congress dedicated a part of the proceeds from the sale of lands to
building highways from the headwaters of the navigable waters emptying
into the Atlantic to the Ohio River and beyond into the Northwest
territory. In 1806, after many misgivings, it authorized a great
national highway binding the East and the West. The Cumberland Road, as
it was called, began in northwestern Maryland, wound through southern
Pennsylvania, crossed the narrow neck of Virginia at Wheeling, and then
shot almost straight across Ohio, Indiana, and Illinois, into Missouri.
By 1817, stagecoaches were running between Washington and Wheeling; by
1833 contractors had carried their work to Columbus, Ohio, and by 1852,
to Vandalia, Illinois. Over this ballasted road mail and passenger
coaches could go at high speed, and heavy freight wagons proceed in
safety at a steady pace.

[Illustration: THE CUMBERLAND ROAD]

=Canals and Steamboats.=--A second epoch in the economic union of the
East and West was reached with the opening of the Erie Canal in 1825,
offering an all-water route from New York City to the Great Lakes and
the Mississippi Valley. Pennsylvania, alarmed by the advantages
conferred on New York by this enterprise, began her system of canals and
portages from Philadelphia to Pittsburgh, completing the last link in
1834. In the South, the Chesapeake and Ohio Company, chartered in 1825,
was busy with a project to connect Georgetown and Cumberland when
railways broke in upon the undertaking before it was half finished.
About the same time, Ohio built a canal across the state, affording
water communication between Lake Erie and the Ohio River through a rich
wheat belt. Passengers could now travel by canal boat into the West with
comparative ease and comfort, if not at a rapid speed, and the bulkiest
of freight could be easily handled. Moreover, the rate charged for
carrying goods was cut by the Erie Canal from $32 a ton per hundred
miles to $1. New Orleans was destined to lose her primacy in the
Mississippi Valley.

The diversion of traffic to Eastern markets was also stimulated by
steamboats which appeared on the Ohio about 1810, three years after
Fulton had made his famous trip on the Hudson. It took twenty men to
sail and row a five-ton scow up the river at a speed of from ten to
twenty miles a day. In 1825, Timothy Flint traveled a hundred miles a
day on the new steamer _Grecian_ "against the whole weight of the
Mississippi current." Three years later the round trip from Louisville
to New Orleans was cut to eight days. Heavy produce that once had to
float down to New Orleans could be carried upstream and sent to the East
by way of the canal systems.

[Illustration: _From an old print_

AN EARLY MISSISSIPPI STEAMBOAT]

Thus the far country was brought near. The timid no longer hesitated at
the thought of the perilous journey. All routes were crowded with
Western immigrants. The forests fell before the ax like grain before the
sickle. Clearings scattered through the woods spread out into a great
mosaic of farms stretching from the Southern Appalachians to Lake
Michigan. The national census of 1830 gave 937,000 inhabitants to Ohio;
343,000 to Indiana; 157,000 to Illinois; 687,000 to Kentucky; and
681,000 to Tennessee.

[Illustration: DISTRIBUTION OF POPULATION, 1830]

With the increase in population and the growth of agriculture came
political influence. People who had once petitioned Congress now sent
their own representatives. Men who had hitherto accepted without
protests Presidents from the seaboard expressed a new spirit of dissent
in 1824 by giving only three electoral votes for John Quincy Adams; and
four years later they sent a son of the soil from Tennessee, Andrew
Jackson, to take Washington's chair as chief executive of the
nation--the first of a long line of Presidents from the Mississippi
basin.


=References=

W.G. Brown, _The Lower South in American History_.

B.A. Hinsdale, _The Old North West_ (2 vols.).

A.B. Hulbert, _Great American Canals_ and _The Cumberland Road_.

T. Roosevelt, _Thomas H. Benton_.

P.J. Treat, _The National Land System_ (1785-1820).

F.J. Turner, _Rise of the New West_ (American Nation Series).

J. Winsor, _The Westward Movement_.


=Questions=

1. How did the West come to play a role in the Revolution?

2. What preparations were necessary to settlement?

3. Give the principal provisions of the Northwest Ordinance.

4. Explain how freehold land tenure happened to predominate in the West.

5. Who were the early settlers in the West? What routes did they take?
How did they travel?

6. Explain the Eastern opposition to the admission of new Western
states. Show how it was overcome.

7. Trace a connection between the economic system of the West and the
spirit of the people.

8. Who were among the early friends of Western development?

9. Describe the difficulties of trade between the East and the West.

10. Show how trade was promoted.


=Research Topics=

=Northwest Ordinance.=--Analysis of text in Macdonald, _Documentary
Source Book_. Roosevelt, _Winning of the West_, Vol. V, pp. 5-57.

=The West before the Revolution.=--Roosevelt, Vol. I.

=The West during the Revolution.=--Roosevelt, Vols. II and III.

=Tennessee.=--Roosevelt, Vol. V, pp. 95-119 and Vol. VI, pp. 9-87.

=The Cumberland Road.=--A.B. Hulbert, _The Cumberland Road_.

=Early Life in the Middle West.=--Callender, _Economic History of the
United States_, pp. 617-633; 636-641.

=Slavery in the Southwest.=--Callender, pp. 641-652.

=Early Land Policy.=--Callender, pp. 668-680.

=Westward Movement of Peoples.=--Roosevelt, Vol. IV, pp. 7-39.

Lists of books dealing with the early history of Western states are
given in Hart, Channing, and Turner, _Guide to the Study and Reading of
American History_ (rev. ed.), pp. 62-89.

=Kentucky.=--Roosevelt, Vol. IV, pp. 176-263.




CHAPTER XI

JACKSONIAN DEMOCRACY


The New England Federalists, at the Hartford convention, prophesied that
in time the West would dominate the East. "At the adoption of the
Constitution," they said, "a certain balance of power among the original
states was considered to exist, and there was at that time and yet is
among those parties a strong affinity between their great and general
interests. By the admission of these [new] states that balance has been
materially affected and unless the practice be modified must ultimately
be destroyed. The Southern states will first avail themselves of their
new confederates to govern the East, and finally the Western states,
multiplied in number, and augmented in population, will control the
interests of the whole." Strangely enough the fulfillment of this
prophecy was being prepared even in Federalist strongholds by the rise
of a new urban democracy that was to make common cause with the farmers
beyond the mountains.


THE DEMOCRATIC MOVEMENT IN THE EAST

=The Aristocratic Features of the Old Order.=--The Revolutionary
fathers, in setting up their first state constitutions, although they
often spoke of government as founded on the consent of the governed, did
not think that consistency required giving the vote to all adult males.
On the contrary they looked upon property owners as the only safe
"depositary" of political power. They went back to the colonial
tradition that related taxation and representation. This, they argued,
was not only just but a safeguard against the "excesses of democracy."

In carrying their theory into execution they placed taxpaying or
property qualifications on the right to vote. Broadly speaking, these
limitations fell into three classes. Three states, Pennsylvania (1776),
New Hampshire (1784), and Georgia (1798), gave the ballot to all who
paid taxes, without reference to the value of their property. Three,
Virginia, Delaware, and Rhode Island, clung firmly to the ancient
principles that only freeholders could be intrusted with electoral
rights. Still other states, while closely restricting the suffrage,
accepted the ownership of other things as well as land in fulfillment of
the requirements. In Massachusetts, for instance, the vote was granted
to all men who held land yielding an annual income of three pounds or
possessed other property worth sixty pounds.

The electors thus enfranchised, numerous as they were, owing to the wide
distribution of land, often suffered from a very onerous disability. In
many states they were able to vote only for persons of wealth because
heavy property qualifications were imposed on public officers. In New
Hampshire, the governor had to be worth five hundred pounds, one-half in
land; in Massachusetts, one thousand pounds, all freehold; in Maryland,
five thousand pounds, one thousand of which was freehold; in North
Carolina, one thousand pounds freehold; and in South Carolina, ten
thousand pounds freehold. A state senator in Massachusetts had to be the
owner of a freehold worth three hundred pounds or personal property
worth six hundred pounds; in New Jersey, one thousand pounds' worth of
property; in North Carolina, three hundred acres of land; in South
Carolina, two thousand pounds freehold. For members of the lower house
of the legislature lower qualifications were required.

In most of the states the suffrage or office holding or both were
further restricted by religious provisions. No single sect was powerful
enough to dominate after the Revolution, but, for the most part,
Catholics and Jews were either disfranchised or excluded from office.
North Carolina and Georgia denied the ballot to any one who was not a
Protestant. Delaware withheld it from all who did not believe in the
Trinity and the inspiration of the Scriptures. Massachusetts and
Maryland limited it to Christians. Virginia and New York, advanced for
their day, made no discrimination in government on account of religious
opinion.

=The Defense of the Old Order.=--It must not be supposed that property
qualifications were thoughtlessly imposed at the outset or considered of
little consequence in practice. In the beginning they were viewed as
fundamental. As towns grew in size and the number of landless citizens
increased, the restrictions were defended with even more vigor. In
Massachusetts, the great Webster upheld the rights of property in
government, saying: "It is entirely just that property should have its
due weight and consideration in political arrangements.... The
disastrous revolutions which the world has witnessed, those political
thunderstorms and earthquakes which have shaken the pillars of society
to their deepest foundations, have been revolutions against property."
In Pennsylvania, a leader in local affairs cried out against a plan to
remove the taxpaying limitation on the suffrage: "What does the delegate
propose? To place the vicious vagrant, the wandering Arabs, the Tartar
hordes of our large cities on the level with the virtuous and good man?"
In Virginia, Jefferson himself had first believed in property
qualifications and had feared with genuine alarm the "mobs of the great
cities." It was near the end of the eighteenth century before he
accepted the idea of manhood suffrage. Even then he was unable to
convince the constitution-makers of his own state. "It is not an idle
chimera of the brain," urged one of them, "that the possession of land
furnishes the strongest evidence of permanent, common interest with, and
attachment to, the community.... It is upon this foundation I wish to
place the right of suffrage. This is the best general standard which can
be resorted to for the purpose of determining whether the persons to be
invested with the right of suffrage are such persons as could be,
consistently with the safety and well-being of the community, intrusted
with the exercise of that right."

=Attacks on the Restricted Suffrage.=--The changing circumstances of
American life, however, soon challenged the rule of those with property.
Prominent among the new forces were the rising mercantile and business
interests. Where the freehold qualification was applied, business men
who did not own land were deprived of the vote and excluded from office.
In New York, for example, the most illiterate farmer who had one hundred
pounds' worth of land could vote for state senator and governor, while
the landless banker or merchant could not. It is not surprising,
therefore, to find business men taking the lead in breaking down
freehold limitations on the suffrage. The professional classes also were
interested in removing the barriers which excluded many of them from
public affairs. It was a schoolmaster, Thomas Dorr, who led the popular
uprising in Rhode Island which brought the exclusive rule by freeholders
to an end.

In addition to the business and professional classes, the mechanics of
the towns showed a growing hostility to a system of government that
generally barred them from voting or holding office. Though not
numerous, they had early begun to exercise an influence on the course of
public affairs. They had led the riots against the Stamp Act, overturned
King George's statue, and "crammed stamps down the throats of
collectors." When the state constitutions were framed they took a lively
interest, particularly in New York City and Philadelphia. In June, 1776,
the "mechanicks in union" in New York protested against putting the new
state constitution into effect without their approval, declaring that
the right to vote on the acceptance or rejection of a fundamental law
"is the birthright of every man to whatever state he may belong." Though
their petition was rejected, their spirit remained. When, a few years
later, the federal Constitution was being framed, the mechanics watched
the process with deep concern; they knew that one of its main objects
was to promote trade and commerce, affecting directly their daily bread.
During the struggle over ratification, they passed resolutions approving
its provisions and they often joined in parades organized to stir up
sentiment for the Constitution, even though they could not vote for
members of the state conventions and so express their will directly.
After the organization of trade unions they collided with the courts of
law and thus became interested in the election of judges and lawmakers.

Those who attacked the old system of class rule found a strong moral
support in the Declaration of Independence. Was it not said that all men
are created equal? Whoever runs may read. Was it not declared that
governments derive their just power from the consent of the governed?
That doctrine was applied with effect to George III and seemed
appropriate for use against the privileged classes of Massachusetts or
Virginia. "How do the principles thus proclaimed," asked the
non-freeholders of Richmond, in petitioning for the ballot, "accord with
the existing regulation of the suffrage? A regulation which, instead of
the equality nature ordains, creates an odious distinction between
members of the same community ... and vests in a favored class, not in
consideration of their public services but of their private possessions,
the highest of all privileges."

=Abolition of Property Qualifications.=--By many minor victories rather
than by any spectacular triumphs did the advocates of manhood suffrage
carry the day. Slight gains were made even during the Revolution or
shortly afterward. In Pennsylvania, the mechanics, by taking an active
part in the contest over the Constitution of 1776, were able to force
the qualification down to the payment of a small tax. Vermont came into
the union in 1792 without any property restrictions. In the same year
Delaware gave the vote to all men who paid taxes. Maryland, reckoned one
of the most conservative of states, embarked on the experiment of
manhood suffrage in 1809; and nine years later, Connecticut, equally
conservative, decided that all taxpayers were worthy of the ballot.

Five states, Massachusetts, New York, Virginia, Rhode Island, and North
Carolina, remained obdurate while these changes were going on around
them; finally they had to yield themselves. The last struggle in
Massachusetts took place in the constitutional convention of 1820. There
Webster, in the prime of his manhood, and John Adams, in the closing
years of his old age, alike protested against such radical innovations
as manhood suffrage. Their protests were futile. The property test was
abolished and a small tax-paying qualification was substituted. New York
surrendered the next year and, after trying some minor restrictions for
five years, went completely over to white manhood suffrage in 1826.
Rhode Island clung to her freehold qualification through thirty years of
agitation. Then Dorr's Rebellion, almost culminating in bloodshed,
brought about a reform in 1843 which introduced a slight tax-paying
qualification as an alternative to the freehold. Virginia and North
Carolina were still unconvinced. The former refused to abandon ownership
of land as the test for political rights until 1850 and the latter until
1856. Although religious discriminations and property qualifications for
office holders were sometimes retained after the establishment of
manhood suffrage, they were usually abolished along with the monopoly of
government enjoyed by property owners and taxpayers.

[Illustration: THOMAS DORR AROUSING HIS FOLLOWERS]

At the end of the first quarter of the nineteenth century, the white
male industrial workers and the mechanics of the Northern cities, at
least, could lay aside the petition for the ballot and enjoy with the
free farmer a voice in the government of their common country.
"Universal democracy," sighed Carlyle, who was widely read in the United
States, "whatever we may think of it has declared itself the inevitable
fact of the days in which we live; and he who has any chance to instruct
or lead in these days must begin by admitting that ... Where no
government is wanted, save that of the parish constable, as in America
with its boundless soil, every man being able to find work and
recompense for himself, democracy may subsist; not elsewhere." Amid the
grave misgivings of the first generation of statesmen, America was
committed to the great adventure, in the populous towns of the East as
well as in the forests and fields of the West.


THE NEW DEMOCRACY ENTERS THE ARENA

The spirit of the new order soon had a pronounced effect on the
machinery of government and the practice of politics. The enfranchised
electors were not long in demanding for themselves a larger share in
administration.

=The Spoils System and Rotation in Office.=--First of all they wanted
office for themselves, regardless of their fitness. They therefore
extended the system of rewarding party workers with government
positions--a system early established in several states, notably New
York and Pennsylvania. Closely connected with it was the practice of
fixing short terms for officers and making frequent changes in
personnel. "Long continuance in office," explained a champion of this
idea in Pennsylvania in 1837, "unfits a man for the discharge of its
duties, by rendering him arbitrary and aristocratic, and tends to beget,
first life office, and then hereditary office, which leads to the
destruction of free government." The solution offered was the historic
doctrine of "rotation in office." At the same time the principle of
popular election was extended to an increasing number of officials who
had once been appointed either by the governor or the legislature. Even
geologists, veterinarians, surveyors, and other technical officers were
declared elective on the theory that their appointment "smacked of
monarchy."

=Popular Election of Presidential Electors.=--In a short time the spirit
of democracy, while playing havoc with the old order in state
government, made its way upward into the federal system. The framers of
the Constitution, bewildered by many proposals and unable to agree on
any single plan, had committed the choice of presidential electors to
the discretion of the state legislatures. The legislatures, in turn,
greedy of power, early adopted the practice of choosing the electors
themselves; but they did not enjoy it long undisturbed. Democracy,
thundering at their doors, demanded that they surrender the privilege to
the people. Reluctantly they yielded, sometimes granting popular
election and then withdrawing it. The drift was inevitable, and the
climax came with the advent of Jacksonian democracy. In 1824, Vermont,
New York, Delaware, South Carolina, Georgia, and Louisiana, though some
had experimented with popular election, still left the choice of
electors with the legislature. Eight years later South Carolina alone
held to the old practice. Popular election had become the final word.
The fanciful idea of an electoral college of "good and wise men,"
selected without passion or partisanship by state legislatures acting as
deliberative bodies, was exploded for all time; the election of the
nation's chief magistrate was committed to the tempestuous methods of
democracy.

=The Nominating Convention.=--As the suffrage was widened and the
popular choice of presidential electors extended, there arose a violent
protest against the methods used by the political parties in nominating
candidates. After the retirement of Washington, both the Republicans and
the Federalists found it necessary to agree upon their favorites before
the election, and they adopted a colonial device--the pre-election
caucus. The Federalist members of Congress held a conference and
selected their candidate, and the Republicans followed the example. In
a short time the practice of nominating by a "congressional caucus"
became a recognized institution. The election still remained with the
people; but the power of picking candidates for their approval passed
into the hands of a small body of Senators and Representatives.


A reaction against this was unavoidable. To friends of "the plain
people," like Andrew Jackson, it was intolerable, all the more so
because the caucus never favored him with the nomination. More
conservative men also found grave objections to it. They pointed out
that, whereas the Constitution intended the President to be an
independent officer, he had now fallen under the control of a caucus of
congressmen. The supremacy of the legislative branch had been obtained
by an extra-legal political device. To such objections were added
practical considerations. In 1824, when personal rivalry had taken the
place of party conflicts, the congressional caucus selected as the
candidate, William H. Crawford, of Georgia, a man of distinction but no
great popularity, passing by such an obvious hero as General Jackson.
The followers of the General were enraged and demanded nothing short of
the death of "King Caucus." Their clamor was effective. Under their
attacks, the caucus came to an ignominious end.

In place of it there arose in 1831 a new device, the national nominating
convention, composed of delegates elected by party voters for the sole
purpose of nominating candidates. Senators and Representatives were
still prominent in the party councils, but they were swamped by hundreds
of delegates "fresh from the people," as Jackson was wont to say. In
fact, each convention was made up mainly of office holders and office
seekers, and the new institution was soon denounced as vigorously as
King Caucus had been, particularly by statesmen who failed to obtain a
nomination. Still it grew in strength and by 1840 was firmly
established.

=The End of the Old Generation.=--In the election of 1824, the
representatives of the "aristocracy" made their last successful stand.
Until then the leadership by men of "wealth and talents" had been
undisputed. There had been five Presidents--Washington, John Adams,
Jefferson, Madison, and Monroe--all Eastern men brought up in prosperous
families with the advantages of culture which come from leisure and the
possession of life's refinements. None of them had ever been compelled
to work with his hands for a livelihood. Four of them had been
slaveholders. Jefferson was a philosopher, learned in natural science, a
master of foreign languages, a gentleman of dignity and grace of manner,
notwithstanding his studied simplicity. Madison, it was said, was armed
"with all the culture of his century." Monroe was a graduate of William
and Mary, a gentleman of the old school. Jefferson and his three
successors called themselves Republicans and professed a genuine faith
in the people but they were not "of the people" themselves; they were
not sons of the soil or the workshop. They were all men of "the grand

old order of society" who gave finish and style even to popular
government.

Monroe was the last of the Presidents belonging to the heroic epoch of
the Revolution. He had served in the war for independence, in the
Congress under the Articles of Confederation, and in official capacity
after the adoption of the Constitution. In short, he was of the age that
had wrought American independence and set the government afloat. With
his passing, leadership went to a new generation; but his successor,
John Quincy Adams, formed a bridge between the old and the new in that
he combined a high degree of culture with democratic sympathies.
Washington had died in 1799, preceded but a few months by Patrick Henry
and followed in four years by Samuel Adams. Hamilton had been killed in
a duel with Burr in 1804. Thomas Jefferson and John Adams were yet alive
in 1824 but they were soon to pass from the scene, reconciled at last,
full of years and honors. Madison was in dignified retirement, destined
to live long enough to protest against the doctrine of nullification
proclaimed by South Carolina before death carried him away at the ripe
old age of eighty-five.

=The Election of John Quincy Adams (1824).=--The campaign of 1824 marked
the end of the "era of good feeling" inaugurated by the collapse of the
Federalist party after the election of 1816. There were four leading
candidates, John Quincy Adams, Andrew Jackson, Henry Clay, and W.H.
Crawford. The result of the election was a division of the electoral
votes into four parts and no one received a majority. Under the
Constitution, therefore, the selection of President passed to the House
of Representatives. Clay, who stood at the bottom of the poll, threw his
weight to Adams and assured his triumph, much to the chagrin of
Jackson's friends. They thought, with a certain justification, that
inasmuch as the hero of New Orleans had received the largest electoral
vote, the House was morally bound to accept the popular judgment and
make him President. Jackson shook hands cordially with Adams on the day
of the inauguration, but never forgave him for being elected.

While Adams called himself a Republican in politics and often spoke of
"the rule of the people," he was regarded by Jackson's followers as "an
aristocrat." He was not a son of the soil. Neither was he acquainted at
first hand with the labor of farmers and mechanics. He had been educated
at Harvard and in Europe. Like his illustrious father, John Adams, he
was a stern and reserved man, little given to seeking popularity.
Moreover, he was from the East and the frontiersmen of the West regarded
him as a man "born with a silver spoon in his mouth." Jackson's
supporters especially disliked him because they thought their hero
entitled to the presidency. Their anger was deepened when Adams
appointed Clay to the office of Secretary of State; and they set up a
cry that there had been a "deal" by which Clay had helped to elect Adams
to get office for himself.

Though Adams conducted his administration with great dignity and in a
fine spirit of public service, he was unable to overcome the opposition
which he encountered on his election to office or to win popularity in
the West and South. On the contrary, by advocating government assistance
in building roads and canals and public grants in aid of education,
arts, and sciences, he ran counter to the current which had set in
against appropriations of federal funds for internal improvements. By
signing the Tariff Bill of 1828, soon known as the "Tariff of
Abominations," he made new enemies without adding to his friends in New
York, Pennsylvania, and Ohio where he sorely needed them. Handicapped by
the false charge that he had been a party to a "corrupt bargain" with
Clay to secure his first election; attacked for his advocacy of a high
protective tariff; charged with favoring an "aristocracy of
office-holders" in Washington on account of his refusal to discharge
government clerks by the wholesale, Adams was retired from the White
House after he had served four years.

=The Triumph of Jackson in 1828.=--Probably no candidate for the
presidency ever had such passionate popular support as Andrew Jackson
had in 1828. He was truly a man of the people. Born of poor parents in
the upland region of South Carolina, schooled in poverty and adversity,
without the advantages of education or the refinements of cultivated
leisure, he seemed the embodiment of the spirit of the new American
democracy. Early in his youth he had gone into the frontier of Tennessee
where he soon won a name as a fearless and intrepid Indian fighter. On
the march and in camp, he endeared himself to his men by sharing their
hardships, sleeping on the ground with them, and eating parched corn
when nothing better could be found for the privates. From local
prominence he sprang into national fame by his exploit at the battle of
New Orleans. His reputation as a military hero was enhanced by the
feeling that he had been a martyr to political treachery in 1824. The
farmers of the West and South claimed him as their own. The mechanics of
the Eastern cities, newly enfranchised, also looked upon him as their
friend. Though his views on the tariff, internal improvements, and other
issues before the country were either vague or unknown, he was readily
elected President.

The returns of the electoral vote in 1828 revealed the sources of
Jackson's power. In New England, he received but one ballot, from
Maine; he had a majority of the electors in New York and all of them in
Pennsylvania; and he carried every state south of Maryland and beyond
the Appalachians. Adams did not get a single electoral vote in the South
and West. The prophecy of the Hartford convention had been fulfilled.

[Illustration: ANDREW JACKSON]

When Jackson took the oath of office on March 4, 1829, the government of
the United States entered into a new era. Until this time the
inauguration of a President--even that of Jefferson, the apostle of
simplicity--had brought no rude shock to the course of affairs at the
capital. Hitherto the installation of a President meant that an
old-fashioned gentleman, accompanied by a few servants, had driven to
the White House in his own coach, taken the oath with quiet dignity,
appointed a few new men to the higher posts, continued in office the
long list of regular civil employees, and begun his administration with
respectable decorum. Jackson changed all this. When he was inaugurated,
men and women journeyed hundreds of miles to witness the ceremony. Great
throngs pressed into the White House, "upset the bowls of punch, broke
the glasses, and stood with their muddy boots on the satin-covered
chairs to see the people's President." If Jefferson's inauguration was,
as he called it, the "great revolution," Jackson's inauguration was a
cataclysm.


THE NEW DEMOCRACY AT WASHINGTON

=The Spoils System.=--The staid and respectable society of Washington
was disturbed by this influx of farmers and frontiersmen. To speak of
politics became "bad form" among fashionable women. The clerks and
civil servants of the government who had enjoyed long and secure tenure
of office became alarmed at the clamor of new men for their positions.
Doubtless the major portion of them had opposed the election of Jackson
and looked with feelings akin to contempt upon him and his followers.
With a hunter's instinct, Jackson scented his prey. Determined to have
none but his friends in office, he made a clean sweep, expelling old
employees to make room for men "fresh from the people." This was a new
custom. Other Presidents had discharged a few officers for engaging in
opposition politics. They had been careful in making appointments not to
choose inveterate enemies; but they discharged relatively few men on
account of their political views and partisan activities.

By wholesale removals and the frank selection of officers on party
grounds--a practice already well intrenched in New York--Jackson
established the "spoils system" at Washington. The famous slogan, "to
the victor belong the spoils of victory," became the avowed principle of
the national government. Statesmen like Calhoun denounced it; poets like
James Russell Lowell ridiculed it; faithful servants of the government
suffered under it; but it held undisturbed sway for half a century
thereafter, each succeeding generation outdoing, if possible, its
predecessor in the use of public office for political purposes. If any
one remarked that training and experience were necessary qualifications
for important public positions, he met Jackson's own profession of
faith: "The duties of any public office are so simple or admit of being
made so simple that any man can in a short time become master of them."

=The Tariff and Nullification.=--Jackson had not been installed in power
very long before he was compelled to choose between states' rights and
nationalism. The immediate occasion of the trouble was the tariff--a
matter on which Jackson did not have any very decided views. His mind
did not run naturally to abstruse economic questions; and owing to the
divided opinion of the country it was "good politics" to be vague and
ambiguous in the controversy. Especially was this true, because the
tariff issue was threatening to split the country into parties again.

_The Development of the Policy of "Protection."_--The war of 1812 and
the commercial policies of England which followed it had accentuated the
need for American economic independence. During that conflict, the
United States, cut off from English manufactures as during the
Revolution, built up home industries to meet the unusual call for iron,
steel, cloth, and other military and naval supplies as well as the
demands from ordinary markets. Iron foundries and textile mills sprang
up as in the night; hundreds of business men invested fortunes in
industrial enterprises so essential to the military needs of the
government; and the people at large fell into the habit of buying
American-made goods again. As the London _Times_ tersely observed of the
Americans, "their first war with England made them independent; their
second war made them formidable."

In recognition of this state of affairs, the tariff of 1816 was
designed: _first_, to prevent England from ruining these "infant
industries" by dumping the accumulated stores of years suddenly upon
American markets; and, _secondly_, to enlarge in the manufacturing
centers the demand for American agricultural produce. It accomplished
the purposes of its framers. It kept in operation the mills and furnaces
so recently built. It multiplied the number of industrial workers and
enhanced the demand for the produce of the soil. It brought about
another very important result. It turned the capital and enterprise of
New England from shipping to manufacturing, and converted her statesmen,
once friends of low tariffs, into ardent advocates of protection.

In the early years of the nineteenth century, the Yankees had bent their
energies toward building and operating ships to carry produce from
America to Europe and manufactures from Europe to America. For this
reason, they had opposed the tariff of 1816 calculated to increase
domestic production and cut down the carrying trade. Defeated in their
efforts, they accepted the inevitable and turned to manufacturing. Soon
they were powerful friends of protection for American enterprise. As the
money invested and the labor employed in the favored industries
increased, the demand for continued and heavier protection grew apace.
Even the farmers who furnished raw materials, like wool, flax, and hemp,
began to see eye to eye with the manufacturers. So the textile interests
of New England, the iron masters of Connecticut, New Jersey, and
Pennsylvania, the wool, hemp, and flax growers of Ohio, Kentucky, and
Tennessee, and the sugar planters of Louisiana developed into a
formidable combination in support of a high protective tariff.

_The Planting States Oppose the Tariff._--In the meantime, the cotton
states on the seaboard had forgotten about the havoc wrought during the
Napoleonic wars when their produce rotted because there were no ships to
carry it to Europe. The seas were now open. The area devoted to cotton
had swiftly expanded as Alabama, Mississippi, and Louisiana were opened
up. Cotton had in fact become "king" and the planters depended for their
prosperity, as they thought, upon the sale of their staple to English
manufacturers whose spinning and weaving mills were the wonder of the
world. Manufacturing nothing and having to buy nearly everything except
farm produce and even much of that for slaves, the planters naturally
wanted to purchase manufactures in the cheapest market, England, where
they sold most of their cotton. The tariff, they contended, raised the
price of the goods they had to buy and was thus in fact a tribute laid
on them for the benefit of the Northern mill owners.

_The Tariff of Abominations._--They were overborne, however, in 1824 and
again in 1828 when Northern manufacturers and Western farmers forced
Congress to make an upward revision of the tariff. The Act of 1828 known
as "the Tariff of Abominations," though slightly modified in 1832, was
"the straw which broke the camel's back." Southern leaders turned in
rage against the whole system. The legislatures of Virginia, North
Carolina, South Carolina, Georgia, and Alabama denounced it; a general
convention of delegates held at Augusta issued a protest of defiance
against it; and South Carolina, weary of verbal battles, decided to
prevent its enforcement.

_South Carolina Nullifies the Tariff._--The legislature of that state,
on October 26, 1832, passed a bill calling for a state convention which
duly assembled in the following month. In no mood for compromise, it
adopted the famous Ordinance of Nullification after a few days' debate.
Every line of this document was clear and firm. The tariff, it opened,
gives "bounties to classes and individuals ... at the expense and to the
injury and oppression of other classes and individuals"; it is a
violation of the Constitution of the United States and therefore null
and void; its enforcement in South Carolina is unlawful; if the federal
government attempts to coerce the state into obeying the law, "the
people of this state will thenceforth hold themselves absolved from all
further obligations to maintain or preserve their political connection
with the people of the other states and will forthwith proceed to
organize a separate government and do all other acts and things which
sovereign and independent states may of right do."

_Southern States Condemn Nullification._--The answer of the country to
this note of defiance, couched in the language used in the Kentucky
resolutions and by the New England Federalists during the war of 1812,
was quick and positive. The legislatures of the Southern states, while
condemning the tariff, repudiated the step which South Carolina had
taken. Georgia responded: "We abhor the doctrine of nullification as
neither a peaceful nor a constitutional remedy." Alabama found it
"unsound in theory and dangerous in practice." North Carolina replied
that it was "revolutionary in character, subversive of the Constitution
of the United States." Mississippi answered: "It is disunion by
force--it is civil war." Virginia spoke more softly, condemning the
tariff and sustaining the principle of the Virginia resolutions but
denying that South Carolina could find in them any sanction for her
proceedings.

_Jackson Firmly Upholds the Union._--The eyes of the country were turned
upon Andrew Jackson. It was known that he looked with no friendly
feelings upon nullification, for, at a Jefferson dinner in the spring of
1830 while the subject was in the air, he had with laconic firmness
announced a toast: "Our federal union; it must be preserved." When two
years later the open challenge came from South Carolina, he replied that
he would enforce the law, saying with his frontier directness: "If a
single drop of blood shall be shed there in opposition to the laws of
the United States, I will hang the first man I can lay my hands on
engaged in such conduct upon the first tree that I can reach." He made
ready to keep his word by preparing for the use of military and naval
forces in sustaining the authority of the federal government. Then in a
long and impassioned proclamation to the people of South Carolina he
pointed out the national character of the union, and announced his
solemn resolve to preserve it by all constitutional means. Nullification
he branded as "incompatible with the existence of the union,
contradicted expressly by the letter of the Constitution, unauthorized
by its spirit, inconsistent with every principle on which it was
founded, and destructive of the great objects for which it was formed."

_A Compromise._--In his messages to Congress, however, Jackson spoke the
language of conciliation. A few days before issuing his proclamation he
suggested that protection should be limited to the articles of domestic
manufacture indispensable to safety in war time, and shortly afterward
he asked for new legislation to aid him in enforcing the laws. With two
propositions before it, one to remove the chief grounds for South
Carolina's resistance and the other to apply force if it was continued,
Congress bent its efforts to avoid a crisis. On February 12, 1833,
Henry Clay laid before the Senate a compromise tariff bill providing for
the gradual reduction of the duties until by 1842 they would reach the
level of the law which Calhoun had supported in 1816. About the same
time the "force bill," designed to give the President ample authority in
executing the law in South Carolina, was taken up. After a short but
acrimonious debate, both measures were passed and signed by President
Jackson on the same day, March 2. Looking upon the reduction of the
tariff as a complete vindication of her policy and an undoubted victory,
South Carolina rescinded her ordinance and enacted another nullifying
the force bill.

[Illustration: _From an old print._

DANIEL WEBSTER]

_The Webster-Hayne Debate._--Where the actual victory lay in this
quarrel, long the subject of high dispute, need not concern us to-day.
Perhaps the chief result of the whole affair was a clarification of the
issue between the North and the South--a definite statement of the
principles for which men on both sides were years afterward to lay down
their lives. On behalf of nationalism and a perpetual union, the stanch
old Democrat from Tennessee had, in his proclamation on nullification,
spoken a language that admitted of only one meaning. On behalf of
nullification, Senator Hayne, of South Carolina, a skilled lawyer and
courtly orator, had in a great speech delivered in the Senate in
January, 1830, set forth clearly and cogently the doctrine that the
union is a compact among sovereign states from which the parties may
lawfully withdraw. It was this address that called into the arena
Daniel Webster, Senator from Massachusetts, who, spreading the mantle
of oblivion over the Hartford convention, delivered a reply to Hayne
that has been reckoned among the powerful orations of all time--a plea
for the supremacy of the Constitution and the national character of the
union.

=The War on the United States Bank.=--If events forced the issue of
nationalism and nullification upon Jackson, the same could not be said
of his attack on the bank. That institution, once denounced by every
true Jeffersonian, had been reestablished in 1816 under the
administration of Jefferson's disciple, James Madison. It had not been
in operation very long, however, before it aroused bitter opposition,
especially in the South and the West. Its notes drove out of circulation
the paper currency of unsound banks chartered by the states, to the
great anger of local financiers. It was accused of favoritism in making
loans, of conferring special privileges upon politicians in return for
their support at Washington. To all Jackson's followers it was "an
insidious money power." One of them openly denounced it as an
institution designed "to strengthen the arm of wealth and counterpoise
the influence of extended suffrage in the disposition of public
affairs."

This sentiment President Jackson fully shared. In his first message to
Congress he assailed the bank in vigorous language. He declared that its
constitutionality was in doubt and alleged that it had failed to
establish a sound and uniform currency. If such an institution was
necessary, he continued, it should be a public bank, owned and managed
by the government, not a private concern endowed with special privileges
by it. In his second and third messages, Jackson came back to the
subject, leaving the decision, however, to "an enlightened people and
their representatives."

Moved by this frank hostility and anxious for the future, the bank
applied to Congress for a renewal of its charter in 1832, four years
before the expiration of its life. Clay, with his eye upon the
presidency and an issue for the campaign, warmly supported the
application. Congress, deeply impressed by his leadership, passed the
bill granting the new charter, and sent the open defiance to Jackson.
His response was an instant veto. The battle was on and it raged with
fury until the close of his second administration, ending in the
destruction of the bank, a disordered currency, and a national panic.

In his veto message, Jackson attacked the bank as unconstitutional and
even hinted at corruption. He refused to assent to the proposition that
the Supreme Court had settled the question of constitutionality by the
decision in the McCulloch case. "Each public officer," he argued, "who
takes an oath to support the Constitution, swears that he will support
it as he understands it, not as it is understood by others."

Not satisfied with his veto and his declaration against the bank,
Jackson ordered the Secretary of the Treasury to withdraw the government
deposits which formed a large part of the institution's funds. This
action he followed up by an open charge that the bank had used money
shamefully to secure the return of its supporters to Congress. The
Senate, stung by this charge, solemnly resolved that Jackson had
"assumed upon himself authority and power not conferred by the
Constitution and laws, but in derogation of both."

The effects of the destruction of the bank were widespread. When its
charter expired in 1836, banking was once more committed to the control
of the states. The state legislatures, under a decision rendered by the
Supreme Court after the death of Marshall, began to charter banks under
state ownership and control, with full power to issue paper money--this
in spite of the provision in the Constitution that states shall not
issue bills of credit or make anything but gold and silver coin legal
tender in the payment of debts. Once more the country was flooded by
paper currency of uncertain value. To make matters worse, Jackson
adopted the practice of depositing huge amounts of government funds in
these banks, not forgetting to render favors to those institutions which
supported him in politics--"pet banks," as they were styled at the
time. In 1837, partially, though by no means entirely, as a result of
the abolition of the bank, the country was plunged into one of the most
disastrous panics which it ever experienced.

=Internal Improvements Checked.=--The bank had presented to Jackson a
very clear problem--one of destruction. Other questions were not so
simple, particularly the subject of federal appropriations in aid of
roads and other internal improvements. Jefferson had strongly favored
government assistance in such matters, but his administration was
followed by a reaction. Both Madison and Monroe vetoed acts of Congress
appropriating public funds for public roads, advancing as their reason
the argument that the Constitution authorized no such laws. Jackson,
puzzled by the clamor on both sides, followed their example without
making the constitutional bar absolute. Congress, he thought, might
lawfully build highways of a national and military value, but he
strongly deprecated attacks by local interests on the federal treasury.

=The Triumph of the Executive Branch.=--Jackson's reelection in 1832
served to confirm his opinion that he was the chosen leader of the
people, freed and instructed to ride rough shod over Congress and even
the courts. No President before or since ever entertained in times of
peace such lofty notions of executive prerogative. The entire body of
federal employees he transformed into obedient servants of his wishes, a
sign or a nod from him making and undoing the fortunes of the humble and
the mighty. His lawful cabinet of advisers, filling all of the high
posts in the government, he treated with scant courtesy, preferring
rather to secure his counsel and advice from an unofficial body of
friends and dependents who, owing to their secret methods and back
stairs arrangements, became known as "the kitchen cabinet." Under the
leadership of a silent, astute, and resourceful politician, Amos
Kendall, this informal gathering of the faithful both gave and carried
out decrees and orders, communicating the President's lightest wish or
strictest command to the uttermost part of the country. Resolutely and
in the face of bitter opposition Jackson had removed the deposits from
the United States Bank. When the Senate protested against this arbitrary
conduct, he did not rest until it was forced to expunge the resolution
of condemnation; in time one of his lieutenants with his own hands was
able to tear the censure from the records. When Chief Justice Marshall
issued a decree against Georgia which did not suit him, Jackson,
according to tradition, blurted out that Marshall could go ahead and
enforce his own orders. To the end he pursued his willful way, finally
even choosing his own successor.


THE RISE OF THE WHIGS

=Jackson's Measures Arouse Opposition.=--Measures so decided, policies
so radical, and conduct so high-handed could not fail to arouse against
Jackson a deep and exasperated opposition. The truth is the conduct of
his entire administration profoundly disturbed the business and finances
of the country. It was accompanied by conditions similar to those which
existed under the Articles of Confederation. A paper currency, almost as
unstable and irritating as the worthless notes of revolutionary days,
flooded the country, hindering the easy transaction of business. The use
of federal funds for internal improvements, so vital to the exchange of
commodities which is the very life of industry, was blocked by executive
vetoes. The Supreme Court, which, under Marshall, had held refractory
states to their obligations under the Constitution, was flouted; states'
rights judges, deliberately selected by Jackson for the bench, began to
sap and undermine the rulings of Marshall. The protective tariff, under
which the textile industry of New England, the iron mills of
Pennsylvania, and the wool, flax, and hemp farms of the West had
flourished, had received a severe blow in the compromise of 1833 which
promised a steady reduction of duties. To cap the climax, Jackson's
party, casting aside the old and reputable name of Republican, boldly
chose for its title the term "Democrat," throwing down the gauntlet to
every conservative who doubted the omniscience of the people. All these
things worked together to evoke an opposition that was sharp and
determined.

[Illustration: AN OLD CARTOON RIDICULING CLAY'S TARIFF AND INTERNAL
IMPROVEMENT PROGRAM]

=Clay and the National Republicans.=--In this opposition movement,
leadership fell to Henry Clay, a son of Kentucky, rather than to Daniel
Webster of Massachusetts. Like Jackson, Clay was born in a home haunted
by poverty. Left fatherless early and thrown upon his own resources, he
went from Virginia into Kentucky where by sheer force of intellect he
rose to eminence in the profession of law. Without the martial gifts or
the martial spirit of Jackson, he slipped more easily into the social
habits of the East at the same time that he retained his hold on the
affections of the boisterous West. Farmers of Ohio, Indiana, and
Kentucky loved him; financiers of New York and Philadelphia trusted him.
He was thus a leader well fitted to gather the forces of opposition
into union against Jackson.

Around Clay's standard assembled a motley collection, representing every
species of political opinion, united by one tie only--hatred for "Old
Hickory." Nullifiers and less strenuous advocates of states' rights were
yoked with nationalists of Webster's school; ardent protectionists were
bound together with equally ardent free traders, all fraternizing in one
grand confusion of ideas under the title of "National Republicans." Thus
the ancient and honorable term selected by Jefferson and his party, now
abandoned by Jacksonian Democracy, was adroitly adopted to cover the
supporters of Clay. The platform of the party, however, embraced all the
old Federalist principles: protection for American industry; internal
improvements; respect for the Supreme Court; resistance to executive
tyranny; and denunciation of the spoils system. Though Jackson was
easily victorious in 1832, the popular vote cast for Clay should have
given him some doubts about the faith of "the whole people" in the
wisdom of his "reign."

=Van Buren and the Panic of 1837.=--Nothing could shake the General's
superb confidence. At the end of his second term he insisted on
selecting his own successor; at a national convention, chosen by party
voters, but packed with his office holders and friends, he nominated
Martin Van Buren of New York. Once more he proved his strength by
carrying the country for the Democrats. With a fine flourish, he
attended the inauguration of Van Buren and then retired, amid the
applause and tears of his devotees, to the Hermitage, his home in
Tennessee.

Fortunately for him, Jackson escaped the odium of a disastrous panic
which struck the country with terrible force in the following summer.
Among the contributory causes of this crisis, no doubt, were the
destruction of the bank and the issuance of the "specie circular" of

1836 which required the purchasers of public lands to pay for them in
coin, instead of the paper notes of state banks. Whatever the dominating
cause, the ruin was widespread. Bank after bank went under; boom towns
in the West collapsed; Eastern mills shut down; and working people in
the industrial centers, starving from unemployment, begged for relief.
Van Buren braved the storm, offering no measure of reform or assistance
to the distracted people. He did seek security for government funds by
suggesting the removal of deposits from private banks and the
establishment of an independent treasury system, with government
depositaries for public funds, in several leading cities. This plan was
finally accepted by Congress in 1840.

Had Van Buren been a captivating figure he might have lived down the
discredit of the panic unjustly laid at his door; but he was far from
being a favorite with the populace. Though a man of many talents, he
owed his position to the quiet and adept management of Jackson rather
than to his own personal qualities. The men of the frontier did not care
for him. They suspected that he ate from "gold plate" and they could not
forgive him for being an astute politician from New York. Still the
Democratic party, remembering Jackson's wishes, renominated him
unanimously in 1840 and saw him go down to utter defeat.

=The Whigs and General Harrison.=--By this time, the National
Republicans, now known as Whigs--a title taken from the party of
opposition to the Crown in England, had learned many lessons. Taking a
leaf out of the Democratic book, they nominated, not Clay of Kentucky,
well known for his views on the bank, the tariff, and internal
improvements, but a military hero, General William Henry Harrison, a man
of uncertain political opinions. Harrison, a son of a Virginia signer of
the Declaration of Independence, sprang into public view by winning a
battle more famous than important, "Tippecanoe"--a brush with the
Indians in Indiana. He added to his laurels by rendering praiseworthy
services during the war of 1812. When days of peace returned he was
rewarded by a grateful people with a seat in Congress. Then he retired
to quiet life in a little village near Cincinnati. Like Jackson he was
held to be a son of the South and the West. Like Jackson he was a
military hero, a lesser light, but still a light. Like Old Hickory he
rode into office on a tide of popular feeling against an Eastern man
accused of being something of an aristocrat. His personal popularity was
sufficient. The Whigs who nominated him shrewdly refused to adopt a
platform or declare their belief in anything. When some Democrat
asserted that Harrison was a backwoodsman whose sole wants were a jug of
hard cider and a log cabin, the Whigs treated the remark not as an
insult but as proof positive that Harrison deserved the votes of Jackson
men. The jug and the cabin they proudly transformed into symbols of the
campaign, and won for their chieftain 234 electoral votes, while Van
Buren got only sixty.

=Harrison and Tyler.=--The Hero of Tippecanoe was not long to enjoy the
fruits of his victory. The hungry horde of Whig office seekers descended
upon him like wolves upon the fold. If he went out they waylaid him; if
he stayed indoors, he was besieged; not even his bed chamber was spared.
He was none too strong at best and he took a deep cold on the day of his
inauguration. Between driving out Democrats and appeasing Whigs, he fell
mortally ill. Before the end of a month he lay dead at the capitol.

Harrison's successor, John Tyler, the Vice President, whom the Whigs had
nominated to catch votes in Virginia, was more of a Democrat than
anything else, though he was not partisan enough to please anybody. The
Whigs railed at him because he would not approve the founding of another
United States Bank. The Democrats stormed at him for refusing, until
near the end of his term, to sanction the annexation of Texas, which had
declared its independence of Mexico in 1836. His entire administration,
marked by unseemly wrangling, produced only two measures of importance.
The Whigs, flushed by victory, with the aid of a few protectionist
Democrats, enacted, in 1842, a new tariff law destroying the compromise
which had brought about the truce between the North and the South, in
the days of nullification. The distinguished leader of the Whigs, Daniel
Webster, as Secretary of State, in negotiation with Lord Ashburton
representing Great Britain, settled the long-standing dispute between
the two countries over the Maine boundary. A year after closing this
chapter in American diplomacy, Webster withdrew to private life, leaving
the President to endure alone the buffets of political fortune.

To the end, the Whigs regarded Tyler as a traitor to their cause; but
the judgment of history is that it was a case of the biter bitten. They
had nominated him for the vice presidency as a man of views acceptable
to Southern Democrats in order to catch their votes, little reckoning
with the chances of his becoming President. Tyler had not deceived them
and, thoroughly soured, he left the White House in 1845 not to appear in
public life again until the days of secession, when he espoused the
Southern confederacy. Jacksonian Democracy, with new leadership, serving
a new cause--slavery--was returned to power under James K. Polk, a
friend of the General from Tennessee. A few grains of sand were to run
through the hour glass before the Whig party was to be broken and
scattered as the Federalists had been more than a generation before.


THE INTERACTION OF AMERICAN AND EUROPEAN OPINION

=Democracy in England and France.=--During the period of Jacksonian
Democracy, as in all epochs of ferment, there was a close relation
between the thought of the New World and the Old. In England, the
successes of the American experiment were used as arguments in favor of
overthrowing the aristocracy which George III had manipulated with such
effect against America half a century before. In the United States, on
the other hand, conservatives like Chancellor Kent, the stout opponent
of manhood suffrage in New York, cited the riots of the British working
classes as a warning against admitting the same classes to a share in
the government of the United States. Along with the agitation of opinion
went epoch-making events. In 1832, the year of Jackson's second
triumph, the British Parliament passed its first reform bill, which
conferred the ballot--not on workingmen as yet--but on mill owners and
shopkeepers whom the landlords regarded with genuine horror. The initial
step was thus taken in breaking down the privileges of the landed
aristocracy and the rich merchants of England.

About the same time a popular revolution occurred in France. The Bourbon
family, restored to the throne of France by the allied powers after
their victory over Napoleon in 1815, had embarked upon a policy of
arbitrary government. To use the familiar phrase, they had learned
nothing and forgotten nothing. Charles X, who came to the throne in
1824, set to work with zeal to undo the results of the French
Revolution, to stifle the press, restrict the suffrage, and restore the
clergy and the nobility to their ancient rights. His policy encountered
equally zealous opposition and in 1830 he was overthrown. The popular
party, under the leadership of Lafayette, established, not a republic as
some of the radicals had hoped, but a "liberal" middle-class monarchy
under Louis Philippe. This second French Revolution made a profound
impression on Americans, convincing them that the whole world was moving
toward democracy. The mayor, aldermen, and citizens of New York City
joined in a great parade to celebrate the fall of the Bourbons. Mingled
with cheers for the new order in France were hurrahs for "the people's
own, Andrew Jackson, the Hero of New Orleans and President of the United
States!"

=European Interest in America.=--To the older and more settled
Europeans, the democratic experiment in America was either a menace or
an inspiration. Conservatives viewed it with anxiety; liberals with
optimism. Far-sighted leaders could see that the tide of democracy was
rising all over the world and could not be stayed. Naturally the country
that had advanced furthest along the new course was the place in which
to find arguments for and against proposals that Europe should make
experiments of the same character.

=De Tocqueville's _Democracy in America_.=--In addition to the casual
traveler there began to visit the United States the thoughtful observer
bent on finding out what manner of nation this was springing up in the
wilderness. Those who looked with sympathy upon the growing popular
forces of England and France found in the United States, in spite of
many blemishes and defects, a guarantee for the future of the people's
rule in the Old World. One of these, Alexis de Tocqueville, a French
liberal of mildly democratic sympathies, made a journey to this country
in 1831; he described in a very remarkable volume, _Democracy in
America_, the grand experiment as he saw it. On the whole he was
convinced. After examining with a critical eye the life and labor of the
American people, as well as the constitutions of the states and the
nation, he came to the conclusion that democracy with all its faults was
both inevitable and successful. Slavery he thought was a painful
contrast to the other features of American life, and he foresaw what
proved to be the irrepressible conflict over it. He believed that
through blundering the people were destined to learn the highest of all
arts, self-government on a grand scale. The absence of a leisure class,
devoted to no calling or profession, merely enjoying the refinements of
life and adding to its graces--the flaw in American culture that gave
deep distress to many a European leader--de Tocqueville thought a
necessary virtue in the republic. "Amongst a democratic people where
there is no hereditary wealth, every man works to earn a living, or has
worked, or is born of parents who have worked. A notion of labor is
therefore presented to the mind on every side as the necessary, natural,
and honest condition of human existence." It was this notion of a
government in the hands of people who labored that struck the French
publicist as the most significant fact in the modern world.

=Harriet Martineau's Visit to America.=--This phase of American life
also profoundly impressed the brilliant English writer, Harriet
Martineau. She saw all parts of the country, the homes of the rich and
the log cabins of the frontier; she traveled in stagecoaches, canal
boats, and on horseback; and visited sessions of Congress and auctions
at slave markets. She tried to view the country impartially and the
thing that left the deepest mark on her mind was the solidarity of the
people in one great political body. "However various may be the tribes
of inhabitants in those states, whatever part of the world may have been
their birthplace, or that of their fathers, however broken may be their
language, however servile or noble their employments, however exalted or
despised their state, all are declared to be bound together by equal
political obligations.... In that self-governing country all are held to
have an equal interest in the principles of its institutions and to be
bound in equal duty to watch their workings." Miss Martineau was also
impressed with the passion of Americans for land ownership and
contrasted the United States favorably with England where the tillers of
the soil were either tenants or laborers for wages.

=Adverse Criticism.=--By no means all observers and writers were
convinced that America was a success. The fastidious traveler, Mrs.
Trollope, who thought the English system of church and state was ideal,
saw in the United States only roughness and ignorance. She lamented the
"total and universal want of manners both in males and females," adding
that while "they appear to have clear heads and active intellects,"
there was "no charm, no grace in their conversation." She found
everywhere a lack of reverence for kings, learning, and rank. Other
critics were even more savage. The editor of the _Foreign Quarterly_
petulantly exclaimed that the United States was "a brigand
confederation." Charles Dickens declared the country to be "so maimed
and lame, so full of sores and ulcers that her best friends turn from
the loathsome creature in disgust." Sydney Smith, editor of the
_Edinburgh Review_, was never tired of trying his caustic wit at the
expense of America. "Their Franklins and Washingtons and all the other
sages and heroes of their revolution were born and bred subjects of the
king of England," he observed in 1820. "During the thirty or forty
years of their independence they have done absolutely nothing for the
sciences, for the arts, for literature, or even for the statesmanlike
studies of politics or political economy.... In the four quarters of the
globe who reads an American book? Or goes to an American play? Or looks
at an American picture or statue?" To put a sharp sting into his taunt
he added, forgetting by whose authority slavery was introduced and
fostered: "Under which of the old tyrannical governments of Europe is
every sixth man a slave whom his fellow creatures may buy and sell?"

Some Americans, while resenting the hasty and often superficial
judgments of European writers, winced under their satire and took
thought about certain particulars in the indictments brought against
them. The mass of the people, however, bent on the great experiment,
gave little heed to carping critics who saw the flaws and not the
achievements of our country--critics who were in fact less interested in
America than in preventing the rise and growth of democracy in Europe.


=References=

J.S. Bassett, _Life of Andrew Jackson_.

J.W. Burgess, _The Middle Period_.

H. Lodge, _Daniel Webster_.

W. Macdonald, _Jacksonian Democracy_ (American Nation Series).

Ostrogorski, _Democracy and the Organization of Political Parties_, Vol.
II.

C.H. Peck, _The Jacksonian Epoch_.

C. Schurz, _Henry Clay_.


=Questions=

1. By what devices was democracy limited in the first days of our
Republic?

2. On what grounds were the limitations defended? Attacked?

3. Outline the rise of political democracy in the United States.

4. Describe three important changes in our political system.

5. Contrast the Presidents of the old and the new generations.

6. Account for the unpopularity of John Adams' administration.

7. What had been the career of Andrew Jackson before 1829?

8. Sketch the history of the protective tariff and explain the theory
underlying it.

9. Explain the growth of Southern opposition to the tariff.

10. Relate the leading events connected with nullification in South
Carolina.

11. State Jackson's views and tell the outcome of the controversy.

12. Why was Jackson opposed to the bank? How did he finally destroy it?

13. The Whigs complained of Jackson's "executive tyranny." What did they
mean?

14. Give some of the leading events in Clay's career.

15. How do you account for the triumph of Harrison in 1840?

16. Why was Europe especially interested in America at this period? Who
were some of the European writers on American affairs?


=Research Topics=

=Jackson's Criticisms of the Bank.=--Macdonald, _Documentary Source
Book_, pp. 320-329.

=Financial Aspects of the Bank Controversy.=--Dewey, _Financial History
of the United States_, Sections 86-87; Elson, _History of the United
States_, pp. 492-496.

=Jackson's View of the Union.=--See his proclamation on nullification in
Macdonald, pp. 333-340.

=Nullification.=--McMaster, _History of the People of the United
States_, Vol. VI, pp. 153-182; Elson, pp. 487-492.

=The Webster-Hayne Debate.=--Analyze the arguments. Extensive extracts
are given in Macdonald's larger three-volume work, _Select Documents of
United States History, 1776-1761_, pp. 239-260.

=The Character of Jackson's Administration.=--Woodrow Wilson, _History
of the American People_, Vol. IV, pp. 1-87; Elson, pp. 498-501.

=The People in 1830.=--From contemporary writings in Hart, _American
History Told by Contemporaries_, Vol. III, pp. 509-530.

=Biographical Studies.=--Andrew Jackson, J.Q. Adams, Henry Clay, Daniel
Webster, J.C. Calhoun, and W.H. Harrison.




CHAPTER XII

THE MIDDLE BORDER AND THE GREAT WEST


"We shall not send an emigrant beyond the Mississippi in a hundred
years," exclaimed Livingston, the principal author of the Louisiana
purchase. When he made this astounding declaration, he doubtless had
before his mind's eye the great stretches of unoccupied lands between
the Appalachians and the Mississippi. He also had before him the history
of the English colonies, which told him of the two centuries required to
settle the seaboard region. To practical men, his prophecy did not seem
far wrong; but before the lapse of half that time there appeared beyond
the Mississippi a tier of new states, reaching from the Gulf of Mexico
to the southern boundary of Minnesota, and a new commonwealth on the
Pacific Ocean where American emigrants had raised the Bear flag of
California.


THE ADVANCE OF THE MIDDLE BORDER

=Missouri.=--When the middle of the nineteenth century had been reached,
the Mississippi River, which Daniel Boone, the intrepid hunter, had
crossed during Washington's administration "to escape from civilization"
in Kentucky, had become the waterway for a vast empire. The center of
population of the United States had passed to the Ohio Valley. Missouri,
with its wide reaches of rich lands, low-lying, level, and fertile, well
adapted to hemp raising, had drawn to its borders thousands of planters
from the old Southern states--from Virginia and the Carolinas as well as
from Kentucky and Tennessee. When the great compromise of 1820-21
admitted her to the union, wearing "every jewel of sovereignty," as a
florid orator announced, migratory slave owners were assured that their
property would be safe in Missouri. Along the western shore of the
Mississippi and on both banks of the Missouri to the uttermost limits of
the state, plantations tilled by bondmen spread out in broad expanses.
In the neighborhood of Jefferson City the slaves numbered more than a
fourth of the population.

Into this stream of migration from the planting South flowed another
current of land-tilling farmers; some from Kentucky, Tennessee, and
Mississippi, driven out by the onrush of the planters buying and
consolidating small farms into vast estates; and still more from the
East and the Old World. To the northwest over against Iowa and to the
southwest against Arkansas, these yeomen laid out farms to be tilled by
their own labor. In those regions the number of slaves seldom rose above
five or six per cent of the population. The old French post, St. Louis,
enriched by the fur trade of the Far West and the steamboat traffic of
the river, grew into a thriving commercial city, including among its
seventy-five thousand inhabitants in 1850 nearly forty thousand
foreigners, German immigrants from Pennsylvania and Europe being the
largest single element.

=Arkansas.=--Below Missouri lay the territory of Arkansas, which had
long been the paradise of the swarthy hunter and the restless
frontiersman fleeing from the advancing borders of farm and town. In
search of the life, wild and free, where the rifle supplied the game and
a few acres of ground the corn and potatoes, they had filtered into the
territory in an unending drift, "squatting" on the land. Without so much
as asking the leave of any government, territorial or national, they
claimed as their own the soil on which they first planted their feet.
Like the Cherokee Indians, whom they had as neighbors, whose very
customs and dress they sometimes adopted, the squatters spent their days
in the midst of rough plenty, beset by chills, fevers, and the ills of
the flesh, but for many years unvexed by political troubles or the
restrictions of civilized life.

Unfortunately for them, however, the fertile valleys of the Mississippi
and Arkansas were well adapted to the cultivation of cotton and tobacco
and their sylvan peace was soon broken by an invasion of planters. The
newcomers, with their servile workers, spread upward in the valley
toward Missouri and along the southern border westward to the Red River.
In time the slaves in the tier of counties against Louisiana ranged from
thirty to seventy per cent of the population. This marked the doom of
the small farmer, swept Arkansas into the main current of planting
politics, and led to a powerful lobby at Washington in favor of
admission to the union, a boon granted in 1836.

=Michigan.=--In accordance with a well-established custom, a free state
was admitted to the union to balance a slave state. In 1833, the people
of Michigan, a territory ten times the size of Connecticut, announced
that the time had come for them to enjoy the privileges of a
commonwealth. All along the southern border the land had been occupied
largely by pioneers from New England, who built prim farmhouses and
adopted the town-meeting plan of self-government after the fashion of
the old home. The famous post of Detroit was growing into a flourishing
city as the boats plying on the Great Lakes carried travelers, settlers,
and freight through the narrows. In all, according to the census, there
were more than ninety thousand inhabitants in the territory; so it was
not without warrant that they clamored for statehood. Congress, busy as
ever with politics, delayed; and the inhabitants of Michigan, unable to
restrain their impatience, called a convention, drew up a constitution,
and started a lively quarrel with Ohio over the southern boundary. The
hand of Congress was now forced. Objections were made to the new
constitution on the ground that it gave the ballot to all free white
males, including aliens not yet naturalized; but the protests were
overborne in a long debate. The boundary was fixed, and Michigan, though
shorn of some of the land she claimed, came into the union in 1837.

=Wisconsin.=--Across Lake Michigan to the west lay the territory of
Wisconsin, which shared with Michigan the interesting history of the
Northwest, running back into the heroic days when French hunters and
missionaries were planning a French empire for the great monarch, Louis
XIV. It will not be forgotten that the French rangers of the woods, the
black-robed priests, prepared for sacrifice, even to death, the trappers
of the French agencies, and the French explorers--Marquette, Joliet, and
Menard--were the first white men to paddle their frail barks through the
northern waters. They first blazed their trails into the black forests
and left traces of their work in the names of portages and little
villages. It was from these forests that Red Men in full war paint
journeyed far to fight under the _fleur-de-lis_ of France when the
soldiers of King Louis made their last stand at Quebec and Montreal
against the imperial arms of Britain. It was here that the British flag
was planted in 1761 and that the great Pontiac conspiracy was formed two
years later to overthrow British dominion.

When, a generation afterward, the Stars and Stripes supplanted the Union
Jack, the French were still almost the only white men in the region.
They were soon joined by hustling Yankee fur traders who did battle
royal against British interlopers. The traders cut their way through
forest trails and laid out the routes through lake and stream and over
portages for the settlers and their families from the states "back
East." It was the forest ranger who discovered the water power later
used to turn the busy mills grinding the grain from the spreading farm
lands. In the wake of the fur hunters, forest men, and farmers came
miners from Kentucky, Tennessee, and Missouri crowding in to exploit the
lead ores of the northwest, some of them bringing slaves to work their
claims. Had it not been for the gold fever of 1849 that drew the
wielders of pick and shovel to the Far West, Wisconsin would early have
taken high rank among the mining regions of the country.

From a favorable point of vantage on Lake Michigan, the village of
Milwaukee, a center for lumber and grain transport and a place of entry
for Eastern goods, grew into a thriving city. It claimed twenty thousand
inhabitants, when in 1848 Congress admitted Wisconsin to the union.
Already the Germans, Irish, and Scandinavians had found their way into
the territory. They joined Americans from the older states in clearing
forests, building roads, transforming trails into highways, erecting
mills, and connecting streams with canals to make a network of routes
for the traffic that poured to and from the Great Lakes.

=Iowa and Minnesota.=--To the southwest of Wisconsin beyond the
Mississippi, where the tall grass of the prairies waved like the sea,
farmers from New England, New York, and Ohio had prepared Iowa for
statehood. A tide of immigration that might have flowed into Missouri
went northward; for freemen, unaccustomed to slavery and slave markets,
preferred the open country above the compromise line. With incredible
swiftness, they spread farms westward from the Mississippi. With Yankee
ingenuity they turned to trading on the river, building before 1836
three prosperous centers of traffic: Dubuque, Davenport, and Burlington.
True to their old traditions, they founded colleges and academies that
religion and learning might be cherished on the frontier as in the
states from which they came. Prepared for self-government, the Iowans
laid siege to the door of Congress and were admitted to the union in
1846.

Above Iowa, on the Mississippi, lay the territory of Minnesota--the home
of the Dakotas, the Ojibways, and the Sioux. Like Michigan and
Wisconsin, it had been explored early by the French scouts, and the
first white settlement was the little French village of Mendota. To the
people of the United States, the resources of the country were first
revealed by the historic journey of Zebulon Pike in 1805 and by American
fur traders who were quick to take advantage of the opportunity to ply
their arts of hunting and bartering in fresh fields. In 1839 an
American settlement was planted at Marina on the St. Croix, the outpost
of advancing civilization. Within twenty years, the territory, boasting
a population of 150,000, asked for admission to the union. In 1858 the
plea was granted and Minnesota showed her gratitude three years later by
being first among the states to offer troops to Lincoln in the hour of
peril.


ON TO THE PACIFIC--TEXAS AND THE MEXICAN WAR

=The Uniformity of the Middle West.=--There was a certain monotony about
pioneering in the Northwest and on the middle border. As the long
stretches of land were cleared or prepared for the plow, they were laid
out like checkerboards into squares of forty, eighty, one hundred sixty,
or more acres, each the seat of a homestead. There was a striking
uniformity also about the endless succession of fertile fields spreading
far and wide under the hot summer sun. No majestic mountains relieved
the sweep of the prairie. Few monuments of other races and antiquity
were there to awaken curiosity about the region. No sonorous bells in
old missions rang out the time of day. The chaffering Red Man bartering
blankets and furs for powder and whisky had passed farther on. The
population was made up of plain farmers and their families engaged in
severe and unbroken labor, chopping down trees, draining fever-breeding
swamps, breaking new ground, and planting from year to year the same
rotation of crops. Nearly all the settlers were of native American stock
into whose frugal and industrious lives the later Irish and German
immigrants fitted, on the whole, with little friction. Even the Dutch
oven fell before the cast-iron cooking stove. Happiness and sorrow,
despair and hope were there, but all encompassed by the heavy tedium of
prosaic sameness.

[Illustration: SANTA BARBARA MISSION]

=A Contrast in the Far West and Southwest.=--As George Rogers Clark and
Daniel Boone had stirred the snug Americans of the seaboard to seek
their fortunes beyond the Appalachians, so now Kit Carson, James Bowie,
Sam Houston, Davy Crockett, and John C. Fremont were to lead the way
into a new land, only a part of which was under the American flag. The
setting for this new scene in the westward movement was thrown out in a
wide sweep from the headwaters of the Mississippi to the banks of the
Rio Grande; from the valleys of the Sabine and Red rivers to Montana and
the Pacific slope. In comparison with the middle border, this region
presented such startling diversities that only the eye of faith could
foresee the unifying power of nationalism binding its communities with
the older sections of the country. What contrasts indeed! The blue grass
region of Kentucky or the rich, black soil of Illinois--the painted
desert, the home of the sage brush and the coyote! The level prairies of
Iowa--the mighty Rockies shouldering themselves high against the
horizon! The long bleak winters of Wisconsin--California of endless
summer! The log churches of Indiana or Illinois--the quaint missions of
San Antonio, Tucson, and Santa Barbara! The little state of
Delaware--the empire of Texas, one hundred and twenty times its area!
And scattered about through the Southwest were signs of an ancient
civilization--fragments of four-and five-story dwellings, ruined dams,
aqueducts, and broken canals, which told of once prosperous peoples
who, by art and science, had conquered the aridity of the desert and
lifted themselves in the scale of culture above the savages of the
plain.

The settlers of this vast empire were to be as diverse in their origins
and habits as those of the colonies on the coast had been. Americans of
English, Irish, and Scotch-Irish descent came as usual from the Eastern
states. To them were added the migratory Germans as well. Now for the
first time came throngs of Scandinavians. Some were to make their homes
on quiet farms as the border advanced against the setting sun. Others
were to be Indian scouts, trappers, fur hunters, miners, cowboys, Texas
planters, keepers of lonely posts on the plain and the desert, stage
drivers, pilots of wagon trains, pony riders, fruit growers, "lumber
jacks," and smelter workers. One common bond united them--a passion for
the self-government accorded to states. As soon as a few thousand
settlers came together in a single territory, there arose a mighty shout
for a position beside the staid commonwealths of the East and the South.
Statehood meant to the pioneers self-government, dignity, and the right
to dispose of land, minerals, and timber in their own way. In the quest
for this local autonomy there arose many a wordy contest in Congress,
each of the political parties lending a helping hand in the admission of
a state when it gave promise of adding new congressmen of the "right
political persuasion," to use the current phrase.

=Southern Planters and Texas.=--While the farmers of the North found the
broad acres of the Western prairies stretching on before them apparently
in endless expanse, it was far different with the Southern planters.
Ever active in their search for new fields as they exhausted the virgin
soil of the older states, the restless subjects of King Cotton quickly
reached the frontier of Louisiana. There they paused; but only for a
moment. The fertile land of Texas just across the boundary lured them on
and the Mexican republic to which it belonged extended to them a more
than generous welcome. Little realizing the perils lurking in a
"peaceful penetration," the authorities at Mexico City opened wide the
doors and made large grants of land to American contractors, who agreed
to bring a number of families into Texas. The omnipresent Yankee, in the
person of Moses Austin of Connecticut, hearing of this good news in the
Southwest, obtained a grant in 1820 to settle three hundred Americans
near Bexar--a commission finally carried out to the letter by his son
and celebrated in the name given to the present capital of the state of
Texas. Within a decade some twenty thousand Americans had crossed the
border.

=Mexico Closes the Door.=--The government of Mexico, unaccustomed to
such enterprise and thoroughly frightened by its extent, drew back in
dismay. Its fears were increased as quarrels broke out between the
Americans and the natives in Texas. Fear grew into consternation when
efforts were made by President Jackson to buy the territory for the
United States. Mexico then sought to close the flood gates. It stopped
all American colonization schemes, canceled many of the land grants, put
a tariff on farming implements, and abolished slavery. These barriers
were raised too late. A call for help ran through the western border of
the United States. The sentinels of the frontier answered. Davy
Crockett, the noted frontiersman, bear hunter, and backwoods politician;
James Bowie, the dexterous wielder of the knife that to this day bears
his name; and Sam Houston, warrior and pioneer, rushed to the aid of
their countrymen in Texas. Unacquainted with the niceties of diplomacy,
impatient at the formalities of international law, they soon made it
known that in spite of Mexican sovereignty they would be their own
masters.

=The Independence of Texas Declared.=--Numbering only about one-fourth
of the population in Texas, they raised the standard of revolt in 1836
and summoned a convention. Following in the footsteps of their
ancestors, they issued a declaration of independence signed mainly by
Americans from the slave states. Anticipating that the government of
Mexico would not quietly accept their word of defiance as final, they
dispatched a force to repel "the invading army," as General Houston
called the troops advancing under the command of Santa Ana, the Mexican
president. A portion of the Texan soldiers took their stand in the
Alamo, an old Spanish mission in the cottonwood trees in the town of San
Antonio. Instead of obeying the order to blow up the mission and retire,
they held their ground until they were completely surrounded and cut off
from all help. Refusing to surrender, they fought to the bitter end, the
last man falling a victim to the sword. Vengeance was swift. Within
three months General Houston overwhelmed Santa Ana at the San Jacinto,
taking him prisoner of war and putting an end to all hopes for the
restoration of Mexican sovereignty over Texas.

The Lone Star Republic, with Houston at the head, then sought admission
to the United States. This seemed at first an easy matter. All that was
required to bring it about appeared to be a treaty annexing Texas to the
union. Moreover, President Jackson, at the height of his popularity, had
a warm regard for General Houston and, with his usual sympathy for rough
and ready ways of doing things, approved the transaction. Through an
American representative in Mexico, Jackson had long and anxiously
labored, by means none too nice, to wring from the Mexican republic the
cession of the coveted territory. When the Texans took matters into
their own hands, he was more than pleased; but he could not marshal the
approval of two-thirds of the Senators required for a treaty of
annexation. Cautious as well as impetuous, Jackson did not press the
issue; he went out of office in 1837 with Texas uncertain as to her
future.

=Northern Opposition to Annexation.=--All through the North the
opposition to annexation was clear and strong. Anti-slavery agitators
could hardly find words savage enough to express their feelings.
"Texas," exclaimed Channing in a letter to Clay, "is but the first step
of aggression. I trust indeed that Providence will beat back and humble
our cupidity and ambition. I now ask whether as a people we are
prepared to seize on a neighboring territory for the end of extending
slavery? I ask whether as a people we can stand forth in the sight of
God, in the sight of nations, and adopt this atrocious policy? Sooner
perish! Sooner be our name blotted out from the record of nations!"
William Lloyd Garrison called for the secession of the Northern states
if Texas was brought into the union with slavery. John Quincy Adams
warned his countrymen that they were treading in the path of the
imperialism that had brought the nations of antiquity to judgment and
destruction. Henry Clay, the Whig candidate for President, taking into
account changing public sentiment, blew hot and cold, losing the state
of New York and the election of 1844 by giving a qualified approval of
annexation. In the same campaign, the Democrats boldly demanded the
"Reannexation of Texas," based on claims which the United States once
had to Spanish territory beyond the Sabine River.

=Annexation.=--The politicians were disposed to walk very warily. Van
Buren, at heart opposed to slavery extension, refused to press the issue
of annexation. Tyler, a pro-slavery Democrat from Virginia, by a strange
fling of fortune carried into office as a nominal Whig, kept his mind
firmly fixed on the idea of reelection and let the troublesome matter
rest until the end of his administration was in sight. He then listened
with favor to the voice of the South. Calhoun stated what seemed to be a
convincing argument: All good Americans have their hearts set on the
Constitution; the admission of Texas is absolutely essential to the
preservation of the union; it will give a balance of power to the South
as against the North growing with incredible swiftness in wealth and
population. Tyler, impressed by the plea, appointed Calhoun to the
office of Secretary of State in 1844, authorizing him to negotiate the
treaty of annexation--a commission at once executed. This scheme was
blocked in the Senate where the necessary two-thirds vote could not be
secured. Balked but not defeated, the advocates of annexation drew up a
joint resolution which required only a majority vote in both houses,
and in February of the next year, just before Tyler gave way to Polk,
they pushed it through Congress. So Texas, amid the groans of Boston and
the hurrahs of Charleston, folded up her flag and came into the union.

[Illustration: TEXAS AND THE TERRITORY IN DISPUTE]

=The Mexican War.=--The inevitable war with Mexico, foretold by the
abolitionists and feared by Henry Clay, ensued, the ostensible cause
being a dispute over the boundaries of the new state. The Texans claimed
all the lands down to the Rio Grande. The Mexicans placed the border of
Texas at the Nueces River and a line drawn thence in a northerly
direction. President Polk, accepting the Texan view of the controversy,
ordered General Zachary Taylor to move beyond the Nueces in defense of
American sovereignty. This act of power, deemed by the Mexicans an
invasion of their territory, was followed by an attack on our troops.

President Polk, not displeased with the turn of events, announced that
American blood had been "spilled on American soil" and that war existed
"by the act of Mexico." Congress, in a burst of patriotic fervor,
brushed aside the protests of those who deplored the conduct of the
government as wanton aggression on a weaker nation and granted money and
supplies to prosecute the war. The few Whigs in the House of
Representatives, who refused to vote in favor of taking up arms,
accepted the inevitable with such good grace as they could command. All
through the South and the West the war was popular. New England
grumbled, but gave loyal, if not enthusiastic, support to a conflict
precipitated by policies not of its own choosing. Only a handful of firm
objectors held out. James Russell Lowell, in his _Biglow Papers_, flung
scorn and sarcasm to the bitter end.

=The Outcome of the War.=--The foregone conclusion was soon reached.
General Taylor might have delivered the fatal thrust from northern
Mexico if politics had not intervened. Polk, anxious to avoid raising up
another military hero for the Whigs to nominate for President, decided
to divide the honors by sending General Scott to strike a blow at the
capital, Mexico City. The deed was done with speed and pomp and two
heroes were lifted into presidential possibilities. In the Far West a
third candidate was made, John C. Fremont, who, in cooperation with
Commodores Sloat and Stockton and General Kearney, planted the Stars and
Stripes on the Pacific slope.

In February, 1848, the Mexicans came to terms, ceding to the victor
California, Arizona, New Mexico, and more--a domain greater in extent
than the combined areas of France and Germany. As a salve to the wound,
the vanquished received fifteen million dollars in cash and the
cancellation of many claims held by American citizens. Five years later,
through the negotiations of James Gadsden, a further cession of lands
along the southern border of Arizona and New Mexico was secured on
payment of ten million dollars.

=General Taylor Elected President.=--The ink was hardly dry upon the
treaty that closed the war before "rough and ready" General Taylor, a
slave owner from Louisiana, "a Whig," as he said, "but not an ultra
Whig," was put forward as the Whig candidate for President. He himself
had not voted for years and he was fairly innocent in matters political.
The tariff, the currency, and internal improvements, with a magnificent
gesture he referred to the people's representatives in Congress,
offering to enforce the laws as made, if elected. Clay's followers
mourned. Polk stormed but could not win even a renomination at the hands
of the Democrats. So it came about that the hero of Buena Vista,
celebrated for his laconic order, "Give 'em a little more grape, Captain
Bragg," became President of the United States.


THE PACIFIC COAST AND UTAH

=Oregon.=--Closely associated in the popular mind with the contest about
the affairs of Texas was a dispute with Great Britain over the
possession of territory in Oregon. In their presidential campaign of
1844, the Democrats had coupled with the slogan, "The Reannexation of
Texas," two other cries, "The Reoccupation of Oregon," and "Fifty-four
Forty or Fight." The last two slogans were founded on American
discoveries and explorations in the Far Northwest. Their appearance in
politics showed that the distant Oregon country, larger in area than New
England, New York, and Pennsylvania combined, was at last receiving from
the nation the attention which its importance warranted.

_Joint Occupation and Settlement._--Both England and the United States
had long laid claim to Oregon and in 1818 they had agreed to occupy the
territory jointly--a contract which was renewed ten years later for an
indefinite period. Under this plan, citizens of both countries were free
to hunt and settle anywhere in the region. The vanguard of British fur
traders and Canadian priests was enlarged by many new recruits, with
Americans not far behind them. John Jacob Astor, the resourceful New
York merchant, sent out trappers and hunters who established a trading
post at Astoria in 1811. Some twenty years later, American
missionaries--among them two very remarkable men, Jason Lee and Marcus
Whitman--were preaching the gospel to the Indians.

Through news from the fur traders and missionaries, Eastern farmers
heard of the fertile lands awaiting their plows on the Pacific slope;
those with the pioneering spirit made ready to take possession of the
new country. In 1839 a band went around by Cape Horn. Four years later a
great expedition went overland. The way once broken, others followed
rapidly. As soon as a few settlements were well established, the
pioneers held a mass meeting and agreed upon a plan of government. "We,
the people of Oregon territory," runs the preamble to their compact,
"for the purposes of mutual protection and to secure peace and
prosperity among ourselves, agree to adopt the following laws and
regulations until such time as the United States of America extend their
jurisdiction over us." Thus self-government made its way across the
Rocky Mountains.

[Illustration: THE OREGON COUNTRY AND THE DISPUTED BOUNDARY]

_The Boundary Dispute with England Adjusted._--By this time it was
evident that the boundaries of Oregon must be fixed. Having made the
question an issue in his campaign, Polk, after his election in 1844,
pressed it upon the attention of the country. In his inaugural address
and his first message to Congress he reiterated the claim of the
Democratic platform that "our title to the whole territory of Oregon is
clear and unquestionable." This pretension Great Britain firmly
rejected, leaving the President a choice between war and compromise.

Polk, already having the contest with Mexico on his hands, sought and
obtained a compromise. The British government, moved by a hint from the
American minister, offered a settlement which would fix the boundary at
the forty-ninth parallel instead of "fifty-four forty," and give it
Vancouver Island. Polk speedily chose this way out of the dilemma.
Instead of making the decision himself, however, and drawing up a
treaty, he turned to the Senate for "counsel." As prearranged with party
leaders, the advice was favorable to the plan. The treaty, duly drawn in
1846, was ratified by the Senate after an acrimonious debate. "Oh!
mountain that was delivered of a mouse," exclaimed Senator Benton, "thy
name shall be fifty-four forty!" Thirteen years later, the southern part
of the territory was admitted to the union as the state of Oregon,
leaving the northern and eastern sections in the status of a territory.

=California.=--With the growth of the northwestern empire, dedicated by
nature to freedom, the planting interests might have been content, had
fortune not wrested from them the fair country of California. Upon this
huge territory they had set their hearts. The mild climate and fertile
soil seemed well suited to slavery and the planters expected to extend
their sway to the entire domain. California was a state of more than
155,000 square miles--about seventy times the size of the state of
Delaware. It could readily be divided into five or six large states, if
that became necessary to preserve the Southern balance of power.

_Early American Relations with California._--Time and tide, it seems,
were not on the side of the planters. Already Americans of a far
different type were invading the Pacific slope. Long before Polk ever
dreamed of California, the Yankee with his cargo of notions had been
around the Horn. Daring skippers had sailed out of New England harbors
with a variety of goods, bent their course around South America to
California, on to China and around the world, trading as they went and
leaving pots, pans, woolen cloth, guns, boots, shoes, salt fish, naval
stores, and rum in their wake. "Home from Californy!" rang the cry in
many a New England port as a good captain let go his anchor on his
return from the long trading voyage in the Pacific.

[Illustration: THE OVERLAND TRAILS]

_The Overland Trails._--Not to be outdone by the mariners of the deep,
western scouts searched for overland routes to the Pacific. Zebulon
Pike, explorer and pathfinder, by his expedition into the Southwest
during Jefferson's administration, had discovered the resources of New
Spain and had shown his countrymen how easy it was to reach Santa Fe
from the upper waters of the Arkansas River. Not long afterward, traders
laid open the route, making Franklin, Missouri, and later Fort
Leavenworth the starting point. Along the trail, once surveyed, poured
caravans heavily guarded by armed men against marauding Indians. Sand
storms often wiped out all signs of the route; hunger and thirst did
many a band of wagoners to death; but the lure of the game and the
profits at the end kept the business thriving. Huge stocks of cottons,
glass, hardware, and ammunition were drawn almost across the continent
to be exchanged at Santa Fe for furs, Indian blankets, silver, and
mules; and many a fortune was made out of the traffic.

_Americans in California._--Why stop at Santa Fe? The question did not
long remain unanswered. In 1829, Ewing Young broke the path to Los
Angeles. Thirteen years later Fremont made the first of his celebrated
expeditions across plain, desert, and mountain, arousing the interest of
the entire country in the Far West. In the wake of the pathfinders went
adventurers, settlers, and artisans. By 1847, more than one-fifth of the
inhabitants in the little post of two thousand on San Francisco Bay were
from the United States. The Mexican War, therefore, was not the
beginning but the end of the American conquest of California--a conquest
initiated by Americans who went to till the soil, to trade, or to follow
some mechanical pursuit.

_The Discovery of Gold._--As if to clinch the hold on California already
secured by the friends of free soil, there came in 1848 the sudden
discovery of gold at Sutter's Mill in the Sacramento Valley. When this
exciting news reached the East, a mighty rush began to California, over
the trails, across the Isthmus of Panama, and around Cape Horn. Before
two years had passed, it is estimated that a hundred thousand people, in
search of fortunes, had arrived in California--mechanics, teachers,
doctors, lawyers, farmers, miners, and laborers from the four corners of
the earth.

[Illustration: _From an old print_

SAN FRANCISCO IN 1849]

_California a Free State._--With this increase in population there
naturally resulted the usual demand for admission to the union. Instead
of waiting for authority from Washington, the Californians held a
convention in 1849 and framed their constitution. With impatience, the
delegates brushed aside the plea that "the balance of power between the
North and South" required the admission of their state as a slave
commonwealth. Without a dissenting voice, they voted in favor of freedom
and boldly made their request for inclusion among the United States.
President Taylor, though a Southern man, advised Congress to admit the
applicant. Robert Toombs of Georgia vowed to God that he preferred
secession. Henry Clay, the great compromiser, came to the rescue and in
1850 California was admitted as a free state.

=Utah.=--On the long road to California, in the midst of forbidding and
barren wastes, a religious sect, the Mormons, had planted a colony
destined to a stormy career. Founded in 1830 under the leadership of
Joseph Smith of New York, the sect had suffered from many cruel buffets
of fortune. From Ohio they had migrated into Missouri where they were
set upon and beaten. Some of them were murdered by indignant neighbors.
Harried out of Missouri, they went into Illinois only to see their
director and prophet, Smith, first imprisoned by the authorities and
then shot by a mob. Having raised up a cloud of enemies on account of
both their religious faith and their practice of allowing a man to have
more than one wife, they fell in heartily with the suggestion of a new
leader, Brigham Young, that they go into the Far West beyond the plains
of Kansas--into the forlorn desert where the wicked would cease from
troubling and the weary could be at rest, as they read in the Bible. In
1847, Young, with a company of picked men, searched far and wide until
he found a suitable spot overlooking the Salt Lake Valley. Returning to
Illinois, he gathered up his followers, now numbering several thousand,
and in one mighty wagon caravan they all went to their distant haven.

_Brigham Young and His Economic System._--In Brigham Young the Mormons
had a leader of remarkable power who gave direction to the redemption of
the arid soil, the management of property, and the upbuilding of
industry. He promised them to make the desert blossom as the rose, and
verily he did it. He firmly shaped the enterprise of the colony along
co-operative lines, holding down the speculator and profiteer with one
hand and giving encouragement to the industrious poor with the other.
With the shrewdness befitting a good business man, he knew how to draw
the line between public and private interest. Land was given outright to
each family, but great care was exercised in the distribution so that
none should have great advantage over another. The purchase of supplies
and the sale of produce were carried on through a cooperative store, the
profits of which went to the common good. Encountering for the first
time in the history of the Anglo-Saxon race the problem of aridity, the
Mormons surmounted the most perplexing obstacles with astounding skill.
They built irrigation works by cooperative labor and granted water
rights to all families on equitable terms.

_The Growth of Industries._--Though farming long remained the major
interest of the colony, the Mormons, eager to be self-supporting in
every possible way, bent their efforts also to manufacturing and later
to mining. Their missionaries, who hunted in the highways and byways of
Europe for converts, never failed to stress the economic advantages of
the sect. "We want," proclaimed President Young to all the earth, "a
company of woolen manufacturers to come with machinery and take the wool
from the sheep and convert it into the best clothes. We want a company
of potters; we need them; the clay is ready and the dishes wanted.... We
want some men to start a furnace forthwith; the iron, coal, and molders
are waiting.... We have a printing press and any one who can take good
printing and writing paper to the Valley will be a blessing to
themselves and the church." Roads and bridges were built; millions were
spent in experiments in agriculture and manufacturing; missionaries at a
huge cost were maintained in the East and in Europe; an army was kept
for defense against the Indians; and colonies were planted in the
outlying regions. A historian of Deseret, as the colony was called by
the Mormons, estimated in 1895 that by the labor of their hands the
people had produced nearly half a billion dollars in wealth since the
coming of the vanguard.

_Polygamy Forbidden._--The hope of the Mormons that they might forever
remain undisturbed by outsiders was soon dashed to earth, for hundreds
of farmers and artisans belonging to other religious sects came to
settle among them. In 1850 the colony was so populous and prosperous
that it was organized into a territory of the United States and brought
under the supervision of the federal government. Protests against
polygamy were raised in the colony and at the seat of authority three
thousand miles away at Washington. The new Republican party in 1856
proclaimed it "the right and duty of Congress to prohibit in the
Territories those twin relics of barbarism, polygamy and slavery." In
due time the Mormons had to give up their marriage practices which were
condemned by the common opinion of all western civilization; but they
kept their religious faith. Monuments to their early enterprise are seen
in the Temple and the Tabernacle, the irrigation works, and the great
wealth of the Church.


SUMMARY OF WESTERN DEVELOPMENT AND NATIONAL POLITICS

While the statesmen of the old generation were solving the problems of
their age, hunters, pioneers, and home seekers were preparing new
problems beyond the Alleghanies. The West was rising in population and
wealth. Between 1783 and 1829, eleven states were added to the original
thirteen. All but two were in the West. Two of them were in the
Louisiana territory beyond the Mississippi. Here the process of
colonization was repeated. Hardy frontier people cut down the forests,
built log cabins, laid out farms, and cut roads through the wilderness.
They began a new civilization just as the immigrants to Virginia or
Massachusetts had done two centuries earlier.

Like the seaboard colonists before them, they too cherished the spirit
of independence and power. They had not gone far upon their course
before they resented the monopoly of the presidency by the East. In 1829
they actually sent one of their own cherished leaders, Andrew Jackson,
to the White House. Again in 1840, in 1844, in 1848, and in 1860, the
Mississippi Valley could boast that one of its sons had been chosen for
the seat of power at Washington. Its democratic temper evoked a cordial
response in the towns of the East where the old aristocracy had been put
aside and artisans had been given the ballot.

For three decades the West occupied the interest of the nation. Under
Jackson's leadership, it destroyed the second United States Bank. When
he smote nullification in South Carolina, it gave him cordial support.
It approved his policy of parceling out government offices among party
workers--"the spoils system" in all its fullness. On only one point did
it really dissent. The West heartily favored internal improvements, the
appropriation of federal funds for highways, canals, and railways.
Jackson had misgivings on this question and awakened sharp criticism by
vetoing a road improvement bill.

From their point of vantage on the frontier, the pioneers pressed on
westward. They pushed into Texas, created a state, declared their
independence, demanded a place in the union, and precipitated a war with
Mexico. They crossed the trackless plain and desert, laying out trails
to Santa Fe, to Oregon, and to California. They were upon the scene when
the Mexican War brought California under the Stars and Stripes. They had
laid out their farms in the Willamette Valley when the slogan
"Fifty-Four Forty or Fight" forced a settlement of the Oregon boundary.
California and Oregon were already in the union when there arose the
Great Civil War testing whether this nation or any nation so conceived
and so dedicated could long endure.


=References=

G.P. Brown, _Westward Expansion_ (American Nation Series).


K. Coman, _Economic Beginnings of the Far West_ (2 vols.).

F. Parkman, _California and the Oregon Trail_.

R.S. Ripley, _The War with Mexico_.

W.C. Rives, _The United States and Mexico, 1821-48_ (2 vols.).


=Questions=

1. Give some of the special features in the history of Missouri,
Arkansas, Michigan, Wisconsin, Iowa, and Minnesota.

2. Contrast the climate and soil of the Middle West and the Far West.

3. How did Mexico at first encourage American immigration?

4. What produced the revolution in Texas? Who led in it?

5. Narrate some of the leading events in the struggle over annexation to
the United States.

6. What action by President Polk precipitated war?

7. Give the details of the peace settlement with Mexico.

8. What is meant by the "joint occupation" of Oregon?

9. How was the Oregon boundary dispute finally settled?

10. Compare the American "invasion" of California with the migration
into Texas.

11. Explain how California became a free state.

12. Describe the early economic policy of the Mormons.


=Research Topics=

=The Independence of Texas.=--McMaster, _History of the People of the
United States_, Vol. VI, pp. 251-270. Woodrow Wilson, _History of the
American People_, Vol. IV, pp. 102-126.

=The Annexation of Texas.=--McMaster, Vol. VII. The passages on
annexation are scattered through this volume and it is an exercise in
ingenuity to make a connected story of them. Source materials in Hart,
_American History Told by Contemporaries_, Vol. III, pp. 637-655; Elson,
_History of the United States_, pp. 516-521, 526-527.

=The War with Mexico.=--Elson, pp. 526-538.

=The Oregon Boundary Dispute.=--Schafer, _History of the Pacific
Northwest_ (rev. ed.), pp. 88-104; 173-185.

=The Migration to Oregon.=--Schafer, pp. 105-172. Coman, _Economic
Beginnings of the Far West_, Vol. II, pp. 113-166.

=The Santa Fe Trail.=--Coman, _Economic Beginnings_, Vol. II, pp. 75-93.

=The Conquest of California.=--Coman, Vol. II, pp. 297-319.

=Gold in California.=--McMaster, Vol. VII, pp. 585-614.

=The Mormon Migration.=--Coman, Vol. II, pp. 167-206.

=Biographical Studies.=--Fremont, Generals Scott and Taylor, Sam
Houston, and David Crockett.

=The Romance of Western Exploration.=--J.G. Neihardt, _The Splendid
Wayfaring_. J.G. Neihardt, _The Song of Hugh Glass_.




PART V. SECTIONAL CONFLICT AND RECONSTRUCTION




CHAPTER XIII

THE RISE OF THE INDUSTRIAL SYSTEM


If Jefferson could have lived to see the Stars and Stripes planted on
the Pacific Coast, the broad empire of Texas added to the planting
states, and the valley of the Willamette waving with wheat sown by
farmers from New England, he would have been more than fortified in his
faith that the future of America lay in agriculture. Even a stanch old
Federalist like Gouverneur Morris or Josiah Quincy would have mournfully
conceded both the prophecy and the claim. Manifest destiny never seemed
more clearly written in the stars.

As the farmers from the Northwest and planters from the Southwest poured
in upon the floor of Congress, the party of Jefferson, christened anew
by Jackson, grew stronger year by year. Opponents there were, no doubt,
disgruntled critics and Whigs by conviction; but in 1852 Franklin
Pierce, the Democratic candidate for President, carried every state in
the union except Massachusetts, Vermont, Kentucky, and Tennessee. This
victory, a triumph under ordinary circumstances, was all the more
significant in that Pierce was pitted against a hero of the Mexican War,
General Scott, whom the Whigs, hoping to win by rousing the martial
ardor of the voters, had nominated. On looking at the election returns,
the new President calmly assured the planters that "the general
principle of reduction of duties with a view to revenue may now be
regarded as the settled policy of the country." With equal confidence,
he waved aside those agitators who devoted themselves "to the supposed
interests of the relatively few Africans in the United States." Like a
watchman in the night he called to the country: "All's well."

The party of Hamilton and Clay lay in the dust.


THE INDUSTRIAL REVOLUTION

As pride often goeth before a fall, so sanguine expectation is sometimes
the symbol of defeat. Jackson destroyed the bank. Polk signed the tariff
bill of 1846 striking an effective blow at the principle of protection
for manufactures. Pierce promised to silence the abolitionists. His
successor was to approve a drastic step in the direction of free trade.
Nevertheless all these things left untouched the springs of power that
were in due time to make America the greatest industrial nation on the
earth; namely, vast national resources, business enterprise, inventive
genius, and the free labor supply of Europe. Unseen by the thoughtless,
unrecorded in the diaries of wiseacres, rarely mentioned in the speeches
of statesmen, there was swiftly rising such a tide in the affairs of
America as Jefferson and Hamilton never dreamed of in their little
philosophies.

=The Inventors.=--Watt and Boulton experimenting with steam in England,
Whitney combining wood and steel into a cotton gin, Fulton and Fitch
applying the steam engine to navigation, Stevens and Peter Cooper trying
out the "iron horse" on "iron highways," Slater building spinning mills
in Pawtucket, Howe attaching the needle to the flying wheel, Morse
spanning a continent with the telegraph, Cyrus Field linking the markets
of the new world with the old along the bed of the Atlantic, McCormick
breaking the sickle under the reaper--these men and a thousand more were
destroying in a mighty revolution of industry the world of the
stagecoach and the tallow candle which Washington and Franklin had
inherited little changed from the age of Caesar. Whitney was to make
cotton king. Watt and Fulton were to make steel and steam masters of the
world. Agriculture was to fall behind in the race for supremacy.

=Industry Outstrips Planting.=--The story of invention, that tribute to
the triumph of mind over matter, fascinating as a romance, need not be
treated in detail here. The effects of invention on social and political
life, multitudinous and never-ending, form the very warp and woof of
American progress from the days of Andrew Jackson to the latest hour.
Neither the great civil conflict--the clash of two systems--nor the
problems of the modern age can be approached without an understanding of
the striking phases of industrialism.

[Illustration: A NEW ENGLAND MILL BUILT IN 1793]

First and foremost among them was the uprush of mills managed by
captains of industry and manned by labor drawn from farms, cities, and
foreign lands. For every planter who cleared a domain in the Southwest
and gathered his army of bondmen about him, there rose in the North a
magician of steam and steel who collected under his roof an army of free
workers.

In seven league boots this new giant strode ahead of the Southern giant.
Between 1850 and 1859, to use dollars and cents as the measure of
progress, the value of domestic manufactures including mines and
fisheries rose from $1,019,106,616 to $1,900,000,000, an increase of
eighty-six per cent in ten years. In this same period the total
production of naval stores, rice, sugar, tobacco, and cotton, the
staples of the South, went only from $165,000,000, in round figures, to
$204,000,000. At the halfway point of the century, the capital invested
in industry, commerce, and cities far exceeded the value of all the farm
land between the Atlantic and the Pacific; thus the course of economy
had been reversed in fifty years. Tested by figures of production, King
Cotton had shriveled by 1860 to a petty prince in comparison, for each
year the captains of industry turned out goods worth nearly twenty times
all the bales of cotton picked on Southern plantations. Iron, boots and
shoes, and leather goods pouring from Northern mills surpassed in value
the entire cotton output.

=The Agrarian West Turns to Industry.=--Nor was this vast enterprise
confined to the old Northeast where, as Madison had sagely remarked,
commerce was early dominant. "Cincinnati," runs an official report in
1854, "appears to be a great central depot for ready-made clothing and
its manufacture for the Western markets may be said to be one of the
great trades of that city." There, wrote another traveler, "I heard the
crack of the cattle driver's whip and the hum of the factory: the West
and the East meeting." Louisville and St. Louis were already famous for
their clothing trades and the manufacture of cotton bagging. Five
hundred of the two thousand woolen mills in the country in 1860 were in
the Western states. Of the output of flour and grist mills, which almost
reached in value the cotton crop of 1850, the Ohio Valley furnished a
rapidly growing share. The old home of Jacksonian democracy, where
Federalists had been almost as scarce as monarchists, turned slowly
backward, as the needle to the pole, toward the principle of protection
for domestic industry, espoused by Hamilton and defended by Clay.

=The Extension of Canals and Railways.=--As necessary to mechanical
industry as steel and steam power was the great market, spread over a
wide and diversified area and knit together by efficient means of
transportation. This service was supplied to industry by the steamship,
which began its career on the Hudson in 1807; by the canals, of which
the Erie opened in 1825 was the most noteworthy; and by the railways,
which came into practical operation about 1830.

[Illustration: _From an old print_

AN EARLY RAILWAY]

With sure instinct the Eastern manufacturer reached out for the markets
of the Northwest territory where free farmers were producing annually
staggering crops of corn, wheat, bacon, and wool. The two great canal
systems--the Erie connecting New York City with the waterways of the
Great Lakes and the Pennsylvania chain linking Philadelphia with the
headwaters of the Ohio--gradually turned the tide of trade from New
Orleans to the Eastern seaboard. The railways followed the same paths.
By 1860, New York had rail connections with Chicago and St. Louis, one
of the routes running through the Hudson and Mohawk valleys and along
the Great Lakes, the other through Philadelphia and Pennsylvania and
across the rich wheat fields of Ohio, Indiana, and Illinois. Baltimore,
not to be outdone by her two rivals, reached out over the mountains for
the Western trade and in 1857 had trains running into St. Louis.

In railway enterprise the South took more interest than in canals, and
the friends of that section came to its aid. To offset the magnet
drawing trade away from the Mississippi Valley, lines were built from
the Gulf to Chicago, the Illinois Central part of the project being a
monument to the zeal and industry of a Democrat, better known in
politics than in business, Stephen A. Douglas. The swift movement of
cotton and tobacco to the North or to seaports was of common concern to
planters and manufacturers. Accordingly lines were flung down along the
Southern coast, linking Richmond, Charleston, and Savannah with the
Northern markets. Other lines struck inland from the coast, giving a
rail outlet to the sea for Raleigh, Columbia, Atlanta, Chattanooga,
Nashville, and Montgomery. Nevertheless, in spite of this enterprise,
the mileage of all the Southern states in 1860 did not equal that of
Ohio, Indiana, and Illinois combined.

=Banking and Finance.=--Out of commerce and manufactures and the
construction and operation of railways came such an accumulation of
capital in the Northern states as merchants of old never imagined. The
banks of the four industrial states of Massachusetts, Connecticut, New
York, and Pennsylvania in 1860 had funds greater than the banks in all
the other states combined. New York City had become the money market of
America, the center to which industrial companies, railway promoters,
farmers, and planters turned for capital to initiate and carry on their
operations. The banks of Louisiana, South Carolina, Georgia, and
Virginia, it is true, had capital far in excess of the banks of the
Northwest; but still they were relatively small compared with the
financial institutions of the East.

=The Growth of the Industrial Population.=--A revolution of such
magnitude in industry, transport, and finance, overturning as it did the
agrarian civilization of the old Northwest and reaching out to the very
borders of the country, could not fail to bring in its train
consequences of a striking character. Some were immediate and obvious.
Others require a fullness of time not yet reached to reveal their
complete significance. Outstanding among them was the growth of an
industrial population, detached from the land, concentrated in cities,
and, to use Jefferson's phrase, dependent upon "the caprices and
casualties of trade" for a livelihood. This was a result, as the great
Virginian had foreseen, which flowed inevitably from public and private
efforts to stimulate industry as against agriculture.

[Illustration: LOWELL, MASSACHUSETTS, IN 1838, AN EARLY INDUSTRIAL
TOWN]

It was estimated in 1860, on the basis of the census figures, that
mechanical production gave employment to 1,100,000 men and 285,000
women, making, if the average number of dependents upon them be
reckoned, nearly six million people or about one-sixth of the population
of the country sustained from manufactures. "This," runs the official
record, "was exclusive of the number engaged in the production of many
of the raw materials and of the food for manufacturers; in the
distribution of their products, such as merchants, clerks, draymen,
mariners, the employees of railroads, expresses, and steamboats; of
capitalists, various artistic and professional classes, as well as
carpenters, bricklayers, painters, and the members of other mechanical
trades not classed as manufactures. It is safe to assume, then, that
one-third of the whole population is supported, directly, or indirectly,
by manufacturing industry." Taking, however, the number of persons
directly supported by manufactures, namely about six millions, reveals
the astounding fact that the white laboring population, divorced from
the soil, already exceeded the number of slaves on Southern farms and
plantations.

_Immigration._--The more carefully the rapid growth of the industrial
population is examined, the more surprising is the fact that such an
immense body of free laborers could be found, particularly when it is
recalled to what desperate straits the colonial leaders were put in
securing immigrants,--slavery, indentured servitude, and kidnapping
being the fruits of their necessities. The answer to the enigma is to be
found partly in European conditions and partly in the cheapness of
transportation after the opening of the era of steam navigation. Shrewd
observers of the course of events had long foreseen that a flood of
cheap labor was bound to come when the way was made easy. Some, among
them Chief Justice Ellsworth, went so far as to prophesy that white
labor would in time be so abundant that slavery would disappear as the
more costly of the two labor systems. The processes of nature were aided
by the policies of government in England and Germany.

_The Coming of the Irish._--The opposition of the Irish people to the
English government, ever furious and irrepressible, was increased in the
mid forties by an almost total failure of the potato crop, the main
support of the peasants. Catholic in religion, they had been compelled
to support a Protestant church. Tillers of the soil by necessity, they
were forced to pay enormous tributes to absentee landlords in England
whose claim to their estates rested upon the title of conquest and
confiscation. Intensely loyal to their race, the Irish were subjected in
all things to the Parliament at London, in which their small minority of
representatives had little influence save in holding a balance of power
between the two contending English parties. To the constant political
irritation, the potato famine added physical distress beyond
description. In cottages and fields and along the highways the victims
of starvation lay dead by the hundreds, the relief which charity
afforded only bringing misery more sharply to the foreground. Those who
were fortunate enough to secure passage money sought escape to America.
In 1844 the total immigration into the United States was less than
eighty thousand; in 1850 it had risen by leaps and bounds to more than
three hundred thousand. Between 1820 and 1860 the immigrants from the
United Kingdom numbered 2,750,000, of whom more than one-half were
Irish. It has been said with a touch of exaggeration that the American
canals and railways of those days were built by the labor of Irishmen.

_The German Migration._--To political discontent and economic distress,
such as was responsible for the coming of the Irish, may likewise be
traced the source of the Germanic migration. The potato blight that fell
upon Ireland visited the Rhine Valley and Southern Germany at the same
time with results as pitiful, if less extensive. The calamity inflicted
by nature was followed shortly by another inflicted by the despotic
conduct of German kings and princes. In 1848 there had occurred
throughout Europe a popular uprising in behalf of republics and
democratic government. For a time it rode on a full tide of success.
Kings were overthrown, or compelled to promise constitutional
government, and tyrannical ministers fled from their palaces. Then came
reaction. Those who had championed the popular cause were imprisoned,
shot, or driven out of the land. Men of attainments and distinction,
whose sole offense was opposition to the government of kings and
princes, sought an asylum in America, carrying with them to the land of
their adoption the spirit of liberty and democracy. In 1847 over fifty
thousand Germans came to America, the forerunners of a migration that
increased, almost steadily, for many years. The record of 1860 showed
that in the previous twenty years nearly a million and a half had found
homes in the United States. Far and wide they scattered, from the mills
and shops of the seacoast towns to the uttermost frontiers of Wisconsin
and Minnesota.

_The Labor of Women and Children._--If the industries, canals, and
railways of the country were largely manned by foreign labor, still
important native sources must not be overlooked; above all, the women
and children of the New England textile districts. Spinning and weaving,
by a tradition that runs far beyond the written records of mankind,
belonged to women. Indeed it was the dexterous housewives, spinsters,
and boys and girls that laid the foundations of the textile industry in
America, foundations upon which the mechanical revolution was built. As
the wheel and loom were taken out of the homes to the factories operated
by water power or the steam engine, the women and, to use Hamilton's
phrase, "the children of tender years," followed as a matter of course.
"The cotton manufacture alone employs six thousand persons in Lowell,"
wrote a French observer in 1836; "of this number nearly five thousand
are young women from seventeen to twenty-four years of age, the
daughters of farmers from the different New England states." It was not
until after the middle of the century that foreign lands proved to be
the chief source from which workers were recruited for the factories of
New England. It was then that the daughters of the Puritans, outdone by
the competition of foreign labor, both of men and women, left the
spinning jenny and the loom to other hands.

=The Rise of Organized Labor.=--The changing conditions of American
life, marked by the spreading mill towns of New England, New York, and
Pennsylvania and the growth of cities like Buffalo, Cincinnati,
Louisville, St. Louis, Detroit, and Chicago in the West, naturally
brought changes, as Jefferson had prophesied, in "manners and morals." A
few mechanics, smiths, carpenters, and masons, widely scattered through
farming regions and rural villages, raise no such problems as tens of
thousands of workers collected in one center in daily intercourse,
learning the power of cooperation and union.

Even before the coming of steam and machinery, in the "good old days" of
handicrafts, laborers in many trades--printers, shoemakers, carpenters,
for example--had begun to draw together in the towns for the advancement
of their interests in the form of higher wages, shorter days, and
milder laws. The shoemakers of Philadelphia, organized in 1794,
conducted a strike in 1799 and held together until indicted seven years
later for conspiracy. During the twenties and thirties, local labor
unions sprang up in all industrial centers and they led almost
immediately to city federations of the several crafts.

As the thousands who were dependent upon their daily labor for their
livelihood mounted into the millions and industries spread across the
continent, the local unions of craftsmen grew into national craft
organizations bound together by the newspapers, the telegraph, and the
railways. Before 1860 there were several such national trade unions,
including the plumbers, printers, mule spinners, iron molders, and stone
cutters. All over the North labor leaders arose--men unknown to general
history but forceful and resourceful characters who forged links binding
scattered and individual workers into a common brotherhood. An attempt
was even made in 1834 to federate all the crafts into a permanent
national organization; but it perished within three years through lack
of support. Half a century had to elapse before the American Federation
of Labor was to accomplish this task.

All the manifestations of the modern labor movement had appeared, in
germ at least, by the time the mid-century was reached: unions, labor
leaders, strikes, a labor press, a labor political program, and a labor
political party. In every great city industrial disputes were a common
occurrence. The papers recorded about four hundred in two years,
1853-54, local affairs but forecasting economic struggles in a larger
field. The labor press seems to have begun with the founding of the
_Mechanics' Free Press_ in Philadelphia in 1828 and the establishment of
the New York _Workingman's Advocate_ shortly afterward. These
semi-political papers were in later years followed by regular trade
papers designed to weld together and advance the interests of particular
crafts. Edited by able leaders, these little sheets with limited
circulation wielded an enormous influence in the ranks of the workers.

=Labor and Politics.=--As for the political program of labor, the main
planks were clear and specific: the abolition of imprisonment for debt,
manhood suffrage in states where property qualifications still
prevailed, free and universal education, laws protecting the safety and
health of workers in mills and factories, abolition of lotteries, repeal
of laws requiring militia service, and free land in the West.

Into the labor papers and platforms there sometimes crept a note of
hostility to the masters of industry, a sign of bitterness that excited
little alarm while cheap land in the West was open to the discontented.
The Philadelphia workmen, in issuing a call for a local convention,
invited "all those of our fellow citizens who live by their own labor
and none other." In Newcastle county, Delaware, the association of
working people complained in 1830: "The poor have no laws; the laws are
made by the rich and of course for the rich." Here and there an
extremist went to the length of advocating an equal division of wealth
among all the people--the crudest kind of communism.

Agitation of this character produced in labor circles profound distrust
of both Whigs and Democrats who talked principally about tariffs and
banks; it resulted in attempts to found independent labor parties. In
Philadelphia, Albany, New York City, and New England, labor candidates
were put up for elections in the early thirties and in a few cases were
victorious at the polls. "The balance of power has at length got into
the hands of the working people, where it properly belongs,"
triumphantly exclaimed the _Mechanics' Free Press_ of Philadelphia in
1829. But the triumph was illusory. Dissensions appeared in the labor
ranks. The old party leaders, particularly of Tammany Hall, the
Democratic party organization in New York City, offered concessions to
labor in return for votes. Newspapers unsparingly denounced "trade union
politicians" as "demagogues," "levellers," and "rag, tag, and bobtail";
and some of them, deeming labor unrest the sour fruit of manhood
suffrage, suggested disfranchisement as a remedy. Under the influence
of concessions and attacks the political fever quickly died away, and
the end of the decade left no remnant of the labor political parties.
Labor leaders turned to a task which seemed more substantial and
practical, that of organizing workingmen into craft unions for the
definite purpose of raising wages and reducing hours.


THE INDUSTRIAL REVOLUTION AND NATIONAL POLITICS

=Southern Plans for Union with the West.=--It was long the design of
Southern statesmen like Calhoun to hold the West and the South together
in one political party. The theory on which they based their hope was
simple. Both sections were agricultural--the producers of raw materials
and the buyers of manufactured goods. The planters were heavy purchasers
of Western bacon, pork, mules, and grain. The Mississippi River and its
tributaries formed the natural channel for the transportation of heavy
produce southward to the plantations and outward to Europe. Therefore,
ran their political reasoning, the interests of the two sections were
one. By standing together in favor of low tariffs, they could buy their
manufactures cheaply in Europe and pay for them in cotton, tobacco, and
grain. The union of the two sections under Jackson's management seemed
perfect.

=The East Forms Ties with the West.=--Eastern leaders were not blind to
the ambitions of Southern statesmen. On the contrary, they also
recognized the importance of forming strong ties with the agrarian West
and drawing the produce of the Ohio Valley to Philadelphia and New York.
The canals and railways were the physical signs of this economic union,
and the results, commercial and political, were soon evident. By the
middle of the century, Southern economists noted the change, one of
them, De Bow, lamenting that "the great cities of the North have
severally penetrated the interior with artificial lines until they have
taken from the open and untaxed current of the Mississippi the commerce
produced on its borders." To this writer it was an astounding thing to
behold "the number of steamers that now descend the upper Mississippi
River, loaded to the guards with produce, as far as the mouth of the
Illinois River and then turn up that stream with their cargoes to be
shipped to New York _via_ Chicago. The Illinois canal has not only swept
the whole produce along the line of the Illinois River to the East, but
it is drawing the products of the upper Mississippi through the same
channel; thus depriving New Orleans and St. Louis of a rich portion of
their former trade."

If to any shippers the broad current of the great river sweeping down to
New Orleans offered easier means of physical communication to the sea
than the canals and railways, the difference could be overcome by the
credit which Eastern bankers were able to extend to the grain and
produce buyers, in the first instance, and through them to the farmers
on the soil. The acute Southern observer just quoted, De Bow, admitted
with evident regret, in 1852, that "last autumn, the rich regions of
Ohio, Indiana, and Illinois were flooded with the local bank notes of
the Eastern States, advanced by the New York houses on produce to be
shipped by way of the canals in the spring.... These moneyed facilities
enable the packer, miller, and speculator to hold on to their produce
until the opening of navigation in the spring and they are no longer
obliged, as formerly, to hurry off their shipments during the winter by
the way of New Orleans in order to realize funds by drafts on their
shipments. The banking facilities at the East are doing as much to draw
trade from us as the canals and railways which Eastern capital is
constructing." Thus canals, railways, and financial credit were swiftly
forging bonds of union between the old home of Jacksonian Democracy in
the West and the older home of Federalism in the East. The nationalism
to which Webster paid eloquent tribute became more and more real with
the passing of time. The self-sufficiency of the pioneer was broken down
as he began to watch the produce markets of New York and Philadelphia
where the prices of corn and hogs fixed his earnings for the year.

=The West and Manufactures.=--In addition to the commercial bonds
between the East and the West there was growing up a common interest in
manufactures. As skilled white labor increased in the Ohio Valley, the
industries springing up in the new cities made Western life more like
that of the industrial East than like that of the planting South.
Moreover, the Western states produced some important raw materials for
American factories, which called for protection against foreign
competition, notably, wool, hemp, and flax. As the South had little or
no foreign competition in cotton and tobacco, the East could not offer
protection for her raw materials in exchange for protection for
industries. With the West, however, it became possible to establish
reciprocity in tariffs; that is, for example, to trade a high rate on
wool for a high rate on textiles or iron.

=The South Dependent on the North.=--While East and West were drawing
together, the distinctions between North and South were becoming more
marked; the latter, having few industries and producing little save raw
materials, was being forced into the position of a dependent section. As
a result of the protective tariff, Southern planters were compelled to
turn more and more to Northern mills for their cloth, shoes, hats, hoes,
plows, and machinery. Nearly all the goods which they bought in Europe
in exchange for their produce came overseas to Northern ports, whence
transshipments were made by rail and water to Southern points of
distribution. Their rice, cotton, and tobacco, in as far as they were
not carried to Europe in British bottoms, were transported by Northern
masters. In these ways, a large part of the financial operations
connected with the sale of Southern produce and the purchase of goods in
exchange passed into the hands of Northern merchants and bankers who,
naturally, made profits from their transactions. Finally, Southern
planters who wanted to buy more land and more slaves on credit borrowed
heavily in the North where huge accumulations made the rates of interest
lower than the smaller banks of the South could afford.

=The South Reckons the Cost of Economic Dependence.=--As Southern
dependence upon Northern capital became more and more marked, Southern
leaders began to chafe at what they regarded as restraints laid upon
their enterprise. In a word, they came to look upon the planter as a
tribute-bearer to the manufacturer and financier. "The South,"
expostulated De Bow, "stands in the attitude of feeding ... a vast
population of [Northern] merchants, shipowners, capitalists, and others
who, without claims on her progeny, drink up the life blood of her
trade.... Where goes the value of our labor but to those who, taking
advantage of our folly, ship for us, buy for us, sell to us, and, after
turning our own capital to their profitable account, return laden with
our money to enjoy their easily earned opulence at home."

Southern statisticians, not satisfied with generalities, attempted to
figure out how great was this tribute in dollars and cents. They
estimated that the planters annually lent to Northern merchants the full
value of their exports, a hundred millions or more, "to be used in the
manipulation of foreign imports." They calculated that no less than
forty millions all told had been paid to shipowners in profits. They
reckoned that, if the South were to work up her own cotton, she would
realize from seventy to one hundred millions a year that otherwise went
North. Finally, to cap the climax, they regretted that planters spent
some fifteen millions a year pleasure-seeking in the alluring cities and
summer resorts of the North.

=Southern Opposition to Northern Policies.=--Proceeding from these
premises, Southern leaders drew the logical conclusion that the entire
program of economic measures demanded in the North was without exception
adverse to Southern interests and, by a similar chain of reasoning,
injurious to the corn and wheat producers of the West. Cheap labor
afforded by free immigration, a protective tariff raising prices of
manufactures for the tiller of the soil, ship subsidies increasing the
tonnage of carrying trade in Northern hands, internal improvements
forging new economic bonds between the East and the West, a national
banking system giving strict national control over the currency as a
safeguard against paper inflation--all these devices were regarded in
the South as contrary to the planting interest. They were constantly
compared with the restrictive measures by which Great Britain more than
half a century before had sought to bind American interests.

As oppression justified a war for independence once, statesmen argued,
so it can justify it again. "It is curious as it is melancholy and
distressing," came a broad hint from South Carolina, "to see how
striking is the analogy between the colonial vassalage to which the
manufacturing states have reduced the planting states and that which
formerly bound the Anglo-American colonies to the British empire....
England said to her American colonies: 'You shall not trade with the
rest of the world for such manufactures as are produced in the mother
country.' The manufacturing states say to their Southern colonies: 'You
shall not trade with the rest of the world for such manufactures as we
produce.'" The conclusion was inexorable: either the South must control
the national government and its economic measures, or it must declare,
as America had done four score years before, its political and economic
independence. As Northern mills multiplied, as railways spun their
mighty web over the face of the North, and as accumulated capital rose
into the hundreds of millions, the conviction of the planters and their
statesmen deepened into desperation.

=Efforts to Start Southern Industries Fail.=--A few of them, seeing the
predominance of the North, made determined efforts to introduce
manufactures into the South. To the leaders who were averse to secession
and nullification this seemed the only remedy for the growing disparity
in the power of the two sections. Societies for the encouragement of
mechanical industries were formed, the investment of capital was sought,
and indeed a few mills were built on Southern soil. The results were
meager. The natural resources, coal and water power, were abundant; but
the enterprise for direction and the skilled labor were wanting. The
stream of European immigration flowed North and West, not South. The
Irish or German laborer, even if he finally made his home in a city, had
before him, while in the North, the alternative of a homestead on
Western land. To him slavery was a strange, if not a repelling,
institution. He did not take to it kindly nor care to fix his home where
it flourished. While slavery lasted, the economy of the South was
inevitably agricultural. While agriculture predominated, leadership with
equal necessity fell to the planting interest. While the planting
interest ruled, political opposition to Northern economy was destined to
grow in strength.

=The Southern Theory of Sectionalism.=--In the opinion of the statesmen
who frankly represented the planting interest, the industrial system was
its deadly enemy. Their entire philosophy of American politics was
summed up in a single paragraph by McDuffie, a spokesman for South
Carolina: "Owing to the federative character of our government, the
great geographical extent of our territory, and the diversity of the
pursuits of our citizens in different parts of the union, it has so
happened that two great interests have sprung up, standing directly
opposed to each other. One of these consists of those manufactures which
the Northern and Middle states are capable of producing but which, owing
to the high price of labor and the high profits of capital in those
states, cannot hold competition with foreign manufactures without the
aid of bounties, directly or indirectly given, either by the general
government or by the state governments. The other of these interests
consists of the great agricultural staples of the Southern states which
can find a market only in foreign countries and which can be
advantageously sold only in exchange for foreign manufactures which come
in competition with those of the Northern and Middle states.... These
interests then stand diametrically and irreconcilably opposed to each
other. The interest, the pecuniary interest of the Northern
manufacturer, is directly promoted by every increase of the taxes
imposed upon Southern commerce; and it is unnecessary to add that the
interest of the Southern planter is promoted by every diminution of
taxes imposed upon the productions of their industry. If, under these
circumstances, the manufacturers were clothed with the power of imposing
taxes, at their pleasure, upon the foreign imports of the planter, no
doubt would exist in the mind of any man that it would have all the
characteristics of an absolute and unqualified despotism." The economic
soundness of this reasoning, a subject of interesting speculation for
the economist, is of little concern to the historian. The historical
point is that this opinion was widely held in the South and with the
progress of time became the prevailing doctrine of the planting
statesmen.

Their antagonism was deepened because they also became convinced, on
what grounds it is not necessary to inquire, that the leaders of the
industrial interest thus opposed to planting formed a consolidated
"aristocracy of wealth," bent upon the pursuit and attainment of
political power at Washington. "By the aid of various associated
interests," continued McDuffie, "the manufacturing capitalists have
obtained a complete and permanent control over the legislation of
Congress on this subject [the tariff].... Men confederated together upon
selfish and interested principles, whether in pursuit of the offices or
the bounties of the government, are ever more active and vigilant than
the great majority who act from disinterested and patriotic impulses.
Have we not witnessed it on this floor, sir? Who ever knew the tariff
men to divide on any question affecting their confederated interests?...
The watchword is, stick together, right or wrong upon every question
affecting the common cause. Such, sir, is the concert and vigilance and
such the combinations by which the manufacturing party, acting upon the
interests of some and the prejudices of others, have obtained a decided
and permanent control over public opinion in all the tariff states."
Thus, as the Southern statesman would have it, the North, in matters
affecting national policies, was ruled by a "confederated interest"
which menaced the planting interest. As the former grew in magnitude and
attached to itself the free farmers of the West through channels of
trade and credit, it followed as night the day that in time the planters
would be overshadowed and at length overborne in the struggle of giants.
Whether the theory was sound or not, Southern statesmen believed it and
acted upon it.


=References=

M. Beard, _Short History of the American Labor Movement_.

E.L. Bogart, _Economic History of the United States_.

J.R. Commons, _History of Labour in the United States_ (2 vols.).

E.R. Johnson, _American Railway Transportation_.

C.D. Wright, _Industrial Evolution of the United States_.


=Questions=

1. What signs pointed to a complete Democratic triumph in 1852?

2. What is the explanation of the extraordinary industrial progress of
America?

3. Compare the planting system with the factory system.

4. In what sections did industry flourish before the Civil War? Why?

5. Show why transportation is so vital to modern industry and
agriculture.

6. Explain how it was possible to secure so many people to labor in
American industries.

7. Trace the steps in the rise of organized labor before 1860.

8. What political and economic reforms did labor demand?

9. Why did the East and the South seek closer ties with the West?

10. Describe the economic forces which were drawing the East and the
West together.

11. In what way was the South economically dependent upon the North?

12 State the national policies generally favored in the North and
condemned in the South.

13. Show how economic conditions in the South were unfavorable to
industry.

14. Give the Southern explanation of the antagonism between the North
and the South.


=Research Topics=

=The Inventions.=--Assign one to each student. Satisfactory accounts are
to be found in any good encyclopedia, especially the Britannica.

=River and Lake Commerce.=--Callender, _Economic History of the United
States_, pp. 313-326.

=Railways and Canals.=--Callender, pp. 326-344; 359-387. Coman,
_Industrial History of the United States_, pp. 216-225.

=The Growth of Industry, 1815-1840.=--Callender, pp. 459-471. From 1850
to 1860, Callender, pp. 471-486.

=Early Labor Conditions.=--Callender, pp. 701-718.

=Early Immigration.=--Callender, pp. 719-732.

=Clay's Home Market Theory of the Tariff.=--Callender, pp. 498-503.

=The New England View of the Tariff.=--Callender, pp. 503-514.




CHAPTER XIV

THE PLANTING SYSTEM AND NATIONAL POLITICS


James Madison, the father of the federal Constitution, after he had
watched for many days the battle royal in the national convention of
1787, exclaimed that the contest was not between the large and the small
states, but between the commercial North and the planting South. From
the inauguration of Washington to the election of Lincoln the sectional
conflict, discerned by this penetrating thinker, exercised a profound
influence on the course of American politics. It was latent during the
"era of good feeling" when the Jeffersonian Republicans adopted
Federalist policies; it flamed up in the contest between the Democrats
and Whigs. Finally it raged in the angry political quarrel which
culminated in the Civil War.


SLAVERY--NORTH AND SOUTH

=The Decline of Slavery in the North.=--At the time of the adoption of
the Constitution, slavery was lawful in all the Northern states except
Massachusetts. There were almost as many bondmen in New York as in
Georgia. New Jersey had more than Delaware or Tennessee, indeed nearly
as many as both combined. All told, however, there were only about forty
thousand in the North as against nearly seven hundred thousand in the
South. Moreover, most of the Northern slaves were domestic servants, not
laborers necessary to keep mills going or fields under cultivation.

There was, in the North, a steadily growing moral sentiment against the
system. Massachusetts abandoned it in 1780. In the same year,
Pennsylvania provided for gradual emancipation. New Hampshire, where
there had been only a handful, Connecticut with a few thousand
domestics, and New Jersey early followed these examples. New York, in
1799, declared that all children born of slaves after July 4 of that
year should be free, though held for a term as apprentices; and in 1827
it swept away the last vestiges of slavery. So with the passing of the
generation that had framed the Constitution, chattel servitude
disappeared in the commercial states, leaving behind only such
discriminations as disfranchisement or high property qualifications on
colored voters.

=The Growth of Northern Sentiment against Slavery.=--In both sections of
the country there early existed, among those more or less
philosophically inclined, a strong opposition to slavery on moral as
well as economic grounds. In the constitutional convention of 1787,
Gouverneur Morris had vigorously condemned it and proposed that the
whole country should bear the cost of abolishing it. About the same time
a society for promoting the abolition of slavery, under the presidency
of Benjamin Franklin, laid before Congress a petition that serious
attention be given to the emancipation of "those unhappy men who alone
in this land of freedom are degraded into perpetual bondage." When
Congress, acting on the recommendations of President Jefferson, provided
for the abolition of the foreign slave trade on January 1, 1808, several
Northern members joined with Southern members in condemning the system
as well as the trade. Later, colonization societies were formed to
encourage the emancipation of slaves and their return to Africa. James
Madison was president and Henry Clay vice president of such an
organization.

The anti-slavery sentiment of which these were the signs was
nevertheless confined to narrow circles and bore no trace of bitterness.

"We consider slavery your calamity, not your crime," wrote a
distinguished Boston clergyman to his Southern brethren, "and we will
share with you the burden of putting an end to it. We will consent that
the public lands shall be appropriated to this object.... I deprecate
everything which sows discord and exasperating sectional animosities."

=Uncompromising Abolition.=--In a little while the spirit of generosity
was gone. Just as Jacksonian Democracy rose to power there appeared a
new kind of anti-slavery doctrine--the dogmatism of the abolition
agitator. For mild speculation on the evils of the system was
substituted an imperious and belligerent demand for instant
emancipation. If a date must be fixed for its appearance, the year 1831
may be taken when William Lloyd Garrison founded in Boston his
anti-slavery paper, _The Liberator_. With singleness of purpose and
utter contempt for all opposing opinions and arguments, he pursued his
course of passionate denunciation. He apologized for having ever
"assented to the popular but pernicious doctrine of gradual abolition."
He chose for his motto: "Immediate and unconditional emancipation!" He
promised his readers that he would be "harsh as truth and uncompromising
as justice"; that he would not "think or speak or write with
moderation." Then he flung out his defiant call: "I am in earnest--I
will not equivocate--I will not excuse--I will not retreat a single
inch--and I will be heard....

     'Such is the vow I take, so help me God.'"

Though Garrison complained that "the apathy of the people is enough to
make every statue leap from its pedestal," he soon learned how alive the
masses were to the meaning of his propaganda. Abolition orators were
stoned in the street and hissed from the platform. Their meeting places
were often attacked and sometimes burned to the ground. Garrison himself
was assaulted in the streets of Boston, finding refuge from the angry
mob behind prison bars. Lovejoy, a publisher in Alton, Illinois, for his
willingness to give abolition a fair hearing, was brutally murdered; his
printing press was broken to pieces as a warning to all those who
disturbed the nation's peace of mind. The South, doubly frightened by a
slave revolt in 1831 which ended in the murder of a number of men,
women, and children, closed all discussion of slavery in that section.
"Now," exclaimed Calhoun, "it is a question which admits of neither
concession nor compromise."

As the opposition hardened, the anti-slavery agitation gathered in force
and intensity. Whittier blew his blast from the New England hills:

    "No slave-hunt in our borders--no pirate on our strand;
     No fetters in the Bay State--no slave upon our land."

Lowell, looking upon the espousal of a great cause as the noblest aim of
his art, ridiculed and excoriated bondage in the South. Those
abolitionists, not gifted as speakers or writers, signed petitions
against slavery and poured them in upon Congress. The flood of them was
so continuous that the House of Representatives, forgetting its
traditions, adopted in 1836 a "gag rule" which prevented the reading of
appeals and consigned them to the waste basket. Not until the Whigs were
in power nearly ten years later was John Quincy Adams able, after a
relentless campaign, to carry a motion rescinding the rule.

How deep was the impression made upon the country by this agitation for
immediate and unconditional emancipation cannot be measured. If the
popular vote for those candidates who opposed not slavery, but its
extension to the territories, be taken as a standard, it was slight
indeed. In 1844, the Free Soil candidate, Birney, polled 62,000 votes
out of over a million and a half; the Free Soil vote of the next
campaign went beyond a quarter of a million, but the increase was due to
the strength of the leader, Martin Van Buren; four years afterward it
receded to 156,000, affording all the outward signs for the belief that
the pleas of the abolitionist found no widespread response among the
people. Yet the agitation undoubtedly ran deeper than the ballot box.
Young statesmen of the North, in whose hands the destiny of frightful
years was to lie, found their indifference to slavery broken and their
consciences stirred by the unending appeal and the tireless reiteration.
Charles Sumner afterward boasted that he read the _Liberator_ two years
before Wendell Phillips, the young Boston lawyer who cast aside his
profession to take up the dangerous cause.

=Early Southern Opposition to Slavery.=--In the South, the sentiment
against slavery was strong; it led some to believe that it would also
come to an end there in due time. Washington disliked it and directed in
his will that his own slaves should be set free after the death of his
wife. Jefferson, looking into the future, condemned the system by which
he also lived, saying: "Can the liberties of a nation be thought secure
when we have removed their only firm basis, a conviction in the minds of
the people that their liberties are the gift of God? Are they not to be
violated but with His wrath? Indeed I tremble for my country when I
reflect that God is just; that His justice cannot sleep forever." Nor
did Southern men confine their sentiments to expressions of academic
opinion. They accepted in 1787 the Ordinance which excluded slavery from
the Northwest territory forever and also the Missouri Compromise, which
shut it out of a vast section of the Louisiana territory.

=The Revolution in the Slave System.=--Among the representatives of
South Carolina and Georgia, however, the anti-slavery views of
Washington and Jefferson were by no means approved; and the drift of
Southern economy was decidedly in favor of extending and perpetuating,
rather than abolishing, the system of chattel servitude. The invention
of the cotton gin and textile machinery created a market for cotton
which the planters, with all their skill and energy, could hardly
supply. Almost every available acre was brought under cotton culture as
the small farmers were driven steadily from the seaboard into the
uplands or to the Northwest.

The demand for slaves to till the swiftly expanding fields was enormous.
The number of bondmen rose from 700,000 in Washington's day to more than
three millions in 1850. At the same time slavery itself was transformed.
Instead of the homestead where the same family of masters kept the same
families of slaves from generation to generation, came the plantation
system of the Far South and Southwest where masters were ever moving and
ever extending their holdings of lands and slaves. This in turn reacted
on the older South where the raising of slaves for the market became a
regular and highly profitable business.

[Illustration: _From an old print_

JOHN C. CALHOUN]

=Slavery Defended as a Positive Good.=--As the abolition agitation
increased and the planting system expanded, apologies for slavery became
fainter and fainter in the South. Then apologies were superseded by
claims that slavery was a beneficial scheme of labor control. Calhoun,
in a famous speech in the Senate in 1837, sounded the new note by
declaring slavery "instead of an evil, a good--a positive good." His
reasoning was as follows: in every civilized society one portion of the
community must live on the labor of another; learning, science, and the
arts are built upon leisure; the African slave, kindly treated by his
master and mistress and looked after in his old age, is better off than
the free laborers of Europe; and under the slave system conflicts
between capital and labor are avoided. The advantages of slavery in this
respect, he concluded, "will become more and more manifest, if left
undisturbed by interference from without, as the country advances in
wealth and numbers."

=Slave Owners Dominate Politics.=--The new doctrine of Calhoun was
eagerly seized by the planters as they came more and more to overshadow
the small farmers of the South and as they beheld the menace of
abolition growing upon the horizon. It formed, as they viewed matters, a
moral defense for their labor system--sound, logical, invincible. It
warranted them in drawing together for the protection of an institution
so necessary, so inevitable, so beneficent.

Though in 1850 the slave owners were only about three hundred and fifty
thousand in a national population of nearly twenty million whites, they
had an influence all out of proportion to their numbers. They were knit
together by the bonds of a common interest. They had leisure and wealth.
They could travel and attend conferences and conventions. Throughout the
South and largely in the North, they had the press, the schools, and the
pulpits on their side. They formed, as it were, a mighty union for the
protection and advancement of their common cause. Aided by those
mechanics and farmers of the North who stuck by Jacksonian Democracy
through thick and thin, the planters became a power in the federal
government. "We nominate Presidents," exultantly boasted a Richmond
newspaper; "the North elects them."

This jubilant Southern claim was conceded by William H. Seward, a
Republican Senator from New York, in a speech describing the power of
slavery in the national government. "A party," he said, "is in one sense
a joint stock association, in which those who contribute most direct the
action and management of the concern.... The slaveholders, contributing
in an overwhelming proportion to the strength of the Democratic party,
necessarily dictate and prescribe its policy." He went on: "The
slaveholding class has become the governing power in each of the
slaveholding states and it practically chooses thirty of the sixty-two
members of the Senate, ninety of the two hundred and thirty-three
members of the House of Representatives, and one hundred and five of the
two hundred and ninety-five electors of President and Vice-President of
the United States." Then he considered the slave power in the Supreme
Court. "That tribunal," he exclaimed, "consists of a chief justice and
eight associate justices. Of these, five were called from slave states
and four from free states. The opinions and bias of each of them were
carefully considered by the President and Senate when he was appointed.
Not one of them was found wanting in soundness of politics, according to
the slaveholder's exposition of the Constitution." Such was the Northern
view of the planting interest that, from the arena of national politics,
challenged the whole country in 1860.

[Illustration: DISTRIBUTION OF SLAVES IN THE SOUTHERN STATES]


SLAVERY IN NATIONAL POLITICS

=National Aspects of Slavery.=--It may be asked why it was that slavery,
founded originally on state law and subject to state government, was
drawn into the current of national affairs. The answer is simple. There
were, in the first place, constitutional reasons. The Congress of the
United States had to make all needful rules for the government of the
territories, the District of Columbia, the forts and other property
under national authority; so it was compelled to determine whether
slavery should exist in the places subject to its jurisdiction. Upon
Congress was also conferred the power of admitting new states; whenever
a territory asked for admission, the issue could be raised as to whether
slavery should be sanctioned or excluded. Under the Constitution,
provision was made for the return of runaway slaves; Congress had the
power to enforce this clause by appropriate legislation. Since the
control of the post office was vested in the federal government, it had
to face the problem raised by the transmission of abolition literature
through the mails. Finally citizens had the right of petition; it
inheres in all free government and it is expressly guaranteed by the
first amendment to the Constitution. It was therefore legal for
abolitionists to present to Congress their petitions, even if they asked
for something which it had no right to grant. It was thus impossible,
constitutionally, to draw a cordon around the slavery issue and confine
the discussion of it to state politics.

There were, in the second place, economic reasons why slavery was
inevitably drawn into the national sphere. It was the basis of the
planting system which had direct commercial relations with the North and
European countries; it was affected by federal laws respecting tariffs,
bounties, ship subsidies, banking, and kindred matters. The planters of
the South, almost without exception, looked upon the protective tariff
as a tribute laid upon them for the benefit of Northern industries. As
heavy borrowers of money in the North, they were generally in favor of
"easy money," if not paper currency, as an aid in the repayment of their
debts. This threw most of them into opposition to the Whig program for a
United States Bank. All financial aids to American shipping they stoutly
resisted, preferring to rely upon the cheaper service rendered by
English shippers. Internal improvements, those substantial ties that
were binding the West to the East and turning the traffic from New
Orleans to Philadelphia and New York, they viewed with alarm. Free
homesteads from the public lands, which tended to overbalance the South
by building free states, became to them a measure dangerous to their
interests. Thus national economic policies, which could not by any twist
or turn be confined to state control, drew the slave system and its
defenders into the political conflict that centered at Washington.

=Slavery and the Territories--the Missouri Compromise (1820).=--Though
men continually talked about "taking slavery out of politics," it could
not be done. By 1818 slavery had become so entrenched and the
anti-slavery sentiment so strong, that Missouri's quest for admission
brought both houses of Congress into a deadlock that was broken only by
compromise. The South, having half the Senators, could prevent the
admission of Missouri stripped of slavery; and the North, powerful in
the House of Representatives, could keep Missouri with slavery out of
the union indefinitely. An adjustment of pretensions was the last
resort. Maine, separated from the parent state of Massachusetts, was
brought into the union with freedom and Missouri with bondage. At the
same time it was agreed that the remainder of the vast Louisiana
territory north of the parallel of 36 o 30' should be, like the old
Northwest, forever free; while the southern portion was left to slavery.
In reality this was an immense gain for liberty. The area dedicated to
free farmers was many times greater than that left to the planters. The
principle was once more asserted that Congress had full power to prevent
slavery in the territories.

[Illustration: THE MISSOURI COMPROMISE]

=The Territorial Question Reopened by the Wilmot Proviso.=--To the
Southern leaders, the annexation of Texas and the conquest of Mexico
meant renewed security to the planting interest against the increasing
wealth and population of the North. Texas, it was said, could be divided
into four slave states. The new territories secured by the treaty of
peace with Mexico contained the promise of at least three more. Thus, as
each new free soil state knocked for admission into the union, the
South could demand as the price of its consent a new slave state. No
wonder Southern statesmen saw, in the annexation of Texas and the
conquest of Mexico, slavery and King Cotton triumphant--secure for all
time against adverse legislation. Northern leaders were equally
convinced that the Southern prophecy was true. Abolitionists and
moderate opponents of slavery alike were in despair. Texas, they
lamented, would fasten slavery upon the country forevermore. "No living
man," cried one, "will see the end of slavery in the United States!"

It so happened, however, that the events which, it was thought, would
secure slavery let loose a storm against it. A sign appeared first on
August 6, 1846, only a few months after war was declared on Mexico. On
that day, David Wilmot, a Democrat from Pennsylvania, introduced into
the House of Representatives a resolution to the effect that, as an
express and fundamental condition to the acquisition of any territory
from the republic of Mexico, slavery should be forever excluded from
every part of it. "The Wilmot Proviso," as the resolution was popularly
called, though defeated on that occasion, was a challenge to the South.

The South answered the challenge. Speaking in the House of
Representatives, Robert Toombs of Georgia boldly declared: "In the
presence of the living God, if by your legislation you seek to drive us
from the territories of California and New Mexico ... I am for
disunion." South Carolina announced that the day for talk had passed and
the time had come to join her sister states "in resisting the
application of the Wilmot Proviso at any and all hazards." A conference,
assembled at Jackson, Mississippi, in the autumn of 1849, called a
general convention of Southern states to meet at Nashville the following
summer. The avowed purpose was to arrest "the course of aggression" and,
if that was not possible, to provide "in the last resort for their
separate welfare by the formation of a compact and union that will
afford protection to their liberties and rights." States that had
spurned South Carolina's plea for nullification in 1832 responded to
this new appeal with alacrity--an augury of the secession to come.

[Illustration: _From an old print._

HENRY CLAY]

=The Great Debate of 1850.=--The temper of the country was white hot
when Congress convened in December, 1849. It was a memorable session,
memorable for the great men who took part in the debates and memorable
for the grand Compromise of 1850 which it produced. In the Senate sat
for the last time three heroic figures: Webster from the North, Calhoun
from the South, and Clay from a border state. For nearly forty years
these three had been leaders of men. All had grown old and gray in
service. Calhoun was already broken in health and in a few months was to
be borne from the political arena forever. Clay and Webster had but two
more years in their allotted span.

Experience, learning, statecraft--all these things they now marshaled in
a mighty effort to solve the slavery problem. On January 29, 1850, Clay
offered to the Senate a compromise granting concessions to both sides;
and a few days later, in a powerful oration, he made a passionate appeal
for a union of hearts through mutual sacrifices. Calhoun relentlessly
demanded the full measure of justice for the South: equal rights in the
territories bought by common blood; the return of runaway slaves as
required by the Constitution; the suppression of the abolitionists; and
the restoration of the balance of power between the North and the South.
Webster, in his notable "Seventh of March speech," condemned the Wilmot
Proviso, advocated a strict enforcement of the fugitive slave law,
denounced the abolitionists, and made a final plea for the Constitution,
union, and liberty. This was the address which called forth from
Whittier the poem, "Ichabod," deploring the fall of the mighty one whom
he thought lost to all sense of faith and honor.

=The Terms of the Compromise of 1850.=--When the debates were closed,
the results were totaled in a series of compromise measures, all of
which were signed in September, 1850, by the new President, Millard
Fillmore, who had taken office two months before on the death of Zachary
Taylor. By these acts the boundaries of Texas were adjusted and the
territory of New Mexico created, subject to the provision that all or
any part of it might be admitted to the union "with or without slavery
as their constitution may provide at the time of their admission." The
Territory of Utah was similarly organized with the same conditions as to
slavery, thus repudiating the Wilmot Proviso without guaranteeing
slavery to the planters. California was admitted as a free state under a
constitution in which the people of the territory had themselves
prohibited slavery.

The slave trade was abolished in the District of Columbia, but slavery
itself existed as before at the capital of the nation. This concession
to anti-slavery sentiment was more than offset by a fugitive slave law,
drastic in spirit and in letter. It placed the enforcement of its terms
in the hands of federal officers appointed from Washington and so
removed it from the control of authorities locally elected. It provided
that masters or their agents, on filing claims in due form, might
summarily remove their escaped slaves without affording their "alleged
fugitives" the right of trial by jury, the right to witness, the right
to offer any testimony in evidence. Finally, to "put teeth" into the
act, heavy penalties were prescribed for all who obstructed or assisted
in obstructing the enforcement of the law. Such was the Great Compromise
of 1850.

[Illustration: AN OLD CARTOON REPRESENTING WEBSTER "STEALING CLAY'S
THUNDER"]

=The Pro-slavery Triumph in the Election of 1852.=--The results of the
election of 1852 seemed to show conclusively that the nation was weary
of slavery agitation and wanted peace. Both parties, Whigs and
Democrats, endorsed the fugitive slave law and approved the Great
Compromise. The Democrats, with Franklin Pierce as their leader, swept
the country against the war hero, General Winfield Scott, on whom the
Whigs had staked their hopes. Even Webster, broken with grief at his
failure to receive the nomination, advised his friends to vote for
Pierce and turned away from politics to meditate upon approaching death.
The verdict of the voters would seem to indicate that for the time
everybody, save a handful of disgruntled agitators, looked upon Clay's
settlement as the last word. "The people, especially the business men of
the country," says Elson, "were utterly weary of the agitation and they
gave their suffrages to the party that promised them rest." The Free
Soil party, condemning slavery as "a sin against God and a crime against
man," and advocating freedom for the territories, failed to carry a
single state. In fact it polled fewer votes than it had four years
earlier--156,000 as against nearly 3,000,000, the combined vote of the
Whigs and Democrats. It is not surprising, therefore, that President
Pierce, surrounded in his cabinet by strong Southern sympathizers, could
promise to put an end to slavery agitation and to crush the abolition
movement in the bud.

=Anti-slavery Agitation Continued.=--The promise was more difficult to
fulfill than to utter. In fact, the vigorous execution of one measure
included in the Compromise--the fugitive slave law--only made matters
worse. Designed as security for the planters, it proved a powerful
instrument in their undoing. Slavery five hundred miles away on a
Louisiana plantation was so remote from the North that only the
strongest imagination could maintain a constant rage against it. "Slave
catching," "man hunting" by federal officers on the streets of
Philadelphia, New York, Boston, Chicago, or Milwaukee and in the hamlets
and villages of the wide-stretching farm lands of the North was another
matter. It brought the most odious aspects of slavery home to thousands
of men and women who would otherwise have been indifferent to the
system. Law-abiding business men, mechanics, farmers, and women, when
they saw peaceful negroes, who had resided in their neighborhoods
perhaps for years, torn away by federal officers and carried back to
bondage, were transformed into enemies of the law. They helped slaves to
escape; they snatched them away from officers who had captured them;
they broke open jails and carried fugitives off to Canada.

Assistance to runaway slaves, always more or less common in the North,
was by this time organized into a system. Regular routes, known as
"underground railways," were laid out across the free states into
Canada, and trusted friends of freedom maintained "underground stations"
where fugitives were concealed in the daytime between their long night
journeys. Funds were raised and secret agents sent into the South to
help negroes to flee. One negro woman, Harriet Tubman, "the Moses of her
people," with headquarters at Philadelphia, is accredited with nineteen
invasions into slave territory and the emancipation of three hundred
negroes. Those who worked at this business were in constant peril. One
underground operator, Calvin Fairbank, spent nearly twenty years in
prison for aiding fugitives from justice. Yet perils and prisons did not
stay those determined men and women who, in obedience to their
consciences, set themselves to this lawless work.

[Illustration: HARRIET BEECHER STOWE]

From thrilling stories of adventure along the underground railways came
some of the scenes and themes of the novel by Harriet Beecher Stowe,
"Uncle Tom's Cabin," published two years after the Compromise of 1850.
Her stirring tale set forth the worst features of slavery in vivid word
pictures that caught and held the attention of millions of readers.
Though the book was unfair to the South and was denounced as a hideous
distortion of the truth, it was quickly dramatized and played in every
city and town throughout the North. Topsy, Little Eva, Uncle Tom, the
fleeing slave, Eliza Harris, and the cruel slave driver, Simon Legree,
with his baying blood hounds, became living specters in many a home that
sought to bar the door to the "unpleasant and irritating business of
slavery agitation."


THE DRIFT OF EVENTS TOWARD THE IRREPRESSIBLE CONFLICT

=Repeal of the Missouri Compromise.=--To practical men, after all, the
"rub-a-dub" agitation of a few abolitionists, an occasional riot over
fugitive slaves, and the vogue of a popular novel seemed of slight or
transient importance. They could point with satisfaction to the election
returns of 1852; but their very security was founded upon shifting
sands. The magnificent triumph of the pro-slavery Democrats in 1852
brought a turn in affairs that destroyed the foundations under their
feet. Emboldened by their own strength and the weakness of their
opponents, they now dared to repeal the Missouri Compromise. The leader
in this fateful enterprise was Stephen A. Douglas, Senator from
Illinois, and the occasion for the deed was the demand for the
organization of territorial government in the regions west of Iowa and
Missouri.

Douglas, like Clay and Webster before him, was consumed by a strong
passion for the presidency, and, to reach his goal, it was necessary to
win the support of the South. This he undoubtedly sought to do when he
introduced on January 4, 1854, a bill organizing the Nebraska territory
on the principle of the Compromise of 1850; namely, that the people in
the territory might themselves decide whether they would have slavery or
not. Unwittingly the avalanche was started.

After a stormy debate, in which important amendments were forced on
Douglas, the Kansas-Nebraska Bill became a law on May 30, 1854. The
measure created two territories, Kansas and Nebraska, and provided that
they, or territories organized out of them, could come into the union as
states "with or without slavery as their constitutions may prescribe at
the time of their admission." Not content with this, the law went on to
declare the Missouri Compromise null and void as being inconsistent with
the principle of non-intervention by Congress with slavery in the states
and territories. Thus by a single blow the very heart of the continent,
dedicated to freedom by solemn agreement, was thrown open to slavery. A
desperate struggle between slave owners and the advocates of freedom was
the outcome in Kansas.

If Douglas fancied that the North would receive the overthrow of the
Missouri Compromise in the same temper that it greeted Clay's
settlement, he was rapidly disillusioned. A blast of rage, terrific in
its fury, swept from Maine to Iowa. Staid old Boston hanged him in
effigy with an inscription--"Stephen A. Douglas, author of the infamous
Nebraska bill: the Benedict Arnold of 1854." City after city burned him
in effigy until, as he himself said, he could travel from the Atlantic
coast to Chicago in the light of the fires. Thousands of Whigs and
Free-soil Democrats deserted their parties which had sanctioned or at
least tolerated the Kansas-Nebraska Bill, declaring that the startling
measure showed an evident resolve on the part of the planters to rule
the whole country. A gage of defiance was thrown down to the
abolitionists. An issue was set even for the moderate and timid who had
been unmoved by the agitation over slavery in the Far South. That issue
was whether slavery was to be confined within its existing boundaries or
be allowed to spread without interference, thereby placing the free
states in the minority and surrendering the federal government wholly to
the slave power.

=The Rise of the Republican Party.=--Events of terrible significance,
swiftly following, drove the country like a ship before a gale straight
into civil war. The Kansas-Nebraska Bill rent the old parties asunder
and called into being the Republican party. While that bill was pending
in Congress, many Northern Whigs and Democrats had come to the
conclusion that a new party dedicated to freedom in the territories must
follow the repeal of the Missouri Compromise. Several places claim to be
the original home of the Republican party; but historians generally
yield it to Wisconsin. At Ripon in that state, a mass meeting of Whigs
and Democrats assembled in February, 1854, and resolved to form a new
party if the Kansas-Nebraska Bill should pass. At a second meeting a
fusion committee representing Whigs, Free Soilers, and Democrats was
formed and the name Republican--the name of Jefferson's old party--was
selected. All over the country similar meetings were held and political
committees were organized.

When the presidential campaign of 1856 began the Republicans entered the
contest. After a preliminary conference in Pittsburgh in February, they
held a convention in Philadelphia at which was drawn up a platform
opposing the extension of slavery to the territories. John C. Fremont,
the distinguished explorer, was named for the presidency. The results
of the election were astounding as compared with the Free-soil failure
of the preceding election. Prominent men like Longfellow, Washington
Irving, William Cullen Bryant, Ralph Waldo Emerson, and George William
Curtis went over to the new party and 1,341,264 votes were rolled up for
"free labor, free speech, free men, free Kansas, and Fremont."
Nevertheless the victory of the Democrats was decisive. Their candidate,
James Buchanan of Pennsylvania, was elected by a majority of 174 to 114
electoral votes.

[Illustration: SLAVE AND FREE SOIL ON EVE OF CIVIL WAR]

=The Dred Scott Decision (1857).=--In his inaugural, Buchanan vaguely
hinted that in a forthcoming decision the Supreme Court would settle one
of the vital questions of the day. This was a reference to the Dred
Scott case then pending. Scott was a slave who had been taken by his
master into the upper Louisiana territory, where freedom had been
established by the Missouri Compromise, and then carried back into his
old state of Missouri. He brought suit for his liberty on the ground
that his residence in the free territory made him free. This raised the
question whether the law of Congress prohibiting slavery north of 36 o
30' was authorized by the federal Constitution or not. The Court might
have avoided answering it by saying that even though Scott was free in
the territory, he became a slave again in Missouri by virtue of the law
of that state. The Court, however, faced the issue squarely. It held
that Scott had not been free anywhere and that, besides, the Missouri
Compromise violated the Constitution and was null and void.

The decision was a triumph for the South. It meant that Congress after
all had no power to abolish slavery in the territories. Under the decree
of the highest court in the land, that could be done only by an
amendment to the Constitution which required a two-thirds vote in
Congress and the approval of three-fourths of the states. Such an
amendment was obviously impossible--the Southern states were too
numerous; but the Republicans were not daunted. "We know," said Lincoln,
"the Court that made it has often overruled its own decisions and we
shall do what we can to have it overrule this." Legislatures of Northern
states passed resolutions condemning the decision and the Republican
platform of 1860 characterized the dogma that the Constitution carried
slavery into the territories as "a dangerous political heresy at
variance with the explicit provisions of that instrument itself ... with
legislative and judicial precedent ... revolutionary in tendency and
subversive of the peace and harmony of the country."

=The Panic of 1857.=--In the midst of the acrimonious dispute over the
Dred Scott decision, came one of the worst business panics which ever
afflicted the country. In the spring and summer of 1857, fourteen
railroad corporations, including the Erie, Michigan Central, and the
Illinois Central, failed to meet their obligations; banks and insurance
companies, some of them the largest and strongest institutions in the
North, closed their doors; stocks and bonds came down in a crash on the
markets; manufacturing was paralyzed; tens of thousands of working
people were thrown out of employment; "hunger meetings" of idle men were
held in the cities and banners bearing the inscription, "We want
bread," were flung out. In New York, working men threatened to invade
the Council Chamber to demand "work or bread," and the frightened mayor
called for the police and soldiers. For this distressing state of
affairs many remedies were offered; none with more zeal and persistence
than the proposal for a higher tariff to take the place of the law of
March, 1857, a Democratic measure making drastic reductions in the rates
of duty. In the manufacturing districts of the North, the panic was
ascribed to the "Democratic assault on business." So an old issue was
again vigorously advanced, preparatory to the next presidential
campaign.

=The Lincoln-Douglas Debates.=--The following year the interest of the
whole country was drawn to a series of debates held in Illinois by
Lincoln and Douglas, both candidates for the United States Senate. In
the course of his campaign Lincoln had uttered his trenchant saying that
"a house divided against itself cannot stand. I believe this government
cannot endure permanently half slave and half free." At the same time he
had accused Douglas, Buchanan, and the Supreme Court of acting in
concert to make slavery national. This daring statement arrested the
attention of Douglas, who was making his campaign on the doctrine of
"squatter sovereignty;" that is, the right of the people of each
territory "to vote slavery up or down." After a few long-distance shots
at each other, the candidates agreed to meet face to face and discuss
the issues of the day. Never had such crowds been seen at political
meetings in Illinois. Farmers deserted their plows, smiths their forges,
and housewives their baking to hear "Honest Abe" and "the Little Giant."

The results of the series of debates were momentous. Lincoln clearly
defined his position. The South, he admitted, was entitled under the
Constitution to a fair, fugitive slave law. He hoped that there might be
no new slave states; but he did not see how Congress could exclude the
people of a territory from admission as a state if they saw fit to adopt
a constitution legalizing the ownership of slaves. He favored the
gradual abolition of slavery in the District of Columbia and the total
exclusion of it from the territories of the United States by act of
Congress.

Moreover, he drove Douglas into a hole by asking how he squared
"squatter sovereignty" with the Dred Scott decision; how, in other
words, the people of a territory could abolish slavery when the Court
had declared that Congress, the superior power, could not do it under
the Constitution? To this baffling question Douglas lamely replied that
the inhabitants of a territory, by "unfriendly legislation," might make
property in slaves insecure and thus destroy the institution. This
answer to Lincoln's query alienated many Southern Democrats who believed
that the Dred Scott decision settled the question of slavery in the
territories for all time. Douglas won the election to the Senate; but
Lincoln, lifted into national fame by the debates, beat him in the
campaign for President two years later.

=John Brown's Raid.=--To the abolitionists the line of argument pursued
by Lincoln, including his proposal to leave slavery untouched in the
states where it existed, was wholly unsatisfactory. One of them, a grim
and resolute man, inflamed by a hatred for slavery in itself, turned
from agitation to violence. "These men are all talk; what is needed is
action--action!" So spoke John Brown of New York. During the sanguinary
struggle in Kansas he hurried to the frontier, gun and dagger in hand,
to help drive slave owners from the free soil of the West. There he
committed deeds of such daring and cruelty that he was outlawed and a
price put upon his head. Still he kept on the path of "action." Aided by
funds from Northern friends, he gathered a small band of his followers
around him, saying to them: "If God be for us, who can be against us?"
He went into Virginia in the autumn of 1859, hoping, as he explained,
"to effect a mighty conquest even though it be like the last victory of
Samson." He seized the government armory at Harper's Ferry, declared
free the slaves whom he found, and called upon them to take up arms in
defense of their liberty. His was a hope as forlorn as it was desperate.
Armed forces came down upon him and, after a hard battle, captured him.
Tried for treason, Brown was condemned to death. The governor of
Virginia turned a deaf ear to pleas for clemency based on the ground
that the prisoner was simply a lunatic. "This is a beautiful country,"
said the stern old Brown glancing upward to the eternal hills on his way
to the gallows, as calmly as if he were returning home from a long
journey. "So perish all such enemies of Virginia. All such enemies of
the Union. All such foes of the human race," solemnly announced the
executioner as he fulfilled the judgment of the law.

The raid and its grim ending deeply moved the country. Abolitionists
looked upon Brown as a martyr and tolled funeral bells on the day of his
execution. Longfellow wrote in his diary: "This will be a great day in
our history; the date of a new revolution as much needed as the old
one." Jefferson Davis saw in the affair "the invasion of a state by a
murderous gang of abolitionists bent on inciting slaves to murder
helpless women and children"--a crime for which the leader had met a
felon's death. Lincoln spoke of the raid as absurd, the deed of an
enthusiast who had brooded over the oppression of a people until he
fancied himself commissioned by heaven to liberate them--an attempt
which ended in "little else than his own execution." To Republican
leaders as a whole, the event was very embarrassing. They were taunted
by the Democrats with responsibility for the deed. Douglas declared his
"firm and deliberate conviction that the Harper's Ferry crime was the
natural, logical, inevitable result of the doctrines and teachings of
the Republican party." So persistent were such attacks that the
Republicans felt called upon in 1860 to denounce Brown's raid "as among
the gravest of crimes."

=The Democrats Divided.=--When the Democratic convention met at
Charleston in the spring of 1860, a few months after Brown's execution,
it soon became clear that there was danger ahead. Between the extreme
slavery advocates of the Far South and the so-called pro-slavery
Democrats of the Douglas type, there was a chasm which no appeals to
party loyalty could bridge. As the spokesman of the West, Douglas knew
that, while the North was not abolitionist, it was passionately set
against an extension of slavery into the territories by act of Congress;
that squatter sovereignty was the mildest kind of compromise acceptable
to the farmers whose votes would determine the fate of the election.
Southern leaders would not accept his opinion. Yancey, speaking for
Alabama, refused to palter with any plan not built on the proposition
that slavery was in itself right. He taunted the Northern Democrats with
taking the view that slavery was wrong, but that they could not do
anything about it. That, he said, was the fatal error--the cause of all
discord, the source of "Black Republicanism," as well as squatter
sovereignty. The gauntlet was thus thrown down at the feet of the
Northern delegates: "You must not apologize for slavery; you must
declare it right; you must advocate its extension." The challenge, so
bluntly put, was as bluntly answered. "Gentlemen of the South,"
responded a delegate from Ohio, "you mistake us. You mistake us. We will
not do it."

For ten days the Charleston convention wrangled over the platform and
balloted for the nomination of a candidate. Douglas, though in the lead,
could not get the two-thirds vote required for victory. For more than
fifty times the roll of the convention was called without a decision.
Then in sheer desperation the convention adjourned to meet later at
Baltimore. When the delegates again assembled, their passions ran as
high as ever. The division into two irreconcilable factions was
unchanged. Uncompromising delegates from the South withdrew to Richmond,
nominated John C. Breckinridge of Kentucky for President, and put forth
a platform asserting the rights of slave owners in the territories and
the duty of the federal government to protect them. The delegates who
remained at Baltimore nominated Douglas and endorsed his doctrine of
squatter sovereignty.

=The Constitutional Union Party.=--While the Democratic party was being
disrupted, a fragment of the former Whig party, known as the
Constitutional Unionists, held a convention at Baltimore and selected
national candidates: John Bell from Tennessee and Edward Everett from
Massachusetts. A melancholy interest attached to this assembly. It was
mainly composed of old men whose political views were those of Clay and
Webster, cherished leaders now dead and gone. In their platform they
sought to exorcise the evil spirit of partisanship by inviting their
fellow citizens to "support the Constitution of the country, the union
of the states, and the enforcement of the laws." The party that
campaigned on this grand sentiment only drew laughter from the Democrats
and derision from the Republicans and polled less than one-fourth the
votes.

=The Republican Convention.=--With the Whigs definitely forced into a
separate group, the Republican convention at Chicago was fated to be
sectional in character, although five slave states did send delegates.
As the Democrats were split, the party that had led a forlorn hope four
years before was on the high road to success at last. New and powerful
recruits were found. The advocates of a high protective tariff and the
friends of free homesteads for farmers and workingmen mingled with
enthusiastic foes of slavery. While still firm in their opposition to
slavery in the territories, the Republicans went on record in favor of a
homestead law granting free lands to settlers and approved customs
duties designed "to encourage the development of the industrial
interests of the whole country." The platform was greeted with cheers
which, according to the stenographic report of the convention, became
loud and prolonged as the protective tariff and homestead planks were
read.

Having skillfully drawn a platform to unite the North in opposition to
slavery and the planting system, the Republicans were also adroit in
their selection of a candidate. The tariff plank might carry
Pennsylvania, a Democratic state; but Ohio, Indiana, and Illinois were
equally essential to success at the polls. The southern counties of
these states were filled with settlers from Virginia, North Carolina,
and Kentucky who, even if they had no love for slavery, were no friends
of abolition. Moreover, remembering the old fight on the United States
Bank in Andrew Jackson's day, they were suspicious of men from the East.
Accordingly, they did not favor the candidacy of Seward, the leading
Republican statesman and "favorite son" of New York.

After much trading and discussing, the convention came to the conclusion
that Abraham Lincoln of Illinois was the most "available" candidate. He
was of Southern origin, born in Kentucky in 1809, a fact that told
heavily in the campaign in the Ohio Valley. He was a man of the soil,
the son of poor frontier parents, a pioneer who in his youth had labored
in the fields and forests, celebrated far and wide as "honest Abe, the
rail-splitter." It was well-known that he disliked slavery, but was no
abolitionist. He had come dangerously near to Seward's radicalism in his
"house-divided-against-itself" speech but he had never committed himself
to the reckless doctrine that there was a "higher law" than the
Constitution. Slavery in the South he tolerated as a bitter fact;
slavery in the territories he opposed with all his strength. Of his
sincerity there could be no doubt. He was a speaker and writer of
singular power, commanding, by the use of simple and homely language,
the hearts and minds of those who heard him speak or read his printed
words. He had gone far enough in his opposition to slavery; but not too
far. He was the man of the hour! Amid lusty cheers from ten thousand
throats, Lincoln was nominated for the presidency by the Republicans. In
the ensuing election, he carried all the free states except New Jersey.


=References=

P.E. Chadwick, _Causes of the Civil War_ (American Nation Series).

W.E. Dodd, _Statesmen of the Old South_.

E. Engle, _Southern Sidelights_ (Sympathetic account of the Old South).

A.B. Hart, _Slavery and Abolition_ (American Nation Series).

J.F. Rhodes, _History of the United States_, Vols. I and II.

T.C. Smith, _Parties and Slavery_ (American Nation Series).


=Questions=

1. Trace the decline of slavery in the North and explain it.

2. Describe the character of early opposition to slavery.

3. What was the effect of abolition agitation?

4. Why did anti-slavery sentiment practically disappear in the South?

5. On what grounds did Calhoun defend slavery?

6. Explain how slave owners became powerful in politics.

7. Why was it impossible to keep the slavery issue out of national
politics?

8. Give the leading steps in the long controversy over slavery in the
territories.

9. State the terms of the Compromise of 1850 and explain its failure.

10. What were the startling events between 1850 and 1860?

11. Account for the rise of the Republican party. What party had used
the title before?

12. How did the Dred Scott decision become a political issue?

13. What were some of the points brought out in the Lincoln-Douglas
debates?

14. Describe the party division in 1860.

15. What were the main planks in the Republican platform?


=Research Topics=

=The Extension of Cotton Planting.=--Callender, _Economic History of the
United States_, pp. 760-768.

=Abolition Agitation.=--McMaster, _History of the People of the United
States_, Vol. VI, pp. 271-298.

=Calhoun's Defense of Slavery.=--Harding, _Select Orations Illustrating
American History_, pp. 247-257.

=The Compromise of 1850.=--Clay's speech in Harding, _Select Orations_,
pp. 267-289. The compromise laws in Macdonald, _Documentary Source Book
of American History_, pp. 383-394. Narrative account in McMaster, Vol.
VIII, pp. 1-55; Elson, _History of the United States_, pp. 540-548.

=The Repeal of the Missouri Compromise.=--McMaster, Vol. VIII, pp.
192-231; Elson, pp. 571-582.

=The Dred Scott Case.=--McMaster, Vol. VIII, pp. 278-282. Compare the
opinion of Taney and the dissent of Curtis in Macdonald, _Documentary
Source Book_, pp. 405-420; Elson, pp. 595-598.

=The Lincoln-Douglas Debates.=--Analysis of original speeches in
Harding, _Select Orations_ pp. 309-341; Elson, pp. 598-604.

=Biographical Studies.=--Calhoun, Clay, Webster, A.H. Stephens, Douglas,
W.H. Seward, William Lloyd Garrison, Wendell Phillips, and Harriet
Beecher Stowe.




CHAPTER XV

THE CIVIL WAR AND RECONSTRUCTION


"The irrepressible conflict is about to be visited upon us through the
Black Republican nominee and his fanatical, diabolical Republican
party," ran an appeal to the voters of South Carolina during the
campaign of 1860. If that calamity comes to pass, responded the governor
of the state, the answer should be a declaration of independence. In a
few days the suspense was over. The news of Lincoln's election came
speeding along the wires. Prepared for the event, the editor of the
Charleston _Mercury_ unfurled the flag of his state amid wild cheers
from an excited throng in the streets. Then he seized his pen and wrote:
"The tea has been thrown overboard; the revolution of 1860 has been
initiated." The issue was submitted to the voters in the choice of
delegates to a state convention called to cast off the yoke of the
Constitution.


THE SOUTHERN CONFEDERACY

=Secession.=--As arranged, the convention of South Carolina assembled in
December and without a dissenting voice passed the ordinance of
secession withdrawing from the union. Bells were rung exultantly, the
roar of cannon carried the news to outlying counties, fireworks lighted
up the heavens, and champagne flowed. The crisis so long expected had
come at last; even the conservatives who had prayed that they might
escape the dreadful crash greeted it with a sigh of relief.

[Illustration: THE UNITED STATES IN 1861

The border states (in purple) remained loyal.]

South Carolina now sent forth an appeal to her sister states--states
that had in Jackson's day repudiated nullification as leading to "the
dissolution of the union." The answer that came this time was in a
different vein. A month had hardly elapsed before five other
states--Florida, Georgia, Alabama, Mississippi, and Louisiana--had
withdrawn from the union. In February, Texas followed. Virginia,
hesitating until the bombardment of Fort Sumter forced a conclusion,
seceded in April; but fifty-five of the one hundred and forty-three
delegates dissented, foreshadowing the creation of the new state of West
Virginia which Congress admitted to the union in 1863. In May, North
Carolina, Arkansas, and Tennessee announced their independence.

=Secession and the Theories of the Union.=--In severing their relations
with the union, the seceding states denied every point in the Northern
theory of the Constitution. That theory, as every one knows, was
carefully formulated by Webster and elaborated by Lincoln. According to
it, the union was older than the states; it was created before the
Declaration of Independence for the purpose of common defense. The
Articles of Confederation did but strengthen this national bond and the
Constitution sealed it forever. The federal government was not a
creature of state governments. It was erected by the people and derived
its powers directly from them. "It is," said Webster, "the people's
Constitution, the people's government; made for the people; made by the
people; and answerable to the people. The people of the United States
have declared that this Constitution shall be the supreme law." When a
state questions the lawfulness of any act of the federal government, it
cannot nullify that act or withdraw from the union; it must abide by the
decision of the Supreme Court of the United States. The union of these
states is perpetual, ran Lincoln's simple argument in the first
inaugural; the federal Constitution has no provision for its own
termination; it can be destroyed only by some action not provided for in
the instrument itself; even if it is a compact among all the states the
consent of all must be necessary to its dissolution; therefore no state
can lawfully get out of the union and acts of violence against the
United States are insurrectionary or revolutionary. This was the system
which he believed himself bound to defend by his oath of office
"registered in heaven."

All this reasoning Southern statesmen utterly rejected. In their opinion
the thirteen original states won their independence as separate and
sovereign powers. The treaty of peace with Great Britain named them all
and acknowledged them "to be free, sovereign, and independent states."
The Articles of Confederation very explicitly declared that "each state
retains its sovereignty, freedom, and independence." The Constitution
was a "league of nations" formed by an alliance of thirteen separate
powers, each one of which ratified the instrument before it was put into
effect. They voluntarily entered the union under the Constitution and
voluntarily they could leave it. Such was the constitutional doctrine of
Hayne, Calhoun, and Jefferson Davis. In seceding, the Southern states
had only to follow legal methods, and the transaction would be correct
in every particular. So conventions were summoned, elections were held,
and "sovereign assemblies of the people" set aside the Constitution in
the same manner as it had been ratified nearly four score years before.
Thus, said the Southern people, the moral judgment was fulfilled and the
letter of the law carried into effect.

[Illustration: JEFFERSON DAVIS]

=The Formation of the Confederacy.=--Acting on the call of Mississippi,
a congress of delegates from the seceded states met at Montgomery,
Alabama, and on February 8, 1861, adopted a temporary plan of union. It
selected, as provisional president, Jefferson Davis of Mississippi, a
man well fitted by experience and moderation for leadership, a graduate
of West Point, who had rendered distinguished service on the field of
battle in the Mexican War, in public office, and as a member of
Congress.

In March, a permanent constitution of the Confederate states was
drafted. It was quickly ratified by the states; elections were held in
November; and the government under it went into effect the next year.
This new constitution, in form, was very much like the famous instrument
drafted at Philadelphia in 1787. It provided for a President, a Senate,
and a House of Representatives along almost identical lines. In the
powers conferred upon them, however, there were striking differences.
The right to appropriate money for internal improvements was expressly
withheld; bounties were not to be granted from the treasury nor import
duties so laid as to promote or foster any branch of industry. The
dignity of the state, if any might be bold enough to question it, was
safeguarded in the opening line by the declaration that each acted "in
its sovereign and independent character" in forming the Southern union.

=Financing the Confederacy.=--No government ever set out upon its career
with more perplexing tasks in front of it. The North had a monetary
system; the South had to create one. The North had a scheme of taxation
that produced large revenues from numerous sources; the South had to
formulate and carry out a financial plan. Like the North, the
Confederacy expected to secure a large revenue from customs duties,
easily collected and little felt among the masses. To this expectation
the blockade of Southern ports inaugurated by Lincoln in April, 1861,
soon put an end. Following the precedent set by Congress under the
Articles of Confederation, the Southern Congress resorted to a direct
property tax apportioned among the states, only to meet the failure that
might have been foretold.

The Confederacy also sold bonds, the first issue bringing into the
treasury nearly all the specie available in the Southern banks. This
specie by unhappy management was early sent abroad to pay for supplies,
sapping the foundations of a sound currency system. Large amounts of
bonds were sold overseas, commanding at first better terms than those
of the North in the markets of London, Paris, and Amsterdam, many an
English lord and statesman buying with enthusiasm and confidence to
lament within a few years the proofs of his folly. The difficulties of
bringing through the blockade any supplies purchased by foreign bond
issues, however, nullified the effect of foreign credit and forced the
Confederacy back upon the device of paper money. In all approximately
one billion dollars streamed from the printing presses, to fall in value
at an alarming rate, reaching in January, 1863, the astounding figure of
fifty dollars in paper money for one in gold. Every known device was
used to prevent its depreciation, without result. To the issues of the
Confederate Congress were added untold millions poured out by the states
and by private banks.

=Human and Material Resources.=--When we measure strength for strength
in those signs of power--men, money, and supplies--it is difficult to
see how the South was able to embark on secession and war with such
confidence in the outcome. In the Confederacy at the final reckoning
there were eleven states in all, to be pitted against twenty-two; a
population of nine millions, nearly one-half servile, to be pitted
against twenty-two millions; a land without great industries to produce
war supplies and without vast capital to furnish war finances, joined in
battle with a nation already industrial and fortified by property worth
eleven billion dollars. Even after the Confederate Congress authorized
conscription in 1862, Southern man power, measured in numbers, was
wholly inadequate to uphold the independence which had been declared.
How, therefore, could the Confederacy hope to sustain itself against

such a combination of men, money, and materials as the North could
marshal?

=Southern Expectations.=--The answer to this question is to be found in
the ideas that prevailed among Southern leaders. First of all, they
hoped, in vain, to carry the Confederacy up to the Ohio River; and, with
the aid of Missouri, to gain possession of the Mississippi Valley, the
granary of the nation. In the second place, they reckoned upon a large
and continuous trade with Great Britain--the exchange of cotton for war
materials. They likewise expected to receive recognition and open aid
from European powers that looked with satisfaction upon the breakup of
the great American republic. In the third place, they believed that
their control over several staples so essential to Northern industry
would enable them to bring on an industrial crisis in the manufacturing
states. "I firmly believe," wrote Senator Hammond, of South Carolina, in
1860, "that the slave-holding South is now the controlling power of the
world; that no other power would face us in hostility. Cotton, rice,
tobacco, and naval stores command the world; and we have the sense to
know it and are sufficiently Teutonic to carry it out successfully. The
North without us would be a motherless calf, bleating about, and die of
mange and starvation."

There were other grounds for confidence. Having seized all of the
federal military and naval supplies in the South, and having left the
national government weak in armed power during their possession of the
presidency, Southern leaders looked to a swift war, if it came at all,
to put the finishing stroke to independence. "The greasy mechanics of
the North," it was repeatedly said, "will not fight." As to disparity in
numbers they drew historic parallels. "Our fathers, a mere handful,
overcame the enormous power of Great Britain," a saying of ex-President
Tyler, ran current to reassure the doubtful. Finally, and this point
cannot be too strongly emphasized, the South expected to see a weakened
and divided North. It knew that the abolitionists and the Southern
sympathizers were ready to let the Confederate states go in peace; that
Lincoln represented only a little more than one-third the voters of the
country; and that the vote for Douglas, Bell, and Breckinridge meant a
decided opposition to the Republicans and their policies.

=Efforts at Compromise.=--Republican leaders, on reviewing the same
facts, were themselves uncertain as to the outcome of a civil war and
made many efforts to avoid a crisis. Thurlow Weed, an Albany journalist
and politician who had done much to carry New York for Lincoln, proposed
a plan for extending the Missouri Compromise line to the Pacific.
Jefferson Davis, warning his followers that a war if it came would be
terrible, was prepared to accept the offer; but Lincoln, remembering his
campaign pledges, stood firm as a rock against it. His followers in
Congress took the same position with regard to a similar settlement
suggested by Senator Crittenden of Kentucky.

Though unwilling to surrender his solemn promises respecting slavery in
the territories, Lincoln was prepared to give to Southern leaders a
strong guarantee that his administration would not interfere directly or
indirectly with slavery in the states. Anxious to reassure the South on
this point, the Republicans in Congress proposed to write into the
Constitution a declaration that no amendment should ever be made
authorizing the abolition of or interference with slavery in any state.
The resolution, duly passed, was sent forth on March 4, 1861, with the
approval of Lincoln; it was actually ratified by three states before the
storm of war destroyed it. By the irony of fate the thirteenth amendment
was to abolish, not guarantee, slavery.


THE WAR MEASURES OF THE FEDERAL GOVERNMENT

=Raising the Armies.=--The crisis at Fort Sumter, on April 12-14, 1861,
forced the President and Congress to turn from negotiations to problems
of warfare. Little did they realize the magnitude of the task before
them. Lincoln's first call for volunteers, issued on April 15, 1861,
limited the number to 75,000, put their term of service at three months,
and prescribed their duty as the enforcement of the law against
combinations too powerful to be overcome by ordinary judicial process.
Disillusionment swiftly followed. The terrible defeat of the Federals at
Bull Run on July 21 revealed the serious character of the task before
them; and by a series of measures Congress put the entire man power of
the country at the President's command. Under these acts, he issued new
calls for volunteers. Early in August, 1862, he ordered a draft of
militiamen numbering 300,000 for nine months' service. The results were
disappointing--ominous--for only about 87,000 soldiers were added to the
army. Something more drastic was clearly necessary.

In March, 1863, Lincoln signed the inevitable draft law; it enrolled in
the national forces liable to military duty all able-bodied male
citizens and persons of foreign birth who had declared their intention
to become citizens, between the ages of twenty and forty-five
years--with exemptions on grounds of physical weakness and dependency.
From the men enrolled were drawn by lot those destined to active
service. Unhappily the measure struck a mortal blow at the principle of
universal liability by excusing any person who found a substitute for
himself or paid into the war office a sum, not exceeding three hundred
dollars, to be fixed by general order. This provision, so crass and so
obviously favoring the well-to-do, sowed seeds of bitterness which
sprang up a hundredfold in the North.

[Illustration: THE DRAFT RIOTS IN NEW YORK CITY]

The beginning of the drawings under the draft act in New York City, on
Monday, July 13, 1863, was the signal for four days of rioting. In the
course of this uprising, draft headquarters were destroyed; the office
of the _Tribune_ was gutted; negroes were seized, hanged, and shot; the
homes of obnoxious Unionists were burned down; the residence of the
mayor of the city was attacked; and regular battles were fought in the
streets between the rioters and the police. Business stopped and a large
part of the city passed absolutely into the control of the mob. Not
until late the following Wednesday did enough troops arrive to restore
order and enable the residents of the city to resume their daily
activities. At least a thousand people had been killed or wounded and
more than a million dollars' worth of damage done to property. The draft
temporarily interrupted by this outbreak was then resumed and carried
out without further trouble.

The results of the draft were in the end distinctly disappointing to the
government. The exemptions were numerous and the number who preferred
and were able to pay $300 rather than serve exceeded all expectations.
Volunteering, it is true, was stimulated, but even that resource could
hardly keep the thinning ranks of the army filled. With reluctance
Congress struck out the $300 exemption clause, but still favored the
well-to-do by allowing them to hire substitutes if they could find them.
With all this power in its hands the administration was able by January,
1865, to construct a union army that outnumbered the Confederates two to
one.

=War Finance.=--In the financial sphere the North faced immense
difficulties. The surplus in the treasury had been dissipated by 1861
and the tariff of 1857 had failed to produce an income sufficient to
meet the ordinary expenses of the government. Confronted by military and
naval expenditures of appalling magnitude, rising from $35,000,000 in
the first year of the war to $1,153,000,000 in the last year, the
administration had to tap every available source of income. The duties
on imports were increased, not once but many times, producing huge
revenues and also meeting the most extravagant demands of the
manufacturers for protection. Direct taxes were imposed on the states
according to their respective populations, but the returns were
meager--all out of proportion to the irritation involved. Stamp taxes
and taxes on luxuries, occupations, and the earnings of corporations
were laid with a weight that, in ordinary times, would have drawn forth
opposition of ominous strength. The whole gamut of taxation was run.
Even a tax on incomes and gains by the year, the first in the history of
the federal government, was included in the long list.

Revenues were supplemented by bond issues, mounting in size and interest
rate, until in October, at the end of the war, the debt stood at
$2,208,000,000. The total cost of the war was many times the money value
of all the slaves in the Southern states. To the debt must be added
nearly half a billion dollars in "greenbacks"--paper money issued by
Congress in desperation as bond sales and revenues from taxes failed to
meet the rising expenditures. This currency issued at par on
questionable warrant from the Constitution, like all such paper, quickly
began to decline until in the worst fortunes of 1864 one dollar in gold
was worth nearly three in greenbacks.

=The Blockade of Southern Ports.=--Four days after his call for
volunteers, April 19, 1861, President Lincoln issued a proclamation
blockading the ports of the Southern Confederacy. Later the blockade was
extended to Virginia and North Carolina, as they withdrew from the
union. Vessels attempting to enter or leave these ports, if they
disregarded the warnings of a blockading ship, were to be captured and
brought as prizes to the nearest convenient port. To make the order
effective, immediate steps were taken to increase the naval forces,
depleted by neglect, until the entire coast line was patrolled with such
a number of ships that it was a rare captain who ventured to run the
gantlet. The collision between the _Merrimac_ and the _Monitor_ in
March, 1862, sealed the fate of the Confederacy. The exploits of the
union navy are recorded in the falling export of cotton: $202,000,000 in
1860; $42,000,000 in 1861; and $4,000,000 in 1862.

The deadly effect of this paralysis of trade upon Southern war power may
be readily imagined. Foreign loans, payable in cotton, could be
negotiated but not paid off. Supplies could be purchased on credit but
not brought through the drag net. With extreme difficulty could the
Confederate government secure even paper for the issue of money and
bonds. Publishers, in despair at the loss of supplies, were finally
driven to the use of brown wrapping paper and wall paper. As the
railways and rolling stock wore out, it became impossible to renew them
from England or France. Unable to export their cotton, planters on the
seaboard burned it in what were called "fires of patriotism." In their
lurid light the fatal weakness of Southern economy stood revealed.

[Illustration: A BLOCKADE RUNNER]

=Diplomacy.=--The war had not advanced far before the federal government
became involved in many perplexing problems of diplomacy in Europe. The
Confederacy early turned to England and France for financial aid and for
recognition as an independent power. Davis believed that the industrial
crisis created by the cotton blockade would in time literally compel
Europe to intervene in order to get this essential staple. The crisis
came as he expected but not the result. Thousands of English textile
workers were thrown out of employment; and yet, while on the point of
starvation, they adopted resolutions favoring the North instead of
petitioning their government to aid the South by breaking the blockade.

With the ruling classes it was far otherwise. Napoleon III, the Emperor
of the French, was eager to help in disrupting the American republic; if
he could have won England's support, he would have carried out his
designs. As it turned out he found plenty of sympathy across the Channel
but not open and official cooperation. According to the eminent
historian, Rhodes, "four-fifths of the British House of Lords and most
members of the House of Commons were favorable to the Confederacy and
anxious for its triumph." Late in 1862 the British ministers, thus
sustained, were on the point of recognizing the independence of the
Confederacy. Had it not been for their extreme caution, for the constant
and harassing criticism by English friends of the United States--like
John Bright--and for the victories of Vicksburg and Gettysburg, both

England and France would have doubtless declared the Confederacy to be
one of the independent powers of the earth.

[Illustration: JOHN BRIGHT]

While stopping short of recognizing its independence, England and France
took several steps that were in favor of the South. In proclaiming
neutrality, they early accepted the Confederates as "belligerents" and
accorded them the rights of people at war--a measure which aroused anger
in the North at first but was later admitted to be sound. Otherwise
Confederates taken in battle would have been regarded as "rebels" or
"traitors" to be hanged or shot. Napoleon III proposed to Russia in 1861
a coalition of powers against the North, only to meet a firm refusal.
The next year he suggested intervention to Great Britain, encountering
this time a conditional rejection of his plans. In 1863, not daunted by
rebuffs, he offered his services to Lincoln as a mediator, receiving in
reply a polite letter declining his proposal and a sharp resolution from
Congress suggesting that he attend to his own affairs.

In both England and France the governments pursued a policy of
friendliness to the Confederate agents. The British ministry, with
indifference if not connivance, permitted rams and ships to be built in
British docks and allowed them to escape to play havoc under the
Confederate flag with American commerce. One of them, the _Alabama_,
built in Liverpool by a British firm and paid for by bonds sold in
England, ran an extraordinary career and threatened to break the
blockade. The course followed by the British government, against the
protests of the American minister in London, was later regretted. By an
award of a tribunal of arbitration at Geneva in 1872, Great Britain was
required to pay the huge sum of $15,500,000 to cover the damages wrought
by Confederate cruisers fitted out in England.

[Illustration: WILLIAM H. SEWARD]

In all fairness it should be said that the conduct of the North
contributed to the irritation between the two countries. Seward, the
Secretary of State, was vindictive in dealing with Great Britain; had it
not been for the moderation of Lincoln, he would have pursued a course
verging in the direction of open war. The New York and Boston papers
were severe in their attacks on England. Words were, on one occasion at
least, accompanied by an act savoring of open hostility. In November,
1861, Captain Wilkes, commanding a union vessel, overhauled the British
steamer _Trent_, and carried off by force two Confederate agents, Mason
and Slidell, sent by President Davis to represent the Confederacy at
London and Paris respectively. This was a clear violation of the right
of merchant vessels to be immune from search and impressment; and, in
answer to the demand of Great Britain for the release of the two men,
the United States conceded that it was in the wrong. It surrendered the
two Confederate agents to a British vessel for safe conduct abroad, and
made appropriate apologies.

=Emancipation.=--Among the extreme war measures adopted by the Northern
government must be counted the emancipation of the slaves in the states
in arms against the union. This step was early and repeatedly suggested
to Lincoln by the abolitionists; but was steadily put aside. He knew
that the abolitionists were a mere handful, that emancipation might
drive the border states into secession, and that the Northern soldiers
had enlisted to save the union. Moreover, he had before him a solemn
resolution passed by Congress on July 22, 1861, declaring the sole
purpose of the war to be the salvation of the union and disavowing any
intention of interfering with slavery.

The federal government, though pledged to the preservation of slavery,
soon found itself beaten back upon its course and out upon a new tack.
Before a year had elapsed, namely on April 10, 1862, Congress resolved
that financial aid should be given to any state that might adopt gradual
emancipation. Six days later it abolished slavery in the District of
Columbia. Two short months elapsed. On June 19, 1862, it swept slavery
forever from the territories of the United States. Chief Justice Taney
still lived, the Dred Scott decision stood as written in the book, but
the Constitution had been re-read in the light of the Civil War. The
drift of public sentiment in the North was being revealed.

While these measures were pending in Congress, Lincoln was slowly making
up his mind. By July of that year he had come to his great decision.
Near the end of that month he read to his cabinet the draft of a
proclamation of emancipation; but he laid it aside until a military
achievement would make it something more than an idle gesture. In
September, the severe check administered to Lee at Antietam seemed to
offer the golden opportunity. On the 22d, the immortal document was
given to the world announcing that, unless the states in arms returned
to the union by January 1, 1863, the fatal blow at their "peculiar
institution" would be delivered. Southern leaders treated it with slight
regard, and so on the date set the promise was fulfilled. The
proclamation was issued as a war measure, adopted by the President as
commander-in-chief of the armed forces, on grounds of military
necessity. It did not abolish slavery. It simply emancipated slaves in
places then in arms against federal authority. Everywhere else slavery,
as far as the Proclamation was concerned, remained lawful.

[Illustration: ABRAHAM LINCOLN]

To seal forever the proclamation of emancipation, and to extend freedom
to the whole country, Congress, in January, 1865, on the urgent
recommendation of Lincoln, transmitted to the states the thirteenth
amendment, abolishing slavery throughout the United States. By the end
of 1865 the amendment was ratified. The house was not divided against
itself; it did not fall; it was all free.

=The Restraint of Civil Liberty.=--As in all great wars, particularly
those in the nature of a civil strife, it was found necessary to use
strong measures to sustain opinion favorable to the administration's
military policies and to frustrate the designs of those who sought to
hamper its action. Within two weeks of his first call for volunteers,
Lincoln empowered General Scott to suspend the writ of _habeas corpus_
along the line of march between Philadelphia and Washington and thus to
arrest and hold without interference from civil courts any one whom he
deemed a menace to the union. At a later date the area thus ruled by
military officers was extended by executive proclamation. By an act of
March 3, 1863, Congress, desiring to lay all doubts about the
President's power, authorized him to suspend the writ throughout the
United States or in any part thereof. It also freed military officers
from the necessity of surrendering to civil courts persons arrested
under their orders, or even making answers to writs issued from such
courts. In the autumn of that year the President, acting under the terms
of this law, declared this ancient and honorable instrument for the
protection of civil liberties, the _habeas corpus_, suspended throughout
the length and breadth of the land. The power of the government was also
strengthened by an act defining and punishing certain conspiracies,
passed on July 31, 1861--a measure which imposed heavy penalties on
those who by force, intimidation, or threat interfered with the
execution of the law.

Thus doubly armed, the military authorities spared no one suspected of
active sympathy with the Southern cause. Editors were arrested and
imprisoned, their papers suspended, and their newsboys locked up. Those
who organized "peace meetings" soon found themselves in the toils of the
law. Members of the Maryland legislature, the mayor of Baltimore, and
local editors suspected of entertaining secessionist opinions, were
imprisoned on military orders although charged with no offense, and were
denied the privilege of examination before a civil magistrate. A Vermont
farmer, too outspoken in his criticism of the government, found himself
behind the bars until the government, in its good pleasure, saw fit to
release him. These measures were not confined to the theater of war nor
to the border states where the spirit of secession was strong enough to
endanger the cause of union. They were applied all through the Northern
states up to the very boundaries of Canada. Zeal for the national cause,
too often supplemented by a zeal for persecution, spread terror among
those who wavered in the singleness of their devotion to the union.

These drastic operations on the part of military authorities, so foreign
to the normal course of civilized life, naturally aroused intense and
bitter hostility. Meetings of protest were held throughout the country.
Thirty-six members of the House of Representatives sought to put on
record their condemnation of the suspension of the _habeas corpus_ act,
only to meet a firm denial by the supporters of the act. Chief Justice
Taney, before whom the case of a man arrested under the President's
military authority was brought, emphatically declared, in a long and
learned opinion bristling with historical examples, that the President
had no power to suspend the writ of _habeas corpus_. In Congress and
out, Democrats, abolitionists, and champions of civil liberty denounced
Lincoln and his Cabinet in unsparing terms. Vallandigham, a Democratic
leader of Ohio, afterward banished to the South for his opposition to
the war, constantly applied to Lincoln the epithet of "Caesar." Wendell
Phillips saw in him "a more unlimited despot than the world knows this
side of China."

Sensitive to such stinging thrusts and no friend of wanton persecution,
Lincoln attempted to mitigate the rigors of the law by paroling many
political prisoners. The general policy, however, he defended in homely
language, very different in tone and meaning from the involved reasoning
of the lawyers. "Must I shoot a simple-minded soldier boy who deserts,
while I must not touch a hair of the wily agitator who induces him to
desert?" he asked in a quiet way of some spokesmen for those who
protested against arresting people for "talking against the war." This
summed up his philosophy. He was engaged in a war to save the union, and
all measures necessary and proper to accomplish that purpose were
warranted by the Constitution which he had sworn to uphold.

=Military Strategy--North and South.=--The broad outlines of military
strategy followed by the commanders of the opposing forces are clear
even to the layman who cannot be expected to master the details of a
campaign or, for that matter, the maneuvers of a single great battle.
The problem for the South was one of defense mainly, though even for
defense swift and paralyzing strokes at the North were later deemed
imperative measures. The problem of the North was, to put it baldly, one
of invasion and conquest. Southern territory had to be invaded and
Southern armies beaten on their own ground or worn down to exhaustion
there.

In the execution of this undertaking, geography, as usual, played a
significant part in the disposition of forces. The Appalachian ranges,
stretching through the Confederacy to Northern Alabama, divided the
campaigns into Eastern and Western enterprises. Both were of signal
importance. Victory in the East promised the capture of the Confederate
capital of Richmond, a stroke of moral worth, hardly to be
overestimated. Victory in the West meant severing the Confederacy and
opening the Mississippi Valley down to the Gulf.

As it turned out, the Western forces accomplished their task first,
vindicating the military powers of union soldiers and shaking the
confidence of opposing commanders. In February, 1862, Grant captured
Fort Donelson on the Tennessee River, rallied wavering unionists in
Kentucky, forced the evacuation of Nashville, and opened the way for two
hundred miles into the Confederacy. At Shiloh, Murfreesboro, Vicksburg,
Chickamauga, Chattanooga, desperate fighting followed and, in spite of
varying fortunes, it resulted in the discomfiture and retirement of
Confederate forces to the Southeast into Georgia. By the middle of 1863,
the Mississippi Valley was open to the Gulf, the initiative taken out of
the hands of Southern commanders in the West, and the way prepared for
Sherman's final stroke--the march from Atlanta to the sea--a maneuver
executed with needless severity in the autumn of 1864.

[Illustration: GENERAL ULYSSES S. GRANT]

[Illustration: GENERAL ROBERT E. LEE]

For the almost unbroken succession of achievements in the West by
Generals Grant, Sherman, Thomas, and Hooker against Albert Sidney
Johnston, Bragg, Pemberton, and Hood, the union forces in the East
offered at first an almost equally unbroken series of misfortunes and
disasters. Far from capturing Richmond, they had been thrown on the
defensive. General after general--McClellan, Pope, Burnside, Hooker, and
Meade--was tried and found wanting. None of them could administer a
crushing defeat to the Confederate troops and more than once the union
soldiers were beaten in a fair battle. They did succeed, however, in
delivering a severe check to advancing Confederates under General Robert
E. Lee, first at Antietam in September, 1862, and then at Gettysburg in
July, 1863--checks reckoned as victories though in each instance the
Confederates escaped without demoralization. Not until the beginning of
the next year, when General Grant, supplied with almost unlimited men
and munitions, began his irresistible hammering at Lee's army, did the
final phase of the war commence. The pitiless drive told at last.
General Lee, on April 9, 1865, seeing the futility of further conflict,
surrendered an army still capable of hard fighting, at Appomattox, not
far from the capital of the Confederacy.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

THE FEDERAL MILITARY HOSPITAL AT GETTYSBURG]

=Abraham Lincoln.=--The services of Lincoln to the cause of union defy
description. A judicial scrutiny of the war reveals his thought and
planning in every part of the varied activity that finally crowned
Northern arms with victory. Is it in the field of diplomacy? Does
Seward, the Secretary of State, propose harsh and caustic measures
likely to draw England's sword into the scale? Lincoln counsels
moderation. He takes the irritating message and with his own hand
strikes out, erases, tones down, and interlines, exchanging for words
that sting and burn the language of prudence and caution. Is it a matter
of compromise with the South, so often proposed by men on both sides
sick of carnage? Lincoln is always ready to listen and turns away only
when he is invited to surrender principles essential to the safety of
the union. Is it high strategy of war, a question of the general best
fitted to win Gettysburg--Hooker, Sedgwick, or Meade? Lincoln goes in
person to the War Department in the dead of night to take counsel with
his Secretary and to make the fateful choice.

Is it a complaint from a citizen, deprived, as he believes, of his civil
liberties unjustly or in violation of the Constitution? Lincoln is ready
to hear it and anxious to afford relief, if warrant can be found for it.
Is a mother begging for the life of a son sentenced to be shot as a
deserter? Lincoln hears her petition, and grants it even against the
protests made by his generals in the name of military discipline. Do
politicians sow dissensions in the army and among civilians? Lincoln
grandly waves aside their petty personalities and invites them to think
of the greater cause. Is it a question of securing votes to ratify the
thirteenth amendment abolishing slavery? Lincoln thinks it not beneath
his dignity to traffic and huckster with politicians over the trifling
jobs asked in return by the members who hold out against him. Does a New
York newspaper call him an ignorant Western boor? Lincoln's reply is a
letter to a mother who has given her all--her sons on the field of
battle--and an address at Gettysburg, both of which will live as long as
the tongue in which they were written. These are tributes not only to
his mastery of the English language but also to his mastery of all those
sentiments of sweetness and strength which are the finest flowers of
culture.

Throughout the entire span of service, however, Lincoln was beset by
merciless critics. The fiery apostles of abolition accused him of
cowardice when he delayed the bold stroke at slavery. Anti-war Democrats
lashed out at every step he took. Even in his own party he found no
peace. Charles Sumner complained: "Our President is now dictator,
_imperator_--whichever you like; but how vain to have the power of a
god and not to use it godlike." Leaders among the Republicans sought to
put him aside in 1864 and place Chase in his chair. "I hope we may never
have a worse man," was Lincoln's quiet answer.

Wide were the dissensions in the North during that year and the
Republicans, while selecting Lincoln as their candidate again, cast off
their old name and chose the simple title of the "Union party."
Moreover, they selected a Southern man, Andrew Johnson, of Tennessee, to
be associated with him as candidate for Vice President. This combination
the Northern Democrats boldly confronted with a platform declaring that
"after four years of failure to restore the union by the experiment of
war, during which, under the pretence of military necessity or war power
higher than the Constitution, the Constitution itself has been
disregarded in every part and public liberty and private right alike
trodden down ... justice, humanity, liberty, and public welfare demand
that immediate efforts be made for a cessation of hostilities, to the
end that peace may be restored on the basis of the federal union of the
states." It is true that the Democratic candidate, General McClellan,
sought to break the yoke imposed upon him by the platform, saying that
he could not look his old comrades in the face and pronounce their
efforts vain; but the party call to the nation to repudiate Lincoln and
his works had gone forth. The response came, giving Lincoln 2,200,000
votes against 1,800,000 for his opponent. The bitter things said about
him during the campaign, he forgot and forgave. When in April, 1865, he
was struck down by the assassin's hand, he above all others in
Washington was planning measures of moderation and healing.


THE RESULTS OF THE CIVIL WAR

There is a strong and natural tendency on the part of writers to stress
the dramatic and heroic aspects of war; but the long judgment of history
requires us to include all other significant phases as well. Like every
great armed conflict, the Civil War outran the purposes of those who
took part in it. Waged over the nature of the union, it made a
revolution in the union, changing public policies and constitutional
principles and giving a new direction to agriculture and industry.

=The Supremacy of the Union.=--First and foremost, the war settled for
all time the long dispute as to the nature of the federal system. The
doctrine of state sovereignty was laid to rest. Men might still speak of
the rights of states and think of their commonwealths with affection,
but nullification and secession were destroyed. The nation was supreme.

=The Destruction of the Slave Power.=--Next to the vindication of
national supremacy was the destruction of the planting aristocracy of
the South--that great power which had furnished leadership of undoubted
ability and had so long contested with the industrial and commercial
interests of the North. The first paralyzing blow at the planters was
struck by the abolition of slavery. The second and third came with the
fourteenth (1868) and fifteenth (1870) amendments, giving the ballot to
freedmen and excluding from public office the Confederate
leaders--driving from the work of reconstruction the finest talents of
the South. As if to add bitterness to gall and wormwood, the fourteenth
amendment forbade the United States or any state to pay any debts
incurred in aid of the Confederacy or in the emancipation of the
slaves--plunging into utter bankruptcy the Southern financiers who had
stripped their section of capital to support their cause. So the
Southern planters found themselves excluded from public office and ruled
over by their former bondmen under the tutelage of Republican leaders.
Their labor system was wrecked and their money and bonds were as
worthless as waste paper. The South was subject to the North. That which
neither the Federalists nor the Whigs had been able to accomplish in the
realm of statecraft was accomplished on the field of battle.


=The Triumph of Industry.=--The wreck of the planting system was
accompanied by a mighty upswing of Northern industry which made the old
Whigs of Massachusetts and Pennsylvania stare in wonderment. The demands
of the federal government for manufactured goods at unrestricted prices
gave a stimulus to business which more than replaced the lost markets of
the South. Between 1860 and 1870 the number of manufacturing
establishments increased 79.6 per cent as against 14.2 for the previous
decade; while the number of persons employed almost doubled. There was
no doubt about the future of American industry.

=The Victory for the Protective Tariff.=--Moreover, it was henceforth to
be well protected. For many years before the war the friends of
protection had been on the defensive. The tariff act of 1857 imposed
duties so low as to presage a tariff for revenue only. The war changed
all that. The extraordinary military expenditures, requiring heavy taxes
on all sources, justified tariffs so high that a follower of Clay or
Webster might well have gasped with astonishment. After the war was over
the debt remained and both interest and principal had to be paid.
Protective arguments based on economic reasoning were supported by a
plain necessity for revenue which admitted no dispute.

=A Liberal Immigration Policy.=--Linked with industry was the labor
supply. The problem of manning industries became a pressing matter, and
Republican leaders grappled with it. In the platform of the Union party
adopted in 1864 it was declared "that foreign immigration, which in the
past has added so much to the wealth, the development of resources, and
the increase of power to this nation--the asylum of the oppressed of all
nations--should be fostered and encouraged by a liberal and just
policy." In that very year Congress, recognizing the importance of the
problem, passed a measure of high significance, creating a bureau of
immigration, and authorizing a modified form of indentured labor, by
making it legal for immigrants to pledge their wages in advance to pay
their passage over. Though the bill was soon repealed, the practice
authorized by it was long continued. The cheapness of the passage
shortened the term of service; but the principle was older than the
days of William Penn.

=The Homestead Act of 1862.=--In the immigration measure guaranteeing a
continuous and adequate labor supply, the manufacturers saw an offset to
the Homestead Act of 1862 granting free lands to settlers. The Homestead
law they had resisted in a long and bitter congressional battle.
Naturally, they had not taken kindly to a scheme which lured men away
from the factories or enabled them to make unlimited demands for higher
wages as the price of remaining. Southern planters likewise had feared
free homesteads for the very good reason that they only promised to add
to the overbalancing power of the North.

In spite of the opposition, supporters of a liberal land policy made
steady gains. Free-soil Democrats,--Jacksonian farmers and
mechanics,--labor reformers, and political leaders, like Stephen A.
Douglas of Illinois and Andrew Johnson of Tennessee, kept up the
agitation in season and out. More than once were they able to force a
homestead bill through the House of Representatives only to have it
blocked in the Senate where Southern interests were intrenched. Then,
after the Senate was won over, a Democratic President, James Buchanan,
vetoed the bill. Still the issue lived. The Republicans, strong among
the farmers of the Northwest, favored it from the beginning and pressed
it upon the attention of the country. Finally the manufacturers yielded;
they received their compensation in the contract labor law. In 1862
Congress provided for the free distribution of land in 160-acre lots
among men and women of strong arms and willing hearts ready to build
their serried lines of homesteads to the Rockies and beyond.

=Internal Improvements.=--If farmers and manufacturers were early
divided on the matter of free homesteads, the same could hardly be said
of internal improvements. The Western tiller of the soil was as eager
for some easy way of sending his produce to market as the manufacturer
was for the same means to transport his goods to the consumer on the
farm. While the Confederate leaders were writing into their
constitution a clause forbidding all appropriations for internal
improvements, the Republican leaders at Washington were planning such
expenditures from the treasury in the form of public land grants to
railways as would have dazed the authors of the national road bill half
a century earlier.

=Sound Finance--National Banking.=--From Hamilton's day to Lincoln's,
business men in the East had contended for a sound system of national
currency. The experience of the states with paper money, painfully
impressive in the years before the framing of the Constitution, had been
convincing to those who understood the economy of business. The
Constitution, as we have seen, bore the signs of this experience. States
were forbidden to emit bills of credit: paper money, in short. This
provision stood clear in the document; but judicial ingenuity had
circumvented it in the age of Jacksonian Democracy. The states had
enacted and the Supreme Court, after the death of John Marshall, had
sustained laws chartering banking companies and authorizing them to
issue paper money. So the country was beset by the old curse, the banks
of Western and Southern states issuing reams of paper notes to help
borrowers pay their debts.

In dealing with war finances, the Republicans attacked this ancient
evil. By act of Congress in 1864, they authorized a series of national
banks founded on the credit of government bonds and empowered to issue
notes. The next year they stopped all bank paper sent forth under the
authority of the states by means of a prohibitive tax. In this way, by
two measures Congress restored federal control over the monetary system
although it did not reestablish the United States Bank so hated by
Jacksonian Democracy.

=Destruction of States' Rights by Fourteenth Amendment.=--These acts and
others not cited here were measures of centralization and consolidation
at the expense of the powers and dignity of the states. They were all of
high import, but the crowning act of nationalism was the fourteenth
amendment which, among other things, forbade states to "deprive any
person of life, liberty or property without due process of law." The
immediate occasion, though not the actual cause of this provision, was
the need for protecting the rights of freedmen against hostile
legislatures in the South. The result of the amendment, as was
prophesied in protests loud and long from every quarter of the
Democratic party, was the subjection of every act of state, municipal,
and county authorities to possible annulment by the Supreme Court at
Washington. The expected happened.

Few negroes ever brought cases under the fourteenth amendment to the
attention of the courts; but thousands of state laws, municipal
ordinances, and acts of local authorities were set aside as null and
void under it. Laws of states regulating railway rates, fixing hours of
labor in bakeshops, and taxing corporations were in due time to be
annulled as conflicting with an amendment erroneously supposed to be
designed solely for the protection of negroes. As centralized power over
tariffs, railways, public lands, and other national concerns went to
Congress, so centralized power over the acts of state and local
authorities involving an infringement of personal and property rights
was conferred on the federal judiciary, the apex of which was the
Supreme Court at Washington. Thus the old federation of "independent
states," all equal in rights and dignity, each wearing the "jewel of
sovereignty" so celebrated in Southern oratory, had gone the way of all
flesh under the withering blasts of Civil War.


RECONSTRUCTION IN THE SOUTH

=Theories about the Position of the Seceded States.=--On the morning of
April 9, 1865, when General Lee surrendered his army to General Grant,
eleven states stood in a peculiar relation to the union now declared
perpetual. Lawyers and political philosophers were much perturbed and
had been for some time as to what should be done with the members of the
former Confederacy. Radical Republicans held that they were "conquered
provinces" at the mercy of Congress, to be governed under such laws as
it saw fit to enact and until in its wisdom it decided to readmit any or
all of them to the union. Men of more conservative views held that, as
the war had been waged by the North on the theory that no state could
secede from the union, the Confederate states had merely attempted to
withdraw and had failed. The corollary of this latter line of argument
was simple: "The Southern states are still in the union and it is the
duty of the President, as commander-in-chief, to remove the federal
troops as soon as order is restored and the state governments ready to
function once more as usual."

=Lincoln's Proposal.=--Some such simple and conservative form of
reconstruction had been suggested by Lincoln in a proclamation of
December 8, 1863. He proposed pardon and a restoration of property,
except in slaves, to nearly all who had "directly or by implication
participated in the existing rebellion," on condition that they take an
oath of loyalty to the union. He then announced that when, in any of the
states named, a body of voters, qualified under the law as it stood
before secession and equal in number to one-tenth the votes cast in
1860, took the oath of allegiance, they should be permitted to
reestablish a state government. Such a government, he added, should be
recognized as a lawful authority and entitled to protection under the
federal Constitution. With reference to the status of the former slaves
Lincoln made it clear that, while their freedom must be recognized, he
would not object to any legislation "which may yet be consistent as a
temporary arrangement with their present condition as a laboring,
landless, and homeless class."

=Andrew Johnson's Plan--His Impeachment.=--Lincoln's successor, Andrew
Johnson, the Vice President, soon after taking office, proposed to
pursue a somewhat similar course. In a number of states he appointed
military governors, instructing them at the earliest possible moment to
assemble conventions, chosen "by that portion of the people of the said
states who are loyal to the United States," and proceed to the
organization of regular civil government. Johnson, a Southern man and a
Democrat, was immediately charged by the Republicans with being too
ready to restore the Southern states. As the months went by, the
opposition to his measures and policies in Congress grew in size and
bitterness. The contest resulted in the impeachment of Johnson by the
House of Representatives in March, 1868, and his acquittal by the Senate
merely because his opponents lacked one vote of the two-thirds required
for conviction.

=Congress Enacts "Reconstruction Laws."=--In fact, Congress was in a
strategic position. It was the law-making body, and it could, moreover,
determine the conditions under which Senators and Representatives from
the South were to be readmitted. It therefore proceeded to pass a series
of reconstruction acts--carrying all of them over Johnson's veto. These
measures, the first of which became a law on March 2, 1867, betrayed an
animus not found anywhere in Lincoln's plans or Johnson's proclamations.

They laid off the ten states--the whole Confederacy with the exception
of Tennessee--still outside the pale, into five military districts, each
commanded by a military officer appointed by the President. They ordered
the commanding general to prepare a register of voters for the election
of delegates to conventions chosen for the purpose of drafting new
constitutions. Such voters, however, were not to be, as Lincoln had
suggested, loyal persons duly qualified under the law existing before
secession but "the male citizens of said state, twenty-one years old and
upward, of whatever race, color, or previous condition, ... except such
as may be disfranchised for participation in the rebellion or for felony
at common law." This was the death knell to the idea that the leaders of
the Confederacy and their white supporters might be permitted to share
in the establishment of the new order. Power was thus arbitrarily thrust
into the hands of the newly emancipated male negroes and the handful of
whites who could show a record of loyalty. That was not all. Each state
was, under the reconstruction acts, compelled to ratify the fourteenth
amendment to the federal Constitution as a price of restoration to the
union.

The composition of the conventions thus authorized may be imagined.
Bondmen without the asking and without preparation found themselves the
governing power. An army of adventurers from the North, "carpet baggers"
as they were called, poured in upon the scene to aid in
"reconstruction." Undoubtedly many men of honor and fine intentions gave
unstinted service, but the results of their deliberations only
aggravated the open wound left by the war. Any number of political
doctors offered their prescriptions; but no effective remedy could be
found. Under measures admittedly open to grave objections, the Southern
states were one after another restored to the union by the grace of
Congress, the last one in 1870. Even this grudging concession of the
formalities of statehood did not mean a full restoration of honors and
privileges. The last soldier was not withdrawn from the last Southern
capital until 1877, and federal control over elections long remained as
a sign of congressional supremacy.

=The Status of the Freedmen.=--Even more intricate than the issues
involved in restoring the seceded states to the union was the question
of what to do with the newly emancipated slaves. That problem, often put
to abolitionists before the war, had become at last a real concern. The
thirteenth amendment abolishing slavery had not touched it at all. It
declared bondmen free, but did nothing to provide them with work or
homes and did not mention the subject of political rights. All these
matters were left to the states, and the legislatures of some of them,
by their famous "black codes," restored a form of servitude under the
guise of vagrancy and apprentice laws. Such methods were in fact partly
responsible for the reaction that led Congress to abandon Lincoln's
policies and undertake its own program of reconstruction.

Still no extensive effort was made to solve by law the economic problems
of the bondmen. Radical abolitionists had advocated that the slaves when
emancipated should be given outright the fields of their former
masters; but Congress steadily rejected the very idea of confiscation.
The necessity of immediate assistance it recognized by creating in 1865
the Freedmen's Bureau to take care of refugees. It authorized the issue
of food and clothing to the destitute and the renting of abandoned and
certain other lands under federal control to former slaves at reasonable
rates. But the larger problem of the relation of the freedmen to the
land, it left to the slow working of time.

Against sharp protests from conservative men, particularly among the
Democrats, Congress did insist, however, on conferring upon the freedmen
certain rights by national law. These rights fell into broad divisions,
civil and political. By an act passed in 1866, Congress gave to former
slaves the rights of white citizens in the matter of making contracts,
giving testimony in courts, and purchasing, selling, and leasing
property. As it was doubtful whether Congress had the power to enact
this law, there was passed and submitted to the states the fourteenth
amendment which gave citizenship to the freedmen, assured them of the
privileges and immunities of citizens of the United States, and declared
that no state should deprive any person of his life, liberty, or
property without due process of law. Not yet satisfied, Congress
attempted to give social equality to negroes by the second civil rights
bill of 1875 which promised to them, among other things, the full and
equal enjoyment of inns, theaters, public conveyances, and places of
amusement--a law later declared unconstitutional by the Supreme Court.

The matter of political rights was even more hotly contested; but the
radical Republicans, like Charles Sumner, asserted that civil rights
were not secure unless supported by the suffrage. In this same
fourteenth amendment they attempted to guarantee the ballot to all negro
men, leaving the women to take care of themselves. The amendment
declared in effect that when any state deprived adult male citizens of
the right to vote, its representation in Congress should be reduced in
the proportion such persons bore to the voting population.

This provision having failed to accomplish its purpose, the fifteenth
amendment was passed and ratified, expressly declaring that no citizen
should be deprived of the right to vote "on account of race, color, or
previous condition of servitude." To make assurance doubly secure,
Congress enacted in 1870, 1872, and 1873 three drastic laws, sometimes
known as "force bills," providing for the use of federal authorities,
civil and military, in supervising elections in all parts of the Union.
So the federal government, having destroyed chattel slavery, sought by
legal decree to sweep away all its signs and badges, civil, social, and
political. Never, save perhaps in some of the civil conflicts of Greece
or Rome, had there occurred in the affairs of a nation a social
revolution so complete, so drastic, and far-reaching in its results.


SUMMARY OF THE SECTIONAL CONFLICT

Just as the United States, under the impetus of Western enterprise,
rounded out the continental domain, its very existence as a nation was
challenged by a fratricidal conflict between two sections. This storm
had been long gathering upon the horizon. From the very beginning in
colonial times there had been a marked difference between the South and
the North. The former by climate and soil was dedicated to a planting
system--the cultivation of tobacco, rice, cotton, and sugar cane--and in
the course of time slave labor became the foundation of the system. The
North, on the other hand, supplemented agriculture by commerce, trade,
and manufacturing. Slavery, though lawful, did not flourish there. An
abundant supply of free labor kept the Northern wheels turning.

This difference between the two sections, early noted by close
observers, was increased with the advent of the steam engine and the
factory system. Between 1815 and 1860 an industrial revolution took
place in the North. Its signs were gigantic factories, huge aggregations
of industrial workers, immense cities, a flourishing commerce, and
prosperous banks. Finding an unfavorable reception in the South, the new
industrial system was confined mainly to the North. By canals and
railways New York, Boston, and Philadelphia were linked with the
wheatfields of Ohio, Indiana, and Illinois. A steel net wove North and
Northwest together. A commercial net supplemented it. Western trade was
diverted from New Orleans to the East and Eastern credit sustained
Western enterprise.

In time, the industrial North and the planting South evolved different
ideas of political policy. The former looked with favor on protective
tariffs, ship subsidies, a sound national banking system, and internal
improvements. The farmers of the West demanded that the public domain be
divided up into free homesteads for farmers. The South steadily swung
around to the opposite view. Its spokesmen came to regard most of these
policies as injurious to the planting interests.

The economic questions were all involved in a moral issue. The Northern
states, in which slavery was of slight consequence, had early abolished
the institution. In the course of a few years there appeared
uncompromising advocates of universal emancipation. Far and wide the
agitation spread. The South was thoroughly frightened. It demanded
protection against the agitators, the enforcement of its rights in the
case of runaway slaves, and equal privileges for slavery in the new
territories.

With the passing years the conflict between the two sections increased
in bitterness. It flamed up in 1820 and was allayed by the Missouri
compromise. It took on the form of a tariff controversy and
nullification in 1832. It appeared again after the Mexican war when the
question of slavery in the new territories was raised. Again
compromise--the great settlement of 1850--seemed to restore peace, only
to prove an illusion. A series of startling events swept the country
into war: the repeal of the Missouri compromise in 1854, the rise of the
Republican party pledged to the prohibition of slavery in the
territories, the Dred Scott decision of 1857, the Lincoln-Douglas
debates, John Brown's raid, the election of Lincoln, and secession.

The Civil War, lasting for four years, tested the strength of both North
and South, in leadership, in finance, in diplomatic skill, in material
resources, in industry, and in armed forces. By the blockade of Southern
ports, by an overwhelming weight of men and materials, and by relentless
hammering on the field of battle, the North was victorious.

The results of the war were revolutionary in character. Slavery was
abolished and the freedmen given the ballot. The Southern planters who
had been the leaders of their section were ruined financially and almost
to a man excluded from taking part in political affairs. The union was
declared to be perpetual and the right of a state to secede settled by
the judgment of battle. Federal control over the affairs of states,
counties, and cities was established by the fourteenth amendment. The
power and prestige of the federal government were enhanced beyond
imagination. The North was now free to pursue its economic policies: a
protective tariff, a national banking system, land grants for railways,
free lands for farmers. Planting had dominated the country for nearly a
generation. Business enterprise was to take its place.


=References=

NORTHERN ACCOUNTS

J.K. Hosmer, _The Appeal to Arms_ and _The Outcome of the Civil War_
(American Nation Series).

J. Ropes, _History of the Civil War_ (best account of military
campaigns).

J.F. Rhodes, _History of the United States_, Vols. III, IV, and V.

J.T. Morse, _Abraham Lincoln_ (2 vols.).


SOUTHERN ACCOUNTS

W.E. Dodd, _Jefferson Davis_.

Jefferson Davis, _Rise and Fall of the Confederate Government_.

E. Pollard, _The Lost Cause_.

A.H. Stephens, _The War between the States_.


=Questions=

1. Contrast the reception of secession in 1860 with that given to
nullification in 1832.

2. Compare the Northern and Southern views of the union.

3. What were the peculiar features of the Confederate constitution?

4. How was the Confederacy financed?

5. Compare the resources of the two sections.

6. On what foundations did Southern hopes rest?

7. Describe the attempts at a peaceful settlement.

8. Compare the raising of armies for the Civil War with the methods
employed in the World War. (See below, chapter XXV.)

9. Compare the financial methods of the government in the two wars.

10. Explain why the blockade was such a deadly weapon.

11. Give the leading diplomatic events of the war.

12. Trace the growth of anti-slavery sentiment.

13. What measures were taken to restrain criticism of the government?

14. What part did Lincoln play in all phases of the war?

15. State the principal results of the war.

16. Compare Lincoln's plan of reconstruction with that adopted by
Congress.

17. What rights did Congress attempt to confer upon the former slaves?


=Research Topics=

=Was Secession Lawful?=--The Southern view by Jefferson Davis in
Harding, _Select Orations Illustrating American History_, pp. 364-369.
Lincoln's view, Harding, pp. 371-381.

=The Confederate Constitution.=--Compare with the federal Constitution
in Macdonald, _Documentary Source Book_, pp. 424-433 and pp. 271-279.

=Federal Legislative Measures.=--Prepare a table and brief digest of the
important laws relating to the war. Macdonald, pp. 433-482.

=Economic Aspects of the War.=--Coman, _Industrial History of the United
States_, pp. 279-301. Dewey, _Financial History of the United States_,
Chaps. XII and XIII. Tabulate the economic measures of Congress in
Macdonald.

=Military Campaigns.=--The great battles are fully treated in Rhodes,
_History of the Civil War_, and teachers desiring to emphasize military
affairs may assign campaigns to members of the class for study and
report. A briefer treatment in Elson, _History of the United States_,
pp. 641-785.

=Biographical Studies.=--Lincoln, Davis, Lee, Grant, Sherman, and other
leaders in civil and military affairs, with reference to local "war
governors."

=English and French Opinion of the War.=--Rhodes, _History of the United
States_, Vol. IV, pp. 337-394.

=The South during the War.=--Rhodes, Vol. V, pp. 343-382.

=The North during the War.=--Rhodes, Vol. V, pp. 189-342.

=Reconstruction Measures.=--Macdonald, _Source Book_, pp. 500-511;
514-518; 529-530; Elson, pp. 786-799.

=The Force Bills.=--Macdonald, pp. 547-551; 554-564.




PART VI. NATIONAL GROWTH AND WORLD POLITICS




CHAPTER XVI

THE POLITICAL AND ECONOMIC EVOLUTION OF THE SOUTH


The outcome of the Civil War in the South was nothing short of a
revolution. The ruling class, the law, and the government of the old
order had been subverted. To political chaos was added the havoc wrought
in agriculture, business, and transportation by military operations. And
as if to fill the cup to the brim, the task of reconstruction was
committed to political leaders from another section of the country,
strangers to the life and traditions of the South.


THE SOUTH AT THE CLOSE OF THE WAR

=A Ruling Class Disfranchised.=--As the sovereignty of the planters had
been the striking feature of the old regime, so their ruin was the
outstanding fact of the new. The situation was extraordinary. The
American Revolution was carried out by people experienced in the arts of
self-government, and at its close they were free to follow the general
course to which they had long been accustomed. The French Revolution
witnessed the overthrow of the clergy and the nobility; but middle
classes who took their places had been steadily rising in intelligence
and wealth.

The Southern Revolution was unlike either of these cataclysms. It was
not brought about by a social upheaval, but by an external crisis. It
did not enfranchise a class that sought and understood power, but
bondmen who had played no part in the struggle. Moreover it struck down
a class equipped to rule. The leading planters were almost to a man
excluded from state and federal offices, and the fourteenth amendment
was a bar to their return. All civil and military places under the
authority of the United States and of the states were closed to every
man who had taken an oath to support the Constitution as a member of
Congress, as a state legislator, or as a state or federal officer, and
afterward engaged in "insurrection or rebellion," or "given aid and
comfort to the enemies" of the United States. This sweeping provision,
supplemented by the reconstruction acts, laid under the ban most of the
talent, energy, and spirit of the South.

=The Condition of the State Governments.=--The legislative, executive,
and judicial branches of the state governments thus passed into the
control of former slaves, led principally by Northern adventurers or
Southern novices, known as "Scalawags." The result was a carnival of
waste, folly, and corruption. The "reconstruction" assembly of South
Carolina bought clocks at $480 apiece and chandeliers at $650. To
purchase land for former bondmen the sum of $800,000 was appropriated;
and swamps bought at seventy-five cents an acre were sold to the state
at five times the cost. In the years between 1868 and 1873, the debt of
the state rose from about $5,800,000 to $24,000,000, and millions of the
increase could not be accounted for by the authorities responsible for
it.

=Economic Ruin--Urban and Rural.=--No matter where Southern men turned
in 1865 they found devastation--in the towns, in the country, and along
the highways. Atlanta, the city to which Sherman applied the torch, lay
in ashes; Nashville and Chattanooga had been partially wrecked; Richmond
and Augusta had suffered severely from fires. Charleston was described
by a visitor as "a city of ruins, of desolation, of vacant houses, of
rotten wharves, of deserted warehouses, of weed gardens, of miles of
grass-grown streets.... How few young men there are, how generally the
young women are dressed in black! The flower of their proud aristocracy
is buried on scores of battle fields."

Those who journeyed through the country about the same time reported
desolation equally widespread and equally pathetic. An English traveler
who made his way along the course of the Tennessee River in 1870 wrote:
"The trail of war is visible throughout the valley in burnt-up gin
houses, ruined bridges, mills, and factories ... and large tracts of
once cultivated land are stripped of every vestige of fencing. The
roads, long neglected, are in disorder and, having in many places become
impassable, new tracks have been made through the woods and fields
without much respect to boundaries." Many a great plantation had been
confiscated by the federal authorities while the owner was in
Confederate service. Many more lay in waste. In the wake of the armies
the homes of rich and poor alike, if spared the torch, had been
despoiled of the stock and seeds necessary to renew agriculture.

=Railways Dilapidated.=--Transportation was still more demoralized. This
is revealed in the pages of congressional reports based upon first-hand
investigations. One eloquent passage illustrates all the rest. From
Pocahontas to Decatur, Alabama, a distance of 114 miles, we are told,
the railroad was "almost entirely destroyed, except the road bed and
iron rails, and they were in a very bad condition--every bridge and
trestle destroyed, cross-ties rotten, buildings burned, water tanks
gone, tracks grown up in weeds and bushes, not a saw mill near the line
and the labor system of the country gone. About forty miles of the track
were burned, the cross-ties entirely destroyed, and the rails bent and
twisted in such a manner as to require great labor to straighten and a
large portion of them requiring renewal."

=Capital and Credit Destroyed.=--The fluid capital of the South, money
and credit, was in the same prostrate condition as the material capital.
The Confederate currency, inflated to the bursting point, had utterly
collapsed and was as worthless as waste paper. The bonds of the
Confederate government were equally valueless. Specie had nearly
disappeared from circulation. The fourteenth amendment to the federal
Constitution had made all "debts, obligations, and claims" incurred in
aid of the Confederate cause "illegal and void." Millions of dollars
owed to Northern creditors before the war were overdue and payment was
pressed upon the debtors. Where such debts were secured by mortgages on
land, executions against the property could be obtained in federal
courts.


THE RESTORATION OF WHITE SUPREMACY

=Intimidation.=--In both politics and economics, the process of
reconstruction in the South was slow and arduous. The first battle in
the political contest for white supremacy was won outside the halls of
legislatures and the courts of law. It was waged, in the main, by secret
organizations, among which the Ku Klux Klan and the White Camelia were
the most prominent. The first of these societies appeared in Tennessee
in 1866 and held its first national convention the following year. It
was in origin a social club. According to its announcement, its objects
were "to protect the weak, the innocent, and the defenceless from the
indignities, wrongs, and outrages of the lawless, the violent, and the
brutal; and to succor the suffering, especially the widows and orphans
of the Confederate soldiers." The whole South was called "the Empire"
and was ruled by a "Grand Wizard." Each state was a realm and each
county a province. In the secret orders there were enrolled over half a
million men.

The methods of the Ku Klux and the White Camelia were similar. Solemn
parades of masked men on horses decked in long robes were held,
sometimes in the daytime and sometimes at the dead of night. Notices
were sent to obnoxious persons warning them to stop certain practices.
If warning failed, something more convincing was tried. Fright was the
emotion most commonly stirred. A horseman, at the witching hour of
midnight, would ride up to the house of some offender, lift his head
gear, take off a skull, and hand it to the trembling victim with the
request that he hold it for a few minutes. Frequently violence was
employed either officially or unofficially by members of the Klan. Tar
and feathers were freely applied; the whip was sometimes laid on
unmercifully, and occasionally a brutal murder was committed. Often the
members were fired upon from bushes or behind trees, and swift
retaliation followed. So alarming did the clashes become that in 1870
Congress forbade interference with electors or going in disguise for the
purpose of obstructing the exercise of the rights enjoyed under federal
law.

In anticipation of such a step on the part of the federal government,
the Ku Klux was officially dissolved by the "Grand Wizard" in 1869.
Nevertheless, the local societies continued their organization and
methods. The spirit survived the national association. "On the whole,"
says a Southern writer, "it is not easy to see what other course was
open to the South.... Armed resistance was out of the question. And yet
there must be some control had of the situation.... If force was denied,
craft was inevitable."

=The Struggle for the Ballot Box.=--The effects of intimidation were
soon seen at elections. The freedman, into whose inexperienced hand the
ballot had been thrust, was ordinarily loath to risk his head by the
exercise of his new rights. He had not attained them by a long and
laborious contest of his own and he saw no urgent reason why he should
battle for the privilege of using them. The mere show of force, the mere
existence of a threat, deterred thousands of ex-slaves from appearing at
the polls. Thus the whites steadily recovered their dominance. Nothing
could prevent it. Congress enacted force bills establishing federal
supervision of elections and the Northern politicians protested against
the return of former Confederates to practical, if not official, power;
but all such opposition was like resistance to the course of nature.

=Amnesty for Southerners.=--The recovery of white supremacy in this way
was quickly felt in national councils. The Democratic party in the North
welcomed it as a sign of its return to power. The more moderate
Republicans, anxious to heal the breach in American unity, sought to
encourage rather than to repress it. So it came about that amnesty for
Confederates was widely advocated. Yet it must be said that the struggle
for the removal of disabilities was stubborn and bitter. Lincoln, with
characteristic generosity, in the midst of the war had issued a general
proclamation of amnesty to nearly all who had been in arms against the
Union, on condition that they take an oath of loyalty; but Johnson,
vindictive toward Southern leaders and determined to make "treason
infamous," had extended the list of exceptions. Congress, even more
relentless in its pursuit of Confederates, pushed through the fourteenth
amendment which worked the sweeping disabilities we have just described.

To appeals for comprehensive clemency, Congress was at first adamant. In
vain did men like Carl Schurz exhort their colleagues to crown their
victory in battle with a noble act of universal pardon and oblivion.
Congress would not yield. It would grant amnesty in individual cases;
for the principle of proscription it stood fast. When finally in 1872,
seven years after the surrender at Appomattox, it did pass the general
amnesty bill, it insisted on certain exceptions. Confederates who had
been members of Congress just before the war, or had served in other
high posts, civil or military, under the federal government, were still
excluded from important offices. Not until the summer of 1898, when the
war with Spain produced once more a union of hearts, did Congress relent
and abolish the last of the disabilities imposed on the Confederates.

=The Force Bills Attacked and Nullified.=--The granting of amnesty
encouraged the Democrats to redouble their efforts all along the line.
In 1874 they captured the House of Representatives and declared war on
the "force bills." As a Republican Senate blocked immediate repeal, they
resorted to an ingenious parliamentary trick. To the appropriation bill
for the support of the army they attached a "rider," or condition, to
the effect that no troops should be used to sustain the Republican
government in Louisiana. The Senate rejected the proposal. A deadlock
ensued and Congress adjourned without making provision for the army.
Satisfied with the technical victory, the Democrats let the army bill
pass the next session, but kept up their fight on the force laws until
they wrung from President Hayes a measure forbidding the use of United
States troops in supervising elections. The following year they again
had recourse to a rider on the army bill and carried it through, putting
an end to the use of money for military control of elections. The
reconstruction program was clearly going to pieces, and the Supreme
Court helped along the process of dissolution by declaring parts of the
laws invalid. In 1878 the Democrats even won a majority in the Senate
and returned to power a large number of men once prominent in the
Confederate cause.

The passions of the war by this time were evidently cooling. A new
generation of men was coming on the scene. The supremacy of the whites
in the South, if not yet complete, was at least assured. Federal
marshals, their deputies, and supervisors of elections still possessed
authority over the polls, but their strength had been shorn by the
withdrawal of United States troops. The war on the remaining remnants of
the "force bills" lapsed into desultory skirmishing. When in 1894 the
last fragment was swept away, the country took little note of the fact.
The only task that lay before the Southern leaders was to write in the
constitutions of their respective states the provisions of law which
would clinch the gains so far secured and establish white supremacy
beyond the reach of outside intervention.

=White Supremacy Sealed by New State Constitutions.=--The impetus to
this final step was given by the rise of the Populist movement in the
South, which sharply divided the whites and in many communities threw
the balance of power into the hands of the few colored voters who
survived the process of intimidation. Southern leaders now devised new
constitutions so constructed as to deprive negroes of the ballot by law.
Mississippi took the lead in 1890; South Carolina followed five years
later; Louisiana, in 1898; North Carolina, in 1900; Alabama and
Maryland, in 1901; and Virginia, in 1902.

The authors of these measures made no attempt to conceal their purposes.
"The intelligent white men of the South," said Governor Tillman, "intend
to govern here." The fifteenth amendment to the federal Constitution,
however, forbade them to deprive any citizen of the right to vote on
account of race, color, or previous condition of servitude. This made
necessary the devices of indirection. They were few, simple, and
effective. The first and most easily administered was the ingenious
provision requiring each prospective voter to read a section of the
state constitution or "understand and explain it" when read to him by
the election officers. As an alternative, the payment of taxes or the
ownership of a small amount of property was accepted as a qualification
for voting. Southern leaders, unwilling to disfranchise any of the poor
white men who had stood side by side with them "in the dark days of
reconstruction," also resorted to a famous provision known as "the
grandfather clause." This plan admitted to the suffrage any man who did
not have either property or educational qualifications, provided he had
voted on or before 1867 or was the son or grandson of any such person.

The devices worked effectively. Of the 147,000 negroes in Mississippi
above the age of twenty-one, only about 8600 registered under the
constitution of 1890. Louisiana had 127,000 colored voters enrolled in
1896; under the constitution drafted two years later the registration
fell to 5300. An analysis of the figures for South Carolina in 1900
indicates that only about one negro out of every hundred adult males of
that race took part in elections. Thus was closed this chapter of
reconstruction.

=The Supreme Court Refuses to Intervene.=--Numerous efforts were made to
prevail upon the Supreme Court of the United States to declare such laws
unconstitutional; but the Court, usually on technical grounds, avoided
coming to a direct decision on the merits of the matter. In one case
the Court remarked that it could not take charge of and operate the
election machinery of Alabama; it concluded that "relief from a great
political wrong, if done as alleged, by the people of a state and by the
state itself, must be given by them, or by the legislative and executive
departments of the government of the United States." Only one of the
several schemes employed, namely, the "grandfather clause," was held to
be a violation of the federal Constitution. This blow, effected in 1915
by the decision in the Oklahoma and Maryland cases, left, however, the
main structure of disfranchisement unimpaired.

=Proposals to Reduce Southern Representation in Congress.=--These
provisions excluding thousands of male citizens from the ballot did not,
in express terms, deprive any one of the vote on account of race or
color. They did not, therefore, run counter to the letter of the
fifteenth amendment; but they did unquestionably make the states which
adopted them liable to the operations of the fourteenth amendment. The
latter very explicitly provides that whenever any state deprives adult
male citizens of the right to vote (except in certain minor cases) the
representation of the state in Congress shall be reduced in the
proportion which such number of disfranchised citizens bears to the
whole number of male citizens over twenty-one years of age.

Mindful of this provision, those who protested against disfranchisement
in the South turned to the Republican party for relief, asking for
action by the political branches of the federal government as the
Supreme Court had suggested. The Republicans responded in their platform
of 1908 by condemning all devices designed to deprive any one of the
ballot for reasons of color alone; they demanded the enforcement in
letter and spirit of the fourteenth as well as all other amendments.
Though victorious in the election, the Republicans refrained from
reopening the ancient contest; they made no attempt to reduce Southern
representation in the House. Southern leaders, while protesting against
the declarations of their opponents, were able to view them as idle
threats in no way endangering the security of the measures by which
political reconstruction had been undone.

=The Solid South.=--Out of the thirty-year conflict against "carpet-bag
rule" there emerged what was long known as the "solid South"--a South
that, except occasionally in the border states, never gave an electoral
vote to a Republican candidate for President. Before the Civil War, the
Southern people had been divided on political questions. Take, for
example, the election of 1860. In all the fifteen slave states the
variety of opinion was marked. In nine of them--Delaware, Virginia,
Tennessee, Missouri, Maryland, Louisiana, Kentucky, Georgia, and
Arkansas--the combined vote against the representative of the extreme
Southern point of view, Breckinridge, constituted a safe majority. In
each of the six states which were carried by Breckinridge, there was a
large and powerful minority. In North Carolina Breckinridge's majority
over Bell and Douglas was only 849 votes. Equally astounding to those
who imagine the South united in defense of extreme views in 1860 was the
vote for Bell, the Unionist candidate, who stood firmly for the
Constitution and silence on slavery. In every Southern state Bell's vote
was large. In Virginia, Kentucky, Missouri, and Tennessee it was greater
than that received by Breckinridge; in Georgia, it was 42,000 against
51,000; in Louisiana, 20,000 against 22,000; in Mississippi, 25,000
against 40,000.

The effect of the Civil War upon these divisions was immediate and
decisive, save in the border states where thousands of men continued to
adhere to the cause of Union. In the Confederacy itself nearly all
dissent was silenced by war. Men who had been bitter opponents joined
hands in defense of their homes; when the armed conflict was over they
remained side by side working against "Republican misrule and negro
domination." By 1890, after Northern supremacy was definitely broken,
they boasted that there were at least twelve Southern states in which no
Republican candidate for President could win a single electoral vote.

=Dissent in the Solid South.=--Though every one grew accustomed to speak
of the South as "solid," it did not escape close observers that in a
number of Southern states there appeared from time to time a fairly
large body of dissenters. In 1892 the Populists made heavy inroads upon
the Democratic ranks. On other occasions, the contests between factions
within the Democratic party over the nomination of candidates revealed
sharp differences of opinion. In some places, moreover, there grew up a
Republican minority of respectable size. For example, in Georgia, Mr.
Taft in 1908 polled 41,000 votes against 72,000 for Mr. Bryan; in North
Carolina, 114,000 against 136,000; in Tennessee, 118,000 against
135,000; in Kentucky, 235,000 against 244,000. In 1920, Senator Harding,
the Republican candidate, broke the record by carrying Tennessee as well
as Kentucky, Oklahoma, and Maryland.


THE ECONOMIC ADVANCE OF THE SOUTH

=The Break-up of the Great Estates.=--In the dissolution of chattel
slavery it was inevitable that the great estate should give way before
the small farm. The plantation was in fact founded on slavery. It was
continued and expanded by slavery. Before the war the prosperous
planter, either by inclination or necessity, invested his surplus in
more land to add to his original domain. As his slaves increased in
number, he was forced to increase his acreage or sell them, and he
usually preferred the former, especially in the Far South. Still another
element favored the large estate. Slave labor quickly exhausted the soil
and of its own force compelled the cutting of the forests and the
extension of the area under cultivation. Finally, the planter took a
natural pride in his great estate; it was a sign of his prowess and his
social prestige.

In 1865 the foundations of the planting system were gone. It was
difficult to get efficient labor to till the vast plantations. The
planters themselves were burdened with debts and handicapped by lack of
capital. Negroes commonly preferred tilling plots of their own, rented
or bought under mortgage, to the more irksome wage labor under white
supervision. The land hunger of the white farmer, once checked by the
planting system, reasserted itself. Before these forces the plantation
broke up. The small farm became the unit of cultivation in the South as
in the North. Between 1870 and 1900 the number of farms doubled in every
state south of the line of the Potomac and Ohio rivers, except in
Arkansas and Louisiana. From year to year the process of breaking up
continued, with all that it implied in the creation of land-owning
farmers.

=The Diversification of Crops.=--No less significant was the concurrent
diversification of crops. Under slavery, tobacco, rice, and sugar were
staples and "cotton was king." These were standard crops. The methods of
cultivation were simple and easily learned. They tested neither the
skill nor the ingenuity of the slaves. As the returns were quick, they
did not call for long-time investments of capital. After slavery was
abolished, they still remained the staples, but far-sighted
agriculturists saw the dangers of depending upon a few crops. The mild
climate all the way around the coast from Virginia to Texas and the
character of the alluvial soil invited the exercise of more imagination.
Peaches, oranges, peanuts, and other fruits and vegetables were found to
grow luxuriantly. Refrigeration for steamships and freight cars put the
markets of great cities at the doors of Southern fruit and vegetable
gardeners. The South, which in planting days had relied so heavily upon
the Northwest for its foodstuffs, began to battle for independence.
Between 1880 and the close of the century the value of its farm crops
increased from $660,000,000 to $1,270,000,000.

=The Industrial and Commercial Revolution.=--On top of the radical
changes in agriculture came an industrial and commercial revolution. The
South had long been rich in natural resources, but the slave system had
been unfavorable to their development. Rivers that would have turned
millions of spindles tumbled unheeded to the seas. Coal and iron beds
lay unopened. Timber was largely sacrificed in clearing lands for
planting, or fell to earth in decay. Southern enterprise was consumed in
planting. Slavery kept out the white immigrants who might have supplied
the skilled labor for industry.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

STEEL MILLS--BIRMINGHAM, ALABAMA]

After 1865, achievement and fortune no longer lay on the land alone. As
soon as the paralysis of the war was over, the South caught the
industrial spirit that had conquered feudal Europe and the agricultural
North. In the development of mineral wealth, enormous strides were
taken. Iron ore of every quality was found, the chief beds being in
Virginia, West Virginia, Tennessee, Kentucky, North Carolina, Georgia,
Alabama, Arkansas, and Texas. Five important coal basins were uncovered:
in Virginia, North Carolina, the Appalachian chain from Maryland to
Northern Alabama, Kentucky, Arkansas, and Texas. Oil pools were found
in Kentucky, Tennessee, and Texas. Within two decades, 1880 to 1900, the
output of mineral wealth multiplied tenfold: from ten millions a year to
one hundred millions. The iron industries of West Virginia and Alabama
began to rival those of Pennsylvania. Birmingham became the Pittsburgh
and Atlanta the Chicago of the South.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

A SOUTHERN COTTON MILL IN A COTTON FIELD]

In other lines of industry, lumbering and cotton manufacturing took a
high rank. The development of Southern timber resources was in every
respect remarkable, particularly in Louisiana, Arkansas, and
Mississippi. At the end of the first decade of the twentieth century,
primacy in lumber had passed from the Great Lakes region to the South.
In 1913 eight Southern states produced nearly four times as much lumber
as the Lake states and twice as much as the vast forests of Washington
and Oregon.

The development of the cotton industry, in the meantime, was similarly
astounding. In 1865 cotton spinning was a negligible matter in the
Southern states. In 1880 they had one-fourth of the mills of the
country. At the end of the century they had one-half the mills, the two
Carolinas taking the lead by consuming more than one-third of their
entire cotton crop. Having both the raw materials and the power at hand,
they enjoyed many advantages over the New England rivals, and at the
opening of the new century were outstripping the latter in the
proportion of spindles annually put into operation. Moreover, the cotton
planters, finding a market at the neighboring mills, began to look
forward to a day when they would be somewhat emancipated from absolute
dependence upon the cotton exchanges of New York, New Orleans, and
Liverpool.

Transportation kept pace with industry. In 1860, the South had about ten
thousand miles of railway. By 1880 the figure had doubled. During the
next twenty years over thirty thousand miles were added, most of the
increase being in Texas. About 1898 there opened a period of
consolidation in which scores of short lines were united, mainly under
the leadership of Northern capitalists, and new through service opened
to the North and West. Thus Southern industries were given easy outlets
to the markets of the nation and brought within the main currents of
national business enterprise.

=The Social Effects of the Economic Changes.=--As long as the slave
system lasted and planting was the major interest, the South was bound
to be sectional in character. With slavery gone, crops diversified,
natural resources developed, and industries promoted, the social order
of the ante-bellum days inevitably dissolved; the South became more and
more assimilated to the system of the North. In this process several
lines of development are evident.

In the first place we see the steady rise of the small farmer. Even in
the old days there had been a large class of white yeomen who owned no
slaves and tilled the soil with their own hands, but they labored under
severe handicaps. They found the fertile lands of the coast and river
valleys nearly all monopolized by planters, and they were by the force
of circumstances driven into the uplands where the soil was thin and the
crops were light. Still they increased in numbers and zealously worked
their freeholds.

The war proved to be their opportunity. With the break-up of the
plantations, they managed to buy land more worthy of their plows. By
intelligent labor and intensive cultivation they were able to restore
much of the worn-out soil to its original fertility. In the meantime
they rose with their prosperity in the social and political scale. It
became common for the sons of white farmers to enter the professions,
while their daughters went away to college and prepared for teaching.
Thus a more democratic tone was given to the white society of the South.
Moreover the migration to the North and West, which had formerly carried
thousands of energetic sons and daughters to search for new homesteads,
was materially reduced. The energy of the agricultural population went
into rehabilitation.

The increase in the number of independent farmers was accompanied by the
rise of small towns and villages which gave diversity to the life of the
South. Before 1860 it was possible to travel through endless stretches
of cotton and tobacco. The social affairs of the planter's family
centered in the homestead even if they were occasionally interrupted by
trips to distant cities or abroad. Carpentry, bricklaying, and
blacksmithing were usually done by slaves skilled in simple handicrafts.
Supplies were bought wholesale. In this way there was little place in
plantation economy for villages and towns with their stores and
mechanics.

The abolition of slavery altered this. Small farms spread out where
plantations had once stood. The skilled freedmen turned to agriculture
rather than to handicrafts; white men of a business or mechanical bent
found an opportunity to serve the needs of their communities. So local
merchants and mechanics became an important element in the social
system. In the county seats, once dominated by the planters, business
and professional men assumed the leadership.

Another vital outcome of this revolution was the transference of a large
part of planting enterprise to business. Mr. Bruce, a Southern historian
of fine scholarship, has summed up this process in a single telling
paragraph: "The higher planting class that under the old system gave so
much distinction to rural life has, so far as it has survived at all,
been concentrated in the cities. The families that in the time of
slavery would have been found only in the country are now found, with a
few exceptions, in the towns. The transplantation has been practically
universal. The talent, the energy, the ambition that formerly sought
expression in the management of great estates and the control of hosts
of slaves, now seek a field of action in trade, in manufacturing
enterprises, or in the general enterprises of development. This was for
the ruling class of the South the natural outcome of the great economic
revolution that followed the war."

As in all other parts of the world, the mechanical revolution was
attended by the growth of a population of industrial workers dependent
not upon the soil but upon wages for their livelihood. When Jefferson
Davis was inaugurated President of the Southern Confederacy, there were
approximately only one hundred thousand persons employed in Southern
manufactures as against more than a million in Northern mills. Fifty
years later, Georgia and Alabama alone had more than one hundred and
fifty thousand wage-earners. Necessarily this meant also a material
increase in urban population, although the wide dispersion of cotton
spinning among small centers prevented the congestion that had
accompanied the rise of the textile industry in New England. In 1910,
New Orleans, Atlanta, Memphis, Nashville, and Houston stood in the same
relation to the New South that Cincinnati, Chicago, Cleveland, and
Detroit had stood to the New West fifty years before. The problems of
labor and capital and municipal administration, which the earlier
writers boasted would never perplex the planting South, had come in full
force.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

A GLIMPSE OF MEMPHIS, TENNESSEE]

=The Revolution in the Status of the Slaves.=--No part of Southern
society was so profoundly affected by the Civil War and economic
reconstruction as the former slaves. On the day of emancipation, they
stood free, but empty-handed, the owners of no tools or property, the
masters of no trade and wholly inexperienced in the arts of self-help
that characterized the whites in general. They had never been accustomed
to looking out for themselves. The plantation bell had called them to
labor and released them. Doles of food and clothing had been regularly
made in given quantities. They did not understand wages, ownership,
renting, contracts, mortgages, leases, bills, or accounts.

When they were emancipated, four courses were open to them. They could
flee from the plantation to the nearest town or city, or to the distant
North, to seek a livelihood. Thousands of them chose this way,
overcrowding cities where disease mowed them down. They could remain
where they, were in their cabins and work for daily wages instead of
food, clothing, and shelter. This second course the major portion of
them chose; but, as few masters had cash to dispense, the new relation
was much like the old, in fact. It was still one of barter. The planter
offered food, clothing, and shelter; the former slaves gave their labor
in return. That was the best that many of them could do.

A third course open to freedmen was that of renting from the former
master, paying him usually with a share of the produce of the land. This
way a large number of them chose. It offered them a chance to become
land owners in time and it afforded an easier life, the renter being, to
a certain extent at least, master of his own hours of labor. The final
and most difficult path was that to ownership of land. Many a master
helped his former slaves to acquire small holdings by offering easy
terms. The more enterprising and the more fortunate who started life as
renters or wage-earners made their way upward to ownership in so many
cases that by the end of the century, one-fourth of the colored laborers
on the land owned the soil they tilled.

In the meantime, the South, though relatively poor, made relatively
large expenditures for the education of the colored population. By the
opening of the twentieth century, facilities were provided for more than
one-half of the colored children of school age. While in many respects
this progress was disappointing, its significance, to be appreciated,
must be derived from a comparison with the total illiteracy which
prevailed under slavery.

In spite of all that happened, however, the status of the negroes in the
South continued to give a peculiar character to that section of the
country. They were almost entirely excluded from the exercise of the
suffrage, especially in the Far South. Special rooms were set aside for
them at the railway stations and special cars on the railway lines. In
the field of industry calling for technical skill, it appears, from the
census figures, that they lost ground between 1890 and 1900--a condition
which their friends ascribed to discriminations against them in law and
in labor organizations and their critics ascribed to their lack of
aptitude. Whatever may be the truth, the fact remained that at the
opening of the twentieth century neither the hopes of the emancipators
nor the fears of their opponents were realized. The marks of the
"peculiar institution" were still largely impressed upon Southern
society.

The situation, however, was by no means unchanging. On the contrary
there was a decided drift in affairs. For one thing, the proportion of
negroes in the South had slowly declined. By 1900 they were in a
majority in only two states, South Carolina and Mississippi. In
Arkansas, Virginia, West Virginia, and North Carolina the proportion of
the white population was steadily growing. The colored migration
northward increased while the westward movement of white farmers which
characterized pioneer days declined. At the same time a part of the
foreign immigration into the United States was diverted southward. As
the years passed these tendencies gained momentum. The already huge
colored quarters in some Northern cities were widely expanded, as whole
counties in the South were stripped of their colored laborers. The race
question, in its political and economic aspects, became less and less
sectional, more and more national. The South was drawn into the main
stream of national life. The separatist forces which produced the
cataclysm of 1861 sank irresistibly into the background.


=References=

H.W. Grady, _The New South_ (1890).

H.A. Herbert, _Why the Solid South_.

W.G. Brown, _The Lower South_.

E.G. Murphy, _Problems of the Present South_.

B.T. Washington, _The Negro Problem_; _The Story of the Negro_; _The
Future of the Negro_.

A.B. Hart, _The Southern South_ and R.S. Baker, _Following the Color
Line_ (two works by Northern writers).

T.N. Page, _The Negro, the Southerner's Problem_.


=Questions=

1. Give the three main subdivisions of the chapter.

2. Compare the condition of the South in 1865 with that of the North.
Compare with the condition of the United States at the close of the
Revolutionary War. At the close of the World War in 1918.

3. Contrast the enfranchisement of the slaves with the enfranchisement
of white men fifty years earlier.

4. What was the condition of the planters as compared with that of the
Northern manufacturers?

5. How does money capital contribute to prosperity? Describe the plight
of Southern finance.

6. Give the chief steps in the restoration of white supremacy.

7. Do you know of any other societies to compare with the Ku Klux Klan?

8. Give Lincoln's plan for amnesty. What principles do you think should
govern the granting of amnesty?

9. How were the "Force bills" overcome?

10. Compare the fourteenth and fifteenth amendments with regard to the
suffrage provisions.

11. Explain how they may be circumvented.

12. Account for the Solid South. What was the situation before 1860?

13. In what ways did Southern agriculture tend to become like that of
the North? What were the social results?

14. Name the chief results of an "industrial revolution" in general. In
the South, in particular.

15. What courses were open to freedmen in 1865?

16. Give the main features in the economic and social status of the
colored population in the South.

17. Explain why the race question is national now, rather than
sectional.



=Research Topics=

=Amnesty for Confederates.=--Study carefully the provisions of the
fourteenth amendment in the Appendix. Macdonald, _Documentary Source
Book of American History_, pp. 470 and 564. A plea for amnesty in
Harding, _Select Orations Illustrating American History_, pp. 467-488.

=Political Conditions in the South in 1868.=--Dunning, _Reconstruction,
Political and Economic_ (American Nation Series), pp. 109-123; Hart,
_American History Told by Contemporaries_, Vol. IV, pp. 445-458,
497-500; Elson, _History of the United States_, pp. 799-805.

=Movement for White Supremacy.=--Dunning, _Reconstruction_, pp. 266-280;
Paxson, _The New Nation_ (Riverside Series), pp. 39-58; Beard, _American
Government and Politics_, pp. 454-457.

=The Withdrawal of Federal Troops from the South.=--Sparks, _National
Development_ (American Nation Series), pp. 84-102; Rhodes, _History of
the United States_, Vol. VIII, pp. 1-12.

=Southern Industry.=--Paxson, _The New Nation_, pp. 192-207; T.M. Young,
_The American Cotton Industry_, pp. 54-99.

=The Race Question.=--B.T. Washington, _Up From Slavery_ (sympathetic
presentation); A.H. Stone, _Studies in the American Race Problem_
(coldly analytical); Hart, _Contemporaries_, Vol. IV, pp. 647-649,
652-654, 663-669.




CHAPTER XVII

BUSINESS ENTERPRISE AND THE REPUBLICAN PARTY


If a single phrase be chosen to characterize American life during the
generation that followed the age of Douglas and Lincoln, it must be
"business enterprise"--the tremendous, irresistible energy of a virile
people, mounting in numbers toward a hundred million and applied without
let or hindrance to the developing of natural resources of unparalleled
richness. The chief goal of this effort was high profits for the
captains of industry, on the one hand; and high wages for the workers,
on the other. Its signs, to use the language of a Republican orator in
1876, were golden harvest fields, whirling spindles, turning wheels,
open furnace doors, flaming forges, and chimneys filled with eager fire.
The device blazoned on its shield and written over its factory doors was
"prosperity." A Republican President was its "advance agent." Released
from the hampering interference of the Southern planters and the
confusing issues of the slavery controversy, business enterprise sprang
forward to the task of winning the entire country. Then it flung its
outposts to the uttermost parts of the earth--Europe, Africa, and the
Orient--where were to be found markets for American goods and natural
resources for American capital to develop.


RAILWAYS AND INDUSTRY

=The Outward Signs of Enterprise.=--It is difficult to comprehend all
the multitudinous activities of American business energy or to appraise
its effects upon the life and destiny of the American people; for beyond
the horizon of the twentieth century lie consequences as yet undreamed
of in our poor philosophy. Statisticians attempt to record its
achievements in terms of miles of railways built, factories opened, men
and women employed, fortunes made, wages paid, cities founded, rivers
spanned, boxes, bales, and tons produced. Historians apply standards of
comparison with the past. Against the slow and leisurely stagecoach,
they set the swift express, rushing from New York to San Francisco in
less time than Washington consumed in his triumphal tour from Mt. Vernon
to New York for his first inaugural. Against the lazy sailing vessel
drifting before a genial breeze, they place the turbine steamer crossing
the Atlantic in five days or the still swifter airplane, in fifteen
hours. For the old workshop where a master and a dozen workmen and
apprentices wrought by hand, they offer the giant factory where ten
thousand persons attend the whirling wheels driven by steam. They write
of the "romance of invention" and the "captains of industry."

[Illustration: _Copyright by Underwood and Underwood, N.Y._

A CORNER IN THE BETHLEHEM STEEL WORKS]

=The Service of the Railway.=--All this is fitting in its way. Figures
and contrasts cannot, however, tell the whole story. Take, for example,
the extension of railways. It is easy to relate that there were 30,000
miles in 1860; 166,000 in 1890; and 242,000 in 1910. It is easy to show
upon the map how a few straggling lines became a perfect mesh of closely
knitted railways; or how, like the tentacles of a great monster, the few
roads ending in the Mississippi Valley in 1860 were extended and
multiplied until they tapped every wheat field, mine, and forest beyond
the valley. All this, eloquent of enterprise as it truly is, does not
reveal the significance of railways for American life. It does not
indicate how railways made a continental market for American goods; nor
how they standardized the whole country, giving to cities on the
advancing frontier the leading features of cities in the old East; nor
how they carried to the pioneer the comforts of civilization; nor yet
how in the West they were the forerunners of civilization, the makers of
homesteads, the builders of states.

=Government Aid for Railways.=--Still the story is not ended. The
significant relation between railways and politics must not be
overlooked. The bounty of a lavish government, for example, made
possible the work of railway promoters. By the year 1872 the Federal
government had granted in aid of railways 155,000,000 acres of land--an
area estimated as almost equal to Pennsylvania, New York, Connecticut,
Rhode Island, Massachusetts, Maine, New Hampshire, and Vermont. The
Union Pacific Company alone secured from the federal government a free
right of way through the public domain, twenty sections of land with
each mile of railway, and a loan up to fifty millions of dollars secured
by a second mortgage on the company's property. More than half of the
northern tier of states lying against Canada from Lake Michigan to the
Pacific was granted to private companies in aid of railways and wagon
roads. About half of New Mexico, Arizona, and California was also given
outright to railway companies. These vast grants from the federal
government were supplemented by gifts from the states in land and by
subscriptions amounting to more than two hundred million dollars. The
history of these gifts and their relation to the political leaders that
engineered them would alone fill a large and interesting volume.

=Railway Fortunes and Capital.=--Out of this gigantic railway promotion,
the first really immense American fortunes were made. Henry Adams, the
grandson of John Quincy Adams, related that his grandfather on his
mother's side, Peter Brooks, on his death in 1849, left a fortune of two
million dollars, "supposed to be the largest estate in Boston," then one
of the few centers of great riches. Compared with the opulence that
sprang out of the Union Pacific, the Northern Pacific, the Southern
Pacific, with their subsidiary and component lines, the estate of Peter
Brooks was a poor man's heritage.

The capital invested in these railways was enormous beyond the
imagination of the men of the stagecoach generation. The total debt of
the United States incurred in the Revolutionary War--a debt which those
of little faith thought the country could never pay--was reckoned at a
figure well under $75,000,000. When the Union Pacific Railroad was
completed, there were outstanding against it $27,000,000 in first
mortgage bonds, $27,000,000 in second mortgage bonds held by the
government, $10,000,000 in income bonds, $10,000,000 in land grant
bonds, and, on top of that huge bonded indebtedness, $36,000,000 in
stock--making $110,000,000 in all. If the amount due the United States
government be subtracted, still there remained, in private hands, stocks
and bonds exceeding in value the whole national debt of Hamilton's
day--a debt that strained all the resources of the Federal government in
1790. Such was the financial significance of the railways.

[Illustration: RAILROADS OF THE UNITED STATES IN 1918]

=Growth and Extension of Industry.=--In the field of manufacturing,
mining, and metal working, the results of business enterprise far
outstripped, if measured in mere dollars, the results of railway
construction. By the end of the century there were about ten billion
dollars invested in factories alone and five million wage-earners
employed in them; while the total value of the output, fourteen billion
dollars, was fifteen times the figure for 1860. In the Eastern states
industries multiplied. In the Northwest territory, the old home of
Jacksonian Democracy, they overtopped agriculture. By the end of the
century, Ohio had almost reached and Illinois had surpassed
Massachusetts in the annual value of manufacturing output.

That was not all. Untold wealth in the form of natural resources was
discovered in the South and West. Coal deposits were found in the
Appalachians stretching from Pennsylvania down to Alabama, in Michigan,
in the Mississippi Valley, and in the Western mountains from North
Dakota to New Mexico. In nearly every coal-bearing region, iron was also
discovered and the great fields of Michigan, Wisconsin, and Minnesota
soon rivaled those of the Appalachian area. Copper, lead, gold, and
silver in fabulous quantities were unearthed by the restless prospectors
who left no plain or mountain fastness unexplored. Petroleum, first
pumped from the wells of Pennsylvania in the summer of 1859, made new
fortunes equaling those of trade, railways, and land speculation. It
scattered its riches with an especially lavish hand through Oklahoma,
Texas, and California.

=The Trust--an Instrument of Industrial Progress.=--Business enterprise,
under the direction of powerful men working single-handed, or of small
groups of men pooling their capital for one or more undertakings, had
not advanced far before there appeared upon the scene still mightier
leaders of even greater imagination. New constructive genius now brought
together and combined under one management hundreds of concerns or
thousands of miles of railways, revealing the magic strength of
cooperation on a national scale. Price-cutting in oil, threatening ruin
to those engaged in the industry, as early as 1879, led a number of
companies in Cleveland, Pittsburgh, and Philadelphia to unite in
price-fixing. Three years later a group of oil interests formed a close
organization, placing all their stocks in the hands of trustees, among
whom was John D. Rockefeller. The trustees, in turn, issued
certificates representing the share to which each participant was
entitled; and took over the management of the entire business. Such was
the nature of the "trust," which was to play such an unique role in the
progress of America.

The idea of combination was applied in time to iron and steel, copper,
lead, sugar, cordage, coal, and other commodities, until in each field
there loomed a giant trust or corporation, controlling, if not most of
the output, at least enough to determine in a large measure the prices
charged to consumers. With the passing years, the railways, mills,
mines, and other business concerns were transferred from individual
owners to corporations. At the end of the nineteenth century, the whole
face of American business was changed. Three-fourths of the output from
industries came from factories under corporate management and only
one-fourth from individual and partnership undertakings.

[Illustration: JOHN D. ROCKEFELLER]

=The Banking Corporation.=--Very closely related to the growth of
business enterprise on a large scale was the system of banking. In the
old days before banks, a person with savings either employed them in his
own undertakings, lent them to a neighbor, or hid them away where they
set no industry in motion. Even in the early stages of modern business,
it was common for a manufacturer to rise from small beginnings by
financing extensions out of his own earnings and profits. This state of
affairs was profoundly altered by the growth of the huge corporations
requiring millions and even billions of capital. The banks, once an
adjunct to business, became the leaders in business.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

WALL STREET, NEW YORK CITY]

It was the banks that undertook to sell the stocks and bonds issued by
new corporations and trusts and to supply them with credit to carry on
their operations. Indeed, many of the great mergers or combinations in
business were initiated by magnates in the banking world with millions
and billions under their control. Through their connections with one
another, the banks formed a perfect network of agencies gathering up the
pennies and dollars of the masses as well as the thousands of the rich
and pouring them all into the channels of business and manufacturing.
In this growth of banking on a national scale, it was inevitable that a
few great centers, like Wall Street in New York or State Street in
Boston, should rise to a position of dominance both in concentrating the
savings and profits of the nation and in financing new as well as old
corporations.

=The Significance of the Corporation.=--The corporation, in fact, became
the striking feature of American business life, one of the most
marvelous institutions of all time, comparable in wealth and power and
the number of its servants with kingdoms and states of old. The effect
of its rise and growth cannot be summarily estimated; but some special
facts are obvious. It made possible gigantic enterprises once entirely
beyond the reach of any individual, no matter how rich. It eliminated
many of the futile and costly wastes of competition in connection with
manufacture, advertising, and selling. It studied the cheapest methods
of production and shut down mills that were poorly equipped or
disadvantageously located. It established laboratories for research in
industry, chemistry, and mechanical inventions. Through the sale of
stocks and bonds, it enabled tens of thousands of people to become
capitalists, if only in a small way. The corporation made it possible
for one person to own, for instance, a $50 share in a million dollar
business concern--a thing entirely impossible under a regime of
individual owners and partnerships.

There was, of course, another side to the picture. Many of the
corporations sought to become monopolies and to make profits, not by
economies and good management, but by extortion from purchasers.
Sometimes they mercilessly crushed small business men, their
competitors, bribed members of legislatures to secure favorable laws,
and contributed to the campaign funds of both leading parties. Wherever
a trust approached the position of a monopoly, it acquired a dominion
over the labor market which enabled it to break even the strongest trade
unions. In short, the power of the trust in finance, in manufacturing,
in politics, and in the field of labor control can hardly be measured.

=The Corporation and Labor.=--In the development of the corporation
there was to be observed a distinct severing of the old ties between
master and workmen, which existed in the days of small industries. For
the personal bond between the owner and the employees was substituted a
new relation. "In most parts of our country," as President Wilson once
said, "men work, not for themselves, not as partners in the old way in
which they used to work, but generally as employees--in a higher or
lower grade--of great corporations." The owner disappeared from the
factory and in his place came the manager, representing the usually
invisible stockholders and dependent for his success upon his ability to
make profits for the owners. Hence the term "soulless corporation,"
which was to exert such a deep influence on American thinking about
industrial relations.

=Cities and Immigration.=--Expressed in terms of human life, this era of
unprecedented enterprise meant huge industrial cities and an immense
labor supply, derived mainly from European immigration. Here, too,
figures tell only a part of the story. In Washington's day nine-tenths
of the American people were engaged in agriculture and lived in the
country; in 1890 more than one-third of the population dwelt in towns of
2500 and over; in 1920 more than half of the population lived in towns
of over 2500. In forty years, between 1860 and 1900, Greater New York
had grown from 1,174,000 to 3,437,000; San Francisco from 56,000 to
342,000; Chicago from 109,000 to 1,698,000. The miles of city tenements
began to rival, in the number of their residents, the farm homesteads of
the West. The time so dreaded by Jefferson had arrived. People were
"piled upon one another in great cities" and the republic of small
farmers had passed away.

To these industrial centers flowed annually an ever-increasing tide of
immigration, reaching the half million point in 1880; rising to
three-quarters of a million three years later; and passing the million
mark in a single year at the opening of the new century. Immigration was
as old as America but new elements now entered the situation. In the
first place, there were radical changes in the nationality of the
newcomers. The migration from Northern Europe--England, Ireland,
Germany, and Scandinavia--diminished; that from Italy, Russia, and
Austria-Hungary increased, more than three-fourths of the entire number
coming from these three lands between the years 1900 and 1910. These
later immigrants were Italians, Poles, Magyars, Czechs, Slovaks,
Russians, and Jews, who came from countries far removed from the
language and the traditions of England whence came the founders of
America.

In the second place, the reception accorded the newcomers differed from
that given to the immigrants in the early days. By 1890 all the free
land was gone. They could not, therefore, be dispersed widely among the
native Americans to assimilate quickly and unconsciously the habits and
ideas of American life. On the contrary, they were diverted mainly to
the industrial centers. There they crowded--nay, overcrowded--into
colonies of their own where they preserved their languages, their
newspapers, and their old-world customs and views.

So eager were American business men to get an enormous labor supply that
they asked few questions about the effect of this "alien invasion" upon
the old America inherited from the fathers. They even stimulated the
invasion artificially by importing huge armies of foreigners under
contract to work in specified mines and mills. There seemed to be no
limit to the factories, forges, refineries, and railways that could be
built, to the multitudes that could be employed in conquering a
continent. As for the future, that was in the hands of Providence!

=Business Theories of Politics.=--As the statesmen of Hamilton's school
and the planters of Calhoun's had their theories of government and
politics, so the leaders in business enterprise had theirs. It was
simple and easily stated. "It is the duty of the government," they
urged, "to protect American industry against foreign competition by
means of high tariffs on imported goods, to aid railways by generous
grants of land, to sell mineral and timber lands at low prices to
energetic men ready to develop them, and then to leave the rest to the
initiative and drive of individuals and companies." All government
interference with the management, prices, rates, charges, and conduct of
private business they held to be either wholly pernicious or intolerably
impertinent. Judging from their speeches and writings, they conceived
the nation as a great collection of individuals, companies, and labor
unions all struggling for profits or high wages and held together by a
government whose principal duty was to keep the peace among them and
protect industry against the foreign manufacturer. Such was the
political theory of business during the generation that followed the
Civil War.


THE SUPREMACY OF THE REPUBLICAN PARTY (1861-85)

=Business Men and Republican Policies.=--Most of the leaders in industry
gravitated to the Republican ranks. They worked in the North and the
Republican party was essentially Northern. It was moreover--at least so
far as the majority of its members were concerned--committed to
protective tariffs, a sound monetary and banking system, the promotion
of railways and industry by land grants, and the development of internal
improvements. It was furthermore generous in its immigration policy. It
proclaimed America to be an asylum for the oppressed of all countries
and flung wide the doors for immigrants eager to fill the factories, man
the mines, and settle upon Western lands. In a word the Republicans
stood for all those specific measures which favored the enlargement and
prosperity of business. At the same time they resisted government
interference with private enterprise. They did not regulate railway
rates, prosecute trusts for forming combinations, or prevent railway
companies from giving lower rates to some shippers than to others. To
sum it up, the political theories of the Republican party for three
decades after the Civil War were the theories of American
business--prosperous and profitable industries for the owners and "the
full dinner pail" for the workmen. Naturally a large portion of those
who flourished under its policies gave their support to it, voted for
its candidates, and subscribed to its campaign funds.

=Sources of Republican Strength in the North.=--The Republican party was
in fact a political organization of singular power. It originated in a
wave of moral enthusiasm, having attracted to itself, if not the
abolitionists, certainly all those idealists, like James Russell Lowell
and George William Curtis, who had opposed slavery when opposition was
neither safe nor popular. To moral principles it added practical
considerations. Business men had confidence in it. Workingmen, who
longed for the independence of the farmer, owed to its indulgent land
policy the opportunity of securing free homesteads in the West. The
immigrant, landing penniless on these shores, as a result of the same
beneficent system, often found himself in a little while with an estate
as large as many a baronial domain in the Old World. Under a Republican
administration, the union had been saved. To it the veterans of the war
could turn with confidence for those rewards of service which the
government could bestow: pensions surpassing in liberality anything that
the world had ever seen. Under a Republican administration also the
great debt had been created in the defense of the union, and to the
Republican party every investor in government bonds could look for the
full and honorable discharge of the interest and principal. The spoils
system, inaugurated by Jacksonian Democracy, in turn placed all the
federal offices in Republican hands, furnishing an army of party workers
to be counted on for loyal service in every campaign.

Of all these things Republican leaders made full and vigorous use,
sometimes ascribing to the party, in accordance with ancient political
usage, merits and achievements not wholly its own. Particularly was this
true in the case of saving the union. "When in the economy of
Providence, this land was to be purged of human slavery ... the
Republican party came into power," ran a declaration in one platform.
"The Republican party suppressed a gigantic rebellion, emancipated four
million slaves, decreed the equal citizenship of all, and established
universal suffrage," ran another. As for the aid rendered by the
millions of Northern Democrats who stood by the union and the tens of
thousands of them who actually fought in the union army, the Republicans
in their zeal were inclined to be oblivious. They repeatedly charged the
Democratic party "with being the same in character and spirit as when it
sympathized with treason."

=Republican Control of the South.=--To the strength enjoyed in the
North, the Republicans for a long time added the advantages that came
from control over the former Confederate states where the newly
enfranchised negroes, under white leadership, gave a grateful support to
the party responsible for their freedom. In this branch of politics,
motives were so mixed that no historian can hope to appraise them all at
their proper values. On the one side of the ledger must be set the
vigorous efforts of the honest and sincere friends of the freedmen to
win for them complete civil and political equality, wiping out not only
slavery but all its badges of misery and servitude. On the same side
must be placed the labor of those who had valiantly fought in forum and
field to save the union and who regarded continued Republican supremacy
after the war as absolutely necessary to prevent the former leaders in
secession from coming back to power. At the same time there were
undoubtedly some men of the baser sort who looked on politics as a game
and who made use of "carpet-bagging" in the South to win the spoils that
might result from it. At all events, both by laws and presidential acts,
the Republicans for many years kept a keen eye upon the maintenance of
their dominion in the South. Their declaration that neither the law nor
its administration should admit any discrimination in respect of
citizens by reason of race, color, or previous condition of servitude
appealed to idealists and brought results in elections. Even South
Carolina, where reposed the ashes of John C. Calhoun, went Republican in
1872 by a vote of three to one!

Republican control was made easy by the force bills described in a
previous chapter--measures which vested the supervision of elections in
federal officers appointed by Republican Presidents. These drastic
measures, departing from American tradition, the Republican authors
urged, were necessary to safeguard the purity of the ballot, not merely
in the South where the timid freedman might readily be frightened from
using it; but also in the North, particularly in New York City, where it
was claimed that fraud was regularly practiced by Democratic leaders.

The Democrats, on their side, indignantly denied the charges, replying
that the force bills were nothing but devices created by the Republicans
for the purpose of securing their continued rule through systematic
interference with elections. Even the measures of reconstruction were
deemed by Democratic leaders as thinly veiled schemes to establish
Republican power throughout the country. "Nor is there the slightest
doubt," exclaimed Samuel J. Tilden, spokesman of the Democrats in New
York and candidate for President in 1876, "that the paramount object and
motive of the Republican party is by these means to secure itself
against a reaction of opinion adverse to it in our great populous
Northern commonwealths.... When the Republican party resolved to
establish negro supremacy in the ten states in order to gain to itself
the representation of those states in Congress, it had to begin by
governing the people of those states by the sword.... The next was the
creation of new electoral bodies for those ten states, in which, by
exclusions, by disfranchisements and proscriptions, by control over
registration, by applying test oaths ... by intimidation and by every
form of influence, three million negroes are made to predominate over
four and a half million whites."

=The War as a Campaign Issue.=--Even the repeal of force bills could not
allay the sectional feelings engendered by the war. The Republicans
could not forgive the men who had so recently been in arms against the
union and insisted on calling them "traitors" and "rebels." The
Southerners, smarting under the reconstruction acts, could regard the
Republicans only as political oppressors. The passions of the war had
been too strong; the distress too deep to be soon forgotten. The
generation that went through it all remembered it all. For twenty
years, the Republicans, in their speeches and platforms, made "a
straight appeal to the patriotism of the Northern voters." They
maintained that their party, which had saved the union and emancipated
the slaves, was alone worthy of protecting the union and uplifting the
freedmen.

Though the Democrats, especially in the North, resented this policy and
dubbed it with the expressive but inelegant phrase, "waving the bloody
shirt," the Republicans refused to surrender a slogan which made such a
ready popular appeal. As late as 1884, a leader expressed the hope that
they might "wring one more President from the bloody shirt." They
refused to let the country forget that the Democratic candidate, Grover
Cleveland, had escaped military service by hiring a substitute; and they
made political capital out of the fact that he had "insulted the
veterans of the Grand Army of the Republic" by going fishing on
Decoration Day.

=Three Republican Presidents.=--Fortified by all these elements of
strength, the Republicans held the presidency from 1869 to 1885. The
three Presidents elected in this period, Grant, Hayes, and Garfield, had
certain striking characteristics in common. They were all of origin
humble enough to please the most exacting Jacksonian Democrat. They had
been generals in the union army. Grant, next to Lincoln, was regarded as
the savior of the Constitution. Hayes and Garfield, though lesser lights
in the military firmament, had honorable records duly appreciated by
veterans of the war, now thoroughly organized into the Grand Army of the
Republic. It is true that Grant was not a politician and had never voted
the Republican ticket; but this was readily overlooked. Hayes and
Garfield on the other hand were loyal party men. The former had served
in Congress and for three terms as governor of his state. The latter had
long been a member of the House of Representatives and was Senator-elect
when he received the nomination for President.

All of them possessed, moreover, another important asset, which was not
forgotten by the astute managers who led in selecting candidates. All
of them were from Ohio--though Grant had been in Illinois when the
summons to military duties came--and Ohio was a strategic state. It lay
between the manufacturing East and the agrarian country to the West.
Having growing industries and wool to sell it benefited from the
protective tariff. Yet being mainly agricultural still, it was not

without sympathy for the farmers who showed low tariff or free trade
tendencies. Whatever share the East had in shaping laws and framing
policies, it was clear that the West was to have the candidates. This
division in privileges--not uncommon in political management--was always
accompanied by a judicious selection of the candidate for Vice
President. With Garfield, for example, was associated a prominent New
York politician, Chester A. Arthur, who, as fate decreed, was destined
to more than three years' service as chief magistrate, on the
assassination of his superior in office.

=The Disputed Election of 1876.=--While taking note of the long years of
Republican supremacy, it must be recorded that grave doubts exist in the
minds of many historians as to whether one of the three Presidents,
Hayes, was actually the victor in 1876 or not. His Democratic opponent,
Samuel J. Tilden, received a popular plurality of a quarter of a million
and had a plausible claim to a majority of the electoral vote. At all
events, four states sent in double returns, one set for Tilden and
another for Hayes; and a deadlock ensued. Both parties vehemently
claimed the election and the passions ran so high that sober men did not
shrink from speaking of civil war again. Fortunately, in the end, the
counsels of peace prevailed. Congress provided for an electoral
commission of fifteen men to review the contested returns. The
Democrats, inspired by Tilden's moderation, accepted the judgment in
favor of Hayes even though they were not convinced that he was really
entitled to the office.


THE GROWTH OF OPPOSITION TO REPUBLICAN RULE

=Abuses in American Political Life.=--During their long tenure of
office, the Republicans could not escape the inevitable consequences of
power; that is, evil practices and corrupt conduct on the part of some
who found shelter within the party. For that matter neither did the
Democrats manage to avoid such difficulties in those states and cities
where they had the majority. In New York City, for instance, the local
Democratic organization, known as Tammany Hall, passed under the sway of
a group of politicians headed by "Boss" Tweed. He plundered the city
treasury until public-spirited citizens, supported by Samuel J. Tilden,
the Democratic leader of the state, rose in revolt, drove the ringleader
from power, and sent him to jail. In Philadelphia, the local Republican
bosses were guilty of offenses as odious as those committed by New York
politicians. Indeed, the decade that followed the Civil War was marred
by so many scandals in public life that one acute editor was moved to
inquire: "Are not all the great communities of the Western World growing
more corrupt as they grow in wealth?"

In the sphere of national politics, where the opportunities were
greater, betrayals of public trust were even more flagrant. One
revelation after another showed officers, high and low, possessed with
the spirit of peculation. Members of Congress, it was found, accepted
railway stock in exchange for votes in favor of land grants and other
concessions to the companies. In the administration as well as the
legislature the disease was rife. Revenue officers permitted whisky
distillers to evade their taxes and received heavy bribes in return. A
probe into the post-office department revealed the malodorous "star
route frauds"--the deliberate overpayment of certain mail carriers whose
lines were indicated in the official record by asterisks or stars. Even
cabinet officers did not escape suspicion, for the trail of the serpent
led straight to the door of one of them.

In the lower ranges of official life, the spoils system became more
virulent as the number of federal employees increased. The holders of
offices and the seekers after them constituted a veritable political
army. They crowded into Republican councils, for the Republicans, being
in power, could alone dispense federal favors. They filled positions in
the party ranging from the lowest township committee to the national
convention. They helped to nominate candidates and draft platforms and
elbowed to one side the busy citizen, not conversant with party
intrigues, who could only give an occasional day to political matters.
Even the Civil Service Act of 1883, wrung from a reluctant Congress two
years after the assassination of Garfield, made little change for a long
time. It took away from the spoilsmen a few thousand government
positions, but it formed no check on the practice of rewarding party
workers from the public treasury.

On viewing this state of affairs, many a distinguished citizen became
profoundly discouraged. James Russell Lowell, for example, thought he
saw a steady decline in public morals. In 1865, hearing of Lee's
surrender, he had exclaimed: "There is something magnificent in having a
country to love!" Ten years later, when asked to write an ode for the
centennial at Philadelphia in 1876, he could think only of a biting
satire on the nation:

    "Show your state legislatures; show your Rings;
     And challenge Europe to produce such things
     As high officials sitting half in sight
     To share the plunder and fix things right.
     If that don't fetch her, why, you need only
     To show your latest style in martyrs,--Tweed:
     She'll find it hard to hide her spiteful tears
     At such advance in one poor hundred years."

When his critics condemned him for this "attack upon his native land,"
Lowell replied in sadness: "These fellows have no notion of what love of
country means. It was in my very blood and bones. If I am not an
American who ever was?... What fills me with doubt and dismay is the
degradation of the moral tone. Is it or is it not a result of democracy?
Is ours a 'government of the people, by the people, for the people,' or
a Kakistocracy [a government of the worst], rather for the benefit of
knaves at the cost of fools?"

=The Reform Movement in Republican Ranks.=--The sentiments expressed by
Lowell, himself a Republican and for a time American ambassador to
England, were shared by many men in his party. Very soon after the close
of the Civil War some of them began to protest vigorously against the
policies and conduct of their leaders. In 1872, the dissenters, calling
themselves Liberal Republicans, broke away altogether, nominated a
candidate of their own, Horace Greeley, and put forward a platform
indicting the Republican President fiercely enough to please the most
uncompromising Democrat. They accused Grant of using "the powers and
opportunities of his high office for the promotion of personal ends."
They charged him with retaining "notoriously corrupt and unworthy men in
places of power and responsibility." They alleged that the Republican
party kept "alive the passions and resentments of the late civil war to
use them for their own advantages," and employed the "public service of
the government as a machinery of corruption and personal influence."

It was not apparent, however, from the ensuing election that any
considerable number of Republicans accepted the views of the Liberals.
Greeley, though indorsed by the Democrats, was utterly routed and died
of a broken heart. The lesson of his discomfiture seemed to be that
independent action was futile. So, at least, it was regarded by most men
of the rising generation like Henry Cabot Lodge, of Massachusetts, and
Theodore Roosevelt, of New York. Profiting by the experience of Greeley
they insisted in season and out that reformers who desired to rid the
party of abuses should remain loyal to it and do their work "on the
inside."

=The Mugwumps and Cleveland Democracy in 1884.=--Though aided by
Republican dissensions, the Democrats were slow in making headway
against the political current. They were deprived of the energetic and
capable leadership once afforded by the planters, like Calhoun, Davis,
and Toombs; they were saddled by their opponents with responsibility for
secession; and they were stripped of the support of the prostrate
South. Not until the last Southern state was restored to the union, not
until a general amnesty was wrung from Congress, not until white
supremacy was established at the polls, and the last federal soldier
withdrawn from Southern capitals did they succeed in capturing the
presidency.

The opportune moment for them came in 1884 when a number of
circumstances favored their aspirations. The Republicans, leaving the
Ohio Valley in their search for a candidate, nominated James G. Blaine
of Maine, a vigorous and popular leader but a man under fire from the
reformers in his own party. The Democrats on their side were able to
find at this juncture an able candidate who had no political enemies in
the sphere of national politics, Grover Cleveland, then governor of New
York and widely celebrated as a man of "sterling honesty." At the same
time a number of dissatisfied Republicans openly espoused the Democratic
cause,--among them Carl Schurz, George William Curtis, Henry Ward
Beecher, and William Everett, men of fine ideals and undoubted
integrity. Though the "regular" Republicans called them "Mugwumps" and
laughed at them as the "men milliners, the dilettanti, and carpet
knights of politics," they had a following that was not to be despised.

The campaign which took place that year was one of the most savage in
American history. Issues were thrust into the background. The tariff,
though mentioned, was not taken seriously. Abuse of the opposition was
the favorite resource of party orators. The Democrats insisted that "the
Republican party so far as principle is concerned is a reminiscence. In
practice it is an organization for enriching those who control its
machinery." For the Republican candidate, Blaine, they could hardly find
words to express their contempt. The Republicans retaliated in kind.
They praised their own good works, as of old, in saving the union, and
denounced the "fraud and violence practiced by the Democracy in the
Southern states." Seeing little objectionable in the public record of
Cleveland as mayor of Buffalo and governor of New York, they attacked
his personal character. Perhaps never in the history of political
campaigns did the discussions on the platform and in the press sink to
so low a level. Decent people were sickened. Even hot partisans shrank
from their own words when, after the election, they had time to reflect
on their heedless passions. Moreover, nothing was decided by the
balloting. Cleveland was elected, but his victory was a narrow one. A
change of a few hundred votes in New York would have sent his opponent
to the White House instead.

=Changing Political Fortunes (1888-96).=--After the Democrats had
settled down to the enjoyment of their hard-earned victory, President
Cleveland in his message of 1887 attacked the tariff as "vicious,
inequitable, and illogical"; as a system of taxation that laid a burden
upon "every consumer in the land for the benefit of our manufacturers."
Business enterprise was thoroughly alarmed. The Republicans
characterized the tariff message as a free-trade assault upon the
industries of the country. Mainly on that issue they elected in 1888
Benjamin Harrison of Indiana, a shrewd lawyer, a reticent politician, a
descendant of the hero of Tippecanoe, and a son of the old Northwest.
Accepting the outcome of the election as a vindication of their
principles, the Republicans, under the leadership of William McKinley in
the House of Representatives, enacted in 1890 a tariff law imposing the
highest duties yet laid in our history. To their utter surprise,
however, they were instantly informed by the country that their program
was not approved. That very autumn they lost in the congressional
elections, and two years later they were decisively beaten in the
presidential campaign, Cleveland once more leading his party to victory.


=References=

L.H. Haney, _Congressional History of Railways_ (2 vols.).

J.P. Davis, _Union Pacific Railway_.

J.M. Swank, _History of the Manufacture of Iron_.

M.T. Copeland, _The Cotton Manufacturing Industry in the United States_
(Harvard Studies).

E.W. Bryce, _Progress of Invention in the Nineteenth Century_.

Ida Tarbell, _History of the Standard Oil Company_ (Critical).

G.H. Montague, _Rise and Progress of the Standard Oil Company_
(Friendly).

H.P. Fairchild, _Immigration_, and F.J. Warne, _The Immigrant Invasion_
(Both works favor exclusion).

I.A. Hourwich, _Immigration_ (Against exclusionist policies).

J.F. Rhodes, _History of the United States, 1877-1896_, Vol. VIII.

Edward Stanwood, _A History of the Presidency_, Vol. I, for the
presidential elections of the period.


=Questions=

1. Contrast the state of industry and commerce at the close of the Civil
War with its condition at the close of the Revolutionary War.

2. Enumerate the services rendered to the nation by the railways.

3. Explain the peculiar relation of railways to government.

4. What sections of the country have been industrialized?

5. How do you account for the rise and growth of the trusts? Explain
some of the economic advantages of the trust.

6. Are the people in cities more or less independent than the farmers?
What was Jefferson's view?

7. State some of the problems raised by unrestricted immigration.

8. What was the theory of the relation of government to business in this
period? Has it changed in recent times?

9. State the leading economic policies sponsored by the Republican
party.

10. Why were the Republicans especially strong immediately after the
Civil War?

11. What illustrations can you give showing the influence of war in
American political campaigns?

12. Account for the strength of middle-western candidates.

13. Enumerate some of the abuses that appeared in American political
life after 1865.

14. Sketch the rise and growth of the reform movement.

15. How is the fluctuating state of public opinion reflected in the
elections from 1880 to 1896?


=Research Topics=

=Invention, Discovery, and Transportation.=--Sparks, _National
Development_ (American Nation Series), pp. 37-67; Bogart, _Economic
History of the United States_, Chaps. XXI, XXII, and XXIII.

=Business and Politics.=--Paxson, _The New Nation_ (Riverside Series),
pp. 92-107; Rhodes, _History of the United States_, Vol. VII, pp. 1-29,
64-73, 175-206; Wilson, _History of the American People_, Vol. IV, pp.
78-96.

=Immigration.=--Coman, _Industrial History of the United States_ (2d
ed.), pp. 369-374; E.L. Bogart, _Economic History of the United States_,
pp. 420-422, 434-437; Jenks and Lauck, _Immigration Problems_, Commons,
_Races and Immigrants_.

=The Disputed Election of 1876.=--Haworth, _The United States in Our Own
Time_, pp. 82-94; Dunning, _Reconstruction, Political and Economic_
(American Nation Series), pp. 294-341; Elson, _History of the United
States_, pp. 835-841.

=Abuses in Political Life.=--Dunning, _Reconstruction_, pp. 281-293; see
criticisms in party platforms in Stanwood, _History of the Presidency_,
Vol. I; Bryce, _American Commonwealth_ (1910 ed.), Vol. II, pp. 379-448;
136-167.

=Studies of Presidential Administrations.=--(_a_) Grant, (_b_) Hayes,
(_c_) Garfield-Arthur, (_d_) Cleveland, and (_e_) Harrison, in Haworth,
_The United States in Our Own Time_, or in Paxson, _The New Nation_
(Riverside Series), or still more briefly in Elson.

=Cleveland Democracy.=--Haworth, _The United States_, pp. 164-183;
Rhodes, _History of the United States_, Vol. VIII, pp. 240-327; Elson,
pp. 857-887.

=Analysis of Modern Immigration Problems.=--_Syllabus in History_ (New
York State, 1919), pp. 110-112.




CHAPTER XVIII

THE DEVELOPMENT OF THE GREAT WEST


At the close of the Civil War, Kansas and Texas were sentinel states on
the middle border. Beyond the Rockies, California, Oregon, and Nevada
stood guard, the last of them having been just admitted to furnish
another vote for the fifteenth amendment abolishing slavery. Between the
near and far frontiers lay a vast reach of plain, desert, plateau, and
mountain, almost wholly undeveloped. A broad domain, extending from
Canada to Mexico, and embracing the regions now included in Washington,
Idaho, Wyoming, Montana, Utah, Arizona, New Mexico, the Dakotas, and
Oklahoma, had fewer than half a million inhabitants. It was laid out
into territories, each administered under a governor appointed by the
President and Senate and, as soon as there was the requisite number of
inhabitants, a legislature elected by the voters. No railway line
stretched across the desert. St. Joseph on the Missouri was the terminus
of the Eastern lines. It required twenty-five days for a passenger to
make the overland journey to California by the stagecoach system,
established in 1858, and more than ten days for the swift pony express,
organized in 1860, to carry a letter to San Francisco. Indians still
roamed the plain and desert and more than one powerful tribe disputed
the white man's title to the soil.


THE RAILWAYS AS TRAIL BLAZERS

=Opening Railways to the Pacific.=--A decade before the Civil War the
importance of rail connection between the East and the Pacific Coast had
been recognized. Pressure had already been brought to bear on Congress
to authorize the construction of a line and to grant land and money in
its aid. Both the Democrats and Republicans approved the idea, but it
was involved in the slavery controversy. Indeed it was submerged in it.
Southern statesmen wanted connections between the Gulf and the Pacific
through Texas, while Northerners stood out for a central route.

The North had its way during the war. Congress, by legislation initiated
in 1862, provided for the immediate organization of companies to build a
line from the Missouri River to California and made grants of land and
loans of money to aid in the enterprise. The Western end, the Central
Pacific, was laid out under the supervision of Leland Stanford. It was
heavily financed by the Mormons of Utah and also by the state
government, the ranchmen, miners, and business men of California; and it
was built principally by Chinese labor. The Eastern end, the Union
Pacific, starting at Omaha, was constructed mainly by veterans of the
Civil War and immigrants from Ireland and Germany. In 1869 the two
companies met near Ogden in Utah and the driving of the last spike,
uniting the Atlantic and the Pacific, was the occasion of a great
demonstration.

Other lines to the Pacific were projected at the same time; but the
panic of 1873 checked railway enterprise for a while. With the revival
of prosperity at the end of that decade, construction was renewed with
vigor and the year 1883 marked a series of railway triumphs. In February
trains were running from New Orleans through Houston, San Antonio, and
Yuma to San Francisco, as a result of a union of the Texas Pacific with
the Southern Pacific and its subsidiary corporations. In September the
last spike was driven in the Northern Pacific at Helena, Montana. Lake
Superior was connected with Puget Sound. The waters explored by Joliet
and Marquette were joined to the waters plowed by Sir Francis Drake
while he was searching for a route around the world. That same year also
a third line was opened to the Pacific by way of the Atchison, Topeka
and Santa Fe, making connections through Albuquerque and Needles with
San Francisco. The fondest hopes of railway promoters seemed to be
realized.

[Illustration: UNITED STATES IN 1870]

=Western Railways Precede Settlement.=--In the Old World and on our
Atlantic seaboard, railways followed population and markets. In the Far
West, railways usually preceded the people. Railway builders planned
cities on paper before they laid tracks connecting them. They sent
missionaries to spread the gospel of "Western opportunity" to people in
the Middle West, in the Eastern cities, and in Southern states. Then
they carried their enthusiastic converts bag and baggage in long trains
to the distant Dakotas and still farther afield. So the development of
the Far West was not left to the tedious processes of time. It was
pushed by men of imagination--adventurers who made a romance of
money-making and who had dreams of empire unequaled by many kings of the
past.

These empire builders bought railway lands in huge tracts; they got more
from the government; they overcame every obstacle of canon, mountain,
and stream with the aid of science; they built cities according to the
plans made by the engineers. Having the towns ready and railway and
steamboat connections formed with the rest of the world, they carried
out the people to use the railways, the steamships, the houses, and the
land. It was in this way that "the frontier speculator paved the way for
the frontier agriculturalist who had to be near a market before he could
farm." The spirit of this imaginative enterprise, which laid out
railways and towns in advance of the people, is seen in an advertisement
of that day: "This extension will run 42 miles from York, northeast
through the Island Lake country, and will have five good North Dakota
towns. The stations on the line will be well equipped with elevators and
will be constructed and ready for operation at the commencement of the
grain season. Prospective merchants have been active in securing
desirable locations at the different towns on the line. There are still
opportunities for hotels, general merchandise, hardware, furniture, and
drug stores, etc."

[Illustration: _Copyright by Underwood and Underwood, N.Y._

A TOWN ON THE PRAIRIE]

Among the railway promoters and builders in the West, James J. Hill,
of the Great Northern and allied lines, was one of the most forceful
figures. He knew that tracks and trains were useless without passengers
and freight; without a population of farmers and town dwellers. He
therefore organized publicity in the Virginias, Iowa, Ohio, Indiana,
Illinois, Wisconsin, and Nebraska especially. He sent out agents to tell
the story of Western opportunity in this vein: "You see your children
come out of school with no chance to get farms of their own because the
cost of land in your older part of the country is so high that you can't
afford to buy land to start your sons out in life around you. They have
to go to the cities to make a living or become laborers in the mills or
hire out as farm hands. There is no future for them there. If you are
doing well where you are and can safeguard the future of your children
and see them prosper around you, don't leave here. But if you want
independence, if you are renting your land, if the money-lender is
carrying you along and you are running behind year after year, you can
do no worse by moving.... You farmers talk of free trade and protection
and what this or that political party will do for you. Why don't you
vote a homestead for yourself? That is the only thing Uncle Sam will
ever give you. Jim Hill hasn't an acre of land to sell you. We are not
in the real estate business. We don't want you to go out West and make a
failure of it because the rates at which we haul you and your goods make
the first transaction a loss.... We must have landless men for a manless
land."

Unlike steamship companies stimulating immigration to get the fares,
Hill was seeking permanent settlers who would produce, manufacture, and
use the railways as the means of exchange. Consequently he fixed low
rates and let his passengers take a good deal of live stock and
household furniture free. By doing this he made an appeal that was
answered by eager families. In 1894 the vanguard of home seekers left
Indiana in fourteen passenger coaches, filled with men, women, and
children, and forty-eight freight cars carrying their household goods
and live stock. In the ten years that followed, 100,000 people from the
Middle West and the South, responding to his call, went to the Western
country where they brought eight million acres of prairie land under
cultivation.

When Hill got his people on the land, he took an interest in everything
that increased the productivity of their labor. Was the output of food
for his freight cars limited by bad drainage on the farms? Hill then
interested himself in practical ways of ditching and tiling. Were
farmers hampered in hauling their goods to his trains by bad roads? In
that case, he urged upon the states the improvement of highways. Did the
traffic slacken because the food shipped was not of the best quality?
Then live stock must be improved and scientific farming promoted. Did
the farmers need credit? Banks must be established close at hand to
advance it. In all conferences on scientific farm management,
conservation of natural resources, banking and credit in relation to
agriculture and industry, Hill was an active participant. His was the
long vision, seeing in conservation and permanent improvements the
foundation of prosperity for the railways and the people.

Indeed, he neglected no opportunity to increase the traffic on the
lines. He wanted no empty cars running in either direction and no wheat
stored in warehouses for the lack of markets. So he looked to the Orient
as well as to Europe as an outlet for the surplus of the farms. He sent
agents to China and Japan to discover what American goods and produce
those countries would consume and what manufactures they had to offer to
Americans in exchange. To open the Pacific trade he bought two ocean
monsters, the _Minnesota_ and the _Dakota_, thus preparing for
emergencies West as well as East. When some Japanese came to the United
States on their way to Europe to buy steel rails, Hill showed them how
easy it was for them to make their purchase in this country and ship by
way of American railways and American vessels. So the railway builder
and promoter, who helped to break the virgin soil of the prairies, lived
through the pioneer epoch and into the age of great finance. Before he
died he saw the wheat fields of North Dakota linked with the spinning
jennies of Manchester and the docks of Yokohama.


THE EVOLUTION OF GRAZING AND AGRICULTURE

=The Removal of the Indians.=--Unlike the frontier of New England in
colonial days or that of Kentucky later, the advancing lines of home
builders in the Far West had little difficulty with warlike natives.
Indian attacks were made on the railway construction gangs; General
Custer had his fatal battle with the Sioux in 1876 and there were minor
brushes; but they were all of relatively slight consequence. The former
practice of treating with the Indians as independent nations was
abandoned in 1871 and most of them were concentrated in reservations
where they were mainly supported by the government. The supervision of
their affairs was vested in a board of commissioners created in 1869 and
instructed to treat them as wards of the nation--a trust which
unfortunately was often betrayed. A further step in Indian policy was
taken in 1887 when provision was made for issuing lands to individual
Indians, thus permitting them to become citizens and settle down among
their white neighbors as farmers or cattle raisers. The disappearance of
the buffalo, the main food supply of the wild Indians, had made them
more tractable and more willing to surrender the freedom of the hunter
for the routine of the reservation, ranch, or wheat field.

=The Cowboy and Cattle Ranger.=--Between the frontier of farms and the
mountains were plains and semi-arid regions in vast reaches suitable for
grazing. As soon as the railways were open into the Missouri Valley,
affording an outlet for stock, there sprang up to the westward cattle
and sheep raising on an immense scale. The far-famed American cowboy was
the hero in this scene. Great herds of cattle were bred in Texas; with
the advancing spring and summer seasons, they were driven northward
across the plains and over the buffalo trails. In a single year, 1884,
it is estimated that nearly one million head of cattle were moved out of
Texas to the North by four thousand cowboys, supplied with 30,000
horses and ponies.

During the two decades from 1870 to 1890 both the cattle men and the
sheep raisers had an almost free run of the plains, using public lands
without paying for the privilege and waging war on one another over the
possession of ranges. At length, however, both had to go, as the
homesteaders and land companies came and fenced in the plain and desert
with endless lines of barbed wire. Already in 1893 a writer familiar
with the frontier lamented the passing of the picturesque days: "The
unique position of the cowboys among the Americans is jeopardized in a
thousand ways. Towns are growing up on their pasture lands; irrigation
schemes of a dozen sorts threaten to turn bunch-grass scenery into
farm-land views; farmers are pre-empting valleys and the sides of
waterways; and the day is not far distant when stock-raising must be
done mainly in small herds, with winter corrals, and then the cowboy's
days will end. Even now his condition disappoints those who knew him
only half a dozen years ago. His breed seems to have deteriorated and
his ranks are filling with men who work for wages rather than for the
love of the free life and bold companionship that once tempted men into
that calling. Splendid Cheyenne saddles are less and less numerous in
the outfits; the distinctive hat that made its way up from Mexico may or
may not be worn; all the civil authorities in nearly all towns in the
grazing country forbid the wearing of side arms; nobody shoots up these
towns any more. The fact is the old simon-pure cowboy days are gone
already."

=Settlement under the Homestead Act of 1862.=--Two factors gave a
special stimulus to the rapid settlement of Western lands which swept
away the Indians and the cattle rangers. The first was the policy of the
railway companies in selling large blocks of land received from the
government at low prices to induce immigration. The second was the
operation of the Homestead law passed in 1862. This measure practically
closed the long controversy over the disposition of the public domain
that was suitable for agriculture. It provided for granting, without any
cost save a small registration fee, public lands in lots of 160 acres
each to citizens and aliens who declared their intention of becoming
citizens. The one important condition attached was that the settler
should occupy the farm for five years before his title was finally
confirmed. Even this stipulation was waived in the case of the Civil War
veterans who were allowed to count their term of military service as a
part of the five years' occupancy required. As the soldiers of the
Revolutionary and Mexican wars had advanced in great numbers to the
frontier in earlier days, so now veterans led in the settlement of the
middle border. Along with them went thousands of German, Irish, and
Scandinavian immigrants, fresh from the Old World. Between 1867 and
1874, 27,000,000 acres were staked out in quarter-section farms. In
twenty years (1860-80), the population of Nebraska leaped from 28,000 to
almost half a million; Kansas from 100,000 to a million; Iowa from
600,000 to 1,600,000; and the Dakotas from 5000 to 140,000.

=The Diversity of Western Agriculture.=--In soil, produce, and
management, Western agriculture presented many contrasts to that of the
East and South. In the region of arable and watered lands the typical
American unit--the small farm tilled by the owner--appeared as usual;
but by the side of it many a huge domain owned by foreign or Eastern
companies and tilled by hired labor. Sometimes the great estate took the
shape of the "bonanza farm" devoted mainly to wheat and corn and
cultivated on a large scale by machinery. Again it assumed the form of
the cattle ranch embracing tens of thousands of acres. Again it was a
vast holding of diversified interest, such as the Santa Anita ranch near
Los Angeles, a domain of 60,000 acres "cultivated in a glorious sweep of
vineyards and orange and olive orchards, rich sheep and cattle pastures
and horse ranches, their life and customs handed down from the Spanish
owners of the various ranches which were swept into one estate."

=Irrigation.=--In one respect agriculture in the Far West was unique. In
a large area spreading through eight states, Montana, Idaho, Wyoming,
Utah, Colorado, Nevada, Arizona, New Mexico, and parts of adjoining
states, the rainfall was so slight that the ordinary crops to which the
American farmer was accustomed could not be grown at all. The Mormons
were the first Anglo-Saxons to encounter aridity, and they were baffled
at first; but they studied it and mastered it by magnificent irrigation
systems. As other settlers poured into the West the problem of the
desert was attacked with a will, some of them replying to the
commiseration of Eastern farmers by saying that it was easier to scoop
out an irrigation ditch than to cut forests and wrestle with stumps and
stones. Private companies bought immense areas at low prices, built
irrigation works, and disposed of their lands in small plots. Some
ranchers with an instinct for water, like that of the miner for metal,
sank wells into the dry sand and were rewarded with gushers that "soused
the thirsty desert and turned its good-for-nothing sand into
good-for-anything loam." The federal government came to the aid of the
arid regions in 1894 by granting lands to the states to be used for
irrigation purposes. In this work Wyoming took the lead with a law which
induced capitalists to invest in irrigation and at the same time
provided for the sale of the redeemed lands to actual settlers. Finally
in 1902 the federal government by its liberal Reclamation Act added its
strength to that of individuals, companies, and states in conquering
"arid America."

"Nowhere," writes Powell, a historian of the West, in his picturesque
_End of the Trail_, "has the white man fought a more courageous fight or
won a more brilliant victory than in Arizona. His weapons have been the
transit and the level, the drill and the dredge, the pick and the spade;
and the enemy which he has conquered has been the most stubborn of all
foes--the hostile forces of Nature.... The story of how the white man
within the space of less than thirty years penetrated, explored, and
mapped this almost unknown region; of how he carried law, order, and
justice into a section which had never had so much as a speaking
acquaintance with any one of the three before; of how, realizing the
necessity for means of communication, he built highways of steel across
this territory from east to west and from north to south; of how,
undismayed by the savageness of the countenance which the desert turned
upon him, he laughed and rolled up his sleeves, and spat upon his hands,
and slashed the face of the desert with canals and irrigating ditches,
and filled those ditches with water brought from deep in the earth or
high in the mountains; and of how, in the conquered and submissive soil,
he replaced the aloe with alfalfa, the mesquite with maize, the cactus
with cotton, forms one of the most inspiring chapters in our history. It
is one of the epics of civilization, this reclamation of the Southwest,
and its heroes, thank God, are Americans.

"Other desert regions have been redeemed by irrigation--Egypt, for
example, and Mesopotamia and parts of the Sudan--but the people of all
those regions lay stretched out in the shade of a convenient palm,
metaphorically speaking, and waited for some one with more energy than
themselves to come along and do the work. But the Arizonians, mindful of
the fact that God, the government, and Carnegie help those who help
themselves, spent their days wielding the pick and shovel, and their
evenings in writing letters to Washington with toil-hardened hands.
After a time the government was prodded into action and the great dams
at Laguna and Roosevelt are the result. Then the people, organizing
themselves into cooperative leagues and water-users' associations, took
up the work of reclamation where the government left off; it is to these
energetic, persevering men who have drilled wells, plowed fields, and
dug ditches through the length and breadth of that great region which
stretches from Yuma to Tucson, that the metamorphosis of Arizona is
due."

The effect of irrigation wherever introduced was amazing. Stretches of
sand and sagebrush gave way to fertile fields bearing crops of wheat,
corn, fruits, vegetables, and grass. Huge ranches grazed by browsing
sheep were broken up into small plots. The cowboy and ranchman vanished.
In their place rose the prosperous community--a community unlike the
township of Iowa or the industrial center of the East. Its intensive
tillage left little room for hired labor. Its small holdings drew
families together in village life rather than dispersing them on the
lonely plain. Often the development of water power in connection with
irrigation afforded electricity for labor-saving devices and lifted many
a burden that in other days fell heavily upon the shoulders of the
farmer and his family.


MINING AND MANUFACTURING IN THE WEST

=Mineral Resources.=--In another important particular the Far West
differed from the Mississippi Valley states. That was in the
predominance of mining over agriculture throughout a vast section.
Indeed it was the minerals rather than the land that attracted the
pioneers who first opened the country. The discovery of gold in
California in 1848 was the signal for the great rush of prospectors,
miners, and promoters who explored the valleys, climbed the hills,
washed the sands, and dug up the soil in their feverish search for gold,
silver, copper, coal, and other minerals. In Nevada and Montana the
development of mineral resources went on all during the Civil War. Alder
Gulch became Virginia City in 1863; Last Chance Gulch was named Helena
in 1864; and Confederate Gulch was christened Diamond City in 1865. At
Butte the miners began operations in 1864 and within five years had
washed out eight million dollars' worth of gold. Under the gold they
found silver; under silver they found copper.

Even at the end of the nineteenth century, after agriculture was well
advanced and stock and sheep raising introduced on a large scale,
minerals continued to be the chief source of wealth in a number of
states. This was revealed by the figures for 1910. The gold, silver,
iron, and copper of Colorado were worth more than the wheat, corn, and
oats combined; the copper of Montana sold for more than all the cereals
and four times the price of the wheat. The interest of Nevada was also
mainly mining, the receipts from the mineral output being $43,000,000 or
more than one-half the national debt of Hamilton's day. The yield of the
mines of Utah was worth four or five times the wheat crop; the coal of
Wyoming brought twice as much as the great wool clip; the minerals of
Arizona were totaled at $43,000,000 as against a wool clip reckoned at
$1,200,000; while in Idaho alone of this group of states did the wheat
crop exceed in value the output of the mines.

[Illustration: _Photograph from Underwood and Underwood, N.Y._

LOGGING]

=Timber Resources.=--The forests of the great West, unlike those of the
Ohio Valley, proved a boon to the pioneers rather than a foe to be
attacked. In Ohio and Indiana, for example, the frontier line of
homemakers had to cut, roll, and burn thousands of trees before they
could put out a crop of any size. Beyond the Mississippi, however,
there were all ready for the breaking plow great reaches of almost
treeless prairie, where every stick of timber was precious. In the other
parts, often rough and mountainous, where stood primeval forests of the
finest woods, the railroads made good use of the timber. They consumed
acres of forests themselves in making ties, bridge timbers, and
telegraph poles, and they laid a heavy tribute upon the forests for
their annual upkeep. The surplus trees, such as had burdened the
pioneers of the Northwest Territory a hundred years before, they carried
off to markets on the east and west coasts.

=Western Industries.=--The peculiar conditions of the Far West
stimulated a rise of industries more rapid than is usual in new country.
The mining activities which in many sections preceded agriculture called
for sawmills to furnish timber for the mines and smelters to reduce and
refine ores. The ranches supplied sheep and cattle for the packing
houses of Kansas City as well as Chicago. The waters of the Northwest
afforded salmon for 4000 cases in 1866 and for 1,400,000 cases in 1916.
The fruits and vegetables of California brought into existence
innumerable canneries. The lumber industry, starting with crude sawmills
to furnish rough timbers for railways and mines, ended in specialized
factories for paper, boxes, and furniture. As the railways preceded
settlement and furnished a ready outlet for local manufactures, so they
encouraged the early establishment of varied industries, thus creating a
state of affairs quite unlike that which obtained in the Ohio Valley in
the early days before the opening of the Erie Canal.

=Social Effects of Economic Activities.=--In many respects the social
life of the Far West also differed from that of the Ohio Valley. The
treeless prairies, though open to homesteads, favored the great estate
tilled in part by tenant labor and in part by migratory seasonal labor,
summoned from all sections of the country for the harvests. The mineral
resources created hundreds of huge fortunes which made the accumulations
of eastern mercantile families look trivial by comparison. Other
millionaires won their fortunes in the railway business and still more
from the cattle and sheep ranges. In many sections the "cattle king," as
he was called, was as dominant as the planter had been in the old South.
Everywhere in the grazing country he was a conspicuous and important
person. He "sometimes invested money in banks, in railroad stocks, or in
city property.... He had his rating in the commercial reviews and could
hobnob with bankers, railroad presidents, and metropolitan merchants....
He attended party caucuses and conventions, ran for the state
legislature, and sometimes defeated a lawyer or metropolitan 'business
man' in the race for a seat in Congress. In proportion to their numbers,
the ranchers ... have constituted a highly impressive class."

Although many of the early capitalists of the great West, especially
from Nevada, spent their money principally in the East, others took
leadership in promoting the sections in which they had made their
fortunes. A railroad pioneer, General Palmer, built his home at Colorado
Springs, founded the town, and encouraged local improvements. Denver
owed its first impressive buildings to the civic patriotism of Horace
Tabor, a wealthy mine owner. Leland Stanford paid his tribute to
California in the endowment of a large university. Colonel W.F. Cody,
better known as "Buffalo Bill," started his career by building a "boom
town" which collapsed, and made a large sum of money supplying buffalo
meat to construction hands (hence his popular name). By his famous Wild
West Show, he increased it to a fortune which he devoted mainly to the
promotion of a western reclamation scheme.

While the Far West was developing this vigorous, aggressive leadership
in business, a considerable industrial population was springing up. Even
the cattle ranges and hundreds of farms were conducted like factories in
that they were managed through overseers who hired plowmen, harvesters,
and cattlemen at regular wages. At the same time there appeared other
peculiar features which made a lasting impression on western economic
life. Mining, lumbering, and fruit growing, for instance, employed
thousands of workers during the rush months and turned them out at other
times. The inevitable result was an army of migratory laborers wandering
from camp to camp, from town to town, and from ranch to ranch, without
fixed homes or established habits of life. From this extraordinary
condition there issued many a long and lawless conflict between capital
and labor, giving a distinct color to the labor movement in whole
sections of the mountain and coast states.


THE ADMISSION OF NEW STATES

=The Spirit of Self-Government.=--The instinct of self-government was
strong in the western communities. In the very beginning, it led to the
organization of volunteer committees, known as "vigilantes," to suppress
crime and punish criminals. As soon as enough people were settled
permanently in a region, they took care to form a more stable kind of
government. An illustration of this process is found in the Oregon
compact made by the pioneers in 1843, the spirit of which is reflected
in an editorial in an old copy of the _Rocky Mountain News_: "We claim
that any body or community of American citizens which from any cause or
under any circumstances is cut off from or from isolation is so situated
as not to be under any active and protecting branch of the central
government, have a right, if on American soil, to frame a government and
enact such laws and regulations as may be necessary for their own
safety, protection, and happiness, always with the condition precedent,
that they shall, at the earliest moment when the central government
shall extend an effective organization and laws over them, give it their
unqualified support and obedience."

People who turned so naturally to the organization of local
administration were equally eager for admission to the union as soon as
any shadow of a claim to statehood could be advanced. As long as a
region was merely one of the territories of the United States, the
appointment of the governor and other officers was controlled by
politics at Washington. Moreover the disposition of land, mineral
rights, forests, and water power was also in the hands of national
leaders. Thus practical considerations were united with the spirit of
independence in the quest for local autonomy.

=Nebraska and Colorado.=--Two states, Nebraska and Colorado, had little
difficulty in securing admission to the union. The first, Nebraska, had
been organized as a territory by the famous Kansas-Nebraska bill which
did so much to precipitate the Civil War. Lying to the north of Kansas,
which had been admitted in 1861, it escaped the invasion of slave owners
from Missouri and was settled mainly by farmers from the North. Though
it claimed a population of only 67,000, it was regarded with kindly
interest by the Republican Congress at Washington and, reduced to its
present boundaries, it received the coveted statehood in 1867.

This was hardly accomplished before the people of Colorado to the
southwest began to make known their demands. They had been organized
under territorial government in 1861 when they numbered only a handful;
but within ten years the aspect of their affairs had completely changed.
The silver and gold deposits of the Leadville and Cripple Creek regions
had attracted an army of miners and prospectors. The city of Denver,
founded in 1858 and named after the governor of Kansas whence came many
of the early settlers, had grown from a straggling camp of log huts into
a prosperous center of trade. By 1875 it was reckoned that the
population of the territory was not less than one hundred thousand; the
following year Congress, yielding to the popular appeal, made Colorado a
member of the American union.

=Six New States (1889-1890).=--For many years there was a deadlock in
Congress over the admission of new states. The spell was broken in 1889
under the leadership of the Dakotas. For a long time the Dakota
territory, organized in 1861, had been looked upon as the home of the
powerful Sioux Indians whose enormous reservation blocked the advance of
the frontier. The discovery of gold in the Black Hills, however, marked
their doom. Even before Congress could open their lands to prospectors,
pioneers were swarming over the country. Farmers from the adjoining
Minnesota and the Eastern states, Scandinavians, Germans, and Canadians,
came in swelling waves to occupy the fertile Dakota lands, now famous
even as far away as the fjords of Norway. Seldom had the plow of man cut
through richer soil than was found in the bottoms of the Red River
Valley, and it became all the more precious when the opening of the
Northern Pacific in 1883 afforded a means of transportation east and
west. The population, which had numbered 135,000 in 1880, passed the
half million mark before ten years had elapsed.

Remembering that Nebraska had been admitted with only 67,000
inhabitants, the Dakotans could not see why they should be kept under
federal tutelage. At the same time Washington, far away on the Pacific
Coast, Montana, Idaho, and Wyoming, boasting of their populations and
their riches, put in their own eloquent pleas. But the members of
Congress were busy with politics. The Democrats saw no good reason for
admitting new Republican states until after their defeat in 1888. Near
the end of their term the next year they opened the door for North and
South Dakota, Washington, and Montana. In 1890, a Republican Congress
brought Idaho and Wyoming into the union, the latter with woman
suffrage, which had been granted twenty-one years before.

=Utah.=--Although Utah had long presented all the elements of a
well-settled and industrious community, its admission to the union was
delayed on account of popular hostility to the practice of polygamy. The
custom, it is true, had been prohibited by act of Congress in 1862; but
the law had been systematically evaded. In 1882 Congress made another
and more effective effort to stamp out polygamy. Five years later it
even went so far as to authorize the confiscation of the property of the
Mormon Church in case the practice of plural marriages was not stopped.
Meanwhile the Gentile or non-Mormon population was steadily increasing
and the leaders in the Church became convinced that the battle
against the sentiment of the country was futile. At last in 1896 Utah
was admitted as a state under a constitution which forbade plural
marriages absolutely and forever. Horace Greeley, who visited Utah in
1859, had prophesied that the Pacific Railroad would work a revolution
in the land of Brigham Young. His prophecy had come true.

[Illustration: THE UNITED STATES IN 1912]

=Rounding out the Continent.=--Three more territories now remained out
of the Union. Oklahoma, long an Indian reservation, had been opened for
settlement to white men in 1889. The rush upon the fertile lands of this
region, the last in the history of America, was marked by all the frenzy
of the final, desperate chance. At a signal from a bugle an army of men
with families in wagons, men and women on horseback and on foot, burst
into the territory. During the first night a city of tents was raised at
Guthrie and Oklahoma City. In ten days wooden houses rose on the plains.
In a single year there were schools, churches, business blocks, and
newspapers. Within fifteen years there was a population of more than
half a million. To the west, Arizona with a population of about 125,000
and New Mexico with 200,000 inhabitants joined Oklahoma in asking for
statehood. Congress, then Republican, looked with reluctance upon the
addition of more Democratic states; but in 1907 it was literally
compelled by public sentiment and a sense of justice to admit Oklahoma.
In 1910 the House of Representatives went to the Democrats and within
two years Arizona and New Mexico were "under the roof." So the
continental domain was rounded out.


THE INFLUENCE OF THE FAR WEST ON NATIONAL LIFE

=The Last of the Frontier.=--When Horace Greeley made his trip west in
1859 he thus recorded the progress of civilization in his journal:

     "May 12th, Chicago.--Chocolate and morning journals last
     seen on the hotel breakfast table.

     23rd, Leavenworth (Kansas).--Room bells and bath tubs make
     their final appearance.

     26th, Manhattan.--Potatoes and eggs last recognized among
     the blessings that 'brighten as they take their flight.'

     27th, Junction City.--Last visitation of a boot-black, with
     dissolving views of a board bedroom. Beds bid us good-by."

[Illustration: _Copyright by Panama-California Exposition_

THE CANADIAN BUILDING AT THE PANAMA-CALIFORNIA INTERNATIONAL
EXPOSITION, SAN DIEGO, 1915]

Within thirty years travelers were riding across that country in Pullman
cars and enjoying at the hotels all the comforts of a standardized
civilization. The "wild west" was gone, and with it that frontier of
pioneers and settlers who had long given such a bent and tone to
American life and had "poured in upon the floor of Congress" such a long
line of "backwoods politicians," as they were scornfully styled.

=Free Land and Eastern Labor.=--It was not only the picturesque features
of the frontier that were gone. Of far more consequence was the
disappearance of free lands with all that meant for American labor. For
more than a hundred years, any man of even moderate means had been able
to secure a homestead of his own and an independent livelihood. For a
hundred years America had been able to supply farms to as many
immigrants as cared to till the soil. Every new pair of strong arms
meant more farms and more wealth. Workmen in Eastern factories, mines,
or mills who did not like their hours, wages, or conditions of labor,
could readily find an outlet to the land. Now all that was over. By
about 1890 most of the desirable land available under the Homestead act
had disappeared. American industrial workers confronted a new situation.

=Grain Supplants King Cotton.=--In the meantime a revolution was taking
place in agriculture. Until 1860 the chief staples sold by America were
cotton and tobacco. With the advance of the frontier, corn and wheat
supplanted them both in agrarian economy. The West became the granary of
the East and of Western Europe. The scoop shovel once used to handle
grain was superseded by the towering elevator, loading and unloading
thousands of bushels every hour. The refrigerator car and ship made the
packing industry as stable as the production of cotton or corn, and gave
an immense impetus to cattle raising and sheep farming. So the meat of
the West took its place on the English dinner table by the side of bread
baked from Dakotan wheat.

=Aid in American Economic Independence.=--The effects of this economic
movement were manifold and striking. Billions of dollars' worth of
American grain, dairy produce, and meat were poured into European
markets where they paid off debts due money lenders and acquired
capital to develop American resources. Thus they accelerated the
progress of American financiers toward national independence. The
country, which had timidly turned to the Old World for capital in
Hamilton's day and had borrowed at high rates of interest in London in
Lincoln's day, moved swiftly toward the time when it would be among the
world's first bankers and money lenders itself. Every grain of wheat and
corn pulled the balance down on the American side of the scale.

=Eastern Agriculture Affected.=--In the East as well as abroad the
opening of the western granary produced momentous results. The
agricultural economy of that part of the country was changed in many
respects. Whole sections of the poorest land went almost out of
cultivation, the abandoned farms of the New England hills bearing solemn
witness to the competing power of western wheat fields. Sheep and cattle
raising, as well as wheat and corn production, suffered at least a
relative decline. Thousands of farmers cultivating land of the lower
grade were forced to go West or were driven to the margin of
subsistence. Even the herds that supplied Eastern cities with milk were
fed upon grain brought halfway across the continent.

=The Expansion of the American Market.=--Upon industry as well as
agriculture, the opening of vast food-producing regions told in a
thousand ways. The demand for farm machinery, clothing, boots, shoes,
and other manufactures gave to American industries such a market as even
Hamilton had never foreseen. Moreover it helped to expand far into the
Mississippi Valley the industrial area once confined to the Northern
seaboard states and to transform the region of the Great Lakes into an
industrial empire. Herein lies the explanation of the growth of
mid-western cities after 1865. Chicago, with its thirty-five railways,
tapped every locality of the West and South. To the railways were added
the water routes of the Lakes, thus creating a strategic center for
industries. Long foresight carried the McCormick reaper works to
Chicago before 1860. From Troy, New York, went a large stove plant. That
was followed by a shoe factory from Massachusetts. The packing industry
rose as a matter of course at a point so advantageous for cattle raisers
and shippers and so well connected with Eastern markets.

To the opening of the Far West also the Lake region was indebted for a
large part of that water-borne traffic which made it "the Mediterranean
basin of North America." The produce of the West and the manufactures of
the East poured through it in an endless stream. The swift growth of
shipbuilding on the Great Lakes helped to compensate for the decline of
the American marine on the high seas. In response to this stimulus
Detroit could boast that her shipwrights were able to turn out a ten
thousand ton Leviathan for ore or grain about "as quickly as carpenters
could put up an eight-room house." Thus in relation to the Far West the
old Northwest territory--the wilderness of Jefferson's time--had taken
the position formerly occupied by New England alone. It was supplying
capital and manufactures for a vast agricultural empire West and South.

=America on the Pacific.=--It has been said that the Mediterranean Sea
was the center of ancient civilization; that modern civilization has
developed on the shores of the Atlantic; and that the future belongs to
the Pacific. At any rate, the sweep of the United States to the shores
of the Pacific quickly exercised a powerful influence on world affairs
and it undoubtedly has a still greater significance for the future.

Very early regular traffic sprang up between the Pacific ports and the
Hawaiian Islands, China, and Japan. Two years before the adjustment of
the Oregon controversy with England, namely in 1844, the United States
had established official and trading relations with China. Ten years
later, four years after the admission of California to the union, the
barred door of Japan was forced open by Commodore Perry. The commerce
which had long before developed between the Pacific ports and Hawaii,
China, and Japan now flourished under official care. In 1865 a ship
from Honolulu carried sugar, molasses, and fruits from Hawaii to the
Oregon port of Astoria. The next year a vessel from Hongkong brought
rice, mats, and tea from China. An era of lucrative trade was opened.
The annexation of Hawaii in 1898, the addition of the Philippines at the
same time, and the participation of American troops in the suppression
of the Boxer rebellion in Peking in 1900, were but signs and symbols of
American power on the Pacific.

[Illustration: _From an old print_

COMMODORE PERRY'S MEN MAKING PRESENTS TO THE JAPANESE]

=Conservation and the Land Problem.=--The disappearance of the frontier
also brought new and serious problems to the governments of the states
and the nation. The people of the whole United States suddenly were
forced to realize that there was a limit to the rich, new land to
exploit and to the forests and minerals awaiting the ax and the pick.
Then arose in America the questions which had long perplexed the
countries of the Old World--the scientific use of the soils and
conservation of natural resources. Hitherto the government had followed
the easy path of giving away arable land and selling forest and mineral
lands at low prices. Now it had to face far more difficult and complex
problems. It also had to consider questions of land tenure again,
especially if the ideal of a nation of home-owning farmers was to be
maintained. While there was plenty of land for every man or woman who
wanted a home on the soil, it made little difference if single landlords
or companies got possession of millions of acres, if a hundred men in
one western river valley owned 17,000,000 acres; but when the good land
for small homesteads was all gone, then was raised the real issue. At
the opening of the twentieth century the nation, which a hundred years
before had land and natural resources apparently without limit, was
compelled to enact law after law conserving its forests and minerals.
Then it was that the great state of California, on the very border of
the continent, felt constrained to enact a land settlement measure
providing government assistance in an effort to break up large holdings
into small lots and to make it easy for actual settlers to acquire small
farms. America was passing into a new epoch.


=References=

Henry Inman, _The Old Santa Fe Trail_.

R.I. Dodge, _The Plains of the Great West_ (1877).

C.H. Shinn, _The Story of the Mine_.

Cy Warman, _The Story of the Railroad_.

Emerson Hough, _The Story of the Cowboy_.

H.H. Bancroft is the author of many works on the West but his writings
will be found only in the larger libraries.

Joseph Schafer, _History of the Pacific Northwest_ (ed. 1918).

T.H. Hittel, _History of California_ (4 vols.).

W.H. Olin, _American Irrigation Farming_.

W.E. Smythe, _The Conquest of Arid America_.

H.A. Millis, _The American-Japanese Problem_.

E.S. Meany, _History of the State of Washington_.

H.K. Norton, _The Story of California_.


=Questions=

1. Name the states west of the Mississippi in 1865.

2. In what manner was the rest of the western region governed?

3. How far had settlement been carried?

4. What were the striking physical features of the West?

5. How was settlement promoted after 1865?

6. Why was admission to the union so eagerly sought?

7. Explain how politics became involved in the creation of new states.

8. Did the West rapidly become like the older sections of the country?

9. What economic peculiarities did it retain or develop?

10. How did the federal government aid in western agriculture?

11. How did the development of the West affect the East? The South?

12. What relation did the opening of the great grain areas of the West
bear to the growth of America's commercial and financial power?

13. State some of the new problems of the West.

14. Discuss the significance of American expansion to the Pacific Ocean.


=Research Topics=

=The Passing of the Wild West.=--Haworth, _The United States in Our Own
Times_, pp. 100-124.

=The Indian Question.=--Sparks, _National Development_ (American Nation
Series), pp. 265-281.

=The Chinese Question.=--Sparks, _National Development_, pp. 229-250;
Rhodes, _History of the United States_, Vol. VIII, pp. 180-196.

=The Railway Age.=--Schafer, _History of the Pacific Northwest_, pp.
230-245; E.V. Smalley, _The Northern Pacific Railroad_; Paxson, _The New
Nation_ (Riverside Series), pp. 20-26, especially the map on p. 23, and
pp. 142-148.

=Agriculture and Business.=--Schafer, _Pacific Northwest_, pp. 246-289.

=Ranching in the Northwest.=--Theodore Roosevelt, _Ranch Life_, and
_Autobiography_, pp. 103-143.

=The Conquest of the Desert.=--W.E. Smythe, _The Conquest of Arid
America_.

=Studies of Individual Western States.=--Consult any good encyclopedia.




CHAPTER XIX

DOMESTIC ISSUES BEFORE THE COUNTRY (1865-1897)


For thirty years after the Civil War the leading political parties,
although they engaged in heated presidential campaigns, were not sharply
and clearly opposed on many matters of vital significance. During none
of that time was there a clash of opinion over specific issues such as
rent the country in 1800 when Jefferson rode a popular wave to victory,
or again in 1828 when Jackson's western hordes came sweeping into power.
The Democrats, who before 1860 definitely opposed protective tariffs,
federal banking, internal improvements, and heavy taxes, now spoke
cautiously on all these points. The Republicans, conscious of the fact
that they had been a minority of the voters in 1860 and warned by the
early loss of the House of Representatives in 1874, also moved with
considerable prudence among the perplexing problems of the day. Again
and again the votes in Congress showed that no clear line separated all
the Democrats from all the Republicans. There were Republicans who
favored tariff reductions and "cheap money." There were Democrats who
looked with partiality upon high protection or with indulgence upon the
contraction of the currency. Only on matters relating to the coercion of
the South was the division between the parties fairly definite; this
could be readily accounted for on practical as well as sentimental
grounds.

After all, the vague criticisms and proposals that found their way into
the political platforms did but reflect the confusion of mind prevailing
in the country. The fact that, out of the eighteen years between 1875
and 1893, the Democrats held the House of Representatives for fourteen
years while the Republicans had every President but one showed that the
voters, like the politicians, were in a state of indecision. Hayes had a
Democratic House during his entire term and a Democratic Senate for two
years of the four. Cleveland was confronted by a belligerent Republican
majority in the Senate during his first administration; and at the same
time was supported by a Democratic majority in the House. Harrison was
sustained by continuous Republican successes in Senatorial elections;
but in the House he had the barest majority from 1889 to 1891 and lost
that altogether at the election held in the middle of his term. The
opinion of the country was evidently unsettled and fluctuating. It was
still distracted by memories of the dead past and uncertain as to the
trend of the future.


THE CURRENCY QUESTION

Nevertheless these years of muddled politics and nebulous issues proved
to be a period in which social forces were gathering for the great
campaign of 1896. Except for three new features--the railways, the
trusts, and the trade unions--the subjects of debate among the people
were the same as those that had engaged their attention since the
foundation of the republic: the currency, the national debt, banking,
the tariff, and taxation.

=Debtors and the Fall in Prices.=--For many reasons the currency
question occupied the center of interest. As of old, the farmers and
planters of the West and South were heavily in debt to the East for
borrowed money secured by farm mortgages; and they counted upon the sale
of cotton, corn, wheat, and hogs to meet interest and principal when
due. During the war, the Western farmers had been able to dispose of
their produce at high prices and thus discharge their debts with
comparative ease; but after the war prices declined. Wheat that sold at
two dollars a bushel in 1865 brought sixty-four cents twenty years
later. The meaning of this for the farmers in debt--and nearly
three-fourths of them were in that class--can be shown by a single
illustration. A thousand-dollar mortgage on a Western farm could be paid
off by five hundred bushels of wheat when prices were high; whereas it
took about fifteen hundred bushels to pay the same debt when wheat was
at the bottom of the scale. For the farmer, it must be remembered, wheat
was the measure of his labor, the product of his toil under the summer
sun; and in its price he found the test of his prosperity.

=Creditors and Falling Prices.=--To the bondholders or creditors, on the
other hand, falling prices were clear gain. If a fifty-dollar coupon on
a bond bought seventy or eighty bushels of wheat instead of twenty or
thirty, the advantage to the owner of the coupon was obvious. Moreover
the advantage seemed to him entirely just. Creditors had suffered heavy
losses when the Civil War carried prices skyward while the interest
rates on their old bonds remained stationary. For example, if a man had
a $1000 bond issued before 1860 and paying interest at five per cent, he
received fifty dollars a year from it. Before the war each dollar would
buy a bushel of wheat; in 1865 it would only buy half a bushel. When
prices--that is, the cost of living--began to go down, creditors
therefore generally regarded the change with satisfaction as a return to
normal conditions.

=The Cause of Falling Prices.=--The fall in prices was due, no doubt, to
many factors. Among them must be reckoned the discontinuance of
government buying for war purposes, labor-saving farm machinery,
immigration, and the opening of new wheat-growing regions. The currency,
too, was an element in the situation. Whatever the cause, the
discontented farmers believed that the way to raise prices was to issue
more money. They viewed it as a case of supply and demand. If there was
a small volume of currency in circulation, prices would be low; if there
was a large volume, prices would be high. Hence they looked with favor
upon all plans to increase the amount of money in circulation. First
they advocated more paper notes--greenbacks--and then they turned to
silver as the remedy. The creditors, on the other hand, naturally
approved the reduction of the volume of currency. They wished to see the
greenbacks withdrawn from circulation and gold--a metal more limited in
volume than silver--made the sole basis of the national monetary system.

=The Battle over the Greenbacks.=--The contest between these factions
began as early as 1866. In that year, Congress enacted a law authorizing
the Treasury to withdraw the greenbacks from circulation. The paper
money party set up a shrill cry of protest, and kept up the fight until,
in 1878, it forced Congress to provide for the continuous re-issue of
the legal tender notes as they came into the Treasury in payment of
taxes and other dues. Then could the friends of easy money rejoice:

    "Thou, Greenback, 'tis of thee
     Fair money of the free,
      Of thee we sing."

=Resumption of Specie Payment.=--There was, however, another side to
this victory. The opponents of the greenbacks, unable to stop the
circulation of paper, induced Congress to pass a law in 1875 providing
that on and after January 1, 1879, "the Secretary of the Treasury shall
redeem in coin the United States legal tender notes then outstanding on
their presentation at the office of the Assistant Treasurer of the
United States in the City of New York in sums of not less than fifty
dollars." "The way to resume," John Sherman had said, "is to resume."
When the hour for redemption arrived, the Treasury was prepared with a
large hoard of gold. "On the appointed day," wrote the assistant
secretary, "anxiety reigned in the office of the Treasury. Hour after
hour passed; no news from New York. Inquiry by wire showed that all was
quiet. At the close of the day this message came: '$135,000 of notes
presented for coin--$400,000 of gold for notes.' That was all.
Resumption was accomplished with no disturbance. By five o'clock the
news was all over the land, and the New York bankers were sipping their
tea in absolute safety."

=The Specie Problem--the Parity of Gold and Silver.=--Defeated in their
efforts to stop "the present suicidal and destructive policy of
contraction," the advocates of an abundant currency demanded an increase
in the volume of silver in circulation. This precipitated one of the
sharpest political battles in American history. The issue turned on
legal as well as economic points. The Constitution gave Congress the
power to coin money and it forbade the states to make anything but gold
and silver legal tender in the payment of debts. It evidently
contemplated the use of both metals in the currency system. Such, at
least, was the view of many eminent statesmen, including no less a
personage than James G. Blaine. The difficulty, however, lay in
maintaining gold and silver coins on a level which would permit them to
circulate with equal facility. Obviously, if the gold in a gold dollar
exceeds the value of the silver in a silver dollar on the open market,
men will hoard gold money and leave silver money in circulation. When,
for example, Congress in 1792 fixed the ratio of the two metals at one
to fifteen--one ounce of gold declared worth fifteen of silver--it was
soon found that gold had been undervalued. When again in 1834 the ratio
was put at one to sixteen, it was found that silver was undervalued.
Consequently the latter metal was not brought in for coinage and silver
almost dropped out of circulation. Many a silver dollar was melted down
by silverware factories.

=Silver Demonetized in 1873.=--So things stood in 1873. At that time,
Congress, in enacting a mintage law, discontinued the coinage of the
standard silver dollar, then practically out of circulation. This act
was denounced later by the friends of silver as "the crime of '73," a
conspiracy devised by the money power and secretly carried out. This
contention the debates in Congress do not seem to sustain. In the course
of the argument on the mint law it was distinctly said by one speaker at
least: "This bill provides for the making of changes in the legal tender
coin of the country and for substituting as legal tender, coin of only
one metal instead of two as heretofore."

=The Decline in the Value of Silver.=--Absorbed in the greenback
controversy, the people apparently did not appreciate, at the time, the
significance of the "demonetization" of silver; but within a few years
several events united in making it the center of a political storm.
Germany, having abandoned silver in 1871, steadily increased her demand
for gold. Three years later, the countries of the Latin Union followed
this example, thus helping to enhance the price of the yellow metal. All
the while, new silver lodes, discovered in the Far West, were pouring
into the market great streams of the white metal, bearing down the
price. Then came the resumption of specie payment, which, in effect,
placed the paper money on a gold basis. Within twenty years silver was
worth in gold only about half the price of 1870.

That there had been a real decline in silver was denied by the friends
of that metal. They alleged that gold had gone up because it had been
given a monopoly in the coinage markets of civilized governments. This
monopoly, they continued, was the fruit of a conspiracy against the
people conceived by the bankers of the world. Moreover, they went on,
the placing of the greenbacks on a gold basis had itself worked a
contraction of the currency; it lowered the prices of labor and produce
to the advantage of the holders of long-term investments bearing a fixed
rate of interest. When wheat sold at sixty-four cents a bushel, their
search for relief became desperate, and they at last concentrated their
efforts on opening the mints of the government for the free coinage of
silver at the ratio of sixteen to one.

=Republicans and Democrats Divided.=--On this question both Republicans
and Democrats were divided, the line being drawn between the East on the
one hand and the South and West on the other, rather than between the
two leading parties. So trusted a leader as James G. Blaine avowed, in a
speech delivered in the Senate in 1878, that, as the Constitution
required Congress to make both gold and silver the money of the land,
the only question left was that of fixing the ratio between them. He
affirmed, moreover, the main contention of the silver faction that a
reopening of the government mints of the world to silver would bring it
up to its old relation with gold. He admitted also that their most
ominous warnings were well founded, saying: "I believe the struggle now
going on in this country and in other countries for a single gold
standard would, if successful, produce widespread disaster throughout
the commercial world. The destruction of silver as money and the
establishment of gold as the sole unit of value must have a ruinous
effect on all forms of property, except those investments which yield a
fixed return."

This was exactly the concession that the silver party wanted.
"Three-fourths of the business enterprises of this country are conducted
on borrowed capital," said Senator Jones, of Nevada. "Three-fourths of
the homes and farms that stand in the names of the actual occupants have
been bought on time and a very large proportion of them are mortgaged
for the payment of some part of the purchase money. Under the operation
of a shrinkage in the volume of money, this enormous mass of borrowers,
at the maturity of their respective debts, though nominally paying no
more than the amount borrowed, with interest, are in reality, in the
amount of the principal alone, returning a percentage of value greater
than they received--more in equity than they contracted to pay.... In
all discussions of the subject the creditors attempt to brush aside the
equities involved by sneering at the debtors."

=The Silver Purchase Act (1878).=--Even before the actual resumption of
specie payment, the advocates of free silver were a power to be reckoned
with, particularly in the Democratic party. They had a majority in the
House of Representatives in 1878 and they carried a silver bill through
that chamber. Blocked by the Republican Senate they accepted a
compromise in the Bland-Allison bill, which provided for huge monthly
purchases of silver by the government for coinage into dollars. So
strong was the sentiment that a two-thirds majority was mustered after
President Hayes vetoed the measure.

The effect of this act, as some had anticipated, was disappointing. It
did not stay silver on its downward course. Thereupon the silver faction
pressed through Congress in 1886 a bill providing for the issue of paper
certificates based on the silver accumulated in the Treasury. Still
silver continued to fall. Then the advocates of inflation declared that
they would be content with nothing short of free coinage at the ratio of
sixteen to one. If the issue had been squarely presented in 1890, there
is good reason for believing that free silver would have received a
majority in both houses of Congress; but it was not presented.

=The Sherman Silver Purchase Act and the Bond Sales.=--Republican
leaders, particularly from the East, stemmed the silver tide by a
diversion of forces. They passed the Sherman Act of 1890 providing for
large monthly purchases of silver and for the issue of notes redeemable
in gold or silver at the discretion of the Secretary of the Treasury. In
a clause of superb ambiguity they announced that it was "the established
policy of the United States to maintain the two metals on a parity with
each other upon the present legal ratio or such other ratio as may be
provided by law." For a while silver was buoyed up. Then it turned once
more on its downward course. In the meantime the Treasury was in a sad
plight. To maintain the gold reserve, President Cleveland felt compelled
to sell government bonds; and to his dismay he found that as soon as the
gold was brought in at the front door of the Treasury, notes were
presented for redemption and the gold was quickly carried out at the
back door. Alarmed at the vicious circle thus created, he urged upon
Congress the repeal of the Sherman Silver Purchase Act. For this he was
roundly condemned by many of his own followers who branded his conduct
as "treason to the party"; but the Republicans, especially from the
East, came to his rescue and in 1893 swept the troublesome sections of
the law from the statute book. The anger of the silver faction knew no
bounds, and the leaders made ready for the approaching presidential
campaign.


THE PROTECTIVE TARIFF AND TAXATION

=Fluctuation in Tariff Policy.=--As each of the old parties was divided
on the currency question, it is not surprising that there was some
confusion in their ranks over the tariff. Like the silver issue, the
tariff tended to align the manufacturing East against the agricultural
West and South rather than to cut directly between the two parties.
Still the Republicans on the whole stood firmly by the rates imposed
during the Civil War. If we except the reductions of 1872 which were
soon offset by increases, we may say that those rates were substantially
unchanged for nearly twenty years. When a revision was brought about,
however, it was initiated by Republican leaders. Seeing a huge surplus
of revenue in the Treasury in 1883, they anticipated popular clamor by
revising the tariff on the theory that it ought to be reformed by its
friends rather than by its enemies. On the other hand, it was the
Republicans also who enacted the McKinley tariff bill of 1890, which
carried protection to its highest point up to that time.

The Democrats on their part were not all confirmed free traders or even
advocates of tariff for revenue only. In Cleveland's first
administration they did attack the protective system in the House, where
they had a majority, and in this they were vigorously supported by the
President. The assault, however, proved to be a futile gesture for it
was blocked by the Republicans in the Senate. When, after the sweeping
victory of 1892, the Democrats in the House again attempted to bring
down the tariff by the Wilson bill of 1894, they were checkmated by
their own party colleagues in the upper chamber. In the end they were
driven into a compromise that looked more like a McKinley than a Calhoun
tariff. The Republicans taunted them with being "babes in the woods."
President Cleveland was so dissatisfied with the bill that he refused to
sign it, allowing it to become a law, on the lapse of ten days, without
his approval.

=The Income Tax of 1894.=--The advocates of tariff reduction usually
associated with their proposal a tax on incomes. The argument which
they advanced in support of their program was simple. Most of the
industries, they said, are in the East and the protective tariff which
taxes consumers for the benefit of manufacturers is, in effect, a
tribute laid upon the rest of the country. As an offset they offered a
tax on large incomes; this owing to the heavy concentration of rich
people in the East, would fall mainly upon the beneficiaries of
protection. "We propose," said one of them, "to place a part of the
burden upon the accumulated wealth of the country instead of placing it
all upon the consumption of the people." In this spirit the sponsors of
the Wilson tariff bill laid a tax upon all incomes of $4000 a year or
more.

In taking this step, the Democrats encountered opposition in their own
party. Senator Hill, of New York, turned fiercely upon them, exclaiming:
"The professors with their books, the socialists with their schemes, the
anarchists with their bombs are all instructing the people in the ...
principles of taxation." Even the Eastern Republicans were hardly as
savage in their denunciation of the tax. But all this labor was wasted.
The next year the Supreme Court of the United States declared the income
tax to be a direct tax, and therefore null and void because it was laid
on incomes wherever found and not apportioned among the states according
to population. The fact that four of the nine judges dissented from this
decision was also an index to the diversity of opinion that divided both
parties.


THE RAILWAYS AND TRUSTS

=The Grangers and State Regulation.=--The same uncertainty about the
railways and trusts pervaded the ranks of the Republicans and Democrats.
As to the railways, the first firm and consistent demand for their
regulation came from the West. There the farmers, in the early
seventies, having got control in state legislatures, particularly in
Iowa, Wisconsin, and Illinois, enacted drastic laws prescribing the
maximum charges which companies could make for carrying freight and
passengers. The application of these measures, however, was limited
because the state could not fix the rates for transporting goods and
passengers beyond its own borders. The power of regulating interstate
commerce, under the Constitution, belonged to Congress.

=The Interstate Commerce Act of 1887.=--Within a few years, the movement
which had been so effective in western legislatures appeared at
Washington in the form of demands for the federal regulation of
interstate rates. In 1887, the pressure became so strong that Congress
created the interstate commerce commission and forbade many abuses on
the part of railways; such as discriminating in charges between one
shipper and another and granting secret rebates to favored persons. This
law was a significant beginning; but it left the main question of
rate-fixing untouched, much to the discontent of farmers and shippers.

=The Sherman Anti-Trust Law of 1890.=--As in the case of the railways,
attacks upon the trusts were first made in state legislatures, where it
became the fashion to provide severe penalties for those who formed
monopolies and "conspired to enhance prices." Republicans and Democrats
united in the promotion of measures of this kind. As in the case of the
railways also, the movement to curb the trusts soon had spokesmen at
Washington. Though Blaine had declared that "trusts were largely a
private affair with which neither the President nor any private citizen
had any particular right to interfere," it was a Republican Congress
that enacted in 1890 the first measure--the Sherman Anti-Trust
Law--directed against great combinations in business. This act declared
illegal "every contract, combination in the form of trust or otherwise,
or conspiracy in restraint of trade and commerce among the several
states or with foreign nations."

=The Futility of the Anti-Trust Law.=--Whether the Sherman law was
directed against all combinations or merely those which placed an
"unreasonable restraint" on trade and competition was not apparent.
Senator Platt of Connecticut, a careful statesman of the old school,
averred: "The questions of whether the bill would be operative, of how
it would operate, or whether it was within the power of Congress to
enact it, have been whistled down the wind in this Senate as idle talk
and the whole effort has been to get some bill headed: 'A bill to punish
trusts,' with which to go to the country." Whatever its purpose, its
effect upon existing trusts and upon the formation of new combinations
was negligible. It was practically unenforced by President Harrison and
President Cleveland, in spite of the constant demand for harsh action
against "monopolies." It was patent that neither the Republicans nor the
Democrats were prepared for a war on the trusts to the bitter end.


THE MINOR PARTIES AND UNREST

=The Demands of Dissenting Parties.=--From the election of 1872, when
Horace Greeley made his ill-fated excursion into politics, onward, there
appeared in each presidential campaign one, and sometimes two or more
parties, stressing issues that appealed mainly to wage-earners and
farmers. Whether they chose to call themselves Labor Reformers,
Greenbackers, or Anti-monopolists, their slogans and their platforms all
pointed in one direction. Even the Prohibitionists, who in 1872 started
on their career with a single issue, the abolition of the liquor
traffic, found themselves making declarations of faith on other matters
and hopelessly split over the money question in 1896.

A composite view of the platforms put forth by the dissenting parties
from the administration of Grant to the close of Cleveland's second term
reveals certain notions common to them all. These included among many
others: the earliest possible payment of the national debt; regulation
of the rates of railways and telegraph companies; repeal of the specie
resumption act of 1875; the issue of legal tender notes by the
government convertible into interest-bearing obligations on demand;
unlimited coinage of silver as well as gold; a graduated inheritance
tax; legislation to take from "land, railroad, money, and other gigantic
corporate monopolies ... the powers they have so corruptly and unjustly
usurped"; popular or direct election of United States Senators; woman
suffrage; and a graduated income tax, "placing the burden of government
on those who can best afford to pay instead of laying it on the farmers
and producers."

=Criticism of the Old Parties.=--To this long program of measures the
reformers added harsh and acrid criticism of the old parties and
sometimes, it must be said, of established institutions of government.
"We denounce," exclaimed the Labor party in 1888, "the Democratic and
Republican parties as hopelessly and shamelessly corrupt and by reason
of their affiliation with monopolies equally unworthy of the suffrages
of those who do not live upon public plunder." "The United States
Senate," insisted the Greenbackers, "is a body composed largely of
aristocratic millionaires who according to their own party papers
generally purchased their elections in order to protect the great
monopolies which they represent." Indeed, if their platforms are to be
accepted at face value, the Greenbackers believed that the entire
government had passed out of the hands of the people.

=The Grangers.=--This unsparing, not to say revolutionary, criticism of
American political life, appealed, it seems, mainly to farmers in the
Middle West. Always active in politics, they had, before the Civil War,
cast their lot as a rule with one or the other of the leading parties.
In 1867, however, there grew up among them an association known as the
"Patrons of Husbandry," which was destined to play a large role in the
partisan contests of the succeeding decades. This society, which
organized local lodges or "granges" on principles of secrecy and
fraternity, was originally designed to promote in a general way the
interests of the farmers. Its political bearings were apparently not
grasped at first by its promoters. Yet, appealing as it did to the most
active and independent spirits among the farmers and gathering to itself
the strength that always comes from organization, it soon found itself
in the hands of leaders more or less involved in politics. Where a few
votes are marshaled together in a democracy, there is power.

=The Greenback Party.=--The first extensive activity of the Grangers was
connected with the attack on the railways in the Middle West which
forced several state legislatures to reduce freight and passenger rates
by law. At the same time, some leaders in the movement, no doubt
emboldened by this success, launched in 1876 a new political party,
popularly known as the Greenbackers, favoring a continued re-issue of
the legal tenders. The beginnings were disappointing; but two years
later, in the congressional elections, the Greenbackers swept whole
sections of the country. Their candidates polled more than a million
votes and fourteen of them were returned to the House of
Representatives. To all outward signs a new and formidable party had
entered the lists.

The sanguine hopes of the leaders proved to be illusory. The quiet
operations of the resumption act the following year, a revival of
industry from a severe panic which had set in during 1873, the Silver
Purchase Act, and the re-issue of Greenbacks cut away some of the
grounds of agitation. There was also a diversion of forces to the silver
faction which had a substantial support in the silver mine owners of the
West. At all events the Greenback vote fell to about 300,000 in the
election of 1880. A still greater drop came four years later and the
party gave up the ghost, its sponsors returning to their former
allegiance or sulking in their tents.

=The Rise of the Populist Party.=--Those leaders of the old parties who
now looked for a happy future unvexed by new factions were doomed to
disappointment. The funeral of the Greenback party was hardly over
before there arose two other political specters in the agrarian
sections: the National Farmers' Alliance and Industrial Union,
particularly strong in the South and West; and the Farmers' Alliance,
operating in the North. By 1890 the two orders claimed over three
million members. As in the case of the Grangers many years before, the
leaders among them found an easy way into politics. In 1892 they held a
convention, nominated a candidate for President, and adopted the name of
"People's Party," from which they were known as Populists. Their
platform, in every line, breathed a spirit of radicalism. They declared
that "the newspapers are largely subsidized or muzzled; public opinion
silenced; business prostrate; our homes covered with mortgages; and the
land concentrating in the hands of capitalists.... The fruits of the
toil of millions are boldly stolen to build up colossal fortunes for a
few." Having delivered this sweeping indictment, the Populists put
forward their remedies: the free coinage of silver, a graduated income
tax, postal savings banks, and government ownership of railways and
telegraphs. At the same time they approved the initiative, referendum,
and popular election of Senators, and condemned the use of federal
troops in labor disputes. On this platform, the Populists polled over a
million votes, captured twenty-two presidential electors, and sent a
powerful delegation to Congress.

=Industrial Distress Augments Unrest.=--The four years intervening
between the campaign of 1892 and the next presidential election brought
forth many events which aggravated the ill-feeling expressed in the
portentous platform of Populism. Cleveland, a consistent enemy of free
silver, gave his powerful support to the gold standard and insisted on
the repeal of the Silver Purchase Act, thus alienating an increasing
number of his own party. In 1893 a grave industrial crisis fell upon the
land: banks and business houses went into bankruptcy with startling
rapidity; factories were closed; idle men thronged the streets hunting
for work; and the prices of wheat and corn dropped to a ruinous level.
Labor disputes also filled the crowded record. A strike at the Pullman
car works in Chicago spread to the railways. Disorders ensued. President
Cleveland, against the protests of the governor of Illinois, John P.
Altgeld, dispatched troops to the scene of action. The United States
district court at Chicago issued an injunction forbidding the president
of the Railway Union, Eugene V. Debs, or his assistants to interfere
with the transmission of the mails or interstate commerce in any form.
For refusing to obey the order, Debs was arrested and imprisoned. With
federal troops in possession of the field, with their leader in jail,
the strikers gave up the battle, defeated but not subdued. To cap the
climax the Supreme Court of the United States, the following year (1895)
declared null and void the income tax law just enacted by Congress, thus
fanning the flames of Populist discontent all over the West and South.


THE SOUND MONEY BATTLE OF 1896

=Conservative Men Alarmed.=--Men of conservative thought and leaning in
both parties were by this time thoroughly disturbed. They looked upon
the rise of Populism and the growth of labor disputes as the signs of a
revolutionary spirit, indeed nothing short of a menace to American
institutions and ideals. The income tax law of 1894, exclaimed the
distinguished New York advocate, Joseph H. Choate, in an impassioned
speech before the Supreme Court, "is communistic in its purposes and
tendencies and is defended here upon principles as communistic,
socialistic--what shall I call them--populistic as ever have been
addressed to any political assembly in the world." Mr. Justice Field in
the name of the Court replied: "The present assault upon capital is but
the beginning. It will be but the stepping stone to others larger and
more sweeping till our political conditions will become a war of the
poor against the rich." In declaring the income tax unconstitutional, he
believed that he was but averting greater evils lurking under its guise.
As for free silver, nearly all conservative men were united in calling
it a measure of confiscation and repudiation; an effort of the debtors
to pay their obligations with money worth fifty cents on the dollar; the
climax of villainies openly defended; a challenge to law, order, and
honor.

=The Republicans Come Out for the Gold Standard.=--It was among the
Republicans that this opinion was most widely shared and firmly held. It
was they who picked up the gauge thrown down by the Populists, though a
host of Democrats, like Cleveland and Hill of New York, also battled
against the growing Populist defection in Democratic ranks. When the
Republican national convention assembled in 1896, the die was soon
cast; a declaration of opposition to free silver save by international
agreement was carried by a vote of eight to one. The Republican party,
to use the vigorous language of Mr. Lodge, arrayed itself against "not
only that organized failure, the Democratic party, but all the wandering
forces of political chaos and social disorder ... in these bitter times
when the forces of disorder are loose and the wreckers with their false
lights gather at the shore to lure the ship of state upon the rocks."
Yet it is due to historic truth to state that McKinley, whom the
Republicans nominated, had voted in Congress for the free coinage of
silver, was widely known as a bimetallist, and was only with difficulty
persuaded to accept the unequivocal indorsement of the gold standard
which was pressed upon him by his counselors. Having accepted it,
however, he proved to be a valiant champion, though his major interest
was undoubtedly in the protective tariff. To him nothing was more
reprehensible than attempts "to array class against class, 'the classes
against the masses,' section against section, labor against capital,
'the poor against the rich,' or interest against interest." Such was the
language of his acceptance speech. The whole program of Populism he now
viewed as a "sudden, dangerous, and revolutionary assault upon law and
order."

=The Democratic Convention at Chicago.=--Never, save at the great
disruption on the eve of the Civil War, did a Democratic national
convention display more feeling than at Chicago in 1896. From the
opening prayer to the last motion before the house, every act, every
speech, every scene, every resolution evoked passions and sowed
dissensions. Departing from long party custom, it voted down in anger a
proposal to praise the administration of the Democratic President,
Cleveland. When the platform with its radical planks, including free
silver, was reported, a veritable storm broke. Senator Hill, trembling
with emotion, protested against the departure from old tests of
Democratic allegiance; against principles that must drive out of the
party men who had grown gray in its service; against revolutionary,
unwise, and unprecedented steps in the history of the party. Senator
Vilas of Wisconsin, in great fervor, avowed that there was no difference
in principle between the free coinage of silver--"the confiscation of
one-half of the credits of the nation for the benefit of debtors"--and
communism itself--"a universal distribution of property." In the triumph
of that cause he saw the beginning of "the overthrow of all law, all
justice, all security and repose in the social order."

[Illustration: _Copyright by Underwood and Underwood, N.Y._

WILLIAM J. BRYAN IN 1898]

=The Crown of Thorns Speech.=--The champions of free silver replied in
strident tones. They accused the gold advocates of being the aggressors
who had assailed the labor and the homes of the people. William Jennings
Bryan, of Nebraska, voiced their sentiments in a memorable oration. He
declared that their cause "was as holy as the cause of liberty--the
cause of humanity." He exclaimed that the contest was between the idle
holders of idle capital and the toiling millions. Then he named those
for whom he spoke--the wage-earner, the country lawyer, the small
merchant, the farmer, and the miner. "The man who is employed for wages
is as much a business man as his employer. The attorney in a country
town is as much a business man as the corporation counsel in a great
metropolis. The merchant at the cross roads store is as much a business
man as the merchant of New York. The farmer ... is as much a business
man as the man who goes upon the board of trade and bets upon the price
of grain. The miners who go a thousand feet into the earth or climb two
thousand feet upon the cliffs ... are as much business men as the few
financial magnates who in a back room corner the money of the world....
It is for these that we speak. We do not come as aggressors. Ours is not
a war of conquest. We are fighting in defense of our homes, our
families, and our posterity. We have petitioned and our petitions have
been scorned. We have entreated and our entreaties have been
disregarded. We have begged and they have mocked when our calamity came.
We beg no longer; we entreat no more; we petition no more. We defy
them.... We shall answer their demands for a gold standard by saying to
them, 'You shall not press upon the brow of labor this crown of thorns.
You shall not crucify mankind upon a cross of gold.'"

=Bryan Nominated.=--In all the history of national conventions never had
an orator so completely swayed a multitude; not even Yancey in his
memorable plea in the Charleston convention of 1860 when, with grave and
moving eloquence, he espoused the Southern cause against the impending
fates. The delegates, after cheering Mr. Bryan until they could cheer no
more, tore the standards from the floor and gathered around the Nebraska
delegation to renew the deafening applause. The platform as reported was
carried by a vote of two to one and the young orator from the West,
hailed as America's Tiberius Gracchus, was nominated as the Democratic
candidate for President. The South and West had triumphed over the East.
The division was sectional, admittedly sectional--the old combination of
power which Calhoun had so anxiously labored to build up a century
earlier. The Gold Democrats were repudiated in terms which were clear to
all. A few, unable to endure the thought of voting the Republican
ticket, held a convention at Indianapolis where, with the sanction of
Cleveland, they nominated candidates of their own and endorsed the gold
standard in a forlorn hope.

=The Democratic Platform.=--It was to the call from Chicago that the
Democrats gave heed and the Republicans made answer. The platform on
which Mr. Bryan stood, unlike most party manifestoes, was explicit in
its language and its appeal. It denounced the practice of allowing
national banks to issue notes intended to circulate as money on the
ground that it was "in derogation of the Constitution," recalling
Jackson's famous attack on the Bank in 1832. It declared that tariff
duties should be laid "for the purpose of revenue"--Calhoun's doctrine.
In demanding the free coinage of silver, it recurred to the practice
abandoned in 1873. The income tax came next on the program. The platform
alleged that the law of 1894, passed by a Democratic Congress, was "in
strict pursuance of the uniform decisions of the Supreme Court for
nearly a hundred years," and then hinted that the decision annulling the
law might be reversed by the same body "as it may hereafter be
constituted."

The appeal to labor voiced by Mr. Bryan in his "crown of thorns" speech
was reinforced in the platform. "As labor creates the wealth of the
country," ran one plank, "we demand the passage of such laws as may be
necessary to protect it in all its rights." Referring to the recent
Pullman strike, the passions of which had not yet died away, the
platform denounced "arbitrary interference by federal authorities in
local affairs as a violation of the Constitution of the United States
and a crime against free institutions." A special objection was lodged
against "government by injunction as a new and highly dangerous form of
oppression by which federal judges, in contempt of the laws of states
and rights of citizens, become at once legislators, judges, and
executioners." The remedy advanced was a federal law assuring trial by
jury in all cases of contempt in labor disputes. Having made this
declaration of faith, the Democrats, with Mr. Bryan at the head, raised
their standard of battle.

=The Heated Campaign.=--The campaign which ensued outrivaled in the
range of its educational activities and the bitterness of its tone all
other political conflicts in American history, not excepting the fateful
struggle of 1860. Immense sums of money were contributed to the funds of
both parties. Railway, banking, and other corporations gave generously
to the Republicans; the silver miners, less lavishly but with the same
anxiety, supported the Democrats. The country was flooded with
pamphlets, posters, and handbills. Every public forum, from the great
auditoriums of the cities to the "red schoolhouses" on the countryside,
was occupied by the opposing forces.

Mr. Bryan took the stump himself, visiting all parts of the country in
special trains and addressing literally millions of people in the open
air. Mr. McKinley chose the older and more formal plan. He received
delegations at his home in Canton and discussed the issues of the
campaign from his front porch, leaving to an army of well-organized
orators the task of reaching the people in their home towns. Parades,
processions, and monster demonstrations filled the land with politics.
Whole states were polled in advance by the Republicans and the doubtful
voters personally visited by men equipped with arguments and literature.
Manufacturers, frightened at the possibility of disordered public
credit, announced that they would close their doors if the Democrats won
the election. Men were dismissed from public and private places on
account of their political views, one eminent college president being
forced out for advocating free silver. The language employed by
impassioned and embittered speakers on both sides roused the public to a
state of frenzy, once more showing the lengths to which men could go in
personal and political abuse.

=The Republican Victory.=--The verdict of the nation was decisive.
McKinley received 271 of the 447 electoral votes, and 7,111,000 popular
votes as against Bryan's 6,509,000. The congressional elections were
equally positive although, on account of the composition of the Senate,
the "hold-over" Democrats and Populists still enjoyed a power out of
proportion to their strength as measured at the polls. Even as it was,
the Republicans got full control of both houses--a dominion of the
entire government which they were to hold for fourteen years--until the
second half of Mr. Taft's administration, when they lost possession of
the House of Representatives. The yoke of indecision was broken. The
party of sound finance and protective tariffs set out upon its lease of
power with untroubled assurance.


REPUBLICAN MEASURES AND RESULTS

=The Gold Standard and the Tariff.=--Yet strange as it may seem, the
Republicans did not at once enact legislation making the gold dollar the
standard for the national currency. Not until 1900 did they take that
positive step. In his first inaugural President McKinley, as if still
uncertain in his own mind or fearing a revival of the contest just
closed, placed the tariff, not the money question, in the forefront.
"The people have decided," he said, "that such legislation should be had
as will give ample protection and encouragement to the industries and
development of our country." Protection for American industries,
therefore, he urged, is the task before Congress. "With adequate revenue
secured, but not until then, we can enter upon changes in our fiscal
laws." As the Republicans had only forty-six of the ninety Senators, and
at least four of them were known advocates of free silver, the
discretion exercised by the President in selecting the tariff for
congressional debate was the better part of valor.

Congress gave heed to the warning. Under the direction of Nelson P.
Dingley, whose name was given to the bill, a tariff measure levying the
highest rates yet laid in the history of American imposts was prepared
and driven through the House of Representatives. The opposition
encountered in the Senate, especially from the West, was overcome by
concessions in favor of that section; but the duties on sugar, tin,
steel, lumber, hemp, and in fact all of the essential commodities
handled by combinations and trusts, were materially raised.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

PRESIDENT MCKINLEY AND HIS CABINET]

=Growth of Combinations.=--The years that followed the enactment of the
Dingley law were, whatever the cause, the most prosperous the country
had witnessed for many a decade. Industries of every kind were soon
running full blast; labor was employed; commerce spread more swiftly
than ever to the markets of the world. Coincident with this progress was
the organization of the greatest combinations and trusts the world had
yet seen. In 1899 the smelters formed a trust with a capital of
$65,000,000; in the same year the Standard Oil Company with a capital of
over one hundred millions took the place of the old trust; and the
Copper Trust was incorporated under the laws of New Jersey, its par
value capital being fixed shortly afterward at $175,000,000. A year
later the National Sugar Refining Company, of New Jersey, started with a
capital of $90,000,000, adopting the policy of issuing to the
stockholders no public statement of its earnings or financial condition.
Before another twelvemonth had elapsed all previous corporate financing
was reduced to small proportions by the flotation of the United States
Steel Corporation with a capital of more than a billion dollars, an
enterprise set in motion by the famous Morgan banking house of New York.

In nearly all these gigantic undertakings, the same great leaders in
finance were more or less intimately associated. To use the language of
an eminent authority: "They are all allied and intertwined by their
various mutual interests. For instance, the Pennsylvania Railroad
interests are on the one hand allied with the Vanderbilts and on the
other with the Rockefellers. The Vanderbilts are closely allied with the
Morgan group.... Viewed as a whole we find the dominating influences in
the trusts to be made up of a network of large and small capitalists,
many allied to one another by ties of more or less importance, but all
being appendages to or parts of the greater groups which are themselves
dependent on and allied with the two mammoth or Rockefeller and Morgan
groups. These two mammoth groups jointly ... constitute the heart of the
business and commercial life of the nation." Such was the picture of
triumphant business enterprise drawn by a financier within a few years
after the memorable campaign of 1896.

America had become one of the first workshops of the world. It was, by
virtue of the closely knit organization of its business and finance, one
of the most powerful and energetic leaders in the struggle of the giants
for the business of the earth. The capital of the Steel Corporation
alone was more than ten times the total national debt which the apostles
of calamity in the days of Washington and Hamilton declared the nation
could never pay. American industry, filling domestic markets to
overflowing, was ready for new worlds to conquer.


=References=

F.W. Taussig, _Tariff History of the United States_.

J.L. Laughlin, _Bimetallism in the United States_.

A.B. Hepburn, _History of Coinage and Currency in the United States_.

E.R.A. Seligman, _The Income Tax_.

S.J. Buck, _The Granger Movement_ (Harvard Studies).

F.H. Dixon, _State Railroad Control_.

H.R. Meyer, _Government Regulation of Railway Rates_.

W.Z. Ripley (editor), _Trusts, Pools, and Corporations_.

R.T. Ely, _Monopolies and Trusts_.

J.B. Clark, _The Control of Trusts_.


=Questions=

1. What proof have we that the political parties were not clearly
divided over issues between 1865 and 1896?

2. Why is a fall in prices a loss to farmers and a gain to holders of
fixed investments?

3. Explain the theory that the quantity of money determines the prices
of commodities.

4. Why was it difficult, if not impossible, to keep gold and silver at a
parity?

5. What special conditions favored a fall in silver between 1870 and
1896?

6. Describe some of the measures taken to raise the value of silver.

7. Explain the relation between the tariff and the income tax in 1894.

8. How did it happen that the farmers led in regulating railway rates?

9. Give the terms of the Sherman Anti-Trust Act. What was its immediate
effect?

10. Name some of the minor parties. Enumerate the reforms they
advocated.

11. Describe briefly the experiments of the farmers in politics.

12. How did industrial conditions increase unrest?

13. Why were conservative men disturbed in the early nineties?

14. Explain the Republican position in 1896.

15. Give Mr. Bryan's doctrines in 1896. Enumerate the chief features of
the Democratic platform.

16. What were the leading measures adopted by the Republicans after
their victory in 1896?


=Research Topics=

=Greenbacks and Resumption.=--Dewey, _Financial History of the United
States_ (6th ed.), Sections 122-125, 154, and 378; MacDonald,
_Documentary Source Book of American History_, pp. 446, 566; Hart,
_American History Told by Contemporaries_, Vol. IV, pp. 531-533; Rhodes,
_History of the United States_, Vol. VIII, pp. 97-101.

=Demonetization and Coinage of Silver.=--Dewey, _Financial History_,
Sections 170-173, 186, 189, 194; MacDonald, _Documentary Source Book_,
pp. 174, 573, 593, 595; Hart, _Contemporaries_, Vol. IV, pp. 529-531;
Rhodes, _History_, Vol. VIII, pp. 93-97.

=Free Silver and the Campaign of 1896.=--Dewey, _National Problems_
(American Nation Series), pp. 220-237, 314-328; Hart, _Contemporaries_,
Vol. IV, pp. 533-538.

=Tariff Revision.=--Dewey, _Financial History_, Sections 167, 180, 181,
187, 192, 196; Hart, _Contemporaries_, Vol. IV, pp. 518-525; Rhodes,
_History_, Vol. VIII, pp. 168-179, 346-351, 418-422.

=Federal Regulation of Railways.=--Dewey, _National Problems_, pp.
91-111; MacDonald, _Documentary Source Book_, pp. 581-590; Hart,
_Contemporaries_, Vol. IV, pp. 521-523; Rhodes, _History_, Vol. VIII,
pp. 288-292.

=The Rise and Regulation of Trusts.=--Dewey, _National Problems_, pp.
188-202; MacDonald, _Documentary Source Book_, pp. 591-593.

=The Grangers and Populism.=--Paxson, _The New Nation_ (Riverside
Series), pp. 20-37, 177-191, 208-223.

=General Analysis of Domestic Problems.=--_Syllabus in History_ (New
York State, 1920), pp. 137-142.




CHAPTER XX

AMERICA A WORLD POWER (1865-1900)


It has now become a fashion, sanctioned by wide usage and by eminent
historians, to speak of America, triumphant over Spain and possessed of
new colonies, as entering the twentieth century in the role of "a world
power," for the first time. Perhaps at this late day, it is useless to
protest against the currency of the idea. Nevertheless, the truth is
that from the fateful moment in March, 1775, when Edmund Burke unfolded
to his colleagues in the British Parliament the resources of an
invincible America, down to the settlement at Versailles in 1919 closing
the drama of the World War, this nation has been a world power,
influencing by its example, by its institutions, by its wealth, trade,
and arms the course of international affairs. And it should be said also
that neither in the field of commercial enterprise nor in that of
diplomacy has it been wanting in spirit or ingenuity.

When John Hay, Secretary of State, heard that an American citizen,
Perdicaris, had been seized by Raisuli, a Moroccan bandit, in 1904, he
wired his brusque message: "We want Perdicaris alive or Raisuli dead."
This was but an echo of Commodore Decatur's equally characteristic
answer, "Not a minute," given nearly a hundred years before to the
pirates of Algiers begging for time to consider whether they would cease
preying upon American merchantmen. Was it not as early as 1844 that the
American commissioner, Caleb Cushing, taking advantage of the British
Opium War on China, negotiated with the Celestial Empire a successful
commercial treaty? Did he not then exultantly exclaim: "The laws of the
Union follow its citizens and its banner protects them even within the
domain of the Chinese Empire"? Was it not almost half a century before
the battle of Manila Bay in 1898, that Commodore Perry with an adequate
naval force "gently coerced Japan into friendship with us," leading all
the nations of the earth in the opening of that empire to the trade of
the Occident? Nor is it inappropriate in this connection to recall the
fact that the Monroe Doctrine celebrates in 1923 its hundredth
anniversary.


AMERICAN FOREIGN RELATIONS (1865-98)

=French Intrigues in Mexico Blocked.=--Between the war for the union and
the war with Spain, the Department of State had many an occasion to
present the rights of America among the powers of the world. Only a
little while after the civil conflict came to a close, it was called
upon to deal with a dangerous situation created in Mexico by the
ambitions of Napoleon III. During the administration of Buchanan, Mexico
had fallen into disorder through the strife of the Liberal and the
Clerical parties; the President asked for authority to use American
troops to bring to a peaceful haven "a wreck upon the ocean, drifting
about as she is impelled by different factions." Our own domestic crisis
then intervened.

Observing the United States heavily involved in its own problems, the
great powers, England, France, and Spain, decided in the autumn of 1861
to take a hand themselves in restoring order in Mexico. They entered
into an agreement to enforce the claims of their citizens against Mexico
and to protect their subjects residing in that republic. They invited
the United States to join them, and, on meeting a polite refusal, they
prepared for a combined military and naval demonstration on their own
account. In the midst of this action England and Spain, discovering the
sinister purposes of Napoleon, withdrew their troops and left the field
to him.

The French Emperor, it was well known, looked with jealousy upon the
growth of the United States and dreamed of establishing in the Western
hemisphere an imperial power to offset the American republic.
Intervention to collect debts was only a cloak for his deeper designs.
Throwing off that guise in due time, he made the Archduke Maximilian, a
brother of the ruler of Austria, emperor in Mexico, and surrounded his
throne by French soldiers, in spite of all protests.

This insolent attack upon the Mexican republic, deeply resented in the
United States, was allowed to drift in its course until 1865. At that
juncture General Sheridan was dispatched to the Mexican border with a
large armed force; General Grant urged the use of the American army to
expel the French from this continent. The Secretary of State, Seward,
counseled negotiation first, and, applying the Monroe Doctrine, was able
to prevail upon Napoleon III to withdraw his troops. Without the support
of French arms, the sham empire in Mexico collapsed like a house of
cards and the unhappy Maximilian, the victim of French ambition and
intrigue, met his death at the hands of a Mexican firing squad.

=Alaska Purchased.=--The Mexican affair had not been brought to a close
before the Department of State was busy with negotiations which resulted
in the purchase of Alaska from Russia. The treaty of cession, signed on
March 30, 1867, added to the United States a domain of nearly six
hundred thousand square miles, a territory larger than Texas and nearly
three-fourths the size of the Louisiana purchase. Though it was a
distant colony separated from our continental domain by a thousand miles
of water, no question of "imperialism" or "colonization foreign to
American doctrines" seems to have been raised at the time. The treaty
was ratified promptly by the Senate. The purchase price, $7,200,000, was
voted by the House of Representatives after the display of some
resentment against a system that compelled it to appropriate money to
fulfill an obligation which it had no part in making. Seward, who
formulated the treaty, rejoiced, as he afterwards said, that he had kept
Alaska out of the hands of England.

=American Interest in the Caribbean.=--Having achieved this diplomatic
triumph, Seward turned to the increase of American power in another
direction. He negotiated, with Denmark, a treaty providing for the
purchase of the islands of St. John and St. Thomas in the West Indies,
strategic points in the Caribbean for sea power. This project, long
afterward brought to fruition by other men, was defeated on this
occasion by the refusal of the Senate to ratify the treaty. Evidently it
was not yet prepared to exercise colonial dominion over other races.

Undaunted by the misadventure in Caribbean policies, President Grant
warmly advocated the acquisition of Santo Domingo. This little republic
had long been in a state of general disorder. In 1869 a treaty of
annexation was concluded with its president. The document Grant
transmitted to the Senate with his cordial approval, only to have it
rejected. Not at all changed in his opinion by the outcome of his
effort, he continued to urge the subject of annexation. Even in his last
message to Congress he referred to it, saying that time had only proved
the wisdom of his early course. The addition of Santo Domingo to the
American sphere of protection was the work of a later generation. The
State Department, temporarily checked, had to bide its time.

=The _Alabama_ Claims Arbitrated.=--Indeed, it had in hand a far more
serious matter, a vexing issue that grew out of Civil War diplomacy. The
British government, as already pointed out in other connections, had
permitted Confederate cruisers, including the famous _Alabama_, built in
British ports, to escape and prey upon the commerce of the Northern
states. This action, denounced at the time by our government as a grave
breach of neutrality as well as a grievous injury to American citizens,
led first to remonstrances and finally to repeated claims for damages
done to American ships and goods. For a long time Great Britain was
firm. Her foreign secretary denied all obligations in the premises,
adding somewhat curtly that "he wished to say once for all that Her
Majesty's government disclaimed any responsibility for the losses and
hoped that they had made their position perfectly clear." Still
President Grant was not persuaded that the door of diplomacy, though
closed, was barred. Hamilton Fish, his Secretary of State, renewed the
demand. Finally he secured from the British government in 1871 the
treaty of Washington providing for the arbitration not merely of the
_Alabama_ and other claims but also all points of serious controversy
between the two countries.

The tribunal of arbitration thus authorized sat at Geneva in
Switzerland, and after a long and careful review of the arguments on
both sides awarded to the United States the lump sum of $15,500,000 to
be distributed among the American claimants. The damages thus allowed
were large, unquestionably larger than strict justice required and it is
not surprising that the decision excited much adverse comment in
England. Nevertheless, the prompt payment by the British government
swept away at once a great cloud of ill-feeling in America. Moreover,
the spectacle of two powerful nations choosing the way of peaceful
arbitration to settle an angry dispute seemed a happy, if illusory, omen
of a modern method for avoiding the arbitrament of war.

=Samoa.=--If the Senate had its doubts at first about the wisdom of
acquiring strategic points for naval power in distant seas, the same
could not be said of the State Department or naval officers. In 1872
Commander Meade, of the United States navy, alive to the importance of
coaling stations even in mid-ocean, made a commercial agreement with the
chief of Tutuila, one of the Samoan Islands, far below the equator, in
the southern Pacific, nearer to Australia than to California. This
agreement, providing among other things for our use of the harbor of
Pago Pago as a naval base, was six years later changed into a formal
treaty ratified by the Senate.

Such enterprise could not escape the vigilant eyes of England and
Germany, both mindful of the course of the sea power in history. The
German emperor, seizing as a pretext a quarrel between his consul in the
islands and a native king, laid claim to an interest in the Samoan
group. England, aware of the dangers arising from German outposts in the
southern seas so near to Australia, was not content to stand aside. So
it happened that all three countries sent battleships to the Samoan
waters, threatening a crisis that was fortunately averted by friendly
settlement. If, as is alleged, Germany entertained a notion of
challenging American sea power then and there, the presence of British
ships must have dispelled that dream.

The result of the affair was a tripartite agreement by which the three
powers in 1889 undertook a protectorate over the islands. But joint
control proved unsatisfactory. There was constant friction between the
Germans and the English. The spheres of authority being vague and open
to dispute, the plan had to be abandoned at the end of ten years.
England withdrew altogether, leaving to Germany all the islands except
Tutuila, which was ceded outright to the United States. Thus one of the
finest harbors in the Pacific, to the intense delight of the American
navy, passed permanently under American dominion. Another triumph in
diplomacy was set down to the credit of the State Department.

=Cleveland and the Venezuela Affair.=--In the relations with South
America, as well as in those with the distant Pacific, the diplomacy of
the government at Washington was put to the test. For some time it had
been watching a dispute between England and Venezuela over the western
boundary of British Guiana and, on an appeal from Venezuela, it had
taken a lively interest in the contest. In 1895 President Cleveland saw
that Great Britain would yield none of her claims. After hearing the
arguments of Venezuela, his Secretary of State, Richard T. Olney, in a
note none too conciliatory, asked the British government whether it was
willing to arbitrate the points in controversy. This inquiry he
accompanied by a warning to the effect that the United States could not
permit any European power to contest its mastery in this hemisphere.
"The United States," said the Secretary, "is practically sovereign on
this continent and its fiat is law upon the subjects to which it
confines its interposition.... Its infinite resources, combined with its
isolated position, render it master of the situation and practically
invulnerable against any or all other powers."

The reply evoked from the British government by this strong statement
was firm and clear. The Monroe Doctrine, it said, even if not so widely
stretched by interpretation, was not binding in international law; the
dispute with Venezuela was a matter of interest merely to the parties
involved; and arbitration of the question was impossible. This response
called forth President Cleveland's startling message of 1895. He asked
Congress to create a commission authorized to ascertain by researches
the true boundary between Venezuela and British Guiana. He added that it
would be the duty of this country "to resist by every means in its
power, as a willful aggression upon its rights and interests, the
appropriation by Great Britain of any lands or the exercise of
governmental jurisdiction over any territory which, after investigation,
we have determined of right belongs to Venezuela." The serious character
of this statement he thoroughly understood. He declared that he was
conscious of his responsibilities, intimating that war, much as it was
to be deplored, was not comparable to "a supine submission to wrong and
injustice and the consequent loss of national self-respect and honor."

[Illustration: GROVER CLEVELAND]

The note of defiance which ran through this message, greeted by shrill
cries of enthusiasm in many circles, was viewed in other quarters as a
portent of war. Responsible newspapers in both countries spoke of an
armed settlement of the dispute as inevitable. Congress created the
commission and appropriated money for the investigation; a body of
learned men was appointed to determine the merits of the conflicting
boundary claims. The British government, deaf to the clamor of the
bellicose section of the London press, deplored the incident,
courteously replied in the affirmative to a request for assistance in
the search for evidence, and finally agreed to the proposition that the
issue be submitted to arbitration. The outcome of this somewhat perilous
dispute contributed not a little to Cleveland's reputation as "a
sterling representative of the true American spirit." This was not
diminished when the tribunal of arbitration found that Great Britain was
on the whole right in her territorial claims against Venezuela.

=The Annexation of Hawaii.=--While engaged in the dangerous Venezuela
controversy, President Cleveland was compelled by a strange turn in
events to consider the annexation of the Hawaiian Islands in the
mid-Pacific. For more than half a century American missionaries had been
active in converting the natives to the Christian faith and enterprising
American business men had been developing the fertile sugar plantations.
Both the Department of State and the Navy Department were fully
conscious of the strategic relation of the islands to the growth of sea
power and watched with anxiety any developments likely to bring them
under some other Dominion.

The country at large was indifferent, however, until 1893, when a
revolution, headed by Americans, broke out, ending in the overthrow of
the native government, the abolition of the primitive monarchy, and the
retirement of Queen Liliuokalani to private life. This crisis, a
repetition of the Texas affair in a small theater, was immediately
followed by a demand from the new Hawaiian government for annexation to
the United States. President Harrison looked with favor on the proposal,
negotiated the treaty of annexation, and laid it before the Senate for
approval. There it still rested when his term of office was brought to a
close.

Harrison's successor, Cleveland, it was well known, had doubts about the
propriety of American action in Hawaii. For the purpose of making an
inquiry into the matter, he sent a special commissioner to the islands.
On the basis of the report of his agent, Cleveland came to the
conclusion that "the revolution in the island kingdom had been
accomplished by the improper use of the armed forces of the United
States and that the wrong should be righted by a restoration of the
queen to her throne." Such being his matured conviction, though the
facts upon which he rested it were warmly controverted, he could do
nothing but withdraw the treaty from the Senate and close the incident.

To the Republicans this sharp and cavalier disposal of their plans,
carried out in a way that impugned the motives of a Republican
President, was nothing less than "a betrayal of American interests." In
their platform of 1896 they made clear their position: "Our foreign
policy should be at all times firm, vigorous, and dignified and all our
interests in the Western hemisphere carefully watched and guarded. The
Hawaiian Islands should be controlled by the United States and no
foreign power should be permitted to interfere with them." There was no
mistaking this view of the issue. As the vote in the election gave
popular sanction to Republican policies, Congress by a joint resolution,
passed on July 6, 1898, annexed the islands to the United States and
later conferred upon them the ordinary territorial form of government.


CUBA AND THE SPANISH WAR

=Early American Relations with Cuba.=--The year that brought Hawaii
finally under the American flag likewise drew to a conclusion another
long controversy over a similar outpost in the Atlantic, one of the last
remnants of the once glorious Spanish empire--the island of Cuba.

For a century the Department of State had kept an anxious eye upon this
base of power, knowing full well that both France and England, already
well established in the West Indies, had their attention also fixed upon
Cuba. In the administration of President Fillmore they had united in
proposing to the United States a tripartite treaty guaranteeing Spain in
her none too certain ownership. This proposal, squarely rejected,
furnished the occasion for a statement of American policy which stood
the test of all the years that followed; namely, that the affair was one
between Spain and the United States alone.

In that long contest in the United States for the balance of power
between the North and South, leaders in the latter section often thought
of bringing Cuba into the union to offset the free states. An
opportunity to announce their purposes publicly was afforded in 1854 by
a controversy over the seizure of an American ship by Cuban authorities.
On that occasion three American ministers abroad, stationed at Madrid,
Paris, and London respectively, held a conference and issued the
celebrated "Ostend Manifesto." They united in declaring that Cuba, by
her geographical position, formed a part of the United States, that
possession by a foreign power was inimical to American interests, and
that an effort should be made to purchase the island from Spain. In case
the owner refused to sell, they concluded, with a menacing flourish, "by
every law, human and divine, we shall be justified in wresting it from
Spain if we possess the power." This startling proclamation to the world
was promptly disowned by the United States government.

[Illustration: _=An old cartoon.=_

A SIGHT TOO BAD

_Struggling Cuba._ "You must be awfully near-sighted, Mr. President, not
to recognize me." _U.S.G._ "No, I am far-sighted: for I can recognize
France."]

=Revolutions in Cuba.=--For nearly twenty years afterwards the Cuban
question rested. Then it was revived in another form during President
Grant's administrations, when the natives became engaged in a
destructive revolt against Spanish officials. For ten years--1868-78--a
guerrilla warfare raged in the island. American citizens, by virtue of
their ancient traditions of democracy, naturally sympathized with a war
for independence and self-government. Expeditions to help the insurgents
were fitted out secretly in American ports. Arms and supplies were
smuggled into Cuba. American soldiers of fortune joined their ranks. The
enforcement of neutrality against the friends of Cuban independence, no
pleasing task for a sympathetic President, the protection of American
lives and property in the revolutionary area, and similar matters kept
our government busy with Cuba for a whole decade.

A brief lull in Cuban disorders was followed in 1895 by a renewal of the
revolutionary movement. The contest between the rebels and the Spanish
troops, marked by extreme cruelty and a total disregard for life and
property, exceeded all bounds of decency, and once more raised the old
questions that had tormented Grant's administration. Gomez, the leader
of the revolt, intent upon provoking American interference, laid waste
the land with fire and sword. By a proclamation of November 6, 1895, he
ordered the destruction of sugar plantations and railway connections and
the closure of all sugar factories. The work of ruin was completed by
the ruthless Spanish general, Weyler, who concentrated the inhabitants
from rural regions into military camps, where they died by the hundreds
of disease and starvation. Stories of the atrocities, bad enough in
simple form, became lurid when transmuted into American news and deeply
moved the sympathies of the American people. Sermons were preached about
Spanish misdeeds; orators demanded that the Cubans be sustained "in
their heroic struggle for independence"; newspapers, scouting the
ordinary forms of diplomatic negotiation, spurned mediation and demanded
intervention and war if necessary.

[Illustration: _Underwood and Underwood, N.Y._

CUBAN REVOLUTIONISTS]

=President Cleveland's Policy.=--Cleveland chose the way of peace. He
ordered the observance of the rule of neutrality. He declined to act on
a resolution of Congress in favor of giving to the Cubans the rights of
belligerents. Anxious to bring order to the distracted island, he
tendered to Spain the good offices of the United States as mediator in
the contest--a tender rejected by the Spanish government with the broad
hint that President Cleveland might be more vigorous in putting a stop
to the unlawful aid in money, arms, and supplies, afforded to the
insurgents by American sympathizers. Thereupon the President returned to
the course he had marked out for himself, leaving "the public nuisance"
to his successor, President McKinley.

=Republican Policies.=--The Republicans in 1897 found themselves in a
position to employ that "firm, vigorous, and dignified" foreign policy
which they had approved in their platform. They had declared: "The
government of Spain having lost control of Cuba and being unable to

protect the property or lives of resident American citizens or to comply
with its treaty obligations, we believe that the government of the
United States should actively use its influence and good offices to
restore peace and give independence to the island." The American
property in Cuba to which the Republicans referred in their platform
amounted by this time to more than fifty million dollars; the commerce
with the island reached more than one hundred millions annually; and the
claims of American citizens against Spain for property destroyed totaled
sixteen millions. To the pleas of humanity which made such an effective
appeal to the hearts of the American people, there were thus added
practical considerations of great weight.

=President McKinley Negotiates.=--In the face of the swelling tide of
popular opinion in favor of quick, drastic, and positive action,
McKinley chose first the way of diplomacy. A short time after his
inauguration he lodged with the Spanish government a dignified protest
against its policies in Cuba, thus opening a game of thrust and parry
with the suave ministers at Madrid. The results of the exchange of
notes were the recall of the obnoxious General Weyler, the appointment
of a governor-general less bloodthirsty in his methods, a change in the
policy of concentrating civilians in military camps, and finally a
promise of "home rule" for Cuba. There is no doubt that the Spanish
government was eager to avoid a war that could have but one outcome. The
American minister at Madrid, General Woodford, was convinced that firm
and patient pressure would have resulted in the final surrender of Cuba
by the Spanish government.

=The De Lome and the _Maine_ Incidents.=--Such a policy was defeated by
events. In February, 1898, a private letter written by Senor de Lome,
the Spanish ambassador at Washington, expressing contempt for the
President of the United States, was filched from the mails and passed
into the hands of a journalist, William R. Hearst, who published it to
the world. In the excited state of American opinion, few gave heed to
the grave breach of diplomatic courtesy committed by breaking open
private correspondence. The Spanish government was compelled to recall
De Lome, thus officially condemning his conduct.

At this point a far more serious crisis put the pacific relations of the
two negotiating countries in dire peril. On February 15, the battleship
_Maine_, riding in the harbor of Havana, was blown up and sunk, carrying
to death two officers and two hundred and fifty-eight members of the
crew. This tragedy, ascribed by the American public to the malevolence
of Spanish officials, profoundly stirred an already furious nation.
When, on March 21, a commission of inquiry reported that the ill-fated
ship had been blown up by a submarine mine which had in turn set off
some of the ship's magazines, the worst suspicions seemed confirmed. If
any one was inclined to be indifferent to the Cuban war for
independence, he was now met by the vehement cry: "Remember the
_Maine_!"

=Spanish Concessions.=--Still the State Department, under McKinley's
steady hand, pursued the path of negotiation, Spain proving more pliable
and more ready with promises of reform in the island. Early in April,
however, there came a decided change in the tenor of American diplomacy.
On the 4th, McKinley, evidently convinced that promises did not mean
performances, instructed our minister at Madrid to warn the Spanish
government that as no effective armistice had been offered to the
Cubans, he would lay the whole matter before Congress. This decision,
every one knew, from the temper of Congress, meant war--a prospect which
excited all the European powers. The Pope took an active interest in the
crisis. France and Germany, foreseeing from long experience in world
politics an increase of American power and prestige through war, sought
to prevent it. Spain, hopeless and conscious of her weakness, at last
dispatched to the President a note promising to suspend hostilities, to
call a Cuban parliament, and to grant all the autonomy that could be
reasonably asked.

=President McKinley Calls for War.=--For reasons of his own--reasons
which have never yet been fully explained--McKinley ignored the final
program of concessions presented by Spain. At the very moment when his
patient negotiations seemed to bear full fruit, he veered sharply from
his course and launched the country into the war by sending to Congress
his militant message of April 11, 1898. Without making public the last
note he had received from Spain, he declared that he was brought to the
end of his effort and the cause was in the hands of Congress. Humanity,
the protection of American citizens and property, the injuries to
American commerce and business, the inability of Spain to bring about
permanent peace in the island--these were the grounds for action that
induced him to ask for authority to employ military and naval forces in
establishing a stable government in Cuba. They were sufficient for a
public already straining at the leash.

=The Resolution of Congress.=--There was no doubt of the outcome when
the issue was withdrawn from diplomacy and placed in charge of Congress.
Resolutions were soon introduced into the House of Representatives
authorizing the President to employ armed force in securing peace and
order in the island and "establishing by the free action of the people
thereof a stable and independent government of their own." To the form
and spirit of this proposal the Democrats and Populists took exception.
In the Senate, where they were stronger, their position had to be
reckoned with by the narrow Republican majority. As the resolution
finally read, the independence of Cuba was recognized; Spain was called
upon to relinquish her authority and withdraw from the island; and the
President was empowered to use force to the extent necessary to carry
the resolutions into effect. Furthermore the United States disclaimed
"any disposition or intention to exercise sovereignty, jurisdiction, or
control over said island except for the pacification thereof." Final
action was taken by Congress on April 19, 1898, and approved by the
President on the following day.

=War and Victory.=--Startling events then followed in swift succession.
The navy, as a result in no small measure of the alertness of Theodore
Roosevelt, Assistant Secretary of the Department, was ready for the
trial by battle. On May 1, Commodore Dewey at Manila Bay shattered the
Spanish fleet, marking the doom of Spanish dominion in the Philippines.
On July 3, the Spanish fleet under Admiral Cervera, in attempting to
escape from Havana, was utterly destroyed by American forces under
Commodore Schley. On July 17, Santiago, invested by American troops
under General Shafter and shelled by the American ships, gave up the
struggle. On July 25 General Miles landed in Porto Rico. On August 13,
General Merritt and Admiral Dewey carried Manila by storm. The war was
over.

=The Peace Protocol.=--Spain had already taken cognizance of stern
facts. As early as July 26, 1898, acting through the French ambassador,
M. Cambon, the Madrid government approached President McKinley for a
statement of the terms on which hostilities could be brought to a close.
After some skirmishing Spain yielded reluctantly to the ultimatum. On
August 12, the preliminary peace protocol was signed, stipulating that
Cuba should be free, Porto Rico ceded to the United States, and Manila
occupied by American troops pending the formal treaty of peace. On
October 1, the commissioners of the two countries met at Paris to bring
about the final settlement.

=Peace Negotiations.=--When the day for the first session of the
conference arrived, the government at Washington apparently had not made
up its mind on the final disposition of the Philippines. Perhaps, before
the battle of Manila Bay, not ten thousand people in the United States
knew or cared where the Philippines were. Certainly there was in the
autumn of 1898 no decided opinion as to what should be done with the
fruits of Dewey's victory. President McKinley doubtless voiced the
sentiment of the people when he stated to the peace commissioners on the
eve of their departure that there had originally been no thought of
conquest in the Pacific.

The march of events, he added, had imposed new duties on the country.
"Incidental to our tenure in the Philippines," he said, "is the
commercial opportunity to which American statesmanship cannot be
indifferent. It is just to use every legitimate means for the
enlargement of American trade." On this ground he directed the
commissioners to accept not less than the cession of the island of
Luzon, the chief of the Philippine group, with its harbor of Manila. It
was not until the latter part of October that he definitely instructed
them to demand the entire archipelago, on the theory that the occupation
of Luzon alone could not be justified "on political, commercial, or
humanitarian grounds." This departure from the letter of the peace
protocol was bitterly resented by the Spanish agents. It was with
heaviness of heart that they surrendered the last sign of Spain's
ancient dominion in the far Pacific.

=The Final Terms of Peace.=--The treaty of peace, as finally agreed
upon, embraced the following terms: the independence of Cuba; the
cession of Porto Rico, Guam, and the Philippines to the United States;
the settlement of claims filed by the citizens of both countries; the
payment of twenty million dollars to Spain by the United States for the
Philippines; and the determination of the status of the inhabitants of
the ceded territories by Congress. The great decision had been made. Its
issue was in the hands of the Senate where the Democrats and the
Populists held the balance of power under the requirement of the
two-thirds vote for ratification.

=The Contest in America over the Treaty of Peace.=--The publication of
the treaty committing the United States to the administration of distant
colonies directed the shifting tides of public opinion into two distinct
channels: support of the policy and opposition to it. The trend in
Republican leadership, long in the direction marked out by the treaty,
now came into the open. Perhaps a majority of the men highest in the
councils of that party had undergone the change of heart reflected in
the letters of John Hay, Secretary of State. In August of 1898 he had
hinted, in a friendly letter to Andrew Carnegie, that he sympathized
with the latter's opposition to "imperialism"; but he had added quickly:
"The only question in my mind is how far it is now possible for us to
withdraw from the Philippines." In November of the same year he wrote to
Whitelaw Reid, one of the peace commissioners at Paris: "There is a wild
and frantic attack now going on in the press against the whole
Philippine transaction. Andrew Carnegie really seems to be off his
head.... But all this confusion of tongues will go its way. The country
will applaud the resolution that has been reached and you will return in
the role of conquering heroes with your 'brows bound with oak.'"

Senator Beveridge of Indiana and Senator Platt of Connecticut, accepting
the verdict of history as the proof of manifest destiny, called for
unquestioning support of the administration in its final step. "Every
expansion of our territory," said the latter, "has been in accordance
with the irresistible law of growth. We could no more resist the
successive expansions by which we have grown to be the strongest nation
on earth than a tree can resist its growth. The history of territorial
expansion is the history of our nation's progress and glory. It is a
matter to be proud of, not to lament. We should rejoice that Providence
has given us the opportunity to extend our influence, our institutions,
and our civilization into regions hitherto closed to us, rather than
contrive how we can thwart its designs."

This doctrine was savagely attacked by opponents of McKinley's policy,
many a stanch Republican joining with the majority of Democrats in
denouncing the treaty as a departure from the ideals of the republic.
Senator Vest introduced in the Senate a resolution that "under the
Constitution of the United States, no power is given to the federal
Government to acquire territory to be held and governed permanently as
colonies." Senator Hoar, of Massachusetts, whose long and honorable
career gave weight to his lightest words, inveighed against the whole
procedure and to the end of his days believed that the new drift into
rivalry with European nations as a colonial power was fraught with
genuine danger. "Our imperialistic friends," he said, "seem to have
forgotten the use of the vocabulary of liberty. They talk about giving
good government. 'We shall give them such a government as we think they
are fitted for.' 'We shall give them a better government than they had
before.' Why, Mr. President, that one phrase conveys to a free man and a
free people the most stinging of insults. In that little phrase, as in a
seed, is contained the germ of all despotism and of all tyranny.
Government is not a gift. Free government is not to be given by all the
blended powers of earth and heaven. It is a birthright. It belongs, as
our fathers said, and as their children said, as Jefferson said, and as
President McKinley said, to human nature itself."

The Senate, more conservative on the question of annexation than the
House of Representatives composed of men freshly elected in the stirring
campaign of 1896, was deliberate about ratification of the treaty. The
Democrats and Populists were especially recalcitrant. Mr. Bryan hurried
to Washington and brought his personal influence to bear in favor of
speedy action. Patriotism required ratification, it was said in one
quarter. The country desires peace and the Senate ought not to delay, it
was urged in another. Finally, on February 6, 1899, the requisite
majority of two-thirds was mustered, many a Senator who voted for the
treaty, however, sharing the misgivings of Senator Hoar as to the
"dangers of imperialism." Indeed at the time, the Senators passed a
resolution declaring that the policy to be adopted in the Philippines
was still an open question, leaving to the future, in this way, the
possibility of retracing their steps.

=The Attitude of England.=--The Spanish war, while accomplishing the
simple objects of those who launched the nation on that course, like all
other wars, produced results wholly unforeseen. In the first place, it
exercised a profound influence on the drift of opinion among European
powers. In England, sympathy with the United States was from the first
positive and outspoken. "The state of feeling here," wrote Mr. Hay, then
ambassador in London, "is the best I have ever known. From every quarter
the evidences of it come to me. The royal family by habit and tradition
are most careful not to break the rules of strict neutrality, but even
among them I find nothing but hearty kindness and--so far as is
consistent with propriety--sympathy. Among the political leaders on both
sides I find not only sympathy but a somewhat eager desire that 'the
other fellows' shall not seem more friendly."

Joseph Chamberlain, the distinguished Liberal statesman, thinking no
doubt of the continental situation, said in a political address at the
very opening of the war that the next duty of Englishmen "is to
establish and maintain bonds of permanent unity with our kinsmen across
the Atlantic.... I even go so far as to say that, terrible as war may
be, even war would be cheaply purchased if, in a great and noble cause,
the Stars and Stripes and the Union Jack should wave together over an
Anglo-Saxon alliance." To the American ambassador he added
significantly that he did not "care a hang what they say about it on the
continent," which was another way of expressing the hope that the
warning to Germany and France was sufficient. This friendly English
opinion, so useful to the United States when a combination of powers to
support Spain was more than possible, removed all fears as to the
consequences of the war. Henry Adams, recalling days of humiliation in
London during the Civil War, when his father was the American
ambassador, coolly remarked that it was "the sudden appearance of
Germany as the grizzly terror" that "frightened England into America's
arms"; but the net result in keeping the field free for an easy triumph
of American arms was none the less appreciated in Washington where,
despite outward calm, fears of European complications were never absent.


AMERICAN POLICIES IN THE PHILIPPINES AND THE ORIENT

=The Filipino Revolt against American Rule.=--In the sphere of domestic
politics, as well as in the field of foreign relations, the outcome of
the Spanish war exercised a marked influence. It introduced at once
problems of colonial administration and difficulties in adjusting trade
relations with the outlying dominions. These were furthermore
complicated in the very beginning by the outbreak of an insurrection
against American sovereignty in the Philippines. The leader of the
revolt, Aguinaldo, had been invited to join the American forces in
overthrowing Spanish dominion, and he had assumed, apparently without
warrant, that independence would be the result of the joint operations.
When the news reached him that the American flag had been substituted
for the Spanish flag, his resentment was keen. In February, 1899, there
occurred a slight collision between his men and some American soldiers.
The conflict thus begun was followed by serious fighting which finally
dwindled into a vexatious guerrilla warfare lasting three years and
costing heavily in men and money. Atrocities were committed by the
native insurrectionists and, sad to relate, they were repaid in kind;
it was argued in defense of the army that the ordinary rules of warfare
were without terror to men accustomed to fighting like savages. In vain
did McKinley assure the Filipinos that the institutions and laws
established in the islands would be designed "not for our satisfaction
or for the expression of our theoretical views, but for the happiness,
peace, and prosperity of the people of the Philippine Islands." Nothing
short of military pressure could bring the warring revolutionists to
terms.

=Attacks on Republican "Imperialism."=--The Filipino insurrection,
following so quickly upon the ratification of the treaty with Spain,
moved the American opponents of McKinley's colonial policies to redouble
their denunciation of what they were pleased to call "imperialism."
Senator Hoar was more than usually caustic in his indictment of the new
course. The revolt against American rule did but convince him of the
folly hidden in the first fateful measures. Everywhere he saw a
conspiracy of silence and injustice. "I have failed to discover in the
speeches, public or private, of the advocates of this war," he contended
in the Senate, "or in the press which supports it and them, a single
expression anywhere of a desire to do justice to the people of the
Philippine Islands, or of a desire to make known to the people of the
United States the truth of the case.... The catchwords, the cries, the
pithy and pregnant phrases of which their speech is full, all mean
dominion. They mean perpetual dominion.... There is not one of these
gentlemen who will rise in his place and affirm that if he were a
Filipino he would not do exactly as the Filipinos are doing; that he
would not despise them if they were to do otherwise. So much at least
they owe of respect to the dead and buried history--the dead and buried
history so far as they can slay and bury it--of their country." In the
way of practical suggestions, the Senator offered as a solution of the
problem: the recognition of independence, assistance in establishing
self-government, and an invitation to all powers to join in a guarantee
of freedom to the islands.

=The Republican Answer.=--To McKinley and his supporters, engaged in a
sanguinary struggle to maintain American supremacy, such talk was more
than quixotic; it was scarcely short of treasonable. They pointed out
the practical obstacles in the way of uniform self-government for a
collection of seven million people ranging in civilization from the most
ignorant hill men to the highly cultivated inhabitants of Manila. The
incidents of the revolt and its repression, they admitted, were painful
enough; but still nothing as compared with the chaos that would follow
the attempt of a people who had never had experience in such matters to
set up and sustain democratic institutions. They preferred rather the
gradual process of fitting the inhabitants of the islands for
self-government. This course, in their eyes, though less poetic, was
more in harmony with the ideals of humanity. Having set out upon it,
they pursued it steadfastly to the end. First, they applied force
without stint to the suppression of the revolt. Then they devoted such
genius for colonial administration as they could command to the
development of civil government, commerce, and industry.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

A PHILIPPINE HOME]

=The Boxer Rebellion in China.=--For a nation with a world-wide trade,
steadily growing, as the progress of home industries redoubled the zeal
for new markets, isolation was obviously impossible. Never was this
clearer than in 1900 when a native revolt against foreigners in China,
known as the Boxer uprising, compelled the United States to join with
the powers of Europe in a military expedition and a diplomatic
settlement. The Boxers, a Chinese association, had for some time carried
on a campaign of hatred against all aliens in the Celestial empire,
calling upon the natives to rise in patriotic wrath and drive out the
foreigners who, they said, "were lacerating China like tigers." In the
summer of 1900 the revolt flamed up in deeds of cruelty. Missionaries
and traders were murdered in the provinces; foreign legations were
stoned; the German ambassador, one of the most cordially despised
foreigners, was killed in the streets of Peking; and to all appearances
a frightful war of extermination had begun. In the month of June nearly
five hundred men, women, and children, representing all nations, were
besieged in the British quarters in Peking under constant fire of
Chinese guns and in peril of a terrible death.

=Intervention in China.=--Nothing but the arrival of armed forces, made
up of Japanese, Russian, British, American, French, and German soldiers
and marines, prevented the destruction of the beleaguered aliens. When
once the foreign troops were in possession of the Chinese capital,
diplomatic questions of the most delicate character arose. For more than
half a century, the imperial powers of Europe had been carving up the
Chinese empire, taking to themselves territory, railway concessions,
mining rights, ports, and commercial privileges at the expense of the
huge but helpless victim. The United States alone among the great
nations, while as zealous as any in the pursuit of peaceful trade, had
refrained from seizing Chinese territory or ports. Moreover, the
Department of State had been urging European countries to treat China
with fairness, to respect her territorial integrity, and to give her
equal trading privileges with all nations.

=The American Policy of the "Open Door."=--In the autumn of 1899,
Secretary Hay had addressed to London, Berlin, Rome, Paris, Tokyo, and
St. Petersburg his famous note on the "open door" policy in China. In
this document he proposed that existing treaty ports and vested
interests of the several foreign countries should be respected; that
the Chinese government should be permitted to extend its tariffs to all
ports held by alien powers except the few free ports; and that there
should be no discrimination in railway and port charges among the
citizens of foreign countries operating in the empire. To these
principles the governments addressed by Mr. Hay, finally acceded with
evident reluctance.

[Illustration: AMERICAN DOMINIONS IN THE PACIFIC]

On this basis he then proposed the settlement that had to follow the
Boxer uprising. "The policy of the Government of the United States," he
said to the great powers, in the summer of 1900, "is to seek a solution
which may bring about permanent safety and peace to China, preserve
Chinese territorial and administrative entity, protect all rights
guaranteed to friendly powers by treaty and international law, and
safeguard for the world the principle of equal and impartial trade with
all parts of the Chinese empire." This was a friendly warning to the
world that the United States would not join in a scramble to punish the
Chinese by carving out more territory. "The moment we acted," said Mr.
Hay, "the rest of the world paused and finally came over to our ground;
and the German government, which is generally brutal but seldom silly,
recovered its senses, and climbed down off its perch."

In taking this position, the Secretary of State did but reflect the
common sense of America. "We are, of course," he explained, "opposed to
the dismemberment of that empire and we do not think that the public
opinion of the United States would justify this government in taking
part in the great game of spoliation now going on." Heavy damages were
collected by the European powers from China for the injuries inflicted
upon their citizens by the Boxers; but the United States, finding the
sum awarded in excess of the legitimate claims, returned the balance in
the form of a fund to be applied to the education of Chinese students in
American universities. "I would rather be, I think," said Mr. Hay, "the
dupe of China than the chum of the Kaiser." By pursuing a liberal
policy, he strengthened the hold of the United States upon the
affections of the Chinese people and, in the long run, as he remarked
himself, safeguarded "our great commercial interests in that Empire."

=Imperialism in the Presidential Campaign of 1900.=--It is not strange
that the policy pursued by the Republican administration in disposing of
the questions raised by the Spanish War became one of the first issues
in the presidential campaign of 1900. Anticipating attacks from every
quarter, the Republicans, in renominating McKinley, set forth their
position in clear and ringing phrases: "In accepting by the treaty of
Paris the just responsibility of our victories in the Spanish War the
President and Senate won the undoubted approval of the American people.
No other course was possible than to destroy Spain's sovereignty
throughout the West Indies and in the Philippine Islands. That course
created our responsibility, before the world and with the unorganized
population whom our intervention had freed from Spain, to provide for
the maintenance of law and order, and for the establishment of good
government and for the performance of international obligations. Our
authority could not be less than our responsibility, and wherever
sovereign rights were extended it became the high duty of the government
to maintain its authority, to put down armed insurrection, and to confer
the blessings of liberty and civilization upon all the rescued peoples.
The largest measure of self-government consistent with their welfare and
our duties shall be secured to them by law." To give more strength to
their ticket, the Republican convention, in a whirlwind of enthusiasm,
nominated for the vice presidency, against his protest, Theodore
Roosevelt, the governor of New York and the hero of the Rough Riders, so
popular on account of their Cuban campaign.

The Democrats, as expected, picked up the gauntlet thrown down with such
defiance by the Republicans. Mr. Bryan, whom they selected as their
candidate, still clung to the currency issue; but the main emphasis,
both of the platform and the appeal for votes, was on the "imperialistic
program" of the Republican administration. The Democrats denounced the
treatment of Cuba and Porto Rico and condemned the Philippine policy in
sharp and vigorous terms. "As we are not willing," ran the platform, "to
surrender our civilization or to convert the Republic into an empire, we
favor an immediate declaration of the Nation's purpose to give to the
Filipinos, first, a stable form of government; second, independence;
third, protection from outside interference.... The greedy commercialism
which dictated the Philippine policy of the Republican administration
attempts to justify it with the plea that it will pay, but even this
sordid and unworthy plea fails when brought to the test of facts. The
war of 'criminal aggression' against the Filipinos entailing an annual
expense of many millions has already cost more than any possible profit
that could accrue from the entire Philippine trade for years to come....
We oppose militarism. It means conquest abroad and intimidation and
oppression at home. It means the strong arm which has ever been fatal to
free institutions. It is what millions of our citizens have fled from in
Europe. It will impose upon our peace-loving people a large standing
army, an unnecessary burden of taxation, and would be a constant menace
to their liberties." Such was the tenor of their appeal to the voters.

With the issues clearly joined, the country rejected the Democratic
candidate even more positively than four years before. The popular vote
cast for McKinley was larger and that cast for Bryan smaller than in the
silver election. Thus vindicated at the polls, McKinley turned with
renewed confidence to the development of the policies he had so far
advanced. But fate cut short his designs. In the September following his
second inauguration, he was shot by an anarchist while attending the
Buffalo exposition. "What a strange and tragic fate it has been of
mine," wrote the Secretary of State, John Hay, on the day of the
President's death, "to stand by the bier of three of my dearest friends,
Lincoln, Garfield, and McKinley, three of the gentlest of men, all risen
to the head of the state and all done to death by assassins." On
September 14, 1901, the Vice President, Theodore Roosevelt, took up the
lines of power that had fallen from the hands of his distinguished
chief, promising to continue "absolutely unbroken" the policies he had
inherited.


SUMMARY OF NATIONAL GROWTH AND WORLD POLITICS

The economic aspects of the period between 1865 and 1900 may be readily
summed up: the recovery of the South from the ruin of the Civil War, the
extension of the railways, the development of the Great West, and the
triumph of industry and business enterprise. In the South many of the
great plantations were broken up and sold in small farms, crops were
diversified, the small farming class was raised in the scale of social
importance, the cotton industry was launched, and the coal, iron,
timber, and other resources were brought into use. In the West the free
arable land was practically exhausted by 1890 under the terms of the
Homestead Act; gold, silver, copper, coal and other minerals were
discovered in abundance; numerous rail connections were formed with the
Atlantic seaboard; the cowboy and the Indian were swept away before a
standardized civilization of electric lights and bathtubs. By the end of
the century the American frontier had disappeared. The wild, primitive
life so long associated with America was gone. The unity of the nation
was established.

In the field of business enterprise, progress was most marked. The
industrial system, which had risen and flourished before the Civil War,
grew into immense proportions and the industrial area was extended from
the Northeast into all parts of the country. Small business concerns
were transformed into huge corporations. Individual plants were merged
under the management of gigantic trusts. Short railway lines were
consolidated into national systems. The industrial population of
wage-earners rose into the tens of millions. The immigration of aliens
increased by leaps and bounds. The cities overshadowed the country. The
nation that had once depended upon Europe for most of its manufactured
goods became a competitor of Europe in the markets of the earth.

In the sphere of politics, the period witnessed the recovery of white
supremacy in the South; the continued discussion of the old questions,
such as the currency, the tariff, and national banking; and the
injection of new issues like the trusts and labor problems. As of old,
foreign affairs were kept well at the front. Alaska was purchased from
Russia; attempts were made to extend American influence in the Caribbean
region; a Samoan island was brought under the flag; and the Hawaiian
islands were annexed. The Monroe Doctrine was applied with vigor in the
dispute between Venezuela and Great Britain.

Assistance was given to the Cubans in their revolutionary struggle
against Spain and thus there was precipitated a war which ended in the
annexation of Porto Rico and the Philippines. American influence in the
Pacific and the Orient was so enlarged as to be a factor of great weight
in world affairs. Thus questions connected with foreign and "imperial"
policies were united with domestic issues to make up the warp and woof
of politics. In the direction of affairs, the Republicans took the
leadership, for they held the presidency during all the years, except
eight, between 1865 and 1900.


=References=

J.W. Foster, _A Century of American Diplomacy_; _American Diplomacy in
the Orient_.

W.F. Reddaway, _The Monroe Doctrine_.

J.H. Latane, _The United States and Spanish America_.

A.C. Coolidge, _United States as a World Power_.

A.T. Mahan, _Interest of the United States in the Sea Power_.

F.E. Chadwick, _Spanish-American War_.

D.C. Worcester, _The Philippine Islands and Their People_.

M.M. Kalaw, _Self-Government in the Philippines_.

L.S. Rowe, _The United States and Porto Rico_.

F.E. Chadwick, _The Relations of the United States and Spain_.

W.R. Shepherd, _Latin America_; _Central and South America_.


=Questions=

1. Tell the story of the international crisis that developed soon after
the Civil War with regard to Mexico.

2. Give the essential facts relating to the purchase of Alaska.

3. Review the early history of our interest in the Caribbean.

4. Amid what circumstances was the Monroe Doctrine applied in
Cleveland's administration?

5. Give the causes that led to the war with Spain.

6. Tell the leading events in that war.

7. What was the outcome as far as Cuba was concerned? The outcome for
the United States?

8. Discuss the attitude of the Filipinos toward American sovereignty in
the islands.

9. Describe McKinley's colonial policy.

10. How was the Spanish War viewed in England? On the Continent?

11. Was there a unified American opinion on American expansion?

12. Was this expansion a departure from our traditions?

13. What events led to foreign intervention in China?

14. Explain the policy of the "open door."


=Research Topics=

=Hawaii and Venezuela.=--Dewey, _National Problems_ (American Nation
Series), pp. 279-313; Macdonald, _Documentary Source Book_, pp. 600-602;
Hart, _American History Told by Contemporaries_, Vol. IV, pp. 612-616.

=Intervention in Cuba.=--Latane, _America as a World Power_ (American
Nation Series), pp. 3-28; Macdonald, _Documentary Source Book_, pp.
597-598; Roosevelt, _Autobiography_, pp. 223-277; Haworth, _The United
States in Our Own Time_, pp. 232-256; Hart, _Contemporaries_, Vol. IV,
pp. 573-578.

=The War with Spain.=--Elson, _History of the United States_, pp.
889-896.

=Terms of Peace with Spain.=--Latane, pp. 63-81; Macdonald, pp. 602-608;
Hart, _Contemporaries_, Vol. IV, pp. 588-590.

=The Philippine Insurrection.=--Latane, pp. 82-99.

=Imperialism as a Campaign Issue.=--Latane, pp. 120-132; Haworth, pp.
257-277; Hart, _Contemporaries_, Vol. IV, pp. 604-611.

=Biographical Studies.=--William McKinley, M.A. Hanna, John Hay;
Admirals, George Dewey, W.T. Sampson, and W.S. Schley; and Generals,
W.R. Shafter, Joseph Wheeler, and H.W. Lawton.

=General Analysis of American Expansion.=--_Syllabus in History_ (New
York State, 1920), pp. 142-147.




PART VII. PROGRESSIVE DEMOCRACY AND THE WORLD WAR




CHAPTER XXI

THE EVOLUTION OF REPUBLICAN POLICIES (1901-13)


=The Personality and Early Career of Roosevelt.=--On September 14, 1901,
when Theodore Roosevelt took the oath of office, the presidency passed
to a new generation and a leader of a new type recalling, if comparisons
must be made, Andrew Jackson rather than any Republican predecessor.
Roosevelt was brusque, hearty, restless, and fond of action--"a young
fellow of infinite dash and originality," as John Hay remarked of him;
combining the spirit of his old college, Harvard, with the breezy
freedom of the plains; interested in everything--a new species of game,
a new book, a diplomatic riddle, or a novel theory of history or
biology. Though only forty-three years old he was well versed in the art
of practical politics. Coming upon the political scene in the early
eighties, he had associated himself with the reformers in the Republican
party; but he was no Mugwump. From the first he vehemently preached the
doctrine of party loyalty; if beaten in the convention, he voted the
straight ticket in the election. For twenty years he adhered to this
rule and during a considerable portion of that period he held office as
a spokesman of his party. He served in the New York legislature, as head
of the metropolitan police force, as federal civil service commissioner
under President Harrison, as assistant secretary of the navy under
President McKinley, and as governor of the Empire state. Political
managers of the old school spoke of him as "brilliant but erratic"; they
soon found him equal to the shrewdest in negotiation and action.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

ROOSEVELT TALKING TO THE ENGINEER OF A RAILROAD TRAIN]


FOREIGN AFFAIRS

=The Panama Canal.=--The most important foreign question confronting
President Roosevelt on the day of his inauguration, that of the Panama
Canal, was a heritage from his predecessor. The idea of a water route
across the isthmus, long a dream of navigators, had become a living
issue after the historic voyage of the battleship _Oregon_ around South
America during the Spanish War. But before the United States could act
it had to undo the Clayton-Bulwer treaty, made with Great Britain in
1850, providing for the construction of the canal under joint
supervision. This was finally effected by the Hay-Pauncefote treaty of
1901 authorizing the United States to proceed alone, on condition that
there should be no discriminations against other nations in the matter
of rates and charges.

This accomplished, it was necessary to decide just where the canal
should be built. One group in Congress favored the route through
Nicaragua; in fact, two official commissions had already approved that
location. Another group favored cutting the way through Panama after
purchasing the rights of the old French company which, under the
direction of De Lesseps, the hero of the Suez Canal, had made a costly
failure some twenty years before. After a heated argument over the
merits of the two plans, preference was given to the Panama route. As
the isthmus was then a part of Colombia, President Roosevelt proceeded
to negotiate with the government at Bogota a treaty authorizing the
United States to cut a canal through its territory. The treaty was
easily framed, but it was rejected by the Colombian senate, much to the
President's exasperation. "You could no more make an agreement with the
Colombian rulers," he exclaimed, "than you could nail jelly to a wall."
He was spared the necessity by a timely revolution. On November 3, 1903,
Panama renounced its allegiance to Colombia and three days later the
United States recognized its independence.

[Illustration: _Courtesy of Panama Canal, Washington, D.C._

DEEPEST EXCAVATED PORTION OF PANAMA CANAL, SHOWING GOLD HILL ON
RIGHT AND CONTRACTOR'S HILL ON LEFT. JUNE, 1913]

This amazing incident was followed shortly by the signature of a treaty
between Panama and the United States in which the latter secured the
right to construct the long-discussed canal, in return for a guarantee
of independence and certain cash payments. The rights and property of
the French concern were then bought, and the final details settled. A
lock rather than a sea-level canal was agreed upon. Construction by the
government directly instead of by private contractors was adopted.
Scientific medicine was summoned to stamp out the tropical diseases
that had made Panama a plague spot. Finally, in 1904, as the President
said, "the dirt began to fly." After surmounting formidable
difficulties--engineering, labor, and sanitary--the American forces in
1913 joined the waters of the Atlantic and the Pacific. Nearly eight
thousand miles were cut off the sea voyage from New York to San
Francisco. If any were inclined to criticize President Roosevelt for
the way in which he snapped off negotiations with Colombia and
recognized the Panama revolutionists, their attention was drawn to the
magnificent outcome of the affair. Notwithstanding the treaty with Great
Britain, Congress passed a tolls bill discriminating in rates in favor
of American ships. It was only on the urgent insistence of President
Wilson that the measure was later repealed.

=The Conclusion of the Russo-Japanese War.=--The applause which greeted
the President's next diplomatic stroke was unmarred by censure of any
kind. In the winter of 1904 there broke out between Japan and Russia a
terrible conflict over the division of spoils in Manchuria. The fortunes
of war were with the agile forces of Nippon. In this struggle, it seems,
President Roosevelt's sympathies were mainly with the Japanese, although
he observed the proprieties of neutrality. At all events, Secretary Hay
wrote in his diary on New Year's Day, 1905, that the President was
"quite firm in his view that we cannot permit Japan to be robbed a
second time of her victory," referring to the fact that Japan, ten years
before, after defeating China on the field of battle, had been forced by
Russia, Germany, and France to forego the fruits of conquest.

Whatever the President's personal feelings may have been, he was aware
that Japan, despite her triumphs over Russia, was staggering under a
heavy burden of debt. At a suggestion from Tokyo, he invited both
belligerents in the summer of 1905 to join in a peace conference. The
celerity of their reply was aided by the pressure of European bankers,
who had already come to a substantial agreement that the war must stop.
After some delay, Portsmouth, New Hampshire, was chosen as the meeting
place for the spokesmen of the two warring powers. Roosevelt presided
over the opening ceremonies with fine urbanity, thoroughly enjoying the
justly earned honor of being for the moment at the center of the world's
interest. He had the satisfaction of seeing the conference end in a
treaty of peace and amity.

=The Monroe Doctrine Applied to Germany.=--Less spectacular than the
Russo-Japanese settlement but not less important was a diplomatic
passage-at-arms with Germany over the Monroe Doctrine. This clash grew
out of the inability or unwillingness of the Venezuelan government to
pay debts due foreign creditors. Having exhausted their patience in
negotiations, England and Germany, in December 1901, sent battleships to
establish what they characterized as "a peaceful blockade" of Venezuelan
ports. Their action was followed by the rupture of diplomatic relations;
there was a possibility that war and the occupation of Venezuelan
territory might result.

While unwilling to stand between a Latin-American country and its
creditors, President Roosevelt was determined that debt collecting
should not be made an excuse for European countries to seize territory.
He therefore urged arbitration of the dispute, winning the assent of
England and Italy. Germany, with a somewhat haughty air, refused to take
the milder course. The President, learning of this refusal, called the
German ambassador to the White House and informed him in very precise
terms that, unless the Imperial German Government consented to
arbitrate, Admiral Dewey would be ordered to the scene with instructions
to prevent Germany from seizing any Venezuelan territory. A week passed
and no answer came from Berlin. Not baffled, the President again took
the matter up with the ambassador, this time with even more firmness; he
stated in language admitting of but one meaning that, unless within
forty-eight hours the Emperor consented to arbitration, American
battleships, already coaled and cleared, would sail for Venezuelan
waters. The hint was sufficient. The Kaiser accepted the proposal and
the President, with the fine irony of diplomacy, complimented him
publicly on "being so stanch an advocate of arbitration." In terms of
the Monroe Doctrine this action meant that the United States, while not
denying the obligations of debtors, would not permit any move on the
part of European powers that might easily lead to the temporary or
permanent occupation of Latin-American territory.

=The Santo Domingo Affair.=--The same issue was involved in a
controversy over Santo Domingo which arose in 1904. The Dominican
republic, like Venezuela, was heavily in debt, and certain European
countries declared that, unless the United States undertook to look
after the finances of the embarrassed debtor, they would resort to armed
coercion. What was the United States to do? The danger of having some
European power strongly intrenched in Santo Domingo was too imminent to
be denied. President Roosevelt acted with characteristic speed, and
notwithstanding strong opposition in the Senate was able, in 1907, to
effect a treaty arrangement which placed Dominican finances under
American supervision.

In the course of the debate over this settlement, a number of
interesting questions arose. It was pertinently asked whether the
American navy should be used to help creditors collect their debts
anywhere in Latin-America. It was suggested also that no sanction should
be given to the practice among European governments of using armed force
to collect private claims. Opponents of President Roosevelt's policy,
and they were neither few nor insignificant, urged that such matters
should be referred to the Hague Court or to special international
commissions for arbitration. To this the answer was made that the United
States could not surrender any question coming under the terms of the
Monroe Doctrine to the decision of an international tribunal. The
position of the administration was very clearly stated by President
Roosevelt himself. "The country," he said, "would certainly decline to
go to war to prevent a foreign government from collecting a just debt;
on the other hand, it is very inadvisable to permit any foreign power to
take possession, even temporarily, of the customs houses of an American
republic in order to enforce the payment of its obligations; for such a
temporary occupation might turn into a permanent occupation. The only
escape from these alternatives may at any time be that we must
ourselves undertake to bring about some arrangement by which so much as
possible of a just obligation shall be paid." The Monroe Doctrine was
negative. It denied to European powers a certain liberty of operation in
this hemisphere. The positive obligations resulting from its application
by the United States were points now emphasized and developed.

=The Hague Conference.=--The controversies over Latin-American relations
and his part in bringing the Russo-Japanese War to a close naturally
made a deep impression upon Roosevelt, turning his mind in the direction
of the peaceful settlement of international disputes. The subject was
moreover in the air. As if conscious of impending calamity, the
statesmen of the Old World, to all outward signs at least, seemed
searching for a way to reduce armaments and avoid the bloody and costly
trial of international causes by the ancient process of battle. It was
the Czar, Nicholas II, fated to die in one of the terrible holocausts
which he helped to bring upon mankind, who summoned the delegates of the
nations in the first Hague Peace Conference in 1899. The conference did
nothing to reduce military burdens or avoid wars but it did recognize
the right of friendly nations to offer the services of mediation to
countries at war and did establish a Court at the Hague for the
arbitration of international disputes.

Encouraged by this experiment, feeble as it was, President Roosevelt in
1904 proposed a second conference, yielding to the Czar the honor of
issuing the call. At this great international assembly, held at the
Hague in 1907, the representatives of the United States proposed a plan
for the compulsory arbitration of certain matters of international
dispute. This was rejected with contempt by Germany. Reduction of
armaments, likewise proposed in the conference, was again deferred. In
fact, nothing was accomplished beyond agreement upon certain rules for
the conduct of "civilized warfare," casting a somewhat lurid light upon
the "pacific" intentions of most of the powers assembled.

=The World Tour of the Fleet.=--As if to assure the world then that the
United States placed little reliance upon the frail reed of peace
conferences, Roosevelt the following year (1908) made an imposing
display of American naval power by sending a fleet of sixteen
battleships on a tour around the globe. On his own authority, he ordered
the ships to sail out of Hampton Roads and circle the earth by way of
the Straits of Magellan, San Francisco, Australia, the Philippines,
China, Japan, and the Suez Canal. This enterprise was not, as some
critics claimed, a "mere boyish flourish." President Roosevelt knew how
deep was the influence of sea power on the fate of nations. He was aware
that no country could have a wide empire of trade and dominion without
force adequate to sustain it. The voyage around the world therefore
served a double purpose. It interested his own country in the naval
program of the government, and it reminded other powers that the
American giant, though quiet, was not sleeping in the midst of
international rivalries.


COLONIAL ADMINISTRATION

=A Constitutional Question Settled.=--In colonial administration, as in
foreign policy, President Roosevelt advanced with firm step in a path
already marked out. President McKinley had defined the principles that
were to control the development of Porto Rico and the Philippines. The
Republican party had announced a program of pacification, gradual
self-government, and commercial improvement. The only remaining question
of importance, to use the popular phrase,--"Does the Constitution follow
the flag?"--had been answered by the Supreme Court of the United States.
Although it was well known that the Constitution did not contemplate the
government of dependencies, such as the Philippines and Porto Rico, the
Court, by generous and ingenious interpretations, found a way for
Congress to apply any reasonable rules required by the occasion.

=Porto Rico.=--The government of Porto Rico was a relatively simple
matter. It was a single island with a fairly homogeneous population
apart from the Spanish upper class. For a time after military occupation
in 1898, it was administered under military rule. This was succeeded by
the establishment of civil government under the "organic act" passed by
Congress in 1900. The law assured to the Porto Ricans American
protection but withheld American citizenship--a boon finally granted in
1917. It provided for a governor and six executive secretaries appointed
by the President with the approval of the Senate; and for a legislature
of two houses--one elected by popular native vote, and an upper chamber
composed of the executive secretaries and five other persons appointed
in the same manner. Thus the United States turned back to the provincial
system maintained by England in Virginia or New York in old colonial
days. The natives were given a voice in their government and the power
of initiating laws; but the final word both in law-making and
administration was vested in officers appointed in Washington. Such was
the plan under which the affairs of Porto Rico were conducted by
President Roosevelt. It lasted until the new organic act of 1917.

[Illustration: _Photograph from Underwood and Underwood, N.Y._

A SUGAR MILL, PORTO RICO]

=The Philippines.=--The administration of the Philippines presented far
more difficult questions. The number of islands, the variety of
languages and races, the differences in civilization all combined to
challenge the skill of the government. Moreover, there was raging in
1901 a stubborn revolt against American authority, which had to be
faced. Following the lines laid down by President McKinley, the
evolution of American policy fell into three stages. At first the
islands were governed directly by the President under his supreme
military power. In 1901 a civilian commission, headed by William Howard
Taft, was selected by the President and charged with the government of
the provinces in which order had been restored. Six years later, under
the terms of an organic act, passed by Congress in 1902, the third stage
was reached. The local government passed into the hands of a governor
and commission, appointed by the President and Senate, and a
legislature--one house elected by popular vote and an upper chamber

composed of the commission. This scheme, like that obtaining in Porto
Rico, remained intact until a Democratic Congress under President
Wilson's leadership carried the colonial administration into its fourth
phase by making both houses elective. Thus, by the steady pursuit of a
liberal policy, self-government was extended to the dependencies; but it
encouraged rather than extinguished the vigorous movement among the
Philippine natives for independence.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

MR TAFT IN THE PHILIPPINES]

=Cuban Relations.=--Within the sphere of colonial affairs, Cuba, though
nominally independent, also presented problems to the government at
Washington. In the fine enthusiasm that accompanied the declaration of
war on Spain, Congress, unmindful of practical considerations,
recognized the independence of Cuba and disclaimed "any disposition or
intention to exercise sovereignty, jurisdiction, or control over said
island except for the pacification thereof." In the settlement that
followed the war, however, it was deemed undesirable to set the young
republic adrift upon the stormy sea of international politics without a
guiding hand. Before withdrawing American troops from the island,
Congress, in March, 1901, enacted, and required Cuba to approve, a
series of restrictions known as the Platt amendment, limiting her power
to incur indebtedness, securing the right of the United States to
intervene whenever necessary to protect life and property, and reserving
to the United States coaling stations at certain points to be agreed
upon. The Cubans made strong protests against what they deemed
"infringements of their sovereignty"; but finally with good grace
accepted their fate. Even when in 1906 President Roosevelt landed
American troops in the island to quell a domestic dissension, they
acquiesced in the action, evidently regarding it as a distinct warning
that they should learn to manage their elections in an orderly manner.


THE ROOSEVELT DOMESTIC POLICIES

=Social Questions to the Front.=--From the day of his inauguration to
the close of his service in 1909, President Roosevelt, in messages,
speeches, and interviews, kept up a lively and interesting discussion of
trusts, capital, labor, poverty, riches, lawbreaking, good citizenship,
and kindred themes. Many a subject previously touched upon only by
representatives of the minor and dissenting parties, he dignified by a
careful examination. That he did this with any fixed design or policy in
mind does not seem to be the case. He admitted himself that when he
became President he did not have in hand any settled or far-reaching
plan of social betterment. He did have, however, serious convictions on
general principles. "I was bent upon making the government," he wrote,
"the most efficient possible instrument in helping the people of the
United States to better themselves in every way, politically, socially,
and industrially. I believed with all my heart in real and
thorough-going democracy and I wished to make the democracy industrial
as well as political, although I had only partially formulated the
method I believed we should follow." It is thus evident at least that he
had departed a long way from the old idea of the government as nothing
but a great policeman keeping order among the people in a struggle over
the distribution of the nation's wealth and resources.

=Roosevelt's View of the Constitution.=--Equally significant was
Roosevelt's attitude toward the Constitution and the office of
President. He utterly repudiated the narrow construction of our national
charter. He held that the Constitution "should be treated as the
greatest document ever devised by the wit of man to aid a people in
exercising every power necessary for its own betterment, not as a
strait-jacket cunningly fashioned to strangle growth." He viewed the
presidency as he did the Constitution. Strict constructionists of the
Jeffersonian school, of whom there were many on occasion even in the
Republican party, had taken a view that the President could do nothing
that he was not specifically authorized by the Constitution to do.
Roosevelt took exactly the opposite position. It was his opinion that it
was not only the President's right but his duty "to do anything that the
needs of the nation demanded unless such action was forbidden by the
Constitution or the laws." He went on to say that he acted "for the
common well-being of all our people whenever and in whatever manner was
necessary, unless prevented by direct constitutional or legislative
prohibition."

=The Trusts and Railways.=--To the trust question, Roosevelt devoted
especial attention. This was unavoidable. By far the larger part of the
business of the country was done by corporations as distinguished from
partnerships and individual owners. The growth of these gigantic
aggregations of capital had been the leading feature in American
industrial development during the last two decades of the nineteenth
century. In the conquest of business by trusts and "the resulting
private fortunes of great magnitude," the Populists and the Democrats
had seen a grievous danger to the republic. "Plutocracy has taken the
place of democracy; the tariff breeds trusts; let us destroy therefore
the tariff and the trusts"--such was the battle cry which had been taken
up by Bryan and his followers.

President Roosevelt countered vigorously. He rejected the idea that the
trusts were the product of the tariff or of governmental action of any
kind. He insisted that they were the outcome of "natural economic
forces": (1) destructive competition among business men compelling them
to avoid ruin by cooperation in fixing prices; (2) the growth of markets
on a national scale and even international scale calling for vast
accumulations of capital to carry on such business; (3) the possibility
of immense savings by the union of many plants under one management. In
the corporation he saw a new stage in the development of American
industry. Unregulated competition he regarded as "the source of evils
which all men concede must be remedied if this civilization of ours is
to survive." The notion, therefore, that these immense business concerns
should be or could be broken up by a decree of law, Roosevelt considered
absurd.

At the same time he proposed that "evil trusts" should be prevented from
"wrong-doing of any kind"; that is, punished for plain swindling, for
making agreements to limit output, for refusing to sell to customers who
dealt with rival firms, and for conspiracies with railways to ruin
competitors by charging high freight rates and for similar abuses.
Accordingly, he proposed, not the destruction of the trusts, but their
regulation by the government. This, he contended, would preserve the
advantages of business on a national scale while preventing the evils
that accompanied it. The railway company he declared to be a public
servant. "Its rates should be just to and open to all shippers alike."
So he answered those who thought that trusts and railway combinations
were private concerns to be managed solely by their owners without let
or hindrance and also those who thought trusts and railway combinations
could be abolished by tariff reduction or criminal prosecution.

=The Labor Question.=--On the labor question, then pressing to the front
in public interest, President Roosevelt took advanced ground for his
time. He declared that the working-man, single-handed and empty-handed,
threatened with starvation if unemployed, was no match for the employer
who was able to bargain and wait. This led him, accordingly, to accept
the principle of the trade union; namely, that only by collective
bargaining can labor be put on a footing to measure its strength equally
with capital. While he severely arraigned labor leaders who advocated
violence and destructive doctrines, he held that "the organization of
labor into trade unions and federations is necessary, is beneficent, and
is one of the greatest possible agencies in the attainment of a true
industrial, as well as a true political, democracy in the United
States." The last resort of trade unions in labor disputes, the strike,
he approved in case negotiations failed to secure "a fair deal."

He thought, however, that labor organizations, even if wisely managed,
could not solve all the pressing social questions of the time. The aid
of the government at many points he believed to be necessary to
eliminate undeserved poverty, industrial diseases, unemployment, and the
unfortunate consequences of industrial accidents. In his first message
of 1901, for instance, he urged that workers injured in industry should
have certain and ample compensation. From time to time he advocated
other legislation to obtain what he called "a larger measure of social
and industrial justice."

=Great Riches and Taxation.=--Even the challenge of the radicals, such
as the Populists, who alleged that "the toil of millions is boldly
stolen to build up colossal fortunes for a few"--challenges which his
predecessors did not consider worthy of notice--President Roosevelt
refused to let pass without an answer. In his first message he denied
the truth of the common saying that the rich were growing richer and the
poor were growing poorer. He asserted that, on the contrary, the average
man, wage worker, farmer, and small business man, was better off than
ever before in the history of our country. That there had been abuses in
the accumulation of wealth he did not pretend to ignore, but he believed
that even immense fortunes, on the whole, represented positive benefits
conferred upon the country. Nevertheless he felt that grave dangers to
the safety and the happiness of the people lurked in great inequalities
of wealth. In 1906 he wrote that he wished it were in his power to
prevent the heaping up of enormous fortunes. The next year, to the
astonishment of many leaders in his own party, he boldly announced in a
message to Congress that he approved both income and inheritance taxes,
then generally viewed as Populist or Democratic measures. He even took
the stand that such taxes should be laid in order to bring about a more
equitable distribution of wealth and greater equality of opportunity
among citizens.


LEGISLATIVE AND EXECUTIVE ACTIVITIES

=Economic Legislation.=--When President Roosevelt turned from the field
of opinion he found himself in a different sphere. Many of his views
were too advanced for the members of his party in Congress, and where
results depended upon the making of new laws, his progress was slow.
Nevertheless, in his administrations several measures were enacted that
bore the stamp of his theories, though it could hardly be said that he
dominated Congress to the same degree as did some other Presidents. The
Hepburn Railway Act of 1906 enlarged the interstate commerce commission;
it extended the commission's power over oil pipe lines, express
companies, and other interstate carriers; it gave the commission the
right to reduce rates found to be unreasonable and discriminatory; it
forbade "midnight tariffs," that is, sudden changes in rates favoring
certain shippers; and it prohibited common carriers from transporting
goods owned by themselves, especially coal, except for their own proper
use. Two important pure food and drug laws, enacted during the same
year, were designed to protect the public against diseased meats and
deleterious foods and drugs. A significant piece of labor legislation
was an act of the same Congress making interstate railways liable to
damages for injuries sustained by their employees. When this measure was
declared unconstitutional by the Supreme Court it was reenacted with the
objectionable clauses removed. A second installment of labor legislation
was offered in the law of 1908 limiting the hours of railway employees
engaged as trainmen or telegraph operators.

[Illustration: _Courtesy United States Reclamation Service._

THE ROOSEVELT DAM, PHOENIX, ARIZONA]

=Reclamation and Conservation.=--The open country--the deserts, the
forests, waterways, and the public lands--interested President Roosevelt
no less than railway and industrial questions. Indeed, in his first
message to Congress he placed the conservation of natural resources
among "the most vital internal problems" of the age, and forcibly
emphasized an issue that had been discussed in a casual way since
Cleveland's first administration. The suggestion evoked an immediate
response in Congress. Under the leadership of Senator Newlands, of
Nevada, the Reclamation Act of 1902 was passed, providing for the
redemption of the desert areas of the West. The proceeds from the sale
of public lands were dedicated to the construction of storage dams and
sluiceways to hold water and divert it as needed to the thirsty sands.
Furthermore it was stipulated that the rents paid by water users should
go into a reclamation fund to continue the good work forever.
Construction was started immediately under the terms of the law. Within
seventeen years about 1,600,000 acres had been reclaimed and more than a
million were actually irrigated. In the single year 1918, the crops of
the irrigated districts were valued at approximately $100,000,000.

In his first message, also, President Roosevelt urged the transfer of
all control over national forests to trained men in the Bureau of
Forestry--a recommendation carried out in 1907 when the Forestry Service
was created. In every direction noteworthy advances were made in the
administration of the national domain. The science of forestry was
improved and knowledge of the subject spread among the people. Lands in
the national forest available for agriculture were opened to settlers.
Water power sites on the public domain were leased for a term of years
to private companies instead of being sold outright. The area of the
national forests was enlarged from 43 million acres to 194 million acres
by presidential proclamation--more than 43 million acres being added in
one year, 1907. The men who turned sheep and cattle to graze on the
public lands were compelled to pay a fair rental, much to their
dissatisfaction. Fire prevention work was undertaken in the forests on a
large scale, reducing the appalling, annual destruction of timber.
Millions of acres of coal land, such as the government had been
carelessly selling to mining companies at low figures, were withdrawn
from sale and held until Congress was prepared to enact laws for the
disposition of them in the public interest. Prosecutions were
instituted against men who had obtained public lands by fraud and vast
tracts were recovered for the national domain. An agitation was begun
which bore fruit under the administrations of Taft and Wilson in laws
reserving to the federal government the ownership of coal, water power,
phosphates, and other natural resources while authorizing corporations
to develop them under leases for a period of years.

=The Prosecution of the Trusts.=--As an executive, President Roosevelt
was also a distinct "personality." His discrimination between "good" and
"bad" trusts led him to prosecute some of them with vigor. On his
initiative, the Northern Securities Company, formed to obtain control of
certain great western railways, was dissolved by order of the Supreme
Court. Proceedings were instituted against the American Tobacco Company
and the Standard Oil Company as monopolies in violation of the Sherman
Anti-Trust law. The Sugar Trust was found guilty of cheating the New
York customs house and some of the minor officers were sent to prison.
Frauds in the Post-office Department were uncovered and the offenders
brought to book. In fact hardly a week passed without stirring news of
"wrong doers" and "malefactors" haled into federal courts.

=The Great Coal Strike.=--The Roosevelt theory that the President could
do anything for public welfare not forbidden by the Constitution and the
laws was put to a severe test in 1902. A strike of the anthracite coal
miners, which started in the summer, ran late into the autumn.
Industries were paralyzed for the want of coal; cities were threatened
with the appalling menace of a winter without heat. Governors and mayors
were powerless and appealed for aid. The mine owners rejected the
demands of the men and refused to permit the arbitration of the points
in dispute, although John Mitchell, the leader of the miners, repeatedly
urged it. After observing closely the course affairs, President
Roosevelt made up his mind that the situation was intolerable. He
arranged to have the federal troops, if necessary, take possession of
the mines and operate them until the strike could be settled. He then
invited the contestants to the White House and by dint of hard labor
induced them to accept, as a substitute or compromise, arbitration by a
commission which he appointed. Thus, by stepping outside the
Constitution and acting as the first citizen of the land, President
Roosevelt averted a crisis of great magnitude.

=The Election of 1904.=--The views and measures which he advocated with
such vigor aroused deep hostility within as well as without his party.
There were rumors of a Republican movement to defeat his nomination in
1904 and it was said that the "financial and corporation interests" were
in arms against him. A prominent Republican paper in New York City
accused him of having "stolen Mr. Bryan's thunder," by harrying the
trusts and favoring labor unions. When the Republican convention
assembled in Chicago, however, the opposition disappeared and Roosevelt
was nominated by acclamation.

This was the signal for a change on the part of Democratic leaders. They
denounced the President as erratic, dangerous, and radical and decided
to assume the moderate role themselves. They put aside Mr. Bryan and
selected as their candidate, Judge Alton B. Parker, of New York, a man

who repudiated free silver and made a direct appeal for the conservative
vote. The outcome of the reversal was astounding. Judge Parker's vote
fell more than a million below that cast for Bryan in 1900; of the 476
electoral votes he received only 140. Roosevelt, in addition to sweeping
the Republican sections, even invaded Democratic territory, carrying the
state of Missouri. Thus vindicated at the polls, he became more
outspoken than ever. His leadership in the party was so widely
recognized that he virtually selected his own successor.


THE ADMINISTRATION OF PRESIDENT TAFT

=The Campaign of 1908.=--Long before the end of his elective term,
President Roosevelt let it be known that he favored as his successor,
William Howard Taft, of Ohio, his Secretary of War. To attain this end
he used every shred of his powerful influence. When the Republican
convention assembled, Mr. Taft easily won the nomination. Though the
party platform was conservative in tone, he gave it a progressive tinge
by expressing his personal belief in the popular election of United
States Senators, an income tax, and other liberal measures. President
Roosevelt announced his faith in the Republican candidate and appealed
to the country for his election.

The turn in Republican affairs now convinced Mr. Bryan that the signs
were propitious for a third attempt to win the presidency. The disaster
to Judge Parker had taught the party that victory did not lie in a
conservative policy. With little difficulty, therefore, the veteran
leader from Nebraska once more rallied the Democrats around his
standard, won the nomination, and wrote a platform vigorously attacking
the tariff, trusts, and monopolies. Supported by a loyal following, he
entered the lists, only to meet another defeat. Though he polled almost
a million and a half more votes than did Judge Parker in 1904, the palm
went to Mr. Taft.

=The Tariff Revision and Party Dissensions.=--At the very beginning of
his term, President Taft had to face the tariff issue. He had met it in
the campaign. Moved by the Democratic demand for a drastic reduction, he
had expressed opinions which were thought to imply a "downward
revision." The Democrats made much of the implication and the
Republicans from the Middle West rejoiced in it. Pressure was coming
from all sides. More than ten years had elapsed since the enactment of
the Dingley bill and the position of many industries had been altered
with the course of time. Evidently the day for revision--at best a
thankless task--had arrived. Taft accepted the inevitable and called
Congress in a special session. Until the midsummer of 1909, Republican
Senators and Representatives wrangled over tariff schedules, the
President making little effort to influence their decisions. When on
August 5 the Payne-Aldrich bill became a law, a breach had been made in
Republican ranks. Powerful Senators from the Middle West had spoken
angrily against many of the high rates imposed by the bill. They had
even broken with their party colleagues to vote against the entire
scheme of tariff revision.

=The Income Tax Amendment.=--The rift in party harmony was widened by
another serious difference of opinion. During the debate on the tariff
bill, there was a concerted movement to include in it an income tax
provision--this in spite of the decision of the Supreme Court in 1895
declaring it unconstitutional. Conservative men were alarmed by the
evident willingness of some members to flout a solemn decree of that
eminent tribunal. At the same time they saw a powerful combination of
Republicans and Democrats determined upon shifting some of the burden of
taxation to large incomes. In the press of circumstances, a compromise
was reached. The income tax bill was dropped for the present; but
Congress passed the sixteenth amendment to the Constitution, authorizing
taxes upon incomes from whatever source they might be derived, without
reference to any apportionment among the states on the basis of
population. The states ratified the amendment and early in 1913 it was
proclaimed.

=President Taft's Policies.=--After the enactment of the tariff bill,
Taft continued to push forward with his legislative program. He
recommended, and Congress created, a special court of commerce with
jurisdiction, among other things, over appeals from the interstate
commerce commission, thus facilitating judicial review of the railway
rates fixed and the orders issued by that body. This measure was quickly
followed by an act establishing a system of postal savings banks in
connection with the post office--a scheme which had long been opposed by
private banks. Two years later, Congress defied the lobby of the express
companies and supplemented the savings banks with a parcels post system,
thus enabling the American postal service to catch up with that of other
progressive nations. With a view to improving the business
administration of the federal government, the President obtained from
Congress a large appropriation for an economy and efficiency commission
charged with the duty of inquiring into wasteful and obsolete methods
and recommending improved devices and practices. The chief result of
this investigation was a vigorous report in favor of a national budget
system, which soon found public backing.

President Taft negotiated with England and France general treaties
providing for the arbitration of disputes which were "justiciable" in
character even though they might involve questions of "vital interest
and national honor." They were coldly received in the Senate and so
amended that Taft abandoned them altogether. A tariff reciprocity
agreement with Canada, however, he forced through Congress in the face
of strong opposition from his own party. After making a serious breach
in Republican ranks, he was chagrined to see the whole scheme come to
naught by the overthrow of the Liberals in the Canadian elections of
1911.

=Prosecution of the Trusts.=--The party schism was even enlarged by what
appeared to be the successful prosecution of several great combinations.
In two important cases, the Supreme Court ordered the dissolution of the
Standard Oil Company and the American Tobacco Company on the ground that
they violated the Sherman Anti-Trust law. In taking this step Chief
Justice White was at some pains to state that the law did not apply to
combinations which did not "unduly" restrain trade. His remark,
construed to mean that the Court would not interfere with corporations
as such, became the subject of a popular outcry against the President
and the judges.


PROGRESSIVE INSURGENCY AND THE ELECTION OF 1912

=Growing Dissensions.=--All in all, Taft's administration from the first
day had been disturbed by party discord. High words had passed over the
tariff bill and disgruntled members of Congress could not forget them.
To differences over issues were added quarrels between youth and old
age. In the House of Representatives there developed a group of young
"insurgent" Republicans who resented the dominance of the Speaker,
Joseph G. Cannon, and other members of the "old guard," as they named
the men of long service and conservative minds. In 1910, the insurgents
went so far as to join with the Democrats in a movement to break the
Speaker's sway by ousting him from the rules committee and depriving him
of the power to appoint its members. The storm was brewing. In the
autumn of that year the Democrats won a clear majority in the House of
Representatives and began an open battle with President Taft by
demanding an immediate downward revision of the tariff.

=The Rise of the Progressive Republicans.=--Preparatory to the campaign
of 1912, the dissenters within the Republican party added the prefix
"Progressive" to their old title and began to organize a movement to
prevent the renomination of Mr. Taft. As early as January 21, 1911, they
formed a Progressive Republican League at the home of Senator La
Follette of Wisconsin and launched an attack on the Taft measures and
policies. In October they indorsed Mr. La Follette as "the logical
Republican candidate" and appealed to the party for support. The
controversy over the tariff had grown into a formidable revolt against
the occupant of the White House.

=Roosevelt in the Field.=--After looking on for a while, ex-President
Roosevelt took a hand in the fray. Soon after his return in 1910 from a
hunting trip in Africa and a tour in Europe, he made a series of
addresses in which he formulated a progressive program. In a speech in
Kansas, he favored regulation of the trusts, a graduated income tax
bearing heavily on great fortunes, tariff revision schedule by schedule,
conservation of natural resources, labor legislation, the direct
primary, and the recall of elective officials. In an address before the
Ohio state constitutional convention in February, 1912, he indorsed the
initiative and referendum and announced a doctrine known as the "recall
of judicial decisions." This was a new and radical note in American
politics. An ex-President of the United States proposed that the people
at the polls should have the right to reverse the decision of a judge
who set aside any act of a state legislature passed in the interests of
social welfare. The Progressive Republicans, impressed by these
addresses, turned from La Follette to Roosevelt and on February 24,
induced him to come out openly as a candidate against Taft for the
Republican nomination.

=The Split in the Republican Party.=--The country then witnessed the
strange spectacle of two men who had once been close companions engaged
in a bitter rivalry to secure a majority of the delegates to the
Republican convention to be held at Chicago. When the convention
assembled, about one-fourth of the seats were contested, the delegates
for both candidates loudly proclaiming the regularity of their election.
In deciding between the contestants the national committee, after the
usual hearings, settled the disputes in such a way that Taft received a
safe majority. After a week of negotiation, Roosevelt and his followers
left the Republican party. Most of his supporters withdrew from the
convention and the few who remained behind refused to answer the roll
call. Undisturbed by this formidable bolt, the regular Republicans went
on with their work. They renominated Mr. Taft and put forth a platform
roundly condemning such Progressive doctrines as the recall of judges.

=The Formation of the Progressive Party.=--The action of the Republicans
in seating the Taft delegates was vigorously denounced by Roosevelt. He
declared that the convention had no claim to represent the voters of the
Republican party; that any candidate named by it would be "the
beneficiary of a successful fraud"; and that it would be deeply
discreditable to any man to accept the convention's approval under such
circumstances. The bitterness of his followers was extreme. On July 8, a
call went forth for a "Progressive" convention to be held in Chicago on
August 5. The assembly which duly met on that day was a unique political
conference. Prominence was given to women delegates, and "politicians"
were notably absent. Roosevelt himself, who was cheered as a conquering
hero, made an impassioned speech setting forth his "confession of
faith." He was nominated by acclamation; Governor Hiram Johnson of
California was selected as his companion candidate for Vice President.
The platform endorsed such political reforms as woman suffrage, direct
primaries, the initiative, referendum, and recall, popular election of
United States Senators, and the short ballot. It favored a program of
social legislation, including the prohibition of child labor and minimum
wages for women. It approved the regulation, rather than the
dissolution, of the trusts. Like apostles in a new and lofty cause, the
Progressives entered a vigorous campaign for the election of their
distinguished leader.

=Woodrow Wilson and the Election of 1912.=--With the Republicans
divided, victory loomed up before the Democrats. Naturally, a terrific
contest over the nomination occurred at their convention in Baltimore.
Champ Clark, Speaker of the House of Representatives, and Governor
Woodrow Wilson, of New Jersey, were the chief contestants. After tossing
to and fro for seven long, hot days, and taking forty-six ballots, the
delegates, powerfully influenced by Mr. Bryan, finally decided in favor
of the governor. As a professor, a writer on historical and political
subjects, and the president of Princeton University, Mr. Wilson had
become widely known in public life. As the governor of New Jersey he had
attracted the support of the progressives in both parties. With grim
determination he had "waged war on the bosses," and pushed through the
legislature measures establishing direct primaries, regulating public
utilities, and creating a system of workmen's compensation in
industries. During the presidential campaign that followed Governor
Wilson toured the country and aroused great enthusiasm by a series of
addresses later published under the title of _The New Freedom_. He
declared that "the government of the United States is at present the
foster child of the special interests." He proposed to free the country
by breaking the dominance of "the big bankers, the big manufacturers,
the big masters of commerce, the heads of railroad corporations and of
steamship corporations."

In the election Governor Wilson easily secured a majority of the
electoral votes, and his party, while retaining possession of the House
of Representatives, captured the Senate as well. The popular verdict,
however, indicated a state of confusion in the country. The combined
Progressive and Republican vote exceeded that of the Democrats by
1,300,000. The Socialists, with Eugene V. Debs as their candidate again,
polled about 900,000 votes, more than double the number received four
years before. Thus, as the result of an extraordinary upheaval the
Republicans, after holding the office of President for sixteen years,
passed out of power, and the government of the country was intrusted to
the Democrats under the leadership of a man destined to be one of the
outstanding figures of the modern age, Woodrow Wilson.


=General References=

J.B. Bishop, _Theodore Roosevelt and His Time_ (2 vols.).

Theodore Roosevelt, _Autobiography_; _New Nationalism_; _Progressive
Principles_.

W.H. Taft, _Popular Government_.

Walter Weyl, _The New Democracy_.

H. Croly, _The Promise of American Life_.

J.B. Bishop, _The Panama Gateway_.

J.B. Scott, _The Hague Peace Conferences_.

W.B. Munro (ed.), _Initiative, Referendum, and Recall_.

C.R. Van Hise, _The Conservation of Natural Resources_.

Gifford Pinchot, _The Fight for Conservation_.

W.F. Willoughby, _Territories and Dependencies of the United States_
(1905).


=Research Topics=

=Roosevelt and "Big Business."=--Haworth, _The United States in Our Own
Time_, pp. 281-289; F.A. Ogg, _National Progress_ (American Nation
Series), pp. 40-75; Paxson, _The New Nation_ (Riverside Series), pp.
293-307.

=Our Insular Possessions.=--Elson, _History of the United States_, pp.
896-904.

=Latin-American Relations.=--Haworth, pp. 294-299; Ogg, pp. 254-257.

=The Panama Canal.=--Haworth, pp. 300-309; Ogg, pp. 266-277; Paxson, pp.
286-292; Elson, pp. 906-911.

=Conservation.=--Haworth, pp. 331-334; Ogg, pp. 96-115; Beard, _American
Government and Politics_ (3d ed.), pp. 401-416.

=Republican Dissensions under Taft's Administration.=--Haworth, pp.
351-360; Ogg, pp. 167-186; Paxson, pp. 324-342; Elson, pp. 916-924.

=The Campaign of 1912.=--Haworth, pp. 360-379; Ogg, pp. 187-208.


=Questions=

1. Compare the early career of Roosevelt with that of some other
President.

2. Name the chief foreign and domestic questions of the Roosevelt-Taft
administrations.

3. What international complications were involved in the Panama Canal
problem?

4. Review the Monroe Doctrine. Discuss Roosevelt's applications of it.

5. What is the strategic importance of the Caribbean to the United
States?

6. What is meant by the sea power? Trace the voyage of the fleet around
the world and mention the significant imperial and commercial points
touched.

7. What is meant by the question: "Does the Constitution follow the
flag?"

8. Trace the history of self-government in Porto Rico. In the
Philippines.

9. What is Cuba's relation to the United States?

10. What was Roosevelt's theory of our Constitution?

11. Give Roosevelt's views on trusts, labor, taxation.

12. Outline the domestic phases of Roosevelt's administrations.

13. Account for the dissensions under Taft.

14. Trace the rise of the Progressive movement.

15. What was Roosevelt's progressive program?

16. Review Wilson's early career and explain the underlying theory of
_The New Freedom_.




CHAPTER XXII

THE SPIRIT OF REFORM IN AMERICA


AN AGE OF CRITICISM

=Attacks on Abuses in American Life.=--The crisis precipitated by the
Progressive uprising was not a sudden and unexpected one. It had been
long in preparation. The revolt against corruption in politics which
produced the Liberal Republican outbreak in the seventies and the
Mugwump movement of the eighties was followed by continuous criticism of
American political and economic development. From 1880 until his death
in 1892, George William Curtis, as president of the Civil Service Reform
Association, kept up a running fire upon the abuses of the spoils
system. James Bryce, an observant English scholar and man of affairs, in
his great work, _The American Commonwealth_, published in 1888, by
picturing fearlessly the political rings and machines which dominated
the cities, gave the whole country a fresh shock. Six years later Henry
D. Lloyd, in a powerful book entitled _Wealth against Commonwealth_,
attacked in scathing language certain trusts which had destroyed their
rivals and bribed public officials. In 1903 Miss Ida Tarbell, an author
of established reputation in the historical field, gave to the public an
account of the Standard Oil Company, revealing the ruthless methods of
that corporation in crushing competition. About the same time Lincoln
Steffens exposed the sordid character of politics in several
municipalities in a series of articles bearing the painful heading: _The
Shame of the Cities_. The critical spirit appeared in almost every form;
in weekly and monthly magazines, in essays and pamphlets, in editorials
and news stories, in novels like Churchill's _Coniston_ and Sinclair's
_The Jungle_. It became so savage and so wanton that the opening years
of the twentieth century were well named "the age of the muckrakers."

=The Subjects of the Criticism.=--In this outburst of invective, nothing
was spared. It was charged that each of the political parties had fallen
into the hands of professional politicians who devoted their time to
managing conventions, making platforms, nominating candidates, and
dictating to officials; in return for their "services" they sold offices
and privileges. It was alleged that mayors and councils had bargained
away for private benefit street railway and other franchises. It was
asserted that many powerful labor unions were dominated by men who
blackmailed employers. Some critics specialized in descriptions of the
poverty, slums, and misery of great cities. Others took up "frenzied
finance" and accused financiers of selling worthless stocks and bonds to
an innocent public. Still others professed to see in the accumulations
of millionaires the downfall of our republic.

=The Attack on "Invisible Government."=--Some even maintained that the
control of public affairs had passed from the people to a sinister
minority called "the invisible government." So eminent and conservative
a statesman as the Hon. Elihu Root lent the weight of his great name to
such an imputation. Speaking of his native state, New York, he said:
"What is the government of this state? What has it been during the forty
years of my acquaintance with it? The government of the Constitution?
Oh, no; not half the time or half way.... From the days of Fenton and
Conkling and Arthur and Cornell and Platt, from the days of David B.
Hill down to the present time, the government of the state has presented
two different lines of activity: one, of the constitutional and
statutory officers of the state and the other of the party leaders; they
call them party bosses. They call the system--I don't coin the
phrase--the system they call 'invisible government.' For I don't know
how many years Mr. Conkling was the supreme ruler in this state. The
governor did not count, the legislature did not count, comptrollers and
secretaries of state and what not did not count. It was what Mr.
Conkling said, and in a great outburst of public rage he was pulled
down. Then Mr. Platt ruled the state; for nigh upon twenty years he
ruled it. It was not the governor; it was not the legislature; it was
Mr. Platt. And the capital was not here [in Albany]; it was at 49
Broadway; Mr. Platt and his lieutenants. It makes no difference what
name you give, whether you call it Fenton or Conkling or Cornell or
Arthur or Platt or by the names of men now living. The ruler of the
state during the greater part of the forty years of my acquaintance with
the state government has not been any man authorized by the constitution
or by law.... The party leader is elected by no one, accountable to no
one, bound by no oath of office, removable by no one."

=The Nation Aroused.=--With the spirit of criticism came also the spirit
of reform. The charges were usually exaggerated; often wholly false; but
there was enough truth in them to warrant renewed vigilance on the part
of American democracy. President Roosevelt doubtless summed up the
sentiment of the great majority of citizens when he demanded the
punishment of wrong-doers in 1907, saying: "It makes not a particle of
difference whether these crimes are committed by a capitalist or by a
laborer, by a leading banker or manufacturer or railroad man or by a
leading representative of a labor union. Swindling in stocks, corrupting
legislatures, making fortunes by the inflation of securities, by
wrecking railroads, by destroying competitors through rebates--these
forms of wrong-doing in the capitalist are far more infamous than any
ordinary form of embezzlement or forgery." The time had come, he added,
to stop "muckraking" and proceed to the constructive work of removing
the abuses that had grown up.


POLITICAL REFORMS

=The Public Service.=--It was a wise comprehension of the needs of
American democracy that led the friends of reform to launch and to
sustain for more than half a century a movement to improve the public
service. On the one side they struck at the spoils system; at the right
of the politicians to use public offices as mere rewards for partisan
work. The federal civil service act of 1883 opened the way to reform by
establishing five vital principles in law: (1) admission to office, not
on the recommendation of party workers, but on the basis of competitive
examinations; (2) promotion for meritorious service of the government
rather than of parties; (3) no assessment of office holders for campaign
funds; (4) permanent tenure during good behavior; and (5) no dismissals
for political reasons. The act itself at first applied to only 14,000
federal offices, but under the constant pressure from the reformers it
was extended until in 1916 it covered nearly 300,000 employees out of an
executive force of approximately 414,000. While gaining steadily at
Washington, civil service reformers carried their agitation into the
states and cities. By 1920 they were able to report ten states with
civil service commissions and the merit system well intrenched in more
than three hundred municipalities.

In excluding spoilsmen from public office, the reformers were, in a
sense, engaged in a negative work: that of "keeping the rascals out."
But there was a second and larger phase to their movement, one
constructive in character: that of getting skilled, loyal, and efficient
servants into the places of responsibility. Everywhere on land and sea,
in town and country, new burdens were laid upon public officers. They
were called upon to supervise the ships sailing to and from our ports;
to inspect the water and milk supplies of our cities; to construct and
operate great public works, such as the Panama and Erie canals; to
regulate the complicated rates of railway companies; to safeguard health
and safety in a thousand ways; to climb the mountains to fight forest
fires; and to descend into the deeps of the earth to combat the deadly
coal gases that assail the miners. In a word, those who labored to
master the secrets and the powers of nature were summoned to the aid of
the government: chemists, engineers, architects, nurses, surgeons,
foresters--the skilled in all the sciences, arts, and crafts.

Keeping rascals out was no task at all compared with the problem of
finding competent people for all the technical offices. "Now," said the
reformers, "we must make attractive careers in the government work for
the best American talent; we must train those applying for admission and
increase the skill of those already in positions of trust; we must see
to it that those entering at the bottom have a chance to rise to the
top; in short, we must work for a government as skilled and efficient as
it is strong, one commanding all the wisdom and talent of America that
public welfare requires."

=The Australian Ballot.=--A second line of attack on the political
machines was made in connection with the ballot. In the early days
elections were frequently held in the open air and the poll was taken by
a show of hands or by the enrollment of the voters under names of their
favorite candidates. When this ancient practice was abandoned in favor
of the printed ballot, there was still no secrecy about elections. Each
party prepared its own ballot, often of a distinctive color, containing
the names of its candidates. On election day, these papers were handed
out to the voters by party workers. Any one could tell from the color of
the ballot dropped into the box, or from some mark on the outside of the
folded ballot, just how each man voted. Those who bought votes were sure
that their purchases were "delivered." Those who intimidated voters
could know when their intimidation was effective. In this way the party
ballot strengthened the party machine.

As a remedy for such abuses, reformers, learning from the experience of
Australia, urged the adoption of the "Australian ballot." That ballot,
though it appeared in many forms, had certain constant features. It was
official, that is, furnished by the government, not by party workers; it
contained the names of all candidates of all parties; it was given out
only in the polling places; and it was marked in secret. The first state
to introduce it was Massachusetts. The year was 1888. Before the end of
the century it had been adopted by nearly all the states in the union.
The salutary effect of the reform in reducing the amount of cheating
and bribery in elections was beyond all question.

=The Direct Primary.=--In connection with the uprising against machine
politics, came a call for the abolition of the old method of nominating
candidates by conventions. These time-honored party assemblies, which
had come down from the days of Andrew Jackson, were, it was said, merely
conclaves of party workers, sustained by the spoils system, and
dominated by an inner circle of bosses. The remedy offered in this case
was again "more democracy," namely, the abolition of the party
convention and the adoption of the direct primary. Candidates were no
longer to be chosen by secret conferences. Any member of a party was to
be allowed to run for any office, to present his name to his party by
securing signatures to a petition, and to submit his candidacy to his
fellow partisans at a direct primary--an election within the party. In
this movement Governor La Follette of Wisconsin took the lead and his
state was the first in the union to adopt the direct primary for
state-wide purposes. The idea spread, rapidly in the West, more slowly
in the East. The public, already angered against "the bosses," grasped
eagerly at it. Governor Hughes in New York pressed it upon the unwilling
legislature. State after state accepted it until by 1918 Rhode Island,
Delaware, Connecticut, and New Mexico were the only states that had not
bowed to the storm. Still the results were disappointing and at that
very time the pendulum was beginning to swing backward.

=Popular Election of Federal Senators.=--While the movement for direct
primaries was still advancing everywhere, a demand for the popular
election of Senators, usually associated with it, swept forward to
victory. Under the original Constitution, it had been expressly provided
that Senators should be chosen by the legislatures of the states. In
practice this rule transferred the selection of Senators to secret
caucuses of party members in the state legislatures. In connection with
these caucuses there had been many scandals, some direct proofs of
brazen bribery and corruption, and dark hints besides. The Senate was
called by its detractors "a millionaires' club" and it was looked upon
as the "citadel of conservatism." The prescription in this case was
likewise "more democracy"--direct election of Senators by popular vote.

This reform was not a new idea. It had been proposed in Congress as
early as 1826. President Johnson, an ardent advocate, made it the
subject of a special message in 1868 Not long afterward it appeared in
Congress. At last in 1893, the year after the great Populist upheaval,
the House of Representatives by the requisite two-thirds vote
incorporated it in an amendment to the federal Constitution. Again and
again it passed the House; but the Senate itself was obdurate. Able
Senators leveled their batteries against it. Mr. Hoar of Massachusetts
declared that it would transfer the seat of power to the "great cities
and masses of population"; that it would "overthrow the whole scheme of
the Senate and in the end the whole scheme of the national Constitution
as designed and established by the framers of the Constitution and the
people who adopted it."

Failing in the Senate, advocates of popular election made a rear assault
through the states. They induced state legislatures to enact laws
requiring the nomination of candidates for the Senate by the direct
primary, and then they bound the legislatures to abide by the popular
choice. Nevada took the lead in 1899. Shortly afterward Oregon, by the
use of the initiative and referendum, practically bound legislators to
accept the popular nominee and the country witnessed the spectacle of a
Republican legislature "electing" a Democrat to represent the state in
the Senate at Washington. By 1910 three-fourths of the states had
applied the direct primary in some form to the choice of Senators. Men
selected by that method began to pour in upon the floors of Congress;
finally in 1912 the two-thirds majority was secured for an amendment to
the federal Constitution providing for the popular election of Senators.
It was quickly ratified by the states. The following year it was
proclaimed in effect.

=The Initiative and Referendum.=--As a corrective for the evils which
had grown up in state legislatures there arose a demand for the
introduction of a Swiss device known as the initiative and referendum.
The initiative permits any one to draw up a proposed bill; and, on
securing a certain number of signatures among the voters, to require the
submission of the measure to the people at an election. If the bill thus
initiated receives a sufficient majority, it becomes a law. The
referendum allows citizens who disapprove any act passed by the
legislature to get up a petition against it and thus bring about a
reference of the measure to the voters at the polls for approval or
rejection. These two practices constitute a form of "direct government."

These devices were prescribed "to restore the government to the people."
The Populists favored them in their platform of 1896. Mr. Bryan, two
years later, made them a part of his program, and in the same year South
Dakota adopted them. In 1902 Oregon, after a strenuous campaign, added a
direct legislation amendment to the state constitution. Within ten years
all the Southwestern, Mountain, and Pacific states, except Texas and
Wyoming, had followed this example. To the east of the Mississippi,
however, direct legislation met a chilly reception. By 1920 only five
states in this section had accepted it: Maine, Massachusetts, Ohio,
Michigan, and Maryland, the last approving the referendum only.

=The Recall.=--Executive officers and judges, as well as legislatures,
had come in for their share of criticism, and it was proposed that they
should likewise be subjected to a closer scrutiny by the public. For
this purpose there was advanced a scheme known as the recall--which
permitted a certain percentage of the voters to compel any officer, at
any time during his term, to go before the people at a new election.
This feature of direct government, tried out first in the city of Los
Angeles, was extended to state-wide uses in Oregon in 1908. It failed,
however, to capture popular imagination to the same degree as the
initiative and referendum. At the end of ten years' agitation, only ten
states, mainly in the West, had adopted it for general purposes, and
four of them did not apply it to the judges of the courts. Still it was
extensively acclaimed in cities and incorporated into hundreds of
municipal laws and charters.

As a general proposition, direct government in all its forms was
bitterly opposed by men of a conservative cast of mind. It was denounced
by Senator Henry Cabot Lodge as "nothing less than a complete revolution
in the fabric of our government and in the fundamental principles upon
which that government rests." In his opinion, it promised to break down
the representative principle and "undermine and overthrow the bulwarks
of ordered liberty and individual freedom." Mr. Taft shared Mr. Lodge's
views and spoke of direct government with scorn. "Votes," he exclaimed,
"are not bread ... referendums do not pay rent or furnish houses,
recalls do not furnish clothes, initiatives do not supply employment or
relieve inequalities of condition or of opportunity."

=Commission Government for Cities.=--In the restless searching out of
evils, the management of cities early came under critical scrutiny. City
government, Mr. Bryce had remarked, was the one conspicuous failure in
America. This sharp thrust, though resented by some, was accepted as a
warning by others. Many prescriptions were offered by doctors of the
body politic. Chief among them was the idea of simplifying the city
government so that the light of public scrutiny could shine through it.
"Let us elect only a few men and make them clearly responsible for the
city government!" was the new cry in municipal reform. So, many city
councils were reduced in size; one of the two houses, which several
cities had adopted in imitation of the federal government, was
abolished; and in order that the mayor could be held to account, he was
given the power to appoint all the chief officials. This made the mayor,
in some cases, the only elective city official and gave the voters a
"short ballot" containing only a few names--an idea which some proposed
to apply also to the state government.

A further step in the concentration of authority was taken in Galveston,
Texas, where the people, looking upon the ruin of their city wrought by
the devastating storm of 1901, and confronted by the difficult problems
of reconstruction, felt the necessity for a more businesslike management
of city affairs and instituted a new form of local administration. They
abolished the old scheme of mayor and council and vested all power in
five commissioners, one of whom, without any special prerogatives, was
assigned to the office of "mayor president." In 1908, the commission
form of government, as it was soon characterized, was adopted by Des
Moines, Iowa. The attention of all municipal reformers was drawn to it
and it was hailed as the guarantee of a better day. By 1920, more than
four hundred cities, including Memphis, Spokane, Birmingham, Newark, and
Buffalo, had adopted it. Still the larger cities like New York and
Chicago kept their boards of aldermen.

=The City Manager Plan.=--A few years' experience with commission
government revealed certain patent defects. The division of the work
among five men was frequently found to introduce dissensions and
irresponsibility. Commissioners were often lacking in the technical
ability required to manage such difficult matters as fire and police
protection, public health, public works, and public utilities. Some one
then proposed to carry over into city government an idea from the
business world. In that sphere the stockholders of each corporation
elect the directors and the directors, in turn, choose a business
manager to conduct the affairs of the company. It was suggested that the
city commissioners, instead of attempting to supervise the details of
the city administration, should select a manager to do this. The scheme
was put into effect in Sumter, South Carolina, in 1912. Like the
commission plan, it became popular. Within eight years more than one
hundred and fifty towns and cities had adopted it. Among the larger
municipalities were Dayton, Springfield (Ohio), Akron, Kalamazoo, and
Phoenix. It promised to create a new public service profession, that of
city manager.


MEASURES OF ECONOMIC REFORM

=The Spirit of American Reform.=--The purification of the ballot, the
restriction of the spoils system, the enlargement of direct popular
control over the organs of government were not the sole answers made by
the reformers to the critics of American institutions. Nor were they the
most important. In fact, they were regarded not as ends in themselves,
but as means to serve a wider purpose. That purpose was the promotion of
the "general welfare." The concrete objects covered by that broad term
were many and varied; but they included the prevention of extortion by
railway and other corporations, the protection of public health, the
extension of education, the improvement of living conditions in the
cities, the elimination of undeserved poverty, the removal of gross
inequalities in wealth, and more equality of opportunity.

All these things involved the use of the powers of government. Although
a few clung to the ancient doctrine that the government should not
interfere with private business at all, the American people at large
rejected that theory as vigorously as they rejected the doctrines of an
extreme socialism which exalts the state above the individual. Leaders
representing every shade of opinion proclaimed the government an
instrument of common welfare to be used in the public interest. "We must
abandon definitely," said Roosevelt, "the _laissez-faire_ theory of
political economy and fearlessly champion a system of increased
governmental control, paying no attention to the cries of worthy people
who denounce this as socialistic." This view was shared by Mr. Taft, who
observed: "Undoubtedly the government can wisely do much more ... to
relieve the oppressed, to create greater equality of opportunity, to
make reasonable terms for labor in employment, and to furnish vocational
education." He was quick to add his caution that "there is a line beyond
which the government cannot go with any good practical results in
seeking to make men and society better."

=The Regulation of Railways.=--The first attempts to use the government
in a large way to control private enterprise in the public interest were
made by the Northwestern states in the decade between 1870 and 1880.
Charges were advanced by the farmers, particularly those organized into
Granges, that the railways extorted the highest possible rates for
freight and passengers, that favoritism was shown to large shippers,
that fraudulent stocks and bonds were sold to the innocent public. It
was claimed that railways were not like other enterprises, but were
"quasi-public" concerns, like the roads and ferries, and thus subject to
government control. Accordingly laws were enacted bringing the railroads
under state supervision. In some cases the state legislature fixed the
maximum rates to be charged by common carriers, and in other cases
commissions were created with the power to establish the rates after an
investigation. This legislation was at first denounced in the East as
nothing less than the "confiscation" of the railways in the interest of
the farmers. Attempts to have the Supreme Court of the United States
declare it unconstitutional were made without avail; still a principle
was finally laid down to the effect that in fixing rates state
legislatures and commissions must permit railway companies to earn a
"fair" return on the capital invested.

In a few years the Granger spirit appeared in Congress. An investigation
revealed a long list of abuses committed by the railways against
shippers and travelers. The result was the interstate commerce act of
1887, which created the Interstate Commerce Commission, forbade
discriminations in rates, and prohibited other objectionable practices
on the part of railways. This measure was loosely enforced and the
abuses against which it was directed continued almost unabated. A demand
for stricter control grew louder and louder. Congress was forced to
heed. In 1903 it enacted the Elkins law, forbidding railways to charge
rates other than those published, and laid penalties upon the officers
and agents of companies, who granted secret favors to shippers, and upon
shippers who accepted them. Three years later a still more drastic step
was taken by the passage of the Hepburn act. The Interstate Commerce
Commission was authorized, upon complaint of some party aggrieved, and
after a public hearing, to determine whether just and reasonable rates
had been charged by the companies. In effect, the right to fix freight
and passenger rates was taken out of the hands of the owners of the
railways engaged in interstate commerce and vested in the hands of the
Interstate Commerce Commission. Thus private property to the value of
$20,000,000,000 or more was declared to be a matter of public concern
and subject to government regulation in the common interest.

=Municipal Utilities.=--Similar problems arose in connection with the
street railways, electric light plants, and other utilities in the great
cities. In the beginning the right to construct such undertakings was
freely, and often corruptly, granted to private companies by city
councils. Distressing abuses arose in connection with such practices.
Many grants or franchises were made perpetual, or perhaps for a term of
999 years. The rates charged and services rendered were left largely to
the will of the companies holding the franchises. Mergers or unions of
companies were common and the public was deluged with stocks and bonds
of doubtful value; bankruptcies were frequent. The connection between
the utility companies and the politicians was, to say the least, not
always in the public interest.

American ingenuity was quick to devise methods for eliminating such
evils. Three lines of progress were laid out by the reformers. One group
proposed that such utilities should be subject to municipal or state
regulation, that the formation of utility companies should be under
public control, and that the issue of stocks and bonds must be approved
by public authority. In some cases state, and in other cases municipal,
commissions were created to exercise this great power over "quasi-public
corporations." Wisconsin, by laws enacted in 1907, put all heat, light,
water works, telephone, and street railway companies under the
supervision of a single railway commission. Other states followed this
example rapidly. By 1920 the principle of public control over municipal
utilities was accepted in nearly every section of the union.

A second line of reform appeared in the "model franchise" for utility
corporations. An illustration of this tendency was afforded by the
Chicago street railway settlement of 1906. The total capital of the
company was fixed at a definite sum, its earnings were agreed upon, and
the city was given the right to buy and operate the system if it desired
to do so. In many states, about the same time, it was provided that no
franchises to utility companies could run more than twenty-five years.

A third group of reformers were satisfied with nothing short of
municipal ownership. They proposed to drive private companies entirely
out of the field and vest the ownership and management of municipal
plants in the city itself. This idea was extensively applied to electric
light and water works plants, but to street railways in only a few
cities, including San Francisco and Seattle. In New York the subways are
owned by the city but leased for operation.

=Tenement House Control.=--Among the other pressing problems of the
cities was the overcrowding in houses unfit for habitation. An inquiry
in New York City made under the authority of the state in 1902 revealed
poverty, misery, slums, dirt, and disease almost beyond imagination. The
immediate answer was the enactment of a tenement house law prescribing
in great detail the size of the rooms, the air space, the light and the
sanitary arrangement for all new buildings. An immense improvement
followed and the idea was quickly taken up in other states having large
industrial centers. In 1920 New York made a further invasion of the
rights of landlords by assuring to the public "reasonable rents" for
flats and apartments.

=Workmen's Compensation.=--No small part of the poverty in cities was
due to the injury of wage-earners while at their trade. Every year the
number of men and women killed or wounded in industry mounted higher.
Under the old law, the workman or his family had to bear the loss unless
the employer had been guilty of some extraordinary negligence. Even in
that case an expensive lawsuit was usually necessary to recover
"damages." In short, although employers insured their buildings and
machinery against necessary risks from fire and storm, they allowed
their employees to assume the heavy losses due to accidents. The
injustice of this, though apparent enough now, was once not generally
recognized. It was said to be unfair to make the employer pay for
injuries for which he was not personally responsible; but the argument
was overborne.

[Illustration: AN EAST SIDE STREET IN NEW YORK]

About 1910 there set in a decided movement in the direction of lifting
the burden of accidents from the unfortunate victims. In the first
place, laws were enacted requiring employers to pay damages in certain
amounts according to the nature of the case, no matter how the accident
occurred, as long as the injured person was not guilty of willful
negligence. By 1914 more than one-half the states had such laws. In the
second place, there developed schemes of industrial insurance in the
form of automatic grants made by state commissions to persons injured in
industries, the funds to be provided by the employers or the state or by
both. By 1917 thirty-six states had legislation of this type.

=Minimum Wages and Mothers' Pensions.=--Another source of poverty,
especially among women and children, was found to be the low wages paid
for their labor. Report after report showed this. In 1912 Massachusetts
took a significant step in the direction of declaring the minimum wages
which might be paid to women and children. Oregon, the following year,
created a commission with power to prescribe minimum wages in certain
industries, based on the cost of living, and to enforce the rates fixed.
Within a short time one-third of the states had legislation of this
character. To cut away some of the evils of poverty and enable widows to
keep their homes intact and bring up their children, a device known as
mothers' pensions became popular during the second decade of the
twentieth century. At the opening of 1913 two states, Colorado and
Illinois, had laws authorizing the payment from public funds of definite
sums to widows with children. Within four years, thirty-five states had
similar legislation.

=Taxation and Great Fortunes.=--As a part of the campaign waged against
poverty by reformers there came a demand for heavy taxes upon great
fortunes, particularly taxes upon inheritances or estates passing to
heirs on the decease of the owners. Roosevelt was an ardent champion of
this type of taxation and dwelt upon it at length in his message to
Congress in 1907. "Such a tax," he said, "would help to preserve a
measurable equality of opportunity for the people of the generations
growing to manhood.... Our aim is to recognize what Lincoln pointed out:
the fact that there are some respects in which men are obviously not
equal; but also to insist that there should be equality of self-respect
and of mutual respect, an equality of rights before the law, and at
least an approximate equality in the conditions under which each man
obtains the chance to show the stuff that is in him when compared with
his fellows."

The spirit of the new age was, therefore, one of reform, not of
revolution. It called for no evolutionary or utopian experiments, but
for the steady and progressive enactment of measures aimed at admitted
abuses and designed to accomplish tangible results in the name of public
welfare.


=General References=

J. Bryce, _The American Commonwealth_.

R.C. Brooks, _Corruption in American Life_.

E.A. Ross, _Changing America_.

P.L. Haworth, _America in Ferment_.

E.R.A. Seligman, _The Income Tax_.

W.Z. Ripley, _Railroads: Rates and Regulation_.

E.S. Bradford, _Commission Government in American Cities_.

H.R. Seager, _A Program of Social Reform_.

C. Zueblin, _American Municipal Progress_.

W.E. Walling, _Progressivism and After_.

_The American Year Book_ (an annual publication which contains reviews
of reform legislation).


=Research Topics=

="The Muckrakers."=--Paxson, _The New Nation_ (Riverside Series), pp.
309-323.

=Civil Service Reform.=--Beard, _American Government and Politics_ (3d
ed.), pp. 222-230; Ogg, _National Progress_ (American Nation Series),
pp. 135-142.

=Direct Government.=--Beard, _American Government_, pp. 461-473; Ogg,
pp. 160-166.

=Popular Election of Senators.=--Beard, _American Government_, pp.
241-244; Ogg, pp. 149-150.

=Party Methods.=--Beard, _American Government_, pp. 656-672.

=Ballot Reform.=--Beard, _American Government_, pp. 672-705.

=Social and Economic Legislation.=--Beard, _American Government_, pp.
721-752.


=Questions=

1. Who were some of the critics of abuses in American life?

2. What particular criticisms were advanced?

3. How did Elihu Root define "invisible government"?

4. Discuss the use of criticism as an aid to progress in a democracy.

5. Explain what is meant by the "merit system" in the civil service.
Review the rise of the spoils system.

6. Why is the public service of increasing importance? Give some of its
new problems.

7. Describe the Australian ballot and the abuses against which it is
directed.

8. What are the elements of direct government? Sketch their progress in
the United States.

9. Trace the history of popular election of Senators.

10. Explain the direct primary. Commission government. The city manager
plan.

11. How does modern reform involve government action? On what theory is
it justified?

12. Enumerate five lines of recent economic reform.




CHAPTER XXIII

THE NEW POLITICAL DEMOCRACY


=Women in Public Affairs.=--The social legislation enacted in response
to the spirit of reform vitally affected women in the home and in
industry and was promoted by their organizations. Where they did not
lead, they were affiliated with movements for social improvement. No
cause escaped their attention; no year passed without widening the range
of their interests. They served on committees that inquired into the
problems of the day; they appeared before legislative assemblies to
advocate remedies for the evils they discovered. By 1912 they were a
force to be reckoned with in national politics. In nine states complete
and equal suffrage had been established, and a widespread campaign for a
national suffrage amendment was in full swing. On every hand lay
evidences that their sphere had been broadened to include public
affairs. This was the culmination of forces that had long been
operating.

=A New Emphasis in History.=--A movement so deeply affecting important
interests could not fail to find a place in time in the written record
of human progress. History often began as a chronicle of kings and
queens, knights and ladies, written partly to amuse and partly to
instruct the classes that appeared in its pages. With the growth of
commerce, parliaments, and international relations, politics and
diplomacy were added to such chronicles of royal and princely doings.
After the rise of democracy, industry, and organized labor, the
transactions of everyday life were deemed worthy of a place in the pages
of history. In each case history was rewritten and the past rediscovered
in the light of the new age. So it will be with the rise and growth of
women's political power. The history of their labor, their education,
their status in society, their influence on the course of events will be
explored and given its place in the general record.

It will be a history of change. The superior position which women enjoy
in America to-day is the result of a slow evolution from an almost
rightless condition in colonial times. The founders of America brought
with them the English common law. Under that law, a married woman's
personal property--jewels, money, furniture, and the like--became her
husband's property; the management of her lands passed into his control.
Even the wages she earned, if she worked for some one else, belonged to
him. Custom, if not law, prescribed that women should not take part in
town meetings or enter into public discussions of religious questions.
Indeed it is a far cry from the banishment of Anne Hutchinson from
Massachusetts in 1637, for daring to dispute with the church fathers, to
the political conventions of 1920 in which women sat as delegates, made
nominating speeches, and served on committees. In the contrast between
these two scenes may be measured the change in the privileges of women
since the landing of the Pilgrims. The account of this progress is a
narrative of individual effort on the part of women, of organizations
among them, of generous aid from sympathetic men in the long agitation
for the removal of civil and political disabilities. It is in part also
a narrative of irresistible economic change which drew women into
industry, created a leisure class, gave women wages and incomes, and
therewith economic independence.


THE RISE OF THE WOMAN MOVEMENT

=Protests of Colonial Women.=--The republican spirit which produced
American independence was of slow and steady growth. It did not spring
up full-armed in a single night. It was, on the contrary, nourished
during a long period of time by fireside discussions as well as by
debates in the public forum. Women shared that fireside sifting of
political principles and passed on the findings of that scrutiny in
letters to their friends, newspaper articles, and every form of written
word. How widespread was this potent, though not spectacular force, is
revealed in the collections of women's letters, articles, songs, dramas,
and satirical "skits" on English rule that have come down to us. In this
search into the reasons of government, some women began to take thought
about laws that excluded them from the ballot. Two women at least left
their protests on record. Abigail, the ingenious and witty wife of John
Adams, wrote to her husband, in March, 1776, that women objected "to all
arbitrary power whether of state or males" and demanded political
privileges in the new order then being created. Hannah Lee Corbin, the
sister of "Lighthorse" Harry Lee, protested to her brother against the
taxation of women without representation.

[Illustration: ABIGAIL ADAMS]

=The Stir among European Women.=--Ferment in America, in the case of
women as of men, was quickened by events in Europe. In 1792, Mary
Wollstonecraft published in England the _Vindication of the Rights of
Women_--a book that was destined to serve the cause of liberty among
women as the writings of Locke and Paine had served that of men. The
specific grievances which stirred English women were men's invasion of
women's industries, such as spinning and weaving; the denial of equal
educational opportunities; and political disabilities. In France also
the great Revolution raised questionings about the status of women. The
rights of "citizenesses" as well as the rights of "citizens" were
examined by the boldest thinkers. This in turn reacted upon women in the
United States.

=Leadership in America.=--The origins of the American woman movement are
to be found in the writings of a few early intellectual leaders. During
the first decades of the nineteenth century, books, articles, and
pamphlets about women came in increasing numbers from the press. Lydia
Maria Child wrote a history of women; Margaret Fuller made a critical
examination of the status of women in her time; and Mrs. Elizabeth Ellet
supplemented the older histories by showing what an important part women
had played in the American Revolution.

=The Struggle for Education.=--Along with criticism, there was carried
on a constructive struggle for better educational facilities for women
who had been from the beginning excluded from every college in the
country. In this long battle, Emma Willard and Mary Lyon led the way;
the former founded a seminary at Troy, New York; and the latter made the
beginnings of Mount Holyoke College in Massachusetts. Oberlin College in
Ohio, established in 1833, opened its doors to girls and from it were
graduated young students to lead in the woman movement. Sarah J. Hale,
who in 1827 became the editor of a "Ladies' Magazine," published in
Boston, conducted a campaign for equal educational opportunities which
helped to bear fruit in the founding of Vassar College shortly after the
Civil War.

=The Desire to Effect Reforms.=--As they came to study their own history
and their own part in civilization, women naturally became deeply
interested in all the controversies going on around them. The temperance
question made a special appeal to them and they organized to demand the
right to be heard on it. In 1846 the "Daughters of Temperance" formed a
secret society favoring prohibition. They dared to criticize the
churches for their indifference and were so bold as to ask that
drunkenness be made a ground for divorce.

The slavery issue even more than temperance called women into public
life. The Grimke sisters of South Carolina emancipated their bondmen,
and one of these sisters, exiled from Charleston for her "Appeal to the
Christian Women of the South," went North to work against the slavery
system. In 1837 the National Women's Anti-Slavery Convention met in New
York; seventy-one women delegates represented eight states. Three years
later eight American women, five of them in Quaker costume, attended the
World Anti-Slavery Convention in London, much to the horror of the men,
who promptly excluded them from the sessions on the ground that it was
not fitting for women to take part in such meetings.

In other spheres of activity, especially social service, women steadily
enlarged their interest. Nothing human did they consider alien to them.
They inveighed against cruel criminal laws and unsanitary prisons. They
organized poor relief and led in private philanthropy. Dorothea Dix
directed the movement that induced the New York legislature to establish
in 1845 a separate asylum for the criminal insane. In the same year
Sarah G. Bagley organized the Lowell Female Reform Association for the
purpose of reducing the long hours of labor for women, safeguarding "the
constitutions of future generations." Mrs. Eliza Woodson Farnham, matron
in Sing Sing penitentiary, was known throughout the nation for her
social work, especially prison reform. Wherever there were misery and
suffering, women were preparing programs of relief.

=Freedom of Speech for Women.=--In the advancement of their causes, of
whatever kind, women of necessity had to make public appeals and take
part in open meetings. Here they encountered difficulties. The
appearance of women on the platform was new and strange. Naturally it
was widely resented. Antoinette Brown, although she had credentials as a
delegate, was driven off the platform of a temperance convention in New
York City simply because she was a woman. James Russell Lowell, editor
of the "Atlantic Monthly," declined a poem from Julia Ward Howe on the
theory that no woman could write a poem; but he added on second thought
that he might consider an article in prose. Nathaniel Hawthorne,
another editor, even objected to something in prose because to him "all
ink-stained women were equally detestable." To the natural resentment
against their intrusion into new fields was added that aroused by their
ideas and methods. As temperance reformers, they criticized in a caustic
manner those who would not accept their opinions. As opponents of
slavery they were especially bitter. One of their conventions, held at
Philadelphia in 1833, passed a resolution calling on all women to leave
those churches that would not condemn every form of human bondage. This
stirred against them many of the clergy who, accustomed to having women
sit silent during services, were in no mood to treat such a revolt
leniently. Then came the last straw. Women decided that they would
preach--out of the pulpit first, and finally in it.

=Women in Industry.=--The period of this ferment was also the age of the
industrial revolution in America, the rise of the factory system, and
the growth of mill towns. The labor of women was transferred from the
homes to the factories. Then arose many questions: the hours of labor,
the sanitary conditions of the mills, the pressure of foreign
immigration on native labor, the wages of women as compared with those
of men, and the right of married women to their own earnings. Labor
organizations sprang up among working women. The mill girls of Lowell,
Massachusetts, mainly the daughters of New England farmers, published a
magazine, "The Lowell Offering." So excellent were their writings that
the French statesman, Thiers, carried a copy of their paper into the
Chamber of Deputies to show what working women could achieve in a
republic. As women were now admittedly earning their own way in the
world by their own labor, they began to talk of their "economic
independence."

=The World Shaken by Revolution.=--Such was the quickening of women's
minds in 1848 when the world was startled once more by a revolution in
France which spread to Germany, Poland, Austria, Hungary, and Italy.
Once more the people of the earth began to explore the principles of
democracy and expound human rights. Women, now better educated and more
"advanced" in their ideas, played a role of still greater importance in
that revolution. They led in agitations and uprisings. They suffered
from reaction and persecution. From their prison in France, two of them
who had been jailed for too much insistence on women's rights exchanged
greetings with American women who were raising the same issue here. By
this time the women had more supporters among the men. Horace Greeley,
editor of the New York _Tribune_, though he afterwards recanted, used
his powerful pen in their behalf. Anti-slavery leaders welcomed their
aid and repaid them by urging the enfranchisement of women.

=The Woman's Rights Convention of 1848.=--The forces, moral and
intellectual, which had been stirring among women, crystallized a few
months after the outbreak of the European revolution in the first
Woman's Rights Convention in the history of America. It met at Seneca
Falls, New York, in 1848, on the call of Lucretia Mott, Martha Wright,
Elizabeth Cady Stanton, and Mary Ann McClintock, three of them Quakers.
Accustomed to take part in church meetings with men, the Quakers
naturally suggested that men as well as women be invited to attend the
convention. Indeed, a man presided over the conference, for that
position seemed too presumptuous even for such stout advocates of
woman's rights.

The deliberations of the Seneca Falls convention resulted in a
Declaration of Rights modeled after the Declaration of Independence. For
example, the preamble began: "When in the course of human events it
becomes necessary for one portion of the family of man to assume among
the people of the earth a position different from that which they have
hitherto occupied...." So also it closed: "Such has been the patient
suffering of women under this government and such is now the necessity
which constrains them to demand the equal station to which they are
entitled." Then followed the list of grievances, the same number which
had been exhibited to George III in 1776. Especially did they assail the
disabilities imposed upon them by the English common law imported into
America--the law which denied married women their property, their wages,
and their legal existence as separate persons. All these grievances they
recited to "a candid world." The remedies for the evils which they
endured were then set forth in detail. They demanded "equal rights" in
the colleges, trades, and professions; equal suffrage; the right to
share in all political offices, honors, and emoluments; the right to
complete equality in marriage, including equal guardianship of the
children; and for married women the right to own property, to keep
wages, to make contracts, to transact business, and to testify in the
courts of justice. In short, they declared women to be persons as men
are persons and entitled to all the rights and privileges of human
beings. Such was the clarion call which went forth to the world in
1848--to an amused and contemptuous world, it must be admitted--but to a
world fated to heed and obey.

=The First Gains in Civil Liberty.=--The convention of 1848 did not make
political enfranchisement the leading issue. Rather did it emphasize the
civil disabilities of women which were most seriously under discussion
at the time. Indeed, the New York legislature of that very year, as the
result of a twelve years' agitation, passed the Married Woman's Property
Act setting aside the general principles of the English common law as
applied to women and giving them many of the "rights of man." California
and Wisconsin followed in 1850; Massachusetts in 1854; and Kansas in
1859. Other states soon fell into line. Women's earnings and
inheritances were at last their own in some states at least. In a little
while laws were passed granting women rights as equal guardians of their
children and permitting them to divorce their husbands on the grounds of
cruelty and drunkenness.

By degrees other steps were taken. The Woman's Medical College of
Pennsylvania was founded in 1850, and the Philadelphia School of Design
for Women three years later. In 1852 the American Women's Educational
Association was formed to initiate an agitation for enlarged
educational opportunities for women. Other colleges soon emulated the
example of Oberlin: the University of Utah in 1850; Hillsdale College in
Michigan in 1855; Baker University in Kansas in 1858; and the University
of Iowa in 1860. New trades and professions were opened to women and old
prejudices against their activities and demands slowly gave way.


THE NATIONAL STRUGGLE FOR WOMAN SUFFRAGE

=The Beginnings of Organization.=--As women surmounted one obstacle
after another, the agitation for equal suffrage came to the front. If
any year is to be fixed as the date of its beginning, it may very well
be 1850, when the suffragists of Ohio urged the state constitutional
convention to confer the vote upon them. With apparent spontaneity there
were held in the same year state suffrage conferences in Indiana,
Pennsylvania, and Massachusetts; and connections were formed among the
leaders of these meetings. At the same time the first national suffrage
convention was held in Worcester, Massachusetts, on the call of
eighty-nine leading men and women representing six states. Accounts of
the convention were widely circulated in this country and abroad.
English women,--for instance, Harriet Martineau,--sent words of
appreciation for the work thus inaugurated. It inspired a leading
article in the "Westminster Review," which deeply interested the
distinguished economist, John Stuart Mill. Soon he was the champion of
woman suffrage in the British Parliament and the author of a powerful
tract _The Subjection of Women_, widely read throughout the
English-speaking world. Thus do world movements grow. Strange to relate
the women of England were enfranchised before the adoption of the
federal suffrage amendment in America.

The national suffrage convention of 1850 was followed by an
extraordinary outburst of agitation. Pamphlets streamed from the press.
Petitions to legislative bodies were drafted, signed, and presented.
There were addresses by favorite orators like Garrison, Phillips, and
Curtis, and lectures and poems by men like Emerson, Longfellow, and
Whittier. In 1853 the first suffrage paper was founded by the wife of a
member of Congress from Rhode Island. By this time the last barrier to
white manhood suffrage in the North had been swept away and the woman's
movement was gaining momentum every year.

=The Suffrage Movement Checked by the Civil War.=--Advocates of woman
suffrage believed themselves on the high road to success when the Civil
War engaged the energies and labors of the nation. Northern women became
absorbed in the struggle to preserve the union. They held no suffrage
conventions for five years. They transformed their associations into
Loyalty Leagues. They banded together to buy only domestic goods when
foreign imports threatened to ruin American markets. They rolled up
monster petitions in favor of the emancipation of slaves. In hospitals,
in military prisons, in agriculture, and in industry they bore their
full share of responsibility. Even when the New York legislature took
advantage of their unguarded moments and repealed the law giving the
mother equal rights with the father in the guardianship of children,
they refused to lay aside war work for agitation. As in all other wars,
their devotion was unstinted and their sacrifices equal to the
necessities of the hour.

=The Federal Suffrage Amendment.=--Their plans and activities, when the
war closed, were shaped by events beyond their control. The emancipation
of the slaves and their proposed enfranchisement made prominent the
question of a national suffrage for the first time in our history.
Friends of the colored man insisted that his civil liberties would not
be safe unless he was granted the right to vote. The woman suffragists
very pertinently asked why the same principle did not apply to women.
The answer which they received was negative. The fourteenth amendment to
the federal Constitution, adopted in 1868, definitely put women aside by
limiting the scope of its application, so far as the suffrage was
concerned, to the male sex. In making manhood suffrage national,
however, it nationalized the issue.

This was the signal for the advocates of woman suffrage. In March, 1869,
their proposed amendment was introduced in Congress by George W. Julian
of Indiana. It provided that no citizen should be deprived of the vote
on account of sex, following the language of the fifteenth amendment
which forbade disfranchisement on account of race. Support for the
amendment, coming from many directions, led the suffragists to believe
that their case was hopeful. In their platform of 1872, for example, the
Republicans praised the women for their loyal devotion to freedom,
welcomed them to spheres of wider usefulness, and declared that the
demand of any class of citizens for additional rights deserved
"respectful consideration."

[Illustration: _Copyright by Underwood and Underwood, N.Y._

SUSAN B. ANTHONY]

Experience soon demonstrated, however, that praise was not the ballot.
Indeed the suffragists already had realized that a tedious contest lay
before them. They had revived in 1866 their regular national convention.
They gave the name of "The Revolution" to their paper, edited by
Elizabeth Cady Stanton and Susan B. Anthony. They formed a national
suffrage association and organized annual pilgrimages to Congress to
present their claims. Such activities bore some results. Many eminent
congressmen were converted to their cause and presented it ably to their
colleagues of both chambers. Still the subject was ridiculed by the
newspapers and looked upon as freakish by the masses.

=The State Campaigns.=--Discouraged by the outcome of the national
campaign, suffragists turned to the voters of the individual states and
sought the ballot at their hands. Gains by this process were painfully
slow. Wyoming, it is true, while still a territory, granted suffrage to
women in 1869 and continued it on becoming a state twenty years later,
in spite of strong protests in Congress. In 1893 Colorado established
complete political equality. In Utah, the third suffrage state, the
cause suffered many vicissitudes. Women were enfranchised by the
territorial legislature; they were deprived of the ballot by Congress in
1887; finally in 1896 on the admission of Utah to the union they
recovered their former rights. During the same year, 1896, Idaho
conferred equal suffrage upon the women. This was the last suffrage
victory for more than a decade.

=The Suffrage Cause in Congress.=--In the midst of the meager gains
among the states there were occasional flurries of hope for immediate
action on the federal amendment. Between 1878 and 1896 the Senate
committee reported the suffrage resolution by a favorable majority on
five different occasions. During the same period, however, there were
nine unfavorable reports and only once did the subject reach the point
of a general debate. At no time could anything like the required
two-thirds vote be obtained.

=The Changing Status of Women.=--While the suffrage movement was
lagging, the activities of women in other directions were steadily
multiplying. College after college--Vassar, Bryn Mawr, Smith, Wellesley,
to mention a few--was founded to give them the advantages of higher
education. Other institutions, especially the state universities of the
West, opened their doors to women, and women were received into the
professions of law and medicine. By the rapid growth of public high
schools in which girls enjoyed the same rights as boys, education was
extended still more widely. The number of women teachers increased by
leaps and bounds.

Meanwhile women were entering nearly every branch of industry and
business. How many of them worked at gainful occupations before 1870 we
do not know; but from that year forward we have the records of the
census. Between 1870 and 1900 the proportion of women in the professions
rose from less than two per cent to more than ten per cent; in trade and
transportation from 24.8 per cent to 43.2 per cent; and in manufacturing
from 13 to 19 per cent. In 1910, there were over 8,000,000 women
gainfully employed as compared with 30,000,000 men. When, during the war
on Germany, the government established the principle of equal pay for
equal work and gave official recognition to the value of their services
in industry, it was discovered how far women had traveled along the road
forecast by the leaders of 1848.

=The Club Movement among Women.=--All over the country women's societies
and clubs were started to advance this or that reform or merely to study
literature, art, and science. In time these women's organizations of all
kinds were federated into city, state, and national associations and
drawn into the consideration of public questions. Under the leadership
of Frances Willard they made temperance reform a vital issue. They took
an interest in legislation pertaining to prisons, pure food, public
health, and municipal government, among other things. At their sessions
and conferences local, state, and national issues were discussed until
finally, it seems, everything led to the quest of the franchise. By
solemn resolution in 1914 the National Federation of Women's Clubs,
representing nearly two million club women, formally endorsed woman
suffrage. In the same year the National Education Association, speaking
for the public school teachers of the land, added its seal of approval.

=State and National Action.=--Again the suffrage movement was in full
swing in the states. Washington in 1910, California in 1911, Oregon,
Kansas, and Arizona in 1912, Nevada and Montana in 1914 by popular vote
enfranchised their women. Illinois in 1913 conferred upon them the right
to vote for President of the United States. The time had arrived for a
new movement. A number of younger suffragists sought to use the votes of
women in the equal suffrage states to compel one or both of the national
political parties to endorse and carry through Congress the federal
suffrage amendment. Pressure then came upon Congress from every
direction: from the suffragists who made a straight appeal on the
grounds of justice; and from the suffragists who besought the women of
the West to vote against candidates for President, who would not approve
the federal amendment. In 1916, for the first time, a leading
presidential candidate, Mr. Charles E. Hughes, speaking for the
Republicans, endorsed the federal amendment and a distinguished
ex-President, Roosevelt, exerted a powerful influence to keep it an
issue in the campaign.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

CONFERENCE OF MEN AND WOMEN DELEGATES AT A NATIONAL CONVENTION IN
1920]

=National Enfranchisement.=--After that, events moved rapidly. The great
state of New York adopted equal suffrage in 1917. Oklahoma, South
Dakota, and Michigan swung into line the following year; several other
states, by legislative action, gave women the right to vote for
President. In the meantime the suffrage battle at Washington grew
intense. Appeals and petitions poured in upon Congress and the
President. Militant suffragists held daily demonstrations in Washington.
On September 30, 1918, President Wilson, who, two years before, had
opposed federal action and endorsed suffrage by state adoption only,
went before Congress and urged the passage of the suffrage amendment to
the Constitution. In June, 1919, the requisite two-thirds vote was
secured; the resolution was carried and transmitted to the states for
ratification. On August 28, 1920, the thirty-sixth state, Tennessee,
approved the amendment, making three-fourths of the states as required
by the Constitution. Thus woman suffrage became the law of the land. A
new political democracy had been created. The age of agitation was
closed and the epoch of responsible citizenship opened.


=General References=

Edith Abbott, _Women in Industry_.

C.P. Gilman, _Woman and Economics_.

I.H. Harper, _Life and Work of Susan B. Anthony_.

E.R. Hecker, _Short History of Woman's Rights_.

S.B. Anthony and I.H. Harper, _History of Woman Suffrage_ (4 vols.).

J.W. Taylor, _Before Vassar Opened_.

A.H. Shaw, _The Story of a Pioneer_.


=Research Topics=

=The Rise of the Woman Suffrage Movement.=--McMaster, _History of the
People of the United States_, Vol. VIII, pp. 116-121; K. Porter,
_History of Suffrage in the United States_, pp. 135-145.

=The Development of the Suffrage Movement.=--Porter, pp. 228-254; Ogg,
_National Progress_ (American Nation Series), pp. 151-156 and p. 382.

=Women's Labor in the Colonial Period.=--E. Abbott, _Women in Industry_,
pp. 10-34.

=Women and the Factory System.=--Abbott, pp. 35-62.

=Early Occupations for Women.=--Abbott, pp. 63-85.

=Women's Wages.=--Abbott, pp. 262-316.


=Questions=

1. Why were women involved in the reform movements of the new century?

2. What is history? What determines the topics that appear in written
history?

3. State the position of women under the old common law.

4. What part did women play in the intellectual movement that preceded
the American Revolution?

5. Explain the rise of the discussion of women's rights.

6. What were some of the early writings about women?

7. Why was there a struggle for educational opportunities?

8. How did reform movements draw women into public affairs and what were
the chief results?

9. Show how the rise of the factory affected the life and labor of
women.

10. Why is the year 1848 an important year in the woman movement?
Discuss the work of the Seneca Falls convention.

11. Enumerate some of the early gains in civil liberty for women.

12. Trace the rise of the suffrage movement. Show the effect of the
Civil War.

13. Review the history of the federal suffrage amendment.

14. Summarize the history of the suffrage in the states.




CHAPTER XXIV

INDUSTRIAL DEMOCRACY


=The New Economic Age.=--The spirit of criticism and the measures of
reform designed to meet it, which characterized the opening years of the
twentieth century, were merely the signs of a new age. The nation had
definitely passed into industrialism. The number of city dwellers
employed for wages as contrasted with the farmers working on their own
land was steadily mounting. The free land, once the refuge of restless
workingmen of the East and the immigrants from Europe, was a thing of
the past. As President Roosevelt later said in speaking of the great
coal strike, "a few generations ago, the American workman could have
saved money, gone West, and taken up a homestead. Now the free lands
were gone. In earlier days, a man who began with a pick and shovel might
come to own a mine. That outlet was now closed as regards the immense
majority.... The majority of men who earned wages in the coal industry,
if they wished to progress at all, were compelled to progress not by
ceasing to be wage-earners but by improving the conditions under which
all the wage-earners of the country lived and worked."

The disappearance of the free land, President Roosevelt went on to say,
also produced "a crass inequality in the bargaining relation of the
employer and the individual employee standing alone. The great
coal-mining and coal-carrying companies which employed their tens of
thousands could easily dispense with the services of any particular
miner. The miner, on the other hand, however expert, could not dispense
with the companies. He needed a job; his wife and children would starve
if he did not get one.... Individually the miners were impotent when
they sought to enter a wage contract with the great companies; they
could make fair terms only by uniting into trade unions to bargain
collectively." It was of this state of affairs that President Taft spoke
when he favored the modification of the common law "so as to put
employees of little power and means on a level with their employers in
adjusting and agreeing upon their mutual obligations."

John D. Rockefeller, Jr., on the side of the great captains of industry,
recognized the same facts. He said: "In the early days of the
development of industry, the employer and capital investor were
frequently one. Daily contact was had between him and his employees, who
were his friends and neighbors.... Because of the proportions which
modern industry has attained, employers and employees are too often
strangers to each other.... Personal relations can be revived only
through adequate representation of the employees. Representation is a
principle which is fundamentally just and vital to the successful
conduct of industry.... It is not consistent for us as Americans to
demand democracy in government and practice autocracy in industry....
With the developments what they are in industry to-day, there is sure to
come a progressive evolution from aristocratic single control, whether
by capital, labor, or the state, to democratic, cooperative control by
all three."


COOPERATION BETWEEN EMPLOYERS AND EMPLOYEES

=Company Unions.=--The changed economic life described by the three
eminent men just quoted was acknowledged by several great companies and
business concerns. All over the country decided efforts were made to
bridge the gulf which industry and the corporation had created. Among
the devices adopted was that of the "company union." In one of the
Western lumber mills, for example, all the employees were invited to
join a company organization; they held monthly meetings to discuss
matters of common concern; they elected a "shop committee" to confer
with the representatives of the company; and periodically the agents of
the employers attended the conferences of the men to talk over matters
of mutual interest. The function of the shop committee was to consider
wages, hours, safety rules, sanitation, recreation and other problems.
Whenever any employee had a grievance he took it up with the foreman
and, if it was not settled to his satisfaction, he brought it before the
shop committee. If the members of the shop committee decided in favor of
the man with a grievance, they attempted to settle the matter with the
company's agents. All these things failing, the dispute was transferred
to a grand meeting of all the employees with the employers'
representatives, in common council. A deadlock, if it ensued from such a
conference, was broken by calling in impartial arbitrators selected by
both sides from among citizens outside the mill. Thus the employees were
given a voice in all decisions affecting their work and welfare; rights
and grievances were treated as matters of mutual interest rather than
individual concern. Representatives of trade unions from outside,
however, were rigidly excluded from all negotiations between employers
and the employees.

=Profit-sharing.=--Another proposal for drawing capital and labor
together was to supplement the wage system by other ties. Sometimes lump
sums were paid to employees who remained in a company's service for a
definite period of years. Again they were given a certain percentage of
the annual profits. In other instances, employees were allowed to buy
stock on easy terms and thus become part owners in the concern. This
last plan was carried so far by a large soap manufacturing company that
the employees, besides becoming stockholders, secured the right to elect
representatives to serve on the board of directors who managed the
entire business. So extensive had profit-sharing become by 1914 that the
Federal Industrial Relations Committee, appointed by the President,
deemed it worthy of a special study. Though opposed by regular trade
unions, it was undoubtedly growing in popularity.

=Labor Managers and Welfare Work.=--Another effort of employers to meet
the problems of the new age appeared in the appointment of specialists,
known as employment managers, whose task it was to study the relations
existing between masters and workers and discover practical methods for
dealing with each grievance as it arose. By 1918, hundreds of big
companies had recognized this modern "profession" and universities were
giving courses of instruction on the subject to young men and women. In
that year a national conference of employment managers was held at
Rochester, New York. The discussion revealed a wide range of duties
assigned to managers, including questions of wages, hours, sanitation,
rest rooms, recreational facilities, and welfare work of every kind
designed to make the conditions in mills and factories safer and more
humane. Thus it was evident that hundreds of employers had abandoned the
old idea that they were dealing merely with individual employees and
that their obligations ended with the payment of any wages they saw fit
to fix. In short, they were seeking to develop a spirit of cooperation
to take the place of competition and enmity; and to increase the
production of commodities by promoting the efficiency and happiness of
the producers.


THE RISE AND GROWTH OF ORGANIZED LABOR

=The American Federation of Labor.=--Meanwhile a powerful association of
workers representing all the leading trades and crafts, organized into
unions of their own, had been built up outside the control of employers.
This was the American Federation of Labor, a nation-wide union of
unions, founded in 1886 on the basis of beginnings made five years
before. At the time of its establishment it had approximately 150,000
members. Its growth up to the end of the century was slow, for the total
enrollment in 1900 was only 300,000. At that point the increase became
marked. The membership reached 1,650,000 in 1904 and more than 3,000,000
in 1919. To be counted in the ranks of organized labor were several
strong unions, friendly to the Federation, though not affiliated with
it. Such, for example, were the Railway Brotherhoods with more than half
a million members. By the opening of 1920 the total strength of
organized labor was put at about 4,000,000 members, meaning, if we
include their families, that nearly one-fifth of the people of the
United States were in some positive way dependent upon the operations of
trade unions.

=Historical Background.=--This was the culmination of a long and
significant history. Before the end of the eighteenth century, the
skilled workmen--printers, shoemakers, tailors, and carpenters--had, as
we have seen, formed local unions in the large cities. Between 1830 and
1860, several aggressive steps were taken in the American labor
movement. For one thing, the number of local unions increased by leaps
and bounds in all the industrial towns. For another, there was
established in every large manufacturing city a central labor body
composed of delegates from the unions of the separate trades. In the
local union the printers or the cordwainers, for example, considered
only their special trade problems. In the central labor union, printers,
cordwainers, iron molders, and other craftsmen considered common
problems and learned to cooperate with one another in enforcing the
demands of each craft. A third step was the federation of the unions of
the same craftsmen in different cities. The printers of New York,
Philadelphia, Boston, and other towns, for instance, drew together and
formed a national trade union of printers built upon the local unions of
that craft. By the eve of the Civil War there were four or five powerful
national unions of this character. The expansion of the railway made
travel and correspondence easier and national conventions possible even
for workmen of small means. About 1834 an attempt was made to federate
the unions of all the different crafts into a national organization; but
the effort was premature.

_The National Labor Union._--The plan which failed in 1834 was tried
again in the sixties. During the war, industries and railways had
flourished as never before; prices had risen rapidly; the demand for
labor had increased; wages had mounted slowly, but steadily. Hundreds of
new local unions had been founded and eight or ten national trade unions
had sprung into being. The time was ripe, it seemed, for a national
consolidation of all labor's forces; and in 1866, the year after the
surrender of General Lee at Appomattox, the "National Labor Union" was
formed at Baltimore under the leadership of an experienced organizer,
W.H. Sylvis of the iron molders. The purpose of the National Labor Union
was not merely to secure labor's standard demands touching hours, wages,
and conditions of work or to maintain the gains already won. It leaned
toward political action and radical opinions. Above all, it sought to
eliminate the conflict between capital and labor by making workingmen
the owners of shops through the formation of cooperative industries. For
six years the National Labor Union continued to hold conferences and
carry on its propaganda; but most of the cooperative enterprises failed,
political dissensions arose, and by 1872 the experiment had come to an
end.

_The Knights of Labor._--While the National Labor Union was
experimenting, there grew up in the industrial world a more radical
organization known as the "Noble Order of the Knights of Labor." It was
founded in Philadelphia in 1869, first as a secret society with rituals,
signs, and pass words; "so that no spy of the boss can find his way into
the lodge room to betray his fellows," as the Knights put it. In form
the new organization was simple. It sought to bring all laborers,
skilled and unskilled, men and women, white and colored, into a mighty
body of local and national unions without distinction of trade or craft.
By 1885, ten years after the national organization was established, it
boasted a membership of over 700,000. In philosophy, the Knights of
Labor were socialistic, for they advocated public ownership of the
railways and other utilities and the formation of cooperative societies
to own and manage stores and factories.

As the Knights were radical in spirit and their strikes, numerous and
prolonged, were often accompanied by violence, the organization alarmed
employers and the general public, raising up against itself a vigorous
opposition. Weaknesses within, as well as foes from without, started the
Knights on the path to dissolution. They waged more strikes than they
could carry on successfully; their cooperative experiments failed as
those of other labor groups before them had failed; and the rank and
file could not be kept in line. The majority of the members wanted
immediate gains in wages or the reduction of hours; when their hopes
were not realized they drifted away from the order. The troubles were
increased by the appearance of the American Federation of Labor, a still
mightier organization composed mainly of skilled workers who held
strategic positions in industry. When they failed to secure the
effective support of the Federation in their efforts to organize the
unskilled, the employers closed in upon them; then the Knights declined
rapidly in power. By 1890 they were a negligible factor and in a short
time they passed into the limbo of dead experiments.

=The Policies of the American Federation.=--Unlike the Knights of Labor,
the American Federation of Labor sought, first of all, to be very
practical in its objects and methods. It avoided all kinds of
socialistic theories and attended strictly to the business of organizing
unions for the purpose of increasing wages, shortening hours, and
improving working conditions for its members. It did not try to include
everybody in one big union but brought together the employees of each
particular craft whose interests were clearly the same. To prepare for
strikes and periods of unemployment, it raised large funds by imposing
heavy dues and created a benefit system to hold men loyally to the
union. In order to permit action on a national scale, it gave the
superior officers extensive powers over local unions.

While declaring that employers and employees had much in common, the
Federation strongly opposed company unions. Employers, it argued, were
affiliated with the National Manufacturers' Association or with similar
employers' organizations; every important industry was now national in
scope; and wages and hours, in view of competition with other shops,
could not be determined in a single factory, no matter how amicable
might be the relations of the company and its workers in that particular
plant. For these reasons, the Federation declared company unions and
local shop committees inherently weak; it insisted that hours, wages,
and other labor standards should be fixed by general trade agreements
applicable to all the plants of a given industry, even if subject to
local modifications.

At the same time, the Federation, far from deliberately antagonizing
employers, sought to enlist their cooperation and support. It affiliated
with the National Civic Federation, an association of business men,
financiers, and professional men, founded in 1900 to promote friendly
relations in the industrial world. In brief, the American Federation of
Labor accepted the modern industrial system and, by organization within
it, endeavored to secure certain definite terms and conditions for trade
unionists.


THE WIDER RELATIONS OF ORGANIZED LABOR

=The Socialists.=--The trade unionism "pure and simple," espoused by the
American Federation of Labor, seemed to involve at first glance nothing
but businesslike negotiations with employers. In practice it did not
work out that way. The Federation was only six years old when a new
organization, appealing directly for the labor vote--namely, the
Socialist Labor Party--nominated a candidate for President, launched
into a national campaign, and called upon trade unionists to desert the
older parties and enter its fold.

The socialistic idea, introduced into national politics in 1892, had
been long in germination. Before the Civil War, a number of reformers,
including Nathaniel Hawthorne, Horace Greeley, and Wendell Phillips,
deeply moved by the poverty of the great industrial cities, had
earnestly sought relief in the establishment of cooperative or
communistic colonies. They believed that people should go into the
country, secure land and tools, own them in common so that no one could
profit from exclusive ownership, and produce by common labor the food
and clothing necessary for their support. For a time this movement
attracted wide interest, but it had little vitality. Nearly all the
colonies failed. Selfishness and indolence usually disrupted the best of
them.

In the course of time this "Utopian" idea was abandoned, and another set
of socialist doctrines, claiming to be more "scientific," appeared
instead. The new school of socialists, adopting the principles of a
German writer and agitator, Karl Marx, appealed directly to workingmen.
It urged them to unite against the capitalists, to get possession of the
machinery of government, and to introduce collective or public ownership
of railways, land, mines, mills, and other means of production. The
Marxian socialists, therefore, became political. They sought to organize
labor and to win elections. Like the other parties they put forward
candidates and platforms. The Socialist Labor party in 1892, for
example, declared in favor of government ownership of utilities, free
school books, woman suffrage, heavy income taxes, and the referendum.
The Socialist party, founded in 1900, with Eugene V. Debs, the leader of
the Pullman strike, as its candidate, called for public ownership of all
trusts, monopolies, mines, railways; and the chief means of production.
In the course of time the vote of the latter organization rose to
considerable proportions, reaching almost a million in 1912. It declined
four years later and then rose in 1920 to about the same figure.

In their appeal for votes, the socialists of every type turned first to
labor. At the annual conventions of the American Federation of Labor
they besought the delegates to endorse socialism. The president of the
Federation, Samuel Gompers, on each occasion took the floor against
them. He repudiated socialism and the socialists, on both theoretical
and practical grounds. He opposed too much public ownership, declaring
that the government was as likely as any private employer to oppress
labor. The approval of socialism, he maintained, would split the
Federation on the rock of politics, weaken it in its fight for higher
wages and shorter hours, and prejudice the public against it. At every
turn he was able to vanquish the socialists in the Federation, although
he could not prevent it from endorsing public ownership of the railways
at the convention of 1920.

=The Extreme Radicals.=--Some of the socialists, defeated in their
efforts to capture organized labor and seeing that the gains in
elections were very meager, broke away from both trade unionism and
politics. One faction, the Industrial Workers of the World, founded in
1905, declared themselves opposed to all capitalists, the wages system,
and craft unions. They asserted that the "working class and the
employing class have nothing in common" and that trade unions only
pitted one set of workers against another set. They repudiated all
government ownership and the government itself, boldly proclaiming their
intention to unite all employees into one big union and seize the
railways, mines, and mills of the country. This doctrine, so
revolutionary in tone, called down upon the extremists the condemnation
of the American Federation of Labor as well as of the general public. At
its convention in 1919, the Federation went on record as "opposed to
Bolshevism, I.W.W.-ism, and the irresponsible leadership that encourages
such a policy." It announced its "firm adherence to American ideals."

=The Federation and Political Issues.=--The hostility of the Federation
to the socialists did not mean, however, that it was indifferent to
political issues or political parties. On the contrary, from time to
time, at its annual conventions, it endorsed political and social
reforms, such as the initiative, referendum, and recall, the abolition
of child labor, the exclusion of Oriental labor, old-age pensions, and
government ownership. Moreover it adopted the policy of "rewarding
friends and punishing enemies" by advising members to vote for or
against candidates according to their stand on the demands of organized
labor.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

SAMUEL GOMPERS AND OTHER LABOR LEADERS]

This policy was pursued with especial zeal in connection with disputes
over the use of injunctions in labor controversies. An injunction is a
bill or writ issued by a judge ordering some person or corporation to do
or to refrain from doing something. For example, a judge may order a
trade union to refrain from interfering with non-union men or to
continue at work handling goods made by non-union labor; and he may fine
or imprison those who disobey his injunction, the penalty being
inflicted for "contempt of court." This ancient legal device came into
prominence in connection with nation-wide railway strikes in 1877. It
was applied with increasing frequency after its effective use against
Eugene V. Debs in the Pullman strike of 1894.

Aroused by the extensive use of the writ, organized labor demanded that
the power of judges to issue injunctions in labor disputes be limited by
law. Representatives of the unions sought support from the Democrats and
the Republicans; they received from the former very specific and cordial
endorsement. In 1896 the Democratic platform denounced "government by
injunction as a new and highly dangerous form of oppression." Mr.
Gompers, while refusing to commit the Federation to Democratic politics,
privately supported Mr. Bryan. In 1908, he came out openly and boasted
that eighty per cent of the votes of the Federation had been cast for
the Democratic candidate. Again in 1912 the same policy was pursued. The
reward was the enactment in 1914 of a federal law exempting trade unions
from prosecution as combinations in restraint of trade, limiting the use
of the injunction in labor disputes, and prescribing trial by jury in
case of contempt of court. This measure was hailed by Mr. Gompers as the
"Magna Carta of Labor" and a vindication of his policy. As a matter of
fact, however, it did not prevent the continued use of injunctions
against trade unions. Nevertheless Mr. Gompers was unshaken in his
conviction that organized labor should not attempt to form an
independent political party or endorse socialist or other radical
economic theories.

=Organized Labor and the Public.=--Besides its relations to employers,
radicals within its own ranks, and political questions, the Federation
had to face responsibilities to the general public. With the passing of
time these became heavy and grave. While industries were small and
conflicts were local in character, a strike seldom affected anybody but
the employer and the employees immediately involved in it. When,
however, industries and trade unions became organized on a national
scale and a strike could paralyze a basic enterprise like coal mining or
railways, the vital interests of all citizens were put in jeopardy.
Moreover, as increases in wages and reductions in hours often added
directly to the cost of living, the action of the unions affected the
well-being of all--the food, clothing, and shelter of the whole people.

For the purpose of meeting the issue raised by this state of affairs, it
was suggested that employers and employees should lay their disputes
before commissions of arbitration for decision and settlement. President
Cleveland, in a message of April 2, 1886, proposed such a method for
disposing of industrial controversies, and two years later Congress
enacted a voluntary arbitration law applicable to the railways. The
principle was extended in 1898 and again in 1913, and under the
authority of the federal government many contentions in the railway
world were settled by arbitration.

The success of such legislation induced some students of industrial
questions to urge that unions and employers should be compelled to
submit all disputes to official tribunals of arbitration. Kansas
actually passed such a law in 1920. Congress in the Esch-Cummins railway
bill of the same year created a federal board of nine members to which
all railway controversies, not settled by negotiation, must be
submitted. Strikes, however, were not absolutely forbidden. Generally
speaking, both employers and employees opposed compulsory adjustments
without offering any substitute in case voluntary arbitration should not
be accepted by both parties to a dispute.


IMMIGRATION AND AMERICANIZATION

=The Problems of Immigration.=--From its very inception, the American
Federation of Labor, like the Knights of Labor before it, was confronted
by numerous questions raised by the ever swelling tide of aliens coming
to our shores. In its effort to make each trade union all-inclusive, it
had to wrestle with a score or more languages. When it succeeded in
thoroughly organizing a craft, it often found its purposes defeated by
an influx of foreigners ready to work for lower wages and thus undermine
the foundations of the union.

At the same time, persons outside the labor movement began to be
apprehensive as they contemplated the undoubted evil, as well as the
good, that seemed to be associated with the "alien invasion." They saw
whole sections of great cities occupied by people speaking foreign
tongues, reading only foreign newspapers, and looking to the Old World
alone for their ideas and their customs. They witnessed an expanding
army of total illiterates, men and women who could read and write no
language at all; while among those aliens who could read few there were
who knew anything of American history, traditions, and ideals. Official
reports revealed that over twenty per cent of the men of the draft army
during the World War could not read a newspaper or write a letter home.
Perhaps most alarming of all was the discovery that thousands of alien
men are in the United States only on a temporary sojourn, solely to make
money and return home with their savings. These men, willing to work for
low wages and live in places unfit for human beings, have no stake in
this country and do not care what becomes of it.

=The Restriction of Immigration.=--In all this there was, strictly
speaking, no cause for surprise. Since the foundation of our republic
the policy of the government had been to encourage the coming of the
alien. For nearly one hundred years no restraining act was passed by
Congress, while two important laws positively encouraged it; namely, the
homestead act of 1862 and the contract immigration law of 1864. Not
until American workingmen came into open collision with cheap Chinese
labor on the Pacific Coast did the federal government spread the first
measure of limitation on the statute books. After the discovery of gold,
and particularly after the opening of the railway construction era, a
horde of laborers from China descended upon California. Accustomed to
starvation wages and indifferent to the conditions of living, they
threatened to cut the American standard to the point of subsistence. By
1876 the protest of American labor was loud and long and both the
Republicans and the Democrats gave heed to it. In 1882 Congress enacted
a law prohibiting the admission of Chinese laborers to the United States
for a term of ten years--later extended by legislation. In a little
while the demand arose for the exclusion of the Japanese as well. In
this case no exclusion law was passed; but an understanding was reached
by which Japan agreed not to issue passports to her laborers authorizing
them to come to the United States. By act of Congress in 1907 the
President was empowered to exclude any laborers who, having passports to
Canada, Hawaii, or Mexico, attempted to enter our country.

These laws and agreements, however, did not remove all grounds for the
agitation of the subject. They were difficult to enforce and it was
claimed by residents of the Coast that in spite of federal authority
Oriental laborers were finding their way into American ports. Moreover,
several Western states, anxious to preserve the soil for American
ownership, enacted laws making it impossible for Chinese and Japanese to
buy land outright; and in other ways they discriminated against
Orientals. Such proceedings placed the federal government in an
embarrassing position. By treaty it had guaranteed specific rights to
Japanese citizens in the United States, and the government at Tokyo
contended that the state laws just cited violated the terms of the
international agreement. The Western states were fixed in their
determination to control Oriental residents; Japan was equally
persistent in asking that no badge of inferiority be attached to her
citizens. Subjected to pressure on both sides, the federal government
sought a way out of the deadlock.

Having embarked upon the policy of restriction in 1882, Congress readily
extended it. In that same year it barred paupers, criminals, convicts,
and the insane. Three years later, mainly owing to the pressure of the
Knights of Labor, it forbade any person, company, or association to
import aliens under contract. By an act of 1887, the contract labor
restriction was made even more severe. In 1903, anarchists were excluded
and the bureau of immigration was transferred from the Treasury
Department to the Department of Commerce and Labor, in order to provide
for a more rigid execution of the law. In 1907 the classes of persons
denied admission were widened to embrace those suffering from physical
and mental defects and otherwise unfit for effective citizenship. When
the Department of Labor was established in 1913 the enforcement of the
law was placed in the hands of the Secretary of Labor, W.B. Wilson, who
was a former leader in the American Federation of Labor.

=The Literacy Test.=--Still the advocates of restriction were not
satisfied. Still organized labor protested and demanded more protection
against the competition of immigrants. In 1917 it won a thirty-year
battle in the passage of a bill excluding "all aliens over sixteen years
of age, physically capable of reading, who cannot read the English
language or some other language or dialect, including Hebrew or
Yiddish." Even President Wilson could not block it, for a two-thirds
vote to overcome his veto was mustered in Congress.

This act, while it served to exclude illiterates, made no drastic cut in
the volume of immigration. Indeed a material reduction was resolutely
opposed in many quarters. People of certain nationalities already in the
United States objected to every barrier that shut out their own kinsmen.
Some Americans of the old stock still held to the idea that the United
States should continue to be an asylum for "the oppressed of the earth."
Many employers looked upon an increased labor supply as the means of
escaping what they called "the domination of trade unions." In the babel
of countless voices, the discussion of these vital matters went on in
town and country.

=Americanization.=--Intimately connected with the subject of immigration
was a call for the "Americanization" of the alien already within our
gates. The revelation of the illiteracy in the army raised the cry and
the demand was intensified when it was found that many of the leaders
among the extreme radicals were foreign in birth and citizenship.
Innumerable programs for assimilating the alien to American life were
drawn up, and in 1919 a national conference on the subject was held in
Washington under the auspices of the Department of the Interior. All
were agreed that the foreigner should be taught to speak and write the
language and understand the government of our country. Congress was
urged to lend aid in this vast undertaking. America, as ex-President
Roosevelt had said, was to find out "whether it was a nation or a
boarding-house."


=General References=

J.R. Commons and Associates, _History of Labor in the United States_ (2
vols.).

Samuel Gompers, _Labor and the Common Welfare_.

W.E. Walling, _Socialism as It Is_.

W.E. Walling (and Others), _The Socialism of Today_.

R.T. Ely, _The Labor Movement in America_.

T.S. Adams and H. Sumner, _Labor Problems_.

J.G. Brooks, _American Syndicalism_ and _Social Unrest_.

P.F. Hall, _Immigration and Its Effects on the United States_.


=Research Topics=

=The Rise of Trade Unionism.=--Mary Beard, _Short History of the
American Labor Movement_, pp. 10-18, 47-53, 62-79; Carlton, _Organized
Labor in American History_, pp. 11-44.

=Labor and Politics.=--Beard, _Short History_, pp. 33-46, 54-61,
103-112; Carlton, pp. 169-197; Ogg, _National Progress_ (American Nation
Series), pp. 76-85.

=The Knights of Labor.=--Beard, _Short History_, pp. 116-126; Dewey,
_National Problems_ (American Nation Series), pp. 40-49.

=The American Federation of Labor--Organization and Policies.=--Beard,
_Short History_, pp. 86-112.

=Organized Labor and the Socialists.=--Beard, _Short History_, pp.
126-149.

=Labor and the Great War.=--Carlton, pp. 282-306; Beard, _Short
History_, pp. 150-170.


=Questions=

1. What are the striking features of the new economic age?

2. Give Mr. Rockefeller's view of industrial democracy.

3. Outline the efforts made by employers to establish closer relations
with their employees.

4. Sketch the rise and growth of the American Federation of Labor.

5. How far back in our history does the labor movement extend?

6. Describe the purposes and outcome of the National Labor Union and the
Knights of Labor.

7. State the chief policies of the American Federation of Labor.

8. How does organized labor become involved with outside forces?

9. Outline the rise of the socialist movement. How did it come into
contact with the American Federation?

10. What was the relation of the Federation to the extreme radicals? To
national politics? To the public?

11. Explain the injunction.

12. Why are labor and immigration closely related?

13. Outline the history of restrictions on immigration.

14. What problems arise in connection with the assimilation of the alien
to American life?




CHAPTER XXV

PRESIDENT WILSON AND THE WORLD WAR


"The welfare, the happiness, the energy, and the spirit of the men and
women who do the daily work in our mines and factories, on our
railroads, in our offices and ports of trade, on our farms, and on the
sea are the underlying necessity of all prosperity." Thus spoke Woodrow
Wilson during his campaign for election. In this spirit, as President,
he gave the signal for work by summoning Congress in a special session
on April 7, 1913. He invited the cooperation of all "forward-looking
men" and indicated that he would assume the role of leadership. As an
evidence of his resolve, he appeared before Congress in person to read
his first message, reviving the old custom of Washington and Adams. Then
he let it be known that he would not give his party any rest until it
fulfilled its pledges to the country. When Democratic Senators balked at
tariff reductions, they were sharply informed that the party had
plighted its word and that no excuses or delays would be tolerated.


DOMESTIC LEGISLATION

=Financial Measures.=--Under this spirited leadership Congress went to
work, passing first the Underwood tariff act of 1913, which made a
downward revision in the rates of duty, fixing them on the average about
twenty-six per cent lower than the figures of 1907. The protective
principle was retained, but an effort was made to permit a moderate
element of foreign competition. As a part of the revenue act Congress
levied a tax on incomes as authorized by the sixteenth amendment to the
Constitution. The tax which roused such party passions twenty years
before was now accepted as a matter of course.

Having disposed of the tariff, Congress took up the old and vexatious
currency question and offered a new solution in the form of the federal
reserve law of December, 1913. This measure, one of the most interesting
in the history of federal finance, embraced four leading features. In
the first place, it continued the prohibition on the issuance of notes
by state banks and provided for a national currency. In the second
place, it put the new banking system under the control of a federal
reserve board composed entirely of government officials. To prevent the
growth of a "central money power," it provided, in the third place, for
the creation of twelve federal reserve banks, one in each of twelve
great districts into which the country is divided. All local national
banks were required and certain other banks permitted to become members
of the new system and share in its control. Finally, with a view to
expanding the currency, a step which the Democrats had long urged upon
the country, the issuance of paper money, under definite safeguards, was
authorized.

Mindful of the agricultural interest, ever dear to the heart of
Jefferson's followers, the Democrats supplemented the reserve law by the
Farm Loan Act of 1916, creating federal agencies to lend money on farm
mortgages at moderate rates of interest. Within a year $20,000,000 had
been lent to farmers, the heaviest borrowing being in nine Western and
Southern states, with Texas in the lead.

=Anti-trust Legislation.=--The tariff and currency laws were followed by
three significant measures relative to trusts. Rejecting utterly the
Progressive doctrine of government regulation, President Wilson
announced that it was the purpose of the Democrats "to destroy monopoly
and maintain competition as the only effective instrument of business
liberty." The first step in this direction, the Clayton Anti-trust Act,
carried into great detail the Sherman law of 1890 forbidding and
penalizing combinations in restraint of interstate and foreign trade. In
every line it revealed a determined effort to tear apart the great
trusts and to put all business on a competitive basis. Its terms were
reinforced in the same year by a law creating a Federal Trade Commission
empowered to inquire into the methods of corporations and lodge
complaints against concerns "using any unfair method of competition." In
only one respect was the severity of the Democratic policy relaxed. An
act of 1918 provided that the Sherman law should not apply to companies
engaged in export trade, the purpose being to encourage large
corporations to enter foreign commerce.

The effect of this whole body of anti-trust legislation, in spite of
much labor on it, remained problematical. Very few combinations were
dissolved as a result of it. Startling investigations were made into
alleged abuses on the part of trusts; but it could hardly be said that
huge business concerns had lost any of their predominance in American
industry.

=Labor Legislation.=--By no mere coincidence, the Clayton Anti-trust law
of 1914 made many concessions to organized labor. It declared that "the
labor of a human being is not a commodity or an article of commerce,"
and it exempted unions from prosecution as "combinations in restraint of
trade." It likewise defined and limited the uses which the federal
courts might make of injunctions in labor disputes and guaranteed trial
by jury to those guilty of disobedience (see p. 581).

The Clayton law was followed the next year by the Seamen's Act giving
greater liberty of contract to American sailors and requiring an
improvement of living conditions on shipboard. This was such a drastic
law that shipowners declared themselves unable to meet foreign
competition under its terms, owing to the low labor standards of other
countries.

Still more extraordinary than the Seamen's Act was the Adamson law of
1916 fixing a standard eight-hour work-day for trainmen on railroads--a
measure wrung from Congress under a threat of a great strike by the four
Railway Brotherhoods. This act, viewed by union leaders as a triumph,
called forth a bitter denunciation of "trade union domination," but it
was easier to criticize than to find another solution of the problem.

Three other laws enacted during President Wilson's administration were
popular in the labor world. One of them provided compensation for
federal employees injured in the discharge of their duties. Another
prohibited the labor of children under a certain age in the industries
of the nation. A third prescribed for coal miners in Alaska an
eight-hour day and modern safeguards for life and health. There were
positive proofs that organized labor had obtained a large share of power
in the councils of the country.

=Federal and State Relations.=--If the interference of the government
with business and labor represented a departure from the old idea of
"the less government the better," what can be said of a large body of
laws affecting the rights of states? The prohibition of child labor
everywhere was one indication of the new tendency. Mr. Wilson had once
declared such legislation unconstitutional; the Supreme Court declared
it unconstitutional; but Congress, undaunted, carried it into effect
under the guise of a tax on goods made by children below the age limit.
There were other indications of the drift. Large sums of money were
appropriated by Congress in 1916 to assist the states in building and
maintaining highways. The same year the Farm Loan Act projected the
federal government into the sphere of local money lending. In 1917
millions of dollars were granted to states in aid of vocational
education, incidentally imposing uniform standards throughout the
country. Evidently the government was no longer limited to the duties of
the policeman.

=The Prohibition Amendment.=--A still more significant form of
intervention in state affairs was the passage, in December, 1917, of an
amendment to the federal Constitution establishing national prohibition
of the manufacture and sale of intoxicating liquors as beverages. This
was the climax of a historical movement extending over half a century.
In 1872, a National Prohibition party, launched three years before,
nominated its first presidential candidate and inaugurated a campaign of
agitation. Though its vote was never large, the cause for which it
stood found increasing favor among the people. State after state by
popular referendum abolished the liquor traffic within its borders. By
1917 at least thirty-two of the forty-eight were "dry." When the federal
amendment was submitted for approval, the ratification was surprisingly
swift. In a little more than a year, namely, on January 16, 1919, it was
proclaimed. Twelve months later the amendment went into effect.


COLONIAL AND FOREIGN POLICIES

=The Philippines and Porto Rico.=--Independence for the Philippines and
larger self-government for Porto Rico had been among the policies of the
Democratic party since the campaign of 1900. President Wilson in his
annual messages urged upon Congress more autonomy for the Filipinos and
a definite promise of final independence. The result was the Jones
Organic Act for the Philippines passed in 1916. This measure provided
that the upper as well as the lower house of the Philippine legislature
should be elected by popular vote, and declared it to be the intention
of the United States to grant independence "as soon as a stable
government can be established." This, said President Wilson on signing
the bill, is "a very satisfactory advance in our policy of extending to
them self-government and control of their own affairs." The following
year Congress, yielding to President Wilson's insistence, passed a new

organic act for Porto Rico, making both houses of the legislature
elective and conferring American citizenship upon the inhabitants of the
island.

[Illustration: THE CARIBBEAN REGION]

=American Power in the Caribbean.=--While extending more self-government
to its dominions, the United States enlarged its sphere of influence in
the Caribbean. The supervision of finances in Santo Domingo, inaugurated
in Roosevelt's administration, was transformed into a protectorate under
Wilson. In 1914 dissensions in the republic led to the landing of
American marines to "supervise" the elections. Two years later, an
officer in the American navy, with authority from Washington, placed
the entire republic "in a state of military occupation." He proceeded to
suspend the government and laws of the country, exile the president,
suppress the congress, and substitute American military authority. In
1919 a consulting board of four prominent Dominicans was appointed to
aid the American military governor; but it resigned the next year after
making a plea for the restoration of independence to the republic. For
all practical purposes, it seemed, the sovereignty of Santo Domingo had
been transferred to the United States.

In the neighboring republic of Haiti, a similar state of affairs
existed. In the summer of 1915 a revolution broke out there--one of a
long series beginning in 1804--and our marines were landed to restore
order. Elections were held under the supervision of American officers,
and a treaty was drawn up placing the management of Haitian finances and
the local constabulary under American authority. In taking this action,
our Secretary of State was careful to announce: "The United States
government has no purpose of aggression and is entirely disinterested in
promoting this protectorate." Still it must be said that there were
vigorous protests on the part of natives and American citizens against
the conduct of our agents in the island. In 1921 President Wilson was
considering withdrawal.

In line with American policy in the West Indian waters was the purchase
in 1917 of the Danish Islands just off the coast of Porto Rico. The
strategic position of the islands, especially in relation to Haiti and
Porto Rico, made them an object of American concern as early as 1867,
when a treaty of purchase was negotiated only to be rejected by the
Senate of the United States. In 1902 a second arrangement was made, but
this time it was defeated by the upper house of the Danish parliament.
The third treaty brought an end to fifty years of bargaining and the
Stars and Stripes were raised over St. Croix, St. Thomas, St. John, and
numerous minor islands scattered about in the neighborhood. "It would be
suicidal," commented a New York newspaper, "for America, on the
threshold of a great commercial expansion in South America, to suffer a
Heligoland, or a Gibraltar, or an Aden to be erected by her rivals at
the mouth of her Suez." On the mainland American power was strengthened
by the establishment of a protectorate over Nicaragua in 1916.

=Mexican Relations.=--The extension of American enterprise southward
into Latin America, of which the operations in the Caribbean regions
were merely one phase, naturally carried Americans into Mexico to
develop the natural resources of that country. Under the iron rule of
General Porfirio Diaz, established in 1876 and maintained with only a
short break until 1911, Mexico had become increasingly attractive to our
business men. On the invitation of President Diaz, they had invested
huge sums in Mexican lands, oil fields, and mines, and had laid the
foundations of a new industrial order. The severe regime instituted by
Diaz, however, stirred popular discontent. The peons, or serfs, demanded
the break-up of the great estates, some of which had come down from the
days of Cortez. Their clamor for "the restoration of the land to the
people could not be silenced." In 1911 Diaz was forced to resign and
left the country.

Mexico now slid down the path to disorder. Revolutions and civil
commotions followed in swift succession. A liberal president, Madero,
installed as the successor to Diaz, was deposed in 1913 and brutally
murdered. Huerta, a military adventurer, hailed for a time as another
"strong man," succeeded Madero whose murder he was accused of
instigating. Although Great Britain and nearly all the powers of Europe
accepted the new government as lawful, the United States steadily
withheld recognition. In the meantime Mexico was torn by insurrections
under the leadership of Carranza, a friend of Madero, Villa, a bandit of
generous pretensions, and Zapata, a radical leader of the peons. Without
the support of the United States, Huerta was doomed.

In the summer of 1914, the dictator resigned and fled from the capital,
leaving the field to Carranza. For six years the new president,
recognized by the United States, held a precarious position which he
vigorously strove to strengthen against various revolutionary movements.
At length in 1920, he too was deposed and murdered, and another military
chieftain, Obregon, installed in power.

These events right at our door could not fail to involve the government
of the United States. In the disorders many American citizens lost their
lives. American property was destroyed and land owned by Americans was
confiscated. A new Mexican constitution, in effect nationalizing the
natural resources of the country, struck at the rights of foreign
investors. Moreover the Mexican border was in constant turmoil. Even in
the last days of his administration, Mr. Taft felt compelled to issue a
solemn warning to the Mexican government protesting against the
violation of American rights.

President Wilson, soon after his inauguration, sent a commissioner to
Mexico to inquire into the situation. Although he declared a general
policy of "watchful waiting," he twice came to blows with Mexican
forces. In 1914 some American sailors at Tampico were arrested by a
Mexican officer; the Mexican government, although it immediately
released the men, refused to make the required apology for the incident.
As a result President Wilson ordered the landing of American forces at
Vera Cruz and the occupation of the city. A clash of arms followed in
which several Americans were killed. War seemed inevitable, but at this
juncture the governments of Argentina, Brazil, and Chile tendered their
good offices as mediators. After a few weeks of negotiation, during
which Huerta was forced out of power, American forces were withdrawn
from Vera Cruz and the incident closed.

In 1916 a second break in amicable relations occurred. In the spring of
that year a band of Villa's men raided the town of Columbus, New Mexico,
killing several citizens and committing robberies. A punitive expedition
under the command of General Pershing was quickly sent out to capture
the offenders. Against the protests of President Carranza, American
forces penetrated deeply into Mexico without effecting the object of
the undertaking. This operation lasted until January, 1917, when the
imminence of war with Germany led to the withdrawal of the American
soldiers. Friendly relations were resumed with the Mexican government
and the policy of "watchful waiting" was continued.


THE UNITED STATES AND THE EUROPEAN WAR

=The Outbreak of the War.=--In the opening days of August, 1914, the
age-long jealousies of European nations, sharpened by new imperial
ambitions, broke out in another general conflict such as had shaken the
world in the days of Napoleon. On June 28, the heir to the
Austro-Hungarian throne was assassinated at Serajevo, the capital of
Bosnia, an Austrian province occupied mainly by Serbs. With a view to
stopping Serbian agitation for independence, Austria-Hungary laid the
blame for this incident on the government of Serbia and made humiliating
demands on that country. Germany at once proposed that the issue should
be regarded as "an affair which should be settled solely between
Austria-Hungary and Serbia"; meaning that the small nation should be
left to the tender mercies of a great power. Russia refused to take this
view. Great Britain proposed a settlement by mediation. Germany backed
up Austria to the limit. To use the language of the German authorities:
"We were perfectly aware that a possible warlike attitude of
Austria-Hungary against Serbia might bring Russia upon the field and
that it might therefore involve us in a war, in accordance with our
duties as allies. We could not, however, in these vital interests of
Austria-Hungary which were at stake, advise our ally to take a yielding
attitude not compatible with his dignity nor deny him our assistance."
That made the war inevitable.

Every day of the fateful August, 1914, was crowded with momentous
events. On the 1st, Germany declared war on Russia. On the 2d, the
Germans invaded the little duchy of Luxemburg and notified the King of
Belgium that they were preparing to violate the neutrality of his realm
on their way to Paris. On the same day, Great Britain, anxiously
besought by the French government, promised the aid of the British navy
if German warships made hostile demonstrations in the Channel. August
3d, the German government declared war on France. The following day,
Great Britain demanded of Germany respect for Belgian neutrality and,
failing to receive the guarantee, broke off diplomatic relations. On the
5th, the British prime minister announced that war had opened between
England and Germany. The storm now broke in all its pitiless fury.

=The State of American Opinion.=--Although President Wilson promptly
proclaimed the neutrality of the United States, the sympathies of a
large majority of the American people were without doubt on the side of
Great Britain and France. To them the invasion of the little kingdom of
Belgium and the horrors that accompanied German occupation were odious
in the extreme. Moreover, they regarded the German imperial government
as an autocratic power wielded in the interest of an ambitious military
party. The Kaiser, William II, and the Crown Prince were the symbols of
royal arrogance. On the other hand, many Americans of German descent, in
memory of their ties with the Fatherland, openly sympathized with the
Central Powers; and many Americans of Irish descent, recalling their
long and bitter struggle for home rule in Ireland, would have regarded
British defeat as a merited redress of ancient grievances.

Extremely sensitive to American opinion, but ill informed about it, the
German government soon began systematic efforts to present its cause to
the people of the United States in the most favorable light possible.
Dr. Bernhard Dernburg, the former colonial secretary of the German
empire, was sent to America as a special agent. For months he filled the
newspapers, magazines, and periodicals with interviews, articles, and
notes on the justice of the Teutonic cause. From a press bureau in New
York flowed a stream of pamphlets, leaflets, and cartoons. A magazine,
"The Fatherland," was founded to secure "fair play for Germany and
Austria." Several professors in American universities, who had received
their training in Germany, took up the pen in defense of the Central
Empires. The German language press, without exception it seems, the
National German Alliance, minor German societies, and Lutheran churches
came to the support of the German cause. Even the English language
papers, though generally favorable to the Entente Allies, opened their
columns in the interest of equal justice to the spokesmen for all the
contending powers of Europe.

Before two weeks had elapsed the controversy had become so intense that
President Wilson (August 18, 1914) was moved to caution his countrymen
against falling into angry disputes. "Every man," he said, "who really
loves America will act and speak in the true spirit of neutrality which
is the spirit of impartiality and fairness and friendliness to all
concerned.... We must be impartial in thought as well as in action, must
put a curb upon our sentiments as well as upon every transaction that
might be construed as a preference of one party to the struggle before
another."

=The Clash over American Trade.=--As in the time of the Napoleonic wars,
the conflict in Europe raised fundamental questions respecting rights of
Americans trading with countries at peace as well as those at war. On
this point there existed on August 1, 1914, a fairly definite body of
principles by which nations were bound. Among them the following were of
vital significance. In the first place, it was recognized that an enemy
merchant ship caught on the high seas was a legitimate prize of war
which might be seized and confiscated. In the second place, it was
agreed that "contraband of war" found on an enemy or neutral ship was a
lawful prize; any ship suspected of carrying it was liable to search and
if caught with forbidden goods was subject to seizure. In the third
place, international law prescribed that a peaceful merchant ship,
whether belonging to an enemy or to a neutral country, should not be
destroyed or sunk without provision for the safety of crew and
passengers. In the fourth place, it was understood that a belligerent
had the right, if it could, to blockade the ports of an enemy and
prevent the ingress and egress of all ships; but such a blockade, to be
lawful, had to be effective.

These general principles left undetermined two important matters: "What
is an effective blockade?" and "What is contraband of war?" The task of
answering these questions fell to Great Britain as mistress of the seas.
Although the German submarines made it impossible for her battleships to
maintain a continuous patrol of the waters in front of blockaded ports,

she declared the blockade to be none the less "effective" because her
navy was supreme. As to contraband of war Great Britain put such a broad
interpretation upon the term as to include nearly every important
article of commerce. Early in 1915 she declared even cargoes of grain
and flour to be contraband, defending the action on the ground that the
German government had recently taken possession of all domestic stocks
of corn, wheat, and flour.

A new question arose in connection with American trade with the neutral
countries surrounding Germany. Great Britain early began to intercept
ships carrying oil, gasoline, and copper--all war materials of prime
importance--on the ground that they either were destined ultimately to
Germany or would release goods for sale to Germans. On November 2, 1914,
the English government announced that the Germans wore sowing mines in
open waters and that therefore the whole of the North Sea was a military
zone. Ships bound for Denmark, Norway, and Sweden were ordered to come
by the English Channel for inspection and sailing directions. In effect,
Americans were now licensed by Great Britain to trade in certain
commodities and in certain amounts with neutral countries.

Against these extraordinary measures, the State Department at Washington
lodged pointed objections, saying: "This government is reluctantly
forced to the conclusion that the present policy of His Majesty's
government toward neutral ships and cargoes exceeds the manifest
necessity of a belligerent and constitutes restrictions upon the rights
of American citizens on the high seas, which are not justified by the
rules of international law or required under the principle of
self-preservation."

=Germany Begins the Submarine Campaign.=--Germany now announced that, on
and after February 18, 1915, the whole of the English Channel and the
waters around Great Britain would be deemed a war zone and that every
enemy ship found therein would be destroyed. The German decree added
that, as the British admiralty had ordered the use of neutral flags by
English ships in time of distress, neutral vessels would be in danger of
destruction if found in the forbidden area. It was clear that Germany
intended to employ submarines to destroy shipping. A new factor was thus
introduced into naval warfare, one not provided for in the accepted laws
of war. A warship overhauling a merchant vessel could easily take its
crew and passengers on board for safe keeping as prescribed by
international law; but a submarine ordinarily could do nothing of the
sort. Of necessity the lives and the ships of neutrals, as well as of
belligerents, were put in mortal peril. This amazing conduct Germany
justified on the ground that it was mere retaliation against Great
Britain for her violations of international law.

The response of the United States to the ominous German order was swift
and direct. On February 10, 1915, it warned Germany that if her
commanders destroyed American lives and ships in obedience to that
decree, the action would "be very hard indeed to reconcile with the
friendly relations happily subsisting between the two governments." The
American note added that the German imperial government would be held to
"strict accountability" and all necessary steps would be taken to
safeguard American lives and American rights. This was firm and clear
language, but the only response which it evoked from Germany was a
suggestion that, if Great Britain would allow food supplies to pass
through the blockade, the submarine campaign would be dropped.

=Violations of American Rights.=--Meanwhile Germany continued to ravage
shipping on the high seas. On January 28, a German raider sank the
American ship, _William P. Frye_, in the South Atlantic; on March 28, a
British ship, the _Falaba_, was sunk by a submarine and many on board,
including an American citizen, were killed; and on April 28, a German
airplane dropped bombs on the American steamer _Cushing_. On the morning
of May 1, 1915, Americans were astounded to see in the newspapers an
advertisement, signed by the German Imperial Embassy, warning travelers
of the dangers in the war zone and notifying them that any who ventured
on British ships into that area did so at their own risk. On that day,
the _Lusitania_, a British steamer, sailed from New York for Liverpool.
On May 7, without warning, the ship was struck by two torpedoes and in a
few minutes went down by the bow, carrying to death 1153 persons
including 114 American men, women, and children. A cry of horror ran
through the country. The German papers in America and a few American
people argued that American citizens had been duly warned of the danger
and had deliberately taken their lives into their own hands; but the
terrible deed was almost universally condemned by public opinion.

=The _Lusitania_ Notes.=--On May 14, the Department of State at
Washington made public the first of three famous notes on the
_Lusitania_ case. It solemnly informed the German government that "no
warning that an unlawful and inhumane act will be committed can possibly
be accepted as an excuse or palliation for that act or as an abatement
of the responsibility for its commission." It called upon the German
government to disavow the act, make reparation as far as possible, and
take steps to prevent "the recurrence of anything so obviously
subversive of the principles of warfare." The note closed with a clear
caution to Germany that the government of the United States would not
"omit any word or any act necessary to the performance of its sacred
duty of maintaining the rights of the United States and its citizens and
of safeguarding their free exercise and enjoyment." The die was cast;
but Germany in reply merely temporized.

In a second note, made public on June 11, the position of the United
States was again affirmed. William Jennings Bryan, the Secretary of
State, had resigned because the drift of President Wilson's policy was
not toward mediation but the strict maintenance of American rights, if
need be, by force of arms. The German reply was still evasive and German
naval commanders continued their course of sinking merchant ships. In a
third and final note of July 21, 1915, President Wilson made it clear to
Germany that he meant what he said when he wrote that he would maintain
the rights of American citizens. Finally after much discussion and
shifting about, the German ambassador on September 1, 1915, sent a brief
note to the Secretary of State: "Liners will not be sunk by our
submarines without warning and without safety of the lives of
non-combatants, provided the liners do not try to escape or offer
resistance." Editorially, the New York _Times_ declared: "It is a
triumph not only of diplomacy but of reason, of humanity, of justice,
and of truth." The Secretary of State saw in it "a recognition of the
fundamental principles for which we have contended."

=The Presidential Election of 1916.=--In the midst of this crisis came
the presidential campaign. On the Republican side everything seemed to
depend upon the action of the Progressives. If the breach created in
1912 could be closed, victory was possible; if not, defeat was certain.
A promise of unity lay in the fact that the conventions of the
Republicans and Progressives were held simultaneously in Chicago. The
friends of Roosevelt hoped that both parties would select him as their
candidate; but this hope was not realized. The Republicans chose, and
the Progressives accepted, Charles E. Hughes, an associate justice of
the federal Supreme Court who, as governor of New York, had won a
national reputation by waging war on "machine politicians."

In the face of the clamor for expressions of sympathy with one or the
other of the contending powers of Europe, the Republicans chose a middle
course, declaring that they would uphold all American rights "at home
and abroad, by land and by sea." This sentiment Mr. Hughes echoed in his
acceptance speech. By some it was interpreted to mean a firmer policy in
dealing with Great Britain; by others, a more vigorous handling of the
submarine menace. The Democrats, on their side, renominated President
Wilson by acclamation, reviewed with pride the legislative achievements
of the party, and commended "the splendid diplomatic victories of our
great President who has preserved the vital interests of our government
and its citizens and kept us out of war."

In the election which ensued President Wilson's popular vote exceeded
that cast for Mr. Hughes by more than half a million, while his
electoral vote stood 277 to 254. The result was regarded, and not
without warrant, as a great personal triumph for the President. He had
received the largest vote yet cast for a presidential candidate. The
Progressive party practically disappeared, and the Socialists suffered a
severe set-back, falling far behind the vote of 1912.

=President Wilson Urges Peace upon the Warring Nations.=--Apparently
convinced that his pacific policies had been profoundly approved by his
countrymen, President Wilson, soon after the election, addressed "peace
notes" to the European belligerents. On December 16, the German Emperor
proposed to the Allied Powers that they enter into peace negotiations, a
suggestion that was treated as a mere political maneuver by the opposing
governments. Two days later President Wilson sent a note to the warring
nations asking them to avow "the terms upon which war might be
concluded." To these notes the Central Powers replied that they were
ready to meet their antagonists in a peace conference; and Allied Powers
answered by presenting certain conditions precedent to a satisfactory
settlement. On January 22, 1917, President Wilson in an address before
the Senate, declared it to be a duty of the United States to take part
in the establishment of a stable peace on the basis of certain
principles. These were, in short: "peace without victory"; the right of
nationalities to freedom and self-government; the independence of
Poland; freedom of the seas; the reduction of armaments; and the
abolition of entangling alliances. The whole world was discussing the
President's remarkable message, when it was dumbfounded to hear, on
January 31, that the German ambassador at Washington had announced the
official renewal of ruthless submarine warfare.


THE UNITED STATES AT WAR

=Steps toward War.=--Three days after the receipt of the news that the
German government intended to return to its former submarine policy,
President Wilson severed diplomatic relations with the German empire. At
the same time he explained to Congress that he desired no conflict with
Germany and would await an "overt act" before taking further steps to
preserve American rights. "God grant," he concluded, "that we may not be
challenged to defend them by acts of willful injustice on the part of
the government of Germany." Yet the challenge came. Between February 26
and April 2, six American merchant vessels were torpedoed, in most cases
without any warning and without regard to the loss of American lives.
President Wilson therefore called upon Congress to answer the German
menace. The reply of Congress on April 6 was a resolution, passed with
only a few dissenting votes, declaring the existence of a state of war
with Germany. Austria-Hungary at once severed diplomatic relations with
the United States; but it was not until December 7 that Congress, acting
on the President's advice, declared war also on that "vassal of the
German government."

=American War Aims.=--In many addresses at the beginning and during the
course of the war, President Wilson stated the purposes which actuated
our government in taking up arms. He first made it clear that it was a
war of self-defense. "The military masters of Germany," he exclaimed,
"denied us the right to be neutral." Proof of that lay on every hand.
Agents of the German imperial government had destroyed American lives
and American property on the high seas. They had filled our communities
with spies. They had planted bombs in ships and munition works. They had
fomented divisions among American citizens.

Though assailed in many ways and compelled to resort to war, the United
States sought no material rewards. "The world must be made safe for
democracy. Its peace must be planted upon the tested foundations of
political liberty. We have no selfish ends to serve. We desire no
conquest, no dominion. We seek no indemnities for ourselves."

In a very remarkable message read to Congress on January 8, 1918,
President Wilson laid down his famous "fourteen points" summarizing the
ideals for which we were fighting. They included open treaties of peace,
openly arrived at; absolute freedom of navigation upon the seas; the
removal, as far as possible, of trade barriers among nations; reduction
of armaments; adjustment of colonial claims in the interest of the
populations concerned; fair and friendly treatment of Russia; the
restoration of Belgium; righting the wrong done to France in 1871 in the
matter of Alsace-Lorraine; adjustment of Italian frontiers along the
lines of nationality; more liberty for the peoples of Austria-Hungary;
the restoration of Serbia and Rumania; the readjustment of the Turkish
Empire; an independent Poland; and an association of nations to afford
mutual guarantees to all states great and small. On a later occasion
President Wilson elaborated the last point, namely, the formation of a
league of nations to guarantee peace and establish justice among the
powers of the world. Democracy, the right of nations to determine their
own fate, a covenant of enduring peace--these were the ideals for which
the American people were to pour out their blood and treasure.

=The Selective Draft.=--The World War became a war of nations. The
powers against which we were arrayed had every able-bodied man in
service and all their resources, human and material, thrown into the
scale. For this reason, President Wilson summoned the whole people of
the United States to make every sacrifice necessary for victory.
Congress by law decreed that the national army should be chosen from all
male citizens and males not enemy aliens who had declared their
intention of becoming citizens. By the first act of May 18, 1917, it
fixed the age limits at twenty-one to thirty-one inclusive. Later, in
August, 1918, it extended them to eighteen and forty-five. From the men
of the first group so enrolled were chosen by lot the soldiers for the
World War who, with the regular army and the national guard, formed the
American Expeditionary Force upholding the American cause on the
battlefields of Europe. "The whole nation," said the President, "must be
a team in which each man shall play the part for which he is best
fitted."

=Liberty Loans and Taxes.=--In order that the military and naval forces
should be stinted in no respect, the nation was called upon to place its
financial resources at the service of the government. Some urged the
"conscription of wealth as well as men," meaning the support of the war
out of taxes upon great fortunes; but more conservative counsels
prevailed. Four great Liberty Loans were floated, all the agencies of
modern publicity being employed to enlist popular interest. The first
loan had four and a half million subscribers; the fourth more than
twenty million. Combined with loans were heavy taxes. A progressive tax
was laid upon incomes beginning with four per cent on incomes in the
lower ranges and rising to sixty-three per cent of that part of any
income above $2,000,000. A progressive tax was levied upon inheritances.
An excess profits tax was laid upon all corporations and partnerships,
rising in amount to sixty per cent of the net income in excess of
thirty-three per cent on the invested capital. "This," said a
distinguished economist, "is the high-water mark in the history of
taxation. Never before in the annals of civilization has an attempt been
made to take as much as two-thirds of a man's income by taxation."

=Mobilizing Material Resources.=--No stone was left unturned to provide
the arms, munitions, supplies, and transportation required in the
gigantic undertaking. Between the declaration of war and the armistice,
Congress enacted law after law relative to food supplies, raw materials,
railways, mines, ships, forests, and industrial enterprises. No power
over the lives and property of citizens, deemed necessary to the
prosecution of the armed conflict, was withheld from the government. The
farmer's wheat, the housewife's sugar, coal at the mines, labor in the
factories, ships at the wharves, trade with friendly countries, the
railways, banks, stores, private fortunes--all were mobilized and laid
under whatever obligations the government deemed imperative. Never was a
nation more completely devoted to a single cause.

A law of August 10, 1917, gave the President power to fix the prices of
wheat and coal and to take almost any steps necessary to prevent
monopoly and excessive prices. By a series of measures, enlarging the
principles of the shipping act of 1916, ships and shipyards were brought
under public control and the government was empowered to embark upon a
great ship-building program. In December, 1917, the government assumed
for the period of the war the operation of the railways under a
presidential proclamation which was elaborated in March, 1918, by act of
Congress. In the summer of 1918 the express, telephone, and telegraph
business of the entire country passed under government control. By war
risk insurance acts allowances were made for the families of enlisted
men, compensation for injuries was provided, death benefits were
instituted, and a system of national insurance was established in the
interest of the men in service. Never before in the history of the
country had the government taken such a wise and humane view of its
obligations to those who served on the field of battle or on the seas.

=The Espionage and Sedition Acts.=--By the Espionage law of June 15,
1917, and the amending law, known as the Sedition act, passed in May of
the following year, the government was given a drastic power over the
expression of opinion. The first measure penalized those who conveyed
information to a foreign country to be used to the injury of the United
States; those who made false statements designed to interfere with the
military or naval forces of the United States; those who attempted to
stir up insubordination or disloyalty in the army and navy; and those
who willfully obstructed enlistment. The Sedition act was still more
severe and sweeping in its terms. It imposed heavy penalties upon any
person who used "abusive language about the government or institutions
of the country." It authorized the dismissal of any officer of the
government who committed "disloyal acts" or uttered "disloyal language,"
and empowered the Postmaster General to close the mails to persons
violating the law. This measure, prepared by the Department of Justice,
encountered vigorous opposition in the Senate, where twenty-four
Republicans and two Democrats voted against it. Senator Johnson of
California denounced it as a law "to suppress the freedom of the press
in the United States and to prevent any man, no matter who he is, from
expressing legitimate criticism concerning the present government." The
constitutionality of the acts was attacked; but they were sustained by
the Supreme Court and stringently enforced.

[Illustration: _Copyright by Underwood and Underwood, N.Y._

THE LAUNCHING OF A SHIP AT THE GREAT NAVAL YARDS, NEWARK, N.J.]

=Labor and the War.=--In view of the restlessness of European labor
during the war and especially the proletarian revolution in Russia in
November, 1917, some anxiety was early expressed as to the stand which
organized labor might take in the United States. It was, however, soon
dispelled. Samuel Gompers, speaking for the American Federation of
Labor, declared that "this is labor's war," and pledged the united
support of all the unions. There was some dissent. The Socialist party
denounced the war as a capitalist quarrel; but all the protests combined
were too slight to have much effect. American labor leaders were sent to
Europe to strengthen the wavering ranks of trade unionists in war-worn
England, France, and Italy. Labor was given representation on the
important boards and commissions dealing with industrial questions.
Trade union standards were accepted by the government and generally
applied in industry. The Department of Labor became one of the powerful
war centers of the nation. In a memorable address to the American
Federation of Labor, President Wilson assured the trade unionists that
labor conditions should not be made unduly onerous by the war and
received in return a pledge of loyalty from the Federation. Recognition
of labor's contribution to winning the war was embodied in the treaty of
peace, which provided for a permanent international organization to
promote the world-wide effort of labor to improve social conditions.
"The league of nations has for its object the establishment of universal
peace," runs the preamble to the labor section of the treaty, "and such
a peace can be established only if it is based upon social justice....
The failure of any nation to adopt humane conditions of labor is an
obstacle in the way of other nations which desire to improve the
conditions in their own countries."

=The American Navy in the War.=--As soon as Congress declared war the
fleet was mobilized, American ports were thrown open to the warships of
the Allies, immediate provision was made for increasing the number of
men and ships, and a contingent of war vessels was sent to cooperate
with the British and French in their life-and-death contest with
submarines. Special effort was made to stimulate the production of
"submarine chasers" and "scout cruisers" to be sent to the danger zone.
Convoys were provided to accompany the transports conveying soldiers to
France. Before the end of the war more than three hundred American
vessels and 75,000 officers and men were operating in European waters.
Though the German fleet failed to come out and challenge the sea power
of the Allies, the battleships of the United States were always ready to
do their full duty in such an event. As things turned out, the service
of the American navy was limited mainly to helping in the campaign that
wore down the submarine menace to Allied shipping.

=The War in France.=--Owing to the peculiar character of the warfare in
France, it required a longer time for American military forces to get
into action; but there was no unnecessary delay. Soon after the
declaration of war, steps were taken to give military assistance to the
Allies. The regular army was enlarged and the troops of the national
guard were brought into national service. On June 13, General John J.
Pershing, chosen head of the American Expeditionary Forces, reached
Paris and began preparations for the arrival of our troops. In June, the
vanguard of the army reached France. A slow and steady stream followed.
As soon as the men enrolled under the draft were ready, it became a
flood. During the period of the war the army was enlarged from about
190,000 men to 3,665,000, of whom more than 2,000,000 were in France
when the armistice was signed.

Although American troops did not take part on a large scale until the
last phase of the war in 1918, several battalions of infantry were in
the trenches by October, 1917, and had their first severe encounter with
the Germans early in November. In January, 1918, they took over a part
of the front line as an American sector. In March, General Pershing
placed our forces at the disposal of General Foch, commander-in-chief of
the Allied armies. The first division, which entered the Montdidier
salient in April, soon was engaged with the enemy, "taking with splendid
dash the town of Cantigny and all other objectives, which were organized
and held steadfastly against vicious counter attacks and galling
artillery fire."

[Illustration: _Copyright by Underwood and Underwood, N.Y._

TROOPS RETURNING FROM FRANCE]

When the Germans launched their grand drives toward the Marne and Paris,
in June and July, 1918, every available man was placed at General Foch's
command. At Belleau Wood, at Chateau-Thierry, and other points along the
deep salient made by the Germans into the French lines, American
soldiers distinguished themselves by heroic action. They also played an
important role in the counter attack that "smashed" the salient and
drove the Germans back.

In September, American troops, with French aid, "wiped out" the German
salient at St. Mihiel. By this time General Pershing was ready for the
great American drive to the northeast in the Argonne forest, while he
also cooperated with the British in the assault on the Hindenburg line.
In the Meuse-Argonne battle, our soldiers encountered some of the most
severe fighting of the war and pressed forward steadily against the most
stubborn resistance from the enemy. On the 6th of November, reported
General Pershing, "a division of the first corps reached a point on the
Meuse opposite Sedan, twenty-five miles from our line of departure. The
strategical goal which was our highest hope was gained. We had cut the
enemy's main line of communications and nothing but a surrender or an
armistice could save his army from complete disaster." Five days later
the end came. On the morning of November 11, the order to cease firing
went into effect. The German army was in rapid retreat and
demoralization had begun. The Kaiser had abdicated and fled into
Holland. The Hohenzollern dreams of empire were shattered. In the
fifty-second month, the World War, involving nearly every civilized
nation on the globe, was brought to a close. More than 75,000 American
soldiers and sailors had given their lives. More than 250,000 had been
wounded or were missing or in German prison camps.

[Illustration: WESTERN BATTLE LINES OF THE VARIOUS YEARS OF THE
WORLD WAR]


THE SETTLEMENT AT PARIS

=The Peace Conference.=--On January 18, 1919, a conference of the Allied
and Associated Powers assembled to pronounce judgment upon the German
empire and its defeated satellites: Austria-Hungary, Bulgaria, and
Turkey. It was a moving spectacle. Seventy-two delegates spoke for
thirty-two states. The United States, Great Britain, France, Italy, and
Japan had five delegates each. Belgium, Brazil, and Serbia were each
assigned three. Canada, Australia, South Africa, India, China, Greece,
Hedjaz, Poland, Portugal, Rumania, Siam, and Czechoslovakia were
allotted two apiece. The remaining states of New Zealand, Bolivia, Cuba,
Ecuador, Guatemala, Haiti, Honduras, Liberia, Nicaragua, Panama, Peru,
and Uruguay each had one delegate. President Wilson spoke in person for
the United States. England, France, and Italy were represented by their
premiers: David Lloyd George, Georges Clemenceau, and Vittorio Orlando.

[Illustration: PREMIERS LLOYD GEORGE, ORLANDO AND CLEMENCEAU AND
PRESIDENT WILSON AT PARIS]

=The Supreme Council.=--The real work of the settlement was first
committed to a Supreme Council of ten representing the United States,
Great Britain, France, Italy, and Japan. This was later reduced to five
members. Then Japan dropped out and finally Italy, leaving only
President Wilson and the Premiers, Lloyd George and Clemenceau, the
"Big Three," who assumed the burden of mighty decisions. On May 6, their
work was completed and in a secret session of the full conference the
whole treaty of peace was approved, though a few of the powers made
reservations or objections. The next day the treaty was presented to the
Germans who, after prolonged protests, signed on the last day of grace,
June 28. This German treaty was followed by agreements with Austria,
Hungary, Bulgaria, and Turkey. Collectively these great documents formed
the legal basis of the general European settlement.

=The Terms of the Settlement.=--The combined treaties make a huge
volume. The German treaty alone embraces about 80,000 words.
Collectively they cover an immense range of subjects which may be
summarized under five heads: (1) The territorial settlement in Europe;
(2) the destruction of German military power; (3) reparations for
damages done by Germany and her allies; (4) the disposition of German
colonies and protectorates; and (5) the League of Nations.

Germany was reduced by the cession of Alsace-Lorraine to France and the
loss of several other provinces. Austria-Hungary was dissolved and
dismembered. Russia was reduced by the creation of new states on the
west. Bulgaria was stripped of her gains in the recent Balkan wars.
Turkey was dismembered. Nine new independent states were created:
Poland, Finland, Lithuania, Latvia, Esthonia, Ukraine, Czechoslovakia,
Armenia, and Hedjaz. Italy, Greece, Rumania, and Serbia were enlarged by
cessions of territory and Serbia was transformed into the great state of
Jugoslavia.

The destruction of German military power was thorough. The entire navy,
with minor exceptions, was turned over to the Allied and Associated
Powers; Germany's total equipment for the future was limited to six
battleships and six light cruisers, with certain small vessels but no
submarines. The number of enlisted men and officers for the army was
fixed at not more than 100,000; the General Staff was dissolved; and the
manufacture of munitions restricted.

Germany was compelled to accept full responsibility for all damages; to
pay five billion dollars in cash and goods, and to make certain other
payments which might be ordered from time to time by an inter-allied
reparations commission. She was also required to deliver to Belgium,
France, and Italy, millions of tons of coal every year for ten years;
while by way of additional compensation to France the rich coal basin of
the Saar was placed under inter-allied control to be exploited under
French administration for a period of at least fifteen years. Austria
and the other associates of Germany were also laid under heavy
obligations to the victors. Damages done to shipping by submarines and
other vessels were to be paid for on the basis of ton for ton.

The disposition of the German colonies and the old Ottoman empire
presented knotty problems. It was finally agreed that the German
colonies and Turkish provinces which were in a backward stage of
development should be placed under the tutelage of certain powers acting
as "mandatories" holding them in "a sacred trust of civilization." An
exception to the mandatory principle arose in the case of German rights
in Shantung, all of which were transferred directly to Japan. It was
this arrangement that led the Chinese delegation to withhold their
signatures from the treaty.

=The League of Nations.=--High among the purposes which he had in mind
in summoning the nation to arms, President Wilson placed the desire to
put an end to war. All through the United States the people spoke of the
"war to end war." No slogan called forth a deeper response from the
public. The President himself repeatedly declared that a general
association of nations must be formed to guard the peace and protect all
against the ambitions of the few. "As I see it," he said in his address
on opening the Fourth Liberty Loan campaign, "the constitution of the
League of Nations and the clear definition of its objects must be a
part, in a sense the most essential part, of the peace settlement
itself."

Nothing was more natural, therefore, than Wilson's insistence at Paris
upon the formation of an international association. Indeed he had gone
to Europe in person largely to accomplish that end. Part One of the
treaty with Germany, the Covenant of the League of Nations, was due to
his labors more than to any other influence. Within the League thus
created were to be embraced all the Allied and Associated Powers and
nearly all the neutrals. By a two-thirds vote of the League Assembly the
excluded nations might be admitted.

The agencies of the League of Nations were to be three in number: (1) a
permanent secretariat located at Geneva; (2) an Assembly consisting of
one delegate from each country, dominion, or self-governing colony
(including Canada, Australia, South Africa, New Zealand, and India); (3)
and a Council consisting of representatives of the United States, Great
Britain, France, Italy, and Japan, and four other representatives
selected by the Assembly from time to time.

The duties imposed on the League and the obligations accepted by its
members were numerous and important. The Council was to take steps to
formulate a scheme for the reduction of armaments and to submit a plan
for the establishment of a permanent Court of International Justice. The
members of the League (Article X) were to respect and preserve as
against external aggression the territorial integrity and existing
political independence of all the associated nations. They were to
submit to arbitration or inquiry by the Council all disputes which could
not be adjusted by diplomacy and in no case to resort to war until three
months after the award. Should any member disregard its covenants, its
action would be considered an act of war against the League, which would
accordingly cut off the trade and business of the hostile member and
recommend through the Council to the several associated governments the
military measures to be taken. In case the decision in any arbitration
of a dispute was unanimous, the members of the League affected by it
were to abide by it.

Such was the settlement at Paris and such was the association of nations
formed to promote the peace of the world. They were quickly approved by
most of the powers, and the first Assembly of the League of Nations met
at Geneva late in 1920.

=The Treaty in the United States.=--When the treaty was presented to the
United States Senate for approval, a violent opposition appeared. In
that chamber the Republicans had a slight majority and a two-thirds vote
was necessary for ratification. The sentiment for and against the treaty
ran mainly along party lines; but the Republicans were themselves
divided. The major portion, known as "reservationists," favored
ratification with certain conditions respecting American rights; while a
small though active minority rejected the League of Nations in its
entirety, announcing themselves to be "irreconcilables." The grounds of
this Republican opposition lay partly in the terms of peace imposed on
Germany and partly in the Covenant of the League of Nations. Exception
was taken to the clauses which affected the rights of American citizens
in property involved in the adjustment with Germany, but the burden of
criticism was directed against the League. Article X guaranteeing
against external aggression the political independence and territorial
integrity of the members of the League was subjected to a specially
heavy fire; while the treatment accorded to China and the sections
affecting American internal affairs were likewise attacked as "unjust
and dangerous." As an outcome of their deliberations, the Republicans
proposed a long list of reservations which touched upon many of the
vital parts of the treaty. These were rejected by President Wilson as
amounting in effect to a "nullification of the treaty." As a deadlock
ensued the treaty was definitely rejected, owing to the failure of its
sponsors to secure the requisite two-thirds vote.

[Illustration: EUROPE]

=The League of Nations in the Campaign of 1920.=--At this juncture the
presidential campaign of 1920 opened. The Republicans, while condemning
the terms of the proposed League, endorsed the general idea of an
international agreement to prevent war. Their candidate, Senator
Warren G. Harding of Ohio, maintained a similar position without saying
definitely whether the League devised at Paris could be recast in such a
manner as to meet his requirements. The Democrats, on the other hand,
while not opposing limitations clarifying the obligations of the United
States, demanded "the immediate ratification of the treaty without
reservations which would impair its essential integrity." The Democratic
candidate, Governor James M. Cox, of Ohio, announced his firm conviction
that the United States should "go into the League," without closing the
door to mild reservations; he appealed to the country largely on that
issue. The election of Senator Harding, in an extraordinary "landslide,"
coupled with the return of a majority of Republicans to the Senate, made
uncertain American participation in the League of Nations.

=The United States and International Entanglements.=--Whether America
entered the League or not, it could not close its doors to the world and
escape perplexing international complications. It had ever-increasing
financial and commercial connections with all other countries. Our
associates in the recent war were heavily indebted to our government.
The prosperity of American industries depended to a considerable extent
upon the recovery of the impoverished and battle-torn countries of
Europe.

There were other complications no less specific. The United States was
compelled by force of circumstances to adopt a Russian policy. The
government of the Czar had been overthrown by a liberal revolution,
which in turn had been succeeded by an extreme, communist
"dictatorship." The Bolsheviki, or majority faction of the socialists,
had obtained control of the national council of peasants, workingmen,
and soldiers, called the soviet, and inaugurated a radical regime. They
had made peace with Germany in March, 1918. Thereupon the United States
joined England, France, and Japan in an unofficial war upon them. After
the general settlement at Paris in 1919, our government, while
withdrawing troops from Siberia and Archangel, continued in its refusal
to recognize the Bolshevists or to permit unhampered trade with them.
President Wilson repeatedly denounced them as the enemies of
civilization and undertook to lay down for all countries the principles
which should govern intercourse with Russia.

Further international complications were created in connection with the
World War, wholly apart from the terms of peace or the League of
Nations. The United States had participated in a general European
conflict which changed the boundaries of countries, called into being
new nations, and reduced the power and territories of the vanquished.
Accordingly, it was bound to face the problem of how far it was prepared
to cooperate with the victors in any settlement of Europe's
difficulties. By no conceivable process, therefore, could America be
disentangled from the web of world affairs. Isolation, if desirable, had
become impossible. Within three hundred years from the founding of the
tiny settlements at Jamestown and Plymouth, America, by virtue of its
institutions, its population, its wealth, and its commerce, had become
first among the nations of the earth. By moral obligations and by
practical interests its fate was thus linked with the destiny of all
mankind.


SUMMARY OF DEMOCRACY AND THE WORLD WAR

The astounding industrial progress that characterized the period
following the Civil War bequeathed to the new generation many perplexing
problems connected with the growth of trusts and railways, the
accumulation of great fortunes, the increase of poverty in the
industrial cities, the exhaustion of the free land, and the acquisition
of dominions in distant seas. As long as there was an abundance of land
in the West any able-bodied man with initiative and industry could
become an independent farmer. People from the cities and immigrants from
Europe had always before them that gateway to property and prosperity.
When the land was all gone, American economic conditions inevitably
became more like those of Europe.

Though the new economic questions had been vigorously debated in many
circles before his day, it was President Roosevelt who first discussed
them continuously from the White House. The natural resources of the
country were being exhausted; he advocated their conservation. Huge
fortunes were being made in business creating inequalities in
opportunity; he favored reducing them by income and inheritance taxes.
Industries were disturbed by strikes; he pressed arbitration upon
capital and labor. The free land was gone; he declared that labor was in
a less favorable position to bargain with capital and therefore should
organize in unions for collective bargaining. There had been wrong-doing
on the part of certain great trusts; those responsible should be
punished.

The spirit of reform was abroad in the land. The spoils system was
attacked. It was alleged that the political parties were dominated by
"rings and bosses." The United States Senate was called "a millionaires'
club." Poverty and misery were observed in the cities. State
legislatures and city governments were accused of corruption.

In answer to the charges, remedies were proposed and adopted. Civil
service reform was approved. The Australian ballot, popular election of
Senators, the initiative, referendum, and recall, commission and city
manager plans for cities, public regulation of railways, compensation
for those injured in industries, minimum wages for women and children,
pensions for widows, the control of housing in the cities--these and a
hundred other reforms were adopted and tried out. The national watchword
became: "America, Improve Thyself."

The spirit of reform broke into both political parties. It appeared in
many statutes enacted by Congress under President Taft's leadership. It
disrupted the Republicans temporarily in 1912 when the Progressive party
entered the field. It led the Democratic candidate in that year,
Governor Wilson, to make a "progressive appeal" to the voters. It
inspired a considerable program of national legislation under President
Wilson's two administrations.

In the age of change, four important amendments to the federal
constitution, the first in more than forty years, were adopted. The
sixteenth empowered Congress to lay an income tax. The seventeenth
assured popular election of Senators. The eighteenth made prohibition
national. The nineteenth, following upon the adoption of woman suffrage
in many states, enfranchised the women of the nation.

In the sphere of industry, equally great changes took place. The major
portion of the nation's business passed into the hands of corporations.
In all the leading industries of the country labor was organized into
trade unions and federated in a national organization. The power of
organized capital and organized labor loomed upon the horizon. Their
struggles, their rights, and their place in the economy of the nation
raised problems of the first magnitude.

While the country was engaged in a heated debate upon its domestic
issues, the World War broke out in Europe in 1914. As a hundred years
before, American rights upon the high seas became involved at once. They
were invaded on both sides; but Germany, in addition to assailing
American ships and property, ruthlessly destroyed American lives. She
set at naught the rules of civilized warfare upon the sea. Warnings from
President Wilson were without avail. Nothing could stay the hand of the
German war party.

After long and patient negotiations, President Wilson in 1917 called
upon the nation to take up arms against an assailant that had in effect
declared war upon America. The answer was swift and firm. The national
resources, human and material, were mobilized. The navy was enlarged, a
draft army created, huge loans floated, heavy taxes laid, and the spirit
of sacrifice called forth in a titanic struggle against an autocratic
power that threatened to dominate Europe and the World.

In the end, American financial, naval, and military assistance counted
heavily in the scale. American sailors scoured the seas searching for
the terrible submarines. American soldiers took part in the last great
drives that broke the might of Germany's army. Such was the nation's
response to the President's summons to arms in a war "for democracy" and
"to end war."

When victory crowned the arms of the powers united against Germany,
President Wilson in person took part in the peace council. He sought to
redeem his pledge to end wars by forming a League of Nations to keep the
peace. In the treaty drawn at the close of the war the first part was a
covenant binding the nations in a permanent association for the
settlement of international disputes. This treaty, the President offered
to the United States Senate for ratification and to his country for
approval.

Once again, as in the days of the Napoleonic wars, the people seriously
discussed the place of America among the powers of the earth. The Senate
refused to ratify the treaty. World politics then became an issue in the
campaign of 1920. Though some Americans talked as if the United States
could close its doors and windows against all mankind, the victor in the
election, Senator Harding, of Ohio, knew better. The election returns
were hardly announced before he began to ask the advice of his
countrymen on the pressing theme that would not be downed: "What part
shall America--first among the nations of the earth in wealth and
power--assume at the council table of the world?"


=General References=

Woodrow Wilson, _The New Freedom_.

C.L. Jones, _The Caribbean Interests of the United States_.

H.P. Willis, _The Federal Reserve_.

C.W. Barron, _The Mexican Problem_ (critical toward Mexico).

L.J. de Bekker, _The Plot against Mexico_ (against American
intervention).

Theodore Roosevelt, _America and the World War_.

E.E. Robinson and V.J. West, _The Foreign Policy of Woodrow Wilson_.

J.S. Bassett, _Our War with Germany_.

Carlton J.H. Hayes, _A Brief History of the Great War_.

J.B. McMaster, _The United States in the World War_.


=Research Topics=

=President Wilson's First Term.=--Elson, _History of the United States_,
pp. 925-941.

=The Underwood Tariff Act.=--Ogg, _National Progress_ (The American
Nation Series), pp. 209-226.

=The Federal Reserve System.=--Ogg, pp. 228-232.

=Trust and Labor Legislation.=--Ogg, pp. 232-236.

=Legislation Respecting the Territories.=--Ogg, pp. 236-245.

=American Interests in the Caribbean.=--Ogg, pp. 246-265.

=American Interests in the Pacific.=--Ogg, pp. 304-324.

=Mexican Affairs.=--Haworth, pp. 388-395; Ogg, pp. 284-304.

=The First Phases of the European War.=--Haworth, pp. 395-412; Ogg, pp.
325-343.

=The Campaign of 1916.=--Haworth, pp. 412-418; Ogg, pp. 364-383.

=America Enters the War.=--Haworth, pp. 422-440; pp. 454-475. Ogg, pp.
384-399; Elson, pp. 951-970.

=Mobilizing the Nation.=--Haworth, pp. 441-453.

=The Peace Settlement.=--Haworth, pp. 475-497; Elson, pp. 971-982.


=Questions=

1. Enumerate the chief financial measures of the Wilson administration.
Review the history of banks and currency and give the details of the
Federal reserve law.

2. What was the Wilson policy toward trusts? Toward labor?

3. Review again the theory of states' rights. How has it fared in recent
years?

4. What steps were taken in colonial policies? In the Caribbean?

5. Outline American-Mexican relations under Wilson.

6. How did the World War break out in Europe?

7. Account for the divided state of opinion in America.

8. Review the events leading up to the War of 1812. Compare them with
the events from 1914 to 1917.

9. State the leading principles of international law involved and show
how they were violated.

10. What American rights were assailed in the submarine campaign?

11. Give Wilson's position on the _Lusitania_ affair.

12. How did the World War affect the presidential campaign of 1916?

13. How did Germany finally drive the United States into war?

14. State the American war aims given by the President.

15. Enumerate the measures taken by the government to win the war.

16. Review the part of the navy in the war. The army.

17. How were the terms of peace formulated?

18. Enumerate the principal results of the war.

19. Describe the League of Nations.

20. Trace the fate of the treaty in American politics.

21. Can there be a policy of isolation for America?




APPENDIX

CONSTITUTION OF THE UNITED STATES


We the people of the United States, in order to form a more
perfect union, establish justice, insure domestic tranquillity, provide
for the common defence, promote the general welfare, and secure the
blessings of liberty to ourselves and our posterity, do ordain and
establish this Constitution for the United States of America.


ARTICLE I

SECTION 1. All legislative powers herein granted shall be vested in a
Congress of the United States, which shall consist of a Senate and House
of Representatives.


SECTION 2. 1. The House of Representatives shall be composed of members
chosen every second year by the people of the several States, and the
electors in each State shall have the qualifications requisite for
electors of the most numerous branch of the State legislature.

2. No person shall be a representative who shall not have attained to
the age of twenty-five years, and been seven years a citizen of the
United States, and who shall not, when elected, be an inhabitant of that
State in which he shall be chosen.

3. Representatives and direct taxes[3] shall be apportioned among the
several States which may be included within this Union, according to
their respective numbers, which shall be determined by adding to the
whole number of free persons, including those bound to service for a
term of years, and excluding Indians not taxed, three-fifths of all
other persons.[3] The actual enumeration shall be made within three
years after the first meeting of the Congress of the United States, and
within every subsequent term of ten years, in such manner as they shall
by law direct. The number of representatives shall not exceed one for
every thirty thousand, but each State shall have at least one
representative; and until such enumeration shall be made, the State of
New Hampshire shall be entitled to choose three, Massachusetts eight,
Rhode Island and Providence Plantations one, Connecticut five, New York
six, New Jersey four, Pennsylvania eight, Delaware one, Maryland six,
Virginia ten, North Carolina five, South Carolina five, and Georgia
three.

4. When vacancies happen in the representation from any State, the
executive authority thereof shall issue writs of election to fill such
vacancies.

5. The House of Representatives shall choose their speaker and other
officers; and shall have the sole power of impeachment.


SECTION 3. 1. The Senate of the United States shall be composed of two
senators from each State, chosen by the legislature thereof, for six
years; and each senator shall have one vote.[4]

2. Immediately after they shall be assembled in consequence of the first
election, they shall be divided as equally as may be into three classes.
The seats of the senators of the first class shall be vacated at the
expiration of the second year, of the second class at the expiration of
the fourth year, and of the third class at the expiration of the sixth
year, so that one-third may be chosen every second year; and if
vacancies happen by resignation, or otherwise, during the recess of the
legislature of any State, the executive thereof may make temporary
appointments until the next meeting of the legislature, which shall then
fill such vacancies.[5]

3. No person shall be a senator who shall not have attained to the age
of thirty years, and been nine years a citizen of the United States, and
who shall not, when elected, be an inhabitant of that State for which he
shall be chosen.

4. The Vice-President of the United States shall be President of the
Senate, but shall have no vote, unless they be equally divided.

5. The Senate shall choose their other officers, and also a President
_pro tempore_, in the absence of the Vice-President, or when he shall
exercise the office of President of the United States.

6. The Senate shall have the sole power to try all impeachments. When
sitting for that purpose, they shall be on oath or affirmation. When the
President of the United States is tried, the chief justice shall
preside: And no person shall be convicted without the concurrence of
two-thirds of the members present.

7. Judgment in cases of impeachment shall not extend further than to
removal from office, and disqualification to hold and enjoy any office
of honor, trust, or profit under the United States: but the party
convicted shall nevertheless be liable and subject to indictment, trial,
judgment, and punishment, according to law.


SECTION 4. 1. The times, places, and manner of holding elections for
senators and representatives, shall be prescribed in each State by the
legislature thereof; but the Congress may at any time by law make or
alter such regulations, except as to the places of choosing senators.

2. The Congress shall assemble at least once in every year, and such
meeting shall be on the first Monday in December, unless they shall by
law appoint a different day.


SECTION 5. 1. Each House shall be the judge of the elections, returns
and qualifications of its own members, and a majority of each shall
constitute a quorum to do business; but a smaller number may adjourn
from day to day, and may be authorized to compel the attendance of
absent members, in such manner, and under such penalties as each House
may provide.

2. Each House may determine the rules of its proceedings, punish its
members for disorderly behaviour, and, with the concurrence of
two-thirds, expel a member.

3. Each House shall keep a journal of its proceedings, and from time to
time publish the same, excepting such parts as may in their judgment
require secrecy; and the yeas and nays of the members of either House on
any question shall, at the desire of one-fifth of those present, be
entered on the journal.

4. Neither House, during the session of Congress, shall, without the
consent of the other, adjourn for more than three days, nor to any other
place than that in which the two Houses shall be sitting.


SECTION 6. 1. The senators and representatives shall receive a
compensation for their services, to be ascertained by law, and paid out
of the Treasury of the United States. They shall in all cases, except
treason, felony, and breach of the peace, be privileged from arrest
during their attendance at the sessions of their respective Houses, and
in going to and returning from the same; and, for any speech or debate
in either House, they shall not be questioned in any other place.

2. No senator or representative shall, during the time for which he was
elected, be appointed to any civil office under the authority of the
United States, which shall have been created, or the emoluments whereof
shall have been increased during such time; and no person, holding any
office under the United States, shall be a member of either House during
his continuance in office.


SECTION 7. 1. All bills for raising revenue shall originate in the House
of Representatives; but the Senate may propose or concur with amendments
as on other bills.

2. Every bill, which shall have passed the House of Representatives; and
the Senate, shall, before it become a law, be presented to the President
of the United States; if he approve he shall sign it, but if not he
shall return it with his objections to that House, in which it shall
have originated, who shall enter the objections at large on their
journal, and proceed to reconsider it. If after such reconsideration
two-thirds of that House shall agree to pass the bill, it shall be sent,
together with the objections, to the other House, by which it shall
likewise be reconsidered, and if approved by two-thirds of that House,
it shall become a law. But in all such cases the votes of both Houses
shall be determined by yeas and nays, and the names of the persons
voting for and against the bill shall be entered on the journal of each
House respectively. If any bill shall not be returned by the President
within ten days (Sundays excepted) after it shall have been presented to
him, the same shall be a law, in like manner as if he had signed it,
unless the Congress by their adjournment prevent its return, in which
case it shall not be a law.

3. Every order, resolution, or vote to which the concurrence of the
Senate and House of Representatives may be necessary (except on a
question of adjournment) shall be presented to the President of the
United States and before the same shall take effect, shall be approved
by him, or being disapproved by him, shall be repassed by two-thirds of
the Senate and House of Representatives, according to the rules and
limitations prescribed in the case of a bill.


SECTION 8. The Congress shall have power: 1. To lay and collect taxes,
duties, imposts, and excises, to pay the debts and provide for the
common defence and general welfare of the United States; but all duties,
imposts, and excises shall be uniform throughout the United States;

2. To borrow money on the credit of the United States;

3. To regulate commerce with foreign nations, and among the several
States, and with the Indian tribes;

4. To establish an uniform rule of naturalization, and uniform laws on
the subject of bankruptcies throughout the United States;

5. To coin money, regulate the value thereof, and of foreign coin, and
fix the standard of weights and measures;

6. To provide for the punishment of counterfeiting the securities and
current coin of the United States;

7. To establish post offices and post roads;

8. To promote the progress of science and useful arts by securing for
limited times to authors and inventors the exclusive right to their
respective writings and discoveries;

9. To constitute tribunals inferior to the Supreme Court;

10. To define and punish piracies and felonies committed on the high
seas, and offences against the law of nations;

11. To declare war, grant letters of marque and reprisal, and make rules
concerning captures on land and water;

12. To raise and support armies, but no appropriation of money to that
use shall be for a longer term than two years;

13. To provide and maintain a navy;

14. To make rules for the government and regulation of the land and
naval forces;

15. To provide for calling forth the militia to execute the laws of the
Union, suppress insurrections, and repel invasions;

16. To provide for organizing, arming, and disciplining the militia,
and for governing such part of them as may be employed in the service
of the United States, reserving to the States respectively the
appointment of the officers, and the authority of training the militia
according to the discipline prescribed by Congress.

17. To exercise exclusive legislation in all cases whatsoever, over such
district (not exceeding ten miles square) as may, by cession of
particular States and the acceptance of Congress, become the seat of the
government of the United States, and to exercise like authority over all
places purchased by the consent of the legislature of the State in which
the same shall be, for the erection of forts, magazines, arsenals,
dock-yards, and other needful buildings;--and

18. To make all laws which shall be necessary and proper for carrying
into execution the foregoing powers, and all other powers vested by this
Constitution in the government of the United States, or in any
department or officer thereof.


SECTION 9. 1. The migration or importation of such persons as any of the
States now existing shall think proper to admit, shall not be prohibited
by the Congress prior to the year one thousand eight hundred and eight,
but a tax or duty may be imposed on such importation, not exceeding ten
dollars for each person.

2. The privilege of the writ of _habeas corpus_ shall not be suspended,
unless when in cases of rebellion or invasion the public safety may
require it.

3. No bill of attainder or _ex post facto_ law shall be passed.

4. No capitation, or other direct, tax shall be laid, unless in
proportion to the census or enumeration hereinbefore directed to be
taken.[6]

5. No tax or duty shall be laid on articles exported from any State.

6. No preference shall be given by any regulation of commerce or revenue
to the ports of one State over those of another: nor shall vessels bound
to, or from, one State, be obliged to enter, clear, or pay duties in
another.

7. No money shall be drawn from the Treasury, but in consequence of
appropriations made by law; and a regular statement and account of the
receipts and expenditures of all public money shall be published from
time to time.

8. No title of nobility shall be granted by the United States; and no
person, holding any office of profit or trust under them, shall, without
the consent of the Congress, accept of any present, emolument, office,
or title, of any kind whatever, from any king, prince, or foreign State.


SECTION 10. 1. No State shall enter into any treaty, alliance, or
confederation; grant letters of marque and reprisal; coin money; emit
bills of credit; make anything but gold and silver coin a tender in
payment of debts; pass any bill of attainder, _ex post facto_ law, or
law impairing the obligation of contracts, or grant any title of
nobility.

2. No State shall, without the consent of the Congress, lay any imposts
or duties on imports or exports, except what may be absolutely necessary
for executing its inspection laws: and the net produce of all duties and
imposts, laid by any State on imports or exports, shall be for the use
of the Treasury of the United States; and all such laws shall be subject
to the revision and control of the Congress.

3. No State shall, without the consent of Congress, lay any duty of
tonnage, keep troops, or ships of war in time of peace, enter into any
agreement or compact with another State, or with a foreign power, or
engage in war unless actually invaded, or in such imminent danger as
will not admit of delay.


ARTICLE II

SECTION 1. 1. The executive power shall be vested in a President of the
United States of America. He shall hold his office during the term of
four years, and, together with the Vice-President, chosen for the same
term, be elected, as follows:

2. Each State shall appoint, in such manner as the legislature thereof
may direct, a number of electors, equal to the whole number of senators
and representatives to which the State may be entitled in the Congress;
but no senator or representative, or person holding an office of trust
or profit under the United States, shall be appointed an elector.[7] The
electors shall meet in their respective States, and vote by ballot for
two persons, of whom one at least shall not be an inhabitant of the same
State with themselves. And they shall make a list of all the persons
voted for, and of the number of votes for each; which list they shall
sign and certify, and transmit sealed to the seat of the government of
the United States, directed to the president of the Senate. The
President of the Senate shall, in the presence of the Senate and House
of Representatives, open all the certificates, and the votes shall then
be counted. The person having the greatest number of votes shall be the
President, if such number be a majority of the whole number of electors
appointed; and if there be more than one who have such majority, and
have an equal number of votes, then the House of Representatives shall
immediately choose by ballot one of them for President; and if no person
have a majority, then from the five highest on the list the said House
shall in like manner choose the President. But in choosing the
President, the votes shall be taken by States, the representation from
each State having one vote; a quorum for this purpose shall consist of a
member or members from two-thirds of the States and a majority of all
the States shall be necessary to a choice. In every case, after the
choice of the President, the person having the greatest number of votes
of the electors shall be the Vice-President. But if there should remain
two or more who have equal votes, the Senate shall choose from them by
ballot the Vice-President.[8]

3. The Congress may determine the time of choosing the electors, and the
day on which they shall give their votes; which day shall be the same
throughout the United States.

4. No person except a natural born citizen, or a citizen of the United
States, at the time of the adoption of this Constitution, shall be
eligible to the office of President; neither shall any person be
eligible to that office who shall not have attained to the age of
thirty-five years, and been fourteen years a resident within the United
States.

5. In case of the removal of the President from office, or of his death,
resignation, or inability to discharge the powers and duties of the said
office, the same shall devolve on the Vice-President, and the Congress
may by law provide for the case of removal, death, resignation, or
inability both of the President and Vice-President, declaring what
officer shall then act as President, and such officer shall act
accordingly, until the disability be removed, or a President shall be
elected.

6. The President shall, at stated times, receive for his services a
compensation, which shall neither be increased nor diminished during the
period for which he shall have been elected, and he shall not receive
within that period any other emolument from the United States, or any of
them.

7. Before he enter on the execution of his office, he shall take the
following oath or affirmation:--"I do solemnly swear (or affirm) that I
will faithfully execute the office of President of the United States,
and will to the best of my ability, preserve, protect, and defend the
Constitution of the United States."


SECTION 2. 1. The President shall be commander-in-chief of the army and
navy of the United States, and of the militia of the several States,
when called into the actual service of the United States; he may require
the opinion, in writing, of the principal officer in each of the
executive departments, upon any subject relating to the duties of their
respective offices, and he shall have power to grant reprieves and
pardons for offences against the United States, except in cases of
impeachment.

2. He shall have power, by and with the advice and consent of the
Senate, to make treaties, provided two-thirds of the senators present
concur; and he shall nominate, and by and with the advice and consent of
the Senate, shall appoint ambassadors, other public ministers and
consuls, judges of the Supreme Court, and all other officers of the
United States, whose appointments are not herein otherwise provided for,
and which shall be established by law: but the Congress may by law vest
the appointment of such inferior officers, as they think proper, in the
President alone, in the courts of law, or in the heads of departments.

3. The President shall have power to fill all vacancies that may happen
during the recess of the Senate, by granting commissions which shall
expire at the end of their next session.


SECTION 3. He shall from time to time give to the Congress information
on the state of the Union, and recommend to their consideration such
measures as he shall judge necessary and expedient; he may, on
extraordinary occasions, convene both Houses, or either of them, and in
case of disagreement between them, with respect to the time of
adjournment, he may adjourn them to such time as he shall think proper;
he shall receive ambassadors and other public ministers; he shall take
care that the laws be faithfully executed, and shall commission all the
officers of the United States.


SECTION 4. The President, Vice-President, and all civil officers of the
United States shall be removed from office on impeachment for, and
conviction of, treason, bribery, or other high crimes and misdemeanors.


ARTICLE III

SECTION 1. The judicial power of the United States shall be vested in
one Supreme Court, and in such inferior courts as the Congress may from
time to time ordain and establish. The judges, both of the Supreme and
inferior courts, shall hold their offices during good behaviour, and
shall, at stated times, receive for their services a compensation, which
shall not be diminished during their continuance in office.


SECTION 2. 1. The judicial power shall extend to all cases, in law and
equity, arising under this Constitution, the laws of the United States,
and treaties made, or which shall be made, under their authority;--to
all cases affecting ambassadors, other public ministers and consuls;--to
all cases of admiralty and maritime jurisdiction;--to controversies to
which the United States shall be a party;--to controversies between two
or more States;--between a State and citizens of another
State;[9]--between citizens of different States;--between citizens of
the same State claiming lands under grants of different States;--and
between a State, or the citizens thereof, and foreign States, citizens,
or subjects.

2. In all cases affecting ambassadors, other public ministers and
consuls and those in which a State shall be a party, the Supreme Court
shall have original jurisdiction. In all the other cases before
mentioned, the Supreme Court shall have appellate jurisdiction, both as
to law and fact, with such exceptions and under such regulations as the
Congress shall make.

3. The trial of all crimes, except in cases of impeachment, shall be by
jury; and such trial shall be held in the State where the said crimes
shall have been committed; but when not committed within any State, the
trial shall be at such place or places as the Congress may by law have
directed.


SECTION 3. 1. Treason against the United States shall consist only in
levying war against them, or in adhering to their enemies, giving them
aid and comfort. No person shall be convicted of treason unless on the
testimony of two witnesses to the same overt act, or on confession in
open court.

2. The Congress shall have power to declare the punishment of treason,
but no attainder of treason shall work corruption of blood or forfeiture
except during the life of the person attainted.


ARTICLE IV

SECTION 1. Full faith and credit shall be given in each State to the
public acts, records, and judicial proceedings of every other State. And
the Congress may by general laws prescribe the manner in which such
acts, records, and proceedings shall be proved, and the effect thereof.


SECTION 2. 1. The citizens of each State shall be entitled to all
privileges and immunities of citizens in the several States.

2. A person charged in any State with treason, felony, or other crime,
who shall flee from justice, and be found in another State, shall on
demand of the executive authority of the State from which he fled, be
delivered up, to be removed to the State having jurisdiction of the
crime.

3. No person held to service or labor in one State, under the laws
thereof, escaping into another, shall, in consequence of any law or
regulation therein, be discharged from such service or labor, but shall
be delivered up on claim of the party to whom such service or labor may
be due.


SECTION 3. 1. New States may be admitted by the Congress into this
Union; but no new State shall be formed or erected within the
jurisdiction of any other State; nor any State be formed by the junction
of two or more States, or parts of States, without the consent of the
legislatures of the States concerned as well as of the Congress.

2. The Congress shall have power to dispose of and make all needful
rules and regulations respecting the territory or other property
belonging to the United States; and nothing in this Constitution shall
be so construed as to prejudice any claims, of the United States, or of
any particular State.


SECTION 4. The United States shall guarantee to every State in this
Union a republican form of government, and shall protect each of them
against invasion; and on application of the legislature, or of the
executive (when the legislature cannot be convened), against domestic
violence.


ARTICLE V

The Congress, whenever two-thirds of both Houses shall deem it
necessary, shall propose amendments to this Constitution, or, on the
application of the legislatures of two-thirds of the several States,
shall call a convention for proposing amendments, which, in either case,
shall be valid to all intents and purposes as part of this Constitution,
when ratified by the legislatures of three-fourths of the several
States, or by conventions in three-fourths thereof, as the one or the
other mode of ratification may be proposed by the Congress; provided
that no amendment which may be made prior to the year one thousand eight
hundred and eight shall in any manner affect the first and fourth
clauses in the ninth Section of the first article; and that no State,
without its consent, shall be deprived of its equal suffrage in the
Senate.


ARTICLE VI

1. All debts contracted and engagements entered into, before the
adoption of this Constitution, shall be as valid against the United
States under this Constitution, as under the Confederation.

2. This Constitution and the laws of the United States which shall be
made in pursuance thereof and all treaties made, or which shall be made,
under the authority of the United States, shall be the supreme law of
the land; and the judges in every State shall be bound thereby, anything
in the Constitution or laws of any State to the contrary
notwithstanding.

3. The senators and representatives before mentioned, and the members of
the several State legislatures, and all executive and judicial officers,
both of the United States and of the several States, shall be bound by
oath or affirmation to support this Constitution; but no religious test
shall ever be required as a qualification to any office or public trust
under the United States.


ARTICLE VII

The ratification of the conventions of nine States shall be sufficient
for the establishment of this Constitution between the States so
ratifying the same.

Done in Convention by the unanimous consent of the States present the
seventeenth day of September in the year of our Lord one thousand seven
hundred and eighty-seven and of the independence of the United States of
America the twelfth. In witness whereof we have hereunto subscribed our
names,

     G^O. WASHINGTON--
     Presidt. and Deputy from Virginia

[and thirty-eight members from all the States except Rhode Island.]

       *       *       *       *       *


Articles in addition to, and amendment of, the Constitution of the
United States of America, proposed by Congress, and ratified by the
legislatures of the several States pursuant to the fifth article of the
original Constitution.


ARTICLE I[10]

Congress shall make no law respecting an establishment of religion, or
prohibiting the free exercise thereof; or abridging the freedom of
speech, or of the press; or the right of the people peaceably to
assemble, and to petition the government for a redress of grievances.


ARTICLE II

A well regulated militia, being necessary to the security of a free
State, the right of the people to keep and bear arms shall not be
infringed.


ARTICLE III

No soldier shall, in time of peace, be quartered in any house, without
the consent of the owner, nor in time of war, but in a manner to be
prescribed by law.


ARTICLE IV

The right of the people to be secure in their persons, houses, papers,
and effects, against unreasonable searches and seizures, shall not be
violated, and no warrants shall issue, but upon probable cause,
supported by oath or affirmation, and particularly describing the place
to be searched, and the persons or things to be seized.


ARTICLE V

No person shall be held to answer for a capital, or otherwise infamous
crime, unless on a presentment or indictment of a grand jury, except in
cases arising in the land or naval forces, or in the militia, when in
actual service in time of war or public danger; nor shall any person be
subject for the same offence to be twice put in jeopardy of life or
limb; nor shall be compelled in any criminal case to be a witness
against himself; nor be deprived of life, liberty, or property, without
due process of law; nor shall private property be taken for public use,
without just compensation.


ARTICLE VI

In all criminal prosecutions, the accused shall enjoy the right to a
speedy and public trial, by an impartial jury of the State and district
wherein the crime shall have been committed, which district shall have
been previously ascertained by law, and to be informed of the nature and
cause of the accusation; to be confronted with the witnesses against
him; to have compulsory process for obtaining witnesses in his favor,
and to have the assistance of counsel for his defence.


ARTICLE VII

In suits at common law, where the value in controversy shall exceed
twenty dollars, the right of trial by jury shall be preserved, and no
fact tried by a jury shall be otherwise reexamined in any court of the
United States, than according to the rules of the common law.


ARTICLE VIII

Excessive bail shall not be required, nor excessive fines imposed, nor
cruel and unusual punishments inflicted.


ARTICLE IX

The enumeration in the Constitution, of certain rights, shall not be
construed to deny or disparage others retained by the people.


ARTICLE X

The powers not delegated to the United States by the Constitution, nor
prohibited by it to the States, are reserved to the States respectively,
or to the people.


ARTICLE XI[11]

The judicial power of the United States shall not be construed to extend
to any suit in law or equity, commenced or prosecuted against one of the
United States by citizens of another State, or by citizens or subjects
of any foreign State.


ARTICLE XII[12]

The electors shall meet in their respective States, and vote by ballot
for President and Vice-President, one of whom at least shall not be an
inhabitant of the same State with themselves; they shall name in their
ballots the person voted for as President, and in distinct ballots the
person voted for as Vice-President, and they shall make distinct lists
of all persons voted for as President, and of all persons voted for as
Vice-President, and of the number of votes for each, which lists they
shall sign and certify, and transmit sealed to the seat of the
government of the United States, directed to the President of the
Senate;--The President of the Senate shall, in presence of the Senate
and House of Representatives, open all the certificates and the votes
shall then be counted;--The person having the greatest number of votes
for President, shall be the President, if such number be a majority of
the whole number of electors appointed; and if no person have such
majority, then from the persons having the highest numbers not exceeding
three on the list of those voted for as President, the House of
Representatives shall choose immediately, by ballot, the President. But
in choosing the President, the votes shall be taken by States, the
representation from each State having one vote; a quorum for this
purpose shall consist of a member or members from two-thirds of the
States, and a majority of all the States shall be necessary to a choice.
And if the House of Representatives shall not choose a President
whenever the right of choice shall devolve upon them, before the fourth
day of March next following, then the Vice-President shall act as
President, as in the case of the death or other constitutional
disability of the President. The person having the greatest number of
votes as Vice-President, shall be the Vice-President, if such number be
a majority of the whole number of electors appointed, and if no person
have a majority, then from the two highest members on the list, the
Senate shall choose the Vice-President; a quorum for the purpose shall
consist of two-thirds of the whole number of senators, and a majority of
the whole number shall be necessary to a choice. But no person
constitutionally ineligible to the office of President shall be eligible
to that of Vice-President of the United States.


ARTICLE XIII[13]

SECTION 1. Neither slavery nor involuntary servitude, except as a
punishment for crime whereof the party shall have been duly convicted,
shall exist within the United States, or any place subject to their
jurisdiction.

SECTION 2. Congress shall have power to enforce this article by
appropriate legislation.


ARTICLE XIV[14]

SECTION 1. All persons born or naturalized in the United States, and
subject to the jurisdiction thereof, are citizens of the United States
and of the State wherein they reside. No State shall make or enforce any
law which shall abridge the privileges or immunities of citizens of the
United States; nor shall any State deprive any person of life, liberty,
or property without due process of law; nor deny to any person within
its jurisdiction the equal protection of the laws.

SECTION 2. Representatives shall be apportioned among the several States
according to their respective numbers, counting the whole number of
persons in each State, excluding Indians not taxed. But when the right
to vote at any election for the choice of electors for President and
Vice-President of the United States, representatives in Congress, the
executive and judicial officers of a State, or the members of the
legislature thereof, is denied to any of the male inhabitants of such
State, being twenty-one years of age, and citizens of the United States,
or in any way abridged, except for participation in rebellion or other
crime, the basis of representation therein shall be reduced in the
proportion which the number of such male citizens shall bear to the
whole number of male citizens twenty-one years of age in such State.

SECTION 3. No person shall be a senator or representative in Congress,
or elector of President and Vice-President, or hold any office, civil or
military, under the United States, or under any State, who, having
previously taken an oath, as a member of Congress, or as an officer of
the United States, or as a member of any State legislature, or as an
executive or judicial officer of any State, to support the Constitution
of the United States, shall have engaged in insurrection or rebellion
against the same, or given aid or comfort to the enemies thereof. But
Congress may by two-thirds vote of each House, remove such disability.

SECTION 4. The validity of the public debt of the United States,
authorized by law, including debts incurred for payment of pensions and
bounties for services in suppressing insurrection or rebellion, shall
not be questioned. But neither the United States nor any State shall
assume or pay any debt or obligation incurred in aid of insurrection or
rebellion against the United States, or any claim for the loss or
emancipation of any slave; but all such debts, obligations, and claims
shall be held illegal and void.

SECTION 5. The Congress shall have power to enforce, by appropriate
legislation, the provisions of this article.


ARTICLE XV[15]

SECTION 1. The right of citizens of the United States to vote shall not
be denied or abridged by the United States or by any State on account of
race, color, or previous condition of servitude.

SECTION 2. The Congress shall have power to enforce this article by
appropriate legislation.


ARTICLE XVI[16]

The Congress shall have power to lay and collect taxes on incomes, from
whatever source derived, without apportionment among the several States,
and without regard to any census or enumeration.


ARTICLE XVII[17]

The Senate of the United States shall be composed of two senators from
each State, elected by the people thereof, for six years; and each
senator shall have one vote. The electors in each State shall have the
qualifications requisite for electors of the most numerous branch of the
State legislature.

When vacancies happen in the representation of any State in the Senate,
the executive authority of each State shall issue writs of election to
fill such vacancies: _Provided_ that the legislature of any State may
empower the executive thereof to make temporary appointments until the
people fill the vacancies by election as the legislature may direct.

This amendment shall not be so construed as to effect the election or
term of any senator chosen before it becomes valid as part of the
Constitution.


ARTICLE XVIII[18]

SECTION 1. After one year from the ratification of this article the
manufacture, sale, or transportation of intoxicating liquors within, the
importation thereof into, or the exportation thereof from the United
States and all territory subject to the jurisdiction thereof for
beverage purposes is hereby prohibited.

SECTION 2. The Congress and the several States shall have concurrent
power to enforce this article by appropriate legislation.

SECTION 3. This article shall be inoperative unless it shall have been
ratified as an amendment to the Constitution by the legislatures of the
several States, as provided in the Constitution, within seven years from
the date of the submission hereof to the States by the Congress.


ARTICLE XIX[19]

The right of citizens of the United States to vote shall not be denied
or abridged by the United States or any State on account of sex.

The Congress shall have power to enforce this article by appropriate
legislation.



POPULATION OF THE UNITED STATES, BY STATES: 1920, 1910, 1900

+---------------------+--------------------------------------------+
|      STATES         |                  POPULATION                |
+                     +--------------+--------------+--------------+
|                     |     1920     |     1910     |     1900     |
+---------------------+--------------+--------------+--------------+
|United States        | 105,708,771  |  91,972,266  |  75,994,575  |
+---------------------+--------------+--------------+--------------+
|Alabama              |   2,348,174  |   2,138,093  |   1,828,697  |
|Arizona              |     333,903  |     204,354  |     122,931  |
|Arkansas             |   1,752,204  |   1,574,449  |   1,311,564  |
|California           |   3,426,861  |   2,377,549  |   1,485,053  |
|Colorado             |     939,629  |     799,024  |     539,700  |
|Connecticut          |   1,380,631  |   1,114,756  |     908,420  |
|Delaware             |     223,003  |     202,322  |     184,735  |
|District of Columbia |     437,571  |     331,069  |     278,718  |
|Florida              |     968,470  |     752,619  |     528,542  |
|Georgia              |   2,895,832  |   2,609,121  |   2,216,331  |
|Idaho                |     431,866  |     325,594  |     161,772  |
|Illinois             |   6,485,280  |   5,638,591  |   4,821,550  |
|Indiana              |   2,930,390  |   2,700,876  |   2,516,462  |
|Iowa                 |   2,404,021  |   2,224,771  |   2,231,853  |
|Kansas               |   1,769,257  |   1,690,949  |   1,470,495  |
|Kentucky             |   2,416,630  |   2,289,905  |   2,147,174  |
|Louisiana            |   1,798,509  |   1,656,388  |   1,381,625  |
|Maine                |     768,014  |     742,371  |     694,466  |
|Maryland             |   1,449,661  |   1,295,346  |   1,188,044  |
|Massachusetts        |   3,852,356  |   3,366,416  |   2,805,346  |
|Michigan             |   3,668,412  |   2,810,173  |   2,420,982  |
|Minnesota            |   2,387,125  |   2,075,708  |   1,751,394  |
|Mississippi          |   1,790,618  |   1,797,114  |   1,551,270  |
|Missouri             |   3,404,055  |   3,293,335  |   3,106,665  |
|Montana              |     548,889  |     376,053  |     243,329  |
|Nebraska             |   1,296,372  |   1,192,214  |   1,066,300  |
|Nevada               |      77,407  |      81,875  |      42,335  |
|New Hampshire        |     443,407  |     430,572  |     411,588  |
|New Jersey           |   3,155,900  |   2,537,167  |   1,883,669  |
|New Mexico           |     360,350  |     327,301  |     195,310  |
|New York             |  10,384,829  |   9,113,614  |   7,268,894  |
|North Carolina       |   2,559,123  |   2,206,287  |   1,893,810  |
|North Dakota         |     645,680  |     577,056  |     319,146  |
|Ohio                 |   5,759,394  |   4,767,121  |   4,157,545  |
|Oklahoma             |   2,028,283  |   1,657,155  |     790,391  |
|Oregon               |     783,389  |     672,765  |     413,536  |
|Pennsylvania         |   8,720,017  |   7,665,111  |   6,302,115  |
|Rhode Island         |     604,397  |     542,610  |     428,556  |
|South Carolina       |   1,683,724  |   1,515,400  |   1,340,316  |
|South Dakota         |     636,547  |     583,888  |     401,570  |
|Tennessee            |   2,337,885  |   2,184,789  |   2,020,616  |
|Texas                |   4,663,228  |   3,896,542  |   3,048,710  |
|Utah                 |     449,396  |     373,351  |     276,749  |
|Vermont              |     352,428  |     355,956  |     343,641  |
|Virginia             |   2,309,187  |   2,061,612  |   1,854,184  |
|Washington           |   1,356,621  |   1,141,990  |     518,103  |
|West Virginia        |   1,463,701  |   1,221,119  |     958,800  |
|Wisconsin            |   2,632,067  |   2,333,860  |   2,069,042  |
|Wyoming              |     194,402  |     145,965  |      92,531  |
+---------------------+--------------+--------------+--------------+

FOOTNOTES:

[3] Partly superseded by the 14th Amendment, p. 639.

[4] See the 17th Amendment, p. 641.

[5] _Ibid._, p. 641.

[6] See the 16th Amendment, p. 640.

[7] The following paragraph was in force only from 1788 to 1803.

[8] Superseded by the 12th Amendment, p. 638.

[9] See the 11th Amendment, p. 638.

[10] First ten amendments proposed by Congress, Sept. 25, 1789.
Proclaimed to be in force Dec. 15, 1791.

[11] Proposed Sept. 5, 1794. Declared in force January 8, 1798.

[12] Adopted in 1804.

[13] Adopted in 1865.

[14] Adopted in 1868.

[15] Proposed February 27, 1869. Declared in force March 30, 1870.

[16] Passed July, 1909; proclaimed February 25, 1913.

[17] Passed May, 1912, in lieu of paragraph one, Section 3, Article I,
of the Constitution and so much of paragraph two of the same Section as
relates to the filling of vacancies; proclaimed May 31, 1913.

[18] Ratified January 16, 1919.

[19] Ratified August 26, 1920.




APPENDIX

TABLE OF PRESIDENTS

NAME                    STATE  PARTY     YEAR IN    VICE-PRESIDENT
                                         OFFICE
1 George Washington      Va.    Fed.    1789-1797   John Adams
2 John Adams             Mass.  Fed.    1797-1801   Thomas Jefferson
3 Thomas Jefferson       Va.    Rep.    1801-1809   Aaron Burr
                                                    George Clinton
4 James Madison          Va.    Rep.    1809-1817   George Clinton
                                                    Elbridge Gerry
5 James Monroe           Va.    Rep.    1817-1825   Daniel D. Tompkins
6 John Q. Adams          Mass.  Rep.    1825-1829   John C. Calhoun
7 Andrew Jackson         Tenn.  Dem.    1829-1837   John C. Calhoun
                                                    Martin Van Buren
8 Martin Van Buren       N.Y.   Dem.    1837-1841   Richard M. Johnson
9 Wm. H. Harrison        Ohio   Whig    1841-1841   John Tyler
10 John Tyler[20]        Va.    Whig    1841-1845
11 James K. Polk         Tenn.  Dem.    1845-1849   George M. Dallas
12 Zachary Taylor        La.    Whig    1849-1850   Millard Fillmore
13 Millard Fillmore[20]  N.Y.   Whig    1850-1853
14 Franklin Pierce       N.H.   Dem.    1853-1857   William R. King
15 James Buchanan        Pa.    Dem.    1857-1861   J.C. Breckinridge
16 Abraham Lincoln       Ill.   Rep.    1861-1865   Hannibal Hamlin
                                                    Andrew Johnson
17 Andrew Johnson[20]    Tenn.  Rep.    1865-1869
18 Ulysses S. Grant      Ill.   Rep.    1869-1877   Schuyler Colfax
                                                    Henry Wilson
19 Rutherford B. Hayes   Ohio   Rep.    1877-1881   Wm. A. Wheeler
20 James A. Garfield     Ohio   Rep.    1881-1881   Chester A. Arthur
21 Chester A. Arthur[20] N.Y.   Rep.    1881-1885
22 Grover Cleveland      N.Y.   Dem.    1885-1889   Thomas A. Hendricks
23 Benjamin Harrison     Ind.   Rep.    1889-1893   Levi P. Morton
24 Grover Cleveland      N.Y.   Dem.    1893-1897   Adlai E. Stevenson
25 William McKinley      Ohio   Rep.    1897-1901   Garrett A. Hobart
                                                    Theodore Roosevelt
26 Theodore Roosevelt[20]N.Y.   Rep.    1901-1909   Chas. W. Fairbanks
27 William H. Taft       Ohio   Rep.    1909-1913   James S. Sherman
28 Woodrow Wilson        N.J.   Dem.    1913-1921   Thomas R. Marshall
29 Warren G. Harding     Ohio   Rep.    1921-       Calvin Coolidge


FOOTNOTES:

[20] Promoted from the vice-presidency on the death of the president.

POPULATION OF THE OUTLYING POSSESSIONS: 1920 AND 1910

----------------------------------------+--------------+---------------
                AREA                    |     1920     |     1910
----------------------------------------+--------------+---------------
United States with outlying possessions |117,857,509   | 101,146,530
                                        +--------------+---------------
Continental United States               |105,708,771   | 91,972,266
Outlying Possessions                    | 12,148,738   |  9,174,264
                                        +--------------|---------------
  Alaska                                |     54,899   |     64,356
  American Samoa                        |      8,056   |      7,251[21]
  Guam                                  |     13,275   |     11,806
  Hawaii                                |    255,912   |    191,909
  Panama Canal Zone                     |     22,858   |     62,810[21]
  Porto Rico                            |  1,299,809   |  1,118,012
  Military  and  naval,  etc.,  service |              |
    abroad                              |    117,238   |     55,608
  Philippine Islands                    |10,350,640[22]|  7,635,426[23]
  Virgin Islands of the United States   |    26,051[24]|     27,086[25]
----------------------------------------+--------------+---------------

FOOTNOTES:

[21] Population in 1912.

[22] Population in 1918.

[23] Population in 1903.

[24] Population in 1917.

[25] Population in 1911.




A TOPICAL SYLLABUS

As a result of a wholesome reaction against the purely chronological
treatment of history, there is now a marked tendency in the direction of
a purely topical handling of the subject. The topical method, however,
may also be pushed too far. Each successive stage of any topic can be
understood only in relation to the forces of the time. For that reason,
the best results are reached when there is a combination of the
chronological and the topical methods. It is therefore suggested that
the teacher first follow the text closely and then review the subject
with the aid of this topical syllabus. The references are to pages.


=Immigration=

     I. Causes: religious (1-2, 4-11, 302), economic (12-17, 302-303),
        and political (302-303).
     II. Colonial immigration.
       1. Diversified character: English, Scotch-Irish, Irish, Jews,
          Germans and other peoples (6-12).
       2. Assimilation to an American type; influence of the land
          system (23-25, 411).
       3. Enforced immigration: indentured servitude, slavery, etc.
          (13-17).
     III. Immigration between 1789-1890.
       1. Nationalities: English, Irish, Germans, and Scandinavians
          (278, 302-303).
       2. Relations to American life (432-433, 445).
     IV. Immigration and immigration questions after 1890.
       1. Change in nationalities (410-411).
       2. Changes in economic opportunities (411).
       3. Problems of congestion and assimilation (410).
       4. Relations to labor and illiteracy (582-586).
       5. Oriental immigration (583).
       6. The restriction of immigration (583-585).

=Expansion of the United States=

     I. Territorial growth.
       1. Territory of the United States in 1783 (134 and color map).
       2. Louisiana purchase, 1803 (188-193 and color map).
       3. Florida purchase, 1819 (204).
       4. Annexation of Texas, 1845 (278-281).
       5. Acquisition of Arizona, New Mexico, California, and other
          territory at close of Mexican War, 1848 (282-283).
       6. The Gadsden purchase, 1853 (283).
       7. Settlement of the Oregon boundary question, 1846 (284-286).
       8. Purchase of Alaska from Russia, 1867 (479).
       9. Acquisition of Tutuila in Samoan group, 1899 (481-482).
       10. Annexation of Hawaii, 1898 (484).
       11. Acquisition of Porto Rico, the Philippines, and Guam at
           close of Spanish War, 1898 (493-494).
       12. Acquisition of Panama Canal strip, 1904 (508-510).
       13. Purchase of Danish West Indies, 1917 (593).
       14. Extension of protectorate over Haiti, Santo Domingo, and
           Nicaragua (593-594).
     II. Development of colonial self-government.
       1. Hawaii (485).
       2. Philippines (516-518).
       3. Porto Rico (515-516).
     III. Sea power.
       1. In American Revolution (118).
       2. In the War of 1812 (193-201).
       3. In the Civil War (353-354).
       4. In the Spanish-American War (492).
       5. In the Caribbean region (512-519).
       6. In the Pacific (447-448, 481).
       7. The role of the American navy (515).

=The Westward Advance of the People=

     I. Beyond the Appalachians.
       1. Government and land system (217-231).
       2. The routes (222-224).
       3. The settlers (221-223, 228-230).
       4. Relations with the East (230-236).
     II. Beyond the Mississippi.
       1. The lower valley (271-273).
       2. The upper valley (275-276).
     III. Prairies, plains, and desert.
       1. Cattle ranges and cowboys (276-278, 431-432).
       2. The free homesteads (432-433).
       3. Irrigation (434-436, 523-525).
     IV. The Far West.
       1. Peculiarities of the West (433-440).
       2. The railways (425-431).
       3. Relations to the East and Europe (443-447).
       4. American power in the Pacific (447-449).

=The Wars of American History=

     I. Indian wars (57-59).
     II. Early colonial wars: King William's, Queen Anne's, and King
         George's (59).
     III. French and Indian War (Seven Years' War), 1754-1763 (59-61).
     IV. Revolutionary War, 1775-1783 (99-135).
     V. The War of 1812, 1812-1815 (193-201).
     VI. The Mexican War, 1845-1848 (276-284).
     VII. The Civil War, 1861-1865 (344-375).
     VIII. The Spanish War, 1898 (485-497).
     IX. The World War, 1914-1918 [American participation, 1917-1918]
         (596-625).

=Government=

     I. Development of the American system of government.
       1. Origin and growth of state government.
         _a._ The trading corporation (2-4), religious congregation
              (4-5), and proprietary system (5-6).
         _b._ Government of the colonies (48-53).
         _c._ Formation of the first state constitutions (108-110).
         _d._ The admission of new states (_see_ Index under each
              state).
         _e._ Influence of Jacksonian Democracy (238-247).
         _f._ Growth of manhood suffrage (238-244).
         _g._ Nullification and state sovereignty (180-182, 251-257).
         _h._ The doctrine of secession (345-346).
         _i._ Effects of the Civil War on position of states (366,
              369-375).
         _j._ Political reform--direct government--initiative,
              referendum, and recall (540-544).
       2. Origin and growth of national government.
         _a._ British imperial control over the colonies (64-72).
         _b._ Attempts at intercolonial union--New England
              Confederation, Albany plan (61-62).
         _c._ The Stamp Act Congress (85-86).
         _d._ The Continental Congresses (99-101).
         _e._ The Articles of Confederation (110-111, 139-143).
         _f._ The formation of the federal Constitution (143-160).
         _g._ Development of the federal Constitution.
           (1) Amendments 1-11--rights of persons and states (163).
           (2) Twelfth amendment--election of President (184, note).
           (3) Amendments 13-15--Civil War settlement (358, 366, 369,
               370, 374, 375).
           (4) Sixteenth amendment--income tax (528-529).
           (5) Seventeenth amendment--election of Senators (541-542).
           (6) Eighteenth amendment--prohibition (591-592).
           (7) Nineteenth amendment--woman suffrage (563-568).
       3. Development of the suffrage.
         _a._ Colonial restrictions (51-52).
         _b._ Provisions of the first state constitutions
              (110, 238-240).
         _c._ Position under federal Constitution of 1787 (149).
         _d._ Extension of manhood suffrage (241-244).
         _e._ Extension and limitation of negro suffrage (373-375,
              382-387).
         _f._ Woman suffrage (560-568).
     II. Relation of government to economic and social welfare.
       1. Debt and currency.
         _a._ Colonial paper money (80).
         _b._ Revolutionary currency and debt (125-127).
         _c._ Disorders under Articles of Confederation (140-141).
         _d._ Powers of Congress under the Constitution to coin money
              (_see_ Constitution in the Appendix).
         _e._ First United States bank notes (167).
         _f._ Second United States bank notes (257).
         _g._ State bank notes (258).
         _h._ Civil War greenbacks and specie payment (352-353, 454).
         _i._ The Civil War debt (252).
         _j._ Notes of National Banks under act of 1864 (369).
         _k._ Demonetization of silver and silver legislation
              (452-458).
         _l._ The gold standard (472).
         _m._ The federal reserve notes (589).
         _n._ Liberty bonds (606).
       2. Banking systems.
         _a._ The first United States bank (167).
         _b._ The second United States bank--origin and destruction
              (203, 257-259).
         _c._ United States treasury system (263).
         _d._ State banks (258).
         _e._ The national banking system of 1864 (369).
         _f._ Services of banks (407-409).
         _g._ Federal reserve system (589).
       3. The tariff.
         _a._ British colonial system (69-72).
         _b._ Disorders under Articles of Confederation (140).
         _c._ The first tariff under the Constitution (150, 167-168).
         _d._ Development of the tariff, 1816-1832 (252-254).
         _f._ Tariff and nullification (254-256).
         _g._ Development to the Civil War--attitude of South and West
              (264, 309-314, 357).
         _h._ Republicans and Civil War tariffs (352, 367).
         _i._ Revival of the tariff controversy under Cleveland (422).
         _j._ Tariff legislation after 1890--McKinley bill (422),
              Wilson bill (459), Dingley bill (472), Payne-Aldrich bill
              (528), Underwood bill (588).
       4. Foreign and domestic commerce and transportation
          (_see_ Tariff, Immigration, and Foreign Relations).
         _a._ British imperial regulations (69-72).
         _b._ Confusion under Articles of Confederation (140).
         _c._ Provisions of federal Constitution (150).
         _d._ Internal improvements--aid to roads, canals, etc.
              (230-236).
         _e._ Aid to railways (403).
         _f._ Service of railways (402).
         _g._ Regulation of railways (460-461, 547-548).
         _h._ Control of trusts and corporations (461-462, 589-590).
       5. Land and natural resources.
         _a._ British control over lands (80).
         _b._ Early federal land measures (219-221).
         _c._ The Homestead act (368, 432-445).
         _d._ Irrigation and reclamation (434-436, 523-525).
         _e._ Conservation of natural resources (523-526).
       6. Legislation advancing human rights and general welfare
          (_see_ Suffrage).
         _a._ Abolition of slavery: civil and political rights of
              negroes (357-358, 373-375).
         _b._ Extension of civil and political rights to women
              (554-568).
         _c._ Legislation relative to labor conditions (549-551,
              579-581, 590-591).
         _d._ Control of public utilities (547-549).
         _e._ Social reform and the war on poverty (549-551).
         _f._ Taxation and equality of opportunity (551-552).

=Political Parties and Political Issues=

     I. The Federalists _versus_ the Anti-Federalists [Jeffersonian
        Republicans] from about 1790 to about 1816 (168-208, 201-203).
       1. Federalist leaders: Hamilton, John Adams, John Marshall,
          Robert Morris.
       2. Anti-Federalist leaders: Jefferson, Madison, Monroe.
       3. Issues: funding the debt, assumption of state debts, first
          United States bank, taxation, tariff, strong central
          government _versus_ states' rights, and the Alien and
          Sedition acts.
     II. Era of "Good Feeling" from about 1816 to about 1824, a period
         of no organized party opposition (248).
     III. The Democrats [former Jeffersonian Republicans] _versus_ the
          Whigs [or National Republicans] from about 1832 to 1856
         (238-265, 276-290, 324-334).
       1. Democratic leaders: Jackson, Van Buren, Calhoun, Benton.

       2. Whig leaders: Webster and Clay.
       3. Issues: second United States bank, tariff, nullification,
          Texas, internal improvements, and disposition of Western
          lands.
     IV. The Democrats _versus_ the Republicans from about 1856 to the
         present time (334-377, 388-389, 412-422, 451-475, 489-534,
         588-620).
       1. Democratic leaders: Jefferson Davis, Tilden, Cleveland,
          Bryan, and Wilson.
       2. Republican leaders: Lincoln, Blaine, McKinley, Roosevelt.
       3. Issues: Civil War and reconstruction, currency, tariff,
          taxation, trusts, railways, foreign policies, imperialism,
          labor questions, and policies with regard to land and
          conservation.
     V. Minor political parties.
       1. Before the Civil War: Free Soil (319) and Labor Parties
          (306-307).
       2. Since the Civil War: Greenback (463-464), Populist (464),
          Liberal Republican (420), Socialistic (577-579), Progressive
         (531-534, 602-603).

=The Economic Development of the United States=

     I. The land and natural resources.
       1. The colonial land system: freehold, plantation, and manor
          (20-25).
       2. Development of the freehold in the West (220-221, 228-230).
       3. The Homestead act and its results (368, 432-433).
       4. The cattle range and cowboy (431-432).
       5. Disappearance of free land (443-445).
       6. Irrigation and reclamation (434-436).
       7. Movement for the conservation of resources (523-526).
     II. Industry.
       1. The rise of local and domestic industries (28-32).
       2. British restrictions on American enterprise (67-69, 70-72).
       3. Protective tariffs (see above, 648-649).
       4. Development of industry previous to the Civil War (295-307).
       5. Great progress of industry after the war (401-406).
       6. Rise and growth of trusts and combinations (406-412,
          472-474).
     III. Commerce and transportation.
       1. Extent of colonial trade and commerce (32-35).
       2. British regulation (69-70).
       3. Effects of the Revolution and the Constitution
          (139-140, 154).
       4. Growth of American shipping (195-196).
       5. Waterways and canals (230-236).
       6. Rise and extension of the railway system (298-300).
       7. Growth of American foreign trade (445-449).
     IV. Rise of organized labor.
       1. Early phases before the Civil War: local unions, city
          federations, and national unions in specific trades
          (304-307).
       2. The National Trade Union, 1866-1872 (574-575).
       3. The Knights of Labor (575-576).
       4. The American Federation of Labor (573-574).
         _a._ Policies of the Federation (576-577).
         _b._ Relations to politics (579-581).
         _c._ Contests with socialists and radicals (577-579).
         _d._ Problems of immigration (582-585).
       5. The relations of capital and labor.
         _a._ The corporation and labor (410, 570-571).
         _b._ Company unions and profit-sharing (571-572).
         _c._ Welfare work (573).
         _d._ Strikes (465, 526, 580-581).
         _e._ Arbitration (581-582).

=American Foreign Relations=

     I. Colonial period.
       1. Indian relations (57-59).
       2. French relations (59-61).
     II. Period of conflict and independence.
       1. Relations with Great Britain (77-108, 116-125, 132-135).
       2. Establishment of connections with European powers (128).
       3. The French alliance of 1778 (128-130).
       4. Assistance of Holland and Spain (130).
     III. Relations with Great Britain since 1783.
       1. Commercial settlement in Jay treaty of 1794 (177-178).
       2. Questions arising out of European wars [1793-1801]
          (176-177, 180).
       3. Blockade and embargo problems (193-199).
       4. War of 1812 (199-201).
       5. Monroe Doctrine and Holy Alliance (205-207).
       6. Maine boundary--Webster-Ashburton treaty (265).
       7. Oregon boundary (284-286).
       8. Attitude of Great Britain during Civil War (354-355).
       9. Arbitration of _Alabama_ claims (480-481).
       10. The Samoan question (481-482)
       11. The Venezuelan question (482-484).
       12. British policy during Spanish-American War (496-497).
       13. Controversy over blockade, 1914-1917 (598-600).
       14. The World War (603-620).
     IV. Relations with France.
       1. The colonial wars (59-61).
       2. The French alliance of 1778 (128-130).
       3. Controversies over the French Revolution (128-130).
       4. Commercial questions arising out of the European wars
          (176-177, 180, 193-199).
       5. Attitude of Napoleon III toward the Civil War (354-355).
       6. The Mexican entanglement (478-479).
       7. The World War (596-620).
     V. Relations with Germany.
       1. Negotiations with Frederick, king of Prussia (128).
       2. The Samoan controversy (481-482).
       3. Spanish-American War (491).
       4. The Venezuelan controversy (512).
       5. The World War (596-620).
     VI. Relations with the Orient.
       1. Early trading connections (486-487).
       2. The opening of China (447).
       3. The opening of Japan (448).
       4. The Boxer rebellion and the "open door" policy (499-502).
       5. Roosevelt and the close of the Russo-Japanese War (511).
       6. The Oriental immigration question (583-584).
     VII. The United States and Latin America.
       1. Mexican relations.
         _a._ Mexican independence and the Monroe Doctrine (205-207).
         _b._ Mexico and French intervention--policy of the United
              States (478-479).
         _c._ The overthrow of Diaz (1911) and recent questions
              (594-596).
       2. Cuban relations.
         _a._ Slavery and the "Ostend Manifesto" (485-486).
         _b._ The revolutionary period, 1867-1877 (487).
         _c._ The revival of revolution (487-491).
         _d._ American intervention and the Spanish War (491-496).
         _e._ The Platt amendment and American protection (518-519).
       3. Caribbean and other relations.
         _a._ Acquisition of Porto Rico (493).
         _b._ The acquisition of the Panama Canal strip (508-510).
         _c._ Purchase of Danish West Indies (593).
         _d._ Venezuelan controversies (482-484, 512).
         _e._ Extension of protectorate over Haiti, Santo Domingo,
              and Nicaragua (513-514, 592-594).




INDEX


Abolition, 318, 331

Adams, Abigail, 556

Adams, John, 97, 128, 179ff.

Adams, J.Q., 247, 319

Adams, Samuel, 90, 99, 108

Adamson law, 590

Aguinaldo, 497

Alabama, admission, 227

_Alabama_ claims, 480

Alamance, battle, 92

Alamo, 280

Alaska, purchase, 479

Albany, plan of union, 62

Algonquins, 57

Alien law, 180

Amendment, method of, 156

Amendments to federal Constitution: first eleven, 163
  twelfth, 184, note
  thirteenth, 358
  fourteenth, 366, 369, 387
  fifteenth, 358
  sixteenth, 528
  seventeenth, 542
  eighteenth, 591
  nineteenth, 563ff.

American expeditionary force, 610

American  Federation  of  Labor,  573, 608

Americanization, 585

Amnesty, for Confederates, 383

Andros, 65

Annapolis, convention, 144

Antietam, 357

Anti-Federalists, 169

Anti-slavery. _See_ Abolition

Anthony, Susan, 564

Appomattox, 363

Arbitration:  international,  480,  514, 617
  labor disputes, 582

Arizona, admission, 443

Arkansas, admission, 272

Arnold, Benedict, 114, 120

Articles of Confederation, 110, 139ff., 146

Ashburton, treaty, 265

Assembly, colonial, 49ff., 89ff.

Assumption, 164ff.

Atlanta, 361

Australian ballot, 540


Bacon, Nathaniel, 58

Ballot:  Australian, 540
  short, 544

Baltimore, Lord, 6

Bank: first U.S., 167
  second, 203, 257ff.

Banking system:  state, 300
  U.S. national, 369
  services of, 407
  _See also_ Federal reserve

Barry, John, 118

Bastille, 172

Bell, John, 341

Belleau Wood, 611

Berlin decree, 194

Blockade: by England and France, 193ff.
  Southern ports, 353
  law and practice in 1914, 598ff.

Bond servants, 13ff.

Boone, Daniel, 28, 218

Boston:  massacre, 91
  evacuation, 116
  port bill, 94

Bowdoin, Governor, 142

Boxer rebellion, 499

Brandywine, 129

Breckinridge, J.C., 340

Bright, John, 355

Brown, John, 338

Brown University, 45

Bryan, W.J., 468ff., 495, 502, 503, 527

Buchanan, James, 335, 368

Budget system, 529

Bull Run, 350

Bunker Hill, 102

Burgoyne, General, 116, 118, 130

Burke, Edmund, 87, 96ff., 132, 175

Burr, Aaron, 183, 231

Business. _See_  Industry


Calhoun, J.C., 198ff., 203, 208, 281, 321, 328

California, 286ff.

Canada, 61, 114, 530

Canals, 233, 298, 508

Canning, British premier, 206

Cannon, J.G., 530

Cantigny, 611

Caribbean, 479

Carpet baggers, 373

Cattle ranger, 431ff.

Caucus, 245

Censorship. _See_ Newspapers

Charles I, 3

Charles II, 65

Charleston, 36, 116

Charters, colonial, 2ff., 41

Chase, Justice, 187

Chateau-Thierry, 611

Checks and balances, 153

_Chesapeake_, the, 195

Chickamauga, 361

Child labor law, 591

China, 447, 499ff.

Chinese labor, 583

Churches, colonial, 39ff., 42, 43

Cities, 35, 36, 300ff., 395, 410, 544

City manager plan, 545

Civil liberty, 358ff., 561

Civil service, 419, 536, 538ff.

Clarendon, Lord, 6

Clark, G.R., 116, 218

Clay, Henry, 198, 203, 248, 261, 328

Clayton anti-trust act, 489

Clergy. _See_ Churches

Cleveland, Grover, 421, 465, 482, 484, 489, 582

Clinton, Sir Henry, 119

Colorado, admission, 441

Combination. _See_ Trusts

Commerce, colonial, 33ff.
  disorders after 1781, 140
  Constitutional provisions on, 154
  Napoleonic wars, 176, 193ff.
  domestic growth of, 307
  congressional regulation of, 460ff., 547
  _See also_ Trusts and Railways

Commission government, 544

Committees of correspondence, 108

_Commonsense_, pamphlet, 103

Communism, colonial, 20f.

Company, trading, 2f.

Compromises: of Constitution, 148, 150, 151
  Missouri, 325, 332
  of 1850, 328ff.
  Crittenden, 350

Conciliation, with England, 131

Concord, battle, 100

Confederacy, Southern, 346ff.

Confederation: New England, 61f.
  _See also_ Articles of

Congregation, religious, 4

Congress:  stamp act, 85
  continental, 99ff.
  under Articles, 139f.
  under Constitution, 152
  powers of, 153

Connecticut: founded, 4ff.
  self-government, 49
  _See also_ Suffrage
  constitutions, state

Conservation, 523ff.

Constitution: formation of, 143ff.
  _See also_ Amendment

_Constitution_, the, 200

Constitutions, state, 109ff., 238ff., 385ff.

Constitutional union party, 340

Contract labor law, 584

Convention: 1787, 144ff.
  nominating, 405

Convicts, colonial, 15

Conway Cabal, 120

Cornwallis, General, 116, 119, 131

Corporation and labor, 571. _See also_ Trusts

Cotton. _See_ Planting system

Cowboy, 431ff.

Cowpens, battle, 116

Cox, J.M., 619

_Crisis, The_, pamphlet, 115

Crittenden Compromise, 350

Cuba, 485ff., 518

Cumberland Gap, 223

Currency. _See_ Banking


Danish West Indies, purchased, 593

Dartmouth College, 45

Daughters of liberty, 84

Davis, Jefferson, 346ff.

Deane, Silas, 128

Debs, E.V., 465, 534

Debt, national, 164ff.

Decatur, Commodore, 477

Declaration of Independence, 101ff.

Defense, national, 154

De Kalb, 121

Delaware, 3, 49

De Lome affair, 490

Democratic party, name assumed, 260
  _See also_ Anti-Federalists

Dewey, Admiral, 492

Diplomacy: of the Revolution, 127ff.
  Civil War, 354

Domestic industry, 28

Donelson, Fort, 361

Dorr Rebellion, 243

Douglas, Stephen A., 333, 337, 368

Draft: Civil War, 351
  World War, 605

Draft riots, 351

Dred Scott case, 335, 338

Drug act, 523

Duquesne, Fort, 60

Dutch, 3, 12


East India Company, 93

Education, 43ff., 557, 591

Electors, popular election of, 245

Elkins law, 547

Emancipation, 357ff.

Embargo acts, 186ff.

England: Colonial policy of, 64ff.
  Revolutionary War, 99ff.
  Jay treaty, 177
  War of 1812, 198ff.
  Monroe Doctrine, 206
  Ashburton treaty, 265
  Civil War, 354
  _Alabama_ claims, 480
  Samoa, 481
  Venezuela question, 482
  Spanish War, 496
  World War, 596ff.

Erie Canal, 233

Esch-Cummins bill, 582

Espionage act, 607

Excess profits tax, 606

Executive, federal, plans for, 151

Expunging resolution, 260


Farm loan act, 589

Federal reserve act, 589

Federal trade commission, 590

_Federalist_, the, 158

Federalists, 168ff., 201ff.

Feudal elements in colonies, 21f.

Filipino revolt. _See_ Philippines

Fillmore, President, 485

Finances: colonial, 64
  revolutionary, 125ff.
  disorders, 140
  Civil War, 347, 352ff.
  World War, 606
  _See also_ Banking

Fishing industry, 31

Fleet, world tour, 515

Florida, 134, 204

Foch, General, 611

Food and fuel law, 607

Force bills, 384 ff., 375

Forests, national, 525ff.

Fourteen points, 605

Fox, C.J., 132

France: colonization, 59ff.
  French and Indian War, 60ff.
  American Revolution, 116, 123, 128ff.
  French Revolution, 165ff.
  Quarrel with, 180
  Napoleonic wars, 193ff.
  Louisiana purchase, 190
  French Revolution of 1830, 266
  Civil War, 354
  Mexican affair, 478
  World War, 596ff.

Franchises, utility, 548

Franklin, Benjamin, 45, 62, 82, 86, 128, 134

Freedmen. _See_ Negro

Freehold. _See_ Land

Free-soil party, 319

Fremont, J.C., 288, 334

French. _See_ France

Friends, the, 5

Frontier. _See_ Land

Fugitive slave act, 329

Fulton, Robert, 231, 234

Fundamental articles, 5

Fundamental orders, 5


Gage, General, 95, 100

Garfield, President, 416

Garrison, William Lloyd, 318

_Gaspee_, the, 92

Gates, General, 116, 120, 131

Genet, 177

George I, 66

George II, 4, 66, 82

George III, 77ff.

Georgia: founded, 4
  royal province, 49
  state constitution, 109
  _See also_ Secession

Germans: colonial immigration, 9ff.
  in Revolutionary War, 102ff.
  later immigration, 303

Germany: Samoa, 481
  Venezuela affair, 512
  World War, 596f.

Gerry, Elbridge, 148

Gettysburg, 362

Gibbon, Edward, 133

Gold: discovery, 288
  standard, 466, 472

Gompers, Samuel, 573, 608

Governor, royal, 49ff.

Grandfather clause, 386f.

Grangers, 460ff.

Grant, General, 361, 416, 480, 487

Great Britain. _See_ England

Greeley, Horace, 420

Greenbacks, 454ff.

Greenbackers, 462ff.

Greene, General, 117, 120

Grenville, 79ff.

Guilford, battle, 117


Habeas corpus, 358

Hague conferences, 514

Haiti, 593

Hamilton, Alexander, 95, 143, 158, 162, 168ff., 231

Harding, W.G., 389, 619

Harlem Heights, battle, 114

Harper's Ferry, 339

Harrison, Benjamin, 422, 484

Harrison, W.H., 198, 263f.

Hartford convention, 201ff., 238

Harvard, 44

Hawaii, 484f.

Hay, John, 477, 500ff.

Hayne, Robert, 256

Hays, President, 416f.

Henry, Patrick, 85

Hepburn act, 523

Hill, James J., 429

Holland, 130

Holy Alliance, 205

Homestead act, 368, 432

Hooker, Thomas, 5

Houston, Sam, 279ff.

Howe, General, 118

Hughes, Charles E., 602

Huguenots, 10

Hume, David, 132

Hutchinson, Anne, 5


Idaho, admission, 442

Income tax, 459, 466, 528, 588, 606

Inheritance tax, 606

Illinois, admission, 226

Illiteracy, 585

Immigration: colonial, 1-17
  before Civil War, 302, 367
  after Civil War, 410ff.
  problems of, 582ff.

Imperialism, 494ff., 498f., 502ff.

Implied powers, 212

Impressment of seamen, 194

Indentured servants, 13f.

Independence, Declaration of, 107

Indiana, admission, 226

Indians, 57ff., 81, 431

Industry: colonial, 28ff.
  growth of, 296ff.
  during Civil War, 366
  after 1865, 390ff., 401ff., 436ff., 559
  _See also_ Trusts

Initiative, the, 543

Injunction, 465, 580

Internal improvements, 260, 368

Interstate commerce act, 461, 529

Intolerable acts, 93

Invisible government, 537

Iowa, admission, 275

Irish, 11, 302

Iron. _See_ Industry

Irrigation, 434ff., 523ff.


Jackson, Andrew, 201, 204, 246, 280

Jacobins, 174

James I, 3

James II, 65

Jamestown, 3, 21

Japan, relations with, 447, 511, 583

Jay, John, 128, 158, 177

Jefferson, Thomas: Declaration of Independence, 107
  Secretary of State, 162ff.
  political leader, 169
  as President, 183ff.
  Monroe Doctrine, 206, 231

Jews, migration of, 11

Johnson, Andrew, 365, 368, 371f.

Johnson, Samuel, 132

Joliet, 59

Jones, John Paul, 118

Judiciary: British system, 67
  federal, 152


Kansas, admission, 441

Kansas-Nebraska bill, 333

Kentucky: admission, 224
  Resolutions, 182

King George's War, 59

King Philip's War, 57

King William's War, 59

King's College (Columbia), 45

Knights of Labor, 575ff.

Kosciusko, 121

Ku Klux Klan, 382


Labor:  rise of organized, 304
  parties, 462ff.
  question, 521
  American Federation, 573ff.
  legislation, 590
  World War, 608ff.

Lafayette, 121

La Follette, Senator, 531

Land: tenure 20ff.
  sales restricted, 80
  Western survey, 219
  federal sales policy, 220
  Western tenure, 228
  disappearance of free, 445
  new problems, 449
  _See also_ Homestead act

La Salle, 59

Lawrence, Captain, 200

League of Nations, 616ff.

Le Boeuf, Fort, 59

Lee, General Charles, 131

Lee, R.E., 357

Lewis and Clark expedition, 193

Lexington, battle, 100

Liberal Republicans, 420

Liberty loan, 606

Lincoln: Mexican War, 282
  Douglas debates, 336f.
  election, 341
  Civil War, 344ff.
  reconstruction, 371

Literacy test, 585

Livingston, R.R., 191

Locke, John, 95

London Company, 3

Long Island, battle, 114

Lords of trade, 67ff.

Louis XVI, 171ff.

Louisiana: ceded to Spain, 61
  purchase, 190ff.
  admission, 227

Loyalists. _See_ Tories

_Lusitania_, the, 601ff.


McClellan, General, 362, 365

McCulloch _vs._ Maryland, 211

McKinley, William, 422, 467ff., 489ff.

Macaulay, Catherine, 132

Madison, James, 158, 197ff.

Maine, 325

_Maine_, the, 490

Manila Bay, battle, 492

Manors, colonial, 22

Manufactures. _See_ Industry

Marbury _vs._ Madison, 209

Marietta, 220

Marion, Francis, 117, 120

Marquette, 59

Marshall, John, 208ff.

Martineau, Harriet, 267

Maryland, founded, 6, 49, 109, 239, 242

Massachusetts: founded, 3ff.
  _See also_ Immigration, Royal province, Industry, Revolutionary War,
     Constitutions, state, Suffrage, Commerce, and Industry

Massachusetts Bay Company, 3
  founded, 3ff.
  _See also_ Immigration, Royal province

_Mayflower_ compact, 4

Mercantile theory, 69

Merchants. _See_ Commerce

_Merrimac_, the, 353

Meuse-Argonne, battle, 612

Mexico: and Texas, 278ff.
  later relations, 594f.

Michigan, admission, 273

Midnight appointees, 187

Milan Decree, 194

Militia, Revolutionary War, 122

Minimum wages, 551

Minnesota, admission, 275

Mississippi River, and West, 189f.

Missouri Compromise, 207, 227, 271, 325, 332

Molasses act, 71

Money, paper, 80, 126, 155, 369

_Monitor_, the, 353

Monroe, James, 204ff., 191

Monroe Doctrine, 205, 512

Montana, admission, 442

Montgomery, General, 114

Morris, Robert, 127

Mothers' pensions, 551

Mohawks, 57

Muckraking, 536f.

Mugwumps, 420

Municipal ownership, 549


Napoleon I, 190

Napoleon III: Civil War, 354f.
  Mexico, 477

National Labor Union, 574

National road, 232

Nationalism, colonial, 56ff.

Natural rights, 95

Navigation acts, 69

Navy: in Revolution, 188
  War of 1812, 195
  Civil War, 353
  World War, 610.
  _See also_ Sea Power

Nebraska, admission, 441

Negro: Civil rights, 370ff.
  in agriculture, 393ff.
  status of, 396ff.
  _See also_ Slavery

New England: colonial times, 6ff., 35, 40ff.
  _See also_ Industry, Suffrage, Commerce, and Wars

New Hampshire: founded, 4ff.
  _See also_ Immigration, Royal province, Suffrage, and Constitutions,
    state

New Jersey, founded, 6.
   _See also_ Immigration, Royal province, Suffrage, and
     Constitutions, state

Newlands, Senator, 524

New Mexico, admission, 443

New Orleans, 59, 190
  battle, 201

Newspapers, colonial, 46ff.

New York: founded by Dutch, 3
  transferred to English, 49
  _See also_ Dutch, Immigration, Royal province, Commerce, Suffrage,
    and Constitutions, state

New York City, colonial, 36

Niagara, Fort, 59

Nicaragua protectorate, 594

Non-intercourse act, 196ff.

Non-importation, 84ff., 99

North, Lord, 100, 131, 133

North Carolina: founded, 6.
  _See also_ Royal province, Immigration, Suffrage, and Constitutions,
    state

North Dakota, admission, 442

Northwest Ordinance, 219

Nullification, 182, 251ff.


Oglethorpe, James, 3

Ohio, admission, 225

Oklahoma, admission, 443

Open door policy, 500

Oregon, 284ff.

Ostend Manifesto, 486

Otis, James, 88, 95f.


Pacific, American influence, 447

Paine, Thomas, 103, 115, 175

Panama Canal, 508ff.

Panics: 1837, 262
  1857, 336
  1873, 464
  1893, 465

Parcel post, 529

Parker, A.B., 527

Parties: rise of, 168ff.
  Federalists, 169ff.
  Anti-Federalists (Jeffersonian Republicans), 169ff.
  Democrats, 260
  Whigs, 260ff.
  Republicans, 334ff.
  Liberal Republicans, 420
  Constitutional union, 340
  minor parties, 462ff.

Paterson, William, 196ff.

Penn, William, 6

Pennsylvania: founded, 6
  _See also_ Penn, Germans, Immigration, Industry, Revolutionary War,
    Constitutions, state, Suffrage

Pennsylvania University, 45

Pensions, soldiers and sailors, 413, 607
  mothers', 551

Pequots, 57

Perry, O.H., 200

Pershing, General, 610

Philadelphia, 36, 116

Philippines, 492ff., 516ff., 592

Phillips, Wendell, 320

Pierce, Franklin, 295, 330

Pike, Z., 193, 287

Pilgrims, 4

Pinckney, Charles, 148

Pitt, William, 61, 79, 87, 132

Planting system, 22f., 25, 149, 389, 393ff.

Plymouth, 4, 21

Polk, J.K., 265, 285f.

Polygamy, 290f.

Populist party, 464

Porto Rico, 515, 592

Postal savings bank, 529

Preble, Commodore, 196

Press. _See_ Newspapers

Primary, direct, 541

Princeton, battle, 129
  University, 45

Profit sharing, 572

Progressive party, 531f.

Prohibition, 591f.

Proprietary colonies, 3, 6

Provinces, royal, 49ff.

Public service, 538ff.

Pulaski, 121

Pullman strike, 465

Pure food act, 523

Puritans, 3, 7, 40ff.


Quakers, 6ff.

Quartering act, 83

Quebec act, 94

Queen Anne's War, 59

Quit rents, 21f.


Radicals, 579

Railways,  298, 402, 425, 460ff., 547, 621

Randolph, Edmund, 146, 147, 162

Ratification, of Constitution, 156ff.

Recall, 543

Reclamation, 523ff.

Reconstruction, 370ff.

Referendum, the, 543

Reign of terror, 174

Republicans: Jeffersonian, 179
  rise of present party, 334ff.
  supremacy of, 412ff.
  _See also_ McKinley, Roosevelt, and Taft

Resumption, 454

Revolution: American, 99ff.
  French, 171ff.
  Russian, 619

Rhode Island: founded, 4ff.
  self-government, 49
  _See also_ Suffrage

Roosevelt, Theodore, 492, 500ff., 531, 570

Royal province, 49ff.

Russia, 205, 207, 355, 479, 619

Russo-Japanese War, 511f.


Saint Mihiel, 612

Samoa, 481

San Jacinto, 280

Santa Fe trail, 287

Santo Domingo, 480, 513, 592

Saratoga, battle, 116, 130

Savannah, 116, 131

Scandinavians, 278

Schools. _See_ Education

Scott, General, 283, 330

Scotch-Irish, 7ff.

Seamen's act, 590

Sea power: American Revolution, 118
  Napoleonic wars, 193ff.
  Civil War, 353
  Caribbean, 593
  Pacific, 447
  World War, 610ff.

Secession, 344ff.

Sedition: act of 1798, 180ff., 187
  of 1918, 608

Senators, popular election, 527, 541ff.

Seven Years' War, 60ff.

Sevier, John, 218

Seward, W.H., 322, 342

Shafter, General, 492

Shays's rebellion, 142

Sherman, General, 361

Sherman: anti-trust law, 461
  silver act, 458

Shiloh, 361

Shipping. _See_ Commerce

Shipping act, 607

Silver, free, 455ff.

Slavery: colonial, 16f.
  trade, 150
  in Northwest, 219
  decline in North, 316f.
  growth in South, 320ff.
  and the Constitution, 324
  and territories, 325ff.
  compromises, 350
  abolished, 357ff.

Smith, Joseph, 290

Socialism, 577ff.

Solid South, 388

Solomon, Hayn, 126

Sons of liberty, 82

South: economic and political views, 309ff.
  _See also_ Slavery and Planting system, and Reconstruction

South Carolina: founded, 6
  nullification, 253ff.
  _See also_ Constitutions, state, Suffrage, Slavery, and Secession

South Dakota, 442

Spain: and Revolution, 130
  Louisiana, 190
  Monroe Doctrine, 205
  Spanish War, 490ff.

Spoils system, 244, 250, 418, 536ff.

Stamp act, 82ff.

Stanton, Elizabeth Cady, 564

States: disorders under Articles of Confederation, 141
  constitutions, federal limits on, 155
  position after Civil War, 366ff.
  _See also_ Suffrage, Nullification, and Secession

Steamboat, 234

Stowe, H.B., 332

Strikes: of 1877, 581
  Pullman, 581
  coal, 526
  _See also_ Labor

Submarine campaign, 600ff.

Suffrage: colonial, 42, 51
  first state constitutions, 239
  White manhood, 242
  Negro, 374ff., 385f.
  Woman, 110, 562ff.

Sugar act, 81

Sumner, Charles, 319

Sumter, Fort, 350

Swedes, 3, 13


Taft, W.H., 527ff.

Tammany Hall, 306, 418

Taney, Chief Justice, 357

Tariff: first, 167
  of 1816, 203
  development of, 251ff.
  abominations, 249, 253
  nullification, 251
  of 1842, 264
  Southern views of, 309ff.
  of 1857, 337
  Civil War, 367
  Wilson bill, 459
  McKinley bill, 422
  Dingley bill, 472
  Payne-Aldrich, 528
  Underwood, 588

Taxation: and representation, 149
  and Constitution, 154
  Civil War, 353
  and wealth, 522, 551
  and World War, 606

Tea act, 88

Tea party, 92

Tenement house reform, 549

Tennessee, 28, 224

Territories, Northwest, 219
  South of the Ohio, 219
  _See also_ Slavery and Compromise

Texas, 278ff.

Tippecanoe, battle, 198

Tocqueville, 267

Toleration, religious, 42

Tories, colonial, 84
  in Revolution, 112

Townshend acts, 80, 87

Trade, colonial, 70
  legislation, 70. _See_ Commerce

Transylvania company, 28

Treasury, independent, 263

Treaties, of 1763, 61
  alliance with France, 177
  of 1783 with England, 134
  Jay, 177, 218
  Louisiana purchase, 191f.
  of 1815, 201
  Ashburton, 265
  of 1848 with Mexico, 283
  Washington with England, 481
  with Spain, 492
  Versailles (1919), 612ff.

Trenton, battle, 116

Trollope, Mrs., 268

Trusts, 405ff., 461, 472ff., 521, 526, 530

Tweed, W.M., 418

Tyler, President, 264ff., 281, 349


"Uncle Tom's Cabin," 332

Union party, 365

Unions. _See_ Labor

Utah, 290ff., 329, 442

Utilities, municipal, 548


Vallandigham, 360

Valley Forge, 116, 129

Van Buren, Martin, 262

Venango, Fort, 59

Venezuela, 482ff., 512

Vermont, 223

Vicksburg, 361

Virginia: founded, 3.
  _See also_ Royal province, Constitutions, state, Planting system,
    Slavery, Secession, and Immigration


Walpole, Sir Robert, 66

Wars: colonial, 57ff.
  Revolutionary, 99ff.
  of 1812, 199ff.
  Mexican, 282ff.
  Civil, 344ff.
  Spanish, 490ff.
  World, 596ff.

Washington: warns French, 60
  in French war, 63
  commander-in-chief, 101ff.
  and movement for Constitution, 142ff.
  as President, 166ff.
  Farewell Address, 178

Washington City, 166

Washington State, 442

Webster, 256, 265, 328

Welfare work, 573

Whigs: English, 78
  colonial, 83
  rise of party, 260ff., 334, 340

Whisky Rebellion, 171

White Camelia, 382

White Plains, battle, 114

Whitman, Marcus, 284

William and Mary College, 45

Williams, Roger, 5, 42

Wilmot Proviso, 326

Wilson, James, 147

Wilson, Woodrow, election, 533f.
  administrations, 588ff.

Winthrop, John, 3

Wisconsin, admission, 274

Witchcraft, 41

Wollstonecraft, Mary, 556

Women: colonial, 28
  Revolutionary War, 124
  labor, 305
  education and civil rights, 554ff.
  suffrage, 562ff.

Workmen's compensation, 549

Writs of assistance, 88

Wyoming, admission, 442


X, Y, Z affair, 180


Yale, 44

Young, Brigham, 290


Zenger, Peter, 48

       *       *       *       *       *

Printed in the United States of America.

       *       *       *       *       *

[Transcriber's notes:

Punctuation normalized in all _Underwood and Underwood, N.Y._

Superscripted letters are denoted with a caret. For example, G^O
WASHINGTON.

Period added after Mass on verso page. Original read "Mass, U.S.A."

Chapter I, page 19, period added to pp. 55-159 and pp. 242-244.

Chapter IV, page 61 cooperation changed to cooperation twice to match
rest of text usage. Also on page 620.

Chapter VI, page 121 changed maneuvered to manoevered.

Chapter VIII, page 185, period added to "Vol." Original read "Vol III,"

Chapter X, page 219, changed coordinate to coordinate to reflect rest of
text usage.

Chapter X, page 234, Italicized habeus corpus to match rest of text.

Chapter XI, page 257 changed reestablished to reestablished to conform
to rest of text usage.

Chapter XI, page 259 changed reelection to reelection

Chapter XII, page 269 added period after "Vol" Vol. II

Chapter XII, page 270. Title of work reads "_Selected Documents of
United States History, 1776-1761_". Research shows the document does
have this title.

Chapter XV, page 351. changed "bout" to "about". "for only about"

Chapter XVI, page 385. changed "provisons" to "provisions".

Chapter XX, page 478. changed "aniversary" to "anniversary".

Chapter XXIV, page 579 word "on" changed to "one" "five commissioners,
one of whom,"

Topical Syllabus. Missing periods added to normalize punctuation in
entries such as on page 648 (4) Sixteenth Amendment--income tax
(528-529).

Appendix, page 631, comma changed to semi-colon on "bills of credit;" to
match rest of list. Also on "obligation of contracts;"

Index, page 657, changed "Freesoil" to Free-soil to match rest of text
usage.

Index, page 660, space removed from "396 ff." changed to "status of,
396ff."

Index, Page 662, added comma to States: disorders under Articles of
Constitution, 141]





End of the Project Gutenberg EBook of History of the United States
by Charles A. Beard and Mary R. Beard

*** END OF THIS PROJECT GUTENBERG EBOOK HISTORY OF THE UNITED STATES ***

***** This file should be named 16960-8.txt or 16960-8.zip *****
This and all associated files of various formats will be found in:
        http://www.gutenberg.org/1/6/9/6/16960/

Produced by Curtis Weyant, M and the Online Distributed
Proofreading Team at http://www.pgdp.net


Updated editions will replace the previous one--the old editions
will be renamed.

Creating the works from public domain print editions means that no
one owns a United States copyright in these works, so the Foundation
(and you!) can copy and distribute it in the United States without
permission and without paying copyright royalties.  Special rules,
set forth in the General Terms of Use part of this license, apply to
copying and distributing Project Gutenberg-tm electronic works to
protect the PROJECT GUTENBERG-tm concept and trademark.  Project
Gutenberg is a registered trademark, and may not be used if you
charge for the eBooks, unless you receive specific permission.  If you
do not charge anything for copies of this eBook, complying with the
rules is very easy.  You may use this eBook for nearly any purpose
such as creation of derivative works, reports, performances and
research.  They may be modified and printed and given away--you may do
practically ANYTHING with public domain eBooks.  Redistribution is
subject to the trademark license, especially commercial
redistribution.



*** START: FULL LICENSE ***

THE FULL PROJECT GUTENBERG LICENSE
PLEASE READ THIS BEFORE YOU DISTRIBUTE OR USE THIS WORK

To protect the Project Gutenberg-tm mission of promoting the free
distribution of electronic works, by using or distributing this work
(or any other work associated in any way with the phrase "Project
Gutenberg"), you agree to comply with all the terms of the Full Project
Gutenberg-tm License (available with this file or online at
http://gutenberg.net/license).


Section 1.  General Terms of Use and Redistributing Project Gutenberg-tm
electronic works

1.A.  By reading or using any part of this Project Gutenberg-tm
electronic work, you indicate that you have read, understand, agree to
and accept all the terms of this license and intellectual property
(trademark/copyright) agreement.  If you do not agree to abide by all
the terms of this agreement, you must cease using and return or destroy
all copies of Project Gutenberg-tm electronic works in your possession.
If you paid a fee for obtaining a copy of or access to a Project
Gutenberg-tm electronic work and you do not agree to be bound by the
terms of this agreement, you may obtain a refund from the person or
entity to whom you paid the fee as set forth in paragraph 1.E.8.

1.B.  "Project Gutenberg" is a registered trademark.  It may only be
used on or associated in any way with an electronic work by people who
agree to be bound by the terms of this agreement.  There are a few
things that you can do with most Project Gutenberg-tm electronic works
even without complying with the full terms of this agreement.  See
paragraph 1.C below.  There are a lot of things you can do with Project
Gutenberg-tm electronic works if you follow the terms of this agreement
and help preserve free future access to Project Gutenberg-tm electronic
works.  See paragraph 1.E below.

1.C.  The Project Gutenberg Literary Archive Foundation ("the Foundation"
or PGLAF), owns a compilation copyright in the collection of Project
Gutenberg-tm electronic works.  Nearly all the individual works in the
collection are in the public domain in the United States.  If an
individual work is in the public domain in the United States and you are
located in the United States, we do not claim a right to prevent you from
copying, distributing, performing, displaying or creating derivative
works based on the work as long as all references to Project Gutenberg
are removed.  Of course, we hope that you will support the Project
Gutenberg-tm mission of promoting free access to electronic works by
freely sharing Project Gutenberg-tm works in compliance with the terms of
this agreement for keeping the Project Gutenberg-tm name associated with
the work.  You can easily comply with the terms of this agreement by
keeping this work in the same format with its attached full Project
Gutenberg-tm License when you share it without charge with others.

1.D.  The copyright laws of the place where you are located also govern
what you can do with this work.  Copyright laws in most countries are in
a constant state of change.  If you are outside the United States, check
the laws of your country in addition to the terms of this agreement
before downloading, copying, displaying, performing, distributing or
creating derivative works based on this work or any other Project
Gutenberg-tm work.  The Foundation makes no representations concerning
the copyright status of any work in any country outside the United
States.

1.E.  Unless you have removed all references to Project Gutenberg:

1.E.1.  The following sentence, with active links to, or other immediate
access to, the full Project Gutenberg-tm License must appear prominently
whenever any copy of a Project Gutenberg-tm work (any work on which the
phrase "Project Gutenberg" appears, or with which the phrase "Project
Gutenberg" is associated) is accessed, displayed, performed, viewed,
copied or distributed:

This eBook is for the use of anyone anywhere at no cost and with
almost no restrictions whatsoever.  You may copy it, give it away or
re-use it under the terms of the Project Gutenberg License included
with this eBook or online at www.gutenberg.net

1.E.2.  If an individual Project Gutenberg-tm electronic work is derived
from the public domain (does not contain a notice indicating that it is
posted with permission of the copyright holder), the work can be copied
and distributed to anyone in the United States without paying any fees
or charges.  If you are redistributing or providing access to a work
with the phrase "Project Gutenberg" associated with or appearing on the
work, you must comply either with the requirements of paragraphs 1.E.1
through 1.E.7 or obtain permission for the use of the work and the
Project Gutenberg-tm trademark as set forth in paragraphs 1.E.8 or
1.E.9.

1.E.3.  If an individual Project Gutenberg-tm electronic work is posted
with the permission of the copyright holder, your use and distribution
must comply with both paragraphs 1.E.1 through 1.E.7 and any additional
terms imposed by the copyright holder.  Additional terms will be linked
to the Project Gutenberg-tm License for all works posted with the
permission of the copyright holder found at the beginning of this work.

1.E.4.  Do not unlink or detach or remove the full Project Gutenberg-tm
License terms from this work, or any files containing a part of this
work or any other work associated with Project Gutenberg-tm.

1.E.5.  Do not copy, display, perform, distribute or redistribute this
electronic work, or any part of this electronic work, without
prominently displaying the sentence set forth in paragraph 1.E.1 with
active links or immediate access to the full terms of the Project
Gutenberg-tm License.

1.E.6.  You may convert to and distribute this work in any binary,
compressed, marked up, nonproprietary or proprietary form, including any
word processing or hypertext form.  However, if you provide access to or
distribute copies of a Project Gutenberg-tm work in a format other than
"Plain Vanilla ASCII" or other format used in the official version
posted on the official Project Gutenberg-tm web site (www.gutenberg.net),
you must, at no additional cost, fee or expense to the user, provide a
copy, a means of exporting a copy, or a means of obtaining a copy upon
request, of the work in its original "Plain Vanilla ASCII" or other
form.  Any alternate format must include the full Project Gutenberg-tm
License as specified in paragraph 1.E.1.

1.E.7.  Do not charge a fee for access to, viewing, displaying,
performing, copying or distributing any Project Gutenberg-tm works
unless you comply with paragraph 1.E.8 or 1.E.9.

1.E.8.  You may charge a reasonable fee for copies of or providing
access to or distributing Project Gutenberg-tm electronic works provided
that

- You pay a royalty fee of 20% of the gross profits you derive from
     the use of Project Gutenberg-tm works calculated using the method
     you already use to calculate your applicable taxes.  The fee is
     owed to the owner of the Project Gutenberg-tm trademark, but he
     has agreed to donate royalties under this paragraph to the
     Project Gutenberg Literary Archive Foundation.  Royalty payments
     must be paid within 60 days following each date on which you
     prepare (or are legally required to prepare) your periodic tax
     returns.  Royalty payments should be clearly marked as such and
     sent to the Project Gutenberg Literary Archive Foundation at the
     address specified in Section 4, "Information about donations to
     the Project Gutenberg Literary Archive Foundation."

- You provide a full refund of any money paid by a user who notifies
     you in writing (or by e-mail) within 30 days of receipt that s/he
     does not agree to the terms of the full Project Gutenberg-tm
     License.  You must require such a user to return or
     destroy all copies of the works possessed in a physical medium
     and discontinue all use of and all access to other copies of
     Project Gutenberg-tm works.

- You provide, in accordance with paragraph 1.F.3, a full refund of any
     money paid for a work or a replacement copy, if a defect in the
     electronic work is discovered and reported to you within 90 days
     of receipt of the work.

- You comply with all other terms of this agreement for free
     distribution of Project Gutenberg-tm works.

1.E.9.  If you wish to charge a fee or distribute a Project Gutenberg-tm
electronic work or group of works on different terms than are set
forth in this agreement, you must obtain permission in writing from
both the Project Gutenberg Literary Archive Foundation and Michael
Hart, the owner of the Project Gutenberg-tm trademark.  Contact the
Foundation as set forth in Section 3 below.

1.F.

1.F.1.  Project Gutenberg volunteers and employees expend considerable
effort to identify, do copyright research on, transcribe and proofread
public domain works in creating the Project Gutenberg-tm
collection.  Despite these efforts, Project Gutenberg-tm electronic
works, and the medium on which they may be stored, may contain
"Defects," such as, but not limited to, incomplete, inaccurate or
corrupt data, transcription errors, a copyright or other intellectual
property infringement, a defective or damaged disk or other medium, a
computer virus, or computer codes that damage or cannot be read by
your equipment.

1.F.2.  LIMITED WARRANTY, DISCLAIMER OF DAMAGES - Except for the "Right
of Replacement or Refund" described in paragraph 1.F.3, the Project
Gutenberg Literary Archive Foundation, the owner of the Project
Gutenberg-tm trademark, and any other party distributing a Project
Gutenberg-tm electronic work under this agreement, disclaim all
liability to you for damages, costs and expenses, including legal
fees.  YOU AGREE THAT YOU HAVE NO REMEDIES FOR NEGLIGENCE, STRICT
LIABILITY, BREACH OF WARRANTY OR BREACH OF CONTRACT EXCEPT THOSE
PROVIDED IN PARAGRAPH F3.  YOU AGREE THAT THE FOUNDATION, THE
TRADEMARK OWNER, AND ANY DISTRIBUTOR UNDER THIS AGREEMENT WILL NOT BE
LIABLE TO YOU FOR ACTUAL, DIRECT, INDIRECT, CONSEQUENTIAL, PUNITIVE OR
INCIDENTAL DAMAGES EVEN IF YOU GIVE NOTICE OF THE POSSIBILITY OF SUCH
DAMAGE.

1.F.3.  LIMITED RIGHT OF REPLACEMENT OR REFUND - If you discover a
defect in this electronic work within 90 days of receiving it, you can
receive a refund of the money (if any) you paid for it by sending a
written explanation to the person you received the work from.  If you
received the work on a physical medium, you must return the medium with
your written explanation.  The person or entity that provided you with
the defective work may elect to provide a replacement copy in lieu of a
refund.  If you received the work electronically, the person or entity
providing it to you may choose to give you a second opportunity to
receive the work electronically in lieu of a refund.  If the second copy
is also defective, you may demand a refund in writing without further
opportunities to fix the problem.

1.F.4.  Except for the limited right of replacement or refund set forth
in paragraph 1.F.3, this work is provided to you 'AS-IS' WITH NO OTHER
WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
WARRANTIES OF MERCHANTIBILITY OR FITNESS FOR ANY PURPOSE.

1.F.5.  Some states do not allow disclaimers of certain implied
warranties or the exclusion or limitation of certain types of damages.
If any disclaimer or limitation set forth in this agreement violates the
law of the state applicable to this agreement, the agreement shall be
interpreted to make the maximum disclaimer or limitation permitted by
the applicable state law.  The invalidity or unenforceability of any
provision of this agreement shall not void the remaining provisions.

1.F.6.  INDEMNITY - You agree to indemnify and hold the Foundation, the
trademark owner, any agent or employee of the Foundation, anyone
providing copies of Project Gutenberg-tm electronic works in accordance
with this agreement, and any volunteers associated with the production,
promotion and distribution of Project Gutenberg-tm electronic works,
harmless from all liability, costs and expenses, including legal fees,
that arise directly or indirectly from any of the following which you do
or cause to occur: (a) distribution of this or any Project Gutenberg-tm
work, (b) alteration, modification, or additions or deletions to any
Project Gutenberg-tm work, and (c) any Defect you cause.


Section  2.  Information about the Mission of Project Gutenberg-tm

Project Gutenberg-tm is synonymous with the free distribution of
electronic works in formats readable by the widest variety of computers
including obsolete, old, middle-aged and new computers.  It exists
because of the efforts of hundreds of volunteers and donations from
people in all walks of life.

Volunteers and financial support to provide volunteers with the
assistance they need, is critical to reaching Project Gutenberg-tm's
goals and ensuring that the Project Gutenberg-tm collection will
remain freely available for generations to come.  In 2001, the Project
Gutenberg Literary Archive Foundation was created to provide a secure
and permanent future for Project Gutenberg-tm and future generations.
To learn more about the Project Gutenberg Literary Archive Foundation
and how your efforts and donations can help, see Sections 3 and 4
and the Foundation web page at http://www.pglaf.org.


Section 3.  Information about the Project Gutenberg Literary Archive
Foundation

The Project Gutenberg Literary Archive Foundation is a non profit
501(c)(3) educational corporation organized under the laws of the
state of Mississippi and granted tax exempt status by the Internal
Revenue Service.  The Foundation's EIN or federal tax identification
number is 64-6221541.  Its 501(c)(3) letter is posted at
http://pglaf.org/fundraising.  Contributions to the Project Gutenberg
Literary Archive Foundation are tax deductible to the full extent
permitted by U.S. federal laws and your state's laws.

The Foundation's principal office is located at 4557 Melan Dr. S.
Fairbanks, AK, 99712., but its volunteers and employees are scattered
throughout numerous locations.  Its business office is located at
809 North 1500 West, Salt Lake City, UT 84116, (801) 596-1887, email
business@pglaf.org.  Email contact links and up to date contact
information can be found at the Foundation's web site and official
page at http://pglaf.org

For additional contact information:
     Dr. Gregory B. Newby
     Chief Executive and Director
     gbnewby@pglaf.org


Section 4.  Information about Donations to the Project Gutenberg
Literary Archive Foundation

Project Gutenberg-tm depends upon and cannot survive without wide
spread public support and donations to carry out its mission of
increasing the number of public domain and licensed works that can be
freely distributed in machine readable form accessible by the widest
array of equipment including outdated equipment.  Many small donations
($1 to $5,000) are particularly important to maintaining tax exempt
status with the IRS.

The Foundation is committed to complying with the laws regulating
charities and charitable donations in all 50 states of the United
States.  Compliance requirements are not uniform and it takes a
considerable effort, much paperwork and many fees to meet and keep up
with these requirements.  We do not solicit donations in locations
where we have not received written confirmation of compliance.  To
SEND DONATIONS or determine the status of compliance for any
particular state visit http://pglaf.org

While we cannot and do not solicit contributions from states where we
have not met the solicitation requirements, we know of no prohibition
against accepting unsolicited donations from donors in such states who
approach us with offers to donate.

International donations are gratefully accepted, but we cannot make
any statements concerning tax treatment of donations received from
outside the United States.  U.S. laws alone swamp our small staff.

Please check the Project Gutenberg Web pages for current donation
methods and addresses.  Donations are accepted in a number of other
ways including including checks, online payments and credit card
donations.  To donate, please visit: http://pglaf.org/donate


Section 5.  General Information About Project Gutenberg-tm electronic
works.

Professor Michael S. Hart is the originator of the Project Gutenberg-tm
concept of a library of electronic works that could be freely shared
with anyone.  For thirty years, he produced and distributed Project
Gutenberg-tm eBooks with only a loose network of volunteer support.


Project Gutenberg-tm eBooks are often created from several printed
editions, all of which are confirmed as Public Domain in the U.S.
unless a copyright notice is included.  Thus, we do not necessarily
keep eBooks in compliance with any particular paper edition.


Most people start at our Web site which has the main PG search facility:

     http://www.gutenberg.net

This Web site includes information about Project Gutenberg-tm,
including how to make donations to the Project Gutenberg Literary
Archive Foundation, how to help produce our new eBooks, and how to
subscribe to our email newsletter to hear about new eBooks.
Project Gutenberg's Manual of Surgery, by Alexis Thomson and Alexander Miles

This eBook is for the use of anyone anywhere at no cost and with
almost no restrictions whatsoever.  You may copy it, give it away or
re-use it under the terms of the Project Gutenberg License included
with this eBook or online at www.gutenberg.org


Title: Manual of Surgery
       Volume First: General Surgery. Sixth Edition.

Author: Alexis Thomson and Alexander Miles

Release Date: March 4, 2006 [EBook #17921]

Language: English

Character set encoding: ISO-8859-1

*** START OF THIS PROJECT GUTENBERG EBOOK MANUAL OF SURGERY ***




Produced by Jonathan Ingram, Laura Wisewell and the Online
Distributed Proofreading Team at http://www.pgdp.net





+--------------------------------------------------------------------+
|                                                                    |
| Transcriber's note: The original text used the apothecaries'       |
| symbols here rendered as [ounce] and [dram]. The substitutions     |
| used for other special characters, such as the oe ligature, are    |
| standard. All the special characters are preserved in the UTF-8    |
| and HTML versions of this text.                                    |
|                                                                    |
| In addition, a number of printing errors have been corrected.      |
| These are marked in the HTML version only.                         |
|                                                                    |
+--------------------------------------------------------------------+




                     OXFORD MEDICAL PUBLICATIONS



                          MANUAL OF SURGERY



                                  BY

                     ALEXIS THOMSON, F.R.C.S.Ed.
           _PROFESSOR OF SURGERY, UNIVERSITY OF EDINBURGH_
                  SURGEON EDINBURGH ROYAL INFIRMARY

                                 AND

                     ALEXANDER MILES, F.R.C.S.Ed.
                  SURGEON EDINBURGH ROYAL INFIRMARY


                             VOLUME FIRST
                           GENERAL SURGERY


                       _SIXTH EDITION REVISED_
                       _WITH 169 ILLUSTRATIONS_



                                LONDON
                 HENRY FROWDE and HODDER & STOUGHTON
                        THE _LANCET_ BUILDING
                 1 & 2 BEDFORD STREET, STRAND, W.C.2






    First Edition                                             1904
    Second Edition                                            1907
    Third Edition                                             1909
    Fourth Edition                                            1911
      "       "    Second Impression                          1913
    Fifth Edition                                             1915
      "       "    Second Impression                          1919
    Sixth Edition                                             1921



                     PRINTED IN GREAT BRITAIN BY
                  MORRISON AND GIBB LTD., EDINBURGH




PREFACE TO SIXTH EDITION


Much has happened since this Manual was last revised, and many surgical
lessons have been learned in the hard school of war. Some may yet have
to be unlearned, and others have but little bearing on the problems
presented to the civilian surgeon. Save in its broadest principles, the
surgery of warfare is a thing apart from the general surgery of civil
life, and the exhaustive literature now available on every aspect of it
makes it unnecessary that it should receive detailed consideration in a
manual for students. In preparing this new edition, therefore, we have
endeavoured to incorporate only such additions to our knowledge and
resources as our experience leads us to believe will prove of permanent
value in civil practice.

For the rest, the text has been revised, condensed, and in places
rearranged; a number of old illustrations have been discarded, and a
greater number of new ones added. Descriptions of operative procedures
have been omitted from the _Manual_, as they are to be found in the
companion volume on _Operative Surgery_, the third edition of which
appeared some months ago.

We have retained the Basle anatomical nomenclature, as extended
experience has confirmed our preference for it. For the convenience of
readers who still employ the old terms, these are given in brackets
after the new.

This edition of the _Manual_ appears in three volumes; the first being
devoted to General Surgery, the other two to Regional Surgery. This
arrangement has enabled us to deal in a more consecutive manner than
hitherto with the surgery of the Extremities, including Fractures and
Dislocations.

We have once more to express our thanks to colleagues in the Edinburgh
School and to other friends for aiding us in providing new
illustrations, and for other valuable help, as well as to our publishers
for their generosity in the matter of illustrations.

EDINBURGH,
    _March_ 1921.




CONTENTS


                                                                   PAGE
    CHAPTER I
    REPAIR                                                            1

    CHAPTER II
    CONDITIONS WHICH INTERFERE WITH REPAIR                           17

    CHAPTER III
    INFLAMMATION                                                     31

    CHAPTER IV
    SUPPURATION                                                      45

    CHAPTER V
    ULCERATION AND ULCERS                                            68

    CHAPTER VI
    GANGRENE                                                         86

    CHAPTER VII
    BACTERIAL AND OTHER WOUND INFECTIONS                            107

    CHAPTER VIII
    TUBERCULOSIS                                                    133

    CHAPTER IX
    SYPHILIS                                                        146

    CHAPTER X
    TUMOURS                                                         181

    CHAPTER XI
    INJURIES                                                        218

    CHAPTER XII
    METHODS OF WOUND TREATMENT                                      241

    CHAPTER XIII
    CONSTITUTIONAL EFFECTS OF INJURIES                              249

    CHAPTER XIV
    THE BLOOD VESSELS                                               258

    CHAPTER XV
    THE LYMPH VESSELS AND GLANDS                                    321

    CHAPTER XVI
    THE NERVES                                                      342

    CHAPTER XVII
    SKIN AND SUBCUTANEOUS TISSUES                                   376

    CHAPTER XVIII
    THE MUSCLES, TENDONS, AND TENDON SHEATHS                        405

    CHAPTER XIX
    THE BURSAE                                                       426

    CHAPTER XX
    DISEASES OF BONE                                                434

    CHAPTER XXI
    DISEASES OF JOINTS                                              501

    INDEX                                                           547




LIST OF ILLUSTRATIONS


  FIG.                                                             PAGE

    1. Ulcer of Back of Hand grafted from Abdominal Wall             15

    2. Staphylococcus aureus in Pus from case of Osteomyelitis       25

    3. Streptococci in Pus from case of Diffuse Cellulitis           26

    4. Bacillus coli communis in Pus from Abdominal Abscess          27

    5. Fraenkel's Pneumococci in Pus from Empyema following          28
       Pneumonia

    6. Passive Hyperaemia of Hand and Forearm induced by Bier's       37
       Bandage

    7. Passive Hyperaemia of Finger induced by Klapp's Suction        38
       Bell

    8. Passive Hyperaemia induced by Klapp's Suction Bell for         39
       Inflammation of Inguinal Gland

    9. Diagram of various forms of Whitlow                           56

   10. Charts of Acute Sapraemia                                      61

   11. Chart of Hectic Fever                                         62

   12. Chart of Septicaemia followed by Pyaemia                        63

   13. Chart of Pyaemia following on Acute Osteomyelitis              65

   14. Leg Ulcers associated with Varicose Veins                     71

   15. Perforating Ulcers of Sole of Foot                            74

   16. Bazin's Disease in a girl aet. 16                              75

   17. Syphilitic Ulcers in region of Knee                           76

   18. Callous Ulcer showing thickened edges                         78

   19. Tibia and Fibula, showing changes due to Chronic Ulcer of     80
       Leg

   20. Senile Gangrene of the Foot                                   89

   21. Embolic Gangrene of Hand and Arm                              92

   22. Gangrene of Terminal Phalanx of Index-Finger                 100

   23. Cancrum Oris                                                 103

   24. Acute Bed Sores over right Buttock                           104

   25. Chart of Erysipelas occurring in a wound                     108

   26. Bacillus of Tetanus                                          113

   27. Bacillus of Anthrax                                          120

   28. Malignant Pustule third day after infection                  122

   29. Malignant Pustule fourteen days after infection              122

   30. Colony of Actinomyces                                        126

   31. Actinomycosis of Maxilla                                     128

   32. Mycetoma, or Madura Foot                                     130

   33. Tubercle bacilli                                             134

   34. Tuberculous Abscess in Lumbar Region                         141

   35. Tuberculous Sinus injected through its opening in the        144
       Forearm with Bismuth Paste

   36. Spirochaete pallida                                           147

   37. Spirochaeta refrigerans from scraping of Vagina               148

   38. Primary Lesion on Thumb, with Secondary Eruption on          154
       Forearm

   39. Syphilitic Rupia                                             159

   40. Ulcerating Gumma of Lips                                     169

   41. Ulceration in inherited Syphilis                             170

   42. Tertiary Syphilitic Ulceration in region of Knee and on      171
       both Thumbs

   43. Facies of Inherited Syphilis                                 174

   44. Facies of Inherited Syphilis                                 175

   45. Subcutaneous Lipoma                                          185

   46. Pedunculated Lipoma of Buttock                               186

   47. Diffuse Lipomatosis of Neck                                  187

   48. Zanthoma of Hands                                            188

   49. Zanthoma of Buttock                                          189

   50. Chondroma growing from Infra-Spinous Fossa of Scapula        190

   51. Chondroma of Metacarpal Bone of Thumb                        190

   52. Cancellous Osteoma of Lower End of Femur                     192

   53. Myeloma of Shaft of Humerus                                  195

   54. Fibro-myoma of Uterus                                        196

   55. Recurrent Sarcoma of Sciatic Nerve                           198

   56. Sarcoma of Arm fungating                                     199

   57. Carcinoma of Breast                                          206

   58. Epithelioma of Lip                                           209

   59. Dermoid Cyst of Ovary                                        213

   60. Carpal Ganglion in a woman aet. 25                            215

   61. Ganglion on lateral aspect of Knee                           216

   62. Radiogram showing pellets embedded in Arm                    228

   63. Cicatricial Contraction following Severe Burn                236

   64. Genealogical Tree of Haemophilic Family                       278

   65. Radiogram showing calcareous degeneration of Arteries        284

   66. Varicose Vein with Thrombosis                                289

   67. Extensive Varix of Internal Saphena System on Left Leg       291

   68. Mixed Naevus of Nose                                          296

   69. Cirsoid Aneurysm of Forehead                                 299

   70. Cirsoid Aneurysm of Orbit and Face                           300

   71. Radiogram of Aneurysm of Aorta                               303

   72. Sacculated Aneurysm of Abdominal Aorta                       304

   73. Radiogram of Innominate Aneurysm after Treatment by          309
       Moore-Corradi method

   74. Thoracic Aneurysm threatening to rupture                     313

   75. Innominate Aneurysm in a woman                               315

   76. Congenital Cystic Tumour or Hygroma of Axilla                328

   77. Tuberculous Cervical Gland with Abscess formation            331

   78. Mass of Tuberculous Glands removed from Axilla               333

   79. Tuberculous Axillary Glands                                  335

   80. Chronic Hodgkin's Disease in boy aet. 11                      337

   81. Lymphadenoma in a woman aet. 44                               338

   82. Lympho Sarcoma removed from Groin                            339

   83. Cancerous Glands in Neck, secondary to Epithelioma of Lip    341

   84. Stump Neuromas of Sciatic Nerve                              345

   85. Stump Neuromas, showing changes at ends of divided Nerves    354

   86. Diffuse Enlargement of Nerves in generalised                 356
       Neuro-Fibromatosis

   87. Plexiform Neuroma of small Sciatic Nerve                     357

   88. Multiple Neuro-Fibromas of Skin (Molluscum fibrosum)         358

   89. Elephantiasis Neuromatosa in a woman aet. 28                  359

   90. Drop-Wrist following Fracture of Shaft of Humerus            365

   91. To illustrate the Loss of Sensation produced by Division     367
       of the Median Nerve

   92. To illustrate Loss of Sensation produced by Complete         368
       Division of Ulnar Nerve

   93. Callosities and Corns on Sole of Foot                        377

   94. Ulcerated Chilblains on Fingers                              378

   95. Carbuncle on Back of Neck                                    381

   96. Tuberculous Elephantiasis                                    383

   97. Elephantiasis in a woman aet. 45                              387

   98. Elephantiasis of Penis and Scrotum                           388

   99. Multiple Sebaceous Cysts or Wens                             390

  100. Sebaceous Horn growing from Auricle                          392

  101. Paraffin Epithelioma                                         394

  102. Rodent Cancer of Inner Canthus                               395

  103. Rodent Cancer with destruction of contents of Orbit          396

  104. Diffuse Melanotic Cancer of Lymphatics of Skin               398

  105. Melanotic Cancer of Forehead with Metastasis in Lymph        399
       Glands

  106. Recurrent Keloid                                             401

  107. Subungual Exostosis                                          403

  108. Avulsion of Tendon                                           410

  109. Volkmann's Ischaemic Contracture                              414

  110. Ossification in Tendon of Ilio-psoas Muscle                  417

  111. Radiogram of Calcification and Ossification in Biceps and    418
       Triceps

  112. Ossification in Muscles of Trunk in generalised Ossifying    419
       Myositis

  113. Hydrops of Prepatellar Bursa                                 427

  114. Section through Gouty Bursa                                  428

  115. Tuberculous Disease of Sub-Deltoid Bursa                     429

  116. Great Enlargement of the Ischial Bursa                       431

  117. Gouty Disease of Bursae                                       432

  118. Shaft of the Femur after Acute Osteomyelitis                 444

  119. Femur and Tibia showing results of Acute Osteomyelitis       445

  120. Segment of Tibia resected for Brodie's Abscess               449

  121. Radiogram of Brodie's Abscess in Lower End of Tibia          451

  122. Sequestrum of Femur after Amputation                         453

  123. New Periosteal Bone on Surface of Femur from Amputation      454
       Stump

  124. Tuberculous Osteomyelitis of Os Magnum                       456

  125. Tuberculous Disease of Tibia                                 457

  126. Diffuse Tuberculous Osteomyelitis of Right Tibia             458

  127. Advanced Tuberculous Disease in Region of Ankle              459

  128. Tuberculous Dactylitis                                       460

  129. Shortening of Middle Finger of Adult, the result of          461
       Tuberculous Dactylitis in Childhood

  130. Syphilitic Disease of Skull                                  463

  131. Syphilitic Hyperostosis and Sclerosis of Tibia               464

  132. Sabre-blade Deformity of Tibia                               467

  133. Skeleton of Rickety Dwarf                                    470

  134. Changes in the Skull resulting from Ostitis Deformans        474

  135. Cadaver, illustrating the alterations in the Lower Limbs     475
       resulting from Ostitis Deformans

  136. Osteomyelitis Fibrosa affecting Femora                       476

  137. Radiogram of Upper End of Femur in Osteomyelitis Fibrosa     478

  138. Radiogram of Right Knee showing Multiple Exostoses           482

  139. Multiple Exostoses of Limbs                                  483

  140. Multiple Cartilaginous Exostoses                             484

  141. Multiple Cartilaginous Exostoses                             486

  142. Multiple Chondromas of Phalanges and Metacarpals             488

  143. Skiagram of Multiple Chondromas                              489

  144. Multiple Chondromas in Hand                                  490

  145. Radiogram of Myeloma of Humerus                              492

  146. Periosteal Sarcoma of Femur                                  493

  147. Periosteal Sarcoma of Humerus                                493

  148. Chondro-Sarcoma of Scapula                                   494

  149. Central Sarcoma of Femur invading Knee Joint                 495

  150. Osseous Shell of Osteo-Sarcoma of Femur                      495

  151. Radiogram of Osteo-Sarcoma of Femur                          496

  152. Radiogram of Chondro-Sarcoma of Humerus                      497

  153. Epitheliomatus Ulcer of Leg invading Tibia                   499

  154. Osseous Ankylosis of Femur and Tibia                         503

  155. Osseous Ankylosis of Knee                                    504

  156. Caseating focus in Upper End of Fibula                       513

  157. Arthritis Deformans of Elbow                                 525

  158. Arthritis Deformans of Knee                                  526

  159. Hypertrophied Fringes of Synovial Membrane of Knee           527

  160. Arthritis Deformans of Hands                                 529

  161. Arthritis Deformans of several Joints                        530

  162. Bones of Knee in Charcot's Disease                           533

  163. Charcot's Disease of Left Knee                               534

  164. Charcot's Disease of both Ankles: front view                 535

  165. Charcot's Disease of both Ankles: back view                  536

  166. Radiogram of Multiple Loose Bodies in Knee-joint             540

  167. Loose Body from Knee-joint                                   541

  168. Multiple partially ossified Chondromas of Synovial           542
       Membrane from Shoulder-joint

  169. Multiple Cartilaginous Loose Bodies from Knee-joint          543




MANUAL OF SURGERY




CHAPTER I

REPAIR


Introduction--Process of repair--Healing by primary union--Granulation
    tissue--Cicatricial tissue--Modifications of process of
    repair--Repair in individual tissues--Transplantation or grafting
    of tissues--Conditions--Sources of grafts--Grafting of individual
    tissues--Methods.


INTRODUCTION

To prolong human life and to alleviate suffering are the ultimate
objects of scientific medicine. The two great branches of the healing
art--Medicine and Surgery--are so intimately related that it is
impossible to draw a hard-and-fast line between them, but for
convenience Surgery may be defined as "the art of treating lesions and
malformations of the human body by manual operations, mediate and
immediate." To apply his art intelligently and successfully, it is
essential that the surgeon should be conversant not only with the normal
anatomy and physiology of the body and with the various pathological
conditions to which it is liable, but also with the nature of the
process by which repair of injured or diseased tissues is effected.
Without this knowledge he is unable to recognise such deviations from
the normal as result from mal-development, injury, or disease, or
rationally to direct his efforts towards the correction or removal of
these.


PROCESS OF REPAIR

The process of repair in living tissue depends upon an inherent power
possessed by vital cells of reacting to the irritation caused by injury
or disease. The cells of the damaged tissues, under the influence of
this irritation, undergo certain proliferative changes, which are
designed to restore the normal structure and configuration of the part.
The process by which this restoration is effected is essentially the
same in all tissues, but the extent to which different tissues can carry
the recuperative process varies. Simple structures, such as skin,
cartilage, bone, periosteum, and tendon, for example, have a high power
of regeneration, and in them the reparative process may result in almost
perfect restitution to the normal. More complex structures, on the other
hand, such as secreting glands, muscle, and the tissues of the central
nervous system, are but imperfectly restored, simple cicatricial
connective tissue taking the place of what has been lost or destroyed.
Any given tissue can be replaced only by tissue of a similar kind, and
in a damaged part each element takes its share in the reparative process
by producing new material which approximates more or less closely to the
normal according to the recuperative capacity of the particular tissue.
The normal process of repair may be interfered with by various
extraneous agencies, the most important of which are infection by
disease-producing micro-organisms, the presence of foreign substances,
undue movement of the affected part, and improper applications and
dressings. The effect of these agencies is to delay repair or to prevent
the individual tissues carrying the process to the furthest degree of
which they are capable.

In the management of wounds and other diseased conditions the main
object of the surgeon is to promote the natural reparative process by
preventing or eliminating any factor by which it may be disturbed.

#Healing by Primary Union.#--The most favourable conditions for the
progress of the reparative process are to be found in a clean-cut wound
of the integument, which is uncomplicated by loss of tissue, by the
presence of foreign substances, or by infection with disease-producing
micro-organisms, and its edges are in contact. Such a wound in virtue of
the absence of infection is said to be _aseptic_, and under these
conditions healing takes place by what is called "primary union"--the
"healing by first intention" of the older writers.

#Granulation Tissue.#--The essential and invariable medium of repair in
all structures is an elementary form of new tissue known as _granulation
tissue_, which is produced in the damaged area in response to the
irritation caused by injury or disease. The vital reaction induced by
such irritation results in dilatation of the vessels of the part,
emigration of leucocytes, transudation of lymph, and certain
proliferative changes in the fixed tissue cells. These changes are
common to the processes of inflammation and repair; no hard-and-fast
line can be drawn between these processes, and the two may go on
together. It is, however, only when the proliferative changes have come
to predominate that the reparative process is effectively established by
the production of healthy granulation tissue.

_Formation of Granulation Tissue._--When a wound is made in the
integument under aseptic conditions, the passage of the knife through
the tissues is immediately followed by an oozing of blood, which soon
coagulates on the cut surfaces. In each of the divided vessels a clot
forms, and extends as far as the nearest collateral branch; and on the
surface of the wound there is a microscopic layer of bruised and
devitalised tissue. If the wound is closed, the narrow space between its
edges is occupied by blood-clot, which consists of red and white
corpuscles mixed with a quantity of fibrin, and this forms a temporary
uniting medium between the divided surfaces. During the first twelve
hours, the minute vessels in the vicinity of the wound dilate, and from
them lymph exudes and leucocytes migrate into the tissues. In from
twenty-four to thirty-six hours, the capillaries of the part adjacent to
the wound begin to throw out minute buds and fine processes, which
bridge the gap and form a firmer, but still temporary, connection
between the two sides. Each bud begins in the wall of the capillary as a
small accumulation of granular protoplasm, which gradually elongates
into a filament containing a nucleus. This filament either joins with a
neighbouring capillary or with a similar filament, and in time these
become hollow and are filled with blood from the vessels that gave them
origin. In this way a series of young _capillary loops_ is formed.

The spaces between these loops are filled by cells of various kinds, the
most important being the _fibroblasts_, which are destined to form
cicatricial fibrous tissue. These fibroblasts are large irregular
nucleated cells derived mainly from the proliferation of the fixed
connective-tissue cells of the part, and to a less extent from the
lymphocytes and other mononuclear cells which have migrated from the
vessels. Among the fibroblasts, larger multi-nucleated cells--_giant
cells_--are sometimes found, particularly when resistant substances,
such as silk ligatures or fragments of bone, are embedded in the
tissues, and their function seems to be to soften such substances
preliminary to their being removed by the phagocytes. Numerous
_polymorpho-nuclear leucocytes_, which have wandered from the vessels,
are also present in the spaces. These act as phagocytes, their function
being to remove the red corpuscles and fibrin of the original clot, and
this performed, they either pass back into the circulation in virtue of
their amoeboid movement, or are themselves eaten up by the growing
fibroblasts. Beyond this phagocytic action, they do not appear to play
any direct part in the reparative process. These young capillary loops,
with their supporting cells and fluids, constitute granulation tissue,
which is usually fully formed in from three to five days, after which it
begins to be replaced by cicatricial or scar tissue.

_Formation of Cicatricial Tissue._--The transformation of this temporary
granulation tissue into scar tissue is effected by the fibroblasts,
which become elongated and spindle-shaped, and produce in and around
them a fine fibrillated material which gradually increases in quantity
till it replaces the cell protoplasm. In this way white fibrous tissue
is formed, the cells of which are arranged in parallel lines and
eventually become grouped in bundles, constituting fully formed white
fibrous tissue. In its growth it gradually obliterates the capillaries,
until at the end of two, three, or four weeks both vessels and cells
have almost entirely disappeared, and the original wound is occupied by
cicatricial tissue. In course of time this tissue becomes consolidated,
and the cicatrix undergoes a certain amount of contraction--_cicatricial
contraction_.

_Healing of Epidermis._--While these changes are taking place in the
deeper parts of the wound, the surface is being covered over by
_epidermis_ growing in from the margins. Within twelve hours the cells
of the rete Malpighii close to the cut edge begin to sprout on to the
surface of the wound, and by their proliferation gradually cover the
granulations with a thin pink pellicle. As the epithelium increases in
thickness it assumes a bluish hue and eventually the cells become
cornified and the epithelium assumes a greyish-white colour.

_Clinical Aspects._--So long as the process of repair is not complicated
by infection with micro-organisms, there is no interference with the
general health of the patient. The temperature remains normal; the
circulatory, gastro-intestinal, nervous, and other functions are
undisturbed; locally, the part is cool, of natural colour and free from
pain.

#Modifications of the Process of Repair.#--The process of repair by
primary union, above described, is to be looked upon as the type of all
reparative processes, such modifications as are met with depending
merely upon incidental differences in the conditions present, such as
loss of tissue, infection by micro-organisms, etc.

_Repair after Loss or Destruction of Tissue._--When the edges of a wound
cannot be approximated either because tissue has been lost, for example
in excising a tumour or because a drainage tube or gauze packing has
been necessary, a greater amount of granulation tissue is required to
fill the gap, but the process is essentially the same as in the ideal
method of repair.

The raw surface is first covered by a layer of coagulated blood and
fibrin. An extensive new formation of capillary loops and fibroblasts
takes place towards the free surface, and goes on until the gap is
filled by a fine velvet-like mass of granulation tissue. This
granulation tissue is gradually replaced by young cicatricial tissue,
and the surface is covered by the ingrowth of epithelium from the edges.

This modification of the reparative process can be best studied
clinically in a recent wound which has been packed with gauze. When the
plug is introduced, the walls of the cavity consist of raw tissue with
numerous oozing blood vessels. On removing the packing on the fifth or
sixth day, the surface is found to be covered with minute, red,
papillary granulations, which are beginning to fill up the cavity. At
the edges the epithelium has proliferated and is covering over the newly
formed granulation tissue. As lymph and leucocytes escape from the
exposed surface there is a certain amount of serous or sero-purulent
discharge. On examining the wound at intervals of a few days, it is
found that the granulation tissue gradually increases in amount till the
gap is completely filled up, and that coincidently the epithelium
spreads in and covers over its surface. In course of time the epithelium
thickens, and as the granulation tissue is slowly replaced by young
cicatricial tissue, which has a peculiar tendency to contract and so to
obliterate the blood vessels in it, the scar that is left becomes
smooth, pale, and depressed. This method of healing is sometimes spoken
of as "healing by granulation"--although, as we have seen, it is by
granulation that all repair takes place.

_Healing by Union of two Granulating Surfaces._--In gaping wounds union
is sometimes obtained by bringing the two surfaces into apposition after
each has become covered with healthy granulations. The exudate on the
surfaces causes them to adhere, capillary loops pass from one to the
other, and their final fusion takes place by the further development of
granulation and cicatricial tissue.

_Reunion of Parts entirely Separated from the Body._--Small portions of
tissue, such as the end of a finger, the tip of the nose or a portion of
the external ear, accidentally separated from the body, if accurately
replaced and fixed in position, occasionally adhere by primary union.

In the course of operations also, portions of skin, fascia, or bone, or
even a complete joint may be transplanted, and unite by primary union.

_Healing under a Scab._--When a small superficial wound is exposed to
the air, the blood and serum exuded on its surface may dry and form a
hard crust or _scab_, which serves to protect the surface from external
irritation in the same way as would a dry pad of sterilised gauze. Under
this scab the formation of granulation tissue, its transformation into
cicatricial tissue, and the growth of epithelium on the surface, go on
until in the course of time the crust separates, leaving a scar.

_Healing by Blood-clot._--In subcutaneous wounds, for example tenotomy,
in amputation wounds, and in wounds made in excising tumours or in
operating upon bones, the space left between the divided tissues becomes
filled with blood-clot, which acts as a temporary scaffolding in which
granulation tissue is built up. Capillary loops grow into the coagulum,
and migrated leucocytes from the adjacent blood vessels destroy the red
corpuscles, and are in turn disposed of by the developing fibroblasts,
which by their growth and proliferation fill up the gap with young
connective tissue. It will be evident that this process only differs
from healing by primary union in the _amount_ of blood-clot that is
present.

_Presence of a Foreign Body._--When an aseptic foreign body is present
in the tissues, _e.g._ a piece of unabsorbable chromicised catgut, the
healing process may be modified. After primary union has taken place the
scar may broaden, become raised above the surface, and assume a
bluish-brown colour; the epidermis gradually thins and gives way,
revealing the softened portion of catgut, which can be pulled out in
pieces, after which the wound rapidly heals and resumes a normal
appearance.


REPAIR IN INDIVIDUAL TISSUES

_Skin and Connective Tissue._--The mode of regeneration of these tissues
under aseptic conditions has already been described as the type of ideal
repair. In highly vascular parts, such as the face, the reparative
process goes on with great rapidity, and even extensive wounds may be
firmly united in from three to five days. Where the anastomosis is less
free the process is more prolonged. The more highly organised elements
of the skin, such as the hair follicles, the sweat and sebaceous glands,
are imperfectly reproduced; hence the scar remains smooth, dry, and
hairless.

_Epithelium._--Epithelium is only reproduced from pre-existing
epithelium, and, as a rule, from one of a similar type, although
metaplastic transformation of cells of one kind of epithelium into
another kind can take place. Thus a granulating surface may be covered
entirely by the ingrowing of the cutaneous epithelium from the margins;
or islets, originating in surviving cells of sebaceous glands or sweat
glands, or of hair follicles, may spring up in the centre of the raw
area. Such islets may also be due to the accidental transference of
loose epithelial cells from the edges. Even the fluid from a blister, in
virtue of the isolated cells of the rete Malpighii which it contains, is
capable of starting epithelial growth on a granulating surface. Hairs
and nails may be completely regenerated if a sufficient amount of the
hair follicles or of the nail matrix has escaped destruction. The
epithelium of a mucous membrane is regenerated in the same way as that
on a cutaneous surface.

Epithelial cells have the power of living for some time after being
separated from their normal surroundings, and of growing again when once
more placed in favourable circumstances. On this fact the practice of
skin grafting is based (p. 11).

_Cartilage._--When an articular cartilage is divided by incision or by
being implicated in a fracture involving the articular end of a bone, it
is repaired by ordinary cicatricial fibrous tissue derived from the
proliferating cells of the perichondrium. Cartilage being a non-vascular
tissue, the reparative process goes on slowly, and it may be many weeks
before it is complete.

It is possible for a metaplastic transformation of connective-tissue
cells into cartilage cells to take place, the characteristic hyaline
matrix being secreted by the new cells. This is sometimes observed as an
intermediary stage in the healing of fractures, especially in young
bones. It may also take place in the regeneration of lost portions of
cartilage, provided the new tissue is so situated as to constitute part
of a joint and to be subjected to pressure by an opposing cartilaginous
surface. This is illustrated by what takes place after excision of
joints where it is desired to restore the function of the articulation.
By carrying out movements between the constituent parts, the fibrous
tissue covering the ends of the bones becomes moulded into shape, its
cells take on the characters of cartilage cells, and, forming a matrix,
so develop a new cartilage.

Conversely, it is observed that when articular cartilage is no longer
subjected to pressure by an opposing cartilage, it tends to be
transformed into fibrous tissue, as may be seen in deformities attended
with displacement of articular surfaces, such as hallux valgus and
club-foot.

After fractures of costal cartilage or of the cartilages of the larynx
the cicatricial tissue may be ultimately replaced by bone.

_Tendons._--When a tendon is divided, for example by subcutaneous
tenotomy, the end nearer the muscle fibres is drawn away from the other,
leaving a gap which is speedily filled by blood-clot. In the course of a
few days this clot becomes permeated by granulation tissue, the
fibroblasts of which are derived from the sheath of the tendon, the
surrounding connective tissue, and probably also from the divided ends
of the tendon itself. These fibroblasts ultimately develop into typical
tendon cells, and the fibres which they form constitute the new tendon
fibres. Under aseptic conditions repair is complete in from two to three
weeks. In the course of the reparative process the tendon and its sheath
may become adherent, which leads to impaired movement and stiffness. If
the ends of an accidentally divided tendon are at once brought into
accurate apposition and secured by sutures, they unite directly with a
minimum amount of scar tissue, and function is perfectly restored.

_Muscle._--Unstriped muscle does not seem to be capable of being
regenerated to any but a moderate degree. If the ends of a divided
striped muscle are at once brought into apposition by stitches, primary
union takes place with a minimum of intervening fibrous tissue. The
nuclei of the muscle fibres in close proximity to this young cicatricial
tissue proliferate, and a few new muscle fibres may be developed, but
any gross loss of muscular tissue is replaced by a fibrous cicatrix. It
would appear that portions of muscle transplanted from animals to fill
up gaps in human muscle are similarly replaced by fibrous tissue. When a
muscle is paralysed from loss of its nerve supply and undergoes complete
degeneration, it is not capable of being regenerated, even should the
integrity of the nerve be restored, and so its function is permanently
lost.

_Secretory Glands._--The regeneration of secretory glands is usually
incomplete, cicatricial tissue taking the place of the glandular
substance which has been destroyed. In wounds of the liver, for example,
the gap is filled by fibrous tissue, but towards the periphery of the

wound the liver cells proliferate and a certain amount of regeneration
takes place. In the kidney also, repair mainly takes place by
cicatricial tissue, and although a few collecting tubules may be
reformed, no regeneration of secreting tissue takes place. After the
operation of decapsulation of the kidney a new capsule is formed, and
during the process young blood vessels permeate the superficial parts
of the kidney and temporarily increase its blood supply, but in the
consolidation of the new fibrous tissue these vessels are ultimately
obliterated. This does not prove that the operation is useless, as the
temporary improvement of the circulation in the kidney may serve to tide
the patient over a critical period of renal insufficiency.

_Stomach and Intestine._--Provided the peritoneal surfaces are
accurately apposed, wounds of the stomach and intestine heal with great
rapidity. Within a few hours the peritoneal surfaces are glued together
by a thin layer of fibrin and leucocytes, which is speedily organised
and replaced by fibrous tissue. Fibrous tissue takes the place of the
muscular elements, which are not regenerated. The mucous lining is
restored by ingrowth from the margins, and there is evidence that some
of the secreting glands may be reproduced.

Hollow viscera, like the oesophagus and urinary bladder, in so far
as they are not covered by peritoneum, heal less rapidly.

_Nerve Tissues._--There is no trustworthy evidence that regeneration of
the tissues of the brain or spinal cord in man ever takes place. Any
loss of substance is replaced by cicatricial tissue.

The repair of _Bone_, _Blood Vessels_, and _Peripheral Nerves_ is more
conveniently considered in the chapters dealing with these structures.

#Rate of Healing.#--While the rate at which wounds heal is remarkably
constant there are certain factors that influence it in one direction or
the other. Healing is more rapid when the edges are in contact, when
there is a minimum amount of blood-clot between them, when the patient
is in normal health and the vitality of the tissues has not been
impaired. Wounds heal slightly more quickly in the young than in the
old, although the difference is so small that it can only be
demonstrated by the most careful observations.

Certain tissues take longer to heal than others: for example, a fracture
of one of the larger long bones takes about six weeks to unite, and
divided nerve trunks take much longer--about a year.

Wounds of certain parts of the body heal more quickly than others: those
of the scalp, face, and neck, for example, heal more quickly than those
over the buttock or sacrum, probably because of their greater
vascularity.

The extent of the wound influences the rate of healing; it is only

natural that a long and deep wound should take longer to heal than a
short and superficial one, because there is so much more work to be
done in the conversion of blood-clot into granulation tissue, and this
again into scar tissue that will be strong enough to stand the strain on
the edges of the wound.


THE TRANSPLANTATION OR GRAFTING OF TISSUES

Conditions are not infrequently met with in which healing is promoted
and restoration of function made possible by the transference of a
portion of tissue from one part of the body to another; the tissue
transferred is known as the _graft_ or the _transplant_. The simplest
example of grafting is the transplantation of skin.

In order that the graft may survive and have a favourable chance of
"taking," as it is called, the transplanted tissue must retain its
vitality until it has formed an organic connection with the tissue in
which it is placed, so that it may derive the necessary nourishment from
its new bed. When these conditions are fulfilled the tissues of the
graft continue to proliferate, producing new tissue elements to replace
those that are lost and making it possible for the graft to become
incorporated with the tissue with which it is in contact.

Dead tissue, on the other hand, can do neither of these things; it is
only capable of acting as a model, or, at the most, as a scaffolding for
such mobile tissue elements as may be derived from, the parent tissue
with which the graft is in contact: a portion of sterilised marine
sponge, for example, may be observed to become permeated with
granulation tissue when it is embedded in the tissues.

A successful graft of living tissue is not only capable of regeneration,
but it acquires a system of lymph and blood vessels, so that in time it
bleeds when cut into, and is permeated by new nerve fibres spreading in
from the periphery towards the centre.

It is instructive to associate the period of survival of the different
tissues of the body after death, with their capacity of being used for
grafting purposes; the higher tissues such as those of the central
nervous system and highly specialised glandular tissues like those of
the kidney lose their vitality quickly after death and are therefore
useless for grafting; connective tissues, on the other hand, such as
fat, cartilage, and bone retain their vitality for several hours after
death, so that when they are transplanted, they readily "take" and do
all that is required of them: the same is true of the skin and its
appendages.

_Sources of Grafts._--It is convenient to differentiate between
_autoplastic_ grafts, that is those derived from the same individual;
_homoplastic_ grafts, derived from another animal of the same species;
and _heteroplastic_ grafts, derived from an animal of another species.
Other conditions being equal, the prospects of success are greatest with
autoplastic grafts, and these are therefore preferred whenever possible.

There are certain details making for success that merit attention: the
graft must not be roughly handled or allowed to dry, or be subjected to
chemical irritation; it must be brought into accurate contact with the
new soil, no blood-clot intervening between the two, no movement of the
one upon the other should be possible and all infection must be
excluded; it will be observed that these are exactly the same conditions
that permit of the primary healing of wounds, with which of course the
healing of grafts is exactly comparable.

_Preservation of Tissues for Grafting._--It was at one time believed
that tissues might be taken from the operating theatre and kept in cold
storage until they were required. It is now agreed that tissues which
have been separated from the body for some time inevitably lose their
vitality, become incapable of regeneration, and are therefore unsuited
for grafting purposes. If it is intended to preserve a portion of tissue
for future grafting, it should be embedded in the subcutaneous tissue of
the abdominal wall until it is wanted; this has been carried out with
portions of costal cartilage and of bone.


INDIVIDUAL TISSUES AS GRAFTS

#The Blood# lends itself in an ideal manner to transplantation, or, as
it has long been called, _transfusion_. Being always a homoplastic
transfer, the new blood is not always tolerated by the old, in which
case biochemical changes occur, resulting in haemolysis, which
corresponds to the disintegration of other unsuccessful homoplastic
grafts. (See article on Transfusion, _Op. Surg._, p. 37.)

#The Skin.#--The skin was the first tissue to be used for grafting
purposes, and it is still employed with greater frequency than any
other, as lesions causing defects of skin are extremely common and
without the aid of grafts are tedious in healing.

Skin grafts may be applied to a raw surface or to one that is covered
with granulations.

_Skin grafting of raw surfaces_ is commonly indicated after operations
for malignant disease in which considerable areas of skin must be
sacrificed, and after accidents, such as avulsion of the scalp by
machinery.

_Skin grafting of granulating surfaces_ is chiefly employed to promote
healing in the large defects of skin caused by severe burns; the
grafting is carried out when the surface is covered by a uniform layer
of healthy granulations and before the inevitable contraction of scar
tissue makes itself manifest. Before applying the grafts it is usual to
scrape away the granulations until the young fibrous tissue underneath
is exposed, but, if the granulations are healthy and can be rendered
aseptic, the grafts may be placed on them directly.

If it is decided to scrape away the granulations, the oozing must be
arrested by pressure with a pad of gauze, a sheet of dental rubber or
green protective is placed next the raw surface to prevent the gauze
adhering and starting the bleeding afresh when it is removed.

#Methods of Skin-Grafting.#--Two methods are employed: one in which the
epidermis is mainly or exclusively employed--epidermis or epithelial
grafting; the other, in which the graft consists of the whole thickness
of the true skin--cutis-grafting.

_Epidermis or Epithelial Grafting._--The method introduced by the late
Professor Thiersch of Leipsic is that almost universally practised. It
consists in transplanting strips of epidermis shaved from the surface of
the skin, the razor passing through the tips of the papillae, which
appear as tiny red points yielding a moderate ooze of blood.

The strips are obtained from the front and lateral aspects of the thigh
or upper arm, the skin in those regions being pliable and comparatively
free from hairs.

They are cut with a sharp hollow-ground razor or with Thiersch's
grafting knife, the blade of which is rinsed in alcohol and kept
moistened with warm saline solution. The cutting is made easier if the
skin is well stretched and kept flat and perfectly steady, the
operator's left hand exerting traction on the skin behind, the hands of
the assistant on the skin in front, one above and the other below the
seat of operation. To ensure uniform strips being cut, the razor is kept
parallel with the surface and used with a short, rapid, sawing movement,
so that, with a little practice, grafts six or eight inches long by one
or two inches broad can readily be cut. The patient is given a general
anaesthetic, or regional anaesthesia is obtained by injections of a
solution of one per cent. novocain into the line of the lateral and
middle cutaneous nerves; the disinfection of the skin is carried out on
the usual lines, any chemical agent being finally got rid of, however,
by means of alcohol followed by saline solution.

The strips of epidermis wrinkle up on the knife and are directly
transferred to the surface, for which they should be made to form a
complete carpet, slightly overlapping the edges of the area and of one
another; some blunt instrument is used to straighten out the strips,
which are then subjected to firm pressure with a pad of gauze to express
blood and air-bells and to ensure accurate contact, for this must be as
close as that between a postage stamp and the paper to which it is
affixed.

As a dressing for the grafted area and of that also from which the
grafts have been taken, gauze soaked in _liquid paraffin_--the patent
variety known as _ambrine_ is excellent--appears to be the best; the
gauze should be moistened every other day or so with fresh paraffin, so
that, at the end of a week, when the grafts should have united, the
gauze can be removed without risk of detaching them. _Dental wax_ is
another useful type of dressing; as is also _picric acid_ solution. Over
the gauze, there is applied a thick layer of cotton wool, and the whole
dressing is kept in place by a firmly applied bandage, and in the case
of the limbs some form of splint should be added to prevent movement.

A dressing may be dispensed with altogether, the grafts being protected
by a wire cage such as is used after vaccination, but they tend to dry
up and come to resemble a scab.

When the grafts have healed, it is well to protect them from injury and
to prevent them drying up and cracking by the liberal application of
lanoline or vaseline.

The new skin is at first insensitive and is fixed to the underlying
connective tissue or bone, but in course of time (from six weeks
onwards) sensation returns and the formation of elastic tissue beneath
renders the skin pliant and movable so that it can be pinched up between
the finger and thumb.

_Reverdin's_ method consists in planting out pieces of skin not bigger
than a pin-head over a granulating surface. It is seldom employed.

_Grafts of the Cutis Vera._--Grafts consisting of the entire thickness
of the true skin were specially advocated by Wolff and are often
associated with his name. They should be cut oval or spindle-shaped, to
facilitate the approximation of the edges of the resulting wound. The
graft should be cut to the exact size of the surface it is to cover;
Gillies believes that tension of the graft favours its taking. These
grafts may be placed either on a fresh raw surface or on healthy
granulations. It is sometimes an advantage to stitch them in position,
especially on the face. The dressing and the after-treatment are the
same as in epidermis grafting.

There is a degree of uncertainty about the graft retaining its vitality
long enough to permit of its deriving the necessary nourishment from its
new surroundings; in a certain number of cases the flap dies and is
thrown off as a slough--moist or dry according to the presence or
absence of septic infection.

The technique for cutis-grafting must be without a flaw, and the asepsis
absolute; there must not only be a complete absence of movement, but
there must be no traction on the flap that will endanger its blood
supply.

Owing to the uncertainty in the results of cutis-grafting the
_two-stage_ or _indirect method_ has been introduced, and its almost
uniform success has led to its sphere of application being widely
extended. The flap is raised as in the direct method but is left
attached at one of its margins for a period ranging from 14 to 21 days
until its blood supply from its new bed is assured; the detachment is
then made complete. The blood supply of the proposed flap may influence
its selection and the way in which it is fashioned; for example, a flap
cut from the side of the head to fill a defect in the cheek, having in
its margin of attachment or pedicle the superficial temporal artery, is
more likely to take than a flap cut with its base above.

Another modification is to raise the flap but leave it connected at both
ends like the piers of a bridge; this method is well suited to defects
of skin on the dorsum of the fingers, hand and forearm, the bridge of
skin is raised from the abdominal wall and the hand is passed beneath it
and securely fixed in position; after an interval of 14 to 21 days, when
the flap is assured of its blood supply, the piers of the bridge are
divided (Fig. 1). With undermining it is usually easy to bring the
edges of the gap in the abdominal wall together, even in children; the
skin flap on the dorsum of the hand appears rather thick and
prominent--almost like the pad of a boxing-glove--for some time, but
the restoration of function in the capacity to flex the fingers is
gratifying in the extreme.

[Illustration: FIG. 1.--Ulcer of back of Hand covered by flap of skin
raised from anterior abdominal wall. The lateral edges of the flap are
divided after the graft has adhered.]

The indirect element of this method of skin-grafting may be carried
still further by transferring the flap of skin first to one part of the
body and then, after it has taken, transferring it to a third part.
Gillies has especially developed this method in the remedying of
deformities of the face caused by gunshot wounds and by petrol burns in
air-men. A rectangular flap of skin is marked out in the neck and chest,
the lateral margins of the flap are raised sufficiently to enable them
to be brought together so as to form a tube of skin: after the
circulation has been restored, the lower end of the tube is detached and
is brought up to the lip or cheek, or eyelid, where it is wanted; when
this end has derived its new blood supply, the other end is detached
from the neck and brought up to where it is wanted. In this way, skin
from the chest may be brought up to form a new forehead and eyelids.

Grafts of _mucous membrane_ are used to cover defects in the lip, cheek,
and conjunctiva. The technique is similar to that employed in
skin-grafting; the sources of mucous membrane are limited and the
element of septic infection cannot always be excluded.

_Fat._--Adipose tissue has a low vitality, but it is easily retained and
it readily lends itself to transplantation. Portions of fat are often
obtainable at operations--from the omentum, for example, otherwise the
subcutaneous fat of the buttock is the most accessible; it may be
employed to fill up cavities of all kinds in order to obtain more rapid
and sounder healing and also to remedy deformity, as in filling up a
depression in the cheek or forehead. It is ultimately converted into
ordinary connective tissue _pari passu_ with the absorption of the fat.

The _fascia lata of the thigh_ is widely and successfully used as a
graft to fill defects in the dura mater, and interposed between the
bones of a joint--if the articular cartilage has been destroyed--to
prevent the occurrence of ankylosis.

The _peritoneum_ of hydrocele and hernial sacs and of the omentum
readily lends itself to transplantation.

_Cartilage and bone_, next to skin, are the tissues most frequently
employed for grafting purposes; their sphere of action is so extensive
and includes so much of technical detail in their employment, that they
will be considered later with the surgery of the bones and joints and
with the methods of re-forming the nose.

_Tendons and blood vessels_ readily lend themselves to transplantation
and will also be referred to later.

_Muscle and nerve_, on the other hand, do not retain their vitality when
severed from their surroundings and do not functionate as grafts except
for their connective-tissue elements, which it goes without saying are
more readily obtainable from other sources.

Portions of the _ovary_ and of the _thyreoid_ have been successfully
transplanted into the subcutaneous cellular tissue of the abdominal wall
by Tuffier and others. In these new surroundings, the ovary or thyreoid
is vascularised and has been shown to functionate, but there is not
sufficient regeneration of the essential tissue elements to "carry on";
the secreting tissue is gradually replaced by connective tissue and the
special function comes to an end. Even such temporary function may,
however, tide a patient over a difficult period.




CHAPTER II

CONDITIONS WHICH INTERFERE WITH REPAIR


SURGICAL BACTERIOLOGY

Want of rest--Irritation--Unhealthy tissues--Pathogenic bacteria.
    SURGICAL BACTERIOLOGY--General characters of
    bacteria--Classification of bacteria--Conditions of bacterial
    life--Pathogenic powers of bacteria--Results of bacterial
    growth--Death of bacteria--Immunity--Antitoxic sera--Identification
    of bacteria--Pyogenic bacteria.

In the management of wounds and other surgical conditions it is
necessary to eliminate various extraneous influences which tend to delay
or arrest the natural process of repair.

Of these, one of the most important is undue movement of the affected
part. "The first and great requisite for the restoration of injured
parts is _rest_," said John Hunter; and physiological and mechanical
rest as the chief of natural therapeutic agents was the theme of John
Hilton's classical work--_Rest and Pain_. In this connection it must be
understood that "rest" implies more than the mere state of physical
repose: all physiological as well as mechanical function must be
prevented as far as is possible. For instance, the constituent bones of
a joint affected with tuberculosis must be controlled by splints or
other appliances so that no movement can take place between them, and
the limb may not be used for any purpose; physiological rest may be
secured to an inflamed colon by making an artificial anus in the caecum;
the activity of a diseased kidney may be diminished by regulating the
quantity and quality of the fluids taken by the patient.

Another source of interference with repair in wounds is _irritation_,
either by mechanical agents such as rough, unsuitable dressings,
bandages, or ill-fitting splints; or by chemical agents in the form of
strong lotions or other applications.

An _unhealthy or devitalised condition of the patient's tissues_ also
hinders the reparative process. Bruised or lacerated skin heals less
kindly than skin cut with a smooth, sharp instrument; and persistent

venous congestion of a part, such as occurs, for example, in the leg
when the veins are varicose, by preventing the access of healthy blood,
tends to delay the healing of open wounds. The existence of grave
constitutional disease, such as Bright's disease, diabetes, syphilis,
scurvy, or alcoholism, also impedes healing.

Infection by disease-producing micro-organisms or _pathogenic bacteria_
is, however, the most potent factor in disturbing the natural process of
repair in wounds.


SURGICAL BACTERIOLOGY

The influence of micro-organisms in the causation of disease, and the
role played by them in interfering with the natural process of repair,
are so important that the science of applied bacteriology has now come
to dominate every department of surgery, and it is from the standpoint
of bacteriology that nearly all surgical questions have to be
considered.

The term _sepsis_ as now used in clinical surgery no longer retains its
original meaning as synonymous with "putrefaction," but is employed to
denote all conditions in which bacterial infection has taken place, and
more particularly those in which pyogenic bacteria are present. In the
same way the term _aseptic_ conveys the idea of freedom from all forms
of bacteria, putrefactive or otherwise; and the term _antiseptic_ is
used to denote a power of counteracting bacteria and their products.

#General Characters of Bacteria.#--A _bacterium_ consists of a finely
granular mass of protoplasm, enclosed in a thin gelatinous envelope.
Many forms are motile--some in virtue of fine thread-like flagella, and
others through contractility of the protoplasm. The great majority
multiply by simple fission, each parent cell giving rise to two daughter
cells, and this process goes on with extraordinary rapidity. Other
varieties, particularly bacilli, are propagated by the formation of
_spores_. A spore is a minute mass of protoplasm surrounded by a dense,
tough membrane, developed in the interior of the parent cell. Spores are
remarkable for their tenacity of life, and for the resistance they offer
to the action of heat and chemical germicides.

Bacteria are most conveniently classified according to their shape. Thus
we recognise (1) those that are globular--_cocci_; (2) those that
resemble a rod--_bacilli_; (3) the spiral or wavy forms--_spirilla_.

_Cocci_ or _micrococci_ are minute round bodies, averaging about 1 u in
diameter. The great majority are non-motile. They multiply by fission;
and when they divide in such a way that the resulting cells remain in
pairs, are called _diplococci_, of which the bacteria of gonorrhoea and
pneumonia are examples (Fig. 5). When they divide irregularly, and form
grape-like bunches, they are known as _staphylococci_, and to this

variety the commonest pyogenic or pus-forming organisms belong (Fig. 2).
When division takes place only in one axis, so that long chains are
formed, the term _streptococcus_ is applied (Fig. 3). Streptococci are
met with in erysipelas and various other inflammatory and suppurative
processes of a spreading character.

_Bacilli_ are rod-shaped bacteria, usually at least twice as long as
they are broad (Fig. 4). Some multiply by fission, others by
sporulation. Some forms are motile, others are non-motile. Tuberculosis,
tetanus, anthrax, and many other surgical diseases are due to different
forms of bacilli.

_Spirilla_ are long, slender, thread-like cells, more or less spiral or
wavy. Some move by a screw-like contraction of the protoplasm, some by
flagellae. The spirochaete associated with syphilis (Fig. 36) is the most
important member of this group.

#Conditions of Bacterial Life.#--Bacteria require for their growth and
development a suitable food-supply in the form of proteins,
carbohydrates, and salts of calcium and potassium which they break up
into simpler elements. An alkaline medium favours bacterial growth; and
moisture is a necessary condition; spores, however, can survive the want
of water for much longer periods than fully developed bacteria. The
necessity for oxygen varies in different species. Those that require
oxygen are known as _aerobic bacilli_ or _aerobes_; those that cannot
live in the presence of oxygen are spoken of as _anaerobes_. The great
majority of bacteria, however, while they prefer to have oxygen, are
able to live without it, and are called _facultative anaerobes_.

The most suitable temperature for bacterial life is from 95 o to 102 o F.,
roughly that of the human body. Extreme or prolonged cold paralyses but
does not kill micro-organisms. Few, however, survive being raised to a
temperature of 134 1/2 o F. Boiling for ten to twenty minutes will kill all
bacteria, and the great majority of spores. Steam applied in an
autoclave under a pressure of two atmospheres destroys even the most
resistant spores in a few minutes. Direct sunlight, electric light, or
even diffuse daylight, is inimical to the growth of bacteria, as are
also Rontgen rays and radium emanations.

#Pathogenic Properties of Bacteria.#--We are now only concerned with
pathogenic bacteria--that is, bacteria capable of producing disease in
the human subject. This capacity depends upon two sets of factors--(1)
certain features peculiar to the invading bacteria, and (2) others
peculiar to the host. Many bacteria have only the power of living upon
dead matter, and are known as _saphrophytes_. Such as do nourish in
living tissue are, by distinction, known as _parasites_. The power a
given parasitic micro-organism has of multiplying in the body and giving
rise to disease is spoken of as its _virulence_, and this varies not
only with different species, but in the same species at different times
and under varying circumstances. The actual number of organisms
introduced is also an important factor in determining their pathogenic
power. Healthy tissues can resist the invasion of a certain number of
bacteria of a given species, but when that number is exceeded, the
organisms get the upper hand and disease results. When the organisms
gain access directly to the blood-stream, as a rule they produce their
effects more certainly and with greater intensity than when they are
introduced into the tissues.

Further, the virulence of an organism is modified by the condition of
the patient into whose tissues it is introduced. So long as a person is
in good health, the tissues are able to resist the attacks of moderate
numbers of most bacteria. Any lowering of the vitality of the
individual, however, either locally or generally, at once renders him
more susceptible to infection. Thus bruised or torn tissue is much more
liable to infection with pus-producing organisms than tissues clean-cut
with a knife; also, after certain diseases, the liability to infection
by the organisms of diphtheria, pneumonia, or erysipelas is much
increased. Even such slight depression of vitality as results from
bodily fatigue, or exposure to cold and damp, may be sufficient to turn
the scale in the battle between the tissues and the bacteria. Age is an
important factor in regard to the action of certain bacteria. Young
subjects are attacked by diphtheria, tuberculosis, acute osteomyelitis,
and some other diseases with greater frequency and severity than those
of more advanced years.

In different races, localities, environment, and seasons, the pathogenic
powers of certain organisms, such as those of erysipelas, diphtheria,
and acute osteomyelitis, vary considerably.

There is evidence that a _mixed infection_--that is, the introduction of
more than one species of organism, for example, the tubercle bacillus
and a pyogenic staphylococcus--increases the severity of the resulting
disease. If one of the varieties gain the ascendancy, the poisons
produced by the others so devitalise the tissue cells, and diminish
their power of resistance, that the virulence of the most active
organisms is increased. On the other hand, there is reason to believe
that the products of certain organisms antagonise one another--for
example, an attack of erysipelas may effect the cure of a patch of
tuberculous lupus.

Lastly, in patients suffering from chronic wasting diseases, bacteria
may invade the internal organs by the blood-stream in enormous numbers
and with great rapidity, during the period of extreme debility which
shortly precedes death. The discovery of such collections of organisms
on post-mortem examination may lead to erroneous conclusions being drawn
as to the cause of death.

#Results of Bacterial Growth.#--Some organisms, such as those of tetanus
and erysipelas, and certain of the pyogenic bacteria, show little
tendency to pass far beyond the point at which they gain an entrance to
the body. Others, on the contrary--for example, the tubercle bacillus
and the organism of acute osteomyelitis--although frequently remaining
localised at the seat of inoculation, tend to pass to distant parts,
lodging in the capillaries of joints, bones, kidney, or lungs, and there
producing their deleterious effects.

In the human subject, multiplication in the blood-stream does not occur
to any great extent. In some general acute pyogenic infections, such as
osteomyelitis, cellulitis, etc., pure cultures of staphylococci or of
streptococci may be obtained from the blood. In pneumococcal and typhoid
infections, also, the organisms may be found in the blood.

It is by the vital changes they bring about in the parts where they
settle that micro-organisms disturb the health of the patient. In
deriving nourishment from the complex organic compounds in which they
nourish, the organisms evolve, probably by means of a ferment, certain
chemical products of unknown composition, but probably colloidal in
nature, and known as _toxins_. When these poisons are absorbed into the
general circulation they give rise to certain groups of symptoms--such
as rise of temperature, associated circulatory and respiratory
derangements, interference with the gastro-intestinal functions and also
with those of the nervous system--which go to make up the condition
known as blood-poisoning, toxaemia, or _bacterial intoxication_. In
addition to this, certain bacteria produce toxins that give rise to
definite and distinct groups of symptoms--such as the convulsions of
tetanus, or the paralyses that follow diphtheria.

_Death of Bacteria._--Under certain circumstances, it would appear that
the accumulation of the toxic products of bacterial action tends to
interfere with the continued life and growth of the organisms
themselves, and in this way the natural cure of certain diseases is
brought about. Outside the body, bacteria may be killed by starvation,
by want of moisture, by being subjected to high temperature, or by the
action of certain chemical agents of which carbolic acid, the
perchloride and biniodide of mercury, and various chlorine preparations
are the most powerful.

#Immunity.#--Some persons are insusceptible to infection by certain
diseases, from which they are said to enjoy a _natural immunity_. In
many acute diseases one attack protects the patient, for a time at
least, from a second attack--_acquired immunity_.

_Phagocytosis._--In the production of immunity the leucocytes and
certain other cells play an important part in virtue of the power they
possess of ingesting bacteria and of destroying them by a process of
intra-cellular digestion. To this process Metchnikoff gave the name of
_phagocytosis_, and he recognised two forms of _phagocytes_: (1) the
_microphages_, which are the polymorpho-nuclear leucocytes of the blood;
and (2) the _macrophages_, which include the larger hyaline leucocytes,
endothelial cells, and connective-tissue corpuscles.

During the process of phagocytosis, the polymorpho-nuclear leucocytes in
the circulating blood increase greatly in numbers (_leucocytosis_), as
well as in their phagocytic action, and in the course of destroying the
bacteria they produce certain ferments which enter the blood serum.
These are known as _opsonins_ or _alexins_, and they act on the bacteria
by a process comparable to narcotisation, and render them an easy prey
for the phagocytes.

_Artificial or Passive Immunity._--A form of immunity can be induced by
the introduction of protective substances obtained from an animal which
has been actively immunised. The process by which passive immunity is
acquired depends upon the fact that as a result of the reaction between
the specific virus of a particular disease (the _antigen_) and the
tissues of the animal attacked, certain substances--_antibodies_--are
produced, which when transferred to the body of a susceptible animal
protect it against that disease. The most important of these antibodies
are the _antitoxins_. From the study of the processes by which immunity
is secured against the effects of bacterial action the serum and vaccine
methods of treating certain infective diseases have been evolved. The
_serum treatment_ is designed to furnish the patient with a sufficiency
of antibodies to neutralise the infection. The anti-diphtheritic and the
anti-tetanic act by neutralising the specific toxins of the
disease--_antitoxic serums_; the anti-streptcoccic and the serum for
anthrax act upon the bacteria--_anti-bacterial serums_.

A _polyvalent_ serum, that is, one derived from an animal which has been
immunised by numerous strains of the organism derived from various
sources, is much more efficacious than when a single strain has been
used.

_Clinical Use of Serums._--Every precaution must be taken to prevent
organismal contamination of the serum or of the apparatus by means of
which it is injected. Syringes are so made that they can be sterilised
by boiling. The best situations for injection are under the skin of the
abdomen, the thorax, or the buttock, and the skin should be purified at
the seat of puncture. If the bulk of the full dose is large, it should
be divided and injected into different parts of the body, not more than
20 c.c. being injected at one place. The serum may be introduced
directly into a vein, or into the spinal canal, _e.g._ anti-tetanic
serum. The immunity produced by injections of antitoxic sera lasts only
for a comparatively short time, seldom longer than a few weeks.

_"Serum Disease" and Anaphylaxis._--It is to be borne in mind that some
patients exhibit a supersensitiveness with regard to protective sera, an
injection being followed in a few days by the appearance of an
urticarial or erythematous rash, pain and swelling of the joints, and a
variable degree of fever. These symptoms, to which the name _serum
disease_ is applied, usually disappear in the course of a few days.

The term _anaphylaxis_ is applied to an allied condition of
supersensitiveness which appears to be induced by the injection of
certain substances, including toxins and sera, that are capable of
acting as antigens. When a second injection is given after an interval
of some days, if anaphylaxis has been established by the first dose, the
patient suddenly manifests toxic symptoms of the nature of profound
shock which may even prove fatal. The conditions which render a person
liable to develop anaphylaxis and the mechanism by which it is
established are as yet imperfectly understood.

_Vaccine Treatment._--The vaccine treatment elaborated by A. E. Wright
consists in injecting, while the disease is still active, specially
prepared dead cultures of the causative organisms, and is based on the
fact that these "vaccines" render the bacteria in the tissues less able
to resist the attacks of the phagocytes. The method is most successful
when the vaccine is prepared from organisms isolated from the patient
himself, _autogenous vaccine_, but when this is impracticable, or takes
a considerable time, laboratory-prepared polyvalent _stock vaccines_ may
be used.

_Clinical Use of Vaccines._--Vaccines should not be given while a
patient is in a negative phase, as a certain amount of the opsonin in
the blood is used up in neutralising the substances injected, and this
may reduce the opsonic index to such an extent that the vaccines
themselves become dangerous. As a rule, the propriety of using a vaccine
can be determined from the general condition of the patient. The initial
dose should always be a small one, particularly if the disease is acute,
and the subsequent dosage will be regulated by the effect produced. If
marked constitutional disturbance with rise of temperature follows the
use of a vaccine, it indicates a negative phase, and calls for a
diminution in the next dose. If, on the other hand, the local as well as
the general condition of the patient improves after the injection, it
indicates a positive phase, and the original dose may be repeated or
even increased. Vaccines are best introduced subcutaneously, a part
being selected which is not liable to pressure, as there is sometimes
considerable local reaction. Repeated doses may be necessary at
intervals of a few days.

The vaccine treatment has been successfully employed in various
tuberculous lesions, in pyogenic infections such as acne, boils,
sycosis, streptococcal, pneumococcal, and gonococcal conditions, in
infections of the accessory air sinuses, and in other diseases caused by
bacteria.


PYOGENIC BACTERIA

From the point of view of the surgeon the most important varieties of
micro-organisms are those that cause inflammation and suppuration--the
_pyogenic bacteria_. This group includes a great many species, and these
are so widely distributed that they are to be met with under all
conditions of everyday life.

The nature of the inflammatory and suppurative processes will be
considered in detail later; suffice it here to say that they are brought
about by the action of one or other of the organisms that we have now to
consider.

It is found that the _staphylococci_, which cluster into groups, tend to
produce localised lesions; while the chain-forms--_streptococci_--give
rise to diffuse, spreading conditions. Many varieties of pyogenic
bacteria have now been differentiated, the best known being the
staphylococcus aureus, the streptococcus, and the bacillus coli
communis.

[Illustration: FIG. 2.--Staphylococcus aureus in Pus from case of
Osteomyelitis. x 1000 diam. Gram's stain.]

_Staphylococcus Aureus._--This is the commonest organism found in
localised inflammatory and suppurative conditions. It varies greatly in
its virulence, and is found in such widely different conditions as skin
pustules, boils, carbuncles, and some acute inflammations of bone. As
seen by the microscope it occurs in grape-like clusters, fission of the
individual cells taking place irregularly (Fig. 2). When grown in
artificial media, the colonies assume an orange-yellow colour--hence the
name _aureus_. It is of high vitality and resists more prolonged
exposure to high temperatures than most non-sporing bacteria. It is
capable of lying latent in the tissues for long periods, for example, in
the marrow of long bones, and of again becoming active and causing a
fresh outbreak of suppuration. This organism is widely distributed: it
is found on the skin, in the mouth, and in other situations in the body,
and as it is present in the dust of the air and on all objects upon
which dust has settled, it is a continual source of infection unless
means are taken to exclude it from wounds.

The _staphylococcus albus_ is much less common than the aureus, but has
the same properties and characters, save that its growth on artificial
media assumes a white colour. It is the common cause of stitch
abscesses, the skin being its normal habitat.

[Illustration: FIG. 3.--Streptococci in Pus from an acute abscess in
subcutaneous tissue. x 1000 diam. Gram's stain.]

_Streptococcus Pyogenes._--This organism also varies greatly in its
virulence; in some instances--for example in erysipelas--it causes a
sharp attack of acute spreading inflammation, which soon subsides
without showing any tendency to end in suppuration; under other
conditions it gives rise to a generalised infection which rapidly proves
fatal. The streptococcus has less capacity of liquefying the tissues
than the staphylococcus, so that pus formation takes place more slowly.
At the same time its products are very potent in destroying the tissues
in their vicinity, and so interfering with the exudation of leucocytes
which would otherwise exercise their protective influence. Streptococci
invade the lymph spaces, and are associated with acute spreading
conditions such as phlegmonous or erysipelatous inflammations and
suppurations, lymphangitis and suppuration in lymph glands, and
inflammation of serous and synovial membranes, also with a form of
pneumonia which is prone to follow on severe operations in the mouth and
throat. Streptococci are also concerned in the production of spreading
gangrene and pyaemia.

Division takes place in one axis, so that chains of varying length are
formed (Fig. 3). It is less easily cultivated by artificial media than
the staphylococcus; it forms a whitish growth.

[Illustration: FIG. 4.--Bacillus coli communis in Urine, from a case of
Cystitis. x 1000 diam. Leishman's stain.]

_Bacillus Coli Communis._--This organism, which is a normal inhabitant
of the intestinal tract, shows a great tendency to invade any organ or
tissue whose vitality is lowered. It is causatively associated with such
conditions as peritonitis and peritoneal suppuration resulting from
strangulated hernia, appendicitis, or perforation in any part of the
alimentary canal. In cystitis, pyelitis, abscess of the kidney,
suppuration in the bile-ducts or liver, and in many other abdominal
conditions, it plays a most important part. The discharge from wounds
infected by this organism has usually a foetid, or even a faecal odour,
and often contains gases resulting from putrefaction.

It is a small rod-shaped organism with short flagellae, which render it
motile (Fig. 4). It closely resembles the typhoid bacillus, but is
distinguished from it by its behaviour in artificial culture media.

[Illustration: FIG. 5.--Fraenkel's Pneumococci in Pus from Empyema
following Pneumonia. x 100 diam. Stained with Muir's capsule stain.]

_Pneumo-bacteria._--Two forms of organism associated with
pneumonia--_Fraenkel's pneumococcus_ (one of the diplococci) (Fig. 5)
and _Friedlander's pneumo-bacillus_ (a short rod-shaped form)--are
frequently met with in inflammations of the serous and synovial
membranes, in suppuration in the liver, and in various other
inflammatory and suppurative conditions.

_Bacillus Typhosus._--This organism has been found in pure culture in
suppurative conditions of bone, of cellular tissue, and of internal
organs, especially during convalescence from typhoid fever. Like the
staphylococcus, it is capable of lying latent in the tissues for long
periods.

_Other Pyogenic Bacteria._--It is not necessary to do more than name
some of the other organisms that are known to be pyogenic, such as the
bacillus pyocyaneus, which is found in green and blue pus, the
micrococcus tetragenus, the gonococcus, actinomyces, the glanders
bacillus, and the tubercle bacillus. Most of these will receive further
mention in connection with the diseases to which they give rise.

#Leucocytosis.#--Most bacterial diseases, as well as certain other
pathological conditions, are associated with an increase in the number
of leucocytes in the blood throughout the circulatory system. This
condition of the blood, which is known as _leucocytosis_, is believed to
be due to an excessive output and rapid formation of leucocytes by the
bone marrow, and it probably has as its object the arrest and
destruction of the invading organisms or toxins. To increase the
resisting power of the system to pathogenic organisms, an artificial
leucocytosis may be induced by subcutaneous injection of a solution of
nucleinate of soda (16 minims of a 5 per cent. solution).

The _normal_ number of leucocytes per cubic millimetre varies in
different individuals, and in the same individual under different
conditions, from 5000 to 10,000: 7500 is a normal average, and anything
above 12,000 is considered abnormal. When leucocytosis is present, the
number may range from 12,000 to 30,000 or even higher; 40,000 is looked
upon as a high degree of leucocytosis. According to Ehrlich, the
following may be taken as the standard proportion of the various forms
of leucocytes in normal blood: polynuclear neutrophile leucocytes, 70 to
72 per cent.; lymphocytes, 22 to 25 per cent.; eosinophile cells, 2 to 4
per cent.; large mononuclear and transitional leucocytes, 2 to 4 per
cent.; mast-cells, 0.5 to 2 per cent.

In estimating the clinical importance of a leucocytosis, it is not
sufficient merely to count the aggregate number of leucocytes present. A
differential count must be made to determine which variety of cells is
in excess. In the majority of surgical affections it is chiefly the
granular polymorpho-nuclear neutrophile leucocytes that are in excess
(_ordinary leucocytosis_). In some cases, and particularly in parasitic
diseases such as trichiniasis and hydatid disease, the eosinophile
leucocytes also show a proportionate increase (_eosinophilia_). The term
_lymphocytosis_ is applied when there is an increase in the number of
circulating lymphocytes, as occurs, for example, in lymphatic leucaemia,
and in certain cases of syphilis.

Leucocytosis is met with in nearly all acute infective diseases, and in
acute pyogenic inflammatory affections, particularly in those attended
with suppuration. In exceptionally acute septic conditions the extreme
virulence of the toxins may prevent the leucocytes reacting, and
leucocytosis may be absent. The absence of leucocytosis in a disease in
which it is usually present is therefore to be looked upon as a grave
omen, particularly when the general symptoms are severe. In some cases
of malignant disease the number of leucocytes is increased to 15,000 or
20,000. A few hours after a severe haemorrhage also there is usually a
leucocytosis of from 15,000 to 30,000, which lasts for three or four
days (Lyon). In cases of haemorrhage the leucocytosis is increased by
infusion of fluids into the circulation. After all operations there is
at least a transient leucocytosis (_post-operative leucocytosis_)
(F. I. Dawson).

The leucocytosis begins soon after the infection manifests itself--for
example, by shivering, rigor, or rise of temperature. The number of
leucocytes rises somewhat rapidly, increases while the condition is
progressing, and remains high during the febrile period, but there is no
constant correspondence between the number of leucocytes and the height
of the temperature. The arrest of the inflammation and its resolution
are accompanied by a fall in the number of leucocytes, while the
occurrence of suppuration is attended with a further increase in their
number.

In interpreting the "blood count," it is to be kept in mind that a
_physiological leucocytosis_ occurs within three or four hours of taking
a meal, especially one rich in proteins, from 1500 to 2000 being added
to the normal number. In this _digestion leucocytosis_ the increase is
chiefly in the polynuclear neutrophile leucocytes. Immediately before
and after delivery, particularly in primiparae, there is usually a
moderate degree of leucocytosis. If the labour is normal and the
puerperium uncomplicated, the number of leucocytes regains the normal in
about a week. Lactation has no appreciable effect on the number of
leucocytes. In new-born infants the leucocyte count is abnormally high,
ranging from 15,000 to 20,000. In children under one year of age, the
normal average is from 10,000 to 20,000.

_Absence of Leucocytosis--Leucopenia._--In certain infective diseases
the number of leucocytes in the circulating blood is abnormally
low--3000 or 4000--and this condition is known as _leucopenia_. It
occurs in typhoid fever, especially in the later stages of the disease,
in tuberculous lesions unaccompanied by suppuration, in malaria, and in
most cases of uncomplicated influenza. The occurrence of leucocytosis in
any of these conditions is to be looked upon as an indication that a
mixed infection has taken place, and that some suppurative process is
present.

The absence of leucocytosis in some cases of virulent septic poisoning
has already been referred to.

It will be evident that too much reliance must not be placed upon a
single observation, particularly in emergency cases. Whenever possible,
a series of observations should be made, the blood being examined about
four hours after meals, and about the same hour each day.

The clinical significance of the blood count in individual diseases will
be further referred to.

_The Iodine or Glycogen Reaction._--The leucocyte count may be
supplemented by staining films of the blood with a watery solution of
iodine and potassium iodide. In all advancing purulent conditions, in
septic poisonings, in pneumonia, and in cancerous growths associated
with ulceration, a certain number of the polynuclear leucocytes are
stained a brown or reddish-brown colour, due to the action of the iodine
on some substance in the cells of the nature of glycogen. This reaction
is absent in serous effusions, in unmixed tuberculous infections, in
uncomplicated typhoid fever, and in the early stages of cancerous
growths.




CHAPTER III

INFLAMMATION


Definition--Nature of inflammation from surgical point of
    view--Sequence of changes in bacterial inflammation--Clinical
    aspects of inflammation--General principles of treatment--Chronic
    inflammation.

Inflammation may be defined as the series of vital changes that occurs
in the tissues in response to irritation. These changes represent the
reaction of the tissue elements to the irritant, and constitute the
attempt made by nature to arrest or to limit its injurious effects, and
to repair the damage done by it.

The phenomena which characterise the inflammatory reaction can be
induced by any form of irritation--such, for example, as mechanical
injury, the application of heat or of chemical substances, or the action
of pathogenic bacteria and their toxins--and they are essentially
similar in kind whatever the irritant may be. The extent to which the
process may go, however, and its effects on the part implicated and on
the system as a whole, vary with different irritants and with the
intensity and duration of their action. A mechanical, a thermal, or a
chemical irritant, acting alone, induces a degree of reaction directly
proportionate to its physical properties, and so long as it does not
completely destroy the vitality of the part involved, the changes in the
tissues are chiefly directed towards repairing the damage done to the
part, and the inflammatory reaction is not only compatible with the
occurrence of ideal repair, but may be looked upon as an integral step
in the reparative process.

The irritation caused by infection with bacteria, on the other hand, is
cumulative, as the organisms not only multiply in the tissues, but in
addition produce chemical poisons (toxins) which aggravate the
irritative effects. The resulting reaction is correspondingly
progressive, and has as its primary object the expulsion of the irritant
and the limitation of its action. If the natural protective effort is
successful, the resulting tissue changes subserve the process of repair,
but if the bacteria gain the upper hand in the struggle, the
inflammatory reaction becomes more intense, certain of the tissue
elements succumb, and the process for the time being is a destructive
one. During the stage of bacterial inflammation, reparative processes
are in abeyance, and it is only after the inflammation has been allayed,
either by natural means or by the aid of the surgeon, that repair takes
place.

In applying the antiseptic principle to the treatment of wounds, our
main object is to exclude or to eliminate the bacterial factor, and so
to prevent the inflammatory reaction going beyond the stage in which it
is protective, and just in proportion as we succeed in attaining this
object, do we favour the occurrence of ideal repair.

#Sequence of Changes in Bacterial Inflammation.#--As the form of
inflammation with which we are most concerned is that due to the action
of bacteria, in describing the process by which the protective influence
of the inflammatory reaction is brought into play, we shall assume the
presence of a bacterial irritant.

The introduction of a colony of micro-organisms is quickly followed by
an accumulation of wandering cells, and proliferation of
connective-tissue cells in the tissues at the site of infection. The
various cells are attracted to the bacteria by a peculiar chemical or
biological power known as _chemotaxis_, which seems to result from
variations in the surface tension of different varieties of cells,
probably caused by some substance produced by the micro-organisms.
Changes in the blood vessels then ensue, the arteries becoming dilated
and the rate of the current in them being for a time increased--_active
hyperaemia_. Soon, however, the rate of the blood flow becomes slower
than normal, and in course of time the current may cease (_stasis_), and
the blood in the vessels may even coagulate (_thrombosis_). Coincidently
with these changes in the vessels, the leucocytes in the blood of the
inflamed part rapidly increase in number, and they become viscous and
adhere to the vessel wall, where they may accumulate in large numbers.
In course of time the leucocytes pass through the vessel
wall--_emigration of leucocytes_--and move towards the seat of
infection, giving rise to a marked degree of _local leucocytosis_.
Through the openings by which the leucocytes have escaped from the
vessels, red corpuscles may be passively extruded--_diapedesis of red
corpuscles_. These processes are accompanied by changes in the
endothelium of the vessel walls, which result in an increased formation
of lymph, which transudes into the meshes of the connective tissue
giving rise to an _inflammatory oedema_, or, if the inflammation is on a
free surface, forming an _inflammatory exudate_. The quantity and
characters of this exudate vary in different parts of the body, and
according to the nature, virulence, and location of the organisms
causing the inflammation. Thus it may be _serous_, as in some forms of
synovitis; _sero-fibrinous_, as in certain varieties of peritonitis, the
fibrin tending to limit the spread of the inflammation by forming
adhesions; _croupous_, when it coagulates on a free surface and forms a
false membrane, as in diphtheria; _haemorrhagic_ when mixed with blood;
or _purulent_, when suppuration has occurred. The protective effects of
the inflammatory reaction depend for the most part upon the transudation
of lymph and the emigration of leucocytes. The lymph contains the
opsonins which act on the bacteria and render them less able to resist
the attack of the phagocytes, as well as the various protective
antibodies which neutralise the toxins. The polymorph leucocytes are the
principal agents in the process of phagocytosis (p. 22), and together
with the other forms of phagocytes they ingest and destroy the bacteria.

If the attempt to repel the invading organisms is successful, the
irritant effects are overcome, the inflammation is arrested, and
_resolution_ is said to take place.

Certain of the vascular and cellular changes are now utilised to restore
the condition to the normal, and _repair_ ensues after the manner
already described. In certain situations, notably in tendon sheaths, in
the cavities of joints, and in the interior of serous cavities, for
example the pleura and peritoneum, the restoration to the normal is not
perfect, adhesions forming between the opposing surfaces.

If, however, the reaction induced by the infection is insufficient to
check the growth and spread of the organisms, or to inhibit their toxin
production, local necrosis of tissue may take place, either in the form
of suppuration or of gangrene, or the toxins absorbed into the
circulation may produce blood-poisoning, which may even prove fatal.

#Clinical Aspects of Inflammation.#--It must clearly be understood that
inflammation is not to be looked upon as a disease in itself, but rather
as an evidence of some infective process going on in the tissues in
which it occurs, and of an effort on the part of these tissues to
overcome the invading organisms and their products. The chief danger to
the patient lies, not in the reactive changes that constitute the
inflammatory process, but in the fact that he is liable to be poisoned
by the toxins of the bacteria at work in the inflamed area.

Since the days of Celsus (first century A.D.), heat, redness, swelling,
and pain have been recognised as cardinal signs of inflammation, and to
these may be added, interference with function in the inflamed part, and
general constitutional disturbance. Variations in these signs and
symptoms depend upon the acuteness of the condition, the nature of the
causative organism and of the tissue attacked, the situation of the part
in relation to the surface, and other factors.

The _heat_ of the inflamed part is to be attributed to the increased
quantity of blood present in it, and the more superficial the affected
area the more readily is the local increase of temperature detected by
the hand. This clinical point is best tested by placing the palm of the
hand and fingers for a few seconds alternately over an uninflamed and an
inflamed area, otherwise under similar conditions as to coverings and
exposure. In this way even slight differences may be recognised.

_Redness_, similarly, is due to the increased afflux of blood to the
inflamed part. The shade of colour varies with the stage of the
inflammation, being lighter and brighter in the early, hyperaemic stages,
and darker and duskier when the blood flow is slowed or when stasis has
occurred and the oxygenation of the blood is defective. In the
thrombotic stage the part may assume a purplish hue.

The _swelling_ is partly due to the increased amount of blood in the
affected part and to the accumulation of leucocytes and proliferated
tissue cells, but chiefly to the exudate in the connective
tissue--_inflammatory oedema_. The more open the structure of the tissue
of the part, the greater is the amount of swelling--witness the marked
degree of oedema that occurs in such parts as the scrotum or the eyelids.

_Pain_ is a symptom seldom absent in inflammation. _Tenderness_--that
is, pain elicited on pressure--is one of the most valuable diagnostic
signs we possess, and is often present before pain is experienced by the
patient. That the area of tenderness corresponds to the area of
inflammation is almost an axiom of surgery. Pain and tenderness are due
to the irritation of nerve filaments of the part, rendered all the more
sensitive by the abnormal conditions of their blood supply. In
inflammatory conditions of internal organs, for example the abdominal
viscera, the pain is frequently referred to other parts, usually to an
area supplied by branches from the same segment of the cord as that
supplying the inflamed part.

For purposes of diagnosis, attention should be paid to the terms in
which the patient describes his pain. For example, the pain caused by
an inflammation of the skin is usually described as of a _burning_ or
_itching_ character; that of inflammation in dense tissues like
periosteum or bone, or in encapsuled organs, as _dull_, _boring_, or
_aching_. When inflammation is passing on to suppuration the pain
assumes a _throbbing_ character, and as the pus reaches the surface, or
"points," as it is called, sharp, _darting_, or _lancinating_ pains are
experienced. Inflammation involving a nerve-trunk may cause a _boring_
or a _tingling_ pain; while the implication of a serous membrane such as
the pleura or peritoneum gives rise to a pain of a sharp, _stabbing_
character.

_Interference with the function_ of the inflamed part is always present
to a greater or less extent.

#Constitutional Disturbances.#--Under the term constitutional
disturbances are included the presence of fever or elevation of
temperature; certain changes in the pulse rate and the respiration;
gastro-intestinal and urinary disturbances; and derangements of the
central nervous system. These are all due to the absorption of toxins
into the general circulation.

_Temperature._--A marked rise of temperature is one of the most constant
and important concomitants of acute inflammatory conditions, and the
temperature chart forms a fairly reliable index of the state of the
patient. The toxins interfere with the nerve-centres in the medulla that
regulate the balance between the production and the loss of body heat.

Clinically the temperature is estimated by means of a self-registering
thermometer placed, for from one to five minutes, in close contact with
the skin in the axilla, or in the mouth. Sometimes the thermometer is
inserted into the rectum, where, however, the temperature is normally
3/4 o F. higher than in the axilla.

_In health_ the temperature of the body is maintained at a mean of about
98.4 o F. (37 o C.) by the heat-regulating mechanism. It varies from hour
to hour even in health, reaching its maximum between four and eight in
the evening, when it may rise to 99 o F., and is at its lowest between
four and six in the morning, when it may be about 97 o F.

The temperature is more easily disturbed in children than in adults, and
may become markedly elevated (104 o or 105 o F.) from comparatively slight
causes; in the aged it is less liable to change, so that a rise to 103 o
or 104 o F. is to be looked upon as indicating a high state of fever.

A sudden rise of temperature is usually associated with a feeling of
chilliness down the back and in the limbs, which may be so marked that
the patient shivers violently, while the skin becomes cold, pale, and
shrivelled--_cutis anserina_. This is a nervous reaction due to a want
of correspondence between the internal and the surface temperature of
the body, and is known clinically as a _rigor_. When the temperature
rises gradually the chill is usually slight and may be unobserved. Even
during the cold stage, however, the internal temperature is already
raised, and by the time the chill has passed off its maximum has been
reached.

The _pulse_ is always increased in frequency, and usually varies
directly with the height of the temperature. _Respiration_ is more
active during the progress of an inflammation; and bronchial catarrh is
common apart from any antecedent respiratory disease.

_Gastro-intestinal disturbances_ take the form of loss of appetite,
vomiting, diminished secretion of the alimentary juices, and weakening
of the peristalsis of the bowel, leading to thirst, dry, furred tongue,
and constipation. Diarrhoea is sometimes present. The _urine_ is usually
scanty, of high specific gravity, rich in nitrogenous substances,
especially urea and uric acid, and in calcium salts, while sodium
chloride is deficient. Albumin and hyaline casts may be present in cases
of severe inflammation with high temperature. The significance of
general _leucocytosis_ has already been referred to.

#General Principles of Treatment.#--The capacity of the inflammatory
reaction for dealing with bacterial infections being limited, it often
becomes necessary for the surgeon to aid the natural defensive
processes, as well as to counteract the local and general effects of the
reaction, and to relieve symptoms.

The ideal means of helping the tissues is by removing the focus of
infection, and when this can be done, as for example in a carbuncle or
an anthrax pustule, the infected area may be completely excised. When
the focus is not sufficiently limited to admit of this, the infected
tissue may be scraped away with the sharp spoon, or destroyed by
caustics or by the actual cautery. If this is inadvisable, the organisms
may be attacked by strong antiseptics, such as pure carbolic acid.

Moist dressings favour the removal of bacteria by promoting the escape
of the inflammatory exudate, in which they are washed out.

#Artificial Hyperaemia.#--When such direct means as the above are
impracticable, much can be done to aid the tissues in their struggle by
improving the condition of the circulation in the inflamed area, so as
to ensure that a plentiful supply of fresh arterial blood reaches it.
The beneficial effects of _hot fomentations and poultices_ depend on
their causing a dilatation of the vessels, and so inducing a hyperaemia
in the affected area. It has been shown experimentally that repeated,
short applications of moist heat (not exceeding 106 o F.) are more
efficacious than continuous application. It is now believed that the
so-called _counter-irritants_--mustard, iodine, cantharides, actual
cautery--act in the same way; and the method of treating erysipelas by
applying a strong solution of iodine around the affected area is based
on the same principle.

[Illustration: FIG. 6.--Passive Hyperaemia of Hand and Forearm induced by
Bier's Bandage.]

While these and similar methods have long been employed in the treatment
of inflammatory conditions, it is only within comparatively recent years
that their mode of action has been properly understood, and to August
Bier belongs the credit of having put the treatment of inflammation on a
scientific and rational basis. Recognising the "beneficent intention" of
the inflammatory reaction, and the protective action of the leucocytosis
which accompanies the hyperaemic stages of the process, Bier was led to
study the effects of increasing the hyperaemia by artificial means. As a
result of his observations, he has formulated a method of treatment
which consists in inducing an artificial hyperaemia in the inflamed area,
either by obstructing the venous return from the part (_passive
hyperaemia_), or by stimulating the arterial flow through it (_active
hyperaemia_).

_Bier's Constricting Bandage._--To induce a _passive hyperaemia_ in a
limb, an elastic bandage is applied some distance above the inflamed
area sufficiently tightly to obstruct the venous return from the distal
parts without arresting in any way the inflow of arterial blood (Fig. 6).
If the constricting band is correctly applied, the parts beyond
become swollen and oedematous, and assume a bluish-red hue, but they
retain their normal temperature, the pulse is unchanged, and there is no
pain. If the part becomes blue, cold, or painful, or if any existing
pain is increased, the band has been applied too tightly. The hyperaemia
is kept up from twenty to twenty-two hours out of the twenty-four, and
in the intervals the limb is elevated to get rid of the oedema and to
empty it of impure blood, and so make room for a fresh supply of healthy
blood when the bandage is re-applied. As the inflammation subsides, the
period during which the band is kept on each day is diminished; but the
treatment should be continued for some days after all signs of
inflammation have subsided.

This method of treating acute inflammatory conditions necessitates
close supervision until the correct degree of tightness of the band has
been determined.

[Illustration: FIG. 7.--Passive Hyperaemia of Finger induced by Klapp's
Suction Bell.]

_Klapp's Suction Bells._--In inflammatory conditions to which the
constricting band cannot be applied, as for example an acute mastitis, a
bubo in the groin, or a boil on the neck, the affected area may be
rendered hyperaemic by an appropriately shaped glass bell applied over it
and exhausted by means of a suction-pump, the rarefaction of the air in
the bell determining a flow of blood into the tissues enclosed within it
(Figs. 7 and 8). The edge of the bell is smeared with vaseline, and the
suction applied for from five to ten minutes at a time, with a
corresponding interval between the applications. Each sitting lasts for
from half an hour to an hour, and the treatment may be carried out once
or twice a day according to circumstances. This apparatus acts in the
same way as the old-fashioned _dry cup_, and is more convenient and
equally efficacious.

[Illustration: FIG. 8.--Passive Hyperaemia induced by Klapp's Suction
Bell for Inflammation of Inguinal Gland.]

_Active hyperaemia_ is induced by the local application of heat,
particularly by means of hot air. It has not proved so useful in acute
inflammation as passive hyperaemia, but is of great value in hastening
the absorption of inflammatory products and in overcoming adhesions and
stiffness in tendons and joints.

_General Treatment._--The patient should be kept at rest, preferably in
bed, to diminish the general tissue waste; and the diet should be
restricted to fluids, such as milk, beef-tea, meat juices or gruel, and
these may be rendered more easily assimilable by artificial digestion if
necessary. To counteract the general effect of toxins absorbed into
the circulation, specific antitoxic sera are employed in certain forms
of infection, such as diphtheria, streptococcal septicaemia, and tetanus.
In other forms of infection, vaccines are employed to increase the
opsonic power of the blood. When such means are not available, the
circulating toxins may to some extent be diluted by giving plenty of
bland fluids by the mouth or normal salt solution by the rectum.

The elimination of the toxins is promoted by securing free action of the
emunctories. A saline purge, such as half an ounce of sulphate of
magnesium in a small quantity of water, ensures a free evacuation of the
bowels. The kidneys are flushed by such diluent drinks as equal parts of
milk and lime water, or milk with a dram of liquor calcis saccharatus
added to each tumblerful. Barley-water and "Imperial drink," which
consists of a dram and a half of cream of tartar added to a pint of
boiling water and sweetened with sugar after cooling, are also useful
and non-irritating diuretics. The skin may be stimulated by Dover's
powder (10 grains) or liquor ammoniae acetatis in three-dram doses every
four hours.

Various drugs administered internally, such as quinine, salol,
salicylate of iron, and others, have a reputation, more or less
deserved, as internal antiseptics.

Weakness of the heart, as indicated by the condition of the pulse, is
treated by the use of such drugs as digitalis, strophanthus, or
strychnin, according to circumstances.

Gastro-intestinal disturbances are met by ordinary medical means.
Vomiting, for example, can sometimes be checked by effervescing drinks,
such as citrate of caffein, or by dilute hydrocyanic acid and bismuth.
In severe cases, and especially when the vomited matter resembles
coffee-grounds from admixture with altered blood--the so-called
post-operative haematemesis--the best means of arresting the vomiting is
by washing out the stomach. Thirst is relieved by rectal injections of
saline solution. The introduction of saline solution into the veins or
by the rectum is also useful in diluting and hastening the elimination
of circulating toxins.

In surgical inflammations, as a rule, nothing is gained by lowering the
temperature, unless at the same time the cause is removed. When severe
or prolonged pyrexia becomes a source of danger, the use of hot or cold
sponging, or even the cold bath, is preferable to the administration of
drugs.

_Relief of Symptoms._--For the relief of _pain_, rest is essential. The
inflamed part should be placed in a splint or other appliance which will
prevent movement, and steps must be taken to reduce its functional
activity as far as possible. Locally, warm and moist dressings, such as
a poultice or fomentation, may be used. To make a fomentation, a piece
of flannel or lint is wrung out of very hot water or antiseptic lotion
and applied under a sheet of mackintosh. Fomentations should be renewed
as often as they cool. An ordinary india-rubber bag filled with hot
water and fixed over the fomentation, by retaining the heat, obviates
the necessity of frequently changing the application. The addition of a
few drops of laudanum sprinkled on the flannel has a soothing effect.
Lead and opium lotion is a useful, soothing application employed as a
fomentation. We prefer the application of lint soaked in a 10 per cent.
aqueous or glycerine solution of ichthyol, or smeared with ichthyol
ointment (1 in 3). Belladonna and glycerine, equal parts, may be used.

Dry cold obtained by means of icebags, or by Leiter's lead tubes through
which a continuous stream of ice-cold water is kept flowing, is
sometimes soothing to the patient, but when the vessels in the inflamed
part are greatly congested its use is attended with considerable risk,
as it not only contracts the arterioles supplying the part, but also
diminishes the outflow of venous blood, and so may determine gangrene of
tissues already devitalised.

A milder form of employing cold is by means of evaporating lotions: a
thin piece of lint or gauze is applied over the inflamed part and kept
constantly moist with the lotion, the dressing being left freely exposed
to allow of continuous evaporation. A useful evaporating lotion is made
up as follows: take of chloride of ammonium, half an ounce; rectified
spirit, one ounce; and water, seven ounces.

The administration of opiates may be necessary for the relief of pain.

The accumulation of an excessive amount of inflammatory exudate may
endanger the vitality of the tissues by pressing on the blood vessels to
such an extent as to cause stasis, and by concentrating the local action
of the toxins. Under such conditions the tension should be relieved and
the exudate with its contained toxins removed by making an incision into
the inflamed tissues, and applying a suction bell. When the exudate has
collected in a synovial cavity, such as a joint or bursa, it may be
withdrawn by means of a trocar and cannula. There are other methods of
withdrawing blood and exudate from an inflamed area, for example by
leeches or wet-cupping, but they are seldom employed now.

Before applying leeches the part must be thoroughly cleansed, and if
the leech is slow to bite, may be smeared with cream. The leech is
retained in position under an inverted wine-glass or wide test-tube till
it takes hold. After it has sucked its fill it usually drops off, having
withdrawn a dram or a dram and a half of blood. If it be desirable to
withdraw more blood, hot fomentations should be applied to the bite. As
it is sometimes necessary to employ considerable pressure to stop the
bleeding, leeches should, if possible, be applied over a bone which will
furnish the necessary resistance. The use of styptics may be called for.

_Wet-cupping_ has almost entirely been superseded by the use of Klapp's
suction bells.

_General blood-letting_ consists in opening a superficial vein
(venesection) and allowing from eight to ten ounces of blood to flow
from it. It is seldom used in the treatment of surgical forms of
inflammation.

_Counter-irritants._--In deep-seated inflammations, counter-irritants
are sometimes employed in the form of mustard leaves or blisters,
according to the degree of irritation required. A mustard leaf or
plaster should not be left on longer than ten or fifteen minutes, unless
it is desired to produce a blister. Blistering may be produced by a
_cantharides plaster_, or by painting with _liquor epispasticus_. The
plaster should be left on from eight to ten hours, and if it has failed
to raise a blister, a hot fomentation should be applied to the part.
_Liquor epispasticus_, alone or mixed with equal parts of collodion, is
painted on the part with a brush. Several paintings are often required
before a blister is raised. The preliminary removal of the natural
grease from the skin favours the action of these applications.

The treatment of inflammation in special tissues and organs will be
considered in the sections devoted to regional surgery.

#Chronic Inflammation.#--A variety of types of chronic and subacute
inflammation are met with which, owing to ignorance of their causations,
cannot at present be satisfactorily classified.

The best defined group is that of the _granulomata_, which includes such
important diseases as tuberculosis and syphilis, and in which different
types of chronic inflammation are caused by infection with a specific
organism, all having the common character, however, that abundant
granulation tissue is formed in which cellular changes are more in
evidence than changes in the blood vessels, and in which the subsequent
degeneration and necrosis of the granulation tissue results in the
breaking down and destruction of the tissue in which it is formed.
Another group is that in which chronic inflammation is due to mild or
attenuated forms of pyogenic infection affecting especially the lymph
glands and the bone marrow. In the glands of the groin, for example,
associated with various forms of irritation about the external genitals,
different types of _chronic lymphadenitis_ are met with; they do not
frankly suppurate as do the acute types, but are attended with a
hyperplasia of the tissue elements which results in enlargement of the
affected glands of a persistent, and sometimes of a relapsing character.
Similar varieties of _osteomyelitis_ are met with that do not, like the
acute forms, go on to suppuration or to death of bone, but result in
thickening of the bone affected, both on the surface and in the
interior, resulting in obliteration of the medullary canal.

A third group of chronic inflammations are those that begin as an acute
pyogenic inflammation, which, instead of resolving completely, persists
in a chronic form. It does so apparently because there is some factor
aiding the organisms and handicapping the tissues, such as the presence
of a foreign body, a piece of glass or metal, or a piece of dead bone;
in these circumstances the inflammation persists in a chronic form,
attended with the formation of fibrous tissue, and, in the case of bone,
with the formation of new bone in excess. It will be evident that in
this group, chronic inflammation and repair are practically
interchangeable terms.

There are other groups of chronic inflammation, the origin of which
continues to be the subject of controversy. Reference is here made to
the chronic inflammations of the synovial membrane of joints, of tendon
sheaths and of bursae--_chronic synovitis_, _teno-synovitis_ and
_bursitis_; of the fibrous tissues of joints--chronic forms of
_arthritis_; of the blood vessels--chronic forms of _endarteritis_ and
of _phlebitis_ and of the peripheral nerves--_neuritis_. Also in the
breast and in the prostate, with the waning of sexual life there may
occur a formation of fibrous tissue--chronic _interstitial mastitis_,
_chronic prostatitis_, having analogies with the chronic interstitial
inflammations of internal organs like the kidney--_chronic interstitial
nephritis_; and in the breast and prostate, as in the kidney, the
formation of fibrous tissue leads to changes in the secreting epithelium
resulting in the formation of cysts.

Lastly, there are still other types of chronic inflammation attended
with the formation of fibrous tissue on such a liberal scale as to
suggest analogies with new growths. The best known of these are the
systematic forms of fibromatosis met with in the central nervous system
and in the peripheral nerves--_neuro-fibromatosis_; in the submucous
coat of the stomach--_gastric fibromatosis_; and in the
colon--_intestinal fibromatosis_.

These conditions will be described with the tissues and organs in which
they occur.

In the _treatment of chronic inflammations_, pending further knowledge
as to their causation, and beyond such obvious indications as to help
the tissues by removing a foreign body or a piece of dead bone, there
are employed--empirically--a number of procedures such as the induction
of hyperaemia, exposure to the X-rays, and the employment of blisters,
cauteries, and setons. Vaccines may be had recourse to in those of
bacterial origin.




CHAPTER IV

SUPPURATION


Definition--Pus--_Varieties_--Acute circumscribed abscess--_Acute
    suppuration in a wound_--_Acute Suppuration in a mucous
    membrane_--Diffuse cellulitis and diffuse suppuration--
    _Whitlow_--_Suppurative cellulitis in different situations_--Chronic
    suppuration--Sinus, Fistula--Constitutional manifestations of
    pyogenic infection--_Sapraemia_--_Septicaemia_--_Pyaemia_.

Suppuration, or the formation of pus, is one of the results of the
action of bacteria on the tissues. The invading organism is usually one
of the staphylococci, less frequently a streptococcus, and still less
frequently one of the other bacteria capable of producing pus, such as
the bacillus coli communis, the gonococcus, the pneumococcus, or the
typhoid bacillus.

So long as the tissues are in a healthy condition they are able to
withstand the attacks of moderate numbers of pyogenic bacteria of
ordinary virulence, but when devitalised by disease, by injury, or by
inflammation due to the action of other pathogenic organisms,
suppuration ensues.

It would appear, for example, that pyogenic organisms can pass through
the healthy urinary tract without doing any damage, but if the pelvis of
the kidney, the ureter, or the bladder is the seat of stone, they give
rise to suppuration. Similarly, a calculus in one of the salivary ducts
frequently results in an abscess forming in the floor of the mouth. When
the lumen of a tubular organ, such as the appendix or the Fallopian tube
is blocked also, the action of pyogenic organisms is favoured and
suppuration ensues.

#Pus.#--The fluid resulting from the process of suppuration is known
as _pus_. In its typical form it is a yellowish creamy substance, of
alkaline reaction, with a specific gravity of about 1030, and it has a
peculiar mawkish odour. If allowed to stand in a test-tube it does not
coagulate, but separates into two layers: the upper, transparent,
straw-coloured fluid, the _liquor puris_ or pus serum, closely
resembling blood serum in its composition, but containing less protein
and more cholestrol; it also contains leucin, tyrosin, and certain
albumoses which prevent coagulation.

The layer at the bottom of the tube consists for the most part of
polymorph leucocytes, and proliferated connective tissue and endothelial
cells (_pus corpuscles_). Other forms of leucocytes may be present,
especially in long-standing suppurations; and there are usually some red
corpuscles, dead bacteria, fat cells and shreds of tissue, cholestrol
crystals, and other detritus in the deposit.

If a film of fresh pus is examined under the microscope, the pus cells
are seen to have a well-defined rounded outline, and to contain a finely
granular protoplasm and a multi-partite nucleus; if still warm, the
cells may exhibit amoeboid movement. In stained films the nuclei take the
stain well. In older pus cells the outline is irregular, the protoplasm
coarsely granular, and the nuclei disintegrated, no longer taking the
stain.

_Variations from Typical Pus._--Pus from old-standing sinuses is often
watery in consistence (ichorous), with few cells. Where the granulations
are vascular and bleed easily, it becomes sanious from admixture with
red corpuscles; while, if a blood-clot be broken down and the debris
mixed with the pus, it contains granules of blood pigment and is said to
be "grumous." The _odour_ of pus varies with the different bacteria
producing it. Pus due to ordinary pyogenic cocci has a mawkish odour;
when putrefactive organisms are present it has a putrid odour; when it
forms in the vicinity of the intestinal canal it usually contains the
bacillus coli communis and has a faecal odour.

The _colour_ of pus also varies: when due to one or other of the
varieties of the bacillus pyocyaneus, it is usually of a blue or green
colour; when mixed with bile derivatives or altered blood pigment, it
may be of a bright orange colour. In wounds inflicted with rough iron
implements from which rust is deposited, the pus often presents the same
colour.

The pus may form and collect within a circumscribed area, constituting a
localised _abscess_; or it may infiltrate the tissues over a wide
area--_diffuse suppuration_.


ACUTE CIRCUMSCRIBED ABSCESS

Any tissue of the body may be the seat of an acute abscess, and there
are many routes by which the bacteria may gain access to the affected
area. For example: an abscess in the integument or subcutaneous
cellular tissue usually results from infection by organisms which have
entered through a wound or abrasion of the surface, or along the ducts
of the skin; an abscess in the breast from organisms which have passed
along the milk ducts opening on the nipple, or along the lymphatics
which accompany these. An abscess in a lymph gland is usually due to
infection passing by way of the lymph channels from the area of skin or
mucous membrane drained by them. Abscesses in internal organs, such as
the kidney, liver, or brain, usually result from organisms carried in
the blood-stream from some focus of infection elsewhere in the body.

A knowledge of the possible avenues of infection is of clinical
importance, as it may enable the source of a given abscess to be traced
and dealt with. In suppuration in the Fallopian tube (pyosalpynx), for
example, the fact that the most common origin of the infection is in the
genital passage, leads to examination for vaginal discharge; and if none
is present, the abscess is probably due to infection carried in the
blood-stream from some primary focus about the mouth, such as a gumboil
or an infective sore throat.

The exact location of an abscess also may furnish a key to its source;
in axillary abscess, for example, if the suppuration is in the lymph
glands the infection has come through the afferent lymphatics; if in the
cellular tissue, it has spread from the neck or chest wall; if in the
hair follicles, it is a local infection through the skin.

#Formation of an Abscess.#--When pyogenic bacteria are introduced into
the tissue there ensues an inflammatory reaction, which is characterised
by dilatation of the blood vessels, exudation of large numbers of
leucocytes, and proliferation of connective-tissue cells. These
wandering cells soon accumulate round the focus of infection, and form a
protective barrier which tends to prevent the spread of the organisms
and to restrict their field of action. Within the area thus
circumscribed the struggle between the bacteria and the phagocytes takes
place, and in the process toxins are formed by the organisms, a certain
number of the leucocytes succumb, and, becoming degenerated, set free
certain proteolytic enzymes or ferments. The toxins cause
coagulation-necrosis of the tissue cells with which they come in
contact, the ferments liquefy the exudate and other albuminous
substances, and in this way _pus_ is formed.

If the bacteria gain the upper hand, this process of liquefaction which
is characteristic of suppuration, extends into the surrounding tissues,
the protective barrier of leucocytes is broken down, and the
suppurative process spreads. A fresh accession of leucocytes, however,
forms a new barrier, and eventually the spread is arrested, and the
collection of pus so hemmed in constitutes an _abscess_.

Owing to the swelling and condensation of the parts around, the pus thus
formed is under considerable pressure, and this causes it to burrow
along the lines of least resistance. In the case of a subcutaneous
abscess the pus usually works its way towards the surface, and "points,"
as it is called. Where it approaches the surface the skin becomes soft
and thin, and eventually sloughs, allowing the pus to escape.

An abscess forming in the deeper planes is prevented from pointing
directly to the surface by the firm fasciae and other fibrous structures.
The pus therefore tends to burrow along the line of the blood vessels
and in the connective-tissue septa, till it either finds a weak spot or
causes a portion of fascia to undergo necrosis and so reaches the
surface. Accordingly, many abscess cavities resulting from deep-seated
suppuration are of irregular shape, with pouches and loculi in various
directions--an arrangement which interferes with their successful
treatment by incision and drainage.

The relief of tension which follows the bursting of an abscess, the
removal of irritation by the escape of pus, and the casting off of
bacteria and toxins, allow the tissues once more to assert themselves,
and a process of repair sets in. The walls of the abscess fall in;
granulation tissue grows into the space and gradually fills it; and
later this is replaced by cicatricial tissue. As a result of the
subsequent contraction of the cicatricial tissue, the scar is usually
depressed below the level of the surrounding skin surface.

If an abscess is prevented from healing--for example, by the presence of
a foreign body or a piece of necrosed bone--a sinus results, and from it
pus escapes until the foreign body is removed.

#Clinical Features of an Acute Circumscribed Abscess.#--In the initial
stages the usual symptoms of inflammation are present. Increased
elevation of temperature, with or without a rigor, progressive
leucocytosis, and sweating, mark the transition between inflammation and
suppuration. An increasing leucocytosis is evidence that a suppurative
process is spreading.

The local symptoms vary with the seat of the abscess. When it is
situated superficially--for example, in the breast tissue--the affected
area is hot, the redness of inflammation gives place to a dusky purple
colour, with a pale, sometimes yellow, spot where the pus is near the
surface. The swelling increases in size, the firm brawny centre becomes
soft, projects as a cone beyond the level of the rest of the swollen
area, and is usually surrounded by a zone of induration.

By gently palpating with the finger-tips over the softened area, a fluid
wave may be detected--_fluctuation_--and when present this is a certain
indication of the existence of fluid in the swelling. Its recognition,
however, is by no means easy, and various fallacies are to be guarded
against in applying this test clinically. When, for example, the walls
of the abscess are thick and rigid, or when its contents are under
excessive tension, the fluid wave cannot be elicited. On the other hand,
a sensation closely resembling fluctuation may often be recognised in
oedematous tissues, in certain soft, solid tumours such as fatty tumours
or vascular sarcomata, in aneurysm, and in a muscle when it is palpated
in its transverse axis.

When pus has formed in deeper parts, and before it has reached the
surface, oedema of the overlying skin is frequently present, and the skin
pits on pressure.

With the formation of pus the continuous burning or boring pain of
inflammation assumes a throbbing character, with occasional sharp,
lancinating twinges. Should doubt remain as to the presence of pus,
recourse may be had to the use of an exploring needle.

_Differential Diagnosis of Acute Abscess._--A practical difficulty which
frequently arises is to decide whether or not pus has actually formed.
It may be accepted as a working rule in practice that when an acute
inflammation has lasted for four or five days without showing signs of
abatement, suppuration has almost certainly occurred. In deep-seated
suppuration, marked oedema of the skin and the occurrence of rigors and
sweating may be taken to indicate the formation of pus.

There are cases on record where rapidly growing sarcomatous and
angiomatous tumours, aneurysms, and the bruises that occur in
haemophylics, have been mistaken for acute abscesses and incised, with
disastrous results.

#Treatment of Acute Abscesses.#--The dictum of John Bell, "Where there
is pus, let it out," summarises the treatment of abscess. The extent and
situation of the incision and the means taken to drain the cavity,
however, vary with the nature, site, and relations of the abscess. In a
superficial abscess, for example a bubo, or an abscess in the breast or
face where a disfiguring scar is undesirable, a small puncture should be
made where the pus threatens to point, and a Klapp's suction bell be
applied as already described (p. 39). A drain is not necessary, and in
the intervals between the applications of the bell the part is covered
with a moist antiseptic dressing.

In abscesses deeply placed, as for example under the gluteal or pectoral
muscles, one or more incisions should be made, and the cavity drained by
glass or rubber tubes or by strips of rubber tissue.

The wound should be dressed the next day, and the tube shortened, in the
case of a rubber tube, by cutting off a portion of its outer end. On the
second day or later, according to circumstances, the tube is removed,
and after this the dressing need not be repeated oftener than every
second or third day.

Where pus has formed in relation to important structures--as, for
example, in the deeper planes of the neck--_Hilton's method_ of opening
the abscess may be employed. An incision is made through the skin and
fascia, a grooved director is gently pushed through the deeper tissues
till pus escapes along its groove, and then the track is widened by
passing in a pair of dressing forceps and expanding the blades. A tube,
or strip of rubber tissue, is introduced, and the subsequent treatment
carried out as in other abscesses. When the drain lies in proximity to a
large blood vessel, care must be taken not to leave it in position long
enough to cause ulceration of the vessel wall by pressure.

In some abscesses, such as those in the vicinity of the anus, the cavity
should be laid freely open in its whole extent, stuffed with iodoform or
bismuth gauze, and treated by the open method.

It is seldom advisable to wash out an abscess cavity, and squeezing out
the pus is also to be avoided, lest the protective zone be broken down
and the infection be diffused into the surrounding tissues.

The importance of taking precautions against further infection in
opening an abscess can scarcely be exaggerated, and the rapidity with
which healing occurs when the access of fresh bacteria is prevented is
in marked contrast to what occurs when such precautions are neglected
and further infection is allowed to take place.

_Acute Suppuration in a Wound._--If in the course of an operation
infection of the wound has occurred, a marked inflammatory reaction soon
manifests itself, and the same changes as occur in the formation of an
acute abscess take place, modified, however, by the fact that the pus
can more readily reach the surface. In from twenty-four to forty-eight
hours the patient is conscious of a sensation of chilliness, or may
even have a rigor. At the same time he feels generally out of sorts,
with impaired appetite, headache, and it may be looseness of the bowels.
His temperature rises to 100 o or 101 o F., and the pulse quickens to 100
or 110.

On exposing the wound it is found that the parts for some distance
around are red, glazed, and oedematous. The discoloration and swelling
are most intense in the immediate vicinity of the wound, the edges of
which are everted and moist. Any stitches that may have been introduced
are tight, and the deep ones may be cutting into the tissues. There is
heat, and a constant burning or throbbing pain, which is increased by
pressure. If the stitches be cut, pus escapes, the wound gapes, and its
surfaces are found to be inflamed and covered with pus.

The open method is the only safe means of treating such wounds. The
infected surface may be sponged over with pure carbolic acid, the excess
of which is washed off with absolute alcohol, and the wound either
drained by tubes or packed with iodoform gauze. The practice of scraping
such surfaces with the sharp spoon, squeezing or even of washing them
out with antiseptic lotions, is attended with the risk of further
diffusing the organisms in the tissue, and is only to be employed under
exceptional circumstances. Continuous irrigation of infected wounds or
their immersion in antiseptic baths is sometimes useful. The free
opening up of the wound is almost immediately followed by a fall in the
temperature. The surrounding inflammation subsides, the discharge of pus
lessens, and healing takes place by the formation of granulation
tissue--the so-called "healing by second intention."

Wound infection may take place from _catgut_ which has not been
efficiently prepared. The local and general reactions may be slight,
and, as a rule, do not appear for seven or eight days after the
operation, and, it may be, not till after the skin edges have united.
The suppuration is strictly localised to the part of the wound where
catgut was employed for stitches or ligatures, and shows little tendency
to spread. The infected part, however, is often long of healing. The
irritation in these cases is probably due to toxins in the catgut and
not to bacteria.

When suppuration occurs in connection with buried sutures of
unabsorbable materials, such as silk, silkworm gut, or silver wire, it
is apt to persist till the foreign material is cast off or removed.

Suppuration may occur in the track of a skin stitch, producing a _stitch
abscess_. The infection may arise from the material used, especially
catgut or silk, or, more frequently perhaps, from the growth of
staphylococcus albus from the skin of the patient when this has been
imperfectly disinfected. The formation of pus under these conditions may
not be attended with any of the usual signs of suppuration, and beyond
some induration around the wound and a slight tenderness on pressure
there may be nothing to suggest the presence of an abscess.

_Acute Suppuration of a Mucous Membrane._--When pyogenic organisms gain
access to a mucous membrane, such as that of the bladder, urethra, or
middle ear, the usual phenomena of acute inflammation and suppuration
ensue, followed by the discharge of pus on the free surface. It would
appear that the most marked changes take place in the submucous tissue,
causing the covering epithelium in places to die and leave small
superficial ulcers, for example in gonorrhoeal urethritis, the
cicatricial contraction of the scar subsequently leading to the
formation of stricture. When mucous glands are present in the membrane,
the pus is mixed with mucus--_muco-pus_.


DIFFUSE CELLULITIS AND DIFFUSE SUPPURATION

Cellulitis is an acute affection resulting from the introduction of some
organism--commonly the _streptococcus pyogenes_--into the cellular
connective tissue of the integument, intermuscular septa, tendon
sheaths, or other structures. Infection always takes place through a
breach of the surface, although this may be superficial and
insignificant, such as a pin-prick, a scratch, or a crack under a nail,
and the wound may have been healed for some time before the inflammation
becomes manifest. The cellulitis, also, may develop at some distance
from the seat of inoculation, the organisms having travelled by the
lymphatics.

The virulence of the organisms, the loose, open nature of the tissues in
which they develop, and the free lymphatic circulation by means of which
they are spread, account for the diffuse nature of the process.
Sometimes numbers of cocci are carried for a considerable distance from
the primary area before they are arrested in the lymphatics, and thus
several patches of inflammation may appear with healthy areas between.

The pus infiltrates the meshes of the cellular tissue, there is
sloughing of considerable portions of tissue of low vitality, such as
fat, fascia, or tendon, and if the process continues for some time
several collections of pus may form.

_Clinical Features._--The reaction in cases of diffuse cellulitis is
severe, and is usually ushered in by a distinct chill or even a rigor,
while the temperature rises to 103 o, 104 o, or 105 o F. The pulse is
proportionately increased in frequency, and is small, feeble, and often
irregular. The face is flushed, the tongue dry and brown, and the
patient may become delirious, especially during the night. Leucocytosis
is present in cases of moderate severity; but in severe cases the
virulence of the toxins prevents reaction taking place, and leucocytosis
is absent.

The local manifestations vary with the relation of the seat of the
inflammation to the surface. When the superficial cellular tissue is
involved, the skin assumes a dark bluish-red colour, is swollen,
oedematous, and the seat of burning pain. To the touch it is firm, hot,
and tender. When the primary focus is in the deeper tissues, the
constitutional disturbance is aggravated, while the local signs are
delayed, and only become prominent when pus forms and approaches the
surface. It is not uncommon for blebs containing dark serous fluid to
form on the skin. The infection frequently spreads along the line of the
main lymph vessels of the part (_septic lymphangitis_) and may reach the
lymph glands (_septic lymphadenitis_).

With the formation of pus the skin becomes soft and boggy at several
points, and eventually breaks, giving exit to a quantity of thick
grumous discharge. Sometimes several small collections under the skin
fuse, and an abscess is formed in which fluctuation can be detected.
Occasionally gases are evolved in the tissues, giving rise to emphysema.
It is common for portions of fascia, ligaments, or tendons to slough,
and this may often be recognised clinically by a peculiar crunching or
grating sensation transmitted to the fingers on making firm pressure on
the part.

If it is not let out by incision, the pus, travelling along the lines of
least resistance, tends to point at several places on the surface, or to
open into joints or other cavities.

_Prognosis._--The occurrence of _septicaemia_ is the most serious risk,
and it is in cases of diffuse suppurative cellulitis that this form of
blood-poisoning assumes its most aggravated forms. The toxins of the
streptococci are exceedingly virulent, and induce local death of tissue
so rapidly that the protective emigration of leucocytes fails to take
place. In some cases the passage of masses of free cocci in the
lymphatics, or of infective emboli in the blood vessels, leads to the
formation of _pyogenic abscesses_ in vital organs, such as the brain,
lungs, liver, kidneys, or other viscera. _Haemorrhage_ from erosion of
arterial or venous trunks may take place and endanger life.

_Treatment._--The treatment of diffuse cellulitis depends to a large
extent on the situation and extent of the affected area, and on the
stage of the process.

_In the limbs_, for example, where the application of a constricting
band is practicable, Bier's method of inducing passive hyperaemia yields
excellent results. If pus is formed, one or more small incisions are
made and a light moist dressing placed over the wounds to absorb the
discharge, but no drain is inserted. The whole of the inflamed area
should be covered with gauze wrung out of a 1 in 10 solution of ichthyol
in glycerine. The dressing is changed as often as necessary, and in the
intervals when the band is off, gentle active and passive movements
should be carried out to prevent the formation of adhesions. After
incisions have been made, we have found the _immersion_ of the limb, for
a few hours at a time, in a water-bath containing warm boracic lotion or
eusol a useful adjuvant to the passive hyperaemia.

_Continuous irrigation_ of the part by a slow, steady stream of lotion,
at the body temperature, such as eusol, or Dakin's solution, or boracic
acid, or frequent washing with peroxide of hydrogen, has been found of
value.

A suitably arranged splint adds to the comfort of the patient; and the
limb should be placed in the attitude which, in the event of stiffness
resulting, will least interfere with its usefulness. The elbow, for
example, should be flexed to a little less than a right angle; at the
wrist, the hand should be dorsiflexed and the fingers flexed slightly
towards the palm.

Massage, passive movement, hot and cold douching, and other measures,
may be necessary to get rid of the chronic oedema, adhesions of tendons,
and stiffness of joints which sometimes remain.

In situations where a constricting band cannot be applied, for example,
on the trunk or the neck, Klapp's suction bells may be used, small
incisions being made to admit of the escape of pus.

If these measures fail or are impracticable, it may be necessary to make
one or more free incisions, and to insert drainage-tubes, portions of
rubber dam, or iodoform worsted.

The general treatment of toxaemia must be carried out, and in cases due
to infection by streptococci, anti-streptococcic serum may be used.

In a few cases, amputation well above the seat of disease, by removing
the source of toxin production, offers the only means of saving the
patient.


WHITLOW

The clinical term whitlow is applied to an acute infection, usually
followed by suppuration, commonly met with in the fingers, less
frequently in the toes. The point of infection is often trivial--a
pin-prick, a puncture caused by a splinter of wood, a scratch, or even
an imperceptible lesion of the skin.

Several varieties of whitlow are recognised, but while it is convenient
to describe them separately, it is to be clearly understood that
clinically they merge one into another, and it is not always possible to
determine in which connective-tissue plane a given infection has
originated.

_Initial Stage._--Attention is usually first attracted to the condition
by a sensation of tightness in the finger and tenderness when the part
is squeezed or knocked against anything. In the course of a few hours
the part becomes red and swollen; there is continuous pain, which soon
assumes a throbbing character, particularly when the hand is dependent,
and may be so severe as to prevent sleep, and the patient may feel
generally out of sorts.

If a constricting band is applied at this stage, the infection can
usually be checked and the occurrence of suppuration prevented. If this
fails, or if the condition is allowed to go untreated, the inflammatory
reaction increases and terminates in suppuration, giving rise to one or
other of the forms of whitlow to be described.

_The Purulent Blister._--In the most superficial variety, pus forms
between the rete Malpighii and the stratum corneum of the skin, the
latter being raised as a blister in which fluctuation can be detected
(Fig. 9, a). This is commonly met with in the palm of the hand of
labouring men who have recently resumed work after a spell of idleness.
When the blister forms near the tip of the finger, the pus burrows under
the nail--which corresponds to the stratum corneum--raising it from its
bed.

There is some local heat and discoloration, and considerable pain and
tenderness, but little or no constitutional disturbance. Superficial
lymphangitis may extend a short distance up the forearm. By clipping
away the raised epidermis, and if necessary the nail, the pus is allowed
to escape, and healing speedily takes place.

_Whitlow at the Nail Fold._--This variety, which is met with among those
who handle septic material, occurs in the sulcus between the nail and
the skin, and is due to the introduction of infective matter at the root
of the nail (Fig. 9, b). A small focus of suppuration forms under the
nail, with swelling and redness of the nail fold, causing intense pain
and discomfort, interfering with sleep, and producing a constitutional
reaction out of all proportion to the local lesion.

To allow the pus to escape, it is necessary, under local anaesthesia, to
cut away the nail fold as well as the portion of nail in the infected
area, or, it may be, to remove the nail entirely. If only a small
opening is made in the nail it is apt to be blocked by granulations.

[Illustration: FIG. 9.--Diagram of various forms of Whitlow.
  a = Purulent blister.
  b = Suppuration at nail fold.
  c = Subcutaneous whitlow.
  d = Whitlow in sheath of flexor tendon (e). ]

_Subcutaneous Whitlow._--In this variety the infection manifests itself
as a cellulitis of the pulp of the finger (Fig. 9, c), which sometimes
spreads towards the palm of the hand. The finger becomes red, swollen,
and tense; there is severe throbbing pain, which is usually worst at
night and prevents sleep, and the part is extremely tender on pressure.
When the palm is invaded there may be marked oedema of the back of the
hand, the dense integument of the palm preventing the swelling from
appearing on the front. The pus may be under such tension that
fluctuation cannot be detected. The patient is usually able to flex the
finger to a certain extent without increasing the pain--a point which
indicates that the tendon sheaths have not been invaded. The
suppurative process may, however, spread to the tendon sheaths, or even
to the bone. Sometimes the excessive tension and virulent toxins induce
actual gangrene of the distal part, or even of the whole finger. There
is considerable constitutional disturbance, the temperature often
reaching 101 o or 102 o F.

The treatment consists in applying a constriction band and making an
incision over the centre of the most tender area, care being taken to
avoid opening the tendon sheath lest the infection be conveyed to it.
Moist dressings should be employed while the suppuration lasts. Carbolic
fomentations, however, are to be avoided on account of the risk of
inducing gangrene.

_Whitlow of the Tendon Sheaths._--In this form the main incidence of the
infection is on the sheaths of the flexor tendons, but it is not always
possible to determine whether it started there or spread thither from
the subcutaneous cellular tissue (Fig. 9, d). In some cases both
connective tissue planes are involved. The affected finger becomes red,
painful, and swollen, the swelling spreading to the dorsum. The
involvement of the tendon sheath is usually indicated by the patient
being unable to flex the finger, and by the pain being increased when he
attempts to do so. On account of the anatomical arrangement of the
tendon sheaths, the process may spread into the forearm--directly in the
case of the thumb and little finger, and after invading the palm in the
case of the other fingers--and there give rise to a diffuse cellulitis
which may result in sloughing of fasciae and tendons. When the infection
spreads into the common flexor sheath under the transverse carpal
(anterior annular) ligament, it is not uncommon for the intercarpal and
wrist joints to become implicated. Impaired movement of tendons and
joints is, therefore, a common sequel to this variety of whitlow.

The _treatment_ consists in inducing passive hyperaemia by Bier's method,
and, if this is done early, suppuration may be avoided. If pus forms,
small incisions are made, under local anaesthesia, to relieve the tension
in the sheath and to diminish the risk of the tendons sloughing. No form
of drain should be inserted. In the fingers the incisions should be made
in the middle line, and in the palm they should be made over the
metacarpal bones to avoid the digital vessels and nerves. If pus has
spread under the transverse carpal ligament, the incision must be made
above the wrist. Passive movements and massage must be commenced as
early as possible and be perseveringly employed to diminish the
formation of adhesions and resulting stiffness.

_Subperiosteal Whitlow._--This form is usually an extension of the
subcutaneous or of the thecal variety, but in some cases the
inflammation begins in the periosteum--usually of the terminal phalanx.
It may lead to necrosis of a portion or even of the entire phalanx. This
is usually recognised by the persistence of suppuration long after the
acute symptoms have passed off, and by feeling bare bone with the probe.
In such cases one or more of the joints are usually implicated also, and
lateral mobility and grating may be elicited. Recovery does not take
place until the dead bone is removed, and the usefulness of the finger
is often seriously impaired by fibrous or bony ankylosis of the
interphalangeal joints. This may render amputation advisable when a
stiff finger is likely to interfere with the patient's occupation.


SUPPURATIVE CELLULITIS IN DIFFERENT SITUATIONS

_Cellulitis of the forearm_ is usually a sequel to one of the deeper
varieties of whitlow.

In the _region of the elbow-joint_, cellulitis is common around the
olecranon. It may originate as an inflammation of the olecranon bursa,
or may invade the bursa secondarily. In exceptional cases the
elbow-joint is also involved.

Cellulitis of the _axilla_ may originate in suppuration in the lymph
glands, following an infected wound of the hand, or it may spread from a
septic wound on the chest wall or in the neck. In some cases it is
impossible to discover the primary seat of infection. A firm, brawny
swelling forms in the armpit and extends on to the chest wall. It is
attended with great pain, which is increased on moving the arm, and
there is marked constitutional disturbance. When suppuration occurs, its
spread is limited by the attachments of the axillary fascia, and the pus
tends to burrow on to the chest wall beneath the pectoral muscles, and
upwards towards the shoulder-joint, which may become infected. When the
pus forms in the axillary space, the treatment consists in making free
incisions, which should be placed on the thoracic side of the axilla to
avoid the axillary vessels and nerves. If the pus spreads on to the
chest wall, the abscess should be opened below the clavicle by Hilton's
method, and a counter opening may be made in the axilla.

Cellulitis of the _sole of the foot_ may follow whitlow of the toes.

In the _region of the ankle_ cellulitis is not common; but _around the
knee_ it frequently occurs in relation to the prepatellar bursa and to
the popliteal lymph glands, and may endanger the knee-joint. It is also
met with in the _groin_ following on inflammation and suppuration of the
inguinal glands, and cases are recorded in which the sloughing process
has implicated the femoral vessels and led to secondary haemorrhage.

Cellulitis of the scalp, orbit, neck, pelvis, and perineum will be
considered with the diseases of these regions.


CHRONIC SUPPURATION

While it is true that a chronic pyogenic abscess is sometimes met
with--for example, in the breast and in the marrow of long bones--in the
great majority of instances the formation of a chronic or cold abscess
is the result of the action of the tubercle bacillus. It is therefore
more convenient to study this form of suppuration with tuberculosis
(p. 139).


SINUS AND FISTULA

#Sinus.#--A sinus is a track leading from a focus of suppuration to a
cutaneous or mucous surface. It usually represents the path by which the
discharge escapes from an abscess cavity that has been prevented from
closing completely, either from mechanical causes or from the persistent
formation of discharge which must find an exit. A sinus is lined by
granulation tissue, and when it is of long standing the opening may be
dragged below the level of the surrounding skin by contraction of the
scar tissue around it. As a sinus will persist until the obstacle to
closure of the original abscess is removed, it is necessary that this
should be sought for. It may be a foreign body, such as a piece of dead
bone, an infected ligature, or a bullet, acting mechanically or by
keeping up discharge, and if the body is removed the sinus usually
heals. The presence of a foreign body is often suggested by a mass of
redundant granulations at the mouth of the sinus. If a sinus passes
through a muscle, the repeated contractions tend to prevent healing
until the muscle is kept at rest by a splint, or put out of action by
division of its fibres. The sinuses associated with empyema are
prevented from healing by the rigidity of the chest wall, and will only
close after an operation which admits of the cavity being obliterated.
In any case it is necessary to disinfect the track, and, it may be, to
remove the unhealthy granulations lining it, by means of the sharp
spoon, or to excise it bodily. To encourage healing from the bottom the
cavity should be packed with bismuth or iodoform gauze. The healing of
long and tortuous sinuses is often hastened by the injection of Beck's
bismuth paste (p. 145). If disfigurement is likely to follow from
cicatricial contraction--for example, in a sinus over the lower jaw
associated with a carious tooth--the sinus should be excised and the raw
surfaces approximated with stitches.

The _tuberculous sinus_ is described under Tuberculosis.

A #fistula# is an abnormal canal passing from a mucous surface to the
skin or to another mucous surface. Fistulae resulting from suppuration
usually occur near the natural openings of mucous canals--for example,
on the cheek, as a salivary fistula; beside the inner angle of the eye,
as a lacrymal fistula; near the ear, as a mastoid fistula; or close to
the anus, as a fistula-in-ano. Intestinal fistulae are sometimes met with
in the abdominal wall after strangulated hernia, operations for
appendicitis, tuberculous peritonitis, and other conditions. In the
perineum, fistulae frequently complicate stricture of the urethra.

Fistulae also occur between the bladder and vagina (_vesico-vaginal
fistula_), or between the bladder and the rectum (_recto-vesical
fistula_).

The _treatment_ of these various forms of fistula will be described in
the sections dealing with the regions in which they occur.

_Congenital fistulae_, such as occur in the neck from imperfect closure
of branchial clefts, or in the abdomen from unobliterated foetal ducts
such as the urachus or Meckel's diverticulum, will be described in their
proper places.


CONSTITUTIONAL MANIFESTATIONS OF PYOGENIC INFECTION

We have here to consider under the terms Sapraemia, Septicaemia, and
Pyaemia certain general effects of pyogenic infection, which, although
their clinical manifestations may vary, are all associated with the
action of the same forms of bacteria. They may occur separately or in
combination, or one may follow on and merge into another.

#Sapraemia#, or septic intoxication, is the name applied to a form of
poisoning resulting from the absorption into the blood of the toxic
products of pyogenic bacteria. These products, which are of the nature
of alkaloids, act immediately on their entrance into the circulation,
and produce effects in direct proportion to the amount absorbed. As the
toxins are gradually eliminated from the body the symptoms abate, and if
no more are introduced they disappear. Sapraemia in these respects,
therefore, is comparable to poisoning by any other form of alkaloid,
such as strychnin or morphin.

_Clinical Features._--The symptoms of sapraemia seldom manifest
themselves within twenty-four hours of an operation or injury, because
it takes some time for the bacteria to produce a sufficient dose of
their poisons. The onset of the condition is marked by a feeling of
chilliness, sometimes amounting to a rigor, and a rise of temperature to
102 o, 103 o, or 104 o F., with morning remissions (Fig. 10). The heart's
action is markedly depressed, and the pulse is soft and compressible.
The appetite is lost, the tongue dry and covered with a thin
brownish-red fur, so that it has the appearance of "dried beef." The
urine is scanty and loaded with urates. In severe cases diarrhoea and
vomiting of dark coffee-ground material are often prominent features.
Death is usually impending when the skin becomes cold and clammy, the
mucous membranes livid, the pulse feeble and fluttering, the discharges
involuntary, and when a low form of muttering delirium is present.

[Illustration: FIG. 10.--Charts of Acute sapraemia from (a) case of
crushed foot, and (b) case of incomplete abortion.]

A local form of septic infection is always present--it may be an
abscess, an infected compound fracture, or an infection of the cavity of
the uterus, for example, from a retained portion of placenta.

_Treatment._--The first indication is the immediate and complete removal
of the infected material. The wound must be freely opened, all
blood-clot, discharge, or necrosed tissue removed, and the area
disinfected by washing with sterilised salt solution, peroxide of
hydrogen, or eusol. Stronger lotions are to be avoided as being likely
to depress the tissues, and so interfere with protective phagocytosis.
On account of its power of neutralising toxins, iodoform is useful in
these cases, and is best employed by packing the wound with iodoform
gauze, and treating it by the open method, if this is possible.

The general treatment is carried out on the same lines as for other
infective conditions.

#Chronic sapraemia or Hectic Fever.#--Hectic fever differs from acute
sapraemia merely in degree. It usually occurs in connection with
tuberculous conditions, such as bone or joint disease, psoas abscess, or
empyema, which have opened externally, and have thereby become infected
with pyogenic organisms. It is gradual in its development, and is of a
mild type throughout.

[Illustration: FIG. 11.--Chart of Hectic Fever.]

The pulse is small, feeble, and compressible, and the temperature rises
in the afternoon or evening to 102 o or 103 o F. (Fig. 11), the cheeks
becoming characteristically flushed. In the early morning the
temperature falls to normal or below it, and the patient breaks into a
profuse perspiration, which leaves him pale, weak, and exhausted. He
becomes rapidly and markedly emaciated, even although in some cases the
appetite remains good and is even voracious.

The poisons circulating in the blood produce _waxy degeneration_ in
certain viscera, notably the liver, spleen, kidneys, and intestines. The
process begins in the arterial walls, and spreads thence to the
connective-tissue structures, causing marked enlargement of the affected
organs. Albuminuria, ascites, oedema of the lower limbs, clubbing of the
fingers, and diarrhoea are among the most prominent symptoms of this
condition.

The _prognosis_ in hectic fever depends on the completeness with which
the further absorption of toxins can be prevented. In many cases this
can only be effected by an operation which provides for free drainage,
and, if possible, the removal of infected tissues. The resulting wound
is best treated by the open method. Even advanced waxy degeneration does
not contra-indicate this line of treatment, as the diseased organs
usually recover if the focus from which absorption of toxic material is
taking place is completely eradicated.

[Illustration: FIG. 12.--Chart of case of Septicaemia followed by
Pyaemia.]

#Septicaemia.#--This form of blood-poisoning is the result of the action
of pyogenic bacteria, which not only produce their toxins at the primary
seat of infection, but themselves enter the blood-stream and are carried
to other parts, where they settle and produce further effects.

_Clinical Features._--There may be an incubation period of some hours
between the infection and the first manifestation of acute septicaemia.
In such conditions as acute osteomyelitis or acute peritonitis, we see
the most typical clinical pictures of this condition. The onset is
marked by a chill, or a rigor, which may be repeated, while the
temperature rises to 103 o or 104 o F., although in very severe cases the
temperature may remain subnormal throughout, the virulence of the toxins
preventing reaction. It is in the general appearance of the patient and
in the condition of the pulse that we have our best guides as to the
severity of the condition. If the pulse remains firm, full, and regular,
and does not exceed 110 or even 120, while the temperature is moderately
raised, the outlook is hopeful; but when the pulse becomes small and
compressible, and reaches 130 or more, especially if at the same time
the temperature is low, a grave prognosis is indicated. The tongue is
often dry and coated with a black crust down the centre, while the sides
are red. It is a good omen when the tongue becomes moist again. Thirst
is most distressing, especially in septicaemia of intestinal origin.
Persistent vomiting of dark-brown material is often present, and
diarrhoea with blood-stained stools is not uncommon. The urine is small
in amount, and contains a large proportion of urates. As the poisons
accumulate, the respiration becomes shallow and laboured, the face of a
dull ashy grey, the nose pinched, and the skin cold and clammy.
Capillary haemorrhages sometimes take place in the skin or mucous
membranes; and in a certain proportion of cases cutaneous eruptions
simulating those of scarlet fever or measles appear, and are apt to lead
to errors in diagnosis. In other cases there is slight jaundice. The
mental state is often one of complete apathy, the patient failing to
realise the gravity of his condition; sometimes there is delirium.

The _prognosis_ is always grave, and depends on the possibility of
completely eradicating the focus of infection, and on the reserve force
the patient has to carry him over the period during which he is
eliminating the poison already circulating in his blood.

The _treatment_ is carried out on the same lines as in sapraemia, but it
is less likely to be successful owing to the organisms having entered
the circulation. When possible, the primary focus of infection should be
dealt with.

#Pyaemia# is a form of blood-poisoning characterised by the development
of secondary foci of suppuration in different parts of the body. Toxins
are thus introduced into the blood, not only at the primary seat of
infection, but also from each of these metastatic collections. Like
septicaemia, this condition is due to pyogenic bacteria, the
_streptococcus pyogenes_ being the commonest organism found. The primary
infection is usually in a wound--for example, a compound fracture--but
cases occur in which the point of entrance of the bacteria is not
discoverable. The dissemination of the organisms takes place through the
medium of infected emboli which form in a thrombosed vein in the
vicinity of the original lesion, and, breaking loose, are carried
thence in the blood-stream. These emboli lodge in the minute vessels of
the lungs, spleen, liver, kidneys, pleura, brain, synovial membranes, or
cellular tissue, and the bacteria they contain give rise to secondary
foci of suppuration. Secondary abscesses are thus formed in those parts,
and these in turn may be the starting-point of new emboli which give
rise to fresh areas of pus formation. The organs above named are the
commonest situations of pyaemic abscesses, but these may also occur in
the bone marrow, the substance of muscles, the heart and pericardium,
lymph glands, subcutaneous tissue, or, in fact, in any tissue of the
body. Organisms circulating in the blood are prone to lodge on the
valves of the heart and give rise to endocarditis.

[Illustration: FIG. 13.--Chart of Pyaemia following on Acute
Osteomyelitis.]

_Clinical Features._--Before antiseptic surgery was practised, pyaemia
was a common complication of wounds. In the present day it is not only
infinitely less common, but appears also to be of a less severe type.
Its rarity and its mildness may be related as cause and effect, because
it was formerly found that pyaemia contracted from a pyaemic patient was
more virulent than that from other sources.

In contrast with sapraemia and septicaemia, pyaemia is late of developing,
and it seldom begins within a week of the primary infection. The first
sign is a feeling of chilliness, or a violent rigor lasting for perhaps
half an hour, during which time the temperature rises to 103 o, 104 o, or
105 o F. In the course of an hour it begins to fall again, and the
patient breaks into a profuse sweat. The temperature may fall several
degrees, but seldom reaches the normal. In a few days there is a second
rigor with rise of temperature, and another remission, and such attacks
may be repeated at diminishing intervals during the course of the
illness (Figs. 12 and 13). The pulse is soft, and tends to remain
abnormally rapid even when the temperature falls nearly to normal.

The face is flushed, and wears a drawn, anxious expression, and the eyes
are bright. A characteristic sweetish odour, which has been compared to
that of new-mown hay, can be detected in the breath and may pervade the
patient. The appetite is lost; there may be sickness and vomiting and
profuse diarrhoea; and the patient emaciates rapidly. The skin is
continuously hot, and has often a peculiar pungent feel. Patches of
erythema sometimes appear scattered over the body. The skin may assume a
dull sallow or earthy hue, or a bright yellow icteric tint may appear.
The conjunctivae also may be yellow. In the latter stages of the disease
the pulse becomes small and fluttering; the tongue becomes dry and
brown; sordes collect on the teeth; and a low muttering form of delirium
supervenes.

Secondary infection of the parotid gland frequently occurs, and gives
rise to a suppurative parotitis. This condition is associated with
severe pain, gradually extending from behind the angle of the jaw on to
the face. There is also swelling over the gland, and eventually
suppuration and sloughing of the gland tissue and overlying skin.

Secondary abscesses in the lymph glands, subcutaneous tissue, or joints
are often so insidious and painless in their development that they are
only discovered accidentally. When the abscess is evacuated, healing
often takes place with remarkable rapidity, and with little impairment
of function.

The general symptoms may be simulated by an attack of malaria.

_Prognosis._--The prognosis in acute pyaemia is much less hopeless than
it once was, a considerable proportion of the patients recovering. In
acute cases the disease proves fatal in ten days or a fortnight, death
being due to toxaemia. Chronic cases often run a long course, lasting for
weeks or even months, and prove fatal from exhaustion and waxy disease
following on prolonged suppuration.

_Treatment._--In such conditions as compound fractures and severe
lacerated wounds, much can be done to avert the conditions which lead to
pyaemia, by applying a Bier's constricting bandage as soon as there is
evidence of infection having taken place, or even if there is reason to
suspect that the wound is not aseptic.

If sepsis is already established, and evidence of general infection is
present, the wound should be opened up sufficiently to admit of thorough
disinfection and drainage, and the constricting bandage applied to aid
the defensive processes going on in the tissues. If these measures fail,
amputation of the limb may be the only means of preventing further
dissemination of infective material from the primary source of
infection.

Attempts have been made to interrupt the channel along which the
infective emboli spread, by ligating or resecting the main vein of the
affected part, but this is seldom feasible except in the case of the
internal jugular vein for infection of the transverse sinus.

Secondary abscesses must be aspirated or opened and drained whenever
possible.

The general treatment is conducted on the same lines as on other forms
of pyogenic infection.




CHAPTER V

ULCERATION AND ULCERS


Definitions--Clinical examination of an ulcer--The healing
    sore.--Classification of ulcers--A. According to cause:
    _Traumatism_, _Imperfect circulation_, _Imperfect nerve-supply_,
    _Constitutional causes_--B. According to condition: _Healing_,
    _Stationary_, _Spreading_.--Treatment.

The process of _ulceration_ may be defined as the molecular or cellular
death of tissue taking place on a free surface. It is essentially of the
same nature as the process of suppuration, only that the purulent
discharge, instead of collecting in a closed cavity and forming an
abscess, at once escapes on the surface.

An _ulcer_ is an open wound or sore in which there are present certain
conditions tending to prevent it undergoing the natural process of
repair. Of these, one of the most important is the presence of
pathogenic bacteria, which by their action not only prevent healing, but
so irritate and destroy the tissues as to lead to an actual increase in
the size of the sore. Interference with the nutrition of a part by oedema
or chronic venous congestion may impede healing; as may also induration
of the surrounding area, by preventing the contraction which is such an
important factor in repair. Defective innervation, such as occurs in
injuries and diseases of the spinal cord, also plays an important part
in delaying repair. In certain constitutional conditions, too--for
example, Bright's disease, diabetes, or syphilis--the vitiated state of
the tissues is an impediment to repair. Mechanical causes, such as
unsuitable dressings or ill-fitting appliances, may also act in the same
direction.

#Clinical Examination of an Ulcer.#--In examining any ulcer, we
observe--(1) Its _base_ or _floor_, noting the presence or absence of
granulations, their disposition, size, colour, vascularity, and whether
they are depressed or elevated in relation to the surrounding parts. (2)
The _discharge_ as to quantity, consistence, colour, composition, and
odour. (3) The _edges_, noting particularly whether or not the marginal
epithelium is attempting to grow over the surface; also their shape,
regularity, thickness, and whether undermined or overlapping, everted or
depressed. (4) The _surrounding tissues_, as to whether they are
congested, oedematous, inflamed, indurated, or otherwise. (5) Whether or
not there is _pain_ or tenderness in the raw surface or its
surroundings. (6) The _part of the body_ on which it occurs, because
certain ulcers have special seats of election--for example, the varicose
ulcer in the lower third of the leg, the perforating ulcer on the sole
of the foot, and so on.

#The Healing Sore.#--If a portion of skin be excised aseptically, and no
attempt made to close the wound, the raw surface left is soon covered
over with a layer of coagulated blood and lymph. In the course of a few
days this is replaced by the growth of _granulations_, which are of
uniform size, of a pinkish-red colour, and moist with a slight serous
exudate containing a few dead leucocytes. They grow until they reach the
level of the surrounding skin, and so fill the gap with a fine velvety
mass of granulation tissue. At the edges, the young epithelium may be
seen spreading in over the granulations as a fine bluish-white pellicle,
which gradually covers the sore, becoming paler in colour as it
thickens, and eventually forming the smooth, non-vascular covering of
the cicatrix. There is no pain, and the surrounding parts are healthy.

This may be used as a type with which to compare the ulcers seen at the
bedside, so that we may determine how far, and in what particulars,
these differ from the type; and that we may in addition recognise the
conditions that have to be counteracted before the characters of the
typical healing sore are assumed.

For purposes of contrast we may indicate the characters of an open sore
in which bacterial infection with pathogenic bacteria has taken place.
The layer of coagulated blood and lymph becomes liquefied and is thrown
off, and instead of granulations being formed, the tissues exposed on
the floor of the ulcer are destroyed by the bacterial toxins, with the
formation of minute sloughs and a quantity of pus.

The discharge is profuse, thin, acrid, and offensive, and consists of
pus, broken-down blood-clot, and sloughs. The edges are inflamed,
irregular, and ragged, showing no sign of growing epithelium--on the
contrary, the sore may be actually increasing in area by the
breaking-down of the tissues at its margins. The surrounding parts are
hot, red, swollen, and oedematous; and there is pain and tenderness both
in the sore itself and in the parts around.

#Classification of Ulcers.#--The nomenclature of ulcers is much involved
and gives rise to great confusion, chiefly for the reason that no one
basis of classification has been adopted. Thus some ulcers are named
according to the causes at work in producing or maintaining them--for
example, the traumatic, the septic, and the varicose ulcer; some from
the constitutional element present, as the gouty and the diabetic ulcer;
and others according to the condition in which they happen to be when
seen by the surgeon, such as the weak, the inflamed, and the callous
ulcer.

So long as we retain these names it will be impossible to find a single
basis for classification; and yet many of the terms are so descriptive
and so generally understood that it is undesirable to abolish them. We
must therefore remain content with a clinical arrangement of ulcers,--it
cannot be called a classification,--considering any given ulcer from two
points of view: first its _cause_, and second its _present condition_.
This method of studying ulcers has the practical advantage that it
furnishes us with the main indications for treatment as well as for
diagnosis: the cause must be removed, and the condition so modified as
to convert the ulcer into an aseptic healing sore.

A. #Arrangement of Ulcers according to their Cause.#--Although any given
ulcer may be due to a combination of causes, it is convenient to
describe the following groups:

_Ulcers due to Traumatism._--Traumatism in the form of a _crush_ or
_bruise_ is a frequent cause of ulcer formation, acting either by
directly destroying the skin, or by so diminishing its vitality that it
is rendered a suitable soil for bacteria. If these gain access, in the
course of a few days the damaged area of skin becomes of a greyish
colour, blebs form on it, and it undergoes necrosis, leaving an
unhealthy raw surface when the slough separates.

_Heat_ and _prolonged exposure to the Rontgen rays_ or _to radium
emanations_ act in a similar way.

The _pressure_ of improperly padded splints or other appliances may so
far interfere with the circulation of the part pressed upon, that the
skin sloughs, leaving an open sore. This is most liable to occur in
patients who suffer from some nerve lesion--such as anterior
poliomyelitis, or injury of the spinal cord or nerve-trunks.
Splint-pressure sores are usually situated over bony prominences, such
as the malleoli, the condyles of the femur or humerus, the head of the
fibula, the dorsum of the foot, or the base of the fifth metatarsal
bone. On removing the splint, the skin of the part pressed upon is found
to be of a red or pink colour, with a pale grey patch in the centre,
which eventually sloughs and leaves an ulcer. Certain forms of
_bed-sore_ are also due to prolonged pressure.

Pressure sores are also known to have been produced artificially by
malingerers and hysterical subjects.

[Illustration: FIG. 14.--Leg Ulcers associated with Varicose Veins and
Pigmentation of the Skin.]

_Ulcers due to Imperfect Circulation._--Imperfect circulation is an
important causative factor in ulceration, especially when it is the
_venous return_ that is defective. This is best illustrated in the
so-called _leg ulcer_, which occurs most frequently on the front and
medial aspect of the lower third of the leg. At this point the
anastomosis between the superficial and deep veins of the leg is less
free than elsewhere, so that the extra stress thrown upon the surface
veins interferes with the nutrition of the skin (Hilton). The importance
of imperfect venous return in the causation of such ulcers is evidenced
by the fact that as soon as the condition of the circulation is improved
by confining the patient to bed and elevating the limb, the ulcer begins
to heal, even although all methods of local treatment have hitherto
proved ineffectual. In a considerable number of cases, but by no means
in all, this form of ulcer is associated with the presence of varicose
veins, and in such cases it is spoken of as the _varicose ulcer_ (Fig. 14).
The presence of varicose veins is frequently associated with a
diffuse brownish or bluish pigmentation of the skin of the lower third
of the leg, or with an obstinate form of dermatitis (_varicose eczema_),
and the scratching or rubbing of the part is liable to cause a breach of
the surface and permit of infection which leads to ulceration. Varicose
ulcers may also originate from the bursting of a small peri-phlebitic
abscess.

Varicose veins in immediate relation to the base of a large chronic
ulcer usually become thrombosed, and in time are reduced to fibrous
cords, and therefore in such cases haemorrhage is not a common
complication. In smaller and more superficial ulcers, however, the
destructive process is liable to implicate the wall of the vessel before
the occurrence of thrombosis, and to lead to profuse and it may be
dangerous bleeding.

These ulcers are at first small and superficial, but from want of care,
from continued standing or walking, or from injudicious treatment, they
gradually become larger and deeper. They are not infrequently multiple,
and this, together with their depth, may lead to their being mistaken
for ulcers due to syphilis. The base of the ulcer is covered with
imperfectly formed, soft, oedematous granulations, which give off a thin
sero-purulent discharge. The edges are slightly inflamed, and show no
evidence of healing. The parts around are usually pigmented and slightly
oedematous, and as a rule there is little pain. This variety of ulcer is
particularly prone to pass into the condition known as callous.

In _anaemic_ patients, especially young girls, ulcers are occasionally
met with which have many of the clinical characters of those associated
with imperfect venous return. They are slow to heal, and tend to pass
into the condition known as weak.

_Ulcers due to Interference with Nerve-Supply._--Any interference with
the nerve-supply of the superficial tissues predisposes to ulceration.
For example, _trophic_ ulcers are liable to occur in injuries or
diseases of the spinal cord, in cerebral paralysis, in limbs weakened by
poliomyelitis, in ascending or peripheral neuritis, or after injuries of
nerve-trunks.

The _acute bed-sore_ is a rapidly progressing form of ulceration, often
amounting to gangrene, of portions of skin exposed to pressure when
their trophic nerve-supply has been interfered with.

[Illustration: FIG. 15.--Perforating Ulcers of Sole of Foot.

(From Photograph lent by Sir Montagu Cotterill.)]

The _perforating ulcer of the foot_ is a peculiar type of sore which
occurs in association with the different forms of peripheral neuritis,
and with various lesions of the brain and spinal cord, such as general
paralysis, locomotor ataxia, or syringo-myelia (Fig. 15). It also occurs
in patients suffering from glycosuria, and is usually associated with
arterio-sclerosis--local or general. Perforating ulcer is met with most
frequently under the head of the metatarsal bone of the great toe. A
callosity forms and suppuration occurs under it, the pus escaping
through a small hole in the centre. The process slowly and gradually
spreads deeper and deeper, till eventually the bone or joint is reached,
and becomes implicated in the destructive process--hence the term
"perforating ulcer." The flexor tendons are sometimes destroyed, the toe
being dorsiflexed by the unopposed extensors. The depth of the track
being so disproportionate to its superficial area, the condition closely
simulates a tuberculous sinus, for which it is liable to be mistaken.
The raw surface is absolutely insensitive, so that the probe can be
freely employed without the patient even being aware of it or suffering
the least discomfort--a significant fact in diagnosis. The cavity is
filled with effete and decomposing epidermis, which has a most offensive
odour. The chronic and intractable character of the ulcer is due to
interference with the trophic nerve-supply of the parts, and to the fact
that the epithelium of the skin grows in and lines the track leading
down to the deepest part of the ulcer and so prevents closure. While
they are commonest on the sole of the foot and other parts subjected to
pressure, perforating ulcers are met with on the sides and dorsum of the
foot and toes, on the hands, and on other parts where no pressure has
been exerted.

The _tuberculous ulcer_, so often seen in the neck, in the vicinity of
joints, or over the ribs and sternum, usually results from the bursting
through the skin of a tuberculous abscess. The base is soft, pale, and
covered with feeble granulations and grey shreddy sloughs. The edges are
of a dull blue or purple colour, and gradually thin out towards their
free margins, and in addition are characteristically undermined, so that
a probe can be passed for some distance between the floor of the ulcer
and the thinned-out edges. Thin, devitalised tags of skin often stretch
from side to side of the ulcer. The outline is irregular; small
perforations often occur through the skin, and a thin, watery discharge,
containing grey shreds of tuberculous debris, escapes.

_Bazin's Disease._--This term is applied to an affection of the skin and
subcutaneous tissue which bears certain resemblances to tuberculosis. It
is met with almost exclusively between the knee and the ankle, and it
usually affects both legs. It is commonest in girls of delicate
constitution, in whose family history there is evidence of a tuberculous
taint. The patient often presents other lesions of a tuberculous
character, notably enlarged cervical glands, and phlyctenular
ophthalmia. The tubercle bacillus has rarely been found, but we have
always observed characteristic epithelioid cells and giant cells in
sections made from the edge or floor of the ulcer.

[Illustration: FIG. 16.--Bazin's Disease in a girl aet. 16.]

The condition begins by the formation in the skin and subcutaneous
tissue of dusky or livid nodules of induration, which soften and
ulcerate, forming small open sores with ragged and undermined edges, not
unlike those resulting from the breaking down of superficial syphilitic
gummata (Fig. 16). Fresh crops of nodules appear in the neighbourhood of
the ulcers, and in turn break down. While in the nodular stage the
affection is sometimes painful, but with the formation of the ulcer the
pain subsides.

The disease runs a chronic course, and may slowly extend over a wide
area in spite of the usual methods of treatment. After lasting for some
months, or even years, however, it may eventually undergo spontaneous
cure. The most satisfactory treatment is to excise the affected tissues
and fill the gap with skin-grafts.

[Illustration: FIG. 17.--Syphilitic Ulcers in region of Knee, showing
punched-out appearance and raised indurated edges.]

The _syphilitic ulcer_ is usually formed by the breaking down of a
cutaneous or subcutaneous gumma in the tertiary stage of syphilis. When
the gummatous tissue is first exposed by the destruction of the skin or
mucous membrane covering it, it appears as a tough greyish slough,
compared to "wash leather," which slowly separates and leaves a more or
less circular, deep, punched-out gap which shows a few feeble unhealthy
granulations and small sloughs on its floor. The edges are raised and
indurated; and the discharge is thick, glairy, and peculiarly offensive.
The parts around the ulcer are congested and of a dark brown colour.
There are usually several such ulcers together, and as they tend to heal
at one part while they spread at another, the affected area assumes a
sinuous or serpiginous outline. Syphilitic ulcers may be met with in any
part of the body, but are most frequent in the upper part of the leg
(Fig. 17), especially around the knee-joint in women, and over the ribs
and sternum. On healing, they usually leave a depressed and adherent
cicatrix.

The _scorbutic ulcer_ occurs in patients suffering from scurvy, and is
characterised by its prominent granulations, which show a marked
tendency to bleed, with the formation of clots, which dry and form a
spongy crust on the surface.

In _gouty_ patients small ulcers which are exceedingly irritable and
painful are liable to occur.

_Ulcers associated with Malignant Disease._--Cancer and sarcoma when
situated in the subcutaneous tissue may destroy the overlying skin so
that the substance of the tumour is exposed. The fungating masses thus
produced are sometimes spoken of as malignant ulcers, but as they are
essentially different in their nature from all other forms of ulcers,
and call for totally different treatment, it is best to consider them
along with the tumours with which they are associated. Rodent ulcer,
which is one form of cancer of the skin, will be discussed with new
growths of the skin.

B. #Arrangement of Ulcers according to their Condition.#--Having arrived
at an opinion as to the cause of a given ulcer, and placed it in one or
other of the preceding groups, the next question to ask is, In what
condition do I find this ulcer at the present moment?

Any ulcer is in one of three states--healing, stationary, or spreading;
although it is not uncommon to find healing going on at one part while
the destructive process is extending at another.

_The Healing Condition._--The process of healing in an ulcer has already
been studied, and we have learned that it takes place by the formation
of granulation tissue, which becomes converted into connective tissue,
and is covered over by epithelium growing in from the edges.

Those ulcers which are _stationary_--that is, neither healing nor
spreading--may be in one of several conditions.

_The Weak Condition._--Any ulcer may get into a weak state from
receiving a blood supply which is defective either in quantity or in
quality. The granulations are small and smooth, and of a pale yellow or
grey colour, the discharge is small in amount, and consists of thin
serum and a few pus cells, and as this dries on the edges it forms scabs
which interfere with the growth of epithelium.

Should the part become oedematous, either from general causes, such as
heart or kidney disease, or from local causes, such as varicose veins,
the granulations share in the oedema, and there is an abundant serous
discharge.

The excessive use of moist dressings leads to a third variety of weak
ulcer--namely, one in which the granulations become large, soft, pale,
and flabby, projecting beyond the level of the skin and overlapping the
edges, which become pale and sodden. The term "proud flesh" is popularly
applied to such redundant granulations.

[Illustration: FIG. 18.--Callous Ulcer, showing thickened edges and
indurated swelling of surrounding parts.]

_The Callous Condition._--This condition is usually met with in ulcers
on the lower third of the leg, and is often associated with the presence
of varicose veins. It is chiefly met with in hospital practice. The want
of healing is mainly due to impeded venous return and to oedema and
induration of the surrounding skin and cellular tissues (Fig. 18). The
induration results from coagulation and partial organisation of the
inflammatory effusion, and prevents the necessary contraction of the
sore. The base of a callous ulcer lies at some distance below the level
of the swollen, thickened, and white edges, and presents a glazed
appearance, such granulations as are present being unhealthy and
irregular. The discharge is usually watery, and cakes in the dressing.
When from neglect and want of cleanliness the ulcer becomes inflamed,
there is considerable pain, and the discharge is purulent and often
offensive.

The prolonged hyperaemia of the tissues in relation to a callous ulcer of
the leg often leads to changes in the underlying bones. The periosteum
is abnormally thick and vascular, the superficial layers of the bone
become injected and porous, and the bones, as a whole, are thickened. In
the macerated bone "the surface is covered with irregular,
stalactite-like processes or foliaceous masses, which, to a certain
extent, follow the line of attachment of the interosseous membrane and
of the intermuscular septa" (Cathcart) (Fig. 19). When the whole
thickness of the soft tissues is destroyed by the ulcerative process,
the area of bone that comes to form the base of the ulcer projects as a
flat, porous node, which in its turn may be eroded. These changes as
seen in the macerated specimen are often mistaken for disease
originating in the bone.

[Illustration: FIG. 19.--Tibia and Fibula, showing changes due to
chronic ulcer of leg.]

The _irritable condition_ is met with in ulcers which occur, as a rule,
just above the external malleolus in women of neurotic temperament. They
are small in size and have prominent granulations, and by the aid of a
probe points of excessive tenderness may be discovered. These, Hilton
believed, correspond to exposed nerve filaments.

_Ulcers which are spreading_ may be met with in one of several
conditions.

_The Inflamed Condition._--Any ulcer may become acutely inflamed from
the access of fresh organisms, aided by mechanical irritation from
trauma, ill-fitting splints or bandages, or want of rest, or from
chemical irritants, such as strong antiseptics. The best clinical
example of an inflamed ulcer is the venereal soft sore. The base of the
ulcer becomes red and angry-looking, the granulations disappear, and a
copious discharge of thin yellow pus, mixed with blood, escapes. Sloughs
of granulation tissue or of connective tissue may form. The edges become
red, ragged, and everted, and the ulcer increases in size by spreading
into the inflamed and oedematous surrounding tissues. Such ulcers are
frequently multiple. Pain is a constant symptom, and is often severe,
and there is usually some constitutional disturbance.

The _phagedaenic condition_ is the result of an ulcer being infected with
specially virulent bacteria. It occurs in syphilitic ulcers, and rapidly
leads to a widespread destruction of tissue. It is also met with in the
throat in some cases of scarlet fever, and may give rise to fatal
haemorrhage by ulcerating into large blood vessels. All the local and
constitutional signs of a severe septic infection are present.

#Treatment of Ulcers.#--An ulcer is not only an immediate cause of
suffering to the patient, crippling and incapacitating him for his work,
but is a distinct and constant menace to his health: the prolonged
discharge reduces his strength; the open sore is a possible source of
infection by the organisms of suppuration, erysipelas, or other specific
diseases; phlebitis, with formation of septic emboli, leading to pyaemia,
is liable to occur; and in old persons it is not uncommon for ulcers of
long standing to become the seat of cancer. In addition, the offensive
odour of many ulcers renders the patient a source of annoyance and
discomfort to others. The primary object of treatment in any ulcer is to
bring it into the condition of a healing sore. When this has been
effected, nature will do the rest, provided extraneous sources of
irritation are excluded.

Steps must be taken to facilitate the venous return from the ulcerated
part, and to ensure that a sufficient supply of fresh, healthy blood
reaches it. The septic element must be eliminated by disinfecting the
ulcer and its surroundings, and any other sources of irritation must be
removed.

If the patient's health is below par, good nourishing food, tonics, and
general hygienic treatment are indicated.

_Management of a Healing Sore._--Perhaps the best dressing for a healing
sore is a layer of Lister's perforated oiled-silk protective, which is
made to cover the raw surface and the skin for about a quarter of an
inch beyond the margins of the sore. Over this three or four thicknesses
of sterilised gauze, wrung out of eusol, creolin, or sterilised water,
are applied, and covered by a pad of absorbent wool. As far as possible
the part should be kept at rest, and the position should be adjusted so
as to favour the circulation in the affected area.

The dressing may be renewed at intervals, and care must be taken to
avoid any rough handling of the sore. Any discharge that lies on the
surface should be removed by a gentle stream of lotion rather than by
wiping. The area round the sore should be cleansed before the fresh
dressing is applied.

In some cases, healing goes on more rapidly under a dressing of weak
boracic ointment (one-quarter the strength of the pharmacopoeial
preparation). The growth of epithelium may be stimulated by a 6 to 8 per
cent. ointment of scarlet-red.

Dusting powders and poultice dressings are best avoided in the treatment
of healing sores.

In extensive ulcers resulting from recent burns, if the granulations are
healthy and aseptic, skin-grafts may safely be placed on them directly.
If, however, their asepticity cannot be relied upon, it is necessary to
scrape away the superficial layer of the granulations, the young fibrous
tissue underneath being conserved, as it is sufficiently vascular to
nourish the grafts placed on it.

#Treatment of Special Varieties of Ulcers.#--Before beginning to treat a
given ulcer, two questions have to be answered--first, What are the
causative conditions present? and second, In what condition do I find
the ulcer?--in other words, In what particulars does it differ from a
healthy healing sore?

If the cause is a local one, it must be removed; if a constitutional
one, means must be taken to counteract it. This done, the condition of
the ulcer must be so modified as to bring it into the state of a healing
sore, after which it will be managed on the lines already laid down.

#Treatment in relation to the Cause of the Ulcer.#--_Traumatic
Group._--The _prophylaxis_ of these ulcers consists in excluding
bacteria, by cleansing crushed or bruised parts, and applying sterilised
dressings and properly adjusted splints. If there is reason to fear that
the disinfection has not been complete, a Bier's constricting bandage
should be applied for some hours each day. These measures will often
prevent a grossly injured portion of skin dying, and will ensure
asepticity should it do so. In the event of the skin giving way, the
same form of dressing should be continued till the slough has separated
and a healthy granulating surface is formed. The protective dressing
appropriate to a healing sore is then substituted. _Pressure sores_ are
treated on the same lines.

The treatment of ulcers caused by _burns and scalds_ will be described
later.

In _ulcers of the leg due to interference with the venous return_, the
primary indication is to elevate the limb in order to facilitate the
flow of the blood in the veins, and so admit of fresh blood reaching the
part. The limb may be placed on pillows, or the foot of the bed raised
on blocks, so that the ulcer lies on a higher level than the heart.
Should varicose veins be present, the question of operative treatment
must be considered.

When an _imperfect nerve supply_ is the main factor underlying ulcer
formation, prophylaxis is the chief consideration. In patients suffering
from spinal injuries or diseases, cerebral paralysis, or affections of
the peripheral nerves, all sources of irritation, such as ill-fitting
splints, tight bandages, moist applications, and hot bottles, should be
avoided. Any part liable to pressure, from the position of the patient
or otherwise, must be carefully protected by pads of wool, air-cushions,
or water-bags, and must be kept absolutely dry. The skin should be
hardened by daily applications of methylated spirit.

Should an ulcer form in spite of these precautions, the mildest
antiseptics must be employed for bathing and dressing it, and as far as
possible all dressings should be dry.

The _perforating ulcer_ of the foot calls for special treatment. To
avoid pressure on the sole of the foot, the patient must be confined to
bed. As the main local obstacle to healing is the down-growth of
epithelium along the sides of the ulcer, this must be removed by the
knife or sharp spoon. The base also should be excised, and any bone
which may have become involved should be gouged away, so as to leave a
healthy and vascular surface. The cavity thus formed is stuffed with
bismuth or iodoform gauze and encouraged to heal from the bottom. As the
parts are insensitive an anaesthetic is not required. After the ulcer has
healed, the patient should wear in his boot a thick felt sole with a
hole cut out opposite the situation of the cicatrix. When a joint has
been opened into, the difficulty of thoroughly getting rid of all
unhealthy and infected granulations is so great that amputation may be
advisable, but it is to be remembered that ulceration may recur in the
stump if pressure is put upon it. The treatment of any nervous disease
or glycosuria which may coexist is, of course, indicated.

Exposure of the plantar nerves by an incision behind the medial
malleolus, and subjecting them to forcible stretching, has been employed
by Chipault and others in the treatment of perforating ulcers of the
foot.

The ulcer that forms in relation to callosities on the sole of the foot
is treated by paring away all the thickened skin, after softening it
with soda fomentations, removing the unhealthy granulations, and
applying stimulating dressings.

_Treatment of Ulcers due to Constitutional Causes._--When ulcers are
associated with such diseases as tuberculosis, syphilis, diabetes,
Bright's disease, scurvy, or gout, these must receive appropriate
treatment.

The local treatment of the _tuberculous ulcer_ calls for special
mention. If the ulcer is of limited extent and situated on an exposed
part of the body, the most satisfactory method is complete removal, by
means of the knife, scissors, or sharp spoon, of the ulcerated surface
and of all the infected area around it, so as to leave a healthy surface
from which granulations may spring up. Should the raw surface left be
likely to result in an unsightly scar or in cicatricial contraction,
skin-grafting should be employed.

For extensive ulcers on the limbs, the chest wall, or on other covered
parts, or when operative treatment is contra-indicated, the use of
tuberculin and exposure to the Rontgen rays have proved beneficial. The
induction of passive hyperaemia, by Bier's or by Klapp's apparatus,
should also be used, either alone or supplementary to other measures.

No ulcerative process responds so readily to medicinal treatment as the
_syphilitic ulcer_ does to the intra-venous administration of arsenical
preparations of the "606" or "914" groups or to full doses of iodide of
potassium and mercury, and the local application of black wash. When the
ulceration has lasted for a long time, however, and is widespread and
deep, the duration of treatment is materially shortened by a thorough
scraping with the sharp spoon.

#Treatment in relation to the Condition of the Ulcer.#--_Ulcers in a
weak condition._--If the weak condition of the ulcer is due to anaemia
or kidney disease, these affections must first be treated. Locally, the
imperfect granulations should be scraped away, and some stimulating
agent applied to the raw surface to promote the growth of healthy
granulations. For this purpose the sore may be covered with gauze
smeared with a 6 to 8 per cent. ointment of scarlet-red, the surrounding
parts being protected from the irritant action of the scarlet-red by a
layer of vaseline. A dressing of gauze moistened with eusol or of
boracic lint wrung out of red lotion (2 grains of sulphate of zinc, and
10 minims of compound tincture of lavender, to an ounce of water), and
covered with a layer of gutta-percha tissue, is also useful.

When the condition has resulted from the prolonged use of moist
dressings, these must be stopped, the redundant granulations clipped
away with scissors, the surface rubbed with silver nitrate or sulphate
of copper (blue-stone), and dry dressings applied.

When the ulcer has assumed the characters of a healing sore, skin-grafts
may be applied to hasten cicatrisation.

_Ulcers in a callous condition_ call for treatment in three
directions--(1) The infective element must be eliminated. When the ulcer
is foul, relays of charcoal poultices (three parts of linseed meal to
one of charcoal), maintained for thirty-six to forty-eight hours, are
useful as a preliminary step. The base of the ulcer and the thickened
edges should then be freely scraped with a sharp spoon, and the
resulting raw surface sponged over with undiluted carbolic acid or
iodine, after which an antiseptic dressing is applied, and changed daily
till healthy granulations appear. (2) The venous return must be
facilitated by elevation of the limb and massage. (3) The induration of
the surrounding parts must be got rid of before contraction of the sore
is possible. For this purpose the free application of blisters, as first
recommended by Syme, leaves little to be desired. Liquor epispasticus
painted over the parts, or a large fly-blister (emplastrum cantharidis)
applied all round the ulcer, speedily disperses the inflammatory
products which cause the induration. The use of elastic pressure or of
strapping, of hot-air baths, or the making of multiple incisions in the
skin around the ulcer, fulfils the same object.

As soon as the ulcer assumes the characters of a healing sore, it should
be covered with skin-grafts, which furnish a much better cicatrix than
that which forms when the ulcer is allowed to heal without such aid.

A more radical method of treatment consists in excising the whole
ulcer, including its edges and about a quarter of an inch of the
surrounding tissue, as well as the underlying fibrous tissue, and
grafting the raw surface.

_Ambulatory Treatment._--When the circumstances of the patient forbid
his lying up in bed, the healing of the ulcer is much delayed. He should
be instructed to take every possible opportunity of placing the limb in
an elevated position, and must constantly wear a firm bandage of
_elastic webbing_. This webbing is porous and admits of evaporation of
the skin and wound secretions--an advantage it has over Martin's rubber
bandage. The bandage should extend from the toes to well above the knee,
and should always be applied while the patient is in the recumbent
position with the leg elevated, preferably before getting out of bed in
the morning. Additional support is given to the veins if the bandage is
applied as a figure of eight.

We have found the following method satisfactory in out-patient
practice. The patient lying on a couch, the limb is raised about
eighteen inches and kept in this position for five minutes--till the
excess of blood has left it. With the limb still raised, the ulcer with
the surrounding skin is covered with a layer, about half an inch thick,
of finely powdered boracic acid, and the leg, from foot to knee,
excluding the sole, is enveloped in a thick layer of wood-wool wadding.
This is held in position by ordinary cotton bandages, painted over with
liquid starch; while the starch is drying the limb is kept elevated.
With this appliance the patient may continue to work, and the dressing
does not require to be changed oftener than once in three or four weeks
(W. G. Richardson).

When an ulcer becomes acutely _inflamed_ as a result of superadded
infection, antiseptic measures are employed to overcome the infection,
and ichthyol or other soothing applications may be used to allay the
pain.

The _phagedaenic ulcer_ calls for more energetic means of disinfection;
the whole of the affected surface is touched with the actual cautery at
a white heat, or is painted with pure carbolic acid. Relays of charcoal
poultices are then applied until the spread of the disease is arrested.

For the _irritable ulcer_ the most satisfactory treatment is complete
excision and subsequent skin-grafting.




CHAPTER VI

GANGRENE


Definition--Types: _Dry_, _Moist_--Varieties--Gangrene primarily due to
    interference with circulation: _Senile gangrene_; _Embolic
    gangrene_; _Gangrene following ligation of arteries_; _Gangrene
    from mechanical causes_; _Gangrene from heat, chemical agents, and
    cold_; _Diabetic gangrene_; _Gangrene associated with spasm of
    blood vessels_; _Raynaud's disease_; _Angio-sclerotic gangrene_;
    _Gangrene from ergot_. Bacterial varieties of gangrene.
    _Pathology_--clinical varieties--_Acute infective gangrene_;
    _Malignant oedema_; _Acute emphysematous_ or _gas gangrene_;
    _Cancrum oris_, _etc_. Bed-sores: _Acute_; _chronic_.

Gangrene or mortification is the process by which a portion of tissue
dies _en masse_, as distinguished from the molecular or cellular death
which constitutes ulceration. The dead portion is known as a _slough_.

In this chapter we shall confine our attention to the process as it
affects the limbs and superficial parts, leaving gangrene of the viscera
to be described in regional surgery.


TYPES OF GANGRENE

Two distinct types of gangrene are met with, which, from their most
obvious point of difference, are known respectively as _dry_ and
_moist_, and there are several clinical varieties of each type.

Speaking generally, it may be said that dry gangrene is essentially due
to a simple _interference with the blood supply_ of a part; while the
main factor in the production of moist gangrene is _bacterial
infection_.

The cardinal signs of gangrene are: change in the colour of the part,
coldness, loss of sensation and motor power, and, lastly, loss of
pulsation in the arteries.

#Dry Gangrene# or #Mummification# is a comparatively slow form of local
death due, as a rule, to a diminution in the arterial blood supply of
the affected part, resulting from such causes as the gradual narrowing
of the lumen of the arteries by disease of their coats, or the blocking
of the main vessel by an embolus.

As the fluids in the tissues are lost by evaporation the part becomes
dry and shrivelled, and as the skin is usually intact, infection does
not take place, or if it does, the want of moisture renders the part an
unsuitable soil, and the organisms do not readily find a footing. Any
spread of the process that may take place is chiefly influenced by the
anatomical distribution of the blocked arteries, and is arrested as soon
as it reaches an area rich in anastomotic vessels. The dead portion is
then cast off, the irritation resulting from the contact of the dead
with the still living tissue inducing the formation of granulations on
the proximal side of the junction, and these by slowly eating into the
dead portion produce a furrow--the _line of demarcation_--which
gradually deepens until complete separation is effected. As the muscles
and bones have a richer blood supply than the integument, the death of
skin and subcutaneous tissues extends higher than that of muscles and
bone, with the result that the stump left after spontaneous separation
is conical, the end of the bone projecting beyond the soft parts.

_Clinical Features._--The part undergoing mortification becomes colder
than normal, the temperature falling to that of the surrounding
atmosphere. In many instances, but not in all, the onset of the process
is accompanied by severe neuralgic pain in the part, probably due to
anaemia of the nerves, to neuritis, or to the irritation of the exposed
axis cylinders by the dead and dying tissues around them. This pain soon
ceases and gives place to a complete loss of sensation. The dead part
becomes dry, horny, shrivelled, and semi-transparent--at first of a dark
brown, but finally of a black colour, from the dissemination of blood
pigment throughout the tissues. There is no putrefaction, and therefore
no putrid odour; and the condition being non-infective, there is not
necessarily any constitutional disturbance. In itself, therefore, dry
gangrene does not involve immediate risk to life; the danger lies in the
fact that the breach of surface at the line of demarcation furnishes a
possible means of entrance for bacteria, which may lead to infective
complications.

#Moist Gangrene# is an acute process, the dead part retaining its fluids
and so affording a favourable soil for the development of bacteria. The
action of the organisms and their toxins on the adjacent tissues leads
to a rapid and wide spread of the process. The skin becomes moist and
macerated, and bullae, containing dark-coloured fluid or gases, form
under the epidermis. The putrefactive gases evolved cause the skin to
become emphysematous and crepitant and produce an offensive odour. The
tissues assume a greenish-black colour from the formation in them of a
sulphide of iron resulting from decomposition of the blood pigment.
Under certain conditions the dead part may undergo changes resembling
more closely those of ordinary post-mortem decomposition. Owing to its
nature the spread of the gangrene is seldom arrested by the natural
protective processes, and it usually continues until the condition
proves fatal from the absorption of toxins into the circulation.

The _clinical features_ vary in the different varieties of moist
gangrene, but the local results of bacterial action and the
constitutional disturbance associated with toxin absorption are present
in all; the prognosis therefore is grave in the extreme.

From what has been said, it will be gathered that in dry gangrene there
is no urgent call for operation to save the patient's life, the primary
indication being to prevent the access of bacteria to the dead part, and
especially to the surface exposed at the line of demarcation. In moist
gangrene, on the contrary, organisms having already obtained a footing,
immediate removal of the dead and dying tissues, as a rule, offers the
only hope of saving life.


VARIETIES OF GANGRENE

#Varieties of Gangrene essentially due to Interference with the
Circulation#

While the varieties of gangrene included in this group depend primarily
on interference with the circulation, it is to be borne in mind that the
clinical course of the affection may be profoundly influenced by
superadded infection with micro-organisms. Although the bacteria do not
play the most important part in producing tissue necrosis, their

subsequent introduction is an accident of such importance that it may
change the whole aspect of affairs and convert a dry form of gangrene
into one of the moist type. Moreover, the low state of vitality of the
tissues, and the extreme difficulty of securing and maintaining asepsis,
make it a sequel of great frequency.

#Senile Gangrene.#--Senile gangrene is the commonest example of local
death produced by a _gradual_ diminution in the quantity of blood
passing through the parts, as a result of arterio-sclerosis or other
chronic disease of the arteries leading to diminution of their calibre.
It is the most characteristic example of the dry type of gangrene. As
the term indicates, it occurs in old persons, but the patient's age is
to be reckoned by the condition of his arteries rather than by the
number of his years. Thus the vessels of a comparatively young man who
has suffered from syphilis and been addicted to alcohol are more liable
to atheromatous degeneration leading to this form of gangrene than are
those of a much older man who has lived a regular and abstemious life.
This form of gangrene is much more common in men than in women. While it
usually attacks only one foot, it is not uncommon for the other foot to
be affected after an interval, and in some cases it is bilateral from
the outset. It must clearly be understood that any form of gangrene may

occur in old persons, the term senile being here restricted to that
variety which results from arterio-sclerosis.

[Illustration: FIG. 20.--Senile Gangrene of the Foot, showing line of
demarcation.]

_Clinical Features._--The commonest seat of the disease is in the toes,
especially the great toe, whence it spreads up the foot to the heel, or
even to the leg (Fig. 20). There is often a history of some slight
injury preceding its onset. The vitality of the tissues is so low that
the balance between life and death may be turned by the most trivial
injury, such as a cut while paring a toe-nail or a corn, a blister
caused by an ill-fitting shoe or the contact of a hot-bottle. In some
cases the actual gangrene is determined by thrombosis of the popliteal
or tibial arteries, which are already narrowed by obliterating
endarteritis.

It is common to find that the patient has been troubled for a long time
before the onset of definite signs of gangrene, with cold feet, with
tingling and loss of feeling, or a peculiar sensation as if walking on
cotton wool.

The first evidence of the death of the part varies in different cases.
Sometimes a dark-blue spot appears on the medial side of the great toe
and gradually increases in size; or a blister containing blood-stained
fluid may form. Streaks or patches of dark-blue mottling appear higher
up on the foot or leg. In other cases a small sore surrounded by a
congested areola forms in relation to the nail and refuses to heal. Such
sores on the toes of old persons are always to be looked upon with
suspicion and treated with the greatest care; and the urine should be
examined for sugar. There is often severe, deep-seated pain of a
neuralgic character, with cramps in the limb, and these may persist long
after a line of demarcation has formed. The dying part loses sensibility
to touch and becomes cold and shrivelled.

All the physical appearances and clinical symptoms associated with dry
gangrene supervene, and the dead portion is delimited by a line of
demarcation. If this forms slowly and irregularly it indicates a very
unsatisfactory condition of the circulation; while, if it forms quickly
and decidedly, the presumption is that the circulation in the parts
above is fairly good. The separation of the dead part is always attended
with the risk of infection taking place, and should this occur, the
temperature rises and other evidences of toxaemia appear.

_Prophylaxis._--The toes and feet of old people, the condition of whose
circulation predisposes them to gangrene, should be protected from
slight injuries such as may be received while paring nails, cutting
corns, or wearing ill-fitting boots. The patient should also be warned
of the risk of exposure to cold, the use of hot-bottles, and of placing
the feet near a fire. Attempts have been made to improve the peripheral
circulation by establishing an anastomosis between the main artery of a
limb and its companion vein, so that arterial blood may reach the
peripheral capillaries--reversal of the circulation--but the clinical
results have proved disappointing. (See _Op. Surg._, p. 29.)

_Treatment._--When there is evidence that gangrene has occurred, the
first indication is to prevent infection by purifying the part, and
after careful drying to wrap it in a thick layer of absorbent and
antiseptic wool, retained in place by a loosely applied bandage. A
slight degree of elevation of the limb is an advantage, but it must not
be sufficient to diminish the amount of blood entering the part.
Hot-bottles are to be used with the utmost caution. As absolute dryness
is essential, ointments or other greasy dressings are to be avoided, as
they tend to prevent evaporation from the skin. Opium should be given
freely to alleviate pain. Stimulation is to be avoided, and the patient
should be carefully dieted.

When the gangrene is limited to the toes in old and feeble patients,
some surgeons advocate the expectant method of treatment, waiting for a
line of demarcation to form and allowing the dead part to be separated.
This takes place so slowly, however, that it necessitates the patient
being laid up for many weeks, or even months; and we agree with the
majority in advising early amputation.

In this connection it is worthy of note that there are certain points at
which gangrene naturally tends to become arrested--namely, at the highly
vascular areas in the neighbourhood of joints. Thus gangrene of the
great toe often stops when it reaches the metatarso-phalangeal joint; or
if it trespasses this limit it may be arrested either at the
tarso-metatarsal or at the ankle joint. If these be passed, it usually
spreads up the leg to just below the knee before signs of arrestment
appear. Further, it is seen from pathological specimens that the spread
is greater on the dorsal than on the plantar aspect, and that the death
of skin and subcutaneous tissues extends higher than that of bone and
muscle.

These facts furnish us with indications as to the seat and method of
amputation. Experience has proved that in senile gangrene of the lower
extremity the most reliable and satisfactory results are obtained by
amputating in the region of the knee, care being taken to perform the
operation so as to leave the prepatellar anastomosis intact by retaining
the patella in the anterior flap. The most satisfactory operation in
these cases is Gritti's supra-condylar amputation. Haemorrhage is easily
controlled by digital pressure, and the use of a tourniquet should be
dispensed with, as the constriction of the limb is liable to interfere
with the vitality of the flaps.

When the tibial vessels can be felt pulsating at the ankle it may be
justifiable, if the patient urgently desires it, to amputate lower than
the knee; but there is considerable risk of gangrene recurring in the
stump and necessitating a second operation.

That amputation for senile gangrene performed between the ankle and the
knee seldom succeeds, is explained by the fact that the vascular
obstruction is usually in the upper part of the posterior tibial artery,
and the operation is therefore performed through tissues with an
inadequate blood supply. It is not uncommon, indeed, on amputating above
the knee, to find even the popliteal artery plugged by a clot. This
should be removed at the amputation by squeezing the vessel from above
downward by a "milking" movement, or by "catheterising the artery" with
the aid of a cannula with a terminal aperture.

It is to be borne in mind that the object of amputation in these cases
is merely to remove the gangrenous part, and so relieve the patient of
the discomfort and the risks from infection which its presence involves.
While it is true that in many of these patients the operation is borne
remarkably well, it must be borne in mind that those who suffer from
senile gangrene are of necessity bad lives, and a guarded opinion should
be expressed as to the prospects of survival. The possibility of the
disease developing in the other limb has already been referred to.

[Illustration: FIG. 21.--Embolic Gangrene of Hand and Arm.]

#Embolic Gangrene# (Fig. 21).--This is the most typical form of gangrene
resulting from the _sudden_ occlusion of the main artery of a part,
whether by the impaction of an embolus or the formation of a thrombus in
its lumen, when the collateral circulation is not sufficiently free to
maintain the vitality of the tissues.

There is sudden pain at the site of impaction of the embolus, and the
pulses beyond are lost. The limb becomes cold, numb, insensitive, and
powerless. It is often pale at first--hence the term "white gangrene"
sometimes applicable to the early appearances, which closely resemble
those presented by the limb of a corpse.

If the part is aseptic it shrivels, and presents the ordinary features
of dry gangrene. It is liable, however, especially in the lower
extremity and when the veins also are obstructed, to become infected and
to assume the characters of the moist type.

The extent of the gangrene depends upon the site of impaction of the
embolus, thus if the _abdominal aorta_ becomes suddenly occluded by an
embolus at its bifurcation, the obstruction of the iliacs and femorals
induces symmetrical gangrene of both extremities as high as the inguinal
ligaments. When gangrene follows occlusion of the _external iliac_ or of
the _femoral artery_ above the origin of its deep branch, the death of
the limb extends as high as the middle or upper third of the thigh. When
the _femoral_ below the origin of its deep branch or the _popliteal
artery_ is obstructed, the veins remaining pervious, the anastomosis
through the profunda is sufficient to maintain the vascular supply, and
gangrene does not necessarily follow. The rupture of a popliteal
aneurysm, however, by compressing the vein and the articular branches,
usually determines gangrene. When an embolus becomes impacted at the
_bifurcation of the popliteal_, if gangrene ensues it usually spreads
well up the leg.

When the _axillary artery_ is the seat of embolic impaction, and
gangrene ensues, the process usually reaches the middle of the upper
arm. Gangrene following the blocking of the _brachial_ at its
bifurcation usually extends as far as the junction of the lower and
middle thirds of the forearm.

Gangrene due to thrombosis or embolism is sometimes met with in patients
recovering from typhus, typhoid, or other fevers, such as that
associated with child-bed. It occurs in peripheral parts, such as the
toes, fingers, nose, or ears.

_Treatment._--The general treatment of embolic gangrene is the same as
that for the senile form. Success has followed opening the artery and
removing the embolus. The artery is exposed at the seat of impaction
and, having been clamped above and below, a longitudinal opening is made
and the clot carefully extracted with the aid of forceps; it is
sometimes unexpectedly long (one recorded from the femoral artery
measured nearly 34 inches); the wound in the artery is then sewn up with
fine silk soaked in paraffin. When amputation is indicated, it must be
performed sufficiently high to ensure a free vascular supply to the
flaps.

#Gangrene following Ligation of Arteries.#--After the ligation of an
artery in its continuity--for example, in the treatment of aneurysm--the
limb may for some days remain in a condition verging on gangrene, the
distal parts being cold, devoid of sensation, and powerless. As the
collateral circulation is established, the vitality of the tissues is
gradually restored and these symptoms pass off. In some cases,
however,--and especially in the lower extremity--gangrene ensues and
presents the same characters as those resulting from embolism. It tends
to be of the dry type. The occlusion of the vein as well as the artery
is not found to increase the risk of gangrene.

#Gangrene from Mechanical Constriction of the Vessels of the part.#--The
application of a bandage or plaster-of-Paris case too tightly, or of a
tourniquet for too long a time, has been known to lead to death of the
part beyond; but such cases are rare, as are also those due to the
pressure of a fractured bone or of a tumour on a large artery or vein.
When gangrene occurs from such causes, it tends to be of the moist type.

Much commoner is it to meet with localised areas of necrosis due to the
excessive _pressure of splints_ over bony prominences, such as the
lateral malleolus, the medial condyle of the humerus, or femur, or over
the dorsum of the foot. This is especially liable to occur when the
nutrition of the skin is depressed by any interference with its
nerve-supply, such as follows injuries to the spine or peripheral
nerves, disease of the brain, or acute anterior poliomyelitis. When the
splint is removed the skin pressed upon is found to be of a pale yellow
or grey colour, and is surrounded by a ring of hyperaemia. If protected
from infection, the clinical course is that of dry gangrene.

Bed-sores, which are closely allied to pressure sores, will be described
at the end of this chapter.

When a localised portion of tissue, for example, a piece of skin, is so
severely _crushed_ or _bruised_ that its blood vessels are occluded and
its structure destroyed, it dies, and, if not infected with bacteria,
dries up, and the shrivelled brown skin is slowly separated by the
growth of granulation tissue beneath and around it.

Fingers, toes, or even considerable portions of limbs may in the same
way be suddenly destroyed by severe trauma, and undergo mummification.
If organisms gain access, typical moist gangrene may ensue, or changes
similar to those of ordinary post-mortem decomposition may take place.

_Treatment._--The first indication is to exclude bacteria by purifying
the damaged part and its surroundings, and applying dry, non-irritating
dressings.

When these measures are successful, dry gangrene ensues. The raw surface
left after the separation of the dead skin may be allowed to heal by
granulation, or may be covered by skin-grafts. In the case of a finger
or a limb it is not necessary to wait until spontaneous separation takes
place, as this is often a slow process. When a well-marked line of
demarcation has formed, amputation may be performed just sufficiently
far above it to enable suitable flaps to be made.

The end of a stump, after spontaneous separation of the gangrenous
portion, requires to be trimmed, sufficient bone being removed to permit
of the soft parts coming together.

If moist gangrene supervenes, amputation must be performed without
delay, and at a higher level.

#Gangrene from Heat, Chemical Agents, and Cold.#--Severe #burns# and
#scalds# may be followed by necrosis of tissue. So long as the parts are
kept absolutely dry--as, for example, by the picric acid method of
treatment--the grossly damaged portions of tissue undergo dry gangrene;
but when wet or oily dressings are applied and organisms gain access,
moist gangrene follows.

Strong #chemical agents#, such as caustic potash, nitric or sulphuric
acid, may also induce local tissue necrosis, the general appearances of
the lesions produced being like those of severe burns. The resulting
sloughs are slow to separate, and leave deep punched-out cavities which
are long of healing.

#Carbolic Gangrene.#--Carbolic acid, even in comparatively weak
solution, is liable to induce dry gangrene when applied as a fomentation
to a finger, especially in women and children. Thrombosis occurs in the
blood vessels of the part, which at first is pale and soft, but later
becomes dark and leathery. On account of the anaesthetic action of
carbolic acid, the onset of the process is painless, and the patient
does not realise his danger. A line of demarcation soon forms, but the
dead part separates very slowly.

#Gangrene from Frost-bite.#--It is difficult to draw the line between
the third degree of chilblain and the milder forms of true frost-bite;
the difference is merely one of degree. Frost-bite affects chiefly the
toes and fingers--especially the great toe and the little finger--the
ears, and the nose. In this country it is seldom seen except in members
of the tramp class, who, in addition to being exposed to cold by
sleeping in the open air, are ill-fed and generally debilitated. The
condition usually manifests itself after the parts, having been
subjected to extreme cold, are brought into warm surroundings. The first
symptom is numbness in the part, followed by a sense of weight,
tingling, and finally by complete loss of sensation. The part attacked
becomes white and bleached-looking, feels icy cold, and is insensitive
to touch. Either immediately, or, it may be, not for several days, it
becomes discoloured and swollen, and finally contracts and shrivels.
Above the dead area the limb may be the seat of excruciating pain. The
dead portion is cast off, as in other forms of dry gangrene, by the
formation of a line of demarcation.

To prevent the occurrence of gangrene from frost-bite it is necessary to
avoid the sudden application of heat. The patient should be placed in a
cold room, and the part rubbed with snow, or put in a cold bath, and
have light friction applied to it. As the circulation is restored the
general surroundings and the local applications are gradually made
warmer. Elevation of the part, wrapping it in cotton wool, and removal
to a warmer room, are then permissible, and stimulants and warm drinks
may be given with caution. When by these means the occurrence of
gangrene is averted, recovery ensues, its onset being indicated by the
white parts assuming a livid red hue and becoming the seat of an acute
burning sensation.

A condition known as _Trench feet_ was widely prevalent amongst the
troops in France during the European War. Although allied to frost-bite,
cold appears to play a less important part in its causation than
humidity and constriction of the limbs producing ischaemia of the feet.
Changes were found in the endothelium of the blood vessels, the axis
cylinders of nerves, and the muscles. The condition does not occur in
civil life.

#Diabetic Gangrene.#--This form of gangrene is prone to occur in persons
over fifty years of age who suffer from glycosuria. The arteries are
often markedly diseased. In some cases the existence of the glycosuria
is unsuspected before the onset of the gangrene, and it is only on
examining the urine that the cause of the condition is discovered. The
gangrenous process seldom begins as suddenly as that associated with
embolism, and, like senile gangrene, which it may closely simulate in
its early stages, it not infrequently begins after a slight injury to
one of the toes. It but rarely, however, assumes the dry, shrivelling
type, as a rule being attended with swelling, oedema, and dusky redness
of the foot, and severe pain. According to Paget, the dead part remains
warm longer than in other forms of senile gangrene; there is a greater
tendency for patches of skin at some distance from the primary seat of
disease to become gangrenous, and for the death of tissue to extend
upwards in the subcutaneous planes, leaving the overlying skin
unaffected. The low vitality of the tissues favours the growth of
bacteria, and if these gain access, the gangrene assumes the characters
of the moist type and spreads rapidly.

The rules for amputation are the same as those governing the treatment
of senile gangrene, the level at which the limb is removed depending
upon whether the gangrene is of the dry or moist type. The general
treatment for diabetes must, of course, be employed whether amputation
is performed or not. Paget recommended that the dietetic treatment
should not be so rigid as in uncomplicated diabetes, and that opium
should be given freely.

The _prognosis_ even after amputation is unfavourable. In many cases the
patient dies with symptoms of diabetic coma within a few days of the
operation; or, if he survives this, he may eventually succumb to
diabetes. In others there is sloughing of the flaps and death results
from toxaemia. Occasionally the other limb becomes gangrenous. On the
other hand, the glycosuria may diminish or may even disappear after
amputation.

#Gangrene associated with Spasm of Blood Vessels.#--#Raynaud's Disease#,
or symmetrical gangrene, is supposed to be due to spasm of the
arterioles, resulting from peripheral neuritis. It occurs oftenest in
women, between the ages of eighteen and thirty, who are the subjects of
uterine disorders, anaemia, or chlorosis. Cold is an aggravating factor,
as the disease is commonest during the winter months. The digits of both
hands or the toes of both feet are simultaneously attacked, and the
disease seldom spreads beyond the phalanges or deeper than the skin.

The first evidence is that the fingers become cold, white, and
insensitive to touch and pain. These attacks of _local syncope_ recur at
varying intervals for months or even years. They last for a few minutes
or even for some hours, and as they pass off the parts become hyperaemic
and painful.

A more advanced stage of the disease is known as _local asphyxia_. The
circulation through the fingers becomes exceedingly sluggish, and the
parts assume a dull, livid hue. There is swelling and burning or
shooting pain. This may pass off in a few days, or may increase in
severity, with the formation of bullae, and end in dry gangrene. As a
rule, the slough which forms is comparatively small and superficial,
but it may take some months to separate. The condition tends to recur in
successive winters.

The _treatment_ consists in remedying any nervous or uterine disorder
that may be present, keeping the parts warm by wrapping them in cotton
wool, and in the use of hot-air or electric baths, the parts being
immersed in water through which a constant current is passed. When
gangrene occurs, it is treated on the same lines as other forms of dry
gangrene, but if amputation is called for it is only with a view to
removing the dead part.

#Angio-sclerotic Gangrene.#--A form of gangrene due to _angio-sclerosis_
is occasionally met with in young persons, even in children. It bears
certain analogies to Raynaud's disease in that spasm of the vessels
plays a part in determining the local death.

The main arteries are narrowed by hyperplastic endarteritis followed by
thrombosis, and similar changes are found in the veins. The condition is
usually met with in the feet, but the upper extremity may be affected,
and is attended with very severe pain, rendering sleep impossible.

The patient is liable to sudden attacks of numbness, tingling and
weakness of the limbs which pass off with rest--_intermittent
claudication_. During these attacks the large arteries--femoral,
brachial, and subclavian--can be felt as firm cords, while pulsation is
lost in the peripheral vessels. Gangrene eventually ensues, is attended
with great pain and runs a slow course. It is treated on the same lines
as Raynaud's disease.

#Gangrene from Ergot.#--Gangrene may occur from interference with blood
supply, the result of tetanic contraction of the minute vessels, such as
results in ill-nourished persons who eat large quantities of coarse rye
bread contaminated with the _claviceps purpurea_ and containing the
ergot of rye. It has also occurred in the fingers of patients who have
taken ergot medicinally over long periods. The gangrene, which attacks
the toes, fingers, ears, or nose, is preceded by formication, numbness,
and pains in the parts to be affected, and is of the dry variety.

In this country it is usually met with in sailors off foreign ships,
whose dietary largely consists of rye bread. Trivial injuries may be the
starting-point, the anaesthesia produced by the ergotin preventing the
patient taking notice of them. Alcoholism is a potent predisposing
cause.

As it is impossible to predict how far the process will spread, it is
advisable to wait for the formation of a line of demarcation before
operating, and then to amputate immediately above the dead part.


BACTERIAL VARIETIES OF GANGRENE

The acute bacillary forms of gangrene all assume the moist type from the
first, and, spreading rapidly, result in extensive necrosis of tissue,
and often end fatally.

The infection is usually a mixed one in which anaerobic bacteria
predominate. The anaerobe most constantly present is the _bacillus
aerogenes capsulatus_, usually in association with other anaerobes, and
sometimes with pyogenic diplo- and streptococci. According to the mode of
action of the associated organisms and the combined effects of their
toxins on the tissues, the gangrenous process presents different
pathological and clinical features. Some combinations, for example,
result in a rapidly spreading cellulitis with early necrosis of
connective tissue accompanied by thrombosis throughout the capillary and
venous circulation of the parts implicated; other combinations cause
great oedema of the part, and others again lead to the formation of gases
in the tissues, particularly in the muscles.

These different effects do not appear to be due to a specific action of
any one of the organisms present, but to the combined effect of a
particular group living in symbiosis.

According as the cellulitic, the oedematous, or the gaseous
characteristics predominate, the clinical varieties of bacillary
gangrene may be separately described, but it must be clearly understood
that they frequently overlap and cannot always be distinguished from one
another.

#Clinical Varieties of Bacillary Gangrene.#--#Acute infective gangrene#
is the form most commonly met with in civil practice. It may follow such
trivial injuries as a pin-prick or a scratch, the signs of acute
cellulitis rapidly giving place to those of a spreading gangrene. Or it
may ensue on a severe railway, machinery, or street accident, when
lacerated and bruised tissues are contaminated with gross dirt. Often
within a few hours of the injury the whole part rapidly becomes painful,
swollen, oedematous, and tense. The skin is at first glazed, and perhaps
paler than normal, but soon assumes a dull red or purplish hue, and
bullae form on the surface. Putrefactive gases may be evolved in the
tissues, and their presence is indicated by emphysematous crackling when
the part is handled. The spread of the disease is so rapid that its
progress is quite visible from hour to hour, and may be traced by the
occurrence of red lines along the course of the lymphatics of the limb.
In the most acute cases the death of the affected part takes place so
rapidly that the local changes indicative of gangrene have not time to
occur, and the fact that the part is dead may be overlooked.

[Illustration: FIG. 22.--Gangrene of Terminal Phalanx of Index-Finger,
following cellulitis of hand resulting from a scratch on the palm of the
hand.]

Rigors may occur, but the temperature is not necessarily raised--indeed,
it is sometimes subnormal. The pulse is small, feeble, rapid, and
irregular. Unless amputation is promptly performed, death usually
follows within thirty-six or forty-eight hours. Even early operation
does not always avert the fatal issue, because the quantity of toxin
absorbed and its extreme virulence are often more than even a robust
subject can outlive.

_Treatment._--Every effort must be made to purify all such wounds as are
contaminated by earth, street dust, stable refuse, or other forms of
gross dirt. Devitalised and contaminated tissue is removed with the
knife or scissors and the wound purified with antiseptics of the
chlorine group or with hydrogen peroxide. If there is a reasonable
prospect that infection has been overcome, the wound may be at once
sutured, but if this is doubtful it is left open and packed or
irrigated.

When acute gangrene has set in no treatment short of amputation is of
any avail, and the sooner this is done, the greater is the hope of
saving the patient. The limb must be amputated well beyond the apparent
limits of the infected area, and stringent precautions must be taken to
avoid discharge from the already gangrenous area reaching the operation
wound. An assistant or nurse, who is to take no other part in the
operation, is told off to carry out the preliminary purification, and to
hold the limb during the operation.

#Malignant Oedema.#--This form of acute gangrene has been defined as
"a spreading inflammatory oedema attended with emphysema, and ultimately
followed by gangrene of the skin and adjacent parts." The predominant
organism is the _bacillus of malignant oedema_ or _vibrion septique_ of
Pasteur, which is found in garden soil, dung, and various putrefying
substances. It is anaerobic, and occurs as long, thick rods with
somewhat rounded ends and several laterally placed flagella. Spores,
which have a high power of resistance, form in the centre of the rods,
and bulge out the sides so as to give the organisms a spindle-shaped
outline. Other pathogenic organisms are also present and aid the
specific bacillus in its action.

At the bedside it is difficult, if not impossible, to distinguish it
from acute infective gangrene. Both follow on the same kinds of injury
and run an exceedingly rapid course. In malignant oedema, however, the
incidence of the disease is mainly on the superficial parts, which
become oedematous and emphysematous, and acquire a marbled appearance
with the veins clearly outlined. Early disappearance of sensation is a
particularly grave symptom. Bullae form on the skin, and the tissues
have "a peculiar heavy but not putrid odour." The constitutional effects
are extremely severe, and death may ensue within a few hours.

#Acute Emphysematous# or #Gas Gangrene# was prevalent in certain areas
at various periods during the European War. It follows infection of
lacerated wounds with the _bacillus aerogenes capsulatus_, usually in
combination with other anaerobes, and its main incidence is on the
muscles, which rapidly become infiltrated with gas that spreads
throughout the whole extent of the muscle, disintegrating its fibres and
leading to necrosis. The gangrenous process spreads with appalling
rapidity, the limb becoming enormously swollen, painful, and crepitant
or even tympanitic. Patches of coppery or purple colour appear on the
skin, and bullae containing blood-stained serum form on the surface. The
toxaemia is profound, and the face and lips assume a characteristic
cyanosis. The condition is attended with a high mortality. Only in the
early stages and when the infection is limited are local measures
successful in arresting the spread; in more severe cases amputation is
the only means of saving life.

#Cancrum Oris# or #Noma#.--This disease is believed to be due to a
specific bacillus, which occurs in long delicate rods, and is chiefly
found at the margin of the gangrenous area. It is prone to attack
unhealthy children from two to five years of age, especially during
their convalescence from such diseases as measles, scarlet fever, or
typhoid, but may attack adults when they are debilitated. It is most
common in the mouth, but sometimes occurs on the vulva. In the mouth it
begins as an ulcerative stomatitis, more especially affecting the gums
or inner aspect of the cheek. The child lies prostrated, and from the
open mouth foul-smelling saliva, streaked with blood, escapes; the face
is of an ashy-grey colour, the lips dark and swollen. On the inner
aspect of the cheek is a deeply ulcerated surface, with sloughy shreds
of dark-brown or black tissue covering its base; the edges are
irregular, firm, and swollen, and the surrounding mucous membrane is
infiltrated and oedematous. In the course of a few hours a dark spot
appears on the outer aspect of the cheek, and rapidly increases in size;
towards the centre it is black, shading off through blue and grey into a
dark-red area which extends over the cheek (Fig. 23). The tissue
implicated is at first firm and indurated, but as it loses its vitality
it becomes doughy and sodden. Finally a slough forms, and, when it
separates, the cheek is perforated.

Meanwhile the process spreads inside the mouth, and the gums, the floor
of the mouth, or even the jaws, may become gangrenous and the teeth fall
out. The constitutional disturbance is severe, the temperature raised,
and the pulse feeble and rapid.

The extremely foetid odour which pervades the room or even the house the
patient occupies, is usually sufficient to suggest the diagnosis of
cancrum oris. The odour must not be mistaken for that due to
decomposition of sordes on the teeth and gums of a debilitated patient.

The _prognosis_ is always grave in the extreme, the main risks being
general toxaemia and septic pneumonia. When recovery takes place there is
serious deformity, and considerable portions of the jaws may be lost by
necrosis.

[Illustration: FIG. 23.--Cancrum oris.

(From a photograph lent by Sir George T. Beatson.)]

_Treatment._--The only satisfactory treatment is thorough removal under
an anaesthetic of all the sloughy tissue, with the surrounding zone in
which the organisms are active. This is most efficiently accomplished by
the knife or scissors, cutting until the tissue bleeds freely, after
which the raw surface is painted with undiluted carbolic acid and
dressed with iodoform gauze. It may be necessary to remove large pieces
of bone when the necrotic process has implicated the jaws. The mouth
must be constantly sprayed with peroxide of hydrogen, and washed out
with a disinfectant and deodorant lotion, such as Condy's fluid. The
patient's general condition calls for free stimulation.

The deformity resulting from these necessarily heroic measures is not so
great as might be expected, and can be further diminished by plastic
operations, which should be undertaken before cicatricial contraction
has occurred.


BED-SORES

Bed-sores are most frequently met with in old and debilitated patients,
or in those whose tissues are devitalised by acute or chronic diseases
associated with stagnation of blood in the peripheral veins. Any
interference with the nerve-supply of the skin, whether from injury or
disease of the central nervous system or of the peripheral nerves,
strongly predisposes to the formation of bed-sores. Prolonged and
excessive pressure over a bony prominence, especially if the parts be
moist with skin secretions, urine, or wound discharges, determines the
formation of a sore. Excoriations, which may develop into true
bed-sores, sometimes form where two skin surfaces remain constantly
apposed, as in the region of the scrotum or labium, under pendulous
mammae, or between fingers or toes confined in a splint.

[Illustration: FIG. 24.--Acute Bed-Sores over Right Buttock.]

_Clinical Features._--Two clinical varieties are met with--the acute
and the chronic bed-sore.

The _acute_ bed-sore usually occurs over the sacrum or buttock. It
develops rapidly after spinal injuries and in the course of certain
brain diseases. The part affected becomes red and congested, while the
surrounding parts are oedematous and swollen, blisters form, and the skin
loses its vitality (Fig. 24).

In advanced cases of general paralysis of the insane, a peculiar form of
acute bed-sore beginning as a blister, and passing on to the formation
of a black, dry eschar, which slowly separates, occurs on such parts as
the medial side of the knee, the angle of the scapula, and the heel.

The _chronic_ bed-sore begins as a dusky reddish purple patch, which
gradually becomes darker till it is almost black. The parts around are
oedematous, and a blister may form. This bursts and exposes the papillae
of the skin, which are of a greenish hue. A tough greyish-black slough
forms, and is slowly separated. It is not uncommon for the gangrenous
area to continue to spread both in width and in depth till it reaches
the periosteum or bone. Bed-sores over the sacrum sometimes implicate
the vertebral canal and lead to spinal meningitis, which usually proves
fatal.

In old and debilitated patients the septic absorption taking place from
a bed-sore often proves a serious complication of other surgical
conditions. From this cause, for example, old people may succumb during
the treatment of a fractured thigh.

The granulating surface left on the separation of the slough tends to
heal comparatively rapidly.

_Prevention of Bed-sores._--The first essential in the prevention of
bed-sores is the regular changing of the patient's position, so that no
one part of the body is continuously pressed upon for any length of
time. Ring-pads of wool, air-cushions, or water-beds are necessary to
remove pressure from prominent parts. Absolute dryness of the skin is
all-important. At least once a day, the sacrum, buttocks,
shoulder-blades, heels, elbows, malleoli, or other parts exposed to
pressure, must be sponged with soap and water, thoroughly dried, and
then rubbed with methylated spirit, which is allowed to dry on the skin.
Dusting the part with boracic acid powder not only keeps it dry, but
prevents the development of bacteria in the skin secretions.

In operation cases, care must be taken that irritating chemicals used to
purify the skin do not collect under the patient and remain in contact
with the skin of the sacrum and buttocks during the time he is on the
operating-table. There is reason to believe that the so-called
"post-operation bed-sore" may be due to such causes. A similar result
has been known to follow soiling of the sheets by the escape of a
turpentine enema.

_Treatment._--Once a bed-sore has formed, every effort must be made to
prevent its spread. Alcohol is used to cleanse the broken surface, and
dry absorbent dressings are applied and frequently changed. It is
sometimes found necessary to employ moist or oily substances, such as
boracic poultices, eucalyptus ointment, or balsam of Peru, to facilitate
the separation of sloughs, or to promote the growth of granulations. In
patients who are not extremely debilitated the slough may be excised,
the raw surface scraped, and then painted with iodine.

Skin-grafting is sometimes useful in covering in the large raw surface
left after separation or removal of sloughs.




CHAPTER VII

BACTERIAL AND OTHER WOUND INFECTIONS


_Erysipelas_--_Diphtheria_--_Tetanus_--_Hydrophobia_--_Anthrax_--
    _Glanders_--_Actinomycosis_--_Mycetoma_--_Delhi
    boil_--_Chigoe_--_Poisoning by insects_--_Snake-bites_.


ERYSIPELAS

Erysipelas, popularly known as "rose," is an acute spreading infective
disease of the skin or of a mucous membrane due to the action of a
streptococcus. Infection invariably takes place through an abrasion of
the surface, although this may be so slight that it escapes observation
even when sought for. The streptococci are found most abundantly in the
lymph spaces just beyond the swollen margin of the inflammatory area,
and in the serous blebs which sometimes form on the surface.

#Clinical Features.#--_Facial erysipelas_ is the commonest clinical
variety, infection usually occurring through some slight abrasion in the
region of the mouth or nose, or from an operation wound in this area.
From this point of origin the inflammation may spread all over the face
and scalp as far back as the nape of the neck. It stops, however, at the
chin, and never extends on to the front of the neck. There is great
oedema of the face, the eyes becoming closed up, and the features
unrecognisable. The inflammation may spread to the meninges, the
intracranial venous sinuses, the eye, or the ear. In some cases the
erysipelas invades the mucous membrane of the mouth, and spreads to the
fauces and larynx, setting up an oedema of the glottis which may prove
dangerous to life.

Erysipelas occasionally attacks an operation wound that has become
septic; and it may accompany septic infection of the genital tract in
puerperal women, or the separation of the umbilical cord in infants
(_erysipelas neonatorum_). After an incubation period, which varies from
fifteen to sixty hours, the patient complains of headache, pains in the
back and limbs, loss of appetite, nausea, and frequently there is
vomiting. He has a chill or slight rigor, initiating a rise of
temperature to 103 o, 104 o, or 105 o F.; and a full bounding pulse of
about 100 (Fig. 25). The tongue is foul, the breath heavy, and, as a
rule, the bowels are constipated. There is frequently albuminuria, and
occasionally nocturnal delirium. A moderate degree of leucocytosis
(15,000 to 20,000) is usually present.

Around the seat of inoculation a diffuse red patch forms, varying in hue
from a bright scarlet to a dull brick-red. The edges are slightly raised
above the level of the surrounding skin, as may readily be recognised by
gently stroking the part from the healthy towards the affected area. The
skin is smooth, tense, and glossy, and presents here and there blisters
filled with serous fluid. The local temperature is raised, and the part
is the seat of a burning sensation and is tender to the touch, the most
tender area being the actively spreading zone which lies about half an
inch beyond the red margin.

[Illustration: FIG. 25.--Chart of Erysipelas occurring in a wound.]

The disease tends to spread spasmodically and irregularly, and the
direction and extent of its progress may be recognised by mapping out
the peripheral zone of tenderness. Red streaks appear along the lines of
the superficial lymph vessels, and the deep lymphatics may sometimes be
palpated as firm, tender cords. The neighbouring glands, also, are
generally enlarged and tender.

The disease lasts for from two or three days to as many weeks, and
relapses are frequent. Spontaneous resolution usually takes place, but
the disease may prove fatal from absorption of toxins, involvement of
the brain or meninges, or from general streptococcal infection.

#Complications.#--_Diffuse suppurative cellulitis_ is the most serious
local complication, and results from a mixed infection with other
pyogenic bacteria. Small _localised superficial abscesses_ may form
during the convalescent stage. They are doubtless due to the action of
skin bacteria, which attack the tissues devitalised by the erysipelas. A
persistent form of _oedema_ sometimes remains after recurrent attacks of
erysipelas, especially when they affect the face or the lower extremity,
a condition which is referred to with elephantiasis.

#Treatment.#--The first indication is to endeavour to arrest the spread
of the process. We have found that by painting with linimentum iodi, a
ring half an inch broad, about an inch in front of the peripheral tender
zone--not the red margin--an artificial leucocytosis is produced, and
the advancing streptococci are thereby arrested. Several coats of the
iodine are applied, one after the other, and this is repeated daily for
several days, even although the erysipelas has not overstepped the ring.
Success depends upon using the liniment of iodine (the tincture is not
strong enough), and in applying it well in front of the disease. To
allay pain the most useful local applications are ichthyol ointment (1
in 6), or lead and opium fomentations.

The general treatment consists in attending to the emunctories, in
administrating quinine in small--two-grain--doses every four hours, or
salicylate of iron (2-5 gr. every three hours), and in giving plenty of
fluid nourishment. It is worthy of note that the anti-streptococcic
serum has proved of less value in the treatment of erysipelas than might
have been expected, probably because the serum is not made from the
proper strain of streptococcus.

It is not necessary to isolate cases of erysipelas, provided the usual
precautions against carrying infection from one patient to another are
rigidly carried out.


DIPHTHERIA

Diphtheria is an acute infective disease due to the action of a specific
bacterium, the _bacillus diphtheriae_ or _Klebs-Loffler bacillus_. The
disease is usually transmitted from one patient to another, but it may
be contracted from cats, fowls, or through the milk of infected cows.
Cases have occurred in which the surgeon has carried the infection from
one patient to another through neglect of antiseptic precautions. The
incubation period varies from two to seven days.

#Clinical Features.#--In _pharyngeal diphtheria_, on the first or
second day of the disease, redness and swelling of the mucous membrane
of the pharynx, tonsils, and palate are well marked, and small, circular
greenish or grey patches of false membrane, composed of necrosed
epithelium, fibrin, leucocytes, and red blood corpuscles, begin to
appear. These rapidly increase in area and thickness, till they coalesce
and form a complete covering to the parts. In the pharynx the false
membrane is less adherent to the surface than it is when the disease
affects the air-passages. The diphtheritic process may spread from the
pharynx to the nasal cavities, causing blocking of the nares, with a
profuse ichorous discharge from the nostrils, and sometimes severe
epistaxis. The infection may spread along the nasal duct to the
conjunctiva. The middle ear also may become involved by spread along the
auditory (Eustachian) tube.

The lymph glands behind the angle of the jaw enlarge and become tender,
and may suppurate from superadded infection. There is pain on
swallowing, and often earache; and the patient speaks with a nasal
accent. He becomes weak and anaemic, and loses his appetite. There is
often albuminuria. Leucocytosis is usually well marked before the
injection of antitoxin; after the injection there is usually a
diminution in the number of leucocytes. The false membrane may separate
and be cast off, after which the patient gradually recovers. Death may
take place from gradual failure of the heart's action or from syncope
during some slight exertion.

_Laryngeal Diphtheria._--The disease may arise in the larynx, although,
as a rule, it spreads thence from the pharynx. It first manifests itself
by a short, dry, croupy cough, and hoarseness of the voice. The first
difficulty in breathing usually takes place during the night, and once
it begins, it rapidly gets worse. Inspiration becomes noisy, sometimes
stridulous or metallic or sibilant, and there is marked indrawing of the
epigastrium and lower intercostal spaces. The hoarseness becomes more
marked, the cough more severe, and the patient restless. The difficulty
of breathing occurs in paroxysms, which gradually increase in frequency
and severity, until at length the patient becomes asphyxiated. The
duration of the disease varies from a few hours to four or five days.

After the acute symptoms have passed off, various localised
paralyses may develop, affecting particularly the nerves of the palatal
and orbital muscles, less frequently the lower limbs.

#Diagnosis.#--The finding of the Klebs-Loffler bacillus is the only
conclusive evidence of the disease. The bacillus may be obtained by
swabbing the throat with a piece of aseptic--not antiseptic--cotton wool
or clean linen rag held in a pair of forceps, and rotated so as to
entangle portions of the false membrane or exudate. The swab thus
obtained is placed in a test-tube, previously sterilised by having had
some water boiled in it, and sent to a laboratory for investigation. To
identify the bacillus a piece of the membrane from the swab is rubbed on
a cover glass, dried, and stained with methylene blue or other basic
stain; or cultures may be made on agar or other suitable medium. When a
bacteriological examination is impossible, or when the clinical features
do not coincide with the results obtained, the patient should always be
treated on the assumption that he suffers from diphtheria. So much doubt
exists as to the real nature of membranous croup and its relationship to
true diphtheria, that when the diagnosis between the two is uncertain
the safest plan is to treat the case as one of diphtheria.

In children, diphtheria may occur on the vulva, vagina, prepuce, or
glans penis, and give rise to difficulty in diagnosis, which is only
cleared up by demonstration of the bacillus.

#Treatment.#--An attempt may be made to destroy or to counteract the
organisms by swabbing the throat with strong antiseptic solutions, such
as 1 in 1000 corrosive sublimate or 1 in 30 carbolic acid, or by
spraying with peroxide of hydrogen.

The antitoxic serum is our sheet-anchor in the treatment of diphtheria,
and recourse should be had to its use as early as possible.

Difficulty of swallowing may be met by the use of a stomach tube passed
either through the mouth or nose. When this is impracticable, nutrient
enemata are called for.

In laryngeal diphtheria, the interference with respiration may call for
intubation of the larynx, or tracheotomy, but the antitoxin treatment
has greatly diminished the number of cases in which it becomes necessary
to have recourse to these measures.

Intubation consists in introducing through the mouth into the larynx a
tube which allows the patient to breathe freely during the period while
the membrane is becoming separated and thrown off. This is best done
with the apparatus of O'Dwyer; but when this instrument is not
available, a simple gum-elastic catheter with a terminal opening (as
suggested by Macewen and Annandale) may be employed.

When intubation is impracticable, the operation of tracheotomy is
called for if the patient's life is endangered by embarrassment of
respiration. Unless the patient is in hospital with skilled assistance
available, tracheotomy is the safer of the two procedures.


TETANUS

Tetanus is a disease resulting from infection of a wound by a specific
micro-organism, the _bacillus tetani_, and characterised by increased
reflex excitability, hypertonus, and spasm of one or more groups of
voluntary muscles.

_Etiology and Morbid Anatomy._--The tetanus bacillus, which is a perfect
anaerobe, is widely distributed in nature and can be isolated from
garden earth, dung-heaps, and stable refuse. It is a slender rod-shaped
bacillus, with a single large spore at one end giving it the shape of a
drum-stick (Fig. 26). The spores, which are the active agents in
producing tetanus, are highly resistant to chemical agents, retain their
vitality in a dry condition, and even survive boiling for five minutes.

The organism does not readily establish itself in the human body, and
seems to flourish best when it finds a nidus in necrotic tissue and is
accompanied by aerobic organisms, which, by using up the oxygen in the
tissues, provide for it a suitable environment. The presence of a
foreign body in the wound seems to favour its action. The infection is
for all practical purposes a local one, the symptoms of the disease
being due to the toxins produced in the wound of infection acting upon
the central nervous system.

The toxin acts principally on the nerve centres in the spinal medulla,
to which it travels from the focus of infection by way of the nerve
fibres supplying the voluntary muscles. Its first effect on the motor
ganglia of the cord is to render them hypersensitive, so that they are
excited by mild stimuli, which under ordinary conditions would produce
no reaction. As the toxin accumulates the reflex arc is affected, with
the result that when a stimulus reaches the ganglia a motor discharge
takes place, which spreads by ascending and descending collaterals to
the reflex apparatus of the whole cord. As the toxin spreads it causes
both motor hyper-tonus and hyper-excitability, which accounts for the
tonic contraction and the clonic spasms characteristic of tetanus.

[Illustration: FIG. 26.--Bacillus of Tetanus from scraping of a wound of
finger, x 1000 diam. Basic fuchsin stain.]

#Clinical Varieties of Tetanus.#--_Acute_ or _Fulminating
Tetanus_.--This variety is characterised by the shortness of the
incubation period, the rapidity of its progress, the severity of its
symptoms, and its all but universally fatal issue in spite of
treatment, death taking place in from one to four days. The
characteristic symptoms may appear within three or four days of the
infliction of the wound, but the incubation period may extend to three
weeks, and the wound may be quite healed before the disease declares
itself--_delayed tetanus_. Usually, however, the wound is inflamed and
suppurating, with ragged and sloughy edges. A slight feverish attack may
mark the onset of the tetanic condition, or the patient may feel
perfectly well until the spasms begin. If careful observations be made,
it may be found that the muscles in the immediate neighbourhood of the
wound are the first to become contracted; but in the majority of
instances the patient's first complaint is of pain and stiffness in the
muscles of mastication, notably the masseter, so that he has difficulty
in opening the mouth--hence the popular name "lock-jaw." The muscles of
expression soon share in the rigidity, and the face assumes a taut,
mask-like aspect. The angles of the mouth may be retracted, producing a
grinning expression known as the _risus sardonicus_.

The next muscles to become stiff and painful are those of the neck,
especially the sterno-mastoid and trapezius. The patient is inclined to
attribute the pain and stiffness to exposure to cold or rheumatism. At
an early stage the diaphragm and the muscles of the anterior abdominal
wall become contracted; later the muscles of the back and thorax are
involved; and lastly those of the limbs. Although this is the typical
order of involvement of the different groups of muscles, it is not
always adhered to.

To this permanent tonic contraction of the muscles there are soon added
clonic spasms. These spasms are at first slight and transient, with
prolonged intervals between the attacks, but rapidly tend to become more
frequent, more severe, and of longer duration, until eventually the
patient simply passes out of one seizure into another.

The distribution of the spasms varies in different cases: in some it is
confined to particular groups of muscles, such as those of the neck,
back, abdominal walls, or limbs; in others all these groups are
simultaneously involved.

When the muscles of the back become spasmodically contracted, the body
is raised from the bed, sometimes to such an extent that the patient
rests only on his heels and occiput--the position of _opisthotonos_.
Lateral arching of the body from excessive action of the muscles on one
side--_pleurosthotonos_--is not uncommon, the arching usually taking
place towards the side on which the wound of infection exists. Less
frequently the body is bent forward so that the knees and chin almost
meet (_emprosthotonos_). Sometimes all the muscles simultaneously become
rigid, so that the body assumes a statuesque attitude (_orthotonos_).
When the thoracic muscles, including the diaphragm, are thrown into
spasm, the patient experiences a distressing sensation as if he were
gripped in a vice, and has extreme difficulty in getting breath. Between
the attacks the limbs are kept rigidly extended. The clonic spasms may
be so severe as to rupture muscles or even to fracture one of the long
bones.

As time goes on, the clonic exacerbations become more and more frequent,
and the slightest external stimulus, such as the feeling of the pulse, a
whisper in the room, a noise in the street, a draught of cold air, the
effort to swallow, a question addressed to the patient or his attempt to
answer, is sufficient to determine an attack. The movements are so
forcible and so continuous that the nurse has great difficulty in
keeping the bedclothes on the patient, or even in keeping him in bed.

The general condition of the patient is pitiful in the extreme. He is
fully conscious of the gravity of the disease, and his mind remains
clear to the end. The suffering induced by the cramp-like spasms of the
muscles keeps him in a constant state of fearful apprehension of the
next seizure, and he is unable to sleep until he becomes utterly
exhausted.

The temperature is moderately raised (100 o to 102 o F.), or may remain
normal throughout. Shortly before death very high temperatures (110 o F.)
have been recorded, and it has been observed that the thermometer
sometimes continues to rise after death, and may reach as high as
112 o F. or more.

The pulse corresponds with the febrile condition. It is accelerated
during the spasms, and may become exceedingly rapid and feeble before
death, probably from paralysis of the vagus. Sudden death from cardiac
paralysis or from cardiac spasm is not uncommon.

The respiration is affected in so far as the spasms of the respiratory
muscles produce dyspnoea, and a feeling of impending suffocation which
adds to the horrors of the disease.

One of the most constant symptoms is a copious perspiration, the patient
being literally bathed in sweat. The urine is diminished in quantity,
but as a rule is normal in composition; as in other acute infective
conditions, albumen and blood may be present. Retention of urine may
result from spasm of the urethral muscles, and necessitate the use of
the catheter.

The fits may cease some time before death, or, on the other hand, death
may occur during a paroxysm from fixation of the diaphragm and arrest of
respiration.

_Differential Diagnosis._--There is little difficulty, as a rule, in
diagnosing a case of fulminating tetanus, but there are several
conditions with which it may occasionally be confused. In _strychnin
poisoning_, for example, the spasms come on immediately after the
patient has taken a toxic dose of the drug; they are clonic in
character, but the muscles are relaxed between the fits. If the dose is
not lethal, the spasms soon cease. In _hydrophobia_ a history of having
been bitten by a rabid animal is usually forthcoming; the spasms, which
are clonic in character, affect chiefly the muscles of respiration and
deglutition, and pass off entirely in the intervals between attacks.
Certain cases of _haemorrhage into the lateral ventricles_ of the brain
also simulate tetanus, but an analysis of the symptoms will prevent
errors in diagnosis. _Cerebro-spinal meningitis_ and _basal meningitis_
present certain superficial resemblances to tetanus, but there is no
trismus, and the spasms chiefly affect the muscles of the neck and
back. _Hysteria and catalepsy_ may assume characters resembling those
of tetanus, but there is little difficulty in distinguishing between
these diseases. Lastly, in the _tetany_ of children, or that following
operations on the thyreoid gland, the spasms are of a jerking character,
affect chiefly the hands and fingers, and yield to medicinal treatment.

#Chronic Tetanus.#--The difference between this and acute tetanus is
mainly one of degree. Its incubation period is longer, it is more slow
and insidious in its progress, and it never reaches the same degree of
severity. Trismus is the most marked and constant form of spasm; and
while the trunk muscles may be involved, those of respiration as a rule
escape. Every additional day the patient lives adds to the probability
of his ultimate recovery. When the disease does prove fatal, it is from
exhaustion, and not from respiratory or cardiac spasm. The usual
duration is from six to ten weeks.

#Delayed Tetanus.#--During the European War acute tetanus occasionally
developed many weeks or even months after a patient had been injured,
and when the original wound had completely healed. It usually followed
some secondary operation, _e.g._, for the removal of a foreign body, or
the breaking down of adhesions, which aroused latent organisms.

#Local Tetanus.#--This term is applied to a form of the disease in which
the hypertonus and spasms are localised to the muscles in the vicinity
of the wound. It usually occurs in patients who have had prophylactic
injections of anti-tetanic serum, the toxins entering the blood being
probably neutralised by the antibodies in circulation, while those
passing along the motor nerves are unaffected.

When it occurs in the _limbs_, attention is usually directed to the fact
by pain accompanying the spasms; the muscles are found to be hard and
there are frequent twitchings of the limb. A characteristic reflex is
present in the lower extremity, namely, extension of the foot and leg
when the sole is tickled.

_Cephalic Tetanus_ is another localised variety which follows injury in
the distribution of the facial nerve. It is characterised by the
occurrence on the same side as the injury, of facial spasm, rapidly
followed by more or less complete paralysis of the muscles of
expression, with unilateral trismus and difficulty in swallowing. Other
cranial nerves, particularly the oculomotor and the hypoglossal, may
also be implicated. A remarkable feature of this condition is that
although the muscles are irresponsive to ordinary physiological stimuli,
they are thrown into spasm by the abnormal impulses of tetanus.

_Trismus._--This term is used to denote a form of tetanic spasm limited
to the muscles of mastication. It is really a mild form of chronic
tetanus, and the prognosis is favourable. It must not be confused with
the fixation of the jaw sometimes associated with a wisdom-tooth
gumboil, with tonsillitis, or with affections of the temporo-mandibular
articulation.

_Tetanus neonatorum_ is a form of tetanus occurring in infants of about
a week old. Infection takes place through the umbilicus, and manifests
itself clinically by spasms of the muscles of mastication. It is almost
invariably fatal within a few days.

_Prophylaxis._--Experience in the European War has established the
fact that the routine injection of anti-tetanic serum to all patients
with lacerated and contaminated wounds greatly reduces the frequency of
tetanus. The sooner the serum is given after the injury, the more
certain is its effect; within twenty-four hours 1500 units injected
subcutaneously is sufficient for the initial dose; if a longer period
has elapsed, 2000 to 3000 units should be given intra-muscularly, as
this ensures more rapid absorption. A second injection is given a week
after the first.

The wound must be purified in the usual way, and all instruments and
appliances used for operations on tetanic patients must be immediately
sterilised by prolonged boiling.

_Treatment._--When tetanus has developed the main indications are to
prevent the further production of toxins in the wound, and to neutralise
those that have been absorbed into the nervous system. Thorough
purification with antiseptics, excision of devitalised tissues, and
drainage of the wound are first carried out. To arrest the absorption of
toxins intra-muscular injections of 10,000 units of serum are given
daily into the muscles of the affected limb, or directly into the nerve
trunks leading from the focus of infection, in the hope of "blocking"
the nerves with antitoxin and so preventing the passage of toxins
towards the spinal cord.

To neutralise the toxins that have already reached the spinal cord, 5000
units should be injected intra-thecally daily for four or five days, the
foot of the bed being raised to enable the serum to reach the upper
parts of the cord.

The quantity of toxin circulating in the blood is so small as to be
practically negligible, and the risk of anaphylactic shock attending
intra-venous injection outweighs any benefit likely to follow this
procedure.

Baccelli recommends the injection of 20 c.c. of a 1 in 100 solution of
carbolic acid into the subcutaneous tissues every four hours during the
period that the contractions persist. Opinions vary as to the
efficiency of this treatment. The intra-thecal injection of 10 c.c. of a
15 per cent. solution of magnesium sulphate has proved beneficial in
alleviating the severity of the spasms, but does not appear to have a
curative effect.

To conserve the patient's strength by preventing or diminishing the
severity of the spasms, he should be placed in a quiet room, and every
form of disturbance avoided. Sedatives, such as bromides, paraldehyde,
or opium, must be given in large doses. Chloral is perhaps the best, and
the patient should rarely have less than 150 grains in twenty-four
hours. When he is unable to swallow, it should be given by the rectum.
The administration of chloroform is of value in conserving the strength
of the patient, by abolishing the spasms, and enabling the attendants to
administer nourishment or drugs either through a stomach tube or by the
rectum. Extreme elevation of temperature is met by tepid sponging. It is
necessary to use the catheter if retention of urine occurs.


HYDROPHOBIA

Hydrophobia is an acute infective disease following on the bite of a
rabid animal. It most commonly follows the bite or lick of a rabid dog
or cat. The virus appears to be communicated through the saliva of the
animal, and to show a marked affinity for nerve tissues; and the disease
is most likely to develop when the patient is infected on the face or
other uncovered part, or in a part richly endowed with nerves.

A dog which has bitten a person should on no account be killed until its
condition has been proved one way or the other. Should rabies develop
and its destruction become necessary, the head and spinal cord should be
retained and forwarded, packed in ice, to a competent observer. Much
anxiety to the person bitten and to his friends would be avoided if
these rules were observed, because in many cases it will be shown that
the animal did not after all suffer from rabies, and that the patient
consequently runs no risk. If, on the other hand, rabies is proved to be
present, the patient should be submitted to the Pasteur treatment.

_Clinical Features._--There is almost always a history of the patient
having been bitten or licked by an animal supposed to suffer from
rabies. The incubation period averages about forty days, but varies from
a fortnight to seven or eight months, and is shorter in young than in
old persons. The original wound has long since healed, and beyond a
slight itchiness or pain shooting along the nerves of the part, shows no
sign of disturbance. A few days of general malaise, with chills and
giddiness precede the onset of the acute manifestations, which affect
chiefly the muscles of deglutition and respiration. One of the earliest
signs is that the patient has periodically a sudden catch in his
breathing "resembling what often occurs when a person goes into a cold
bath." This is due to spasm of the diaphragm, and is frequently
accompanied by a loud-sounding hiccough, likened by the laity to the
barking of a dog. Difficulty in swallowing fluids may be the first
symptom.

The spasms rapidly spread to all the muscles of deglutition and
respiration, so that the patient not only has the greatest difficulty in
swallowing, but has a constant sense of impending suffocation. To add to
his distress, a copious secretion of viscid saliva fills his mouth. Any
voluntary effort, as well as all forms of external stimuli, only serve
to aggravate the spasms which are always induced by the attempt to
swallow fluid, or even by the sound of running water.

The temperature is raised; the pulse is small, rapid, and intermittent;
and the urine may contain sugar and albumen.

The mind may remain clear to the end, or the patient may have delusions,
supposing himself to be surrounded by terrifying forms. There is always
extreme mental agitation and despair, and the sufferer is in constant
fear of his impending fate. Happily the inevitable issue is not long
delayed, death usually occurring in from two to four days from the
onset. The symptoms of the disease are so characteristic that there is
no difficulty in diagnosis. The only condition with which it is liable
to be confused is the variety of cephalic tetanus in which the muscles
of deglutition are specially involved--the so-called tetanus
hydrophobicus.

_Prophylaxis._--The bite of an animal suspected of being rabid should be
cauterised at once by means of the actual or Paquelin cautery, or by a
strong chemical escharotic such as pure carbolic acid, after which
antiseptic dressings are applied.

It is, however, to Pasteur's _preventive inoculation_ that we must look
for our best hope of averting the onset of symptoms. "It may now be
taken as established that a grave responsibility rests on those
concerned if a person bitten by a mad animal is not subjected to the
Pasteur treatment" (Muir and Ritchie).

This method is based on the fact that the long incubation period of the
disease admits of the patient being inoculated with a modified virus
producing a mild attack, which protects him from the natural disease.

_Treatment._--When the symptoms have once developed they can only be
palliated. The patient must be kept absolutely quiet and free from all
sources of irritation. The spasms may be diminished by means of chloral
and bromides, or by chloroform inhalation.


ANTHRAX

Anthrax is a comparatively rare disease, communicable to man from
certain of the lower animals, such as sheep, oxen, horses, deer, and
other herbivora. In animals it is characterised by symptoms of acute
general poisoning, and, from the fact that it produces a marked
enlargement of the spleen, is known in veterinary surgery as "splenic
fever."

The _bacillus anthracis_ (Fig. 27), the largest of the known pathogenic
bacteria, occurs in groups or in chains made up of numerous bacilli,
each bacillus measuring from 6 to 8 u in length. The organisms are found
in enormous numbers throughout the bodies of animals that have died of
anthrax, and are readily recognised and cultivated. Sporulation only
takes place outside the body, probably because free oxygen is necessary
to the process. In the spore-free condition, the organisms are readily
destroyed by ordinary germicides, and by the gastric juice. The spores,
on the other hand, have a high degree of resistance. Not only do they
remain viable in the dry state for long periods, even up to a year, but
they survive boiling for five minutes, and must be subjected to dry heat
at 140 o C. for several hours before they are destroyed.

[Illustration: FIG. 27.--Bacillus of Anthrax in section of skin, from a
case of malignant pustule; shows vesicle containing bacilli. x 400 diam.
Gram's stain.]

_Clinical Varieties of Anthrax._--In man, anthrax may manifest itself in
one of three clinical forms.

It may be transmitted by means of spores or bacilli directly from a
diseased animal to those who, by their occupation or otherwise, are
brought into contact with it--for example, shepherds, butchers,
veterinary surgeons, or hide-porters. Infection may occur on the face by
the use of a shaving-brush contaminated by spores. The path of infection
is usually through an abrasion of the skin, and the primary
manifestations are local, constituting what is known as _the malignant
pustule_.

In other cases the disease is contracted through the inhalation of the
dried spores into the respiratory passages. This occurs oftenest in
those who work amongst wool, fur, and rags, and a form of acute
pneumonia of great virulence ensues. This affection is known as
_wool-sorter's disease_, and is almost universally fatal.

There is reason to believe that infection may also take place by means
of spores ingested into the alimentary canal in meat or milk derived
from diseased animals, or in infected water.

#Clinical Features of Malignant Pustule.#--We shall here confine
ourselves to the consideration of the local lesion as it occurs in the
skin--_the malignant pustule_.

The point of infection is usually on an uncovered part of the body, such
as the face, hands, arms, or back of the neck, and the wound may be
exceedingly minute. After an incubation period varying from a few hours
to several days, a reddish nodule resembling a small boil appears at the
seat of inoculation, the immediately surrounding skin becomes swollen
and indurated, and over the indurated area there appear a number of
small vesicles containing serum, which at first is clear but soon
becomes blood-stained (Fig. 28). Coincidently the subcutaneous tissue
for a considerable distance around becomes markedly oedematous, and the
skin red and tense. Within a few hours, blood is extravasated in the
centre of the indurated area, the blisters burst, and a dark brown or
black eschar, composed of necrosed skin and subcutaneous tissue and
altered blood, forms (Fig. 29). Meanwhile the induration extends, fresh
vesicles form and in turn burst, and the eschar increases in size. The
neighbouring lymph glands soon become swollen and tender. The affected
part is hot and itchy, but the patient does not complain of great pain.
There is a moderate degree of constitutional disturbance, with headache,
nausea, and sometimes shivering.

If the infection becomes generalised--_anthracaemia_--the temperature
rises to 103 o or 104 o F., the pulse becomes feeble and rapid, and other
signs of severe blood-poisoning appear: vomiting, diarrhoea, pains in the
limbs, headache and delirium, and the condition proves fatal in from
five to eight days.

_Differential Diagnosis._--When the malignant pustule is fully
developed, the central slough with the surrounding vesicles and the
widespread oedema are characteristic. The bacillus can be obtained from
the peripheral portion of the slough, from the blisters, and from the
adjacent lymph vessels and glands. The occupation of the patient may
suggest the possibility of anthrax infection.

[Illustration: FIG. 28.--Malignant Pustule, third day after infection
with Anthrax, showing great oedema of upper extremity and pectoral region
(cf. Fig. 29).]

[Illustration: FIG. 29.--Malignant Pustule, fourteen days after
infection, showing black eschar in process of separation. The oedema has
largely disappeared. Treated by Sclavo's serum (cf. Fig. 28).]

_Prophylaxis._--Any wound suspected of being infected with anthrax
should at once be cauterised with caustic potash, the actual cautery, or
pure carbolic acid.

_Treatment._--The best results hitherto obtained have followed the use
of the anti-anthrax serum introduced by Sclavo. The initial dose is 40
c.c., and if the serum is given early in the disease, the beneficial
effects are manifest in a few hours. Favourable results have also
followed the use of pyocyanase, a vaccine prepared from the bacillus
pyocyaneus.

By some it is recommended that the local lesion should be freely
excised; others advocate cauterisation of the affected part with solid
caustic potash till all the indurated area is softened. Graf has had
excellent results by the latter method in a large series of cases, the
oedema subsiding in about twenty-four hours and the constitutional
symptoms rapidly improving. Wolff and Wiewiorowski, on the other hand,
have had equally good results by simply protecting the local lesion with
a mild antiseptic dressing, and relying upon general treatment.

The general treatment consists in feeding and stimulating the patient as
freely as possible. Quinine, in 5 to 10 grain doses every four hours,
and powdered ipecacuanha, in 40 to 60 grain doses every four hours, have
also been employed with apparent benefit.


GLANDERS

Glanders is due to the action of a specific bacterium, the _bacillus
mallei_, which resembles the tubercle bacillus, save that it is somewhat
shorter and broader, and does not stain by Gram's method. It requires
higher temperatures for its cultivation than the tubercle bacillus, and
its growth on potato is of a characteristic chocolate-brown colour, with
a greenish-yellow ring at the margin of the growth. The bacillus mallei
retains its vitality for long periods under ordinary conditions, but is
readily killed by heat and chemical agents. It does not form spores.

_Clinical Features._--Both in the lower animals and in man the bacillus
gives rise to two distinct types of disease--_acute glanders_, and
_chronic glanders_ or _farcy_.

Acute Glanders is most commonly met with in the horse and in other
equine animals, horned cattle being immune. It affects the septum of the
nose and adjacent parts, firm, translucent, greyish nodules containing
lymphoid and epithelioid cells appearing in the mucous membrane. These
nodules subsequently break down in the centre, forming irregular
ulcers, which are attended with profuse discharge, and marked
inflammatory swelling. The cervical lymph glands, as well as the lungs,
spleen, and liver, may be the seat of secondary nodules.

_In man_, acute glanders is commoner than the chronic variety. Infection
always takes place through an abraded surface, and usually on one of the
uncovered parts of the body--most commonly the skin of the hands, arms,
or face; or on the mucous membrane of the mouth, nose, or eye. The
disease has been acquired by accidental inoculation in the course of
experimental investigations in the laboratory, and proved fatal. The
incubation period is from three to five days.

The _local_ manifestations are pain and swelling in the region of the
infected wound, with inflammatory redness around it and along the lines
of the superficial lymphatics. In the course of a week, small, firm
nodules appear, and are rapidly transformed into pustules. These may
occur on the face and in the vicinity of joints, and may be mistaken for
the eruption of small-pox.

After breaking down, these pustules give rise to irregular ulcers, which
by their confluence lead to extensive destruction of skin. Sometimes the
nasal mucous membrane becomes affected, and produces a discharge--at
first watery, but later sanious and purulent. Necrosis of the bones of
the nose may take place, in which case the discharge becomes peculiarly
offensive. In nearly every case metastatic abscesses form in different
parts of the body, such as the lungs, joints, or muscles.

During the development of the disease the patient feels ill, complains
of headache and pains in the limbs, the temperature rises to 104 o or
even to 106 o F., and assumes a pyaemic type. The pulse becomes rapid and
weak. The tongue is dry and brown. There is profuse sweating,
albuminuria, and often insomnia with delirium. Death may take place
within a week, but more frequently occurs during the second or third
week.

_Differential Diagnosis._--There is nothing characteristic in the site
of the primary lesion in man, and the condition may, during the early
stages, be mistaken for a boil or carbuncle, or for any acute
inflammatory condition. Later, the disease may simulate acute articular
rheumatism, or may manifest all the symptoms of acute septicaemia or
pyaemia. The diagnosis is established by the recognition of the bacillus.
Veterinary surgeons attach great importance to the mallein test as a
means of diagnosis in animals, but in the human subject its use is
attended with considerable risk and is not to be recommended.

_Treatment._--Excision of the primary nodule, followed by the
application of the thermo-cautery and sponging with pure carbolic acid,
should be carried out, provided the condition is sufficiently limited to
render complete removal practicable.

When secondary abscesses form in accessible situations, they must be
incised, disinfected, and drained. The general treatment is carried out
on the same lines as in other acute infective diseases.

#Chronic Glanders.#--_In the horse_ the chronic form of glanders is
known as _farcy_, and follows infection through an abrasion of the skin,
involving chiefly the superficial lymph vessels and glands. The
lymphatics become indurated and nodular, constituting what veterinarians
call _farcy pipes_ and _farcy buds_.

_In man_ also the clinical features of the chronic variety of the
disease are somewhat different from those of the acute form. Here, too,
infection takes place through a broken cutaneous surface, and leads to a
superficial lymphangitis with nodular thickening of the lymphatics
(_farcy buds_). The neighbouring glands soon become swollen and
indurated. The primary lesion meanwhile inflames, suppurates, and, after
breaking down, leaves a large, irregular ulcer with thickened edges and
a foul, purulent or bloody discharge. The glands break down in the same
way, and lead to wide destruction of skin, and the resulting sinuses and
ulcers are exceedingly intractable. Secondary deposits in the
subcutaneous tissue, the muscles, and other parts, are not uncommon, and
the nasal mucous membrane may become involved. The disease often runs a
chronic course, extending to four or five months, or even longer.
Recovery takes place in about 50 per cent. of cases, but the
convalescence is prolonged, and at any time the disease may assume the
characters of the acute variety and speedily prove fatal.

The _differential diagnosis_ is often difficult, especially in the
chronic nodules, in which it may be impossible to demonstrate the
bacillus. The ulcerated lesions of farcy have to be distinguished from
those of tubercle, syphilis, and other forms of infective granuloma.

_Treatment._--Limited areas of disease should be completely excised. The
general condition of the patient must be improved by tonics, good food,
and favourable hygienic surroundings. In some cases potassium iodide
acts beneficially.


ACTINOMYCOSIS

Actinomycosis is a chronic disease due to the action of an organism
somewhat higher in the vegetable scale than ordinary bacteria--the
_streptothrix actinomyces_ or _ray fungus_.

[Illustration: FIG. 30.--Section of Actinomycosis Colony in Pus from
Abscess of Liver, showing filaments and clubs of streptothrix
actinomyces. x 400 diam. Gram's stain.]

_Etiology and Morbid Anatomy._--The actinomyces, which has never been
met with outside the body, gives rise in oxen, horses, and other animals
to tumour-like masses composed of granulation tissue; and in man to
chronic suppurative processes which may result in a condition resembling
chronic pyaemia. The actinomyces is more complex in structure than other
pathogenic organisms, and occurs in the tissues in the form of small,
round, semi-translucent bodies, about the size of a pin-head or less,
and consisting of colonies of the fungus. On account of their yellow
tint they are spoken of as "sulphur grains." Each colony is made up of a
series of thin, interlacing, and branching _filaments_, some of which
are broken up so as to form masses or chains of _cocci_; and around the
periphery of the colony are elongated, pear-shaped, hyaline, _club-like
bodies_ (Fig. 30).

Infection is believed to be conveyed by the husks of cereals, especially
barley; and the organism has been found adhering to particles of grain
embedded in the tissues of animals suffering from the disease. In the
human subject there is often a history of exposure to infection from
such sources, and the disease is said to be most common during the
harvesting months.

Around each colony of actinomyces is a zone of granulation tissue in
which suppuration usually occurs, so that the fungus comes to lie in a
bath of greenish-yellow pus. As the process spreads these purulent foci
become confluent and form abscess cavities. When metastasis takes place,
as it occasionally does, the fungus is transmitted by the blood vessels,
as in pyaemia.

_Clinical features._--In man the disease may be met with in the skin,
the organisms gaining access through an abrasion, and spreading by the
formation of new nodules in the same way as tuberculosis.

The region of the mouth and jaws is one of the commonest sites of
surgical actinomycosis. Infection takes place, as a rule, along the side
of a carious tooth, and spreads to the lower jaw. A swelling is slowly
and insidiously developed, but when the loose connective tissue of the
neck becomes infiltrated, the spread is more rapid. The whole region
becomes infiltrated and swollen, and the skin ultimately gives way and
free suppuration occurs, resulting in the formation of sinuses. The
characteristic greenish-grey or yellow granules are seen in the pus, and
when examined microscopically reveal the colonies of actinomyces.

Less frequently the maxilla becomes affected, and the disease may spread
to the base of the skull and brain. The vertebrae may become involved by
infection taking place through the pharynx or oesophagus, and leading to
a condition simulating tuberculous disease of the spine. When it
implicates the intestinal canal and its accessory glands, the lungs,
pleura, and bronchial tubes, or the brain, the disease is not amenable
to surgical treatment.

_Differential Diagnosis._--The conditions likely to be mistaken for
surgical actinomycosis are sarcoma, tubercle, and syphilis. In the early
stages the differential diagnosis is exceedingly difficult. In many
cases it is only possible when suppuration has occurred and the fungus
can be demonstrated.

The slow destruction of the affected tissue by suppuration, the absence
of pain, tenderness, and redness, simulate tuberculosis, but the absence
of glandular involvement helps to distinguish it.

Syphilitic lesions are liable to be mistaken for actinomycosis, all the
more that in both diseases improvement follows the administration of
iodides. When it affects the lower jaw, in its early stages,
actinomycosis may closely simulate a periosteal sarcoma.

[Illustration: FIG. 31.--Actinomycosis of Maxilla. The disease spread to
opposite side; finally implicated base of skull, and proved fatal.
Treated by radium.

(Mr. D. P. D. Wilkie's case.)]

The recognition of the fungus is the crucial point in diagnosis.

_Prognosis._--Spontaneous cure rarely occurs. When the disease
implicates internal organs, it is almost always fatal. On external parts
the destructive process gradually spreads, and the patient eventually
succumbs to superadded septic infection. When, from its situation, the
primary focus admits of removal, the prognosis is more favourable.

_Treatment._--The surgical treatment is early and free removal of the
affected tissues, after which the wound is cauterised by the actual
cautery, and sponged over with pure carbolic acid. The cavity is packed
with iodoform gauze, no attempt being made to close the wound.

Success has attended the use of a vaccine prepared from cultures of the
organism; and the X-rays and radium, combined with the administration of
iodides in large doses, or with intra-muscular injections of a 10 per
cent. solution of cacodylate of soda, have proved of benefit.

MYCETOMA, OR MADURA FOOT.--Mycetoma is a chronic disease due to
an organism resembling that of actinomycosis, but not identical with it.
It is endemic in certain tropical countries, and is most frequently met
with in India. Infection takes place through an abrasion of the skin,
and the disease usually occurs on the feet of adult males who work
barefooted in the fields.

_Clinical Features._--The disease begins on the foot as an indurated
patch, which becomes discoloured and permeated by black or yellow
nodules containing the organism. These nodules break down by
suppuration, and numerous minute abscesses lined by granulation tissues
are thus formed. In the pus are found yellow particles likened to
fish-roe, or black pigmented granules like gunpowder. Sinuses form, and
the whole foot becomes greatly swollen and distorted by flattening of
the sole and dorsiflexion of the toes. Areas of caries or necrosis occur
in the bones, and the disease gradually extends up the leg (Fig. 32).
There is but little pain, and no glandular involvement or constitutional
disturbance. The disease runs a prolonged course, sometimes lasting for
twenty or thirty years. Spontaneous cure never takes place, and the risk
to life is that of prolonged suppuration.

If the disease is localised, it may be removed by the knife or sharp
spoon, and the part afterwards cauterised. As a rule, amputation well
above the disease is the best line of treatment. Unlike actinomycosis,
this disease does not appear to be benefited by iodides.

[Illustration: FIG. 32.--Mycetoma, or Madura Foot. (Museum of Royal
College of Surgeons, Edinburgh.)]

DELHI BOIL.--_Synonyms_--Aleppo boil, Biskra button, Furunculus
orientalis, Natal sore.

Delhi boil is a chronic inflammatory disease, most commonly met with in
India, especially towards the end of the wet season. The disease occurs
oftenest on the face, and is believed to be due to an organism, although
this has not been demonstrated. The infection is supposed to be conveyed
through water used for washing, or by the bites of insects.

_Clinical Features._--A red spot, resembling the mark of a mosquito
bite, appears on the affected part, and is attended with itching. After
becoming papular and increasing to the size of a pea, desquamation takes
place, leaving a dull-red surface, over which in the course of several
weeks there develops a series of small yellowish-white spots, from which
serum exudes, and, drying, forms a thick scab. Under this scab the skin
ulcerates, leaving small oval sores with sharply bevelled edges, and an
uneven floor covered with yellow or sanious pus. These sores vary in
number from one to forty or fifty. They may last for months and then
heal spontaneously, or may continue to spread until arrested by suitable
treatment. There is no enlargement of adjacent glands, and but little
inflammatory reaction in the surrounding tissues; nor is there any
marked constitutional disturbance. Recovery is often followed by
cicatricial contraction leading to deformity of the face.

The _treatment_ consists in destroying the original papule by the actual
cautery, acid nitrate of mercury, or pure carbolic acid. The ulcers
should be scraped with the sharp spoon, and cauterised.

CHIGOE.--Chigoe or jigger results from the introduction of the
eggs of the sand-flea (_Pulex penetrans_) into the tissues. It occurs in
tropical Africa, South America, and the West Indies. The impregnated
female flea remains attached to the part till the eggs mature, when by
their irritation they cause localised inflammation with pustules or
vesicles on the surface. Children are most commonly attacked,
particularly about the toe-nails and on the scrotum. The treatment
consists in picking out the insect with a blunt needle, special care
being taken not to break it up. The puncture is then cauterised. The
application of essential oils to the feet acts as a preventive.

POISONING BY INSECTS.--The bites of certain insects, such as
mosquitoes, midges, different varieties of flies, wasps, and spiders,
may be followed by serious complications. The effects are mainly due to
the injection of an irritant acid secretion, the exact nature of which
has not been ascertained.

The local lesion is a puncture, surrounded by a zone of hyperaemia,
wheals, or vesicles, and is associated with burning sensations and
itching which usually pass off in a few hours, but may recur at
intervals, especially when the patient is warm in bed. Scratching also
reproduces the local signs and symptoms. Where the connective tissue is
loose--for example, in the eyelid or scrotum--there is often
considerable swelling; and in the mouth and fauces this may lead to
oedema of the glottis, which may prove fatal.

The _treatment_ consists in the local application of dilute alkalies
such as ammonia water, solutions of carbonate or bicarbonate of soda, or
sal-volatile. Weak carbolic lotions, or lead and opium lotion, are
useful in allaying the local irritation. One of the best means of
neutralising the poison is to apply to the sting a drop of a mixture
containing equal parts of pure carbolic acid and liquor ammoniae.

Free stimulation is called for when severe constitutional symptoms are
present.

SNAKE-BITES.--We are here only concerned with the injuries
inflicted by the venomous varieties of snakes, the most important of
which are the hooded snakes of India, the rattle-snakes of America, the
horned snakes of Africa, the viper of Europe, and the adder of the
United Kingdom.

While the virulence of these creatures varies widely, they are all
capable of producing in a greater or less degree symptoms of acute
poisoning in man and other animals. By means of two recurved fangs
attached to the upper jaw, and connected by a duct with poison-secreting
glands, they introduce into their prey a thick, transparent, yellowish
fluid, of acid reaction, probably of the nature of an albumose, and
known as the _venom_.

The _clinical features_ resulting from the injection of the venom vary
directly in intensity with the amount of the poison introduced, and the
rapidity with which it reaches the circulating blood, being most marked
when it immediately enters a large vein. The poison is innocuous when
taken into the stomach.

_Locally_ the snake inflicts a double wound, passing vertically into the
subcutaneous tissue; the edges of the punctures are ecchymosed, and the
adjacent vessels the seat of thrombosis. Immediately there is intense
pain, and considerable swelling with congestion, which tends to spread
towards the trunk. Extensive gangrene may ensue. There is no special
involvement of the lymphatics.

The _general symptoms_ may come on at once if the snake is a
particularly venomous one, or not for some hours if less virulent. In
the majority of viper or adder bites the constitutional disturbance is
slight and transient, if it appears at all. Snake-bites in children are
particularly dangerous.

The patient's condition is one of profound shock with faintness,
giddiness, dimness of sight, and a feeling of great terror. The pupils
dilate, the skin becomes moist with a clammy sweat, and nausea with
vomiting, sometimes of blood, ensues. High fever, cramps, loss of
sensation, haematuria, and melaena are among the other symptoms that may
be present. The pulse becomes feeble and rapid, the respiratory nerve
centres are profoundly depressed, and delirium followed by coma usually
precedes the fatal issue, which may take place in from five to
forty-eight hours. If the patient survives for two days the prognosis is
favourable.

_Treatment._--A broad ligature should be tied tightly round the limb
above the seat of infection, to prevent the poison passing into the
general circulation, and bleeding from the wound should be encouraged.
The application of an elastic bandage from above downward to empty the
blood out of the infected portion of the limb has been recommended. The
whole of the bite should at once be excised, and crystals of
permanganate of potash rubbed into the wound until it is black, or
peroxide of hydrogen applied with the object of destroying the poison by
oxidation.

The general treatment consists in free stimulation with whisky, brandy,
ammonia, digitalis, etc. Hypodermic injections of strychnin in doses
sufficiently large to produce a slight degree of poisoning by the drug
are particularly useful. The most rational treatment, when it is
available, is the use of the _antivenin_ introduced by Fraser and
Calmette.




CHAPTER VIII

TUBERCULOSIS


Tubercle bacillus--Methods of infection--Inherited and acquired
    predisposition--Relationship of tuberculosis to injury--Human and
    bovine tuberculosis--Action of the bacillus upon the
    tissues--Tuberculous granulation tissue--Natural cure--Recrudescence
    of the disease--THE TUBERCULOUS ABSCESS--Contents and wall of the
    abscess--Tuberculous sinuses.

Tuberculosis occurs more frequently in some situations than in others;
it is common, for example, in lymph glands, in bones and joints, in the
peritoneum, the intestine, the kidney, prostate and testis, and in the
skin and subcutaneous cellular tissue; it is seldom met with in the
breast or in muscles, and it rarely affects the ovary, the pancreas, the
parotid, or the thyreoid.

_Tubercle bacilli_ vary widely in their virulence, and they are more
tenacious of life than the common pyogenic bacteria. In a dry state, for
example, they can retain their vitality for months; and they can also
survive immersion in water for prolonged periods. They resist the action
of the products of putrefaction for a considerable time, and are not
destroyed by digestive processes in the stomach and intestine. They may
be killed in a few minutes by boiling, or by exposure to steam under
pressure, or by immersion for less than a minute in 1 in 20 carbolic
lotion.

#Methods of Infection.#--In marked contrast to what obtains in the
infective diseases that have already been described, tuberculosis rarely
results from the _infection of a wound_. In exceptional instances,
however, this does occur, and in illustration of the fact may be cited
the case of a servant who cut her finger with a broken spittoon
containing the sputum of her consumptive master; the wound subsequently
showed evidence of tuberculous infection, which ultimately spread up
along the lymph vessels of the arm. Pathologists, too, whose hands,
before the days of rubber gloves, were frequently exposed to the contact
of tuberculous tissues and pus, were liable to suffer from a form of
tuberculosis of the skin of the finger, known as _anatomical tubercle_.
Slight wounds of the feet in children who go about barefoot in towns
sometimes become infected with tubercle. Operation wounds made with
instruments contaminated with tuberculous material have also been known
to become infected. It is highly probable that the common form of
tuberculosis of the skin known as "lupus" arises by direct infection
from without.

[Illustration: FIG. 33.--Tubercle Bacilli in caseous material
x 1000 diam. Z. Neilsen stain.]

In the vast majority of cases the tubercle bacillus gains entrance to
the body by way of the mucous surfaces, the organisms being either
inhaled or swallowed; those inhaled are mostly derived from the human
subject, those swallowed, from cattle. Bacilli, whether inhaled or
swallowed, are especially apt to lodge about the pharynx and pass to the
pharyngeal lymphoid tissue and tonsils, and by way of the lymph vessels
to the glands. The glands most frequently infected in this way are the
cervical glands, and those within the cavity of the chest--particularly
the bronchial glands at the root of the lung. From these, infection
extends at any later period in life to the bones, joints, and internal
organs.

There is reason to believe that the organisms may lie in a dormant
condition for an indefinite period in these glands, and only become
active long afterwards, when some depression of the patient's health
produces conditions which favour their growth. When the organisms become
active in this way, the tuberculous tissue undergoes softening and
disintegration, and the infective material, by bursting into an adjacent
vein, may enter the blood-stream, in which it is carried to distant
parts of the body. In this way a _general tuberculosis_ may be set up,
or localised foci of tuberculosis may develop in the tissues in which
the organisms lodge. Many tuberculous patients are to be regarded as
possessing in their bronchial glands, or elsewhere, an internal store of
bacilli, to which the disease for which advice is sought owes its
origin, and from which similar outbreaks of tuberculosis may originate
in the future.

_The alimentary mucous membrane_, especially that of the lower ileum and
caecum, is exposed to infection by swallowed sputum and by food
materials, such as milk, containing tubercle bacilli. The organisms may
lodge in the mucous membrane and cause tuberculous ulceration, or they
may be carried through the wall of the bowel into the lacteals, along
which they pass to the mesenteric glands where they become arrested and
give rise to tuberculous disease.

#Relationship of Tuberculosis to Trauma.#--Any tissue whose vitality has
been lowered by injury or disease furnishes a favourable nidus for the
lodgment and growth of tubercle bacilli. The injury or disease, however,
is to be looked upon as determining the _localisation_ of the
tuberculous lesion rather than as an essential factor in its causation.
In a person, for example, in whose blood tubercle bacilli are
circulating and reaching every tissue and organ of the body, the
occurrence of tuberculous disease in a particular part may be determined
by the depression of the tissues resulting from an injury of that part.
There can be no doubt that excessive movement and jarring of a limb
aggravates tuberculous disease of a joint; also that an injury may light
up a focus that has been long quiescent, but we do not agree with
those--Da Costa, for example--who maintain that injury may be a
determining cause of tuberculosis. The question is not one of mere
academic interest, but one that may raise important issues in the law
courts.

#Human and Bovine Tuberculosis.#--The frequency of the bovine bacillus
in the abdominal and in the glandular and osseous tuberculous lesions of
children would appear to justify the conclusion that the disease is
transmissible from the ox to the human subject, and that the milk of
tuberculous cows is probably a common vehicle of transmission.

#Changes in the Tissues following upon the successful Lodgment of
Tubercle Bacilli.#--The action of the bacilli on the tissues results in
the formation of granulation tissue comprising characteristic tissue
elements and with a marked tendency to undergo caseation.

The recognition of the characteristic elements, with or without
caseation, is usually sufficient evidence of the tuberculous nature of
any portion of tissue examined for diagnostic purposes. The recognition
of the bacillus itself by appropriate methods of staining makes the
diagnosis a certainty; but as it is by no means easy to identify the
organism in many forms of surgical tuberculosis, it may be necessary to
have recourse to experimental inoculation of susceptible animals such as
guinea-pigs.

The changes subsequent to the formation of tuberculous granulation
tissue are liable to many variations. It must always be borne in mind
that although the bacilli have effected a lodgment and have inaugurated
disease, the relation between them and the tissues remains one of mutual
antagonism; which of them is to gain and keep the upper hand in the
conflict depends on their relative powers of resistance.

If the tissues prevail, there ensues a process of repair. In the
immediate vicinity of the area of infection young connective tissue, and
later, fibrous tissue, is formed. This may replace the tuberculous
tissue and bring about repair--a fibrous cicatrix remaining to mark the
scene of the previous contest. Scars of this nature are frequently
discovered at the apex of the lung after death in persons who have at
one time suffered from pulmonary phthisis. Under other circumstances,
the tuberculous tissue that has undergone caseation, or even
calcification, is only encapsulated by the new fibrous tissue, like a
foreign body. Although this may be regarded as a victory for the
tissues, the cure, if such it may be called, is not necessarily a
permanent one, for at any subsequent period, if the part affected is
disturbed by injury or through some other influence, the encapsulated
tubercle may again become active and get the upper hand of the tissues,
and there results a relapse or recrudescence of the disease. This
_tendency to relapse_ after apparent cure is a notable feature of
tuberculous disease as it is met with in the spine, or in the
hip-joint, and it necessitates a prolonged course of treatment to give
the best chance of a lasting cure.

If, however, at the inauguration of the tuberculous disease the bacilli
prevail, the infection tends to spread into the tissues surrounding
those originally infected, and more and more tuberculous granulation
tissue is formed. Finally the tuberculous tissue breaks down and
liquefies, resulting in the formation of a cold abscess. In their
struggle with the tissues, tubercle bacilli receive considerable support
and assistance from any pyogenic organisms that may be present. A
tuberculous infection may exhibit its aggressive qualities in a more
serious manner by sending off detachments of bacilli, which are carried
by the lymphatics to the nearest glands, or by the blood-stream to more
distant, and it may be to all, parts of the body. When the infection is
thus generalised, the condition is called _general tuberculosis_.
Considering the extraordinary frequency of localised forms of surgical
tuberculosis, general dissemination of the disease is rare.

#The clinical features# of surgical tuberculosis will be described with
the individual tissues and organs, as they vary widely according to the
situation of the lesion.

#The general treatment# consists in combating the adverse influences
that have been mentioned as increasing the liability to tuberculous
infection. Within recent years the value of the "open-air" treatment has
been widely recognised. An open-air life, even in the centre of a city,
may be followed by marked improvement, especially in the hospital class
of patient, whose home surroundings tend to favour the progress of the
disease. The purer air of places away from centres of population is
still better; and, according to the idiosyncrasies of the individual
patient, mountain air or that of the sea coast may be preferred. In view
of the possible discomforts and gastric disturbance which may attend a
sea-voyage, this should be recommended to patients suffering from
tuberculous lesions with more caution than has hitherto been exercised.
The diet must be a liberal one, and should include those articles which
are at the same time easily digested and nourishing, especially proteids
and fats; milk obtained from a reliable source and underdone
butcher-meat are among the best. When the ordinary nourishment taken is
insufficient, it may be supplemented by such articles as malt extract,
stout, and cod-liver oil. The last is specially beneficial in patients
who do not take enough fat in other forms. It is noteworthy that many
tuberculous patients show an aversion to fat.

For _the use of tuberculin in diagnosis_ and for _the vaccine treatment
of tuberculosis_ the reader is referred to text-books on medicine.

In addition to increasing the resisting power of the patient, it is
important to enable the fluids of the body, so altered, to come into
contact with the tuberculous focus. One of the obstacles to this is that
the focus is often surrounded by tissues or fluids which have been
almost entirely deprived of bactericidal substances. In the case of
caseated glands in the neck, for example, it is obvious that the removal
of this inert material is necessary before the tissues can be irrigated
with fluids of high bactericidal value. Again, in tuberculous ascites
the abdominal cavity is filled with a fluid practically devoid of
anti-bacterial substances, so that the bacilli are able to thrive and
work their will on the tissues. When the stagnant fluid is got rid of by
laparotomy, the parts are immediately douched with lymph charged with
protective substances, the bactericidal power of which may be many times
that of the fluid displaced.

It is probable that the beneficial influence of _counter-irritants_,
such as blisters, and exposure to the _Finsen light_ and other forms of
_rays_, is to be attributed in part to the increased flow of blood to
the infected tissues.

_Artificial Hyperaemia._--As has been explained, the induction of
hyperaemia by the method devised by Bier, constitutes one of our most
efficient means of combating bacterial infection. The treatment of
tuberculosis on this plan has been proved by experience to be a valuable
addition to our therapeutic measures, and the simplicity of its
application has led to its being widely adopted in practice. It results
in an increase in the reactive changes around the tuberculous focus, an
increase in the immigration of leucocytes, and infiltration with the
lymphocytes.

The constricting bandage should be applied at some distance above the
seat of infection; for instance, in disease of the wrist, it is put on
above the elbow, and it must not cause pain either where it is applied
or in the diseased part. The bandage is only applied for a few hours
each day, either two hours at a time or twice a day for one hour, and,
while it is on, all dressings are removed save a piece of sterile gauze
over any wound or sinus that may be present. The process of cure takes a
long time--nine or even twelve months in the case of a severe joint
affection.

In cases in which a constricting bandage is inapplicable, for example,
in cold abscesses, tuberculous glands or tendon sheaths, Klapp's suction
bell is employed. The cup is applied for five minutes at a time and then
taken off for three minutes, and this is repeated over a period of
about three-quarters of an hour. The pus is allowed to escape by a small
incision, and no packing or drain should be introduced.

It has been found that tuberculous lesions tend to undergo cure
when the infected tissues are exposed to the rays of the
sun--_heliotherapy_--therefore whenever practicable this therapeutic
measure should be had recourse to.

Since the introduction of the methods of treatment described above, and
especially by their employment at an early stage in the disease, the
number of cases of tuberculosis requiring operative interference has
greatly diminished. There are still circumstances, however, in which an
operation is required; for example, in disease of the lymph glands for
the removal of inert masses of caseous material, in disease of bone for
the removal of sequestra, or in disease of joints to improve the
function of the limb. It is to be understood, however, that operative
treatment must always be preceded by and combined with other therapeutic
measures.


TUBERCULOUS ABSCESS

The caseation of tuberculous granulation tissue and its liquefaction is
a slow and insidious process, and is unattended with the classical signs
of inflammation--hence the terms "cold" and "chronic" applied to the
tuberculous abscess.

In a cold abscess, such as that which results from tuberculous disease
of the vertebrae, the clinical appearances are those of a soft, fluid
swelling without heat, redness, pain, or fever. When toxic symptoms are
present, they are usually due to a mixed infection.

A tuberculous abscess results from the disintegration and liquefaction
of tuberculous granulation tissue which has undergone caseation. Fluid
and cells from the adjacent blood vessels exude into the cavity, and
lead to variations in the character of its contents. In some cases the
contents consist of a clear amber-coloured fluid, in which are suspended
fragments of caseated tissue; in others, of a white material like
cream-cheese. From the addition of a sufficient number of leucocytes,
the contents may resemble the pus of an ordinary abscess.

The wall of the abscess is lined with tuberculous granulation tissue,
the inner layers of which are undergoing caseation and disintegration,
and present a shreddy appearance; the outer layers consist of
tuberculous tissue which has not yet undergone caseation. The abscess
tends to increase in size by progressive liquefaction of the inner
layers, caseation of the outer layers, and the further invasion of the
surrounding tissues by tubercle bacilli. In this way a tuberculous
abscess is capable of indefinite extension and increase in size until it
reaches a free surface and ruptures externally. The direction in which
it spreads is influenced by the anatomical arrangement of the tissues,
and possibly to some extent by gravity, and the abscess may reach the
surface at a considerable distance from its seat of origin. The best
illustration of this is seen in the psoas abscess, which may originate
in the dorsal vertebrae, extend downwards within the sheath of the psoas
muscle, and finally appear in the thigh.

#Clinical Features.#--The insidious development of the tuberculous
abscess is one of its characteristic features. The swelling may attain a
considerable size without the patient being aware of its existence, and,
as a matter of fact, it is often discovered accidentally. The absence of
toxaemia is to be associated with the incapacity of the wall of the
abscess to permit of absorption; this is shown also by the fact that
when even a large quantity of iodoform is inserted into the cavity of
the abscess, there are no symptoms of poisoning. The abscess varies in
size from a small cherry to a cavity containing several pints of pus.
Its shape also varies; it is usually that of a flattened sphere, but it
may present pockets or burrows running in various directions. Sometimes
it is hour-glass or dumb-bell shaped, as is well illustrated in the
region of the groin in disease of the spine or pelvis, where there may
be a large sac occupying the venter ilii, and a smaller one in the
thigh, the two communicating by a narrow channel under Poupart's
ligament. By pressing with the fingers the pus may be displaced from one
compartment to the other. The usual course of events is that the abscess
progresses slowly, and finally reaches a free surface--generally the
skin. As it does so there may be some pain, redness, and local elevation
of temperature. Fluctuation becomes evident and superficial, and the
skin becomes livid and finally gives way. If the case is left to nature,
the discharge of pus continues, and the track opening on the skin
remains as a _sinus_. The persistence of suppuration is due to the
presence in the wall of the abscess and of the sinus, of tuberculous
granulation tissue, which, so long as it remains, continues to furnish
discharge, and so prevents healing. Sooner or later pyogenic organisms
gain access to the sinus, and through it to the wall of the abscess.
They tend further to depress the resisting power of the tissues, and
thereby aggravate and perpetuate the tuberculous disease. This
superadded infection with pyogenic organisms exposes the patient to the
further risks of septic intoxication, especially in the form of hectic
fever and septicaemia, and increases the liability to general
tuberculosis, and to waxy degeneration of the internal organs. The mixed
infection is chiefly responsible for the pyrexia, sweating, and
emaciation which the laity associate with consumptive disease. A
tuberculous abscess may in one or other of these ways be a cause of
death.

_Residual abscess_ is the name given to an abscess that makes its
appearance months, or even years, after the apparent cure of tuberculous
disease--as, for example, in the hip-joint or spine. It is called
residual because it has its origin in the remains of the original
disease.

[Illustration: FIG. 34.--Tuberculous Abscess in right lumbar region in a
woman aged thirty.]

#Diagnosis.#--A cold abscess is to be diagnosed from a syphilitic gumma,
a cyst, and from lipoma and other soft tumours. The differential
diagnosis of these affections will be considered later; it is often made
easier by recognising the presence of a lesion that is likely to cause a
cold abscess, such as tuberculous disease of the spine or of the
sacro-iliac joint. When it is about to burst externally, it may be
difficult to distinguish a tuberculous abscess from one due to infection
with pyogenic organisms. Even when the abscess is opened, the
appearances of the pus may not supply the desired information, and it
may be necessary to submit it to bacteriological examination. When the
pus is found to be sterile, it is usually safe to assume that the
condition is tuberculous, as in other forms of suppuration the causative
organisms can usually be recognised. Experimental inoculation will
establish a definite diagnosis, but it implies a delay of two to three
weeks.

#Treatment.#--The tuberculous abscess may recede and disappear under
general treatment. Many surgeons advise that so long as the abscess is
quiescent it should be left alone. All agree, however, that if it shows
a tendency to spread, to increase in size, or to approach the skin or a
mucous membrane, something should be done to avoid the danger of its
bursting and becoming infected with pyogenic organisms. Simple
evacuation of the abscess by a hollow needle may suffice, or bismuth or
iodoform may be introduced after withdrawal of the contents.

_Evacuation of the Abscess and Injection of Iodoform._--The iodoform is
employed in the form of a 10 per cent. solution in ether or the same
proportion suspended in glycerin. Either form becomes sterile soon after
it is prepared. Its curative effects would appear to depend upon the
liberation of iodine, which restrains the activity of the bacilli, and
upon its capacity for irritating the tissues and so inducing a
protective leucocytosis, and also of stimulating the formation of scar
tissue. An anaesthetic is rarely called for, except in children. The
abscess is first evacuated by means of a large trocar and cannula
introduced obliquely through the overlying soft parts, avoiding any part
where the skin is thin or red. If the cannula becomes blocked with
caseous material, it may be cleared with a probe, or a small quantity of
saline solution is forced in by the syringe. The iodoform is injected by
means of a glass-barrelled syringe, which is firmly screwed on to the
cannula. The amount injected varies with the size of the abscess and the
age of the patient; it may be said to range from two or three drams in
the case of children to several ounces in large abscesses in adults. The
cannula is withdrawn, the puncture is closed by a Michel's clip, and a
dressing applied so as to exert a certain amount of compression. If the
abscess fills up again, the procedure should be repeated; in doing so,
the contents show the coloration due to liberated iodine. When the
contents are semi-solid, and cannot be withdrawn even through a large
cannula, an incision must be made, and, after the cavity has been
emptied, the iodoform is introduced through a short rubber tube attached
to the syringe. Experience has shown that even large abscesses, such as
those associated with spinal disease, may be cured by iodoform
injection, and this even when rupture of the abscess on the skin surface
has appeared to be imminent.

Another method of treatment which is less popular now than it used to
be, and which is chiefly applicable in abscesses of moderate size, is by
_incision of the abscess and removal of the tuberculous tissue in its
wall_ with the sharp spoon. An incision is made which will give free
access to the interior of the abscess, so that outlying pockets or
recesses may not be overlooked. After removal of the pus, the wall of
the abscess is scraped with the Volkmann spoon or with Barker's flushing
spoon, to get rid of the tuberculous tissue with which it is lined. In
using the spoon, care must be taken that its sharp edge does not
perforate the wall of a vein or other important structure. Any debris
which may adhere to the walls is removed by rubbing with dry gauze. The
oozing of blood is arrested by packing the cavity for a few minutes with
gauze. After the packing is removed, iodoform powder is rubbed into the
raw surface. The soft parts divided by the incision are sutured in
layers so as to ensure primary union. If, on the other hand, there is
fear of a mixed infection, especially in abscesses near the rectum or
anus, it is safer to treat it by the open method, packing the cavity
with iodoform worsted or bismuth gauze, which is renewed at intervals of
a week or ten days as the cavity heals from the bottom.

Another method is to incise the abscess, cleanse the cavity with gauze,
irrigate with Carrel-Dakin solution and pack with gauze smeared with the
dilute non-toxic B.I.P.P. (bismuth and iodoform 2 parts, vaseline 12
parts, hard paraffin, sufficient to give the consistence of butter). The
wound is closed with "bipped" silk sutures; one of these--the "waiting
suture"--is left loose to permit of withdrawal of the gauze after
forty-eight hours; the waiting suture is then tied, and delayed primary
union is thus effected.

When the skin over the abscess is red, thin, and about to give way, as
is frequently the case when the abscess is situated in the subcutaneous
cellular tissue, any skin which is undermined and infected with tubercle
should be removed with the scissors at the same time that the abscess is
dealt with.

In abscesses treated by the open method, when the cavity has become
lined with healthy granulations, it may be closed by secondary suture,
or, if the granulating surface is flush with the skin, healing may be
hastened by skin-grafting.

If the tuberculous abscess has burst and left a _sinus_, this is apt to
persist because of the presence of tuberculous tissue in its wall, and
of superadded pyogenic infection, or because it serves as an avenue for
the escape of discharge from a focus of tubercle in a bone or a lymph
gland.

[Illustration: FIG. 35.--Tuberculous Sinus injected through its opening
in the forearm with bismuth paste.

(Mr. Pirie Watson's case--Radiogram by Dr. Hope Fowler.)]

The treatment varies with the conditions present, and must include
measures directed to the lesion from which the sinus has originated. The
extent and direction of any given sinus may be demonstrated by the use
of the probe, or, more accurately, by injecting the sinus with a paste
consisting of white vaseline containing 10 to 30 per cent. of bismuth
subcarbonate, and following its track with the X-rays (Fig. 35).

It was found by Beck of Chicago that the injection of bismuth paste is
frequently followed by healing of the sinus, and that, if one injection
fails to bring about a cure, repeating the injection every second day
may be successful. Some caution must be observed in this treatment, as
symptoms of poisoning have been observed to follow its use. If they
manifest themselves, an injection of warm olive oil should be given; the
oil, left in for twelve hours or so, forms an emulsion with the bismuth,
which can be withdrawn by aspiration. Iodoform suspended in glycerin may
be employed in a similar manner. When these and other non-operative
measures fail, and the whole track of the sinus is accessible, it should
be laid open, scraped, and packed with bismuth or iodoform gauze until
it heals from the bottom.

The _tuberculous ulcer_ is described in the chapter on ulcers.




CHAPTER IX

SYPHILIS


Definition.--Virus.--ACQUIRED SYPHILIS--Primary period:
    _Incubation, primary chancre, glandular enlargement_;
    _Extra-genital chancres_--Treatment--Secondary period: _General
    symptoms, skin affections, mucous patches, affections of bones,
    joints, eyes_, etc.--Treatment: _Salvarsan_--_Methods of
    administering mercury_--Syphilis and marriage--Intermediate
    stage--_Reminders_--Tertiary period: _General symptoms_,
    _gummata_, _tertiary ulcers_, _tertiary lesions of skin, mucous
    membrane, bones, joints_, etc.--Second attacks.--INHERITED
    SYPHILIS--Transmission--_Clinical features in infancy, in later
    life_--Contagiousness--Treatment.

Syphilis is an infective disease due to the entrance into the body of a
specific virus. It is nearly always communicated from one individual to
another by contact infection, the discharge from a syphilitic lesion
being the medium through which the virus is transmitted, and the seat of
inoculation is almost invariably a surface covered by squamous
epithelium. The disease was unknown in Europe before the year 1493, when
it was introduced into Spain by Columbus' crew, who were infected in
Haiti, where the disease had been endemic from time immemorial (Bloch).

The granulation tissue which forms as a result of the reaction of the
tissues to the presence of the virus is chiefly composed of lymphocytes
and plasma cells, along with an abundant new formation of capillary
blood vessels. Giant cells are not uncommon, but the endothelioid cells,
which are so marked a feature of tuberculous granulation tissue, are
practically absent.

When syphilis is communicated from one individual to another by contact
infection, the condition is spoken of as _acquired syphilis_, and the
first visible sign of the disease appears at the site of inoculation,
and is known as _the primary lesion_. Those who have thus acquired the
disease may transmit it to their offspring, who are then said to suffer
from _inherited syphilis_.

#The Virus of Syphilis.#--The cause of syphilis, whether acquired or
inherited, is the organism, described by Schaudinn and Hoffman, in 1905,
under the name of _spirochaeta pallida_ or _spironema pallidum_. It is a
delicate, thread-like spirilla, in length averaging from 8 to 10 u and
in width about 0.25 u, and is distinguished from other spirochaetes by
its delicate shape, its dead-white appearance, together with its closely
twisted spiral form, with numerous undulations (10 to 26), which are
perfectly regular, and are characteristic in that they remain the same
during rest and in active movement (Fig. 36). In a fresh specimen, such
as a scraping from a hard chancre suspended in a little salt solution,
it shows active movements. The organism is readily destroyed by heat,
and perishes in the absence of moisture. It has been proved
experimentally that it remains infective only up to six hours after its
removal from the body. Noguchi has succeeded in obtaining pure cultures
from the infected tissues of the rabbit.

[Illustration: FIG. 36.--Spirochaeta pallida from scraping of hard
Chancre of Prepuce. x 1000 diam. Burri method.]

The spirochaete may be recognised in films made by scraping the deeper
parts of the primary lesion, from papules on the skin, or from blisters
artificially raised on lesions of the skin or on the immediately
adjacent portion of healthy skin. It is readily found in the mucous
patches and condylomata of the secondary period. It is best stained by
Giemsa's method, and its recognition is greatly aided by the use of the
ultra-microscope.

The spirochaete has been demonstrated in every form of syphilitic lesion,
and has been isolated from the blood--with difficulty--and from lymph
withdrawn by a hollow needle from enlarged lymph glands. The saliva of
persons suffering from syphilitic lesions of the mouth also contains the
organism.

[Illustration: FIG. 37.--Spirochaeta refrigerans from scraping of Vagina.
x 1000 diam. Burri method.]

In tertiary lesions there is greater difficulty in demonstrating the
spirochaete, but small numbers have been found in the peripheral parts of
gummata and in the thickened patches in syphilitic disease of the aorta.
Noguchi and Moore have discovered the spirochaete in the brain in a
number of cases of general paralysis of the insane. The spirochaete may
persist in the body for a long time after infection; its presence has
been demonstrated as long as sixteen years after the original
acquisition of the disease.

In inherited syphilis the spirochaete is present in enormous numbers
throughout all the organs and fluids of the body.

Considerable interest attaches to the observations of Metchnikoff, Roux,
and Neisser, who have succeeded in conveying syphilis to the chimpanzee
and other members of the ape tribe, obtaining primary and secondary
lesions similar to those observed in man, and also containing the
spirochaete. In animals the disease has been transmitted by material from
all kinds of syphilitic lesions, including even the blood in the
secondary and tertiary stages of the disease. The primary lesion is in
the form of an indurated papule, in every respect resembling the
corresponding lesion in man, and associated with enlargement and
induration of the lymph glands. The primary lesion usually appears about
thirty days after inoculation, to be followed, in about half the cases,
by secondary manifestations, which are usually of a mild character; in
no instance has any tertiary lesion been observed. The severity of the
affection amongst apes would appear to be in proportion to the nearness
of the relationship of the animal to the human subject. The eye of the
rabbit is also susceptible to inoculation from syphilitic lesions; the
material in a finely divided state is introduced into the anterior
chamber of the eye.

Attempts to immunise against the disease have so far proved negative,
but Metchnikoff has shown that the inunction of the part inoculated with
an ointment containing 33 per cent. of calomel, within one hour of
infection, suffices to neutralise the virus in man, and up to eighteen
hours in monkeys. He recommends the adoption of this procedure in the
prophylaxis of syphilis.

Noguchi has made an emulsion of dead spirochaetes which he calls
_luetin_, and which gives a specific reaction resembling that of
tuberculin in tuberculosis, a papule or a pustule forming at the site of
the intra-dermal injection. It is said to be most efficacious in the
tertiary and latent forms of syphilis, which are precisely those forms
in which the diagnosis is surrounded with difficulties.


ACQUIRED SYPHILIS

In the vast majority of cases, infection takes place during the congress
of the sexes. Delicate, easily abraded surfaces are then brought into
contact, and the discharge from lesions containing the virus is placed
under favourable conditions for conveying the disease from one person to
the other. In the male the possibility of infection taking place is
increased if the virus is retained under cover of a long and tight
prepuce, and if there are abrasions on the surface with which it comes
in contact. The frequency with which infection takes place on the
genitals during sexual intercourse warrants syphilis being considered a
venereal disease, although there are other ways in which it may be
contracted.

Some of these imply direct contact--such, for example, as kissing, the
digital examination of syphilitic patients by doctors or nurses, or
infection of the surgeon's fingers while operating upon a syphilitic
patient. In suckling, a syphilitic wet nurse may infect a healthy
infant, or a syphilitic infant may infect a healthy wet nurse. In other
cases the infection is by indirect contact, the virus being conveyed
through the medium of articles contaminated by a syphilitic
patient--such, for example, as surgical instruments, tobacco pipes, wind
instruments, table utensils, towels, or underclothing. Physiological
secretions, such as saliva, milk, or tears, are not capable of
communicating the disease unless contaminated by discharge from a
syphilitic sore. While the saliva itself is innocuous, it can be, and
often is, contaminated by the discharge from mucous patches or other
syphilitic lesions in the mouth and throat, and is then a dangerous
medium of infection. Unless these extra-genital sources of infection are
borne in mind, there is a danger of failing to recognise the primary
lesion of syphilis in unusual positions, such as the lip, finger, or
nipple. When the disease is thus acquired by innocent transfer, it is
known as _syphilis insontium_.

#Stages or Periods of Syphilis.#--Following the teaching of Ricord, it
is customary to divide the life-history of syphilis into three periods
or stages, referred to, for convenience, as primary, secondary, and
tertiary. This division is to some extent arbitrary and artificial, as
the different stages overlap one another, and the lesions of one stage
merge insensibly into those of another. Wide variations are met with in
the manifestations of the secondary stage, and histologically there is
no valid distinction to be drawn between secondary and tertiary lesions.

_The primary period_ embraces the interval that elapses between the
initial infection and the first constitutional manifestations,--roughly,
from four to eight weeks,--and includes the period of incubation, the
development of the primary sore, and the enlargement of the nearest
lymph glands.

_The secondary period_ varies in duration from one to two years, during
which time the patient is liable to suffer from manifestations which are
for the most part superficial in character, affecting the skin and its
appendages, the mucous membranes, and the lymph glands.

_The tertiary period_ has no time-limit except that it follows upon the
secondary, so that during the remainder of his life the patient is
liable to suffer from manifestations which may affect the deeper tissues
and internal organs as well as the skin and mucous membranes.

#Primary Syphilis.#--_The period of incubation_ represents the interval
that elapses between the occurrence of infection and the appearance of
the primary lesion at the site of inoculation. Its limits may be stated
as varying from two to six weeks, with an average of from twenty-one to
twenty-eight days. While the disease is incubating, there is nothing to
show that infection has occurred.

_The Primary Lesion._--The incubation period having elapsed, there
appears at the site of inoculation a circumscribed area of infiltration
which represents the reaction of the tissues to the entrance of the
virus. The first appearance is that of a sharply defined papule, rarely
larger than a split pea. Its surface is at first smooth and shiny, but
as necrosis of the tissue elements takes place in the centre, it becomes
concave, and in many cases the epithelium is shed, and an ulcer is
formed. Such an ulcer has an elevated border, sharply cut edges, an
indurated base, and exudes a scanty serous discharge; its surface is at
first occupied by yellow necrosed tissue, but in time this is replaced
by smooth, pale-pink granulation tissue; finally, epithelium may spread
over the surface, and the ulcer heals. As a rule, the patient suffers
little discomfort, and may even be ignorant of the existence of the
lesion, unless, as a result of exposure to mechanical or septic
irritation, ulceration ensues, and the sore becomes painful and tender,
and yields a purulent discharge. The primary lesion may persist until
the secondary manifestations make their appearance, that is, for several
weeks.

It cannot be emphasised too strongly that the induration of the primary
lesion, which has obtained for it the name of "hard chancre," is its
most important characteristic. It is best appreciated when the sore is
grasped from side to side between the finger and thumb. The sensation on
grasping it has been aptly compared to that imparted by a nodule of
cartilage, or by a button felt through a layer of cloth. The evidence
obtained by touch is more valuable than that obtained by inspection, a
fact which is made use of in the recognition of _concealed
chancres_--that is, those which are hidden by a tight prepuce. The
induration is due not only to the dense packing of the connective-tissue
spaces with lymphocytes and plasma cells, but also to the formation of
new connective-tissue elements. It is most marked in chancres situated
in the furrow between the glans and the prepuce.

_In the male_, the primary lesion specially affects certain
_situations_, and the appearances vary with these: (1) On the inner
aspect of the prepuce, and in the fold between the prepuce and the
glans; in the latter situation the induration imparts a "collar-like"
rigidity to the prepuce, which is most apparent when it is rolled back
over the corona. (2) At the orifice of the prepuce the primary lesion
assumes the form of multiple linear ulcers or fissures, and as each of
these is attended with infiltration, the prepuce cannot be pulled
back--a condition known as _syphilitic phimosis_. (3) On the glans penis
the infiltration may be so superficial that it resembles a layer of
parchment, but if it invades the cavernous tissue there is a dense mass
of induration. (4) On the external aspect of the prepuce or on the skin
of the penis itself. (5) At either end of the torn fraenum, in the form
of a diamond-shaped ulcer raised above the surroundings. (6) In relation
to the meatus and canal of the urethra, in either of which situations
the swelling and induration may lead to narrowing of the urethra, so
that the urine is passed with pain and difficulty and in a minute
stream; stricture results only in the exceptional cases in which the
chancre has ulcerated and caused destruction of tissue. A chancre within
the orifice of the urethra is rare, and, being concealed from view, it
can only be recognised by the discharge from the meatus and by the
induration felt between the finger and thumb on palpating the urethra.

_In the female_, the primary lesion is not so typical or so easily
recognised as in men; it is usually met with on the labia; the
induration is rarely characteristic and does not last so long. The
primary lesion may take the form of condylomata. Indurated oedema, with
brownish-red or livid discoloration of one or both labia, is diagnostic
of syphilis.

The hard chancre is usually solitary, but sometimes there are two or
more; when there are several, they are individually smaller than the
solitary chancre.

It is the exception for a hard chancre to leave a visible scar, hence,
in examining patients with a doubtful history of syphilis, little
reliance can be placed on the presence or absence of a scar on the
genitals. When the primary lesion has taken the form of an open ulcer
with purulent discharge, or has sloughed, there is a permanent scar.

_Infection of the adjacent lymph glands_ is usually found to have taken
place by the time the primary lesion has acquired its characteristic
induration. Several of the glands along Poupart's ligament, on one or on
both sides, become enlarged, rounded, and indurated; they are usually
freely movable, and are rarely sensitive unless there is superadded
septic infection. The term _bullet-bubo_ has been applied to them, and
their presence is of great value in diagnosis. In a certain number of
cases, one of the main _lymph vessels_ on the dorsum of the penis is
transformed into a fibrous cord easily recognisable on palpation, and
when grasped between the fingers appears to be in size and consistence
not unlike the vas deferens.

_Concealed chancre_ is the term applied when one or more chancres are
situated within the sac of a prepuce which cannot be retracted. If the
induration is well marked, the chancre can be palpated through the
prepuce, and is tender on pressure. As under these conditions it is
impossible for the patient to keep the parts clean, septic infection
becomes a prominent feature, the prepuce is oedematous and inflamed, and
there is an abundant discharge of pus from its orifice. It occasionally
happens that the infection assumes a virulent character and causes
sloughing of the prepuce--a condition known as _phagedaena_. The
discharge is then foul and blood-stained, and the prepuce becomes of a
dusky red or purple colour, and may finally slough, exposing the glans.

_Extra-genital or Erratic Chancres_ (Fig. 38).--Erratic chancre is the
term applied by Jonathan Hutchinson to the primary lesion of syphilis
when it appears on parts of the body other than the genitals. It differs
in some respects from the hard chancre as met with on the penis; it is
usually larger, the induration is more diffused, and the enlarged glands
are softer and more sensitive. The glands in nearest relation to the
sore are those first affected, for example, the epitrochlear or axillary
glands in chancre of the finger; the submaxillary glands in chancre of
the lip or mouth; or the pre-auricular gland in chancre of the eyelid or
forehead. In consequence of their divergence from the typical chancre,
and of their being often met with in persons who, from age,
surroundings, or moral character, are unlikely subjects of venereal
disease, the true nature of erratic chancres is often overlooked until
the persistence of the lesion, its want of resemblance to anything else,
or the onset of constitutional symptoms, determines the diagnosis of
syphilis. A solitary, indolent sore occurring on the lip, eyelid,
finger, or nipple, which does not heal but tends to increase in size,
and is associated with induration and enlargement of the adjacent
glands, is most likely to be the primary lesion of syphilis.

[Illustration: FIG. 38.--Primary Lesion on Thumb, with Secondary
Eruption on Forearm.[1]]

[1] From _A System of Syphilis_, vol. ii., edited by D'Arcy Power and
J. Keogh Murphy, Oxford Medical Publications.

#The Soft Sore, Soft Chancre, or Chancroid.#--The differential diagnosis
of syphilis necessitates the consideration of the _soft sore_, _soft
chancre_, or _chancroid_, which is also a common form of venereal
disease, and is due to infection with a virulent pus-forming bacillus,
first described by Ducrey in 1889. Ducrey's bacillus occurs in the form
of minute oval rods measuring about 1.5 u in length, which stain readily
with any basic aniline dye, but are quickly decolorised by Gram's
method. They are found mixed with other organisms in the purulent
discharge from the sore, and are chiefly arranged in small groups or in
short chains. Soft sores are always contracted by direct contact from
another individual, and the incubation period is a short one of from two
to five days. They are usually situated in the vicinity of the fraenum,
and, in women, about the labia minora or fourchette; they probably
originate in abrasions in these situations. They appear as pustules,
which are rapidly converted into small, acutely inflamed ulcers with
sharply cut, irregular margins, which bleed easily and yield an abundant
yellow purulent discharge. They are devoid of the induration of
syphilis, are painful, and nearly always multiple, reproducing
themselves in successive crops by auto-inoculation. Soft sores are often
complicated by phimosis and balanitis, and they frequently lead to
infection of the glands in the groin. The resulting bubo is ill-defined,
painful, and tender, and suppuration occurs in about one-fourth of the
cases. The overlying skin becomes adherent and red, and suppuration
takes place either in the form of separate foci in the interior of the
individual glands, or around them; in the latter case, on incision, the
glands are found lying bathed in pus. Ducrey's bacillus is found in pure
culture in the pus. Sometimes other pyogenic organisms are superadded.
After the bubo has been opened the wound may take on the characters of a
soft sore.

_Treatment._--Soft sores heal rapidly when kept clean. If concealed
under a tight prepuce, an incision should be made along the dorsum to
give access to the sores. They should be washed with eusol, and dusted
with a mixture of one part iodoform and two parts boracic or salicylic
acid, or, when the odour of iodoform is objected to, of equal parts of
boracic acid and carbonate of zinc. Immersion of the penis in a bath of
eusol for some hours daily is useful. The sore is then covered with a
piece of gauze kept in position by drawing the prepuce over it, or by a
few turns of a narrow bandage. Sublimed sulphur frequently rubbed into
the sore is recommended by C. H. Mills. If the sores spread in spite of
this, they should be painted with cocaine and then cauterised. When the
glands in the groin are infected, the patient must be confined to bed,
and a dressing impregnated with ichthyol and glycerin (10 per cent.)
applied; the repeated use of a suction bell is of great service.
Harrison recommends aspiration of a bubonic abscess, followed by
injection of 1 in 20 solution of tincture of iodine into the cavity;
this is in turn aspirated, and then 1 or 2 c.c. of the solution injected
and left in. This is repeated as often as the cavity refills. It is
sometimes necessary to let the pus out by one or more small incisions
and continue the use of the suction bell.

_Diagnosis of Primary Syphilis._--In cases in which there is a history
of an incubation period of from three to five weeks, when the sore is
indurated, persistent, and indolent, and attended with bullet-buboes in
the groin, the diagnosis of primary syphilis is not difficult. Owing,
however, to the great importance of instituting treatment at the
earliest possible stage of the infection, an effort should be made to
establish the diagnosis without delay by demonstrating the spirochaete.
Before any antiseptic is applied, the margin of the suspected sore is
rubbed with gauze, and the serum that exudes on pressure is collected
in a capillary tube and sent to a pathologist for microscopical
examination. A better specimen can sometimes be obtained by puncturing
an enlarged lymph gland with a hypodermic needle, injecting a few minims
of sterile saline solution and then aspirating the blood-stained fluid.

The Wassermann test must not be relied upon for diagnosis in the early
stage, as it does not appear until the disease has become generalised
and the secondary manifestations are about to begin. The practice of
waiting in doubtful cases before making a diagnosis until secondary
manifestations appear is to be condemned.

Extra-genital chancres, _e.g._ sores on the fingers of doctors or
nurses, are specially liable to be overlooked, if the possibility of
syphilis is not kept in mind.

It is important to bear in mind _the possibility of a patient having
acquired a mixed infection_ with the virus of soft chancre, which will
manifest itself a few days after infection, and the virus of syphilis,
which shows itself after an interval of several weeks. This occurrence
was formerly the source of much confusion in diagnosis, and it was
believed at one time that syphilis might result from soft sores, but it
is now established that syphilis does not follow upon soft sores unless
the virus of syphilis has been introduced at the same time. The
practitioner must be on his guard, therefore, when a patient asks his
advice concerning a venereal sore which has appeared within a few days
of exposure to infection. Such a patient is naturally anxious to know
whether he has contracted syphilis or not, but neither a positive nor a
negative answer can be given--unless the spirochaete can be identified.

Syphilis is also to be diagnosed from _epithelioma_, the common form of
cancer of the penis. It is especially in elderly patients with a tight
prepuce that the induration of syphilis is liable to be mistaken for
that associated with epithelioma. In difficult cases the prepuce must be
slit open.

Difficulty may occur in the diagnosis of primary syphilis from _herpes_,
as this may appear as late as ten days after connection; it commences as
a group of vesicles which soon burst and leave shallow ulcers with a
yellow floor; these disappear quickly on the use of an antiseptic
dusting powder.

Apprehensive patients who have committed sexual indiscretions are apt to
regard as syphilitic any lesion which happens to be located on the
penis--for example, acne pustules, eczema, psoriasis papules, boils,
balanitis, or venereal warts.

_The local treatment_ of the primary sore consists in attempting to
destroy the organisms _in situ_. An ointment made up of calomel 33
parts, lanoline 67 parts, and vaseline 10 parts (Metchnikoff's cream) is
rubbed into the sore several times a day. If the surface is unbroken, it
may be dusted lightly with a powder composed of equal parts of calomel
and carbonate of zinc. A gauze dressing is applied, and the penis and
scrotum should be supported against the abdominal wall by a triangular
handkerchief or bathing-drawers; if there is inflammatory oedema the
patient should be confined to bed.

In _concealed chancres_ with phimosis, the sac of the prepuce should be
slit up along the dorsum to admit of the ointment being applied. If
phagedaena occurs, the prepuce must be slit open along the dorsum, or if
sloughing, cut away, and the patient should have frequent sitz baths of
weak sublimate lotion. When the chancre is within the meatus, iodoform
bougies are inserted into the urethra, and the urine should be rendered
bland by drinking large quantities of fluid.

General treatment is considered on p. 149.

#Secondary Syphilis.#--The following description of secondary syphilis
is based on the average course of the disease in untreated cases. The
onset of constitutional symptoms occurs from six to twelve weeks after
infection, and the manifestations are the result of the entrance of the
virus into the general circulation, and its being carried to all parts
of the body. The period during which the patient is liable to suffer
from secondary symptoms ranges from six months to two years.

In some cases the general health is not disturbed; in others the patient
is feverish and out of sorts, losing appetite, becoming pale and anaemic,
complaining of lassitude, incapacity for exertion, headache, and pains
of a rheumatic type referred to the bones. There is a moderate degree of
leucocytosis, but the increase is due not to the polymorpho-nuclear
leucocytes but to lymphocytes. In isolated cases the temperature rises
to 101 o or 102 o F. and the patient loses flesh. The lymph glands,
particularly those along the posterior border of the sterno-mastoid,
become enlarged and slightly tender. The hair comes out, eruptions
appear on the skin and mucous membranes, and the patient may suffer from
sore throat and affections of the eyes. The local lesions are to be
regarded as being of the nature of reactions against accumulations of
the parasite, lymphocytes and plasma cells being the elements chiefly
concerned in the reactive process.

_Affections of the Skin_ are among the most constant manifestations. An
evanescent macular rash, not unlike that of measles--_roseola_--is the
first to appear, usually in from six to eight weeks from the date of
infection; it is widely diffused over the trunk, and the original dull
rose-colour soon fades, leaving brownish stains, which in time
disappear. It is usually followed by a _papular eruption_, the
individual papules being raised above the surface of the skin, smooth or
scaly, and as they are due to infiltration of the skin they are more
persistent than the roseoles. They vary in size and distribution, being
sometimes small, hard, polished, and closely aggregated like lichen,
sometimes as large as a shilling-piece, with an accumulation of scales
on the surface like that seen in psoriasis. The co-existence of scaly
papules and faded roseoles is very suggestive of syphilis.

Other types of eruption are less common, and are met with from the third
month onwards. A _pustular_ eruption, not unlike that of acne, is
sometimes a prominent feature, but is not characteristic of syphilis
unless it affects the scalp and forehead and is associated with the
remains of the papular eruption. The term _ecthyma_ is applied when the
pustules are of large size, and, after breaking on the surface, give
rise to superficial ulcers; the discharge from the ulcer often dries up
and forms a scab or crust which is continually added to from below as
the ulcer extends in area and depth. The term _rupia_ is applied when
the crusts are prominent, dark in colour, and conical in shape, roughly
resembling the shell of a limpet. If the crust is detached, a sharply
defined ulcer is exposed, and when this heals it leaves a scar which is
usually circular, thin, white, shining like satin, and the surrounding
skin is darkly pigmented; in the case of deep ulcers, the scar is
depressed and adherent (Fig. 39).

[Illustration: FIG. 39.--Syphilitic Rupia, showing the limpet-shaped
crusts or scabs.]

In the later stages there may occur a form of creeping or _spreading
ulceration of the skin_ of the face, groin, or scrotum, healing at one
edge and spreading at another like tuberculous lupus, but distinguished
from this by its more rapid progress and by the pigmentation of the
scar.

_Condylomata_ are more characteristic of syphilis than any other type of
skin lesion. They are papules occurring on those parts of the body where
the skin is habitually moist, and especially where two skin surfaces are
in contact. They are chiefly met with on the external genitals,
especially in women, around the anus, beneath large pendulous mammae,
between the toes, and at the angles of the mouth, and in these
situations their development is greatly favoured by neglect of
cleanliness. They present the appearance of well-defined circular or
ovoid areas in which the skin is thickened and raised above the surface;
they are covered with a white sodden epidermis, and furnish a scanty but
very infective discharge. Under the influence of irritation and want of
rest, as at the anus or at the angle of the mouth, they are apt to
become fissured and superficially ulcerated, and the discharge then
becomes abundant and may crust on the surface, forming yellow scabs. At
the angle of the mouth the condylomatous patches may spread to the
cheek, and when they ulcerate may leave fissure-like scars radiating
from the mouth--an appearance best seen in inherited syphilis (Fig. 44).

_The Appendages of the Skin._--The _hair_ loses its gloss, becomes dry
and brittle, and readily falls out, either as an exaggeration of the
normal shedding of the hair, or in scattered areas over the scalp
(_syphilitic alopoecia_). The hair is not re-formed in the scars which
result from ulcerated lesions of the scalp. The _nail-folds_
occasionally present a pustular eruption and superficial ulceration, to
which the name _syphilitic onychia_ has been applied; more commonly the
nails become brittle and ragged, and they may even be shed.

_The Mucous Membranes_, and especially those of the _mouth_ and
_throat_, suffer from lesions similar to those met with on the skin. On
a mucous surface the papular eruption assumes the form of _mucous
patches_, which are areas with a congested base covered with a thin
white film of sodden epithelium like wet tissue-paper. They are best
seen on the inner aspect of the cheeks, the soft palate, uvula, pillars
of the fauces, and tonsils. In addition to mucous patches, there may be
a number of small, _superficial, kidney-shaped ulcers_, especially along
the margins of the tongue and on the tonsils. In the absence of mucous
patches and ulcers, the sore throat may be characterised by a bluish
tinge of the inflamed mucous membrane and a thin film of shed epithelium
on the surface. Sometimes there is an elongated sinuous film which has
been likened to the track of a snail. In the _larynx_ the presence of
congestion, oedema, and mucous patches may be the cause of persistent
hoarseness. The _tongue_ often presents a combination of lesions,
including ulcers, patches where the papillae are absent, fissures, and
raised white papules resembling warts, especially towards the centre of
the dorsum. These lesions are specially apt to occur in those who smoke,
drink undiluted alcohol or spirits, or eat hot condiments to excess, or
who have irregular, sharp-cornered teeth. At a later period, and in
those who are broken down in health from intemperance or other cause,
the sore throat may take the form of rapidly spreading, penetrating
ulcers in the soft palate and pillars of the fauces, which may lead to
extensive destruction of tissue, with subsequent scars and deformity
highly characteristic of previous syphilis.

In the _Bones_, lesions occur which assume the clinical features of an
evanescent periostitis, the patient complaining of nocturnal pains over
the frontal bone, sternum, tibiae, and ulnae, and localised tenderness on
tapping over these bones.

In the _Joints_, a serous synovitis or hydrops may occur, chiefly in the
knee, on one or on both sides.

_The Affections of the Eyes_, although fortunately rare, are of great
importance because of the serious results which may follow if they are
not recognised and treated. _Iritis_ is the commonest of these, and may
occur in one or in both eyes, one after the other, from three to eight
months after infection. The patient complains of impairment of sight and
of frontal or supraorbital pain. The eye waters and is hypersensitive,
the iris is discoloured and reacts sluggishly to light, and there is a
zone of ciliary congestion around the cornea. The appearance of minute
white nodules or flakes of lymph at the margin of the pupil is
especially characteristic of syphilitic iritis. When adhesions have
formed between the iris and the structures in relation to it, the pupil
dilates irregularly under atropin. Although complete recovery is to be
expected under early and energetic treatment, if neglected, _iritis_ may
result in occlusion of the pupil and permanent impairment or loss of
sight.

The other lesions of the eye are much rarer, and can only be discovered
on ophthalmoscopic examination.

The virus of syphilis exerts a special influence upon the _Blood
Vessels_, exciting a proliferation of the endothelial lining which
results in narrowing of their lumen, _endarteritis_, and a perivascular
infiltration in the form of accumulations of plasma cells around the
vessels and in the lymphatics that accompany them.

In the _Brain_, in the later periods of secondary and in tertiary
syphilis, changes occur as a result of the narrowing of the lumen of the
arteries, or of their complete obliteration by thrombosis. By
interfering with the nutrition of those parts of the brain supplied by
the affected arteries, these lesions give rise to clinical features of
which severe headache and paralysis are the most prominent.

Affections of the _Spinal Cord_ are extremely rare, but paraplegia from
myelitis has been observed.

Lastly, attention must be directed to the remarkable variations observed
in different patients. Sometimes the virulent character of the disease
can only be accounted for by an idiosyncrasy of the patient.
Constitutional symptoms, particularly pyrexia and anaemia, are most often
met with in young women. Patients over forty years of age have greater
difficulty in overcoming the infection than younger adults. Malarial and
other infections, and the conditions attending life in tropical
countries, from the debility which they cause, tend to aggravate and
prolong the disease, which then assumes the characters of what has been
called _malignant syphilis_. All chronic ailments have a similar
influence, and alcoholic intemperance is universally regarded as a
serious aggravating factor.

_Diagnosis of Secondary Syphilis._--A routine examination should be made
of the parts of the body which are most often affected in this
disease--the scalp, mouth, throat, posterior cervical glands, and the
trunk, the patient being stripped and examined by daylight. Among the
_diagnostic features of the skin affections_ the following may be
mentioned: They are frequently, and sometimes to a marked degree,
symmetrical; more than one type of eruption--papules and pustules, for
example--are present at the same time; there is little itching; they are
at first a dull-red colour, but later present a brown pigmentation which
has been likened to the colour of raw ham; they exhibit a predilection
for those parts of the forehead and neck which are close to the roots of
the hair; they tend to pass off spontaneously; and they disappear
rapidly under treatment.

#Serum Diagnosis--Wassermann Reaction.#--Wassermann found that if an
extract of syphilitic liver rich in spirochaetes is mixed with the serum
from a syphilitic patient, a large amount of complement is fixed. The
application of the test is highly complicated and can only be carried
out by an expert pathologist. For the purpose he is supplied with from 5
c.c. to 10 c.c. of the patient's blood, withdrawn under aseptic
conditions from the median basilic vein by means of a serum syringe, and
transferred to a clean and dry glass tube. There is abundant evidence
that the Wassermann test is a reliable means of establishing a diagnosis
of syphilis.

A definitely positive reaction can usually be obtained between the
fifteenth and thirtieth day after the appearance of the primary lesion,
and as time goes on it becomes more marked. During the secondary period
the reaction is practically always positive. In the tertiary stage also
it is positive except in so far as it is modified by the results of
treatment. In para-syphilitic lesions such as general paralysis and
tabes a positive reaction is almost always present. In inherited
syphilis the reaction is positive in every case. A positive reaction may
be present in other diseases, for example, frambesia, trypanosomiasis,
and leprosy.

As the presence of the reaction is an evidence of the activity of the
spirochaetes, repeated applications of the test furnish a valuable means
of estimating the efficacy of treatment. The object aimed at is to
change a persistently positive reaction to a permanently negative one.

#Treatment of Syphilis.#--In the treatment of syphilis the two main
objects are to maintain the general health at the highest possible
standard, and to introduce into the system therapeutic agents which will
inhibit or destroy the invading parasite.

The second of these objects has been achieved by the researches of
Ehrlich, who, in conjunction with his pupil, Hata, has built up a
compound, the dihydrochloride of dioxydiamido-arseno-benzol, popularly
known as salvarsan or "606." Other preparations, such as kharsivan,
arseno-billon, and diarsenol, are chemically equivalent to salvarsan,
containing from 27 to 31 per cent. of arsenic, and are equally
efficient. The full dose is 0.6 grm. All these members of the "606"
group form an acid solution when dissolved in water, and must be
rendered alkaline before being injected. As subcutaneous and
intra-muscular injections cause considerable pain, and may cause
sloughing of the tissues, "606" preparations must be injected
intravenously. Ehrlich has devised a preparation--neo-salvarsan, or
"914," which is more easily prepared and forms a neutral solution. It
contains from 18 to 20 per cent. of arsenic. Neo-kharsivan,
novo-arseno-billon, and neo-diarsenol belong to the "914" group, the
full dosage of which is 0.9 grm. As subcutaneous and intra-muscular
injections of the "914" group are not painful, and even more efficient
than intravenous injections, the administration is simpler.

Galyl, luargol, and other preparations act in the same way as the "606"
and "914" groups.

The "606" preparations may be introduced into the veins by injection or
by means of an apparatus which allows the solution to flow in by
gravity. The left median basilic vein is selected, and a platino-iridium
needle with a short point and a bore larger than that of the ordinary
hypodermic syringe is used. The needle is passed for a few millimetres
along the vein, and the solution is then slowly introduced; before
withdrawing the needle some saline is run in to diminish the risk of
thrombosis.

The "914" preparations may be injected either into the subcutaneous
tissue of the buttock or into the substance of the gluteus muscle. The
part is then massaged for a few minutes, and the massage is repeated
daily for a few days.

No hard-and-fast rules can be laid down as to what constitutes a
complete course of treatment. Harrison recommends as a _minimum_ course
of one of the "914" preparations in _early primary cases_ an initial
dose of 0.45 grm. given intra-muscularly or into the deep subcutaneous
tissue; the same dose a week later; 0.6 grm. the following week; then
miss a week and give 9.6 grms. on two successive weeks; then miss two
weeks and give 0.6 grm. on two more successive weeks.

When a _positive Wassermann reaction_ is present before treatment is
commenced, the above course is prolonged as follows: for three weeks is
given a course of potassium iodide, after which four more weekly
injections of 0.6 grm. of "914" are given.

With each injection of "914" after the first, throughout the whole
course 1 grain of mercury is injected intra-muscularly.

In the course of a few hours, there is usually some indisposition, with
a feeling of chilliness and slight rise of temperature; these symptoms
pass off within twenty-four hours, and in a few days there is a decided
improvement of health. Three or four days after an intra-muscular
injection there may be pain and stiffness in the gluteal region.

These preparations are the most efficient therapeutic agents that have
yet been employed in the treatment of syphilis.

The manifestations of the disease disappear with remarkable rapidity.
Observations show that the spirochaetes lose their capacity for movement
within an hour or two of the administration, and usually disappear
altogether in from twenty-four to thirty-six hours. Wassermann's
reaction usually yields a negative result in from three weeks to two
months, but later may again become positive. Subsequent doses of the
arsenical preparation are therefore usually indicated, and should be
given in from 7 to 21 days according to the dose.

When syphilis occurs in a _pregnant woman_, she should be given in the
early months an ordinary course of "914," followed by 10-grain doses of
potassium iodide twice daily. The injections may be repeated two months
later, and during the remainder of the pregnancy 2-grain mercury pills
are given twice daily (A. Campbell). The presence of albumen in the
urine contra-indicates arsenical treatment.

It need scarcely be pointed out that the use of powerful drugs like
"606" and "914" is not free from risk; it may be mentioned that each
dose contains nearly three grains of arsenic. Before the administration
the patient must be overhauled; its administration is contra-indicated
in the presence of disease of the heart and blood vessels, especially a
combination of syphilitic aortitis and sclerosis of the coronary
arteries, with degeneration of the heart muscle; in affections of the
central nervous system, especially advanced paralysis, and in such
disturbances of metabolism as are associated with diabetes and Bright's
disease. Its use is not contra-indicated in any lesion of active
syphilis.

The administration is controlled by the systematic examination of the
urine for arsenic.

_The Administration of Mercury._--The success of the arsenical
preparations has diminished the importance of mercury in the treatment
of syphilis, but it is still used to supplement the effect of the
injections. The amount of mercury to be given in any case must be
proportioned to the idiosyncrasies of the patient, and it is advisable,
before commencing the treatment, to test his urine and record his
body-weight. The small amount of mercury given at the outset is
gradually increased. If the body-weight falls, or if the gums become
sore and the breath foul, the mercury should be stopped for a time. If
salivation occurs, the drinking of hot water and the taking of hot baths
should be insisted upon, and half-dram doses of the alkaline sulphates
prescribed.

_Methods of Administering Mercury._--(1) _By the Mouth._--This was for
long the most popular method in this country, the preparation usually
employed being grey powder, in pills or tablets, each of which contains
one grain of the powder. Three of these are given daily in the first
instance, and the daily dose is increased to five or even seven grains
till the standard for the individual patient is arrived at. As the grey
powder alone sometimes causes irritation of the bowels, it should be
combined with iron, as in the following formula: Hydrarg. c. cret. gr. 1;
ferri sulph. exsiccat. gr. 1 or 2.

(2) _By Inunction._--Inunction consists in rubbing into the pores of the
skin an ointment composed of equal parts of 20 per cent. oleate of
mercury and lanolin. Every night after a hot bath, a dram of the
ointment (made up by the chemist in paper packets) is rubbed for fifteen
minutes into the skin where it is soft and comparatively free from
hairs. When the patient has been brought under the influence of the
mercury, inunction may be replaced by one of the other methods, of
administering the drug.

(3) _By Intra-muscular Injection._--This consists in introducing the
drug by means of a hypodermic syringe into the substance of the gluteal
muscles. The syringe is made of glass, and has a solid glass piston; the
needle of platino-iridium should be 5 cm. long and of a larger calibre
than the ordinary hypodermic needle. The preparation usually employed
consists of: metallic mercury or calomel 1 dram, lanolin and olive oil
each 2 drams; it must be warmed to allow of its passage through the
needle. Five minims--containing one grain of metallic mercury--represent
a dose, and this is injected into the muscles above and behind the great
trochanter once a week. The contents of the syringe are slowly
expressed, and, after withdrawing the needle, gentle massage of the
buttock should be employed. Four courses each of ten injections are
given the first year, three courses of the same number during the second
and third years, and two courses during the fourth year (Lambkin).

_The General Health._--The patient must lead a regular life and
cultivate the fresh-air habit, which is as beneficial in syphilis as in
tuberculosis. Anaemia, malaria, and other sources of debility must
receive appropriate treatment. The diet should be simple and easily
digested, and should include a full supply of milk. Alcohol is
prohibited. The excretory organs are encouraged to act by the liberal
drinking of hot water between meals, say five or six tumblerfuls in the
twenty-four hours. The functions of the skin are further aided by
frequent hot baths, and by the wearing of warm underclothing. While the
patient should avoid exposure to cold, and taxing his energies by undue
exertion, he should be advised to take exercise in the open air. On
account of the liability to lesions of the mouth and throat, he should
use tobacco in moderation, his teeth should be thoroughly overhauled by
the dentist, and he should brush them after every meal, using an
antiseptic tooth powder or wash. The mouth and throat should be rinsed
out night and morning with a solution of chlorate of potash and alum, or
with peroxide of hydrogen.

_Treatment of the Local Manifestations._--_The skin lesions_ are treated
on the same lines as similar eruptions of other origin. As local
applications, preparations of mercury are usually selected, notably the
ointments of the red oxide of mercury, ammoniated mercury, or oleate of
mercury (5 per cent.), or the mercurial plaster introduced by Unna. In
the treatment of condylomata the greatest attention must be paid to
cleanliness and dryness. After washing and drying the affected patches,
they are dusted with a powder consisting of equal parts of calomel and
carbonate of zinc; and apposed skin surfaces, such as the nates or
labia, are separated by sublimate wool. In the ulcers of later secondary
syphilis, crusts are got rid of in the first instance by means of a
boracic poultice, after which a piece of lint or gauze cut to the size
of the ulcer and soaked in black wash is applied and covered with
oil-silk. If the ulcer tends to spread in area or in depth, it should be
scraped with a sharp spoon, and painted over with acid nitrate of
mercury, or a local hyperaemia may be induced by Klapp's suction
apparatus.

_In lesions of the mouth and throat_, the teeth should be attended to;
the best local application is a solution of chromic acid--10 grains to
the ounce--painted on with a brush once daily. If this fails, the
lesions may be dusted with calomel the last thing at night. For deep
ulcers of the throat the patient should gargle frequently with chlorine
water or with perchloride of mercury (1 in 2000); if the ulcer continues
to spread it should be painted with acid nitrate of mercury.

In the treatment of _iritis_ the eyes are shaded from the light and
completely rested, and the pupil is well dilated by atropin to prevent
adhesions. If there is much pain, a blister may be applied to the
temple.

_The Relations of Syphilis to Marriage._--Before the introduction of the
Ehrlich-Hata treatment no patient was allowed to marry until three years
had elapsed after the disappearance of the last manifestation. While
marriage might be entered upon under these conditions without risk of
the husband infecting the wife, the possibility of his conveying the
disease to the offspring cannot be absolutely excluded. It is
recommended, as a precautionary measure, to give a further mercurial
course of two or three months' duration before marriage, and an
intravenous injection of an arsenical preparation.

#Intermediate Stage.#--After the dying away of the secondary
manifestations and before the appearance of tertiary lesions, the
patient may present certain symptoms which Hutchinson called
_reminders_. These usually consist of relapses of certain of the
affections of the skin, mouth, or throat, already described. In the
skin, they may assume the form of peeling patches in the palms, or may
appear as spreading and confluent circles of a scaly papular eruption,
which if neglected may lead to the formation of fissures and superficial
ulcers. Less frequently there is a relapse of the eye affections, or of
paralytic symptoms from disease of the cerebral arteries.

#Tertiary Syphilis.#--While the manifestations of primary and secondary
syphilis are common, those of the tertiary period are by comparison
rare, and are observed chiefly in those who have either neglected
treatment or who have had their powers of resistance lowered by
privation, by alcoholic indulgence, or by tropical disease.

It is to be borne in mind that in a certain proportion of men and in a
larger proportion of women, the patient has no knowledge of having
suffered from syphilis. Certain slight but important signs may give the
clue in a number of cases, such as irregularity of the pupils or failure
to react to light, abnormality of the reflexes, and the discovery of
patches of leucoplakia on the tongue, cheek, or palate.

The _general character of tertiary manifestations_ may be stated as
follows: They attack by preference the tissues derived from the
mesoblastic layer of the embryo--the cellular tissue, bones, muscles,
and viscera. They are often localised to one particular tissue or organ,
such, for example, as the subcutaneous cellular tissue, the bones, or
the liver, and they are rarely symmetrical. They are usually aggressive
and persistent, with little tendency to natural cure, and they may be
dangerous to life, because of the destructive changes produced in such
organs as the brain or the larynx. They are remarkably amenable to
treatment if instituted before the stage which is attended with
destruction of tissue is reached. Early tertiary lesions may be
infective, and the disease may be transmitted by the discharges from
them; but the later the lesions the less is the risk of their containing
an infective virus.

The most prominent feature of tertiary syphilis consists in the
formation of granulation tissue, and this takes place on a scale
considerably larger than that observed in lesions of the secondary
period. The granulation tissue frequently forms a definite swelling or
tumour-like mass (syphiloma), which, from its peculiar elastic
consistence, is known as a _gumma_. In its early stages a gumma is a
firm, semi-translucent greyish or greyish-red mass of tissue; later it
becomes opaque, yellow, and caseous, with a tendency to soften and
liquefy. The gumma does harm by displacing and replacing the normal
tissue elements of the part affected, and by involving these in the
degenerative changes, of the nature of caseation and necrosis, which
produce the destructive lesions of the skin, mucous membranes, and
internal organs. This is true not only of the circumscribed gumma, but
of the condition known as _gummatous infiltration_ or _syphilitic
cirrhosis_, in which the granulation tissue is diffused throughout the
connective-tissue framework of such organs as the tongue or liver. Both
the gummatous lesions and the fibrosis of tertiary syphilis are directly
excited by the spirochaetes.

The life-history of an untreated gumma varies with its environment. When
protected from injury and irritation in the substance of an internal
organ such as the liver, it may become encapsulated by fibrous tissue,
and persist in this condition for an indefinite period, or it may be
absorbed and leave in its place a fibrous cicatrix. In the interior of a
long bone it may replace the rigid framework of the shaft to such an
extent as to lead to pathological fracture. If it is near the surface of
the body--as, for example, in the subcutaneous or submucous cellular
tissue, or in the periosteum of a superficial bone, such as the palate,
the skull, or the tibia--the tissue of which it is composed is apt to
undergo necrosis, in which the overlying skin or mucous membrane
frequently participates, the result being an ulcer--the tertiary
syphilitic ulcer (Figs. 40 and 41).

_Tertiary Lesions of the Skin and Subcutaneous Cellular Tissue._--The
clinical features of a _subcutaneous gumma_ are those of an indolent,
painless, elastic swelling, varying in size from a pea to an almond or
walnut. After a variable period it usually softens in the centre, the
skin over it becomes livid and dusky, and finally separates as a slough,
exposing the tissue of the gumma, which sometimes appears as a mucoid,
yellowish, honey-like substance, more frequently as a sodden, caseated
tissue resembling wash-leather. The caseated tissue of a gumma differs
from that of a tuberculous lesion in being tough and firm, of a buff
colour like wash-leather, or whitish, like boiled fish. The degenerated
tissue separates slowly and gradually, and in untreated cases may be
visible for weeks in the floor of the ulcer.

[Illustration: FIG. 40.--Ulcerating Gumma of Lips.

(From a photograph lent by Dr. Stopford Taylor and Dr. R. W. Mackenna.)]

_The tertiary ulcer_ may be situated anywhere, but is most frequently
met with on the leg, especially in the region of the knee (Fig. 42) and
over the calf. There may be one or more ulcers, and also scars of
antecedent ulcers. The edges are sharply cut, as if punched out; the
margins are rounded in outline, firm, and congested; the base is
occupied by gummatous tissue, or, if this has already separated and
sloughed out, by unhealthy granulations and a thick purulent discharge.
When the ulcer has healed it leaves a scar which is depressed, and if
over a bone, is adherent to it. The features of the tertiary ulcer,
however, are not always so characteristic as the above description would
imply. It is to be diagnosed from the "leg ulcer," which occurs almost
exclusively on the lower third of the leg; from Bazin's disease (p. 74);
from the ulcers that result from certain forms of malignant disease,
such as rodent cancer, and from those met with in chronic glanders.

_Gummatous Infiltration of the Skin_ ("Syphilitic Lupus").--This is a
lesion, met with chiefly on the face and in the region of the external
genitals, in which the skin becomes infiltrated with granulation tissue
so that it is thickened, raised above the surface, and of a brownish-red
colour. It appears as isolated nodules, which may fuse together; the
epidermis becomes scaly and is shed, giving rise to superficial ulcers
which are usually covered by crusted discharge. The disease tends to
spread, creeping over the skin with a serpiginous, crescentic, or
horse-shoe margin, while the central portion may heal and leave a scar.
From the fact of its healing in the centre while it spreads at the
margin, it may resemble tuberculous disease of the skin. It can usually
be differentiated by observing that the infiltration is on a larger
scale; the progress is much more rapid, involving in the course of
months an area which in the case of tuberculosis would require as many
years; the scars are sounder and are less liable to break down again;
and the disease rapidly yields to anti-syphilitic treatment.

[Illustration: FIG. 41.--Ulceration of nineteen year's duration
in a woman aet. 24, the subject of inherited syphilis, showing active
ulceration, cicatricial contraction, and sabre-blade deformity of
tibiae.]

_Tertiary lesions of mucous membrane and of the submucous cellular
tissue_ are met with chiefly in the tongue, nose, throat, larynx, and
rectum. They originate as gummata or as gummatous infiltrations, which
are liable to break down and lead to the formation of ulcers which may
prove locally destructive, and, in such situations as the larynx, even
dangerous to life. In the tongue the tertiary ulcer may prove the
starting-point of cancer; and in the larynx or rectum the healing of the
ulcer may lead to cicatricial stenosis.

Tertiary lesions of the _bones and joints_, of the _muscles_, and of the
_internal organs_, will be described under these heads. The part played
by syphilis in the production of disease of arteries and of aneurysm
will be referred to along with diseases of blood vessels.

[Illustration: FIG. 42.--Tertiary Syphilitic Ulceration in region of
Knee and on both Thumbs of woman aet. 37.]

_Treatment._--The most valuable drugs for the treatment of the
manifestations of the tertiary period are the arsenical preparations and
the iodides of sodium and potassium. On account of their depressing
effects, the latter are frequently prescribed along with carbonate of
ammonium. The dose is usually a matter of experiment in each individual
case; 5 grains three times a day may suffice, or it may be necessary to
increase each dose to 20 or 25 grains. The symptoms of iodism which may
follow from the smaller doses usually disappear on giving a larger
amount of the drug. It should be taken after meals, with abundant water
or other fluid, especially if given in tablet form. It is advisable to
continue the iodides for from one to three months after the lesions for
which they are given have cleared up. If the potassium salt is not
tolerated, it may be replaced by the ammonium or sodium iodide.

_Local Treatment._--The absorption of a subcutaneous gumma is often
hastened by the application of a fly-blister. When a gumma has broken on
the surface and caused an ulcer, this is treated on general principles,
with a preference, however, for applications containing mercury or
iodine, or both. If a wet dressing is required to cleanse the ulcer,
black wash may be used; if a powder to promote dryness, one containing
iodoform; if an ointment is indicated, the choice lies between the red
oxide of mercury or the dilute nitrate of mercury ointment, and one
consisting of equal parts of lanolin and vaselin with 2 per cent. of
iodine. Deep ulcers, and obstinate lesions of the bones, larynx, and
other parts may be treated by excision or scraping with the sharp spoon.

#Second Attacks of Syphilis.#--Instances of re-infection of syphilis
have been recorded with greater frequency since the more general
introduction of arsenical treatment. A remarkable feature in such cases
is the shortness of the interval between the original infection and the
alleged re-infection; in a recent series of twenty-eight cases, this
interval was less than a year. Another feature of interest is that when
patients in the tertiary stage of syphilis are inoculated with the virus
from lesions from these in the primary and secondary stage lesions of
the tertiary type are produced.

Reference may be made to the #relapsing false indurated chancre#,
described by Hutchinson and by Fournier, as it may be the source of
difficulty in diagnosis. A patient who has had an infecting chancre one
or more years before, may present a slightly raised induration on the
penis at or close to the site of his original sore. This relapsed
induration is often so like that of a primary chancre that it is
impossible to distinguish between them, except by the history. If there
has been a recent exposure to venereal infection, it is liable to be
regarded as the primary lesion of a second attack of syphilis, but the
further progress shows that neither bullet-buboes nor secondary
manifestations develop. These facts, together with the disappearance of
the induration under treatment, make it very likely that the lesion is
really gummatous in character.


INHERITED SYPHILIS

One of the most striking features of syphilis is that it may be
transmitted from infected parents to their offspring, the children
exhibiting the manifestations that characterise the acquired form of the
disease.

The more recent the syphilis in the parent, the greater is the risk of
the disease being communicated to the offspring; so that if either
parent suffers from secondary syphilis the infection is almost
inevitably transmitted.

While it is certain that either parent may be responsible for
transmitting the disease to the next generation, the method of
transmission is not known. In the case of a syphilitic mother it is most
probable that the infection is conveyed to the foetus by the placental
circulation. In the case of a syphilitic father, it is commonly believed
that the infection is conveyed to the ovum through the seminal fluid at
the moment of conception. If a series of children, one after the other,
suffer from inherited syphilis, it is almost invariably the case that
the mother has been infected.

In contrast to the acquired form, inherited syphilis is remarkable for
the absence of any primary stage, the infection being a general one from
the outset. The spirochaete is demonstrated in incredible numbers in the
liver, spleen, lung, and other organs, and in the nasal secretion, and,
from any of these, successful inoculations in monkeys can readily be
made. The manifestations differ in degree rather than in kind from those
of the acquired disease; the difference is partly due to the fact that
the virus is attacking developing instead of fully formed tissues.

The virus exercises an injurious influence on the foetus, which in many
cases dies during the early months of intra-uterine life, so that
miscarriage results, and this may take place in repeated pregnancies,
the date at which the miscarriage occurs becoming later as the virus in
the mother becomes attenuated. Eventually a child is carried to full
term, and it may be still-born, or, if born alive, may suffer from
syphilitic manifestations. It is difficult to explain such vagaries of
syphilitic inheritance as the infection of one twin and the escape of
the other.

_Clinical Features._--We are not here concerned with the severe forms of
the disease which prove fatal, but with the milder forms in which the
infant is apparently healthy when born, but after from two to six weeks
begins to show evidence of the syphilitic taint.

The usual phenomena are that the child ceases to thrive, becomes thin
and sallow, and suffers from eruptions on the skin and mucous membranes.
There is frequently a condition known as _snuffles_, in which the nasal
passages are obstructed by an accumulation of thin muco-purulent
discharge which causes the breathing to be noisy. It usually begins
within a month after birth and before the eruptions on the skin appear.
When long continued it is liable to interfere with the development of
the nasal bones, so that when the child grows up there results a
condition known as the "saddle-nose" deformity (Figs. 43 and 44).

[Illustration: FIG. 43.--Facies of Inherited Syphilis.

(From Dr. Byrom Bramwell's _Atlas of Clinical Medicine_.)]

_Affections of the Skin._--Although all types of skin affection are met
with in the inherited disease, the most important is a _papular_
eruption, the papules being of large size, with a smooth shining top and
of a reddish-brown colour. It affects chiefly the buttocks and thighs,
the genitals, and other parts which are constantly moist. It is
necessary to distinguish this specific eruption from a form of eczema
which occurs in these situations in non-syphilitic children, the points
that characterise the syphilitic condition being the infiltration of the
skin and the coppery colour of the eruption. At the anus the papules
acquire the characters of _condylomata_, also at the angles of the
mouth, where they often ulcerate and leave radiating scars.

_Affections of the Mucous Membranes._--The inflammation of the nasal
mucous membrane that causes snuffles has already been referred to. There
may be mucous patches in the mouth, or a stomatitis which is of
importance, because it results in interference with the development of
the permanent teeth. The mucous membrane of the larynx may be the seat
of mucous patches or of catarrh, and as a result the child's cry is
hoarse.

_Affections of the Bones._--Swellings at the ends of the long bones, due
to inflammation at the epiphysial junctions, are most often observed at
the upper end of the humerus and in the bones in the region of the
elbow. Partial displacement and mobility at the ossifying junction may
be observed. The infant cries when the part is touched; and as it does
not move the limb voluntarily, the condition is spoken of as _the
pseudo-paralysis of syphilis_. Recovery takes place under
anti-syphilitic treatment and immobilisation of the limb.

Diffuse thickening of the shafts of the long bones, due to a deposit of
new bone by the periosteum, is sometimes met with.

[Illustration: FIG. 44.--Facies of Inherited Syphilis.]

The conditions of the skull known as Parrot's nodes or bosses, and
craniotabes, were formerly believed to be characteristic of inherited
syphilis, but they are now known to occur, particularly in rickety
children, from other causes. The _bosses_ result from the heaping up of
new spongy bone beneath the pericranium, and they may be grouped
symmetrically around the anterior fontanelle, or may extend along either
side of the sagittal suture, which appears as a deep groove--the
"natiform skull." The bosses disappear in time, but the skull may remain
permanently altered in shape, the frontal and parietal eminences
appearing unduly prominent. The term _craniotabes_ is applied when the
bone becomes thin and soft, reverting to its original membranous
condition, so that the affected areas dimple under the finger like
parchment or thin cardboard; its localisation in the posterior parts of
the skull suggests that the disappearance of the osseous tissue is
influenced by the pressure of the head on the pillow. Craniotabes is
recovered from as the child improves in health.

Between the ages of three and six months, certain other phenomena may be
met with, such as _effusion into the joints_, especially the knees;
_iritis_, in one or in both eyes, and enlargement of the spleen and
liver.

In the majority of cases the child recovers from these early
manifestations, especially when efficiently treated, and may enjoy an
indefinite period of good health. On the other hand, when it attains the
age of from two to four years, it may begin to manifest lesions which
correspond to those of the tertiary period of acquired syphilis.

#Later Lesions.#--In the skin and subcutaneous tissue, the later
manifestations may take the form of localised gummata, which tend to
break down and form ulcers, on the leg for example, or of a spreading
gummatous infiltration which is also liable to ulcerate, leaving
disfiguring scars, especially on the face. The palate and fauces may be
destroyed by ulceration. In the nose, especially when the ulcerative
process is associated with a putrid discharge--ozaena--the destruction of
tissue may be considerable and result in unsightly deformity. The entire
palatal portions of the upper jaws, the vomer, turbinate, and other
bones bounding the nasal and oral cavities, may disappear, so that on
looking into the mouth the base of the skull is readily seen. Gummatous
disease is frequently observed also in the flat bones of the skull, in
the bones of the hand, as syphilitic dactylitis, and in the bones of the
forearm and leg. When the tibia is affected the disease is frequently
bilateral, and may assume the form of gummatous ulcers and sinuses. In
later years the tibia may present alterations in shape resulting from
antecedent gummatous disease--for example, nodular thickenings of the
shaft, flattening of the crest, or a more uniform increase in thickness
and length of the shaft of the bone, which, when it is curved in
addition, is described as the "sabre-blade" deformity. Among lesions of
the viscera, mention should be made of gumma of the testis, which causes
the organ to become enlarged, uneven, and indurated. This has even been
observed in infants a few months old.

Occasionally a syphilitic child suffers from a succession of these
gummatous lesions with resulting ill-health, and, it may be, waxy
disease of the internal organs; on the other hand, it may recover and
present no further manifestations of the inherited taint.

_Affections of the Eyes._--At or near puberty there is frequently
observed an affection of the eyes, known as _chronic interstitial
keratitis_, the relationship of which to inherited syphilis was first
established by Hutchinson. It occurs between the ages of six and sixteen
years, and usually affects one eye before the other. It commences as a
diffuse haziness or steaminess near the centre of the cornea, and as it
spreads the entire cornea assumes the appearance of ground glass. The
chief complaint is of dimness of sight, which may almost amount to
blindness, but there is little pain or photophobia; a certain amount of
conjunctival and ciliary congestion is usually present, and there may be
_iritis_ in addition. The cornea, or parts of it, may become of a deep
pink or salmon colour from the formation in it of new blood vessels. The
affection may last for from eighteen months to two years. Complete
recovery usually takes place, but slight opacities, especially in the
site of former salmon patches, may persist, and the disease occasionally
relapses. _Choroiditis_ and _retinitis_ may also occur, and leave
permanent changes easily recognised on examination with the
ophthalmoscope.

Among the rarer and more serious lesions of the inherited disease may be
mentioned gummatous disease in the _larynx and trachea_, attended with
ulceration and resulting in stenosis; and lesions of the _nervous
system_ which may result in convulsions, paralysis, or dementia.

In a limited number of cases, about the period of puberty there may
develop _deafness_, which is usually bilateral and may become absolute.

_Changes in the Permanent Teeth._--These affect specially the upper
central incisors, which are dwarfed and stand somewhat apart in the gum,
with their free edges converging towards one another. They are tapering
or peg-shaped, and present at their cutting margin a deep semilunar
notch. These appearances are commonly associated with the name of
Hutchinson, who first described them. Affecting as they do the
permanent teeth, they are not available for diagnosis until the child is
over eight years of age. Henry Moon drew attention to a change in the
first molars; these are reduced in size and dome-shaped through dwarfing
of the central tubercle of each cusp.

#Diagnosis of Inherited Syphilis.#--When there is a typical eruption on
the buttocks and snuffles there is no difficulty in recognising the
disease. When, however, the rash is scanty or is obscured by co-existing
eczema, most reliance should be placed on the distribution of the
eruption, on the brown stains which are left after it has passed off, on
the presence of condylomata, and of fissuring and scarring at the angles
of the mouth. The history of the mother relative to repeated
miscarriages and still-born children may afford confirmatory evidence.
In doubtful cases, the diagnosis may be aided by the Wassermann test and
by noting the therapeutic effects of grey powder, which, in syphilitic
infants, usually effects a marked and rapid improvement both in the
symptoms and in the general health.

While a considerable number of syphilitic children grow up without
showing any trace of their syphilitic inheritance, the majority retain
throughout life one or more of the following characteristics, which may
therefore be described as _permanent signs of the inherited disease_:
Dwarfing of stature from interference with growth at the epiphysial
junctions; the forehead low and vertical, and the parietal and frontal
eminences unduly prominent; the bridge of the nose sunken and rounded;
radiating scars at the angles of the mouth; perforation or destruction
of the hard palate; Hutchinson's teeth; opacities of the cornea from
antecedent keratitis; alterations in the fundus oculi from choroiditis;
deafness; depressed scars or nodes on the bones from previous gummata;
"sabre-blade" or other deformity of the tibiae.

#The Contagiousness of Inherited Syphilis.#--In 1837, Colles of Dublin
stated his belief that, while a syphilitic infant may convey the disease
to a healthy wet nurse, it is incapable of infecting its own mother if
nursed by her, even although she may never have shown symptoms of the
disease. This doctrine, which is known as _Colles' law_, is generally
accepted in spite of the alleged occurrence of occasional exceptions.
The older the child, the less risk there is of its communicating the
disease to others, until eventually the tendency dies out altogether, as
it does in the tertiary period of acquired syphilis. It should be
added, however, that the contagiousness of inherited syphilis is denied
by some observers, who affirm that, when syphilitic infants prove
infective, the disease has been really acquired at or soon after birth.

There is general agreement that the subjects of inherited syphilis
cannot transmit the disease by inheritance to their offspring, and that,
although they very rarely acquire the disease _de novo_, it is possible
for them to do so.

#Prognosis of Inherited Syphilis.#--Although inherited syphilis is
responsible for a large but apparently diminishing mortality in infancy,
the subjects of this disease may grow up to be as strong and healthy as
their neighbours. Hutchinson insisted on the fact that there is little
bad health in the general community that can be attributed to inherited
syphilis.

#Treatment.#--Arsenical injections are as beneficial in the inherited as
in the acquired disease. An infant the subject of inherited syphilis
should, if possible, be nursed by its mother, and failing this it should
be fed by hand. In infants at the breast, the drug may be given to the
mother; in others, it is administered in the same manner as already
described--only in smaller doses. On the first appearance of syphilitic
manifestations it should be given 0.05 grm, novarsenbillon, injected
into the deep subcutaneous tissues every week for six weeks, followed by
one year's mercurial inunction--a piece of mercurial ointment the size
of a pea being inserted under the infant's binder. In older children the
dose is proportionately increased. The general health should be improved
in every possible direction; considerable benefit may be derived from
the use of cod-liver oil, and from preparations containing iron and
calcium. Surgical interference may be required in the destructive
gummatous lesions of the nose, throat, larynx, and bones, either with
the object of arresting the spread of the disease, or of removing or
alleviating the resulting deformities. In children suffering from
keratitis, the eyes should be protected from the light by smoked or
coloured glasses, and the pupils should be dilated with atropin from
time to time, especially in cases complicated with iritis.

#Acquired Syphilis in Infants and Young Children.#--When syphilis is met
with in infants and young children, it is apt to be taken for granted
that the disease has been inherited. It is possible, however, for them
to acquire the disease--as, for example, while passing through the
maternal passages during birth, through being nursed or kissed by
infected women, or through the rite of circumcision. The risk of
infection which formerly existed by the arm-to-arm method of
vaccination has been abolished by the use of calf lymph.

The clinical features of the acquired disease in infants and young
children are similar to those observed in the adult, with a tendency,
however, to be more severe, probably because the disease is often late
in being recognised and treated.




CHAPTER X

TUMOURS[2]


Definition--Etiology--General characters of innocent and malignant
    tumours. CLASSIFICATION OF TUMOURS: I. Connective-tissue tumours:
    (1) _Innocent_: _Lipoma_, _Xanthoma_, _Chondroma_, _Osteoma_,
    _Odontoma_, _Fibroma_, _Myxoma_, _Endothelioma_, etc.; (2)
    _Malignant_: _Sarcoma_--II. Epithelial tumours: (1) _Innocent_:
    _Papilloma_, _Adenoma_, _Cystic Adenoma_; (2) _Malignant_:
    _Epithelioma_, _Glandular Cancer_, _Rodent Cancer_, _Melanotic
    Cancer_--III. Dermoids--IV. Teratoma. Cysts: _Retention_,
    _Exudation_, _Implantation_, _Parasitic_, _Lymphatic or Serous_.
    Ganglion.

[2] For the histology of tumours the reader is referred to a text-book
of pathology.

A tumour or neoplasm is a localised swelling composed of newly formed
tissue which fulfils no physiological function. Tumours increase in size
quite independently of the growth of the body, and there is no natural
termination to their growth. They are to be distinguished from such
over-growths as are of the nature of simple hypertrophy or local
giantism, and also from inflammatory swellings, which usually develop
under the influence of a definite cause, have a natural termination, and
tend to disappear when the cause ceases to act.

The _etiology of tumours_ is imperfectly understood. Various factors,
acting either singly or in combination, may be concerned in their
development. Certain tumours, for example, are the result of some
congenital malformation of the particular tissue from which they take
origin. This would appear to be the case in many tumours of blood
vessels (angioma), of cartilage (chondroma), of bone (osteoma), and of
secreting gland tissue (adenoma). The theory that tumours originate from
foetal residues or "rests," is associated with the name of Cohnheim.
These rests are supposed to be undifferentiated embryonic cells which
remain embedded amongst fully formed tissue elements, and lie dormant
until they are excited into active growth and give rise to a tumour.
This mode of origin is illustrated by the development of dermoids from
sequestrated portions of epidermis.

Among the local factors concerned in the development of tumours,
reference must be made to the influence of irritation. This is probably
an important agent in the causation of many of the tumours met with in
the skin and in mucous membranes--for example, cancer of the skin, of
the lip, and of the tongue. The part played by injury is doubtful. It
not infrequently happens that the development of a tumour is preceded by
an injury of the part in which it grows, but it does not necessarily
follow that the injury and the tumour are related as cause and effect.
It is possible that an injury may stimulate into active growth
undifferentiated tissue elements or "rests," and so determine the growth
of a tumour, or that it may alter the characters of a tumour which
already exists, causing it to grow more rapidly.

The popular belief that there is some constitutional peculiarity
concerned in the causation of tumours is largely based on the fact that
certain forms of new growth--for example, cancer--are known to occur
with undue frequency in certain families. The same influence is more
striking in the case of certain innocent tumours--particularly multiple
osteomas and lipomas--which are hereditary in the same sense as
supernumerary or webbed fingers, and appear in members of the same
family through several generations.


INNOCENT AND MALIGNANT TUMOURS

For clinical purposes, tumours are arbitrarily divided into two
classes--the innocent and the malignant. The outstanding difference
between them is, that while the evil effects of innocent tumours are
entirely local and depend for their severity on the environment of the
growth, malignant tumours wherever situated, in addition to producing
similar local effects, injure the general health and ultimately cause
death.

_Innocent_, benign, or simple tumours present a close structural
resemblance to the normal tissues of the body. They grow slowly, and are
usually definitely circumscribed by a fibrous capsule, from which they
are easily enucleated, and they do not tend to recur after removal. In
their growth they merely push aside and compress adjacent parts, and
they present no tendency to ulcerate and bleed unless the overlying skin
or mucous membrane is injured. Although usually solitary, some are
multiple from the outset--for example, fatty, fibrous, and bony tumours,
warts, and fibroid tumours of the uterus. They produce no constitutional
disturbance. They only threaten life when growing in the vicinity of
vital organs, and then only in virtue of their situation--for example,
death may result from an innocent tumour in the air-passage causing
suffocation, in the intestine causing obstruction of the bowels, or in
the vertebral canal causing pressure on the spinal medulla.

_Malignant tumours_ usually show a marked departure from the structure
and arrangement of the normal tissues of the body. Although the cells of
which they are composed are derived from normal tissue cells, they tend
to take on a lower, more vegetative form; they may be regarded as
parasites living at the expense of the organism, multiplying
indefinitely and destroying everything with which they come in contact.

Malignant tumours grow more rapidly than innocent tumours, and tend to
infiltrate their surroundings by sending out prolongations or offshoots;
they are therefore liable to recur after an operation which is
restricted to the removal of the main tumour. They are not encapsulated,
although they may appear to be circumscribed by condensation of the
surrounding tissues; they are rarely multiple at the outset, but show a
marked tendency to spread to other parts of the body. Fragments of the
parent tumour may become separated and be carried off in the lymph or
blood-stream and deposited in other parts of the body, where they give
rise to secondary growths. Malignant tumours tend to invade and destroy
the overlying skin or mucous membrane, and thus give rise to bleeding
ulcers; if the tumour tissue protrudes through the gap in the skin, it
is said to _fungate_. In course of time they give rise to a condition of
ill-health or _cachexia_, the patient becoming pale, sallow, feverish,
and emaciated, probably as a result of chronic poisoning from the
absorption of toxic products from the tumour. They ultimately destroy
life, it may be by their local effects, such as ulceration and
haemorrhage, by favouring the entrance of septic infection, by
interfering with the function of organs which are essential to life, by
cachexia, or by a combination of these effects.

The situation of a malignant tumour exercises considerable influence on
the rapidity, as well as on the mode, in which it causes death. Some
cancers, such as that known as "rodent," show malignant features which
are entirely local, while others, such as melanotic cancer, exhibit a
malignancy characterised by rapid generalisation of growths throughout
the body. Tumours that are structurally alike may show variations in
malignancy, according to their situation and to the age of the patient,
as well as to other factors which are as yet unknown.

In attempting to arrive at a conclusion as to the innocence or
malignancy of any tumour, too much reliance must not be placed on its
histological features; its situation, rate of growth, and other clinical
features must also be taken into consideration. It cannot be too
emphatically stated that there is no hard-and-fast line between innocent
and malignant growths; there is an indefinite transition from one to the
other. The possibility of the transformation of a benign into a
malignant tumour must be admitted. Such a transformation implies a
change in the structure of the growth, and has been observed especially
in fibrous and cartilaginous tumours, in tumours of the thyreoid gland,
and in uterine fibroids. The alteration in character may take place
under the influence of injury, prolonged or repeated irritation,
incomplete removal of the benign tumour by operation, or the altered
physiological conditions of the tissues which attend upon advancing
years.

After a tumour has been removed by operation it should as a routine
measure be subjected to microscopical examination; the results are often
instructive and sometimes other than what was expected.

#Varieties of Tumours.#--In the following description, tumours are
classified on an anatomical basis, taking in order first the
connective-tissue group and subsequently those that originate in
epithelium.


INNOCENT CONNECTIVE-TISSUE TUMOURS

#Lipoma.#--A lipoma is composed of fat resembling that normally present
in the body. The commonest variety is the _subcutaneous lipoma_, which
grows from the subcutaneous fat, and forms a soft, irregularly lobulated
tumour (Fig. 45). The fat is arranged in lobules separated by
connective-tissue septa, which are continuous with the capsule
surrounding the tumour and with the overlying skin, which becomes
dimpled or puckered when an attempt is made to pinch it up. As the fat
is almost fluid at the body temperature, fluctuation can usually be
detected. These tumours vary greatly in size, occur at all ages, grow
slowly, and, while generally solitary, are sometimes multiple. They are
most commonly met with on the shoulder, buttock, or back. In certain
situations, such as the thigh and perineum, they tend to become
pedunculated (Fig. 46).

A fatty tumour is to be diagnosed from a cold abscess and from a cyst.
The distinguishing features of the lipoma are the tacking down and
dimpling of the overlying skin, the lobulation of the tumour, which is
recognised when it is pressed upon with the flat of the hand, and, more
reliable than either of these, the mobility, the tumour slipping away
when pressed upon at its margin.

[Illustration: FIG. 45.--Subcutaneous Lipoma showing lobulation.]

The prognosis is more favourable than in any other tumour as it never
changes its characters; the only reasons for its removal by operation
are its unsightliness and its probable increase in size in the course of
years. The operation consists in dividing the skin and capsule over the
tumour and shelling it out. Care must be taken that none of the outlying
lobules are left behind. If the overlying skin is damaged or closely
adherent, it should be removed along with the tumour.

[Illustration: FIG. 46.--Pedunculated Lipoma of Buttock of forty years'
duration in a woman aet. 68.]

_Multiple subcutaneous lipomas_ are frequently symmetrical, and in a
certain group of cases, met with chiefly in women, pain is a prominent
symptom, hence the term _adiposis dolorosa_ (Dercum). These multiple
tumours show little or no tendency to increase in size, and the pain
which attends their development does not persist.

In the neck, axilla, and pubes a diffuse overgrowth of the subcutaneous
fat is sometimes met with, forming symmetrical tumour-like masses, known
as _diffuse lipoma_. As this is not, strictly speaking, a tumour, the
term _diffuse lipomatosis_ is to be preferred. A similar condition was
described by Jonathan Hutchinson as being met with in the domestic
animals. If causing disfigurement, the mass of fat may be removed by
operation.

[Illustration: FIG. 47.--Diffuse Lipomatosis of Neck.]

_Lipoma in other Situations._--The _periosteal lipoma_ is usually
congenital, and is most often met with in the hand; it forms a
projecting lobulated tumour, which, when situated in the palm, resembles
an angioma or a lymphangioma. The _subserous lipoma_ arises from the
extra-peritoneal fat in the posterior abdominal wall, in which case it
tends to grow forwards between the layers of the mesentery and to give
rise to an abdominal tumour; or it may grow from the extra-peritoneal
fat in the anterior abdominal wall and protrude from one of the hernial
openings or through an abnormal opening in the parietes, constituting a
_fatty hernia_. A _subsynovial lipoma_ grows from the fat surrounding
the synovial membrane of a joint, and projects into its interior, giving
rise to the symptoms of loose body. Lipomas are also met with growing
from the adipose connective tissue _between or in the substance of
muscles_, and, when situated beneath the deep fascia, such as the fascia
lata of the thigh, the characteristic signs are obscured and a
differential diagnosis is difficult. It may be differentiated from a
cold abscess by puncture with an exploring needle.

[Illustration: FIG. 48.--Zanthoma of Hands in a girl aet. 14, showing
multiple subcutaneous tumours (cf. Fig. 49).

(Sir H. J. Stiles' case.)]

#Zanthoma# is a rare but interesting form of tumour, composed of a
fibrous and fatty tissue, containing a granular orange-yellow pigment,
resembling that of the corpus luteum. It originates in the corium and
presents two clinical varieties. In the first of these, it occurs in the
form of raised yellow patches, usually in the skin of the eyelids of
persons after middle life, and in many instances is associated with
chronic jaundice; the patches are often symmetrical, and as they
increase in size they tend to fuse with another.

The second form occurs in children and adolescents; it may affect
several generations of the same family, and is often multiple, there
being a combination of thickened yellow patches of skin and projecting
tumours, some of which may attain a considerable size (Figs. 48 and 49).
On section, the tumour tissue presents a brilliant orange or saffron
colour.

There is no indication for removing the tumours unless for the deformity
which they cause; exposure to the X-rays is to be preferred to
operation.

[Illustration: FIG. 49.--Zanthoma showing Subcutaneous Tumours on
Buttocks. From same patient as Fig. 48.]

#Chondroma.#--A chondroma is mainly composed of cartilage. Processes of
vascular connective tissue pass in between the nodules of cartilage
composing the tumour from the fibrous capsule which surrounds it. On
section it is of a greyish-blue colour and semi-translucent. The tumour
is firm and elastic in consistence, but certain portions may be densely
hard from calcification or ossification, while other portions may be
soft and fluctuating as a result of myxomatous degeneration and
liquefaction. These tumours grow slowly and painlessly, and may surround
nerves and arteries without injuring them. They may cause a deep hollow
in the bone from which they originate. All intermediate forms between
the innocent chondroma and the malignant chondro-sarcoma are met with.
Chondroma may occur in a multiple form, especially in relation to the
phalanges and metacarpal bones. When growing in the interior of a bone
it causes a spindle-shaped enlargement of the shaft, which in the case
of a phalanx or metacarpal bone may resemble the dactylitis resulting
from tubercle or syphilis. A chondroma appears as a clear area in a
skiagram.

A _skiagram_ of a bone in which there is a chondroma shows a clear
rounded area in the position of the tumour, which must be differentiated
from similar clear areas due to other kinds of tumour, especially the
myeloma; when it has undergone calcification or ossification, it gives a
shadow as dark as bone.

[Illustration: FIG. 50.--Chondroma growing from infraspinous fossa of
Scapula.]

[Illustration: FIG. 51.--Chondroma of Metacarpal Bone of Thumb.]

_Treatment._--In view of the unstable quality of the chondroma,
especially of its liability to become malignant, it should be removed as
soon as it is recognised. In those projecting from the surface of a
bone, both the tumour and its capsule should be removed. If in the
interior, a sufficient amount of the cortex should be removed to allow
of the tumour being scraped out, and care must be taken that no nodules
of cartilage are left behind. In multiple chondromas of the hand, when
the fingers are crippled and useless, exposure to the X-rays should be
given a trial, and in extreme cases the question of amputation may have
to be considered. When a cartilaginous tumour takes on active growth, it
must be treated as malignant.

The chondromas that are met with at the ends of the long bones in
children and young adults form a group by themselves. They are usually
related to the epiphysial cartilage, and it was suggested by Virchow
that they take origin from islands of cartilage which have not been used
up in the process of ossification. They are believed to occur more
frequently in those who have suffered from rickets. They have no
malignant tendencies and tend to undergo ossification concurrently with
the epiphysial cartilage from which they take origin, and constitute
what are known as _cartilaginous exostoses_. These are sometimes met
with in a multiple form, and may occur in several generations of the
same family. They are considered in greater detail in the chapter
dealing with tumours of bone.

Minute nodules of cartilage sometimes form in the synovial membrane of
joints and lining of tendon sheaths and bursae: they tend to become
detached from the membrane and constitute loose bodies; they also
undergo a variable amount of calcification and ossification, so as to be
visible in skiagrams. They are further considered with loose bodies in
joints.

Cartilaginous tumours in the parotid, submaxillary gland, and testicle
belong to a class of "mixed tumours" that will be referred to later.

#Osteoma.#--The true osteoma is composed of bony tissue, and originates
from the skeleton. Two varieties are recognised--the spongy or
cancellous, and the ivory or compact. The _spongy_ or _cancellous
osteoma_ is really an ossified chondroma, and is met with at the ends of
the long bones (Fig. 52). From the fact that it projects from the
surface of the bone it is often spoken of as an _exostosis_. It grows
slowly, and rarely causes any discomfort unless it presses upon a
nerve-trunk or upon a bursa which has developed over it. The Rontgen
rays show a dark shadow corresponding to the ossified portion of the
tumour, and continuous with that of the bone from which it is growing
(Fig. 138). Operative interference is only indicated when the tumour is
giving rise to inconvenience. It is then removed, its base or neck being
divided by means of the chisel. The multiple variety of osteoma is
considered with the diseases of bone.

The bony outgrowth from the terminal phalanx of the great toe--known as
the _subungual exostosis_--is described and figured on p. 404. Bony
projections or "spurs" sometimes occur on the under surface of the
calcaneus, and, projecting downwards and forwards from the greater
process, cause pain on putting the heel to the ground.

[Illustration: FIG. 52.--Cancellous Osteoma of lower end of Femur.]

The _ivory_ or _compact osteoma_ is composed of dense bone, and usually
grows from the skull. It is generally sessile and solitary, and may grow
into the interior of the skull, into the frontal sinus, into the cavity
of the orbit or nose, or may fill up the external auditory meatus,
causing most unsightly deformity and interference with sight, breathing,
and hearing.

Bony formations occur in _muscles and tendons_, especially at their
points of attachment to the skeleton, and are known as false exostoses;
they are described with the diseases of muscles.

#Odontoma.#--An odontoma is composed of dental tissues in varying
proportions and different degrees of development, arising from
tooth-germs or from teeth still in process of growth (Bland Sutton).
Odontomas resemble teeth in so far that during their development they
remain hidden below the mucous membrane and give no evidence of their
existence. There then succeeds, usually between the twentieth and
twenty-fifth years, an eruptive stage, which is often attended with
suppuration, and this may be the means of drawing attention to the
tumour. Following Bland Sutton, several varieties of odontoma may be
distinguished according to the part of the tooth-germ concerned in their
formation.

The _epithelial odontoma_ is derived from persistent portions of the
epithelium of the enamel organ, and constitutes a multilocular cystic
tumour which is chiefly met with in the mandible. The cystic spaces of
the tumour contain a brownish glairy fluid. These tumours have been
described by Eve under the name of multilocular cystic epithelial
tumours of the jaw.

The _follicular odontoma_, also known as a _dentigerous cyst_, is
derived from the distension of a tooth follicle. It constitutes a cyst
containing a viscid fluid, and an imperfectly formed tooth is often
found embedded in its wall. The cyst usually forms in relation to one of
the permanent molars, and may attain considerable dimensions.

The _fibrous odontoma_ is the result of an overgrowth of fibrous tissue
surrounding the tooth sac, which encapsulates the tooth and prevents its
eruption. The thickened tooth sac is usually mistaken for a fibrous
tumour, until, after removal, the tooth is recognised in its interior.

_Composite Odontoma._--This is a convenient term to apply to certain
hard dental tumours which are met with in the jaws, and consist of
enamel, dentine, and cement. The tumour is to be regarded as being
derived from an abnormal growth of all the elements of a tooth germ, or
of two or more tooth germs, indiscriminately fused with one another. It
may appear in childhood, and form a smooth unyielding tumour, often of
considerable size, replacing the corresponding permanent tooth. It may
cause a purulent discharge, and in some cases it has been extruded after
sloughing of the overlying soft parts. Many examples of this variety of
odontoma, growing in the nasal cavity or in the maxillary sinus, have
been erroneously regarded as osteomas even after removal.

On section, the tumour is usually laminated, and is seen to consist
mainly of dentine with a partial covering of enamel and cement.

_Diagnosis._--Odontomas are often only diagnosed after removal. When
attended with suppuration, the condition has been mistaken for disease
of the jaw. Fibrous odontomas have been mistaken for sarcoma, and
portions of the maxilla removed unnecessarily. Any circumscribed tumour
of the jaw, particularly when met with in a young adult, should suggest
the possibility of an odontoma. Skiagrams often give useful information
both for diagnosis and for treatment.

_Treatment._--The solid varieties of odontoma can usually be shelled out
after dividing the overlying soft parts. In the follicular variety, it
is usually sufficient to excise a portion of the wall, scrape out the
interior, and remove any tooth that may be present. The cavity is then
packed and allowed to heal from the bottom.

#Fibroma.#--A fibroma is a tumour composed of fibrous connective tissue.
A distinction may be made between the _soft fibroma_, which is
comparatively rich in cells and blood vessels, and in which the fibres
are arranged loosely; and the _hard fibroma_, which is composed of
closely packed bundles of fibres often arranged in a concentric fashion
around the blood vessels. The cut surface of the soft fibroma presents a
pinkish-white, fleshy appearance, resembling the slowly growing forms of
sarcoma; that of a hard fibroma presents a dry, glistening appearance,
aptly compared to watered silk. The soft variety grows much more rapidly
than the hard. In certain fibromas--in those, for example, which grow
from the periosteum of the base of the skull and project into the
naso-pharynx--the blood vessels are dilated into sinuses and have no
proper sheaths; they therefore tend to remain open when divided, and to
bleed excessively. Transition forms between soft fibroma and sarcoma are
met with, so that in operating for their removal it is safer to take
away the capsule along with the tumour, and the patient should be kept
under observation in view of the risk of recurrence.

The skin--especially the skin of the buttock--is one of the favourite
seats of fibroma, and it may occur in a multiple form. It is met with
also in the subcutaneous and intermuscular cellular tissue, and in the
abdominal wall, where it sometimes attains considerable dimensions.
Various forms of fibroma are met with in the mamma and are described
with diseases of that organ. The fibrous overgrowths in the skin, known
as _keloid_ and _molluscum fibrosum_, and those met with in the _sheaths
of nerves_, are described elsewhere. Fibroid tumours of the uterus are
described with myoma.

_Diffuse fibroma_ or _Fibromatosis_, analogous to lipomatosis, is met
with in the connective tissue of the skin and sheaths of nerves, and
constitutes one form of neuro-fibromatosis; a similar change is also met
with in the stomach and colon.

#Myxoma.#--A myxoma is composed of tissue of a soft gelatinous,
semifluid consistence. The pure myxoma is extremely rare, and
clinically resembles the lipoma. Myxomatous tissue is, however,
frequently found in other connective-tissue tumours as a result of
degeneration, for example, in cartilaginous tumours and in sarcomas.
Myxomatous tissue is also a prominent constituent of the "innocent
parotid tumour." Mucous polypus of the nose, which is often described as
a myxoma, is merely a pendulous process of oedematous mucous membrane.

[Illustration: FIG. 53.--Myeloma of Shaft of Humerus, causing
pathological fracture. (Mr. J. W. Struthers' case.)

(The unusual site of the tumour is to be noted.)]

#Myeloma.#--A myeloma is composed of large multinuclear giant cells
surrounded by round and spindle cells. The cut surface of the tumour
presents a deep red or maroon colour. While occasionally met with in
tendon sheaths and bursae, and is then of an orange-yellow colour, the
myeloma occurs most frequently in the cancellous tissue at the ends of
the long bones, its favourite site being the upper end of the tibia.
Although formerly classified as a sarcoma, it is the exception for it to
present malignant features, and it can usually be extirpated by local
measures without fear of recurrence. The diagnosis, X-ray appearances,
and the method of removal are considered with the diseases of bone.
Sometimes the myeloma is met with in multiple form in the skeleton, in
association with an unusual form of protein in the urine (Bence Jones).

#Myoma.#--A myoma is composed of non-striped muscle fibres. A pure myoma
is very rare, and is met with in organs possessed of non-striped muscle,
such as the stomach, intestine, urinary bladder, and prostate. In the
uterus, which is the most common situation, these tumours contain a
considerable admixture of fibrous tissue, and are known as _fibroids_ or
_fibro-myomas_. They present on section a fasciculated appearance, which
may resemble that of a section of balls of cotton (Fig. 54). They are
encapsulated and vascular, frequently attain a large size, and may be
single or multiple. While they may occasion neither inconvenience nor
suffering, they frequently give rise to profuse haemorrhage from the
uterus, and may cause serious symptoms by pressing injuriously on the
ureters or the intestine, or by complicating pregnancy and parturition.

The #Rhabdomyoma# is an extremely rare form of tumour, met with in the
kidney, uterus, and testicle. It contains striped muscle fibres, and is
supposed to originate from a residue of muscular tissue which has become
sequestrated during development.

[Illustration: FIG. 54.--Fibro-myoma of Uterus.

(Anatomical Museum, University of Edinburgh.)]

#Glioma.#--A glioma is a tumour composed of neuroglia. It is met with
exclusively in the central nervous system, retina, and optic nerve. It
is a slowly growing, soft, ill-defined tumour, which displaces the
adjacent nerve centres and nerve tracts, and is liable to become the
seat of haemorrhage and thus to give rise to pressure symptoms resembling
apoplexy. The glioma of the retina tends to grow into the vitreous
humour and to perforate the globe. It is usually of the nature of a
glio-sarcoma and is highly malignant.

#Endotheliomas# take origin from the endothelium of lymph vessels and
blood vessels, and serous cavities. They show great variation in type,
partly because of the number of different kinds of endothelium from
which they are derived, and partly because the new connective tissue
which is formed is liable to undergo transformation into other tissues.
They may be soft or hard, solid or cystic, diffuse or circumscribed;
they grow very slowly, and are almost always innocent, although
recurrence has been occasionally observed. Cases of multiple
endotheliomata of the skin have recently been described by Wise.

_Angioma_, _lymphangioma_, and _neuroma_ are described with the disease
of the individual tissues.


MALIGNANT CONNECTIVE-TISSUE TUMOURS--SARCOMA

The term sarcoma is applied to any connective-tissue tumour which
exhibits malignant characters. The essential structural feature is the
predominance of the cellular elements over the intercellular substance
or stroma, in which respect a sarcoma resembles the connective tissue of
the embryo. The typical sarcoma consists chiefly of immature or
embryonic connective tissue. It most frequently originates from fascia,
intermuscular connective tissue, periosteum, bone-marrow, and skin, and
forms a rounded or nodulated tumour which appears to be encapsulated,
but the capsule merely consists of the condensed surrounding tissues,
and usually contains sarcomatous elements. The consistence of the tumour
depends on the nature and amount of the stroma, and on the presence of
degenerative changes. The softer medullary forms are composed almost
exclusively of cells; while the harder forms--such as the fibro-,
chondro-, and osteo-sarcoma--are provided with an abundant stroma and
are relatively poor in cells. Degenerative changes may produce areas of
softening or liquefaction which result in the formation of cystic
cavities in the interior of the tumour. The colour depends on the amount
of blood in the tumour, and on the presence of the products of
degeneration.

The blood vessels are usually represented by mere chinks or spaces
between the cells. This peculiarity accounts for the facility with which
haemorrhage takes place into the substance of the tumour, the persistence
of the bleeding when it is incised or ulcerates through the skin, and
the readiness with which the sarcomatous cells are carried off and
infect distant parts through the blood-stream. Sarcomas are devoid of
lymphatics, and unless originating in lymphatic structures--for example,
in the tonsil--they rarely infect the lymph glands. Minute portions of
the tumour grow into the small veins, and, becoming detached, are
transported by the blood-current to distant organs, where they are
arrested in the capillaries and give rise to secondary growths. These
are most frequently situated in the lungs, except when the primary
growth lies within the territory of the portal circulation, in which
case they occur in the liver. The secondary growths closely resemble the
parent tumour. Sarcoma may invade an adjacent vein on such a scale that
if the invading portion becomes detached it may constitute a dangerous
embolus. This may be observed in sarcoma of the kidney, the growth
taking place along the renal vein until it projects into the vena cava.

[Illustration: FIG. 55.--Recurrent Sarcoma of Sciatic Nerve in a woman
aet. 27. Recurrence twenty months after removal of primary growth.]

In its growth, a sarcoma compresses and destroys neighbouring parts,
surrounds vessels and nerves, and may lead to destruction of the skin,
either by invading it, or more commonly by causing sloughing from
pressure. Inflammatory and suppurative changes may take place as a
result of pyogenic infection following upon sloughing of the overlying
skin or upon an exploratory incision. Once the skin is broken the tumour
fungates through the opening. Sarcomas vary in malignancy, especially as
regards rapidity of growth and capacity for dissemination. Certain of
them, such as the so-called "recurrent fibroid of Paget," grow
comparatively slowly, and are only malignant in the sense that they tend
to recur locally after removal; others--especially the more cellular
ones--grow with extreme rapidity, and are early disseminated throughout
the body, resembling in these respects the most malignant forms of
cancer. They are usually solitary in the first instance, although
primary multiple growths are occasionally met with in the skin and in
the bones.

Many varieties of sarcoma are recognised, according to its structural
peculiarities. Thus, in virtue of the size and character of the cells,
we have the _small round-celled_ and the _large round-celled_ sarcoma,
the _small_ and the _large spindle-celled_, the _giant-celled_ and the
_mixed-celled_ sarcoma. The _lympho-sarcoma_ presents a structure
similar to that of lymph-follicular tissue, and the _alveolar sarcoma_
an arrangement of cells in alveoli resembling that seen in cancers. When
there is a considerable amount of intercellular fibrous tissue, the
tumour is called a _fibro-sarcoma_.

[Illustration: FIG. 56.--Fungating Sarcoma of Arm.

(Dr. J. M'Watt's case.)]

The term _lymphangio-sarcoma_ is applied when the cells of the tumour
are derived from the endothelium of lymph spaces and vessels. The
_angio-sarcomas_ are those in which blood vessels form a prominent
element in the structure of the tumour. They are sometimes derived from
innocent angiomas, and they may be so vascular as to pulsate and on
auscultation yield a blowing murmur like an aneurysm. The
_glio-sarcoma_, _myxo-sarcoma_, _chondro-sarcoma_, and _myo-sarcoma_ are
mixed forms which usually develop in pre-existing innocent tumours. The
_osteo-sarcoma_ is characterised by the formation in the tumour of bone,
the medullary spaces being occupied by sarcomatous cells in place of
marrow. The _osteoid sarcoma_ is characterised by the formation of a
tissue resembling bone but deficient in lime salts, and the _petrifying
sarcoma_ by the formation of calcified areas in the stroma. These
varieties, although met with chiefly in the bones, may occur in soft
tissues such as muscle, and in such organs as the mamma. The pigmented
varieties include the _chloroma_, which is of a light-green colour, and
the _melanotic sarcoma_, which is brown or black. The _psammoma_ is a
sarcoma containing a material resembling sand; it is chiefly met with in
the membranes of the brain. The _chordoma_ is a rare form of tumour
originating from the remains of the notochord in the region of the
spheno-occipital synchondrosis or in the sacro-coccygeal region.

_Diagnosis of Sarcoma._--A sarcoma is to be differentiated from an
inflammatory swelling such as results from tubercle, actinomycosis, or
syphilis, from an innocent tumour, and from a cancer. The points on
which the diagnosis is founded are discussed with the different tissues
and organs.

_Treatment._--The removal of the tumour by operation is the most
reliable method of treatment; in order to be successful it must be
undertaken before dissemination has taken place, and a considerable area
of healthy tissue beyond the apparent margin of the growth must be
removed, and in tumours near the surface of the body, the overlying skin
also.

In order to prevent recurrence, a tube of _radium_, to which a silk
thread is attached, is inserted into the space from which the tumour was
removed; the thread is brought out at the drain-opening, and at the end
of a week or ten days the tube of radium is removed by pulling on the
thread. Radium causes a reaction in the tissues attended with exudation
from the vessels, for the escape of which provision must be made. If
radium is not available, the affected area is repeatedly exposed to the
action of the _X-rays_ as soon as the wound has healed. The employment
of these measures has diminished to a remarkable degree the recurrence
of sarcoma after operation.

It will readily be understood that the less thoroughly or radically the
growth has been removed, the more do we depend upon radium or the X-rays
for bringing about a permanent cure, and that in advanced cases of
sarcoma and in cases in which, on account of their anatomical situation,
removal by operation is necessarily incomplete, the prospect of cure is
still more dependent on the use of radium or of the X-rays. Finally,
there are cases in which removal by operation is impossible, the
so-called _inoperable sarcoma_; a tube of radium, to which a silk thread
is attached, is inserted into the substance of the tumour, either
through an opening made by a large trocar, or, when necessary, by open
dissection. A second tube of radium is placed upon the skin over the
tumour and is secured there by a stitch or by a strip of plaster, thus
securing a cross-fire action of the radium rays, both from within and
without, as this is found to be much more efficacious in destroying or
inhibiting the cellular elements of the growth. The tubes of radium are
left _in situ_ for from eight to fourteen days, according to the power
of the radium employed, but are moved about every second day or so in
order that every part of the tumour may be efficiently radiated. If the
tumour shrinks in size after the use of radium and becomes operable, it
should be removed before time is given it to resume its growth. It will
depend upon the subsequent course of the disease, whether or not a
second, or it may be even a third, application of radium will be
required.

Where neither radium nor X-rays is available or applicable, recourse may
be had to the injection of Coley's fluid, a preparation containing the
mixed toxins of the streptococcus of erysipelas and the bacillus
prodigiosus; or of selenium.


EPITHELIAL TUMOURS

An excessive and erratic growth of epithelium is the essential and
distinguishing feature of these tumours. The innocent forms are the
papilloma and the adenoma; the malignant, the carcinoma or cancer.

#Papilloma.#--A papilloma is a tumour which projects from a cutaneous or
mucous surface, and consists of a central axis of vascular fibrous
tissue with a covering of epithelium resembling that of the surface from
which the tumour grows. In the papillomas of the skin--commonly known as
_warts_--the covering consists of epidermis; in those growing from
mucous surfaces it consists of the epithelium covering the mucous
membrane. When the surface epithelium projects as filiform processes,
the tumour is called a _villous papilloma_, the best-known example of
which is met with in the urinary bladder. Papillomatous growths are
also met with in the larynx, in the ducts of the breast, and in the
interior of certain cystic tumours of the breast and of the ovary.
Although papillomas are primarily innocent, they may become the
starting-point of cancer, especially in persons past middle life and if
the papilloma has been subjected to irritation and has ulcerated. The
clinical features and treatment of the various forms of papilloma are
considered with the individual tissues and organs.

#Adenoma.#--An adenoma is a tumour constructed on the type of, and
growing in connection with, a secreting gland. In the substance of such
glands as the mamma, parotid, thyreoid, and prostate, adenomas are met
with as encapsulated tumours. When they originate from the glands of the
skin or of a mucous membrane, they tend to project from the surface, and
form pedunculated tumours or polypi.

Adenomas may be single or multiple, and they vary greatly in size. The
tumour is seldom composed entirely of gland tissue; it usually contains
a considerable proportion of fibrous tissue, and is then called a
_fibro-adenoma_. When it contains myxomatous tissue it is called a
_myxo-adenoma_, and when the gland spaces of the tumour become distended
with accumulated secretion, a _cystic adenoma_, the best examples of
which are met with in the mamma and ovary. A characteristic feature of
the cystic variety is the tendency the tumour tissue exhibits to project
into the interior of the cysts, constituting what are known as
_intracystic growths_. They are essentially innocent, but intracystic
growths, especially in the mamma of women over fifty, should be regarded
with suspicion and therefore should be removed on radical lines.
Transition forms between adenoma and carcinoma are also met with in the
rectum and large intestine, and these should be treated on the same
lines as cancer.


CARCINOMA OR CANCER

A cancer is a malignant tumour which originates in epithelium. The
cancer cells are derived by proliferation from already existing
epithelium, and they invade the sub-epithelial connective tissue in the
form of simple or branching columns. These columns are enclosed in
spaces--termed alveoli--which are probably dilated lymph spaces, and
which communicate freely with the lymph vessels. The cells composing the
columns and filling the alveoli vary with the character of the
epithelium in which the cancer originates. The malignancy of cancer
depends on the tendency which the epithelium has of invading the tissues
in its neighbourhood, and on the capacity of the cells, when
transported elsewhere by the lymph or blood-stream, of giving rise to
secondary growths.

Cancer may arise on any surface covered by epithelium or in any of the
secreting glands of the body, but it is much more common in some
situations than in others. It is frequently met with, for example, in
the skin, in the stomach and large intestine, in the breast, the uterus,
and the external genitals; less frequently in the gall-bladder, larynx,
thyreoid, prostate, and urinary bladder.

Tissues appear to be most liable to cancer when, having attained
maturity, they enter upon the phase of decadence or involution, and this
phase is reached by different tissues at different periods. It is not so
much, therefore, the age of the person in whom it occurs, as the age of
the tissue in which it arises, that determines the maximum incidence of
cancer. Cancer of the stomach appears and attains a maximum frequency
earlier than cancer of the skin; cancer of the uterus and mamma is more
frequent towards the decline of reproductive activity than in the later
years of life; rectal cancer is not infrequently met with during the
second and third decades. There is evidence that the irritation caused
by alcohol and tobacco plays a part in the causation of cancer, in the
fact that a large proportion of those who become the subjects of cancer
of the mouth are excessive drinkers and smokers.

A cancer may appear as a papillary growth on a mucous or a skin surface,
as a nodule in the substance of an organ, or as a diffuse thickening of
a tubular organ such as the stomach or intestine. The absence of
definition in cancerous tumours explains the difficulty of completely
removing them by surgical measures, and has led to the practice of
complete extirpation of cancerous organs wherever this is possible. The
boundaries of the affected organ, moreover, are frequently transgressed
by the disease, and the epithelial infiltration implicates the
surrounding parts. In cancer of the breast, for example, the disease
often extends to the adjacent skin, fat, and muscle; in cancer of the
lip or tongue, to the mandible; in cancer of the uterus or intestine, to
the investing peritoneum.

In addition to its tendency to infiltrate adjacent tissues and organs,
cancer is also liable to give rise to _secondary growths_. These are
most often met with in the nearest lymph glands; those in the neck, for
example, becoming infected from cancer of the lip, tongue, or throat;
those in the axilla, from cancer of the breast; those along the
curvatures of the stomach, from cancer of the pylorus; and those in the
groin, from cancer of the external genitals. In lymph vessels the cancer
cells may merely accumulate so as to fill the lumen and form indurated
cords, or they may proliferate and give rise to secondary nodules along
the course of the vessels. When the lymphatic network in the skin is
diffusely infected, the appearance is either that of a multitude of
secondary nodules or of a diffuse thickening, so that the skin comes to
resemble coarse leather. On the wall of the chest this condition is
known as _cancer en cuirasse_. Although the cancer cells constantly
attack the walls of the adjacent veins and spread into their interior at
a comparatively early period, secondary growths due to dissemination by
the blood-stream rarely show themselves clinically until late in the
course of the disease. It is probable that many of the cancer cells
which are carried away in the blood or lymph stream undergo necrosis and
fail to give rise to secondary growths. Secondary growths present a
faithful reproduction of the structure of the primary tumour. Apart from
the lymph glands, the chief seats of secondary growths are the liver,
lungs, serous membranes, and bone marrow.

It is generally believed that the secondary growths in cancer that
develop at a distance from the primary tumour, those, for example, in
the medullary canal of the femur or in the diploe of the skull occurring
in advanced cases of cancer of the breast, are the result of
dissemination of cancer cells by way of the blood-stream and are to be
regarded as emboli. Sampson Handley disagrees with this view; he
believes that the dissemination is accomplished in a more subtle way,
namely, by the actual growth of cancer cells along the finer vessels of
the lymph plexuses that ramify in the deep fascia, a method of spread
which he calls _permeation_. It is maintained also that permeation
occurs as readily against the lymph stream as with it. He compares the
spread of cancer to that of an invisible annular ringworm. The growing
edge extends in a wider and wider circle, within which a healing process
may occur, so that the area of permeation is a ring, rather than a disc.
Healing occurs by a process of "peri-lymphatic fibrosis," but as the
natural process of healing may fail at isolated points, nodules of
cancer appear, which, although apparently separate from the primary
growth, have developed in continuity with it, peri-lymphatic fibrosis
having destroyed the cancer chain connecting the nodule with the primary
growth. This centrifugal spread of cancer is clearly seen in the
distribution of the subcutaneous secondary nodules so frequently met
with in the late stages of mammary cancer. The area within which the
secondary nodules occur is a circle of continually increasing diameter
with the primary growth in the centre.

In the rare cases in which the skin of the greater part of the body is
affected, the nodules rarely appear below the level of the deltoid or
the middle third of the thigh, the patient dying before the spread can
reach the distal portions of the limbs.

Handley argues against the embolic origin of the metastases in the bones
because of the rarity of these in the bones of the distal parts of the
limbs, because of the fact that secondary cancer of the femur nearly
always commences in the upper third of the shaft, which harmonises with
the intimate connection of the deep fascia with the periosteum over the
great trochanter, thus favouring invasion of the bone marrow when
permeation has spread thus far. He claims support for the permeation
theory from the fact that the humerus is rarely involved below the
insertion of the deltoid, and that spontaneous fracture of the femur is
three times more common on the side on which the breast cancer is
situated.

The tumour tissue may undergo necrosis, and when the overlying skin or
mucous membrane gives way an ulcer is formed. The margins of a
_cancerous ulcer_ (Fig. 57) are made up of tumour tissue which has not
broken down. Usually they are irregular, nodularly thickened or
indurated; sometimes they are raised and crater-like. The floor of the
ulcer is smooth and glazed, or occupied by necrosed tissue, and the
discharge is watery and blood-stained, and as a result of putrefactive
changes may become offensive. Haemorrhage is rarely a prominent feature,
but discharge of blood may constitute a symptom of considerable
diagnostic importance in cancer of internal organs such as the rectum,
the bladder, or the uterus.

[Illustration: FIG. 57.--Carcinoma of Breast with Cancerous Ulcer.]

_The Contagiousness of Cancer._--A limited number of cases are on record
in which a cancer appears to have been transferred by contact, as from
the lower to the upper lip, from one labium majus to the other, from the
tongue to the cheek, and from one vocal cord to the other; these being
all examples of cancer involving surfaces which are constantly or
frequently in contact. The transference of cancer from one human being
to another, whether by accident, as in the case of a surgeon wounding
his finger while operating for cancer, or by the deliberate introduction
of a portion of cancerous tumour into the tissues, has never been known
to occur. It is by no means infrequent, however, that when recurrence
takes place after an operation for the removal of cancer, the recurrent
nodules make their appearance in the main scar or in the scars of
stitches in its neighbourhood. In the lower animals the grafting of
cancer only succeeds in animals of the same species; for example, a
cancer taken from a mouse will not grow in the tissues of a rat, but
only in a mouse of the same variety as that from which the graft was
taken.

While cancer cannot be regarded as either contagious or infectious, it
is important to bear in mind the possibility of infection of a wound
with cancer when operating for the disease. A cancer should not be cut
into unless this is essential for purposes of diagnosis, and the wound
made for exploration should be tightly closed by stitches before the
curative operation is proceeded with; the instruments used for the
exploration must not be used again until they have been boiled. The
greatest care should be taken that a cancer which has softened or broken
down is not opened into during the operation.

Investigations regarding the cause of cancer have been prosecuted with
great energy during recent years, but as yet without positive result. It
is recognised that there are a number of conditions which favour the
development of cancer, such as prolonged irritation, and a considerable
number of cases have been recorded in which cancer of the skin of the
hands has followed prolonged and repeated exposure to the Rontgen rays.

_The Alleged Increase of Cancer._--Regarding the alleged increase of
cancer, it may be pointed out that it is impossible to ascertain how
much of the apparent increase is due to more accurate diagnosis and
improved registration. It is probable also that some increase has taken
place in consequence of the increased average duration of life; a larger
proportion of persons now reach the age at which cancer is frequent.

_The prognosis_ largely depends on the variety of cancer and on its
situation. Certain varieties--such as the atrophic cancer of the breast
which occurs in old people, and some forms of cancer in the rectum--are
so indolent in their progress that they can scarcely be said to shorten
life; while others--such as the softer varieties of mammary cancer
occurring in young women--are among the most malignant of tumours. The
mode in which cancer causes death depends to a large extent upon its
situation. In the gullet, for example, it usually causes death by
starvation; in the larynx or thyreoid, by suffocation; in the intestine,
by obstruction of the bowels; in the uterus, prostate, and bladder, by
haemorrhage or by implication of the ureters and kidneys. Independently
of their situation, however, cancers frequently cause death by giving
rise to a progressive impairment of health known as the _cancerous
cachexia_, a condition which is due to the continued absorption of
poisonous products from the tumour. The patient loses appetite, becomes
emaciated, pale, and feverish, and gradually loses strength until he
dies. In many cases, especially those in which ulceration has occurred,
the addition of pyogenic infection may also be concerned in the failure
of health.

_Treatment._--Removal by surgical means affords the best prospect of
cure. If carcinomatous disease is to be rooted out, its mode of spread
by means of the lymph vessels must be borne in mind, and as this occurs
at an early stage, and is not evident on examination, a wide area must
be included in the operation. The organ from which the original growth
springs should, if practicable, be altogether removed, because its lymph
vessels generally communicate freely with each other, and secondary
deposits have probably already taken place in various parts of it. In
addition, the nearest chain of lymph glands must also be removed, even
though they may not be noticeably enlarged, and in some cases--in cancer
of the breast, for example--the intervening lymph vessels should be
removed at the same time.

The treatment of cancer by other than operative methods has received a
great deal of attention within recent years, and many agents have been
put to the test, _e.g._ colloidal suspensions of selenium, but without
any positive results. Most benefit has resulted from the use of radium
and of the X-rays, and one or other should be employed as a routine
measure after every operation for cancer.

It has been demonstrated that cancer cells are more sensitive to radium
and to the Rontgen rays than the normal cells of the body, and are more
easily killed. The effect varies a good deal with the nature and seat of
the tumour. In rodent cancers of the skin, for example, both radium and
X-ray treatment are very successful, and are to be preferred to
operation because they yield a better cosmetic result. While small
epitheliomas of the skin may be cured by means of the rays, they are not
so amenable as rodent cancers.

Cancers of mucous membranes are less amenable to ray treatment because
they are less circumscribed and are difficult of access. In cancers
under the skin, the Rontgen rays are less efficient; if radium is
employed, the tube containing it should be inserted into the substance
of the tumour after the method described in connection with sarcoma--and
another tube should be placed on the overlying skin.

In the employment of X-rays and of radium in the treatment of cancer,
experience is required, not only to obtain the maximum effect of the
rays, but to avoid damage to the adjacent and overlying tissues.

Ray treatment is not to be looked upon as a rival but as a powerful
supplement to the operative treatment of cancer.


VARIETIES OF CANCER

The varieties of cancer are distinguished according to the character and
arrangement of the epithelial cells.

The _squamous epithelial cancer_ or _epithelioma_ originates from a
surface covered by squamous epithelium, such as the skin, or the mucous
membrane of the mouth, gullet, or larynx. The cancer cells retain the
characters of squamous epithelium, and, being confined within the lymph
spaces of the sub-epithelial connective tissue, become compressed and
undergo a horny change. This results in the formation of concentrically
laminated masses known as cell nests.

The clinical features are those of a slowly growing indurated tumour,
which nearly always ulcerates; there is a characteristic induration of
the edges and floor of the ulcer, and its surface is often covered with
warty or cauliflower-like outgrowths (Fig. 58). The infection of the
lymph glands is early and constant, and constitutes the most dangerous
feature of the disease; the secondary growths in the glands exhibit the
characteristic induration, and may themselves break down and lead to the
formation of ulcers.

[Illustration: FIG. 58.--Epithelioma of Lip.]

Epithelioma frequently originates in long-standing ulcers or sinuses,
and in scars, and probably results from the displacement and
sequestration of epithelial cells during the process of cicatrisation.

The _columnar epithelial cancer_ or _columnar epithelioma_ originates in
mucous membranes covered with columnar epithelium, and is chiefly met
with in the stomach and intestine. As it resembles an adenoma in
structure it is sometimes described as a _malignant adenoma_. Its
malignancy is shown by the proliferating epithelium invading the other
coats of the stomach or intestine, and by the development of secondary
growths.

_Glandular carcinoma_ originates in organs such as the breast, and in
the glands of mucous membranes and skin. The epithelial cells are not
arranged on any definite plan, but are closely packed in irregularly
shaped alveoli. If the alveoli are large and the intervening stroma is
scanty and delicate, the tumour is soft and brain-like, and is described
as a _medullary_ or _encephaloid cancer_. If the alveoli are small and
the intervening stroma is abundant and composed of dense fibrous tissue,
the tumour is hard, and is known as a _scirrhous cancer_--a form which
is most frequently met with in the breast. If the cells undergo
degeneration and absorption and the stroma contracts, the tumour becomes
still harder, and tends to shrink and to draw in the surrounding parts,
leading, in the breast, to retraction of the nipple and overlying skin,
and in the stomach and colon to narrowing of the lumen. When the cells
of the tumour undergo colloid degeneration, a _colloid cancer_ results;
if the degeneration is complete, as may occur in the breast, the
malignancy is thereby greatly diminished; if only partial, as is more
common in rectal cancer, the malignancy is not appreciably affected.
Melanin pigment is formed in relation to the cells and stroma of certain
epithelial tumours, giving rise to _melanotic cancer_, one of the most
malignant of all new growths. Cyst-like spaces may form in the tumour by
the accumulation of the secretion of the epithelial cells, or as a
result of their degeneration--_cystic carcinoma_. This is met with
chiefly in the breast and ovary, and the tumour resembles the cystic
adenoma, but it tends to infect its surroundings and gives rise to
secondary growths.

_Rodent cancer_ originates in the glands of the skin, and presents a
special tendency to break down and ulcerate on the surface (Figs. 102
and 103). It almost never infects the lymph glands.


DERMOIDS

A dermoid is a tumour containing skin or mucous membrane, occurring in a
situation where these tissues are not met under normal conditions.

The _skin dermoid_, or _derma-cyst_ as it has been called by Askanazy,
arises from a portion of epiblast, which has become sequestrated during
the process of coalescence of two cutaneous surfaces in development.
This form is therefore most frequently met with on the face and neck in
the situations which correspond to the various clefts and fissures of
the embryo. It occurs also on the trunk in situations where the lateral
halves of the body coalesce during development. Such a dermoid usually
takes the form of a globular cyst, the wall of which consists of skin,
and the contents of turbid fluid containing desquamated epithelium, fat
droplets, cholestrol crystals, and detached hairs. Delicate hairs may
also be found projecting from the epithelial lining of the cyst.

Faulty coalescence of the cutaneous covering of the back occurs most
frequently over the lower sacral vertebrae, giving rise to small
congenital recesses, known as post-anal dimples and coccygeal sinuses.
These recesses are lined with skin, which is furnished with hairs,
sebaceous and sweat glands. If the external orifice becomes occluded,
there results a dermoid cyst.

_Tubulo-dermoids_ arise from embryonic ducts and passages that are
normally obliterated at birth, for example, _lingual dermoids_ develop
in relation to the thyreo-glossal duct; _rectal and post-rectal_
dermoids to the post-anal gut; and _branchial dermoids_ in relation to
the branchial clefts. Tubulo-dermoids present the same structure as skin
dermoids, save that mucous membrane takes the place of skin in the wall
of the cyst, and the contents consist of the pent-up secretion of mucous
glands.

_Clinical Features._--Although dermoids are of congenital origin, they
are rarely evident at birth, and may not give rise to visible tumours
until puberty, when the skin and its appendages become more active, or
not till adult life. Superficial dermoids, such as those met with at the
outer angle of the orbit, form rounded, definitely limited tumours over
which the skin is freely movable. They are usually adherent to the
deeper parts, and when situated over the skull may be lodged in a
depression or actual gap in the bone. Sometimes the cyst becomes
infected and suppurates, and finally ruptures on the surface. This may
lead to a natural cure, or a persistent sinus may form. Dermoids more
deeply placed, such as those within the thorax, or those situated
between the rectum and sacrum, give rise to difficulty in diagnosis,
even with the help of the X-rays, and their nature is seldom recognised
until the escape of the contents--particularly hairs--supplies the clue.
The literature of dermoid cysts is full of accounts of puzzling tumours
met with in all sorts of situations.

The treatment is to remove the cyst. When it is impossible to remove the
whole of the lining membrane by dissection, the portion that is left
should be destroyed with the cautery.

_Ovarian Dermoids._--Dermoids are not uncommon in the ovary (Fig. 59).
They usually take the form of unilocular or multilocular cysts, the
wall of which contains skin, mucous membrane, hair follicles, sebaceous,
sweat, and mucous glands, nails, teeth, nipples, and mammary glands. The
cavity of the cyst usually contains a pultaceous mixture of shed
epithelium, fluid fat, and hair. If the cyst ruptures, the epithelial
elements are diffused over the peritoneum, and may give rise to
secondary dermoids.

[Illustration: FIG. 59.--Dermoid Cyst of Ovary showing Teeth in its
interior.]

The ovarian dermoid appears clinically as an abdominal or pelvic tumour
provided with a pedicle; if the pedicle becomes twisted, the tumour
undergoes strangulation, an event which is attended with urgent
symptoms, not unlike those of strangulated hernia.

The treatment consists in removing the tumour by laparotomy.

#Teratoma.#--A teratoma is believed to result from partial dichotomy or
cleavage of the trunk axis of the embryo, and is found exclusively in
connection with the skull and vertebral column. It may take the form of
a monstrosity such as conjoined twins or a parasitic foetus, but more
commonly it is met with as an irregularly shaped tumour, usually growing
from the sacrum. On dissection, such a tumour is found to contain a
curious mixture of tissues--bones, skin, and portions of viscera, such
as the intestine or liver. The question of the removal of the tumour
requires to be considered in relation to the conditions present in each
individual case.


CYSTS[3]

[3] Cysts which form in relation to new-growths have been considered
with tumours.

Cysts are rounded sacs, the wall being composed of fibrous tissue lined
by epithelium or endothelium; the contents are fluid or semi-solid, and
vary in character according to the tissue in which the cyst has
originated.

_Retention and Exudation Cysts._--_Retention cysts_ develop when the
duct of a secreting gland is partly obstructed; the secretion
accumulates, and the gland and its duct become distended into a cyst.
They are met with in the mamma and in the salivary glands. Sebaceous
cysts or wens are described with diseases of the skin. _Exudation cysts_
arise from the distension of cavities which are not provided with
excretory ducts, such as those in the thyreoid.

_Implantation cysts_ are caused by the accidental transference of
portions of the epidermis into the underlying connective tissue, as may
occur in wounds by needles, awls, forks, or thorns. The implanted
epidermis proliferates and forms a small cyst. They are met with chiefly
on the palmar aspect of the fingers, and vary in size from a split pea
to a cherry. The treatment consists in removing them by dissection.

_Parasitic cysts_ are produced by the growth within the tissues of
cyst-forming parasites, the best known being the taenia echinococcus,
which gives rise to the _hydatid cyst_. The liver is by far the most
common site of hydatid cysts in the human subject.

With regard to the further life-history of hydatids, the living elements
of the cyst may die and degenerate, or the cyst may increase in size
until it ruptures. As a result of pyogenic infection the cyst may be
converted into an abscess.

The _clinical features_ of hydatids vary so much with their situation
and size, that they are best discussed with the individual organs. In
general it may be said that there is a slow formation of a globular,
elastic, fluctuating, painless swelling. Fluctuation is detected when
the cyst approaches the surface, and it is then also that percussion
may elicit the "hydatid thrill" or fremitus. This thrill is not often
obtainable, and in any case is not pathognomonic of hydatids, as it may
be elicited in ascites and in other abdominal cysts. Pressure of the
cyst upon adjacent structures, and the occurrence of suppuration, are
attended with characteristic clinical features.

The _diagnosis_ of hydatids will be considered with the individual
organs. The disease is more common in certain parts of Australia and in
Shetland and Iceland than in countries where the association of dogs in
the domestic life of the inhabitants is less intimate. Pfeiler, who has
worked at the _serum diagnosis of hydatid disease_, regards the
complement deviation method as the most reliable; he believes that a
positive reaction may almost be regarded as absolutely diagnostic of an
echinococcal lesion.

The _treatment_ is to excise the cyst completely, or to inject into it a
1 per cent. solution of formalin. In operating upon hydatids the utmost
care must be taken to avoid leakage of the contents of the cyst, as
these may readily disseminate the infection.

A _blood cyst_ or haematoma results from the encapsulation of
extravasated blood in the tissues, from haemorrhage taking place into a
preformed cyst, or from the saccular pouching of a varicose vein.

A _lymph cyst_ usually results from a contusion in which the skin is
forcibly displaced from the subjacent tissues, and lymph vessels are
thereby torn across. The cyst is usually situated between the skin and
fascia, and contains clear or blood-stained serum. At first it is lax
and fluctuates readily, later it becomes larger and more tense. The
treatment consists in drawing off the contents through a hollow needle
and applying firm pressure. Apart from injury, lymph cysts are met with
as the result of the distension of lymph spaces and vessels
(_lymphangiectasis_); and in lymphangiomas, of which the best-known
example is the cystic hygroma or hydrocele of the neck.


GANGLION

This term is applied to a cyst filled with a clear colourless jelly or
colloid material, met with in the vicinity of a joint or tendon sheath.

The commonest variety--the _carpal ganglion_--popularly known as a
sprained sinew--is met with as a smooth, rounded, or oval swelling on
the dorsal aspect of the carpus, usually towards its radial side (Fig. 60).
It is situated over one of the intercarpal or other joints in this
region, and may be connected with one or other of the extensor tendons.
The skin and fascia are movable over the cyst. The cyst varies in size
from a pea to a pigeon's egg, and usually attains its maximum size
within a few months and then remains stationary. It becomes tense and
prominent when the hand is flexed towards the palm. Its appearance is
usually ascribed to some strain of the wrist--for example, in girls
learning gymnastics. It may cause no symptoms or it may interfere with
the use of the hand, especially in grasping movements and when the hand
is dorsiflexed. In girls it may give rise to pain which shoots up the
arm. Ganglia are also met with on the dorsum of the metacarpus and on
the palmar aspect of the wrist.

[Illustration: FIG. 60.--Carpal Ganglion in a woman aet. 25.]

The _tarsal ganglion_ is situated on the dorsum of the foot over one or
other of the intertarsal joints. It is usually smaller, flatter, and
more tense than that met with over the wrist, so that it is sometimes
mistaken for a bony tumour. It rarely causes symptoms, unless so
situated as to be pressed upon by the boot.

_Ganglia in the region of the knee_ are usually situated over the
interval between the femur and tibia, most often on the lateral aspect
of the joint in front of the tendon of the biceps (Fig. 61). The
swelling, which may attain the size of half a walnut, is tense and hard
when the knee is extended, and becomes softer and more prominent when it
is flexed. They are met with in young adults who follow laborious
occupations or who indulge in athletics, and they cause stiffness,
discomfort, and impairment of the use of the limb. A ganglion is
sometimes met with on the median aspect of the head of the metatarsal
bone of the great toe and may be the cause of considerable suffering; it
is indistinguishable from the thickened and enlarged bursa so commonly
present in this situation in the condition known as bunion.

[Illustration: FIG. 61.--Ganglion on lateral aspect of Knee in a young
woman.]

Ganglionic cysts are met with in other situations than those mentioned,
but they are so rare as not to require separate description.

Ganglia are to be diagnosed by their situation and physical characters;
enlarged bursae, synovial cysts, and new-growths are the swellings most
likely to be mistaken for them. The diagnosis is sometimes only cleared
up by withdrawing the clear, jelly-like contents through a hollow
needle.

_Pathological Anatomy._--The wall of the cyst is composed of fibrous
tissue closely adherent to or fused with the surrounding tissues, so
that it cannot be shelled out. There is no endothelial lining, and the
fibrous tissue of the wall is in immediate contact with the colloid
material in the interior, which appears to be derived by a process of
degeneration from the surrounding connective tissue. In the region of
the knee the ganglion is usually multilocular, and consists of a
meshwork of fibrous tissue, the meshes of which are occupied by colloid
material.

It is often stated that a ganglion originates from a hernial protrusion
of the synovial membrane of a joint or tendon sheath. We have not been
able to demonstrate any communication between the cavity of the cyst
and that of an adjacent tendon sheath or joint. It is possible, however,
that the cyst may originate from a minute portion of synovial membrane
being protruded and strangulated so that it becomes disconnected from
that to which it originally belonged; it may then degenerate and give
rise to colloid material, which accumulates and forms a cyst. Ledderhose
and others regard ganglia as entirely new formations in the
peri-articular tissues, resulting from colloid degeneration of the
fibrous tissue of the capsular ligament, occurring at first in numerous
small areas which later coalesce. Ganglia are probably, therefore, of
the nature of degeneration cysts arising in the capsule of joints, in
tendons, and in their sheaths.

_Treatment._--A ganglion can usually be got rid of by a modification of
the old-fashioned seton. The skin and cyst wall are transfixed by a
stout needle carrying a double thread of silkworm gut; some of the
colourless jelly escapes from the punctures; the ends of the thread are
tied and cut short, and a dressing is applied. A week later the threads
are removed and the minute punctures are sealed with collodion. The
action of the threads is to convert the cyst wall into granulation
tissue, which undergoes the usual conversion into scar tissue. If the
cyst re-forms, it should be removed by open dissection under local
anaesthesia. Puncture with a tenotomy knife and scraping the interior,
and the injection of irritants, are alternative, but less satisfactory,
methods of treatment.

_Ganglia_ in the substance of _tendons_ are rare. The diagnosis rests on
the observation that the small tumour is cystic, and that it follows the
movements of the tendon. The cyst is at first multiple, but the
partitions disappear, and the spaces are thrown into one. The tendon is
so weakened that it readily ruptures. The best treatment is to resect
the affected segment of tendon.

The so-called "compound palmar ganglion" is a tuberculous disease of the
tendon sheaths, and is described with diseases of tendon sheaths.




CHAPTER XI

INJURIES


CONTUSIONS--WOUNDS: _Varieties_--WOUNDS BY FIREARMS AND
    EXPLOSIVES: _Pistol-shot wounds_; _Wounds by sporting guns_;
    _Wounds by rifle bullets_; _Wounds received in warfare_; _Shell
    wounds_. _Embedded foreign bodies_--BURNS AND
    SCALDS--INJURIES PRODUCED BY ELECTRICITY: _X-ray and
    radium_; _Electrical burns_; _Lightning stroke_.


CONTUSIONS

A contusion or bruise is a laceration of the subcutaneous soft tissues,
without solution of continuity of the skin. When the integument gives
way at the same time, a _contused-wound_ results. Bruising occurs when
force is applied to a part by means of a blunt object, whether as a
direct blow, a crush, or a grazing form of violence. If the force acts
at right angles to the part, it tends to produce localised lesions which
extend deeply; while, if it acts obliquely, it gives rise to lesions
which are more diffuse, but comparatively superficial. It is well to
remember that those who suffer from scurvy, or haemophilia (bleeders),
and fat and anaemic females, are liable to be bruised by comparatively
trivial injuries.

_Clinical Features._--The less severe forms of contusion are associated
with _ecchymosis_, numerous minute and discrete punctate haemorrhages
being scattered through the superficial layers of the skin, which is
slightly oedematous. The effused blood is soon reabsorbed.

The more severe forms are attended with _extravasation_, the
extravasated blood being widely diffused through the cellular tissue of
the part, especially where this is loose and lax, as in the region of
the orbit, the scrotum and perineum, and on the chest wall. A blue or
bluish-black discoloration occurs in patches, varying in size and depth
with the degree of force which produced the injury, and in shape with
the instrument employed. It is most intense in regions where the skin is
naturally thin and pigmented. In parts where the extravasated blood is
only separated from the oxygen of the air by a thin layer of epidermis
or by a mucous membrane, it retains its bright arterial colour. These
points are often well illustrated in cases of black eye, where the blood
effused under the conjunctiva is bright red, while that in the eyelids
is almost black. In severe contusions associated with great tension of
the skin--for example, over the front of the tibia or around the
ankle--blisters often form on the surface and constitute a possible
avenue of infection. When deeply situated, the blood tends to spread
along the lines of least resistance, partly under the influence of
gravity, passing under fasciae, between muscles, along the sheaths of
vessels, or in connective-tissue spaces, so that it may only reach the
surface after some time, and at a considerable distance from the seat of
injury. This fact is sometimes of importance in diagnosis, as, for
example, in certain fractures of the base of the skull, where
discoloration appears under the conjunctiva or behind the mastoid
process some days after the accident.

Blood extravasated deeply in the tissues gives rise to a firm,
resistant, doughy swelling, in which there may be elicited on deep
palpation a peculiar sensation, not unlike the crepitus of fracture.

It frequently happens that, from the tearing of lymph vessels, serous
fluid is extravasated, and a _lymphatic_ or _serous cyst_ may form.

In all contusions accompanied by extravasation, there is marked swelling
of the area involved, as well as pain and tenderness. The temperature
may rise to 101 o F., or, in the large extravasations that occur in
bleeders, even higher--a form of aseptic fever. The degree of shock is
variable, but sudden syncope frequently results from severe bruises of
the testicle, abdomen, or head, and occasionally marked nervous
depression follows these injuries.

Contusion of muscles or nerves may produce partial atrophy and paresis,
as is often seen after injuries in the region of the shoulder.

In alcoholic or other debilitated patients, suppuration is liable to
ensue in bruised parts, infection taking place from cocci circulating in
the blood, or through the overlying skin.

_Terminations of Contusions._--The usual termination is a complete
return to the normal, some of the extravasated blood being organised,
but most of it being reabsorbed. During the process characteristic
alterations in the colour of the effused blood take place as a result of
changes in the blood pigment. In from twenty-four to forty-eight hours
the margins of the blue area become of a violet hue, and as time goes on
the discoloured area increases in size, and becomes successively green,
yellow, and lemon-coloured at its margins, the central part being the
last to change. The rate at which this play of colours proceeds is so
variable, and depends on so many circumstances, that no time-limits can
be laid down. During the disintegration of the effused blood the
adjacent lymph glands may become enlarged, and on dissection may be
found to be pigmented. Sometimes the blood persists as a collection of
fluid with a newly formed connective-tissue capsule, constituting a
_haematoma_ or _blood cyst_, more often met with in the scalp than in
other parts.

The impairment of the blood supply of the skin may lead to the formation
of _blisters_, or to _necrosis_. Death of skin is more liable to occur
in bleeders, and when the slough separates the blood-clot is exposed and
the reparative changes go on extremely slowly. _Suppuration_ may occur
and lead to the formation of an abscess as a result of direct infection
from the skin or through the circulation.

_Treatment._--If the patient is seen immediately after the accident,
elevation of the part, and firm pressure applied by means of a thick pad
of cotton wool and an elastic bandage, are useful in preventing effusion
of blood. Ice-bags and evaporating lotions are to be used with caution,
as they are liable to lower the vitality of the damaged tissues and lead
to necrosis of the skin.

When extravasation has already taken place, massage is the most speedy
and efficacious means of dispersing the effused blood. The part should
be massaged several times a day, unless the presence of blebs or
abrasions of the skin prevents this being done. When this is the case,
the use of antiseptic dressings is called for to prevent infection and
to promote healing, after which massage is employed.

When the tension caused by the extravasated blood threatens the vitality
of the skin, incisions may be made, if asepsis can be assured. The blood
from a haematoma may be withdrawn by an exploring needle, and the
puncture sealed with collodion. Infective complications must be looked
for and dealt with on general principles.


WOUNDS

A wound is a solution in the continuity of the skin or mucous membrane
and of the underlying tissues, caused by violence.

Three varieties of wounds are described: incised, punctured, and
contused and lacerated.

#Incised Wounds.#--Typical examples of incised wounds are those made by
the surgeon in the course of an operation, wounds accidentally inflicted
by cutting instruments, and suicidal cut-throat wounds. It should be
borne in mind in connection with medico-legal inquiries, that wounds of
soft parts that closely overlie a bone, such as the skull, the tibia, or
the patella, although, inflicted by a blunt instrument, may have all the
appearances of incised wounds.

_Clinical Features._--One of the characteristic features of an incised
wound is its tendency to gape. This is evident in long skin wounds, and
especially when the cut runs across the part, or when it extends deeply
enough to divide muscular fibres at right angles to their long axis. The
gaping of a wound, further, is more marked when the underlying tissues
are in a state of tension--as, for example, in inflamed parts. Incised
wounds in the palm of the hand, the sole of the foot, or the scalp,
however, have little tendency to gape, because of the close attachment
of the skin to the underlying fascia.

Incised wounds, especially in inflamed tissues, tend to bleed profusely;
and when a vessel is only partly divided and is therefore unable to
contract, it continues to bleed longer than when completely cut across.

The _special risks_ of incised wounds are: (1) division of large blood
vessels, leading to profuse haemorrhage; (2) division of nerve-trunks,
resulting in motor and sensory disturbances; and (3) division of tendons
or muscles, interfering with movement.

_Treatment._--If haemorrhage is still going on, it must be arrested by
pressure, torsion, or ligature, as the accumulation of blood in a wound
interferes with union. If necessary, the wound should be purified by
washing with saline solution or eusol, and the surrounding skin painted
with iodine, after which the edges are approximated by sutures. The raw
surfaces must be brought into accurate apposition, care being taken that
no inversion of the cutaneous surface takes place. In extensive and deep
wounds, to ensure more complete closure and to prevent subsequent
stretching of the scar, it is advisable to unite the different
structures--muscles, fasciae, and subcutaneous tissue--by separate series
of _buried sutures_ of catgut or other absorbable material. For the
approximation of the skin edges, stitches of horse-hair, fishing-gut, or
fine silk are the most appropriate. These _stitches of coaptation_ may
be interrupted or continuous. In small superficial wounds on exposed
parts, stitch marks may be avoided by approximating the edges with
strips of gauze fixed in position by collodion, or by subcutaneous
sutures of fine catgut. Where the skin is loose, as, for example, in the
neck, on the limbs, or in the scrotum, the use of Michel's clips is
advantageous in so far as these bring the deep surfaces of the skin into
accurate apposition, are introduced with comparatively little pain, and
leave only a slight mark if removed within forty-eight hours.

When there is any difficulty in bringing the edges of the wound into
apposition, a few interrupted _relaxation stitches_ may be introduced
wide of the margins, to take the strain off the coaptation stitches.
Stout silk, fishing-gut, or silver wire may be employed for this
purpose. When the tension is extreme, Lister's button suture may be
employed. The tension is relieved and death of skin prevented by scoring
it freely with a sharp knife. Relaxation stitches should be removed in
four or five days, and stitches of coaptation in from seven to ten days.
On the face and neck, wounds heal rapidly, and stitches may be removed
in two or three days, thus diminishing the marks they leave.

_Drainage._--In wounds in which no cavity has been left, and in which
there is no reason to suspect infection, drainage is unnecessary. When,
however, the deeper parts of an extensive wound cannot be brought into
accurate apposition, and especially when there is any prospect of oozing
of blood or serum--as in amputation stumps or after excision of the
breast--drainage is indicated. It is a wise precaution also to insert
drainage tubes into wounds in fat patients when there is the slightest
reason to suspect the presence of infection. Glass or rubber tubes are
the best drains; but where it is desirable to leave little mark, a few
strands of horse-hair, or a small roll of rubber, form a satisfactory
substitute. Except when infection occurs, the drain is removed in from
one to four days and the opening closed with a Michel's clip or a
suture.

#Punctured Wounds.#--Punctured wounds are produced by narrow, pointed
instruments, and the sharper and smoother the instrument the more does
the resulting injury resemble an incised wound; while from more rounded
and rougher instruments the edges of the wound are more or less contused
or lacerated. The depth of punctured wounds greatly exceeds their width,
and the damage to subcutaneous parts is usually greater than that to the
skin. When the instrument transfixes a part, the edges of the wound of
entrance may be inverted, and those of the exit wound everted. If the
instrument is a rough one, these conditions may be reversed by its
sudden withdrawal.

Punctured wounds neither gape nor bleed much. Even when a large vessel
is implicated, the bleeding usually takes place into the tissues rather
than externally.

The _risks_ incident to this class of wounds are: (1) the extreme
difficulty, especially when a dense fascia has been perforated, of
rendering them aseptic, on account of the uncertainty as to their depth,
and of the way in which the surface wound closes on the withdrawal of
the instrument; (2) different forms of aneurysm may result from the
puncture of a large vessel; (3) perforation of a joint, or of a serous
cavity, such as the abdomen, thorax, or skull, materially adds to the
danger.

_Treatment._--The first indication is to purify the whole extent of the
wound, and to remove any foreign body or blood-clot that may be in it.
It is usually necessary to enlarge the wound, freely dividing injured
fasciae, paring away bruised tissues, and purifying the whole
wound-surface. Any blood vessel that is punctured should be cut across
and tied; and divided muscles, tendons, or nerves must be sutured. After
haemorrhage has been arrested, iodoform and bismuth paste is rubbed into
the raw surface, and the wound closed. If there is any reason to doubt
the asepticity of the wound, it is better treated by the open method,
and a Bier's bandage should be applied.

#Contused and Lacerated Wounds.#--These may be considered together, as
they so occur in practice. They are produced by crushing, biting, or
tearing forms of violence--such as result from machinery accidents,
firearms, or the bites of animals. In addition to the irregular wound of
the integument, there is always more or less bruising of the parts
beneath and around, and the subcutaneous lesions are much wider than
appears on the surface.

Wounds of this variety usually gape considerably, especially when there
is much laceration of the skin. It is not uncommon to have considerable
portions of skin, muscle, or tendon completely torn away.

Haemorrhage is seldom a prominent feature, as the crushing or tearing of
the vessel wall leads to the obliteration of the lumen.

The _special risks_ of these wounds are: (1) Sloughing of the bruised
tissues, especially when attempts to sterilise the wound have not been
successful. (2) Reactionary haemorrhage after the initial shock has
passed off. (3) Secondary haemorrhage as a result of infective processes
ensuing in the wound. (4) Loss of muscle or tendon, interfering with
motion. (5) Cicatricial contraction. (6) Gangrene, which may follow
occlusion of main vessels, or virulent infective processes. (7) It is
not uncommon to have particles of carbon embedded in the tissues after
lacerated wounds, leaving unsightly, pigmented scars. This is often seen
in coal-miners, and in those injured by firearms, and is to be prevented
by removing all gross dirt from the edges of the wound.

_Treatment._--In severe wounds of this class implicating the
extremities, the most important question that arises is whether or not
the limb can be saved. In examining the limb, attention should first be
directed to the state of the main blood vessels, in order to determine
if the vascular supply of the part beyond the lesion is sufficient to
maintain its vitality. Amputation is usually called for if there is
complete absence of pulsation in the distal arteries and if the part
beyond is cold. If at the same time important nerve-trunks are
lacerated, so that the function of the limb would be seriously impaired,
it is not worth running the risk of attempting to save it. If, in
addition, there is extensive destruction of large muscular masses or of
important tendons, or comminution of the bones, amputation is usually
imperative. Stripping of large areas of skin is not in itself a reason
for removing a limb, as much can be done by skin grafting, but when it
is associated with other lesions it favours amputation. In considering
these points, it must be borne in mind that the damage to the deeper
tissues is always more extensive than appears on the surface, and that
in many cases it is only possible to estimate the real extent of the
injury by administering an anaesthetic and exploring the wound. In
doubtful cases the possibility of rendering the parts aseptic will often
decide the question for or against amputation. If thorough purification
is accomplished, the success which attends conservative measures is
often remarkable. It is permissible to run an amount of risk to save an
upper extremity which would be unjustifiable in the case of a lower
limb. The age and occupation of the patient must also be taken into
account.

It having been decided to try and save the limb, the question is only
settled for the moment; it may have to be reconsidered from day to day,
or even from hour to hour, according to the progress of the case.

When it is decided to make the attempt to save the limb, the wound must
be thoroughly purified. All bruised tissue in which gross dirt has
become engrained should be cut away with knife or scissors. The raw
surface is then cleansed with eusol, washed with sterilised salt
solution followed by methylated spirit, and rubbed all over with "bipp"
paste. If the purification is considered satisfactory the wound may be
closed, otherwise it is left open, freely drained or packed with gauze,
and the limb is immobilised by suitable splints.


WOUNDS BY FIREARMS AND EXPLOSIVES

It is not necessary here to do more than indicate the general characters
of wounds produced by modern weapons. For further details the reader is
referred to works on military surgery. Experience has shown that the
nature and severity of the injuries sustained in warfare vary widely in

different campaigns, and even in different fields of the same campaign.
Slight variations in the size, shape, and weight of rifle bullets, for
example, may profoundly modify the lesions they produce: witness the
destructive effect of the pointed bullet compared with that of the
conical form previously used. The conditions under which the fighting is
carried on also influence the wounds. Those sustained in the open,
long-range fighting of the South African campaign of 1899-1902 were very
different from those met with in the entrenched warfare in France in
1914-1918. It has been found also that the infective complications are
greatly influenced by the terrain in which the fighting takes place. In
the dry, sandy, uncultivated veldt of South Africa, bullet wounds seldom
became infected, while those sustained in the highly manured fields of
Belgium were almost invariably contaminated with putrefactive organisms,
and gaseous gangrene and tetanus were common complications. It has been
found also that wounds inflicted in naval engagements present different
characters from those sustained on land. Many other factors, such as the
physical and mental condition of the men, the facilities for affording
first aid, and the transport arrangements, also play a part in
determining the nature and condition of the wounds that have to be dealt
with by military surgeons.

Whatever the nature of the weapon concerned, the wound is of the
_punctured, contused, and lacerated_ variety. Its severity depends on
the size, shape, and velocity of the missile, the range at which the
weapon is discharged, and the part of the body struck.

Shock is a prominent feature, but its degree, as well as the time of its
onset, varies with the extent and seat of the injury, and with the
mental state of the patient when wounded. We have observed pronounced
shock in children after being shot even when no serious injury was
sustained. At the moment of injury the patient experiences a sensation
which is variously described as being like the lash of a whip, a blow
with a stick, or an electric shock. There is not much pain at first, but
later it may become severe, and is usually associated with intense
thirst, especially when much blood has been lost.

In all forms of wounds sustained in warfare, septic infection
constitutes the main risk, particularly that resulting from
streptococci. The presence of anaerobic organisms introduces the
additional danger of gaseous forms of gangrene.

The earlier the wound is disinfected the greater is the possibility of
diminishing this risk. If cleansing is carried out within the first six
hours the chance of eliminating sepsis is good; with every succeeding
six hours it diminishes, until after twenty-four hours it is seldom
possible to do more than mitigate sepsis. (J. T. Morrison.)

The presence of a metallic foreign body having been determined and its
position localised by means of the X-rays, all devitalised and
contaminated tissue is excised, the foreign material, _e.g._, a missile,
fragments of clothing, gravel and blood-clot, removed, the wound
purified with antiseptics and closed or drained according to
circumstances.

#Pistol-shot Wounds.#--Wounds inflicted by pistols, revolvers, and small
air-guns are of frequent occurrence in civil practice, the weapon being
discharged usually by accident, but frequently with suicidal, and
sometimes with homicidal intent.

With all calibres and at all ranges, except actual contact, the wound of
entrance is smaller than the bullet. If the weapon is discharged within
a foot of the body, the skin surrounding the wound is usually stained
with powder and burned, and the hair singed. At ranges varying from six
inches to thirty feet, grains of powder may be found embedded in the
skin or lying loose on the surface, the greater the range the wider
being the area of spread. When black powder is used, the embedded grains
usually leave a permanent bluish-black tattooing of the skin. When the
weapon is placed in contact with the skin, the subcutaneous tissues are
lacerated over an area of two or three inches around the opening made by
the bullet and smoke and powder-staining and scorching are more marked
than at longer ranges.

When the bullet perforates, the exit wound is usually larger and more
extensively lacerated than the wound of entrance. Its margins are as a
rule everted, and it shows no marks of flame, smoke, or powder. These
features are common to all perforations caused by bullets.

Pistol wounds only produce dangerous effects when fired at close range,
and when the cavities of the skull, the thorax, or the abdomen are
implicated. In the abdomen a lethal injury may readily be caused even by
pistols of the "toy" order. These injuries will be described with
regional surgery.

Pistol-shot wounds of _joints_ and _soft parts_ are seldom of serious
import apart from the risk of haemorrhage and of infection.

_Treatment._--The treatment of wounds of the soft parts consists in
purifying the wounds of entrance and exit and the surrounding skin, and
in providing for drainage if this is indicated.

There being no urgency for the removal of the bullet, time should be
taken to have it localised by the X-rays, preferably by stereoscopic
plates. In some cases it is not necessary to remove the bullet.

#Wounds by Sporting Guns.#--In the common sporting or scatter gun, with
which accidents so commonly occur during the shooting season, the charge
of small shot or pellets leave the muzzle of the gun as a solid mass
which makes a single ragged wound having much the appearance of that
caused by a single bullet. At a distance of from four to five feet from
the muzzle the pellets begin to disperse so that there are separate
punctures around the main central wound. As the range increases, these
outlying punctures make a wider and wider pattern, until at a distance
of from eighteen to twenty feet from the muzzle, the scattering is
complete, there is no longer any central wound, and each individual
pellet makes its own puncture. From these elementary data, it is usually
possible, from the features of the wound, to arrive at an approximately
accurate conclusion regarding the range at which the gun was discharged,
and this may have an important bearing on the question of accident,
suicide, or murder.

As regards the effects on the tissues at close range, that is, within a
few feet, there is widespread laceration and disruption; if a bone is
struck it is shattered, and portions of bone may be displaced or even
driven out through the exit wound.

When the charge impinges over one of the large cavities of the body, the
shot may scatter widely through the contained viscera, and there is
often no exit wound. In the thorax, for example, if a rib is struck, the
charge and possibly fragments of bone, will penetrate the pleura, and be
dispersed throughout the lung; in the head, the skull may be shattered
and the brain torn up; and in the abdomen, the hollow viscera may be
perforated in many places and the solid organs lacerated.

On covered parts the clothing, by deflecting the shot, influences the
size and shape of the wound; the entrance wound is increased in size and
more ragged, and portions of the clothes may be driven into the tissues.

[Illustration: FIG. 62.--Radiogram showing Pellets embedded in Arm.

(Mr. J. W. Dowden's case.)]

A charge of small shot is much more destructive to blood vessels,
tendons, and ligaments than a single bullet, which in many cases pushes
such structures aside without dividing them. In the abdomen and chest,
also, the damage done by a full charge of shot is much more extensive
than that inflicted by a single bullet, the deflection of the pellets
leading to a greater number of perforations of the intestine and more
widespread laceration of solid viscera.

When the charge impinges on one of the extremities at close range, we
often have the opportunity of observing that the exit wound is larger,
more ragged than that of entrance, and that its edges are everted; the
extensive tearing and bruising of all the tissues, including the bones,
and the marked tendency to early and progressive septic infection,
render amputation compulsory in the majority of such cases.

At a range of from twenty to thirty feet, although the scatter is
complete, the pellets are still close together, so that if they
encounter the shaft of a long bone, even the femur, they fracture the
bone across, often along with some longitudinal splintering.

Individual pellets striking the shafts of long bones become flattened or
distorted, and when cancellated bone is struck they become embedded in
it (Fig. 62).

The skin, when it is closely peppered with shot, is liable to lose its
vitality, and with the addition of a little sepsis, readily necroses and
comes away as a slough.

When the shot have diverged so as to strike singly, they seldom do much
harm, but fatal damage may be done to the brain or to the aorta, or the
eye may be seriously injured by a single pellet.

Small shot fired at longer ranges--over about a hundred and fifty
feet--usually go through the skin, but seldom pierce the fascia, and lie
embedded in the subcutaneous tissue, from which they can readily be
extracted.

The wad of the cartridge behaves erratically: so long as it remains flat
it goes off with the rest of the charge, and is often buried in the
wound; but if it curls up or turns on its side, it is usually deflected
and flies clear of the shot. It may make a separate wound.

Wounds from sporting guns are to be _treated_ on the usual lines, the
early efforts being directed to the alleviation of shock and the
prevention of septic infection. There is rarely any urgency in the
removal of pellets from the tissues.

#Wounds by Rifle Bullets.#--The vast majority of wounds inflicted by
rifle bullets are met with in the field during active warfare, and fall
to be treated by military surgeons. They occasionally occur
accidentally, however, during range practice for example, and may then
come under the notice of the civil surgeon.

It is only necessary here to consider the effects of modern small-bore
rifle or machine-gun bullets.

The trajectory is practically flat up to 675 yards. In destructive
effect there is not much difference between the various high velocity
bullets used in different armies; they will kill up to a distance of two
miles. The hard covering is employed to enable the bullet to take the
grooves in the rifle, and to prevent it stripping as it passes through
the barrel. It also increases the penetrating power of the missile, but
diminishes its "stopping" power, unless a vital part or a long bone is
struck. By removing the covering from the point of the bullet, as is
done in the Dum-Dum bullet, or by splitting the end, the bullet is made
to expand or "mushroom" when it strikes the body, and its stopping power
is thereby greatly increased, the resulting wound being much more
severe. These "soft-nosed" expanding bullets are to be distinguished
from "explosive" bullets which contain substances which detonate on
impact. High velocity bullets are unlikely to lodge in the body unless
spent, or pulled up by a sandbag, or metal buckle on a belt, or a book
in the pocket, or the core and the case separating--"stripping" of the
bullet. Spent shot may merely cause bruising of the surface, or they may
pass through the skin and lodge in the subcutaneous tissue, or may even
damage some deeper structure such as a nerve trunk.

A blank cartridge fired at close range may cause a severe wound, and, if
charged with black powder, may leave a permanent bluish-black
pigmentation of the skin.

The lesions of individual tissues--bones, nerves, blood vessels--are
considered with these.

#Treatment of Gunshot Wounds under War Conditions.#--It is only
necessary to indicate briefly the method of dealing with gunshot wounds
in warfare as practised in the European War.

1. _On the Field._--Haemorrhage is arrested in the limbs by an improvised
tourniquet; in the head by a pad and bandage; in the thorax or abdomen
by packing if necessary, but this should be avoided if possible, as it
favours septic infection. If a limb is all but detached it should be
completely severed. A full dose of morphin is given hypodermically. The
ampoule of iodine carried by the wounded man is broken, and its contents
are poured over and around the wound, after which the field dressing is
applied. In extensive wounds, the "shell-dressing" carried by the
stretcher bearers is preferred. All bandages are applied loosely to
allow for subsequent swelling. The fragments of fractured bones are
immobilised by some form of emergency splint.

2. _At the Advanced Dressing Station_, after the patient has had a
liberal allowance of warm fluid nourishment, such as soup or tea, a full
dose of anti-tetanic serum is injected. The tourniquet is removed and
the wound inspected. Urgent amputations are performed. Moribund patients
are detained lest they die _en route_.

3. _In the Field Ambulance or Casualty Clearing Station_ further
measures are employed for the relief of shock, and urgent operations are
performed, such as amputation for gangrene, tracheotomy for dyspnoea, or
laparotomy for perforated or lacerated intestine. In the majority of
cases the main object is to guard against infection; the skin is
disinfected over a wide area and surrounded with towels; damaged tissue,
especially muscle, is removed with the knife or scissors, and foreign
bodies are extracted. Torn blood vessels, and, if possible, nerves and
tendons are repaired. The wound is then partly closed, provision being
made for free drainage, or some special method of irrigation, such as
that of Carrel, is adopted. Sometimes the wound is treated with bismuth,
iodoform, and paraffin paste (B.I.P.P.) and sutured.

4. _In the Base Hospital or Hospital Ship_ various measures may be
called for according to the progress of the wound and the condition of
the patient.

#Shell Wounds and Wounds produced by Explosions.#--It is convenient to
consider together the effects of the bursting of shells fired from heavy
ordnance and those resulting in the course of blasting operations from
the discharge of dynamite or other explosives, or from the bursting of
steam boilers or pipes, the breaking of machinery, and similar accidents
met with in civil practice.

Wounds inflicted by shell fragments and shrapnel bullets tend to be
extensive in area, and show great contusion, laceration, and destruction
of the tissues. The missiles frequently lodge and carry portions of the
clothing and, it may be, articles from the man's pocket, with them.
Shell wounds are attended with a considerable degree of shock. On
account of the wide area of contusion which surrounds the actual wound
produced by shell fragments, amputation, when called for, should be
performed some distance above the torn tissues, as there is considerable
risk of sloughing of the flaps.

Wounds produced by dynamite explosions and the bursting of boilers have
the same general characters as shell wounds. Fragments of stone, coal,
or metal may lodge in the tissues, and favour the occurrence of
infective complications.

All such injuries are to be treated on the general principles governing
contused and lacerated wounds.


EMBEDDED FOREIGN BODIES

In the course of many operations foreign substances are introduced into
the tissues and intentionally left there, for example, suture and
ligature materials, steel or aluminium plates, silver wire or ivory pegs
used to secure the fixation of bones, or solid paraffin employed to
correct deformities. Other substances, such as gauze, drainage tubes,
or metal instruments, may be unintentionally left in a wound.

Foreign bodies may also lodge in accidentally inflicted wounds, for
example, bullets, needles, splinters of wood, or fragments of clothing.
The needles of hypodermic syringes sometimes break and a portion remains
embedded in the tissues. As a result of explosions, particles of carbon,
in the form of coal-dust or gunpowder, or portions of shale, may lodge
in a wound.

The embedded foreign body at first acts as an irritant, and induces a
reaction in the tissues in which it lodges, in the form of hyperaemia,
local leucocytosis, proliferation of fibroblasts, and the formation of
granulation tissue. The subsequent changes depend upon whether or not
the wound is infected with pyogenic bacteria. If it is so infected,
suppuration ensues, a sinus forms, and persists until the foreign body
is either cast out or removed.

If the wound is aseptic, the fate of the foreign body varies with its
character. A substance that is absorbable, such as catgut or fine silk,
is surrounded and permeated by the phagocytes, which soften and
disintegrate it, the debris being gradually absorbed in much the same
manner as a fibrinous exudate. Minute bodies that are not capable of
being absorbed, such as particles of carbon, or of pigment used in
tattooing, are taken up by the phagocytes, and in course of time
removed. Larger bodies, such as needles or bullets, which are not
capable of being destroyed by the phagocytes, become encapsulated. In
the granulation tissue by which they are surrounded large multinuclear
giant-cells appear ("_foreign-body giant-cells_") and attach themselves
to the foreign body, the fibroblasts proliferate and a capsule of scar
tissue is eventually formed around the body. The tissues of the capsule
may show evidence of iron pigmentation. Sometimes fluid accumulates
around a foreign body within its capsule, constituting a cyst.

Substances like paraffin, strands of silk used to bridge a gap in a
tendon, or portions of calcined bone, instead of being encapsulated, are
gradually permeated and eventually replaced by new connective tissue.

Embedded bodies may remain in the tissues for an indefinite period
without giving rise to inconvenience. At any time, however, they may
cause trouble, either as a result of infective complications, or by
inducing the formation of a mass of inflammatory tissue around them,
which may simulate a gumma, a tuberculous focus, or a sarcoma. This
latter condition may give rise to difficulties in diagnosis,
particularly if there is no history forthcoming of the entrance of the
foreign body. The ignorance of patients regarding the possible lodgment
in the tissues of a foreign body--even of considerable size--is
remarkable. In such cases the X-rays will reveal the presence of the
foreign body if it is sufficiently opaque to cast a shadow. The heavy,
lead-containing varieties of glass throw very definite shadows little
inferior in sharpness and definition to those of metal; almost all the
ordinary forms of commercial glass also may be shown up by the X-rays.

Foreign bodies encapsulated in the peritoneal cavity are specially
dangerous, as the proximity of the intestine furnishes a constant
possibility of infection.

The question of removal of the foreign body must be decided according to
the conditions present in individual cases; in searching for a foreign
body in the tissues, unless it has been accurately located, a general
anaesthetic is to be preferred.


BURNS AND SCALDS

The distinction between a burn which results from the action of dry heat
on the tissues of the body and a scald which results from the action of
moist heat, has no clinical significance.

In young and debilitated subjects hot poultices may produce injuries of
the nature of burns. In old people with enfeebled circulation mere
exposure to a strong fire may cause severe degrees of burning, the
clothes covering the part being uninjured. This may also occur about the
feet, legs, or knees of persons while intoxicated who have fallen asleep
before the fire.

The damage done to the tissues by strong caustics, such as fuming nitric
acid, sulphuric acid, caustic potash, nitrate of silver, or arsenical
paste, presents pathological and clinical features almost identical with
those resulting from heat. Electricity and the Rontgen rays also produce
lesions of the nature of burns.

_Pathology of Burns._--Much discussion has taken place regarding the
explanation of the rapidly fatal issue in extensive superficial burns.
On post-mortem examination the lesions found in these cases are: (1)
general hyperaemia of all the organs of the abdominal, thoracic, and
cerebro-spinal cavities; (2) marked leucocytosis, with destruction of
red corpuscles, setting free haemoglobin which lodges in the epithelial
cells of the tubules of the kidneys; (3) minute thrombi and
extravasations throughout the tissues of the body; (4) degeneration of
the ganglion cells of the solar plexus; (5) oedema and degeneration of
the lymphoid tissue throughout the body; (6) cloudy swelling of the
liver and kidneys, and softening and enlargement of the spleen. Bardeen
suggests that these morbid phenomena correspond so closely to those met
with where the presence of a toxin is known to produce them, that in all
probability death is similarly due to the action of some poison produced
by the action of heat on the skin and on the proteins of the blood.

#Clinical Features--Local Phenomena.#--The most generally accepted
classification of burns is that of Dupuytren, which is based upon the
depth of the lesion. Six degrees are thus, recognised: (1) hyperaemia or
erythema; (2) vesication; (3) partial destruction of the true skin; (4)
total destruction of the true skin; (5) charring of muscles; (6)
charring of bones.

It must be observed, however, that burns met with at the bedside always
illustrate more than one of these degrees, the deeper forms always being
associated with those less deep, and the clinical picture is made up of
the combined characters of all. A burn is classified in terms of its
most severe portion. It is also to be remarked that the extent and
severity of a burn usually prove to be greater than at first sight
appears.

_Burns of the first degree_ are associated with erythema of the skin,
due to hyperaemia of its blood vessels, and result from scorching by
flame, from contact with solids or fluids below 212 o F., or from
exposure to the sun's rays. They are characterised clinically by acute
pain, redness, transitory swelling from oedema, and subsequent
desquamation of the surface layers of the epidermis. A special form of
pigmentation of the skin is seen on the front of the legs of women from
exposure to the heat of the fire.

_Burns of Second Degree--Vesication of the Skin._--These are
characterised by the occurrence of vesicles or blisters which are
scattered over the hyperaemic area, and contain a clear yellowish or
brownish fluid. On removing the raised epidermis, the congested and
highly sensitive papillae of the skin are exposed. Unna has found that
pyogenic bacteria are invariably present in these blisters. Burns of the
second degree leave no scar but frequently a persistent discoloration.
In rare instances the burned area becomes the seat of a peculiar
overgrowth of fibrous tissue of the nature of keloid (p 401).

_Burns of Third Degree--Partial Destruction of the Skin._--The epidermis
and papillae are destroyed in patches, leaving hard, dry, and insensitive
sloughs of a yellow or black colour. The pain in these burns is
intense, but passes off during the first or second day, to return again,
however, when, about the end of a week, the sloughs separate and expose
the nerve filaments of the underlying skin. Granulations spring up to
fill the gap, and are rapidly covered by epithelium, derived partly from
the margins and partly from the remains of skin glands which have not
been completely destroyed. These latter appear on the surface of the
granulations as small bluish islets which gradually increase in size,
become of a greyish-white colour, and ultimately blend with one another
and with the edges. The resulting cicatrix may be slightly depressed,
but otherwise exhibits little tendency to contract and cause deformity.

_Burns of Fourth Degree--Total Destruction of the Skin._--These follow
the more prolonged action of any form of intense heat. Large, black, dry
eschars are formed, surrounded by a zone of intense congestion. Pain is
less severe, and is referred to the parts that have been burned to a
less degree. Infection is liable to occur and to lead to wide
destruction of the surrounding skin. The amount of granulation tissue
necessary to fill the gap is therefore great; and as the epithelial
covering can only be derived from the margins--the skin glands being
completely destroyed--the healing process is slow. The resulting scars
are irregular, deep and puckered, and show a great tendency to contract.
Keloid frequently develops in such cicatrices. When situated in the
region of the face, neck, or flexures of joints, much deformity and
impairment of function may result (Fig. 63).

[Illustration: FIG. 63.--Cicatricial Contraction following Severe Burn.]

In _burns of the fifth degree_ the lesion extends through the
subcutaneous tissue and involves the muscles; while in those of the
_sixth degree_ it passes still more deeply and implicates the bones.
These burns are comparatively limited in area, as they are usually
produced by prolonged contact with hot metal or caustics. Burns of the
fifth and sixth degrees are met with in epileptics or intoxicated
persons who fall into the fire. Large blood vessels, nerve-trunks,
joints, or serous cavities may be implicated.

#General Phenomena.#--It is customary to divide the clinical history of
a severe burn into three periods; but it is to be observed that the
features characteristic of the periods have been greatly modified since
burns have been treated on the same lines as other wounds.

_The first period_ lasts for from thirty-six to forty-eight hours,
during which time the patient remains in a more or less profound state
of _shock_, and there is a remarkable absence of pain. When shock is
absent or little marked, however, the amount of suffering may be great.
When the injury proves fatal during this period, death is due to shock,
probably aggravated by the absorption of poisonous substances produced
in the burned tissues. In fatal cases there is often evidence of
cerebral congestion and oedema.

The _second period_ begins when the shock passes off, and lasts till the
sloughs separate. The outstanding feature of this period is _toxaemia_,
manifested by fever, the temperature rising to 102 o, 103 o, or 104 o F.,
and congestive or inflammatory conditions of internal organs, giving
rise to such clinical complications as bronchitis, broncho-pneumonia, or
pleurisy--especially in burns of the thorax; or meningitis and
cerebritis, when the neck or head is the seat of the burn. Intestinal
catarrh associated with diarrhoea is not uncommon; and ulceration of the
duodenum leading to perforation has been met with in a few cases. These
phenomena are much more prominent when bacterial infection has taken
place, and it seems probable that they are to be attributed chiefly to
the infection, as they have become less frequent and less severe since
burns have been treated like other breaches of the surface. Albuminuria
is a fairly constant symptom in severe burns, and is associated with
congestion of the kidneys. In burns implicating the face, neck, mouth,
or pharynx, oedema of the glottis is a dangerous complication, entailing
as it does the risk of suffocation.

The _third period_ begins when the sloughs separate, usually between
the seventh and fourteenth days, and lasts till the wound heals, its
duration depending upon the size, depth, and asepticity of the raw area.
The chief causes of death during this period are toxin absorption in any
of its forms; waxy disease of the liver, kidneys, or intestine; less
commonly erysipelas, tetanus, or other diseases due to infection by
specific organisms. We have seen nothing to substantiate the belief that
duodenal ulcers are liable to perforate during the third period.

The _prognosis_ in burns depends on (1) the superficial extent, and, to
a much less degree, the depth of the injury. When more than one-third of
the entire surface of the body is involved, even in a mild degree, the
prognosis is grave. (2) The situation of the burn is important. Burns
over the serous cavities--abdomen, thorax, or skull--are, other things
being equal, much more dangerous than burns of the limbs. The risk of
oedema of the glottis in burns about the neck and mouth has already been
referred to. (3) Children are more liable to succumb to shock during the
early period, but withstand prolonged suppuration better than adults.
(4) When the patient survives the shock, the presence or absence of
infection is the all-important factor in prognosis.

#Treatment.#--The _general treatment_ consists in combating the shock.
When pain is severe, morphin must be injected.

_Local Treatment._--The local treatment must be carried out on
antiseptic lines, a general anaesthetic being administered, if necessary,
to enable the purification to be carried out thoroughly. After carefully
removing the clothing, the whole of the burned area is gently, but
thoroughly, cleansed with peroxide of hydrogen or warm boracic lotion,
followed by sterilised saline solution. As pyogenic bacteria are
invariably found in the blisters of burns, these must be opened and the
raised epithelium removed.

The dressings subsequently applied should meet the following
indications: the relief of pain; the prevention of sepsis; and the
promotion of cicatrisation.

An application which satisfactorily fulfils these requirements is
_picric acid_. Pads of lint or gauze are lightly wrung out of a solution
made up of picric acid, 1 1/2 drams; absolute alcohol, 3 ounces;
distilled water, 40 ounces, and applied over the whole of the reddened
area. These are covered with antiseptic wool, _without_ any waterproof
covering, and retained in position by a many-tailed bandage. The
dressing should be changed once or twice a week, under the guidance of
the temperature chart, any portion of the original dressing which
remains perfectly dry being left undisturbed. The value of a general
anaesthetic in dressing extensive burns, especially in children, can
scarcely be overestimated.

Picric acid yields its best results in superficial burns, and it is
useful as _a primary dressing_ in all. As soon as the sloughs separate
and a granulating surface forms, the ordinary treatment for a healing
sore is instituted. Any slough under which pus has collected should be
cut away with scissors to permit of free drainage.

An occlusive dressing of melted _paraffin_ has also been employed. A
useful preparation consists of: Paraffin molle 25 per cent., paraffin
durum 67 per cent., olive oil 5 per cent., oil of eucalyptus 2 per
cent., and beta-naphthol 1/4 per cent. It has a melting point of 48 o C.
It is also known as _Ambrine_ and _Burnol_. After the burned area has
been cleansed and thoroughly dried, it is sponged or painted with the
melted paraffin, and before solidification takes place a layer of
sterilised gauze is applied and covered with a second coating of
paraffin. Further coats of paraffin are applied every other day to
prevent the gauze sticking to the skin.

An alternative method of treating extensive burns is by immersing the
part, or even the whole body when the trunk is affected, in a bath of
boracic lotion kept at the body temperature, the lotion being frequently
renewed.

If a burn is already infected when first seen, it is to be treated on
the same principles as govern the treatment of other infected wounds.

All moist or greasy applications, such as Carron oil, carbolic oil and
ointments, and all substances like collodion and dry powders, which
retain discharges, entirely fail to meet the indications for the
rational treatment of burns, and should be abandoned.

Skin-grafting is of great value in hastening healing after extensive
burns, and in preventing cicatricial contraction. The _deformities_
which are so liable to develop from contraction of the cicatrices are
treated on general principles. In the region of the face, neck, and
flexures of joints (Fig. 63), where they are most marked, the contracted
bands may be divided and the parts stretched, the raw surface left being
covered by Thiersch grafts or by flaps of skin raised from adjacent
surfaces or from other parts of the body (Fig. 1).


INJURIES PRODUCED BY ELECTRICITY

#Injuries produced by Exposure to X-Rays and Radium.#--In the routine
treatment of disease by radiations, injury is sometimes done to the
tissues, even when the greatest care is exercised as to dosage and
frequency of application. Robert Knox describes the following
ill-effects.

_Acute dermatitis_ varying in degree from a slight erythema to deep
ulceration or even necrosis of skin. When ulcers form they are extremely
painful and slow to heal. When hair-bearing areas are affected,
epilation may occur without destroying the hair follicles and the hairs
are reproduced, but if the reaction is excessive permanent alopecia may
result.

_Chronic dermatitis_, which results from persistence of the acute form,
is most intractable and may assume malignant characters. X-ray warts are
a late manifestation of chronic dermatitis and may become malignant.

Among the _late manifestations_ are neuritis, telangiectasis, and a
painful and intractable form of ulceration, any of which may come on
months or even years after the cessation of exposure. _Sterility_ may be
induced in X-ray workers who are imperfectly protected from the effects
of the rays.

#Electrical burns# usually occur in those who are engaged in industrial
undertakings where powerful electrical currents are employed.

The lesions--which vary from a slight superficial scorching to complete
charring of parts--are most evident at the points of entrance and exit
of the current, the intervening tissues apparently escaping injury.

The more superficial degrees of electrical burns differ from those
produced by heat in being almost painless, and in healing very slowly,
although as a rule they remain dry and aseptic.

The more severe forms are attended with a considerable degree of shock,
which is not only more profound, but also lasts much longer than the
shock in an ordinary burn of corresponding severity. The parts at the
point of entrance of the current are charred to a greater or lesser
depth. The eschar is at first dry and crisp, and is surrounded by a zone
of pallor. For the first thirty-six to forty-eight hours there is
comparatively little suffering, but at the end of that time the parts
become exceedingly painful. In a majority of cases, in spite of careful
purification, a slow form of moist gangrene sets in, and the slough
spreads both in area and in depth, until the muscles and often the
large blood vessels and nerves are exposed. A line of demarcation
eventually forms, but the sloughs are exceedingly slow to separate,
taking from three to five times as long as in an ordinary burn, and
during the process of separation there is considerable risk of secondary
haemorrhage from erosion of large vessels.

_Treatment._--Electrical burns are treated on the same lines as ordinary
burns, by thorough purification and the application of dry dressings,
with a view to avoiding the onset of moist gangrene. After granulations
have formed, skin-grafting is of value in hastening healing.

#Lightning-stroke.#--In a large proportion of cases lightning-stroke
proves instantly fatal. In non-fatal cases the patient suffers from a
profound degree of shock, and there may or may not be any external
evidence of injury. In the mildest cases red spots or wheals--closely
resembling those of urticaria--may appear on the body, but they usually
fade again in the course of twenty-four hours. Sometimes large patches
of skin are scorched or stained, the discoloured area showing an
arborescent appearance. In other cases the injured skin becomes dry and
glazed, resembling parchment. Appearances are occasionally met with
corresponding to those of a superficial burn produced by heat. The chief
difference from ordinary burns is the extreme slowness with which
healing takes place. Localised paralysis of groups of muscles, or even
of a whole limb, may follow any degree of lightning-stroke. Treatment is
mainly directed towards combating the shock, the surface-lesions being
treated on the same lines as ordinary burns.




CHAPTER XII

METHODS OF WOUND TREATMENT


Varieties of wounds--Modes of infection--Lister's work--Means taken to
    prevent infection of wounds: _heat_; _chemical antiseptics_;
    _disinfection of hands_; _preparation of skin of patient_;
    _instruments_; _ligatures_; _dressings_--Means taken to combat
    infection: _purification_; _open-wound method_.

The surgeon is called upon to treat two distinct classes of wounds: (1)
those resulting from injury or disease in which _the skin is already
broken_, or in which a communication with a mucous surface exists; and
(2) those that he himself makes _through intact skin_, no infected
mucous surface being involved.

Infection by bacteria must be assumed to have taken place in all wounds
made in any other way than by the knife of the surgeon operating through
unbroken skin. On this assumption the modern system of wound treatment
is based. Pathogenic bacteria are so widely distributed, that in the
ordinary circumstances of everyday life, no matter how trivial a wound
may be, or how short a time it may remain exposed, the access of
organisms to it is almost certain unless preventive measures are
employed.

It cannot be emphasised too strongly that rigid precautions are to be
taken to exclude fresh infection, not only in dealing with wounds that
are free of organisms, but equally in the management of wounds and other
lesions that are already infected. Any laxity in our methods which
admits of fresh organisms reaching an infected wound adds materially to
the severity of the infective process and consequently to the patient's
risk.

There are many ways in which accidental infection may occur. Take, for
example, the case of a person who receives a cut on the face by being
knocked down in a carriage accident on the street. Organisms may be
introduced to such a wound from the shaft or wheel by which he was
struck, from the ground on which he lay, from any portion of his
clothing that may have come in contact with the wound, or from his own
skin. Or, again, the hands of those who render first aid, the water used
to bathe the wound, the handkerchief or other extemporised dressing
applied to it, may be the means of conveying bacterial infection. Should
the wound open on a mucous surface, such as the mouth or nasal cavity,
the organisms constantly present in such situations are liable to prove
agents of infection.

Even after the patient has come under professional care the risks of his
wound becoming infected are not past, because the hands of the doctor,
his instruments, dressings, or other appliances may all, unless
purified, become the sources of infection.

In the case of an operation carried out through unbroken skin, organisms
may be introduced into the wound from the patient's own skin, from the
hands of the surgeon or his assistants, through the medium of
contaminated instruments, swabs, ligature or suture materials, or other
things used in the course of the operation, or from the dressings
applied to the wound.

Further, bacteria may gain access to devitalised tissues by way of the
blood-stream, being carried hither from some infected area elsewhere in
the body.

_The Antiseptic System of Surgery._--Those who only know the surgical
conditions of to-day can scarcely realise the state of matters which
existed before the introduction of the antiseptic system by Joseph
Lister in 1867. In those days few wounds escaped the ravages of pyogenic
and other bacteria, with the result that suppuration ensued after most
operations, and such diseases as erysipelas, pyaemia, and "hospital
gangrene" were of everyday occurrence. The mortality after compound
fractures, amputations, and many other operations was appalling, and
death from blood-poisoning frequently followed even the most trivial
operations. An operation was looked upon as a last resource, and the
inherent risk from blood-poisoning seemed to have set an impassable
barrier to the further progress of surgery. To the genius of Lister we
owe it that this barrier was removed. Having satisfied himself that the
septic process was due to bacterial infection, he devised a means of
preventing the access of organisms to wounds or of counteracting their
effects. Carbolic acid was the first antiseptic agent he employed, and
by its use in compound fractures he soon obtained results such as had
never before been attained. The principle was applied to other
conditions with like success, and so profoundly has it affected the
whole aspect of surgical pathology, that many of the infective diseases
with which surgeons formerly had to deal are now all but unknown. The
broad principles upon which Lister founded his system remain unchanged,
although the methods employed to put them into practice have been
modified.

#Means taken to Prevent Infection of Wounds.#--The avenues by which
infective agents may gain access to surgical wounds are so numerous and
so wide, that it requires the greatest care and the most watchful
attention on the part of the surgeon to guard them all. It is only by
constant practice and patient attention to technical details in the
operating room and at the bedside, that the carrying out of surgical
manipulations in such a way as to avoid bacterial infection will become
an instinctive act and a second nature. It is only possible here to
indicate the chief directions in which danger lies, and to describe the
means most generally adopted to avoid it.

To prevent infection, it is essential that everything which comes into
contact with a wound should be sterilised or disinfected, and to ensure
the best results it is necessary that the efficiency of our methods of
sterilisation should be periodically tested. The two chief agencies at
our disposal are heat and chemical antiseptics.

#Sterilisation by Heat.#--The most reliable, and at the same time the
most convenient and generally applicable, means of sterilisation is by
heat. All bacteria and spores are completely destroyed by being
subjected for fifteen minutes to _saturated circulating steam_ at a
temperature of 130 o to 145 o C. (= 266 o to 293 o F.). The articles to be
sterilised are enclosed in a perforated tin casket, which is placed in a
specially constructed steriliser, such as that of Schimmelbusch. This
apparatus is so arranged that the steam circulates under a pressure of
from two to three atmospheres, and permeates everything contained in it.
Objects so sterilised are dry when removed from the steriliser. This
method is specially suitable for appliances which are not damaged by
steam, such, for example, as gauze swabs, towels, aprons, gloves, and
metal instruments; it is essential that the efficiency of the steriliser
be tested from time to time by a self-registering thermometer or other
means.

The best substitute for circulating steam is _boiling_. The articles are
placed in a "fish-kettle steriliser" and boiled for fifteen minutes in a
1 per cent. solution of washing soda.

To prevent contamination of objects that have been sterilised they must
on no account be touched by any one whose hands have not been
disinfected and protected by sterilised gloves.

#Sterilisation by Chemical Agents.#--For the purification of the skin of
the patient, the hands of the surgeon, and knives and other instruments
that are damaged by heat, recourse must be had to chemical agents.
These, however, are less reliable than heat, and are open to certain
other objections.

#Disinfection of the Hands.#--It is now generally recognised that one of
the most likely sources of wound infection is the hands of the surgeon
and his assistants. It is only by carefully studying to avoid all
contact with infective matter that the hands can be kept surgically
pure, and that this source of wound infection can be reduced to a
minimum. The risk of infection from this source has further been greatly
reduced by the systematic use of rubber gloves by house-surgeons,
dressers, and nurses. The habitual use of gloves has also been adopted
by the great majority of surgeons; the minority, who find they are
handicapped by wearing gloves as a routine measure, are obliged to do so
when operating in infective cases or dressing infected wounds, and in
making rectal and vaginal examinations.

The gloves may be sterilised by steam, and are then put on dry, or by
boiling, in which case they are put on wet. The gauntlet of the glove
should overlap and confine the end of the sleeve of the sterilised
overall, and the gloved hands are rinsed in lotion before and at
frequent intervals during the operation. The hands are sterilised before
putting on the gloves, preferably by a method which dehydrates the skin.
Cotton gloves may be worn by the surgeon when tying ligatures, or
between operations, and by the anaesthetist during operations on the
head, neck, and chest.

The first step in the disinfection of the hands is the mechanical
removal of gross surface dirt and loose epithelium by soap, a stream of
running water as hot as can be borne, and a loofah or nail-brush, that
has been previously sterilised by heat. The nails should be cut down
till there is no sulcus between the nail edge and the pulp of the finger
in which organisms may lodge. They are next washed for three minutes in
methylated spirit to dehydrate the skin, and then for two or three
minutes in 70 per cent. sublimate or biniodide alcohol (1 in 1000).
Finally, the hands are rubbed with dry sterilised gauze.

#Preparation of the Skin of the Patient.#--In the purification of the
skin of the patient before operation, reliance is to be placed chiefly
in the mechanical removal of dirt and grease by the same means as are
taken for the cleansing of the surgeon's hands. Hair-covered parts
should be shaved. The skin is then dehydrated by washing with methylated
spirit, followed by 70 per cent. sublimate or biniodide alcohol (1 in
1000). This is done some hours before the operation, and the part is
then covered with pads of dry sterilised gauze or a sterilised towel.
Immediately before the operation the skin is again purified in the same
way.

The _iodine method_ of disinfecting the skin introduced by Grossich is
simple, and equally efficient. The day before operation the skin, after
being washed with soap and water, is shaved, dehydrated by means of
methylated spirit, and then painted with a 5 per cent. solution of
iodine in rectified spirit. The painting with iodine is repeated just
before the operation commences, and again after it is completed. The
final application is omitted in the case of children. In emergency
operations the skin is shaved dry and dehydrated with spirit, after
which the iodine is applied as described above. The staining of the skin
is an advantage, as it enables the operator to recognise the area that
has been prepared.

If any acne pustules or infected sinuses are present, they should be
destroyed or purified by means of the thermo-cautery or pure carbolic
acid, after the patient is anaesthetised.

#Appliances used at Operation.#--_Instruments_ that are not damaged by
heat must be boiled in a fish-kettle or other suitable steriliser for
fifteen minutes in a 1 per cent. solution of cresol or washing soda.
Just before the operation begins they are removed in the tray of the
steriliser and placed on a sterilised towel within reach of the surgeon
or his assistant. Knives and instruments that are liable to be damaged
by heat should be purified by being soaked in pure cresol for a few
minutes, or in 1 in 20 carbolic for at least an hour.

_Pads of Gauze_ sterilised by compressed circulating steam have almost
entirely superseded marine sponges for operative purposes. To avoid the
risk of leaving swabs in the peritoneal cavity, large square pads of
gauze, to one corner of which a piece of strong tape about a foot long
is securely stitched, should be employed. They should be removed from
the caskets in which they are sterilised by means of sterilised forceps,
and handed direct to the surgeon. The assistant who attends to the swabs
should wear sterilised gloves.

_Ligatures and Sutures._--To avoid the risk of implanting infective
matter in a wound by means of the materials used for ligatures and
sutures, great care must be taken in their preparation.

_Catgut._--The following methods of preparing catgut have proved
satisfactory: (1) The gut is soaked in juniper oil for at least a month;
the juniper oil is then removed by ether and alcohol, and the gut
preserved in 1 in 1000 solution of corrosive sublimate in alcohol
(Kocher). (2) The gut is placed in a brass receiver and boiled for
three-quarters of an hour in a solution consisting of 85 per cent.
absolute alcohol, 10 per cent. water, and 5 per cent. carbolic acid, and
is then stored in 90 per cent. alcohol. (3) Cladius recommends that the
catgut, just as it is bought from the dealers, be loosely rolled on a
spool, and then immersed in a solution of--iodine, 1 part; iodide of
potassium, 1 part; distilled water, 100 parts. At the end of eight days
it is ready for use. Moschcowitz has found that the tensile strength of
catgut so prepared is increased if it is kept dry in a sterile vessel,
instead of being left indefinitely in the iodine solution. If
Salkindsohn's formula is used--tincture of iodine, 1 part; proof spirit,
15 parts--the gut can be kept permanently in the solution without
becoming brittle. To avoid contamination from the hands, catgut should
be removed from the bottle with aseptic forceps and passed direct to the
surgeon. Any portion unused should be thrown away.

_Silk_ is prepared by being soaked for twelve hours in ether, for other
twelve in alcohol, and then boiled for ten minutes in 1 in 1000
sublimate solution. It is then wound on spools with purified hands
protected by sterilised gloves, and kept in absolute alcohol. Before an
operation the silk is again boiled for ten minutes in the same solution,
and is used directly from this (Kocher). Linen thread is sterilised in
the same way as silk.

Fishing-gut and silver wire, as well as the needles, should be boiled
along with the instruments. Horse-hair and fishing-gut may be sterilised
by prolonged immersion in 1 in 20 carbolic, or in the iodine solutions
employed to sterilise catgut.

The field of operation is surrounded by sterilised towels, clipped to
the edges of the wound, and securely fixed in position so that no
contamination may take place from the surroundings.

The surgeon and his assistants, including the anaesthetist, wear
overalls sterilised by steam. To avoid the risk of infection from dust,
scurf, or drops of perspiration falling from the head, the surgeon and
his assistants may wear sterilised cotton caps. To obviate the risk of
infection taking place by drops of saliva projected from the mouth in
talking or coughing in the vicinity of a wound, a simple mask may be
worn.

The risk of infection from the _air_ is now known to be very small, so
long as there is no excess of floating dust. All sweeping, dusting, and
disturbing of curtains, blinds, or furniture must therefore be avoided
before or during an operation.

It has been shown that the presence of spectators increases the number
of organisms in the atmosphere. In teaching clinics, therefore, the risk
from air infection is greater than in private practice.

To facilitate primary union, all haemorrhage should be arrested, and the
accumulation of fluid in the wound prevented. When much oozing is
anticipated, a glass or rubber drainage-tube is inserted through a small
opening specially made for the purpose. In aseptic wounds the tube may
be removed in from twenty-four to forty-eight hours, and where it is
important to avoid a scar, the opening should be closed with a Michel's
clip; in infected wounds the tube must remain as long as the discharge
continues.

The fascia and skin should be brought into accurate apposition by
sutures. If any cavity exists in the deeper part of the wound it should
be obliterated by buried sutures, or by so adjusting the dressing as to
bring its walls into apposition.

If these precautions have been successful, the wound will heal under the
original dressing, which need not be interfered with for from seven to
ten days, according to the nature of the case.

#Dressings.#--_Gauze_, sterilised by heat, is almost universally
employed for the dressing of wounds. _Double cyanide gauze_ may be used
in such regions as the neck, axilla, or groin, where complete
sterilisation of the skin is difficult to attain, and where it is
desirable to leave the dressing undisturbed for ten days or more.
_Iodoform_ or _bismuth gauze_ is of special value for the packing of
wounds treated by the open method.

One variety or another of _wool_, rendered absorbent by the extraction
of its fat, and sterilised by heat, forms a part of almost every
surgical dressing, and various antiseptic agents may be added to it. Of
these, corrosive sublimate is the most generally used. Wood-wool
dressings are more highly and more uniformly absorbent than cotton
wools. As evaporation takes place through wool dressings, the discharge
becomes dried, and so forms an unfavourable medium for bacterial growth.

Pads of _sphagnum moss_, sterilised by heat, are highly absorbent, and
being economical are used when there is much discharge, and in cases
where a leakage of urine has to be soaked up.

#Means adopted to combat Infection.#--As has already been indicated, the
same antiseptic precautions are to be taken in dealing with infected as
with aseptic wounds.

In _recent injuries_ such as result from railway or machinery accidents,
with bruising and crushing of the tissues and grinding of gross dirt
into the wounds, the scissors must be freely used to remove the tissues
that have been devitalised or impregnated with foreign material.
Hair-covered parts should be shaved and the surrounding skin painted
with iodine. Crushed and contaminated portions of bone should be
chiselled away. Opinions differ as to the benefit derived from washing
such wounds with chemical antiseptics, which are liable to devitalise
the tissues with which they come in contact, and so render them less
able to resist the action of any organisms that may remain in them. All
are agreed, however, that free washing with normal salt solution is
useful in mechanically cleansing the injured parts. Peroxide of hydrogen
sprayed over such wounds is also beneficial in virtue of its oxidising
properties. Efficient drainage must be provided, and stitches should be
used sparingly, if at all.

The best way in which to treat such wounds is by the _open method_. This
consists in packing the wound with iodoform or bismuth gauze, which is
left in position as long as it adheres to the raw surface. The packing
may be renewed at intervals until the wound is filled by granulations;
or, in the course of a few days when it becomes evident that the
infection has been overcome, _secondary_ sutures may be introduced and
the edges drawn together, provision being made at the ends for further
packing or for drainage-tubes.

If earth or street dirt has entered the wound, the surface may with
advantage be painted over with pure carbolic acid, as virulent
organisms, such as those of tetanus or spreading gangrene, are liable to
be present. Prophylactic injection of tetanus antitoxin may be
indicated.




CHAPTER XIII

CONSTITUTIONAL EFFECTS OF INJURIES


SYNCOPE--SHOCK--COLLAPSE--FAT EMBOLISM--TRAUMATIC ASPHYXIA--DELIRIUM
    IN SURGICAL PATIENTS: _Delirium in general_; _Delirium tremens_;
    _Traumatic delirium_.


SYNCOPE, SHOCK, AND COLLAPSE

Syncope, shock, and collapse are clinical conditions which, although
depending on different causes, bear a superficial resemblance to one
another.

#Syncope or Fainting.#--Syncope is the result of a suddenly produced
anaemia of the brain from temporary weakening or arrest of the heart's
action. In surgical practice, this condition is usually observed in
nervous persons who have been subjected to pain, as in the reduction of
a dislocation or the incision of a whitlow; or in those who have rapidly
lost a considerable quantity of blood. It may also follow the sudden
withdrawal of fluid from a large cavity, as in tapping an abdomen for
ascites, or withdrawing fluid from the pleural cavity. Syncope sometimes
occurs also during the administration of a general anaesthetic,
especially if there is a tendency to sickness and the patient is not
completely under. During an operation the onset of syncope is often
recognised by the cessation of oozing from the divided vessels before
the general symptoms become manifest.

_Clinical Features._--When a person is about to faint he feels giddy,
has surging sounds in his ears, and haziness of vision; he yawns,
becomes pale and sick, and a free flow of saliva takes place into the
mouth. The pupils dilate; the pulse becomes small and almost
imperceptible; the respirations shallow and hurried; consciousness
gradually fades away, and he falls in a heap on the floor.

Sometimes vomiting ensues before the patient completely loses
consciousness, and the muscular exertion entailed may ward off the
actual faint. This is frequently seen in threatened syncopal attacks
during chloroform administration.

Recovery begins in a few seconds, the patient sighing or gasping, or, it
may be, vomiting; the strength of the pulse gradually increases, and
consciousness slowly returns. In some cases, however, syncope is fatal.

_Treatment._--The head should at once be lowered--in imitation of
nature's method--to encourage the flow of blood to the brain, the
patient, if necessary, being held up by the heels. All tight clothing,
especially round the neck or chest, must be loosened. The heart may be
stimulated reflexly by dashing cold water over the face or chest, or by
rubbing the face vigorously with a rough towel. The application of
volatile substances, such as ammonia or smelling-salts, to the nose; the
administration by the mouth of sal-volatile, whisky or brandy, and the
intra-muscular injection of ether, are the most speedily efficacious
remedies. In severe cases the application of hot cloths over the heart,
or of the faradic current over the line of the phrenic nerve, just above
the clavicle, may be called for.

#Surgical Shock.#--The condition known as surgical shock may be looked
upon as a state of profound exhaustion of the mechanism that exists in
the body for the transformation of energy. This mechanism consists of
(1) the _brain_, which, through certain special centres, regulates all
vital activity; (2) the _adrenal glands_, the secretion of
which--adrenalin--acting as a stimulant of the sympathetic system, so
controls the tone of the blood vessels as to maintain efficient
oxidation of the tissues; and (3) _the liver_, which stores and delivers
glycogen as it is required by the muscles, and in addition, deals with
the by-products of metabolism.

Crile and his co-workers have shown that in surgical shock histological
changes occur in the cells of the brain, the adrenals, and the liver,
and that these are identical, whatever be the cause that leads to the
exhaustion of the energy-transforming mechanism. These changes vary in
degree, and range from slight alterations in the structure of the
protoplasm to complete disorganisation of the cell elements.

The influences which contribute to bring about this form of exhaustion
that we call shock are varied, and include such emotional states as
fear, anxiety, or worry, physical injury and toxic infection, and the
effects of these factors are augmented by anything that tends to lower
the vitality, such as loss of blood, exposure, insufficient food, loss
of sleep or antecedent illness.

Any one or any combination of these influences may cause shock, but the
most potent, and the one which most concerns the surgeon, is physical
injury, _e.g._, a severe accident or an operation (_traumatic shock_).
This is usually associated with some emotional disturbance, such as fear
or anxiety (_emotional shock_), or with haemorrhage; and may be followed
by septic infection (_toxic shock_).

The exaggerated afferent impulses reaching the brain as a result of
trauma, inhibit the action of the nuclei in the region of the fourth
ventricle and cerebellum which maintain the muscular tone, with the
result that the muscular tone is diminished and there is a marked fall
in the arterial blood pressure. The capillaries dilate--the blood
stagnating in them and giving off its oxygen and transuding its fluid
elements into the tissues--with the result that an insufficient quantity
of oxygenated blood reaches the heart to enable it to maintain an
efficient circulation. As the sarco-lactic acid liberated in the muscles
is not oxygenated a condition of acidosis ensues.

The more highly the injured part is endowed with sensory nerves the more
marked is the shock; a crush of the hand, for example, is attended with
a more intense degree of shock than a correspondingly severe crush of
the foot; and injuries of such specially innervated parts as the testis,
the urethra, the face, or the spinal cord, are associated with severe
degrees, as are also those of parts innervated from the sympathetic
system, such as the abdominal or thoracic viscera. It is to be borne in
mind that a state of general anaesthesia does not prevent injurious
impulses reaching the brain and causing shock during an operation. If
the main nerves of the part are "blocked" by injection of a local
anaesthetic, however, the central nervous system is protected from these
impulses.

While the aged frequently manifest but few signs of shock, they have a
correspondingly feeble power of recovery; and while many young children
suffer little, even after severe operations, others with much less cause
succumb to shock.

When the injured person's mind is absorbed with other matters than his
own condition,--as, for example, during the heat of a battle or in the
excitement of a railway accident or a conflagration,--even severe
injuries may be unattended by pain or shock at the time, although when
the period of excitement is over, the severity of the shock is all the
greater. The same thing is observed in persons injured while under the
influence of alcohol.

_Clinical Features._--The patient is in a state of prostration. He is
roused from his condition of indifference with difficulty, but answers
questions intelligently, if only in a whisper. The face is pale, beads
of sweat stand out on the brow, the features are drawn, the eyes
sunken, and the cheeks hollow. The lips and ears are pallid; the skin of
the body of a greyish colour, cold, and clammy. The pulse is rapid,
fluttering, and often all but imperceptible at the wrist; the
respiration is irregular, shallow, and sighing; and the temperature may
fall to 96 o F. or even lower. The mouth is parched, and the patient
complains of thirst. There is little sensibility to pain.

Except in very severe cases, shock tends towards recovery within a few
hours, the _reaction_, as it is called, being often ushered in by
vomiting. The colour improves; the pulse becomes full and bounding; the
respiration deeper and more regular; the temperature rises to 100 o F. or
higher; and the patient begins to take notice of his surroundings. The
condition of neurasthenia which sometimes follows an operation may be
associated with the degenerative changes in nerve cells described by
Crile.

In certain cases the symptoms of traumatic shock blend with those
resulting from toxin absorption, and it is difficult to estimate the
relative importance of the two factors in the causation of the
condition. The conditions formerly known as "delayed shock" and
"prostration with excitement" are now generally recognised to be due to
toxaemia.

_Question of Operating during Shock._--Most authorities agree that
operations should only be undertaken during profound shock when they are
imperatively demanded for the arrest of haemorrhage, the prevention of
infection of serous cavities, or for the relief of pain which is
producing or intensifying the condition.

_Prevention of Operation Shock._--In the preparation of a patient for
operation, drastic purgation and prolonged fasting must be avoided, and
about half an hour before a severe operation a pint of saline solution
should be slowly introduced into the rectum; this is repeated, if
necessary, during the operation, and at its conclusion. The
operating-room must be warm--not less than 70 o F.--and the patient
should be wrapped in cotton wool and blankets, and surrounded by
hot-bottles. All lotions used must be warm (100 o F.); and the operation
should be completed as speedily and as bloodlessly as possible. The
element of fear may to some extent be eliminated by the preliminary
administration of such drugs as scopolamin or morphin, and with a view
to preventing the passage of exciting afferent impulses, Crile advocates
"blocking" of the nerves by the injection of a 1 per cent. solution of
novocaine into their substance on the proximal side of the field of
operation. To prevent after-pain in abdominal wounds he recommends
injecting the edges with quinine and urea hydrochlorate before suturing,
the resulting anaesthesia lasting for twenty-four to forty-eight hours.
To these preventive measures the term _anoci-association_ has been
applied. In selecting an anaesthetic, it may be borne in mind that
chloroform lowers the blood pressure more than ether does, and that with
spinal anaesthesia there is no lowering of the blood pressure.

_Treatment._--A patient suffering from shock should be placed in the
recumbent position, with the foot of the bed raised to facilitate the
return circulation in the large veins, and so to increase the flow of
blood to the brain. His bed should be placed near a large fire, and the
patient himself surrounded by cotton wool and blankets and hot-bottles.
If he has lost much blood, the limbs should be wrapped in cotton wool
and firmly bandaged from below upwards, to conserve as much of the
circulating blood as possible in the trunk and head. If the shock is
moderate in degree, as soon as the patient has been put to bed, about a
pint of saline solution should be introduced into the rectum, and 10 to
15 minims of adrenalin chloride (1 in 1000) may with advantage be added
to the fluid. The injection should be repeated every two hours until the
circulation is sufficiently restored. In severe cases, especially when
associated with haemorrhage, transfusion of whole blood from a compatible
donor, is the most efficient means (_Op. Surg._, p. 37). Cardiac
stimulants such as strychnin, digitalin, or strophanthin are
contra-indicated in shock, as they merely exhaust the already impaired
vaso-motor centre.

Artificial respiration may be useful in tiding a patient over the
critical period of shock, especially at the end of a severe operation.

Failing this, the introduction of saline solution at a temperature of
about 105 o F. into a vein or into the subcutaneous tissue is useful
where much blood has been lost (p. 276). Two or three pints may be
injected into a vein, or smaller quantities under the skin.

Thirst is best met by giving small quantities of warm water by the
mouth, or by the introduction of saline solution into the rectum. Ice
only relieves thirst for a short time, and as it is liable to induce
flatulence should be avoided, especially in abdominal cases. Dryness of
the tongue may be relieved by swabbing the mouth with a mixture of
glycerine and lemon juice.

If severe pain calls for the use of morphin, 1/120th grain of atropin
should be added, or heroin alone may be given in doses of 1/24th to
1/12th grain.

#Collapse# is a clinical condition which comes on more insidiously than
shock, and which does not attain its maximum degree of severity for
several hours. It is met with in the course of severe illnesses,
especially such as are associated with the loss of large quantities of
fluid from the body--for example, by severe diarrhoea, notably in Asiatic
cholera; by persistent vomiting; or by profuse sweating, as in some
cases of heat-stroke. Severe degrees of collapse follow sudden and
profuse loss of blood.

Collapse often follows upon shock--for example, in intestinal
perforations, or after abdominal operations complicated by peritonitis,
especially if there is vomiting, as in cases of obstruction high up in
the intestine. The symptoms of collapse are aggravated if toxin
absorption is superadded to the loss of fluid.

The _clinical features_ of this condition are practically the same as
those of shock; and it is treated on the same lines.

FAT EMBOLISM.--After various injuries and operations, but
especially such as implicate the marrow of long bones--for example,
comminuted fractures, osteotomies, resections of joints, or the forcible
correction of deformities--fluid fat may enter the circulation in
variable quantity. In the vast majority of cases no ill effects follow,
but when the quantity is large or when the absorption is long continued
certain symptoms ensue, either immediately, or more frequently not for
two or three days. These are mostly referable to the lungs and brain.

In the lung the fat collects in the minute blood vessels and produces
venous congestion and oedema, and sometimes pneumonia. Dyspnoea, with
cyanosis, a persistent cough and frothy or blood-stained sputum, a
feeble pulse and low temperature, are the chief symptoms.

When the fat lodges in the capillaries of the brain, the pulse becomes
small, rapid, and irregular, delirium followed by coma ensues, and the
condition is usually rapidly fatal.

Fat is usually to be detected in the urine, even in mild cases.

The _treatment_ consists in tiding the patient over the acute stage of
his illness, until the fat is eliminated from the blood vessels.

TRAUMATIC ASPHYXIA OR TRAUMATIC CYANOSIS.--This term has been
applied to a condition which results when the thorax is so forcibly
compressed that respiration is mechanically arrested for several
minutes. It has occurred from being crushed in a struggling crowd, or
under a fall of masonry, and in machinery accidents. When the patient is
released, the face and the neck as low down as the level of the
clavicles present an intense coloration, varying from deep purple to
blue-black. The affected area is sharply defined, and on close
inspection the appearance is found to be due to the presence of
countless minute reddish-blue or black spots, with small areas or
streaks of normal skin between them. The punctate nature of the
coloration is best recognised towards the periphery of the affected
area--at the junction of the brow with the hairy scalp, and where the
dark patch meets the normal skin of the chest (Beach and Cobb). Pressure
over the skin does not cause the colour to disappear as in ordinary
cyanosis. It has been shown by Wright of Boston, that the coloration is
due to stasis from mechanical over-distension of the veins and
capillaries; actual extravasation into the tissues is exceptional. The
sharply defined distribution of the coloration is attributed to the
absence of functionating valves in the veins of the head and neck, so
that when the increased intra-thoracic pressure is transmitted to these
veins they become engorged. Under the conjunctivae there are
extravasations of bright red blood; and sublingual haematoma has been
observed (Beatson).

The discoloration begins to fade within a few hours, and after the
second or third day it disappears, without showing any of the chromatic
changes which characterise a bruise. The sub-conjunctival ecchymosis,
however, persists for several weeks and disappears like other
extravasations. Apart from combating the shock, or dealing with
concomitant injuries, no treatment is called for.


DELIRIUM IN SURGICAL PATIENTS

Delirium is a temporary disturbance of mind which occurs in the course
of certain diseases, and sometimes after injuries or operations. It may
be associated with any of the acute pyogenic infections; with
erysipelas, especially when it affects the head or face; or with chronic
infective diseases of the urinary organs. In the various forms of
meningitis also, and in some cases of injury to the head, it is common;
and it is sometimes met with after severe haemorrhage, and in cases of
poisoning by such drugs as iodoform, cocain, or alcohol. Delirium may
also, of course, be a symptom of insanity.

Often there is merely incoherent muttering regarding past incidents or
occupations, or about absent friends; or the condition may assume the
form of excitement, of dementia, or of melancholia; and the symptoms are
usually worst at night.

#Delirium Tremens# is seen in persons addicted to alcohol, who, as the
result of accident or operation, are suddenly compelled to lie in bed.
Although oftenest met with in habitual drunkards or chronic tipplers, it
is by no means uncommon in moderate drinkers, and has even been seen in
children.

_Clinical Features._--The delirium, which has been aptly described as
being of a "busy" character, usually manifests itself within a few days
of the patient being laid up. For two or three days he refuses food, is
depressed, suspicious, sleepless and restless, demanding to be allowed
up. Then he begins to mutter incoherently, to pull off the bedclothes,
and to attempt to get out of bed. There is general muscular tremor, most
marked in the tongue, the lips, and the hands. The patient imagines that
he sees all sorts of horrible beings around him, and is sometimes
greatly distressed because of rats, mice, beetles, or snakes, which he
fancies are crawling over him. The pulse is soft, rapid, and
compressible; the temperature is only moderately raised (100 o-101 o F.),
and as a rule there is profuse sweating. The digestion is markedly
impaired, and there is often vomiting. Patients in this condition are
peculiarly insensitive to pain, and may even walk about with a fractured
leg without apparent discomfort.

In most cases the symptoms begin to pass off in three or four days; the
patient sleeps, the hallucinations and tremors cease, and he gradually
recovers. In other cases the temperature rises, the pulse becomes rapid,
and death results from exhaustion.

The main indication in _treatment_ is to secure sleep, and this is done
by the administration of bromides, chloral, or paraldehyde, or of one or
other of the drugs of which sulphonal, trional, and veronal are
examples. Heroin in doses of from 1/24th to 1/12th grain is often of
service. Morphin must be used with great caution. In some cases hyoscin
(1/200 grain) injected hypodermically is found efficacious when all
other means have failed, but this drug must be used with great
discrimination. The patient must be encouraged to take plenty of easily
digested fluid food, supplemented, if necessary, by nutrient enemata and
saline infusions.

In the early stage a brisk mercurial purge is often of value. Alcohol
should be withheld, unless failing of the pulse strongly indicates its
use, and then it should be given along with the food.

A delirious patient must be constantly watched by a trained attendant or
other competent person, lest he get out of bed and do harm to himself or
others. Mechanical restraint is often necessary, but must be avoided if
possible, as it is apt to increase the excitement and exhaust the
patient. On account of the extreme restlessness, there is often great
difficulty in carrying out the proper treatment of the primary surgical
condition, and considerable modifications in splints and other
appliances are often rendered necessary.

A form of delirium, sometimes spoken of as #Traumatic Delirium#, may
follow on severe injuries or operations in persons of neurotic
temperament, or in those whose nervous system is exhausted by overwork.
It is met with apart from alcoholic intemperance. This form of delirium
seems to be specially prone to ensue on operations on the face, the
thyreoid gland, or the genito-urinary organs. The symptoms appear in
from two to five days after the operation, and take the form of
restlessness, sleeplessness, low incoherent muttering, and picking at
the bedclothes. It is not necessarily attended by fever or by muscular
tremors. The patient may show hysterical symptoms. This condition is
probably to be regarded as a form of insanity, as it is liable to merge
into mania or melancholia.

The _treatment_ is carried out on the same lines as that of delirium
tremens.




CHAPTER XIV

THE BLOOD VESSELS


Anatomy--INJURIES OF ARTERIES: _Varieties_--INJURIES OF
    VEINS: _Air Embolism_--Repair of blood vessels and natural
    arrest of haemorrhage--HAEMORRHAGE: _Varieties_;
    _Prevention_; _Arrest_--Constitutional effects of
    haemorrhage--Haemophilia--DISEASES OF BLOOD VESSELS:
    Thrombosis; Embolism--Arteritis: _Varieties_;
    Arterio-sclerosis--Thrombo-phlebitis--Phlebitis:
    _Varieties_--VARIX--ANGIOMATA--Naevus: _Varieties_;
    _Electrolysis_--Cirsoid aneurysm--ANEURYSM: _Varieties_;
    _Methods of treatment_--ANEURYSMS OF INDIVIDUAL ARTERIES.

#Surgical Anatomy.#--An _artery_ has three coats: an internal coat--the
_tunica intima_--made up of a single layer of endothelial cells lining
the lumen; outside of this a layer of delicate connective tissue; and
still farther out a dense tissue composed of longitudinally arranged
elastic fibres--the internal elastic lamina. The tunica intima is easily
ruptured. The middle coat, or _tunica media_, consists of non-striped
muscular fibres, arranged for the most part concentrically round the
vessel. In this coat also there is a considerable proportion of elastic
tissue, especially in the larger vessels. The thickness of the vessel
wall depends chiefly on the development of the muscular coat. The
external coat, or _tunica externa_, is composed of fibrous tissue,
containing, especially in vessels of medium calibre, some yellow elastic
fibres in its deeper layers.

In most parts of the body the arteries lie in a sheath of connective
tissue, from which fine fibrous processes pass to the tunica externa.
The connection, however, is not a close one, and the artery when divided
transversely is capable of retracting for a considerable distance within
its sheath. In some of the larger arteries the sheath assumes the form
of a definite membrane.

The arteries are nourished by small vessels--the _vasa vasorum_--which
ramify chiefly in the outer coat. They are also well supplied with
nerves, which regulate the size of the lumen by inducing contraction or
relaxation of the muscular coat.

The _veins_ are constructed on the same general plan as the arteries,
the individual coats, however, being thinner. The inner coat is less
easily ruptured, and the middle coat contains a smaller proportion of
muscular tissue. In one important point veins differ structurally from
arteries--namely, in being provided with valves which prevent reflux of
the blood. These valves are composed of semilunar folds of the tunica
intima strengthened by an addition of connective tissue. Each valve
usually consists of two semilunar flaps attached to opposite sides of
the vessel wall, each flap having a small sinus on its cardiac side.
The distension of these sinuses with blood closes the valve and
prevents regurgitation. Valves are absent from the superior and inferior
venae cavae, the portal vein and its tributaries, the hepatic, renal,
uterine, and spermatic veins, and from the veins in the lower part of
the rectum. They are ill-developed or absent also in the iliac and
common femoral veins--a fact which has an important bearing on the
production of varix in the veins of the lower extremity.

The wall of _capillaries_ consists of a single layer of endothelial
cells.


HAEMORRHAGE

Various terms are employed in relation to haemorrhage, according to its
seat, its origin, the time at which it occurs, and other circumstances.

The term _external haemorrhage_ is employed when the blood escapes on the
surface; when the bleeding takes place into the tissues or into a cavity
it is spoken of as _internal_. The blood may infiltrate the connective
tissue, constituting an _extravasation_ of blood; or it may collect in a
space or cavity and form a _haematoma_.

The coughing up of blood from the lungs is known as _haemoptysis_;
vomiting of blood from the stomach, as _haematemesis_; the passage of
black-coloured stools due to the presence of blood altered by digestion,
as _melaena_; and the passage of bloody urine, as _haematuria_.

Haemorrhage is known as arterial, venous, or capillary, according to the
nature of the vessel from which it takes place.

In _arterial_ haemorrhage the blood is bright red in colour, and escapes
from the cardiac end of the divided vessel in pulsating jets
synchronously with the systole of the heart. In vascular parts--for
example the face--both ends of a divided artery bleed freely. The blood
flowing from an artery may be dark in colour if the respiration is
impeded. When the heart's action is weak and the blood tension low the
flow may appear to be continuous and not in jets. The blood from a
divided artery at the bottom of a deep wound, escapes on the surface in
a steady flow.

_Venous_ bleeding is not pulsatile, but occurs in a continuous stream,
which, although both ends of the vessel may bleed, is more copious from
the distal end. The blood is dark red under ordinary conditions, but may
be purplish, or even black, if the respiration is interfered with. When
one of the large veins in the neck is wounded, the effects of
respiration produce a rise and fall in the stream which may resemble
arterial pulsation.

In _capillary_ haemorrhage, red blood escapes from numerous points on the
surface of the wound in a steady ooze. This form of bleeding is serious
in those who are the subjects of haemophilia.


INJURIES OF ARTERIES

The following description of the injuries of arteries refers to the
larger, named trunks. The injuries of smaller, unnamed vessels are
included in the consideration of wounds and contusions.

#Contusion.#--An artery may be contused by a blow or crush, or by the
oblique impact of a bullet. The bruising of the vessel wall, especially
if it is diseased, may result in the formation of a thrombus which
occludes the lumen temporarily or even permanently, and in rare cases
may lead to gangrene of the limb beyond.

#Subcutaneous Rupture.#--An artery may be ruptured subcutaneously by a
blow or crush, or by a displaced fragment of bone. This injury has been
produced also during attempts to reduce dislocations, especially those
of old standing at the shoulder. It is most liable to occur when the
vessels are diseased. The rupture may be incomplete or complete.

_Incomplete Subcutaneous Rupture._--In the majority of cases the rupture
is incomplete--the inner and middle coats being torn, while the outer
remains intact. The middle coat contracts and retracts, and the
internal, because of its elasticity, curls up in the interior of the
vessel, forming a valvular obstruction to the blood-flow. In most cases
this results in the formation of a thrombus which occludes the vessel.
In some cases the blood-pressure gradually distends the injured segment
of the vessel wall and leads to the formation of an aneurysm.

The pulsation in the vessels beyond the seat of rupture is arrested--for
a time at least--owing to the occlusion of the vessel, and the limb
becomes cold and powerless. The pulsation seldom returns within five or
six weeks of the injury, if indeed it is not permanently arrested, but,
as a rule, a collateral circulation is rapidly established, sufficient
to nourish the parts beyond. If the pulsation returns within a week of
the injury, the presumption is that the occlusion was due to pressure
from without--for example, by haemorrhage into the sheath or the pressure
of a fragment of bone.

_Complete Subcutaneous Rupture._--When the rupture is complete, all the
coats of the vessel are torn and the blood escapes into the surrounding
tissues. If the original injury is attended with much shock, the
bleeding may not take place until the period of reaction. Rupture of the
popliteal artery in association with fracture of the femur, or of the
axillary or brachial artery with fracture of the humerus or dislocation
of the shoulder, are familiar examples of this injury.

Like incomplete rupture, this lesion is accompanied by loss of pulsation
and power, and by coldness of the limb beyond; a tense and excessively
painful swelling rapidly appears in the region of the injury, and, where
the cellular tissue is loose, may attain a considerable size. The
pressure of the effused blood occludes the veins and leads to congestion
and oedema of the limb beyond. The interference with the circulation, and
the damage to the tissues, may be so great that gangrene ensues.

_Treatment._--When an artery has been contused or ruptured, the limb
must be placed in the most favourable condition for restoration of the
circulation. The skin is disinfected and the limb wrapped in cotton wool
to conserve its heat, and elevated to such an extent as to promote the
venous return without at the same time interfering with the inflow of
blood. A careful watch must be kept on the state of nutrition of the
limb, lest gangrene occurs.

If no complications supervene, the swelling subsides, and recovery may
be complete in six or eight weeks. If the extravasation is great and the
skin threatens to give way, or if the vitality of the limb is seriously
endangered, it is advisable to expose the injured vessel, and, after
clearing away the clots, to attempt to suture the rent in the artery,
or, if torn across, to join the ends after paring the bruised edges. If
this is impracticable, a ligature is applied above and below the
rupture. If gangrene ensues, amputation must be performed.

These descriptions apply to the larger arteries of the extremities. A
good illustration of subcutaneous rupture of the arteries of the head is
afforded by the tearing of the middle meningeal artery caused by the
application of blunt violence to the skull; and of the arteries of the
trunk--caused by the tearing of the renal artery in rupture of the
kidney.

#Open Wounds of Arteries--Laceration.#--Laceration of large arteries is
a common complication of machinery and railway accidents. The violence
being usually of a tearing, twisting, or crushing nature, such injuries
are seldom associated with much haemorrhage, as torn or crushed vessels
quickly become occluded by contraction and retraction of their coats and
by the formation of a clot. A whole limb even may be avulsed from the
body with comparatively little loss of blood. The risk in such cases is
secondary haemorrhage resulting from pyogenic infection.

The _treatment_ is that applicable to all wounds, with, in addition, the
ligation of the lacerated vessels.

#Punctured wounds# of blood vessels may result from stabs, or they may
be accidentally inflicted in the course of an operation.

The division of the coats of the vessel being incomplete, the natural
haemostasis that results from curling up of the intima and contraction of
the media, fails to take place, and bleeding goes on into the
surrounding tissues, and externally. If the sheath of the vessel is not
widely damaged, the gradually increasing tension of the extravasated
blood retained within it may ultimately arrest the haemorrhage. A clot
then forms between the lips of the wound in the vessel wall and projects
for a short distance into the lumen, without, however, materially
interfering with the flow through the vessel. The organisation of this
clot results in the healing of the wound in the vessel wall.

In other cases the blood escapes beyond the sheath and collects in the
surrounding tissues, and a traumatic aneurysm results. Secondary
haemorrhage may occur if the wound becomes infected.

The _treatment_ consists in enlarging the external wound to permit of
the damaged vessel being ligated above and below the puncture. In some
cases it may be possible to suture the opening in the vessel wall. When
circumstances prevent these measures being taken, the bleeding may be
arrested by making firm pressure over the wound with a pad; but this
procedure is liable to be followed by the formation of an aneurysm.

_Minute puncture of arteries_ such as frequently occur in the hypodermic
administration of drugs and in the use of exploring needles, are not
attended with any escape of blood, chiefly because of the elastic recoil
of the arterial wall; a tiny thrombus of platelets and thrombus forms at
the point where the intima is punctured.

#Incised Wounds.#--We here refer only to such incised wounds as partly
divide the vessel wall.

Longitudinal wounds show little tendency to gape, and are therefore not
attended with much bleeding. They usually heal rapidly, but, like
punctured wounds, are liable to be followed by the formation of an
aneurysm.

When, however, the incision in the vessel wall is oblique or transverse,
the retraction of the muscular coat causes the opening to gape, with the
result that there is haemorrhage, which, even in comparatively small
arteries, may be so profuse as to prove dangerous. When the associated
wound in the soft parts is valvular the haemorrhage is arrested and an
aneurysm may develop.

When a large arterial trunk, such as the external iliac, the femoral,
the common carotid, the brachial, or the popliteal, has been partly
divided, for example, in the course of an operation, the opening should
be closed with sutures--_arteriorrhaphy_. The circulation being
controlled by a tourniquet, or the artery itself occluded by a clamp,
fine silk or catgut stitches are passed through the outer and middle
coats after the method of Lembert, a fine, round needle being employed.
The sheath of the vessel or an adjacent fascia should be stitched
over the line of suture in the vessel wall. If infection be excluded,
there is little risk of thrombosis or secondary haemorrhage; and even if
thrombosis should develop at the point of suture, the artery is
obstructed gradually, and the establishment of a collateral circulation
takes place better than after ligation. In the case of smaller trunks,
or when suture is impracticable, the artery should be tied above and
below the opening, and divided between the ligatures.

#Gunshot Wounds of Blood Vessels.#--In the majority of cases injuries of
large vessels are associated with an external wound; the profusion of
the bleeding indicates the size of the damaged vessel, and the colour of
the blood and the nature of the flow denote whether an artery or a vein
is implicated.

When an artery is wounded a firm _haematoma_ may form, with an expansile
pulsation and a palpable thrill--whether such a haematoma remains
circumscribed or becomes diffuse depends upon the density or laxity of
the tissues around it. In course of time a _traumatic arterial aneurysm_
may develop from such a haematoma.

When an artery and its companion vein are injured simultaneously an
_arterio-venous aneurysm_ (p. 310) may develop. This frequently takes
place without the formation of a haematoma as the arterial blood finds
its way into the vein and so does not escape into the tissues. Even if a
haematoma forms it seldom assumes a great size. In time a swelling is
recognised, with a palpable thrill and a systolic bruit, loudest at the
level of the communication and accompanied by a continuous venous hum.

If leakage occurs into the tissues, the extravasated blood may occlude
the vein by pressure, and the symptoms of arterial aneurysm replace
those of the arterio-venous form, the systolic bruit persisting, while
the venous hum disappears.

_Gangrene_ may ensue if the blood supply is seriously interfered with,
or the signs of _ischaemia_ may develop; the muscles lose their
elasticity, become hard and paralysed, and anaesthesia of the "glove" or
"stocking" type, with other alterations of sensation ensue. Apart from
ischaemia, _reflex paralysis_ of motion and sensation of a transient kind
may follow injury of a large vessel.

_Treatment_ is carried out on the same lines as for similar injuries due
to other causes.


INJURIES OF VEINS

Veins are subject to the same forms of injury as arteries, and the
results are alike in both, such variations as occur being dependent
partly on the difference in their anatomical structure, and partly on
the conditions of the circulation through them.

#Subcutaneous rupture# of veins occur most frequently in association
with fractures and in the reduction of dislocations. The veins most
commonly ruptured are the popliteal, the axillary, the femoral, and the
subclavian. On account of the smaller amount of elastic and muscular
tissue in the wall of a vein, the contraction and retraction of its
walls are less than in an artery, and so bleeding may continue for a
longer period. On the other hand, owing to the lower blood-pressure the
outflow goes on more slowly, and the gradually increasing pressure
produced by the extravasated blood is usually sufficient to arrest the
haemorrhage before it becomes serious. As an aid in diagnosing the source
of the bleeding, it should be remembered that the rupture of a vein does
not affect the pulsation in the limb beyond. The risks are practically
the same as when an artery is ruptured, excepting that of aneurysm, and
the treatment is carried out on the same lines, but it is seldom
necessary to operate for the purpose of applying a ligature to the
injured vein.

#Wounds# of veins--punctured and incised--frequently occur in the course
of operations; for example, in the removal of tumours or diseased glands
from the neck, the axilla, or the groin. They are also met with as a
result of accidental stabs and of suicidal or homicidal injuries. The
haemorrhage from a large vein so damaged is usually profuse, but it is
more readily controlled by external pressure than that from an artery.
When a vein is merely punctured, the bleeding may be arrested by
pressure with a pad of gauze, or by a lateral ligature--that is, picking
up the margins of the rent in the wall and securing them with a
ligature without occluding the lumen. In the large veins, such as the
internal jugular, the femoral, or the axillary, it is usually possible
to suture the opening in the wall. This does not necessarily result in
thrombosis in the vessel, or in obliteration of its lumen.

When an _artery and vein are simultaneously wounded_, the features
peculiar to each are present in greater or less degree. In the limbs
gangrene may ensue, especially if the wound is infected. Punctured and
gun-shot wounds implicating both artery and vein are liable to be
followed by the development of arterio-venous aneurysm.

#Entrance of Air into Veins--Air Embolism.#--This serious, though
fortunately rare, accident is apt to occur in the course of operations
in the region of the thorax, neck, or axilla, if a large vein is opened
and fails to collapse on account of the rigidity of its walls, its
incorporation in a dense fascia, or from traction being made upon it. If
the wound in a vein is thus held open, the negative pressure during
inspiration sucks air into the right side of the heart. This is
accompanied by a hissing or gurgling sound, and with the next expiration
some frothy blood escapes from the wound. The patient instantly becomes
pale, the pupils dilate, respiration becomes laboured, and although the
heart may continue to beat forcibly, the peripheral pulse is weak, and
may even be imperceptible. On auscultating the heart, a churning sound
may be heard. Death may result in a few minutes; or the heart may slowly
regain its power and recovery take place.

_Prevention._--In operations in the "dangerous area"--as the region of
the root of the neck is called in this connection--care must be taken
not to cut or divide any vein before it has been secured by forceps, and
to apply ligatures securely and at once. Deep wounds in this region
should be kept filled with normal salt solution. Immediately a cut is
recognised in a vein, a finger should be placed over the vessel on the
cardiac side of the wound, and kept there until the opening is secured.

_Treatment._--Little can be done after the air has actually entered the
vein beyond endeavouring to maintain the heart's action by hypodermic
injections of ether or strychnin and the application of mustard or hot
cloths over the chest. The head at the same time should be lowered to
prevent syncope. Attempts to withdraw the air by suction, and the
employment of artificial respiration, have proved futile, and are, by
some, considered dangerous. In a desperate case massage of the heart
might be tried.


THE NATURAL ARREST OF HAEMORRHAGE AND THE REPAIR OF BLOOD
VESSELS

#Primary Haemorrhage.#--The term primary haemorrhage is applied to the
bleeding which follows immediately on the wounding of a blood vessel.
The natural process by which such haemorrhage is arrested varies with the
character of the wound in the vessel and may be modified by accidental
circumstances.

(a) _Repair of completely divided Artery._--When an artery is
_completely_ divided, the circular fibres of the muscular coat contract,
so that the lumen of the cut ends is diminished, and at the same time
each segment retracts within its sheath in virtue of the recoil of the
elastic elements in its walls, the tunica intima curls up in the
interior of the vessel, and the tunica externa collapses over the cut
ends. The blood that escapes from the injured vessel fills the
interstices of the tissues, and, coagulating, forms a clot which
temporarily arrests the bleeding. That part of the clot which lies
between the divided ends of the vessel and in the cellular tissue
outside, is known as the _external clot_, while the portion which
projects into the lumen of the vessel is known as the _internal clot_,
and it usually extends as far as the nearest collateral branch. These
processes constitute what is known as the _temporary arrest of
haemorrhage_, which, it will be observed, is effected by the contraction
and retraction of the divided artery and by clotting.

The _permanent arrest_ takes place by the transformation of the clot
into scar tissue. The internal clot plays the most important part in the
process; it becomes invaded by leucocytes and proliferating endothelial
and connective-tissue cells, and new blood vessels permeate the mass,
which is thus converted into granulation tissue. This is ultimately
replaced by fibrous tissue, which permanently occludes the end of the
vessel. Concurrently and by the same process the external clot is
converted into scar tissue.

If a divided artery is _ligated at its cut end_, the tension of the
ligature is usually sufficient to rupture the inner and middle coats,
which curl up within the lumen, the outer coat alone being held in the
grasp of the ligature. An internal clot forms and, becoming organised,
permanently occludes the vessel as above described. The ligature and the
small portion of vessel beyond it are subsequently absorbed.

In course of time the collateral branches of the vessel above and below
the level of section enlarge and their inter-communication becomes more
free, so that even when large trunks have been divided the vascular
supply of the parts beyond may be completely restored. This is known as
the development of the _collateral circulation_.

_Imperfect Collateral Circulation._--While the development of the
collateral circulation after the ligation or obstruction from other
cause of a main arterial trunk may be sufficient to prevent gangrene of
the limb, it may be insufficient for its adequate nourishment; it may be
cold, bluish in colour, and there may be necrosis of the skin over bony
points; this is notably the case in the lower extremity after ligation
of the femoral or popliteal artery, when patches of skin may die over
the prominence of the heel, the balls of the toes, the projecting base
of the fifth metatarsal and the external malleolus.

If, during the period of reaction, the blood-pressure rises

considerably, the occluding clot at the divided end of the vessel may be
washed away or the ligature displaced, permitting of fresh bleeding
taking place--_reactionary_ or _intermediary haemorrhage_ (p. 272).

In the event of the wound becoming infected with pyogenic organisms, the
occluding blood-clot or the young fibrous tissue may become
disintegrated in the suppurative process, and the bleeding start
afresh--_secondary haemorrhage_ (p. 273).

(b) If an artery is only _partly cut across_, the divided fibres of
the tunica muscularis contract and those of the tunica externa retract,
with the result that a more or less circular hole is formed in the wall
of the vessel, from which free bleeding takes place, as the conditions
are unfavourable for the formation of an occluding clot. Even if a clot
does form, when the blood-pressure rises it is readily displaced,
leading to reactionary haemorrhage. Should the wound become infected,
secondary haemorrhage is specially liable to occur. A further risk
attends this form of injury, in that the intra-vascular tension may in
time lead to gradual stretching of the scar tissue which closes the gap
in the vessel wall, with the result that a localised dilatation or
diverticulum forms, constituting a _traumatic aneurysm_.

(c) When the injury merely takes the form of a _puncture_ or _small
incision_ a blood-clot forms between the edges, becomes organised, and
is converted into cicatricial tissue which seals the aperture. Such
wounds may also be followed by reactionary or secondary haemorrhage, or
later by the formation of a traumatic aneurysm.

_Conditions which influence the Natural Arrest of Haemorrhage._--The
natural arrest of bleeding is favoured by tearing or crushing of the
vessel walls, owing to the contraction and retraction of the coats and
the tendency of blood to coagulate when in contact with damaged tissue.
Hence the primary haemorrhage following lacerated wounds is seldom
copious. The occurrence of syncope or of profound shock also helps to
stop bleeding by reducing the force of the heart's action.

On the other hand, there are conditions which retard the natural arrest.
When, for example, a vessel is only partly divided, the contraction and
retraction of the muscular coat, instead of diminishing the calibre of
the artery, causes the wound in the vessel to gape; by completing the
division of the vessel under these circumstances the bleeding can often
be arrested. In certain situations, also, the arteries are so intimately
connected with their sheaths, that when cut across they were unable to
retract and contract--for example, in the scalp, in the penis, and in
bones--and copious bleeding may take place from comparatively small
vessels. This inability of the vessels to contract and retract is met
with also in inflamed and oedematous parts and in scar tissue. Arteries
divided in the substance of a muscle also sometimes bleed unduly. Any
increase in the force of the heart's action, such as may result from
exertion, excitement, or over-stimulation, also interferes with the
natural arrest. Lastly, in bleeders, there are conditions which
interfere with the natural arrest of haemorrhage.

#Repair of a Vessel ligated in its Continuity.#--When a ligature is
applied to an artery it should be pulled sufficiently tight to occlude
the lumen without causing rupture of its coats. It often happens,
however, that the compression causes rupture of the inner and middle
coats, so that only the outer coat remains in the grasp of the ligature.
While this weakens the wall of the vessel, it has the advantage of
hastening coagulation, by bringing the blood into contact with damaged
tissue. Whether the inner and middle coats are ruptured or not, blood
coagulates both above and below the ligature, the proximal clot being
longer and broader than that on the distal side. In small arteries these
clots extend as far as the nearest collateral branch, but in the larger
trunks their length varies. The permanent occlusion of those portions of
the vessel occupied by clot is brought about by the formation of
granulation tissue, and its replacement by cicatricial tissue, so that
the occluded segment of the vessel is represented by a fibrous cord. In
this process the coagulum only plays a passive role by forming a
scaffolding on which the granulation tissue is built up. The ligature
surrounding the vessel, and the elements of the clot, are ultimately
absorbed.

#Repair of Veins.#--The process of repair in veins is the same as that
in arteries, but the thrombosed area may become canalised and the
circulation through the vessel be re-established.


HAEMORRHAGE IN SURGICAL OPERATIONS

The management of the haemorrhage which accompanies an operation includes
(a) preventive measures, and (b) the arrest of the bleeding.

#Prevention of Haemorrhage.#--Whenever possible, haemorrhage should be
controlled by _digital compression_ of the main artery supplying the
limb rather than by a tourniquet. If efficiently applied compression
reduces the immediate loss of blood to a minimum, and the bleeding from
small vessels that follows the removal of the tourniquet is avoided.
Further, the pressure of a tourniquet has been shown to be a material
factor in producing shock.

In selecting a point at which to apply digital compression, it is
essential that the vessel should be lying over a bone which will furnish
the necessary resistance. The common carotid, for example, is pressed
backward and medially against the transverse process (carotid tubercle)
of the sixth cervical vertebra; the temporal against the temporal
process (zygoma) in front of the ear; and the facial against the
mandible at the anterior edge of the masseter.

In the upper extremity, the subclavian is pressed against the first rib
by making pressure downwards and backwards in the hollow above the
clavicle; the axillary and brachial by pressing against the shaft of the
humerus.

In the lower extremity, the femoral is controlled by pressing in a
direction backward and slightly upward against the brim of the pelvis,
midway between the symphysis pubis and the anterior superior iliac
spine.

The abdominal aorta may be compressed against the bodies of the lumbar
vertebrae opposite the umbilicus, if the spine is arched well forwards
over a pillow or sand-bag, or by the method suggested by Macewen, in
which the patient's spine is arched forwards by allowing the lower
extremities and pelvis to hang over the end of the table, while the
assistant, standing on a stool, applies his closed fist over the
abdominal aorta and compresses it against the vertebral column.
Momburg recommends an elastic cord wound round the body between the
iliac crest and the lower border of the ribs, but this procedure has
caused serious damage to the intestine.

When digital compression is not available, the most convenient and
certain means of preventing haemorrhage--say in an amputation--is by the
use of some form of _tourniquet_, such as the elastic tube of Esmarch or
of Foulis, or an elastic bandage, or the screw tourniquet of Petit.
Before applying any of these it is advisable to empty the limb of blood.
This is best done after the manner suggested by Lister: the limb is held
vertical for three or four minutes; the veins are thus emptied by
gravitation, and they collapse, and as a physiological result of this
the arteries reflexly contract, so that the quantity of blood entering
the limb is reduced to a minimum. With the limb still elevated the
tourniquet is firmly applied, a part being selected where the vessel can
be pressed directly against a bone, and where there is no risk of
exerting injurious pressure on the nerve-trunks. The tourniquet should
be applied over several layers of gauze or lint to protect the skin, and
the first turn of the tourniquet must be rapidly and tightly applied to
arrest completely the arterial flow, otherwise the veins only are
obstructed and the limb becomes congested. In the lower extremity the
best place to apply a tourniquet is the middle third of the thigh; in
the upper extremity, in the middle of the arm. A tourniquet should never
be applied tighter or left on longer than is absolutely necessary.

The screw tourniquet of Petit is to be preferred when it is desired to
intermit the flow through the main artery as in operations for aneurysm.

When a tourniquet cannot conveniently be applied, or when its presence
interferes with the carrying out of the operation--as, for example, in
amputations at the hip or shoulder--the haemorrhage may be controlled by
preliminary ligation of the main artery above the seat of operation--for
instance, the external iliac or the subclavian. For such contingencies
also the steel skewers used by Spence and Wyeth, or a special clamp or
forceps, such as that suggested by Lynn Thomas, may be employed. In the
case of vessels which it is undesirable to occlude permanently, such as
the common carotid, the temporary application of a ligature or clamp is
useful.

#Arrest of Haemorrhage.#--_Ligature._--This is the best means of securing
the larger vessels. The divided vessel having been caught with forceps
as near to its cut end as possible, a ligature of catgut or silk is tied
round it. When there is difficulty in applying a ligature securely, for
example in a dense tissue like the scalp or periosteum, or in a friable
tissue like the thyreoid gland or the mesentery, a stitch should be
passed so as to surround the bleeding vessel a short distance from its
end, in this way ensuring a better hold and preventing the ligature from
slipping.

If the haemorrhage is from a partly divided vessel, this should be
completely cut across to enable its walls to contract and retract, and
to facilitate the application of forceps and ligatures.

_Torsion._--This method is seldom employed except for comparatively
small vessels, but it is applicable to even the largest arteries. In
employing torsion, the end of the vessel is caught with forceps, and the
terminal portion twisted round several times. The object is to tear the
inner and middle coats so that they curl up inside the lumen, while the
outer fibrous coat is twisted into a cord which occludes the end of the
vessel.

_Forci-pressure._--Bleeding from the smallest arteries and from
arterioles can usually be arrested by firmly squeezing them for a few
minutes with artery forceps. It is usually found that on the removal of
the forceps at the end of an operation no further haemorrhage takes
place. By the use of specially strong clamps, such as the angiotribes of
Doyen, large trunks may be occluded by pressure.

_Cautery._--The actual cautery or Paquelin's thermo-cautery is seldom
employed to arrest haemorrhage, but is frequently useful in preventing
it, as, for example, in the removal of piles, or in opening the bowel in
colostomy. It is used at a dull-red heat, which sears the divided ends
of the vessel and so occludes the lumen. A bright-red or a white heat
cuts the vessel across without occluding it. The separation of the
slough produced by the charring of the tissues is sometimes attended
with secondary bleeding.

_Haemostatics_ or _Styptics_.--The local application of haemostatics is
seldom to be recommended. In the treatment of epistaxis or bleeding from
the nose, of haemorrhage from the socket of a tooth, and sometimes from
ulcerating or granulating surfaces, however, they may be useful. All
clots must be removed and the drug applied directly to the bleeding
surface. Adrenalin and turpentine are the most useful drugs for this
purpose.

Haemorrhage from bone, for example the skull, may be arrested by means of
Horsley's aseptic plastic wax. To stop persistent oozing from soft
tissues, Horsley successfully applied a portion of living vascular
tissue, such as a fragment of muscle, which readily adheres to the
oozing surface and yields elements that cause coagulation of the blood
by thrombo-kinetic processes. When examined after two or three days the
muscle has been found to be closely adherent and undergoing
organisation.

#Arrest of Accidental Haemorrhage.#--The most efficient means of
temporarily controlling haemorrhage is by pressure applied with the
finger, or with a pad of gauze, directly over the bleeding point. While
this is maintained an assistant makes digital pressure, or applies a
tourniquet, over the main vessel of the limb on the proximal side of the
bleeding point. A useful _emergency tourniquet_ may be improvised by
folding a large handkerchief _en cravatte_, with a cork or piece of wood
in the fold to act as a pad. The handkerchief is applied round the
limb, with the pad over the main artery, and the ends knotted on the
lateral aspect of the limb. With a strong piece of wood the handkerchief
is wound up like a Spanish windlass, until sufficient pressure is
exerted to arrest the bleeding.

When haemorrhage is taking place from a number of small vessels, its
arrest may be effected by elevation of the bleeding part, particularly
if it is a limb. By this means the force of the circulation is
diminished and the formation of coagula favoured. Similarly, in wounds
of the hand or forearm, or of the foot or leg, bleeding may be arrested
by placing a pad in the flexure and acutely flexing the limb at the
elbow or knee respectively.

#Reactionary Haemorrhage.#--Reactionary or intermediary haemorrhage
is really a recurrence of primary bleeding. As the name indicates, it
occurs during the period of reaction--that is, within the first twelve
hours after an operation or injury. It may be due to the increase in the
blood-pressure that accompanies reaction displacing clots which have
formed in the vessels, or causing vessels to bleed which did not bleed
during the operation; to the slipping of a ligature; or to the giving
way of a grossly damaged portion of the vessel wall. In the scrotum, the
relaxation of the dartos during the first few hours after operation
occasionally leads to reactionary haemorrhage.

As a rule, reactionary haemorrhage takes place from small vessels as a
result of the displacement of occluding clots, and in many cases the
haemorrhage stops when the bandages and soaked dressings are removed. If
not, it is usually sufficient to remove the clots and apply firm
pressure, and in the case of a limb to elevate it. Should the haemorrhage
recur, the wound must be reopened, and ligatures applied to the bleeding
vessels. Douching the wound with hot sterilised water (about 110 o F.),
and plugging it tightly with gauze, are often successful in arresting
capillary oozing. When the bleeding is more copious, it is usually due
to a ligature having slipped from a large vessel such as the external
jugular vein after operations in the neck, and the wound must be opened
up and the vessel again secured. The internal administration of heroin
or morphin, by keeping the patient quiet, may prove useful in preventing
the recurrence of haemorrhage.

#Secondary Haemorrhage.#--The term secondary haemorrhage refers to
bleeding that is delayed in its onset and is due to pyogenic infection
of the tissues around an artery. The septic process causes softening and
erosion of the wall of the artery so that it gives way under the
pressure of the contained blood. The leakage may occur in drops, or as a
rush of blood, according to the extent of the erosion, the size of the
artery concerned, and the relations of the erosion to the surrounding
tissues. When met with as a complication of a wound there is an
interval--usually a week to ten days--between the receipt of the wound
and the first haemorrhage, this time being required for the extension of
the septic process to the wall of the artery and the consequent erosion
of its coats. When secondary haemorrhage occurs apart from a wound, there
is a similar septic process attacking the wall of the artery from the
outside; for example in sloughing sore-throat, the separation of a
slough may implicate the wall of an artery and be followed by serious
and it may be fatal haemorrhage. The mechanical pressure of a fragment of
bone or of a rubber drainage tube upon the vessel may aid the septic
process in causing erosion of the artery. In pre-Listerian days, the
silk ligature around the artery likewise favoured the changes that lead
to secondary haemorrhage, and the interesting observation was often made,
that when the collateral circulation was well established, the leakage
occurred on the _distal_ side of the ligature. While it may happen that
the initial haemorrhage is rapidly fatal, as for example when the
external carotid or one of its branches suddenly gives way, it is quite
common to have one, two or more _warning haemorrhages_ before the leakage
on a large scale, which is rapidly fatal.

The _appearances of the wound_ in cases complicated by secondary
haemorrhage are only characteristic in so far that while obviously
infected, there is an absence of all reaction; instead of frankly
suppurating, there is little or no discharge and the surrounding
cellular tissue and the limb beyond are oedematous and pit on pressure.

The _general symptoms_ of septic poisoning in cases of secondary
haemorrhage vary widely in severity: they may be so slight that the
general health is scarcely affected and the convalescence from an
operation, for example, may be apparently normal except that the wound
does not heal satisfactorily. For example, a patient may be recovering
from an operation such as the removal of an epithelioma of the mouth,
pharynx or larynx and the associated lymph glands in the neck, and be
able to be up and going about his room, when, suddenly, without warning
and without obvious cause, a rush of blood occurs from the mouth or the
incompletely healed wound in the neck, causing death within a few
minutes.

On the other hand, the toxaemia may be of a profound type associated with
marked pallor and progressive failure of strength, which, of itself,
even when the danger from haemorrhage has been overcome, may have a fatal
termination. The _prognosis_ therefore in cases of secondary haemorrhage
can never be other than uncertain and unfavourable; the danger from loss
of blood _per se_ is less when the artery concerned is amenable to
control by surgical measures.

_Treatment._--The treatment of secondary haemorrhage includes the use of
local measures to arrest the bleeding, the employment of general
measures to counteract the accompanying toxaemia, and when the loss of
blood has been considerable, the treatment of the bloodless state.

_Local Measures to arrest the Haemorrhage._--The occurrence of even
slight haemorrhages from a septic wound in the vicinity of a large blood
vessel is to be taken seriously; it is usually necessary to _open up the
wound_, clear out the clots and infected tissues with a sharp spoon,
disinfect the walls of the cavity with eusol or hydrogen peroxide, and
_pack_ it carefully but not too tightly with gauze impregnated with some
antiseptic, such as "bipp," so that, if the bleeding does not recur, it
may be left undisturbed for several days. The packing should if possible
be brought into actual contact with the leaking point in the vessel, and
so arranged as to make pressure on the artery above the erosion. The
dressings and bandage are then applied, with the limb in the attitude
that will diminish the force of the stream through the main artery, for
example, flexion at the elbow in haemorrhage from the deep palmar arch.
Other measures for combating the local sepsis, such as the irrigation
method of Carrel, may be considered.

If the wound involves one of the extremities, it may be useful; and it
imparts confidence to the nurse, and, it may be, to the patient, if a
Petit's tourniquet is loosely applied above the wound, which the nurse
is instructed to tighten up in the event of bleeding taking place.

_Ligation of the Artery._--If the haemorrhage recurs in spite of packing
the wound, or if it is serious from the outset and likely to be critical
if repeated, ligation of the artery itself or of the trunk from which it
springs, at a selected spot higher up, should be considered. This is
most often indicated in wounds of the extremities.

As examples of proximal ligation for secondary haemorrhage may be cited
ligation of the hypogastric artery for haemorrhage in the buttock, of the
common iliac for haemorrhage in the thigh, of the brachial in the upper
arm for haemorrhage from the deep palmar arch, and of the posterior
tibial behind the medial malleolus for haemorrhage from the sole of the
foot.

_Amputation_ is the last resource, and should be decided upon if the
haemorrhage recurs after proximal ligation, or if this has been followed
by gangrene of the limb; it should also be considered if the nature of
the wound and the virulence of the sepsis would of themselves justify
removal of the limb. Every surgeon can recall cases in which a timely
amputation has been the means of saving life.

The _counteraction of the toxaemia_ and the _treatment of the bloodless
state_, are carried out on the usual lines.

#Haemorrhage of Toxic Origin.#--Mention must also be made of haemorrhages
which depend upon infective or toxic conditions and in which no gross
lesion of the vessels can be discovered. The bleeding occurs as an
oozing, which may be comparatively slight and unimportant, or by its
persistence may become serious. It takes place into the superficial
layers of the skin, from mucous membranes, and into the substance of
such organs as the pancreas. Haemorrhage from the stomach and intestine,
attended with a brown or black discoloration of the vomit and of the
stools, is one of the best known examples: it is not uncommonly met with
in infective conditions originating in the appendix, intestine,
gall-bladder, and other abdominal organs. Haemorrhage from the mucous
membrane of the stomach after abdominal operations--apparently also due
to toxic causes and not to the operation--gives rise to the so-called
_post-operative haematemesis_.

#Constitutional Effects of Haemorrhage.#--The severity of the symptoms
resulting from haemorrhage depends as much on the rapidity with which the
bleeding takes place as on the amount of blood lost. The sudden loss of
a large quantity, whether from an open wound or into a serous
cavity--for example, after rupture of the liver or spleen--is attended
with marked pallor of the surface of the body and coldness of the skin,
especially of the face, feet, and hands. The skin is moist with a cold,
clammy sweat, and beads of perspiration stand out on the forehead. The
pulse becomes feeble, soft, and rapid, and the patient is dull and
listless, and complains of extreme thirst. The temperature is usually
sub-normal; and the respiration rapid, shallow, and sighing in
character. Abnormal visual sensations, in the form of flashes of light
or spots before the eyes; and rushing, buzzing, or ringing sounds in the
ears, are often complained of.

In extreme cases, phenomena which have been aptly described as those of
"air-hunger" ensue. On account of the small quantity of blood
circulating through the body, and the diminished haemoglobin content of
the blood, the tissues are imperfectly oxygenated, and the patient
becomes extremely restless, gasping for breath, constantly throwing
about his arms and baring his chest in the vain attempt to breath more
freely. Faintness and giddiness are marked features. The diminished
supply of oxygen to the brain and to the muscles produces muscular
twitchings, and sometimes convulsions. Finally the pupils dilate, the
sphincters relax, and death ensues.

Young children stand the loss of blood badly, but they quickly recover,
as the regeneration of blood takes place rapidly. In old people also,
and especially when they are fat, the loss of blood is badly borne, and
the ill effects last longer. Women, on the whole, stand loss of blood
better than men, and in them the blood is more rapidly re-formed. A few
hours after a severe haemorrhage there is usually a leucocytosis of from
15,000 to 30,000.

#Treatment of the Bloodless State.#--The patient should be placed in a
warm, well-ventilated room, and the foot of the bed elevated. Cardiac
stimulants, such as strychnin or alcohol, must be judiciously
administered, over-stimulation being avoided. The inhalation of oxygen
has been found useful in relieving the urgent symptoms of dyspnoea.

The blood may be emptied from the limbs into the vessels of the trunk,
where it is more needed, by holding them vertically in the air for a few
minutes, and then applying a firm elastic bandage over a layer of cotton
wool, from the periphery towards the trunk.

_Introduction of Fluids into the Circulation._--The most valuable
measure for maintaining the circulation, however, is by transfusion of
blood (_Op. Surg._, p. 37). If this is not immediately available the
introduction of from one to three pints of physiological salt
solution (a teaspoonful of common salt to a pint of water) into a vein,
or a 6 per cent. solution of gum acacia, is a useful expedient. The
solution is sterilised by boiling, and cooled to a temperature of about
105 o F. The addition of 5 to 10 minims of adrenalin solution (1 in 1000)
is advantageous in raising the blood-pressure (_Op. Surg._, p. 565).

When the intra-venous method is not available, one or two pints of
saline solution with adrenalin should be slowly introduced into the
rectum, by means of a long rubber tube and a filler. Satisfactory,
although less rapidly obtained results follow the introduction of saline
solution into the cellular tissue--for example, under the mamma, into
the axilla, or under the skin of the back.

If the patient can retain fluids taken by the mouth--such as hot coffee,
barley water, or soda water--these should be freely given, unless the
injury necessitates operative treatment under a general anaesthetic.

Transfusion of blood is most valuable as _a preliminary to operation_ in
patients who are bloodless as a result of haemorrhage from gastric and
duodenal ulcers, and in bleeders.


HAEMOPHILIA

The term haemophilia is applied to an inherited disease which renders the
patient liable to serious haemorrhage from even the most trivial
injuries; and the subjects of it are popularly known as "bleeders."

The cause of the disease and its true nature are as yet unknown. There
is no proof of any structural defect in the blood vessels, and beyond
the fact that there is a diminution in the number of blood-plates, it
has not been demonstrated that there is any alteration in the
composition of the blood.

The affection is in a marked degree hereditary, all the branches of an
affected family being liable to suffer. Its mode of transmission to
individuals, moreover, is characteristic: the male members of the stock
alone suffer from the affection in its typical form, while the tendency
is transmitted through the female line. Thus the daughters of a father
who is a bleeder, whilst they do not themselves suffer from the disease,
transmit the tendency to their male offspring. The sons, on the other
hand, neither suffer themselves nor transmit the disease to their
children (Fig. 64). The female members of a haemophilic stock are often
very prolific, and there is usually a predominance of daughters in their
families.


FIG 64.--Genealogical Tree of a Haemophilic Family.

Great-Great-Grandmother                Great-Great-Grandfather
Mrs D. (Lancashire) F                  M (History not known
                   .|                  |  as to bleeding)
                   .|                  |
                   .+----------+-------+
                   ............|
                              .|
                           ....|
                           .+---------+--------+
         Great-Grandmother .|         |        |
           (Married three  .F        MB       MB
                times)     .|
                           .|
                           .|
      By First Husband     .|                  By Second           By Third
              ..............|                  Husband             Husband
   +-----------+------------+----------+-------+-------+-----------+------+
   |          .|            |          |       +-------+-----------+------+
   M          .F            F          F       |       |           +------+
   |          .|            |          |       MB      F Died in      No
Died       Grandmother      |          |               | Childbed    Family
 aet.          .|            |     +-----------+   +----+---
 70           .|        +------+  |had family |   |
              .|        |      |  |but history|   |
              .|        MB    MB  |not known  |   MB
              .|
              .|
              .|.............................
+-----+----------+------------+------------+------------+-------------+
|     |          |            |            |.           |             |
|     |          |            |            |.           |             |
M     M          M            MB           F.           F             F
      |                                    |.           |             |
      |                                  Mother   +--+--+---+--+--+   |
    +----+                                 |.     |  |  |   |  |  |   |
    |    |                                 |.     M  M  MB  F  F  F   |
    M    F                                 |.                         |
     Not Married                           |.             +---+---+---+---+
                                           |.             |   |   |   |   |
                                           |.             MB  M   MB  M   M
                              .............|.
                         +-----+-----+-----+-----+-----+
                         |    .|    .|     |     |     |
                         |    .|*   .|*    |     |     |
                         M    MB    MB     F     F     F


F = Females.  M = Males (not bleeders).  MB = Males (bleeders)

 ** the patients observed by the authors. The dotted line shows the
    transmission of the disease to our patients through four
    generations.


The disease is met with in boys who are otherwise healthy, and usually
manifests itself during the first few years of life. In rare instances
profuse haemorrhage takes place when the umbilical cord separates. As a
rule the first evidence is the occurrence of long-continued and
uncontrollable bleeding from a comparatively slight injury, such as the
scratch of a pin, the extraction of a tooth, or after the operation of
circumcision. The blood oozes slowly from the capillaries; at first it
appears normal, but after flowing for some days, or it may be weeks, it
becomes pale, thin, and watery, and shows less and less tendency to
coagulate.

Female members of haemophilia families sometimes show a tendency to
excessive haemorrhage, but they seldom manifest the characteristic
features met with in the male members.

Sometimes the haemorrhage takes place apparently spontaneously from the
gums, the nasal or the intestinal mucous membrane. In other cases the
bleeding occurs into the cellular tissue under the skin or mucous
membrane, producing large areas of ecchymosis and discoloration. One of
the commonest manifestations of the disease is the occurrence of
haemorrhage into the cavities of the large joints, especially the knee,
elbow, or hip. The patient suffers repeatedly from such haemorrhages, the
determining injury being often so slight as to have passed unobserved.

There is evidence that the tendency to bleed is greater at certain times
than at others--in some cases showing almost a cyclical
character--although nothing is known as to the cause of the variation.

After a severe haemorrhage into the cellular tissue or into a joint, the
patient becomes pale and anaemic, the temperature may rise to 102 o or
103 o F., the pulse become small and rapid, and haemic murmurs are
sometimes developed over the heart and large arteries. The swelling is
tense, fluctuating, and hot, and there is considerable pain and
tenderness.

In exceptional cases, blisters form over the seat of the effusion, or
the skin may even slough, and the clinical features may therefore come
to simulate closely those of an acute suppurative condition. When the
skin sloughs, an ulcer is formed with altered blood-clot in its floor
like that seen in scurvy, and there is a remarkable absence of any
attempt at healing.

The acute symptoms gradually subside, and the blood is slowly absorbed,
the discoloration of the skin passing through the same series of changes
as occur after an ordinary bruise. The patients seldom manifest the
symptoms of the bloodless state, and the blood is rapidly regenerated.

The _diagnosis_ is easy if the patient or his friends are aware of the
family tendency to haemorrhage and inform the doctor of it, but they are
often sensitive and reticent regarding the fact, and it may only be
elicited after close investigation. From the history it is usually easy
to exclude scurvy and purpura. Repeated haemorrhages into a joint may
result in appearances which closely simulate those of tuberculous
disease. Recent haemorrhages into the cellular tissue often present
clinical features closely resembling those of acute cellulitis or
osteomyelitis. A careful examination, however, may reveal ecchymoses on
other parts of the body which give a clue to the nature of the
condition, and may prevent the disastrous consequences that may follow
incision.

These patients usually succumb sooner or later to haemorrhage, although
they often survive several severe attacks. After middle life the
tendency to bleed appears to diminish.

_Treatment._--As a rule the ordinary means of arresting haemorrhage are
of little avail. From among the numerous means suggested, the following
may be mentioned: The application to the bleeding point of gauze soaked
in a 1 in 1000 solution of adrenalin; prolonged inhalation of oxygen;
freezing the part with a spray of ethyl-chloride; one or more
subcutaneous injections of gelatin--5 ounces of a 2 1/2 per cent.
solution of white gelatin in normal salt solution being injected at a
temperature of about 100 o F.; the injection of pituitary extract. The
application of a pad of gauze soaked in the blood of a normal person
sometimes arrests the bleeding.

To prevent bleeding in haemophilics, intra-venous or subcutaneous
injections of fresh blood serum, taken from the human subject, the
sheep, the dog, or the horse, have proved useful. If fresh serum is not
available, anti-diphtheritic or anti-tetanic serum or trade
preparations, such as hemoplastin, may be employed. We have removed the
appendix and amputated through the thigh in haemophilic subjects without
excessive loss of blood after a course of fresh sheep's serum given by
the mouth over a period of several weeks.

The chloride and lactate of calcium, and extract of thymus gland have
been employed to increase the coagulability of the blood. The patient
should drink large quantities of milk, which also increases the
coagulability of the blood. Monro has observed remarkable results from
the hypodermic injection of emetin hydrochloride in  1/2-grain doses.


THROMBOSIS AND EMBOLISM

The processes known as thrombosis and embolism are so intimately
associated with the diseases of blood vessels that it is convenient to
define these terms in the first instance.

#Thrombosis.#--The term _thrombus_ is applied to a clot of blood formed
in the interior of the heart or of a blood vessel, and the process by
which such a clot forms is known as _thrombosis_. It would appear that
slowing or stagnation of the blood-stream, and interference with the
integrity of the lining membrane of the vessel wall, are the most
important factors determining the formation of the clot. Alterations in
the blood itself, such as occur, for example, in certain toxaemias, also
favour coagulation. When the thrombus is formed slowly, it consists of
white blood cells with a small proportion of fibrin, and, being
deposited in successive layers, has a distinctly laminated appearance on
section. It is known as a _white thrombus_ or laminated clot, and is
often met with in the sac of an aneurysm (Fig. 72). When rapidly formed
in a vessel in which the blood is almost stagnant--as, for example, in a
pouched varicose vein--the blood coagulates _en masse_, and the clot
consists of all the elements of the blood, constituting a _red thrombus_
(Fig. 66). Sometimes the thrombus is _mixed_--a red thrombus being
deposited on a white one, it may be in alternate layers.

When aseptic, a thrombus may become detached and be carried off in the
blood-stream as an embolus; it may become organised; or it may
degenerate and undergo calcification. Occasionally a small thrombus
situated behind a valve in a varicose vein or in the terminal end of a
dilated vein--for example in a pile--undergoes calcification, and is
then spoken of as a _phlebolith_; it gives a shadow with the X-rays.

When infected with pyogenic bacteria, the thrombus becomes converted
into pus and a localised abscess forms; or portions of the thrombus may
be carried as emboli in the circulation to distant parts, where they
give rise to secondary foci of suppuration--pyaemic abscesses.

#Embolism.#--The term _embolus_ is applied to any body carried along in
the circulation and ultimately becoming impacted in a blood vessel. This
occurrence is known as _embolism_. The commonest forms of embolus are
portions of thrombi or of fibrinous formations on the valves of the
heart, the latter being usually infected with micro-organisms.

Embolism plays an important part in determining one form of gangrene, as
has already been described. Infective emboli are the direct cause of the
secondary abscesses that occur in pyaemia; and they are sometimes
responsible for the formation of aneurysm.

Portions of malignant tumours also may form emboli, and their impaction
in the vessels may lead to the development of secondary growths in
distant parts of the body.

Fat and air embolism have already been referred to.


ARTERITIS

_Pyogenic._--Non-suppurative inflammation of the coats of an artery may
so soften the wall of the vessel as to lead to aneurysmal dilatation. It
is not uncommon in children, and explains the occurrence of aneurysm in
young subjects.

When suppuration occurs, the vessel wall becomes disintegrated and gives
way, leading to secondary haemorrhage. If the vessel ruptures into an
abscess cavity, dangerous bleeding may occur when the abscess bursts or
is opened.

_Syphilitic._--The inflammation associated with syphilis results in
thickening of the tunica intima, whereby the lumen of the vessel becomes
narrowed, or even obliterated--_endarteritis obliterans_. The middle
coat usually escapes, but the tunica externa is generally thickened.
These changes cause serious interference with the nutrition of the parts
supplied by the affected arteries. In large trunks, by diminishing the
elasticity of the vessel wall, they are liable to lead to the formation
of aneurysm.

Changes in the arterial walls closely resembling those of syphilitic
arteritis are sometimes met with in _tuberculous_ lesions.

#Arterio-sclerosis# or #Chronic Arteritis#.--These terms are applied to
certain changes which result in narrowing of the lumen and loss of
elasticity in the arteries. The condition may affect the whole vascular
system or may be confined to particular areas. In the smaller arteries
there is more or less uniform thickening of the tunica intima from
proliferation of the endothelium and increase in the connective tissue
in the elastic lamina--a form of obliterative endarteritis. The
narrowing of the vessels may be sufficient to determine gangrene in the
extremities. In course of time, particularly in the larger arteries,
this new tissue undergoes degeneration, at first of a fatty nature, but
progressing in the direction of calcification, and this is followed by
the deposit of lime salts in the young connective tissue and the
formation of calcareous plates or rings over a considerable area of the
vessel wall. To this stage in the process the term _atheroma_ is
applied. The endothelium over these plates often disappears, leaving
them exposed to the blood-stream.

Changes of a similar kind sometimes occur in the middle coat, the lime
salts being deposited among the muscle fibres in concentric rings.

The primary cause of arterio-sclerosis is not definitely known, but its
almost constant occurrence, to a greater or less degree, in the aged
suggests that it is of the nature of a senile degeneration. It is
favoured by anything which throws excessive strain on the vessel walls,
such as heavy muscular work; by chronic alcoholism and syphilis; or by
such general diseases as tend to raise the blood-pressure--for example,
chronic Bright's disease or gout. It occurs with greater frequency and
with greater severity in men than in women.

Atheromatous degeneration is most common in the large arterial trunks,
and the changes are most marked at the arch of the aorta, opposite the
flexures of joints, at the mouths of large branches, and at parts where
the vessel lies in contact with bone. The presence of diseased patches
in the wall of an artery diminishes its elasticity and favours
aneurysmal dilatation. Such a vessel also is liable to be ruptured by
external violence and so give rise to traumatic aneurysm. Thrombosis is
liable to occur when calcareous plates are exposed in the lumen of the
vessel by destruction of the endothelium, and this predisposes to
embolism. Arterio-sclerosis also interferes with the natural arrest of
haemorrhage, and by rendering the vessels brittle, makes it difficult to
secure them by ligature. In advanced cases the accessible arteries--such
as the radial, the temporal or the femoral--may be felt as firm,
tortuous cords, which are sometimes so hard that they have been aptly
compared to "pipe-stems." The pulse is smaller and less compressible
than normal, and the vessel moves bodily with each pulsation. It must be
borne in mind, however, that the condition of the radial artery may fail
to afford a clue to that of the larger arteries. Calcified arteries are
readily identified in skiagrams (Fig. 65).

[Illustration: FIG. 65.--Radiogram showing Calcareous Degeneration
(Atheroma) of Arteries.]

We have met with a chronic form of arterial degeneration in elderly
women, affecting especially the great vessels at the root of the neck,
in which the artery is remarkably attenuated and dilated, and so friable
that the wall readily tears when seized with an artery-forceps,
rendering ligation of the vessel in the ordinary way well-nigh
impossible. Matas suggests infolding the wall of the vessel with
interrupted sutures that do not pierce the intima, and wrapping it
round with a strip of peritoneum or omentum.

The most serious form of arterial _thrombosis_ is that met with _in the
abdominal aorta_, which is attended with violent pains in the lower
limbs, rapidly followed by paralysis and arrest of the circulation.


THROMBO-PHLEBITIS AND THROMBOSIS IN VEINS

#Thrombosis# is more common in veins than in arteries, because slowing
of the blood-stream and irritation of the endothelium of the vessel wall
are, owing to the conditions of the venous circulation, more readily
induced in veins.

Venous thrombosis may occur from purely mechanical causes--as, for
example, when the wall of a vein is incised, or the vessel included in a
ligature, or when it is bruised or crushed by a fragment of a broken
bone or by a bandage too tightly applied. Under these conditions
thrombosis is essentially a reparative process, and has already been
considered in relation to the repair of blood vessels.

In other cases thrombosis is associated with certain constitutional
diseases--gout, for example; the endothelium of the veins undergoing
changes--possibly the result of irritation by abnormal constituents in
the blood--which favour the formation of thrombi.

Under these various conditions the formation of a thrombus is not
necessarily associated with the action of bacteria, although in any
of them this additional factor may be present.

The most common cause of venous thrombosis, however, is inflammation of
the wall of the vein--phlebitis.

#Phlebitis.#--Various forms of phlebitis are met with, but for practical
purposes they may be divided into two groups--one in which there is a
tendency to the formation of a thrombus; the other in which the
infective element predominates.

In surgical patients, the _thrombotic form_ is almost invariably met
with in the lower extremity, and usually occurs in those who are
debilitated and anaemic, and who are confined to bed for prolonged
periods--for example, during the treatment of fractures of the leg or
pelvis, or after such operations as herniotomy, prostatectomy, or
appendectomy.

_Clinical Features._--The most typical example of this form of phlebitis
is that so frequently met with in the great saphena vein, especially
when it is varicose. The onset of the attack is indicated by a sudden
pain in the lower limb--sometimes below, sometimes above the knee. This
initial pain may be associated with shivering or even with a rigor, and
the temperature usually rises one or two degrees. There is swelling and
tenderness along the line of the affected vein, and the skin over it is
a dull-red or purple colour. The swollen vein may be felt as a firm
cord, with bead-like enlargements in the position of the valves. The
patient experiences a feeling of stiffness and tightness throughout the
limb. There is often oedema of the leg and foot, especially when the limb
is in the dependent position. The acute symptoms pass off in a few days,
but the swelling and tenderness of the vein and the oedema of the limb
may last for many weeks.

When the deep veins--iliac, femoral, popliteal--are involved, there is
great swelling of the whole limb, which is of a firm almost "wooden"
consistence, and of a pale-white colour; the oedema may be so great that
it is impossible to feel the affected vein until the swelling has
subsided. This is most often seen in puerperal women, and is known as
_phlegmasia alba dolens_.

_Treatment._--The patient must be placed at absolute rest, with the foot
of the bed raised on blocks 10 or 12 inches high, and the limb
immobilised by sand-bags or splints. It is necessary to avoid handling
the parts, lest the clot be displaced and embolism occur. To avoid
frequent movement of the limb, the necessary dressings should be kept in
position by means of a many-tailed rather than a roller bandage.

To relieve the pain, warm fomentations or lead and opium lotion should
be applied. Later, ichthyol-glycerin, or glycerin and belladonna, may be
substituted.

When, at the end of three weeks, the danger of embolism is past,
douching and gentle massage may be employed to disperse the oedema; and
when the patient gets up he should wear a supporting elastic bandage.

The _infective_ form usually begins as a peri-phlebitis arising in
connection with some focus of infection in the adjacent tissues. The
elements of the vessel wall are destroyed by suppuration, and the
thrombus in its lumen becomes infected with pyogenic bacteria and
undergoes softening.

_Occlusion of the inferior vena cava_ as a result of infective
thrombosis is a well-known condition, the thrombosis extending into the
main trunk from some of its tributaries, either from the femoral or
iliac veins below or from the hepatic veins above.

Portions of the softened thrombus are liable to become detached and to
enter the circulating blood, in which they are carried as emboli. These
may lodge in distant parts, and give rise to secondary foci of
suppuration--pyaemic abscesses.

_Clinical Features._--Infective phlebitis is most frequently met with in
the transverse sinus as a sequel to chronic suppuration in the mastoid
antrum and middle ear. It also occurs in relation to the peripheral
veins, but in these it can seldom be recognised as a separate entity,
being merged in the general infective process from which it takes
origin. Its occurrence may be inferred, if in the course of a
suppurative lesion there is a sudden rise of temperature, with pain,
redness, and swelling along the line of a venous trunk, and a rapidly
developed oedema of the limb, with pitting of the skin on pressure. In
rare cases a localised abscess forms in the vein and points towards the
surface.

_Treatment._--Attention must be directed towards the condition with
which the phlebitis is associated. Ligation of the vein on the cardiac
side of the thrombus with a view to preventing embolism is seldom
feasible in the peripheral veins, although, as will be pointed out
later, the jugular vein is ligated with this object in cases of
phlebitis of the transverse sinus.


VARIX--VARICOSE VEINS

The term varix is applied to a condition in which veins are so altered
in structure that they remain permanently dilated, and are at the same
time lengthened and tortuous. Two types are met with: one in which
dilatation of a large superficial vein and its tributaries is the most
obvious feature; the other, in which bunches of distended and tortuous
vessels develop at one or more points in the course of a vein, a
condition to which Virchow applied the term _angioma racemosum venosum_.
The two types may occur in combination.

Any vein in the body may become varicose, but the condition is rare
except in the veins of the lower extremity, in the veins of the
spermatic cord (varicocele), and in the veins of the anal canal
(haemorrhoids).

We are here concerned with varix as it occurs in the veins of the lower
extremity.

_Etiology._--Considerable difference of opinion exists as to the
essential cause of varix. The weight of evidence is in favour of the
view that, when dilatation is the predominant element, it results from a
congenital deficiency in the number, size, and strength of the valves of
the affected veins, and in an inherent weakness in the vessel walls.
The _angioma racemosum venosum_ is probably also due to a congenital
alteration in the structure of the vessels, and is allied to tumours of
blood vessels. The view that varix is congenital in origin, as was first
suggested by Virchow, is supported by the fact that in a large
proportion of cases the condition is hereditary; not only may several
members of the same family in succeeding generations suffer from varix,
but it is often found that the same vein, or segment of a vein, is
involved in all of them. The frequent occurrence of varix in youth is
also an indication of its congenital origin.

In the majority of cases it is only when some exciting factor comes into
operation that the clinical phenomena associated with varix appear. The
most common exciting cause is increased pressure within the veins, and
this may be produced in a variety of ways. In certain diseases of the
heart, lungs, and liver, for example, the venous pressure may be so
raised as to cause a localised dilatation of such veins as are
congenitally weak. The direct pressure of a tumour, or of the gravid
uterus on the large venous trunks in the pelvis, may so obstruct the
flow as to distend the veins of the lower extremity. It is a common
experience in women that the signs of varix date from an antecedent
pregnancy. The importance of the wearing of tight garters as a factor in
the production of varicose veins has been exaggerated, although it must
be admitted that this practice is calculated to aggravate the condition
when it is once established. It has been proved experimentally that the
backward pressure in the veins may be greatly increased by straining, a
fact which helps to explain the frequency with which varicosity occurs
in the lower limbs of athletes and of those whose occupation involves
repeated and violent muscular efforts. There is reason to believe,
moreover, that a sudden strain may, by rupturing the valves and so
rendering them incompetent, induce varicosity independently of any
congenital defect. Prolonged standing or walking, by allowing gravity to
act on the column of blood in the veins of the lower limbs, is also an
important determining factor in the production of varix.

Thrombosis of the deep veins--in the leg, for example--may induce marked
dilatation of the superficial veins, by throwing an increased amount of
work upon them. This is to be looked upon rather as a compensatory
hypertrophy of the superficial vessels than as a true varix.

_Morbid Anatomy._--In the lower extremity the varicosity most commonly
affects the vessels of the great saphena system; less frequently those
of the small saphena system. Sometimes both systems are involved, and
large communicating branches may develop between the two.

The essential lesion is the absence or deficiency of valves, so that
they are incompetent and fail to support the column of blood which bears
back upon them. Normally the valves in the femoral and iliac veins and
in the inferior vena cava are imperfectly developed, so that in the
erect posture the great saphena receives a large share of the backward
pressure of the column of venous blood.

The whole length of the vein may be affected, but as a rule the disease
is confined to one or more segments, which are not only dilated, but are
also increased in length, so that they become convoluted. The adjacent
loops of the convoluted vein are often bound together by fibrous tissue.
All the coats are thickened, chiefly by an increased development of
connective tissue, and in some cases changes similar to those of
arterio-sclerosis occur. The walls of varicose veins are often
exceedingly brittle. In some cases the thickening is uniform, and in
others it is irregular, so that here and there thin-walled sacs or
pouches project from the side of the vein. These pouches vary in size
from a bean to a hen's egg, the larger forms being called _venous
cysts_, and being most commonly met with in the region of the saphenous
opening and of the opening in the popliteal fascia. Such pouches, being
exposed to injury, are frequently the seat of thrombosis (Fig. 66).

[Illustration: FIG. 66.--Thrombosis in Tortuous and Pouched Great
Saphena Vein, in longitudinal section.]

_Clinical Features._--Varix is most frequently met with between puberty
and the age of thirty, and the sexes appear to suffer about equally.

The amount of discomfort bears no direct proportion to the extent of
the varicosity. It depends rather upon the degree of pressure in the
veins, as is shown by the fact that it is relieved by elevation of the
limb. When the whole length of the main trunk of the great saphena is
implicated, the pressure in the vein is high and the patient suffers a
good deal of pain and discomfort. When, on the contrary, the upper part
of the saphena and its valves are intact, and only the more distal veins
are involved, the pressure is not so high and there is comparatively
little suffering. The usual complaint is of a sense of weight and
fulness in the limb after standing or walking, sometimes accompanied by
actual pain, from which relief is at once obtained by raising the limb.
Cramp-like pains in the muscles are often associated with varix of the
deep veins.

The dilated and tortuous vein can be readily seen and felt when the
patient is examined in the upright posture. In advanced cases, bead-like
swellings are sometimes to be detected over the position of the valves,
and, on running the fingers along the course of the vessel, a firm
ridge, due to periphlebitis, may be detected on each side of the vein.
When the limb is oedematous, the outline of the veins is obscured, but
they can be identified on palpation as gutter-like tracks. When large
veins are implicated, a distinct impulse on coughing may be seen to pass
down as far as the knee; and if the vessel is sharply percussed a fluid
wave may be detected passing both up and down the vein.

If the patient is placed on a couch and the limb elevated, the veins are
emptied, and if pressure is then made over the region of the saphenous
opening and the patient allowed to stand up, so long as the great
saphena system alone is involved, the veins fill again very slowly from
below. If the small saphena system also is involved, and if
communicating branches are dilated, the veins fill up from below more
rapidly. When the pressure over the saphenous opening is removed, the
blood rapidly rushes into the varicose vessels from above; this is known
as Trendelenburg's test.

The most marked dilatation usually occurs on the medial side of the
limb, between the middle of the thigh and the middle of the calf, the
arrangement of the veins showing great variety (Fig. 67).

There are usually one or more bunches of enlarged and tortuous veins in
the region of the knee. Frequently a large branch establishes a
communication between the systems of the great and small saphenous veins
in the region of the popliteal space, or across the front of the upper
part of the tibia. The superficial position of this last branch and its
proximity to the bone render it liable to injury.

[Illustration: FIG. 67.--Extensive Varix of Internal Saphena System on
Left Leg, of many years' standing.]

The small veins of the skin of the ankle and foot often show as fine
blue streaks arranged in a stellate or arborescent manner, especially in
women who have borne children.

_Complications._--When the varix is of long standing, the skin in the
lower part of the leg sometimes assumes a mahogany-brown or bluish hue,
as a result of the _deposit of blood pigment_ in the tissues, and this
is frequently a precursor of ulceration.

_Chronic dermatitis_ (_varicose eczema_) is often met with in the lower
part of the leg, and is due to interference with the nutrition of the
skin. The incompetence of the valves allows the pressure in the varicose
veins to equal that in the arterioles, so that the capillary circulation
is impeded. From the same cause the blood in the deep veins is enabled
to enter the superficial veins, where the backward pressure is so great
that the blood flows down again, and so a vicious circle is established.
The blood therefore loses more and more of its oxygen, and so fails to
nourish the tissues.

The _ulcer_ of the leg associated with varicose veins has already been
described.

_Haemorrhage_ may take place from a varicose vein as a result of a wound
or of ulceration of its wall. Increased intra-venous pressure produced
by severe muscular strain may determine rupture of a vein exposed in the
floor of an ulcer. If the limb is dependent, the incompetency of the
valves permits of rapid and copious bleeding, which may prove fatal,
particularly if the patient is intoxicated when the rupture takes place
and no means are taken to arrest the haemorrhage. The bleeding may be
arrested at once by elevating the limb, or by applying pressure directly
over the bleeding point.

_Phlebitis and thrombosis_ are common sequelae of varix, and may prove
dangerous, either by spreading into the large venous trunks or by giving
rise to emboli. The larger the varix the greater is the tendency for a
thrombus to spread upwards and to involve the deep veins. Thrombi
usually originate in venous cysts or pouches, and at acute bends on the
vessel, especially when these are situated in the vicinity of the knee,
and are subjected to repeated injuries--for example in riding.
Phleboliths sometimes form in such pouches, and may be recognised in a
radiogram. In a certain proportion of cases, especially in elderly
people, the occurrence of thrombosis leads to cure of the condition by
the thrombus becoming organised and obliterating the vein.

_Treatment._--At best the treatment of varicose veins is only
palliative, as it is obviously impossible to restore to the vessels
their normal structure. The patient must avoid wearing anything, such as
a garter, which constricts the limb, and any obvious cause of direct
pressure on the pelvic veins, such as a tumour, persistent
constipation, or an ill-fitting truss, should be removed. Cardiac,
renal, or pulmonary causes of venous congestion must also be treated,
and the functions of the liver regulated. Severe forms of muscular
exertion and prolonged standing or walking are to be avoided, and the
patient may with benefit rest the limb in an elevated position for a few
hours each day. To support the distended vessels, a closely woven silk
or worsted stocking, or a light and porous form of elastic bandage,
applied as a puttee, should be worn. These appliances should be put on
before the patient leaves his bed in the morning, and should only be
removed after he lies down at night. In this way the vessels are never
allowed to become dilated. Elastic stockings, and bandages made entirely
of india-rubber, are to be avoided. In early and mild cases these
measures are usually sufficient to relieve the patient's discomfort.

_Operative Treatment._--In aggravated cases, when the patient is
suffering pain, when his occupation is interfered with by repeated
attacks of phlebitis, or when there are large pouches on the veins,
operative treatment is called for. The younger the patient the clearer
is the indication to operate. It may be necessary to operate to enable a
patient to enter one of the public services, even although no symptoms
are present. The presence of an ulcer does not contra-indicate
operation; the ulcer should be excised, and the raw surface covered with
skin grafts, before dealing with the veins.

The _operation of Trendelenburg_ is especially appropriate to cases in
which the trunk of the great saphena vein in the thigh is alone
involved. It consists in exposing three or four inches of the vein in
its upper part, applying a ligature at the upper and lower ends of the
exposed portion, and, after tying all tributary branches, resecting this
portion of the vein.

The procedure of C. H. Mayo is adapted to cases in which it is desirable
to remove longer segments of the veins. It consists in the employment of
special instruments known as "ring-enucleators" or "vein-strippers," by
means of which long portions of the vein are removed through
comparatively small incisions.

An alternative procedure consists in avulsing segments of the vein by
means of Babcock's stylet, which consists of a flexible steel rod, 30
inches in length, with acorn-shaped terminals. The instrument is passed
along the lumen of the segment to be dealt with, and a ligature applied
around the vein above the bulbous end of the stylet enables nearly the
whole length of the great saphena vein to be dragged out in one piece.
These methods are not suitable when the veins are brittle, when there
are pouches or calcareous deposits in their walls, or where there has
been periphlebitis binding the coils together.

Mitchell of Belfast advises exposing the varices at numerous points by
half-inch incisions, and, after clamping the vein between two pairs of
forceps, cutting it across and twisting out the segments of the vein
between adjacent incisions. The edges of the incisions are sutured; and
the limb is firmly bandaged from below upwards, and kept in an elevated
position. We have employed this method with satisfactory results.

The treatment of the complications of varix has already been considered.


ANGIOMA[4]

[4] In the description of angiomas we have followed the teaching of the
late John Duncan.

Tumours of blood vessels may be divided, according to the nature of the
vessels of which they are composed, into the capillary, the venous, and
the arterial angiomas.


CAPILLARY ANGIOMA

The most common form of capillary angioma is the naevus or congenital
telangiectasis.

#Naevus.#--A naevus is a collection of dilated capillaries, the afferent
arterioles and the efferent venules of which often share in the
dilatation. Little is known regarding the _etiology_ of naevi beyond the
fact that they are of congenital origin. They often escape notice until
the child is some days old, but attention is usually drawn to them
within a fortnight of birth. For practical purposes the most useful
classification of naevi is into the cutaneous, the subcutaneous, and the
mixed forms.

_The cutaneous naevus_, "mother's mark," or "port-wine stain," consists
of an aggregation of dilated capillaries in the substance of the skin.
On stretching the skin the vessels can be seen to form a fine network,
or to run in leashes parallel to one another. A dilated arteriole or a
vein winding about among the capillaries may sometimes be detected.
These naevi occur on any part of the body, but they are most frequently
met with on the face. They may be multiple, and vary greatly in size,
some being no bigger than a pin-head, while others cover large areas of
the body. In colour they present every tint from purple to brilliant
red; in the majority there is a considerable dash of blue, especially in
cold weather.

Unlike the other forms of naevi, the cutaneous variety shows little
tendency to disappear, and it is especially persistent when associated
with overgrowth of the epidermis and of the hairs--_naevoid mole_.

The _treatment_ of the cutaneous naevus is unsatisfactory, owing to the
difficulty of removing the naevus without leaving a scar which is even
more disfiguring. Very small naevi may be destroyed by a fine pointed
Paquelin thermo-cautery, or by escharotics, such as nitric acid. For
larger naevi, radium and solidified carbon dioxide ("CO_2 snow") may be
used. The extensive port-wine stains so often met with on the face are
best left alone.

The _subcutaneous naevus_ is comparatively rare. It constitutes a
well-defined, localised tumour, which may possess a distinct capsule,
especially when it has ceased to grow or is retrogressing. On section,
it presents the appearance of a finely reticulated sponge.

Although it may be noticed at, or within a few days of, birth, a
subcutaneous naevus is often overlooked, especially when on a covered
part of the body, and may not be discovered till the patient is some
years old. It forms a rounded, lobulated swelling, seldom of large size
and yielding a sensation like that of a sponge; the skin over it is
normal, or may exhibit a bluish tinge, especially in cold weather. In
some cases the tumour is diminished by pressing the blood out of it, but
slowly fills again when the pressure is relaxed, and it swells up when
the child struggles or cries. From a cold abscess it is diagnosed by the
history and progress of the swelling and by the absence of fluctuation.
When situated over one of the hernial openings, it closely simulates a
hernia; and when it occurs in the middle line of the face, head, or
back, it may be mistaken for such other congenital conditions as
meningocele or spina bifida. When other means fail, the use of an
exploring needle clears up the diagnosis.

_Mixed Naevus._--As its name indicates, the mixed naevus partakes of the
characters of the other two varieties; that is, it is a subcutaneous
naevus with involvement of the skin.

It is frequently met with on the face and head, but may occur on any
part of the body. It also affects parts covered by mucous membrane, such
as the cheek, tongue, and soft palate. The swelling is rounded or
lobulated, and projects beyond the level of its surroundings. Sometimes
the skin is invaded by the naevoid tissue over the whole extent of the
tumour, sometimes only over a limited area. Frequently the margin only
is of a bright-red colour, while the skin in the centre resembles a
cicatrix. The swelling is reduced by steady pressure, and increases in
size and becomes tense when the child cries.

[Illustration: FIG. 68.--Mixed Naevus of Nose which was subsequently
cured by Electrolysis.]

_Prognosis._--The rate of growth of the subcutaneous and mixed forms of
naevi varies greatly. They sometimes increase rapidly, especially during
the first few months of life; after this they usually grow at the same
rate as the child, or more slowly. There is a decided tendency to
disappearance of these varieties, fully 50 per cent. undergoing natural
cure by a process of obliteration, similar to the obliteration of
vessels in cicatricial tissue. This usually begins about the period of
the first dentition, sometimes at the second dentition, and sometimes at
puberty. On the other hand, an increased activity of growth may be shown
at these periods. The onset of natural cure is recognised by the tumour
becoming firmer and less compressible, and, in the mixed variety, by the
colour becoming less bright. Injury, infection, or ulceration of the
overlying skin may initiate the curative process.

Towards adult life the spaces in a subcutaneous naevus may become greatly
enlarged, leading to the formation of a cavernous angioma.

_Treatment._--In view of the frequency with which subcutaneous and mixed
naevi disappear spontaneously, interference is only called for when the
growth of the tumour is out of proportion to that of the child, or when,
from its situation--for example in the vicinity of the eye--any marked
increase in its size would render it less amenable to treatment.

The methods of treatment most generally applicable are the use of radium
and carbon dioxide snow, igni-puncture, electrolysis, and excision.

For naevi situated on exposed parts, where it is desirable to avoid a
scar, the use of _radium_ is to be preferred. The tube of radium is
applied at intervals to different parts of the naevus, the duration and
frequency of the applications varying with the strength of the
emanations and the reaction produced. The object aimed at is to induce
obliteration of the naevoid tissue by cicatricial contraction without
destroying the overlying skin. _Carbon-dioxide snow_ may be employed in
the same manner, but the results are inferior to those obtained by
radium.

_Igni-puncture_ consists in making a number of punctures at different
parts of the naevus with a fine-pointed thermo-cautery, with the object
of starting at each point a process of cicatrisation which extends
throughout the naevoid tissue and so obliterates the vessels.

_Electrolysis_ acts by decomposing the blood and tissues into their
constituent elements--oxygen and acids appearing at the positive,
hydrogen and bases at the negative electrode. These substances and gases
being given off in a nascent condition, at once enter into new
combinations with anything in the vicinity with which they have a
chemical affinity. In the naevus the practical result of this reaction is
that at the positive pole nitric acid, and at the negative pole caustic
potash, both in a state of minute subdivision, make their appearance.
The effect on the tissues around the positive pole, therefore, is
equivalent to that of an acid cauterisation, and on those round the
negative pole, to an alkaline cauterisation.

As the process is painful, a general anaesthetic is necessary. The
current used should be from 20 to 80 milliamperes, gradually increasing
from zero, without shock; three to six large Bunsen cells give a
sufficient current, and no galvanometer is required. Steel needles,
insulated with vulcanite to within an eighth of an inch of their points,
are the best. Both poles are introduced into the naevus, the positive
being kept fixed at one spot, while the negative is moved about so as to
produce a number of different tracks of cauterisation. On no account
must either pole be allowed to come in contact with the skin, lest a
slough be formed. The duration of the sitting is determined by the
effect produced, as indicated by the hardening of the tumour, the
average duration being from fifteen to twenty minutes. If pallor of the
skin appears, it indicates that the needles are too near the surface, or
that the blood supply to the integument is being cut off, and is an
indication to stop. To cauterise the track and so prevent bleeding, the
needles should be slowly withdrawn while the current is flowing. When
the skin is reached the current is turned off. The punctures are covered
with collodion. Six or eight weeks should be allowed to elapse before
repeating the procedure. From two to eight or ten sittings may be
necessary, according to the size and character of the naevus.

_Excision_ is to be preferred for naevi of moderate size situated on
covered parts of the body, where a scar is of no importance. Its chief
advantages over electrolysis are that a single operation is sufficient,
and that the cure is speedy and certain. The operation is attended with
much less haemorrhage than might be expected.

#Cavernous Angioma.#--This form of angioma consists of a series of large
blood spaces which are usually derived from the dilatation of the
capillaries of a subcutaneous naevus. The spaces come to communicate
freely with one another by the disappearance of adjacent capillary
walls. While the most common situation is in the subcutaneous tissue, a
cavernous angioma is sometimes met with in internal organs. It may
appear at any age from early youth to middle life, and is of slow growth
and may become stationary. The swelling is rounded or oval, there is no
pulsation or bruit, and the tumour is but slightly compressible. The
treatment consists in dissecting it out.

#Aneurysm by Anastomosis# is the name applied to a vascular tumour in
which the arteries, veins, and capillaries are all involved. It is met
with chiefly on the upper part of the trunk, the neck, and the scalp. It
tends gradually to increase in size, and may, after many years, attain
an enormous size. The tumour is ill-defined, and varies in consistence.
It is pulsatile, and a systolic bruit or a "thrilling" murmur may be
heard over it. The chief risk is haemorrhage from injury or ulceration.

[Illustration: FIG. 69.--Cirsoid Aneurysm of Forehead in a boy aet. 10.

(Mr. J. W. Dowden's case.)]

The _treatment_ is conducted on the same lines as for naevus. When
electrolysis is employed, it should be directed towards the afferent
vessels; and if it fails to arrest the flow through these, it is useless
to persist with it. In some cases ligation of the afferent vessels has
been successful.

#Arterial Angioma# or #Cirsoid Aneurysm#.--This is composed of the
enlarged branches of an arterial trunk. It originates in the smaller
branches of an artery--usually the temporal--and may spread to the main
trunk, and may even involve branches of other trunks with which the
affected artery anastomoses.

The condition is probably congenital in origin, though its appearance is
frequently preceded by an injury. It almost invariably occurs in the
scalp, and is usually met with in adolescent young adults.

The affected vessels slowly increase in size, and become tortuous, with
narrowings and dilatations here and there. Grooves and gutters are
frequently found in the bone underlying the dilated vessels.

There is a constant loud bruit in the tumour, which greatly troubles the
patient and may interfere with sleep. There is no tendency either to
natural cure or to rupture, but severe and even fatal haemorrhage may
follow a wound of the dilated vessels.

[Illustration: FIG. 70.--Cirsoid Aneurysm of Orbit and Face, which
developed after a blow on the Orbit with a cricket ball.

(From a photograph lent by Sir Montagu Cotterill.)]

The condition may be treated by excision or by electrolysis. In excision
the haemorrhage is controlled by an elastic tourniquet applied
horizontally round the head, or by ligation of the feeding trunks. In
large tumours the bleeding is formidable. In many cases electrolysis is
to be preferred, and is performed in the same way as for naevus. The
positive pole is placed in the centre of the tumour, while the negative
is introduced into the main affluents one after another.


ANEURYSM

An aneurysm is a sac communicating with an artery, and containing fluid
or coagulated blood.

Two types are met with--the pathological and the traumatic. It is
convenient to describe in this section also certain conditions in which
there is an abnormal communication between an artery and a
vein--arterio-venous aneurysm.


PATHOLOGICAL ANEURYSM

In this class are included such dilatations as result from weakening of
the arterial coats, combined, in most cases, with a loss of elasticity
in the walls and increase in the arterial tension due to
arterio-sclerosis. In some cases the vessel wall is softened by
arteritis--especially the embolic form--so that it yields before the
pressure of the blood.

Repeated and sudden raising of the arterial tension, as a result, for
example, of violent muscular efforts or of excessive indulgence in
alcohol, plays an important part in the causation of aneurysm. These
factors probably explain the comparative frequency of aneurysm in those
who follow such arduous occupations as soldiers, sailors,
dock-labourers, and navvies. In these classes the condition usually
manifests itself between the ages of thirty and fifty--that is, when the
vessels are beginning to degenerate, although the heart is still
vigorous and the men are hard at work. The comparative immunity of women
may also be explained by the less severe muscular strain involved by
their occupations and recreations.

Syphilis plays an important part in the production of aneurysm, probably
by predisposing the patient to arterio-sclerosis and atheroma, and
inducing an increase in the vascular tension in the peripheral vessels,
from loss of elasticity of the vessel wall and narrowing of the lumen as
a result of syphilitic arteritis. It is a striking fact that aneurysm is
seldom met with in women who have not suffered from syphilis.

#Varieties--Fusiform Aneurysm.#--When the _whole circumference_ of an
artery has been weakened, the tension of the blood causes the walls to
dilate uniformly, so that a fusiform or tubular aneurysm results. All
the coats of the vessel are stretched and form the sac of the aneurysm,
and the affected portion is not only dilated but is also increased in
length. This form is chiefly met with in the arch of the aorta, but may
occur in any of the main arterial trunks. As the sac of the aneurysm
includes all three coats, and as the inner and outer coats are usually
thickened by the deposit in them of connective tissue, this variety
increases in size slowly and seldom gives rise to urgent symptoms.

As a rule a fusiform aneurysm contains fluid blood, but when the intima
is roughened by disease, especially in the form of calcareous plates,
shreds of clot may adhere to it.

It has little tendency to natural cure, although this is occasionally
effected by the emerging artery becoming occluded by a clot; it has also
little tendency to rupture.

#Sacculated Aneurysm.#--When a _limited area_ of the vessel wall is
weakened--for example by atheroma or by other form of arteritis--this
portion yields before the pressure of the blood, and a sacculated
aneurysm results. The internal and middle coats being already damaged,
or, it may be, destroyed, by the primary disease, the stress falls on
the external coat, which in the majority of cases constitutes the sac.
To withstand the pressure the external coat becomes thickened, and as
the aneurysm increases in size it forms adhesions to surrounding
tissues, so that fasciae, tendons, nerves, and other structures may be
found matted together in its wall. The wall is further strengthened by
the deposit on its inner aspect of blood-clot, which may eventually
become organised.

The contents of the sac consist of fluid blood and a varying amount of
clot which is deposited in concentric layers on the inner aspect of the
sac, where it forms a pale, striated, firm mass, which constitutes a
laminated clot. Near the blood-current the clot is soft, red, and
friable (Fig. 72). The laminated clot not only strengthens the sac,
enabling it to resist the blood-pressure and so prevent rupture, but, if
it increases sufficiently to fill the cavity, may bring about cure. The
principle upon which all methods of treatment are based is to imitate
nature in producing such a clot.

Sacculated aneurysm, as compared with the fusiform variety, tends to
rupture and also to cure by the formation of laminated clot; natural
cure is sometimes all but complete when extension and rupture occur and
cause death.

An aneurysm is said to be _diffused_ when the sac ruptures and the blood
escapes into the cellular tissue.

#Clinical Features of Aneurysm.#--Surgically, the sacculated is by far
the most important variety. The outstanding feature is the existence in
the line of an artery of a globular swelling, which pulsates. The
pulsation is of an expansile character, which is detected by observing
that when both hands are placed over the swelling they are separated
with each beat of the heart. If the main artery be compressed on the
cardiac side of the swelling, the pulsation is arrested and the tumour
becomes smaller and less tense, and it may be still further reduced in
size by gentle pressure being made over it so as to empty it of fluid
blood. On allowing the blood again to flow through the artery, the
pulsation returns at once, but several beats are required before the sac
regains its former size. In most cases a distinct thrill is felt on
placing the hand over the swelling, and a blowing, systolic murmur may
be heard with the stethoscope. It is to be borne in mind that
occasionally, when the interchange of blood between an aneurysm and the
artery from which it arises is small, pulsation and bruit may be slight
or even absent. This is also the case when the sac contains a
considerable quantity of clot. When it becomes filled with
clot--_consolidated aneurysm_--these signs disappear, and the clinical
features are those of a solid tumour lying in contact with an artery,
and transmitting its pulsation.

A comparison of the pulse in the artery beyond the seat of the aneurysm
with that in the corresponding artery on the healthy side, shows that on
the affected side the wave is smaller in volume, and delayed in time. A
pulse tracing shows that the normal impulse and dicrotic waves are lost,
and that the force and rapidity of the tidal wave are diminished.

[Illustration: FIG. 71.--Radiogram of Aneurysm of Aorta, showing
laminated clot and erosion of bodies of vertebrae. The intervertebral
discs are intact.]

An aneurysm exerts pressure on the surrounding structures, which are
usually thickened and adherent to it and to one another. Adjacent veins
may be so compressed that congestion and oedema of the parts beyond are
produced. Pain, disturbances of sensation, and muscular paralyses may
result from pressure on nerves. Such bones as the sternum and vertebrae
undergo erosion and are absorbed by the gradually increasing pressure of
the aneurysm. Cartilage, on the other hand, being elastic, yields before
the pressure, so that the intervertebral discs or the costal cartilages
may escape while the adjacent bones are destroyed (Fig. 71). The skin
over the tumour becomes thinned and stretched, until finally a slough
forms, and when it separates haemorrhage takes place.

[Illustration: FIG. 72.--Sacculated Aneurysm of Abdominal Aorta nearly
filled with laminated clot. Note greater density of clot towards
periphery.]

In the progress of an aneurysm towards rupture, timely clotting may
avert death for the moment, but while extension in one direction has
been arrested there is apt to be extension in another, with imminence of
rupture, or it may be again postponed.

#Differential Diagnosis.#--The diagnosis is to be made from other
pulsatile swellings. Pulsation is sometimes transmitted from a large
artery to a tumour, a mass of enlarged lymph glands, or an inflammatory
swelling which lies in its vicinity, but the pulsation is not
expansile--a most important point in differential diagnosis. Such
swellings may, by appropriate manipulation, be moved from the artery and
the pulsation ceases, and compression of the artery on the cardiac side
of the swelling, although it arrests the pulsation, does not produce any
diminution in the size or tension of the swelling, and when the pressure
is removed the pulsation is restored immediately.

Fluid swellings overlying an artery, such as cysts, abscesses, or
enlarged bursae, may closely simulate aneurysm. An apparent expansion may
accompany the pulsation, but careful examination usually enables this to
be distinguished from the true expansion of an aneurysm. Compression of
the artery makes no difference in the size or tension of the swelling.

Vascular tumours, such as sarcoma and goitre, may yield an expansile
pulsation and a soft, whifling bruit, but they differ from an aneurysm
in that they are not diminished in size by compression of the main
artery, nor can they be emptied by pressure.

The exaggerated pulsation sometimes observed in the abdominal aorta, the
"pulsating aorta" seen in women, should not be mistaken for aneurysm.

#Prognosis.#--When _natural cure_ occurs it is usually brought about by
the formation of laminated clot, which gradually increases in amount
till it fills the sac. Sometimes a portion of the clot in the sac is
separated and becomes impacted as an embolus in the artery beyond,
leading to thrombosis which first occludes the artery and then extends
into the sac.

The progress of natural cure is indicated by the aneurysm becoming
smaller, firmer, less expansile, and less compressible; the murmur and
thrill diminish and the pressure effects become less marked. When the
cure is complete the expansile pulsation is lost, and there remains a
firm swelling attached to the vessel (_consolidated aneurysm_). While
these changes are taking place the collateral arteries become enlarged,
and an anastomotic circulation is established.

An aneurysm may prove _fatal_ by exerting pressure on important
structures, by causing syncope, by rupture, or from the occurrence of
suppuration. _Pressure_ symptoms are usually most serious from aneurysms
situated in the neck, thorax, or skull. Sudden fatal _syncope_ is not
infrequent in cases of aneurysm of the thoracic aorta.

_Rupture_ may take place through the skin, on a mucous or serous
surface, or into the cellular tissue. The first haemorrhage is often
slight and stops naturally, but it soon recurs, and is so profuse,
especially when the blood escapes externally, that it rapidly proves
fatal. When the bleeding takes place into the cellular tissue, the
aneurysm is said to become _diffused_, and the extravasated blood
spreads widely through the tissues, exerting great pressure on the
surrounding structures.

The _clinical features_ associated with rupture are sudden and severe
pain in the part, and the patient becomes pale, cold, and faint. If a
comparatively small escape of blood takes place into the tissues, the
sudden alteration in the size, shape, and tension of the aneurysm,
together with loss of pulsation, may be the only local signs. When the
bleeding is profuse, however, the parts beyond the aneurysm become
greatly swollen, livid, and cold, and the pulse beyond is completely
lost. The arrest of the blood supply may result in gangrene. Sometimes
the pressure of the extravasated blood causes the skin to slough and,
later, give way, and fatal haemorrhage results.

The _treatment_ is carried out on the same lines as for a ruptured
artery (p. 261), it being remembered, however, that the artery is
diseased and does not lend itself to reconstructive procedures.

_Suppuration_ may occur in the vicinity of an aneurysm, and the aneurysm
may burst into the abscess which forms, so that when the latter points
the pus is mixed with broken-down blood-clot, and finally free
haemorrhage takes place. It has more than once happened that a surgeon
has incised such an abscess without having recognised its association
with aneurysm, with tragic results.

#Treatment.#--In treating an aneurysm, the indications are to imitate
Nature's method of cure by means of laminated clot.

_Constitutional treatment_ consists in taking measures to reduce the
arterial tension and to diminish the force of the heart's action. The
patient must be kept in bed. A dry and non-stimulating diet is
indicated, the quantity being gradually reduced till it is just
sufficient to maintain nutrition. Saline purges are employed to reduce
the vascular tension. The benefit derived from potassium iodide
administered in full doses, as first recommended by George W. Balfour,
probably depends on its depressing action on the heart and its
therapeutic benefit in syphilis. Pain or restlessness may call for the
use of opiates, of which heroin is the most efficient.

_Local Treatment._--When constitutional treatment fails, local measures
must be adopted, and many methods are available.

#Endo-aneurysmorrhaphy.#--The operation devised by Rudolf Matas in 1888
aims at closing the opening between the sac and its feeding artery, and
in addition, folding the wall of the sac in such a way as to leave no
vacant space. If there is marked disease of the vessel, Matas' operation
is not possible and recourse is then had to ligation of the artery just
above the sac.

_Extirpation of the Sac--The Old Operation._--The procedure which goes
by this name consists in exposing the aneurysm, incising the sac,
clearing out the clots, and ligating the artery above and below the sac.
This method is suitable to sacculated aneurysm of the limbs, so long as
they are circumscribed and free from complications. It has been
successfully practised also in aneurysm of the subclavian, carotid, and
external iliac arteries. It is not applicable to cases in which there is
such a degree of atheroma as would interfere with the successful
ligation of the artery. The continuity of the artery may be restored by
grafting into the gap left after excision of the sac a segment of the
great saphena vein.

_Ligation of the Artery._--The object of tying the artery is to diminish
or to arrest the flow of blood through the aneurysm so that the blood
coagulates both in the sac and in the feeding artery. The ligature may
be applied on the cardiac side of the aneurysm--proximal ligation, or to
the artery beyond--distal ligation.

_Proximal Ligation._--The ligature may be applied immediately above the
sac (Anel, 1710) or at a distance above (John Hunter, 1785). The
_Hunterian operation_ ensures that the ligature is applied to a part of
the artery that is presumably healthy and where relations are
undisturbed by the proximity of the sac; the best example is the
ligation of the superficial femoral artery in Scarpa's triangle or in
Hunter's canal for popliteal aneurysm; it is on record that Syme
performed this operation with cure of the aneurysm on thirty-nine
occasions.

It is to be noted that the Hunterian ligature does not aim at
_arresting_ the flow of blood through the sac, but is designed so to
diminish its volume and force as to favour the deposition within the sac
of laminated clot. The development of the collateral circulation which
follows upon ligation of the artery at a distance above the sac may be
attended with just that amount of return stream which favours the
deposit of laminated clot, and consequently the cure of the aneurysm;
the return stream may, however, be so forcible as to prevent coagulation
of the blood in the sac, or only to allow of the formation of a red
thrombus which may in its turn be dispersed so that pulsation in the sac
recurs. This does not necessarily imply failure to cure, as the
recurrent pulsation may only be temporary; the formation of laminated
clot may ultimately take place and lead to consolidation of the
aneurysm.

The least desirable result of the Hunterian ligature is met with in
cases where, owing to widespread arterial disease, the collateral
circulation does not develop and gangrene of the limb supervenes.

_Anel's ligature_ is only practised as part of the operation which deals
with the sac directly.

_Distal Ligation._--The tying of the artery beyond the sac, or of its
two branches where it bifurcates (Brasdor, 1760, and Wardrop, 1825), may
arrest or only diminish the flow of blood through the sac. It is less
successful than the proximal ligature, and is therefore restricted to
aneurysms so situated as not to be amenable to other methods; for
example, in aneurysm of the common carotid near its origin, the artery
may be ligated near its bifurcation, or in aneurysm of the innominate
artery, the carotid and subclavian arteries are tied at the seat of
election.

_Compression._--Digital compression of the feeding artery has been given
up except as a preparation for operations on the sac with a view to
favouring the development of a collateral circulation.

_Macewen's acupuncture or "needling"_ consists in passing one or more
fine, highly tempered steel needles through the tissues overlying the
aneurysm, and through its outer wall. The needles are made to touch the
opposite wall of the sac, and the pulsation of the aneurysm imparts a
movement to them which causes them to scarify the inner surface of the
sac. White thrombus forms on the rough surface produced, and leads to
further coagulation. The needles may be left in position for some hours,
being shifted from time to time, the projecting ends being surrounded
with sterile gauze.

The _Moore-Corradi method_ consists in introducing through the wall of
the aneurysm a hollow insulated needle, through the lumen of which from
10 to 20 feet of highly drawn silver or other wire is passed into the
sac, where it coils up into an open meshwork (Fig. 73). The positive
pole of a galvanic battery is attached to the wire, and the negative
pole placed over the patient's back. A current, varying in strength from
20 to 70 milliamperes, is allowed to flow for about an hour. The hollow
needle is then withdrawn, but the wire is left _in situ_. The results
are somewhat similar to those obtained by needling, but the clot formed
on the large coil of wire is more extensive.

[Illustration: FIG. 73.--Radiogram of Innominate Aneurysm after
treatment by the Moore-Corradi method. Two feet of finely drawn silver
wire were introduced. The patient, a woman, aet. 47, lived for ten months
after operation, free from pain (cf. Fig. 75).]

Colt's method of wiring has been mainly used in the treatment of
abdominal aneurysm; gilt wire in the form of a wisp is introduced
through the cannula and expands into an umbrella shape.

_Subcutaneous Injections of Gelatin._--Three or four ounces of a 2 per
cent. solution of white gelatin in sterilised water, at a temperature of
about 100 o F., are injected into the subcutaneous tissue of the abdomen
every two, three, or four days. In the course of a fortnight or three
weeks improvement may begin. The clot which forms is liable to soften
and be absorbed, but a repetition of the injection has in several cases
established a permanent cure.

_Amputation of the limb_ is indicated in cases complicated by
suppuration, by secondary haemorrhage after excision or ligation, or by
gangrene. Amputation at the shoulder was performed by Fergusson in a
case of subclavian aneurysm, as a means of arresting the blood-flow
through the sac.


TRAUMATIC ANEURYSM

The essential feature of a traumatic aneurysm is that it is produced by
some form of injury which divides all the coats of the artery. The walls
of the injured vessel are presumably healthy, but they form no part of
the sac of the aneurysm. The sac consists of the condensed and thickened
tissues around the artery.

The injury to the artery may be a subcutaneous one such as a tear by a
fragment of bone: much more commonly it is a punctured wound from a stab
or from a bullet.

The aneurysm usually forms soon after the injury is inflicted; the blood
slowly escapes into the surrounding tissues, gradually displacing and
condensing them, until they form a sac enclosing the effused blood.

Less frequently a traumatic aneurysm forms some considerable time after
the injury, from gradual stretching of the fibrous cicatrix by which the
wound in the wall of the artery has been closed. The gradual stretching
of this cicatrix results in condensation of the surrounding structures
which form the sac, on the inner aspect of which laminated clot is
deposited.

A traumatic aneurysm is almost always sacculated, and, so long as it
remains circumscribed, has the same characters as a pathological
sacculated aneurysm, with the addition that there is a scar in the
overlying skin. A traumatic aneurysm is liable to become diffuse--a
change which, although attended with considerable risk of gangrene, has
sometimes been the means of bringing about a cure.

The treatment is governed by the same principles as apply to the
pathological varieties, but as the walls of the artery are not diseased,
operative measures dealing with the sac and the adjacent segment of the
affected artery are to be preferred.


ARTERIO-VENOUS ANEURYSM

An abnormal communication between an artery and a vein constitutes an
arterio-venous aneurysm. Two varieties are recognised--one in which the
communication is direct--_aneurysmal varix_; the other in which the
vein communicates with the artery through the medium of a sac--_varicose
aneurysm_.

Either variety may result from pathological causes, but in the majority
of cases they are traumatic in origin, being due to such injuries as
stabs, punctured wounds, and gun-shot injuries which involve both artery
and vein. In former times the most common situation was at the bend of
the elbow, the brachial artery being accidentally punctured in
blood-letting from the median basilic vein. Arterio-venous aneurysm is a
frequent result of injuries by modern high-velocity bullets--for
example, in the neck or groin.

In _aneurysmal varix_ the higher blood pressure in the artery forces
arterial blood into the vein, which near the point of communication with
the artery tends to become dilated, and to form a thick-walled sac,
beyond which the vessel and its tributaries are distended and tortuous.
The clinical features resemble those associated with varicose veins, but
the entrance of arterial blood into the dilated veins causes them to
pulsate, and produces in them a vibratory thrill and a loud murmur. In
those at the groin, the distension of the veins may be so great that
they look like sinuses running through the muscles, a feature that must
be taken into account in any operation.

As the condition tends to remain stationary, the support of an elastic
bandage is all that is required; but when the condition progresses and
causes serious inconvenience, it may be necessary to cut down and expose
the communication between the artery and vein, and, after separating the
vessels, to close the opening in each by suture; this may be difficult
or impossible if the parts are matted from former suppuration. If it is
impossible thus to obliterate the communication, the artery should be
ligated above and below the point of communication; although the risk of
gangrene is considerable unless means are taken to develop the
collateral circulation beforehand (Makins).

_Varicose aneurysm_ usually develops in relation to a traumatic
aneurysm, the sac becoming adherent to an adjacent vein, and ultimately
opening into it. In this way a communication between the artery and the
vein is established, and the clinical features are those of a
combination of aneurysm and aneurysmal varix.

As there is little tendency to spontaneous cure, and as the aneurysm is
liable to increase in size and finally to rupture, operative treatment
is usually called for. This is carried out on the same lines as for
aneurysmal varix, and at the same time incising the sac, turning out the
clots, and ligating any branches which open into the sac. If it can be
avoided, the vein should not be ligated.


ANEURYSMS OF INDIVIDUAL ARTERIES

#Thoracic Aneurysm.#--All varieties of aneurysm occur in the aorta, the
fusiform being the most common, although a sacculated aneurysm
frequently springs from a fusiform dilatation.

The _clinical features_ depend chiefly on the direction in which the
aneurysm enlarges, and are not always well marked even when the sac is
of considerable size. They consist in a pulsatile swelling--sometimes in
the supra-sternal notch, but usually towards the right side of the
sternum--with an increased area of dulness on percussion. With the
X-rays a dark shadow is seen corresponding to the sac. Pain is usually a
prominent symptom, and is largely referable to the pressure of the
aneurysm on the vertebrae or the sternum, causing erosion of these bones.
Pressure on the thoracic veins and on the air-passage causes cyanosis
and dyspnoea. When the oesophagus is pressed upon, the patient may have
difficulty in swallowing. The left recurrent nerve may be stretched or
pressed upon as it hooks round the arch of the aorta, and hoarseness of
the voice and a characteristic "brassy" cough may result from paralysis
of the muscles of the larynx which it supplies. The vagus, the phrenic,
and the spinal nerves may also be pressed upon. When the aneurysm is on
the transverse part of the arch, the trachea is pulled down with each
beat of the heart--a clinical phenomena known as the "tracheal tug."
Aneurysm of the descending aorta may, after eroding the bodies of the
vertebrae (Fig. 71) and posterior portions of the ribs, form a swelling
in the back to the left of the spine.

Inasmuch as obliteration of the sac and the feeding artery is out of the
question, surgical treatment is confined to causing coagulation of the
blood in an extension or pouching of the sac, which, making its way
through the parietes of the chest, threatens to rupture externally. This
may be achieved by Macewen's needles or by the introduction of wire into
the sac. We have had cases under observation in which the treatment
referred to has been followed by such an amount of improvement that the
patient has been able to resume a laborious occupation for one or more
years. Christopher Heath found that improvement followed ligation of the
left common carotid in aneurysm of the transverse part of the aortic
arch.

[Illustration: FIG. 74.--Thoracic Aneurysm, threatening to rupture
externally, but prevented from doing so by Macewen's needling. The
needles were left in for forty-eight hours.]

#Abdominal Aneurysm.#--Aneurysm is much less frequent in the abdominal
than in the thoracic aorta. While any of the large branches in the
abdomen may be affected, the most common seats are in the aorta itself,
just above the origin of the coeliac artery and at the bifurcation.

The _clinical features_ vary with the site of the aneurysm and with its
rapidity and direction of growth. A smooth, rounded swelling, which
exhibits expansile pulsation, forms, usually towards the left of the
middle line. It may extend upwards under cover of the ribs, downwards
towards the pelvis, or backward towards the loin. On palpation a
systolic thrill may be detected, but the presence of a murmur is neither
constant nor characteristic. Pain is usually present; it may be
neuralgic in character, or may simulate renal colic. When the aneurysm
presses on the vertebrae and erodes them, the symptoms simulate those of
spinal caries, particularly if, as sometimes happens, symptoms of
compression paraplegia ensue. In its growth the swelling may press upon
and displace the adjacent viscera, and so interfere with their
functions.

The _diagnosis_ has to be made from solid or cystic tumours overlying
the artery; from a "pulsating aorta"; and from spinal caries; much help
is obtained by the use of the X-rays.

The condition usually proves fatal, either by the aneurysm bursting into
the peritoneal cavity, or by slow leakage into the retro-peritoneal
tissue.

The Moore-Corradi method has been successfully employed, access to the
sac having been obtained by opening the abdomen. Ligation of the aorta
has so far been unsuccessful, but in one case operated upon by Keen the
patient survived forty-eight days.

#Innominate aneurysm# may be of the fusiform or of the sacculated
variety, and is frequently associated with pouching of the aorta. It
usually grows upwards and laterally, projecting above the sternum and
right clavicle, which may be eroded or displaced (Fig. 75). Symptoms of
pressure on the structures in the neck, similar to those produced by
aortic aneurysm, occur. The pulses in the right upper extremity and in
the right carotid and its branches are diminished and delayed. Pressure
on the right brachial plexus causes shooting pain down the arm and
muscular paresis on that side. Vaso-motor disturbances and contraction
of the pupil on the right side may result from pressure on the
sympathetic. Death may take place from rupture, or from pressure on the
air-passage.

[Illustration: FIG. 75.--Innominate Aneurysm in a woman, aet. 47, eight
months after treatment by Moore-Corradi method (cf. Fig. 73).]

The available methods of treatment are ligation of the right common
carotid and third part of the right subclavian (Wardrop's operation), of
which a number of successful cases have been recorded. Those most
suitable for ligation are cases in which the aneurysm is circumscribed
and globular (Sheen). If ligation is found to be impracticable, the
Moore-Corradi method or Macewen's needling may be tried.

#Carotid Aneurysms.#--Aneurysm of the _common carotid_ is more frequent
on the right than on the left side, and is usually situated either at
the root of the neck or near the bifurcation. It is the aneurysm most
frequently met with in women. From its position the swelling is liable
to press on the vagus, recurrent and sympathetic nerves, on the
air-passage, and on the oesophagus, giving rise to symptoms referable to
such pressure. There may be cerebral symptoms from interference with the
blood supply of the brain.

Aneurysm near the origin has to be diagnosed from subclavian,
innominate, and aortic aneurysm, and from other swellings--solid or
fluid--met with in the neck. It is often difficult to determine with
precision the trunk from which an aneurysm at the root of the neck
originates, and not infrequently more than one vessel shares in the
dilatation. A careful consideration of the position in which the
swelling first appeared, of the direction in which it has progressed, of
its pressure effects, and of the condition of the pulses beyond, may
help in distinguishing between aortic, innominate, carotid, and
subclavian aneurysms. Skiagraphy is also of assistance in recognising
the vessel involved.

Tumours of the thyreoid, enlarged lymph glands, and fatty and
sarcomatous tumours can usually be distinguished from aneurysm by the
history of the swelling and by physical examination. Cystic tumours and
abscesses in the neck are sometimes more difficult to differentiate on
account of the apparently expansile character of the pulsation
transmitted to them. The fact that compression of the vessel does not
affect the size and tension of these fluid swellings is useful in
distinguishing them from aneurysm.

_Treatment._--Digital compression of the vessel against the transverse
process of the sixth cervical vertebra--the "carotid tubercle"--has been
successfully employed in the treatment of aneurysm near the bifurcation.
Proximal ligation in the case of high aneurysms, or distal ligation in
those situated at the root of the neck, is more certain. Extirpation of
the sac is probably the best method of treatment, especially in those of
traumatic origin. These operations are attended with considerable risk
of hemiplegia from interference with the blood supply of the brain.

The _external carotid_ and the cervical portion of the _internal
carotid_ are seldom the primary seat of aneurysm, although they are
liable to be implicated by the upward spread of an aneurysm at the
bifurcation of the common trunk. In addition to the ordinary signs of
aneurysm, the clinical manifestations are chiefly referable to pressure
on the pharynx and larynx, and on the hypoglossal nerve. Aneurysm of the
internal carotid is of special importance on account of the way in which
it bulges into the pharynx in the region of the tonsil, in some cases
closely simulating a tonsillar abscess. Cases are on record in which
such an aneurysm has been mistaken for an abscess and incised, with
disastrous results.

_Aneurysmal varix_ may occur in the neck as a result of stabs or bullet
wounds. The communication is usually between the common carotid artery
and the internal jugular vein. The resulting interference with the
cerebral circulation causes headache, giddiness, and other brain
symptoms, and a persistent loud murmur is usually a source of annoyance
to the patient and may be sufficient indication for operative treatment.

#Intracranial aneurysm# involves the internal carotid and its branches,
or the basilar artery, and appears to be more frequently associated with
syphilis and with valvular disease of the heart than are external
aneurysms. It gives rise to symptoms similar to those of other
intracranial tumours, and there is sometimes a loud murmur. It usually
proves fatal by rupture, and intracranial haemorrhage. The treatment is
to ligate the common carotid or the vertebral artery in the neck,
according to the seat of the aneurysm.

#Orbital Aneurysm.#--The term pulsating exophthalmos is employed to
embrace a number of pathological conditions, including aneurysm, in
which the chief symptoms are pulsation in the orbit and protrusion of
the eyeball. There may be, in addition, congestion and oedema of the
eyelids, and a distinct thrill and murmur, which can be controlled by
compression of the common carotid in the neck. Varying degrees of ocular
paralysis and of interference with vision may also be present.

These symptoms are due, in the majority of cases, to an aneurysmal varix
of the internal carotid artery and cavernous sinus, which is often
traumatic in origin, being produced either by fracture of the base of
the skull or by a punctured wound of the orbit. In other cases they are
due to aneurysm of the ophthalmic artery, to thrombosis of the cavernous
sinus, and, in rare instances, to cirsoid aneurysm.

If compression of the common carotid is found to arrest the pulsation,
ligation of this vessel is indicated.

#Subclavian Aneurysm.#--Subclavian aneurysm is usually met with in men
who follow occupations involving constant use of the shoulder--for
example, dock-porters and coal-heavers. It is more common on the right
side.

The aneurysm usually springs from the third part of the artery, and
appears as a tense, rounded, pulsatile swelling just above the clavicle
and to the outer side of the sterno-mastoid muscle. It occasionally
extends towards the thorax, where it may become adherent to the pleura.
The radial pulse on the same side is small and delayed. Congestion and
oedema of the arm, with pain, numbness, and muscular weakness, may result
from pressure on the veins and nerves as they pass under the clavicle;
and pressure on the phrenic nerve may induce hiccough. The aneurysm is
of slow growth, and occasionally undergoes spontaneous cure.

The conditions most likely to be mistaken for it are a soft, rapidly
growing sarcoma, and a normal artery raised on a cervical rib.

On account of the relations of the artery and of its branches, treatment
is attended with greater difficulty and danger in subclavian than in
almost any other form of external aneurysm. The available operative
measures are proximal ligation of the innominate, and distal ligation.
In some cases it has been found necessary to combine distal ligation
with amputation at the shoulder-joint, to prevent the collateral
circulation maintaining the flow through the aneurysm. Matas' operation
has been successfully performed by Hogarth Pringle.

#Axillary Aneurysm.#--This is usually met with in the right arm of
labouring men and sailors, and not infrequently follows an injury in the
region of the shoulder. The vessel may be damaged by the head of a
dislocated humerus or in attempts to reduce the dislocation, by the
fragments of a fractured bone, or by a stab or cut. Sometimes the vein
also is injured and an arterio-venous aneurysm established.

Owing to the laxity of the tissues, it increases rapidly, and it may
soon attain a large size, filling up the axilla, and displacing the
clavicle upwards. This renders compression of the third part of the
subclavian difficult or impossible. It may extend beneath the clavicle
into the neck, or, extending inwards may form adhesions to the chest
wall, and, after eroding the ribs, to the pleura.

The usual symptoms of aneurysm are present, and the pressure effects on
the veins and nerves are similar to those produced by an aneurysm of the
subclavian. Intra-thoracic complications, such as pleurisy or pneumonia,
are not infrequent when there are adhesions to the chest wall and
pleura. Rupture may take place externally, into the shoulder-joint, or
into the pleura.

Extirpation of the sac is the operation of choice, but, if this is
impracticable, ligation of the third part of the subclavian may be had
recourse to.

#Brachial aneurysm# usually occurs at the bend of the elbow, is of
traumatic origin, and is best treated by excision of the sac.

_Aneurysmal varix_, which was frequently met with in this situation in
the days of the barber-surgeons,--usually as a result of the artery
having been accidentally wounded while performing venesection of the
median basilic vein,--may be treated, according to the amount of
discomfort it causes, by a supporting bandage, or by ligation of the
artery above and below the point of communication.

Aneurysms of the vessels of the #forearm and hand# call for no special
mention; they are almost invariably traumatic, and are treated by
excision of the sac.

#Inguinal Aneurysm# (_Aneurysm of the Iliac and Femoral
Arteries_).--Aneurysms appearing in the region of Poupart's ligament may
have their origin in the external or common iliac arteries or in the
upper part of the femoral. On account of the tension of the fascia lata,
they tend to spread upwards towards the abdomen, and, to a less extent,
downwards into the thigh. Sometimes a constriction occurs across the
sac at the level of Poupart's ligament.

The pressure exerted on the nerves and veins of the lower extremity
causes pain, congestion, and oedema of the limb. Rupture may take place
externally, or into the cellular tissue of the iliac fossa.

These aneurysms have to be diagnosed from pulsating sarcoma growing from
the pelvic bones, and from an abscess or a mass of enlarged lymph glands
overlying the artery and transmitting its pulsation.

The method of treatment that has met with most success is ligation of
the common or external iliac, reached either by reflecting the
peritoneum from off the iliac fossa (extra-peritoneal operation), or by
going through the peritoneal cavity (trans-peritoneal operation).

#Gluteal Aneurysm.#--An aneurysm in the buttock may arise from the
superior or from the inferior gluteal artery, but by the time it forms a
salient swelling it is seldom possible to recognise by external
examination in which vessel it takes origin. The special symptoms to
which it gives rise are pain down the limb from pressure on the sciatic
nerve, and interference with the movements at the hip.

Ligation of the hypogastric (internal iliac) by the trans-peritoneal
route is the most satisfactory method of treatment. Extirpation of the
sac is difficult and dangerous, especially when the aneurysm has spread
into the pelvis.

#Femoral Aneurysm.#--Aneurysm of the femoral artery beyond the origin of
the profunda branch is usually traumatic in origin, and is more common
in Scarpa's triangle than in Hunter's canal. Any of the methods already
described is available for their treatment--the choice lying between
Matas' operation and ligation of the external iliac.

Aneurysm of the _profunda femoris_ is distinguished from that of the
main trunk by the fact that the pulses beyond are, in the former,
unaffected, and by the normal artery being felt pulsating over or
alongside the sac.

In _aneurysmal varix_, a not infrequent result of a bullet wound or a
stab, the communication with the vein may involve the main trunk of the
femoral artery. Should operative interference become necessary as a
result of progressive increase in size of the tumour, or progressive
distension of the veins of the limb, an attempt should be made to
separate the vessels concerned and to close the opening in each by
suture. If this is impracticable, the artery is tied above and below the
communication; gangrene of the limb may supervene, and we have observed
a case in which the gangrene extended up to the junction of the middle
and lower thirds of the thigh, and in which recovery followed upon
amputation of the thigh.

#Popliteal Aneurysm.#--This is the most common surgical aneurysm, and is
not infrequently met with in both limbs. It is generally due to disease
of the artery, and repeated slight strains, which are so liable to occur
at the knee, play an important part in its formation. In former times it
was common in post-boys, from the repeated flexion and extension of the
knee in riding.

The aneurysm is usually of the sacculated variety, and may spring from
the front or from the back of the vessel. It may exert pressure on the
bones and ligaments of the joint, and it has been known to rupture into
the articulation. The pain, stiffness, and effusion into the joint which
accompany these changes often lead to an erroneous diagnosis of joint
disease. The sac may press upon the popliteal artery or vein and their
branches, causing congestion and oedema of the leg, and lead to gangrene.
Pressure on the tibial and common peroneal nerves gives rise to severe
pain, muscular cramp, and weakness of the leg.

The differential diagnosis is to be made from abscess, bursal cyst,
enlarged glands, and sarcoma, especially pulsating sarcoma of one of the
bones entering into the knee joint.

The choice of operation lies between ligation of the femoral artery in
Hunter's canal, and Matas' operation of aneurysmo-arteriorrhaphy. The
success which attends the Hunterian operation is evidenced by the fact
that Syme performed it thirty-seven times without a single failure. If
it fails, the old operation should be considered, but it is a more
serious operation, and one which is more liable to be followed by
gangrene of the limb. Experience shows that ligation of the vein, or
even the removal of a portion of it, is not necessarily followed by
gangrene. The risk of gangrene is diminished by a course of digital
compression of the femoral artery, before operating on the aneurysm.

_Aneurysmal varix_ is sometimes met with in the region of the popliteal
space. It is characterised by the usual symptoms, and is treated by
palliative measures, or by ligation of the artery above and below the
point of communication.

_Aneurysm_ in the #leg and foot# is rare. It is almost always traumatic,
and is treated by excision of the sac.




CHAPTER XV

THE LYMPH VESSELS AND GLANDS


Anatomy and Physiology--INJURIES OF LYMPH VESSELS--_Wounds of
    thoracic duct_--DISEASES OF LYMPH VESSELS--Lymphangitis:
    _Varieties_--Lymphangiectasis--Filarial
    disease--Lymphangioma--DISEASES OF LYMPH
    GLANDS--Lymphadenitis: _Septic_; _Tuberculous_;
    _Syphilitic_--Lymphadenoma--Leucocythaemia--TUMOURS.

#Surgical Anatomy and Physiology.#--Lymph is essentially blood plasma,
which has passed through the walls of capillaries. After bathing
and nourishing the tissues, it is collected by lymph vessels, which
return it to the blood stream by way of the thoracic duct. These lymph
vessels take origin in the lymph spaces of the tissues and in the
walls of serous cavities, and they usually run alongside blood
vessels--_perivascular lymph vessels_. They have a structure similar to
that of veins, but are more abundantly provided with valves. Along the
course of the lymph trunks are the _lymph glands_, which possess a
definite capsule and are composed of a reticulated connective tissue,
the spaces of which are packed with leucocytes. The glands act as
filters, arresting not only inert substances, such as blood pigment
circulating in the lymph, but also living elements, such as cancer cells
or bacteria. As it passes through a gland the lymph is brought into
intimate contact with the leucocytes, and in bacterial infections there
is always a struggle between the organisms and the leucocytes, so that
the glands may be looked upon as an important line of defence, retarding
or preventing the passage of bacteria and their products into the
general circulation. The infective agent, moreover, in order to reach
the blood stream, must usually overcome the resistance of several
glands.

Lymph glands are, for the most part, arranged in groups or chains, such
as those in the axilla, neck, and groin. In any given situation they
vary in number and size in different individuals, and fresh glands may
be formed on comparatively slight stimulus, and disappear when the
stimulus is withdrawn. The best-known example of this is the increase in
the number of glands in the axilla which takes place during lactation;
when this function ceases, many of the glands become involuted and are
transformed into fat, and in the event of a subsequent lactation they
are again developed. After glands have been removed by operation, new
ones may be formed.

The following are the more important groups of glands, and the areas
drained by them in the head and neck and in the extremities.

#Head and Neck.#--_The anterior auricular (parotid and pre-auricular)
glands_ lie beneath the parotid fascia in front of the ear, and some
are partly embedded in the substance of the parotid gland; they drain
the parts about the temple, cheek, eyelids, and auricle, and are
frequently the seat of tuberculous disease. _The occipital gland_,
situated over the origin of the trapezius from the superior curved line,
drains the top and back of the head; it is rarely infected. _The
posterior auricular (mastoid) glands_ lie over the mastoid process, and
drain the side of the head and auricle. These three groups pour their
lymph into the superficial cervical glands. _The submaxillary_--two to
six in number--lie along the lower order of the mandible from the
symphysis to the angle, the posterior ones (paramandibular) being
closely connected with the submaxillary salivary gland. They receive
lymph from the face, lips, floor of the mouth, gums, teeth, anterior
part of tongue, and the alae nasi, and from the pre-auricular glands. The
lymph passes from them into the deeper cervical glands. They are
frequently infected with tubercle, with epithelioma which has spread to
them from the mouth, and also with pyogenic organisms. _The submental
glands_ lie in or close to the median line between the anterior bellies
of the digastric muscles, and receive lymph from the lips. It is rare
for them to be the seat of tubercle, but in epithelioma of the lower lip
and floor of the mouth they are infected at an early stage of the
disease. _The supra-hyoid gland_ lies a little farther back, immediately
above the hyoid bone, and receives lymph from the tongue. _The
superficial cervical (external jugular) glands_, when present, lie along
the external jugular vein, and receives lymph from the occipital and
auricular glands and from the auricle. _The sterno-mastoid
glands_--glandulae concatinatae--form a chain along the posterior edge of
the sterno-mastoid muscle, some of them lying beneath the muscle. They
are commonly enlarged in secondary syphilis. _The superior deep cervical
(internal jugular) glands_--from six to twenty in number--form a
continuous chain along the internal jugular vein, beneath the
sterno-mastoid muscle. They drain the various groups of glands which lie
nearer the surface, also the interior of the skull, the larynx, trachea,
thyreoid, and lower part of the pharynx, and pour their lymph into the
main trunks at the root of the neck. Belonging to this group is one
large gland (the tonsillar gland) which lies behind the posterior belly
of the digastric, and rests in the angle between the internal jugular
and common facial veins. It is commonly enlarged in affections of the
tonsil and posterior part of the tongue. In the same group are three or
four glands which lie entirely under cover of the upper end of the
sterno-mastoid muscle, and surround the accessory nerve before it
perforates the muscle. The deep cervical glands are commonly infected by
tubercle and also by epithelioma secondary to disease in the tongue or
throat. _The inferior deep cervical (supra-clavicular) glands_ lie in
the posterior triangle, above the clavicle. They receive lymph from the
lowest cervical glands, from the upper part of the chest wall, and from
the highest axillary glands. They are frequently infected in cancer of
the breast; those on the left side also in cancer of the stomach. The
removal of diseased supra-clavicular glands is not to be lightly
undertaken, as difficulties are liable to ensue in connection with the
thoracic duct, the pleura, or the junction of the subclavian and
internal jugular veins. _The retro-pharyngeal glands_ lie on each side
of the median line upon the rectus capitis anticus major muscle and in
front of the pre-vertebral layer of the cervical fascia. They receive
part of the lymph from the posterior wall of the pharynx, the interior
of the nose and its accessory cavities, the auditory (Eustachian) tube,
and the tympanum. When they are infected with pyogenic organisms or
with tubercle bacilli, they may lead to the formation of one form of
retro-pharyngeal abscess.

#Upper Extremity.#--_The epi-trochlear and cubital glands_ vary in
number, that most commonly present lying about an inch and a half above
the medial epi-condyle, and other and smaller glands may lie along the
medial (internal) bicipital groove or at the bend of the elbow. They
drain the ulnar side of the hand and forearm, and pour their lymph into
the axillary group. The epi-trochlear gland is sometimes enlarged in
syphilis. _The axillary glands_ are arranged in groups: a central group
lies embedded in the axillary fascia and fat, and is often related to an
opening in it; a posterior or subscapular group lies along the line of
the subscapular vessels; anterior or pectoral groups lie behind the
pectoralis minor, along the medial side of the axillary vein, and an
inter-pectoral group, between the two pectoral muscles. The axillary
glands receive lymph from the arm, mamma, and side of the chest, and
pass it on into the lowest cervical glands and the main lymph trunk.
They are frequently the seat of pyogenic, tuberculous, and cancerous
infection, and their complete removal is an essential part of the
operation for cancer of the breast.

#Lower Extremity.#--_The popliteal glands_ include one superficial gland
at the termination of the small saphenous vein, and several deeper ones
in relation to the popliteal vessels. They receive lymph from the toes
and foot, and transmit it to the inguinal glands. _The femoral glands_
lie vertically along the upper part of the great saphenous vein, and
receive lymph from the leg and foot; from them the lymph passes to the
deep inguinal and external iliac glands. The femoral glands often
participate in pyogenic infections entering through the skin of the toes
and sole of the foot. _The superficial inguinal glands_ lie along the
inguinal (Poupart's) ligament, and receive lymph from the external
genitals, anus, perineum, buttock, and anterior abdominal wall. The
lymph passes on to the deep inguinal and external iliac glands. The
superficial glands through their relations to the genitals are
frequently the subject of venereal infection, and also of epithelioma
when this disease affects the genitals or anus; they are rarely the seat
of tuberculosis. _The deep inguinal glands_ lie on the medial side of
the femoral vein, and sometimes within the femoral canal. They receive
lymph from the deep lymphatics of the lower limb, and some of the
efferent vessels from the femoral and superficial inguinal glands. The
lymph then passes on through the femoral canal to the external iliac
glands. The extension of malignant disease, whether cancer or sarcoma,
can often be traced along these deeper lymphatics into the pelvis, and
as the obstruction to the flow of lymph increases there is a
corresponding increase in the swollen dropsical condition of the lower
limb on the same side.

The glands of the _thorax_ and _abdomen_ will be considered with the
surgery of these regions.


INJURIES OF LYMPH VESSELS

Lymph vessels are divided in all wounds, and the lymph that escapes from
them is added to any discharge that may be present. In injuries of
larger trunks the lymph may escape in considerable quantity as a
colourless, watery fluid--_lymphorrhagia_; and the opening through which
it escapes is known as a _lymphatic fistula_. This has been observed
chiefly after extensive operation for the removal of malignant glands in
the groin where there already exists a considerable degree of
obstruction to the lymph stream, and in such cases the lymph, including
that which has accumulated in the vessels of the limb, may escape in
such abundance as to soak through large dressings and delay healing.
Ultimately new lymph channels are formed, so that at the end of from
four to six weeks the discharge of lymph ceases and the wound heals.

_Lymphatic Oedema._--When the lymphatic return from a limb has been
seriously interfered with,--as, for example, when the axillary contents
has been completely cleared out in operating for cancer of the
breast,--a condition of lymphatic oedema may result, the arm becoming
swollen, tight, and heavy.

Various degrees of the conditions are met with; in the severe forms,
there is pain, as well as incapacity of the limb. As in ordinary oedema,
the condition is relieved by elevation of the limb, but not nearly to
the same degree; in time the tissues become so hard and tense as
scarcely to pit on pressure; this is in part due to the formation of new
connective tissue and hypertrophy of the skin; in advanced cases there
is a gradual transition into one form of elephantiasis.

Handley has devised a method of treatment--_lymphangioplasty_--the
object of which is to drain the lymph by embedding a number of silk
threads in the subcutaneous cellular tissue.

#Wounds of the Thoracic Duct.#--The thoracic duct usually opens at the
angle formed by the junction of the left internal jugular and subclavian
veins, but it may open into either of these vessels by one or by several
channels, or the duct may be double throughout its course. There is a
smaller duct on the right side--the right lymphatic duct. The duct or
ducts may be displaced by a tumour or a mass of enlarged glands, and may
be accidentally wounded in dissections at the root of the neck; jets of
milky fluid--chyle--may at once escape from it. The jets are rhythmical
and coincide with expiration. The injury may, however, not be observed
at the time of operation, but later through the dressings being soaked
with chyle--_chylorrhoea_. If the wound involves the only existing main
duct and all the chyle escapes, the patient suffers from intense thirst,
emaciation, and weakness, and may die of inanition; but if, as is
usually the case, only one of several collateral channels is implicated,
the loss of chyle may be of little moment, as the discharge usually
ceases. If the wound heals so that the chyle is prevented from escaping,
a fluctuating swelling may form beneath the scar; in course of time it
gradually disappears.

An attempt should be made to close the wound in the duct by means of a
fine suture; failing this, the duct must be occluded by a ligature as if
it were a bleeding artery. The tissues are then stitched over it and the
skin wound accurately closed, so as to obtain primary union, firm
pressure being applied by dressings and an elastic webbing bandage. Even
if the main duct is obliterated, a collateral circulation is usually
established. A wound of the right lymphatic duct is of less importance.

_Subcutaneous rupture of the thoracic duct_ may result from a crush of
the thorax. The chyle escapes and accumulates in the cellular tissue of
the posterior mediastinum, behind the peritoneum, in the pleural cavity
(_chylo-thorax_), or in the peritoneal cavity (_chylous ascites_). There
are physical signs of fluid in one or other of these situations, but, as
a rule, the nature of the lesion is only recognised when chyle is
withdrawn by the exploring needle.


DISEASES OF LYMPH VESSELS

#Lymphangitis.#--Inflammation of peripheral lymph vessels usually
results from some primary source of pyogenic infection in the skin. This
may be a wound or a purulent blister, and the streptococcus pyogenes is
the organism most frequently present. _Septic_ lymphangitis is commonly
met with in those who, from the nature of their occupation, handle
infective material. A _gonococcal_ form has been observed in those
suffering from gonorrhoea.

The inflammation affects chiefly the walls of the vessels, and is
attended with clotting of the lymph. There is also some degree of
inflammation of the surrounding cellular tissue--_peri-lymphangitis_.
One or more abscesses may form along the course of the vessels, or a
spreading cellulitis may supervene.

The _clinical features_ resemble those of other pyogenic infections, and
there are wavy red lines running from the source of infection towards
the nearest lymph glands. These correspond to the inflamed vessels, and
are the seat of burning pain and tenderness. The associated glands are
enlarged and painful. In severe cases the symptoms merge into those of
septicaemia. When the deep lymph vessels alone are involved, the
superficial red lines are absent, but the limb becomes greatly swollen
and pits on pressure.

In cases of extensive lymphangitis, especially when there are repeated
attacks, the vessels are obliterated by the formation of new connective
tissue and a persistent solid oedema results, culminating in one form of
elephantiasis.

_Treatment._--The primary source of infection is dealt with on the usual
lines. If the lymphangitis affects an extremity, Bier's elastic bandage
is applied, and if suppuration occurs, the pus is let out through one or
more small incisions; in other parts of the body Klapp's suction bells
are employed. An autogenous vaccine may be prepared and injected. When
the condition has subsided, the limb is massaged and evenly bandaged to
promote the disappearance of oedema.

_Tuberculous Lymphangitis._--Although lymph vessels play an important
role in the spread of tuberculosis, the clinical recognition of the
disease in them is exceptional. The infection spreads upwards along the
superficial lymphatics, which become nodularly thickened; at one or more
points, larger, peri-lymphangitic nodules may form and break down into
abscesses and ulcers; the nearest group of glands become infected at an
early stage. When the disease is widely distributed throughout the
lymphatics of the limb, it becomes swollen and hard--a condition
illustrated by lupus elephantiasis.

_Syphilitic lymphangitis_ is observed in cases of primary syphilis, in
which the vessels of the dorsum of the penis can be felt as indurated
cords.

In addition to acting as channels for the conveyance of bacterial
infection, _lymph vessels frequently convey the cells of malignant
tumours_, and especially cancer, from the seat of the primary disease to
the nearest lymph glands, and they may themselves become the seat of
cancerous growth forming nodular cords. The permeation of cancer by way
of the lymphatics, described by Sampson Handley, has already been
referred to.

#Lymphangiectasis# is a dilated or varicose condition of lymph vessels.
It is met with as a congenital affection in the tongue and lips, or it
may be acquired as the result of any condition which is attended with
extensive obliteration or blocking of the main lymph trunks. An
interesting type of lymphangiectasis is that which results from the
presence of the _filaria Bancrofti_ in the vessels, and is observed
chiefly in the groin, spermatic cord, and scrotum of persons who have
lived in the tropics.

_Filarial disease in the lymphatics of the groin_ appears as a soft,
doughy swelling, varying in size from a walnut to a cocoa-nut; it may
partly disappear on pressure and when the patient lies down.

The patient gives a history of feverish attacks of the nature of
lymphangitis during which the swelling becomes painful and tender. These
attacks may show a remarkable periodicity, and each may be followed by
an increase in the size of the swelling, which may extend along the
inguinal canal into the abdomen, or down the spermatic cord into the
scrotum. On dissection, the swelling is found to be made up of dilated,
tortuous, and thickened lymph vessels in which the parent worm is
sometimes found, and of greatly enlarged lymph glands which have
undergone fibrosis, with giant-cell formation and eosinophile
aggregations. The fluid in the dilated vessels is either clear or
turbid, in the latter case resembling chyle. The affection is frequently
bilateral, and may be associated with lymph scrotum, with elephantiasis,
and with chyluria.

The _diagnosis_ is to be made from such other swellings in the groin as
hernia, lipoma, or cystic pouching of the great saphenous vein. It is
confirmed by finding the recently dead or dying worms in the inflamed
lymph glands.

_Treatment._--When the disease is limited to the groin or scrotum,
excision may bring about a permanent cure, but it may result in the
formation of lymphatic sinuses and only afford temporary relief.

#Lymphangioma.#--A lymphangioma is a swelling composed of a series of
cavities and channels filled with lymph and freely communicating with
one another. The cavities result either from the new formation of lymph
spaces or vessels, or from the dilatation of those which already exist;
their walls are composed of fibro-areolar tissue lined by endothelium
and strengthened by non-striped muscle. They are rarely provided with a
definite capsule, and frequently send prolongations of their substance
between and into muscles and other structures in their vicinity. They
are of congenital origin and usually make their appearance at or shortly
after birth. When the tumour is made up of a meshwork of caverns and
channels, it is called a _cavernous lymphangioma_; when it is composed
of one or more cysts, it is called a _cystic lymphangioma_. It is
probable that the cysts are derived from the caverns by breaking down
and absorption of the intervening septa, as transition forms between the
cavernous and cystic varieties are sometimes met with.

The _cavernous lymphangioma_ appears as an ill-defined, soft swelling,
presenting many of the characters of a subcutaneous haemangioma, but it
is not capable of being emptied by pressure, it does not become tense
when the blood pressure is raised, as in crying, and if the tumour is
punctured, it yields lymph instead of blood. It also resembles a lipoma,
especially the congenital variety which grows from the periosteum, and
the differential diagnosis between these is rarely completed until the
swelling is punctured or explored by operation. If treatment is called
for, it is carried out on the same lines as for haemangioma, by means of
electrolysis, igni-puncture, or excision. Complete excision is rarely
possible because of the want of definition and encapsulation, but it is
not necessary for cure, as the parts that remain undergo cicatrisation.

[Illustration: FIG. 76.--Congenital Cystic Tumour or Hygroma of Axilla.

(From a photograph lent by Dr. Lediard.)]

The _cystic lymphangioma_, _lymphatic cyst_, or _congenital cystic
hygroma_ is most often met with in the neck--_hydrocele of the neck_; it
is situated beneath the deep fascia, and projects either in front of or
behind the sterno-mastoid muscle. It may attain a large size, the
overlying skin and cyst wall may be so thin as to be translucent, and it
has been known to cause serious impairment of respiration through
pressing on the trachea. In the axilla also the cystic tumour may attain
a considerable size (Fig. 76); less frequent situations are the groin,
and the floor of the mouth, where it constitutes one form of ranula.

The nature of these swellings is to be recognised by their situation, by
their having existed from infancy, and, if necessary, by drawing off
some of the contents of the cyst through a fine needle. They are usually
remarkably indolent, persisting often for a long term of years without
change, and, like the haemangioma, they sometimes undergo spontaneous
cicatrisation and cure. Sometimes the cystic tumour becomes infected and
forms an abscess--another, although less desirable, method of cure.
Those situated in the neck are most liable to suppurate, probably
because of pyogenic organisms being brought to them by the lymphatics
taking origin in the scalp, ear, or throat.

If operative interference is called for, the cysts may be tapped and
injected with iodine, or excised; the operation for removal may entail a
considerable dissection amongst the deeper structures at the root of the
neck, and should not be lightly undertaken; parts left behind may be
induced to cicatrise by inserting a tube of radium and leaving it for a
few days.

Lymphangiomas are met with in the abdomen in the form of _omental
cysts_.


DISEASES OF LYMPH GLANDS

#Lymphadenitis.#--Inflammation of lymph glands results from the advent
of an irritant, usually bacterial or toxic, brought to the glands by the
afferent lymph vessels. These vessels may share in the inflammation and
be the seat of lymphangitis, or they may show no evidence of the passage
of the noxa. It is exceptional for the irritant to reach the gland
through the blood-stream.

A strain or other form of trauma is sometimes blamed for the onset of
lymphadenitis, especially in the glands of the groin (bubo), but it is
usually possible to discover some source of pyogenic infection which is
responsible for the mischief, or to obtain a history of some antecedent
infection such as gonorrhoea. It is possible for gonococci to lie latent
in the inguinal glands for long periods, and only give rise to
lymphadenitis if the glands be subsequently subjected to injury. The
glands most frequently affected are those in the neck, axilla, and
groin.

The characters of the lymphadenitis vary with the nature of the
irritant. Sometimes it is mild and evanescent, as in the glandular
enlargement in the neck which attends tonsillitis and other forms of
sore throat. Sometimes it is more persistent, as in the enlargement
that is associated with adenoids, hypertrophied tonsils, carious teeth,
eczema of the scalp, and otorrhoea; and it is possible that this indolent
enlargement predisposes to tuberculous infection. A similar enlargement
is met with in the axilla in cases of chronic interstitial mastitis, and
in the groin as a result of chronic irritation about the external
genitals, such as balanitis.

Sometimes the lymphadenitis is of an acute character, and the tendency
is towards the formation of an abscess. This is illustrated in the
axillary glands as a result of infected wounds of the fingers; in the
femoral glands in infected wounds or purulent blisters on the foot; in
the inguinal glands in gonorrhoea and soft sore; and in the cervical
glands in the severer forms of sore throat associated with diphtheria
and scarlet fever. The most acute suppurations result from infection
with streptococci.

Superficial glands, when inflamed and suppurating, become enlarged,
tender, fixed, and matted to one another. In the glands of the groin the
suppurative process is often remarkably sluggish; purulent foci form in
the interior of individual glands, and some time may elapse before the
pus erupts through their respective capsules. In the deeply placed
cervical glands, especially in cases of streptococcal throat infections,
the suppuration rapidly involves the surrounding cellular tissue, and
the clinical features are those of an acute cellulitis and deeply seated
abscess. When this is incised the necrosed glands may be found lying in
the pus, and on bacteriological examination are found to be swarming
with streptococci. In suppuration of the axillary glands the abscess may
be quite superficial, or it may be deeply placed beneath the strong
fascia and pectoral muscles, according to the group of glands involved.

The _diagnosis_ of septic lymphadenitis is usually easy. The indolent
enlargements are not always to be distinguished, however, from
commencing tuberculous disease, except by the use of the tuberculin
test, and by the fact that they usually disappear on removing the
peripheral source of irritation.

_Treatment._--The first indication is to discover and deal with the
source of infection, and in the indolent forms of lymphadenitis this
will usually be followed by recovery. In the acute forms following on
pyogenic infection, the best results are obtained from the hyperaemic
treatment carried out by means of suction bells. If suppuration is not
thereby prevented, or if it has already taken place, each separate
collection of pus is punctured with a narrow-bladed knife and the use of
the suction bell is persevered with. If there is a large periglandular
abscess, as is often the case, in the neck and axilla, the opening may
require to be made by Hilton's method, and it may be necessary to insert
a drainage-tube.

[Illustration: FIG. 77.--Tuberculous Cervical Gland with abscess
formation in subcutaneous cellular tissue, in a boy aet. 10.]

#Tuberculous Disease of Glands.#--This is a disease of great frequency
and importance. The tubercle bacilli usually gain access to the gland
through the afferent lymph vessels, which convey them from some lesion
of the surface within the area drained by them. Tuberculous infection
may supervene in glands that are already enlarged as a result of chronic
septic irritation. While any of the glands in the body may be affected,
the disease is most often met with in the cervical groups which derive
their lymph from the mouth, nose, throat, and ear.

_The appearance of the glands on section_ varies with the stage of the
disease. In the early stages the gland is enlarged, it may be to many
times its natural size, is normal in appearance and consistence, and as
there is no peri-adenitis it is easily shelled out from its
surroundings. On microscopical examination, however, there is evidence
of infection in the shape of bacilli and of characteristic giant and
epithelioid cells. At a later stage, the gland tissue is studded with
minute yellow foci which tend to enlarge and in time to become
confluent, so that the whole gland is ultimately converted into a
caseous mass. This caseous material is surrounded by the thickened
capsule which, as a result of peri-adenitis, tends to become adherent to
and fused with surrounding structures, and particularly with layers of
fascia and with the walls of veins. The caseated tissue often remains
unchanged for long periods; it may become calcified, but more frequently
it breaks down and liquefies.

#Tuberculous disease in the cervical glands# is a common accompaniment
or sequel of adenoids, enlarged tonsils, carious teeth, pharyngitis,
middle-ear disease, and conjunctivitis. These lesions afford the bacilli
a chance of entry into the lymph vessels, in which they are carried to
the glands, where they give rise to disease.

The enlargement may affect only one gland, usually below the angle of
the mandible, and remain confined to it, the gland reaching the size of
a hazel-nut, and being ovoid, firm, and painless. More commonly the
disease affects several glands, on one or on both sides of the neck.
When the disease commences in the pre-auricular or submaxillary glands,
it tends to spread to those along the carotid sheath: when the posterior
auricular and occipital glands are first involved, the spread is to
those along the posterior border of the sterno-mastoid. In many cases
all the chains in front of, beneath, and behind this muscle are
involved, the enlarged glands extending from the mastoid to the
clavicle. They are at first discrete and movable, and may even vary in
size from time to time; but with the addition of peri-adenitis they
become fixed and matted together, forming lobulated or nodular masses
(Fig. 78). They become adherent not only to one another, but also to the
structures in their vicinity,--and notably to the internal jugular
vein,--a point of importance in regard to their removal by operation.

At any stage the disease may be arrested and the glands remain for long
periods without further change. It is possible that the tuberculous
tissue may undergo cicatrisation. More commonly suppuration ensues, and
a cold abscess forms, but if there is a mixed infection, the pyogenic
factor being usually derived from the throat, it may take on active
features.

[Illustration: FIG. 78.--Mass of Tuberculous Glands removed from Axilla
(cf. Fig. 79).]

The transition from the solid to the liquefied stage is attended with
pain and tenderness in the gland, which at the same time becomes fixed
and globular, and finally fluctuation can be elicited.

If left to itself, the softened tubercle erupts through the capsule of
the gland and infects the cellular tissue. The cervical fascia is
perforated and a cold abscess, often much larger than the gland from
which it took origin, forms between the fascia and the overlying skin.
The further stages--reddening, undermining of skin and external rupture,
with the formation of ulcers and sinuses--have been described with
tuberculous abscess. The ulcers and sinuses persist indefinitely, or
they heal and then break out again; sometimes the skin becomes infected,
and a condition like lupus spreads over a considerable area. Spontaneous
healing finally takes place after the caseous tubercle has been
extruded; the resulting scars are extremely unsightly, being puckered or
bridled, or hypertrophied like keloid.

While the disease is most common in childhood and youth, it may be met
with even in advanced life; and although often associated with impaired
health and unhealthy surroundings, it may affect those who are
apparently robust and are in affluent circumstances.

_Diagnosis._--The chief importance lies in differentiating tuberculous
disease from lympho-sarcoma and from lymphadenoma, and this is usually
possible from the history and from the nature of the enlargement. Signs
of liquefaction and suppuration support the diagnosis of tubercle. If
any doubt remains, one of the glands should be removed and submitted to
microscopical examination. Other forms of sarcoma, and the enlargement
of an accessory thyreoid, are less likely to be confused with
tuberculous glands. Calcified tuberculous glands give definite shadows
with the X-rays.

Enlargement of the cervical glands from secondary cancer may simulate
tuberculosis, but is differentiated by its association with cancer in
the mouth or throat, and by the characteristic, stone-like induration of
epithelioma.

The cold abscess which results from tuberculous glands is to be
distinguished from that due to disease in the cervical spine,
retro-pharyngeal abscess, as well as from congenital and other cystic
swellings in the neck.

_Prognosis._--Next to lupus, glandular disease is of all tuberculous
lesions the least dangerous to life; but while it is the rule to recover
from tuberculous disease of glands with or without an operation, it is
unfortunately quite common for such persons to become the subjects of
tuberculosis in other parts of the body at any subsequent period of
life.

_Treatment._--There is considerable difference of opinion regarding the
treatment of glandular tuberculosis. Some authorities, impressed with
the undoubted possibility of natural cure, are satisfied with promoting
this by measures directed towards improving the general health, by the
prolonged administration of tuberculin, and by repeated exposures to the
X-rays and to sunlight. Others again, influenced by the risk of
extension of the disease and by the destruction of tissue and
disfigurement caused by breaking down of the tuberculous tissue and
mixed infection, advocate the removal of the glands by operation.

The conditions vary widely in different cases, and the treatment should
be adapted to the individual requirements. If the disease remains
confined to the glands originally infected and there are no signs of
breaking down, "expectant measures" may be persevered with.

[Illustration: FIG. 79.--Tuberculous Axillary Glands (cf. Fig. 78).]

If, on the other hand, the disease exhibits aggressive tendencies, the
question of operation should be considered. The undesirable results of
the breaking down and liquefaction of the diseased gland may be avoided
by the timely withdrawal of the fluid contents through a hollow needle.

_The excision of tuberculous glands_ is often a difficult operation,
because of the number and deep situation of the glands to be removed,
and of the adhesions to surrounding structures. The skin incision must
be sufficiently extensive to give access to the whole of the affected
area, and to avoid disfigurement should, whenever possible, be made in
the line of the natural creases of the skin. In exposing the glands the
common facial and other venous trunks may require to be clamped and
tied. Care must be taken not to injure the important nerves,
particularly the accessory, the vagus, and the phrenic. The
inframaxillary branches of the facial, the hypoglossal and its
descending branches, and the motor branches of the deep cervical plexus,
are also liable to be injured. The dissection is rendered easier and is
attended with less risk of injury to the nerves, if the patient is
placed in the sitting posture so as to empty the veins, and, instead of
a knife, the conical scissors of Mayo are employed. When the glands are
extensively affected on both sides of the neck, it is advisable to allow
an interval to elapse rather than to operate on both sides at one
sitting. (_Op. Surg._, p. 189.)

If the tonsils are enlarged they should not be removed at the same time,
as, by so doing, there is a risk of pyogenic infection from the throat
being carried to the wound in the neck, but they should be removed,
after an interval, to prevent relapse of disease in the glands.

_When the skin is broken_ and caseous tuberculous tissue is exposed,
healing is promoted by cutting away diseased skin, removing the
granulation tissue with the spoon, scraping sinuses, and packing the
cavity with iodoform worsted and treating it by the open method and
secondary suture if necessary. Exposure to the sunshine on the seashore
and to the X-rays is often beneficial in these cases.

#Tuberculous disease in the axillary glands# may be a result of
extension from those in the neck, from the mamma, ribs, or sternum, or
more rarely from the upper extremity. We have seen it from an infected
wound of a finger. In some cases no source of infection is discoverable.
The individual glands attain a considerable size, and they fuse together
to form a large tumour which fills up the axillary space. The disease
progresses more rapidly than it does in the cervical glands, and almost
always goes on to suppuration with the formation of sinuses.
Conservative measures need not be considered, as the only satisfactory
treatment is excision, and that without delay.

#Tuberculous disease in the glands of the groin# is comparatively rare.
We have chiefly observed it in the femoral glands as a result of
inoculation tubercle on the toes or sole of the foot. The affected
glands nearly always break down and suppurate, and after destroying the
overlying skin give rise to fungating ulcers. The treatment consists in
excising the glands and the affected skin. The dissection may be
attended with troublesome haemorrhage from the numerous veins that
converge towards the femoral trunk.

Tuberculous disease in the _mesenteric_ and _bronchial glands_ is
described with the surgery of regions.

#Syphilitic Disease of Glands.#--Enlargement of lymph glands is a
prominent feature of acquired syphilis, especially in the form of the
indolent or bullet-bubo which accompanies the primary lesion, and the
general enlargement of glands that occurs in secondary syphilis.
Gummatous disease in glands is extremely rare; the affected gland
rapidly enlarges to the size of a walnut, and may then persist for a
long period without further change; if it breaks down, the overlying
skin is destroyed and the caseated tissue of the gumma exposed.

#Lymphadenoma.#--_Hodgkin's Disease_ (Pseudo-leukaemia of German
authors).--This is a rare disease, the origin of which is as yet
unknown, but analogy would suggest that it is due to infection with a
slowly growing micro-organism. It is chiefly met with in young subjects,
and is characterised by a painless enlargement of a particular group of
glands, most commonly those in the cervical region (Fig. 80).

[Illustration: FIG. 80.--Chronic Hodgkin's Disease in a boy aet. 11.]

The glands are usually larger than in tuberculosis, and they remain
longer discrete and movable; they are firm in consistence, and on
section present a granular appearance due to overgrowth of the
connective-tissue framework. In time the glandular masses may form
enormous projecting tumours, the swelling being added to by lymphatic
oedema of the overlying cellular tissue and skin.

The enlargement spreads along the chain of glands to those above the
clavicle, to those in the axilla, and to those of the opposite side
(Fig. 81). Later, the glands in the groin become enlarged, and it is
probable that the infection has spread from the neck along the
mediastinal, bronchial, retro-peritoneal, and mesenteric glands, and has
branched off to the iliac and inguinal groups.

Two clinical types are recognised, one in which the disease progresses
slowly and remains confined to the cervical glands for two or more
years; the other, in which the disease is more rapidly disseminated and
causes death in from twelve to eighteen months.

[Illustration: FIG. 81.--Lymphadenoma (Hodgkin's Disease) affecting left
side of neck and left axilla, in a woman aet. 44. Three years' duration.]

In the acute form, the health suffers, there is fever, and the glands
may vary in size with variations in the temperature; the blood presents
the characters met with in secondary anaemia. The spleen, liver, testes,
and mammae may be enlarged; the glandular swellings press on important
structures, such as the trachea, oesophagus, or great veins, and symptoms
referable to such pressure manifest themselves.

_Diagnosis._--Considerable difficulty attends the diagnosis of
lymphadenoma at an early stage. The negative results of tuberculin tests
may assist in the differentiation from tuberculous disease, but the more
certain means of excising one of the suspected glands and submitting it
to microscopical examination should be had recourse to. The sections
show proliferation of endothelial cells, the formation of numerous giant
cells quite unlike those of tuberculosis and a progressive fibrosis.
Lympho-sarcoma can usually be differentiated by the rapid assumption of
the local features of malignant disease, and in a gland removed for
examination, a predominance of small round cells with scanty protoplasm.
The enlargement associated with leucocythaemia is differentiated by the
characteristic changes in the blood.

_Treatment._--In the acute form of lymphadenoma, treatment is of little
avail. Arsenic may be given in full doses either by the mouth or by
subcutaneous injection; the intravenous administration of neo-salvarsan
may be tried. Exposure to the X-rays and to radium has been more
successful than any other form of treatment. Excision of glands,
although sometimes beneficial, seldom arrests the progress of the
disease. The ease and rapidity with which large masses of glands may be
shelled out is in remarkable contrast to what is observed in tuberculous
disease. Surgical interference may give relief when important structures
are being pressed upon--tracheotomy, for example, may be required where
life is threatened by asphyxia.

#Leucocythaemia.#--This is a disease of the blood and of the
blood-forming organs, in which there is a great increase in the number,
and an alteration of the character, of the leucocytes present in the
blood. It may simulate lymphadenoma, because, in certain forms of the
disease, the lymph glands, especially those in the neck, axilla, and
groin, are greatly enlarged.


TUMOURS OF LYMPH GLANDS

#Primary Tumours.#--_Lympho-sarcoma_, which may be regarded as a sarcoma
starting in a lymph gland, appears in the neck, axilla, or groin as a
rapidly growing tumour consisting of one enlarged gland with numerous
satellites. As the tumour increases in size, the sarcomatous tissue
erupts through the capsule of the gland, and infiltrates the surrounding
tissues, whereby it becomes fixed to these and to the skin.

[Illustration: FIG. 82.--Lympho-Sarcoma removed from Groin. It will be
observed that there is one large central parent tumour surrounded by
satellites.]

The prognosis is grave in the extreme, and the only hope is in early
excision, followed by the use of radium and X-rays. We have observed a
case of lympho-sarcoma above the clavicle, in which excision of all that
was removable, followed by the insertion of a tube of radium for ten
days, was followed by a disappearance of the disease over a period which
extended to nearly five years, when death resulted from a tumour in the
mediastinum. In a second case in which the growth was in the groin, the
patient, a young man, remained well for over two years and was then lost
sight of.

#Secondary Tumours.#--Next to tuberculosis, _secondary cancer_ is the
most common disease of lymph glands. In the neck it is met with in
association with epithelioma of the lip, tongue, or fauces. The glands
form tumours of variable size, and are often larger than the primary
growth, the characters of which they reproduce. The glands are at first
movable, but soon become fixed both to each other and to their
surroundings; when fixed to the mandible they form a swelling of
bone-like hardness; in time they soften, liquefy, and burst through the
skin, forming foul, fungating ulcers. A similar condition is met with in
the groin from epithelioma of the penis, scrotum, or vulva. In cancer of
the breast, the infection of the axillary glands is an important
complication.

In _pigmented_ or _melanotic cancers_ of the skin, the glands are early
infected and increase rapidly, so that, when the primary growth is still
of small size--as, for example, on the sole of the foot--the femoral
glands may already constitute large pigmented tumours.

[Illustration: FIG. 83.--Cancerous Glands in Neck secondary to
Epithelioma of Lip.

(Mr. G. L. Chiene's case.)]

The implication of the glands in other forms of cancer will be
considered with regional surgery.

_Secondary sarcoma_ is seldom met with in the lymph glands except when
the primary growth is a lympho-sarcoma and is situated in the tonsil,
thyreoid, or testicle.




CHAPTER XVI

THE NERVES


Anatomy--INJURIES OF NERVES: Changes in nerves after division;
    Repair and its modifications; Clinical features; _Primary and
    secondary suture_--SUBCUTANEOUS INJURIES OF
    NERVES--DISEASES: _Neuritis_; _Tumours_--Surgery of
    the individual nerves: _Brachial neuralgia_; _Sciatica_;
    _Trigeminal neuralgia_.

#Anatomy.#--A nerve-trunk is made up of a variable number of bundles of
nerve fibres surrounded and supported by a framework of connective
tissue. The nerve fibres are chiefly of the medullated type, and they
run without interruption from a nerve cell or _neuron_ in the brain or
spinal medulla to their peripheral terminations in muscle, skin, and
secretory glands.

Each nerve fibre consists of a number of nerve fibrils collected into a
central bundle--the axis cylinder--which is surrounded by an envelope,
the neurolemma or sheath of Schwann. Between the neurolemma and the axis
cylinder is the medullated sheath, composed of a fatty substance known
as myelin. This medullated sheath is interrupted at the nodes of
Ranvier, and in each internode is a nucleus lying between the myelin and
the neurolemma. The axis cylinder is the essential conducting structure
of the nerve, while the neurolemma and the myelin act as insulating
agents. The axis cylinder depends for its nutrition on the central
neuron with which it is connected, and from which it originally
developed, and it degenerates if it is separated from its neuron.

The connective-tissue framework of a nerve-trunk consists of the
_perineurium_, or general sheath, which surrounds all the bundles; the
_epineurium_, surrounding individual groups of bundles; and the
_endoneurium_, a delicate connective tissue separating the individual
nerve fibres. The blood vessels and lymphatics run in these
connective-tissue sheaths.

According to Head and his co-workers, Sherren and Rivers, the afferent
fibres in the peripheral nerves can be divided into three systems:--

1. Those which subserve _deep sensibility_ and conduct the impulses
produced by pressure as well as those which enable the patient to
recognise the position of a joint on passive movement (joint-sensation),
and the kinaesthetic sense, which recognises that active contraction of
the muscle is taking place (active muscle-sensation). The fibres of this
system run with the motor nerves, and pass to muscles, tendons, and
joints. Even division of both the ulnar and the median nerves above the
wrist produces little loss of deep sensibility, unless the tendons are
also cut through. The failure to recognise this form of sensibility has
been largely responsible for the conflicting statements as to the
sensory phenomena following operations for the repair of divided nerves.

2. Those which subserve _protopathic_ sensibility--that is, are capable
of responding to painful cutaneous stimuli and to the extremes of heat
and cold. These also endow the hairs with sensibility to pain. They are
the first to regenerate after division.

3. Those which subserve _epicritic_ sensibility, the most highly
specialised, capable of appreciating light touch, _e.g._ with a wisp of
cotton wool, as a well-localised sensation, and the finer grades of
temperature, called cool and warm (72 o-104 o F.), and of discriminating
as separate the points of a pair of compasses 2 cms. apart. These are
the last to regenerate.

A nerve also exerts a trophic influence on the tissues in which it is
distributed.

The researches of Stoffel on the minute anatomy of the larger nerves,
and the disposition in them of the bundles of nerve fibres supplying
different groups of muscles, have opened up what promises to be a
fruitful field of clinical investigation and therapeutics. He has shown
that in the larger nerve-trunks the nerve bundles for special groups of
muscles are not, as was formerly supposed, arranged irregularly and
fortuitously, but that on the contrary the nerve fibres to a particular
group of muscles have a typical and practically constant position within
the nerve.

In the large nerve-trunks of the limbs he has worked out the exact
position of the bundles for the various groups of muscles, so that in a
cross section of a particular nerve the component bundles can be
labelled as confidently and accurately as can be the cortical areas in
the brain. In the living subject, by using a fine needle-like electrode
and a very weak galvanic current, he has been able to differentiate the
nerve bundles for the various groups of muscles. In several cases of
spastic paralysis he succeeded in picking out in the nerve-trunk of the
affected limb the nerve bundles supplying the spastic muscles, and, by
resecting portions of them, in relieving the spasm. In a case of spastic
contracture of the pronator muscles of the forearm, for example, an
incision is made along the line of the median nerve above the bend of
the elbow. At the lateral side of the median nerve, where it lies in
contact with the biceps muscle, is situated a well-defined and easily
isolated bundle of fibres which supplies the pronator teres, the flexor
carpi radialis, and the palmaris longus muscles. On incising the sheath
of the nerve this bundle can be readily dissected up and its identity
confirmed by stimulating it with a very weak galvanic current. An inch
or more of the bundle is then resected.


INJURIES OF NERVES

Nerves are liable to be cut or torn across, bruised, compressed,
stretched, or torn away from their connections with the spinal medulla.

#Complete Division of a Mixed Nerve.#--Complete division is a common
result of accidental wounds, especially above the wrist, where the
ulnar, median, and radial nerves are frequently cut across, and in
gun-shot injuries.

_Changes in Structure and Function._--The mere interruption of the
continuity of a nerve results in degeneration of its fibres, the myelin
being broken up into droplets and absorbed, while the axis cylinders
swell up, disintegrate, and finally disappear. Both the conducting and
the insulating elements are thus lost. The degeneration in the central
end of the divided nerve is usually limited to the immediate proximity
of the lesion, and does not even involve all the nerve fibres. In the
distal end, it extends throughout the entire peripheral distribution of
the nerve, and appears to be due to the cutting off of the fibres from
their trophic nerve cells in the spinal medulla. Immediate suturing of
the ends does not affect the degeneration of the distal segment. The
peripheral end undergoes complete degeneration in from six weeks to two
months.

The physiological effects of complete division are that the muscles
supplied by the nerve are immediately paralysed, the area to which it
furnishes the sole cutaneous supply becomes insensitive, and the other
structures, including tendons, bones, and joints, lose sensation, and
begin to atrophy from loss of the trophic influence.

#Nerves divided in Amputation.#--In the case of nerves divided in an
amputation, there is an active, although necessarily abortive, attempt
at regeneration, which results in the formation of bulbous swellings at
the cut ends of the nerves. When there has been suppuration, and
especially if the nerves have been cut so as to be exposed in the wound,
these bulbous swellings may attain an abnormal size, and are then known
as "amputation" or "stump neuromas" (Fig. 84).

When the nerves in a stump have not been cut sufficiently short, they
may become involved in the cicatrix, and it may be necessary, on account
of pain, to free them from their adhesions, and to resect enough of the
terminal portions to prevent them again becoming adherent. When this is
difficult, a portion may be resected from each of the nerve-trunks at a
higher level; and if this fails to give relief, a fresh amputation may
be performed. When there is agonising pain dependent upon an ascending
neuritis, it may be necessary to resect the corresponding posterior
nerve roots within the vertebral canal.

[Illustration: FIG. 84.--Stump Neuromas of Sciatic Nerve, excised forty
years after the original amputation by Mr. A. G. Miller.]

#Other Injuries of Nerves.#--_Contusion_ of a nerve-trunk is attended
with extravasation of blood into the connective-tissue sheaths, and is
followed by degeneration of the contused nerve fibres. Function is
usually restored, the conducting paths being re-established by the
formation of new nerve fibres.

When a nerve is _torn across_ or badly _crushed_--as, for example, by a
fractured bone--the changes are similar to those in a divided nerve, and
the ultimate result depends on the amount of separation between the ends
and the possibility of the young axis cylinders bridging the gap.

_Involvement of Nerves in Scar Tissue._--Pressure or traction may be
exerted upon a nerve by contracting scar tissue, or a process of
neuritis or perineuritis may be induced.

When terminal filaments are involved in a scar, it is best to dissect
out the scar, and along with it the ends of the nerves pressed upon.
When a nerve-trunk, such as the sciatic, is involved in cicatricial
tissue, the nerve must be exposed and freed from its surroundings
(_neurolysis_), and then stretched so as to tear any adhesions that may
be present above or below the part exposed. It may be advisable to
displace the liberated nerve from its original position so as to
minimise the risk of its incorporation in the scar of the original wound
or in that resulting from the operation--for example, the radial nerve
may be buried in the substance of the triceps, or it may be surrounded
by a segment of vein or portion of fat-bearing fascia.

_Injuries of nerves resulting from_ #gun-shot wounds# include: (1) those
in which the nerve is directly damaged by the bullet, and (2) those in
which the nerve-trunk is involved secondarily either by scar tissue in
its vicinity or by callus following fracture of an adjacent bone. The
primary injuries include contusion, partial or complete division, and
perforation of the nerve-trunk. One of the most constant symptoms is the
early occurrence of severe neuralgic pain, and this is usually
associated with marked hyperaesthesia.

#Regeneration.#--_Process of Repair when the Ends are in Contact._--_If
the wound is aseptic_, and the ends of the divided nerve are sutured or
remain in contact, they become united, and the conducting paths are
re-established by a regeneration of nerve fibres. There is a difference
of opinion as to the method of regeneration. The Wallerian doctrine is
that the axis cylinders in the central end grow downwards, and enter the
nerve sheaths of the distal portion, and continue growing until they
reach the peripheral terminations in muscle and skin, and in course of
time acquire a myelin sheath; the cells of the neurolemma multiply and
form long chains in both ends of the nerve, and are believed to provide
for the nourishment and support of the actively lengthening axis
cylinders. Another view is that the formation of new axis cylinders is
not confined to the central end, but that it goes on also in the
peripheral segment, in which, however, the new axis cylinders do not
attain maturity until continuity with the central end has been
re-established.

_If the wound becomes infected_ and suppuration occurs, the young nerve
fibres are destroyed and efficient regeneration is prevented; the
formation of scar tissue also may constitute a permanent obstacle to new
nerve fibres bridging the gap.

_When the ends are not in contact_, reunion of the divided nerve fibres
does not take place whether the wound is infected or not. At the
proximal end there forms a bulbous swelling, which becomes adherent to
the scar tissue. It consists of branching axis cylinders running in all
directions, these having failed to reach the distal end because of the
extent of the gap. The peripheral end is completely degenerated, and is
represented by a fibrous cord, the cut end of which is often slightly
swollen or bulbous, and is also incorporated with the scar tissue of
the wound.

#Clinical Features.#--The symptoms resulting from division and non-union
of a nerve-trunk necessarily vary with the functions of the affected
nerve. The following description refers to a mixed sensori-motor trunk,
such as the median or radial (musculo-spiral) nerve.

_Sensory Phenomena._--Superficial touch is tested by means of a wisp of
cotton wool stroked gently across the skin; the capacity of
discriminating two points as separate, by a pair of blunt-pointed
compasses; the sensation of pressure, by means of a pencil or other
blunt object; of pain, by pricking or scratching with a needle; and of
sensibility to heat and cold, by test-tubes containing water at
different temperatures. While these tests are being carried out, the
patient's eyes are screened off.

After division of a nerve containing sensory fibres, there is an area of
absolute cutaneous insensibility to touch (anaesthesia), to pain
(analgesia), and to all degrees of temperature--_loss of protopathic
sensibility_; surrounded by an area in which there is loss of sensation
to light touch, inability to recognise minor differences of temperature
(72 o-104 o F.), and to appreciate as separate impressions the contact of
the two points of a compass--_loss of epicritic sensibility_ (Head and
Sherren) (Figs. 91, 92).

_Motor Phenomena._--There is immediate and complete loss of voluntary
power in the muscles supplied by the divided nerve. The muscles rapidly
waste, and within from three to five days, they cease to react to the
faradic current. When tested with the galvanic current, it is found that
a stronger current must be used to call forth contraction than in a
healthy muscle, and the contraction appears first at the closing of the
circuit when the anode is used as the testing electrode. The loss of
excitability to the interrupted current, and the specific alteration in
the type of contraction with the constant current, is known as the
_reaction of degeneration_. After a few weeks all electric excitability
is lost. The paralysed muscles undergo fatty degeneration, which attains
its maximum three or four months after the division of the nerve.
Further changes may take place, and result in the transformation of the
muscle into fibrous tissue, which by undergoing shortening may cause
deformity known as _paralytic contracture_.

_Vaso-motor Phenomena._--In the majority of cases there is an initial
rise in the temperature of the part (2 o to 3 o F.), with redness and
increased vascularity. This is followed by a fall in the local
temperature, which may amount to 8 o or 10 o F., the parts becoming pale
and cold. Sometimes the hyperaemia resulting from vaso-motor paralysis is
more persistent, and is associated with swelling of the parts from
oedema--the so-called _angio-neurotic oedema_. The vascularity varies with
external influences, and in cold weather the parts present a bluish
appearance.

_Trophic Phenomena._--Owing to the disappearance of the subcutaneous
fat, the skin is smooth and thin, and may be abnormally dry. The hair is
harsh, dry, and easily shed. The nails become brittle and furrowed, or
thick and curved, and the ends of the fingers become club-shaped. Skin
eruptions, especially in the form of blisters, occur, or there may be
actual ulcers of the skin, especially in winter. In aggravated cases the
tips of the fingers disappear from progressive ulceration, and in the
sole of the foot a perforating ulcer may develop. Arthropathies are
occasionally met with, the joints becoming the seat of a painless
effusion or hydrops, which is followed by fibrous thickening of the
capsular and other ligaments, and terminates in stiffness and fibrous
ankylosis. In this way the fingers are seriously crippled and deformed.

#Treatment of Divided Nerves.#--The treatment consists in approximating
the divided ends of the nerve and placing them under the most favourable
conditions for repair, and this should be done at the earliest possible
opportunity. (_Op. Surg._, pp. 45, 46.)

#Primary Suture.#--The reunion of a recently divided nerve is spoken of
as primary suture, and for its success asepsis is essential. As the
suturing of the ends of the nerve is extremely painful, an anaesthetic is
required.

When the wound is healed and while waiting for the restoration of
function, measures are employed to maintain the nutrition of the damaged
nerve and of the parts supplied by it. The limb is exercised, massaged,
and douched, and protected from cold and other injurious influences. The
nutrition of the paralysed muscles is further improved by electricity.
The galvanic current is employed, using at first a mild current of not
more than 5 milliamperes for about ten minutes, the current being made
to flow downwards in the course of the nerve, with the positive
electrode applied to the spine, and the negative over the affected nerve
near its termination. It is an advantage to have a metronome in the
circuit whereby the current is opened and closed automatically at
intervals, so as to cause contraction of the muscles.

_The results_ of primary suture, when it has been performed under
favourable conditions, are usually satisfactory. In a series of cases
investigated by Head and Sherren, the period between the operation and
the first return of sensation averaged 65 days. According to Purves
Stewart protopathic sensation commences to appear in about six weeks and
is completely restored in six months; electric sensation and motor power
reappear together in about six months, and restoration is complete in a
year. When sensation returns, the area of insensibility to pain steadily
diminishes and disappears; sensibility to extremes of temperature
appears soon after; and last of all, after a considerable interval,
there is simultaneous return of appreciation of light touch, moderate
degrees of temperature, and the points of a compass.

A clinical means of estimating how regeneration in a divided nerve is
progressing has been described by Tinel. He found that a tingling
sensation, similar to that experienced in the foot, when it is
recovering from the "sleeping" condition induced by prolonged pressure
on the sciatic nerve from sitting on a hard bench, can be elicited on
percussing over _growing_ axis cylinders. Tapping over the proximal end
of a _newly divided nerve_, _e.g._ the common peroneal behind the head
of the fibula, produces no tingling, but when in about three weeks
axis cylinders begin to grow in the proximal end-bulb, local tingling is
induced by tapping there. The downward growth of the axis cylinders can
be traced by tapping over the distal segment of the nerve, the tingling
sensation being elicited as far down as the young axis cylinders have
reached. When the regeneration of the axis cylinders is complete,
tapping no longer causes tingling. It usually takes about one hundred
days for this stage to be reached.

Tinel's sign is present before voluntary movement, muscular tone, or the
normal electrical reactions reappear.

In cases of complete nerve paralysis that have not been operated upon,
the tingling test is helpful in determining whether or not regeneration
is taking place. Its detection may prevent an unnecessary operation
being performed.

Primary suture should not be attempted so long as the wound shows signs
of infection, as it is almost certain to end in failure. The ends should
be sutured, however, as soon as the wound is aseptic or has healed.

#Secondary Suture.#--The term secondary suture is applied to the
operation of stitching the ends of the divided nerve after the wound has
healed.

_Results of Secondary Suture._--When secondary suture has been performed
under favourable conditions, the prognosis is good, but a longer time is
required for restoration of function than after primary suture. Purves
Stewart says protopathic sensation is sometimes observed much earlier
than in primary suture, because partial regeneration of axis cylinders
in the peripheral segment has already taken place. Sensation is
recovered first, but it seldom returns before three or four months.
There then follows an improvement or disappearance of any trophic
disturbances that may be present. Recovery of motion may be deferred for
long periods--rather because of the changes in the muscles than from
want of conductivity in the nerve--and if the muscles have undergone
complete degeneration, it may never take place at all. While waiting for
recovery, every effort should be made to maintain the nutrition of the
damaged nerve, and of the parts which it supplies.

When suture is found to be impossible, recourse must be had to other
methods, known as nerve bridging and nerve implantation.

#Incomplete Division of a Mixed Nerve.#--The effects of partial division
of a mixed nerve vary according to the destination of the nerve bundles
that have been interrupted. Within their area of distribution the
paralysis is as complete as if the whole trunk had been cut across. The
uninjured nerve-bundles continue to transmit impulses with the result
that there is a _dissociated paralysis_ within the distribution of the
affected nerve, some muscles continuing to act and to respond normally
to electric stimulation, while others behave as if the whole nerve-trunk
had been severed.

In addition to vasomotor and trophic changes, there is often severe pain
of a burning kind (_causalgia_ or _thermalgia_) which comes on about a
fortnight after the injury and causes intense and continuous suffering
which may last for months. Paroxysms of pain may be excited by the
slightest touch or by heat, and the patient usually learns for himself
that the constant application of cold wet cloths allays the pain. The
thermalgic area sweats profusely.

Operative treatment is indicated where there is no sign of improvement
within three months, when recovery is arrested before complete
restoration of function is attained, or when thermalgic pain is
excessive.

#Subcutaneous Injuries of Nerves.#--Several varieties of subcutaneous
injuries of nerves are met with. One of the best known is the
compression paralysis of the nerves of the upper arm which results from
sleeping with the arm resting on the back of a chair or the edge of a
table--the so-called "drunkard's palsy"; and from the pressure of a
crutch in the axilla--"crutch paralysis." In some of these injuries,
notably "drunkard's palsy," the disability appears to be due not to
damage of the nerve, but to overstretching of the extensors of the wrist
and fingers (Jones). A similar form of paralysis is sometimes met with
from the pressure of a tourniquet, from tight bandages or splints, from
the pressure exerted by a dislocated bone or by excessive callus, and
from hyper-extension of the arm during anaesthesia.

In all these forms there is impaired sensation, rarely amounting to
anaesthesia, marked muscular wasting, and diminution or loss of voluntary
motor power, while--and this is a point of great importance--the normal
electrical reactions are preserved. There may also develop trophic
changes such as blisters, superficial ulcers, and clubbing of the tips
of the fingers. The prognosis is usually favourable, as recovery is the
rule within from one to three months. If, however, neuritis supervenes,
the electrical reactions are altered, the muscles degenerate, and
recovery may be retarded or may fail to take place.

Injuries which act abruptly or instantaneously are illustrated in the
crushing of a nerve by the sudden displacement of a sharp-edged fragment
of bone, as may occur in comminuted fractures of the humerus. The
symptoms include perversion or loss of sensation, motor paralysis, and
atrophy of muscles, which show the reaction of degeneration from the
eighth day onwards. The presence of the reaction of degeneration
influences both the prognosis and the treatment, for it implies a lesion
which is probably incapable of spontaneous recovery, and which can only
be remedied by operation.

The _treatment_ varies with the cause and nature of the lesion. When,
for example, a displaced bone or a mass of callus is pressing upon the
nerve, steps must be taken to relieve the pressure, by operation if
necessary. When there is reason to believe that the nerve is severely
crushed or torn across, it should be exposed by incision, and, after
removal of the damaged ends, should be united by sutures. When it is
impossible to make a definite diagnosis as to the state of the nerve, it
is better to expose it by operation, and thus learn the exact state of
affairs without delay; in the event of the nerve being torn, the ends
should be united by sutures.

#Dislocation of Nerves.#--This injury, which resembles the dislocation
of tendons from their grooves, is seldom met with except in the ulnar
nerve at the elbow, and is described with injuries of that nerve.


DISEASES OF NERVES

#Traumatic Neuritis.#--This consists in an overgrowth of the
connective-tissue framework of a nerve, which causes irritation and
pressure upon the nerve fibres, sometimes resulting in their
degeneration. It may originate in connection with a wound in the
vicinity of a nerve, as, for example, when the brachial nerves are
involved in scar tissue subsequent to an operation for clearing out the
axilla for cancer; or in contusion and compression of a nerve--for
example, by the pressure of the head of the humerus in a dislocation of
the shoulder. Some weeks or months after the injury, the patient
complains of increasing hyperaesthesia and of neuralgic pains in the
course of the nerve. The nerve is very sensitive to pressure, and, if
superficial, may be felt to be swollen. The associated muscles are
wasted and weak, and are subject to twitchings. There are also trophic
disturbances. It is rare to have complete sensory and motor paralysis.
The disease is commonest in the nerves of the upper extremity, and the
hand may become crippled and useless.

_Treatment._--Any constitutional condition which predisposes to
neuritis, such as gout, diabetes, or syphilis, must receive appropriate
treatment. The symptoms may be relieved by rest and by soothing
applications, such as belladonna, ichthyol, or menthol, by the use of
hot-air and electric baths, and in obstinate cases by blistering or by
the application of Corrigan's button. When such treatment fails the
nerve may be stretched, or, in the case of a purely sensory trunk, a
portion may be excised. Local causes, such as involvement of the nerve
in a scar or in adhesions, may afford indications for operative
treatment.

#Multiple Peripheral Neuritis.#--Although this disease mainly comes
under the cognizance of the physician, it may be attended with phenomena
which call for surgical interference. In this country it is commonly due
to alcoholism, but it may result from diabetes or from chronic poisoning
with lead or arsenic, or from bacterial infections and intoxications
such as occur in diphtheria, gonorrhoea, syphilis, leprosy, typhoid,
influenza, beri-beri, and many other diseases.

It is, as a rule, widely distributed throughout the peripheral nerves,
but the distribution frequently varies with the cause--the alcoholic
form, for example, mainly affecting the legs, the diphtheritic form the
soft palate and pharynx, and that associated with lead poisoning the
forearms. The essential lesion is a degeneration of the conducting
fibres of the affected nerves, and the prominent symptoms are the result
of this. In alcoholic neuritis there is great tenderness of the muscles.
When the legs are affected the patient may be unable to walk, and the
toes may droop and the heel be drawn up, resulting in one variety of pes
equino-varus. Pressure sores and perforating ulcer of the foot are the
most important trophic phenomena.

Apart from the medical _treatment_, measures must be taken to prevent
deformity, especially when the legs are affected. The bedclothes are
supported by a cage, and the foot maintained at right angles to the leg
by sand-bags or splints. When the disease is subsiding, the nutrition of
the damaged nerves and muscles should be maintained by massage, baths,
passive movements, and the use of the galvanic current. When deformity
has been allowed to take place, operative measures may be required for
its correction.


NEUROMA[5]

[5] We have followed the classification adopted by Alexis Thomson in his
work _On Neuroma, and Neuro-fibromatosis_ (Edinburgh: 1900).

Neuroma is a clinical term applied to all tumours, irrespective of their
structure, which have their seat in nerves.

A tumour composed of newly formed nerve tissue is spoken of as a #true
neuroma#; when ganglionic cells are present in addition to nerve fibres,
the name _ganglionic neuroma_ is applied. These tumours are rare, and
are chiefly met with in the main cords or abdominal plexuses of the
sympathetic system of children or young adults. They are quite
insensitive, and their removal is only called for if they cause pain or
show signs of malignancy.

A #false neuroma# is an overgrowth of the sheath of a nerve. This
overgrowth may result in the formation of a circumscribed tumour, or may
take the form of a diffuse fibromatosis.

_The circumscribed or solitary tumour_ grows from the sheath of a nerve
which is otherwise healthy, and it may be innocent or malignant.

_The innocent_ form is usually fibrous or myxomatous, and is definitely
encapsulated. It may become cystic as a result of haemorrhage or of
myxomatous degeneration. It grows very slowly, is usually elliptical in
shape, and the solid form is rarely larger than a hazel-nut. The nerve
fibres may be spread out all round the tumour, or may run only on one
side of it. When subcutaneous and related to the smaller unnamed
cutaneous nerves, it is known as a _painful subcutaneous nodule_ or
_tubercle_. It is chiefly met with about the ankle, and most often in
women. It is remarkably sensitive, even gentle handling causing intense
pain, which usually radiates to the periphery of the nerve affected.
When related to a deeper, named nerve-trunk, it is known as a
_trunk-neuroma_. It is usually less sensitive than the "subcutaneous
nodule," and rarely gives rise to motor symptoms unless it involves the
nerve roots where they pass through bony canals.

A trunk-neuroma is recognised clinically by its position in the line of
a nerve, by the fact that it is movable in the transverse axis of the
nerve but not in its long axis, and by being unduly painful and
sensitive.

[Illustration: FIG. 85.--Amputation Stump of Upper Arm, showing bulbous
thickening of the ends of the nerves, embedded in scar tissue at the
apex of the stamp.]

_Treatment._--If the tumour causes suffering it should be removed,
preferably by shelling it out from the investing nerve sheath or
capsule. In the subcutaneous nodule the nerve is rarely recognisable,
and is usually sacrificed. When removal of the tumour is incomplete, a
tube of radium should be inserted into the cavity, to prevent recurrence
of the tumour in a malignant form.

_The malignant neuroma_ is a sarcoma growing from the sheath of a nerve.
It has the same characters and clinical features as the innocent
variety, only it grows more rapidly, and by destroying the nerve fibres
causes motor symptoms--jerkings followed by paralysis. The sarcoma tends
to spread along the lymph spaces in the long axis of the nerve, as well
as to implicate the surrounding tissues, and it is liable to give rise
to secondary growths. The malignant neuroma is met with chiefly in the
sciatic and other large nerves of the limbs.

The _treatment_ is conducted on the same lines as sarcoma in other
situations; the insertion of a tube of radium after removal of the
tumour diminishes the tendency to recurrence; a portion of the
nerve-trunk being sacrificed, means must be taken to bridge the gap. In
inoperable cases it may be possible to relieve pain by excising a
portion of the nerve above the tumour, or, when this is impracticable,
by resecting the posterior nerve roots and their ganglia within the
vertebral canal.

The so-called _amputation neuroma_ has already been referred to (p. 344).

_Diffuse or Generalised Neuro-Fibromatosis--Recklinghausen's
Disease._--These terms are now used to include what were formerly known
as "multiple neuromata," as well as certain other overgrowths related to
nerves. The essential lesion is an overgrowth of the endoneural
connective tissue throughout the nerves of both the cerebro-spinal and
sympathetic systems. The nerves are diffusely and unequally thickened,
so that small twigs may become enlarged to the size of the median, while
at irregular intervals along their course the connective-tissue
overgrowth is exaggerated so as to form tumour-like swellings similar to
the trunk-neuroma already described. The tumours, which vary greatly in
size and number--as many as a thousand have been counted in one
case--are enclosed in a capsule derived from the perineurium. The
fibromatosis may also affect the cranial nerves, the ganglia on the
posterior nerve roots, the nerves within the vertebral canal, and the
sympathetic nerves and ganglia, as well as the continuations of the
motor nerves within the muscles. The nerve fibres, although mechanically
displaced and dissociated by the overgrown endoneurium, undergo no
structural change except when compressed in passing through a bony
canal.

The disease probably originates before birth, although it may not make
its appearance till adolescence or even till adult life. It is sometimes
met with in several members of one family. It is recognised clinically
by the presence of multiple tumours in the course of the nerves, and
sometimes by palpable enlargement of the superficial nerve-trunks
(Fig. 86). The tumours resemble the solitary trunk-neuroma, are usually
quite insensitive, and many of them are unknown to the patient. As a
result of injury or other exciting cause, however, one or other tumour
may increase in size and become extremely sensitive; the pain is then
agonising; it is increased by handling, and interferes with sleep. In
these conditions, a malignant transformation of the fibroma into sarcoma
is to be suspected. Motor disturbances are exceptional, unless in the
case of tumours within the vertebral canal, which press on the spinal
medulla and cause paraplegia.

[Illustration: FIG. 86.--Diffuse enlargement of Nerves in generalised
Neuro-fibromatosis.

(After R. W. Smith.)]

Neuro-fibromatosis is frequently accompanied by _pigmentation of the
skin_ in the form of brown spots or patches scattered over the trunk.

The disease is often stationary for long periods. In progressive cases
the patient becomes exhausted, and usually dies of some intercurrent
affection, particularly phthisis. The treatment is restricted to
relieving symptoms and complications; removal of one of the tumours is
to be strongly deprecated.

In a considerable proportion of cases one of the multiple tumours takes
on the characters of a malignant growth ("secondary malignant neuroma,"
Garre). This malignant transformation may follow upon injury, or on an
unsuccessful attempt to remove the tumour. The features are those of a
rapidly growing sarcoma involving a nerve-trunk, with agonising pain
and muscular cramps, followed by paralysis from destruction of the
nerve fibres. The removal of the tumour is usually followed by
recurrence, so that high amputation is the only treatment to be
recommended. Metastasis to internal organs is exceptional.

[Illustration: FIG. 87.--Plexiform Neuroma of small Sciatic Nerve, from
a girl aet. 16.

(Mr. Annandale's case.)]

There are other types of neuro-fibromatosis which require brief mention.

_The plexiform neuroma_ (Fig. 87) is a fibromatosis confined to the
distribution of one or more contiguous nerves or of a plexus of nerves,
and it may occur either by itself or along with multiple tumours of the
nerve-trunks and with pigmentation of the skin. The clinical features
are those of an ill-defined swelling composed of a number of tortuous,
convoluted cords, lying in a loose areolar tissue and freely movable on
one another. It is rarely the seat of pain or tenderness. It most often
appears in the early years of life, sometimes in relation to a pigmented
or hairy mole. It is of slow growth, may remain stationary for long
periods, and has little or no tendency to become malignant. It is
usually subcutaneous, and is frequently situated on the head or neck in
the distribution of the trigeminal or superficial cervical nerves. There
is no necessity for its removal, but this may be indicated because of
disfigurement, especially on the face or scalp or because its bulk
interferes with function. When involving the ophthalmic division of the
trigeminus, for example, it may cause enlargement of the upper lid and
proptosis, with danger to the function of the globe. The results of
excision are usually satisfactory, even if the removal is not complete.

[Illustration: FIG. 88.--Multiple Neuro-fibromas of Skin (Molluscum
fibrosum, or Recklinghausen's disease).]

_The cutaneous neuro-fibroma_ or _molluscum fibrosum_ has been shown by
Recklinghausen to be a soft fibroma related to the terminal filaments of
one of the cutaneous nerves (Fig. 88). The disease appears in the form
of multiple, soft, projecting tumours, scattered all over the body,
except the palms of the hands and soles of the feet. The tumours are of
all sizes, some being no larger than a pin's head, whilst many are as
big as a filbert and a few even larger. Many are sessile and others are
distinctly pedunculated, but all are covered with skin. They are mobile,
soft to the touch, and of the consistence of firm fat. In exceptional
cases one of the skin tumours may attain an enormous size and cause a
hideous deformity, hanging down by its own weight in lobulated or folded
masses (pachy-dermatocele). The treatment consists in removing the
larger swellings. In some cases molluscum fibrosum is associated with
pigmentation of the skin and with multiple tumours of the nerve-trunks.
The small multiple tumours rarely call for interference.

[Illustration: FIG. 89.--Elephantiasis Neuromatosa in a woman aet. 28]

_Elephantiasis neuromatosa_ is the name applied by Virchow to a
condition in which a limb is swollen and misshapen as a result of the
extension of a neuro-fibromatosis to the skin and subcutaneous cellular
tissue of the extremity as a whole (Fig. 89). It usually begins in early
life without apparent cause, and it may be associated with multiple
tumours of the nerve-trunks. The inconvenience caused by the bulk and
weight of the limb may justify its removal.


SURGERY OF THE INDIVIDUAL NERVES[6]

[6] We desire here to acknowledge our indebtedness to Mr. James
Sherren's work on _Injuries of Nerves and their Treatment_.

#The Brachial Plexus.#--Lesions of the brachial plexus may be divided
into those above the clavicle and those below that bone.

In the #supra-clavicular injuries#, the violence applied to the head or
shoulder causes over-stretching of the anterior branches (primary
divisions) of the cervical nerves, the fifth, or the fifth and sixth
being those most liable to suffer. Sometimes the traction is exerted
upon the plexus from below, as when a man in falling from a height
endeavours to save himself by clutching at some projection, and the
lesion then mainly affects the first dorsal nerve. There is tearing of
the nerve sheaths, with haemorrhage, but in severe cases partial or
complete severance of nerve fibres may occur and these give way at
different levels. During the healing process an excess of fibrous tissue
is formed, which may interfere with regeneration.

_Post-anaesthetic paralysis_ occurs in patients in whom, during the
course of an operation, the arm is abducted and rotated laterally or
extended above the head, causing over-stretching of the plexus,
especially of the fifth, or fifth and sixth, anterior branches.

A _cervical rib_ may damage the plexus by direct pressure, the part
usually affected being the medial cord, which is made up of fibres from
the eighth cervical and first dorsal nerves.

When a lesion of the plexus complicates a _fracture of the clavicle_,
the nerve injury is due, not to pressure on or laceration of the nerves
by fragments of bone, but to the violence causing the fracture, and this
is usually applied to the point of the shoulder.

Penetrating _wounds_, apart from those met with in military practice,
are rare.

In the #infra-clavicular injuries#, the lesion most often results from
the pressure of the dislocated head of the humerus; occasionally from
attempts made to reduce the dislocation by the heel-in-the-axilla
method, or from fracture of the upper end of the humerus or of the neck
of the scapula. The whole plexus may suffer, but more frequently the
medial cord is alone implicated.

_Clinical Features._--Three types of lesion result from indirect
violence: the whole plexus; the upper-arm type; and the lower-arm type.

_When the whole plexus is involved_, sensibility is lost over the entire
forearm and hand and over the lateral surface of the arm in its distal
two-thirds. All the muscles of the arm, forearm, and hand are paralysed,
and, as a rule, also the pectorals and spinati, but the rhomboids and
serratus anterior escape. There is paralysis of the sympathetic fibres
to the eye and orbit, with narrowing of the palpebral fissure, recession
of the globe, and the pupil is slow to dilate when shaded from the
light.

The _upper-arm type_--Erb-Duchenne paralysis--is that most frequently
met with, and it is due to a lesion of the fifth anterior branch, or, it
may be, also of the sixth. The position of the upper limb is typical:
the arm and forearm hang close to the side, with the forearm extended
and pronated; the deltoid, spinati, biceps, brachialis, and supinators
are paralysed, and in some cases the radial extensors of the wrist and
the pronator teres are also affected. The patient is unable to supinate
the forearm or to abduct the arm, and in most cases to flex the forearm.
He may, however, regain some power of flexing the forearm when it is
fully pronated, the extensors of the wrist becoming feeble flexors of
the elbow. There is, as a rule, no loss of sensibility, but complaint
may be made of tickling and of pins-and-needles over the lateral aspect
of the arm. The abnormal position of the limb may persist although the
muscles regain the power of voluntary movement, and as the condition
frequently follows a fall on the shoulder, great care is necessary in
diagnosis, as the condition is apt to be attributed to an injury to the
axillary (circumflex) nerve.

The _lower-arm type_ of paralysis, associated with the name of Klumpke,
is usually due to over-stretching of the plexus, and especially affects
the anterior branch of the first dorsal nerve. In typical cases all the
intrinsic muscles of the hand are affected, and the hand assumes the
claw shape. Sensibility is usually altered over the medial side of the
arm and forearm, and there is paralysis of the sympathetic.

_Infra-clavicular injuries_, as already stated, are most often produced
by a sub-coracoid dislocation of the humerus; the medial cord is that
most frequently injured, and the muscles paralysed are those supplied by
the ulnar nerve, with, in addition, those intrinsic muscles of the hand
supplied by the median. Sensibility is affected over the medial surface
of the forearm and ulnar area of the hand. Injury of the lateral and
posterior cords is very rare.

_Treatment_ is carried out on the lines already laid down for nerve
injuries in general. It is impossible to diagnose between complete and
incomplete rupture of the nerve cords, until sufficient time has elapsed
to allow of the establishment of the reaction of degeneration. If this
is present at the end of fourteen days, operation should not be delayed.
Access to the cords of the plexus is obtained by a dissection similar to
that employed for the subclavian artery, and the nerves are sought for
as they emerge from under cover of the scalenus anterior, and are then
traced until the seat of injury is found. In the case of the first
dorsal nerve, it may be necessary temporarily to resect the clavicle.
The usual after-treatment must be persisted in until recovery ensues,
and care must be taken that the paralysed muscles do not become
over-stretched. The prognosis is less favourable in the supra-clavicular
lesions than in those below the clavicle, which nearly always recover
without surgical intervention.

In the _brachial birth-paralysis_ met with in infants, the lesion is due
to over-stretching of the plexus, and is nearly always of the
Erb-Duchenne type. The injury is usually unilateral, it occurs with
almost equal frequency in breech and in vertex presentations, and the
left arm is more often affected than the right. The lesion is seldom
recognised at birth. The first symptom noticed is tenderness in the
supra-clavicular region, the child crying when this part is touched or
the arm is moved. The attitude may be that of the Erb-Duchenne type, or
the whole of the muscles of the upper limb may be flaccid, and the arm
hangs powerless. A considerable proportion of the cases recover
spontaneously. The arm is to be kept at rest, with the affected muscles
relaxed, and, as soon as tenderness has disappeared, daily massage and
passive movements are employed. The reaction of degeneration can rarely
be satisfactorily tested before the child is three months old, but if it
is present, an operation should be performed. After operation, the
shoulder should be elevated so that no traction is exerted on the
affected cords.

#The long thoracic nerve# (nerve of Bell), which supplies the serratus
anterior, is rarely injured. In those whose occupation entails carrying
weights upon the shoulder it may be contused, and the resulting
paralysis of the serratus is usually combined with paralysis of the
lower part of the trapezius, the branches from the third and fourth
cervical nerves which supply this muscle also being exposed to pressure
as they pass across the root of the neck. There is complaint of pain
above the clavicle, and winging of the scapula; the patient is unable to
raise the arm in front of the body above the level of the shoulder or to
perform any forward pushing movements; on attempting either of these the
winging of the scapula is at once increased. If the scapula is compared
with that on the sound side, it is seen that, in addition to the lower
angle being more prominent, the spine is more horizontal and the lower
angle nearer the middle line. The majority of these cases recover if the
limb is placed at absolute rest, the elbow supported, and massage and
galvanism persevered with. If the paralysis persists, the sterno-costal
portion of the pectoralis major may be transplanted to the lower angle
of the scapula.

The long thoracic nerve may be cut across while clearing out the axilla
in operating for cancer of the breast. The displacement of the scapula
is not so marked as in the preceding type, and the patient is able to
perform pushing movements below the level of the shoulder. If the
reaction of degeneration develops, an operation may be performed, the
ends of the nerve being sutured, or the distal end grafted into the
posterior cord of the brachial plexus.

#The Axillary (Circumflex) Nerve.#--In the majority of cases in which
paralysis of the deltoid follows upon an injury of the shoulder, it is
due to a lesion of the fifth cervical nerve, as has already been
described in injuries of the brachial plexus. The axillary nerve itself
as it passes round the neck of the humerus is most liable to be injured
from the pressure of a crutch, or of the head of the humerus in
sub-glenoid dislocation, or in fracture of the neck of the scapula or of
the humerus. In miners, who work for long periods lying on the side, the
muscle may be paralysed by direct pressure on the terminal filaments of
the nerve, and the nerve may also be involved as a result of disease in
the sub-deltoid bursa.

The deltoid is wasted, and the acromion unduly prominent. In recent
cases paralysis of the muscle is easily detected. In cases of long
standing it is not so simple, because other muscles, the spinati, the
clavicular fibres of the pectoral and the serratus, take its place and
elevate the arm; there is always loss of sensation on the lateral aspect
of the shoulder. There is rarely any call for operative treatment, as
the paralysis is usually compensated for by other muscles.

When the _supra-scapular nerve_ is contused or stretched in injuries of
the shoulder, the spinati muscles are paralysed and wasted, the spine of
the scapula is unduly prominent, and there is impairment in the power of
abducting the arm and rotating it laterally.

The _musculo-cutaneous nerve_ is very rarely injured; when cut across,
there is paralysis of the coraco-brachialis, biceps, and part of the
brachialis, but no movements are abolished, the forearm being flexed, in
the pronated position, by the brachio-radialis and long radial extensor
of the wrist; in the supinated position, by that portion of the
brachialis supplied by the radial nerve. Supination is feebly performed
by the supinator muscle. Protopathic and epicritic sensibility are lost
over the radial side of the forearm.

#Radial (Musculo-Spiral) Nerve.#--From its anatomical relationships this
trunk is more exposed to injury than any other nerve in the body. It is
frequently compressed against the humerus in sleeping with the arm
resting on the back of a chair, especially in the deep sleep of
alcoholic intoxication (drunkard's palsy). It may be pressed upon by a
crutch in the axilla, by the dislocated head of the humerus, or by
violent compression of the arm, as when an elastic tourniquet is applied
too tightly. The most serious and permanent injuries of this nerve are
associated with fractures of the humerus, especially those from direct
violence attended with comminution of the bone. The nerve may be crushed
or torn by one of the fragments at the time of the injury, or at a later
period may be compressed by callus.

_Clinical Features._--Immediately after the injury it is impossible to
tell whether the nerve is torn across or merely compressed. The patient
may complain of numbness and tingling in the distribution of the
superficial branch of the nerve, but it is a striking fact, that so long
as the nerve is divided below the level at which it gives off the dorsal
cutaneous nerve of the forearm (external cutaneous branch), there is no
loss of sensation. When it is divided above the origin of the dorsal
cutaneous branch, or when the dorsal branch of the musculo-cutaneous
nerve is also divided, there is a loss of sensibility on the dorsum
of the hand.

The motor symptoms predominate, the muscles affected being the extensors
of the wrist and fingers, and the supinators. There is a characteristic
"drop-wrist"; the wrist is flexed and pronated, and the patient is
unable to dorsiflex the wrist or fingers (Fig. 90). If the hand and
proximal phalanges are supported, the second and third phalanges may be
partly extended by the interossei and lumbricals. There is also
considerable impairment of power in the muscles which antagonise those
that are paralysed, so that the grasp of the hand is feeble, and the
patient almost loses the use of it; in some cases this would appear to
be due to the median nerve having been injured at the same time.

[Illustration: FIG. 90.--Drop-wrist following Fracture of Shaft of
Humerus.]

If the lesion is high up, as it is, for example, in crutch paralysis,
the triceps and anconeus may also suffer.

_Treatment._--The slighter forms of injury by compression recover under
massage, douching, and electricity. If there is drop-wrist, the hand and
forearm are placed on a palmar splint, with the hand dorsiflexed to
nearly a right angle, and this position is maintained until voluntary
dorsiflexion at the wrist returns to the normal. Recovery is sometimes
delayed for several months.

In the more severe injuries associated with fracture of the humerus and
attended with the reaction of degeneration, it is necessary to cut down
upon the nerve and free it from the pressure of a fragment of bone or
from callus or adhesions. If the nerve is torn across, the ends must be
sutured, and if this is impossible owing to loss of tissue, the gap may
be bridged by a graft taken from the superficial branch of the radial
nerve, or the ends may be implanted into the median.

Finally, in cases in which the paralysis is permanent and incurable, the
disability may be relieved by operation. A fascial graft can be employed
to act as a ligament permanently extending the wrist; it is attached to
the third and fourth metacarpal bones distally and to the radius or ulna
proximally. The flexor carpi radialis can then be joined up with the
extensor digitorum communis by passing its tendon through an aperture in
the interosseous membrane, or better still, through the pronator
quadratus, as there is less likelihood of the formation of adhesions
when the tendon passes through muscle than through interosseous
membrane. The palmaris longus is anastomosed with the abductor pollicis
longus (extensor ossis metacarpi pollicis), thus securing a fair amount
of abduction of the thumb. The flexor carpi ulnaris may also be
anastomosed with the common extensor of the fingers. The extensors of
the wrist may be shortened, so as to place the hand in the position of
dorsal flexion, and thus improve the attitude and grasp of the hand.

_The superficial branch of the radial_ (radial nerve) _and the deep
branch_ (posterior interosseous), apart from suffering in lesions of the
radial, are liable to be contused or torn is dislocation of the head of
the radius, and in fracture of the neck of the bone. The deep branch may
be divided as it passes through the supinator in operations on old
fractures and dislocations in the region of the elbow. Division of the
superficial branch in the upper two-thirds of the forearm produces no
loss of sensibility; division in the lower third after the nerve has
become associated with branches from the musculo-cutaneous is followed
by a loss of sensibility on the radial side of the hand and thumb. Wounds
on the dorsal surface of the wrist and forearm are often followed by
loss of sensibility over a larger area, because the musculo-cutaneous
nerve is divided as well, and some of the fibres of the lower lateral
cutaneous branch of the radial.

[Illustration: FIG. 91.--To illustrate the Loss of Sensation produced by
Division of the Median Nerve. The area of complete cutaneous
insensibility is shaded black. The parts insensitive to light touch and
to intermediate degrees of temperature are enclosed within the dotted
line.

(After Head and Sherren.)]

#The Median Nerve# is most frequently injured in wounds made by broken
glass in the region of the wrist. It may also be injured in fractures of
the lower end of the humerus, in fractures of both bones of the forearm,
and as a result of pressure by splints. After _division at the elbow_,
there is impairment of mobility which affects the thumb, and to a less
extent the index finger: the terminal phalanx of the thumb cannot be
flexed owing to the paralysis of the flexor pollicis longus, and the
index can only be flexed at its metacarpo-phalangeal joint by the
interosseous muscles attached to it. Pronation of the forearm is feeble,
and is completed by the weight of the hand. After _division at the
wrist_, the abductor-opponens group of muscles and the two lateral
lumbricals only are affected; the abduction of the thumb can be feebly
imitated by the short extensor and the long abductor (ext. ossis
metacarpi pollicis), while opposition may be simulated by contraction of
the long flexor and the short abductor of the thumb; the paralysis of
the two medial lumbricals produces no symptoms that can be recognised.
It is important to remember that when the median nerve is divided at the
wrist, deep touch can be appreciated over the whole of the area
supplied by the nerve; the injury, therefore, is liable to be over
looked. If, however, the tendons are divided as well as the nerve, there
is insensibility to deep touch. The areas of epicritic and of
protopathic insensibility are illustrated in Fig. 91. The division of
the nerve at the elbow, or even at the axilla, does not increase the
extent of the loss of epicritic or protopathic sensibility, but usually
affects deep sensibility.

[Illustration: FIG. 92.--To illustrate Loss of Sensation produced by
complete Division of Ulnar Nerve. Loss of all forms of cutaneous
sensibility is represented by the shaded area. The parts insensitive to
light touch and to intermediate degrees of heat and cold are enclosed
within the dotted line.

(Head and Sherren.)]

#The Ulnar Nerve.#--The most common injury of this nerve is its division
in transverse accidental wounds just above the wrist. In the arm it may
be contused, along with the radial, in crutch paralysis; in the region
of the elbow it may be injured in fractures or dislocations, or it may
be accidentally divided in the operation for excising the elbow-joint.

When it is injured _at or above the elbow_, there is paralysis of the
flexor carpi ulnaris, the ulnar half of the flexor digitorum profundus,
all the interossei, the two medial lumbricals, and the adductors of the
thumb. The hand assumes a characteristic attitude: the index and middle
fingers are extended at the metacarpo-phalangeal joints owing to
paralysis of the interosseous muscles attached to them; the little and
ring fingers are hyper-extended at these joints in consequence of the
paralysis of the lumbricals; all the fingers are flexed at the
inter-phalangeal joints, the flexion being most marked in the little and
ring fingers--claw-hand or _main en griffe_. On flexing the wrist, the
hand is tilted to the radial side, but the paralysis of the flexor carpi
ulnaris is often compensated for by the action of the palmaris longus.
The little and ring fingers can be flexed to a slight degree by the
slips of the flexor sublimis attached to them and supplied by the median
nerve; flexion of the terminal phalanx of the little finger is almost
impossible. Adduction and abduction movements of the fingers are lost.
Adduction of the thumb is carried out, not by the paralysed adductor
pollicis, but the movement may be simulated by the long flexor and
extensor muscles of the thumb. Epicritic sensibility is lost over the
little finger, the ulnar half of the ring finger, and that part of the
palm and dorsum of the hand to the ulnar side of a line drawn
longitudinally through the ring finger and continued upwards.
Protopathic sensibility is lost over an area which varies in different
cases. Deep sensibility is usually lost over an area almost as extensive
as that of protopathic insensibility.

When the nerve is _divided at the wrist_, the adjacent tendons are also
frequently severed. If divided below the point at which its dorsal
branch is given off, the sensory paralysis is much less marked, and the
injury is therefore liable to be overlooked until the wasting of muscles
and typical _main en griffe_ ensue. The loss of sensibility after
division of the nerve before the dorsal branch is given off resembles
that after division at the elbow, except that in uncomplicated cases
deep sensibility is usually retained. If the tendons are divided as
well, however, deep touch is also lost.

Care must be taken in all these injuries to prevent deformity; a splint
must be worn, at least during the night, until the muscles regain their
power of voluntary movement, and then exercises should be instituted.

#Dislocation of the ulnar nerve# at the elbow results from sudden and
violent flexion of the joint, the muscular effort causing stretching or
laceration of the fascia that holds the nerve in its groove; it is
predisposed to if the groove is shallow as a result of imperfect
development of the medial condyle of the humerus, and by cubitus valgus.

The nerve slips forward, and may be felt lying on the medial aspect of
the condyle. It may retain this position, or it may slip backwards and
forwards with the movements of the arm. The symptoms at the time of the
displacement are some disability at the elbow, and pain and tingling
along the nerve, which are exaggerated by movement and by pressure. The
symptoms may subside altogether, or a neuritis may develop, with severe
pain shooting up the nerve.

The dislocated nerve is easily replaced, but is difficult to retain in
position. In recent cases the arm may be placed in the extended position
with a pad over the condyle, care being taken to avoid pressure on the
nerve. Failing relief, it is better to make a bed for the nerve by
dividing the deep fascia behind the medial condyle and to stitch the
edges of the fascia over the nerve. This operation has been successful
in all the recorded cases.

#The Sciatic Nerve.#--When this nerve is compressed, as by sitting on a
fence, there is tingling and powerlessness in the limb as a whole, known
as "sleeping" of the limb, but these phenomena are evanescent. _Injuries
to the great sciatic nerve_ are rare except in war. Partial division is
more common than complete, and it is noteworthy that the fibres destined
for the peroneal nerve are more often and more severely injured than
those for the tibial (internal popliteal). After complete division, all
the muscles of the leg are paralysed; if the section is in the upper
part of the thigh, the hamstrings are also paralysed. The limb is at
first quite powerless, but the patient usually recovers sufficiently to
be able to walk with a little support, and although the hamstrings are
paralysed the knee can be flexed by the sartorius and gracilis. The
chief feature is drop-foot. There is also loss of sensation below the
knee except along the course of the long saphenous nerve on the medial
side of the leg and foot. Sensibility to deep touch is only lost over a
comparatively small area on the dorsum of the foot.

#The Common Peroneal (external popliteal) nerve# is exposed to injury
where it winds round the neck of the fibula, because it is superficial
and lies against the unyielding bone. It may be compressed by a
tourniquet, or it may be bruised or torn in fractures of the upper end
of the bone. It has been divided in accidental wounds,--by a scythe, for
example,--in incising for cellulitis, and in performing subcutaneous
tenotomy of the biceps tendon. Cases have been observed of paralysis of
the nerve as a result of prolonged acute flexion of the knee in certain
occupations.

When the nerve is divided, the most obvious result is "drop-foot"; the
patient is unable to dorsiflex the foot and cannot lift his toes off the
ground, so that in walking he is obliged to jerk the foot forwards and
laterally. The loss of sensibility depends upon whether the nerve is
divided above or below the origin of the large cutaneous branch which
comes off just before it passes round the neck of the fibula. In course
of time the foot becomes inverted and the toes are pointed--pes
equino-varus--and trophic sores are liable to form.

#The Tibial (internal popliteal) nerve# is rarely injured.

#The Cranial nerves# are considered with affections of the head and neck
(Vol. II.).


NEURALGIA

The term neuralgia is applied clinically to any pain which follows the
course of a nerve, and is not referable to any discoverable cause. It
should not be applied to pain which results from pressure on a nerve by
a tumour, a mass of callus, an aneurysm, or by any similar gross lesion.
We shall only consider here those forms of neuralgia which are amenable
to surgical treatment.

#Brachial Neuralgia.#--The pain is definitely located in the
distribution of one of the branches or nerve roots, is often
intermittent, and is usually associated with tingling and disturbance of
tactile sensation. The root of the neck should be examined to exclude
pressure as the cause of the pain by a cervical rib, a tumour, or an
aneurysm. When medical treatment fails, the nerve-trunks may be injected
with saline solution or recourse may be had to operative measures, the
affected cords being exposed and stretched through an incision in the
posterior triangle of the neck. If this fails to give relief, the more
serious operation of resecting the posterior roots of the affected
nerves within the vertebral canal may be considered.

_Neuralgia of the sciatic nerve_--#sciatica#--is the most common form of
neuralgia met with in surgical practice.

It is chiefly met with in adults of gouty or rheumatic tendencies who
suffer from indigestion, constipation, and oxaluria--in fact, the same
type of patients who are liable to lumbago, and the two affections are
frequently associated. In hospital practice it is commonly met with in
coal-miners and others who assume a squatting position at work. The
onset of the pain may follow over-exertion and exposure to cold and wet,
especially in those who do not take regular exercise. Any error of diet
or indulgence in beer or wine may contribute to its development.

The essential symptom is paroxysmal or continuous pain along the course
of the nerve in the buttock, thigh, or leg. It may be comparatively
slight, or it may be so severe as to prevent sleep. It is aggravated by
movement, so that the patient walks lame or is obliged to lie up. It is
aggravated also by any movement which tends to put the nerve on the
stretch, as in bending down to put on the shoes, such movements also
causing tingling down the nerve, and sometimes numbness in the foot.
This may be demonstrated by flexing the thigh on the abdomen, the knee
being kept extended; there is no pain if the same manoeuvre is repeated
with the knee flexed. The nerve is sensitive to pressure, the most
tender points being its emergence from the greater sciatic foramen, the
hollow between the trochanter and the ischial tuberosity, and where the
common peroneal nerve winds round the neck of the fibula. The muscles of
the thigh are often wasted and are liable to twitch.

The clinical features vary a good deal in different cases; the affection
is often obstinate, and may last for many weeks or even months.

In the sciatica that results from neuritis and perineuritis, there is
marked tenderness on pressure due to the involvement of the nerve
filaments in the sheath of the nerve, and there may be patches of
cutaneous anaesthesia, loss of tendon reflexes, localised wasting of
muscles, and vaso-motor and trophic changes. The presence of the
reaction of degeneration confirms the diagnosis of neuritis. In
long-standing cases the pain and discomfort may lead to a postural
scoliosis (_ischias-scoliotica_).

_Diagnosis._--Pain referred along the course of the sciatic nerve on one
side, or, as is sometimes the case, on both sides, is a symptom of
tumours of the uterus, the rectum, or the pelvic bones. It may result
also from the pressure of an abscess or an aneurysm either inside the
pelvis or in the buttock, and is sometimes associated with disease of
the spinal medulla, such as tabes. Gluteal fibrositis may be mistaken
for sciatica. It is also necessary to exclude such conditions as disease
in the hip or sacro-iliac joint, especially tuberculous disease and
arthritis deformans, before arriving at a diagnosis of sciatica. A
digital examination of the rectum or vagina is of great value in
excluding intra-pelvic tumours.

_Treatment_ is both general and local. Any constitutional tendency, such
as gout or rheumatism, must be counteracted, and indigestion, oxaluria,
and constipation should receive appropriate treatment. In acute cases
the patient is confined to bed between blankets, the limb is wrapped in
thermogene wool, and the knee is flexed over a pillow; in some cases
relief is experienced from the use of a long splint, or slinging the leg
in a Salter's cradle. A rubber hot-bottle may be applied over the seat
of greatest pain. The bowels should be well opened by castor oil or by
calomel followed by a saline. Salicylate of soda in full doses, or
aspirin, usually proves effectual in relieving pain, but when this is
very intense it may call for injections of heroin or morphin. Potassium
iodide is of benefit in chronic cases.

Relief usually results from bathing, douching, and massage, and from
repeated gentle stretching of the nerve. This may be carried out by
passive movements of the limb--the hip being flexed while the knee is
kept extended; and by active movements--the patient flexing the limb at
the hip, the knee being maintained in the extended position. These
exercises, which may be preceded by massage, are carried out night and
morning, and should be practised systematically by those who are liable
to sciatica.

Benefit has followed the injection into the nerve itself, or into the
tissues surrounding it, of normal saline solution; from 70-100 c.c. are
injected at one time. If the pain recurs, the injection may require to
be repeated on many occasions at different points up and down the nerve.
Needling or acupuncture consists in piercing the nerve at intervals in
the buttock and thigh with long steel needles. Six or eight needles are
inserted and left in position for from fifteen to thirty minutes.

In obstinate and severe cases the nerve may be _forcibly stretched_.
This may be done bloodlessly by placing the patient on his back with the
hip flexed to a right angle, and then gradually extending the knee until
it is in a straight line with the thigh (Billroth). A general anaesthetic
is usually required. A more effectual method is to expose the nerve
through an incision at the fold of the buttock, and forcibly pull upon
it. This operation is most successful when the pain is due to the nerve
being involved in adhesions.

#Trigeminal Neuralgia.#--A severe form of epileptiform neuralgia occurs
in the branches of the fifth nerve, and is one of the most painful
affections to which human flesh is liable. So far as its pathology is
known, it is believed to be due to degenerative changes in the semilunar
(Gasserian) ganglion. It is met with in adults, is almost invariably
unilateral, and develops without apparent cause. The pain, which occurs
in paroxysms, is at first of moderate severity, but gradually becomes
agonising. In the early stages the paroxysms occur at wide intervals,
but later they recur with such frequency as to be almost continuous.
They are usually excited by some trivial cause, such as moving the jaws
in eating or speaking, touching the face as in washing, or exposure to a
draught of cold air. Between the paroxysms the patient is free from
pain, but is in constant terror of its return, and the face wears an
expression of extreme suffering and anxiety. When the paroxysm is
accompanied by twitching of the facial muscles, it is called _spasmodic
tic_.

The skin of the affected area may be glazed and red, or may be pale and
moist with inspissated sweat, the patient not daring to touch or wash
it.

There is excessive tenderness at the points of emergence of the
different branches on the face, and pressure over one or other of these
points may excite a paroxysm. In typical cases the patient is unable to
take any active part in life. The attempt to eat is attended with such
severe pain that he avoids taking food. In some cases the suffering is
so great that the patient only obtains sleep by the use of hypnotics,
and he is often on the verge of suicide.

_Diagnosis._--There is seldom any difficulty in recognising the disease.
It is important, however, to exclude the hysterical form of neuralgia,
which is characterised by its occurrence earlier in life, by the pain
varying in situation, being frequently bilateral, and being more often
constant than paroxysmal.

_Treatment._--Before having recourse to the measures described below, it
is advisable to give a thorough trial to the medical measures used in
the treatment of neuralgia.

_The Injection of Alcohol into the Nerve._--The alcohol acts by
destroying the nerve fibres, and must be brought into direct contact
with them; if the nerve has been properly struck the injection is
followed by complete anaesthesia in the distribution of the nerve. The
relief may last for from six months to three years; if the pain returns,
the injection may be repeated. The strength of the alcohol should be 85
per cent., and the amount injected about 2 c.c.; a general, or
preferably a local, anaesthetic (novocain) should be employed
(Schlosser); the needle is 8 cm. long, and 0.7 mm. in diameter. The
severe pain which the alcohol causes may be lessened, after the needle
has penetrated to the necessary depth, by passing a few cubic
centimetres of a 2 per cent. solution of _novocain-suprarenin_ through
it before the alcohol is injected. The treatment by injection of alcohol
is superior to the resection of branches of the nerve, for though
relapses occur after the treatment with alcohol, renewed freedom from
pain may be obtained by its repetition. The ophthalmic division should
not, however, be treated in this manner, for the alcohol may escape into
the orbit and endanger other nerves in this region. Harris recommends
the injection of alcohol into the semilunar ganglion.

_Operative Treatment._--This consists in the removal of the affected
nerve or nerves, either by resection--_neurectomy_; or by a combination
of resection with twisting or tearing of the nerve from its central
connections--_avulsion_. To prevent the regeneration of the nerve after
these operations, the canal of exit through the bone should be
obliterated; this is best accomplished by a silver screw-nail driven
home by an ordinary screw-driver (Charles H. Mayo).

When the neuralgia involves branches of two or of all three trunks, or
when it has recurred after temporary relief following resection of
individual branches, the _removal of the semilunar ganglion_, along with
the main trunks of the maxillary and mandibular divisions, should be
considered.

The operation is a difficult and serious one, but the results are
satisfactory so far as the cure of the neuralgia is concerned. There is
little or no disability from the unilateral paralysis of the muscles of
mastication; but on account of the insensitiveness of the cornea, the
eye must be protected from irritation, especially during the first month
or two after the operation; this may be done by fixing a large
watch-glass around the edge of the orbit with adhesive plaster.

If the ophthalmic branch is not involved, neither it nor the ganglion
should be interfered with; the maxillary and mandibular divisions should
be divided within the skull, and the foramen rotundum and foramen ovale
obliterated.




CHAPTER XVII

THE SKIN AND SUBCUTANEOUS TISSUE


Structure of skin--_Blisters_--_Callosities_--_Corns_--_Chilblains_
    --_Boils_--_Carbuncle_--_Abscess_--_Veldt sores_--Tuberculosis of
    skin: _Inoculation tubercle_--_Lupus_: _Varieties_--Sporotrichosis
    --Elephantiasis--Sebaceous cysts or wens--Moles--Horns--New growths:
    _Fibroma_; _Papilloma_; _Adenoma_; _Epithelioma_; _Rodent cancer_;
    _Melanotic cancer_; _Sarcoma_--AFFECTIONS OF CICATRICES--_Varieties
    of scars_--_Keloid_--_Tumours_--AFFECTIONS OF NAILS.

#Structure of Skin.#--The skin is composed of a superficial cellular
layer--the epidermis, and the corium or true skin. The _epidermis_ is
differentiated from without inwards into the stratum corneum, the
stratum lucidum, the stratum granulosum, and the rete Malpighii or
germinal layer, from which all the others are developed. The _corium_ or
_true skin_ consists of connective tissue, in which ramify the blood
vessels, lymphatics, and nerves. That part of the corium immediately
adjoining the epidermis is known as the papillary portion, and contains
the terminal loops of the cutaneous blood vessels and the terminations
of the cutaneous nerves. The deeper portion of the true skin is known as
the reticular portion, and is largely composed of adipose tissue.

#Blisters# result from the exudation of serous fluid beneath the horny
layer of the epidermis. The fluid may be clear, as in the blisters of a
recent burn, or blood-stained, as in the blisters commonly accompanying
fractures of the leg. It may become purulent as a result of infection,
and this may be the starting-point of lymphangitis or cellulitis.

The skin should be disinfected and the blisters punctured. When
infected, the separated horny layer must be cut away with scissors to
allow of the necessary purification.

#Callosities# are prominent, indurated masses of the horny layer of the
epidermis, where it has been exposed to prolonged friction and pressure.
They occur on the fingers and hand as a result of certain occupations
and sports, but are most common under the balls of the toes or heel. A
bursa may form beneath a callosity, and if it becomes inflamed may cause
considerable suffering; if suppuration ensues, a sinus may form,
resembling a perforating ulcer of the foot.

The _treatment_ of callosities on the foot consists in removing pressure
by wearing properly fitting boots, and in applying a ring pad around the
callosity; another method is to fit a sock of spongiopilene with a hole
cut out opposite the callosity. After soaking in hot water, the
overgrown horny layer is pared away, and the part painted daily with a
saturated solution of salicylic acid in flexile collodion.

[Illustration: FIG. 93.--Callosities and Corns on the Sole and Plantar
Aspect of the Toes in a woman who was also the subject of flat-foot.]

#Corns.#--A corn is a localised overgrowth of the horny layer of the
epidermis, which grows downwards, pressing upon and displacing the
sensitive papillae of the corium. Corns are due to the friction and
pressure of ill-fitting boots, and are met with chiefly on the toes and
sole of the foot. A corn is usually hard, dry, and white; but it may be
sodden from moisture, as in "soft corns" between the toes. A bursa may
form beneath a corn, and if inflamed constitutes one form of bunion.
When suppuration takes place in relation to a corn, there is great pain
and disability, and it may prove the starting-point of lymphangitis.

The _treatment_ consists in the wearing of properly fitting boots and
stockings, and, if the symptoms persist, the corn should be removed.
This is done after the manner of chiropodists by digging out the corn
with a suitably shaped knife. A more radical procedure is to excise,
under local anaesthesia, the portion of skin containing the corn and
the underlying bursa. The majority of so-called corn solvents consist of
a solution of salicylic acid in collodion; if this is painted on daily,
the epidermis dies and can then be pared away. The unskilful paring of
corns may determine the occurrence of senile gangrene in those who are
predisposed to it by disease of the arteries.

[Illustration: FIG. 94.--Ulcerated Chilblains on Fingers of a Child.]

#Chilblains.#--Chilblain or _erythema pernio_ is a vascular disturbance
resulting from the alternate action of cold and heat on the distal parts
of the body. Chilblains are met with chiefly on the fingers and toes in
children and anaemic girls. In the mild form there is a sensation of
burning and itching, the part becomes swollen, of a dusky red colour,
and the skin is tense and shiny. In more severe cases the burning and
itching are attended with pain, and the skin becomes of a violet or
wine-red colour. There is a third degree, closely approaching
frost-bite, in which the skin tends to blister and give way, leaving an
indolent raw surface popularly known as a "broken chilblain."

Those liable to chilblains should take open-air exercise, nourishing
food, cod-liver oil, and tonics. Woollen stockings and gloves should be
worn in cold weather, and sudden changes of temperature avoided. The
symptoms may be relieved by ichthyol ointment, glycerin and belladonna,
or a mixture of Venice turpentine, castor oil, and collodion applied on
lint which is wrapped round the toe. Another favourite application is
one of equal parts of tincture of capsicum and compound liniment of
camphor, painted over the area night and morning. Balsam of Peru or
resin ointment spread on gauze should be applied to broken chilblains.
The most effective treatment is Bier's bandage applied for about six
hours twice daily; it can be worn while the patient is following his
occupation; in chronic cases this may be supplemented with hot-air
baths.

#Boils and Carbuncles.#--These result from infection with the
staphylococcus aureus, which enters the orifices of the ducts of the
skin under the influence of friction and pressure, as was demonstrated
by the well-known experiment of Garre, who produced a crop of pustules
and boils on his own forearm by rubbing in a culture of the
staphylococcus aureus.

A #boil# results when the infection is located in a hair follicle or
sebaceous gland. A hard, painful, conical swelling develops, to which,
so long as the skin retains its normal appearance, the term "blind
boil" is applied. Usually, however, the skin becomes red, and after a
time breaks, giving exit to a drop or two of thick pus. After an
interval of from six to ten days a soft white slough is discharged; this
is known as the "core," and consists of the necrosed hair follicle or
sebaceous gland. After the separation of the core the boil heals
rapidly, leaving a small depressed scar.

Boils are most frequently met with on the back of the neck and the
buttocks, and on other parts where the skin is coarse and thick and is
exposed to friction and pressure. The occurrence of a number or a
succession of boils is due to spread of the infection, the cocci from
the original boil obtaining access to adjacent hair follicles. The
spread of boils may be unwittingly promoted by the use of a domestic
poultice or the wearing of infected underclothing.

While boils are frequently met with in debilitated persons, and
particularly in those suffering from diabetes or Bright's disease, they
also occur in those who enjoy vigorous health. They seldom prove
dangerous to life except in diabetic subjects, but when they occur on
the face there is a risk of lymphatic and of general pyogenic infection.
Boils may be differentiated from syphilitic lesions of the skin by
their acute onset and progress, and by the absence of other evidence of
syphilis; and from the malignant or anthrax pustule by the absence of
the central black eschar and of the circumstances which attend upon
anthrax infection.

_Treatment._--The skin of the affected area should be painted with
iodine, and a Klapp's suction bell applied thrice daily. If pus forms,
the skin is frozen with ethyl-chloride and a small incision made, after
which the application of the suction bell is persevered with. The
further treatment consists in the use of diluted boracic or resin
ointment. In multiple boils on the trunk and limbs, lysol or boracic
baths are of service; the underclothing should be frequently changed,
and that which is discarded must be disinfected. In patients with
recurrence of boils about the neck, re-infection frequently takes place
from the scalp, to which therefore treatment should be directed.

Any impaired condition of health should be corrected; when, there is
sugar or albumen in the urine the conditions on which these depend must
receive appropriate treatment. When there are successive crops of boils,
recourse should be had to vaccines. In refractory cases benefit has
followed the subcutaneous injection of lipoid solution containing tin.

#Carbuncle# may be looked upon as an aggregation of boils, and is
characterised by a densely hard base and a brownish-red discoloration of
the skin. It is usually about the size of a crown-piece, but it may
continue to enlarge until it attains the size of a dinner-plate. The
patient is ill and feverish, and the pain may be so severe as to prevent
sleep. As time goes on several points of suppuration appear, and when
these burst there are formed a number of openings in the skin, giving it
a cribriform appearance; these openings exude pus. The different
openings ultimately fuse and the large adherent greyish-white slough is
exposed. The separation of the slough is a tedious process, and the
patient may become exhausted by pain, discharge, and toxin absorption.
When the slough is finally thrown off, a deep gap is left, which takes a
long time to heal. A large carbuncle is a grave disease, especially in a
weakly person suffering from diabetes or chronic alcoholism; we have on
several occasions seen diabetic coma supervene and the patient die
without recovering consciousness. In the majority of cases the patient
is laid aside for several months. It is most common in male adults over
forty years of age, and is usually situated on the back between the
shoulders. When it occurs on the face or anterior part of the neck it is
especially dangerous, because of the greater risk of dissemination of
the infection.

A carbuncle is to be differentiated from an ulcerated gumma and from
anthrax pustule.

[Illustration: FIG. 95.--Carbuncle of seventeen days' duration in a
woman aet. 57.]

_Treatment._--Pain is relieved by full doses of opium or codein, and
these drugs are specially indicated when sugar is present in the urine.
Vaccines may be given a trial. The diet should be liberal and easily
digested, and strychnin and other stimulants may be of service. Locally
the treatment is carried out on the same lines as for boils.

In some cases it is advisable to excise the carbuncle or to make
incisions across it in different directions, so that the resulting wound
presents a stellate appearance.

#Acute Abscesses of the Skin and Subcutaneous Tissue in Young
Children.#--In young infants, abscesses are not infrequently met with
scattered over the trunk and limbs, and are probably the result of
infection of the sebaceous glands from dirty underclothing. The
abscesses should be opened, and the further spread of infection
prevented by cleansing of the skin and by the use of clean under-linen.
Similar abscesses are met with on the scalp in association with eczema,
impetigo, and pediculosis.

#Veldt Sore.#--This sore usually originates in an abrasion of the
epidermis, such as a sun blister, the bite of an insect, or a scratch. A
pustule forms and bursts, and a brownish-yellow scab forms over it. When
this is removed, an ulcer is left which has little tendency to heal.
These sores are most common about the hands, arms, neck, and feet, and
are most apt to occur in those who have had no opportunities of washing,
and who have lived for a long time on tinned foods.

#Tuberculosis of the Skin.#--Interest attaches chiefly to the primary
forms of tuberculosis of the skin in which the bacilli penetrate from
without--inoculation tubercle and lupus.

#Inoculation Tubercle.#--The appearances vary with the conditions under
which the inoculation takes place. As observed on the fingers of adults,
the affection takes the form of an indolent painless swelling, the
epidermis being red and glazed, or warty, and irregularly fissured.
Sometimes the epidermis gives way, forming an ulcer with flabby
granulations. The infection rarely spreads to the lymphatics, but we
have seen inoculation tubercle of the index-finger followed by a large
cold abscess on the median side of the upper arm and by a huge mass of
breaking down glands in the axilla.

In children who run about barefooted in towns, tubercle may be
inoculated into wounds in the sole or about the toes, and although the
local appearances may not be characteristic, the nature of the infection
is revealed by its tendency to spread up the limb along the lymph
vessels, giving rise to abscesses and fungating ulcers in relation to
the femoral glands.

#Tuberculous Lupus.#--This is an extremely chronic affection of the
skin. It rarely extends to the lymph glands, and of all tuberculous
lesions is the least dangerous to life. The commonest form of
lupus--_lupus vulgaris_--usually commences in childhood or youth, and is
most often met with on the nose or cheek. The early and typical
appearance is that of brownish-yellow or pink nodules in the skin, about
the size of hemp seed. Healing frequently occurs in the centre of the
affected area while the disease continues to extend at the margin.

When there is actual destruction of tissue and ulceration--the so-called
"_lupus excedens_" or "_ulcerans_"--healing is attended with
cicatricial contraction, which may cause unsightly deformity. When the
cheek is affected, the lower eyelid may be drawn down and everted; when
the lips are affected, the mouth may be distorted or seriously
diminished in size. When the nose is attacked, both the skin and mucous
surfaces are usually involved, and the nasal orifices may be narrowed or
even obliterated; sometimes the soft parts, including the cartilages,
are destroyed, leaving only the bones covered by tightly stretched scar
tissue.

The disease progresses slowly, healing in some places and spreading at
others. The patient complains of a burning sensation, but little of
pain, and is chiefly concerned about the disfigurement. Nothing is more
characteristic of lupus than the appearance of fresh nodules in parts
which have already healed. In the course of years large tracts of the
face and neck may become affected. From the lips it may spread to the
gum and palate, giving to the mucous membrane the appearance of a
raised, bright-red, papillary or villous surface. When the disease
affects the gums, the teeth may become loose and fall out.

[Illustration: FIG. 96.--Tuberculous Elephantiasis in a woman aet. 35.]

On parts of the body other than the face, the disease is even more
chronic, and is often attended with a considerable production of dense
fibrous tissue--the so-called _fibroid lupus_. Sometimes there is a
warty thickening of the epidermis--_lupus verrucosus_. In the fingers
and toes it may lead to a progressive destruction of tissue like that
observed in leprosy, and from the resulting loss of portions of the
digits it has been called _lupus mutilans_. In the lower extremity a
remarkable form of the disease is sometimes met with, to which the term
_lupus elephantiasis_ (Fig. 96) has been applied. It commences as an
ordinary lupus of the toes or dorsum of the foot, from which the
tuberculous infection spreads to the lymph vessels, and the limb as a
whole becomes enormously swollen and unshapely.

Finally, a long-standing lupus, especially on the cheek, may become the
seat of epithelioma--_lupus epithelioma_--usually of the exuberant or
cauliflower type, which, like other epitheliomas that originate in scar
tissue, presents little tendency to infect the lymphatics.

The _diagnosis_ of lupus is founded on the chronic progress and long
duration, and the central scarring with peripheral extension of the
disease. On the face it is most liable to be confused with syphilis and
with rodent cancer. The syphilitic lesion belongs to the tertiary
period, and although presenting a superficial resemblance to
tuberculosis, its progress is more rapid, so that within a few months it
may involve an area of skin as wide as would be affected by lupus in as
many years. Further, it readily yields to anti-syphilitic treatment. In
cases of tertiary syphilis in which the nose is destroyed, it will be
noticed that the bones have suffered most, while in lupus the
destruction of tissue involves chiefly the soft parts.

Rodent cancer is liable to be mistaken for lupus, because it affects the
same parts of the face; it is equally chronic, and may partly heal. It
begins later in life, however, the margin of the ulcer is more sharply
defined, and often presents a "rolled" appearance.

_Treatment._--When the disease is confined to a limited area, the most
rapid and certain cure is obtained by _excision_; larger areas are
scraped with the sharp spoon. The _ray treatment_ includes the use of
luminous, Rontgen, or radium rays, and possesses the advantage of being
comparatively painless and of being followed by the least amount of
scarring and deformity.

Encouraging results have also been obtained by the application of carbon
dioxide snow.

#Multiple subcutaneous tuberculous nodules# are met with chiefly in
children. They are indolent and painless, and rarely attract attention
until they break down and form abscesses, which are usually about the
size of a cherry, and when these burst sinuses or ulcers result. If the
overlying skin is still intact, the best treatment is excision. If the
abscess has already infected the skin, each focus should be scraped and
packed.

#Sporotrichosis# is a mycotic infection due to the sporothrix Shenkii.
It presents so many features resembling syphilis and tubercle that it is
frequently mistaken for one or other of these affections. It occurs
chiefly in males between fifteen and forty-five, who are farmers, fruit
and vegetable dealers, or florists. There is usually a history of trauma
of the nature of a scratch or a cut, and after a long incubation period
there develop a series of small, hard, round nodules in the skin and
subcutaneous tissue which, without pain or temperature, soften into
cold abscesses and leave indolent ulcers or sinuses. The infection is
of slow progress and follows the course of the lymphatics. From the
gelatinous pus the organism is cultivated without difficulty, and this
is the essential step in arriving at a diagnosis. The disease yields in
a few weeks to full doses of iodide of potassium.

#Elephantiasis.#--This term is applied to an excessive enlargement of a
part depending upon an overgrowth of the skin and subcutaneous cellular
tissue, and it may result from a number of causes, acting independently
or in combination. The condition is observed chiefly in the extremities
and in the external organs of generation.

_Elephantiasis from Lymphatic or Venous Obstruction._--Of this the
best-known example is _tropical elephantiasis_ (E. arabum), which is
endemic in Samoa, Barbadoes, and other places. It attacks the lower
extremity or the genitals in either sex (Figs. 97, 98). The disease is
usually ushered in with fever, and signs of lymphangitis in the part
affected. After a number of such attacks, the lymph vessels appear to
become obliterated, and the skin and subcutaneous cellular tissue, being
bathed in stagnant lymph--which possibly contains the products of
streptococci--take on an overgrowth, which continues until the part
assumes gigantic proportions. In certain cases the lymph trunks have
been found to be blocked with the parent worms of the filaria Bancrofti.
Cases of elephantiasis of the lower extremity are met with in this
country in which there are no filarial parasites in the lymph vessels,
and these present features closely resembling the tropical variety, and
usually follow upon repeated attacks of lymphangitis or erysipelas.

The part affected is enormously increased in size, and causes
inconvenience from its bulk and weight. In contrast to ordinary dropsy,
there is no pitting on pressure, and the swelling does not disappear on
elevation of the limb. The skin becomes rough and warty, and may hang
down in pendulous folds. Blisters form on the surface and yield an
abundant exudate of clear lymph. From neglect of cleanliness, the skin
becomes the seat of eczema or even of ulceration attended with foul
discharge.

Samson Handley has sought to replace the blocked lymph vessels by
burying in the subcutaneous tissue of the swollen part a number of stout
silk threads--_lymphangioplasty_. By their capillary action they drain
the lymph to a healthy region above, and thus enable it to enter the
circulation. It has been more successful in the face and upper limb than
in the lower extremity. If the tissues are infected with pus organisms,
a course of vaccines should precede the operation.

[Illustration: FIG. 97.--Elephantiasis in a woman aet. 45.]

A similar type of elephantiasis may occur after extirpation of the lymph
glands in the axilla or groin; in the leg in long-standing standing
varix and phlebitis with chronic ulcer; in the arm as a result of
extensive cancerous disease of the lymphatics in the axilla secondarily
to cancer of the breast; and in extensive tuberculous disease of the
lymphatics. The last-named is chiefly observed in the lower limb in
young adult women, and from its following upon lupus of the toes or foot
it has been called _lupus elephantiasis_. The tuberculous infection
spreads slowly up the limb by way of the lymph vessels, and as these are
obliterated the skin and cellular tissues become hypertrophied, and the
surface is studded over with fungating tuberculous masses of a livid
blue colour. As the more severe forms of the disease may prove dangerous
to life by pyogenic complications inducing gangrene of the limb, the
question of amputation may have to be considered.

[Illustration: FIG. 98.--Elephantiasis of Penis and Scrotum in native of
Demerara.

(Mr. Annandale's case.)]

Belonging to this group also is a form of _congenital elephantiasis_
resulting from the circular constriction of a limb _in utero_ by
amniotic bands.

_Elephantiasis occurring apart from lymphatic or venous obstruction_ is
illustrated by _elephantiasis nervorum_, in which there is an overgrowth
of the skin and cellular tissue of an extremity in association with
neuro-fibromatosis of the cutaneous nerves (Fig. 89); and by
_elephantiasis Graecorum_--a form of leprosy in which the skin of the
face becomes the seat of tumour-like masses consisting of leprous
nodules. It is also illustrated by _elephantiasis involving the scrotum_
as a result of prolonged irritation by the urine in cases in which the
penis has been amputated and the urine has infiltrated the scrotal
tissues over a period of years.

#Sebaceous Cysts.#--Atheromatous cysts or wens are formed in relation to
the sebaceous glands and hair follicles. They are commonly met with in
adults, on the scalp (Fig. 99), face, neck, back, and external genitals.
Sometimes they are multiple, and they may be met with in several members
of the same family. They are smooth, rounded, or discoid cysts, varying
in size from a split-pea to a Tangerine orange. In consistence they are
firm and elastic, or fluctuating, and are incorporated with the
overlying skin, but movable on the deeper structures. The orifice of the
partly blocked sebaceous follicle is sometimes visible, and the contents
of the cyst can be squeezed through the opening. The wall of the cyst is
composed of a connective-tissue capsule lined by stratified squamous
epithelium. The contents consist of accumulated epithelial cells, and
are at first dry and pearly white in appearance, but as a result of
fatty degeneration they break down into a greyish-yellow pultaceous and
semi-fluid material having a peculiar stale odour. It is probable that
the decomposition of the contents is the result of the presence of
bacteria, and that from the surgical point of view they should be
regarded as infective. A sebaceous cyst may remain indefinitely without
change, or may slowly increase in size, the skin over it becoming
stretched and closely adherent to the cyst wall as a result of friction
and pressure. The contents may ooze from the orifice of the duct and dry
on the skin surface, leading to the formation of a sebaceous horn
(Fig. 100). As a result of injury the cyst may undergo sudden
enlargement from haemorrhage into its interior.

Recurrent attacks of inflammation frequently occur, especially in wens
of the face and scalp. Suppuration may ensue and be followed by cure of
the cyst, or an offensive fungating ulcer forms which may be mistaken
for epithelioma. True cancerous transformation is rare.

Wens are to be _diagnosed_ from dermoids, from fatty tumours, and from
cold abscesses. Dermoids usually appear before adult life, and as they
nearly always lie beneath the fascia, the skin is movable over them. A
fatty tumour is movable, and is often lobulated. The confusion with a
cold abscess is most likely to occur in wens of the neck or back, and it
may be impossible without the use of an exploring needle to
differentiate between them.

[Illustration: FIG. 99.--Multiple Sebaceous Cysts or Wens; the larger
ones are of many years' duration.]

_Treatment._--The removal of wens is to be recommended while they are
small and freely movable, as they are then easily shelled out after
incising the overlying skin; sometimes splitting the cyst makes its
removal easier. Local anaesthesia is to be preferred. It is important
that none of the cyst wall be left behind. In large and adherent wens an
ellipse of skin is removed along with the cyst. When inflamed, it may be
impossible to dissect out the cyst, and the wall should be destroyed
with carbolic acid, the resulting wound being treated by the open
method.

#Moles.#--The term mole is applied to a pigmented, and usually hairy,
patch of skin, present at or appearing shortly after birth. The colour
varies from brown to black, according to the amount of melanin pigment
present. The lesion consists in an overgrowth of epidermis which often
presents an alveolar arrangement. Moles vary greatly in size: some are
mere dots, others are as large as the palm of the hand, and occasionally
a mole covers half the face. In addition to being unsightly, they bleed
freely when abraded, are liable to ulcerate from friction and pressure,
and occasionally become the starting-point of melanotic cancer. Rodent
cancer sometimes originates in the slightly pigmented moles met with on
the face. Overgrowths in relation to the cutaneous nerves, especially
the plexiform neuroma, occasionally originate in pigmented moles. Soldau
believes that the pigmentation and overgrowth of the epidermis in moles
are associated with, and probably result from, a fibromatosis of the
cutaneous nerves.

_Treatment._--The quickest way to get rid of a mole is to excise it; if
the edges of the gap cannot be brought together with sutures, recourse
should be had to grafting. In large hairy moles of the face whose size
forbids excision, radium or the X-rays should be employed. Excellent
results have been obtained by refrigeration with solid carbon dioxide.
In children and women with delicate skin, applications of from ten to
thirty seconds suffice. In persons with coarse skin an application of
one minute may be necessary, and it may have to be repeated.

#Horns.#--The _sebaceous_ horn results from the accumulation of the
dried contents of a wen on the surface of the skin: the sebaceous
material after drying up becomes cornified, and as fresh material is
added to the base the horn increases in length (Fig. 100). The _wart_
horn grows from a warty papilloma of the skin. _Cicatrix_ horns are
formed by the heaping up of epidermis in the scars that result from
burns. _Nail_ horns are overgrown nails (keratomata of the nail bed),
and are met with chiefly in the great toe of elderly bedridden patients.
If an ulcer forms at the base of a horn, it may prove the starting-point
of epithelioma, and for this reason, as well as for others, horns should
be removed.

[Illustration: FIG. 100.--Sebaceous Horn growing from Auricle.

(Dr. Kenneth Maclachan's case.)]

#New Growths in the Skin and Subcutaneous Tissue.#--The _Angioma_ has
been described with diseases of blood vessels. _Fibroma._--Various types
of fibroma occur in the skin. A soft pedunculated fibroma, about the
size of a pea, is commonly met with, especially on the neck and trunk;
it is usually solitary, and is easily removed with scissors. The
multiple, soft fibroma known as _molluscum fibrosum_, which depends upon
a neuro-fibromatosis of the cutaneous nerves, is described with the
tumours of nerves. Hard fibromas occurring singly or in groups may be
met with, especially in the skin of the buttock, and may present a local
malignancy, recurring after removal like the "recurrent fibroid" of
Paget. The "painful subcutaneous nodule" is a solitary fibroma related
to one of the cutaneous nerves. The hard fibroma known as _keloid_ is
described with the affections of scars.

#Papilloma.#--The _common wart_ or verruca is an outgrowth of the
surface epidermis. It may be sessile or pedunculated hard or soft. The
surface may be smooth, or fissured and foliated like a cauliflower, or
it may be divided up into a number of spines. Warts are met with chiefly
on the hands, and are often multiple, occurring in clusters or in
successive crops. Multiple warts appear to result from some contagion,
the nature of which is unknown; they sometimes occur in an epidemic form
among school-children, and show a remarkable tendency to disappear
spontaneously. The solitary flat-topped wart which occurs on the face
of old people may, if irritated, become the seat of epithelioma. A warty
growth of the epidermis is a frequent accompaniment of moles and of that
variety of lupus known as _lupus verrucosus_.

_Treatment._--In the multiple warts of children the health should be
braced up by a change to the seaside. A dusting-powder, consisting of
boracic acid with 5 per cent. salicylic acid, may be rubbed into the
hands after washing and drying. The persistent warts of young adults
should be excised after freezing with chloride of ethyl. When cutting is
objected to, they may be painted night and morning with salicylic
collodion, the epidermis being dehydrated with alcohol before each
application.

_Venereal warts_ occur on the genitals of either sex, and may form large
cauliflower-like masses on the inner surface of the prepuce or of the
labia majora. Although frequently co-existing with gonorrhoea or
syphilis, they occur independently of these diseases, being probably
acquired by contact with another individual suffering from warts
(C. W. Cathcart). They give rise to considerable irritation and
suffering, and when cleanliness is neglected there may be an offensive
discharge.

In the female, the cauliflower-like masses are dissected from the labia;
in the male, the prepuce is removed and the warts on the glans are
snipped off with scissors. In milder cases, the warts usually disappear
if the parts are kept absolutely dry and clean. A useful dusting-powder
is one consisting of calamine and 5 per cent. salicylic acid; the
exsiccated sulphate of iron, in the form of a powder, may be employed in
cases which resist this treatment.

#Adenoma.#--This is a comparatively rare tumour growing from the glands
of the skin. One variety, known as the "tomato tumour," which apparently
originates from _the sweat glands_, is met with on the scalp and face in
women past middle life. These growths are often multiple; the individual
tumours vary in size, and the skin, which is almost devoid of hairs, is
glistening and tightly stretched over them. A similar tumour may occur
on the nose. The _sebaceous adenoma_, which originates from the
sebaceous glands, forms a projecting tumour on the face or scalp, and
when the skin is irritated it may ulcerate and fungate. The treatment
consists in the removal of the tumour along with the overlying skin.

The exuberant masses on the nose known as "rhinophyma," "lipoma nasi,"
or "potato nose" are of the nature of sebaceous adenoma, and are removed
by shaving them off with a knife until the normal shape of the nose is
restored Healing takes place with remarkable rapidity.

#Cancer.#--There are several types of primary cancer of the skin, the
most important being squamous epithelioma, rodent cancer, and melanotic
cancer.

[Illustration: FIG. 101.--Paraffin Epithelioma.]

#Epithelioma# occurs in a variety of forms. When originating in a small
ulcer or wart-for example on the face in old people--it presents the
features of a chronic indurated ulcer. A more exuberant and rapidly
growing form of epithelial cancer, described by Hutchinson as the
_crateriform ulcer_, commences on the face as a small red pimple which
rapidly develops into an elevated mass shaped like a bee-hive, and
breaks down in the centre. Epithelioma may develop anywhere on the body
in relation to long-standing ulcers, especially that resulting from a
burn or from lupus; this form usually presents an exuberant outgrowth of
epidermis not unlike a cauliflower. An interesting example of
epithelioma has been described by Neve of Kashmir. The natives in that
province are in the habit of carrying a fire-basket suspended from the
waist, which often burns the skin and causes a chronic ulcer, and many
of these ulcers become the seat of epithelioma, due, in Neve's opinion,
to the actual contact of the sooty pan with the skin.

The term _trade epithelioma_ has been applied to that form met with in
those who follow certain occupations, such as paraffin workers and
chimney-sweeps. The most recent member of this group is the _X-ray
carcinoma_, which is met with in those who are constantly exposed to the
irritation of the X-rays; there is first a chronic dermatitis with warty
overgrowth of the surface epithelium, pigmentation, and the formation of
fissures and warts. The trade epithelioma varies a good deal in
malignancy, but it tends to cause death in the same manner as other
epitheliomas.

Epithelial cancer has also been observed in those who have taken arsenic
over long periods for medicinal purposes.

[Illustration: FIG. 102.--Rodent Cancer of Inner Canthus.]

#Rodent Cancer# (Rodent Ulcer).--This is a cancer originating in the
sweat glands or sebaceous follicles, or in the foetal residues of
cutaneous glands. The cells are small and closely packed together in
alveoli or in reticulated columns; cell nests are rare. It is remarkably
constant in its seat of origin, being nearly always located on the
lateral aspect of the nose or in the vicinity of the lower eyelid
(Fig. 102). It is rare on the trunk or limbs. It commences as a small
flattened nodule in the skin, the epidermis over it being stretched and
shining. The centre becomes depressed, while the margins extend in the
form of an elevated ridge. Sooner or later the epidermis gives way in
the centre, exposing a smooth raw surface devoid of granulations.

[Illustration: FIG. 103.--Rodent Cancer of fifteen years' duration,
which has destroyed the contents of the Orbit.

(Sir Montagu Cotterill's case)]

The margin, while in parts irregular, is typically represented by a
well-defined "rolled" border which consists of the peripheral portion of
the cancer that has not broken down. The central ulcer may temporarily
heal. There is itching but little pain, and the condition progresses
extremely slowly; rodent cancers which have existed for many years are
frequently met with. The disease attacks and destroys every structure
with which it comes in contact, such as the eyelids, the walls of the
nasal cavities, and the bones of the face; hence it may produce the most
hideous deformities (Fig. 103). The patient may succumb to haemorrhage or
to infective complications such as erysipelas or meningitis.

Secondary growths in the lymph glands, while not unknown, are extremely
rare. We have only seen them once--in a case of rodent cancer in the
groin.

_Diagnosis._--Lupus is the disease most often mistaken for rodent
cancer. Lupus usually begins earlier in life, it presents apple-jelly
nodules, and lacks the rounded, elevated border. Syphilitic lesions
progress more rapidly, and also lack the characteristic margin. The
differentiation from squamous epithelioma is of considerable importance,
as the latter affection spreads more rapidly, involves the lymph glands
early, and is much more dangerous to life.

_Treatment._--In rodent cancers of limited size--say less than one inch
in diameter--free excision is the most rapid and certain method of
treatment. The alternative is the application of radium or of the
Rontgen rays, which, although requiring many exposures, results in cure
with the minimum of disfigurement. If the cancer already covers an
extensive area, or has invaded the cavity of the orbit or nose, radium
or X-rays yield the best results. The effect is soon shown by the
ingrowth of healthy epithelium from the surrounding skin, and at the
same time the discharge is lessened. Good results are also reported from
the application of carbon dioxide snow, especially when this follows
upon a course of X-ray treatment.

#Paget's disease# of the nipple is an epithelioma occurring in women
over forty years of age: a similar form of epithelioma is sometimes met
with at the umbilicus or on the genitals.

#Melanotic Cancer.#--Under this head are included all new growths which
contain an excess of melanin pigment. Many of these were formerly
described as melanotic sarcoma. They nearly always originate in a
pigmented mole which has been subjected to irritation. The primary
growth may remain so small that its presence is not even suspected, or
it may increase in size, ulcerate, and fungate. The amount of pigment
varies: when small in amount the growth is brown, when abundant it is a
deep black. The most remarkable feature is the rapidity with which the
disease becomes disseminated along the lymphatics, the first evidence of
which is an enlargement of the lymph glands. As the primary growth is
often situated on the sole of the foot or in the matrix of the nail of
the great toe, the femoral and inguinal glands become enlarged in
succession, forming tumours much larger than the primary growth.
Sometimes the dissemination involves the lymph vessels of the limb,
forming a series of indurated pigmented cords and nodules (Fig. 104).
Lastly, the dissemination may be universal throughout the body, and this
usually occurs at a comparatively early stage. The secondary growths are
deeply pigmented, being usually of a coal-black colour, and melanin
pigment may be present in the urine. When recurrence takes place in or
near the scar left by the operation, the cancer nodules are not
necessarily pigmented.

[Illustration: FIG. 104.--Diffuse Melanotic Cancer of Lymphatics of Skin
secondary to a Growth in the Sole of the Foot.]

To extirpate the disease it is necessary to excise the tumour, with a
zone of healthy skin around it and a somewhat large zone of the
underlying subcutaneous tissue and deep fascia. Hogarth Pringle
recommends that a broad strip of subcutaneous fascia up to and including
the nearest anatomical group of glands should be removed with the tumour
in one continuous piece.

#Secondary Cancer of the Skin.#--Cancer may spread to the skin from a
subjacent growth by direct continuity or by way of the lymphatics. Both
of these processes are so well illustrated in cases of mammary cancer
that they will be described in relation to that disease.

#Sarcoma# of various types is met with in the skin. The fibroma, after
excision, may recur as a fibro-sarcoma. The alveolar sarcoma commences
as a hard lump and increases in size until the epidermis gives way and
an ulcer is formed.

[Illustration: FIG. 105.--Melanotic Cancer of Forehead with Metastases
in Lymph Vessels and Glands.

(Mr. D. P. D. Wilkie's case.)]

A number of fresh tumours may spring up around the original growth.
Sometimes the primary growth appears in the form of multiple nodules
which tend to become confluent. Excision, unless performed early, is of
little avail, and in any case should be followed up by exposure to
radium.


AFFECTIONS OF CICATRICES

A cicatrix or scar consists of closely packed bundles of white fibres
covered by epidermis; the skin glands and hair follicles are usually
absent. The size, shape, and level of the cicatrix depend upon the
conditions which preceded healing.

A healthy scar, when recently formed, has a smooth, glossy surface of a
pinkish colour, which tends to become whiter as a result of obliteration
of the blood vessels concerned in its formation.

_Weak Scars._--A scar is said to be weak when it readily breaks down as
a result of irritation or pressure. The scars resulting from severe
burns and those over amputation stumps are especially liable to break
down from trivial causes. The treatment is to excise the weak portion of
the scar and bring the edges of the gap together.

_Contracted scars_ frequently cause deformity either by displacing
parts, such as the eyelid or lip, or by fixing parts and preventing the
normal movements--for example, a scar on the flexor aspect of a joint
may prevent extension of the forearm (Fig. 63). These are treated by
dividing the scar, correcting the deformity, and filling up the gap with
epithelial grafts, or with a flap of the whole thickness of the skin.
When deformity results from _depression of a scar_, as is not uncommon
after the healing of a sinus, the treatment is to excise the scar.
Depressed scars may be raised by the injection of paraffin into the
subcutaneous tissue.

_Painful Scars._--Pain in relation to a scar is usually due to nerve
fibres being compressed or stretched in the cicatricial tissue; and in
some cases to ascending neuritis. The treatment consists in excising the
scar or in stretching or excising a portion of the nerve affected.

_Pigmented or Discoloured Scars._--The best-known examples are the blue
coloration which results from coal-dust or gunpowder, the brown scars
resulting from chronic ulcer with venous congestion of the leg, and the
variously coloured scars caused by tattooing. The only satisfactory
method of getting rid of the coloration is to excise the scar; the edges
are brought together by sutures, or the raw surface is covered with
skin-grafts according to the size of the gap.

_Hypertrophied Scars._--Scars occasionally broaden out and become
prominent, and on exposed parts this may prove a source of
disappointment after operations such as those for goitre or tuberculous
glands in the neck. There is sometimes considerable improvement from
exposure to the X-rays.

_Keloid._--This term is applied to an overgrowth of scar tissue which
extends beyond the area of the original wound, and the name is derived
from the fact that this extension occurs in the form of radiating
processes, suggesting the claws of a crab. It is essentially a fibroma
or new growth of fibrous tissue, which commences in relation to the
walls of the smaller blood vessels; the bundles of fibrous tissue are
for the most part parallel with the surface, and the epidermis is
tightly stretched over them. It is more frequent in the negro and in
those who are, or have been, the subjects of tuberculous disease.

[Illustration: FIG. 106.--Recurrent Keloid in scar left by operation for
tuberculous glands in a girl aet. 7.]

Keloid may attack scars of any kind, such as those resulting from
leech-bites, acne pustules, boils or blisters; those resulting from
operation or accidental wounds; and the scars resulting from burns,
especially when situated over the sternum, appear to be specially
liable. The scar becomes more and more conspicuous, is elevated above
the surface, of a pinkish or brownish-pink pink colour, and sends out
irregular prolongations around its margins. The patient may complain of
itching and burning, and of great sensitiveness of the scar, even to
contact with the clothing.

There is a natural hesitation to excise keloid because of the fear of
its returning in the new scar. The application of radium is, so far as
we know, the only means of preventing such return. The irritation
associated with keloid may be relieved by the application of salicylic
collodion or of salicylic and creosote plaster.

_Epithelioma_ is liable to attack scars in old people, especially those
which result from burns sustained early in childhood and have never
really healed. From the absence of lymphatics in scar tissue, the
disease does not spread to the glands until it has invaded the tissues
outside the scar; the prognosis is therefore better than in epithelioma
in general. It should be excised widely; in the lower extremity when
there is also extensive destruction of tissue from an antecedent chronic
ulcer or osteomyelitis, it may be better to amputate the limb.


AFFECTION OF THE NAILS

_Injuries._--When a nail is contused or crushed, blood is extravasated
beneath it, and the nail is usually shed, a new one growing in its
place. A splinter driven underneath the nail causes great pain, and if
organisms are carried in along with it, may give rise to infective
complications. The free edge of the nail should be clipped away to allow
of the removal of the foreign body and the necessary disinfection.

_Trophic Changes._--The growth of the nails may be interfered with in
any disturbance of the general health. In nerve lesions, such as a
divided nerve-trunk, the nails are apt to suffer, becoming curved,
brittle, or furrowed, or they may be shed.

_Onychia_ is the term applied to an infection of the soft parts around
the nail or of the matrix beneath it. The commonest form of onychia has
already been referred to with whitlow. There is a superficial variety
resulting from the extension of a purulent blister beneath the nail
lifting it up from its bed, the pus being visible through the nail. The
nail as well as the raised horny layer of the epidermis should be
removed. A deeper and more troublesome onychia results from infection at
the nail-fold; the infection spreads slowly beneath the fold until it
reaches the matrix, and a drop or two of pus forms beneath the nail,
usually in the region of the lunule. This affection entails a
disability of the finger which may last for weeks unless it is properly
treated. Treatment by hyperaemia, using a suction bell, should first be
tried, and, failing improvement, the nail-fold and lunule should be
frozen, and a considerable portion removed with the knife; if only a
small portion of the nail is removed, the opening is blocked by
granulations springing from the matrix. A new nail is formed, but it is
liable to be misshapen.

_Tuberculous onychia_ is met with in children and adolescents. It
appears as a livid or red swelling at the root of the nail and spreading
around its margins. The epidermis, which is thin and shiny, gives way,
and the nail is usually shed.

[Illustration: FIG. 107.--Subungual Exostosis growing from Distal
Phalanx of Great Toe, showing Ulceration of Skin and Displacement of
Nail.

_a._ Surface view.   _b._ On section.]

_Syphilitic_ affections of the nails assume various aspects. A primary
chancre at the edge of the nail may be mistaken for a whitlow,
especially if it is attended with much pain. Other forms of onychia
occur during secondary syphilis simultaneously with the skin eruptions,
and may prove obstinate and lead to shedding of the nails. They also
occur in inherited syphilis. In addition to general treatment, an
ointment containing 5 per cent. of oleate of mercury should be applied
locally.

_Ingrowing Toe-nail._--This is more accurately described as an
overgrowth of the soft tissues along the edge of the nail. It is most
frequently met with in the great toe in young adults with flat-foot
whose feet perspire freely, who wear ill-fitting shoes, and who cut
their toe-nails carelessly or tear them with their fingers. Where the
soft tissues are pressed against the edge of the nail, the skin gives
way and there is the formation of exuberant granulations and of
discharge which is sometimes foetid. The affection is a painful one and
may unfit the patient for work. In mild cases the condition may be
remedied by getting rid of contributing causes and by disinfecting the
skin and nail; the nail is cut evenly, and the groove between it and the
skin packed with an antiseptic dusting-powder, such as boracic acid. In
more severe cases it may be necessary to remove an ellipse of tissue
consisting of the edge of the nail, together with the subjacent matrix
and the redundant nail-fold.

_Subungual exostosis_ is an osteoma growing from the terminal phalanx of
the great toe (Fig. 107). It raises the nail and may be accompanied by
ulceration of the skin over the most prominent part of the growth. The
soft parts, including the nail, should be reflected towards the dorsum
in the form of a flap, the base of the exostosis divided with the
chisel, and the exostosis removed.

_Malignant disease_ in relation to the nails is rare. Squamous
epithelioma and melanotic cancer are the forms met with. Treatment
consists in amputating the digit concerned, and in removing the
associated lymph glands.




CHAPTER XVIII

THE MUSCLES, TENDONS, AND TENDON SHEATHS


INJURIES: _Contusion_; _Sprain_; _Rupture_--Hernia of
    muscle--Dislocation of tendons--Wounds--Avulsion of tendon.
    DISEASES OF MUSCLE AND OF TENDONS: _Atrophy_; _"Muscular
    rheumatism"_--_Fibrositis_; _Contracture_; _Myositis_;
    _Calcification and Ossification_; _Tumours_. DISEASES OF TENDON
    SHEATHS: _Teno-synovitis_.


INJURIES

#Contusion of Muscle.#--Contusion of muscle, which consists in bruising
of its fibres and blood vessels, may be due to violence acting from
without, as in a blow, a kick, or a fall; or from within, as by the
displacement of bone in a fracture or dislocation.

The symptoms are those common to all contusions, and the patient
complains of severe pain on attempting to use the muscle, and maintains
an attitude which relaxes it. If the sheath of the muscle also is torn,
there is subcutaneous ecchymosis, and the accumulation of blood may
result in the formation of a haematoma.

Restoration of function is usually complete; but when the nerve
supplying the muscle is bruised at the same time, as may occur in the
deltoid, wasting and loss of function may be persistent. In exceptional
cases the process of repair may be attended with the formation of bone
in the substance of the muscle, and this may likewise impair its
function.

A contused muscle should be placed at rest and supported by cotton wool
and a bandage; after an interval, massage and appropriate exercises are
employed.

#Sprain and Partial Rupture of Muscle.#--This lesion consists in
overstretching and partial rupture of the fibres of a muscle or its
aponeurosis. It is of common occurrence in athletes and in those who
follow laborious occupations. It may follow upon a single or repeated
effort--especially in those who are out of training. Familiar examples
of muscular sprain are the "labourer's" or "golfer's back," affecting
the latissimus dorsi or the sacrospinalis (erector spinae); the
"tennis-player's elbow," and the "sculler's sprain," affecting the
muscles and ligaments about the elbow; the "angler's elbow," affecting
the common origin of the extensors and supinators; the "sprinter's
sprain," affecting the flexors of the hip; and the "jumper's and
dancer's sprain," affecting the muscles of the calf. The patient
complains of pain, often sudden in onset, of tenderness on pressure, and
of inability to carry out the particular movement by which the sprain
was produced. The disability varies in different cases, and it may
incapacitate the patient from following his occupation or sport for
weeks or, if imperfectly treated, even for months.

The _treatment_ consists in resting the muscle from the particular
effort concerned in the production of the sprain, in gently exercising
it in other directions, in the use of massage, and the induction of
hyperaemia by means of heat. In neglected cases, that is, where the
muscle has not been exercised, the patient shrinks from using it and the
disablement threatens to be permanent; it is sometimes said that
adhesions have formed and that these interfere with the recovery of
function. The condition may be overcome by graduated movements or by a
sudden forcible movement under an anaesthetic. These cases afford a
fruitful field for the bone-setter.

#Rupture of Muscle or Tendon.#--A muscle or a tendon may be ruptured in
its continuity or torn from its attachment to bone. The site of rupture
in individual muscles is remarkably constant, and is usually at the
junction of the muscular and tendinous portions. When rupture takes
place through the belly of a muscle, the ends retract, the amount of
retraction depending on the length of the muscle, and the extent of its
attachment to adjacent aponeurosis or bone. The biceps in the arm, and
the sartorius in the thigh, furnish examples of muscles in which the
separation between the ends may be considerable.

The gap in the muscle becomes filled with blood, and this in time is
replaced by connective tissue, which forms a bond of union between the
ends. When the space is considerable the connecting medium consists of
fibrous tissue, but when the ends are in contact it contains a number of
newly formed muscle fibres. In the process of repair, one or both ends
of the muscle or tendon may become fixed by adhesions to adjacent
structures, and if the distal portion of a muscle is deprived of its
nerve supply it may undergo degeneration and so have its function
impaired.

Rupture of a muscle or tendon is usually the result of a sudden, and
often involuntary, movement. As examples may be cited the rupture of
the quadriceps extensor in attempting to regain the balance when falling
backwards; of the gastrocnemius, plantaris, or tendo-calcaneus in
jumping or dancing; of the adductors of the thigh in gripping a horse
when it swerves--"rider's sprain"; of the abdominal muscles in vomiting,
and of the biceps in sudden movements of the arm. Sometimes the effort
is one that would scarcely be thought likely to rupture a muscle, as in
the case recorded by Pagenstecher, where a professional athlete, while
sitting at table, ruptured his biceps in a sudden effort to catch a
falling glass. It would appear that the rupture is brought about not so
much by the contraction of the muscle concerned, as by the contraction
of the antagonistic muscles taking place before that of the muscle which
undergoes rupture is completed. The violent muscular contractions of
epilepsy, tetanus, or delirium rarely cause rupture.

The _clinical features_ are usually characteristic. The patient
experiences a sudden pain, with the sensation of being struck with a
whip, and of something giving way; sometimes a distant snap is heard.
The limb becomes powerless. At the seat of rupture there is tenderness
and swelling, and there may be ecchymosis. As the swelling subsides, a
gap may be felt between the retracted ends, and this becomes wider when
the muscle is thrown into contraction. If untreated, a hard, fibrous
cord remains at the seat of rupture.

_Treatment._--The ends are approximated by placing the limb in an
attitude which relaxes the muscle, and the position is maintained by
bandages, splints, or special apparatus. When it is impossible thus to
approximate the ends satisfactorily, the muscle or tendon is exposed by
incision, and the ends brought into accurate contact by catgut sutures.
This operation of primary suture yields the most satisfactory results,
and is most successful when it is done within five or six days of the
accident. Secondary suture after an interval of months is rendered
difficult by the retraction of the ends and by their adhesion to
adjacent structures.

_Rupture of the biceps of the arm_ may involve the long or the short
head, or the belly of the muscle. Most interest attaches to rupture of
the long tendon of origin. There is pain and tenderness in front of the
upper end of the humerus, the patient is unable to abduct or to elevate
the arm, and he may be unable to flex the elbow when the forearm is
supinated. The long axis of the muscle, instead of being parallel with
the humerus, inclines downwards and outwards. When the patient is asked
to contract the muscle, its belly is seen to be drawn towards the
elbow.

The _adductor longus_ may be ruptured, or torn from the pubes, by a
violent effort to adduct the limb. A swelling forms in the upper and
medial part of the thigh, which becomes smaller and harder when the
muscle is thrown into contraction.

The _quadriceps femoris_ is usually ruptured close to its insertion into
the patella, in the attempt to avoid falling backwards. The injury is
sometimes bilateral. The injured limb is rendered useless for
progression, as it suddenly gives way whenever the knee is flexed.
Treatment is conducted on the same lines as in transverse fracture of
the patella; in the majority of cases the continuity of the quadriceps
should be re-established by suture within five or six days of the
accident.

The _tendo calcaneus_ (Achillis) is comparatively easily ruptured, and
the symptoms are sometimes so slight that the nature of the injury may
be overlooked. The limb should be put up with the knee flexed and the
toes pointed. This may be effected by attaching one end of an elastic
band to the heel of a slipper, and securing the other to the lower third
of the thigh. If this is not sufficient to bring the ends into
apposition they should be approximated by an open operation.

The _plantaris_ is not infrequently ruptured from trivial causes, such
as a sudden movement in boxing, tennis, or hockey. A sharp stinging pain
like the stroke of a whip is felt in the calf; there is marked
tenderness at the seat of rupture, and the patient is unable to raise
the heel without pain. The injury is of little importance, and if the
patient does not raise the heel from the ground in walking, it is
recovered from in a couple of weeks or so, without it being necessary to
lay him up.

#Hernia of Muscle.#--This is a rare condition, in which, owing to the
fascia covering a muscle becoming stretched or torn, the muscular
substance is protruded through the rent. It has been observed chiefly in
the adductor longus. An oval swelling forms in the upper part of the
thigh, is soft and prominent when the muscle is relaxed, less prominent
when it is passively extended, and disappears when the muscle is thrown
into contraction. It is liable to be mistaken, according to its
situation, for a tumour, a cyst, a pouched vein, or a femoral or
obturator hernia. Treatment is only called for when it is causing
inconvenience, the muscle being exposed by a suitable incision, the
herniated portion excised, and the rent in the sheath closed by sutures.

#Dislocation of Tendons.#--Tendons which run in grooves may be displaced
as a result of rupture of the confining sheath. This injury is met with
chiefly in the tendons at the ankle and in the long tendon of the
biceps.

Dislocation of the _peronei tendons_ may occur, for example, from a
violent twist of the foot. There is severe pain and considerable
swelling on the lateral aspect of the ankle; the peroneus longus by
itself, or together with the brevis, can be felt on the lateral aspect
or in front of the lateral malleolus; the patient is unable to move the
foot. By a little manipulation the tendons are replaced in their
grooves, and are retained there by a series of strips of plaster. At the
end of three weeks massage and exercises are employed.

In other cases there is no history of injury, but whenever the foot is
everted the tendon of the peroneus longus is liable to be jerked
forwards out of its groove, sometimes with an audible snap. The patient
suffers pain and is disabled until the tendon is replaced. Reduction is
easy, but as the displacement tends to recur, an operation is required
to fix the tendon in its place. An incision is made over the tendon; if
the sheath is slack or torn, it is tightened up or closed with catgut
sutures; or an artificial sheath is made by raising up a quadrilateral
flap of periosteum from the lateral aspect of the fibula, and stitching
it over the tendon.

Similarly the _tibialis posterior_ may be displaced over the medial
malleolus as a result of inversion of the foot.

The _long tendon of the biceps_ may be dislocated laterally--or more
frequently medially--as a result of violent or repeated rotation
movements of the arm, such as are performed in wringing clothes. The
patient is aware of the displacement taking place, and is unable to
extend the forearm until the displaced tendon has been reduced by
abducting the arm. In recurrent cases the patient may be able to
dislocate the tendon at will, but the disability is so inconsiderable
that there is rarely any occasion for interference.

#Wounds of Muscles and Tendons.#--When a muscle is cut across in a
wound, its ends should be brought together with sutures. If the ends are
allowed to retract, and especially if the wound suppurates, they become
united by scar tissue and fixed to bone or other adjacent structure. In
a limb this interferes with the functions of the muscle; in the
abdominal wall the scar tissue may stretch, and so favour the
development of a ventral hernia.

Tendons may be cut across accidentally, especially in those wounds so
commonly met with above the wrist as a result, for example, of the hand
being thrust through a pane of glass. It is essential that the ends
should be sutured to each other, and as the proximal end is retracted
the original wound may require to be enlarged in an upward direction.
When primary suture has been omitted, or has failed in consequence of
suppuration, the separated ends of the tendon become adherent to
adjacent structures, and the function of the associated muscle is
impaired or lost. Under these conditions the operation of secondary
suture is indicated.

A free incision is necessary to discover and isolate the ends of the
tendon; if the interval is too wide to admit of their being approximated
by sutures, means must be taken to lengthen the tendon, or one from some
other part may be inserted in the gap. A new sheath may be provided for
the tendon by resecting a portion of the great saphenous vein.

_Injuries of the tendons of the fingers_ are comparatively common. One
of the best known is the partial or complete rupture of the aponeurosis
of the extensor tendon close to its insertion into the terminal
phalanx--_drop-_ or _mallet-finger_. This may result from comparatively
slight violence, such as striking the tip of the extended finger against
an object, or the violence may be more severe, as in attempting to catch
a cricket ball or in falling. The terminal phalanx is flexed towards the
palm and the patient is unable to extend it. The treatment consists in
putting up the finger with the middle joint strongly flexed. In
neglected cases, a perfect functional result can only be obtained by
operation; under a local anaesthetic, the ruptured tendon is exposed and
is sutured to the base of the phalanx, which may be drilled for the
passage of the sutures.

_Subcutaneous rupture_ of one or other _of the digital tendons_ in the
hand or at the wrist can be remedied only by operation. When some time
has elapsed since the accident, the proximal end may be so retracted
that it cannot be brought down into contact with the distal end, in
which case a slip may be taken from an adjacent tendon; in the case of
one of the extensors of the thumb, the extensor carpi radialis longus
may be detached from its insertion and stitched to the distal end of the
tendon of the thumb.

Subcutaneous _rupture of the tendon of the extensor pollicis longus_ at
the wrist takes place just after its emergence from beneath the annular
ligament; the actual rupture may occur painlessly, more frequently a
sharp pain is felt over the back of the wrist. The prominence of the
tendon, which normally forms the ulnar border of the snuff-box,
disappears. This lesion is chiefly met with in drummer-boys and is the
cause of drummer's palsy. The only chance of restoring function is in
uniting the ruptured tendon by open operation.

[Illustration: FIG. 108.--Avulsion of Tendon with Terminal Phalanx of
Thumb.

(Surgical Museum, University of Edinburgh.)]

_Avulsion of Tendons._--This is a rare injury, in which the tendons of a
finger or toe are torn from their attachments along with a portion of
the digit concerned. In the hand, it is usually brought about by the
fingers being caught in the reins of a runaway horse, or being seized in
a horse's teeth, or in machinery. It is usually the terminal phalanx
that is separated, and with it the tendon of the deep flexor, which
ruptures at its junction with the belly of the muscle (Fig. 108). The
treatment consists in disinfecting the wound, closing the tendon-sheath,
and trimming the mutilated finger so as to provide a useful stump.


DISEASES OF MUSCLES AND TENDONS

_Congenital absence_ of muscles is sometimes met with, usually in
association with other deformities. The pectoralis major, for example,
may be absent on one or on both sides, without, however, causing any
disability, as other muscles enlarge and take on its functions.

_Atrophy of Muscle._--Simple atrophy, in which the muscle elements are
merely diminished in size without undergoing any structural alteration,
is commonly met with as a result of disuse, as when a patient is
confined to bed for a long period.

In cases of joint disease, the muscles acting on the joint become
atrophied more rapidly than is accounted for by disuse alone, and this
is attributed to an interference with the trophic innervation of the
muscles reflected from centres in the spinal medulla. It is more marked
in the extensor than in the flexor groups of muscles. Those affected
become soft and flaccid, exhibit tremors on attempted movement, and
their excitability to the faradic current is diminished.

_Neuropathic atrophy_ is associated with lesions of the nervous system.
It is most pronounced in lesions of the motor nerve-trunks, probably
because vaso-motor and trophic fibres are involved as well as those that
are purely motor in function. It is attended with definite structural
alterations, the muscle elements first undergoing fatty degeneration,
and then being absorbed, and replaced to a large extent by ordinary
connective tissue and fat. At a certain stage the muscles exhibit the
reaction of degeneration. In the common form of paralysis resulting from
poliomyelitis, many fibres undergo fatty degeneration and are replaced
by fat, while at the same time there is a regeneration of muscle fibres.

#Fibrositis# or "#Muscular Rheumatism#."--This clinical term is applied
to a group of affections of which lumbago is the best-known example. The
group includes lumbago, stiff-neck, and pleurodynia--conditions which
have this in common, that sudden and severe pain is excited by movement
of the affected part. The lesion consists in inflammatory hyperplasia of
the connective tissue; the new tissue differs from normal fibrous tissue
in its tendency to contract, in being swollen, painful and tender on
pressure, and in the fact that it can be massaged away (Stockman). It
would appear to involve mainly the fibrous tissue of muscles, although
it may extend from this to aponeuroses, ligaments, periosteum, and the
sheaths of nerves. The term _fibrositis_ was applied to it by Gowers in
1904.

In _lumbago_--_lumbo-sacral fibrositis_--the pain is usually located
over the sacrum, the sacro-iliac joint, or the aponeurosis of the lumbar
muscles on one or both sides. The amount of tenderness varies, and so
long as the patient is still he is free from pain. The slightest
attempt to alter his position, however, is attended by pain, which may
be so severe as to render him helpless for the moment. The pain is most
marked on rising from the stooping or sitting posture, and may extend
down the back of the hip, especially if, as is commonly the case,
lumbago and gluteal fibrosis coexist. Once a patient has suffered from
lumbago, it is liable to recur, and an attack may be determined by
errors of diet, changes of weather, exposure to cold or unwonted
exertion. It is met with chiefly in male adults, and is most apt to
occur in those who are gouty or are the subjects of oxaluric dyspepsia.

_Gluteal fibrositis_ usually follows exposure to wet, and affects the
gluteal muscles, particularly the medius, and their aponeurotic
coverings. When the condition has lasted for some time, indurated
strands or nodules can be detected on palpating the relaxed muscles. The
patient complains of persistent aching and stiffness over the buttock,
and sometimes extending down the lateral aspect of the thigh. The pain
is aggravated by such movements as bring the affected muscles into
action. It is not referred to the line of the sciatic nerve, nor is
there tenderness on pressing over the nerve, or sensations of tingling
or numbness in the leg or foot.

If untreated, the morbid process may implicate the sheath of the sciatic
nerve and cause genuine sciatic neuralgia (Llewellyn and Jones). A
similar condition may implicate the fascia lata of the thigh, or the
calf muscles and their aponeuroses--_crural fibrositis_.

In _painful stiff-neck_, or "rheumatic torticollis," the pain is located
in one side of the neck, and is excited by some inadvertent movement.
The head is held stiffly on one side as in wry-neck, the patient
contracting the sterno-mastoid. There may be tenderness over the
vertebral spines or in the lines of the cervical nerves, and the
sterno-mastoid may undergo atrophy. This affection is more often met
with in children.

In _pleurodynia_--_intercostal fibrositis_--the pain is in the line of
the intercostal nerves, and is excited by movement of the chest, as in
coughing, or by any bodily exertion. There is often marked tenderness.

A similar affection is met with in the _shoulder and arm_--_brachial
fibrositis_--especially on waking from sleep. There is acute pain on
attempting to abduct the arm, and there may be localised tenderness in
the region of the axillary nerve.

_Treatment._--The general treatment is concerned with the diet,
attention to the stomach, bowels, and kidneys and with the correction
of any gouty tendencies that may be present. Remedies such as
salicylates are given for the relief of pain, and for this purpose drugs
of the aspirin type are to be preferred, and these may be followed by
large doses of iodide of potassium. Great benefit is derived from
massage, and from the induction of hyperaemia by means of heat. Cupping
or needling, or, in exceptional cases, hypodermic injections of
antipyrin or morphin, may be called for. To prevent relapses of lumbago,
the patient must take systematic exercises of all kinds, especially such
as bring out the movements of the vertebral column and hip-joints.

[Illustration: FIG. 109.--Volkmann's Ischaemic Contracture. When the
wrist is flexed to a right angle it is possible to extend the fingers.

(Photographs lent by Mr. Lawford Knaggs)]

#Contracture of Muscles.#--Permanent shortening of muscles results from
the prolonged approximation of their points of attachment, or from
structural changes in their substance produced by injury or by disease.
It is a frequent accompaniment and sometimes a cause of deformities, in
the treatment of which lengthening of the shortened muscles or their
tendons may be an essential step.

#Myositis.#--_Ischaemic Myositis._--Volkmann was the first to describe a
form of myositis followed by contracture, resulting from interference
with the arterial blood supply. It is most frequently observed in the
flexor muscles of the forearm in children and young persons under
treatment for fractures in the region of the elbow, the splints and
bandages causing compression of the blood vessels. There is considerable
effusion of blood, the skin is tense, and the muscles, vessels, and
nerves are compressed; this is further increased if the elbow is flexed
and splints and tight bandages are applied. The muscles acquire a
board-like hardness and no longer contract under the will, and passive
motion is painful and restricted. Slight contracture of the fingers is
usually the first sign of the malady; in time the muscles undergo
further contraction, and this brings about a claw-like deformity of the
hand. The affected muscles usually show the reaction of degeneration. In
severe cases the median and ulnar nerves are also the seat of
cicatricial changes (ischaemic neuritis).

By means of splints, the interphalangeal, metacarpo-phalangeal, and
wrist joints should be gradually extended until the deformity is
over-corrected (R. Jones). Murphy advises resection of the radius and
ulna sufficient to admit of dorsiflexion of the joints and lengthening
of the flexor tendons.

Various forms of _pyogenic_ infection are met with in muscle, most
frequently in relation to pyaemia and to typhoid fever. These may result
in overgrowth of the connective-tissue framework of the muscle and
degeneration of its fibres, or in suppuration and the formation of one
or more abscesses in the muscle substance. Repair may be associated with
contracture.

A _gonorrhoeal_ form of myositis is sometimes met with; it is painful,
but rarely goes on to suppuration.

In the early secondary period of _syphilis_, the muscles may be the seat
of dull, aching, nocturnal pains, especially in the neck and back.
_Syphilitic contracture_ is a condition which has been observed chiefly
in the later secondary period; the biceps of the arm and the hamstrings
in the thigh are the muscles more commonly affected. The striking
feature is a gradually increasing difficulty of extending the limb at
the elbow or knee, and progressive flexion of the joint. The affected
muscle is larger and firmer than normal, and its electric excitability
is diminished. In tertiary syphilis, individual muscles may become the
seat of interstitial myositis or of gummata, and these affections
readily yield to anti-syphilitic remedies.

_Tuberculous disease_ in muscle, while usually due to extension from
adjacent tissues, is sometimes the result of a primary infection through
the blood-stream. Tuberculous nodules are found disseminated throughout
the muscle; the surrounding tissues are indurated, and central caseation
may take place and lead to abscess formation and sinuses. We have
observed this form of tuberculous disease in the gastrocnemius and in
the psoas--in the latter muscle apart from tuberculous disease in the
vertebrae.

#Tendinitis.#--German authors describe an inflammation of tendon as
distinguished from inflammation of its sheath, and give it the name
tendinitis. It is met with most frequently in the tendo-calcaneus in
gouty and rheumatic subjects who have overstrained the tendon,
especially during cold and damp weather. There is localised pain which
is aggravated by walking, and the tendon is sensitive and swollen from a
little above its insertion to its junction with the muscle. Gouty
nodules may form in its substance. Constitutional measures, massage, and
douching should be employed, and the tendon should be protected from
strain.

#Calcification and Ossification in Muscles, Tendons, and
Fasciae.#--_Myositis ossificans._--Ossifications in muscles, tendons,
fasciae, and ligaments, in those who are the subjects of arthritis
deformans, are seldom recognised clinically, but are frequently met with
in dissecting-rooms and museums. Similar localised ossifications are met
with in Charcot's disease of joints, and in fractures which have
repaired with exuberant callus. The new bone may be in the form of
spicules, plates, or irregular masses, which, when connected with a
bone, are called _false exostoses_ (Fig. 110).

[Illustration: FIG. 110.--Ossification in Tendon of Ilio-psoas Muscle.]

_Traumatic Ossification in Relation to Muscle._--Various forms of
ossification are met with in muscle as the result of a single or of
repeated injury. Ossification in the crureus or vastus lateralis muscle
has been frequently observed as a result of a kick from a horse. Within
a week or two a swelling appears at the site of injury, and becomes
progressively harder until its consistence is that of bone. If the mass
of new bone moves with the affected muscle, it causes little
inconvenience. If, as is commonly the case, it is fixed to the femur,
the action of the muscle is impaired, and the patient complains of pain
and difficulty in flexing the knee. A skiagram shows the extent of the
mass and its relationship to the femur. The treatment consists in
excising the bony mass.

Difficulty may arise in differentiating such a mass of bone from
sarcoma; the ossification in muscle is uniformly hard, while the sarcoma
varies in consistence at different parts, and the X-ray picture shows a
clear outline of the bone in the vicinity of the ossification in
muscle, whereas in sarcoma the involvement of the bone is shown by
indentations and irregularity in its contour.

A similar ossification has been observed in relation to the insertion of
the brachialis muscle as a sequel of dislocation of the elbow. After
reduction of the dislocation, the range of movement gradually diminishes
and a hard swelling appears in front of the lower end of the humerus.
The lump continues to increase in size and in three to four weeks the
disability becomes complete. A radiogram shows a shadow in the muscle,
attached at one part as a rule to the coronoid process. During the next
three or four months, the lump in front of the elbow remains stationary
in size; a gradual decrease then ensues, but the swelling persists, as a
rule, for several years.

[Illustration: FIG. 111.--Calcification and Ossification in Biceps and
Triceps.

(From a radiogram lent by Dr. C. A. Adair Dighton.)]

Ossification in the adductor longus was first described by Billroth
under the name of "rider's bone." It follows bruising and partial
rupture of the muscle, and has been observed chiefly in cavalry
soldiers. If it causes inconvenience the bone may be removed by
operation.

Ossification in the deltoid and pectoral muscles has been observed in
foot-soldiers in the German army, and has received the name of
"drill-bone"; it is due to bruising of the muscle by the recoil of the
rifle.

_Progressive Ossifying Myositis._--This is a rare and interesting
disease, in which the muscles, tendons, and fasciae throughout the body
become the seat of ossification. It affects almost exclusively the male
sex, and usually begins in childhood or youth, sometimes after an
injury, sometimes without apparent cause. The muscles of the back,
especially the trapezius and latissimus, are the first to be affected,
and the initial complaint is limitation of movement.

[Illustration: FIG. 112.--Ossification in Muscles of Trunk in a case of
generalised Ossifying Myositis.

(Photograph lent by Dr. Rustomjee.)]

The affected muscles show swellings which are rounded or oval, firm and
elastic, sharply defined, without tenderness and without discoloration
of the overlying skin. Skiagrams show that a considerable deposit of
lime salts may precede the formation of bone, as is seen in Fig. 111. In
course of time the vertebral column becomes rigid, the head is bent
forward, the hips are flexed, and abduction and other movements of the
arms are limited. The disease progresses by fits and starts, until all
the striped muscles of the body are replaced by bone, and all movements,
even those of the jaws, are abolished. The subjects of this disease
usually succumb to pulmonary tuberculosis.

There is no means of arresting the disease, and surgical treatment is
restricted to the removal or division of any mass of bone that
interferes with an important movement.

A remarkable feature of this disease is the frequent presence of a
deformity of the great toe, which usually takes the form of hallux
valgus, the great toe coming to lie beneath the second one; the
shortening is usually ascribed to absence of the first phalanx, but it
has been shown to depend also on a synostosis and imperfect development
of the phalanges. A similar deformity of the thumb is sometimes met
with.

Microscopical examination of the muscles shows that, prior to the
deposition of lime salts and the formation of bone, there occurs a
proliferation of the intra-muscular connective tissue and a gradual
replacement and absorption of the muscle fibres. The bone is spongy in
character, and its development takes place along similar lines to those
observed in ossification from the periosteum.

#Tumours of Muscle.#--With the exception of congenital varieties, such
as the rhabdomyoma, tumours of muscle grow from the connective-tissue
framework and not from the muscle fibres. Innocent tumours, such as the
fibroma, lipoma, angioma, and neuro-fibroma, are rare. Malignant tumours
may be primary in the muscle, or may result from extension from adjacent
growths--for example, implication of the pectoral muscle in cancer of
the breast--or they may be derived from tumours situated elsewhere. The
diagnosis of an intra-muscular tumour is made by observing that the
swelling is situated beneath the deep fascia, that it becomes firm and
fixed when the muscle contracts, and that, when the muscle is relaxed,
it becomes softer, and can be moved in the transverse axis of the
muscle, but not in its long axis.

Clinical interest attaches to that form of slowly growing
fibro-sarcoma--_the recurrent fibroid of Paget_--which is most
frequently met with in the muscles of the abdominal wall. A rarer
variety is the ossifying chondro-sarcoma, which undergoes ossification
to such an extent as to be visible in skiagrams.

In primary sarcoma the treatment consists in removing the muscle. In the
limbs, the function of the muscle that is removed may be retained by
transplanting an adjacent muscle in its place.

_Hydatid cysts_ of muscle resemble those developing in other tissues.


DISEASES OF TENDON SHEATHS

Tendon sheaths have the same structure and function as the synovial
membranes of joints, and are liable to the same diseases. Apart from the
tendon sheaths displayed in anatomical dissections, there is a loose
peritendinous and perimuscular cellular tissue which is subject to the
same pathological conditions as the tendon sheaths proper.

#Teno-synovitis.#--The toxic or infective agent is conveyed to the
tendon sheaths through the blood-stream, as in the gouty, gonorrhoeal,
and tuberculous varieties, or is introduced directly through a wound, as
in the common pyogenic form of teno-synovitis.

_Teno-synovitis Crepitans._--In the simple or traumatic form of
teno-synovitis, although the most prominent etiological factor is a
strain or over-use of the tendon, there would appear to be some other,
probably a toxic, factor in its production, otherwise the affection
would be much more common than it is: only a small proportion of those
who strain or over-use their tendons become the subjects of
teno-synovitis. The opposed surfaces of the tendon and its sheath are
covered with fibrinous lymph, so that there is friction when they move
on one another.

The _clinical features_ are pain on movement, tenderness on pressure
over the affected tendon, and a sensation of crepitation or friction
when the tendon is moved in its sheath. The crepitation may be soft like
the friction of snow, or may resemble the creaking of new
leather--"saddle-back creaking." There may be swelling in the long axis
of the tendon, and redness and oedema of the skin. If there is an
effusion of fluid into the sheath, the swelling is more marked and
crepitation is absent. There is little tendency to the formation of
adhesions.

In the upper extremity, the sheath of the long tendon of the biceps may
be affected, but the condition is most common in the tendons about the
wrist, particularly in the extensors of the thumb, and it is most
frequently met with in those who follow occupations which involve
prolonged use or excessive straining of these tendons--for example,
washerwomen or riveters. It also occurs as a result of excessive
piano-playing, fencing, or rowing.

At the ankle it affects the peronei, the extensor digitorum longus, or
the tibialis anterior. It is most often met with in relation to the
tendo-calcaneus--_Achillo-dynia_--and results from the pressure of
ill-fitting boots or from the excessive use and strain of the tendon in
cycling, walking, or dancing. There is pain in raising the heel from the
ground, and creaking can be felt on palpation.

The _treatment_ consists in putting the affected tendon at rest, and
with this object a splint may be helpful; the usual remedies for
inflammation are indicated: Bier's hyperaemia, lead and opium
fomentations, and ichthyol and glycerine. The affection readily subsides
under treatment, but is liable to relapse on a repetition of the
exciting cause.

_Gouty Teno-synovitis._--A deposit of urate of soda beneath the
endothelial covering of tendons or of that lining their sheaths is
commonly met with in gouty subjects. The accumulation of urates may
result in the formation of visible nodular swellings, varying in size
from a pea to a cherry, attached to the tendon and moving with it. They
may be merely unsightly, or they may interfere with the use of the
tendon. Recurrent attacks of inflammation are prone to occur. We have
removed such gouty masses with satisfactory results.

_Suppurative Teno-synovitis._--This form usually follows upon infected
wounds of the fingers--especially of the thumb or little finger--and is
a frequent sequel to whitlow; it may also follow amputation of a finger.
Once the infection has gained access to the sheath, it tends to spread,
and may reach the palm or even the forearm, being then associated with
cellulitis. In moderately acute cases the tendon and its sheath become
covered with granulations, which subsequently lead to the formation of
adhesions; while in more acute cases the tendon sloughs. The pus may
burst into the cellular tissue outside the sheath, and the suppuration
is liable to spread to neighbouring sheaths or to adjacent bones or
joints--for example, those of the wrist.

The _treatment_ consists in inducing hyperaemia and making small
incisions for the escape of pus. The site of incision is determined by
the point of greatest tenderness on pressure. After the inflammation has
subsided, active and passive movements are employed to prevent the
formation of adhesions between the tendon and its sheath. If the tendon
sloughs, the dead portion should be cut away, as its separation is
extremely slow and is attended with prolonged suppuration.

_Gonorrhoeal Teno-synovitis._--This is met with especially in the tendon
sheaths about the wrist and ankle. It may occur in a mild form, with
pain, impairment of movement, and oedema, and sometimes an elongated,
fluctuating swelling, the result of serous effusion into the sheath.
This condition may alternate with a gonorrhoeal affection of one of the
larger joints. It may subside under rest and soothing applications, but
is liable to relapse. In the more severe variety the skin is red, and
the swelling partakes of the characters of a phlegmon with threatening
suppuration; it may result in crippling from adhesions. Even if pus
forms in the sheath, the tendon rarely sloughs. The treatment consists
in inducing hyperaemia by Bier's method; and a vaccine may be employed
with satisfactory results.

#Tuberculous Disease of Tendon Sheaths.#--This is a comparatively common
affection, and is analogous to tuberculous disease of the synovial
membrane of joints. It may originate in the sheath, or may spread to it
from an adjacent bone.

The commonest form--hydrops--is that in which the synovial sheath is
distended with a viscous fluid, and the fibrinous material on the free
surface becomes detached and is moulded into melon-seed bodies by the
movement of the tendon. The sheath itself is thickened by the growth of
tuberculous granulation tissue. The bodies are smooth and of a
dull-white colour, and vary greatly in size and shape. There may be an
overgrowth of the fatty fringes of the synovial sheath, a condition
described as "arborescent lipoma."

The _clinical features_ vary with the tendon sheath affected. In the
common flexor sheath of the hand an hour-glass-shaped swelling is
formed, bulging above and below the transverse carpal (anterior annular)
ligament--formerly known as _compound palmar ganglion_. There is little
or no pain, but the fingers tend to be stiff and weak, and to become
flexed. On palpation, it is usually possible to displace the contents of
the sheath from one compartment to the other, and this may yield
fluctuation, and, what is more characteristic, a peculiar soft crepitant
sensation from the movement of the melon-seed bodies. In the sheath of
the peronei or other tendons about the ankle, the swelling is
sausage-shaped, and is constricted opposite the annular ligament.

The onset and progress of the affection are most insidious, and the
condition may remain stationary for long periods. It is aggravated by
use or strain of the tendons involved. In exceptional cases the skin is
thinned and gives way, resulting in the formation of a sinus.

_Treatment._--In the common flexor sheath of the palm, an attempt may be
made to cure the condition by removing the contents through a small
incision and filling the cavity with iodoform glycerine, followed by the
use of Bier's bandage. If this fails, the distended sheath is laid open,
the contents removed, the wall scraped, and the wound closed.

A less common form of tuberculous disease is that in which the sheath
becomes the seat of _a diffuse tuberculous thickening_, not unlike the
white swelling met with in joints, and with a similar tendency to
caseation. A painless swelling of an elastic character forms in relation
to the tendon sheath. It is hour-glass-shaped in the common flexor
sheath of the palm, elongated or sausage-shaped in the extensors of the
wrist and in the tendons at the ankle. The tuberculous granulation
tissue is liable to break down and lead to the formation of a cold
abscess and sinuses, and in our experience is often associated with
disease in an adjacent bone or joint. In the peronei tendons, for
example, it may result from disease of the fibula or of the ankle-joint.

When conservative measures fail, excision of the affected sheath should
be performed; the whole of the diseased area being exposed by free
incision of the overlying soft parts, the sheath is carefully isolated
from the surrounding tissues and is cut across above and below. Any
tuberculous tissue on the tendon itself is removed with a sharp spoon.
Associated bone or joint lesions are dealt with at the same time. In the
after-treatment the functions of the tendons must be preserved by
voluntary and passive movements.

#Syphilitic Affections of Tendon Sheaths.#--These closely resemble the
syphilitic affections of the synovial membrane of joints. During the
secondary period the lesion usually consists in effusion into the
sheath; gummata are met with during the tertiary period.

Arborescent lipoma has been found in the sheaths of tendons about the
wrist and ankle, sometimes in a multiple and symmetrical form,
unattended by symptoms and disappearing under anti-syphilitic treatment.

#Tumours of Tendon Sheaths.#--Innocent tumours, such as _lipoma_,
_fibroma_, and _myxoma_, are rare. Special mention should be made of the
_myeloma_ which is met with at the wrist or ankle as an elongated
swelling of slow development, or over the phalanx of a finger as a small
rounded swelling. The tumour tissue, when exposed by dissection, is of a
chocolate or chamois-yellow colour, and consists almost entirely of
giant cells. The treatment consists in dissecting the tumour tissue off
the tendons, and this is usually successful in bringing about a
permanent cure.

All varieties of _sarcoma_ are met with, but their origin from tendon
sheaths is not associated with special features.




CHAPTER XIX

THE BURSAE


Anatomy--Normal and adventitious bursae--Injuries: Bursal
    haematoma--DISEASES: Infective bursitis; Traumatic or trade
    bursitis; Bursal hydrops; Solid bursal tumour; Gonorrhoeal and
    suppurative forms of bursitis; Tuberculous and syphilitic
    disease--Tumours--_Diseases of individual bursae in the upper and
    lower extremities_.

A bursa is a closed sac lined by endothelium and containing synovia.
Some are normally present--for instance, that between the skin and the
patella, and that between the aponeurosis of the gluteus maximus and the
great trochanter. _Adventitious bursae_ are developed as a result of
abnormal pressure--for example, over the tarsal bones in cases of
club-foot.

#Injuries of Bursae.#--As a result of contusion, especially in bleeders,
haemorrhage may occur into the cavity of a bursa and give rise to a
_bursal haematoma_. Such a haematoma may mask a fracture of the bone
beneath--for example, fracture of the olecranon.

#Diseases of Bursae.#--The lining membrane of bursae resembles that of
joints and tendon sheaths, and is liable to the same forms of disease.

#Infective bursitis# frequently follows abrasions, scratches, and wounds
of the skin over the prepatellar or olecranon bursa, and in neglected
cases the infection transgresses the wall of the bursa and gives rise to
a spreading cellulitis.

#Traumatic or Trade Bursitis.#--This term may be conveniently applied to
those affections of bursae which result from repeated slight traumatism
incident to particular occupations. The most familiar examples of these
are the enlargement of the prepatellar bursa met with in housemaids--the
"housemaid's knee" (Fig. 113); the enlargement of the olecranon
bursa--"miner's elbow"; and of the ischial bursa--"weaver's" or
"tailor's bottom" (Fig. 116). These affections are characterised by an
effusion of fluid into the sac of the bursa with thickening of its
lining membrane. While friction and pressure are the most evident
factors in their production, it is probable that there is also some
toxic agent concerned, otherwise these affections would be much more
common than they are. Of the countless housemaids in whom the
prepatellar bursa is subjected to friction and pressure, only a small
proportion become the subjects of housemaid's knee.

_Clinical Features._--As these are best illustrated in the different
varieties of prepatellar bursitis, it is convenient to take this as the
type. In a number of cases the inflammation is acute and the patient is
unable to use the limb; the part is hot, swollen, and tender, and
fluctuation can be detected in the bursa. In the majority the condition
is chronic, and the chief feature is the gradual accumulation of fluid
constituting the _bursal hydrops_ or _hygroma_. When the affection has
lasted some time, or has frequently relapsed, the wall of the bursa
becomes thickened by fibrous tissue, which may be deposited irregularly,
so that septa, bands, or fringes are formed, not unlike those met with
in arthritis deformans. These fringes may be detached and form loose
bodies like those met with in joints; less frequently there are
fibrinous bodies of the melon-seed type, sometimes moulded into circular
discs like wafers. The presence of irregular thickenings of the wall, or
of loose bodies, may be recognised on palpation, especially in
superficial bursae, if the sac is not tensely filled with fluid. The
thickening of the wall may take place in a uniform and concentric
fashion, resulting in the formation of a fibrous tumour--_the solid
bursal tumour_--a small cavity remaining in the centre which serves to
distinguish it from a new growth or neoplasm.

[Illustration: FIG. 113.--Hydrops of Prepatellar Bursa in a housemaid.]

The _treatment_ varies according to the variety and stage of the
affection. In recent cases the symptoms subside under rest and the
application of fomentations. Hydrops may be got rid of by blistering,
by tapping, or by incision and drainage. When the wall is thickened, the
most satisfactory treatment is to excise the bursa; the overlying skin
being reflected in the shape of a horse-shoe flap or being removed along
with the bursa.

#Other Diseases of Bursae# are associated with _gonorrhoeal infection_,
and with _rheumatism_, especially that following scarlet fever, and are
apt to be persistent or to relapse after apparent cure. In the _gouty_
form, urate of soda is deposited in the wall of the bursa, and may
result in the formation of chalky tumours, sometimes of considerable
size (Fig. 114).

[Illustration: FIG. 114.--Section through Bursa over external malleolus,
showing deposit of urate of soda. (Cf. Fig. 117.)]

_Tuberculous disease_ of bursae closely resembles that of tendon sheaths.
It may occur as an independent affection, or may be associated with
disease in an adjacent bone or joint. It is met with chiefly in the
prepatellar and subdeltoid bursae, or in one of the bursae over the great
trochanter. The clinical features are those of an indolent hydrops, with
or without melon-seed bodies, or of uniform thickening of the wall of
the bursa; the tuberculous granulation tissue may break down into a cold
abscess, and give rise to sinuses. The best treatment is to excise the
affected bursa, or, when this is impracticable, to lay it freely open,
remove the tuberculous tissue with the sharp spoon or knife, and treat
the cavity by the open method.

_Syphilitic disease_ is rarely recognised except in the form of bursal
and peri-bursal gummata in front of the knee-joint.

_New growths_ include the fibroma, the myxoma, the myeloma or
giant-celled tumour, and various forms of sarcoma.

#Diseases of Individual Bursae.#--The _olecranon bursa_ is frequently
the seat of pyogenic infection and of traumatic or trade bursitis, the
latter being known as "miner's" or "student's elbow."

[Illustration: FIG. 115.--Tuberculous Disease of Sub-deltoid Bursa.

(From a photograph lent by Sir George T. Beatson.)]

The _sub-deltoid_ or _sub-acromial bursa_, which usually presents a
single cavity and does not normally communicate with the shoulder-joint,
is indispensable in abduction and rotation of the humerus. When the arm
is abducted, the fixed lower part or floor of the bursa is carried under
the acromion, and the upper part or roof is rolled up in the same
direction, hence tenderness over the inflamed bursa may disappear when
the arm is abducted (Dawbarn's sign). It is liable to traumatic
affections from a fall on the shoulder, pressure, or over-use of the
limb. Pain, located commonly at the insertion of the deltoid, is a
constant symptom and is especially annoying at night, the patient being
unable to get into a comfortable position. Tenderness may be elicited
over the anatomical limits of the bursa, and is usually most marked over
the great tuberosity, just external to the inter-tubercular (bicipital)
groove. When adhesions are present, abduction beyond 10 degrees is
impossible. Demonstrable effusion is not uncommon, but is disguised by
the overlying tissues. If left to himself, the patient tends to maintain
the limb in the "sling position," and resists movements in the direction
of abduction and rotation. In the treatment of this affection the arm
should be maintained at a right angle to the body, the arm being rotated
medially (Codman). When pain does not prevent it, movements of the arm
and massage are persevered with. In neglected cases, when adhesions have
formed and the shoulder is fixed, it may be necessary to break down the
adhesions under an anaesthetic.

The bursa is also liable to infective conditions, such as acute
rheumatism, gonorrhoea, suppuration, or tubercle. In tuberculous disease
a large fluctuating swelling may form and acquire the characters of a
cold abscess (Fig. 115).

The bursa underneath the tendon of the _subscapularis_ muscle when
inflamed causes alteration in the attitude of the shoulder and
impairment of its movements.

An adventitious bursa forms over the _acromion_ process in porters and
others who carry weights on the shoulder, and may be the seat of
traumatic bursitis.

The bursa under the _tendon of insertion of the biceps_, when the seat
of disease, is attended with pain and swelling about a finger's breadth
below the bend of the elbow; there is pain and difficulty in effecting
the combined movement of flexion and supination, slight limitation of
extension, and restriction of pronation.

In the lower extremity, a large number of normal and adventitious bursae
are met with and may be the seat of bursitis. That over the _tuberosity
of the ischium_, when enlarged as a trade disease, is known as
"weaver's" or "tailor's bottom." It may form a fluctuating swelling of
great size, projecting on the buttock and extending down the thigh, and
causing great inconvenience in sitting (Fig. 116). It sometimes contains
a number of loose bodies.

There are two bursae over the _great trochanter_, one superficial to, the
other beneath the aponeurosis of the gluteus maximus; the latter is not
infrequently infected by tuberculous disease that has spread from the
trochanter.

The bursa _between the psoas muscle and the capsule of the hip-joint_
may be the seat of tuberculous disease, and give rise to clinical
features not unlike those of disease of the hip-joint. The limb is
flexed, abducted and rotated out; there is a swelling in the upper part
of Scarpa's triangle, but the movements are not restricted in directions
which do not entail putting the ilio-psoas muscle on the stretch.

Cartilaginous and partly ossified loose bodies may accumulate in the
ilio-psoas bursa and distend it, both in a downward direction towards
the hip-joint, with which it communicates, and upwards, projecting
towards the abdomen.

The bursa beneath the quadriceps extensor--_subcrural bursa_--usually
communicates with the knee-joint and shares in its diseases. When shut
off from the joint it may suffer independently, and when distended with
fluid forms a horse-shoe swelling above the patella.

In front of the patella and its ligament is the _prepatellar bursa_,
which may have one, two, or three compartments, usually communicating
with one another. It is the seat of the affection known as "housemaid's
knee," which is very common and is sometimes bilateral, and, less
frequently, of tuberculous disease which usually originates in the
patella.

[Illustration: FIG. 116.--Great Enlargement of the Ischial Bursa.

(Mr. Scot-Skirving's case.)]

The bursa _between the ligamentum patellae and the tibia_ is rarely the
seat of disease. When it is, there is pain and tenderness referred to
the ligament, the patient is unable to extend the limb completely, the
tuberosity of the tibia is apparently enlarged, and there is a
fluctuating swelling on either side of the ligament, most marked in the
extended position of the limb.

Of the numerous bursae in the popliteal space, that _between the
semi-membranosus and the medial head of the gastrocnemius_ is most
frequently the seat of disease, which is usually of the nature of a
simple hydrops, forming a fluctuating egg-or sausage-shaped swelling at
the medial side of the popliteal space. It is flaccid in the flexed, and
tense in the extended position. As a rule it causes little
inconvenience, and may be left alone. Otherwise it should be dissected
out, and if, as is frequently the case, there is a communication with
the knee-joint, this should be closed with sutures.

[Illustration: FIG. 117.--Gouty Disease of Bursae in a tailor. The bursal
tumours were almost entirely composed of urate of soda. (Cf. Fig. 114.)]

An adventitious bursa may form over the _lateral malleolus_, especially
in tailors, giving rise to the condition known as "tailor's ankle"
(Fig. 117).

The bursa _between the tendo-calcaneus (Achillis) and the upper part of
the calcaneus_ may become inflamed--especially as a result of
post-scarlatinal rheumatism or gonorrhoea. The affection is known as
Achillo-bursitis. There is severe pain in the region of the insertion of
the tendo-calcaneus, the movements at the ankle-joint are restricted,
and the patient may be unable to walk. There is a tender swelling on
either side of the tendon. When, in spite of palliative treatment, the
affection persists or relapses, it is best to excise the bursa. The
tendo-calcaneus is detached from the calcaneus, the bursa dissected out,
and the tendon replaced. If there is a bony projection from the
calcaneus, it should be shaved off with the chisel.

The bursa that is sometimes met with on the under aspect of the
calcaneus--_the subcalcanean bursa_--when inflamed, gives rise to pain
and tenderness in the sole of the foot. This affection may be associated
with a spinous projection from the bone, which is capable of being
recognised in a skiagram. The soft parts of the heel are turned forwards
as a flap, the bursa is dissected out, and the projection of bone, if
present, is removed.

The enlargement of adventitious bursae over the head of the first
metatarsal in hallux valgus; over the tarsus, metatarsus, and digits in
the different forms of club-foot; over the angular projection in Pott's
disease of the spine; over the end of the bone in amputation stumps, and
over hard tumours such as chondroma and osteoma, are described
elsewhere.




CHAPTER XX

DISEASES OF BONE


Anatomy and physiology--Regeneration of bone--Transplantation of bone.
    DISEASES OF BONE--Definition of terms--Pyogenic diseases:
    _Acute osteomyelitis and periostitis_; _Chronic and relapsing
    osteomyelitis_; _Abscess of bone_--Tuberculous disease--Syphilitic
    disease--Hydatids; Rickets; Osteomalacia--Ostitis deformans of
    Paget--Osteomyelitis fibrosa--Affections of bones in diseases of
    the nervous system--Fragilitas ossium--Tumours and cysts of bone.

#Surgical Anatomy.#--During the period of growth, a long bone such as
the tibia consists of a shaft or _diaphysis_, and two extremities or
_epiphyses_. So long as growth continues there intervenes between the
shaft and each of the epiphyses a disc of actively growing
cartilage--_the epiphysial cartilage_; and at the junction of this
cartilage with the shaft is a zone of young, vascular, spongy bone known
as the _metaphysis_ or _epiphysial junction_. The shaft is a cylinder of
compact bone enclosing the medullary canal, which is filled with yellow
marrow. The extremities, which include the ossifying junctions, consist
of spongy bone, the spaces of which are filled with red marrow. The
articular aspect of the epiphysis is invested with a thick layer of
hyaline cartilage, known as the _articular cartilage_, which would
appear to be mainly nourished from the synovia.

The external investment--the _periosteum_--is thick and vascular during
the period of growth, but becomes thin and less vascular when the
skeleton has attained maturity. Except where muscles are attached it is
easily separated from the bone; at the extremities it is intimately
connected with the epiphysial cartilage and with the epiphysis, and at
the margin of the latter it becomes continuous with the capsule of the
adjacent joint. It consists of two layers, an outer fibrous and an inner
cellular layer; the cells, which are called osteoblasts, are continuous
with those lining the Haversian canals and the medullary cavity.

The arrangement of the _blood vessels_ determines to some extent the
incidence of disease in bone. The nutrient artery, after entering the
medullary canal through a special foramen in the cortex, bifurcates, and
one main division runs towards each of the extremities, and terminates
at the ossifying junction in a series of capillary loops projected
against the epiphysial cartilage. This arrangement favours the lodgment
of any organisms that may be circulating in the blood, and partly
accounts for the frequency with which diseases of bacterial origin
develop in the region of the ossifying junction. The diaphysis is also
nourished by numerous blood vessels from the periosteum, which penetrate
the cortex through the Haversian canals and anastomose with those
derived from the nutrient artery. The epiphyses are nourished by a
separate system of blood vessels, derived from the arteries which supply
the adjacent joint. The veins of the marrow are of large calibre and are
devoid of valves.

The _nerves_ enter the marrow along with the arteries, and, being
derived from the sympathetic system, are probably chiefly concerned with
the innervation of the blood vessels, but they are also capable of
transmitting sensory impulses, as pain is a prominent feature of many
bone affections.

It has long been believed that _the function of the periosteum_ is to
form new bone, but this view has been questioned by Sir William Macewen,
who maintains that its chief function is to limit the formation of new
bone. His experimental observations appear to show that new bone is
exclusively formed by the cellular elements or osteoblasts: these are
found on the surface of the bone, lining the Haversian canals and in the
marrow. We believe that it will avoid confusion in the study of the
diseases of bone if the osteoblasts on the surface of the bone are still
regarded as forming the deeper layer of the periosteum.

The formation of new bone by the osteoblasts may be _defective_ as a
result of physiological conditions, such as old age and disease of a
part, and defective formation is often associated with atrophy, or more
strictly speaking, absorption, of the existing bone, as is well seen in
the edentulous jaw and in the neck of the femur of a person advanced in
years. Defective formation associated with atrophy is also illustrated
in the bones of the lower limbs of persons who are unable to stand or
walk, and in the distal portion of a bone which is the seat of an
ununited fracture. The same combination is seen in an exaggerated degree
in the bones of limbs that are paralysed; in the case of adults, atrophy
of bone predominates; in children and adolescents, defective formation
is the more prominent feature, and the affected bones are attenuated,
smooth on the surface, and abnormally light.

On the other hand, the formation of new bone may be _exaggerated_, the
osteoblasts being excited to abnormal activity by stimuli of different
kinds: for example, the secretion of certain glandular organs, such as
the pituitary and thyreoid; the diluted toxins of certain
micro-organisms, such as the staphylococcus aureus and the spirochaete of
syphilis; a condition of hyperaemia, such as that produced artificially
by the application of a Bier's bandage or that which accompanies a
chronic leg-ulcer.

The new bone is laid down on the surface, in the Haversian canals, or
in the cancellous spaces and medullary canal, or in all three
situations. The new bone on the surface sometimes takes the form of a
diffuse _encrustation_ of porous or spongy bone as in secondary
syphilis, sometimes as a uniform increase in the girth of the
bone--_hyperostosis_, sometimes as a localised heaping up of bone or
_node_, and sometimes in the form of spicules, spoken of as
_osteophytes_. When the new bone is laid down in the Haversian canals,
cancellous spaces and medulla, the bone becomes denser and heavier, and
is said to be _sclerosed_; in extreme instances this may result in
obliteration of the medullary canal. Hyperostosis and sclerosis are
frequently met with in combination, a condition that is well illustrated
in the femur and tibia in tertiary syphilis; if the subject of this
condition is confined to bed for several months before his death, the
sclerosis may be undone, and rarefaction may even proceed beyond the
normal, the bone becoming lighter and richer in fat, although retaining
its abnormal girth.

The _function of the epiphysial cartilage_ is to provide for the growth
of the shaft in length. While all epiphysial cartilages contribute to
this result, certain of them functionate more actively and for a longer
period than others. Those at the knee, for example, contribute more to
the length of limb than do those at the hip or ankle, and they are also
the last to unite. In the upper limb the more active epiphyses are at
the shoulder and wrist, and these also are the last to unite.

The activity of the epiphysial cartilage may be modified as a result of
disease. In rickets, for example, the formation of new bone may take
place unequally, and may go on more rapidly in one half of the disc than
in the other, with the result that the axis of the shaft comes to
deviate from the normal, giving rise to knock-knee or bow-knee. In
bacterial diseases originating in the marrow, if the epiphysial junction
is directly involved in the destructive process, its bone-forming
functions may be retarded or abolished, and the subsequent growth of the
bone be seriously interfered with. On the other hand, if it is not
directly involved but is merely influenced by the proximity of an
infective focus, its bone-forming functions may be stimulated by the
diluted toxins and the growth of the bone in length exaggerated. In
paralysed limbs the growth from the epiphyses is usually little short of
the normal. The result of interference with growth is more injurious in
the lower than in the upper limb, because, from the functional point of
view, it is essential that the lower extremities should be approximately
of equal length. In the forearm or leg, where there are two parallel
bones, if the growth of one is arrested the continued growth of the
other results in a deviation of the hand or foot to one side.

In certain diseases, such as rickets and inherited syphilis, and in
developmental anomalies such as achondroplasia, _dwarfing_ of the
skeleton results from defective growth of bone at the ossifying
junctions. Conversely, excessive growth of bone at the ossifying
junctions results in abnormal height of the skeleton or _giantism_ as a
result, for example, of increased activity of the pituitary in
adolescents, and in eunuchs who have been castrated in childhood or
adolescence; in the latter, union of the epiphyses at the ends of the
long bones is delayed beyond the usual period at which the skeleton
attains maturity.

#Regeneration of Bone.#--When bone has been lost or destroyed as a
result of injury or disease, it is capable of being reproduced, the
extent to which regeneration takes place varying under different
conditions. The chief part in the regeneration of bone is played by the
osteoblasts in the adjacent marrow and in the deeper layer of the
periosteum. The shaft of a long bone may be reproduced after having been
destroyed by disease or removed by operation. The flat bones of the
skull and the bones of the face, which are primarily developed in
membrane, have little capacity of regeneration; hence, when bone has
been lost or removed in these situations, there results a permanent
defect.

Wounds or defects in articular cartilage are repaired by fibrous or
osseous tissue derived from the subjacent cancellous spaces.

_Transplantation of Bone--Bone-grafting._--Clinical experience is
conclusive that a portion of bone which has been completely detached
from its surroundings--for example, a trephine circle, or a flap of bone
detached with the saw, or the loose fragments in a compound
fracture--may become, if replaced in position, firmly and permanently
incorporated with the surrounding bone. Embedded foreign bodies, on the
other hand, such as ivory pegs or decalcified bone, exhibit, on removal
after a sufficient interval, evidence of having been eroded, in the
shape of worm-eaten depressions and perforations, and do not become
united or fused to the surrounding bone. It follows from this that the
implanting of living bone is to be preferred to the implanting of dead
bone or of foreign material. We believe that transplanted living bone
when placed under favourable conditions survives and becomes
incorporated with the bone with which it is in contact, and does not
merely act as a scaffolding. We believe also that the retention of the
periosteum on the graft is not essential, but, by favouring the
establishment of vascular connections, it contributes to the survival of
the graft and the success of the transplantation. Macewen maintains that
bone grafts "take" better if broken up into small fragments; we regard
this as unnecessary. Bone grafts yield better functional results when
they are immovably fixed to the adjacent bone by suture, pegs, or
plates. As in all grafting procedures, asepsis is essential.

Transplanted bone retains its vitality when embedded in the soft parts,
but is gradually absorbed and replaced by fibrous tissue.


DISEASES OF BONE

The morbid processes met with in bone originate in the same way and lead
to the same results as do similar processes in other tissues. The
structural peculiarities of bone, however, and the important changes
which take place in the skeleton during the period of growth, modify
certain of the clinical and pathological features.

_Definition of Terms._--Any diseased process that affects the periosteum
is spoken of as _periostitis_; the term _osteomyelitis_ is employed when
it is located in the marrow. The term _epiphysitis_ has been applied to
an inflammatory process in two distinct situations--namely, the
ossifying nucleus in the epiphysis, and the ossifying junction or
metaphysis between the epiphysial cartilage and the diaphysis. We shall
restrict the term to inflammation in the first of these situations.
Inflammation at the ossifying junction is included under the term
osteomyelitis.

The term _rarefying ostitis_ is applied to any process that is attended
with excessive absorption of the framework of a bone, whereby it becomes
more porous or spongy than it was before, a condition known as
_osteoporosis_.

The term _caries_ is employed to indicate any diseased process
associated with crumbling away of the trabecular framework of a bone. It
may be considered as the equivalent of ulceration or molecular
destruction in the soft parts. The carious process is preceded by the
formation of granulation tissue in the marrow or periosteum, which eats
away and replaces the bone in contact with it. The subsequent
degeneration and death of the granulation tissue under the necrotic
influence of bacterial toxins results in disintegration and crumbling
away of the trabecular framework of the portion of bone affected.
Clinically, carious bone yields a soft grating sensation under the
pressure of the probe. The macerated bone presents a rough, eroded
surface.

The term _dry caries_ (_caries sicca_) is applied to that variety which
is unattended with suppuration.

_Necrosis_ is the term applied to the death of a tangible portion of
bone, and the dead portion when separated is called a _sequestrum_. The
term _exfoliation_ is sometimes employed to indicate the separation or
throwing off of a superficial sequestrum. The edges and deep surface of
the sequestrum present a serrated or worm-eaten appearance due to the
process of erosion by which the dead bone has been separated from the
living.


BACTERIAL DISEASES

The most important diseases in this group are the pyogenic, the
tuberculous, and the syphilitic.

PYOGENIC DISEASES OF BONE.--These diseases result from
infection with pyogenic organisms, and two varieties or types are
recognised according to whether the organisms concerned reach their seat
of action by way of the blood-stream, or through an infection of the
soft parts in contact with the bone.


INFECTIONS THROUGH THE BLOOD-STREAM

#Diseases caused by the Staphylococcus Aureus.#--As the majority of
pyogenic diseases are due to infection with the staphylococcus aureus,
these will be described first.

#Acute osteomyelitis# is a suppurative process beginning in the marrow
and tending to spread to the periosteum. The disease is common in
children, but is rare after the skeleton has attained maturity. Boys are
affected more often than girls, in the proportion of three to one,
probably because they are more liable to exposure, to injury, and to
violent exertion.

_Etiology._--Staphylococci gain access to the blood-stream in various
ways, it may be through the skin or through a mucous surface.

Such conditions as, for example, a blow, some extra exertion such as a
long walk, or exposure to cold, as in wading, may act as localising
factors.

The long bones are chiefly affected, and the commonest sites are: either
end of the tibia and the lower end of the femur; the other bones of the
skeleton are affected in rare instances.

_Pathology._--The disease commences and is most intense in the marrow of
the ossifying junction at one end of the diaphysis; it may commence at
both ends simultaneously--_bipolar osteomyelitis_; or, commencing at one
end, may spread to the other.

The changes observed are those of intense engorgement of the marrow,
going on to greenish-yellow purulent infiltration. Where the process is
most advanced--that is, at the ossifying junction--there are evidences
of absorption of the framework of the bone; the marrow spaces and
Haversian canals undergo enlargement and become filled with
greenish-yellow pus. This rarefaction of the spongy bone is the earliest
change seen with the X-rays.

The process may remain localised to the ossifying junction, but usually
spreads along the medullary canal for a varying distance, and also
extends to the periosteum by way of the enlarged Haversian canals. The
pus accumulates under the periosteum and lifts it up from the bone. The
extent of spread in the medullary canal and beneath the periosteum is in
close correspondence. The periosteum of the diaphysis is easily
separated--hence the facility with which the pus spreads along the
shaft; but in the region of the ossifying junction it is raised with
difficulty because of its intimate connection with the epiphysial
cartilage. Less frequently there is more than one collection of pus
under the periosteum, each being derived from a focus of suppuration in
the subjacent marrow. The pus perforates the periosteum, and makes its
way to the surface by the easiest anatomical route, and discharges
externally, forming one or more sinuses through which fresh infection
may take place. The infection may spread to the adjacent joint, either
directly through the epiphysis and articular cartilage, or along the
deep layer of the periosteum and its continuation--the capsular
ligament. When the epiphysis is intra-articular, as, for example, in the
head of the femur, the pus when it reaches the surface of the bone
necessarily erupts directly into the joint.

While the occurrence of purely periosteal suppuration is regarded as
possible, we are of opinion that the embolic form of staphylococcal
osteomyelitis always originates in the marrow.

The portion of the diaphysis which has sustained the action of the
concentrated toxins has its vitality further impaired as a result of the
stripping of the periosteum and thrombosis of the blood vessels of the
marrow, so that _necrosis_ of bone is one of the most striking results
of the disease, and as this takes place rapidly, that is, in a day or
two, the term _acute necrosis_, formerly applied to the disease, was
amply justified.

When there is marked rarefaction of the bone at the ossifying junction,
the epiphysis is liable to be separated--_epiphysiolysis_. The
separation usually takes place through the young bone of the ossifying
junction, and the surfaces of the diaphysis and epiphysis are opposed to
each other by irregular eroded surfaces bathed in pus. The separated
epiphysis may be kept in place by the periosteum, but when this has been
detached by the formation of pus beneath it, the epiphysis is liable to
be displaced by muscular action or by some movement of the limb, or it
is the diaphysis that is displaced, for example, the lower end of the
diaphysis of the femur may be projected into the popliteal space.

The epiphysial cartilage usually continues its bone-forming functions,
but when it has been seriously damaged or displaced, the further growth
of the bone in length may be interfered with. Sometimes the separated
and displaced epiphysis dies and constitutes a sequestrum.

The adjacent joint may become filled at an early stage with a serous
effusion, which may be sterile. When the cocci gain access to the joint,
the lesion assumes the characters of a purulent arthritis, which, from
its frequency during the earlier years of life, has been called _the
acute arthritis of infants_.

Separation of an epiphysis nearly always results in infection and
destruction of the adjacent joint.

Osteomyelitis is rare in the bones of the carpus and tarsus, and the
associated joints are usually infected from the outset. In flat bones,
such as the skull, the scapula, or the ilium, suppuration usually occurs
on both aspects of the bone as well as in the marrow.

_Clinical Features._--The constitutional symptoms, which are due to the
associated toxaemia, vary considerably in different cases. In mild cases
they may be so slight as to escape recognition. In exceptionally severe
cases the patient may succumb before there are obvious signs of the
localisation of the staphylococci in the bone marrow. In average cases
the temperature rises rapidly with a rigor and runs an irregular course
with morning remissions, there is marked general illness accompanied by
headache, vomiting, and sometimes delirium.

The local manifestations are pain and tenderness in relation to one of
the long bones; the pain may be so severe as to prevent sleep and to
cause the child to cry out. Tenderness on pressure over the bone is the
most valuable diagnostic sign. At a later stage there is an ill-defined
swelling in the region of the ossifying junction, with oedema of the
overlying skin and dilatation of the superficial veins.

The swelling appears earlier and is more definite in superficial bones
such as the tibia, than in those more deeply placed such as the upper
end of the femur. It may be less evident to the eye than to the fingers,
and is best appreciated by gently stroking the bone from the middle of
its shaft towards the end. The maximum thickening and tenderness usually
correspond to the junction of the diaphysis with the epiphysis, and the
swelling tails off gradually along the shaft. As time goes on there is
redness of the skin, especially over a superficial bone, such as the
tibia, the swelling becomes softer, and gives evidence of fluctuation.
This stage may be reached at the end of twenty-four hours, or not for
some days.

Suppuration spreads towards the surface, until, some days later, the
skin sloughs and pus escapes, after which the fever usually remits and
the pain and other symptoms are relieved. The pus may contain blood and
droplets of fat derived from the marrow, and in some cases minute
particles of bone are present also. The presence of fat and bony
particles in the pus confirms the medullary origin of the suppuration.

If an incision is made, the periosteum is found to be raised from the
bone; the extent of the bare bone will be found to correspond fairly
accurately with the extent of the lesion in the marrow.

_Local Complications._--The adjacent joint may exhibit symptoms which
vary from those of a simple effusion to those of a purulent _arthritis_.
The joint symptoms may count for little in the clinical picture, or, as
in the case of the hip, may so predominate as to overshadow those of the
bone lesion from which they originated.

_Separation and displacement of the epiphysis_ usually reveals itself by
an alteration in the attitude of the limb; it is nearly always
associated with suppuration in the adjacent joint.

When _pathological fracture_ of the shaft occurs, as it may do, from
some muscular effort or strain, it is attended with the usual signs of
fracture.

_Dislocation_ of the adjacent joint has been chiefly observed at the
hip; it may result from effusion into the joint and stretching of the
ligaments, or may be the sequel of a purulent arthritis; the signs of
dislocation are not so obvious as might be expected, but it is attended
with an alteration in the attitude of the limb, and the displacement of
the head of the bone is readily shown in a skiagram.

_General Complications._--In some cases a _multiplicity of lesions_ in
the bones and joints imparts to the disease the features of pyaemia. The
occurrence of endocarditis, as indicated by alterations in the heart
sounds and the development of murmurs, may cause widespread infective
embolism, and metastatic suppurations in the kidneys, heart-wall, and
lungs, as well as in other bones and joints than those primarily
affected. The secondary suppurations are liable to be overlooked unless
sought for, as they are rarely attended with much pain.

In these multiple forms of osteomyelitis the toxaemic symptoms
predominate; the patient is dull and listless, or he may be restless and
talkative, or actually delirious. The tongue is dry and coated, the lips
and teeth are covered with sordes, the motions are loose and offensive,
and may be passed involuntarily. The temperature is remittent and
irregular, the pulse small and rapid, and the urine may contain blood
and albumen. Sometimes the skin shows erythematous and purpuric rashes,
and the patient may cry out as in meningitis. The post-mortem
appearances are those of pyaemia.

_Differential Diagnosis._--Acute osteomyelitis is to be diagnosed from
infections of the soft parts, such as erysipelas and cellulitis, and, in
the case of the tibia, from erythema nodosum. Tenderness localised to
the ossifying junction is the most valuable diagnostic sign of
osteomyelitis.

When there is early and pronounced general intoxication, there is likely
to be confusion with other acute febrile illnesses, such as scarlet
fever. In all febrile conditions in children and adolescents, the
ossifying junctions of the long bones should be examined for areas of
pain and tenderness.

Osteomyelitis has many features in common with acute articular
rheumatism, and some authorities believe them to be different forms of
the same disease (Kocher). In acute rheumatism, however, the joint
symptoms predominate, there is an absence of suppuration, and the pains
and temperature yield to salicylates.

The _prognosis_ varies with the type of the disease, with its
location--the vertebrae, skull, pelvis, and lower jaw being specially
unfavourable--with the multiplicity of the lesions, and with the
development of endocarditis and internal metastases.

_Treatment._--This is carried out on the same lines as in other pyogenic
infections.

In the earliest stages of the disease, the induction of hyperaemia is
indicated, and should be employed until the diagnosis is definitely
established, and in the meantime preparations for operation should be
made. An incision is made down to and through the periosteum, and
whether pus is found or not, the bone should be opened in the vicinity
of the ossifying junction by means of a drill, gouge, or trephine. If
pus is found, the opening in the bone is extended along the shaft as far
as the periosteum has been separated, and the infected marrow is removed
with the spoon. The cavity is then lightly packed with rubber dam, or,
as recommended by Bier, the skin edges are brought together by sutures
which are loosely tied to afford sufficient space between them for the
exit of discharge, and the hyperaemic treatment is continued.

When there is widespread suppuration in the marrow, and the shaft is
extensively bared of periosteum and appears likely to die, it may be
resected straight away or after an interval of a day or two. Early
resection of the shaft is also indicated if the opening of the medullary
canal is not followed by relief of symptoms. In the leg and forearm, the
unaffected bone maintains the length and contour of the limb; in the
case of the femur and humerus, extension with weight and pulley along
with some form of moulded gutter splint is employed with a similar
object.

Amputation of the limb is reserved for grave cases, in which life is
endangered by toxaemia, which is attributed to the primary lesion. It may
be called for later if the limb is likely to be useless, as, for
example, when the whole shaft of the bone is dead without the formation
of a new case, when the epiphyses are separated and displaced, and the
joints are disorganised.

Flat bones, such as the skull or ilium, must be trephined and the pus
cleared out from both aspects of the bone. In the vertebrae, operative
interference is usually restricted to opening and draining the
associated abscess.

#Nature's Effort at Repair.#--_In cases which are left to nature_, and
in which necrosis of bone has occurred, those portions of the periosteum
and marrow which have retained their vitality resume their osteogenetic
functions, often to an exaggerated degree. Where the periosteum has been
lifted up by an accumulation of pus, or is in contact with bone that is
dead, it proceeds to form new bone with great activity, so that the dead
shaft becomes surrounded by a sheath or case of new bone, known as the
_involucrum_ (Fig. 118). Where the periosteum has been perforated by pus
making its way to the surface, there are defects or holes in the
involucrum, called _cloacae_. As these correspond more or less in
position to the sinuses in the skin, in passing a probe down one of the
sinuses it usually passes through a cloaca and strikes the dead bone
lying in the interior. If the periosteum has been extensively
destroyed, new bone may only be formed in patches, or not at all. The
dead bone is separated from the living by the agency of granulation
tissue with its usual complements of phagocytes and osteoclasts, so that
the sequestrum presents along its margins and on its deep surface a
pitted, grooved, and worm-eaten appearance, except on the periosteal
aspect, which is unaltered. Ultimately the dead bone becomes loose and
lies in a cavity a little larger than itself; the wall of the cavity is
formed by the new case, lined with granulation tissue. The separation of
the sequestrum takes place more rapidly in the spongy bone of the
ossifying junction than in the compact bone of the shaft.

When foci of suppuration have been scattered up and down the medullary
cavity, and the bone has died in patches, several sequestra may be
included by the new case; each portion of dead bone is slowly separated,
and comes to lie in a cavity lined by granulations.

Even at a distance from the actual necrosis there is formation of new
bone by the marrow; the medullary canal is often obliterated, and the
bone becomes heavier and denser--sclerosis; and the new bone which is
deposited on the original shaft results in an increase in the girth of
the bone--hyperostosis.

[Illustration: FIG. 118.--Shaft of Femur after Acute Osteomyelitis. The
shaft has undergone extensive necrosis, and a shell of new bone has been
formed by the periosteum.]

_Pathological fracture_ of the shaft may occur at the site of necrosis,
when the new case is incapable of resisting the strain put upon it, and
is most frequently met with in the shaft of the femur. Short of
fracture, there may be bending or curving of the new case, and this
results in deformity and shortening of the limb (Fig. 119).

The _extrusion of a sequestrum_ may occur, provided there is a cloaca
large enough to allow of its escape, but the surgeon has usually to
interfere by performing the operation of sequestrectomy. Displacement or
partial extrusion of the dead bone may cause complications, as when a
sequestrum derived from the trigone of the femur perforates the
popliteal artery or the cavity of the knee-joint, or a sequestrum of the
pelvis perforates the wall of the urinary bladder.

The extent to which bone which has been lost is reproduced varies in
different parts of the skeleton: while the long bones, the scapula, the
mandible, and other bones which are developed in cartilage are almost
completely re-formed, bones which are entirely developed in membrane,
such as the flat bones of the skull and the maxilla, are not reproduced.

[Illustration: FIG. 119.--Femur and Tibia showing results of Acute
Osteomyelitis affecting Trigone of Femur; sequestrum partly surrounded
by new case; backward displacement of lower epiphysis and implication of
knee-joint.]

It may be instructive to describe _the X-ray appearances of a long bone
that has passed through an attack of acute osteomyelitis_ severe enough
to have caused necrosis of part of the diaphysis. The shadow of the dead
bone is seen in the position of the original shaft which it represents;
it is of the same shape and density as the original shaft, while its
margins present an irregular contour from the erosion concerned in its
separation. The sequestrum is separated from the living bone by a clear
zone which corresponds to the layer of granulations lining the cavity in
which it lies. This clear zone separating the shadow of the dead bone
from that of the living bone by which it is surrounded is conclusive
evidence of a sequestrum. The medullary canal in the vicinity of the
sequestrum being obliterated, is represented by a shadow of varying
density, continuous with that of the surrounding bone. The shadow of the
new case or involucrum with its wavy contour is also in evidence, with
its openings or cloacae, and is mainly responsible for the increase in
the diameter of the bone.

The skiagram may also show separation and displacement of the adjacent
epiphysis and destruction of the articular surfaces or dislocation of
the joint.

_Sequelae of Acute Suppurative Osteomyelitis._--The commonest sequel is
the presence of a sequestrum with one or more discharging sinuses; owing
to the abundant formation of scar tissue these sinuses have rigid edges
which are usually depressed and adherent to the bone.

_The Recognition and Removal of Sequestra._--So long as there is dead
bone there will be suppuration from the granulations lining the cavity
in which it lies, and a discharge of pus from the sinuses, so that the
mere persistence of discharge after an attack of osteomyelitis, is
presumptive evidence of the occurrence of necrosis. Where there are one
or more sinuses, the passage of a probe which strikes bare bone affords
corroboration of the view that the bone has perished. When the dead bone
has been separated from the living, the X-rays yield the most exact
information.

The traditional practice is to wait until the dead bone is entirely
separated before undertaking an operation for its removal, from fear, on
the one hand, of leaving portions behind which may keep up the
discharge, and, on the other, of removing more bone than is necessary.
This practice need not be adhered to, as by operating at an earlier
stage healing is greatly hastened. If it is decided to wait for
separation of the dead bone, drainage should be improved, and the
infective element combated by the induction of hyperaemia.

_The operation_ for the removal of the dead bone (_sequestrectomy_)
consists in opening up the periosteum and the new case sufficiently to
allow of the removal of all the dead bone, including the most minute
sequestra. The limb having been rendered bloodless, existing sinuses are
enlarged, but if these are inconveniently situated--for example, in the
centre of the popliteal space in necrosis of the femoral trigone--it is
better to make a fresh wound down to the bone on that aspect of the
limb which affords best access, and which entails the least injury of
the soft parts. The periosteum, which is thick and easily separable, is
raised from the new case with an elevator, and with the chisel or gouge
enough of the new bone is taken away to allow of the removal of the
sequestrum. Care must be taken not to leave behind any fragment of dead
bone, as this will interfere with healing, and may determine a relapse
of suppuration.

The dead bone having been removed, the lining granulations are scraped
away with a spoon, and the cavity is disinfected.

There are different ways of dealing with a _bone cavity_. It may be
packed with gauze (impregnated with "bipp" or with iodoform), which is
changed at intervals until healing takes place from the bottom; it may
be filled with a flap of bone and periosteum raised from the vicinity,
or with bone grafts; or the wall of bone on one side of the cavity may
be chiselled through at its base, so that it can be brought into contact
with the opposite wall. The method of filling bone cavities devised by
Mosetig-Moorhof, consists in disinfecting and drying the cavity by a
current of hot air, and filling it with a mixture of powdered iodoform
(60 parts) and oil of sesame and spermaceti (each 40 parts), which is
fluid at a temperature of 112 o F.; the soft parts are then brought
together without drainage. As the cavity fills up with new bone the
iodoform is gradually absorbed. Iodoform gives a dark shadow with the
X-rays, so that the process of its absorption can be followed in
skiagrams taken at intervals.

These procedures may be carried out at the same time as the sequestrum
is removed, or after an interval. In all of them, asepsis is essential
for success.

The _deformities_ resulting from osteomyelitis are more marked the
earlier in life the disease occurs. Even under favourable conditions,
and with the continuous effort at reconstruction of the bone by Nature's
method, the return to normal is often far from perfect, and there
usually remains a variable amount of hyperostosis and sclerosis and
sometimes curving of the bone. Under less favourable conditions, the
late results of osteomyelitis may be more serious. _Shortening_ is not
uncommon from interference with growth at the ossifying junction.
_Exaggerated growth_ in the length of a bone is rare, and has been
observed chiefly in the bones of the leg. Where there are two parallel
bones--as in the leg, for example--the growth of the diseased bone may
be impaired, and the other continuing its normal growth becomes
disproportionately long; less frequently the growth of the diseased
bone is exaggerated, and it becomes the longer of the two. In either
case, the longer bone becomes curved. An _obliquity_ of the bone may
result when one half of the epiphysial cartilage is destroyed and the
other half continues to form bone, giving rise to such deformities as
knock-knee and club-hand.

Deformity may also result from vicious union of a pathological fracture,
permanent displacement of an epiphysis, contracture, ankylosis, or
dislocation of the adjacent joint.

#Relapsing Osteomyelitis.#--As the term indicates, the various forms of
relapsing osteomyelitis date back to an antecedent attack, and their
occurrence depends on the capacity of staphylococci to lie latent in the
marrow.

Relapse may take place within a few months of the original attack, or
not for many years. Cases are sometimes met with in which relapses recur
at regular intervals for several years, the tendency, however, being for
the attacks to become milder as the virulence of the organisms becomes
more and more attenuated.

_Clinical Features._--Osteomyelitis in a patient over twenty-five is
nearly always of the relapsing variety. In some cases the bone becomes
enlarged, with pain and tenderness on pressure; in others there are the
usual phenomena which attend suppuration, but the pus is slow in coming
to the surface, and the constitutional symptoms are slight. The pus may
escape by new channels, or one of the old sinuses may re-open.
Radiograms usually furnish useful information as to the condition of the
bone, both as it is altered by the original attack and by the changes
that attend the relapse of the infective process.

_Treatment._--In cases of thickening of the bone with persistent and
severe pain, if relief is not afforded by the repeated application of
blisters, the thickened periosteum should be incised, and the bone
opened up with the chisel or trephine. In cases attended with
suppuration, the swelling is incised and drained, and if there is a
sequestrum, it must be removed.

#Circumscribed Abscess of Bone--"Brodie's Abscess."#--The most important
form of relapsing osteomyelitis is the circumscribed abscess of bone
first described by Benjamin Brodie. It is usually met with in young
adults, but we have met with it in patients over fifty. Several years
may intervene between the original attack of osteomyelitis and the onset
of symptoms of abscess.

_Morbid Anatomy._[7]--The abscess is nearly always situated in the
central axis of the bone in the region of the ossifying junction,
although cases are occasionally met with in which it lies nearer the
middle of the shaft. In exceptional cases there is more than one abscess
(Fig. 120). The tibia is the bone most commonly affected, but the lower
end of the femur, or either end of the humerus, may be the seat of the
abscess. In the quiescent stage the lesion is represented by a small
cavity in the bone, filled with clear serum, and lined by a fibrous
membrane which is engaged in forming bone. Around the cavity the bone is
sclerosed, and the medullary canal is obliterated. When the infection
becomes active, the contents of the cavity are transformed into a
greenish-yellow pus from which the staphylococcus can be isolated, and
the cavity is lined by a thin film of granulation tissue which erodes
the surrounding bone and so causes the abscess to increase in size. If
the erosion proceeds uniformly, the cavity is spherical or oval; if it
is more active at some points than others, diverticula or tunnels are
formed, and one of these may finally erupt through the shell of the bone
or into an adjacent joint. Small irregular sequestra are occasionally
found within the abscess cavity. In long-standing cases it is common to
find extensive obliteration of the medullary canal, and a considerable
increase in the girth of the bone.

[7] Alexis Thomson, _Edin. Med. Journ._, 1906.

[Illustration: FIG. 120.--Segment of Tibia resected for Brodie's
Abscess. The specimen shows two separate abscesses in the centre of the
shaft, the lower one quiescent, the upper one active and increasing in
size.]

The size of the abscess ranges from that of a cherry to that of a
walnut, but specimens in museums show that, if left to Nature, the
abscess may attain much greater dimensions.

The affected bone is not only thicker and heavier than normal, but may
also be curved or otherwise deformed as a result of the original attack
of osteomyelitis.

The _clinical features_ are almost exclusively local. Pain, due to
tension within the abscess, is the dominant symptom. At first it is
vague and difficult to localise, later it is referred to the interior of
the bone, and is described as "boring." It is aggravated by use of the
limb, and there are often, especially during the night, exacerbations in
which the pain becomes excruciating. In the early stages there are
periods of days or weeks during which the symptoms abate, but as the
abscess increases these become shorter, until the patient is hardly ever
free from pain. Localised tenderness can almost always be elicited by
percussion, or by compressing the bone between the fingers and thumb.
The pain induced by the traction of muscles attached to the bone, or by
the weight of the body, may interfere with the function of the limb, and
in the lower extremity cause a limp in walking. The limb may be disabled
from _involvement of the adjacent joint_, in which there may be an
intermittent hydrops which comes and goes coincidently with
exacerbations of pain; or the abscess may perforate the joint and set up
an acute arthritis.

The _diagnosis_ of Brodie's abscess from other affections met with at
the ends of long bones, and particularly from tuberculosis, syphilis,
and new growths, is made by a consideration of the previous history,
especially with reference to an antecedent attack of osteomyelitis. When
the adjacent joint is implicated, the surgeon may be misled by the
patient referring all the symptoms to the joint.

The X-ray picture is usually diagnostic chiefly because all the lesions
which are liable to be confused with Brodie's abscess--gumma, tubercle,
myeloma, chondroma, and sarcoma--give a well-marked central clear area;
the sclerosis around Brodie's abscess gives a dense shadow in which the
central clear area is either not seen at all or only faintly (Fig. 121).

_Treatment._--If an abscess is suspected, there should be no hesitation
in exploring the interior of the bone. It is exposed by a suitable
incision; the periosteum is reflected and the bone is opened up by a
trephine or chisel, and the presence of an abscess may be at once
indicated by the escape of pus. If, owing to the small size of the
abscess or the density of the bone surrounding it, the pus is not
reached by this procedure, the bone should be drilled in different
directions.

[Illustration: FIG. 121.--Radiogram of Brodie's Abscess in Lower End of
Tibia.]

#Other Forms of Acute Osteomyelitis.#--Among the less severe forms of
osteomyelitis resulting from the action of attenuated organisms are the
_serous_ variety, in which an effusion of serous fluid forms under the
periosteum; and _growth fever_, in which the child complains of vague
evanescent pains (growing pains), and of feeling tired and disinclined
to play; there may be some rise of temperature in the evening.

Infection with the _staphylococcus albus_, the _streptococcus_, or the
_pneumococcus_ also causes a mild form of osteomyelitis which may go on
to suppuration.

_Necrosis without suppuration_, described by Paget under the name "quiet
necrosis," is a rare disease, and would appear to be associated with an
attenuated form of staphylococcal infection (Tavel). It occurs in
adults, being met with up to the age of fifty or sixty, and is
characterised by the insidious development of a swelling which involves
a considerable extent of a long bone. The pain varies in intensity, and
may be continuous or intermittent, and there is tenderness on pressure.
The shaft is increased in girth as a result of its being surrounded by a
new case of bone. The resemblance to sarcoma may be very close, but the
swelling is not as defined as in sarcoma, nor does it ever assume the
characteristic "leg of mutton" shape. In both diseases there is a
tendency to pathological fracture. It is difficult also in the absence
of skiagrams to differentiate the condition from syphilitic and from
tuberculous disease. If the diagnosis is not established after
examination with the X-rays, an exploratory incision should be made; if
dead bone is found, it is removed.

In typhoid fever the bone marrow is liable to be invaded by _the typhoid
bacillus_, which may set up osteomyelitis soon after its lodgment, or it
may lie latent for a considerable period before doing so. The lesions
may be single or multiple, they involve the marrow or the periosteum or
both, and they may or may not be attended with suppuration. They are
most commonly met with in the tibia and in the ribs at the
costo-chondral junctions.

The bone lesions usually occur during the seventh or eighth week of the
fever, but have been known to occur much later. The chief complaint is
of vague pains, at first referred to several bones, later becoming
localised in one; they are aggravated by movement, or by handling the
bone, and are worst at night. There is redness and oedema of the
overlying soft parts, and swelling with vague fluctuation, and on
incision there escapes a yellow creamy pus, or a brown syrupy fluid
containing the typhoid bacillus in pure culture. Necrosis is
exceptional.

When the abscess develops slowly, the condition resembles tuberculous
disease, from which it may be diagnosed by the history of typhoid fever,
and by obtaining a positive Widal reaction.

The prognosis is favourable, but recovery is apt to be slow, and relapse
is not uncommon.

It is usually sufficient to incise the periosteum, but when the disease
occurs in a rib it may be necessary to resect a portion of bone.

#Pyogenic Osteomyelitis due to Spread of Infection from the Soft
Parts.#--There still remain those forms of osteomyelitis which result
from infection through a wound involving the bone--for example, compound
fractures, gun-shot injuries, osteotomies, amputations, resections, or
operations for un-united fracture. In all of these the marrow is exposed
to infection by such organisms as are present in the wound. A similar
form of osteomyelitis may occur apart from a wound--for example,
infection may spread to the jaws from lesions of the mouth; to the
skull, from lesions of the scalp or of the cranial bones
themselves--such as a syphilitic gumma or a sarcoma which has fungated
externally; or to the petrous temporal, from suppuration in the middle
ear.

The most common is an osteomyelitis commencing in the marrow exposed in
a wound infected with pyogenic organisms. In amputation stumps,
fungating granulations protrude from the sawn end of the bone, and if
necrosis takes place, the sequestrum is annular, affecting the
cross-section of the bone at the saw-line; or tubular, extending up the
shaft, and tapering off above. The periosteum is more easily detached,
is thicker than normal, and is actively engaged in forming bone. In the
macerated specimen, the new bone presents a characteristic coral-like
appearance, and may be perforated by cloacae (Fig. 122).

[Illustration: FIG. 122.--Tubular Sequestrum resulting from Septic
Osteomyelitis in Amputation Stump.]

Like other pyogenic infections, it may terminate in pyaemia, as a result
of septic phlebitis in the marrow.

The _clinical features_ of osteomyelitis in _an amputation stump_ are
those of ordinary pyogenic infection; the involvement of the bone may be
suspected from the clinical course, the absence of improvement from
measures directed towards overcoming the sepsis in the soft parts, and
the persistence of suppuration in spite of free drainage, but it is not
recognised unless the bone is exposed by opening up the stump or the
changes in the bone are shown by the X-rays. The first change is due to
the deposit of new bone on the periosteal surface; later, there is the
shadow of the sequestrum.

Healing does not take place until the sequestrum is extruded or removed
by operation.

_In compound fractures_, if a fragment dies and forms a sequestrum, it
is apt to be walled in by new bone; the sinuses continue to discharge
until the sequestrum is removed. Even after healing has taken place,
relapse is liable to occur, especially in gun-shot injuries. Months or
years afterwards, the bone may become painful and tender. The symptoms
may subside under rest and elevation of the limb and the application of
a compress, or an abscess forms and bursts with comparatively little
suffering. The contents may be clear yellow serum or watery pus;
sometimes a small spicule of bone is discharged. Valuable information,
both for diagnosis and treatment, is afforded by skiagrams.

[Illustration: FIG. 123.--New Periosteal Bone on surface of Femur from
Amputation Stump. Osteomyelitis supervened on the amputation, and
resulted in necrosis at the sawn section of the bone. (Anatomical
Museum, University of Edinburgh.)]


TUBERCULOUS DISEASE

The tuberculous diseases of bone result from infection of the marrow or
periosteum by tubercle bacilli conveyed through the arteries; it is
exceedingly rare for tubercle to appear in bone as a primary infection,
the bacilli being usually derived from some pre-existing focus in the
bronchial glands or elsewhere. According to the observations of John
Fraser, 60 per cent. of the cases of bone and joint tubercle in children
are due to the bovine bacillus, 37 per cent. to the human variety, and
in 3 per cent. both types are present.

Tuberculous disease in bone is characterised by its insidious onset and
slow progress, and by the frequency with which it is associated with
disease of the adjacent joint.

#Periosteal tuberculosis# is met with in the ribs, sternum, vertebral
column, skull, and less frequently in the long bones of the limbs. It
may originate in the periosteum, or may spread thence from the marrow,
or from synovial membrane.

_In superficial bones_, such as the sternum, the formation of
tuberculous granulation tissue in the deeper layer of the periosteum,
and its subsequent caseation and liquefaction, is attended by the
insidious development of a doughy swelling, which is not as a rule
painful, although tender on pressure. While the swelling often remains
quiescent for some time, it tends to increase in size, to become boggy
or fluctuating, and to assume the characters of a cold abscess. The pus
perforates the fibrous layer of the periosteum, invading and infecting
the overlying soft parts, its spread being influenced by the anatomical
arrangement of the tissues. The size of the abscess affords no
indication of the extent of the bone lesion from which it originates. As
the abscess reaches the surface, the skin becomes of a dusky red or
livid colour, is gradually thinned out, and finally sloughs, forming a
sinus. A probe passed into the sinus strikes carious bone. Small
sequestra may be found embedded in the granulation tissue. The sinus
persists as long as any active tubercle remains in the tissues, and is
apt to form an avenue for pyogenic infection.

_In deeply seated bones_, such as the upper end of the femur, the
formation of a cold abscess in the soft parts is often the first
evidence of the disease.

_Diagnosis._--Before the stage of cold abscess is reached, the localised
swelling is to be differentiated from a gumma, from chronic forms of
staphylococcal osteomyelitis, from enlarged bursa or ganglion, from
sub-periosteal lipoma, and from sarcoma. Most difficulty is met with in
relation to periosteal sarcoma, which must be differentiated either by
the X-ray appearances or by an exploratory incision.

_X-ray appearances in periosteal tubercle_: the surface of the cortical
bone in the area of disease is roughened and irregular by erosion, and
in the vicinity there may be a deposit of new bone on the surface,
particularly if a sinus is present and mixed infection has occurred; in
_syphilis_ the shadow of the bone is denser as a result of sclerosis,
and there is usually more new bone on the surface--hyperostosis; in
_periosteal sarcoma_ there is greater erosion and consequently greater
irregularity in the contour of the cortical bone, and frequently there
is evidence of formation of bone in the form of characteristic spicules
projecting from the surface at a right angle.

The early recognition of periosteal lesions in the articular ends of
bones is of importance, as the disease, if left to itself, is liable to
spread to the adjacent joint.

The _treatment_ is that of tuberculous lesions in general; if
conservative measures fail, the choice lies between the injection of
iodoform, and removal of the infected tissues with the sharp spoon. In
the ribs it is more satisfactory to remove the diseased portion of bone
along with the wall of the associated abscess or sinus. If all the
tubercle has been removed and there is no pyogenic infection, the wound
is stitched up with the object of obtaining primary union; otherwise it
is treated by the open method.

#Tuberculous Osteomyelitis.#--Tuberculous lesions in the marrow occur as
isolated or as multiple foci of granulation tissue, which replace the
marrow and erode the trabeculae of bone in the vicinity (Fig. 124). The
individual focus varies in size from a pea to a walnut. The changes that
ensue resemble in character those in other tissues, and the extent of
the destruction varies according to the way in which the tubercle
bacillus and the marrow interact upon one another. The granulation
tissue may undergo caseation and liquefaction, or may become
encapsulated by fibrous tissue--"encysted tubercle."

[Illustration: FIG. 124.--Tuberculous Osteomyelitis of Os Magnum,
excised from a boy aet. 8. Note well-defined caseous focus, with several
minute foci in surrounding marrow.]

Sometimes the tuberculous granulation tissue spreads in the marrow,
assuming the characters of a diffuse infiltration--diffuse tuberculous
osteomyelitis. The trabecular framework of the bone undergoes erosion
and absorption--rarefying ostitis--and either disappears altogether or
only irregular fragments or sequestra of microscopic dimensions remain
in the area affected. Less frequently the trabecular framework is added
to by the formation of new bone, resulting in a remarkable degree of
sclerosis, and if, following upon this, there is caseation of the
tubercle and death of the affected portion of bone, there results a
sequestrum often of considerable size and characteristic shape, which,
because of the sclerosis and surrounding endarteritis, is exceedingly
slow in separating. When the sequestrum involves an articular surface it
is often wedge-shaped; in other situations it is rounded or truncated
and lies in the long axis of the medullary canal (Fig. 125). Finally,
the sequestrum lies loose in a cavity lined by tuberculous granulation
tissue, and is readily identified in a radiogram. This type of sclerosis
preceding death of the bone is highly characteristic of tuberculosis.

[Illustration: FIG. 125.--Tuberculous Disease of Child's Tibia,
showing sequestrum in medullary cavity, and increase in girth from
excess of new bone.]

_Clinical Features._--As a rule, it is only in superficially placed
bones, such as the tibia, ulna, clavicle, mandible, or phalanges, that
tuberculous disease in the marrow gives rise to signs sufficiently
definite to allow of its clinical recognition. In the vertebrae, or in
the bones of deeply seated joints, such as the hip or shoulder, the
existence of tuberculous lesions in the marrow can only be inferred from
indirect signs--such, for example, as rigidity and curvature in the case
of the spine, or from the symptoms of grave and persistent joint-disease
in the case of the hip or shoulder.

With few exceptions, tuberculous disease in the interior of a bone does
not reveal its presence until by extension it reaches one or other of
the surfaces of the bone. In the shaft of a long bone its eruption on
the periosteal surface is usually followed by the formation of a cold
abscess in the overlying soft parts. When situated in the articular ends
of bones, the disease more often erupts in relation to the reflection of
the synovial membrane or directly on the articular surface--in either
case giving rise to disease of the joint (Fig. 156).

[Illustration: Fig. 126.--Diffuse Tuberculous Osteomyelitis of Right
Tibia.

(Photograph lent by Sir H. J. Stiles.)]

#Diffuse Tuberculous Osteomyelitis in the shaft of a long bone# is
comparatively rare, and has been observed chiefly in the tibia and the
ulna in children (Fig. 126). It commences at the growing extremity of
the diaphysis, and spreads along the medulla to a variable extent; it is
attended by the formation of vascular and porous bone on the surface,
which causes thickening of the diaphysis; this is most marked at the
ossifying junction and tapers off along the shaft. The infection not
only spreads along the medulla, but it invades the spongy bone
surrounding this, and then the cortical bone, and is only prevented from
reaching the soft parts by the new bone formed by the periosteum. The
bone is replaced by granulation tissue, and disappears, or part of it
may become sclerosed and in time form a sequestrum. In the macerated
specimen, the sequestrum appears small in proportion to the large cavity
in which it lies. All these changes are revealed in a good skiagram,
which not only confirms the diagnosis, but, in many instances,
demonstrates the extent of the disease, the presence or absence of a
sequestrum, and the amount of new bone on the surface. Finally the
periosteum gives way, and an abscess forms in the soft parts; and if
left to itself ruptures externally, leaving a sinus. The most
satisfactory _treatment_ is to resect sub-periosteally the diseased
portion of the diaphysis.

_In cancellous bones, such as those of the tarsus_, there is a similar
caseous infiltration in the marrow, and this may be attended with the
formation of a sequestrum either in the interior of the bone or
involving its outer shell, as shown in Fig. 127. The situation and
extent of the disease are shown in X-ray photographs. After the
tuberculous granulation tissue erupts through the cortex of the bone, it
gives rise to a cold abscess or infects adjacent joints or tendon
sheaths.

[Illustration: FIG. 127.--Advanced Tuberculous Disease in region of
Ankle. The ankle-joint is ankylosed, and there is a large sequestrum in
the calcaneus.

(Specimen in Anatomical Museum, University of Edinburgh.)]

If an exact diagnosis is made at an early stage of the disease--and this
is often possible with the aid of X-rays--the affected bone is excised
sub-periosteally or its interior is cleared out with the sharp spoon and
gouge, the latter procedure being preferred in the case of the
_calcaneus_ to conserve the stability of the heel. When several bones
and joints are simultaneously affected, and there are sinuses with
mixed infection, amputation is usually indicated, especially in adults.

#Tuberculous dactylitis# is the name applied to a diffuse form of the
disease as it affects the phalanges, metacarpal or metatarsal bones. The
lesion presents, on a small scale, all the anatomical changes that have
been described as occurring in the medulla of the tibia or ulna, and
they are easily followed in skiagrams. A periosteal type of dactylitis
is also met with.

The _clinical features_ are those of a spindle-shaped swelling of a
finger or toe, indolent, painless, and interfering but little with the
function of the digit. Recovery may eventually occur without
suppuration, but it is common to have the formation of a cold abscess,
which bursts and forms one or more sinuses. It may be difficult to
differentiate tuberculous dactylitis from the enlargement of the
phalanges in inherited syphilis (syphilitic dactylitis), especially when
the tuberculous lesion occurs in a child who is the subject of inherited
syphilis.

[Illustration: FIG. 128.--Tuberculous Dactylitis.]

In the syphilitic lesion, skiagrams usually show a more abundant
formation of new bone, but in many cases the doubt is only cleared up by
observing the results of the tuberculin test or the effects of
anti-syphilitic treatment.

Sarcoma of a phalanx or metacarpal bone may closely resemble a
dactylitis both clinically and in skiagrams, but it is rare.

_Treatment._--Recovery under conservative measures is not uncommon, and
the functional results are usually better than those following upon
operative treatment, although in either case the affected finger is
liable to be dwarfed (Fig. 129). The finger should be immobilised in a
splint, and a Bier's bandage applied to the upper arm. Operative
interference is indicated if a cold abscess develops, if there is a
persistent sinus, or if a sequestrum has formed, a point upon which
information is obtained by examination with the X-rays. When a toe is
affected, amputation is the best treatment, but in the case of a finger
it is rarely called for. In the case of a metacarpal or metatarsal bone,
sub-periosteal resection is the procedure of choice, saving the
articular ends if possible.

[Illustration: FIG. 129.--Shortening of Middle Finger of Adult, the
result of Tuberculous Dactylitis in childhood.]


SYPHILITIC DISEASE

Syphilitic affections of bone may be met with at any period of the
disease, but the graver forms occur in the tertiary stage of acquired
and inherited syphilis. The virus is carried by the blood-stream to all
parts of the skeleton, but the local development of the disease appears
to be influenced by a predisposition on the part of individual bones.

Syphilitic diseases of bone are much less common in practice than those
due to pyogenic and tuberculous infectious, and they show a marked
predilection for the tibia, sternum, and skull. They differ from
tuberculous affections in the frequency with which they attack the
shafts of bones rather than the articular ends, and in the comparative
rarity of joint complications.

_Evanescent periostitis_ is met with in acquired syphilis during the
period of the early skin eruptions. The patient complains, especially at
night, of pains over the frontal bone, ribs, sternum, tibiae, or ulnae.
Localised tenderness is elicited on pressure, and there is slight
swelling, which, however, rarely amounts to what may be described as a
_periosteal node_.

In the later stages of acquired syphilis, _gummatous periostitis and
osteomyelitis_ occur, and are characterised by the formation in the
periosteum and marrow of circumscribed gummata or of a diffuse gummatous
infiltration. The framework of the bone is rarefied in the area
immediately involved, and sclerosed in the parts beyond. If the
gummatous tissue degenerates and breaks down, and especially if the
overlying skin is perforated and septic infection is superadded, the
bone disintegrates and exhibits the condition known as _syphilitic
caries_; sometimes a portion of bone has its blood supply so far
interfered with that it dies--_syphilitic necrosis_. Syphilitic
sequestra are heavier and denser than normal bone, because sclerosis
usually precedes death of the bone. The bones especially affected by
gummatous disease are: the skull, the septum of the nose, the nasal
bones, palate, sternum, femur, tibia, and the bones of the forearm.

_In the bones of the skull_, gummata may form in the peri-cranium,
diploe, or dura mater. An isolated gumma forms a firm elastic swelling,
shading off into the surroundings. In the macerated bone there is a
depression or an actual perforation of the calvaria; multiple gummata
tend to fuse with one another at their margins, giving the appearance of
a combination of circles: these sometimes surround an area of bone and
cut it off from its blood supply (Fig. 130). If the overlying skin is
destroyed and septic infection superadded, such an isolated area of bone
is apt to die and furnish a sequestrum; the separation of the dead bone
is extremely slow, partly from the want of vascularity in the sclerosed
bone round about, and partly from the density of the sequestrum. In
exceptional cases the necrosis involves the entire vertical plate of the
frontal bone. Pus is formed between the bone and the dura (suppurative
pachymeningitis), and this may be followed by cerebral abscess or by
pyaemia. Gummatous disease in the wall of the orbit may cause
displacement of the eye and paralysis of the ocular muscles.

[Illustration: FIG. 130.--Syphilitic Disease of Skull, showing a
sequestrum in process of separation.]

On the inner surface of the skull, the formation of gummatous tissue may
cause pressure on the brain and give rise to intense pain in the head,
Jacksonian epilepsy, or paralysis, the symptoms varying with the seat
and extent of the disease. The cranial nerves may be pressed upon at the
base, especially at their points of exit, and this gives rise to
symptoms of irritation or paralysis in the area of distribution of the
nerves affected.

_In the septum of the nose, the nasal bones, and the hard palate_,
gummatous disease causes ulceration, which, beginning in the mucous
membrane, spreads to the bones, and being complicated with septic
infection leads to caries and necrosis. In the nose, the disease is
attended with stinking discharge (ozoena), the extrusion of portions of
dead bone, and subsequently with deformity characterised by loss of the
bridge of the nose; in the palate, it is common to have a perforation,
so that the air escapes through the nose in speaking, giving to the
voice a characteristic nasal tone.

_Syphilitic disease of the tibia_ may be taken as the type of the
affection as it occurs _in the long bones_. Gummatous disease in the
periosteum may be localised and result in the formation of a
well-defined node, or the whole shaft may become the seat of an
irregular nodular enlargement (Fig. 132). If the bone is macerated, it
is found to be heavier and bulkier than normal; there is diffuse
sclerosis with obliteration of the medullary canal, and the surface is
uneven from heaping up of new bone--hyperostosis (Fig. 131). If a
periosteal gumma breaks down and invades the skin, a syphilitic ulcer is
formed with carious bone at the bottom. A central gumma may eat away the
surrounding bone to such an extent that the shaft undergoes pathological
fracture. In the rare cases in which it attacks the articular end of a
long bone, gummatous disease may implicate the adjacent joint and give
rise to syphilitic arthritis.

[Illustration: FIG. 131.--Syphilitic Hyperostosis and Sclerosis of
Tibia, on section and on surface view.]

_Clinical Features._--There is severe boring pain--as if a gimlet were
being driven into the bone. It is worst at night, preventing sleep, and
has been ascribed to compression of the nerves in the narrowed Haversian
canals.

The _periosteal gumma_ appears as a smooth, circumscribed swelling which
is soft and elastic in the centre and firm at the margins, and shades
off into the surrounding bone. The gumma may be completely absorbed or
it may give place to a hard node. In some cases the gumma softens in the
centre, the skin becomes adherent, thin, and red, and finally gives way.
The opening in the skin persists as a sinus, or develops into a typical
ulcer with irregular, crescentic margins; in either case a probe reveals
the presence of carious bone or of a sequestrum. The health may be
impaired as a result of mixed infection, and the absorption of toxins
and waxy degeneration in the viscera may ultimately be induced.

A _central gumma_ in a long bone may not reveal its presence until it
erupts through the shell and reaches the periosteal surface or invades
an adjacent joint. Sometimes the first manifestation is a fracture of
the bone produced by slight violence.

In radiograms the appearance of syphilitic bones is usually
characteristic. When there is hyperostosis and sclerosis, the shaft
appears denser and broader than normal, and the contour is uneven or
wavy. When there is a central gumma, the shadow is interrupted by a
rounded clear area, like that of a chondroma or myeloma, but there is
sclerosis round about.

_Diagnosis._--The conditions most liable to be mistaken for syphilitic
disease of bone are chronic staphylococcal osteomyelitis, tuberculosis,
and sarcoma; and the diagnosis is to be made by the history and progress
of the disease, the result of examination with the X-rays, and the
results of specific tests and treatment.

_Treatment._--The general health is to be improved by open air, by
nourishing food, and by the administration of cod-liver oil, iron, and
arsenic. Anti-syphilitic remedies should be given, and if they are
administered before there is any destruction of tissue, the benefit
derived from them is usually marked.

Radiograms show the rapid absorption of the new bone both on the surface
and in the marrow, and are of value in establishing the therapeutic
diagnosis.

In certain cases, and particularly when there are destructive changes in
the bone complicated with pyogenic infection, specific remedies have
little effect. In cases of persistent or relapsing gummatous disease
with ulceration of skin, it is often necessary to remove the diseased
soft parts with the sharp spoon and scissors, and to gouge or chisel
away the unhealthy bone, on the same lines as in tuberculous disease.
When hyperostosis and sclerosis of the bone is attended with severe pain
which does not yield to blistering, the periosteum may be incised and
the sclerosed bone perforated with a drill or trephine.

#Lesions of Bone in Inherited Syphilis.#--_Craniotabes_, in which the
flat bones of the skull undergo absorption in patches, was formerly
regarded as syphilitic, but it is now known to result from prolonged
malnutrition from any cause. _Bossing of the skull_ resulting in the
formation of Parrot's nodes is also being withdrawn from the category of
syphilitic affections. The lesions in infancy--epiphysitis, bossing of
the skull, and craniotabes--have been referred to in the chapter on
inherited syphilis.

_Epiphysitis or Syphilitic Perichondritis._--The first of these terms is
misleading, because the lesion involves the ossifying junction and the
shaft of the bone, and the epiphysis only indirectly. The young bone is
replaced by granulation tissue, so that large clear areas are seen with
the X-rays. The symptoms are referred to the joint, because it is there
that the muscles are inserted and drag on the perichondrium when
movement occurs; swelling is most marked in the vicinity of the joint,
and it may be added to by effusion into the synovial cavity. The baby,
usually under six months, is noticed to be feverish and fretful and to
cry when touched. The mother discovers that the pain is caused by moving
a particular limb, usually the arm, as the humerus, radius, and ulna are
the bones most commonly affected; the limb, moreover, hangs useless at
the side as if paralysed, and the condition was formerly described as
_syphilitic pseudo-paralysis_.

The lesions met with later correspond to those of the tertiary period of
the acquired disease, but as they affect bones which are still actively
growing, the effects are more striking. Gummatous disease may come and
go over periods of many years, with the result that the external
appearance and architectural arrangement of a long bone come to be
profoundly altered. In the tibia, for example, the shaft is bowed
forward in a gentle curve, which is compared to the curve of a
sabre--"sabre-blade" deformity (Fig. 132). The diffuse thickening all
round the bone obscures the sharp margins so that the bone becomes
circular in section and the anterior and mesial edges are blunted, and
the comparison to a cucumber is deserved. In some cases the tibia is
actually increased in length as well as in girth.

[Illustration: FIG. 132.--Sabre-blade Deformity of Left Tibia in
Inherited Syphilis.

(From a photograph lent by Sir George T. Beatson.)]

The contrast between the grossly enlarged and misshapen tibia and the
normal or even attenuated fibula is a striking one.

_Treatment_ is carried out on lines similar to those recommended in the
acquired disease. When curving of the tibia causes disability in
walking, the bone may be straightened by a cuneiform resection.

_Syphilitic dactylitis_ is met with chiefly in children. It may affect
any of the fingers or toes, but is commonest in the first phalanx of the
index-finger or of the thumb. Several fingers may be attacked at the
same time or in succession. The lesion consists in a gummatous
infiltration of the soft parts surrounding the phalanx, or a gummatous
osteomyelitis, but there is practically no tendency to break down and
discharge, or to the formation of a sequestrum as is so common in
tuberculous dactylitis.

The finger becomes the seat of a swelling, which is more evident on the
dorsal aspect, and, according to the distribution and extent of the
disease, it is acorn-shaped, fusiform, or cylindrical. It is firm and
elastic, and usually painless. The movements are impaired, especially if
the joints are involved. In its early stages the disease is amenable to
anti-syphilitic treatment, and complete recovery is the rule.


HYDATID DISEASE

This rare disease results from the lodgment of the embryos of the taenia
echinoccus, which are conveyed to the marrow by the blood-stream. The
cysts are small, usually about the size of a pin-head, and they are
present in enormous numbers scattered throughout the marrow. The parts
of the skeleton most often affected are the articular ends of the long
bones, the bodies of the vertebrae, and the pelvis.

As the cysts increase in number and in size, the framework of the bone
is gradually absorbed, and there result excavations or cavities. The
marrow and spongy bone first disappear, the compact tissue then becomes
thin, and pathological fracture may result. The bone becomes expanded,
and the cysts may escape through perforations into the surrounding
cellular tissue, and when thus freed from confinement may attain
considerable dimensions. Suppuration from superadded pyogenic infection
may be attended with extensive necrosis, and lead to disorganisation of
the adjacent joint.

_Clinical Features._--The patient complains of deep-seated pains. In
superficial bones, such as the tibia, there is enlargement, and it may
be possible to recognise egg-shell crackling, or unequal consistence of
the bone, which is hard in some parts, and doughy and elastic in others.
The disease may pursue an indolent course during months or years until
some complication occurs, such as suppuration or fracture. With the
occurrence of suppuration the disease becomes more active, and abscesses
may form in the soft parts and in the adjacent joint. In the vertebral
column, hydatids give rise to angular deformity and paraplegia. In the
pelvis, there is usually great enlargement of the bones, and when
suppuration occurs it is apt to infect the hip-joint and to terminate
fatally.

Examination with the X-rays shows the characteristic excavations of the
bone caused by the cysts. The disease is liable to be mistaken for
central tumour, gumma, tuberculosis, or abscess of bone.

The _treatment_ consists in thorough eradication of the parasite by
operation. The bone is laid open and scraped or resected according to
the extent of the disease, and the raw surfaces swabbed with 1 per cent.
formalin. In advanced cases complicated with spontaneous fracture or
with suppuration, amputation affords the best chance of recovery.

The lesions in the bones resulting from _actinomycosis_ and from
_mycetoma_, have been described with these diseases.


CONSTITUTIONAL DISEASES ATTENDED WITH LESIONS IN THE BONES

These include rickets, scurvy-rickets, osteomalacia, ostitis deformans,
osteomyelitis fibrosa, fragilitas ossium, and diseases of the nervous
system.


RICKETS

Rickets or rachitis is a constitutional disease associated with
disturbance of nutrition, and attended with changes in the skeleton.
The disease is most common and most severe among the children of the
poorer classes in large cities, who are improperly fed and are brought
up in unhealthy surroundings. There is evidence that the most important
factors in the causation of rickets are ill-health of the mother during
pregnancy, and the administration to the child after its birth of food
which is defective in animal fat, proteids, and salts of lime, or which
contains these in such a form that they are not readily assimilated. The
occurrence of the disease is favoured, and its features are aggravated,
by imperfect oxygenation of the blood as the result of a deficiency of
fresh air and sunlight, want of exercise, and by other conditions which
prevail in the slums of large towns.

_Pathological Anatomy._--The most striking feature is the softness
(malacia) of the bones, due to excessive absorption of osseous tissue,
and the formation of an imperfectly calcified tissue at the sites of
ossification. The affected bones lose their rigidity, so that they are
bent under the weight of the body, by the traction of muscles, and by
other mechanical forces.

The _periosteum_ is thick and vascular, and when detached carries with
it plates and spicules of soft porous bone. The new bone may be so
abundant that it forms a thick crust on the surface, and in the flat
bones of the skull this may be heaped up in the form of bosses or ridges
resembling those ascribed to inherited syphilis.

In the epiphysial cartilages and at the ossifying junctions, all the
processes concerned in ossification, excepting the deposition of lime
salts, occur to an exaggerated degree. The cartilage of the epiphysial
disc proliferates actively and irregularly, so that it becomes softer,
thicker, and wider, and gives rise to a visible swelling, best seen at
the lower end of the radius and lower end of the tibia, and at the
costo-chondral junctions where the series of beaded swellings is known
as the "rickety rosary."

The ossifying zone is increased in depth; the marrow is abnormally
vascular; and the new bone that is formed is imperfectly calcified. The
result is that the bones may never attain their normal length, and they
remain stunted throughout life as in rickety dwarfs (Fig. 133), or the
shafts may grow unequally and come to deviate from their normal axes as
in knock-knee and bow-knee.

[Illustration: FIG. 133.--Skeleton of Rickety Dwarf, known as
"Bowed Joseph," leader of the Meal Riots in Edinburgh, who died in 1780.

(Anatomical Museum, University of Edinburgh.)]

These changes are well brought out in skiagrams; instead of the
well-defined narrow line which represents the epiphysial cartilage,
there is an ill-defined, blurred zone of considerable depth.

In the shafts of the long bones, owing to the excessive absorption of
bone, the cortex becomes porous, the spongy bone is rarefied, and the
bones readily bend or break under mechanical influences. When the
disease is arrested, a process of repair sets in which often results in
the bones becoming denser and heavier than normal. In the flat bones of
the skull, the absorption may result in the entire disappearance of
areas of bone, leaving a membrane which dimples like thin cardboard
under the pressure of the finger--a condition known as _craniotabes_.

_Changes in the Skeleton before the Child is able to walk._--The
fontanelles remain open until the end of the second year or longer, and
the frontal and parietal eminences are unduly prominent. There is
sometimes hydrocephalus, and the head is characteristically enlarged.
The jaws are altered so that while the upper jaw is contracted into the
shape of a #V#, the lower jaw is square instead of rounded in outline,
and the teeth do not oppose one another. In the _thorax_, the chief
feature may be the beading at the costo-chondral junctions, principally
of the fifth and sixth ribs or its walls may be contracted,
particularly if respiration is interfered with as a result of bronchial
catarrh or adenoids. The contraction may take the form of a vertical
groove on each side, or of a horizontal groove at the level of the upper
end of the xiphi-sternum; when the sternum and cartilages form a
projection in front, the deformity is known as "pigeon-breast."

The _spine_ may be curved backwards--_kyphosis_--throughout its
whole extent or only in one part; or it may be curved to one
side--_scoliosis_.

In the _limbs_, the prominent features are the deficient growth in
length of the long bones, the enlargements at the epiphysial junctions,
and the bending, and occasional greenstick fracture, of the shafts. The
degree of enlargement of the epiphysial junctions is directly
proportionate to the amount of movement to which the bone is subjected
(John Thomson). The curves at this stage depend on the attitude of the
child while sitting or being carried--for example, the arm bones become
bent in children who paddle about the floor with the aid of their arms;
and in a child who lies on its back with the lower limbs everted, the
weight of the limb may lead to curvature of the neck of the femur--coxa
vara. The clavicle or humerus may sustain greenstick fracture from the
child being lifted by the arms; the femur, by a fall. From the extreme
laxity of the ligaments, the joints can be moved beyond the normal
limits, and the child is often observed to twist its limbs into abnormal
attitudes.

_In Children who have walked._--In these children the most important
deformities occur in the spine, pelvis, and lower extremities, and
result for the most part from yielding of the softened bones under the
weight of the body. Scoliosis is the usual type of spinal curvature, and
in extreme cases it may lead to a pronounced form of hump-back. The
pelvis may remain small (_justo-minor pelvis_), or it may be contracted
in the sagittal plane (_flat pelvis_); when the bones are unusually
soft, the acetabular portions are pushed inwards by the femora bearing
the weight of the body, and the pelvis assumes the shape of a trefoil,
as in the malacia of women. The shaft of the femur is curved forwards
and laterally; the bones of the leg laterally as in bow-leg, or
forwards, or forwards and laterally just above the ankle. The
deformities at the knee (genu valgum, genu varum, and genu recurvatum),
and at the hip (coxa vara), will be described in the volume dealing with
the Extremities.

The majority of cases seen in surgical practice suffer from the
deformities resulting from rickets rather than from the active disease.
The examination of a large series of children at different ages shows
that the deformities become less and less frequent with each year. Those
who recover may ultimately show no trace of rickets, and this is
especially true of children who grow at the average rate; in those,
however, in whom growth is retarded, especially from the fifth to the
seventh year, the deformities are apt to be permanent. It may be noted
that the scoliosis due to rickets has little tendency towards recovery.

_Treatment._--The treatment of the disease consists in regulating the
diet, improving the surroundings, and preventing deformity. Phosphorus
in doses of 100th grain may be given dissolved in cod-liver oil, and
preparations of iron and lime may be added with advantage. To avoid
those postures which predispose to deformities, the child should lie as
much as possible. In the well-to-do classes this is readily accomplished
by the aid of a nurse and the use of a perambulator. In hospital
out-patients the child is kept off its feet by the use of a light wooden
splint applied to the lateral aspect of each lower extremity, and
extending from the pelvis to 6 inches beyond the sole.

When deformities are already present, the treatment depends upon whether
or not there is any prospect of the bone straightening naturally. Under
five years of age this may, as a rule, be confidently expected; the
child should be kept off its feet, and the limbs bathed and massaged. In
children of five or six and upwards, the prospect of natural
straightening is a diminishing one, and it is more satisfactory to
correct the deformity by operation. In rickety curvature of the spine,
the child should lie on a firm mattress, or, to allow of its being taken
into the open air, upon a double Thomas' splint extending from the
occiput to the heels; the muscles acting on the trunk should be braced
up by massage and appropriate exercises.

#Late Rickets# or #Rachitis Adolescentium# is met with at any age from
nine to seventeen, and is generally believed to be due to a
recrudescence of rickets which had been present in childhood. The
disease is not attended with any disturbance of the general health; the
pathological changes are the same as in infantile rickets, but are for
the most part confined to the ossifying junctions, especially those
which are most active during adolescence, for example at the knee-joint.
The patient is easily tired, complains of pain in the bones, and, unless
care is taken, deformity is liable to ensue. There can be no doubt that
adolescent rickets plays an important part in the production of the
deformities which occur at or near puberty, especially knock-knee and
bow-knee.

#Scurvy-Rickets# or #Infantile Scurvy#.--This disease, described by
Barlow and Cheadle, is met with in infants under two years who have been
brought up upon sterilised or condensed milk and other proprietary
foods, and is most common in the well-to-do classes. The haemorrhages,
which are so characteristic of the disease, are usually preceded for
some weeks by a cachectic condition, with listlessness and debility and
disinclination for movement. Very commonly the child ceases to move one
of his lower limbs--pseudo-paralysis--and screams if it is touched; a
swelling is found over one of the bones, usually the femur, accompanied
by exquisite tenderness; the skin is tense and shiny, and there may be
some oedema. These symptoms are due to a sub-periosteal haemorrhage, and
associated with this there may be crepitus from separation of an
epiphysis, rarely from fracture of the shaft of the bone. X-ray
photographs show enlargement of the bone, the periosteum being raised
from the shaft and new bone formed in relation to it. Haemorrhages also
occur into the skin, presenting the appearance of bruises, into the
orbit and conjunctiva, and from the mucous membranes.

The _treatment_ consists in correcting the errors in diet. The infant
should have a wet nurse or a plentiful supply of cow's milk in its
natural state. Anti-scorbutics in the form of orange, lemon, or grape
juice, and of potatoes bruised down in milk, may be given.

#Osteomalacia.#--The term osteomalacia includes a group of conditions,
closely allied to rickets, in which the bones of adults become soft and
yielding, so that they are unduly liable to bend or break.

One form occurs in _pregnant and puerperal women_, affecting most
commonly the pelvis and lumbar vertebrae, but sometimes the entire
skeleton. The lime salts are absorbed, the bones lose their rigidity and
bend under the weight of the body and other mechanical influences, with
the result that gross deformities are produced, particularly in the
pelvis, the lumbar spine, and the hip-joints.

_Neuropathic_ forms occur in certain chronic diseases of the brain and
cord; in some cases the bones lose their lime salts and bend, in others
they become brittle.

_Osteomalacia associated with New Growths in the Skeleton._--When
_secondary cancer_ is widely distributed throughout the skeleton, it is
associated with softening of the bones, as a result of which they
readily bend or break, and after death are easily cut with a knife. In
the disease known as _multiple myeloma_, the interior of the ribs,
sternum, and bodies of the vertebrae is occupied by a reddish gelatinous
pulp, the structure of which resembles sarcoma; the bones are reduced to
a mere shell, and may break on the slightest pressure; the urine
contains albumose, a substance resembling albumen but coagulating at a
comparatively low temperature (140 o F.), and the coagulum is
re-dissolved on boiling, and it is readily precipitated by hydrochloric
acid (Bence-Jones).

#Ostitis Deformans--Paget's Disease of Bone.#--This rare disease was
first described by Sir James Paget in 1877. In the early stages, the
marrow is transformed into a vascular connective tissue; its bone-eating
functions are exaggerated, and the framework of the bone becomes
rarefied, so that it bends under pressure as in osteomalacia. In course
of time, however, new bone is formed in great abundance; it is at first
devoid of lime salts, but later becomes calcified, so that the bones
regain their rigidity. This formation of new bone is much in excess of
the normal, the bones become large and bulky, their surfaces rough and
uneven, their texture sclerosed in parts, and the medullary canal is
frequently obliterated. These changes are well brought out in X-ray
photographs. The curving of the long bones, which is such a striking
feature of the disease, may be associated with actual lengthening, and
the changes are sometimes remarkably symmetrical (Fig. 135). The bones
forming the cranium may be enormously thickened, the sutures are
obliterated, the distinction into tables and diploe is lost, and, while
the general texture is finely porous, there may be areas as dense as
ivory (Fig. 134).

[Illustration: FIG. 134.--Changes in the Skull resulting from Ostitis
Deformans.

(Anatomical Museum, University of Edinburgh.)]

_Clinical Features._--The disease is usually met with in persons over
fifty years of age. It is insidious in its onset, and, the patient's
attention may be first attracted by the occurrence of vague pains in the
back or limbs; by the enlargement and bending of such bones as the tibia
or femur; or by a gradual increase in the size of the head,
necessitating the wearing of larger hats. When the condition is fully
developed, the attitude and general appearance are eminently
characteristic. The height is diminished, and, owing to the curving of
the lower limbs and spine, the arms appear unnaturally long; the head
and upper part of the spine are bent forwards; the legs are held apart,
slightly flexed at the knees, and are rotated out as well as curved; the
whole appearance suggests that of one of the large anthropoid apes. The
muscles of the limbs may waste to such an extent as to leave the large,
curved, misshapen bones covered only by the skin (Fig. 135). In the
majority of cases the bones of the lower extremities are much earlier
and more severely affected than those of the upper extremity, but the
capacity of walking is usually maintained even in the presence of great
deformity. In a case observed by Byrom Bramwell, the patient suffered
from a succession of fractures over a period of years.

[Illustration: FIG. 135.--Cadaver, illustrating the alterations in the
Lower Limbs resulting from Ostitis Deformans.]

The disease may last for an indefinite period, the general health
remaining long unaffected. In a considerable number of the recorded
cases one of the bones became the seat of sarcoma.

#Osteomyelitis Fibrosa.#--This comparatively rare disease, which was
first described by Recklinghausen, presents many interesting features.
Because of its causing deformities of the bones and an undue liability
to fracture, and being chiefly met with in adolescents, it is regarded
by some authors as a juvenile form of Paget's disease. It may be
diffused throughout the skeleton--we have seen it in the skull and in
the bones of the extremities--or it may be confined to a single bone,
usually the femur, or, what is more remarkable, the condition may affect
a portion only of the shaft of a long bone and be sharply defined from
the normal bone in contact with it.

[Illustration: FIG. 136.--Osteomyelitis Fibrosa affecting Femora in a
man aet. 19. The curving of the bones is due to multiple fractures.]

On longitudinal section of a long bone during the active stage of the
disease, the marrow is seen to be replaced by a vascular young
connective tissue which encroaches on the surrounding spongy bone,
reducing it to the slenderest proportions; the formation of bone from
the periosteum does not keep pace with the absorption and replacement
going on in the interior, and the cortex may be reduced to a thin shell
of imperfectly calcified bone which can be cut with a knife. The young
connective tissue which replaces the marrow is not unlike that seen in
osteomalacia; it is highly vascular and may show haemorrhages of various
date; there are abundant giant cells of the myeloma type, and
degeneration and liquefaction of tissue may result in the formation of
cysts, which, when they constitute a prominent feature, are responsible
for the name--_osteomyelitis fibrosa cystica_--sometimes applied to the
condition.

It would appear that most of the recorded cases of _cysts of bone_ owe
their origin to this disease, while the abundance of giant cells with
occasional islands of cartilage in the wall of such cysts is responsible
for the view formerly held that they owed their origin to the
liquefaction of a solid tumour, such as a myeloma, a chondroma, or even
a sarcoma. Although the tissue elements in this disease resemble those
of a new growth arising in the marrow, they differ in their arrangement
and in their method of growth; there is no tendency to erupt through the
cortex of the bone, to invade the soft parts, or to give rise to
secondary growths.

_Clinical Features._--The onset of the disease is insidious, and
attention is usually first directed to it by the occurrence of fracture
of the shaft of one of the long bones--usually the femur--from violence
that would be insufficient to break a healthy bone. Apart from fracture,
the great increase in the size of one of the long bones and its uneven
contour are sufficiently remarkable to suggest examination with the
X-rays, by means of which the condition is at once recognised. A
systematic examination of the other long bones will often reveal the
presence of the disease at a stage before the bone is altered
externally.

Symmetrical bossing of the skull was present in the case shown in
Figs. 136 and 137, and there were also scattered patches of brown
pigmentation of the skin of the face, neck, and trunk, similar to those
met with in generalised neuro-fibromatosis. Apart from fracture, the
disease is recognised by the thickening and usually also by the curving
of the shafts of the long bones. It is easy to understand the curvature
of bones that have passed through a soft stage and also of those that
have been broken and badly united, but it is difficult to account for
the curvatures that have no such cause; for example, we have seen
marked curve of the radius in a forearm of which the ulna was quite
straight. The curvature probably resulted from exaggerated growth in
length.

[Illustration: FIG. 137.--Radiogram of Upper End of Femur showing
appearances in Osteomyelitis Fibrosa.]

The X-ray appearances vary with the stage of the malady, not estimated
in time, for the condition is chronic and may become stationary, but
according to whether it is progressive or undergoing repair. The shadow
of the bone presents a poor contrast to the soft parts, and no trace of
its original architecture; in extreme cases the shadow of the femur
resembles an unevenly filled sausage (Fig. 137); there is no cortical
layer, the interior shows no trabecular structure, and some of the many
clear areas are probably cysts. The condition extends right up to the
articular cartilage, or, in the case of adolescent bones, up to the
epiphysial cartilage.

_Prognosis._--The condition does not appear to affect the general
health. The future is concerned with the local conditions, and,
especially in the case of the femur, with its liability to fracture; so
far as we know there is no time limit to this.

_Treatment_ is confined to protecting the affected bone--usually the
femur--from injury. Operative treatment may be required for lameness due
to a badly united fracture.

#Neuropathic Atrophy of Bone.#--The conditions included under this
heading occur in association with diseases of the nervous system.

Most importance attaches to the fragility of the bones met with in
general paralysis of the insane, locomotor ataxia, and other chronic
diseases of the brain and spinal cord. The bones are liable to be
fractured by forces which would be insufficient to break a healthy bone.
In _locomotor ataxia_ the fractures affect especially the bones of the
lower extremity, and may occur before there are any definite nerve
symptoms, but they are more often met with in the ataxic stage, when the
abrupt and uncontrolled movements of the limbs may play a part in their
causation. They may be unattended with pain, and may fail to unite; when
repair does take place, it is sometimes attended with an excessive
formation of callus. Joint lesions of the nature of Charcot's disease
may occur simultaneously with the alterations in the bones. In
_syringomyelia_ pathological fracture is not so frequent as in locomotor
ataxia; it is more likely to occur in the bones of the upper extremity,
and especially in the humerus. In some cases of _epilepsy_ the bones
break when the patient falls in a fit, and there is usually an
exaggerated amount of comminution.

In these affections the bones present no histological or chemical
alterations, and the X-ray shadow does not differ from the normal. It is
maintained, therefore, that the disposition to fracture does not depend
upon a fragility of the bone, but on the loss of the muscular sense and
of common sensation in the bones, as a result of which there is an
inability properly to throw the muscles into action and dispose the
limbs so as to place them under the most favourable conditions to meet
external violence.

#Osteogenesis Imperfecta#, #Fragilitas Ossium#, or #Congenital
Osteopsathyrosis#.--These terms are used to describe a condition in
which an undue fragility of the bones dates from intra-uterine life. It
may occur in several members of the same family. In severe cases,
intra-uterine fractures occur, and during parturition fresh fractures
are almost sure to be produced, so that at birth there is a combination
of recent fractures and old fractures united and partly united, with
bendings and thickenings of the bones. Large areas of the cranial vault
may remain membranous.

After birth the predisposition to fracture continues, the bones are
easily broken, the fractures are attended with little or no pain, the
crepitus is soft, and although union may take place, it may be delayed
and be attended with excess of callus. Cases have been observed in which
a child has sustained over a hundred fractures.

The bones show a feeble shadow with the X-rays, and appear thin and
atrophied; the medullary canal is increased at the expense of the
cortex.

In young infants in whom multiple fractures occur the prognosis as to
life is unfavourable, and no satisfactory treatment of the disease has
been formulated. If the patient survives, the tendency to fracture
gradually disappears.

#Hypertrophic Pulmonary Osteo-Arthropathy.#--This condition, which was
described by Marie in 1890, is secondary to disease in the chest, such
as chronic phthisis, empyema, bronchiectasis, or sarcoma of the lung.

There is symmetrical enlargement and deformity of the hands and feet;
the shafts of the bones are thickened, and the soft tissues of the
terminal segments of the digits hypertrophied. The fingers come to
resemble drum-sticks, and the thumb the clapper of a bell. The nails are
convex, and incurved at their free ends, suggesting a resemblance to the
beak of a parrot. There is also enlargement of the lower ends of the
bones of the forearm and leg, and effusion into the wrist and
ankle-joints. Skiagrams of the hands and feet show a deposit of new bone
along the shafts of the phalanges.


TUMOURS OF BONE

New growths which originate in the skeleton are spoken of as _primary
tumours_; those which invade the bones, either by metastasis from other
parts of the body or by spread from adjacent tissues, as _secondary_. A
tumour of bone may grow from the cellular elements of the periosteum,
the marrow, or the epiphysial cartilage.

Primary tumours are of the connective-tissue type, and are usually
solitary, although certain forms, such as the chondroma, may be multiple
from the outset.

_Periosteal tumours_ are at first situated on one side of the bone, but
as they grow they tend to surround it completely. Innocent periosteal
tumours retain the outer fibrous layer as a capsule. Malignant tumours
tend to perforate the periosteal capsule and invade the soft parts.

_Central_ or _medullary tumours_ as they increase in size replace the
surrounding bone, and simultaneously new bone is formed on the surface;
as this is in its turn absorbed, further bone is formed beneath the
periosteum, so that in time the bone is increased in girth, and is said
to be "expanded" by the growth in its interior.

#Primary Tumours--Osteoma.#--When the tumour projects from the surface
of a bone it is called an _exostosis_. When growing from bones developed
in membrane, such as the flat bones of the skull, it is usually dense
like ivory, and the term _ivory exostosis_ is employed. When derived
from hyaline cartilage--for example, at the ends of the long bones--it
is known as a _cartilaginous exostosis_. This is invested with a cap of
cartilage from which it continues to grow until the skeleton attains
maturity.

An exostosis forms a rounded or mushroom-shaped tumour of limited size,
which may be either sessile or pedunculated, and its surface is smooth
or nodulated (Figs. 138 and 139). A cartilaginous exostosis in the
vicinity of a joint may be invested with a synovial sac or bursa--the
so-called _exostosis bursata_. The bursa may be derived from the
synovial membrane of the adjacent joint with which its cavity sometimes
communicates, or it may be of adventitious origin; when it is the seat
of bursitis and becomes distended with fluid, it may mask the underlying
exostosis, which then requires a radiogram for its demonstration.

[Illustration: FIG. 138.--Radiogram of Right Knee showing Multiple
Exostoses.]

_Clinically_, the osteoma forms a hard, indolent tumour attached to a
bone. The symptoms to which it gives rise depend on its situation. In
the vicinity of a joint, it may interfere with movement; on the medial
side of the knee it may incapacitate the patient from riding. When
growing from the dorsum of the terminal phalanx of the great
toe--_subungual exostosis_--it displaces the nail, and may project
through its matrix at the point of the toe, while the soft parts over it
may be ulcerated from pressure (Fig. 107). It incapacitates the patient
from wearing a boot. When it presses on a nerve-trunk it causes pains
and cramps. In the orbit it displaces the eyeball; in the nasal fossae
and in the external auditory meatus it causes obstruction, which may be
attended with ulceration and discharge. In the skull it may project
from the outer table, forming a smooth rounded swelling, or it may
project from the inner table and press upon the brain.

The diagnosis is to be made by the slow growth of the tumour, its
hardness, and by the shadow which it presents with the X-rays (Fig. 138).

An osteoma which does not cause symptoms may be left alone, as it ceases
to grow when the skeleton is mature and has no tendency to change its
benign character. If causing symptoms, it is removed by dividing the
neck or base of the tumour with a chisel, care being taken to remove the
whole of the overlying cartilage. The dense varieties met with in the
bones of the skull present greater difficulties; if it is necessary to
remove them, the base or neck of the tumour is perforated in many
directions with highly tempered drills rotated by some form of engine,
and the division is completed with the chisel.

[Illustration: FIG. 139.--Multiple Exotoses of both limbs.

(Photograph lent by Sir George T. Beatson.)]

#Multiple Exostoses.#--This disease, which, by custom, is still placed
in the category of tumours, is to be regarded as a disorder of growth,
dating from intra-uterine life and probably due to a disturbance in the
function of the glands of internal secretion, the thyreoid being the one
which is most likely to be at fault (Arthur Keith). The disorder of
growth is confined to those elements of the skeleton where a core of
bone formed in cartilage comes to be encased in a sheath of bone formed
beneath the periosteum. To indicate this abnormality the name
_diaphysial aclasis_ has been employed by Arthur Keith at the suggestion
of Morley Roberts.

Bones formed entirely in cartilage are exempt, namely, the tarsal and
carpal bones, the epiphyses of the long bones, the sternum, and the
bodies of the vertebrae. Bones formed entirely in membrane, that is,
those of the face and of the cranial vault, are also exempt. The
disorder mainly affects the ossifying junctions of the long bones of the
extremities, the vertebral border of the scapula, and the cristal border
of the ilium.

_Clinically_ the disease is attended with the gradual and painless
development during childhood or adolescence of a number of tumours or
irregular projections of bone, at the ends of the long bones, the
vertebral border of the scapula, and the cristal border of the ilium.
They exhibit a rough symmetry; they rarely attain any size; and they
usually cease growing when the skeleton attains maturity--the conversion
of cartilage into bone being then completed. While they originate from
the ossifying junctions of the long bones, they tend, as the shaft
increases in length, to project from the surface of the bone at some
distance from the ossifying junction and to "point" away from it. They
may cause symptoms by "locking" the adjacent joint or by pressing upon
nerve-trunks or blood vessels.

In a considerable proportion of cases, the disturbance of growth is
further manifested by dwarfing of the long bones; these are not only
deficient in length but are sometimes also curved and misshapen, which
accounts for the condition being occasionally confused with the
disturbances of growth resulting from rickets. In about one-third of the
recorded cases there is a dislocation of the head of the radius on one
or on both sides, a result of unequal growth between the bones of the
forearm.

[Illustration: FIG. 140.--Multiple Cartilaginous Exostoses in a
man aet. 27. The scapular tumour projecting above the right clavicle has
taken on active growth and pressed injuriously on the cords of the
brachial plexus.]

In early adult life, one of the tumours, instead of undergoing
ossification, may take on active growth and exhibit the features of a
chondro-sarcoma, pressing injuriously upon adjacent structures (Fig. 140)
and giving rise later to metastases in the lungs.

The _X-ray appearances_ of the bones affected are of a striking
character; apart from the outgrowths of bone or "tumours" there is
evident a widespread alteration in the internal architecture of the
bones, which suggests analogies with other disturbances of ossification
such as achondroplasia and osteomyelitis fibrosa. The condition is one
that runs in families, sometimes through several generations; we have
more than once seen a father and son together in the hospital
waiting-room.

As regards _treatment_, there is no indication for surgical interference
except when one or other tumour is a source of disability as by pressing
upon a nerve-trunk or by locking a joint, in which case it is easily
removed by chiselling through its neck.

[Illustration: FIG. 141.--Multiple Cartilaginous Exostoses in a
man aet. 27, the same as in Fig. 140.]

_Diffuse Osteoma, Leontiasis Ossea._--This rare affection was described
by Virchow, and named leontiasis ossea because of the disfigurement to
which it gives rise. It usually commences in adolescence as a diffuse
overgrowth first of one and then of both maxillae; these bones are
enlarged in all directions and project on the face, and the nasal fossae
and the maxillary and frontal sinuses become filled up with bone, which
encroaches also on the orbital cavities. In addition to the hideous
deformity, the patient suffers from blocking of the nose, loss of smell,
and protrusion of the eyes, sometimes followed by loss of sight. The
condition is liable to spread to the zygomatic and frontal bones, the
vault of the skull, and to the mandible. The base of the skull is not
affected. The disease is of slow progress and may become arrested; life
may be prolonged for many years, or may be terminated by brain
complications or by intercurrent affections. In certain cases it is
possible to remove some of the more disfiguring of the bony masses.

A less aggressive form, confined to the maxilla on one side, is
sometimes met with, and, in a case of this variety under our own
observation, the disfigurement, which was the only subject of complaint,
was removed, after reflecting the soft parts, by paring away the excess
of bone; this is easily done as the bone is spongy, and at an early
stage, imperfectly calcified.

A remarkable form of _unilateral hypertrophy and diffuse osteoma of the
skull_, following the distribution of the fifth nerve, has seen
described by Jonathan Hutchinson and Alexis Thomson.

#Chondroma.#--Cartilaginous tumours, apart from those giving rise to
multiple exostoses, grow from the long bones and from the scapula,
ilium, ribs, or jaws. They usually project from the surface of the bone,
and may attain an enormous size; sometimes they grow in the interior of
a bone, the so-called _enchondroma_.

The hyaline cartilage composing the tumour frequently undergoes
myxomatous degeneration, resulting in the formation of a glairy,
semi-fluid jelly, and if this change takes place throughout the tumour
it comes to resemble a cyst. On the other hand, the cartilage may
undergo calcification or ossification. The most important transition of
all is that into sarcoma, the so-called _malignant chondroma_ or
_chondro-sarcoma_, which is associated with rapid increase in size,
and parts of the tumour may be carried off in the blood-stream and give
rise to secondary growths, especially in the lungs.

Cases have been met with in which certain parts of the skeleton--only
those developed in cartilage--were so uniformly permeated with cartilage
that the condition has been described as a "chondromatosis" and is
regarded as dating from an early period of foetal life. Unlike the
condition known as multiple cartilaginous exostoses, it is a malignant
disease.

[Illustration: FIG. 142.--Multiple Chondromas of Phalanges and
Metacarpals in a boy aet. 10 (cf. Fig. 143).]

The chondroma is met with as a slowly growing tumour which is specially
common in the bones of the hand, often in a multiple form (Figs. 142 and
144). The surface is smooth or lobulated, and in consistence the tumour
may be dense and elastic like normal cartilage, or may present areas of
softening, or of bony hardness. The skin moves freely over it, except in
relation to the bones of the fingers, where it may become adherent and
ulcerate, simulating the appearance of a malignant tumour. Large tumours
growing from the bones of the extremities may implicate the main
vessels and nerves, either surrounding them or pressing on them.

Portions of a chondroma, which have undergone calcification or
ossification, throw a dark shadow with the X-rays; unaltered cartilage
and myxomatous tissue appear as clear areas.

[Illustration: FIG. 143.--Skiagram of Multiple Chondromas shown
in Fig. 142.]

_Treatment._--It is necessary to remove the whole tumour, and in
chondromas growing from the surface of the bone, especially if they are
pedunculated, this is comparatively easy. When a bone, such as the
scapula or mandible, is involved, it is better to excise the bone, or at
least the part of it which bears the tumour. In the case of central
tumours the shell of bone is removed over an area sufficient to allow of
the enucleation of the tumour, or the affected portion of bone is
resected. Should there be evidence of malignancy, such as increased rate
of growth, a tube of radium should be inserted, and in advanced cases
with destruction of tissue, amputation may be called for.

[Illustration: FIG. 144.--Multiple Chondromas in Hand of boy aet. 8]

In multiple chondromas of the hand in young subjects, it was formerly
the custom to amputate the limb; an attempt should be made to avoid this
by shelling out the larger tumours individually, and persevering with
the application of the X-rays or of radium to inhibit the growth of the
smaller ones.

Chondromas springing from the pelvic bones usually arise in the region
of the sacro-iliac joint; they project into the pelvis and press on the
bladder and rectum, and on the sciatic and obturator nerves; sometimes
also on the iliac veins, causing oedema of the legs. They are liable to
take on malignant characters, and rarely lend themselves to complete
removal by operation.

#Fibroma# is met with chiefly as a periosteal growth in relation to the
mouth and pharynx, the _simple epulis_ of the alveolar margin and the
_naso-pharyngeal polypus_ being the most common examples. We have met
with a fibroma in the interior of the lower end of the femur of an
adult, causing expansion of the bone with decided increase in girth and
liability to pathological fracture; it is possible that this represents
the cured stage of osteomyelitis fibrosa.

_Myxoma_, _lipoma_, and _angioma_ of bone are all rare.

#Myeloma.#--The myeloid tumour, which is sometimes classified with the
sarcomas, contains as its chief elements large giant cells, like those
normally present in the marrow. On section these tumours present a
brownish-red or chocolate colour, and, being highly vascular, are liable
to haemorrhages, and therefore also to pigmentation, and to the formation
of blood cysts. Sometimes the arterial vessels are so dilated as to
impart to the tumour an aneurysmal pulsation and bruit. The enlargement
or "expansion" of the bone results in the cortex being represented by a
thin shell of bone, which may crackle on pressure--parchment or
egg-shell crackling.

The myeloma is most often met with between the ages of twenty-five and
forty in the upper end of the tibia or lower end of the femur. It grows
slowly and causes little pain, and may long escape recognition unless an
examination is made with the X-rays. Although these tumours have been
known to give rise to metastases, they are, as a rule, innocent and are
to be treated as such. When located in the shaft of a long bone,
pathological fracture is liable to occur.

_Diagnosis and X-ray Appearances of Myeloma._--The early diagnosis of
myeloma is made with the aid of the X-rays: the typical appearance is
that of a rounded or oval clear area bounded by a shell of bone of
diminishing thickness (Fig. 145). The inflammatory lesions at the ends
of the long bones--tubercle, syphilitic gumma, and Brodie's abscess,
that resemble myeloma, are all attended with the formation of new bone
in greater or lesser amount. The myeloma is also to be diagnosed from
chondroma, from sarcoma, and from osteomyelitis fibrosa cystica.

[Illustration: FIG. 145.--Radiogram of Myeloma of Humerus.

(Mr. J. W. Struthers' case.)]

_Treatment._--In early cases the cortex is opened up to give free access
to the tumour tissue, which is scraped out with the spoon. Bloodgood
advises the use of Esmarch's tourniquet, and that the curetting be
followed by painting with pure carbolic acid and then rinsing with
alcohol; a rod of bone is inserted to fill the gap. In advanced cases
the segment of bone is resected and a portion of the tibia or fibula
from the other limb inserted into the gap; a tube of radium should also
be introduced.

The coexistence of diffuse myelomatosis of the skeleton and albumosuria
(Bence-Jones) is referred to on p. 474. Myeloma occurs in the jaws,
taking origin in the marrow or from the periosteum of the alveolar
process, and is described elsewhere.

#Sarcoma# and #endothelioma# are the commonest tumours of bone, and
present wide variations in structure and in clinical features.
Structurally, two main groups may be differentiated: (1) the soft,
rapidly growing cellular tumours, and (2) those containing fully formed
fibrous tissue, cartilage, or bone.

(1) The _soft cellular tumours_ are composed mainly of spindle or round
cells; they grow from the marrow of the spongy ends or from the
periosteum of the long bones, the diploe of the skull, the pelvis,
vertebrae, and jaws. As they grow they may cause little alteration in the
contour of the bone, but they eat away its framework and replace it, so
that the continuity of the bone is maintained only by tumour tissue, and
pathological fracture is a frequent result. The small round-celled
sarcomas are among the most malignant tumours of bone, growing with
great rapidity, and at an early stage giving rise to secondary growths.

(2) The second group includes the _fibro-_, _osteo-_, and
_chondro-sarcomas_, and combinations of these; in all of them fully
formed tissues or attempts at fully formed tissues predominate over the
cellular elements. They grow chiefly from the deeper layer of the
periosteum, and at first form a projection on the surface, but later
tend to surround the bone (Fig. 150), and to invade its interior,
filling up the marrow spaces with a white, bone-like substance; in the
flat bones of the skull they may traverse the diploe and erupt on the
inner table. The tumour tissue next the shaft consists of a dense,
white, homogeneous material, from which there radiate into the softer
parts of the tumour, spicules, needles, and plates, often exhibiting a
fan-like arrangement (Fig. 151). The peripheral portion consists of soft
sarcomatous tissue, which invades the overlying soft parts. The
articular cartilage long resists destruction. The ossifying sarcoma is
met with most often in the femur and tibia, less frequently in the
humerus, skull, pelvis, and jaws. In the long bones it may grow from the
shaft, while the chondro-sarcoma more often originates at the
extremities. Sometimes they are multiple, several tumours appearing
simultaneously or one after another. Secondary growths are met with
chiefly in the lungs, metastasis taking place by way of the veins.

[Illustration: FIG. 146.--Periosteal Sarcoma of Femur in a young
subject.]

[Illustration: FIG. 147.--Periosteal Sarcoma of Humerus, after
maceration.

(Anatomical Museum, University of Edinburgh.)]

_Clinical Features._--Sarcoma is usually met with before the age of
thirty, and is comparatively common in children. Males suffer oftener
than females, in the proportion of two to one.

In _periosteal sarcoma_ the presence of a swelling is usually the first
symptom; the tumour is fusiform, firm, and regular in outline, and when
it occurs near the end of a long bone the limb frequently assumes a
characteristic "leg of mutton" shape (Fig. 146). The surface may be
uniform or bossed, the consistence varies at different parts, and the
swelling gradually tapers off along the shaft. On firm pressure, fine
crepitation may be felt from crushing of the delicate framework of new
bone.

[Illustration: FIG. 148.--Chondro-Sarcoma of Scapula in a man aet. 63;
removal of the scapula was followed two years later by metastases and
death.]

In _central sarcoma_ pain is the first symptom, and it is usually
constant, dull, and aching; is not obviously increased by use of the
limb, but is often worse at night. Swelling occurs late, and is due to
expansion of the bone; it is fusiform or globular, and is at first
densely hard, but in time there may be parchment-like or egg-shell
crackling from yielding of the thin shell. The swelling may pulsate, and
a bruit may be heard over it. In advanced cases it may be impossible to
differentiate between a periosteal and a central tumour, either
clinically or after the specimen has been laid open.

Pathological fracture is more common in central tumours, and sometimes
is the first sign that calls attention to the condition. Consolidation
rarely takes place, although there is often an attempt at union by the
formation of cartilaginous callus.

[Illustration: FIG. 149.--Central Sarcoma of Lower End of Femur,
invading the knee-joint.

(Museum of Royal College of Surgeons, Edinburgh.)]

[Illustration: FIG. 150.--Osseous Shell of Osteo-Sarcoma of Upper Third
of Femur, after maceration.]

The soft parts over the tumour for a long time preserve their normal
appearance; or they become oedematous, and the subcutaneous venous
network is evident through the skin. Elevation of the temperature over
the tumour, which may amount to two degrees or more, is a point of
diagnostic significance, as it suggests an inflammatory lesion.

The adjacent joint usually remains intact, although its movements may be
impaired by the bulk of the tumour or by effusion into the cavity.

Enlargement of the neighbouring lymph glands does not necessarily imply
that they have become infected with sarcoma for the enlargement may
disappear after removal of the primary growth; actual infection of the
glands, however, does sometimes occur, and in them the histological
structure of the parent tumour is reproduced.

To obtain a reasonable prospect of cure, the _diagnosis_ must be made at
an early stage. Great reliance is to be placed on information gained by
examination with the X-rays.

[Illustration: FIG. 151.--Radiogram of Osteo-Sarcoma of Upper Third
of Femur.]

_X-ray Appearances._--In periosteal tumours that do not ossify, there is
merely erosion of bone, and the shadow is not unlike that given by
caries; in ossifying tumours, the arrangement of the new bone on the
surface is characteristic, and when it takes the form of spicules at
right angles to the shaft, it is pathognomic.

In soft central tumours, there is disappearance of bone shadow in the
area of the tumour, while above and below or around this, the shadow is
that of normal bone right up to the clear area. In many respects the
X-ray appearances resemble those of myeloma. In tumours in which there
is a considerable amount of imperfectly formed new bone, this gives a
shadow which barely replaces that of the original bone, in parts it may
even add to it--the resulting picture differing widely in different
cases; but it is usually possible to differentiate it from that caused
by bacterial infections of the bone and from lesions of the adjacent
joint.

[Illustration: FIG. 152.--Radiogram of Chondro-Sarcoma of Upper End of
Humerus in a woman aet. 29.]

Skiagraphy is not only of assistance in differentiating new growths from
other diseases of bone, but may also yield information as to the
situation and nature of the tumour, which may have important bearings on
its treatment by operation.

When fracture of a long bone takes place in an adolescent or young adult
from comparatively slight violence, disease of the bone should be
suspected and an X-ray examination made.

In difficult cases the final appeal is to exploratory incision and
microscopical examination of a portion of the tumour; this should be
done when the major operation has been arranged for, the surgeon waiting
until the examination is completed.

The _prognosis_ varies widely. In general, it may be said that
periosteal tumours are less favourable than central ones, because they
are more liable to give rise to metastases. Permanent cures are
unfortunately the exception.

_Treatment._--When one of the bones of a limb is involved, the usual
practice has been to perform amputation well above the growth, and this
may still be recommended as a routine procedure. There are reasons,
however, which may be urged against its continuance. High amputation is
unnecessary in the more benign sarcomas, and in the more malignant forms
is usually unavailing to prevent a fatal issue either from local
recurrence or from metastases in the lungs or elsewhere. Following
the lead of Mikulicz, a considerable number of permanent cures have been
obtained by resecting the portion of bone which is the seat of the
tumour, and substituting for it a corresponding portion from the tibia
or fibula of the other limb. In a cellular sarcoma of the humerus of a
boy we resected the shaft and inserted his fibula ten years ago, and he
shows no sign of recurrence. When resection is impracticable, a
subcapsular enucleation is performed, followed by the insertion of
radium.

#Pulsating Haematoma# or #Aneurysm of Bone#.--A limited number of these
are innocent cavernous tumours dating from a congenital angioma. The
majority would appear to be the result of changes in a sarcoma,
endothelioma, or myeloma. The tumour tissue largely disappears, while
the vessels and vascular spaces undergo a remarkable development. The
tumour may come to be represented by one large blood-containing space
communicating with the arteries of the limb; the walls of the space
consist of the remains of the original tumour, plus a shell of bone of
varying thickness. The most common seats of the condition are the lower
end of the femur, the upper end of the tibia, and the bones of the
pelvis.

The _clinical features_ are those of a pulsating tumour of slow
development, and as in true aneurysm, the pulsation and bruit disappear
on compression of the main artery. The origin of the tumour from bone
may be revealed by the presence of egg-shell crackling, and by
examination with the X-rays.

If the condition is believed to be innocent, the treatment is the same
as for aneurysm--preferably by ligation of the main artery; if
malignant, it is the same as for sarcoma.

#Secondary Tumours of Bone.#--These embrace two groups of new growth,
those which give rise to secondary growths in the marrow of bones and
those which spread to bone by direct continuity.

_Metastatic Tumours._--Excepting certain cancers which give rise to
metastases by lymphatic permeation (Handley), the common metastases
arising in the bone-marrow reach their destination through the
blood-stream.

[Illustration: FIG. 153.--Epitheliomatous Ulcer of Leg with direct
extension to Tibia.

(Lord Lister's specimen. Anatomical Museum, University of Edinburgh.)]

Secondary cancer is a comparatively common disease, and, as in
metastases in other tissues, the secondary growths resemble the parent
tumour. The soft forms grow rapidly, and eat away the bone, without
altering its shape or form. In slowly growing forms there may be
considerable formation of imperfectly formed bone, often deficient in
lime salts; this condition may be widely diffused throughout the
skeleton, and, as it is associated with softening and bending of the
bones, it is known as _cancerous osteomalacia_. Secondary cancer of bone
is attended with pain, or it suddenly attracts notice by the occurrence
of pathological fracture--as, for example, in the shaft of the femur or
humerus. In the vertebrae, it is attended with a painful form of
paraplegia, which may involve the lower or all four extremities. On the
other hand, the disease may show itself clinically as a tumour of bone,
which may attain a considerable size, and may be mistaken for a sarcoma,
unless the existence of the primary cancer is discovered.

The cancers most liable to give rise to metastasis in bone are those of
the breast, liver, uterus, prostate, colon, and rectum; hyper-nephroma
of the kidney may also give rise to metastases in bone.

_Secondary tumours derived from the thyreoid gland_ require special
mention, because they are peculiar in that neither the primary growth in
the thyreoid nor the secondary growth in the bones is necessarily
malignant. They are therefore amenable to operative treatment.

_Secondary sarcoma_, whether derived from a primary growth in the bone
or in the soft parts, is much rarer than secondary cancer. Its removal
by operation is usually contra-indicated, but we have known of cases
terminating fatally in which the _section_ revealed only one metastasis,
the removal of which would have benefited the patient.

In all of these conditions, examination of the bones with the X-rays
gives valuable information and often disclose unsuspected metastases.

_Cancer of Bone resulting from Direct Extension from Soft Parts._--In
this group there are also two clinical types. The first is met with in
relation to _epithelioma of a mucous surface_--for example, the palate,
tongue, gums, antrum, frontal sinus, auditory meatus, or middle ear.
They will be described under these special regions.

The second type is met with in relation to _epithelioma occurring in a
sinus_, the sequel of suppurative osteomyelitis, compound fracture, or
tuberculous disease. The patient has usually had a discharging sinus for
a great number of years: we have known it to last as many as fifty. The
epithelioma originates at the skin orifice of the sinus, and spreads to
the bone and into its interior, where the progress of the cancer is
resisted by dense bone, which obliterates the medullary canal. Although
its progress is slow, the infiltration of the bone is usually more
extensive than appears externally. It is recognised clinically by the
characteristic cauliflower growth at the orifice of the sinus, and by
the offensive nature of the discharge. A similar epithelioma may arise
in connection with a _chronic ulcer of the leg_. The cancer may infect
the femoral lymph glands. The operative treatment is influenced by the
extent of the disease in the soft parts overlying the bone, and consists
in wide removal of the diseased tissues and resection of the bone, or in
amputation.

#Cysts of Bone.#--With the exception of hydatid cysts, cysts in the
interior of bone are the result of the liquefaction of solid tissue;
this may be that of chondroma, myeloma, or sarcoma, but more commonly of
the marrow in osteomyelitis fibrosa.




CHAPTER XXI

DISEASES OF JOINTS


Definition of terms--Ankylosis. DISEASES: Errors of
    development--Bacterial diseases: _Pyogenic_; _Gonorrhoeal_;
    _Tuberculous_; _Syphilitic_; _Acute rheumatism_--Diseases
    associated with certain constitutional conditions: _Gout_; _Chronic
    articular rheumatism_; _Arthritis deformans_;
    _Haemophilia_--Diseases associated with affections of the nervous
    system: _Neuro-arthropathies_; _Charcot's disease_--Hysterical or
    mimetic affections of joints--Tumours and cysts--Loose bodies.

#Definition of Terms.#--The term _synovitis_ is applied to any reaction
which affects the synovial membrane of a joint. It is usually associated
with effusion of fluid, and this may be serous, sero-fibrinous, or
purulent. As the term synovitis merely refers to the tissue involved, it
should always be used with an adjective--such as gouty, gonorrhoeal, or
tuberculous--which indicates its pathological nature.

The terms _hydrops_, _hydrarthrosis_, and _chronic serous synovitis_ are
synonymous, and are employed when a serous effusion into the joint is
the prominent clinical feature. Hydrops may occur apart from
disease--for example, in the knee-joint from repeated sprains, or when
there is a loose body in the joint--but is met with chiefly in the
chronic forms of synovitis which result from gonorrhoea, tuberculosis,
syphilis, arthritis deformans, or arthropathies of nerve origin.

_Arthritis_ is the term applied when not only the synovial membrane but
the articular surfaces, and it may be also the ends of the bones, are
involved, and it is necessary to prefix a qualifying adjective which
indicates its nature. When effusion is present, it may be serous, as in
arthritis deformans, or sero-fibrinous or purulent, as in certain forms
of pyogenic and tuberculous arthritis. Wasting of the muscles,
especially the extensors, in the vicinity of the joint is a constant
accompaniment of arthritis. On account of the involvement of the
articular surfaces, arthritis is apt to be followed by ankylosis.

The term _empyema_ is sometimes employed to indicate that the cavity of
the joint contains pus. This is observed chiefly in chronic disease of
pyogenic or tuberculous origin, and is usually attended with the
formation of abscesses outside the joint.

_Ulceration of cartilage_ and _caries of the articular surfaces_ are
common accompaniments of the more serious and progressive forms of joint
disease, especially those of bacterial origin. The destruction of
cartilage may be secondary to disease of the synovial membrane or of the
subjacent bone. When the disease begins as a synovitis, the synovial
membrane spreads over the articular surface, fuses with the cartilage
and eats into it, causing defects or holes which are spoken of as
ulcers. When the disease begins in the bone, the marrow is converted
into granulation tissue, which eats into the cartilage and separates it
from the bone. Following on the destruction of the cartilage, the
articular surface of the bone undergoes disintegration, a condition
spoken of as _caries of the articular surface_. The occurrence of
ulceration of cartilage and of articular caries is attended with the
clinical signs of fixation of the joint from involuntary muscular
contraction, wasting of muscles, and starting pains. These _starting
pains_ are the result of sudden involuntary movements of the joint. They
occur most frequently as the patient is dropping off to sleep; the
muscles becoming relaxed, the sensitive ulcerated surfaces jar on one
another, which causes sudden reflex contraction of the muscles, and the
resulting movement being attended with severe pain, wakens the patient
with a start. Advanced articular caries is usually associated with some
abnormal attitude and with shortening of the limb. It may be possible to
feel the bony surfaces grate upon one another. When all its constituent
elements are damaged or destroyed, a joint is said to be _disorganised_.
Should recovery take place, repair is usually attended with union of the
opposing articular surfaces either by fibrous tissue or by bone.

#Conditions of Impaired Mobility of Joints.#--There are four conditions
of impaired mobility in joints: rigidity, contracture, ankylosis, and
locking. _Rigidity_ is the fixation of a joint by involuntary
contraction of muscles, and is of value as a sign of disease in
deep-seated joints, such as the hip. It disappears under anaesthesia.

_Contracture_ is the term applied when the fixation is due to permanent
shortening of the soft parts around a joint--muscles, tendons,
ligaments, fasciae, or skin. As the structures on the flexor aspect are
more liable to undergo such shortening, contracture is nearly always
associated with flexion. Contracture may result from disease of the
joint, or from conditions outside it--for example, disease in one of
the adjacent bones, or lesions of the nerves.

_Ankylosis_ is the term applied when impaired mobility results from
changes involving the articular surfaces. It is frequently combined with
contracture. Three anatomical varieties of ankylosis are
recognised--(a) The _fibrous_, in which there are adhesions between
the opposing surfaces, which may be in the form of loose isolated bands
of fibrous tissue, or may bind the bones so closely together as to
obliterate the cavity of the joint. The resulting stiffness, therefore,
varies from a mere restriction of the normal range of movement, up to a
close union of the bones which prevents movement. Fibrous ankylosis may
follow upon injury, especially dislocation or fracture implicating a
joint, or it may result from any form of arthritis. (b) _Cartilaginous
ankylosis_ implies the fusion of two apposed cartilaginous surfaces. It
is often found between the patella and the trochlear surface of the
femur in tuberculous disease of the knee. The fusion of the
cartilaginous surfaces is preceded by the spreading of a vascular
connective tissue, derived from the synovial membrane, over the
articular cartilage. Clinically, it is associated with absolute
immobility, (c) _Bony ankylosis_ or _synostosis_ is an osseous union
between articulating surfaces (Figs. 154 and 155). It may follow upon
fibrous or cartilaginous ankylosis, or may result from the fusion of two
articular surfaces which have lost their cartilage and become covered
with granulations. In the majority of cases it is to be regarded as a
reparative process, presenting analogies with the union of fracture.

[Illustration: FIG. 154.--Osseous Ankylosis of Femur and Tibia in
position of flexion.]

The term _arthritis ossificans_ has been applied by Joseph Griffiths to
a condition in which the articular surfaces become fused without evident
cause.

The occurrence of ankylosis in a joint before the skeleton has attained
maturity does not appear to impair the growth in length of the bones
affected; ankylosis of the temporo-maxillary joints, however, greatly
impairs the growth of the mandible. When there is arrest of growth
accompanying ankylosis, it usually depends on changes in the ossifying
junctions caused by the original disease.

To differentiate by manipulation between muscular fixation and
ankylosis, it may be necessary to anaesthetise the patient. The nature
and extent of ankylosis may be learned by skiagraphy; in osseous
ankylosis the shadow of the two bones is a continuous one. In fibrous as
contrasted with osseous ankylosis mobility may be elicited, although
only to a limited extent; while in osseous ankylosis the joint is
rigidly fixed, and attempts to move it are painless.

[Illustration: FIG. 155.--Osseous Ankylosis of Knee in the flexed
position following upon Tuberculous Arthritis.

(Anatomical Museum, University of Edinburgh.)]

The _treatment_ is influenced by the nature of the original lesion, the
variety of the ankylosis, and the attitude of the joint. When there is
restriction of movement due to fibrous adhesions, these may be elongated
or ruptured. Elongation of the adhesions may be effected by
manipulations, exercises, and the use of special forms of
apparatus--such as the application of weights to the limb. It may be
necessary to administer an anaesthetic before rupturing strong fibrous
adhesions, and this procedure must be carried out with caution, in view
of such risks as fracture of the bone--which is often rarefied--or
separation of an epiphysis. There is also the risk of fat embolism, and
of re-starting the original disease. The giving way of adhesions may be
attended with an audible crack; and the procedure is often followed by
considerable pain and effusion into the joint, which necessitate rest
for some days before exercises and manipulations can be resumed.

_Operative treatment_ may be called for in cases in which the bones are
closely bound to one another by fibrous or by osseous tissue.

_Arthrolysis_, which consists in opening the joint and dividing the
fibrous adhesions, is almost inevitably followed by their reunion.

_Arthroplasty._--Murphy of Chicago devised this operation for restoring
movement to an ankylosed joint. It consists in transplanting between the
bones a flap of fat-bearing tissue, from which a bursal cavity lined
with endothelium and containing a fluid rich in mucin is ultimately
formed.

Arthroplasty is most successful in ankylosis following upon injury; when
the ankylosis results from some infective condition such as tuberculosis
or gonorrhoea, it is liable to result in failure either because of a
fresh outbreak of the infection or because the ankylosis recurs.

When arthroplasty is impracticable, and a movable joint is desired--for
example at the elbow--a considerable amount of bone, and it may be also
of periosteum and capsular ligament, is resected to allow of the
formation of a false joint.

When bony ankylosis has occurred with the joint in an undesirable
attitude--for example flexion at the hip or knee--it can sometimes be
remedied by osteotomy or by a wedge-shaped resection of the bone, with
or without such additional division of the contracted soft parts as will
permit of the limb being placed in the attitude desired.

Bony ankylosis of the joints of a finger, whether the result of injury
or disease, is difficult to remedy by any operative procedure, for while
it is possible to restore mobility, the new joint is apt to be
flail-like.

_Locking._--A joint is said to lock when its movements are abruptly
arrested by the coming together of bony outgrowths around the joint. It
is best illustrated in arthritis deformans of the hip in which new bone
formed round the rim of the acetabulum mechanically arrests the
excursions of the head of the femur. The new bone, which limits the
movements, is readily demonstrated in skiagrams; it may be removed by
operative means. Locking of joints is more often met with as a result of
injuries, especially in fractures occurring in the region of the elbow.
In certain injuries of the semilunar menisci of the knee, also, the
joint is liable to a variety of locking, which differs, however, in many
respects from that described above.

#Errors of Development.#--These include congenital dislocations and
other deformities of intra-uterine origin, such as abnormal laxity of
joints, absence, displacement, or defective growth of one or other of
the essential constituents of a joint. The more important of these are
described along with the surgery of the Extremities.


DISEASES OF JOINTS

#Bacterial Diseases.#--In most bacterial diseases the organisms are
carried to the joint in the blood-stream, and they lodge either in the
synovial membrane or in one of the bones, whence the disease
subsequently spreads to the other structures of the joint. Organisms may
also be introduced through accidental wounds. It has been shown
experimentally that joints are among the most susceptible parts of the
body to infection, and this would appear to be due to the viscid
character of the synovial fluid, which protects organisms from
bactericidal agents in the tissues and fluids.


PYOGENIC DISEASES

The commoner pyogenic diseases are the result of infection of one or
other of the joint structures with _staphylococci_ or _streptococci_,
which may be demonstrated in the exudate in the joint and in the
substance of the synovial membrane. The mode of infection is the same as
in the pyogenic diseases of bone, the metastasis occurring most
frequently from the mucous membrane of the pharynx (J. B. Murphy). The
localisation of the infection in a particular joint is determined by
injury, exposure to cold, antecedent disease of the joint, or other
factors, the nature of which is not always apparent.

The effects on the joint vary in severity. In the milder forms, there is
engorgement and infiltration of the synovial membrane, and an effusion
into the cavity of the joint of serous fluid mixed with flakes of
fibrin--_serous synovitis_. In more severe infections the exudate
consists of pus mixed with fibrin, and, it may be, red blood
corpuscles--_purulent_ or _suppurative synovitis_; the synovial membrane
and the ligaments are softened, and the surface of the membrane presents
granulations resembling those on an ulcer; foci of suppuration may
develop in the peri-articular cellular tissue and result in abscesses.
In _acute arthritis_, all the structures of the joint are involved; the
articular cartilage is invaded by granulation tissue derived from the
synovial membrane, and from the marrow of the subjacent bone; it
presents a worm-eaten or ulcerated appearance, or it may undergo
necrosis and separate, exposing the subjacent bone and leading to
disintegration of the osseous trabeculae--_caries_. With the destruction
of the ligaments, the stability of the joint is lost, and it becomes
disorganised.

The _clinical features_ vary with the extent of the infection. When
this is confined to the synovial and peri-synovial tissues--_acute
serous_ and _purulent synovitis_--there is the usual general reaction,
associated with pyrexia and great pain in the joint. The part is hot and
swollen, the swelling assuming the shape of the distended synovial sac,
fluctuation can usually be elicited, and the joint is held in the flexed
position.

When the joint is infected by extension from the surrounding cellular
tissue, the joint lesion may not be recognised at an early stage because
of the swollen condition of the limb, and because there are already
symptoms of toxaemia. We have observed a case in which both the hip and
knee joints were infected from the cellular tissue.

If the infection involves all the joint structures--_acute
arthritis_--the general and local phenomena are intensified, the
temperature rises quickly, often with a rigor, and remains high; the
patient looks ill, and is either unable to sleep or the sleep is
disturbed by starting pains. The joint is held rigid in the flexed
position, and the least attempt at movement causes severe pain; the
slightest jar--even the shaking of the bed--may cause agony. The joint
is hot, tensely distended, and there may be oedema of the peri-articular
tissues or of the limb as a whole. If the pus perforates the joint
capsule, there are signs of abscess or of diffuse suppuration in the
cellular tissue. The final disorganisation of the joint is indicated by
abnormal mobility and grating of the articular surfaces, or by
spontaneous displacement of the bones, and this may amount to
dislocation. In the acute arthritis of infants, the epiphysis concerned
may be separated and displaced.

When the _joint is infected through an external wound_, the anatomical
features are similar to those observed when the infection has reached
the joint by the blood-stream, but the destructive changes tend to be
more severe and are more likely to result in disorganisation.

The _terminations_ vary with the gravity of the infection and with the
stage at which treatment is instituted. In the milder forms recovery is
the rule, with more or less complete restoration of function. In more
severe forms the joint may be permanently damaged as a result of fibrous
or bony ankylosis, or from displacement or dislocation. From changes in
the peri-articular structures there may be contracture in an undesirable
position, and in young subjects the growth of the limb may be interfered
with. The persistence of sinuses is usually due to disease in one or
other of the adjacent bones. In the most severe forms, and especially
when several joints are involved, death may result from toxaemia.

The _treatment_ is carried out on the same principles as in other
pyogenic infections. The limb is immobilised in such an attitude that
should stiffness occur there will be the least interference with
function. Extension by weight and pulley is the most valuable means of
allaying muscular spasm and relieving intra-articular tension and of
counteracting the tendency to flexion; as much as 15 or 20 pounds may be
required to relieve the pain.

The induction of hyperaemia is sometimes remarkably efficacious in
relieving pain and in arresting the progress of the infection. If the
fluid in the joint is in sufficient quantity to cause tension, if it
persists, or if there is reason to suspect that it is purulent, it
should be withdrawn without delay; an exploring syringe usually
suffices, the skin being punctured with a tenotomy knife, and, as
practised by Murphy, 5 to 15 c.c. of a 2 per cent. solution of formalin
in glycerin are injected and the wound is closed. In virulent infections
the injection may be repeated in twenty-four hours. Drainage by tube or
otherwise is to be condemned (Murphy). A vaccine may be prepared from
the fluid in the joint and injected into the subcutaneous cellular
tissue.

Suppuration in the peri-articular soft parts or in one of the adjacent
bones must be looked for and dealt with.

When convalescence is established, attention is directed to the
restoration of the functions of the limb, and to the prevention of
stiffness and deformity by movements and massage, and the use of hot-air
and other baths.

At a later stage, and especially in neglected cases, operative and other
measures may be required for deformity or ankylosis.


#Metastatic Forms of Pyogenic Infection#

In #pyaemia#, one or more joints may fill with pus without marked
symptoms or signs, and if the pus is aspirated without delay the joint
often recovers without impairment of function.

In #typhoid fever#, joint lesions result from infection with the typhoid
bacillus alone or along with pyogenic organisms, and run their course
with or without suppuration; there is again a remarkable absence of
symptoms, and attention may only be called to the condition by the
occurrence of dislocation.

Joint lesions are comparatively common in #scarlet fever#, and were
formerly described as scarlatinal rheumatism. The most frequent clinical
type is that of a serous synovitis, occurring within a week or ten days
from the onset of the fever. Its favourite seat is in the hand and
wrist, the sheaths of the extensor tendons as well as the synovial
membrane of the joints being involved. It does not tend to migrate to
other joints, and rarely lasts longer than a few days. It is probably
due to the specific virus of scarlet fever.

At a later stage, especially in children and in cases in which the
throat lesion is severe, an arthritis is sometimes observed that is
believed to be a metastasis from the throat; it may be acute and
suppurative, affect several joints, and exhibit a septicaemic or pyaemic
character.

The joints of the lower extremity are especially apt to suffer; the
child is seriously ill, is delirious at night, develops bed-sores over
the sacrum and, it may happen that, not being expected to recover, the
legs are allowed to assume contracture deformities with ankylosis or
dislocation at the hip and flexion ankylosis at the knees; should the
child survive, the degree of crippling may be pitiable in the extreme;
prolonged orthopaedic treatment and a series of operations--arthroplasty,
osteotomies, and resections--may be required to restore even a limited
capacity of locomotion.

#Pneumococcal affections of joints#, the result of infection with the
pneumococcus of Fraenkel, are being met with in increasing numbers. The
local lesion varies from a _synovitis_ with infiltration of the synovial
membrane and effusion of serum or pus, to an _acute arthritis_ with
erosion of cartilage, caries of the articular surfaces, and
disorganisation of the joint. The knee is most frequently affected, but
several joints may suffer at the same time. In most cases the joint
affection makes its appearance a few days after the commencement of a
pneumonia, but in a number of instances, especially among children, the
lung is not specially involved, and the condition is an indication of a
generalised pneumococcal infection, which may manifest itself by
endocarditis, empyema, meningitis, or peritonitis, and frequently has a
fatal termination. The differential diagnosis from other forms of
pyogenic infection is established by bacteriological examination of the
fluid withdrawn from the joint. The treatment is carried out on the same
lines as in other pyogenic infections, considerable reliance being
placed on the use of autogenous vaccines.

In #measles#, #diphtheria#, #smallpox#, #influenza#, and #dysentery#,
similar joint lesions may occur.

The joint lesions which accompany #acute rheumatism# or "rheumatic
fever" are believed to be due to a diplococcus. In the course of a
general illness in which there is moderate pyrexia and profuse sweating,
some of the larger joints, and not infrequently the smaller ones also,
become swollen and extremely sensitive, so that the sufferer lies in bed
helpless, dreading the slightest movement. From day to day fresh joints
are attacked, while those first affected subside, often with great
rapidity. Affections of the heart-valves and of the pericardium are
commonly present. On recovery from the acute illness, it may be found
that the joints have entirely recovered, but in a small proportion of
cases certain of them remain stiff and pass into the crippled condition
described under chronic rheumatism. There is no call for operative
interference.

#Gonococcal Affections of Joints.#--These include all forms of joint
lesion occurring in association with gonorrhoeal urethritis,
vulvo-vaginitis, or gonorrhoeal ophthalmia. They may develop at any stage
of the urethritis, but are most frequently met with from the eighteenth
to the twenty-second day after the primary infection, when the organisms
have reached the posterior urethra; they have been observed, however,
after the discharge has ceased. There is no connection between the
severity of the gonorrhoea and the incidence of joint disease. In women,
the gonorrhoeal nature of the discharge must be established by
bacteriological examination.

As a complication of ophthalmia, the joint lesions are met with in
infants, and occur more commonly towards the end of the second or during
the third week.

The gonococcus is carried to the joint in the blood-stream and is first
deposited in the synovial membrane, in the tissues of which it can
usually be found; it may be impossible to find it in the exudate within
the joint. The joint lesions may be the only evidence of metastasis, or
they may be part of a general infection involving the endocardium,
pleura, and tendon sheaths.

The joints most frequently affected are the knee, elbow, ankle, wrist,
and fingers. Usually two or more joints are affected.

Several clinical types are differentiated. (1) A _dry poly-arthritis_
met with in the joints and tendon sheaths of the wrist and hand,
formerly described as gonorrhoeal rheumatism, which in some cases is
trifling and evanescent, and in others is persistent and progressive,
and results in stiffness of the affected joints and permanent crippling
of the hand and fingers.

(2) The commonest type is a _chronic synovitis_ or _hydrops_, in which
the joint--very often the knee--becomes filled with a serous or
sero-fibrinous exudate. There are no reactive changes in the synovial
membrane, cellular tissue, or skin, nor is there any fever or
disturbance of health. The movements are free except in so far as they
are restricted by the amount of fluid in the joint. It usually subsides
in two or three weeks under rest, but tends to relapse.

(3) An _acute synovitis_ with peri-articular phlegmon is most often met
with in the elbow, but it occurs also in the knee and ankle. There is a
sudden onset of severe pain and swelling in and around the joint, with
considerable fever and disturbance of health. The slightest movement
causes pain, and the part is sensitive to touch. The skin is hot and
tense, and in the case of the elbow may be red and fiery as in
erysipelas.

The deposit of fibrin on the synovial membrane and on the articular
surfaces may lead to the formation of adhesions, sometimes in the form
of isolated bands, sometimes in the form of a close fibrous union
between the bones.

(4) A _suppurative arthritis_, like that caused by ordinary pus
microbes, may be the result of gonococcal infection alone or of a mixed
infection. Usually only one joint is affected, but the condition may be
multiple. The articular cartilages are destroyed, the ends of the bones
are covered with granulations, extra-articular abscesses form, and
complete osseous ankylosis results.

The _diagnosis_ is often missed because the possibility of gonorrhoea is
not suspected.

The denial of the disease by the patient is not always to be relied
upon, especially in the case of women, as they may be ignorant of its
presence. The chief points in the differential diagnosis from acute
articular rheumatism are, that the gonorrhoeal affection is more often
confined to one or two joints, has little tendency to wander from joint
to joint, and its progress is not appreciably influenced by salicylates,
although these drugs may relieve pain. The conclusive point is the
recognition of a gonorrhoeal discharge or of threads in the urine.

The disease may persist or may relapse, and the patient may be laid up
for weeks or months, and may finally be crippled in one or in several
joints.

The _treatment_--besides that of the urethral disease or of the
ophthalmia--consists in rest until all pain and sensitiveness have
disappeared. The pain is relieved by salicylates, but most benefit
follows weight extension, the induction of hyperaemia by the rubber
bandage and hot-air baths; if the joint is greatly distended, the fluid
may be withdrawn by a needle and syringe. Detoxicated vaccines should be
given from the first, and in afebrile cases the injection of a foreign
protein, such as anti-typhoid vaccine, is beneficial (Harrison).

Murphy has found benefit from the introduction into the joint, in the
early stages, of from 5 to 15 c.c. of a 2 per cent. solution of formalin
in glycerin. This may be repeated within a week, the patient being kept
in bed with light weight extension. In the chronic hydrops the fluid is
withdrawn, and about an ounce of a 1 per cent. solution of protargol
injected; the patient should be warned of the marked reaction which
follows.

After all symptoms have settled down, but not till then, for fear of
exciting relapse or metastasis, the joint is massaged and exercised.
Stiffness from adhesions is most intractable, and may, in spite of every
attention, terminate in ankylosis even in cases where there has been no
suppuration. Forcible breaking down of adhesions under anaesthesia is
not recommended, as it is followed by great suffering and the adhesions
re-form. Operation for ankylosis--arthroplasty--should not be
undertaken, as the ankylosis recurs.


TUBERCULOUS DISEASE

Tuberculous disease of joints results from bacillary infection through
the arteries. The disease may commence in the synovial membrane or in
the marrow of one of the adjacent bones, and the relative frequency of
these two seats of infection has been the subject of considerable
difference of opinion. The traditional view of Konig is that in the knee
and most of the larger joints the disease arises in the bone and in the
synovial membrane in about equal proportion, and that in the hip the
number of cases beginning in the bones is about five times greater than
that originating in the membrane. This estimate, so far as the actual
frequency of bone lesions is concerned, has been generally accepted, but
recent observers, notably John Fraser, do not accept the presence of
bone lesions as necessarily proving that the disease commenced in the
bones; he maintains, and we think with good grounds, that in many cases
the disease having commenced in the synovial membrane, slowly spreads to
the bone by way of the blood vessels and lymphatics, and gives rise to
lesions in the marrow.

#Morbid Anatomy.#--Tuberculous disease in the articular end of a long
bone may give rise to _reactive changes_ in the adjacent joint,
characterised by effusion and by the extension of the synovial membrane
over the articular surfaces. This may result in the formation of
adhesions which obliterate the cavity of the joint or divide it into
compartments. These lesions are comparatively common, and are not
necessarily due to actual tuberculous infection of the joint.

The _infection of the joint_ by tubercle originating in the adjacent
bone may take place at the periphery, the osseous focus reaching the
surface of the bone at the site of reflection of the synovial membrane,
and the infection which begins at this point then spreads to the rest of
the membrane. Or it may take place in the central area, by the
projection of tuberculous granulation tissue into the joint following
upon erosion of the cartilage (Fig. 156).

[Illustration: FIG. 156.--Section of Upper End of Fibula, showing
caseating focus in marrow, erupting on articular surface and infecting
joint.]

_Changes in the Synovial Membrane._--In the majority of cases there is a
_diffuse thickening of the synovial membrane_, due to the formation of
granulation tissue, or of young connective tissue, in its substance.
This new tissue is arranged in two layers--the outer composed of fully
formed connective or fibrous tissue, the inner of embryonic tissue,
usually permeated with miliary tubercles. On opening the joint, these
tubercles may be seen on the surface of the membrane, or the surface may
be covered with a layer of fibrinous or caseating tissue. Where there is
greater resistance on the part of the tissues, there is active formation
of young connective tissue which circumscribes or encapsulates the
tubercles, so that they remain embedded in the substance of the
membrane, and are only seen on cutting into it.

The thickened synovial membrane is projected into the cavity of the
joint, filling up its pouches and recesses, and spreading over the
surface of the articular cartilage "like ivy growing on a wall."
Wherever the synovial tissue covers the cartilage it becomes adherent to
and fused with it. The morbid process may be arrested at this stage, and
fibrous adhesions form between the opposing articular surfaces, or it
may progress, in which case further changes occur, resulting in
destruction of the articular cartilage and exposure of the subjacent
bone.

In rare instances the synovial membrane presents nodular masses or
lumps, resembling the tuberculous tumours met with in the brain; they
project into the cavity of the joint, are often pedunculated, and may
give rise to the symptoms of loose body. The fringes of synovial
membrane may also undergo a remarkable development, like that observed
in arthritis deformans, and described as arborescent lipoma. Both these
types are almost exclusively met with in the knee.

_The Contents of Tuberculous Joints._--In a large proportion of cases of
synovial tuberculosis the joint is entirely filled up by the diffuse
thickening of the synovial membrane. In a small number there is an
abundant serous exudate, and with this there may be a considerable
formation of fibrin, covering the surface of the membrane and floating
in the fluid as flakes or masses; under the influence of movement it may
assume the shape of melon-seed bodies. More rarely the joint contains
pus, and the surface of the synovial membrane resembles the wall of a
cold abscess.

_Ulceration and Necrosis of Cartilage._--The synovial tissue covering
the cartilage causes pitting and perforation of the cartilage and makes
its way through it, and often spreads widely between it and the
subjacent bone; the cartilage may be detached in portions of
considerable size. It may be similarly ulcerated or detached as a result
of disease in the bone.

_Caries of Articular Surfaces._--Tuberculous infiltration of the marrow
in the surface cancelli breaks up the spongy framework of the bone into
minute irregular fragments, so that it disintegrates or crumbles
away--caries. When there is an absence of caseation and suppuration, the
condition is called _caries sicca_.

The pressure of the articular surfaces against one another favours the
progress of ulceration of cartilage and of articular caries. These
processes are usually more advanced in the areas most exposed to
pressure--for example, in the hip-joint, on the superior aspect of the
head of the femur, and on the posterior and upper segment of the
acetabulum.

The occurrence of _pathological dislocation_ is due to softening and
stretching of the ligaments which normally retain the bones in position,
and to some factor causing displacement, which may be the accumulation
of fluid or of granulations in the joint, the involuntary contraction of
muscles, or some movement or twist of the limb. The occurrence of
dislocation is also favoured by destructive changes in the bones.

_Peri-articular tubercle and abscess_ may result from the spread of
disease from the bone or joint into the surrounding tissues, either
directly or by way of the lymphatics. A peri-articular abscess may
spread in several directions, sometimes invading tendon sheaths or
bursae, and finally reaching the skin surface by tortuous sinuses.

Reactive changes in the vicinity of tuberculous joints are of common
occurrence, and play a considerable part in the production of what is
clinically known as _white swelling_. New connective tissue forms in the
peri-articular fat and between muscles and tendons. It may be tough and
fibrous, or soft, vascular, and oedematous, and the peri-articular fat
becomes swollen and gelatinous, constituting a layer of considerable
thickness. The fat disappears and is replaced by a mucoid effusion
between the fibrous bundles of connective tissue. This is what was
formerly known as _gelatinous degeneration_ of the synovial membrane. In
the case of the wrist the newly formed connective tissue may fix the
tendons in their sheaths, interfering with the movements of the fingers.
In relation to the bones also there may be reactive changes, resulting
in the formation of spicules of new bone on the periosteal surfaces and
at the attachment of the capsular and other ligaments; these are only
met with where pyogenic infection has been superadded.

_Terminations and Sequelae._--A natural process of cure may occur at any
stage, the tuberculous tissue being replaced by scar tissue. Recovery is
apt to be attended with impairment of movement due to adhesions,
ankylosis, or contracture of the peri-articular structures. Caseous foci
in the interior of the bones may become encapsulated, and a cure be thus
effected, or they may be the cause of a relapse of the disease at a
later date. Interference with growth is comparatively common, and may
involve only the epiphysial junctions in the immediate vicinity of the
joint affected, or those of all the bones of the limb. This is well seen
in adults who have suffered from severe disease of the hip in
childhood--the entire limb, including the foot, being shorter and
smaller than the corresponding parts of the opposite side.

Atrophic conditions are also met with, the bones undergoing fatty
atrophy, so that in extreme cases they may be cut with a knife or be
easily fractured. These atrophic conditions are most marked in bedridden
patients, and are largely due to disuse of the limb; they are recovered
from if it is able to resume its functions.

#Clinical Features.#--These vary with the different anatomical forms of
the disease, and with the joint affected.

Sometimes the disease is ushered in by a febrile attack attended with
pains in several joints--described by John Duncan as _tuberculous
arthritic fever_. This is liable to be mistaken for rheumatic fever,
from which, however, it differs in that there is no real migration from
joint to joint; there is an absence of sweating and of cardiac
complications; and no benefit follows the administration of salicylates.

In exceptional cases, tuberculous joint disease follows an acute course
resembling that of the pyogenic arthritis of infants. This has been
observed in children, especially in the knee, the lesion being in the
synovial membrane, and attended with an accumulation of pus in the
joint. If promptly treated by incision and drainage, recovery is rapid,
and free movement of the joint, may be preserved.

The onset and early stages of tuberculous disease, however, are more
often insidious, and are attended with so few symptoms that the disease
may have obtained a considerable hold before it attracts notice. It is
not uncommon for patients or their friends to attribute the condition to
injury, as it often first attracts attention after some slight trauma or
excessive use of the limb. The symptoms usually subside under rest, only
to relapse again with use of the limb.

The initial local symptoms may be due to the presence of a focus in the
neighbouring bone, perhaps causing neuralgic pains in the joint, or
weakness, tiredness, stiffness, and inability to use the limb, these
symptoms improving with rest and being aggravated by exertion.

It is rarely possible by external examination to recognise deep-seated
osseous foci in the vicinity of joints; but if they are near the surface
in a superficial bone--such as the head of the tibia--there may be local
thickening of the periosteum, oedema, pain, and tenderness on pressure
and on percussion.

_X-ray Appearances of Tuberculous Joints._--Gross lesions such as
caseous foci in the marrow of the adjacent bone show as clear areas with
an ill-defined margin; a sclerosed focus gives a denser shadow than the
surrounding bone, and a sequestrum presents a dark shadow of irregular
contour, and a clear interval between it and the surrounding bone.

Caries of the articular surface imparts a woolly appearance or irregular
contour in place of the well-defined outline of the articular end of the
bone. In bony ankylosis the shadow of the two bones is a continuous one,
the joint interval having been filled up. The minor changes are best
appreciated on comparison with the normal joint of the other limb.

_Wasting of muscles_ is a constant accompaniment of tuberculous joint
disease. It is to be attributed partly to want of use, but chiefly to
reflex interference with the trophic innervation of the muscles. It is
specially well seen in the extensor and adductor muscles of the thigh in
disease of the knee, and in the deltoid in disease of the shoulder. The
muscles become soft and flaccid, they exhibit tremors on attempted
movement, and their excitability to the faradic current is diminished.
The muscular tissue may be largely replaced by fat.

_Impairment of the normal movements_ is one of the most valuable
diagnostic signs, particularly in deeply seated joints such as the
shoulder, hip, and spine. It is due to a protective contraction of the
muscles around the joint, designed to prevent movement. This muscular
fixation disappears under anaesthesia.

_Abnormal attitudes of the limb_ occur earlier, and are more pronounced
in cases in which pain and other irritative symptoms of articular
disease are well marked, and are best illustrated by the attitudes
assumed in disease of the hip. They are due to reflex or involuntary
contraction of the muscles acting on the joint, with the object of
placing it in the attitude of greatest ease; they also disappear under
anaesthesia. With the lapse of time they not only become exaggerated, but
may become permanent from ankylosis or from contracture of the soft
parts round the joint.

_Startings at night_ are to be regarded as an indication that there is
progressive disease involving the articular surfaces.

_The formation of extra-articular abscess_ may take place early, or it
may not occur till long after the disease has subsided. The abscess may
develop so insidiously that it does not attract attention until it has
attained considerable size, especially when associated with disease of
the spine, pelvis, or hip. The position of the abscess in relation to
different joints is fairly constant and is determined by the anatomical
relationships of the capsule and synovial membrane to the surrounding
tissues. The bursae and tendon sheaths in the vicinity may influence the
direction of spread of the abscess and the situation of resulting
sinuses. When the abscess is allowed to burst, or is opened and becomes
infected with pyogenic bacteria, there is not only the risk of
aggravation of the disease and persistent suppuration, but there is a
greater liability to general tuberculosis.

The sinuses may be so tortuous that a probe cannot be passed to the
primary focus of disease, and their course and disposition can only be
demonstrated by injecting the sinuses with an emulsion of bismuth and
taking X-ray photographs.

Tuberculous infection of the lymph glands of the limb is exceptional,
but may follow upon infection of the skin around the orifice of a sinus.

A slight rise of temperature in the evening may be induced in quiescent
joint lesions by injury or by movement of the joint under anaesthesia, or
by the fatigue of a railway journey. When sinuses have formed and become
infected with pyogenic bacteria, there may be a diurnal variation in the
temperature of the type known as hectic fever (Fig. 11).

_Relative Frequency of Tuberculous Disease in Different
Joints._--Hospital statistics show that joints are affected in the
following order of frequency: Spine, knee, hip, ankle and tarsus, elbow,
wrist, shoulder. The hip and spine are most often affected in childhood
and youth, the shoulder and wrist in adults; the knee, ankle, and elbow
show little age preference.

_Clinical Variations of Tuberculous Joint Disease._--The above
description applies to tuberculous joint disease in general; it must be
modified to include special manifestations or varieties.

When the main incidence of the infection affects the synovial membrane,
the clinical picture may assume the form of a _hydrops_, or of an
_empyema_ in which the joint is filled with pus. More common than either
of these is the well-known _white swelling_ or _tumor albus_ (Wiseman,
1676) which is the clinical manifestation of diffuse thickening of the
synovial membrane along with mucoid degeneration of the peri-synovial
cellular tissue. It is well seen in joints which are superficial--such
as the knee, ankle, elbow, and wrist. The swelling, which is the first
and most prominent clinical feature, develops gradually and painlessly,
obliterating the bony prominences by filling up the natural hollows. It
appears greater to the eye than is borne out by measurement, being
thrown into relief by the wasting of the muscles above and below the
joint. In the early stage the swelling is elastic, doughy, and
non-sensitive, and corresponds to the superficial area of the synovial
membrane involved, and there is comparatively little complaint on the
part of the patient, because the articular surfaces and ligaments are
still intact. There may be a feeling of weight in the limb, and in the
case of the knee and ankle the patient tires on walking and drags the
leg with more or less of a limp. Movements of the joint are permitted,
but are limited in range. The disability is increased by use and
exertion, but, for a time at least, it improves under rest.

If the disease is not arrested, there follow the symptoms and signs of
involvement of the articular surfaces.

_Influence of Tuberculous Joint Disease on the General
Health._--Experience shows that the early stages of tuberculous joint
disease are compatible with the appearance of good health. As a rule,
however, and especially if there is mixed infection, the health suffers,
the appetite is impaired, the patient is easily tired, and there may be
some loss of weight.

#Treatment.#--In addition to the general treatment of tuberculosis,
local measures are employed. These may be described under two heads--the
conservative and the operative.

_Conservative treatment_ is almost always to be employed in the first
instance, as by it a larger proportion of cures is obtained with a
smaller mortality and with better functional results than by operation.

_Treatment by rest_ implies the immobilisation of the diseased limb
until pain and tenderness have disappeared. The attitude in which the
limb is immobilised should be that in which, in the event of subsequent
stiffness, it will be most serviceable to the patient. Immobilisation
may be secured by bandages, splints, extension, or other apparatus.
_Extension_ with weight and pulley is of value in securing rest,
especially in disease of the hip or knee; it eliminates muscular spasm,
relieves pain and startings at night, and prevents abnormal attitudes of
the limb. If, when the patient first comes under observation, the limb
is in a deformed attitude which does not readily yield to extension, the
deformity should be corrected under an anaesthetic.

_The induction of hyperaemia_ is often helpful, the rubber bandage or the
hot-air chamber being employed for an hour or so morning and evening.

_Injection of Iodoform._--This is carried out on the same lines as have
been described for tuberculous abscess. After the fluid contents of the
joint are withdrawn, the iodoform is injected; and this may require to
be repeated in a month or six weeks.

After the injection of iodoform there is usually considerable reaction,
attended with fever (101 o F.), headache, and malaise, and considerable
pain and swelling of the joint. In some cases there is sickness, and
there may be blood pigment in the urine. The severity of these phenomena
diminishes with each subsequent injection.

The use of Scott's dressing and of blisters and of the actual cautery
has largely gone out of fashion, but the cautery may still be employed
with benefit for the relief of pain in cases in which ulceration of
cartilage is a prominent feature.

The application of the X-rays has proved beneficial in synovial lesions
in superficial joints such as the wrist or elbow; prolonged exposures
are made at fortnightly intervals, and on account of the cicatricial
contraction which attends upon recovery, the joint must be kept in good
position.

Conservative treatment is only abandoned if improvement does not show
itself after a thorough trial, or if the disease relapses after apparent
cure.

_Operative Treatment._--Other things being equal, operation is more
often indicated in adults than in children, because after the age of
twenty there is less prospect of recovery under conservative treatment,
there is more tendency for the disease to relapse and to invade the
internal organs, and there is no fear of interfering with the growth of
the bones. The state of the general health may necessitate operation as
the most rapid method of removing the disease. The social status of the
patient must also be taken into account; the bread-winner, under
existing social conditions, may be unable to give up his work for a
sufficient time to give conservative measures a fair trial.

The _local conditions_ which decide for or against operation are
differently regarded by different surgeons, but it may be said in
general terms that operative interference is indicated in cases in which
the disease continues to progress in spite of a fair trial of
conservative measures; in cases unsuited for conservative
treatment--that is to say, where there are severe bone lesions.
Operative interference is indicated also when the functional result will
be better than that likely to be obtained by conservative measures, as
is often the case in the knee and elbow. Cold abscesses should, if
possible, be dealt with before operating on the joint.

In many cases the extent of the operation can only be decided after
exploration. The aim is to remove all the disease with the least
impairment of function and the minimum sacrifice of healthy tissue. The
more open the method of operating the better, so that all parts of the
joint may be available for inspection. The methods of Kocher, which
permit of dislocating the joint, are specially to be recommended, as
this procedure affords the freest possible access. Diseased synovial
membrane is removed with the scissors or knife. If the cartilages are
sound, and if a movable joint is aimed at, they may be left; but if
ankylosis is desired, they must be removed. Localised disease of the
cartilage should be removed with the spoon or gouge, and the bone
beneath investigated. If the articular surface is extensively diseased,
a thin slice of bone should be removed, and if foci in the marrow are
then revealed, it is better to gouge them out than to remove further
slices of bone, as this involves sacrifice of the cortex and periosteum.

Operative treatment of deformities resulting from tuberculous joint
disease has almost entirely replaced reduction by force; the contracted
soft parts are divided, and the bone is resected.

_Amputation_ for tuberculous joint disease has become one of the rare
operations of surgery, and is only justified when less radical measures
have failed and the condition of the limb is affecting the general
health. Amputation is more frequently called for in persons past middle
life who are the subjects of pulmonary tuberculosis.


SYPHILITIC DISEASE

Syphilitic affections of joints are comparatively rare. As in
tuberculosis, the disease may be first located in the synovial membrane,
or it may spread to the joint from one of the bones.

In #acquired syphilis#, at an early stage and before the skin eruptions
appear, one of the large joints, such as the shoulder or knee, may be
the seat of pain--_arthralgia_--which is worse at night. In the
secondary stage, a _synovitis_ with serous effusion is not uncommon, and
may affect several joints. Syphilitic _hydrops_ is met with almost
exclusively in the knee; it is frequently bilateral, and is insidious in
its onset and progress, the patient usually being able to go about.

In the _tertiary stage_ the joint lesions are persistent and
destructive, and result from the formation of gummata, either in the
deeper layers of the synovial membrane or in the adjacent bone or
periosteum.

_Peri-synovial_ and _peri-bursal gummata_ are met with in relation to
the knee-joint of middle-aged adults, especially women. They are usually
multiple, develop slowly, and are rarely sensitive or painful. One or
more of the gummata may break down and give rise to tertiary ulcers. The
co-existence of indolent swellings, ulcers, and depressed scars in the
vicinity of the knee is characteristic of tertiary syphilis.

The disease spreads throughout the capsule and synovial membrane, which
becomes diffusely thickened and infiltrated with granulation tissue
which eats into and replaces the articular cartilage. Clinically, the
condition resembles tuberculous disease of the synovial membrane, for
which it is probably frequently mistaken, but in the syphilitic
affection the swelling is nodular and uneven, and the subjective
symptoms are slight, mobility is little impaired, and yet the deformity
is considerable.

_Syphilitic osteo-arthritis_ results from a gumma in the periosteum or
marrow of one of the adjacent bones. There is gradual enlargement of one
of the bones, the patient complains of pains, which are worst at night.
The disease may extend to the synovial membrane and be attended with
effusion into the joint, or it may erupt on the periosteal surface and
invade the skin, forming one or more sinuses. The further progress is
complicated by the occurrence of pyogenic infection leading to necrosis
of bone, in the knee-joint, for example, the patella or one of the
condyles of the femur or tibia, may furnish a sequestrum. In such cases,
anti-syphilitic treatment must be supplemented by operation for the
removal of the diseased tissues. In the knee, excision is rarely
necessary; but in the elbow it may be called for to obtain a movable
joint.

In #inherited syphilis# the earliest joint affections are those in which
there is an effusion into the joint, especially the knee or elbow; and
in exceptional cases pyogenic infection may be superadded, and pus form
in the joint.

In older children, a gummatous synovitis is met with of which the most
striking features are: its insidious development, its chronic course,
symmetrical distribution, freedom from pain, the free mobility of the
joint, its tendency to relapse, and its association with other
syphilitic stigmata, especially in the eyes. The knees are the joints
most frequently affected, and the condition usually yields readily to
anti-syphilitic treatment without impairment of function.


JOINT DISEASES ACCOMPANYING CERTAIN CONSTITUTIONAL CONDITIONS

#Gout.#--_Arthritis Urica._--One of the manifestations of gout is that
certain joints are liable to attacks of inflammation associated with the
deposit of a chalk-like material composed of sodium biurate, chiefly in
the matrix of the articular cartilage, it may be in streaks or patches
towards the central area of the joint, or throughout the entire extent
of the cartilage, which appears as if it had been painted over with
plaster of Paris. As a result of this uratic infiltration, the cartilage
loses its vitality and crumbles away, leading to the formation of what
are known as gouty ulcers, and these may extend through the cartilage
and invade the bone. The deposit of urates in the synovial membrane is
attended with effusion into the joint and the formation of adhesions,
while in the ligaments and peri-articular structures it leads to the
formation of scar tissue. The metatarso-phalangeal joint of the great
toe, on one or on both sides, is that most frequently affected. The
disease is met with in men after middle life, and while common enough in
England and Ireland, is almost unknown in hospital practice in Scotland.

The _clinical features_ are characteristic. There is a sudden onset of
excruciating pain, usually during the early hours of the morning, the
joint becomes swollen, red, and glistening, with engorgement of the
veins and some fever and disturbance of health and temper. In the course
of a week or ten days there is a gradual return to the normal. Such
attacks may recur only once a year or they may be more frequent; the
successive attacks tend to become less acute but last longer, and the
local phenomena persist, the joint remaining permanently swollen and
stiff. Masses of chalk form in and around the joint, and those in the
subcutaneous tissue may break through the skin, forming indolent ulcers
with exposure of the chalky masses (_tophi_). The hands may become
seriously crippled, especially when the tendon sheaths and bursae also
are affected; the crippling resembles that resulting from arthritis
deformans but it differs in not being symmetrical.

The local _treatment_ consists in employing soothing applications and a
Bier's bandage for two or three hours twice daily while the symptoms are
acute; later, hot-air baths, massage, and exercises are indicated. It is
remarkable how completely even the most deformed joints may recover
their function. Dietetic and medicinal treatment must also be employed.

#Chronic Rheumatism.#--This term is applied to a condition which
sometimes follows upon acute articular rheumatism in persons presenting
a family tendency to acute rheumatism or to inflammations of serous
membranes, and manifesting other evidence of the rheumatic taint, such
as chorea or rheumatic nodules.

The changes in the joints involve almost exclusively the synovial
membrane and the ligaments; they consist in cellular infiltration and
exudation, resulting in the formation of new connective tissue which
encroaches on the cavity of the joint and gives rise to adhesions, and
by contracting causes stiffness and deformity. The articular cartilages
may subsequently be transformed into connective tissue, with consequent
fibrous ankylosis and obliteration of the joint. The bones are affected
only in so far as they undergo fatty atrophy from disuse of the limb, or
alteration in their configuration as a result of partial dislocation.
Osseous ankylosis may occur, especially in the small joints of the hand
and foot.

The disease is generally poly-articular and may be met with in childhood
and youth as well as in adult life. In some cases pain is so severe that
the patient resists the least attempt at movement. In others, the
joints, although stiff, can be moved but exhibit pronounced crackings.
When there is much connective tissue formed in relation to the synovial
membrane, the joint is swollen, and as the muscles waste above and
below, the swelling is spindle-shaped. Subacute exacerbations occur from
time to time, with fever and aggravation of the local symptoms and
implication of other joints. After repeated recurrences, there is
ankylosis with deformity, the patient becoming a helpless cripple. On
account of the tendency to visceral complications, the tenure of life is
uncertain.

From the nature of the disease, _treatment_ is for the most part
palliative. Salicylates are only of service during the exacerbations
attended with pyrexia. The application of soda fomentations, turpentine
cloths, or electric or hot-air baths may be useful. Improvement may
result from the general and local therapeutics available at such places
as Bath, Buxton, Harrogate, Strathpeffer, Wiesbaden, or Aix. In selected
cases, a certain measure of success has followed operative interference,
which consists in a modified excision. The deformities resulting from
chronic rheumatism are but little amenable to surgical treatment, and
forcible attempts to remedy stiffness or deformity are to be avoided.

#Arthritis Deformans# (_Osteo-arthritis, Rheumatoid Arthritis, Rheumatic
Gout, Malum Senile, Traumatic or Mechanical Arthritis_).--Under the term
arthritis deformans, which was first employed by Virchow, it is
convenient to include a number of joint affections which have many
anatomical and clinical features in common.

The disease is widely distributed in the animal kingdom, both in
domestic species and in wild animals in the natural state such as the
larger carnivora and the gorilla; evidence of it has also been found in
the bones of animals buried with prehistoric man.

The morbid changes in the joints present a remarkable combination of
atrophy and degeneration on the one hand and overgrowth on the other,
indicating a profound disturbance of nutrition in the joint structures.
The nature of this disturbance and its etiology are imperfectly known.
By many writers it is believed to depend upon some form of
auto-intoxication, the toxins being absorbed from the gastro-intestinal
tract, and those who suffer are supposed to possess what has been called
an "arthritic diathesis."

The localisation of the disease in a particular joint may be determined
by several factors, of which trauma appears to be the most important.
The condition is frequently observed to follow, either directly or after
an interval, upon a lesion which involves gross injury of the joint or
of one of the neighbouring bones. It occurs with greater frequency after
repeated minor injuries affecting the joint and its vicinity, such as
sprains and contusions, and particularly those sustained in laborious
occupations. This connection between trauma and arthritis deformans led
Arbuthnot Lane to apply to it the term _traumatic_ or _trade arthritis_.

The traumatic or strain factor in the production of the disease may be
manifested in a less obvious fashion. In the lower extremity, for
example, _any condition which disturbs the static equilibrium of the
limb as a whole_ would appear to predispose to the disease in one or
other of the joints. The static equilibrium may be disturbed by such
deformities as flat-foot or knock-knee, and badly united fractures of
the lower extremity. In hallux valgus, the metatarso-phalangeal joint of
the great toe undergoes changes characteristic of arthritis deformans.

A number of cases have been recorded in which arthritis deformans has
followed upon antecedent disease of the joint, such as pyogenic or
gonorrhoeal synovitis, upon repeated haemorrhages into the knee-joint in
bleeders, and in unreduced dislocations in which a new joint has been
established.

[Illustration: FIG. 157.--Arthritis Deformans of Elbow, showing
destruction of articular surfaces and masses of new bone around the
articular margins.

(Anatomical Museum, University of Edinburgh.)]

Lastly, Poncet and other members of the Lyons school regard arthritis
deformans as due to an attenuated form of tuberculous infection, and
draw attention to the fact that a tuberculous family history is often
met with in the subjects of the disease.

[Illustration: FIG. 158.--Arthritis Deformans of Knee, showing
eburnation and grooving of articular surfaces.

(Anatomical Museum, University of Edinburgh.)]

_Morbid Anatomy._--The commonest type is that in which the articular
surfaces undergo degenerative changes. The primary change involves the
articular cartilage, which becomes softened and fibrillated and is worn
away until the subjacent bone is exposed. If the bone is rarefied, the
enlarged cancellous spaces are opened into and an eroded and worm-eaten
appearance is brought about; with further use of the joint, the bone is
worn away, so that in a ball-and-socket joint like the hip, the head of
the femur and the acetabulum are markedly altered in size and shape.
More commonly, the bone exposed as a result of disappearance of the
cartilage is denser than normal, and under the influence of the
movements of the joint, becomes smooth and polished--a change described
as _eburnation_ of the articular surfaces (Fig. 158). In hinge-joints
such as the knee and elbow, the influence of movement is shown by a
series of parallel grooves corresponding to the lines of friction
(Fig. 158).

[Illustration: FIG. 159.--Hypertrophied Fringes of Synovial Membrane in
Arthritis Deformans of Knee.

(Museum of Royal College of Surgeons, Edinburgh.)]

While these degenerative changes are gradually causing destruction of
the articular surfaces, reparative and hypertrophic changes are taking
place at the periphery. Along the line of the junction between the
cartilage and synovial membrane, the proliferation of tissue leads to
the formation of nodules or masses of cartilage--_ecchondroses_--which
are subsequently converted into bone (Fig. 157). Gross alterations in
the ends of the bone are thus brought about which can be recognised
clinically and in skiagrams, and which tend to restrict the normal range
of movement. The extension of the ossification into the synovial
reflection and capsular ligament adds a collar or "lip" of new bone,
known as "lipping" of the articular margins, and also into other
ligaments, insertions of tendons and intermuscular septa giving rise to
bony outgrowths or osteophytes not unlike those met with in the
neuro-arthropathies.

Proliferative changes in the synovial membrane are attended with
increased vascularity and thickening of the membrane and an enlargement
of its villi and fringes. When the fatty fringes are developed to an
exaggerated degree, the condition is described as an _arborescent
lipoma_ (Fig. 159). Individual fringes may attain the size of a hazel
nut, and the fibro-fatty tissue of which they are composed may be
converted into cartilage and bone; such a body may remain attached by a
narrow pedicle or stalk, or this may be torn across and the body becomes
loose and, unless confined in a recess of the joint, it wanders about
and may become impacted between the articular surfaces. These changes in
the synovial membrane are often associated with an abundant exudate or
hydrops. These degenerative and hypertrophic changes, while usually
attended with marked restriction of movement and sometimes by "locking"
of the joint, practically never result in ankylosis.

The _ankylosing type_ of chronic arthritis is fortunately much rarer
than those described above, and is chiefly met with in the joints of the
fingers and toes and in those of the vertebral column. The synovial
membrane proliferates, grows over the cartilage, and replaces it, and
when two such articular surfaces are in contact they tend to adhere,
thus obliterating the joint, cavity, and resulting in fibrous or bony
ankylosis. The changes progress slowly and, before they result in
ankylosis, various sub-luxations and dislocations may occur with
distortion and deformity which, in the case of the fingers, is extremely
disabling and unsightly (Fig. 160).

_Clinical Features._--It is usually observed that in patients who are
still young the tendency is for the disease to advance with considerable
rapidity, so that in the course of months it may cause crippling of
several joints. The course of the disease as met with in persons past
middle life is more chronic; it begins insidiously, and many years may
pass before there is pronounced disability. The earliest symptom is
stiffness, especially in the morning after rest, which passes off
temporarily with use of the limb. As time goes on, the range of movement
becomes restricted, and crackings occur. This stage of the disease may
be prolonged indefinitely; if it progresses, stiffness becomes more
pronounced, certain movements are lost, others develop in abnormal
directions, and deformed attitudes add to the disablement. The disease
is compatible with long life, but not with any active occupation, hence
those of the hospital class who suffer from it tend to accumulate in
workhouse infirmaries.

_Hydrops_ is most marked in the knee, and may affect also the adjacent
bursae. As the joint becomes distended with fluid, the ligaments are
stretched, the limb becomes weak and unstable, and the patient complains
of a feeling of weight, of insecurity, and of tiredness. Pain is
occasional and evanescent, and is usually the result of some extra
exertion, or exposure to cold and wet. This form of the disease is
extremely chronic, and may last for an indefinite number of years. It is
to be diagnosed from the other forms of hydrops already considered--the
purely traumatic, the pyogenic, gonorrhoeal, tuberculous, and
syphilitic--and from that associated with Charcot's disease.

_Hypertrophied fringes and pedunculated or loose bodies_ often co-exist
with hydrops, and give rise to characteristic clinical features,
particularly in the knee. The fringes, especially when they assume the
type of the arborescent lipoma, project into the cavity of the joint,
filling up its recesses and distending its capsule so that the joint is
swollen and slightly flexed. Pain is not a prominent feature, and the
patient may walk fairly well. On grasping the joint while it is being
actively flexed and extended, the fringes may be felt moving under the
fingers. Symptoms from impaction of a loose body are exceptional.

[Illustration: FIG. 160.--Arthritis Deformans of Hands, showing
symmetry of lesions, ulnar deviation of fingers, and nodular thickening
at inter-phalangeal joints.]

_The dry form of arthritis deformans_, although specially common in the
knee, is met with in other joints, either as a mon-articular or
poly-articular disease; and it is also met with in the joints of the
spine and of the fingers as well as in the temporo-mandibular joint. In
the joints of the fingers the disease is remarkably symmetrical, and
tends to assume a nodular type (Heberden's nodes) (Fig. 160); in younger
subjects it assumes a more painful and progressive fusiform type
(Fig. 161). In the larger joints the subjective symptoms usually precede

any palpable evidence of disease, the patient complaining of stiffness,
crackings, and aching, aggravated by changes in the weather. The
roughness due to fibrillation of the articular cartilages causes coarse
friction on moving the joint, or, in the knee, on moving the patella on
the condyles of the femur. It may be months or even years before the
lipping and other hypertrophic changes in the ends of the bones are
recognisable, and before the joint assumes the deformed features which
the name of the disease suggests.

The capsular ligament, except in hydrops, is the seat of
connective-tissue overgrowth, and tends to become contracted and rigid.
Intra-articular ligaments, such as the ligamentum teres in the hip, are
usually worn away and disappear. The surrounding muscles undergo
atrophy, tendons become adherent to their sheaths and may be ossified,
and the sheaths of nerves may be involved by the cicatricial changes in
the surrounding tissues.

_The X-ray appearances of arthritis deformans_ necessarily vary with the
type of the disease and the joint affected; in the joints of the fingers
there is a narrowing of the spaces between the articular ends of the
bones as a result of absorption of the articular cartilage, and
rarefaction of the cancellous tissue in the vicinity of the joints; in
the larger joints there is "lipping" of the articular margins,
osteophytes, and other evidence of abnormal ossification in and around
the joint. Eburnation of the articular surfaces is shown by increase in
the density of the shadow of the bone in the areas affected.

[Illustration: FIG. 161.--Arthritis Deformans affecting several
Joints, in a boy aet. 10.

(Dr. Dickson's case.)]

_Treatment._--Treatment is for the most part limited to the relief of
symptoms. On no account should the affected joints be kept at rest by
means of splints or other apparatus. Active movements and exercises of
all kinds are to be persevered with. When pain is a prominent feature,
it may be relieved either by douches of iodine and hot water (tincture
of iodine 1 oz. to the quart), or by the application of lint saturated
with a lotion made up of chloral hydrate, gr. v, glycerin [dram]j, water
[ounce]j, and covered with oil-silk. Strain and over-use of the joint
and sudden changes of temperature are to be avoided. The induction of
hyperaemia by means of massage, the elastic bandage, and hot-air baths is
often of service. Operative interference is indicated when the disease
is of a severe type, when it is mon-articular, and when the general
condition of the patient is otherwise favourable. Excision has been
practised with success in the hip, knee, elbow, and temporo-mandibular
joints. Limitation of movement and locking at the hip-joint when due to
new bone round the edge of the acetabulum may be greatly relieved by
removal of the bone--a procedure known as _cheilotomy_. Loose bodies and
hypertrophied fringes if causing symptoms may also be removed by
operation.

When stiffness and grating on movement are prominent features we have
found the injection of from half to one ounce of sterilised white
vaseline afford decided relief.

The patient should be nourished well, and there need be no restriction
in the diet such as is required in gouty patients, so long as the
digestion is not impaired. Benefit is also derived from the
administration of cod-liver oil, and of tonics, such as strychnin,
arsenic, and iron, and in some cases of iodide of potassium. Luff
recommends the administration over long periods of guaiacol carbonate,
in cachets beginning with doses of 5-10 grs. and increased to 15-20 grs.
thrice daily. A course of treatment at one of the reputed spas--Aix,
Bath, Buxton, Gastein, Harrogate, Strathpeffer, Wiesbaden, Wildbad--is
often beneficial.

In some cases benefit has followed the prolonged internal administration
of liquid paraffin.

On the assumption that the condition is the result of an
auto-intoxication from the intestinal tract, saline purges and
irrigation of the colon are indicated, and Arbuthnot Lane claims to have
brought about improvement by short-circuiting or by resecting the colon.

Residence in a warm and dry climate, with an open-air life, has been
known to arrest the disease when other measures have failed to give
relief.

The application of radium and the ingestion of radio-active waters have
also been recommended.

#Haemophilic# or #Bleeder's Joint#.--This is a rare but characteristic
affection met with chiefly in the knee-joint of boys who are the
subjects of haemophilia. After some trivial injury, or even without
apparent cause, a haemorrhage takes place into the joint. The joint is
tensely swollen, cannot be completely extended, and is so painful that
the patient is obliged to lie up. The temperature is often raised (101 o
to 102 o F.), especially if there are also haemorrhages elsewhere. The
blood in the joint is slowly re-absorbed, and by the end of a fortnight
or so, the symptoms completely disappear. As a rule these attacks are
repeated; the pain attending them diminishes, but the joint becomes the
seat of permanent changes: the synovial membrane is thickened,
abnormally vascular, and coloured brown from the deposit of blood
pigment; on its surface, and in parts of the articular cartilage, there
is a deposit of rust-coloured fibrin; there may be extensive adhesions,
and in some cases changes occur like those observed in arthritis
deformans with erosion and ulceration of the cartilage and a form of dry
caries of the articular surfaces, which may terminate in ankylosis.

As the swelling of the joint is associated with wasting of the muscles,
with stiffness, and with flexion, the condition closely resembles
tuberculous disease of the synovial membrane. From errors in diagnosis
such joints have been operated upon, with disastrous results due to
haemorrhage.

The treatment of a recent haemorrhage consists in securing absolute rest
and applying elastic compression. The introduction of blood-serum (10-15
c.c.) into a vein may assist in arresting the haemorrhage;
anti-diphtheritic serum is that most readily obtainable.

After an interval, measures should be adopted to promote the absorption
of blood and to prevent stiffness and flexion; these include massage,
movements, and extension with weight and pulley.


JOINT DISEASES ASSOCIATED WITH LESIONS OF THE NERVOUS SYSTEM:
NEURO-ARTHROPATHIES

_In Lesions of Peripheral Nerves._--In the hand, and more rarely in the
foot, when one or other of the main nerve-trunks has been divided or
compressed, the joints may become swollen and painful and afterwards
become stiff and deformed. Bony ankylosis has been observed.

_In Affections of the Spinal Medulla._--In myelitis, progressive
muscular atrophy, poliomyelitis, insular sclerosis, and in traumatic
lesions, joint affections are occasionally met with.

The occurrence of joint lesions in _locomotor ataxia_ (tabes dorsalis)
was first described by Charcot in 1868--hence the term "Charcot's
disease" applied to them. Although they usually develop in the ataxic
stage, one or more years after the initial spinal symptoms, they may
appear before there is any evidence of tabes. The onset is frequently
determined by some injury. The joints of the lower extremity are most
commonly affected, and the disease is bilateral in a considerable
proportion of cases--both knees or both hips, for instance, being
implicated.

Among the theories suggested in explanation of these arthropathies the
most recent is that by Babinski and Barre, which traces the condition to
vascular lesions of a syphilitic type in the articular arteries.

The first symptom is usually a swelling of the joint and its vicinity.
There is no redness or heat and no pain on movement. The peri-articular
swelling, unlike ordinary oedema, scarcely pits even on firm pressure.

[Illustration: FIG. 162.--Bones of Knee-joint in advanced stage of
Charcot's Disease. The medial part of the head of the tibia has
disappeared.

(Anatomical Museum, University of Edinburgh).]

In mild cases this condition of affairs may persist for months; in
severe cases destructive changes ensue with remarkable rapidity. The
joint becomes enormously swollen, loses its normal contour, and the ends
of the bones become irregularly deformed (Fig. 162). Sometimes, and
especially in the knee, the clinical features are those of an enormous
hydrops with fibrinous and other loose bodies and hypertrophied
fringes--and great oedema of the peri-articular tissues (Fig. 163). The
joint is wobbly or flail-like from stretching and destruction of the
controlling ligaments, and is devoid of sensation. In other cases,
wearing down and total disappearance of the ends of the bones is the
prominent feature, attended with flail-like movements and with coarse
grating. Dislocation is observed chiefly at the hip, and is rather a
gross displacement with unnatural mobility than a typical dislocation,
and it is usually possible to move the bones freely upon one another and
to reduce the displacement. A striking feature is the extensive
formation of new bone in the capsular ligament and surrounding muscles.
The enormous swelling and its rapid development may suggest the growth
of a malignant tumour. The most useful factor in diagnosis is the entire
absence of pain, of tenderness, and of common sensibility. The freedom
with which a tabetic patient will allow his disorganised joint to be
handled requires to be seen to be appreciated.

[Illustration: FIG. 163.--Charcot's Disease of Left Knee. The joint is
distended with fluid and the whole limb is oedematous.]

The rapidity of the destructive changes in certain cases of tabes, and
the entire absence of joint lesions in others, would favour the view
that special parts of the spinal medulla must be implicated in the
former group.

In _syringomyelia_, joint affections (gliomatous arthropathies) are more
frequent than in tabes, and they usually involve the upper extremity in
correspondence with the seat of the spinal lesion, which usually affects
the lower cervical and upper thoracic segments. Except that the joint
disease is seldom symmetrical, it closely resembles the arthropathy of
tabes. The completeness of the analgesia of the articular structures
and of the overlying soft parts is illustrated by the fact that in one
case the patient himself was in the habit of letting out the fluid from
his elbow with the aid of a pair of scissors, and that in another the
joint was painlessly excised without an anaesthetic.

[Illustration: FIG. 164.--Charcot's Disease of both Ankles: front view.
Man, aet. 32.]

The disease may become arrested or may go on to complete
disorganisation; suppuration may ensue from infection through a breach
of the surface, and in rare cases the joint has become the seat of
tuberculosis.

[Illustration: FIG. 165.--Charcot's Disease of both Ankles: back view.
Man, aet. 32.]

_Treatment_, in addition to that of the nerve lesion underlying the
arthropathy, consists in supporting and protecting the joint by means of
bandages, splints, and other apparatus. In the lower extremity, the use
of crutches is helpful in taking the strain off the affected limb. When
there is much distension of the joint, considerable relief follows upon
withdrawal of fluid. The best possible result being rigid ankylosis in a
good position, it may be advisable to bring this about artificially by
arthrodesis or resection. Operation is indicated when only one joint is
affected and when the cord lesion is such as will permit of the patient
using the limb. The wounds heal well, but the victims of tabes are
unfavourable subjects for operative interference, on account of their
liability to intercurrent complications. When the limb is quite useless,
amputation may be the best course.

_In cerebral lesions_ attended with hemiplegia, joint affections,
characterised by evanescent pain, redness, and swelling, are
occasionally met with. The secondary changes in joints which are the
seat of paralytic contracture are considered with the surgery of the
Extremities.

In cases of _hysteria_ and other _functional affections of the
nervous system_, an intermittent neuropathic hydrops has been
observed--especially in the knee. Without apparent cause, the joint
fills with fluid and its movements become restricted, and after from two
to eight days the swelling subsides and the joint returns to normal. A
remarkable feature of the condition is that the effusion into the joint
recurs at regular intervals, it may be over a period of years. Psychic
conditions have been known to induce attacks, and sometimes to abort
them or even to cause their disappearance. Hence it has been recommended
that treatment by suggestion should be employed along with tonic doses
of quinine and arsenic.


HYSTERICAL OR MIMETIC JOINT AFFECTIONS

Under this heading, Sir Benjamin Brodie, in 1822, described an affection
of joints, characterised by the prominence of subjective symptoms and
the absence of pathological changes. Although most frequently met with
in young women with an impressionable nervous system, and especially
among those in good social circumstances, it occurs occasionally in men.
The onset may be referred to injury or exposure to cold, or may be
associated with some disturbance of the emotions or of the generative
organs; or the condition may be an involuntary imitation of the symptoms
of organic joint disease presented by a relative or friend.

It is characteristic that the symptoms develop abruptly without
satisfactory cause, that they are exaggerated and wanting in harmony
with one another, and that they do not correspond with the features of
any of the known forms of organic disease. In some cases the only
complaint is of severe pain; more often this is associated with
excessive tenderness and with impairment of the functions of the joint.
On examination the joint presents a normal appearance, but the skin
over it is remarkably sensitive. A light touch is more likely to excite
pain than deep and firm pressure. Stiffness is a variable feature--in
some cases amounting to absolute rigidity, so that no ordinary force
will elicit movement. It is characteristic of this, as of other
neuroses, that the symptoms come and go without sufficient cause. When
the patient's attention is diverted, the pain and stiffness may
disappear. There is no actual swelling of the joint, although there may
be an appearance of this from wasting of the muscles above and below. If
the joint is kept rigid for long periods, secondary contracture may
occur--in the knee with flexion, in the hip with flexion and adduction.

The _diagnosis_ is often a matter of considerable difficulty, and the
condition is liable to be mistaken for such organic lesions as a
tuberculous or pyogenic focus in the bone close to the joint.

The greatest difficulty is met with in the knee and hip, where the
condition may closely simulate tuberculous disease. The use of the
Rontgen rays, or examination of the joint under anaesthesia, is helpful.

The _local treatment_ consists chiefly in improving the nutrition of the
affected limb by means of massage, exercises, baths, and electricity.
Splints are to be avoided. In refractory cases, benefit may follow the
application of blisters or of Corrigan's button. The general condition
of the patient must be treated on the same lines as in other neuroses.
The Weir-Mitchell treatment may have to be employed in obstinate cases,
the patient being secluded from her friends and placed in charge of a
nurse. Complete recovery is the rule, but when the muscles are weak and
wasted from prolonged disuse, a considerable time may elapse before the
limb returns to normal.


TUMOURS AND CYSTS

New growths taking origin in the synovial membrane are rare, and are not
usually diagnosed before operation. They are attended with exudation
into the joint, and in the case of _sarcoma_ the fluid is usually
blood-stained. If the tumour projects in a polypoidal manner into the
joint, it may cause symptoms of loose body. One or two cases have been
recorded in which a _cartilaginous tumour_ growing from the synovial
membrane has erupted through the joint capsule and infiltrated the
adjoining muscles. _Multiple cartilaginous tumours_ forming loose bodies
are described on p. 544.

_Cysts of joints_ constitute an ill-defined group which includes ganglia
formed in relation to the capsular ligament. Cystic distension of bursae
which communicate with the joint is most often met with in the region of
the knee in cases of long-standing hydrops. It was suggested by Morrant
Baker that cystic swellings may result from the hernial protrusion of
the synovial membrane between the stretched fibres of the capsular
ligament, and the name "Baker's cysts" has been applied to these.

In the majority of cases, cysts in relation to joints give rise to
little inconvenience and may be left alone. If interfered with at all,
they should be excised.


LOOSE BODIES

It is convenient to describe the varieties of loose bodies under two
heads: those composed of fibrin, and those composed of organised
connective tissue.

#Fibrinous Loose Bodies# (Corpora oryzoidea).--These are homogeneous or
concentrically laminated masses of fibrin, sometimes resembling rice
grains, melon seeds, or adhesive wafers, sometimes quite irregular in
shape. Usually they are present in large numbers, but sometimes there is
only one, and it may attain considerable dimensions. They are not
peculiar to joints, for they are met with in tendon sheaths and bursae,
and their origin from synovial membrane may be accepted as proved. They
occur in tuberculosis, arthritis deformans, and in Charcot's disease,
and their presence is almost invariably associated with an effusion of
fluid into the joint. While they may result from the coagulation of
fibrin-forming elements in the exudate, their occurrence in tuberculous
hydrops would appear to be the result of coagulation necrosis, or of
fibrinous degeneration of the surface layer of the diseased synovial
membrane. However formed, their shape is the result of mechanical
influences, and especially of the movement of the joint.

_Clinically_, loose bodies composed of fibrin constitute an unimportant
addition to the features of the disease with which they are associated.
They never give rise to the classical symptoms associated with impaction
of a loose body between the articular surfaces. Their presence may be
recognised, especially in the knee, by the crepitating sensation
imparted to the fingers of the hand grasping the joint while it is
flexed and extended by the patient.

The _treatment_ is directed towards the disease underlying the hydrops.
If it is desired to empty the joint, this is best done by open
incision.

[Illustration: FIG. 166.--Radiogram of Multiple Loose Bodies in
Knee-joint and Semi-membranosus Bursa in a man aet. 38.

(Mr. J. W. Dowden's case.)]

#Bodies composed of Organised Connective Tissue.#--These are
comparatively common in joints that are already the seat of some chronic
disease, such as arthritis deformans, Charcot's arthropathy, or synovial
tuberculosis. They take origin almost exclusively from an erratic
overgrowth of the fringes of the synovial membrane, and may consist
entirely of fat, the arborescent lipoma (Fig. 159) being the most
pronounced example of this variety. Fibrous tissue or cartilage may
form in one or more of the fatty fringes and give rise to hard nodular
masses, which may attain a considerable size, and in course of time may
undergo ossification.

Like other hypertrophies on a free surface, they tend to become
pedunculated, and so acquire a limited range of movement. The pedicle
may give way and the body become free. In this condition it may wander
about the joint, or lie snugly in one of its recesses until disturbed by
some sudden movement. A loose body free in a joint is capable of growth,
deriving the necessary nutriment from the surrounding fluid. The size
and number of the bodies vary widely. Single specimens have been known
to attain the size of the patella. The smaller varieties may number
considerably over a hundred.

[Illustration: FIG. 167.--Loose Body from Knee-joint of man aet. 25.
Natural size.

a = Convex surface.   b = Concave surface.]

In arthritis deformans a rarer type of loose body is met with, a portion
of the lipping of one of the articular margins being detached by injury.
In Charcot's disease, bodies composed of bone are formed in relation to
the capsular and other ligaments, and may be made to grate upon one
another.

The _clinical features_ in this group are mainly those of the disease
which has given rise to the loose bodies, and it is exceptional to meet
with symptoms from impaction of the body between the articular surfaces.
Treatment is to be directed towards the primary disease in the joint, as
well as to the removal of the loose bodies.

[Illustration: FIG. 168.--Multiple partially ossified Chondromas of
Synovial Membrane, from Shoulder-joint, the seat of arthritis deformans,
from a man aet. 35.]

_Loose Bodies in Joints which are otherwise healthy._--It is in joints
otherwise healthy that loose bodies causing the classical symptoms and
calling for operative treatment are most frequently met with. They occur
chiefly in the knee and elbow of healthy males under the age of thirty.
The complaint may be of vague pains, of occasional cracking on moving
the joint, or of impairment of function--usually an inability to extend
or flex the joint completely. In many cases a clear account is given of
the symptoms which arise when the body is impacted between the articular
surfaces, namely, sudden onset of intense sickening pain, loss of power
in the limb and locking of the joint, followed by effusion and other
accompaniments of a severe sprain. On some particular movement, the
body is disengaged, the locking disappears, and recovery takes place.
Attacks of this kind may recur at irregular intervals, during a period
of many years. On examining the joint, it is usually found to contain
fluid, and there may be points of special tenderness corresponding to
the ligaments that have been overstretched. In cases in which there has
been recurrent attacks of locking, the ligaments become slack, the joint
is wobbly, and the quadriceps is wasted. The patient himself, or the
surgeon, may discover the loose body and feel it roll beneath his
fingers, especially if it is lodged in the supra-patellar pouch in the
knee, or on one or other side of the olecranon in the elbow. In most
instances the patient has carefully observed his own symptoms, and is
aware not only of the existence of the loose body, but of its erratic
appearance at different parts of the joint. This feature serves to
differentiate the lesions from a torn medial meniscus in which the pain
and tenderness are always in the same spot. As the body usually contains
bone, it is recognisable in a skiagram.

[Illustration: FIG. 169.--Multiple Cartilaginous Loose Bodies from
Knee-joint.]

There are two methods of _removing the body_; the first and simpler
method is applicable when the body can be palpated, usually in the
supra-patellar pouch; it is preferably transfixed by a needle and can
then be removed through a small incision; otherwise, the joint must be
freely opened and explored, firstly to find the body and further to
remove it.

The characters of this type of loose body are remarkably constant. It is
usually solitary, about the size of a bean or almond, concavo-convex in
shape, the convex aspect being smooth like an articular surface, the
concave aspect uneven and nodulated and showing reparative changes,
healing over of the raw surface, and the new formation of fibrous
tissue, hyaline cartilage and bone, the necessary nutriment being
derived from the synovial fluid (Fig. 167). The body is sometimes found
to be lodged in a defect or excavation in one of the articular surfaces,
usually the medial condyle of the femur, from which it is readily
shelled out by means of an elevator. It presents on section a layer of
articular cartilage on the convex aspect and a variable thickness of
spongy bone beneath this.

The origin of these bodies is one of the most debated questions in
surgical pathology; they obviously consist of a portion of the articular
surface of one of the bones, but how this is detached still remains a
mystery; some maintain that it is purely traumatic; Konig regards them
as portions of the articular surface which have been detached by a
morbid process which he calls "osteochondritis dessicans."

_Multiple Chondromas and Osteomas of the Synovial Membrane._--In this
rare type of loose body, the surface of the synovial membrane is studded
with small sessile or pedunculated tumours composed of pure hyaline
cartilage, or of bone, or of transition stages between cartilage and
bone. They are pearly white in colour, pitted and nodular on the
surface, rarely larger than a pea, although when compressed they may
cake into masses of considerable size. With the movements of the joint
many of the tumours become detached and lie in the serous exudate
excited by their presence. They are found also in the diverticula of the
synovial membrane, in the shoulder in the downward prolongation along
the tendon of the biceps, in the hip in the bursal extension beneath the
psoas.

The patient complains of increasing disability of the limb, movements of
the joint becoming more and more restricted and painful. There is
swelling corresponding to the distended capsule of the joint, and on
palpation the bodies moving under the fingers yield a sensation as of
grains of rice shifting in a bag. If the bodies are so numerous as to be
tightly packed together, the impression is that of a plastic mass having
the shape of the synovial sac. The stiffness and the cracking on
movement may suggest arthritis deformans, but the X-ray appearances make
the diagnosis an easy one. We have observed two cases of this affection
in the knee-joint of adult women, one in the shoulder-joint of an adult
male (Fig. 168), and Caird has observed one in the hip. The treatment
consists in opening the joint by free incision and removing the bodies.

_Displacement of the menisci_ of the knee is referred to with injuries
of that joint.




INDEX


  Abdominal aneurysm, 313
    aorta, compression of, 269
      embolus of, 93

  Abscess, 46
    acute circumscribed, 46
    of bone, 448
    Brodie's, 448
    chronic, 139
    cold, 139
    embolic, 66
    formation of, 47
    Hilton's method of opening, 50
    pointing of, 48
    pyaemic, 287
    residual, 141
    of skin, multiple, 382
    stitch, 51
    treatment of, 49
    tuberculous, 139, 141
      peri-articular, 514, 517

  Achillo-bursitis, 432

  Achillo-dynia, 422

  Acidosis, 251

  Acromion bursa, 429

  Actinomycosis, 126

  Active hyperaemia, 39

  Acupuncture in aneurysm, 308

  Acute arthritis of infants, 440
    necrosis of bone, 439

  Adductor longus muscle, rupture of, 408

  Adenoma, 202
    malignant, 209
    sebaceous, 393
    of skin, 393
    varieties of, 202

  Adiposus dolorosa, 186

  Aerobes, 19

  Air embolism, 265
    hunger, 276

  Albumosuria, 195, 474, 492

  Aleppo boil, 129

  Alexins, 22

  Ambrine, 13, 238

  Amputation neuroma, 344

  Anaerobes, 19

  Anaesthesia, after nerve injuries, 347

  Analgesia, 347

  Anaphylaxis, 23

  Anatomical tubercle, 134

  Anatomy. _See_ Surgical Anatomy

  Anel's operation for aneurysm, 307

  Aneurysm, 300. _See also_ Individual Arteries
    abdominal, 313
    acupuncture in, 308
    amputation in, 310
    by anastomosis, 298
    Anel's operation for, 307, 310
    arterio-venous, 263
    axillary, 318
    of bone, 498
    brachial, 318
    Brasdor's operation for, 308
    cirsoid, 299
    Colt's method of wiring for, 309
    compression for, 308
    consolidated, 304, 305
    differential diagnosis of, 305
    diffused, 302
    digital compression in, 308
    excision of, 307
    of forearm and hand, 318
    fusiform, 301
    gelatin injections in, 309
    Hunter's operation for, 307
    iliac, 318
    of individual arteries, 312
    inguinal, 318
    innominate, 314
    intracranial, 316
    of leg and foot, 320
    ligation of artery for, 307
    Macewen's acupuncture for, 308
    Matas' operation for, 307
    Moore-Corradi method, 308
    natural cure of, 305
    old operation for, 307
    of ophthalmic artery, 317
    orbital, 317
    pathological, 301
    pulse in, 304
    rupture of, 306
    sacculated, 302
    suppuration in, 306
    thoracic, 312
    traumatic, 263, 310
    treatment of, 306
    varicose, 311
    Wardrop's operation for, 308
    X-rays in diagnosis of, 304

  Aneurysmal varix, 311, 316, 318, 319, 320

  Angioma, 284
    arterial, 299
    capillary, 294
    cavernous, 297
    racemosum venosum, 287
    venous, 294

  Angio-neurotic oedema, 348
    sarcoma, 199

  Angler's elbow, 406

  Ankle, cellulitis of, 58

  Ankylosis of joints, 503. _See also_ Individual Joints

  Anoci-association, 253

  Anthracaemia, 121

  Anthrax, 119

  Anti-bacterial sera, 23
    -diphtheritic serum, 111
    -streptococcic serum, 23, 109
    -tetanic serum, 117

  Antibodies, 22

  Antigens, 22

  Antiseptics, 242

  Antitoxic sera, 23

  Antitoxins, 22

  Antivenin, 132

  Aorta, abdominal, compression of, 269
    aneurysm of, 313
    embolism of, 93
    ligation of, 314
    pulsating, 305, 314

  Arborescent lipoma, 423

  Arseno-billon, 163

  Arteries, anatomy of, 258
    compression of individual, 269
    contusion of, 260
    digital compression of, 269
    gangrene following ligation of, 94
    gunshot wounds of, 263

  Arteries, ligation of, for aneurysm, 307
    punctured wounds of, 262
    repair of, 266, 268
    rupture of, 260
    wounds of, 261, 262

  Arterio-sclerosis, 282

  Arterio-venous aneurysm, 310

  Arteritis, varieties of, 282

  Arthritis, 501. _See also_ Individual Joints
    acute, 506
      of infants, 440
    deformans, 524
    gonococcal, 510
    neuropathic, 532
    ossificans, 503
    pneumococcal, 509
    pyogenic, 506
    rheumatic, 523
    rheumatoid, 524
    septic, 506
    scarlatinal, 508
    trade, 525
    traumatic, 524
    tuberculous, 512
    urica, 522

  Arthrolysis, 505

  Arthropathies, 532
    gliomatous, 534

  Arthroplasty, 505

  Articular caries, 502, 514

  Artificial hyperaemia, 39

  Ascites, chylous, 325

  Asepsis, 18

  Asphyxia, local, 97
    traumatic, 254

  Atheroma, 283

  Avulsion of nerves, 375
    of tendons, 411

  Axilla, cellulitis of, 58
    hygroma of, 328

  Axillary aneurysm, 318
    artery, embolus of, 93
    lymph glands, 336
    nerve, injuries of, 363


  Bacilli, 19

  Bacillus aerogenes capsulatus, 99
    anthracis, 119
    coli communis, 27
    diphtheriae 109
    drum-stick, 112
    of Ducrey, 154
    of glanders, 123
    Klebs-Loffler, 109
    of malignant oedema, 101
    mallei, 123
    pyocyaneus, 29
    of soft sore, 154
    of tetanus, 112
    tubercle, 133
    typhosus, 29, 452

  Bacteria, death of, 21
    general characters of, 18
    pathogenic properties of, 19
    pyogenic, 24, 29

  Bacterial intoxication, 21

  Bacteriology, surgical, 17

  Baker's cysts, 539

  Bazin's disease, 74, 169

  Beck's paste in sinuses, 145

  Bed-sores, 73, 103

  Bence-Jones on albumosuria, 195, 474, 492

  Biceps, bursa under, 430
    dislocation of long tendon of, 409
    rupture of, 407

  Bier's artificial hyperaemia, 38

  B.I.P.P., 143

  Birth palsies, 362

  Biskra button, 129

  Bismuth gauze, 247
    injections in sinuses, 145

  Bites of animals, 223

  Black eye, 219

  Bleeder's joint, 531

  Bleeders, 277
    bruises in, 218

  Blisters, 376
    purulent, 55

  Blocking of nerves for shock, 252

  Blood, count, 30
    cysts, 214, 220
    transfusion of, 11, 253

  Blood vessels. _See_ Arteries and Veins

  Bloodless state, treatment of, 276

  Blood letting, general, 42

  Boil, 379
    Aleppo, 129
    Delhi, 129

  Bone. _See also_ Individual Bones
    abscess of, 448
    aneurysm of, 498
    angioma of, 491
    atrophy of, 479
    bacterial diseases of, 438
    Brodie's abscess of, 448
    cancer of, secondary, 499
    caries of, 437, 438
    changes in ulcers of leg, 79
    chondroma of, 487
    cysts of, 477, 500
    diseases of, 434
      due to staphylococcus aureus, 438
    endothelioma of, 492
    exostoses of, 191, 481
    fibroma of, 491
    fragility of, 479
    grafting, 16, 436
    gumma of, 464
    hydatid disease of, 467
    hyperostosis, 435, 464
    hypertrophic pulmonary osteo-arthropathy, 480
    hypertrophy of, 435
    lipoma of, 491
    lipping of, 527
    malacia of, 473
    marrow, function of, 434
    myeloma of, 491
    myxoma of, 491
    necrosis of, 438
    neuropathic atrophy of, 479
    osteoma of, 481
    osteomalacia of, 473
    osteomyelitis of, 65, 437, 438, 451, 453, 473
      fibrosa, 476
    osteoporosis of, 437
    osteopsathyrosis, 479
    ostitis deformans, 474
    Paget's disease of, 474
    periosteum, function of, 435
    periostitis, 437
    pulsating haematoma of, 498
    pyogenic diseases of, 438
    regeneration of, 436
    rickety affections of, 468
    sarcoma of, 492
    sclerosis of, 435
    scurvy affecting, 473
    secondary tumours of, 499
    surgical anatomy of, 434
    staphylococcal diseases of, 438
    syphilitic diseases of, 461, 465
    transplantation of, 436
    tuberculous diseases of, 454
    tumours of, 480
      malignant, 492, 499
      metastatic, 499
      thyreoid, 500
    typhoid, infection of, 452
    X-ray appearances in diseases of, 445, 455, 485, 491, 496

  Bovine tuberculosis, 136

  Brachial aneurysm, 318
    artery, embolus of, 93
      compression of, 269
    birth-paralysis, 362
    fibrositis, 413
    neuralgia, 371
    plexus, lesions of, 360

  Brain, joint affections in lesions of, 537
    syphilitic lesions of, 161

  Branchial dermoids, 211

  Brasdor's operation for aneurysm, 308

  Brodie's abscess, 448

  Bruises, 218

  Bubo, 329
    bullet, 153
    of soft sores, 155

  Bullet bubo, 153

  Bullets, embedded, 231
    varieties of, 230

  Burnol, 238

  Burns, 233
    classification, of, 234
    electrical, 239
    pathology of, 233
    by X-rays, 239

  Bursae. _See also_ Individual Bursae
    adventitious, 426
    affections of, 426
      individual, 428
    diseases of, 426, 428
    haematoma of, 426
    hydrops of, 427
    hygroma of, 423
    inflammation of, 426
    injuries of, 426
    loose bodies in, 427
    syphilis of, 428
    tuberculosis of, 428
    tumours of, 427, 428


  Cachexia, cancerous, 207

  Calcanean bursa, 432

  Calcification in arteries, 282
    in muscles, 416
    in tuberculosis, 136

  Callosities, 376

  Callous ulcers, 79, 84

  Cancer, 202
    arsenic, 395
    of bone, 499
    cachexia in, 207
    chimney-sweep's, 395
    colloid, 210
    columnar epithelial, 209
    contagiousness of, 205
    cystic, 210
    definition of, 202
    degeneration of, 205
    encephaloid, 210
    _en cuirasse_, 204
    glandular, 210
    glandular infection in, 203
    increase of, 207
    of lymph glands, 340
    medullary, 210
    melanotic, 210, 341, 397
    paraffin, 395
    pigmented, 210
    radium treatment of, 208
    rodent, 210, 395
    scirrhous, 210
    of skin, 394
    spread of, 204
    squamous epithelial, 208
    ulceration of, 205
    varieties of, 208
    X-ray, 208

  Cancrum oris, 102

  Cantharides plaster, 42

  Capillaries, anatomy of, 258

  Capillary angioma, 294
    loops, 3

  Carbolic gangrene, 95

  Carbon-dioxide snow, 297

  Carbuncle, 380

  Carcinoma. _See_ Cancer

  Caries, 437, 438
    of articular surfaces, 502, 514
    sicca, 438
    syphilitic, 462
    tuberculous, 455

  Carotid aneurysm, 314
    artery, compression of, 269
    tubercle, 269

  Carpal ganglion, 214

  Carron oil, 238

  Cartilage, grafting of, 16
    repair of, 7
    ulceration of, 502, 514

  Cartilaginous exostosis, 191, 481

  Caseation in tuberculosis, 136

  Catalepsy, 116

  Catgut, infection by, 51
    preparation of, 245

  Cautery in haemorrhage, 271

  Cavernous angioma, 298
    lymphangioma, 327

  Cellulitis, 52
    in different situations, 58
    diffuse, 52

  Cephalic or Kopf tetanus, 116

  Cerebro-spinal meningitis, 115

  Cervical adenitis, 332
    rib, 360

  Chalk stones in gouty joints, 523

  Chancre, concealed, 152, 153, 157
    erratic, 153
    extra-genital, 153
    hard, 151
    meatal, 152
    multiple, 152
    relapsing false indurated, 172
    soft, 154
    urethral, 152

  Chancroid, 154

  Charcoal poultice, 84

  Charcot's disease, 533

  Cheloid. _See_ Keloid

  Chemiotaxis, 32

  Chigoe, 130

  Chilblain, 378

  Chimney-sweep's cancer, 395

  Chloroma, 200

  Chondroma, 189, 487
    multiple, 544

  Chondromatosis, 488

  Chondro-sarcoma, 189, 200, 487

  Chordoma, 200

  Choroiditis, syphilitic, 177

  Chylorrhoea, 325

  Chylo-thorax, 325

  Chylous ascites, 325

  Cicatrices, varieties of, 400

  Cicatricial contraction, 4
    tissue, 4

  Circumflex nerve. _See_ Axillary Nerve

  Cirsoid aneurysm, 299

  Claw-hand, 369

  Cloacae in bone, 443

  Cocci, 18

  Coeliac artery, aneurysm of, 313

  Coley's fluid, 201

  Collapse, 254

  Collateral circulation, 267

  Colles' law, 178

  Colloid cancer, 210

  Common peroneal nerve, 370

  Compound palmar ganglion, 217, 423

  Condylomata, 158, 174

  Congenital fistulas, 60
    telangiectasis, 294

  Connective tissue, repair of, 6

  Contracture of joints, 502
    of muscles, 415
    paralytic, 347

  Contusions, 218

  Cornea, syphilitic ulceration of, 177

  Corns, 377

  Corpora oryzoidea, 539

  Counter-irritants, 37, 42

  Craniotabes, 175, 176, 465

  Crural fibrositis, 413

  Crutch paralysis, 351

  Cupping dry, 39
    wet, 42

  Cutis anserina, 36

  Cyanosis, traumatic, 254

  Cyst, 212
    atheromatous, 389
    Baker's, 539
    blood 214, 220
    of bone, 477, 500
    dentigerous, 193
    derma, 210
    exudation, 212
    ganglionic, 215
    haemorrhagic, 220
    hydatid, 213
    implantation, 212
    of joints, 538
    lymph, 214
    lymphatic, 219, 328
    omental, 329
    parasitic, 213
    retention, 212
    sebaceous, 212, 389
    serous, 219
    venous, 289

  Cystic adenoma, 202
    carcinoma, 210
    hygroma of neck, 328
    lymphangioma, 327, 328


  Dactylitis, syphilitic, 176, 460, 466
    tuberculous, 460

  Dancer's sprain, 406

  Deafness, syphilitic, 178

  Deformities. _See_ Individual Regions

  Delhi boil, 129

  Delirium, in surgical patients, 255
    traumatic, 257

  Delirium tremens, 256

  Dentigerous cyst, 193

  Dercum on adiposus dolorosa, 186

  Derma-cysts, 210

  Dermatitis, 239, 292

  Dermoids, 210

  Diabetic gangrene, 96

  Diarsenol, 163

  Diapedesis of red corpuscles, 32

  Diaphysial aclasis, 483

  Diffuse aneurysm, 302
    cellulitis, 52
    fibromatosis, 194
    lipomatosis, 187
    neuro-fibromatosis, 355
    osteoma, 485
    suppuration, 52

  Diphtheria, 109
    antitoxin in, 111
    intubation in, 111

  Diplococci, 19

  Dislocation of nerves, 351, 369
    pathological, 514
    of tendons, 408

  Double cyanide gauze, 247

  Drainage of wounds, 222

  Dressings, surgical, 247

  Drill-bone, 418

  Drop-finger, 411
    -foot, 370
    -wrist, 365

  Drunkard's palsy, 351, 364

  Duchenne's paralysis, 361

  Ducrey's bacillus, 154

  Duodenum, ulceration of, in burns, 236

  Dwarf, rickety, 469
    syphilitic, 178


  Eburnation of articular surfaces, 557

  Ecchondroses, 527

  Ecchymosis, 218

  Echinococcus, 213

  Echthyma, 158

  Eczema, varicose, 292

  Elbow, angler's, 406
    cellulitis of, 58
    tennis, 406

  Electricity, injuries by, 239

  Electrolysis in angioma, 297

  Elephantiasis, varieties of, 360, 384, 386

  Embolism, 281
    air, 265

  Embolism, fat, 254
    of individual arteries, 93

  Embolus, 281

  Emigration of leucocytes, 32

  Emotional shock, 251

  Emphysema, 99, 102

  Emprosthotonos, 214

  Empyema of joints, 501, 518

  Encephaloid cancer, 210

  Endarteritis obliterans, 282
    syphilitic, 161

  Endo-aneurysmorrhaphy, 307

  Endothelioma, 196
    of bone, 492

  Epicritic sensibility of nerves, 343

  Epidermis, grafting, 12
    repair of, 4

  Epiphysial cartilage, 434
    junction, 434
      in rickets, 469

  Epiphysiolysis, 440

  Epiphysitis, 437
    syphilitic, 465

  Epithelial tumours, 201

  Epithelioma, 208
    chimney-sweep's, 395
    lupus, 384
    paraffin, 395
    in scars, 402
    sinus, 500
    of skin, 394
    trade, 395
    varieties of, 208
    X-ray, 395

  Epithelium grafting, 12
    repair of, 6

  Epulis, 491

  Erb's paralysis, 361

  Erysipelas, varieties of, 107

  Erythema pernio, 378
    nodosum, 442

  Evaporating lotions, 41

  Exfoliation, 438

  Exophthalmos, pulsating, 317

  Exostosis, 191, 481
    bursata, 481
    cancellous, 481
    cartilaginous, 191, 481
    false, 192
    ivory, 481
    multiple, 483
    spongy, 191, 481
    subungual, 191, 404, 481

  Explosives, wounds by, 231

  External iliac artery, embolus of, 93

  External popliteal nerve. _See_ Common Peroneal Nerve

  Extravasation of blood, 259

  Exudates, varieties of, 33

  Exudation cysts, 212

  Eye, syphilitic lesions of, 160, 176, 177


  Facial artery, compression of, 269
    erysipelas, 107

  Fainting, 249

  Farcy, 125

  Fascia, grafting of, 16

  Fat embolism, 254
    grafting of, 16

  Fatty hernia, 187
    tumours, 184

  Feet, trench, 96

  Femoral aneurysm, 318
    artery compression of, 269
    embolus of, 93
    lymph glands, 323

  Fever, 35

  Fibro-adenoma, 202

  Fibroblasts, 3

  Fibroid, recurrent, of Paget, 199, 392, 420
    uterine, 195

  Fibroma, 194
    of bone, 491
    diffuse, 194
    recurrent, of Paget, 199, 392, 420
    of skin, 391
    varieties of, 194

  Fibromatosis, diffuse, 194

  Fibro-myoma, 195

  Fibro-sarcoma, 199

  Fibrositis, varieties of, 372, 412

  Filaria Bancrofti, 326

  Filarial disease, 326

  Finger, chancre of, 154
    drop-, 411
    mallet-, 411

  Fingers, gouty affections of, 523
    whitlow of, 55

  Finsen light treatment, 138

  Firearms, wounds by, 225, 227, 230

  First intention, healing by, 2

  Fistula, 60
    congenital, 60
    lymphatic, 325
    varieties of, 60

  Fluctuation, 49

  Fomentations, 37, 41

  Foot, cellulitis of, 58
    drop-, 370
    Madura, 129
    perforating ulcer of, 73

  Forci-pressure in haemorrhage, 271

  Forearm, aneurysm of, 318
    cellulitis of, 58

  Foreign bodies, embedded, 6, 231

  Fracture, pathological, 444

  Fraenkel's pneumococcus, 28

  Fragilitas ossium, 479

  Friedlander's pneumo-bacillus, 28

  Frost-bite, gangrene from, 95

  Furunculus orientalis, 129


  Galyl, 163

  Ganglion, 214, 215, 217
    compound palmar, 217, 423

  Ganglionic neuroma, 353

  Gangrene, 86
    acute infective, 99
      emphysematous, 102
    from angio-sclerosis, 98
    bacterial varieties of, 99
    from burns and scalds, 95
    cancrum oris, 102
    carbolic, 95
    from chemical agents, 95
    clinical types of, 86
      varieties of, 88
    from constriction of vessels, 94
    diabetic, 96
    dry, 86
    embolic, 92
    from ergot, 98
    from frost-bite, 95
    gas, 102
    from interference with circulation, 86
    following ligation of arteries, 94
    line of demarcation in, 87
    malignant oedema, 101
    moist, 87
    noma, 102
    phagedaena, 153
    Raynaud's disease, 97
    senile, 88
    traumatic, 94
    from trench feet, 96
    white, 93
    from whitlow, 99

  Gas gangrene, 102

  Gasserian ganglion, removal of, 375

  Gauze, varieties of, 247

  Gauze, sterilisation of, 245

  Gelatin, injection of, in aneurysm, 309
    in haemophilia, 280

  Gelatinous degeneration of joints, 515

  Giant cells, 3

  Glanders, 123

  Glands, lymph. _See_ Lymph Glands

  Glioma, 196

  Gliomatous arthropathies, 534

  Glio-sarcoma, 200

  Gloves in surgery, 244

  Gluteal aneurysm, 319
    fibrositis, 372, 413

  Glycogen reaction, 30

  Glycosuria in perforating ulcer, 73

  Golfer's back, 405

  Gonorrhoeal bursitis, 428
    joint lesions, 510
    lymphangitis, 325
    myositis, 416
    ophthalmia, joint lesions following, 510
    rheumatism, 510
    teno-synovitis, 423

  Gout, joint affections in, 522

  Gouty bursitis, 428
    joints, 522
    teno-synovitis, 422
    tophi, 523
    ulcers, 77

  Grafting of bone, 436
    of epithelium, 12
    of mucous membrane, 16
    of skin, 11
    of tissues, 10

  Granulation, healing by, 5
    tissue, formation of, 2
      syphilitic, 146
      tuberculous, 136

  Granulations, 2

  Granuloma, 42

  Groin, cellulitis of, 59
    filarial disease in lymphatics of, 326

  Growing pains, 451

  Growth fever, 451

  Gumma, 168
    of bone, 464
    peri-bursal, 521
    periosteal, 521
    peri-synovial, 521
    subcutaneous, 76
    syphilitic, 168

  Gummatous infiltration, 168

  Gunshot wounds, 225, 227, 230


  Haematemesis, 259
    post-operative, 275

  Haematoma, 220
    bursal, 426
    pulsating, of bone, 498

  Haematuria, 259

  Haemophilia, 277

  Haemophilic joint, 531

  Haemoptysis, 259

  Haemorrhage, 266
    arrest of, 266, 270, 272, 274
    arterial, 259
    capillary, 260
    cautery in, 271
    constitutional effects of, 275
    digital compression in, 269
    external, 259
    forci-pressure in, 271
    intermediate, 272
    internal, 259
    ligature in, 270
    in operations, 269
    prevention of, 269
    primary, 266
    reactionary, 272
    saline infusions in, 276
    secondary, 273
    styptics in, 271
    torsion in, 271
    tourniquets in, 270, 272
    toxic, 275
    from varicose veins, 292
    venous, 259

  Haemorrhagic diathesis, 277

  Haemostatics, 271

  Hair, syphilitic lesions of, 159

  Hand, claw-, 369

  Hands, disinfection of, 244

  Hard chancre, 151

  Healing by blood-clot, 6
    by first intention, 2
    by granulation, 5
    by primary union, 2
    rate of, 9
    under scab, 6
    by second intention, 5
    sore, 69, 81
    ulcer, 77
    by union of granulating surfaces, 5

  Heart, massage of, 265

  Heberden's nodes, 529

  Hectic fever, 62

  Heliotherapy, 139

  Hernia, fatty, 187
    of muscle, 408

  Herpes, syphilitic, 156

  Hilton's method of opening abscess, 50

  Hodgkin's disease, 377

  Horns, varieties of, 389, 391

  Housemaid's knee, 426, 431

  Hunter's operation for aneurysm, 307

  Hutchinson's teeth, 177

  Hydatid cysts, 213
      of bone, 467
      of muscle, 421
    thrill, 214

  Hydrocele of neck, 328

  Hydrophobia, 115, 118

  Hydrops, 501, 518

  Hygroma of axilla, 328
    bursal, 427
    of neck, 328

  Hyperaemia, 32
    active, 39
    artificial, 36
    passive, 38
    in tuberculosis, 138

  Hyperostosis, 435
    syphilitic, 464

  Hypertrophic pulmonary osteo-arthropathy, 480

  Hysterical joint affections, 537


  Ice-bags, 41

  Ichthyma, syphilitic, 158

  Igni-puncture in naevus, 297

  Iliac aneurysm, 318

  Immunity, 22

  Imperial drink, 40

  Implantation cysts, 212

  Infantile scurvy, 473

  Infection, accidental, 241
    by catgut, 51
    mixed, 20
    prevention of, 243
    of wounds, 241

  Inflammation, 31
    changes in, 32
    chronic, 42
    clinical aspects of, 33
    constitutional disturbance in, 35
    general principles of treatment in, 36, 39

  Inflammation, leucocytosis in, 36
    stages of, 32

  Infusion of saline solution, 276

  Ingrowing toe-nail, 403

  Inguinal aneurysm, 318
    lymph glands, 323

  Injuries, 218. _See also_ Individual Tissues and Regions
    constitutional effects of, 249

  Innominate aneurysm, 314

  Inoculation tubercle, 382

  Insects, poisoning by, 130

  Instruments, sterilisation of, 245

  Intercostal fibrositis, 413

  Intermittent claudication of vessels, 98

  Internal popliteal nerve. _See_ Tibial Nerve

  Interstitial keratitis, 177

  Intestine, repair of, 9

  Intoxication, bacterial, 21

  Intracranial aneurysm, 316

  Intra-cystic growths, 202

  Intubation of larynx, 111

  Involucrum, 443

  Iodine, catgut, 246
    for disinfection of skin, 245
    reaction, 30

  Iodoform gauze, 247
    injection of, 142
    in joint diseases, 519

  Iritis, syphilitic, 160

  Irrigation, continuous, 54

  Irritable ulcers, 79

  Ischaemic contracture of muscles, 415

  Ischial bursa, 430

  Ischias scoliotica, 372

  Ivory exostosis, 481


  Jaws, actinomycosis of, 127
    changes in, in rickets, 470
    cystic tumours of, 193

  Jigger, 130

  Joints. _See also_ Individual Joints
    ankylosis of, 503
    bacterial diseases of, 506
    bleeder's, 531
    Charcot's disease of, 533
    chondromata, multiple, of, 544
    contracture of, 502
    cysts of, 538
    developmental errors of, 505
    diseases of, general, 501, 506
    disorganisation of, 502
    empyema of, 501
    gelatinous degeneration of, 515
    gliomatous arthropathies, 534
    gonococcal affections of, 510
    gouty affections of, 522
    haemophilic, 531
    hydrops of, 501
    hysterical affections of, 537
    impaired mobility of, 502
    iodoform in diseases of, 519
    loose bodies in, 529, 539
    mimetic affections of, 537
    nerve lesions affecting, 532
    neuro-arthropathies, 532
    osteo-arthritis, 524
    pneumococcal infection of, 509
    pyaemic affections of, 508
    pyogenic diseases of, 506
    rheumatic affections of, 523, 524
    rigidity of, 502
    scarlet fever, infection of, in 508
    spinal diseases affecting, 532
    starting pains in, 502, 517
    synostosis, 503
    syphilitic diseases of, 521
    tuberculous diseases of, 512
    tumours of, 538
    typhoid infection of, 508
    white swelling of, 515, 518

  Jumper's sprain, 406


  Keloid, 194, 401

  Keratitis, interstitial, in syphilis, 177

  Keratoma of nail bed, 391

  Kharsivan, 163

  Klapp's suction bells, 39

  Klebs-Loffler bacillus, 109

  Klumpke's paralysis, 361

  Knee, cellulitis of, 58
    ganglion of, 215
    housemaid's, 426, 431

  Kopf or cephalic tetanus, 116

  Kyphosis, 471


  Labourer's back, 405

  Larynx, syphilis of, 177

  Leeches, 41

  Leg ulcer, 72
    varicose veins of, 287

  Leiter's lead tubes, 41

  Leontiasis ossea, 485

  Leucocytes, emigration of, 32
    varieties of, 29
    wandering, 3

  Leucocythaemia, 340

  Leucocytosis, 22, 29
    absence of, 30
    digestion, 30
    after haemorrhage, 30
    local, 32
    physiological, 29, 30
    post-operative, 30

  Leucopenia, 30

  Leucoplakia, 167

  Lightning stroke, 240

  Line of demarcation in gangrene, 87

  Lingual dermoids, 211

  Lipoma, 184
    arborescent, 423
    of bone, 187, 491
    diffuse, 187
    intra-muscular, 188
    multiple, 186
    nasi, 393
    periosteal, 187
    subcutaneous, 184, 186
    subserous, 187
    subsynovial, 187

  Lipomatosis, diffuse, 187

  Lipping of bone, 527

  Liquor epispasticus, 42
    puris, 45

  Listerian methods of wound treatment, 242

  Locking of joints, 505

  Lock-jaw, 113

  Locomotor ataxia, joint lesions in, 532

  Long thoracic nerve, injuries of, 363

  Loose bodies in bursae, 427
    in joints, 529, 539
    in tendon sheaths, 423
    varieties of, 539

  Lotion, evaporating, 41

  Luargol, 163

  Luetin, 149

  Lumbago, 412

  Lumbo-sacral fibrositis, 412

  Lupus, 134, 382
    epithelioma, 384
    syphilitic, 169
    tuberculous, 382
    varieties of, 383, 393

  Lymph, 321
    cysts, 214
    glands, cancer of, 340
      diseases of, 329
      functions of, 221
      sarcoma of, 341
      surgical anatomy of, 321
      syphilitic diseases of, 337
      tuberculosis of, 331
      tumours of, 340
    oedema, 325
    scrotum, 389
    vessels, diseases of, 325
      injuries of, 323

  Lymphadenitis, 53, 329

  Lymphadenoma, 337

  Lymphangiectasis, 214, 326

  Lymphangioma, varieties of, 327

  Lymphangioplasty, 325, 386

  Lymphangio-sarcoma, 199

  Lymphangitis, 325
    septic, 53
    varieties of, 325

  Lymphatic cyst, 328
    fistula, 324
    oedema, 325

  Lymphatics, 321

  Lymphocytosis, 29

  Lymphorrhagia, 323

  Lympho-sarcoma, 199, 340


  Macewen's method of compressing abdominal aorta, 269

  Macrophages, 22

  Madura foot, 129
  _Main en griffe_, 369

  Malacia of bones, 473

  Malignant adenoma, 209
    cachexia, 207
    oedema, 101
    pustule, 120
    tumours, 183
    ulcers, 77

  Mallein test, 125

  Mallet-finger, 411

  Malum senile, 524

  Marriage and syphilis, 167

  Matas' operation for aneurysm, 307

  Median nerve, lesions of, 367

  Medullary cancer, 210

  Melaena, 259

  Melanotic cancer, 210, 397
    sarcoma, 200

  Melon-seed bodies, 539

  Meningitis, basal, 115
    cerebro-spinal, 115

  Mercury in syphilis, administration of, 165

  Metchnikoff's cream, 157

  Michel's clips, 222

  Micrococci, 18

  Micrococcus tetragenus, 29

  Micro-organisms, 18

  Microphages, 22

  Mimetic joint affections, 537

  Miner's elbow, 426

  Mitchell's operation for varicose veins, 294

  Mixed infection, 20
    naevus, 295
    venereal infection, 156

  Moist gangrene, 87

  Moles, 390
    naevoid, 295

  Molluscum fibrosum, 194, 359, 391

  Moore-Corradi method of treating aneurysm, 308

  Mosetig-Moorhof on filling of bone cavities, 447

  Mother's mark, 294

  Muco-pus, 52

  Mucous membrane, grafting of, 16
      suppuration in, 51
    patches, 160, 174

  Multilocular cystic tumours of jaw, 193

  Mummification, 86

  Muscle, affections of, 405
    atrophy of, 412
    calcification of, 416
    congenital absence of, 411
    contracture of, 415
    contusion of, 405
    diseases of, 411
    gonorrhoea of, 416
    grafting of, 16
    hernia of, 408
    hydatid cysts of, 421
    inflammation of, 415
    injuries of, 405
    ossification in, 416
    repair of, 8
    rheumatism of, 412
    rupture of, 405, 406
    sprain of, 405
    syphilis of, 416
    tuberculosis of, 416
    tumours of, 420
    wounds of, 409

  Muscular rheumatism, 412

  Musculo-cutaneous nerve, 364

  Musculo-spiral nerve. _See_ Radial Nerve

  Mustard leaves, 42

  Mycetoma, 129

  Myelitis, syphilitic, 161

  Myeloma, 195, 491
    of bone, 491
    of tendon sheaths, 424

  Myoma, 195

  Myo-sarcoma, 200

  Myositis ossificans, 416, 418
    varieties of, 415

  Myxo-adenoma, 202

  Myxoma, 194
    of bone, 491

  Myxo-sarcoma, 200


  Naevoid mole, 295

  Naevus, 294
    electrolysis of, 297
    operations for, 298
    radium treatment of, 297
    varieties of, 294

  Nail fold, whitlow of, 56
    horns, 391

  Nails, affections of, 402
    ingrowing, 403
    regeneration of, 7
    syphilitic lesions of, 159, 402

  Nasal bones, syphilitic disease of, 188, 462

  Naso-pharyngeal polypus, 491

  Natal sore, 129

  Neck, cystic hygroma of, 328
    glands of, diseases, 332
    hydrocele of, 328
    lipomatosis of, 187
    painful stiff-, 413

  Necrosis, acute, 439
    of bone, 438
    quiet, of Paget, 452
    syphilitic, 462

  Neo-diarsenol, 163
    -kharsivan, 163
    -salvarsan, 163

  Neoplasms, 181

  Nerve of Bell. _See_ Long Thoracic Nerve

  Nerves, 342. _See also_ Individual Nerves
    alcohol injections of, 374
    anatomy of, 342
    avulsion of, 375
    blocking of, 251, 252
    bullet wounds of, 346
    contusion of, 345
    crushing of, 345
    diseases of, 352
    dislocation of, 351, 369
    effects of division of, 344
    gun-shot wounds of, 346
    grafting of, 16
    implicated in scar tissue, 345
    individual, surgery of, 360
    injuries of, 344
    joint affections in lesions of, 532
    reaction of degeneration, 347
    regeneration of, 9, 346
    in scar tissue, 345
    sensibility, forms of, 343
    subcutaneous injuries of, 350
    suture of, primary, 348
      secondary, 349
    Tinel's sign, 349
    torn, 345
    tumours of, 353
    ulcers in lesions of, 73, 82

  Neuralgia, varieties of, 371

  Neurectomy, 375

  Neuritis, multiple peripheral, varieties of, 352
    traumatic, 352

  Neuro-arthropathies, 352. _See also_ Individual Joints

  Neuro-fibromatosis, 355, 359

  Neurolysis, 345

  Neuroma, stump, 344
    varieties of, 353
    "914," 613

  Nodes, periosteal, 464
    Heberden's 529

  Noma, 102

  Nose, sebaceous adenoma of, 393

  Novo-arseno-billon, 163

  Nucleinate of soda, 29


  Odontoma, 192
    varieties of, 193

  O'Dwyer's intubation apparatus, 111

  Oedema, 32, 34
    angio-neurotic, 348
    lymphatic, 325
    malignant, 101
    persistent, 109

  Olecranon bursa, 428

  Omental cyst, 329

  Onychia, varieties of, 402

  Operations during shock, 252

  Opisthotonos, 114

  Opsonins, 22

  Orbital aneurysm, 317

  Orthotonos, 114

  Ossification in muscles, tendons, and fasciae, 416

  Ossifying junction, 434

  Osteo-arthritis, 524
    syphilitic, 522

  Osteo-arthropathy, pulmonary, 480

  Osteochondritis dessicans, 544

  Osteogenesis imperfecta, 479

  Osteoid sarcoma, 200

  Osteoma, 191, 481
    cancellous, 191
    compact, 192
    diffuse, 485
    ivory, 192
    multiple, 544
    in muscles and tendons, 416
    spongy, 191
    subungual, 191, 404, 481

  Osteomalacia, varieties of, 473

  Osteomyelitis, 65, 437
    acute, 65, 438, 451, 453
    after amputation, 453
    bipolar, 439
    fibrosa, 476
    gummatous, 462
    from infection from soft parts, 453
    pyogenic, 438
    relapsing, 448
    sequelae of, 443
    streptococcal, 451
    tuberculous, 456, 458
    in typhoid fever, 452

  Osteophytes, 435

  Osteoporosis, 437

  Osteopsathyrosis, 479

  Osteosarcoma, 200

  Osteosclerosis, 435

  Ostitis deformans, 474
    rarefying, 474

  Ovarian dermoids, 211

  Ovary, grafting of, 16

  Ozoena, 176


  Pachydermatocele, 360

  Paget's disease of bone, 474
    of nipple, 397
    recurrent fibroma, 199, 392, 420

  Pain, starting, in joint disease, 502, 517
    varieties of, 35

  Painful subcutaneous nodules, 354, 392

  Palate, syphilitic lesions of, 178, 462

  Palmar ganglion, compound, 217, 423

  Papilloma, varieties of, 201, 392

  Paraffin cancer, 395

  Paralysis, brachial birth, 362
    Erb-Duchenne, 361
    Klumpke's, 361
    post-anaesthetic, 360
    pseudo, of syphilis, 174, 466

  Parasitic bacteria, 20
    cysts, 213

  Paronychia. _See_ Onychia

  Parotid abscess in pyaemia, 66
    lymph glands, 321
    tumours, 195

  Parotitis, 66

  Parrot's nodes, 175, 465

  Passive hyperaemia, Bier's, 38

  Pasteur's treatment for hydrophobia, 119

  Pelvis, rickety changes in, 471

  Perforating ulcer, 73, 82

  Perichondritis, syphilitic, 465

  Peri-lymphangitis, 325

  Periosteum, function of, 434
    gumma of, 464
    in rickets, 469

  Periostitis, 437. _See also_ Osteomyelitis
    syphilitic, 461
    tuberculous, 455

  Peripheral neuritis, 352

  Peroneal nerve, 370

  Peronei tendons, dislocation of, 409

  Petrifying sarcoma, 200

  Phagedaena, 153

  Phagedaenic ulcers, 80, 85

  Phagocytes, 3, 22

  Phagocytosis, 22

  Phimosis, with hard chancre, 152
    with soft sores, 155

  Phlebitis, 285, 292

  Phlegmasia alba dolens, 286

  Picric acid, 13, 237

  Pigeon-breast, 471

  Plantaris, rupture of, 408

  Pleurodynia, 413

  Pleurosthotonos, 114

  Pneumo-bacillus, Friedlander's bacteria, 28

  Pneumococcal arthritis, 509

  Pneumococcus, 28

  Polypi, 195

  Popliteal aneurysm, 320
    artery, embolus of, 93
    bursae, 432

    lymph glands, 323
    nerves. _See_ Common Peroneal Nerve and Tibial Nerve

  Port-wine stain, 294

  Post-anaesthetic paralysis, 360
    -anal dimple, 211

  Posterior auricular lymph glands, 322

  Post-rectal dermoids, 211

  Potato-nose, 393

  Poultice, 37
    charcoal, 84

  Pre-auricular lymph glands, 322

  Prepatellar bursa, 431

  Pressure sores, 70, 82

  Primary union of wounds, 2

  Protopathic sensibility of nerves, 343

  Proud flesh, 79

  Psammoma, 200

  Pseudo-leucaemia, 337

  Pseudo-paralysis of syphilis, 174, 466

  Psoas bursa, 430

  Pulmonary osteo-arthropathy, 480

  Pulsating aorta, 305, 314
    exophthalmos, 317
    haematoma of bone, 498

  Punctured wounds, 222

  Purpura, 280

  Purulent blister, 55

  Pus, 45
    varieties of, 46

  Pyaemia, 64
    abscess in joints in, 508

  Pyogenic bacteria, 24, 29


  Quadriceps extensor femoris, rupture of, 408


  Rabies, 118

  Rachitis, 468
    adolescentium, 472

  Radial nerve, lesions of, 364

  Radium, in lupus, 385
    in cancer, 208
    in naevus, 297
    ulceration from, 239

  Ranula, 329

  Rarefying ostitis, 437

  Ray fungus, 126

  Raynaud's disease, 97

  Reaction of degeneration, 347

  Reactionary haemorrhage, 272

  Recklinghausen's disease, 355

  Recurrent fibroid of Paget, 199, 392, 420

  Repair. _See_ Individual Tissues
    conditions interfering with, 17
    after loss of tissue, 4
    modifications of, 4
    of separated parts, 5

  Rest, 17

  Rests, foetal, 181

  Retention cysts, 212

  Retro-pharyngeal lymph glands, 322

  Reverdin's method of skin-grafting, 13

  Rhabdomyoma, 196

  Rheumatic arthritis, 524
    fever, 509
    gout, 524
    torticollis, 413

  Rheumatism, acute, 509
    chronic, 523
    gonorrhoeal, 510
    muscular, 412
    scarlatinal, 508

  Rheumatoid arthritis, 524

  Rhinophyma, 393

  Rickets, 468
    bone lesions in, 469
    changes in skeleton in, 470
    late, 472
    scurvy, 473

  Rickety, dwarf, 469
    pelvis, 471
    rosary, 469
    scoliosis, 471

  Rider's bone, 418
    sprain, 407

  Rigidity of joints, 502

  Rigor, 36

  Risus sardonicus, 114

  Rodent cancer, 210, 395
    ulcer, 210, 395

  Rontgen rays. _See_ X-rays

  Rose or erysipelas, 107

  Roseola, syphilitic, 158

  Rupia, syphilitic, 158


  Sabre-blade deformity of tibia, 466

  Sacculated aneurysm, 302

  Saddle-nose deformity, 174

  Saline infusions in haemorrhage, 276

  Salvarsan in syphilis, 162

  Sapraemia, 60
    chronic, 62

  Saprophytic bacteria, 20

  Sarcoma, 197
    of bone, 492
    inoperable, 201
    of joints, 538
    of lymph glands, 341
    melanotic, 200
    periosteal, 493
    of skin, 398
    of synovial membrane, 538
    of tendon sheaths, 424
    varieties, 199

  Scab, healing under, 6

  Scalds, 233

  Scapula, winged, 363

  Scarlet fever, joint lesions in, 508

  Scars. _See_ Cicatrices

  Sciatic nerve, lesions of, 370

  Sciatica, 371

  Scirrhous cancer, 210

  Sclavo's serum, 123

  Scoliosis, rickety, 471
    in sciatica, 372

  Scorbutic ulcers, 77

  Scrotum, elephantiasis of, 389

  Sculler's sprain, 406

  Scurvy, 473
    rickets, 473

  Sebaceous adenoma, 393
    cysts, 389
    horns, 389

  Secondary haemorrhage, 273
    syphilis, 151, 147

  Selenium in malignant tumours, 201, 208

  Semilunar ganglion, 375

  Semi-membranosus bursa, 432

  Sepsis, 18

  Septicaemia, 53, 63

  Sequestrectomy, 446

  Sequestrum of bone, 438

  Serratus anterior muscle, paralysis of, 363

  Serum, anti-diphtheritic, 109
    anti-bacterial, 23
    anti-tetanic, 117
    disease, 23
    in haemophilia, 280
    polyvalent, 23
    Sclavo's, for anthrax, 123
    treatment, 23

  Seton, 217

  Shell wounds, 231

  Shock, 250
    delayed, 252

  Shoulder, fibrositis of, 413

  Sinus, 59
    epithelioma, 500
    tuberculous, 143

  "606," 162

  Skewers for prevention of haemorrhage, 270

  Skin, 376
    abscesses of, 382
    actinomycosis of, 126
    cancer of, 394, 398
    dermoids, 210
    grafting of, 11, 14
    preparation of, for operation, 244
    repair of, 6
    sporotrichosis of, 385
    structure of, 376
    syphilitic lesions of, 157, 166
    tuberculosis of, 382, 385
    tumours of, 391

  Skull, bossing of, 465
    craniotabes of, 175, 176, 465
    diffuse osteoma of, 485
    natiform, 176
    Parrot's nodes, 465
    syphilitic disease of, 462
    unilateral hypertrophy of, 487

  Slough, 86

  Snake-bites, 131

  Snuffles, 173

  Soft chancre, 154
    corns, 377
    sore, 154

  Spas, 531

  Spasmodic tic, 373

  Sphagnum moss, 247

  Spinal arthropathies, 532
    cord, joint affections in lesions of, 532
    repair of, 9
    syphilis of, 161

  Spine, changes in rickets, 471

  Spirilla, 19

  Spirochaete pallida, 147

  Spironema pallidum, 147

  Splenic fever, 119

  Spores, 18

  Sporotrichosis, 385

  Sprain of muscle, 405, 407

  Sprinter's sprain, 406

  Staphylococci, 19, 24, 438

  Staphylococcus albus, 26
    aureus, 25

  Starting pains in joints, 502, 517

  Stasis, 32

  Sterilisation, surgical, 243

  Sterno-mastoid lymph glands, 322

  Stitch abscess, 51

  Stitches. _See_ Sutures

  Streptococci, 19, 24

  Streptococcus pyogenes, 26

  Streptothrix actinomyces, 126

  Strychnin poisoning, 115

  Stump neuroma, 344

  Styptics, 271

  Sub-acromial bursa, 429

  Sub-calcanean bursa, 433

  Subclavian aneurysm, 317

  Sub-crural bursa, 430

  Sub-deltoid bursa, 429

  Submaxillary lymph glands, 322

  Submental lymph glands, 322

  Sub-patellar bursa, 431

  Subscapularis bursa, 430

  Subungual exostosis, 191, 404, 481

  Suction bells, 39

  Suppuration, 45
    chronic, 59
    diffuse, 52
    in mucous membranes, 52
    in wounds, 50

  Supra-clavicular lymph glands, 322

  Supra-hyoid lymph glands, 322

  Supra-scapular nerve, lesions of, 364

  Surgery, definition of, 1
    Listerian, 242

  Surgical anatomy of blood vessels, 258
    of bone, 434
    of epiphyses, 434
    of lymphatics, 321
    of nerves, 342
    of skin, 376

  Surgical bacteriology, 17, 18
    shock, 250

  Sutures, 221
    sterilisation of, 245

  Sweat-glands, tumours of, 393

  Syncope, 249
    local, 97

  Synostosis, 503

  Synovial membrane, tumours of, 538

  Synovitis, 501, 506
    gonococcal, 510
    septic, 506
    serous, 506, 507
    suppurative, 507
    syphilitic, 521

  Syphilis, 147. _See also_ Individual Tissues and Organs

  Syphilis, acquired, 146, 149
      in infants, 179
    arsenical preparations in, 162
    arteritis in, 282
    bones, lesions in, 461, 465
    brain, lesions in, 161
    of bursae, 428
    cirrhosis in, 168
    Colles' law, 178
    contracture of muscle in, 416
    dactylitis in, 176, 460, 466
    epiphysitis of infants, 465
    extra-genital, 153
    in female, 152, 164
    gumma, 168, 462
    hydrops in, 521
    incubation of, 151
    in infants, 179
    inherited, 146, 172
      contagiousness of, 178
      diagnosis of, 178
      facies of, 174, 175
      lesions of bone in, 465
        eyes in, 176, 177
        joints in, 522
        skin in, 173, 174
        teeth in, 177
      treatment of, 179
    insontium, 153
    intermediate stage of, 167
    interstitial keratitis in, 177
    iodides in, 171
    iritis in, 166
    joint lesions in, 521
    of larynx, 177
    lupus, 169
    lymphadenitis, 153, 337
    lymphangitis, 326
    in male, 152
    malignant, 161
    and marriage, 167
    mercury in, 164
    mixed infection, 156
    of mouth, 166
    of mucous membranes, 160, 173, 174
    mucous patches, 160, 174
    of muscle, 416
    of nails, 159
    of nose, 188
    onychia in, 403
    osteo-arthritis, 522
    of palate, 178, 462
    phagedaena, 153
    phimosis in, 152
    in pregnant women, 164
    primary, 151
      diagnosis of, 155
      lesion of, 146, 151
      treatment of, 163
    prophylaxis of, 149
    pseudo-paralysis of, 174, 466
    reminders, 167
    second attacks of, 172
    secondary, 151, 157
      diagnosis of, 161
      lesions of eye in, 160
        hair in, 159
        nails in, 159, 402
        skin in, 162
      treatment of, 162
    serum diagnosis, 149
    skin affections in, 157, 166
    skull, lesions of, 462
    spirochaete pallida in, 147
    stages of, 150
    stomatitis, 174
    synovitis, 521
    teeth in, 177
    of tendon sheaths, 424
    tertiary, 151, 167
      diagnosis of, 167
      general manifestations of, 167
      lesions of mucous membrane in, 171
        skin in, 168, 169
      treatment of, 171
      ulcer, 169
    ulcers in, 76, 83, 169
    virus of, 147
    Wassermann reaction in, 156

  Syphiloma, 168

  Syringomyelia, joint lesions in, 534


  Tabes dorsales, joint lesions in, 532

  Taenia echinococcus, 213

  Tailor's ankle, 432

  Tailor's bottom, 426, 430

  Tarsal ganglion, 215

  Tarsus, tuberculosis of, 459

  Teeth in inherited syphilis, 177

  Telangiectasis, congenital, 294

  Temperature in surgical diseases, 35, 40

  Temporal artery, compression of, 269

  Tenderness, 34

  Tendinitis, 416

  Tendon sheaths, affections of, 421
    syphilitic affections of, 424
    tuberculosis of, 423, 424
    tumours of, 424
    whitlow of, 57

  Tendons. _See also_ Individual Tendons
    avulsion of, 411
    calcification in, 416
    diseases of, 411
    dislocation of, 408
    ganglion of, 217
    grafting of, 16
    inflammation of, 416
    ossification of, 416
    repair of, 8
    rupture of, 406, 408
    tumours of, 420
    wounds of, 409

  Tennis-player's elbow, 406

  Teno-synovitis, varieties of, 421

  Teratoma, 212

  Tertiary syphilis, 151, 167

  Tetanus, varieties of, 112

  Tetany, 116

  Thiersch's method of skin-grafting, 12

  Thirst, treatment of, 40

  Thoracic aneurysm, 312
    duct, subcutaneous rupture of, 325
      surgical anatomy of, 324
      wounds of, 325

  Thorax, rickety changes in, 469

  Thrombo-phlebitis, 285

  Thrombosis, 32, 281, 285, 292

  Thyreoid gland, grafting of, 16
    secondary tumours derived from, 500

  Tibia, sabre-blade deformity of, 466

  Tibial nerve, lesions of, 371

  Tic, spasmodic, 373

  Tinel's sign, 349

  Toe-nail, ingrowing, 403

  Toes, gouty affections of, 522
    syphilitic dactylitis of, 176, 460, 466
    tuberculous dactylitis, 460

  Tomato tumour, 393

  Tophi, gouty, 523

  Torsion of blood vessels, 271

  Torticollis, rheumatic, 413

  Tourniquet, varieties of, 270, 272

  Toxaemia, 21

  Toxins, 21, 33

  Tracheal tug in aneurysm, 312

  Tracheotomy, 111

  Trade arthritis, 525
    bursitis, 426
    epithelionia, 395

  Transfusion of blood, 276

  Transplantation of tissues, 10

  Trench feet, 96

  Trendelenburg's operation for varicose veins, 293

  Treponema pallidum, 147

  Trifacial neuralgia, 373

  Trigeminal neuralgia, 373

  Trismus, 117

  Trochanteric bursa, 430

  Trophic changes after nerve injuries, 348
    ulcer, 73

  Tropical elephantiasis, 386

  Trunk neuroma, 354

  Tubercle, anatomical, 134
    bacillus, 133

  Tuberculin, 138

  Tuberculosis, 133. _See also_ Individual Tissues and Organs
    bacillus of, 133
    of bone, 454, 456, 458
    bovine, 136
    of bursae, 428
    calcification in, 136
    caseation in, 136
    general, 135
    human, 136
    of joints, 512
    of lymph glands, 331
    of lymph vessels, 326
    modes of infection, 136
    of muscle, 416
    of nails, 403
    open-air treatment of, 137
    passive hyperaemia in, 138
    principles of treatment of, 137
    of skin, 382, 385
    of tendon sheaths, 423, 424
    trauma in causation of, 135
    vaccine treatment in, 138

  Tuberculous abscess, 139
    arthritic fever, 516
    dactylitis, 460
    granulation tissue, 136
    lupus, 382
    lymphadenitis, 331
    lymphangitis, 326
    onychia, 403
    sinus, 143

  Tuberculous ulcers, 73, 83

  Tubulo-dermoids, 211

  Tumor albus, 518

  Tumours, 181. _See also_ Individual Tumours and Tissues

  Typhoid, joint lesions in, 508
    osteomyelitis in, 452


  Ulceration, of cartilage, 502, 514
    definition of, 68

  Ulcers, 68
    ambulatory treatment of, 85
    Bazin's disease, 74, 169
    bone changes in, 79
    callous, 79, 84
    cancerous, 205
    classification of, 70
    clinical examination of, 68
    conditions of, 77
    crateriform, 395
    duodenal, in burns, 236
    epithelioma in, 500
    healing, 77
    gouty, 77
    due to imperfect circulation, 71, 82
    due to imperfect nerve-supply, 73, 82
    inflamed, 79, 85
    irritable, 79, 85
    leg, 72, 169
    malignant, 77
    perforating, 73, 82
    phagedaenic, 80, 85
    pressure, 70
    from radium, 70
    rodent, 395
    from Rontgen rays, 70
    scorbutic, 77
    skin-grafting, 14
    spreading, 79
    syphilitic, 76, 83, 158, 160, 169
    traumatic, 70, 81
    treatment of, 80
    trophic, 73
    tuberculous, 73, 83
    varicose, 72
    weak, 77, 83

  Ulnar nerve, lesions of, 368

  Uterine fibroids, 195


  Vaccine treatment, 23, 40

  Varicose aneurysm, 311
    eczema, 292
    ulcer, 72
    veins, 287

  Varix, 287

  Veins, anatomy of, 258
    entrance of air into, 265
    injuries of, 264
    repair of, 269
    rupture of, 264
    thrombosis of, 281
    varicose, 287
    wounds of, 264

  Veldt sores, 382

  Venereal disease. _See_ Syphilis
    soft sore, 154

  Venesection, 42

  Venous cysts, 289

  Verruca, 392

  Vibrion septique, 101

  Villous papilloma, 201

  Volkmann's ischaemic contracture, 415

  Vulva, diphtheria of, 111


  Wardrop's operation for aneurysm, 308

  Wart, 201, 392
    venereal, 393
    X-ray, 239

  Wassermann's reaction, 156, 162

  Weaver's bottom, 426, 430

  Weir-Mitchell treatment in hysterical joint affections, 538

  Wens, 389

  Wet-cupping, 42

  White swelling of joints, 515, 518

  Whitlow, 55
    gangrene from, 99
    at nail fold, 56
    purulent blister, 55
    subcutaneous, 56
    subperiosteal, 58
    of tendon sheaths, 57
    thecal, 57

  Whitlow, of toes, 55
    varieties of, 55

  Winged scapula, 363

  Wool-sorter's disease, 121

  Wounds, 220. _See also_ Individual Tissues and Regions
    acute suppuration in, 50
    bullet, 229
    contused, 218, 223
    drainage of, 222
    by electricity, 239
    by explosives, 231
    by firearms, 225, 227, 230
    incised, 221
    infection of, 107
    lacerated, 223
    open method of treating, 247, 248
    pistol-shot, 226
    punctured, 222
    shell, 231
    treatment, 241
    in warfare, 225, 230

  Wrist, drop-, 365

  Wry-neck, rheumatic, 413


  Xanthoma, 188

  X-rays, burns by, 239
    cancer from, 395
    dermatitis from, 239
    ulcers from, 239
    warts from, 239
    in diagnosis of aneurysm, 304
      arthritis deformans, 530
      bone diseases, 445
        tumours, 485, 491, 496
        tuberculosis, 455
      foreign bodies, 233
      joint tuberculosis, 516
    in treatment of cancer, 208
      lupus, 385
      sarcoma, 201
      tuberculosis, 138





End of the Project Gutenberg EBook of Manual of Surgery, by 
Alexis Thomson and Alexander Miles

*** END OF THIS PROJECT GUTENBERG EBOOK MANUAL OF SURGERY ***

***** This file should be named 17921-8.txt or 17921-8.zip *****
This and all associated files of various formats will be found in:
        http://www.gutenberg.org/1/7/9/2/17921/

Produced by Jonathan Ingram, Laura Wisewell and the Online
Distributed Proofreading Team at http://www.pgdp.net


Updated editions will replace the previous one--the old editions
will be renamed.

Creating the works from public domain print editions means that no
one owns a United States copyright in these works, so the Foundation
(and you!) can copy and distribute it in the United States without
permission and without paying copyright royalties.  Special rules,
set forth in the General Terms of Use part of this license, apply to
copying and distributing Project Gutenberg-tm electronic works to
protect the PROJECT GUTENBERG-tm concept and trademark.  Project
Gutenberg is a registered trademark, and may not be used if you
charge for the eBooks, unless you receive specific permission.  If you
do not charge anything for copies of this eBook, complying with the
rules is very easy.  You may use this eBook for nearly any purpose
such as creation of derivative works, reports, performances and
research.  They may be modified and printed and given away--you may do
practically ANYTHING with public domain eBooks.  Redistribution is
subject to the trademark license, especially commercial
redistribution.



*** START: FULL LICENSE ***

THE FULL PROJECT GUTENBERG LICENSE
PLEASE READ THIS BEFORE YOU DISTRIBUTE OR USE THIS WORK

To protect the Project Gutenberg-tm mission of promoting the free
distribution of electronic works, by using or distributing this work
(or any other work associated in any way with the phrase "Project
Gutenberg"), you agree to comply with all the terms of the Full Project
Gutenberg-tm License (available with this file or online at
http://gutenberg.org/license).


Section 1.  General Terms of Use and Redistributing Project Gutenberg-tm
electronic works

1.A.  By reading or using any part of this Project Gutenberg-tm
electronic work, you indicate that you have read, understand, agree to
and accept all the terms of this license and intellectual property
(trademark/copyright) agreement.  If you do not agree to abide by all
the terms of this agreement, you must cease using and return or destroy
all copies of Project Gutenberg-tm electronic works in your possession.
If you paid a fee for obtaining a copy of or access to a Project
Gutenberg-tm electronic work and you do not agree to be bound by the
terms of this agreement, you may obtain a refund from the person or
entity to whom you paid the fee as set forth in paragraph 1.E.8.

1.B.  "Project Gutenberg" is a registered trademark.  It may only be
used on or associated in any way with an electronic work by people who
agree to be bound by the terms of this agreement.  There are a few
things that you can do with most Project Gutenberg-tm electronic works
even without complying with the full terms of this agreement.  See
paragraph 1.C below.  There are a lot of things you can do with Project
Gutenberg-tm electronic works if you follow the terms of this agreement
and help preserve free future access to Project Gutenberg-tm electronic
works.  See paragraph 1.E below.

1.C.  The Project Gutenberg Literary Archive Foundation ("the Foundation"
or PGLAF), owns a compilation copyright in the collection of Project
Gutenberg-tm electronic works.  Nearly all the individual works in the
collection are in the public domain in the United States.  If an
individual work is in the public domain in the United States and you are
located in the United States, we do not claim a right to prevent you from
copying, distributing, performing, displaying or creating derivative
works based on the work as long as all references to Project Gutenberg
are removed.  Of course, we hope that you will support the Project
Gutenberg-tm mission of promoting free access to electronic works by
freely sharing Project Gutenberg-tm works in compliance with the terms of
this agreement for keeping the Project Gutenberg-tm name associated with
the work.  You can easily comply with the terms of this agreement by
keeping this work in the same format with its attached full Project
Gutenberg-tm License when you share it without charge with others.

1.D.  The copyright laws of the place where you are located also govern
what you can do with this work.  Copyright laws in most countries are in
a constant state of change.  If you are outside the United States, check
the laws of your country in addition to the terms of this agreement
before downloading, copying, displaying, performing, distributing or
creating derivative works based on this work or any other Project
Gutenberg-tm work.  The Foundation makes no representations concerning
the copyright status of any work in any country outside the United
States.

1.E.  Unless you have removed all references to Project Gutenberg:

1.E.1.  The following sentence, with active links to, or other immediate
access to, the full Project Gutenberg-tm License must appear prominently
whenever any copy of a Project Gutenberg-tm work (any work on which the
phrase "Project Gutenberg" appears, or with which the phrase "Project
Gutenberg" is associated) is accessed, displayed, performed, viewed,
copied or distributed:

This eBook is for the use of anyone anywhere at no cost and with
almost no restrictions whatsoever.  You may copy it, give it away or
re-use it under the terms of the Project Gutenberg License included
with this eBook or online at www.gutenberg.org

1.E.2.  If an individual Project Gutenberg-tm electronic work is derived
from the public domain (does not contain a notice indicating that it is
posted with permission of the copyright holder), the work can be copied
and distributed to anyone in the United States without paying any fees
or charges.  If you are redistributing or providing access to a work
with the phrase "Project Gutenberg" associated with or appearing on the
work, you must comply either with the requirements of paragraphs 1.E.1
through 1.E.7 or obtain permission for the use of the work and the
Project Gutenberg-tm trademark as set forth in paragraphs 1.E.8 or
1.E.9.

1.E.3.  If an individual Project Gutenberg-tm electronic work is posted
with the permission of the copyright holder, your use and distribution
must comply with both paragraphs 1.E.1 through 1.E.7 and any additional
terms imposed by the copyright holder.  Additional terms will be linked
to the Project Gutenberg-tm License for all works posted with the
permission of the copyright holder found at the beginning of this work.

1.E.4.  Do not unlink or detach or remove the full Project Gutenberg-tm
License terms from this work, or any files containing a part of this
work or any other work associated with Project Gutenberg-tm.

1.E.5.  Do not copy, display, perform, distribute or redistribute this
electronic work, or any part of this electronic work, without
prominently displaying the sentence set forth in paragraph 1.E.1 with
active links or immediate access to the full terms of the Project
Gutenberg-tm License.

1.E.6.  You may convert to and distribute this work in any binary,
compressed, marked up, nonproprietary or proprietary form, including any
word processing or hypertext form.  However, if you provide access to or
distribute copies of a Project Gutenberg-tm work in a format other than
"Plain Vanilla ASCII" or other format used in the official version
posted on the official Project Gutenberg-tm web site (www.gutenberg.org),
you must, at no additional cost, fee or expense to the user, provide a
copy, a means of exporting a copy, or a means of obtaining a copy upon
request, of the work in its original "Plain Vanilla ASCII" or other
form.  Any alternate format must include the full Project Gutenberg-tm
License as specified in paragraph 1.E.1.

1.E.7.  Do not charge a fee for access to, viewing, displaying,
performing, copying or distributing any Project Gutenberg-tm works
unless you comply with paragraph 1.E.8 or 1.E.9.

1.E.8.  You may charge a reasonable fee for copies of or providing
access to or distributing Project Gutenberg-tm electronic works provided
that

- You pay a royalty fee of 20% of the gross profits you derive from
     the use of Project Gutenberg-tm works calculated using the method
     you already use to calculate your applicable taxes.  The fee is
     owed to the owner of the Project Gutenberg-tm trademark, but he
     has agreed to donate royalties under this paragraph to the
     Project Gutenberg Literary Archive Foundation.  Royalty payments
     must be paid within 60 days following each date on which you
     prepare (or are legally required to prepare) your periodic tax
     returns.  Royalty payments should be clearly marked as such and
     sent to the Project Gutenberg Literary Archive Foundation at the
     address specified in Section 4, "Information about donations to
     the Project Gutenberg Literary Archive Foundation."

- You provide a full refund of any money paid by a user who notifies
     you in writing (or by e-mail) within 30 days of receipt that s/he
     does not agree to the terms of the full Project Gutenberg-tm
     License.  You must require such a user to return or
     destroy all copies of the works possessed in a physical medium
     and discontinue all use of and all access to other copies of
     Project Gutenberg-tm works.

- You provide, in accordance with paragraph 1.F.3, a full refund of any
     money paid for a work or a replacement copy, if a defect in the
     electronic work is discovered and reported to you within 90 days
     of receipt of the work.

- You comply with all other terms of this agreement for free
     distribution of Project Gutenberg-tm works.

1.E.9.  If you wish to charge a fee or distribute a Project Gutenberg-tm
electronic work or group of works on different terms than are set
forth in this agreement, you must obtain permission in writing from
both the Project Gutenberg Literary Archive Foundation and Michael
Hart, the owner of the Project Gutenberg-tm trademark.  Contact the
Foundation as set forth in Section 3 below.

1.F.

1.F.1.  Project Gutenberg volunteers and employees expend considerable
effort to identify, do copyright research on, transcribe and proofread
public domain works in creating the Project Gutenberg-tm
collection.  Despite these efforts, Project Gutenberg-tm electronic
works, and the medium on which they may be stored, may contain
"Defects," such as, but not limited to, incomplete, inaccurate or
corrupt data, transcription errors, a copyright or other intellectual
property infringement, a defective or damaged disk or other medium, a
computer virus, or computer codes that damage or cannot be read by
your equipment.

1.F.2.  LIMITED WARRANTY, DISCLAIMER OF DAMAGES - Except for the "Right
of Replacement or Refund" described in paragraph 1.F.3, the Project
Gutenberg Literary Archive Foundation, the owner of the Project
Gutenberg-tm trademark, and any other party distributing a Project
Gutenberg-tm electronic work under this agreement, disclaim all
liability to you for damages, costs and expenses, including legal
fees.  YOU AGREE THAT YOU HAVE NO REMEDIES FOR NEGLIGENCE, STRICT
LIABILITY, BREACH OF WARRANTY OR BREACH OF CONTRACT EXCEPT THOSE
PROVIDED IN PARAGRAPH F3.  YOU AGREE THAT THE FOUNDATION, THE
TRADEMARK OWNER, AND ANY DISTRIBUTOR UNDER THIS AGREEMENT WILL NOT BE
LIABLE TO YOU FOR ACTUAL, DIRECT, INDIRECT, CONSEQUENTIAL, PUNITIVE OR
INCIDENTAL DAMAGES EVEN IF YOU GIVE NOTICE OF THE POSSIBILITY OF SUCH
DAMAGE.

1.F.3.  LIMITED RIGHT OF REPLACEMENT OR REFUND - If you discover a
defect in this electronic work within 90 days of receiving it, you can
receive a refund of the money (if any) you paid for it by sending a
written explanation to the person you received the work from.  If you
received the work on a physical medium, you must return the medium with
your written explanation.  The person or entity that provided you with
the defective work may elect to provide a replacement copy in lieu of a
refund.  If you received the work electronically, the person or entity
providing it to you may choose to give you a second opportunity to
receive the work electronically in lieu of a refund.  If the second copy
is also defective, you may demand a refund in writing without further
opportunities to fix the problem.

1.F.4.  Except for the limited right of replacement or refund set forth
in paragraph 1.F.3, this work is provided to you 'AS-IS', WITH NO OTHER
WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
WARRANTIES OF MERCHANTIBILITY OR FITNESS FOR ANY PURPOSE.

1.F.5.  Some states do not allow disclaimers of certain implied
warranties or the exclusion or limitation of certain types of damages.
If any disclaimer or limitation set forth in this agreement violates the
law of the state applicable to this agreement, the agreement shall be
interpreted to make the maximum disclaimer or limitation permitted by
the applicable state law.  The invalidity or unenforceability of any
provision of this agreement shall not void the remaining provisions.

1.F.6.  INDEMNITY - You agree to indemnify and hold the Foundation, the
trademark owner, any agent or employee of the Foundation, anyone
providing copies of Project Gutenberg-tm electronic works in accordance
with this agreement, and any volunteers associated with the production,
promotion and distribution of Project Gutenberg-tm electronic works,
harmless from all liability, costs and expenses, including legal fees,
that arise directly or indirectly from any of the following which you do
or cause to occur: (a) distribution of this or any Project Gutenberg-tm
work, (b) alteration, modification, or additions or deletions to any
Project Gutenberg-tm work, and (c) any Defect you cause.


Section  2.  Information about the Mission of Project Gutenberg-tm

Project Gutenberg-tm is synonymous with the free distribution of
electronic works in formats readable by the widest variety of computers
including obsolete, old, middle-aged and new computers.  It exists
because of the efforts of hundreds of volunteers and donations from
people in all walks of life.

Volunteers and financial support to provide volunteers with the
assistance they need, is critical to reaching Project Gutenberg-tm's
goals and ensuring that the Project Gutenberg-tm collection will
remain freely available for generations to come.  In 2001, the Project
Gutenberg Literary Archive Foundation was created to provide a secure
and permanent future for Project Gutenberg-tm and future generations.
To learn more about the Project Gutenberg Literary Archive Foundation
and how your efforts and donations can help, see Sections 3 and 4
and the Foundation web page at http://www.pglaf.org.


Section 3.  Information about the Project Gutenberg Literary Archive
Foundation

The Project Gutenberg Literary Archive Foundation is a non profit
501(c)(3) educational corporation organized under the laws of the
state of Mississippi and granted tax exempt status by the Internal
Revenue Service.  The Foundation's EIN or federal tax identification
number is 64-6221541.  Its 501(c)(3) letter is posted at
http://pglaf.org/fundraising.  Contributions to the Project Gutenberg
Literary Archive Foundation are tax deductible to the full extent
permitted by U.S. federal laws and your state's laws.

The Foundation's principal office is located at 4557 Melan Dr. S.
Fairbanks, AK, 99712., but its volunteers and employees are scattered
throughout numerous locations.  Its business office is located at
809 North 1500 West, Salt Lake City, UT 84116, (801) 596-1887, email
business@pglaf.org.  Email contact links and up to date contact
information can be found at the Foundation's web site and official
page at http://pglaf.org

For additional contact information:
     Dr. Gregory B. Newby
     Chief Executive and Director
     gbnewby@pglaf.org

Section 4.  Information about Donations to the Project Gutenberg
Literary Archive Foundation

Project Gutenberg-tm depends upon and cannot survive without wide
spread public support and donations to carry out its mission of
increasing the number of public domain and licensed works that can be
freely distributed in machine readable form accessible by the widest
array of equipment including outdated equipment.  Many small donations
($1 to $5,000) are particularly important to maintaining tax exempt
status with the IRS.

The Foundation is committed to complying with the laws regulating
charities and charitable donations in all 50 states of the United
States.  Compliance requirements are not uniform and it takes a
considerable effort, much paperwork and many fees to meet and keep up
with these requirements.  We do not solicit donations in locations
where we have not received written confirmation of compliance.  To
SEND DONATIONS or determine the status of compliance for any
particular state visit http://pglaf.org

While we cannot and do not solicit contributions from states where we
have not met the solicitation requirements, we know of no prohibition
against accepting unsolicited donations from donors in such states who
approach us with offers to donate.

International donations are gratefully accepted, but we cannot make
any statements concerning tax treatment of donations received from
outside the United States.  U.S. laws alone swamp our small staff.

Please check the Project Gutenberg Web pages for current donation
methods and addresses.  Donations are accepted in a number of other
ways including checks, online payments and credit card donations.
To donate, please visit: http://pglaf.org/donate


Section 5.  General Information About Project Gutenberg-tm electronic
works.

Professor Michael S. Hart is the originator of the Project Gutenberg-tm
concept of a library of electronic works that could be freely shared
with anyone.  For thirty years, he produced and distributed Project
Gutenberg-tm eBooks with only a loose network of volunteer support.

Project Gutenberg-tm eBooks are often created from several printed
editions, all of which are confirmed as Public Domain in the U.S.
unless a copyright notice is included.  Thus, we do not necessarily
keep eBooks in compliance with any particular paper edition.

Most people start at our Web site which has the main PG search facility:

     http://www.gutenberg.org

This Web site includes information about Project Gutenberg-tm,
including how to make donations to the Project Gutenberg Literary
Archive Foundation, how to help produce our new eBooks, and how to
subscribe to our email newsletter to hear about new eBooks.

*** END: FULL LICENSE ***

The Project Gutenberg EBook of War and Peace, by Leo Tolstoy
(#9 in our series by Leo Tolstoy)

Copyright laws are changing all over the world. Be sure to check the
copyright laws for your country before downloading or redistributing
this or any other Project Gutenberg eBook.

This header should be the first thing seen when viewing this Project
Gutenberg file.  Please do not remove it.  Do not change or edit the
header without written permission.

Please read the "legal small print," and other information about the
eBook and Project Gutenberg at the bottom of this file.  Included is
important information about your specific rights and restrictions in
how the file may be used.  You can also find out about how to make a
donation to Project Gutenberg, and how to get involved.


**Welcome To The World of Free Plain Vanilla Electronic Texts**

**eBooks Readable By Both Humans and By Computers, Since 1971**

*****These eBooks Were Prepared By Thousands of Volunteers!*****


Title: War and Peace

Author: Leo Tolstoy

Translator: Louise and Aylmer Maude

Release Date: April, 2001  [EBook #2600]
[This file was first posted on October 7, 2003]
[Most recently updated: May 21, 2006]

Edition: 11

Language: English

Character set encoding: US-ASCII

*** START OF THE PROJECT GUTENBERG EBOOK, WAR AND PEACE ***










War and Peace

by Leo Tolstoy/Tolstoi




BOOK ONE: 1805




CHAPTER I


"Well, Prince, so Genoa and Lucca are now just family estates of the
Buonapartes. But I warn you, if you don't tell me that this means war,
if you still try to defend the infamies and horrors perpetrated by
that Antichrist--I really believe he is Antichrist--I will have
nothing more to do with you and you are no longer my friend, no longer
my 'faithful slave,' as you call yourself! But how do you do? I see
I have frightened you--sit down and tell me all the news."

It was in July, 1805, and the speaker was the well-known Anna
Pavlovna Scherer, maid of honor and favorite of the Empress Marya
Fedorovna. With these words she greeted Prince Vasili Kuragin, a man
of high rank and importance, who was the first to arrive at her
reception. Anna Pavlovna had had a cough for some days. She was, as
she said, suffering from la grippe; grippe being then a new word in
St. Petersburg, used only by the elite.

All her invitations without exception, written in French, and
delivered by a scarlet-liveried footman that morning, ran as follows:

"If you have nothing better to do, Count [or Prince], and if the
prospect of spending an evening with a poor invalid is not too
terrible, I shall be very charmed to see you tonight between 7 and 10-
Annette Scherer."

"Heavens! what a virulent attack!" replied the prince, not in the
least disconcerted by this reception. He had just entered, wearing
an embroidered court uniform, knee breeches, and shoes, and had
stars on his breast and a serene expression on his flat face. He spoke
in that refined French in which our grandfathers not only spoke but
thought, and with the gentle, patronizing intonation natural to a
man of importance who had grown old in society and at court. He went
up to Anna Pavlovna, kissed her hand, presenting to her his bald,
scented, and shining head, and complacently seated himself on the
sofa.

"First of all, dear friend, tell me how you are. Set your friend's
mind at rest," said he without altering his tone, beneath the
politeness and affected sympathy of which indifference and even
irony could be discerned.

"Can one be well while suffering morally? Can one be calm in times
like these if one has any feeling?" said Anna Pavlovna. "You are
staying the whole evening, I hope?"

"And the fete at the English ambassador's? Today is Wednesday. I
must put in an appearance there," said the prince. "My daughter is
coming for me to take me there."

"I thought today's fete had been canceled. I confess all these
festivities and fireworks are becoming wearisome."

"If they had known that you wished it, the entertainment would
have been put off," said the prince, who, like a wound-up clock, by
force of habit said things he did not even wish to be believed.

"Don't tease! Well, and what has been decided about Novosiltsev's
dispatch? You know everything."

"What can one say about it?" replied the prince in a cold,
listless tone. "What has been decided? They have decided that
Buonaparte has burnt his boats, and I believe that we are ready to
burn ours."

Prince Vasili always spoke languidly, like an actor repeating a
stale part. Anna Pavlovna Scherer on the contrary, despite her forty
years, overflowed with animation and impulsiveness. To be an
enthusiast had become her social vocation and, sometimes even when she
did not feel like it, she became enthusiastic in order not to
disappoint the expectations of those who knew her. The subdued smile
which, though it did not suit her faded features, always played
round her lips expressed, as in a spoiled child, a continual
consciousness of her charming defect, which she neither wished, nor
could, nor considered it necessary, to correct.

In the midst of a conversation on political matters Anna Pavlovna
burst out:

"Oh, don't speak to me of Austria. Perhaps I don't understand
things, but Austria never has wished, and does not wish, for war.
She is betraying us! Russia alone must save Europe. Our gracious
sovereign recognizes his high vocation and will be true to it. That is
the one thing I have faith in! Our good and wonderful sovereign has to
perform the noblest role on earth, and he is so virtuous and noble
that God will not forsake him. He will fulfill his vocation and
crush the hydra of revolution, which has become more terrible than
ever in the person of this murderer and villain! We alone must
avenge the blood of the just one.... Whom, I ask you, can we rely
on?... England with her commercial spirit will not and cannot
understand the Emperor Alexander's loftiness of soul. She has
refused to evacuate Malta. She wanted to find, and still seeks, some
secret motive in our actions. What answer did Novosiltsev get? None.
The English have not understood and cannot understand the
self-abnegation of our Emperor who wants nothing for himself, but only
desires the good of mankind. And what have they promised? Nothing! And
what little they have promised they will not perform! Prussia has
always declared that Buonaparte is invincible, and that all Europe
is powerless before him.... And I don't believe a word that Hardenburg
says, or Haugwitz either. This famous Prussian neutrality is just a
trap. I have faith only in God and the lofty destiny of our adored
monarch. He will save Europe!"

She suddenly paused, smiling at her own impetuosity.

"I think," said the prince with a smile, "that if you had been
sent instead of our dear Wintzingerode you would have captured the
King of Prussia's consent by assault. You are so eloquent. Will you
give me a cup of tea?"

"In a moment. A propos," she added, becoming calm again, "I am
expecting two very interesting men tonight, le Vicomte de Mortemart,
who is connected with the Montmorencys through the Rohans, one of
the best French families. He is one of the genuine emigres, the good
ones. And also the Abbe Morio. Do you know that profound thinker? He
has been received by the Emperor. Had you heard?"

"I shall be delighted to meet them," said the prince. "But tell me,"
he added with studied carelessness as if it had only just occurred
to him, though the question he was about to ask was the chief motive
of his visit, "is it true that the Dowager Empress wants Baron Funke
to be appointed first secretary at Vienna? The baron by all accounts
is a poor creature."

Prince Vasili wished to obtain this post for his son, but others
were trying through the Dowager Empress Marya Fedorovna to secure it
for the baron.

Anna Pavlovna almost closed her eyes to indicate that neither she
nor anyone else had a right to criticize what the Empress desired or
was pleased with.

"Baron Funke has been recommended to the Dowager Empress by her
sister," was all she said, in a dry and mournful tone.

As she named the Empress, Anna Pavlovna's face suddenly assumed an
expression of profound and sincere devotion and respect mingled with
sadness, and this occurred every time she mentioned her illustrious
patroness. She added that Her Majesty had deigned to show Baron
Funke beaucoup d'estime, and again her face clouded over with sadness.

The prince was silent and looked indifferent. But, with the
womanly and courtierlike quickness and tact habitual to her, Anna
Pavlovna wished both to rebuke him (for daring to speak he had done of
a man recommended to the Empress) and at the same time to console him,
so she said:

"Now about your family. Do you know that since your daughter came
out everyone has been enraptured by her? They say she is amazingly
beautiful."

The prince bowed to signify his respect and gratitude.

"I often think," she continued after a short pause, drawing nearer
to the prince and smiling amiably at him as if to show that
political and social topics were ended and the time had come for
intimate conversation--"I often think how unfairly sometimes the
joys of life are distributed. Why has fate given you two such splendid
children? I don't speak of Anatole, your youngest. I don't like
him," she added in a tone admitting of no rejoinder and raising her
eyebrows. "Two such charming children. And really you appreciate
them less than anyone, and so you don't deserve to have them."

And she smiled her ecstatic smile.

"I can't help it," said the prince. "Lavater would have said I
lack the bump of paternity."

"Don't joke; I mean to have a serious talk with you. Do you know I
am dissatisfied with your younger son? Between ourselves" (and her
face assumed its melancholy expression), "he was mentioned at Her
Majesty's and you were pitied...."

The prince answered nothing, but she looked at him significantly,
awaiting a reply. He frowned.

"What would you have me do?" he said at last. "You know I did all
a father could for their education, and they have both turned out
fools. Hippolyte is at least a quiet fool, but Anatole is an active
one. That is the only difference between them." He said this smiling
in a way more natural and animated than usual, so that the wrinkles
round his mouth very clearly revealed something unexpectedly coarse
and unpleasant.

"And why are children born to such men as you? If you were not a
father there would be nothing I could reproach you with," said Anna
Pavlovna, looking up pensively.

"I am your faithful slave and to you alone I can confess that my
children are the bane of my life. It is the cross I have to bear. That
is how I explain it to myself. It can't be helped!"

He said no more, but expressed his resignation to cruel fate by a
gesture. Anna Pavlovna meditated.

"Have you never thought of marrying your prodigal son Anatole?"
she asked. "They say old maids have a mania for matchmaking, and
though I don't feel that weakness in myself as yet, I know a little
person who is very unhappy with her father. She is a relation of
yours, Princess Mary Bolkonskaya."

Prince Vasili did not reply, though, with the quickness of memory
and perception befitting a man of the world, he indicated by a
movement of the head that he was considering this information.

"Do you know," he said at last, evidently unable to check the sad
current of his thoughts, "that Anatole is costing me forty thousand
rubles a year? And," he went on after a pause, "what will it be in
five years, if he goes on like this?" Presently he added: "That's what
we fathers have to put up with.... Is this princess of yours rich?"

"Her father is very rich and stingy. He lives in the country. He
is the well-known Prince Bolkonski who had to retire from the army
under the late Emperor, and was nicknamed 'the King of Prussia.' He is
very clever but eccentric, and a bore. The poor girl is very
unhappy. She has a brother; I think you know him, he married Lise
Meinen lately. He is an aide-de-camp of Kutuzov's and will be here
tonight."

"Listen, dear Annette," said the prince, suddenly taking Anna
Pavlovna's hand and for some reason drawing it downwards. "Arrange
that affair for me and I shall always be your most devoted slave-
slafe with an f, as a village elder of mine writes in his reports.
She is rich and of good family and that's all I want."

And with the familiarity and easy grace peculiar to him, he raised
the maid of honor's hand to his lips, kissed it, and swung it to and
fro as he lay back in his armchair, looking in another direction.

"Attendez," said Anna Pavlovna, reflecting, "I'll speak to Lise,
young Bolkonski's wife, this very evening, and perhaps the thing can
be arranged. It shall be on your family's behalf that I'll start my
apprenticeship as old maid."





CHAPTER II


Anna Pavlovna's drawing room was gradually filling. The highest
Petersburg society was assembled there: people differing widely in age
and character but alike in the social circle to which they belonged.
Prince Vasili's daughter, the beautiful Helene, came to take her
father to the ambassador's entertainment; she wore a ball dress and
her badge as maid of honor. The youthful little Princess
Bolkonskaya, known as la femme la plus seduisante de Petersbourg,* was
also there. She had been married during the previous winter, and being
pregnant did not go to any large gatherings, but only to small
receptions. Prince Vasili's son, Hippolyte, had come with Mortemart,
whom he introduced. The Abbe Morio and many others had also come.


*The most fascinating woman in Petersburg.


To each new arrival Anna Pavlovna said, "You have not yet seen my
aunt," or "You do not know my aunt?" and very gravely conducted him or
her to a little old lady, wearing large bows of ribbon in her cap, who
had come sailing in from another room as soon as the guests began to
arrive; and slowly turning her eyes from the visitor to her aunt, Anna
Pavlovna mentioned each one's name and then left them.

Each visitor performed the ceremony of greeting this old aunt whom
not one of them knew, not one of them wanted to know, and not one of
them cared about; Anna Pavlovna observed these greetings with mournful
and solemn interest and silent approval. The aunt spoke to each of
them in the same words, about their health and her own, and the health
of Her Majesty, "who, thank God, was better today." And each
visitor, though politeness prevented his showing impatience, left
the old woman with a sense of relief at having performed a vexatious
duty and did not return to her the whole evening.

The young Princess Bolkonskaya had brought some work in a
gold-embroidered velvet bag. Her pretty little upper lip, on which a
delicate dark down was just perceptible, was too short for her
teeth, but it lifted all the more sweetly, and was especially charming
when she occasionally drew it down to meet the lower lip. As is always
the case with a thoroughly attractive woman, her defect--the shortness
of her upper lip and her half-open mouth--seemed to be her own special
and peculiar form of beauty. Everyone brightened at the sight of
this pretty young woman, so soon to become a mother, so full of life
and health, and carrying her burden so lightly. Old men and dull
dispirited young ones who looked at her, after being in her company
and talking to her a little while, felt as if they too were
becoming, like her, full of life and health. All who talked to her,
and at each word saw her bright smile and the constant gleam of her
white teeth, thought that they were in a specially amiable mood that
day.

The little princess went round the table with quick, short,
swaying steps, her workbag on her arm, and gaily spreading out her
dress sat down on a sofa near the silver samovar, as if all she was
doing was a pleasure to herself and to all around her. "I have brought
my work," said she in French, displaying her bag and addressing all
present. "Mind, Annette, I hope you have not played a wicked trick
on me," she added, turning to her hostess. "You wrote that it was to
be quite a small reception, and just see how badly I am dressed."
And she spread out her arms to show her short-waisted, lace-trimmed,
dainty gray dress, girdled with a broad ribbon just below the breast.

"Soyez tranquille, Lise, you will always be prettier than anyone
else," replied Anna Pavlovna.

"You know," said the princess in the same tone of voice and still in
French, turning to a general, "my husband is deserting me? He is going
to get himself killed. Tell me what this wretched war is for?" she
added, addressing Prince Vasili, and without waiting for an answer she
turned to speak to his daughter, the beautiful Helene.

"What a delightful woman this little princess is!" said Prince
Vasili to Anna Pavlovna.

One of the next arrivals was a stout, heavily built young man with
close-cropped hair, spectacles, the light-colored breeches fashionable
at that time, a very high ruffle, and a brown dress coat. This stout
young man was an illegitimate son of Count Bezukhov, a well-known
grandee of Catherine's time who now lay dying in Moscow. The young man
had not yet entered either the military or civil service, as he had
only just returned from abroad where he had been educated, and this
was his first appearance in society. Anna Pavlovna greeted him with
the nod she accorded to the lowest hierarchy in her drawing room.
But in spite of this lowest-grade greeting, a look of anxiety and
fear, as at the sight of something too large and unsuited to the
place, came over her face when she saw Pierre enter. Though he was
certainly rather bigger than the other men in the room, her anxiety
could only have reference to the clever though shy, but observant
and natural, expression which distinguished him from everyone else
in that drawing room.

"It is very good of you, Monsieur Pierre, to come and visit a poor
invalid," said Anna Pavlovna, exchanging an alarmed glance with her
aunt as she conducted him to her.

Pierre murmured something unintelligible, and continued to look
round as if in search of something. On his way to the aunt he bowed to
the little princess with a pleased smile, as to an intimate
acquaintance.

Anna Pavlovna's alarm was justified, for Pierre turned away from the
aunt without waiting to hear her speech about Her Majesty's health.
Anna Pavlovna in dismay detained him with the words: "Do you know
the Abbe Morio? He is a most interesting man."

"Yes, I have heard of his scheme for perpetual peace, and it is very
interesting but hardly feasible."

"You think so?" rejoined Anna Pavlovna in order to say something and
get away to attend to her duties as hostess. But Pierre now
committed a reverse act of impoliteness. First he had left a lady
before she had finished speaking to him, and now he continued to speak
to another who wished to get away. With his head bent, and his big
feet spread apart, he began explaining his reasons for thinking the
abbe's plan chimerical.

"We will talk of it later," said Anna Pavlovna with a smile.

And having got rid of this young man who did not know how to behave,
she resumed her duties as hostess and continued to listen and watch,
ready to help at any point where the conversation might happen to
flag. As the foreman of a spinning mill, when he has set the hands
to work, goes round and notices here a spindle that has stopped or
there one that creaks or makes more noise than it should, and
hastens to check the machine or set it in proper motion, so Anna
Pavlovna moved about her drawing room, approaching now a silent, now a
too-noisy group, and by a word or slight rearrangement kept the
conversational machine in steady, proper, and regular motion. But amid
these cares her anxiety about Pierre was evident. She kept an
anxious watch on him when he approached the group round Mortemart to
listen to what was being said there, and again when he passed to
another group whose center was the abbe.

Pierre had been educated abroad, and this reception at Anna
Pavlovna's was the first he had attended in Russia. He knew that all
the intellectual lights of Petersburg were gathered there and, like
a child in a toyshop, did not know which way to look, afraid of
missing any clever conversation that was to be heard. Seeing the
self-confident and refined expression on the faces of those present he
was always expecting to hear something very profound. At last he
came up to Morio. Here the conversation seemed interesting and he
stood waiting for an opportunity to express his own views, as young
people are fond of doing.




CHAPTER III


Anna Pavlovna's reception was in full swing. The spindles hummed
steadily and ceaselessly on all sides. With the exception of the aunt,
beside whom sat only one elderly lady, who with her thin careworn face
was rather out of place in this brilliant society, the whole company
had settled into three groups. One, chiefly masculine, had formed
round the abbe. Another, of young people, was grouped round the
beautiful Princess Helene, Prince Vasili's daughter, and the little
Princess Bolkonskaya, very pretty and rosy, though rather too plump
for her age. The third group was gathered round Mortemart and Anna
Pavlovna.

The vicomte was a nice-looking young man with soft features and
polished manners, who evidently considered himself a celebrity but out
of politeness modestly placed himself at the disposal of the circle in
which he found himself. Anna Pavlovna was obviously serving him up
as a treat to her guests. As a clever maitre d'hotel serves up as a
specially choice delicacy a piece of meat that no one who had seen
it in the kitchen would have cared to eat, so Anna Pavlovna served
up to her guests, first the vicomte and then the abbe, as peculiarly
choice morsels. The group about Mortemart immediately began discussing
the murder of the Duc d'Enghien. The vicomte said that the Duc
d'Enghien had perished by his own magnanimity, and that there were
particular reasons for Buonaparte's hatred of him.

"Ah, yes! Do tell us all about it, Vicomte," said Anna Pavlovna,
with a pleasant feeling that there was something a la Louis XV in
the sound of that sentence: "Contez nous cela, Vicomte."

The vicomte bowed and smiled courteously in token of his willingness
to comply. Anna Pavlovna arranged a group round him, inviting everyone
to listen to his tale.

"The vicomte knew the duc personally," whispered Anna Pavlovna to of
the guests. "The vicomte is a wonderful raconteur," said she to
another. "How evidently he belongs to the best society," said she to a
third; and the vicomte was served up to the company in the choicest
and most advantageous style, like a well-garnished joint of roast beef
on a hot dish.

The vicomte wished to begin his story and gave a subtle smile.

"Come over here, Helene, dear," said Anna Pavlovna to the
beautiful young princess who was sitting some way off, the center of
another group.

The princess smiled. She rose with the same unchanging smile with
which she had first entered the room--the smile of a perfectly
beautiful woman. With a slight rustle of her white dress trimmed
with moss and ivy, with a gleam of white shoulders, glossy hair, and
sparkling diamonds, she passed between the men who made way for her,
not looking at any of them but smiling on all, as if graciously
allowing each the privilege of admiring her beautiful figure and
shapely shoulders, back, and bosom--which in the fashion of those days
were very much exposed--and she seemed to bring the glamour of a
ballroom with her as she moved toward Anna Pavlovna. Helene was so
lovely that not only did she not show any trace of coquetry, but on
the contrary she even appeared shy of her unquestionable and all too
victorious beauty. She seemed to wish, but to be unable, to diminish
its effect.

"How lovely!" said everyone who saw her; and the vicomte lifted
his shoulders and dropped his eyes as if startled by something
extraordinary when she took her seat opposite and beamed upon him also
with her unchanging smile.

"Madame, I doubt my ability before such an audience," said he,
smilingly inclining his head.

The princess rested her bare round arm on a little table and
considered a reply unnecessary. She smilingly waited. All the time the
story was being told she sat upright, glancing now at her beautiful
round arm, altered in shape by its pressure on the table, now at her
still more beautiful bosom, on which she readjusted a diamond
necklace. From time to time she smoothed the folds of her dress, and
whenever the story produced an effect she glanced at Anna Pavlovna, at
once adopted just the expression she saw on the maid of honor's
face, and again relapsed into her radiant smile.

The little princess had also left the tea table and followed Helene.

"Wait a moment, I'll get my work.... Now then, what are you thinking
of?" she went on, turning to Prince Hippolyte. "Fetch me my workbag."

There was a general movement as the princess, smiling and talking
merrily to everyone at once, sat down and gaily arranged herself in
her seat.

"Now I am all right," she said, and asking the vicomte to begin, she
took up her work.

Prince Hippolyte, having brought the workbag, joined the circle
and moving a chair close to hers seated himself beside her.

Le charmant Hippolyte was surprising by his extraordinary
resemblance to his beautiful sister, but yet more by the fact that
in spite of this resemblance he was exceedingly ugly. His features
were like his sister's, but while in her case everything was lit up by
a joyous, self-satisfied, youthful, and constant smile of animation,
and by the wonderful classic beauty of her figure, his face on the
contrary was dulled by imbecility and a constant expression of
sullen self-confidence, while his body was thin and weak. His eyes,
nose, and mouth all seemed puckered into a vacant, wearied grimace,
and his arms and legs always fell into unnatural positions.

"It's not going to be a ghost story?" said he, sitting down beside
the princess and hastily adjusting his lorgnette, as if without this
instrument he could not begin to speak.

"Why no, my dear fellow," said the astonished narrator, shrugging
his shoulders.

"Because I hate ghost stories," said Prince Hippolyte in a tone
which showed that he only understood the meaning of his words after he
had uttered them.

He spoke with such self-confidence that his hearers could not be
sure whether what he said was very witty or very stupid. He was
dressed in a dark-green dress coat, knee breeches of the color of
cuisse de nymphe effrayee, as he called it, shoes, and silk stockings.

The vicomte told his tale very neatly. It was an anecdote, then
current, to the effect that the Duc d'Enghien had gone secretly to
Paris to visit Mademoiselle George; that at her house he came upon
Bonaparte, who also enjoyed the famous actress' favors, and that in
his presence Napoleon happened to fall into one of the fainting fits
to which he was subject, and was thus at the duc's mercy. The latter
spared him, and this magnanimity Bonaparte subsequently repaid by
death.

The story was very pretty and interesting, especially at the point
where the rivals suddenly recognized one another; and the ladies
looked agitated.

"Charming!" said Anna Pavlovna with an inquiring glance at the
little princess.

"Charming!" whispered the little princess, sticking the needle
into her work as if to testify that the interest and fascination of
the story prevented her from going on with it.

The vicomte appreciated this silent praise and smiling gratefully
prepared to continue, but just then Anna Pavlovna, who had kept a
watchful eye on the young man who so alarmed her, noticed that he
was talking too loudly and vehemently with the abbe, so she hurried to
the rescue. Pierre had managed to start a conversation with the abbe
about the balance of power, and the latter, evidently interested by
the young man's simple-minded eagerness, was explaining his pet
theory. Both were talking and listening too eagerly and too naturally,
which was why Anna Pavlovna disapproved.

"The means are... the balance of power in Europe and the rights of
the people," the abbe was saying. "It is only necessary for one
powerful nation like Russia--barbaric as she is said to be--to place
herself disinterestedly at the head of an alliance having for its
object the maintenance of the balance of power of Europe, and it would
save the world!"

"But how are you to get that balance?" Pierre was beginning.

At that moment Anna Pavlovna came up and, looking severely at
Pierre, asked the Italian how he stood Russian climate. The
Italian's face instantly changed and assumed an offensively
affected, sugary expression, evidently habitual to him when conversing
with women.

"I am so enchanted by the brilliancy of the wit and culture of the
society, more especially of the feminine society, in which I have
had the honor of being received, that I have not yet had time to think
of the climate," said he.

Not letting the abbe and Pierre escape, Anna Pavlovna, the more
conveniently to keep them under observation, brought them into the
larger circle.





CHAPTER IV


Just then another visitor entered the drawing room: Prince Andrew
Bolkonski, the little princess' husband. He was a very handsome
young man, of medium height, with firm, clearcut features.
Everything about him, from his weary, bored expression to his quiet,
measured step, offered a most striking contrast to his quiet, little
wife. It was evident that he not only knew everyone in the drawing
room, but had found them to be so tiresome that it wearied him to look
at or listen to them. And among all these faces that he found so
tedious, none seemed to bore him so much as that of his pretty wife.
He turned away from her with a grimace that distorted his handsome
face, kissed Anna Pavlovna's hand, and screwing up his eyes scanned
the whole company.

"You are off to the war, Prince?" said Anna Pavlovna.

"General Kutuzov," said Bolkonski, speaking French and stressing the
last syllable of the general's name like a Frenchman, "has been
pleased to take me as an aide-de-camp...."

"And Lise, your wife?"

"She will go to the country."

"Are you not ashamed to deprive us of your charming wife?"

"Andre," said his wife, addressing her husband in the same
coquettish manner in which she spoke to other men, "the vicomte has
been telling us such a tale about Mademoiselle George and Buonaparte!"

Prince Andrew screwed up his eyes and turned away. Pierre, who
from the moment Prince Andrew entered the room had watched him with
glad, affectionate eyes, now came up and took his arm. Before he
looked round Prince Andrew frowned again, expressing his annoyance
with whoever was touching his arm, but when he saw Pierre's beaming
face he gave him an unexpectedly kind and pleasant smile.

"There now!... So you, too, are in the great world?" said he to
Pierre.

"I knew you would be here," replied Pierre. "I will come to supper
with you. May I?" he added in a low voice so as not to disturb the
vicomte who was continuing his story.

"No, impossible!" said Prince Andrew, laughing and pressing Pierre's
hand to show that there was no need to ask the question. He wished
to say something more, but at that moment Prince Vasili and his
daughter got up to go and the two young men rose to let them pass.

"You must excuse me, dear Vicomte," said Prince Vasili to the
Frenchman, holding him down by the sleeve in a friendly way to prevent
his rising. "This unfortunate fete at the ambassador's deprives me
of a pleasure, and obliges me to interrupt you. I am very sorry to
leave your enchanting party," said he, turning to Anna Pavlovna.

His daughter, Princess Helene, passed between the chairs, lightly
holding up the folds of her dress, and the smile shone still more
radiantly on her beautiful face. Pierre gazed at her with rapturous,
almost frightened, eyes as she passed him.

"Very lovely," said Prince Andrew.

"Very," said Pierre.

In passing Prince Vasili seized Pierre's hand and said to Anna
Pavlovna: "Educate this bear for me! He has been staying with me a
whole month and this is the first time I have seen him in society.
Nothing is so necessary for a young man as the society of clever
women."


Anna Pavlovna smiled and promised to take Pierre in hand. She knew
his father to be a connection of Prince Vasili's. The elderly lady who
had been sitting with the old aunt rose hurriedly and overtook
Prince Vasili in the anteroom. All the affectation of interest she had
assumed had left her kindly and tearworn face and it now expressed
only anxiety and fear.

"How about my son Boris, Prince?" said she, hurrying after him
into the anteroom. "I can't remain any longer in Petersburg. Tell me
what news I may take back to my poor boy."


Although Prince Vasili listened reluctantly and not very politely to
the elderly lady, even betraying some impatience, she gave him an
ingratiating and appealing smile, and took his hand that he might
not go away.

"What would it cost you to say a word to the Emperor, and then he
would be transferred to the Guards at once?" said she.

"Believe me, Princess, I am ready to do all I can," answered
Prince Vasili, "but it is difficult for me to ask the Emperor. I
should advise you to appeal to Rumyantsev through Prince Golitsyn.
That would be the best way."

The elderly lady was a Princess Drubetskaya, belonging to one of the
best families in Russia, but she was poor, and having long been out of
society had lost her former influential connections. She had now
come to Petersburg to procure an appointment in the Guards for her
only son. It was, in fact, solely to meet Prince Vasili that she had
obtained an invitation to Anna Pavlovna's reception and had sat
listening to the vicomte's story. Prince Vasili's words frightened
her, an embittered look clouded her once handsome face, but only for a
moment; then she smiled again and clutched Prince Vasili's arm more
tightly.

"Listen to me, Prince," said she. "I have never yet asked you for
anything and I never will again, nor have I ever reminded you of my
father's friendship for you; but now I entreat you for God's sake to
do this for my son--and I shall always regard you as a benefactor,"
she added hurriedly. "No, don't be angry, but promise! I have asked
Golitsyn and he has refused. Be the kindhearted man you always
were," she said, trying to smile though tears were in her eyes.

"Papa, we shall be late," said Princess Helene, turning her
beautiful head and looking over her classically molded shoulder as she
stood waiting by the door.

Influence in society, however, is a capital which has to be
economized if it is to last. Prince Vasili knew this, and having
once realized that if he asked on behalf of all who begged of him,
he would soon be unable to ask for himself, he became chary of using
his influence. But in Princess Drubetskaya's case he felt, after her
second appeal, something like qualms of conscience. She had reminded
him of what was quite true; he had been indebted to her father for the
first steps in his career. Moreover, he could see by her manners
that she was one of those women--mostly mothers--who, having once made
up their minds, will not rest until they have gained their end, and
are prepared if necessary to go on insisting day after day and hour
after hour, and even to make scenes. This last consideration moved
him.

"My dear Anna Mikhaylovna," said he with his usual familiarity and
weariness of tone, "it is almost impossible for me to do what you ask;
but to prove my devotion to you and how I respect your father's
memory, I will do the impossible--your son shall be transferred to the
Guards. Here is my hand on it. Are you satisfied?"

"My dear benefactor! This is what I expected from you--I knew your
kindness!" He turned to go.

"Wait--just a word! When he has been transferred to the Guards..."
she faltered. "You are on good terms with Michael Ilarionovich
Kutuzov... recommend Boris to him as adjutant! Then I shall be at
rest, and then..."

Prince Vasili smiled.

"No, I won't promise that. You don't know how Kutuzov is pestered
since his appointment as Commander in Chief. He told me himself that
all the Moscow ladies have conspired to give him all their sons as
adjutants."

"No, but do promise! I won't let you go! My dear benefactor..."

"Papa," said his beautiful daughter in the same tone as before,
"we shall be late."

"Well, au revoir! Good-by! You hear her?"

"Then tomorrow you will speak to the Emperor?"

"Certainly; but about Kutuzov, I don't promise."

"Do promise, do promise, Vasili!" cried Anna Mikhaylovna as he went,
with the smile of a coquettish girl, which at one time probably came
naturally to her, but was now very ill-suited to her careworn face.

Apparently she had forgotten her age and by force of habit
employed all the old feminine arts. But as soon as the prince had gone
her face resumed its former cold, artificial expression. She
returned to the group where the vicomte was still talking, and again
pretended to listen, while waiting till it would be time to leave. Her
task was accomplished.





CHAPTER V


"And what do you think of this latest comedy, the coronation at
Milan?" asked Anna Pavlovna, "and of the comedy of the people of Genoa
and Lucca laying their petitions before Monsieur Buonaparte, and
Monsieur Buonaparte sitting on a throne and granting the petitions
of the nations? Adorable! It is enough to make one's head whirl! It is
as if the whole world had gone crazy."

Prince Andrew looked Anna Pavlovna straight in the face with a
sarcastic smile.

"'Dieu me la donne, gare a qui la touche!'* They say he was very
fine when he said that," he remarked, repeating the words in
Italian: "'Dio mi l'ha dato. Guai a chi la tocchi!'"


*God has given it to me, let him who touches it beware!


"I hope this will prove the last drop that will make the glass run
over," Anna Pavlovna continued. "The sovereigns will not be able to
endure this man who is a menace to everything."

"The sovereigns? I do not speak of Russia," said the vicomte, polite
but hopeless: "The sovereigns, madame... What have they done for Louis
XVII, for the Queen, or for Madame Elizabeth? Nothing!" and he
became more animated. "And believe me, they are reaping the reward
of their betrayal of the Bourbon cause. The sovereigns! Why, they
are sending ambassadors to compliment the usurper."

And sighing disdainfully, he again changed his position.

Prince Hippolyte, who had been gazing at the vicomte for some time
through his lorgnette, suddenly turned completely round toward the
little princess, and having asked for a needle began tracing the Conde
coat of arms on the table. He explained this to her with as much
gravity as if she had asked him to do it.

"Baton de gueules, engrele de gueules d' azur--maison Conde," said
he.

The princess listened, smiling.

"If Buonaparte remains on the throne of France a year longer," the
vicomte continued, with the air of a man who, in a matter with which
he is better acquainted than anyone else, does not listen to others
but follows the current of his own thoughts, "things will have gone
too far. By intrigues, violence, exile, and executions, French
society--I mean good French society--will have been forever destroyed,
and then..."

He shrugged his shoulders and spread out his hands. Pierre wished to
make a remark, for the conversation interested him, but Anna Pavlovna,
who had him under observation, interrupted:

"The Emperor Alexander," said she, with the melancholy which
always accompanied any reference of hers to the Imperial family,

"has declared that he will leave it to the French people themselves to
choose their own form of government; and I believe that once free from
the usurper, the whole nation will certainly throw itself into the
arms of its rightful king," she concluded, trying to be amiable to the
royalist emigrant.

"That is doubtful," said Prince Andrew. "Monsieur le Vicomte quite
rightly supposes that matters have already gone too far. I think it
will be difficult to return to the old regime."

"From what I have heard," said Pierre, blushing and breaking into
the conversation, "almost all the aristocracy has already gone over to
Bonaparte's side."

"It is the Buonapartists who say that," replied the vicomte
without looking at Pierre. "At the present time it is difficult to
know the real state of French public opinion."

"Bonaparte has said so," remarked Prince Andrew with a sarcastic
smile.

It was evident that he did not like the vicomte and was aiming his
remarks at him, though without looking at him.

"'I showed them the path to glory, but they did not follow it,'"
Prince Andrew continued after a short silence, again quoting
Napoleon's words. "'I opened my antechambers and they crowded in.' I
do not know how far he was justified in saying so."

"Not in the least," replied the vicomte. "After the murder of the
duc even the most partial ceased to regard him as a hero. If to some
people," he went on, turning to Anna Pavlovna, "he ever was a hero,
after the murder of the duc there was one martyr more in heaven and
one hero less on earth."

Before Anna Pavlovna and the others had time to smile their
appreciation of the vicomte's epigram, Pierre again broke into the
conversation, and though Anna Pavlovna felt sure he would say
something inappropriate, she was unable to stop him.

"The execution of the Duc d'Enghien," declared Monsieur Pierre, "was
a political necessity, and it seems to me that Napoleon showed
greatness of soul by not fearing to take on himself the whole
responsibility of that deed."

"Dieu! Mon Dieu!" muttered Anna Pavlovna in a terrified whisper.

"What, Monsieur Pierre... Do you consider that assassination shows
greatness of soul?" said the little princess, smiling and drawing
her work nearer to her.

"Oh! Oh!" exclaimed several voices.

"Capital!" said Prince Hippolyte in English, and began slapping
his knee with the palm of his hand.

The vicomte merely shrugged his shoulders. Pierre looked solemnly at
his audience over his spectacles and continued.

"I say so," he continued desperately, "because the Bourbons fled
from the Revolution leaving the people to anarchy, and Napoleon
alone understood the Revolution and quelled it, and so for the general
good, he could not stop short for the sake of one man's life."

"Won't you come over to the other table?" suggested Anna Pavlovna.

But Pierre continued his speech without heeding her.

"No," cried he, becoming more and more eager, "Napoleon is great
because he rose superior to the Revolution, suppressed its abuses,
preserved all that was good in it--equality of citizenship and freedom
of speech and of the press--and only for that reason did he obtain
power."

"Yes, if having obtained power, without availing himself of it to
commit murder he had restored it to the rightful king, I should have
called him a great man," remarked the vicomte.

"He could not do that. The people only gave him power that he
might rid them of the Bourbons and because they saw that he was a
great man. The Revolution was a grand thing!" continued Monsieur
Pierre, betraying by this desperate and provocative proposition his
extreme youth and his wish to express all that was in his mind.

"What? Revolution and regicide a grand thing?... Well, after that...
But won't you come to this other table?" repeated Anna Pavlovna.

"Rousseau's Contrat social," said the vicomte with a tolerant smile.

"I am not speaking of regicide, I am speaking about ideas."

"Yes: ideas of robbery, murder, and regicide," again interjected
an ironical voice.

"Those were extremes, no doubt, but they are not what is most
important. What is important are the rights of man, emancipation
from prejudices, and equality of citizenship, and all these ideas
Napoleon has retained in full force."

"Liberty and equality," said the vicomte contemptuously, as if at
last deciding seriously to prove to this youth how foolish his words
were, "high-sounding words which have long been discredited. Who
does not love liberty and equality? Even our Saviour preached
liberty and equality. Have people since the Revolution become happier?
On the contrary. We wanted liberty, but Buonaparte has destroyed it."

Prince Andrew kept looking with an amused smile from Pierre to the
vicomte and from the vicomte to their hostess. In the first moment
of Pierre's outburst Anna Pavlovna, despite her social experience, was
horror-struck. But when she saw that Pierre's sacrilegious words had
not exasperated the vicomte, and had convinced herself that it was
impossible to stop him, she rallied her forces and joined the
vicomte in a vigorous attack on the orator.

"But, my dear Monsieur Pierre," said she, "how do you explain the
fact of a great man executing a duc--or even an ordinary man who--is
innocent and untried?"

"I should like," said the vicomte, "to ask how monsieur explains the
18th Brumaire; was not that an imposture? It was a swindle, and not at
all like the conduct of a great man!"

"And the prisoners he killed in Africa? That was horrible!" said the
little princess, shrugging her shoulders.

"He's a low fellow, say what you will," remarked Prince Hippolyte.

Pierre, not knowing whom to answer, looked at them all and smiled.
His smile was unlike the half-smile of other people. When he smiled,
his grave, even rather gloomy, look was instantaneously replaced by
another--a childlike, kindly, even rather silly look, which seemed
to ask forgiveness.

The vicomte who was meeting him for the first time saw clearly
that this young Jacobin was not so terrible as his words suggested.
All were silent.

"How do you expect him to answer you all at once?" said Prince
Andrew. "Besides, in the actions of a statesman one has to distinguish
between his acts as a private person, as a general, and as an emperor.
So it seems to me."

"Yes, yes, of course!" Pierre chimed in, pleased at the arrival of
this reinforcement.

"One must admit," continued Prince Andrew, "that Napoleon as a man
was great on the bridge of Arcola, and in the hospital at Jaffa
where he gave his hand to the plague-stricken; but... but there are
other acts which it is difficult to justify."

Prince Andrew, who had evidently wished to tone down the awkwardness
of Pierre's remarks, rose and made a sign to his wife that it was time
to go.


Suddenly Prince Hippolyte started up making signs to everyone to
attend, and asking them all to be seated began:

"I was told a charming Moscow story today and must treat you to
it. Excuse me, Vicomte--I must tell it in Russian or the point will be
lost...." And Prince Hippolyte began to tell his story in such Russian
as a Frenchman would speak after spending about a year in Russia.
Everyone waited, so emphatically and eagerly did he demand their
attention to his story.

"There is in Moscow a lady, une dame, and she is very stingy. She
must have two footmen behind her carriage, and very big ones. That was
her taste. And she had a lady's maid, also big. She said..."

Here Prince Hippolyte paused, evidently collecting his ideas with
difficulty.

"She said... Oh yes! She said, 'Girl,' to the maid, 'put on a
livery, get up behind the carriage, and come with me while I make some
calls.'"

Here Prince Hippolyte spluttered and burst out laughing long
before his audience, which produced an effect unfavorable to the
narrator. Several persons, among them the elderly lady and Anna
Pavlovna, did however smile.

"She went. Suddenly there was a great wind. The girl lost her hat
and her long hair came down...." Here he could contain himself no
longer and went on, between gasps of laughter: "And the whole world
knew...."

And so the anecdote ended. Though it was unintelligible why he had
told it, or why it had to be told in Russian, still Anna Pavlovna
and the others appreciated Prince Hippolyte's social tact in so
agreeably ending Pierre's unpleasant and unamiable outburst. After the
anecdote the conversation broke up into insignificant small talk about
the last and next balls, about theatricals, and who would meet whom,
and when and where.





CHAPTER VI


Having thanked Anna Pavlovna for her charming soiree, the guests
began to take their leave.

Pierre was ungainly. Stout, about the average height, broad, with
huge red hands; he did not know, as the saying is, how to enter a
drawing room and still less how to leave one; that is, how to say
something particularly agreeable before going away. Besides this he
was absent-minded. When he rose to go, he took up instead of his
own, the general's three-cornered hat, and held it, pulling at the
plume, till the general asked him to restore it. All his
absent-mindedness and inability to enter a room and converse in it
was, however, redeemed by his kindly, simple, and modest expression.
Anna Pavlovna turned toward him and, with a Christian mildness that
expressed forgiveness of his indiscretion, nodded and said: "I hope to
see you again, but I also hope you will change your opinions, my
dear Monsieur Pierre."

When she said this, he did not reply and only bowed, but again
everybody saw his smile, which said nothing, unless perhaps, "Opinions
are opinions, but you see what a capital, good-natured fellow I am."
And everyone, including Anna Pavlovna, felt this.

Prince Andrew had gone out into the hall, and, turning his shoulders
to the footman who was helping him on with his cloak, listened
indifferently to his wife's chatter with Prince Hippolyte who had also
come into the hall. Prince Hippolyte stood close to the pretty,
pregnant princess, and stared fixedly at her through his eyeglass.

"Go in, Annette, or you will catch cold," said the little
princess, taking leave of Anna Pavlovna. "It is settled," she added in
a low voice.

Anna Pavlovna had already managed to speak to Lise about the match
she contemplated between Anatole and the little princess'
sister-in-law.

"I rely on you, my dear," said Anna Pavlovna, also in a low tone.
"Write to her and let me know how her father looks at the matter. Au
revoir!"--and she left the hall.

Prince Hippolyte approached the little princess and, bending his
face close to her, began to whisper something.

Two footmen, the princess' and his own, stood holding a shawl and
a cloak, waiting for the conversation to finish. They listened to
the French sentences which to them were meaningless, with an air of
understanding but not wishing to appear to do so. The princess as
usual spoke smilingly and listened with a laugh.

"I am very glad I did not go to the ambassador's," said Prince
Hippolyte "-so dull-. It has been a delightful evening, has it not?
Delightful!"

"They say the ball will be very good," replied the princess, drawing
up her downy little lip. "All the pretty women in society will be
there."

"Not all, for you will not be there; not all," said Prince Hippolyte
smiling joyfully; and snatching the shawl from the footman, whom he
even pushed aside, he began wrapping it round the princess. Either
from awkwardness or intentionally (no one could have said which) after
the shawl had been adjusted he kept his arm around her for a long
time, as though embracing her.

Still smiling, she gracefully moved away, turning and glancing at
her husband. Prince Andrew's eyes were closed, so weary and sleepy did
he seem.

"Are you ready?" he asked his wife, looking past her.

Prince Hippolyte hurriedly put on his cloak, which in the latest
fashion reached to his very heels, and, stumbling in it, ran out
into the porch following the princess, whom a footman was helping into
the carriage.

"Princesse, au revoir," cried he, stumbling with his tongue as
well as with his feet.

The princess, picking up her dress, was taking her seat in the
dark carriage, her husband was adjusting his saber; Prince
Hippolyte, under pretense of helping, was in everyone's way.

"Allow me, sir," said Prince Andrew in Russian in a cold,
disagreeable tone to Prince Hippolyte who was blocking his path.

"I am expecting you, Pierre," said the same voice, but gently and
affectionately.

The postilion started, the carriage wheels rattled. Prince Hippolyte
laughed spasmodically as he stood in the porch waiting for the vicomte
whom he had promised to take home.

"Well, mon cher," said the vicomte, having seated himself beside
Hippolyte in the carriage, "your little princess is very nice, very
nice indeed, quite French," and he kissed the tips of his fingers.
Hippolyte burst out laughing.

"Do you know, you are a terrible chap for all your innocent airs,"
continued the vicomte. "I pity the poor husband, that little officer
who gives himself the airs of a monarch."

Hippolyte spluttered again, and amid his laughter said, "And you
were saying that the Russian ladies are not equal to the French? One
has to know how to deal with them."


Pierre reaching the house first went into Prince Andrew's study like
one quite at home, and from habit immediately lay down on the sofa,
took from the shelf the first book that came to his hand (it was
Caesar's Commentaries), and resting on his elbow, began reading it
in the middle.

"What have you done to Mlle Scherer? She will be quite ill now,"
said Prince Andrew, as he entered the study, rubbing his small white
hands.

Pierre turned his whole body, making the sofa creak. He lifted his
eager face to Prince Andrew, smiled, and waved his hand.

"That abbe is very interesting but he does not see the thing in
the right light.... In my opinion perpetual peace is possible but--I
do not know how to express it... not by a balance of political
power...."

It was evident that Prince Andrew was not interested in such
abstract conversation.

"One can't everywhere say all one thinks, mon cher. Well, have you
at last decided on anything? Are you going to be a guardsman or a
diplomatist?" asked Prince Andrew after a momentary silence.

Pierre sat up on the sofa, with his legs tucked under him.

"Really, I don't yet know. I don't like either the one or the
other."

"But you must decide on something! Your father expects it."

Pierre at the age of ten had been sent abroad with an abbe as tutor,
and had remained away till he was twenty. When he returned to Moscow
his father dismissed the abbe and said to the young man, "Now go to
Petersburg, look round, and choose your profession. I will agree to
anything. Here is a letter to Prince Vasili, and here is money.
Write to me all about it, and I will help you in everything." Pierre
had already been choosing a career for three months, and had not
decided on anything. It was about this choice that Prince Andrew was
speaking. Pierre rubbed his forehead.

"But he must be a Freemason," said he, referring to the abbe whom he
had met that evening.

"That is all nonsense." Prince Andrew again interrupted him, "let us
talk business. Have you been to the Horse Guards?"

"No, I have not; but this is what I have been thinking and wanted to
tell you. There is a war now against Napoleon. If it were a war for
freedom I could understand it and should be the first to enter the
army; but to help England and Austria against the greatest man in
the world is not right."

Prince Andrew only shrugged his shoulders at Pierre's childish
words. He put on the air of one who finds it impossible to reply to
such nonsense, but it would in fact have been difficult to give any
other answer than the one Prince Andrew gave to this naive question.

"If no one fought except on his own conviction, there would be no
wars," he said.

"And that would be splendid," said Pierre.

Prince Andrew smiled ironically.

"Very likely it would be splendid, but it will never come about..."

"Well, why are you going to the war?" asked Pierre.

"What for? I don't know. I must. Besides that I am going..." He
paused. "I am going because the life I am leading here does not suit
me!"





CHAPTER VII


The rustle of a woman's dress was heard in the next room. Prince
Andrew shook himself as if waking up, and his face assumed the look it
had had in Anna Pavlovna's drawing room. Pierre removed his feet
from the sofa. The princess came in. She had changed her gown for a
house dress as fresh and elegant as the other. Prince Andrew rose
and politely placed a chair for her.

"How is it," she began, as usual in French, settling down briskly
and fussily in the easy chair, "how is it Annette never got married?
How stupid you men all are not to have married her! Excuse me for
saying so, but you have no sense about women. What an argumentative
fellow you are, Monsieur Pierre!"

"And I am still arguing with your husband. I can't understand why he
wants to go to the war," replied Pierre, addressing the princess
with none of the embarrassment so commonly shown by young men in their
intercourse with young women.

The princess started. Evidently Pierre's words touched her to the
quick.

"Ah, that is just what I tell him!" said she. "I don't understand
it; I don't in the least understand why men can't live without wars.
How is it that we women don't want anything of the kind, don't need
it? Now you shall judge between us. I always tell him: Here he is
Uncle's aide-de-camp, a most brilliant position. He is so well
known, so much appreciated by everyone. The other day at the
Apraksins' I heard a lady asking, 'Is that the famous Prince
Andrew?' I did indeed." She laughed. "He is so well received
everywhere. He might easily become aide-de-camp to the Emperor. You
know the Emperor spoke to him most graciously. Annette and I were
speaking of how to arrange it. What do you think?"

Pierre looked at his friend and, noticing that he did not like the
conversation, gave no reply.

"When are you starting?" he asked.

"Oh, don't speak of his going, don't! I won't hear it spoken of,"
said the princess in the same petulantly playful tone in which she had
spoken to Hippolyte in the drawing room and which was so plainly
ill-suited to the family circle of which Pierre was almost a member.
"Today when I remembered that all these delightful associations must
be broken off... and then you know, Andre..." (she looked
significantly at her husband) "I'm afraid, I'm afraid!" she whispered,
and a shudder ran down her back.

Her husband looked at her as if surprised to notice that someone
besides Pierre and himself was in the room, and addressed her in a
tone of frigid politeness.

"What is it you are afraid of, Lise? I don't understand," said he.

"There, what egotists men all are: all, all egotists! Just for a
whim of his own, goodness only knows why, he leaves me and locks me up
alone in the country."

"With my father and sister, remember," said Prince Andrew gently.

"Alone all the same, without my friends.... And he expects me not to
be afraid."

Her tone was now querulous and her lip drawn up, giving her not a
joyful, but an animal, squirrel-like expression. She paused as if
she felt it indecorous to speak of her pregnancy before Pierre, though
the gist of the matter lay in that.

"I still can't understand what you are afraid of," said Prince
Andrew slowly, not taking his eyes off his wife.

The princess blushed, and raised her arms with a gesture of despair.

"No, Andrew, I must say you have changed. Oh, how you have..."

"Your doctor tells you to go to bed earlier," said Prince Andrew.
"You had better go."

The princess said nothing, but suddenly her short downy lip
quivered. Prince Andrew rose, shrugged his shoulders, and walked about
the room.

Pierre looked over his spectacles with naive surprise, now at him
and now at her, moved as if about to rise too, but changed his mind.

"Why should I mind Monsieur Pierre being here?" exclaimed the little
princess suddenly, her pretty face all at once distorted by a
tearful grimace. "I have long wanted to ask you, Andrew, why you
have changed so to me? What have I done to you? You are going to the
war and have no pity for me. Why is it?"

"Lise!" was all Prince Andrew said. But that one word expressed an
entreaty, a threat, and above all conviction that she would herself
regret her words. But she went on hurriedly:

"You treat me like an invalid or a child. I see it all! Did you
behave like that six months ago?"

"Lise, I beg you to desist," said Prince Andrew still more
emphatically.

Pierre, who had been growing more and more agitated as he listened
to all this, rose and approached the princess. He seemed unable to
bear the sight of tears and was ready to cry himself.

"Calm yourself, Princess! It seems so to you because... I assure you
I myself have experienced... and so... because... No, excuse me! An
outsider is out of place here... No, don't distress yourself...
Good-by!"

Prince Andrew caught him by the hand.

"No, wait, Pierre! The princess is too kind to wish to deprive me of
the pleasure of spending the evening with you."

"No, he thinks only of himself," muttered the princess without
restraining her angry tears.

"Lise!" said Prince Andrew dryly, raising his voice to the pitch
which indicates that patience is exhausted.

Suddenly the angry, squirrel-like expression of the princess' pretty
face changed into a winning and piteous look of fear. Her beautiful
eyes glanced askance at her husband's face, and her own assumed the
timid, deprecating expression of a dog when it rapidly but feebly wags
its drooping tail.

"Mon Dieu, mon Dieu!" she muttered, and lifting her dress with one
hand she went up to her husband and kissed him on the forehead.

"Good night, Lise," said he, rising and courteously kissing her hand
as he would have done to a stranger.





CHAPTER VIII


The friends were silent. Neither cared to begin talking. Pierre
continually glanced at Prince Andrew; Prince Andrew rubbed his
forehead with his small hand.

"Let us go and have supper," he said with a sigh, going to the door.

They entered the elegant, newly decorated, and luxurious dining
room. Everything from the table napkins to the silver, china, and
glass bore that imprint of newness found in the households of the
newly married. Halfway through supper Prince Andrew leaned his
elbows on the table and, with a look of nervous agitation such as
Pierre had never before seen on his face, began to talk--as one who
has long had something on his mind and suddenly determines to speak
out.

"Never, never marry, my dear fellow! That's my advice: never marry
till you can say to yourself that you have done all you are capable
of, and until you have ceased to love the woman of your choice and
have seen her plainly as she is, or else you will make a cruel and
irrevocable mistake. Marry when you are old and good for nothing--or
all that is good and noble in you will be lost. It will all be
wasted on trifles. Yes! Yes! Yes! Don't look at me with such surprise.
If you marry expecting anything from yourself in the future, you
will feel at every step that for you all is ended, all is closed
except the drawing room, where you will be ranged side by side with
a court lackey and an idiot!... But what's the good?..." and he
waved his arm.

Pierre took off his spectacles, which made his face seem different
and the good-natured expression still more apparent, and gazed at
his friend in amazement.

"My wife," continued Prince Andrew, "is an excellent woman, one of
those rare women with whom a man's honor is safe; but, O God, what
would I not give now to be unmarried! You are the first and only one
to whom I mention this, because I like you."

As he said this Prince Andrew was less than ever like that Bolkonski
who had lolled in Anna Pavlovna's easy chairs and with half-closed
eyes had uttered French phrases between his teeth. Every muscle of his
thin face was now quivering with nervous excitement; his eyes, in
which the fire of life had seemed extinguished, now flashed with
brilliant light. It was evident that the more lifeless he seemed at
ordinary times, the more impassioned he became in these moments of
almost morbid irritation.

"You don't understand why I say this," he continued, "but it is
the whole story of life. You talk of Bonaparte and his career," said
he (though Pierre had not mentioned Bonaparte), "but Bonaparte when he
worked went step by step toward his goal. He was free, he had
nothing but his aim to consider, and he reached it. But tie yourself
up with a woman and, like a chained convict, you lose all freedom! And
all you have of hope and strength merely weighs you down and
torments you with regret. Drawing rooms, gossip, balls, vanity, and
triviality--these are the enchanted circle I cannot escape from. I
am now going to the war, the greatest war there ever was, and I know
nothing and am fit for nothing. I am very amiable and have a caustic
wit," continued Prince Andrew, "and at Anna Pavlovna's they listen
to me. And that stupid set without whom my wife cannot exist, and
those women... If you only knew what those society women are, and
women in general! My father is right. Selfish, vain, stupid, trivial
in everything--that's what women are when you see them in their true
colors! When you meet them in society it seems as if there were
something in them, but there's nothing, nothing, nothing! No, don't
marry, my dear fellow; don't marry!" concluded Prince Andrew.

"It seems funny to me," said Pierre, "that you, you should
consider yourself incapable and your life a spoiled life. You have
everything before you, everything. And you..."

He did not finish his sentence, but his tone showed how highly he
thought of his friend and how much he expected of him in the future.

"How can he talk like that?" thought Pierre. He considered his
friend a model of perfection because Prince Andrew possessed in the
highest degree just the very qualities Pierre lacked, and which
might be best described as strength of will. Pierre was always
astonished at Prince Andrew's calm manner of treating everybody, his
extraordinary memory, his extensive reading (he had read everything,
knew everything, and had an opinion about everything), but above all
at his capacity for work and study. And if Pierre was often struck
by Andrew's lack of capacity for philosophical meditation (to which he
himself was particularly addicted), he regarded even this not as a
defect but as a sign of strength.

Even in the best, most friendly and simplest relations of life,
praise and commendation are essential, just as grease is necessary
to wheels that they may run smoothly.

"My part is played out," said Prince Andrew. "What's the use of
talking about me? Let us talk about you," he added after a silence,
smiling at his reassuring thoughts.

That smile was immediately reflected on Pierre's face.

"But what is there to say about me?" said Pierre, his face
relaxing into a careless, merry smile. "What am I? An illegitimate
son!" He suddenly blushed crimson, and it was plain that he had made a
great effort to say this. "Without a name and without means... And
it really..." But he did not say what "it really" was. "For the
present I am free and am all right. Only I haven't the least idea what
I am to do; I wanted to consult you seriously."

Prince Andrew looked kindly at him, yet his glance--friendly and
affectionate as it was--expressed a sense of his own superiority.

"I am fond of you, especially as you are the one live man among
our whole set. Yes, you're all right! Choose what you will; it's all
the same. You'll be all right anywhere. But look here: give up
visiting those Kuragins and leading that sort of life. It suits you so
badly--all this debauchery, dissipation, and the rest of it!"

"What would you have, my dear fellow?" answered Pierre, shrugging
his shoulders. "Women, my dear fellow; women!"

"I don't understand it," replied Prince Andrew. "Women who are comme
il faut, that's a different matter; but the Kuragins' set of women,
'women and wine' I don't understand!"

Pierre was staying at Prince Vasili Kuragin's and sharing the
dissipated life of his son Anatole, the son whom they were planning to
reform by marrying him to Prince Andrew's sister.

"Do you know?" said Pierre, as if suddenly struck by a happy
thought, "seriously, I have long been thinking of it.... Leading
such a life I can't decide or think properly about anything. One's
head aches, and one spends all one's money. He asked me for tonight,
but I won't go."

"You give me your word of honor not to go?"

"On my honor!"





CHAPTER IX


It was past one o'clock when Pierre left his friend. It was a
cloudless, northern, summer night. Pierre took an open cab intending
to drive straight home. But the nearer he drew to the house the more
he felt the impossibility of going to sleep on such a night. It was
light enough to see a long way in the deserted street and it seemed
more like morning or evening than night. On the way Pierre
remembered that Anatole Kuragin was expecting the usual set for
cards that evening, after which there was generally a drinking bout,
finishing with visits of a kind Pierre was very fond of.

"I should like to go to Kuragin's," thought he.

But he immediately recalled his promise to Prince Andrew not to go
there. Then, as happens to people of weak character, he desired so
passionately once more to enjoy that dissipation he was so
accustomed to that he decided to go. The thought immediately
occurred to him that his promise to Prince Andrew was of no account,
because before he gave it he had already promised Prince Anatole to
come to his gathering; "besides," thought he, "all such 'words of
honor' are conventional things with no definite meaning, especially if
one considers that by tomorrow one may be dead, or something so
extraordinary may happen to one that honor and dishonor will be all
the same!" Pierre often indulged in reflections of this sort,
nullifying all his decisions and intentions. He went to Kuragin's.

Reaching the large house near the Horse Guards' barracks, in which
Anatole lived, Pierre entered the lighted porch, ascended the
stairs, and went in at the open door. There was no one in the
anteroom; empty bottles, cloaks, and overshoes were lying about; there
was a smell of alcohol, and sounds of voices and shouting in the
distance.

Cards and supper were over, but the visitors had not yet
dispersed. Pierre threw off his cloak and entered the first room, in
which were the remains of supper. A footman, thinking no one saw
him, was drinking on the sly what was left in the glasses. From the
third room came sounds of laughter, the shouting of familiar voices,
the growling of a bear, and general commotion. Some eight or nine
young men were crowding anxiously round an open window. Three others
were romping with a young bear, one pulling him by the chain and
trying to set him at the others.

"I bet a hundred on Stevens!" shouted one.

"Mind, no holding on!" cried another.

"I bet on Dolokhov!" cried a third. "Kuragin, you part our hands."

"There, leave Bruin alone; here's a bet on."

"At one draught, or he loses!" shouted a fourth.

"Jacob, bring a bottle!" shouted the host, a tall, handsome fellow
who stood in the midst of the group, without a coat, and with his fine
linen shirt unfastened in front. "Wait a bit, you fellows.... Here
is Petya! Good man!" cried he, addressing Pierre.

Another voice, from a man of medium height with clear blue eyes,
particularly striking among all these drunken voices by its sober
ring, cried from the window: "Come here; part the bets!" This was
Dolokhov, an officer of the Semenov regiment, a notorious gambler
and duelist, who was living with Anatole. Pierre smiled, looking about
him merrily.

"I don't understand. What's it all about?"

"Wait a bit, he is not drunk yet! A bottle here," said Anatole,
taking a glass from the table he went up to Pierre.

"First of all you must drink!"

Pierre drank one glass after another, looking from under his brows
at the tipsy guests who were again crowding round the window, and
listening to their chatter. Anatole kept on refilling Pierre's glass
while explaining that Dolokhov was betting with Stevens, an English
naval officer, that he would drink a bottle of rum sitting on the
outer ledge of the third floor window with his legs hanging out.

"Go on, you must drink it all," said Anatole, giving Pierre the last
glass, "or I won't let you go!"

"No, I won't," said Pierre, pushing Anatole aside, and he went up to
the window.

Dolokhov was holding the Englishman's hand and clearly and
distinctly repeating the terms of the bet, addressing himself
particularly to Anatole and Pierre.

Dolokhov was of medium height, with curly hair and light-blue
eyes. He was about twenty-five. Like all infantry officers he wore
no mustache, so that his mouth, the most striking feature of his face,
was clearly seen. The lines of that mouth were remarkably finely
curved. The middle of the upper lip formed a sharp wedge and closed
firmly on the firm lower one, and something like two distinct smiles
played continually round the two corners of the mouth; this,
together with the resolute, insolent intelligence of his eyes,
produced an effect which made it impossible not to notice his face.
Dolokhov was a man of small means and no connections. Yet, though
Anatole spent tens of thousands of rubles, Dolokhov lived with him and
had placed himself on such a footing that all who knew them, including
Anatole himself, respected him more than they did Anatole. Dolokhov
could play all games and nearly always won. However much he drank,
he never lost his clearheadedness. Both Kuragin and Dolokhov were at
that time notorious among the rakes and scapegraces of Petersburg.

The bottle of rum was brought. The window frame which prevented
anyone from sitting on the outer sill was being forced out by two
footmen, who were evidently flurried and intimidated by the directions
and shouts of the gentlemen around.

Anatole with his swaggering air strode up to the window. He wanted
to smash something. Pushing away the footmen he tugged at the frame,
but could not move it. He smashed a pane.

"You have a try, Hercules," said he, turning to Pierre.

Pierre seized the crossbeam, tugged, and wrenched the oak frame
out with a crash.

"Take it right out, or they'll think I'm holding on," said Dolokhov.

"Is the Englishman bragging?... Eh? Is it all right?" said Anatole.

"First-rate," said Pierre, looking at Dolokhov, who with a bottle of
rum in his hand was approaching the window, from which the light of
the sky, the dawn merging with the afterglow of sunset, was visible.

Dolokhov, the bottle of rum still in his hand, jumped onto the
window sill. "Listen!" cried he, standing there and addressing those
in the room. All were silent.

"I bet fifty imperials"--he spoke French that the Englishman might
understand him, but he did, not speak it very well--"I bet fifty
imperials... or do you wish to make it a hundred?" added he,
addressing the Englishman.

"No, fifty," replied the latter.

"All right. Fifty imperials... that I will drink a whole bottle of
rum without taking it from my mouth, sitting outside the window on
this spot" (he stooped and pointed to the sloping ledge outside the
window) "and without holding on to anything. Is that right?"

"Quite right," said the Englishman.

Anatole turned to the Englishman and taking him by one of the
buttons of his coat and looking down at him--the Englishman was short-
began repeating the terms of the wager to him in English.

"Wait!" cried Dolokhov, hammering with the bottle on the window sill
to attract attention. "Wait a bit, Kuragin. Listen! If anyone else
does the same, I will pay him a hundred imperials. Do you understand?"

The Englishman nodded, but gave no indication whether he intended to
accept this challenge or not. Anatole did not release him, and
though he kept nodding to show that he understood, Anatole went on
translating Dolokhov's words into English. A thin young lad, an hussar
of the Life Guards, who had been losing that evening, climbed on the
window sill, leaned over, and looked down.

"Oh! Oh! Oh!" he muttered, looking down from the window at the
stones of the pavement.

"Shut up!" cried Dolokhov, pushing him away from the window. The lad
jumped awkwardly back into the room, tripping over his spurs.

Placing the bottle on the window sill where he could reach it
easily, Dolokhov climbed carefully and slowly through the window and
lowered his legs. Pressing against both sides of the window, he
adjusted himself on his seat, lowered his hands, moved a little to the
right and then to the left, and took up the bottle. Anatole brought
two candles and placed them on the window sill, though it was
already quite light. Dolokhov's back in his white shirt, and his curly
head, were lit up from both sides. Everyone crowded to the window, the
Englishman in front. Pierre stood smiling but silent. One man, older
than the others present, suddenly pushed forward with a scared and
angry look and wanted to seize hold of Dolokhov's shirt.

"I say, this is folly! He'll be killed," said this more sensible
man.

Anatole stopped him.

"Don't touch him! You'll startle him and then he'll be killed.
Eh?... What then?... Eh?"

Dolokhov turned round and, again holding on with both hands,
arranged himself on his seat.

"If anyone comes meddling again," said he, emitting the words
separately through his thin compressed lips, "I will throw him down
there. Now then!"

Saying this he again turned round, dropped his hands, took the
bottle and lifted it to his lips, threw back his head, and raised
his free hand to balance himself. One of the footmen who had stooped
to pick up some broken glass remained in that position without
taking his eyes from the window and from Dolokhov's back. Anatole
stood erect with staring eyes. The Englishman looked on sideways,
pursing up his lips. The man who had wished to stop the affair ran
to a corner of the room and threw himself on a sofa with his face to
the wall. Pierre hid his face, from which a faint smile forgot to fade
though his features now expressed horror and fear. All were still.
Pierre took his hands from his eyes. Dolokhov still sat in the same
position, only his head was thrown further back till his curly hair
touched his shirt collar, and the hand holding the bottle was lifted
higher and higher and trembled with the effort. The bottle was
emptying perceptibly and rising still higher and his head tilting
yet further back. "Why is it so long?" thought Pierre. It seemed to
him that more than half an hour had elapsed. Suddenly Dolokhov made
a backward movement with his spine, and his arm trembled nervously;
this was sufficient to cause his whole body to slip as he sat on the
sloping ledge. As he began slipping down, his head and arm wavered
still more with the strain. One hand moved as if to clutch the
window sill, but refrained from touching it. Pierre again covered
his eyes and thought he would never never them again. Suddenly he
was aware of a stir all around. He looked up: Dolokhov was standing on
the window sill, with a pale but radiant face.

"It's empty."

He threw the bottle to the Englishman, who caught it neatly.
Dolokhov jumped down. He smelt strongly of rum.

"Well done!... Fine fellow!... There's a bet for you!... Devil
take you!" came from different sides.

The Englishman took out his purse and began counting out the
money. Dolokhov stood frowning and did not speak. Pierre jumped upon
the window sill.

"Gentlemen, who wishes to bet with me? I'll do the same thing!" he
suddenly cried. "Even without a bet, there! Tell them to bring me a
bottle. I'll do it.... Bring a bottle!"

"Let him do it, let him do it," said Dolokhov, smiling.

"What next? Have you gone mad?... No one would let you!... Why,
you go giddy even on a staircase," exclaimed several voices.

"I'll drink it! Let's have a bottle of rum!" shouted Pierre, banging
the table with a determined and drunken gesture and preparing to climb
out of the window.

They seized him by his arms; but he was so strong that everyone
who touched him was sent flying.

"No, you'll never manage him that way," said Anatole. "Wait a bit
and I'll get round him.... Listen! I'll take your bet tomorrow, but
now we are all going to ----'s."

"Come on then," cried Pierre. "Come on!... And we'll take Bruin with
us."

And he caught the bear, took it in his arms, lifted it from the
ground, and began dancing round the room with it.





CHAPTER X


Prince Vasili kept the promise he had given to Princess
Drubetskaya who had spoken to him on behalf of her only son Boris on
the evening of Anna Pavlovna's soiree. The matter was mentioned to the
Emperor, an exception made, and Boris transferred into the regiment of
Semenov Guards with the rank of cornet. He received, however, no
appointment to Kutuzov's staff despite all Anna Mikhaylovna's
endeavors and entreaties. Soon after Anna Pavlovna's reception Anna
Mikhaylovna returned to Moscow and went straight to her rich
relations, the Rostovs, with whom she stayed when in the town and
where her darling Bory, who had only just entered a regiment
of the line and was being at once transferred to the Guards as a
cornet, had been educated from childhood and lived for years at a
time. The Guards had already left Petersburg on the tenth of August,
and her son, who had remained in Moscow for his equipment, was to join
them on the march to Radzivilov.

It was St. Natalia's day and the name day of two of the Rostovs--the
mother and the youngest daughter--both named Nataly. Ever since the
morning, carriages with six horses had been coming and going
continually, bringing visitors to the Countess Rostova's big house
on the Povarskaya, so well known to all Moscow. The countess herself
and her handsome eldest daughter were in the drawing-room with the
visitors who came to congratulate, and who constantly succeeded one
another in relays.

The countess was a woman of about forty-five, with a thin Oriental
type of face, evidently worn out with childbearing--she had had
twelve. A languor of motion and speech, resulting from weakness,
gave her a distinguished air which inspired respect. Princess Anna

Mikhaylovna Drubetskaya, who as a member of the household was also
seated in the drawing room, helped to receive and entertain the
visitors. The young people were in one of the inner rooms, not
considering it necessary to take part in receiving the visitors. The
count met the guests and saw them off, inviting them all to dinner.

"I am very, very grateful to you, mon cher," or "ma chere"--he
called everyone without exception and without the slightest
variation in his tone, "my dear," whether they were above or below him
in rank--"I thank you for myself and for our two dear ones whose
name day we are keeping. But mind you come to dinner or I shall be
offended, ma chere! On behalf of the whole family I beg you to come,
mon cher!" These words he repeated to everyone without exception or
variation, and with the same expression on his full, cheerful,
clean-shaven face, the same firm pressure of the hand and the same
quick, repeated bows. As soon as he had seen a visitor off he returned
to one of those who were still in the drawing room, drew a chair
toward him or her, and jauntily spreading out his legs and putting his
hands on his knees with the air of a man who enjoys life and knows how
to live, he swayed to and fro with dignity, offered surmises about the
weather, or touched on questions of health, sometimes in Russian and
sometimes in very bad but self-confident French; then again, like a
man weary but unflinching in the fulfillment of duty, he rose to see
some visitors off and, stroking his scanty gray hairs over his bald
patch, also asked them to dinner. Sometimes on his way back from the
anteroom he would pass through the conservatory and pantry into the
large marble dining hall, where tables were being set out for eighty
people; and looking at the footmen, who were bringing in silver and
china, moving tables, and unfolding damask table linen, he would
call Dmitri Vasilevich, a man of good family and the manager of all
his affairs, and while looking with pleasure at the enormous table
would say: "Well, Dmitri, you'll see that things are all as they
should be? That's right! The great thing is the serving, that's it."
And with a complacent sigh he would return to the drawing room.

"Marya Lvovna Karagina and her daughter!" announced the countess'
gigantic footman in his bass voice, entering the drawing room. The
countess reflected a moment and took a pinch from a gold snuffbox with
her husband's portrait on it.

"I'm quite worn out by these callers. However, I'll see her and no
more. She is so affected. Ask her in," she said to the footman in a
sad voice, as if saying: "Very well, finish me off."

A tall, stout, and proud-looking woman, with a round-faced smiling
daughter, entered the drawing room, their dresses rustling.

"Dear Countess, what an age... She has been laid up, poor child...
at the Razumovski's ball... and Countess Apraksina... I was so
delighted..." came the sounds of animated feminine voices,
interrupting one another and mingling with the rustling of dresses and
the scraping of chairs. Then one of those conversations began which
last out until, at the first pause, the guests rise with a rustle of
dresses and say, "I am so delighted... Mamma's health... and
Countess Apraksina..." and then, again rustling, pass into the
anteroom, put on cloaks or mantles, and drive away. The conversation
was on the chief topic of the day: the illness of the wealthy and
celebrated beau of Catherine's day, Count Bezukhov, and about his
illegitimate son Pierre, the one who had behaved so improperly at Anna
Pavlovna's reception.

"I am so sorry for the poor count," said the visitor. "He is in such
bad health, and now this vexation about his son is enough to kill
him!"

"What is that?" asked the countess as if she did not know what the
visitor alluded to, though she had already heard about the cause of
Count Bezukhov's distress some fifteen times.

"That's what comes of a modern education," exclaimed the visitor.
"It seems that while he was abroad this young man was allowed to do as
he liked, now in Petersburg I hear he has been doing such terrible
things that he has been expelled by the police."

"You don't say so!" replied the countess.

"He chose his friends badly," interposed Anna Mikhaylovna. "Prince
Vasili's son, he, and a certain Dolokhov have, it is said, been up
to heaven only knows what! And they have had to suffer for it.
Dolokhov has been degraded to the ranks and Bezukhov's son sent back
to Moscow. Anatole Kuragin's father managed somehow to get his son's
affair hushed up, but even he was ordered out of Petersburg."

"But what have they been up to?" asked the countess.

"They are regular brigands, especially Dolokhov," replied the
visitor. "He is a son of Marya Ivanovna Dolokhova, such a worthy
woman, but there, just fancy! Those three got hold of a bear
somewhere, put it in a carriage, and set off with it to visit some
actresses! The police tried to interfere, and what did the young men
do? They tied a policeman and the bear back to back and put the bear
into the Moyka Canal. And there was the bear swimming about with the
policeman on his back!"

"What a nice figure the policeman must have cut, my dear!" shouted
the count, dying with laughter.

"Oh, how dreadful! How can you laugh at it, Count?"

Yet the ladies themselves could not help laughing.

"It was all they could do to rescue the poor man," continued the
visitor. "And to think it is Cyril Vladimirovich Bezukhov's son who
amuses himself in this sensible manner! And he was said to be so
well educated and clever. This is all that his foreign education has
done for him! I hope that here in Moscow no one will receive him, in
spite of his money. They wanted to introduce him to me, but I quite
declined: I have my daughters to consider."

"Why do you say this young man is so rich?" asked the countess,
turning away from the girls, who at once assumed an air of
inattention. "His children are all illegitimate. I think Pierre also
is illegitimate."

The visitor made a gesture with her hand.

"I should think he has a score of them."

Princess Anna Mikhaylovna intervened in the conversation,
evidently wishing to show her connections and knowledge of what went
on in society.

"The fact of the matter is," said she significantly, and also in a
half whisper, "everyone knows Count Cyril's reputation.... He has lost
count of his children, but this Pierre was his favorite."

"How handsome the old man still was only a year ago!" remarked the
countess. "I have never seen a handsomer man."

"He is very much altered now," said Anna Mikhaylovna. "Well, as I
was saying, Prince Vasili is the next heir through his wife, but the
count is very fond of Pierre, looked after his education, and wrote to
the Emperor about him; so that in the case of his death--and he is
so ill that he may die at any moment, and Dr. Lorrain has come from
Petersburg--no one knows who will inherit his immense fortune,
Pierre or Prince Vasili. Forty thousand serfs and millions of
rubles! I know it all very well for Prince Vasili told me himself.
Besides, Cyril Vladimirovich is my mother's second cousin. He's also
my Bory's godfather," she added, as if she attached no importance at
all to the fact.

"Prince Vasili arrived in Moscow yesterday. I hear he has come on
some inspection business," remarked the visitor.

"Yes, but between ourselves," said the princess, "that is a
pretext. The fact is he has come to see Count Cyril Vladimirovich,
hearing how ill he is."

"But do you know, my dear, that was a capital joke," said the count;
and seeing that the elder visitor was not listening, he turned to
the young ladies. "I can just imagine what a funny figure that
policeman cut!"

And as he waved his arms to impersonate the policeman, his portly
form again shook with a deep ringing laugh, the laugh of one who
always eats well and, in particular, drinks well. "So do come and dine
with us!" he said.





CHAPTER XI


Silence ensued. The countess looked at her callers, smiling affably,
but not concealing the fact that she would not be distressed if they
now rose and took their leave. The visitor's daughter was already
smoothing down her dress with an inquiring look at her mother, when
suddenly from the next room were heard the footsteps of boys and girls
running to the door and the noise of a chair falling over, and a
girl of thirteen, hiding something in the folds of her short muslin
frock, darted in and stopped short in the middle of the room. It was
evident that she had not intended her flight to bring her so far.
Behind her in the doorway appeared a student with a crimson coat
collar, an officer of the Guards, a girl of fifteen, and a plump
rosy-faced boy in a short jacket.

The count jumped up and, swaying from side to side, spread his
arms wide and threw them round the little girl who had run in.

"Ah, here she is!" he exclaimed laughing. "My pet, whose name day it
is. My dear pet!"

"Ma chere, there is a time for everything," said the countess with
feigned severity. "You spoil her, Ilya," she added, turning to her
husband.

"How do you do, my dear? I wish you many happy returns of your
name day," said the visitor. "What a charming child," she added,
addressing the mother.

This black-eyed, wide-mouthed girl, not pretty but full of life-
with childish bare shoulders which after her run heaved and shook
her bodice, with black curls tossed backward, thin bare arms, little
legs in lace-frilled drawers, and feet in low slippers--was just at
that charming age when a girl is no longer a child, though the child
is not yet a young woman. Escaping from her father she ran to hide her
flushed face in the lace of her mother's mantilla--not paying the
least attention to her severe remark--and began to laugh. She laughed,
and in fragmentary sentences tried to explain about a doll which she
produced from the folds of her frock.

"Do you see?... My doll... Mimi... You see..." was all Natasha
managed to utter (to her everything seemed funny). She leaned
against her mother and burst into such a loud, ringing fit of laughter
that even the prim visitor could not help joining in.

"Now then, go away and take your monstrosity with you," said the
mother, pushing away her daughter with pretended sternness, and
turning to the visitor she added: "She is my youngest girl."

Natasha, raising her face for a moment from her mother's mantilla,
glanced up at her through tears of laughter, and again hid her face.

The visitor, compelled to look on at this family scene, thought it
necessary to take some part in it.

"Tell me, my dear," said she to Natasha, "is Mimi a relation of
yours? A daughter, I suppose?"

Natasha did not like the visitor's tone of condescension to childish
things. She did not reply, but looked at her seriously.

Meanwhile the younger generation: Boris, the officer, Anna
Mikhaylovna's son; Nicholas, the undergraduate, the count's eldest
son; Sonya, the count's fifteen-year-old niece, and little Petya,
his youngest boy, had all settled down in the drawing room and were
obviously trying to restrain within the bounds of decorum the
excitement and mirth that shone in all their faces. Evidently in the
back rooms, from which they had dashed out so impetuously, the
conversation had been more amusing than the drawing-room talk of
society scandals, the weather, and Countess Apraksina. Now and then
they glanced at one another, hardly able to suppress their laughter.

The two young men, the student and the officer, friends from
childhood, were of the same age and both handsome fellows, though
not alike. Boris was tall and fair, and his calm and handsome face had
regular, delicate features. Nicholas was short with curly hair and
an open expression. Dark hairs were already showing on his upper
lip, and his whole face expressed impetuosity and enthusiasm. Nicholas
blushed when he entered the drawing room. He evidently tried to find
something to say, but failed. Boris on the contrary at once found
his footing, and related quietly and humorously how he had know that
doll Mimi when she was still quite a young lady, before her nose was
broken; how she had aged during the five years he had known her, and
how her head had cracked right across the skull. Having said this he
glanced at Natasha. She turned away from him and glanced at her
younger brother, who was screwing up his eyes and shaking with
suppressed laughter, and unable to control herself any longer, she
jumped up and rushed from the room as fast as her nimble little feet
would carry her. Boris did not laugh.

"You were meaning to go out, weren't you, Mamma? Do you want the
carriage?" he asked his mother with a smile.

"Yes, yes, go and tell them to get it ready," she answered,
returning his smile.

Boris quietly left the room and went in search of Natasha. The plump
boy ran after them angrily, as if vexed that their program had been
disturbed.





CHAPTER XII


The only young people remaining in the drawing room, not counting
the young lady visitor and the countess' eldest daughter (who was four
years older than her sister and behaved already like a grown-up
person), were Nicholas and Sonya, the niece. Sonya was a slender
little brunette with a tender look in her eyes which were veiled by
long lashes, thick black plaits coiling twice round her head, and a
tawny tint in her complexion and especially in the color of her
slender but graceful and muscular arms and neck. By the grace of her
movements, by the softness and flexibility of her small limbs, and
by a certain coyness and reserve of manner, she reminded one of a
pretty, half-grown kitten which promises to become a beautiful
little cat. She evidently considered it proper to show an interest
in the general conversation by smiling, but in spite of herself her
eyes under their thick long lashes watched her cousin who was going to
join the army, with such passionate girlish adoration that her smile
could not for a single instant impose upon anyone, and it was clear
that the kitten had settled down only to spring up with more energy
and again play with her cousin as soon as they too could, like Natasha
and Boris, escape from the drawing room.

"Ah yes, my dear," said the count, addressing the visitor and
pointing to Nicholas, "his friend Boris has become an officer, and
so for friendship's sake he is leaving the university and me, his
old father, and entering the military service, my dear. And there
was a place and everything waiting for him in the Archives Department!
Isn't that friendship?" remarked the count in an inquiring tone.

"But they say that war has been declared," replied the visitor.

"They've been saying so a long while," said the count, "and
they'll say so again and again, and that will be the end of it. My
dear, there's friendship for you," he repeated. "He's joining the
hussars."

The visitor, not knowing what to say, shook her head.

"It's not at all from friendship," declared Nicholas, flaring up and
turning away as if from a shameful aspersion. "It is not from
friendship at all; I simply feel that the army is my vocation."

He glanced at his cousin and the young lady visitor; and they were
both regarding him with a smile of approbation.

"Schubert, the colonel of the Pavlograd Hussars, is dining with us
today. He has been here on leave and is taking Nicholas back with him.
It can't be helped!" said the count, shrugging his shoulders and
speaking playfully of a matter that evidently distressed him.

"I have already told you, Papa," said his son, "that if you don't
wish to let me go, I'll stay. But I know I am no use anywhere except
in the army; I am not a diplomat or a government clerk.--I don't
know how to hide what I feel." As he spoke he kept glancing with the
flirtatiousness of a handsome youth at Sonya and the young lady
visitor.

The little kitten, feasting her eyes on him, seemed ready at any
moment to start her gambols again and display her kittenish nature.

"All right, all right!" said the old count. "He always flares up!
This Buonaparte has turned all their heads; they all think of how he
rose from an ensign and became Emperor. Well, well, God grant it,"
he added, not noticing his visitor's sarcastic smile.

The elders began talking about Bonaparte. Julie Karagina turned to
young Rostov.

"What a pity you weren't at the Arkharovs' on Thursday. It was so
dull without you," said she, giving him a tender smile.

The young man, flattered, sat down nearer to her with a coquettish
smile, and engaged the smiling Julie in a confidential conversation
without at all noticing that his involuntary smile had stabbed the
heart of Sonya, who blushed and smiled unnaturally. In the midst of
his talk he glanced round at her. She gave him a passionately angry
glance, and hardly able to restrain her tears and maintain the
artificial smile on her lips, she got up and left the room. All
Nicholas' animation vanished. He waited for the first pause in the
conversation, and then with a distressed face left the room to find
Sonya.

"How plainly all these young people wear their hearts on their
sleeves!" said Anna Mikhaylovna, pointing to Nicholas as he went
out. "Cousinage--dangereux voisinage;"* she added.


*Cousinhood is a dangerous neighborhood.


"Yes," said the countess when the brightness these young people
had brought into the room had vanished; and as if answering a question
no one had put but which was always in her mind, "and how much
suffering, how much anxiety one has had to go through that we might
rejoice in them now! And yet really the anxiety is greater now than
the joy. One is always, always anxious! Especially just at this age,
so dangerous both for girls and boys."

"It all depends on the bringing up," remarked the visitor.

"Yes, you're quite right," continued the countess. "Till now I
have always, thank God, been my children's friend and had their full
confidence," said she, repeating the mistake of so many parents who
imagine that their children have no secrets from them. "I know I shall
always be my daughters' first confidante, and that if Nicholas, with
his impulsive nature, does get into mischief (a boy can't help it), he
will all the same never be like those Petersburg young men."

"Yes, they are splendid, splendid youngsters," chimed in the
count, who always solved questions that seemed to him perplexing by
deciding that everything was splendid. "Just fancy: wants to be an
hussar. What's one to do, my dear?"

"What a charming creature your younger girl is," said the visitor;
"a little volcano!"

"Yes, a regular volcano," said the count. "Takes after me! And
what a voice she has; though she's my daughter, I tell the truth
when I say she'll be a singer, a second Salomoni! We have engaged an
Italian to give her lessons."

"Isn't she too young? I have heard that it harms the voice to
train it at that age."

"Oh no, not at all too young!" replied the count. "Why, our
mothers used to be married at twelve or thirteen."

"And she's in love with Boris already. Just fancy!" said the
countess with a gentle smile, looking at Boris' and went on, evidently
concerned with a thought that always occupied her: "Now you see if I
were to be severe with her and to forbid it... goodness knows what
they might be up to on the sly" (she meant that they would be
kissing), "but as it is, I know every word she utters. She will come
running to me of her own accord in the evening and tell me everything.
Perhaps I spoil her, but really that seems the best plan. With her
elder sister I was stricter."

"Yes, I was brought up quite differently," remarked the handsome
elder daughter, Countess Vera, with a smile.

But the smile did not enhance Vera's beauty as smiles generally
do; on the contrary it gave her an unnatural, and therefore
unpleasant, expression. Vera was good-looking, not at all stupid,
quick at learning, was well brought up, and had a pleasant voice; what
she said was true and appropriate, yet, strange to say, everyone-
the visitors and countess alike--turned to look at her as if wondering
why she had said it, and they all felt awkward.

"People are always too clever with their eldest children and try
to make something exceptional of them," said the visitor.

"What's the good of denying it, my dear? Our dear countess was too
clever with Vera," said the count. "Well, what of that? She's turned
out splendidly all the same," he added, winking at Vera.

The guests got up and took their leave, promising to return to
dinner.

"What manners! I thought they would never go," said the countess,
when she had seen her guests out.





CHAPTER XIII


When Natasha ran out of the drawing room she only went as far as the
conservatory. There she paused and stood listening to the conversation
in the drawing room, waiting for Boris to come out. She was already
growing impatient, and stamped her foot, ready to cry at his not
coming at once, when she heard the young man's discreet steps
approaching neither quickly nor slowly. At this Natasha dashed swiftly
among the flower tubs and hid there.

Boris paused in the middle of the room, looked round, brushed a
little dust from the sleeve of his uniform, and going up to a mirror
examined his handsome face. Natasha, very still, peered out from her
ambush, waiting to see what he would do. He stood a little while
before the glass, smiled, and walked toward the other door. Natasha
was about to call him but changed her mind. "Let him look for me,"
thought she. Hardly had Boris gone than Sonya, flushed, in tears,
and muttering angrily, came in at the other door. Natasha checked
her first impulse to run out to her, and remained in her hiding place,
watching--as under an invisible cap--to see what went on in the world.
She was experiencing a new and peculiar pleasure. Sonya, muttering
to herself, kept looking round toward the drawing-room door. It opened
and Nicholas came in.

"Sonya, what is the matter with you? How can you?" said he,
running up to her.

"It's nothing, nothing; leave me alone!" sobbed Sonya.

"Ah, I know what it is."

"Well, if you do, so much the better, and you can go back to her!"

"So-o-onya! Look here! How can you torture me and yourself like
that, for a mere fancy?" said Nicholas taking her hand.

Sonya did not pull it away, and left off crying. Natasha, not
stirring and scarcely breathing, watched from her ambush with
sparkling eyes. "What will happen now?" thought she.

"Sonya! What is anyone in the world to me? You alone are
everything!" said Nicholas. "And I will prove it to you."

"I don't like you to talk like that."

"Well, then, I won't; only forgive me, Sonya!" He drew her to him
and kissed her.

"Oh, how nice," thought Natasha; and when Sonya and Nicholas had
gone out of the conservatory she followed and called Boris to her.

"Boris, come here," said she with a sly and significant look. "I
have something to tell you. Here, here!" and she led him into the
conservatory to the place among the tubs where she had been hiding.

Boris followed her, smiling.

"What is the something?" asked he.

She grew confused, glanced round, and, seeing the doll she had
thrown down on one of the tubs, picked it up.

"Kiss the doll," said she.

Boris looked attentively and kindly at her eager face, but did not
reply.

"Don't you want to? Well, then, come here," said she, and went
further in among the plants and threw down the doll. "Closer, closer!"
she whispered.

She caught the young officer by his cuffs, and a look of solemnity
and fear appeared on her flushed face.

"And me? Would you like to kiss me?" she whispered almost inaudibly,
glancing up at him from under her brows, smiling, and almost crying
from excitement.

Boris blushed.

"How funny you are!" he said, bending down to her and blushing still
more, but he waited and did nothing.

Suddenly she jumped up onto a tub to be higher than he, embraced him
so that both her slender bare arms clasped him above his neck, and,
tossing back her hair, kissed him full on the lips.

Then she slipped down among the flowerpots on the other side of
the tubs and stood, hanging her head.

"Natasha," he said, "you know that I love you, but..."

"You are in love with me?" Natasha broke in.

"Yes, I am, but please don't let us do like that.... In another four
years... then I will ask for your hand."

Natasha considered.

"Thirteen, fourteen, fifteen, sixteen," she counted on her slender
little fingers. "All right! Then it's settled?"

A smile of joy and satisfaction lit up her eager face.

"Settled!" replied Boris.

"Forever?" said the little girl. "Till death itself?"

She took his arm and with a happy face went with him into the
adjoining sitting room.





CHAPTER XIV


After receiving her visitors, the countess was so tired that she
gave orders to admit no more, but the porter was told to be sure to
invite to dinner all who came "to congratulate." The countess wished
to have a tete-a-tete talk with the friend of her childhood,
Princess Anna Mikhaylovna, whom she had not seen properly since she
returned from Petersburg. Anna Mikhaylovna, with her tear-worn but
pleasant face, drew her chair nearer to that of the countess.

"With you I will be quite frank," said Anna Mikhaylovna. "There
are not many left of us old friends! That's why I so value your
friendship."

Anna Mikhaylovna looked at Vera and paused. The countess pressed her
friend's hand.

"Vera," she said to her eldest daughter who was evidently not a
favorite, "how is it you have so little tact? Don't you see you are
not wanted here? Go to the other girls, or..."

The handsome Vera smiled contemptuously but did not seem at all
hurt.

"If you had told me sooner, Mamma, I would have gone," she replied
as she rose to go to her own room.

But as she passed the sitting room she noticed two couples
sitting, one pair at each window. She stopped and smiled scornfully.
Sonya was sitting close to Nicholas who was copying out some verses
for her, the first he had ever written. Boris and Natasha were at
the other window and ceased talking when Vera entered. Sonya and
Natasha looked at Vera with guilty, happy faces.

It was pleasant and touching to see these little girls in love;
but apparently the sight of them roused no pleasant feeling in Vera.

"How often have I asked you not to take my things?" she said. "You
have a room of your own," and she took the inkstand from Nicholas.

"In a minute, in a minute," he said, dipping his pen.

"You always manage to do things at the wrong time," continued
Vera. "You came rushing into the drawing room so that everyone felt
ashamed of you."

Though what she said was quite just, perhaps for that very reason no
one replied, and the four simply looked at one another. She lingered
in the room with the inkstand in her hand.

"And at your age what secrets can there be between Natasha and
Boris, or between you two? It's all nonsense!"

"Now, Vera, what does it matter to you?" said Natasha in defense,
speaking very gently.

She seemed that day to be more than ever kind and affectionate to
everyone.

"Very silly," said Vera. "I am ashamed of you. Secrets indeed!"

"All have secrets of their own," answered Natasha, getting warmer.
"We don't interfere with you and Berg."

"I should think not," said Vera, "because there can never be
anything wrong in my behavior. But I'll just tell Mamma how you are
behaving with Boris."

"Natalya Ilynichna behaves very well to me," remarked Boris. "I have
nothing to complain of."

"Don't, Boris! You are such a diplomat that it is really
tiresome," said Natasha in a mortified voice that trembled slightly.
(She used the word "diplomat," which was just then much in vogue among
the children, in the special sense they attached to it.) "Why does she
bother me?" And she added, turning to Vera, "You'll never understand
it, because you've never loved anyone. You have no heart! You are a
Madame de Genlis and nothing more" (this nickname, bestowed on Vera by
Nicholas, was considered very stinging), "and your greatest pleasure
is to be unpleasant to people! Go and flirt with Berg as much as you
please," she finished quickly.

"I shall at any rate not run after a young man before visitors..."

"Well, now you've done what you wanted," put in Nicholas--"said
unpleasant things to everyone and upset them. Let's go to the
nursery."

All four, like a flock of scared birds, got up and left the room.

"The unpleasant things were said to me," remarked Vera, "I said none
to anyone."

"Madame de Genlis! Madame de Genlis!" shouted laughing voices
through the door.

The handsome Vera, who produced such an irritating and unpleasant
effect on everyone, smiled and, evidently unmoved by what had been
said to her, went to the looking glass and arranged her hair and
scarf. Looking at her own handsome face she seemed to become still
colder and calmer.


In the drawing room the conversation was still going on.

"Ah, my dear," said the countess, "my life is not all roses
either. Don't I know that at the rate we are living our means won't
last long? It's all the Club and his easygoing nature. Even in the
country do we get any rest? Theatricals, hunting, and heaven knows
what besides! But don't let's talk about me; tell me how you managed
everything. I often wonder at you, Annette--how at your age you can
rush off alone in a carriage to Moscow, to Petersburg, to those
ministers and great people, and know how to deal with them all! It's
quite astonishing. How did you get things settled? I couldn't possibly
do it."

"Ah, my love," answered Anna Mikhaylovna, "God grant you never
know what it is to be left a widow without means and with a son you
love to distraction! One learns many things then," she added with a
certain pride. "That lawsuit taught me much. When I want to see one of
those big people I write a note: 'Princess So-and-So desires an
interview with So and-So,' and then I take a cab and go myself two,
three, or four times--till I get what I want. I don't mind what they
think of me."

"Well, and to whom did you apply about Bory?" asked the countess.
"You see yours is already an officer in the Guards, while my
Nicholas is going as a cadet. There's no one to interest himself for
him. To whom did you apply?"

"To Prince Vasili. He was so kind. He at once agreed to
everything, and put the matter before the Emperor," said Princess Anna
Mikhaylovna enthusiastically, quite forgetting all the humiliation she
had endured to gain her end.

"Has Prince Vasili aged much?" asked the countess. "I have not
seen him since we acted together at the Rumyantsovs' theatricals. I
expect he has forgotten me. He paid me attentions in those days," said
the countess, with a smile.

"He is just the same as ever," replied Anna Mikhaylovna,
"overflowing with amiability. His position has not turned his head
at all. He said to me, 'I am sorry I can do so little for you, dear
Princess. I am at your command.' Yes, he is a fine fellow and a very
kind relation. But, Nataly, you know my love for my son: I would do
anything for his happiness! And my affairs are in such a bad way
that my position is now a terrible one," continued Anna Mikhaylovna,
sadly, dropping her voice. "My wretched lawsuit takes all I have and
makes no progress. Would you believe it, I have literally not a
penny and don't know how to equip Boris." She took out her
handkerchief and began to cry. "I need five hundred rubles, and have
only one twenty-five-ruble note. I am in such a state.... My only hope
now is in Count Cyril Vladimirovich Bezukhov. If he will not assist
his godson--you know he is Bory's godfather--and allow him something
for his maintenance, all my trouble will have been thrown away.... I
shall not be able to equip him."

The countess' eyes filled with tears and she pondered in silence.

"I often think, though, perhaps it's a sin," said the princess,
"that here lives Count Cyril Vladimirovich Bezukhov so rich, all
alone... that tremendous fortune... and what is his life worth? It's a
burden to him, and Bory's life is only just beginning...."

"Surely he will leave something to Boris," said the countess.

"Heaven only knows, my dear! These rich grandees are so selfish.
Still, I will take Boris and go to see him at once, and I shall
speak to him straight out. Let people think what they will of me, it's
really all the same to me when my son's fate is at stake." The
princess rose. "It's now two o'clock and you dine at four. There
will just be time."

And like a practical Petersburg lady who knows how to make the
most of time, Anna Mikhaylovna sent someone to call her son, and
went into the anteroom with him.

"Good-by, my dear," said she to the countess who saw her to the
door, and added in a whisper so that her son should not hear, "Wish me
good luck."

"Are you going to Count Cyril Vladimirovich, my dear?" said the
count coming out from the dining hall into the anteroom, and he added:
"If he is better, ask Pierre to dine with us. He has been to the
house, you know, and danced with the children. Be sure to invite
him, my dear. We will see how Taras distinguishes himself today. He
says Count Orlov never gave such a dinner as ours will be!"





CHAPTER XV

"My dear Boris," said Princess Anna Mikhaylovna to her son as
Countess Rostova's carriage in which they were seated drove over the
straw covered street and turned into the wide courtyard of Count Cyril
Vladimirovich Bezukhov's house. "My dear Boris," said the mother,
drawing her hand from beneath her old mantle and laying it timidly and
tenderly on her son's arm, "be affectionate and attentive to him.
Count Cyril Vladimirovich is your godfather after all, your future
depends on him. Remember that, my dear, and be nice to him, as you
so well know how to be."

"If only I knew that anything besides humiliation would come of
it..." answered her son coldly. "But I have promised and will do it
for your sake."

Although the hall porter saw someone's carriage standing at the
entrance, after scrutinizing the mother and son (who without asking to
be announced had passed straight through the glass porch between the
rows of statues in niches) and looking significantly at the lady's old
cloak, he asked whether they wanted the count or the princesses,
and, hearing that they wished to see the count, said his excellency
was worse today, and that his excellency was not receiving anyone.

"We may as well go back," said the son in French.

"My dear!" exclaimed his mother imploringly, again laying her hand
on his arm as if that touch might soothe or rouse him.

Boris said no more, but looked inquiringly at his mother without
taking off his cloak.

"My friend," said Anna Mikhaylovna in gentle tones, addressing the
hall porter, "I know Count Cyril Vladimirovich is very ill... that's
why I have come... I am a relation. I shall not disturb him, my
friend... I only need see Prince Vasili Sergeevich: he is staying
here, is he not? Please announce me."

The hall porter sullenly pulled a bell that rang upstairs, and
turned away.

"Princess Drubetskaya to see Prince Vasili Sergeevich," he called to
a footman dressed in knee breeches, shoes, and a swallow-tail coat,
who ran downstairs and looked over from the halfway landing.

The mother smoothed the folds of her dyed silk dress before a
large Venetian mirror in the wall, and in her trodden-down shoes
briskly ascended the carpeted stairs.

"My dear," she said to her son, once more stimulating him by a
touch, "you promised me!"

The son, lowering his eyes, followed her quietly.

They entered the large hall, from which one of the doors led to
the apartments assigned to Prince Vasili.

Just as the mother and son, having reached the middle of the hall,
were about to ask their way of an elderly footman who had sprung up as
they entered, the bronze handle of one of the doors turned and
Prince Vasili came out--wearing a velvet coat with a single star on
his breast, as was his custom when at home--taking leave of a
good-looking, dark-haired man. This was the celebrated Petersburg
doctor, Lorrain.

"Then it is certain?" said the prince.

"Prince, humanum est errare,* but..." replied the doctor, swallowing
his r's, and pronouncing the Latin words with a French accent.


*To err is human.


"Very well, very well..."

Seeing Anna Mikhaylovna and her son, Prince Vasili dismissed the
doctor with a bow and approached them silently and with a look of
inquiry. The son noticed that an expression of profound sorrow
suddenly clouded his mother's face, and he smiled slightly.

"Ah, Prince! In what sad circumstances we meet again! And how is our
dear invalid?" said she, as though unaware of the cold offensive
look fixed on her.

Prince Vasili stared at her and at Boris questioningly and
perplexed. Boris bowed politely. Prince Vasili without acknowledging
the bow turned to Anna Mikhaylovna, answering her query by a
movement of the head and lips indicating very little hope for the
patient.

"Is it possible?" exclaimed Anna Mikhaylovna. "Oh, how awful! It
is terrible to think.... This is my son," she added, indicating Boris.
"He wanted to thank you himself."

Boris bowed again politely.

"Believe me, Prince, a mother's heart will never forget what you
have done for us."

"I am glad I was able to do you a service, my dear Anna
Mikhaylovna," said Prince Vasili, arranging his lace frill, and in
tone and manner, here in Moscow to Anna Mikhaylovna whom he had placed
under an obligation, assuming an air of much greater importance than
he had done in Petersburg at Anna Scherer's reception.

"Try to serve well and show yourself worthy," added he, addressing
Boris with severity. "I am glad.... Are you here on leave?" he went on
in his usual tone of indifference.

"I am awaiting orders to join my new regiment, your excellency,"
replied Boris, betraying neither annoyance at the prince's brusque
manner nor a desire to enter into conversation, but speaking so
quietly and respectfully that the prince gave him a searching glance.

"Are you living with your mother?"

"I am living at Countess Rostova's," replied Boris, again adding,
"your excellency."

"That is, with Ilya Rostov who married Nataly Shinshina," said
Anna Mikhaylovna.

"I know, I know," answered Prince Vasili in his monotonous voice. "I
never could understand how Nataly made up her mind to marry that
unlicked bear! A perfectly absurd and stupid fellow, and a gambler
too, I am told."

"But a very kind man, Prince," said Anna Mikhaylovna with a pathetic
smile, as though she too knew that Count Rostov deserved this censure,
but asked him not to be too hard on the poor old man. "What do the
doctors say?" asked the princess after a pause, her worn face again
expressing deep sorrow.

"They give little hope," replied the prince.

"And I should so like to thank Uncle once for all his kindness to me
and Boris. He is his godson," she added, her tone suggesting that this
fact ought to give Prince Vasili much satisfaction.

Prince Vasili became thoughtful and frowned. Anna Mikhaylovna saw
that he was afraid of finding in her a rival for Count Bezukhov's
fortune, and hastened to reassure him.

"If it were not for my sincere affection and devotion to Uncle,"
said she, uttering the word with peculiar assurance and unconcern,
"I know his character: noble, upright... but you see he has no one
with him except the young princesses.... They are still young...." She
bent her head and continued in a whisper: "Has he performed his
final duty, Prince? How priceless are those last moments! It can
make things no worse, and it is absolutely necessary to prepare him if
he is so ill. We women, Prince," and she smiled tenderly, "always know
how to say these things. I absolutely must see him, however painful it
may be for me. I am used to suffering."

Evidently the prince understood her, and also understood, as he
had done at Anna Pavlovna's, that it would be difficult to get rid
of Anna Mikhaylovna.

"Would not such a meeting be too trying for him, dear Anna
Mikhaylovna?" said he. "Let us wait until evening. The doctors are
expecting a crisis."

"But one cannot delay, Prince, at such a moment! Consider that the
welfare of his soul is at stake. Ah, it is awful: the duties of a
Christian..."

A door of one of the inner rooms opened and one of the princesses,
the count's niece, entered with a cold, stern face. The length of
her body was strikingly out of proportion to her short legs. Prince
Vasili turned to her.

"Well, how is he?"

"Still the same; but what can you expect, this noise..." said the
princess, looking at Anna Mikhaylovna as at a stranger.

"Ah, my dear, I hardly knew you," said Anna Mikhaylovna with a happy
smile, ambling lightly up to the count's niece. "I have come, and am
at your service to help you nurse my uncle. I imagine what you have
gone through," and she sympathetically turned up her eyes.

The princess gave no reply and did not even smile, but left the room
as Anna Mikhaylovna took off her gloves and, occupying the position
she had conquered, settled down in an armchair, inviting Prince Vasili
to take a seat beside her.

"Boris," she said to her son with a smile, "I shall go in to see the
count, my uncle; but you, my dear, had better go to Pierre meanwhile
and don't forget to give him the Rostovs' invitation. They ask him
to dinner. I suppose he won't go?" she continued, turning to the
prince.

"On the contrary," replied the prince, who had plainly become
depressed, "I shall be only too glad if you relieve me of that young
man.... Here he is, and the count has not once asked for him."

He shrugged his shoulders. A footman conducted Boris down one flight
of stairs and up another, to Pierre's rooms.





CHAPTER XVI


Pierre, after all, had not managed to choose a career for himself in
Petersburg, and had been expelled from there for riotous conduct and
sent to Moscow. The story told about him at Count Rostov's was true.
Pierre had taken part in tying a policeman to a bear. He had now
been for some days in Moscow and was staying as usual at his
father's house. Though he expected that the story of his escapade
would be already known in Moscow and that the ladies about his father-
who were never favorably disposed toward him--would have used it to
turn the count against him, he nevertheless on the day of his
arrival went to his father's part of the house. Entering the drawing
room, where the princesses spent most of their time, he greeted the
ladies, two of whom were sitting at embroidery frames while a third
read aloud. It was the eldest who was reading--the one who had met
Anna Mikhaylovna. The two younger ones were embroidering: both were
rosy and pretty and they differed only in that one had a little mole
on her lip which made her much prettier. Pierre was received as if
he were a corpse or a leper. The eldest princess paused in her reading
and silently stared at him with frightened eyes; the second assumed
precisely the same expression; while the youngest, the one with the
mole, who was of a cheerful and lively disposition, bent over her
frame to hide a smile probably evoked by the amusing scene she
foresaw. She drew her wool down through the canvas and, scarcely
able to refrain from laughing, stooped as if trying to make out the
pattern.

"How do you do, cousin?" said Pierre. "You don't recognize me?"

"I recognize you only too well, too well."

"How is the count? Can I see him?" asked Pierre, awkwardly as usual,
but unabashed.

"The count is suffering physically and mentally, and apparently
you have done your best to increase his mental sufferings."

"Can I see the count?" Pierre again asked.

"Hm.... If you wish to kill him, to kill him outright, you can see
him... Olga, go and see whether Uncle's beef tea is ready--it is
almost time," she added, giving Pierre to understand that they were
busy, and busy making his father comfortable, while evidently he,
Pierre, was only busy causing him annoyance.

Olga went out. Pierre stood looking at the sisters; then he bowed
and said: "Then I will go to my rooms. You will let me know when I can
see him."

And he left the room, followed by the low but ringing laughter of
the sister with the mole.

Next day Prince Vasili had arrived and settled in the count's house.
He sent for Pierre and said to him: "My dear fellow, if you are
going to behave here as you did in Petersburg, you will end very
badly; that is all I have to say to you. The count is very, very
ill, and you must not see him at all."

Since then Pierre had not been disturbed and had spent the whole
time in his rooms upstairs.

When Boris appeared at his door Pierre was pacing up and down his
room, stopping occasionally at a corner to make menacing gestures at
the wall, as if running a sword through an invisible foe, and
glaring savagely over his spectacles, and then again resuming his
walk, muttering indistinct words, shrugging his shoulders and
gesticulating.

"England is done for," said he, scowling and pointing his finger
at someone unseen. "Mr. Pitt, as a traitor to the nation and to the
rights of man, is sentenced to..." But before Pierre--who at that
moment imagined himself to be Napoleon in person and to have just
effected the dangerous crossing of the Straits of Dover and captured
London--could pronounce Pitt's sentence, he saw a well-built and
handsome young officer entering his room. Pierre paused. He had left
Moscow when Boris was a boy of fourteen, and had quite forgotten
him, but in his usual impulsive and hearty way he took Boris by the
hand with a friendly smile.

"Do you remember me?" asked Boris quietly with a pleasant smile.
"I have come with my mother to see the count, but it seems he is not
well."

"Yes, it seems he is ill. People are always disturbing him,"
answered Pierre, trying to remember who this young man was.

Boris felt that Pierre did not recognize him but did not consider it
necessary to introduce himself, and without experiencing the least
embarrassment looked Pierre straight in the face.

"Count Rostov asks you to come to dinner today," said he, after a
considerable pause which made Pierre feel uncomfortable.

"Ah, Count Rostov!" exclaimed Pierre joyfully. "Then you are his
son, Ilya? Only fancy, I didn't know you at first. Do you remember how
we went to the Sparrow Hills with Madame Jacquot?... It's such an
age..."

"You are mistaken," said Boris deliberately, with a bold and
slightly sarcastic smile. "I am Boris, son of Princess Anna
Mikhaylovna Drubetskaya. Rostov, the father, is Ilya, and his son is
Nicholas. I never knew any Madame Jacquot."

Pierre shook his head and arms as if attacked by mosquitoes or bees.

"Oh dear, what am I thinking about? I've mixed everything up. One
has so many relatives in Moscow! So you are Boris? Of course. Well,
now we know where we are. And what do you think of the Boulogne
expedition? The English will come off badly, you know, if Napoleon
gets across the Channel. I think the expedition is quite feasible.
If only Villeneuve doesn't make a mess of things!"

Boris knew nothing about the Boulogne expedition; he did not read
the papers and it was the first time he had heard Villeneuve's name.

"We here in Moscow are more occupied with dinner parties and scandal
than with politics," said he in his quiet ironical tone. "I know
nothing about it and have not thought about it. Moscow is chiefly busy
with gossip," he continued. "Just now they are talking about you and
your father."

Pierre smiled in his good-natured way as if afraid for his
companion's sake that the latter might say something he would
afterwards regret. But Boris spoke distinctly, clearly, and dryly,
looking straight into Pierre's eyes.

"Moscow has nothing else to do but gossip," Boris went on.
"Everybody is wondering to whom the count will leave his fortune,
though he may perhaps outlive us all, as I sincerely hope he will..."

"Yes, it is all very horrid," interrupted Pierre, "very horrid."

Pierre was still afraid that this officer might inadvertently say
something disconcerting to himself.

"And it must seem to you," said Boris flushing slightly, but not
changing his tone or attitude, "it must seem to you that everyone is
trying to get something out of the rich man?"

"So it does," thought Pierre.

"But I just wish to say, to avoid misunderstandings, that you are
quite mistaken if you reckon me or my mother among such people. We are
very poor, but for my own part at any rate, for the very reason that
your father is rich, I don't regard myself as a relation of his, and
neither I nor my mother would ever ask or take anything from him."

For a long time Pierre could not understand, but when he did, he
jumped up from the sofa, seized Boris under the elbow in his quick,
clumsy way, and, blushing far more than Boris, began to speak with a
feeling of mingled shame and vexation.

"Well, this is strange! Do you suppose I... who could think?... I
know very well..."

But Boris again interrupted him.

"I am glad I have spoken out fully. Perhaps you did not like it? You
must excuse me," said he, putting Pierre at ease instead of being
put at ease by him, "but I hope I have not offended you. I always make
it a rule to speak out... Well, what answer am I to take? Will you
come to dinner at the Rostovs'?"

And Boris, having apparently relieved himself of an onerous duty and
extricated himself from an awkward situation and placed another in it,
became quite pleasant again.

"No, but I say," said Pierre, calming down, "you are a wonderful
fellow! What you have just said is good, very good. Of course you
don't know me. We have not met for such a long time... not since we
were children. You might think that I... I understand, quite
understand. I could not have done it myself, I should not have had the
courage, but it's splendid. I am very glad to have made your
acquaintance. It's queer," he added after a pause, "that you should
have suspected me!" He began to laugh. "Well, what of it! I hope we'll
get better acquainted," and he pressed Boris' hand. "Do you know, I
have not once been in to see the count. He has not sent for me.... I
am sorry for him as a man, but what can one do?"

"And so you think Napoleon will manage to get an army across?" asked
Boris with a smile.

Pierre saw that Boris wished to change the subject, and being of the
same mind he began explaining the advantages and disadvantages of
the Boulogne expedition.

A footman came in to summon Boris--the princess was going. Pierre,
in order to make Boris' better acquaintance, promised to come to
dinner, and warmly pressing his hand looked affectionately over his
spectacles into Boris' eyes. After he had gone Pierre continued pacing
up and down the room for a long time, no longer piercing an
imaginary foe with his imaginary sword, but smiling at the remembrance
of that pleasant, intelligent, and resolute young man.

As often happens in early youth, especially to one who leads a
lonely life, he felt an unaccountable tenderness for this young man
and made up his mind that they would be friends.

Prince Vasili saw the princess off. She held a handkerchief to her
eyes and her face was tearful.

"It is dreadful, dreadful!" she was saying, "but cost me what it may
I shall do my duty. I will come and spend the night. He must not be
left like this. Every moment is precious. I can't think why his nieces
put it off. Perhaps God will help me to find a way to prepare
him!... Adieu, Prince! May God support you..."

"Adieu, ma bonne," answered Prince Vasili turning away from her.

"Oh, he is in a dreadful state," said the mother to her son when
they were in the carriage. "He hardly recognizes anybody."

"I don't understand, Mamma--what is his attitude to Pierre?" asked
the son.

"The will will show that, my dear; our fate also depends on it."

"But why do you expect that he will leave us anything?"

"Ah, my dear! He is so rich, and we are so poor!"

"Well, that is hardly a sufficient reason, Mamma..."

"Oh, Heaven! How ill he is!" exclaimed the mother.





CHAPTER XVII

After Anna Mikhaylovna had driven off with her son to visit Count
Cyril Vladimirovich Bezukhov, Countess Rostova sat for a long time all
alone applying her handkerchief to her eyes. At last she rang.

"What is the matter with you, my dear?" she said crossly to the maid
who kept her waiting some minutes. "Don't you wish to serve me? Then
I'll find you another place."

The countess was upset by her friend's sorrow and humiliating
poverty, and was therefore out of sorts, a state of mind which with
her always found expression in calling her maid "my dear" and speaking
to her with exaggerated politeness.

"I am very sorry, ma'am," answered the maid.

"Ask the count to come to me."

The count came waddling in to see his wife with a rather guilty look
as usual.

"Well, little countess? What a saute of game au madere we are to
have, my dear! I tasted it. The thousand rubles I paid for Taras
were not ill-spent. He is worth it!"

He sat down by his wife, his elbows on his knees and his hands
ruffling his gray hair.

"What are your commands, little countess?"

"You see, my dear... What's that mess?" she said, pointing to his
waistcoat. "It's the saute, most likely," she added with a smile.
"Well, you see, Count, I want some money."

Her face became sad.

"Oh, little countess!"... and the count began bustling to get out
his pocketbook.

"I want a great deal, Count! I want five hundred rubles," and taking
out her cambric handkerchief she began wiping her husband's waistcoat.

"Yes, immediately, immediately! Hey, who's there?" he called out
in a tone only used by persons who are certain that those they call
will rush to obey the summons. "Send Dmitri to me!"

Dmitri, a man of good family who had been brought up in the
count's house and now managed all his affairs, stepped softly into the
room.

"This is what I want, my dear fellow," said the count to the
deferential young man who had entered. "Bring me..." he reflected a
moment, "yes, bring me seven hundred rubles, yes! But mind, don't
bring me such tattered and dirty notes as last time, but nice clean
ones for the countess."

"Yes, Dmitri, clean ones, please," said the countess, sighing
deeply.

"When would you like them, your excellency?" asked Dmitri. "Allow me
to inform you... But, don't be uneasy," he added, noticing that the
count was beginning to breathe heavily and quickly which was always
a sign of approaching anger. "I was forgetting... Do you wish it
brought at once?"

"Yes, yes; just so! Bring it. Give it to the countess."

"What a treasure that Dmitri is," added the count with a smile
when the young man had departed. "There is never any 'impossible'
with him. That's a thing I hate! Everything is possible."

"Ah, money, Count, money! How much sorrow it causes in the world,"
said the countess. "But I am in great need of this sum."

"You, my little countess, are a notorious spendthrift," said the
count, and having kissed his wife's hand he went back to his study.

When Anna Mikhaylovna returned from Count Bezukhov's the money,
all in clean notes, was lying ready under a handkerchief on the
countess' little table, and Anna Mikhaylovna noticed that something
was agitating her.

"Well, my dear?" asked the countess.

"Oh, what a terrible state he is in! One would not know him, he is
so ill! I was only there a few moments and hardly said a word..."

"Annette, for heaven's sake don't refuse me," the countess began,
with a blush that looked very strange on her thin, dignified,
elderly face, and she took the money from under the handkerchief.

Anna Mikhaylovna instantly guessed her intention and stooped to be
ready to embrace the countess at the appropriate moment.

"This is for Boris from me, for his outfit."

Anna Mikhaylovna was already embracing her and weeping. The countess
wept too. They wept because they were friends, and because they were
kindhearted, and because they--friends from childhood--had to think
about such a base thing as money, and because their youth was over....
But those tears were pleasant to them both.





CHAPTER XVIII


Countess Rostova, with her daughters and a large number of guests,
was already seated in the drawing room. The count took the gentlemen
into his study and showed them his choice collection of Turkish pipes.
From time to time he went out to ask: "Hasn't she come yet?" They were
expecting Marya Dmitrievna Akhrosimova, known in society as le
terrible dragon, a lady distinguished not for wealth or rank, but
for common sense and frank plainness of speech. Marya Dmitrievna was
known to the Imperial family as well as to all Moscow and
Petersburg, and both cities wondered at her, laughed privately at
her rudenesses, and told good stories about her, while none the less
all without exception respected and feared her.

In the count's room, which was full of tobacco smoke, they talked of
war that had been announced in a manifesto, and about the
recruiting. None of them had yet seen the manifesto, but they all knew
it had appeared. The count sat on the sofa between two guests who were
smoking and talking. He neither smoked nor talked, but bending his
head first to one side and then to the other watched the smokers
with evident pleasure and listened to the conversation of his two
neighbors, whom he egged on against each other.

One of them was a sallow, clean-shaven civilian with a thin and
wrinkled face, already growing old, though he was dressed like a
most fashionable young man. He sat with his legs up on the sofa as
if quite at home and, having stuck an amber mouthpiece far into his
mouth, was inhaling the smoke spasmodically and screwing up his
eyes. This was an old bachelor, Shinshin, a cousin of the countess', a
man with "a sharp tongue" as they said in Moscow society. He seemed to
be condescending to his companion. The latter, a fresh, rosy officer
of the Guards, irreproachably washed, brushed, and buttoned, held
his pipe in the middle of his mouth and with red lips gently inhaled
the smoke, letting it escape from his handsome mouth in rings. This
was Lieutenant Berg, an officer in the Semenov regiment with whom
Boris was to travel to join the army, and about whom Natasha had,
teased her elder sister Vera, speaking of Berg as her "intended."
The count sat between them and listened attentively. His favorite
occupation when not playing boston, a card game he was very fond of,
was that of listener, especially when he succeeded in setting two
loquacious talkers at one another.

"Well, then, old chap, mon tres honorable Alphonse Karlovich,"
said Shinshin, laughing ironically and mixing the most ordinary
Russian expressions with the choicest French phrases--which was a
peculiarity of his speech. "Vous comptez vous faire des rentes sur
l'etat;* you want to make something out of your company?"


*You expect to make an income out of the government.


"No, Peter Nikolaevich; I only want to show that in the cavalry
the advantages are far less than in the infantry. Just consider my own
position now, Peter Nikolaevich..."

Berg always spoke quietly, politely, and with great precision. His
conversation always related entirely to himself; he would remain
calm and silent when the talk related to any topic that had no
direct bearing on himself. He could remain silent for hours without
being at all put out of countenance himself or making others
uncomfortable, but as soon as the conversation concerned himself he
would begin to talk circumstantially and with evident satisfaction.

"Consider my position, Peter Nikolaevich. Were I in the cavalry I
should get not more than two hundred rubles every four months, even
with the rank of lieutenant; but as it is I receive two hundred and
thirty," said he, looking at Shinshin and the count with a joyful,
pleasant smile, as if it were obvious to him that his success must
always be the chief desire of everyone else.

"Besides that, Peter Nikolaevich, by exchanging into the Guards I
shall be in a more prominent position," continued Berg, "and vacancies
occur much more frequently in the Foot Guards. Then just think what
can be done with two hundred and thirty rubles! I even manage to put a
little aside and to send something to my father," he went on, emitting
a smoke ring.

"La balance y est...* A German knows how to skin a flint, as the
proverb says," remarked Shinshin, moving his pipe to the other side of
his mouth and winking at the count.


*So that squares matters.


The count burst out laughing. The other guests seeing that
Shinshin was talking came up to listen. Berg, oblivious of irony or
indifference, continued to explain how by exchanging into the Guards
he had already gained a step on his old comrades of the Cadet Corps;
how in wartime the company commander might get killed and he, as
senior in the company, might easily succeed to the post; how popular
he was with everyone in the regiment, and how satisfied his father was
with him. Berg evidently enjoyed narrating all this, and did not
seem to suspect that others, too, might have their own interests.
But all he said was so prettily sedate, and the naivete of his
youthful egotism was so obvious, that he disarmed his hearers.

"Well, my boy, you'll get along wherever you go--foot or horse--that
I'll warrant," said Shinshin, patting him on the shoulder and taking
his feet off the sofa.

Berg smiled joyously. The count, by his guests, went into the
drawing room.

It was just the moment before a big dinner when the assembled
guests, expecting the summons to zakuska,* avoid engaging in any
long conversation but think it necessary to move about and talk, in
order to show that they are not at all impatient for their food. The
host and hostess look toward the door, and now and then glance at
one another, and the visitors try to guess from these glances who,
or what, they are waiting for--some important relation who has not yet
arrived, or a dish that is not yet ready.


*Hors d'oeuvres.


Pierre had come just at dinnertime and was sitting awkwardly in
the middle of the drawing room on the first chair he had come
across, blocking the way for everyone. The countess tried to make
him talk, but he went on naively looking around through his spectacles
as if in search of somebody and answered all her questions in
monosyllables. He was in the way and was the only one who did not
notice the fact. Most of the guests, knowing of the affair with the
bear, looked with curiosity at this big, stout, quiet man, wondering
how such a clumsy, modest fellow could have played such a prank on a
policeman.

"You have only lately arrived?" the countess asked him.

"Oui, madame," replied he, looking around him.

"You have not yet seen my husband?"

"Non, madame." He smiled quite inappropriately.

"You have been in Paris recently, I believe? I suppose it's very
interesting."

"Very interesting."

The countess exchanged glances with Anna Mikhaylovna. The latter
understood that she was being asked to entertain this young man, and
sitting down beside him she began to speak about his father; but he
answered her, as he had the countess, only in monosyllables. The other
guests were all conversing with one another. "The Razumovskis... It
was charming... You are very kind... Countess Apraksina..." was
heard on all sides. The countess rose and went into the ballroom.

"Marya Dmitrievna?" came her voice from there.

"Herself," came the answer in a rough voice, and Marya Dmitrievna
entered the room.

All the unmarried ladies and even the married ones except the very
oldest rose. Marya Dmitrievna paused at the door. Tall and stout,
holding high her fifty-year-old head with its gray curls, she stood
surveying the guests, and leisurely arranged her wide sleeves as if
rolling them up. Marya Dmitrievna always spoke in Russian.

"Health and happiness to her whose name day we are keeping and to
her children," she said, in her loud, full-toned voice which drowned
all others. "Well, you old sinner," she went on, turning to the
count who was kissing her hand, "you're feeling dull in Moscow, I
daresay? Nowhere to hunt with your dogs? But what is to be done, old
man? Just see how these nestlings are growing up," and she pointed
to the girls. "You must look for husbands for them whether you like it
or not...."

"Well," said she, "how's my Cossack?" (Marya Dmitrievna always called
Natasha a Cossack) and she stroked the child's arm as she came up
fearless and gay to kiss her hand. "I know she's a scamp of a girl,
but I like her."

She took a pair of pear-shaped ruby earrings from her huge
reticule and, having given them to the rosy Natasha, who beamed with
the pleasure of her saint's-day fete, turned away at once and
addressed herself to Pierre.

"Eh, eh, friend! Come here a bit," said she, assuming a soft high
tone of voice. "Come here, my friend..." and she ominously tucked up
her sleeves still higher. Pierre approached, looking at her in a
childlike way through his spectacles.

"Come nearer, come nearer, friend! I used to be the only one to tell
your father the truth when he was in favor, and in your case it's my
evident duty." She paused. All were silent, expectant of what was to
follow, for this was dearly only a prelude.

"A fine lad! My word! A fine lad!... His father lies on his deathbed
and he amuses himself setting a policeman astride a bear! For shame,
sir, for shame! It would be better if you went to the war."

She turned away and gave her hand to the count, who could hardly
keep from laughing.

"Well, I suppose it is time we were at table?" said Marya
Dmitrievna.

The count went in first with Marya Dmitrievna, the countess followed
on the arm of a colonel of hussars, a man of importance to them
because Nicholas was to go with him to the regiment; then came Anna
Mikhaylovna with Shinshin. Berg gave his arm to Vera. The smiling
Julie Karagina went in with Nicholas. After them other couples
followed, filling the whole dining hall, and last of all the children,
tutors, and governesses followed singly. The footmen began moving
about, chairs scraped, the band struck up in the gallery, and the
guests settled down in their places. Then the strains of the count's
household band were replaced by the clatter of knives and forks, the
voices of visitors, and the soft steps of the footmen. At one end of
the table sat the countess with Marya Dmitrievna on her right and Anna
Mikhaylovna on her left, the other lady visitors were farther down. At
the other end sat the count, with the hussar colonel on his left and
Shinshin and the other male visitors on his right. Midway down the
long table on one side sat the grownup young people: Vera beside Berg,
and Pierre beside Boris; and on the other side, the children,
tutors, and governesses. From behind the crystal decanters and fruit
vases the count kept glancing at his wife and her tall cap with its
light-blue ribbons, and busily filled his neighbors' glasses, not
neglecting his own. The countess in turn, without omitting her
duties as hostess, threw significant glances from behind the
pineapples at her husband whose face and bald head seemed by their
redness to contrast more than usual with his gray hair. At the ladies'
end an even chatter of voices was heard all the time, at the men's end
the voices sounded louder and louder, especially that of the colonel
of hussars who, growing more and more flushed, ate and drank so much
that the count held him up as a pattern to the other guests. Berg with
tender smiles was saying to Vera that love is not an earthly but a
heavenly feeling. Boris was telling his new friend Pierre who the
guests were and exchanging glances with Natasha, who was sitting
opposite. Pierre spoke little but examined the new faces, and ate a
great deal. Of the two soups he chose turtle with savory patties and
went on to the game without omitting a single dish or one of the
wines. These latter the butler thrust mysteriously forward, wrapped in
a napkin, from behind the next man's shoulders and whispered: "Dry
Madeira"... "Hungarian"... or "Rhine wine" as the case might be. Of
the four crystal glasses engraved with the count's monogram that stood
before his plate, Pierre held out one at random and drank with
enjoyment, gazing with ever-increasing amiability at the other guests.
Natasha, who sat opposite, was looking at Boris as girls of thirteen
look at the boy they are in love with and have just kissed for the
first time. Sometimes that same look fell on Pierre, and that funny
lively little girl's look made him inclined to laugh without knowing
why.

Nicholas sat at some distance from Sonya, beside Julie Karagina,
to whom he was again talking with the same involuntary smile. Sonya
wore a company smile but was evidently tormented by jealousy; now
she turned pale, now blushed and strained every nerve to overhear what
Nicholas and Julie were saying to one another. The governess kept
looking round uneasily as if preparing to resent any slight that might
be put upon the children. The German tutor was trying to remember
all the dishes, wines, and kinds of dessert, in order to send a full
description of the dinner to his people in Germany; and he felt
greatly offended when the butler with a bottle wrapped in a napkin
passed him by. He frowned, trying to appear as if he did not want
any of that wine, but was mortified because no one would understand
that it was not to quench his thirst or from greediness that he wanted
it, but simply from a conscientious desire for knowledge.





CHAPTER XIX


At the men's end of the table the talk grew more and more
animated. The colonel told them that the declaration of war had
already appeared in Petersburg and that a copy, which he had himself
seen, had that day been forwarded by courier to the commander in
chief.

"And why the deuce are we going to fight Bonaparte?" remarked
Shinshin. "He has stopped Austria's cackle and I fear it will be our
turn next."

The colonel was a stout, tall, plethoric German, evidently devoted
to the service and patriotically Russian. He resented Shinshin's
remark.

"It is for the reasson, my goot sir," said he, speaking with a
German accent, "for the reasson zat ze Emperor knows zat. He
declares in ze manifessto zat he cannot fiew wiz indifference ze
danger vreatening Russia and zat ze safety and dignity of ze Empire as
vell as ze sanctity of its alliances..." he spoke this last word
with particular emphasis as if in it lay the gist of the matter.

Then with the unerring official memory that characterized him he
repeated from the opening words of the manifesto:

... and the wish, which constitutes the Emperor's sole and
absolute aim--to establish peace in Europe on firm foundations--has
now decided him to despatch part of the army abroad and to create a
new condition for the attainment of that purpose.

"Zat, my dear sir, is vy..." he concluded, drinking a tumbler of
wine with dignity and looking to the count for approval.

"Connaissez-vous le Proverbe:* 'Jerome, Jerome, do not roam, but
turn spindles at home!'?" said Shinshin, puckering his brows and
smiling. "Cela nous convient a merveille.*[2] Suvorov now--he knew
what he was about; yet they beat him a plate couture,*[3] and where
are we to find Suvorovs now? Je vous demande un peu,"*[4] said he,
continually changing from French to Russian.


*Do you know the proverb?

*[2] That suits us down to the ground.

*[3] Hollow.

*[4] I just ask you that.


"Ve must vight to the last tr-r-op of our plood!" said the
colonel, thumping the table; "and ve must tie for our Emperor, and zen
all vill pe vell. And ve must discuss it as little as po-o-ossible"...
he dwelt particularly on the word possible... "as po-o-ossible," he
ended, again turning to the count. "Zat is how ve old hussars look
at it, and zere's an end of it! And how do you, a young man and a
young hussar, how do you judge of it?" he added, addressing
Nicholas, who when he heard that the war was being discussed had
turned from his partner with eyes and ears intent on the colonel.

"I am quite of your opinion," replied Nicholas, flaming up,
turning his plate round and moving his wineglasses about with as
much decision and desperation as though he were at that moment
facing some great danger. "I am convinced that we Russians must die or
conquer," he concluded, conscious--as were others--after the words
were uttered that his remarks were too enthusiastic and emphatic for
the occasion and were therefore awkward.

"What you said just now was splendid!" said his partner Julie.

Sonya trembled all over and blushed to her ears and behind them
and down to her neck and shoulders while Nicholas was speaking.

Pierre listened to the colonel's speech and nodded approvingly.

"That's fine," said he.

"The young man's a real hussar!" shouted the colonel, again thumping
the table.

"What are you making such a noise about over there?" Marya
Dmitrievna's deep voice suddenly inquired from the other end of the
table. "What are you thumping the table for?" she demanded of the
hussar, "and why are you exciting yourself? Do you think the French
are here?"

"I am speaking ze truce," replied the hussar with a smile.

"It's all about the war," the count shouted down the table. "You
know my son's going, Marya Dmitrievna? My son is going."

"I have four sons in the army but still I don't fret. It is all in
God's hands. You may die in your bed or God may spare you in a
battle," replied Marya Dmitrievna's deep voice, which easily carried
the whole length of the table.

"That's true!"

Once more the conversations concentrated, the ladies' at the one end
and the men's at the other.

"You won't ask," Natasha's little brother was saying; "I know you
won't ask!"

"I will," replied Natasha.

Her face suddenly flushed with reckless and joyous resolution. She
half rose, by a glance inviting Pierre, who sat opposite, to listen to
what was coming, and turning to her mother:

"Mamma!" rang out the clear contralto notes of her childish voice,
audible the whole length of the table.

"What is it?" asked the countess, startled; but seeing by her
daughter's face that it was only mischief, she shook a finger at her
sternly with a threatening and forbidding movement of her head.

The conversation was hushed.

"Mamma! What sweets are we going to have?" and Natasha's voice
sounded still more firm and resolute.

The countess tried to frown, but could not. Marya Dmitrievna shook
her fat finger.

"Cossack!" she said threateningly.

Most of the guests, uncertain how to regard this sally, looked at
the elders.

"You had better take care!" said the countess.

"Mamma! What sweets are we going to have?" Natasha again cried
boldly, with saucy gaiety, confident that her prank would be taken
in good part.

Sonya and fat little Petya doubled up with laughter.

"You see! I have asked," whispered Natasha to her little brother and
to Pierre, glancing at him again.

"Ice pudding, but you won't get any," said Marya Dmitrievna.

Natasha saw there was nothing to be afraid of and so she braved even
Marya Dmitrievna.

"Marya Dmitrievna! What kind of ice pudding? I don't like ice
cream."

"Carrot ices."

"No! What kind, Marya Dmitrievna? What kind?" she almost screamed;
"I want to know!"

Marya Dmitrievna and the countess burst out laughing, and all the
guests joined in. Everyone laughed, not at Marya Dmitrievna's answer
but at the incredible boldness and smartness of this little girl who
had dared to treat Marya Dmitrievna in this fashion.

Natasha only desisted when she had been told that there would be
pineapple ice. Before the ices, champagne was served round. The band
again struck up, the count and countess kissed, and the guests,
leaving their seats, went up to "congratulate" the countess, and
reached across the table to clink glasses with the count, with the
children, and with one another. Again the footmen rushed about, chairs
scraped, and in the same order in which they had entered but with
redder faces, the guests returned to the drawing room and to the
count's study.





CHAPTER XX


The card tables were drawn out, sets made up for boston, and the
count's visitors settled themselves, some in the two drawing rooms,
some in the sitting room, some in the library.

The count, holding his cards fanwise, kept himself with difficulty
from dropping into his usual after-dinner nap, and laughed at
everything. The young people, at the countess' instigation, gathered
round the clavichord and harp. Julie by general request played
first. After she had played a little air with variations on the
harp, she joined the other young ladies in begging Natasha and
Nicholas, who were noted for their musical talent, to sing
something. Natasha, who was treated as though she were grown up, was
evidently very proud of this but at the same time felt shy.

"What shall we sing?" she said.

"'The Brook,'" suggested Nicholas.

"Well, then, let's be quick. Boris, come here," said Natasha. "But
where is Sonya?"

She looked round and seeing that her friend was not in the room
ran to look for her.

Running into Sonya's room and not finding her there, Natasha ran
to the nursery, but Sonya was not there either. Natasha concluded that
she must be on the chest in the passage. The chest in the passage
was the place of mourning for the younger female generation in the
Rostov household. And there in fact was Sonya lying face downward on
Nurse's dirty feather bed on the top of the chest, crumpling her gauzy
pink dress under her, hiding her face with her slender fingers, and
sobbing so convulsively that her bare little shoulders shook.
Natasha's face, which had been so radiantly happy all that saint's
day, suddenly changed: her eyes became fixed, and then a shiver passed
down her broad neck and the corners of her mouth drooped.

"Sonya! What is it? What is the matter?... Oo... Oo... Oo...!" And
Natasha's large mouth widened, making her look quite ugly, and she
began to wail like a baby without knowing why, except that Sonya was
crying. Sonya tried to lift her head to answer but could not, and
hid her face still deeper in the bed. Natasha wept, sitting on the
blue-striped feather bed and hugging her friend. With an effort
Sonya sat up and began wiping her eyes and explaining.

"Nicholas is going away in a week's time, his... papers... have
come... he told me himself... but still I should not cry," and she
showed a paper she held in her hand--with the verses Nicholas had
written, "still, I should not cry, but you can't... no one can
understand... what a soul he has!"

And she began to cry again because he had such a noble soul.

"It's all very well for you... I am not envious... I love you and
Boris also," she went on, gaining a little strength; "he is nice...
there are no difficulties in your way.... But Nicholas is my cousin...
one would have to... the Metropolitan himself... and even then it
can't be done. And besides, if she tells Mamma" (Sonya looked upon the
countess as her mother and called her so) "that I am spoiling
Nicholas' career and am heartless and ungrateful, while truly... God
is my witness," and she made the sign of the cross, "I love her so
much, and all of you, only Vera... And what for? What have I done to
her? I am so grateful to you that I would willingly sacrifice
everything, only I have nothing...."

Sonya could not continue, and again hid her face in her hands and in
the feather bed. Natasha began consoling her, but her face showed that

she understood all the gravity of her friend's trouble.

"Sonya," she suddenly exclaimed, as if she had guessed the true
reason of her friend's sorrow, "I'm sure Vera has said something to
you since dinner? Hasn't she?"

"Yes, these verses Nicholas wrote himself and I copied some
others, and she found them on my table and said she'd show them to
Mamma, and that I was ungrateful, and that Mamma would never allow him
to marry me, but that he'll marry Julie. You see how he's been with
her all day... Natasha, what have I done to deserve it?..."

And again she began to sob, more bitterly than before. Natasha
lifted her up, hugged her, and, smiling through her tears, began
comforting her.

"Sonya, don't believe her, darling! Don't believe her! Do you
remember how we and Nicholas, all three of us, talked in the sitting
room after supper? Why, we settled how everything was to be. I don't
quite remember how, but don't you remember that it could all be
arranged and how nice it all was? There's Uncle Shinshin's brother has
married his first cousin. And we are only second cousins, you know.
And Boris says it is quite possible. You know I have told him all
about it. And he is so clever and so good!" said Natasha. "Don't you
cry, Sonya, dear love, darling Sonya!" and she kissed her and laughed.
"Vera's spiteful; never mind her! And all will come right and she
won't say anything to Mamma. Nicholas will tell her himself, and he
doesn't care at all for Julie."

Natasha kissed her on the hair.

Sonya sat up. The little kitten brightened, its eyes shone, and it
seemed ready to lift its tail, jump down on its soft paws, and begin
playing with the ball of worsted as a kitten should.

"Do you think so?... Really? Truly?" she said, quickly smoothing her
frock and hair.

"Really, truly!" answered Natasha, pushing in a crisp lock that
had strayed from under her friend's plaits.

Both laughed.

"Well, let's go and sing 'The Brook.'"

"Come along!"

"Do you know, that fat Pierre who sat opposite me is so funny!" said
Natasha, stopping suddenly. "I feel so happy!"

And she set off at a run along the passage.

Sonya, shaking off some down which clung to her and tucking away the
verses in the bosom of her dress close to her bony little chest, ran
after Natasha down the passage into the sitting room with flushed face
and light, joyous steps. At the visitors' request the young people
sang the quartette, "The Brook," with which everyone was delighted.
Then Nicholas sang a song he had just learned:


   At nighttime in the moon's fair glow
     How sweet, as fancies wander free,
   To feel that in this world there's one
     Who still is thinking but of thee!

   That while her fingers touch the harp
     Wafting sweet music music the lea,
   It is for thee thus swells her heart,
     Sighing its message out to thee...

   A day or two, then bliss unspoilt,
     But oh! till then I cannot live!...


He had not finished the last verse before the young people began
to get ready to dance in the large hall, and the sound of the feet and
the coughing of the musicians were heard from the gallery.


Pierre was sitting in the drawing-room where Shinshin had engaged
him, as a man recently returned from abroad, in a political
conversation in which several others joined but which bored Pierre.
When the music began Natasha came in and walking straight up to Pierre
said, laughing and blushing:

"Mamma told me to ask you to join the dancers."

"I am afraid of mixing the figures," Pierre replied; "but if you
will be my teacher..." And lowering his big arm he offered it to the
slender little girl.

While the couples were arranging themselves and the musicians tuning
up, Pierre sat down with his little partner. Natasha was perfectly
happy; she was dancing with a grown-up man, who had been abroad. She
was sitting in a conspicuous place and talking to him like a
grown-up lady. She had a fan in her hand that one of the ladies had
given her to hold. Assuming quite the pose of a society woman
(heaven knows when and where she had learned it) she talked with her
partner, fanning herself and smiling over the fan.

"Dear, dear! Just look at her!" exclaimed the countess as she
crossed the ballroom, pointing to Natasha.

Natasha blushed and laughed.

"Well, really, Mamma! Why should you? What is there to be
surprised at?"


In the midst of the third ecossaise there was a clatter of chairs
being pushed back in the sitting room where the count and Marya
Dmitrievna had been playing cards with the majority of the more
distinguished and older visitors. They now, stretching themselves
after sitting so long, and replacing their purses and pocketbooks,
entered the ballroom. First came Marya Dmitrievna and the count,
both with merry countenances. The count, with playful ceremony
somewhat in ballet style, offered his bent arm to Marya Dmitrievna. He
drew himself up, a smile of debonair gallantry lit up his face and
as soon as the last figure of the ecossaise was ended, he clapped
his hands to the musicians and shouted up to their gallery, addressing
the first violin:

"Semen! Do you know the Daniel Cooper?"

This was the count's favorite dance, which he had danced in his
youth. (Strictly speaking, Daniel Cooper was one figure of the
anglaise.)

"Look at Papa!" shouted Natasha to the whole company, and quite
forgetting that she was dancing with a grown-up partner she bent her
curly head to her knees and made the whole room ring with her
laughter.

And indeed everybody in the room looked with a smile of pleasure
at the jovial old gentleman, who standing beside his tall and stout
partner, Marya Dmitrievna, curved his arms, beat time, straightened
his shoulders, turned out his toes, tapped gently with his foot,
and, by a smile that broadened his round face more and more,
prepared the onlookers for what was to follow. As soon as the
provocatively gay strains of Daniel Cooper (somewhat resembling
those of a merry peasant dance) began to sound, all the doorways of
the ballroom were suddenly filled by the domestic serfs--the men on
one side and the women on the other--who with beaming faces had come
to see their master making merry.

"Just look at the master! A regular eagle he is!" loudly remarked
the nurse, as she stood in one of the doorways.

The count danced well and knew it. But his partner could not and did
not want to dance well. Her enormous figure stood erect, her
powerful arms hanging down (she had handed her reticule to the
countess), and only her stern but handsome face really joined in the
dance. What was expressed by the whole of the count's plump figure, in
Marya Dmitrievna found expression only in her more and more beaming
face and quivering nose. But if the count, getting more and more
into the swing of it, charmed the spectators by the unexpectedness
of his adroit maneuvers and the agility with which he capered about on
his light feet, Marya Dmitrievna produced no less impression by slight
exertions--the least effort to move her shoulders or bend her arms
when turning, or stamp her foot--which everyone appreciated in view of
her size and habitual severity. The dance grew livelier and
livelier. The other couples could not attract a moment's attention
to their own evolutions and did not even try to do so. All were
watching the count and Marya Dmitrievna. Natasha kept pulling everyone
by sleeve or dress, urging them to "look at Papa!" though as it was
they never took their eyes off the couple. In the intervals of the
dance the count, breathing deeply, waved and shouted to the
musicians to play faster. Faster, faster, and faster; lightly, more
lightly, and yet more lightly whirled the count, flying round Marya
Dmitrievna, now on his toes, now on his heels; until, turning his
partner round to her seat, he executed the final pas, raising his soft
foot backwards, bowing his perspiring head, smiling and making a
wide sweep with his arm, amid a thunder of applause and laughter led
by Natasha. Both partners stood still, breathing heavily and wiping
their faces with their cambric handkerchiefs.

"That's how we used to dance in our time, ma chere," said the count.

"That was a Daniel Cooper!" exclaimed Marya Dmitrievna, tucking up
her sleeves and puffing heavily.





CHAPTER XXI


While in the Rostovs' ballroom the sixth anglaise was being
danced, to a tune in which the weary musicians blundered, and while
tired footmen and cooks were getting the supper, Count Bezukhov had
a sixth stroke. The doctors pronounced recovery impossible. After a
mute confession, communion was administered to the dying man,
preparations made for the sacrament of unction, and in his house there
was the bustle and thrill of suspense usual at such moments. Outside
the house, beyond the gates, a group of undertakers, who hid
whenever a carriage drove up, waited in expectation of an important
order for an expensive funeral. The Military Governor of Moscow, who
had been assiduous in sending aides-de-camp to inquire after the
count's health, came himself that evening to bid a last farewell to
the celebrated grandee of Catherine's court, Count Bezukhov.

The magnificent reception room was crowded. Everyone stood up
respectfully when the Military Governor, having stayed about half an
hour alone with the dying man, passed out, slightly acknowledging
their bows and trying to escape as quickly as from the glances fixed
on him by the doctors, clergy, and relatives of the family. Prince
Vasili, who had grown thinner and paler during the last few days,
escorted him to the door, repeating something to him several times
in low tones.

When the Military Governor had gone, Prince Vasili sat down all
alone on a chair in the ballroom, crossing one leg high over the
other, leaning his elbow on his knee and covering his face with his
hand. After sitting so for a while he rose, and, looking about him
with frightened eyes, went with unusually hurried steps down the
long corridor leading to the back of the house, to the room of the
eldest princess.

Those who were in the dimly lit reception room spoke in nervous
whispers, and, whenever anyone went into or came from the dying
man's room, grew silent and gazed with eyes full of curiosity or
expectancy at his door, which creaked slightly when opened.

"The limits of human life... are fixed and may not be o'erpassed,"
said an old priest to a lady who had taken a seat beside him and was
listening naively to his words.

"I wonder, is it not too late to administer unction?" asked the
lady, adding the priest's clerical title, as if she had no opinion
of her own on the subject.

"Ah, madam, it is a great sacrament," replied the priest, passing
his hand over the thin grizzled strands of hair combed back across his
bald head.

"Who was that? The Military Governor himself?" was being asked at
the other side of the room. "How young-looking he is!"

"Yes, and he is over sixty. I hear the count no longer recognizes
anyone. They wished to administer the sacrament of unction."

"I knew someone who received that sacrament seven times."

The second princess had just come from the sickroom with her eyes
red from weeping and sat down beside Dr. Lorrain, who was sitting in a
graceful pose under a portrait of Catherine, leaning his elbow on a
table.

"Beautiful," said the doctor in answer to a remark about the
weather. "The weather is beautiful, Princess; and besides, in Moscow
one feels as if one were in the country."

"Yes, indeed," replied the princess with a sigh. "So he may have
something to drink?"

Lorrain considered.

"Has he taken his medicine?"

"Yes."

The doctor glanced at his watch.

"Take a glass of boiled water and put a pinch of cream of tartar,"
and he indicated with his delicate fingers what he meant by a pinch.

"Dere has neffer been a gase," a German doctor was saying to an
aide-de-camp, "dat one liffs after de sird stroke."

"And what a well-preserved man he was!" remarked the aide-de-camp.
"And who will inherit his wealth?" he added in a whisper.

"It von't go begging," replied the German with a smile.

Everyone again looked toward the door, which creaked as the second
princess went in with the drink she had prepared according to
Lorrain's instructions. The German doctor went up to Lorrain.

"Do you think he can last till morning?" asked the German,
addressing Lorrain in French which he pronounced badly.

Lorrain, pursing up his lips, waved a severely negative finger
before his nose.

"Tonight, not later," said he in a low voice, and he moved away with
a decorous smile of self-satisfaction at being able clearly to
understand and state the patient's condition.


Meanwhile Prince Vasili had opened the door into the princess' room.

In this room it was almost dark; only two tiny lamps were burning
before the icons and there was a pleasant scent of flowers and burnt
pastilles. The room was crowded with small pieces of furniture,
whatnots, cupboards, and little tables. The quilt of a high, white
feather bed was just visible behind a screen. A small dog began to
bark.

"Ah, is it you, cousin?"

She rose and smoothed her hair, which was as usual so extremely
smooth that it seemed to be made of one piece with her head and
covered with varnish.

"Has anything happened?" she asked. "I am so terrified."

"No, there is no change. I only came to have a talk about
business, Catiche,"* muttered the prince, seating himself wearily on
the chair she had just vacated. "You have made the place warm, I
must say," he remarked. "Well, sit down: let's have a talk."


*Catherine.


"I thought perhaps something had happened," she said with her
unchanging stonily severe expression; and, sitting down opposite the
prince, she prepared to listen.

"I wished to get a nap, mon cousin, but I can't."

"Well, my dear?" said Prince Vasili, taking her hand and bending
it downwards as was his habit.

It was plain that this "well?" referred to much that they both
understood without naming.

The princess, who had a straight, rigid body, abnormally long for
her legs, looked directly at Prince Vasili with no sign of emotion
in her prominent gray eyes. Then she shook her head and glanced up
at the icons with a sigh. This might have been taken as an
expression of sorrow and devotion, or of weariness and hope of resting
before long. Prince Vasili understood it as an expression of
weariness.

"And I?" he said; "do you think it is easier for me? I am as worn
out as a post horse, but still I must have a talk with you, Catiche, a
very serious talk."

Prince Vasili said no more and his cheeks began to twitch nervously,
now on one side, now on the other, giving his face an unpleasant
expression which was never to be seen on it in a drawing room. His
eyes too seemed strange; at one moment they looked impudently sly
and at the next glanced round in alarm.

The princess, holding her little dog on her lap with her thin bony
hands, looked attentively into Prince Vasili's eyes evidently resolved
not to be the first to break silence, if she had to wait till morning.

"Well, you see, my dear princess and cousin, Catherine Semenovna,"
continued Prince Vasili, returning to his theme, apparently not
without an inner struggle; "at such a moment as this one must think of
everything. One must think of the future, of all of you... I love
you all, like children of my own, as you know."

The princess continued to look at him without moving, and with the
same dull expression.

"And then of course my family has also to be considered," Prince
Vasili went on, testily pushing away a little table without looking at
her. "You know, Catiche, that we--you three sisters, Mamontov, and
my wife--are the count's only direct heirs. I know, I know how hard it
is for you to talk or think of such matters. It is no easier for me;
but, my dear, I am getting on for sixty and must be prepared for
anything. Do you know I have sent for Pierre? The count," pointing
to his portrait, "definitely demanded that he should be called."

Prince Vasili looked questioningly at the princess, but could not
make out whether she was considering what he had just said or
whether she was simply looking at him.

"There is one thing I constantly pray God to grant, mon cousin," she
replied, "and it is that He would be merciful to him and would allow
his noble soul peacefully to leave this..."

"Yes, yes, of course," interrupted Prince Vasili impatiently,
rubbing his bald head and angrily pulling back toward him the little
table that he had pushed away. "But... in short, the fact is... you
know yourself that last winter the count made a will by which he
left all his property, not to us his direct heirs, but to Pierre."

"He has made wills enough!" quietly remarked the princess. "But he
cannot leave the estate to Pierre. Pierre is illegitimate."

"But, my dear," said Prince Vasili suddenly, clutching the little
table and becoming more animated and talking more rapidly: "what if
a letter has been written to the Emperor in which the count asks for
Pierre's legitimation? Do you understand that in consideration of
the count's services, his request would be granted?..."

The princess smiled as people do who think they know more about
the subject under discussion than those they are talking with.

"I can tell you more," continued Prince Vasili, seizing her hand,
"that letter was written, though it was not sent, and the Emperor knew
of it. The only question is, has it been destroyed or not? If not,
then as soon as all is over," and Prince Vasili sighed to intimate
what he meant by the words all is over, "and the count's papers are
opened, the will and letter will be delivered to the Emperor, and
the petition will certainly be granted. Pierre will get everything
as the legitimate son."

"And our share?" asked the princess smiling ironically, as if
anything might happen, only not that.

"But, my poor Catiche, it is as clear as daylight! He will then be
the legal heir to everything and you won't get anything. You must
know, my dear, whether the will and letter were written, and whether
they have been destroyed or not. And if they have somehow been
overlooked, you ought to know where they are, and must find them,
because..."

"What next?" the princess interrupted, smiling sardonically and
not changing the expression of her eyes. "I am a woman, and you
think we are all stupid; but I know this: an illegitimate son cannot
inherit... un batard!"* she added, as if supposing that this
translation of the word would effectively prove to Prince Vasili the
invalidity of his contention.


*A bastard.


"Well, really, Catiche! Can't you understand! You are so
intelligent, how is it you don't see that if the count has written a
letter to the Emperor begging him to recognize Pierre as legitimate,
it follows that Pierre will not be Pierre but will become Count
Bezukhov, and will then inherit everything under the will? And if
the will and letter are not destroyed, then you will have nothing
but the consolation of having been dutiful et tout ce qui s'ensuit!*
That's certain."


*And all that follows therefrom.


"I know the will was made, but I also know that it is invalid; and
you, mon cousin, seem to consider me a perfect fool," said the
princess with the expression women assume when they suppose they are
saying something witty and stinging.

"My dear Princess Catherine Semenovna," began Prince Vasili
impatiently, "I came here not to wrangle with you, but to talk about
your interests as with a kinswoman, a good, kind, true relation. And I
tell you for the tenth time that if the letter to the Emperor and
the will in Pierre's favor are among the count's papers, then, my dear
girl, you and your sisters are not heiresses! If you don't believe me,
then believe an expert. I have just been talking to Dmitri Onufrich"
(the family solicitor) "and he says the same."

At this a sudden change evidently took place in the princess' ideas;
her thin lips grew white, though her eyes did not change, and her
voice when she began to speak passed through such transitions as she
herself evidently did not expect.

"That would be a fine thing!" said she. "I never wanted anything and
I don't now."

She pushed the little dog off her lap and smoothed her dress.

"And this is gratitude--this is recognition for those who have
sacrificed everything for his sake!" she cried. "It's splendid!
Fine! I don't want anything, Prince."

"Yes, but you are not the only one. There are your sisters..."
replied Prince Vasili.

But the princess did not listen to him.

"Yes, I knew it long ago but had forgotten. I knew that I could
expect nothing but meanness, deceit, envy, intrigue, and
ingratitude--the blackest ingratitude--in this house..."

"Do you or do you not know where that will is?" insisted Prince
Vasili, his cheeks twitching more than ever.

"Yes, I was a fool! I still believed in people, loved them, and
sacrificed myself. But only the base, the vile succeed! I know who has
been intriguing!"

The princess wished to rise, but the prince held her by the hand.
She had the air of one who has suddenly lost faith in the whole
human race. She gave her companion an angry glance.

"There is still time, my dear. You must remember, Catiche, that it
was all done casually in a moment of anger, of illness, and was
afterwards forgotten. Our duty, my dear, is to rectify his mistake, to
ease his last moments by not letting him commit this injustice, and
not to let him die feeling that he is rendering unhappy those who..."

"Who sacrificed everything for him," chimed in the princess, who
would again have risen had not the prince still held her fast, "though
he never could appreciate it. No, mon cousin," she added with a
sigh, "I shall always remember that in this world one must expect no
reward, that in this world there is neither honor nor justice. In this
world one has to be cunning and cruel."

"Now come, come! Be reasonable. I know your excellent heart."

"No, I have a wicked heart."

"I know your heart," repeated the prince. "I value your friendship
and wish you to have as good an opinion of me. Don't upset yourself,
and let us talk sensibly while there is still time, be it a day or
be it but an hour.... Tell me all you know about the will, and above
all where it is. You must know. We will take it at once and show it to
the count. He has, no doubt, forgotten it and will wish to destroy it.
You understand that my sole desire is conscientiously to carry out his
wishes; that is my only reason for being here. I came simply to help
him and you."

"Now I see it all! I know who has been intriguing--I know!" cried
the princess.

"That's not the point, my dear."

"It's that protege of yours, that sweet Princess Drubetskaya, that
Anna Mikhaylovna whom I would not take for a housemaid... the
infamous, vile woman!"

"Do not let us lose any time..."

"Ah, don't talk to me! Last winter she wheedled herself in here
and told the count such vile, disgraceful things about us,
especially about Sophie--I can't repeat them--that it made the count
quite ill and he would not see us for a whole fortnight. I know it was
then he wrote this vile, infamous paper, but I thought the thing was
invalid."

"We've got to it at last--why did you not tell me about it sooner?"

"It's in the inlaid portfolio that he keeps under his pillow,"
said the princess, ignoring his question. "Now I know! Yes; if I
have a sin, a great sin, it is hatred of that vile woman!" almost
shrieked the princess, now quite changed. "And what does she come
worming herself in here for? But I will give her a piece of my mind.
The time will come!"





CHAPTER XXII


While these conversations were going on in the reception room and
the princess' room, a carriage containing Pierre (who had been sent
for) and Anna Mikhaylovna (who found it necessary to accompany him)
was driving into the court of Count Bezukhov's house. As the wheels
rolled softly over the straw beneath the windows, Anna Mikhaylovna,
having turned with words of comfort to her companion, realized that he
was asleep in his corner and woke him up. Rousing himself, Pierre
followed Anna Mikhaylovna out of the carriage, and only then began
to think of the interview with his dying father which awaited him.
He noticed that they had not come to the front entrance but to the
back door. While he was getting down from the carriage steps two
men, who looked like tradespeople, ran hurriedly from the entrance and
hid in the shadow of the wall. Pausing for a moment, Pierre noticed
several other men of the same kind hiding in the shadow of the house
on both sides. But neither Anna Mikhaylovna nor the footman nor the
coachman, who could not help seeing these people, took any notice of
them. "It seems to be all right," Pierre concluded, and followed
Anna Mikhaylovna. She hurriedly ascended the narrow dimly lit stone
staircase, calling to Pierre, who was lagging behind, to follow.
Though he did not see why it was necessary for him to go to the
count at all, still less why he had to go by the back stairs, yet
judging by Anna Mikhaylovna's air of assurance and haste, Pierre
concluded that it was all absolutely necessary. Halfway up the
stairs they were almost knocked over by some men who, carrying
pails, came running downstairs, their boots clattering. These men
pressed close to the wall to let Pierre and Anna Mikhaylovna pass
and did not evince the least surprise at seeing them there.

"Is this the way to the princesses' apartments?" asked Anna
Mikhaylovna of one of them.

"Yes," replied a footman in a bold loud voice, as if anything were
now permissible; "the door to the left, ma'am."

"Perhaps the count did not ask for me," said Pierre when he
reached the landing. "I'd better go to my own room."

Anna Mikhaylovna paused and waited for him to come up.

"Ah, my friend!" she said, touching his arm as she had done her
son's when speaking to him that afternoon, "believe me I suffer no
less than you do, but be a man!"

"But really, hadn't I better go away?" he asked, looking kindly at
her over his spectacles.

"Ah, my dear friend! Forget the wrongs that may have been done
you. Think that he is your father... perhaps in the agony of death."
She sighed. "I have loved you like a son from the first. Trust
yourself to me, Pierre. I shall not forget your interests."

Pierre did not understand a word, but the conviction that all this
had to be grew stronger, and he meekly followed Anna Mikhaylovna who
was already opening a door.

This door led into a back anteroom. An old man, a servant of the
princesses, sat in a corner knitting a stocking. Pierre had never been
in this part of the house and did not even know of the existence of
these rooms. Anna Mikhaylovna, addressing a maid who was hurrying past
with a decanter on a tray as "my dear" and "my sweet," asked about the
princess' health and then led Pierre along a stone passage. The
first door on the left led into the princesses' apartments. The maid
with the decanter in her haste had not closed the door (everything
in the house was done in haste at that time), and Pierre and Anna
Mikhaylovna in passing instinctively glanced into the room, where
Prince Vasili and the eldest princess were sitting close together
talking. Seeing them pass, Prince Vasili drew back with obvious
impatience, while the princess jumped up and with a gesture of
desperation slammed the door with all her might.

This action was so unlike her usual composure and the fear
depicted on Prince Vasili's face so out of keeping with his dignity
that Pierre stopped and glanced inquiringly over his spectacles at his
guide. Anna Mikhaylovna evinced no surprise, she only smiled faintly
and sighed, as if to say that this was no more than she had expected.

"Be a man, my friend. I will look after your interests," said she in
reply to his look, and went still faster along the passage.

Pierre could not make out what it was all about, and still less what
"watching over his interests" meant, but he decided that all these
things had to be. From the passage they went into a large, dimly lit
room adjoining the count's reception room. It was one of those
sumptuous but cold apartments known to Pierre only from the front
approach, but even in this room there now stood an empty bath, and
water had been spilled on the carpet. They were met by a deacon with a
censer and by a servant who passed out on tiptoe without heeding them.
They went into the reception room familiar to Pierre, with two Italian
windows opening into the conservatory, with its large bust and full
length portrait of Catherine the Great. The same people were still
sitting here in almost the same positions as before, whispering to one
another. All became silent and turned to look at the pale tear-worn
Anna Mikhaylovna as she entered, and at the big stout figure of Pierre
who, hanging his head, meekly followed her.

Anna Mikhaylovna's face expressed a consciousness that the
decisive moment had arrived. With the air of a practical Petersburg
lady she now, keeping Pierre close beside her, entered the room even
more boldly than that afternoon. She felt that as she brought with her
the person the dying man wished to see, her own admission was assured.
Casting a rapid glance at all those in the room and noticing the
count's confessor there, she glided up to him with a sort of amble,
not exactly bowing yet seeming to grow suddenly smaller, and
respectfully received the blessing first of one and then of another
priest.

"God be thanked that you are in time," said she to one of the
priests; "all we relatives have been in such anxiety. This young man
is the count's son," she added more softly. "What a terrible moment!"

Having said this she went up to the doctor.

"Dear doctor," said she, "this young man is the count's son. Is
there any hope?"

The doctor cast a rapid glance upwards and silently shrugged his
shoulders. Anna Mikhaylovna with just the same movement raised her
shoulders and eyes, almost closing the latter, sighed, and moved
away from the doctor to Pierre. To him, in a particularly respectful
and tenderly sad voice, she said:

"Trust in His mercy!" and pointing out a small sofa for him to sit
and wait for her, she went silently toward the door that everyone
was watching and it creaked very slightly as she disappeared behind
it.

Pierre, having made up his mind to obey his monitress implicitly,
moved toward the sofa she had indicated. As soon as Anna Mikhaylovna
had disappeared he noticed that the eyes of all in the room turned
to him with something more than curiosity and sympathy. He noticed
that they whispered to one another, casting significant looks at him
with a kind of awe and even servility. A deference such as he had
never before received was shown him. A strange lady, the one who had
been talking to the priests, rose and offered him her seat; an
aide-de-camp picked up and returned a glove Pierre had dropped; the
doctors became respectfully silent as he passed by, and moved to
make way for him. At first Pierre wished to take another seat so as
not to trouble the lady, and also to pick up the glove himself and
to pass round the doctors who were not even in his way; but all at
once he felt that this would not do, and that tonight he was a
person obliged to perform some sort of awful rite which everyone
expected of him, and that he was therefore bound to accept their
services. He took the glove in silence from the aide-de-camp, and
sat down in the lady's chair, placing his huge hands symmetrically
on his knees in the naive attitude of an Egyptian statue, and
decided in his own mind that all was as it should be, and that in
order not to lose his head and do foolish things he must not act on
his own ideas tonight, but must yield himself up entirely to the
will of those who were guiding him.

Not two minutes had passed before Prince Vasili with head erect
majestically entered the room. He was wearing his long coat with three
stars on his breast. He seemed to have grown thinner since the
morning; his eyes seemed larger than usual when he glanced round and
noticed Pierre. He went up to him, took his hand (a thing he never
used to do), and drew it downwards as if wishing to ascertain
whether it was firmly fixed on.

"Courage, courage, my friend! He has asked to see you. That is
well!" and he turned to go.

But Pierre thought it necessary to ask: "How is..." and hesitated,
not knowing whether it would be proper to call the dying man "the
count," yet ashamed to call him "father."

"He had another stroke about half an hour ago. Courage, my
friend..."

Pierre's mind was in such a confused state that the word "stroke"
suggested to him a blow from something. He looked at Prince Vasili
in perplexity, and only later grasped that a stroke was an attack of
illness. Prince Vasili said something to Lorrain in passing and went
through the door on tiptoe. He could not walk well on tiptoe and his
whole body jerked at each step. The eldest princess followed him,
and the priests and deacons and some servants also went in at the
door. Through that door was heard a noise of things being moved about,
and at last Anna Mikhaylovna, still with the same expression, pale but
resolute in the discharge of duty, ran out and touching Pierre lightly
on the arm said:

"The divine mercy is inexhaustible! Unction is about to be
administered. Come."

Pierre went in at the door, stepping on the soft carpet, and noticed
that the strange lady, the aide-de-camp, and some of the servants, all
followed him in, as if there were now no further need for permission
to enter that room.





CHAPTER XXIII


Pierre well knew this large room divided by columns and an arch, its
walls hung round with Persian carpets. The part of the room behind the
columns, with a high silk-curtained mahogany bedstead on one side
and on the other an immense case containing icons, was brightly
illuminated with red light like a Russian church during evening
service. Under the gleaming icons stood a long invalid chair, and in
that chair on snowy-white smooth pillows, evidently freshly changed,
Pierre saw--covered to the waist by a bright green quilt--the
familiar, majestic figure of his father, Count Bezukhov, with that
gray mane of hair above his broad forehead which reminded one of a
lion, and the deep characteristically noble wrinkles of his
handsome, ruddy face. He lay just under the icons; his large thick
hands outside the quilt. Into the right hand, which was lying palm
downwards, a wax taper had been thrust between forefinger and thumb,
and an old servant, bending over from behind the chair, held it in
position. By the chair stood the priests, their long hair falling over
their magnificent glittering vestments, with lighted tapers in their
hands, slowly and solemnly conducting the service. A little behind
them stood the two younger princesses holding handkerchiefs to their
eyes, and just in front of them their eldest sister, Catiche, with a
vicious and determined look steadily fixed on the icons, as though
declaring to all that she could not answer for herself should she
glance round. Anna Mikhaylovna, with a meek, sorrowful, and
all-forgiving expression on her face, stood by the door near the
strange lady. Prince Vasili in front of the door, near the invalid
chair, a wax taper in his left hand, was leaning his left arm on the
carved back of a velvet chair he had turned round for the purpose, and
was crossing himself with his right hand, turning his eyes upward each
time he touched his forehead. His face wore a calm look of piety and
resignation to the will of God. "If you do not understand these
sentiments," he seemed to be saying, "so much the worse for you!"

Behind him stood the aide-de-camp, the doctors, and the menservants;
the men and women had separated as in church. All were silently
crossing themselves, and the reading of the church service, the
subdued chanting of deep bass voices, and in the intervals sighs and
the shuffling of feet were the only sounds that could be heard. Anna
Mikhaylovna, with an air of importance that showed that she felt she
quite knew what she was about, went across the room to where Pierre
was standing and gave him a taper. He lit it and, distracted by
observing those around him, began crossing himself with the hand
that held the taper.

Sophie, the rosy, laughter-loving, youngest princess with the
mole, watched him. She smiled, hid her face in her handkerchief, and
remained with it hidden for awhile; then looking up and seeing
Pierre she again began to laugh. She evidently felt unable to look
at him without laughing, but could not resist looking at him: so to be
out of temptation she slipped quietly behind one of the columns. In
the midst of the service the voices of the priests suddenly ceased,
they whispered to one another, and the old servant who was holding the
count's hand got up and said something to the ladies. Anna Mikhaylovna
stepped forward and, stooping over the dying man, beckoned to
Lorrain from behind her back. The French doctor held no taper; he
was leaning against one of the columns in a respectful attitude
implying that he, a foreigner, in spite of all differences of faith,
understood the full importance of the rite now being performed and
even approved of it. He now approached the sick man with the noiseless
step of one in full vigor of life, with his delicate white fingers
raised from the green quilt the hand that was free, and turning
sideways felt the pulse and reflected a moment. The sick man was given
something to drink, there was a stir around him, then the people
resumed their places and the service continued. During this interval
Pierre noticed that Prince Vasili left the chair on which he had
been leaning, and--with air which intimated that he knew what he was
about and if others did not understand him it was so much the worse
for them--did not go up to the dying man, but passed by him, joined
the eldest princess, and moved with her to the side of the room
where stood the high bedstead with its silken hangings. On leaving the
bed both Prince Vasili and the princess passed out by a back door, but
returned to their places one after the other before the service was
concluded. Pierre paid no more attention to this occurrence than to
the rest of what went on, having made up his mind once for all that
what he saw happening around him that evening was in some way
essential.

The chanting of the service ceased, and the voice of the priest
was heard respectfully congratulating the dying man on having received
the sacrament. The dying man lay as lifeless and immovable as
before. Around him everyone began to stir: steps were audible and
whispers, among which Anna Mikhaylovna's was the most distinct.

Pierre heard her say:

"Certainly he must be moved onto the bed; here it will be
impossible..."

The sick man was so surrounded by doctors, princesses, and
servants that Pierre could no longer see the reddish-yellow face
with its gray mane--which, though he saw other faces as well, he had
not lost sight of for a single moment during the whole service. He
judged by the cautious movements of those who crowded round the
invalid chair that they had lifted the dying man and were moving him.

"Catch hold of my arm or you'll drop him!" he heard one of the
servants say in a frightened whisper. "Catch hold from underneath.
Here!" exclaimed different voices; and the heavy breathing of the
bearers and the shuffling of their feet grew more hurried, as if the
weight they were carrying were too much for them.

As the bearers, among whom was Anna Mikhaylovna, passed the young
man he caught a momentary glimpse between their heads and backs of the
dying man's high, stout, uncovered chest and powerful shoulders,
raised by those who were holding him under the armpits, and of his
gray, curly, leonine head. This head, with its remarkably broad brow
and cheekbones, its handsome, sensual mouth, and its cold, majestic
expression, was not disfigured by the approach of death. It was the
same as Pierre remembered it three months before, when the count had
sent him to Petersburg. But now this head was swaying helplessly
with the uneven movements of the bearers, and the cold listless gaze
fixed itself upon nothing.

After a few minutes' bustle beside the high bedstead, those who
had carried the sick man dispersed. Anna Mikhaylovna touched
Pierre's hand and said, "Come." Pierre went with her to the bed on
which the sick man had been laid in a stately pose in keeping with the
ceremony just completed. He lay with his head propped high on the
pillows. His hands were symmetrically placed on the green silk
quilt, the palms downward. When Pierre came up the count was gazing
straight at him, but with a look the significance of which could not
be understood by mortal man. Either this look meant nothing but that
as long as one has eyes they must look somewhere, or it meant too
much. Pierre hesitated, not knowing what to do, and glanced
inquiringly at his guide. Anna Mikhaylovna made a hurried sign with
her eyes, glancing at the sick man's hand and moving her lips as if to
send it a kiss. Pierre, carefully stretching his neck so as not to
touch the quilt, followed her suggestion and pressed his lips to the
large boned, fleshy hand. Neither the hand nor a single muscle of
the count's face stirred. Once more Pierre looked questioningly at
Anna Mikhaylovna to see what he was to do next. Anna Mikhaylovna
with her eyes indicated a chair that stood beside the bed. Pierre
obediently sat down, his eyes asking if he were doing right. Anna
Mikhaylovna nodded approvingly. Again Pierre fell into the naively
symmetrical pose of an Egyptian statue, evidently distressed that
his stout and clumsy body took up so much room and doing his utmost to
look as small as possible. He looked at the count, who still gazed
at the spot where Pierre's face had been before he sat down. Anna
Mikhaylovna indicated by her attitude her consciousness of the
pathetic importance of these last moments of meeting between the
father and son. This lasted about two minutes, which to Pierre
seemed an hour. Suddenly the broad muscles and lines of the count's
face began to twitch. The twitching increased, the handsome mouth
was drawn to one side (only now did Pierre realize how near death
his father was), and from that distorted mouth issued an indistinct,
hoarse sound. Anna Mikhaylovna looked attentively at the sick man's
eyes, trying to guess what he wanted; she pointed first to Pierre,
then to some drink, then named Prince Vasili in an inquiring
whisper, then pointed to the quilt. The eyes and face of the sick
man showed impatience. He made an effort to look at the servant who
stood constantly at the head of the bed.

"Wants to turn on the other side," whispered the servant, and got up
to turn the count's heavy body toward the wall.

Pierre rose to help him.

While the count was being turned over, one of his arms fell back
helplessly and he made a fruitless effort to pull it forward.
Whether he noticed the look of terror with which Pierre regarded
that lifeless arm, or whether some other thought flitted across his
dying brain, at any rate he glanced at the refractory arm, at Pierre's
terror-stricken face, and again at the arm, and on his face a
feeble, piteous smile appeared, quite out of keeping with his
features, that seemed to deride his own helplessness. At sight of this
smile Pierre felt an unexpected quivering in his breast and a tickling
in his nose, and tears dimmed his eyes. The sick man was turned on
to his side with his face to the wall. He sighed.

"He is dozing," said Anna Mikhaylovna, observing that one of the
princesses was coming to take her turn at watching. "Let us go."

Pierre went out.





CHAPTER XXIV


There was now no one in the reception room except Prince Vasili
and the eldest princess, who were sitting under the portrait of
Catherine the Great and talking eagerly. As soon as they saw Pierre
and his companion they became silent, and Pierre thought he saw the
princess hide something as she whispered:

"I can't bear the sight of that woman."

"Catiche has had tea served in the small drawing room," said
Prince Vasili to Anna Mikhaylovna. "Go and take something, my poor
Anna Mikhaylovna, or you will not hold out."

To Pierre he said nothing, merely giving his arm a sympathetic
squeeze below the shoulder. Pierre went with Anna Mikhaylovna into the
small drawing room.

"There is nothing so refreshing after a sleepless night as a cup
of this delicious Russian tea," Lorrain was saying with an air of
restrained animation as he stood sipping tea from a delicate Chinese
handleless cup before a table on which tea and a cold supper were laid
in the small circular room. Around the table all who were at Count
Bezukhov's house that night had gathered to fortify themselves. Pierre
well remembered this small circular drawing room with its mirrors
and little tables. During balls given at the house Pierre, who did not
know how to dance, had liked sitting in this room to watch the
ladies who, as they passed through in their ball dresses with diamonds
and pearls on their bare shoulders, looked at themselves in the
brilliantly lighted mirrors which repeated their reflections several
times. Now this same room was dimly lighted by two candles. On one
small table tea things and supper dishes stood in disorder, and in the
middle of the night a motley throng of people sat there, not
merrymaking, but somberly whispering, and betraying by every word
and movement that they none of them forgot what was happening and what
was about to happen in the bedroom. Pierre did not eat anything though
he would very much have liked to. He looked inquiringly at his
monitress and saw that she was again going on tiptoe to the
reception room where they had left Prince Vasili and the eldest
princess. Pierre concluded that this also was essential, and after a
short interval followed her. Anna Mikhaylovna was standing beside
the princess, and they were both speaking in excited whispers.

"Permit me, Princess, to know what is necessary and what is not
necessary," said the younger of the two speakers, evidently in the
same state of excitement as when she had slammed the door of her room.

"But, my dear princess," answered Anna Mikhaylovna blandly but
impressively, blocking the way to the bedroom and preventing the other
from passing, "won't this be too much for poor Uncle at a moment
when he needs repose? Worldly conversation at a moment when his soul
is already prepared..."

Prince Vasili was seated in an easy chair in his familiar
attitude, with one leg crossed high above the other. His cheeks, which
were so flabby that they looked heavier below, were twitching
violently; but he wore the air of a man little concerned in what the
two ladies were saying.

"Come, my dear Anna Mikhaylovna, let Catiche do as she pleases.
You know how fond the count is of her."

"I don't even know what is in this paper," said the younger of the
two ladies, addressing Prince Vasili and pointing to an inlaid
portfolio she held in her hand. "All I know is that his real will is
in his writing table, and this is a paper he has forgotten...."

She tried to pass Anna Mikhaylovna, but the latter sprang so as to
bar her path.

"I know, my dear, kind princess," said Anna Mikhaylovna, seizing the
portfolio so firmly that it was plain she would not let go easily.
"Dear princess, I beg and implore you, have some pity on him! Je
vous en conjure..."

The princess did not reply. Their efforts in the struggle for the
portfolio were the only sounds audible, but it was evident that if the
princess did speak, her words would not be flattering to Anna
Mikhaylovna. Though the latter held on tenaciously, her voice lost
none of its honeyed firmness and softness.

"Pierre, my dear, come here. I think he will not be out of place
in a family consultation; is it not so, Prince?"

"Why don't you speak, cousin?" suddenly shrieked the princess so
loud that those in the drawing room heard her and were startled.
"Why do you remain silent when heaven knows who permits herself to
interfere, making a scene on the very threshold of a dying man's room?
Intriguer!" she hissed viciously, and tugged with all her might at the
portfolio.

But Anna Mikhaylovna went forward a step or two to keep her hold
on the portfolio, and changed her grip.

Prince Vasili rose. "Oh!" said he with reproach and surprise,
"this is absurd! Come, let go I tell you."

The princess let go.

"And you too!"

But Anna Mikhaylovna did not obey him.

"Let go, I tell you! I will take the responsibility. I myself will
go and ask him, I!... does that satisfy you?"

"But, Prince," said Anna Mikhaylovna, "after such a solemn
sacrament, allow him a moment's peace! Here, Pierre, tell them your
opinion," said she, turning to the young man who, having come quite
close, was gazing with astonishment at the angry face of the
princess which had lost all dignity, and at the twitching cheeks of
Prince Vasili.

"Remember that you will answer for the consequences," said Prince
Vasili severely. "You don't know what you are doing."

"Vile woman!" shouted the princess, darting unexpectedly at Anna
Mikhaylovna and snatching the portfolio from her.

Prince Vasili bent his head and spread out his hands.

At this moment that terrible door, which Pierre had watched so
long and which had always opened so quietly, burst noisily open and
banged against the wall, and the second of the three sisters rushed
out wringing her hands.

"What are you doing!" she cried vehemently. "He is dying and you
leave me alone with him!"

Her sister dropped the portfolio. Anna Mikhaylovna, stooping,
quickly caught up the object of contention and ran into the bedroom.
The eldest princess and Prince Vasili, recovering themselves, followed
her. A few minutes later the eldest sister came out with a pale hard
face, again biting her underlip. At sight of Pierre her expression
showed an irrepressible hatred.

"Yes, now you may be glad!" said she; "this is what you have been
waiting for." And bursting into tears she hid her face in her
handkerchief and rushed from the room.

Prince Vasili came next. He staggered to the sofa on which Pierre
was sitting and dropped onto it, covering his face with his hand.
Pierre noticed that he was pale and that his jaw quivered and shook as
if in an ague.

"Ah, my friend!" said he, taking Pierre by the elbow; and there
was in his voice a sincerity and weakness Pierre had never observed in
it before. "How often we sin, how much we deceive, and all for what? I
am near sixty, dear friend... I too... All will end in death, all!
Death is awful..." and he burst into tears.

Anna Mikhaylovna came out last. She approached Pierre with slow,
quiet steps.

"Pierre!" she said.

Pierre gave her an inquiring look. She kissed the young man on his
forehead, wetting him with her tears. Then after a pause she said:

"He is no more...."

Pierre looked at her over his spectacles.

"Come, I will go with you. Try to weep, nothing gives such relief as
tears."

She led him into the dark drawing room and Pierre was glad no one
could see his face. Anna Mikhaylovna left him, and when she returned
he was fast asleep with his head on his arm.

In the morning Anna Mikhaylovna said to Pierre:

"Yes, my dear, this is a great loss for us all, not to speak of you.
But God will support you: you are young, and are now, I hope, in
command of an immense fortune. The will has not yet been opened. I
know you well enough to be sure that this will not turn your head, but
it imposes duties on you, and you must be a man."

Pierre was silent.

"Perhaps later on I may tell you, my dear boy, that if I had not
been there, God only knows what would have happened! You know, Uncle
promised me only the day before yesterday not to forget Boris. But
he had no time. I hope, my dear friend, you will carry out your
father's wish?"

Pierre understood nothing of all this and coloring shyly looked in
silence at Princess Anna Mikhaylovna. After her talk with Pierre, Anna
Mikhaylovna returned to the Rostovs' and went to bed. On waking in the
morning she told the Rostovs and all her acquaintances the details
of Count Bezukhov's death. She said the count had died as she would
herself wish to die, that his end was not only touching but
edifying. As to the last meeting between father and son, it was so
touching that she could not think of it without tears, and did not
know which had behaved better during those awful moments--the father
who so remembered everything and everybody at last and had
spoken such pathetic words to the son, or Pierre, whom it had been
pitiful to see, so stricken was he with grief, though he tried hard to
hide it in order not to sadden his dying father. "It is painful, but
it does one good. It uplifts the soul to see such men as the old count
and his worthy son," said she. Of the behavior of the eldest
princess and Prince Vasili she spoke disapprovingly, but in whispers
and as a great secret.





CHAPTER XXV


At Bald Hills, Prince Nicholas Andreevich Bolkonski's estate, the
arrival of young Prince Andrew and his wife was daily expected, but
this expectation did not upset the regular routine of life in the
old prince's household. General in Chief Prince Nicholas Andreevich
(nicknamed in society, "the King of Prussia") ever since the Emperor
Paul had exiled him to his country estate had lived there continuously
with his daughter, Princess Mary, and her companion, Mademoiselle
Bourienne. Though in the new reign he was free to return to the
capitals, he still continued to live in the country, remarking that
anyone who wanted to see him could come the hundred miles from
Moscow to Bald Hills, while he himself needed no one and nothing. He
used to say that there are only two sources of human vice--idleness
and superstition, and only two virtues--activity and intelligence.
He himself undertook his daughter's education, and to develop these
two cardinal virtues in her gave her lessons in algebra and geometry
till she was twenty, and arranged her life so that her whole time
was occupied. He was himself always occupied: writing his memoirs,
solving problems in higher mathematics, turning snuffboxes on a lathe,
working in the garden, or superintending the building that was
always going on at his estate. As regularity is a prime condition
facilitating activity, regularity in his household was carried to
the highest point of exactitude. He always came to table under
precisely the same conditions, and not only at the same hour but at
the same minute. With those about him, from his daughter to his serfs,
the prince was sharp and invariably exacting, so that without being
a hardhearted man he inspired such fear and respect as few hardhearted
men would have aroused. Although he was in retirement and had now no
influence in political affairs, every high official appointed to the
province in which the prince's estate lay considered it his duty to
visit him and waited in the lofty antechamber ante chamber just as the
architect, gardener, or Princess Mary did, till the prince appeared
punctually to the appointed hour. Everyone sitting in this antechamber
experienced the same feeling of respect and even fear when the
enormously high study door opened and showed the figure of a rather
small old man, with powdered wig, small withered hands, and bushy gray
eyebrows which, when he frowned, sometimes hid the gleam of his
shrewd, youthfully glittering eyes.

On the morning of the day that the young couple were to arrive,
Princess Mary entered the antechamber as usual at the time appointed
for the morning greeting, crossing herself with trepidation and
repeating a silent prayer. Every morning she came in like that, and
every morning prayed that the daily interview might pass off well.

An old powdered manservant who was sitting in the antechamber rose
quietly and said in a whisper: "Please walk in."

Through the door came the regular hum of a lathe. The princess
timidly opened the door which moved noiselessly and easily. She paused
at the entrance. The prince was working at the lathe and after
glancing round continued his work.

The enormous study was full of things evidently in constant use. The
large table covered with books and plans, the tall glass-fronted
bookcases with keys in the locks, the high desk for writing while
standing up, on which lay an open exercise book, and the lathe with
tools laid ready to hand and shavings scattered around--all
indicated continuous, varied, and orderly activity. The motion of
the small foot shod in a Tartar boot embroidered with silver, and
the firm pressure of the lean sinewy hand, showed that the prince
still possessed the tenacious endurance and vigor of hardy old age.
After a few more turns of the lathe he removed his foot from the
pedal, wiped his chisel, dropped it into a leather pouch attached to
the lathe, and, approaching the table, summoned his daughter. He never
gave his children a blessing, so he simply held out his bristly
cheek (as yet unshaven) and, regarding her tenderly and attentively,
said severely:

"Quite well? All right then, sit down." He took the exercise book
containing lessons in geometry written by himself and drew up a
chair with his foot.

"For tomorrow!" said he, quickly finding the page and making a
scratch from one paragraph to another with his hard nail.

The princess bent over the exercise book on the table.

"Wait a bit, here's a letter for you," said the old man suddenly,
taking a letter addressed in a woman's hand from a bag hanging above
the table, onto which he threw it.

At the sight of the letter red patches showed themselves on the
princess' face. She took it quickly and bent her head over it.

"From Heloise?" asked the prince with a cold smile that showed his
still sound, yellowish teeth.

"Yes, it's from Julie," replied the princess with a timid glance and
a timid smile.

"I'll let two more letters pass, but the third I'll read," said
the prince sternly; "I'm afraid you write much nonsense. I'll read the
third!"

"Read this if you like, Father," said the princess, blushing still
more and holding out the letter.

"The third, I said the third!" cried the prince abruptly, pushing
the letter away, and leaning his elbows on the table he drew toward
him the exercise book containing geometrical figures.

"Well, madam," he began, stooping over the book close to his
daughter and placing an arm on the back of the chair on which she sat,
so that she felt herself surrounded on all sides by the acrid scent of
old age and tobacco, which she had known so long. "Now, madam, these
triangles are equal; please note that the angle ABC..."

The princess looked in a scared way at her father's eyes
glittering close to her; the red patches on her face came and went,
and it was plain that she understood nothing and was so frightened
that her fear would prevent her understanding any of her father's
further explanations, however clear they might be. Whether it was
the teacher's fault or the pupil's, this same thing happened every
day: the princess' eyes grew dim, she could not see and could not hear
anything, but was only conscious of her stern father's withered face
close to her, of his breath and the smell of him, and could think only
of how to get away quickly to her own room to make out the problem
in peace. The old man was beside himself: moved the chair on which
he was sitting noisily backward and forward, made efforts to control
himself and not become vehement, but almost always did become
vehement, scolded, and sometimes flung the exercise book away.

The princess gave a wrong answer.

"Well now, isn't she a fool!" shouted the prince, pushing the book
aside and turning sharply away; but rising immediately, he paced up
and down, lightly touched his daughter's hair and sat down again.

He drew up his chair, and continued to explain.

"This won't do, Princess; it won't do," said he, when Princess Mary,
having taken and closed the exercise book with the next day's
lesson, was about to leave: "Mathematics are most important, madam!
I don't want to have you like our silly ladies. Get used to it and
you'll like it," and he patted her cheek. "It will drive all the
nonsense out of your head."

She turned to go, but he stopped her with a gesture and took an
uncut book from the high desk.

"Here is some sort of Key to the Mysteries that your Heloise has
sent you. Religious! I don't interfere with anyone's belief... I
have looked at it. Take it. Well, now go. Go."

He patted her on the shoulder and himself closed the door after her.

Princess Mary went back to her room with the sad, scared
expression that rarely left her and which made her plain, sickly
face yet plainer. She sat down at her writing table, on which stood
miniature portraits and which was littered with books and papers.
The princess was as untidy as her father was tidy. She put down the
geometry book and eagerly broke the seal of her letter. It was from
her most intimate friend from childhood; that same Julie Karagina
who had been at the Rostovs' name-day party.

Julie wrote in French:


Dear and precious Friend, How terrible and frightful a thing is
separation! Though I tell myself that half my life and half my
happiness are wrapped up in you, and that in spite of the distance
separating us our hearts are united by indissoluble bonds, my heart
rebels against fate and in spite of the pleasures and distractions
around me I cannot overcome a certain secret sorrow that has been in
my heart ever since we parted. Why are we not together as we were last
summer, in your big study, on the blue sofa, the confidential sofa?
Why cannot I now, as three months ago, draw fresh moral strength
from your look, so gentle, calm, and penetrating, a look I loved so
well and seem to see before me as I write?


Having read thus far, Princess Mary sighed and glanced into the
mirror which stood on her right. It reflected a weak, ungraceful
figure and thin face. Her eyes, always sad, now looked with particular
hopelessness at her reflection in the glass. "She flatters me,"
thought the princess, turning away and continuing to read. But Julie
did not flatter her friend, the princess' eyes--large, deep and
luminous (it seemed as if at times there radiated from them shafts
of warm light)--were so beautiful that very often in spite of the
plainness of her face they gave her an attraction more powerful than
that of beauty. But the princess never saw the beautiful expression of
her own eyes--the look they had when she was not thinking of
herself. As with everyone, her face assumed a forced unnatural
expression as soon as she looked in a glass. She went on reading:


All Moscow talks of nothing but war. One of my two brothers is
already abroad, the other is with the Guards, who are starting on
their march to the frontier. Our dear Emperor has left Petersburg
and it is thought intends to expose his precious person to the chances
of war. God grant that the Corsican monster who is destroying the
peace of Europe may be overthrown by the angel whom it has pleased the
Almighty, in His goodness, to give us as sovereign! To say nothing
of my brothers, this war has deprived me of one of the associations
nearest my heart. I mean young Nicholas Rostov, who with his
enthusiasm could not bear to remain inactive and has left the
university to join the army. I will confess to you, dear Mary, that in
spite of his extreme youth his departure for the army was a great
grief to me. This young man, of whom I spoke to you last summer, is so
noble-minded and full of that real youthfulness which one seldom finds
nowadays among our old men of twenty and, particularly, he is so frank
and has so much heart. He is so pure and poetic that my relations with
him, transient as they were, have been one of the sweetest comforts to
my poor heart, which has already suffered so much. Someday I will tell
you about our parting and all that was said then. That is still too
fresh. Ah, dear friend, you are happy not to know these poignant
joys and sorrows. You are fortunate, for the latter are generally
the stronger! I know very well that Count Nicholas is too young ever
to be more to me than a friend, but this sweet friendship, this poetic
and pure intimacy, were what my heart needed. But enough of this!
The chief news, about which all Moscow gossips, is the death of old
Count Bezukhov, and his inheritance. Fancy! The three princesses
have received very little, Prince Vasili nothing, and it is Monsieur
Pierre who has inherited all the property and has besides been
recognized as legitimate; so that he is now Count Bezukhov and
possessor of the finest fortune in Russia. It is rumored that Prince
Vasili played a very despicable part in this affair and that he
returned to Petersburg quite crestfallen.

I confess I understand very little about all these matters of
wills and inheritance; but I do know that since this young man, whom
we all used to know as plain Monsieur Pierre, has become Count
Bezukhov and the owner of one of the largest fortunes in Russia, I
am much amused to watch the change in the tone and manners of the
mammas burdened by marriageable daughters, and of the young ladies
themselves, toward him, though, between you and me, he always seemed
to me a poor sort of fellow. As for the past two years people have
amused themselves by finding husbands for me (most of whom I don't
even know), the matchmaking chronicles of Moscow now speak of me as
the future Countess Bezukhova. But you will understand that I have
no desire for the post. A propos of marriages: do you know that a
while ago that universal auntie Anna Mikhaylovna told me, under the
seal of strict secrecy, of a plan of marriage for you. It is neither
more nor less than with Prince Vasili's son Anatole, whom they wish to
reform by marrying him to someone rich and distinguee, and it is on
you that his relations' choice has fallen. I don't know what you
will think of it, but I consider it my duty to let you know of it.
He is said to be very handsome and a terrible scapegrace. That is
all I have been able to find out about him.

But enough of gossip. I am at the end of my second sheet of paper,
and Mamma has sent for me to go and dine at the Apraksins'. Read the
mystical book I am sending you; it has an enormous success here.
Though there are things in it difficult for the feeble human mind to
grasp, it is an admirable book which calms and elevates the soul.
Adieu! Give my respects to monsieur your father and my compliments
to Mademoiselle Bourienne. I embrace you as I love you.

JULIE

P.S. Let me have news of your brother and his charming little wife.


The princess pondered awhile with a thoughtful smile and her
luminous eyes lit up so that her face was entirely transformed. Then
she suddenly rose and with her heavy tread went up to the table. She
took a sheet of paper and her hand moved rapidly over it. This is
the reply she wrote, also in French:


Dear and precious Friend, Your letter of the 13th has given me great
delight. So you still love me, my romantic Julie? Separation, of which
you say so much that is bad, does not seem to have had its usual
effect on you. You complain of our separation. What then should I say,
if I dared complain, I who am deprived of all who are dear to me?
Ah, if we had not religion to console us life would be very sad. Why
do you suppose that I should look severely on your affection for
that young man? On such matters I am only severe with myself. I
understand such feelings in others, and if never having felt them I
cannot approve of them, neither do I condemn them. Only it seems to me
that Christian love, love of one's neighbor, love of one's enemy, is
worthier, sweeter, and better than the feelings which the beautiful
eyes of a young man can inspire in a romantic and loving young girl
like yourself.

The news of Count Bezukhov's death reached us before your letter and
my father was much affected by it. He says the count was the last
representative but one of the great century, and that it is his own
turn now, but that he will do all he can to let his turn come as
late as possible. God preserve us from that terrible misfortune!

I cannot agree with you about Pierre, whom I knew as a child. He
always seemed to me to have an excellent heart, and that is the
quality I value most in people. As to his inheritance and the part
played by Prince Vasili, it is very sad for both. Ah, my dear
friend, our divine Saviour's words, that it is easier for a camel to
go through the eye of a needle than for a rich man to enter the
Kingdom of God, are terribly true. I pity Prince Vasili but am still
more sorry for Pierre. So young, and burdened with such riches--to
what temptations he will be exposed! If I were asked what I desire
most on earth, it would be to be poorer than the poorest beggar. A
thousand thanks, dear friend, for the volume you have sent me and
which has such success in Moscow. Yet since you tell me that among
some good things it contains others which our weak human understanding
cannot grasp, it seems to me rather useless to spend time in reading
what is unintelligible and can therefore bear no fruit. I never
could understand the fondness some people have for confusing their
minds by dwelling on mystical books that merely awaken their doubts
and excite their imagination, giving them a bent for exaggeration
quite contrary to Christian simplicity. Let us rather read the
Epistles and Gospels. Let us not seek to penetrate what mysteries they
contain; for how can we, miserable sinners that we are, know the
terrible and holy secrets of Providence while we remain in this
flesh which forms an impenetrable veil between us and the Eternal? Let
us rather confine ourselves to studying those sublime rules which
our divine Saviour has left for our guidance here below. Let us try to
conform to them and follow them, and let us be persuaded that the less
we let our feeble human minds roam, the better we shall please God,
who rejects all knowledge that does not come from Him; and the less we
seek to fathom what He has been pleased to conceal from us, the sooner
will He vouchsafe its revelation to us through His divine Spirit.

My father has not spoken to me of a suitor, but has only told me
that he has received a letter and is expecting a visit from Prince
Vasili. In regard to this project of marriage for me, I will tell you,
dear sweet friend, that I look on marriage as a divine institution
to which we must conform. However painful it may be to me, should
the Almighty lay the duties of wife and mother upon me I
shall try to perform them as faithfully as I can, without
disquieting myself by examining my feelings toward him whom He may
give me for husband.

I have had a letter from my brother, who announces his speedy
arrival at Bald Hills with his wife. This pleasure will be but a brief
one, however, for he will leave, us again to take part in this unhappy
war into which we have been drawn, God knows how or why. Not only
where you are--at the heart of affairs and of the world--is the talk
all of war, even here amid fieldwork and the calm of nature--which
townsfolk consider characteristic of the country--rumors of war are
heard and painfully felt. My father talks of nothing but marches and
countermarches, things of which I understand nothing; and the day
before yesterday during my daily walk through the village I
witnessed a heartrending scene.... It was a convoy of conscripts
enrolled from our people and starting to join the army. You should
have seen the state of the mothers, wives, and children of the men who
were going and should have heard the sobs. It seems as though
mankind has forgotten the laws of its divine Saviour, Who preached
love and forgiveness of injuries--and that men attribute the
greatest merit to skill in killing one another.

Adieu, dear and kind friend; may our divine Saviour and His most
Holy Mother keep you in their holy and all-powerful care!

MARY


"Ah, you are sending off a letter, Princess? I have already
dispatched mine. I have written to my poor mother," said the smiling
Mademoiselle Bourienne rapidly, in her pleasant mellow tones and
with guttural r's. She brought into Princess Mary's strenuous,
mournful, and gloomy world a quite different atmosphere, careless,
lighthearted, and self-satisfied.

"Princess, I must warn you," she added, lowering her voice and
evidently listening to herself with pleasure, and speaking with
exaggerated grasseyement, "the prince has been scolding Michael
Ivanovich. He is in a very bad humor, very morose. Be prepared."

"Ah, dear friend," replied Princess Mary, "I have asked you never to
warn me of the humor my father is in. I do not allow myself to judge
him and would not have others do so."

The princess glanced at her watch and, seeing that she was five
minutes late in starting her practice on the clavichord, went into the
sitting room with a look of alarm. Between twelve and two o'clock,
as the day was mapped out, the prince rested and the princess played
the clavichord.





CHAPTER XXVI


The gray-haired valet was sitting drowsily listening to the
snoring of the prince, who was in his large study. From the far side
of the house through the closed doors came the sound of difficult
passages--twenty times repeated--of a sonata by Dussek.

Just then a closed carriage and another with a hood drove up to
the porch. Prince Andrew got out of the carriage, helped his little
wife to alight, and let her pass into the house before him. Old
Tikhon, wearing a wig, put his head out of the door of the
antechamber, reported in a whisper that the prince was sleeping, and
hastily closed the door. Tikhon knew that neither the son's arrival
nor any other unusual event must be allowed to disturb the appointed
order of the day. Prince Andrew apparently knew this as well as
Tikhon; he looked at his watch as if to ascertain whether his father's
habits had changed since he was at home last, and, having assured
himself that they had not, he turned to his wife.

"He will get up in twenty minutes. Let us go across to Mary's room,"
he said.

The little princess had grown stouter during this time, but her eyes
and her short, downy, smiling lip lifted when she began to speak
just as merrily and prettily as ever.

"Why, this is a palace!" she said to her husband, looking around
with the expression with which people compliment their host at a ball.
"Let's come, quick, quick!" And with a glance round, she smiled at
Tikhon, at her husband, and at the footman who accompanied them.

"Is that Mary practicing? Let's go quietly and take her by
surprise."

Prince Andrew followed her with a courteous but sad expression.

"You've grown older, Tikhon," he said in passing to the old man, who
kissed his hand.

Before they reached the room from which the sounds of the clavichord
came, the pretty, fair haired Frenchwoman, Mademoiselle Bourienne,
rushed out apparently beside herself with delight.

"Ah! what joy for the princess!" exclaimed she: "At last! I must let
her know."

"No, no, please not... You are Mademoiselle Bourienne," said the
little princess, kissing her. "I know you already through my
sister-in-law's friendship for you. She was not expecting us?"

They went up to the door of the sitting room from which came the
sound of the oft-repeated passage of the sonata. Prince Andrew stopped
and made a grimace, as if expecting something unpleasant.

The little princess entered the room. The passage broke off in the
middle, a cry was heard, then Princess Mary's heavy tread and the
sound of kissing. When Prince Andrew went in the two princesses, who
had only met once before for a short time at his wedding, were in each
other's arms warmly pressing their lips to whatever place they
happened to touch. Mademoiselle Bourienne stood near them pressing her
hand to her heart, with a beatific smile and obviously equally ready
to cry or to laugh. Prince Andrew shrugged his shoulders and
frowned, as lovers of music do when they hear a false note. The two
women let go of one another, and then, as if afraid of being too late,
seized each other's hands, kissing them and pulling them away, and
again began kissing each other on the face, and then to Prince
Andrew's surprise both began to cry and kissed again. Mademoiselle
Bourienne also began to cry. Prince Andrew evidently felt ill at ease,
but to the two women it seemed quite natural that they should cry, and
apparently it never entered their heads that it could have been
otherwise at this meeting.

"Ah! my dear!... Ah! Mary!" they suddenly exclaimed, and then
laughed. "I dreamed last night..."--"You were not expecting us?..."-
"Ah! Mary, you have got thinner?..." "And you have grown stouter!..."

"I knew the princess at once," put in Mademoiselle Bourienne.

"And I had no idea!..." exclaimed Princess Mary. "Ah, Andrew, I
did not see you."

Prince Andrew and his sister, hand in hand, kissed one another,
and he told her she was still the same crybaby as ever. Princess
Mary had turned toward her brother, and through her tears the
loving, warm, gentle look of her large luminous eyes, very beautiful
at that moment, rested on Prince Andrew's face.

The little princess talked incessantly, her short, downy upper lip
continually and rapidly touching her rosy nether lip when necessary
and drawing up again next moment when her face broke into a smile of
glittering teeth and sparkling eyes. She told of an accident they
had had on the Spasski Hill which might have been serious for her in
her condition, and immediately after that informed them that she had
left all her clothes in Petersburg and that heaven knew what she would
have to dress in here; and that Andrew had quite changed, and that
Kitty Odyntsova had married an old man, and that there was a suitor
for Mary, a real one, but that they would talk of that later. Princess
Mary was still looking silently at her brother and her beautiful
eyes were full of love and sadness. It was plain that she was
following a train of thought independent of her sister-in-law's words.
In the midst of a description of the last Petersburg fete she
addressed her brother:

"So you are really going to the war, Andrew?" she said sighing.

Lise sighed too.

"Yes, and even tomorrow," replied her brother.

"He is leaving me here, God knows why, when he might have had
promotion..."

Princess Mary did not listen to the end, but continuing her train of
thought turned to her sister-in-law with a tender glance at her
figure.

"Is it certain?" she said.

The face of the little princess changed. She sighed and said:
"Yes, quite certain. Ah! it is very dreadful..."

Her lip descended. She brought her face close to her sister-in-law's
and unexpectedly again began to cry.

"She needs rest," said Prince Andrew with a frown. "Don't you, Lise?
Take her to your room and I'll go to Father. How is he? Just the
same?"

"Yes, just the same. Though I don't know what your opinion will be,"
answered the princess joyfully.

"And are the hours the same? And the walks in the avenues? And the
lathe?" asked Prince Andrew with a scarcely perceptible smile which
showed that, in spite of all his love and respect for his father, he
was aware of his weaknesses.

"The hours are the same, and the lathe, and also the mathematics and
my geometry lessons," said Princess Mary gleefully, as if her
lessons in geometry were among the greatest delights of her life.

When the twenty minutes had elapsed and the time had come for the
old prince to get up, Tikhon came to call the young prince to his
father. The old man made a departure from his usual routine in honor
of his son's arrival: he gave orders to admit him to his apartments
while he dressed for dinner. The old prince always dressed in
old-fashioned style, wearing an antique coat and powdered hair; and
when Prince Andrew entered his father's dressing room (not with the
contemptuous look and manner he wore in drawing rooms, but with the
animated face with which he talked to Pierre), the old man was sitting
on a large leather-covered chair, wrapped in a powdering mantle,
entrusting his head to Tikhon.

"Ah! here's the warrior! Wants to vanquish Buonaparte?" said the old
man, shaking his powdered head as much as the tail, which Tikhon was
holding fast to plait, would allow.

"You at least must tackle him properly, or else if he goes on like
this he'll soon have us, too, for his subjects! How are you?" And he
held out his cheek.

The old man was in a good temper after his nap before dinner. (He
used to say that a nap "after dinner was silver--before dinner,
golden.") He cast happy, sidelong glances at his son from under his
thick, bushy eyebrows. Prince Andrew went up and kissed his father
on the spot indicated to him. He made no reply on his father's
favorite topic--making fun of the military men of the day, and more
particularly of Bonaparte.

"Yes, Father, I have come come to you and brought my wife who is
pregnant," said Prince Andrew, following every movement of his
father's face with an eager and respectful look. "How is your health?"

"Only fools and rakes fall ill, my boy. You know me: I am busy
from morning till night and abstemious, so of course I am well."

"Thank God," said his son smiling.

"God has nothing to do with it! Well, go on," he continued,
returning to his hobby; "tell me how the Germans have taught you to
fight Bonaparte by this new science you call 'strategy.'"

Prince Andrew smiled.

"Give me time to collect my wits, Father," said he, with a smile
that showed that his father's foibles did not prevent his son from
loving and honoring him. "Why, I have not yet had time to settle
down!"

"Nonsense, nonsense!" cried the old man, shaking his pigtail to
see whether it was firmly plaited, and grasping his by the hand.
"The house for your wife is ready. Princess Mary will take her there
and show her over, and they'll talk nineteen to the dozen. That's
their woman's way! I am glad to have her. Sit down and talk. About
Mikhelson's army I understand--Tolstoy's too... a simultaneous
expedition.... But what's the southern army to do? Prussia is
neutral... I know that. What about Austria?" said he, rising from
his chair and pacing up and down the room followed by Tikhon, who
ran after him, handing him different articles of clothing. "What of
Sweden? How will they cross Pomerania?"

Prince Andrew, seeing that his father insisted, began--at first
reluctantly, but gradually with more and more animation, and from
habit changing unconsciously from Russian to French as he went on-
to explain the plan of operation for the coming campaign. He explained
how an army, ninety thousand strong, was to threaten Prussia so as
to bring her out of her neutrality and draw her into the war; how part
of that army was to join some Swedish forces at Stralsund; how two
hundred and twenty thousand Austrians, with a hundred thousand
Russians, were to operate in Italy and on the Rhine; how fifty
thousand Russians and as many English were to land at Naples, and
how a total force of five hundred thousand men was to attack the
French from different sides. The old prince did not evince the least
interest during this explanation, but as if he were not listening to
it continued to dress while walking about, and three times
unexpectedly interrupted. Once he stopped it by shouting: "The white
one, the white one!"

This meant that Tikhon was not handing him the waistcoat he
wanted. Another time he interrupted, saying:

"And will she soon be confined?" and shaking his head
reproachfully said: "That's bad! Go on, go on."

The third interruption came when Prince Andrew was finishing his
description. The old man began to sing, in the cracked voice of old
age: "Malbrook s'en va-t-en guerre. Dieu sait quand reviendra."*


*"Marlborough is going to the wars; God knows when he'll return."


His son only smiled.

"I don't say it's a plan I approve of," said the son; "I am only
telling you what it is. Napoleon has also formed his plan by now,
not worse than this one."

"Well, you've told me nothing new," and the old man repeated,
meditatively and rapidly:

"Dieu sait quand reviendra. Go to the dining room."





CHAPTER XXVII


At the appointed hour the prince, powdered and shaven, entered the
dining room where his daughter-in-law, Princess Mary, and Mademoiselle
Bourienne were already awaiting him together with his architect, who
by a strange caprice of his employer's was admitted to table though
the position of that insignificant individual was such as could
certainly not have caused him to expect that honor. The prince, who
generally kept very strictly to social distinctions and rarely
admitted even important government officials to his table, had
unexpectedly selected Michael Ivanovich (who always went into a corner
to blow his nose on his checked handkerchief) to illustrate the theory
that all men are equals, and had more than once impressed on his
daughter that Michael Ivanovich was "not a whit worse than you or
I." At dinner the prince usually spoke to the taciturn Michael
Ivanovich more often than to anyone else.

In the dining room, which like all the rooms in the house was
exceedingly lofty, the members of the household and the footmen--one
behind each chair--stood waiting for the prince to enter. The head
butler, napkin on arm, was scanning the setting of the table, making
signs to the footmen, and anxiously glancing from the clock to the
door by which the prince was to enter. Prince Andrew was looking at
a large gilt frame, new to him, containing the genealogical tree of
the Princes Bolkonski, opposite which hung another such frame with a
badly painted portrait (evidently by the hand of the artist
belonging to the estate) of a ruling prince, in a crown--an alleged
descendant of Rurik and ancestor of the Bolkonskis. Prince Andrew,
looking again at that genealogical tree, shook his head, laughing as a
man laughs who looks at a portrait so characteristic of the original
as to be amusing.

"How thoroughly like him that is!" he said to Princess Mary, who had
come up to him.

Princess Mary looked at her brother in surprise. She did not
understand what he was laughing at. Everything her father did inspired
her with reverence and was beyond question.

"Everyone has his Achilles' heel," continued Prince Andrew.
"Fancy, with his powerful mind, indulging in such nonsense!"

Princess Mary could not understand the boldness of her brother's
criticism and was about to reply, when the expected footsteps were
heard coming from the study. The prince walked in quickly and jauntily
as was his wont, as if intentionally contrasting the briskness of
his manners with the strict formality of his house. At that moment the
great clock struck two and another with a shrill tone joined in from
the drawing room. The prince stood still; his lively glittering eyes
from under their thick, bushy eyebrows sternly scanned all present and
rested on the little princess. She felt, as courtiers do when the Tsar
enters, the sensation of fear and respect which the old man inspired
in all around him. He stroked her hair and then patted her awkwardly
on the back of her neck.

"I'm glad, glad, to see you," he said, looking attentively into
her eyes, and then quickly went to his place and sat down. "Sit
down, sit down! Sit down, Michael Ianovich!"

He indicated a place beside him to his daughter-in-law. A footman
moved the chair for her.

"Ho, ho!" said the old man, casting his eyes on her rounded
figure. "You've been in a hurry. That's bad!"

He laughed in his usual dry, cold, unpleasant way, with his lips
only and not with his eyes.

"You must walk, walk as much as possible, as much as possible," he
said.

The little princess did not, or did not wish to, hear his words. She
was silent and seemed confused. The prince asked her about her father,
and she began to smile and talk. He asked about mutual
acquaintances, and she became still more animated and chattered away
giving him greetings from various people and retailing the town
gossip.

"Countess Apraksina, poor thing, has lost her husband and she has
cried her eyes out," she said, growing more and more lively.

As she became animated the prince looked at her more and more
sternly, and suddenly, as if he had studied her sufficiently and had
formed a definite idea of her, he turned away and addressed Michael
Ivanovich.

"Well, Michael Ivanovich, our Bonaparte will be having a bad time of
it. Prince Andrew" (he always spoke thus of his son) "has been telling
me what forces are being collected against him! While you and I
never thought much of him."

Michael Ivanovich did not at all know when "you and I" had said such
things about Bonaparte, but understanding that he was wanted as a
peg on which to hang the prince's favorite topic, he looked
inquiringly at the young prince, wondering what would follow.

"He is a great tactician!" said the prince to his son, pointing to
the architect.

And the conversation again turned on the war, on Bonaparte, and
the generals and statesmen of the day. The old prince seemed convinced
not only that all the men of the day were mere babies who did not know
the A B C of war or of politics, and that Bonaparte was an
insignificant little Frenchy, successful only because there were no
longer any Potemkins or Suvorovs left to oppose him; but he was also
convinced that there were no political difficulties in Europe and no
real war, but only a sort of puppet show at which the men of the day
were playing, pretending to do something real. Prince Andrew gaily
bore with his father's ridicule of the new men, and drew him on and
listened to him with evident pleasure.

"The past always seems good," said he, "but did not Suvorov
himself fall into a trap Moreau set him, and from which he did not
know how to escape?"

"Who told you that? Who?" cried the prince. "Suvorov!" And he jerked
away his plate, which Tikhon briskly caught. "Suvorov!... Consider,
Prince Andrew. Two... Frederick and Suvorov; Moreau!... Moreau would
have been a prisoner if Suvorov had had a free hand; but he had the
Hofs-kriegs-wurst-schnapps-Rath on his hands. It would have puzzled
the devil himself! When you get there you'll find out what those
Hofs-kriegs-wurst-Raths are! Suvorov couldn't manage them so what
chance has Michael Kutuzov? No, my dear boy," he continued, "you and
your generals won't get on against Buonaparte; you'll have to call
in the French, so that birds of a feather may fight together. The
German, Pahlen, has been sent to New York in America, to fetch the
Frenchman, Moreau," he said, alluding to the invitation made that year
to Moreau to enter the Russian service.... "Wonderful!... Were the
Potemkins, Suvorovs, and Orlovs Germans? No, lad, either you fellows
have all lost your wits, or I have outlived mine. May God help you,
but we'll see what will happen. Buonaparte has become a great
commander among them! Hm!..."

"I don't at all say that all the plans are good," said Prince
Andrew, "I am only surprised at your opinion of Bonaparte. You may
laugh as much as you like, but all the same Bonaparte is a great
general!"

"Michael Ivanovich!" cried the old prince to the architect who, busy
with his roast meat, hoped he had been forgotten: "Didn't I tell you
Buonaparte was a great tactician? Here, he says the same thing."

"To be sure, your excellency." replied the architect.

The prince again laughed his frigid laugh.

"Buonaparte was born with a silver spoon in his mouth. He has got
splendid soldiers. Besides he began by attacking Germans. And only
idlers have failed to beat the Germans. Since the world began
everybody has beaten the Germans. They beat no one--except one
another. He made his reputation fighting them."

And the prince began explaining all the blunders which, according to
him, Bonaparte had made in his campaigns and even in politics. His son
made no rejoinder, but it was evident that whatever arguments were
presented he was as little able as his father to change his opinion.
He listened, refraining from a reply, and involuntarily wondered how
this old man, living alone in the country for so many years, could
know and discuss so minutely and acutely all the recent European
military and political events.

"You think I'm an old man and don't understand the present state
of affairs?" concluded his father. "But it troubles me. I don't
sleep at night. Come now, where has this great commander of yours
shown his skill?" he concluded.

"That would take too long to tell," answered the son.

"Well, then go to your Buonaparte! Mademoiselle Bourienne, here's
another admirer of that powder-monkey emperor of yours," he
exclaimed in excellent French.

"You know, Prince, I am not a Bonapartist!"

"Dieu sait quand reviendra..." hummed the prince out of tune and,
with a laugh still more so, he quitted the table.

The little princess during the whole discussion and the rest of
the dinner sat silent, glancing with a frightened look now at her
father-in-law and now at Princess Mary. When they left the table she
took her sister-in-law's arm and drew her into another room.

"What a clever man your father is," said she; "perhaps that is why I
am afraid of him."

"Oh, he is so kind!" answered Princess Mary.





CHAPTER XXVIII


Prince Andrew was to leave next evening. The old prince, not
altering his routine, retired as usual after dinner. The little
princess was in her sister-in-law's room. Prince Andrew in a traveling
coat without epaulettes had been packing with his valet in the rooms
assigned to him. After inspecting the carriage himself and seeing
the trunks put in, he ordered the horses to be harnessed. Only those
things he always kept with him remained in his room; a small box, a
large canteen fitted with silver plate, two Turkish pistols and a
saber--a present from his father who had brought it from the siege
of Ochakov. All these traveling effects of Prince Andrew's were in
very good order: new, clean, and in cloth covers carefully tied with
tapes.

When starting on a journey or changing their mode of life, men
capable of reflection are generally in a serious frame of mind. At
such moments one reviews the past and plans for the future. Prince
Andrew's face looked very thoughtful and tender. With his hands behind
him he paced briskly from corner to corner of the room, looking
straight before him and thoughtfully shaking his head. Did he fear
going to the war, or was he sad at leaving his wife?--perhaps both,
but evidently he did not wish to be seen in that mood, for hearing
footsteps in the passage he hurriedly unclasped his hands, stopped
at a table as if tying the cover of the small box, and assumed his
usual tranquil and impenetrable expression. It was the heavy tread
of Princess Mary that he heard.

"I hear you have given orders to harness," she cried, panting (she
had apparently been running), "and I did so wish to have another
talk with you alone! God knows how long we may again be parted. You
are not angry with me for coming? You have changed so, Andrusha,"
she added, as if to explain such a question.

She smiled as she uttered his pet name, "Andrusha." It was obviously
strange to her to think that this stern handsome man should be
Andrusha--the slender mischievous boy who had been her playfellow in
childhood.

"And where is Lise?" he asked, answering her question only by a
smile.

"She was so tired that she has fallen asleep on the sofa in my room.
Oh, Andrew! What a treasure of a wife you have," said she, sitting
down on the sofa, facing her brother. "She is quite a child: such a
dear, merry child. I have grown so fond of her."

Prince Andrew was silent, but the princess noticed the ironical
and contemptuous look that showed itself on his face.

"One must be indulgent to little weaknesses; who is free from
them, Andrew? Don't forget that she has grown up and been educated
in society, and so her position now is not a rosy one. We should enter
into everyone's situation. Tout comprendre, c'est tout pardonner.*
Think it must be for her, poor thing, after what she has been used to,
to be parted from her husband and be left alone in the country, in her
condition! It's very hard."


*To understand all is to forgive all.


Prince Andrew smiled as he looked at his sister, as we smile at
those we think we thoroughly understand.

"You live in the country and don't think the life terrible," he
replied.

"I... that's different. Why speak of me? I don't want any other
life, and can't, for I know no other. But think, Andrew: for a young
society woman to be buried in the country during the best years of her
life, all alone--for Papa is always busy, and I... well, you know what
poor resources I have for entertaining a woman used to the best
society. There is only Mademoiselle Bourienne...."

"I don't like your Mademoiselle Bourienne at all," said Prince
Andrew.

"No? She is very nice and kind and, above all, she's much to be
pitied. She has no one, no one. To tell the truth, I don't need her,
and she's even in my way. You know I always was a savage, and now am
even more so. I like being alone.... Father likes her very much. She
and Michael Ivanovich are the two people to whom he is always gentle
and kind, because he has been a benefactor to them both. As Sterne
says: 'We don't love people so much for the good they have done us, as
for the good we have done them.' Father took her when she was homeless
after losing her own father. She is very good-natured, and my father
likes her way of reading. She reads to him in the evenings and reads
splendidly."

"To be quite frank, Mary, I expect Father's character sometimes
makes things trying for you, doesn't it?" Prince Andrew asked
suddenly.

Princess Mary was first surprised and then aghast at this question.

"For me? For me?... Trying for me!..." said she.

"He always was rather harsh; and now I should think he's getting
very trying," said Prince Andrew, apparently speaking lightly of their
father in order to puzzle or test his sister.

"You are good in every way, Andrew, but you have a kind of
intellectual pride," said the princess, following the train of her own
thoughts rather than the trend of the conversation--"and that's a
great sin. How can one judge Father? But even if one might, what
feeling except veneration could such a man as my father evoke? And I
am so contented and happy with him. I only wish you were all as
happy as I am."

Her brother shook his head incredulously.

"The only thing that is hard for me... I will tell you the truth,
Andrew... is Father's way of treating religious subjects. I don't
understand how a man of his immense intellect can fail to see what
is as clear as day, and can go so far astray. That is the only thing
that makes me unhappy. But even in this I can see lately a shade of
improvement. His satire has been less bitter of late, and there was
a monk he received and had a long talk with."

"Ah! my dear, I am afraid you and your monk are wasting your
powder," said Prince Andrew banteringly yet tenderly.

"Ah! mon ami, I only pray, and hope that God will hear me.
Andrew..." she said timidly after a moment's silence, "I have a
great favor to ask of you."

"What is it, dear?"

"No--promise that you will not refuse! It will give you no trouble
and is nothing unworthy of you, but it will comfort me. Promise,
Andrusha!..." said she, putting her hand in her reticule but not yet
taking out what she was holding inside it, as if what she held were
the subject of her request and must not be shown before the request
was granted.

She looked timidly at her brother.

"Even if it were a great deal of trouble..." answered Prince Andrew,
as if guessing what it was about.

"Think what you please! I know you are just like Father. Think as
you please, but do this for my sake! Please do! Father's father, our
grandfather, wore it in all his wars." (She still did not take out
what she was holding in her reticule.) "So you promise?"

"Of course. What is it?"

"Andrew, I bless you with this icon and you must promise me you will
never take it off. Do you promise?"

"If it does not weigh a hundredweight and won't break my neck...
To please you..." said Prince Andrew. But immediately, noticing the
pained expression his joke had brought to his sister's face, he
repented and added: "I am glad; really, dear, I am very glad."

"Against your will He will save and have mercy on you and bring
you to Himself, for in Him alone is truth and peace," said she in a
voice trembling with emotion, solemnly holding up in both hands before
her brother a small, oval, antique, dark-faced icon of the Saviour
in a gold setting, on a finely wrought silver chain.

She crossed herself, kissed the icon, and handed it to Andrew.

"Please, Andrew, for my sake!..."

Rays of gentle light shone from her large, timid eyes. Those eyes
lit up the whole of her thin, sickly face and made it beautiful. Her
brother would have taken the icon, but she stopped him. Andrew
understood, crossed himself and kissed the icon. There was a look of
tenderness, for he was touched, but also a gleam of irony on his face.

"Thank you, my dear." She kissed him on the forehead and sat down
again on the sofa. They were silent for a while.

"As I was saying to you, Andrew, be kind and generous as you
always used to be. Don't judge Lise harshly," she began. "She is so
sweet, so good-natured, and her position now is a very hard one."

"I do not think I have complained of my wife to you, Masha, or
blamed her. Why do you say all this to me?"

Red patches appeared on Princess Mary's face and she was silent as
if she felt guilty.

"I have said nothing to you, but you have already been talked to.
And I am sorry for that," he went on.

The patches grew deeper on her forehead, neck, and cheeks. She tried
to say something but could not. Her brother had guessed right: the
little princess had been crying after dinner and had spoken of her
forebodings about her confinement, and how she dreaded it, and had
complained of her fate, her father-in-law, and her husband. After
crying she had fallen asleep. Prince Andrew felt sorry for his sister.

"Know this, Masha: I can't reproach, have not reproached, and
never shall reproach my wife with anything, and I cannot reproach
myself with anything in regard to her; and that always will be so in
whatever circumstances I may be placed. But if you want to know the
truth... if you want to know whether I am happy? No! Is she happy? No!
But why this is so I don't know..."

As he said this he rose, went to his sister, and, stooping, kissed
her forehead. His fine eyes lit up with a thoughtful, kindly, and
unaccustomed brightness, but he was looking not at his sister but over
her head toward the darkness of the open doorway.

"Let us go to her, I must say good-by. Or--go and wake and I'll come
in a moment. Petrushka!" he called to his valet: "Come here, take
these away. Put this on the seat and this to the right."

Princess Mary rose and moved to the door, then stopped and said:
"Andrew, if you had faith you would have turned to God and asked Him
to give you the love you do not feel, and your prayer would have
been answered."

"Well, may be!" said Prince Andrew. "Go, Masha; I'll come
immediately."

On the way to his sister's room, in the passage which connected
one wing with the other, Prince Andrew met Mademoiselle Bourienne
smiling sweetly. It was the third time that day that, with an ecstatic
and artless smile, she had met him in secluded passages.

"Oh! I thought you were in your room," she said, for some reason
blushing and dropping her eyes.

Prince Andrew looked sternly at her and an expression of anger
suddenly came over his face. He said nothing to her but looked at
her forehead and hair, without looking at her eyes, with such contempt
that the Frenchwoman blushed and went away without a word. When he
reached his sister's room his wife was already awake and her merry
voice, hurrying one word after another, came through the open door.
She was speaking as usual in French, and as if after long
self-restraint she wished to make up for lost time.

"No, but imagine the old Countess Zubova, with false curls and her
mouth full of false teeth, as if she were trying to cheat old
age.... Ha, ha, ha! Mary!"

This very sentence about Countess Zubova and this same laugh
Prince Andrew had already heard from his wife in the presence of
others some five times. He entered the room softly. The little
princess, plump and rosy, was sitting in an easy chair with her work
in her hands, talking incessantly, repeating Petersburg
reminiscences and even phrases. Prince Andrew came up, stroked her
hair, and asked if she felt rested after their journey. She answered
him and continued her chatter.

The coach with six horses was waiting at the porch. It was an autumn
night, so dark that the coachman could not see the carriage pole.
Servants with lanterns were bustling about in the porch. The immense
house was brilliant with lights shining through its lofty windows. The
domestic serfs were crowding in the hall, waiting to bid good-by to
the young prince. The members of the household were all gathered in
the reception hall: Michael Ivanovich, Mademoiselle Bourienne,
Princess Mary, and the little princess. Prince Andrew had been
called to his father's study as the latter wished to say good-by to
him alone. All were waiting for them to come out.

When Prince Andrew entered the study the old man in his old-age
spectacles and white dressing gown, in which he received no one but
his son, sat at the table writing. He glanced round.

"Going?" And he went on writing.

"I've come to say good-by."

"Kiss me here," and he touched his cheek: "Thanks, thanks!"

"What do you thank me for?"

"For not dilly-dallying and not hanging to a woman's apron
strings. The Service before everything. Thanks, thanks!" And he went
on writing, so that his quill spluttered and squeaked. "If you have
anything to say, say it. These two things can be done together," he
added.

"About my wife... I am ashamed as it is to leave her on your
hands..."

"Why talk nonsense? Say what you want."

"When her confinement is due, send to Moscow for an accoucheur....
Let him be here...."

The old prince stopped writing and, as if not understanding, fixed
his stern eyes on his son.

"I know that no one can help if nature does not do her work," said
Prince Andrew, evidently confused. "I know that out of a million cases
only one goes wrong, but it is her fancy and mine. They have been
telling her things. She has had a dream and is frightened."

"Hm... Hm..." muttered the old prince to himself, finishing what
he was writing. "I'll do it."

He signed with a flourish and suddenly turning to his son began to
laugh.

"It's a bad business, eh?"

"What is bad, Father?"

"The wife!" said the old prince, briefly and significantly.

"I don't understand!" said Prince Andrew.

"No, it can't be helped, lad," said the prince. "They're all like
that; one can't unmarry. Don't be afraid; I won't tell anyone, but you
know it yourself."

He seized his son by the hand with small bony fingers, shook it,
looked straight into his son's face with keen eyes which seemed to see
through him, and again laughed his frigid laugh.

The son sighed, thus admitting that his father had understood him.
The old man continued to fold and seal his letter, snatching up and
throwing down the wax, the seal, and the paper, with his accustomed
rapidity.

"What's to be done? She's pretty! I will do everything. Make your
mind easy," said he in abrupt sentences while sealing his letter.

Andrew did not speak; he was both pleased and displeased that his
father understood him. The old man got up and gave the letter to his
son.

"Listen!" said he; "don't worry about your wife: what can be done
shall be. Now listen! Give this letter to Michael Ilarionovich.* I
have written that he should make use of you in proper places and not
keep you long as an adjutant: a bad position! Tell him I remember
and like him. Write and tell me how he receives you. If he is all
right--serve him. Nicholas Bolkonski's son need not serve under anyone
if he is in disfavor. Now come here."


*Kutuzov.


He spoke so rapidly that he did not finish half his words, but his
son was accustomed to understand him. He led him to the desk, raised
the lid, drew out a drawer, and took out an exercise book filled
with his bold, tall, close handwriting.

"I shall probably die before you. So remember, these are my memoirs;
hand them to the Emperor after my death. Now here is a Lombard bond
and a letter; it is a premium for the man who writes a history of
Suvorov's wars. Send it to the Academy. Here are some jottings for you
to read when I am gone. You will find them useful."

Andrew did not tell his father that he would no doubt live a long
time yet. He felt that he must not say it.

"I will do it all, Father," he said.

"Well, now, good-by!" He gave his son his hand to kiss, and embraced
him. "Remember this, Prince Andrew, if they kill you it will hurt
me, your old father..." he paused unexpectedly, and then in a
querulous voice suddenly shrieked: "but if I hear that you have not
behaved like a son of Nicholas Bolkonski, I shall be ashamed!"

"You need not have said that to me, Father," said the son with a
smile.

The old man was silent.

"I also wanted to ask you," continued Prince Andrew, "if I'm
killed and if I have a son, do not let him be taken away from you-
as I said yesterday... let him grow up with you.... Please."

"Not let the wife have him?" said the old man, and laughed.

They stood silent, facing one another. The old man's sharp eyes were
fixed straight on his son's. Something twitched in the lower part of
the old prince's face.

"We've said good-by. Go!" he suddenly shouted in a loud, angry
voice, opening his door.

"What is it? What?" asked both princesses when they saw for a moment
at the door Prince Andrew and the figure of the old man in a white
dressing gown, spectacled and wigless, shouting in an angry voice.

Prince Andrew sighed and made no reply.

"Well!" he said, turning to his wife.

And this "Well!" sounded coldly ironic, as if he were saying,:
"Now go through your performance."

"Andrew, already!" said the little princess, turning pale and
looking with dismay at her husband.

He embraced her. She screamed and fell unconscious on his shoulder.

He cautiously released the shoulder she leaned on, looked into her
face, and carefully placed her in an easy chair.

"Adieu, Mary," said he gently to his sister, taking her by the
hand and kissing her, and then he left the room with rapid steps.

The little princess lay in the armchair, Mademoiselle Bourienne
chafing her temples. Princess Mary, supporting her sister-in-law,
still looked with her beautiful eyes full of tears at the door through
which Prince Andrew had gone and made the sign of the cross in his
direction. From the study, like pistol shots, came the frequent
sound of the old man angrily blowing his nose. Hardly had Prince
Andrew gone when the study door opened quickly and the stern figure of
the old man in the white dressing gown looked out.

"Gone? That's all right!" said he; and looking angrily at the
unconscious little princess, he shook his head reprovingly and slammed
the door.





BOOK TWO: 1805





CHAPTER I


In October, 1805, a Russian army was occupying the villages and
towns of the Archduchy of Austria, and yet other regiments freshly
arriving from Russia were settling near the fortress of Braunau and
burdening the inhabitants on whom they were quartered. Braunau was the
headquarters of the commander-in-chief, Kutuzov.

On October 11, 1805, one of the infantry regiments that had just
reached Braunau had halted half a mile from the town, waiting to be
inspected by the commander in chief. Despite the un-Russian appearance
of the locality and surroundings--fruit gardens, stone fences, tiled
roofs, and hills in the distance--and despite the fact that the
inhabitants (who gazed with curiosity at the soldiers) were not
Russians, the regiment had just the appearance of any Russian regiment
preparing for an inspection anywhere in the heart of Russia.

On the evening of the last day's march an order had been received
that the commander in chief would inspect the regiment on the march.
Though the words of the order were not clear to the regimental
commander, and the question arose whether the troops were to be in
marching order or not, it was decided at a consultation between the
battalion commanders to present the regiment in parade order, on the
principle that it is always better to "bow too low than not bow low
enough." So the soldiers, after a twenty-mile march, were kept mending
and cleaning all night long without closing their eyes, while the
adjutants and company commanders calculated and reckoned, and by
morning the regiment--instead of the straggling, disorderly crowd it
had been on its last march the day before--presented a well-ordered
array of two thousand men each of whom knew his place and his duty,
had every button and every strap in place, and shone with cleanliness.
And not only externally was all in order, but had it pleased the
commander in chief to look under the uniforms he would have found on
every man a clean shirt, and in every knapsack the appointed number of
articles, "awl, soap, and all," as the soldiers say. There was only
one circumstance concerning which no one could be at ease. It was
the state of the soldiers' boots. More than half the men's boots
were in holes. But this defect was not due to any fault of the
regimental commander, for in spite of repeated demands boots had not
been issued by the Austrian commissariat, and the regiment had marched
some seven hundred miles.

The commander of the regiment was an elderly, choleric, stout, and
thick-set general with grizzled eyebrows and whiskers, and wider
from chest to back than across the shoulders. He had on a brand-new
uniform showing the creases where it had been folded and thick gold
epaulettes which seemed to stand rather than lie down on his massive
shoulders. He had the air of a man happily performing one of the
most solemn duties of his life. He walked about in front of the line
and at every step pulled himself up, slightly arching his back. It was
plain that the commander admired his regiment, rejoiced in it, and
that his whole mind was engrossed by it, yet his strut seemed to
indicate that, besides military matters, social interests and the fair
sex occupied no small part of his thoughts.

"Well, Michael Mitrich, sir?" he said, addressing one of the
battalion commanders who smilingly pressed forward (it was plain
that they both felt happy). "We had our hands full last night.
However, I think the regiment is not a bad one, eh?"

The battalion commander perceived the jovial irony and laughed.

"It would not be turned off the field even on the Tsaritsin Meadow."

"What?" asked the commander.

At that moment, on the road from the town on which signalers had
been posted, two men appeared on horse back. They were an
aide-de-camp followed by a Cossack.

The aide-de-camp was sent to confirm the order which had not been
clearly worded the day before, namely, that the commander in chief
wished to see the regiment just in the state in which it had been on
the march: in their greatcoats, and packs, and without any preparation
whatever.

A member of the Hofkriegsrath from Vienna had come to Kutuzov the
day before with proposals and demands for him to join up with the army
of the Archduke Ferdinand and Mack, and Kutuzov, not considering
this junction advisable, meant, among other arguments in support of
his view, to show the Austrian general the wretched state in which the
troops arrived from Russia. With this object he intended to meet the
regiment; so the worse the condition it was in, the better pleased the
commander in chief would be. Though the aide-de-camp did not know
these circumstances, he nevertheless delivered the definite order that
the men should be in their greatcoats and in marching order, and
that the commander in chief would otherwise be dissatisfied. On
hearing this the regimental commander hung his head, silently shrugged
his shoulders, and spread out his arms with a choleric gesture.

"A fine mess we've made of it!" he remarked.

"There now! Didn't I tell you, Michael Mitrich, that if it was
said 'on the march' it meant in greatcoats?" said he reproachfully
to the battalion commander. "Oh, my God!" he added, stepping
resolutely forward. "Company commanders!" he shouted in a voice
accustomed to command. "Sergeants major!... How soon will he be here?"
he asked the aide-de-camp with a respectful politeness evidently
relating to the personage he was referring to.

"In an hour's time, I should say."

"Shall we have time to change clothes?"

"I don't know, General...."

The regimental commander, going up to the line himself, ordered
the soldiers to change into their greatcoats. The company commanders
ran off to their companies, the sergeants major began bustling (the
greatcoats were not in very good condition), and instantly the squares
that had up to then been in regular order and silent began to sway and
stretch and hum with voices. On all sides soldiers were running to and
fro, throwing up their knapsacks with a jerk of their shoulders and
pulling the straps over their heads, unstrapping their overcoats and
drawing the sleeves on with upraised arms.

In half an hour all was again in order, only the squares had
become gray instead of black. The regimental commander walked with his
jerky steps to the front of the regiment and examined it from a
distance.

"Whatever is this? This!" he shouted and stood still. "Commander
of the third company!"

"Commander of the third company wanted by the general!...
commander to the general... third company to the commander." The words
passed along the lines and an adjutant ran to look for the missing
officer.

When the eager but misrepeated words had reached their destination
in a cry of: "The general to the third company," the missing officer
appeared from behind his company and, though he was a middle-aged
man and not in the habit of running, trotted awkwardly stumbling on
his toes toward the general. The captain's face showed the
uneasiness of a schoolboy who is told to repeat a lesson he has not
learned. Spots appeared on his nose, the redness of which was
evidently due to intemperance, and his mouth twitched nervously. The
general looked the captain up and down as he came up panting,
slackening his pace as he approached.

"You will soon be dressing your men in petticoats! What is this?"
shouted the regimental commander, thrusting forward his jaw and
pointing at a soldier in the ranks of the third company in a greatcoat
of bluish cloth, which contrasted with the others. "What have you been
after? The commander in chief is expected and you leave your place?
Eh? I'll teach you to dress the men in fancy coats for a parade....
Eh...?"

The commander of the company, with his eyes fixed on his superior,
pressed two fingers more and more rigidly to his cap, as if in this
pressure lay his only hope of salvation.

"Well, why don't you speak? Whom have you got there dressed up as
a Hungarian?" said the commander with an austere gibe.

"Your excellency..."

"Well, your excellency, what? Your excellency! But what about your
excellency?... nobody knows."

"Your excellency, it's the officer Dolokhov, who has been reduced to
the ranks," said the captain softly.

"Well? Has he been degraded into a field marshal, or into a soldier?
If a soldier, he should be dressed in regulation uniform like the
others."

"Your excellency, you gave him leave yourself, on the march."

"Gave him leave? Leave? That's just like you young men," said the
regimental commander cooling down a little. "Leave indeed.... One says
a word to you and you... What?" he added with renewed irritation, "I
beg you to dress your men decently."

And the commander, turning to look at the adjutant, directed his
jerky steps down the line. He was evidently pleased at his own display
of anger and walking up to the regiment wished to find a further
excuse for wrath. Having snapped at an officer for an unpolished
badge, at another because his line was not straight, he reached the
third company.

"H-o-o-w are you standing? Where's your leg? Your leg?" shouted
the commander with a tone of suffering in his voice, while there
were still five men between him and Dolokhov with his bluish-gray
uniform.

Dolokhov slowly straightened his bent knee, looking straight with
his clear, insolent eyes in the general's face.

"Why a blue coat? Off with it... Sergeant major! Change his
coat... the ras..." he did not finish.

"General, I must obey orders, but I am not bound to endure..."
Dolokhov hurriedly interrupted.

"No talking in the ranks!... No talking, no talking!"

"Not bound to endure insults," Dolokhov concluded in loud, ringing
tones.

The eyes of the general and the soldier met. The general became
silent, angrily pulling down his tight scarf.

"I request you to have the goodness to change your coat," he said as
he turned away.





CHAPTER II


"He's coming!" shouted the signaler at that moment.

The regimental commander, flushing, ran to his horse, seized the
stirrup with trembling hands, threw his body across the saddle,
righted himself, drew his saber, and with a happy and resolute
countenance, opening his mouth awry, prepared to shout. The regiment
fluttered like a bird preening its plumage and became motionless.

"Att-ention!" shouted the regimental commander in a soul-shaking
voice which expressed joy for himself, severity for the regiment,
and welcome for the approaching chief.

Along the broad country road, edged on both sides by trees, came a
high, light blue Viennese caleche, slightly creaking on its springs
and drawn by six horses at a smart trot. Behind the caleche galloped
the suite and a convoy of Croats. Beside Kutuzov sat an Austrian
general, in a white uniform that looked strange among the Russian
black ones. The caleche stopped in front of the regiment. Kutuzov
and the Austrian general were talking in low voices and Kutuzov smiled
slightly as treading heavily he stepped down from the carriage just as
if those two thousand men breathlessly gazing at him and the
regimental commander did not exist.

The word of command rang out, and again the regiment quivered, as
with a jingling sound it presented arms. Then amidst a dead silence
the feeble voice of the commander in chief was heard. The regiment
roared, "Health to your ex... len... len... lency!" and again all
became silent. At first Kutuzov stood still while the regiment
moved; then he and the general in white, accompanied by the suite,
walked between the ranks.

From the way the regimental commander saluted the commander in chief
and devoured him with his eyes, drawing himself up obsequiously, and
from the way he walked through the ranks behind the generals,
bending forward and hardly able to restrain his jerky movements, and
from the way he darted forward at every word or gesture of the
commander in chief, it was evident that he performed his duty as a
subordinate with even greater zeal than his duty as a commander.
Thanks to the strictness and assiduity of its commander the
regiment, in comparison with others that had reached Braunau at the
same time, was in splendid condition. There were only 217 sick and
stragglers. Everything was in good order except the boots.

Kutuzov walked through the ranks, sometimes stopping to say a few
friendly words to officers he had known in the Turkish war,
sometimes also to the soldiers. Looking at their boots he several
times shook his head sadly, pointing them out to the Austrian
general with an expression which seemed to say that he was not blaming
anyone, but could not help noticing what a bad state of things it was.
The regimental commander ran forward on each such occasion, fearing to
miss a single word of the commander in chief's regarding the regiment.
Behind Kutuzov, at a distance that allowed every softly spoken word to
be heard, followed some twenty men of his suite. These gentlemen
talked among themselves and sometimes laughed. Nearest of all to the
commander in chief walked a handsome adjutant. This was Prince
Bolkonski. Beside him was his comrade Nesvitski, a tall staff officer,
extremely stout, with a kindly, smiling, handsome face and moist eyes.
Nesvitski could hardly keep from laughter provoked by a swarthy hussar
officer who walked beside him. This hussar, with a grave face and
without a smile or a change in the expression of his fixed eyes,
watched the regimental commander's back and mimicked his every
movement. Each time the commander started and bent forward, the hussar
started and bent forward in exactly the same manner. Nesvitski laughed
and nudged the others to make them look at the wag.

Kutuzov walked slowly and languidly past thousands of eyes which
were starting from their sockets to watch their chief. On reaching the
third company he suddenly stopped. His suite, not having expected
this, involuntarily came closer to him.

"Ah, Timokhin!" said he, recognizing the red-nosed captain who had
been reprimanded on account of the blue greatcoat.

One would have thought it impossible for a man to stretch himself
more than Timokhin had done when he was reprimanded by the
regimental commander, but now that the commander in chief addressed
him he drew himself up to such an extent that it seemed he could not
have sustained it had the commander in chief continued to look at him,
and so Kutuzov, who evidently understood his case and wished him
nothing but good, quickly turned away, a scarcely perceptible smile
flitting over his scarred and puffy face.

"Another Ismail comrade," said he. "A brave officer! Are you
satisfied with him?" he asked the regimental commander.

And the latter--unconscious that he was being reflected in the
hussar officer as in a looking glass--started, moved forward, and
answered: "Highly satisfied, your excellency!"

"We all have our weaknesses," said Kutuzov smiling and walking
away from him. "He used to have a predilection for Bacchus."

The regimental commander was afraid he might be blamed for this
and did not answer. The hussar at that moment noticed the face of
the red-nosed captain and his drawn-in stomach, and mimicked his
expression and pose with such exactitude that Nesvitski could not help
laughing. Kutuzov turned round. The officer evidently had complete
control of his face, and while Kutuzov was turning managed to make a
grimace and then assume a most serious, deferential, and innocent
expression.

The third company was the last, and Kutuzov pondered, apparently
trying to recollect something. Prince Andrew stepped forward from
among the suite and said in French:

"You told me to remind you of the officer Dolokhov, reduced to the
ranks in this regiment."

"Where is Dolokhov?" asked Kutuzov.

Dolokhov, who had already changed into a soldier's gray greatcoat,
did not wait to be called. The shapely figure of the fair-haired
soldier, with his clear blue eyes, stepped forward from the ranks,
went up to the commander in chief, and presented arms.

"Have you a complaint to make?" Kutuzov asked with a slight frown.

"This is Dolokhov," said Prince Andrew.

"Ah!" said Kutuzov. "I hope this will be a lesson to you. Do your
duty. The Emperor is gracious, and I shan't forget you if you
deserve well."

The clear blue eyes looked at the commander in chief just as
boldly as they had looked at the regimental commander, seeming by
their expression to tear open the veil of convention that separates
a commander in chief so widely from a private.

"One thing I ask of your excellency," Dolokhov said in his firm,
ringing, deliberate voice. "I ask an opportunity to atone for my fault
and prove my devotion to His Majesty the Emperor and to Russia!"

Kutuzov turned away. The same smile of the eyes with which he had
turned from Captain Timokhin again flitted over his face. He turned
away with a grimace as if to say that everything Dolokhov had said
to him and everything he could say had long been known to him, that he
was weary of it and it was not at all what he wanted. He turned away
and went to the carriage.

The regiment broke up into companies, which went to their
appointed quarters near Braunau, where they hoped to receive boots and
clothes and to rest after their hard marches.

"You won't bear me a grudge, Prokhor Ignatych?" said the
regimental commander, overtaking the third company on its way to its
quarters and riding up to Captain Timokhin who was walking in front.
(The regimental commander's face now that the inspection was happily
over beamed with irrepressible delight.) "It's in the Emperor's
service... it can't be helped... one is sometimes a bit hasty on
parade... I am the first to apologize, you know me!... He was very
pleased!" And he held out his hand to the captain.

"Don't mention it, General, as if I'd be so bold!" replied the
captain, his nose growing redder as he gave a smile which showed where
two front teeth were missing that had been knocked out by the butt end
of a gun at Ismail.

"And tell Mr. Dolokhov that I won't forget him--he may be quite
easy. And tell me, please--I've been meaning to ask--how is to ask-
how is he behaving himself, and in general..."

"As far as the service goes he is quite punctilious, your
excellency; but his character..." said Timokhin.

"And what about his character?" asked the regimental commander.

"It's different on different days," answered the captain. "One day
he is sensible, well educated, and good-natured, and the next he's a
wild beast.... In Poland, if you please, he nearly killed a Jew."

"Oh, well, well!" remarked the regimental commander. "Still, one
must have pity on a young man in misfortune. You know he has important
connections... Well, then, you just..."

"I will, your excellency," said Timokhin, showing by his smile
that he understood his commander's wish.

"Well, of course, of course!"

The regimental commander sought out Dolokhov in the ranks and,
reining in his horse, said to him:

"After the next affair... epaulettes."

Dolokhov looked round but did not say anything, nor did the
mocking smile on his lips change.

"Well, that's all right," continued the regimental commander. "A cup
of vodka for the men from me," he added so that the soldiers could
hear. "I thank you all! God be praised!" and he rode past that company
and overtook the next one.

"Well, he's really a good fellow, one can serve under him," said
Timokhin to the subaltern beside him.

"In a word, a hearty one..." said the subaltern, laughing (the
regimental commander was nicknamed King of Hearts).

The cheerful mood of their officers after the inspection infected
the soldiers. The company marched on gaily. The soldiers' voices could
be heard on every side.

"And they said Kutuzov was blind of one eye?"

"And so he is! Quite blind!"

"No, friend, he is sharper-eyed than you are. Boots and leg bands...
he noticed everything..."

"When he looked at my feet, friend... well, thinks I..."

"And that other one with him, the Austrian, looked as if he were
smeared with chalk--as white as flour! I suppose they polish him up as
they do the guns."

"I say, Fedeshon!... Did he say when the battles are to begin? You
were near him. Everybody said that Buonaparte himself was at Braunau."

"Buonaparte himself!... Just listen to the fool, what he doesn't
know! The Prussians are up in arms now. The Austrians, you see, are
putting them down. When they've been put down, the war with Buonaparte
will begin. And he says Buonaparte is in Braunau! Shows you're a fool.
You'd better listen more carefully!"

"What devils these quartermasters are! See, the fifth company is
turning into the village already... they will have their buckwheat
cooked before we reach our quarters."

"Give me a biscuit, you devil!"

"And did you give me tobacco yesterday? That's just it, friend!
Ah, well, never mind, here you are."

"They might call a halt here or we'll have to do another four
miles without eating."

"Wasn't it fine when those Germans gave us lifts! You just sit still
and are drawn along."

"And here, friend, the people are quite beggarly. There they all
seemed to be Poles--all under the Russian crown--but here they're
all regular Germans."

"Singers to the front " came the captain's order.

And from the different ranks some twenty men ran to the front. A
drummer, their leader, turned round facing the singers, and
flourishing his arm, began a long-drawn-out soldiers' song, commencing
with the words: "Morning dawned, the sun was rising," and
concluding: "On then, brothers, on to glory, led by Father

Kamenski." This song had been composed in the Turkish campaign and now
being sung in Austria, the only change being that the words "Father
Kamenski" were replaced by "Father Kutuzov."

Having jerked out these last words as soldiers do and waved his arms
as if flinging something to the ground, the drummer--a lean,
handsome soldier of forty--looked sternly at the singers and screwed
up his eyes. Then having satisfied himself that all eyes were fixed on
him, he raised both arms as if carefully lifting some invisible but
precious object above his head and, holding it there for some seconds,
suddenly flung it down and began:

"Oh, my bower, oh, my bower...!"

"Oh, my bower new...!" chimed in twenty voices, and the castanet
player, in spite of the burden of his equipment, rushed out to the
front and, walking backwards before the company, jerked his
shoulders and flourished his castanets as if threatening someone.
The soldiers, swinging their arms and keeping time spontaneously,
marched with long steps. Behind the company the sound of wheels, the
creaking of springs, and the tramp of horses' hoofs were heard.
Kutuzov and his suite were returning to the town. The commander in
chief made a sign that the men should continue to march at ease, and
he and all his suite showed pleasure at the sound of the singing and
the sight of the dancing soldier and the gay and smartly marching men.
In the second file from the right flank, beside which the carriage
passed the company, a blue-eyed soldier involuntarily attracted
notice. It was Dolokhov marching with particular grace and boldness in
time to the song and looking at those driving past as if he pitied all
who were not at that moment marching with the company. The hussar
cornet of Kutuzov's suite who had mimicked the regimental commander,
fell back from the carriage and rode up to Dolokhov.

Hussar cornet Zherkov had at one time, in Petersburg, belonged to
the wild set led by Dolokhov. Zherkov had met Dolokhov abroad as a
private and had not seen fit to recognize him. But now that Kutuzov
had spoken to the gentleman ranker, he addressed him with the
cordiality of an old friend.

"My dear fellow, how are you?" said he through the singing, making
his horse keep pace with the company.

"How am I?" Dolokhov answered coldly. "I am as you see."

The lively song gave a special flavor to the tone of free and easy
gaiety with which Zherkov spoke, and to the intentional coldness of
Dolokhov's reply.

"And how do you get on with the officers?" inquired Zherkov.

"All right. They are good fellows. And how have you wriggled onto
the staff?"

"I was attached; I'm on duty."

Both were silent.

"She let the hawk fly upward from her wide right sleeve," went the
song, arousing an involuntary sensation of courage and cheerfulness.
Their conversation would probably have been different but for the
effect of that song.

"Is it true that Austrians have been beaten?" asked Dolokhov.

"The devil only knows! They say so."

"I'm glad," answered Dolokhov briefly and clearly, as the song
demanded.

"I say, come round some evening and we'll have a game of faro!" said
Zherkov.

"Why, have you too much money?"

"Do come."

"I can't. I've sworn not to. I won't drink and won't play till I get
reinstated."

"Well, that's only till the first engagement."

"We shall see."

They were again silent.

"Come if you need anything. One can at least be of use on the
staff..."

Dolokhov smiled. "Don't trouble. If I want anything, I won't beg-
I'll take it!"

"Well, never mind; I only..."

"And I only..."

"Good-by."

"Good health..."

        "It's a long, long way.
        To my native land..."


Zherkov touched his horse with the spurs; it pranced excitedly
from foot to foot uncertain with which to start, then settled down,
galloped past the company, and overtook the carriage, still keeping
time to the song.





CHAPTER III


On returning from the review, Kutuzov took the Austrian general into
his private room and, calling his adjutant, asked for some papers
relating to the condition of the troops on their arrival, and the
letters that had come from the Archduke Ferdinand, who was in
command of the advanced army. Prince Andrew Bolkonski came into the
room with the required papers. Kutuzov and the Austrian member of
the Hofkriegsrath were sitting at the table on which a plan was spread
out.

"Ah!..." said Kutuzov glancing at Bolkonski as if by this
exclamation he was asking the adjutant to wait, and he went on with
the conversation in French.

"All I can say, General," said he with a pleasant elegance of
expression and intonation that obliged one to listen to each
deliberately spoken word. It was evident that Kutuzov himself listened
with pleasure to his own voice. "All I can say, General, is that if
the matter depended on my personal wishes, the will of His Majesty the
Emperor Francis would have been fulfilled long ago. I should long
ago have joined the archduke. And believe me on my honour that to me
personally it would be a pleasure to hand over the supreme command
of the army into the hands of a better informed and more skillful
general--of whom Austria has so many--and to lay down all this heavy
responsibility. But circumstances are sometimes too strong for us,
General."

And Kutuzov smiled in a way that seemed to say, "You are quite at
liberty not to believe me and I don't even care whether you do or not,
but you have no grounds for telling me so. And that is the whole
point."

The Austrian general looked dissatisfied, but had no option but to
reply in the same tone.

"On the contrary," he said, in a querulous and angry tone that
contrasted with his flattering words, "on the contrary, your
excellency's participation in the common action is highly valued by
His Majesty; but we think the present delay is depriving the
splendid Russian troops and their commander of the laurels they have
been accustomed to win in their battles," he concluded his evidently
prearranged sentence.

Kutuzov bowed with the same smile.

"But that is my conviction, and judging by the last letter with
which His Highness the Archduke Ferdinand has honored me, I imagine
that the Austrian troops, under the direction of so skillful a
leader as General Mack, have by now already gained a decisive
victory and no longer need our aid," said Kutuzov.

The general frowned. Though there was no definite news of an
Austrian defeat, there were many circumstances confirming the
unfavorable rumors that were afloat, and so Kutuzov's suggestion of an
Austrian victory sounded much like irony. But Kutuzov went on
blandly smiling with the same expression, which seemed to say that
he had a right to suppose so. And, in fact, the last letter he had
received from Mack's army informed him of a victory and stated
strategically the position of the army was very favorable.

"Give me that letter," said Kutuzov turning to Prince Andrew.
"Please have a look at it"--and Kutuzov with an ironical smile about
the corners of his mouth read to the Austrian general the following
passage, in German, from the Archduke Ferdinand's letter:


We have fully concentrated forces of nearly seventy thousand men
with which to attack and defeat the enemy should he cross the Lech.
Also, as we are masters of Ulm, we cannot be deprived of the advantage
of commanding both sides of the Danube, so that should the enemy not
cross the Lech, we can cross the Danube, throw ourselves on his line
of communications, recross the river lower down, and frustrate his
intention should he try to direct his whole force against our faithful
ally. We shall therefore confidently await the moment when the
Imperial Russian army will be fully equipped, and shall then, in
conjunction with it, easily find a way to prepare for the enemy the
fate he deserves.


Kutuzov sighed deeply on finishing this paragraph and looked at
the member of the Hofkriegsrath mildly and attentively.

"But you know the wise maxim your excellency, advising one to expect
the worst," said the Austrian general, evidently wishing to have
done with jests and to come to business. He involuntarily looked round
at the aide-de-camp.

"Excuse me, General," interrupted Kutuzov, also turning to Prince
Andrew. "Look here, my dear fellow, get from Kozlovski all the reports
from our scouts. Here are two letters from Count Nostitz and here is
one from His Highness the Archduke Ferdinand and here are these," he
said, handing him several papers, "make a neat memorandum in French
out of all this, showing all the news we have had of the movements
of the Austrian army, and then give it to his excellency."

Prince Andrew bowed his head in token of having understood from
the first not only what had been said but also what Kutuzov would have
liked to tell him. He gathered up the papers and with a bow to both,
stepped softly over the carpet and went out into the waiting room.

Though not much time had passed since Prince Andrew had left Russia,
he had changed greatly during that period. In the expression of his
face, in his movements, in his walk, scarcely a trace was left of
his former affected languor and indolence. He now looked like a man
who has time to think of the impression he makes on others, but is
occupied with agreeable and interesting work. His face expressed
more satisfaction with himself and those around him, his smile and
glance were brighter and more attractive.

Kutuzov, whom he had overtaken in Poland, had received him very
kindly, promised not to forget him, distinguished him above the
other adjutants, and had taken him to Vienna and given him the more
serious commissions. From Vienna Kutuzov wrote to his old comrade,
Prince Andrew's father.


Your son bids fair to become an officer distinguished by his
industry, firmness, and expedition. I consider myself fortunate to
have such a subordinate by me.


On Kutuzov's staff, among his fellow officers and in the army
generally, Prince Andrew had, as he had had in Petersburg society, two
quite opposite reputations. Some, a minority, acknowledged him to be
different from themselves and from everyone else, expected great
things of him, listened to him, admired, and imitated him, and with
them Prince Andrew was natural and pleasant. Others, the majority,
disliked him and considered him conceited, cold, and disagreeable. But
among these people Prince Andrew knew how to take his stand so that
they respected and even feared him.

Coming out of Kutuzov's room into the waiting room with the papers
in his hand Prince Andrew came up to his comrade, the aide-de-camp
on duty, Kozlovski, who was sitting at the window with a book.

"Well, Prince?" asked Kozlovski.

"I am ordered to write a memorandum explaining why we are not
advancing."

"And why is it?"

Prince Andrew shrugged his shoulders.

"Any news from Mack?"

"No."

"If it were true that he has been beaten, news would have come."

"Probably," said Prince Andrew moving toward the outer door.

But at that instant a tall Austrian general in a greatcoat, with the
order of Maria Theresa on his neck and a black bandage round his head,
who had evidently just arrived, entered quickly, slamming the door.
Prince Andrew stopped short.

"Commander in Chief Kutuzov?" said the newly arrived general
speaking quickly with a harsh German accent, looking to both sides and
advancing straight toward the inner door.

"The commander in chief is engaged," said Kozlovski, going hurriedly
up to the unknown general and blocking his way to the door. "Whom
shall I announce?"

The unknown general looked disdainfully down at Kozlovski, who was
rather short, as if surprised that anyone should not know him.

"The commander in chief is engaged," repeated Kozlovski calmly.

The general's face clouded, his lips quivered and trembled. He
took out a notebook, hurriedly scribbled something in pencil, tore out
the leaf, gave it to Kozlovski, stepped quickly to the window, and
threw himself into a chair, gazing at those in the room as if
asking, "Why do they look at me?" Then he lifted his head, stretched
his neck as if he intended to say something, but immediately, with
affected indifference, began to hum to himself, producing a queer
sound which immediately broke off. The door of the private room opened
and Kutuzov appeared in the doorway. The general with the bandaged
head bent forward as though running away from some danger, and, making
long, quick strides with his thin legs, went up to Kutuzov.

"Vous voyez le malheureux Mack," he uttered in a broken voice.

Kutuzov's face as he stood in the open doorway remained perfectly
immobile for a few moments. Then wrinkles ran over his face like a
wave and his forehead became smooth again, he bowed his head
respectfully, closed his eyes, silently let Mack enter his room before
him, and closed the door himself behind him.

The report which had been circulated that the Austrians had been
beaten and that the whole army had surrendered at Ulm proved to be
correct. Within half an hour adjutants had been sent in various
directions with orders which showed that the Russian troops, who had
hitherto been inactive, would also soon have to meet the enemy.

Prince Andrew was one of those rare staff officers whose chief
interest lay in the general progress of the war. When he saw Mack
and heard the details of his disaster he understood that half the
campaign was lost, understood all the difficulties of the Russian
army's position, and vividly imagined what awaited it and the part
he would have to play. Involuntarily he felt a joyful agitation at the
thought of the humiliation of arrogant Austria and that in a week's
time he might, perhaps, see and take part in the first Russian
encounter with the French since Suvorov met them. He feared that
Bonaparte's genius might outweigh all the courage of the Russian
troops, and at the same time could not admit the idea of his hero
being disgraced.

Excited and irritated by these thoughts Prince Andrew went toward
his room to write to his father, to whom he wrote every day. In the
corridor he met Nesvitski, with whom he shared a room, and the wag
Zherkov; they were as usual laughing.

"Why are you so glum?" asked Nesvitski noticing Prince Andrew's pale
face and glittering eyes.

"There's nothing to be gay about," answered Bolkonski.

Just as Prince Andrew met Nesvitski and Zherkov, there came toward
them from the other end of the corridor, Strauch, an Austrian
general who on Kutuzov's staff in charge of the provisioning of the
Russian army, and the member of the Hofkriegsrath who had arrived
the previous evening. There was room enough in the wide corridor for
the generals to pass the three officers quite easily, but Zherkov,
pushing Nesvitski aside with his arm, said in a breathless voice,

"They're coming!... they're coming!... Stand aside, make way, please
make way!"

The generals were passing by, looking as if they wished to avoid
embarrassing attentions. On the face of the wag Zherkov there suddenly
appeared a stupid smile of glee which he seemed unable to suppress.

"Your excellency," said he in German, stepping forward and
addressing the Austrian general, "I have the honor to congratulate
you."

He bowed his head and scraped first with one foot and then with
the other, awkwardly, like a child at a dancing lesson.

The member of the Hofkriegsrath looked at him severely but, seeing
the seriousness of his stupid smile, could not but give him a moment's
attention. He screwed up his eyes showing that he was listening.

"I have the honor to congratulate you. General Mack has arrived,
quite well, only a little bruised just here," he added, pointing
with a beaming smile to his head.

The general frowned, turned away, and went on.

"Gott, wie naiv!"* said he angrily, after he had gone a few steps.

*"Good God, what simplicity!"


Nesvitski with a laugh threw his arms round Prince Andrew, but
Bolkonski, turning still paler, pushed him away with an angry look and
turned to Zherkov. The nervous irritation aroused by the appearance of
Mack, the news of his defeat, and the thought of what lay before the
Russian army found vent in anger at Zherkov's untimely jest.

"If you, sir, choose to make a buffoon of yourself," he said
sharply, with a slight trembling of the lower jaw, "I can't prevent
your doing so; but I warn you that if you dare to play the fool in
my presence, I will teach you to behave yourself."

Nesvitski and Zherkov were so surprised by this outburst that they
gazed at Bolkonski silently with wide-open eyes.

"What's the matter? I only congratulated them," said Zherkov.

"I am not jesting with you; please be silent!" cried Bolkonski,
and taking Nesvitski's arm he left Zherkov, who did not know what to
say.

"Come, what's the matter, old fellow?" said Nesvitski trying to
soothe him.

"What's the matter?" exclaimed Prince Andrew standing still in his
excitement. "Don't you understand that either we are officers
serving our Tsar and our country, rejoicing in the successes and
grieving at the misfortunes of our common cause, or we are merely
lackeys who care nothing for their master's business. Quarante mille
hommes massacres et l'armee de nos allies detruite, et vous trouvez la
le mot pour rire,"* he said, as if strengthening his views by this
French sentence. "C'est bien pour un garcon de rein comme cet
individu dont vous avez fait un ami, mais pas pour vous, pas pour
vous.*[2] Only a hobbledehoy could amuse himself in this way," he
added in Russian--but pronouncing the word with a French accent-
having noticed that Zherkov could still hear him.


*"Forty thousand men massacred and the army of our allies destroyed,
and you find that a cause for jesting!"

*[2] "It is all very well for that good-for-nothing fellow of whom
you have made a friend, but not for you, not for you."


He waited a moment to see whether the cornet would answer, but he
turned and went out of the corridor.





CHAPTER IV


The Pavlograd Hussars were stationed two miles from Braunau. The
squadron in which Nicholas Rostov served as a cadet was quartered in
the German village of Salzeneck. The best quarters in the village were
assigned to cavalry-captain Denisov, the squadron commander, known
throughout the whole cavalry division as Vaska Denisov. Cadet
Rostov, ever since he had overtaken the regiment in Poland, had
lived with the squadron commander.

On October 11, the day when all was astir at headquarters over the
news of Mack's defeat, the camp life of the officers of this
squadron was proceeding as usual. Denisov, who had been losing at
cards all night, had not yet come home when Rostov rode back early
in the morning from a foraging expedition. Rostov in his cadet
uniform, with a jerk to his horse, rode up to the porch, swung his leg
over the saddle with a supple youthful movement, stood for a moment in
the stirrup as if loathe to part from his horse, and at last sprang
down and called to his orderly.

"Ah, Bondarenko, dear friend!" said he to the hussar who rushed up
headlong to the horse. "Walk him up and down, my dear fellow," he
continued, with that gay brotherly cordiality which goodhearted
young people show to everyone when they are happy.

"Yes, your excellency," answered the Ukrainian gaily, tossing his
head.

"Mind, walk him up and down well!"

Another hussar also rushed toward the horse, but Bondarenko had
already thrown the reins of the snaffle bridle over the horse's
head. It was evident that the cadet was liberal with his tips and that
it paid to serve him. Rostov patted the horse's neck and then his
flank, and lingered for a moment.

"Splendid! What a horse he will be!" he thought with a smile, and
holding up his saber, his spurs jingling, he ran up the steps of the
porch. His landlord, who in a waistcoat and a pointed cap, pitchfork
in hand, was clearing manure from the cowhouse, looked out, and his
face immediately brightened on seeing Rostov. "Schon gut Morgen! Schon
gut Morgen!"* he said winking with a merry smile, evidently pleased to
greet the young man.


*"A very good morning! A very good morning!"


"Schon fleissig?"* said Rostov with the same gay brotherly smile
which did not leave his eager face. "Hoch Oestreicher! Hoch Russen!
Kaiser Alexander hoch!"*[2] said he, quoting words often repeated by
the German landlord.


*"Busy already?"

*[2] "Hurrah for the Austrians! Hurrah for the Russians! Hurrah
for Emperor Alexander!"


The German laughed, came out of the cowshed, pulled off his cap, and
waving it above his head cried:

"Und die ganze Welt hoch!"*


*"And hurrah for the whole world!"


Rostov waved his cap above his head like the German and cried
laughing, "Und vivat die ganze Welt!" Though neither the German
cleaning his cowshed nor Rostov back with his platoon from foraging
for hay had any reason for rejoicing, they looked at each other with
joyful delight and brotherly love, wagged their heads in token of
their mutual affection, and parted smiling, the German returning to
his cowshed and Rostov going to the cottage he occupied with Denisov.

"What about your master?" he asked Lavrushka, Denisov's orderly,
whom all the regiment knew for a rogue.

"Hasn't been in since the evening. Must have been losing,"
answered Lavrushka. "I know by now, if he wins he comes back early
to brag about it, but if he stays out till morning it means he's
lost and will come back in a rage. Will you have coffee?"

"Yes, bring some."

Ten minutes later Lavrushka brought the coffee. "He's coming!"
said he. "Now for trouble!" Rostov looked out of the window and saw
Denisov coming home. Denisov was a small man with a red face,
sparkling black eyes, and black tousled mustache and hair. He wore
an unfastened cloak, wide breeches hanging down in creases, and a
crumpled shako on the back of his head. He came up to the porch
gloomily, hanging his head.

"Lavwuska!" he shouted loudly and angrily, "take it off, blockhead!"

"Well, I am taking it off," replied Lavrushka's voice.

"Ah, you're up already," said Denisov, entering the room.

"Long ago," answered Rostov, "I have already been for the hay, and
have seen Fraulein Mathilde."

"Weally! And I've been losing, bwother. I lost yesterday like a
damned fool!" cried Denisov, not pronouncing his r's. "Such ill
luck! Such ill luck. As soon as you left, it began and went on.
Hullo there! Tea!"

Puckering up his face though smiling, and showing his short strong
teeth, he began with stubby fingers of both hands to ruffle up his
thick tangled black hair.

"And what devil made me go to that wat?" (an officer nicknamed
"the rat") he said, rubbing his forehead and whole face with both
hands. "Just fancy, he didn't let me win a single cahd, not one cahd."

He took the lighted pipe that was offered to him, gripped it in
his fist, and tapped it on the floor, making the sparks fly, while
he continued to shout.

"He lets one win the singles and collahs it as soon as one doubles
it; gives the singles and snatches the doubles!"

He scattered the burning tobacco, smashed the pipe, and threw it
away. Then he remained silent for a while, and all at once looked
cheerfully with his glittering, black eyes at Rostov.

"If at least we had some women here; but there's nothing foh one
to do but dwink. If we could only get to fighting soon. Hullo, who's
there?" he said, turning to the door as he heard a tread of heavy
boots and the clinking of spurs that came to a stop, and a
respectful cough.

"The squadron quartermaster!" said Lavrushka.

Denisov's face puckered still more.

"Wetched!" he muttered, throwing down a purse with some gold in
it. "Wostov, deah fellow, just see how much there is left and shove
the purse undah the pillow," he said, and went out to the
quartermaster.

Rostov took the money and, mechanically arranging the old and new
coins in separate piles, began counting them.

"Ah! Telyanin! How d'ye do? They plucked me last night," came
Denisov's voice from the next room.

"Where? At Bykov's, at the rat's... I knew it," replied a piping
voice, and Lieutenant Telyanin, a small officer of the same
squadron, entered the room.

Rostov thrust the purse under the pillow and shook the damp little
hand which was offered him. Telyanin for some reason had been
transferred from the Guards just before this campaign. He behaved very
well in the regiment but was not liked; Rostov especially detested him
and was unable to overcome or conceal his groundless antipathy to
the man.

"Well, young cavalryman, how is my Rook behaving?" he asked. (Rook
was a young horse Telyanin had sold to Rostov.)

The lieutenant never looked the man he was speaking to straight in
the face; his eyes continually wandered from one object to another.

"I saw you riding this morning..." he added.

"Oh, he's all right, a good horse," answered Rostov, though the
horse for which he had paid seven hundred rubbles was not worth half
that sum. "He's begun to go a little lame on the left foreleg," he
added.

"The hoof's cracked! That's nothing. I'll teach you what to do and
show you what kind of rivet to use."

"Yes, please do," said Rostov.

"I'll show you, I'll show you! It's not a secret. And it's a horse
you'll thank me for."

"Then I'll have it brought round," said Rostov wishing to avoid
Telyanin, and he went out to give the order.

In the passage Denisov, with a pipe, was squatting on the
threshold facing the quartermaster who was reporting to him. On seeing
Rostov, Denisov screwed up his face and pointing over his shoulder
with his thumb to the room where Telyanin was sitting, he frowned
and gave a shudder of disgust.

"Ugh! I don't like that fellow," he said, regardless of the
quartermaster's presence.

Rostov shrugged his shoulders as much as to say: "Nor do I, but
what's one to do?" and, having given his order, he returned to
Telyanin.

Telyanin was sitting in the same indolent pose in which Rostov had
left him, rubbing his small white hands.

"Well there certainly are disgusting people," thought Rostov as he
entered.

"Have you told them to bring the horse?" asked Telyanin, getting
up and looking carelessly about him.

"I have."

"Let us go ourselves. I only came round to ask Denisov about
yesterday's order. Have you got it, Denisov?"

"Not yet. But where are you off to?"

"I want to teach this young man how to shoe a horse," said Telyanin.

They went through the porch and into the stable. The lieutenant
explained how to rivet the hoof and went away to his own quarters.

When Rostov went back there was a bottle of vodka and a sausage on
the table. Denisov was sitting there scratching with his pen on a
sheet of paper. He looked gloomily in Rostov's face and said: "I am
witing to her."

He leaned his elbows on the table with his pen in his hand and,
evidently glad of a chance to say quicker in words what he wanted to
write, told Rostov the contents of his letter.

"You see, my fwiend," he said, "we sleep when we don't love. We
are childwen of the dust... but one falls in love and one is a God,
one is pua' as on the first day of cweation... Who's that now? Send
him to the devil, I'm busy!" he shouted to Lavrushka, who went up to
him not in the least abashed.

"Who should it be? You yourself told him to come. It's the
quartermaster for the money."

Denisov frowned and was about to shout some reply but stopped.

"Wetched business," he muttered to himself. "How much is left in the
puhse?" he asked, turning to Rostov.

"Seven new and three old imperials."

"Oh, it's wetched! Well, what are you standing there for, you
sca'cwow? Call the quahtehmasteh," he shouted to Lavrushka.

"Please, Denisov, let me lend you some: I have some, you know," said
Rostov, blushing.

"Don't like bowwowing from my own fellows, I don't," growled
Denisov.

"But if you won't accept money from me like a comrade, you will
offend me. Really I have some," Rostov repeated.

"No, I tell you."

And Denisov went to the bed to get the purse from under the pillow.

"Where have you put it, Wostov?"

"Under the lower pillow."

"It's not there."

Denisov threw both pillows on the floor. The purse was not there.

"That's a miwacle."

"Wait, haven't you dropped it?" said Rostov, picking up the
pillows one at a time and shaking them.

He pulled off the quilt and shook it. The purse was not there.

"Dear me, can I have forgotten? No, I remember thinking that you
kept it under your head like a treasure," said Rostov. "I put it
just here. Where is it?" he asked, turning to Lavrushka.

"I haven't been in the room. It must be where you put it."

"But it isn't?..."

"You're always like that; you thwow a thing down anywhere and forget
it. Feel in your pockets."

"No, if I hadn't thought of it being a treasure," said Rostov,
"but I remember putting it there."

Lavrushka turned all the bedding over, looked under the bed and
under the table, searched everywhere, and stood still in the middle of
the room. Denisov silently watched Lavrushka's movements, and when the
latter threw up his arms in surprise saying it was nowhere to be found
Denisov glanced at Rostov.

"Wostov, you've not been playing schoolboy twicks..."

Rostov felt Denisov's gaze fixed on him, raised his eyes, and
instantly dropped them again. All the blood which had seemed congested
somewhere below his throat rushed to his face and eyes. He could not
draw breath.

"And there hasn't been anyone in the room except the lieutenant
and yourselves. It must be here somewhere," said Lavrushka.

"Now then, you devil's puppet, look alive and hunt for it!"
shouted Denisov, suddenly, turning purple and rushing at the man
with a threatening gesture. "If the purse isn't found I'll flog you,
I'll flog you all."

Rostov, his eyes avoiding Denisov, began buttoning his coat, buckled
on his saber, and put on his cap.

"I must have that purse, I tell you," shouted Denisov, shaking his
orderly by the shoulders and knocking him against the wall.

"Denisov, let him alone, I know who has taken it," said Rostov,
going toward the door without raising his eyes. Denisov paused,
thought a moment, and, evidently understanding what Rostov hinted
at, seized his arm.

"Nonsense!" he cried, and the veins on his forehead and neck stood
out like cords. "You are mad, I tell you. I won't allow it. The
purse is here! I'll flay this scoundwel alive, and it will be found."

"I know who has taken it," repeated Rostov in an unsteady voice, and
went to the door.

"And I tell you, don't you dahe to do it!" shouted Denisov,
rushing at the cadet to restrain him.

But Rostov pulled away his arm and, with as much anger as though
Denisov were his worst enemy, firmly fixed his eyes directly on his
face.

"Do you understand what you're saying?" he said in a trembling
voice. "There was no one else in the room except myself. So that if it
is not so, then..."

He could not finish, and ran out of the room.

"Ah, may the devil take you and evewybody," were the last words
Rostov heard.

Rostov went to Telyanin's quarters.

"The master is not in, he's gone to headquarters," said Telyanin's
orderly. "Has something happened?" he added, surprised at the
cadet's troubled face.

"No, nothing."

"You've only just missed him," said the orderly.

The headquarters were situated two miles away from Salzeneck, and
Rostov, without returning home, took a horse and rode there. There was
an inn in the village which the officers frequented. Rostov rode up to
it and saw Telyanin's horse at the porch.

In the second room of the inn the lieutenant was sitting over a dish
of sausages and a bottle of wine.

"Ah, you've come here too, young man!" he said, smiling and
raising his eyebrows.

"Yes," said Rostov as if it cost him a great deal to utter the word;
and he sat down at the nearest table.

Both were silent. There were two Germans and a Russian officer in
the room. No one spoke and the only sounds heard were the clatter of
knives and the munching of the lieutenant.

When Telyanin had finished his lunch he took out of his pocket a
double purse and, drawing its rings aside with his small, white,
turned-up fingers, drew out a gold imperial, and lifting his
eyebrows gave it to the waiter.

"Please be quick," he said.

The coin was a new one. Rostov rose and went up to Telyanin.

"Allow me to look at your purse," he said in a low, almost
inaudible, voice.

With shifting eyes but eyebrows still raised, Telyanin handed him
the purse.

"Yes, it's a nice purse. Yes, yes," he said, growing suddenly
pale, and added, "Look at it, young man."

Rostov took the purse in his hand, examined it and the money in
it, and looked at Telyanin. The lieutenant was looking about in his
usual way and suddenly seemed to grow very merry.

"If we get to Vienna I'll get rid of it there but in these
wretched little towns there's nowhere to spend it," said he. "Well,
let me have it, young man, I'm going."

Rostov did not speak.

"And you? Are you going to have lunch too? They feed you quite
decently here," continued Telyanin. "Now then, let me have it."

He stretched out his hand to take hold of the purse. Rostov let go
of it. Telyanin took the purse and began carelessly slipping it into
the pocket of his riding breeches, with his eyebrows lifted and his
mouth slightly open, as if to say, "Yes, yes, I am putting my purse in
my pocket and that's quite simple and is no else's business."

"Well, young man?" he said with a sigh, and from under his lifted
brows he glanced into Rostov's eyes.

Some flash as of an electric spark shot from Telyanin's eyes to
Rostov's and back, and back again and again in an instant.

"Come here," said Rostov, catching hold of Telyanin's arm and almost
dragging him to the window. "That money is Denisov's; you took
it..." he whispered just above Telyanin's ear.

"What? What? How dare you? What?" said Telyanin.

But these words came like a piteous, despairing cry and an
entreaty for pardon. As soon as Rostov heard them, an enormous load of
doubt fell from him. He was glad, and at the same instant began to
pity the miserable man who stood before him, but the task he had begun
had to be completed.

"Heaven only knows what the people here may imagine," muttered
Telyanin, taking up his cap and moving toward a small empty room.
"We must have an explanation..."

"I know it and shall prove it," said Rostov.

"I..."

Every muscle of Telyanin's pale, terrified face began to quiver, his
eyes still shifted from side to side but with a downward look not
rising to Rostov's face, and his sobs were audible.

"Count!... Don't ruin a young fellow... here is this wretched money,
take it..." He threw it on the table. "I have an old father and
mother!..."

Rostov took the money, avoiding Telyanin's eyes, and went out of the
room without a word. But at the door he stopped and then retraced
his steps. "O God," he said with tears in his eyes, "how could you
do it?"

"Count..." said Telyanin drawing nearer to him.

"Don't touch me," said Rostov, drawing back. "If you need it, take
the money," and he threw the purse to him and ran out of the inn.





CHAPTER V


That same evening there was an animated discussion among the
squadron's officers in Denisov's quarters.

"And I tell you, Rostov, that you must apologize to the colonel!"
said a tall, grizzly-haired staff captain, with enormous mustaches and
many wrinkles on his large features, to Rostov who was crimson with
excitement.

The staff captain, Kirsten, had twice been reduced to the ranks
for affairs of honor and had twice regained his commission.

"I will allow no one to call me a liar!" cried Rostov. "He told me I
lied, and I told him he lied. And there it rests. He may keep me on
duty every day, or may place me under arrest, but no one can make me
apologize, because if he, as commander of this regiment, thinks it
beneath his dignity to give me satisfaction, then..."

"You just wait a moment, my dear fellow, and listen," interrupted
the staff captain in his deep bass, calmly stroking his long mustache.
"You tell the colonel in the presence of other officers that an
officer has stolen..."

"I'm not to blame that the conversation began in the presence of
other officers. Perhaps I ought not to have spoken before them, but
I am not a diplomatist. That's why I joined the hussars, thinking that
here one would not need finesse; and he tells me that I am lying--so
let him give me satisfaction..."

"That's all right. No one thinks you a coward, but that's not the
point. Ask Denisov whether it is not out of the question for a cadet
to demand satisfaction of his regimental commander?"

Denisov sat gloomily biting his mustache and listening to the
conversation, evidently with no wish to take part in it. He answered
the staff captain's question by a disapproving shake of his head.

"You speak to the colonel about this nasty business before other
officers," continued the staff captain, "and Bogdanich" (the colonel
was called Bogdanich) "shuts you up."

"He did not shut me up, he said I was telling an untruth."

"Well, have it so, and you talked a lot of nonsense to him and
must apologize."

"Not on any account!" exclaimed Rostov.

"I did not expect this of you," said the staff captain seriously and
severely. "You don't wish to apologize, but, man, it's not only to him
but to the whole regiment--all of us--you're to blame all round. The
case is this: you ought to have thought the matter over and taken
advice; but no, you go and blurt it all straight out before the
officers. Now what was the colonel to do? Have the officer tried and
disgrace the whole regiment? Disgrace the whole regiment because of
one scoundrel? Is that how you look at it? We don't see it like
that. And Bogdanich was a brick: he told you you were saying what
was not true. It's not pleasant, but what's to be done, my dear
fellow? You landed yourself in it. And now, when one wants to smooth
the thing over, some conceit prevents your apologizing, and you wish
to make the whole affair public. You are offended at being put on duty
a bit, but why not apologize to an old and honorable officer? Whatever
Bogdanich may be, anyway he is an honorable and brave old colonel!
You're quick at taking offense, but you don't mind disgracing the
whole regiment!" The staff captain's voice began to tremble. "You have
been in the regiment next to no time, my lad, you're here today and
tomorrow you'll be appointed adjutant somewhere and can snap your
fingers when it is said 'There are thieves among the Pavlograd
officers!' But it's not all the same to us! Am I not right, Denisov?
It's not the same!"

Denisov remained silent and did not move, but occasionally looked
with his glittering black eyes at Rostov.

"You value your own pride and don't wish to apologize," continued
the staff captain, "but we old fellows, who have grown up in and,
God willing, are going to die in the regiment, we prize the honor of
the regiment, and Bogdanich knows it. Oh, we do prize it, old
fellow! And all this is not right, it's not right! You may take
offense or not but I always stick to mother truth. It's not right!"

And the staff captain rose and turned away from Rostov.

"That's twue, devil take it!" shouted Denisov, jumping up. "Now then,
Wostov, now then!"

 Rostov, growing red and pale alternately, looked first at one
officer and then at the other.

"No, gentlemen, no... you mustn't think... I quite understand.
You're wrong to think that of me... I... for me... for the honor of
the regiment I'd... Ah well, I'll show that in action, and for me
the honor of the flag... Well, never mind, it's true I'm to blame,
to blame all round. Well, what else do you want?..."

"Come, that's right, Count!" cried the staff captain, turning
round and clapping Rostov on the shoulder with his big hand.

"I tell you," shouted Denisov, "he's a fine fellow."

"That's better, Count," said the staff captain, beginning to address
Rostov by his title, as if in recognition of his confession. "Go and
apologize, your excellency. Yes, go!"

"Gentlemen, I'll do anything. No one shall hear a word from me,"
said Rostov in an imploring voice, "but I can't apologize, by God I
can't, do what you will! How can I go and apologize like a little
boy asking forgiveness?"

Denisov began to laugh.

"It'll be worse for you. Bogdanich is vindictive and you'll pay
for your obstinacy," said Kirsten.

"No, on my word it's not obstinacy! I can't describe the feeling.
I can't..."

"Well, it's as you like," said the staff captain. "And what has
become of that scoundrel?" he asked Denisov.

"He has weported himself sick, he's to be stwuck off the list
tomowwow," muttered Denisov.

"It is an illness, there's no other way of explaining it," said
the staff captain.

"Illness or not, he'd better not cwoss my path. I'd kill him!"
shouted Denisov in a bloodthirsty tone.

Just then Zherkov entered the room.

"What brings you here?" cried the officers turning to the newcomer.

"We're to go into action, gentlemen! Mack has surrendered with his
whole army."

"It's not true!"

"I've seen him myself!"

"What? Saw the real Mack? With hands and feet?"

"Into action! Into action! Bring him a bottle for such news! But how
did you come here?"

"I've been sent back to the regiment all on account of that devil,
Mack. An Austrian general complained of me. I congratulated him on
Mack's arrival... What's the matter, Rostov? You look as if you'd just
come out of a hot bath."

"Oh, my dear fellow, we're in such a stew here these last two days."

The regimental adjutant came in and confirmed the news brought by
Zherkov. They were under orders to advance next day.

"We're going into action, gentlemen!"

"Well, thank God! We've been sitting here too long!"





CHAPTER VI


Kutuzov fell back toward Vienna, destroying behind him the bridges
over the rivers Inn (at Braunau) and Traun (near Linz). On October
23 the Russian troops were crossing the river Enns. At midday the
Russian baggage train, the artillery, and columns of troops were
defiling through the town of Enns on both sides of the bridge.

It was a warm, rainy, autumnal day. The wide expanse that opened out
before the heights on which the Russian batteries stood guarding the
bridge was at times veiled by a diaphanous curtain of slanting rain,
and then, suddenly spread out in the sunlight, far-distant objects
could be clearly seen glittering as though freshly varnished. Down
below, the little town could be seen with its white, red-roofed
houses, its cathedral, and its bridge, on both sides of which streamed
jostling masses of Russian troops. At the bend of the Danube, vessels,
an island, and a castle with a park surrounded by the waters of the
confluence of the Enns and the Danube became visible, and the rocky
left bank of the Danube covered with pine forests, with a mystic
background of green treetops and bluish gorges. The turrets of a
convent stood out beyond a wild virgin pine forest, and far away on
the other side of the Enns the enemy's horse patrols could be
discerned.

Among the field guns on the brow of the hill the general in
command of the rearguard stood with a staff officer, scanning the
country through his fieldglass. A little behind them Nesvitski, who
had been sent to the rearguard by the commander in chief, was
sitting on the trail of a gun carriage. A Cossack who accompanied
him had handed him a knapsack and a flask, and Nesvitski was
treating some officers to pies and real doppelkummel. The officers
gladly gathered round him, some on their knees, some squatting Turkish
fashion on the wet grass.

"Yes, the Austrian prince who built that castle was no fool. It's
a fine place! Why are you not eating anything, gentlemen?" Nesvitski
was saying.

"Thank you very much, Prince," answered one of the officers, pleased
to be talking to a staff officer of such importance. "It's a lovely
place! We passed close to the park and saw two deer... and what a
splendid house!"

"Look, Prince," said another, who would have dearly liked to take
another pie but felt shy, and therefore pretended to be examining
the countryside--"See, our infantrymen have already got there. Look
there in the meadow behind the village, three of them are dragging
something. They'll ransack that castle," he remarked with evident
approval.

"So they will," said Nesvitski. "No, but what I should like,"
added he, munching a pie in his moist-lipped handsome mouth, "would be
to slip in over there."

He pointed with a smile to a turreted nunnery, and his eyes narrowed
and gleamed.

"That would be fine, gentlemen!"

The officers laughed.

"Just to flutter the nuns a bit. They say there are Italian girls
among them. On my word I'd give five years of my life for it!"

"They must be feeling dull, too," said one of the bolder officers,
laughing.

Meanwhile the staff officer standing in front pointed out
something to the general, who looked through his field glass.

"Yes, so it is, so it is," said the general angrily, lowering the
field glass and shrugging his shoulders, "so it is! They'll be fired
on at the crossing. And why are they dawdling there?"

On the opposite side the enemy could be seen by the naked eye, and
from their battery a milk-white cloud arose. Then came the distant
report of a shot, and our troops could be seen hurrying to the
crossing.

Nesvitski rose, puffing, and went up to the general, smiling.

"Would not your excellency like a little refreshment?" he said.

"It's a bad business," said the general without answering him,
"our men have been wasting time."

"Hadn't I better ride over, your excellency?" asked Nesvitski.

"Yes, please do," answered the general, and he repeated the order
that had already once been given in detail: "and tell the hussars that
they are to cross last and to fire the bridge as I ordered; and the
inflammable material on the bridge must be reinspected."

"Very good," answered Nesvitski.

He called the Cossack with his horse, told him to put away the
knapsack and flask, and swung his heavy person easily into the saddle.

"I'll really call in on the nuns," he said to the officers who
watched him smilingly, and he rode off by the winding path down the
hill.

"Now then, let's see how far it will carry, Captain. Just try!" said
the general, turning to an artillery officer. "Have a little fun to
pass the time."

"Crew, to your guns!" commanded the officer.

In a moment the men came running gaily from their campfires and
began loading.

"One!" came the command.

Number one jumped briskly aside. The gun rang out with a deafening
metallic roar, and a whistling grenade flew above the heads of our
troops below the hill and fell far short of the enemy, a little
smoke showing the spot where it burst.

The faces of officers and men brightened up at the sound. Everyone
got up and began watching the movements of our troops below, as
plainly visible as if but a stone's throw away, and the movements of
the approaching enemy farther off. At the same instant the sun came
fully out from behind the clouds, and the clear sound of the
solitary shot and the brilliance of the bright sunshine merged in a
single joyous and spirited impression.





CHAPTER VII


Two of the enemy's shots had already flown across the bridge,
where there was a crush. Halfway across stood Prince Nesvitski, who
had alighted from his horse and whose big body was jammed
against the railings. He looked back laughing to the Cossack who stood
a few steps behind him holding two horses by their bridles. Each
time Prince Nesvitski tried to move on, soldiers and carts pushed
him back again and pressed him against the railings, and all he
could do was to smile.

"What a fine fellow you are, friend!" said the Cossack to a convoy
soldier with a wagon, who was pressing onto the infantrymen who were
crowded together close to his wheels and his horses. "What a fellow!
You can't wait a moment! Don't you see the general wants to pass?"

But the convoyman took no notice of the word "general" and shouted
at the soldiers who were blocking his way. "Hi there, boys! Keep to
the left! Wait a bit." But the soldiers, crowded together shoulder
to shoulder, their bayonets interlocking, moved over the bridge in a
dense mass. Looking down over the rails Prince Nesvitski saw the
rapid, noisy little waves of the Enns, which rippling and eddying
round the piles of the bridge chased each other along. Looking on
the bridge he saw equally uniform living waves of soldiers, shoulder
straps, covered shakos, knapsacks, bayonets, long muskets, and,
under the shakos, faces with broad cheekbones, sunken cheeks, and
listless tired expressions, and feet that moved through the sticky mud
that covered the planks of the bridge. Sometimes through the
monotonous waves of men, like a fleck of white foam on the waves of
the Enns, an officer, in a cloak and with a type of face different
from that of the men, squeezed his way along; sometimes like a chip of
wood whirling in the river, an hussar on foot, an orderly, or a
townsman was carried through the waves of infantry; and sometimes like
a log floating down the river, an officers' or company's baggage
wagon, piled high, leather covered, and hemmed in on all sides,
moved across the bridge.

"It's as if a dam had burst," said the Cossack hopelessly. "Are
there many more of you to come?"

"A million all but one!" replied a waggish soldier in a torn coat,
with a wink, and passed on followed by another, an old man.

"If he" (he meant the enemy) "begins popping at the bridge now,"
said the old soldier dismally to a comrade, "you'll forget to
scratch yourself."

That soldier passed on, and after him came another sitting on a
cart.

"Where the devil have the leg bands been shoved to?" said an
orderly, running behind the cart and fumbling in the back of it.

And he also passed on with the wagon. Then came some merry
soldiers who had evidently been drinking.

"And then, old fellow, he gives him one in the teeth with the butt
end of his gun..." a soldier whose greatcoat was well tucked up said
gaily, with a wide swing of his arm.

"Yes, the ham was just delicious..." answered another with a loud
laugh. And they, too, passed on, so that Nesvitski did not learn who
had been struck on the teeth, or what the ham had to do with it.

"Bah! How they scurry. He just sends a ball and they think they'll
all be killed," a sergeant was saying angrily and reproachfully.

"As it flies past me, Daddy, the ball I mean," said a young
soldier with an enormous mouth, hardly refraining from laughing, "I
felt like dying of fright. I did, 'pon my word, I got that
frightened!" said he, as if bragging of having been frightened.

That one also passed. Then followed a cart unlike any that had
gone before. It was a German cart with a pair of horses led by a
German, and seemed loaded with a whole houseful of effects. A fine
brindled cow with a large udder was attached to the cart behind. A
woman with an unweaned baby, an old woman, and a healthy German girl
with bright red cheeks were sitting on some feather beds. Evidently
these fugitives were allowed to pass by special permission. The eyes
of all the soldiers turned toward the women, and while the vehicle was
passing at foot pace all the soldiers' remarks related to the two
young ones. Every face bore almost the same smile, expressing unseemly
thoughts about the women.

"Just see, the German sausage is making tracks, too!"

"Sell me the missis," said another soldier, addressing the German,
who, angry and frightened, strode energetically along with downcast
eyes.

"See how smart she's made herself! Oh, the devils!"

"There, Fedotov, you should be quartered on them!"

"I have seen as much before now, mate!"

"Where are you going?" asked an infantry officer who was eating an
apple, also half smiling as he looked at the handsome girl.

The German closed his eyes, signifying that he did not understand.

"Take it if you like," said the officer, giving the girl an apple.

The girl smiled and took it. Nesvitski like the rest of the men on
the bridge did not take his eyes off the women till they had passed.
When they had gone by, the same stream of soldiers followed, with
the same kind of talk, and at last all stopped. As often happens,
the horses of a convoy wagon became restive at the end of the
bridge, and the whole crowd had to wait.

"And why are they stopping? There's no proper order!" said the
soldiers. "Where are you shoving to? Devil take you! Can't you wait?
It'll be worse if he fires the bridge. See, here's an officer jammed
in too"--different voices were saying in the crowd, as the men
looked at one another, and all pressed toward the exit from the
bridge.

Looking down at the waters of the Enns under the bridge, Nesvitski
suddenly heard a sound new to him, of something swiftly approaching...
something big, that splashed into the water.

"Just see where it carries to!" a soldier near by said sternly,
looking round at the sound.

"Encouraging us to get along quicker," said another uneasily.

The crowd moved on again. Nesvitski realized that it was a cannon
ball.

"Hey, Cossack, my horse!" he said. "Now, then, you there! get out of
the way! Make way!"

With great difficulty he managed to get to his horse, and shouting
continually he moved on. The soldiers squeezed themselves to make
way for him, but again pressed on him so that they jammed his leg, and
those nearest him were not to blame for they were themselves pressed
still harder from behind.

"Nesvitski, Nesvitski! you numskull!" came a hoarse voice from
behind him.

Nesvitski looked round and saw, some fifteen paces away but
separated by the living mass of moving infantry, Vaska Denisov, red
and shaggy, with his cap on the back of his black head and a cloak
hanging jauntily over his shoulder.

"Tell these devils, these fiends, to let me pass!" shouted Denisov
evidently in a fit of rage, his coal-black eyes with their bloodshot
whites glittering and rolling as he waved his sheathed saber in a
small bare hand as red as his face.

"Ah, Vaska!" joyfully replied Nesvitski. "What's up with you?"

"The squadwon can't pass," shouted Vaska Denisov, showing his
white teeth fiercely and spurring his black thoroughbred Arab, which
twitched its ears as the bayonets touched it, and snorted, spurting
white foam from his bit, tramping the planks of the bridge with his
hoofs, and apparently ready to jump over the railings had his rider
let him. "What is this? They're like sheep! Just like sheep! Out of
the way!... Let us pass!... Stop there, you devil with the cart!
I'll hack you with my saber!" he shouted, actually drawing his saber
from its scabbard and flourishing it.

The soldiers crowded against one another with terrified faces, and
Denisov joined Nesvitski.

"How's it you're not drunk today?" said Nesvitski when the other had
ridden up to him.

"They don't even give one time to dwink!" answered Vaska Denisov.
"They keep dwagging the wegiment to and fwo all day. If they mean to
fight, let's fight. But the devil knows what this is."

"What a dandy you are today!" said Nesvitski, looking at Denisov's
new cloak and saddlecloth.

Denisov smiled, took out of his sabretache a handkerchief that
diffused a smell of perfume, and put it to Nesvitski's nose.

"Of course. I'm going into action! I've shaved, bwushed my teeth,
and scented myself."

The imposing figure of Nesvitski followed by his Cossack, and the
determination of Denisov who flourished his sword and shouted
frantically, had such an effect that they managed to squeeze through
to the farther side of the bridge and stopped the infantry. Beside the
bridge Nesvitski found the colonel to whom he had to deliver the
order, and having done this he rode back.

Having cleared the way Denisov stopped at the end of the bridge.
Carelessly holding in his stallion that was neighing and pawing the
ground, eager to rejoin its fellows, he watched his squadron draw
nearer. Then the clang of hoofs, as of several horses galloping,
resounded on the planks of the bridge, and the squadron, officers in
front and men four abreast, spread across the bridge and began to
emerge on his side of it.

The infantry who had been stopped crowded near the bridge in the
trampled mud and gazed with that particular feeling of ill-will,
estrangement, and ridicule with which troops of different arms usually
encounter one another at the clean, smart hussars who moved past
them in regular order.

"Smart lads! Only fit for a fair!" said one.

"What good are they? They're led about just for show!" remarked
another.

"Don't kick up the dust, you infantry!" jested an hussar whose
prancing horse had splashed mud over some foot soldiers.

"I'd like to put you on a two days' march with a knapsack! Your fine
cords would soon get a bit rubbed," said an infantryman, wiping the
mud off his face with his sleeve. "Perched up there, you're more
like a bird than a man."

"There now, Zikin, they ought to put you on a horse. You'd look
fine," said a corporal, chaffing a thin little soldier who bent
under the weight of his knapsack.

"Take a stick between your legs, that'll suit you for a horse!"
the hussar shouted back.





CHAPTER VIII


The last of the infantry hurriedly crossed the bridge, squeezing
together as they approached it as if passing through a funnel. At last
the baggage wagons had all crossed, the crush was less, and the last
battalion came onto the bridge. Only Denisov's squadron of hussars
remained on the farther side of the bridge facing the enemy, who could
be seen from the hill on the opposite bank but was not yet visible
from the bridge, for the horizon as seen from the valley through which
the river flowed was formed by the rising ground only half a mile
away. At the foot of the hill lay wasteland over which a few groups of
our Cossack scouts were moving. Suddenly on the road at the top of the
high ground, artillery and troops in blue uniform were seen. These
were the French. A group of Cossack scouts retired down the hill at
a trot. All the officers and men of Denisov's squadron, though they
tried to talk of other things and to look in other directions, thought
only of what was there on the hilltop, and kept constantly looking
at the patches appearing on the skyline, which they knew to be the
enemy's troops. The weather had cleared again since noon and the sun
was descending brightly upon the Danube and the dark hills around
it. It was calm, and at intervals the bugle calls and the shouts of
the enemy could be heard from the hill. There was no one now between
the squadron and the enemy except a few scattered skirmishers. An
empty space of some seven hundred yards was all that separated them.
The enemy ceased firing, and that stern, threatening, inaccessible,
and intangible line which separates two hostile armies was all the
more clearly felt.

"One step beyond that boundary line which resembles the line
dividing the living from the dead lies uncertainty, suffering, and
death. And what is there? Who is there?--there beyond that field, that
tree, that roof lit up by the sun? No one knows, but one wants to
know. You fear and yet long to cross that line, and know that sooner
or later it must be crossed and you will have to find out what is
there, just as you will inevitably have to learn what lies the other
side of death. But you are strong, healthy, cheerful, and excited, and
are surrounded by other such excitedly animated and healthy men." So
thinks, or at any rate feels, anyone who comes in sight of the
enemy, and that feeling gives a particular glamour and glad keenness
of impression to everything that takes place at such moments.

On the high ground where the enemy was, the smoke of a cannon
rose, and a ball flew whistling over the heads of the hussar squadron.
The officers who had been standing together rode off to their
places. The hussars began carefully aligning their horses. Silence
fell on the whole squadron. All were looking at the enemy in front and
at the squadron commander, awaiting the word of command. A second
and a third cannon ball flew past. Evidently they were firing at the
hussars, but the balls with rapid rhythmic whistle flew over the heads
of the horsemen and fell somewhere beyond them. The hussars did not
look round, but at the sound of each shot, as at the word of
command, the whole squadron with its rows of faces so alike yet so
different, holding its breath while the ball flew past, rose in the
stirrups and sank back again. The soldiers without turning their heads
glanced at one another, curious to see their comrades' impression.
Every face, from Denisov's to that of the bugler, showed one common
expression of conflict, irritation, and excitement, around chin and
mouth. The quartermaster frowned, looking at the soldiers as if
threatening to punish them. Cadet Mironov ducked every time a ball
flew past. Rostov on the left flank, mounted on his Rook--a handsome
horse despite its game leg--had the happy air of a schoolboy called up
before a large audience for an examination in which he feels sure he
will distinguish himself. He was glancing at everyone with a clear,
bright expression, as if asking them to notice how calmly he sat under
fire. But despite himself, on his face too that same indication of
something new and stern showed round the mouth.

"Who's that curtseying there? Cadet Miwonov! That's not wight!
Look at me," cried Denisov who, unable to keep still on one spot, kept
turning his horse in front of the squadron.

The black, hairy, snub-nosed face of Vaska Denisov, and his whole
short sturdy figure with the sinewy hairy hand and stumpy fingers in
which he held the hilt of his naked saber, looked just as it usually
did, especially toward evening when he had emptied his second
bottle; he was only redder than usual. With his shaggy head thrown
back like birds when they drink, pressing his spurs mercilessly into
the sides of his good horse, Bedouin, and sitting as though falling
backwards in the saddle, he galloped to the other flank of the
squadron and shouted in a hoarse voice to the men to look to their
pistols. He rode up to Kirsten. The staff captain on his broad-backed,
steady mare came at a walk to meet him. His face with its long
mustache was serious as always, only his eyes were brighter than
usual.

"Well, what about it?" said he to Denisov. "It won't come to a
fight. You'll see--we shall retire."

"The devil only knows what they're about!" muttered Denisov. "Ah,
Wostov," he cried noticing the cadet's bright face, "you've got it
at last."

And he smiled approvingly, evidently pleased with the cadet.
Rostov felt perfectly happy. Just then the commander appeared on the
bridge. Denisov galloped up to him.

"Your excellency! Let us attack them! I'll dwive them off."

"Attack indeed!" said the colonel in a bored voice, puckering up his
face as if driving off a troublesome fly. "And why are you stopping
here? Don't you see the skirmishers are retreating? Lead the
squadron back."

The squadron crossed the bridge and drew out of range of fire
without having lost a single man. The second squadron that had been in
the front line followed them across and the last Cossacks quitted
the farther side of the river.

The two Pavlograd squadrons, having crossed the bridge, retired up
the hill one after the other. Their colonel, Karl Bogdanich
Schubert, came up to Denisov's squadron and rode at a footpace not far
from Rostov, without taking any notice of him although they were now
meeting for the first time since their encounter concerning
Telyanin. Rostov, feeling that he was at the front and in the power of
a man toward whom he now admitted that he had been to blame, did not
lift his eyes from the colonel's athletic back, his nape covered
with light hair, and his red neck. It seemed to Rostov that
Bogdanich was only pretending not to notice him, and that his whole
aim now was to test the cadet's courage, so he drew himself up and
looked around him merrily; then it seemed to him that Bogdanich rode
so near in order to show him his courage. Next he thought that his
enemy would send the squadron on a desperate attack just to punish
him--Rostov. Then he imagined how, after the attack, Bogdanich would
come up to him as he lay wounded and would magnanimously extend the
hand of reconciliation.

The high-shouldered figure of Zherkov, familiar to the Pavlograds as
he had but recently left their regiment, rode up to the colonel. After
his dismissal from headquarters Zherkov had not remained in the
regiment, saying he was not such a fool as to slave at the front
when he could get more rewards by doing nothing on the staff, and
had succeeded in attaching himself as an orderly officer to Prince
Bagration. He now came to his former chief with an order from the
commander of the rear guard.

"Colonel," he said, addressing Rostov's enemy with an air of
gloomy gravity and glancing round at his comrades, "there is an
order to stop and fire the bridge."

"An order to who?" asked the colonel morosely.

"I don't myself know 'to who,'" replied the cornet in a serious
tone, "but the prince told me to 'go and tell the colonel that the
hussars must return quickly and fire the bridge.'"

Zherkov was followed by an officer of the suite who rode up to the
colonel of hussars with the same order. After him the stout
Nesvitski came galloping up on a Cossack horse that could scarcely
carry his weight.

"How's this, Colonel?" he shouted as he approached. "I told you to
fire the bridge, and now someone has gone and blundered; they are
all beside themselves over there and one can't make anything out."

The colonel deliberately stopped the regiment and turned to
Nesvitski.

"You spoke to me of inflammable material," said he, "but you said
nothing about firing it."

"But, my dear sir," said Nesvitski as he drew up, taking off his cap
and smoothing his hair wet with perspiration with his plump hand,
"wasn't I telling you to fire the bridge, when inflammable material
had been put in position?"

"I am not your 'dear sir,' Mr. Staff Officer, and you did not tell
me to burn the bridge! I know the service, and it is my habit orders
strictly to obey. You said the bridge would be burned, but who would
it burn, I could not know by the holy spirit!"

"Ah, that's always the way!" said Nesvitski with a wave of the hand.
"How did you get here?" said he, turning to Zherkov.

"On the same business. But you are damp! Let me wring you out!"

"You were saying, Mr. Staff Officer..." continued the colonel in
an offended tone.

"Colonel," interrupted the officer of the suite, "You must be
quick or the enemy will bring up his guns to use grapeshot."

The colonel looked silently at the officer of the suite, at the
stout staff officer, and at Zherkov, and he frowned.

"I will the bridge fire," he said in a solemn tone as if to announce
that in spite of all the unpleasantness he had to endure he would
still do the right thing.

Striking his horse with his long muscular legs as if it were to
blame for everything, the colonel moved forward and ordered the second
squadron, that in which Rostov was serving under Denisov, to return to
the bridge.

"There, it's just as I thought," said Rostov to himself. "He
wishes to test me!" His heart contracted and the blood rushed to his
face. "Let him see whether I am a coward!" he thought.

Again on all the bright faces of the squadron the serious expression
appeared that they had worn when under fire. Rostov watched his enemy,
the colonel, closely--to find in his face confirmation of his own
conjecture, but the colonel did not once glance at Rostov, and
looked as he always did when at the front, solemn and stern. Then came
the word of command.

"Look sharp! Look sharp!" several voices repeated around him.

Their sabers catching in the bridles and their spurs jingling, the
hussars hastily dismounted, not knowing what they were to do. The
men were crossing themselves. Rostov no longer looked at the
colonel, he had no time. He was afraid of falling behind the
hussars, so much afraid that his heart stood still. His hand
trembled as he gave his horse into an orderly's charge, and he felt
the blood rush to his heart with a thud. Denisov rode past him,
leaning back and shouting something. Rostov saw nothing but the
hussars running all around him, their spurs catching and their
sabers clattering.

"Stretchers!" shouted someone behind him.

Rostov did not think what this call for stretchers meant; he ran on,
trying only to be ahead of the others; but just at the bridge, not
looking at the ground, he came on some sticky, trodden mud,
stumbled, and fell on his hands. The others outstripped him.

"At boss zides, Captain," he heard the voice of the colonel, who,
having ridden ahead, had pulled up his horse near the bridge, with a
triumphant, cheerful face.

Rostov wiping his muddy hands on his breeches looked at his enemy
and was about to run on, thinking that the farther he went to the
front the better. But Bogdanich, without looking at or recognizing
Rostov, shouted to him:

"Who's that running on the middle of the bridge? To the right!
Come back, Cadet!" he cried angrily; and turning to Denisov, who,
showing off his courage, had ridden on to the planks of the bridge:

"Why run risks, Captain? You should dismount," he said.

"Oh, every bullet has its billet," answered Vaska Denisov, turning
in his saddle.


Meanwhile Nesvitski, Zherkov, and the officer of the suite were
standing together out of range of the shots, watching, now the small
group of men with yellow shakos, dark-green jackets braided with cord,
and blue riding breeches, who were swarming near the bridge, and
then at what was approaching in the distance from the opposite side-
the blue uniforms and groups with horses, easily recognizable as
artillery.

"Will they burn the bridge or not? Who'll get there first? Will they
get there and fire the bridge or will the French get within
grapeshot range and wipe them out?" These were the questions each
man of the troops on the high ground above the bridge involuntarily
asked himself with a sinking heart--watching the bridge and the
hussars in the bright evening light and the blue tunics advancing from
the other side with their bayonets and guns.

"Ugh. The hussars will get it hot!" said Nesvitski; "they are within
grapeshot range now."

"He shouldn't have taken so many men," said the officer of the
suite.

"True enough," answered Nesvitski; "two smart fellows could have
done the job just as well."

"Ah, your excellency," put in Zherkov, his eyes fixed on the
hussars, but still with that naive air that made it impossible to know
whether he was speaking in jest or in earnest. "Ah, your excellency!
How you look at things! Send two men? And who then would give us the
Vladimir medal and ribbon? But now, even if they do get peppered,
the squadron may be recommended for honors and he may get a ribbon.
Our Bogdanich knows how things are done."

"There now!" said the officer of the suite, "that's grapeshot."

He pointed to the French guns, the limbers of which were being
detached and hurriedly removed.

On the French side, amid the groups with cannon, a cloud of smoke
appeared, then a second and a third almost simultaneously, and at
the moment when the first report was heard a fourth was seen. Then two
reports one after another, and a third.

"Oh! Oh!" groaned Nesvitski as if in fierce pain, seizing the
officer of the suite by the arm. "Look! A man has fallen! Fallen,
fallen!"

"Two, I think."

"If I were Tsar I would never go to war," said Nesvitski, turning
away.

The French guns were hastily reloaded. The infantry in their blue
uniforms advanced toward the bridge at a run. Smoke appeared again but
at irregular intervals, and grapeshot cracked and rattled onto the
bridge. But this time Nesvitski could not see what was happening
there, as a dense cloud of smoke arose from it. The hussars had
succeeded in setting it on fire and the French batteries were now
firing at them, no longer to hinder them but because the guns were
trained and there was someone to fire at.

The French had time to fire three rounds of grapeshot before the
hussars got back to their horses. Two were misdirected and the shot
went too high, but the last round fell in the midst of a group of
hussars and knocked three of them over.

Rostov, absorbed by his relations with Bogdanich, had paused on
the bridge not knowing what to do. There was no one to hew down (as he
had always imagined battles to himself), nor could he help to fire the
bridge because he had not brought any burning straw with him like
the other soldiers. He stood looking about him, when suddenly he heard
a rattle on the bridge as if nuts were being spilt, and the hussar
nearest to him fell against the rails with a groan. Rostov ran up to
him with the others. Again someone shouted, "Stretchers!" Four men
seized the hussar and began lifting him.

"Oooh! For Christ's sake let me alone!" cried the wounded man, but
still he was lifted and laid on the stretcher.

Nicholas Rostov turned away and, as if searching for something,
gazed into the distance, at the waters of the Danube, at the sky,
and at the sun. How beautiful the sky looked; how blue, how calm,
and how deep! How bright and glorious was the setting sun! With what
soft glitter the waters of the distant Danube shone. And fairer
still were the faraway blue mountains beyond the river, the nunnery,
the mysterious gorges, and the pine forests veiled in the mist of
their summits... There was peace and happiness... "I should wishing
for nothing else, nothing, if only I were there," thought Rostov.
"In myself alone and in that sunshine there is so much happiness;
but here... groans, suffering, fear, and this uncertainty and hurry...
There--they are shouting again, and again are all running back
somewhere, and I shall run with them, and it, death, is here above
me and around... Another instant and I shall never again see the
sun, this water, that gorge!..."

At that instant the sun began to hide behind the clouds, and other
stretchers came into view before Rostov. And the fear of death and
of the stretchers, and love of the sun and of life, all merged into
one feeling of sickening agitation.

"O Lord God! Thou who art in that heaven, save, forgive, and protect
me!" Rostov whispered.

The hussars ran back to the men who held their horses; their
voices sounded louder and calmer, the stretchers disappeared from
sight.

"Well, fwiend? So you've smelt powdah!" shouted Vaska Denisov just
above his ear.

"It's all over; but I am a coward--yes, a coward!" thought Rostov,
and sighing deeply he took Rook, his horse, which stood resting one
foot, from the orderly and began to mount.

"Was that grapeshot?" he asked Denisov.

"Yes and no mistake!" cried Denisov. "You worked like wegular bwicks
and it's nasty work! An attack's pleasant work! Hacking away at the
dogs! But this sort of thing is the very devil, with them shooting
at you like a target."

And Denisov rode up to a group that had stopped near Rostov,
composed of the colonel, Nesvitski, Zherkov, and the officer from
the suite.

"Well, it seems that no one has noticed," thought Rostov. And this
was true. No one had taken any notice, for everyone knew the sensation
which the cadet under fire for the first time had experienced.

"Here's something for you to report," said Zherkov. "See if I
don't get promoted to a sublieutenancy."

"Inform the prince that I the bridge fired!" said the colonel
triumphantly and gaily.

"And if he asks about the losses?"

"A trifle," said the colonel in his bass voice: "two hussars
wounded, and one knocked out," he added, unable to restrain a happy
smile, and pronouncing the phrase "knocked out" with ringing
distinctness.





CHAPTER IX


Pursued by the French army of a hundred thousand men under the
command of Bonaparte, encountering a population that was unfriendly to
it, losing confidence in its allies, suffering from shortness of
supplies, and compelled to act under conditions of war unlike anything
that had been foreseen, the Russian army of thirty-five thousand men
commanded by Kutuzov was hurriedly retreating along the Danube,
stopping where overtaken by the enemy and fighting rearguard actions
only as far as necessary to enable it to retreat without losing its
heavy equipment. There had been actions at Lambach, Amstetten, and
Melk; but despite the courage and endurance--acknowledged even by
the enemy--with which the Russians fought, the only consequence of
these actions was a yet more rapid retreat. Austrian troops that had
escaped capture at Ulm and had joined Kutuzov at Braunau now separated
from the Russian army, and Kutuzov was left with only his own weak and
exhausted forces. The defense of Vienna was no longer to be thought
of. Instead of an offensive, the plan of which, carefully prepared
in accord with the modern science of strategics, had been handed to
Kutuzov when he was in Vienna by the Austrian Hofkriegsrath, the
sole and almost unattainable aim remaining for him was to effect a
junction with the forces that were advancing from Russia, without
losing his army as Mack had done at Ulm.

On the twenty-eighth of October Kutuzov with his army crossed to the
left bank of the Danube and took up a position for the first time with
the river between himself and the main body of the French. On the
thirtieth he attacked Mortier's division, which was on the left
bank, and broke it up. In this action for the first time trophies were
taken: banners, cannon, and two enemy generals. For the first time,
after a fortnight's retreat, the Russian troops had halted and after a
fight had not only held the field but had repulsed the French.
Though the troops were ill-clad, exhausted, and had lost a third of
their number in killed, wounded, sick, and stragglers; though a number
of sick and wounded had been abandoned on the other side of the Danube
with a letter in which Kutuzov entrusted them to the humanity of the
enemy; and though the big hospitals and the houses in Krems
converted into military hospitals could no longer accommodate all
the sick and wounded, yet the stand made at Krems and the victory over
Mortier raised the spirits of the army considerably. Throughout the
whole army and at headquarters most joyful though erroneous rumors
were rife of the imaginary approach of columns from Russia, of some
victory gained by the Austrians, and of the retreat of the
frightened Bonaparte.

Prince Andrew during the battle had been in attendance on the
Austrian General Schmidt, who was killed in the action. His horse
had been wounded under him and his own arm slightly grazed by a
bullet. As a mark of the commander in chief's special favor he was
sent with the news of this victory to the Austrian court, now no
longer at Vienna (which was threatened by the French) but at Brunn.
Despite his apparently delicate build Prince Andrew could endure
physical fatigue far better than many very muscular men, and on the
night of the battle, having arrived at Krems excited but not weary,
with dispatches from Dokhturov to Kutuzov, he was sent immediately
with a special dispatch to Brunn. To be so sent meant not only a
reward but an important step toward promotion.

The night was dark but starry, the road showed black in the snow
that had fallen the previous day--the day of the battle. Reviewing his
impressions of the recent battle, picturing pleasantly to himself
the impression his news of a victory would create, or recalling the
send-off given him by the commander in chief and his fellow
officers, Prince Andrew was galloping along in a post chaise
enjoying the feelings of a man who has at length begun to attain a
long-desired happiness. As soon as he closed his eyes his ears
seemed filled with the rattle of the wheels and the sensation of
victory. Then he began to imagine that the Russians were running
away and that he himself was killed, but he quickly roused himself
with a feeling of joy, as if learning afresh that this was not so
but that on the contrary the French had run away. He again recalled
all the details of the victory and his own calm courage during the
battle, and feeling reassured he dozed off.... The dark starry night
was followed by a bright cheerful morning. The snow was thawing in the
sunshine, the horses galloped quickly, and on both sides of the road
were forests of different kinds, fields, and villages.

At one of the post stations he overtook a convoy of Russian wounded.
The Russian officer in charge of the transport lolled back in the
front cart, shouting and scolding a soldier with coarse abuse. In each
of the long German carts six or more pale, dirty, bandaged men were
being jolted over the stony road. Some of them were talking (he
heard Russian words), others were eating bread; the more severely
wounded looked silently, with the languid interest of sick children,
at the envoy hurrying past them.

Prince Andrew told his driver to stop, and asked a soldier in what
action they had been wounded. "Day before yesterday, on the Danube,"
answered the soldier. Prince Andrew took out his purse and gave the
soldier three gold pieces.

"That's for them all," he said to the officer who came up.

"Get well soon, lads!" he continued, turning to the soldiers.
"There's plenty to do still."

"What news, sir?" asked the officer, evidently anxious to start a
conversation.

"Good news!... Go on!" he shouted to the driver, and they galloped
on.

It was already quite dark when Prince Andrew rattled over the
paved streets of Brunn and found himself surrounded by high buildings,
the lights of shops, houses, and street lamps, fine carriages, and all
that atmosphere of a large and active town which is always so
attractive to a soldier after camp life. Despite his rapid journey and
sleepless night, Prince Andrew when he drove up to the palace felt
even more vigorous and alert than he had done the day before. Only his
eyes gleamed feverishly and his thoughts followed one another with
extraordinary clearness and rapidity. He again vividly recalled the
details of the battle, no longer dim, but definite and in the
concise form in which he imagined himself stating them to
the Emperor Francis. He vividly imagined the casual questions that
might be put to him and the answers he would give. He expected to be
at once presented to the Emperor. At the chief entrance to the palace,
however, an official came running out to meet him, and learning that
he was a special messenger led him to another entrance.

"To the right from the corridor, Euer Hochgeboren! There you will
find the adjutant on duty," said the official. "He will conduct you to
the Minister of War."

The adjutant on duty, meeting Prince Andrew, asked him to wait,
and went in to the Minister of War. Five minutes later he returned and
bowing with particular courtesy ushered Prince Andrew before him along
a corridor to the cabinet where the Minister of War was at work. The
adjutant by his elaborate courtesy appeared to wish to ward off any
attempt at familiarity on the part of the Russian messenger.

Prince Andrew's joyous feeling was considerably weakened as he
approached the door of the minister's room. He felt offended, and
without his noticing it the feeling of offense immediately turned into
one of disdain which was quite uncalled for. His fertile mind
instantly suggested to him a point of view which gave him a right to
despise the adjutant and the minister. "Away from the smell of powder,
they probably think it easy to gain victories!" he thought. His eyes
narrowed disdainfully, he entered the room of the Minister of War with
peculiarly deliberate steps. This feeling of disdain was heightened
when he saw the minister seated at a large table reading some papers
and making pencil notes on them, and for the first two or three
minutes taking no notice of his arrival. A wax candle stood at each
side of the minister's bent bald head with its gray temples. He went
on reading to the end, without raising his eyes at the opening of
the door and the sound of footsteps.

"Take this and deliver it," said he to his adjutant, handing him the
papers and still taking no notice of the special messenger.

Prince Andrew felt that either the actions of Kutuzov's army
interested the Minister of War less than any of the other matters he
was concerned with, or he wanted to give the Russian special messenger
that impression. "But that is a matter of perfect indifference to me,"
he thought. The minister drew the remaining papers together,
arranged them evenly, and then raised his head. He had an intellectual
and distinctive head, but the instant he turned to Prince Andrew the
firm, intelligent expression on his face changed in a way evidently
deliberate and habitual to him. His face took on the stupid artificial
smile (which does not even attempt to hide its artificiality) of a man
who is continually receiving many petitioners one after another.

"From General Field Marshal Kutuzov?" he asked. "I hope it is good
news? There has been an encounter with Mortier? A victory? It was high
time!"

He took the dispatch which was addressed to him and began to read it
with a mournful expression.

"Oh, my God! My God! Schmidt!" he exclaimed in German. "What a
calamity! What a calamity!"

Having glanced through the dispatch he laid it on the table and
looked at Prince Andrew, evidently considering something.

"Ah what a calamity! You say the affair was decisive? But Mortier is
not captured." Again he pondered. "I am very glad you have brought
good news, though Schmidt's death is a heavy price to pay for the
victory. His Majesty will no doubt wish to see you, but not today. I
thank you! You must have a rest. Be at the levee tomorrow after the
parade. However, I will let you know."

The stupid smile, which had left his face while he was speaking,
reappeared.

"Au revoir! Thank you very much. His Majesty will probably desire to
see you," he added, bowing his head.

When Prince Andrew left the palace he felt that all the interest and
happiness the victory had afforded him had been now left in the
indifferent hands of the Minister of War and the polite adjutant.
The whole tenor of his thoughts instantaneously changed; the battle
seemed the memory of a remote event long past.





CHAPTER X


Prince Andrew stayed at Brunn with Bilibin, a Russian acquaintance
of his in the diplomatic service.

"Ah, my dear prince! I could not have a more welcome visitor,"
said Bilibin as he came out to meet Prince Andrew. "Franz, put the
prince's things in my bedroom," said he to the servant who was
ushering Bolkonski in. "So you're a messenger of victory, eh?
Splendid! And I am sitting here ill, as you see."

After washing and dressing, Prince Andrew came into the diplomat's
luxurious study and sat down to the dinner prepared for him. Bilibin
settled down comfortably beside the fire.

After his journey and the campaign during which he had been deprived
of all the comforts of cleanliness and all the refinements of life,
Prince Andrew felt a pleasant sense of repose among luxurious
surroundings such as he had been accustomed to from childhood. Besides
it was pleasant, after his reception by the Austrians, to speak if not
in Russian (for they were speaking French) at least with a Russian who
would, he supposed, share the general Russian antipathy to the
Austrians which was then particularly strong.

Bilibin was a man of thirty-five, a bachelor, and of the same circle
as Prince Andrew. They had known each other previously in
Petersburg, but had become more intimate when Prince Andrew was in
Vienna with Kutuzov. Just as Prince Andrew was a young man who gave
promise of rising high in the military profession, so to an even
greater extent Bilibin gave promise of rising in his diplomatic
career. He still a young man but no longer a young diplomat, as he had
entered the service at the age of sixteen, had been in Paris and
Copenhagen, and now held a rather important post in Vienna. Both the
foreign minister and our ambassador in Vienna knew him and valued him.
He was not one of those many diplomats who are esteemed because they
have certain negative qualities, avoid doing certain things, and speak
French. He was one of those, who, liking work, knew how to do it,
and despite his indolence would sometimes spend a whole night at his
writing table. He worked well whatever the import of his work. It
was not the question "What for?" but the question "How?" that
interested him. What the diplomatic matter might be he did not care,
but it gave him great pleasure to prepare a circular, memorandum, or
report, skillfully, pointedly, and elegantly. Bilibin's services
were valued not only for what he wrote, but also for his skill in
dealing and conversing with those in the highest spheres.

Bilibin liked conversation as he liked work, only when it could be
made elegantly witty. In society he always awaited an opportunity to
say something striking and took part in a conversation only when
that was possible. His conversation was always sprinkled with
wittily original, finished phrases of general interest. These
sayings were prepared in the inner laboratory of his mind in a
portable form as if intentionally, so that insignificant society
people might carry them from drawing room to drawing room. And, in
fact, Bilibin's witticisms were hawked about in the Viennese drawing
rooms and often had an influence on matters considered important.

His thin, worn, sallow face was covered with deep wrinkles, which
always looked as clean and well washed as the tips of one's fingers
after a Russian bath. The movement of these wrinkles formed the
principal play of expression on his face. Now his forehead would
pucker into deep folds and his eyebrows were lifted, then his eyebrows
would descend and deep wrinkles would crease his cheeks. His small,
deep-set eyes always twinkled and looked out straight.

"Well, now tell me about your exploits," said he.

Bolkonski, very modestly without once mentioning himself,
described the engagement and his reception by the Minister of War.

"They received me and my news as one receives a dog in a game of
skittles," said he in conclusion.

Bilibin smiled and the wrinkles on his face disappeared.

"Cependant, mon cher," he remarked, examining his nails from a
distance and puckering the skin above his left eye, "malgre la haute
estime que je professe pour the Orthodox Russian army, j'avoue que
votre victoire n'est pas des plus victorieuses."*


*"But my dear fellow, with all my respect for the Orthodox Russian
army, I must say that your victory was not particularly victorious."


He went on talking in this way in French, uttering only those
words in Russian on which he wished to put a contemptuous emphasis.

"Come now! You with all your forces fall on the unfortunate
Mortier and his one division, and even then Mortier slips through your
fingers! Where's the victory?"

"But seriously," said Prince Andrew, "we can at any rate say without
boasting that it was a little better than at Ulm..."

"Why didn't you capture one, just one, marshal for us?"

"Because not everything happens as one expects or with the
smoothness of a parade. We had expected, as I told you, to get at
their rear by seven in the morning but had not reached it by five in
the afternoon."

"And why didn't you do it at seven in the morning? You ought to have
been there at seven in the morning," returned Bilibin with a smile.
"You ought to have been there at seven in the morning."

"Why did you not succeed in impressing on Bonaparte by diplomatic
methods that he had better leave Genoa alone?" retorted Prince
Andrew in the same tone.

"I know," interrupted Bilibin, "you're thinking it's very easy to
take marshals, sitting on a sofa by the fire! That is true, but
still why didn't you capture him? So don't be surprised if not only
the Minister of War but also his Most August Majesty the Emperor and
King Francis is not much delighted by your victory. Even I, a poor
secretary of the Russian Embassy, do not feel any need in token of
my joy to give my Franz a thaler, or let him go with his Liebchen to
the Prater... True, we have no Prater here..."

He looked straight at Prince Andrew and suddenly unwrinkled his
forehead.

"It is now my turn to ask you 'why?' mon cher," said Bolkonski. "I
confess I do not understand: perhaps there are diplomatic subtleties
here beyond my feeble intelligence, but I can't make it out. Mack
loses a whole army, the Archduke Ferdinand and the Archduke Karl
give no signs of life and make blunder after blunder. Kutuzov alone at
last gains a real victory, destroying the spell of the invincibility
of the French, and the Minister of War does not even care to hear
the details."

"That's just it, my dear fellow. You see it's hurrah for the Tsar,
for Russia, for the Orthodox Greek faith! All that is beautiful, but
what do we, I mean the Austrian court, care for your victories?
Bring us nice news of a victory by the Archduke Karl or Ferdinand (one
archduke's as good as another, as you know) and even if it is only
over a fire brigade of Bonaparte's, that will be another story and
we'll fire off some cannon! But this sort of thing seems done on
purpose to vex us. The Archduke Karl does nothing, the Archduke
Ferdinand disgraces himself. You abandon Vienna, give up its
defense--as much as to say: 'Heaven is with us, but heaven help you
and your capital!' The one general whom we all loved, Schmidt, you
expose to a bullet, and then you congratulate us on the victory! Admit
that more irritating news than yours could not have been conceived.
It's as if it had been done on purpose, on purpose. Besides, suppose
you did gain a brilliant victory, if even the Archduke Karl gained a
victory, what effect would that have on the general course of
events? It's too late now when Vienna is occupied by the French army!"

"What? Occupied? Vienna occupied?"

"Not only occupied, but Bonaparte is at Schonbrunn, and the count,
our dear Count Vrbna, goes to him for orders."

After the fatigues and impressions of the journey, his reception,
and especially after having dined, Bolkonski felt that he could not
take in the full significance of the words he heard.

"Count Lichtenfels was here this morning," Bilibin continued, "and
showed me a letter in which the parade of the French in Vienna was
fully described: Prince Murat et tout le tremblement... You see that
your victory is not a matter for great rejoicing and that you can't be
received as a savior."

"Really I don't care about that, I don't care at all," said Prince
Andrew, beginning to understand that his news of the battle before
Krems was really of small importance in view of such events as the
fall of Austria's capital. "How is it Vienna was taken? What of the
bridge and its celebrated bridgehead and Prince Auersperg? We heard
reports that Prince Auersperg was defending Vienna?" he said.

"Prince Auersperg is on this, on our side of the river, and is
defending us--doing it very badly, I think, but still he is
defending us. But Vienna is on the other side. No, the bridge has
not yet been taken and I hope it will not be, for it is mined and
orders have been given to blow it up. Otherwise we should long ago
have been in the mountains of Bohemia, and you and your army would
have spent a bad quarter of an hour between two fires."

"But still this does not mean that the campaign is over," said
Prince Andrew.

"Well, I think it is. The bigwigs here think so too, but they
daren't say so. It will be as I said at the beginning of the campaign,
it won't be your skirmishing at Durrenstein, or gunpowder at all, that
will decide the matter, but those who devised it," said Bilibin
quoting one of his own mots, releasing the wrinkles on his forehead,
and pausing. "The only question is what will come of the meeting
between the Emperor Alexander and the King of Prussia in Berlin? If
Prussia joins the Allies, Austria's hand will be forced and there will
be war. If not it is merely a question of settling where the
preliminaries of the new Campo Formio are to be drawn up."

"What an extraordinary genius!" Prince Andrew suddenly exclaimed,
clenching his small hand and striking the table with it, "and what
luck the man has!"

"Buonaparte?" said Bilibin inquiringly, puckering up his forehead to
indicate that he was about to say something witty. "Buonaparte?" he
repeated, accentuating the u: "I think, however, now that he lays down
laws for Austria at Schonbrunn, il faut lui faire grace de l'u!* I
shall certainly adopt an innovation and call him simply Bonaparte!"


*"We must let him off the u!"


"But joking apart," said Prince Andrew, "do you really think the
campaign is over?"

"This is what I think. Austria has been made a fool of, and she is
not used to it. She will retaliate. And she has been fooled in the
first place because her provinces have been pillaged--they say the
Holy Russian army loots terribly--her army is destroyed, her capital
taken, and all this for the beaux yeux* of His Sardinian Majesty.
And therefore--this is between ourselves--I instinctively feel that we
are being deceived, my instinct tells me of negotiations with France
and projects for peace, a secret peace concluded separately."


*Fine eyes.


"Impossible!" cried Prince Andrew. "That would be too base."

"If we live we shall see," replied Bilibin, his face again
becoming smooth as a sign that the conversation was at an end.

When Prince Andrew reached the room prepared for him and lay down in
a clean shirt on the feather bed with its warmed and fragrant pillows,
he felt that the battle of which he had brought tidings was far, far
away from him. The alliance with Prussia, Austria's treachery,
Bonaparte's new triumph, tomorrow's levee and parade, and the audience
with the Emperor Francis occupied his thoughts.

He closed his eyes, and immediately a sound of cannonading, of
musketry and the rattling of carriage wheels seemed to fill his
ears, and now again drawn out in a thin line the musketeers were
descending the hill, the French were firing, and he felt his heart
palpitating as he rode forward beside Schmidt with the bullets merrily
whistling all around, and he experienced tenfold the joy of living, as
he had not done since childhood.

He woke up...

"Yes, that all happened!" he said, and, smiling happily to himself
like a child, he fell into a deep, youthful slumber.





CHAPTER XI


Next day he woke late. Recalling his recent impressions, the first
thought that came into his mind was that today he had to be
presented to the Emperor Francis; he remembered the Minister of War,
the polite Austrian adjutant, Bilibin, and last night's
conversation. Having dressed for his attendance at court in full
parade uniform, which he had not worn for a long time, he went into
Bilibin's study fresh, animated, and handsome, with his hand bandaged.
In the study were four gentlemen of the diplomatic corps. With
Prince Hippolyte Kuragin, who was a secretary to the embassy,
Bolkonski was already acquainted. Bilibin introduced him to the
others.

The gentlemen assembled at Bilibin's were young, wealthy, gay
society men, who here, as in Vienna, formed a special set which
Bilibin, their leader, called les notres.* This set, consisting almost
exclusively of diplomats, evidently had its own interests which had
nothing to do with war or politics but related to high society, to
certain women, and to the official side of the service. These
gentlemen received Prince Andrew as one of themselves, an honor they
did not extend to many. From politeness and to start conversation,
they asked him a few questions about the army and the battle, and then
the talk went off into merry jests and gossip.


*Ours.


"But the best of it was," said one, telling of the misfortune of a
fellow diplomat, "that the Chancellor told him flatly that his
appointment to London was a promotion and that he was so to regard it.
Can you fancy the figure he cut?..."

"But the worst of it, gentlemen--I am giving Kuragin away to you--is
that that man suffers, and this Don Juan, wicked fellow, is taking
advantage of it!"

Prince Hippolyte was lolling in a lounge chair with his legs over
its arm. He began to laugh.

"Tell me about that!" he said.

"Oh, you Don Juan! You serpent!" cried several voices.

"You, Bolkonski, don't know," said Bilibin turning to Prince Andrew,
"that all the atrocities of the French army (I nearly said of the
Russian army) are nothing compared to what this man has been doing
among the women!"

"La femme est la compagne de l'homme,"* announced Prince
Hippolyte, and began looking through a lorgnette at his elevated legs.


*"Woman is man's companion."


Bilibin and the rest of "ours" burst out laughing in Hippolyte's
face, and Prince Andrew saw that Hippolyte, of whom--he had to
admit--he had almost been jealous on his wife's account, was the
butt of this set.

"Oh, I must give you a treat," Bilibin whispered to Bolkonski.
"Kuragin is exquisite when he discusses politics--you should see his
gravity!"

He sat down beside Hippolyte and wrinkling his forehead began
talking to him about politics. Prince Andrew and the others gathered
round these two.

"The Berlin cabinet cannot express a feeling of alliance," began
Hippolyte gazing round with importance at the others, "without
expressing... as in its last note... you understand... Besides, unless
His Majesty the Emperor derogates from the principle of our
alliance...

"Wait, I have not finished..." he said to Prince Andrew, seizing him
by the arm, "I believe that intervention will be stronger than
nonintervention. And..." he paused. "Finally one cannot impute the
nonreceipt of our dispatch of November 18. That is how it will end."
And he released Bolkonski's arm to indicate that he had now quite
finished.

"Demosthenes, I know thee by the pebble thou secretest in thy golden
mouth!" said Bilibin, and the mop of hair on his head moved with
satisfaction.

Everybody laughed, and Hippolyte louder than anyone. He was
evidently distressed, and breathed painfully, but could not restrain
the wild laughter that convulsed his usually impassive features.

"Well now, gentlemen," said Bilibin, "Bolkonski is my guest in
this house and in Brunn itself. I want to entertain him as far as I
can, with all the pleasures of life here. If we were in Vienna it
would be easy, but here, in this wretched Moravian hole, it is more
difficult, and I beg you all to help me. Brunn's attractions must be
shown him. You can undertake the theater, I society, and you,
Hippolyte, of course the women."

"We must let him see Amelie, she's exquisite!" said one of "ours,"
kissing his finger tips.

"In general we must turn this bloodthirsty soldier to more humane
interests," said Bilibin.

"I shall scarcely be able to avail myself of your hospitality,
gentlemen, it is already time for me to go," replied Prince Andrew
looking at his watch.

"Where to?"

"To the Emperor."

"Oh! Oh! Oh! Well, au revoir, Bolkonski! Au revoir, Prince! Come
back early to dinner," cried several voices. "We'll take you in hand."

"When speaking to the Emperor, try as far as you can to praise the
way that provisions are supplied and the routes indicated," said
Bilibin, accompanying him to the hall.

"I should like to speak well of them, but as far as I the facts, I
can't," replied Bolkonski, smiling.

"Well, talk as much as you can, anyway. He has a passion for
giving audiences, but he does not like talking himself and can't do
it, as you will see."





CHAPTER XII


At the levee Prince Andrew stood among the Austrian officers as he
had been told to, and the Emperor Francis merely looked fixedly into
his face and just nodded to him with to him with his long head. But
after it was over, the adjutant he had seen the previous day
ceremoniously informed Bolkonski that the Emperor desired to give
him an audience. The Emperor Francis received him standing in the
middle of the room. Before the conversation began Prince Andrew was
struck by the fact that the Emperor seemed confused and blushed as
if not knowing what to say.

"Tell me, when did the battle begin?" he asked hurriedly.

Prince Andrew replied. Then followed other questions just as simple:
"Was Kutuzov well? When had he left Krems?" and so on. The Emperor
spoke as if his sole aim were to put a given number of questions-
the answers to these questions, as was only too evident, did not
interest him.

"At what o'clock did the battle begin?" asked the Emperor.

"I cannot inform Your Majesty at what o'clock the battle began at
the front, but at Durrenstein, where I was, our attack began after
five in the afternoon," replied Bolkonski growing more animated and
expecting that he would have a chance to give a reliable account,
which he had ready in his mind, of all he knew and had seen. But the
Emperor smiled and interrupted him.

"How many miles?"

"From where to where, Your Majesty?"

"From Durrenstein to Krems."

"Three and a half miles, Your Majesty."

"The French have abandoned the left bank?"

"According to the scouts the last of them crossed on rafts during
the night."

"Is there sufficient forage in Krems?"

"Forage has not been supplied to the extent..."

The Emperor interrupted him.

"At what o'clock was General Schmidt killed?"

"At seven o'clock, I believe."

"At seven o'clock? It's very sad, very sad!"

The Emperor thanked Prince Andrew and bowed. Prince Andrew
withdrew and was immediately surrounded by courtiers on all sides.
Everywhere he saw friendly looks and heard friendly words. Yesterday's
adjutant reproached him for not having stayed at the palace, and
offered him his own house. The Minister of War came up and
congratulated him on the Maria Theresa Order of the third grade, which
the Emperor was conferring on him. The Empress' chamberlain invited
him to see Her Majesty. The archduchess also wished to see him. He did
not know whom to answer, and for a few seconds collected his thoughts.
Then the Russian ambassador took him by the shoulder, led him to the
window, and began to talk to him.

Contrary to Bilibin's forecast the news he had brought was
joyfully received. A thanksgiving service was arranged, Kutuzov was
awarded the Grand Cross of Maria Theresa, and the whole army
received rewards. Bolkonski was invited everywhere, and had to spend
the whole morning calling on the principal Austrian dignitaries.
Between four and five in the afternoon, having made all his calls,
he was returning to Bilibin's house thinking out a letter to his
father about the battle and his visit to Brunn. At the door he found a
vehicle half full of luggage. Franz, Bilibin's man, was dragging a
portmanteau with some difficulty out of the front door.

Before returning to Bilibin's Prince Andrew had gone to bookshop
to provide himself with some books for the campaign, and had spent
some time in the shop.

"What is it?" he asked.

"Oh, your excellency!" said Franz, with difficulty rolling the
portmanteau into the vehicle, "we are to move on still farther. The
scoundrel is again at our heels!"

"Eh? What?" asked Prince Andrew.

Bilibin came out to meet him. His usually calm face showed
excitement.

"There now! Confess that this is delightful," said he. "This
affair of the Thabor Bridge, at Vienna.... They have crossed without
striking a blow!"

Prince Andrew could not understand.

"But where do you come from not to know what every coachman in the
town knows?"

"I come from the archduchess'. I heard nothing there."

"And you didn't see that everybody is packing up?"

"I did not... What is it all about?" inquired Prince Andrew
impatiently.

"What's it all about? Why, the French have crossed the bridge that
Auersperg was defending, and the bridge was not blown up: so Murat
is now rushing along the road to Brunn and will be here in a day or
two."

"What? Here? But why did they not blow up the bridge, if it was
mined?"

"That is what I ask you. No one, not even Bonaparte, knows why."

Bolkonski shrugged his shoulders.

"But if the bridge is crossed it means that the army too is lost? It
will be cut off," said he.

"That's just it," answered Bilibin. "Listen! The French entered
Vienna as I told you. Very well. Next day, which was yesterday,
those gentlemen, messieurs les marechaux,* Murat, Lannes,and Belliard,
mount and ride to bridge. (Observe that all three are Gascons.)
'Gentlemen,' says one of them, 'you know the Thabor Bridge is mined
and doubly mined and that there are menacing fortifications at its
head and an army of fifteen thousand men has been ordered to blow up
the bridge and not let us cross? But it will please our sovereign
the Emperor Napoleon if we take this bridge, so let us three go and
take it!' 'Yes, let's!' say the others. And off they go and take the
bridge, cross it, and now with their whole army are on this side of
the Danube, marching on us, you, and your lines of communication."


*The marshalls.


"Stop jesting," said Prince Andrew sadly and seriously. This news
grieved him and yet he was pleased.

As soon as he learned that the Russian army was in such a hopeless
situation it occurred to him that it was he who was destined to lead
it out of this position; that here was the Toulon that would lift
him from the ranks of obscure officers and offer him the first step to
fame! Listening to Bilibin he was already imagining how on reaching
the army he would give an opinion at the war council which would be
the only one that could save the army, and how he alone would be
entrusted with the executing of the plan.

"Stop this jesting," he said

"I am not jesting," Bilibin went on. "Nothing is truer or sadder.
These gentlemen ride onto the bridge alone and wave white
handkerchiefs; they assure the officer on duty that they, the
marshals, are on their way to negotiate with Prince Auersperg. He lets
them enter the tete-de-pont.* They spin him a thousand gasconades,
saying that the war is over, that the Emperor Francis is arranging a
meeting with Bonaparte, that they desire to see Prince Auersperg,
and so on. The officer sends for Auersperg; these gentlemen embrace
the officers, crack jokes, sit on the cannon, and meanwhile a French
battalion gets to the bridge unobserved, flings the bags of incendiary
material into the water, and approaches the tete-de-pont. At length
appears the lieutenant general, our dear Prince Auersperg von
Mautern himself. 'Dearest foe! Flower of the Austrian army, hero of
the Turkish wars Hostilities are ended, we can shake one another's
hand.... The Emperor Napoleon burns with impatience to make Prince
Auersperg's acquaintance.' In a word, those gentlemen, Gascons indeed,
so bewildered him with fine words, and he is so flattered by his
rapidly established intimacy with the French marshals, and so
dazzled by the sight of Murat's mantle and ostrich plumes, qu'il n'y
voit que du feu, et oublie celui qu'il devait faire faire sur
l'ennemi!"*[2] In spite of the animation of his speech, Bilibin did
not forget to pause after this mot to give time for its due
appreciation. "The French battalion rushes to the bridgehead, spikes
the guns, and the bridge is taken! But what is best of all," he went
on, his excitement subsiding under the delightful interest of his
own story, "is that the sergeant in charge of the cannon which was
to give the signal to fire the mines and blow up the bridge, this
sergeant, seeing that the French troops were running onto the
bridge, was about to fire, but Lannes stayed his hand. The sergeant,
who was evidently wiser than his general, goes up to Auersperg and
says: 'Prince, you are being deceived, here are the French!' Murat,
seeing that all is lost if the sergeant is allowed to speak, turns
to Auersperg with feigned astonishment (he is a true Gascon) and says:
'I don't recognize the world-famous Austrian discipline, if you
allow a subordinate to address you like that!' It was a stroke of
genius. Prince Auersperg feels his dignity at stake and orders the
sergeant to be arrested. Come, you must own that this affair of the
Thabor Bridge is delightful! It is not exactly stupidity, nor
rascality...."


*Bridgehead.

*[2] That their fire gets into his eyes and he forgets that he ought
to be firing at the enemy.


"It may be treachery," said Prince Andrew, vividly imagining the
gray overcoats, wounds, the smoke of gunpowder, the sounds of
firing, and the glory that awaited him.

"Not that either. That puts the court in too bad a light," replied
Bilibin. "It's not treachery nor rascality nor stupidity: it is just as
at Ulm... it is..."--he seemed to be trying to find the right
expression. "C'est... c'est du Mack. Nous sommes mackes [It is... it
is a bit of Mack. We are Macked]," he concluded, feeling that he had
produced a good epigram, a fresh one that would be repeated. His
hitherto puckered brow became smooth as a sign of pleasure, and with a
slight smile he began to examine his nails.

"Where are you off to?" he said suddenly to Prince Andrew who had
risen and was going toward his room.

"I am going away."

"Where to?"

"To the army."

"But you meant to stay another two days?"

"But now I am off at once."

And Prince Andrew after giving directions about his departure went
to his room.

"Do you know, mon cher," said Bilibin following him, "I have been
thinking about you. Why are you going?"

And in proof of the conclusiveness of his opinion all the wrinkles
vanished from his face.

Prince Andrew looked inquiringly at him and gave no reply.

"Why are you going? I know you think it your duty to gallop back
to the army now that it is in danger. I understand that. Mon cher,
it is heroism!"

"Not at all," said Prince Andrew.

"But as you are a philosopher, be a consistent one, look at the
other side of the question and you will see that your duty, on the
contrary, is to take care of yourself. Leave it to those who are no
longer fit for anything else.... You have not been ordered to return
and have not been dismissed from here; therefore, you can stay and
go with us wherever our ill luck takes us. They say we are going to
Olmutz, and Olmutz is a very decent town. You and I will travel
comfortably in my caleche."

"Do stop joking, Bilibin," cried Bolkonski.

"I am speaking sincerely as a friend! Consider! Where and why are
you going, when you might remain here? You are faced by one of two
things," and the skin over his left temple puckered, "either you
will not reach your regiment before peace is concluded, or you will
share defeat and disgrace with Kutuzov's whole army."

And Bilibin unwrinkled his temple, feeling that the dilemma was
insoluble.

"I cannot argue about it," replied Prince Andrew coldly, but he
thought: "I am going to save the army."

"My dear fellow, you are a hero!" said Bilibin.





CHAPTER XIII


That same night, having taken leave of the Minister of War,
Bolkonski set off to rejoin the army, not knowing where he would
find it and fearing to be captured by the French on the way to Krems.

In Brunn everybody attached to the court was packing up, and the
heavy baggage was already being dispatched to Olmutz. Near Hetzelsdorf
Prince Andrew struck the high road along which the Russian army was
moving with great haste and in the greatest disorder. The road was
so obstructed with carts that it was impossible to get by in a
carriage. Prince Andrew took a horse and a Cossack from a Cossack
commander, and hungry and weary, making his way past the baggage
wagons, rode in search of the commander in chief and of his own
luggage. Very sinister reports of the position of the army reached him
as he went along, and the appearance of the troops in their disorderly
flight confirmed these rumors.

"Cette armee russe que l'or de l'Angleterre a transportee des
extremites de l'univers, nous allons lui faire eprouver le meme
sort--(le sort de l'armee d'Ulm)."* He remembered these words in
Bonaparte's address to his army at the beginning of the campaign,
and they awoke in him astonishment at the genius of his hero, a
feeling of wounded pride, and a hope of glory. "And should there be
nothing left but to die?" he thought. "Well, if need be, I shall do it
no worse than others."


*"That Russian army which has been brought from the ends of the
earth by English gold, we shall cause to share the same fate--(the
fate of the army at Ulm)."


He looked with disdain at the endless confused mass of
detachments, carts, guns, artillery, and again baggage wagons and
vehicles of all kinds overtaking one another and blocking the muddy
road, three and sometimes four abreast. From all sides, behind and
before, as far as ear could reach, there were the rattle of wheels,
the creaking of carts and gun carriages, the tramp of horses, the
crack of whips, shouts, the urging of horses, and the swearing of
soldiers, orderlies, and officers. All along the sides of the road
fallen horses were to be seen, some flayed, some not, and
broken-down carts beside which solitary soldiers sat waiting for
something, and again soldiers straggling from their companies,
crowds of whom set off to the neighboring villages, or returned from
them dragging sheep, fowls, hay, and bulging sacks. At each ascent
or descent of the road the crowds were yet denser and the din of
shouting more incessant. Soldiers floundering knee-deep in mud
pushed the guns and wagons themselves. Whips cracked, hoofs slipped,
traces broke, and lungs were strained with shouting. The officers
directing the march rode backward and forward between the carts. Their
voices were but feebly heard amid the uproar and one saw by their
faces that they despaired of the possibility of checking this
disorder.

"Here is our dear Orthodox Russian army," thought Bolkonski,
recalling Bilibin's words.

Wishing to find out where the commander in chief was, he rode up
to a convoy. Directly opposite to him came a strange one-horse
vehicle, evidently rigged up by soldiers out of any available
materials and looking like something between a cart, a cabriolet,
and a caleche. A soldier was driving, and a woman enveloped in
shawls sat behind the apron under the leather hood of the vehicle.
Prince Andrew rode up and was just putting his question to a soldier
when his attention was diverted by the desperate shrieks of the
woman in the vehicle. An officer in charge of transport was beating
the soldier who was driving the woman's vehicle for trying to get
ahead of others, and the strokes of his whip fell on the apron of
the equipage. The woman screamed piercingly. Seeing Prince Andrew
she leaned out from behind the apron and, waving her thin arms from
under the woolen shawl, cried:

"Mr. Aide-de-camp! Mr. Aide-de-camp!... For heaven's sake... Protect
me! What will become of us? I am the wife of the doctor of the Seventh
Chasseurs.... They won't let us pass, we are left behind and have lost
our people..."

"I'll flatten you into a pancake!" shouted the angry officer to
the soldier. "Turn back with your slut!"

"Mr. Aide-de-camp! Help me!... What does it all mean?" screamed
the doctor's wife.

"Kindly let this cart pass. Don't you see it's a woman?" said Prince
Andrew riding up to the officer.

The officer glanced at him, and without replying turned again to the
soldier. "I'll teach you to push on!... Back!"

"Let them pass, I tell you!" repeated Prince Andrew, compressing his
lips.

"And who are you?" cried the officer, turning on him with tipsy
rage, "who are you? Are you in command here? Eh? I am commander
here, not you! Go back or I'll flatten you into a pancake," repeated
he. This expression evidently pleased him.

"That was a nice snub for the little aide-de-camp," came a voice
from behind.

Prince Andrew saw that the officer was in that state of senseless,
tipsy rage when a man does not know what he is saying. He saw that his
championship of the doctor's wife in her queer trap might expose him
to what he dreaded more than anything in the world--to ridicule; but
his instinct urged him on. Before the officer finished his sentence
Prince Andrew, his face distorted with fury, rode up to him and raised
his riding whip.

"Kind...ly let--them--pass!"

The officer flourished his arm and hastily rode away.

"It's all the fault of these fellows on the staff that there's
this disorder," he muttered. "Do as you like."

Prince Andrew without lifting his eyes rode hastily away from the
doctor's wife, who was calling him her deliverer, and recalling with a
sense of disgust the minutest details of this humiliating scene he
galloped on to the village where he was told that the commander in
chief was.

On reaching the village he dismounted and went to the nearest house,
intending to rest if but for a moment, eat something, and try to
sort out the stinging and tormenting thoughts that confused his
mind. "This is a mob of scoundrels and not an army," he was thinking
as he went up to the window of the first house, when a familiar
voice called him by name.

He turned round. Nesvitski's handsome face looked out of the
little window. Nesvitski, moving his moist lips as he chewed
something, and flourishing his arm, called him to enter.

"Bolkonski! Bolkonski!... Don't you hear? Eh? Come quick..." he
shouted.

Entering the house, Prince Andrew saw Nesvitski and another adjutant
having something to eat. They hastily turned round to him asking if he
had any news. On their familiar faces he read agitation and alarm.
This was particularly noticeable on Nesvitski's usually laughing
countenance.

"Where is the commander in chief?" asked Bolkonski.

"Here, in that house," answered the adjutant.

"Well, is it true that it's peace and capitulation?" asked
Nesvitski.

"I was going to ask you. I know nothing except that it was all I
could do to get here."

"And we, my dear boy! It's terrible! I was wrong to laugh at Mack,
we're getting it still worse," said Nesvitski. "But sit down and
have something to eat."

"You won't be able to find either your baggage or anything else now,
Prince. And God only knows where your man Peter is," said the other
adjutant.

"Where are headquarters?"

"We are to spend the night in Znaim."

"Well, I have got all I need into packs for two horses," said
Nesvitski. "They've made up splendid packs for me--fit to cross the
Bohemian mountains with. It's a bad lookout, old fellow! But what's
the matter with you? You must be ill to shiver like that," he added,
noticing that Prince Andrew winced as at an electric shock.

"It's nothing," replied Prince Andrew.

He had just remembered his recent encounter with the doctor's wife
and the convoy officer.

"What is the commander in chief doing here?" he asked.

"I can't make out at all," said Nesvitski.

"Well, all I can make out is that everything is abominable,
abominable, quite abominable!" said Prince Andrew, and he went off
to the house where the commander in chief was.

Passing by Kutuzov's carriage and the exhausted saddle horses of his
suite, with their Cossacks who were talking loudly together, Prince
Andrew entered the passage. Kutuzov himself, he was told, was in the
house with Prince Bagration and Weyrother. Weyrother was the
Austrian general who had succeeded Schmidt. In the passage little
Kozlovski was squatting on his heels in front of a clerk. The clerk,
with cuffs turned up, was hastily writing at a tub turned bottom
upwards. Kozlovski's face looked worn--he too had evidently not
slept all night. He glanced at Prince Andrew and did not even nod to
him.

"Second line... have you written it?" he continued dictating to
the clerk. "The Kiev Grenadiers, Podolian..."

"One can't write so fast, your honor," said the clerk, glancing
angrily and disrespectfully at Kozlovski.

Through the door came the sounds of Kutuzov's voice, excited and
dissatisfied, interrupted by another, an unfamiliar voice. From the
sound of these voices, the inattentive way Kozlovski looked at him,
the disrespectful manner of the exhausted clerk, the fact that the
clerk and Kozlovski were squatting on the floor by a tub so near to
the commander in chief, and from the noisy laughter of the Cossacks
holding the horses near the window, Prince Andrew felt that
something important and disastrous was about to happen.

He turned to Kozlovski with urgent questions.

"Immediately, Prince," said Kozlovski. "Dispositions for Bagration."

"What about capitulation?"

"Nothing of the sort. Orders are issued for a battle."

Prince Andrew moved toward the door from whence voices were heard.
Just as he was going to open it the sounds ceased, the door opened,
and Kutuzov with his eagle nose and puffy face appeared in the
doorway. Prince Andrew stood right in front of Kutuzov but the
expression of the commander in chief's one sound eye showed him to
be so preoccupied with thoughts and anxieties as to be oblivious of
his presence. He looked straight at his adjutant's face without
recognizing him.

"Well, have you finished?" said he to Kozlovski.

"One moment, your excellency."

Bagration, a gaunt middle-aged man of medium height with a firm,
impassive face of Oriental type, came out after the commander in
chief.

"I have the honor to present myself," repeated Prince Andrew
rather loudly, handing Kutuzov an envelope.

"Ah, from Vienna? Very good. Later, later!"

Kutuzov went out into the porch with Bagration.

"Well, good-by, Prince," said he to Bagration. "My blessing, and may
Christ be with you in your great endeavor!"

His face suddenly softened and tears came into his eyes. With his
left hand he drew Bagration toward him, and with his right, on which
he wore a ring, he made the sign of the cross over him with a
gesture evidently habitual, offering his puffy cheek, but Bagration
kissed him on the neck instead.

"Christ be with you!" Kutuzov repeated and went toward his carriage.
"Get in with me," said he to Bolkonski.

"Your excellency, I should like to be of use here. Allow me to
remain with Prince Bagration's detachment."

"Get in," said Kutuzov, and noticing that Bolkonski still delayed,
he added: "I need good officers myself, need them myself!"

They got into the carriage and drove for a few minutes in silence.

"There is still much, much before us," he said, as if with an old
man's penetration he understood all that was passing in Bolkonski's
mind. "If a tenth part of his detachment returns I shall thank God,"
he added as if speaking to himself.

Prince Andrew glanced at Kutuzov's face only a foot distant from him
and involuntarily noticed the carefully washed seams of the scar
near his temple, where an Ismail bullet had pierced his skull, and the
empty eye socket. "Yes, he has a right to speak so calmly of those
men's death," thought Bolkonski.

"That is why I beg to be sent to that detachment," he said.

Kutuzov did not reply. He seemed to have forgotten what he had
been saying, and sat plunged in thought. Five minutes later, gently
swaying on the soft springs of the carriage, he turned to Prince
Andrew. There was not a trace of agitation on his face. With
delicate irony he questioned Prince Andrew about the details of his
interview with the Emperor, about the remarks he had heard at court
concerning the Krems affair, and about some ladies they both knew.





CHAPTER XIV


On November 1 Kutuzov had received, through a spy, news that the
army he commanded was in an almost hopeless position. The spy reported
that the French, after crossing the bridge at Vienna, were advancing
in immense force upon Kutuzov's line of communication with the
troops that were arriving from Russia. If Kutuzov decided to remain at
Krems, Napoleon's army of one hundred and fifty thousand men would cut
him off completely and surround his exhausted army of forty
thousand, and he would find himself in the position of Mack at Ulm. If
Kutuzov decided to abandon the road connecting him with the troops
arriving from Russia, he would have to march with no road into unknown
parts of the Bohemian mountains, defending himself against superior
forces of the enemy and abandoning all hope of a junction with
Buxhowden. If Kutuzov decided to retreat along the road from Krems
to Olmutz, to unite with the troops arriving from Russia, he risked
being forestalled on that road by the French who had crossed the
Vienna bridge, and encumbered by his baggage and transport, having
to accept battle on the march against an enemy three times as
strong, who would hem him in from two sides.

Kutuzov chose this latter course.

The French, the spy reported, having crossed the Vienna bridge, were
advancing by forced marches toward Znaim, which lay sixty-six miles
off on the line of Kutuzov's retreat. If he reached Znaim before the
French, there would be great hope of saving the army; to let the
French forestall him at Znaim meant the exposure of his whole army
to a disgrace such as that of Ulm, or to utter destruction. But to
forestall the French with his whole army was impossible. The road
for the French from Vienna to Znaim was shorter and better than the
road for the Russians from Krems to Znaim.

The night he received the news, Kutuzov sent Bagration's vanguard,
four thousand strong, to the right across the hills from the
Krems-Znaim to the Vienna-Znaim road. Bagration was to make this march
without resting, and to halt facing Vienna with Znaim to his rear, and
if he succeeded in forestalling the French he was to delay them as
long as possible. Kutuzov himself with all his transport took the road
to Znaim.

Marching thirty miles that stormy night across roadless hills,
with his hungry, ill-shod soldiers, and losing a third of his men as
stragglers by the way, Bagration came out on the Vienna-Znaim road
at Hollabrunn a few hours ahead of the French who were approaching
Hollabrunn from Vienna. Kutuzov with his transport had still to
march for some days before he could reach Znaim. Hence Bagration
with his four thousand hungry, exhausted men would have to detain
for days the whole enemy army that came upon him at Hollabrunn,
which was clearly impossible. But a freak of fate made the
impossible possible. The success of the trick that had placed the

Vienna bridge in the hands of the French without a fight led Murat
to try to deceive Kutuzov in a similar way. Meeting Bagration's weak
detachment on the Znaim road he supposed it to be Kutuzov's whole
army. To be able to crush it absolutely he awaited the arrival of
the rest of the troops who were on their way from Vienna, and with
this object offered a three days' truce on condition that both
armies should remain in position without moving. Murat declared that
negotiations for peace were already proceeding, and that he
therefore offered this truce to avoid unnecessary bloodshed. Count
Nostitz, the Austrian general occupying the advanced posts, believed
Murat's emissary and retired, leaving Bagration's division exposed.
Another emissary rode to the Russian line to announce the peace
negotiations and to offer the Russian army the three days' truce.
Bagration replied that he was not authorized either to accept or
refuse a truce and sent his adjutant to Kutuzov to report the offer he
had received.

A truce was Kutuzov's sole chance of gaining time, giving
Bagration's exhausted troops some rest, and letting the transport
and heavy convoys (whose movements were concealed from the French)
advance if but one stage nearer Znaim. The offer of a truce gave the
only, and a quite unexpected, chance of saving the army. On
receiving the news he immediately dispatched Adjutant General
Wintzingerode, who was in attendance on him, to the enemy camp.
Wintzingerode was not merely to agree to the truce but also to offer
terms of capitulation, and meanwhile Kutuzov sent his adjutants back
to hasten to the utmost the movements of the baggage trains of the
entire army along the Krems-Znaim road. Bagration's exhausted and
hungry detachment, which alone covered this movement of the
transport and of the whole army, had to remain stationary in face of
an enemy eight times as strong as itself.

Kutuzov's expectations that the proposals of capitulation (which
were in no way binding) might give time for part of the transport to
pass, and also that Murat's mistake would very soon be discovered,
proved correct. As soon as Bonaparte (who was at Schonbrunn, sixteen
miles from Hollabrunn) received Murat's dispatch with the proposal
of a truce and a capitulation, he detected a ruse and wrote the
following letter to Murat:


Schonbrunn, 25th Brumaire, 1805,

at eight o'clock in the morning

To PRINCE MURAT,

I cannot find words to express to you my displeasure. You command
only my advance guard, and have no right to arrange an armistice
without my order. You are causing me to lose the fruits of a campaign.
Break the armistice immediately and march on the enemy. Inform him
that the general who signed that capitulation had no right to do so,
and that no one but the Emperor of Russia has that right.

If, however, the Emperor of Russia ratifies that convention, I
will ratify it; but it is only a trick. March on, destroy the
Russian army.... You are in a position to seize its baggage and
artillery.

The Russian Emperor's aide-de-camp is an impostor. Officers are
nothing when they have no powers; this one had none.... The
Austrians let themselves be tricked at the crossing of the Vienna
bridge, you are letting yourself be tricked by an aide-de-camp of
the Emperor.

NAPOLEON


Bonaparte's adjutant rode full gallop with this menacing letter to
Murat. Bonaparte himself, not trusting to his generals, moved with all
the Guards to the field of battle, afraid of letting a ready victim
escape, and Bagration's four thousand men merrily lighted campfires,
dried and warmed themselves, cooked their porridge for the first
time for three days, and not one of them knew or imagined what was
in store for him.





CHAPTER XV


Between three and four o'clock in the afternoon Prince Andrew, who
had persisted in his request to Kutuzov, arrived at Grunth and
reported himself to Bagration. Bonaparte's adjutant had not yet
reached Murat's detachment and the battle had not yet begun. In
Bagration's detachment no one knew anything of the general position of
affairs. They talked of peace but did not believe in its
possibility; others talked of a battle but also disbelieved in the
nearness of an engagement. Bagration, knowing Bolkonski to be a
favorite and trusted adjutant, received him with distinction and
special marks of favor, explaining to him that there would probably be
an engagement that day or the next, and giving him full liberty to
remain with him during the battle or to join the rearguard and have an
eye on the order of retreat, "which is also very important."

"However, there will hardly be an engagement today," said
Bagration as if to reassure Prince Andrew.

"If he is one of the ordinary little staff dandies sent to earn a
medal he can get his reward just as well in the rearguard, but if he
wishes to stay with me, let him... he'll be of use here if he's a
brave officer," thought Bagration. Prince Andrew, without replying,
asked the prince's permission to ride round the position to see the
disposition of the forces, so as to know his bearings should he be
sent to execute an order. The officer on duty, a handsome, elegantly
dressed man with a diamond ring on his forefinger, who was fond of
speaking French though he spoke it badly, offered to conduct Prince
Andrew.

On all sides they saw rain-soaked officers with dejected faces who
seemed to be seeking something, and soldiers dragging doors,
benches, and fencing from the village.

"There now, Prince! We can't stop those fellows," said the staff
officer pointing to the soldiers. "The officers don't keep them in
hand. And there," he pointed to a sutler's tent, "they crowd in and
sit. This morning I turned them all out and now look, it's full again.
I must go there, Prince, and scare them a bit. It won't take a
moment."

"Yes, let's go in and I will get myself a roll and some cheese,"
said Prince Andrew who had not yet had time to eat anything.

"Why didn't you mention it, Prince? I would have offered you
something."

They dismounted and entered the tent. Several officers, with flushed
and weary faces, were sitting at the table eating and drinking.

"Now what does this mean, gentlemen?" said the staff officer, in the
reproachful tone of a man who has repeated the same thing more than
once. "You know it won't do to leave your posts like this. The
prince gave orders that no one should leave his post. Now you,
Captain," and he turned to a thin, dirty little artillery officer
who without his boots (he had given them to the canteen keeper to
dry), in only his stockings, rose when they entered, smiling not
altogether comfortably.

"Well, aren't you ashamed of yourself, Captain Tushin?" he
continued. "One would think that as an artillery officer you would set
a good example, yet here you are without your boots! The alarm will be
sounded and you'll be in a pretty position without your boots!" (The
staff officer smiled.) "Kindly return to your posts, gentlemen, all of
you, all!" he added in a tone of command.

Prince Andrew smiled involuntarily as he looked at the artillery
officer Tushin, who silent and smiling, shifting from one stockinged
foot to the other, glanced inquiringly with his large, intelligent,
kindly eyes from Prince Andrew to the staff officer.

"The soldiers say it feels easier without boots," said Captain
Tushin smiling shyly in his uncomfortable position, evidently
wishing to adopt a jocular tone. But before he had finished he felt
that his jest was unacceptable and had not come off. He grew confused.

"Kindly return to your posts," said the staff officer trying to
preserve his gravity.

Prince Andrew glanced again at the artillery officer's small figure.
There was something peculiar about it, quite unsoldierly, rather
comic, but extremely attractive.

The staff officer and Prince Andrew mounted their horses and rode
on.

Having ridden beyond the village, continually meeting and overtaking
soldiers and officers of various regiments, they saw on their left
some entrenchments being thrown up, the freshly dug clay of which
showed up red. Several battalions of soldiers, in their shirt
sleeves despite the cold wind, swarmed in these earthworks like a host
of white ants; spadefuls of red clay were continually being thrown
up from behind the bank by unseen hands. Prince Andrew and the officer
rode up, looked at the entrenchment, and went on again. Just behind it
they came upon some dozens of soldiers, continually replaced by
others, who ran from the entrenchment. They had to hold their noses
and put their horses to a trot to escape from the poisoned
atmosphere of these latrines.

"Voila l'agrement des camps, monsieur le Prince,"* said the staff
officer.


*"This is a pleasure one gets in camp, Prince."


They rode up the opposite hill. From there the French could
already be seen. Prince Andrew stopped and began examining the
position.

"That's our battery," said the staff officer indicating the
highest point. "It's in charge of the queer fellow we saw without
his boots. You can see everything from there; let's go there, Prince."

"Thank you very much, I will go on alone," said Prince Andrew,
wishing to rid himself of this staff officer's company, "please
don't trouble yourself further."

The staff officer remained behind and Prince Andrew rode on alone.

The farther forward and nearer the enemy he went, the more orderly
and cheerful were the troops. The greatest disorder and depression had
been in the baggage train he had passed that morning on the Znaim road
seven miles away from the French. At Grunth also some apprehension and
alarm could be felt, but the nearer Prince Andrew came to the French
lines the more confident was the appearance of our troops. The
soldiers in their greatcoats were ranged in lines, the sergeants major
and company officers were counting the men, poking the last man in
each section in the ribs and telling him to hold his hand up. Soldiers
scattered over the whole place were dragging logs and brushwood and
were building shelters with merry chatter and laughter; around the
fires sat others, dressed and undressed, drying their shirts and leg
bands or mending boots or overcoats and crowding round the boilers and
porridge cookers. In one company dinner was ready, and the soldiers
were gazing eagerly at the steaming boiler, waiting till the sample,
which a quartermaster sergeant was carrying in a wooden bowl to an
officer who sat on a log before his shelter, had been tasted.

Another company, a lucky one for not all the companies had vodka,
crowded round a pock-marked, broad-shouldered sergeant major who,
tilting a keg, filled one after another the canteen lids held out to
him. The soldiers lifted the canteen lids to their lips with
reverential faces, emptied them, rolling the vodka in their mouths,
and walked away from the sergeant major with brightened expressions,
licking their lips and wiping them on the sleeves of their greatcoats.
All their faces were as serene as if all this were happening at home
awaiting peaceful encampment, and not within sight of the enemy before
an action in which at least half of them would be left on the field.
After passing a chasseur regiment and in the lines of the Kiev
grenadiers--fine fellows busy with similar peaceful affairs--near
the shelter of the regimental commander, higher than and different
from the others, Prince Andrew came out in front of a platoon of
grenadiers before whom lay a naked man. Two soldiers held him while
two others were flourishing their switches and striking him
regularly on his bare back. The man shrieked unnaturally. A stout
major was pacing up and down the line, and regardless of the screams
kept repeating:

"It's a shame for a soldier to steal; a soldier must be honest,
honorable, and brave, but if he robs his fellows there is no honor
in him, he's a scoundrel. Go on! Go on!"

So the swishing sound of the strokes, and the desperate but
unnatural screams, continued.

"Go on, go on!" said the major.

A young officer with a bewildered and pained expression on his
face stepped away from the man and looked round inquiringly at the
adjutant as he rode by.

Prince Andrew, having reached the front line, rode along it. Our
front line and that of the enemy were far apart on the right and
left flanks, but in the center where the men with a flag of truce
had passed that morning, the lines were so near together that the
men could see one another's faces and speak to one another. Besides
the soldiers who formed the picket line on either side, there were
many curious onlookers who, jesting and laughing, stared at their
strange foreign enemies.

Since early morning--despite an injunction not to approach the
picket line--the officers had been unable to keep sight-seers away.
The soldiers forming the picket line, like showmen exhibiting a
curiosity, no longer looked at the French but paid attention to the
sight-seers and grew weary waiting to be relieved. Prince Andrew
halted to have a look at the French.

"Look! Look there!" one soldier was saying to another, pointing to a
Russian musketeer who had gone up to the picket line with an officer
and was rapidly and excitedly talking to a French grenadier. "Hark
to him jabbering! Fine, isn't it? It's all the Frenchy can do to
keep up with him. There now, Sidorov!"

"Wait a bit and listen. It's fine!" answered Sidorov, who was
considered an adept at French.

The soldier to whom the laughers referred was Dolokhov. Prince
Andrew recognized him and stopped to listen to what he was saying.
Dolokhov had come from the left flank where their regiment was
stationed, with his captain.

"Now then, go on, go on!" incited the officer, bending forward and
trying not to lose a word of the speech which was incomprehensible
to him. "More, please: more! What's he saying?"

Dolokhov did not answer the captain; he had been drawn into a hot
dispute with the French grenadier. They were naturally talking about
the campaign. The Frenchman, confusing the Austrians with the
Russians, was trying to prove that the Russians had surrendered and
had fled all the way from Ulm, while Dolokhov maintained that the
Russians had not surrendered but had beaten the French.

"We have orders to drive you off here, and we shall drive you
off," said Dolokhov.

"Only take care you and your Cossacks are not all captured!" said
the French grenadier.

The French onlookers and listeners laughed.

"We'll make you dance as we did under Suvorov...,"* said Dolokhov.


*"On vous fera danser."


"Qu' est-ce qu'il chante?"* asked a Frenchman.


*"What's he singing about?"


"It's ancient history," said another, guessing that it referred to a
former war. "The Emperor will teach your Suvara as he has taught the
others..."

"Bonaparte..." began Dolokhov, but the Frenchman interrupted him.

"Not Bonaparte. He is the Emperor! Sacre nom...!" cried he angrily.

"The devil skin your Emperor."

And Dolokhov swore at him in coarse soldier's Russian and
shouldering his musket walked away.

"Let us go, Ivan Lukich," he said to the captain.

"Ah, that's the way to talk French," said the picket soldiers. "Now,
Sidorov, you have a try!"

Sidorov, turning to the French, winked, and began to jabber
meaningless sounds very fast: "Kari, mala, tafa, safi, muter,
Kaska," he said, trying to give an expressive intonation to his voice.

"Ho! ho! ho! Ha! ha! ha! ha! Ouh! ouh!" came peals of such healthy
and good-humored laughter from the soldiers that it infected the
French involuntarily, so much so that the only thing left to do seemed
to be to unload the muskets, muskets, explode the ammunition, and
all return home as quickly as possible.

But the guns remained loaded, the loopholes in blockhouses and
entrenchments looked out just as menacingly, and the unlimbered cannon
confronted one another as before.





CHAPTER XVI


Having ridden round the whole line from right flank to left,
Prince Andrew made his way up to the battery from which the staff
officer had told him the whole field could be seen. Here he
dismounted, and stopped beside the farthest of the four unlimbered
cannon. Before the guns an artillery sentry was pacing up and down; he
stood at attention when the officer arrived, but at a sign resumed his
measured, monotonous pacing. Behind the guns were their limbers and
still farther back picket ropes and artillerymen's bonfires. To the
left, not far from the farthest cannon, was a small, newly constructed
wattle shed from which came the sound of officers' voices in eager
conversation.

It was true that a view over nearly the whole Russian position and
the greater part of the enemy's opened out from this battery. Just
facing it, on the crest of the opposite hill, the village of Schon
Grabern could be seen, and in three places to left and right the
French troops amid the smoke of their campfires, the greater part of
whom were evidently in the village itself and behind the hill. To
the left from that village, amid the smoke, was something resembling a
battery, but it was impossible to see it clearly with the naked eye.
Our right flank was posted on a rather steep incline which dominated
the French position. Our infantry were stationed there, and at the
farthest point the dragoons. In the center, where Tushin's battery
stood and from which Prince Andrew was surveying the position, was the
easiest and most direct descent and ascent to the brook separating
us from Schon Grabern. On the left our troops were close to a copse,
in which smoked the bonfires of our infantry who were felling wood.
The French line was wider than ours, and it was plain that they
could easily outflank us on both sides. Behind our position was a
steep and deep dip, making it difficult for artillery and cavalry to
retire. Prince Andrew took out his notebook and, leaning on the
cannon, sketched a plan of the position. He made some notes on two
points, intending to mention them to Bagration. His idea was, first,
to concentrate all the artillery in the center, and secondly, to
withdraw the cavalry to the other side of the dip. Prince Andrew,
being always near the commander in chief, closely following the mass
movements and general orders, and constantly studying historical
accounts of battles, involuntarily pictured to himself the course of
events in the forthcoming action in broad outline. He imagined only
important possibilities: "If the enemy attacks the right flank," he
said to himself, "the Kiev grenadiers and the Podolsk chasseurs must
hold their position till reserves from the center come up. In that
case the dragoons could successfully make a flank counterattack. If
they attack our center we, having the center battery on this high
ground, shall withdraw the left flank under its cover, and retreat
to the dip by echelons." So he reasoned.... All the time he had been
beside the gun, he had heard the voices of the officers distinctly,
but as often happens had not understood a word of what they were
saying. Suddenly, however, he was struck by a voice coming from the
shed, and its tone was so sincere that he could not but listen.

"No, friend," said a pleasant and, as it seemed to Prince Andrew,
a familiar voice, "what I say is that if it were possible to know what
is beyond death, none of us would be afraid of it. That's so, friend."

Another, a younger voice, interrupted him: "Afraid or not, you can't
escape it anyhow."

"All the same, one is afraid! Oh, you clever people," said a third
manly voice interrupting them both. "Of course you artillery men are
very wise, because you can take everything along with you--vodka and
snacks."

And the owner of the manly voice, evidently an infantry officer,
laughed.

"Yes, one is afraid," continued the first speaker, he of the
familiar voice. "One is afraid of the unknown, that's what it is.
Whatever we may say about the soul going to the sky... we know there
is no sky but only an atmosphere."

The manly voice again interrupted the artillery officer.

"Well, stand us some of your herb vodka, Tushin," it said.

"Why," thought Prince Andrew, "that's the captain who stood up in
the sutler's hut without his boots." He recognized the agreeable,
philosophizing voice with pleasure.

"Some herb vodka? Certainly!" said Tushin. "But still, to conceive a
future life..."

He did not finish. Just then there was a whistle in the air;
nearer and nearer, faster and louder, louder and faster, a cannon
ball, as if it had not finished saying what was necessary, thudded
into the ground near the shed with super human force, throwing up a
mass of earth. The ground seemed to groan at the terrible impact.

And immediately Tushin, with a short pipe in the corner of his mouth
and his kind, intelligent face rather pale, rushed out of the shed
followed by the owner of the manly voice, a dashing infantry officer
who hurried off to his company, buttoning up his coat as he ran.





CHAPTER XVII


Mounting his horse again Prince Andrew lingered with the battery,
looking at the puff from the gun that had sent the ball. His eyes
ran rapidly over the wide space, but he only saw that the hitherto
motionless masses of the French now swayed and that there really was a
battery to their left. The smoke above it had not yet dispersed. Two
mounted Frenchmen, probably adjutants, were galloping up the hill. A
small but distinctly visible enemy column was moving down the hill,
probably to strengthen the front line. The smoke of the first shot had
not yet dispersed before another puff appeared, followed by a
report. The battle had begun! Prince Andrew turned his horse and
galloped back to Grunth to find Prince Bagration. He heard the
cannonade behind him growing louder and more frequent. Evidently our
guns had begun to reply. From the bottom of the slope, where the
parleys had taken place, came the report of musketry.

Lemarrois had just arrived at a gallop with Bonaparte's stern
letter, and Murat, humiliated and anxious to expiate his fault, had at
once moved his forces to attack the center and outflank both the
Russian wings, hoping before evening and before the arrival of the
Emperor to crush the contemptible detachment that stood before him.

"It has begun. Here it is!" thought Prince Andrew, feeling the blood
rush to his heart. "But where and how will my Toulon present itself?"

Passing between the companies that had been eating porridge and
drinking vodka a quarter of an hour before, he saw everywhere the same
rapid movement of soldiers forming ranks and getting their muskets
ready, and on all their faces he recognized the same eagerness that
filled his heart. "It has begun! Here it is, dreadful but
enjoyable!" was what the face of each soldier and each officer
seemed to say.

Before he had reached the embankments that were being thrown up,
he saw, in the light of the dull autumn evening, mounted men coming
toward him. The foremost, wearing a Cossack cloak and lambskin cap and
riding a white horse, was Prince Bagration. Prince Andrew stopped,
waiting for him to come up; Prince Bagration reined in his horse and
recognizing Prince Andrew nodded to him. He still looked ahead while
Prince Andrew told him what he had seen.

The feeling, "It has begun! Here it is!" was seen even on Prince
Bagration's hard brown face with its half-closed, dull, sleepy eyes.
Prince Andrew gazed with anxious curiosity at that impassive face
and wished he could tell what, if anything, this man was thinking
and feeling at that moment. "Is there anything at all behind that
impassive face?" Prince Andrew asked himself as he looked. Prince
Bagration bent his head in sign of agreement with what Prince Andrew
told him, and said, "Very good!" in a tone that seemed to imply that
everything that took place and was reported to him was exactly what he
had foreseen. Prince Andrew, out of breath with his rapid ride,
spoke quickly. Prince Bagration, uttering his words with an Oriental
accent, spoke particularly slowly, as if to impress the fact that
there was no need to hurry. However, he put his horse to a trot in the
direction of Tushin's battery. Prince Andrew followed with the
suite. Behind Prince Bagration rode an officer of the suite, the
prince's personal adjutant, Zherkov, an orderly officer, the staff
officer on duty, riding a fine bobtailed horse, and a civilian--an
accountant who had asked permission to be present at the battle out of
curiosity. The accountant, a stout, full-faced man, looked around
him with a naive smile of satisfaction and presented a strange
appearance among the hussars, Cossacks, and adjutants, in his camlet
coat, as he jolted on his horse with a convoy officer's saddle.

"He wants to see a battle," said Zherkov to Bolkonski, pointing to
the accountant, "but he feels a pain in the pit of his stomach
already."

"Oh, leave off!" said the accountant with a beaming but rather
cunning smile, as if flattered at being made the subject of
Zherkov's joke, and purposely trying to appear stupider than he really
was.

"It is very strange, mon Monsieur Prince," said the staff officer.
(He remembered that in French there is some peculiar way of addressing
a prince, but could not get it quite right.)

By this time they were all approaching Tushin's battery, and a
ball struck the ground in front of them.

"What's that that has fallen?" asked the accountant with a naive
smile.

"A French pancake," answered Zherkov.

"So that's what they hit with?" asked the accountant. "How awful!"

He seemed to swell with satisfaction. He had hardly finished
speaking when they again heard an unexpectedly violent whistling which
suddenly ended with a thud into something soft... f-f-flop! and a
Cossack, riding a little to their right and behind the accountant,
crashed to earth with his horse. Zherkov and the staff officer bent
over their saddles and turned their horses away. The accountant
stopped, facing the Cossack, and examined him with attentive
curiosity. The Cossack was dead, but the horse still struggled.

Prince Bagration screwed up his eyes, looked round, and, seeing
the cause of the confusion, turned away with indifference, as if to
say, "Is it worth while noticing trifles?" He reined in his horse with
the case of a skillful rider and, slightly bending over, disengaged
his saber which had caught in his cloak. It was an old-fashioned saber
of a kind no longer in general use. Prince Andrew remembered the story
of Suvorov giving his saber to Bagration in Italy, and the
recollection was particularly pleasant at that moment. They had
reached the battery at which Prince Andrew had been when he examined
the battlefield.

"Whose company?" asked Prince Bagration of an artilleryman
standing by the ammunition wagon.

He asked, "Whose company?" but he really meant, "Are you
frightened here?" and the artilleryman understood him.

"Captain Tushin's, your excellency!" shouted the red-haired,
freckled gunner in a merry voice, standing to attention.

"Yes, yes," muttered Bagration as if considering something, and he
rode past the limbers to the farthest cannon.

As he approached, a ringing shot issued from it deafening him and
his suite, and in the smoke that suddenly surrounded the gun they
could see the gunners who had seized it straining to roll it quickly
back to its former position. A huge, broad-shouldered gunner, Number
One, holding a mop, his legs far apart, sprang to the wheel; while
Number Two with a trembling hand placed a charge in the cannon's
mouth. The short, round-shouldered Captain Tushin, stumbling over
the tail of the gun carriage, moved forward and, not noticing the
general, looked out shading his eyes with his small hand.

"Lift it two lines more and it will be just right," cried he in a
feeble voice to which he tried to impart a dashing note, ill suited to
his weak figure. "Number Two!" he squeaked. "Fire, Medvedev!"

Bagration called to him, and Tushin, raising three fingers to his
cap with a bashful and awkward gesture not at all like a military
salute but like a priest's benediction, approached the general. Though
Tushin's guns had been intended to cannonade the valley, he was firing
incendiary balls at the village of Schon Grabern visible just
opposite, in front of which large masses of French were advancing.

No one had given Tushin orders where and at what to fire, but
after consulting his sergeant major, Zakharchenko, for whom he had
great respect, he had decided that it would be a good thing to set
fire to the village. "Very good!" said Bagration in reply to the
officer's report, and began deliberately to examine the whole
battlefield extended before him. The French had advanced nearest on
our right. Below the height on which the Kiev regiment was
stationed, in the hollow where the rivulet flowed, the soul-stirring
rolling and crackling of musketry was heard, and much farther to the
right beyond the dragoons, the officer of the suite pointed out to
Bagration a French column that was outflanking us. To the left the
horizon bounded by the adjacent wood. Prince Bagration ordered two
battalions from the center to be sent to reinforce the right flank.
The officer of the suite ventured to remark to the prince that if
these battalions went away, the guns would remain without support.
Prince Bagration turned to the officer and with his dull eyes looked
at him in silence. It seemed to Prince Andrew that the officer's
remark was just and that really no answer could be made to it. But
at that moment an adjutant galloped up with a message from the
commander of the regiment in the hollow and news that immense masses
of the French were coming down upon them and that his regiment was
in disorder and was retreating upon the Kiev grenadiers. Prince
Bagration bowed his head in sign of assent and approval. He rode off
at a walk to the right and sent an adjutant to the dragoons with
orders to attack the French. But this adjutant returned half an hour
later with the news that the commander of the dragoons had already
retreated beyond the dip in the ground, as a heavy fire had been
opened on him and he was losing men uselessly, and so had hastened
to throw some sharpshooters into the wood.

"Very good!" said Bagration.

As he was leaving the battery, firing was heard on the left also,
and as it was too far to the left flank for him to have time to go
there himself, Prince Bagration sent Zherkov to tell the general in
command (the one who had paraded his regiment before Kutuzov at
Braunau) that he must retreat as quickly as possible behind the hollow
in the rear, as the right flank would probably not be able to
withstand the enemy's attack very long. About Tushin and the battalion
that had been in support of his battery all was forgotten. Prince
Andrew listened attentively to Bagration's colloquies with the
commanding officers and the orders he gave them and, to his
surprise, found that no orders were really given, but that Prince
Bagration tried to make it appear that everything done by necessity,
by accident, or by the will of subordinate commanders was done, if not
by his direct command, at least in accord with his intentions.
Prince Andrew noticed, however, that though what happened was due to
chance and was independent of the commander's will, owing to the
tact Bagration showed, his presence was very valuable. Officers who
approached him with disturbed countenances became calm; soldiers and
officers greeted him gaily, grew more cheerful in his presence, and
were evidently anxious to display their courage before him.





CHAPTER XVIII


Prince Bagration, having reached the highest point of our right
flank, began riding downhill to where the roll of musketry was heard
but where on account of the smoke nothing could be seen. The nearer
they got to the hollow the less they could see but the more they
felt the nearness of the actual battlefield. They began to meet
wounded men. One with a bleeding head and no cap was being dragged
along by two soldiers who supported him under the arms. There was a
gurgle in his throat and he was spitting blood. A bullet had evidently
hit him in the throat or mouth. Another was walking sturdily by
himself but without his musket, groaning aloud and swinging his arm
which had just been hurt, while blood from it was streaming over his
greatcoat as from a bottle. He had that moment been wounded and his
face showed fear rather than suffering. Crossing a road they descended
a steep incline and saw several men lying on the ground; they also met
a crowd of soldiers some of whom were unwounded. The soldiers were
ascending the hill breathing heavily, and despite the general's
presence were talking loudly and gesticulating. In front of them
rows of gray cloaks were already visible through the smoke, and an
officer catching sight of Bagration rushed shouting after the crowd of
retreating soldiers, ordering them back. Bagration rode up to the
ranks along which shots crackled now here and now there, drowning
the sound of voices and the shouts of command. The whole air reeked
with smoke. The excited faces of the soldiers were blackened with
it. Some were using their ramrods, others putting powder on the
touchpans or taking charges from their pouches, while others were
firing, though who they were firing at could not be seen for the smoke
which there was no wind to carry away. A pleasant humming and
whistling of bullets were often heard. "What is this?" thought
Prince Andrew approaching the crowd of soldiers. "It can't be an
attack, for they are not moving; it can't be a square--for they are
not drawn up for that."

The commander of the regiment, a thin, feeble-looking old man with a
pleasant smile--his eyelids drooping more than half over his old eyes,
giving him a mild expression, rode up to Bagration and welcomed him as
a host welcomes an honored guest. He reported that his regiment had
been attacked by French cavalry and that, though the attack had been
repulsed, he had lost more than half his men. He said the attack had
been repulsed, employing this military term to describe what had
occurred to his regiment, but in reality he did not himself know
what had happened during that half-hour to the troops entrusted to
him, and could not say with certainty whether the attack had been
repulsed or his regiment had been broken up. All he knew was that at
the commencement of the action balls and shells began flying all
over his regiment and hitting men and that afterwards someone had
shouted "Cavalry!" and our men had begun firing. They were still
firing, not at the cavalry which had disappeared, but at French
infantry who had come into the hollow and were firing at our men.
Prince Bagration bowed his head as a sign that this was exactly what
he had desired and expected. Turning to his adjutant he ordered him to
bring down the two battalions of the Sixth Chasseurs whom they had
just passed. Prince Andrew was struck by the changed expression on
Prince Bagration's face at this moment. It expressed the
concentrated and happy resolution you see on the face of a man who
on a hot day takes a final run before plunging into the water. The
dull, sleepy expression was no longer there, nor the affectation of
profound thought. The round, steady, hawk's eyes looked before him
eagerly and rather disdainfully, not resting on anything although
his movements were still slow and measured.

The commander of the regiment turned to Prince Bagration, entreating
him to go back as it was too dangerous to remain where they were.
"Please, your excellency, for God's sake!" he kept saying, glancing
for support at an officer of the suite who turned away from him.
"There, you see!" and he drew attention to the bullets whistling,
singing, and hissing continually around them. He spoke in the tone
of entreaty and reproach that a carpenter uses to a gentleman who
has picked up an ax: "We are used to it, but you, sir, will blister
your hands." He spoke as if those bullets could not kill him, and
his half-closed eyes gave still more persuasiveness to his words.
The staff officer joined in the colonel's appeals, but Bagration did
not reply; he only gave an order to cease firing and re-form, so as to
give room for the two approaching battalions. While he was speaking,
the curtain of smoke that had concealed the hollow, driven by a rising
wind, began to move from right to left as if drawn by an invisible
hand, and the hill opposite, with the French moving about on it,
opened out before them. All eyes fastened involuntarily on this French
column advancing against them and winding down over the uneven ground.
One could already see the soldiers' shaggy caps, distinguish the
officers from the men, and see the standard flapping against its
staff.

"They march splendidly," remarked someone in Bagration's suite.

The head of the column had already descended into the hollow. The
clash would take place on this side of it...

The remains of our regiment which had been in action rapidly
formed up and moved to the right; from behind it, dispersing the
laggards, came two battalions of the Sixth Chasseurs in fine order.
Before they had reached Bagration, the weighty tread of the mass of
men marching in step could be heard. On their left flank, nearest to
Bagration, marched a company commander, a fine round-faced man, with a
stupid and happy expression--the same man who had rushed out of the
wattle shed. At that moment he was clearly thinking of nothing but how
dashing a fellow he would appear as he passed the commander.

With the self-satisfaction of a man on parade, he stepped lightly
with his muscular legs as if sailing along, stretching himself to
his full height without the smallest effort, his ease contrasting with
the heavy tread of the soldiers who were keeping step with him. He
carried close to his leg a narrow unsheathed sword (small, curved, and
not like a real weapon) and looked now at the superior officers and
now back at the men without losing step, his whole powerful body
turning flexibly. It was as if all the powers of his soul were
concentrated on passing the commander in the best possible manner, and
feeling that he was doing it well he was happy. "Left... left...
left..." he seemed to repeat to himself at each alternate step; and in
time to this, with stern but varied faces, the wall of soldiers
burdened with knapsacks and muskets marched in step, and each one of
these hundreds of soldiers seemed to be repeating to himself at each
alternate step, "Left... left... left..." A fat major skirted a
bush, puffing and falling out of step; a soldier who had fallen
behind, his face showing alarm at his defection, ran at a trot,
panting to catch up with his company. A cannon ball, cleaving the air,
flew over the heads of Bagration and his suite, and fell into the
column to the measure of "Left... left!" "Close up!" came the
company commander's voice in jaunty tones. The soldiers passed in a
semicircle round something where the ball had fallen, and an old
trooper on the flank, a noncommissioned officer who had stopped beside
the dead men, ran to catch up his line and, falling into step with a
hop, looked back angrily, and through the ominous silence and the
regular tramp of feet beating the ground in unison, one seemed to hear
left... left... left.

"Well done, lads!" said Prince Bagration.

"Glad to do our best, your ex'len-lency!" came a confused shout from
the ranks. A morose soldier marching on the left turned his eyes on
Bagration as he shouted, with an expression that seemed to say: "We
know that ourselves!" Another, without looking round, as though
fearing to relax, shouted with his mouth wide open and passed on.

The order was given to halt and down knapsacks.

Bagration rode round the ranks that had marched past him and
dismounted. He gave the reins to a Cossack, took off and handed over
his felt coat, stretched his legs, and set his cap straight. The
head of the French column, with its officers leading, appeared from
below the hill.

"Forward, with God!" said Bagration, in a resolute, sonorous
voice, turning for a moment to the front line, and slightly swinging
his arms, he went forward uneasily over the rough field with the
awkward gait of a cavalryman. Prince Andrew felt that an invisible
power was leading him forward, and experienced great happiness.

The French were already near. Prince Andrew, walking beside
Bagration, could clearly distinguish their bandoliers, red epaulets,
and even their faces. (He distinctly saw an old French officer who,
with gaitered legs and turned-out toes, climbed the hill with
difficulty.) Prince Bagration gave no further orders and silently
continued to walk on in front of the ranks. Suddenly one shot after
another rang out from the French, smoke appeared all along their
uneven ranks, and musket shots sounded. Several of our men fell, among
them the round-faced officer who had marched so gaily and
complacently. But at the moment the first report was heard,
Bagration looked round and shouted, "Hurrah!"

"Hurrah--ah!--ah!" rang a long-drawn shout from our ranks, and
passing Bagration and racing one another they rushed in an irregular
but joyous and eager crowd down the hill at their disordered foe.





CHAPTER XIX


The attack of the Sixth Chasseurs secured the retreat of our right
flank. In the center Tushin's forgotten battery, which had managed
to set fire to the Schon Grabern village, delayed the French
advance. The French were putting out the fire which the wind was
spreading, and thus gave us time to retreat. The retirement of the
center to the other side of the dip in the ground at the rear was
hurried and noisy, but the different companies did not get mixed.
But our left--which consisted of the Azov and Podolsk infantry and the
Pavlograd hussars--was simultaneously attacked and outflanked by
superior French forces under Lannes and was thrown into confusion.
Bagration had sent Zherkov to the general commanding that left flank
with orders to retreat immediately.

Zherkov, not removing his hand from his cap, turned his horse
about and galloped off. But no sooner had he left Bagration than his
courage failed him. He was seized by panic and could not go where it
was dangerous.

Having reached the left flank, instead of going to the front where
the firing was, he began to look for the general and his staff where
they could not possibly be, and so did not deliver the order.

The command of the left flank belonged by seniority to the commander
of the regiment Kutuzov had reviewed at Braunau and in which
Dolokhov was serving as a private. But the command of the extreme left
flank had been assigned to the commander of the Pavlograd regiment
in which Rostov was serving, and a misunderstanding arose. The two
commanders were much exasperated with one another and, long after
the action had begun on the right flank and the French were already
advancing, were engaged in discussion with the sole object of
offending one another. But the regiments, both cavalry and infantry,
were by no means ready for the impending action. From privates to
general they were not expecting a battle and were engaged in
peaceful occupations, the cavalry feeding the horses and the
infantry collecting wood.

"He higher iss dan I in rank," said the German colonel of the
hussars, flushing and addressing an adjutant who had ridden up, "so
let him do what he vill, but I cannot sacrifice my hussars...
Bugler, sount ze retreat!"

But haste was becoming imperative. Cannon and musketry, mingling
together, thundered on the right and in the center, while the
capotes of Lannes' sharpshooters were already seen crossing the
milldam and forming up within twice the range of a musket shot. The
general in command of the infantry went toward his horse with jerky
steps, and having mounted drew himself up very straight and tall and
rode to the Pavlograd commander. The commanders met with polite bows
but with secret malevolence in their hearts.

"Once again, Colonel," said the general, "I can't leave half my
men in the wood. I beg of you, I beg of you," he repeated, "to
occupy the position and prepare for an attack."

"I peg of you yourself not to mix in vot is not your business!"
suddenly replied the irate colonel. "If you vere in the cavalry..."

"I am not in the cavalry, Colonel, but I am a Russian general and if
you are not aware of the fact..."

"Quite avare, your excellency," suddenly shouted the colonel,
touching his horse and turning purple in the face. "Vill you be so
goot to come to ze front and see dat zis position iss no goot? I don't
vish to destroy my men for your pleasure!"

"You forget yourself, Colonel. I am not considering my own
pleasure and I won't allow it to be said!"

Taking the colonel's outburst as a challenge to his courage, the
general expanded his chest and rode, frowning, beside him to the front
line, as if their differences would be settled there amongst the
bullets. They reached the front, several bullets sped over them, and
they halted in silence. There was nothing fresh to be seen from the
line, for from where they had been before it had been evident that
it was impossible for cavalry to act among the bushes and broken
ground, as well as that the French were outflanking our left. The
general and colonel looked sternly and significantly at one another
like two fighting cocks preparing for battle, each vainly trying to
detect signs of cowardice in the other. Both passed the examination
successfully. As there was nothing to said, and neither wished to give
occasion for it to be alleged that he had been the first to leave
the range of fire, they would have remained there for a long time
testing each other's courage had it not been that just then they heard
the rattle of musketry and a muffled shout almost behind them in the
wood. The French had attacked the men collecting wood in the copse. It
was no longer possible for the hussars to retreat with the infantry.
They were cut off from the line of retreat on the left by the
French. However inconvenient the position, it was now necessary to
attack in order to cut away through for themselves.

The squadron in which Rostov was serving had scarcely time to
mount before it was halted facing the enemy. Again, as at the Enns
bridge, there was nothing between the squadron and the enemy, and
again that terrible dividing line of uncertainty and fear-
resembling the line separating the living from the dead--lay between
them. All were conscious of this unseen line, and the question whether
they would cross it or not, and how they would cross it,
agitated them all.

The colonel rode to the front, angrily gave some reply to
questions put to him by the officers, and, like a man desperately
insisting on having his own way, gave an order. No one said anything
definite, but the rumor of an attack spread through the squadron.
The command to form up rang out and the sabers whizzed as they were
drawn from their scabbards. Still no one moved. The troops of the left
flank, infantry and hussars alike, felt that the commander did not
himself know what to do, and this irresolution communicated itself
to the men.

"If only they would be quick!" thought Rostov, feeling that at
last the time had come to experience the joy of an attack of which
he had so often heard from his fellow hussars.

"Fo'ward, with God, lads!" rang out Denisov's voice. "At a twot
fo'ward!"

The horses' croups began to sway in the front line. Rook pulled at
the reins and started of his own accord.

Before him, on the right, Rostov saw the front lines of his
hussars and still farther ahead a dark line which he could not see
distinctly but took to be the enemy. Shots could be heard, but some
way off.

"Faster!" came the word of command, and Rostov felt Rook's flanks
drooping as he broke into a gallop.

Rostov anticipated his horse's movements and became more and more
elated. He had noticed a solitary tree ahead of him. This tree had
been in the middle of the line that had seemed so terrible--and now he
had crossed that line and not only was there nothing terrible, but
everything was becoming more and more happy and animated. "Oh, how I
will slash at him!" thought Rostov, gripping the hilt of his saber.

"Hur-a-a-a-ah!" came a roar of voices. "Let anyone come my way now,"
thought Rostov driving his spurs into Rook and letting him go at a
full gallop so that he outstripped the others. Ahead, the enemy was
already visible. Suddenly something like a birch broom seemed to sweep
over the squadron. Rostov raised his saber, ready to strike, but at
that instant the trooper Nikitenko, who was galloping ahead, shot away
from him, and Rostov felt as in a dream that he continued to be
carried forward with unnatural speed but yet stayed on the same
spot. From behind him Bondarchuk, an hussar he knew, jolted against
him and looked angrily at him. Bondarchuk's horse swerved and galloped
past.

"How is it I am not moving? I have fallen, I am killed!" Rostov
asked and answered at the same instant. He was alone in the middle
of a field. Instead of the moving horses and hussars' backs, he saw
nothing before him but the motionless earth and the stubble around
him. There was warm blood under his arm. "No, I am wounded and the
horse is killed." Rook tried to rise on his forelegs but fell back,
pinning his rider's leg. Blood was flowing from his head; he struggled
but could not rise. Rostov also tried to rise but fell back, his
sabretache having become entangled in the saddle. Where our men
were, and where the French, he did not know. There was no one near.

Having disentangled his leg, he rose. "Where, on which side, was now
the line that had so sharply divided the two armies?" he asked himself
and could not answer. "Can something bad have happened to me?" he
wondered as he got up: and at that moment he felt that something
superfluous was hanging on his benumbed left arm. The wrist felt as if
it were not his. He examined his hand carefully, vainly trying to find
blood on it. "Ah, here are people coming," he thought joyfully, seeing
some men running toward him. "They will help me!" In front came a
man wearing a strange shako and a blue cloak, swarthy, sunburned,
and with a hooked nose. Then came two more, and many more running
behind. One of them said something strange, not in Russian. In among
the hindmost of these men wearing similar shakos was a Russian hussar.
He was being held by the arms and his horse was being led behind him.

"It must be one of ours, a prisoner. Yes. Can it be that they will
take me too? Who are these men?" thought Rostov, scarcely believing
his eyes. "Can they be French?" He looked at the approaching
Frenchmen, and though but a moment before he had been galloping to get
at them and hack them to pieces, their proximity now seemed so awful
that he could not believe his eyes. "Who are they? Why are they
running? Can they be coming at me? And why? To kill me? Me whom
everyone is so fond of?" He remembered his mother's love for him,
and his family's, and his friends', and the enemy's intention to
kill him seemed impossible. "But perhaps they may do it!" For more
than ten seconds he stood not moving from the spot or realizing the
situation. The foremost Frenchman, the one with the hooked nose, was
already so close that the expression of his face could be seen. And
the excited, alien face of that man, his bayonet hanging down, holding
his breath, and running so lightly, frightened Rostov. He seized his
pistol and, instead of firing it, flung it at the Frenchman and ran
with all his might toward the bushes. He did not now run with the
feeling of doubt and conflict with which he had trodden the Enns
bridge, but with the feeling of a hare fleeing from the hounds. One
single sentiment, that of fear for his young and happy life, possessed
his whole being. Rapidly leaping the furrows, he fled across the field
with the impetuosity he used to show at catchplay, now and then
turning his good-natured, pale, young face to look back. A shudder
of terror went through him: "No, better not look," he thought, but
having reached the bushes he glanced round once more. The French had
fallen behind, and just as he looked round the first man changed his
run to a walk and, turning, shouted something loudly to a comrade
farther back. Rostov paused. "No, there's some mistake," thought he.
"They can't have wanted to kill me." But at the same time, his left
arm felt as heavy as if a seventy-pound weight were tied to it. He
could run no more. The Frenchman also stopped and took aim. Rostov
closed his eyes and stooped down. One bullet and then another whistled
past him. He mustered his last remaining strength, took hold of his
left hand with his right, and reached the bushes. Behind these were
some Russian sharpshooters.





CHAPTER XX


The infantry regiments that had been caught unawares in the
outskirts of the wood ran out of it, the different companies getting
mixed, and retreated as a disorderly crowd. One soldier, in his
fear, uttered the senseless cry, "Cut off!" that is so terrible in
battle, and that word infected the whole crowd with a feeling of
panic.

"Surrounded! Cut off? We're lost!" shouted the fugitives.

The moment he heard the firing and the cry from behind, the
general realized that something dreadful had happened to his regiment,
and the thought that he, an exemplary officer of many years' service
who had never been to blame, might be held responsible at headquarters
for negligence or inefficiency so staggered him that, forgetting the
recalcitrant cavalry colonel, his own dignity as a general, and
above all quite forgetting the danger and all regard for
self-preservation, he clutched the crupper of his saddle and, spurring
his horse, galloped to the regiment under a hail of bullets which fell
around, but fortunately missed him. His one desire was to know what
was happening and at any cost correct, or remedy, the mistake if he
had made one, so that he, an exemplary officer of twenty-two years'
service, who had never been censured, should not be held to blame.

Having galloped safely through the French, he reached a field behind
the copse across which our men, regardless of orders, were running and
descending the valley. That moment of moral hesitation which decides
the fate of battles had arrived. Would this disorderly crowd of
soldiers attend to the voice of their commander, or would they,
disregarding him, continue their flight? Despite his desperate
shouts that used to seem so terrible to the soldiers, despite his
furious purple countenance distorted out of all likeness to his former
self, and the flourishing of his saber, the soldiers all continued
to run, talking, firing into the air, and disobeying orders. The moral
hesitation which decided the fate of battles was evidently culminating
in a panic.

The general had a fit of coughing as a result of shouting and of the
powder smoke and stopped in despair. Everything seemed lost. But at
that moment the French who were attacking, suddenly and without any
apparent reason, ran back and disappeared from the outskirts, and
Russian sharpshooters showed themselves in the copse. It was
Timokhin's company, which alone had maintained its order in the wood
and, having lain in ambush in a ditch, now attacked the French
unexpectedly. Timokhin, armed only with a sword, had rushed at the
enemy with such a desperate cry and such mad, drunken determination
that, taken by surprise, the French had thrown down their muskets
and run. Dolokhov, running beside Timokhin, killed a Frenchman at
close quarters and was the first to seize the surrendering French
officer by his collar. Our fugitives returned, the battalions
re-formed, and the French who had nearly cut our left flank in half
were for the moment repulsed. Our reserve units were able to join
up, and the fight was at an end. The regimental commander and Major
Ekonomov had stopped beside a bridge, letting the retreating companies
pass by them, when a soldier came up and took hold of the
commander's stirrup, almost leaning against him. The man was wearing a
bluish coat of broadcloth, he had no knapsack or cap, his head was
bandaged, and over his shoulder a French munition pouch was slung.
He had an officer's sword in his hand. The soldier was pale, his
blue eyes looked impudently into the commander's face, and his lips
were smiling. Though the commander was occupied in giving instructions
to Major Ekonomov, he could not help taking notice of the soldier.

"Your excellency, here are two trophies," said Dolokhov, pointing to
the French sword and pouch. "I have taken an officer prisoner. I
stopped the company." Dolokhov breathed heavily from weariness and
spoke in abrupt sentences. "The whole company can bear witness. I
beg you will remember this, your excellency!"

"All right, all right," replied the commander, and turned to Major
Ekonomov.

But Dolokhov did not go away; he untied the handkerchief around
his head, pulled it off, and showed the blood congealed on his hair.

"A bayonet wound. I remained at the front. Remember, your
excellency!"


Tushin's battery had been forgotten and only at the very end of
the action did Prince Bagration, still hearing the cannonade in the
center, send his orderly staff officer, and later Prince Andrew
also, to order the battery to retire as quickly as possible. When
the supports attached to Tushin's battery had been moved away in the
middle of the action by someone's order, the battery had continued
firing and was only not captured by the French because the enemy could
not surmise that anyone could have the effrontery to continue firing
from four quite undefended guns. On the contrary, the energetic action
of that battery led the French to suppose that here--in the center-
the main Russian forces were concentrated. Twice they had attempted to
attack this point, but on each occasion had been driven back by
grapeshot from the four isolated guns on the hillock.

Soon after Prince Bagration had left him, Tushin had succeeded in
setting fire to Schon Grabern.

"Look at them scurrying! It's burning! Just see the smoke! Fine!
Grand! Look at the smoke, the smoke!" exclaimed the artillerymen,
brightening up.

All the guns, without waiting for orders, were being fired in the
direction of the conflagration. As if urging each other on, the
soldiers cried at each shot: "Fine! That's good! Look at it... Grand!"
The fire, fanned by the breeze, was rapidly spreading. The French
columns that had advanced beyond the village went back; but as
though in revenge for this failure, the enemy placed ten guns to the
right of the village and began firing them at Tushin's battery.

In their childlike glee, aroused by the fire and their luck in
successfully cannonading the French, our artillerymen only noticed
this battery when two balls, and then four more, fell among our
guns, one knocking over two horses and another tearing off a
munition-wagon driver's leg. Their spirits once roused were,
however, not diminished, but only changed character. The horses were
replaced by others from a reserve gun carriage, the wounded were
carried away, and the four guns were turned against the ten-gun
battery. Tushin's companion officer had been killed at the beginning
of the engagement and within an hour seventeen of the forty men of the
guns' crews had been disabled, but the artillerymen were still as
merry and lively as ever. Twice they noticed the French appearing
below them, and then they fired grapeshot at them.

Little Tushin, moving feebly and awkwardly, kept telling his orderly
to "refill my pipe for that one!" and then, scattering sparks from it,
ran forward shading his eyes with his small hand to look at the
French.

"Smack at 'em, lads!" he kept saying, seizing the guns by the wheels
and working the screws himself.

Amid the smoke, deafened by the incessant reports which always
made him jump, Tushin not taking his pipe from his mouth ran from
gun to gun, now aiming, now counting the charges, now giving orders
about replacing dead or wounded horses and harnessing fresh ones,
and shouting in his feeble voice, so high pitched and irresolute.
His face grew more and more animated. Only when a man was killed or
wounded did he frown and turn away from the sight, shouting angrily at
the men who, as is always the case, hesitated about lifting the
injured or dead. The soldiers, for the most part handsome fellows and,
as is always the case in an artillery company, a head and shoulders
taller and twice as broad as their officer--all looked at their
commander like children in an embarrassing situation, and the
expression on his face was invariably reflected on theirs.

Owing to the terrible uproar and the necessity for concentration and
activity, Tushin did not experience the slightest unpleasant sense
of fear, and the thought that he might be killed or badly wounded
never occurred to him. On the contrary, he became more and more
elated. It seemed to him that it was a very long time ago, almost a
day, since he had first seen the enemy and fired the first shot, and
that the corner of the field he stood on was well-known and familiar
ground. Though he thought of everything, considered everything, and
did everything the best of officers could do in his position, he was
in a state akin to feverish delirium or drunkenness.

From the deafening sounds of his own guns around him, the whistle
and thud of the enemy's cannon balls, from the flushed and
perspiring faces of the crew bustling round the guns, from the sight
of the blood of men and horses, from the little puffs of smoke on
the enemy's side (always followed by a ball flying past and striking
the earth, a man, a gun, a horse), from the sight of all these
things a fantastic world of his own had taken possession of his
brain and at that moment afforded him pleasure. The enemy's guns
were in his fancy not guns but pipes from which occasional puffs
were blown by an invisible smoker.

"There... he's puffing again," muttered Tushin to himself, as a
small cloud rose from the hill and was borne in a streak to the left
by the wind.

"Now look out for the ball... we'll throw it back."

"What do you want, your honor?" asked an artilleryman, standing
close by, who heard him muttering.

"Nothing... only a shell..." he answered.

"Come along, our Matvevna!" he said to himself. "Matvevna"* was
the name his fancy gave to the farthest gun of the battery, which
was large and of an old pattern. The French swarming round their
guns seemed to him like ants. In that world, the handsome drunkard
Number One of the second gun's crew was "uncle"; Tushin looked at
him more often than at anyone else and took delight in his every
movement. The sound of musketry at the foot of the hill, now
diminishing, now increasing, seemed like someone's breathing. He
listened intently to the ebb and flow of these sounds.


*Daughter of Matthew.


"Ah! Breathing again, breathing!" he muttered to himself.

He imagined himself as an enormously tall, powerful man who was
throwing cannon balls at the French with both hands.

"Now then, Matvevna, dear old lady, don't let me down!" he was
saying as he moved from the gun, when a strange, unfamiliar voice
called above his head: "Captain Tushin! Captain!"

Tushin turned round in dismay. It was the staff officer who had
turned him out of the booth at Grunth. He was shouting in a gasping
voice:

"Are you mad? You have twice been ordered to retreat, and you..."

"Why are they down on me?" thought Tushin, looking in alarm at his
superior.

"I... don't..." he muttered, holding up two fingers to his cap.
"I..."

But the staff officer did not finish what he wanted to say. A cannon
ball, flying close to him, caused him to duck and bend over his horse.
He paused, and just as he was about to say something more, another
ball stopped him. He turned his horse and galloped off.

"Retire! All to retire!" he shouted from a distance.

The soldiers laughed. A moment later, an adjutant arrived with the
same order.

It was Prince Andrew. The first thing he saw on riding up to the
space where Tushin's guns were stationed was an unharnessed horse with
a broken leg, that lay screaming piteously beside the harnessed
horses. Blood was gushing from its leg as from a spring. Among the
limbers lay several dead men. One ball after another passed over as he
approached and he felt a nervous shudder run down his spine. But the
mere thought of being afraid roused him again. "I cannot be afraid,"
thought he, and dismounted slowly among the guns. He delivered the
order and did not leave the battery. He decided to have the guns
removed from their positions and withdrawn in his presence. Together
with Tushin, stepping across the bodies and under a terrible fire from
the French, he attended to the removal of the guns.

"A staff officer was here a minute ago, but skipped off," said an
artilleryman to Prince Andrew. "Not like your honor!"

Prince Andrew said nothing to Tushin. They were both so busy as to
seem not to notice one another. When having limbered up the only two
cannon that remained uninjured out of the four, they began moving down
the hill (one shattered gun and one unicorn were left behind),
Prince Andrew rode up to Tushin.

"Well, till we meet again..." he said, holding out his hand to
Tushin.

"Good-by, my dear fellow," said Tushin. "Dear soul! Good-by, my dear
fellow!" and for some unknown reason tears suddenly filled his eyes.





CHAPTER XXI


The wind had fallen and black clouds, merging with the powder smoke,
hung low over the field of battle on the horizon. It was growing
dark and the glow of two conflagrations was the more conspicuous.
The cannonade was dying down, but the rattle of musketry behind and on
the right sounded oftener and nearer. As soon as Tushin with his guns,
continually driving round or coming upon wounded men, was out of range
of fire and had descended into the dip, he was met by some of the
staff, among them the staff officer and Zherkov, who had been twice
sent to Tushin's battery but had never reached it. Interrupting one
another, they all gave, and transmitted, orders as to how to
proceed, reprimanding and reproaching him. Tushin gave no orders, and,
silently--fearing to speak because at every word he felt ready to weep
without knowing why--rode behind on his artillery nag. Though the
orders were to abandon the wounded, many of them dragged themselves
after troops and begged for seats on the gun carriages. The jaunty
infantry officer who just before the battle had rushed out of Tushin's
wattle shed was laid, with a bullet in his stomach, on "Matvevna's"
carriage. At the foot of the hill, a pale hussar cadet, supporting one
hand with the other, came up to Tushin and asked for a seat.

"Captain, for God's sake! I've hurt my arm," he said timidly. "For
God's sake... I can't walk. For God's sake!"

It was plain that this cadet had already repeatedly asked for a lift
and been refused. He asked in a hesitating, piteous voice.

"Tell them to give me a seat, for God's sake!"

"Give him a seat," said Tushin. "Lay a cloak for him to sit on,
lad," he said, addressing his favorite soldier. "And where is the
wounded officer?"

"He has been set down. He died," replied someone.

"Help him up. Sit down, dear fellow, sit down! Spread out the cloak,
Antonov."

The cadet was Rostov. With one hand he supported the other; he was
pale and his jaw trembled, shivering feverishly. He was placed on
"Matvevna," the gun from which they had removed the dead officer.
The cloak they spread under him was wet with blood which stained his
breeches and arm.

"What, are you wounded, my lad?" said Tushin, approaching the gun on
which Rostov sat.

"No, it's a sprain."

"Then what is this blood on the gun carriage?" inquired Tushin.

"It was the officer, your honor, stained it," answered the
artilleryman, wiping away the blood with his coat sleeve, as if
apologizing for the state of his gun.

It was all that they could do to get the guns up the rise aided by
the infantry, and having reached the village of Gruntersdorf they
halted. It had grown so dark that one could not distinguish the
uniforms ten paces off, and the firing had begun to subside. Suddenly,
near by on the right, shouting and firing were again heard. Flashes of
shot gleamed in the darkness. This was the last French attack and
was met by soldiers who had sheltered in the village houses. They
all rushed out of the village again, but Tushin's guns could not move,
and the artillerymen, Tushin, and the cadet exchanged silent glances
as they awaited their fate. The firing died down and soldiers, talking
eagerly, streamed out of a side street.

"Not hurt, Petrov?" asked one.

"We've given it 'em hot, mate! They won't make another push now,"
said another.

"You couldn't see a thing. How they shot at their own fellows!
Nothing could be seen. Pitch-dark, brother! Isn't there something to
drink?"

The French had been repulsed for the last time. And again and
again in the complete darkness Tushin's guns moved forward, surrounded
by the humming infantry as by a frame.

In the darkness, it seemed as though a gloomy unseen river was
flowing always in one direction, humming with whispers and talk and
the sound of hoofs and wheels. Amid the general rumble, the groans and
voices of the wounded were more distinctly heard than any other
sound in the darkness of the night. The gloom that enveloped the
army was filled with their groans, which seemed to melt into one
with the darkness of the night. After a while the moving mass became
agitated, someone rode past on a white horse followed by his suite,
and said something in passing: "What did he say? Where to, now?
Halt, is it? Did he thank us?" came eager questions from all sides.
The whole moving mass began pressing closer together and a report
spread that they were ordered to halt: evidently those in front had
halted. All remained where they were in the middle of the muddy road.

Fires were lighted and the talk became more audible. Captain Tushin,
having given orders to his company, sent a soldier to find a
dressing station or a doctor for the cadet, and sat down by a
bonfire the soldiers had kindled on the road. Rostov, too, dragged
himself to the fire. From pain, cold, and damp, a feverish shivering
shook his whole body. Drowsiness was irresistibly mastering him, but
he kept awake by an excruciating pain in his arm, for which
he could find no satisfactory position. He kept closing his eyes and
then again looking at the fire, which seemed to him dazzlingly red,
and at the feeble, round-shouldered figure of Tushin who was sitting
cross-legged like a Turk beside him. Tushin's large, kind, intelligent
eyes were fixed with sympathy and commiseration on Rostov, who saw
that Tushin with his whole heart wished to help him but could not.

From all sides were heard the footsteps and talk of the infantry,
who were walking, driving past, and settling down all around. The
sound of voices, the tramping feet, the horses' hoofs moving in mud,
the crackling of wood fires near and afar, merged into one tremulous
rumble.

It was no longer, as before, a dark, unseen river flowing through
the gloom, but a dark sea swelling and gradually subsiding after a
storm. Rostov looked at and listened listlessly to what passed
before and around him. An infantryman came to the fire, squatted on
his heels, held his hands to the blaze, and turned away his face.

"You don't mind your honor?" he asked Tushin. "I've lost my company,
your honor. I don't know where... such bad luck!"

With the soldier, an infantry officer with a bandaged cheek came
up to the bonfire, and addressing Tushin asked him to have the guns
moved a trifle to let a wagon go past. After he had gone, two soldiers
rushed to the campfire. They were quarreling and fighting desperately,
each trying to snatch from the other a boot they were both holding
on to.

"You picked it up?... I dare say! You're very smart!" one of them
shouted hoarsely.

Then a thin, pale soldier, his neck bandaged with a bloodstained leg
band, came up and in angry tones asked the artillerymen for water.

"Must one die like a dog?" said he.

Tushin told them to give the man some water. Then a cheerful soldier
ran up, begging a little fire for the infantry.

"A nice little hot torch for the infantry! Good luck to you,
fellow countrymen. Thanks for the fire--we'll return it with
interest," said he, carrying away into the darkness a glowing stick.

Next came four soldiers, carrying something heavy on a cloak, and
passed by the fire. One of them stumbled.

"Who the devil has put the logs on the road?" snarled he.

"He's dead--why carry him?" said another.

"Shut up!"

And they disappeared into the darkness with with their load.

"Still aching?" Tushin asked Rostov in a whisper.

"Yes."

"Your honor, you're wanted by the general. He is in the hut here,"
said a gunner, coming up to Tushin.

"Coming, friend."

Tushin rose and, buttoning his greatcoat and pulling it straight,
walked away from the fire.

Not far from the artillery campfire, in a hut that had been prepared
for him, Prince Bagration sat at dinner, talking with some
commanding officers who had gathered at his quarters. The little old
man with the half-closed eyes was there greedily gnawing a mutton
bone, and the general who had served blamelessly for twenty-two years,
flushed by a glass of vodka and the dinner; and the staff officer with
the signet ring, and Zherkov, uneasily glancing at them all, and
Prince Andrew, pale, with compressed lips and feverishly glittering
eyes.

In a corner of the hut stood a standard captured from the French,
and the accountant with the naive face was feeling its texture,
shaking his head in perplexity--perhaps because the banner really
interested him, perhaps because it was hard for him, hungry as he was,
to look on at a dinner where there was no place for him. In the next
hut there was a French colonel who had been taken prisoner by our
dragoons. Our officers were flocking in to look at him. Prince
Bagration was thanking the individual commanders and inquiring into
details of the action and our losses. The general whose regiment had
been inspected at Braunau was informing the prince that as soon as the
action began he had withdrawn from the wood, mustered the men who were
woodcutting, and, allowing the French to pass him, had made a
bayonet charge with two battalions and had broken up the French
troops.

"When I saw, your excellency, that their first battalion was
disorganized, I stopped in the road and thought: 'I'll let them come
on and will meet them with the fire of the whole battalion'--and
that's what I did."

The general had so wished to do this and was so sorry he had not
managed to do it that it seemed to him as if it had really happened.
Perhaps it might really have been so? Could one possibly make out amid
all that confusion what did or did not happen?

"By the way, your excellency, I should inform you," he continued-
remembering Dolokhov's conversation with Kutuzov and his last
interview with the gentleman-ranker--"that Private Dolokhov, who was
reduced to the ranks, took a French officer prisoner in my presence
and particularly distinguished himself."

"I saw the Pavlograd hussars attack there, your excellency,"
chimed in Zherkov, looking uneasily around. He had not seen the
hussars all that day, but had heard about them from an infantry
officer. "They broke up two squares, your excellency."

Several of those present smiled at Zherkov's words, expecting one of
his usual jokes, but noticing that what he was saying redounded to the
glory of our arms and of the day's work, they assumed a serious
expression, though many of them knew that what he was saying was a lie
devoid of any foundation. Prince Bagration turned to the old colonel:

"Gentlemen, I thank you all; all arms have behaved heroically:
infantry, cavalry, and artillery. How was it that two guns were
abandoned in the center?" he inquired, searching with his eyes for
someone. (Prince Bagration did not ask about the guns on the left
flank; he knew that all the guns there had been abandoned at the
very beginning of the action.) "I think I sent you?" he added, turning
to the staff officer on duty.

"One was damaged," answered the staff officer, "and the other I
can't understand. I was there all the time giving orders and had
only just left.... It is true that it was hot there," he added,
modestly.

Someone mentioned that Captain Tushin was bivouacking close to the
village and had already been sent for.

"Oh, but you were there?" said Prince Bagration, addressing Prince
Andrew.

"Of course, we only just missed one another," said the staff
officer, with a smile to Bolkonski.

"I had not the pleasure of seeing you," said Prince Andrew, coldly
and abruptly.

All were silent. Tushin appeared at the threshold and made his way
timidly from behind the backs of the generals. As he stepped past
the generals in the crowded hut, feeling embarrassed as he always
was by the sight of his superiors, he did not notice the staff of
the banner and stumbled over it. Several of those present laughed.

"How was it a gun was abandoned?" asked Bagration, frowning, not
so much at the captain as at those who were laughing, among whom
Zherkov laughed loudest.

Only now, when he was confronted by the stern authorities, did his
guilt and the disgrace of having lost two guns and yet remaining alive
present themselves to Tushin in all their horror. He had been so
excited that he had not thought about it until that moment. The
officers' laughter confused him still more. He stood before
Bagration with his lower jaw trembling and was hardly able to
mutter: "I don't know... your excellency... I had no men... your
excellency."

"You might have taken some from the covering troops."

Tushin did not say that there were no covering troops, though that
was perfectly true. He was afraid of getting some other officer into
trouble, and silently fixed his eyes on Bagration as a schoolboy who
has blundered looks at an examiner.

The silence lasted some time. Prince Bagration, apparently not
wishing to be severe, found nothing to say; the others did not venture
to intervene. Prince Andrew looked at Tushin from under his brows
and his fingers twitched nervously.

"Your excellency!" Prince Andrew broke the silence with his abrupt
voice," you were pleased to send me to Captain Tushin's battery. I
went there and found two thirds of the men and horses knocked out, two
guns smashed, and no supports at all."

Prince Bagration and Tushin looked with equal intentness at
Bolkonski, who spoke with suppressed agitation.

"And, if your excellency will allow me to express my opinion," he
continued, "we owe today's success chiefly to the action of that
battery and the heroic endurance of Captain Tushin and his company,"
and without awaiting a reply, Prince Andrew rose and left the table.

Prince Bagration looked at Tushin, evidently reluctant to show
distrust in Bolkonski's emphatic opinion yet not feeling able fully to
credit it, bent his head, and told Tushin that he could go. Prince
Andrew went out with him.

"Thank you; you saved me, my dear fellow!" said Tushin.

Prince Andrew gave him a look, but said nothing and went away. He
felt sad and depressed. It was all so strange, so unlike what he had
hoped.


"Who are they? Why are they here? What do they want? And when will
all this end?" thought Rostov, looking at the changing shadows
before him. The pain in his arm became more and more intense.
Irresistible drowsiness overpowered him, red rings danced before his
eyes, and the impression of those voices and faces and a sense of
loneliness merged with the physical pain. It was they, these soldiers-
wounded and unwounded--it was they who were crushing, weighing down,
and twisting the sinews and scorching the flesh of his sprained arm
and shoulder. To rid himself of them he closed his eyes.

For a moment he dozed, but in that short interval innumerable things
appeared to him in a dream: his mother and her large white hand,
Sonya's thin little shoulders, Natasha's eyes and laughter, Denisov
with his voice and mustache, and Telyanin and all that affair with
Telyanin and Bogdanich. That affair was the same thing as this soldier
with the harsh voice, and it was that affair and this soldier that
were so agonizingly, incessantly pulling and pressing his arm and
always dragging it in one direction. He tried to get away from them,
but they would not for an instant let his shoulder move a hair's
breadth. It would not ache--it would be well--if only they did not
pull it, but it was impossible to get rid of them.

He opened his eyes and looked up. The black canopy of night hung
less than a yard above the glow of the charcoal. Flakes of falling
snow were fluttering in that light. Tushin had not returned, the
doctor had not come. He was alone now, except for a soldier who was
sitting naked at the other side of the fire, warming his thin yellow
body.

"Nobody wants me!" thought Rostov. "There is no one to help me or
pity me. Yet I was once at home, strong, happy, and loved." He
sighed and, doing so, groaned involuntarily.

"Eh, is anything hurting you?" asked the soldier, shaking his
shirt out over the fire, and not waiting for an answer he gave a grunt
and added: "What a lot of men have been crippled today--frightful!"

Rostov did not listen to the soldier. He looked at the snowflakes
fluttering above the fire and remembered a Russian winter at his warm,
bright home, his fluffy fur coat, his quickly gliding sleigh, his
healthy body, and all the affection and care of his family. "And why
did I come here?" he wondered.

Next day the French army did not renew their attack, and the remnant
of Bagration's detachment was reunited to Kutuzov's army.




BOOK THREE: 1805





CHAPTER I


Prince Vasili was not a man who deliberately thought out his
plans. Still less did he think of injuring anyone for his own
advantage. He was merely a man of the world who had got on and to whom
getting on had become a habit. Schemes and devices for which he
never rightly accounted to himself, but which formed the whole
interest of his life, were constantly shaping themselves in his
mind, arising from the circumstances and persons he met. Of these
plans he had not merely one or two in his head but dozens, some only
beginning to form themselves, some approaching achievement, and some
in course of disintegration. He did not, for instance, say to himself:
"This man now has influence, I must gain his confidence and friendship
and through him obtain a special grant." Nor did he say to himself:
"Pierre is a rich man, I must entice him to marry my daughter and lend
me the forty thousand rubles I need." But when he came across
a man of position his instinct immediately told him that this
man could be useful, and without any premeditation Prince Vasili
took the first opportunity to gain his confidence, flatter him, become
intimate with him, and finally make his request.

He had Pierre at hand in Moscow and procured for him an
appointment as Gentleman of the Bedchamber, which at that time
conferred the status of Councilor of State, and insisted on the
young man accompanying him to Petersburg and staying at his house.
With apparent absent-mindedness, yet with unhesitating assurance
that he was doing the right thing, Prince Vasili did everything to get
Pierre to marry his daughter. Had he thought out his plans
beforehand he could not have been so natural and shown such unaffected
familiarity in intercourse with everybody both above and below him
in social standing. Something always drew him toward those richer
and more powerful than himself and he had rare skill in seizing the
most opportune moment for making use of people.

Pierre, on unexpectedly becoming Count Bezukhov and a rich man, felt
himself after his recent loneliness and freedom from cares so beset
and preoccupied that only in bed was he able to be by himself. He
had to sign papers, to present himself at government offices, the
purpose of which was not clear to him, to question his chief
steward, to visit his estate near Moscow, and to receive many people
who formerly did not even wish to know of his existence but would
now have been offended and grieved had he chosen not to see them.
These different people--businessmen, relations, and acquaintances
alike--were all disposed to treat the young heir in the most
friendly and flattering manner: they were all evidently firmly
convinced of Pierre's noble qualities. He was always hearing such
words as: "With your remarkable kindness," or, "With your excellent
heart," "You are yourself so honorable Count," or, "Were he as
clever as you," and so on, till he began sincerely to believe in his
own exceptional kindness and extraordinary intelligence, the more so
as in the depth of his heart it had always seemed to him that he
really was very kind and intelligent. Even people who had formerly
been spiteful toward him and evidently unfriendly now became gentle
and affectionate. The angry eldest princess, with the long waist and
hair plastered down like a doll's, had come into Pierre's room after
the funeral. With drooping eyes and frequent blushes she told him
she was very sorry about their past misunderstandings and did not
now feel she had a right to ask him for anything, except only for
permission, after the blow she had received, to remain for a few weeks
longer in the house she so loved and where she had sacrificed so much.
She could not refrain from weeping at these words. Touched that this
statuesque princess could so change, Pierre took her hand and begged
her forgiveness, without knowing what for. From that day the eldest
princess quite changed toward Pierre and began knitting a striped
scarf for him.

"Do this for my sake, mon cher; after all, she had to put up with
a great deal from the deceased," said Prince Vasili to him, handing
him a deed to sign for the princess' benefit.

Prince Vasili had come to the conclusion that it was necessary to
throw this bone--a bill for thirty thousand rubles--to the poor
princess that it might not occur to her to speak of his share in the
affair of the inlaid portfolio. Pierre signed the deed and after
that the princess grew still kinder. The younger sisters also became
affectionate to him, especially the youngest, the pretty one with
the mole, who often made him feel confused by her smiles and her own
confusion when meeting him.

It seemed so natural to Pierre that everyone should like him, and it
would have seemed so unnatural had anyone disliked him, that he
could not but believe in the sincerity of those around him. Besides,
he had no time to ask himself whether these people were sincere or
not. He was always busy and always felt in a state of mild and
cheerful intoxication. He felt as though he were the center of some
important and general movement; that something was constantly expected
of him, that if he did not do it he would grieve and disappoint many
people, but if he did this and that, all would be well; and he did
what was demanded of him, but still that happy result always
remained in the future.

More than anyone else, Prince Vasili took possession of Pierre's
affairs and of Pierre himself in those early days. From the death of
Count Bezukhov he did not let go his hold of the lad. He had the air
of a man oppressed by business, weary and suffering, who yet would
not, for pity's sake, leave this helpless youth who, after all, was
the son of his old friend and the possessor of such enormous wealth,
to the caprice of fate and the designs of rogues. During the few
days he spent in Moscow after the death of Count Bezukhov, he would
call Pierre, or go to him himself, and tell him what ought to be
done in a tone of weariness and assurance, as if he were adding
every time: "You know I am overwhelmed with business and it is
purely out of charity that I trouble myself about you, and you also
know quite well that what I propose is the only thing possible."

"Well, my dear fellow, tomorrow we are off at last," said Prince
Vasili one day, closing his eyes and fingering Pierre's elbow,
speaking as if he were saying something which had long since been
agreed upon and could not now be altered. "We start tomorrow and I'm
giving you a place in my carriage. I am very glad. All our important
business here is now settled, and I ought to have been off long ago.
Here is something I have received from the chancellor. I asked him for
you, and you have been entered in the diplomatic corps and made a
Gentleman of the Bedchamber. The diplomatic career now lies open
before you."

Notwithstanding the tone of wearied assurance with which these words
were pronounced, Pierre, who had so long been considering his
career, wished to make some suggestion. But Prince Vasili
interrupted him in the special deep cooing tone, precluding the
possibility of interrupting his speech, which he used in extreme cases
when special persuasion was needed.

"Mais, mon cher, I did this for my own sake, to satisfy my
conscience, and there is nothing to thank me for. No one has ever
complained yet of being too much loved; and besides, you are free, you
could throw it up tomorrow. But you will see everything for yourself
when you get to Petersburg. It is high time for you to get away from
these terrible recollections." Prince Vasili sighed. "Yes, yes, my
boy. And my valet can go in your carriage. Ah! I was nearly
forgetting," he added. "You know, mon cher, your father and I had some
accounts to settle, so I have received what was due from the Ryazan
estate and will keep it; you won't require it. We'll go into the
accounts later."

By "what was due from the Ryazan estate" Prince Vasili meant several
thousand rubles quitrent received from Pierre's peasants, which the
prince had retained for himself.

In Petersburg, as in Moscow, Pierre found the same atmosphere of
gentleness and affection. He could not refuse the post, or rather
the rank (for he did nothing), that Prince Vasili had procured for
him, and acquaintances, invitations, and social occupations were so
numerous that, even more than in Moscow, he felt a sense of
bewilderment, bustle, and continual expectation of some good, always
in front of him but never attained.

Of his former bachelor acquaintances many were no longer in
Petersburg. The Guards had gone to the front; Dolokhov had been
reduced to the ranks; Anatole was in the army somewhere in the
provinces; Prince Andrew was abroad; so Pierre had not the opportunity
to spend his nights as he used to like to spend them, or to open his
mind by intimate talks with a friend older than himself and whom he
respected. His whole time was taken up with dinners and balls and
was spent chiefly at Prince Vasili's house in the company of the stout
princess, his wife, and his beautiful daughter Helene.

Like the others, Anna Pavlovna Scherer showed Pierre the change of
attitude toward him that had taken place in society.

Formerly in Anna Pavlovna's presence, Pierre had always felt that
what he was saying was out of place, tactless and unsuitable, that
remarks which seemed to him clever while they formed in his mind
became foolish as soon as he uttered them, while on the contrary
Hippolyte's stupidest remarks came out clever and apt. Now
everything Pierre said was charmant. Even if Anna Pavlovna did not say
so, he could see that she wished to and only refrained out of regard
for his modesty.

In the beginning of the winter of 1805-6 Pierre received one of Anna
Pavlovna's usual pink notes with an invitation to which was added:
"You will find the beautiful Helene here, whom it is always delightful
to see."

When he read that sentence, Pierre felt for the first time that some
link which other people recognized had grown up between himself and
Helene, and that thought both alarmed him, as if some obligation
were being imposed on him which he could not fulfill, and pleased
him as an entertaining supposition.

Anna Pavlovna's "At Home" was like the former one, only the
novelty she offered her guests this time was not Mortemart, but a
diplomatist fresh from Berlin with the very latest details of the
Emperor Alexander's visit to Potsdam, and of how the two august
friends had pledged themselves in an indissoluble alliance to uphold
the cause of justice against the enemy of the human race. Anna
Pavlovna received Pierre with a shade of melancholy, evidently
relating to the young man's recent loss by the death of Count Bezukhov
(everyone constantly considered it a duty to assure Pierre that he was
greatly afflicted by the death of the father he had hardly known), and
her melancholy was just like the august melancholy she showed at the
mention of her most august Majesty the Empress Marya Fedorovna. Pierre
felt flattered by this. Anna Pavlovna arranged the different groups in
her drawing room with her habitual skill. The large group, in which
were Prince Vasili and the generals, had the benefit of the
diplomat. Another group was at the tea table. Pierre wished to join
the former, but Anna Pavlovna--who was in the excited condition of a
commander on a battlefield to whom thousands of new and brilliant
ideas occur which there is hardly time to put in action--seeing
Pierre, touched his sleeve with her finger, saying:

"Wait a bit, I have something in view for you this evening." (She
glanced at Helene and smiled at her.) "My dear Helene, be charitable
to my poor aunt who adores you. Go and keep her company for ten
minutes. And that it will not be too dull, here is the dear count
who will not refuse to accompany you."

The beauty went to the aunt, but Anna Pavlovna detained Pierre,
looking as if she had to give some final necessary instructions.

"Isn't she exquisite?" she said to Pierre, pointing to the stately
beauty as she glided away. "And how she carries herself! For so
young a girl, such tact, such masterly perfection of manner! It
comes from her heart. Happy the man who wins her! With her the least
worldly of men would occupy a most brilliant position in society.
Don't you think so? I only wanted to know your opinion," and Anna
Pavlovna let Pierre go.

Pierre, in reply, sincerely agreed with her as to Helene's
perfection of manner. If he ever thought of Helene, it was just of her
beauty and her remarkable skill in appearing silently dignified in
society.

The old aunt received the two young people in her corner, but seemed
desirous of hiding her adoration for Helene and inclined rather to
show her fear of Anna Pavlovna. She looked at her niece, as if
inquiring what she was to do with these people. On leaving them,
Anna Pavlovna again touched Pierre's sleeve, saying: "I hope you won't
say that it is dull in my house again," and she glanced at Helene.

Helene smiled, with a look implying that she did not admit the
possibility of anyone seeing her without being enchanted. The aunt
coughed, swallowed, and said in French that she was very pleased to
see Helene, then she turned to Pierre with the same words of welcome
and the same look. In the middle of a dull and halting conversation,
Helene turned to Pierre with the beautiful bright smile that she
gave to everyone. Pierre was so used to that smile, and it had so
little meaning for him, that he paid no attention to it. The aunt
was just speaking of a collection of snuffboxes that had belonged to
Pierre's father, Count Bezukhov, and showed them her own box. Princess
Helene asked to see the portrait of the aunt's husband on the box lid.

"That is probably the work of Vinesse," said Pierre, mentioning a
celebrated miniaturist, and he leaned over the table to take the
snuffbox while trying to hear what was being said at the other table.

He half rose, meaning to go round, but the aunt handed him the
snuffbox, passing it across Helene's back. Helene stooped forward to
make room, and looked round with a smile. She was, as always at
evening parties, wearing a dress such as was then fashionable, cut
very low at front and back. Her bust, which had always seemed like
marble to Pierre, was so close to him that his shortsighted eyes could
not but perceive the living charm of her neck and shoulders, so near
to his lips that he need only have bent his head a little to have
touched them. He was conscious of the warmth of her body, the scent of
perfume, and the creaking of her corset as she moved. He did not see
her marble beauty forming a complete whole with her dress, but all the
charm of her body only covered by her garments. And having once seen
this he could not help being aware it, just as we cannot renew an
illusion we have once seen through.

"So you have never noticed before how beautiful I am?" Helene seemed
to say. "You had not noticed that I am a woman? Yes, I am a woman
who may belong to anyone--to you too," said her glance. And at that
moment Pierre felt that Helene not only could, but must, be his
wife, and that it could not be otherwise.

He knew this at that moment as surely as if he had been standing
at the altar with her. How and when this would be he did not know,
he did not even know if it would be a good thing (he even felt, he
knew not why, that it would be a bad thing), but he knew it would
happen.

Pierre dropped his eyes, lifted them again, and wished once more
to see her as a distant beauty far removed from him, as he had seen
her every day until then, but he could no longer do it. He could
not, any more than a man who has been looking at a tuft of steppe
grass through the mist and taking it for a tree can again take it
for a tree after he has once recognized it to be a tuft of grass.
She was terribly close to him. She already had power over him, and
between them there was no longer any barrier except the barrier of his
own will.

"Well, I will leave you in your little corner," came Anna Pavlovna's
voice, "I see you are all right there."

And Pierre, anxiously trying to remember whether he had done
anything reprehensible, looked round with a blush. It seemed to him
that everyone knew what had happened to him as he knew it himself.

A little later when he went up to the large circle, Anna Pavlovna
said to him: "I hear you are refitting your Petersburg house?"

This was true. The architect had told him that it was necessary, and
Pierre, without knowing why, was having his enormous Petersburg
house done up.

"That's a good thing, but don't move from Prince Vasili's. It is
good to have a friend like the prince," she said, smiling at Prince
Vasili. "I know something about that. Don't I? And you are still so
young. You need advice. Don't be angry with me for exercising an old
woman's privilege."

She paused, as women always do, expecting something after they
have mentioned their age. "If you marry it will be a different thing,"
she continued, uniting them both in one glance. Pierre did not look at
Helene nor she at him. But she was just as terribly close to him. He
muttered something and colored.

When he got home he could not sleep for a long time for thinking
of what had happened. What had happened? Nothing. He had merely
understood that the woman he had known as a child, of whom when her
beauty was mentioned he had said absent-mindedly: "Yes, she's good
looking," he had understood that this woman might belong to him.

"But she's stupid. I have myself said she is stupid," he thought.
"There is something nasty, something wrong, in the feeling she excites
in me. I have been told that her brother Anatole was in love with
her and she with him, that there was quite a scandal and that that's
why he was sent away. Hippolyte is her brother... Prince Vasili is her
father... It's bad...." he reflected, but while he was thinking this
(the reflection was still incomplete), he caught himself smiling and
was conscious that another line of thought had sprung up, and while
thinking of her worthlessness he was also dreaming of how she would be
his wife, how she would love him become quite different, and how all
he had thought and heard of her might be false. And he again saw her
not as the daughter of Prince Vasili, but visualized her whole body
only veiled by its gray dress. "But no! Why did this thought never
occur to me before?" and again he told himself that it was impossible,
that there would be something unnatural, and as it seemed to him
dishonorable, in this marriage. He recalled her former words and looks
and the words and looks of those who had seen them together. He
recalled Anna Pavlovna's words and looks when she spoke to him about
his house, recalled thousands of such hints from Prince Vasili and
others, and was seized by terror lest he had already, in some way,
bound himself to do something that was evidently wrong and that he
ought not to do. But at the very time he was expressing this
conviction to himself, in another part of his mind her image rose in
all its womanly beauty.





CHAPTER II

In November, 1805, Prince Vasili had to go on a tour of inspection
in four different provinces. He had arranged this for himself so as to
visit his neglected estates at the same time and pick up his son
Anatole where his regiment was stationed, and take him to visit Prince
Nicholas Bolkonski in order to arrange a match for him with the
daughter of that rich old man. But before leaving home and undertaking
these new affairs, Prince Vasili had to settle matters with Pierre,
who, it is true, had latterly spent whole days at home, that is, in
Prince Vasili's house where he was staying, and had been absurd,
excited, and foolish in Helene's presence (as a lover should be),
but had not yet proposed to her.

"This is all very fine, but things must be settled," said Prince
Vasili to himself, with a sorrowful sigh, one morning, feeling that
Pierre who was under such obligations to him ("But never mind that")
was not behaving very well in this matter. "Youth, frivolity...
well, God be with him," thought he, relishing his own goodness of
heart, "but it must be brought to a head. The day after tomorrow
will be Lelya's name day. I will invite two or three people, and if he
does not understand what he ought to do then it will be my affair-
yes, my affair. I am her father."

Six weeks after Anna Pavlovna's "At Home" and after the sleepless
night when he had decided that to marry Helene would be a calamity and
that he ought to avoid her and go away, Pierre, despite that decision,
had not left Prince Vasili's and felt with terror that in people's
eyes he was every day more and more connected with her, that it was
impossible for him to return to his former conception of her, that
he could not break away from her, and that though it would be a
terrible thing he would have to unite his fate with hers. He might
perhaps have been able to free himself but that Prince Vasili (who had
rarely before given receptions) now hardly let a day go by without
having an evening party at which Pierre had to be present unless he
wished to spoil the general pleasure and disappoint everyone's
expectation. Prince Vasili, in the rare moments when he was at home,
would take Pierre's hand in passing and draw it downwards, or
absent-mindedly hold out his wrinkled, clean-shaven cheek for Pierre
to kiss and would say: "Till tomorrow," or, "Be in to dinner or I
shall not see you," or, "I am staying in for your sake," and so on.
And though Prince Vasili, when he stayed in (as he said) for
Pierre's sake, hardly exchanged a couple of words with him, Pierre
felt unable to disappoint him. Every day he said to himself one and
the same thing: "It is time I understood her and made up my mind
what she really is. Was I mistaken before, or am I mistaken now? No,
she is not stupid, she is an excellent girl," he sometimes said to
himself "she never makes a mistake, never says anything stupid. She
says little, but what she does say is always clear and simple, so
she is not stupid. She never was abashed and is not abashed now, so
she cannot be a bad woman!" He had often begun to make reflections
or think aloud in her company, and she had always answered him
either by a brief but appropriate remark--showing that it did not
interest her--or by a silent look and smile which more palpably than
anything else showed Pierre her superiority. She was right in
regarding all arguments as nonsense in comparison with that smile.

She always addressed him with a radiantly confiding smile meant
for him alone, in which there was something more significant than in
the general smile that usually brightened her face. Pierre knew that
everyone was waiting for him to say a word and cross a certain line,
and he knew that sooner or later he would step across it, but an
incomprehensible terror seized him at the thought of that dreadful
step. A thousand times during that month and a half while he felt
himself drawn nearer and nearer to that dreadful abyss, Pierre said to
himself: "What am I doing? I need resolution. Can it be that I have
none?"

He wished to take a decision, but felt with dismay that in this
matter he lacked that strength of will which he had known in himself
and really possessed. Pierre was one of those who are only strong when
they feel themselves quite innocent, and since that day when he was
overpowered by a feeling of desire while stooping over the snuffbox at
Anna Pavlovna's, an unacknowledged sense of the guilt of that desire
paralyzed his will.

On Helene's name day, a small party of just their own people--as his
wife said--met for supper at Prince Vasili's. All these friends and
relations had been given to understand that the fate of the young girl
would be decided that evening. The visitors were seated at supper.
Princess Kuragina, a portly imposing woman who had once been handsome,
was sitting at the head of the table. On either side of her sat the
more important guests--an old general and his wife, and Anna
Pavlovna Scherer. At the other end sat the younger and less
important guests, and there too sat the members of the family, and
Pierre and Helene, side by side. Prince Vasili was not having any
supper: he went round the table in a merry mood, sitting down now by
one, now by another, of the guests. To each of them he made some
careless and agreeable remark except to Pierre and Helene, whose
presence he seemed not to notice. He enlivened the whole party. The
wax candles burned brightly, the silver and crystal gleamed, so did
the ladies' toilets and the gold and silver of the men's epaulets;
servants in scarlet liveries moved round the table, the clatter of
plates, knives, and glasses mingled with the animated hum of several
conversations. At one end of the table, the old chamberlain was
heard assuring an old baroness that he loved her passionately, at
which she laughed; at the other could be heard the story of the
misfortunes of some Mary Viktorovna or other. At the center of the
table, Prince Vasili attracted everybody's attention. With a facetious
smile on his face, he was telling the ladies about last Wednesday's
meeting of the Imperial Council, at which Sergey Kuzmich
Vyazmitinov, the new military governor general of Petersburg, had
received and read the then famous rescript of the Emperor Alexander
from the army to Sergey Kuzmich, in which the Emperor said that he was
receiving from all sides declarations of the people's loyalty, that
the declaration from Petersburg gave him particular pleasure, and that
he was proud to be at the head of such a nation and would endeavor
to be worthy of it. This rescript began with the words: "Sergey
Kuzmich, From all sides reports reach me," etc.

"Well, and so he never got farther than: 'Sergey Kuzmich'?" asked
one of the ladies.

"Exactly, not a hair's breadth farther," answered Prince Vasili,
laughing, "'Sergey Kuzmich... From all sides... From all sides...
Sergey Kuzmich...' Poor Vyazmitinov could not get any farther! He
began the rescript again and again, but as soon as he uttered 'Sergey'
he sobbed, 'Kuz-mi-ch,' tears, and 'From all sides' was smothered in
sobs and he could get no farther. And again his handkerchief, and
again: 'Sergey Kuzmich, From all sides,'... and tears, till at last
somebody else was asked to read it."

"Kuzmich... From all sides... and then tears," someone repeated
laughing.

"Don't be unkind," cried Anna Pavlovna from her end of the table
holding up a threatening finger. "He is such a worthy and excellent
man, our dear Vyazmitinov...."

Everybody laughed a great deal. At the head of the table, where
the honored guests sat, everyone seemed to be in high spirits and
under the influence of a variety of exciting sensations. Only Pierre
and Helene sat silently side by side almost at the bottom of the
table, a suppressed smile brightening both their faces, a smile that
had nothing to do with Sergey Kuzmich--a smile of bashfulness at their
own feelings. But much as all the rest laughed, talked, and joked,
much as they enjoyed their Rhine wine, saute, and ices, and however
they avoided looking at the young couple, and heedless and unobservant
as they seemed of them, one could feel by the occasional glances
they gave that the story about Sergey Kuzmich, the laughter, and the
food were all a pretense, and that the whole attention of that company
was directed to--Pierre and Helene. Prince Vasili mimicked the sobbing
of Sergey Kuzmich and at the same time his eyes glanced toward his
daughter, and while he laughed the expression on his face clearly
said: "Yes... it's getting on, it will all be settled today." Anna
Pavlovna threatened him on behalf of "our dear Vyazmitinov," and in
her eyes, which, for an instant, glanced at Pierre, Prince Vasili read
a congratulation on his future son-in-law and on his daughter's
happiness. The old princess sighed sadly as she offered some wine to
the old lady next to her and glanced angrily at her daughter, and
her sigh seemed to say: "Yes, there's nothing left for you and me
but to sip sweet wine, my dear, now that the time has come for these
young ones to be thus boldly, provocatively happy." "And what nonsense
all this is that I am saying!" thought a diplomatist, glancing at
the happy faces of the lovers. "That's happiness!"

Into the insignificant, trifling, and artificial interests uniting
that society had entered the simple feeling of the attraction of a
healthy and handsome young man and woman for one another. And this
human feeling dominated everything else and soared above all their
affected chatter. Jests fell flat, news was not interesting, and the
animation was evidently forced. Not only the guests but even the
footmen waiting at table seemed to feel this, and they forgot their
duties as they looked at the beautiful Helene with her radiant face
and at the red, broad, and happy though uneasy face of Pierre. It
seemed as if the very light of the candles was focused on those two
happy faces alone.

Pierre felt that he was the center of it all, and this both pleased
and embarrassed him. He was like a man entirely absorbed in some
occupation. He did not see, hear, or understand anything clearly. Only
now and then detached ideas and impressions from the world of
reality shot unexpectedly through his mind.

"So it is all finished!" he thought. "And how has it all happened?
How quickly! Now I know that not because of her alone, nor of myself
alone, but because of everyone, it must inevitably come about. They
are all expecting it, they are so sure that it will happen that I
cannot, I cannot, disappoint them. But how will it be? I do not
know, but it will certainly happen!" thought Pierre, glancing at those
dazzling shoulders close to his eyes.

Or he would suddenly feel ashamed of he knew not what. He felt it
awkward to attract everyone's attention and to be considered a lucky
man and, with his plain face, to be looked on as a sort of Paris
possessed of a Helen. "But no doubt it always is and must be so!" he
consoled himself. "And besides, what have I done to bring it about?
How did it begin? I traveled from Moscow with Prince Vasili. Then
there was nothing. So why should I not stay at his house? Then I
played cards with her and picked up her reticule and drove out with
her. How did it begin, when did it all come about?" And here he was
sitting by her side as her betrothed, seeing, hearing, feeling her
nearness, her breathing, her movements, her beauty. Then it would
suddenly seem to him that it was not she but he was so unusually
beautiful, and that that was why they all looked so at him, and
flattered by this general admiration he would expand his chest,
raise his head, and rejoice at his good fortune. Suddenly he heard a
familiar voice repeating something to him a second time. But Pierre
was so absorbed that he did not understand what was said.

"I am asking you when you last heard from Bolkonski," repeated
Prince Vasili a third time. "How absent-minded you are, my dear
fellow."

Prince Vasili smiled, and Pierre noticed that everyone was smiling
at him and Helene. "Well, what of it, if you all know it?" thought
Pierre. "What of it? It's the truth!" and he himself smiled his gentle
childlike smile, and Helene smiled too.

"When did you get the letter? Was it from Olmutz?" repeated Prince
Vasili, who pretended to want to know this in order to settle a
dispute.

"How can one talk or think of such trifles?" thought Pierre.

"Yes, from Olmutz," he answered, with a sigh.

After supper Pierre with his partner followed the others into the
drawing room. The guests began to disperse, some without taking
leave of Helene. Some, as if unwilling to distract her from an
important occupation, came up to her for a moment and made haste to go
away, refusing to let her see them off. The diplomatist preserved a
mournful silence as he left the drawing room. He pictured the vanity
of his diplomatic career in comparison with Pierre's happiness. The
old general grumbled at his wife when she asked how his leg was.
"Oh, the old fool," he thought. "That Princess Helene will be
beautiful still when she's fifty."

"I think I may congratulate you," whispered Anna Pavlovna to the old
princess, kissing her soundly. "If I hadn't this headache I'd have
stayed longer."

The old princess did not reply, she was tormented by jealousy of her
daughter's happiness.

While the guests were taking their leave Pierre remained for a
long time alone with Helene in the little drawing room where they were
sitting. He had often before, during the last six weeks, remained
alone with her, but had never spoken to her of love. Now he felt
that it was inevitable, but he could not make up his mind to take
the final step. He felt ashamed; he felt that he was occupying someone
else's place here beside Helene. "This happiness is not for you," some
inner voice whispered to him. "This happiness is for those who have
not in them what there is in you."

But, as he had to say something, he began by asking her whether
she was satisfied with the party. She replied in her usual simple
manner that this name day of hers had been one of the pleasantest
she had ever had.

Some of the nearest relatives had not yet left. They were sitting in
the large drawing room. Prince Vasili came up to Pierre with languid
footsteps. Pierre rose and said it was getting late. Prince Vasili
gave him a look of stern inquiry, as though what Pierre had just
said was so strange that one could not take it in. But then the
expression of severity changed, and he drew Pierre's hand downwards,
made him sit down, and smiled affectionately.

"Well, Lelya?" he asked, turning instantly to his daughter and
addressing her with the careless tone of habitual tenderness natural
to parents who have petted their children from babyhood, but which
Prince Vasili had only acquired by imitating other parents.

And he again turned to Pierre.

"Sergey Kuzmich--From all sides-" he said, unbuttoning the top
button of his waistcoat.

Pierre smiled, but his smile showed that he knew it was not the
story about Sergey Kuzmich that interested Prince Vasili just then,
and Prince Vasili saw that Pierre knew this. He suddenly muttered
something and went away. It seemed to Pierre that even the prince
was disconcerted. The sight of the discomposure of that old man of the
world touched Pierre: he looked at Helene and she too seemed
disconcerted, and her look seemed to say: "Well, it is your own
fault."

"The step must be taken but I cannot, I cannot!" thought Pierre, and
he again began speaking about indifferent matters, about Sergey
Kuzmich, asking what the point of the story was as he had not heard it
properly. Helene answered with a smile that she too had missed it.

When Prince Vasili returned to the drawing room, the princess, his
wife, was talking in low tones to the elderly lady about Pierre.

"Of course, it is a very brilliant match, but happiness, my dear..."

"Marriages are made in heaven," replied the elderly lady.

Prince Vasili passed by, seeming not to hear the ladies, and sat
down on a sofa in a far corner of the room. He closed his eyes and
seemed to be dozing. His head sank forward and then he roused himself.

"Aline," he said to his wife, "go and see what they are about."

The princess went up to the door, passed by it with a dignified
and indifferent air, and glanced into the little drawing room.
Pierre and Helene still sat talking just as before.

"Still the same," she said to her husband.

Prince Vasili frowned, twisting his mouth, his cheeks quivered and
his face assumed the coarse, unpleasant expression peculiar to him.
Shaking himself, he rose, threw back his head, and with resolute steps
went past the ladies into the little drawing room. With quick steps he
went joyfully up to Pierre. His face was so unusually triumphant
that Pierre rose in alarm on seeing it.

"Thank God!" said Prince Vasili. "My wife has told me everything!"
(He put one arm around Pierre and the other around his daughter.)--"My
dear boy... Lelya... I am very pleased." (His voice trembled.) "I
loved your father... and she will make you a good wife... God bless
you!..."

He embraced his daughter, and then again Pierre, and kissed him with
his malodorous mouth. Tears actually moistened his cheeks.

"Princess, come here!" he shouted.

The old princess came in and also wept. The elderly lady was using
her handkerchief too. Pierre was kissed, and he kissed the beautiful
Helene's hand several times. After a while they were left alone again.

"All this had to be and could not be otherwise," thought Pierre, "so
it is useless to ask whether it is good or bad. It is good because
it's definite and one is rid of the old tormenting doubt." Pierre held
the hand of his betrothed in silence, looking at her beautiful bosom
as it rose and fell.

"Helene!" he said aloud and paused.

"Something special is always said in such cases," he thought, but
could not remember what it was that people say. He looked at her face.
She drew nearer to him. Her face flushed.

"Oh, take those off... those..." she said, pointing to his
spectacles.

Pierre took them off, and his eyes, besides the strange look eyes
have from which spectacles have just been removed, had also a
frightened and inquiring look. He was about to stoop over her hand and
kiss it, but with a rapid, almost brutal movement of her head, she
intercepted his lips and met them with her own. Her face struck
Pierre, by its altered, unpleasantly excited expression.

"It is too late now, it's done; besides I love her," thought Pierre.

"Je vous aime!"* he said, remembering what has to be said at such
moments: but his words sounded so weak that he felt ashamed of
himself.


*"I love you."


Six weeks later he was married, and settled in Count Bezukhov's
large, newly furnished Petersburg house, the happy possessor, as
people said, of a wife who was a celebrated beauty and of millions
of money.





CHAPTER III


Old Prince Nicholas Bolkonski received a letter from Prince Vasili
in November, 1805, announcing that he and his son would be paying
him a visit. "I am starting on a journey of inspection, and of
course I shall think nothing of an extra seventy miles to come and see
you at the same time, my honored benefactor," wrote Prince Vasili. "My
son Anatole is accompanying me on his way to the army, so I hope you
will allow him personally to express the deep respect that,
emulating his father, he feels for you."

"It seems that there will be no need to bring Mary out, suitors
are coming to us of their own accord," incautiously remarked the
little princess on hearing the news.

Prince Nicholas frowned, but said nothing.

A fortnight after the letter Prince Vasili's servants came one
evening in advance of him, and he and his son arrived next day.

Old Bolkonski had always had a poor opinion of Prince Vasili's
character, but more so recently, since in the new reigns of Paul and
Alexander Prince Vasili had risen to high position and honors. And
now, from the hints contained in his letter and given by the little
princess, he saw which way the wind was blowing, and his low opinion
changed into a feeling of contemptuous ill will. He snorted whenever
he mentioned him. On the day of Prince Vasili's arrival, Prince
Bolkonski was particularly discontented and out of temper. Whether
he was in a bad temper because Prince Vasili was coming, or whether
his being in a bad temper made him specially annoyed at Prince
Vasili's visit, he was in a bad temper, and in the morning Tikhon
had already advised the architect not to go to the prince with his
report.

"Do you hear how he's walking?" said Tikhon, drawing the architect's
attention to the sound of the prince's footsteps. "Stepping flat on
his heels--we know what that means...."

However, at nine o'clock the prince, in his velvet coat with a sable
collar and cap, went out for his usual walk. It had snowed the day
before and the path to the hothouse, along which the prince was in the
habit of walking, had been swept: the marks of the broom were still
visible in the snow and a shovel had been left sticking in one of
the soft snowbanks that bordered both sides of the path. The prince
went through the conservatories, the serfs' quarters, and the
outbuildings, frowning and silent.

"Can a sleigh pass?" he asked his overseer, a venerable man,
resembling his master in manners and looks, who was accompanying him
back to the house.

"The snow is deep. I am having the avenue swept, your honor."

The prince bowed his head and went up to the porch. "God be
thanked," thought the overseer, "the storm has blown over!"

"It would have been hard to drive up, your honor," he added. "I
heard, your honor, that a minister is coming to visit your honor."

The prince turned round to the overseer and fixed his eyes on him,
frowning.

"What? A minister? What minister? Who gave orders?" he said in his
shrill, harsh voice. "The road is not swept for the princess my
daughter, but for a minister! For me, there are no ministers!"

"Your honor, I thought..."

"You thought!" shouted the prince, his words coming more and more
rapidly and indistinctly. "You thought!... Rascals! Blackgaurds!...
I'll teach you to think!" and lifting his stick he swung it and
would have hit Alpatych, the overseer, had not the latter
instinctively avoided the blow. "Thought... Blackguards..." shouted
the prince rapidly.

But although Alpatych, frightened at his own temerity in avoiding
the stroke, came up to the prince, bowing his bald head resignedly
before him, or perhaps for that very reason, the prince, though he
continued to shout: "Blackgaurds!... Throw the snow back on the road!"
did not lift his stick again but hurried into the house.

Before dinner, Princess Mary and Mademoiselle Bourienne, who knew
that the prince was in a bad humor, stood awaiting him; Mademoiselle
Bourienne with a radiant face that said: "I know nothing, I am the
same as usual," and Princess Mary pale, frightened, and with
downcast eyes. What she found hardest to bear was to know that on such
occasions she ought to behave like Mademoiselle Bourienne, but could
not. She thought: "If I seem not to notice he will think that I do not
sympathize with him; if I seem sad and out of spirits myself, he
will say (as he has done before) that I'm in the dumps."

The prince looked at his daughter's frightened face and snorted.

"Fool... or dummy!" he muttered.

"And the other one is not here. They've been telling tales," he
thought--referring to the little princess who was not in the dining
room.

"Where is the princess?" he asked. "Hiding?"

"She is not very well," answered Mademoiselle Bourienne with a
bright smile, "so she won't come down. It is natural in her state."

"Hm! Hm!" muttered the prince, sitting down.

His plate seemed to him not quite clean, and pointing to a spot he
flung it away. Tikhon caught it and handed it to a footman. The little
princess was not unwell, but had such an overpowering fear of the
prince that, hearing he was in a bad humor, she had decided not to
appear.

"I am afraid for the baby," she said to Mademoiselle Bourienne:
"Heaven knows what a fright might do."

In general at Bald Hills the little princess lived in constant fear,
and with a sense of antipathy to the old prince which she did not
realize because the fear was so much the stronger feeling. The
prince reciprocated this antipathy, but it was overpowered by his
contempt for her. When the little princess had grown accustomed to
life at Bald Hills, she took a special fancy to Mademoiselle
Bourienne, spent whole days with her, asked her to sleep in her
room, and often talked with her about the old prince and criticized
him.

"So we are to have visitors, mon prince?" remarked Mademoiselle
Bourienne, unfolding her white napkin with her rosy fingers. "His
Excellency Prince Vasili Kuragin and his son, I understand?" she
said inquiringly.

"Hm!--his excellency is a puppy.... I got him his appointment in the
service," said the prince disdainfully. "Why his son is coming I don't
understand. Perhaps Princess Elizabeth and Princess Mary know. I don't
want him." (He looked at his blushing daughter.) "Are you unwell
today? Eh? Afraid of the 'minister' as that idiot Alpatych called
him this morning?"

"No, mon pere."

Though Mademoiselle Bourienne had been so unsuccessful in her choice
of a subject, she did not stop talking, but chattered about the
conservatories and the beauty of a flower that had just opened, and
after the soup the prince became more genial.

After dinner, he went to see his daughter-in-law. The little
princess was sitting at a small table, chattering with Masha, her
maid. She grew pale on seeing her father-in-law.

She was much altered. She was now plain rather than pretty. Her
cheeks had sunk, her lip was drawn up, and her eyes drawn down.

"Yes, I feel a kind of oppression," she said in reply to the
prince's question as to how she felt.

"Do you want anything?"

"No, merci, mon pere."

"Well, all right, all right."

He left the room and went to the waiting room where Alpatych stood
with bowed head.

"Has the snow been shoveled back?"

"Yes, your excellency. Forgive me for heaven's sake... It was only
my stupidity."

"All right, all right," interrupted the prince, and laughing his
unnatural way, he stretched out his hand for Alpatych to kiss, and
then proceeded to his study.

Prince Vasili arrived that evening. He was met in the avenue by
coachmen and footmen, who, with loud shouts, dragged his sleighs up to
one of the lodges over the road purposely laden with snow.

Prince Vasili and Anatole had separate rooms assigned to them.

Anatole, having taken off his overcoat, sat with arms akimbo
before a table on a corner of which he smilingly and absent-mindedly
fixed his large and handsome eyes. He regarded his whole life as a
continual round of amusement which someone for some reason had to
provide for him. And he looked on this visit to a churlish old man and
a rich and ugly heiress in the same way. All this might, he thought,
turn out very well and amusingly. "And why not marry her if she really
has so much money? That never does any harm," thought Anatole.

He shaved and scented himself with the care and elegance which had
become habitual to him and, his handsome head held high, entered his
father's room with the good-humored and victorious air natural to him.
Prince Vasili's two valets were busy dressing him, and he looked round
with much animation and cheerfully nodded to his son as the latter
entered, as if to say: "Yes, that's how I want you to look."

"I say, Father, joking apart, is she very hideous?" Anatole asked,
as if continuing a conversation the subject of which had often been
mentioned during the journey.

"Enough! What nonsense! Above all, try to be respectful and cautious
with the old prince."

"If he starts a row I'll go away," said Prince Anatole. "I can't
bear those old men! Eh?"

"Remember, for you everything depends on this."

In the meantime, not only was it known in the maidservants' rooms
that the minister and his son had arrived, but the appearance of
both had been minutely described. Princess Mary was sitting alone in
her room, vainly trying to master her agitation.

"Why did they write, why did Lise tell me about it? It can never
happen!" she said, looking at herself in the glass. "How shall I enter
the drawing room? Even if I like him I can't now be myself with
him." The mere thought of her father's look filled her with terror.
The little princess and Mademoiselle Bourienne had already received
from Masha, the lady's maid, the necessary report of how handsome
the minister's son was, with his rosy cheeks and dark eyebrows, and
with what difficulty the father had dragged his legs upstairs while
the son had followed him like an eagle, three steps at a time.
Having received this information, the little princess and Mademoiselle
Bourienne, whose chattering voices had reached her from the
corridor, went into Princess Mary's room.

"You know they've come, Marie?" said the little princess, waddling
in, and sinking heavily into an armchair.

She was no longer in the loose gown she generally wore in the
morning, but had on one of her best dresses. Her hair was carefully
done and her face was animated, which, however, did not conceal its
sunken and faded outlines. Dressed as she used to be in Petersburg
society, it was still more noticeable how much plainer she had become.
Some unobtrusive touch had been added to Mademoiselle Bourienne's
toilet which rendered her fresh and pretty face yet more attractive.

"What! Are you going to remain as you are, dear princess?" she
began. "They'll be announcing that the gentlemen are in the drawing
room and we shall have to go down, and you have not smartened yourself
up at all!"

The little princess got up, rang for the maid, and hurriedly and
merrily began to devise and carry out a plan of how Princess Mary
should be dressed. Princess Mary's self-esteem was wounded by the fact
that the arrival of a suitor agitated her, and still more so by both
her companions' not having the least conception that it could be
otherwise. To tell them that she felt ashamed for herself and for them
would be to betray her agitation, while to decline their offers to
dress her would prolong their banter and insistence. She flushed,
her beautiful eyes grew dim, red blotches came on her face, and it
took on the unattractive martyrlike expression it so often wore, as
she submitted herself to Mademoiselle Bourienne and Lise. Both these
women quite sincerely tried to make her look pretty. She was so
plain that neither of them could think of her as a rival, so they
began dressing her with perfect sincerity, and with the naive and firm
conviction women have that dress can make a face pretty.

"No really, my dear, this dress is not pretty," said Lise, looking
sideways at Princess Mary from a little distance. "You have a maroon
dress, have it fetched. Really! You know the fate of your whole life
may be at stake. But this one is too light, it's not becoming!"

It was not the dress, but the face and whole figure of Princess Mary
that was not pretty, but neither Mademoiselle Bourienne nor the little
princess felt this; they still thought that if a blue ribbon were
placed in the hair, the hair combed up, and the blue scarf arranged
lower on the best maroon dress, and so on, all would be well. They
forgot that the frightened face and the figure could not be altered,
and that however they might change the setting and adornment of that
face, it would still remain piteous and plain. After two or three
changes to which Princess Mary meekly submitted, just as her hair
had been arranged on the top of her head (a style that quite altered
and spoiled her looks) and she had put on a maroon dress with a
pale-blue scarf, the little princess walked twice round her, now
adjusting a fold of the dress with her little hand, now arranging
the scarf and looking at her with her head bent first on one side
and then on the other.

"No, it will not do," she said decidedly, clasping her hands. "No,
Mary, really this dress does not suit you. I prefer you in your little
gray everyday dress. Now please, do it for my sake. Katie," she said
to the maid, "bring the princess her gray dress, and you'll see,
Mademoiselle Bourienne, how I shall arrange it," she added, smiling
with a foretaste of artistic pleasure.

But when Katie brought the required dress, Princess Mary remained
sitting motionless before the glass, looking at her face, and saw in
the mirror her eyes full of tears and her mouth quivering, ready to
burst into sobs.

"Come, dear princess," said Mademoiselle Bourienne, "just one more
little effort."

The little princess, taking the dress from the maid, came up to
Princess Mary.

"Well, now we'll arrange something quite simple and becoming," she
said.

The three voices, hers, Mademoiselle Bourienne's, and Katie's, who
was laughing at something, mingled in a merry sound, like the chirping
of birds.

"No, leave me alone," said Princess Mary.

Her voice sounded so serious and so sad that the chirping of the
birds was silenced at once. They looked at the beautiful, large,
thoughtful eyes full of tears and of thoughts, gazing shiningly and
imploringly at them, and understood that it was useless and even cruel
to insist.

"At least, change your coiffure," said the little princess.
"Didn't I tell you," she went on, turning reproachfully to
Mademoiselle Bourienne, "Mary's is a face which such a coiffure does
not suit in the least. Not in the least! Please change it."

"Leave me alone, please leave me alone! It is all quite the same
to me," answered a voice struggling with tears.

Mademoiselle Bourienne and the little princess had to own to
themselves that Princess Mary in this guise looked very plain, worse
than usual, but it was too late. She was looking at them with an
expression they both knew, an expression thoughtful and sad. This
expression in Princess Mary did not frighten them (she never
inspired fear in anyone), but they knew that when it appeared on her
face, she became mute and was not to be shaken in her determination.

"You will change it, won't you?" said Lise. And as Princess Mary
gave no answer, she left the room.

Princess Mary was left alone. She did not comply with Lise's
request, she not only left her hair as it was, but did not even look
in her glass. Letting her arms fall helplessly, she sat with
downcast eyes and pondered. A husband, a man, a strong dominant and
strangely attractive being rose in her imagination, and carried her
into a totally different happy world of his own. She fancied a
child, her own--such as she had seen the day before in the arms of her
nurse's daughter--at her own breast, the husband standing by and
gazing tenderly at her and the child. "But no, it is impossible, I
am too ugly," she thought.

"Please come to tea. The prince will be out in a moment," came the
maid's voice at the door.

She roused herself, and felt appalled at what she had been thinking,
and before going down she went into the room where the icons hung and,
her eyes fixed on the dark face of a large icon of the Saviour lit
by a lamp, she stood before it with folded hands for a few moments.
A painful doubt filled her soul. Could the joy of love, of earthly
love for a man, be for her? In her thoughts of marriage Princess
Mary dreamed of happiness and of children, but her strongest, most
deeply hidden longing was for earthly love. The more she tried to hide
this feeling from others and even from herself, the stronger it
grew. "O God," she said, "how am I to stifle in my heart these
temptations of the devil? How am I to renounce forever these vile
fancies, so as peacefully to fulfill Thy will?" And scarcely had she
put that question than God gave her the answer in her own heart.
"Desire nothing for thyself, seek nothing, be not anxious or
envious. Man's future and thy own fate must remain hidden from thee,
but live so that thou mayest be ready for anything. If it be God's
will to prove thee in the duties of marriage, be ready to fulfill
His will." With this consoling thought (but yet with a hope for the
fulfillment of her forbidden earthly longing) Princess Mary sighed,
and having crossed herself went down, thinking neither of her gown and
coiffure nor of how she would go in nor of what she would say. What
could all that matter in comparison with the will of God, without
Whose care not a hair of man's head can fall?





CHAPTER IV


When Princess Mary came down, Prince Vasili and his son were already
in the drawing room, talking to the little princess and Mademoiselle
Bourienne. When she entered with her heavy step, treading on her
heels, the gentlemen and Mademoiselle Bourienne rose and the little
princess, indicating her to the gentlemen, said: "Voila Marie!"
Princess Mary saw them all and saw them in detail. She saw Prince
Vasili's face, serious for an instant at the sight of her, but
immediately smiling again, and the little princess curiously noting
the impression "Marie" produced on the visitors. And she saw
Mademoiselle Bourienne, with her ribbon and pretty face, and her
unusually animated look which was fixed on him, but him she could
not see, she only saw something large, brilliant, and handsome
moving toward her as she entered the room. Prince Vasili approached
first, and she kissed the bold forehead that bent over her hand and
answered his question by saying that, on the contrary, she
remembered him quite well. Then Anatole came up to her. She still
could not see him. She only felt a soft hand taking hers firmly, and
she touched with her lips a white forehead, over which was beautiful
light-brown hair smelling of pomade. When she looked up at him she was
struck by his beauty. Anatole stood with his right thumb under a
button of his uniform, his chest expanded and his back drawn in,
slightly swinging one foot, and, with his head a little bent, looked
with beaming face at the princess without speaking and evidently not
thinking about her at all. Anatole was not quick-witted, nor ready
or eloquent in conversation, but he had the faculty, so invaluable
in society, of composure and imperturbable self-possession. If a man
lacking in self-confidence remains dumb on a first introduction and
betrays a consciousness of the impropriety of such silence and an
anxiety to find something to say, the effect is bad. But Anatole was
dumb, swung his foot, and smilingly examined the princess' hair. It
was evident that he could be silent in this way for a very long
time. "If anyone finds this silence inconvenient, let him talk, but
I don't want to," he seemed to say. Besides this, in his behavior to
women Anatole had a manner which particularly inspires in them
curiosity, awe, and even love--a supercilious consciousness of his own
superiority. It was was as if he said to them: "I know you, I know
you, but why should I bother about you? You'd be only too glad, of
course." Perhaps he did not really think this when he met women-
even probably he did not, for in general he thought very little--but
his looks and manner gave that impression. The princess felt this, and
as if wishing to show him that she did not even dare expect to
interest him, she turned to his father. The conversation was general
and animated, thanks to Princess Lise's voice and little downy lip
that lifted over her white teeth. She met Prince Vasili with that
playful manner often employed by lively chatty people, and
consisting in the assumption that between the person they so address
and themselves there are some semi-private, long-established jokes and
amusing reminiscences, though no such reminiscences really exist--just
as none existed in this case. Prince Vasili readily adopted her tone
and the little princess also drew Anatole, whom she hardly knew,
into these amusing recollections of things that had never occurred.
Mademoiselle Bourienne also shared them and even Princess Mary felt
herself pleasantly made to share in these merry reminiscences.

"Here at least we shall have the benefit of your company all to
ourselves, dear prince," said the little princess (of course, in
French) to Prince Vasili. "It's not as at Annette's* receptions
where you always ran away; you remember cette chere Annette!"


*Anna Pavlovna.

"Ah, but you won't talk politics to me like Annette!"

"And our little tea table?"

"Oh, yes!"

"Why is it you were never at Annette's?" the little princess asked
Anatole. "Ah, I know, I know," she said with a sly glance, "your
brother Hippolyte told me about your goings on. Oh!" and she shook her
finger at him, "I have even heard of your doings in Paris!"

"And didn't Hippolyte tell you?" asked Prince Vasili, turning to his
son and seizing the little princess' arm as if she would have run away
and he had just managed to catch her, "didn't he tell you how he
himself was pining for the dear princess, and how she showed him the
door? Oh, she is a pearl among women, Princess," he added, turning
to Princess Mary.

When Paris was mentioned, Mademoiselle Bourienne for her part seized
the opportunity of joining in the general current of recollections.

She took the liberty of inquiring whether it was long since
Anatole had left Paris and how he had liked that city. Anatole
answered the Frenchwoman very readily and, looking at her with a
smile, talked to her about her native land. When he saw the pretty
little Bourienne, Anatole came to the conclusion that he would not
find Bald Hills dull either. "Not at all bad!" he thought, examining
her, "not at all bad, that little companion! I hope she will bring her
along with her when we're married, la petite est gentille."*


*The little one is charming.


The old prince dressed leisurely in his study, frowning and
considering what he was to do. The coming of these visitors annoyed
him. "What are Prince Vasili and that son of his to me? Prince
Vasili is a shallow braggart and his son, no doubt, is a fine
specimen," he grumbled to himself. What angered him was that the
coming of these visitors revived in his mind an unsettled question
he always tried to stifle, one about which he always deceived himself.
The question was whether he could ever bring himself to part from
his daughter and give her to a husband. The prince never directly
asked himself that question, knowing beforehand that he would have
to answer it justly, and justice clashed not only with his feelings
but with the very possibility of life. Life without Princess Mary,
little as he seemed to value her, was unthinkable to him. "And why
should she marry?" he thought. "To be unhappy for certain. There's
Lise, married to Andrew--a better husband one would think could hardly
be found nowadays--but is she contented with her lot? And who would
marry Marie for love? Plain and awkward! They'll take her for her
connections and wealth. Are there no women living unmarried, and
even the happier for it?" So thought Prince Bolkonski while
dressing, and yet the question he was always putting off demanded an
immediate answer. Prince Vasili had brought his son with the evident
intention of proposing, and today or tomorrow he would probably ask
for an answer. His birth and position in society were not bad.
"Well, I've nothing against it," the prince said to himself, "but he
must be worthy of her. And that is what we shall see."

"That is what we shall see! That is what we shall see!" he added
aloud.

He entered the drawing room with his usual alert step, glancing
rapidly round the company. He noticed the change in the little
princess' dress, Mademoiselle Bourienne's ribbon, Princess Mary's
unbecoming coiffure, Mademoiselle Bourienne's and Anatole's smiles,
and the loneliness of his daughter amid the general conversation. "Got
herself up like a fool!" he thought, looking irritably at her. "She is
shameless, and he ignores her!"

He went straight up to Prince Vasili.

"Well! How d'ye do? How d'ye do? Glad to see you!"

"Friendship laughs at distance," began Prince Vasili in his usual
rapid, self-confident, familiar tone. "Here is my second son; please
love and befriend him."

Prince Bolkonski surveyed Anatole.

"Fine young fellow! Fine young fellow!" he said. "Well, come and
kiss me," and he offered his cheek.

Anatole kissed the old man, and looked at him with curiosity and
perfect composure, waiting for a display of the eccentricities his
father had told him to expect.

Prince Bolkonski sat down in his usual place in the corner of the
sofa and, drawing up an armchair for Prince Vasili, pointed to it
and began questioning him about political affairs and news. He
seemed to listen attentively to what Prince Vasili said, but kept
glancing at Princess Mary.

"And so they are writing from Potsdam already?" he said, repeating
Prince Vasili's last words. Then rising, he suddenly went up to his
daughter.

"Is it for visitors you've got yourself up like that, eh?" said
he. "Fine, very fine! You have done up your hair in this new way for
the visitors, and before the visitors I tell you that in future you
are never to dare to change your way of dress without my consent."

"It was my fault, mon pere," interceded the little princess, with
a blush.

"You must do as you please," said Prince Bolkonski, bowing to his
daughter-in-law, "but she need not make a fool of herself, she's plain
enough as it is."

And he sat down again, paying no more attention to his daughter, who
was reduced to tears.

"On the contrary, that coiffure suits the princess very well,"
said Prince Vasili.

"Now you, young prince, what's your name?" said Prince Bolkonski,
turning to Anatole, "come here, let us talk and get acquainted."

"Now the fun begins," thought Anatole, sitting down with a smile
beside the old prince.

"Well, my dear boy, I hear you've been educated abroad, not taught
to read and write by the deacon, like your father and me. Now tell me,
my dear boy, are you serving in the Horse Guards?" asked the old
man, scrutinizing Anatole closely and intently.

"No, I have been transferred to the line," said Anatole, hardly able
to restrain his laughter.

"Ah! That's a good thing. So, my dear boy, you wish to serve the
Tsar and the country? It is wartime. Such a fine fellow must serve.
Well, are you off to the front?"

"No, Prince, our regiment has gone to the front, but I am
attached... what is it I am attached to, Papa?" said Anatole,
turning to his father with a laugh.

"A splendid soldier, splendid! 'What am I attached to!' Ha, ha, ha!"
laughed Prince Bolkonski, and Anatole laughed still louder. Suddenly
Prince Bolkonski frowned.

"You may go," he said to Anatole.

Anatole returned smiling to the ladies.

"And so you've had him educated abroad, Prince Vasili, haven't you?"
said the old prince to Prince Vasili.

"I have done my best for him, and I can assure you the education
there is much better than ours."

"Yes, everything is different nowadays, everything is changed. The
lad's a fine fellow, a fine fellow! Well, come with me now." He took
Prince Vasili's arm and led him to his study. As soon as they were
alone together, Prince Vasili announced his hopes and wishes to the
old prince.

"Well, do you think I shall prevent her, that I can't part from
her?" said the old prince angrily. "What an idea! I'm ready for it
tomorrow! Only let me tell you, I want to know my son-in-law better.
You know my principles--everything aboveboard? I will ask her tomorrow
in your presence; if she is willing, then he can stay on. He can
stay and I'll see." The old prince snorted. "Let her marry, it's all
the same to me!" he screamed in the same piercing tone as when parting
from his son.

"I will tell you frankly," said Prince Vasili in the tone of a
crafty man convinced of the futility of being cunning with so
keen-sighted companion. "You know, you see right through people.
Anatole is no genius, but he is an honest, goodhearted lad; an
excellent son or kinsman."

"All right, all right, we'll see!"

As always happens when women lead lonely lives for any length of
time without male society, on Anatole's appearance all the three women
of Prince Bolkonski's household felt that their life had not been real
till then. Their powers of reasoning, feeling, and observing
immediately increased tenfold, and their life, which seemed to have
been passed in darkness, was suddenly lit up by a new brightness, full
of significance.

Princess Mary grew quite unconscious of her face and coiffure. The
handsome open face of the man who might perhaps be her husband
absorbed all her attention. He seemed to her kind, brave,
determined, manly, and magnanimous. She felt convinced of that.
Thousands of dreams of a future family life continually rose in her
imagination. She drove them away and tried to conceal them.

"But am I not too cold with him?" thought the princess. "I try to be
reserved because in the depth of my soul I feel too near to him
already, but then he cannot know what I think of him and may imagine
that I do not like him."

And Princess Mary tried, but could not manage, to be cordial to
her new guest. "Poor girl, she's devilish ugly!" thought Anatole.

Mademoiselle Bourienne, also roused to great excitement by Anatole's
arrival, thought in another way. Of course, she, a handsome young
woman without any definite position, without relations or even a
country, did not intend to devote her life to serving Prince
Bolkonski, to reading aloud to him and being friends with Princess
Mary. Mademoiselle Bourienne had long been waiting for a Russian
prince who, able to appreciate at a glance her superiority to the
plain, badly dressed, ungainly Russian princesses, would fall in
love with her and carry her off; and here at last was a Russian
prince. Mademoiselle Bourienne knew a story, heard from her aunt but
finished in her own way, which she liked to repeat to herself. It
was the story of a girl who had been seduced, and to whom her poor
mother (sa pauvre mere) appeared, and reproached her for yielding to a
man without being married. Mademoiselle Bourienne was often touched to
tears as in imagination she told this story to him, her seducer. And
now he, a real Russian prince, had appeared. He would carry her away
and then sa pauvre mere would appear and he would marry her. So her
future shaped itself in Mademoiselle Bourienne's head at the very time
she was talking to Anatole about Paris. It was not calculation that
guided her (she did not even for a moment consider what she should
do), but all this had long been familiar to her, and now that
Anatole had appeared it just grouped itself around him and she
wished and tried to please him as much as possible.

The little princess, like an old war horse that hears the trumpet,
unconsciously and quite forgetting her condition, prepared for the
familiar gallop of coquetry, without any ulterior motive or any
struggle, but with naive and lighthearted gaiety.

Although in female society Anatole usually assumed the role of a man
tired of being run after by women, his vanity was flattered by the
spectacle of his power over these three women. Besides that, he was
beginning to feel for the pretty and provocative Mademoiselle
Bourienne that passionate animal feeling which was apt to master him
with great suddenness and prompt him to the coarsest and most reckless
actions.

After tea, the company went into the sitting room and Princess
Mary was asked to play on the clavichord. Anatole, laughing and in
high spirits, came and leaned on his elbows, facing her and beside
Mademoiselle Bourienne. Princess Mary felt his look with a painfully
joyous emotion. Her favorite sonata bore her into a most intimately
poetic world and the look she felt upon her made that world still more
poetic. But Anatole's expression, though his eyes were fixed on her,
referred not to her but to the movements of Mademoiselle Bourienne's
little foot, which he was then touching with his own under the
clavichord. Mademoiselle Bourienne was also looking at Princess
Mary, and in her lovely eyes there was a look of fearful joy and
hope that was also new to the princess.

"How she loves me!" thought Princess Mary. "How happy I am now,
and how happy I may be with such a friend and such a husband! Husband?
Can it be possible?" she thought, not daring to look at his face,
but still feeling his eyes gazing at her.

In the evening, after supper, when all were about to retire, Anatole
kissed Princess Mary's hand. She did not know how she found the
courage, but she looked straight into his handsome face as it came
near to her shortsighted eyes. Turning from Princess Mary he went up
and kissed Mademoiselle Bourienne's hand. (This was not etiquette, but
then he did everything so simply and with such assurance!)
Mademoiselle Bourienne flushed, and gave the princess a frightened
look.

"What delicacy!" thought the princess. "Is it possible that Amelie"
(Mademoiselle Bourienne) "thinks I could be jealous of her, and not
value her pure affection and devotion to me?" She went up to her and
kissed her warmly. Anatole went up to kiss the little princess' hand.

"No! No! No! When your father writes to tell me that you are
behaving well I will give you my hand to kiss. Not till then!" she
said. And smilingly raising a finger at him, she left the room.




CHAPTER V


They all separated, but, except Anatole who fell asleep as soon as
he got into bed, all kept awake a long time that night.

"Is he really to be my husband, this stranger who is so kind--yes,
kind, that is the chief thing," thought Princess Mary; and fear, which
she had seldom experienced, came upon her. She feared to look round,
it seemed to her that someone was there standing behind the screen
in the dark corner. And this someone was he--the devil--and he was
also this man with the white forehead, black eyebrows, and red lips.

She rang for her maid and asked her to sleep in her room.

Mademoiselle Bourienne walked up and down the conservatory for a
long time that evening, vainly expecting someone, now smiling at
someone, now working herself up to tears with the imaginary words of
her pauvre mere rebuking her for her fall.

The little princess grumbled to her maid that her bed was badly
made. She could not lie either on her face or on her side. Every
position was awkward and uncomfortable, and her burden oppressed her
now more than ever because Anatole's presence had vividly recalled
to her the time when she was not like that and when everything was
light and gay. She sat in an armchair in her dressing jacket and
nightcap and Katie, sleepy and disheveled, beat and turned the heavy
feather bed for the third time, muttering to herself.

"I told you it was all lumps and holes!" the little princess
repeated. "I should be glad enough to fall asleep, so it's not my
fault!" and her voice quivered like that of a child about to cry.

The old prince did not sleep either. Tikhon, half asleep, heard
him pacing angrily about and snorting. The old prince felt as though
he had been insulted through his daughter. The insult was the more
pointed because it concerned not himself but another, his daughter,
whom he loved more than himself. He kept telling himself that he would
consider the whole matter and decide what was right and how he
should act, but instead of that he only excited himself more and more.

"The first man that turns up--she forgets her father and
everything else, runs upstairs and does up her hair and wags her
tail and is unlike herself! Glad to throw her father over! And she
knew I should notice it. Fr... fr... fr! And don't I see that that
idiot had eyes only for Bourienne--I shall have to get rid of her. And
how is it she has not pride enough to see it? If she has no pride
for herself she might at least have some for my sake! She must be
shown that the blockhead thinks nothing of her and looks only at
Bourienne. No, she has no pride... but I'll let her see...."

The old prince knew that if he told his daughter she was making a
mistake and that Anatole meant to flirt with Mademoiselle Bourienne,
Princess Mary's self-esteem would be wounded and his point (not to
be parted from her) would be gained, so pacifying himself with this
thought, he called Tikhon and began to undress.

"What devil brought them here?" thought he, while Tikhon was putting
the nightshirt over his dried-up old body and gray-haired chest. "I
never invited them. They came to disturb my life--and there is not
much of it left."

"Devil take 'em!" he muttered, while his head was still covered by
the shirt.

Tikhon knew his master's habit of sometimes thinking aloud, and
therefore met with unaltered looks the angrily inquisitive
expression of the face that emerged from the shirt.

"Gone to bed?" asked the prince.

Tikhon, like all good valets, instinctively knew the direction of
his master's thoughts. He guessed that the question referred to Prince
Vasili and his son.

"They have gone to bed and put out their lights, your excellency."

"No good... no good..." said the prince rapidly, and thrusting his
feet into his slippers and his arms into the sleeves of his dressing
gown, he went to the couch on which he slept.

Though no words had passed between Anatole and Mademoiselle
Bourienne, they quite understood one another as to the first part of
their romance, up to the appearance of the pauvre mere; they
understood that they had much to say to one another in private and
so they had been seeking an opportunity since morning to meet one
another alone. When Princess Mary went to her father's room at the
usual hour, Mademoiselle Bourienne and Anatole met in the
conservatory.

Princess Mary went to the door of the study with special
trepidation. It seemed to her that not only did everybody know that
her fate would be decided that day, but that they also knew what she
thought about it. She read this in Tikhon's face and in that of Prince
Vasili's valet, who made her a low bow when she met him in the
corridor carrying hot water.

The old prince was very affectionate and careful in his treatment of
his daughter that morning. Princess Mary well knew this painstaking
expression of her father's. His face wore that expression when his dry
hands clenched with vexation at her not understanding a sum in
arithmetic, when rising from his chair he would walk away from her,
repeating in a low voice the same words several times over.

He came to the point at once, treating her ceremoniously.

"I have had a proposition made me concerning you," he said with an
unnatural smile. "I expect you have guessed that Prince Vasili has not
come and brought his pupil with him" (for some reason Prince Bolkonski
referred to Anatole as a "pupil") "for the sake of my beautiful
eyes. Last night a proposition was made me on your account and, as you
know my principles, I refer it to you."

"How am I to understand you, mon pere?" said the princess, growing
pale and then blushing.

"How understand me!" cried her father angrily. "Prince Vasili
finds you to his taste as a daughter-in-law and makes a proposal to
you on his pupil's behalf. That's how it's to be understood! 'How
understand it'!... And I ask you!"

"I do not know what you think, Father," whispered the princess.

"I? I? What of me? Leave me out of the question. I'm not going to
get married. What about you? That's what I want to know."

The princess saw that her father regarded the matter with
disapproval, but at that moment the thought occurred to her that her
fate would be decided now or never. She lowered her eyes so as not
to see the gaze under which she felt that she could not think, but
would only be able to submit from habit, and she said: "I wish only to
do your will, but if I had to express my own desire..." She had no
time to finish. The old prince interrupted her.

"That's admirable!" he shouted. "He will take you with your dowry
and take Mademoiselle Bourienne into the bargain. She'll be the
wife, while you..."

The prince stopped. He saw the effect these words had produced on
his daughter. She lowered her head and was ready to burst into tears.

"Now then, now then, I'm only joking!" he said. "Remember this,
Princess, I hold to the principle that a maiden has a full right to
choose. I give you freedom. Only remember that your life's happiness
depends on your decision. Never mind me!"

"But I do not know, Father!"

"There's no need to talk! He receives his orders and will marry
you or anybody; but you are free to choose.... Go to your room,
think it over, and come back in an hour and tell me in his presence:
yes or no. I know you will pray over it. Well, pray if you like, but
you had better think it over. Go! Yes or no, yes or no, yes or no!" he
still shouted when the princess, as if lost in a fog, had already
staggered out of the study.

Her fate was decided and happily decided. But what her father had
said about Mademoiselle Bourienne was dreadful. It was untrue to be
sure, but still it was terrible, and she could not help thinking of
it. She was going straight on through the conservatory, neither seeing
nor hearing anything, when suddenly the well-known whispering of
Mademoiselle Bourienne aroused her. She raised her eyes, and two steps
away saw Anatole embracing the Frenchwoman and whispering something to
her. With a horrified expression on his handsome face, Anatole
looked at Princess Mary, but did not at once take his arm from the
waist of Mademoiselle Bourienne who had not yet seen her.

"Who's that? Why? Wait a moment!" Anatole's face seemed to say.
Princess Mary looked at them in silence. She could not understand
it. At last Mademoiselle Bourienne gave a scream and ran away. Anatole
bowed to Princess Mary with a gay smile, as if inviting her to join in
a laugh at this strange incident, and then shrugging his shoulders
went to the door that led to his own apartments.

An hour later, Tikhon came to call Princess Mary to the old
prince; he added that Prince Vasili was also there. When Tikhon came
to her Princess Mary was sitting on the sofa in her room, holding
the weeping Mademoiselle Bourienne in her arms and gently stroking her
hair. The princess' beautiful eyes with all their former calm radiance
were looking with tender affection and pity at Mademoiselle
Bourienne's pretty face.

"No, Princess, I have lost your affection forever!" said
Mademoiselle Bourienne.

"Why? I love you more than ever," said Princess Mary, "and I will
try to do all I can for your happiness."

"But you despise me. You who are so pure can never understand
being so carried away by passion. Oh, only my poor mother..."

"I quite understand," answered Princess Mary, with a sad smile.
"Calm yourself, my dear. I will go to my father," she said, and went
out.

Prince Vasili, with one leg thrown high over the other and a
snuffbox in his hand, was sitting there with a smile of deep emotion
on his face, as if stirred to his heart's core and himself
regretting and laughing at his own sensibility, when Princess Mary
entered. He hurriedly took a pinch of snuff.

"Ah, my dear, my dear!" he began, rising and taking her by both
hands. Then, sighing, he added: "My son's fate is in your hands.
Decide, my dear, good, gentle Marie, whom I have always loved as a
daughter!"

He drew back and a real tear appeared in his eye.

"Fr... fr..." snorted Prince Bolkonski. "The prince is making a
proposition to you in his pupil's--I mean, his son's--name. Do you
wish or not to be Prince Anatole Kuragin's wife? Reply: yes or no," he
shouted, "and then I shall reserve the right to state my opinion also.
Yes, my opinion, and only my opinion," added Prince Bolkonski, turning
to Prince Vasili and answering his imploring look. "Yes, or no?"

"My desire is never to leave you, Father, never to separate my
life from yours. I don't wish to marry," she answered positively,
glancing at Prince Vasili and at her father with her beautiful eyes.

"Humbug! Nonsense! Humbug, humbug, humbug!" cried Prince
Bolkonski, frowning and taking his daughter's hand; he did not kiss
her, but only bending his forehead to hers just touched it, and
pressed her hand so that she winced and uttered a cry.

Prince Vasili rose.

"My dear, I must tell you that this is a moment I shall never, never
forget. But, my dear, will you not give us a little hope of touching
this heart, so kind and generous? Say 'perhaps'... The future is so
long. Say 'perhaps.'"

"Prince, what I have said is all there is in my heart. I thank you
for the honor, but I shall never be your son's wife."

"Well, so that's finished, my dear fellow! I am very glad to have
seen you. Very glad! Go back to your rooms, Princess. Go!" said the
old prince. "Very, very glad to have seen you," repeated he,
embracing Prince Vasili.

"My vocation is a different one," thought Princess Mary. "My
vocation is to be happy with another kind of happiness, the
happiness of love and self-sacrifice. And cost what it may, I will
arrange poor Amelie's happiness, she loves him so passionately, and so
passionately repents. I will do all I can to arrange the match between
them. If he is not rich I will give her the means; I will ask my
father and Andrew. I shall be so happy when she is his wife. She is so
unfortunate, a stranger, alone, helpless! And, oh God, how
passionately she must love him if she could so far forget herself!
Perhaps I might have done the same!..." thought Princess Mary.





CHAPTER VI


It was long since the Rostovs had news of Nicholas. Not till
midwinter was the count at last handed a letter addressed in his son's
handwriting. On receiving it, he ran on tiptoe to his study in alarm
and haste, trying to escape notice, closed the door, and began to read
the letter.

Anna Mikhaylovna, who always knew everything that passed in the
house, on hearing of the arrival of the letter went softly into the
room and found the count with it in his hand, sobbing and laughing
at the same time.

Anna Mikhaylovna, though her circumstances had improved, was still
living with the Rostovs.

"My dear friend?" said she, in a tone of pathetic inquiry,
prepared to sympathize in any way.

The count sobbed yet more.

"Nikolenka... a letter... wa... a... s... wounded... my darling
boy... the countess... promoted to be an officer... thank God... How
tell the little countess!"

Anna Mikhaylovna sat down beside him, with her own handkerchief
wiped the tears from his eyes and from the letter, then having dried
her own eyes she comforted the count, and decided that at dinner and
till teatime she would prepare the countess, and after tea, with God's
help, would inform her.

At dinner Anna Mikhaylovna talked the whole time about the war
news and about Nikolenka, twice asked when the last letter had been
received from him, though she knew that already, and remarked that
they might very likely be getting a letter from him that day. Each
time that these hints began to make the countess anxious and she
glanced uneasily at the count and at Anna Mikhaylovna, the latter very
adroitly turned the conversation to insignificant matters. Natasha,
who, of the whole family, was the most gifted with a capacity to
feel any shades of intonation, look, and expression, pricked up her
ears from the beginning of the meal and was certain that there was
some secret between her father and Anna Mikhaylovna, that it had
something to do with her brother, and that Anna Mikhaylovna was
preparing them for it. Bold as she was, Natasha, who knew how
sensitive her mother was to anything relating to Nikolenka, did not
venture to ask any questions at dinner, but she was too excited to eat
anything and kept wriggling about on her chair regardless of her
governess' remarks. After dinner, she rushed head long after Anna
Mikhaylovna and, dashing at her, flung herself on her neck as soon
as she overtook her in the sitting room.

"Auntie, darling, do tell me what it is!"

"Nothing, my dear."

"No, dearest, sweet one, honey, I won't give up--I know you know
something."

Anna Mikhaylovna shook her head.

"You are a little slyboots," she said.

"A letter from Nikolenka! I'm sure of it!" exclaimed Natasha,
reading confirmation in Anna Mikhaylovna's face.

"But for God's sake, be careful, you know how it may affect your
mamma."

"I will, I will, only tell me! You won't? Then I will go and tell at
once."

Anna Mikhaylovna, in a few words, told her the contents of the
letter, on condition that she should tell no one.

"No, on my true word of honor," said Natasha, crossing herself,
"I won't tell anyone!" and she ran off at once to Sonya.

"Nikolenka... wounded... a letter," she announced in gleeful
triumph.

"Nicholas!" was all Sonya said, instantly turning white.

Natasha, seeing the impression the of her brother's wound produced
on Sonya, felt for the first time the sorrowful side of the news.

She rushed to Sonya, hugged her, and began to cry.

"A little wound, but he has been made an officer; he is well now, he
wrote himself," said she through her tears.

"There now! It's true that all you women are crybabies," remarked
Petya, pacing the room with large, resolute strides. "Now I'm very
glad, very glad indeed, that my brother has distinguished himself
so. You are all blubberers and understand nothing."

Natasha smiled through her tears.

"You haven't read the letter?" asked Sonya.

"No, but she said that it was all over and that he's now an
officer."

"Thank God!" said Sonya, crossing herself. "But perhaps she deceived
you. Let us go to Mamma."

Petya paced the room in silence for a time.

"If I'd been in Nikolenka's place I would have killed even more of
those Frenchmen," he said. "What nasty brutes they are! I'd have
killed so many that there'd have been a heap of them."

"Hold your tongue, Petya, what a goose you are!"

"I'm not a goose, but they are who cry about trifles," said Petya.

"Do you remember him?" Natasha suddenly asked, after a moment's
silence.

Sonya smiled.

"Do I remember Nicholas?"

"No, Sonya, but do you remember so that you remember him
perfectly, remember everything?" said Natasha, with an expressive
gesture, evidently wishing to give her words a very definite
meaning. "I remember Nikolenka too, I remember him well," she said.
"But I don't remember Boris. I don't remember him a bit."

"What! You don't remember Boris?" asked Sonya in surprise.

"It's not that I don't remember--I know what he is like, but not
as I remember Nikolenka. Him--I just shut my eyes and remember, but
Boris... No!" (She shut her eyes.)"No! there's nothing at all."

"Oh, Natasha!" said Sonya, looking ecstatically and earnestly at her
friend as if she did not consider her worthy to hear what she meant to
say and as if she were saying it to someone else, with whom joking was
out of the question, "I am in love with your brother once for all and,
whatever may happen to him or to me, shall never cease to love him
as long as I live."

Natasha looked at Sonya with wondering and inquisitive eyes, and
said nothing. She felt that Sonya was speaking the truth, that there
was such love as Sonya was speaking of. But Natasha had not yet felt
anything like it. She believed it could be, but did not understand it.

"Shall you write to him?" she asked.

Sonya became thoughtful. The question of how to write to Nicholas,
and whether she ought to write, tormented her. Now that he was already
an officer and a wounded hero, would it be right to remind him of
herself and, as it might seem, of the obligations to her he had
taken on himself?

"I don't know. I think if he writes, I will write too," she said,
blushing.

"And you won't feel ashamed to write to him?"

Sonya smiled.

"No."

"And I should be ashamed to write to Boris. I'm not going to."

"Why should you be ashamed?"

"Well, I don't know. It's awkward and would make me ashamed."

"And I know why she'd be ashamed," said Petya, offended by Natasha's
previous remark. "It's because she was in love with that fat one in
spectacles" (that was how Petya described his namesake, the new
Count Bezukhov) "and now she's in love with that singer" (he meant
Natasha's Italian singing master), "that's why she's ashamed!"

"Petya, you're a stupid!" said Natasha.

"Not more stupid than you, madam," said the nine-year-old Petya,
with the air of an old brigadier.

The countess had been prepared by Anna Mikhaylovna's hints at
dinner. On retiring to her own room, she sat in an armchair, her
eyes fixed on a miniature portrait of her son on the lid of a
snuffbox, while the tears kept coming into her eyes. Anna Mikhaylovna,
with the letter, came on tiptoe to the countess' door and paused.

"Don't come in," she said to the old count who was following her.
"Come later." And she went in, closing the door behind her.

The count put his ear to the keyhole and listened.

At first he heard the sound of indifferent voices, then Anna
Mikhaylovna's voice alone in a long speech, then a cry, then
silence, then both voices together with glad intonations, and then
footsteps. Anna Mikhaylovna opened the door. Her face wore the proud
expression of a surgeon who has just performed a difficult operation
and admits the public to appreciate his skill.

"It is done!" she said to the count, pointing triumphantly to the
countess, who sat holding in one hand the snuffbox with its portrait
and in the other the letter, and pressing them alternately to her
lips.

When she saw the count, she stretched out her arms to him,
embraced his bald head, over which she again looked at the letter
and the portrait, and in order to press them again to her lips, she
slightly pushed away the bald head. Vera, Natasha, Sonya, and Petya
now entered the room, and the reading of the letter began. After a
brief description of the campaign and the two battles in which he
had taken part, and his promotion, Nicholas said that he kissed his
father's and mother's hands asking for their blessing, and that he
kissed Vera, Natasha, and Petya. Besides that, he sent greetings to
Monsieur Schelling, Madame Schoss, and his old nurse, and asked them
to kiss for him "dear Sonya, whom he loved and thought of just the
same as ever." When she heard this Sonya blushed so that tears came
into her eyes and, unable to bear the looks turned upon her, ran
away into the dancing hall, whirled round it at full speed with her
dress puffed out like a balloon, and, flushed and smiling, plumped
down on the floor. The countess was crying.

"Why are you crying, Mamma?" asked Vera. "From all he says one
should be glad and not cry."

This was quite true, but the count, the countess, and Natasha looked
at her reproachfully. "And who is it she takes after?" thought the
countess.

Nicholas' letter was read over hundreds of times, and those who were
considered worthy to hear it had to come to the countess, for she
did not let it out of her hands. The tutors came, and the nurses,
and Dmitri, and several acquaintances, and the countess reread the
letter each time with fresh pleasure and each time discovered in it
fresh proofs of Nikolenka's virtues. How strange, how extraordinary,
how joyful it seemed, that her son, the scarcely perceptible motion of
whose tiny limbs she had felt twenty years ago within her, that son
about whom she used to have quarrels with the too indulgent count,
that son who had first learned to say "pear" and then "granny," that
this son should now be away in a foreign land amid strange
surroundings, a manly warrior doing some kind of man's work of his
own, without help or guidance. The universal experience of ages,
showing that children do grow imperceptibly from the cradle to
manhood, did not exist for the countess. Her son's growth toward
manhood, at each of its stages, had seemed as extraordinary to her
as if there had never existed the millions of human beings who grew up
in the same way. As twenty years before, it seemed impossible that the
little creature who lived somewhere under her heart would ever cry,
suck her breast, and begin to speak, so now she could not believe that
that little creature could be this strong, brave man, this model son
and officer that, judging by this letter, he now was.

"What a style! How charmingly he describes!" said she, reading the
descriptive part of the letter. "And what a soul! Not a word about
himself.... Not a word! About some Denisov or other, though he
himself, I dare say, is braver than any of them. He says nothing about
his sufferings. What a heart! How like him it is! And how he has
remembered everybody! Not forgetting anyone. I always said when he was
only so high--I always said...."

For more than a week preparations were being made, rough drafts of
letters to Nicholas from all the household were written and copied
out, while under the supervision of the countess and the solicitude of
the count, money and all things necessary for the uniform and
equipment of the newly commissioned officer were collected. Anna
Mikhaylovna, practical woman that she was, had even managed by favor
with army authorities to secure advantageous means of communication
for herself and her son. She had opportunities of sending her
letters to the Grand Duke Constantine Pavlovich, who commanded the
Guards. The Rostovs supposed that The Russian Guards, Abroad, was
quite a definite address, and that if a letter reached the Grand
Duke in command of the Guards there was no reason why it should not
reach the Pavlograd regiment, which was presumably somewhere in the
same neighborhood. And so it was decided to send the letters and money
by the Grand Duke's courier to Boris and Boris was to forward them
to Nicholas. The letters were from the old count, the countess, Petya,
Vera, Natasha, and Sonya, and finally there were six thousand rubles
for his outfit and various other things the old count sent to his son.





CHAPTER VII


On the twelfth of November, Kutuzov's active army, in camp before
Olmutz, was preparing to be reviewed next day by the two Emperors--the
Russian and the Austrian. The Guards, just arrived from Russia,
spent the night ten miles from Olmutz and next morning were to come
straight to the review, reaching the field at Olmutz by ten o'clock.

That day Nicholas Rostov received a letter from Boris, telling him
that the Ismaylov regiment was quartered for the night ten miles
from Olmutz and that he wanted to see him as he had a letter and money
for him. Rostov was particularly in need of money now that the troops,
after their active service, were stationed near Olmutz and the camp
swarmed with well-provisioned sutlers and Austrian Jews offering all
sorts of tempting wares. The Pavlograds held feast after feast,
celebrating awards they had received for the campaign, and made
expeditions to Olmutz to visit a certain Caroline the Hungarian, who
had recently opened a restaurant there with girls as waitresses.
Rostov, who had just celebrated his promotion to a cornetcy and bought
Denisov's horse, Bedouin, was in debt all round, to his comrades and
the sutlers. On receiving Boris' letter he rode with a fellow
officer to Olmutz, dined there, drank a bottle of wine, and then set
off alone to the Guards' camp to find his old playmate. Rostov had not
yet had time to get his uniform. He had on a shabby cadet jacket,
decorated with a soldier's cross, equally shabby cadet's riding
breeches lined with worn leather, and an officer's saber with a
sword knot. The Don horse he was riding was one he had bought from a
Cossack during the campaign, and he wore a crumpled hussar cap stuck
jauntily back on one side of his head. As he rode up to the camp he
thought how he would impress Boris and all his comrades of the
Guards by his appearance--that of a fighting hussar who had been under
fire.

The Guards had made their whole march as if on a pleasure trip,
parading their cleanliness and discipline. They had come by easy
stages, their knapsacks conveyed on carts, and the Austrian
authorities had provided excellent dinners for the officers at every
halting place. The regiments had entered and left the town with
their bands playing, and by the Grand Duke's orders the men had
marched all the way in step (a practice on which the Guards prided
themselves), the officers on foot and at their proper posts. Boris had
been quartered, and had marched all the way, with Berg who was already
in command of a company. Berg, who had obtained his captaincy during
the campaign, had gained the confidence of his superiors by his
promptitude and accuracy and had arranged his money matters very
satisfactorily. Boris, during the campaign, had made the
acquaintance of many persons who might prove useful to him, and by a
letter of recommendation he had brought from Pierre had become
acquainted with Prince Andrew Bolkonski, through whom he hoped to
obtain a post on the commander in chief's staff. Berg and Boris,
having rested after yesterday's march, were sitting, clean and
neatly dressed, at a round table in the clean quarters allotted to
them, playing chess. Berg held a smoking pipe between his knees.
Boris, in the accurate way characteristic of him, was building a
little pyramid of chessmen with his delicate white fingers while
awaiting Berg's move, and watched his opponent's face, evidently
thinking about the game as he always thought only of whatever he was
engaged on.

"Well, how are you going to get out of that?" he remarked.

"We'll try to," replied Berg, touching a pawn and then removing
his hand.

At that moment the door opened.

"Here he is at last!" shouted Rostov. "And Berg too! Oh, you
petisenfans, allay cushay dormir!" he exclaimed, imitating his Russian
nurse's French, at which he and Boris used to laugh long ago.

"Dear me, how you have changed!"

Boris rose to meet Rostov, but in doing so did not omit to steady
and replace some chessmen that were falling. He was about to embrace
his friend, but Nicholas avoided him. With that peculiar feeling of
youth, that dread of beaten tracks, and wish to express itself in a
manner different from that of its elders which is often insincere,
Nicholas wished to do something special on meeting his friend. He
wanted to pinch him, push him, do anything but kiss him--a thing
everybody did. But notwithstanding this, Boris embraced him in a
quiet, friendly way and kissed him three times.

They had not met for nearly half a year and, being at the age when
young men take their first steps on life's road, each saw immense
changes in the other, quite a new reflection of the society in which
they had taken those first steps. Both had changed greatly since
they last met and both were in a hurry to show the changes that had
taken place in them.

"Oh, you damned dandies! Clean and fresh as if you'd been to a fete,
not like us sinners of the line," cried Rostov, with martial swagger
and with baritone notes in his voice, new to Boris, pointing to his
own mud-bespattered breeches. The German landlady, hearing Rostov's
loud voice, popped her head in at the door.

"Eh, is she pretty?" he asked with a wink.

"Why do you shout so? You'll frighten them!" said Boris. "I did
not expect you today," he added. "I only sent you the note yesterday
by Bolkonski--an adjutant of Kutuzov's, who's a friend of mine. I
did not think he would get it to you so quickly.... Well, how are you?
Been under fire already?" asked Boris.

Without answering, Rostov shook the soldier's Cross of St. George
fastened to the cording of his uniform and, indicating a bandaged arm,
glanced at Berg with a smile.

"As you see," he said.

"Indeed? Yes, yes!" said Boris, with a smile. "And we too have had a
splendid march. You know, of course, that His Imperial Highness rode
with our regiment all the time, so that we had every comfort and every
advantage. What receptions we had in Poland! What dinners and balls! I
can't tell you. And the Tsarevich was very gracious to all our
officers."

And the two friends told each other of their doings, the one of
his hussar revels and life in the fighting line, the other of the
pleasures and advantages of service under members of the Imperial
family.

"Oh, you Guards!" said Rostov. "I say, send for some wine."

Boris made a grimace.

"If you really want it," said he.

He went to his bed, drew a purse from under the clean pillow, and
sent for wine.

"Yes, and I have some money and a letter to give you," he added.

Rostov took the letter and, throwing the money on the sofa, put both
arms on the table and began to read. After reading a few lines, he
glanced angrily at Berg, then, meeting his eyes, hid his face behind
the letter.

"Well, they've sent you a tidy sum," said Berg, eying the heavy
purse that sank into the sofa. "As for us, Count, we get along on
our pay. I can tell you for myself..."

"I say, Berg, my dear fellow," said Rostov, "when you get a letter
from home and meet one of your own people whom you want to talk
everything over with, and I happen to be there, I'll go at once, to be
out of your way! Do go somewhere, anywhere... to the devil!" he
exclaimed, and immediately seizing him by the shoulder and looking
amiably into his face, evidently wishing to soften the rudeness of his
words, he added, "Don't be hurt, my dear fellow; you know I speak from
my heart as to an old acquaintance."

"Oh, don't mention it, Count! I quite understand," said Berg,
getting up and speaking in a muffled and guttural voice.

"Go across to our hosts: they invited you," added Boris.

Berg put on the cleanest of coats, without a spot or speck of
dust, stood before a looking glass and brushed the hair on his temples
upwards, in the way affected by the Emperor Alexander, and, having
assured himself from the way Rostov looked at it that his coat had
been noticed, left the room with a pleasant smile.

"Oh dear, what a beast I am!" muttered Rostov, as he read the
letter.

"Why?"

"Oh, what a pig I am, not to have written and to have given them
such a fright! Oh, what a pig I am!" he repeated, flushing suddenly.
"Well, have you sent Gabriel for some wine? All right let's have
some!"

In the letter from his parents was enclosed a letter of
recommendation to Bagration which the old countess at Anna
Mikhaylovna's advice had obtained through an acquaintance and sent
to her son, asking him to take it to its destination and make use of
it.

"What nonsense! Much I need it!" said Rostov, throwing the letter
under the table.

"Why have you thrown that away?" asked Boris.

"It is some letter of recommendation... what the devil do I want
it for!"

"Why 'What the devil'?" said Boris, picking it up and reading the
address. "This letter would be of great use to you."

"I want nothing, and I won't be anyone's adjutant."

"Why not?" inquired Boris.

"It's a lackey's job!"

"You are still the same dreamer, I see," remarked Boris, shaking his
head.

"And you're still the same diplomatist! But that's not the
point... Come, how are you?" asked Rostov.

"Well, as you see. So far everything's all right, but I confess I
should much like to be an adjutant and not remain at the front."

"Why?"

"Because when once a man starts on military service, he should try
to make as successful a career of it as possible."

"Oh, that's it!" said Rostov, evidently thinking of something else.

He looked intently and inquiringly into his friend's eyes, evidently
trying in vain to find the answer to some question.

Old Gabriel brought in the wine.

"Shouldn't we now send for Berg?" asked Boris. "He would drink
with you. I can't."

"Well, send for him... and how do you get on with that German?"
asked Rostov, with a contemptuous smile.

"He is a very, very nice, honest, and pleasant fellow," answered
Boris.

Again Rostov looked intently into Boris' eyes and sighed. Berg
returned, and over the bottle of wine conversation between the three
officers became animated. The Guardsmen told Rostov of their march and
how they had been made much of in Russia, Poland, and abroad. They
spoke of the sayings and doings of their commander, the Grand Duke,
and told stories of his kindness and irascibility. Berg, as usual,
kept silent when the subject did not relate to himself, but in
connection with the stories of the Grand Duke's quick temper he
related with gusto how in Galicia he had managed to deal with the
Grand Duke when the latter made a tour of the regiments and was
annoyed at the irregularity of a movement. With a pleasant smile
Berg related how the Grand Duke had ridden up to him in a violent
passion, shouting: "Arnauts!" ("Arnauts" was the Tsarevich's
favorite expression when he was in a rage) and called for the
company commander.

"Would you believe it, Count, I was not at all alarmed, because I
knew I was right. Without boasting, you know, I may say that I know
the Army Orders by heart and know the Regulations as well as I do
the Lord's Prayer. So, Count, there never is any negligence in my
company, and so my conscience was at ease. I came forward...." (Berg
stood up and showed how he presented himself, with his hand to his
cap, and really it would have been difficult for a face to express
greater respect and self-complacency than his did.) "Well, he
stormed at me, as the saying is, stormed and stormed and stormed! It
was not a matter of life but rather of death, as the saying is.
'Albanians!' and 'devils!' and 'To Siberia!'" said Berg with a
sagacious smile. "I knew I was in the right so I kept silent; was
not that best, Count?... 'Hey, are you dumb?' he shouted. Still I
remained silent. And what do you think, Count? The next day it was not
even mentioned in the Orders of the Day. That's what keeping one's
head means. That's the way, Count," said Berg, lighting his pipe and
emitting rings of smoke.

"Yes, that was fine," said Rostov, smiling.

But Boris noticed that he was preparing to make fun of Berg, and
skillfully changed the subject. He asked him to tell them how and
where he got his wound. This pleased Rostov and he began talking about
it, and as he went on became more and more animated. He told them of
his Schon Grabern affair, just as those who have taken part in a
battle generally do describe it, that is, as they would like it to
have been, as they have heard it described by others, and as sounds
well, but not at all as it really was. Rostov was a truthful young man
and would on no account have told a deliberate lie. He began his story
meaning to tell everything just as it happened, but imperceptibly,
involuntarily, and inevitably he lapsed into falsehood. If he had told
the truth to his hearers--who like himself had often heard stories
of attacks and had formed a definite idea of what an attack was and
were expecting to hear just such a story--they would either not have
believed him or, still worse, would have thought that Rostov was
himself to blame since what generally happens to the narrators of
cavalry attacks had not happened to him. He could not tell them simply
that everyone went at a trot and that he fell off his horse and
sprained his arm and then ran as hard as he could from a Frenchman
into the wood. Besides, to tell everything as it really happened, it
would have been necessary to make an effort of will to tell only
what happened. It is very difficult to tell the truth, and young
people are rarely capable of it. His hearers expected a story of how
beside himself and all aflame with excitement, he had flown like a
storm at the square, cut his way in, slashed right and left, how his
saber had tasted flesh and he had fallen exhausted, and so on. And
so he told them all that.

In the middle of his story, just as he was saying: "You cannot
imagine what a strange frenzy one experiences during an attack,"
Prince Andrew, whom Boris was expecting, entered the room. Prince
Andrew, who liked to help young men, was flattered by being asked
for his assistance and being well disposed toward Boris, who had
managed to please him the day before, he wished to do what the young
man wanted. Having been sent with papers from Kutuzov to the
Tsarevich, he looked in on Boris, hoping to find him alone. When he
came in and saw an hussar of the line recounting his military exploits
(Prince Andrew could not endure that sort of man), he gave Boris a
pleasant smile, frowned as with half-closed eyes he looked at
Rostov, bowed slightly and wearily, and sat down languidly on the
sofa: he felt it unpleasant to have dropped in on bad company.
Rostov flushed up on noticing this, but he did not care, this was a
mere stranger. Glancing, however, at Boris, he saw that he too
seemed ashamed of the hussar of the line.

In spite of Prince Andrew's disagreeable, ironical tone, in spite of
the contempt with which Rostov, from his fighting army point of
view, regarded all these little adjutants on the staff of whom the
newcomer was evidently one, Rostov felt confused, blushed, and
became silent. Boris inquired what news there might be on the staff,
and what, without indiscretion, one might ask about our plans.

"We shall probably advance," replied Bolkonski, evidently
reluctant to say more in the presence of a stranger.

Berg took the opportunity to ask, with great politeness, whether, as
was rumored, the allowance of forage money to captains of companies
would be doubled. To this Prince Andrew answered with a smile that
he could give no opinion on such an important government order, and
Berg laughed gaily.

"As to your business," Prince Andrew continued, addressing Boris,
"we will talk of it later" (and he looked round at Rostov). "Come to
me after the review and we will do what is possible."

And, having glanced round the room, Prince Andrew turned to
Rostov, whose state of unconquerable childish embarrassment now
changing to anger he did not condescend to notice, and said: "I
think you were talking of the Schon Grabern affair? Were you there?"

"I was there," said Rostov angrily, as if intending to insult the
aide-de-camp.

Bolkonski noticed the hussar's state of mind, and it amused him.
With a slightly contemptuous smile, he said: "Yes, there are many
stories now told about that affair!"

"Yes, stories!" repeated Rostov loudly, looking with eyes suddenly
grown furious, now at Boris, now at Bolkonski. "Yes, many stories! But
our stories are the stories of men who have been under the enemy's
fire! Our stories have some weight, not like the stories of those
fellows on the staff who get rewards without doing anything!"

"Of whom you imagine me to be one?" said Prince Andrew, with a quiet
and particularly amiable smile.

A strange feeling of exasperation and yet of respect for this
man's self-possession mingled at that moment in Rostov's soul.

"I am not talking about you," he said, "I don't know you and,
frankly, I don't want to. I am speaking of the staff in general."

"And I will tell you this," Prince Andrew interrupted in a tone of
quiet authority, "you wish to insult me, and I am ready to agree
with you that it would be very easy to do so if you haven't sufficient
self-respect, but admit that the time and place are very badly chosen.
In a day or two we shall all have to take part in a greater and more
serious duel, and besides, Drubetskoy, who says he is an old friend of
yours, is not at all to blame that my face has the misfortune to
displease you. However," he added rising, "you know my name and
where to find me, but don't forget that I do not regard either
myself or you as having been at all insulted, and as a man older
than you, my advice is to let the matter drop. Well then, on Friday
after the review I shall expect you, Drubetskoy. Au revoir!" exclaimed
Prince Andrew, and with a bow to them both he went out.

Only when Prince Andrew was gone did Rostov think of what he ought
to have said. And he was still more angry at having omitted to say it.
He ordered his horse at once and, coldly taking leave of Boris, rode
home. Should he go to headquarters next day and challenge that
affected adjutant, or really let the matter drop, was the question
that worried him all the way. He thought angrily of the pleasure he
would have at seeing the fright of that small and frail but proud
man when covered by his pistol, and then he felt with surprise that of
all the men he knew there was none he would so much like to have for a
friend as that very adjutant whom he so hated.





CHAPTER VIII


The day after Rostov had been to see Boris, a review was held of the
Austrian and Russian troops, both those freshly arrived from Russia
and those who had been campaigning under Kutuzov. The two Emperors,
the Russian with his heir the Tsarevich, and the Austrian with the
Archduke, inspected the allied army of eighty thousand men.

From early morning the smart clean troops were on the move,
forming up on the field before the fortress. Now thousands of feet and
bayonets moved and halted at the officers' command, turned with
banners flying, formed up at intervals, and wheeled round other
similar masses of infantry in different uniforms; now was heard the
rhythmic beat of hoofs and the jingling of showy cavalry in blue, red,
and green braided uniforms, with smartly dressed bandsmen in front
mounted on black, roan, or gray horses; then again, spreading out with
the brazen clatter of the polished shining cannon that quivered on the
gun carriages and with the smell of linstocks, came the artillery
which crawled between the infantry and cavalry and took up its
appointed position. Not only the generals in full parade uniforms,
with their thin or thick waists drawn in to the utmost, their red
necks squeezed into their stiff collars, and wearing scarves and all
their decorations, not only the elegant, pomaded officers, but every
soldier with his freshly washed and shaven face and his weapons
clean and polished to the utmost, and every horse groomed till its
coat shone like satin and every hair of its wetted mane lay smooth-
felt that no small matter was happening, but an important and solemn
affair. Every general and every soldier was conscious of his own
insignificance, aware of being but a drop in that ocean of men, and
yet at the same time was conscious of his strength as a part of that
enormous whole.

From early morning strenuous activities and efforts had begun and by
ten o'clock all had been brought into due order. The ranks were
drown up on the vast field. The whole army was extended in three
lines: the cavalry in front, behind it the artillery, and behind
that again the infantry.

A space like a street was left between each two lines of troops. The
three parts of that army were sharply distinguished: Kutuzov's
fighting army (with the Pavlograds on the right flank of the front);
those recently arrived from Russia, both Guards and regiments of the
line; and the Austrian troops. But they all stood in the same lines,
under one command, and in a like order.

Like wind over leaves ran an excited whisper: "They're coming!
They're coming!" Alarmed voices were heard, and a stir of final
preparation swept over all the troops.

From the direction of Olmutz in front of them, a group was seen
approaching. And at that moment, though the day was still, a light
gust of wind blowing over the army slightly stirred the streamers on
the lances and the unfolded standards fluttered against their
staffs. It looked as if by that slight motion the army itself was
expressing its joy at the approach of the Emperors. One voice was
heard shouting: "Eyes front!" Then, like the crowing of cocks at
sunrise, this was repeated by others from various sides and all became
silent.

In the deathlike stillness only the tramp of horses was heard.
This was the Emperors' suites. The Emperors rode up to the flank,
and the trumpets of the first cavalry regiment played the general
march. It seemed as though not the trumpeters were playing, but as
if the army itself, rejoicing at the Emperors' approach, had naturally
burst into music. Amid these sounds, only the youthful kindly voice of
the Emperor Alexander was clearly heard. He gave the words of
greeting, and the first regiment roared "Hurrah!" so deafeningly,
continuously, and joyfully that the men themselves were awed by
their multitude and the immensity of the power they constituted.

Rostov, standing in the front lines of Kutuzov's army which the Tsar
approached first, experienced the same feeling as every other man in
that army: a feeling of self-forgetfulness, a proud consciousness of
might, and a passionate attraction to him who was the cause of this
triumph.

He felt that at a single word from that man all this vast mass
(and he himself an insignificant atom in it) would go through fire and
water, commit crime, die, or perform deeds of highest heroism, and
so he could not but tremble and his heart stand still at the imminence
of that word.

"Hurrah! Hurrah! Hurrah!" thundered from all sides, one regiment
after another greeting the Tsar with the strains of the march, and
then "Hurrah!"... Then the general march, and again "Hurrah!
Hurrah!" growing ever stronger and fuller and merging into a deafening
roar.

Till the Tsar reached it, each regiment in its silence and
immobility seemed like a lifeless body, but as soon as he came up it
became alive, its thunder joining the roar of the whole line along
which he had already passed. Through the terrible and deafening roar
of those voices, amid the square masses of troops standing
motionless as if turned to stone, hundreds of riders composing the
suites moved carelessly but symmetrically and above all freely, and in
front of them two men--the Emperors. Upon them the undivided,
tensely passionate attention of that whole mass of men was
concentrated.

The handsome young Emperor Alexander, in the uniform of the Horse
Guards, wearing a cocked hat with its peaks front and back, with his
pleasant face and resonant though not loud voice, attracted everyone's
attention.

Rostov was not far from the trumpeters, and with his keen sight
had recognized the Tsar and watched his approach. When he was within
twenty paces, and Nicholas could clearly distinguish every detail of
his handsome, happy young face, he experienced a feeling tenderness
and ecstasy such as he had never before known. Every trait and every
movement of the Tsar's seemed to him enchanting.

Stopping in front of the Pavlograds, the Tsar said something in
French to the Austrian Emperor and smiled.

Seeing that smile, Rostov involuntarily smiled himself and felt a
still stronger flow of love for his sovereign. He longed to show
that love in some way and knowing that this was impossible was ready
to cry. The Tsar called the colonel of the regiment and said a few
words to him.

"Oh God, what would happen to me if the Emperor spoke to me?"
thought Rostov. "I should die of happiness!"

The Tsar addressed the officers also: "I thank you all, gentlemen, I
thank you with my whole heart." To Rostov every word sounded like a
voice from heaven. How gladly would he have died at once for his Tsar!

"You have earned the St. George's standards and will be worthy of
them."

"Oh, to die, to die for him," thought Rostov.

The Tsar said something more which Rostov did not hear, and the
soldiers, straining their lungs, shouted "Hurrah!"

Rostov too, bending over his saddle, shouted "Hurrah!" with all
his might, feeling that he would like to injure himself by that shout,
if only to express his rapture fully.

The Tsar stopped a few minutes in front of the hussars as if
undecided.

"How can the Emperor be undecided?" thought Rostov, but then even
this indecision appeared to him majestic and enchanting, like
everything else the Tsar did.

That hesitation lasted only an instant. The Tsar's foot, in the
narrow pointed boot then fashionable, touched the groin of the
bobtailed bay mare he rode, his hand in a white glove gathered up
the reins, and he moved off accompanied by an irregularly swaying
sea of aides-de-camp. Farther and farther he rode away, stopping at
other regiments, till at last only his white plumes were visible to
Rostov from amid the suites that surrounded the Emperors.

Among the gentlemen of the suite, Rostov noticed Bolkonski,
sitting his horse indolently and carelessly. Rostov recalled their
quarrel of yesterday and the question presented itself whether he
ought or ought not to challenge Bolkonski. "Of course not!" he now
thought. "Is it worth thinking or speaking of it at such a moment?
At a time of such love, such rapture, and such self-sacrifice, what do
any of our quarrels and affronts matter? I love and forgive
everybody now."

When the Emperor had passed nearly all the regiments, the troops
began a ceremonial march past him, and Rostov on Bedouin, recently
purchased from Denisov, rode past too, at the rear of his squadron-
that is, alone and in full view of the Emperor.

Before he reached him, Rostov, who was a splendid horseman,
spurred Bedouin twice and successfully put him to the showy trot in
which the animal went when excited. Bending his foaming muzzle to
his chest, his tail extended, Bedouin, as if also conscious of the
Emperor's eye upon him, passed splendidly, lifting his feet with a
high and graceful action, as if flying through the air without
touching the ground.

Rostov himself, his legs well back and his stomach drawn in and
feeling himself one with his horse, rode past the Emperor with a
frowning but blissful face "like a vewy devil," as Denisov expressed
it.

"Fine fellows, the Pavlograds!" remarked the Emperor.

"My God, how happy I should be if he ordered me to leap into the
fire this instant!" thought Rostov.

When the review was over, the newly arrived officers, and also
Kutuzov's, collected in groups and began to talk about the awards,
about the Austrians and their uniforms, about their lines, about
Bonaparte, and how badly the latter would fare now, especially if
the Essen corps arrived and Prussia took our side.

But the talk in every group was chiefly about the Emperor Alexander.
His every word and movement was described with ecstasy.

They all had but one wish: to advance as soon as possible against
the enemy under the Emperor's command. Commanded by the Emperor
himself they could not fail to vanquish anyone, be it whom it might:
so thought Rostov and most of the officers after the review.

All were then more confident of victory than the winning of two
battles would have made them.





CHAPTER IX


The day after the review, Boris, in his best uniform and with his
comrade Berg's best wishes for success, rode to Olmutz to see
Bolkonski, wishing to profit by his friendliness and obtain for
himself the best post he could--preferably that of adjutant to some
important personage, a position in the army which seemed to him most
attractive. "It is all very well for Rostov, whose father sends him
ten thousand rubles at a time, to talk about not wishing to cringe
to anybody and not be anyone's lackey, but I who have nothing but my
brains have to make a career and must not miss opportunities, but must
avail myself of them!" he reflected.

He did not find Prince Andrew in Olmutz that day, but the appearance
of the town where the headquarters and the diplomatic corps were
stationed and the two Emperors were living with their suites,
households, and courts only strengthened his desire to belong to
that higher world.

He knew no one, and despite his smart Guardsman's uniform, all these
exalted personages passing in the streets in their elegant carriages
with their plumes, ribbons, and medals, both courtiers and military
men, seemed so immeasurably above him, an insignificant officer of the
Guards, that they not only did not wish to, but simply could not, be
aware of his existence. At the quarters of the commander in chief,
Kutuzov, where he inquired for Bolkonski, all the adjutants and even
the orderlies looked at him as if they wished to impress on him that a
great many officers like him were always coming there and that
everybody was heartily sick of them. In spite of this, or rather
because of it, next day, November 15, after dinner he again went to
Olmutz and, entering the house occupied by Kutuzov, asked for
Bolkonski. Prince Andrew was in and Boris was shown into a large
hall probably formerly used for dancing, but in which five beds now
stood, and furniture of various kinds: a table, chairs, and a
clavichord. One adjutant, nearest the door, was sitting at the table
in a Persian dressing gown, writing. Another, the red, stout
Nesvitski, lay on a bed with his arms under his head, laughing with an
officer who had sat down beside him. A third was playing a Viennese
waltz on the clavichord, while a fourth, lying on the clavichord, sang
the tune. Bolkonski was not there. None of these gentlemen changed his
position on seeing Boris. The one who was writing and whom Boris
addressed turned round crossly and told him Bolkonski was on duty
and that he should go through the door on the left into the
reception room if he wished to see him. Boris thanked him and went
to the reception room, where he found some ten officers and generals.

When he entered, Prince Andrew, his eyes drooping contemptuously
(with that peculiar expression of polite weariness which plainly says,
"If it were not my duty I would not talk to you for a moment"), was
listening to an old Russian general with decorations, who stood very
erect, almost on tiptoe, with a soldier's obsequious expression on his
purple face, reporting something.

"Very well, then, be so good as to wait," said Prince Andrew to
the general, in Russian, speaking with the French intonation he
affected when he wished to speak contemptuously, and noticing Boris,
Prince Andrew, paying no more heed to the general who ran after him
imploring him to hear something more, nodded and turned to him with
a cheerful smile.

At that moment Boris clearly realized what he had before surmised,
that in the army, besides the subordination and discipline
prescribed in the military code, which he and the others knew in the
regiment, there was another, more important, subordination, which made
this tight-laced, purple-faced general wait respectfully while Captain
Prince Andrew, for his own pleasure, chose to chat with Lieutenant
Drubetskoy. More than ever was Boris resolved to serve in future not
according to the written code, but under this unwritten law. He felt
now that merely by having been recommended to Prince Andrew he had
already risen above the general who at the front had the power to
annihilate him, a lieutenant of the Guards. Prince Andrew came up to
him and took his hand.


"I am very sorry you did not find me in yesterday. I was fussing
about with Germans all day. We went with Weyrother to survey the
dispositions. When Germans start being accurate, there's no end to
it!"

Boris smiled, as if he understood what Prince Andrew was alluding to
as something generally known. But it the first time he had heard
Weyrother's name, or even the term "dispositions."

"Well, my dear fellow, so you still want to be an adjutant? I have
been thinking about you."

"Yes, I was thinking"--for some reason Boris could not help
blushing--"of asking the commander in chief. He has had a letter
from Prince Kuragin about me. I only wanted to ask because I fear
the Guards won't be in action," he added as if in apology.

"All right, all right. We'll talk it over," replied Prince Andrew.
"Only let me report this gentleman's business, and I shall be at
your disposal."

While Prince Andrew went to report about the purple-faced general,
that gentleman--evidently not sharing Boris' conception of the
advantages of the unwritten code of subordination--looked so fixedly
at the presumptuous lieutenant who had prevented his finishing what he
had to say to the adjutant that Boris felt uncomfortable. He turned
away and waited impatiently for Prince Andrew's return from the
commander in chief's room.

"You see, my dear fellow, I have been thinking about you," said
Prince Andrew when they had gone into the large room where the
clavichord was. "It's no use your going to the commander in chief.
He would say a lot of pleasant things, ask you to dinner" ("That would
not be bad as regards the unwritten code," thought Boris), "but
nothing more would come of it. There will soon be a battalion of us
aides-de-camp and adjutants! But this is what we'll do: I have a
good friend, an adjutant general and an excellent fellow, Prince
Dolgorukov; and though you may not know it, the fact is that now
Kutuzov with his staff and all of us count for nothing. Everything
is now centered round the Emperor. So we will go to Dolgorukov; I have
to go there anyhow and I have already spoken to him about you. We
shall see whether he cannot attach you to himself or find a place
for you somewhere nearer the sun."

Prince Andrew always became specially keen when he had to guide a
young man and help him to worldly success. Under cover of obtaining
help of this kind for another, which from pride he would never
accept for himself, he kept in touch with the circle which confers
success and which attracted him. He very readily took up Boris'
cause and went with him to Dolgorukov.

It was late in the evening when they entered the palace at Olmutz
occupied by the Emperors and their retinues.

That same day a council of war had been held in which all the
members of the Hofkriegsrath and both Emperors took part. At that
council, contrary to the views of the old generals Kutuzov and
Prince Schwartzenberg, it had been decided to advance immediately
and give battle to Bonaparte. The council of war was just over when
Prince Andrew accompanied by Boris arrived at the palace to find
Dolgorukov. Everyone at headquarters was still under the spell of
the day's council, at which the party of the young had triumphed.
The voices of those who counseled delay and advised waiting for
something else before advancing had been so completely silenced and
their arguments confuted by such conclusive evidence of the advantages
of attacking that what had been discussed at the council--the coming
battle and the victory that would certainly result from it--no
longer seemed to be in the future but in the past. All the
advantages were on our side. Our enormous forces, undoubtedly superior
to Napoleon's, were concentrated in one place, the troops inspired
by the Emperors' presence were eager for action. The strategic
position where the operations would take place was familiar in all its
details to the Austrian General Weyrother: a lucky accident had
ordained that the Austrian army should maneuver the previous year on
the very fields where the French had now to be fought; the adjacent
locality was known and shown in every detail on the maps, and
Bonaparte, evidently weakened, was undertaking nothing.

Dolgorukov, one of the warmest advocates of an attack, had just
returned from the council, tired and exhausted but eager and proud
of the victory that had been gained. Prince Andrew introduced his
protege, but Prince Dolgorukov politely and firmly pressing his hand
said nothing to Boris and, evidently unable to suppress the thoughts
which were uppermost in his mind at that moment, addressed Prince
Andrew in French.

"Ah, my dear fellow, what a battle we have gained! God grant that
the one that will result from it will be as victorious! However,
dear fellow," he said abruptly and eagerly, "I must confess to
having been unjust to the Austrians and especially to Weyrother.
What exactitude, what minuteness, what knowledge of the locality, what
foresight for every eventuality, every possibility even to the
smallest detail! No, my dear fellow, no conditions better than our
present ones could have been devised. This combination of Austrian
precision with Russian valor--what more could be wished for?"

"So the attack is definitely resolved on?" asked Bolkonski.

"And do you know, my dear fellow, it seems to me that Bonaparte
has decidedly lost bearings, you know that a letter was received
from him today for the Emperor." Dolgorukov smiled significantly.

"Is that so? And what did he say?" inquired Bolkonski.

"What can he say? Tra-di-ri-di-ra and so on... merely to gain
time. I tell you he is in our hands, that's certain! But what was most
amusing," he continued, with a sudden, good-natured laugh, "was that
we could not think how to address the reply! If not as 'Consul' and of
course not as 'Emperor,' it seemed to me it should be to 'General
Bonaparte.'"

"But between not recognizing him as Emperor and calling him
General Bonaparte, there is a difference," remarked Bolkonski.

"That's just it," interrupted Dolgorukov quickly, laughing. "You
know Bilibin--he's a very clever fellow. He suggested addressing him
as 'Usurper and Enemy of Mankind.'"

Dolgorukov laughed merrily.

"Only that?" said Bolkonski.

"All the same, it was Bilibin who found a suitable form for the
address. He is a wise and clever fellow."

"What was it?"

"To the Head of the French Government... Au chef du gouvernement
francais," said Dolgorukov, with grave satisfaction. "Good, wasn't
it?"

"Yes, but he will dislike it extremely," said Bolkonski.

"Oh yes, very much! My brother knows him, he's dined with him--the
present Emperor--more than once in Paris, and tells me he never met
a more cunning or subtle diplomatist--you know, a combination of
French adroitness and Italian play-acting! Do you know the tale
about him and Count Markov? Count Markov was the only man who knew how
to handle him. You know the story of the handkerchief? It is
delightful!"

And the talkative Dolgorukov, turning now to Boris, now to Prince
Andrew, told how Bonaparte wishing to test Markov, our ambassador,
purposely dropped a handkerchief in front of him and stood looking
at Markov, probably expecting Markov to pick it up for him, and how
Markov immediately dropped his own beside it and picked it up
without touching Bonaparte's.

"Delightful!" said Bolkonski. "But I have come to you, Prince, as
a petitioner on behalf of this young man. You see..." but before
Prince Andrew could finish, an aide-de-camp came in to summon
Dolgorukov to the Emperor.

"Oh, what a nuisance," said Dolgorukov, getting up hurriedly and
pressing the hands of Prince Andrew and Boris. "You know I should be
very glad to do all in my power both for you and for this dear young
man." Again he pressed the hand of the latter with an expression of
good-natured, sincere, and animated levity. "But you see... another
time!"

Boris was excited by the thought of being so close to the higher
powers as he felt himself to be at that moment. He was conscious
that here he was in contact with the springs that set in motion the
enormous movements of the mass of which in his regiment he felt
himself a tiny, obedient, and insignificant atom. They followed Prince
Dolgorukov out into the corridor and met--coming out of the door of
the Emperor's room by which Dolgorukov had entered--a short man in
civilian clothes with a clever face and sharply projecting jaw
which, without spoiling his face, gave him a peculiar vivacity and
shiftiness of expression. This short man nodded to Dolgorukov as to an
intimate friend and stared at Prince Andrew with cool intensity,
walking straight toward him and evidently expecting him to bow or to
step out of his way. Prince Andrew did neither: a look of animosity
appeared on his face and the other turned away and went down the
side of the corridor.

"Who was that?" asked Boris.

"He is one of the most remarkable, but to me most unpleasant of men-
the Minister of Foreign Affairs, Prince Adam Czartoryski.... It is
such men as he who decide the fate of nations," added Bolkonski with a
sigh he could not suppress, as they passed out of the palace.

Next day, the army began its campaign, and up to the very battle
of Austerlitz, Boris was unable to see either Prince Andrew or
Dolgorukov again and remained for a while with the Ismaylov regiment.





CHAPTER X


At dawn on the sixteenth of November, Denisov's squadron, in which
Nicholas Rostov served and which was in Prince Bagration's detachment,
moved from the place where it had spent the night, advancing into
action as arranged, and after going behind other columns for about two
thirds of a mile was stopped on the highroad. Rostov saw the
Cossacks and then the first and second squadrons of hussars and
infantry battalions and artillery pass by and go forward and then
Generals Bagration and Dolgorukov ride past with their adjutants.
All the fear before action which he had experienced as previously, all
the inner struggle to conquer that fear, all his dreams of
distinguishing himself as a true hussar in this battle, had been
wasted. Their squadron remained in reserve and Nicholas Rostov spent
that day in a dull and wretched mood. At nine in the morning, he heard
firing in front and shouts of hurrah, and saw wounded being brought
back (there were not many of them), and at last he saw how a whole
detachment of French cavalry was brought in, convoyed by a sontnya
of Cossacks. Evidently the affair was over and, though not big, had
been a successful engagement. The men and officers returning spoke
of a brilliant victory, of the occupation of the town of Wischau and
the capture of a whole French squadron. The day was bright and sunny
after a sharp night frost, and the cheerful glitter of that autumn day
was in keeping with the news of victory which was conveyed, not only
by the tales of those who had taken part in it, but also by the joyful
expression on the faces of soldiers, officers, generals, and
adjutants, as they passed Rostov going or coming. And Nicholas, who
had vainly suffered all the dread that precedes a battle and had spent
that happy day in inactivity, was all the more depressed.

"Come here, Wostov. Let's dwink to dwown our gwief!" shouted
Denisov, who had settled down by the roadside with a flask and some
food.

The officers gathered round Denisov's canteen, eating and talking.

"There! They are bringing another!" cried one of the officers,
indicating a captive French dragoon who was being brought in on foot
by two Cossacks.

One of them was leading by the bridle a fine large French horse he
had taken from the prisoner.

"Sell us that horse!" Denisov called out to the Cossacks.

"If you like, your honor!"

The officers got up and stood round the Cossacks and their prisoner.
The French dragoon was a young Alsatian who spoke French with a German
accent. He was breathless with agitation, his face was red, and when
he heard some French spoken he at once began speaking to the officers,
addressing first one, then another. He said he would not have been
taken, it was not his fault but the corporal's who had sent him to
seize some horsecloths, though he had told him the Russians were
there. And at every word he added: "But don't hurt my little horse!"
and stroked the animal. It was plain that he did not quite grasp where
he was. Now he excused himself for having been taken prisoner and now,
imagining himself before his own officers, insisted on his soldierly
discipline and zeal in the service. He brought with him into our
rearguard all the freshness of atmosphere of the French army, which
was so alien to us.

The Cossacks sold the horse for two gold pieces, and Rostov, being
the richest of the officers now that he had received his money, bought
it.

"But don't hurt my little horse!" said the Alsatian good-naturedly
to Rostov when the animal was handed over to the hussar.

Rostov smilingly reassured the dragoon and gave him money.

"Alley! Alley!" said the Cossack, touching the prisoner's arm to
make him go on.

"The Emperor! The Emperor!" was suddenly heard among the hussars.

All began to run and bustle, and Rostov saw coming up the road
behind him several riders with white plumes in their hats. In a moment
everyone was in his place, waiting.

Rostov did not know or remember how he ran to his place and mounted.
Instantly his regret at not having been in action and his dejected
mood amid people of whom he was weary had gone, instantly every
thought of himself had vanished. He was filled with happiness at his
nearness to the Emperor. He felt that this nearness by itself made
up to him for the day he had lost. He was happy as a lover when the
longed-for moment of meeting arrives. Not daring to look round and
without looking round, he was ecstatically conscious of his
approach. He felt it not only from the sound of the hoofs of the
approaching cavalcade, but because as he drew near everything grew
brighter, more joyful, more significant, and more festive around
him. Nearer and nearer to Rostov came that sun shedding beams of
mild and majestic light around, and already he felt himself
enveloped in those beams, he heard his voice, that kindly, calm, and
majestic voice that was yet so simple! And as if in accord with
Rostov's feeling, there was a deathly stillness amid which was heard
the Emperor's voice.

"The Pavlograd hussars?" he inquired.

"The reserves, sire!" replied a voice, a very human one compared
to that which had said: "The Pavlograd hussars?"

The Emperor drew level with Rostov and halted. Alexander's face
was even more beautiful than it had been three days before at the
review. It shone with such gaiety and youth, such innocent youth, that
it suggested the liveliness of a fourteen-year-old boy, and yet it was
the face of the majestic Emperor. Casually, while surveying the
squadron, the Emperor's eyes met Rostov's and rested on them for not
more than two seconds. Whether or no the Emperor understood what was
going on in Rostov's soul (it seemed to Rostov that he understood
everything), at any rate his light-blue eyes gazed for about two
seconds into Rostov's face. A gentle, mild light poured from them.
Then all at once he raised his eyebrows, abruptly touched his horse
with his left foot, and galloped on.

The younger Emperor could not restrain his wish to be present at the
battle and, in spite of the remonstrances of his courtiers, at
twelve o'clock left the third column with which he had been and
galloped toward the vanguard. Before he came up with the hussars,
several adjutants met him with news of the successful result of the
action.

This battle, which consisted in the capture of a French squadron,
was represented as a brilliant victory over the French, and so the
Emperor and the whole army, especially while the smoke hung over the
battlefield, believed that the French had been defeated and were
retreating against their will. A few minutes after the Emperor had
passed, the Pavlograd division was ordered to advance. In Wischau
itself, a petty German town, Rostov saw the Emperor again. In the
market place, where there had been some rather heavy firing before the
Emperor's arrival, lay several killed and wounded soldiers whom
there had not been time to move. The Emperor, surrounded by his
suite of officers and courtiers, was riding a bobtailed chestnut mare,
a different one from that which he had ridden at the review, and
bending to one side he gracefully held a gold lorgnette to his eyes
and looked at a soldier who lay prone, with blood on his uncovered
head. The wounded soldier was so dirty, coarse, and revolting that his
proximity to the Emperor shocked Rostov. Rostov saw how the
Emperor's rather round shoulders shuddered as if a cold shiver had run
down them, how his left foot began convulsively tapping the horse's
side with the spur, and how the well-trained horse looked round
unconcerned and did not stir. An adjutant, dismounting, lifted the
soldier under the arms to place him on a stretcher that had been
brought. The soldier groaned.

"Gently, gently! Can't you do it more gently?" said the Emperor
apparently suffering more than the dying soldier, and he rode away.

Rostov saw tears filling the Emperor's eyes and heard him, as he was
riding away, say to Czartoryski: "What a terrible thing war is: what a
terrible thing! Quelle terrible chose que la guerre!"

The troops of the vanguard were stationed before Wischau, within
sight of the enemy's lines, which all day long had yielded ground to
us at the least firing. The Emperor's gratitude was announced to the
vanguard, rewards were promised, and the men received a double
ration of vodka. The campfires crackled and the soldiers' songs
resounded even more merrily than on the previous night. Denisov
celebrated his promotion to the rank of major, and Rostov, who had
already drunk enough, at the end of the feast proposed the Emperor's
health. "Not 'our Sovereign, the Emperor,' as they say at official
dinners," said he, "but the health of our Sovereign, that good,
enchanting, and great man! Let us drink to his health and to the
certain defeat of the French!"

"If we fought before," he said, "not letting the French pass, as
at Schon Grabern, what shall we not do now when he is at the front? We
will all die for him gladly! Is it not so, gentlemen? Perhaps I am not
saying it right, I have drunk a good deal--but that is how I feel, and
so do you too! To the health of Alexander the First! Hurrah!"

"Hurrah!" rang the enthusiastic voices of the officers.

And the old cavalry captain, Kirsten, shouted enthusiastically and
no less sincerely than the twenty-year-old Rostov.

When the officers had emptied and smashed their glasses, Kirsten
filled others and, in shirt sleeves and breeches, went glass in hand
to the soldiers' bonfires and with his long gray mustache, his white
chest showing under his open shirt, he stood in a majestic pose in the
light of the campfire, waving his uplifted arm.

"Lads! here's to our Sovereign, the Emperor, and victory over our
enemies! Hurrah!" he exclaimed in his dashing, old, hussar's baritone.

The hussars crowded round and responded heartily with loud shouts.

Late that night, when all had separated, Denisov with his short hand
patted his favorite, Rostov, on the shoulder.

"As there's no one to fall in love with on campaign, he's fallen
in love with the Tsar," he said.

"Denisov, don't make fun of it!" cried Rostov. "It is such a
lofty, beautiful feeling, such a..."

"I believe it, I believe it, fwiend, and I share and appwove..."

"No, you don't understand!"

And Rostov got up and went wandering among the campfires, dreaming
of what happiness it would be to die--not in saving the Emperor's life
(he did not even dare to dream of that), but simply to die before
his eyes. He really was in love with the Tsar and the glory of the
Russian arms and the hope of future triumph. And he was not the only
man to experience that feeling during those memorable days preceding
the battle of Austerlitz: nine tenths of the men in the Russian army
were then in love, though less ecstatically, with their Tsar and the
glory of the Russian arms.





CHAPTER XI


The next day the Emperor stopped at Wischau, and Villier, his
physician, was repeatedly summoned to see him. At headquarters and
among the troops near by the news spread that the Emperor was
unwell. He ate nothing and had slept badly that night, those around
him reported. The cause of this indisposition was the strong
impression made on his sensitive mind by the sight of the killed and
wounded.

At daybreak on the seventeenth, a French officer who had come with a
flag of truce, demanding an audience with the Russian Emperor, was
brought into Wischau from our outposts. This officer was Savary. The
Emperor had only just fallen asleep and so Savary had to wait. At
midday he was admitted to the Emperor, and an hour later he rode off
with Prince Dolgorukov to the advanced post of the French army.

It was rumored that Savary had been sent to propose to Alexander a
meeting with Napoleon. To the joy and pride of the whole army, a
personal interview was refused, and instead of the Sovereign, Prince
Dolgorukov, the victor at Wischau, was sent with Savary to negotiate
with Napoleon if, contrary to expectations, these negotiations were
actuated by a real desire for peace.

Toward evening Dolgorukov came back, went straight to the Tsar,
and remained alone with him for a long time.

On the eighteenth and nineteenth of November, the army advanced
two days' march and the enemy's outposts after a brief interchange
of shots retreated. In the highest army circles from midday on the
nineteenth, a great, excitedly bustling activity began which lasted
till the morning of the twentieth, when the memorable battle of
Austerlitz was fought.

Till midday on the nineteenth, the activity--the eager talk, running
to and fro, and dispatching of adjutants--was confined to the
Emperor's headquarters. But on the afternoon of that day, this
activity reached Kutuzov's headquarters and the staffs of the
commanders of columns. By evening, the adjutants had spread it to
all ends and parts of the army, and in the night from the nineteenth
to the twentieth, the whole eighty thousand allied troops rose from
their bivouacs to the hum of voices, and the army swayed and started
in one enormous mass six miles long.

The concentrated activity which had begun at the Emperor's
headquarters in the morning and had started the whole movement that
followed was like the first movement of the main wheel of a large
tower clock. One wheel slowly moved, another was set in motion, and
a third, and wheels began to revolve faster and faster, levers and
cogwheels to work, chimes to play, figures to pop out, and the hands
to advance with regular motion as a result of all that activity.

Just as in the mechanism of a clock, so in the mechanism of the
military machine, an impulse once given leads to the final result; and
just as indifferently quiescent till the moment when motion is
transmitted to them are the parts of the mechanism which the impulse
has not yet reached. Wheels creak on their axles as the cogs engage
one another and the revolving pulleys whirr with the rapidity of their
movement, but a neighboring wheel is as quiet and motionless as though
it were prepared to remain so for a hundred years; but the moment
comes when the lever catches it and obeying the impulse that wheel
begins to creak and joins in the common motion the result and aim of
which are beyond its ken.

Just as in a clock, the result of the complicated motion of
innumerable wheels and pulleys is merely a slow and regular movement
of the hands which show the time, so the result of all the complicated
human activities of 160,000 Russians and French--all their passions,
desires, remorse, humiliations, sufferings, outbursts of pride,
fear, and enthusiasm--was only the loss of the battle of Austerlitz,
the so-called battle of the three Emperors--that is to say, a slow
movement of the hand on the dial of human history.

Prince Andrew was on duty that day and in constant attendance on the
commander in chief.

At six in the evening, Kutuzov went to the Emperor's headquarters
and after staying but a short time with the Tsar went to see the grand
marshal of the court, Count Tolstoy.

Bolkonski took the opportunity to go in to get some details of the
coming action from Dolgorukov. He felt that Kutuzov was upset and
dissatisfied about something and that at headquarters they were
dissatisfied with him, and also that at the Emperor's headquarters
everyone adopted toward him the tone of men who know something
others do not know: he therefore wished to speak to Dolgorukov.

"Well, how d'you do, my dear fellow?" said Dolgorukov, who was
sitting at tea with Bilibin. "The fete is for tomorrow. How is your
old fellow? Out of sorts?"

"I won't say he is out of sorts, but I fancy he would like to be
heard."

"But they heard him at the council of war and will hear him when
he talks sense, but to temporize and wait for something now when
Bonaparte fears nothing so much as a general battle is impossible."

"Yes, you have seen him?" said Prince Andrew. "Well, what is
Bonaparte like? How did he impress you?"

"Yes, I saw him, and am convinced that he fears nothing so much as a
general engagement," repeated Dolgorukov, evidently prizing this
general conclusion which he had arrived at from his interview with
Napoleon. "If he weren't afraid of a battle why did he ask for that
interview? Why negotiate, and above all why retreat, when to retreat
is so contrary to his method of conducting war? Believe me, he is
afraid, afraid of a general battle. His hour has come! Mark my words!"

"But tell me, what is he like, eh?" said Prince Andrew again.

"He is a man in a gray overcoat, very anxious that I should call him
'Your Majesty,' but who, to his chagrin, got no title from me!
That's the sort of man he is, and nothing more," replied Dolgorukov,
looking round at Bilibin with a smile.

"Despite my great respect for old Kutuzov," he continued, "we should
be a nice set of fellows if we were to wait about and so give him a
chance to escape, or to trick us, now that we certainly have him in
our hands! No, we mustn't forget Suvorov and his rule--not to put
yourself in a position to be attacked, but yourself to attack. Believe
me in war the energy of young men often shows the way better than
all the experience of old Cunctators."

"But in what position are we going to attack him? I have been at the
outposts today and it is impossible to say where his chief forces
are situated," said Prince Andrew.

He wished to explain to Dolgorukov a plan of attack he had himself
formed.

"Oh, that is all the same," Dolgorukov said quickly, and getting
up he spread a map on the table. "All eventualities have been
foreseen. If he is standing before Brunn..."

And Prince Dolgorukov rapidly but indistinctly explained Weyrother's
plan of a flanking movement.

Prince Andrew began to reply and to state his own plan, which
might have been as good as Weyrother's, but for the disadvantage
that Weyrother's had already been approved. As soon as Prince Andrew
began to demonstrate the defects of the latter and the merits of his
own plan, Prince Dolgorukov ceased to listen to him and gazed
absent-mindedly not at the map, but at Prince Andrew's face.

"There will be a council of war at Kutuzov's tonight, though; you
can say all this there," remarked Dolgorukov.

"I will do so," said Prince Andrew, moving away from the map.

"Whatever are you bothering about, gentlemen?" said Bilibin, who,
till then, had listened with an amused smile to their conversation and
now was evidently ready with a joke. "Whether tomorrow brings
victory or defeat, the glory of our Russian arms is secure. Except
your Kutuzov, there is not a single Russian in command of a column!
The commanders are: Herr General Wimpfen, le Comte de Langeron, le
Prince de Lichtenstein, le Prince, de Hohenlohe, and finally
Prishprish, and so on like all those Polish names."

"Be quiet, backbiter!" said Dolgorukov. "It is not true; there are
now two Russians, Miloradovich, and Dokhturov, and there would be a
third, Count Arakcheev, if his nerves were not too weak."

"However, I think General Kutuzov has come out," said Prince Andrew.
"I wish you good luck and success, gentlemen!" he added and went out
after shaking hands with Dolgorukov and Bilibin.

On the way home, Prince Andrew could not refrain from asking
Kutuzov, who was sitting silently beside him, what he thought of
tomorrow's battle.

Kutuzov looked sternly at his adjutant and, after a pause,
replied: "I think the battle will be lost, and so I told Count Tolstoy
and asked him to tell the Emperor. What do you think he replied? 'But,
my dear general, I am engaged with rice and cutlets, look after
military matters yourself!' Yes... That was the answer I got!"





CHAPTER XII


Shortly after nine o'clock that evening, Weyrother drove with his
plans to Kutuzov's quarters where the council of war was to be held.
All the commanders of columns were summoned to the commander in
chief's and with the exception of Prince Bagration, who declined to
come, were all there at the appointed time.

Weyrother, who was in full control of the proposed battle, by his
eagerness and briskness presented a marked contrast to the
dissatisfied and drowsy Kutuzov, who reluctantly played the part of
chairman and president of the council of war. Weyrother evidently felt
himself to be at the head of a movement that had already become
unrestrainable. He was like a horse running downhill harnessed to a
heavy cart. Whether he was pulling it or being pushed by it he did not
know, but rushed along at headlong speed with no time to consider what
this movement might lead to. Weyrother had been twice that evening
to the enemy's picket line to reconnoiter personally, and twice to the
Emperors, Russian and Austrian, to report and explain, and to his
headquarters where he had dictated the dispositions in German, and
now, much exhausted, he arrived at Kutuzov's.

He was evidently so busy that he even forgot to be polite to the
commander in chief. He interrupted him, talked rapidly and
indistinctly, without looking at the man he was addressing, and did
not reply to questions put to him. He was bespattered with mud and had
a pitiful, weary, and distracted air, though at the same time he was
haughty and self-confident.

Kutuzov was occupying a nobleman's castle of modest dimensions
near Ostralitz. In the large drawing room which had become the
commander in chief's office were gathered Kutuzov himself,
Weyrother, and the members of the council of war. They were drinking
tea, and only awaited Prince Bagration to begin the council. At last
Bagration's orderly came with the news that the prince could not
attend. Prince Andrew came in to inform the commander in chief of this
and, availing himself of permission previously given him by Kutuzov to
be present at the council, he remained in the room.

"Since Prince Bagration is not coming, we may begin," said
Weyrother, hurriedly rising from his seat and going up to the table on
which an enormous map of the environs of Brunn was spread out.

Kutuzov, with his uniform unbuttoned so that his fat neck bulged
over his collar as if escaping, was sitting almost asleep in a low
chair, with his podgy old hands resting symmetrically on its arms.
At the sound of Weyrother's voice, he opened his one eye with an
effort.


"Yes, yes, if you please! It is already late," said he, and
nodding his head he let it droop and again closed his eye.

If at first the members of the council thought that Kutuzov was
pretending to sleep, the sounds his nose emitted during the reading
that followed proved that the commander in chief at that moment was
absorbed by a far more serious matter than a desire to show his
contempt for the dispositions or anything else--he was engaged in
satisfying the irresistible human need for sleep. He really was
asleep. Weyrother, with the gesture of a man too busy to lose a
moment, glanced at Kutuzov and, having convinced himself that he was
asleep, took up a paper and in a loud, monotonous voice began to
read out the dispositions for the impending battle, under a heading
which he also read out:

"Dispositions for an attack on the enemy position behind Kobelnitz
and Sokolnitz, November 30, 1805."

The dispositions were very complicated and difficult. They began
as follows:

"As the enemy's left wing rests on wooded hills and his right
extends along Kobelnitz and Sokolnitz behind the ponds that are there,
while we, on the other hand, with our left wing by far outflank his
right, it is advantageous to attack the enemy's latter wing especially
if we occupy the villages of Sokolnitz and Kobelnitz, whereby we can
both fall on his flank and pursue him over the plain between
Schlappanitz and the Thuerassa forest, avoiding the defiles of
Schlappanitz and Bellowitz which cover the enemy's front. For this
object it is necessary that... The first column marches... The
second column marches... The third column marches..." and so on,
read Weyrother.

The generals seemed to listen reluctantly to the difficult
dispositions. The tall, fair-haired General Buxhowden stood, leaning
his back against the wall, his eyes fixed on a burning candle, and
seemed not to listen or even to wish to be thought to listen.
Exactly opposite Weyrother, with his glistening wide-open eyes fixed
upon him and his mustache twisted upwards, sat the ruddy
Miloradovich in a military pose, his elbows turned outwards, his hands
on his knees, and his shoulders raised. He remained stubbornly silent,
gazing at Weyrother's face, and only turned away his eyes when the
Austrian chief of staff finished reading. Then Miloradovich looked
round significantly at the other generals. But one could not tell from
that significant look whether he agreed or disagreed and was satisfied
or not with the arrangements. Next to Weyrother sat Count Langeron
who, with a subtle smile that never left his typically southern French
face during the whole time of the reading, gazed at his delicate
fingers which rapidly twirled by its corners a gold snuffbox on
which was a portrait. In the middle of one of the longest sentences,
he stopped the rotary motion of the snuffbox, raised his head, and
with inimical politeness lurking in the corners of his thin lips
interrupted Weyrother, wishing to say something. But the Austrian
general, continuing to read, frowned angrily and jerked his elbows, as
if to say: "You can tell me your views later, but now be so good as to
look at the map and listen." Langeron lifted his eyes with an
expression of perplexity, turned round to Miloradovich as if seeking
an explanation, but meeting the latter's impressive but meaningless
gaze drooped his eyes sadly and again took to twirling his snuffbox.

"A geography lesson!" he muttered as if to himself, but loud
enough to be heard.

Przebyszewski, with respectful but dignified politeness, held his
hand to his ear toward Weyrother, with the air of a man absorbed in
attention. Dohkturov, a little man, sat opposite Weyrother, with an
assiduous and modest mien, and stooping over the outspread map
conscientiously studied the dispositions and the unfamiliar
locality. He asked Weyrother several times to repeat words he had
not clearly heard and the difficult names of villages. Weyrother
complied and Dohkturov noted them down.

When the reading which lasted more than an hour was over, Langeron
again brought his snuffbox to rest and, without looking at Weyrother
or at anyone in particular, began to say how difficult it was to carry
out such a plan in which the enemy's position was assumed to be known,
whereas it was perhaps not known, since the enemy was in movement.
Langeron's objections were valid but it was obvious that their chief
aim was to show General Weyrother--who had read his dispositions
with as much self-confidence as if he were addressing school children-
that he had to do, not with fools, but with men who could teach him
something in military matters.

When the monotonous sound of Weyrother's voice ceased, Kutuzov
opened his eye as a miller wakes up when the soporific drone of the
mill wheel is interrupted. He listened to what Langeron said, as if
remarking, "So you are still at that silly business!" quickly closed
his eye again, and let his head sink still lower.

Langeron, trying as virulently as possible to sting Weyrother's
vanity as author of the military plan, argued that Bonaparte might
easily attack instead of being attacked, and so render the whole of
this plan perfectly worthless. Weyrother met all objections with a
firm and contemptuous smile, evidently prepared beforehand to meet all
objections be they what they might.

"If he could attack us, he would have done so today," said he.

"So you think he is powerless?" said Langeron.

"He has forty thousand men at most," replied Weyrother, with the
smile of a doctor to whom an old wife wishes to explain the
treatment of a case.

"In that case he is inviting his doom by awaiting our attack,"
said Langeron, with a subtly ironical smile, again glancing round
for support to Miloradovich who was near him.

But Miloradovich was at that moment evidently thinking of anything
rather than of what the generals were disputing about.

"Ma foi!" said he, "tomorrow we shall see all that on the
battlefield."

Weyrother again gave that smile which seemed to say that to him it
was strange and ridiculous to meet objections from Russian generals
and to have to prove to them what he had not merely convinced
himself of, but had also convinced the sovereign Emperors of.

"The enemy has quenched his fires and a continual noise is heard
from his camp," said he. "What does that mean? Either he is
retreating, which is the only thing we need fear, or he is changing
his position." (He smiled ironically.) "But even if he also took up
a position in the Thuerassa, he merely saves us a great deal of
trouble and all our arrangements to the minutest detail remain the
same."

"How is that?..." began Prince Andrew, who had for long been waiting
an opportunity to express his doubts.

Kutuzov here woke up, coughed heavily, and looked round at the
generals.

"Gentlemen, the dispositions for tomorrow--or rather for today,
for it is past midnight--cannot now be altered," said he. "You have
heard them, and we shall all do our duty. But before a battle, there
is nothing more important..." he paused, "than to have a good sleep."

He moved as if to rise. The generals bowed and retired. It was
past midnight. Prince Andrew went out.


The council of war, at which Prince Andrew had not been able to
express his opinion as he had hoped to, left on him a vague and uneasy
impression. Whether Dolgorukov and Weyrother, or Kutuzov, Langeron,
and the others who did not approve of the plan of attack, were
right--he did not know. "But was it really not possible for Kutuzov to
state his views plainly to the Emperor? Is it possible that on account
of court and personal considerations tens of thousands of lives, and
my life, my life," he thought, "must be risked?"

"Yes, it is very likely that I shall be killed tomorrow," he
thought. And suddenly, at this thought of death, a whole series of
most distant, most intimate, memories rose in his imagination: he
remembered his last parting from his father and his wife; he
remembered the days when he first loved her. He thought of her
pregnancy and felt sorry for her and for himself, and in a nervously
emotional and softened mood he went out of the hut in which he was
billeted with Nesvitski and began to walk up and down before it.

The night was foggy and through the fog the moonlight gleamed
mysteriously. "Yes, tomorrow, tomorrow!" he thought. "Tomorrow
everything may be over for me! All these memories will be no more,
none of them will have any meaning for me. Tomorrow perhaps, even
certainly, I have a presentiment that for the first time I shall
have to show all I can do." And his fancy pictured the battle, its
loss, the concentration of fighting at one point, and the hesitation
of all the commanders. And then that happy moment, that Toulon for
which he had so long waited, presents itself to him at last. He firmly
and clearly expresses his opinion to Kutuzov, to Weyrother, and to the
Emperors. All are struck by the justness of his views, but no one
undertakes to carry them out, so he takes a regiment, a division-
stipulates that no one is to interfere with his arrangements--leads
his division to the decisive point, and gains the victory alone.
"But death and suffering?" suggested another voice. Prince Andrew,
however, did not answer that voice and went on dreaming of his
triumphs. The dispositions for the next battle are planned by him
alone. Nominally he is only an adjutant on Kutuzov's staff, but he
does everything alone. The next battle is won by him alone. Kutuzov is
removed and he is appointed... "Well and then?" asked the other voice.
"If before that you are not ten times wounded, killed, or betrayed,
well... what then?..." "Well then," Prince Andrew answered himself, "I
don't know what will happen and don't want to know, and can't, but
if I want this--want glory, want to be known to men, want to be
loved by them, it is not my fault that I want it and want nothing
but that and live only for that. Yes, for that alone! I shall never
tell anyone, but, oh God! what am I to do if I love nothing but fame
and men's esteem? Death, wounds, the loss of family--I fear nothing.
And precious and dear as many persons are to me--father, sister, wife-
those dearest to me--yet dreadful and unnatural as it seems, I would
give them all at once for a moment of glory, of triumph over men, of
love from men I don't know and never shall know, for the love of these
men here," he thought, as he listened to voices in Kutuzov's
courtyard. The voices were those of the orderlies who were packing up;
one voice, probably a coachman's, was teasing Kutuzov's old cook
whom Prince Andrew knew, and who was called Tit. He was saying,
"Tit, I say, Tit!"

"Well?" returned the old man.

"Go, Tit, thresh a bit!" said the wag.

"Oh, go to the devil!" called out a voice, drowned by the laughter
of the orderlies and servants.

"All the same, I love and value nothing but triumph over them all, I
value this mystic power and glory that is floating here above me in
this mist!"





CHAPTER XIII


That same night, Rostov was with a platoon on skirmishing duty in
front of Bagration's detachment. His hussars were placed along the
line in couples and he himself rode along the line trying to master
the sleepiness that kept coming over him. An enormous space, with
our army's campfires dimly glowing in the fog, could be seen behind
him; in front of him was misty darkness. Rostov could see nothing,
peer as he would into that foggy distance: now something gleamed gray,
now there was something black, now little lights seemed to glimmer
where the enemy ought to be, now he fancied it was only something in
his own eyes. His eyes kept closing, and in his fancy appeared--now
the Emperor, now Denisov, and now Moscow memories--and he again
hurriedly opened his eyes and saw close before him the head and ears
of the horse he was riding, and sometimes, when he came within six
paces of them, the black figures of hussars, but in the distance was
still the same misty darkness. "Why not?... It might easily happen,"
thought Rostov, "that the Emperor will meet me and give me an order as
he would to any other officer; he'll say: 'Go and find out what's
there.' There are many stories of his getting to know an officer in
just such a chance way and attaching him to himself! What if he gave
me a place near him? Oh, how I would guard him, how I would tell him
the truth, how I would unmask his deceivers!" And in order to
realize vividly his love devotion to the sovereign, Rostov pictured to
himself an enemy or a deceitful German, whom he would not only kill
with pleasure but whom he would slap in the face before the Emperor.
Suddenly a distant shout aroused him. He started and opened his eyes.

"Where am I? Oh yes, in the skirmishing line... pass and
watchword--shaft, Olmutz. What a nuisance that our squadron will be in
reserve tomorrow," he thought. "I'll ask leave to go to the front,
this may be my only chance of seeing the Emperor. It won't be long now
before I am off duty. I'll take another turn and when I get back
I'll go to the general and ask him." He readjusted himself in the
saddle and touched up his horse to ride once more round his hussars.
It seemed to him that it was getting lighter. To the left he saw a
sloping descent lit up, and facing it a black knoll that seemed as
steep as a wall. On this knoll there was a white patch that Rostov
could not at all make out: was it a glade in the wood lit up by the
moon, or some unmelted snow, or some white houses? He even thought
something moved on that white spot. "I expect it's snow... that
spot... a spot--une tache," he thought. "There now... it's not a
tache... Natasha... sister, black eyes... Na... tasha... (Won't she be
surprised when I tell her how I've seen the Emperor?) Natasha...
take my sabretache..."--"Keep to the right, your honor, there are
bushes here," came the voice of an hussar, past whom Rostov was riding
in the act of falling asleep. Rostov lifted his head that had sunk
almost to his horse's mane and pulled up beside the hussar. He was
succumbing to irresistible, youthful, childish drowsiness. "But what
was I thinking? I mustn't forget. How shall I speak to the Emperor?
No, that's not it--that's tomorrow. Oh yes! Natasha... sabretache...
saber them...Whom? The hussars... Ah, the hussars with mustaches.
Along the Tverskaya Street rode the hussar with mustaches... I thought
about him too, just opposite Guryev's house... Old Guryev.... Oh,
but Denisov's a fine fellow. But that's all nonsense. The chief
thing is that the Emperor is here. How he looked at me and wished to
say something, but dared not.... No, it was I who dared not. But
that's nonsense, the chief thing is not to forget the important
thing I was thinking of. Yes, Na-tasha, sabretache, oh, yes, yes!
That's right!" And his head once more sank to his horse's neck. All at
once it seemed to him that he was being fired at. "What? What?
What?... Cut them down! What?..." said Rostov, waking up. At the
moment he opened his eyes he heard in front of him, where the
enemy was, the long-drawn shouts of thousands of voices. His horse and
the horse of the hussar near him pricked their ears at these shouts.
Over there, where the shouting came from, a fire flared up and went
out again, then another, and all along the French line on the hill
fires flared up and the shouting grew louder and louder. Rostov
could hear the sound of French words but could not distinguish them.
The din of many voices was too great; all he could hear was: "ahahah!"
and "rrrr!"

"What's that? What do you make of it?" said Rostov to the hussar
beside him. "That must be the enemy's camp!"

The hussar did not reply.

"Why, don't you hear it?" Rostov asked again, after waiting for a
reply.

"Who can tell, your honor?" replied the hussar reluctantly.

"From the direction, it must be the enemy," repeated Rostov.

"It may be he or it may be nothing," muttered the hussar. "It's
dark... Steady!" he cried to his fidgeting horse.

Rostov's horse was also getting restive: it pawed the frozen ground,
pricking its ears at the noise and looking at the lights. The shouting
grew still louder and merged into a general roar that only an army
of several thousand men could produce. The lights spread farther and
farther, probably along the line of the French camp. Rostov no
longer wanted to sleep. The gay triumphant shouting of the enemy
army had a stimulating effect on him. "Vive l'Empereur! L'Empereur!"
he now heard distinctly.

"They can't be far off, probably just beyond the stream," he said to
the hussar beside him.

The hussar only sighed without replying and coughed angrily. The
sound of horse's hoofs approaching at a trot along the line of hussars
was heard, and out of the foggy darkness the figure of a sergeant of
hussars suddenly appeared, looming huge as an elephant.

"Your honor, the generals!" said the sergeant, riding up to Rostov.

Rostov, still looking round toward the fires and the shouts, rode
with the sergeant to meet some mounted men who were riding along the
line. One was on a white horse. Prince Bagration and Prince Dolgorukov
with their adjutants had come to witness the curious phenomenon of the
lights and shouts in the enemy's camp. Rostov rode up to Bagration,
reported to him, and then joined the adjutants listening to what the
generals were saying.

"Believe me," said Prince Dolgorukov, addressing Bagration, "it is
nothing but a trick! He has retreated and ordered the rearguard to
kindle fires and make a noise to deceive us."

"Hardly," said Bagration. "I saw them this evening on that knoll; if
they had retreated they would have withdrawn from that too....
Officer!" said Bagration to Rostov, "are the enemy's skirmishers still
there?"

"They were there this evening, but now I don't know, your
excellency. Shall I go with some of my hussars to see?" replied
Rostov.

Bagration stopped and, before replying, tried to see Rostov's face
in the mist.

"Well, go and see," he said, after a pause.

"Yes, sir."

Rostov spurred his horse, called to Sergeant Fedchenko and two other
hussars, told them to follow him, and trotted downhill in the
direction from which the shouting came. He felt both frightened and
pleased to be riding alone with three hussars into that mysterious and
dangerous misty distance where no one had been before him. Bagration
called to him from the hill not to go beyond the stream, but Rostov
pretended not to hear him and did not stop but rode on and on,
continually mistaking bushes for trees and gullies for men and
continually discovering his mistakes. Having descended the hill at a
trot, he no longer saw either our own or the enemy's fires, but
heard the shouting of the French more loudly and distinctly. In the
valley he saw before him something like a river, but when he reached
it he found it was a road. Having come out onto the road he reined
in his horse, hesitating whether to ride along it or cross it and ride
over the black field up the hillside. To keep to the road which
gleamed white in the mist would have been safer because it would be
easier to see people coming along it. "Follow me!" said he, crossed
the road, and began riding up the hill at a gallop toward the point
where the French pickets had been standing that evening.

"Your honor, there he is!" cried one of the hussars behind him.
And before Rostov had time to make out what the black thing was that
had suddenly appeared in the fog, there was a flash, followed by a
report, and a bullet whizzing high up in the mist with a plaintive
sound passed out of hearing. Another musket missed fire but flashed in
the pan. Rostov turned his horse and galloped back. Four more
reports followed at intervals, and the bullets passed somewhere in the
fog singing in different tones. Rostov reined in his horse, whose
spirits had risen, like his own, at the firing, and went back at a
footpace. "Well, some more! Some more!" a merry voice was saying in
his soul. But no more shots came.

Only when approaching Bagration did Rostov let his horse gallop
again, and with his hand at the salute rode up to the general.

Dolgorukov was still insisting that the French had retreated and had
only lit fires to deceive us.

"What does that prove?" he was saying as Rostov rode up. "They might
retreat and leave the pickets."

"It's plain that they have not all gone yet, Prince," said
Bagration. "Wait till tomorrow morning, we'll find out everything
tomorrow."

"The picket is still on the hill, your excellency, just where it was
in the evening," reported Rostov, stooping forward with his hand at
the salute and unable to repress the smile of delight induced by his
ride and especially by the sound of the bullets.

"Very good, very good," said Bagration. "Thank you, officer."

"Your excellency," said Rostov, "may I ask a favor?"

"What is it?"

"Tomorrow our squadron is to be in reserve. May I ask to be attached
to the first squadron?"

"What's your name?"

"Count Rostov."

"Oh, very well, you may stay in attendance on me."

"Count Ilya Rostov's son?" asked Dolgorukov.

But Rostov did not reply.

"Then I may reckon on it, your excellency?"

"I will give the order."

"Tomorrow very likely I may be sent with some message to the
Emperor," thought Rostov.

"Thank God!"


The fires and shouting in the enemy's army were occasioned by the
fact that while Napoleon's proclamation was being read to the troops
the Emperor himself rode round his bivouacs. The soldiers, on seeing
him, lit wisps of straw and ran after him, shouting, "Vive
l'Empereur!" Napoleon's proclamation was as follows:


Soldiers! The Russian army is advancing against you to avenge the
Austrian army of Ulm. They are the same battalions you broke at
Hollabrunn and have pursued ever since to this place. The position
we occupy is a strong one, and while they are marching to go round
me on the right they will expose a flank to me. Soldiers! I will
myself direct your battalions. I will keep out of fire if you with
your habitual valor carry disorder and confusion into the enemy's
ranks, but should victory be in doubt, even for a moment, you will see
your Emperor exposing himself to the first blows of the enemy, for
there must be no doubt of victory, especially on this day when what is
at stake is the honor of the French infantry, so necessary to the
honor of our nation.

Do not break your ranks on the plea of removing the wounded! Let
every man be fully imbued with the thought that we must defeat these
hirelings of England, inspired by such hatred of our nation! This
victory will conclude our campaign and we can return to winter
quarters, where fresh French troops who are being raised in France
will join us, and the peace I shall conclude will be worthy of my
people, of you, and of myself.

NAPOLEON





CHAPTER XIV


At five in the morning it was still quite dark. The troops of the
center, the reserves, and Bagration's right flank had not yet moved,
but on the left flank the columns of infantry, cavalry, and artillery,
which were to be the first to descend the heights to attack the French
right flank and drive it into the Bohemian mountains according to
plan, were already up and astir. The smoke of the campfires, into
which they were throwing everything superfluous, made the eyes
smart. It was cold and dark. The officers were hurriedly drinking
tea and breakfasting, the soldiers, munching biscuit and beating a
tattoo with their feet to warm themselves, gathering round the fires
throwing into the flames the remains of sheds, chairs, tables, wheels,
tubs, and everything that they did not want or could not carry away
with them. Austrian column guides were moving in and out among the
Russian troops and served as heralds of the advance. As soon as an
Austrian officer showed himself near a commanding officer's
quarters, the regiment began to move: the soldiers ran from the fires,
thrust their pipes into their boots, their bags into the carts, got
their muskets ready, and formed rank. The officers buttoned up their
coats, buckled on their swords and pouches, and moved along the
ranks shouting. The train drivers and orderlies harnessed and packed
the wagons and tied on the loads. The adjutants and battalion and
regimental commanders mounted, crossed themselves, gave final
instructions, orders, and commissions to the baggage men who
remained behind, and the monotonous tramp of thousands of feet
resounded. The column moved forward without knowing where and
unable, from the masses around them, the smoke and the increasing fog,
to see either the place they were leaving or that to which they were
going.

A soldier on the march is hemmed in and borne along by his
regiment as much as a sailor is by his ship. However far he has
walked, whatever strange, unknown, and dangerous places he reaches,
just as a sailor is always surrounded by the same decks, masts, and
rigging of his ship, so the soldier always has around him the same
comrades, the same ranks, the same sergeant major Ivan Mitrich, the
same company dog Jack, and the same commanders. The sailor rarely
cares to know the latitude in which his ship is sailing, but on the
day of battle--heaven knows how and whence--a stern note of which
all are conscious sounds in the moral atmosphere of an army,
announcing the approach of something decisive and solemn, and
awakening in the men an unusual curiosity. On the day of battle the
soldiers excitedly try to get beyond the interests of their
regiment, they listen intently, look about, and eagerly ask concerning
what is going on around them.

The fog had grown so dense that though it was growing light they
could not see ten paces ahead. Bushes looked like gigantic trees and
level ground like cliffs and slopes. Anywhere, on any side, one
might encounter an enemy invisible ten paces off. But the columns
advanced for a long time, always in the same fog, descending and
ascending hills, avoiding gardens and enclosures, going over new and
unknown ground, and nowhere encountering the enemy. On the contrary,
the soldiers became aware that in front, behind, and on all sides,
other Russian columns were moving in the same direction. Every soldier
felt glad to know that to the unknown place where he was going, many
more of our men were going too.

"There now, the Kurskies have also gone past," was being said in the
ranks.

"It's wonderful what a lot of our troops have gathered, lads! Last
night I looked at the campfires and there was no end of them. A
regular Moscow!"

Though none of the column commanders rode up to the ranks or
talked to the men (the commanders, as we saw at the council of war,
were out of humor and dissatisfied with the affair, and so did not
exert themselves to cheer the men but merely carried out the
orders), yet the troops marched gaily, as they always do when going
into action, especially to an attack. But when they had marched for
about an hour in the dense fog, the greater part of the men had to
halt and an unpleasant consciousness of some dislocation and blunder
spread through the ranks. How such a consciousness is communicated
is very difficult to define, but it certainly is communicated very
surely, and flows rapidly, imperceptibly, and irrepressibly, as
water does in a creek. Had the Russian army been alone without any
allies, it might perhaps have been a long time before this
consciousness of mismanagement became a general conviction, but as
it was, the disorder was readily and naturally attributed to the
stupid Germans, and everyone was convinced that a dangerous muddle had
been occasioned by the sausage eaters.

"Why have we stopped? Is the way blocked? Or have we already come up
against the French?"

"No, one can't hear them. They'd be firing if we had."

"They were in a hurry enough to start us, and now here we stand in
the middle of a field without rhyme or reason. It's all those damned
Germans' muddling! What stupid devils!"

"Yes, I'd send them on in front, but no fear, they're crowding up
behind. And now here we stand hungry."

"I say, shall we soon be clear? They say the cavalry are blocking
the way," said an officer.

"Ah, those damned Germans! They don't know their own country!"
said another.

"What division are you?" shouted an adjutant, riding up.

"The Eighteenth."

"Then why are you here? You should have gone on long ago, now you
won't get there till evening."

"What stupid orders! They don't themselves know what they are
doing!" said the officer and rode off.

Then a general rode past shouting something angrily, not in Russian.

"Tafa-lafa! But what he's jabbering no one can make out," said a
soldier, mimicking the general who had ridden away. "I'd shoot them,
the scoundrels!"

"We were ordered to be at the place before nine, but we haven't
got halfway. Fine orders!" was being repeated on different sides.

And the feeling of energy with which the troops had started began to
turn into vexation and anger at the stupid arrangements and at the
Germans.

The cause of the confusion was that while the Austrian cavalry was
moving toward our left flank, the higher command found that our center
was too far separated from our right flank and the cavalry were all
ordered to turn back to the right. Several thousand cavalry crossed in
front of the infantry, who had to wait.

At the front an altercation occurred between an Austrian guide and a
Russian general. The general shouted a demand that the cavalry
should be halted, the Austrian argued that not he, but the higher
command, was to blame. The troops meanwhile stood growing listless and
dispirited. After an hour's delay they at last moved on, descending
the hill. The fog that was dispersing on the hill lay still more
densely below, where they were descending. In front in the fog a
shot was heard and then another, at first irregularly at varying
intervals--trata... tat--and then more and more regularly and rapidly,
and the action at the Goldbach Stream began.

Not expecting to come on the enemy down by the stream, and having
stumbled on him in the fog, hearing no encouraging word from their
commanders, and with a consciousness of being too late spreading
through the ranks, and above all being unable to see anything in front
or around them in the thick fog, the Russians exchanged shots with the
enemy lazily and advanced and again halted, receiving no timely orders
from the officers or adjutants who wandered about in the fog in
those unknown surroundings unable to find their own regiments. In this
way the action began for the first, second, and third columns, which
had gone down into the valley. The fourth column, with which Kutuzov
was, stood on the Pratzen Heights.

Below, where the fight was beginning, there was still thick fog;
on the higher ground it was clearing, but nothing could be seen of
what was going on in front. Whether all the enemy forces were, as we
supposed, six miles away, or whether they were near by in that sea
of mist, no one knew till after eight o'clock.

It was nine o'clock in the morning. The fog lay unbroken like a
sea down below, but higher up at the village of Schlappanitz where
Napoleon stood with his marshals around him, it was quite light. Above
him was a clear blue sky, and the sun's vast orb quivered like a
huge hollow, crimson float on the surface of that milky sea of mist.
The whole French army, and even Napoleon himself with his staff,
were not on the far side of the streams and hollows of Sokolnitz and
Schlappanitz beyond which we intended to take up our position and
begin the action, but were on this side, so close to our own forces
that Napoleon with the naked eye could distinguish a mounted man
from one on foot. Napoleon, in the blue cloak which he had worn on his
Italian campaign, sat on his small gray Arab horse a little in front
of his marshals. He gazed silently at the hills which seemed to rise
out of the sea of mist and on which the Russian troops were moving
in the distance, and he listened to the sounds of firing in the
valley. Not a single muscle of his face--which in those days was still
thin--moved. His gleaming eyes were fixed intently on one spot. His
predictions were being justified. Part of the Russian force had
already descended into the valley toward the ponds and lakes and
part were leaving these Pratzen Heights which he intended to attack
and regarded as the key to the position. He saw over the mist that
in a hollow between two hills near the village of Pratzen, the Russian
columns, their bayonets glittering, were moving continuously in one
direction toward the valley and disappearing one after another into
the mist. From information he had received the evening before, from
the sound of wheels and footsteps heard by the outposts during the
night, by the disorderly movement of the Russian columns, and from all
indications, he saw clearly that the allies believed him to be far
away in front of them, and that the columns moving near Pratzen
constituted the center of the Russian army, and that that center was
already sufficiently weakened to be successfully attacked. But still
he did not begin the engagement.

Today was a great day for him--the anniversary of his coronation.
Before dawn he had slept for a few hours, and refreshed, vigorous, and
in good spirits, he mounted his horse and rode out into the field in
that happy mood in which everything seems possible and everything
succeeds. He sat motionless, looking at the heights visible above
the mist, and his cold face wore that special look of confident,
self-complacent happiness that one sees on the face of a boy happily
in love. The marshals stood behind him not venturing to distract his
attention. He looked now at the Pratzen Heights, now at the sun
floating up out of the mist.

When the sun had entirely emerged from the fog, and fields and
mist were aglow with dazzling light--as if he had only awaited this to
begin the action--he drew the glove from his shapely white hand,
made a sign with it to the marshals, and ordered the action to
begin. The marshals, accompanied by adjutants, galloped off in
different directions, and a few minutes later the chief forces of
the French army moved rapidly toward those Pratzen Heights which
were being more and more denuded by Russian troops moving down the
valley to their left.





CHAPTER XV


At eight o'clock Kutuzov rode to Pratzen at the head of the fourth
column, Miloradovich's, the one that was to take the place of
Przebyszewski's and Langeron's columns which had already gone down
into the valley. He greeted the men of the foremost regiment and
gave them the order to march, thereby indicating that he intended to
lead that column himself. When he had reached the village of Pratzen
he halted. Prince Andrew was behind, among the immense number
forming the commander in chief's suite. He was in a state of
suppressed excitement and irritation, though controlledly calm as a
man is at the approach of a long-awaited moment. He was firmly
convinced that this was the day of his Toulon, or his bridge of
Arcola. How it would come about he did not know, but he felt sure it
would do so. The locality and the position of our troops were known to
him as far as they could be known to anyone in our army. His own
strategic plan, which obviously could not now be carried out, was
forgotten. Now, entering into Weyrother's plan, Prince Andrew
considered possible contingencies and formed new projects such as
might call for his rapidity of perception and decision.

To the left down below in the mist, the musketry fire of unseen
forces could be heard. It was there Prince Andrew thought the fight
would concentrate. "There we shall encounter difficulties, and there,"
thought he, "I shall be sent with a brigade or division, and there,
standard in hand, I shall go forward and break whatever is in front of
me."

He could not look calmly at the standards of the passing battalions.
Seeing them he kept thinking, "That may be the very standard with
which I shall lead the army."

In the morning all that was left of the night mist on the heights
was a hoar frost now turning to dew, but in the valleys it still lay
like a milk-white sea. Nothing was visible in the valley to the left
into which our troops had descended and from whence came the sounds of
firing. Above the heights was the dark clear sky, and to the right the
vast orb of the sun. In front, far off on the farther shore of that
sea of mist, some wooded hills were discernible, and it was there
the enemy probably was, for something could be descried. On the
right the Guards were entering the misty region with a sound of
hoofs and wheels and now and then a gleam of bayonets; to the left
beyond the village similar masses of cavalry came up and disappeared
in the sea of mist. In front and behind moved infantry. The
commander in chief was standing at the end of the village letting
the troops pass by him. That morning Kutuzov seemed worn and
irritable. The infantry passing before him came to a halt without
any command being given, apparently obstructed by something in front.

"Do order them to form into battalion columns and go round the
village!" he said angrily to a general who had ridden up. "Don't you
understand, your excellency, my dear sir, that you must not defile
through narrow village streets when we are marching against the
enemy?"

"I intended to re-form them beyond the village, your excellency,"
answered the general.

Kutuzov laughed bitterly.

"You'll make a fine thing of it, deploying in sight of the enemy!
Very fine!"

"The enemy is still far away, your excellency. According to the
dispositions..."

"The dispositions!" exclaimed Kutuzov bitterly. "Who told you
that?... Kindly do as you are ordered."

"Yes, sir."

"My dear fellow," Nesvitski whispered to Prince Andrew, "the old man
is as surly as a dog."

An Austrian officer in a white uniform with green plumes in his
hat galloped up to Kutuzov and asked in the Emperor's name had the
fourth column advanced into action.

Kutuzov turned round without answering and his eye happened to
fall upon Prince Andrew, who was beside him. Seeing him, Kutuzov's
malevolent and caustic expression softened, as if admitting that
what was being done was not his adjutant's fault, and still not
answering the Austrian adjutant, he addressed Bolkonski.

"Go, my dear fellow, and see whether the third division has passed
the village. Tell it to stop and await my orders."

Hardly had Prince Andrew started than he stopped him.

"And ask whether sharpshooters have been posted," he added. "What
are they doing? What are they doing?" he murmured to himself, still
not replying to the Austrian.

Prince Andrew galloped off to execute the order.

Overtaking the battalions that continued to advance, he stopped
the third division and convinced himself that there really were no
sharpshooters in front of our columns. The colonel at the head of
the regiment was much surprised at the commander in chief's order to
throw out skirmishers. He had felt perfectly sure that there were
other troops in front of him and that the enemy must be at least six
miles away. There was really nothing to be seen in front except a
barren descent hidden by dense mist. Having given orders in the
commander in chief's name to rectify this omission, Prince Andrew
galloped back. Kutuzov still in the same place, his stout body resting
heavily in the saddle with the lassitude of age, sat yawning wearily
with closed eyes. The troops were no longer moving, but stood with the
butts of their muskets on the ground.

"All right, all right!" he said to Prince Andrew, and turned to a
general who, watch in hand, was saying it was time they started as all
the left-flank columns had already descended.

"Plenty of time, your excellency," muttered Kutuzov in the midst
of a yawn. "Plenty of time," he repeated.

Just then at a distance behind Kutuzov was heard the sound of
regiments saluting, and this sound rapidly came nearer along the whole
extended line of the advancing Russian columns. Evidently the person
they were greeting was riding quickly. When the soldiers of the
regiment in front of which Kutuzov was standing began to shout, he
rode a little to one side and looked round with a frown. Along the
road from Pratzen galloped what looked like a squadron of horsemen
in various uniforms. Two of them rode side by side in front, at full
gallop. One in a black uniform with white plumes in his hat rode a
bobtailed chestnut horse, the other who was in a white uniform rode
a black one. These were the two Emperors followed by their suites.
Kutuzov, affecting the manners of an old soldier at the front, gave
the command "Attention!" and rode up to the Emperors with a salute.
His whole appearance and manner were suddenly transformed. He put on
the air of a subordinate who obeys without reasoning. With an
affectation of respect which evidently struck Alexander
unpleasantly, he rode up and saluted.

This unpleasant impression merely flitted over the young and happy
face of the Emperor like a cloud of haze across a clear sky and
vanished. After his illness he looked rather thinner that day than
on the field of Olmutz where Bolkonski had seen him for the first time
abroad, but there was still the same bewitching combination of majesty
and mildness in his fine gray eyes, and on his delicate lips the
same capacity for varying expression and the same prevalent appearance
of goodhearted innocent youth.

At the Olmutz review he had seemed more majestic; here he seemed
brighter and more energetic. He was slightly flushed after galloping
two miles, and reining in his horse he sighed restfully and looked
round at the faces of his suite, young and animated as his own.
Czartoryski, Novosiltsev, Prince Volkonsky, Strogonov, and the others,
all richly dressed gay young men on splendid, well-groomed, fresh,
only slightly heated horses, exchanging remarks and smiling, had
stopped behind the Emperor. The Emperor Francis, a rosy, long faced
young man, sat very erect on his handsome black horse, looking about
him in a leisurely and preoccupied manner. He beckoned to one of his
white adjutants and asked some question--"Most likely he is asking
at what o'clock they started," thought Prince Andrew, watching his old
acquaintance with a smile he could not repress as he recalled his
reception at Brunn. In the Emperors' suite were the picked young
orderly officers of the Guard and line regiments, Russian and
Austrian. Among them were grooms leading the Tsar's beautiful relay
horses covered with embroidered cloths.

As when a window is opened a whiff of fresh air from the fields
enters a stuffy room, so a whiff of youthfulness, energy, and
confidence of success reached Kutuzov's cheerless staff with the
galloping advent of all these brilliant young men.

"Why aren't you beginning, Michael Ilarionovich?" said the Emperor
Alexander hurriedly to Kutuzov, glancing courteously at the same
time at the Emperor Francis.

"I am waiting, Your Majesty," answered Kutuzov, bending forward
respectfully.

The Emperor, frowning slightly, bent his ear forward as if he had
not quite heard.

"Waiting, Your Majesty," repeated Kutuzov. (Prince Andrew noted that
Kutuzov's upper lip twitched unnaturally as he said the word
"waiting.") "Not all the columns have formed up yet, Your Majesty."

The Tsar heard but obviously did not like the reply; he shrugged his
rather round shoulders and glanced at Novosiltsev who was near him, as
if complaining of Kutuzov.

"You know, Michael Ilarionovich, we are not on the
Empress' Field where a parade does not begin till all the troops are
assembled," said the Tsar with another glance at the Emperor
Francis, as if inviting him if not to join in at least to listen to
what he was saying. But the Emperor Francis continued to look about
him and did not listen.

"That is just why I do not begin, sire," said Kutuzov in a
resounding voice, apparently to preclude the possibility of not
being heard, and again something in his face twitched--"That is just
why I do not begin, sire, because we are not on parade and not on
the Empress' Field." said clearly and distinctly.

In the Emperor's suite all exchanged rapid looks that expressed
dissatisfaction and reproach. "Old though he may be, he should not, he
certainly should not, speak like that," their glances seemed to say.

The Tsar looked intently and observantly into Kutuzov's eye
waiting to hear whether he would say anything more. But Kutuzov,
with respectfully bowed head, seemed also to be waiting. The silence
lasted for about a minute.

"However, if you command it, Your Majesty," said Kutuzov, lifting
his head and again assuming his former tone of a dull, unreasoning,
but submissive general.

He touched his horse and having called Miloradovich, the commander
of the column, gave him the order to advance.

The troops again began to move, and two battalions of the Novgorod
and one of the Apsheron regiment went forward past the Emperor.

As this Apsheron battalion marched by, the red-faced Miloradovich,
without his greatcoat, with his Orders on his breast and an enormous
tuft of plumes in his cocked hat worn on one side with its corners
front and back, galloped strenuously forward, and with a dashing
salute reined in his horse before the Emperor.

"God be with you, general!" said the Emperor.

"Ma foi, sire, nous ferons ce qui sera dans notre possibilite,
sire,"* he answered gaily, raising nevertheless ironic smiles among
the gentlemen of the Tsar's suite by his poor French.


*"Indeed, Sire, we shall do everything it is possible to do, Sire."


Miloradovich wheeled his horse sharply and stationed himself a
little behind the Emperor. The Apsheron men, excited by the Tsar's
presence, passed in step before the Emperors and their suites at a
bold, brisk pace.

"Lads!" shouted Miloradovich in a loud, self-confident, and cheery
voice, obviously so elated by the sound of firing, by the prospect
of battle, and by the sight of the gallant Apsherons, his comrades
in Suvorov's time, now passing so gallantly before the Emperors,
that he forgot the sovereigns' presence. "Lads, it's not the first
village you've had to take," cried he.

"Glad to do our best!" shouted the soldiers.

The Emperor's horse started at the sudden cry. This horse that had
carried the sovereign at reviews in Russia bore him also here on the
field of Austerlitz, enduring the heedless blows of his left foot
and pricking its ears at the sound of shots just as it had done on the
Empress' Field, not understanding the significance of the firing,
nor of the nearness of the Emperor Francis' black cob, nor of all that
was being said, thought, and felt that day by its rider.

The Emperor turned with a smile to one of his followers and made a
remark to him, pointing to the gallant Apsherons.





CHAPTER XVI


Kutuzov accompanied by his adjutants rode at a walking pace behind
the carabineers.

When he had gone less than half a mile in the rear of the column
he stopped at a solitary, deserted house that had probably once been
an inn, where two roads parted. Both of them led downhill and troops
were marching along both.

The fog had begun to clear and enemy troops were already dimly
visible about a mile and a half off on the opposite heights. Down
below, on the left, the firing became more distinct. Kutuzov had
stopped and was speaking to an Austrian general. Prince Andrew, who
was a little behind looking at them, turned to an adjutant to ask
him for a field glass.

"Look, look!" said this adjutant, looking not at the troops in the
distance, but down the hill before him. "It's the French!"

The two generals and the adjutant took hold of the field glass,
trying to snatch it from one another. The expression on all their
faces suddenly changed to one of horror. The French were supposed to
be a mile and a half away, but had suddenly and unexpectedly
appeared just in front of us.

"It's the enemy?... No!... Yes, see it is!... for certain.... But
how is that?" said different voices.

With the naked eye Prince Andrew saw below them to the right, not
more than five hundred paces from where Kutuzov was standing, a
dense French column coming up to meet the Apsherons.

"Here it is! The decisive moment has arrived. My turn has come,"
thought Prince Andrew, and striking his horse he rode up to Kutuzov.

"The Apsherons must be stopped, your excellency," cried he. But at
that very instant a cloud of smoke spread all round, firing was
heard quite close at hand, and a voice of naive terror barely two
steps from Prince Andrew shouted, "Brothers! All's lost!" And at
this as if at a command, everyone began to run.

Confused and ever-increasing crowds were running back to where
five minutes before the troops had passed the Emperors. Not only would
it have been difficult to stop that crowd, it was even impossible
not to be carried back with it oneself. Bolkonski only tried not to
lose touch with it, and looked around bewildered and unable to grasp
what was happening in front of him. Nesvitski with an angry face,
red and unlike himself, was shouting to Kutuzov that if he did not
ride away at once he would certainly be taken prisoner. Kutuzov
remained in the same place and without answering drew out a
handkerchief. Blood was flowing from his cheek. Prince Andrew forced
his way to him.

"You are wounded?" he asked, hardly able to master the trembling
of his lower jaw.

"The wound is not here, it is there!" said Kutuzov, pressing the
handkerchief to his wounded cheek and pointing to the fleeing
soldiers. "Stop them!" he shouted, and at the same moment, probably
realizing that it was impossible to stop them, spurred his horse and
rode to the right.

A fresh wave of the flying mob caught him and bore him back with it.

The troops were running in such a dense mass that once surrounded by
them it was difficult to get out again. One was shouting, "Get on! Why
are you hindering us?" Another in the same place turned round and
fired in the air; a third was striking the horse Kutuzov himself rode.
Having by a great effort got away to the left from that flood of
men, Kutuzov, with his suite diminished by more than half, rode toward
a sound of artillery fire near by. Having forced his way out of the
crowd of fugitives, Prince Andrew, trying to keep near Kutuzov, saw on
the slope of the hill amid the smoke a Russian battery that was
still firing and Frenchmen running toward it. Higher up stood some
Russian infantry, neither moving forward to protect the battery nor
backward with the fleeing crowd. A mounted general separated himself
from the infantry and approached Kutuzov. Of Kutuzov's suite only four
remained. They were all pale and exchanged looks in silence.

"Stop those wretches!" gasped Kutuzov to the regimental commander,
pointing to the flying soldiers; but at that instant, as if to
punish him for those words, bullets flew hissing across the regiment
and across Kutuzov's suite like a flock of little birds.

The French had attacked the battery and, seeing Kutuzov, were firing
at him. After this volley the regimental commander clutched at his
leg; several soldiers fell, and a second lieutenant who was holding
the flag let it fall from his hands. It swayed and fell, but caught on
the muskets of the nearest soldiers. The soldiers started firing
without orders.

"Oh! Oh! Oh!" groaned Kutuzov despairingly and looked around....
"Bolkonski!" he whispered, his voice trembling from a consciousness of
the feebleness of age, "Bolkonski!" he whispered, pointing to the
disordered battalion and at the enemy, "what's that?"

But before he had finished speaking, Prince Andrew, feeling tears of
shame and anger choking him, had already leapt from his horse and
run to the standard.

"Forward, lads!" he shouted in a voice piercing as a child's.

"Here it is!" thought he, seizing the staff of the standard and
hearing with pleasure the whistle of bullets evidently aimed at him.
Several soldiers fell.

"Hurrah!" shouted Prince Andrew, and, scarcely able to hold up the
heavy standard, he ran forward with full confidence that the whole
battalion would follow him.

And really he only ran a few steps alone. One soldier moved and then
another and soon the whole battalion ran forward shouting "Hurrah!"
and overtook him. A sergeant of the battalion ran up and took the flag
that was swaying from its weight in Prince Andrew's hands, but he
was immediately killed. Prince Andrew again seized the standard and,
dragging it by the staff, ran on with the battalion. In front he saw
our artillerymen, some of whom were fighting, while others, having
abandoned their guns, were running toward him. He also saw French
infantry soldiers who were seizing the artillery horses and turning
the guns round. Prince Andrew and the battalion were already within
twenty paces of the cannon. He heard the whistle of bullets above
him unceasingly and to right and left of him soldiers continually
groaned and dropped. But he did not look at them: he looked only at
what was going on in front of him--at the battery. He now saw
clearly the figure of a red-haired gunner with his shako knocked awry,
pulling one end of a mop while a French soldier tugged at the other.
He could distinctly see the distraught yet angry expression on the
faces of these two men, who evidently did not realize what they were
doing.

"What are they about?" thought Prince Andrew as he gazed at them.
"Why doesn't the red-haired gunner run away as he is unarmed? Why
doesn't the Frenchman stab him? He will not get away before the
Frenchman remembers his bayonet and stabs him...."

And really another French soldier, trailing his musket, ran up to
the struggling men, and the fate of the red-haired gunner, who had
triumphantly secured the mop and still did not realize what awaited
him, was about to be decided. But Prince Andrew did not see how it
ended. It seemed to him as though one of the soldiers near him hit him
on the head with the full swing of a bludgeon. It hurt a little, but
the worst of it was that the pain distracted him and prevented his
seeing what he had been looking at.

"What's this? Am I falling? My legs are giving way," thought he, and
fell on his back. He opened his eyes, hoping to see how the struggle
of the Frenchmen with the gunners ended, whether the red-haired gunner
had been killed or not and whether the cannon had been captured or
saved. But he saw nothing. Above him there was now nothing but the
sky--the lofty sky, not clear yet still immeasurably lofty, with
gray clouds gliding slowly across it. "How quiet, peaceful, and
solemn; not at all as I ran," thought Prince Andrew--"not as we ran,
shouting and fighting, not at all as the gunner and the Frenchman with
frightened and angry faces struggled for the mop: how differently do
those clouds glide across that lofty infinite sky! How was it I did
not see that lofty sky before? And how happy I am to have found it
at last! Yes! All is vanity, all falsehood, except that infinite
sky. There is nothing, nothing, but that. But even it does not
exist, there is nothing but quiet and peace. Thank God!..."





CHAPTER XVII


On our right flank commanded by Bagration, at nine o'clock the
battle had not yet begun. Not wishing to agree to Dolgorukov's
demand to commence the action, and wishing to avert responsibility
from himself, Prince Bagration proposed to Dolgorukov to send to
inquire of the commander in chief. Bagration knew that as the distance
between the two flanks was more than six miles, even if the
messenger were not killed (which he very likely would be), and found
the commander in chief (which would be very difficult), he would not
be able to get back before evening.

Bagration cast his large, expressionless, sleepy eyes round his
suite, and the boyish face Rostov, breathless with excitement and
hope, was the first to catch his eye. He sent him.

"And if I should meet His Majesty before I meet the commander in
chief, your excellency?" said Rostov, with his hand to his cap.

"You can give the message to His Majesty," said Dolgorukov,
hurriedly interrupting Bagration.

On being relieved from picket duty Rostov had managed to get a few
hours' sleep before morning and felt cheerful, bold, and resolute,
with elasticity of movement, faith in his good fortune, and
generally in that state of mind which makes everything seem
possible, pleasant, and easy.

All his wishes were being fulfilled that morning: there was to be
a general engagement in which he was taking part, more than that, he
was orderly to the bravest general, and still more, he was going
with a message to Kutuzov, perhaps even to the sovereign himself.
The morning was bright, he had a good horse under him, and his heart
was full of joy and happiness. On receiving the order he gave his
horse the rein and galloped along the line. At first he rode along the
line of Bagration's troops, which had not yet advanced into action but
were standing motionless; then he came to the region occupied by
Uvarov's cavalry and here he noticed a stir and signs of preparation
for battle; having passed Uvarov's cavalry he clearly heard the
sound of cannon and musketry ahead of him. The firing grew louder
and louder.

In the fresh morning air were now heard, not two or three musket
shots at irregular intervals as before, followed by one or two
cannon shots, but a roll of volleys of musketry from the slopes of the
hill before Pratzen, interrupted by such frequent reports of cannon
that sometimes several of them were not separated from one another but
merged into a general roar.

He could see puffs of musketry smoke that seemed to chase one
another down the hillsides, and clouds of cannon smoke rolling,
spreading, and mingling with one another. He could also, by the
gleam of bayonets visible through the smoke, make out moving masses of
infantry and narrow lines of artillery with green caissons.

Rostov stopped his horse for a moment on a hillock to see what was
going on, but strain his attention as he would he could not understand
or make out anything of what was happening: there in the smoke men
of some sort were moving about, in front and behind moved lines of
troops; but why, whither, and who they were, it was impossible to make
out. These sights and sounds had no depressing or intimidating
effect on him; on the contrary, they stimulated his energy and
determination.

"Go on! Go on! Give it them!" he mentally exclaimed at these sounds,
and again proceeded to gallop along the line, penetrating farther
and farther into the region where the army was already in action.

"How it will be there I don't know, but all will be well!" thought
Rostov.

After passing some Austrian troops he noticed that the next part
of the line (the Guards) was already in action.

"So much the better! I shall see it close," he thought.

He was riding almost along the front line. A handful of men came
galloping toward him. They were our Uhlans who with disordered ranks
were returning from the attack. Rostov got out of their way,
involuntarily noticed that one of them was bleeding, and galloped on.

"That is no business of mine," he thought. He had not ridden many
hundred yards after that before he saw to his left, across the whole
width of the field, an enormous mass of cavalry in brilliant white
uniforms, mounted on black horses, trotting straight toward him and
across his path. Rostov put his horse to full gallop to get out of the
way of these men, and he would have got clear had they continued at
the same speed, but they kept increasing their pace, so that some of
the horses were already galloping. Rostov heard the thud of their
hoofs and the jingle of their weapons and saw their horses, their
figures, and even their faces, more and more distinctly. They were our
Horse Guards, advancing to attack the French cavalry that was coming
to meet them.

The Horse Guards were galloping, but still holding in their
horses. Rostov could already see their faces and heard the command:
"Charge!" shouted by an officer who was urging his thoroughbred to
full speed. Rostov, fearing to be crushed or swept into the attack
on the French, galloped along the front as hard as his horse could go,
but still was not in time to avoid them.

The last of the Horse Guards, a huge pockmarked fellow, frowned
angrily on seeing Rostov before him, with whom he would inevitably
collide. This Guardsman would certainly have bowled Rostov and his
Bedouin over (Rostov felt himself quite tiny and weak compared to
these gigantic men and horses) had it not occurred to Rostov to
flourish his whip before the eyes of the Guardsman's horse. The
heavy black horse, sixteen hands high, shied, throwing back its
ears; but the pockmarked Guardsman drove his huge spurs in
violently, and the horse, flourishing its tail and extending its neck,
galloped on yet faster. Hardly had the Horse Guards passed Rostov
before he heard them shout, "Hurrah!" and looking back saw that
their foremost ranks were mixed up with some foreign cavalry with
red epaulets, probably French. He could see nothing more, for
immediately afterwards cannon began firing from somewhere and smoke
enveloped everything.

At that moment, as the Horse Guards, having passed him,
disappeared in the smoke, Rostov hesitated whether to gallop after
them or to go where he was sent. This was the brilliant charge of
the Horse Guards that amazed the French themselves. Rostov was
horrified to hear later that of all that mass of huge and handsome
men, of all those brilliant, rich youths, officers and cadets, who had
galloped past him on their thousand-ruble horses, only eighteen were
left after the charge.

"Why should I envy them? My chance is not lost, and maybe I shall
see the Emperor immediately!" thought Rostov and galloped on.

When he came level with the Foot Guards he noticed that about them
and around them cannon balls were flying, of which he was aware not so
much because he heard their sound as because he saw uneasiness on
the soldiers' faces and unnatural warlike solemnity on those of the
officers.

Passing behind one of the lines of a regiment of Foot Guards he
heard a voice calling him by name.

"Rostov!"

"What?" he answered, not recognizing Boris.

"I say, we've been in the front line! Our regiment attacked!" said
Boris with the happy smile seen on the faces of young men who have
been under fire for the first time.

Rostov stopped.

"Have you?" he said. "Well, how did it go?"

"We drove them back!" said Boris with animation, growing
talkative. "Can you imagine it?" and he began describing how the
Guards, having taken up their position and seeing troops before
them, thought they were Austrians, and all at once discovered from the
cannon balls discharged by those troops that they were themselves in
the front line and had unexpectedly to go into action. Rostov
without hearing Boris to the end spurred his horse.

"Where are you off to?" asked Boris.

"With a message to His Majesty."

"There he is!" said Boris, thinking Rostov had said "His
Highness," and pointing to the Grand Duke who with his high
shoulders and frowning brows stood a hundred paces away from them in
his helmet and Horse Guards' jacket, shouting something to a pale,
white uniformed Austrian officer.

"But that's the Grand Duke, and I want the commander in chief or the
Emperor," said Rostov, and was about to spur his horse.

"Count! Count!" shouted Berg who ran up from the other side as eager
as Boris. "Count! I am wounded in my right hand" (and he showed his
bleeding hand with a handkerchief tied round it) "and I remained at
the front. I held my sword in my left hand, Count. All our family--the
von Bergs--have been knights!"

He said something more, but Rostov did not wait to hear it and
rode away.

Having passed the Guards and traversed an empty space, Rostov, to
avoid again getting in front of the first line as he had done when the
Horse Guards charged, followed the line of reserves, going far round
the place where the hottest musket fire and cannonade were heard.
Suddenly he heard musket fire quite close in front of him and behind
our troops, where he could never have expected the enemy to be.

"What can it be?" he thought. "The enemy in the rear of our army?
Impossible!" And suddenly he was seized by a panic of fear for himself
and for the issue of the whole battle. "But be that what it may," he
reflected, "there is no riding round it now. I must look for the
commander in chief here, and if all is lost it is for me to perish
with the rest."

The foreboding of evil that had suddenly come over Rostov was more
and more confirmed the farther he rode into the region behind the
village of Pratzen, which was full of troops of all kinds.

"What does it mean? What is it? Whom are they firing at? Who is
firing?" Rostov kept asking as he came up to Russian and Austrian
soldiers running in confused crowds across his path.

"The devil knows! They've killed everybody! It's all up now!" he was
told in Russian, German, and Czech by the crowd of fugitives who
understood what was happening as little as he did.

"Kill the Germans!" shouted one.

"May the devil take them--the traitors!"

"Zum Henker diese Russen!"* muttered a German.


*"Hang these Russians!"


Several wounded men passed along the road, and words of abuse,
screams, and groans mingled in a general hubbub, then the firing
died down. Rostov learned later that Russian and Austrian soldiers had
been firing at one another.

"My God! What does it all mean?" thought he. "And here, where at any
moment the Emperor may see them.... But no, these must be only a
handful of scoundrels. It will soon be over, it can't be that, it
can't be! Only to get past them quicker, quicker!"

The idea of defeat and flight could not enter Rostov's head.
Though he saw French cannon and French troops on the Pratzen Heights
just where he had been ordered to look for the commander in chief,
he could not, did not wish to, believe that.





CHAPTER XVIII


Rostov had been ordered to look for Kutuzov and the Emperor near the
village of Pratzen. But neither they nor a single commanding officer
were there, only disorganized crowds of troops of various kinds. He
urged on his already weary horse to get quickly past these crowds, but
the farther he went the more disorganized they were. The highroad on
which he had come out was thronged with caleches, carriages of all
sorts, and Russian and Austrian soldiers of all arms, some wounded and
some not. This whole mass droned and jostled in confusion under the
dismal influence of cannon balls flying from the French batteries
stationed on the Pratzen Heights.

"Where is the Emperor? Where is Kutuzov?" Rostov kept asking
everyone he could stop, but got no answer from anyone.

At last seizing a soldier by his collar he forced him to answer.

"Eh, brother! They've all bolted long ago!" said the soldier,
laughing for some reason and shaking himself free.

Having left that soldier who was evidently drunk, Rostov stopped the
horse of a batman or groom of some important personage and began to
question him. The man announced that the Tsar had been driven in a
carriage at full speed about an hour before along that very road and
that he was dangerously wounded.

"It can't be!" said Rostov. "It must have been someone else."

"I saw him myself." replied the man with a self-confident smile of
derision. "I ought to know the Emperor by now, after the times I've
seen him in Petersburg. I saw him just as I see you.... There he sat
in the carriage as pale as anything. How they made the four black
horses fly! Gracious me, they did rattle past! It's time I knew the
Imperial horses and Ilya Ivanych. I don't think Ilya drives anyone
except the Tsar!"

Rostov let go of the horse and was about to ride on, when a
wounded officer passing by addressed him:

"Who is it you want?" he asked. "The commander in chief? He was
killed by a cannon ball--struck in the breast before our regiment."

"Not killed--wounded!" another officer corrected him.

"Who? Kutuzov?" asked Rostov.

"Not Kutuzov, but what's his name--well, never mind... there are not
many left alive. Go that way, to that village, all the commanders
are there," said the officer, pointing to the village of Hosjeradek,
and he walked on.

Rostov rode on at a footpace not knowing why or to whom he was now
going. The Emperor was wounded, the battle lost. It was impossible
to doubt it now. Rostov rode in the direction pointed out to him, in
which he saw turrets and a church. What need to hurry? What was he now
to say to the Tsar or to Kutuzov, even if they were alive and
unwounded?

"Take this road, your honor, that way you will be killed at once!" a
soldier shouted to him. "They'd kill you there!"

"Oh, what are you talking about?" said another. "Where is he to
go? That way is nearer."

Rostov considered, and then went in the direction where they said he
would be killed.

"It's all the same now. If the Emperor is wounded, am I to try to
save myself?" he thought. He rode on to the region where the
greatest number of men had perished in fleeing from Pratzen. The
French had not yet occupied that region, and the Russians--the
uninjured and slightly wounded--had left it long ago. All about the
field, like heaps of manure on well-kept plowland, lay from ten to
fifteen dead and wounded to each couple of acres. The wounded crept
together in twos and threes and one could hear their distressing
screams and groans, sometimes feigned--or so it seemed to Rostov. He
put his horse to a trot to avoid seeing all these suffering men, and
he felt afraid--afraid not for his life, but for the courage he needed
and which he knew would not stand the sight of these unfortunates.

The French, who had ceased firing at this field strewn with dead and
wounded where there was no one left to fire at, on seeing an
adjutant riding over it trained a gun on him and fired several
shots. The sensation of those terrible whistling sounds and of the
corpses around him merged in Rostov's mind into a single feeling of
terror and pity for himself. He remembered his mother's last letter.
"What would she feel," thought he, "if she saw me here now on this
field with the cannon aimed at me?"

In the village of Hosjeradek there were Russian troops retiring from
the field of battle, who though still in some confusion were less
disordered. The French cannon did not reach there and the musketry
fire sounded far away. Here everyone clearly saw and said that the
battle was lost. No one whom Rostov asked could tell him where the
Emperor or Kutuzov was. Some said the report that the Emperor was
wounded was correct, others that it was not, and explained the false
rumor that had spread by the fact that the Emperor's carriage had
really galloped from the field of battle with the pale and terrified
Ober-Hofmarschal Count Tolstoy, who had ridden out to the
battlefield with others in the Emperor's suite. One officer told
Rostov that he had seen someone from headquarters behind the village
to the left, and thither Rostov rode, not hoping to find anyone but
merely to ease his conscience. When he had ridden about two miles
and had passed the last of the Russian troops, he saw, near a
kitchen garden with a ditch round it, two men on horseback facing
the ditch. One with a white plume in his hat seemed familiar to
Rostov; the other on a beautiful chestnut horse (which Rostov
fancied he had seen before) rode up to the ditch, struck his horse
with his spurs, and giving it the rein leaped lightly over. Only a
little earth crumbled from the bank under the horse's hind hoofs.
Turning the horse sharply, he again jumped the ditch, and
deferentially addressed the horseman with the white plumes,
evidently suggesting that he should do the same. The rider, whose
figure seemed familiar to Rostov and involuntarily riveted his
attention, made a gesture of refusal with his head and hand and by
that gesture Rostov instantly recognized his lamented and adored
monarch.

"But it can't be he, alone in the midst of this empty field!"
thought Rostov. At that moment Alexander turned his head and Rostov
saw the beloved features that were so deeply engraved on his memory.
The Emperor was pale, his cheeks sunken and his eyes hollow, but the
charm, the mildness of his features, was all the greater. Rostov was
happy in the assurance that the rumors about the Emperor being wounded
were false. He was happy to be seeing him. He knew that he might and
even ought to go straight to him and give the message Dolgorukov had
ordered him to deliver.

But as a youth in love trembles, is unnerved, and dares not utter
the thoughts he has dreamed of for nights, but looks around for help
or a chance of delay and flight when the longed-for moment comes and
he is alone with her, so Rostov, now that he had attained what he
had longed for more than anything else in the world, did not know
how to approach the Emperor, and a thousand reasons occurred to him
why it would be inconvenient, unseemly, and impossible to do so.

"What! It is as if I were glad of a chance to take advantage of
his being alone and despondent! A strange face may seem unpleasant
or painful to him at this moment of sorrow; besides, what can I say to
him now, when my heart fails me and my mouth feels dry at the mere
sight of him?" Not one of the innumerable speeches addressed to the
Emperor that he had composed in his imagination could he now recall.
Those speeches were intended for quite other conditions, they were for
the most part to be spoken at a moment of victory and triumph,
generally when he was dying of wounds and the sovereign had thanked
him for heroic deeds, and while dying he expressed the love his
actions had proved.

"Besides how can I ask the Emperor for his instructions for the
right flank now that it is nearly four o'clock and the battle is lost?
No, certainly I must not approach him, I must not intrude on his
reflections. Better die a thousand times than risk receiving an unkind
look or bad opinion from him," Rostov decided; and sorrowfully and
with a heart full despair he rode away, continually looking back at
the Tsar, who still remained in the same attitude of indecision.

While Rostov was thus arguing with himself and riding sadly away,
Captain von Toll chanced to ride to the same spot, and seeing the
Emperor at once rode up to him, offered his services, and assisted him
to cross the ditch on foot. The Emperor, wishing to rest and feeling
unwell, sat down under an apple tree and von Toll remained beside him.
Rostov from a distance saw with envy and remorse how von Toll spoke
long and warmly to the Emperor and how the Emperor, evidently weeping,
covered his eyes with his hand and pressed von Toll's hand.

"And I might have been in his place!" thought Rostov, and hardly
restraining his tears of pity for the Emperor, he rode on in utter
despair, not knowing where to or why he was now riding.

His despair was all the greater from feeling that his own weakness
was the cause his grief.

He might... not only might but should, have gone up to the
sovereign. It was a unique chance to show his devotion to the
Emperor and he had not made use of it.... "What have I done?"
thought he. And he turned round and galloped back to the place where
he had seen the Emperor, but there was no one beyond the ditch now.
Only some carts and carriages were passing by. From one of the drivers
he learned that Kutuzov's staff were not far off, in the village the
vehicles were going to. Rostov followed them. In front of him walked
Kutuzov's groom leading horses in horsecloths. Then came a cart, and
behind that walked an old, bandy-legged domestic serf in a peaked
cap and sheepskin coat.

"Tit! I say, Tit!" said the groom.

"What?" answered the old man absent-mindedly.

"Go, Tit! Thresh a bit!"

"Oh, you fool!" said the old man, spitting angrily. Some time passed
in silence, and then the same joke was repeated.


Before five in the evening the battle had been lost at all points.
More than a hundred cannon were already in the hands of the French.

Przebyszewski and his corps had laid down their arms. Other
columns after losing half their men were retreating in disorderly
confused masses.

The remains of Langeron's and Dokhturov's mingled forces were
crowding around the dams and banks of the ponds near the village of
Augesd.

After five o'clock it was only at the Augesd Dam that a hot
cannonade (delivered by the French alone) was still to be heard from
numerous batteries ranged on the slopes of the Pratzen Heights,
directed at our retreating forces.

In the rearguard, Dokhturov and others rallying some battalions kept
up a musketry fire at the French cavalry that was pursuing our troops.
It was growing dusk. On the narrow Augesd Dam where for so many
years the old miller had been accustomed to sit in his tasseled cap
peacefully angling, while his grandson, with shirt sleeves rolled
up, handled the floundering silvery fish in the watering can, on
that dam over which for so many years Moravians in shaggy caps and
blue jackets had peacefully driven their two-horse carts loaded with
wheat and had returned dusty with flour whitening their carts--on that
narrow dam amid the wagons and the cannon, under the horses' hoofs and
between the wagon wheels, men disfigured by fear of death now
crowded together, crushing one another, dying, stepping over the dying
and killing one another, only to move on a few steps and be killed
themselves in the same way.

Every ten seconds a cannon ball flew compressing the air around,
or a shell burst in the midst of that dense throng, killing some and
splashing with blood those near them.

Dolokhov--now an officer--wounded in the arm, and on foot, with
the regimental commander on horseback and some ten men of his company,
represented all that was left of that whole regiment. Impelled by
the crowd, they had got wedged in at the approach to the dam and,
jammed in on all sides, had stopped because a horse in front had
fallen under a cannon and the crowd were dragging it out. A cannon
ball killed someone behind them, another fell in front and splashed
Dolokhov with blood. The crowd, pushing forward desperately,
squeezed together, moved a few steps, and again stopped.

"Move on a hundred yards and we are certainly saved, remain here
another two minutes and it is certain death," thought each one.

Dolokhov who was in the midst of the crowd forced his way to the
edge of the dam, throwing two soldiers off their feet, and ran onto
the slippery ice that covered the millpool.

"Turn this way!" he shouted, jumping over the ice which creaked
under him; "turn this way!" he shouted to those with the gun. "It
bears!..."

The ice bore him but it swayed and creaked, and it was plain that it
would give way not only under a cannon or a crowd, but very soon
even under his weight alone. The men looked at him and pressed to
the bank, hesitating to step onto the ice. The general on horseback at
the entrance to the dam raised his hand and opened his mouth to
address Dolokhov. Suddenly a cannon ball hissed so low above the crowd
that everyone ducked. It flopped into something moist, and the general
fell from his horse in a pool of blood. Nobody gave him a look or
thought of raising him.

"Get onto the ice, over the ice! Go on! Turn! Don't you hear? Go
on!" innumerable voices suddenly shouted after the ball had struck the
general, the men themselves not knowing what, or why, they were
shouting.

One of the hindmost guns that was going onto the dam turned off onto
the ice. Crowds of soldiers from the dam began running onto the frozen
pond. The ice gave way under one of the foremost soldiers, and one leg
slipped into the water. He tried to right himself but fell in up to
his waist. The nearest soldiers shrank back, the gun driver stopped
his horse, but from behind still came the shouts: "Onto the ice, why
do you stop? Go on! Go on!" And cries of horror were heard in the
crowd. The soldiers near the gun waved their arms and beat the
horses to make them turn and move on. The horses moved off the bank.
The ice, that had held under those on foot, collapsed in a great mass,
and some forty men who were on it dashed, some forward and some
back, drowning one another.

Still the cannon balls continued regularly to whistle and flop
onto the ice and into the water and oftenest of all among the crowd
that covered the dam, the pond, and the bank.





CHAPTER XIX


On the Pratzen Heights, where he had fallen with the flagstaff in
his hand, lay Prince Andrew Bolkonski bleeding profusely and
unconsciously uttering a gentle, piteous, and childlike moan.

Toward evening he ceased moaning and became quite still. He did
not know how long his unconsciousness lasted. Suddenly he again felt
that he was alive and suffering from a burning, lacerating pain in his
head.

"Where is it, that lofty sky that I did not know till now, but saw
today?" was his first thought. "And I did not know this suffering
either," he thought. "Yes, I did not know anything, anything at all
till now. But where am I?"

He listened and heard the sound of approaching horses, and voices
speaking French. He opened his eyes. Above him again was the same
lofty sky with clouds that had risen and were floating still higher,
and between them gleamed blue infinity. He did not turn his head and
did not see those who, judging by the sound of hoofs and voices, had
ridden up and stopped near him.

It was Napoleon accompanied by two aides-de-camp. Bonaparte riding
over the battlefield had given final orders to strengthen the
batteries firing at the Augesd Dam and was looking at the killed and
wounded left on the field.

"Fine men!" remarked Napoleon, looking at a dead Russian
grenadier, who, with his face buried in the ground and a blackened
nape, lay on his stomach with an already stiffened arm flung wide.

"The ammunition for the guns in position is exhausted, Your
Majesty," said an adjutant who had come from the batteries that were
firing at Augesd.

"Have some brought from the reserve," said Napoleon, and having gone
on a few steps he stopped before Prince Andrew, who lay on his back
with the flagstaff that had been dropped beside him. (The flag had
already been taken by the French as a trophy.)

"That's a fine death!" said Napoleon as he gazed at Bolkonski.

Prince Andrew understood that this was said of him and that it was
Napoleon who said it. He heard the speaker addressed as Sire. But he
heard the words as he might have heard the buzzing of a fly. Not
only did they not interest him, but he took no notice of them and at
once forgot them. His head was burning, he felt himself bleeding to
death, and he saw above him the remote, lofty, and everlasting sky. He
knew it was Napoleon--his hero--but at that moment Napoleon seemed
to him such a small, insignificant creature compared with what was
passing now between himself and that lofty infinite sky with the
clouds flying over it. At that moment it meant nothing to him who
might be standing over him, or what was said of him; he was only
glad that people were standing near him and only wished that they
would help him and bring him back to life, which seemed to him so
beautiful now that he had today learned to understand it so
differently. He collected all his strength, to stir and utter a sound.
He feebly moved his leg and uttered a weak, sickly groan which aroused
his own pity.

"Ah! He is alive," said Napoleon. "Lift this young man up and
carry him to the dressing station."

Having said this, Napoleon rode on to meet Marshal Lannes, who,
hat in hand, rode up smiling to the Emperor to congratulate him on the
victory.

Prince Andrew remembered nothing more: he lost consciousness from
the terrible pain of being lifted onto the stretcher, the jolting
while being moved, and the probing of his wound at the dressing
station. He did not regain consciousness till late in the day, when
with other wounded and captured Russian officers he was carried to the
hospital. During this transfer he felt a little stronger and was
able to look about him and even speak.

The first words he heard on coming to his senses were those of a
French convoy officer, who said rapidly: "We must halt here: the
Emperor will pass here immediately; it will please him to see these
gentlemen prisoners."

"There are so many prisoners today, nearly the whole Russian army,
that he is probably tired of them," said another officer.

"All the same! They say this one is the commander of all the Emperor
Alexander's Guards," said the first one, indicating a Russian
officer in the white uniform of the Horse Guards.

Bolkonski recognized Prince Repnin whom he had met in Petersburg
society. Beside him stood a lad of nineteen, also a wounded officer of
the Horse Guards.

Bonaparte, having come up at a gallop, stopped his horse.

"Which is the senior?" he asked, on seeing the prisoners.

They named the colonel, Prince Repnin.

"You are the commander of the Emperor Alexander's regiment of
Horse Guards?" asked Napoleon.

"I commanded a squadron," replied Repnin.

"Your regiment fulfilled its duty honorably," said Napoleon.

"The praise of a great commander is a soldier's highest reward,"
said Repnin.

"I bestow it with pleasure," said Napoleon. "And who is that young
man beside you?"

Prince Repnin named Lieutenant Sukhtelen.

After looking at him Napoleon smiled.

"He's very young to come to meddle with us."

"Youth is no hindrance to courage," muttered Sukhtelen in a
failing voice.

"A splendid reply!" said Napoleon. "Young man, you will go far!"

Prince Andrew, who had also been brought forward before the
Emperor's eyes to complete the show of prisoners, could not fail to
attract his attention. Napoleon apparently remembered seeing him on
the battlefield and, addressing him, again used the epithet "young
man" that was connected in his memory with Prince Andrew.

"Well, and you, young man," said he. "How do you feel, mon brave?"

Though five minutes before, Prince Andrew had been able to say a few
words to the soldiers who were carrying him, now with his eyes fixed
straight on Napoleon, he was silent.... So insignificant at that
moment seemed to him all the interests that engrossed Napoleon, so
mean did his hero himself with his paltry vanity and joy in victory
appear, compared to the lofty, equitable, and kindly sky which he
had seen and understood, that he could not answer him.

Everything seemed so futile and insignificant in comparison with the
stern and solemn train of thought that weakness from loss of blood,
suffering, and the nearness of death aroused in him. Looking into
Napoleon's eyes Prince Andrew thought of the insignificance of
greatness, the unimportance of life which no one could understand, and
the still greater unimportance of death, the meaning of which no one
alive could understand or explain.

The Emperor without waiting for an answer turned away and said to
one of the officers as he went: "Have these gentlemen attended to
and taken to my bivouac; let my doctor, Larrey, examine their
wounds. Au revoir, Prince Repnin!" and he spurred his horse and
galloped away.

His face shone with self-satisfaction and pleasure.

The soldiers who had carried Prince Andrew had noticed and taken the
little gold icon Princess Mary had hung round her brother's neck,
but seeing the favor the Emperor showed the prisoners, they now
hastened to return the holy image.

Prince Andrew did not see how and by whom it was replaced, but the
little icon with its thin gold chain suddenly appeared upon his
chest outside his uniform.

"It would be good," thought Prince Andrew, glancing at the icon
his sister had hung round his neck with such emotion and reverence,
"it would be good if everything were as clear and simple as it seems
to Mary. How good it would be to know where to seek for help in this
life, and what to expect after it beyond the grave! How happy and calm
I should be if I could now say: 'Lord, have mercy on me!'... But to
whom should I say that? Either to a Power indefinable,
incomprehensible, which I not only cannot address but which I cannot
even express in words--the Great All or Nothing-" said he to
himself, "or to that God who has been sewn into this amulet by Mary!
There is nothing certain, nothing at all except the unimportance of
everything I understand, and the greatness of something
incomprehensible but all-important."

The stretchers moved on. At every jolt he again felt unendurable
pain; his feverishness increased and he grew delirious. Visions of his
father, wife, sister, and future son, and the tenderness he had felt
the night before the battle, the figure of the insignificant little
Napoleon, and above all this the lofty sky, formed the chief
subjects of his delirious fancies.

The quiet home life and peaceful happiness of Bald Hills presented
itself to him. He was already enjoying that happiness when that little
Napoleon had suddenly appeared with his unsympathizing look of
shortsighted delight at the misery of others, and doubts and
torments had followed, and only the heavens promised peace. Toward
morning all these dreams melted and merged into the chaos and darkness
of unconciousness and oblivion which in the opinion of Napoleon's
doctor, Larrey, was much more likely to end in death than in
convalescence.

"He is a nervous, bilious subject," said Larrey, "and will not
recover."

And Prince Andrew, with others fatally wounded, was left to the care
of the inhabitants of the district.





BOOK FOUR: 1806



CHAPTER I


Early in the year 1806 Nicholas Rostov returned home on leave.
Denisov was going home to Voronezh and Rostov persuaded him to
travel with him as far as Moscow and to stay with him there. Meeting a
comrade at the last post station but one before Moscow, Denisov had
drunk three bottles of wine with him and, despite the jolting ruts
across the snow-covered road, did not once wake up on the way to
Moscow, but lay at the bottom of the sleigh beside Rostov, who grew
more and more impatient the nearer they got to Moscow.

"How much longer? How much longer? Oh, these insufferable streets,
shops, bakers' signboards, street lamps, and sleighs!" thought Rostov,
when their leave permits had been passed at the town gate and they had
entered Moscow.

"Denisov! We're here! He's asleep," he added, leaning forward with
his whole body as if in that position he hoped to hasten the speed
of the sleigh.

Denisov gave no answer.

"There's the corner at the crossroads, where the cabman, Zakhar, has
his stand, and there's Zakhar himself and still the same horse! And
here's the little shop where we used to buy gingerbread! Can't you
hurry up? Now then!"

"Which house is it?" asked the driver.

"Why, that one, right at the end, the big one. Don't you see? That's
our house," said Rostov. "Of course, it's our house! Denisov, Denisov!
We're almost there!"

Denisov raised his head, coughed, and made no answer.

"Dmitri," said Rostov to his valet on the box, "those lights are
in our house, aren't they?"

"Yes, sir, and there's a light in your father's study."

"Then they've not gone to bed yet? What do you think? Mind now,
don't forget to put out my new coat," added Rostov, fingering his
new mustache. "Now then, get on," he shouted to the driver. "Do wake
up, Vaska!" he went on, turning to Denisov, whose head was again
nodding. "Come, get on! You shall have three rubles for vodka--get
on!" Rostov shouted, when the sleigh was only three houses from his
door. It seemed to him the horses were not moving at all. At last
the sleigh bore to the right, drew up at an entrance, and Rostov saw
overhead the old familiar cornice with a bit of plaster broken off,
the porch, and the post by the side of the pavement. He sprang out
before the sleigh stopped, and ran into the hall. The house stood cold
and silent, as if quite regardless of who had come to it. There was no
one in the hall. "Oh God! Is everyone all right?" he thought, stopping
for a moment with a sinking heart, and then immediately starting to
run along the hall and up the warped steps of the familiar
staircase. The well-known old door handle, which always angered the
countess when it was not properly cleaned, turned as loosely as
ever. A solitary tallow candle burned in the anteroom.

Old Michael was asleep on the chest. Prokofy, the footman, who was
so strong that he could lift the back of the carriage from behind, sat
plaiting slippers out of cloth selvedges. He looked up at the
opening door and his expression of sleepy indifference suddenly
changed to one of delighted amazement.

"Gracious heavens! The young count!" he cried, recognizing his young
master. "Can it be? My treasure!" and Prokofy, trembling with
excitement, rushed toward the drawing-room door, probably in order
to announce him, but, changing his mind, came back and stooped to kiss
the young man's shoulder.

"All well?" asked Rostov, drawing away his arm.

"Yes, God be thanked! Yes! They've just finished supper. Let me have
a look at you, your excellency."

"Is everything quite all right?"

"The Lord be thanked, yes!"

Rostov, who had completely forgotten Denisov, not wishing anyone
to forestall him, threw off his fur coat and ran on tiptoe through the
large dark ballroom. All was the same: there were the same old card
tables and the same chandelier with a cover over it; but someone had
already seen the young master, and, before he had reached the
drawing room, something flew out from a side door like a tornado and
began hugging and kissing him. Another and yet another creature of the
same kind sprang from a second door and a third; more hugging, more
kissing, more outcries, and tears of joy. He could not distinguish
which was Papa, which Natasha, and which Petya. Everyone shouted,
talked, and kissed him at the same time. Only his mother was not
there, he noticed that.

"And I did not know... Nicholas... My darling!..."

"Here he is... our own... Kolya,* dear fellow... How he has
changed!... Where are the candles?... Tea!..."


*Nicholas.


"And me, kiss me!"

"Dearest... and me!"

Sonya, Natasha, Petya, Anna Mikhaylovna, Vera, and the old count
were all hugging him, and the serfs, men and maids, flocked into the
room, exclaiming and oh-ing and ah-ing.

Petya, clinging to his legs, kept shouting, "And me too!"

Natasha, after she had pulled him down toward her and covered his
face with kisses, holding him tight by the skirt of his coat, sprang
away and pranced up and down in one place like a goat and shrieked
piercingly.

All around were loving eyes glistening with tears of joy, and all
around were lips seeking a kiss.

Sonya too, all rosy red, clung to his arm and, radiant with bliss,
looked eagerly toward his eyes, waiting for the look for which she
longed. Sonya now was sixteen and she was very pretty, especially at
this moment of happy, rapturous excitement. She gazed at him, not
taking her eyes off him, and smiling and holding her breath. He gave
her a grateful look, but was still expectant and looking for
someone. The old countess had not yet come. But now steps were heard
at the door, steps so rapid that they could hardly be his mother's.

Yet it was she, dressed in a new gown which he did not know, made
since he had left. All the others let him go, and he ran to her.
When they met, she fell on his breast, sobbing. She could not lift her
face, but only pressed it to the cold braiding of his hussar's jacket.
Denisov, who had come into the room unnoticed by anyone, stood there
and wiped his eyes at the sight.

"Vasili Denisov, your son's friend," he said, introducing himself to
the count, who was looking inquiringly at him.

"You are most welcome! I know, I know," said the count, kissing
and embracing Denisov. "Nicholas wrote us... Natasha, Vera, look! Here
is Denisov!"

The same happy, rapturous faces turned to the shaggy figure of
Denisov.

"Darling Denisov!" screamed Natasha, beside herself with rapture,
springing to him, putting her arms round him, and kissing him. This
escapade made everybody feel confused. Denisov blushed too, but smiled
and, taking Natasha's hand, kissed it.

Denisov was shown to the room prepared for him, and the Rostovs
all gathered round Nicholas in the sitting room.

The old countess, not letting go of his hand and kissing it every
moment, sat beside him: the rest, crowding round him, watched every
movement, word, or look of his, never taking their blissfully
adoring eyes off him. His brother and sisters struggled for the places
nearest to him and disputed with one another who should bring him
his tea, handkerchief, and pipe.

Rostov was very happy in the love they showed him; but the first
moment of meeting had been so beatific that his present joy seemed
insufficient, and he kept expecting something more, more and yet more.

Next morning, after the fatigues of their journey, the travelers
slept till ten o'clock.

In the room next their bedroom there was a confusion of sabers,
satchels, sabretaches, open portmanteaus, and dirty boots. Two freshly
cleaned pairs with spurs had just been placed by the wall. The
servants were bringing in jugs and basins, hot water for shaving,
and their well-brushed clothes. There was a masculine odor and a smell
of tobacco.

"Hallo, Gwiska--my pipe!" came Vasili Denisov's husky voice.
"Wostov, get up!"

Rostov, rubbing his eyes that seemed glued together, raised his
disheveled head from the hot pillow.

"Why, is it late?"

"Late! It's nearly ten o'clock," answered Natasha's voice. A
rustle of starched petticoats and the whispering and laughter of
girls' voices came from the adjoining room. The door was opened a
crack and there was a glimpse of something blue, of ribbons, black
hair, and merry faces. It was Natasha, Sonya, and Petya, who had
come to see whether they were getting up.

"Nicholas! Get up!" Natasha's voice was again heard at the door.

"Directly!"

Meanwhile, Petya, having found and seized the sabers in the outer
room, with the delight boys feel at the sight of a military elder
brother, and forgetting that it was unbecoming for the girls to see
men undressed, opened the bedroom door.

"Is this your saber?" he shouted.

The girls sprang aside. Denisov hid his hairy legs under the
blanket, looking with a scared face at his comrade for help. The door,
having let Petya in, closed again. A sound of laughter came from
behind it.

"Nicholas! Come out in your dressing gown!" said Natasha's voice.

"Is this your saber?" asked Petya. "Or is it yours?" he said,
addressing the black-mustached Denisov with servile deference.

Rostov hurriedly put something on his feet, drew on his dressing
gown, and went out. Natasha had put on one spurred boot and was just
getting her foot into the other. Sonya, when he came in, was
twirling round and was about to expand her dresses into a balloon
and sit down. They were dressed alike, in new pale-blue frocks, and
were both fresh, rosy, and bright. Sonya ran away, but Natasha, taking
her brother's arm, led him into the sitting room, where they began
talking. They hardly gave one another time to ask questions and give
replies concerning a thousand little matters which could not
interest anyone but themselves. Natasha laughed at every word he
said or that she said herself, not because what they were saying was
amusing, but because she felt happy and was unable to control her
joy which expressed itself by laughter.

"Oh, how nice, how splendid!" she said to everything.

Rostov felt that, under the influence of the warm rays of love, that
childlike smile which had not once appeared on his face since he
left home now for the first time after eighteen months again
brightened his soul and his face.

"No, but listen," she said, "now you are quite a man, aren't you?
I'm awfully glad you're my brother." She touched his mustache. "I want
to know what you men are like. Are you the same as we? No?"

"Why did Sonya run away?" asked Rostov.

"Ah, yes! That's a whole long story! How are you going to speak to
her--thou or you?"

"As may happen," said Rostov.

"No, call her you, please! I'll tell you all about it some other
time. No, I'll tell you now. You know Sonya's my dearest friend.
Such a friend that I burned my arm for her sake. Look here!"

She pulled up her muslin sleeve and showed him a red scar on her
long, slender, delicate arm, high above the elbow on that part that is
covered even by a ball dress.

"I burned this to prove my love for her. I just heated a ruler in
the fire and pressed it there!"

Sitting on the sofa with the little cushions on its arms, in what
used to be his old schoolroom, and looking into Natasha's wildly
bright eyes, Rostov re-entered that world of home and childhood
which had no meaning for anyone else, but gave him some of the best
joys of his life; and the burning of an arm with a ruler as a proof of
love did not seem to him senseless, he understood and was not
surprised at it.

"Well, and is that all?" he asked.

"We are such friends, such friends! All that ruler business was just
nonsense, but we are friends forever. She, if she loves anyone, does
it for life, but I don't understand that, I forget quickly."

"Well, what then?"

"Well, she loves me and you like that."

Natasha suddenly flushed.

"Why, you remember before you went away?... Well, she says you are
to forget all that.... She says: 'I shall love him always, but let him
be free.' Isn't that lovely and noble! Yes, very noble? Isn't it?"
asked Natasha, so seriously and excitedly that it was evident that
what she was now saying she had talked of before, with tears.

Rostov became thoughtful.

"I never go back on my word," he said. "Besides, Sonya is so
charming that only a fool would renounce such happiness."

"No, no!" cried Natasha, "she and I have already talked it over.
We knew you'd say so. But it won't do, because you see, if you say
that--if you consider yourself bound by your promise--it will seem
as if she had not meant it seriously. It makes it as if you were
marrying her because you must, and that wouldn't do at all."

Rostov saw that it had been well considered by them. Sonya had
already struck him by her beauty on the preceding day. Today, when
he had caught a glimpse of her, she seemed still more lovely. She
was a charming girl of sixteen, evidently passionately in love with
him (he did not doubt that for an instant). Why should he not love her
now, and even marry her, Rostov thought, but just now there were so
many other pleasures and interests before him! "Yes, they have taken a
wise decision," he thought, "I must remain free."

"Well then, that's excellent," said he. "We'll talk it over later
on. Oh, how glad I am to have you!"

"Well, and are you still true to Boris?" he continued.

"Oh, what nonsense!" cried Natasha, laughing. "I don't think about
him or anyone else, and I don't want anything of the kind."

"Dear me! Then what are you up now?"

"Now?" repeated Natasha, and a happy smile lit up her face. "Have
you seen Duport?"

"No."

"Not seen Duport--the famous dancer? Well then, you won't
understand. That's what I'm up to."

Curving her arms, Natasha held out her skirts as dancers do, ran
back a few steps, turned, cut a caper, brought her little feet sharply
together, and made some steps on the very tips of her toes.

"See, I'm standing! See!" she said, but could not maintain herself
on her toes any longer. "So that's what I'm up to! I'll never marry
anyone, but will be a dancer. Only don't tell anyone."

Rostov laughed so loud and merrily that Denisov, in his bedroom,
felt envious and Natasha could not help joining in.

"No, but don't you think it's nice?" she kept repeating.

"Nice! And so you no longer wish to marry Boris?"

Natasha flared up. "I don't want to marry anyone. And I'll tell
him so when I see him!"

"Dear me!" said Rostov.

"But that's all rubbish," Natasha chattered on. "And is Denisov
nice?" she asked.

"Yes, indeed!"

"Oh, well then, good-by: go and dress. Is he very terrible,
Denisov?"

"Why terrible?" asked Nicholas. "No, Vaska is a splendid fellow."

"You call him Vaska? That's funny! And is he very nice?"

"Very."

"Well then, be quick. We'll all have breakfast together."

And Natasha rose and went out of the room on tiptoe, like a ballet
dancer, but smiling as only happy girls of fifteen can smile. When
Rostov met Sonya in the drawing room, he reddened. He did not know how
to behave with her. The evening before, in the first happy moment of
meeting, they had kissed each other, but today they felt it could
not be done; he felt that everybody, including his mother and sisters,
was looking inquiringly at him and watching to see how he would behave
with her. He kissed her hand and addressed her not as thou but as you-
Sonya. But their eyes met and said thou, and exchanged tender
kisses. Her looks asked him to forgive her for having dared, by
Natasha's intermediacy, to remind him of his promise, and then thanked
him for his love. His looks thanked her for offering him his freedom
and told her that one way or another he would never cease to love her,
for that would be impossible.

"How strange it is," said Vera, selecting a moment when all were
silent, "that Sonya and Nicholas now say you to one another and meet
like strangers."

Vera's remark was correct, as her remarks always were, but, like
most of her observations, it made everyone feel uncomfortable, not
only Sonya, Nicholas, and Natasha, but even the old countess, who-
dreading this love affair which might hinder Nicholas from making a
brilliant match--blushed like a girl.

Denisov, to Rostov's surprise, appeared in the drawing room with
pomaded hair, perfumed, and in a new uniform, looking just as smart as
he made himself when going into battle, and he was more amiable to the
ladies and gentlemen than Rostov had ever expected to see him.





CHAPTER II


On his return to Moscow from the army, Nicholas Rostov was
welcomed by his home circle as the best of sons, a hero, and their
darling Nikolenka; by his relations as a charming, attractive, and
polite young man; by his acquaintances as a handsome lieutenant of
hussars, a good dancer, and one of the best matches in the city.

The Rostovs knew everybody in Moscow. The old count had money enough
that year, as all his estates had been remortgaged, and so Nicholas,
acquiring a trotter of his own, very stylish riding breeches of the
latest cut, such as no one else yet had in Moscow, and boots of the
latest fashion, with extremely pointed toes and small silver spurs,
passed his time very gaily. After a short period of adapting himself
to the old conditions of life, Nicholas found it very pleasant to be
at home again. He felt that he had grown up and matured very much. His
despair at failing in a Scripture examination, his borrowing money
from Gavril to pay a sleigh driver, his kissing Sonya on the sly--he
now recalled all this as childishness he had left immeasurably behind.
Now he was a lieutenant of hussars, in a jacket laced with silver, and
wearing the Cross of St. George, awarded to soldiers for bravery in
action, and in the company of well-known, elderly, and respected
racing men was training a trotter of his own for a race. He knew a
lady on one of the boulevards whom he visited of an evening. He led
the mazurka at the Arkharovs' ball, talked about the war with Field
Marshal Kamenski, visited the English Club, and was on intimate
terms with a colonel of forty to whom Denisov had introduced him.

His passion for the Emperor had cooled somewhat in Moscow. But
still, as he did not see him and had no opportunity of seeing him,
he often spoke about him and about his love for him, letting it be
understood that he had not told all and that there was something in
his feelings for the Emperor not everyone could understand, and with
his whole soul he shared the adoration then common in Moscow for the
Emperor, who was spoken of as the "angel incarnate."

During Rostov's short stay in Moscow, before rejoining the army,
he did not draw closer to Sonya, but rather drifted away from her. She
was very pretty and sweet, and evidently deeply in love with him,
but he was at the period of youth when there seems so much to do
that there is no time for that sort of thing and a young man fears
to bind himself and prizes his freedom which he needs for so many
other things. When he thought of Sonya, during this stay in Moscow, he
said to himself, "Ah, there will be, and there are, many more such
girls somewhere whom I do not yet know. There will be time enough to
think about love when I want to, but now I have no time." Besides,
it seemed to him that the society of women was rather derogatory to
his manhood. He went to balls and into ladies' society with an
affectation of doing so against his will. The races, the English Club,
sprees with Denisov, and visits to a certain house--that was another
matter and quite the thing for a dashing young hussar!

At the beginning of March, old Count Ilya Rostov was very busy
arranging a dinner in honor of Prince Bagration at the English Club.

The count walked up and down the hall in his dressing gown, giving
orders to the club steward and to the famous Feoktist, the Club's head
cook, about asparagus, fresh cucumbers, strawberries, veal, and fish
for this dinner. The count had been a member and on the committee of
the Club from the day it was founded. To him the Club entrusted the
arrangement of the festival in honor of Bagration, for few men knew so
well how to arrange a feast on an open-handed, hospitable scale, and
still fewer men would be so well able and willing to make up out of
their own resources what might be needed for the success of the
fete. The club cook and the steward listened to the count's orders
with pleased faces, for they knew that under no other management could
they so easily extract a good profit for themselves from a dinner
costing several thousand rubles.

"Well then, mind and have cocks' comb in the turtle soup, you know!"

"Shall we have three cold dishes then?" asked the cook.

The count considered.

"We can't have less--yes, three... the mayonnaise, that's one," said
he, bending down a finger.

"Then am I to order those large sterlets?" asked the steward.

"Yes, it can't be helped if they won't take less. Ah, dear me! I was
forgetting. We must have another entree. Ah, goodness gracious!" he
clutched at his head. "Who is going to get me the flowers? Dmitri! Eh,
Dmitri! Gallop off to our Moscow estate," he said to the factotum
who appeared at his call. "Hurry off and tell Maksim, the gardener, to
set the serfs to work. Say that everything out of the hothouses must
be brought here well wrapped up in felt. I must have two hundred
pots here on Friday."

Having given several more orders, he was about to go to his
"little countess" to have a rest, but remembering something else of
importance, he returned again, called back the cook and the club
steward, and again began giving orders. A light footstep and the
clinking of spurs were heard at the door, and the young count,
handsome, rosy, with a dark little mustache, evidently rested and made
sleeker by his easy life in Moscow, entered the room.

"Ah, my boy, my head's in a whirl!" said the old man with a smile,
as if he felt a little confused before his son. "Now, if you would
only help a bit! I must have singers too. I shall have my own
orchestra, but shouldn't we get the gypsy singers as well? You
military men like that sort of thing."

"Really, Papa, I believe Prince Bagration worried himself less
before the battle of Schon Grabern than you do now," said his son with
a smile.

The old count pretended to be angry.

"Yes, you talk, but try it yourself!"

And the count turned to the cook, who, with a shrewd and
respectful expression, looked observantly and sympathetically at the
father and son.

"What have the young people come to nowadays, eh, Feoktist?" said
he. "Laughing at us old fellows!"

"That's so, your excellency, all they have to do is to eat a good
dinner, but providing it and serving it all up, that's not their
business!"

"That's it, that's it!" exclaimed the count, and gaily seizing his
son by both hands, he cried, "Now I've got you, so take the sleigh and
pair at once, and go to Bezukhob's, and tell him 'Count Ilya has
sent you to ask for strawberries and fresh pineapples.' We can't get
them from anyone else. He's not there himself, so you'll have to go in
and ask the princesses; and from there go on to the Rasgulyay--the
coachman Ipatka knows--and look up the gypsy Ilyushka, the one who
danced at Count Orlov's, you remember, in a white Cossack coat, and
bring him along to me."

"And am I to bring the gypsy girls along with him?" asked
Nicholas, laughing. "Dear, dear!..."

At that moment, with noiseless footsteps and with the
businesslike, preoccupied, yet meekly Christian look which never
left her face, Anna Mikhaylovna entered the hall. Though she came upon
the count in his dressing gown every day, he invariably became
confused and begged her to excuse his costume.

"No matter at all, my dear count," she said, meekly closing her
eyes. "But I'll go to Bezukhov's myself. Pierre has arrived, and now
we shall get anything we want from his hothouses. I have to see him in
any case. He has forwarded me a letter from Boris. Thank God, Boris is
now on the staff."

The count was delighted at Anna Mikhaylovna's taking upon herself
one of his commissions and ordered the small closed carriage for her.

"Tell Bezukhov to come. I'll put his name down. Is his wife with
him?" he asked.

Anna Mikhaylovna turned up her eyes, and profound sadness was
depicted on her face.

"Ah, my dear friend, he is very unfortunate," she said. "If what
we hear is true, it is dreadful. How little we dreamed of such a thing
when we were rejoicing at his happiness! And such a lofty angelic soul
as young Bezukhov! Yes, I pity him from my heart, and shall try to
give him what consolation I can."

"Wh-what is the matter?" asked both the young and old Rostov.

Anna Mikhaylovna sighed deeply.

"Dolokhov, Mary Ivanovna's son," she said in a mysterious whisper,
"has compromised her completely, they say. Pierre took him up, invited
him to his house in Petersburg, and now... she has come here and
that daredevil after her!" said Anna Mikhaylovna, wishing to show
her sympathy for Pierre, but by involuntary intonations and a half
smile betraying her sympathy for the "daredevil," as she called
Dolokhov. "They say Pierre is quite broken by his misfortune."

"Dear, dear! But still tell him to come to the Club--it will all
blow over. It will be a tremendous banquet."

Next day, the third of March, soon after one o'clock, two hundred
and fifty members of the English Club and fifty guests were awaiting
the guest of honor and hero of the Austrian campaign, Prince
Bagration, to dinner.

On the first arrival of the news of the battle of Austerlitz, Moscow
had been bewildered. At that time, the Russians were so used to
victories that on receiving news of the defeat some would simply not
believe it, while others sought some extraordinary explanation of so
strange an event. In the English Club, where all who were
distinguished, important, and well informed forgathered when the
news began to arrive in December, nothing was said about the war and
the last battle, as though all were in a conspiracy of silence. The
men who set the tone in conversation--Count Rostopchin, Prince Yuri
Dolgorukov, Valuev, Count Markov, and Prince Vyazemski--did not show
themselves at the Club, but met in private houses in intimate circles,
and the Moscovites who took their opinions from others--Ilya Rostov
among them--remained for a while without any definite opinion on the
subject of the war and without leaders. The Moscovites felt that
something was wrong and that to discuss the bad news was difficult,
and so it was best to be silent. But after a while, just as a jury
comes out of its room, the bigwigs who guided the Club's opinion
reappeared, and everybody began speaking clearly and definitely.
Reasons were found for the incredible, unheard-of, and impossible
event of a Russian defeat, everything became clear, and in all corners
of Moscow the same things began to be said. These reasons were the
treachery of the Austrians, a defective commissariat, the treachery of
the Pole Przebyszewski and of the Frenchman Langeron, Kutuzov's
incapacity, and (it was whispered) the youth and inexperience of the
sovereign, who had trusted worthless and insignificant people. But the
army, the Russian army, everyone declared, was extraordinary and had
achieved miracles of valor. The soldiers, officers, and generals were
heroes. But the hero of heroes was Prince Bagration, distinguished
by his Schon Grabern affair and by the retreat from Austerlitz,
where he alone had withdrawn his column unbroken and had all day
beaten back an enemy force twice as numerous as his own. What also
conduced to Bagration's being selected as Moscow's hero was the fact
that he had no connections in the city and was a stranger there. In
his person, honor was shown to a simple fighting Russian soldier
without connections and intrigues, and to one who was associated by
memories of the Italian campaign with the name of Suvorov. Moreover,
paying such honor to Bagration was the best way of expressing
disapproval and dislike of Kutuzov.

"Had there been no Bagration, it would have been necessary to invent
him," said the wit Shinshin, parodying the words of Voltaire.
Kutuzov no one spoke of, except some who abused him in whispers,
calling him a court weathercock and an old satyr.

All Moscow repeated Prince Dolgorukov's saying: "If you go on
modeling and modeling you must get smeared with clay," suggesting
consolation for our defeat by the memory of former victories; and
the words of Rostopchin, that French soldiers have to be incited to
battle by highfalutin words, and Germans by logical arguments to
show them that it is more dangerous to run away than to advance, but
that Russian soldiers only need to be restrained and held back! On all
sides, new and fresh anecdotes were heard of individual examples of
heroism shown by our officers and men at Austerlitz. One had saved a
standard, another had killed five Frenchmen, a third had loaded five
cannon singlehanded. Berg was mentioned, by those who did not know
him, as having, when wounded in the right hand, taken his sword in the
left, and gone forward. Of Bolkonski, nothing was said, and only those
who knew him intimately regretted that he had died so young, leaving a
pregnant wife with his eccentric father.





CHAPTER III


On that third of March, all the rooms in the English Club were
filled with a hum of conversation, like the hum of bees swarming in
springtime. The members and guests of the Club wandered hither and
thither, sat, stood, met, and separated, some in uniform and some in
evening dress, and a few here and there with powdered hair and in
Russian kaftans. Powdered footmen, in livery with buckled shoes and
smart stockings, stood at every door anxiously noting visitors'
every movement in order to offer their services. Most of those present
were elderly, respected men with broad, self-confident faces, fat
fingers, and resolute gestures and voices. This class of guests and
members sat in certain habitual places and met in certain habitual
groups. A minority of those present were casual guests--chiefly
young men, among whom were Denisov, Rostov, and Dolokhov--who was
now again an officer in the Semenov regiment. The faces of these young
people, especially those who were militarymen, bore that expression of
condescending respect for their elders which seems to say to the older
generation, "We are prepared to respect and honor you, but all the
same remember that the future belongs to us."

Nesvitski was there as an old member of the Club. Pierre, who at his
wife's command had let his hair grow and abandoned his spectacles,
went about the rooms fashionably dressed but looking sad and dull.
Here, as elsewhere, he was surrounded by an atmosphere of subservience
to his wealth, and being in the habit of lording it over these people,
he treated them with absent-minded contempt.

By his age he should have belonged to the younger men, but by his
wealth and connections he belonged to the groups old and honored
guests, and so he went from one group to another. Some of the most
important old men were the center of groups which even strangers
approached respectfully to hear the voices of well-known men. The
largest circles formed round Count Rostopchin, Valuev, and
Naryshkin. Rostopchin was describing how the Russians had been
overwhelmed by flying Austrians and had had to force their way through
them with bayonets.

Valuev was confidentially telling that Uvarov had been sent from
Petersburg to ascertain what Moscow was thinking about Austerlitz.

In the third circle, Naryshkin was speaking of the meeting of the
Austrian Council of War at which Suvorov crowed like a cock in reply
to the nonsense talked by the Austrian generals. Shinshin, standing
close by, tried to make a joke, saying that Kutuzov had evidently
failed to learn from Suvorov even so simple a thing as the art of
crowing like a cock, but the elder members glanced severely at the
wit, making him feel that in that place and on that day, it was
improper to speak so of Kutuzov.

Count Ilya Rostov, hurried and preoccupied, went about in his soft
boots between the dining and drawing rooms, hastily greeting the
important and unimportant, all of whom he knew, as if they were all
equals, while his eyes occasionally sought out his fine well-set-up
young son, resting on him and winking joyfully at him. Young Rostov
stood at a window with Dolokhov, whose acquaintance he had lately made
and highly valued. The old count came up to them and pressed
Dolokhov's hand.

"Please come and visit us... you know my brave boy... been
together out there... both playing the hero... Ah, Vasili
Ignatovich... How d'ye do, old fellow?" he said, turning to an old man
who was passing, but before he had finished his greeting there was a
general stir, and a footman who had run in announced, with a
frightened face: "He's arrived!"

Bells rang, the stewards rushed forward, and--like rye shaken
together in a shovel--the guests who had been scattered about in
different rooms came together and crowded in the large drawing room by
the door of the ballroom.

Bagration appeared in the doorway of the anteroom without hat or
sword, which, in accord with the Club custom, he had given up to the
hall porter. He had no lambskin cap on his head, nor had he a loaded
whip over his shoulder, as when Rostov had seen him on the eve of
the battle of Austerlitz, but wore a tight new uniform with Russian
and foreign Orders, and the Star of St. George on his left breast.
Evidently just before coming to the dinner he had had his hair and
whiskers trimmed, which changed his appearance for the worse. There
was something naively festive in his air, which, in conjunction with
his firm and virile features, gave him a rather comical expression.
Bekleshev and Theodore Uvarov, who had arrived with him, paused at the
doorway to allow him, as the guest of honor, to enter first. Bagration
was embarrassed, not wishing to avail himself of their courtesy, and
this caused some delay at the doors, but after all he did at last
enter first. He walked shyly and awkwardly over the parquet floor of
the reception room, not knowing what to do with his hands; he was more
accustomed to walk over a plowed field under fire, as he had done at
the head of the Kursk regiment at Schon Grabern--and he would have
found that easier. The committeemen met him at the first door and,
expressing their delight at seeing such a highly honored guest, took
possession of him as it were, without waiting for his reply,
surrounded him, and led him to the drawing room. It was at first
impossible to enter the drawing-room door for the crowd of members and
guests jostling one another and trying to get a good look at Bagration
over each other's shoulders, as if he were some rare animal. Count
Ilya Rostov, laughing and repeating the words, "Make way, dear boy!
Make way, make way!" pushed through the crowd more energetically
than anyone, led the guests into the drawing room, and seated them
on the center sofa. The bigwigs, the most respected members of the
Club, beset the new arrivals. Count Ilya, again thrusting his way
through the crowd, went out of the drawing room and reappeared a
minute later with another committeeman, carrying a large silver salver
which he presented to Prince Bagration. On the salver lay some
verses composed and printed in the hero's honor. Bagration, on
seeing the salver, glanced around in dismay, as though seeking help.
But all eyes demanded that he should submit. Feeling himself in
their power, he resolutely took the salver with both hands and
looked sternly and reproachfully at the count who had presented it
to him. Someone obligingly took the dish from Bagration (or he
would, it seemed, have held it till evening and have gone in to dinner
with it) and drew his attention to the verses.

"Well, I will read them, then!" Bagration seemed to say, and, fixing
his weary eyes on the paper, began to read them with a fixed and
serious expression. But the author himself took the verses and began
reading them aloud. Bagration bowed his bead and listened:

   Bring glory then to Alexander's reign
   And on the throne our Titus shield.
   A dreaded foe be thou, kindhearted as a man,
   A Rhipheus at home, a Caesar in the field!
   E'en fortunate Napoleon
   Knows by experience, now, Bagration,
   And dare not Herculean Russians trouble...

But before he had finished reading, a stentorian major-domo
announced that dinner was ready! The door opened, and from the
dining room came the resounding strains of the polonaise:

   Conquest's joyful thunder waken,
   Triumph, valiant Russians, now!...

and Count Rostov, glancing angrily at the author who went on reading
his verses, bowed to Bagration. Everyone rose, feeling that dinner was
more important than verses, and Bagration, again preceding all the
rest, went in to dinner. He was seated in the place of honor between
two Alexanders--Bekleshev and Naryshkin--which was a significant
allusion to the name of the sovereign. Three hundred persons took
their seats in the dining room, according to their rank and
importance: the more important nearer to the honored guest, as
naturally as water flows deepest where the land lies lowest.

Just before dinner, Count Ilya Rostov presented his son to
Bagration, who recognized him and said a few words to him,
disjointed and awkward, as were all the words he spoke that day, and
Count Ilya looked joyfully and proudly around while Bagration spoke to
his son.

Nicholas Rostov, with Denisov and his new acquaintance, Dolokhov,
sat almost at the middle of the table. Facing them sat Pierre,
beside Prince Nesvitski. Count Ilya Rostov with the other members of
the committee sat facing Bagration and, as the very personification of
Moscow hospitality, did the honors to the prince.

His efforts had not been in vain. The dinner, both the Lenten and
the other fare, was splendid, yet he could not feel quite at ease till
the end of the meal. He winked at the butler, whispered directions
to the footmen, and awaited each expected dish with some anxiety.
Everything was excellent. With the second course, a gigantic sterlet
(at sight of which Ilya Rostov blushed with self-conscious
pleasure), the footmen began popping corks and filling the champagne
glasses. After the fish, which made a certain sensation, the count
exchanged glances with the other committeemen. "There will be many
toasts, it's time to begin," he whispered, and taking up his glass, he
rose. All were silent, waiting for what he would say.

"To the health of our Sovereign, the Emperor!" he cried, and at
the same moment his kindly eyes grew moist with tears of joy and
enthusiasm. The band immediately struck up "Conquest's joyful
thunder waken..." All rose and cried "Hurrah!" Bagration also rose and
shouted "Hurrah!" in exactly the same voice in which he had shouted it
on the field at Schon Grabern. Young Rostov's ecstatic voice could
be heard above the three hundred others. He nearly wept. "To the
health of our Sovereign, the Emperor!" he roared, "Hurrah!" and
emptying his glass at one gulp he dashed it to the floor. Many
followed his example, and the loud shouting continued for a long time.
When the voices subsided, the footmen cleared away the broken glass
and everybody sat down again, smiling at the noise they had made and
exchanging remarks. The old count rose once more, glanced at a note
lying beside his plate, and proposed a toast, "To the health of the
hero of our last campaign, Prince Peter Ivanovich Bagration!" and
again his blue eyes grew moist. "Hurrah!" cried the three hundred
voices again, but instead of the band a choir began singing a
cantata composed by Paul Ivanovich Kutuzov:

   Russians! O'er all barriers on!
   Courage conquest guarantees;
   Have we not Bagration?
   He brings foe men to their knees,... etc.


As soon as the singing was over, another and another toast was
proposed and Count Ilya Rostov became more and more moved, more
glass was smashed, and the shouting grew louder. They drank to
Bekleshev, Naryshkin, Uvarov, Dolgorukov, Apraksin, Valuev, to the
committee, to all the Club members and to all the Club guests, and
finally to Count Ilya Rostov separately, as the organizer of the
banquet. At that toast, the count took out his handkerchief and,
covering his face, wept outright.





CHAPTER IV


Pierre sat opposite Dolokhov and Nicholas Rostov. As usual, he ate
and drank much, and eagerly. But those who knew him intimately noticed
that some great change had come over him that day. He was silent all
through dinner and looked about, blinking and scowling, or, with fixed
eyes and a look of complete absent-mindedness, kept rubbing the bridge
of his nose. His face was depressed and gloomy. He seemed to see and
hear nothing of what was going on around him and to be absorbed by
some depressing and unsolved problem.

The unsolved problem that tormented him was caused by hints given by
the princess, his cousin, at Moscow, concerning Dolokhov's intimacy
with his wife, and by an anonymous letter he had received that
morning, which in the mean jocular way common to anonymous letters
said that he saw badly through his spectacles, but that his wife's
connection with Dolokhov was a secret to no one but himself. Pierre
absolutely disbelieved both the princess' hints and the letter, but he
feared now to look at Dolokhov, who was sitting opposite him. Every
time he chanced to meet Dolokhov's handsome insolent eyes, Pierre felt
something terrible and monstrous rising in his soul and turned quickly
away. Involuntarily recalling his wife's past and her relations with
Dolokhov, Pierre saw clearly that what was said in the letter might be
true, or might at least seem to be true had it not referred to his
wife. He involuntarily remembered how Dolokhov, who had fully
recovered his former position after the campaign, had returned to
Petersburg and come to him. Availing himself of his friendly relations
with Pierre as a boon companion, Dolokhov had come straight to his
house, and Pierre had put him up and lent him money. Pierre recalled
how Helene had smilingly expressed disapproval of Dolokhov's living at
their house, and how cynically Dolokhov had praised his wife's
beauty to him and from that time till they came to Moscow had not left
them for a day.

"Yes, he is very handsome," thought Pierre, "and I know him. It
would be particularly pleasant to him to dishonor my name and ridicule
me, just because I have exerted myself on his behalf, befriended
him, and helped him. I know and understand what a spice that would add
to the pleasure of deceiving me, if it really were true. Yes, if it
were true, but I do not believe it. I have no right to, and can't,
believe it." He remembered the expression Dolokhov's face assumed in
his moments of cruelty, as when tying the policeman to the bear and
dropping them into the water, or when he challenged a man to a duel
without any reason, or shot a post-boy's horse with a pistol. That
expression was often on Dolokhov's face when looking at him. "Yes,
he is a bully," thought Pierre, "to kill a man means nothing to him.
It must seem to him that everyone is afraid of him, and that must
please him. He must think that I, too, am afraid of him--and in fact I
am afraid of him," he thought, and again he felt something terrible
and monstrous rising in his soul. Dolokhov, Denisov, and Rostov were
now sitting opposite Pierre and seemed very gay. Rostov was talking
merrily to his two friends, one of whom was a dashing hussar and the
other a notorious duelist and rake, and every now and then he
glanced ironically at Pierre, whose preoccupied, absent-minded, and
massive figure was a very noticeable one at the dinner. Rostov
looked inimically at Pierre, first because Pierre appeared to his
hussar eyes as a rich civilian, the husband of a beauty, and in a
word--an old woman; and secondly because Pierre in his preoccupation
and absent-mindedness had not recognized Rostov and had not
responded to his greeting. When the Emperor's health was drunk,
Pierre, lost in thought, did not rise or lift his glass.

"What are you about?" shouted Rostov, looking at him in an ecstasy
of exasperation. "Don't you hear it's His Majesty the Emperor's
health?"

Pierre sighed, rose submissively, emptied his glass, and, waiting
till all were seated again, turned with his kindly smile to Rostov.

"Why, I didn't recognize you!" he said. But Rostov was otherwise
engaged; he was shouting "Hurrah!"

"Why don't you renew the acquaintance?" said Dolokhov to Rostov.

"Confound him, he's a fool!" said Rostov.

"One should make up to the husbands of pretty women," said Denisov.

Pierre did not catch what they were saying, but knew they were
talking about him. He reddened and turned away.

"Well, now to the health of handsome women!" said Dolokhov, and with
a serious expression, but with a smile lurking at the corners of his
mouth, he turned with his glass to Pierre.

"Here's to the health of lovely women, Peterkin--and their
lovers!" he added.

Pierre, with downcast eyes, drank out of his glass without looking
at Dolokhov or answering him. The footman, who was distributing
leaflets with Kutuzov's cantata, laid one before Pierre as one of
the principal guests. He was just going to take it when Dolokhov,
leaning across, snatched it from his hand and began reading it. Pierre
looked at Dolokhov and his eyes dropped, the something terrible and
monstrous that had tormented him all dinnertime rose and took
possession of him. He leaned his whole massive body across the table.

"How dare you take it?" he shouted.

Hearing that cry and seeing to whom it was addressed, Nesvitski
and the neighbor on his right quickly turned in alarm to Bezukhov.

"Don't! Don't! What are you about?" whispered their frightened
voices.

Dolokhov looked at Pierre with clear, mirthful, cruel eyes, and that
smile of his which seemed to say, "Ah! This is what I like!"

"You shan't have it!" he said distinctly.

Pale, with quivering lips, Pierre snatched the copy.

"You...! you... scoundrel! I challenge you!" he ejaculated, and,
pushing back his chair, he rose from the table.

At the very instant he did this and uttered those words, Pierre felt
that the question of his wife's guilt which had been tormenting him
the whole day was finally and indubitably answered in the affirmative.
He hated her and was forever sundered from her. Despite Denisov's
request that he would take no part in the matter, Rostov agreed to
be Dolokhov's second, and after dinner he discussed the arrangements
for the duel with Nesvitski, Bezukhov's second. Pierre went home,
but Rostov with Dolokhov and Denisov stayed on at the Club till
late, listening to the gypsies and other singers.

"Well then, till tomorrow at Sokolniki," said Dolokhov, as he took
leave of Rostov in the Club porch.

"And do you feel quite calm?" Rostov asked.

Dolokhov paused.

"Well, you see, I'll tell you the whole secret of dueling in two
words. If you are going to fight a duel, and you make a will and write
affectionate letters to your parents, and if you think you may be
killed, you are a fool and are lost for certain. But go with the
firm intention of killing your man as quickly and surely as
possible, and then all will be right, as our bear huntsman at Kostroma
used to tell me. 'Everyone fears a bear,' he says, 'but when you see
one your fear's all gone, and your only thought is not to let him
get away!' And that's how it is with me. A demain, mon cher."*


*Till tomorrow, my dear fellow.


Next day, at eight in the morning, Pierre and Nesvitski drove to the
Sokolniki forest and found Dolokhov, Denisov, and Rostov already
there. Pierre had the air of a man preoccupied with considerations
which had no connection with the matter in hand. His haggard face
was yellow. He had evidently not slept that night. He looked about
distractedly and screwed up his eyes as if dazzled by the sun. He
was entirely absorbed by two considerations: his wife's guilt, of
which after his sleepless night he had not the slightest doubt, and
the guiltlessness of Dolokhov, who had no reason to preserve the honor
of a man who was nothing to him.... "I should perhaps have done the
same thing in his place," thought Pierre. "It's even certain that I
should have done the same, then why this duel, this murder? Either I
shall kill him, or he will hit me in the head, or elbow, or knee.
Can't I go away from here, run away, bury myself somewhere?" passed
through his mind. But just at moments when such thoughts occurred to
him, he would ask in a particularly calm and absent-minded way,
which inspired the respect of the onlookers, "Will it be long? Are
things ready?"

When all was ready, the sabers stuck in the snow to mark the
barriers, and the pistols loaded, Nesvitski went up to Pierre.

"I should not be doing my duty, Count," he said in timid tones, "and
should not justify your confidence and the honor you have done me in
choosing me for your second, if at this grave, this very grave, moment
I did not tell you the whole truth. I think there is no sufficient
ground for this affair, or for blood to be shed over it.... You were
not right, not quite in the right, you were impetuous..."

"Oh yes, it is horribly stupid," said Pierre.

"Then allow me to express your regrets, and I am sure your
opponent will accept them," said Nesvitski (who like the others
concerned in the affair, and like everyone in similar cases, did not
yet believe that the affair had come to an actual duel). "You know,
Count, it is much more honorable to admit one's mistake than to let
matters become irreparable. There was no insult on either side.
Allow me to convey...."

"No! What is there to talk about?" said Pierre. "It's all the
same.... Is everything ready?" he added. "Only tell me where to go and
where to shoot," he said with an unnaturally gentle smile.

He took the pistol in his hand and began asking about the working of
the trigger, as he had not before held a pistol in his hand--a fact
that he did not to confess.

"Oh yes, like that, I know, I only forgot," said he.

"No apologies, none whatever," said Dolokhov to Denisov (who on
his side had been attempting a reconciliation), and he also went up to
the appointed place.

The spot chosen for the duel was some eighty paces from the road,
where the sleighs had been left, in a small clearing in the pine
forest covered with melting snow, the frost having begun to break up
during the last few days. The antagonists stood forty paces apart at
the farther edge of the clearing. The seconds, measuring the paces,
left tracks in the deep wet snow between the place where they had been
standing and Nesvitski's and Dolokhov's sabers, which were stuck
intothe ground ten paces apart to mark the barrier. It was thawing and
misty; at forty paces' distance nothing could be seen. For three
minutes all had been ready, but they still delayed and all were
silent.





CHAPTER V


"Well begin!" said Dolokhov.

"All right," said Pierre, still smiling in the same way. A feeling
of dread was in the air. It was evident that the affair so lightly
begun could no longer be averted but was taking its course
independently of men's will.

Denisov first went to the barrier and announced: "As the adve'sawies
have wefused a weconciliation, please pwoceed. Take your pistols,
and at the word thwee begin to advance.

"O-ne! T-wo! Thwee!" he shouted angrily and stepped aside.

The combatants advanced along the trodden tracks, nearer and
nearer to one another, beginning to see one another through the
mist. They had the right to fire when they liked as they approached
the barrier. Dolokhov walked slowly without raising his pistol,
looking intently with his bright, sparkling blue eyes into his
antagonist's face. His mouth wore its usual semblance of a smile.

"So I can fire when I like!" said Pierre, and at the word "three,"
he went quickly forward, missing the trodden path and stepping into
the deep snow. He held the pistol in his right hand at arm's length,
apparently afraid of shooting himself with it. His left hand he held
carefully back, because he wished to support his right hand with it
and knew he must not do so. Having advanced six paces and strayed
off the track into the snow, Pierre looked down at his feet, then
quickly glanced at Dolokhov and, bending his finger as he had been
shown, fired. Not at all expecting so loud a report, Pierre
shuddered at the sound and then, smiling at his own sensations,
stood still. The smoke, rendered denser by the mist, prevented him
from seeing anything for an instant, but there was no second report as
he had expected. He only heard Dolokhov's hurried steps, and his
figure came in view through the smoke. He was pressing one hand to his
left side, while the other clutched his drooping pistol. His face
was pale. Rostov ran toward him and said something.

"No-o-o!" muttered Dolokhov through his teeth, "no, it's not
over." And after stumbling a few staggering steps right up to the
saber, he sank on the snow beside it. His left hand was bloody; he
wiped it on his coat and supported himself with it. His frowning
face was pallid and quivered.

"Plea..." began Dolokhov, but could not at first pronounce the word.

"Please," he uttered with an effort.

Pierre, hardly restraining his sobs, began running toward Dolokhov
and was about to cross the space between the barriers, when Dolokhov
cried:

"To your barrier!" and Pierre, grasping what was meant, stopped by
his saber. Only ten paces divided them. Dolokhov lowered his head to
the snow, greedily bit at it, again raised his head, adjusted himself,
drew in his legs and sat up, seeking a firm center of gravity. He
sucked and swallowed the cold snow, his lips quivered but
his eyes, still smiling, glittered with effort and exasperation as
he mustered his remaining strength. He raised his pistol and aimed.

"Sideways! Cover yourself with your pistol!" ejaculated Nesvitski.

"Cover yourself!" even Denisov cried to his adversary.

Pierre, with a gentle smile of pity and remorse, his arms and legs
helplessly spread out, stood with his broad chest directly facing
Dolokhov looked sorrowfully at him. Denisov, Rostov, and Nesvitski
closed their eyes. At the same instant they heard a report and
Dolokhov's angry cry.

"Missed!" shouted Dolokhov, and he lay helplessly, face downwards on
the snow.

Pierre clutched his temples, and turning round went into the forest,
trampling through the deep snow, and muttering incoherent words:

"Folly... folly! Death... lies..." he repeated, puckering his face.

Nesvitski stopped him and took him home.

Rostov and Denisov drove away with the wounded Dolokhov.

The latter lay silent in the sleigh with closed eyes and did not
answer a word to the questions addressed to him. But on entering
Moscow he suddenly came to and, lifting his head with an effort,
took Rostov, who was sitting beside him, by the hand. Rostov was
struck by the totally altered and unexpectedly rapturous and tender
expression on Dolokhov's face.

"Well? How do you feel?" he asked.

"Bad! But it's not that, my friend-" said Dolokhov with a gasping
voice. "Where are we? In Moscow, I know. I don't matter, but I have
killed her, killed... She won't get over it! She won't survive...."

"Who?" asked Rostov.

"My mother! My mother, my angel, my adored angel mother," and
Dolokhov pressed Rostov's hand and burst into tears.

When he had become a little quieter, he explained to Rostov that
he was living with his mother, who, if she saw him dying, would not
survive it. He implored Rostov to go on and prepare her.

Rostov went on ahead to do what was asked, and to his great surprise
learned that Dolokhov the brawler, Dolokhov the bully, lived in Moscow
with an old mother and a hunchback sister, and was the most
affectionate of sons and brothers.





CHAPTER VI


Pierre had of late rarely seen his wife alone. Both in Petersburg
and in Moscow their house was always full of visitors. The night after
the duel he did not go to his bedroom but, as he often did, remained
in his father's room, that huge room in which Count Bezukhov had died.

He lay down on the sofa meaning to fall asleep and forget all that
had happened to him, but could not do so. Such a storm of feelings,
thoughts, and memories suddenly arose within him that he could not
fall asleep, nor even remain in one place, but had to jump up and pace
the room with rapid steps. Now he seemed to see her in the early
days of their marriage, with bare shoulders and a languid,
passionate look on her face, and then immediately he saw beside her
Dolokhov's handsome, insolent, hard, and mocking face as he had seen
it at the banquet, and then that same face pale, quivering, and
suffering, as it had been when he reeled and sank on the snow.

"What has happened?" he asked himself. "I have killed her lover,
yes, killed my wife's lover. Yes, that was it! And why? How did I come
to do it?"--"Because you married her," answered an inner voice.

"But in what was I to blame?" he asked. "In marrying her without
loving her; in deceiving yourself and her." And he vividly recalled
that moment after supper at Prince Vasili's, when he spoke those words
he had found so difficult to utter: "I love you." "It all comes from
that! Even then I felt it," he thought. "I felt then that it was not
so, that I had no right to do it. And so it turns out."

He remembered his honeymoon and blushed at the recollection.
Particularly vivid, humiliating, and shameful was the recollection
of how one day soon after his marriage he came out of the bedroom into
his study a little before noon in his silk dressing gown and found his
head steward there, who, bowing respectfully, looked into his face and
at his dressing gown and smiled slightly, as if expressing
respectful understanding of his employer's happiness.

"But how often I have felt proud of her, proud of her majestic
beauty and social tact," thought he; "been proud of my house, in
which she received all Petersburg, proud of her unapproachability and
beauty. So this is what I was proud of! I then thought that I did
not understand her. How often when considering her character I have
told myself that I was to blame for not understanding her, for not
understanding that constant composure and complacency and lack of
all interests or desires, and the whole secret lies in the terrible
truth that she is a depraved woman. Now I have spoken that terrible
word to myself all has become clear.

"Anatole used to come to borrow money from her and used to kiss
her naked shoulders. She did not give him the money, but let herself
be kissed. Her father in jest tried to rouse her jealousy, and she
replied with a calm smile that she was not so stupid as to be jealous:
'Let him do what he pleases,' she used to say of me. One day I asked
her if she felt any symptoms of pregnancy. She laughed
contemptuously and said she was not a fool to want to have children,
and that she was not going to have any children by me."

Then he recalled the coarseness and bluntness of her thoughts and
the vulgarity of the expressions that were natural to her, though
she had been brought up in the most aristocratic circles.

"I'm not such a fool.... Just you try it on.... Allez-vous
promener,"* she used to say. Often seeing the success she had with
young and old men and women Pierre could not understand why he did not
love her.


*"You clear out of this."


"Yes, I never loved her," said he to himself; "I knew she was a
depraved woman," he repeated, "but dared not admit it to myself. And
now there's Dolokhov sitting in the snow with a forced smile and
perhaps dying, while meeting my remorse with some forced bravado!"

Pierre was one of those people who, in spite of an appearance of
what is called weak character, do not seek a confidant in their
troubles. He digested his sufferings alone.

"It is all, all her fault," he said to himself; "but what of that?
Why did I bind myself to her? Why did I say 'Je vous aime'* to her,
which was a lie, and worse than a lie? I am guilty and must
endure... what? A slur on my name? A misfortune for life? Oh, that's
nonsense," he thought. "The slur on my name and honor--that's all
apart from myself.


*I love you.


"Louis XVI was executed because they said he was dishonorable and
a criminal," came into Pierre's head, "and from their point of view
they were right, as were those too who canonized him and died a
martyr's death for his sake. Then Robespierre was beheaded for being a
despot. Who is right and who is wrong? No one! But if you are alive-
live: tomorrow you'll die as I might have died an hour ago. And is
it worth tormenting oneself, when one has only a moment of life in
comparison with eternity?"

But at the moment when he imagined himself calmed by such
reflections, she suddenly came into his mind as she was at the moments
when he had most strongly expressed his insincere love for her, and he
felt the blood rush to his heart and had again to get up and move
about and break and tear whatever came to his hand. "Why did I tell
her that 'Je vous aime'?" he kept repeating to himself. And when he
had said it for the tenth time, Molibre's words: "Mais que diable
alloit-il faire dans cette galere?" occurred to him, and he began to
laugh at himself.

In the night he called his valet and told him to pack up to go to
Petersburg. He could not imagine how he could speak to her now. He
resolved to go away next day and leave a letter informing her of his
intention to part from her forever.

Next morning when the valet came into the room with his coffee,
Pierre was lying asleep on the ottoman with an open book in his hand.

He woke up and looked round for a while with a startled
expression, unable to realize where he was.

"The countess told me to inquire whether your excellency was at
home," said the valet.

But before Pierre could decide what answer he would send, the
countess herself in a white satin dressing gown embroidered with
silver and with simply dressed hair (two immense plaits twice round
her lovely head like a coronet) entered the room, calm and majestic,
except that there was a wrathful wrinkle on her rather prominent
marble brow. With her imperturbable calm she did not begin to speak in
front of the valet. She knew of the duel and had come to speak about
it. She waited till the valet had set down the coffee things and
left the room. Pierre looked at her timidly over his spectacles, and
like a hare surrounded by hounds who lays back her ears and
continues to crouch motionless before her enemies, he tried to
continue reading. But feeling this to be senseless and impossible,
he again glanced timidly at her. She did not sit down but looked at
him with a contemptuous smile, waiting for the valet to go.

"Well, what's this now? What have you been up to now, I should
like to know?" she asked sternly.

"I? What have I...?" stammered Pierre.

"So it seems you're a hero, eh? Come now, what was this duel
about? What is it meant to prove? What? I ask you."

Pierre turned over heavily on the ottoman and opened his mouth,
but could not reply.

"If you won't answer, I'll tell you..." Helene went on. "You believe
everything you're told. You were told..." Helene laughed, "that
Dolokhov was my lover," she said in French with her coarse plainness
of speech, uttering the word amant as casually as any other word, "and
you believed it! Well, what have you proved? What does this duel
prove? That you're a fool, que vous etes un sot, but everybody knew
that. What will be the result? That I shall be the laughingstock of
all Moscow, that everyone will say that you, drunk and not knowing
what you were about, challenged a man you are jealous of without
cause." Helene raised her voice and became more and more excited, "A
man who's a better man than you in every way..."

"Hm... Hm...!" growled Pierre, frowning without looking at her,
and not moving a muscle.

"And how could you believe he was my lover? Why? Because I like
his company? If you were cleverer and more agreeable, I should
prefer yours."

"Don't speak to me... I beg you," muttered Pierre hoarsely.

"Why shouldn't I speak? I can speak as I like, and I tell you
plainly that there are not many wives with husbands such as you who
would not have taken lovers (des amants), but I have not done so,"
said she.

Pierre wished to say something, looked at her with eyes whose
strange expression she did not understand, and lay down again. He
was suffering physically at that moment, there was a weight on his
chest and he could not breathe. He knew that he must do something to
put an end to this suffering, but what he wanted to do was too
terrible.

"We had better separate," he muttered in a broken voice.

"Separate? Very well, but only if you give me a fortune," said
Helene. "Separate! That's a thing to frighten me with!"

Pierre leaped up from the sofa and rushed staggering toward her.

"I'll kill you!" he shouted, and seizing the marble top of a table
with a strength he had never before felt, he made a step toward her
brandishing the slab.

Helene's face became terrible, she shrieked and sprang aside. His
father's nature showed itself in Pierre. He felt the fascination and
delight of frenzy. He flung down the slab, broke it, and swooping down
on her with outstretched hands shouted, "Get out!" in such a
terrible voice that the whole house heard it with horror. God knows
what he would have done at that moment had Helene not fled from the
room.


A week later Pierre gave his wife full power to control all his
estates in Great Russia, which formed the larger part of his property,
and left for Petersburg alone.





CHAPTER VII


Two months had elapsed since the news of the battle of Austerlitz
and the loss of Prince Andrew had reached Bald Hills, and in spite
of the letters sent through the embassy and all the searches made, his
body had not been found nor was he on the list of prisoners. What
was worst of all for his relations was the fact that there was still a
possibility of his having been picked up on the battlefield by the
people of the place and that he might now be lying, recovering or
dying, alone among strangers and unable to send news of himself. The
gazettes from which the old prince first heard of the defeat at
Austerlitz stated, as usual very briefly and vaguely, that after
brilliant engagements the Russians had had to retreat and had made
their withdrawal in perfect order. The old prince understood from this
official report that our army had been defeated. A week after the
gazette report of the battle of Austerlitz came a letter from
Kutuzov informing the prince of the fate that had befallen his son.

"Your son," wrote Kutuzov, "fell before my eyes, a standard in his
hand and at the head of a regiment--he fell as a hero, worthy of his
father and his fatherland. To the great regret of myself and of the
whole army it is still uncertain whether he is alive or not. I comfort
myself and you with the hope that your son is alive, for otherwise
he would have been mentioned among the officers found on the field
of battle, a list of whom has been sent me under flag of truce."

After receiving this news late in the evening, when he was alone
in his study, the old prince went for his walk as usual next
morning, but he was silent with his steward, the gardener, and the
architect, and though he looked very grim he said nothing to anyone.

When Princess Mary went to him at the usual hour he was working at
his lathe and, as usual, did not look round at her.

"Ah, Princess Mary!" he said suddenly in an unnatural voice,
throwing down his chisel. (The wheel continued to revolve by its own
impetus, and Princess Mary long remembered the dying creak of that
wheel, which merged in her memory with what followed.)

She approached him, saw his face, and something gave way within her.
Her eyes grew dim. By the expression of her father's face, not sad,
not crushed, but angry and working unnaturally, she saw that hanging
over her and about to crush her was some terrible misfortune, the
worst in life, one she had not yet experienced, irreparable and
incomprehensible--the death of one she loved.

"Father! Andrew!"--said the ungraceful, awkward princess with such
an indescribable charm of sorrow and self-forgetfulness that her
father could not bear her look but turned away with a sob.

"Bad news! He's not among the prisoners nor among the killed!
Kutuzov writes..." and he screamed as piercingly as if he wished to
drive the princess away by that scream... "Killed!"

The princess did not fall down or faint. She was already pale, but
on hearing these words her face changed and something brightened in
her beautiful, radiant eyes. It was as if joy--a supreme joy apart
from the joys and sorrows of this world--overflowed the great grief
within her. She forgot all fear of her father, went up to him, took
his hand, and drawing him down put her arm round his thin, scraggy
neck.

"Father," she said, "do not turn away from me, let us weep together."

"Scoundrels! Blackguards!" shrieked the old man, turning his face
away from her. "Destroying the army, destroying the men! And why?
Go, go and tell Lise."

The princess sank helplessly into an armchair beside her father
and wept. She saw her brother now as he had been at the moment when he
took leave of her and of Lise, his look tender yet proud. She saw
him tender and amused as he was when he put on the little icon. "Did
he believe? Had he repented of his unbelief? Was he now there? There
in the realms of eternal peace and blessedness?" she thought.

"Father, tell me how it happened," she asked through her tears.

"Go! Go! Killed in battle, where the best of Russian men and
Russia's glory were led to destruction. Go, Princess Mary. Go and tell
Lise. I will follow."

When Princess Mary returned from her father, the little princess sat
working and looked up with that curious expression of inner, happy
calm peculiar to pregnant women. It was evident that her eyes did
not see Princess Mary but were looking within... into herself... at
something joyful and mysterious taking place within her.

"Mary," she said, moving away from the embroidery frame and lying
back, "give me your hand." She took her sister-in-law's hand and
held it below her waist.

Her eyes were smiling expectantly, her downy lip rose and remained
lifted in childlike happiness.

Princess Mary knelt down before her and hid her face in the folds of
her sister-in-law's dress.

"There, there! Do you feel it? I feel so strange. And do you know,
Mary, I am going to love him very much," said Lise, looking with
bright and happy eyes at her sister-in-law.

Princess Mary could not lift her head, she was weeping.

"What is the matter, Mary?"

"Nothing... only I feel sad... sad about Andrew," she said, wiping
away her tears on her sister-in-law's knee.

Several times in the course of the morning Princess Mary began
trying to prepare her sister-in-law, and every time began to cry.
Unobservant as was the little princess, these tears, the cause of
which she did not understand, agitated her. She said nothing but
looked about uneasily as if in search of something. Before dinner
the old prince, of whom she was always afraid, came into her room with
a peculiarly restless and malign expression and went out again without
saying a word. She looked at Princess Mary, then sat thinking for a
while with that expression of attention to something within her that
is only seen in pregnant women, and suddenly began to cry.

"Has anything come from Andrew?" she asked.

"No, you know it's too soon for news. But my father is anxious and I
feel afraid."

"So there's nothing?"

"Nothing," answered Princess Mary, looking firmly with her radiant
eyes at her sister-in-law.

She had determined not to tell her and persuaded her father to
hide the terrible news from her till after her confinement, which
was expected within a few days. Princess Mary and the old prince
each bore and hid their grief in their own way. The old prince would
not cherish any hope: he made up his mind that Prince Andrew had
been killed, and though he sent an official to Austria to seek for
traces of his son, he ordered a monument from Moscow which he intended
to erect in his own garden to his memory, and he told everybody that
his son had been killed. He tried not to change his former way of
life, but his strength failed him. He walked less, ate less, slept
less, and became weaker every day. Princess Mary hoped. She prayed for
her brother as living and was always awaiting news of his return.





CHAPTER VIII


"Dearest," said the little princess after breakfast on the morning
of the nineteenth March, and her downy little lip rose from old habit,
but as sorrow was manifest in every smile, the sound of every word,
and even every footstep in that house since the terrible news had
come, so now the smile of the little princess--influenced by the
general mood though without knowing its cause--was such as to remind
one still more of the general sorrow.

"Dearest, I'm afraid this morning's fruschtique*--as Foka the cook
calls it--has disagreed with me."


*Fruhstuck: breakfast.


"What is the matter with you, my darling? You look pale. Oh, you are
very pale!" said Princess Mary in alarm, running with her soft,
ponderous steps up to her sister-in-law.

"Your excellency, should not Mary Bogdanovna be sent for?" said
one of the maids who was present. (Mary Bogdanovna was a midwife
from the neighboring town, who had been at Bald Hills for the last
fortnight.)

"Oh yes," assented Princess Mary, "perhaps that's it. I'll go.
Courage, my angel." She kissed Lise and was about to leave the room.

"Oh, no, no!" And besides the pallor and the physical suffering on
the little princess' face, an expression of childish fear of
inevitable pain showed itself.

"No, it's only indigestion?... Say it's only indigestion, say so,
Mary! Say..." And the little princess began to cry capriciously like a
suffering child and to wring her little hands even with some
affectation. Princess Mary ran out of the room to fetch Mary
Bogdanovna.

"Mon Dieu! Mon Dieu! Oh!" she heard as she left the room.

The midwife was already on her way to meet her, rubbing her small,
plump white hands with an air of calm importance.

"Mary Bogdanovna, I think it's beginning!" said Princess Mary
looking at the midwife with wide-open eyes of alarm.

"Well, the Lord be thanked, Princess," said Mary Bogdanovna, not
hastening her steps. "You young ladies should not know anything
about it."

"But how is it the doctor from Moscow is not here yet?" said the
princess. (In accordance with Lise's and Prince Andrew's wishes they
had sent in good time to Moscow for a doctor and were expecting him at
any moment.)

"No matter, Princess, don't be alarmed," said Mary Bogdanovna.
"We'll manage very well without a doctor."

Five minutes later Princess Mary from her room heard something heavy
being carried by. She looked out. The men servants were carrying the
large leather sofa from Prince Andrew's study into the bedroom. On
their faces was a quiet and solemn look.

Princess Mary sat alone in her room listening to the sounds in the
house, now and then opening her door when someone passed and
watching what was going on in the passage. Some women passing with
quiet steps in and out of the bedroom glanced at the princess and
turned away. She did not venture to ask any questions, and shut the
door again, now sitting down in her easy chair, now taking her
prayer book, now kneeling before the icon stand. To her surprise and
distress she found that her prayers did not calm her excitement.
Suddenly her door opened softly and her old nurse, Praskovya Savishna,
who hardly ever came to that room as the old prince had forbidden
it, appeared on the threshold with a shawl round her head.

"I've come to sit with you a bit, Masha," said the nurse, "and
here I've brought the prince's wedding candles to light before his
saint, my angel," she said with a sigh.

"Oh, nurse, I'm so glad!"

"God is merciful, birdie."

The nurse lit the gilt candles before the icons and sat down by
the door with her knitting. Princess Mary took a book and began
reading. Only when footsteps or voices were heard did they look at one
another, the princess anxious and inquiring, the nurse encouraging.
Everyone in the house was dominated by the same feeling that
Princess Mary experienced as she sat in her room. But owing to the
superstition that the fewer the people who know of it the less a woman
in travail suffers, everyone tried to pretend not to know; no one
spoke of it, but apart from the ordinary staid and respectful good
manners habitual in the prince's household, a common anxiety, a
softening of the heart, and a consciousness that something great and
mysterious was being accomplished at that moment made itself felt.

There was no laughter in the maids' large hall. In the men servants'
hall all sat waiting, silently and alert. In the outlying serfs'
quarters torches and candles were burning and no one slept. The old
prince, stepping on his heels, paced up and down his study and sent
Tikhon to ask Mary Bogdanovna what news.--"Say only that 'the prince
told me to ask,' and come and tell me her answer."

"Inform the prince that labor has begun," said Mary Bogdanovna,
giving the messenger a significant look.

Tikhon went and told the prince.

"Very good!" said the prince closing the door behind him, and Tikhon
did not hear the slightest sound from the study after that.

After a while he re-entered it as if to snuff the candles, and,
seeing the prince was lying on the sofa, looked at him, noticed his
perturbed face, shook his head, and going up to him silently kissed
him on the shoulder and left the room without snuffing the candles
or saying why he had entered. The most solemn mystery in the world
continued its course. Evening passed, night came, and the feeling of
suspense and softening of heart in the presence of the unfathomable
did not lessen but increased. No one slept.

It was one of those March nights when winter seems to wish to resume
its sway and scatters its last snows and storms with desperate fury. A
relay of horses had been sent up the highroad to meet the German
doctor from Moscow who was expected every moment, and men on horseback
with lanterns were sent to the crossroads to guide him over the
country road with its hollows and snow-covered pools of water.

Princess Mary had long since put aside her book: she sat silent, her
luminous eyes fixed on her nurse's wrinkled face (every line of
which she knew so well), on the lock of gray hair that escaped from
under the kerchief, and the loose skin that hung under her chin.

Nurse Savishna, knitting in hand, was telling in low tones, scarcely
hearing or understanding her own words, what she had told hundreds
of times before: how the late princess had given birth to Princess
Mary in Kishenev with only a Moldavian peasant woman to help instead
of a midwife.

"God is merciful, doctors are never needed," she said.

Suddenly a gust of wind beat violently against the casement of the
window, from which the double frame had been removed (by order of
the prince, one window frame was removed in each room as soon as the
larks returned), and, forcing open a loosely closed latch, set the
damask curtain flapping and blew out the candle with its chill,
snowy draft. Princess Mary shuddered; her nurse, putting down the
stocking she was knitting, went to the window and leaning out tried to
catch the open casement. The cold wind flapped the ends of her
kerchief and her loose locks of gray hair.

"Princess, my dear, there's someone driving up the avenue!" she
said, holding the casement and not closing it. "With lanterns. Most
likely the doctor."

"Oh, my God! thank God!" said Princess Mary. "I must go and meet
him, he does not know Russian."

Princess Mary threw a shawl over her head and ran to meet the
newcomer. As she was crossing the anteroom she saw through the
window a carriage with lanterns, standing at the entrance. She went
out on the stairs. On a banister post stood a tallow candle which
guttered in the draft. On the landing below, Philip, the footman,
stood looking scared and holding another candle. Still lower, beyond
the turn of the staircase, one could hear the footstep of someone in
thick felt boots, and a voice that seemed familiar to Princess Mary
was saying something.

"Thank God!" said the voice. "And Father?"

"Gone to bed," replied the voice of Demyan the house steward, who
was downstairs.

Then the voice said something more, Demyan replied, and the steps in
the felt boots approached the unseen bend of the staircase more
rapidly.

"It's Andrew!" thought Princess Mary. "No it can't be, that would be
too extraordinary," and at the very moment she thought this, the
face and figure of Prince Andrew, in a fur cloak the deep collar of
which covered with snow, appeared on the landing where the footman
stood with the candle. Yes, it was he, pale, thin, with a changed
and strangely softened but agitated expression on his face. He came up
the stairs and embraced his sister.

"You did not get my letter?" he asked, and not waiting for a
reply--which he would not have received, for the princess was unable
to speak--he turned back, rapidly mounted the stairs again with the
doctor who had entered the hall after him (they had met at the last
post station), and again embraced his sister.

"What a strange fate, Masha darling!" And having taken off his cloak
and felt boots, he went to the little princess' apartment.





CHAPTER IX


The little princess lay supported by pillows, with a white cap on
her head (the pains had just left her). Strands of her black hair
lay round her inflamed and perspiring cheeks, her charming rosy
mouth with its downy lip was open and she was smiling joyfully. Prince
Andrew entered and paused facing her at the foot of the sofa on
which she was lying. Her glittering eyes, filled with childlike fear
and excitement, rested on him without changing their expression. "I
love you all and have done no harm to anyone; why must I suffer so?
Help me!" her look seemed to say. She saw her husband, but did not
realize the significance of his appearance before her now. Prince
Andrew went round the sofa and kissed her forehead.

"My darling!" he said--a word he had never used to her before.
"God is merciful...."

She looked at him inquiringly and with childlike reproach.

"I expected help from you and I get none, none from you either!"
said her eyes. She was not surprised at his having come; she did not
realize that he had come. His coming had nothing to do with her
sufferings or with their relief. The pangs began again and Mary
Bogdanovna advised Prince Andrew to leave the room.

The doctor entered. Prince Andrew went out and, meeting Princess
Mary, again joined her. They began talking in whispers, but their talk
broke off at every moment. They waited and listened.

"Go, dear," said Princess Mary.

Prince Andrew went again to his wife and sat waiting in the room
next to hers. A woman came from the bedroom with a frightened face and
became confused when she saw Prince Andrew. He covered his face with
his hands and remained so for some minutes. Piteous, helpless,
animal moans came through the door. Prince Andrew got up, went to
the door, and tried to open it. Someone was holding it shut.

"You can't come in! You can't!" said a terrified voice from within.

He began pacing the room. The screaming ceased, and a few more
seconds went by. Then suddenly a terrible shriek--it could not be
hers, she could not scream like that--came from the bedroom. Prince
Andrew ran to the door; the scream ceased and he heard the wail of
an infant.

"What have they taken a baby in there for?" thought Prince Andrew in
the first second. "A baby? What baby...? Why is there a baby there? Or
is the baby born?"

Then suddenly he realized the joyful significance of that wail;
tears choked him, and leaning his elbows on the window sill be began
to cry, sobbing like a child. The door opened. The doctor with his
shirt sleeves tucked up, without a coat, pale and with a trembling
jaw, came out of the room. Prince Andrew turned to him, but the doctor
gave him a bewildered look and passed by without a word. A woman
rushed out and seeing Prince Andrew stopped, hesitating on the
threshold. He went into his wife's room. She was lying dead, in the
same position he had seen her in five minutes before and, despite
the fixed eyes and the pallor of the cheeks, the same expression was
on her charming childlike face with its upper lip covered with tiny
black hair.

"I love you all, and have done no harm to anyone; and what have
you done to me?"--said her charming, pathetic, dead face.

In a corner of the room something red and tiny gave a grunt and
squealed in Mary Bogdanovna's trembling white hands.


Two hours later Prince Andrew, stepping softly, went into his
father's room. The old man already knew everything. He was standing
close to the door and as soon as it opened his rough old arms closed
like a vise round his son's neck, and without a word he began to sob
like a child.


Three days later the little princess was buried, and Prince Andrew
went up the steps to where the coffin stood, to give her the
farewell kiss. And there in the coffin was the same face, though
with closed eyes. "Ah, what have you done to me?" it still seemed to
say, and Prince Andrew felt that something gave way in his soul and
that he was guilty of a sin he could neither remedy nor forget. He
could not weep. The old man too came up and kissed the waxen little
hands that lay quietly crossed one on the other on her breast, and
to him, too, her face seemed to say: "Ah, what have you done to me,
and why?" And at the sight the old man turned angrily away.


Another five days passed, and then the young Prince Nicholas
Andreevich was baptized. The wet nurse supported the coverlet with her
while the priest with a goose feather anointed the boy's little red
and wrinkled soles and palms.

His grandfather, who was his godfather, trembling and afraid of
dropping him, carried the infant round the battered tin font and
handed him over to the godmother, Princess Mary. Prince Andrew sat
in another room, faint with fear lest the baby should be drowned in
the font, and awaited the termination of the ceremony. He looked up
joyfully at the baby when the nurse brought it to him and nodded
approval when she told him that the wax with the baby's hair had not
sunk in the font but had floated.





CHAPTER X


Rostov's share in Dolokhov's duel with Bezukhov was hushed up by the
efforts of the old count, and instead of being degraded to the ranks
as he expected he was appointed an adjutant to the governor general of
Moscow. As a result he could not go to the country with the rest of
the family, but was kept all summer in Moscow by his new duties.
Dolokhov recovered, and Rostov became very friendly with him during
his convalescence. Dolokhov lay ill at his mother's who loved him
passionately and tenderly, and old Mary Ivanovna, who had grown fond
of Rostov for his friendship to her Fedya, often talked to him about
her son.

"Yes, Count," she would say, "he is too noble and pure-souled for
our present, depraved world. No one now loves virtue; it seems like
a reproach to everyone. Now tell me, Count, was it right, was it
honorable, of Bezukhov? And Fedya, with his noble spirit, loved him
and even now never says a word against him. Those pranks in Petersburg
when they played some tricks on a policeman, didn't they do it
together? And there! Bezukhov got off scotfree, while Fedya had to
bear the whole burden on his shoulders. Fancy what he had to go
through! It's true he has been reinstated, but how could they fail
to do that? I think there were not many such gallant sons of the
fatherland out there as he. And now--this duel! Have these people no
feeling, or honor? Knowing him to be an only son, to challenge him and
shoot so straight! It's well God had mercy on us. And what was it for?
Who doesn't have intrigues nowadays? Why, if he was so jealous, as I
see things he should have shown it sooner, but he lets it go on for
months. And then to call him out, reckoning on Fedya not fighting
because he owed him money! What baseness! What meanness! I know you
understand Fedya, my dear count; that, believe me, is why I am so fond
of you. Few people do understand him. He is such a lofty, heavenly
soul!"

Dolokhov himself during his convalescence spoke to Rostov in a way
no one would have expected of him.

"I know people consider me a bad man!" he said. "Let them! I don't
care a straw about anyone but those I love; but those I love, I love
so that I would give my life for them, and the others I'd throttle
if they stood in my way. I have an adored, a priceless mother, and two
or three friends--you among them--and as for the rest I only care
about them in so far as they are harmful or useful. And most of them
are harmful, especially the women. Yes, dear boy," he continued, "I
have met loving, noble, high-minded men, but I have not yet met any
women--countesses or cooks--who were not venal. I have not yet met
that divine purity and devotion I look for in women. If I found such a
one I'd give my life for her! But those!..." and he made a gesture of
contempt. "And believe me, if I still value my life it is only because
I still hope to meet such a divine creature, who will regenerate,
purify, and elevate me. But you don't understand it."

"Oh, yes, I quite understand," answered Rostov, who was under his
new friend's influence.

In the autumn the Rostovs returned to Moscow. Early in the winter
Denisov also came back and stayed with them. The first half of the
winter of 1806, which Nicholas Rostov spent in Moscow, was one of
the happiest, merriest times for him and the whole family. Nicholas
brought many young men to his parents' house. Vera was a handsome girl
of twenty; Sonya a girl of sixteen with all the charm of an opening
flower; Natasha, half grown up and half child, was now childishly
amusing, now girlishly enchanting.

At that time in the Rostovs' house there prevailed an amorous
atmosphere characteristic of homes where there are very young and very
charming girls. Every young man who came to the house--seeing those
impressionable, smiling young faces (smiling probably at their own
happiness), feeling the eager bustle around him, and hearing the
fitful bursts of song and music and the inconsequent but friendly
prattle of young girls ready for anything and full of hope-
experienced the same feeling; sharing with the young folk of the
Rostovs' household a readiness to fall in love and an expectation of
happiness.

Among the young men introduced by Rostov one of the first was
Dolokhov, whom everyone in the house liked except Natasha. She
almost quarreled with her brother about him. She insisted that he
was a bad man, and that in the duel with Bezukhov, Pierre was right
and Dolokhov wrong, and further that he was disagreeable and
unnatural.

"There's nothing for me to understand," cried out with resolute
self-will, "he is wicked and heartless. There now, I like your Denisov
though he is a rake and all that, still I like him; so you see I do
understand. I don't know how to put it... with this one everything
is calculated, and I don't like that. But Denisov..."

"Oh, Denisov is quite different," replied Nicholas, implying that
even Denisov was nothing compared to Dolokhov--"you must understand
what a soul there is in Dolokhov, you should see him with his
mother. What a heart!"

"Well, I don't know about that, but I am uncomfortable with him. And
do you know he has fallen in love with Sonya?"

"What nonsense..."

"I'm certain of it; you'll see."

Natasha's prediction proved true. Dolokhov, who did not usually care
for the society of ladies, began to come often to the house, and the
question for whose sake he came (though no one spoke of it) was soon
settled. He came because of Sonya. And Sonya, though she would never
have dared to say so, knew it and blushed scarlet every time
Dolokhov appeared.

Dolokhov often dined at the Rostovs', never missed a performance
at which they were present, and went to Iogel's balls for young people
which the Rostovs always attended. He was pointedly attentive to Sonya
and looked at her in such a way that not only could she not bear his
glances without coloring, but even the old countess and Natasha
blushed when they saw his looks.

It was evident that this strange, strong man was under the
irresistible influence of the dark, graceful girl who loved another.

Rostov noticed something new in Dolokhov's relations with Sonya, but
he did not explain to himself what these new relations were.
"They're always in love with someone," he thought of Sonya and
Natasha. But he was not as much at ease with Sonya and Dolokhov as
before and was less frequently at home.

In the autumn of 1806 everybody had again begun talking of the war
with Napoleon with even greater warmth than the year before. Orders
were given to raise recruits, ten men in every thousand for the
regular army, and besides this, nine men in every thousand for the
militia. Everywhere Bonaparte was anathematized and in Moscow
nothing but the coming war was talked of. For the Rostov family the
whole interest of these preparations for war lay in the fact that
Nicholas would not hear of remaining in Moscow, and only awaited the
termination of Denisov's furlough after Christmas to return with him
to their regiment. His approaching departure did not prevent his
amusing himself, but rather gave zest to his pleasures. He spent the
greater part of his time away from home, at dinners, parties, and
balls.





CHAPTER XI


On the third day after Christmas Nicholas dined at home, a thing
he had rarely done of late. It was a grand farewell dinner, as he
and Denisov were leaving to join their regiment after Epiphany.
About twenty people were present, including Dolokhov and Denisov.

Never had love been so much in the air, and never had the amorous
atmosphere made itself so strongly felt in the Rostovs' house as at
this holiday time. "Seize the moments of happiness, love and be loved!
That is the only reality in the world, all else is folly. It is the
one thing we are interested in here," said the spirit of the place.

Nicholas, having as usual exhausted two pairs of horses, without
visiting all the places he meant to go to and where he had been
invited, returned home just before dinner. As soon as he entered he
noticed and felt the tension of the amorous air in the house, and also
noticed a curious embarrassment among some of those present. Sonya,
Dolokhov, and the old countess were especially disturbed, and to a
lesser degree Natasha. Nicholas understood that something must have
happened between Sonya and Dolokhov before dinner, and with the kindly
sensitiveness natural to him was very gentle and wary with them both
at dinner. On that same evening there was to be one of the balls
that Iogel (the dancing master) gave for his pupils durings the
holidays.

"Nicholas, will you come to Iogel's? Please do!" said Natasha. "He
asked you, and Vasili Dmitrich* is also going."


*Denisov.


"Where would I not go at the countess' command!" said Denisov, who
at the Rostovs' had jocularly assumed the role of Natasha's knight.
"I'm even weady to dance the pas de chale."

"If I have time," answered Nicholas. "But I promised the
Arkharovs; they have a party."

"And you?" he asked Dolokhov, but as soon as he had asked the
question he noticed that it should not have been put.

"Perhaps," coldly and angrily replied Dolokhov, glancing at Sonya,
and, scowling, he gave Nicholas just such a look as he had given
Pierre at the Club dinner.

"There is something up," thought Nicholas, and he was further
confirmed in this conclusion by the fact that Dolokhov left
immediately after dinner. He called Natasha and asked her what was the
matter.

"And I was looking for you," said Natasha running out to him. "I
told you, but you would not believe it," she said triumphantly. "He
has proposed to Sonya!"

Little as Nicholas had occupied himself with Sonya of late,
something seemed to give way within him at this news. Dolokhov was a
suitable and in some respects a brilliant match for the dowerless,
orphan girl. From the point of view of the old countess and of society
it was out of the question for her to refuse him. And therefore
Nicholas' first feeling on hearing the news was one of anger with
Sonya.... He tried to say, "That's capital; of course she'll forget
her childish promises and accept the offer," but before he had time to
say it Natasha began again.

"And fancy! she refused him quite definitely!" adding, after a
pause, "she told him she loved another."

"Yes, my Sonya could not have done otherwise!" thought Nicholas.

"Much as Mamma pressed her, she refused, and I know she won't change
once she has said..."

"And Mamma pressed her!" said Nicholas reproachfully.

"Yes," said Natasha. "Do you know, Nicholas--don't be angry--but I
know you will not marry her. I know, heaven knows how, but I know
for certain that you won't marry her."

"Now don't know that at all!" said Nicholas. "But I must talk to
her. What a darling Sonya is!" he added with a smile.

"Ah, she is indeed a darling! I'll send her to you."

And Natasha kissed her brother and ran away.

A minute later Sonya came in with a frightened, guilty, and scared
look. Nicholas went up to her and kissed her hand. This was the
first time since his return that they had talked alone and about their
love.

"Sophie," he began, timidly at first and then more and more
boldly, "if you wish to refuse one who is not only a brilliant and
advantageous match but a splendid, noble fellow... he is my friend..."

Sonya interrupted him.

"I have already refused," she said hurriedly.

"If you are refusing for my sake, I am afraid that I..."

Sonya again interrupted. She gave him an imploring, frightened look.

"Nicholas, don't tell me that!" she said.

"No, but I must. It may be arrogant of me, but still it is best to
say it. If you refuse him on my account, I must tell you the whole
truth. I love you, and I think I love you more than anyone else...."

"That is enough for me," said Sonya, blushing.

"No, but I have been in love a thousand times and shall fall in love
again, though for no one have I such a feeling of friendship,
confidence, and love as I have for you. Then I am young. Mamma does
not wish it. In a word, I make no promise. And I beg you to consider
Dolokhov's offer," he said, articulating his friend's name with
difficulty.

"Don't say that to me! I want nothing. I love you as a brother and
always shall, and I want nothing more."

"You are an angel: I am not worthy of you, but I am afraid of
misleading you."

And Nicholas again kissed her hand.





CHAPTER XII


Iogel's were the most enjoyable balls in Moscow. So said the mothers
as they watched their young people executing their newly learned
steps, and so said the youths and maidens themselves as they danced
till they were ready to drop, and so said the grown-up young men and
women who came to these balls with an air of condescension and found
them most enjoyable. That year two marriages had come of these
balls. The two pretty young Princesses Gorchakov met suitors there and
were married and so further increased the fame of these dances. What
distinguished them from others was the absence of host or hostess
and the presence of the good-natured Iogel, flying about like a
feather and bowing according to the rules of his art, as he
collected the tickets from all his visitors. There was the fact that
only those came who wished to dance and amuse themselves as girls of
thirteen and fourteen do who are wearing long dresses for the first
time. With scarcely any exceptions they all were, or seemed to be,
pretty--so rapturous were their smiles and so sparkling their eyes.
Sometimes the best of the pupils, of whom Natasha, who was
exceptionally graceful, was first, even danced the pas de chale, but
at this last ball only the ecossaise, the anglaise, and the mazurka,
which was just coming into fashion, were danced. Iogel had taken a
ballroom in Bezukhov's house, and the ball, as everyone said, was a
great success. There were many pretty girls and the Rostov girls
were among the prettiest. They were both particularly happy and gay.
That evening, proud of Dolokhov's proposal, her refusal, and her
explanation with Nicholas, Sonya twirled about before she left home so
that the maid could hardly get her hair plaited, and she was
transparently radiant with impulsive joy.

Natasha no less proud of her first long dress and of being at a real
ball was even happier. They were both dressed in white muslin with
pink ribbons.

Natasha fell in love the very moment she entered the ballroom. She
was not in love with anyone in particular, but with everyone. Whatever
person she happened to look at she was in love with for that moment.

"Oh, how delightful it is!" she kept saying, running up to Sonya.

Nicholas and Denisov were walking up and down, looking with kindly
patronage at the dancers.

"How sweet she is--she will be a weal beauty!" said Denisov.

"Who?"

"Countess Natasha," answered Denisov.

"And how she dances! What gwace!" he said again after a pause.

"Who are you talking about?"

"About your sister," ejaculated Denisov testily.

Rostov smiled.

"My dear count, you were one of my best pupils--you must dance,"
said little Iogel coming up to Nicholas. "Look how many charming young
ladies-" He turned with the same request to Denisov who was also a
former pupil of his.

"No, my dear fellow, I'll be a wallflower," said Denisov. "Don't you
wecollect what bad use I made of your lessons?"

"Oh no!" said Iogel, hastening to reassure him. "You were only
inattentive, but you had talent--oh yes, you had talent!"

 The band struck up the newly introduced mazurka. Nicholas could not
refuse Iogel and asked Sonya to dance. Denisov sat down by the old
ladies and, leaning on his saber and beating time with his foot,
told them something funny and kept them amused, while he watched the
young people dancing, Iogel with Natasha, his pride and his best
pupil, were the first couple. Noiselessly, skillfully stepping with
his little feet in low shoes, Iogel flew first across the hall with
Natasha, who, though shy, went on carefully executing her steps.
Denisov did not take his eyes off her and beat time with his saber
in a way that clearly indicated that if he was not dancing it was
because he would not and not because he could not. In the middle of
a figure he beckoned to Rostov who was passing:

"This is not at all the thing," he said. "What sort of Polish
mazuwka is this? But she does dance splendidly."

Knowing that Denisov had a reputation even in Poland for the
masterly way in which he danced the mazurka, Nicholas ran up to
Natasha:

"Go and choose Denisov. He is a real dancer, a wonder!" he said.

When it came to Natasha's turn to choose a partner, she rose and,
tripping rapidly across in her little shoes trimmed with bows, ran
timidly to the corner where Denisov sat. She saw that everybody was
looking at her and waiting. Nicholas saw that Denisov was refusing
though he smiled delightedly. He ran up to them.

"Please, Vasili Dmitrich," Natasha was saying, "do come!"

"Oh no, let me off, Countess," Denisov replied.

"Now then, Vaska," said Nicholas.

"They coax me as if I were Vaska the cat!" said Denisov jokingly.

"I'll sing for you a whole evening," said Natasha.

"Oh, the faiwy! She can do anything with me!" said Denisov, and he
unhooked his saber. He came out from behind the chairs, clasped his
partner's hand firmly, threw back his head, and advanced his foot,
waiting for the beat. Only on horse back and in the mazurka was
Denisov's short stature not noticeable and he looked the fine fellow
he felt himself to be. At the right beat of the music he looked
sideways at his partner with a merry and triumphant air, suddenly
stamped with one foot, bounded from the floor like a ball, and flew
round the room taking his partner with him. He glided silently on
one foot half across the room, and seeming not to notice the chairs
was dashing straight at them, when suddenly, clinking his spurs and
spreading out his legs, he stopped short on his heels, stood so a
second, stamped on the spot clanking his spurs, whirled rapidly round,
and, striking his left heel against his right, flew round again in a
circle. Natasha guessed what he meant to do, and abandoning herself to
him followed his lead hardly knowing how. First he spun her round,
holding her now with his left, now with his right hand, then falling
on one knee he twirled her round him, and again jumping up, dashed
so impetuously forward that it seemed as if he would rush through
the whole suite of rooms without drawing breath, and then he
suddenly stopped and performed some new and unexpected steps. When
at last, smartly whirling his partner round in front of her chair,
he drew up with a click of his spurs and bowed to her, Natasha did not
even make him a curtsy. She fixed her eyes on him in amazement,
smiling as if she did not recognize him.

"What does this mean?" she brought out.

Although Iogel did not acknowledge this to be the real mazurka,
everyone was delighted with Denisov's skill, he was asked again and
again as a partner, and the old men began smilingly to talk about
Poland and the good old days. Denisov, flushed after the mazurka and
mopping himself with his handkerchief, sat down by Natasha and did not
leave her for the rest of the evening.





CHAPTER XIII


For two days after that Rostov did not see Dolokhov at his own or at
Dolokhov's home: on the third day he received a note from him:


As I do not intend to be at your house again for reasons you know
of, and am going to rejoin my regiment, I am giving a farewell
supper tonight to my friends--come to the English Hotel.


About ten o'clock Rostov went to the English Hotel straight from the
theater, where he had been with his family and Denisov. He was at once
shown to the best room, which Dolokhov had taken for that evening.
Some twenty men were gathered round a table at which Dolokhov sat
between two candles. On the table was a pile of gold and paper
money, and he was keeping the bank. Rostov had not seen him since
his proposal and Sonya's refusal and felt uncomfortable at the thought
of how they would meet.

Dolokhov's clear, cold glance met Rostov as soon as he entered the
door, as though he had long expected him.

"It's a long time since we met," he said. "Thanks for coming. I'll
just finish dealing, and then Ilyushka will come with his chorus."

"I called once or twice at your house," said Rostov, reddening.

Dolokhov made no reply.

"You may punt," he said.

Rostov recalled at that moment a strange conversation he had once
had with Dolokhov. "None but fools trust to luck in play," Dolokhov
had then said.

"Or are you afraid to play with me?" Dolokhov now asked as if
guessing Rostov's thought.

Beneath his smile Rostov saw in him the mood he had shown at the
Club dinner and at other times, when as if tired of everyday life he
had felt a need to escape from it by some strange, and usually
cruel, action.

Rostov felt ill at ease. He tried, but failed, to find some joke
with which to reply to Dolokhov's words. But before he had thought
of anything, Dolokhov, looking straight in his face, said slowly and
deliberately so that everyone could hear:

"Do you remember we had a talk about cards... 'He's a fool who
trusts to luck, one should make certain,' and I want to try."

"To try his luck or the certainty?" Rostov asked himself.

"Well, you'd better not play," Dolokhov added, and springing a new
pack of cards said: "Bank, gentlemen!"

Moving the money forward he prepared to deal. Rostov sat down by his
side and at first did not play. Dolokhov kept glancing at him.

"Why don't you play?" he asked.

And strange to say Nicholas felt that he could not help taking up
a card, putting a small stake on it, and beginning to play.

"I have no money with me," he said.

"I'll trust you."

Rostov staked five rubles on a card and lost, staked again, and
again lost. Dolokhov "killed," that is, beat, ten cards of Rostov's
running.

"Gentlemen," said Dolokhov after he had dealt for some time. "Please
place your money on the cards or I may get muddled in the reckoning."

One of the players said he hoped he might be trusted.

"Yes, you might, but I am afraid of getting the accounts mixed. So I
ask you to put the money on your cards," replied Dolokhov. "Don't
stint yourself, we'll settle afterwards," he added, turning to Rostov.

The game continued; a waiter kept handing round champagne.

All Rostov's cards were beaten and he had eight hundred rubles
scored up against him. He wrote "800 rubles" on a card, but while
the waiter filled his glass he changed his mind and altered it to
his usual stake of twenty rubles.

"Leave it," said Dolokhov, though he did not seem to be even looking
at Rostov, "you'll win it back all the sooner. I lose to the others
but win from you. Or are you afraid of me?" he asked again.

Rostov submitted. He let the eight hundred remain and laid down a
seven of hearts with a torn corner, which he had picked up from the
floor. He well remembered that seven afterwards. He laid down the
seven of hearts, on which with a broken bit of chalk he had written
"800 rubles" in clear upright figures; he emptied the glass of warm
champagne that was handed him, smiled at Dolokhov's words, and with
a sinking heart, waiting for a seven to turn up, gazed at Dolokhov's
hands which held the pack. Much depended on Rostov's winning or losing
on that seven of hearts. On the previous Sunday the old count had
given his son two thousand rubles, and though he always disliked
speaking of money difficulties had told Nicholas that this was all
he could let him have till May, and asked him to be more economical
this time. Nicholas had replied that it would be more than enough
for him and that he gave his word of honor not to take anything more
till the spring. Now only twelve hundred rubles was left of that
money, so that this seven of hearts meant for him not only the loss of
sixteen hundred rubles, but the necessity of going back on his word.
With a sinking heart he watched Dolokhov's hands and thought, "Now
then, make haste and let me have this card and I'll take my cap and
drive home to supper with Denisov, Natasha, and Sonya, and will
certainly never touch a card again." At that moment his home life,
jokes with Petya, talks with Sonya, duets with Natasha, piquet with
his father, and even his comfortable bed in the house on the
Povarskaya rose before him with such vividness, clearness, and charm
that it seemed as if it were all a lost and unappreciated bliss,
long past. He could not conceive that a stupid chance, letting the
seven be dealt to the right rather than to the left, might deprive him
of all this happiness, newly appreciated and newly illumined, and
plunge him into the depths of unknown and undefined misery. That could
not be, yet he awaited with a sinking heart the movement of Dolokhov's
hands. Those broad, reddish hands, with hairy wrists visible from
under the shirt cuffs, laid down the pack and took up a glass and a
pipe that were handed him.

"So you are not afraid to play with me?" repeated Dolokhov, and as
if about to tell a good story he put down the cards, leaned back in
his chair, and began deliberately with a smile:

"Yes, gentlemen, I've been told there's a rumor going about Moscow
that I'm a sharper, so I advise you to be careful."

"Come now, deal!" exclaimed Rostov.

"Oh, those Moscow gossips!" said Dolokhov, and he took up the
cards with a smile.

"Aah!" Rostov almost screamed lifting both hands to his head. The
seven he needed was lying uppermost, the first card in the pack. He
had lost more than he could pay.

"Still, don't ruin yourself!" said Dolokhov with a side glance at
Rostov as he continued to deal.





CHAPTER XIV


An hour and a half later most of the players were but little
interested in their own play.

The whole interest was concentrated on Rostov. Instead of sixteen
hundred rubles he had a long column of figures scored against him,
which he had reckoned up to ten thousand, but that now, as he
vaguely supposed, must have risen to fifteen thousand. In reality it
already exceeded twenty thousand rubles. Dolokhov was no longer
listening to stories or telling them, but followed every movement of
Rostov's hands and occasionally ran his eyes over the score against
him. He had decided to play until that score reached forty-three
thousand. He had fixed on that number because forty-three was the
sum of his and Sonya's joint ages. Rostov, leaning his head on both
hands, sat at the table which was scrawled over with figures, wet with
spilled wine, and littered with cards. One tormenting impression did
not leave him: that those broad-boned reddish hands with hairy
wrists visible from under the shirt sleeves, those hands which he
loved and hated, held him in their power.

"Six hundred rubles, ace, a corner, a nine... winning it back's
impossible... Oh, how pleasant it was at home!... The knave, double or
quits... it can't be!... And why is he doing this to me?" Rostov
pondered. Sometimes he staked a large sum, but Dolokhov refused to
accept it and fixed the stake himself. Nicholas submitted to him,
and at one moment prayed to God as he had done on the battlefield at
the bridge over the Enns, and then guessed that the card that came
first to hand from the crumpled heap under the table would save him,
now counted the cords on his coat and took a card with that number and
tried staking the total of his losses on it, then he looked round
for aid from the other players, or peered at the now cold face of
Dolokhov and tried to read what was passing in his mind.

"He knows of course what this loss means to me. He can't want my
ruin. Wasn't he my friend? Wasn't I fond of him? But it's not his
fault. What's he to do if he has such luck?... And it's not my fault
either," he thought to himself, "I have done nothing wrong. Have I
killed anyone, or insulted or wished harm to anyone? Why such a
terrible misfortune? And when did it begin? Such a little while ago
I came to this table with the thought of winning a hundred rubles to
buy that casket for Mamma's name day and then going home. I was so
happy, so free, so lighthearted! And I did not realize how happy I
was! When did that end and when did this new, terrible state of things
begin? What marked the change? I sat all the time in this same place
at this table, chose and placed cards, and watched those broad-boned
agile hands in the same way. When did it happen and what has happened?
I am well and strong and still the same and in the same place. No,
it can't be! Surely it will all end in nothing!"

He was flushed and bathed in perspiration, though the room was not
hot. His face was terrible and piteous to see, especially from its
helpless efforts to seem calm.

The score against him reached the fateful sum of forty-three
thousand. Rostov had just prepared a card, by bending the corner of
which he meant to double the three thousand just put down to his
score, when Dolokhov, slamming down the pack of cards, put it aside
and began rapidly adding up the total of Rostov's debt, breaking the
chalk as he marked the figures in his clear, bold hand.

"Supper, it's time for supper! And here are the gypsies!"

Some swarthy men and women were really entering from the cold
outside and saying something in their gypsy accents. Nicholas
understood that it was all over; but he said in an indifferent tone:

"Well, won't you go on? I had a splendid card all ready," as if it
were the fun of the game which interested him most.

"It's all up! I'm lost!" thought he. "Now a bullet through my brain-
that's all that's left me!" And at the same time he said in a
cheerful voice:

"Come now, just this one more little card!"

"All right!" said Dolokhov, having finished the addition. "All
right! Twenty-one rubles," he said, pointing to the figure
twenty-one by which the total exceeded the round sum of forty-three
thousand; and taking up a pack he prepared to deal. Rostov
submissively unbent the corner of his card and, instead of the six
thousand he had intended, carefully wrote twenty-one.

"It's all the same to me," he said. "I only want to see whether
you will let me win this ten, or beat it."

Dolokhov began to deal seriously. Oh, how Rostov detested at that
moment those hands with their short reddish fingers and hairy
wrists, which held him in their power.... The ten fell to him.

"You owe forty-three thousand, Count," said Dolokhov, and stretching
himself he rose from the table. "One does get tired sitting so
long," he added.

"Yes, I'm tired too," said Rostov.

Dolokhov cut him short, as if to remind him that it was not for
him to jest.

"When am I to receive the money, Count?"

Rostov, flushing, drew Dolokhov into the next room.

"I cannot pay it all immediately. Will you take an I.O.U.?" he said.

"I say, Rostov," said Dolokhov clearly, smiling and looking Nicholas
straight in the eyes, "you know the saying, 'Lucky in love, unlucky at
cards.' Your cousin is in love with you, I know."

"Oh, it's terrible to feel oneself so in this man's power,"
thought Rostov. He knew what a shock he would inflict on his father
and mother by the news of this loss, he knew what a relief it would be
to escape it all, and felt that Dolokhov knew that he could save him
from all this shame and sorrow, but wanted now to play with him as a
cat does with a mouse.

"Your cousin..." Dolokhov started to say, but Nicholas interrupted
him.

"My cousin has nothing to do with this and it's not necessary to
mention her!" he exclaimed fiercely.

"Then when am I to have it?"

"Tomorrow," replied Rostov and left the room.





CHAPTER XV


To say "tomorrow" and keep up a dignified tone was not difficult,
but to go home alone, see his sisters, brother, mother, and father,
confess and ask for money he had no right to after giving his word
of honor, was terrible.

At home, they had not yet gone to bed. The young people, after
returning from the theater, had had supper and were grouped round
the clavichord. As soon as Nicholas entered, he was enfolded in that
poetic atmosphere of love which pervaded the Rostov household that
winter and, now after Dolokhov's proposal and Iogel's ball, seemed
to have grown thicker round Sonya and Natasha as the air does before a
thunderstorm. Sonya and Natasha, in the light-blue dresses they had
worn at the theater, looking pretty and conscious of it, were standing
by the clavichord, happy and smiling. Vera was playing chess with
Shinshin in the drawing room. The old countess, waiting for the return
of her husband and son, sat playing patience with the old
gentlewoman who lived in their house. Denisov, with sparkling eyes and
ruffled hair, sat at the clavichord striking chords with his short
fingers, his legs thrown back and his eyes rolling as he sang, with
his small, husky, but true voice, some verses called "Enchantress,"
which he had composed, and to which he was trying to fit music:

   Enchantress, say, to my forsaken lyre
   What magic power is this recalls me still?
   What spark has set my inmost soul on fire,
   What is this bliss that makes my fingers thrill?

He was singing in passionate tones, gazing with his
sparkling black-agate eyes at the frightened and happy Natasha.

"Splendid! Excellent!" exclaimed Natasha. "Another verse," she
said, without noticing Nicholas.

"Everything's still the same with them," thought Nicholas,
glancing into the drawing room, where he saw Vera and his mother
with the old lady.

"Ah, and here's Nicholas!" cried Natasha, running up to him.

"Is Papa at home?" he asked.

"I am so glad you've come!" said Natasha, without answering him. "We
are enjoying ourselves! Vasili Dmitrich is staying a day longer for my
sake! Did you know?"

"No, Papa is not back yet," said Sonya.

"Nicholas, have you come? Come here, dear!" called the old
countess from the drawing room.

Nicholas went to her, kissed her hand, and sitting down silently
at her table began to watch her hands arranging the cards. From the
dancing room, they still heard the laughter and merry voices trying to
persuade Natasha to sing.

"All wight! All wight!" shouted Denisov. "It's no good making
excuses now! It's your turn to sing the ba'cawolla--I entweat you!"

The countess glanced at her silent son.

"What is the matter?" she asked.

"Oh, nothing," said he, as if weary of being continually asked the
same question. "Will Papa be back soon?"

"I expect so."

"Everything's the same with them. They know nothing about it!
Where am I to go?" thought Nicholas, and went again into the dancing
room where the clavichord stood.

Sonya was sitting at the clavichord, playing the prelude to
Denisov's favorite barcarolle. Natasha was preparing to sing.
Denisov was looking at her with enraptured eyes.

Nicholas began pacing up and down the room.

"Why do they want to make her sing? How can she sing? There's
nothing to be happy about!" thought he.

Sonya struck the first chord of the prelude.

"My God, I'm a ruined and dishonored man! A bullet through my
brain is the only thing left me--not singing!" his thoughts ran on.
"Go away? But where to? It's one--let them sing!"

He continued to pace the room, looking gloomily at Denisov and the
girls and avoiding their eyes.

"Nikolenka, what is the matter?" Sonya's eyes fixed on him seemed to
ask. She noticed at once that something had happened to him.

Nicholas turned away from her. Natasha too, with her quick instinct,
had instantly noticed her brother's condition. But, though she noticed
it, she was herself in such high spirits at that moment, so far from
sorrow, sadness, or self-reproach, that she purposely deceived herself
as young people often do. "No, I am too happy now to spoil my
enjoyment by sympathy with anyone's sorrow," she felt, and she said to
herself: "No, I must be mistaken, he must be feeling happy, just as
I am."

"Now, Sonya!" she said, going to the very middle of the room,
where she considered the resonance was best.

Having lifted her head and let her arms droop lifelessly, as
ballet dancers do, Natasha, rising energetically from her heels to her
toes, stepped to the middle of the room and stood still.

"Yes, that's me!" she seemed to say, answering the rapt gaze with
which Denisov followed her.

"And what is she so pleased about?" thought Nicholas, looking at his
sister. "Why isn't she dull and ashamed?"

Natasha took the first note, her throat swelled, her chest rose, her
eyes became serious. At that moment she was oblivious of her
surroundings, and from her smiling lips flowed sounds which anyone may
produce at the same intervals hold for the same time, but which
leave you cold a thousand times and the thousand and first time thrill
you and make you weep.

Natasha, that winter, had for the first time begun to sing
seriously, mainly because Denisov so delighted in her singing. She
no longer sang as a child, there was no longer in her singing that
comical, childish, painstaking effect that had been in it before;
but she did not yet sing well, as all the connoisseurs who heard her
said: "It is not trained, but it is a beautiful voice that must be
trained." Only they generally said this some time after she had
finished singing. While that untrained voice, with its incorrect
breathing and labored transitions, was sounding, even the connoisseurs
said nothing, but only delighted in it and wished to hear it again. In
her voice there was a virginal freshness, an unconsciousness of her
own powers, and an as yet untrained velvety softness, which so mingled
with her lack of art in singing that it seemed as if nothing in that
voice could be altered without spoiling it.

"What is this?" thought Nicholas, listening to her with widely
opened eyes. "What has happened to her? How she is singing today!" And
suddenly the whole world centered for him on anticipation of the
next note, the next phrase, and everything in the world was divided
into three beats: "Oh mio crudele affetto."... One, two, three... one,
two, three... One... "Oh mio crudele affetto."... One, two, three...
One. "Oh, this senseless life of ours!" thought Nicholas. "All this
misery, and money, and Dolokhov, and anger, and honor--it's all
nonsense... but this is real.... Now then, Natasha, now then, dearest!
Now then, darling! How will she take that si? She's taken it! Thank
God!" And without noticing that he was singing, to strengthen the si
he sung a second, a third below the high note. "Ah, God! How fine! Did
I really take it? How fortunate!" he thought.

Oh, how that chord vibrated, and how moved was something that was
finest in Rostov's soul! And this something was apart from
everything else in the world and above everything in the world.
"What were losses, and Dolokhov, and words of honor?... All
nonsense! One might kill and rob and yet be happy..."





CHAPTER XVI


It was long since Rostov had felt such enjoyment from music as he
did that day. But no sooner had Natasha finished her barcarolle than
reality again presented itself. He got up without saying a word and
went downstairs to his own room. A quarter of an hour later the old
count came in from his Club, cheerful and contented. Nicholas, hearing
him drive up, went to meet him.

"Well--had a good time?" said the old count, smiling gaily and
proudly at his son.

Nicholas tried to say "Yes," but could not: and he nearly burst into
sobs. The count was lighting his pipe and did not notice his son's
condition.

"Ah, it can't be avoided!" thought Nicholas, for the first and
last time. And suddenly, in the most casual tone, which made him
feel ashamed of himself, he said, as if merely asking his
father to let him have the carriage to drive to town:

"Papa, I have come on a matter of business. I was nearly forgetting.
I need some money."

"Dear me!" said his father, who was in a specially good humor. "I
told you it would not be enough. How much?"

"Very much," said Nicholas flushing, and with a stupid careless
smile, for which he was long unable to forgive himself, "I have lost a
little, I mean a good deal, a great deal--forty three thousand."

"What! To whom?... Nonsense!" cried the count, suddenly reddening
with an apoplectic flush over neck and nape as old people do.

"I promised to pay tomorrow," said Nicholas.

"Well!..." said the old count, spreading out his arms and sinking
helplessly on the sofa.

"It can't be helped It happens to everyone!" said the son, with a
bold, free, and easy tone, while in his soul he regarded himself as
a worthless scoundrel whose whole life could not atone for his
crime. He longed to kiss his father's hands and kneel to beg his
forgiveness, but said, in a careless and even rude voice, that it
happens to everyone!

The old count cast down his eyes on hearing his son's words and
began bustlingly searching for something.

"Yes, yes," he muttered, "it will be difficult, I fear, difficult to
raise... happens to everybody! Yes, who has not done it?"

And with a furtive glance at his son's face, the count went out of
the room.... Nicholas had been prepared for resistance, but had not at
all expected this.

"Papa! Pa-pa!" he called after him, sobbing, "forgive me!" And
seizing his father's hand, he pressed it to his lips and burst into
tears.

While father and son were having their explanation, the mother and
daughter were having one not less important. Natasha came running to
her mother, quite excited.

"Mamma!... Mamma!... He has made me..."

"Made what?"

"Made, made me an offer, Mamma! Mamma!" she exclaimed.

The countess did not believe her ears. Denisov had proposed. To
whom? To this chit of a girl, Natasha, who not so long ago was playing
with dolls and who was still having lessons.

"Don't, Natasha! What nonsense!" she said, hoping it was a joke.

"Nonsense, indeed! I am telling you the fact," said Natasha
indignantly. "I come to ask you what to do, and you call it
'nonsense!'"

The countess shrugged her shoulders.

"If it true that Monsieur Denisov has made you a proposal, tell
him he is a fool, that's all!"

"No, he's not a fool!" replied Natasha indignantly and seriously.

"Well then, what do you want? You're all in love nowadays. Well,
if you are in love, marry him!" said the countess, with a laugh of
annoyance. "Good luck to you!"

"No, Mamma, I'm not in love with him, I suppose I'm not in love with
him."

"Well then, tell him so."

"Mamma, are you cross? Don't be cross, dear! Is it my fault?"

"No, but what is it, my dear? Do you want me to go and tell him?"
said the countess smiling.

"No, I will do it myself, only tell me what to say. It's all very
well for you," said Natasha, with a responsive smile. "You should have
seen how he said it! I know he did not mean to say it, but it came out
accidently."

"Well, all the same, you must refuse him."

"No, I mustn't. I am so sorry for him! He's so nice."

"Well then, accept his offer. It's high time for you to be married,"
answered the countess sharply and sarcastically.

"No, Mamma, but I'm so sorry for him. I don't know how I'm to say
it."

"And there's nothing for you to say. I shall speak to him myself,"
said the countess, indignant that they should have dared to treat this
little Natasha as grown up.

"No, not on any account! I will tell him myself, and you'll listen
at the door," and Natasha ran across the drawing room to the dancing
hall, where Denisov was sitting on the same chair by the clavichord
with his face in his hands.

He jumped up at the sound of her light step.

"Nataly," he said, moving with rapid steps toward her, "decide my
fate. It is in your hands."

"Vasili Dmitrich, I'm so sorry for you!... No, but you are so
nice... but it won't do...not that... but as a friend, I shall
always love you."

Denisov bent over her hand and she heard strange sounds she did
not understand. She kissed his rough curly black head. At this
instant, they heard the quick rustle of the countess' dress. She
came up to them.

"Vasili Dmitrich, I thank you for the honor," she said, with an
embarrassed voice, though it sounded severe to Denisov--"but my
daughter is so young, and I thought that, as my son's friend, you
would have addressed yourself first to me. In that case you would
not have obliged me to give this refusal."

"Countess..." said Denisov, with downcast eyes and a guilty face. He
tried to say more, but faltered.

Natasha could not remain calm, seeing him in such a plight. She
began to sob aloud.

"Countess, I have done w'ong," Denisov went on in an unsteady voice,
"but believe me, I so adore your daughter and all your family that I
would give my life twice over..." He looked at the countess, and
seeing her severe face said: "Well, good-by, Countess," and kissing
her hand, he left the room with quick resolute strides, without
looking at Natasha.


Next day Rostov saw Denisov off. He not wish to stay another day
in Moscow. All Denisov's Moscow friends gave him a farewell
entertainment at the gypsies', with the result that he had no
recollection of how he was put in the sleigh or of the first three
stages of his journey.

After Denisov's departure, Rostov spent another fortnight in Moscow,
without going out of the house, waiting for the money his father could
not at once raise, and he spent most of his time in the girls' room.

Sonya was more tender and devoted to him than ever. It was as if she
wanted to show him that his losses were an achievement that made her
love him all the more, but Nicholas now considered himself unworthy of
her.

He filled the girls' albums with verses and music, and having at
last sent Dolokhov the whole forty-three thousand rubles and
received his receipt, he left at the end of November, without taking
leave of any of his acquaintances, to overtake his regiment which
was already in Poland.





BOOK FIVE: 1806 --07





CHAPTER I


After his interview with his wife Pierre left for Petersburg. At the
Torzhok post station, either there were no horses or the postmaster
would not supply them. Pierre was obliged to wait. Without undressing,
he lay down on the leather sofa in front of a round table, put his big
feet in their overboots on the table, and began to reflect.

"Will you have the portmanteaus brought in? And a bed got ready, and
tea?" asked his valet.

Pierre gave no answer, for he neither heard nor saw anything. He had
begun to think of the last station and was still pondering on the same
question--one so important that he took no notice of what went on
around him. Not only was he indifferent as to whether he got to
Petersburg earlier or later, or whether he secured accommodation at
this station, but compared to the thoughts that now occupied him it
was a matter of indifference whether he remained there for a few hours
or for the rest of his life.

The postmaster, his wife, the valet, and a peasant woman selling
Torzhok embroidery came into the room offering their services. Without
changing his careless attitude, Pierre looked at them over his
spectacles unable to understand what they wanted or how they could
go on living without having solved the problems that so absorbed
him. He had been engrossed by the same thoughts ever since the day
he returned from Sokolniki after the duel and had spent that first
agonizing, sleepless night. But now, in the solitude of the journey,
they seized him with special force. No matter what he thought about,
he always returned to these same questions which he could not solve
and yet could not cease to ask himself. It was as if the thread of the
chief screw which held his life together were stripped, so that the
screw could not get in or out, but went on turning uselessly in the
same place.

The postmaster came in and began obsequiously to beg his
excellency to wait only two hours, when, come what might, he would let
his excellency have the courier horses. It was plain that he was lying
and only wanted to get more money from the traveler.

"Is this good or bad?" Pierre asked himself. "It is good for me, bad
for another traveler, and for himself it's unavoidable, because he
needs money for food; the man said an officer had once given him a
thrashing for letting a private traveler have the courier horses.
But the officer thrashed him because he had to get on as quickly as
possible. And I," continued Pierre, "shot Dolokhov because I
considered myself injured, and Louis XVI was executed because they
considered him a criminal, and a year later they executed those who
executed him--also for some reason. What is bad? What is good? What
should one love and what hate? What does one live for? And what am
I? What is life, and what is death? What power governs all?"

There was no answer to any of these questions, except one, and
that not a logical answer and not at all a reply to them. The answer
was: "You'll die and all will end. You'll die and know all, or cease
asking." But dying was also dreadful.

The Torzhok peddler woman, in a whining voice, went on offering
her wares, especially a pair of goatskin slippers. "I have hundreds of
rubles I don't know what to do with, and she stands in her tattered
cloak looking timidly at me," he thought. "And what does she want
the money for? As if that money could add a hair's breadth to
happiness or peace of mind. Can anything in the world make her or me
less a prey to evil and death?--death which ends all and must come
today or tomorrow--at any rate, in an instant as compared with
eternity." And again he twisted the screw with the stripped thread,
and again it turned uselessly in the same place.

His servant handed him a half-cut novel, in the form of letters,
by Madame de Souza. He began reading about the sufferings and virtuous
struggles of a certain Emilie de Mansfeld. "And why did she resist her
seducer when she loved him?" he thought. "God could not have put
into her heart an impulse that was against His will. My wife--as she
once was--did not struggle, and perhaps she was right. Nothing has
been found out, nothing discovered," Pierre again said to himself.
"All we can know is that we know nothing. And that's the height of
human wisdom."

Everything within and around him seemed confused, senseless, and
repellent. Yet in this very repugnance to all his circumstances Pierre
found a kind of tantalizing satisfaction.

"I make bold to ask your excellency to move a little for this
gentleman," said the postmaster, entering the room followed by another
traveler, also detained for lack of horses.

The newcomer was a short, large-boned, yellow-faced, wrinkled old
man, with gray bushy eyebrows overhanging bright eyes of an indefinite
grayish color.

Pierre took his feet off the table, stood up, and lay down on a
bed that had been got ready for him, glancing now and then at the
newcomer, who, with a gloomy and tired face, was wearily taking off
his wraps with the aid of his servant, and not looking at Pierre. With
a pair of felt boots on his thin bony legs, and keeping on a worn,
nankeen-covered, sheepskin coat, the traveler sat down on the sofa,
leaned back his big head with its broad temples and close-cropped
hair, and looked at Bezukhov. The stern, shrewd, and penetrating
expression of that look struck Pierre. He felt a wish to speak to
the stranger, but by the time he had made up his mind to ask him a
question about the roads, the traveler had closed his eyes. His
shriveled old hands were folded and on the finger of one of them
Pierre noticed a large cast iron ring with a seal representing a
death's head. The stranger sat without stirring, either resting or, as
it seemed to Pierre, sunk in profound and calm meditation. His servant
was also a yellow, wrinkled old man, without beard or mustache,
evidently not because he was shaven but because they had never
grown. This active old servant was unpacking the traveler's canteen
and preparing tea. He brought in a boiling samovar. When everything
was ready, the stranger opened his eyes, moved to the table, filled
a tumbler with tea for himself and one for the beardless old man to
whom he passed it. Pierre began to feel a sense of uneasiness, and the
need, even the inevitability, of entering into conversation with
this stranger.

The servant brought back his tumbler turned upside down,* with an
unfinished bit of nibbled sugar, and asked if anything more would be
wanted.


*To indicate he did not want more tea.


"No. Give me the book," said the stranger.

The servant handed him a book which Pierre took to be a devotional
work, and the traveler became absorbed in it. Pierre looked at him.
All at once the stranger closed the book, putting in a marker, and
again, leaning with his arms on the back of the sofa, sat in his
former position with his eyes shut. Pierre looked at him and had not
time to turn away when the old man, opening his eyes, fixed his steady
and severe gaze straight on Pierre's face.

Pierre felt confused and wished to avoid that look, but the bright
old eyes attracted him irresistibly.





CHAPTER II


"I have the pleasure of addressing Count Bezukhov, if I am not
mistaken," said the stranger in a deliberate and loud voice.

Pierre looked silently and inquiringly at him over his spectacles.

"I have heard of you, my dear sir," continued the stranger, "and
of your misfortune." He seemed to emphasize the last word, as if to
say--"Yes, misfortune! Call it what you please, I know that what
happened to you in Moscow was a misfortune."--"I regret it very
much, my dear sir."

Pierre flushed and, hurriedly putting his legs down from the bed,
bent forward toward the old man with a forced and timid smile.

"I have not referred to this out of curiosity, my dear sir, but
for greater reasons."

He paused, his gaze still on Pierre, and moved aside on the sofa
by way of inviting the other to take a seat beside him. Pierre felt
reluctant to enter into conversation with this old man, but,
submitting to him involuntarily, came up and sat down beside him.

"You are unhappy, my dear sir," the stranger continued. "You are
young and I am old. I should like to help you as far as lies in my
power."

"Oh, yes!" said Pierre, with a forced smile. "I am very grateful
to you. Where are you traveling from?"

The stranger's face was not genial, it was even cold and severe, but
in spite of this, both the face and words of his new acquaintance were
irresistibly attractive to Pierre.

"But if for reason you don't feel inclined to talk to me," said
the old man, "say so, my dear sir." And he suddenly smiled, in an
unexpected and tenderly paternal way.

"Oh no, not at all! On the contrary, I am very glad to make your
acquaintance," said Pierre. And again, glancing at the stranger's
hands, he looked more closely at the ring, with its skull--a Masonic
sign.

"Allow me to ask," he said, "are you a Mason?"

"Yes, I belong to the Brotherhood of the Freemasons," said the
stranger, looking deeper and deeper into Pierre's eyes. "And in
their name and my own I hold out a brotherly hand to you."

"I am afraid," said Pierre, smiling, and wavering between the
confidence the personality of the Freemason inspired in him and his
own habit of ridiculing the Masonic beliefs--"I am afraid I am very
far from understanding--how am I to put it?--I am afraid my way of
looking at the world is so opposed to yours that we shall not
understand one another."

"I know your outlook," said the Mason, "and the view of life you
mention, and which you think is the result of your own mental efforts,
is the one held by the majority of people, and is the invariable fruit
of pride, indolence, and ignorance. Forgive me, my dear sir, but if
I had not known it I should not have addressed you. Your view of
life is a regrettable delusion."

"Just as I may suppose you to be deluded," said Pierre, with a faint
smile.

"I should never dare to say that I know the truth," said the
Mason, whose words struck Pierre more and more by their precision
and firmness. "No one can attain to truth by himself. Only by laying
stone on stone with the cooperation of all, by the millions of
generations from our forefather Adam to our own times, is that
temple reared which is to be a worthy dwelling place of the Great
God," he added, and closed his eyes.

"I ought to tell you that I do not believe... do not believe in God,"
said Pierre, regretfully and with an effort, feeling it essential to
speak the whole truth.

The Mason looked intently at Pierre and smiled as a rich man with
millions in hand might smile at a poor fellow who told him that he,
poor man, had not the five rubles that would make him happy.

"Yes, you do not know Him, my dear sir," said the Mason. "You cannot
know Him. You do not know Him and that is why you are unhappy."

"Yes, yes, I am unhappy," assented Pierre. "But what am I to do?"

"You know Him not, my dear sir, and so you are very unhappy. You
do not know Him, but He is here, He is in me, He is in my words, He
is in thee, and even in those blasphemous words thou hast just
uttered!" pronounced the Mason in a stern and tremulous voice.

He paused and sighed, evidently trying to calm himself.

"If He were not," he said quietly, "you and I would not be
speaking of Him, my dear sir. Of what, of whom, are we speaking?
Whom hast thou denied?" he suddenly asked with exulting austerity
and authority in his voice. "Who invented Him, if He did not exist?
Whence came thy conception of the existence of such an
incomprehensible Being? didst thou, and why did the whole world,
conceive the idea of the existence of such an incomprehensible
Being, a Being all-powerful, eternal, and infinite in all His
attributes?..."

He stopped and remained silent for a long time.

Pierre could not and did not wish to break this silence.

"He exists, but to understand Him is hard," the Mason began again,
looking not at Pierre but straight before him, and turning the
leaves of his book with his old hands which from excitement he could
not keep still. "If it were a man whose existence thou didst doubt I
could bring him to thee, could take him by the hand and show him to
thee. But how can I, an insignificant mortal, show His omnipotence,
His infinity, and all His mercy to one who is blind, or who shuts
his eyes that he may not see or understand Him and may not see or
understand his own vileness and sinfulness?" He paused again. "Who art
thou? Thou dreamest that thou art wise because thou couldst utter
those blasphemous words," he went on, with a somber and scornful
smile. "And thou art more foolish and unreasonable than a little
child, who, playing with the parts of a skillfully made watch, dares
to say that, as he does not understand its use, he does not believe in
the master who made it. To know Him is hard.... For ages, from our
forefather Adam to our own day, we labor to attain that knowledge
and are still infinitely far from our aim; but in our lack of
understanding we see only our weakness and His greatness...."

Pierre listened with swelling heart, gazing into the Mason's face
with shining eyes, not interrupting or questioning him, but
believing with his whole soul what the stranger said. Whether he
accepted the wise reasoning contained in the Mason's words, or
believed as a child believes, in the speaker's tone of conviction
and earnestness, or the tremor of the speaker's voice--which sometimes
almost broke--or those brilliant aged eyes grown old in this
conviction, or the calm firmness and certainty of his vocation,
which radiated from his whole being (and which struck Pierre
especially by contrast with his own dejection and hopelessness)--at
any rate, Pierre longed with his whole soul to believe and he did
believe, and felt a joyful sense of comfort, regeneration, and
return to life.

"He is not to be apprehended by reason, but by life," said the
Mason.

"I do not understand," said Pierre, feeling with dismay doubts
reawakening. He was afraid of any want of clearness, any weakness,
in the Mason's arguments; he dreaded not to be able to believe in him.
"I don't understand," he said, "how it is that the mind of man
cannot attain the knowledge of which you speak."

The Mason smiled with his gentle fatherly smile.

"The highest wisdom and truth are like the purest liquid we may wish
to imbibe," he said. "Can I receive that pure liquid into an impure
vessel and judge of its purity? Only by the inner purification of
myself can I retain in some degree of purity the liquid I receive."

"Yes, yes, that is so," said Pierre joyfully.

"The highest wisdom is not founded on reason alone, not on those
worldly sciences of physics, history, chemistry, and the like, into
which intellectual knowledge is divided. The highest wisdom is one.
The highest wisdom has but one science--the science of the whole-
the science explaining the whole creation and man's place in it. To
receive that science it is necessary to purify and renew one's inner
self, and so before one can know, it is necessary to believe and to
perfect one's self. And to attain this end, we have the light called
conscience that God has implanted in our souls."

"Yes, yes," assented Pierre.

"Look then at thy inner self with the eyes of the spirit, and ask
thyself whether thou art content with thyself. What hast thou attained
relying on reason only? What art thou? You are young, you are rich,
you are clever, you are well educated. And what have you done with all
these good gifts? Are you content with yourself and with your life?"

"No, I hate my life," Pierre muttered, wincing.

"Thou hatest it. Then change it, purify thyself; and as thou art
purified, thou wilt gain wisdom. Look at your life, my dear sir. How
have you spent it? In riotous orgies and debauchery, receiving
everything from society and giving nothing in return. You have
become the possessor of wealth. How have you used it? What have you
done for your neighbor? Have you ever thought of your tens of
thousands of slaves? Have you helped them physically and morally?
No! You have profited by their toil to lead a profligate life. That is
what you have done. Have you chosen a post in which you might be of
service to your neighbor? No! You have spent your life in idleness.
Then you married, my dear sir--took on yourself responsibility for the
guidance of a young woman; and what have you done? You have not helped
her to find the way of truth, my dear sir, but have thrust her into an
abyss of deceit and misery. A man offended you and you shot him, and
you say you do not know God and hate your life. There is nothing
strange in that, my dear sir!"

After these words, the Mason, as if tired by his long discourse,
again leaned his arms on the back of the sofa and closed his eyes.
Pierre looked at that aged, stern, motionless, almost lifeless face
and moved his lips without uttering a sound. He wished to say, "Yes, a
vile, idle, vicious life!" but dared not break the silence.

The Mason cleared his throat huskily, as old men do, and called
his servant.

"How about the horses?" he asked, without looking at Pierre.

"The exchange horses have just come," answered the servant. "Will
you not rest here?"

"No, tell them to harness."

"Can he really be going away leaving me alone without having told me
all, and without promising to help me?" thought Pierre, rising with
downcast head; and he began to pace the room, glancing occasionally at
the Mason. "Yes, I never thought of it, but I have led a
contemptible and profligate life, though I did not like it and did not
want to," thought Pierre. "But this man knows the truth and, if he
wished to, could disclose it to me."

Pierre wished to say this to the Mason, but did not dare to. The
traveler, having packed his things with his practiced hands, began
fastening his coat. When he had finished, he turned to Bezukhov, and
said in a tone of indifferent politeness:

"Where are you going to now, my dear sir?"

"I?... I'm going to Petersburg," answered Pierre, in a childlike,
hesitating voice. "I thank you. I agree with all you have said. But do
not suppose me to be so bad. With my whole soul I wish to be what
you would have me be, but I have never had help from anyone.... But it
is I, above all, who am to blame for everything. Help me, teach me,
and perhaps I may..."

Pierre could not go on. He gulped and turned away.

The Mason remained silent for a long time, evidently considering.

"Help comes from God alone," he said, "but such measure of help as
our Order can bestow it will render you, my dear sir. You are going to
Petersburg. Hand this to Count Willarski" (he took out his notebook
and wrote a few words on a large sheet of paper folded in four).
"Allow me to give you a piece of advice. When you reach the capital,
first of all devote some time to solitude and self-examination and
do not resume your former way of life. And now I wish you a good
journey, my dear sir," he added, seeing that his servant had
entered... "and success."

The traveler was Joseph Alexeevich Bazdeev, as Pierre saw from the
postmaster's book. Bazdeev had been one of the best-known Freemasons
and Martinists, even in Novikov's time. For a long while after he
had gone, Pierre did not go to bed or order horses but paced up and
down the room, pondering over his vicious past, and with a rapturous
sense of beginning anew pictured to himself the blissful,
irreproachable, virtuous future that seemed to him so easy. It
seemed to him that he had been vicious only because he had somehow
forgotten how good it is to be virtuous. Not a trace of his former
doubts remained in his soul. He firmly believed in the possibility
of the brotherhood of men united in the aim of supporting one
another in the path of virtue, and that is how Freemasonry presented
itself to him.





CHAPTER III


On reaching Petersburg Pierre did not let anyone know of his
arrival, he went nowhere and spent whole days in reading Thomas a
Kempis, whose book had been sent him by someone unknown. One thing
he continually realized as he read that book: the joy, hitherto
unknown to him, of believing in the possibility of attaining
perfection, and in the possibility of active brotherly love among men,
which Joseph Alexeevich had revealed to him. A week after his arrival,
the young Polish count, Willarski, whom Pierre had known slightly in
Petersburg society, came into his room one evening in the official and
ceremonious manner in which Dolokhov's second had called on him,
and, having closed the door behind him and satisfied himself that
there was nobody else in the room, addressed Pierre.

"I have come to you with a message and an offer, Count," he said
without sitting down. "A person of very high standing in our
Brotherhood has made application for you to be received into our Order
before the usual term and has proposed to me to be your sponsor. I
consider it a sacred duty to fulfill that person's wishes. Do you wish
to enter the Brotherhood of Freemasons under my sponsorship?"

 The cold, austere tone of this man, whom he had almost always
before met at balls, amiably smiling in the society of the most
brilliant women, surprised Pierre.

"Yes, I do wish it," said he.

Willarski bowed his head.

"One more question, Count," he said, "which beg you to answer in all
sincerity--not as a future Mason but as an honest man: have you
renounced your former convictions--do you believe in God?"

Pierre considered.

"Yes... yes, I believe in God," he said.

"In that case..." began Willarski, but Pierre interrupted him.

"Yes, I do believe in God," he repeated.

"In that case we can go," said Willarski. "My carriage is at your
service."

Willarski was silent throughout the drive. To Pierre's inquiries
as to what he must do and how he should answer, Willarski only replied
that brothers more worthy than he would test him and that Pierre had
only to tell the truth.

Having entered the courtyard of a large house where the Lodge had
its headquarters, and having ascended a dark staircase, they entered a
small well-lit anteroom where they took off their cloaks without the
aid of a servant. From there they passed into another room. A man in
strange attire appeared at the door. Willarski, stepping toward him,
said something to him in French in an undertone and then went up to
a small wardrobe in which Pierre noticed garments such as he had never
seen before. Having taken a kerchief from the cupboard, Willarski
bound Pierre's eyes with it and tied it in a knot behind, catching
some hairs painfully in the knot. Then he drew his face down, kissed
him, and taking him by the hand led him forward. The hairs tied in the
knot hurt Pierre and there were lines of pain on his face and a
shamefaced smile. His huge figure, with arms hanging down and with a
puckered, though smiling face, moved after Willarski with uncertain,
timid steps.

Having led him about ten paces, Willarski stopped.

"Whatever happens to you," he said, "you must bear it all manfully
if you have firmly resolved to join our Brotherhood." (Pierre nodded
affirmatively.) "When you hear a knock at the door, you will uncover
your eyes," added Willarski. "I wish you courage and success," and,
pressing Pierre's hand, he went out.

Left alone, Pierre went on smiling in the same way. Once or twice he
shrugged his and raised his hand to the kerchief, as if wishing to
take it off, but let it drop again. The five minutes spent with his
eyes bandaged seemed to him an hour. His arms felt numb, his legs
almost gave way, it seemed to him that he was tired out. He
experienced a variety of most complex sensations. He felt afraid of
what would happen to him and still more afraid of showing his fear. He
felt curious to know what was going to happen and what would be
revealed to him; but most of all, he felt joyful that the moment had
come when he would at last start on that path of regeneration and on
the actively virtuous life of which he had been dreaming since he
met Joseph Alexeevich. Loud knocks were heard at the door. Pierre took
the bandage off his eyes and glanced around him. The room was in black
darkness, only a small lamp was burning inside something white. Pierre
went nearer and saw that the lamp stood on a black table on which
lay an open book. The book was the Gospel, and the white thing with
the lamp inside was a human skull with its cavities and teeth. After
reading the first words of the Gospel: "In the beginning was the
Word and the Word was with God," Pierre went round the table and saw a
large open box filled with something. It was a coffin with bones
inside. He was not at all surprised by what he saw. Hoping to enter on
an entirely new life quite unlike the old one, he expected
everything to be unusual, even more unusual than what he was seeing. A
skull, a coffin, the Gospel--it seemed to him that he had expected all
this and even more. Trying to stimulate his emotions he looked around.
"God, death, love, the brotherhood of man," he kept saying to himself,
associating these words with vague yet joyful ideas. The door opened
and someone came in.

By the dim light, to which Pierre had already become accustomed,
he saw rather short man. Having evidently come from the light into the
darkness, the man paused, then moved with cautious steps toward the
table and placed on it his small leather-gloved hands.

This short man had on a white leather apron which covered his
chest and part of his legs; he had on a kind of necklace above which
rose a high white ruffle, outlining his rather long face which was lit
up from below.

"For what have you come hither?" asked the newcomer, turning in
Pierre's direction at a slight rustle made by the latter. "Why have
you, who do not believe in the truth of the light and who have not
seen the light, come here? What do you seek from us? Wisdom, virtue,
enlightenment?"

At the moment the door opened and the stranger came in, Pierre
felt a sense of awe and veneration such as he had experienced in his
boyhood at confession; he felt himself in the presence of one socially
a complete stranger, yet nearer to him through the brotherhood of man.
With bated breath and beating heart he moved toward the Rhetor (by
which name the brother who prepared a seeker for entrance into the
Brotherhood was known). Drawing nearer, he recognized in the Rhetor
a man he knew, Smolyaninov, and it mortified him to think that the
newcomer was an acquaintance--he wished him simply a brother and a
virtuous instructor. For a long time he could not utter a word, so
that the Rhetor had to repeat his question.

"Yes... I... I... desire regeneration," Pierre uttered with
difficulty.

"Very well," said Smolyaninov, and went on at once: "Have you any
idea of the means by which our holy Order will help you to reach
your aim?" said he quietly and quickly.

"I... hope... for guidance... help... in regeneration," said Pierre,
with a trembling voice and some difficulty in utterance due to his
excitement and to being unaccustomed to speak of abstract matters in
Russian.

"What is your conception of Freemasonry?"

"I imagine that Freemasonry is the fraternity and equality of men
who have virtuous aims," said Pierre, feeling ashamed of the
inadequacy of his words for the solemnity of the moment, as he
spoke. "I imagine..."

"Good!" said the Rhetor quickly, apparently satisfied with this
answer. "Have you sought for means of attaining your aim in religion?"

"No, I considered it erroneous and did not follow it," said
Pierre, so softly that the Rhetor did not hear him and asked him
what he was saying. "I have been an atheist," answered Pierre.

"You are seeking for truth in order to follow its laws in your life,
therefore you seek wisdom and virtue. Is that not so?" said the
Rhetor, after a moment's pause.

"Yes, yes," assented Pierre.

The Rhetor cleared his throat, crossed his gloved hands on his
breast, and began to speak.

"Now I must disclose to you the chief aim of our Order," he said,
"and if this aim coincides with yours, you may enter our Brotherhood
with profit. The first and chief object of our Order, the foundation
on which it rests and which no human power can destroy, is the
preservation and handing on to posterity of a certain important
mystery... which has come down to us from the remotest ages, even from
the first man--a mystery on which perhaps the fate of mankind depends.
But since this mystery is of such a nature that nobody can know or use
it unless he be prepared by long and diligent self-purification, not
everyone can hope to attain it quickly. Hence we have a secondary aim,
that of preparing our members as much as possible to reform their
hearts, to purify and enlighten their minds, by means handed on to
us by tradition from those who have striven to attain this mystery,
and thereby to render them capable of receiving it.

"By purifying and regenerating our members we try, thirdly, to
improve the whole human race, offering it in our members an example of
piety and virtue, and thereby try with all our might to combat the
evil which sways the world. Think this over and I will come to you
again."

"To combat the evil which sways the world..." Pierre repeated, and a
mental image of his future activity in this direction rose in his
mind. He imagined men such as he had himself been a fortnight ago, and
he addressed an edifying exhortation to them. He imagined to himself
vicious and unfortunate people whom he would assist by word and
deed, imagined oppressors whose victims he would rescue. Of the
three objects mentioned by the Rhetor, this last, that of improving
mankind, especially appealed to Pierre. The important mystery
mentioned by the Rhetor, though it aroused his curiosity, did not seem
to him essential, and the second aim, that of purifying and
regenerating himself, did not much interest him because at that moment
he felt with delight that he was already perfectly cured of his former
faults and was ready for all that was good.

Half an hour later, the Rhetor returned to inform the seeker of
the seven virtues, corresponding to the seven steps of Solomon's
temple, which every Freemason should cultivate in himself. These
virtues were:  1. Discretion, the keeping of the secrets of the Order.
 2. Obedience to those of higher ranks in the Order.  3. Morality.  4.
Love of mankind.  5. Courage.  6. Generosity.  7. The love of death.

"In the seventh place, try, by the frequent thought of death," the
Rhetor said, "to bring yourself to regard it not as a dreaded foe, but
as a friend that frees the soul grown weary in the labors of virtue
from this distressful life, and leads it to its place of recompense
and peace."

"Yes, that must be so," thought Pierre, when after these words the
Rhetor went away, leaving him to solitary meditation. "It must be
so, but I am still so weak that I love my life, the meaning of which
is only now gradually opening before me." But five of the other
virtues which Pierre recalled, counting them on his fingers, he felt
already in his soul: courage, generosity, morality, love of mankind,
and especially obedience--which did not even seem to him a virtue, but
a joy. (He now felt so glad to be free from his own lawlessness and to
submit his will to those who knew the indubitable truth.) He forgot
what the seventh virtue was and could not recall it.

The third time the Rhetor came back more quickly and asked Pierre
whether he was still firm in his intention and determined to submit to
all that would be required of him.

"I am ready for everything," said Pierre.

"I must also inform you," said the Rhetor, "that our Order
delivers its teaching not in words only but also by other means, which
may perhaps have a stronger effect on the sincere seeker after
wisdom and virtue than mere words. This chamber with what you see
therein should already have suggested to your heart, if it is sincere,
more than words could do. You will perhaps also see in your further
initiation a like method of enlightenment. Our Order imitates the
ancient societies that explained their teaching by hieroglyphics. A
hieroglyph," said the Rhetor, "is an emblem of something not
cognizable by the senses but which possesses qualities resembling
those of the symbol."

Pierre knew very well what a hieroglyph was, but dared not speak. He
listened to the Rhetor in silence, feeling from all he said that his
ordeal was about to begin.

"If you are resolved, I must begin your initiation," said the Rhetor
coming closer to Pierre. "In token of generosity I ask you to give
me all your valuables."

"But I have nothing here," replied Pierre, supposing that he was
asked to give up all he possessed.

"What you have with you: watch, money, rings...."

Pierre quickly took out his purse and watch, but could not manage
for some time to get the wedding ring off his fat finger. When that
had been done, the Rhetor said:

"In token of obedience, I ask you to undress."

Pierre took off his coat, waistcoat, and left boot according to
the Rhetor's instructions. The Mason drew the shirt back from Pierre's
left breast, and stooping down pulled up the left leg of his
trousers to above the knee. Pierre hurriedly began taking off his
right boot also and was going to tuck up the other trouser leg to save
this stranger the trouble, but the Mason told him that was not
necessary and gave him a slipper for his left foot. With a childlike
smile of embarrassment, doubt, and self-derision, which appeared on
his face against his will, Pierre stood with his arms hanging down and
legs apart, before his brother Rhetor, and awaited his further
commands.

"And now, in token of candor, I ask you to reveal to me your chief
passion," said the latter.

"My passion! I have had so many," replied Pierre.

"That passion which more than all others caused you to waver on
the path of virtue," said the Mason.

Pierre paused, seeking a reply.

"Wine? Gluttony? Idleness? Laziness? Irritability? Anger? Women?" He
went over his vices in his mind, not knowing to which of them to
give the pre-eminence.

"Women," he said in a low, scarcely audible voice.

The Mason did not move and for a long time said nothing after this
answer. At last he moved up to Pierre and, taking the kerchief that
lay on the table, again bound his eyes.

"For the last time I say to you--turn all your attention upon
yourself, put a bridle on your senses, and seek blessedness, not in
passion but in your own heart. The source of blessedness is not
without us but within...."

Pierre had already long been feeling in himself that refreshing
source of blessedness which now flooded his heart with glad emotion.





CHAPTER IV


Soon after this there came into the dark chamber to fetch Pierre,
not the Rhetor but Pierre's sponsor, Willarski, whom he recognized
by his voice. To fresh questions as to the firmness of his
resolution Pierre replied: "Yes, yes, I agree," and with a beaming,
childlike smile, his fat chest uncovered, stepping unevenly and
timidly in one slippered and one booted foot, he advanced, while
Willarski held a sword to his bare chest. He was conducted from that
room along passages that turned backwards and forwards and was at last
brought to the doors of the Lodge. Willarski coughed, he was
answered by the Masonic knock with mallets, the doors opened before
them. A bass voice (Pierre was still blindfold) questioned him as to
who he was, when and where he was born, and so on. Then he was again
led somewhere still blindfold, and as they went along he was told
allegories of the toils of his pilgrimage, of holy friendship, of
the Eternal Architect of the universe, and of the courage with which
he should endure toils and dangers. During these wanderings, Pierre
noticed that he was spoken of now as the "Seeker," now as the
"Sufferer," and now as the "Postulant," to the accompaniment of
various knockings with mallets and swords. As he was being led up to
some object he noticed a hesitation and uncertainty among his
conductors. He heard those around him disputing in whispers and one of
them insisting that he should be led along a certain carpet. After
that they took his right hand, placed it on something, and told him to
hold a pair of compasses to his left breast with the other hand and to
repeat after someone who read aloud an oath of fidelity to the laws of
the Order. The candles were then extinguished and some spirit lighted,
as Pierre knew by the smell, and he was told that he would now see the
lesser light. The bandage was taken off his eyes and, by the faint
light of the burning spirit, Pierre, as in a dream, saw several men
standing before him, wearing aprons like the Rhetor's and holding
swords in their hands pointed at his breast. Among them stood a man
whose white shirt was stained with blood. On seeing this, Pierre moved
forward with his breast toward the swords, meaning them to pierce
it. But the swords were drawn back from him and he was at once
blindfolded again.

"Now thou hast seen the lesser light," uttered a voice. Then the
candles were relit and he was told that he would see the full light;
the bandage was again removed and more than ten voices said
together: "Sic transit gloria mundi."

Pierre gradually began to recover himself and looked about at the
room and at the people in it. Round a long table covered with black
sat some twelve men in garments like those he had already seen. Some
of them Pierre had met in Petersburg society. In the President's chair
sat a young man he did not know, with a peculiar cross hanging from
his neck. On his right sat the Italian abbe whom Pierre had met at
Anna Pavlovna's two years before. There were also present a very
distinguished dignitary and a Swiss who had formerly been tutor at the
Kuragins'. All maintained a solemn silence, listening to the words
of the President, who held a mallet in his hand. Let into the wall was
a star-shaped light. At one side of the table was a small carpet
with various figures worked upon it, at the other was something
resembling an altar on which lay a Testament and a skull. Round it
stood seven large candlesticks like those used in churches. Two of the
brothers led Pierre up to the altar, placed his feet at right
angles, and bade him lie down, saying that he must prostrate himself
at the Gates of the Temple.

"He must first receive the trowel," whispered one of the brothers.

"Oh, hush, please!" said another.

Pierre, perplexed, looked round with his shortsighted eyes without
obeying, and suddenly doubts arose in his mind. "Where am I? What am I
doing? Aren't they laughing at me? Shan't I be ashamed to remember
this?" But these doubts only lasted a moment. Pierre glanced at the
serious faces of those around, remembered all he had already gone
through, and realized that he could not stop halfway. He was aghast at
his hesitation and, trying to arouse his former devotional feeling,
prostrated himself before the Gates of the Temple. And really, the
feeling of devotion returned to him even more strongly than before.
When he had lain there some time, he was told to get up, and a white
leather apron, such as the others wore, was put on him: he was given a
trowel and three pairs of gloves, and then the Grand Master
addressed him. He told him that he should try to do nothing to stain
the whiteness of that apron, which symbolized strength and purity;
then of the unexplained trowel, he told him to toil with it to cleanse
his own heart from vice, and indulgently to smooth with it the heart
of his neighbor. As to the first pair of gloves, a man's, he said that
Pierre could not know their meaning but must keep them. The second
pair of man's gloves he was to wear at the meetings, and finally of
the third, a pair of women's gloves, he said: "Dear brother, these
woman's gloves are intended for you too. Give them to the woman whom
you shall honor most of all. This gift will be a pledge of your purity
of heart to her whom you select to be your worthy helpmeet in
Masonry." And after a pause, he added: "But beware, dear brother, that
these gloves do not deck hands that are unclean." While the Grand
Master said these last words it seemed to Pierre that he grew
embarrassed. Pierre himself grew still more confused, blushed like a
child till tears came to his eyes, began looking about him uneasily,
and an awkward pause followed.

This silence was broken by one of the brethren, who led Pierre up to
the rug and began reading to him from a manuscript book an explanation
of all the figures on it: the sun, the moon, a hammer, a plumb line, a
trowel, a rough stone and a squared stone, a pillar, three windows,
and so on. Then a place was assigned to Pierre, he was shown the signs
of the Lodge, told the password, and at last was permitted to sit
down. The Grand Master began reading the statutes. They were very
long, and Pierre, from joy, agitation, and embarrassment, was not in a
state to understand what was being read. He managed to follow only the
last words of the statutes and these remained in his mind.

"In our temples we recognize no other distinctions," read the
Grand Master, "but those between virtue and vice. Beware of making any
distinctions which may infringe equality. Fly to a brother's aid
whoever he may be, exhort him who goeth astray, raise him that
falleth, never bear malice or enmity toward thy brother. Be kindly and
courteous. Kindle in all hearts the flame of virtue. Share thy
happiness with thy neighbor, and may envy never dim the purity of that
bliss. Forgive thy enemy, do not avenge thyself except by doing him
good. Thus fulfilling the highest law thou shalt regain traces of
the ancient dignity which thou hast lost."

He finished and, getting up, embraced and kissed Pierre, who, with
tears of joy in his eyes, looked round him, not knowing how to
answer the congratulations and greetings from acquaintances that met
him on all sides. He acknowledged no acquaintances but saw in all
these men only brothers, and burned with impatience to set to work
with them.

The Grand Master rapped with his mallet. All the Masons sat down
in their places, and one of them read an exhortation on the
necessity of humility.

The Grand Master proposed that the last duty should be performed,
and the distinguished dignitary who bore the title of "Collector of
Alms" went round to all the brothers. Pierre would have liked to
subscribe all he had, but fearing that it might look like pride
subscribed the same amount as the others.

The meeting was at an end, and on reaching home Pierre felt as if he
had returned from a long journey on which he had spent dozens of
years, had become completely changed, and had quite left behind his
former habits and way of life.





CHAPTER V


The day after he had been received into the Lodge, Pierre was
sitting at home reading a book and trying to fathom the significance
of the Square, one side of which symbolized God, another moral things,
a third physical things, and the fourth a combination of these. Now
and then his attention wandered from the book and the Square and he
formed in imagination a new plan of life. On the previous evening at
the Lodge, he had heard that a rumor of his duel had reached the
Emperor and that it would be wiser for him to leave Petersburg. Pierre
proposed going to his estates in the south and there attending to
the welfare of his serfs. He was joyfully planning this new life, when
Prince Vasili suddenly entered the room.

"My dear fellow, what have you been up to in Moscow? Why have you
quarreled with Helene, mon cher? You are under a delusion," said
Prince Vasili, as he entered. "I know all about it, and I can tell you
positively that Helene is as innocent before you as Christ was
before the Jews."

Pierre was about to reply, but Prince Vasili interrupted him.

"And why didn't you simply come straight to me as to a friend? I
know all about it and understand it all," he said. "You behaved as
becomes a man values his honor, perhaps too hastily, but we won't go
into that. But consider the position in which you are placing her
and me in the eyes of society, and even of the court," he added,
lowering his voice. "She is living in Moscow and you are here.
Remember, dear boy," and he drew Pierre's arm downwards, "it is simply
a misunderstanding. I expect you feel it so yourself. Let us write her
a letter at once, and she'll come here and all will be explained, or
else, my dear boy, let me tell you it's quite likely you'll have to
suffer for it."

Prince Vasili gave Pierre a significant look.

"I know from reliable sources that the Dowager Empress is taking a
keen interest in the whole affair. You know she is very gracious to
Helene."

Pierre tried several times to speak, but, on one hand, Prince Vasili
did not let him and, on the other, Pierre himself feared to begin to
speak in the tone of decided refusal and disagreement in which he
had firmly resolved to answer his father-in-law. Moreover, the words
of the Masonic statutes, "be kindly and courteous," recurred to him.
He blinked, went red, got up and sat down again, struggling with
himself to do what was for him the most difficult thing in life--to
say an unpleasant thing to a man's face, to say what the other,
whoever he might be, did not expect. He was so used to submitting to
Prince Vasili's tone of careless self-assurance that he felt he
would be unable to withstand it now, but he also felt that on what
he said now his future depended--whether he would follow the same
old road, or that new path so attractively shown him by the Masons, on
which he firmly believed he would be reborn to a new life.

"Now, dear boy," said Prince Vasili playfully, "say 'yes,' and
I'll write to her myself, and we will kill the fatted calf."

But before Prince Vasili had finished his playful speech, Pierre,
without looking at him, and with a kind of fury that made him like his
father, muttered in a whisper:

"Prince, I did not ask you here. Go, please go!" And he jumped up
and opened the door for him.

"Go!" he repeated, amazed at himself and glad to see the look of
confusion and fear that showed itself on Prince Vasili's face.

"What's the matter with you? Are you ill?"

"Go!" the quivering voice repeated. And Prince Vasili had to go
without receiving any explanation.

A week later, Pierre, having taken leave of his new friends, the
Masons, and leaving large sums of money with them for alms, went
away to his estates. His new brethren gave him letters to the Kiev and
Odessa Masons and promised to write to him and guide him in his new
activity.





CHAPTER VI


The duel between Pierre and Dolokhov was hushed up and, in spite
of the Emperor's severity regarding duels at that time, neither the
principals nor their seconds suffered for it. But the story of the
duel, confirmed by Pierre's rupture with his wife, was the talk of
society. Pierre who had been regarded with patronizing condescension
when he was an illegitimate son, and petted and extolled when he was
the best match in Russia, had sunk greatly in the esteem of society
after his marriage--when the marriageable daughters and their
mothers had nothing to hope from him--especially as he did not know
how, and did not wish, to court society's favor. Now he alone was
blamed for what had happened, he was said to be insanely jealous and
subject like his father to fits of bloodthirsty rage. And when after
Pierre's departure Helene returned to Petersburg, she was received
by all her acquaintances not only cordially, but even with a shade
of deference due to her misfortune. When conversation turned on her
husband Helene assumed a dignified expression, which with
characteristic tact she had acquired though she did not understand its
significance. This expression suggested that she had resolved to
endure her troubles uncomplainingly and that her husband was a cross
laid upon her by God. Prince Vasili expressed his opinion more openly.
He shrugged his shoulders when Pierre was mentioned and, pointing to
his forehead, remarked:

"A bit touched--I always said so."

"I said from the first," declared Anna Pavlovna referring to Pierre,
"I said at the time and before anyone else" (she insisted on her
priority) "that that senseless young man was spoiled by the depraved
ideas of these days. I said so even at the time when everybody was
in raptures about him, when he had just returned from abroad, and
when, if you remember, he posed as a sort of Marat at one of my
soirees. And how has it ended? I was against this marriage even then
and foretold all that has happened."

Anna Pavlovna continued to give on free evenings the same kind of
soirees as before--such as she alone had the gift of arranging--at
which was to be found "the cream of really good society, the bloom
of the intellectual essence of Petersburg," as she herself put it.
Besides this refined selection of society Anna Pavlovna's receptions
were also distinguished by the fact that she always presented some new
and interesting person to the visitors and that nowhere else was the
state of the political thermometer of legitimate Petersburg court
society so dearly and distinctly indicated.

Toward the end of 1806, when all the sad details of Napoleon's
destruction of the Prussian army at Jena and Auerstadt and the
surrender of most of the Prussian fortresses had been received, when
our troops had already entered Prussia and our second war with
Napoleon was beginning, Anna Pavlovna gave one of her soirees. The
"cream of really good society" consisted of the fascinating Helene,
forsaken by her husband, Mortemart, the delightful Prince Hippolyte
who had just returned from Vienna, two diplomatists, the old aunt, a
young man referred to in that drawing room as "a man of great merit"
(un homme de beaucoup de merite), a newly appointed maid of honor
and her mother, and several other less noteworthy persons.

The novelty Anna Pavlovna was setting before her guests that evening
was Boris Drubetskoy, who had just arrived as a special messenger from
the Prussian army and was aide-de-camp to a very important personage.

The temperature shown by the political thermometer to the company
that evening was this:

"Whatever the European sovereigns and commanders may do to
countenance Bonaparte, and to cause me, and us in general, annoyance
and mortification, our opinion of Bonaparte cannot alter. We shall not
cease to express our sincere views on that subject, and can only say
to the King Prussia and others: 'So much the worse for you. Tu l'as
voulu, George Dandin,' that's all we have to say about it!"

When Boris, who was to be served up to the guests, entered the
drawing room, almost all the company had assembled, and the
conversation, guided by Anna Pavlovna, was about our diplomatic
relations with Austria and the hope of an alliance with her.

Boris, grown more manly and looking fresh, rosy and
self-possessed, entered the drawing room elegantly dressed in the
uniform of an aide-de-camp and was duly conducted to pay his
respects to the aunt and then brought back to the general circle.

Anna Pavlovna gave him her shriveled hand to kiss and introduced him
to several persons whom he did not know, giving him a whispered
description of each.

"Prince Hippolyte Kuragin, M. Krug, the charge d'affaires from 
Copenhagen--a profound intellect," and simply, "Mr. Shitov--a 
man of great merit"--this of the man usually so described.

Thanks to Anna Mikhaylovna's efforts, his own tastes, and the
peculiarities of his reserved nature, Boris had managed during his
service to place himself very advantageously. He was aide-de-camp to a
very important personage, had been sent on a very important mission to
Prussia, and had just returned from there as a special messenger. He
had become thoroughly conversant with that unwritten code with which
he had been so pleased at Olmutz and according to which an ensign
might rank incomparably higher than a general, and according to
which what was needed for success in the service was not effort or
work, or courage, or perseverance, but only the knowledge of how to
get on with those who can grant rewards, and he was himself often
surprised at the rapidity of his success and at the inability of
others to understand these things. In consequence of this discovery
his whole manner of life, all his relations with old friends, all
his plans for his future, were completely altered. He was not rich,
but would spend his last groat to be better dressed than others, and
would rather deprive himself of many pleasures than allow himself to
be seen in a shabby equipage or appear in the streets of Petersburg in
an old uniform. He made friends with and sought the acquaintance of
only those above him in position and who could therefore be of use
to him. He liked Petersburg and despised Moscow. The remembrance of
the Rostovs' house and of his childish love for Natasha was unpleasant
to him and he had not once been to see the Rostovs since the day of
his departure for the army. To be in Anna Pavlovna's drawing room he
considered an important step up in the service, and he at once
understood his role, letting his hostess make use of whatever interest
he had to offer. He himself carefully scanned each face, appraising
the possibilities of establishing intimacy with each of those present,
and the advantages that might accrue. He took the seat indicated to
him beside the fair Helene and listened to the general conversation.

"Vienna considers the bases of the proposed treaty so unattainable
that not even a continuity of most brilliant successes would secure
them, and she doubts the means we have of gaining them. That is the
actual phrase used by the Vienna cabinet," said the Danish charge
d'affaires.

"The doubt is flattering," said "the man of profound intellect,"
with a subtle smile.

"We must distinguish between the Vienna cabinet and the Emperor of
Austria," said Mortemart. "The Emperor of Austria can never have
thought of such a thing, it is only the cabinet that says it."

"Ah, my dear vicomte," put in Anna Pavlovna, "L'Urope" (for some
reason she called it Urope as if that were a specially refined
French pronunciation which she could allow herself when conversing
with a Frenchman), "L'Urope ne sera jamais notre alliee sincere."*


*"Europe will never be our sincere ally."


After that Anna Pavlovna led up to the courage and firmness of the
King of Prussia, in order to draw Boris into the conversation.

Boris listened attentively to each of the speakers, awaiting his
turn, but managed meanwhile to look round repeatedly at his
neighbor, the beautiful Helene, whose eyes several times met those
of the handsome young aide-de-camp with a smile.

Speaking of the position of Prussia, Anna Pavlovna very naturally
asked Boris to tell them about his journey to Glogau and in what state
he found the Prussian army. Boris, speaking with deliberation, told
them in pure, correct French many interesting details about the armies
and the court, carefully abstaining from expressing an opinion of
his own about the facts he was recounting. For some time he
engrossed the general attention, and Anna Pavlovna felt that the
novelty she had served up was received with pleasure by all her
visitors. The greatest attention of all to Boris' narrative was
shown by Helene. She asked him several questions about his journey and
seemed greatly interested in the state of the Prussian army. As soon
as he had finished she turned to him with her usual smile.

"You absolutely must come and see me," she said in a tone that
implied that, for certain considerations he could not know of, this
was absolutely necessary.

"On Tuesday between eight and nine. It will give me great pleasure."

Boris promised to fulfill her wish and was about to begin a
conversation with her, when Anna Pavlovna called him away on the
pretext that her aunt wished to hear him.

"You know her husband, of course?" said Anna Pavlovna, closing her
eyes and indicating Helene with a sorrowful gesture. "Ah, she is
such an unfortunate and charming woman! Don't mention him before
her--please don't! It is too painful for her!"





CHAPTER VII


When Boris and Anna Pavlovna returned to the others Prince Hippolyte
had the ear of the company.

Bending forward in his armchair he said: "Le Roi de Prusse!" and
having said this laughed. Everyone turned toward him.

"Le Roi de Prusse?" Hippolyte said interrogatively, again
laughing, and then calmly and seriously sat back in his chair. Anna
Pavlovna waited for him to go on, but as he seemed quite decided to
say no more she began to tell of how at Potsdam the impious
Bonaparte had stolen the sword of Frederick the Great.

"It is the sword of Frederick the Great which I..." she began, but
Hippolyte interrupted her with the words: "Le Roi de Prusse..." and
again, as soon as all turned toward him, excused himself and
said no more.

Anna Pavlovna frowned. Mortemart, Hippolyte's friend, addressed
him firmly.

"Come now, what about your Roi de Prusse?"

Hippolyte laughed as if ashamed of laughing.

"Oh, it's nothing. I only wished to say..." (he wanted to repeat a
joke he had heard in Vienna and which he had been trying all that
evening to get in) "I only wished to say that we are wrong to fight
pour le Roi de Prusse!"

Boris smiled circumspectly, so that it might be taken as ironical or
appreciative according to the way the joke was received. Everybody
laughed.

"Your joke is too bad, it's witty but unjust," said Anna Pavlovna,
shaking her little shriveled finger at him.

"We are not fighting pour le Roi de Prusse, but for right
principles. Oh, that wicked Prince Hippolyte!" she said.

The conversation did not flag all evening and turned chiefly on
the political news. It became particularly animated toward the end
of the evening when the rewards bestowed by the Emperor were
mentioned.

"You know N--N--received a snuffbox with the portrait last year?"
said "the man of profound intellect." "Why shouldn't S--S--get the
same distinction?"

"Pardon me! A snuffbox with the Emperor's portrait is a reward but
not a distinction," said the diplomatist--"a gift, rather."

"There are precedents, I may mention Schwarzenberg."

"It's impossible," replied another.

"Will you bet? The ribbon of the order is a different matter...."

When everybody rose to go, Helene who had spoken very little all the
evening again turned to Boris, asking him in a tone of caressing
significant command to come to her on Tuesday.

"It is of great importance to me," she said, turning with a smile
toward Anna Pavlovna, and Anna Pavlovna, with the same sad smile
with which she spoke of her exalted patroness, supported Helene's
wish.

It seemed as if from some words Boris had spoken that evening
about the Prussian army, Helene had suddenly found it necessary to see
him. She seemed to promise to explain that necessity to him when he
came on Tuesday.

But on Tuesday evening, having come to Helene's splendid salon,
Boris received no clear explanation of why it had been necessary for
him to come. There were other guests and the countess talked little to
him, and only as he kissed her hand on taking leave said
unexpectedly and in a whisper, with a strangely unsmiling face:
"Come to dinner tomorrow... in the evening. You must come.... Come!"

During that stay in Petersburg, Boris became an intimate in the
countess' house.





CHAPTER VIII


The war was flaming up and nearing the Russian frontier.
Everywhere one heard curses on Bonaparte, "the enemy of mankind."
Militiamen and recruits were being enrolled in the villages, and
from the seat of war came contradictory news, false as usual and
therefore variously interpreted. The life of old Prince Bolkonski,
Prince Andrew, and Princess Mary had greatly changed since 1805.

In 1806 the old prince was made one of the eight commanders in chief
then appointed to supervise the enrollment decreed throughout
Russia. Despite the weakness of age, which had become particularly
noticeable since the time when he thought his son had been killed,
he did not think it right to refuse a duty to which he had been
appointed by the Emperor himself, and this fresh opportunity for
action gave him new energy and strength. He was continually
traveling through the three provinces entrusted to him, was pedantic
in the fulfillment of his duties, severe to cruelty with his
subordinates, and went into everything down to the minutest details
himself. Princess Mary had ceased taking lessons in mathematics from
her father, and when the old prince was at home went to his study with
the wet nurse and little Prince Nicholas (as his grandfather called
him). The baby Prince Nicholas lived with his wet nurse and nurse
Savishna in the late princess' rooms and Princess Mary spent most of
the day in the nursery, taking a mother's place to her little nephew
as best she could. Mademoiselle Bourienne, too, seemed passionately
fond of the boy, and Princess Mary often deprived herself to give
her friend the pleasure of dandling the little angel--as she called
her nephew--and playing with him.

Near the altar of the church at Bald Hills there was a chapel over
the tomb of the little princess, and in this chapel was a marble
monument brought from Italy, representing an angel with outspread
wings ready to fly upwards. The angel's upper lip was slightly
raised as though about to smile, and once on coming out of the
chapel Prince Andrew and Princess Mary admitted to one another that
the angel's face reminded them strangely of the little princess. But
what was still stranger, though of this Prince Andrew said nothing
to his sister, was that in the expression the sculptor had happened to
give the angel's face, Prince Andrew read the same mild reproach he
had read on the face of his dead wife: "Ah, why have you done this
to me?"

Soon after Prince Andrew's return the old prince made over to him
a large estate, Bogucharovo, about twenty-five miles from Bald
Hills. Partly because of the depressing memories associated with
Bald Hills, partly because Prince Andrew did not always feel equal
to bearing with his father's peculiarities, and partly because he
needed solitude, Prince Andrew made use of Bogucharovo, began building
and spent most of his time there.

After the Austerlitz campaign Prince Andrew had firmly resolved
not to continue his military service, and when the war recommenced and
everybody had to serve, he took a post under his father in the
recruitment so as to avoid active service. The old prince and his
son seemed to have changed roles since the campaign of 1805. The old
man, roused by activity, expected the best results from the new
campaign, while Prince Andrew on the contrary, taking no part in the
war and secretly regretting this, saw only the dark side.

On February 26, 1807, the old prince set off on one of his circuits.
Prince Andrew remained at Bald Hills as usual during his father's
absence. Little Nicholas had been unwell for four days. The coachman
who had driven the old prince to town returned bringing papers and
letters for Prince Andrew.

Not finding the young prince in his study the valet went with the
letters to Princess Mary's apartments, but did not find him there.
He was told that the prince had gone to the nursery.

"If you please, your excellency, Petrusha has brought some
papers," said one of the nursemaids to Prince Andrew who was sitting
on a child's little chair while, frowning and with trembling hands, he
poured drops from a medicine bottle into a wineglass half full of
water.

"What is it?" he said crossly, and, his hand shaking
unintentionally, he poured too many drops into the glass. He threw the
mixture onto the floor and asked for some more water. The maid brought
it.

There were in the room a child's cot, two boxes, two armchairs, a
table, a child's table, and the little chair on which Prince Andrew
was sitting. The curtains were drawn, and a single candle was
burning on the table, screened by a bound music book so that the light
did not fall on the cot.

"My dear," said Princess Mary, addressing her brother from beside
the cot where she was standing, "better wait a bit... later..."

"Oh, leave off, you always talk nonsense and keep putting things
off--and this is what comes of it!" said Prince Andrew in an
exasperated whisper, evidently meaning to wound his sister.

"My dear, really... it's better not to wake him... he's asleep,"
said the princess in a tone of entreaty.

Prince Andrew got up and went on tiptoe up to the little bed,
wineglass in hand.

"Perhaps we'd really better not wake him," he said hesitating.

"As you please... really... I think so... but as you please," said
Princess Mary, evidently intimidated and confused that her opinion had
prevailed. She drew her brother's attention to the maid who was
calling him in a whisper.

It was the second night that neither of them had slept, watching the
boy who was in a high fever. These last days, mistrusting their
household doctor and expecting another for whom they had sent to town,
they had been trying first one remedy and then another. Worn out by
sleeplessness and anxiety they threw their burden of sorrow on one
another and reproached and disputed with each other.

"Petrusha has come with papers from your father," whispered the
maid.

Prince Andrew went out.

"Devil take them!" he muttered, and after listening to the verbal
instructions his father had sent and taking the correspondence and his
father's letter, he returned to the nursery.

"Well?" he asked.

"Still the same. Wait, for heaven's sake. Karl Ivanich always says
that sleep is more important than anything," whispered Princess Mary
with a sigh.

Prince Andrew went up to the child and felt him. He was burning hot.

"Confound you and your Karl Ivanich!" He took the glass with the
drops and again went up to the cot.

"Andrew, don't!" said Princess Mary.

But he scowled at her angrily though also with suffering in his
eyes, and stooped glass in hand over the infant.

"But I wish it," he said. "I beg you--give it him!"

Princess Mary shrugged her shoulders but took the glass submissively
and calling the nurse began giving the medicine. The child screamed
hoarsely. Prince Andrew winced and, clutching his head, went out and
sat down on a sofa in the next room.

He still had all the letters in his hand. Opening them
mechanically he began reading. The old prince, now and then using
abbreviations, wrote in his large elongated hand on blue paper as
follows:


Have just this moment received by special messenger very joyful
news--if it's not false. Bennigsen seems to have obtained a complete
victory over Buonaparte at Eylau. In Petersburg everyone is rejoicing,
and the rewards sent to the army are innumerable. Though he is a
German--I congratulate him! I can't make out what the commander at
Korchevo--a certain Khandrikov--is up to; till now the additional
men and provisions have not arrived. Gallop off to him at once and say
I'll have his head off if everything is not here in a week. Have
received another letter about the Preussisch-Eylau battle from
Petenka--he took part in it--and it's all true. When mischief-makers
don't meddle even a German beats Buonaparte. He is said to be
fleeing in great disorder. Mind you gallop off to Korchevo without
delay and carry out instructions!


Prince Andrew sighed and broke the seal of another envelope. It
was a closely written letter of two sheets from Bilibin. He folded
it up without reading it and reread his father's letter, ending with
the words: "Gallop off to Korchevo and carry out instructions!"

"No, pardon me, I won't go now till the child is better," thought
he, going to the door and looking into the nursery.

Princess Mary was still standing by the cot, gently rocking the
baby.

"Ah yes, and what else did he say that's unpleasant?" thought Prince
Andrew, recalling his father's letter. "Yes, we have gained a
victory over Bonaparte, just when I'm not serving. Yes, yes, he's
always poking fun at me.... Ah, well! Let him!" And he began reading
Bilibin's letter which was written in French. He read without
understanding half of it, read only to forget, if but for a moment,
what he had too long been thinking of so painfully to the exclusion of
all else.





CHAPTER IX


Bilibin was now at army headquarters in a diplomatic capacity, and
though he wrote in French and used French jests and French idioms,
he described the whole campaign with a fearless self-censure and
self-derision genuinely Russian. Bilibin wrote that the obligation
of diplomatic discretion tormented him, and he was happy to have in
Prince Andrew a reliable correspondent to whom he could pour out the
bile he had accumulated at the sight of all that was being done in the
army. The letter was old, having been written before the battle at
Preussisch-Eylau.

"Since the day of our brilliant success at Austerlitz," wrote
Bilibin, "as you know, my dear prince, I never leave headquarters. I
have certainly acquired a taste for war, and it is just as well for
me; what I have seen during these last three months is incredible.

"I begin ab ovo. 'The enemy of the human race,' as you know, attacks
the Prussians. The Prussians are our faithful allies who have only
betrayed us three times in three years. We take up their cause, but it
turns out that 'the enemy of the human race' pays no heed to our
fine speeches and in his rude and savage way throws himself on the
Prussians without giving them time to finish the parade they had
begun, and in two twists of the hand he breaks them to smithereens and
installs himself in the palace at Potsdam.

"'I most ardently desire,' writes the King of Prussia to
Bonaparte, 'that Your Majesty should be received and treated in my
palace in a manner agreeable to yourself, and in so far as
circumstances allowed, I have hastened to take all steps to that
end. May I have succeeded!' The Prussian generals pride themselves
on being polite to the French and lay down their arms at the first
demand.

"The head of the garrison at Glogau, with ten thousand men, asks the
King of Prussia what he is to do if he is summoned to surrender....
All this is absolutely true.

"In short, hoping to settle matters by taking up a warlike attitude,
it turns out that we have landed ourselves in war, and what is more,
in war on our own frontiers, with and for the King of Prussia. We have
everything in perfect order, only one little thing is lacking, namely,
a commander in chief. As it was considered that the Austerlitz success
might have been more decisive had the commander in chief not been so
young, all our octogenarians were reviewed, and of Prozorovski and
Kamenski the latter was preferred. The general comes to us,
Suvorov-like, in a kibitka, and is received with acclamations of joy
and triumph.

"On the 4th, the first courier arrives from Petersburg. The mails
are taken to the field marshal's room, for he likes to do everything
himself. I am called in to help sort the letters and take those
meant for us. The field marshal looks on and waits for letters
addressed to him. We search, but none are to be found. The field
marshal grows impatient and sets to work himself and finds letters
from the Emperor to Count T., Prince V., and others. Then he bursts
into one of his wild furies and rages at everyone and everything,
seizes the letters, opens them, and reads those from the Emperor
addressed to others. 'Ah! So that's the way they treat me! No
confidence in me! Ah, ordered to keep an eye on me! Very well then!
Get along with you!' So he writes the famous order of the day to
General Bennigsen:

'I am wounded and cannot ride and consequently cannot command the
army. You have brought your army corps to Pultusk, routed: here it
is exposed, and without fuel or forage, so something must be done,
and, as you yourself reported to Count Buxhowden yesterday, you must
think of retreating to our frontier--which do today.'

"'From all my riding,' he writes to the Emperor, 'I have got a
saddle sore which, coming after all my previous journeys, quite
prevents my riding and commanding so vast an army, so I have passed on
the command to the general next in seniority, Count Buxhowden,
having sent him my whole staff and all that belongs to it, advising
him if there is a lack of bread, to move farther into the interior
of Prussia, for only one day's ration of bread remains, and in some
regiments none at all, as reported by the division commanders,
Ostermann and Sedmoretzki, and all that the peasants had has been
eaten up. I myself will remain in hospital at Ostrolenka till I
recover. In regard to which I humbly submit my report, with the
information that if the army remains in its present bivouac another
fortnight there will not be a healthy man left in it by spring.

"'Grant leave to retire to his country seat to an old man who is
already in any case dishonored by being unable to fulfill the great
and glorious task for which he was chosen. I shall await your most
gracious permission here in hospital, that I may not have to play
the part of a secretary rather than commander in the army. My
removal from the army does not produce the slightest stir--a blind man
has left it. There are thousands such as I in Russia.'

"The field marshal is angry with the Emperor and he punishes us all,
isn't it logical?

"This is the first act. Those that follow are naturally increasingly
interesting and entertaining. After the field marshal's departure it
appears that we are within sight of the enemy and must give battle.
Buxhowden is commander in chief by seniority, but General Bennigsen
does not quite see it; more particularly as it is he and his corps who
are within sight of the enemy and he wishes to profit by the
opportunity to fight a battle 'on his own hand' as the Germans say. He
does so. This is the battle of Pultusk, which is considered a great
victory but in my opinion was nothing of the kind. We civilians, as
you know, have a very bad way of deciding whether a battle was won
or lost. Those who retreat after a battle have lost it is what we say;
and according to that it is we who lost the battle of Pultusk. In
short, we retreat after the battle but send a courier to Petersburg
with news of a victory, and General Bennigsen, hoping to receive
from Petersburg the post of commander in chief as a reward for his
victory, does not give up the command of the army to General
Buxhowden. During this interregnum we begin a very original and
interesting series of maneuvers. Our aim is no longer, as it should
be, to avoid or attack the enemy, but solely to avoid General
Buxhowden who by right of seniority should be our chief. So
energetically do we pursue this aim that after crossing an
unfordable river we burn the bridges to separate ourselves from our
enemy, who at the moment is not Bonaparte but Buxhowden. General
Buxhowden was all but attacked and captured by a superior enemy
force as a result of one of these maneuvers that enabled us to
escape him. Buxhowden pursues us--we scuttle. He hardly crosses the
river to our side before we recross to the other. At last our enemy.
Buxhowden, catches us and attacks. Both generals are angry, and the
result is a challenge on Buxhowden's part and an epileptic fit on
Bennigsen's. But at the critical moment the courier who carried the
news of our victory at Pultusk to Petersburg returns bringing our
appointment as commander in chief, and our first foe, Buxhowden, is
vanquished; we can now turn our thoughts to the second, Bonaparte. But
as it turns out, just at that moment a third enemy rises before us-
namely the Orthodox Russian soldiers, loudly demanding bread, meat,
biscuits, fodder, and whatnot! The stores are empty, the roads
impassable. The Orthodox begin looting, and in a way of which our last
campaign can give you no idea. Half the regiments form bands and scour
the countryside and put everything to fire and sword. The
inhabitants are totally ruined, the hospitals overflow with sick,
and famine is everywhere. Twice the marauders even attack our
headquarters, and the commander in chief has to ask for a battalion to
disperse them. During one of these attacks they carried off my empty
portmanteau and my dressing gown. The Emperor proposes to give all
commanders of divisions the right to shoot marauders, but I much
fear this will oblige one half the army to shoot the other."

At first Prince Andrew read with his eyes only, but after a while,
in spite of himself (although he knew how far it was safe to trust
Bilibin), what he had read began to interest him more and more. When
he had read thus far, he crumpled the letter up and threw it away.
It was not what he had read that vexed him, but the fact that the life
out there in which he had now no part could perturb him. He shut his
eyes, rubbed his forehead as if to rid himself of all interest in what
he had read, and listened to what was passing in the nursery. Suddenly
he thought he heard a strange noise through the door. He was seized
with alarm lest something should have happened to the child while he
was reading the letter. He went on tiptoe to the nursery door and
opened it.

Just as he went in he saw that the nurse was hiding something from
him with a scared look and that Princess Mary was no longer by the
cot.

"My dear," he heard what seemed to him her despairing whisper behind
him.

As often happens after long sleeplessness and long anxiety, he was
seized by an unreasoning panic--it occurred to him that the child
was dead. All that he saw and heard seemed to confirm this terror.

"All is over," he thought, and a cold sweat broke out on his
forehead. He went to the cot in confusion, sure that he would find
it empty and that the nurse had been hiding the dead baby. He drew the
curtain aside and for some time his frightened, restless eyes could
not find the baby. At last he saw him: the rosy boy had tossed about
till he lay across the bed with his head lower than the pillow, and
was smacking his lips in his sleep and breathing evenly.

Prince Andrew was as glad to find the boy like that, as if he had
already lost him. He bent over him and, as his sister had taught
him, tried with his lips whether the child was still feverish. The
soft forehead was moist. Prince Andrew touched the head with his hand;
even the hair was wet, so profusely had the child perspired. He was
not dead, but evidently the crisis was over and he was convalescent.
Prince Andrew longed to snatch up, to squeeze, to hold to his heart,
this helpless little creature, but dared not do so. He stood over him,
gazing at his head and at the little arms and legs which showed
under the blanket. He heard a rustle behind him and a shadow
appeared under the curtain of the cot. He did not look round, but
still gazing at the infant's face listened to his regular breathing.
The dark shadow was Princess Mary, who had come up to the cot with
noiseless steps, lifted the curtain, and dropped it again behind
her. Prince Andrew recognized her without looking and held out his
hand to her. She pressed it.

"He has perspired," said Prince Andrew.

"I was coming to tell you so."

The child moved slightly in his sleep, smiled, and rubbed his
forehead against the pillow.

Prince Andrew looked at his sister. In the dim shadow of the curtain
her luminous eyes shone more brightly than usual from the tears of joy
that were in them. She leaned over to her brother and kissed him,
slightly catching the curtain of the cot. Each made the other a
warning gesture and stood still in the dim light beneath the curtain
as if not wishing to leave that seclusion where they three were shut
off from all the world. Prince Andrew was the first to move away,
ruffling his hair against the muslin of the curtain.

"Yes, this is the one thing left me now," he said with a sigh.




CHAPTER X


Soon after his admission to the Masonic Brotherhood, Pierre went
to the Kiev province, where he had the greatest number of serfs,
taking with him full directions which he had written down for his
own guidance as to what he should do on his estates.

When he reached Kiev he sent for all his stewards to the head office
and explained to them his intentions and wishes. He told them that
steps would be taken immediately to free his serfs--and that till then
they were not to be overburdened with labor, women while nursing their
babies were not to be sent to work, assistance was to be given to
the serfs, punishments were to be admonitory and not corporal, and
hospitals, asylums, and schools were to be established on all the
estates. Some of the stewards (there were semiliterate foremen among
them) listened with alarm, supposing these words to mean that the
young count was displeased with their management and embezzlement of
money, some after their first fright were amused by Pierre's lisp
and the new words they had not heard before, others simply enjoyed
hearing how the master talked, while the cleverest among them,
including the chief steward, understood from this speech how they
could best handle the master for their own ends.

The chief steward expressed great sympathy with Pierre's intentions,
but remarked that besides these changes it would be necessary to go
into the general state of affairs which was far from satisfactory.

Despite Count Bezukhov's enormous wealth, since he had come into
an income which was said to amount to five hundred thousand rubles a
year, Pierre felt himself far poorer than when his father had made him
an allowance of ten thousand rubles. He had a dim perception of the
following budget:

About 80,000 went in payments on all the estates to the Land Bank,
about 30,000 went for the upkeep of the estate near Moscow, the town
house, and the allowance to the three princesses; about 15,000 was
given in pensions and the same amount for asylums; 150,000 alimony was
sent to the countess; about 70,00 went for interest on debts. The
building of a new church, previously begun, had cost about 10,000 in
each of the last two years, and he did not know how the rest, about
100,000 rubles, was spent, and almost every year he was obliged to
borrow. Besides this the chief steward wrote every year telling him of
fires and bad harvests, or of the necessity of rebuilding factories
and workshops. So the first task Pierre had to face was one for
which he had very little aptitude or inclination--practical business.

He discussed estate affairs every day with his chief steward. But he
felt that this did not forward matters at all. He felt that these
consultations were detached from real affairs and did not link up with
them or make them move. On the one hand, the chief steward put the
state of things to him in the very worst light, pointing out the
necessity of paying off the debts and undertaking new activities
with serf labor, to which Pierre did not agree. On the other hand,
Pierre demanded that steps should be taken to liberate the serfs,
which the steward met by showing the necessity of first paying off the
loans from the Land Bank, and the consequent impossibility of a speedy
emancipation.

The steward did not say it was quite impossible, but suggested
selling the forests in the province of Kostroma, the land lower down
the river, and the Crimean estate, in order to make it possible: all
of which operations according to him were connected with such
complicated measures--the removal of injunctions, petitions,
permits, and so on--that Pierre became quite bewildered and only
replied:

"Yes, yes, do so."

Pierre had none of the practical persistence that would have enabled
him to attend to the business himself and so he disliked it and only
tried to pretend to the steward that he was attending to it. The
steward for his part tried to pretend to the count that he
considered these consultations very valuable for the proprietor and
troublesome to himself.

In Kiev Pierre found some people he knew, and strangers hastened
to make his acquaintance and joyfully welcomed the rich newcomer,
the largest landowner of the province. Temptations to Pierre's
greatest weakness--the one to which he had confessed when admitted
to the Lodge--were so strong that he could not resist them. Again
whole days, weeks, and months of his life passed in as great a rush
and were as much occupied with evening parties, dinners, lunches,
and balls, giving him no time for reflection, as in Petersburg.
Instead of the new life he had hoped to lead he still lived the old
life, only in new surroundings.

Of the three precepts of Freemasonry Pierre realized that he did not
fulfill the one which enjoined every Mason to set an example of
moral life, and that of the seven virtues he lacked two--morality
and the love of death. He consoled himself with the thought that he
fulfilled another of the precepts--that of reforming the human race-
and had other virtues--love of his neighbor, and especially
generosity.

In the spring of 1807 he decided to return to Petersburg. On the way
he intended to visit all his estates and see for himself how far his
orders had been carried out and in what state were the serfs whom
God had entrusted to his care and whom he intended to benefit.

The chief steward, who considered the young count's attempts
almost insane--unprofitable to himself, to the count, and to the
serfs--made some concessions. Continuing to represent the liberation
of the serfs as impracticable, he arranged for the erection of large
buildings--schools, hospitals, and asylums--on all the estates
before the master arrived. Everywhere preparations were made not for
ceremonious welcomes (which he knew Pierre would not like), but for
just such gratefully religious ones, with offerings of icons and the
bread and salt of hospitality, as, according to his understanding of
his master, would touch and delude him.

The southern spring, the comfortable rapid traveling in a Vienna
carriage, and the solitude of the road, all had a gladdening effect on
Pierre. The estates he had not before visited were each more
picturesque than the other; the serfs everywhere seemed thriving and
touchingly grateful for the benefits conferred on them. Everywhere
were receptions, which though they embarrassed Pierre awakened a
joyful feeling in the depth of his heart. In one place the peasants
presented him with bread and salt and an icon of Saint Peter and Saint
Paul, asking permission, as a mark of their gratitude for the benefits
he had conferred on them, to build a new chantry to the church at
their own expense in honor of Peter and Paul, his patron saints. In
another place the women with infants in arms met him to thank him
for releasing them from hard work. On a third estate the priest,
bearing a cross, came to meet him surrounded by children whom, by
the count's generosity, he was instructing in reading, writing, and
religion. On all his estates Pierre saw with his own eyes brick
buildings erected or in course of erection, all on one plan, for
hospitals, schools, and almshouses, which were soon to be opened.
Everywhere he saw the stewards' accounts, according to which the
serfs' manorial labor had been diminished, and heard the touching
thanks of deputations of serfs in their full-skirted blue coats.

What Pierre did not know was that the place where they presented him
with bread and salt and wished to build a chantry in honor of Peter
and Paul was a market village where a fair was held on St. Peter's
day, and that the richest peasants (who formed the deputation) had
begun the chantry long before, but that nine tenths of the peasants in
that villages were in a state of the greatest poverty. He did not know
that since the nursing mothers were no longer sent to work on his
land, they did still harder work on their own land. He did not know
that the priest who met him with the cross oppressed the peasants by
his exactions, and that the pupils' parents wept at having to let
him take their children and secured their release by heavy payments.
He did not know that the brick buildings, built to plan, were being
built by serfs whose manorial labor was thus increased, though
lessened on paper. He did not know that where the steward had shown
him in the accounts that the serfs' payments had been diminished by
a third, their obligatory manorial work had been increased by a
half. And so Pierre was delighted with his visit to his estates and
quite recovered the philanthropic mood in which he had left
Petersburg, and wrote enthusiastic letters to his "brother-instructor"
as he called the Grand Master.

"How easy it is, how little effort it needs, to do so much good,"
thought Pierre, "and how little attention we pay to it!"

He was pleased at the gratitude he received, but felt abashed at
receiving it. This gratitude reminded him of how much more he might do
for these simple, kindly people.

The chief steward, a very stupid but cunning man who saw perfectly
through the naive and intelligent count and played with him as with
a toy, seeing the effect these prearranged receptions had on Pierre,
pressed him still harder with proofs of the impossibility and above
all the uselessness of freeing the serfs, who were quite happy as it
was.

Pierre in his secret soul agreed with the steward that it would be
difficult to imagine happier people, and that God only knew what would
happen to them when they were free, but he insisted, though
reluctantly, on what he thought right. The steward promised to do
all in his power to carry out the count's wishes, seeing clearly
that not only would the count never be able to find out whether all
measures had been taken for the sale of the land and forests and to
release them from the Land Bank, but would probably never even inquire
and would never know that the newly erected buildings were standing
empty and that the serfs continued to give in money and work all
that other people's serfs gave--that is to say, all that could be
got out of them.





CHAPTER XI


Returning from his journey through South Russia in the happiest
state of mind, Pierre carried out an intention he had long had of
visiting his friend Bolkonski, whom he had not seen for two years.

Bogucharovo lay in a flat uninteresting part of the country among
fields and forests of fir and birch, which were partly cut down. The
house lay behind a newly dug pond filled with water to the brink and
with banks still bare of grass. It was at the end of a village that
stretched along the highroad in the midst of a young copse in which
were a few fir trees.

The homestead consisted of a threshing floor, outhouses, stables,
a bathhouse, a lodge, and a large brick house with semicircular facade
still in course of construction. Round the house was a garden newly
laid out. The fences and gates were new and solid; two fire pumps
and a water cart, painted green, stood in a shed; the paths were
straight, the bridges were strong and had handrails. Everything bore
an impress of tidiness and good management. Some domestic serfs Pierre
met, in reply to inquiries as to where the prince lived, pointed out a
small newly built lodge close to the pond. Anton, a man who had looked
after Prince Andrew in his boyhood, helped Pierre out of his carriage,
said that the prince was at home, and showed him into a clean little
anteroom.

Pierre was struck by the modesty of the small though clean house
after the brilliant surroundings in which he had last met his friend
in Petersburg.

He quickly entered the small reception room with its
still-unplastered wooden walls redolent of pine, and would have gone
farther, but Anton ran ahead on tiptoe and knocked at a door.

"Well, what is it?" came a sharp, unpleasant voice.

"A visitor," answered Anton.

"Ask him to wait," and the sound was heard of a chair being pushed
back.

Pierre went with rapid steps to the door and suddenly came face to
face with Prince Andrew, who came out frowning and looking old. Pierre
embraced him and lifting his spectacles kissed his friend on the cheek
and looked at him closely.

"Well, I did not expect you, I am very glad," said Prince Andrew.

Pierre said nothing; he looked fixedly at his friend with
surprise. He was struck by the change in him. His words were kindly
and there was a smile on his lips and face, but his eyes were dull and
lifeless and in spite of his evident wish to do so he could not give
them a joyous and glad sparkle. Prince Andrew had grown thinner,
paler, and more manly-looking, but what amazed and estranged Pierre
till he got used to it were his inertia and a wrinkle on his brow
indicating prolonged concentration on some one thought.

As is usually the case with people meeting after a prolonged
separation, it was long before their conversation could settle on
anything. They put questions and gave brief replies about things
they knew ought to be talked over at length. At last the
conversation gradually settled on some of the topics at first
lightly touched on: their past life, plans for the future, Pierre's
journeys and occupations, the war, and so on. The preoccupation and
despondency which Pierre had noticed in his friend's look was now
still more clearly expressed in the smile with which he listened to
Pierre, especially when he spoke with joyful animation of the past
or the future. It was as if Prince Andrew would have liked to
sympathize with what Pierre was saying, but could not. The latter
began to feel that it was in bad taste to speak of his enthusiasms,
dreams, and hopes of happiness or goodness, in Prince Andrew's
presence. He was ashamed to express his new Masonic views, which had
been particularly revived and strengthened by his late tour. He
checked himself, fearing to seem naive, yet he felt an irresistible
desire to show his friend as soon as possible that he was now a
quite different, and better, Pierre than he had been in Petersburg.

"I can't tell you how much I have lived through since then. I hardly
know myself again."

"Yes, we have altered much, very much, since then," said Prince
Andrew.

"Well, and you? What are your plans?"

"Plans!" repeated Prince Andrew ironically. "My plans?" he said,
as if astonished at the word. "Well, you see, I'm building. I mean
to settle here altogether next year...."

Pierre looked silently and searchingly into Prince Andrew's face,
which had grown much older.

"No, I meant to ask..." Pierre began, but Prince Andrew
interrupted him.

"But why talk of me?... Talk to me, yes, tell me about your
travels and all you have been doing on your estates."

Pierre began describing what he had done on his estates, trying as
far as possible to conceal his own part in the improvements that had
been made. Prince Andrew several times prompted Pierre's story of what
he had been doing, as though it were all an old-time story, and he
listened not only without interest but even as if ashamed of what
Pierre was telling him.

Pierre felt uncomfortable and even depressed in his friend's company
and at last became silent.

"I'll tell you what, my dear fellow," said Prince Andrew, who
evidently also felt depressed and constrained with his visitor, "I
am only bivouacking here and have just come to look round. I am
going back to my sister today. I will introduce you to her. But of
course you know her already," he said, evidently trying to entertain a
visitor with whom he now found nothing in common. "We will go after
dinner. And would you now like to look round my place?"

They went out and walked about till dinnertime, talking of the
political news and common acquaintances like people who do not know
each other intimately. Prince Andrew spoke with some animation and
interest only of the new homestead he was constructing and its
buildings, but even here, while on the scaffolding, in the midst of
a talk explaining the future arrangements of the house, he interrupted
himself:

"However, this is not at all interesting. Let us have dinner, and
then we'll set off."

At dinner, conversation turned on Pierre's marriage.

"I was very much surprised when I heard of it," said Prince Andrew.

Pierre blushed, as he always did when it was mentioned, and said
hurriedly: "I will tell you some time how it all happened. But you
know it is all over, and forever."

"Forever?" said Prince Andrew. "Nothing's forever."

"But you know how it all ended, don't you? You heard of the duel?"

"And so you had to go through that too!"

"One thing I thank God for is that I did not kill that man," said
Pierre.

"Why so?" asked Prince Andrew. "To kill a vicious dog is a very good
thing really."

"No, to kill a man is bad--wrong."

"Why is it wrong?" urged Prince Andrew. "It is not given to man to
know what is right and what is wrong. Men always did and always will
err, and in nothing more than in what they consider right and wrong."

"What does harm to another is wrong," said Pierre, feeling with
pleasure that for the first time since his arrival Prince Andrew was
roused, had begun to talk, and wanted to express what had brought
him to his present state.

"And who has told you what is bad for another man?" he asked.

"Bad! Bad!" exclaimed Pierre. "We all know what is bad for
ourselves."

"Yes, we know that, but the harm I am conscious of in myself is
something I cannot inflict on others," said Prince Andrew, growing
more and more animated and evidently wishing to express his new
outlook to Pierre. He spoke in French. "I only know two very real
evils in life: remorse and illness. The only good is the absence of
those evils. To live for myself avoiding those two evils is my whole
philosophy now."

"And love of one's neighbor, and self-sacrifice?" began Pierre. "No,
I can't agree with you! To live only so as not to do evil and not to
have to repent is not enough. I lived like that, I lived for myself
and ruined my life. And only now when I am living, or at least trying"
(Pierre's modesty made him correct himself) "to live for others,
only now have I understood all the happiness of life. No, I shall
not agree with you, and you do not really believe what you are
saying." Prince Andrew looked silently at Pierre with an ironic smile.

"When you see my sister, Princess Mary, you'll get on with her,"
he said. "Perhaps you are right for yourself," he added after a
short pause, "but everyone lives in his own way. You lived for
yourself and say you nearly ruined your life and only found
happiness when you began living for others. I experienced just the
reverse. I lived for glory.--And after all what is glory? The same
love of others, a desire to do something for them, a desire for
their approval.--So I lived for others, and not almost, but quite,
ruined my life. And I have become calmer since I began to live only
for myself."

"But what do you mean by living only for yourself?" asked Pierre,
growing excited. "What about your son, your sister, and your father?"

"But that's just the same as myself--they are not others," explained
Prince Andrew. "The others, one's neighbors, le prochain, as you and
Princess Mary call it, are the chief source of all error and evil.
Le prochain--your Kiev peasants to whom you want to do good."

And he looked at Pierre with a mocking, challenging expression. He
evidently wished to draw him on.

"You are joking," replied Pierre, growing more and more excited.
"What error or evil can there be in my wishing to do good, and even
doing a little--though I did very little and did it very badly? What
evil can there be in it if unfortunate people, our serfs, people
like ourselves, were growing up and dying with no idea of God and
truth beyond ceremonies and meaningless prayers and are now instructed
in a comforting belief in future life, retribution, recompense, and
consolation? What evil and error are there in it, if people were dying
of disease without help while material assistance could so easily be
rendered, and I supplied them with a doctor, a hospital, and an asylum
for the aged? And is it not a palpable, unquestionable good if a
peasant, or a woman with a baby, has no rest day or night and I give
them rest and leisure?" said Pierre, hurrying and lisping. "And I have
done that though badly and to a small extent; but I have done
something toward it and you cannot persuade me that it was not a
good action, and more than that, you can't make me believe that you do
not think so yourself. And the main thing is," he continued, "that I
know, and know for certain, that the enjoyment of doing this good is
the only sure happiness in life."

"Yes, if you put it like that it's quite a different matter," said
Prince Andrew. "I build a house and lay out a garden, and you build
hospitals. The one and the other may serve as a pastime. But what's
right and what's good must be judged by one who knows all, but not
by us. Well, you want an argument," he added, "come on then."

They rose from the table and sat down in the entrance porch which
served as a veranda.

"Come, let's argue then," said Prince Andrew, "You talk of schools,"
he went on, crooking a finger, "education and so forth; that is, you
want to raise him" (pointing to a peasant who passed by them taking
off his cap) "from his animal condition and awaken in him spiritual
needs, while it seems to me that animal happiness is the only
happiness possible, and that is just what you want to deprive him
of. I envy him, but you want to make him what I am, without giving him
my means. Then you say, 'lighten his toil.' But as I see it,
physical labor is as essential to him, as much a condition of his
existence, as mental activity is to you or me. You can't help
thinking. I go to bed after two in the morning, thoughts come and I
can't sleep but toss about till dawn, because I think and can't help
thinking, just as he can't help plowing and mowing; if he didn't, he
would go to the drink shop or fall ill. Just as I could not stand
his terrible physical labor but should die of it in a week, so he
could not stand my physical idleness, but would grow fat and die.
The third thing--what else was it you talked about?" and Prince Andrew
crooked a third finger. "Ah, yes, hospitals, medicine. He has a fit,
he is dying, and you come and bleed him and patch him up. He will drag
about as a cripple, a burden to everybody, for another ten years. It
would be far easier and simpler for him to die. Others are being
born and there are plenty of them as it is. It would be different if
you grudged losing a laborer--that's how I regard him--but you want to
cure him from love of him. And he does not want that. And besides,
what a notion that medicine ever cured anyone! Killed them, yes!" said
he, frowning angrily and turning away from Pierre.

Prince Andrew expressed his ideas so clearly and distinctly that
it was evident he had reflected on this subject more than once, and he
spoke readily and rapidly like a man who has not talked for a long
time. His glance became more animated as his conclusions became more
hopeless.

"Oh, that is dreadful, dreadful!" said Pierre. "I don't understand
how one can live with such ideas. I had such moments myself not long
ago, in Moscow and when traveling, but at such times I collapsed so
that I don't live at all--everything seems hateful to me... myself
most of all. Then I don't eat, don't wash... and how is it with
you?..."

"Why not wash? That is not cleanly," said Prince Andrew; "on the
contrary one must try to make one's life as pleasant as possible.
I'm alive, that is not my fault, so I must live out my life as best
I can without hurting others."

"But with such ideas what motive have you for living? One would
sit without moving, undertaking nothing...."

"Life as it is leaves one no peace. I should be thankful to do
nothing, but here on the one hand the local nobility have done me
the honor to choose me to be their marshal; it was all I could do to
get out of it. They could not understand that I have not the necessary
qualifications for it--the kind of good-natured, fussy shallowness
necessary for the position. Then there's this house, which must be
built in order to have a nook of one's own in which to be quiet. And
now there's this recruiting."

"Why aren't you serving in the army?"

"After Austerlitz!" said Prince Andrew gloomily. "No, thank you very
much! I have promised myself not to serve again in the active
Russian army. And I won't--not even if Bonaparte were here at Smolensk
threatening Bald Hills--even then I wouldn't serve in the Russian
army! Well, as I was saying," he continued, recovering his
composure, "now there's this recruiting. My father is chief in command
of the Third District, and my only way of avoiding active service is
to serve under him."

"Then you are serving?"

"I am."

He paused a little while.

"And why do you serve?"

"Why, for this reason! My father is one of the most remarkable men
of his time. But he is growing old, and though not exactly cruel he
has too energetic a character. He is so accustomed to unlimited
power that he is terrible, and now he has this authority of a
commander in chief of the recruiting, granted by the Emperor. If I had
been two hours late a fortnight ago he would have had a paymaster's
clerk at Yukhnovna hanged," said Prince Andrew with a smile. "So I
am serving because I alone have any influence with my father, and
now and then can save him from actions which would torment him
afterwards."

"Well, there you see!"

"Yes, but it is not as you imagine," Prince Andrew continued. "I did
not, and do not, in the least care about that scoundrel of a clerk who
had stolen some boots from the recruits; I should even have been
very glad to see him hanged, but I was sorry for my father--that again
is for myself."

Prince Andrew grew more and more animated. His eyes glittered
feverishly while he tried to prove to Pierre that in his actions there
was no desire to do good to his neighbor.

"There now, you wish to liberate your serfs," he continued; "that is
a very good thing, but not for you--I don't suppose you ever had
anyone flogged or sent to Siberia--and still less for your serfs. If
they are beaten, flogged, or sent to Siberia, I don't suppose they are
any the worse off. In Siberia they lead the same animal life, and
the stripes on their bodies heal, and they are happy as before. But it
is a good thing for proprietors who perish morally, bring remorse upon
themselves, stifle this remorse and grow callous, as a result of being
able to inflict punishments justly and unjustly. It is those people
I pity, and for their sake I should like to liberate the serfs. You
may not have seen, but I have seen, how good men brought up in those
traditions of unlimited power, in time when they grow more
irritable, become cruel and harsh, are conscious of it, but cannot
restrain themselves and grow more and more miserable."

Prince Andrew spoke so earnestly that Pierre could not help thinking
that these thoughts had been suggested to Prince Andrew by his
father's case.

He did not reply.

"So that's what I'm sorry for--human dignity, peace of mind, purity,
and not the serfs' backs and foreheads, which, beat and shave as you
may, always remain the same backs and foreheads."

"No, no! A thousand times no! I shall never agree with you," said
Pierre.





CHAPTER XII


In the evening Andrew and Pierre got into the open carriage and
drove to Bald Hills. Prince Andrew, glancing at Pierre, broke the
silence now and then with remarks which showed that he was in a good
temper.

Pointing to the fields, he spoke of the improvements he was making
in his husbandry.

Pierre remained gloomily silent, answering in monosyllables and
apparently immersed in his own thoughts.

He was thinking that Prince Andrew was unhappy, had gone astray, did
not see the true light, and that he, Pierre, ought to aid,
enlighten, and raise him. But as soon as he thought of what he
should say, he felt that Prince Andrew with one word, one argument,
would upset all his teaching, and he shrank from beginning, afraid
of exposing to possible ridicule what to him was precious and sacred.

"No, but why do you think so?" Pierre suddenly began, lowering his
head and looking like a bull about to charge, "why do you think so?
You should not think so."

"Think? What about?" asked Prince Andrew with surprise.

"About life, about man's destiny. It can't be so. I myself thought
like that, and do you know what saved me? Freemasonry! No, don't
smile. Freemasonry is not a religious ceremonial sect, as I thought it
was: Freemasonry is the best expression of the best, the eternal,
aspects of humanity."

And he began to explain Freemasonry as he understood it to Prince
Andrew. He said that Freemasonry is the teaching of Christianity freed
from the bonds of State and Church, a teaching of equality,
brotherhood, and love.

"Only our holy brotherhood has the real meaning of life, all the
rest is a dream," said Pierre. "Understand, my dear fellow, that
outside this union all is filled with deceit and falsehood and I agree
with you that nothing is left for an intelligent and good man but to
live out his life, like you, merely trying not to harm others. But
make our fundamental convictions your own, join our brotherhood,
give yourself up to us, let yourself be guided, and you will at once
feel yourself, as I have felt myself, a part of that vast invisible
chain the beginning of which is hidden in heaven," said Pierre.

Prince Andrew, looking straight in front of him, listened in silence
to Pierre's words. More than once, when the noise of the wheels
prevented his catching what Pierre said, he asked him to repeat it,
and by the peculiar glow that came into Prince Andrew's eyes and by
his silence, Pierre saw that his words were not in vain and that
Prince Andrew would not interrupt him or laugh at what he said.

They reached a river that had overflowed its banks and which they
had to cross by ferry. While the carriage and horses were being placed
on it, they also stepped on the raft.

Prince Andrew, leaning his arms on the raft railing, gazed
silently at the flooding waters glittering in the setting sun.

"Well, what do you think about it?" Pierre asked. "Why are you
silent?"

"What do I think about it? I am listening to you. It's all very
well.... You say: join our brotherhood and we will show you the aim of
life, the destiny of man, and the laws which govern the world. But who
are we? Men. How is it you know everything? Why do I alone not see
what you see? You see a reign of goodness and truth on earth, but I
don't see it."

Pierre interrupted him.

"Do you believe in a future life?" he asked.

"A future life?" Prince Andrew repeated, but Pierre, giving him no
time to reply, took the repetition for a denial, the more readily as
he knew Prince Andrew's former atheistic convictions.

"You say you can't see a reign of goodness and truth on earth. Nor
could I, and it cannot be seen if one looks on our life here as the
end of everything. On earth, here on this earth" (Pierre pointed to
the fields), "there is no truth, all is false and evil; but in the
universe, in the whole universe there is a kingdom of truth, and we
who are now the children of earth are--eternally--children of the
whole universe. Don't I feel in my soul that I am part of this vast
harmonious whole? Don't I feel that I form one link, one step, between
the lower and higher beings, in this vast harmonious multitude of
beings in whom the Deity--the Supreme Power if you prefer the term--is
manifest? If I see, clearly see, that ladder leading from plant to
man, why should I suppose it breaks off at me and does not go
farther and farther? I feel that I cannot vanish, since nothing
vanishes in this world, but that I shall always exist and always
have existed. I feel that beyond me and above me there are spirits,
and that in this world there is truth."

"Yes, that is Herder's theory," said Prince Andrew, "but it is not
that which can convince me, dear friend--life and death are what
convince. What convinces is when one sees a being dear to one, bound
up with one's own life, before whom one was to blame and had hoped
to make it right" (Prince Andrew's voice trembled and he turned away),
"and suddenly that being is seized with pain, suffers, and ceases to
exist.... Why? It cannot be that there is no answer. And I believe
there is.... That's what convinces, that is what has convinced me,"
said Prince Andrew.

"Yes, yes, of course," said Pierre, "isn't that what I'm saying?"

"No. All I say is that it is not argument that convinces me of the
necessity of a future life, but this: when you go hand in hand with
someone and all at once that person vanishes there, into nowhere,
and you yourself are left facing that abyss, and look in. And I have
looked in...."

"Well, that's it then! You know that there is a there and there is a
Someone? There is the future life. The Someone is--God."

Prince Andrew did not reply. The carriage and horses had long
since been taken off, onto the farther bank, and reharnessed. The
sun had sunk half below the horizon and an evening frost was
starring the puddles near the ferry, but Pierre and Andrew, to the
astonishment of the footmen, coachmen, and ferrymen, still stood on
the raft and talked.

"If there is a God and future life, there is truth and good, and
man's highest happiness consists in striving to attain them. We must
live, we must love, and we must believe that we live not only today on
this scrap of earth, but have lived and shall live forever, there,
in the Whole," said Pierre, and he pointed to the sky.

Prince Andrew stood leaning on the railing of the raft listening
to Pierre, and he gazed with his eyes fixed on the red reflection of
the sun gleaming on the blue waters. There was perfect stillness.
Pierre became silent. The raft had long since stopped and only the
waves of the current beat softly against it below. Prince Andrew
felt as if the sound of the waves kept up a refrain to Pierre's words,
whispering:

"It is true, believe it."

He sighed, and glanced with a radiant, childlike, tender look at
Pierre's face, flushed and rapturous, but yet shy before his
superior friend.

"Yes, if it only were so!" said Prince Andrew. "However, it is
time to get on," he added, and, stepping off the raft, he looked up at
the sky to which Pierre had pointed, and for the first time since
Austerlitz saw that high, everlasting sky he had seen while lying on
that battlefield; and something that had long been slumbering,
something that was best within him, suddenly awoke, joyful and
youthful, in his soul. It vanished as soon as he returned to the
customary conditions of his life, but he knew that this feeling
which he did not know how to develop existed within him. His meeting
with Pierre formed an epoch in Prince Andrew's life. Though
outwardly he continued to live in the same old way, inwardly he
began a new life.





CHAPTER XIII


It was getting dusk when Prince Andrew and Pierre drove up to the
front entrance of the house at Bald Hills. As they approached the
house, Prince Andrew with a smile drew Pierre's attention to a
commotion going on at the back porch. A woman, bent with age, with a
wallet on her back, and a short, long-haired, young man in a black
garment had rushed back to the gate on seeing the carriage driving up.
Two women ran out after them, and all four, looking round at the
carriage, ran in dismay up the steps of the back porch.

"Those are Mary's 'God's folk,'" said Prince Andrew. "They have
mistaken us for my father. This is the one matter in which she
disobeys him. He orders these pilgrims to be driven away, but she
receives them."

"But what are 'God's folk'?" asked Pierre.

Prince Andrew had no time to answer. The servants came out to meet
them, and he asked where the old prince was and whether he was
expected back soon.

The old prince had gone to the town and was expected back any
minute.

Prince Andrew led Pierre to his own apartments, which were always
kept in perfect order and readiness for him in his father's house;
he himself went to the nursery.

"Let us go and see my sister," he said to Pierre when he returned.
"I have not found her yet, she is hiding now, sitting with her
'God's folk.' It will serve her right, she will be confused, but you
will see her 'God's folk.' It's really very curious."

"What are 'God's folk'?" asked Pierre.

"Come, and you'll see for yourself."

Princess Mary really was disconcerted and red patches came on her
face when they went in. In her snug room, with lamps burning before
the icon stand, a young lad with a long nose and long hair, wearing
a monk's cassock, sat on the sofa beside her, behind a samovar. Near
them, in an armchair, sat a thin, shriveled, old woman, with a meek
expression on her childlike face.

"Andrew, why didn't you warn me?" said the princess, with mild
reproach, as she stood before her pilgrims like a hen before her
chickens.

"Charmee de vous voir. Je suis tres contente de vous voir,"* she
said to Pierre as he kissed her hand. She had known him as a child,
and now his friendship with Andrew, his misfortune with his wife,
and above all his kindly, simple face disposed her favorably toward
him. She looked at him with her beautiful radiant eyes and seemed to
say, "I like you very much, but please don't laugh at my people."
After exchanging the first greetings, they sat down.


*"Delighted to see you. I am very glad to see you."


"Ah, and Ivanushka is here too!" said Prince Andrew, glancing with a
smile at the young pilgrim.

"Andrew!" said Princess Mary, imploringly. "Il faut que vous sachiez
que c'est une femme,"* said Prince Andrew to Pierre.

"Andrew, au nom de Dieu!"*[2] Princess Mary repeated.


*"You must know that this is a woman."

*[2] "For heaven's sake."


It was evident that Prince Andrew's ironical tone toward the
pilgrims and Princess Mary's helpless attempts to protect them were
their customary long-established relations on the matter.

"Mais, ma bonne amie," said Prince Andrew, "vous devriez au
contraire m'etre reconnaissante de ce que j'explique a Pierre votre
intimite avec ce jeune homme."*


*"But, my dear, you ought on the contrary to be grateful to me for
explaining to Pierre your intimacy with this young man."


"Really?" said Pierre, gazing over his spectacles with curiosity and
seriousness (for which Princess Mary was specially grateful to him)
into Ivanushka's face, who, seeing that she was being spoken about,
looked round at them all with crafty eyes.

Princess Mary's embarrassment on her people's account was quite
unnecessary. They were not in the least abashed. The old woman,
lowering her eyes but casting side glances at the newcomers, had
turned her cup upside down and placed a nibbled bit of sugar beside
it, and sat quietly in her armchair, though hoping to be offered
another cup of tea. Ivanushka, sipping out of her saucer, looked
with sly womanish eyes from under her brows at the young men.

"Where have you been? To Kiev?" Prince Andrew asked the old woman.

"I have, good sir," she answered garrulously. "Just at Christmastime
I was deemed worthy to partake of the holy and heavenly sacrament at
the shrine of the saint. And now I'm from Kolyazin, master, where a
great and wonderful blessing has been revealed."

"And was Ivanushka with you?"

"I go by myself, benefactor," said Ivanushka, trying to speak in a
bass voice. "I only came across Pelageya in Yukhnovo..."

Pelageya interrupted her companion; she evidently wished to tell
what she had seen.

"In Kolyazin, master, a wonderful blessing has been revealed."

"What is it? Some new relics?" asked Prince Andrew.

"Andrew, do leave off," said Princess Mary. "Don't tell him,
Pelageya."

"No... why not, my dear, why shouldn't I? I like him. He is kind, he
is one of God's chosen, he's a benefactor, he once gave me ten rubles,
I remember. When I was in Kiev, Crazy Cyril says to me (he's one of
God's own and goes barefoot summer and winter), he says, 'Why are
you not going to the right place? Go to Kolyazin where a
wonder-working icon of the Holy Mother of God has been revealed.' On
hearing those words I said good-by to the holy folk and went."

All were silent, only the pilgrim woman went on in measured tones,
drawing in her breath.

"So I come, master, and the people say to me: 'A great blessing
has been revealed, holy oil trickles from the cheeks of our blessed
Mother, the Holy Virgin Mother of God'...."

"All right, all right, you can tell us afterwards," said Princess
Mary, flushing.

"Let me ask her," said Pierre. "Did you see it yourselves?" he
inquired.

"Oh, yes, master, I was found worthy. Such a brightness on the
face like the light of heaven, and from the blessed Mother's cheek
it drops and drops...."

"But, dear me, that must be a fraud!" said Pierre, naively, who
had listened attentively to the pilgrim.

"Oh, master, what are you saying?" exclaimed the horrified Pelageya,
turning to Princess Mary for support.

"They impose on the people," he repeated.

"Lord Jesus Christ!" exclaimed the pilgrim woman, crossing
herself. "Oh, don't speak so, master! There was a general who did
not believe, and said, 'The monks cheat,' and as soon as he'd said
it he went blind. And he dreamed that the Holy Virgin Mother of the
Kiev catacombs came to him and said, 'Believe in me and I will make
you whole.' So he begged: 'Take me to her, take me to her.' It's the
real truth I'm telling you, I saw it myself. So he was brought,
quite blind, straight to her, and he goes up to her and falls down and
says, 'Make me whole,' says he, 'and I'll give thee what the Tsar
bestowed on me.' I saw it myself, master, the star is fixed into the
icon. Well, and what do you think? He received his sight! It's a sin
to speak so. God will punish you," she said admonishingly, turning
to Pierre.

"How did the star get into the icon?" Pierre asked.

"And was the Holy Mother promoted to the rank of general?" said
Prince Andrew, with a smile.

Pelageya suddenly grew quite pale and clasped her hands.

"Oh, master, master, what a sin! And you who have a son!" she began,
her pallor suddenly turning to a vivid red. "Master, what have you
said? God forgive you!" And she crossed herself. "Lord forgive him! My
dear, what does it mean?..." she asked, turning to Princess Mary.
She got up and, almost crying, began to arrange her wallet. She
evidently felt frightened and ashamed to have accepted charity in a
house where such things could be said, and was at the same time
sorry to have now to forgo the charity of this house.

"Now, why need you do it?" said Princess Mary. "Why did you come
to me?..."

"Come, Pelageya, I was joking," said Pierre. "Princesse, ma
parole, je n'ai pas voulu l'offenser.* I did not mean anything, I
was only joking," he said, smiling shyly and trying to efface his
offense. "It was all my fault, and Andrew was only joking."


*"Princess, on my word, I did not wish to offend her."


Pelageya stopped doubtfully, but in Pierre's face there was such a
look of sincere penitence, and Prince Andrew glanced so meekly now
at her and now at Pierre, that she was gradually reassured.





CHAPTER XIV


The pilgrim woman was appeased and, being encouraged to talk, gave a
long account of Father Amphilochus, who led so holy a life that his
hands smelled of incense, and how on her last visit to Kiev some monks
she knew let her have the keys of the catacombs, and how she, taking
some dried bread with her, had spent two days in the catacombs with
the saints. "I'd pray awhile to one, ponder awhile, then go on to
another. I'd sleep a bit and then again go and kiss the relics, and
there was such peace all around, such blessedness, that one don't want
to come out, even into the light of heaven again."

Pierre listened to her attentively and seriously. Prince Andrew went
out of the room, and then, leaving "God's folk" to finish their tea,
Princess Mary took Pierre into the drawing room.

"You are very kind," she said to him.

"Oh, I really did not mean to hurt her feelings. I understand them
so well and have the greatest respect for them."

Princess Mary looked at him silently and smiled affectionately.

"I have known you a long time, you see, and am as fond of you as
of a brother," she said. "How do you find Andrew?" she added
hurriedly, not giving him time to reply to her affectionate words.
"I am very anxious about him. His health was better in the winter, but
last spring his wound reopened and the doctor said he ought to go away
for a cure. And I am also very much afraid for him spiritually. He has
not a character like us women who, when we suffer, can weep away our
sorrows. He keeps it all within him. Today he is cheerful and in
good spirits, but that is the effect of your visit--he is not often
like that. If you could persuade him to go abroad. He needs
activity, and this quiet regular life is very bad for him. Others
don't notice it, but I see it."

Toward ten o'clock the men servants rushed to the front door,
hearing the bells of the old prince's carriage approaching. Prince
Andrew and Pierre also went out into the porch.

"Who's that?" asked the old prince, noticing Pierre as he got out
of, the carriage.

"Ah! Very glad! Kiss me," he said, having learned who the young
stranger was.

The old prince was in a good temper and very gracious to Pierre.

Before supper, Prince Andrew, coming back to his father's study,
found him disputing hotly with his visitor. Pierre was maintaining
that a time would come when there would be no more wars. The old
prince disputed it chaffingly, but without getting angry.

"Drain the blood from men's veins and put in water instead, then
there will be no more war! Old women's nonsense--old women's
nonsense!" he repeated, but still he patted Pierre affectionately on
the shoulder, and then went up to the table where Prince Andrew,
evidently not wishing to join in the conversation, was looking over
the papers his father had brought from town. The old prince went up to
him and began to talk business.

"The marshal, a Count Rostov, hasn't sent half his contingent. He
came to town and wanted to invite me to dinner--I gave him a pretty
dinner!... And there, look at this.... Well, my boy," the old prince
went on, addressing his son and patting Pierre on the shoulder. "A
fine fellow--your friend--I like him! He stirs me up. Another says
clever things and one doesn't care to listen, but this one talks
rubbish yet stirs an old fellow up. Well, go! Get along! Perhaps
I'll come and sit with you at supper. We'll have another dispute. Make
friends with my little fool, Princess Mary," he shouted after
Pierre, through the door.

Only now, on his visit to Bald Hills, did Pierre fully realize the
strength and charm of his friendship with Prince Andrew. That charm
was not expressed so much in his relations with him as with all his
family and with the household. With the stern old prince and the
gentle, timid Princess Mary, though he had scarcely known them, Pierre
at once felt like an old friend. They were all fond of him already.
Not only Princess Mary, who had been won by his gentleness with the
pilgrims, gave him her most radiant looks, but even the one-year-old
"Prince Nicholas" (as his grandfather called him) smiled at Pierre and
let himself be taken in his arms, and Michael Ivanovich and
Mademoiselle Bourienne looked at him with pleasant smiles when he
talked to the old prince.

The old prince came in to supper; this was evidently on Pierre's
account. And during the two days of the young man's visit he was
extremely kind to him and told him to visit them again.

When Pierre had gone and the members of the household met
together, they began to express their opinions of him as people always
do after a new acquaintance has left, but as seldom happens, no one
said anything but what was good of him.





CHAPTER XV


When returning from his leave, Rostov felt, for the first time,
how close was the bond that united him to Denisov and and the whole
regiment.

On approaching it, Rostov felt as he had done when approaching his
home in Moscow. When he saw the first hussar with the unbuttoned
uniform of his regiment, when he recognized red-haired Dementyev and
saw the picket ropes of the roan horses, when Lavrushka gleefully
shouted to his master, "The count has come!" and Denisov, who had been
asleep on his bed, ran all disheveled out of the mud hut to embrace
him, and the officers collected round to greet the new arrival, Rostov
experienced the same feeling his mother, his father, and his sister
had embraced him, and tears of joy choked him so that he could not
speak. The regiment was also a home, and as unalterably dear and
precious as his parents' house.

When he had reported himself to the commander of the regiment and
had been reassigned to his former squadron, had been on duty and had
gone out foraging, when he had again entered into all the little
interests of the regiment and felt himself deprived of liberty and
bound in one narrow, unchanging frame, he experienced the same sense
of peace, of moral support, and the same sense being at home here in
his own place, as he had felt under the parental roof. But here was
none of all that turmoil of the world at large, where he did not
know his right place and took mistaken decisions; here was no Sonya
with whom he ought, or ought not, to have an explanation; here was
no possibility of going there or not going there; here there were
not twenty-four hours in the day which could be spent in such a
variety of ways; there was not that innumerable crowd of people of
whom not one was nearer to him or farther from him than another; there
were none of those uncertain and undefined money relations with his
father, and nothing to recall that terrible loss to Dolokhov. Here, in
the regiment, all was clear and simple. The whole world was divided
into two unequal parts: one, our Pavlograd regiment; the other, all
the rest. And the rest was no concern of his. In the regiment,
everything was definite: who was lieutenant, who captain, who was a
good fellow, who a bad one, and most of all, who was a comrade. The
canteenkeeper gave one credit, one's pay came every four months, there
was nothing to think out or decide, you had only to do nothing that
was considered bad in the Pavlograd regiment and, when given an order,
to do what was clearly, distinctly, and definitely ordered--and all
would be well.

Having once more entered into the definite conditions of this
regimental life, Rostov felt the joy and relief a tired man feels on
lying down to rest. Life in the regiment, during this campaign, was
all the pleasanter for him, because, after his loss to Dolokhov (for
which, in spite of all his family's efforts to console him, he could
not forgive himself), he had made up his mind to atone for his fault
by serving, not as he had done before, but really well, and by being a
perfectly first-rate comrade and officer--in a word, a splendid man
altogether, a thing which seemed so difficult out in the world, but so
possible in the regiment.

After his losses, he had determined to pay back his debt to his
parents in five years. He received ten thousand rubles a year, but now
resolved to take only two thousand and leave the rest to repay the
debt to his parents.

Our army, after repeated retreats and advances and battles at
Pultusk and Preussisch-Eylau, was concentrated near Bartenstein. It
was awaiting the Emperor's arrival and the beginning of a new
campaign.

The Pavlograd regiment, belonging to that part of the army which had
served in the 1805 campaign, had been recruiting up to strength in
Russia, and arrived too late to take part in the first actions of
the campaign. It had been neither at Pultusk nor at Preussisch-Eylau
and, when it joined the army in the field in the second half of the
campaign, was attached to Platov's division.

Platov's division was acting independently of the main army. Several
times parts of the Pavlograd regiment had exchanged shots with the
enemy, had taken prisoners, and once had even captured Marshal
Oudinot's carriages. In April the Pavlograds were stationed
immovably for some weeks near a totally ruined and deserted German
village.

A thaw had set in, it was muddy and cold, the ice on the river
broke, and the roads became impassable. For days neither provisions
for the men nor fodder for the horses had been issued. As no
transports could arrive, the men dispersed about the abandoned and
deserted villages, searching for potatoes, but found few even of
these.

Everything had been eaten up and the inhabitants had all fled--if
any remained, they were worse than beggars and nothing more could be
taken from them; even the soldiers, usually pitiless enough, instead
of taking anything from them, often gave them the last of their
rations.

The Pavlograd regiment had had only two men wounded in action, but
had lost nearly half its men from hunger and sickness. In the
hospitals, death was so certain that soldiers suffering from fever, or
the swelling that came from bad food, preferred to remain on duty, and
hardly able to drag their legs went to the front rather than to the
hospitals. When spring came on, the soldiers found a plant just
showing out of the ground that looked like asparagus, which, for
some reason, they called "Mashka's sweet root." It was very bitter,
but they wandered about the fields seeking it and dug it out with
their sabers and ate it, though they were ordered not to do so, as
it was a noxious plant. That spring a new disease broke
out among the soldiers, a swelling of the arms, legs, and face,
which the doctors attributed to eating this root. But in spite of
all this, the soldiers of Denisov's squadron fed chiefly on
"Mashka's sweet root," because it was the second week that the last of
the biscuits were being doled out at the rate of half a pound a man
and the last potatoes received had sprouted and frozen.

The horses also had been fed for a fortnight on straw from the
thatched roofs and had become terribly thin, though still covered with
tufts of felty winter hair.

Despite this destitution, the soldiers and officers went on living
just as usual. Despite their pale swollen faces and tattered uniforms,
the hussars formed line for roll call, kept things in order, groomed
their horses, polished their arms, brought in straw from the
thatched roofs in place of fodder, and sat down to dine round the
caldrons from which they rose up hungry, joking about their nasty food
and their hunger. As usual, in their spare time, they lit bonfires,
steamed themselves before them naked; smoked, picked out and baked
sprouting rotten potatoes, told and listened to stories of
Potemkin's and Suvorov's campaigns, or to legends of Alesha the Sly,
or the priest's laborer Mikolka.

The officers, as usual, lived in twos and threes in the roofless,
half-ruined houses. The seniors tried to collect straw and potatoes
and, in general, food for the men. The younger ones occupied
themselves as before, some playing cards (there was plenty of money,
though there was no food), some with more innocent games, such as
quoits and skittles. The general trend of the campaign was rarely
spoken of, partly because nothing certain was known about it, partly
because there was a vague feeling that in the main it was going badly.

Rostov lived, as before, with Denisov, and since their furlough they
had become more friendly than ever. Denisov never spoke of Rostov's
family, but by the tender friendship his commander showed him,
Rostov felt that the elder hussar's luckless love for Natasha played a
part in strengthening their friendship. Denisov evidently tried to
expose Rostov to danger as seldom as possible, and after an action
greeted his safe return with evident joy. On one of his foraging
expeditions, in a deserted and ruined village to which he had come
in search of provisions, Rostov found a family consisting of an old
Pole and his daughter with an infant in arms. They were half clad,
hungry, too weak to get away on foot and had no means of obtaining a
conveyance. Rostov brought them to his quarters, placed them in his
own lodging, and kept them for some weeks while the old man was
recovering. One of his comrades, talking of women, began chaffing
Rostov, saying that he was more wily than any of them and that it
would not be a bad thing if he introduced to them the pretty Polish
girl he had saved. Rostov took the joke as an insult, flared up, and
said such unpleasant things to the officer that it was all Denisov
could do to prevent a duel. When the officer had gone away, Denisov,
who did not himself know what Rostov's relations with the Polish
girl might be, began to upbraid him for his quickness of temper, and
Rostov replied:

"Say what you like.... She is like a sister to me, and I can't
tell you how it offended me... because... well, for that reason...."

Denisov patted him on the shoulder and began rapidly pacing the room
without looking at Rostov, as was his way at moments of deep feeling.

"Ah, what a mad bweed you Wostovs are!" he muttered, and Rostov
noticed tears in his eyes.





CHAPTER XVI


In April the troops were enlivened by news of the Emperor's arrival,
but Rostov had no chance of being present at the review he held at
Bartenstein, as the Pavlograds were at the outposts far beyond that
place.

They were bivouacking. Denisov and Rostov were living in an earth
hut, dug out for them by the soldiers and roofed with branches and
turf. The hut was made in the following manner, which had then come
into vogue. A trench was dug three and a half feet wide, four feet
eight inches deep, and eight feet long. At one end of the trench,
steps were cut out and these formed the entrance and vestibule. The
trench itself was the room, in which the lucky ones, such as the
squadron commander, had a board, lying on piles at the end opposite
the entrance, to serve as a table. On each side of the trench, the
earth was cut out to a breadth of about two and a half feet, and
this did duty for bedsteads and couches. The roof was so constructed
that one could stand up in the middle of the trench and could even sit
up on the beds if one drew close to the table. Denisov, who was living
luxuriously because the soldiers of his squadron liked him, had also a
board in the roof at the farther end, with a piece of (broken but
mended) glass in it for a window. When it was very cold, embers from
the soldiers' campfire were placed on a bent sheet of iron on the
steps in the "reception room"--as Denisov called that part of the hut-
and it was then so warm that the officers, of whom there were always
some with Denisov and Rostov, sat in their shirt sleeves.

In April, Rostov was on orderly duty. One morning, between seven and
eight, returning after a sleepless night, he sent for embers,
changed his rain-soaked underclothes, said his prayers, drank tea, got
warm, then tidied up the things on the table and in his own corner,
and, his face glowing from exposure to the wind and with nothing on
but his shirt, lay down on his back, putting his arms under his
head. He was pleasantly considering the probability of being
promoted in a few days for his last reconnoitering expedition, and
was awaiting Denisov, who had gone out somewhere and with whom he
wanted a talk.

Suddenly he heard Denisov shouting in a vibrating voice behind the
hut, evidently much excited. Rostov moved to the window to see whom he
was speaking to, and saw the quartermaster, Topcheenko.

"I ordered you not to let them eat that Mashka woot stuff!" Denisov
was shouting. "And I saw with my own eyes how Lazarchuk bwought some
fwom the fields."

"I have given the order again and again, your honor, but they
don't obey," answered the quartermaster.

Rostov lay down again on his bed and thought complacently: "Let
him fuss and bustle now, my job's done and I'm lying down--capitally!"
He could hear that Lavrushka--that sly, bold orderly of Denisov's--was
talking, as well as the quartermaster. Lavrushka was saying
something about loaded wagons, biscuits, and oxen he had seen when
he had gone out for provisions.

Then Denisov's voice was heard shouting farther and farther away.
"Saddle! Second platoon!"

"Where are they off to now?" thought Rostov.

Five minutes later, Denisov came into the hut, climbed with muddy
boots on the bed, lit his pipe, furiously scattered his things
about, took his leaded whip, buckled on his saber, and went out again.
In answer to Rostov's inquiry where he was going, he answered
vaguely and crossly that he had some business.

"Let God and our gweat monarch judge me afterwards!" said Denisov
going out, and Rostov heard the hoofs of several horses splashing
through the mud. He did not even trouble to find out where Denisov had
gone. Having got warm in his corner, he fell asleep and did not
leave the hut till toward evening. Denisov had not yet returned. The
weather had cleared up, and near the next hut two officers and a cadet
were playing svayka, laughing as they threw their missiles which
buried themselves in the soft mud. Rostov joined them. In the middle
of the game, the officers saw some wagons approaching with fifteen
hussars on their skinny horses behind them. The wagons escorted by the
hussars drew up to the picket ropes and a crowd of hussars
surrounded them.

"There now, Denisov has been worrying," said Rostov, "and here are
the provisions."

"So they are!" said the officers. "Won't the soldiers be glad!"

A little behind the hussars came Denisov, accompanied by two
infantry officers with whom he was talking.

Rostov went to meet them.

"I warn you, Captain," one of the officers, a short thin man,

evidently very angry, was saying.

"Haven't I told you I won't give them up?" replied Denisov.

"You will answer for it, Captain. It is mutiny--seizing the
transport of one's own army. Our men have had nothing to eat for two
days."

"And mine have had nothing for two weeks," said Denisov.

"It is robbery! You'll answer for it, sir!" said the infantry
officer, raising his voice.

"Now, what are you pestewing me for?" cried Denisov, suddenly losing
his temper. "I shall answer for it and not you, and you'd better not
buzz about here till you get hurt. Be off! Go!" he shouted at the
officers.

"Very well, then!" shouted the little officer, undaunted and not
riding away. "If you are determined to rob, I'll..."

"Go to the devil! quick ma'ch, while you're safe and sound!" and
Denisov turned his horse on the officer.

"Very well, very well!" muttered the officer, threateningly, and
turning his horse he trotted away, jolting in his saddle.

"A dog astwide a fence! A weal dog astwide a fence!" shouted Denisov
after him (the most insulting expression a cavalryman can address to a
mounted infantryman) and riding up to Rostov, he burst out laughing.

"I've taken twansports from the infantwy by force!" he said.
"After all, can't let our men starve."

The wagons that had reached the hussars had been consigned to an
infantry regiment, but learning from Lavrushka that the transport
was unescorted, Denisov with his hussars had seized it by force. The
soldiers had biscuits dealt out to them freely, and they even shared
them with the other squadrons.

The next day the regimental commander sent for Denisov, and
holding his fingers spread out before his eyes said:

"This is how I look at this affair: I know nothing about it and
won't begin proceedings, but I advise you to ride over to the staff
and settle the business there in the commissariat department and if
possible sign a receipt for such and such stores received. If not,
as the demand was booked against an infantry regiment, there will be a
row and the affair may end badly."

From the regimental commander's, Denisov rode straight to the
staff with a sincere desire to act on this advice. In the evening he
came back to his dugout in a state such as Rostov had never yet seen
him in. Denisov could not speak and gasped for breath. When Rostov
asked what was the matter, he only uttered some incoherent oaths and
threats in a hoarse, feeble voice.

Alarmed at Denisov's condition, Rostov suggested that he should
undress, drink some water, and send for the doctor.

"Twy me for wobbewy... oh! Some more water... Let them twy me, but
I'll always thwash scoundwels... and I'll tell the Empewo'...
Ice..." he muttered.

The regimental doctor, when he came, said it was absolutely
necessary to bleed Denisov. A deep saucer of black blood was taken
from his hairy arm and only then was he able to relate what had
happened to him.

"I get there," began Denisov. "'Now then, where's your chief's
quarters?' They were pointed out. 'Please to wait.' 'I've widden
twenty miles and have duties to attend to and no time to wait.
Announce me.' Vewy well, so out comes their head chief--also took it
into his head to lecture me: 'It's wobbewy!'--'Wobbewy,' I say, 'is
not done by man who seizes pwovisions to feed his soldiers, but by him
who takes them to fill his own pockets!' 'Will you please be
silent?' 'Vewy good!' Then he says: 'Go and give a weceipt to the
commissioner, but your affair will be passed on to headquarters.' I go
to the commissioner. I enter, and at the table... who do you think?
No, but wait a bit!... Who is it that's starving us?" shouted Denisov,
hitting the table with the fist of his newly bled arm so violently
that the table nearly broke down and the tumblers on it jumped
about. "Telyanin! 'What? So it's you who's starving us to death! Is
it? Take this and this!' and I hit him so pat, stwaight on his
snout... 'Ah, what a... what...!' and I sta'ted fwashing him...
Well, I've had a bit of fun I can tell you!" cried Denisov, gleeful
and yet angry, his showing under his black mustache. "I'd have
killed him if they hadn't taken him away!"

"But what are you shouting for? Calm yourself," said Rostov. "You've
set your arm bleeding afresh. Wait, we must tie it up again."

Denisov was bandaged up again and put to bed. Next day he woke
calm and cheerful.

But at noon the adjutant of the regiment came into Rostov's and
Denisov's dugout with a grave and serious face and regretfully
showed them a paper addressed to Major Denisov from the regimental
commander in which inquiries were made about yesterday's occurrence.
The adjutant told them that the affair was likely to take a very bad
turn: that a court-martial had been appointed, and that in view of the
severity with which marauding and insubordination were now regarded,
degradation to the ranks would be the best that could be hoped for.

The case, as represented by the offended parties, was that, after
seizing the transports, Major Denisov, being drunk, went to the
chief quartermaster and without any provocation called him a thief,
threatened to strike him, and on being led out had rushed into the
office and given two officials a thrashing, and dislocated the arm
of one of them.

In answer to Rostov's renewed questions, Denisov said, laughing,
that he thought he remembered that some other fellow had got mixed
up in it, but that it was all nonsense and rubbish, and he did not
in the least fear any kind of trial, and that if those scoundrels
dared attack him he would give them an answer that they would not
easily forget.

Denisov spoke contemptuously of the whole matter, but Rostov knew
him too well not to detect that (while hiding it from others) at heart
he feared a court-martial and was worried over the affair, which was
evidently taking a bad turn. Every day, letters of inquiry and notices
from the court arrived, and on the first of May, Denisov was ordered
to hand the squadron over to the next in seniority and appear before
the staff of his division to explain his violence at the
commissariat office. On the previous day Platov reconnoitered with two
Cossack regiments and two squadrons of hussars. Denisov, as was his
wont, rode out in front of the outposts, parading his courage. A
bullet fired by a French sharpshooter hit him in the fleshy part of
his leg. Perhaps at another time Denisov would not have left the
regiment for so slight a wound, but now he took advantage of it to
excuse himself from appearing at the staff and went into hospital.





CHAPTER XVII


In June the battle of Friedland was fought, in which the
Pavlograds did not take part, and after that an armistice was
proclaimed. Rostov, who felt his friend's absence very much, having no
news of him since he left and feeling very anxious about his wound and
the progress of his affairs, took advantage of the armistice to get
leave to visit Denisov in hospital.

The hospital was in a small Prussian town that had been twice
devastated by Russian and French troops. Because it was summer, when
it is so beautiful out in the fields, the little town presented a
particularly dismal appearance with its broken roofs and fences, its
foul streets, tattered inhabitants, and the sick and drunken
soldiers wandering about.

The hospital was in a brick building with some of the window
frames and panes broken and a courtyard surrounded by the remains of a
wooden fence that had been pulled to pieces. Several bandaged
soldiers, with pale swollen faces, were sitting or walking about in
the sunshine in the yard.

Directly Rostov entered the door he was enveloped by a smell of
putrefaction and hospital air. On the stairs he met a Russian army
doctor smoking a cigar. The doctor was followed by a Russian
assistant.

"I can't tear myself to pieces," the doctor was saying. "Come to
Makar Alexeevich in the evening. I shall be there."

The assistant asked some further questions.

"Oh, do the best you can! Isn't it all the same?" The doctor noticed
Rostov coming upstairs.

"What do you want, sir?" said the doctor. "What do you want? The
bullets having spared you, do you want to try typhus? This is a
pesthouse, sir."

"How so?" asked Rostov.

"Typhus, sir. It's death to go in. Only we two, Makeev and I" (he
pointed to the assistant), "keep on here. Some five of us doctors have
died in this place.... When a new one comes he is done for in a week,"
said the doctor with evident satisfaction. "Prussian doctors have been
invited here, but our allies don't like it at all."

Rostov explained that he wanted to see Major Denisov of the hussars,
who was wounded.

"I don't know. I can't tell you, sir. Only think! I am alone in
charge of three hospitals with more than four hundred patients! It's
well that the charitable Prussian ladies send us two pounds of
coffee and some lint each month or we should be lost!" he laughed.
"Four hundred, sir, and they're always sending me fresh ones. There
are four hundred? Eh?" he asked, turning to the assistant.

The assistant looked fagged out. He was evidently vexed and
impatient for the talkative doctor to go.

"Major Denisov," Rostov said again. "He was wounded at Molliten."

"Dead, I fancy. Eh, Makeev?" queried the doctor, in a tone of
indifference.

The assistant, however, did not confirm the doctor's words.

"Is he tall and with reddish hair?" asked the doctor.

Rostov described Denisov's appearance.

"There was one like that," said the doctor, as if pleased. "That one
is dead, I fancy. However, I'll look up our list. We had a list.
Have you got it, Makeev?"

"Makar Alexeevich has the list," answered the assistant. "But if
you'll step into the officers' wards you'll see for yourself," he
added, turning to Rostov.

"Ah, you'd better not go, sir," said the doctor, "or you may have to
stay here yourself."

But Rostov bowed himself away from the doctor and asked the
assistant to show him the way.

"Only don't blame me!" the doctor shouted up after him.

Rostov and the assistant went into the dark corridor. The smell
was so strong there that Rostov held his nose and had to pause and
collect his strength before he could go on. A door opened to the
right, and an emaciated sallow man on crutches, barefoot and in
underclothing, limped out and, leaning against the doorpost, looked
with glittering envious eyes at those who were passing. Glancing in at
the door, Rostov saw that the sick and wounded were lying on the floor
on straw and overcoats.

"May I go in and look?"

"What is there to see?" said the assistant.

But, just because the assistant evidently did not want him to go in,
Rostov entered the soldiers' ward. The foul air, to which he had
already begun to get used in the corridor, was still stronger here. It
was a little different, more pungent, and one felt that this was where
it originated.

In the long room, brightly lit up by the sun through the large
windows, the sick and wounded lay in two rows with their heads to
the walls, and leaving a passage in the middle. Most of them were
unconscious and paid no attention to the newcomers. Those who were
conscious raised themselves or lifted their thin yellow faces, and all
looked intently at Rostov with the same expression of hope, of relief,
reproach, and envy of another's health. Rostov went to the middle of
the room and looking through the open doors into the two adjoining
rooms saw the same thing there. He stood still, looking silently
around. He had not at all expected such a sight. Just before him,
almost across the middle of the passage on the bare floor, lay a
sick man, probably a Cossack to judge by the cut of his hair. The
man lay on his back, his huge arms and legs outstretched. His face was
purple, his eyes were rolled back so that only the whites were seen,
and on his bare legs and arms which were still red, the veins stood
out like cords. He was knocking the back of his head against the
floor, hoarsely uttering some word which he kept repeating. Rostov
listened and made out the word. It was "drink, drink, a drink!" Rostov
glanced round, looking for someone who would put this man back in
his place and bring him water.

"Who looks after the sick here?" he asked the assistant.

Just then a commissariat soldier, a hospital orderly, came in from
the next room, marching stiffly, and drew up in front of Rostov.

"Good day, your honor!" he shouted, rolling his eyes at Rostov and
evidently mistaking him for one of the hospital authorities.

"Get him to his place and give him some water," said Rostov,
pointing to the Cossack.

"Yes, your honor," the soldier replied complacently, and rolling his
eyes more than ever he drew himself up still straighter, but did not
move.

"No, it's impossible to do anything here," thought Rostov,
lowering his eyes, and he was going out, but became aware of an
intense look fixed on him on his right, and he turned. Close to the
corner, on an overcoat, sat an old, unshaven, gray-bearded soldier
as thin as a skeleton, with a stern sallow face and eyes intently
fixed on Rostov. The man's neighbor on one side whispered something to
him, pointing at Rostov, who noticed that the old man wanted to
speak to him. He drew nearer and saw that the old man had only one leg
bent under him, the other had been amputated above the knee. His
neighbor on the other side, who lay motionless some distance from
him with his head thrown back, was a young soldier with a snub nose.
His pale waxen face was still freckled and his eyes were rolled
back. Rostov looked at the young soldier and a cold chill ran down his
back.

"Why, this one seems..." he began, turning to the assistant.

"And how we've been begging, your honor," said the old soldier,
his jaw quivering. "He's been dead since morning. After all we're men,
not dogs."

"I'll send someone at once. He shall be taken away--taken away at
once," said the assistant hurriedly. "Let us go, your honor."

"Yes, yes, let us go," said Rostov hastily, and lowering his eyes
and shrinking, he tried to pass unnoticed between the rows of
reproachful envious eyes that were fixed upon him, and went out of the
room.





CHAPTER XVIII


Going along the corridor, the assistant led Rostov to the
officers' wards, consisting of three rooms, the doors of which stood
open. There were beds in these rooms and the sick and wounded officers
were lying or sitting on them. Some were walking about the rooms in
hospital dressing gowns. The first person Rostov met in the
officers' ward was a thin little man with one arm, who was walking
about the first room in a nightcap and hospital dressing gown, with
a pipe between his teeth. Rostov looked at him, trying to remember
where he had seen him before.

"See where we've met again!" said the little man. "Tushin, Tushin,
don't you remember, who gave you a lift at Schon Grabern? And I've had
a bit cut off, you see..." he went on with a smile, pointing to the
empty sleeve of his dressing gown. "Looking for Vasili Dmitrich
Denisov? My neighbor," he added, when he heard who Rostov wanted.
"Here, here," and Tushin led him into the next room, from whence
came sounds of several laughing voices.

"How can they laugh, or even live at all here?" thought Rostov,
still aware of that smell of decomposing flesh that had been so strong
in the soldiers' ward, and still seeming to see fixed on him those
envious looks which had followed him out from both sides, and the face
of that young soldier with eyes rolled back.

Denisov lay asleep on his bed with his head under the blanket,
though it was nearly noon.

"Ah, Wostov? How are you, how are you?" he called out, still in
the same voice as in the regiment, but Rostov noticed sadly that under
this habitual ease and animation some new, sinister, hidden feeling
showed itself in the expression of Denisov's face and the
intonations of his voice.

His wound, though a slight one, had not yet healed even now, six
weeks after he had been hit. His face had the same swollen pallor as
the faces of the other hospital patients, but it was not this that
struck Rostov. What struck him was that Denisov did not seem glad to
see him, and smiled at him unnaturally. He did not ask about the
regiment, nor about the general state of affairs, and when Rostov
spoke of these matters did not listen.

Rostov even noticed that Denisov did not like to be reminded of
the regiment, or in general of that other free life which was going on
outside the hospital. He seemed to try to forget that old life and was
only interested in the affair with the commissariat officers. On
Rostov's inquiry as to how the matter stood, he at once produced
from under his pillow a paper he had received from the commission
and the rough draft of his answer to it. He became animated when he
began reading his paper and specially drew Rostov's attention to the
stinging rejoinders he made to his enemies. His hospital companions,
who had gathered round Rostov--a fresh arrival from the world outside-
gradually began to disperse as soon as Denisov began reading his
answer. Rostov noticed by their faces that all those gentlemen had
already heard that story more than once and were tired of it. Only the
man who had the next bed, a stout Uhlan, continued to sit on his
bed, gloomily frowning and smoking a pipe, and little one-armed Tushin
still listened, shaking his head disapprovingly. In the middle of
the reading, the Uhlan interrupted Denisov.

"But what I say is," he said, turning to Rostov, "it would be best
simply to petition the Emperor for pardon. They say great rewards will
now be distributed, and surely a pardon would be granted...."

"Me petition the Empewo'!" exclaimed Denisov, in a voice to which he
tried hard to give the old energy and fire, but which sounded like
an expression of irritable impotence. "What for? If I were a wobber
I would ask mercy, but I'm being court-martialed for bwinging
wobbers to book. Let them twy me, I'm not afwaid of anyone. I've
served the Tsar and my countwy honowably and have not stolen! And am I
to be degwaded?... Listen, I'm w'iting to them stwaight. This is
what I say: 'If I had wobbed the Tweasuwy...'"

"It's certainly well written," said Tushin, "but that's not the
point, Vasili Dmitrich," and he also turned to Rostov. "One has to
submit, and Vasili Dmitrich doesn't want to. You know the auditor told
you it was a bad business."

"Well, let it be bad," said Denisov.

"The auditor wrote out a petition for you," continued Tushin, "and
you ought to sign it and ask this gentleman to take it. No doubt he"
(indicating Rostov) "has connections on the staff. You won't find a
better opportunity."

"Haven't I said I'm not going to gwovel?" Denisov interrupted him,
went on reading his paper.

Rostov had not the courage to persuade Denisov, though he
instinctively felt that the way advised by Tushin and the other
officers was the safest, and though he would have been glad to be of
service to Denisov. He knew his stubborn will and straightforward
hasty temper.

When the reading of Denisov's virulent reply, which took more than
an hour, was over, Rostov said nothing, and he spent the rest of the
day in a most dejected state of mind amid Denisov's hospital comrades,
who had round him, telling them what he knew and listening to their
stories. Denisov was moodily silent all the evening.

Late in the evening, when Rostov was about to leave, he asked
Denisov whether he had no commission for him.

"Yes, wait a bit," said Denisov, glancing round at the officers, and
taking his papers from under his pillow he went to the window, where
he had an inkpot, and sat down to write.

"It seems it's no use knocking one's head against a wall!" he
said, coming from the window and giving Rostov a large envelope. In it
was the petition to the Emperor drawn up by the auditor, in which
Denisov, without alluding to the offenses of the commissariat
officials, simply asked for pardon.

"Hand it in. It seems..."

He did not finish, but gave a painfully unnatural smile.





CHAPTER XIX


Having returned to the regiment and told the commander the state
of Denisov's affairs, Rostov rode to Tilsit with the letter to the
Emperor.

On the thirteenth of June the French and Russian Emperors arrived in
Tilsit. Boris Drubetskoy had asked the important personage on whom
he was in attendance, to include him in the suite appointed for the
stay at Tilsit.

"I should like to see the great man," he said, alluding to Napoleon,
whom hitherto he, like everyone else, had always called Buonaparte.

"You are speaking of Buonaparte?" asked the general, smiling.


Boris looked at his general inquiringly and immediately saw that
he was being tested.

"I am speaking, Prince, of the Emperor Napoleon," he replied. The
general patted him on the shoulder, with a smile.

"You will go far," he said, and took him to Tilsit with him.

Boris was among the few present at the Niemen on the day the two
Emperors met. He saw the raft, decorated with monograms, saw
Napoleon pass before the French Guards on the farther bank of the
river, saw the pensive face of the Emperor Alexander as he sat in
silence in a tavern on the bank of the Niemen awaiting Napoleon's
arrival, saw both Emperors get into boats, and saw how Napoleon-
reaching the raft first--stepped quickly forward to meet Alexander and
held out his hand to him, and how they both retired into the pavilion.
Since he had begun to move in the highest circles Boris had made it
his habit to watch attentively all that went on around him and to note
it down. At the time of the meeting at Tilsit he asked the names of
those who had come with Napoleon and about the uniforms they wore, and
listened attentively to words spoken by important personages. At the
moment the Emperors went into the pavilion he looked at his watch, and
did not forget to look at it again when Alexander came out. The
interview had lasted an hour and fifty-three minutes. He noted this
down that same evening, among other facts he felt to be of historic
importance. As the Emperor's suite was a very small one, it was a
matter of great importance, for a man who valued his success in the
service, to be at Tilsit on the occasion of this interview between the
two Emperors, and having succeeded in this, Boris felt that henceforth
his position was fully assured. He had not only become known, but
people had grown accustomed to him and accepted him. Twice he had
executed commissions to the Emperor himself, so that the latter knew
his face, and all those at court, far from cold-shouldering him as
at first when they considered him a newcomer, would now have been
surprised had he been absent.

Boris lodged with another adjutant, the Polish Count Zhilinski.
Zhilinski, a Pole brought up in Paris, was rich, and passionately fond
of the French, and almost every day of the stay at Tilsit, French
officers of the Guard and from French headquarters were dining and
lunching with him and Boris.

On the evening of the twenty-fourth of June, Count Zhilinski
arranged a supper for his French friends. The guest of honor was an
aide-de-camp of Napoleon's, there were also several French officers of
the Guard, and a page of Napoleon's, a young lad of an old
aristocratic French family. That same day, Rostov, profiting by the
darkness to avoid being recognized in civilian dress, came to Tilsit
and went to the lodging occupied by Boris and Zhilinski.

Rostov, in common with the whole army from which he came, was far
from having experienced the change of feeling toward Napoleon and
the French--who from being foes had suddenly become friends--that
had taken place at headquarters and in Boris. In the army, Bonaparte
and the French were still regarded with mingled feelings of anger,
contempt, and fear. Only recently, talking with one of Platov's
Cossack officers, Rostov had argued that if Napoleon were taken
prisoner he would be treated not as a sovereign, but as a criminal.
Quite lately, happening to meet a wounded French colonel on the
road, Rostov had maintained with heat that peace was impossible
between a legitimate sovereign and the criminal Bonaparte. Rostov
was therefore unpleasantly struck by the presence of French officers
in Boris' lodging, dressed in uniforms he had been accustomed to see
from quite a different point of view from the outposts of the flank.
As soon as he noticed a French officer, who thrust his head out of the
door, that warlike feeling of hostility which he always experienced at
the sight of the enemy suddenly seized him. He stopped at the
threshold and asked in Russian whether Drubetskoy lived there.
Boris, hearing a strange voice in the anteroom, came out to meet
him. An expression of annoyance showed itself for a moment on his face
on first recognizing Rostov.

"Ah, it's you? Very glad, very glad to see you," he said, however,
coming toward him with a smile. But Rostov had noticed his first
impulse.

"I've come at a bad time I think. I should not have come, but I have
business," he said coldly.

"No, I only wonder how you managed to get away from your regiment.
Dans un moment je suis a vous,"* he said, answering someone who called
him.


*"In a minute I shall be at your disposal."


"I see I'm intruding," Rostov repeated.

The look of annoyance had already disappeared from Boris' face:
having evidently reflected and decided how to act, he very quietly
took both Rostov's hands and led him into the next room. His eyes,
looking serenely and steadily at Rostov, seemed to be veiled by
something, as if screened by blue spectacles of conventionality. So it
seemed to Rostov.

"Oh, come now! As if you could come at a wrong time!" said Boris,
and he led him into the room where the supper table was laid and
introduced him to his guests, explaining that he was not a civilian,
but an hussar officer, and an old friend of his.

"Count Zhilinski--le Comte N. N.--le Capitaine S. S.," said he,
naming his guests. Rostov looked frowningly at the Frenchmen, bowed
reluctantly, and remained silent.

Zhilinski evidently did not receive this new Russian person very
willingly into his circle and did not speak to Rostov. Boris did not
appear to notice the constraint the newcomer produced and, with the
same pleasant composure and the same veiled look in his eyes with
which he had met Rostov, tried to enliven the conversation. One of the
Frenchmen, with the politeness characteristic of his countrymen,
addressed the obstinately taciturn Rostov, saying that the latter
had probably come to Tilsit to see the Emperor.

"No, I came on business," replied Rostov, briefly.

Rostov had been out of humor from the moment he noticed the look
of dissatisfaction on Boris' face, and as always happens to those in a
bad humor, it seemed to him that everyone regarded him with aversion
and that he was in everybody's way. He really was in their way, for he
alone took no part in the conversation which again became general. The
looks the visitors cast on him seemed to say: "And what is he
sitting here for?" He rose and went up to Boris.

"Anyhow, I'm in your way," he said in a low tone. "Come and talk
over my business and I'll go away."

"Oh, no, not at all," said Boris. "But if you are tired, come and
lie down in my room and have a rest."

"Yes, really..."

They went into the little room where Boris slept. Rostov, without
sitting down, began at once, irritably (as if Boris were to blame in
some way) telling him about Denisov's affair, asking him whether,
through his general, he could and would intercede with the Emperor
on Denisov's behalf and get Denisov's petition handed in. When he
and Boris were alone, Rostov felt for the first time that he could not
look Boris in the face without a sense of awkwardness. Boris, with one
leg crossed over the other and stroking his left hand with the slender
fingers of his right, listened to Rostov as a general listens to the
report of a subordinate, now looking aside and now gazing straight
into Rostov's eyes with the same veiled look. Each time this
happened Rostov felt uncomfortable and cast down his eyes.

"I have heard of such cases and know that His Majesty is very severe
in such affairs. I think it would be best not to bring it before the
Emperor, but to apply to the commander of the corps.... But in
general, I think..."

"So you don't want to do anything? Well then, say so!" Rostov almost
shouted, not looking Boris in the face.

Boris smiled.

"On the contrary, I will do what I can. Only I thought..."

At that moment Zhilinski's voice was heard calling Boris.

"Well then, go, go, go..." said Rostov, and refusing supper and
remaining alone in the little room, he walked up and down for a long
time, hearing the lighthearted French conversation from the next room.





CHAPTER XX


Rostov had come to Tilsit the day least suitable for a petition on
Denisov's behalf. He could not himself go to the general in attendance
as he was in mufti and had come to Tilsit without permission to do so,
and Boris, even had he wished to, could not have done so on the
following day. On that day, June 27, the preliminaries of peace were
signed. The Emperors exchanged decorations: Alexander received the
Cross of the Legion of Honor and Napoleon the Order of St. Andrew of
the First Degree, and a dinner had been arranged for the evening,
given by a battalion of the French Guards to the Preobrazhensk
battalion. The Emperors were to be present at that banquet.

Rostov felt so ill at ease and uncomfortable with Boris that, when
the latter looked in after supper, he pretended to be asleep, and
early next morning went away, avoiding Boris. In his civilian
clothes and a round hat, he wandered about the town, staring at the
French and their uniforms and at the streets and houses where the
Russian and French Emperors were staying. In a square he saw tables
being set up and preparations made for the dinner; he saw the
Russian and French colors draped from side to side of the streets,
with hugh monograms A and N. In the windows of the houses also flags
and bunting were displayed.

"Boris doesn't want to help me and I don't want to ask him. That's
settled," thought Nicholas. "All is over between us, but I won't leave
here without having done all I can for Denisov and certainly not
without getting his letter to the Emperor. The Emperor!... He is
here!" thought Rostov, who had unconsciously returned to the house
where Alexander lodged.

Saddled horses were standing before the house and the suite were
assembling, evidently preparing for the Emperor to come out.

"I may see him at any moment," thought Rostov. "If only I were to
hand the letter direct to him and tell him all... could they really
arrest me for my civilian clothes? Surely not! He would understand
on whose side justice lies. He understands everything, knows
everything. Who can be more just, more magnanimous than he? And even
if they did arrest me for being here, what would it matter?" thought
he, looking at an officer who was entering the house the Emperor
occupied. "After all, people do go in.... It's all nonsense! I'll go
in and hand the letter to the Emperor myself so much the worse for
Drubetskoy who drives me to it!" And suddenly with a determination
he himself did not expect, Rostov felt for the letter in his pocket
and went straight to the house.

"No, I won't miss my opportunity now, as I did after Austerlitz," he
thought, expecting every moment to meet the monarch, and conscious
of the blood that rushed to his heart at the thought. "I will fall
at his feet and beseech him. He will lift me up, will listen, and will
even thank me. 'I am happy when I can do good, but to remedy injustice
is the greatest happiness,'" Rostov fancied the sovereign saying.
And passing people who looked after him with curiosity, he entered the
porch of the Emperor's house.

A broad staircase led straight up from the entry, and to the right
he saw a closed door. Below, under the staircase, was a door leading
to the lower floor.

"Whom do you want?" someone inquired.

"To hand in a letter, a petition, to His Majesty," said Nicholas,
with a tremor in his voice.

"A petition? This way, to the officer on duty" (he was
shown the door leading downstairs), "only it won't be accepted."

On hearing this indifferent voice, Rostov grew frightened at what he
was doing; the thought of meeting the Emperor at any moment was so
fascinating and consequently so alarming that he was ready to run
away, but the official who had questioned him opened the door, and
Rostov entered.

A short stout man of about thirty, in white breeches and high
boots and a batiste shirt that he had evidently only just put on,
standing in that room, and his valet was buttoning on to the back of
his breeches a new pair of handsome silk-embroidered braces that,
for some reason, attracted Rostov's attention. This man was was
speaking to someone in the adjoining room.

"A good figure and in her first bloom," he was saying, but on seeing
Rostov, he stopped short and frowned.

"What is it? A petition?"

"What is it?" asked the person in the other room.

"Another petitioner," answered the man with the braces.

"Tell him to come later. He'll be coming out directly, we must go."

"Later... later! Tomorrow. It's too late..."

Rostov turned and was about to go, but the man in the braces stopped
him.

"Whom have you come from? Who are you?"

"I come from Major Denisov," answered Rostov.

"Are you an officer?"

"Lieutenant Count Rostov."

"What audacity! Hand it in through your commander. And go along with
you... go," and he continued to put on the uniform the valet handed
him.

Rostov went back into the hall and noticed that in the porch there
were many officers and generals in full parade uniform, whom he had to
pass.

Cursing his temerity, his heart sinking at the thought of finding
himself at any moment face to face with the Emperor and being put to
shame and arrested in his presence, fully alive now to the impropriety
of his conduct and repenting of it, Rostov, with downcast eyes, was
making his way out of the house through the brilliant suite when a
familiar voice called him and a hand detained him.

"What are you doing here, sir, in civilian dress?" asked a deep
voice.

It was a cavalry general who had obtained the Emperor's special
favor during this campaign, and who had formerly commanded the
division in which Rostov was serving.

Rostov, in dismay, began justifying himself, but seeing the
kindly, jocular face of the general, he took him aside and in an
excited voice told him the whole affair, asking him to intercede for
Denisov, whom the general knew. Having heard Rostov to the end, the
general shook his head gravely.

"I'm sorry, sorry for that fine fellow. Give me the letter."

Hardly had Rostov handed him the letter and finished explaining
Denisov's case, when hasty steps and the jingling of spurs were
heard on the stairs, and the general, leaving him, went to the
porch. The gentlemen of the Emperor's suite ran down the stairs and
went to their horses. Hayne, the same groom who had been at
Austerlitz, led up the Emperor's horse, and the faint creak of a
footstep Rostov knew at once was heard on the stairs. Forgetting the
danger of being recognized, Rostov went close to the porch, together
with some inquisitive civilians, and again, after two years, saw those
features he adored: that same face and same look and step, and the
same union of majesty and mildness.... And the feeling of enthusiasm
and love for his sovereign rose again in Rostov's soul in all its
old force. In the uniform of the Preobrazhensk regiment--white
chamois-leather breeches and high boots--and wearing a star Rostov did
not know (it was that of the Legion d'honneur), the monarch came out
into the porch, putting on his gloves and carrying his hat under his
arm. He stopped and looked about him, brightening everything around by
his glance. He spoke a few words to some of the generals, and,
recognizing the former commander of Rostov's division, smiled and
beckoned to him.

All the suite drew back and Rostov saw the general talking for
some time to the Emperor.

The Emperor said a few words to him and took a step toward his
horse. Again the crowd of members of the suite and street gazers
(among whom was Rostov) moved nearer to the Emperor. Stopping beside
his horse, with his hand on the saddle, the Emperor turned to the
cavalry general and said in a loud voice, evidently wishing to be
heard by all:

"I cannot do it, General. I cannot, because the law is stronger than
I," and he raised his foot to the stirrup.

The general bowed his head respectfully, and the monarch mounted and
rode down the street at a gallop. Beside himself with enthusiasm,
Rostov ran after him with the crowd.





CHAPTER XXI


The Emperor rode to the square where, facing one another, a
battalion of the Preobrazhensk regiment stood on the right and a
battalion of the French Guards in their bearskin caps on the left.

As the Tsar rode up to one flank of the battalions, which
presented arms, another group of horsemen galloped up to the
opposite flank, and at the head of them Rostov recognized Napoleon. It
could be no one else. He came at a gallop, wearing a small hat, a blue
uniform open over a white vest, and the St. Andrew ribbon over his
shoulder. He was riding a very fine thoroughbred gray Arab horse
with a crimson gold-embroidered saddlecloth. On approaching
Alexander he raised his hat, and as he did so, Rostov, with his
cavalryman's eye, could not help noticing that Napoleon did not sit
well or firmly in the saddle. The battalions shouted "Hurrah!" and
"Vive l'Empereur!" Napoleon said something to Alexander, and both
Emperors dismounted and took each other's hands. Napoleon's face
wore an unpleasant and artificial smile. Alexander was saying
something affable to him.

In spite of the trampling of the French gendarmes' horses, which
were pushing back the crowd, Rostov kept his eyes on every movement of
Alexander and Bonaparte. It struck him as a surprise that Alexander
treated Bonaparte as an equal and that the latter was quite at ease
with the Tsar, as if such relations with an Emperor were an everyday
matter to him.

Alexander and Napoleon, with the long train of their suites,
approached the right flank of the Preobrazhensk battalion and came
straight up to the crowd standing there. The crowd unexpectedly
found itself so close to the Emperors that Rostov, standing in the
front row, was afraid he might be recognized.

"Sire, I ask your permission to present the Legion of Honor to the
bravest of your soldiers," said a sharp, precise voice, articulating
every letter.

This was said by the undersized Napoleon, looking up straight into
Alexander's eyes. Alexander listened attentively to what was said to
him and, bending his head, smiled pleasantly.

"To him who has borne himself most bravely in this last war,"
added Napoleon, accentuating each syllable, as with a composure and
assurance exasperating to Rostov, he ran his eyes over the Russian
ranks drawn up before him, who all presented arms with their eyes
fixed on their Emperor.

"Will Your Majesty allow me to consult the colonel?" said
Alexander and took a few hasty steps toward Prince Kozlovski, the
commander of the battalion.

Bonaparte meanwhile began taking the glove off his small white hand,
tore it in doing so, and threw it away. An aide-de-camp behind him
rushed forward and picked it up.

"To whom shall it be given?" the Emperor Alexander asked
Koslovski, in Russian in a low voice.

"To whomever Your Majesty commands."

The Emperor knit his brows with dissatisfaction and, glancing
back, remarked:

"But we must give him an answer."

Kozlovski scanned the ranks resolutely and included Rostov in his
scrutiny.

"Can it be me?" thought Rostov.

"Lazarev!" the colonel called, with a frown, and Lazarev, the
first soldier in the rank, stepped briskly forward.

"Where are you off to? Stop here!" voices whispered to Lazarev who
did not know where to go. Lazarev stopped, casting a sidelong look
at his colonel in alarm. His face twitched, as often happens to
soldiers called before the ranks.

Napoleon slightly turned his head, and put his plump little hand out
behind him as if to take something. The members of his suite, guessing
at once what he wanted, moved about and whispered as they passed
something from one to another, and a page--the same one Rostov had
seen the previous evening at Boris'--ran forward and, bowing
respectfully over the outstretched hand and not keeping it waiting a
moment, laid in it an Order on a red ribbon. Napoleon, without
looking, pressed two fingers together and the badge was between
them. Then he approached Lazarev (who rolled his eyes and persistently
gazed at his own monarch), looked round at the Emperor Alexander to
imply that what he was now doing was done for the sake of his ally,
and the small white hand holding the Order touched one of Lazarev's
buttons. It was as if Napoleon knew that it was only necessary for his
hand to deign to touch that soldier's breast for the soldier to be
forever happy, rewarded, and distinguished from everyone else in the
world. Napoleon merely laid the cross on Lazarev's breast and,
dropping his hand, turned toward Alexander as though sure that the
cross would adhere there. And it really did.

Officious hands, Russian and French, immediately seized the cross
and fastened it to the uniform. Lazarev glanced morosely at the little
man with white hands who was doing something to him and, still
standing motionless presenting arms, looked again straight into
Alexander's eyes, as if asking whether he should stand there, or go
away, or do something else. But receiving no orders, he remained for
some time in that rigid position.

The Emperors remounted and rode away. The Preobrazhensk battalion,
breaking rank, mingled with the French Guards and sat down at the
tables prepared for them.

Lazarev sat in the place of honor. Russian and French officers
embraced him, congratulated him, and pressed his hands. Crowds of
officers and civilians drew near merely to see him. A rumble of
Russian and French voices and laughter filled the air round the tables
in the square. Two officers with flushed faces, looking cheerful and
happy, passed by Rostov.

"What d'you think of the treat? All on silver plate," one of them
was saying. "Have you seen Lazarev?"

"I have."

"Tomorrow, I hear, the Preobrazhenskis will give them a dinner."

"Yes, but what luck for Lazarev! Twelve hundred francs' pension
for life."

"Here's a cap, lads!" shouted a Preobrazhensk soldier, donning a
shaggy French cap.

"It's a fine thing! First-rate!"

"Have you heard the password?" asked one Guards' officer of another.
"The day before yesterday it was 'Napoleon, France, bravoure';
yesterday, 'Alexandre, Russie, grandeur.' One day our Emperor gives it
and next day Napoleon. Tomorrow our Emperor will send a St. George's
Cross to the bravest of the French Guards. It has to be done. He
must respond in kind."

Boris, too, with his friend Zhilinski, came to see the Preobrazhensk
banquet. On his way back, he noticed Rostov standing by the corner
of a house.

"Rostov! How d'you do? We missed one another," he said, and could
not refrain from asking what was the matter, so strangely dismal and
troubled was Rostov's face.

"Nothing, nothing," replied Rostov.

"You'll call round?"

"Yes, I will."

Rostov stood at that corner for a long time, watching the feast from
a distance. In his mind, a painful process was going on
which he could not bring to a conclusion. Terrible doubts rose in
his soul. Now he remembered Denisov with his changed expression, his
submission, and the whole hospital, with arms and legs torn off and
its dirt and disease. So vividly did he recall that hospital stench of
dead flesh that he looked round to see where the smell came from. Next
he thought of that self-satisfied Bonaparte, with his small white
hand, who was now an Emperor, liked and respected by Alexander. Then
why those severed arms and legs and those dead men?... Then again he
thought of Lazarev rewarded and Denisov punished and unpardoned. He
caught himself harboring such strange thoughts that he was frightened.

The smell of the food the Preobrazhenskis were eating and a sense of
hunger recalled him from these reflections; he had to get something to
eat before going away. He went to a hotel he had noticed that morning.
There he found so many people, among them officers who, like
himself, had come in civilian clothes, that he had difficulty in
getting a dinner. Two officers of his own division joined him. The
conversation naturally turned on the peace. The officers, his
comrades, like most of the army, were dissatisfied with the peace
concluded after the battle of Friedland. They said that had we held
out a little longer Napoleon would have been done for, as his troops
had neither provisions nor ammunition. Nicholas ate and drank (chiefly
the latter) in silence. He finished a couple of bottles of wine by
himself. The process in his mind went on tormenting him without
reaching a conclusion. He feared to give way to his thoughts, yet
could not get rid of them. Suddenly, on one of the officers' saying
that it was humiliating to look at the French, Rostov began shouting
with uncalled-for wrath, and therefore much to the surprise of the
officers:

"How can you judge what's best?" he cried, the blood suddenly
rushing to his face. "How can you judge the Emperor's actions? What
right have we to argue? We cannot comprehend either the Emperor's or
his actions!"

"But I never said a word about the Emperor!" said the officer,
justifying himself, and unable to understand Rostov's outburst, except
on the supposition that he was drunk.

But Rostov did not listen to him.

"We are not diplomatic officials, we are soldiers and nothing more,"
he went on. "If we are ordered to die, we must die. If we're punished,
it means that we have deserved it, it's not for us to judge. If the
Emperor pleases to recognize Bonaparte as Emperor and to conclude an
alliance with him, it means that that is the right thing to do. If
once we begin judging and arguing about everything, nothing sacred
will be left! That way we shall be saying there is no God--nothing!"
shouted Nicholas, banging the table--very little to the point as it
seemed to his listeners, but quite relevantly to the course of his own
thoughts.

"Our business is to do our duty, to fight and not to think! That's
all...." said he.

"And to drink," said one of the officers, not wishing to quarrel.

"Yes, and to drink," assented Nicholas. "Hullo there! Another
bottle!" he shouted.

In 1808 the Emperor Alexander went to Erfurt for a fresh interview
with the Emperor Napoleon, and in the upper circles of Petersburg
there was much talk of the grandeur of this important meeting.





CHAPTER XXII


In 1809 the intimacy between "the world's two arbiters," as Napoleon
and Alexander were called, was such that when Napoleon declared war on
Austria a Russian corps crossed the frontier to co-operate with our
old enemy Bonaparte against our old ally the Emperor of Austria, and
in court circles the possibility of marriage between Napoleon and
one of Alexander's sisters was spoken of. But besides considerations
of foreign policy, the attention of Russian society was at that time
keenly directed on the internal changes that were being undertaken
in all the departments of government.

Life meanwhile--real life, with its essential interests of health
and sickness, toil and rest, and its intellectual interests in
thought, science, poetry, music, love, friendship, hatred, and
passions--went on as usual, independently of and apart from
political friendship or enmity with Napoleon Bonaparte and from all
the schemes of reconstruction.




BOOK SIX: 1808 --10





CHAPTER I


Prince Andrew had spent two years continuously in the country.

All the plans Pierre had attempted on his estates--and constantly
changing from one thing to another had never accomplished--were
carried out by Prince Andrew without display and without perceptible
difficulty.

He had in the highest degree a practical tenacity which Pierre
lacked, and without fuss or strain on his part this set things going.

On one of his estates the three hundred serfs were liberated and
became free agricultural laborers--this being one of the first
examples of the kind in Russia. On other estates the serfs' compulsory
labor was commuted for a quitrent. A trained midwife was engaged for
Bogucharovo at his expense, and a priest was paid to teach reading and
writing to the children of the peasants and household serfs.

Prince Andrew spent half his time at Bald Hills with his father
and his son, who was still in the care of nurses. The other half he
spent in "Bogucharovo Cloister," as his father called Prince
Andrew's estate. Despite the indifference to the affairs of the
world he had expressed to Pierre, he diligently followed all that went
on, received many books, and to his surprise noticed that when he or
his father had visitors from Petersburg, the very vortex of life,
these people lagged behind himself--who never left the country--in
knowledge of what was happening in home and foreign affairs.

Besides being occupied with his estates and reading a great
variety of books, Prince Andrew was at this time busy with a
critical of survey our last two unfortunate campaigns, and with
drawing up a proposal for a reform of the army rules and regulations.

In the spring of 1809 he went to visit the Ryazan estates which
had been inherited by his son, whose guardian he was.

Warmed by the spring sunshine he sat in the caleche looking at the
new grass, the first leaves on the birches, and the first puffs of
white spring clouds floating across the clear blue sky. He was not
thinking of anything, but looked absent-mindedly and cheerfully from
side to side.

They crossed the ferry where he had talked with Pierre the year
before. They went through the muddy village, past threshing floors and
green fields of winter rye, downhill where snow still lodged near
the bridge, uphill where the clay had been liquefied by the rain, past
strips of stubble land and bushes touched with green here and there,
and into a birch forest growing on both sides of the road. In the
forest it was almost hot, no wind could be felt. The birches with
their sticky green leaves were motionless, and lilac-colored flowers
and the first blades of green grass were pushing up and lifting last
year's leaves. The coarse evergreen color of the small fir trees
scattered here and there among the birches was an unpleasant
reminder of winter. On entering the forest the horses began to snort
and sweated visibly.

Peter the footman made some remark to the coachman; the latter
assented. But apparently the coachman's sympathy was not enough for
Peter, and he turned on the box toward his master.

"How pleasant it is, your excellency!" he said with a respectful
smile.

"What?"

"It's pleasant, your excellency!"

"What is he talking about?" thought Prince Andrew. "Oh, the
spring, I suppose," he thought as he turned round. "Yes, really
everything is green already.... How early! The birches and cherry
and alders too are coming out.... But the oaks show no sign yet. Ah,
here is one oak!"

 At the edge of the road stood an oak. Probably ten times the age of
the birches that formed the forest, it was ten times as thick and
twice as tall as they. It was an enormous tree, its girth twice as
great as a man could embrace, and evidently long ago some of its
branches had been broken off and its bark scarred. With its huge
ungainly limbs sprawling unsymmetrically, and its gnarled hands and
fingers, it stood an aged, stern, and scornful monster among the
smiling birch trees. Only the dead-looking evergreen firs dotted about
in the forest, and this oak, refused to yield to the charm of spring
or notice either the spring or the sunshine.

"Spring, love, happiness!" this oak seemed to say. "Are you not
weary of that stupid, meaningless, constantly repeated fraud? Always
the same and always a fraud? There is no spring, no sun, no happiness!
Look at those cramped dead firs, ever the same, and at me too,
sticking out my broken and barked fingers just where they have
grown, whether from my back or my sides: as they have grown so I
stand, and I do not believe in your hopes and your lies."

As he passed through the forest Prince Andrew turned several times
to look at that oak, as if expecting something from it. Under the oak,
too, were flowers and grass, but it stood among them scowling,
rigid, misshapen, and grim as ever.

"Yes, the oak is right, a thousand times right," thought Prince
Andrew. "Let others--the young--yield afresh to that fraud, but we
know life, our life is finished!"

A whole sequence of new thoughts, hopeless but mournfully
pleasant, rose in his soul in connection with that tree. During this
journey he, as it were, considered his life afresh and arrived at
his old conclusion, restful in its hopelessness: that it was not for
him to begin anything anew--but that he must live out his life,
content to do no harm, and not disturbing himself or desiring
anything.





CHAPTER II


Prince Andrew had to see the Marshal of the Nobility for the
district in connection with the affairs of the Ryazan estate of
which he was trustee. This Marshal was Count Ilya Rostov, and in the
middle of May Prince Andrew went to visit him.

It was now hot spring weather. The whole forest was already
clothed in green. It was dusty and so hot that on passing near water
one longed to bathe.

Prince Andrew, depressed and preoccupied with the business about
which he had to speak to the Marshal, was driving up the avenue in the
grounds of the Rostovs' house at Otradnoe. He heard merry girlish
cries behind some trees on the right and saw a group of girls running to
cross the path of his caleche. Ahead of the rest and nearer to him ran
a dark-haired, remarkably slim, pretty girl in a yellow chintz
dress, with a white handkerchief on her head from under which loose
locks of hair escaped. The girl was shouting something but, seeing
that he was a stranger, ran back laughing without looking at him.

Suddenly, he did not know why, he felt a pang. The day was so
beautiful, the sun so bright, everything around so gay, but that
slim pretty girl did not know, or wish to know, of his existence and
was contented and cheerful in her own separate--probably foolish-
but bright and happy life. "What is she so glad about? What is she
thinking of? Not of the military regulations or of the arrangement
of the Ryazan serfs' quitrents. Of what is she thinking? Why is she so
happy?" Prince Andrew asked himself with instinctive curiosity.

In 1809 Count Ilya Rostov was living at Otradnoe just as he had done
in former years, that is, entertaining almost the whole province
with hunts, theatricals, dinners, and music. He was glad to see Prince
Andrew, as he was to see any new visitor, and insisted on his
staying the night.

During the dull day, in the course of which he was entertained by
his elderly hosts and by the more important of the visitors (the old
count's house was crowded on account of an approaching name day),
Prince Andrew repeatedly glanced at Natasha, gay and laughing among
the younger members of the company, and asked himself each time, "What
is she thinking about? Why is she so glad?"

That night, alone in new surroundings, he was long unable to
sleep. He read awhile and then put out his candle, but relit it. It
was hot in the room, the inside shutters of which were closed. He
was cross with the stupid old man (as he called Rostov), who had
made him stay by assuring him that some necessary documents had not
yet arrived from town, and he was vexed with himself for having
stayed.

He got up and went to the window to open it. As soon as he opened
the shutters the moonlight, as if it had long been watching for
this, burst into the room. He opened the casement. The night was
fresh, bright, and very still. Just before the window was a row of
pollard trees, looking black on one side and with a silvery light on
the other. Beneath the trees grewsome kind of lush, wet, bushy
vegetation with silver-lit leaves and stems here and there. Farther
back beyond the dark trees a roof glittered with dew, to the right was
a leafy tree with brilliantly white trunk and branches, and above it
shone the moon, nearly at its full, in a pale, almost starless, spring
sky. Prince Andrew leaned his elbows on the window ledge and his
eyes rested on that sky.

His room was on the first floor. Those in the rooms above were
also awake. He heard female voices overhead.

"Just once more," said a girlish voice above him which Prince Andrew
recognized at once.

"But when are you coming to bed?" replied another voice.

"I won't, I can't sleep, what's the use? Come now for the last
time."

 Two girlish voices sang a musical passage--the end of some song.

"Oh, how lovely! Now go to sleep, and there's an end of it."

"You go to sleep, but I can't," said the first voice, coming
nearer to the window. She was evidently leaning right out, for the
rustle of her dress and even her breathing could be heard.
Everything was stone-still, like the moon and its light and the
shadows. Prince Andrew, too, dared not stir, for fear of betraying his
unintentional presence.

"Sonya! Sonya!" he again heard the first speaker. "Oh, how can you
sleep? Only look how glorious it is! Ah, how glorious! Do wake up,
Sonya!" she said almost with tears in her voice. "There never, never
was such a lovely night before!"

Sonya made some reluctant reply.

"Do just come and see what a moon!... Oh, how lovely! Come
here.... Darling, sweetheart, come here! There, you see? I feel like
sitting down on my heels, putting my arms round my knees like this,
straining tight, as tight as possible, and flying away! Like this...."

"Take care, you'll fall out."

He heard the sound of a scuffle and Sonya's disapproving voice:
"It's past one o'clock."

"Oh, you only spoil things for me. All right, go, go!"

Again all was silent, but Prince Andrew knew she was still sitting
there. From time to time he heard a soft rustle and at times a sigh.

"O God, O God! What does it mean?" she suddenly exclaimed. "To bed
then, if it must be!" and she slammed the casement.

"For her I might as well not exist!" thought Prince Andrew while
he listened to her voice, for some reason expecting yet fearing that
she might say something about him. "There she is again! As if it
were on purpose," thought he.

In his soul there suddenly arose such an unexpected turmoil of
youthful thoughts and hopes, contrary to the whole tenor of his
life, that unable to explain his condition to himself he lay down
and fell asleep at once.





CHAPTER III


Next morning, having taken leave of no one but the count, and not
waiting for the ladies to appear, Prince Andrew set off for home.

It was already the beginning of June when on his return journey he
drove into the birch forest where the gnarled old oak had made so
strange and memorable an impression on him. In the forest the
harness bells sounded yet more muffled than they had done six weeks
before, for now all was thick, shady, and dense, and the young firs
dotted about in the forest did not jar on the general beauty but,
lending themselves to the mood around, were delicately green with
fluffy young shoots.

The whole day had been hot. Somewhere a storm was gathering, but
only a small cloud had scattered some raindrops lightly, sprinkling
the road and the sappy leaves. The left side of the forest was dark in
the shade, the right side glittered in the sunlight, wet and shiny and
scarcely swayed by the breeze. Everything was in blossom, the
nightingales trilled, and their voices reverberated now near, now
far away.

"Yes, here in this forest was that oak with which I agreed," thought
Prince Andrew. "But where is it?" he again wondered, gazing at the
left side of the road, and without recognizing it he looked with
admiration at the very oak he sought. The old oak, quite transfigured,
spreading out a canopy of sappy dark-green foliage, stood rapt and
slightly trembling in the rays of the evening sun. Neither gnarled
fingers nor old scars nor old doubts and sorrows were any of them in
evidence now. Through the hard century-old bark, even where there were
no twigs, leaves had sprouted such as one could hardly believe the old
veteran could have produced.

"Yes, it is the same oak," thought Prince Andrew, and all at once he
was seized by an unreasoning springtime feeling of joy and renewal.
All the best moments of his life suddenly rose to his memory.
Austerlitz with the lofty heavens, his wife's dead reproachful face,
Pierre at the ferry, that girl thrilled by the beauty of the night,
and that night itself and the moon, and.... all this rushed suddenly
to his mind.

"No, life is not over at thirty-one!" Prince Andrew suddenly decided
finally and decisively. "It is not enough for me to know what I have
in me--everyone must know it: Pierre, and that young girl who wanted
to fly away into the sky, everyone must know me, so that my life may
not be lived for myself alone while others live so apart from it,
but so that it may be reflected in them all, and they and I may live
in harmony!"


On reaching home Prince Andrew decided to go to Petersburg that
autumn and found all sorts of reasons for this decision. A whole
serics of sensible and logical considerations showing it to be
essential for him to go to Petersburg, and even to re-enter the
service, kept springing up in his mind. He could not now understand
how he could ever even have doubted the necessity of taking an
active share in life, just as a month before he had not understood how
the idea of leaving the quiet country could ever enter his head. It
now seemed clear to him that all his experience of life must be
senselessly wasted unless he applied it to some kind of work and again
played an active part in life. He did not even remember how
formerly, on the strength of similar wretched logical arguments, it
had seemed obvious that he would be degrading himself if he now, after
the lessons he had had in life, allowed himself to believe in the
possibility of being useful and in the possibility of happiness or
love. Now reason suggested quite the opposite. After that journey to
Ryazan he found the country dull; his former pursuits no longer
interested him, and often when sitting alone in his study he got up,
went to the mirror, and gazed a long time at his own face. Then he
would turn away to the portrait of his dead Lise, who with hair curled
a la grecque looked tenderly and gaily at him out of the gilt frame.
She did not now say those former terrible words to him, but looked
simply, merrily, and inquisitively at him. And Prince Andrew, crossing
his arms behind him, long paced the room, now frowning, now smiling,
as he reflected on those irrational, inexpressible thoughts, secret as
a crime, which altered his whole life and were connected with
Pierre, with fame, with the girl at the window, the oak, and woman's
beauty and love. And if anyone came into his room at such moments he
was particularly cold, stern, and above all unpleasantly logical.

"My dear," Princess Mary entering at such a moment would say,
"little Nicholas can't go out today, it's very cold."

"If it were hot," Prince Andrew would reply at such times very dryly
to his sister, "he could go out in his smock, but as it is cold he
must wear warm clothes, which were designed for that purpose. That
is what follows from the fact that it is cold; and not that a child
who needs fresh air should remain at home," he would add with
extreme logic, as if punishing someone for those secret illogical
emotions that stirred within him.

At such moments Princess Mary would think how intellectual work
dries men up.





CHAPTER IV


Prince Andrew arrived in Petersburg in August, 1809. It was the time
when the youthful Speranski was at the zenith of his fame and his
reforms were being pushed forward with the greatest energy. That
same August the Emperor was thrown from his caleche, injured his
leg, and remained three weeks at Peterhof, receiving Speranski every
day and no one else. At that time the two famous decrees were being
prepared that so agitated society--abolishing court ranks and
introducing examinations to qualify for the grades of Collegiate
Assessor and State Councilor--and not merely these but a whole state
constitution, intended to change the existing order of government in
Russia: legal, administrative, and financial, from the Council of
State down to the district tribunals. Now those vague liberal dreams
with which the Emperor Alexander had ascended the throne, and which he
had tried to put into effect with the aid of his associates,
Czartoryski, Novosiltsev, Kochubey, and Strogonov--whom he himself
in jest had called his Comite de salut public--were taking shape and
being realized.

Now all these men were replaced by Speranski on the civil side,
and Arakcheev on the military. Soon after his arrival Prince Andrew,
as a gentleman of the chamber, presented himself at court and at a
levee. The Emperor, though he met him twice, did not favor him with
a single word. It had always seemed to Prince Andrew before that he
was antipathetic to the Emperor and that the latter disliked his
face and personality generally, and in the cold, repellent glance
the Emperor gave him, he now found further confirmation of this
surmise. The courtiers explained the Emperor's neglect of him by His
Majesty's displeasure at Bolkonski's not having served since 1805.

"I know myself that one cannot help one's sympathies and
antipathies," thought Prince Andrew, "so it will not do to present
my proposal for the reform of the army regulations to the Emperor
personally, but the project will speak for itself."

He mentioned what he had written to an old field marshal, a friend
of his father's. The field marshal made an appointment to see him,
received him graciously, and promised to inform the Emperor. A few
days later Prince Andrew received notice that he was to go to see
the Minister of War, Count Arakcheev.


On the appointed day Prince Andrew entered Count Arakcheev's waiting
room at nine in the morning.

He did not know Arakcheev personally, had never seen him, and all he
had heard of him inspired him with but little respect for the man.

"He is Minister of War, a man trusted by the Emperor, and I need not
concern myself about his personal qualities: he has been
commissioned to consider my project, so he alone can get it
adopted," thought Prince Andrew as he waited among a number of
important and unimportant people in Count Arakcheev's waiting room.

During his service, chiefly as an adjutant, Prince Andrew had seen
the anterooms of many important men, and the different types of such
rooms were well known to him. Count Arakcheev's anteroom had quite a
special character. The faces of the unimportant people awaiting
their turn for an audience showed embarrassment and servility; the
faces of those of higher rank expressed a common feeling of
awkwardness, covered by a mask of unconcern and ridicule of
themselves, their situation, and the person for whom they were
waiting. Some walked thoughtfully up and down, others whispered and
laughed. Prince Andrew heard the nickname "Sila Andreevich" and the
words, "Uncle will give it to us hot," in reference to Count
Arakcheev. One general (an important personage), evidently feeling
offended at having to wait so long, sat crossing and uncrossing his
legs and smiling contemptuously to himself.

But the moment the door opened one feeling alone appeared on all
faces--that of fear. Prince Andrew for the second time asked the
adjutant on duty to take in his name, but received an ironical look
and was told that his turn would come in due course. After some others
had been shown in and out of the minister's room by the adjutant on
duty, an officer who struck Prince Andrew by his humiliated and
frightened air was admitted at that terrible door. This officer's
audience lasted a long time. Then suddenly the grating sound of a
harsh voice was heard from the other side of the door, and the
officer--with pale face and trembling lips--came out and passed
through the waiting room, clutching his head.

After this Prince Andrew was conducted to the door and the officer
on duty said in a whisper, "To the right, at the window."

Prince Andrew entered a plain tidy room and saw at the table a man
of forty with a long waist, a long closely cropped head, deep
wrinkles, scowling brows above dull greenish-hazel eyes and an
overhanging red nose. Arakcheev turned his head toward him without
looking at him.

"What is your petition?" asked Arakcheev.

"I am not petitioning, your excellency," returned Prince Andrew
quietly.

Arakcheev's eyes turned toward him.

"Sit down," said he. "Prince Bolkonski?"

"I am not petitioning about anything. His Majesty the Emperor has
deigned to send your excellency a project submitted by me..."

"You see, my dear sir, I have read your project," interrupted
Arakcheev, uttering only the first words amiably and then--again
without looking at Prince Andrew--relapsing gradually into a tone of
grumbling contempt. "You are proposing new military laws? There are
many laws but no one to carry out the old ones. Nowadays everybody
designs laws, it is easier writing than doing."

"I came at His Majesty the Emperor's wish to learn from your
excellency how you propose to deal with the memorandum I have
presented," said Prince Andrew politely.

"I have endorsed a resolution on your memorandum and sent it to
the committee. I do not approve of it," said Arakcheev, rising and
taking a paper from his writing table. "Here!" and he handed it to
Prince Andrew.

Across the paper was scrawled in pencil, without capital letters,
misspelled, and without punctuation: "Unsoundly constructed because
resembles an imitation of the French military code and from the
Articles of War needlessly deviating."

"To what committee has the memorandum been referred?" inquired
Prince Andrew.

"To the Committee on Army Regulations, and I have recommended that
your honor should be appointed a member, but without a salary."

Prince Andrew smiled.

"I don't want one."

"A member without salary," repeated Arakcheev. "I have the
honor... Eh! Call the next one! Who else is there?" he shouted, bowing
to Prince Andrew.





CHAPTER V


While waiting for the announcement of his appointment to the
committee Prince Andrew looked up his former acquaintances,
particularly those he knew to be in power and whose aid he might need.
In Petersburg he now experienced the same feeling he had had on the
eve of a battle, when troubled by anxious curiosity and irresistibly
attracted to the ruling circles where the future, on which the fate of
millions depended, was being shaped. From the irritation of the
older men, the curiosity of the uninitiated, the reserve of the
initiated, the hurry and preoccupation of everyone, and the
innumerable committees and commissions of whose existence he learned
every day, he felt that now, in 1809, here in Petersburg a vast
civil conflict was in preparation, the commander in chief of which was
a mysterious person he did not know, but who was supposed to be a
man of genius--Speranski. And this movement of reconstruction of which
Prince Andrew had a vague idea, and Speranski its chief promoter,
began to interest him so keenly that the question of the army
regulations quickly receded to a secondary place in his consciousness.

Prince Andrew was most favorably placed to secure good reception
in the highest and most diverse Petersburg circles of the day. The
reforming party cordially welcomed and courted him, the first place
because he was reputed to be clever and very well read, and secondly
because by liberating his serfs he had obtained the reputation of
being a liberal. The party of the old and dissatisfied, who censured
the innovations, turned to him expecting his sympathy in their
disapproval of the reforms, simply because he was the son of his
father. The feminine society world welcomed him gladly, because he was
rich, distinguished, a good match, and almost a newcomer, with a
halo of romance on account of his supposed death and the tragic loss
of his wife. Besides this the general opinion of all who had known him
previously was that he had greatly improved during these last five
years, having softened and grown more manly, lost his former
affectation, pride, and contemptuous irony, and acquired the
serenity that comes with years. People talked about him, were
interested in him, and wanted to meet him.

The day after his interview with Count Arakcheev, Prince Andrew
spent the evening at Count Kochubey's. He told the count of his
interview with Sila Andreevich (Kochubey spoke of Arakcheev by that
nickname with the same vague irony Prince Andrew had noticed in the
Minister of War's anteroom).

"Mon cher, even in this case you can't do without Michael
Mikhaylovich Speranski. He manages everything. I'll speak to him. He
has promised to come this evening."

"What has Speranski to do with the army regulations?" asked Prince
Andrew.

Kochubey shook his head smilingly, as if surprised at Bolkonski's
simplicity.

"We were talking to him about you a few days ago," Kochubey
continued, "and about your freed plowmen."

"Oh, is it you, Prince, who have freed your serfs?" said an old
man of Catherine's day, turning contemptuously toward Bolkonski.

"It was a small estate that brought in no profit," replied Prince
Andrew, trying to extenuate his action so as not to irritate the old
man uselessly.

"Afraid of being late..." said the old man, looking at Kochubey.

"There's one thing I don't understand," he continued. "Who will plow
the land if they are set free? It is easy to write laws, but difficult
to rule.... Just the same as now--I ask you, Count--who will be
heads of the departments when everybody has to pass examinations?"

"Those who pass the examinations, I suppose," replied Kochubey,
crossing his legs and glancing round.

"Well, I have Pryanichnikov serving under me, a splendid man, a
priceless man, but he's sixty. Is he to go up for examination?"

"Yes, that's a difficulty, as education is not at all general,
but..."

Count Kochubey did not finish. He rose, took Prince Andrew by the
arm, and went to meet a tall, bald, fair man of about forty with a
large open forehead and a long face of unusual and peculiar whiteness,
who was just entering. The newcomer wore a blue swallow-tail coat with
a cross suspended from his neck and a star on his left breast. It
was Speranski. Prince Andrew recognized him at once, and felt a
throb within him, as happens at critical moments of life. Whether it
was from respect, envy, or anticipation, he did not know.
Speranski's whole figure was of a peculiar type that made him easily
recognizable. In the society in which Prince Andrew lived he had never
seen anyone who together with awkward and clumsy gestures possessed
such calmness and self-assurance; he had never seen so resolute yet
gentle an expression as that in those half-closed, rather humid
eyes, or so firm a smile that expressed nothing; nor had he heard such
a refined, smooth, soft voice; above all he had never seen such
delicate whiteness of face or hands--hands which were broad, but
very plump, soft, and white. Such whiteness and softness Prince Andrew
had only seen on the faces of soldiers who had been long in
hospital. This was Speranski, Secretary of State, reporter to the
Emperor and his companion at Erfurt, where he had more than once met
and talked with Napoleon.

Speranski did not shift his eyes from one face to another as
people involuntarily do on entering a large company and was in no
hurry to speak. He spoke slowly, with assurance that he would be
listened to, and he looked only at the person with whom he was
conversing.

Prince Andrew followed Speranski's every word and movement with
particular attention. As happens to some people, especially to men who
judge those near to them severely, he always on meeting anyone new-
especially anyone whom, like Speranski, he knew by reputation-
expected to discover in him the perfection of human qualities.

Speranski told Kochubey he was sorry he had been unable to come
sooner as he had been detained at the palace. He did not say that
the Emperor had kept him, and Prince Andrew noticed this affectation
of modesty. When Kochubey introduced Prince Andrew, Speranski slowly
turned his eyes to Bolkonski with his customary smile and looked at
him in silence.

"I am very glad to make your acquaintance. I had heard of you, as
everyone has," he said after a pause.

Kochubey said a few words about the reception Arakcheev had given
Bolkonski. Speranski smiled more markedly.

"The chairman of the Committee on Army Regulations is my good friend
Monsieur Magnitski," he said, fully articulating every word and
syllable, "and if you like I can put you in touch with him." He paused
at the full stop. "I hope you will find him sympathetic and ready to
co-operate in promoting all that is reasonable."

A circle soon formed round Speranski, and the old man who had talked
about his subordinate Pryanichnikov addressed a question to him.

Prince Andrew without joining in the conversation watched every
movement of Speranski's: this man, not long since an insignificant
divinity student, who now, Bolkonski thought, held in his hands--those
plump white hands--the fate of Russia. Prince Andrew was struck by the
extraordinarily disdainful composure with which Speranski answered the
old man. He appeared to address condescending words to him from an
immeasurable height. When the old man began to speak too loud,
Speranski smiled and said he could not judge of the advantage or
disadvantage of what pleased the sovereign.

Having talked for a little while in the general circle, Speranski
rose and coming up to Prince Andrew took him along to the other end of
the room. It was clear that he thought it necessary to interest
himself in Bolkonski.

"I had no chance to talk with you, Prince, during the animated
conversation in which that venerable gentleman involved me," he said
with a mildly contemptuous smile, as if intimating by that smile
that he and Prince Andrew understood the insignificance of the
people with whom he had just been talking. This flattered Prince
Andrew. "I have known of you for a long time: first from your action
with regard to your serfs, a first example, of which it is very
desirable that there should be more imitators; and secondly because
you are one of those gentlemen of the chamber who have not
considered themselves offended by the new decree concerning the
ranks allotted to courtiers, which is causing so much gossip and
tittle-tattle."

"No," said Prince Andrew, "my father did not wish me to take
advantage of the privilege. I began the service from the lower grade."

"Your father, a man of the last century, evidently stands above
our contemporaries who so condemn this measure which merely
reestablishes natural justice."

"I think, however, that these condemnations have some ground,"
returned Prince Andrew, trying to resist Speranski's influence, of
which he began to be conscious. He did not like to agree with him in
everything and felt a wish to contradict. Though he usually spoke
easily and well, he felt a difficulty in expressing himself now
while talking with Speranski. He was too much absorbed in observing
the famous man's personality.

"Grounds of personal ambition maybe," Speranski put in quietly.

"And of state interest to some extent," said Prince Andrew.

"What do you mean?" asked Speranski quietly, lowering his eyes.

"I am an admirer of Montesquieu," replied Prince Andrew, "and his
idea that le principe des monarchies est l'honneur me parait
incontestable. Certains droits et privileges de la noblesse me
paraissent etre des moyens de soutenir ce sentiment."*


*"The principle of monarchies is honor seems to me incontestable.
Certain rights and privileges for the aristocracy appear to me a means
of maintaining that sentiment."


The smile vanished from Speranski's white face, which was much
improved by the change. Probably Prince Andrew's thought interested
him.

"Si vous envisagez la question sous ce point de vue,"* he began,
pronouncing French with evident difficulty, and speaking even slower
than in Russian but quite calmly.


*"If you regard the question from that point of view."


Speranski went on to say that honor, l'honeur, cannot be upheld by
privileges harmful to the service; that honor, l'honneur, is either
a negative concept of not doing what is blameworthy or it is a
source of emulation in pursuit of commendation and rewards, which
recognize it. His arguments were concise, simple, and clear.

"An institution upholding honor, the source of emulation, is one
similar to the Legion d'honneur of the great Emperor Napoleon, not
harmful but helpful to the success of the service, but not a class
or court privilege."

"I do not dispute that, but it cannot be denied that court
privileges have attained the same end," returned Prince Andrew. "Every
courtier considers himself bound to maintain his position worthily."

"Yet you do not care to avail yourself of the privilege, Prince,"
said Speranski, indicating by a smile that he wished to finish amiably
an argument which was embarrassing for his companion. "If you will
do me the honor of calling on me on Wednesday," he added, "I will,
after talking with Magnitski, let you know what may interest you,
and shall also have the pleasure of a more detailed chat with you."

Closing his eyes, he bowed a la francaise, without taking leave, and
trying to attract as little attention as possible, he left the room.





CHAPTER VI


During the first weeks of his stay in Petersburg Prince Andrew
felt the whole trend of thought he had formed during his life of
seclusion quite overshadowed by the trifling cares that engrossed
him in that city.

On returning home in the evening he would jot down in his notebook
four or five necessary calls or appointments for certain hours. The
mechanism of life, the arrangement of the day so as to be in time
everywhere, absorbed the greater part of his vital energy. He did
nothing, did not even think or find time to think, but only talked,
and talked successfully, of what he had thought while in the country.

He sometimes noticed with dissatisfaction that he repeated the
same remark on the same day in different circles. But he was so busy
for whole days together that he had no time to notice that he was
thinking of nothing.

As he had done on their first meeting at Kochubey's, Speranski
produced a strong impression on Prince Andrew on the Wednesday, when
he received him tete-a-tate at his own house and talked to him long
and confidentially.

To Bolkonski so many people appeared contemptible and
insignificant creatures, and he so longed to find in someone the
living ideal of that perfection toward which he strove, that he
readily believed that in Speranski he had found this ideal of a
perfectly rational and virtuous man. Had Speranski sprung from the
same class as himself and possessed the same breeding and
traditions, Bolkonski would soon have discovered his weak, human,
unheroic sides; but as it was, Speranski's strange and logical turn of
mind inspired him with respect all the more because he did not quite
understand him. Moreover, Speranski, either because he appreciated the
other's capacity or because he considered it necessary to win him to
his side, showed off his dispassionate calm reasonableness before
Prince Andrew and flattered him with that subtle flattery which goes
hand in hand with self-assurance and consists in a tacit assumption
that one's companion is the only man besides oneself capable of
understanding the folly of the rest of mankind and the
reasonableness and profundity of one's own ideas.

During their long conversation on Wednesday evening, Speranski
more than once remarked: "We regard everything that is above the
common level of rooted custom..." or, with a smile: "But we want the
wolves to be fed and the sheep to be safe..." or: "They cannot
understand this..." and all in a way that seemed to say: "We, you
and I, understand what they are and who we are."

This first long conversation with Speranski only strengthened in
Prince Andrew the feeling he had experienced toward him at their first
meeting. He saw in him a remarkable, clear-thinking man of vast
intellect who by his energy and persistence had attained power,
which he was using solely for the welfare of Russia. In Prince
Andrew's eyes Speranski was the man he would himself have wished to
be--one who explained all the facts of life reasonably, considered
important only what was rational, and was capable of applying the
standard of reason to everything. Everything seemed so simple and
clear in Speranski's exposition that Prince Andrew involuntarily
agreed with him about everything. If he replied and argued, it was
only because he wished to maintain his independence and not submit
to Speranski's opinions entirely. Everything was right and
everything was as it should be: only one thing disconcerted Prince
Andrew. This was Speranski's cold, mirrorlike look, which did not
allow one to penetrate to his soul, and his delicate white hands,
which Prince Andrew involuntarily watched as one does watch the
hands of those who possess power. This mirrorlike gaze and those
delicate hands irritated Prince Andrew, he knew not why. He was
unpleasantly struck, too, by the excessive contempt for others that he
observed in Speranski, and by the diversity of lines of argument he
used to support his opinions. He made use of every kind of mental
device, except analogy, and passed too boldly, it seemed to Prince
Andrew, from one to another. Now he would take up the position of a
practical man and condemn dreamers; now that of a satirist, and
laugh ironically at his opponents; now grow severely logical, or
suddenly rise to the realm of metaphysics. (This last resource was one
he very frequently employed.) He would transfer a question to
metaphysical heights, pass on to definitions of space, time, and
thought, and, having deduced the refutation he needed, would again
descend to the level of the original discussion.

In general the trait of Speranski's mentality which struck Prince
Andrew most was his absolute and unshakable belief in the power and
authority of reason. It was evident that the thought could never occur
to him which to Prince Andrew seemed so natural, namely, that it is
after all impossible to express all one thinks; and that he had
never felt the doubt, "Is not all I think and believe nonsense?" And
it was just this peculiarity of Speranski's mind that particularly
attracted Prince Andrew.

During the first period of their acquaintance Bolkonski felt a
passionate admiration for him similar to that which he had once felt
for Bonaparte. The fact that Speranski was the son of a village
priest, and that stupid people might meanly despise him on account
of his humble origin (as in fact many did), caused Prince Andrew to
cherish his sentiment for him the more, and unconsciously to
strengthen it.

On that first evening Bolkonski spent with him, having mentioned the
Commission for the Revision of the Code of Laws, Speranski told him
sarcastically that the Commission had existed for a hundred and
fifty years, had cost millions, and had done nothing except that
Rosenkampf had stuck labels on the corresponding paragraphs of the
different codes.

"And that is all the state has for the millions it has spent,"
said he. "We want to give the Senate new juridical powers, but we have
no laws. That is why it is a sin for men like you, Prince, not to
serve in these times!"

Prince Andrew said that for that work an education in
jurisprudence was needed which he did not possess.

"But nobody possesses it, so what would you have? It is a vicious
circle from which we must break a way out."

A week later Prince Andrew was a member of the Committee on Army
Regulations and--what he had not at all expected--was chairman of a
section of the committee for the revision of the laws. At
Speranski's request he took the first part of the Civil Code that
was being drawn up and, with the aid of the Code Napoleon and the
Institutes of Justinian, he worked at formulating the section on
Personal Rights.





CHAPTER VII


Nearly two years before this, in 1808, Pierre on returning to
Petersburg after visiting his estates had involuntarily found
himself in a leading position among the Petersburg Freemasons. He
arranged dining and funeral lodge meetings, enrolled new members,
and busied himself uniting various lodges and acquiring authentic
charters. He gave money for the erection of temples and supplemented
as far as he could the collection of alms, in regard to which the
majority of members were stingy and irregular. He supported almost
singlehanded a poorhouse the order had founded in Petersburg.

His life meanwhile continued as before, with the same infatuations
and dissipations. He liked to dine and drink well, and though he
considered it immoral and humiliating could not resist the temptations
of the bachelor circles in which he moved.

Amid the turmoil of his activities and distractions, however, Pierre
at the end of a year began to feel that the more firmly he tried to
rest upon it, the more Masonic ground on which he stood gave way under
him. At the same time he felt that the deeper the ground sank under
him the closer bound he involuntarily became to the order. When he had
joined the Freemasons he had experienced the feeling of one who
confidently steps onto the smooth surface of a bog. When he put his
foot down it sank in. To make quite sure of the firmness the ground,
he put his other foot down and sank deeper still, became stuck in
it, and involuntarily waded knee-deep in the bog.

Joseph Alexeevich was not in Petersburg--he had of late stood
aside from the affairs of the Petersburg lodges, and lived almost
entirely in Moscow. All the members of the lodges were men Pierre knew
in ordinary life, and it was difficult for him to regard them merely
as Brothers in Freemasonry and not as Prince B. or Ivan Vasilevich D.,
whom he knew in society mostly as weak and insignificant men. Under
the Masonic aprons and insignia he saw the uniforms and decorations at
which they aimed in ordinary life. Often after collecting alms, and
reckoning up twenty to thirty rubles received for the most part in
promises from a dozen members, of whom half were as well able to pay
as himself, Pierre remembered the Masonic vow in which each Brother
promised to devote all his belongings to his neighbor, and doubts on
which he tried not to dwell arose in his soul.

He divided the Brothers he knew into four categories. In the first
he put those who did not take an active part in the affairs of the
lodges or in human affairs, but were exclusively occupied with the
mystical science of the order: with questions of the threefold
designation of God, the three primordial elements--sulphur, mercury,
and salt--or the meaning of the square and all the various figures
of the temple of Solomon. Pierre respected this class of Brothers to
which the elder ones chiefly belonged, including, Pierre thought,
Joseph Alexeevich himself, but he did not share their interests. His
heart was not in the mystical aspect of Freemasonry.

In the second category Pierre reckoned himself and others like
him, seeking and vacillating, who had not yet found in Freemasonry a
straight and comprehensible path, but hoped to do so.

In the third category he included those Brothers (the majority)
who saw nothing in Freemasonry but the external forms and
ceremonies, and prized the strict performance of these forms without
troubling about their purport or significance. Such were Willarski and
even the Grand Master of the principal lodge.

Finally, to the fourth category also a great many Brothers belonged,
particularly those who had lately joined. These according to
Pierre's observations were men who had no belief in anything, nor
desire for anything, but joined the Freemasons merely to associate
with the wealthy young Brothers who were influential through their
connections or rank, and of whom there were very many in the lodge.

Pierre began to feel dissatisfied with what he was doing.
Freemasonry, at any rate as he saw it here, sometimes seemed to him
based merely on externals. He did not think of doubting Freemasonry
itself, but suspected that Russian Masonry had taken a wrong path
and deviated from its original principles. And so toward the end of
the year he went abroad to be initiated into the higher secrets of the
order.

In the summer of 1809 Pierre returned to Petersburg. Our
Freemasons knew from correspondence with those abroad that Bezukhov
had obtained the confidence of many highly placed persons, had been
initiated into many mysteries, had been raised to a higher grade,
and was bringing back with him much that might conduce to the
advantage of the Masonic cause in Russia. The Petersburg Freemasons
all came to see him, tried to ingratiate themselves with him, and it
seemed to them all that he was preparing something for them and
concealing it.

A solemn meeting of the lodge of the second degree was convened,
at which Pierre promised to communicate to the Petersburg Brothers
what he had to deliver to them from the highest leaders of their
order. The meeting was a full one. After the usual ceremonies Pierre
rose and began his address.

"Dear Brothers," he began, blushing and stammering, with a written
speech in his hand, "it is not sufficient to observe our mysteries
in the seclusion of our lodge--we must act--act! We are drowsing,
but we must act." Pierre raised his notebook and began to read.

"For the dissemination of pure truth and to secure the triumph of
virtue," he read, "we must cleanse men from prejudice, diffuse
principles in harmony with the spirit of the times, undertake the
education of the young, unite ourselves in indissoluble bonds with the
wisest men, boldly yet prudently overcome superstitions, infidelity,
and folly, and form of those devoted to us a body linked together by
unity of purpose and possessed of authority and power.

"To attain this end we must secure a preponderance of virtue over
vice and must endeavor to secure that the honest man may, even in this
world, receive a lasting reward for his virtue. But in these great
endeavors we are gravely hampered by the political institutions of
today. What is to be done in these circumstances? To favor
revolutions, overthrow everything, repel force by force?... No! We are
very far from that. Every violent reform deserves censure, for it
quite fails to remedy evil while men remain what they are, and also
because wisdom needs no violence.

"The whole plan of our order should be based on the idea of
preparing men of firmness and virtue bound together by unity of
conviction--aiming at the punishment of vice and folly, and
patronizing talent and virtue: raising worthy men from the dust and
attaching them to our Brotherhood. Only then will our order have the
power unobtrusively to bind the hands of the protectors of disorder
and to control them without their being aware of it. In a word, we
must found a form of government holding universal sway, which should
be diffused over the whole world without destroying the bonds of
citizenship, and beside which all other governments can continue in
their customary course and do everything except what impedes the great
aim of our order, which is to obtain for virtue the victory over vice.
This aim was that of Christianity itself. It taught men to be wise and
good and for their own benefit to follow the example and instruction
of the best and wisest men.

"At that time, when everything was plunged in darkness, preaching
alone was of course sufficient. The novelty of Truth endowed her
with special strength, but now we need much more powerful methods.
It is now necessary that man, governed by his senses, should find in
virtue a charm palpable to those senses. It is impossible to eradicate
the passions; but we must strive to direct them to a noble aim, and it
is therefore necessary that everyone should be able to satisfy his
passions within the limits of virtue. Our order should provide means
to that end.

"As soon as we have a certain number of worthy men in every state,
each of them again training two others and all being closely united,
everything will be possible for our order, which has already in secret
accomplished much for the welfare of mankind."

This speech not only made a strong impression, but created
excitement in the lodge. The majority of the Brothers, seeing in it
dangerous designs of Illuminism,* met it with a coldness that
surprised Pierre. The Grand Master began answering him, and Pierre
began developing his views with more and more warmth. It was long
since there had been so stormy a meeting. Parties were formed, some
accusing Pierre of Illuminism, others supporting him. At that
meeting he was struck for the first time by the endless variety of
men's minds, which prevents a truth from ever presenting itself
identically to two persons. Even those members who seemed to be on his
side understood him in their own way with limitations and
alterations he could not agree to, as what he always wanted most was
to convey his thought to others just as he himself understood it.


*The Illuminati sought to substitute republican for monarchical
institutions.


At the end of the meeting the Grand Master with irony and ill-will
reproved Bezukhov for his vehemence and said it was not love of virtue
alone, but also a love of strife that had moved him in the dispute.
Pierre did not answer him and asked briefly whether his proposal would
be accepted. He was told that it would not, and without waiting for
the usual formalities he left the lodge and went home.





CHAPTER VIII


Again Pierre was overtaken by the depression he so dreaded. For
three days after the delivery of his speech at the lodge he lay on a
sofa at home receiving no one and going nowhere.

It was just then that he received a letter from his wife, who
implored him to see her, telling him how grieved she was about him and
how she wished to devote her whole life to him.

At the end of the letter she informed him that in a few days she
would return to Petersburg from abroad.

Following this letter one of the Masonic Brothers whom Pierre
respected less than the others forced his way in to see him and,
turning the conversation upon Pierre's matrimonial affairs, by way
of fraternal advice expressed the opinion that his severity to his
wife was wrong and that he was neglecting one of the first rules of
Freemasonry by not forgiving the penitent.

At the same time his mother-in-law, Prince Vasili's wife, sent to
him imploring him to come if only for a few minutes to discuss a
most important matter. Pierre saw that there was a conspiracy
against him and that they wanted to reunite him with his wife, and
in the mood he then was, this was not even unpleasant to him.
Nothing mattered to him. Nothing in life seemed to him of much
importance, and under the influence of the depression that possessed
him he valued neither his liberty nor his resolution to punish his
wife.

"No one is right and no one is to blame; so she too is not to
blame," he thought.

If he did not at once give his consent to a reunion with his wife,
it was only because in his state of depression he did not feel able to
take any step. Had his wife come to him, he would not have turned
her away. Compared to what preoccupied him, was it not a matter of
indifference whether he lived with his wife or not?

Without replying either to his wife or his mother-in-law, Pierre
late one night prepared for a journey and started for Moscow to see
Joseph Alexeevich. This is what he noted in his diary:


Moscow, 17th November

I have just returned from my benefactor, and hasten to write down
what I have experienced. Joseph Alexeevich is living poorly and has
for three years been suffering from a painful disease of the
bladder. No one has ever heard him utter a groan or a word of
complaint. From morning till late at night, except when he eats his
very plain food, he is working at science. He received me graciously
and made me sit down on the bed on which he lay. I made the sign of
the Knights of the East and of Jerusalem, and he responded in the same
manner, asking me with a mild smile what I had learned and gained in
the Prussian and Scottish lodges. I told him everything as best I
could, and told him what I had proposed to our Petersburg lodge, of
the bad reception I had encountered, and of my rupture with the
Brothers. Joseph Alexeevich, having remained silent and thoughtful for
a good while, told me his view of the matter, which at once lit up for
me my whole past and the future path I should follow. He surprised
me by asking whether I remembered the threefold aim of the order:
(1) The preservation and study of the mystery. (2) The purification
and reformation of oneself for its reception, and (3) The
improvement of the human race by striving for such purification. Which
is the principal aim of these three? Certainly self-reformation and
self-purification. Only to this aim can we always strive independently
of circumstances. But at the same time just this aim demands the
greatest efforts of us; and so, led astray by pride, losing sight of
this aim, we occupy ourselves either with the mystery which in our
impurity we are unworthy to receive, or seek the reformation of the
human race while ourselves setting an example of baseness and
profligacy. Illuminism is not a pure doctrine, just because it is
attracted by social activity and puffed up by pride. On this ground
Joseph Alexeevich condemned my speech and my whole activity, and in
the depth of my soul I agreed with him. Talking of my family affairs
he said to me, "the chief duty of a true Mason, as I have told you,
lies in perfecting himself. We often think that by removing all the
difficulties of our life we shall more quickly reach our aim, but on
the contrary, my dear sir, it is only in the midst of worldly cares
that we can attain our three chief aims: (1) Self-knowledge--for man
can only know himself by comparison, (2) Self-perfecting, which can
only be attained by conflict, and (3) The attainment of the chief
virtue--love of death. Only the vicissitudes of life can show us its
vanity and develop our innate love of death or of rebirth to a new
life." These words are all the more remarkable because, in spite of
his great physical sufferings, Joseph Alexeevich is never weary of
life though he loves death, for which--in spite of the purity and
loftiness of his inner man--he does not yet feel himself
sufficiently prepared. My benefactor then explained to me fully the
meaning of the Great Square of creation and pointed out to me that the
numbers three and seven are the basis of everything. He advised me not
to avoid intercourse with the Petersburg Brothers, but to take up only
second-grade posts in the lodge, to try, while diverting the
Brothers from pride, to turn them toward the true path
self-knowledge and self-perfecting. Besides this he advised me for
myself personally above all to keep a watch over myself, and to that
end he gave me a notebook, the one I am now writing in and in which
I will in future note down all my actions.


Petersburg, 23rd November

I am again living with my wife. My mother-in-law came to me in tears
and said that Helene was here and that she implored me to hear her;
that she was innocent and unhappy at my desertion, and much more. I
knew that if I once let myself see her I should not have strength to
go on refusing what she wanted. In my perplexity I did not know
whose aid and advice to seek. Had my benefactor been here he would
have told me what to do. I went to my room and reread Joseph
Alexeevich's letters and recalled my conversations with him, and
deduced from it all that I ought not to refuse a suppliant, and
ought to reach a helping hand to everyone--especially to one so
closely bound to me--and that I must bear my cross. But if I forgive
her for the sake of doing right, then let union with her have only a
spiritual aim. That is what I decided, and what I wrote to Joseph
Alexeevich. I told my wife that I begged her to forget the past, to
forgive me whatever wrong I may have done her, and that I had
nothing to forgive. It gave me joy to tell her this. She need not know
how hard it was for me to see her again. I have settled on the upper
floor of this big house and am experiencing a happy feeling of
regeneration.





CHAPTER IX


At that time, as always happens, the highest society that met at
court and at the grand balls was divided into several circles, each
with its own particular tone. The largest of these was the French
circle of the Napoleonic alliance, the circle of Count Rumyantsev
and Caulaincourt. In this group Helene, as soon as she had settled
in Petersburg with her husband, took a very prominent place. She was
visited by the members of the French embassy and by many belonging
to that circle and noted for their intellect and polished manners.

Helene had been at Erfurt during the famous meeting of the
Emperors and had brought from there these connections with the
Napoleonic notabilities. At Erfurt her success had been brilliant.
Napoleon himself had noticed her in the theater and said of her:
"C'est un superbe animal."* Her success as a beautiful and elegant
woman did not surprise Pierre, for she had become even handsomer
than before. What did surprise him was that during these last two
years his wife had succeeded in gaining the reputation "d' une femme
charmante, aussi spirituelle que belle."*[2] The distinguished
Prince de Ligne wrote her eight-page letters. Bilibin saved up his
epigrams to produce them in Countess Bezukhova's presence. To be
received in the Countess Bezukhova's salon was regarded as a diploma
of intellect. Young men read books before attending Helene's evenings,
to have something to say in her salon, and secretaries of the embassy,
and even ambassadors, confided diplomatic secrets to her, so that in a
way Helene was a power. Pierre, who knew she was very stupid,
sometimes attended, with a strange feeling of perplexity and fear, her
evenings and dinner parties, where politics, poetry, and philosophy
were discussed. At these parties his feelings were like those of a
conjuror who always expects his trick to be found out at any moment.
But whether because stupidity was just what was needed to run such a
salon, or because those who were deceived found pleasure in the
deception, at any rate it remained unexposed and Helene Bezukhova's
reputation as a lovely and clever woman became so firmly established
that she could say the emptiest and stupidest things and everybody
would go into raptures over every word of hers and look for a profound
meaning in it of which she herself had no conception.


*"That's a superb animal."

*[2] "Of a charming woman, as witty as she is lovely."


Pierre was just the husband needed for a brilliant society woman. He
was that absent-minded crank, a grand seigneur husband who was in no
one's way, and far from spoiling the high tone and general
impression of the drawing room, he served, by the contrast he
presented to her, as an advantageous background to his elegant and
tactful wife. Pierre during the last two years, as a result of his
continual absorption in abstract interests and his sincere contempt
for all else, had acquired in his wife's circle, which did not
interest him, that air of unconcern, indifference, and benevolence
toward all, which cannot be acquired artificially and therefore
inspires involuntary respect. He entered his wife's drawing room as
one enters a theater, was acquainted with everybody, equally pleased
to see everyone, and equally indifferent to them all. Sometimes he
joined in a conversation which interested him and, regardless of
whether any "gentlemen of the embassy" were present or not,
lispingly expressed his views, which were sometimes not at all in
accord with the accepted tone of the moment. But the general opinion
concerning the queer husband of "the most distinguished woman in
Petersburg" was so well established that no one took his freaks
seriously.

Among the many young men who frequented her house every day, Boris
Drubetskoy, who had already achieved great success in the service, was
the most intimate friend of the Bezukhov household since Helene's
return from Erfurt. Helene spoke of him as "mon page" and treated
him like a child. Her smile for him was the same as for everybody, but
sometimes that smile made Pierre uncomfortable. Toward him Boris
behaved with a particularly dignified and sad deference. This shade of
deference also disturbed Pierre. He had suffered so painfully three
years before from the mortification to which his wife had subjected
him that he now protected himself from the danger of its repetition,
first by not being a husband to his wife, and secondly by not allowing
himself to suspect.

"No, now that she has become a bluestocking she has finally
renounced her former infatuations," he told himself. "There has
never been an instance of a bluestocking being carried away by affairs
of the heart"--a statement which, though gathered from an unknown
source, he believed implicitly. Yet strange to say Boris' presence
in his wife's drawing room (and he was almost always there) had a
physical effect upon Pierre; it constricted his limbs and destroyed
the unconsciousness and freedom of his movements.

"What a strange antipathy," thought Pierre, "yet I used to like
him very much."

In the eyes of the world Pierre was a great gentleman, the rather
blind and absurd husband of a distinguished wife, a clever crank who
did nothing but harmed nobody and was a first-rate, good-natured
fellow. But a complex and difficult process of internal development
was taking place all this time in Pierre's soul, revealing much to him
and causing him many spiritual doubts and joys.





CHAPTER X


Pierre went on with his diary, and this is what he wrote in it
during that time:


24th November

Got up at eight, read the Scriptures, then went to my duties. [By
Joseph Alexeevich's advice Pierre had entered the service of the state
and served on one of the committees.] Returned home for dinner and
dined alone--the countess had many visitors I do not like. I ate and
drank moderately and after dinner copied out some passages for the
Brothers. In the evening I went down to the countess and told a
funny story about B., and only remembered that I ought not to have
done so when everybody laughed loudly at it.

I am going to bed with a happy and tranquil mind. Great God, help me
to walk in Thy paths, (1) to conquer anger by calmness and
deliberation, (2) to vanquish lust by self-restraint and repulsion,
(3) to withdraw from worldliness, but not avoid (a) the service of the
state, (b) family duties, (c) relations with my friends, and the
management of my affairs.


27th November

I got up late. On waking I lay long in bed yielding to sloth. O God,
help and strengthen me that I may walk in Thy ways! Read the
Scriptures, but without proper feeling. Brother Urusov came and we
talked about worldly vanities. He told me of the Emperor's new
projects. I began to criticize them, but remembered my rules and my
benefactor's words--that a true Freemason should be a zealous worker
for the state when his aid is required and a quiet onlooker when not
called on to assist. My tongue is my enemy. Brothers G. V. and O.
visited me and we had a preliminary talk about the reception of a
new Brother. They laid on me the duty of Rhetor. I feel myself weak
and unworthy. Then our talk turned to the interpretation of the
seven pillars and steps of the Temple, the seven sciences, the seven
virtues, the seven vices, and the seven gifts of the Holy Spirit.
Brother O. was very eloquent. In the evening the admission took place.
The new decoration of the Premises contributed much to the
magnificence of the spectacle. It was Boris Drubetskoy who was
admitted. I nominated him and was the Rhetor. A strange feeling
agitated me all the time I was alone with him in the dark chamber. I
caught myself harboring a feeling of hatred toward him which I
vainly tried to overcome. That is why I should really like to save him
from evil and lead him into the path of truth, but evil thoughts of
him did not leave me. It seemed to me that his object in entering
the Brotherhood was merely to be intimate and in favor with members of
our lodge. Apart from the fact that he had asked me several times
whether N. and S. were members of our lodge (a question to which I
could not reply) and that according to my observation he is
incapable of feeling respect for our holy order and is too preoccupied
and satisfied with the outer man to desire spiritual improvement, I
had no cause to doubt him, but he seemed to me insincere, and all
the time I stood alone with him in the dark temple it seemed to me
that he was smiling contemptuously at my words, and I wished really to
stab his bare breast with the sword I held to it. I could not be
eloquent, nor could I frankly mention my doubts to the Brothers and to
the Grand Master. Great Architect of Nature, help me to find the
true path out of the labyrinth of lies!


 After this, three pages were left blank in the diary, and then
the following was written:


I have had a long and instructive talk alone with Brother V., who
advised me to hold fast by brother A. Though I am unworthy, much was
revealed to me. Adonai is the name of the creator of the world. Elohim
is the name of the ruler of all. The third name is the name
unutterable which means the All. Talks with Brother V. strengthen,
refresh, and support me in the path of virtue. In his presence doubt
has no place. The distinction between the poor teachings of mundane
science and our sacred all-embracing teaching is clear to me. Human
sciences dissect everything to comprehend it, and kill everything to
examine it. In the holy science of our order all is one, all is
known in its entirety and life. The Trinity--the three elements of
matter--are sulphur, mercury, and salt. Sulphur is of an oily and
fiery nature; in combination with salt by its fiery nature it
arouses a desire in the latter by means of which it attracts
mercury, seizes it, holds it, and in combination produces other
bodies. Mercury is a fluid, volatile, spiritual essence. Christ, the
Holy Spirit, Him!...


3rd December

Awoke late, read the Scriptures but was apathetic. Afterwards went
and paced up and down the large hall. I wished to meditate, but
instead my imagination pictured an occurrence of four years ago,
when Dolokhov, meeting me in Moscow after our duel, said he hoped I
was enjoying perfect peace of mind in spite of my wife's absence. At
the time I gave him no answer. Now I recalled every detail of that
meeting and in my mind gave him the most malevolent and bitter
replies. I recollected myself and drove away that thought only when
I found myself glowing with anger, but I did not sufficiently
repent. Afterwards Boris Drubetskoy came and began relating various
adventures. His coming vexed me from the first, and I said something
disagreeable to him. He replied. I flared up and said much that was
unpleasant and even rude to him. He became silent, and I recollected
myself only when it was too late. My God, I cannot get on with him
at all. The cause of this is my egotism. I set myself above him and so
become much worse than he, for he is lenient to my rudeness while I on
the contrary nourish contempt for him. O God, grant that in his
presence I may rather see my own vileness, and behave so that he too
may benefit. After dinner I fell asleep and as I was drowsing off I
clearly heard a voice saying in my left ear, "Thy day!"

I dreamed that I was walking in the dark and was suddenly surrounded
by dogs, but I went on undismayed. Suddenly a smallish dog seized my
left thigh with its teeth and would not let go. I began to throttle it
with my hands. Scarcely had I torn it off before another, a bigger
one, began biting me. I lifted it up, but the higher I lifted it the
bigger and heavier it grew. And suddenly Brother A. came and, taking
my arm, led me to a building to enter which we had to pass along a
narrow plank. I stepped on it, but it bent and gave way and I began to
clamber up a fence which I could scarcely reach with my hands. After
much effort I dragged myself up, so that my leg hung down on one
side and my body on the other. I looked round and saw Brother A.
standing on the fence and pointing me to a broad avenue and garden,
and in the garden was a large and beautiful building. I woke up. O
Lord, great Architect of Nature, help me to tear from myself these
dogs--my passions especially the last, which unites in itself the
strength of all the former ones, and aid me to enter that temple of
virtue to a vision of which I attained in my dream.


7th December

I dreamed that Joseph Alexeevich was sitting in my house, and that I
was very glad and wished to entertain him. It seemed as if I chattered
incessantly with other people and suddenly remembered that this
could not please him, and I wished to come close to him and embrace
him. But as soon as I drew near I saw that his face had changed and
grown young, and he was quietly telling me something about the
teaching of our order, but so softly that I could not hear it. Then it
seemed that we all left the room and something strange happened. We
were sitting or lying on the floor. He was telling me something, and I
wished to show him my sensibility, and not listening to what he was
saying I began picturing to myself the condition of my inner man and
the grace of God sanctifying me. And tears came into my eyes, and I
was glad he noticed this. But he looked at me with vexation and jumped
up, breaking off his remarks. I felt abashed and asked whether what he
had been saying did not concern me; but he did not reply, gave me a
kind look, and then we suddenly found ourselves in my bedroom where
there is a double bed. He lay down on the edge of it and I burned with
longing to caress him and lie down too. And he said, "Tell me
frankly what is your chief temptation? Do you know it? I think you
know it already." Abashed by this question, I replied that sloth was
my chief temptation. He shook his head incredulously; and even more
abashed, I said that though I was living with my wife as he advised, I
was not living with her as her husband. To this he replied that one
should not deprive a wife of one's embraces and gave me to
understand that that was my duty. But I replied that I should be
ashamed to do it, and suddenly everything vanished. And I awoke and
found in my mind the text from the Gospel: "The life was the light
of men. And the light shineth in darkness; and the darkness
comprehended it not." Joseph Alexeevich's face had looked young and
bright. That day I received a letter from my benefactor in which he
wrote about "conjugal duties."


9th December

I had a dream from which I awoke with a throbbing heart. I saw
that I was in Moscow in my house, in the big sitting room, and
Joseph Alexeevich came in from the drawing room. I seemed to know at
once that the process of regeneration had already taken place in
him, and I rushed to meet him. I embraced him and kissed his hands,
and he said, "Hast thou noticed that my face is different?" I looked
at him, still holding him in my arms, and saw that his face was young,
but that he had no hair on his head and his features were quite
changed. And I said, "I should have known you had I met you by
chance," and I thought to myself, "Am I telling the truth?" And
suddenly I saw him lying like a dead body; then he gradually recovered
and went with me into my study carrying a large book of sheets of
drawing paper; I said, "I drew that," and he answered by bowing his
head. I opened the book, and on all the pages there were excellent
drawings. And in my dream I knew that these drawings represented the
love adventures of the soul with its beloved. And on its pages I saw a
beautiful representation of a maiden in transparent garments and
with a transparent body, flying up to the clouds. And I seemed to know
that this maiden was nothing else than a representation of the Song of
Songs. And looking at those drawings I dreamed I felt that I was doing
wrong, but could not tear myself away from them. Lord, help me! My
God, if Thy forsaking me is Thy doing, Thy will be done; but if I am
myself the cause, teach me what I should do! I shall perish of my
debauchery if Thou utterly desertest me!





CHAPTER XI


The Rostovs' monetary affairs had not improved during the two
years they had spent in the country.

Though Nicholas Rostov had kept firmly to his resolution and was
still serving modestly in an obscure regiment, spending
comparatively little, the way of life at Otradnoe--Mitenka's
management of affairs, in particular--was such that the debts
inevitably increased every year. The only resource obviously
presenting itself to the old count was to apply for an official
post, so he had come to Petersburg to look for one and also, as he
said, to let the lassies enjoy themselves for the last time.

Soon after their arrival in Petersburg Berg proposed to Vera and was
accepted.

Though in Moscow the Rostovs belonged to the best society without
themselves giving it a thought, yet in Petersburg their circle of
acquaintances was a mixed and indefinite one. In Petersburg they
were provincials, and the very people they had entertained in Moscow
without inquiring to what set they belonged, here looked down on them.

The Rostovs lived in the same hospitable way in Petersburg as in
Moscow, and the most diverse people met at their suppers. Country
neighbors from Otradnoe, impoverished old squires and their daughters,
Peronskaya a maid of honor, Pierre Bezukhov, and the son of their
district postmaster who had obtained a post in Petersburg. Among the
men who very soon became frequent visitors at the Rostovs' house in
Petersburg were Boris, Pierre whom the count had met in the street and
dragged home with him, and Berg who spent whole days at the Rostovs'
and paid the eldest daughter, Countess Vera, the attentions a young
man pays when he intends to propose.

Not in vain had Berg shown everybody his right hand wounded at
Austerlitz and held a perfectly unnecessary sword in his left. He
narrated that episode so persistently and with so important an air
that everyone believed in the merit and usefulness of his deed, and he
had obtained two decorations for Austerlitz.

In the Finnish war he also managed to distinguish himself. He had
picked up the scrap of a grenade that had killed an aide-de-camp
standing near the commander in chief and had taken it to his
commander. Just as he had done after Austerlitz, he related this
occurrence at such length and so insistently that everyone again
believed it had been necessary to do this, and he received two
decorations for the Finnish war also. In 1809 he was a captain in
the Guards, wore medals, and held some special lucrative posts in
Petersburg.

Though some skeptics smiled when told of Berg's merits, it could not
be denied that he was a painstaking and brave officer, on excellent
terms with his superiors, and a moral young man with a brilliant
career before him and an assured position in society.

Four years before, meeting a German comrade in the stalls of a
Moscow theater, Berg had pointed out Vera Rostova to him and had
said in German, "das soll mein Weib werden,"* and from that moment had
made up his mind to marry her. Now in Petersburg, having considered
the Rostovs' position and his own, he decided that the time had come
to propose.


*"That girl shall be my wife."


Berg's proposal was at first received with a perplexity that was not
flattering to him. At first it seemed strange that the son of an
obscure Livonian gentleman should propose marriage to a Countess
Rostova; but Berg's chief characteristic was such a naive and good
natured egotism that the Rostovs involuntarily came to think it
would be a good thing, since he himself was so firmly convinced that
it was good, indeed excellent. Moreover, the Rostovs' affairs were
seriously embarrassed, as the suitor could not but know; and above
all, Vera was twenty-four, had been taken out everywhere, and though
she was certainly good-looking and sensible, no one up to now had
proposed to her. So they gave their consent.

"You see," said Berg to his comrade, whom he called "friend" only
because he knew that everyone has friends, "you see, I have considered
it all, and should not marry if I had not thought it all out or if
it were in any way unsuitable. But on the contrary, my papa and
mamma are now provided for--I have arranged that rent for them in
the Baltic Provinces--and I can live in Petersburg on my pay, and with
her fortune and my good management we can get along nicely. I am not
marrying for money--I consider that dishonorable--but a wife should
bring her share and a husband his. I have my position in the
service, she has connections and some means. In our times that is
worth something, isn't it? But above all, she is a handsome, estimable
girl, and she loves me..."

Berg blushed and smiled.

"And I love her, because her character is sensible and very good.
Now the other sister, though they are the same family, is quite
different--an unpleasant character and has not the same
intelligence. She is so... you know?... Unpleasant... But my
fiancee!... Well, you will be coming," he was going to say, "to dine,"
but changed his mind and said "to take tea with us," and quickly
doubling up his tongue he blew a small round ring of tobacco smoke,
perfectly embodying his dream of happiness.

After the first feeling of perplexity aroused in the parents by
Berg's proposal, the holiday tone of joyousness usual at such times
took possession of the family, but the rejoicing was external and
insincere. In the family's feeling toward this wedding a certain
awkwardness and constraint was evident, as if they were ashamed of not
having loved Vera sufficiently and of being so ready to get her off
their hands. The old count felt this most. He would probably have been
unable to state the cause of his embarrassment, but it resulted from
the state of his affairs. He did not know at all how much he had, what
his debts amounted to, or what dowry he could give Vera. When his
daughters were born he had assigned to each of them, for her dowry, an
estate with three hundred serfs; but one of these estates had
already been sold, and the other was mortgaged and the interest so
much in arrears that it would have to be sold, so that it was
impossible to give it to Vera. Nor had he any money.

Berg had already been engaged a month, and only a week remained
before the wedding, but the count had not yet decided in his own
mind the question of the dowry, nor spoken to his wife about it. At
one time the count thought of giving her the Ryazan estate or of
selling a forest, at another time of borrowing money on a note of
hand. A few days before the wedding Berg entered the count's study
early one morning and, with a pleasant smile, respectfully asked his
future father-in-law to let him know what Vera's dowry would be. The
count was so disconcerted by this long-foreseen inquiry that without
consideration he gave the first reply that came into his head. "I like
your being businesslike about it.... I like it. You shall be
satisfied...."

And patting Berg on the shoulder he got up, wishing to end the
conversation. But Berg, smiling pleasantly, explained that if he did
not know for certain how much Vera would have and did not receive at
least part of the dowry in advance, he would have to break matters
off.

"Because, consider, Count--if I allowed myself to marry now
without having definite means to maintain my wife, I should be
acting badly...."

The conversation ended by the count, who wished to be generous and
to avoid further importunity, saying that he would give a note of hand
for eighty thousand rubles. Berg smiled meekly, kissed the count on
the shoulder, and said that he was very grateful, but that it was
impossible for him to arrange his new life without receiving thirty
thousand in ready money. "Or at least twenty thousand, Count," he
added, "and then a note of hand for only sixty thousand."

"Yes, yes, all right!" said the count hurriedly. "Only excuse me, my

dear fellow, I'll give you twenty thousand and a note of hand for
eighty thousand as well. Yes, yes! Kiss me."





CHAPTER XII


Natasha was sixteen and it was the year 1809, the very year to which
she had counted on her fingers with Boris after they had kissed four
years ago. Since then she had not seen him. Before Sonya and her
mother, if Boris happened to be mentioned, she spoke quite freely of
that episode as of some childish, long-forgotten matter that was not
worth mentioning. But in the secret depths of her soul the question
whether her engagement to Boris was a jest or an important, binding
promise tormented her.

Since Boris left Moscow in 1805 to join the army he had had not seen
the Rostovs. He had been in Moscow several times, and had passed
near Otradnoe, but had never been to see them.

Sometimes it occurred to Natasha that he not wish to see her, and
this conjecture was confirmed by the sad tone in which her elders
spoke of him.

"Nowadays old friends are not remembered," the countess would say
when Boris was mentioned.

Anna Mikhaylovna also had of late visited them less frequently,
seemed to hold herself with particular dignity, and always spoke
rapturously and gratefully of the merits of her son and the
brilliant career on which he had entered. When the Rostovs came to
Petersburg Boris called on them.

He drove to their house in some agitation. The memory of Natasha was
his most poetic recollection. But he went with the firm intention of
letting her and her parents feel that the childish relations between
himself and Natasha could not be binding either on her or on him. He
had a brilliant position in society thanks to his intimacy with
Countess Bezukhova, a brilliant position in the service thanks to
the patronage of an important personage whose complete confidence he
enjoyed, and he was beginning to make plans for marrying one of the
richest heiresses in Petersburg, plans which might very easily be
realized. When he entered the Rostovs' drawing room Natasha was in her
own room. When she heard of his arrival she almost ran into the
drawing room, flushed and beaming with a more than cordial smile.

Boris remembered Natasha in a short dress, with dark eyes shining
from under her curls and boisterous, childish laughter, as he had
known her four years before; and so he was taken aback when quite a
different Natasha entered, and his face expressed rapturous
astonishment. This expression on his face pleased Natasha.

"Well, do you recognize your little madcap playmate?" asked the
countess.

Boris kissed Natasha's hand and said that he was astonished at the
change in her.

"How handsome you have grown!"

"I should think so!" replied Natasha's laughing eyes.

"And is Papa older?" she asked.

Natasha sat down and, without joining in Boris' conversation with
the countess, silently and minutely studied her childhood's suitor. He
felt the weight of that resolute and affectionate scrutiny and glanced
at her occasionally.

Boris' uniform, spurs, tie, and the way his hair was brushed were
all comme il faut and in the latest fashion. This Natasha noticed at
once. He sat rather sideways in the armchair next to the countess,
arranging with his right hand the cleanest of gloves that fitted his
left hand like a skin, and he spoke with a particularly refined
compression of his lips about the amusements of the highest Petersburg
society, recalling with mild irony old times in Moscow and Moscow
acquaintances. It was not accidentally, Natasha felt, that he alluded,
when speaking of the highest aristocracy, to an ambassador's ball he
had attended, and to invitations he had received from N.N. and S.S.

All this time Natasha sat silent, glancing up at him from under
her brows. This gaze disturbed and confused Boris more and more. He
looked round more frequently toward her, and broke off in what he
was saying. He did not stay more than ten minutes, then rose and
took his leave. The same inquisitive, challenging, and rather
mocking eyes still looked at him. After his first visit Boris said
to himself that Natasha attracted him just as much as ever, but that
he must not yield to that feeling, because to marry her, a girl almost
without fortune, would mean ruin to his career, while to renew their
former relations without intending to marry her would be dishonorable.
Boris made up his mind to avoid meeting Natasha, but despite that
resolution he called again a few days later and began calling often
and spending whole days at the Rostovs'. It seemed to him that he
ought to have an explanation with Natasha and tell her that the old
times must be forgotten, that in spite of everything... she could
not be his wife, that he had no means, and they would never let her
marry him. But he failed to do so and felt awkward about entering on
such an explanation. From day to day he became more and more
entangled. It seemed to her mother and Sonya that Natasha was in
love with Boris as of old. She sang him his favorite songs, showed him
her album, making him write in it, did not allow him to allude to
the past, letting it be understood how was the present; and every
day he went away in a fog, without having said what he meant to, and
not knowing what he was doing or why he came, or how it would all end.
He left off visiting Helene and received reproachful notes from her
every day, and yet he continued to spend whole days with the Rostovs.





CHAPTER XIII


One night when the old countess, in nightcap and dressing jacket,
without her false curls, and with her poor little knob of hair showing
under her white cotton cap, knelt sighing and groaning on a rug and
bowing to the ground in prayer, her door creaked and Natasha, also
in a dressing jacket with slippers on her bare feet and her hair in
curlpapers, ran in. The countess--her prayerful mood dispelled--looked
round and frowned. She was finishing her last prayer: "Can it be
that this couch will be my grave?" Natasha, flushed and eager,
seeing her mother in prayer, suddenly checked her rush, half sat down,
and unconsciously put out her tongue as if chiding herself. Seeing
that her mother was still praying she ran on tiptoe to the bed and,
rapidly slipping one little foot against the other, pushed off her
slippers and jumped onto the bed the countess had feared might
become her grave. This couch was high, with a feather bed and five
pillows each smaller than the one below. Natasha jumped on it, sank
into the feather bed, rolled over to the wall, and began snuggling
up the bedclothes as she settled down, raising her knees to her
chin, kicking out and laughing almost inaudibly, now covering
herself up head and all, and now peeping at her mother. The countess
finished her prayers and came to the bed with a stern face, but
seeing, that Natasha's head was covered, she smiled in her kind,
weak way.

"Now then, now then!" said she.

"Mamma, can we have a talk? Yes?" said Natasha. "Now, just one on
your throat and another... that'll do!" And seizing her mother round
the neck, she kissed her on the throat. In her behavior to her
mother Natasha seemed rough, but she was so sensitive and tactful that
however she clasped her mother she always managed to do it without
hurting her or making her feel uncomfortable or displeased.

"Well, what is it tonight?" said the mother, having arranged her
pillows and waited until Natasha, after turning over a couple of
times, had settled down beside her under the quilt, spread out her
arms, and assumed a serious expression.

These visits of Natasha's at night before the count returned from
his club were one of the greatest pleasures of both mother, and
daughter.

"What is it tonight?--But I have to tell you..."

Natasha put her hand on her mother's mouth.

"About Boris... I know," she said seriously; "that's what I have
come about. Don't say it--I know. No, do tell me!" and she removed her
hand. "Tell me, Mamma! He's nice?"

"Natasha, you are sixteen. At your age I was married. You say
Boris is nice. He is very nice, and I love him like a son. But what
then?... What are you thinking about? You have quite turned his
head, I can see that...."

As she said this the countess looked round at her daughter.
Natasha was lying looking steadily straight before her at one of the
mahogany sphinxes carved on the corners of the bedstead, so that the
countess only saw her daughter's face in profile. That face struck her
by its peculiarly serious and concentrated expression.

Natasha was listening and considering.

"Well, what then?" said she.

"You have quite turned his head, and why? What do you want of him?
You know you can't marry him."

"Why not?" said Natasha, without changing her position.

"Because he is young, because he is poor, because he is a
relation... and because you yourself don't love him."

"How do you know?"

"I know. It is not right, darling!"

 "But if I want to..." said Natasha.

"Leave off talking nonsense," said the countess.

"But if I want to..."

"Natasha, I am in earnest..."

Natasha did not let her finish. She drew the countess' large hand to
her, kissed it on the back and then on the palm, then again turned
it over and began kissing first one knuckle, then the space between
the knuckles, then the next knuckle, whispering, "January, February,
March, April, May. Speak, Mamma, why don't you say anything? Speak!"
said she, turning to her mother, who was tenderly gazing at her
daughter and in that contemplation seemed to have forgotten all she
had wished to say.

"It won't do, my love! Not everyone will understand this
friendship dating from your childish days, and to see him so
intimate with you may injure you in the eyes of other young men who
visit us, and above all it torments him for nothing. He may already
have found a suitable and wealthy match, and now he's half crazy."

"Crazy?" repeated Natasha.

"I'll tell you some things about myself. I had a cousin..."

"I know! Cyril Matveich... but he is old."

"He was not always old. But this is what I'll do, Natasha, I'll have
a talk with Boris. He need not come so often...."

"Why not, if he likes to?"

"Because I know it will end in nothing...."

"How can you know? No, Mamma, don't speak to him! What nonsense!"
said Natasha in the tone of one being deprived of her property. "Well,
I won't marry, but let him come if he enjoys it and I enjoy it."
Natasha smiled and looked at her mother. "Not to marry, but just
so," she added.

"How so, my pet?"

"Just so. There's no need for me to marry him. But... just so."

"Just so, just so," repeated the countess, and shaking all over, she
went off into a good humored, unexpected, elderly laugh.

"Don't laugh, stop!" cried Natasha. "You're shaking the whole bed!
You're awfully like me, just such another giggler.... Wait..." and she
seized the countess' hands and kissed a knuckle of the little
finger, saying, "June," and continued, kissing, "July, August," on the
other hand. "But, Mamma, is he very much in love? What do you think?
Was anybody ever so much in love with you? And he's very nice, very,
very nice. Only not quite my taste--he is so narrow, like the
dining-room clock.... Don't you understand? Narrow, you know--gray,
light gray..."

"What rubbish you're talking!" said the countess.

Natasha continued: "Don't you really understand? Nicholas would
understand.... Bezukhov, now, is blue, dark-blue and red, and he is
square."

"You flirt with him too," said the countess, laughing.

"No, he is a Freemason, I have found out. He is fine, dark-blue
and red.... How can I explain it to you?"

"Little countess!" the count's voice called from behind the door.
"You're not asleep?" Natasha jumped up, snatched up her slippers,
and ran barefoot to her own room.

It was a long time before she could sleep. She kept thinking that no
one could understand all that she understood and all there was in her.

"Sonya?" she thought, glancing at that curled-up, sleeping little
kitten with her enormous plait of hair. "No, how could she? She's
virtuous. She fell in love with Nicholas and does not wish to know
anything more. Even Mamma does not understand. It is wonderful how
clever I am and how... charming she is," she went on, speaking of
herself in the third person, and imagining it was some very wise
man--the wisest and best of men--who was saying it of her. "There is
everything, everything in her," continued this man. "She is
unusually intelligent, charming... and then she is pretty,
uncommonly pretty, and agile--she swims and rides splendidly... and
her voice! One can really say it's a wonderful voice!"

She hummed a scrap from her favorite opera by Cherubini, threw
herself on her bed, laughed at the pleasant thought that she would
immediately fall asleep, called Dunyasha the maid to put out the
candle, and before Dunyasha had left the room had already passed
into yet another happier world of dreams, where everything was as
light and beautiful as in reality, and even more so because it was
different.


Next day the countess called Boris aside and had a talk with him,
after which he ceased coming to the Rostovs'.





CHAPTER XIV


On the thirty-first of December, New Year's Eve, 1809 --10 an old
grandee of Catherine's day was giving a ball and midnight supper.
The diplomatic corps and the Emperor himself were to be present.

The grandee's well-known mansion on the English Quay glittered
with innumerable lights. Police were stationed at the brightly lit
entrance which was carpeted with red baize, and not only gendarmes but
dozens of police officers and even the police master himself stood
at the porch. Carriages kept driving away and fresh ones arriving,
with red-liveried footmen and footmen in plumed hats. From the
carriages emerged men wearing uniforms, stars, and ribbons, while
ladies in satin and ermine cautiously descended the carriage steps
which were let down for them with a clatter, and then walked hurriedly
and noiselessly over the baize at the entrance.

Almost every time a new carriage drove up a whisper ran through
the crowd and caps were doffed.

"The Emperor?... No, a minister.... prince... ambassador. Don't
you see the plumes?..." was whispered among the crowd.

One person, better dressed than the rest, seemed to know everyone
and mentioned by name the greatest dignitaries of the day.

A third of the visitors had already arrived, but the Rostovs, who
were to be present, were still hurrying to get dressed.

There had been many discussions and preparations for this ball in
the Rostov family, many fears that the invitation would not arrive,
that the dresses would not be ready, or that something would not be
arranged as it should be.

Marya Ignatevna Peronskaya, a thin and shallow maid of honor at
the court of the Dowager Empress, who was a friend and relation of the
countess and piloted the provincial Rostovs in Petersburg high
society, was to accompany them to the ball.

They were to call for her at her house in the Taurida Gardens at ten
o'clock, but it was already five minutes to ten, and the girls were
not yet dressed.

Natasha was going to her first grand ball. She had got up at eight
that morning and had been in a fever of excitement and activity all
day. All her powers since morning had been concentrated on ensuring
that they all--she herself, Mamma, and Sonya--should be as well
dressed as possible. Sonya and her mother put themselves entirely in
her hands. The countess was to wear a claret-colored velvet dress, and
the two girls white gauze over pink silk slips, with roses on their
bodices and their hair dressed a la grecque.

Everything essential had already been done; feet, hands, necks,
and ears washed, perfumed, and powdered, as befits a ball; the
openwork silk stockings and white satin shoes with ribbons were
already on; the hairdressing was almost done. Sonya was finishing
dressing and so was the countess, but Natasha, who had bustled about
helping them all, was behindhand. She was still sitting before a
looking-glass with a dressing jacket thrown over her slender
shoulders. Sonya stood ready dressed in the middle of the room and,
pressing the head of a pin till it hurt her dainty finger, was
fixing on a last ribbon that squeaked as the pin went through it.

"That's not the way, that's not the way, Sonya!" cried Natasha
turning her head and clutching with both hands at her hair which the
maid who was dressing it had not time to release. "That bow is not
right. Come here!"

Sonya sat down and Natasha pinned the ribbon on differently.

"Allow me, Miss! I can't do it like that," said the maid who was
holding Natasha's hair.

"Oh, dear! Well then, wait. That's right, Sonya."

"Aren't you ready? It is nearly ten," came the countess' voice.

"Directly! Directly! And you, Mamma?"

"I have only my cap to pin on."

"Don't do it without me!" called Natasha. "You won't do it right."

"But it's already ten."

They had decided to be at the ball by half past ten, and Natasha had
still to get dressed and they had to call at the Taurida Gardens.

When her hair was done, Natasha, in her short petticoat from under
which her dancing shoes showed, and in her mother's dressing jacket,
ran up to Sonya, scrutinized her, and then ran to her mother.
Turning her mother's head this way and that, she fastened on the cap
and, hurriedly kissing her gray hair, ran back to the maids who were
turning up the hem of her skirt.

The cause of the delay was Natasha's skirt, which was too long.
Two maids were turning up the hem and hurriedly biting off the ends of
thread. A third with pins in her mouth was running about between the
countess and Sonya, and a fourth held the whole of the gossamer
garment up high on one uplifted hand.

"Mavra, quicker, darling!"

"Give me my thimble, Miss, from there..."

"Whenever will you be ready?" asked the count coming to the door.
"Here is here is some scent. Peronskaya must be tired of waiting."

"It's ready, Miss," said the maid, holding up the shortened gauze
dress with two fingers, and blowing and shaking something off it, as
if by this to express a consciousness of the airiness and purity of
what she held.

Natasha began putting on the dress.

"In a minute! In a minute! Don't come in, Papa!" she cried to her
father as he opened the door--speaking from under the filmy skirt
which still covered her whole face.

Sonya slammed the door to. A minute later they let the count in.
He was wearing a blue swallow-tail coat, shoes and stockings, and
was perfumed and his hair pomaded.

"Oh, Papa! how nice you look! Charming!" cried Natasha, as she stood
in the middle of the room smoothing out the folds of the gauze.

"If you please, Miss! allow me," said the maid, who on her knees was
pulling the skirt straight and shifting the pins from one side of
her mouth to the other with her tongue.

"Say what you like," exclaimed Sonya, in a despairing voice as she
looked at Natasha, "say what you like, it's still too long."

Natasha stepped back to look at herself in the pier glass. The dress
was too long.

"Really, madam, it is not at all too long," said Mavra, crawling
on her knees after her young lady.

"Well, if it's too long we'll take it up... we'll tack it up in
one minute," said the resolute Dunyasha taking a needle that was stuck
on the front of her little shawl and, still kneeling on the floor, set
to work once more.

At that moment, with soft steps, the countess came in shyly, in
her cap and velvet gown.

"Oo-oo, my beauty!" exclaimed the count, "she looks better than
any of you!"

He would have embraced her but, blushing, she stepped aside
fearing to be rumpled.

"Mamma, your cap, more to this side," said Natasha. "I'll arrange
it," and she rushed forward so that the maids who were tacking up
her skirt could not move fast enough and a piece of gauze was torn
off.

"Oh goodness! What has happened? Really it was not my fault!"

"Never mind, I'll run it up, it won't show," said Dunyasha.

"What a beauty--a very queen!" said the nurse as she came to the
door. "And Sonya! They are lovely!"

At a quarter past ten they at last got into their carriages and
started. But they had still to call at the Taurida Gardens.

Peronskaya was quite ready. In spite of her age and plainness she
had gone through the same process as the Rostovs, but with less
flurry--for to her it was a matter of routine. Her ugly old body was
washed, perfumed, and powdered in just the same way. She had washed
behind her ears just as carefully, and when she entered her drawing
room in her yellow dress, wearing her badge as maid of honor, her
old lady's maid was as full of rapturous admiration as the Rostovs'
servants had been.

She praised the Rostovs' toilets. They praised her taste and toilet,
and at eleven o'clock, careful of their coiffures and dresses, they
settled themselves in their carriages and drove off.





CHAPTER XV


Natasha had not had a moment free since early morning and had not
once had time to think of what lay before her.

In the damp chill air and crowded closeness of the swaying carriage,
she for the first time vividly imagined what was in store for her
there at the ball, in those brightly lighted rooms--with music,
flowers, dances, the Emperor, and all the brilliant young people of
Petersburg. The prospect was so splendid that she hardly believed it
would come true, so out of keeping was it with the chill darkness
and closeness of the carriage. She understood all that awaited her
only when, after stepping over the red baize at the entrance, she
entered the hall, took off her fur cloak, and, beside Sonya and in
front of her mother, mounted the brightly illuminated stairs between
the flowers. Only then did she remember how she must behave at a ball,
and tried to assume the majestic air she considered indispensable
for a girl on such an occasion. But, fortunately for her, she felt her
eyes growing misty, she saw nothing clearly, her pulse beat a
hundred to the minute, and the blood throbbed at her heart. She
could not assume that pose, which would have made her ridiculous,
and she moved on almost fainting from excitement and trying with all
her might to conceal it. And this was the very attitude that became
her best. Before and behind them other visitors were entering, also
talking in low tones and wearing ball dresses. The mirrors on the
landing reflected ladies in white, pale-blue, and pink dresses, with
diamonds and pearls on their bare necks and arms.

Natasha looked in the mirrors and could not distinguish her
reflection from the others. All was blended into one brilliant
procession. On entering the ballroom the regular hum of voices,
footsteps, and greetings deafened Natasha, and the light and glitter
dazzled her still more. The host and hostess, who had already been
standing at the door for half an hour repeating the same words to
the various arrivals, "Charme de vous voir,"* greeted the Rostovs
and Peronskaya in the same manner.


*"Delighted to see you."


The two girls in their white dresses, each with a rose in her
black hair, both curtsied in the same way, but the hostess' eye
involuntarily rested longer on the slim Natasha. She looked at her and
gave her alone a special smile in addition to her usual smile as
hostess. Looking at her she may have recalled the golden,
irrecoverable days of her own girlhood and her own first ball. The
host also followed Natasha with his eyes and asked the count which was
his daughter.

"Charming!" said he, kissing the tips of his fingers.

In the ballroom guests stood crowding at the entrance doors awaiting
the Emperor. The countess took up a position in one of the front
rows of that crowd. Natasha heard and felt that several people were
asking about her and looking at her. She realized that those
noticing her liked her, and this observation helped to calm her.

"There are some like ourselves and some worse," she thought.

Peronskaya was pointing out to the countess the most important
people at the ball.

"That is the Dutch ambassador, do you see? That gray-haired man,"
she said, indicating an old man with a profusion of silver-gray
curly hair, who was surrounded by ladies laughing at something he
said.

"Ah, here she is, the Queen of Petersburg, Countess Bezukhova," said
Peronskaya, indicating Helene who had just entered. "How lovely! She
is quite equal to Marya Antonovna. See how the men, young and old, pay
court to her. Beautiful and clever... they say Prince--is quite mad
about her. But see, those two, though not good-looking, are even
more run after."

She pointed to a lady who was crossing the room followed by a very
plain daughter.

"She is a splendid match, a millionairess," said Peronskaya. "And
look, here come her suitors."

"That is Bezukhova's brother, Anatole Kuragin," she said, indicating
a handsome officer of the Horse Guards who passed by them with head
erect, looking at something over the heads of the ladies. "He's
handsome, isn't he? I hear they will marry him to that rich girl.
But your cousin, Drubetskoy, is also very attentive to her. They say
she has millions. Oh yes, that's the French ambassador himself!" she
replied to the countess' inquiry about Caulaincourt. "Looks as if he
were a king! All the same, the French are charming, very charming.
No one more charming in society. Ah, here she is! Yes, she is still
the most beautiful of them all, our Marya Antonovna! And how simply
she is dressed! Lovely! And that stout one in spectacles is the
universal Freemason," she went on, indicating Pierre. "Put him
beside his wife and he looks a regular buffoon!"

Pierre, swaying his stout body, advanced, making way through the
crowd and nodding to right and left as casually and good-naturedly
as if he were passing through a crowd at a fair. He pushed through,
evidently looking for someone.

Natasha looked joyfully at the familiar face of Pierre, "the
buffoon," as Peronskaya had called him, and knew he was looking for
them, and for her in particular. He had promised to be at the ball and
introduce partners to her.

But before he reached them Pierre stopped beside a very handsome,
dark man of middle height, and in a white uniform, who stood by a
window talking to a tall man wearing stars and a ribbon. Natasha at
once recognized the shorter and younger man in the white uniform: it
was Bolkonski, who seemed to her to have grown much younger,
happier, and better-looking.

"There's someone else we know--Bolkonski, do you see, Mamma?" said
Natasha, pointing out Prince Andrew. "You remember, he stayed a
night with us at Otradnoe."

"Oh, you know him?" said Peronskaya. "I can't bear him. Il fait a
present la pluie et le beau temps.* He's too proud for anything.
Takes after his father. And he's hand in glove with Speranski, writing
some project or other. Just look how he treats the ladies! There's one
talking to him and he has turned away," she said, pointing at him.
"I'd give it to him if he treated me as he does those ladies."


*"He is all the rage just now.





CHAPTER XVI


Suddenly everybody stirred, began talking, and pressed forward and
then back, and between the two rows, which separated, the Emperor
entered to the sounds of music that had immediately struck up.
Behind him walked his host and hostess. He walked in rapidly, bowing
to right and left as if anxious to get the first moments of the
reception over. The band played the polonaise in vogue at that time on
account of the words that had been set to it, beginning: "Alexander,
Elisaveta, all our hearts you ravish quite..." The Emperor passed on
to the drawing room, the crowd made a rush for the doors, and
several persons with excited faces hurried there and back again.
Then the crowd hastily retired from the drawing-room door, at which
the Emperor reappeared talking to the hostess. A young man, looking
distraught, pounced down on the ladies, asking them to move aside.
Some ladies, with faces betraying complete forgetfulness of all the
rules of decorum, pushed forward to the detriment of their toilets.
The men began to choose partners and take their places for the
polonaise.

Everyone moved back, and the Emperor came smiling out of the drawing
room leading his hostess by the hand but not keeping time to the
music. The host followed with Marya Antonovna Naryshkina; then came
ambassadors, ministers, and various generals, whom Peronskaya
diligently named. More than half the ladies already had partners and
were taking up, or preparing to take up, their positions for the
polonaise. Natasha felt that she would be left with her mother and
Sonya among a minority of women who crowded near the wall, not
having been invited to dance. She stood with her slender arms
hanging down, her scarcely defined bosom rising and falling regularly,
and with bated breath and glittering, frightened eyes gazed straight
before her, evidently prepared for the height of joy or misery. She
was not concerned about the Emperor or any of those great people
whom Peronskaya was pointing out--she had but one thought: "Is it
possible no one will ask me, that I shall not be among the first to
dance? Is it possible that not one of all these men will notice me?
They do not even seem to see me, or if they do they look as if they
were saying, 'Ah, she's not the one I'm after, so it's not worth
looking at her!' No, it's impossible," she thought. "They must know
how I long to dance, how splendidly I dance, and how they would
enjoy dancing with me."

The strains of the polonaise, which had continued for a considerable
time, had begun to sound like a sad reminiscence to Natasha's ears.
She wanted to cry. Peronskaya had left them. The count was at the
other end of the room. She and the countess and Sonya were standing by
themselves as in the depths of a forest amid that crowd of
strangers, with no one interested in them and not wanted by anyone.
Prince Andrew with a lady passed by, evidently not recognizing them.
The handsome Anatole was smilingly talking to a partner on his arm and
looked at Natasha as one looks at a wall. Boris passed them twice
and each time turned away. Berg and his wife, who were not dancing,
came up to them.

This family gathering seemed humiliating to Natasha--as if there
were nowhere else for the family to talk but here at the ball. She did
not listen to or look at Vera, who was telling her something about her
own green dress.

At last the Emperor stopped beside his last partner (he had danced
with three) and the music ceased. A worried aide-de-camp ran up to the
Rostovs requesting them to stand farther back, though as it was they
were already close to the wall, and from the gallery resounded the
distinct, precise, enticingly rhythmical strains of a waltz. The
Emperor looked smilingly down the room. A minute passed but no one had
yet begun dancing. An aide-de-camp, the Master of Ceremonies, went
up to Countess Bezukhova and asked her to dance. She smilingly
raised her hand and laid it on his shoulder without looking at him.
The aide-de-camp, an adept in his art, grasping his partner firmly
round her waist, with confident deliberation started smoothly, gliding
first round the edge of the circle, then at the corner of the room
he caught Helene's left hand and turned her, the only sound audible,
apart from the ever-quickening music, being the rhythmic click of
the spurs on his rapid, agile feet, while at every third beat his
partner's velvet dress spread out and seemed to flash as she whirled
round. Natasha gazed at them and was ready to cry because it was not
she who was dancing that first turn of the waltz.

Prince Andrew, in the white uniform of a cavalry colonel, wearing
stockings and dancing shoes, stood looking animated and bright in
the front row of the circle not far from the Rostovs. Baron Firhoff
was talking to him about the first sitting of the Council of State
to be held next day. Prince Andrew, as one closely connected with
Speranski and participating in the work of the legislative commission,
could give reliable information about that sitting, concerning which
various rumors were current. But not listening to what Firhoff was
saying, he was gazing now at the sovereign and now at the men
intending to dance who had not yet gathered courage to enter the
circle.

Prince Andrew was watching these men abashed by the Emperor's
presence, and the women who were breathlessly longing to be asked to
dance.

Pierre came up to him and caught him by the arm.

"You always dance. I have a protegee, the young Rostova, here. Ask
her," he said.

"Where is she?" asked Bolkonski. "Excuse me!" he added, turning to
the baron, "we will finish this conversation elsewhere--at a ball
one must dance." He stepped forward in the direction Pierre indicated.
The despairing, dejected expression of Natasha's face caught his
eye. He recognized her, guessed her feelings, saw that it was her
debut, remembered her conversation at the window, and with an
expression of pleasure on his face approached Countess Rostova.

"Allow me to introduce you to my daughter," said the countess,
with heightened color.

"I have the pleasure of being already acquainted, if the countess
remembers me," said Prince Andrew with a low and courteous bow quite
belying Peronskaya's remarks about his rudeness, and approaching
Natasha he held out his arm to grasp her waist before he had completed
his invitation. He asked her to waltz. That tremulous expression on
Natasha's face, prepared either for despair or rapture, suddenly
brightened into a happy, grateful, childlike smile.

"I have long been waiting for you," that frightened happy little
girl seemed to say by the smile that replaced the threatened tears, as
she raised her hand to Prince Andrew's shoulder. They were the
second couple to enter the circle. Prince Andrew was one of the best
dancers of his day and Natasha danced exquisitely. Her little feet
in their white satin dancing shoes did their work swiftly, lightly,
and independently of herself, while her face beamed with ecstatic
happiness. Her slender bare arms and neck were not beautiful--compared
to Helene's her shoulders looked thin and her bosom undeveloped. But
Helene seemed, as it were, hardened by a varnish left by the thousands
of looks that had scanned her person, while Natasha was like a girl
exposed for the first time, who would have felt very much ashamed
had she not been assured that this was absolutely necessary.

Prince Andrew liked dancing, and wishing to escape as quickly as
possible from the political and clever talk which everyone addressed
to him, wishing also to break up the circle of restraint he
disliked, caused by the Emperor's presence, he danced, and had
chosen Natasha because Pierre pointed her out to him and because she
was the first pretty girl who caught his eye; but scarcely had he
embraced that slender supple figure and felt her stirring so close
to him and smiling so near him than the wine of her charm rose to
his head, and he felt himself revived and rejuvenated when after
leaving her he stood breathing deeply and watching the other dancers.





CHAPTER XVII


After Prince Andrew, Boris came up to ask Natasha for dance, and
then the aide-de-camp who had opened the ball, and several other young
men, so that, flushed and happy, and passing on her superfluous
partners to Sonya, she did not cease dancing all the evening. She
noticed and saw nothing of what occupied everyone else. Not only did
she fail to notice that the Emperor talked a long time with the French
ambassador, and how particularly gracious he was to a certain lady, or
that Prince So-and-so and So-and-so did and said this and that, and
that Helene had great success and was honored was by the special
attention of So-and-so, but she did not even see the Emperor, and only
noticed that he had gone because the ball became livelier after his
departure. For one of the merry cotillions before supper Prince Andrew
was again her partner. He reminded her of their first encounter in the
Otradnoe avenue, and how she had been unable to sleep that moonlight
night, and told her how he had involuntarily overheard her. Natasha
blushed at that recollection and tried to excuse herself, as if
there had been something to be ashamed of in what Prince Andrew had
overheard.

Like all men who have grown up in society, Prince Andrew liked
meeting someone there not of the conventional society stamp. And
such was Natasha, with her surprise, her delight, her shyness, and
even her mistakes in speaking French. With her he behaved with special
care and tenderness, sitting beside her and talking of the simplest
and most unimportant matters; he admired her shy grace. In the
middle of the cotillion, having completed one of the figures, Natasha,
still out of breath, was returning to her seat when another dancer
chose her. She was tired and panting and evidently thought of
declining, but immediately put her hand gaily on the man's shoulder,
smiling at Prince Andrew.

"I'd be glad to sit beside you and rest: I'm tired; but you see
how they keep asking me, and I'm glad of it, I'm happy and I love
everybody, and you and I understand it all," and much, much more was
said in her smile. When her partner left her Natasha ran across the
room to choose two ladies for the figure.

"If she goes to her cousin first and then to another lady, she
will be my wife," said Prince Andrew to himself quite to his own
surprise, as he watched her. She did go first to her cousin.

"What rubbish sometimes enters one's head!" thought Prince Andrew,
"but what is certain is that that girl is so charming, so original,
that she won't be dancing here a month before she will be
married.... Such as she are rare here," he thought, as Natasha,
readjusting a rose that was slipping on her bodice, settled herself
beside him.

When the cotillion was over the old count in his blue coat came up
to the dancers. He invited Prince Andrew to come and see them, and
asked his daughter whether she was enjoying herself. Natasha did not
answer at once but only looked up with a smile that said
reproachfully: "How can you ask such a question?"

"I have never enjoyed myself so much before!" she said, and Prince
Andrew noticed how her thin arms rose quickly as if to embrace her
father and instantly dropped again. Natasha was happier than she had
ever been in her life. She was at that height of bliss when one
becomes completely kind and good and does not believe in the
possibility of evil, unhappiness, or sorrow.

At that ball Pierre for the first time felt humiliated by the
position his wife occupied in court circles. He was gloomy and
absent-minded. A deep furrow ran across his forehead, and standing
by a window he stared over his spectacles seeing no one.

On her way to supper Natasha passed him.

Pierre's gloomy, unhappy look struck her. She stopped in front of
him. She wished to help him, to bestow on him the superabundance of
her own happiness.

"How delightful it is, Count!" said she. "Isn't it?"

Pierre smiled absent-mindedly, evidently not grasping what she said.

"Yes, I am very glad," he said.

"How can people be dissatisfied with anything?" thought Natasha.
"Especially such a capital fellow as Bezukhov!" In Natasha's eyes
all the people at the ball alike were good, kind, and splendid people,
loving one another; none of them capable of injuring another--and so
they ought all to be happy.





CHAPTER XVIII


Next day Prince Andrew thought of the ball, but his mind did not
dwell on it long. "Yes, it was a very brilliant ball," and then...
"Yes, that little Rostova is very charming. There's something fresh,
original, un-Petersburg-like about her that distinguishes her." That
was all he thought about yesterday's ball, and after his morning tea
he set to work.

But either from fatigue or want of sleep he was ill-disposed for
work and could get nothing done. He kept criticizing his own work,
as he often did, and was glad when he heard someone coming.

The visitor was Bitski, who served on various committees, frequented
all the societies in Petersburg, and a passionate devotee of the new
ideas and of Speranski, and a diligent Petersburg newsmonger--one of
those men who choose their opinions like their clothes according to
the fashion, but who for that very reason appear to be the warmest
partisans. Hardly had he got rid of his hat before he ran into
Prince Andrew's room with a preoccupied air and at once began talking.
He had just heard particulars of that morning's sitting of the Council
of State opened by the Emperor, and he spoke of it enthusiastically.
The Emperor's speech had been extraordinary. It had been a speech such
as only constitutional monarchs deliver. "The Sovereign plainly said
that the Council and Senate are estates of the realm, he said that the
government must rest not on authority but on secure bases. The Emperor
said that the fiscal system must be reorganized and the accounts
published," recounted Bitski, emphasizing certain words and opening
his eyes significantly.

"Ah, yes! Today's events mark an epoch, the greatest epoch in our
history," he concluded.

Prince Andrew listened to the account of the opening of the
Council of State, which he had so impatiently awaited and to which
he had attached such importance, and was surprised that this event,
now that it had taken place, did not affect him, and even seemed quite
insignificant. He listened with quiet irony to Bitski's enthusiastic
account of it. A very simple thought occurred to him: "What does it
matter to me or to Bitski what the Emperor was pleased to say at the
Council? Can all that make me any happier or better?"

And this simple reflection suddenly destroyed all the interest
Prince Andrew had felt in the impending reforms. He was going to
dine that evening at Speranski's, "with only a few friends," as the
host had said when inviting him. The prospect of that dinner in the
intimate home circle of the man he so admired had greatly interested
Prince Andrew, especially as he had not yet seen Speranski in his
domestic surroundings, but now he felt disinclined to go to it.

At the appointed hour, however, he entered the modest house
Speranski owned in the Taurida Gardens. In the parqueted dining room
this small house, remarkable for its extreme cleanliness (suggesting
that of a monastery), Prince Andrew, who was rather late, found the
friendly gathering of Speranski's intimate acquaintances already
assembled at five o'clock. There were no ladies present except
Speranski's little daughter (long-faced like her father) and her
governess. The other guests were Gervais, Magnitski, and Stolypin.
While still in the anteroom Prince Andrew heard loud voices and a
ringing staccato laugh--a laugh such as one hears on the stage.
Someone--it sounded like Speranski--was distinctly ejaculating
ha-ha-ha. Prince Andrew had never before heard Speranski's famous
laugh, and this ringing, high pitched laughter from a statesman made a
strange impression on him.

He entered the dining room. The whole company were standing
between two windows at a small table laid with hors-d'oeuvres.
Speranski, wearing a gray swallow-tail coat with a star on the breast,
and evidently still the same waistcoat and high white stock he had
worn at the meeting of the Council of State, stood at the table with a
beaming countenance. His guests surrounded him. Magnitski,
addressing himself to Speranski, was relating an anecdote, and
Speranski was laughing in advance at what Magnitski was going to
say. When Prince Andrew entered the room Magnitski's words were
again crowned by laughter. Stolypin gave a deep bass guffaw as he
munched a piece of bread and cheese. Gervais laughed softly with a
hissing chuckle, and Speranski in a high-pitched staccato manner.

Still laughing, Speranski held out his soft white hand to Prince
Andrew.

"Very pleased to see you, Prince," he said. "One moment..." he
went on, turning to Magnitski and interrupting his story. "We have
agreed that this is a dinner for recreation, with not a word about
business!" and turning again to the narrator he began to laugh afresh.

Prince Andrew looked at the laughing Speranski with astonishment,
regret, and disillusionment. It seemed to him that this was not
Speranski but someone else. Everything that had formerly appeared
mysterious and fascinating in Speranski suddenly became plain and
unattractive.

At dinner the conversation did not cease for a moment and seemed
to consist of the contents of a book of funny anecdotes. Before
Magnitski had finished his story someone else was anxious to relate
something still funnier. Most of the anecdotes, if not relating to the
state service, related to people in the service. It seemed that in
this company the insignificance of those people was so definitely
accepted that the only possible attitude toward them was one of good
humored ridicule. Speranski related how at the Council that morning
a deaf dignitary, when asked his opinion, replied that he thought so
too. Gervais gave a long account of an official revision, remarkable
for the stupidity of everybody concerned. Stolypin, stuttering,
broke into the conversation and began excitedly talking of the
abuses that existed under the former order of things--threatening to
give a serious turn to the conversation. Magnitski starting quizzing
Stolypin about his vehemence. Gervais intervened with a joke, and
the talk reverted to its former lively tone.

Evidently Speranski liked to rest after his labors and find
amusement in a circle of friends, and his guests, understanding his
wish, tried to enliven him and amuse themselves. But their gaiety
seemed to Prince Andrew mirthless and tiresome. Speranski's
high-pitched voice struck him unpleasantly, and the incessant laughter
grated on him like a false note. Prince Andrew did not laugh and
feared that he would be a damper on the spirits of the company, but no
one took any notice of his being out of harmony with the general mood.
They all seemed very gay.

He tried several times to join in the conversation, but his
remarks were tossed aside each time like a cork thrown out of the
water, and he could not jest with them.

There was nothing wrong or unseemly in what they said, it was
witty and might have been funny, but it lacked just that something
which is the salt of mirth, and they were not even aware that such a
thing existed.

After dinner Speranski's daughter and her governess rose. He
patted the little girl with his white hand and kissed her. And that
gesture, too, seemed unnatural to Prince Andrew.

The men remained at table over their port--English fashion. In the
midst of a conversation that was started about Napoleon's Spanish
affairs, which they all agreed in approving, Prince Andrew began to
express a contrary opinion. Speranski smiled and, with an evident wish
to prevent the conversation from taking an unpleasant course, told a
story that had no connection with the previous conversation. For a few
moments all were silent.

Having sat some time at table, Speranski corked a bottle of wine
and, remarking, "Nowadays good wine rides in a carriage and pair,"
passed it to the servant and got up. All rose and continuing to talk
loudly went into the drawing room. Two letters brought by a courier
were handed to Speranski and he took them to his study. As soon as
he had left the room the general merriment stopped and the guests
began to converse sensibly and quietly with one another.

"Now for the recitation!" said Speranski on returning from his
study. "A wonderful talent!" he said to Prince Andrew, and Magnitski
immediately assumed a pose and began reciting some humorous verses
in French which he had composed about various well-known Petersburg
people. He was interrupted several times by applause. When the
verses were finished Prince Andrew went up to Speranski and took his
leave.

"Where are you off to so early?" asked Speranski.

"I promised to go to a reception."

They said no more. Prince Andrew looked closely into those
mirrorlike, impenetrable eyes, and felt that it had been ridiculous of
him to have expected anything from Speranski and from any of his own
activities connected with him, or ever to have attributed importance
to what Speranski was doing. That precise, mirthless laughter rang
in Prince Andrew's ears long after he had left the house.

When he reached home Prince Andrew began thinking of his life in
Petersburg during those last four months as if it were something
new. He recalled his exertions and solicitations, and the history of
his project of army reform, which had been accepted for
consideration and which they were trying to pass over in silence
simply because another, a very poor one, had already been prepared and
submitted to the Emperor. He thought of the meetings of a committee of
which Berg was a member. He remembered how carefully and at what
length everything relating to form and procedure was discussed at
those meetings, and how sedulously and promptly all that related to
the gist of the business was evaded. He recalled his labors on the
Legal Code, and how painstakingly he had translated the articles of
the Roman and French codes into Russian, and he felt ashamed of
himself. Then he vividly pictured to himself Bogucharovo, his
occupations in the country, his journey to Ryazan; he remembered the
peasants and Dron the village elder, and mentally applying to them the
Personal Rights he had divided into paragraphs, he felt astonished
that he could have spent so much time on such useless work.





CHAPTER XIX


Next day Prince Andrew called at a few houses he had not visited
before, and among them at the Rostovs' with whom he had renewed
acquaintance at the ball. Apart from considerations of politeness
which demanded the call, he wanted to see that original, eager girl
who had left such a pleasant impression on his mind, in her own home.

Natasha was one of the first to meet him. She was wearing a
dark-blue house dress in which Prince Andrew thought her even prettier
than in her ball dress. She and all the Rostov family welcomed him
as an old friend, simply and cordially. The whole family, whom he
had formerly judged severely, now seemed to him to consist of
excellent, simple, and kindly people. The old count's hospitality
and good nature, which struck one especially in Petersburg as a
pleasant surprise, were such that Prince Andrew could not refuse to
stay to dinner. "Yes," he thought, "they are capital people, who of
course have not the slightest idea what a treasure they possess in
Natasha; but they are kindly folk and form the best possible setting
for this strikingly poetic, charming girl, overflowing with life!"

In Natasha Prince Andrew was conscious of a strange world completely
alien to him and brimful of joys unknown to him, a different world,
that in the Otradnoe avenue and at the window that moonlight night had
already begun to disconcert him. Now this world disconcerted him no
longer and was no longer alien to him, but he himself having entered
it found in it a new enjoyment.

After dinner Natasha, at Prince Andrew's request, went to the
clavichord and began singing. Prince Andrew stood by a window
talking to the ladies and listened to her. In the midst of a phrase he
ceased speaking and suddenly felt tears choking him, a thing he had
thought impossible for him. He looked at Natasha as she sang, and
something new and joyful stirred in his soul. He felt happy and at the
same time sad. He had absolutely nothing to weep about yet he was
ready to weep. What about? His former love? The little princess? His
disillusionments?... His hopes for the future?... Yes and no. The
chief reason was a sudden, vivid sense of the terrible contrast
between something infinitely great and illimitable within him and that
limited and material something that he, and even she, was. This
contrast weighed on and yet cheered him while she sang.

As soon as Natasha had finished she went up to him and asked how
he liked her voice. She asked this and then became confused, feeling
that she ought not to have asked it. He smiled, looking at her, and
said he liked her singing as he liked everything she did.

Prince Andrew left the Rostovs' late in the evening. He went to
bed from habit, but soon realized that he could not sleep. Having
lit his candle he sat up in bed, then got up, then lay down again
not at all troubled by his sleeplessness: his soul was as fresh and
joyful as if he had stepped out of a stuffy room into God's own
fresh air. It did not enter his head that he was in love with Natasha;
he was not thinking about her, but only picturing her to himself,
and in consequence all life appeared in a new light. "Why do I strive,
why do I toil in this narrow, confined frame, when life, all life with
all its joys, is open to me?" said he to himself. And for the first
time for a very long while he began making happy plans for the future.
He decided that he must attend to his son's education by finding a
tutor and putting the boy in his charge, then he ought to retire
from the service and go abroad, and see England, Switzerland and
Italy. "I must use my freedom while I feel so much strength and
youth in me," he said to himself. "Pierre was right when he said one
must believe in the possibility of happiness in order to be happy, and
now I do believe in it. Let the dead bury their dead, but while one
has life one must live and be happy!" thought he.





CHAPTER XX


One morning Colonel Berg, whom Pierre knew as he knew everybody in
Moscow and Petersburg, came to see him. Berg arrived in an
immaculate brand-new uniform, with his hair pomaded and brushed
forward over his temples as the Emperor Alexander wore his hair.

"I have just been to see the countess, your wife. Unfortunately
she could not grant my request, but I hope, Count, I shall be more
fortunate with you," he said with a smile.

"What is it you wish, Colonel? I am at your service."

"I have now quite settled in my new rooms, Count" (Berg said this
with perfect conviction that this information could not but be
agreeable), "and so I wish to arrange just a small party for my own
and my wife's friends." (He smiled still more pleasantly.) "I wished
to ask the countess and you to do me the honor of coming to tea and to
supper."

Only Countess Helene, considering the society of such people as
the Bergs beneath her, could be cruel enough to refuse such an
invitation. Berg explained so clearly why he wanted to collect at
his house a small but select company, and why this would give him
pleasure, and why though he grudged spending money on cards or
anything harmful, he was prepared to run into some expense for the
sake of good society--that Pierre could not refuse, and promised to
come.

"But don't be late, Count, if I may venture to ask; about ten
minutes to eight, please. We shall make up a rubber. Our general is
coming. He is very good to me. We shall have supper, Count. So you
will do me the favor."

Contrary to his habit of being late, Pierre on that day arrived at
the Bergs' house, not at ten but at fifteen minutes to eight.

Having prepared everything necessary for the party, the Bergs were
ready for their guests' arrival.

In their new, clean, and light study with its small busts and
pictures and new furniture sat Berg and his wife. Berg, closely
buttoned up in his new uniform, sat beside his wife explaining to
her that one always could and should be acquainted with people above
one, because only then does one get satisfaction from acquaintances.

"You can get to know something, you can ask for something. See how I
managed from my first promotion." (Berg measured his life not by years
but by promotions.) "My comrades are still nobodies, while I am only
waiting for a vacancy to command a regiment, and have the happiness to
be your husband." (He rose and kissed Vera's hand, and on the way to
her straightened out a turned-up corner of the carpet.) "And how
have I obtained all this? Chiefly by knowing how to choose my
aquaintances. It goes without saying that one must be conscientious
and methodical."

Berg smiled with a sense of his superiority over a weak woman, and
paused, reflecting that this dear wife of his was after all but a weak
woman who could not understand all that constitutes a man's dignity,
what it was ein Mann zu sein.* Vera at the same time smiling with a
sense of superiority over her good, conscientious husband, who all the
same understood life wrongly, as according to Vera all men did.
Berg, judging by his wife, thought all women weak and foolish. Vera,
judging only by her husband and generalizing from that observation,
supposed that all men, though they understand nothing and are
conceited and selfish, ascribe common sense to themselves alone.


*To be a man.


Berg rose and embraced his wife carefully, so as not to crush her
lace fichu for which he had paid a good price, kissing her straight on
the lips.

"The only thing is, we mustn't have children too soon," he
continued, following an unconscious sequence of ideas.

"Yes," answered Vera, "I don't at all want that. We must live for
society."

"Princess Yusupova wore one exactly like this," said Berg,
pointing to the fichu with a happy and kindly smile.

Just then Count Bezukhov was announced. Husband and wife glanced
at one another, both smiling with self-satisfaction, and each mentally
claiming the honor of this visit.

"This is what what comes of knowing how to make acquaintances,"
thought Berg. "This is what comes of knowing how to conduct oneself."

"But please don't interrupt me when I am entertaining the guests,"
said Vera, "because I know what interests each of them and what to say
to different people."

Berg smiled again.

"It can't be helped: men must sometimes have masculine
conversation," said he.

They received Pierre in their small, new drawing-room, where it
was impossible to sit down anywhere without disturbing its symmetry,
neatness, and order; so it was quite comprehensible and not strange
that Berg, having generously offered to disturb the symmetry of an
armchair or of the sofa for his dear guest, but being apparently
painfully undecided on the matter himself, eventually left the visitor
to settle the question of selection. Pierre disturbed the symmetry
by moving a chair for himself, and Berg and Vera immediately began
their evening party, interrupting each other in their efforts to
entertain their guest.

Vera, having decided in her own mind that Pierre ought to be
entertained with conversation about the French embassy, at once
began accordingly. Berg, having decided that masculine conversation
was required, interrupted his wife's remarks and touched on the
question of the war with Austria, and unconsciously jumped from the
general subject to personal considerations as to the proposals made
him to take part in the Austrian campaign and the reasons why he had
declined them. Though the conversation was very incoherent and Vera
was angry at the intrusion of the masculine element, both husband
and wife felt with satisfaction that, even if only one guest was
present, their evening had begun very well and was as like as two peas
to every other evening party with its talk, tea, and lighted candles.

Before long Boris, Berg's old comrade, arrived. There was a shade of
condescension and patronage in his treatment of Berg and Vera. After
Boris came a lady with the colonel, then the general himself, then the
Rostovs, and the party became unquestionably exactly like all other
evening parties. Berg and Vera could not repress their smiles of
satisfaction at the sight of all this movement in their drawing
room, at the sound of the disconnected talk, the rustling of
dresses, and the bowing and scraping. Everything was just as everybody
always has it, especially so the general, who admired the apartment,
patted Berg on the shoulder, and with parental authority superintended
the setting out of the table for boston. The general sat down by Count
Ilya Rostov, who was next to himself the most important guest. The old
people sat with the old, the young with the young, and the hostess
at the tea table, on which stood exactly the same kind of cakes in a
silver cake basket as the Panins had at their party. Everything was
just as it was everywhere else.





CHAPTER XXI


Pierre, as one of the principal guests, had to sit down to boston
with Count Rostov, the general, and the colonel. At the card table
he happened to be directly facing Natasha, and was struck by a curious
change that had come over her since the ball. She was silent, and
not only less pretty than at the ball, but only redeemed from
plainness by her look of gentle indifference to everything around.

"What's the matter with her?" thought Pierre, glancing at her. She
was sitting by her sister at the tea table, and reluctantly, without
looking at him, made some reply to Boris who sat down beside her.
After playing out a whole suit and to his partner's delight taking
five tricks, Pierre, hearing greetings and the steps of someone who
had entered the room while he was picking up his tricks, glanced again
at Natasha.

"What has happened to her?" he asked himself with still greater
surprise.

Prince Andrew was standing before her, saying something to her
with a look of tender solicitude. She, having raised her head, was
looking up at him, flushed and evidently trying to master her rapid
breathing. And the bright glow of some inner fire that had been
suppressed was again alight in her. She was completely transformed and
from a plain girl had again become what she had been at the ball.

Prince Andrew went up to Pierre, and the latter noticed a new and
youthful expression in his friend's face.

Pierre changed places several times during the game, sitting now
with his back to Natasha and now facing her, but during the whole of
the six rubbers he watched her and his friend.

"Something very important is happening between them," thought
Pierre, and a feeling that was both joyful and painful agitated him
and made him neglect the game.

After six rubbers the general got up, saying that it was no use
playing like that, and Pierre was released. Natasha on one side was
talking with Sonya and Boris, and Vera with a subtle smile was
saying something to Prince Andrew. Pierre went up to his friend and,
asking whether they were talking secrets, sat down beside them.
Vera, having noticed Prince Andrew's attentions to Natasha, decided
that at a party, a real evening party, subtle allusions to the
tender passion were absolutely necessary and, seizing a moment when
Prince Andrew was alone, began a conversation with him about
feelings in general and about her sister. With so intellectual a guest
as she considered Prince Andrew to be, she felt that she had to employ
her diplomatic tact.

When Pierre went up to them he noticed that Vera was being carried
away by her self-satisfied talk, but that Prince Andrew seemed
embarrassed, a thing that rarely happened with him.

"What do you think?" Vera was saying with an arch smile. "You are so
discerning, Prince, and understand people's characters so well at a
glance. What do you think of Natalie? Could she be constant in her
attachments? Could she, like other women" (Vera meant herself),
"love a man once for all and remain true to him forever? That is
what I consider true love. What do you think, Prince?"

"I know your sister too little," replied Prince Andrew, with a
sarcastic smile under which he wished to hide his embarrassment, "to
be able to solve so delicate a question, and then I have noticed
that the less attractive a woman is the more constant she is likely to
be," he added, and looked up Pierre who was just approaching them.

"Yes, that is true, Prince. In our days," continued Vera--mentioning
"our days" as people of limited intelligence are fond of doing,
imagining that they have discovered and appraised the peculiarities of
"our days" and that human characteristics change with the times--"in
our days a girl has so much freedom that the pleasure of being courted
often stifles real feeling in her. And it must be confessed that
Natalie is very susceptible." This return to the subject of Natalie
caused Prince Andrew to knit his brows with discomfort: he was about
to rise, but Vera continued with a still more subtle smile:

"I think no one has been more courted than she," she went on, "but
till quite lately she never cared seriously for anyone. Now you
know, Count," she said to Pierre, "even our dear cousin Boris, who,
between ourselves, was very far gone in the land of tenderness..."
(alluding to a map of love much in vogue at that time).

Prince Andrew frowned and remained silent.

"You are friendly with Boris, aren't you?" asked Vera.

"Yes, I know him..."

"I expect he has told you of his childish love for Natasha?"

"Oh, there was childish love?" suddenly asked Prince Andrew,
blushing unexpectedly.

"Yes, you know between cousins intimacy often leads to love. Le
cousinage est un dangereux voisinage.* Don't you think so?"


*"Cousinhood is a dangerous neighborhood."


"Oh, undoubtedly!" said Prince Andrew, and with sudden and unnatural
liveliness he began chaffing Pierre about the need to be very
careful with his fifty-year-old Moscow cousins, and in the midst of
these jesting remarks he rose, taking Pierre by the arm, and drew
him aside.

"Well?" asked Pierre, seeing his friend's strange animation with
surprise, and noticing the glance he turned on Natasha as he rose.

"I must... I must have a talk with you," said Prince Andrew. "You
know that pair of women's gloves?" (He referred to the Masonic
gloves given to a newly initiated Brother to present to the woman he
loved.) "I... but no, I will talk to you later on," and with a strange
light in his eyes and restlessness in his movements, Prince Andrew
approached Natasha and sat down beside her. Pierre saw how Prince
Andrew asked her something and how she flushed as she replied.

But at that moment Berg came to Pierre and began insisting that he
should take part in an argument between the general and the colonel on
the affairs in Spain.

Berg was satisfied and happy. The smile of pleasure never left his
face. The party was very successful and quite like other parties he
had seen. Everything was similar: the ladies' subtle talk, the
cards, the general raising his voice at the card table, and the
samovar and the tea cakes; only one thing was lacking that he had
always seen at the evening parties he wished to imitate. They had
not yet had a loud conversation among the men and a dispute about
something important and clever. Now the general had begun such a
discussion and so Berg drew Pierre to it.





CHAPTER XXII


Next day, having been invited by the count, Prince Andrew dined with
the Rostovs and spent the rest of the day there.

Everyone in the house realized for whose sake Prince Andrew came,
and without concealing it he tried to be with Natasha all day. Not
only in the soul of the frightened yet happy and enraptured Natasha,
but in the whole house, there was a feeling of awe at something
important that was bound to happen. The countess looked with sad and
sternly serious eyes at Prince Andrew when he talked to Natasha and
timidly started some artificial conversation about trifles as soon
as he looked her way. Sonya was afraid to leave Natasha and afraid
of being in the way when she was with them. Natasha grew pale, in a
panic of expectation, when she remained alone with him for a moment.
Prince Andrew surprised her by his timidity. She felt that he wanted
to say something to her but could not bring himself to do so.

In the evening, when Prince Andrew had left, the countess went up to
Natasha and whispered: "Well, what?"

"Mamma! For heaven's sake don't ask me anything now! One can't
talk about that," said Natasha.

But all the same that night Natasha, now agitated and now
frightened, lay a long time in her mother's bed gazing straight
before her. She told her how he had complimented her, how he told
her he was going abroad, asked her where they were going to spend
the summer, and then how he had asked her about Boris.

"But such a... such a... never happened to me before!" she said.
"Only I feel afraid in his presence. I am always afraid when I'm
with him. What does that mean? Does it mean that it's the real
thing? Yes? Mamma, are you asleep?"

"No, my love; I am frightened myself," answered her mother. "Now
go!"

"All the same I shan't sleep. What silliness, to sleep! Mummy!
Mummy! such a thing never happened to me before," she said,
surprised and alarmed at the feeling she was aware of in herself. "And
could we ever have thought!..."

It seemed to Natasha that even at the time she first saw Prince
Andrew at Otradnoe she had fallen in love with him. It was as if she
feared this strange, unexpected happiness of meeting again the very
man she had then chosen (she was firmly convinced she had done so) and
of finding him, as it seemed, not indifferent to her.

"And it had to happen that he should come specially to Petersburg
while we are here. And it had to happen that we should meet at that
ball. It is fate. Clearly it is fate that everything led up to this!
Already then, directly I saw him I felt something peculiar."

"What else did he say to you? What are those verses? Read them..."
said her mother, thoughtfully, referring to some verses Prince
Andrew had written in Natasha's album.

"Mamma, one need not be ashamed of his being a widower?"

"Don't, Natasha! Pray to God. 'Marriages are made in heaven,'"
said her mother.

"Darling Mummy, how I love you! How happy I am!" cried Natasha,
shedding tears of joy and excitement and embracing her mother.

At that very time Prince Andrew was sitting with Pierre and
telling him of his love for Natasha and his firm resolve to make her
his wife.

That day Countess Helene had a reception at her house. The French
ambassador was there, and a foreign prince of the blood who had of
late become a frequent visitor of hers, and many brilliant ladies
and gentlemen. Pierre, who had come downstairs, walked through the
rooms and struck everyone by his preoccupied, absent-minded, and
morose air.

Since the ball he had felt the approach of a fit of nervous
depression and had made desperate efforts to combat it. Since the
intimacy of his wife with the royal prince, Pierre had unexpectedly
been made a gentleman of the bedchamber, and from that time he had
begun to feel oppressed and ashamed in court society, and dark
thoughts of the vanity of all things human came to him oftener than
before. At the same time the feeling he had noticed between his
protegee Natasha and Prince Andrew accentuated his gloom by the
contrast between his own position and his friend's. He tried equally
to avoid thinking about his wife, and about Natasha and Prince Andrew;
and again everything seemed to him insignificant in comparison with
eternity; again the question: for what? presented itself; and he
forced himself to work day and night at Masonic labors, hoping to
drive away the evil spirit that threatened him. Toward midnight, after
he had left the countess' apartments, he was sitting upstairs in a
shabby dressing gown, copying out the original transaction of the
Scottish lodge of Freemasons at a table in his low room cloudy with
tobacco smoke, when someone came in. It was Prince Andrew.

"Ah, it's you!" said Pierre with a preoccupied, dissatisfied air.
"And I, you see, am hard at it." He pointed to his manuscript book
with that air of escaping from the ills of life with which unhappy
people look at their work.

Prince Andrew, with a beaming, ecstatic expression of renewed life
on his face, paused in front of Pierre and, not noticing his sad look,
smiled at him with the egotism of joy.

"Well, dear heart," said he, "I wanted to tell you about it
yesterday and I have come to do so today. I never experienced anything
like it before. I am in love, my friend!"

Suddenly Pierre heaved a deep sigh and dumped his heavy person
down on the sofa beside Prince Andrew.

"With Natasha Rostova, yes?" said he.

"Yes, yes! Who else should it be? I should never have believed it,
but the feeling is stronger than I. Yesterday I tormented myself and
suffered, but I would not exchange even that torment for anything in
the world, I have not lived till now. At last I live, but I can't live
without her! But can she love me?... I am too old for her.... Why
don't you speak?"

"I? I? What did I tell you?" said Pierre suddenly, rising and
beginning to pace up and down the room. "I always thought it....
That girl is such a treasure... she is a rare girl.... My dear friend,
I entreat you, don't philosophize, don't doubt, marry, marry,
marry.... And I am sure there will not be a happier man than you."

"But what of her?"

"She loves you."

"Don't talk rubbish..." said Prince Andrew, smiling and looking into
Pierre's eyes.

"She does, I know," Pierre cried fiercely.

"But do listen," returned Prince Andrew, holding him by the arm. "Do
you know the condition I am in? I must talk about it to someone."

"Well, go on, go on. I am very glad," said Pierre, and his face
really changed, his brow became smooth, and he listened gladly to
Prince Andrew. Prince Andrew seemed, and really was, quite a
different, quite a new man. Where was his spleen, his contempt for
life, his disillusionment? Pierre was the only person to whom he
made up his mind to speak openly; and to him he told all that was in
his soul. Now he boldly and lightly made plans for an extended future,
said he could not sacrifice his own happiness to his father's caprice,
and spoke of how he would either make his father consent to this
marriage and love her, or would do without his consent; then he
marveled at the feeling that had mastered him as at something strange,
apart from and independent of himself.

"I should not have believed anyone who told me that I was capable of
such love," said Prince Andrew. "It is not at all the same feeling
that I knew in the past. The whole world is now for me divided into
two halves: one half is she, and there all is joy, hope, light: the
other half is everything where she is not, and there is all gloom
and darkness...."

"Darkness and gloom," reiterated Pierre: "yes, yes, I understand
that."

"I cannot help loving the light, it is not my fault. And I am very
happy! You understand me? I know you are glad for my sake."

"Yes, yes," Pierre assented, looking at his friend with a touched
and sad expression in his eyes. The brighter Prince Andrew's lot
appeared to him, the gloomier seemed his own.





CHAPTER XXIII


Prince Andrew needed his father's consent to his marriage, and to
obtain this he started for the country next day.

His father received his son's communication with external composure,
but inward wrath. He could not comprehend how anyone could wish to
alter his life or introduce anything new into it, when his own life
was already ending. "If only they would let me end my days as I want
to," thought the old man, "then they might do as they please." With
his son, however, he employed the diplomacy he reserved for
important occasions and, adopting a quiet tone, discussed the whole
matter.

In the first place the marriage was not a brilliant one as regards
birth, wealth, or rank. Secondly, Prince Andrew was no longer as young
as he had been and his health was poor (the old man laid special
stress on this), while she was very young. Thirdly, he had a son
whom it would be a pity to entrust to a chit of a girl. "Fourthly
and finally," the father said, looking ironically at his son, "I beg
you to put it off for a year: go abroad, take a cure, look out as
you wanted to for a German tutor for Prince Nicholas. Then if your
love or passion or obstinacy--as you please--is still as great, marry!
And that's my last word on it. Mind, the last..." concluded the
prince, in a tone which showed that nothing would make him alter his
decision.

Prince Andrew saw clearly that the old man hoped that his
feelings, or his fiancee's, would not stand a year's test, or that
he (the old prince himself) would die before then, and he decided to
conform to his father's wish--to propose, and postpone the wedding for
a year.

Three weeks after the last evening he had spent with the Rostovs,
Prince Andrew returned to Petersburg.


Next day after her talk with her mother Natasha expected Bolkonski
all day, but he did not come. On the second and third day it was the
same. Pierre did not come either and Natasha, not knowing that
Prince Andrew had gone to see his father, could not explain his
absence to herself.

Three weeks passed in this way. Natasha had no desire to go out
anywhere and wandered from room to room like a shadow, idle and
listless; she wept secretly at night and did not go to her mother in
the evenings. She blushed continually and was irritable. It seemed
to her that everybody knew about her disappointment and was laughing
at her and pitying her. Strong as was her inward grief, this wound
to her vanity intensified her misery.

Once she came to her mother, tried to say something, and suddenly
began to cry. Her tears were those of an offended child who does not
know why it is being punished.

The countess began to soothe Natasha, who after first listening to
her mother's words, suddenly interrupted her:

"Leave off, Mamma! I don't think, and don't want to think about
it! He just came and then left off, left off..."

Her voice trembled, and she again nearly cried, but recovered and
went on quietly:

"And I don't at all want to get married. And I am afraid of him; I
have now become quite calm, quite calm."

The day after this conversation Natasha put on the old dress which
she knew had the peculiar property of conducing to cheerfulness in the
mornings, and that day she returned to the old way of life which she
had abandoned since the ball. Having finished her morning tea she went
to the ballroom, which she particularly liked for its loud
resonance, and began singing her solfeggio. When she had finished
her first exercise she stood still in the middle of the room and
sang a musical phrase that particularly pleased her. She listened
joyfully (as though she had not expected it) to the charm of the notes
reverberating, filling the whole empty ballroom, and slowly dying
away; and all at once she felt cheerful. "What's the good of making so
much of it? Things are nice as it is," she said to herself, and she
began walking up and down the room, not stepping simply on the
resounding parquet but treading with each step from the heel to the
toe (she had on a new and favorite pair of shoes) and listening to the
regular tap of the heel and creak of the toe as gladly as she had to
the sounds of her own voice. Passing a mirror she glanced into it.
"There, that's me!" the expression of her face seemed to say as she
caught sight of herself. "Well, and very nice too! I need nobody."

A footman wanted to come in to clear away something in the room
but she would not let him, and having closed the door behind him
continued her walk. That morning she had returned to her favorite
mood--love of, and delight in, herself. "How charming that Natasha
is!" she said again, speaking as some third, collective, male
person. "Pretty, a good voice, young, and in nobody's way if only they
leave her in peace." But however much they left her in peace she could
not now be at peace, and immediately felt this.

In the hall the porch door opened, and someone asked, "At home?" and
then footsteps were heard. Natasha was looking at the mirror, but
did not see herself. She listened to the sounds in the hall. When
she saw herself, her face was pale. It was he. She knew this for
certain, though she hardly heard his voice through the closed doors.

Pale and agitated, Natasha ran into the drawing room.

"Mamma! Bolkonski has come!" she said. "Mamma, it is awful, it is
unbearable! I don't want... to be tormented? What am I to do?..."

Before the countess could answer, Prince Andrew entered the room
with an agitated and serious face. As soon as he saw Natasha his
face brightened. He kissed the countess' hand and Natasha's, and sat
down beside the sofa.

"It is long since we had the pleasure..." began the countess, but
Prince Andrew interrupted her by answering her intended question,
obviously in haste to say what he had to.

"I have not been to see all this time because I have been at my
father's. I had to talk over a very important matter with him. I
only got back last night," he said glancing at Natasha; "I want to
have a talk with you, Countess," he added after a moment's pause.

The countess lowered her eyes, sighing deeply.

"I am at your disposal," she murmured.

Natasha knew that she ought to go away, but was unable to do so:
something gripped her throat, and regardless of manners she stared
straight at Prince Andrew with wide-open eyes.

"At once? This instant!... No, it can't be!" she thought.

Again he glanced at her, and that glance convinced her that she
was not mistaken. Yes, at once, that very instant, her fate would be
decided.

"Go, Natasha! I will call you," said the countess in a whisper.

Natasha glanced with frightened imploring eyes at Prince Andrew
and at her mother and went out.

"I have come, Countess, to ask for your daughter's hand," said
Prince Andrew.

The countess' face flushed hotly, but she said nothing.

"Your offer..." she began at last sedately. He remained silent,
looking into her eyes. "Your offer..." (she grew confused) "is
agreeable to us, and I accept your offer. I am glad. And my husband...
I hope... but it will depend on her...."

"I will speak to her when I have your consent.... Do you give it
to me?" said Prince Andrew.

"Yes," replied the countess. She held out her hand to him, and
with a mixed feeling of estrangement and tenderness pressed her lips
to his forehead as he stooped to kiss her hand. She wished to love him
as a son, but felt that to her he was a stranger and a terrifying man.
"I am sure my husband will consent," said the countess, "but your
father..."

"My father, to whom I have told my plans, has made it an express
condition of his consent that the wedding is not to take place for a
year. And I wished to tell you of that," said Prince Andrew.

"It is true that Natasha is still young, but--so long as that?..."

"It is unavoidable," said Prince Andrew with a sigh.

"I will send her to you," said the countess, and left the room.

"Lord have mercy upon us!" she repeated while seeking her daughter.

Sonya said that Natasha was in her bedroom. Natasha was sitting on
the bed, pale and dry eyed, and was gazing at the icons and whispering
something as she rapidly crossed herself. Seeing her mother she jumped
up and flew to her.

"Well, Mamma?... Well?..."

"Go, go to him. He is asking for your hand," said the countess,
coldly it seemed to Natasha. "Go... go," said the mother, sadly and
reproachfully, with a deep sigh, as her daughter ran away.

Natasha never remembered how she entered the drawing room. When
she came in and saw him she paused. "Is it possible that this stranger
has now become everything to me?" she asked herself, and immediately
answered, "Yes, everything! He alone is now dearer to me than
everything in the world." Prince Andrew came up to her with downcast
eyes.

"I have loved you from the very first moment I saw you. May I hope?"

He looked at her and was struck by the serious impassioned
expression of her face. Her face said: "Why ask? Why doubt what you
cannot but know? Why speak, when words cannot express what one feels?"

She drew near to him and stopped. He took her hand and kissed it.

"Do you love me?"

"Yes, yes!" Natasha murmured as if in vexation. Then she sighed
loudly and, catching her breath more and more quickly, began to sob.

"What is it? What's the matter?"

"Oh, I am so happy!" she replied, smiled through her tears, bent
over closer to him, paused for an instant as if asking herself whether
she might, and then kissed him.

Prince Andrew held her hands, looked into her eyes, and did not find
in his heart his former love for her. Something in him had suddenly
changed; there was no longer the former poetic and mystic charm of
desire, but there was pity for her feminine and childish weakness,
fear at her devotion and trustfulness, and an oppressive yet joyful
sense of the duty that now bound him to her forever. The present
feeling, though not so bright and poetic as the former, was stronger
and more serious.

"Did your mother tell you that it cannot be for a year?" asked
Prince Andrew, still looking into her eyes.

"Is it possible that I--the 'chit of a girl,' as everybody called
me," thought Natasha--"is it possible that I am now to be the wife and
the equal of this strange, dear, clever man whom even my father
looks up to? Can it be true? Can it be true that there can be no
more playing with life, that now I am grown up, that on me now lies
a responsibility for my every word and deed? Yes, but what did he
ask me?"

"No," she replied, but she had not understood his question.

"Forgive me!" he said. "But you are so young, and I have already
been through so much in life. I am afraid for you, you do not yet know
yourself."

Natasha listened with concentrated attention, trying but failing
to take in the meaning of his words.

"Hard as this year which delays my happiness will be," continued
Prince Andrew, "it will give you time to be sure of yourself. I ask
you to make me happy in a year, but you are free: our engagement shall
remain a secret, and should you find that you do not love me, or
should you come to love..." said Prince Andrew with an unnatural
smile.

"Why do you say that?" Natasha interrupted him. "You know that
from the very day you first came to Otradnoe I have loved you," she
cried, quite convinced that she spoke the truth.

"In a year you will learn to know yourself...."

"A whole year!" Natasha repeated suddenly, only now realizing that
the marriage was to be postponed for a year. "But why a year? Why a
year?..."

Prince Andrew began to explain to her the reasons for this delay.
Natasha did not hear him.

"And can't it be helped?" she asked. Prince Andrew did not reply,
but his face expressed the impossibility of altering that decision.

"It's awful! Oh, it's awful! awful!" Natasha suddenly cried, and
again burst into sobs. "I shall die, waiting a year: it's
impossible, it's awful!" She looked into her lover's face and saw in
it a look of commiseration and perplexity.

"No, no! I'll do anything!" she said, suddenly checking her tears.
"I am so happy."

The father and mother came into the room and gave the betrothed
couple their blessing.

From that day Prince Andrew began to frequent the Rostovs' as
Natasha's affianced lover.





CHAPTER XXIV

No betrothal ceremony took place and Natasha's engagement to
Bolkonski was not announced; Prince Andrew insisted on that. He said
that as he was responsible for the delay he ought to bear the whole
burden of it; that he had given his word and bound himself forever,
but that he did not wish to bind Natasha and gave her perfect freedom.
If after six months she felt that she did not love him she would
have full right to reject him. Naturally neither Natasha nor her
parents wished to hear of this, but Prince Andrew was firm. He came
every day to the Rostovs', but did not behave to Natasha as an
affianced lover: he did not use the familiar thou, but said you to
her, and kissed only her hand. After their engagement, quite
different, intimate, and natural relations sprang up between them.
It was as if they had not known each other till now. Both liked to
recall how they had regarded each other when as yet they were
nothing to one another; they felt themselves now quite different
beings: then they were artificial, now natural and sincere. At first
the family felt some constraint in intercourse with Prince Andrew;
he seemed a man from another world, and for a long time Natasha
trained the family to get used to him, proudly assuring them all
that he only appeared to be different, but was really just like all of
them, and that she was not afraid of him and no one else ought to
be. After a few days they grew accustomed to him, and without
restraint in his presence pursued their usual way of life, in which he
took his part. He could talk about rural economy with the count,
fashions with the countess and Natasha, and about albums and fancywork
with Sonya. Sometimes the household both among themselves and in his
presence expressed their wonder at how it had all happened, and at the
evident omens there had been of it: Prince Andrew's coming to Otradnoe
and their coming to Petersburg, and the likeness between Natasha and
Prince Andrew which her nurse had noticed on his first visit, and
Andrew's encounter with Nicholas in 1805, and many other incidents
betokening that it had to be.

In the house that poetic dullness and quiet reigned which always
accompanies the presence of a betrothed couple. Often when all sitting
together everyone kept silent. Sometimes the others would get up and
go away and the couple, left alone, still remained silent. They rarely
spoke of their future life. Prince Andrew was afraid and ashamed to
speak of it. Natasha shared this as she did all his feelings, which
she constantly divined. Once she began questioning him about his
son. Prince Andrew blushed, as he often did now--Natasha
particularly liked it in him--and said that his son would not live
with them.

"Why not?" asked Natasha in a frightened tone.

"I cannot take him away from his grandfather, and besides..."

"How I should have loved him!" said Natasha, immediately guessing
his thought; "but I know you wish to avoid any pretext for finding
fault with us."

Sometimes the old count would come up, kiss Prince Andrew, and ask
his advice about Petya's education or Nicholas' service. The old
countess sighed as she looked at them; Sonya was always getting
frightened lest she should be in the way and tried to find excuses for
leaving them alone, even when they did not wish it. When Prince Andrew
spoke (he could tell a story very well), Natasha listened to him
with pride; when she spoke she noticed with fear and joy that he gazed
attentively and scrutinizingly at her. She asked herself in
perplexity: "What does he look for in me? He is trying to discover
something by looking at me! What if what he seeks in me is not there?"
Sometimes she fell into one of the mad, merry moods characteristic
of her, and then she particularly loved to hear and see how Prince
Andrew laughed. He seldom laughed, but when he did he abandoned
himself entirely to his laughter, and after such a laugh she always
felt nearer to him. Natasha would have been completely happy if the
thought of the separation awaiting her and drawing near had not
terrified her, just as the mere thought of it made him turn pale and
cold.

On the eve of his departure from Petersburg Prince Andrew brought
with him Pierre, who had not been to the Rostovs' once since the ball.
Pierre seemed disconcerted and embarrassed. He was talking to the
countess, and Natasha sat down beside a little chess table with Sonya,
thereby inviting Prince Andrew to come too. He did so.

"You have known Bezukhov a long time?" he asked. "Do you like him?"

"Yes, he's a dear, but very absurd."

And as usual when speaking of Pierre, she began to tell anecdotes of
his absent-mindedness, some of which had even been invented about him.

"Do you know I have entrusted him with our secret? I have known
him from childhood. He has a heart of gold. I beg you, Natalie,"
Prince Andrew said with sudden seriousness--"I am going away and
heaven knows what may happen. You may cease to... all right, I know
I am not to say that. Only this, then: whatever may happen to you when
I am not here..."

"What can happen?"

"Whatever trouble may come," Prince Andrew continued, "I beg you,
Mademoiselle Sophie, whatever may happen, to turn to him alone for
advice and help! He is a most absent-minded and absurd fellow, but
he has a heart of gold."

Neither her father, nor her mother, nor Sonya, nor Prince Andrew
himself could have foreseen how the separation from her lover would
act on Natasha. Flushed and agitated she went about the house all that
day, dry-eyed, occupied with most trivial matters as if not
understanding what awaited her. She did not even cry when, on taking
leave, he kissed her hand for the last time. "Don't go!" she said in a
tone that made him wonder whether he really ought not to stay and
which he remembered long afterwards. Nor did she cry when he was gone;
but for several days she sat in her room dry-eyed, taking no
interest in anything and only saying now and then, "Oh, why did he
go away?"

But a fortnight after his departure, to the surprise of those around
her, she recovered from her mental sickness just as suddenly and
became her old self again, but with a change in her moral physiognomy,
as a child gets up after a long illness with a changed expression of
face.





CHAPTER XXV


During that year after his son's departure, Prince Nicholas
Bolkonski's health and temper became much worse. He grew still more
irritable, and it was Princess Mary who generally bore the brunt of
his frequent fits of unprovoked anger. He seemed carefully to seek out
her tender spots so as to torture her mentally as harshly as possible.
Princess Mary had two passions and consequently two joys--her
nephew, little Nicholas, and religion--and these were the favorite
subjects of the prince's attacks and ridicule. Whatever was spoken
of he would bring round to the superstitiousness of old maids, or
the petting and spoiling of children. "You want to make him"--little
Nicholas--"into an old maid like yourself! A pity! Prince Andrew wants
a son and not an old maid," he would say. Or, turning to
Mademoiselle Bourienne, he would ask her in Princess Mary's presence
how she liked our village priests and icons and would joke about them.

He continually hurt Princess Mary's feelings and tormented her,
but it cost her no effort to forgive him. Could he be to blame
toward her, or could her father, whom she knew loved her in spite of
it all, be unjust? And what is justice? The princess never thought
of that proud word "justice." All the complex laws of man centered for
her in one clear and simple law--the law of love and self-sacrifice
taught us by Him who lovingly suffered for mankind though He Himself
was God. What had she to do with the justice or injustice of other
people? She had to endure and love, and that she did.

During the winter Prince Andrew had come to Bald Hills and had
been gay, gentle, and more affectionate than Princess Mary had known
him for a long time past. She felt that something had happened to him,
but he said nothing to her about his love. Before he left he had a
long talk with his father about something, and Princess Mary noticed
that before his departure they were dissatisfied with one another.

Soon after Prince Andrew had gone, Princess Mary wrote to her friend
Julie Karagina in Petersburg, whom she had dreamed (as all girls
dream) of marrying to her brother, and who was at that time in
mourning for her own brother, killed in Turkey.


Sorrow, it seems, is our common lot, my dear, tender friend Julie.

Your loss is so terrible that I can only explain it to myself as a
special providence of God who, loving you, wishes to try you and
your excellent mother. Oh, my friend! Religion, and religion alone,
can--I will not say comfort us--but save us from despair. Religion
alone can explain to us what without its help man cannot comprehend:
why, for what cause, kind and noble beings able to find happiness in
life--not merely harming no one but necessary to the happiness of
others--are called away to God, while cruel, useless, harmful persons,
or such as are a burden to themselves and to others, are left
living. The first death I saw, and one I shall never forget--that of
my dear sister-in-law--left that impression on me. Just as you ask
destiny why your splendid brother had to die, so I asked why that
angel Lise, who not only never wronged anyone, but in whose soul there
were never any unkind thoughts, had to die. And what do you think,
dear friend? Five years have passed since then, and already I, with my
petty understanding, begin to see clearly why she had to die, and in
what way that death was but an expression of the infinite goodness
of the Creator, whose every action, though generally
incomprehensible to us, is but a manifestation of His infinite love
for His creatures. Perhaps, I often think, she was too angelically
innocent to have the strength to perform all a mother's duties. As a
young wife she was irreproachable; perhaps she could not have been
so as a mother. As it is, not only has she left us, and particularly
Prince Andrew, with the purest regrets and memories, but probably
she will there receive a place I dare not hope for myself. But not
to speak of her alone, that early and terrible death has had the
most beneficent influence on me and on my brother in spite of all
our grief. Then, at the moment of our loss, these thoughts could not
occur to me; I should then have dismissed them with horror, but now
they are very clear and certain. I write all this to you, dear friend,
only to convince you of the Gospel truth which has become for me a
principle of life: not a single hair of our heads will fall without
His will. And His will is governed only by infinite love for us, and
so whatever befalls us is for our good.

You ask whether we shall spend next winter in Moscow. In spite of my
wish to see you, I do not think so and do not want to do so. You
will be surprised to hear that the reason for this is Buonaparte!
The case is this: my father's health is growing noticeably worse, he
cannot stand any contradiction and is becoming irritable. This
irritability is, as you know, chiefly directed to political questions.
He cannot endure the notion that Buonaparte is negotiating on equal
terms with all the sovereigns of Europe and particularly with our own,
the grandson of the Great Catherine! As you know, I am quite
indifferent to politics, but from my father's remarks and his talks
with Michael Ivanovich I know all that goes on in the world and
especially about the honors conferred on Buonaparte, who only at
Bald Hills in the whole world, it seems, is not accepted as a great
man, still less as Emperor of France. And my father cannot stand this.
It seems to me that it is chiefly because of his political views
that my father is reluctant to speak of going to Moscow; for he
foresees the encounters that would result from his way of expressing
his views regardless of anybody. All the benefit he might derive
from a course of treatment he would lose as a result of the disputes
about Buonaparte which would be inevitable. In any case it will be
decided very shortly.

Our family life goes on in the old way except for my brother
Andrew's absence. He, as I wrote you before, has changed very much
of late. After his sorrow he only this year quite recovered his
spirits. He has again become as I used to know him when a child: kind,
affectionate, with that heart of gold to which I know no equal. He has
realized, it seems to me, that life is not over for him. But
together with this mental change he has grown physically much
weaker. He has become thinner and more nervous. I am anxious about him
and glad he is taking this trip abroad which the doctors recommended
long ago. I hope it will cure him. You write that in Petersburg he
is spoken of as one of the most active, cultivated, and capable of the
young men. Forgive my vanity as a relation, but I never doubted it.
The good he has done to everybody here, from his peasants up to the
gentry, is incalculable. On his arrival in Petersburg he received only
his due. I always wonder at the way rumors fly from Petersburg to
Moscow, especially such false ones as that you write about--I mean the
report of my brother's betrothal to the little Rostova. I do not think
my brother will ever marry again, and certainly not her; and this is
why: first, I know that though he rarely speaks about the wife he
has lost, the grief of that loss has gone too deep in his heart for
him ever to decide to give her a successor and our little angel a
stepmother. Secondly because, as far as I know, that girl is not the
kind of girl who could please Prince Andrew. I do not think he would
choose her for a wife, and frankly I do not wish it. But I am
running on too long and am at the end of my second sheet. Good-by,
my dear friend. May God keep you in His holy and mighty care. My
dear friend, Mademoiselle Bourienne, sends you kisses.

MARY





CHAPTER XXVI


In the middle of the summer Princess Mary received an unexpected
letter from Prince Andrew in Switzerland in which he gave her
strange and surprising news. He informed her of his engagement to
Natasha Rostova. The whole letter breathed loving rapture for his
betrothed and tender and confiding affection for his sister. He
wrote that he had never loved as he did now and that only now did he
understand and know what life was. He asked his sister to forgive
him for not having told her of his resolve when he had last visited
Bald Hills, though he had spoken of it to his father. He had not
done so for fear Princess Mary should ask her father to give his
consent, irritating him and having to bear the brunt of his
displeasure without attaining her object. "Besides," he wrote, "the
matter was not then so definitely settled as it is now. My father then
insisted on a delay of a year and now already six months, half of that
period, have passed, and my resolution is firmer than ever. If the
doctors did not keep me here at the spas I should be back in Russia,
but as it is I have to postpone my return for three months. You know
me and my relations with Father. I want nothing from him. I have
been and always shall be independent; but to go against his will and
arouse his anger, now that he may perhaps remain with us such a
short time, would destroy half my happiness. I am now writing to him
about the same question, and beg you to choose a good moment to hand
him the letter and to let me know how he looks at the whole matter and
whether there is hope that he may consent to reduce the term by four
months."

After long hesitations, doubts, and prayers, Princess Mary gave
the letter to her father. The next day the old prince said to her
quietly:

"Write and tell your brother to wait till I am dead.... It won't
be long--I shall soon set him free."

The princess was about to reply, but her father would not let her
speak and, raising his voice more and more, cried:

"Marry, marry, my boy!... A good family!... Clever people, eh? Rich,
eh? Yes, a nice stepmother little Nicholas will have! Write and tell
him that he may marry tomorrow if he likes. She will be little
Nicholas' stepmother and I'll marry Bourienne!... Ha, ha, ha! He
mustn't be without a stepmother either! Only one thing, no more
women are wanted in my house--let him marry and live by himself.
Perhaps you will go and live with him too?" he added, turning to
Princess Mary. "Go in heavens name! Go out into the frost... the
frost... the frost!

After this outburst the prince did not speak any more about the
matter. But repressed vexation at his son's poor-spirited behavior
found expression in his treatment of his daughter. To his former
pretexts for irony a fresh one was now added--allusions to stepmothers
and amiabilities to Mademoiselle Bourienne.

"Why shouldn't I marry her?" he asked his daughter. "She'll make a
splendid princess!"

And latterly, to her surprise and bewilderment, Princess Mary
noticed that her father was really associating more and more with
the Frenchwoman. She wrote to Prince Andrew about the reception of his
letter, but comforted him with hopes of reconciling their father to
the idea.

Little Nicholas and his education, her brother Andrew, and
religion were Princess Mary's joys and consolations; but besides that,
since everyone must have personal hopes, Princess Mary in the
profoundest depths of her heart had a hidden dream and hope that
supplied the chief consolation of her life. This comforting dream
and hope were given her by God's folk--the half-witted and other
pilgrims who visited her without the prince's knowledge. The longer
she lived, the more experience and observation she had of life, the
greater was her wonder at the short-sightedness of men who seek
enjoyment and happiness here on earth: toiling, suffering, struggling,
and harming one another, to obtain that impossible, visionary,
sinful happiness. Prince Andrew had loved his wife, she died, but that
was not enough: he wanted to bind his happiness to another woman.
Her father objected to this because he wanted a more distinguished and
wealthier match for Andrew. And they all struggled and suffered and
tormented one another and injured their souls, their eternal souls,
for the attainment of benefits which endure but for an instant. Not
only do we know this ourselves, but Christ, the Son of God, came
down to earth and told us that this life is but for a moment and is
a probation; yet we cling to it and think to find happiness in it.
"How is it that no one realizes this?" thought Princess Mary. "No
one except these despised God's folk who, wallet on back, come to me
by the back door, afraid of being seen by the prince, not for fear
of ill-usage by him but for fear of causing him to sin. To leave
family, home, and all the cares of worldly welfare, in order without
clinging to anything to wander in hempen rags from place to place
under an assumed name, doing no one any harm but praying for all-
for those who drive one away as well as for those who protect one:
higher than that life and truth there is no life or truth!"

There was one pilgrim, a quiet pockmarked little woman of fifty
called Theodosia, who for over thirty years had gone about barefoot
and worn heavy chains. Princess Mary was particularly fond of her.
Once, when in a room with a lamp dimly lit before the icon Theodosia
was talking of her life, the thought that Theodosia alone had found
the true path of life suddenly came to Princess Mary with such force
that she resolved to become a pilgrim herself. When Theodosia had gone
to sleep Princess Mary thought about this for a long time, and at last
made up her mind that, strange as it might seem, she must go on a
pilgrimage. She disclosed this thought to no one but to her confessor,
Father Akinfi, the monk, and he approved of her intention. Under guise
of a present for the pilgrims, Princess Mary prepared a pilgrim's
complete costume for herself: a coarse smock, bast shoes, a rough
coat, and a black kerchief. Often, approaching the chest of drawers
containing this secret treasure, Princess Mary paused, uncertain
whether the time had not already come to put her project into
execution.

Often, listening to the pilgrims' tales, she was so stimulated by
their simple speech, mechanical to them but to her so full of deep
meaning, that several times she was on the point of abandoning
everything and running away from home. In imagination she already
pictured herself by Theodosia's side, dressed in coarse rags,
walking with a staff, a wallet on her back, along the dusty road,
directing her wanderings from one saint's shrine to another, free from
envy, earthly love, or desire, and reaching at last the place where
there is no more sorrow or sighing, but eternal joy and bliss.

"I shall come to a place and pray there, and before having time to
get used to it or getting to love it, I shall go farther. I will go on
till my legs fail, and I'll lie down and die somewhere, and shall at
last reach that eternal, quiet haven, where there is neither sorrow
nor sighing..." thought Princess Mary.

But afterwards, when she saw her father and especially little Koko
(Nicholas), her resolve weakened. She wept quietly, and felt that
she was a sinner who loved her father and little nephew more than God.





BOOK SEVEN: 1810 --11





CHAPTER I


The Bible legend tells us that the absence of labor--idleness--was a
condition of the first man's blessedness before the Fall. Fallen man
has retained a love of idleness, but the curse weighs on the race
not only because we have to seek our bread in the sweat of our
brows, but because our moral nature is such that we cannot be both
idle and at ease. An inner voice tells us we are in the wrong if we
are idle. If man could find a state in which he felt that though
idle he was fulfilling his duty, he would have found one of the
conditions of man's primitive blessedness. And such a state of
obligatory and irreproachable idleness is the lot of a whole class-
the military. The chief attraction of military service has consisted
and will consist in this compulsory and irreproachable idleness.

Nicholas Rostov experienced this blissful condition to the full
when, after 1807, he continued to serve in the Pavlograd regiment,
in which he already commanded the squadron he had taken over from
Denisov.

Rostov had become a bluff, good-natured fellow, whom his Moscow
acquaintances would have considered rather bad form, but who was liked
and respected by his comrades, subordinates, and superiors, and was
well contented with his life. Of late, in 1809, he found in letters
from home more frequent complaints from his mother that their
affairs were falling into greater and greater disorder, and that it
was time for him to come back to gladden and comfort his old parents.

Reading these letters, Nicholas felt a dread of their wanting to
take him away from surroundings in which, protected from all the
entanglements of life, he was living so calmly and quietly. He felt
that sooner or later he would have to re-enter that whirlpool of life,
with its embarrassments and affairs to be straightened out, its
accounts with stewards, quarrels, and intrigues, its ties, society,
and with Sonya's love and his promise to her. It was all dreadfully
difficult and complicated; and he replied to his mother in cold,
formal letters in French, beginning: "My dear Mamma," and ending:
"Your obedient son," which said nothing of when he would return. In
1810 he received letters from his parents, in which they told him of
Natasha's engagement to Bolkonski, and that the wedding would be in
a year's time because the old prince made difficulties. This letter
grieved and mortified Nicholas. In the first place he was sorry that
Natasha, for whom he cared more than for anyone else in the family,
should be lost to the home; and secondly, from his hussar point of
view, he regretted not to have been there to show that fellow
Bolkonski that connection with him was no such great honor after
all, and that if he loved Natasha he might dispense with permission
from his dotard father. For a moment he hesitated whether he should
not apply for leave in order to see Natasha before she was married,
but then came the maneuvers, and considerations about Sonya and
about the confusion of their affairs, and Nicholas again put it off.
But in the spring of that year, he received a letter from his
mother, written without his father's knowledge, and that letter
persuaded him to return. She wrote that if he did not come and take
matters in hand, their whole property would be sold by auction and
they would all have to go begging. The count was so weak, and
trusted Mitenka so much, and was so good-natured, that everybody
took advantage of him and things were going from bad to worse. "For
God's sake, I implore you, come at once if you do not wish to make
me and the whole family wretched," wrote the countess.

This letter touched Nicholas. He had that common sense of a
matter-of-fact man which showed him what he ought to do.

The right thing now was, if not to retire from the service, at any
rate to go home on leave. Why he had to go he did not know; but
after his after-dinner nap he gave orders to saddle Mars, an extremely
vicious gray stallion that had not been ridden for a long time, and
when he returned with the horse all in a lather, he informed Lavrushka
(Denisov's servant who had remained with him) and his comrades who
turned up in the evening that he was applying for leave and was
going home. Difficult and strange as it was for him to reflect that he
would go away without having heard from the staff--and this interested
him extremely--whether he was promoted to a captaincy or would receive
the Order of St. Anne for the last maneuvers; strange as it was to
think that he would go away without having sold his three roans to the
Polish Count Golukhovski, who was bargaining for the horses Rostov had
betted he would sell for two thousand rubles; incomprehensible as it
seemed that the ball the hussars were giving in honor of the Polish
Mademoiselle Przazdziecka (out of rivalry to the Uhlans who had
given one in honor of their Polish Mademoiselle Borzozowska) would
take place without him--he knew he must go away from this good, bright
world to somewhere where everything was stupid and confused. A week
later he obtained his leave. His hussar comrades--not only those of
his own regiment, but the whole brigade--gave Rostov a dinner to which
the subscription was fifteen rubles a head, and at which there were
two bands and two choirs of singers. Rostov danced the Trepak with
Major Basov; the tipsy officers tossed, embraced, and dropped
Rostov; the soldiers of the third squadron tossed him too, and shouted
"hurrah!" and then they put him in his sleigh and escorted him as
far as the first post station.

During the first half of the journey--from Kremenchug to Kiev--all
Rostov's thoughts, as is usual in such cases, were behind him, with
the squadron; but when he had gone more than halfway he began to
forget his three roans and Dozhoyveyko, his quartermaster, and to
wonder anxiously how things would be at Otradnoe and what he would
find there. Thoughts of home grew stronger the nearer he approached
it--far stronger, as though this feeling of his was subject to the law
by which the force of attraction is in inverse proportion to the
square of the distance. At the last post station before Otradnoe he
gave the driver a three-ruble tip, and on arriving he ran
breathlessly, like a boy, up the steps of his home.

After the rapture of meeting, and after that odd feeling of
unsatisfied expectation--the feeling that "everything is just the
same, so why did I hurry?"--Nicholas began to settle down in his old
home world. His father and mother were much the same, only a little
older. What was new in them was a certain uneasiness and occasional
discord, which there used not to be, and which, as Nicholas soon found
out, was due to the bad state of their affairs. Sonya was nearly
twenty; she had stopped growing prettier and promised nothing more
than she was already, but that was enough. She exhaled happiness and
love from the time Nicholas returned, and the faithful, unalterable
love of this girl had a gladdening effect on him. Petya and Natasha
surprised Nicholas most. Petya was a big handsome boy of thirteen,
merry, witty, and mischievous, with a voice that was already breaking.
As for Natasha, for a long while Nicholas wondered and laughed
whenever he looked at her.

"You're not the same at all," he said.

"How? Am I uglier?"

"On the contrary, but what dignity? A princess!" he whispered to
her.

"Yes, yes, yes!" cried Natasha, joyfully.

She told him about her romance with Prince Andrew and of his visit
to Otradnoe and showed him his last letter.

"Well, are you glad?" Natasha asked. "I am so tranquil and happy
now."

"Very glad," answered Nicholas. "He is an excellent fellow.... And
are you very much in love?"

"How shall I put it?" replied Natasha. "I was in love with Boris,
with my teacher, and with Denisov, but this is quite different. I feel
at peace and settled. I know that no better man than he exists, and
I am calm and contented now. Not at all as before."

Nicholas expressed his disapproval of the postponement of the
marriage for a year; but Natasha attacked her brother with
exasperation, proving to him that it could not be otherwise, and
that it would be a bad thing to enter a family against the father's
will, and that she herself wished it so.

"You don't at all understand," she said.

Nicholas was silent and agreed with her.

Her brother often wondered as he looked at her. She did not seem
at all like a girl in love and parted from her affianced husband.
She was even-tempered and calm and quite as cheerful as of old. This
amazed Nicholas and even made him regard Bolkonski's courtship
skeptically. He could not believe that her fate was sealed, especially
as he had not seen her with Prince Andrew. It always seemed to him
that there was something not quite right about this intended marriage.

"Why this delay? Why no betrothal?" he thought. Once, when he had
touched on this topic with his mother, he discovered, to his
surprise and somewhat to his satisfaction, that in the depth of her
soul she too had doubts about this marriage.

"You see he writes," said she, showing her son a letter of Prince
Andrew's, with that latent grudge a mother always has in regard to a
daughter's future married happiness, "he writes that he won't come
before December. What can be keeping him? Illness, probably! His
health is very delicate. Don't tell Natasha. And don't attach
importance to her being so bright: that's because she's living through
the last days of her girlhood, but I know what she is like every
time we receive a letter from him! However, God grant that
everything turns out well!" (She always ended with these words.) "He
is an excellent man!"





CHAPTER II


After reaching home Nicholas was at first serious and even dull.
He was worried by the impending necessity of interfering in the stupid
business matters for which his mother had called him home. To throw
off this burden as quickly as possible, on the third day after his
arrival he went, angry and scowling and without answering questions as
to where he was going, to Mitenka's lodge and demanded an account of
everything. But what an account of everything might be Nicholas knew
even less than the frightened and bewildered Mitenka. The conversation
and the examination of the accounts with Mitenka did not last long.
The village elder, a peasant delegate, and the village clerk, who were
waiting in the passage, heard with fear and delight first the young
count's voice roaring and snapping and rising louder and louder, and
then words of abuse, dreadful words, ejaculated one after the other.

"Robber!... Ungrateful wretch!... I'll hack the dog to pieces! I'm
not my father!... Robbing us!..." and so on.

Then with no less fear and delight they saw how the young count, red
in the face and with bloodshot eyes, dragged Mitenka out by the scruff
of the neck and applied his foot and knee to his behind with great
agility at convenient moments between the words, shouting, "Be off!
Never let me see your face here again, you villain!"

Mitenka flew headlong down the six steps and ran away into the
shrubbery. (This shrubbery was a well-known haven of refuge for
culprits at Otradnoe. Mitenka himself, returning tipsy from the
town, used to hide there, and many of the residents at Otradnoe,
hiding from Mitenka, knew of its protective qualities.)

Mitenka's wife and sisters-in-law thrust their heads and
frightened faces out of the door of a room where a bright samovar
was boiling and where the steward's high bedstead stood with its
patchwork quilt.

The young count paid no heed to them, but, breathing hard, passed by
with resolute strides and went into the house.

The countess, who heard at once from the maids what had happened
at the lodge, was calmed by the thought that now their affairs would
certainly improve, but on the other hand felt anxious as to the effect
this excitement might have on her son. She went several times to his
door on tiptoe and listened, as he lighted one pipe after another.

Next day the old count called his son aside and, with an embarrassed
smile, said to him:

"But you know, my dear boy, it's a pity you got excited! Mitenka has
told me all about it."

"I knew," thought Nicholas, "that I should never understand anything
in this crazy world."

"You were angry that he had not entered those 700 rubles. But they
were carried forward--and you did not look at the other page."

"Papa, he is a blackguard and a thief! I know he is! And what I have
done, I have done; but, if you like, I won't speak to him again."

"No, my dear boy" (the count, too, felt embarrassed. He knew he
had mismanaged his wife's property and was to blame toward his
children, but he did not know how to remedy it). "No, I beg you to
attend to the business. I am old. I..."

"No, Papa. Forgive me if I have caused you unpleasantness. I
understand it all less than you do."

"Devil take all these peasants, and money matters, and carryings
forward from page to page," he thought. "I used to understand what a
'corner' and the stakes at cards meant, but carrying forward to
another page I don't understand at all," said he to himself, and after
that he did not meddle in business affairs. But once the countess
called her son and informed him that she had a promissory note from
Anna Mikhaylovna for two thousand rubles, and asked him what he
thought of doing with it.

"This," answered Nicholas. "You say it rests with me. Well, I
don't like Anna Mikhaylovna and I don't like Boris, but they were
our friends and poor. Well then, this!" and he tore up the note, and
by so doing caused the old countess to weep tears of joy. After
that, young Rostov took no further part in any business affairs, but
devoted himself with passionate enthusiasm to what was to him a new
pursuit--the chase--for which his father kept a large establishment.





CHAPTER III


The weather was already growing wintry and morning frosts
congealed an earth saturated by autumn rains. The verdure had
thickened and its bright green stood out sharply against the
brownish strips of winter rye trodden down by the cattle, and
against the pale-yellow stubble of the spring buckwheat. The wooded
ravines and the copses, which at the end of August had still been
green islands amid black fields and stubble, had become golden and
bright-red islands amid the green winter rye. The hares had already
half changed their summer coats, the fox cubs were beginning to
scatter, and the young wolves were bigger than dogs. It was the best
time of the year for the chase. The hounds of that ardent young
sportsman Rostov had not merely reached hard winter condition, but
were so jaded that at a meeting of the huntsmen it was decided to give
them a three days' rest and then, on the sixteenth of September, to go
on a distant expedition, starting from the oak grove where there was
an undisturbed litter of wolf cubs.

All that day the hounds remained at home. It was frosty and the
air was sharp, but toward evening the sky became overcast and it began
to thaw. On the fifteenth, when young Rostov, in his dressing gown,
looked out of the window, he saw it was an unsurpassable morning for
hunting: it was as if the sky were melting and sinking to the earth
without any wind. The only motion in the air was that of the dripping,
microscopic particles of drizzling mist. The bare twigs in the
garden were hung with transparent drops which fell on the freshly
fallen leaves. The earth in the kitchen garden looked wet and black
and glistened like poppy seed and at a short distance merged into
the dull, moist veil of mist. Nicholas went out into the wet and muddy
porch. There was a smell of decaying leaves and of dog. Milka, a
black-spotted, broad-haunched bitch with prominent black eyes, got
up on seeing her master, stretched her hind legs, lay down like a
hare, and then suddenly jumped up and licked him right on his nose and
mustache. Another borzoi, a dog, catching sight of his master from the
garden path, arched his back and, rushing headlong toward the porch
with lifted tail, began rubbing himself against his legs.

"O-hoy!" came at that moment, that inimitable huntsman's call
which unites the deepest bass with the shrillest tenor, and round
the corner came Daniel the head huntsman and head kennelman, a gray,
wrinkled old man with hair cut straight over his forehead, Ukrainian
fashion, a long bent whip in his hand, and that look of independence
and scorn of everything that is only seen in huntsmen. He doffed his
Circassian cap to his master and looked at him scornfully. This
scorn was not offensive to his master. Nicholas knew that this Daniel,
disdainful of everybody and who considered himself above them, was all
the same his serf and huntsman.

"Daniel!" Nicholas said timidly, conscious at the sight of the
weather, the hounds, and the huntsman that he was being carried away
by that irresistible passion for sport which makes a man forget all
his previous resolutions, as a lover forgets in the presence of his
mistress.

"What orders, your excellency?" said the huntsman in his deep
bass, deep as a proto-deacon's and hoarse with hallooing--and two
flashing black eyes gazed from under his brows at his master, who
was silent. "Can you resist it?" those eyes seemed to be asking.

"It's a good day, eh? For a hunt and a gallop, eh?" asked
Nicholas, scratching Milka behind the ears.

Daniel did not answer, but winked instead.

"I sent Uvarka at dawn to listen," his bass boomed out after a
minute's pause. "He says she's moved them into the Otradnoe enclosure.
They were howling there." (This meant that the she-wolf, about whom
they both knew, had moved with her cubs to the Otradnoe copse, a small
place a mile and a half from the house.)

"We ought to go, don't you think so?" said Nicholas. "Come to me
with Uvarka."

"As you please."

"Then put off feeding them."

"Yes, sir."

Five minutes later Daniel and Uvarka were standing in Nicholas'
big study. Though Daniel was not a big man, to see him in a room was
like seeing a horse or a bear on the floor among the furniture and
surroundings of human life. Daniel himself felt this, and as usual
stood just inside the door, trying to speak softly and not move, for
fear of breaking something in the master's apartment, and he
hastened to say all that was necessary so as to get from under that
ceiling, out into the open under the sky once more.

Having finished his inquiries and extorted from Daniel an opinion
that the hounds were fit (Daniel himself wished to go hunting),
Nicholas ordered the horses to be saddled. But just as Daniel was
about to go Natasha came in with rapid steps, not having done up her
hair or finished dressing and with her old nurse's big shawl wrapped
round her. Petya ran in at the same time.

"You are going?" asked Natasha. "I knew you would! Sonya said you
wouldn't go, but I knew that today is the sort of day when you
couldn't help going."

"Yes, we are going," replied Nicholas reluctantly, for today, as
he intended to hunt seriously, he did not want to take Natasha and
Petya. "We are going, but only wolf hunting: it would be dull for
you."

"You know it is my greatest pleasure," said Natasha. "It's not fair;
you are going by yourself, are having the horses saddled and said
nothing to us about it."

"'No barrier bars a Russian's path'--we'll go!" shouted Petya.

"But you can't. Mamma said you mustn't," said Nicholas to Natasha.

"Yes, I'll go. I shall certainly go," said Natasha decisively.
"Daniel, tell them to saddle for us, and Michael must come with my
dogs," she added to the huntsman.

It seemed to Daniel irksome and improper to be in a room at all, but
to have anything to do with a young lady seemed to him impossible.
He cast down his eyes and hurried out as if it were none of his
business, careful as he went not to inflict any accidental injury on
the young lady.





CHAPTER IV


The old count, who had always kept up an enormous hunting
establishment but had now handed it all completely over to his son's
care, being in very good spirits on this fifteenth of September,
prepared to go out with the others.

In an hour's time the whole hunting party was at the porch.
Nicholas, with a stern and serious air which showed that now was no
time for attending to trifles, went past Natasha and Petya who were
trying to tell him something. He had a look at all the details of
the hunt, sent a pack of hounds and huntsmen on ahead to find the
quarry, mounted his chestnut Donets, and whistling to his own leash of
borzois, set off across the threshing ground to a field leading to the
Otradnoe wood. The old count's horse, a sorrel gelding called
Viflyanka, was led by the groom in attendance on him, while the
count himself was to drive in a small trap straight to a spot reserved
for him.

They were taking fifty-four hounds, with six hunt attendants and
whippers-in. Besides the family, there were eight borzoi kennelmen and
more than forty borzois, so that, with the borzois on the leash
belonging to members of the family, there were about a hundred and
thirty dogs and twenty horsemen.

Each dog knew its master and its call. Each man in the hunt knew his
business, his place, what he had to do. As soon as they had passed the
fence they all spread out evenly and quietly, without noise or talk,
along the road and field leading to the Otradnoe covert.

The horses stepped over the field as over a thick carpet, now and
then splashing into puddles as they crossed a road. The misty sky
still seemed to descend evenly and imperceptibly toward the earth, the
air was still, warm, and silent. Occasionally the whistle of a
huntsman, the snort of a horse, the crack of a whip, or the whine of a
straggling hound could be heard.

When they had gone a little less than a mile, five more riders
with dogs appeared out of the mist, approaching the Rostovs. In
front rode a fresh-looking, handsome old man with a large gray
mustache.

"Good morning, Uncle!" said Nicholas, when the old man drew near.

"That's it. Come on!... I was sure of it," began "Uncle." (He was
a distant relative of the Rostovs', a man of small means, and their
neighbor.) "I knew you wouldn't be able to resist it and it's a good
thing you're going. That's it! Come on! (This was "Uncle's" favorite
expression.) "Take the covert at once, for my Girchik says the Ilagins
are at Korniki with their hounds. That's it. Come on!... They'll
take the cubs from under your very nose."

"That's where I'm going. Shall we join up our packs?" asked
Nicholas.

The hounds were joined into one pack, and "Uncle" and Nicholas
rode on side by side. Natasha, muffled up in shawls which did not hide
her eager face and shining eyes, galloped up to them. She was followed
by Petya who always kept close to her, by Michael, a huntsman, and
by a groom appointed to look after her. Petya, who was laughing,
whipped and pulled at his horse. Natasha sat easily and confidently on
her black Arabchik and reined him in without effort with a firm hand.

"Uncle" looked round disapprovingly at Petya and Natasha. He did not
like to combine frivolity with the serious business of hunting.

"Good morning, Uncle! We are going too!" shouted Petya.

"Good morning, good morning! But don't go overriding the hounds,"
said "Uncle" sternly.

"Nicholas, what a fine dog Trunila is! He knew me," said Natasha,
referring to her favorite hound.

"In the first place, Trunila is not a 'dog,' but a harrier," thought
Nicholas, and looked sternly at his sister, trying to make her feel
the distance that ought to separate them at that moment. Natasha
understood it.

"You mustn't think we'll be in anyone's way, Uncle," she said.
"We'll go to our places and won't budge."

"A good thing too, little countess," said "Uncle," "only mind you
don't fall off your horse," he added, "because--that's it, come on!-
you've nothing to hold on to."

The oasis of the Otradnoe covert came in sight a few hundred yards
off, the huntsmen were already nearing it. Rostov, having finally
settled with "Uncle" where they should set on the hounds, and having
shown Natasha where she was to stand--a spot where nothing could
possibly run out--went round above the ravine.

"Well, nephew, you're going for a big wolf," said "Uncle." "Mind and
don't let her slip!"

"That's as may happen," answered Rostov. "Karay, here!" he
shouted, answering "Uncle's" remark by this call to his borzoi.
Karay was a shaggy old dog with a hanging jowl, famous for having
tackled a big wolf unaided. They all took up their places.

The old count, knowing his son's ardor in the hunt, hurried so as
not to be late, and the huntsmen had not yet reached their places when
Count Ilya Rostov, cheerful, flushed, and with quivering cheeks, drove
up with his black horses over the winter rye to the place reserved for
him, where a wolf might come out. Having straightened his coat and
fastened on his hunting knives and horn, he mounted his good, sleek,
well-fed, and comfortable horse, Viflyanka, which was turning gray,
like himself. His horses and trap were sent home. Count Ilya Rostov,
though not at heart a keen sportsman, knew the rules of the hunt well,
and rode to the bushy edge of the road where he was to stand, arranged
his reins, settled himself in the saddle, and, feeling that he was
ready, looked about with a smile.

Beside him was Simon Chekmar, his personal attendant, an old
horseman now somewhat stiff in the saddle. Chekmar held in leash three
formidable wolfhounds, who had, however, grown fat like their master
and his horse. Two wise old dogs lay down unleashed. Some hundred
paces farther along the edge of the wood stood Mitka, the count's
other groom, a daring horseman and keen rider to hounds. Before the
hunt, by old custom, the count had drunk a silver cupful of mulled
brandy, taken a snack, and washed it down with half a bottle of his
favorite Bordeaux.

He was somewhat flushed with the wine and the drive. His eyes were
rather moist and glittered more than usual, and as he sat in his
saddle, wrapped up in his fur coat, he looked like a child taken out
for an outing.

The thin, hollow-cheeked Chekmar, having got everything ready,
kept glancing at his master with whom he had lived on the best of
terms for thirty years, and understanding the mood he was in
expected a pleasant chat. A third person rode up circumspectly through
the wood (it was plain that he had had a lesson) and stopped behind
the count. This person was a gray-bearded old man in a woman's
cloak, with a tall peaked cap on his head. He was the buffoon, who
went by a woman's name, Nastasya Ivanovna.

"Well, Nastasya Ivanovna!" whispered the count, winking at him.
"If you scare away the beast, Daniel'll give it you!"

"I know a thing or two myself!" said Nastasya Ivanovna.

"Hush!" whispered the count and turned to Simon. "Have you seen
the young countess?" he asked. "Where is she?"

"With young Count Peter, by the Zharov rank grass," answered
Simon, smiling. "Though she's a lady, she's very fond of hunting."

"And you're surprised at the way she rides, Simon, eh?" said the
count. "She's as good as many a man!"

"Of course! It's marvelous. So bold, so easy!"

"And Nicholas? Where is he? By the Lyadov upland, isn't he?"

"Yes, sir. He knows where to stand. He understands the matter so
well that Daniel and I are often quite astounded," said Simon, well
knowing what would please his master.

"Rides well, eh? And how well he looks on his horse, eh?"

"A perfect picture! How he chased a fox out of the rank grass by the
Zavarzinsk thicket the other day! Leaped a fearful place; what a sight
when they rushed from the covert... the horse worth a thousand
rubles and the rider beyond all price! Yes, one would have to search
far to find another as smart."

"To search far..." repeated the count, evidently sorry Simon had not
said more. "To search far," he said, turning back the skirt of his
coat to get at his snuffbox.

"The other day when he came out from Mass in full uniform, Michael
Sidorych..." Simon did not finish, for on the still air he had
distinctly caught the music of the hunt with only two or three
hounds giving tongue. He bent down his head and listened, shaking a
warning finger at his master. "They are on the scent of the cubs..."
he whispered, "straight to the Lyadov uplands."

The count, forgetting to smooth out the smile on his face, looked
into the distance straight before him, down the narrow open space,
holding the snuffbox in his hand but not taking any. After the cry
of the hounds came the deep tones of the wolf call from Daniel's
hunting horn; the pack joined the first three hounds and they could be
heard in full cry, with that peculiar lift in the note that
indicates that they are after a wolf. The whippers-in no longer set on
the hounds, but changed to the cry of ulyulyu, and above the others
rose Daniel's voice, now a deep bass, now piercingly shrill. His voice
seemed to fill the whole wood and carried far beyond out into the open
field.

After listening a few moments in silence, the count and his
attendant convinced themselves that the hounds had separated into
two packs: the sound of the larger pack, eagerly giving tongue,
began to die away in the distance, the other pack rushed by the wood
past the count, and it was with this that Daniel's voice was heard
calling ulyulyu. The sounds of both packs mingled and broke apart
again, but both were becoming more distant.

Simon sighed and stooped to straighten the leash a young borzoi
had entangled; the count too sighed and, noticing the snuffbox in
his hand, opened it and took a pinch. "Back!" cried Simon to a
borzoi that was pushing forward out of the wood. The count started and
dropped the snuffbox. Nastasya Ivanovna dismounted to pick it up.
The count and Simon were looking at him.

Then, unexpectedly, as often happens, the sound of the hunt suddenly
approached, as if the hounds in full cry and Daniel ulyulyuing were
just in front of them.

The count turned and saw on his right Mitka staring at him with eyes
starting out of his head, raising his cap and pointing before him to
the other side.

"Look out!" he shouted, in a voice plainly showing that he had
long fretted to utter that word, and letting the borzois slip he
galloped toward the count.

The count and Simon galloped out of the wood and saw on their left a
wolf which, softly swaying from side to side, was coming at a quiet
lope farther to the left to the very place where they were standing.
The angry borzois whined and getting free of the leash rushed past the
horses' feet at the wolf.

The wolf paused, turned its heavy forehead toward the dogs
awkwardly, like a man suffering from the quinsy, and, still slightly
swaying from side to side, gave a couple of leaps and with a swish
of its tail disappeared into the skirt of the wood. At the same
instant, with a cry like a wail, first one hound, then another, and
then another, sprang helter-skelter from the wood opposite and the
whole pack rushed across the field toward the very spot where the wolf
had disappeared. The hazel bushes parted behind the hounds and
Daniel's chestnut horse appeared, dark with sweat. On its long back
sat Daniel, hunched forward, capless, his disheveled gray hair hanging
over his flushed, perspiring face.

"Ulyulyulyu! ulyulyu!..." he cried. When he caught sight of the
count his eyes flashed lightning.

"Blast you!" he shouted, holding up his whip threateningly at the
count.

"You've let the wolf go!... What sportsmen!" and as if scorning to
say more to the frightened and shamefaced count, he lashed the heaving
flanks of his sweating chestnut gelding with all the anger the count
had aroused and flew off after the hounds. The count, like a
punished schoolboy, looked round, trying by a smile to win Simon's
sympathy for his plight. But Simon was no longer there. He was
galloping round by the bushes while the field was coming up on both
sides, all trying to head the wolf, but it vanished into the wood
before they could do so.





CHAPTER V


Nicholas Rostov meanwhile remained at his post, waiting for the
wolf. By the way the hunt approached and receded, by the cries of
the dogs whose notes were familiar to him, by the way the voices of
the huntsmen approached, receded, and rose, he realized what was
happening at the copse. He knew that young and old wolves were
there, that the hounds had separated into two packs, that somewhere
a wolf was being chased, and that something had gone wrong. He
expected the wolf to come his way any moment. He made thousands of
different conjectures as to where and from what side the beast would
come and how he would set upon it. Hope alternated with despair.
Several times he addressed a prayer to God that the wolf should come
his way. He prayed with that passionate and shame-faced feeling with
which men pray at moments of great excitement arising from trivial
causes. "What would it be to Thee to do this for me?" he said to
God. "I know Thou art great, and that it is a sin to ask this of Thee,
but for God's sake do let the old wolf come my way and let Karay
spring at it--in sight of 'Uncle' who is watching from over there--and
seize it by the throat in a death grip!" A thousand times during
that half-hour Rostov cast eager and restless glances over the edge of
the wood, with the two scraggy oaks rising above the aspen undergrowth
and the gully with its water-worn side and "Uncle's" cap just
visible above the bush on his right.

"No, I shan't have such luck," thought Rostov, "yet what wouldn't it
be worth! It is not to be! Everywhere, at cards and in war, I am
always unlucky." Memories of Austerlitz and of Dolokhov flashed
rapidly and clearly through his mind. "Only once in my life to get
an old wolf, I want only that!" thought he, straining eyes and ears
and looking to the left and then to the right and listening to the
slightest variation of note in the cries of the dogs.

Again he looked to the right and saw something running toward him
across the deserted field. "No, it can't be!" thought Rostov, taking a
deep breath, as a man does at the coming of something long hoped
for. The height of happiness was reached--and so simply, without
warning, or noise, or display, that Rostov could not believe his
eyes and remained in doubt for over a second. The wolf ran forward and
jumped heavily over a gully that lay in her path. She was an old
animal with a gray back and big reddish belly. She ran without
hurry, evidently feeling sure that no one saw her. Rostov, holding his
breath, looked round at the borzois. They stood or lay not seeing
the wolf or understanding the situation. Old Karay had turned his head
and was angrily searching for fleas, baring his yellow teeth and
snapping at his hind legs.

"Ulyulyulyu!" whispered Rostov, pouting his lips. The borzois jumped
up, jerking the rings of the leashes and pricking their ears. Karay
finished scratching his hindquarters and, cocking his ears, got up
with quivering tail from which tufts of matted hair hung down.

"Shall I loose them or not?" Nicholas asked himself as the wolf
approached him coming from the copse. Suddenly the wolf's whole
physiognomy changed: she shuddered, seeing what she had probably never
seen before--human eyes fixed upon her--and turning her head a
little toward Rostov, she paused.

"Back or forward? Eh, no matter, forward..." the wolf seemed to
say to herself, and she moved forward without again looking round
and with a quiet, long, easy yet resolute lope.

"Ulyulyu!" cried Nicholas, in a voice not his own, and of its own
accord his good horse darted headlong downhill, leaping over gullies
to head off the wolf, and the borzois passed it, running faster still.
Nicholas did not hear his own cry nor feel that he was galloping,
nor see the borzois, nor the ground over which he went: he saw only
the wolf, who, increasing her speed, bounded on in the same
direction along the hollow. The first to come into view was Milka,
with her black markings and powerful quarters, gaining upon the
wolf. Nearer and nearer... now she was ahead of it; but the wolf
turned its head to face her, and instead of putting on speed as she
usually did Milka suddenly raised her tail and stiffened her forelegs.

"Ulyulyulyulyu!" shouted Nicholas.

The reddish Lyubim rushed forward from behind Milka, sprang
impetuously at the wolf, and seized it by its hindquarters, but
immediately jumped aside in terror. The wolf crouched, gnashed her
teeth, and again rose and bounded forward, followed at the distance of
a couple of feet by all the borzois, who did not get any closer to
her.

"She'll get away! No, it's impossible!" thought Nicholas, still
shouting with a hoarse voice.

"Karay, ulyulyu!..." he shouted, looking round for the old borzoi
who was now his only hope. Karay, with all the strength age had left
him, stretched himself to the utmost and, watching the wolf,
galloped heavily aside to intercept it. But the quickness of the
wolf's lope and the borzoi's slower pace made it plain that Karay
had miscalculated. Nicholas could already see not far in front of
him the wood where the wolf would certainly escape should she reach
it. But, coming toward him, he saw hounds and a huntsman galloping
almost straight at the wolf. There was still hope. A long, yellowish

young borzoi, one Nicholas did not know, from another leash, rushed
impetuously at the wolf from in front and almost knocked her over. But
the wolf jumped up more quickly than anyone could have expected and,
gnashing her teeth, flew at the yellowish borzoi, which, with a
piercing yelp, fell with its head on the ground, bleeding from a
gash in its side.

"Karay? Old fellow!..." wailed Nicholas.

Thanks to the delay caused by this crossing of the wolf's path,
the old dog with its felted hair hanging from its thigh was within
five paces of it. As if aware of her danger, the wolf turned her
eyes on Karay, tucked her tail yet further between her legs, and
increased her speed. But here Nicholas only saw that something
happened to Karay--the borzoi was suddenly on the wolf, and they
rolled together down into a gully just in front of them.

That instant, when Nicholas saw the wolf struggling in the gully
with the dogs, while from under them could be seen her gray hair and
outstretched hind leg and her frightened choking head, with her ears
laid back (Karay was pinning her by the throat), was the happiest
moment of his life. With his hand on his saddlebow, he was ready to
dismount and stab the wolf, when she suddenly thrust her head up
from among that mass of dogs, and then her forepaws were on the edge
of the gully. She clicked her teeth (Karay no longer had her by the
throat), leaped with a movement of her hind legs out of the gully, and
having disengaged herself from the dogs, with tail tucked in again,
went forward. Karay, his hair bristling, and probably bruised or
wounded, climbed with difficulty out of the gully.

"Oh my God! Why?" Nicholas cried in despair.

"Uncle's" huntsman was galloping from the other side across the
wolf's path and his borzois once more stopped the animal's advance.
She was again hemmed in.

Nicholas and his attendant, with "Uncle" and his huntsman, were
all riding round the wolf, crying "ulyulyu!" shouting and preparing to
dismount each moment that the wolf crouched back, and starting forward
again every time she shook herself and moved toward the wood where she
would be safe.

Already, at the beginning of this chase, Daniel, hearing the
ulyulyuing, had rushed out from the wood. He saw Karay seize the wolf,
and checked his horse, supposing the affair to be over. But when he
saw that the horsemen did not dismount and that the wolf shook herself
and ran for safety, Daniel set his chestnut galloping, not at the wolf
but straight toward the wood, just as Karay had run to cut the
animal off. As a result of this, he galloped up to the wolf just
when she had been stopped a second time by "Uncle's" borzois.

Daniel galloped up silently, holding a naked dagger in his left hand
and thrashing the laboring sides of his chestnut horse with his whip
as if it were a flail.

Nicholas neither saw nor heard Daniel until the chestnut,
breathing heavily, panted past him, and he heard the fall of a body
and saw Daniel lying on the wolf's back among the dogs, trying to
seize her by the ears. It was evident to the dogs, the hunters, and to
the wolf herself that all was now over. The terrified wolf pressed
back her ears and tried to rise, but the borzois stuck to her.
Daniel rose a little, took a step, and with his whole weight, as if
lying down to rest, fell on the wolf, seizing her by the ears.
Nicholas was about to stab her, but Daniel whispered, "Don't! We'll
gag her!" and, changing his position, set his foot on the wolf's neck.
A stick was thrust between her jaws and she was fastened with a leash,
as if bridled, her legs were bound together, and Daniel rolled her
over once or twice from side to side.

With happy, exhausted faces, they laid the old wolf, alive, on a
shying and snorting horse and, accompanied by the dogs yelping at her,
took her to the place where they were all to meet. The hounds had
killed two of the cubs and the borzois three. The huntsmen assembled
with their booty and their stories, and all came to look at the
wolf, which, with her broad-browed head hanging down and the bitten
stick between her jaws, gazed with great glassy eyes at this crowd
of dogs and men surrounding her. When she was touched, she jerked
her bound legs and looked wildly yet simply at everybody. Old Count
Rostov also rode up and touched the wolf.

"Oh, what a formidable one!" said he. "A formidable one, eh?" he
asked Daniel, who was standing near.

"Yes, your excellency," answered Daniel, quickly doffing his cap.

The count remembered the wolf he had let slip and his encounter with
Daniel.

"Ah, but you are a crusty fellow, friend!" said the count.

For sole reply Daniel gave him a shy, childlike, meek, and amiable
smile.





CHAPTER VI


The old count went home, and Natasha and Petya promised to return
very soon, but as it was still early the hunt went farther. At
midday they put the hounds into a ravine thickly overgrown with
young trees. Nicholas standing in a fallow field could see all his
whips.

Facing him lay a field of winter rye, there his own huntsman stood
alone in a hollow behind a hazel bush. The hounds had scarcely been
loosed before Nicholas heard one he knew, Voltorn, giving tongue at
intervals; other hounds joined in, now pausing and now again giving
tongue. A moment later he heard a cry from the wooded ravine that a
fox had been found, and the whole pack, joining together, rushed along
the ravine toward the ryefield and away from Nicholas.

He saw the whips in their red caps galloping along the edge of the
ravine, he even saw the hounds, and was expecting a fox to show itself
at any moment on the ryefield opposite.

The huntsman standing in the hollow moved and loosed his borzois,
and Nicholas saw a queer, short-legged red fox with a fine brush going
hard across the field. The borzois bore down on it.... Now they drew
close to the fox which began to dodge between the field in sharper and
sharper curves, trailing its brush, when suddenly a strange white
borzoi dashed in followed by a black one, and everything was in
confusion; the borzois formed a star-shaped figure, scarcely swaying
their bodies and with tails turned away from the center of the
group. Two huntsmen galloped up to the dogs; one in a red cap, the
other, a stranger, in a green coat.

"What's this?" thought Nicholas. "Where's that huntsman from? He
is not 'Uncle's' man."

The huntsmen got the fox, but stayed there a long time without
strapping it to the saddle. Their horses, bridled and with high
saddles, stood near them and there too the dogs were lying. The
huntsmen waved their arms and did something to the fox. Then from that
spot came the sound of a horn, with the signal agreed on in case of
a fight.

"That's Ilagin's huntsman having a row with our Ivan," said
Nicholas' groom.

Nicholas sent the man to call Natasha and Petya to him, and rode
at a footpace to the place where the whips were getting the hounds
together. Several of the field galloped to the spot where the fight
was going on.

Nicholas dismounted, and with Natasha and Petya, who had ridden
up, stopped near the hounds, waiting to see how the matter would
end. Out of the bushes came the huntsman who had been fighting and
rode toward his young master, with the fox tied to his crupper.
While still at a distance he took off his cap and tried to speak
respectfully, but he was pale and breathless and his face was angry.
One of his eyes was black, but he probably was not even aware of it.

"What has happened?" asked Nicholas.

"A likely thing, killing a fox our dogs had hunted! And it was my
gray bitch that caught it! Go to law, indeed!... He snatches at the
fox! I gave him one with the fox. Here it is on my saddle! Do you want
a taste of this?..." said the huntsman, pointing to his dagger and
probably imagining himself still speaking to his foe.

Nicholas, not stopping to talk to the man, asked his sister and
Petya to wait for him and rode to the spot where the enemy's,
Ilagin's, hunting party was.

The victorious huntsman rode off to join the field, and there,
surrounded by inquiring sympathizers, recounted his exploits.

The facts were that Ilagin, with whom the Rostovs had a quarrel
and were at law, hunted over places that belonged by custom to the
Rostovs, and had now, as if purposely, sent his men to the very
woods the Rostovs were hunting and let his man snatch a fox their dogs
had chased.

Nicholas, though he had never seen Ilagin, with his usual absence of
moderation in judgment, hated him cordially from reports of his
arbitrariness and violence, and regarded him as his bitterest foe.
He rode in angry agitation toward him, firmly grasping his whip and
fully prepared to take the most resolute and desperate steps to punish
his enemy.

Hardly had he passed an angle of the wood before a stout gentleman
in a beaver cap came riding toward him on a handsome raven-black
horse, accompanied by two hunt servants.

Instead of an enemy, Nicholas found in Ilagin a stately and
courteous gentleman who was particularly anxious to make the young
count's acquaintance. Having ridden up to Nicholas, Ilagin raised
his beaver cap and said he much regretted what had occurred and
would have the man punished who had allowed himself to seize a fox
hunted by someone else's borzois. He hoped to become better acquainted
with the count and invited him to draw his covert.

Natasha, afraid that her brother would do something dreadful, had
followed him in some excitement. Seeing the enemies exchanging
friendly greetings, she rode up to them. Ilagin lifted his beaver
cap still higher to Natasha and said, with a pleasant smile, that
the young countess resembled Diana in her passion for the chase as
well as in her beauty, of which he had heard much.

To expiate his huntsman's offense, Ilagin pressed the Rostovs to
come to an upland of his about a mile away which he usually kept for
himself and which, he said, swarmed with hares. Nicholas agreed, and
the hunt, now doubled, moved on.

The way to Iligin's upland was across the fields. The hunt
servants fell into line. The masters rode together. "Uncle," Rostov,
and Ilagin kept stealthily glancing at one another's dogs, trying
not to be observed by their companions and searching uneasily for
rivals to their own borzois.

Rostov was particularly struck by the beauty of a small,
pure-bred, red-spotted bitch on Ilagin's leash, slender but with
muscles like steel, a delicate muzzle, and prominent black eyes. He
had heard of the swiftness of Ilagin's borzois, and in that
beautiful bitch saw a rival to his own Milka.

In the middle of a sober conversation begun by Ilagin about the
year's harvest, Nicholas pointed to the red-spotted bitch.

"A fine little bitch, that!" said he in a careless tone. "Is she
swift?"

"That one? Yes, she's a good dog, gets what she's after," answered
Ilagin indifferently, of the red-spotted bitch Erza, for which, a year
before, he had given a neighbor three families of house serfs. "So
in your parts, too, the harvest is nothing to boast of, Count?" he
went on, continuing the conversation they had begun. And considering
it polite to return the young count's compliment, Ilagin looked at his
borzois and picked out Milka who attracted his attention by her
breadth. "That black-spotted one of yours is fine--well shaped!"
said he.

"Yes, she's fast enough," replied Nicholas, and thought: "If only
a full-grown hare would cross the field now I'd show you what sort
of borzoi she is," and turning to his groom, he said he would give a
ruble to anyone who found a hare.

"I don't understand," continued Ilagin, "how some sportsmen can be
so jealous about game and dogs. For myself, I can tell you, Count, I
enjoy riding in company such as this... what could be better?" (he
again raised his cap to Natasha) "but as for counting skins and what
one takes, I don't care about that."

"Of course not!"

"Or being upset because someone else's borzoi and not mine catches
something. All I care about is to enjoy seeing the chase, is it not
so, Count? For I consider that..."

"A-tu!" came the long-drawn cry of one of the borzoi whippers-in,
who had halted. He stood on a knoll in the stubble, holding his whip
aloft, and again repeated his long-drawn cry, "A-tu!" (This call and
the uplifted whip meant that he saw a sitting hare.)

"Ah, he has found one, I think," said Ilagin carelessly. "Yes, we
must ride up.... Shall we both course it?" answered Nicholas, seeing
in Erza and "Uncle's" red Rugay two rivals he had never yet had a
chance of pitting against his own borzois. "And suppose they outdo
my Milka at once!" he thought as he rode with "Uncle" and Ilagin
toward the hare.

"A full-grown one?" asked Ilagin as he approached the whip who had
sighted the hare--and not without agitation he looked round and
whistled to Erza.

"And you, Michael Nikanorovich?" he said, addressing "Uncle."

The latter was riding with a sullen expression on his face.

"How can I join in? Why, you've given a village for each of your
borzois! That's it, come on! Yours are worth thousands. Try yours
against one another, you two, and I'll look on!"

"Rugay, hey, hey!" he shouted. "Rugayushka!" he added, involuntarily
by this diminutive expressing his affection and the hopes he placed on
this red borzoi. Natasha saw and felt the agitation the two elderly
men and her brother were trying to conceal, and was herself excited by
it.

The huntsman stood halfway up the knoll holding up his whip and
the gentlefolk rode up to him at a footpace; the hounds that were
far off on the horizon turned away from the hare, and the whips, but
not the gentlefolk, also moved away. All were moving slowly and
sedately.

"How is it pointing?" asked Nicholas, riding a hundred paces
toward the whip who had sighted the hare.

But before the whip could reply, the hare, scenting the frost coming
next morning, was unable to rest and leaped up. The pack on leash
rushed downhill in full cry after the hare, and from all sides the
borzois that were not on leash darted after the hounds and the hare.
All the hunt, who had been moving slowly, shouted, "Stop!" calling
in the hounds, while the borzoi whips, with a cry of "A-tu!" galloped
across the field setting the borzois on the hare. The tranquil Ilagin,
Nicholas, Natasha, and "Uncle" flew, reckless of where and how they
went, seeing only the borzois and the hare and fearing only to lose
sight even for an instant of the chase. The hare they had started
was a strong and swift one. When he jumped up he did not run at
once, but pricked his ears listening to the shouting and trampling
that resounded from all sides at once. He took a dozen bounds, not
very quickly, letting the borzois gain on him, and, finally having
chosen his direction and realized his danger, laid back his ears and
rushed off headlong. He had been lying in the stubble, but in front of
him was the autumn sowing where the ground was soft. The two borzois
of the huntsman who had sighted him, having been the nearest, were the
first to see and pursue him, but they had not gone far before Ilagin's
red-spotted Erza passed them, got within a length, flew at the hare
with terrible swiftness aiming at his scut, and, thinking she had
seized him, rolled over like a ball. The hare arched his back and
bounded off yet more swiftly. From behind Erza rushed the
broad-haunched, black-spotted Milka and began rapidly gaining on the
hare.

"Milashka, dear!" rose Nicholas' triumphant cry. It looked as if
Milka would immediately pounce on the hare, but she overtook him and
flew past. The hare had squatted. Again the beautiful Erza reached
him, but when close to the hare's scut paused as if measuring the
distance, so as not to make a mistake this time but seize his hind
leg.

"Erza, darling!" Ilagin wailed in a voice unlike his own. Erza did
not hearken to his appeal. At the very moment when she would have
seized her prey, the hare moved and darted along the balk between
the winter rye and the stubble. Again Erza and Milka were abreast,
running like a pair of carriage horses, and began to overtake the
hare, but it was easier for the hare to run on the balk and the
borzois did not overtake him so quickly.

"Rugay, Rugayushka! That's it, come on!" came a third voice just
then, and "Uncle's" red borzoi, straining and curving its back, caught
up with the two foremost borzois, pushed ahead of them regardless of
the terrible strain, put on speed close to the hare, knocked it off
the balk onto the ryefield, again put on speed still more viciously,
sinking to his knees in the muddy field, and all one could see was
how, muddying his back, he rolled over with the hare. A ring of
borzois surrounded him. A moment later everyone had drawn up round the
crowd of dogs. Only the delighted "Uncle" dismounted, and cut off a
pad, shaking the hare for the blood to drip off, and anxiously
glancing round with restless eyes while his arms and legs twitched. He
spoke without himself knowing whom to or what about. "That's it,
come on! That's a dog!... There, it has beaten them all, the
thousand-ruble as well as the one-ruble borzois. That's it, come
on!" said he, panting and looking wrathfully around as if he were
abusing someone, as if they were all his enemies and had insulted him,
and only now had he at last succeeded in justifying himself. "There
are your thousand-ruble ones.... That's it, come on!..."

"Rugay, here's a pad for you!" he said, throwing down the hare's
muddy pad. "You've deserved it, that's it, come on!"

"She'd tired herself out, she'd run it down three times by herself,"
said Nicholas, also not listening to anyone and regardless of
whether he were heard or not.

"But what is there in running across it like that?" said Ilagin's
groom.

"Once she had missed it and turned it away, any mongrel could take
it," Ilagin was saying at the same time, breathless from his gallop
and his excitement. At the same moment Natasha, without drawing
breath, screamed joyously, ecstatically, and so piercingly that it set
everyone's ear tingling. By that shriek she expressed what the
others expressed by all talking at once, and it was so strange that
she must herself have been ashamed of so wild a cry and everyone
else would have been amazed at it at any other time. "Uncle" himself
twisted up the hare, threw it neatly and smartly across his horse's
back as if by that gesture he meant to rebuke everybody, and, with
an air of not wishing to speak to anyone, mounted his bay and rode
off. The others all followed, dispirited and shamefaced, and only much
later were they able to regain their former affectation of
indifference. For a long time they continued to look at red Rugay who,
his arched back spattered with mud and clanking the ring of his leash,
walked along just behind "Uncle's" horse with the serene air of a
conqueror.

"Well, I am like any other dog as long as it's not a question of
coursing. But when it is, then look out!" his appearance seemed to
Nicholas to be saying.

When, much later, "Uncle" rode up to Nicholas and began talking to
him, he felt flattered that, after what had happened, "Uncle"
deigned to speak to him.





CHAPTER VII


Toward evening Ilagin took leave of Nicholas, who found that they
were so far from home that he accepted "Uncle's" offer that the
hunting party should spend the night in his little village of
Mikhaylovna.

"And if you put up at my house that will be better still. That's it,
come on!" said "Uncle." "You see it's damp weather, and you could
rest, and the little countess could be driven home in a trap."

"Uncle's" offer was accepted. A huntsman was sent to Otradnoe for
a trap, while Nicholas rode with Natasha and Petya to "Uncle's" house.

Some five male domestic serfs, big and little, rushed out to the
front porch to meet their master. A score of women serfs, old and
young, as well as children, popped out from the back entrance to
have a look at the hunters who were arriving. The presence of Natasha-
a woman, a lady, and on horseback--raised the curiosity of the serfs
to such a degree that many of them came up to her, stared her in the
face, and unabashed by her presence made remarks about her as though
she were some prodigy on show and not a human being able to hear or
understand what was said about her.

"Arinka! Look, she sits sideways! There she sits and her skirt
dangles.... See, she's got a little hunting horn!"

"Goodness gracious! See her knife?..."

"Isn't she a Tartar!"

"How is it you didn't go head over heels?" asked the boldest of all,
addressing Natasha directly.

"Uncle" dismounted at the porch of his little wooden house which
stood in the midst of an overgrown garden and, after a glance at his
retainers, shouted authoritatively that the superfluous ones should
take themselves off and that all necessary preparations should be made
to receive the guests and the visitors.

The serfs all dispersed. "Uncle" lifted Natasha off her horse and
taking her hand led her up the rickety wooden steps of the porch.
The house, with its bare, unplastered log walls, was not overclean--it
did not seem that those living in it aimed at keeping it spotless--but
neither was it noticeably neglected. In the entry there was a smell of
fresh apples, and wolf and fox skins hung about.

"Uncle" led the visitors through the anteroom into a small hall with
a folding table and red chairs, then into the drawing room with a
round birchwood table and a sofa, and finally into his private room
where there was a tattered sofa, a worn carpet, and portraits of
Suvorov, of the host's father and mother, and of himself in military
uniform. The study smelt strongly of tobacco and dogs. "Uncle" asked
his visitors to sit down and make themselves at home, and then went
out of the room. Rugay, his back still muddy, came into the room and
lay down on the sofa, cleaning himself with his tongue and teeth.
Leading from the study was a passage in which a partition with
ragged curtains could be seen. From behind this came women's
laughter and whispers. Natasha, Nicholas, and Petya took off their
wraps and sat down on the sofa. Petya, leaning on his elbow, fell
asleep at once. Natasha and Nicholas were silent. Their faces
glowed, they were hungry and very cheerful. They looked at one another
(now that the hunt was over and they were in the house, Nicholas no
longer considered it necessary to show his manly superiority over
his sister), Natasha gave him a wink, and neither refrained long
from bursting into a peal of ringing laughter even before they had a
pretext ready to account for it.

After a while "Uncle" came in, in a Cossack coat, blue trousers, and
small top boots. And Natasha felt that this costume, the very one
she had regarded with surprise and amusement at Otradnoe, was just the
right thing and not at all worse than a swallow-tail or frock coat.
"Uncle" too was in high spirits and far from being offended by the
brother's and sister's laughter (it could never enter his head that
they might be laughing at his way of life) he himself joined in the
merriment.

"That's right, young countess, that's it, come on! I never saw
anyone like her!" said he, offering Nicholas a pipe with a long stem
and, with a practiced motion of three fingers, taking down another
that had been cut short. "She's ridden all day like a man, and is as
fresh as ever!"

Soon after "Uncle's" reappearance the door was opened, evidently
from the sound by a barefooted girl, and a stout, rosy, good-looking
woman of about forty, with a double chin and full red lips, entered
carrying a large loaded tray. With hospitable dignity and cordiality
in her glance and in every motion, she looked at the visitors and,
with a pleasant smile, bowed respectfully. In spite of her exceptional
stoutness, which caused her to protrude her chest and stomach and
throw back her head, this woman (who was "Uncle's" housekeeper) trod
very lightly. She went to the table, set down the tray, and with her
plump white hands deftly took from it the bottles and various hors
d'oeuvres and dishes and arranged them on the table. When she had
finished, she stepped aside and stopped at the door with a smile on
her face. "Here I am. I am she! Now do you understand 'Uncle'?" her
expression said to Rostov. How could one help understanding? Not
only Nicholas, but even Natasha understood the meaning of his puckered
brow and the happy complacent smile that slightly puckered his lips
when Anisya Fedorovna entered. On the tray was a bottle of herb
wine, different kinds of vodka, pickled mushrooms, rye cakes made with
buttermilk, honey in the comb, still mead and sparkling mead,
apples, nuts (raw and roasted), and nut-and-honey sweets. Afterwards
she brought a freshly roasted chicken, ham, preserves made with honey,
and preserves made with sugar.

All this was the fruit of Anisya Fedorovna's housekeeping,
gathered and prepared by her. The smell and taste of it all had a
smack of Anisya Fedorovna herself: a savor of juiciness,
cleanliness, whiteness, and pleasant smiles.

"Take this, little Lady-Countess!" she kept saying, as she offered
Natasha first one thing and then another.

Natasha ate of everything and thought she had never seen or eaten
such buttermilk cakes, such aromatic jam, such honey-and-nut sweets,
or such a chicken anywhere. Anisya Fedorovna left the room.

After supper, over their cherry brandy, Rostov and "Uncle" talked of
past and future hunts, of Rugay and Ilagin's dogs, while Natasha sat
upright on the sofa and listened with sparkling eyes. She tried
several times to wake Petya that he might eat something, but he only
muttered incoherent words without waking up. Natasha felt so
lighthearted and happy in these novel surroundings that she only
feared the trap would come for her too soon. After a casual pause,
such as often occurs when receiving friends for the first time in
one's own house, "Uncle," answering a thought that was in his
visitors' mind, said:

"This, you see, is how I am finishing my days... Death will come.
That's it, come on! Nothing will remain. Then why harm anyone?"

"Uncle's" face was very significant and even handsome as he said
this. Involuntarily Rostov recalled all the good he had heard about
him from his father and the neighbors. Throughout the whole province
"Uncle" had the reputation of being the most honorable and
disinterested of cranks. They called him in to decide family disputes,
chose him as executor, confided secrets to him, elected him to be a
justice and to other posts; but he always persistently refused
public appointments, passing the autumn and spring in the fields on
his bay gelding, sitting at home in winter, and lying in his overgrown
garden in summer.

"Why don't you enter the service, Uncle?"

"I did once, but gave it up. I am not fit for it. That's it, come
on! I can't make head or tail of it. That's for you--I haven't
brains enough. Now, hunting is another matter--that's it, come on!
Open the door, there!" he shouted. "Why have you shut it?"

The door at the end of the passage led to the huntsmen's room, as
they called the room for the hunt servants.

There was a rapid patter of bare feet, and an unseen hand opened the
door into the huntsmen's room, from which came the clear sounds of a
balalayka on which someone, who was evidently a master of the art, was
playing. Natasha had been listening to those strains for some time and
now went out into the passage to hear better.

"That's Mitka, my coachman.... I have got him a good balalayka.
I'm fond of it," said "Uncle."

It was the custom for Mitka to play the balalayka in the
huntsmen's room when "Uncle" returned from the chase. "Uncle" was fond
of such music.

"How good! Really very good!" said Nicholas with some
unintentional superciliousness, as if ashamed to confess that the
sounds pleased him very much.

"Very good?" said Natasha reproachfully, noticing her brother's
tone. "Not 'very good' it's simply delicious!"

Just as "Uncle's" pickled mushrooms, honey, and cherry brandy had
seemed to her the best in the world, so also that song, at that
moment, seemed to her the acme of musical delight.

"More, please, more!" cried Natasha at the door as soon as the
balalayka ceased. Mitka tuned up afresh, and recommenced thrumming the
balalayka to the air of My Lady, with trills and variations. "Uncle"
sat listening, slightly smiling, with his head on one side. The air
was repeated a hundred times. The balalayka was retuned several
times and the same notes were thrummed again, but the listeners did
not grow weary of it and wished to hear it again and again. Anisya
Fedorovna came in and leaned her portly person against the doorpost.

"You like listening?" she said to Natasha, with a smile extremely
like "Uncle's." "That's a good player of ours," she added.

"He doesn't play that part right!" said "Uncle" suddenly, with an
energetic gesture. "Here he ought to burst out--that's it, come on!-
ought to burst out."

"Do you play then?" asked Natasha.

"Uncle" did not answer, but smiled.

"Anisya, go and see if the strings of my guitar are all right. I
haven't touched it for a long time. That's it--come on! I've given
it up."

Anisya Fedorovna, with her light step, willingly went to fulfill her
errand and brought back the guitar.

Without looking at anyone, "Uncle" blew the dust off it and, tapping
the case with his bony fingers, tuned the guitar and settled himself
in his armchair. He took the guitar a little above the fingerboard,
arching his left elbow with a somewhat theatrical gesture, and, with a
wink at Anisya Fedorovna, struck a single chord, pure and sonorous,
and then quietly, smoothly, and confidently began playing in very slow
time, not My Lady, but the well-known song: Came a maiden down the
street. The tune, played with precision and in exact time, began to
thrill in the hearts of Nicholas and Natasha, arousing in them the
same kind of sober mirth as radiated from Anisya Fedorovna's whole
being. Anisya Fedorovna flushed, and drawing her kerchief over her
face went laughing out of the room. "Uncle" continued to play
correctly, carefully, with energetic firmness, looking with a
changed and inspired expression at the spot where Anisya Fedorovna had
just stood. Something seemed to be laughing a little on one side of
his face under his gray mustaches, especially as the song grew brisker
and the time quicker and when, here and there, as he ran his fingers
over the strings, something seemed to snap.

"Lovely, lovely! Go on, Uncle, go on!" shouted Natasha as soon as he
had finished. She jumped up and hugged and kissed him. "Nicholas,
Nicholas!" she said, turning to her brother, as if asking him: "What
is it moves me so?"

Nicholas too was greatly pleased by "Uncle's" playing, and "Uncle"
played the piece over again. Anisya Fedorovna's smiling face
reappeared in the doorway and behind hers other faces...

    Fetching water clear and sweet,
    Stop, dear maiden, I entreat-

played "Uncle" once more, running his fingers skillfully over the
strings, and then he stopped short and jerked his shoulders.

"Go on, Uncle dear," Natasha wailed in an imploring tone as if her
life depended on it.

"Uncle" rose, and it was as if there were two men in him: one of
them smiled seriously at the merry fellow, while the merry fellow
struck a naive and precise attitude preparatory to a folk dance.

"Now then, niece!" he exclaimed, waving to Natasha the hand that had
just struck a chord.

Natasha threw off the shawl from her shoulders, ran forward to
face "Uncle," and setting her arms akimbo also made a motion with
her shoulders and struck an attitude.

Where, how, and when had this young countess, educated by an emigree
French governess, imbibed from the Russian air she breathed that
spirit and obtained that manner which the pas de chale* would, one
would have supposed, long ago have effaced? But the spirit and the
movements were those inimitable and unteachable Russian ones that
"Uncle" had expected of her. As soon as she had struck her pose, and
smiled triumphantly, proudly, and with sly merriment, the fear that
had at first seized Nicholas and the others that she might not do
the right thing was at an end, and they were already admiring her.


*The French shawl dance.


She did the right thing with such precision, such complete
precision, that Anisya Fedorovna, who had at once handed her the
handkerchief she needed for the dance, had tears in her eyes, though
she laughed as she watched this slim, graceful countess, reared in
silks and velvets and so different from herself, who yet was able to
understand all that was in Anisya and in Anisya's father and mother
and aunt, and in every Russian man and woman.

"Well, little countess; that's it--come on!" cried "Uncle," with a
joyous laugh, having finished the dance. "Well done, niece! Now a fine
young fellow must be found as husband for you. That's it--come on!"

"He's chosen already," said Nicholas smiling.

"Oh?" said "Uncle" in surprise, looking inquiringly at Natasha,
who nodded her head with a happy smile.

"And such a one!" she said. But as soon as she had said it a new
train of thoughts and feelings arose in her. "What did Nicholas' smile
mean when he said 'chosen already'? Is he glad of it or not? It is
as if he thought my Bolkonski would not approve of or understand our
gaiety. But he would understand it all. Where is he now?" she thought,
and her face suddenly became serious. But this lasted only a second.
"Don't dare to think about it," she said to herself, and sat down
again smilingly beside "Uncle," begging him to play something more.

"Uncle" played another song and a valse; then after a pause he
cleared his throat and sang his favorite hunting song:

    As 'twas growing dark last night
    Fell the snow so soft and light...


"Uncle" sang as peasants sing, with full and naive conviction that
the whole meaning of a song lies in the words and that the tune
comes of itself, and that apart from the words there is no tune, which
exists only to give measure to the words. As a result of this the
unconsidered tune, like the song of a bird, was extraordinarily
good. Natasha was in ecstasies over "Uncle's" singing. She resolved to
give up learning the harp and to play only the guitar. She asked
"Uncle" for his guitar and at once found the chords of the song.

After nine o'clock two traps and three mounted men, who had been
sent to look for them, arrived to fetch Natasha and Petya. The count
and countess did not know where they were and were very anxious,
said one of the men.

Petya was carried out like a log and laid in the larger of the two
traps. Natasha and Nicholas got into the other. "Uncle" wrapped
Natasha up warmly and took leave of her with quite a new tenderness.
He accompanied them on foot as far as the bridge that could not be
crossed, so that they had to go round by the ford, and he sent
huntsmen to ride in front with lanterns.

"Good-by, dear niece," his voice called out of the darkness--not the
voice Natasha had known previously, but the one that had sung As 'twas
growing dark last night.

In the village through which they passed there were red lights and a
cheerful smell of smoke.

"What a darling Uncle is!" said Natasha, when they had come out onto
the highroad.

"Yes," returned Nicholas. "You're not cold?"

"No. I'm quite, quite all right. I feel so comfortable!" answered
Natasha, almost perplexed by her feelings. They remained silent a long
while. The night was dark and damp. They could not see the horses, but
only heard them splashing through the unseen mud.

What was passing in that receptive childlike soul that so eagerly
caught and assimilated all the diverse impressions of life? How did
they all find place in her? But she was very happy. As they were
nearing home she suddenly struck up the air of As 'twas growing dark
last night--the tune of which she had all the way been trying to get
and had at last caught.

"Got it?" said Nicholas.

"What were you thinking about just now, Nicholas?" inquired Natasha.

They were fond of asking one another that question.

"I?" said Nicholas, trying to remember. "Well, you see, first I
thought that Rugay, the red hound, was like Uncle, and that if he were
a man he would always keep Uncle near him, if not for his riding, then
for his manner. What a good fellow Uncle is! Don't you think so?...
Well, and you?"

"I? Wait a bit, wait.... Yes, first I thought that we are driving
along and imagining that we are going home, but that heaven knows
where we are really going in the darkness, and that we shall arrive
and suddenly find that we are not in Otradnoe, but in Fairyland. And
then I thought... No, nothing else."

"I know, I expect you thought of him," said Nicholas, smiling as
Natasha knew by the sound of his voice.

"No," said Natasha, though she had in reality been thinking about
Prince Andrew at the same time as of the rest, and of how he would
have liked "Uncle." "And then I was saying to myself all the way, 'How
well Anisya carried herself, how well!'" And Nicholas heard her
spontaneous, happy, ringing laughter. "And do you know," she
suddenly said, "I know that I shall never again be as happy and
tranquil as I am now."

"Rubbish, nonsense, humbug!" exclaimed Nicholas, and he thought:
"How charming this Natasha of mine is! I have no other friend like her
and never shall have. Why should she marry? We might always drive
about together!"

"What a darling this Nicholas of mine is!" thought Natasha.

"Ah, there are still lights in the drawingroom!" she said,
pointing to the windows of the house that gleamed invitingly in the
moist velvety darkness of the night.





CHAPTER VIII


Count Ilya Rostov had resigned the position of Marshal of the
Nobility because it involved him in too much expense, but still his
affairs did not improve. Natasha and Nicholas often noticed their
parents conferring together anxiously and privately and heard
suggestions of selling the fine ancestral Rostov house and estate near
Moscow. It was not necessary to entertain so freely as when the
count had been Marshal, and life at Otradnoe was quieter than in
former years, but still the enormous house and its lodges were full of
people and more than twenty sat down to table every day. These were
all their own people who had settled down in the house almost as
members of the family, or persons who were, it seemed, obliged to live
in the count's house. Such were Dimmler the musician and his wife,
Vogel the dancing master and his family, Belova, an old maiden lady,
an inmate of the house, and many others such as Petya's tutors, the
girls' former governess, and other people who simply found it
preferable and more advantageous to live in the count's house than
at home. They had not as many visitors as before, but the old habits
of life without which the count and countess could not conceive of
existence remained unchanged. There was still the hunting
establishment which Nicholas had even enlarged, the same fifty
horses and fifteen grooms in the stables, the same expensive
presents and dinner parties to the whole district on name days;
there were still the count's games of whist and boston, at which-
spreading out his cards so that everybody could see them--he let
himself be plundered of hundreds of rubles every day by his neighbors,
who looked upon an opportunity to play a rubber with Count Rostov as a
most profitable source of income.

The count moved in his affairs as in a huge net, trying not to
believe that he was entangled but becoming more and more so at every
step, and feeling too feeble to break the meshes or to set to work
carefully and patiently to disentangle them. The countess, with her
loving heart, felt that her children were being ruined, that it was
not the count's fault for he could not help being what he was--that
(though he tried to hide it) he himself suffered from the
consciousness of his own and his children's ruin, and she tried to
find means of remedying the position. From her feminine point of
view she could see only one solution, namely, for Nicholas to marry
a rich heiress. She felt this to be their last hope and that if
Nicholas refused the match she had found for him, she would have to
abandon the hope of ever getting matters right. This match was with
Julie Karagina, the daughter of excellent and virtuous parents, a girl
the Rostovs had known from childhood, and who had now become a wealthy
heiress through the death of the last of her brothers.

The countess had written direct to Julie's mother in Moscow
suggesting a marriage between their children and had received a
favorable answer from her. Karagina had replied that for her part
she was agreeable, and everything depend on her daughter's
inclination. She invited Nicholas to come to Moscow.

Several times the countess, with tears in her eyes, told her son
that now both her daughters were settled, her only wish was to see him
married. She said she could lie down in her grave peacefully if that
were accomplished. Then she told him that she knew of a splendid
girl and tried to discover what he thought about marriage.

At other times she praised Julie to him and advised him to go to
Moscow during the holidays to amuse himself. Nicholas guessed what his
mother's remarks were leading to and during one of these conversations
induced her to speak quite frankly. She told him that her only hope of
getting their affairs disentangled now lay in his marrying Julie
Karagina.

"But, Mamma, suppose I loved a girl who has no fortune, would you
expect me to sacrifice my feelings and my honor for the sake of
money?" he asked his mother, not realizing the cruelty of his question
and only wishing to show his noble-mindedness.

"No, you have not understood me," said his mother, not knowing how
to justify herself. "You have not understood me, Nikolenka. It is your
happiness I wish for," she added, feeling that she was telling an
untruth and was becoming entangled. She began to cry.

"Mamma, don't cry! Only tell me that you wish it, and you know I
will give my life, anything, to put you at ease," said Nicholas. "I
would sacrifice anything for you--even my feelings."

But the countess did not want the question put like that: she did
not want a sacrifice from her son, she herself wished to make a
sacrifice for him.

"No, you have not understood me, don't let us talk about it," she
replied, wiping away her tears.

"Maybe I do love a poor girl," said Nicholas to himself. "Am I to
sacrifice my feelings and my honor for money? I wonder how Mamma could
speak so to me. Because Sonya is poor I must not love her," he
thought, "must not respond to her faithful, devoted love? Yet I should
certainly be happier with her than with some doll-like Julie. I can
always sacrifice my feelings for my family's welfare," he said to
himself, "but I can't coerce my feelings. If I love Sonya, that
feeling is for me stronger and higher than all else."

Nicholas did not go to Moscow, and the countess did not renew the
conversation with him about marriage. She saw with sorrow, and
sometimes with exasperation, symptoms of a growing attachment
between her son and the portionless Sonya. Though she blamed herself
for it, she could not refrain from grumbling at and worrying Sonya,
often pulling her up without reason, addressing her stiffly as "my
dear," and using the formal "you" instead of the intimate "thou" in
speaking to her. The kindhearted countess was the more vexed with
Sonya because that poor, dark-eyed niece of hers was so meek, so kind,
so devotedly grateful to her benefactors, and so faithfully,
unchangingly, and unselfishly in love with Nicholas, that there were
no grounds for finding fault with her.

Nicholas was spending the last of his leave at home. A fourth letter
had come from Prince Andrew, from Rome, in which he wrote that he
would have been on his way back to Russia long ago had not his wound
unexpectedly reopened in the warm climate, which obliged him to
defer his return till the beginning of the new year. Natasha was still
as much in love with her betrothed, found the same comfort in that
love, and was still as ready to throw herself into all the pleasures
of life as before; but at the end of the fourth month of their
separation she began to have fits of depression which she could not
master. She felt sorry for herself: sorry that she was being wasted
all this time and of no use to anyone--while she felt herself so
capable of loving and being loved.

Things were not cheerful in the Rostovs' home.





CHAPTER IX


Christmas came and except for the ceremonial Mass, the solemn and
wearisome Christmas congratulations from neighbors and servants, and
the new dresses everyone put on, there were no special festivities,
though the calm frost of twenty degrees Reaumur, the dazzling sunshine
by day, and the starlight of the winter nights seemed to call for some
special celebration of the season.

On the third day of Christmas week, after the midday dinner, all the
inmates of the house dispersed to various rooms. It was the dullest
time of the day. Nicholas, who had been visiting some neighbors that
morning, was asleep on the sitting-room sofa. The old count was
resting in his study. Sonya sat in the drawing room at the round
table, copying a design for embroidery. The countess was playing
patience. Nastasya Ivanovna the buffoon sat with a sad face at the
window with two old ladies. Natasha came into the room, went up to
Sonya, glanced at what she was doing, and then went up to her mother
and stood without speaking.

"Why are you wandering about like an outcast?" asked her mother.
"What do you want?"

"Him... I want him... now, this minute! I want him!" said Natasha,
with glittering eyes and no sign of a smile.

The countess lifted her head and looked attentively at her daughter.

"Don't look at me, Mamma! Don't look; I shall cry directly."

"Sit down with me a little," said the countess.

"Mamma, I want him. Why should I be wasted like this, Mamma?"

Her voice broke, tears gushed from her eyes, and she turned
quickly to hide them and left the room.

She passed into the sitting room, stood there thinking awhile, and
then went into the maids' room. There an old maidservant was grumbling
at a young girl who stood panting, having just run in through the cold
from the serfs' quarters.

"Stop playing--there's a time for everything," said the old woman.

"Let her alone, Kondratevna," said Natasha. "Go, Mavrushka, go."

Having released Mavrushka, Natasha crossed the dancing hall and went
to the vestibule. There an old footman and two young ones were playing
cards. They broke off and rose as she entered.

"What can I do with them?" thought Natasha.

"Oh, Nikita, please go... where can I send him?... Yes, go to the
yard and fetch a fowl, please, a cock, and you, Misha, bring me some
oats."

"Just a few oats?" said Misha, cheerfully and readily.

"Go, go quickly," the old man urged him.

"And you, Theodore, get me a piece of chalk."

On her way past the butler's pantry she told them to set a
samovar, though it was not at all the time for tea.

Foka, the butler, was the most ill-tempered person in the house.
Natasha liked to test her power over him. He distrusted the order
and asked whether the samovar was really wanted.

"Oh dear, what a young lady!" said Foka, pretending to frown at
Natasha.

No one in the house sent people about or gave them as much trouble
as Natasha did. She could not see people unconcernedly, but had to
send them on some errand. She seemed to be trying whether any of
them would get angry or sulky with her; but the serfs fulfilled no
one's orders so readily as they did hers. "What can I do, where can
I go?" thought she, as she went slowly along the passage.

"Nastasya Ivanovna, what sort of children shall I have?" she asked
the buffoon, who was coming toward her in a woman's jacket.

"Why, fleas, crickets, grasshoppers," answered the buffoon.

"O Lord, O Lord, it's always the same! Oh, where am I to go? What am
I to do with myself?" And tapping with her heels, she ran quickly
upstairs to see Vogel and his wife who lived on the upper story.

Two governesses were sitting with the Vogels at a table, on which
were plates of raisins, walnuts, and almonds. The governesses were
discussing whether it was cheaper to live in Moscow or Odessa. Natasha
sat down, listened to their talk with a serious and thoughtful air,
and then got up again.

"The island of Madagascar," she said, "Ma-da-gas-car," she repeated,
articulating each syllable distinctly, and, not replying to Madame
Schoss who asked her what she was saying, she went out of the room.

Her brother Petya was upstairs too; with the man in attendance on
him he was preparing fireworks to let off that night.

"Petya! Petya!" she called to him. "Carry me downstairs."

Petya ran up and offered her his back. She jumped on it, putting her
arms round his neck, and he pranced along with her.

"No, don't... the island of Madagascar!" she said, and jumping off
his back she went downstairs.

Having as it were reviewed her kingdom, tested her power, and made
sure that everyone was submissive, but that all the same it was
dull, Natasha betook herself to the ballroom, picked up her guitar,
sat down in a dark corner behind a bookcase, and began to run her
fingers over the strings in the bass, picking out a passage she
recalled from an opera she had heard in Petersburg with Prince Andrew.
What she drew from the guitar would have had no meaning for other
listeners, but in her imagination a whole series of reminiscences
arose from those sounds. She sat behind the bookcase with her eyes
fixed on a streak of light escaping from the pantry door and
listened to herself and pondered. She was in a mood for brooding on
the past.

Sonya passed to the pantry with a glass in her hand. Natasha glanced
at her and at the crack in the pantry door, and it seemed to her
that she remembered the light failing through that crack once before
and Sonya passing with a glass in her hand. "Yes it was exactly the
same," thought Natasha.

"Sonya, what is this?" she cried, twanging a thick string.

"Oh, you are there!" said Sonya with a start, and came near and
listened. "I don't know. A storm?" she ventured timidly, afraid of
being wrong.

"There! That's just how she started and just how she came up smiling
timidly when all this happened before," thought Natasha, "and in
just the same way I thought there was something lacking in her."

"No, it's the chorus from The Water-Carrier, listen!" and Natasha
sang the air of the chorus so that Sonya should catch it. "Where
were you going?" she asked.

"To change the water in this glass. I am just finishing the design."

"You always find something to do, but I can't," said Natasha. "And
where's Nicholas?"

"Asleep, I think."

"Sonya, go and wake him," said Natasha. "Tell him I want him to come
and sing."

She sat awhile, wondering what the meaning of it all having happened
before could be, and without solving this problem, or at all
regretting not having done so, she again passed in fancy to the time
when she was with him and he was looking at her with a lover's eyes.

"Oh, if only he would come quicker! I am so afraid it will never be!
And, worst of all, I am growing old--that's the thing! There won't
then be in me what there is now. But perhaps he'll come today, will
come immediately. Perhaps he has come and is sitting in the drawing
room. Perhaps he came yesterday and I have forgotten it." She rose,
put down the guitar, and went to the drawing room.

All the domestic circle, tutors, governesses, and guests, were
already at the tea table. The servants stood round the table--but
Prince Andrew was not there and life was going on as before.

"Ah, here she is!" said the old count, when he saw Natasha enter.
"Well, sit down by me." But Natasha stayed by her mother and glanced
round as if looking for something.

"Mamma!" she muttered, "give him to me, give him, Mamma, quickly,
quickly!" and she again had difficulty in repressing her sobs.

She sat down at the table and listened to the conversation between
the elders and Nicholas, who had also come to the table. "My God, my
God! The same faces, the same talk, Papa holding his cup and blowing
in the same way!" thought Natasha, feeling with horror a sense of
repulsion rising up in her for the whole household, because they
were always the same.

After tea, Nicholas, Sonya, and Natasha went to the sitting room, to
their favorite corner where their most intimate talks always began.





CHAPTER X


"Does it ever happen to you," said Natasha to her brother, when
they settled down in the sitting room, "does it ever happen to you
to feel as if there were nothing more to come--nothing; that
everything good is past? And to feel not exactly dull, but sad?"

"I should think so!" he replied. "I have felt like that when
everything was all right and everyone was cheerful. The thought has
come into my mind that I was already tired of it all, and that we must
all die. Once in the regiment I had not gone to some merrymaking where
there was music... and suddenly I felt so depressed..."

"Oh yes, I know, I know, I know!" Natasha interrupted him. "When I
was quite little that used to be so with me. Do you remember when I
was punished once about some plums? You were all dancing, and I sat
sobbing in the schoolroom? I shall never forget it: I felt sad and
sorry for everyone, for myself, and for everyone. And I was
innocent--that was the chief thing," said Natasha. "Do you remember?"

"I remember," answered Nicholas. "I remember that I came to you
afterwards and wanted to comfort you, but do you know, I felt
ashamed to. We were terribly absurd. I had a funny doll then and
wanted to give it to you. Do you remember?"

"And do you remember," Natasha asked with a pensive smile, "how
once, long, long ago, when we were quite little, Uncle called us
into the study--that was in the old house--and it was dark--we went in
and suddenly there stood..."

"A Negro," chimed in Nicholas with a smile of delight. "Of course
I remember. Even now I don't know whether there really was a Negro, or
if we only dreamed it or were told about him."

"He was gray, you remember, and had white teeth, and stood and
looked at us..."

"Sonya, do you remember?" asked Nicholas.

"Yes, yes, I do remember something too," Sonya answered timidly.

"You know I have asked Papa and Mamma about that Negro," said
Natasha, "and they say there was no Negro at all. But you see, you
remember!"

"Of course I do, I remember his teeth as if I had just seen them."

"How strange it is! It's as if it were a dream! I like that."

"And do you remember how we rolled hard-boiled eggs in the ballroom,
and suddenly two old women began spinning round on the carpet? Was
that real or not? Do you remember what fun it was?"

"Yes, and you remember how Papa in his blue overcoat fired a gun
in the porch?"

So they went through their memories, smiling with pleasure: not
the sad memories of old age, but poetic, youthful ones--those
impressions of one's most distant past in which dreams and realities
blend--and they laughed with quiet enjoyment.

Sonya, as always, did not quite keep pace with them, though they
shared the same reminiscences.

Much that they remembered had slipped from her mind, and what she
recalled did not arouse the same poetic feeling as they experienced.
She simply enjoyed their pleasure and tried to fit in with it.

She only really took part when they recalled Sonya's first
arrival. She told them how afraid she had been of Nicholas because
he had on a corded jacket and her nurse had told her that she, too,
would be sewn up with cords.

"And I remember their telling me that you had been born under a
cabbage," said Natasha, "and I remember that I dared not disbelieve
it then, but knew that it was not true, and I felt so uncomfortable."

While they were talking a maid thrust her head in at the other
door of the sitting room.

"They have brought the cock, Miss," she said in a whisper.

"It isn't wanted, Petya. Tell them to take it away," replied
Natasha.

In the middle of their talk in the sitting room, Dimmler came in and
went up to the harp that stood there in a corner. He took off its
cloth covering, and the harp gave out a jarring sound.

"Mr. Dimmler, please play my favorite nocturne by Field," came the
old countess' voice from the drawing room.

Dimmler struck a chord and, turning to Natasha, Nicholas, and Sonya,
remarked: "How quiet you young people are!"

"Yes, we're philosophizing," said Natasha, glancing round for a
moment and then continuing the conversation. They were now
discussing dreams.

Dimmler began to play; Natasha went on tiptoe noiselessly to the
table, took up a candle, carried it out, and returned, seating herself
quietly in her former place. It was dark in the room especially
where they were sitting on the sofa, but through the big windows the
silvery light of the full moon fell on the floor. Dimmler had finished
the piece but still sat softly running his fingers over the strings,
evidently uncertain whether to stop or to play something else.

"Do you know," said Natasha in a whisper, moving closer to
Nicholas and Sonya, "that when one goes on and on recalling
memories, one at last begins to remember what happened before one
was in the world..."

"That is metempsychosis," said Sonya, who had always learned well,
and remembered everything. "The Egyptians believed that our souls have
lived in animals, and will go back into animals again."

"No, I don't believe we ever were in animals," said Natasha, still
in a whisper though the music had ceased. "But I am certain that we
were angels somewhere there, and have been here, and that is why we
remember...."

"May I join you?" said Dimmler who had come up quietly, and he sat
down by them.

"If we have been angels, why have we fallen lower?" said Nicholas.
"No, that can't be!"

"Not lower, who said we were lower?... How do I know what I was
before?" Natasha rejoined with conviction. "The soul is immortal--well
then, if I shall always live I must have lived before, lived for a
whole eternity."

"Yes, but it is hard for us to imagine eternity," remarked
Dimmler, who had joined the young folk with a mildly condescending
smile but now spoke as quietly and seriously as they.

"Why is it hard to imagine eternity?" said Natasha. "It is now
today, and it will be tomorrow, and always; and there was yesterday,
and the day before..."

"Natasha! Now it's your turn. Sing me something," they heard the
countess say. "Why are you sitting there like conspirators?"

"Mamma, I don't at all want to," replied Natasha, but all the same
she rose.

None of them, not even the middle-aged Dimmler, wanted to break
off their conversation and quit that corner in the sitting room, but
Natasha got up and Nicholas sat down at the clavichord. Standing as
usual in the middle of the hall and choosing the place where the
resonance was best, Natasha began to sing her mother's favorite song.

She had said she did not want to sing, but it was long since she had
sung, and long before she again sang, as she did that evening. The
count, from his study where he was talking to Mitenka, heard her
and, like a schoolboy in a hurry to run out to play, blundered in
his talk while giving orders to the steward, and at last stopped,
while Mitenka stood in front of him also listening and smiling.
Nicholas did not take his eyes off his sister and drew breath in
time with her. Sonya, as she listened, thought of the immense
difference there was between herself and her friend, and how
impossible it was for her to be anything like as bewitching as her
cousin. The old countess sat with a blissful yet sad smile and with
tears in her eyes, occasionally shaking her head. She thought of
Natasha and of her own youth, and of how there was something unnatural
and dreadful in this impending marriage of Natasha and Prince Andrew.

Dimmler, who had seated himself beside the countess, listened with
closed eyes.

"Ah, Countess," he said at last, "that's a European talent, she
has nothing to learn--what softness, tenderness, and strength...."

"Ah, how afraid I am for her, how afraid I am!" said the countess,
not realizing to whom she was speaking. Her maternal instinct told her
that Natasha had too much of something, and that because of this she
would not be happy. Before Natasha had finished singing,
fourteen-year-old Petya rushed in delightedly, to say that some
mummers had arrived.

Natasha stopped abruptly.

"Idiot!" she screamed at her brother and, running to a chair,
threw herself on it, sobbing so violently that she could not stop
for a long time.

"It's nothing, Mamma, really it's nothing; only Petya startled
me," she said, trying to smile, but her tears still flowed and sobs
still choked her.

The mummers (some of the house serfs) dressed up as bears, Turks,
innkeepers, and ladies--frightening and funny--bringing in with them
the cold from outside and a feeling of gaiety, crowded, at first
timidly, into the anteroom, then hiding behind one another they pushed
into the ballroom where, shyly at first and then more and more merrily
and heartily, they started singing, dancing, and playing Christmas
games. The countess, when she had identified them and laughed at their
costumes, went into the drawing room. The count sat in the ballroom,
smiling radiantly and applauding the players. The young people had
disappeared.

Half an hour later there appeared among the other mummers in the
ballroom an old lady in a hooped skirt--this was Nicholas. A Turkish
girl was Petya. A clown was Dimmler. An hussar was Natasha, and a
Circassian was Sonya with burnt-cork mustache and eyebrows.

After the condescending surprise, nonrecognition, and praise, from
those who were not themselves dressed up, the young people decided
that their costumes were so good that they ought to be shown
elsewhere.

Nicholas, who, as the roads were in splendid condition, wanted to
take them all for a drive in his troyka, proposed to take with them
about a dozen of the serf mummers and drive to "Uncle's."

"No, why disturb the old fellow?" said the countess. "Besides, you
wouldn't have room to turn round there. If you must go, go to the
Melyukovs'."

Melyukova was a widow, who, with her family and their tutors and
governesses, lived three miles from the Rostovs.

"That's right, my dear," chimed in the old count, thoroughly
aroused. "I'll dress up at once and go with them. I'll make Pashette
open her eyes."

But the countess would not agree to his going; he had had a bad
leg all these last days. It was decided that the count must not go,
but that if Louisa Ivanovna (Madame Schoss) would go with them, the
young ladies might go to the Melyukovs', Sonya, generally so timid and
shy, more urgently than anyone begging Louisa Ivanovna not to refuse.

Sonya's costume was the best of all. Her mustache and eyebrows
were extraordinarily becoming. Everyone told her she looked very
handsome, and she was in a spirited and energetic mood unusual with
her. Some inner voice told her that now or never her fate would be
decided, and in her male attire she seemed quite a different person.
Louisa Ivanovna consented to go, and in half an hour four troyka
sleighs with large and small bells, their runners squeaking and
whistling over the frozen snow, drove up to the porch.

Natasha was foremost in setting a merry holiday tone, which, passing
from one to another, grew stronger and reached its climax
when they all came out into the frost and got into the sleighs,
talking, calling to one another, laughing, and shouting.

Two of the troykas were the usual household sleighs, the third was
the old count's with a trotter from the Orlov stud as shaft horse, the
fourth was Nicholas' own with a short shaggy black shaft horse.
Nicholas, in his old lady's dress over which he had belted his
hussar overcoat, stood in the middle of the sleigh, reins in hand.

It was so light that he could see the moonlight reflected from the
metal harness disks and from the eyes of the horses, who looked
round in alarm at the noisy party under the shadow of the porch roof.

Natasha, Sonya, Madame Schoss, and two maids got into Nicholas'
sleigh; Dimmler, his wife, and Petya, into the old count's, and the
rest of the mummers seated themselves in the other two sleighs.

"You go ahead, Zakhar!" shouted Nicholas to his father's coachman,
wishing for a chance to race past him.

The old count's troyka, with Dimmler and his party, started forward,
squeaking on its runners as though freezing to the snow, its
deep-toned bell clanging. The side horses, pressing against the shafts
of the middle horse, sank in the snow, which was dry and glittered
like sugar, and threw it up.

Nicholas set off, following the first sleigh; behind him the
others moved noisily, their runners squeaking. At first they drove
at a steady trot along the narrow road. While they drove past the
garden the shadows of the bare trees often fell across the road and
hid the brilliant moonlight, but as soon as they were past the
fence, the snowy plain bathed in moonlight and motionless spread out
before them glittering like diamonds and dappled with bluish
shadows. Bang, bang! went the first sleigh over a cradle hole in the
snow of the road, and each of the other sleighs jolted in the same
way, and rudely breaking the frost-bound stillness, the troykas
began to speed along the road, one after the other.

"A hare's track, a lot of tracks!" rang out Natasha's voice
through the frost-bound air.

"How light it is, Nicholas!" came Sonya's voice.

Nicholas glanced round at Sonya, and bent down to see her face
closer. Quite a new, sweet face with black eyebrows and mustaches
peeped up at him from her sable furs--so close and yet so distant-
in the moonlight.

"That used to be Sonya," thought he, and looked at her closer and
smiled.

"What is it, Nicholas?"

"Nothing," said he and turned again to the horses.

When they came out onto the beaten highroad--polished by sleigh
runners and cut up by rough-shod hoofs, the marks of which were
visible in the moonlight--the horses began to tug at the reins of
their own accord and increased their pace. The near side horse,
arching his head and breaking into a short canter, tugged at his
traces. The shaft horse swayed from side to side, moving his ears as
if asking: "Isn't it time to begin now?" In front, already far ahead
the deep bell of the sleigh ringing farther and farther off, the black
horses driven by Zakhar could be clearly seen against the white
snow. From that sleigh one could hear the shouts, laughter, and voices
of the mummers.

"Gee up, my darlings!" shouted Nicholas, pulling the reins to one
side and flourishing the whip.

It was only by the keener wind that met them and the jerks given
by the side horses who pulled harder--ever increasing their gallop-
that one noticed how fast the troyka was flying. Nicholas looked back.
With screams squeals, and waving of whips that caused even the shaft
horses to gallop--the other sleighs followed. The shaft horse swung
steadily beneath the bow over its head, with no thought of
slackening pace and ready to put on speed when required.

Nicholas overtook the first sleigh. They were driving downhill and
coming out upon a broad trodden track across a meadow, near a river.

"Where are we?" thought he. "It's the Kosoy meadow, I suppose. But
no--this is something new I've never seen before. This isn't the Kosoy
meadow nor the Demkin hill, and heaven only knows what it is! It is
something new and enchanted. Well, whatever it may be..." And shouting
to his horses, he began to pass the first sleigh.

Zakhar held back his horses and turned his face, which was already
covered with hoarfrost to his eyebrows.

Nicholas gave the horses the rein, and Zakhar, stretching out his
arms, clucked his tongue and let his horses go.

"Now, look out, master!" he cried.

Faster still the two troykas flew side by side, and faster moved the
feet of the galloping side horses. Nicholas began to draw ahead.
Zakhar, while still keeping his arms extended, raised one hand with
the reins.

"No you won't, master!" he shouted.

Nicholas put all his horses to a gallop and passed Zakhar. The
horses showered the fine dry snow on the faces of those in the sleigh-
beside them sounded quick ringing bells and they caught confused
glimpses of swiftly moving legs and the shadows of the troyka they
were passing. The whistling sound of the runners on the snow and the
voices of girls shrieking were heard from different sides.

Again checking his horses, Nicholas looked around him. They were
still surrounded by the magic plain bathed in moonlight and spangled
with stars.

"Zakhar is shouting that I should turn to the left, but why to the
left?" thought Nicholas. "Are we getting to the Melyukovs'? Is this
Melyukovka? Heaven only knows where we are going, and heaven knows
what is happening to us--but it is very strange and pleasant
whatever it is." And he looked round in the sleigh.

"Look, his mustache and eyelashes are all white!" said one of the
strange, pretty, unfamiliar people--the one with fine eyebrows and
mustache.

"I think this used to be Natasha," thought Nicholas, "and that was
Madame Schoss, but perhaps it's not, and this Circassian with the
mustache I don't know, but I love her."

"Aren't you cold?" he asked.

They did not answer but began to laugh. Dimmler from the sleigh
behind shouted something--probably something funny--but they could not
make out what he said.

"Yes, yes!" some voices answered, laughing.

"But here was a fairy forest with black moving shadows, and a
glitter of diamonds and a flight of marble steps and the silver
roofs of fairy buildings and the shrill yells of some animals. And
if this is really Melyukovka, it is still stranger that we drove
heaven knows where and have come to Melyukovka," thought Nicholas.

It really was Melyukovka, and maids and footmen with merry faces
came running, out to the porch carrying candles.

"Who is it?" asked someone in the porch.

"The mummers from the count's. I know by the horses," replied some
voices.





CHAPTER XI


Pelageya Danilovna Melyukova, a broadly built, energetic woman
wearing spectacles, sat in the drawing room in a loose dress,
surrounded by her daughters whom she was trying to keep from feeling
dull. They were quietly dropping melted wax into snow and looking at
the shadows the wax figures would throw on the wall, when they heard
the steps and voices of new arrivals in the vestibule.

Hussars, ladies, witches, clowns, and bears, after clearing their
throats and wiping the hoarfrost from their faces in the vestibule,
came into the ballroom where candles were hurriedly lighted. The
clown--Dimmler--and the lady--Nicholas--started a dance. Surrounded by
the screaming children the mummers, covering their faces and
disguising their voices, bowed to their hostess and arranged
themselves about the room.

"Dear me! there's no recognizing them! And Natasha! See whom she
looks like! She really reminds me of somebody. But Herr Dimmler--isn't
he good! I didn't know him! And how he dances. Dear me, there's a
Circassian. Really, how becoming it is to dear Sonya. And who is that?
Well, you have cheered us up! Nikita and Vanya--clear away the tables!
And we were sitting so quietly. Ha, ha, ha!... The hussar, the hussar!
Just like a boy! And the legs!... I can't look at him..." different
voices were saying.

Natasha, the young Melyukovs' favorite, disappeared with them into
the back rooms where a cork and various dressing gowns and male
garments were called for and received from the footman by bare girlish
arms from behind the door. Ten minutes later, all the young
Melyukovs joined the mummers.

Pelageya Danilovna, having given orders to clear the rooms for the
visitors and arranged about refreshments for the gentry and the serfs,
went about among the mummers without removing her spectacles,
peering into their faces with a suppressed smile and failing to
recognize any of them. It was not merely Dimmler and the Rostovs she
failed to recognize, she did not even recognize her own daughters,
or her late husband's, dressing gowns and uniforms, which they had put
on.

"And who is is this?" she asked her governess, peering into the face
of her own daughter dressed up as a Kazan-Tartar. "I suppose it is one
of the Rostovs! Well, Mr. Hussar, and what regiment do you serve
in?" she asked Natasha. "Here, hand some fruit jelly to the Turk!" she
ordered the butler who was handing things round. "That's not forbidden
by his law."

Sometimes, as she looked at the strange but amusing capers cut by
the dancers, who--having decided once for all that being disguised, no
one would recognize them--were not at all shy, Pelageya Danilovna
hid her face in her handkerchief, and her whole stout body shook
with irrepressible, kindly, elderly laughter.

"My little Sasha! Look at Sasha!" she said.

After Russian country dances and chorus dances, Pelageya Danilovna
made the serfs and gentry join in one large circle: a ring, a
string, and a silver ruble were fetched and they all played games
together.

In an hour, all the costumes were crumpled and disordered. The
corked eyebrows and mustaches were smeared over the perspiring,
flushed, and merry faces. Pelageya Danilovna began to recognize the
mummers, admired their cleverly contrived costumes, and particularly
how they suited the young ladies, and she thanked them all for
having entertained her so well. The visitors were invited to supper in
the drawing room, and the serfs had something served to them in the
ballroom.

"Now to tell one's fortune in the empty bathhouse is frightening!"
said an old maid who lived with the Melyukovs, during supper.

"Why?" said the eldest Melyukov girl.

"You wouldn't go, it takes courage..."

"I'll go," said Sonya.

"Tell what happened to the young lady!" said the second Melyukov
girl.

"Well," began the old maid, "a young lady once went out, took a
cock, laid the table for two, all properly, and sat down. After
sitting a while, she suddenly hears someone coming... a sleigh
drives up with harness bells; she hears him coming! He comes in,
just in the shape of a man, like an officer--comes in and sits down to
table with her."

"Ah! ah!" screamed Natasha, rolling her eyes with horror.

"Yes? And how... did he speak?"

"Yes, like a man. Everything quite all right, and he began
persuading her; and she should have kept him talking till cockcrow,
but she got frightened, just got frightened and hid her face in her
hands. Then he caught her up. It was lucky the maids ran in just
then..."

"Now, why frighten them?" said Pelageya Danilovna.

"Mamma, you used to try your fate yourself..." said her daughter.

"And how does one do it in a barn?" inquired Sonya.

"Well, say you went to the barn now, and listened. It depends on
what you hear; hammering and knocking--that's bad; but a sound of
shifting grain is good and one sometimes hears that, too."

"Mamma, tell us what happened to you in the barn."

Pelageya Danilovna smiled.

"Oh, I've forgotten..." she replied. "But none of you would go?"

"Yes, I will; Pelageya Danilovna, let me! I'll go," said Sonya.

"Well, why not, if you're not afraid?"

"Louisa Ivanovna, may I?" asked Sonya.

Whether they were playing the ring and string game or the ruble game
or talking as now, Nicholas did not leave Sonya's side, and gazed at
her with quite new eyes. It seemed to him that it was only today,
thanks to that burnt-cork mustache, that he had fully learned to
know her. And really, that evening, Sonya was brighter, more animated,
and prettier than Nicholas had ever seen her before.

"So that's what she is like; what a fool I have been!" he thought
gazing at her sparkling eyes, and under the mustache a happy rapturous
smile dimpled her cheeks, a smile he had never seen before.

"I'm not afraid of anything," said Sonya. "May I go at once?" She
got up.

They told her where the barn was and how she should stand and
listen, and they handed her a fur cloak. She threw this over her
head and shoulders and glanced at Nicholas.

"What a darling that girl is!" thought he. "And what have I been
thinking of till now?"

Sonya went out into the passage to go to the barn. Nicholas went
hastily to the front porch, saying he felt too hot. The crowd of
people really had made the house stuffy.

Outside, there was the same cold stillness and the same moon, but
even brighter than before. The light was so strong and the snow
sparkled with so many stars that one did not wish to look up at the
sky and the real stars were unnoticed. The sky was black and dreary,
while the earth was gay.

"I am a fool, a fool! what have I been waiting for?" thought
Nicholas, and running out from the porch he went round the corner of
the house and along the path that led to the back porch. He knew Sonya
would pass that way. Halfway lay some snow-covered piles of firewood
and across and along them a network of shadows from the bare old
lime trees fell on the snow and on the path. This path led to the
barn. The log walls of the barn and its snow-covered roof, that looked
as if hewn out of some precious stone, sparkled in the moonlight. A
tree in the garden snapped with the frost, and then all was again
perfectly silent. His bosom seemed to inhale not air but the
strength of eternal youth and gladness.

From the back porch came the sound of feet descending the steps, the
bottom step upon which snow had fallen gave a ringing creak and he
heard the voice of an old maidservant saying, "Straight, straight,
along the path, Miss. Only, don't look back."

"I am not afraid," answered Sonya's voice, and along the path toward
Nicholas came the crunching, whistling sound of Sonya's feet in her
thin shoes.

Sonya came along, wrapped in her cloak. She was only a couple of
paces away when she saw him, and to her too he was not the Nicholas
she had known and always slightly feared. He was in a woman's dress,
with tousled hair and a happy smile new to Sonya. She ran rapidly
toward him.

"Quite different and yet the same," thought Nicholas, looking at her
face all lit up by the moonlight. He slipped his arms under the
cloak that covered her head, embraced her, pressed her to him, and
kissed her on the lips that wore a mustache and had a smell of burnt
cork. Sonya kissed him full on the lips, and disengaging her little
hands pressed them to his cheeks.

"Sonya!... Nicholas!"... was all they said. They ran to the barn and
then back again, re-entering, he by the front and she by the back
porch.





CHAPTER XII


When they all drove back from Pelageya Danilovna's, Natasha, who
always saw and noticed everything, arranged that she and Madame Schoss
should go back in the sleigh with Dimmler, and Sonya with Nicholas and
the maids.

On the way back Nicholas drove at a steady pace instead of racing
and kept peering by that fantastic all-transforming light into Sonya's
face and searching beneath the eyebrows and mustache for his former
and his present Sonya from whom he had resolved never to be parted
again. He looked and recognizing in her both the old and the new
Sonya, and being reminded by the smell of burnt cork of the
sensation of her kiss, inhaled the frosty air with a full breast
and, looking at the ground flying beneath him and at the sparkling
sky, felt himself again in fairyland.

"Sonya, is it well with thee?" he asked from time to time.

"Yes!" she replied. "And with thee?"

When halfway home Nicholas handed the reins to the coachman and
ran for a moment to Natasha's sleigh and stood on its wing.

"Natasha!" he whispered in French, "do you know I have made up my
mind about Sonya?"

"Have you told her?" asked Natasha, suddenly beaming all over with
joy.

"Oh, how strange you are with that mustache and those eyebrows!...
Natasha--are you glad?"

"I am so glad, so glad! I was beginning to be vexed with you. I
did not tell you, but you have been treating her badly. What a heart
she has, Nicholas! I am horrid sometimes, but I was ashamed to be
happy while Sonya was not," continued Natasha. "Now I am so glad!
Well, run back to her."

"No, wait a bit.... Oh, how funny you look!" cried Nicholas, peering
into her face and finding in his sister too something new, unusual,
and bewitchingly tender that he had not seen in her before.
"Natasha, it's magical, isn't it?"

"Yes," she replied. "You have done splendidly."

"Had I seen her before as she is now," thought Nicholas, "I should
long ago have asked her what to do and have done whatever she told me,
and all would have been well."

"So you are glad and I have done right?"

"Oh, quite right! I had a quarrel with Mamma some time ago about it.
Mamma said she was angling for you. How could she say such a thing!
I nearly stormed at Mamma. I will never let anyone say anything bad of
Sonya, for there is nothing but good in her."

"Then it's all right?" said Nicholas, again scrutinizing the
expression of his sister's face to see if she was in earnest. Then
he jumped down and, his boots scrunching the snow, ran back to his
sleigh. The same happy, smiling Circassian, with mustache and
beaming eyes looking up from under a sable hood, was still sitting
there, and that Circassian was Sonya, and that Sonya was certainly his
future happy and loving wife.

When they reached home and had told their mother how they had
spent the evening at the Melyukovs', the girls went to their
bedroom. When they had undressed, but without washing off the cork
mustaches, they sat a long time talking of their happiness. They
talked of how they would live when they were married, how their
husbands would be friends, and how happy they would be. On Natasha's
table stood two looking glasses which Dunyasha had prepared
beforehand.

"Only when will all that be? I am afraid never.... It would be too
good!" said Natasha, rising and going to the looking glasses.

"Sit down, Natasha; perhaps you'll see him," said Sonya.

Natasha lit the candles, one on each side of one of the looking
glasses, and sat down.

"I see someone with a mustache," said Natasha, seeing her own face.

"You mustn't laugh, Miss," said Dunyasha.

With Sonya's help and the maid's, Natasha got the glass she held
into the right position opposite the other; her face assumed a serious
expression and she sat silent. She sat a long time looking at the
receding line of candles reflected in the glasses and expecting
(from tales she had heard) to see a coffin, or him, Prince Andrew,
in that last dim, indistinctly outlined square. But ready as she was
to take the smallest speck for the image of a man or of a coffin,
she saw nothing. She began blinking rapidly and moved away from the
looking glasses.

"Why is it others see things and I don't?" she said. "You sit down
now, Sonya. You absolutely must, tonight! Do it for me.... Today I
feel so frightened!"

Sonya sat down before the glasses, got the right position, and began
looking.

"Now, Miss Sonya is sure to see something," whispered Dunyasha;
"while you do nothing but laugh."

Sonya heard this and Natasha's whisper:

"I know she will. She saw something last year."

For about three minutes all were silent.

"Of course she will!" whispered Natasha, but did not finish...
suddenly Sonya pushed away the glass she was holding and covered her
eyes with her hand.

"Oh, Natasha!" she cried.

"Did you see? Did you? What was it?" exclaimed Natasha, holding up
the looking glass.

Sonya had not seen anything, she was just wanting to blink and to
get up when she heard Natasha say, "Of course she will!" She did not
wish to disappoint either Dunyasha or Natasha, but it was hard to
sit still. She did not herself know how or why the exclamation escaped
her when she covered her eyes.

"You saw him?" urged Natasha, seizing her hand.

"Yes. Wait a bit... I... saw him," Sonya could not help saying,
not yet knowing whom Natasha meant by him, Nicholas or Prince Andrew.

"But why shouldn't I say I saw something? Others do see! Besides who
can tell whether I saw anything or not?" flashed through Sonya's mind.

"Yes, I saw him," she said.

"How? Standing or lying?"

"No, I saw... At first there was nothing, then I saw him lying
down."

"Andrew lying? Is he ill?" asked Natasha, her frightened eyes
fixed on her friend.

"No, on the contrary, on the contrary! His face was cheerful, and he
turned to me." And when saying this she herself fancied she had really
seen what she described.

"Well, and then, Sonya?..."

"After that, I could not make out what there was; something blue and
red..."

"Sonya! When will he come back? When shall I see him! O, God, how
afraid I am for him and for myself and about everything!..." Natasha
began, and without replying to Sonya's words of comfort she got into
bed, and long after her candle was out lay open-eyed and motionless,
gazing at the moonlight through the frosty windowpanes.





CHAPTER XIII


Soon after the Christmas holidays Nicholas told his mother of his
love for Sonya and of his firm resolve to marry her. The countess, who
had long noticed what was going on between them and was expecting this
declaration, listened to him in silence and then told her son that
he might marry whom he pleased, but that neither she nor his father
would give their blessing to such a marriage. Nicholas, for the
first time, felt that his mother was displeased with him and that,
despite her love for him, she would not give way. Coldly, without
looking at her son, she sent for her husband and, when he came,
tried briefly and coldly to inform him of the facts, in her son's
presence, but unable to restrain herself she burst into tears of
vexation and left the room. The old count began irresolutely to
admonish Nicholas and beg him to abandon his purpose. Nicholas replied
that he could not go back on his word, and his father, sighing and
evidently disconcerted, very soon became silent and went in to the
countess. In all his encounters with his son, the count was always
conscious of his own guilt toward him for having wasted the family
fortune, and so he could not be angry with him for refusing to marry
an heiress and choosing the dowerless Sonya. On this occasion, he
was only more vividly conscious of the fact that if his affairs had
not been in disorder, no better wife for Nicholas than Sonya could
have been wished for, and that no one but himself with his Mitenka and
his uncomfortable habits was to blame for the condition of the
family finances.

The father and mother did not speak of the matter to their son
again, but a few days later the countess sent for Sonya and, with a
cruelty neither of them expected, reproached her niece for trying to
catch Nicholas and for ingratitude. Sonya listened silently with
downcast eyes to the countess' cruel words, without understanding what
was required of her. She was ready to sacrifice everything for her
benefactors. Self-sacrifice was her most cherished idea but in this
case she could not see what she ought to sacrifice, or for whom. She
could not help loving the countess and the whole Rostov family, but
neither could she help loving Nicholas and knowing that his
happiness depended on that love. She was silent and sad and did not
reply. Nicholas felt the situation to be intolerable and went to
have an explanation with his mother. He first implored her to
forgive him and Sonya and consent to their marriage, then he
threatened that if she molested Sonya he would at once marry her
secretly.

The countess, with a coldness her son had never seen in her
before, replied that he was of age, that Prince Andrew was marrying
without his father's consent, and he could do the same, but that she
would never receive that intriguer as her daughter.

Exploding at the word intriguer, Nicholas, raising his voice, told
his mother he had never expected her to try to force him to sell his
feelings, but if that were so, he would say for the last time....
But he had no time to utter the decisive word which the expression
of his face caused his mother to await with terror, and which would
perhaps have forever remained a cruel memory to them both. He had
not time to say it, for Natasha, with a pale and set face, entered the
room from the door at which she had been listening.

"Nicholas, you are talking nonsense! Be quiet, be quiet, be quiet, I
tell you!..." she almost screamed, so as to drown his voice.

"Mamma darling, it's not at all so... my poor, sweet darling," she
said to her mother, who conscious that they had been on the brink of a
rupture gazed at her son with terror, but in the obstinacy and
excitement of the conflict could not and would not give way.

"Nicholas, I'll explain to you. Go away! Listen, Mamma darling,"
said Natasha.

Her words were incoherent, but they attained the purpose at which
she was aiming.

The countess, sobbing heavily, hid her face on her daughter's
breast, while Nicholas rose, clutching his head, and left the room.

Natasha set to work to effect a reconciliation, and so far succeeded
that Nicholas received a promise from his mother that Sonya should not
be troubled, while he on his side promised not to undertake anything
without his parents' knowledge.

Firmly resolved, after putting his affairs in order in the regiment,
to retire from the army and return and marry Sonya, Nicholas, serious,
sorrowful, and at variance with his parents, but, as it seemed to him,
passionately in love, left at the beginning of January to rejoin his
regiment.

After Nicholas had gone things in the Rostov household were more
depressing than ever, and the countess fell ill from mental agitation.

Sonya was unhappy at the separation from Nicholas and still more
so on account of the hostile tone the countess could not help adopting
toward her. The count was more perturbed than ever by the condition of
his affairs, which called for some decisive action. Their town house
and estate near Moscow had inevitably to be sold, and for this they
had to go to Moscow. But the countess' health obliged them to delay
their departure from day to day.

Natasha, who had borne the first period of separation from her
betrothed lightly and even cheerfully, now grew more agitated and
impatient every day. The thought that her best days, which she would
have employed in loving him, were being vainly wasted, with no
advantage to anyone, tormented her incessantly. His letters for the
most part irritated her. It hurt her to think that while she lived
only in the thought of him, he was living a real life, seeing new
places and new people that interested him. The more interesting his
letters were the more vexed she felt. Her letters to him, far from
giving her any comfort, seemed to her a wearisome and artificial
obligation. She could not write, because she could not conceive the
possibility of expressing sincerely in a letter even a thousandth part
of what she expressed by voice, smile, and glance. She wrote to him
formal, monotonous, and dry letters, to which she attached no
importance herself, and in the rough copies of which the countess
corrected her mistakes in spelling.

There was still no improvement in the countess' health, but it was
impossible to defer the journey to Moscow any longer. Natasha's
trousseau had to be ordered and the house sold. Moreover, Prince
Andrew was expected in Moscow, where old Prince Bolkonski was spending
the winter, and Natasha felt sure he had already arrived.

So the countess remained in the country, and the count, taking Sonya
and Natasha with him, went to Moscow at the end of January.




BOOK EIGHT: 1811 --12





CHAPTER I


After Prince Andrews engagement to Natasha, Pierre without any
apparent cause suddenly felt it impossible to go on living as
before. Firmly convinced as he was of the truths revealed to him by
his benefactor, and happy as he had been in perfecting his inner
man, to which he had devoted himself with such ardor--all the zest
of such a life vanished after the engagement of Andrew and Natasha and
the death of Joseph Alexeevich, the news of which reached him almost
at the same time. Only the skeleton of life remained: his house, a
brilliant wife who now enjoyed the favors of a very important
personage, acquaintance with all Petersburg, and his court service
with its dull formalities. And this life suddenly seemed to Pierre
unexpectedly loathsome. He ceased keeping a diary, avoided the company
of the Brothers, began going to the Club again, drank a great deal,
and came once more in touch with the bachelor sets, leading such a
life that the Countess Helene thought it necessary to speak severely
to him about it. Pierre felt that she right, and to avoid compromising
her went away to Moscow.

In Moscow as soon as he entered his huge house in which the faded
and fading princesses still lived, with its enormous retinue; as
soon as, driving through the town, he saw the Iberian shrine with
innumerable tapers burning before the golden covers of the icons,
the Kremlin Square with its snow undisturbed by vehicles, the sleigh
drivers and hovels of the Sivtsev Vrazhok, those old Moscovites who
desired nothing, hurried nowhere, and were ending their days
leisurely; when he saw those old Moscow ladies, the Moscow balls,
and the English Club, he felt himself at home in a quiet haven. In
Moscow he felt at peace, at home, warm and dirty as in an old dressing
gown.

Moscow society, from the old women down to the children, received
Pierre like a long-expected guest whose place was always ready
awaiting him. For Moscow society Pierre was the nicest, kindest,
most intellectual, merriest, and most magnanimous of cranks, a
heedless, genial nobleman of the old Russian type. His purse was
always empty because it was open to everyone.

Benefit performances, poor pictures, statues, benevolent
societies, gypsy choirs, schools, subscription dinners, sprees,
Freemasons, churches, and books--no one and nothing met with a refusal
from him, and had it not been for two friends who had borrowed large
sums from him and taken him under their protection, he would have
given everything away. There was never a dinner or soiree at the
Club without him. As soon as he sank into his place on the sofa
after two bottles of Margaux he was surrounded, and talking,
disputing, and joking began. When there were quarrels, his kindly
smile and well-timed jests reconciled the antagonists. The Masonic
dinners were dull and dreary when he was not there.

When after a bachelor supper he rose with his amiable and kindly
smile, yielding to the entreaties of the festive company to drive
off somewhere with them, shouts of delight and triumph arose among the
young men. At balls he danced if a partner was needed. Young ladies,
married and unmarried, liked him because without making love to any of
them, he was equally amiable to all, especially after supper. "Il
est charmant; il n'a pas de sexe,"* they said of him.


*"He is charming; he has no sex."


Pierre was one of those retired gentlemen-in-waiting of whom there
were hundreds good-humoredly ending their days in Moscow.

How horrified he would have been seven years before, when he first
arrived from abroad, had he been told that there was no need for him
to seek or plan anything, that his rut had long been shaped, eternally
predetermined, and that wriggle as he might, he would be what all in
his position were. He could not have believed it! Had he not at one
time longed with all his heart to establish a republic in Russia; then
himself to be a Napoleon; then to be a philosopher; and then a
strategist and the conqueror of Napoleon? Had he not seen the
possibility of, and passionately desired, the regeneration of the
sinful human race, and his own progress to the highest degree of
perfection? Had he not established schools and hospitals and liberated
his serfs?

But instead of all that--here he was, the wealthy husband of an
unfaithful wife, a retired gentleman-in-waiting, fond of eating and
drinking and, as he unbuttoned his waistcoat, of abusing the
government a bit, a member of the Moscow English Club, and a universal
favorite in Moscow society. For a long time he could not reconcile
himself to the idea that he was one of those same retired Moscow
gentlemen-in-waiting he had so despised seven years before.

Sometimes he consoled himself with the thought that he was only
living this life temporarily; but then he was shocked by the thought
of how many, like himself, had entered that life and that Club
temporarily, with all their teeth and hair, and had only left it
when not a single tooth or hair remained.

In moments of pride, when he thought of his position it seemed to
him that he was quite different and distinct from those other
retired gentlemen-in-waiting he had formerly despised: they were
empty, stupid, contented fellows, satisfied with their position,
"while I am still discontented and want to do something for mankind.
But perhaps all these comrades of mine struggled just like me and
sought something new, a path in life of their own, and like me were
brought by force of circumstances, society, and race--by that
elemental force against which man is powerless--to the condition I
am in," said he to himself in moments of humility; and after living
some time in Moscow he no longer despised, but began to grow fond
of, to respect, and to pity his comrades in destiny, as he pitied
himself.

Pierre longer suffered moments of despair, hypochondria, and disgust
with life, but the malady that had formerly found expression in such
acute attacks was driven inwards and never left him for a moment.
"What for? Why? What is going on in the world?" he would ask himself
in perplexity several times a day, involuntarily beginning to
reflect anew on the meaning of the phenomena of life; but knowing by
experience that there were no answers to these questions he made haste
to turn away from them, and took up a book, or hurried of to the
Club or to Apollon Nikolaevich's, to exchange the gossip of the town.

"Helene, who has never cared for anything but her own body and is
one of the stupidest women in the world," thought Pierre, "is regarded
by people as the acme of intelligence and refinement, and they pay
homage to her. Napoleon Bonaparte was despised by all as long as he
was great, but now that he has become a wretched comedian the
Emperor Francis wants to offer him his daughter in an illegal
marriage. The Spaniards, through the Catholic clergy, offer praise
to God for their victory over the French on the fourteenth of June,
and the French, also through the Catholic clergy, offer praise because
on that same fourteenth of June they defeated the Spaniards. My
brother Masons swear by the blood that they are ready to sacrifice
everything for their neighbor, but they do not give a ruble each to
the collections for the poor, and they intrigue, the Astraea Lodge
against the Manna Seekers, and fuss about an authentic Scotch carpet
and a charter that nobody needs, and the meaning of which the very man
who wrote it does not understand. We all profess the Christian law
of forgiveness of injuries and love of our neighbors, the law in honor
of which we have built in Moscow forty times forty churches--but
yesterday a deserter was knouted to death and a minister of that
same law of love and forgiveness, a priest, gave the soldier a cross
to kiss before his execution." So thought Pierre, and the whole of
this general deception which everyone accepts, accustomed as he was to
it, astonished him each time as if it were something new. "I
understand the deception and confusion," he thought, "but how am I
to tell them all that I see? I have tried, and have always found
that they too in the depths of their souls understand it as I do,
and only try not to see it. So it appears that it must be so! But I-
what is to become of me?" thought he. He had the unfortunate
capacity many men, especially Russians, have of seeing and believing
in the possibility of goodness and truth, but of seeing the evil and
falsehood of life too clearly to be able to take a serious part in it.
Every sphere of work was connected, in his eyes, with evil and
deception. Whatever he tried to be, whatever he engaged in, the evil
and falsehood of it repulsed him and blocked every path of activity.
Yet he had to live and to find occupation. It was too dreadful to be
under the burden of these insoluble problems, so he abandoned
himself to any distraction in order to forget them. He frequented
every kind of society, drank much, bought pictures, engaged in
building, and above all--read.

He read, and read everything that came to hand. On coming home,
while his valets were still taking off his things, he picked up a book
and began to read. From reading he passed to sleeping, from sleeping
to gossip in drawing rooms of the Club, from gossip to carousals and
women; from carousals back to gossip, reading, and wine. Drinking
became more and more a physical and also a moral necessity. Though the
doctors warned him that with his corpulence wine was dangerous for
him, he drank a great deal. He was only quite at ease when having
poured several glasses of wine mechanically into his large mouth he
felt a pleasant warmth in his body, an amiability toward all his
fellows, and a readiness to respond superficially to every idea
without probing it deeply. Only after emptying a bottle or two did
he feel dimly that the terribly tangled skein of life which previously
had terrified him was not as dreadful as he had thought. He was always
conscious of some aspect of that skein, as with a buzzing in his
head after dinner or supper he chatted or listened to conversation
or read. But under the influence of wine he said to himself: "It
doesn't matter. I'll get it unraveled. I have a solution ready, but
have no time now--I'll think it all out later on!" But the later on
never came.

In the morning, on an empty stomach, all the old questions
appeared as insoluble and terrible as ever, and Pierre hastily
picked up a book, and if anyone came to see him he was glad.

Sometimes he remembered how he had heard that soldiers in war when
entrenched under the enemy's fire, if they have nothing to do, try
hard to find some occupation the more easily to bear the danger. To
Pierre all men seemed like those soldiers, seeking refuge from life:
some in ambition, some in cards, some in framing laws, some in
women, some in toys, some in horses, some in politics, some in
sport, some in wine, and some in governmental affairs. "Nothing is
trivial, and nothing is important, it's all the same--only to save
oneself from it as best one can," thought Pierre. "Only not to see it,
that dreadful it!"





CHAPTER II


At the beginning of winter Prince Nicholas Bolkonski and his
daughter moved to Moscow. At that time enthusiasm for the Emperor
Alexander's regime had weakened and a patriotic and anti-French
tendency prevailed there, and this, together with his past and his
intellect and his originality, at once made Prince Nicholas
Bolkonski an object of particular respect to the Moscovites and the
center of the Moscow opposition to the government.

The prince had aged very much that year. He showed marked signs of
senility by a tendency to fall asleep, forgetfulness of quite recent
events, remembrance of remote ones, and the childish vanity with which
he accepted the role of head of the Moscow opposition. In spite of
this the old man inspired in all his visitors alike a feeling of
respectful veneration--especially of an evening when he came in to tea
in his old-fashioned coat and powdered wig and, aroused by anyone,
told his abrupt stories of the past, or uttered yet more abrupt and
scathing criticisms of the present. For them all, that old-fashioned
house with its gigantic mirrors, pre-Revolution furniture, powdered
footmen, and the stern shrewd old man (himself a relic of the past
century) with his gentle daughter and the pretty Frenchwoman who
were reverently devoted to him presented a majestic and agreeable
spectacle. But the visitors did not reflect that besides the couple of
hours during which they saw their host, there were also twenty-two
hours in the day during which the private and intimate life of the
house continued.

Latterly that private life had become very trying for Princess Mary.
There in Moscow she was deprived of her greatest pleasures--talks with
the pilgrims and the solitude which refreshed her at Bald Hills--and
she had none of the advantages and pleasures of city life. She did not
go out into society; everyone knew that her father would not let her
go anywhere without him, and his failing health prevented his going
out himself, so that she was not invited to dinners and evening
parties. She had quite abandoned the hope of getting married. She
saw the coldness and malevolence with which the old prince received
and dismissed the young men, possible suitors, who sometimes
appeared at their house. She had no friends: during this visit to
Moscow she had been disappointed in the two who had been nearest to
her. Mademoiselle Bourienne, with whom she had never been able to be
quite frank, had now become unpleasant to her, and for various reasons
Princess Mary avoided her. Julie, with whom she had corresponded for
the last five years, was in Moscow, but proved to be quite alien to
her when they met. Just then Julie, who by the death of her brothers
had become one of the richest heiresses in Moscow, was in the full
whirl of society pleasures. She was surrounded by young men who, she
fancied, had suddenly learned to appreciate her worth. Julie was at
that stage in the life of a society woman when she feels that her last
chance of marrying has come and that her fate must be decided now or
never. On Thursdays Princess Mary remembered with a mournful smile
that she now had no one to write to, since Julie--whose presence
gave her no pleasure was here and they met every week. Like the old
emigre who declined to marry the lady with whom he had spent his
evenings for years, she regretted Julie's presence and having no one
to write to. In Moscow Princess Mary had no one to talk to, no one
to whom to confide her sorrow, and much sorrow fell to her lot just
then. The time for Prince Andrew's return and marriage was
approaching, but his request to her to prepare his father for it had
not been carried out; in fact, it seemed as if matters were quite
hopeless, for at every mention of the young Countess Rostova the old
prince (who apart from that was usually in a bad temper) lost
control of himself. Another lately added sorrow arose from the lessons
she gave her six year-old nephew. To her consternation she detected in
herself in relation to little Nicholas some symptoms of her father's
irritability. However often she told herself that she must not get
irritable when teaching her nephew, almost every time that, pointer in
hand, she sat down to show him the French alphabet, she so longed to
pour her own knowledge quickly and easily into the child--who was
already afraid that Auntie might at any moment get angry--that at
his slightest inattention she trembled, became flustered and heated,
raised her voice, and sometimes pulled him by the arm and put him in
the corner. Having put him in the corner she would herself begin to
cry over her cruel, evil nature, and little Nicholas, following her
example, would sob, and without permission would leave his corner,
come to her, pull her wet hands from her face, and comfort her. But
what distressed the princess most of all was her father's
irritability, which was always directed against her and had of late
amounted to cruelty. Had he forced her to prostrate herself to the
ground all night, had he beaten her or made her fetch wood or water,
it would never have entered her mind to think her position hard; but
this loving despot--the more cruel because he loved her and for that
reason tormented himself and her--knew how not merely to hurt and
humiliate her deliberately, but to show her that she was always to
blame for everything. Of late he had exhibited a new trait that
tormented Princess Mary more than anything else; this was his
ever-increasing intimacy with Mademoiselle Bourienne. The idea that at
the first moment of receiving the news of his son's intentions had
occurred to him in jest--that if Andrew got married he himself would
marry Bourienne--had evidently pleased him, and latterly he had
persistently, and as it seemed to Princess Mary merely to offend
her, shown special endearments to the companion and expressed his
dissatisfaction with his daughter by demonstrations of love of
Bourienne.

One day in Moscow in Princess Mary's presence (she thought her
father did it purposely when she was there) the old prince kissed
Mademoiselle Bourienne's hand and, drawing her to him, embraced her
affectionately. Princess Mary flushed and ran out of the room. A few
minutes later Mademoiselle Bourienne came into Princess Mary's room
smiling and making cheerful remarks in her agreeable voice. Princess
Mary hastily wiped away her tears, went resolutely up to
Mademoiselle Bourienne, and evidently unconscious of what she was
doing began shouting in angry haste at the Frenchwoman, her voice
breaking: "It's horrible, vile, inhuman, to take advantage of the
weakness..." She did not finish. "Leave my room," she exclaimed, and
burst into sobs.

Next day the prince did not say a word to his daughter, but she
noticed that at dinner he gave orders that Mademoiselle Bourienne
should be served first. After dinner, when the footman handed coffee
and from habit began with the princess, the prince suddenly grew
furious, threw his stick at Philip, and instantly gave instructions to
have him conscripted for the army.

"He doesn't obey... I said it twice... and he doesn't obey! She is
the first person in this house; she's my best friend," cried the
prince. "And if you allow yourself," he screamed in a fury, addressing
Princess Mary for the first time, "to forget yourself again before her
as you dared to do yesterday, I will show you who is master in this
house. Go! Don't let me set eyes on you; beg her pardon!"

Princess Mary asked Mademoiselle Bourienne's pardon, and also her
father's pardon for herself and for Philip the footman, who had begged
for her intervention.

At such moments something like a pride of sacrifice gathered in
her soul. And suddenly that father whom she had judged would look
for his spectacles in her presence, fumbling near them and not
seeing them, or would forget something that had just occurred, or take
a false step with his failing legs and turn to see if anyone had
noticed his feebleness, or, worst of all, at dinner when there were no
visitors to excite him would suddenly fall asleep, letting his
napkin drop and his shaking head sink over his plate. "He is old and
feeble, and I dare to condemn him!" she thought at such moments,
with a feeling of revulsion against herself.





CHAPTER III


In 1811 there was living in Moscow a French doctor--Metivier--who
had rapidly become the fashion. He was enormously tall, handsome,
amiable as Frenchmen are, and was, as all Moscow said, an
extraordinarily clever doctor. He was received in the best houses
not merely as a doctor, but as an equal.

Prince Nicholas had always ridiculed medicine, but latterly on
Mademoiselle Bourienne's advice had allowed this doctor to visit him
and had grown accustomed to him. Metivier came to see the prince about
twice a week.

On December 6--St. Nicholas' Day and the prince's name day--all
Moscow came to the prince's front door but he gave orders to admit
no one and to invite to dinner only a small number, a list of whom
he gave to Princess Mary.

Metivier, who came in the morning with his felicitations, considered
it proper in his quality of doctor de forcer la consigne,* as he
told Princess Mary, and went in to see the prince. It happened that on
that morning of his name day the prince was in one of his worst moods.
He had been going about the house all the morning finding fault with
everyone and pretending not to understand what was said to him and not
to be understood himself. Princess Mary well knew this mood of quiet
absorbed querulousness, which generally culminated in a burst of rage,
and she went about all that morning as though facing a cocked and
loaded gun and awaited the inevitable explosion. Until the doctor's
arrival the morning had passed off safely. After admitting the doctor,
Princess Mary sat down with a book in the drawing room near the door
through which she could hear all that passed in the study.


*To force the guard.


At first she heard only Metivier's voice, then her father's, then
both voices began speaking at the same time, the door was flung
open, and on the threshold appeared the handsome figure of the
terrified Metivier with his shock of black hair, and the prince in his
dressing gown and fez, his face distorted with fury and the pupils
of his eyes rolled downwards.

"You don't understand?" shouted the prince, "but I do! French spy,
slave of Buonaparte, spy, get out of my house! Be off, I tell you..."

Metivier, shrugging his shoulders, went up to Mademoiselle Bourienne
who at the sound of shouting had run in from an adjoining room.

"The prince is not very well: bile and rush of blood to the head.
Keep calm, I will call again tomorrow," said Metivier; and putting his
fingers to his lips he hastened away.

Through the study door came the sound of slippered feet and the cry:
"Spies, traitors, traitors everywhere! Not a moment's peace in my
own house!"

After Metivier's departure the old prince called his daughter in,
and the whole weight of his wrath fell on her. She was to blame that a
spy had been admitted. Had he not told her, yes, told her to make a
list, and not to admit anyone who was not on that list? Then why was
that scoundrel admitted? She was the cause of it all. With her, he
said, he could not have a moment's peace and could not die quietly.

"No, ma'am! We must part, we must part! Understand that,
understand it! I cannot endure any more," he said, and left the
room. Then, as if afraid she might find some means of consolation,
he returned and trying to appear calm added: "And don't imagine I have
said this in a moment of anger. I am calm. I have thought it over, and
it will be carried out--we must part; so find some place for
yourself...." But he could not restrain himself and with the virulence
of which only one who loves is capable, evidently suffering himself,
he shook his fists at her and screamed:

"If only some fool would marry her!" Then he slammed the door,
sent for Mademoiselle Bourienne, and subsided into his study.

At two o'clock the six chosen guests assembled for dinner.

These guests--the famous Count Rostopchin, Prince Lopukhin with
his nephew, General Chatrov an old war comrade of the prince's, and of
the younger generation Pierre and Boris Drubetskoy--awaited the prince
in the drawing room.

Boris, who had come to Moscow on leave a few days before, had been
anxious to be presented to Prince Nicholas Bolkonski, and had
contrived to ingratiate himself so well that the old prince in his
case made an exception to the rule of not receiving bachelors in his
house.

The prince's house did not belong to what is known as fashionable
society, but his little circle--though not much talked about in
town--was one it was more flattering to be received in than any other.
Boris had realized this the week before when the commander in chief in
his presence invited Rostopchin to dinner on St. Nicholas' Day, and
Rostopchin had replied that he could not come:

"On that day I always go to pay my devotions to the relics of Prince
Nicholas Bolkonski."

"Oh, yes, yes!" replied the commander in chief. "How is he?..."

The small group that assembled before dinner in the lofty
old-fashioned drawing room with its old furniture resembled the solemn
gathering of a court of justice. All were silent or talked in low
tones. Prince Nicholas came in serious and taciturn. Princess Mary
seemed even quieter and more diffident than usual. The guests were
reluctant to address her, feeling that she was in no mood for their
conversation. Count Rostopchin alone kept the conversation going,
now relating the latest town news, and now the latest political
gossip.

Lopukhin and the old general occasionally took part in the
conversation. Prince Bolkonski listened as a presiding judge
receives a report, only now and then, silently or by a brief word,
showing that he took heed of what was being reported to him. The
tone of the conversation was such as indicated that no one approved of
what was being done in the political world. Incidents were related
evidently confirming the opinion that everything was going from bad to
worse, but whether telling a story or giving an opinion the speaker
always stopped, or was stopped, at the point beyond which his
criticism might touch the sovereign himself.

At dinner the talk turned on the latest political news: Napoleon's
seizure of the Duke of Oldenburg's territory, and the Russian Note,
hostile to Napoleon, which had been sent to all the European courts.

"Bonaparte treats Europe as a pirate does a captured vessel," said
Count Rostopchin, repeating a phrase he had uttered several times
before. "One only wonders at the long-suffering or blindness of the
crowned heads. Now the Pope's turn has come and Bonaparte doesn't
scruple to depose the head of the Catholic Church--yet all keep
silent! Our sovereign alone has protested against the seizure of the
Duke of Oldenburg's territory, and even..." Count Rostopchin paused,
feeling that he had reached the limit beyond which censure was
impossible.

"Other territories have been offered in exchange for the Duchy of
Oldenburg," said Prince Bolkonski. "He shifts the Dukes about as I
might move my serfs from Bald Hills to Bogucharovo or my Ryazan
estates."

"The Duke of Oldenburg bears his misfortunes with admirable strength
of character and resignation," remarked Boris, joining in
respectfully.

He said this because on his journey from Petersburg he had had the
honor of being presented to the Duke. Prince Bolkonski glanced at
the young man as if about to say something in reply, but changed his
mind, evidently considering him too young.

"I have read our protests about the Oldenburg affair and was
surprised how badly the Note was worded," remarked Count Rostopchin in
the casual tone of a man dealing with a subject quite familiar to him.

Pierre looked at Rostopchin with naive astonishment, not
understanding why he should be disturbed by the bad composition of the
Note.

"Does it matter, Count, how the Note is worded," he asked, "so
long as its substance is forcible?"

"My dear fellow, with our five hundred thousand troops it should
be easy to have a good style," returned Count Rostopchin.

Pierre now understood the count's dissatisfaction with the wording
of the Note.

"One would have thought quill drivers enough had sprung up,"
remarked the old prince. "There in Petersburg they are always writing-
not notes only but even new laws. My Andrew there has written a
whole volume of laws for Russia. Nowadays they are always writing!"
and he laughed unnaturally.

There was a momentary pause in the conversation; the old general
cleared his throat to draw attention.

"Did you hear of the last event at the review in Petersburg? The
figure cut by the new French ambassador."

"Eh? Yes, I heard something: he said something awkward in His
Majesty's presence."

"His Majesty drew attention to the Grenadier division and to the
march past," continued the general, "and it seems the ambassador
took no notice and allowed himself to reply that: 'We in France pay no
attention to such trifles!' The Emperor did not condescend to reply.
At the next review, they say, the Emperor did not once deign to
address him."

All were silent. On this fact relating to the Emperor personally, it
was impossible to pass any judgment.

"Impudent fellows!" said the prince. "You know Metivier? I turned
him out of my house this morning. He was here; they admitted him spite
of my request that they should let no one in," he went on, glancing
angrily at his daughter.

And he narrated his whole conversation with the French doctor and
the reasons that convinced him that Metivier was a spy. Though these
reasons were very insufficient and obscure, no one made any rejoinder.

After the roast, champagne was served. The guests rose to
congratulate the old prince. Princess Mary, too, went round to him.

He gave her a cold, angry look and offered her his wrinkled,
clean-shaven cheek to kiss. The whole expression of his face told
her that he had not forgotten the morning's talk, that his decision
remained in force, and only the presence of visitors hindered his
speaking of it to her now.

When they went into the drawing room where coffee was served, the
old men sat together.

Prince Nicholas grew more animated and expressed his views on the
impending war.

He said that our wars with Bonaparte would be disastrous so long
as we sought alliances with the Germans and thrust ourselves into
European affairs, into which we had been drawn by the Peace of Tilsit.
"We ought not to fight either for or against Austria. Our political
interests are all in the East, and in regard to Bonaparte the only
thing is to have an armed frontier and a firm policy, and he will
never dare to cross the Russian frontier, as was the case in 1807!"

"How can we fight the French, Prince?" said Count Rostopchin. "Can
we arm ourselves against our teachers and divinities? Look at our
youths, look at our ladies! The French are our Gods: Paris is our
Kingdom of Heaven."

He began speaking louder, evidently to be heard by everyone.

"French dresses, French ideas, French feelings! There now, you
turned Metivier out by the scruff of his neck because he is a
Frenchman and a scoundrel, but our ladies crawl after him on their
knees. I went to a party last night, and there out of five ladies
three were Roman Catholics and had the Pope's indulgence for doing
woolwork on Sundays. And they themselves sit there nearly naked,
like the signboards at our Public Baths if I may say so. Ah, when
one looks at our young people, Prince, one would like to take Peter
the Great's old cudgel out of the museum and belabor them in the
Russian way till all the nonsense jumps out of them."

All were silent. The old prince looked at Rostopchin with a smile
and wagged his head approvingly.

"Well, good-by, your excellency, keep well!" said Rostopchin,
getting up with characteristic briskness and holding out his hand to
the prince.

"Good-by, my dear fellow.... His words are music, I never tire of
hearing him!" said the old prince, keeping hold of the hand and
offering his cheek to be kissed.

Following Rostopchin's example the others also rose.





CHAPTER IV


Princess Mary as she sat listening to the old men's talk and
faultfinding, understood nothing of what she heard; she only
wondered whether the guests had all observed her father's hostile
attitude toward her. She did not even notice the special attentions
and amiabilities shown her during dinner by Boris Drubetskoy, who
was visiting them for the third time already.

Princess Mary turned with absent-minded questioning look to
Pierre, who hat in hand and with a smile on his face was the last of
the guests to approach her after the old prince had gone out and
they were left alone in the drawing room.

"May I stay a little longer?" he said, letting his stout body sink
into an armchair beside her.

"Oh yes," she answered. "You noticed nothing?" her look asked.

Pierre was in an agreeable after-dinner mood. He looked straight
before him and smiled quietly.

"Have you known that young man long, Princess?" he asked.

"Who?"

"Drubetskoy."

"No, not long..."

"Do you like him?"

"Yes, he is an agreeable young man.... Why do you ask me that?" said
Princess Mary, still thinking of that morning's conversation with
her father.

"Because I have noticed that when a young man comes on leave from
Petersburg to Moscow it is usually with the object of marrying an
heiress."

"You have observed that?" said Princess Mary.

"Yes," returned Pierre with a smile, "and this young man now manages
matters so that where there is a wealthy heiress there he is too. I
can read him like a book. At present he is hesitating whom to lay
siege to--you or Mademoiselle Julie Karagina. He is very attentive
to her."

"He visits them?"

"Yes, very often. And do you know the new way of courting?" said
Pierre with an amused smile, evidently in that cheerful mood of good
humored raillery for which he so often reproached himself in his
diary.

"No," replied Princess Mary.

"To please Moscow girls nowadays one has to be melancholy. He is
very melancholy with Mademoiselle Karagina," said Pierre.

"Really?" asked Princess Mary, looking into Pierre's kindly face and
still thinking of her own sorrow. "It would be a relief," thought she,
"if I ventured to confide what I am feeling to someone. I should
like to tell everything to Pierre. He is kind and generous. It would
be a relief. He would give me advice."

"Would you marry him?"

"Oh, my God, Count, there are moments when I would marry anybody!"
she cried suddenly to her own surprise and with tears in her voice.
"Ah, how bitter it is to love someone near to you and to feel that..."
she went on in a trembling voice, "that you can do nothing for him but
grieve him, and to know that you cannot alter this. Then there is only
one thing left--to go away, but where could I go?"

"What is wrong? What is it, Princess?"

But without finishing what she was saying, Princess Mary burst
into tears.

"I don't know what is the matter with me today. Don't take any
notice--forget what I have said!"

Pierre's gaiety vanished completely. He anxiously questioned the
princess, asked her to speak out fully and confide her grief to him;
but she only repeated that she begged him to forget what she had said,
that she did not remember what she had said, and that she had no
trouble except the one he knew of--that Prince Andrew's marriage
threatened to cause a rupture between father and son.

"Have you any news of the Rostovs?" she asked, to change the
subject. "I was told they are coming soon. I am also expecting
Andrew any day. I should like them to meet here."

"And how does he now regard the matter?" asked Pierre, referring
to the old prince.

Princess Mary shook her head.

"What is to be done? In a few months the year will be up. The
thing is impossible. I only wish I could spare my brother the first
moments. I wish they would come sooner. I hope to be friends with her.
You have known them a long time," said Princess Mary. "Tell me
honestly the whole truth: what sort of girl is she, and what do you
think of her?--The real truth, because you know Andrew is risking so
much doing this against his father's will that I should like to
know..."

An undefined instinct told Pierre that these explanations, and
repeated requests to be told the whole truth, expressed ill-will on
the princess' part toward her future sister-in-law and a wish that
he should disapprove of Andrew's choice; but in reply he said what
he felt rather than what he thought.

"I don't know how to answer your question," he said, blushing
without knowing why. "I really don't know what sort of girl she is;
I can't analyze her at all. She is enchanting, but what makes her so I
don't know. That is all one can say about her."

Princess Mary sighed, and the expression on her face said: "Yes,
that's what I expected and feared."

"Is she clever?" she asked.

Pierre considered.

"I think not," he said, "and yet--yes. She does not deign to be
clever.... Oh no, she is simply enchanting, and that is all."

Princess Mary again shook her head disapprovingly.

"Ah, I so long to like her! Tell her so if you see her before I do."

"I hear they are expected very soon," said Pierre.

Princess Mary told Pierre of her plan to become intimate with her
future sister-in-law as soon as the Rostovs arrived and to try to
accustom the old prince to her.





CHAPTER V


Boris had not succeeded in making a wealthy match in Petersburg,
so with the same object in view he came to Moscow. There he wavered
between the two richest heiresses, Julie and Princess Mary. Though
Princess Mary despite her plainness seemed to him more attractive than
Julie, he, without knowing why, felt awkward about paying court to
her. When they had last met on the old prince's name day, she had
answered at random all his attempts to talk sentimentally, evidently
not listening to what he was saying.

Julie on the contrary accepted his attentions readily, though in a
manner peculiar to herself.

She was twenty-seven. After the death of her brothers she had become
very wealthy. She was by now decidedly plain, but thought herself
not merely as good-looking as before but even far more attractive. She
was confirmed in this delusion by the fact that she had become a
very wealthy heiress and also by the fact that the older she grew
the less dangerous she became to men, and the more freely they could
associate with her and avail themselves of her suppers, soirees, and
the animated company that assembled at her house, without incurring
any obligation. A man who would have been afraid ten years before of
going every day to the house when there was a girl of seventeen there,
for fear of compromising her and committing himself, would now go
boldly every day and treat her not as a marriageable girl but as a
sexless acquaintance.

That winter the Karagins' house was the most agreeable and
hospitable in Moscow. In addition to the formal evening and dinner
parties, a large company, chiefly of men, gathered there every day,
supping at midnight and staying till three in the morning. Julie never
missed a ball, a promenade, or a play. Her dresses were always of
the latest fashion. But in spite of that she seemed to be
disillusioned about everything and told everyone that she did not
believe either in friendship or in love, or any of the joys of life,
and expected peace only "yonder." She adopted the tone of one who
has suffered a great disappointment, like a girl who has either lost
the man she loved or been cruelly deceived by him. Though nothing of
the kind had happened to her she was regarded in that light, and had
even herself come to believe that she had suffered much in life.
This melancholy, which did not prevent her amusing herself, did not
hinder the young people who came to her house from passing the time
pleasantly. Every visitor who came to the house paid his tribute to
the melancholy mood of the hostess, and then amused himself with
society gossip, dancing, intellectual games, and bouts rimes, which
were in vogue at the Karagins'. Only a few of these young men, among
them Boris, entered more deeply into Julie's melancholy, and with
these she had prolonged conversations in private on the vanity of
all worldly things, and to them she showed her albums filled with
mournful sketches, maxims, and verses.

To Boris, Julie was particularly gracious: she regretted his early
disillusionment with life, offered him such consolation of
friendship as she who had herself suffered so much could render, and
showed him her album. Boris sketched two trees in the album and wrote:
"Rustic trees, your dark branches shed gloom and melancholy upon me."

On another page he drew a tomb, and wrote:

    La mort est secourable et la mort est tranquille.
    Ah! contre les douleurs il n'y a pas d'autre asile.*


*Death gives relief and death is peaceful.

 Ah! from suffering there is no other refuge.

Julia said this was charming

"There is something so enchanting in the smile of melancholy," she
said to Boris, repeating word for word a passage she had copied from a
book. "It is a ray of light in the darkness, a shade between sadness
and despair, showing the possibility of consolation."

In reply Boris wrote these lines:

    Aliment de poison d'une ame trop sensible,
    Toi, sans qui le bonheur me serait impossible,
    Tendre melancholie, ah, viens me consoler,
    Viens calmer les tourments de ma sombre retraite,
    Et mele une douceur secrete
    A ces pleurs que je sens couler.*


*Poisonous nourishment of a too sensitive soul,

 Thou, without whom happiness would for me be impossible,

 Tender melancholy, ah, come to console me,

 Come to calm the torments of my gloomy retreat,

 And mingle a secret sweetness

 With these tears that I feel to be flowing.


For Boris, Julie played most doleful nocturnes on her harp. Boris
read Poor Liza aloud to her, and more than once interrupted the
reading because of the emotions that choked him. Meeting at large
gatherings Julie and Boris looked on one another as the only souls who
understood one another in a world of indifferent people.

Anna Mikhaylovna, who often visited the Karagins, while playing
cards with the mother made careful inquiries as to Julie's dowry
(she was to have two estates in Penza and the Nizhegorod forests).
Anna Mikhaylovna regarded the refined sadness that united her son to
the wealthy Julie with emotion, and resignation to the Divine will.

"You are always charming and melancholy, my dear Julie," she said to
the daughter. "Boris says his soul finds repose at your house. He
has suffered so many disappointments and is so sensitive," said she to
the mother. "Ah, my dear, I can't tell you how fond I have grown of
Julie latterly," she said to her son. "But who could help loving
her? She is an angelic being! Ah, Boris, Boris!"--she paused. "And how
I pity her mother," she went on; "today she showed me her accounts and
letters from Penza (they have enormous estates there), and she, poor
thing, has no one to help her, and they do cheat her so!"

Boris smiled almost imperceptibly while listening to his mother.
He laughed blandly at her naive diplomacy but listened to what she had
to say, and sometimes questioned her carefully about the Penza and
Nizhegorod estates.

Julie had long been expecting a proposal from her melancholy
adorer and was ready to accept it; but some secret feeling of
repulsion for her, for her passionate desire to get married, for her
artificiality, and a feeling of horror at renouncing the possibility
of real love still restrained Boris. His leave was expiring. He
spent every day and whole days at the Karagins', and every day on
thinking the matter over told himself that he would propose
tomorrow. But in Julie's presence, looking at her red face and chin
(nearly always powdered), her moist eyes, and her expression of
continual readiness to pass at once from melancholy to an unnatural
rapture of married bliss, Boris could not utter the decisive words,
though in imagination he had long regarded himself as the possessor of
those Penza and Nizhegorod estates and had apportioned the use of
the income from them. Julie saw Boris' indecision, and sometimes the
thought occurred to her that she was repulsive to him, but her
feminine self-deception immediately supplied her with consolation, and
she told herself that he was only shy from love. Her melancholy,
however, began to turn to irritability, and not long before Boris'
departure she formed a definite plan of action. Just as Boris' leave
of absence was expiring, Anatole Kuragin made his appearance in
Moscow, and of course in the Karagins' drawing room, and Julie,
suddenly abandoning her melancholy, became cheerful and very attentive
to Kuragin.

"My dear," said Anna Mikhaylovna to her son, "I know from a reliable
source that Prince Vasili has sent his son to Moscow to get him
married to Julie. I am so fond of Julie that I should be sorry for
her. What do you think of it, my dear?"

The idea of being made a fool of and of having thrown away that
whole month of arduous melancholy service to Julie, and of seeing
all the revenue from the Penza estates which he had already mentally
apportioned and put to proper use fall into the hands of another,
and especially into the hands of that idiot Anatole, pained Boris.
He drove to the Karagins' with the firm intention of proposing.
Julie met him in a gay, careless manner, spoke casually of how she had
enjoyed yesterday's ball, and asked when he was leaving. Though
Boris had come intentionally to speak of his love and therefore
meant to be tender, he began speaking irritably of feminine
inconstancy, of how easily women can turn from sadness to joy, and how
their moods depend solely on who happens to be paying court to them.
Julie was offended and replied that it was true that a woman needs
variety, and the same thing over and over again would weary anyone.

"Then I should advise you..." Boris began, wishing to sting her; but
at that instant the galling thought occurred to him that he might have
to leave Moscow without having accomplished his aim, and have vainly
wasted his efforts--which was a thing he never allowed to happen.

He checked himself in the middle of the sentence, lowered his eyes
to avoid seeing her unpleasantly irritated and irresolute face, and
said:

"I did not come here at all to quarrel with you. On the contrary..."

He glanced at her to make sure that he might go on. Her irritability
had suddenly quite vanished, and her anxious, imploring eyes were
fixed on him with greedy expectation. "I can always arrange so as
not to see her often," thought Boris. "The affair has been begun and
must be finished!" He blushed hotly, raised his eyes to hers, and
said:

"You know my feelings for you!"

There was no need to say more: Julie's face shone with triumph and
self-satisfaction; but she forced Boris to say all that is said on
such occasions--that he loved her and had never loved any other
woman more than her. She knew that for the Penza estates and
Nizhegorod forests she could demand this, and she received what she
demanded.

The affianced couple, no longer alluding to trees that shed gloom
and melancholy upon them, planned the arrangements of a splendid house
in Petersburg, paid calls, and prepared everything for a brilliant
wedding.





CHAPTER VI


At the end of January old Count Rostov went to Moscow with Natasha
and Sonya. The countess was still unwell and unable to travel but it
was impossible to wait for her recovery. Prince Andrew was expected in
Moscow any day, the trousseau had to be ordered and the estate near
Moscow had to be sold, besides which the opportunity of presenting his
future daughter-in-law to old Prince Bolkonski while he was in
Moscow could not be missed. The Rostovs' Moscow house had not been
heated that winter and, as they had come only for a short time and the
countess was not with them, the count decided to stay with Marya
Dmitrievna Akhrosimova, who had long been pressing her hospitality
on them.

Late one evening the Rostovs' four sleighs drove into Marya
Dmitrievna's courtyard in the old Konyusheny street. Marya
Dmitrievna lived alone. She had already married off her daughter,
and her sons were all in the service.

She held herself as erect, told everyone her opinion as candidly,
loudly, and bluntly as ever, and her whole bearing seemed a reproach
to others for any weakness, passion, or temptation--the possibility of
which she did not admit. From early in the morning, wearing a dressing
jacket, she attended to her household affairs, and then she drove out:
on holy days to church and after the service to jails and prisons on
affairs of which she never spoke to anyone. On ordinary days, after
dressing, she received petitioners of various classes, of whom there
were always some. Then she had dinner, a substantial and appetizing
meal at which there were always three or four guests; after dinner she
played a game of boston, and at night she had the newspapers or a
new book read to her while she knitted. She rarely made an exception
and went out to pay visits, and then only to the most important
persons in the town.

She had not yet gone to bed when the Rostovs arrived and the
pulley of the hall door squeaked from the cold as it let in the
Rostovs and their servants. Marya Dmitrievna, with her spectacles
hanging down on her nose and her head flung back, stood in the hall
doorway looking with a stern, grim face at the new arrivals. One might
have thought she was angry with the travelers and would immediately
turn them out, had she not at the same time been giving careful
instructions to the servants for the accommodation of the visitors and
their belongings.

"The count's things? Bring them here," she said, pointing to the
portmanteaus and not greeting anyone. "The young ladies'? There to the
left. Now what are you dawdling for?" she cried to the maids. "Get the
samovar ready!... You've grown plumper and prettier," she remarked,
drawing Natasha (whose cheeks were glowing from the cold) to her by
the hood. "Foo! You are cold! Now take off your things, quick!" she
shouted to the count who was going to kiss her hand. "You're half
frozen, I'm sure! Bring some rum for tea!... Bonjour, Sonya dear!" she
added, turning to Sonya and indicating by this French greeting her
slightly contemptuous though affectionate attitude toward her.

When they came in to tea, having taken off their outdoor things
and tidied themselves up after their journey, Marya Dmitrievna
kissed them all in due order.

"I'm heartily glad you have come and are staying with me. It was
high time," she said, giving Natasha a significant look. "The old
man is here and his son's expected any day. You'll have to make his
acquaintance. But we'll speak of that later on," she added, glancing at
Sonya with a look that showed she did not want to speak of it in her
presence. "Now listen," she said to the count. "What do you want
tomorrow? Whom will you send for? Shinshin?" she crooked one of her
fingers. "The sniveling Anna Mikhaylovna? That's two. She's here
with her son. The son is getting married! Then Bezukhov, eh? He is
here too, with his wife. He ran away from her and she came galloping
after him. He dined with me on Wednesday. As for them"--and she
pointed to the girls--"tomorrow I'll take them first to the Iberian
shrine of the Mother of God, and then we'll drive to the
Super-Rogue's. I suppose you'll have everything new. Don't judge by
me: sleeves nowadays are this size! The other day young Princess Irina
Vasilevna came to see me; she was an awful sight--looked as if she had
put two barrels on her arms. You know not a day passes now without
some new fashion.... And what have you to do yourself?" she asked
the count sternly.

"One thing has come on top of another: her rags to buy, and now a
purchaser has turned up for the Moscow estate and for the house. If
you will be so kind, I'll fix a time and go down to the estate just
for a day, and leave my lassies with you."

"All right. All right. They'll be safe with me, as safe as in
Chancery! I'll take them where they must go, scold them a bit, and pet
them a bit," said Marya Dmitrievna, touching her goddaughter and
favorite, Natasha, on the cheek with her large hand.

Next morning Marya Dmitrievna took the young ladies to the Iberian
shrine of the Mother of God and to Madame Suppert-Roguet, who was so
afraid of Marya Dmitrievna that she always let her have costumes at
a loss merely to get rid of her. Marya Dmitrievna ordered almost the
whole trousseau. When they got home she turned everybody out of the
room except Nataisha, and then called her pet to her armchair.

"Well, now we'll talk. I congratulate you on your betrothed.
You've hooked a fine fellow! I am glad for your sake and I've known
him since he was so high." She held her hand a couple of feet from the
ground. Natasha blushed happily. "I like him and all his family. Now
listen! You know that old Prince Nicholas much dislikes his son's
marrying. The old fellow's crotchety! Of course Prince Andrew is not a
child and can shift without him, but it's not nice to enter a family
against a father's will. One wants to do it peacefully and lovingly.
You're a clever girl and you'll know how to manage. Be kind, and use
your wits. Then all will be well."

Natasha remained silent, from shyness Marya Dmitrievna supposed, but
really because she disliked anyone interfering in what touched her
love of Prince Andrew, which seemed to her so apart from all human
affairs that no one could understand it. She loved and knew Prince
Andrew, he loved her only, and was to come one of these days and
take her. She wanted nothing more.

"You see I have known him a long time and am also fond of Mary, your
future sister-in-law. 'Husbands' sisters bring up blisters,' but
this one wouldn't hurt a fly. She has asked me to bring you two
together. Tomorrow you'll go with your father to see her. Be very nice
and affectionate to her: you're younger than she. When he comes, he'll
find you already know his sister and father and are liked by them.
Am I right or not? Won't that be best?"

"Yes, it will," Natasha answered reluctantly.





CHAPTER VII


Next day, by Marya Dmitrievna's advice, Count Rostov took Natasha to
call on Prince Nicholas Bolkonski. The count did not set out
cheerfully on this visit, at heart he felt afraid. He well
remembered the last interview he had had with the old prince at the
time of the enrollment, when in reply to an invitation to dinner he
had had to listen to an angry reprimand for not having provided his
full quota of men. Natasha, on the other hand, having put on her
best gown, was in the highest spirits. "They can't help liking me,"
she thought. "Everybody always has liked me, and I am so willing to do
anything they wish, so ready to be fond of him--for being his
father--and of her--for being his sister--that there is no reason
for them not to like me..."

They drove up to the gloomy old house on the Vozdvizhenka and
entered the vestibule.

"Well, the Lord have mercy on us!" said the count, half in jest,
half in earnest; but Natasha noticed that her father was flurried on
entering the anteroom and inquired timidly and softly whether the
prince and princess were at home.

When they had been announced a perturbation was noticeable among the
servants. The footman who had gone to announce them was stopped by
another in the large hall and they whispered to one another. Then a
maidservant ran into the hall and hurriedly said something, mentioning
the princess. At last an old, cross looking footman came and announced
to the Rostovs that the prince was not receiving, but that the
princess begged them to walk up. The first person who came to meet the
visitors was Mademoiselle Bourienne. She greeted the father and
daughter with special politeness and showed them to the princess'
room. The princess, looking excited and nervous, her face flushed in
patches, ran in to meet the visitors, treading heavily, and vainly
trying to appear cordial and at ease. From the first glance Princess
Mary did not like Natasha. She thought her too fashionably dressed,
frivolously gay and vain. She did not at all realize that before
having seen her future sister-in-law she was prejudiced against her by
involuntary envy of her beauty, youth, and happiness, as well as by
jealousy of her brother's love for her. Apart from this insuperable
antipathy to her, Princess Mary was agitated just then because on
the Rostovs' being announced, the old prince had shouted that he did
not wish to see them, that Princess Mary might do so if she chose, but
they were not to be admitted to him. She had decided to receive
them, but feared lest the prince might at any moment indulge in some
freak, as he seemed much upset by the Rostovs' visit.

"There, my dear princess, I've brought you my songstress," said
the count, bowing and looking round uneasily as if afraid the old
prince might appear. "I am so glad you should get to know one
another... very sorry the prince is still ailing," and after a few
more commonplace remarks he rose. "If you'll allow me to leave my
Natasha in your hands for a quarter of an hour, Princess, I'll drive
round to see Anna Semenovna, it's quite near in the Dogs' Square,
and then I'll come back for her."

The count had devised this diplomatic ruse (as he afterwards told
his daughter) to give the future sisters-in-law an opportunity to talk
to one another freely, but another motive was to avoid the danger of
encountering the old prince, of whom he was afraid. He did not mention
this to his daughter, but Natasha noticed her father's nervousness and
anxiety and felt mortified by it. She blushed for him, grew still
angrier at having blushed, and looked at the princess with a bold
and defiant expression which said that she was not afraid of
anybody. The princess told the count that she would be delighted,
and only begged him to stay longer at Anna Semenovna's, and he
departed.

Despite the uneasy glances thrown at her by Princess Mary--who
wished to have a tete-a-tete with Natasha--Mademoiselle Bourienne
remained in the room and persistently talked about Moscow amusements
and theaters. Natasha felt offended by the hesitation she had
noticed in the anteroom, by her father's nervousness, and by the
unnatural manner of the princess who--she thought--was making a
favor of receiving her, and so everything displeased her. She did
not like Princess Mary, whom she thought very plain, affected, and
dry. Natasha suddenly shrank into herself and involuntarily assumed an
offhand air which alienated Princess Mary still more. After five
minutes of irksome, constrained conversation, they heard the sound
of slippered feet rapidly approaching. Princess Mary looked
frightened.

The door opened and the old prince, in a dress, ing gown and a white
nightcap, came in.

"Ah, madam!" he began. "Madam, Countess... Countess Rostova, if I am
not mistaken... I beg you to excuse me, to excuse me... I did not
know, madam. God is my witness, I did not know you had honored us with
a visit, and I came in such a costume only to see my daughter. I beg
you to excuse me... God is my witness, I didn't know-" he repeated,
stressing the word "God" so unnaturally and so unpleasantly that
Princess Mary stood with downcast eyes not daring to look either at
her father or at Natasha.

Nor did the latter, having risen and curtsied, know what to do.
Mademoiselle Bourienne alone smiled agreeably.

"I beg you to excuse me, excuse me! God is my witness, I did not
know," muttered the old man, and after looking Natasha over from
head to foot he went out.

Mademoiselle Bourienne was the first to recover herself after this
apparition and began speaking about the prince's indisposition.
Natasha and Princess Mary looked at one another in silence, and the
longer they did so without saying what they wanted to say, the greater
grew their antipathy to one another.

When the count returned, Natasha was impolitely pleased and hastened
to get away: at that moment she hated the stiff, elderly princess, who
could place her in such an embarrassing position and had spent half an
hour with her without once mentioning Prince Andrew. "I couldn't begin
talking about him in the presence of that Frenchwoman," thought
Natasha. The same thought was meanwhile tormenting Princess Mary.
She knew what she ought to have said to Natasha, but she had been
unable to say it because Mademoiselle Bourienne was in the way, and
because, without knowing why, she felt it very difficult to speak of
the marriage. When the count was already leaving the room, Princess
Mary went up hurriedly to Natasha, took her by the hand, and said with
a deep sigh:

"Wait, I must..."

Natasha glanced at her ironically without knowing why.

"Dear Natalie," said Princess Mary, "I want you to know that I am
glad my brother has found happiness...."

She paused, feeling that she was not telling the truth. Natasha
noticed this and guessed its reason.

"I think, Princess, it is not convenient to speak of that now,"
she said with external dignity and coldness, though she felt the tears
choking her.

"What have I said and what have I done?" thought she, as soon as she
was out of the room.

They waited a long time for Natasha to come to dinner that day.
She sat in her room crying like a child, blowing her nose and sobbing.
Sonya stood beside her, kissing her hair.

"Natasha, what is it about?" she asked. "What do they matter to you?
It will all pass, Natasha."

"But if you only knew how offensive it was... as if I..."

"Don't talk about it, Natasha. It wasn't your fault so why should
you mind? Kiss me," said Sonya.

Natasha raised her head and, kissing her friend on the lips, pressed
her wet face against her.

"I can't tell you, I don't know. No one's to blame," said Natasha-
"It's my fault. But it all hurts terribly. Oh, why doesn't he
come?..."

She came in to dinner with red eyes. Marya Dmitrievna, who knew
how the prince had received the Rostovs, pretended not to notice how
upset Natasha was and jested resolutely and loudly at table with the
count and the other guests.





CHAPTER VIII


That evening the Rostovs went to the Opera, for which Marya
Dmitrievna had taken a box.

Natasha did not want to go, but could not refuse Marya
Dmitrievna's kind offer which was intended expressly for her. When she
came ready dressed into the ballroom to await her father, and
looking in the large mirror there saw that she was pretty, very
pretty, she felt even more sad, but it was a sweet, tender sadness.

"O God, if he were here now I would not behave as I did then, but
differently. I would not be silly and afraid of things, I would simply
embrace him, cling to him, and make him look at me with those
searching inquiring eyes with which he has so often looked at me,
and then I would make him laugh as he used to laugh. And his eyes--how
I see those eyes!" thought Natasha. "And what do his father and sister
matter to me? I love him alone, him, him, with that face and those
eyes, with his smile, manly and yet childlike.... No, I had better not
think of him; not think of him but forget him, quite forget him for
the present. I can't bear this waiting and I shall cry in a minute!"
and she turned away from the glass, making an effort not to cry.
"And how can Sonya love Nicholas so calmly and quietly and wait so
long and so patiently?" thought she, looking at Sonya, who also came
in quite ready, with a fan in her hand. "No, she's altogether
different. I can't!"

Natasha at that moment felt so softened and tender that it was not
enough for her to love and know she was beloved, she wanted now, at
once, to embrace the man she loved, to speak and hear from him words
of love such as filled her heart. While she sat in the carriage beside
her father, pensively watching the lights of the street lamps
flickering on the frozen window, she felt still sadder and more in
love, and forgot where she was going and with whom. Having fallen into
the line of carriages, the Rostovs' carriage drove up to the
theater, its wheels squeaking over the snow. Natasha and Sonya,
holding up their dresses, jumped out quickly. The count got out helped
by the footmen, and, passing among men and women who were entering and
the program sellers, they all three went along the corridor to the
first row of boxes. Through the closed doors the music was already
audible.

"Natasha, your hair!..." whispered Sonya.

An attendant deferentially and quickly slipped before the ladies and
opened the door of their box. The music sounded louder and through the
door rows of brightly lit boxes in which ladies sat with bare arms and
shoulders, and noisy stalls brilliant with uniforms, glittered
before their eyes. A lady entering the next box shot a glance of
feminine envy at Natasha. The curtain had not yet risen and the
overture was being played. Natasha, smoothing her gown, went in with
Sonya and sat down, scanning the brilliant tiers of boxes opposite.
A sensation she had not experienced for a long time--that of
hundreds of eyes looking at her bare arms and neck--suddenly
affected her both agreeably and disagreeably and called up a whole
crowd of memories, desires and emotions associated with that feeling.

The two remarkably pretty girls, Natasha and Sonya, with Count
Rostov who had not been seen in Moscow for a long time, attracted
general attention. Moreover, everybody knew vaguely of Natasha's
engagement to Prince Andrew, and knew that the Rostovs had lived in
the country ever since, and all looked with curiosity at a fiancee who
was making one of the best matches in Russia.

Natasha's looks, as everyone told her, had improved in the
country, and that evening thanks to her agitation she was particularly
pretty. She struck those who saw her by her fullness of life and
beauty, combined with her indifference to everything about her. Her
black eyes looked at the crowd without seeking anyone, and her
delicate arm, bare to above the elbow, lay on the velvet edge of the
box, while, evidently unconsciously, she opened and closed her hand in
time to the music, crumpling her program. "Look, there's Alenina,"
said Sonya, "with her mother, isn't it?"

"Dear me, Michael Kirilovich has grown still stouter!" remarked
the count.

"Look at our Anna Mikhaylovna--what a headdress she has on!"

"The Karagins, Julie--and Boris with them. One can see at once
that they're engaged...."

"Drubetskoy has proposed?"

"Oh yes, I heard it today," said Shinshin, coming into the
Rostovs' box.

Natasha looked in the direction in which her father's eyes were
turned and saw Julie sitting beside her mother with a happy look on
her face and a string of pearls round her thick red neck--which
Natasha knew was covered with powder. Behind them, wearing a smile and
leaning over with an ear to Julie's mouth, was Boris' handsome
smoothly brushed head. He looked the Rostovs from under his brows
and said something, smiling, to his betrothed.

"They are talking about us, about me and him!" thought Natasha. "And
he no doubt is calming her jealousy of me. They needn't trouble
themselves! If only they knew how little I am concerned about any of
them."

Behind them sat Anna Mikhaylovna wearing a green headdress and
with a happy look of resignation to the will of God on her face. Their
box was pervaded by that atmosphere of an affianced couple which
Natasha knew so well and liked so much. She turned away and suddenly
remembered all that had been so humiliating in her morning's visit.

"What right has he not to wish to receive me into his family? Oh,
better not think of it--not till he comes back!" she told herself, and
began looking at the faces, some strange and some familiar, in the
stalls. In the front, in the very center, leaning back against the
orchestra rail, stood Dolokhov in a Persian dress, his curly hair
brushed up into a huge shock. He stood in full view of the audience,
well aware that he was attracting everyone's attention, yet as much at
ease as though he were in his own room. Around him thronged Moscow's
most brilliant young men, whom he evidently dominated.

The count, laughing, nudged the blushing Sonya and pointed to her
former adorer.

"Do you recognize him?" said he. "And where has he sprung from?"
he asked, turning to Shinshin. "Didn't he vanish somewhere?"

"He did," replied Shinshin. "He was in the Caucasus and ran away
from there. They say he has been acting as minister to some ruling
prince in Persia, where he killed the Shah's brother. Now all the
Moscow ladies are mad about him! It's 'Dolokhov the Persian' that does
it! We never hear a word but Dolokhov is mentioned. They swear by him,
they offer him to you as they would a dish of choice sterlet. Dolokhov
and Anatole Kuragin have turned all our ladies' heads."

A tall, beautiful woman with a mass of plaited hair and much exposed
plump white shoulders and neck, round which she wore a double string
of large pearls, entered the adjoining box rustling her heavy silk
dress and took a long time settling into her place.

Natasha involuntarily gazed at that neck, those shoulders, and
pearls and coiffure, and admired the beauty of the shoulders and the
pearls. While Natasha was fixing her gaze on her for the second time
the lady looked round and, meeting the count's eyes, nodded to him and
smiled. She was the Countess Bezukhova, Pierre's wife, and the
count, who knew everyone in society, leaned over and spoke to her.

"Have you been here long, Countess?" he inquired. "I'll call, I'll
call to kiss your hand. I'm here on business and have brought my girls
with me. They say Semenova acts marvelously. Count Pierre never used
to forget us. Is he here?"

"Yes, he meant to look in," answered Helene, and glanced attentively
at Natasha.

Count Rostov resumed his seat.

"Handsome, isn't she?" he whispered to Natasha.

"Wonderful!" answered Natasha. "She's a woman one could easily
fall in love with."

Just then the last chords of the overture were heard and the
conductor tapped with his stick. Some latecomers took their seats in
the stalls, and the curtain rose.

As soon as it rose everyone in the boxes and stalls became silent,
and all the men, old and young, in uniform and evening dress, and
all the women with gems on their bare flesh, turned their whole
attention with eager curiosity to the stage. Natasha too began to look
at it.





CHAPTER IX


The floor of the stage consisted of smooth boards, at the sides
was some painted cardboard representing trees, and at the back was a
cloth stretched over boards. In the center of the stage sat some girls
in red bodices and white skirts. One very fat girl in a white silk
dress sat apart on a low bench, to the back of which a piece of
green cardboard was glued. They all sang something. When they had
finished their song the girl in white went up to the prompter's box
and a man with tight silk trousers over his stout legs, and holding
a plume and a dagger, went up to her and began singing, waving his
arms about.

First the man in the tight trousers sang alone, then she sang,
then they both paused while the orchestra played and the man
fingered the hand of the girl in white, obviously awaiting the beat to
start singing with her. They sang together and everyone in the theater
began clapping and shouting, while the man and woman on the stage--who
represented lovers--began smiling, spreading out their arms, and
bowing.

After her life in the country, and in her present serious mood,
all this seemed grotesque and amazing to Natasha. She could not follow
the opera nor even listen to the music; she saw only the painted
cardboard and the queerly dressed men and women who moved, spoke,
and sang so strangely in that brilliant light. She knew what it was
all meant to represent, but it was so pretentiously false and
unnatural that she first felt ashamed for the actors and then amused
at them. She looked at the faces of the audience, seeking in them
the same sense of ridicule and perplexity she herself experienced, but
they all seemed attentive to what was happening on the stage, and
expressed delight which to Natasha seemed feigned. "I suppose it has
to be like this!" she thought. She kept looking round in turn at the
rows of pomaded heads in the stalls and then at the seminude women
in the boxes, especially at Helene in the next box, who--apparently
quite unclothed--sat with a quiet tranquil smile, not taking her
eyes off the stage. And feeling the bright light that flooded the
whole place and the warm air heated by the crowd, Natasha little by
little began to pass into a state of intoxication she had not
experienced for a long while. She did not realize who and where she
was, nor what was going on before her. As she looked and thought,
the strangest fancies unexpectedly and disconnectedly passed through
her mind: the idea occurred to her of jumping onto the edge of the box
and singing the air the actress was singing, then she wished to
touch with her fan an old gentleman sitting not far from her, then
to lean over to Helene and tickle her.

At a moment when all was quiet before the commencement of a song,
a door leading to the stalls on the side nearest the Rostovs' box
creaked, and the steps of a belated arrival were heard. "There's
Kuragin!" whispered Shinshin. Countess Bezukhova turned smiling to the
newcomer, and Natasha, following the direction of that look, saw an
exceptionally handsome adjutant approaching their box with a
self-assured yet courteous bearing. This was Anatole Kuragin whom
she had seen and noticed long ago at the ball in Petersburg. He was
now in an adjutant's uniform with one epaulet and a shoulder knot.
He moved with a restrained swagger which would have been ridiculous
had he not been so good-looking and had his handsome face not worn
such an expression of good-humored complacency and gaiety. Though
the performance was proceeding, he walked deliberately down the
carpeted gangway, his sword and spurs slightly jingling and his
handsome perfumed head held high. Having looked at Natasha he
approached his sister, laid his well gloved hand on the edge of her
box, nodded to her, and leaning forward asked a question, with a
motion toward Natasha.

"Mais charmante!" said he, evidently referring to Natasha, who did
not exactly hear his words but understood them from the movement of
his lips. Then he took his place in the first row of the stalls and
sat down beside Dolokhov, nudging with his elbow in a friendly and
offhand way that Dolokhov whom others treated so fawningly. He
winked at him gaily, smiled, and rested his foot against the orchestra
screen.

"How like the brother is to the sister," remarked the count. "And
how handsome they both are!"

Shinshin, lowering his voice, began to tell the count of some
intrigue of Kuragin's in Moscow, and Natasha tried to overhear it just
because he had said she was "charmante."

The first act was over. In the stalls everyone began moving about,
going out and coming in.

Boris came to the Rostovs' box, received their congratulations
very simply, and raising his eyebrows with an absent-minded smile
conveyed to Natasha and Sonya his fiancee's invitation to her wedding,
and went away. Natasha with a gay, coquettish smile talked to him, and
congratulated on his approaching wedding that same Boris with whom she
had formerly been in love. In the state of intoxication she was in,
everything seemed simple and natural.

The scantily clad Helene smiled at everyone in the same way, and
Natasha gave Boris a similar smile.

Helene's box was filled and surrounded from the stalls by the most
distinguished and intellectual men, who seemed to vie with one another
in their wish to let everyone see that they knew her.

During the whole of that entr'acte Kuragin stood with Dolokhov in
front of the orchestra partition, looking at the Rostovs' box. Natasha
knew he was talking about her and this afforded her pleasure. She even
turned so that he should see her profile in what she thought was its
most becoming aspect. Before the beginning of the second act Pierre
appeared in the stalls. The Rostovs had not seen him since their
arrival. His face looked sad, and he had grown still stouter since
Natasha last saw him. He passed up to the front rows, not noticing
anyone. Anatole went up to him and began speaking to him, looking at
and indicating the Rostovs' box. On seeing Natasha Pierre grew
animated and, hastily passing between the rows, came toward their box.
When he got there he leaned on his elbows and, smiling, talked to
her for a long time. While conversing with Pierre, Natasha heard a
man's voice in Countess Bezukhova's box and something told her it
was Kuragin. She turned and their eyes met. Almost smiling, he gazed
straight into her eyes with such an enraptured caressing look that
it seemed strange to be so near him, to look at him like that, to be
so sure he admired her, and not to be acquainted with him.

In the second act there was scenery representing tombstones, there
was a round hole in the canvas to represent the moon, shades were
raised over the footlights, and from horns and contrabass came deep
notes while many people appeared from right and left wearing black
cloaks and holding things like daggers in their hands. They began
waving their arms. Then some other people ran in and began dragging
away the maiden who had been in white and was now in light blue.
They did not drag her away at once, but sang with her for a long
time and then at last dragged her off, and behind the scenes something
metallic was struck three times and everyone knelt down and sang a
prayer. All these things were repeatedly interrupted by the
enthusiastic shouts of the audience.

During this act every time Natasha looked toward the stalls she
saw Anatole Kuragin with an arm thrown across the back of his chair,
staring at her. She was pleased to see that he was captivated by her
and it did not occur to her that there was anything wrong in it.

When the second act was over Countess Bezukhova rose, turned to
the Rostovs' box--her whole bosom completely exposed--beckoned the old
count with a gloved finger, and paying no attention to those who had
entered her box began talking to him with an amiable smile.

"Do make me acquainted with your charming daughters," said she. "The
whole town is singing their praises and I don't even know then!"

Natasha rose and curtsied to the splendid countess. She was so
pleased by praise from this brilliant beauty that she blushed with
pleasure.

"I want to become a Moscovite too, now," said Helene. "How is it
you're not ashamed to bury such pearls in the country?"

Countess Bezukhova quite deserved her reputation of being a
fascinating woman. She could say what she did not think--especially
what was flattering--quite simply and naturally.

"Dear count, you must let me look after your daughters! Though I
am not staying here long this time--nor are you--I will try to amuse
them. I have already heard much of you in Petersburg and wanted to get
to know you," said she to Natasha with her stereotyped and lovely
smile. "I had heard about you from my page, Drubetskoy. Have you heard
he is getting married? And also from my husband's friend Bolkonski,
Prince Andrew Bolkonski," she went on with special emphasis,
implying that she knew of his relation to Natasha. To get better
acquainted she asked that one of the young ladies should come into her
box for the rest of the performance, and Natasha moved over to it.

The scene of the third act represented a palace in which many
candles were burning and pictures of knights with short beards hung on
the walls. In the middle stood what were probably a king and a
queen. The king waved his right arm and, evidently nervous, sang
something badly and sat down on a crimson throne. The maiden who had
been first in white and then in light blue, now wore only a smock, and
stood beside the throne with her hair down. She sang something
mournfully, addressing the queen, but the king waved his arm severely,
and men and women with bare legs came in from both sides and began
dancing all together. Then the violins played very shrilly and merrily
and one of the women with thick bare legs and thin arms, separating
from the others, went behind the wings, adjusted her bodice,
returned to the middle of the stage, and began jumping and striking
one foot rapidly against the other. In the stalls everyone clapped and
shouted "bravo!" Then one of the men went into a corner of the
stage. The cymbals and horns in the orchestra struck up more loudly,
and this man with bare legs jumped very high and waved his feet
about very rapidly. (He was Duport, who received sixty thousand rubles
a year for this art.) Everybody in the stalls, boxes, and galleries
began clapping and shouting with all their might, and the man
stopped and began smiling and bowing to all sides. Then other men
and women danced with bare legs. Then the king again shouted to the
sound of music, and they all began singing. But suddenly a storm
came on, chromatic scales and diminished sevenths were heard in the
orchestra, everyone ran off, again dragging one of their number
away, and the curtain dropped. Once more there was a terrible noise
and clatter among the audience, and with rapturous faces everyone
began shouting: "Duport! Duport! Duport!" Natasha no longer thought
this strange. She look about with pleasure, smiling joyfully.

"Isn't Duport delightful?" Helene asked her.

"Oh, yes," replied Natasha.





CHAPTER X


During the entr'acte a whiff of cold air came into Helene's box, the
door opened, and Anatole entered, stooping and trying not to brush
against anyone.

"Let me introduce my brother to you," said Helene, her eyes shifting
uneasily from Natasha to Anatole.

Natasha turned her pretty little head toward the elegant young
officer and smiled at him over her bare shoulder. Anatole, who was
as handsome at close quarters as at a distance, sat down beside her
and told her he had long wished to have this happiness--ever since the
Naryshkins' ball in fact, at which he had had the well-remembered
pleasure of seeing her. Kuragin was much more sensible and simple with
women than among men. He talked boldly and naturally, and Natasha
was strangely and agreeably struck by the fact that there was
nothing formidable in this man about whom there was so much talk,
but that on the contrary his smile was most naive, cheerful, and
good-natured.

Kuragin asked her opinion of the performance and told her how at a
previous performance Semenova had fallen down on the stage.

"And do you know, Countess," he said, suddenly addressing her as
an old, familiar acquaintance, "we are getting up a costume
tournament; you ought to take part in it! It will be great fun. We
shall all meet at the Karagins'! Please come! No! Really, eh?" said
he.

While saying this he never removed his smiling eyes from her face,
her neck, and her bare arms. Natasha knew for certain that he was
enraptured by her. This pleased her, yet his presence made her feel
constrained and oppressed. When she was not looking at him she felt
that he was looking at her shoulders, and she involuntarily caught his
eye so that he should look into hers rather than this. But looking
into his eyes she was frightened, realizing that there was not that
barrier of modesty she had always felt between herself and other
men. She did not know how it was that within five minutes she had come
to feel herself terribly near to this man. When she turned away she
feared he might seize her from behind by her bare arm and kiss her
on the neck. They spoke of most ordinary things, yet she felt that
they were closer to one another than she had ever been to any man.
Natasha kept turning to Helene and to her father, as if asking what it
all meant, but Helene was engaged in conversation with a general and
did not answer her look, and her father's eyes said nothing but what
they always said: "Having a good time? Well, I'm glad of it!"

During one of these moments of awkward silence when Anatole's
prominent eyes were gazing calmly and fixedly at her, Natasha, to
break the silence, asked him how he liked Moscow. She asked the
question and blushed. She felt all the time that by talking to him she
was doing something improper. Anatole smiled as though to encourage
her.

"At first I did not like it much, because what makes a town pleasant
ce sont les jolies femmes,* isn't that so? But now I like it very much
indeed," he said, looking at her significantly. "You'll come to the
costume tournament, Countess? Do come!" and putting out his hand to
her bouquet and dropping his voice, he added, "You will be the
prettiest there. Do come, dear countess, and give me this flower as
a pledge!"


*Are the pretty women.


Natasha did not understand what he was saying any more than he did
himself, but she felt that his incomprehensible words had an
improper intention. She did not know what to say and turned away as if
she had not heard his remark. But as soon as she had turned away she
felt that he was there, behind, so close behind her.

"How is he now? Confused? Angry? Ought I to put it right?" she asked
herself, and she could not refrain from turning round. She looked
straight into his eyes, and his nearness, self-assurance, and the
good-natured tenderness of his smile vanquished her. She smiled just
as he was doing, gazing straight into his eyes. And again she felt
with horror that no barrier lay between him and her.

The curtain rose again. Anatole left the box, serene and gay.
Natasha went back to her father in the other box, now quite submissive
to the world she found herself in. All that was going on before her
now seemed quite natural, but on the other hand all her previous
thoughts of her betrothed, of Princess Mary, or of life in the country
did not once recur to her mind and were as if belonging to a remote
past.

In the fourth act there was some sort of devil who sang waving his
arm about, till the boards were withdrawn from under him and he
disappeared down below. That was the only part of the fourth act
that Natasha saw. She felt agitated and tormented, and the cause of
this was Kuragin whom she could not help watching. As they were
leaving the theater Anatole came up to them, called their carriage,
and helped them in. As he was putting Natasha in he pressed her arm
above the elbow. Agitated and flushed she turned round. He was looking
at her with glittering eyes, smiling tenderly.


Only after she had reached home was Natasha able clearly to think
over what had happened to her, and suddenly remembering Prince
Andrew she was horrified, and at tea to which all had sat down after
the opera, she gave a loud exclamation, flushed, and ran out of the
room.

"O God! I am lost!" she said to herself. "How could I let him?"
She sat for a long time hiding her flushed face in her hands trying to
realize what had happened to her, but was unable either to
understand what had happened or what she felt. Everything seemed dark,
obscure, and terrible. There in that enormous, illuminated theater
where the bare-legged Duport, in a tinsel-decorated jacket, jumped
about to the music on wet boards, and young girls and old men, and the
nearly naked Helene with her proud, calm smile, rapturously cried
"bravo!"--there in the presence of that Helene it had all seemed clear
and simple; but now, alone by herself, it was incomprehensible.
"What is it? What was that terror I felt of him? What is this
gnawing of conscience I am feeling now?" she thought.

Only to the old countess at night in bed could Natasha have told all
she was feeling. She knew that Sonya with her severe and simple
views would either not understand it at all or would be horrified at
such a confession. So Natasha tried to solve what was torturing her by
herself.

"Am I spoiled for Andrew's love or not?" she asked herself, and with
soothing irony replied: "What a fool I am to ask that! What did happen
to me? Nothing! I have done nothing, I didn't lead him on at all.
Nobody will know and I shall never see him again," she told herself.
"So it is plain that nothing has happened and there is nothing to
repent of, and Andrew can love me still. But why 'still?' O God, why
isn't he here?" Natasha quieted herself for a moment, but again some
instinct told her that though all this was true, and though nothing
had happened, yet the former purity of her love for Prince Andrew
had perished. And again in imagination she went over her whole
conversation with Kuragin, and again saw the face, gestures, and
tender smile of that bold handsome man when he pressed her arm.





CHAPTER XI

Anatole Kuragin was staying in Moscow because his father had sent
him away from Petersburg, where he had been spending twenty thousand
rubles a year in cash, besides running up debts for as much more,
which his creditors demanded from his father.

His father announced to him that he would now pay half his debts for
the last time, but only on condition that he went to Moscow as
adjutant to the commander in chief--a post his father had procured for
him--and would at last try to make a good match there. He indicated to
him Princess Mary and Julie Karagina.

Anatole consented and went to Moscow, where he put up at Pierre's
house. Pierre received him unwillingly at first, but got used to him
after a while, sometimes even accompanied him on his carousals, and
gave him money under the guise of loans.

As Shinshin had remarked, from the time of his arrival Anatole had
turned the heads of the Moscow ladies, especially by the fact that
he slighted them and plainly preferred the gypsy girls and French
actresses--with the chief of whom, Mademoiselle George, he was said to
be on intimate relations. He had never missed a carousal at
Danilov's or other Moscow revelers', drank whole nights through,
outvying everyone else, and was at all the balls and parties of the
best society. There was talk of his intrigues with some of the ladies,
and he flirted with a few of them at the balls. But he did not run
after the unmarried girls, especially the rich heiresses who were most
of them plain. There was a special reason for this, as he had got
married two years before--a fact known only to his most intimate
friends. At that time while with his regiment in Poland, a Polish
landowner of small means had forced him to marry his daughter. Anatole
had very soon abandoned his wife and, for a payment which he agreed to
send to his father-in-law, had arranged to be free to pass himself off
as a bachelor.

Anatole was always content with his position, with himself, and with
others. He was instinctively and thoroughly convinced that was
impossible for him to live otherwise than as he did and that he had
never in his life done anything base. He was incapable of
considering how his actions might affect others or what the
consequences of this or that action of his might be. He was
convinced that, as a duck is so made that it must live in water, so
God had made him such that he must spend thirty thousand rubles a year
and always occupy a prominent position in society. He believed this so
firmly that others, looking at him, were persuaded of it too and did
not refuse him either a leading place in society or money, which he
borrowed from anyone and everyone and evidently would not repay.

He was not a gambler, at any rate he did not care about winning.
He was not vain. He did not mind what people thought of him. Still
less could he be accused of ambition. More than once he had vexed
his father by spoiling his own career, and he laughed at
distinctions of all kinds. He was not mean, and did not refuse
anyone who asked of him. All he cared about was gaiety and women,
and as according to his ideas there was nothing dishonorable in
these tastes, and he was incapable of considering what the
gratification of his tastes entailed for others, he honestly
considered himself irreproachable, sincerely despised rogues and bad
people, and with a tranquil conscience carried his head high.

Rakes, those male Magdalenes, have a secret feeling of innocence
similar to that which female Magdalenes have, based on the same hope
of forgiveness. "All will be forgiven her, for she loved much; and all
will be forgiven him, for he enjoyed much."

Dolokhov, who had reappeared that year in Moscow after his exile and
his Persian adventures, and was leading a life of luxury, gambling,
and dissipation, associated with his old Petersburg comrade Kuragin
and made use of him for his own ends.

Anatole was sincerely fond of Dolokhov for his cleverness and
audacity. Dolokhov, who needed Anatole Kuragin's name, position, and
connections as a bait to draw rich young men into his gambling set,
made use of him and amused himself at his expense without letting
the other feel it. Apart from the advantage he derived from Anatole,
the very process of dominating another's will was in itself a
pleasure, a habit, and a necessity to Dolokhov.

Natasha had made a strong impression on Kuragin. At supper after the
opera he described to Dolokhov with the air of a connoisseur the
attractions of her arms, shoulders, feet, and hair and expressed his
intention of making love to her. Anatole had no notion and was
incapable of considering what might come of such love-making, as he
never had any notion of the outcome of any of his actions.

"She's first-rate, my dear fellow, but not for us," replied
Dolokhov.

"I will tell my sister to ask her to dinner," said Anatole. "Eh?"

"You'd better wait till she's married...."

"You know, I adore little girls, they lose their heads at once,"
pursued Anatole.

"You have been caught once already by a 'little girl,'" said
Dolokhov who knew of Kuragin's marriage. "Take care!"

"Well, that can't happen twice! Eh?" said Anatole, with a
good-humored laugh.





CHAPTER XII


The day after the opera the Rostovs went nowhere and nobody came
to see them. Marya Dmitrievna talked to the count about something
which they concealed from Natasha. Natasha guessed they were talking
about the old prince and planning something, and this disquieted and
offended her. She was expecting Prince Andrew any moment and twice
that day sent a manservant to the Vozdvizhenka to ascertain whether he
had come. He had not arrived. She suffered more now than during her
first days in Moscow. To her impatience and pining for him were now
added the unpleasant recollection of her interview with Princess
Mary and the old prince, and a fear and anxiety of which she did not
understand the cause. She continually fancied that either he would
never come or that something would happen to her before he came. She
could no longer think of him by herself calmly and continuously as she
had done before. As soon as she began to think of him, the
recollection of the old prince, of Princess Mary, of the theater,
and of Kuragin mingled with her thoughts. The question again presented
itself whether she was not guilty, whether she had not already
broken faith with Prince Andrew, and again she found herself recalling
to the minutest detail every word, every gesture, and every shade in
the play of expression on the face of the man who had been able to
arouse in her such an incomprehensible and terrifying feeling. To
the family Natasha seemed livelier than usual, but she was far less
tranquil and happy than before.

On Sunday morning Marya Dmitrievna invited her visitors to Mass at
her parish church--the Church of the Assumption built over the
graves of victims of the plague.

"I don't like those fashionable churches," she said, evidently
priding herself on her independence of thought. "God is the same every
where. We have an excellent priest, he conducts the service decently
and with dignity, and the deacon is the same. What holiness is there
in giving concerts in the choir? I don't like it, it's just
self-indulgence!"

Marya Dmitrievna liked Sundays and knew how to keep them. Her
whole house was scrubbed and cleaned on Saturdays; neither she nor the
servants worked, and they all wore holiday dress and went to church.
At her table there were extra dishes at dinner, and the servants had
vodka and roast goose or suckling pig. But in nothing in the house was
the holiday so noticeable as in Marya Dmitrievna's broad, stern
face, which on that day wore an invariable look of solemn festivity.

After Mass, when they had finished their coffee in the dining room
where the loose covers had been removed from the furniture, a
servant announced that the carriage was ready, and Marya Dmitrievna
rose with a stern air. She wore her holiday shawl, in which she paid
calls, and announced that she was going to see Prince Nicholas
Bolkonski to have an explanation with him about Natasha.

After she had gone, a dressmaker from Madame Suppert-Roguet waited
on the Rostovs, and Natasha, very glad of this diversion, having
shut herself into a room adjoining the drawing room, occupied
herself trying on the new dresses. Just as she had put on a bodice
without sleeves and only tacked together, and was turning her head
to see in the glass how the back fitted, she heard in the drawing room
the animated sounds of her father's voice and another's--a woman's-
that made her flush. It was Helene. Natasha had not time to take off
the bodice before the door opened and Countess Bezukhova, dressed in a
purple velvet gown with a high collar, came into the room beaming with
good-humored amiable smiles.

"Oh, my enchantress!" she cried to the blushing Natasha.
"Charming! No, this is really beyond anything, my dear count," said
she to Count Rostov who had followed her in. "How can you live in
Moscow and go nowhere? No, I won't let you off! Mademoiselle George
will recite at my house tonight and there'll be some people, and if
you don't bring your lovely girls--who are prettier than
Mademoiselle George--I won't know you! My husband is away in Tver or I
would send him to fetch you. You must come. You positively must!
Between eight and nine."

She nodded to the dressmaker, whom she knew and who had curtsied
respectfully to her, and seated herself in an armchair beside the
looking glass, draping the folds of her velvet dress picturesquely.
She did not cease chattering good-naturedly and gaily, continually
praising Natasha's beauty. She looked at Natasha's dresses and praised
them, as well as a new dress of her own made of "metallic gauze,"
which she had received from Paris, and advised Natasha to have one
like it.

"But anything suits you, my charmer!" she remarked.

A smile of pleasure never left Natasha's face. She felt happy and as
if she were blossoming under the praise of this dear Countess
Bezukhova who had formerly seemed to her so unapproachable and
important and was now so kind to her. Natasha brightened up and felt
almost in love with this woman, who was so beautiful and so kind.
Helene for her part was sincerely delighted with Natasha and wished to
give her a good time. Anatole had asked her to bring him and Natasha
together, and she was calling on the Rostovs for that purpose. The
idea of throwing her brother and Natasha together amused her.

Though at one time, in Petersburg, she had been annoyed with Natasha
for drawing Boris away, she did not think of that now, and in her
own way heartily wished Natasha well. As she was leaving the Rostovs
she called her protegee aside.

"My brother dined with me yesterday--we nearly died of laughter-
he ate nothing and kept sighing for you, my charmer! He is madly,
quite madly, in love with you, my dear."

Natasha blushed scarlet when she heard this.

"How she blushes, how she blushes, my pretty!" said Helene. "You
must certainly come. If you love somebody, my charmer, that is not a
reason to shut yourself up. Even if you are engaged, I am sure your
fiance would wish you to go into society rather than be bored to
death."

"So she knows I am engaged, and she and her husband Pierre--that
good Pierre--have talked and laughed about this. So it's all right."
And again, under Helene's influence, what had seemed terrible now
seemed simple and natural. "And she is such a grande dame, so kind,
and evidently likes me so much. And why not enjoy myself?" thought
Natasha, gazing at Helene with wide-open, wondering eyes.

Marya Dmitrievna came back to dinner taciturn and serious, having
evidently suffered a defeat at the old prince's. She was still too
agitated by the encounter to be able to talk of the affair calmly.
In answer to the count's inquiries she replied that things were all
right and that she would tell about it next day. On hearing of
Countess Bezukhova's visit and the invitation for that evening,
Marya Dmitrievna remarked:

"I don't care to have anything to do with Bezukhova and don't advise
you to; however, if you've promised--go. It will divert your
thoughts," she added, addressing Natasha.





CHAPTER XIII


Count Rostov took the girls to Countess Bezukhova's. There were a
good many people there, but nearly all strangers to Natasha. Count
Rostov was displeased to see that the company consisted almost
entirely of men and women known for the freedom of their conduct.
Mademoiselle George was standing in a corner of the drawing room
surrounded by young men. There were several Frenchmen present, among
them Metivier who from the time Helene reached Moscow had been an
intimate in her house. The count decided not to sit down to cards or
let his girls out of his sight and to get away as soon as Mademoiselle
George's performance was over.

Anatole was at the door, evidently on the lookout for the Rostovs.
Immediately after greeting the count he went up to Natasha and
followed her. As soon as she saw him she was seized by the same
feeling she had had at the opera--gratified vanity at his admiration
of her and fear at the absence of a moral barrier between them.

Helene welcomed Natasha delightedly and was loud in admiration of
her beauty and her dress. Soon after their arrival Mademoiselle George
went out of the room to change her costume. In the drawing room people
began arranging the chairs and taking their seats. Anatole moved a
chair for Natasha and was about to sit down beside her, but the count,
who never lost sight of her, took the seat himself. Anatole sat down
behind her.

Mademoiselle George, with her bare, fat, dimpled arms, and a red
shawl draped over one shoulder, came into the space left vacant for
her, and assumed an unnatural pose. Enthusiastic whispering was
audible.

Mademoiselle George looked sternly and gloomily at the audience
and began reciting some French verses describing her guilty love for
her son. In some places she raised her voice, in others she whispered,
lifting her head triumphantly; sometimes she paused and uttered hoarse
sounds, rolling her eyes.

"Adorable! divine! delicious!" was heard from every side.

Natasha looked at the fat actress, but neither saw nor heard nor
understood anything of what went on before her. She only felt
herself again completely borne away into this strange senseless world-
so remote from her old world--a world in which it was impossible to
know what was good or bad, reasonable or senseless. Behind her sat
Anatole, and conscious of his proximity she experienced a frightened
sense of expectancy.

After the first monologue the whole company rose and surrounded
Mademoiselle George, expressing their enthusiasm.

"How beautiful she is!" Natasha remarked to her father who had
also risen and was moving through the crowd toward the actress.

"I don't think so when I look at you!" said Anatole, following
Natasha. He said this at a moment when she alone could hear him.
"You are enchanting... from the moment I saw you I have never
ceased..."

"Come, come, Natasha!" said the count, as he turned back for his
daughter. "How beautiful she is!" Natasha without saying anything
stepped up to her father and looked at him with surprised inquiring
eyes.

After giving several recitations, Mademoiselle George left, and
Countess Bezukhova asked her visitors into the ballroom.

The count wished to go home, but Helene entreated him not to spoil
her improvised ball, and the Rostovs stayed on. Anatole asked
Natasha for a valse and as they danced he pressed her waist and hand
and told her she was bewitching and that he loved her. During the
ecossaise, which she also danced with him, Anatole said nothing when
they happened to be by themselves, but merely gazed at her. Natasha
lifted her frightened eyes to him, but there was such confident
tenderness in his affectionate look and smile that she could not,
whilst looking at him, say what she had to say. She lowered her eyes.

"Don't say such things to me. I am betrothed and love another,"
she said rapidly.... She glanced at him.

Anatole was not upset or pained by what she had said.

"Don't speak to me of that! What can I do?" said he. "I tell you I
am madly, madly, in love with you! Is it my fault that you are
enchanting?... It's our turn to begin."

Natasha, animated and excited, looked about her with wide-open
frightened eyes and seemed merrier than usual. She understood hardly
anything that went on that evening. They danced the ecossaise and
the Grossvater. Her father asked her to come home, but she begged to
remain. Wherever she went and whomever she was speaking to, she felt
his eyes upon her. Later on she recalled how she had asked her
father to let her go to the dressing room to rearrange her dress, that
Helene had followed her and spoken laughingly of her brother's love,
and that she again met Anatole in the little sitting room. Helene
had disappeared leaving them alone, and Anatole had taken her hand and
said in a tender voice:

"I cannot come to visit you but is it possible that I shall never
see you? I love you madly. Can I never...?" and, blocking her path, he
brought his face close to hers.

His large, glittering, masculine eyes were so close to hers that she
saw nothing but them.

"Natalie?" he whispered inquiringly while she felt her hands being
painfully pressed. "Natalie?"

"I don't understand. I have nothing to say," her eyes replied.

Burning lips were pressed to hers, and at the same instant she
felt herself released, and Helene's footsteps and the rustle of her
dress were heard in the room. Natasha looked round at her, and then,
red and trembling, threw a frightened look of inquiry at Anatole and
moved toward the door.

"One word, just one, for God's sake!" cried Anatole.

She paused. She so wanted a word from him that would explain to
her what had happened and to which she could find no answer.

"Natalie, just a word, only one!" he kept repeating, evidently not
knowing what to say and he repeated it till Helene came up to them.

Helene returned with Natasha to the drawing room. The Rostovs went
away without staying for supper.

After reaching home Natasha did not sleep all night. She was
tormented by the insoluble question whether she loved Anatole or
Prince Andrew. She loved Prince Andrew--she remembered distinctly
how deeply she loved him. But she also loved Anatole, of that there
was no doubt. "Else how could all this have happened?" thought she.
"If, after that, I could return his smile when saying good-by, if I
was able to let it come to that, it means that I loved him from the
first. It means that he is kind, noble, and splendid, and I could
not help loving him. What am I to do if I love him and the other one
too?" she asked herself, unable to find an answer to these terrible
questions.





CHAPTER XIV


Morning came with its cares and bustle. Everyone got up and began to
move about and talk, dressmakers came again. Marya Dmitrievna
appeared, and they were called to breakfast. Natasha kept looking
uneasily at everybody with wide-open eyes, as if wishing to
intercept every glance directed toward her, and tried to appear the
same as usual.

After breakfast, which was her best time, Marya Dmitrievna sat
down in her armchair and called Natasha and the count to her.

"Well, friends, I have now thought the whole matter over and this is
my advice," she began. "Yesterday, as you know, I went to see Prince
Bolkonski. Well, I had a talk with him.... He took it into his head to
begin shouting, but I am not one to be shouted down. I said what I had
to say!"

"Well, and he?" asked the count.

"He? He's crazy... he did not want to listen. But what's the use
of talking? As it is we have worn the poor girl out," said Marya
Dmitrievna. "My advice to you is finish your business and go back home
to Otradnoe... and wait there."

"Oh, no!" exclaimed Natasha.

"Yes, go back," said Marya Dmitrievna, "and wait there. If your
betrothed comes here now--there will be no avoiding a quarrel; but
alone with the old man he will talk things over and then come on to
you."

Count Rostov approved of this suggestion, appreciating its
reasonableness. If the old man came round it would be all the better
to visit him in Moscow or at Bald Hills later on; and if not, the
wedding, against his wishes, could only be arranged at Otradnoe.

"That is perfectly true. And I am sorry I went to see him and took
her," said the old count.

"No, why be sorry? Being here, you had to pay your respects. But
if he won't--that's his affair," said Marya Dmitrievna, looking for
something in her reticule. "Besides, the trousseau is ready, so
there is nothing to wait for; and what is not ready I'll send after
you. Though I don't like letting you go, it is the best way. So go,
with God's blessing!"

Having found what she was looking for in the reticule she handed
it to Natasha. It was a letter from Princess Mary.

"She has written to you. How she torments herself, poor thing! She's
afraid you might think that she does not like you."

"But she doesn't like me," said Natasha.

"Don't talk nonsense!" cried Marya Dmitrievna.

"I shan't believe anyone, I know she doesn't like me," replied
Natasha boldly as she took the letter, and her face expressed a cold
and angry resolution that caused Marya Dmitrievna to look at her
more intently and to frown.

"Don't answer like that, my good girl!" she said. "What I say is
true! Write an answer!" Natasha did not reply and went to her own room
to read Princess Mary's letter.

Princess Mary wrote that she was in despair at the
misunderstanding that had occurred between them. Whatever her father's
feelings might be, she begged Natasha to believe that she could not
help loving her as the one chosen by her brother, for whose
happiness she was ready to sacrifice everything.

"Do not think, however," she wrote, "that my father is
ill-disposed toward you. He is an invalid and an old man who must be
forgiven; but he is good and magnanimous and will love her who makes
his son happy." Princess Mary went on to ask Natasha to fix a time
when she could see her again.

After reading the letter Natasha sat down at the writing table to
answer it. "Dear Princess," she wrote in French quickly and
mechanically, and then paused. What more could she write after all
that had happened the evening before? "Yes, yes! All that has
happened, and now all is changed," she thought as she sat with the
letter she had begun before her. "Must I break off with him? Must I
really? That's awful..." and to escape from these dreadful thoughts
she went to Sonya and began sorting patterns with her.

After dinner Natasha went to her room and again took up Princess
Mary's letter. "Can it be that it is all over?" she thought. "Can it
be that all this has happened so quickly and has destroyed all that
went before?" She recalled her love for Prince Andrew in all its
former strength, and at the same time felt that she loved Kuragin. She
vividly pictured herself as Prince Andrew's wife, and the scenes of
happiness with him she had so often repeated in her imagination, and
at the same time, aglow with excitement, recalled every detail of
yesterday's interview with Anatole.

"Why could that not be as well?" she sometimes asked herself in
complete bewilderment. "Only so could I be completely happy; but now I
have to choose, and I can't be happy without either of them. Only,"
she thought, "to tell Prince Andrew what has happened or to hide it
from him are both equally impossible. But with that one nothing is
spoiled. But am I really to abandon forever the joy of Prince Andrew's
love, in which I have lived so long?"

"Please, Miss!" whispered a maid entering the room with a mysterious
air. "A man told me to give you this-" and she handed Natasha a
letter.

"Only, for Christ's sake..." the girl went on, as Natasha, without
thinking, mechanically broke the seal and read a love letter from
Anatole, of which, without taking in a word, she understood only
that it was a letter from him--from the man she loved. Yes, she
loved him, or else how could that have happened which had happened?
And how could she have a love letter from him in her hand?

With trembling hands Natasha held that passionate love letter
which Dolokhov had composed for Anatole, and as she read it she
found in it an echo of all that she herself imagined she was feeling.

"Since yesterday evening my fate has been sealed; to be loved by you
or to die. There is no other way for me," the letter began. Then he
went on to say that he knew her parents would not give her to him--for
this there were secret reasons he could reveal only to her--but that
if she loved him she need only say the word yes, and no human power
could hinder their bliss. Love would conquer all. He would steal her
away and carry her off to the ends of the earth.

"Yes, yes! I love him!" thought Natasha, reading the letter for
the twentieth time and finding some peculiarly deep meaning in each
word of it.

That evening Marya Dmitrievna was going to the Akharovs' and
proposed to take the girls with her. Natasha, pleading a headache,
remained at home.





CHAPTER XV


On returning late in the evening Sonya went to Natasha's room, and
to her surprise found her still dressed and asleep on the sofa. Open
on the table, beside her lay Anatole's letter. Sonya picked it up
and read it.

As she read she glanced at the sleeping Natasha, trying to find in
her face an explanation of what she was reading, but did not find
it. Her face was calm, gentle, and happy. Clutching her breast to keep
herself from choking, Sonya, pale and trembling with fear and
agitation, sat down in an armchair and burst into tears.

"How was it I noticed nothing? How could it go so far? Can she
have left off loving Prince Andrew? And how could she let Kuragin go
to such lengths? He is a deceiver and a villain, that's plain! What
will Nicholas, dear noble Nicholas, do when he hears of it? So this is
the meaning of her excited, resolute, unnatural look the day before
yesterday, yesterday, and today," thought Sonya. "But it can't be that
she loves him! She probably opened the letter without knowing who it
was from. Probably she is offended by it. She could not do such a
thing!"

Sonya wiped away her tears and went up to Natasha, again scanning
her face.

"Natasha!" she said, just audibly.

Natasha awoke and saw Sonya.

"Ah, you're back?"

And with the decision and tenderness that often come at the moment
of awakening, she embraced her friend, but noticing Sonya's look of
embarrassment, her own face expressed confusion and suspicion.

"Sonya, you've read that letter?" she demanded.

"Yes," answered Sonya softly.

Natasha smiled rapturously.

"No, Sonya, I can't any longer!" she said. "I can't hide it from you
any longer. You know, we love one another! Sonya, darling, he
writes... Sonya..."

Sonya stared open-eyed at Natasha, unable to believe her ears.

"And Bolkonski?" she asked.

"Ah, Sonya, if you only knew how happy I am!" cried Natasha. "You
don't know what love is...."

"But, Natasha, can that be all over?"

Natasha looked at Sonya with wide-open eyes as if she could not
grasp the question.

"Well, then, are you refusing Prince Andrew?" said Sonya.

"Oh, you don't understand anything! Don't talk nonsense, just
listen!" said Natasha, with momentary vexation.

"But I can't believe it," insisted Sonya. "I don't understand. How
is it you have loved a man for a whole year and suddenly... Why, you
have only seen him three times! Natasha, I don't believe you, you're
joking! In three days to forget everything and so..."

"Three days?" said Natasha. "It seems to me I've loved him a hundred
years. It seems to me that I have never loved anyone before. You can't
understand it.... Sonya, wait a bit, sit here," and Natasha embraced
and kissed her.

"I had heard that it happens like this, and you must have heard it
too, but it's only now that I feel such love. It's not the same as
before. As soon as I saw him I felt he was my master and I his
slave, and that I could not help loving him. Yes, his slave!
Whatever he orders I shall do. You don't understand that. What can I
do? What can I do, Sonya?" cried Natasha with a happy yet frightened
expression.

"But think what you are doing," cried Sonya. "I can't leave it
like this. This secret correspondence... How could you let him go so
far?" she went on, with a horror and disgust she could hardly conceal.

"I told you that I have no will," Natasha replied. "Why can't you
understand? I love him!"

"Then I won't let it come to that... I shall tell!" cried Sonya,
bursting into tears.

"What do you mean? For God's sake... If you tell, you are my enemy!"
declared Natasha. "You want me to be miserable, you want us to be
separated...."

When she saw Natasha's fright, Sonya shed tears of shame and pity
for her friend.

"But what has happened between you?" she asked. "What has he said to
you? Why doesn't he come to the house?"

Natasha did not answer her questions.

"For God's sake, Sonya, don't tell anyone, don't torture me,"
Natasha entreated. "Remember no one ought to interfere in such
matters! I have confided in you...."

"But why this secrecy? Why doesn't he come to the house?" asked
Sonya. "Why doesn't he openly ask for your hand? You know Prince
Andrew gave you complete freedom--if it is really so; but I don't
believe it! Natasha, have you considered what these secret reasons can
be?"

Natasha looked at Sonya with astonishment. Evidently this question
presented itself to her mind for the first time and she did not know
how to answer it.

"I don't know what the reasons are. But there must be reasons!"

Sonya sighed and shook her head incredulously.

"If there were reasons..." she began.

But Natasha, guessing her doubts, interrupted her in alarm.

"Sonya, one can't doubt him! One can't, one can't! Don't you
understand?" she cried.

"Does he love you?"

"Does he love me?" Natasha repeated with a smile of pity at her
friend's lack of comprehension. "Why, you have read his letter and you
have seen him."

"But if he is dishonorable?"

"He! dishonorable? If you only knew!" exclaimed Natasha.

"If he is an honorable man he should either declare his intentions
or cease seeing you; and if you won't do this, I will. I will write to
him, and I will tell Papa!" said Sonya resolutely.

"But I can't live without him!" cried Natasha.

"Natasha, I don't understand you. And what are you saying! Think
of your father and of Nicholas."

"I don't want anyone, I don't love anyone but him. How dare you
say he is dishonorable? Don't you know that I love him?" screamed
Natasha. "Go away, Sonya! I don't want to quarrel with you, but go,
for God's sake go! You see how I am suffering!" Natasha cried angrily,
in a voice of despair and repressed irritation. Sonya burst into
sobs and ran from the room.

Natasha went to the table and without a moment's reflection wrote
that answer to Princess Mary which she had been unable to write all
the morning. In this letter she said briefly that all their
misunderstandings were at an end; that availing herself of the
magnanimity of Prince Andrew who when he went abroad had given her her
freedom, she begged Princess Mary to forget everything and forgive her
if she had been to blame toward her, but that she could not be his wife.
At that moment this all seemed quite easy, simple, and clear to Natasha.


On Friday the Rostovs were to return to the country, but on
Wednesday the count went with the prospective purchaser to his
estate near Moscow.

On the day the count left, Sonya and Natasha were invited to a big
dinner party at the Karagins', and Marya Dmitrievna took them there.
At that party Natasha again met Anatole, and Sonya noticed that she
spoke to him, trying not to be overheard, and that all through
dinner she was more agitated than ever. When they got home Natasha was
the first to begin the explanation Sonya expected.

"There, Sonya, you were talking all sorts of nonsense about him,"
Natasha began in a mild voice such as children use when they wish to
be praised. "We have had an explanation today."

"Well, what happened? What did he say? Natasha, how glad I am you're
not angry with me! Tell me everything--the whole truth. What did he
say?"

Natasha became thoughtful.

"Oh, Sonya, if you knew him as I do! He said... He asked me what I
had promised Bolkonski. He was glad I was free to refuse him."

Sonya sighed sorrowfully.

"But you haven't refused Bolkonski?" said she.

"Perhaps I have. Perhaps all is over between me and Bolkonski. Why
do you think so badly of me?"

"I don't think anything, only I don't understand this..."

"Wait a bit, Sonya, you'll understand everything. You'll see what
a man he is! Now don't think badly of me or of him. I don't think
badly of anyone: I love and pity everybody. But what am I to do?"

Sonya did not succumb to the tender tone Natasha used toward her.
The more emotional and ingratiating the expression of Natasha's face
became, the more serious and stern grew Sonya's.

"Natasha," said she, "you asked me not to speak to you, and I
haven't spoken, but now you yourself have begun. I don't trust him,
Natasha. Why this secrecy?"

"Again, again!" interrupted Natasha.

"Natasha, I am afraid for you!"

"Afraid of what?"

"I am afraid you're going to your ruin," said Sonya resolutely,
and was herself horrified at what she had said.

Anger again showed in Natasha's face.

"And I'll go to my ruin, I will, as soon as possible! It's not
your business! It won't be you, but I, who'll suffer. Leave me
alone, leave me alone! I hate you!"

"Natasha!" moaned Sonya, aghast.

"I hate you, I hate you! You're my enemy forever!" And Natasha ran
out of the room.

Natasha did not speak to Sonya again and avoided her. With the
same expression of agitated surprise and guilt she went about the
house, taking up now one occupation, now another, and at once
abandoning them.

Hard as it was for Sonya, she watched her friend and did not let her
out of her sight.

The day before the count was to return, Sonya noticed that Natasha
sat by the drawingroom window all the morning as if expecting
something and that she made a sign to an officer who drove past,
whom Sonya took to be Anatole.

Sonya began watching her friend still more attentively and noticed
that at dinner and all that evening Natasha was in a strange and
unnatural state. She answered questions at random, began sentences she
did not finish, and laughed at everything.

After tea Sonya noticed a housemaid at Natasha's door timidly
waiting to let her pass. She let the girl go in, and then listening at
the door learned that another letter had been delivered.

Then suddenly it became clear to Sonya that Natasha had some
dreadful plan for that evening. Sonya knocked at her door. Natasha did
not let her in.

"She will run away with him!" thought Sonya. "She is capable of
anything. There was something particularly pathetic and resolute in
her face today. She cried as she said good-by to Uncle," Sonya
remembered. "Yes, that's it, she means to elope with him, but what
am I to do?" thought she, recalling all the signs that clearly
indicated that Natasha had some terrible intention. "The count is
away. What am I to do? Write to Kuragin demanding an explanation?
But what is there to oblige him to reply? Write to Pierre, as Prince
Andrew asked me to in case of some misfortune?... But perhaps she
really has already refused Bolkonski--she sent a letter to Princess
Mary yesterday. And Uncle is away...." To tell Marya Dmitrievna who
had such faith in Natasha seemed to Sonya terrible. "Well, anyway,"
thought Sonya as she stood in the dark passage, "now or never I must
prove that I remember the family's goodness to me and that I love
Nicholas. Yes! If I don't sleep for three nights I'll not leave this
passage and will hold her back by force and will and not let the
family be disgraced," thought she.





CHAPTER XVI


Anatole had lately moved to Dolokhov's. The plan for Natalie
Rostova's abduction had been arranged and the preparations made by
Dolokhov a few days before, and on the day that Sonya, after listening
at Natasha's door, resolved to safeguard her, it was to have been
put into execution. Natasha had promised to come out to Kuragin at the
back porch at ten that evening. Kuragin was to put her into a troyka
he would have ready and to drive her forty miles to the village of
Kamenka, where an unfrocked priest was in readiness to perform a
marriage ceremony over them. At Kamenka a relay of horses was to
wait which would take them to the Warsaw highroad, and from there they
would hasten abroad with post horses.

Anatole had a passport, an order for post horses, ten thousand
rubles he had taken from his sister and another ten thousand
borrowed with Dolokhov's help.

Two witnesses for the mock marriage--Khvostikov, a retired petty
official whom Dolokhov made use of in his gambling transactions, and
Makarin, a retired hussar, a kindly, weak fellow who had an
unbounded affection for Kuragin--were sitting at tea in Dolokhov's
front room.

In his large study, the walls of which were hung to the ceiling with
Persian rugs, bearskins, and weapons, sat Dolokhov in a traveling
cloak and high boots, at an open desk on which lay abacus and some
bundles of paper money. Anatole, with uniform unbuttoned, walked to
and fro from the room where the witnesses were sitting, through the
study to the room behind, where his French valet and others were
packing the last of his things. Dolokhov was counting the money and
noting something down.

"Well," he said, "Khvostikov must have two thousand."

"Give it to him, then," said Anatole.

"Makarka" (their name for Makarin) "will go through fire and water
for you for nothing. So here are our accounts all settled," said
Dolokhov, showing him the memorandum. "Is that right?"

"Yes, of course," returned Anatole, evidently not listening to
Dolokhov and looking straight before him with a smile that did not
leave his face.

Dolokhov banged down the or of his and turned to Anatole with an
ironic smile:

"Do you know? You'd really better drop it all. There's still time!"

"Fool," retorted Anatole. "Don't talk nonsense! If you only
knew... it's the devil knows what!"

"No, really, give it up!" said Dolokhov. "I am speaking seriously.
It's no joke, this plot you've hatched."

"What, teasing again? Go to the devil! Eh?" said Anatole, making a
grimace. "Really it's no time for your stupid jokes," and he left
the room.

Dolokhov smiled contemptuously and condescendingly when Anatole
had gone out.

"You wait a bit," he called after him. "I'm not joking, I'm
talking sense. Come here, come here!"

Anatole returned and looked at Dolokhov, trying to give him his
attention and evidently submitting to him involuntarily.

"Now listen to me. I'm telling you this for the last time. Why
should I joke about it? Did I hinder you? Who arranged everything
for you? Who found the priest and got the passport? Who raised the
money? I did it all."

"Well, thank you for it. Do you think I am not grateful?" And
Anatole sighed and embraced Dolokhov.

"I helped you, but all the same I must tell you the truth; it is a
dangerous business, and if you think about it--a stupid business.
Well, you'll carry her off--all right! Will they let it stop at
that? It will come out that you're already married. Why, they'll
have you in the criminal court...."

"Oh, nonsense, nonsense!" Anatole ejaculated and again made a
grimace. "Didn't I explain to you? What?" And Anatole, with the
partiality dull-witted people have for any conclusion they have
reached by their own reasoning, repeated the argument he had already
put to Dolokhov a hundred times. "Didn't I explain to you that I
have come to this conclusion: if this marriage is invalid," he went
on, crooking one finger, "then I have nothing to answer for; but if it
is valid, no matter! Abroad no one will know anything about it.
Isn't that so? And don't talk to me, don't, don't."

"Seriously, you'd better drop it! You'll only get yourself into a
mess!"

"Go to the devil!" cried Anatole and, clutching his hair, left the
room, but returned at once and dropped into an armchair in front of
Dolokhov with his feet turned under him. "It's the very devil! What?
Feel how it beats!" He took Dolokhov's hand and put it on his heart.
"What a foot, my dear fellow! What a glance! A goddess!" he added in
French. "What?"

Dolokhov with a cold smile and a gleam in his handsome insolent eyes
looked at him--evidently wishing to get some more amusement out of
him.

"Well and when the money's gone, what then?"

"What then? Eh?" repeated Anatole, sincerely perplexed by a
thought of the future. "What then?... Then, I don't know.... But why
talk nonsense!" He glanced at his watch. "It's time!"

Anatole went into the back room.

"Now then! Nearly ready? You're dawdling!" he shouted to the
servants.

Dolokhov put away the money, called a footman whom he ordered to
bring something for them to eat and drink before the journey, and went
into the room where Khvostikov and Makarin were sitting.

Anatole lay on the sofa in the study leaning on his elbow and
smiling pensively, while his handsome lips muttered tenderly to
himself.

"Come and eat something. Have a drink!" Dolokhov shouted to him from
the other room.

"I don't want to," answered Anatole continuing to smile.

"Come! Balaga is here."

Anatole rose and went into the dining room. Balaga was a famous
troyka driver who had known Dolokhov and Anatole some six years and
had given them good service with his troykas. More than once when
Anatole's regiment was stationed at Tver he had taken him from Tver in
the evening, brought him to Moscow by daybreak, and driven him back
again the next night. More than once he had enabled Dolokhov to escape
when pursued. More than once he had driven them through the town
with gypsies and "ladykins" as he called the cocottes. More than
once in their service he had run over pedestrians and upset vehicles
in the streets of Moscow and had always been protected from the
consequences by "my gentlemen" as he called them. He had ruined more
than one horse in their service. More than once they had beaten him,
and more than once they had made him drunk on champagne and Madeira,
which he loved; and he knew more than one thing about each of them
which would long ago have sent an ordinary man to Siberia. They
often called Balaga into their orgies and made him drink and dance
at the gypsies', and more than one thousand rubles of their money
had passed through his hands. In their service he risked his skin
and his life twenty times a year, and in their service had lost more
horses than the money he had from them would buy. But he liked them;
liked that mad driving at twelve miles an hour, liked upsetting a
driver or running down a pedestrian, and flying at full gallop through
the Moscow streets. He liked to hear those wild, tipsy shouts behind
him: "Get on! Get on!" when it was impossible to go any faster. He
liked giving a painful lash on the neck to some peasant who, more dead
than alive, was already hurrying out of his way. "Real gentlemen!"
he considered them.

Anatole and Dolokhov liked Balaga too for his masterly driving and
because he liked the things they liked. With others Balaga
bargained, charging twenty-five rubles for a two hours' drive, and
rarely drove himself, generally letting his young men do so. But
with "his gentlemen" he always drove himself and never demanded
anything for his work. Only a couple of times a year--when he knew
from their valets that they had money in hand--he would turn up of a
morning quite sober and with a deep bow would ask them to help him.
The gentlemen always made him sit down.

"Do help me out, Theodore Ivanych, sir," or "your excellency," he
would say. "I am quite out of horses. Let me have what you can to go
to the fair."

And Anatole and Dolokhov, when they had money, would give him a
thousand or a couple of thousand rubles.

Balaga was a fair-haired, short, and snub-nosed peasant of about
twenty-seven; red-faced, with a particularly red thick neck,
glittering little eyes, and a small beard. He wore a fine,
dark-blue, silk-lined cloth coat over a sheepskin.

On entering the room now he crossed himself, turning toward the
front corner of the room, and went up to Dolokhov, holding out a
small, black hand.

"Theodore Ivanych!" he said, bowing.

"How d'you do, friend? Well, here he is!"

"Good day, your excellency!" he said, again holding out his hand
to Anatole who had just come in.

"I say, Balaga," said Anatole, putting his hands on the man's
shoulders, "do you care for me or not? Eh? Now, do me a service....
What horses have you come with? Eh?"

"As your messenger ordered, your special beasts," replied Balaga.

"Well, listen, Balaga! Drive all three to death but get me there
in three hours. Eh?"

"When they are dead, what shall I drive?" said Balaga with a wink.

"Mind, I'll smash your face in! Don't make jokes!" cried Anatole,
suddenly rolling his eyes.

"Why joke?" said the driver, laughing. "As if I'd grudge my
gentlemen anything! As fast as ever the horses can gallop, so fast
we'll go!"

"Ah!" said Anatole. "Well, sit down."

"Yes, sit down!" said Dolokhov.

"I'll stand, Theodore Ivanych."

"Sit down; nonsense! Have a drink!" said Anatole, and filled a large
glass of Madeira for him.

The driver's eyes sparkled at the sight of the wine. After
refusing it for manners' sake, he drank it and wiped his mouth with
a red silk handkerchief he took out of his cap.

"And when are we to start, your excellency?"

"Well..." Anatole looked at his watch. "We'll start at once. Mind,
Balaga! You'll get there in time? Eh?"

"That depends on our luck in starting, else why shouldn't we be
there in time?" replied Balaga. "Didn't we get you to Tver in seven
hours? I think you remember that, your excellency?"

"Do you know, one Christmas I drove from Tver," said Anatole,
smilingly at the recollection and turning to Makarin who gazed
rapturously at him with wide-open eyes. "Will you believe it, Makarka,
it took one's breath away, the rate we flew. We came across a train of
loaded sleighs and drove right over two of them. Eh?"

"Those were horses!" Balaga continued the tale. "That time I'd
harnessed two young side horses with the bay in the shafts," he went
on, turning to Dolokhov. "Will you believe it, Theodore Ivanych, those
animals flew forty miles? I couldn't hold them in, my hands grew
numb in the sharp frost so that I threw down the reins--'Catch hold
yourself, your excellency!' says I, and I just tumbled on the bottom
of the sleigh and sprawled there. It wasn't a case of urging them
on, there was no holding them in till we reached the place. The devils
took us there in three hours! Only the near one died of it."





CHAPTER XVII


Anatole went out of the room and returned a few minutes later
wearing a fur coat girt with a silver belt, and a sable cap jauntily
set on one side and very becoming to his handsome face. Having
looked in a mirror, and standing before Dolokhov in the same pose he
had assumed before it, he lifted a glass of wine.

"Well, good-by, Theodore. Thank you for everything and farewell!"
said Anatole. "Well, comrades and friends..." he considered for a
moment "...of my youth, farewell!" he said, turning to Makarin and the
others.

Though they were all going with him, Anatole evidently wished to
make something touching and solemn out of this address to his
comrades. He spoke slowly in a loud voice and throwing out his chest
slightly swayed one leg.

"All take glasses; you too, Balaga. Well, comrades and friends of my
youth, we've had our fling and lived and reveled. Eh? And now, when
shall we meet again? I am going abroad. We have had a good time--now
farewell, lads! To our health! Hurrah!..." he cried, and emptying
his glass flung it on the floor.

"To your health!" said Balaga who also emptied his glass, and
wiped his mouth with his handkerchief.

Makarin embraced Anatole with tears in his eyes.

"Ah, Prince, how sorry I am to part from you!

"Let's go. Let's go!" cried Anatole.

Balaga was about to leave the room.

"No, stop!" said Anatole. "Shut the door; we have first to sit down.
That's the way."

They shut the door and all sat down.

"Now, quick march, lads!" said Anatole, rising.

Joseph, his valet, handed him his sabretache and saber, and they all
went out into the vestibule.

"And where's the fur cloak?" asked Dolokhov. "Hey, Ignatka! Go to
Matrena Matrevna and ask her for the sable cloak. I have heard what
elopements are like," continued Dolokhov with a wink. "Why, she'll
rush out more dead than alive just in the things she is wearing; if
you delay at all there'll be tears and 'Papa' and 'Mamma,' and she's
frozen in a minute and must go back--but you wrap the fur cloak
round her first thing and carry her to the sleigh."

The valet brought a woman's fox-lined cloak.

"Fool, I told you the sable one! Hey, Matrena, the sable!" he
shouted so that his voice rang far through the rooms.

A handsome, slim, and pale-faced gypsy girl with glittering black
eyes and curly blue-black hair, wearing a red shawl, ran out with a
sable mantle on her arm.

"Here, I don't grudge it--take it!" she said, evidently afraid of
her master and yet regretful of her cloak.

Dolokhov, without answering, took the cloak, threw it over
Matrena, and wrapped her up in it.

"That's the way," said Dolokhov, "and then so!" and he turned the
collar up round her head, leaving only a little of the face uncovered.
"And then so, do you see?" and he pushed Anatole's head forward to
meet the gap left by the collar, through which Matrena's brilliant
smile was seen.

"Well, good-by, Matrena," said Anatole, kissing her. "Ah, my
revels here are over. Remember me to Steshka. There, good-by! Good-by,
Matrena, wish me luck!"

"Well, Prince, may God give you great luck!" said Matrena in her
gypsy accent.

Two troykas were standing before the porch and two young drivers
were holding the horses. Balaga took his seat in the front one and
holding his elbows high arranged the reins deliberately. Anatole and
Dolokhov got in with him. Makarin, Khvostikov, and a valet seated
themselves in the other sleigh.

"Well, are you ready?" asked Balaga.

"Go!" he cried, twisting the reins round his hands, and the troyka
tore down the Nikitski Boulevard.

"Tproo! Get out of the way! Hi!... Tproo!..." The shouting of Balaga
and of the sturdy young fellow seated on the box was all that could be
heard. On the Arbat Square the troyka caught against a carriage;
something cracked, shouts were heard, and the troyka flew along the
Arbat Street.

After taking a turn along the Podnovinski Boulevard, Balaga began to
rein in, and turning back drew up at the crossing of the old
Konyusheny Street.

The young fellow on the box jumped down to hold the horses and
Anatole and Dolokhov went along the pavement. When they reached the
gate Dolokhov whistled. The whistle was answered, and a maidservant
ran out.

"Come into the courtyard or you'll be seen; she'll come out
directly," said she.

Dolokhov stayed by the gate. Anatole followed the maid into the
courtyard, turned the corner, and ran up into the porch.

He was met by Gabriel, Marya Dmitrievna's gigantic footman.

"Come to the mistress, please," said the footman in his deep bass,
intercepting any retreat.

"To what Mistress? Who are you?" asked Anatole in a breathless
whisper.

"Kindly step in, my orders are to bring you in."

"Kuragin! Come back!" shouted Dolokhov. "Betrayed! Back!"

Dolokhov, after Anatole entered, had remained at the wicket gate and
was struggling with the yard porter who was trying to lock it. With
a last desperate effort Dolokhov pushed the porter aside, and when
Anatole ran back seized him by the arm, pulled him through the wicket,
and ran back with him to the troyka.





CHAPTER XVIII


Marya Dmitrievna, having found Sonya weeping in the corridor, made
her confess everything, and intercepting the note to Natasha she
read it and went into Natasha's room with it in her hand.

"You shameless good-for-nothing!" said she. "I won't hear a word."

Pushing back Natasha who looked at her with astonished but
tearless eyes, she locked her in; and having given orders to the
yard porter to admit the persons who would be coming that evening, but
not to let them out again, and having told the footman to bring them
up to her, she seated herself in the drawing room to await the
abductors.

When Gabriel came to inform her that the men who had come had run
away again, she rose frowning, and clasping her hands behind her paced
through the rooms a long time considering what she should do. Toward
midnight she went to Natasha's room fingering the key in her pocket.
Sonya was sitting sobbing in the corridor. "Marya Dmitrievna, for
God's sake let me in to her!" she pleaded, but Marya Dmitrievna
unlocked the door and went in without giving her an answer....
"Disgusting, abominable... In my house... horrid girl, hussy! I'm only
sorry for her father!" thought she, trying to restrain her wrath.
"Hard as it may be, I'll tell them all to hold their tongues and
will hide it from the count." She entered the room with resolute
steps. Natasha lying on the sofa, her head hidden in her hands, and
she did not stir. She was in just the same position in which Marya
Dmitrievna had left her.

"A nice girl! Very nice!" said Marya Dmitrievna. "Arranging meetings
with lovers in my house! It's no use pretending: you listen when I
speak to you!" And Marya Dmitrievna touched her arm. "Listen when when
I speak! You've disgraced yourself like the lowest of hussies. I'd
treat you differently, but I'm sorry for your father, so I will
conceal it."

Natasha did not change her position, but her whole body heaved
with noiseless, convulsive sobs which choked her. Marya Dmitrievna
glanced round at Sonya and seated herself on the sofa beside Natasha.

"It's lucky for him that he escaped me; but I'll find him!" she said
in her rough voice. "Do you hear what I am saying or not?" she added.

She put her large hand under Natasha's face and turned it toward
her. Both Marya Dmitrievna and Sonya were amazed when they saw how
Natasha looked. Her eyes were dry and glistening, her lips compressed,
her cheeks sunken.

"Let me be!... What is it to me?... I shall die!" she muttered,
wrenching herself from Marya Dmitrievna's hands with a vicious
effort and sinking down again into her former position.

"Natalie!" said Marya Dmitrievna. "I wish for your good. Lie
still, stay like that then, I won't touch you. But listen. I won't
tell you how guilty you are. You know that yourself. But when your
father comes back tomorrow what am I to tell him? Eh?"

Again Natasha's body shook with sobs.

"Suppose he finds out, and your brother, and your betrothed?"

"I have no betrothed: I have refused him!" cried Natasha.

"That's all the same," continued Dmitrievna. "If they hear of
this, will they let it pass? He, your father, I know him... if he
challenges him to a duel will that be all right? Eh?"

"Oh, let me be! Why have you interfered at all? Why? Why? Who
asked you to?" shouted Natasha, raising herself on the sofa and
looking malignantly at Marya Dmitrievna.

"But what did you want?" cried Marya Dmitrievna, growing angry
again. "Were you kept under lock and key? Who hindered his coming to
the house? Why carry you off as if you were some gypsy singing
girl?... Well, if he had carried you off... do you think they wouldn't
have found him? Your father, or brother, or your betrothed? And he's a
scoundrel, a wretch--that's a fact!"

"He is better than any of you!" exclaimed Natasha getting up. "If
you hadn't interfered... Oh, my God! What is it all? What is it?
Sonya, why?... Go away!"

And she burst into sobs with the despairing vehemence with which
people bewail disasters they feel they have themselves occasioned.
Marya Dmitrievna was to speak again but Natasha cried out:

"Go away! Go away! You all hate and despise me!" and she threw
herself back on the sofa.

Marya Dmitrievna went on admonishing her for some time, enjoining on
her that it must all be kept from her father and assuring her that
nobody would know anything about it if only Natasha herself would
undertake to forget it all and not let anyone see that something had
happened. Natasha did not reply, nor did she sob any longer, but she
grew cold and had a shivering fit. Marya Dmitrievna put a pillow under
her head, covered her with two quilts, and herself brought her some
lime-flower water, but Natasha did not respond to her.

"Well, let her sleep," said Marya Dmitrievna as she went of the room
supposing Natasha to be asleep.

But Natasha was not asleep; with pale face and fixed wide-open
eyes she looked straight before her. All that night she did not
sleep or weep and did not speak to Sonya who got up and went to her
several times.

Next day Count Rostov returned from his estate near Moscow in time
for lunch as he had promised. He was in very good spirits; the
affair with the purchaser was going on satisfactorily, and there was
nothing to keep him any longer in Moscow, away from the countess
whom he missed. Marya Dmitrievna met him and told him that Natasha had
been very unwell the day before and that they had sent for the doctor,
but that she was better now. Natasha had not left her room that
morning. With compressed and parched lips and dry fixed eyes, she
sat at the window, uneasily watching the people who drove past and
hurriedly glancing round at anyone who entered the room. She was
evidently expecting news of him and that he would come or would
write to her.

When the count came to see her she turned anxiously round at the
sound of a man's footstep, and then her face resumed its cold and
malevolent expression. She did not even get up to greet him. "What
is the matter with you, my angel? Are you ill?" asked the count.

After a moment's silence Natasha answered: "Yes, ill."

In reply to the count's anxious inquiries as to why she was so
dejected and whether anything had happened to her betrothed, she
assured him that nothing had happened and asked him not to worry.
Marya Dmitrievna confirmed Natasha's assurances that nothing had
happened. From the pretense of illness, from his daughter's
distress, and by the embarrassed faces of Sonya and Marya
Dmitrievna, the count saw clearly that something had gone wrong during
his absence, but it was so terrible for him to think that anything
disgraceful had happened to his beloved daughter, and he so prized his
own cheerful tranquillity, that he avoided inquiries and tried to
assure himself that nothing particularly had happened; and he was only
dissatisfied that her indisposition delayed their return to the
country.





CHAPTER XIX


From the day his wife arrived in Moscow Pierre had been intending to
go away somewhere, so as not to be near her. Soon after the Rostovs
came to Moscow the effect Natasha had on him made him hasten to
carry out his intention. He went to Tver to see Joseph Alexeevich's
widow, who had long since promised to hand over to him some papers
of her deceased husband's.

When he returned to Moscow Pierre was handed a letter from Marya
Dmitrievna asking him to come and see her on a matter of great
importance relating to Andrew Bolkonski and his betrothed. Pierre
had been avoiding Natasha because it seemed to him that his feeling
for her was stronger than a married man's should be for his friend's
fiancee. Yet some fate constantly threw them together.

"What can have happened? And what can they want with me?" thought he
as he dressed to go to Marya Dmitrievna's. "If only Prince Andrew
would hurry up and come and marry her!" thought he on his way to the
house.

On the Tverskoy Boulevard a familiar voice called to him.

"Pierre! Been back long?" someone shouted. Pierre raised his head.
In a sleigh drawn by two gray trotting-horses that were bespattering
the dashboard with snow, Anatole and his constant companion Makarin
dashed past. Anatole was sitting upright in the classic pose of
military dandies, the lower part of his face hidden by his beaver
collar and his head slightly bent. His face was fresh and rosy, his
white-plumed hat, tilted to one side, disclosed his curled and pomaded
hair besprinkled with powdery snow.

"Yes, indeed, that's a true sage," thought Pierre. "He sees
nothing beyond the pleasure of the moment, nothing troubles him and so
he is always cheerful, satisfied, and serene. What wouldn't I give
to be like him!" he thought enviously.

In Marya Dmitrievna's anteroom the footman who helped him off with
his fur coat said that the mistress asked him to come to her bedroom.

When he opened the ballroom door Pierre saw Natasha sitting at the
window, with a thin, pale, and spiteful face. She glanced round at
him, frowned, and left the room with an expression of cold dignity.

"What has happened?" asked Pierre, entering Marya Dmitrievna's room.

"Fine doings!" answered Dmitrievna. "For fifty-eight years have I
lived in this world and never known anything so disgraceful!"

And having put him on his honor not to repeat anything she told him,
Marya Dmitrievna informed him that Natasha had refused Prince Andrew
without her parents' knowledge and that the cause of this was
Anatole Kuragin into whose society Pierre's wife had thrown her and
with whom Natasha had tried to elope during her father's absence, in
order to be married secretly.

Pierre raised his shoulders and listened open-mouthed to what was
told him, scarcely able to believe his own ears. That Prince
Andrew's deeply loved affianced wife--the same Natasha Rostova who
used to be so charming--should give up Bolkonski for that fool Anatole
who was already secretly married (as Pierre knew), and should be so in
love with him as to agree to run away with him, was something Pierre
could not conceive and could not imagine.

He could not reconcile the charming impression he had of Natasha,
whom he had known from a child, with this new conception of her
baseness, folly, and cruelty. He thought of his wife. "They are all
alike!" he said to himself, reflecting that he was not the only man
unfortunate enough to be tied to a bad woman. But still he pitied
Prince Andrew to the point of tears and sympathized with his wounded
pride, and the more he pitied his friend the more did he think with
contempt and even with disgust of that Natasha who had just passed him
in the ballroom with such a look of cold dignity. He did not know that
Natasha's soul was overflowing with despair, shame, and humiliation,
and that it was not her fault that her face happened to assume an
expression of calm dignity and severity.

"But how get married?" said Pierre, in answer to Marya Dmitrievna.
"He could not marry--he is married!"

"Things get worse from hour to hour!" ejaculated Marya Dmitrievna.
"A nice youth! What a scoundrel! And she's expecting him--expecting
him since yesterday. She must be told! Then at least she won't go on
expecting him."

After hearing the details of Anatole's marriage from Pierre, and
giving vent to her anger against Anatole in words of abuse, Marya
Dmitrievna told Pierre why she had sent for him. She was afraid that
the count or Bolkonski, who might arrive at any moment, if they knew
of this affair (which she hoped to hide from them) might challenge
Anatole to a duel, and she therefore asked Pierre to tell his
brother-in-law in her name to leave Moscow and not dare to let her set
eyes on him again. Pierre--only now realizing the danger to the old
count, Nicholas, and Prince Andrew--promised to do as she wished.
Having briefly and exactly explained her wishes to him, she let him go
to the drawing room.

"Mind, the count knows nothing. Behave as if you know nothing
either," she said. "And I will go and tell her it is no use
expecting him! And stay to dinner if you care to!" she called after
Pierre.

Pierre met the old count, who seemed nervous and upset. That morning
Natasha had told him that she had rejected Bolkonski.

"Troubles, troubles, my dear fellow!" he said to Pierre. "What
troubles one has with these girls without their mother! I do so regret
having come here.... I will be frank with you. Have you heard she
has broken off her engagement without consulting anybody? It's true
this engagement never was much to my liking. Of course he is an
excellent man, but still, with his father's disapproval they
wouldn't have been happy, and Natasha won't lack suitors. Still, it
has been going on so long, and to take such a step without father's or
mother's consent! And now she's ill, and God knows what! It's hard,
Count, hard to manage daughters in their mother's absence...."

Pierre saw that the count was much upset and tried to change the
subject, but the count returned to his troubles.

Sonya entered the room with an agitated face.

"Natasha is not quite well; she's in her room and would like to
see you. Marya Dmitrievna is with her and she too asks you to come."

"Yes, you are a great friend of Bolkonski's, no doubt she wants to
send him a message," said the count. "Oh dear! Oh dear! How happy it
all was!"

And clutching the spare gray locks on his temples the count left the
room.

When Marya Dmitrievna told Natasha that Anatole was married, Natasha
did not wish to believe it and insisted on having it confirmed by
Pierre himself. Sonya told Pierre this as she led him along the
corridor to Natasha's room.

Natasha, pale and stern, was sitting beside Marya Dmitrievna, and
her eyes, glittering feverishly, met Pierre with a questioning look
the moment he entered. She did not smile or nod, but only gazed
fixedly at him, and her look asked only one thing: was he a friend, or
like the others an enemy in regard to Anatole? As for Pierre, he
evidently did not exist for her.

"He knows all about it," said Marya Dmitrievna pointing to Pierre
and addressing Natasha. "Let him tell you whether I have told the
truth."

Natasha looked from one to the other as a hunted and wounded
animal looks at the approaching dogs and sportsmen.

"Natalya Ilynichna," Pierre began, dropping his eyes with a
feeling of pity for her and loathing for the thing he had to do,
"whether it is true or not should make no difference to you,
because..."

"Then it is not true that he's married!"

"Yes, it is true."

"Has he been married long?" she asked. "On your honor?..."

Pierre gave his word of honor.

"Is he still here?" she asked, quickly.

"Yes, I have just seen him."

She was evidently unable to speak and made a sign with her hands
that they should leave her alone.





CHAPTER XX


Pierre did not stay for dinner, but left the room and went away at
once. He drove through the town seeking Anatole Kuragin, at the
thought of whom now the blood rushed to his heart and he felt a
difficulty in breathing. He was not at the ice hills, nor at the
gypsies', nor at Komoneno's. Pierre drove to the Club. In the Club all
was going on as usual. The members who were assembling for dinner were
sitting about in groups; they greeted Pierre and spoke of the town
news. The footman having greeted him, knowing his habits and his
acquaintances, told him there was a place left for him in the small
dining room and that Prince Michael Zakharych was in the library,
but Paul Timofeevich had not yet arrived. One of Pierre's
acquaintances, while they were talking about the weather, asked if
he had heard of Kuragin's abduction of Rostova which was talked of
in the town, and was it true? Pierre laughed and said it was
nonsense for he had just come from the Rostovs'. He asked everyone
about Anatole. One man told him he had not come yet, and another
that he was coming to dinner. Pierre felt it strange to see this calm,
indifferent crowd of people unaware of what was going on in his
soul. He paced through the ballroom, waited till everyone had come,
and as Anatole had not turned up did not stay for dinner but drove
home.

Anatole, for whom Pierre was looking, dined that day with
Dolokhov, consulting him as to how to remedy this unfortunate
affair. It seemed to him essential to see Natasha. In the evening he
drove to his sister's to discuss with her how to arrange a meeting.
When Pierre returned home after vainly hunting all over Moscow, his
valet informed him that Prince Anatole was with the countess. The
countess' drawing room was full of guests.

Pierre without greeting his wife whom he had not seen since his
return--at that moment she was more repulsive to him than ever-
entered the drawing room and seeing Anatole went up to him.

"Ah, Pierre," said the countess going up to her husband. "You
don't know what a plight our Anatole..."

She stopped, seeing in the forward thrust of her husband's head,
in his glowing eyes and his resolute gait, the terrible indications of
that rage and strength which she knew and had herself experienced
after his duel with Dolokhov.

"Where you are, there is vice and evil!" said Pierre to his wife.
"Anatole, come with me! I must speak to you," he added in French.

Anatole glanced round at his sister and rose submissively, ready
to follow Pierre. Pierre, taking him by the arm, pulled him toward
himself and was leading him from the room.

"If you allow yourself in my drawing room..." whispered Helene,
but Pierre did not reply and went out of the room.

Anatole followed him with his usual jaunty step but his face
betrayed anxiety.

Having entered his study Pierre closed the door and addressed
Anatole without looking at him.

"You promised Countess Rostova to marry her and were about to
elope with her, is that so?"

"Mon cher," answered Anatole (their whole conversation was in
French), "I don't consider myself bound to answer questions put to
me in that tone."

Pierre's face, already pale, became distorted by fury. He seized
Anatole by the collar of his uniform with his big hand and shook him
from side to side till Anatole's face showed a sufficient degree of
terror.

"When I tell you that I must talk to you!..." repeated Pierre.

"Come now, this is stupid. What?" said Anatole, fingering a button
of his collar that had been wrenched loose with a bit of the cloth.

"You're a scoundrel and a blackguard, and I don't know what deprives
me from the pleasure of smashing your head with this!" said Pierre,
expressing himself so artificially because he was talking French.

He took a heavy paperweight and lifted it threateningly, but at once
put it back in its place.

"Did you promise to marry her?"

"I... I didn't think of it. I never promised, because..."

Pierre interrupted him.

"Have you any letters of hers? Any letters?" he said, moving
toward Anatole.

Anatole glanced at him and immediately thrust his hand into his
pocket and drew out his pocketbook.

Pierre took the letter Anatole handed him and, pushing aside a table
that stood in his way, threw himself on the sofa.

"I shan't be violent, don't be afraid!" said Pierre in answer to a
frightened gesture of Anatole's. "First, the letters," said he, as
if repeating a lesson to himself. "Secondly," he continued after a
short pause, again rising and again pacing the room, "tomorrow you
must get out of Moscow."

"But how can I?..."

"Thirdly," Pierre continued without listening to him, "you must
never breathe a word of what has passed between you and Countess
Rostova. I know I can't prevent your doing so, but if you have a spark
of conscience..." Pierre paced the room several times in silence.

Anatole sat at a table frowning and biting his lips.

"After all, you must understand that besides your pleasure there
is such a thing as other people's happiness and peace, and that you
are ruining a whole life for the sake of amusing yourself! Amuse
yourself with women like my wife--with them you are within your
rights, for they know what you want of them. They are armed against
you by the same experience of debauchery; but to promise a maid to
marry her... to deceive, to kidnap.... Don't you understand that it is
as mean as beating an old man or a child?..."

Pierre paused and looked at Anatole no longer with an angry but with
a questioning look.

"I don't know about that, eh?" said Anatole, growing more
confident as Pierre mastered his wrath. "I don't know that and don't
want to," he said, not looking at Pierre and with a slight tremor of
his lower jaw, "but you have used such words to me--'mean' and so
on--which as a man of honor I can't allow anyone to use."

Pierre glanced at him with amazement, unable to understand what he
wanted.

"Though it was tete-a-tete," Anatole continued, "still I can't..."

"Is it satisfaction you want?" said Pierre ironically.

"You could at least take back your words. What? If you want me to do
as you wish, eh?"

"I take them back, I take them back!" said Pierre, "and I ask you to
forgive me." Pierre involuntarily glanced at the loose button. "And if
you require money for your journey..."

Anatole smiled. The expression of that base and cringing smile,
which Pierre knew so well in his wife, revolted him.

"Oh, vile and heartless brood!" he exclaimed, and left the room.

Next day Anatole left for Petersburg.





CHAPTER XXI


Pierre drove to Marya Dmitrievna's to tell her of the fulfillment of
her wish that Kuragin should be banished from Moscow. The whole
house was in a state of alarm and commotion. Natasha was very ill,
having, as Marya Dmitrievna told him in secret, poisoned herself the
night after she had been told that Anatole was married, with some
arsenic she had stealthily procured. After swallowing a little she had
been so frightened that she woke Sonya and told her what she had done.
The necessary antidotes had been administered in time and she was
now out of danger, though still so weak that it was out of the
question to move her to the country, and so the countess had been sent
for. Pierre saw the distracted count, and Sonya, who had a
tear-stained face, but he could not see Natasha.

Pierre dined at the club that day and heard on all sides gossip
about the attempted abduction of Rostova. He resolutely denied these
rumors, assuring everyone that nothing had happened except that his
brother-in-law had proposed to her and been refused. It seemed to
Pierre that it was his duty to conceal the whole affair and
re-establish Natasha's reputation.

He was awaiting Prince Andrew's return with dread and went every day
to the old prince's for news of him.

Old Prince Bolkonski heard all the rumors current in the town from
Mademoiselle Bourienne and had read the note to Princess Mary in which
Natasha had broken off her engagement. He seemed in better spirits
than usual and awaited his son with great impatience.

Some days after Anatole's departure Pierre received a note from
Prince Andrew, informing him of his arrival and asking him to come
to see him.

As soon as he reached Moscow, Prince Andrew had received from his
father Natasha's note to Princess Mary breaking off her engagement
(Mademoiselle Bourienne had purloined it from Princess Mary and
given it to the old prince), and he heard from him the story of
Natasha's elopement, with additions.

Prince Andrew had arrived in the evening and Pierre came to see
him next morning. Pierre expected to find Prince Andrew in almost
the same state as Natasha and was therefore surprised on entering
the drawing room to hear him in the study talking in a loud animated
voice about some intrigue going on in Petersburg. The old prince's
voice and another now and then interrupted him. Princess Mary came out
to meet Pierre. She sighed, looking toward the door of the room
where Prince Andrew was, evidently intending to express her sympathy
with his sorrow, but Pierre saw by her face that she was glad both
at what had happened and at the way her brother had taken the news
of Natasha's faithlessness.

"He says he expected it," she remarked. "I know his pride will not
let him express his feelings, but still he has taken it better, far
better, than I expected. Evidently it had to be...."

"But is it possible that all is really ended?" asked Pierre.

Princess Mary looked at him with astonishment. She did not
understand how he could ask such a question. Pierre went into the
study. Prince Andrew, greatly changed and plainly in better health,
but with a fresh horizontal wrinkle between his brows, stood in
civilian dress facing his father and Prince Meshcherski, warmly
disputing and vigorously gesticulating. The conversation was about
Speranski--the news of whose sudden exile and alleged treachery had
just reached Moscow.

"Now he is censured and accused by all who were enthusiastic about
him a month ago," Prince Andrew was saying, "and by those who were
unable to understand his aims. To judge a man who is in disfavor and
to throw on him all the blame of other men's mistakes is very easy,
but I maintain that if anything good has been accomplished in this
reign it was done by him, by him alone."

He paused at the sight of Pierre. His face quivered and
immediately assumed a vindictive expression.

"Posterity will do him justice," he concluded, and at once turned to
Pierre.

"Well, how are you? Still getting stouter?" he said with
animation, but the new wrinkle on his forehead deepened. "Yes, I am
well," he said in answer to Pierre's question, and smiled.

To Pierre that smile said plainly: "I am well, but my health is
now of no use to anyone."

After a few words to Pierre about the awful roads from the Polish
frontier, about people he had met in Switzerland who knew Pierre,
and about M. Dessalles, whom he had brought from abroad to be his
son's tutor, Prince Andrew again joined warmly in the conversation
about Speranski which was still going on between the two old men.

"If there were treason, or proofs of secret relations with Napoleon,
they would have been made public," he said with warmth and haste. "I
do not, and never did, like Speranski personally, but I like justice!"

Pierre now recognized in his friend a need with which he was only
too familiar, to get excited and to have arguments about extraneous
matters in order to stifle thoughts that were too oppressive and too
intimate. When Prince Meshcherski had left, Prince Andrew took
Pierre's arm and asked him into the room that had been assigned him. A
bed had been made up there, and some open portmanteaus and trunks
stood about. Prince Andrew went to one and took out a small casket,
from which he drew a packet wrapped in paper. He did it all silently
and very quickly. He stood up and coughed. His face was gloomy and his
lips compressed.

"Forgive me for troubling you..."

Pierre saw that Prince Andrew was going to speak of Natasha, and his
broad face expressed pity and sympathy. This expression irritated
Prince Andrew, and in a determined, ringing, and unpleasant tone he
continued:

"I have received a refusal from Countess Rostova and have heard
reports of your brother-in-law having sought her hand, or something of
that kind. Is that true?"

"Both true and untrue," Pierre began; but Prince Andrew
interrupted him.

"Here are her letters and her portrait," said he.

He took the packet from the table and handed it to Pierre.

"Give this to the countess... if you see her."

"She is very ill," said Pierre.

"Then she is here still?" said Prince Andrew. "And Prince
Kuragin?" he added quickly.

"He left long ago. She has been at death's door."

"I much regret her illness," said Prince Andrew; and he smiled
like his father, coldly, maliciously, and unpleasantly.

"So Monsieur Kuragin has not honored Countess Rostova with his
hand?" said Prince Andrew, and he snorted several times.

"He could not marry, for he was married already," said Pierre.

Prince Andrew laughed disagreeably, again reminding one of his
father.

"And where is your brother-in-law now, if I may ask?" he said.

"He has gone to Peters... But I don't know," said Pierre.

"Well, it doesn't matter," said Prince Andrew. "Tell Countess
Rostova that she was and is perfectly free and that I wish her all
that is good."

Pierre took the packet. Prince Andrew, as if trying to remember
whether he had something more to say, or waiting to see if Pierre
would say anything, looked fixedly at him.

"I say, do you remember our discussion in Petersburg?" asked Pierre,
"about..."

"Yes," returned Prince Andrew hastily. "I said that a fallen woman
should be forgiven, but I didn't say I could forgive her. I can't."

"But can this be compared...?" said Pierre.

Prince Andrew interrupted him and cried sharply: "Yes, ask her
hand again, be magnanimous, and so on?... Yes, that would be very
noble, but I am unable to follow in that gentleman's footsteps. If you
wish to be my friend never speak to me of that... of all that! Well,
good-by. So you'll give her the packet?"

Pierre left the room and went to the old prince and Princess Mary.

The old man seemed livelier than usual. Princess Mary was the same
as always, but beneath her sympathy for her brother, Pierre noticed
her satisfaction that the engagement had been broken off. Looking at
them Pierre realized what contempt and animosity they all felt for the
Rostovs, and that it was impossible in their presence even to
mention the name of her who could give up Prince Andrew for anyone
else.

At dinner the talk turned on the war, the approach of which was
becoming evident. Prince Andrew talked incessantly, arguing now with
his father, now with the Swiss tutor Dessalles, and showing an
unnatural animation, the cause of which Pierre so well understood.





CHAPTER XXII


That same evening Pierre went to the Rostovs' to fulfill the
commission entrusted to him. Natasha was in bed, the count at the
Club, and Pierre, after giving the letters to Sonya, went to Marya
Dmitrievna who was interested to know how Prince Andrew had taken
the news. Ten minutes later Sonya came to Marya Dmitrievna.

"Natasha insists on seeing Count Peter Kirilovich," said she.

"But how? Are we to take him up to her? The room there has not
been tidied up."

"No, she has dressed and gone into the drawing room," said Sonya.

Marya Dmitrievna only shrugged her shoulders.

"When will her mother come? She has worried me to death! Now mind,
don't tell her everything!" said she to Pierre. "One hasn't the
heart to scold her, she is so much to be pitied, so much to be
pitied."

Natasha was standing in the middle of the drawing room, emaciated,
with a pale set face, but not at all shamefaced as Pierre expected
to find her. When he appeared at the door she grew flurried, evidently
undecided whether to go to meet him or to wait till he came up.

Pierre hastened to her. He thought she would give him her hand as
usual; but she, stepping up to him, stopped, breathing heavily, her
arms hanging lifelessly just in the pose she used to stand in when she
went to the middle of the ballroom to sing, but with quite a different
expression of face.

"Peter Kirilovich," she began rapidly, "Prince Bolkonski was your
friend--is your friend," she corrected herself. (It seemed to her that
everything that had once been must now be different.) "He told me once
to apply to you..."

Pierre sniffed as he looked at her, but did not speak. Till then
he had reproached her in his heart and tried to despise her, but he
now felt so sorry for her that there was no room in his soul for
reproach.

"He is here now: tell him... to for... forgive me!" She stopped
and breathed still more quickly, but did not shed tears.

"Yes... I will tell him," answered Pierre; "but..."

He did not know what to say.

Natasha was evidently dismayed at the thought of what he might think
she had meant.

"No, I know all is over," she said hurriedly. "No, that can never
be. I'm only tormented by the wrong I have done him. Tell him only
that I beg him to forgive, forgive, forgive me for everything...."

She trembled all over and sat down on a chair.

A sense of pity he had never before known overflowed Pierre's heart.

"I will tell him, I will tell him everything once more," said
Pierre. "But... I should like to know one thing...."

"Know what?" Natasha's eyes asked.

"I should like to know, did you love..." Pierre did not know how
to refer to Anatole and flushed at the thought of him--"did you love
that bad man?"

"Don't call him bad!" said Natasha. "But I don't know, don't know at
all...."

She began to cry and a still greater sense of pity, tenderness,
and love welled up in Pierre. He felt the tears trickle under his
spectacles and hoped they would not be noticed.

"We won't speak of it any more, my dear," said Pierre, and his
gentle, cordial tone suddenly seemed very strange to Natasha.

"We won't speak of it, my dear--I'll tell him everything; but one
thing I beg of you, consider me your friend and if you want help,
advice, or simply to open your heart to someone--not now, but when
your mind is clearer think of me!" He took her hand and kissed it.
"I shall be happy if it's in my power..."

Pierre grew confused.

"Don't speak to me like that. I am not worth it!" exclaimed
Natasha and turned to leave the room, but Pierre held her hand.

He knew he had something more to say to her. But when he said it
he was amazed at his own words.

"Stop, stop! You have your whole life before you," said he to her.

"Before me? No! All is over for me," she replied with shame and
self-abasement.

 "All over?" he repeated. "If I were not myself, but the handsomest,
cleverest, and best man in the world, and were free, I would this
moment ask on my knees for your hand and your love!"

For the first time for many days Natasha wept tears of gratitude and
tenderness, and glancing at Pierre she went out of the room.

Pierre too when she had gone almost ran into the anteroom,
restraining tears of tenderness and joy that choked him, and without
finding the sleeves of his fur cloak threw it on and got into his
sleigh.

"Where to now, your excellency?" asked the coachman.

"Where to?" Pierre asked himself. "Where can I go now? Surely not to
the Club or to pay calls?" All men seemed so pitiful, so poor, in
comparison with this feeling of tenderness and love he experienced: in
comparison with that softened, grateful, last look she had given him
through her tears.

"Home!" said Pierre, and despite twenty-two degrees of frost
Fahrenheit he threw open the bearskin cloak from his broad chest and
inhaled the air with joy.

It was clear and frosty. Above the dirty, ill-lit streets, above the
black roofs, stretched the dark starry sky. Only looking up at the sky
did Pierre cease to feel how sordid and humiliating were all mundane
things compared with the heights to which his soul had just been
raised. At the entrance to the Arbat Square an immense expanse of dark
starry sky presented itself to his eyes. Almost in the center of it,
above the Prechistenka Boulevard, surrounded and sprinkled on all
sides by stars but distinguished from them all by its nearness to
the earth, its white light, and its long uplifted tail, shone the
enormous and brilliant comet of 1812--the comet which was said to
portend all kinds of woes and the end of the world. In Pierre,
however, that comet with its long luminous tail aroused no feeling
of fear. On the contrary he gazed joyfully, his eyes moist with tears,
at this bright comet which, having traveled in its orbit with
inconceivable velocity through immeasurable space, seemed suddenly-
like an arrow piercing the earth--to remain fixed in a chosen spot,
vigorously holding its tail erect, shining and displaying its white
light amid countless other scintillating stars. It seemed to Pierre
that this comet fully responded to what was passing in his own
softened and uplifted soul, now blossoming into a new life.





BOOK NINE: 1812





CHAPTER I


From the close of the year 1811 intensified arming and concentrating
of the forces of Western Europe began, and in 1812 these forces-
millions of men, reckoning those transporting and feeding the army-
moved from the west eastwards to the Russian frontier, toward which
since 1811 Russian forces had been similarly drawn. On the twelfth
of June, 1812, the forces of Western Europe crossed the Russian
frontier and war began, that is, an event took place opposed to
human reason and to human nature. Millions of men perpetrated
against one another such innumerable crimes, frauds, treacheries,
thefts, forgeries, issues of false money, burglaries, incendiarisms,
and murders as in whole centuries are not recorded in the annals of
all the law courts of the world, but which those who committed them
did not at the time regard as being crimes.

What produced this extraordinary occurrence? What were its causes?
The historians tell us with naive assurance that its causes were the
wrongs inflicted on the Duke of Oldenburg, the nonobservance of the
Continental System, the ambition of Napoleon, the firmness of
Alexander, the mistakes of the diplomatists, and so on.

Consequently, it would only have been necessary for Metternich,
Rumyantsev, or Talleyrand, between a levee and an evening party, to
have taken proper pains and written a more adroit note, or for
Napoleon to have written to Alexander: "My respected Brother, I
consent to restore the duchy to the Duke of Oldenburg"--and there
would have been no war.

We can understand that the matter seemed like that to
contemporaries. It naturally seemed to Napoleon that the war was
caused by England's intrigues (as in fact he said on the island of St.
Helena). It naturally seemed to members of the English Parliament that
the cause of the war was Napoleon's ambition; to the Duke of
Oldenburg, that the cause of the war was the violence done to him;
to businessmen that the cause of the way was the Continental System
which was ruining Europe; to the generals and old soldiers that the
chief reason for the war was the necessity of giving them
employment; to the legitimists of that day that it was the need of
re-establishing les bons principes, and to the diplomatists of that
time that it all resulted from the fact that the alliance between
Russia and Austria in 1809 had not been sufficiently well concealed
from Napoleon, and from the awkward wording of Memorandum No. 178.
It is natural that these and a countless and infinite quantity of
other reasons, the number depending on the endless diversity of points
of view, presented themselves to the men of that day; but to us, to
posterity who view the thing that happened in all its magnitude and
perceive its plain and terrible meaning, these causes seem
insufficient. To us it is incomprehensible that millions of
Christian men killed and tortured each other either because Napoleon
was ambitious or Alexander was firm, or because England's policy was
astute or the Duke of Oldenburg wronged. We cannot grasp what
connection such circumstances have with the actual fact of slaughter
and violence: why because the Duke was wronged, thousands of men
from the other side of Europe killed and ruined the people of Smolensk
and Moscow and were killed by them.

To us, their descendants, who are not historians and are not carried
away by the process of research and can therefore regard the event
with unclouded common sense, an incalculable number of causes
present themselves. The deeper we delve in search of these causes
the more of them we find; and each separate cause or whole series of
causes appears to us equally valid in itself and equally false by
its insignificance compared to the magnitude of the events, and by its
impotence--apart from the cooperation of all the other coincident
causes--to occasion the event. To us, the wish or objection of this or
that French corporal to serve a second term appears as much a cause as
Napoleon's refusal to withdraw his troops beyond the Vistula and to
restore the duchy of Oldenburg; for had he not wished to serve, and
had a second, a third, and a thousandth corporal and private also
refused, there would have been so many less men in Napoleon's army and
the war could not have occurred.

Had Napoleon not taken offense at the demand that he should withdraw
beyond the Vistula, and not ordered his troops to advance, there would
have been no war; but had all his sergeants objected to serving a
second term then also there could have been no war. Nor could there
have been a war had there been no English intrigues and no Duke of
Oldenburg, and had Alexander not felt insulted, and had there not been
an autocratic government in Russia, or a Revolution in France and a
subsequent dictatorship and Empire, or all the things that produced
the French Revolution, and so on. Without each of these causes nothing
could have happened. So all these causes--myriads of causes--coincided
to bring it about. And so there was no one cause for that
occurrence, but it had to occur because it had to. Millions of men,
renouncing their human feelings and reason, had to go from west to
east to slay their fellows, just as some centuries previously hordes
of men had come from the east to the west, slaying their fellows.

The actions of Napoleon and Alexander, on whose words the event
seemed to hang, were as little voluntary as the actions of any soldier
who was drawn into the campaign by lot or by conscription. This
could not be otherwise, for in order that the will of Napoleon and
Alexander (on whom the event seemed to depend) should be carried
out, the concurrence of innumerable circumstances was needed without
any one of which the event could not have taken place. It was
necessary that millions of men in whose hands lay the real power-
the soldiers who fired, or transported provisions and guns--should
consent to carry out the will of these weak individuals, and should
have been induced to do so by an infinite number of diverse and
complex causes.

We are forced to fall back on fatalism as an explanation of
irrational events (that is to say, events the reasonableness of
which we do not understand). The more we try to explain such events in
history reasonably, the more unreasonable and incomprehensible do they
become to us.

Each man lives for himself, using his freedom to attain his personal
aims, and feels with his whole being that he can now do or abstain
from doing this or that action; but as soon as he has done it, that
action performed at a certain moment in time becomes irrevocable and
belongs to history, in which it has not a free but a predestined
significance.

There are two sides to the life of every man, his individual life,
which is the more free the more abstract its interests, and his
elemental hive life in which he inevitably obeys laws laid down for
him.

Man lives consciously for himself, but is an unconscious
instrument in the attainment of the historic, universal, aims of
humanity. A deed done is irrevocable, and its result coinciding in
time with the actions of millions of other men assumes an historic
significance. The higher a man stands on the social ladder, the more
people he is connected with and the more power he has over others, the
more evident is the predestination and inevitability of his every
action.

"The king's heart is in the hands of the Lord."

A king is history's slave.

History, that is, the unconscious, general, hive life of mankind,
uses every moment of the life of kings as a tool for its own purposes.

Though Napoleon at that time, in 1812, was more convinced than
ever that it depended on him, verser (ou ne pas verser) le sang de ses
peuples*--as Alexander expressed it in the last letter he wrote him-
he had never been so much in the grip of inevitable laws, which
compelled him, while thinking that he was acting on his own
volition, to perform for the hive life--that is to say, for history-
whatever had to be performed.


*"To shed (or not to shed) the blood of his peoples."


The people of the west moved eastwards to slay their fellow men, and
by the law of coincidence thousands of minute causes fitted in and
co-ordinated to produce that movement and war: reproaches for the
nonobservance of the Continental System, the Duke of Oldenburg's
wrongs, the movement of troops into Prussia--undertaken (as it
seemed to Napoleon) only for the purpose of securing an armed peace,
the French Emperor's love and habit of war coinciding with his
people's inclinations, allurement by the grandeur of the preparations,
and the expenditure on those preparations and the need of obtaining
advantages to compensate for that expenditure, the intoxicating honors
he received in Dresden, the diplomatic negotiations which, in the
opinion of contemporaries, were carried on with a sincere desire to
attain peace, but which only wounded the self-love of both sides,
and millions of other causes that adapted themselves to
the event that was happening or coincided with it.

When an apple has ripened and falls, why does it fall? Because of
its attraction to the earth, because its stalk withers, because it
is dried by the sun, because it grows heavier, because the wind shakes
it, or because the boy standing below wants to eat it?

Nothing is the cause. All this is only the coincidence of conditions
in which all vital organic and elemental events occur. And the
botanist who finds that the apple falls because the cellular tissue
decays and so forth is equally right with the child who stands under
the tree and says the apple fell because he wanted to eat it and
prayed for it. Equally right or wrong is he who says that Napoleon
went to Moscow because he wanted to, and perished because Alexander
desired his destruction, and he who says that an undermined hill
weighing a million tons fell because the last navvy struck it for
the last time with his mattock. In historic events the so-called great
men are labels giving names to events, and like labels they have but
the smallest connection with the event itself.

Every act of theirs, which appears to them an act of their own will,
is in an historical sense involuntary and is related to the whole
course of history and predestined from eternity.





CHAPTER II


On the twenty-ninth of May Napoleon left Dresden, where he had spent
three weeks surrounded by a court that included princes, dukes, kings,
and even an emperor. Before leaving, Napoleon showed favor to the
emperor, kings, and princes who had deserved it, reprimanded the kings
and princes with whom he was dissatisfied, presented pearls and
diamonds of his own--that is, which he had taken from other kings-
to the Empress of Austria, and having, as his historian tells us,
tenderly embraced the Empress Marie Louise--who regarded him as her
husband, though he had left another wife in Paris--left her grieved by
the parting which she seemed hardly able to bear. Though the
diplomatists still firmly believed in the possibility of peace and
worked zealously to that end, and though the Emperor Napoleon
himself wrote a letter to Alexander, calling him Monsieur mon frere,
and sincerely assured him that he did not want war and would always
love and honor him--yet he set off to join his army, and at every
station gave fresh orders to accelerate the movement of his troops
from west to east. He went in a traveling coach with six horses,
surrounded by pages, aides-de-camp, and an escort, along the road to
Posen, Thorn, Danzig, and Konigsberg. At each of these towns thousands
of people met him with excitement and enthusiasm.

The army was moving from west to east, and relays of six horses
carried him in the same direction. On the tenth of June,* coming up
with the army, he spent the night in apartments prepared for him on
the estate of a Polish count in the Vilkavisski forest.


*Old style.


Next day, overtaking the army, he went in a carriage to the
Niemen, and, changing into a Polish uniform, he drove to the riverbank
in order to select a place for the crossing.

Seeing, on the other side, some Cossacks (les Cosaques) and the
wide-spreading steppes in the midst of which lay the holy city of
Moscow (Moscou, la ville sainte), the capital of a realm such as the
Scythia into which Alexander the Great had marched--Napoleon
unexpectedly, and contrary alike to strategic and diplomatic
considerations, ordered an advance, and the next day his army began to
cross the Niemen.

Early in the morning of the twelfth of June he came out of his tent,
which was pitched that day on the steep left bank of the Niemen, and
looked through a spyglass at the streams of his troops pouring out
of the Vilkavisski forest and flowing over the three bridges thrown
across the river. The troops, knowing of the Emperor's presence,
were on the lookout for him, and when they caught sight of a figure in
an overcoat and a cocked hat standing apart from his suite in front of
his tent on the hill, they threw up their caps and shouted: "Vive
l'Empereur!" and one after another poured in a ceaseless stream out of
the vast forest that had concealed them and, separating, flowed on and
on by the three bridges to the other side.

"Now we'll go into action. Oh, when he takes it in hand himself,
things get hot... by heaven!... There he is!... Vive l'Empereur! So
these are the steppes of Asia! It's a nasty country all the same. Au
revoir, Beauche; I'll keep the best palace in Moscow for you! Au
revoir. Good luck!... Did you see the Emperor? Vive l'Empereur!...
preur!--If they make me Governor of India, Gerard, I'll make you
Minister of Kashmir--that's settled. Vive l'Empereur! Hurrah!
hurrah! hurrah! The Cossacks--those rascals--see how they run! Vive
l'Empereur! There he is, do you see him? I've seen him twice, as I see
you now. The little corporal... I saw him give the cross to one of the
veterans.... Vive l'Empereur!" came the voices of men, old and
young, of most diverse characters and social positions. On the faces
of all was one common expression of joy at the commencement of the
long-expected campaign and of rapture and devotion to the man in the
gray coat who was standing on the hill.

On the thirteenth of June a rather small, thoroughbred Arab horse
was brought to Napoleon. He mounted it and rode at a gallop to one
of the bridges over the Niemen, deafened continually by incessant
and rapturous acclamations which he evidently endured only because
it was impossible to forbid the soldiers to express their love of
him by such shouting, but the shouting which accompanied him
everywhere disturbed him and distracted him from the military cares
that had occupied him from the time he joined the army. He rode across
one of the swaying pontoon bridges to the farther side, turned sharply
to the left, and galloped in the direction of Kovno, preceded by
enraptured, mounted chasseurs of the Guard who, breathless with
delight, galloped ahead to clear a path for him through the troops. On
reaching the broad river Viliya, he stopped near a regiment of
Polish Uhlans stationed by the river.

"Vivat!" shouted the Poles, ecstatically, breaking their ranks and
pressing against one another to see him.

Napoleon looked up and down the river, dismounted, and sat down on a
log that lay on the bank. At a mute sign from him, a telescope was
handed him which he rested on the back of a happy page who had run
up to him, and he gazed at the opposite bank. Then he became
absorbed in a map laid out on the logs. Without lifting his head he
said something, and two of his aides-de-camp galloped off to the
Polish Uhlans.

"What? What did he say?" was heard in the ranks of the Polish Uhlans
when one of the aides-de-camp rode up to them.

The order was to find a ford and to cross the river. The colonel
of the Polish Uhlans, a handsome old man, flushed and, fumbling in his
speech from excitement, asked the aide-de-camp whether he would be
permitted to swim the river with his Uhlans instead of seeking a ford.
In evident fear of refusal, like a boy asking for permission to get on
a horse, he begged to be allowed to swim across the river before the
Emperor's eyes. The aide-de-camp replied that probably the Emperor
would not be displeased at this excess of zeal.

As soon as the aide-de-camp had said this, the old mustached
officer, with happy face and sparkling eyes, raised his saber, shouted
"Vivat!" and, commanding the Uhlans to follow him, spurred his horse
and galloped into the river. He gave an angry thrust to his horse,
which had grown restive under him, and plunged into the water, heading
for the deepest part where the current was swift. Hundreds of Uhlans
galloped in after him. It was cold and uncanny in the rapid current in
the middle of the stream, and the Uhlans caught hold of one another as
they fell off their horses. Some of the horses were drowned and some
of the men; the others tried to swim on, some in the saddle and some
clinging to their horses' manes. They tried to make their way
forward to the opposite bank and, though there was a ford one third of
a mile away, were proud that they were swimming and drowning in this
river under the eyes of the man who sat on the log and was not even
looking at what they were doing. When the aide-de-camp, having
returned and choosing an opportune moment, ventured to draw the
Emperor's attention to the devotion of the Poles to his person, the
little man in the gray overcoat got up and, having summoned
Berthier, began pacing up and down the bank with him, giving him
instructions and occasionally glancing disapprovingly at the
drowning Uhlans who distracted his attention.

For him it was no new conviction that his presence in any part of
the world, from Africa to the steppes of Muscovy alike, was enough
to dumfound people and impel them to insane self-oblivion. He called
for his horse and rode to his quarters.

Some forty Uhlans were drowned in the river, though boats were
sent to their assistance. The majority struggled back to the bank from
which they had started. The colonel and some of his men got across and
with difficulty clambered out on the further bank. And as soon as they
had got out, in their soaked and streaming clothes, they shouted
"Vivat!" and looked ecstatically at the spot where Napoleon had been
but where he no longer was and at that moment considered themselves
happy.

That evening, between issuing one order that the forged Russian
paper money prepared for use in Russia should be delivered as
quickly as possible and another that a Saxon should be shot, on whom a
letter containing information about the orders to the French army
had been found, Napoleon also gave instructions that the Polish
colonel who had needlessly plunged into the river should be enrolled
in the Legion d'honneur of which Napoleon was himself the head.

Quos vult perdere dementat.*


*Those whom (God) wishes to destroy he drives mad.





CHAPTER III


The Emperor of Russia had, meanwhile, been in Vilna for more than
a month, reviewing troops and holding maneuvers. Nothing was ready for
the war that everyone expected and to prepare for which the Emperor
had come from Petersburg. There was no general plan of action. The
vacillation between the various plans that were proposed had even
increased after the Emperor had been at headquarters for a month. Each
of the three armies had its own commander in chief, but there was no
supreme commander of all the forces, and the Emperor did not assume
that responsibility himself.

The longer the Emperor remained in Vilna the less did everybody-
tired of waiting--prepare for the war. All the efforts of those who
surrounded the sovereign seemed directed merely to making him spend
his time pleasantly and forget that war was impending.

In June, after many balls and fetes given by the Polish magnates, by
the courtiers, and by the Emperor himself, it occurred to one of the
Polish aides-de-camp in attendance that a dinner and ball should be
given for the Emperor by his aides-de-camp. This idea was eagerly
received. The Emperor gave his consent. The aides-de-camp collected
money by subscription. The lady who was thought to be most pleasing to
the Emperor was invited to act as hostess. Count Bennigsen, being a
landowner in the Vilna province, offered his country house for the
fete, and the thirteenth of June was fixed for a ball, dinner,
regatta, and fireworks at Zakret, Count Bennigsen's country seat.


The very day that Napoleon issued the order to cross the Niemen, and
his vanguard, driving off the Cossacks, crossed the Russian
frontier, Alexander spent the evening at the entertainment given by
his aides-de-camp at Bennigsen's country house.

It was a gay and brilliant fete. Connoisseurs of such matters
declared that rarely had so many beautiful women been assembled in one
place. Countess Bezukhova was present among other Russian ladies who
had followed the sovereign from Petersburg to Vilna and eclipsed the
refined Polish ladies by her massive, so called Russian type of
beauty. The Emperor noticed her and honored her with a dance.

Boris Drubetskoy, having left his wife in Moscow and being for the
present en garcon (as he phrased it), was also there and, though not
an aide-de-camp, had subscribed a large sum toward the expenses. Boris
was now a rich man who had risen to high honors and no longer sought
patronage but stood on an equal footing with the highest of those of
his own age. He was meeting Helene in Vilna after not having seen
her for a long time and did not recall the past, but as Helene was
enjoying the favors of a very important personage and Boris had only
recently married, they met as good friends of long standing.

At midnight dancing was still going on. Helene, not having a
suitable partner, herself offered to dance the mazurka with Boris.
They were the third couple. Boris, coolly looking at Helene's dazzling
bare shoulders which emerged from a dark, gold-embroidered, gauze
gown, talked to her of old acquaintances and at the same time, unaware
of it himself and unnoticed by others, never for an instant ceased
to observe the Emperor who was in the same room. The Emperor was not
dancing, he stood in the doorway, stopping now one pair and now
another with gracious words which he alone knew how to utter.

As the mazurka began, Boris saw that Adjutant General Balashev,
one of those in closest attendance on the Emperor, went up to him
and contrary to court etiquette stood near him while he was talking to
a Polish lady. Having finished speaking to her, the Emperor looked
inquiringly at Balashev and, evidently understanding that he only
acted thus because there were important reasons for so doing, nodded
slightly to the lady and turned to him. Hardly had Balashev begun to
speak before a look of amazement appeared on the Emperor's face. He
took Balashev by the arm and crossed the room with him,
unconsciously clearing a path seven yards wide as the people on both
sides made way for him. Boris noticed Arakcheev's excited face when
the sovereign went out with Balashev. Arakcheev looked at the
Emperor from under his brow and, sniffing with his red nose, stepped
forward from the crowd as if expecting the Emperor to address him.
(Boris understood that Arakcheev envied Balashev and was displeased
that evidently important news had reached the Emperor otherwise than
through himself.)

But the Emperor and Balashev passed out into the illuminated
garden without noticing Arakcheev who, holding his sword and
glancing wrathfully around, followed some twenty paces behind them.

All the time Boris was going through the figures of the mazurka,
he was worried by the question of what news Balashev had brought and
how he could find it out before others. In the figure in which he
had to choose two ladies, he whispered to Helene that he meant to
choose Countess Potocka who, he thought, had gone out onto the
veranda, and glided over the parquet to the door opening into the
garden, where, seeing Balashev and the Emperor returning to the
veranda, he stood still. They were moving toward the door. Boris,
fluttering as if he had not had time to withdraw, respectfully pressed
close to the doorpost with bowed head.

The Emperor, with the agitation of one who has been personally
affronted, was finishing with these words:

"To enter Russia without declaring war! I will not make peace as
long as a single armed enemy remains in my country!" It seemed to
Boris that it gave the Emperor pleasure to utter these words. He was
satisfied with the form in which he had expressed his thoughts, but
displeased that Boris had overheard it.

"Let no one know of it!" the Emperor added with a frown.

Boris understood that this was meant for him and, closing his
eyes, slightly bowed his head. The Emperor re-entered the ballroom and
remained there about another half-hour.

Boris was thus the first to learn the news that the French army
had crossed the Niemen and, thanks to this, was able to show certain
important personages that much that was concealed from others was
usually known to him, and by this means he rose higher in their
estimation.


The unexpected news of the French having crossed the Niemen was
particularly startling after a month of unfulfilled expectations,
and at a ball. On first receiving the news, under the influence of
indignation and resentment the Emperor had found a phrase that pleased
him, fully expressed his feelings, and has since become famous. On
returning home at two o'clock that night he sent for his secretary,
Shishkov, and told him to write an order to the troops and a
rescript to Field Marshal Prince Saltykov, in which he insisted on the
words being inserted that he would not make peace so long as a
single armed Frenchman remained on Russian soil.

Next day the following letter was sent to Napoleon:


Monsieur mon frere,

Yesterday I learned that, despite the loyalty which I have kept my
engagements with Your Majesty, your troops have crossed the Russian
frontier, and I have this moment received from Petersburg a note, in
which Count Lauriston informs me, as a reason for this aggression,
that Your Majesty has considered yourself to be in a state of war with
me from the time Prince Kuragin asked for his passports. The reasons
on which the Duc de Bassano based his refusal to deliver them to him
would never have led me to suppose that that could serve as a
pretext for aggression. In fact, the ambassador, as he himself has
declared, was never authorized to make that demand, and as soon as I
was informed of it I let him know how much I disapproved of it and
ordered him to remain at his post. If Your Majesty does not intend
to shed the blood of our peoples for such a misunderstanding, and
consents to withdraw your troops from Russian territory, I will regard
what has passed as not having occurred and an understanding between us
will be possible. In the contrary case, Your Majesty, I shall see
myself forced to repel an attack that nothing on my part has provoked.
It still depends on Your Majesty to preserve humanity from the
calamity of another war. I am, etc.,
                                         (signed) Alexander





CHAPTER IV


At two in the morning of the fourteenth of June, the Emperor, having
sent for Balashev and read him his letter to Napoleon, ordered him
to take it and hand it personally to the French Emperor. When
dispatching Balashev, the Emperor repeated to him the words that he
would not make peace so long as a single armed enemy remained on
Russian soil and told him to transmit those words to Napoleon.
Alexander did not insert them in his letter to Napoleon, because
with his characteristic tact he felt it would be injudicious to use
them at a moment when a last attempt at reconciliation was being made,
but he definitely instructed Balashev to repeat them personally to
Napoleon.

Having set off in the small hours of the fourteenth, accompanied
by a bugler and two Cossacks, Balashev reached the French outposts
at the village of Rykonty, on the Russian side of the Niemen, by dawn.
There he was stopped by French cavalry sentinels.

A French noncommissioned officer of hussars, in crimson uniform
and a shaggy cap, shouted to the approaching Balashev to halt.
Balashev did not do so at once, but continued to advance along the
road at a walking pace.

The noncommissioned officer frowned and, muttering words of abuse,
advanced his horse's chest against Balashev, put his hand to his
saber, and shouted rudely at the Russian general, asking: was he
deaf that he did not do as he was told? Balashev mentioned who he was.
The noncommissioned officer began talking with his comrades about
regimental matters without looking at the Russian general.

After living at the seat of the highest authority and power, after
conversing with the Emperor less than three hours before, and in
general being accustomed to the respect due to his rank in the
service, Balashev found it very strange here on Russian soil to
encounter this hostile, and still more this disrespectful, application
of brute force to himself.

The sun was only just appearing from behind the clouds, the air
was fresh and dewy. A herd of cattle was being driven along the road
from the village, and over the fields the larks rose trilling, one
after another, like bubbles rising in water.

Balashev looked around him, awaiting the arrival of an officer
from the village. The Russian Cossacks and bugler and the French
hussars looked silently at one another from time to time.

A French colonel of hussars, who had evidently just left his bed,
came riding from the village on a handsome sleek gray horse,
accompanied by two hussars. The officer, the soldiers, and their
horses all looked smart and well kept.

It was that first period of a campaign when troops are still in full
trim, almost like that of peacetime maneuvers, but with a shade of
martial swagger in their clothes, and a touch of the gaiety and spirit
of enterprise which always accompany the opening of a campaign.

The French colonel with difficulty repressed a yawn, but was
polite and evidently understood Balashev's importance. He led him past
his soldiers and behind the outposts and told him that his wish to
be presented to the Emperor would most likely be satisfied
immediately, as the Emperor's quarters were, he believed, not far off.

They rode through the village of Rykonty, past tethered French
hussar horses, past sentinels and men who saluted their colonel and
stared with curiosity at a Russian uniform, and came out at the
other end of the village. The colonel said that the commander of the
division was a mile and a quarter away and would receive Balashev
and conduct him to his destination.

The sun had by now risen and shone gaily on the bright verdure.

They had hardly ridden up a hill, past a tavern, before they saw a
group of horsemen coming toward them. In front of the group, on a
black horse with trappings that glittered in the sun, rode a tall
man with plumes in his hat and black hair curling down to his
shoulders. He wore a red mantle, and stretched his long legs forward
in French fashion. This man rode toward Balashev at a gallop, his
plumes flowing and his gems and gold lace glittering in the bright
June sunshine.

Balashev was only two horses' length from the equestrian with the
bracelets, plunies, necklaces, and gold embroidery, who was
galloping toward him with a theatrically solemn countenance, when
Julner, the French colonel, whispered respectfully: "The King of
Naples!" It was, in fact, Murat, now called "King of Naples." Though
it was quite incomprehensible why he should be King of Naples, he
was called so, and was himself convinced that he was so, and therefore
assumed a more solemn and important air than formerly. He was so
sure that he really was the King of Naples that when, on the eve of
his departure from that city, while walking through the streets with
his wife, some Italians called out to him: "Viva il re!"* he turned to
his wife with a pensive smile and said: "Poor fellows, they don't know
that I am leaving them tomorrow!"


*"Long live the king."


But though he firmly believed himself to be King of Naples and
pitied the grief felt by the subjects he was abandoning, latterly,
after he had been ordered to return to military service--and
especially since his last interview with Napoleon in Danzig, when
his august brother-in-law had told him: "I made you King that you
should reign in my way, but not in yours!"--he had cheerfully taken up
his familiar business, and--like a well-fed but not overfat horse that
feels himself in harness and grows skittish between the shafts--he
dressed up in clothes as variegated and expensive as possible, and
gaily and contentedly galloped along the roads of Poland, without
himself knowing why or whither.

On seeing the Russian general he threw back his head, with its
long hair curling to his shoulders, in a majestically royal manner,
and looked inquiringly at the French colonel. The colonel respectfully
informed His Majesty of Balashev's mission, whose name he could not
pronounce.

"De Bal-macheve!" said the King (overcoming by his assurance the
difficulty that had presented itself to the colonel). "Charmed to make
your acquaintance, General!" he added, with a gesture of kingly
condescension.

As soon as the King began to speak loud and fast his royal dignity
instantly forsook him, and without noticing it he passed into his
natural tone of good-natured familiarity. He laid his hand on the
withers of Balashev's horse and said:

"Well, General, it all looks like war," as if regretting a
circumstance of which he was unable to judge.

"Your Majesty," replied Balashev, "my master, the Emperor, does
not desire war and as Your Majesty sees..." said Balashev, using the
words Your Majesty at every opportunity, with the affectation
unavoidable in frequently addressing one to whom the title was still a
novelty.

Murat's face beamed with stupid satisfaction as he listened to
"Monsieur de Bal-macheve." But royaute oblige!* and he felt it
incumbent on him, as a king and an ally, to confer on state affairs
with Alexander's envoy. He dismounted, took Balashev's arm, and moving
a few steps away from his suite, which waited respectfully, began to
pace up and down with him, trying to speak significantly. He
referred to the fact that the Emperor Napoleon had resented the demand
that he should withdraw his troops from Prussia, especially when
that demand became generally known and the dignity of France was
thereby offended.


*"Royalty has its obligations."


Balashev replied that there was "nothing offensive in the demand,
because..." but Murat interrupted him.

"Then you don't consider the Emperor Alexander the aggressor?" he
asked unexpectedly, with a kindly and foolish smile.

Balashev told him why he considered Napoleon to be the originator of
the war.

"Oh, my dear general!" Murat again interrupted him, "with all my
heart I wish the Emperors may arrange the affair between them, and
that the war begun by no wish of mine may finish as quickly as
possible!" said he, in the tone of a servant who wants to remain
good friends with another despite a quarrel between their masters.

And he went on to inquiries about the Grand Duke and the state of
his health, and to reminiscences of the gay and amusing times he had
spent with him in Naples. Then suddenly, as if remembering his royal
dignity, Murat solemnly drew himself up, assumed the pose in which
he had stood at his coronation, and, waving his right arm, said:

"I won't detain you longer, General. I wish success to your
mission," and with his embroidered red mantle, his flowing feathers,
and his glittering ornaments, he rejoined his suite who were
respectfully awaiting him.

Balashev rode on, supposing from Murat's words that he would very
soon be brought before Napoleon himself. But instead of that, at the
next village the sentinels of Davout's infantry corps detained him
as the pickets of the vanguard had done, and an adjutant of the
corps commander, who was fetched, conducted him into the village to
Marshal Davout.





CHAPTER V


Davout was to Napoleon what Arakcheev was to Alexander--though not a
coward like Arakcheev, he was as precise, as cruel, and as unable to
express his devotion to his monarch except by cruelty.

In the organism of states such men are necessary, as wolves are
necessary in the organism of nature, and they always exist, always
appear and hold their own, however incongruous their presence and
their proximity to the head of the government may be. This
inevitability alone can explain how the cruel Arakcheev, who tore
out a grenadier's mustache with his own hands, whose weak nerves
rendered him unable to face danger, and who was neither an educated
man nor a courtier, was able to maintain his powerful position with
Alexander, whose own character was chivalrous, noble, and gentle.

Balashev found Davout seated on a barrel in the shed of a
peasant's hut, writing--he was auditing accounts. Better quarters
could have been found him, but Marshal Davout was one of those men who
purposely put themselves in most depressing conditions to have a
justification for being gloomy. For the same reason they are always
hard at work and in a hurry. "How can I think of the bright side of
life when, as you see, I am sitting on a barrel and working in a dirty
shed?" the expression of his face seemed to say. The chief pleasure
and necessity of such men, when they encounter anyone who shows
animation, is to flaunt their own dreary, persistent activity.
Davout allowed himself that pleasure when Balashev was brought in.
He became still more absorbed in his task when the Russian general
entered, and after glancing over his spectacles at Balashev's face,
which was animated by the beauty of the morning and by his talk with
Murat, he did not rise or even stir, but scowled still more and
sneered malevolently.

When he noticed in Balashev's face the disagreeable impression
this reception produced, Davout raised his head and coldly asked
what he wanted.

Thinking he could have been received in such a manner only because
Davout did not know that he was adjutant general to the Emperor
Alexander and even his envoy to Napoleon, Balashev hastened to
inform him of his rank and mission. Contrary to his expectation,
Davout, after hearing him, became still surlier and ruder.

"Where is your dispatch?" he inquired. "Give it to me. I will send
it to the Emperor."

Balashev replied that he had been ordered to hand it personally to
the Emperor.

"Your Emperor's orders are obeyed in your army, but here," said
Davout, "you must do as you're told."

And, as if to make the Russian general still more conscious of his
dependence on brute force, Davout sent an adjutant to call the officer
on duty.

Balashev took out the packet containing the Emperor's letter and
laid it on the table (made of a door with its hinges still hanging
on it, laid across two barrels). Davout took the packet and read the
inscription.

"You are perfectly at liberty to treat me with respect or not,"
protested Balashev, "but permit me to observe that I have the honor to
be adjutant general to His Majesty...."

Davout glanced at him silently and plainly derived pleasure from the
signs of agitation and confusion which appeared on Balashev's face.

"You will be treated as is fitting," said he and, putting the packet
in his pocket, left the shed.

A minute later the marshal's adjutant, de Castres, came in and
conducted Balashev to the quarters assigned him.

That day he dined with the marshal, at the same board on the
barrels.

Next day Davout rode out early and, after asking Balashev to come to
him, peremptorily requested him to remain there, to move on with the
baggage train should orders come for it to move, and to talk to no one
except Monsieur de Castres.

After four days of solitude, ennui, and consciousness of his
impotence and insignificance--particularly acute by contrast with
the sphere of power in which he had so lately moved--and after several
marches with the marshal's baggage and the French army, which occupied
the whole district, Balashev was brought to Vilna--now occupied by the
French--through the very gate by which he had left it four days
previously.

Next day the imperial gentleman-in-waiting, the Comte de Turenne,
came to Balashev and informed him of the Emperor Napoleon's wish to
honor him with an audience.

Four days before, sentinels of the Preobrazhensk regiment had
stood in front of the house to which Balashev was conducted, and now
two French grenadiers stood there in blue uniforms unfastened in front
and with shaggy caps on their heads, and an escort of hussars and
Uhlans and a brilliant suite of aides-de-camp, pages, and generals,
who were waiting for Napoleon to come out, were standing at the porch,
round his saddle horse and his Mameluke, Rustan. Napoleon received
Balashev in the very house in Vilna from which Alexander had
dispatched him on his mission.





CHAPTER VI


Though Balashev was used to imperial pomp, he was amazed at the
luxury and magnificence of Napoleon's court.

The Comte de Turenne showed him into a big reception room where many
generals, gentlemen-in-waiting, and Polish magnates--several of whom
Balashev had seen at the court of the Emperor of Russia--were waiting.
Duroc said that Napoleon would receive the Russian general before
going for his ride.

After some minutes, the gentleman-in-waiting who was on duty came
into the great reception room and, bowing politely, asked Balashev
to follow him.

Balashev went into a small reception room, one door of which led
into a study, the very one from which the Russian Emperor had
dispatched him on his mission. He stood a minute or two, waiting. He
heard hurried footsteps beyond the door, both halves of it were opened
rapidly; all was silent and then from the study the sound was heard of
other steps, firm and resolute--they were those of Napoleon. He had
just finished dressing for his ride, and wore a blue uniform,
opening in front over a white waistcoat so long that it covered his
rotund stomach, white leather breeches tightly fitting the fat
thighs of his short legs, and Hessian boots. His short hair had
evidently just been brushed, but one lock hung down in the middle of
his broad forehead. His plump white neck stood out sharply above the
black collar of his uniform, and he smelled of Eau de Cologne. His
full face, rather young-looking, with its prominent chin, wore a
gracious and majestic expression of imperial welcome.

He entered briskly, with a jerk at every step and his head
slightly thrown back. His whole short corpulent figure with broad
thick shoulders, and chest and stomach involuntarily protruding, had
that imposing and stately appearance one sees in men of forty who live
in comfort. It was evident, too, that he was in the best of spirits
that day.

He nodded in answer to Balashav's low and respectful bow, and coming
up to him at once began speaking like a man who values every moment of
his time and does not condescend to prepare what he has to say but
is sure he will always say the right thing and say it well.

"Good day, General!" said he. "I have received the letter you
brought from the Emperor Alexander and am very glad to see you." He
glanced with his large eyes into Balashav's face and immediately
looked past him.

It was plain that Balashev's personality did not interest him at
all. Evidently only what took place within his own mind interested
him. Nothing outside himself had any significance for him, because
everything in the world, it seemed to him, depended entirely on his
will.

"I do not, and did not, desire war," he continued, "but it has
been forced on me. Even now" (he emphasized the word) "I am ready to
receive any explanations you can give me."

And he began clearly and concisely to explain his reasons for
dissatisfaction with the Russian government. Judging by the calmly
moderate and amicable tone in which the French Emperor spoke, Balashev
was firmly persuaded that he wished for peace and intended to enter
into negotiations.

When Napoleon, having finished speaking, looked inquiringly at the
Russian envoy, Balashev began a speech he had prepared long before:
"Sire! The Emperor, my master..." but the sight of the Emperor's
eyes bent on him confused him. "You are flurried--compose yourself!"
Napoleon seemed to say, as with a scarcely perceptible smile he looked
at Balashev's uniform and sword.

Balashev recovered himself and began to speak. He said that the
Emperor Alexander did not consider Kurakin's demand for his
passports a sufficient cause for war; that Kurakin had acted on his
own initiative and without his sovereign's assent, that the Emperor
Alexander did not desire war, and had no relations with England.

"Not yet!" interposed Napoleon, and, as if fearing to give vent to
his feelings, he frowned and nodded slightly as a sign that Balashev
might proceed.

After saying all he had been instructed to say, Balashev added
that the Emperor Alexander wished for peace, but would not enter
into negotiations except on condition that... Here Balashev hesitated:
he remembered the words the Emperor Alexander had not written in his
letter, but had specially inserted in the rescript to Saltykov and had
told Balashev to repeat to Napoleon. Balashev remembered these
words, "So long as a single armed foe remains on Russian soil," but
some complex feeling restrained him. He could not utter them, though
he wished to do so. He grew confused and said: "On condition that
the French army retires beyond the Niemen."

Napoleon noticed Balashev's embarrassment when uttering these last
words; his face twitched and the calf of his left leg began to
quiver rhythmically. Without moving from where he stood he began
speaking in a louder tone and more hurriedly than before. During the
speech that followed, Balashev, who more than once lowered his eyes,
involuntarily noticed the quivering of Napoleon's left leg which
increased the more Napoleon raised his voice.

"I desire peace, no less than the Emperor Alexander," he began.
"Have I not for eighteen months been doing everything to obtain it?
I have waited eighteen months for explanations. But in order to
begin negotiations, what is demanded of me?" he said, frowning and
making an energetic gesture of inquiry with his small white plump
hand.

"The withdrawal of your army beyond the Niemen, sire," replied
Balashev.

"The Niemen?" repeated Napoleon. "So now you want me to retire
beyond the Niemen--only the Niemen?" repeated Napoleon, looking
straight at Balashev.

The latter bowed his head respectfully.

Instead of the demand of four months earlier to withdraw from
Pomerania, only a withdrawal beyond the Niemen was now demanded.
Napoleon turned quickly and began to pace the room.

"You say the demand now is that I am to withdraw beyond the Niemen
before commencing negotiations, but in just the same way two months
ago the demand was that I should withdraw beyond the Vistula and the
Oder, and yet you are willing to negotiate."

He went in silence from one corner of the room to the other and
again stopped in front of Balashev. Balashev noticed that his left leg
was quivering faster than before and his face seemed petrified in
its stern expression. This quivering of his left leg was a thing
Napoleon was conscious of. "The vibration of my left calf is a great
sign with me," he remarked at a later date.

"Such demands as to retreat beyond the Vistula and Oder may be
made to a Prince of Baden, but not to me!" Napoleon almost screamed,
quite to his own surprise. "If you gave me Petersburg and Moscow I
could not accept such conditions. You say I have begun this war! But
who first joined his army? The Emperor Alexander, not I! And you offer
me negotiations when I have expended millions, when you are in
alliance with England, and when your position is a bad one. You
offer me negotiations! But what is the aim of your alliance with
England? What has she given you?" he continued hurriedly, evidently no
longer trying to show the advantages of peace and discuss its
possibility, but only to prove his own rectitude and power and
Alexander's errors and duplicity.

The commencement of his speech had obviously been made with the
intention of demonstrating the advantages of his position and
showing that he was nevertheless willing to negotiate. But he had
begun talking, and the more he talked the less could he control his
words.

The whole purport of his remarks now was evidently to exalt
himself and insult Alexander--just what he had least desired at the
commencement of the interview.

"I hear you have made peace with Turkey?"

Balashev bowed his head affirmatively.

"Peace has been concluded..." he began.

But Napoleon did not let him speak. He evidently wanted to do all
the talking himself, and continued to talk with the sort of
eloquence and unrestrained irritability to which spoiled people are so
prone.

"Yes, I know you have made peace with the Turks without obtaining
Moldavia and Wallachia; I would have given your sovereign those
provinces as I gave him Finland. Yes," he went on, "I promised and
would have given the Emperor Alexander Moldavia and Wallachia, and now
he won't have those splendid provinces. Yet he might have united
them to his empire and in a single reign would have extended Russia
from the Gulf of Bothnia to the mouths of the Danube. Catherine the
Great could not have done more," said Napoleon, growing more and
more excited as he paced up and down the room, repeating to Balashev
almost the very words he had used to Alexander himself at Tilsit. "All
that, he would have owed to my friendship. Oh, what a splendid reign!"
he repeated several times, then paused, drew from his pocket a gold
snuffbox, lifted it to his nose, and greedily sniffed at it.

"What a splendid reign the Emperor Alexander's might have been!"

He looked compassionately at Balashev, and as soon as the latter
tried to make some rejoinder hastily interrupted him.

"What could he wish or look for that he would not have obtained
through my friendship?" demanded Napoleon, shrugging his shoulders
in perplexity. "But no, he has preferred to surround himself with my
enemies, and with whom? With Steins, Armfeldts, Bennigsens, and
Wintzingerodes! Stein, a traitor expelled from his own country;
Armfeldt, a rake and an intriguer; Wintzingerode, a fugitive French
subject; Bennigsen, rather more of a soldier than the others, but
all the same an incompetent who was unable to do anything in 1807
and who should awaken terrible memories in the Emperor Alexander's
mind.... Granted that were they competent they might be made use
of," continued Napoleon--hardly able to keep pace in words with the
rush of thoughts that incessantly sprang up, proving how right and
strong he was (in his perception the two were one and the same)-
"but they are not even that! They are neither fit for war nor peace!
Barclay is said to be the most capable of them all, but I cannot say
so, judging by his first movements. And what are they doing, all these
courtiers? Pfuel proposes, Armfeldt disputes, Bennigsen considers, and
Barclay, called on to act, does not know what to decide on, and time
passes bringing no result. Bagration alone is a military man. He's
stupid, but he has experience, a quick eye, and resolution.... And
what role is your young monarch playing in that monstrous crowd?
They compromise him and throw on him the responsibility for all that
happens. A sovereign should not be with the army unless he is a
general!" said Napoleon, evidently uttering these words as a direct
challenge to the Emperor. He knew how Alexander desired to be a
military commander.

"The campaign began only a week ago, and you haven't even been
able to defend Vilna. You are cut in two and have been driven out of
the Polish provinces. Your army is grumbling."

"On the contrary, Your Majesty," said Balashev, hardly able to
remember what had been said to him and following these verbal
fireworks with difficulty, "the troops are burning with eagerness..."

"I know everything!" Napoleon interrupted him. "I know everything. I
know the number of your battalions as exactly as I know my own. You
have not two hundred thousand men, and I have three times that number.
I give you my word of honor," said Napoleon, forgetting that his
word of honor could carry no weight--"I give you my word of honor that
I have five hundred and thirty thousand men this side of the
Vistula. The Turks will be of no use to you; they are worth nothing
and have shown it by making peace with you. As for the Swedes--it is
their fate to be governed by mad kings. Their king was insane and they
changed him for another--Bernadotte, who promptly went mad--for no
Swede would ally himself with Russia unless he were mad."

Napoleon grinned maliciously and again raised his snuffbox to his
nose.

Balashev knew how to reply to each of Napoleon's remarks, and
would have done so; he continually made the gesture of a man wishing
to say something, but Napoleon always interrupted him. To the
alleged insanity of the Swedes, Balashev wished to reply that when
Russia is on her side Sweden is practically an island: but Napoleon
gave an angry exclamation to drown his voice. Napoleon was in that
state of irritability in which a man has to talk, talk, and talk,
merely to convince himself that he is in the right. Balashev began
to feel uncomfortable: as envoy he feared to demean his dignity and
felt the necessity of replying; but, as a man, he shrank before the
transport of groundless wrath that had evidently seized Napoleon. He
knew that none of the words now uttered by Napoleon had any
significance, and that Napoleon himself would be ashamed of them
when he came to his senses. Balashev stood with downcast eyes, looking
at the movements of Napoleon's stout legs and trying to avoid
meeting his eyes.

"But what do I care about your allies?" said Napoleon. "I have
allies--the Poles. There are eighty thousand of them and they fight
like lions. And there will be two hundred thousand of them."

And probably still more perturbed by the fact that he had uttered
this obvious falsehood, and that Balashev still stood silently
before him in the same attitude of submission to fate, Napoleon
abruptly turned round, drew close to Balashev's face, and,
gesticulating rapidly and energetically with his white hands, almost
shouted:

"Know that if you stir up Prussia against me, I'll wipe it off the
map of Europe!" he declared, his face pale and distorted by anger, and
he struck one of his small hands energetically with the other. "Yes, I
will throw you back beyond the Dvina and beyond the Dnieper, and
will re-erect against you that barrier which it was criminal and blind
of Europe to allow to be destroyed. Yes, that is what will happen to
you. That is what you have gained by alienating me!" And he walked
silently several times up and down the room, his fat shoulders
twitching.

He put his snuffbox into his waistcoat pocket, took it out again,
lifted it several times to his nose, and stopped in front of Balashev.
He paused, looked ironically straight into Balashev's eyes, and said
in a quiet voice:

"And yet what a splendid reign your master might have had!"

Balashev, feeling it incumbent on him to reply, said that from the
Russian side things did not appear in so gloomy a light. Napoleon
was silent, still looking derisively at him and evidently not
listening to him. Balashev said that in Russia the best results were
expected from the war. Napoleon nodded condescendingly, as if to
say, "I know it's your duty to say that, but you don't believe it
yourself. I have convinced you."

When Balashev had ended, Napoleon again took out his snuffbox,
sniffed at it, and stamped his foot twice on the floor as a signal.
The door opened, a gentleman-in-waiting, bending respectfully,
handed the Emperor his hat and gloves; another brought him a pocket
handkerchief. Napoleon, without giving them a glance, turned to
Balashev:

"Assure the Emperor Alexander from me," said he, taking his hat,
"that I am as devoted to him as before: I know him thoroughly and very
highly esteem his lofty qualities. I will detain you no longer,
General; you shall receive my letter to the Emperor."

And Napoleon went quickly to the door. Everyone in the reception
room rushed forward and descended the staircase.





CHAPTER VII


After all that Napoleon had said to him--those bursts of anger and
the last dryly spoken words: "I will detain you no longer, General;
you shall receive my letter," Balashev felt convinced that Napoleon
would not wish to see him, and would even avoid another meeting with
him--an insulted envoy--especially as he had witnessed his unseemly
anger. But, to his surprise, Balashev received, through Duroc, an
invitation to dine with the Emperor that day.

Bessieres, Caulaincourt, and Berthier were present at that dinner.

Napoleon met Balashev cheerfully and amiably. He not only showed
no sign of constraint or self-reproach on account of his outburst that
morning, but, on the contrary, tried to reassure Balashev. It was
evident that he had long been convinced that it was impossible for him
to make a mistake, and that in his perception whatever he did was
right, not because it harmonized with any idea of right and wrong, but
because he did it.

The Emperor was in very good spirits after his ride through Vilna,
where crowds of people had rapturously greeted and followed him.
From all the windows of the streets through which he rode, rugs,
flags, and his monogram were displayed, and the Polish ladies,
welcoming him, waved their handkerchiefs to him.

At dinner, having placed Balashev beside him, Napoleon not only
treated him amiably but behaved as if Balashev were one of his own
courtiers, one of those who sympathized with his plans and ought to
rejoice at his success. In the course of conversation he mentioned
Moscow and questioned Balashev about the Russian capital, not merely
as an interested traveler asks about a new city he intends to visit,
but as if convinced that Balashev, as a Russian, must be flattered
by his curiosity.

"How many inhabitants are there in Moscow? How many houses? Is it
true that Moscow is called 'Holy Moscow'? How many churches are
there in Moscow?" he asked.

And receiving the reply that there were more than two hundred
churches, he remarked:

"Why such a quantity of churches?"

"The Russians are very devout," replied Balashev.

"But a large number of monasteries and churches is always a sign
of the backwardness of a people," said Napoleon, turning to
Caulaincourt for appreciation of this remark.

Balashev respectfully ventured to disagree with the French Emperor.

"Every country has its own character," said he.

"But nowhere in Europe is there anything like that," said Napoleon.

"I beg your Majesty's pardon," returned Balashev, "besides Russia
there is Spain, where there are also many churches and monasteries."

This reply of Balashev's, which hinted at the recent defeats of
the French in Spain, was much appreciated when he related it at
Alexander's court, but it was not much appreciated at Napoleon's
dinner, where it passed unnoticed.

The uninterested and perplexed faces of the marshals showed that
they were puzzled as to what Balashev's tone suggested. "If there is a
point we don't see it, or it is not at all witty," their expressions
seemed to say. So little was his rejoinder appreciated that Napoleon
did not notice it at all and naively asked Balashev through what towns
the direct road from there to Moscow passed. Balashev, who was on
the alert all through the dinner, replied that just as "all roads lead
to Rome," so all roads lead to Moscow: there were many roads, and
"among them the road through Poltava, which Charles XII chose."
Balashev involuntarily flushed with pleasure at the aptitude of this
reply, but hardly had he uttered the word Poltava before
Caulaincourt began speaking of the badness of the road from Petersburg
to Moscow and of his Petersburg reminiscences.

After dinner they went to drink coffee in Napoleon's study, which
four days previously had been that of the Emperor Alexander.
Napoleon sat down, toying with his Sevres coffee cup, and motioned
Balashev to a chair beside him.

Napoleon was in that well-known after-dinner mood which, more than
any reasoned cause, makes a man contented with himself and disposed to
consider everyone his friend. It seemed to him that he was
surrounded by men who adored him: and he felt convinced that, after
his dinner, Balashev too was his friend and worshiper. Napoleon turned
to him with a pleasant, though slightly ironic, smile.

"They tell me this is the room the Emperor Alexander occupied?
Strange, isn't it, General?" he said, evidently not doubting that this
remark would be agreeable to his hearer since it went to prove his,
Napoleon's, superiority to Alexander.

Balashev made no reply and bowed his head in silence.

"Yes. Four days ago in this room, Wintzingerode and Stein were
deliberating," continued Napoleon with the same derisive and
self-confident smile. "What I can't understand," he went on, "is
that the Emperor Alexander has surrounded himself with my personal
enemies. That I do not... understand. Has he not thought that I may
the same?" and he turned inquiringly to Balashev, and evidently this
thought turned him back on to the track of his morning's anger,
which was still fresh in him.

"And let him know that I will do so!" said Napoleon, rising and
pushing his cup away with his hand. "I'll drive all his Wurttemberg,
Baden, and Weimar relations out of Germany.... Yes. I'll drive them
out. Let him prepare an asylum for them in Russia!"

Balashev bowed his head with an air indicating that he would like to
make his bow and leave, and only listened because he could not help
hearing what was said to him. Napoleon did not notice this expression;
he treated Balashev not as an envoy from his enemy, but as a man now
fully devoted to him and who must rejoice at his former master's
humiliation.

"And why has the Emperor Alexander taken command of the armies? What
is the good of that? War is my profession, but his business is to
reign and not to command armies! Why has he taken on himself such a
responsibility?"

Again Napoleon brought out his snuffbox, paced several times up
and down the room in silence, and then, suddenly and unexpectedly,
went up to Balashev and with a slight smile, as confidently,
quickly, and simply as if he were doing something not merely
important but pleasing to Balashev, he raised his hand to the
forty-year-old Russian general's face and, taking him by the ear,
pulled it gently, smiling with his lips only.

To have one's ear pulled by the Emperor was considered the
greatest honor and mark of favor at the French court.

"Well, adorer and courtier of the Emperor Alexander, why don't you
say anything?" said he, as if it was ridiculous, in his presence, to
be the adorer and courtier of anyone but himself, Napoleon. "Are the
horses ready for the general?" he added, with a slight inclination
of his head in reply to Balashev's bow. "Let him have mine, he has a
long way to go!"

The letter taken by Balashev was the last Napoleon sent to
Alexander. Every detail of the interview was communicated to the
Russian monarch, and the war began...





CHAPTER VIII


After his interview with Pierre in Moscow, Prince Andrew went to
Petersburg, on business as he told his family, but really to meet
Anatole Kuragin whom he felt it necessary to encounter. On reaching
Petersburg he inquired for Kuragin but the latter had already left the
city. Pierre had warned his brother-in-law that Prince Andrew was on
his track. Anatole Kuragin promptly obtained an appointment from the
Minister of War and went to join the army in Moldavia. While in
Petersburg Prince Andrew met Kutuzov, his former commander who was
always well disposed toward him, and Kutuzov suggested that he
should accompany him to the army in Moldavia, to which the old general
had been appointed commander in chief. So Prince Andrew, having
received an appointment on the headquarters staff, left for Turkey.

Prince Andrew did not think it proper to write and challenge
Kuragin. He thought that if he challenged him without some fresh cause
it might compromise the young Countess Rostova and so he wanted to
meet Kuragin personally in order to find a fresh pretext for a duel.
But he again failed to meet Kuragin in Turkey, for soon after Prince
Andrew arrived, the latter returned to Russia. In a new country,
amid new conditions, Prince Andrew found life easier to bear. After
his betrothed had broken faith with him--which he felt the more
acutely the more he tried to conceal its effects--the surroundings
in which he had been happy became trying to him, and the freedom and
independence he had once prized so highly were still more so. Not only
could he no longer think the thoughts that had first come to him as he
lay gazing at the sky on the field of Austerlitz and had later
enlarged upon with Pierre, and which had filled his solitude at
Bogucharovo and then in Switzerland and Rome, but he even dreaded to
recall them and the bright and boundless horizons they had
revealed. He was now concerned only with the nearest practical matters
unrelated to his past interests, and he seized on these the more
eagerly the more those past interests were closed to him. It was as if
that lofty, infinite canopy of heaven that had once towered above
him had suddenly turned into a low, solid vault that weighed him down,
in which all was clear, but nothing eternal or mysterious.

Of the activities that presented themselves to him, army service was
the simplest and most familiar. As a general on duty on Kutuzov's
staff, he applied himself to business with zeal and perseverance and
surprised Kutuzov by his willingness and accuracy in work. Not
having found Kuragin in Turkey, Prince Andrew did not think it
necessary to rush back to Russia after him, but all the same he knew
that however long it might be before he met Kuragin, despite his
contempt for him and despite all the proofs he deduced to convince
himself that it was not worth stooping to a conflict with him--he knew
that when he did meet him he would not be able to resist calling him
out, any more than a ravenous man can help snatching at food. And
the consciousness that the insult was not yet avenged, that his rancor
was still unspent, weighed on his heart and poisoned the artificial
tranquillity which he managed to obtain in Turkey by means of
restless, plodding, and rather vainglorious and ambitious activity.

In the year 1812, when news of the war with Napoleon reached
Bucharest--where Kutuzov had been living for two months, passing his
days and nights with a Wallachian woman--Prince Andrew asked Kutuzov
to transfer him to the Western Army. Kutuzov, who was already weary of
Bolkonski's activity which seemed to reproach his own idleness, very
readily let him go and gave him a mission to Barclay de Tolly.

Before joining the Western Army which was then, in May, encamped
at Drissa, Prince Andrew visited Bald Hills which was directly on
his way, being only two miles off the Smolensk highroad. During the
last three years there had been so many changes in his life, he had
thought, felt, and seen so much (having traveled both in the east
and the west), that on reaching Bald Hills it struck him as strange
and unexpected to find the way of life there unchanged and still the
same in every detail. He entered through the gates with their stone
pillars and drove up the avenue leading to the house as if he were
entering an enchanted, sleeping castle. The same old stateliness,
the same cleanliness, the same stillness reigned there, and inside
there was the same furniture, the same walls, sounds, and smell, and
the same timid faces, only somewhat older. Princess Mary was still the
same timid, plain maiden getting on in years, uselessly and
joylessly passing the best years of her life in fear and constant
suffering. Mademoiselle Bourienne was the same coquettish,
self-satisfied girl, enjoying every moment of her existence and full
of joyous hopes for the future. She had merely become more
self-confident, Prince Andrew thought. Dessalles, the tutor he had
brought from Switzerland, was wearing a coat of Russian cut and
talking broken Russian to the servants, but was still the same
narrowly intelligent, conscientious, and pedantic preceptor. The old
prince had changed in appearance only by the loss of a tooth, which
left a noticeable gap on one side of his mouth; in character he was
the same as ever, only showing still more irritability and
skepticism as to what was happening in the world. Little Nicholas
alone had changed. He had grown, become rosier, had curly dark hair,
and, when merry and laughing, quite unconsciously lifted the upper lip
of his pretty little mouth just as the little princess used to do.
He alone did not obey the law of immutability in the enchanted,
sleeping castle. But though externally all remained as of old, the
inner relations of all these people had changed since Prince Andrew
had seen them last. The household was divided into two alien and
hostile camps, who changed their habits for his sake and only met
because he was there. To the one camp belonged the old prince,
Madmoiselle Bourienne, and the architect; to the other Princess
Mary, Dessalles, little Nicholas, and all the old nurses and maids.

During his stay at Bald Hills all the family dined together, but
they were ill at ease and Prince Andrew felt that he was a visitor for
whose sake an exception was being made and that his presence made them
all feel awkward. Involuntarily feeling this at dinner on the first
day, he was taciturn, and the old prince noticing this also became
morosely dumb and retired to his apartments directly after dinner.
In the evening, when Prince Andrew went to him and, trying to rouse
him, began to tell him of the young Count Kamensky's campaign, the old
prince began unexpectedly to talk about Princess Mary, blaming her for
her superstitions and her dislike of Mademoiselle Bourienne, who, he
said, was the only person really attached to him.

The old prince said that if he was ill it was only because of
Princess Mary: that she purposely worried and irritated him, and
that by indulgence and silly talk she was spoiling little Prince
Nicholas. The old prince knew very well that he tormented his daughter
and that her life was very hard, but he also knew that he could not
help tormenting her and that she deserved it. "Why does Prince Andrew,
who sees this, say nothing to me about his sister? Does he think me
a scoundrel, or an old fool who, without any reason, keeps his own
daughter at a distance and attaches this Frenchwoman to himself? He
doesn't understand, so I must explain it, and he must hear me out,"
thought the old prince. And he began explaining why he could not put
up with his daughter's unreasonable character.

"If you ask me," said Prince Andrew, without looking up (he was
censuring his father for the first time in his life), "I did not
wish to speak about it, but as you ask me I will give you my frank
opinion. If there is any misunderstanding and discord between you
and Mary, I can't blame her for it at all. I know how she loves and
respects you. Since you ask me," continued Prince Andrew, becoming
irritable--as he was always liable to do of late--"I can only say that
if there are any misunderstandings they are caused by that worthless
woman, who is not fit to be my sister's companion."

The old man at first stared fixedly at his son, and an unnatural
smile disclosed the fresh gap between his teeth to which Prince Andrew
could not get accustomed.

"What companion, my dear boy? Eh? You've already been talking it
over! Eh?"

"Father, I did not want to judge," said Prince Andrew, in a hard and
bitter tone, "but you challenged me, and I have said, and always shall
say, that Mary is not to blame, but those to blame--the one to
blame--is that Frenchwoman."

"Ah, he has passed judgment... passed judgement!" said the old man
in a low voice and, as it seemed to Prince Andrew, with some
embarrassment, but then he suddenly jumped up and cried: "Be off, be
off! Let not a trace of you remain here!..."


Prince Andrew wished to leave at once, but Princess Mary persuaded
him to stay another day. That day he did not see his father, who did
not leave his room and admitted no one but Mademoiselle Bourienne
and Tikhon, but asked several times whether his son had gone. Next
day, before leaving, Prince Andrew went to his son's rooms. The boy,
curly-headed like his mother and glowing with health, sat on his knee,
and Prince Andrew began telling him the story of Bluebeard, but fell
into a reverie without finishing the story. He thought not of this
pretty child, his son whom he held on his knee, but of himself. He
sought in himself either remorse for having angered his father or
regret at leaving home for the first time in his life on bad terms
with him, and was horrified to find neither. What meant still more
to him was that he sought and did not find in himself the former
tenderness for his son which he had hoped to reawaken by caressing the
boy and taking him on his knee.

"Well, go on!" said his son.

Prince Andrew, without replying, put him down from his knee and went
out of the room.

As soon as Prince Andrew had given up his daily occupations, and
especially on returning to the old conditions of life amid which he
had been happy, weariness of life overcame him with its former
intensity, and he hastened to escape from these memories and to find
some work as soon as possible.

"So you've decided to go, Andrew?" asked his sister.

"Thank God that I can," replied Prince Andrew. "I am very sorry
you can't."

"Why do you say that?" replied Princess Mary. "Why do you say
that, when you are going to this terrible war, and he is so old?
Mademoiselle Bourienne says he has been asking about you...."

As soon as she began to speak of that, her lips trembled and her
tears began to fall. Prince Andrew turned away and began pacing the
room.

"Ah, my God! my God! When one thinks who and what--what trash--can
cause people misery!" he said with a malignity that alarmed Princess
Mary.

She understood that when speaking of "trash" he referred not only to
Mademoiselle Bourienne, the cause of her misery, but also to the man
who had ruined his own happiness.

"Andrew! One thing I beg, I entreat of you!" she said, touching
his elbow and looking at him with eyes that shone through her tears.
"I understand you" (she looked down). "Don't imagine that sorrow is
the work of men. Men are His tools." She looked a little above
Prince Andrew's head with the confident, accustomed look with which
one looks at the place where a familiar portrait hangs. "Sorrow is
sent by Him, not by men. Men are His instruments, they are not to
blame. If you think someone has wronged you, forget it and forgive! We
have no right to punish. And then you will know the happiness of
forgiving."

"If I were a woman I would do so, Mary. That is a woman's virtue.
But a man should not and cannot forgive and forget," he replied, and
though till that moment he had not been thinking of Kuragin, all his
unexpended anger suddenly swelled up in his heart.

"If Mary is already persuading me forgive, it means that I ought
long ago to have punished him," he thought. And giving her no
further reply, he began thinking of the glad vindictive moment when he
would meet Kuragin who he knew was now in the army.

Princess Mary begged him to stay one day more, saying that she
knew how unhappy her father would be if Andrew left without being
reconciled to him, but Prince Andrew replied that he would probably
soon be back again from the army and would certainly write to his
father, but that the longer he stayed now the more embittered their
differences would become.

"Good-by, Andrew! Remember that misfortunes come from God, and men
are never to blame," were the last words he heard from his sister when
he took leave of her.

"Then it must be so!" thought Prince Andrew as he drove out of the
avenue from the house at Bald Hills. "She, poor innocent creature,
is left to be victimized by an old man who has outlived his wits.
The old man feels he is guilty, but cannot change himself. My boy is
growing up and rejoices in life, in which like everybody else he
will deceive or be deceived. And I am off to the army. Why? I myself
don't know. I want to meet that man whom I despise, so as to give
him a chance to kill and laugh at me!"

These conditions of life had been the same before, but then they
were all connected, while now they had all tumbled to pieces. Only
senseless things, lacking coherence, presented themselves one after
another to Prince Andrew's mind.





CHAPTER IX


Prince Andrew reached the general headquarters of the army at the
end of June. The first army, with which was the Emperor, occupied
the fortified camp at Drissa; the second army was retreating, trying
to effect a junction with the first one from which it was said to be
cut off by large French forces. Everyone was dissatisfied with the
general course of affairs in the Russian army, but no one
anticipated any danger of invasion of the Russian provinces, and no
one thought the war would extend farther than the western, the Polish,
provinces.

Prince Andrew found Barclay de Tolly, to whom he had been
assigned, on the bank of the Drissa. As there was not a single town or
large village in the vicinity of the camp, the immense number of
generals and courtiers accompanying the army were living in the best
houses of the villages on both sides of the river, over a radius of
six miles. Barclay de Tolly was quartered nearly three miles from
the Emperor. He received Bolkonski stiffly and coldly and told him
in his foreign accent that he would mention him to the Emperor for a
decision as to his employment, but asked him meanwhile to remain on
his staff. Anatole Kuragin, whom Prince Andrew had hoped to find
with the army, was not there. He had gone to Petersburg, but Prince
Andrew was glad to hear this. His mind was occupied by the interests
of the center that was conducting a gigantic war, and he was glad to
be free for a while from the distraction caused by the thought of
Kuragin. During the first four days, while no duties were required
of him, Prince Andrew rode round the whole fortified camp and, by
the aid of his own knowledge and by talks with experts, tried to
form a definite opinion about it. But the question whether the camp
was advantageous or disadvantageous remained for him undecided.
Already from his military experience and what he had seen in the
Austrian campaign, he had come to the conclusion that in war the
most deeply considered plans have no significance and that all depends
on the way unexpected movements of the enemy--that cannot be foreseen-
are met, and on how and by whom the whole matter is handled. To
clear up this last point for himself, Prince Andrew, utilizing his
position and acquaintances, tried to fathom the character of the
control of the army and of the men and parties engaged in it, and he
deduced for himself the following of the state of affairs.

While the Emperor had still been at Vilna, the forces had been
divided into three armies. First, the army under Barclay de Tolly,
secondly, the army under Bagration, and thirdly, the one commanded
by Tormasov. The Emperor was with the first army, but not as commander
in chief. In the orders issued it was stated, not that the Emperor
would take command, but only that he would be with the army. The
Emperor, moreover, had with him not a commander in chief's staff but
the imperial headquarters staff. In attendance on him was the head
of the imperial staff, Quartermaster General Prince Volkonski, as well
as generals, imperial aides-de-camp, diplomatic officials, and a large
number of foreigners, but not the army staff. Besides these, there
were in attendance on the Emperor without any definite appointments:
Arakcheev, the ex-Minister of War; Count Bennigsen, the senior general
in rank; the Grand Duke Tsarevich Constantine Pavlovich; Count
Rumyantsev, the Chancellor; Stein, a former Prussian minister;
Armfeldt, a Swedish general; Pfuel, the chief author of the plan of
campaign; Paulucci, an adjutant general and Sardinian emigre;
Wolzogen--and many others. Though these men had no military
appointment in the army, their position gave them influence, and often
a corps commander, or even the commander in chief, did not know in
what capacity he was questioned by Bennigsen, the Grand Duke,
Arakcheev, or Prince Volkonski, or was given this or that advice and
did not know whether a certain order received in the form of advice
emanated from the man who gave it or from the Emperor and whether it
had to be executed or not. But this was only the external condition;
the essential significance of the presence of the Emperor and of all
these people, from a courtier's point of view (and in an Emperor's
vicinity all became courtiers), was clear to everyone. It was this:
the Emperor did not assume the title of commander in chief, but
disposed of all the armies; the men around him were his assistants.
Arakcheev was a faithful custodian to enforce order and acted as the
sovereign's bodyguard. Bennigsen was a landlord in the Vilna
province who appeared to be doing the honors of the district, but
was in reality a good general, useful as an adviser and ready at
hand to replace Barclay. The Grand Duke was there because it suited
him to be. The ex-Minister Stein was there because his advice was
useful and the Emperor Alexander held him in high esteem personally.
Armfeldt virulently hated Napoleon and was a general full of
self-confidence, a quality that always influenced Alexander.
Paulucci was there because he was bold and decided in speech. The
adjutants general were there because they always accompanied the
Emperor, and lastly and chiefly Pfuel was there because he had drawn
up the plan of campaign against Napoleon and, having induced Alexander
to believe in the efficacy of that plan, was directing the whole
business of the war. With Pfuel was Wolzogen, who expressed Pfuel's
thoughts in a more comprehensible way than Pfuel himself (who was a
harsh, bookish theorist, self-confident to the point of despising
everyone else) was able to do.

Besides these Russians and foreigners who propounded new and
unexpected ideas every day--especially the foreigners, who did so with
a boldness characteristic of people employed in a country not their
own--there were many secondary personages accompanying the army
because their principals were there.

Among the opinions and voices in this immense, restless,
brilliant, and proud sphere, Prince Andrew noticed the following
sharply defined subdivisions of and parties:

The first party consisted of Pfuel and his adherents--military
theorists who believed in a science of war with immutable laws--laws
of oblique movements, outflankings, and so forth. Pfuel and his
adherents demanded a retirement into the depths of the country in
accordance with precise laws defined by a pseudo-theory of war, and
they saw only barbarism, ignorance, or evil intention in every
deviation from that theory. To this party belonged the foreign nobles,
Wolzogen, Wintzingerode, and others, chiefly Germans.

The second party was directly opposed to the first; one extreme,
as always happens, was met by representatives of the other. The
members of this party were those who had demanded an advance from
Vilna into Poland and freedom from all prearranged plans. Besides
being advocates of bold action, this section also represented
nationalism, which made them still more one-sided in the dispute. They
were Russians: Bagration, Ermolov (who was beginning to come to the
front), and others. At that time a famous joke of Ermolov's was
being circulated, that as a great favor he had petitioned the
Emperor to make him a German. The men of that party, remembering
Suvorov, said that what one had to do was not to reason, or stick pins
into maps, but to fight, beat the enemy, keep him out of Russia, and
not let the army get discouraged.

To the third party--in which the Emperor had most confidence-
belonged the courtiers who tried to arrange compromises between the
other two. The members of this party, chiefly civilians and to whom
Arakcheev belonged, thought and said what men who have no
convictions but wish to seem to have some generally say. They said
that undoubtedly war, particularly against such a genius as
Bonaparte (they called him Bonaparte now), needs most deeply devised
plans and profound scientific knowledge and in that respect Pfuel
was a genius, but at the same time it had to be acknowledged that
the theorists are often one sided, and therefore one should not
trust them absolutely, but should also listen to what Pfuel's
opponents and practical men of experience in warfare had to say, and
then choose a middle course. They insisted on the retention of the
camp at Drissa, according to Pfuel's plan, but on changing the
movements of the other armies. Though, by this course, neither one aim
nor the other could be attained, yet it seemed best to the adherents
of this third party.

Of a fourth opinion the most conspicuous representative was the
Tsarevich, who could not forget his disillusionment at Austerlitz,
where he had ridden out at the head of the Guards, in his casque and
cavalry uniform as to a review, expecting to crush the French
gallantly; but unexpectedly finding himself in the front line had
narrowly escaped amid the general confusion. The men of this party had
both the quality and the defect of frankness in their opinions. They
feared Napoleon, recognized his strength and their own weakness, and
frankly said so. They said: "Nothing but sorrow, shame, and ruin
will come of all this! We have abandoned Vilna and Vitebsk and shall
abandon Drissa. The only reasonable thing left to do is to conclude
peace as soon as possible, before we are turned out of Petersburg."

This view was very general in the upper army circles and found
support also in Petersburg and from the chancellor, Rumyantsev, who,
for other reasons of state, was in favor of peace.

The fifth party consisted of those who were adherents of Barclay
de Tolly, not so much as a man but as minister of war and commander in
chief. "Be he what he may" (they always began like that), "he is an
honest, practical man and we have nobody better. Give him real
power, for war cannot be conducted successfully without unity of
command, and he will show what he can do, as he did in Finland. If our
army is well organized and strong and has withdrawn to Drissa
without suffering any defeats, we owe this entirely to Barclay. If
Barclay is now to be superseded by Bennigsen all will be lost, for
Bennigsen showed his incapacity already in 1807."

The sixth party, the Bennigsenites, said, on the contrary, that at
any rate there was no one more active and experienced than
Bennigsen: "and twist about as you may, you will have to come to
Bennigsen eventually. Let the others make mistakes now!" said they,
arguing that our retirement to Drissa was a most shameful reverse
and an unbroken series of blunders. "The more mistakes that are made
the better. It will at any rate be understood all the sooner that
things cannot go on like this. What is wanted is not some Barclay or
other, but a man like Bennigsen, who made his mark in 1807, and to
whom Napoleon himself did justice--a man whose authority would be
willingly recognized, and Bennigsen is the only such man."

The seventh party consisted of the sort of people who are always
to be found, especially around young sovereigns, and of whom there
were particularly many round Alexander--generals and imperial
aides-de-camp passionately devoted to the Emperor, not merely as a
monarch but as a man, adoring him sincerely and disinterestedly, as
Rostov had done in 1805, and who saw in him not only all the virtues
but all human capabilities as well. These men, though enchanted with
the sovereign for refusing the command of the army, yet blamed him for
such excessive modesty, and only desired and insisted that their
adored sovereign should abandon his diffidence and openly announce
that he would place himself at the head of the army, gather round
him a commander in chief's staff, and, consulting experienced
theoreticians and practical men where necessary, would himself lead
the troops, whose spirits would thereby be raised to the highest
pitch.

The eighth and largest group, which in its enormous numbers was to
the others as ninety-nine to one, consisted of men who desired neither
peace nor war, neither an advance nor a defensive camp at the Drissa
or anywhere else, neither Barclay nor the Emperor, neither Pfuel nor
Bennigsen, but only the one most essential thing--as much advantage
and pleasure for themselves as possible. In the troubled waters of
conflicting and intersecting intrigues that eddied about the Emperor's
headquarters, it was possible to succeed in many ways unthinkable at
other times. A man who simply wished to retain his lucrative post
would today agree with Pfuel, tomorrow with his opponent, and the
day after, merely to avoid responsibility or to please the Emperor,
would declare that he had no opinion at all on the matter. Another who
wished to gain some advantage would attract the Emperor's attention by
loudly advocating the very thing the Emperor had hinted at the day
before, and would dispute and shout at the council, beating his breast
and challenging those who did not agree with him to duels, thereby
proving that he was prepared to sacrifice himself for the common good.
A third, in the absence of opponents, between two councils would
simply solicit a special gratuity for his faithful services, well
knowing that at that moment people would be too busy to refuse him.
A fourth while seemingly overwhelmed with work would often come
accidentally under the Emperor's eye. A fifth, to achieve his
long-cherished aim of dining with the Emperor, would stubbornly insist
on the correctness or falsity of some newly emerging opinion and for
this object would produce arguments more or less forcible and correct.

All the men of this party were fishing for rubles, decorations,
and promotions, and in this pursuit watched only the weathercock of
imperial favor, and directly they noticed it turning in any direction,
this whole drone population of the army began blowing hard that way,
so that it was all the harder for the Emperor to turn it elsewhere.
Amid the uncertainties of the position, with the menace of serious
danger giving a peculiarly threatening character to everything, amid
this vortex of intrigue, egotism, conflict of views and feelings,
and the diversity of race among these people--this eighth and
largest party of those preoccupied with personal interests imparted
great confusion and obscurity to the common task. Whatever question
arose, a swarm of these drones, without having finished their
buzzing on a previous theme, flew over to the new one and by their hum
drowned and obscured the voices of those who were disputing honestly.

From among all these parties, just at the time Prince Andrew reached
the army, another, a ninth party, was being formed and was beginning
to raise its voice. This was the party of the elders, reasonable men
experienced and capable in state affairs, who, without sharing any
of those conflicting opinions, were able to take a detached view of
what was going on at the staff at headquarters and to consider means
of escape from this muddle, indecision, intricacy, and weakness.

The men of this party said and thought that what was wrong
resulted chiefly from the Emperor's presence in the army with his
military court and from the consequent presence there of an
indefinite, conditional, and unsteady fluctuation of relations,
which is in place at court but harmful in an army; that a sovereign
should reign but not command the army, and that the only way out of
the position would be for the Emperor and his court to leave the army;
that the mere presence of the Emperor paralyzed the action of fifty
thousand men required to secure his personal safety, and that the
worst commander in chief if independent would be better than the
very best one trammeled by the presence and authority of the monarch.

Just at the time Prince Andrew was living unoccupied at Drissa,
Shishkov, the Secretary of State and one of the chief
representatives of this party, wrote a letter to the Emperor which
Arakcheev and Balashev agreed to sign. In this letter, availing
himself of permission given him by the Emperor to discuss the
general course of affairs, he respectfully suggested--on the plea that
it was necessary for the sovereign to arouse a warlike spirit in the
people of the capital--that the Emperor should leave the army.

That arousing of the people by their sovereign and his call to
them to defend their country--the very incitement which was the
chief cause of Russia's triumph in so far as it was produced by the
Tsar's personal presence in Moscow--was suggested to the Emperor,
and accepted by him, as a pretext for quitting the army.





CHAPTER X


This letter had not yet been presented to the Emperor when
Barclay, one day at dinner, informed Bolkonski that the sovereign
wished to see him personally, to question him about Turkey, and that
Prince Andrew was to present himself at Bennigsen's quarters at six
that evening.

News was received at the Emperor's quarters that very day of a fresh
movement by Napoleon which might endanger the army--news
subsequently found to be false. And that morning Colonel Michaud had
ridden round the Drissa fortifications with the Emperor and had
pointed out to him that this fortified camp constructed by Pfuel,
and till then considered a chef-d'oeuvre of tactical science which
would ensure Napoleon's destruction, was an absurdity, threatening the
destruction of the Russian army.

Prince Andrew arrived at Bennigsen's quarters--a country gentleman's
house of moderate size, situated on the very banks of the river.
Neither Bennigsen nor the Emperor was there, but Chernyshev, the
Emperor's aide-de-camp, received Bolkonski and informed him that the
Emperor, accompanied by General Bennigsen and Marquis Paulucci, had
gone a second time that day to inspect the fortifications of the
Drissa camp, of the suitability of which serious doubts were beginning
to be felt.

Chernyshev was sitting at a window in the first room with a French
novel in his hand. This room had probably been a music room; there was
still an organ in it on which some rugs were piled, and in one
corner stood the folding bedstead of Bennigsen's adjutant. This
adjutant was also there and sat dozing on the rolled-up bedding,
evidently exhausted by work or by feasting. Two doors led from the
room, one straight on into what had been the drawing room, and
another, on the right, to the study. Through the first door came the
sound of voices conversing in German and occasionally in French. In
that drawing room were gathered, by the Emperor's wish, not a military
council (the Emperor preferred indefiniteness), but certain persons
whose opinions he wished to know in view of the impending
difficulties. It was not a council of war, but, as it were, a
council to elucidate certain questions for the Emperor personally.
To this semicouncil had been invited the Swedish General Armfeldt,
Adjutant General Wolzogen, Wintzingerode (whom Napoleon had referred
to as a renegade French subject), Michaud, Toll, Count Stein who was
not a military man at all, and Pfuel himself, who, as Prince Andrew
had heard, was the mainspring of the whole affair. Prince Andrew had
an opportunity of getting a good look at him, for Pfuel arrived soon
after himself and, in passing through to the drawing room, stopped a
minute to speak to Chernyshev.

At first sight, Pfuel, in his ill-made uniform of a Russian general,
which fitted him badly like a fancy costume, seemed familiar to Prince
Andrew, though he saw him now for the first time. There was about
him something of Weyrother, Mack, and Schmidt, and many other German
theorist-generals whom Prince Andrew had seen in 1805, but he was more
typical than any of them. Prince Andrew had never yet seen a German
theorist in whom all the characteristics of those others were united
to such an extent.

Pfuel was short and very thin but broad-boned, of coarse, robust
build, broad in the hips, and with prominent shoulder blades. His face
was much wrinkled and his eyes deep set. His hair had evidently been
hastily brushed smooth in front of the temples, but stuck up behind in
quaint little tufts. He entered the room, looking restlessly and
angrily around, as if afraid of everything in that large apartment.
Awkwardly holding up his sword, he addressed Chernyshev and asked in
German where the Emperor was. One could see that he wished to pass
through the rooms as quickly as possible, finish with the bows and
greetings, and sit down to business in front of a map, where he
would feel at home. He nodded hurriedly in reply to Chernyshev, and
smiled ironically on hearing that the sovereign was inspecting the
fortifications that he, Pfuel, had planned in accord with his
theory. He muttered something to himself abruptly and in a bass voice,
as self-assured Germans do--it might have been "stupid fellow"... or
"the whole affair will be ruined," or "something absurd will come of
it."... Prince Andrew did not catch what he said and would have passed
on, but Chernyshev introduced him to Pfuel, remarking that Prince
Andrew was just back from Turkey where the war had terminated so
fortunately. Pfuel barely glanced--not so much at Prince Andrew as
past him--and said, with a laugh: "That must have been a fine tactical
war"; and, laughing contemptuously, went on into the room from which
the sound of voices was heard.

Pfuel, always inclined to be irritably sarcastic, was particularly
disturbed that day, evidently by the fact that they had dared to
inspect and criticize his camp in his absence. From this short
interview with Pfuel, Prince Andrew, thanks to his Austerlitz
experiences, was able to form a clear conception of the man. Pfuel was
one of those hopelessly and immutably self-confident men,
self-confident to the point of martyrdom as only Germans are,
because only Germans are self-confident on the basis of an abstract
notion--science, that is, the supposed knowledge of absolute truth.
A Frenchman is self-assured because he regards himself personally,
both in mind and body, as irresistibly attractive to men and women. An
Englishman is self-assured, as being a citizen of the best-organized
state in the world, and therefore as an Englishman always knows what
he should do and knows that all he does as an Englishman is
undoubtedly correct. An Italian is self-assured because he is
excitable and easily forgets himself and other people. A Russian is
self-assured just because he knows nothing does not want to know
anything, since he does not believe that anything can be known. The
German's self-assurance is worst of all, stronger and more repulsive
than any other, because he imagines that he knows the truth-
science--which he himself has invented but which is for him the
absolute truth.

Pfuel was evidently of that sort. He had a science--the theory of
oblique movements deduced by him from the history of Frederick the
Great's wars, and all he came across in the history of more recent
warfare seemed to him absurd and barbarous--monstrous collisions in
which so many blunders were committed by both sides that these wars
could not be called wars, they did not accord with the theory, and
therefore could not serve as material for science.

In 1806 Pfuel had been one of those responsible, for the plan of
campaign that ended in Jena and Auerstadt, but he did not see the
least proof of the fallibility of his theory in the disasters of
that war. On the contrary, the deviations made from his theory were,
in his opinion, the sole cause of the whole disaster, and with
characteristically gleeful sarcasm he would remark, "There, I said the
whole affair would go to the devil!" Pfuel was one of those
theoreticians who so love their theory that they lose sight of the
theory's object--its practical application. His love of theory made
him hate everything practical, and he would not listen to it. He was
even pleased by failures, for failures resulting from deviations in
practice from the theory only proved to him the accuracy of his
theory.

He said a few words to Prince Andrew and Chernyshev about the
present war, with the air of a man who knows beforehand that all
will go wrong, and who is not displeased that it should be so. The
unbrushed tufts of hair sticking up behind and the hastily brushed
hair on his temples expressed this most eloquently.

He passed into the next room, and the deep, querulous sounds of
his voice were at once heard from there.





CHAPTER XI


Prince Andrew's eyes were still following Pfuel out of the room when
Count Bennigsen entered hurriedly, and nodding to Bolkonski, but not
pausing, went into the study, giving instructions to his adjutant as
he went. The Emperor was following him, and Bennigsen had hastened
on to make some preparations and to be ready to receive the sovereign.
Chernyshev and Prince Andrew went out into the porch, where the
Emperor, who looked fatigued, was dismounting. Marquis Paulucci was
talking to him with particular warmth and the Emperor, with his head
bent to the left, was listening with a dissatisfied air. The Emperor
moved forward evidently wishing to end the conversation, but the
flushed and excited Italian, oblivious of decorum, followed him and
continued to speak.

"And as for the man who advised forming this camp--the Drissa camp,"
said Paulucci, as the Emperor mounted the steps and noticing Prince
Andrew scanned his unfamiliar face, "as to that person, sire..."
continued Paulucci, desperately, apparently unable to restrain
himself, "the man who advised the Drissa camp--I see no alternative
but the lunatic asylum or the gallows!"

Without heeding the end of the Italian's remarks, and as though
not hearing them, the Emperor, recognizing Bolkonski, addressed him
graciously.

"I am very glad to see you! Go in there where they are meeting,
and wait for me."

The Emperor went into the study. He was followed by Prince Peter
Mikhaylovich Volkonski and Baron Stein, and the door closed behind
them. Prince Andrew, taking advantage of the Emperor's permission,
accompanied Paulucci, whom he had known in Turkey, into the drawing
room where the council was assembled.

Prince Peter Mikhaylovich Volkonski occupied the position, as it
were, of chief of the Emperor's staff. He came out of the study into
the drawing room with some maps which he spread on a table, and put
questions on which he wished to hear the opinion of the gentlemen
present. What had happened was that news (which afterwards proved to
be false) had been received during the night of a movement by the
French to outflank the Drissa camp.

The first to speak was General Armfeldt who, to meet the
difficulty that presented itself, unexpectedly proposed a perfectly
new position away from the Petersburg and Moscow roads. The reason for
this was inexplicable (unless he wished to show that he, too, could
have an opinion), but he urged that at this point the army should
unite and there await the enemy. It was plain that Armfeldt had
thought out that plan long ago and now expounded it not so much to
answer the questions put--which, in fact, his plan did not answer-
as to avail himself of the opportunity to air it. It was one of the
millions of proposals, one as good as another, that could be made as
long as it was quite unknown what character the war would take. Some
disputed his arguments, others defended them. Young Count Toll
objected to the Swedish general's views more warmly than anyone
else, and in the course of the dispute drew from his side pocket a
well-filled notebook, which he asked permission to read to them. In
these voluminous notes Toll suggested another scheme, totally
different from Armfeldt's or Pfuel's plan of campaign. In answer to
Toll, Paulucci suggested an advance and an attack, which, he urged,
could alone extricate us from the present uncertainty and from the
trap (as he called the Drissa camp) in which we were situated.

During all these discussions Pfuel and his interpreter, Wolzogen
(his "bridge" in court relations), were silent. Pfuel only snorted
contemptuously and turned away, to show that he would never demean
himself by replying to such nonsense as he was now hearing. So when
Prince Volkonski, who was in the chair, called on him to give his
opinion, he merely said:

"Why ask me? General Armfeldt has proposed a splendid position
with an exposed rear, or why not this Italian gentleman's attack--very
fine, or a retreat, also good! Why ask me?" said he. "Why, you
yourselves know everything better than I do."

But when Volkonski said, with a frown, that it was in the
Emperor's name that he asked his opinion, Pfuel rose and, suddenly
growing animated, began to speak:

"Everything has been spoiled, everything muddled, everybody
thought they knew better than I did, and now you come to me! How
mend matters? There is nothing to mend! The principles laid down by me
must be strictly adhered to," said he, drumming on the table with
his bony fingers. "What is the difficulty? Nonsense, childishness!"

He went up to the map and speaking rapidly began proving that no
eventuality could alter the efficiency of the Drissa camp, that
everything had been foreseen, and that if the enemy were really
going to outflank it, the enemy would inevitably be destroyed.

Paulucci, who did not know German, began questioning him in
French. Wolzogen came to the assistance of his chief, who spoke French
badly, and began translating for him, hardly able to keep pace with
Pfuel, who was rapidly demonstrating that not only all that had
happened, but all that could happen, had been foreseen in his
scheme, and that if there were now any difficulties the whole fault
lay in the fact that his plan had not been precisely executed. He kept
laughing sarcastically, he demonstrated, and at last contemptuously
ceased to demonstrate, like a mathematician who ceases to prove in
various ways the accuracy of a problem that has already been proved.
Wolzogen took his place and continued to explain his views in
French, every now and then turning to Pfuel and saying, "Is it not so,
your excellency?" But Pfuel, like a man heated in a fight who

strikes those on his own side, shouted angrily at his own supporter,
Wolzogen:

"Well, of course, what more is there to explain?"

Paulucci and Michaud both attacked Wolzogen simultaneously in
French. Armfeldt addressed Pfuel in German. Toll explained to
Volkonski in Russian. Prince Andrew listened and observed in silence.

Of all these men Prince Andrew sympathized most with Pfuel, angry,
determined, and absurdly self-confident as he was. Of all those
present, evidently he alone was not seeking anything for himself,
nursed no hatred against anyone, and only desired that the plan,
formed on a theory arrived at by years of toil, should be carried out.
He was ridiculous, and unpleasantly sarcastic, but yet he inspired
involuntary respect by his boundless devotion to an idea. Besides
this, the remarks of all except Pfuel had one common trait that had
not been noticeable at the council of war in 1805: there was now a
panic fear of Napoleon's genius, which, though concealed, was
noticeable in every rejoinder. Everything was assumed to be possible
for Napoleon, they expected him from every side, and invoked his
terrible name to shatter each other's proposals. Pfuel alone seemed to
consider Napoleon a barbarian like everyone else who opposed his
theory. But besides this feeling of respect, Pfuel evoked pity in
Prince Andrew. From the tone in which the courtiers addressed him
and the way Paulucci had allowed himself to speak of him to the
Emperor, but above all from a certain desperation in Pfuel's own
expressions, it was clear that the others knew, and Pfuel himself
felt, that his fall was at hand. And despite his self-confidence and
grumpy German sarcasm he was pitiable, with his hair smoothly
brushed on the temples and sticking up in tufts behind. Though he
concealed the fact under a show of irritation and contempt, he was
evidently in despair that the sole remaining chance of verifying his
theory by a huge experiment and proving its soundness to the whole
world was slipping away from him.

The discussions continued a long time, and the longer they lasted
the more heated became the disputes, culminating in shouts and
personalities, and the less was it possible to arrive at any general
conclusion from all that had been said. Prince Andrew, listening to
this polyglot talk and to these surmises, plans, refutations, and
shouts, felt nothing but amazement at what they were saying. A thought
that had long since and often occurred to him during his military
activities--the idea that there is not and cannot be any science of
war, and that therefore there can be no such thing as a military
genius--now appeared to him an obvious truth. "What theory and science
is possible about a matter the conditions and circumstances of which
are unknown and cannot be defined, especially when the strength of the
acting forces cannot be ascertained? No one was or is able to
foresee in what condition our or the enemy's armies will be in a day's
time, and no one can gauge the force of this or that detachment.
Sometimes--when there is not a coward at the front to shout, 'We are
cut off!' and start running, but a brave and jolly lad who shouts,
'Hurrah!'--a detachment of five thousand is worth thirty thousand,
as at Schon Grabern, while at times fifty thousand run from eight
thousand, as at Austerlitz. What science can there be in a matter in
which, as in all practical matters, nothing can be defined and
everything depends on innumerable conditions, the significance of
which is determined at a particular moment which arrives no one
knows when? Armfeldt says our army is cut in half, and Paulucci says
we have got the French army between two fires; Michaud says that the
worthlessness of the Drissa camp lies in having the river behind it,
and Pfuel says that is what constitutes its strength; Toll proposes
one plan, Armfeldt another, and they are all good and all bad, and the
advantages of any suggestions can be seen only at the moment of trial.
And why do they all speak of a 'military genius'? Is a man a genius
who can order bread to be brought up at the right time and say who
is to go to the right and who to the left? It is only because military
men are invested with pomp and power and crowds of sychophants flatter
power, attributing to it qualities of genius it does not possess.
The best generals I have known were, on the contrary, stupid or
absent-minded men. Bagration was the best, Napoleon himself admitted
that. And of Bonaparte himself! I remember his limited, self-satisfied
face on the field of Austerlitz. Not only does a good army commander
not need any special qualities, on the contrary he needs the absence
of the highest and best human attributes--love, poetry, tenderness,
and philosophic inquiring doubt. He should be limited, firmly
convinced that what he is doing is very important (otherwise he will
not have sufficient patience), and only then will he be a brave
leader. God forbid that he should be humane, should love, or pity,
or think of what is just and unjust. It is understandable that a
theory of their 'genius' was invented for them long ago because they
have power! The success of a military action depends not on them,
but on the man in the ranks who shouts, 'We are lost!' or who
shouts, 'Hurrah!' And only in the ranks can one serve with assurance
of being useful."

So thought Prince Andrew as he listened to the talking, and he
roused himself only when Paulucci called him and everyone was leaving.

At the review next day the Emperor asked Prince Andrew where he
would like to serve, and Prince Andrew lost his standing in court
circles forever by not asking to remain attached to the sovereign's
person, but for permission to serve in the army.





CHAPTER XII


Before the beginning of the campaign, Rostov had received a letter
from his parents in which they told him briefly of Natasha's illness
and the breaking off of her engagement to Prince Andrew (which they
explained by Natasha's having rejected him) and again asked Nicholas
to retire from the army and return home. On receiving this letter,
Nicholas did not even make any attempt to get leave of absence or to
retire from the army, but wrote to his parents that he was sorry
Natasha was ill and her engagement broken off, and that he would do
all he could to meet their wishes. To Sonya he wrote separately.

"Adored friend of my soul!" he wrote. "Nothing but honor could
keep me from returning to the country. But now, at the commencement of
the campaign, I should feel dishonored, not only in my comrades'
eyes but in my own, if I preferred my own happiness to my love and
duty to the Fatherland. But this shall be our last separation. Believe
me, directly the war is over, if I am still alive and still loved by
you, I will throw up everything and fly to you, to press you forever
to my ardent breast."

It was, in fact, only the commencement of the campaign that
prevented Rostov from returning home as he had promised and marrying
Sonya. The autumn in Otradnoe with the hunting, and the winter with
the Christmas holidays and Sonya's love, had opened out to him a vista
of tranquil rural joys and peace such as he had never known before,
and which now allured him. "A splendid wife, children, a good pack
of hounds, a dozen leashes of smart borzois, agriculture, neighbors,
service by election..." thought he. But now the campaign was
beginning, and he had to remain with his regiment. And since it had to
be so, Nicholas Rostov, as was natural to him, felt contented with the
life he led in the regiment and was able to find pleasure in that
life.

On his return from his furlough Nicholas, having been joyfully
welcomed by his comrades, was sent to obtain remounts and brought back
from the Ukraine excellent horses which pleased him and earned him
commendation from his commanders. During his absence he had been
promoted captain, and when the regiment was put on war footing with an
increase in numbers, he was again allotted his old squadron.

The campaign began, the regiment was moved into Poland on double
pay, new officers arrived, new men and horses, and above all everybody
was infected with the merrily excited mood that goes with the
commencement of a war, and Rostov, conscious of his advantageous
position in the regiment, devoted himself entirely to the pleasures
and interests of military service, though he knew that sooner or later
he would have to relinquish them.

The troops retired from Vilna for various complicated reasons of
state, political and strategic. Each step of the retreat was
accompanied by a complicated interplay of interests, arguments, and
passions at headquarters. For the Pavlograd hussars, however, the
whole of this retreat during the finest period of summer and with
sufficient supplies was a very simple and agreeable business.

It was only at headquarters that there was depression, uneasiness,
and intriguing; in the body of the army they did not ask themselves
where they were going or why. If they regretted having to retreat,
it was only because they had to leave billets they had grown
accustomed to, or some pretty young Polish lady. If the thought that
things looked bad chanced to enter anyone's head, he tried to be as
cheerful as befits a good soldier and not to think of the general
trend of affairs, but only of the task nearest to hand. First they
camped gaily before Vilna, making acquaintance with the Polish
landowners, preparing for reviews and being reviewed by the Emperor
and other high commanders. Then came an order to retreat to Sventsyani
and destroy any provisions they could not carry away with them.
Sventsyani was remembered by the hussars only as the drunken camp, a
name the whole army gave to their encampment there, and because many
complaints were made against the troops, who, taking advantage of
the order to collect provisions, took also horses, carriages, and
carpets from the Polish proprietors. Rostov remembered Sventsyani,
because on the first day of their arrival at that small town he
changed his sergeant major and was unable to manage all the drunken
men of his squadron who, unknown to him, had appropriated five barrels
of old beer. From Sventsyani they retired farther and farther to
Drissa, and thence again beyond Drissa, drawing near to the frontier
of Russia proper.

On the thirteenth of July the Pavlograds took part in a serious
action for the first time.

On the twelfth of July, on the eve of that action, there was a heavy
storm of rain and hail. In general, the summer of 1812 was
remarkable for its storms.

The two Pavlograd squadrons were bivouacking on a field of rye,
which was already in ear but had been completely trodden down by
cattle and horses. The rain was descending in torrents, and Rostov,
with a young officer named Ilyin, his protege, was sitting in a
hastily constructed shelter. An officer of their regiment, with long
mustaches extending onto his cheeks, who after riding to the staff had
been overtaken by the rain, entered Rostov's shelter.

"I have come from the staff, Count. Have you heard of Raevski's
exploit?"

And the officer gave them details of the Saltanov battle, which he
had heard at the staff.

Rostov, smoking his pipe and turning his head about as the water
trickled down his neck, listened inattentively, with an occasional
glance at Ilyin, who was pressing close to him. This officer, a lad of
sixteen who had recently joined the regiment, was now in the same
relation to Nicholas that Nicholas had been to Denisov seven years
before. Ilyin tried to imitate Rostov in everything and adored him
as a girl might have done.

Zdrzhinski, the officer with the long mustache, spoke
grandiloquently of the Saltanov dam being "a Russian Thermopylae," and
of how a deed worthy of antiquity had been performed by General
Raevski. He recounted how Raevski had led his two sons onto the dam
under terrific fire and had charged with them beside him. Rostov heard
the story and not only said nothing to encourage Zdrzhinski's
enthusiasm but, on the contrary, looked like a man ashamed of what
he was hearing, though with no intention of contradicting it. Since
the campaigns of Austerlitz and of 1807 Rostov knew by experience that
men always lie when describing military exploits, as he himself had
done when recounting them; besides that, he had experience enough to
know that nothing happens in war at all as we can imagine or relate
it. And so he did not like Zdrzhinski's tale, nor did he like
Zdrzhinski himself who, with his mustaches extending over his
cheeks, bent low over the face of his hearer, as was his habit, and
crowded Rostov in the narrow shanty. Rostov looked at him in
silence. "In the first place, there must have been such a confusion
and crowding on the dam that was being attacked that if Raevski did
lead his sons there, it could have had no effect except perhaps on
some dozen men nearest to him," thought he, "the rest could not have
seen how or with whom Raevski came onto the dam. And even those who
did see it would not have been much stimulated by it, for what had
they to do with Raevski's tender paternal feelings when their own
skins were in danger? And besides, the fate of the Fatherland did
not depend on whether they took the Saltanov dam or not, as we are
told was the case at Thermopylae. So why should he have made such a
sacrifice? And why expose his own children in the battle? I would
not have taken my brother Petya there, or even Ilyin, who's a stranger
to me but a nice lad, but would have tried to put them somewhere under
cover," Nicholas continued to think, as he listened to Zdrzhinski. But
he did not express his thoughts, for in such matters, too, he had
gained experience. He knew that this tale redounded to the glory of
our arms and so one had to pretend not to doubt it. And he acted
accordingly.

"I can't stand this any more," said Ilyin, noticing that Rostov
did not relish Zdrzhinski's conversation. "My stockings and shirt...
and the water is running on my seat! I'll go and look for shelter. The
rain seems less heavy."

Ilyin went out and Zdrzhinski rode away.

Five minutes later Ilyin, splashing through the mud, came running
back to the shanty.

"Hurrah! Rostov, come quick! I've found it! About two hundred
yards away there's a tavern where ours have already gathered. We can
at least get dry there, and Mary Hendrikhovna's there."

Mary Hendrikhovna was the wife of the regimental doctor, a pretty
young German woman he had married in Poland. The doctor, whether
from lack of means or because he did not like to part from his young
wife in the early days of their marriage, took her about with him
wherever the hussar regiment went and his jealousy had become a
standing joke among the hussar officers.

Rostov threw his cloak over his shoulders, shouted to Lavrushka to
follow with the things, and--now slipping in the mud, now splashing
right through it--set off with Ilyin in the lessening rain and the
darkness that was occasionally rent by distant lightning.

"Rostov, where are you?"

"Here. What lightning!" they called to one another.





CHAPTER XIII


In the tavern, before which stood the doctor's covered cart, there
were already some five officers. Mary Hendrikhovna, a plump little
blonde German, in a dressing jacket and nightcap, was sitting on a
broad bench in the front corner. Her husband, the doctor, lay asleep
behind her. Rostov and Ilyin, on entering the room, were welcomed with
merry shouts and laughter.

"Dear me, how jolly we are!" said Rostov laughing.

"And why do you stand there gaping?"

"What swells they are! Why, the water streams from them! Don't
make our drawing room so wet."

"Don't mess Mary Hendrikhovna's dress!" cried other voices.

Rostov and Ilyin hastened to find a corner where they could change
into dry clothes without offending Mary Hendrikhovna's modesty. They
were going into a tiny recess behind a partition to change, but
found it completely filled by three officers who sat playing cards
by the light of a solitary candle on an empty box, and these
officers would on no account yield their position. Mary Hendrikhovna
obliged them with the loan of a petticoat to be used as a curtain, and
behind that screen Rostov and Ilyin, helped by Lavrushka who had
brought their kits, changed their wet things for dry ones.

A fire was made up in the dilapidated brick stove. A board was
found, fixed on two saddles and covered with a horsecloth, a small
samovar was produced and a cellaret and half a bottle of rum, and
having asked Mary Hendrikhovna to preside, they all crowded round her.
One offered her a clean handkerchief to wipe her charming hands,
another spread a jacket under her little feet to keep them from the
damp, another hung his coat over the window to keep out the draft, and
yet another waved the flies off her husband's face, lest he should
wake up.

"Leave him alone," said Mary Hendrikhovna, smiling timidly and
happily. "He is sleeping well as it is, after a sleepless night."

"Oh, no, Mary Hendrikhovna," replied the officer, "one must look
after the doctor. Perhaps he'll take pity on me someday, when it comes
to cutting off a leg or an arm for me."

There were only three tumblers, the water was so muddy that one
could not make out whether the tea was strong or weak, and the samovar
held only six tumblers of water, but this made it all the pleasanter
to take turns in order of seniority to receive one's tumbler from Mary
Hendrikhovna's plump little hands with their short and not overclean
nails. All the officers appeared to be, and really were, in love
with her that evening. Even those playing cards behind the partition
soon left their game and came over to the samovar, yielding to the
general mood of courting Mary Hendrikhovna. She, seeing herself
surrounded by such brilliant and polite young men, beamed with
satisfaction, try as she might to hide it, and perturbed as she
evidently was each time her husband moved in his sleep behind her.

There was only one spoon, sugar was more plentiful than anything
else, but it took too long to dissolve, so it was decided that Mary
Hendrikhovna should stir the sugar for everyone in turn. Rostov
received his tumbler, and adding some rum to it asked Mary
Hendrikhovna to stir it.

"But you take it without sugar?" she said, smiling all the time,
as if everything she said and everything the others said was very
amusing and had a double meaning.

"It is not the sugar I want, but only that your little hand should
stir my tea."

Mary Hendrikhovna assented and began looking for the spoon which
someone meanwhile had pounced on.

"Use your finger, Mary Hendrikhovna, it will be still nicer," said
Rostov.

"Too hot!" she replied, blushing with pleasure.

Ilyin put a few drops of rum into the bucket of water and brought it
to Mary Hendrikhovna, asking her to stir it with her finger.

"This is my cup," said he. "Only dip your finger in it and I'll
drink it all up."

When they had emptied the samovar, Rostov took a pack of cards and
proposed that they should play "Kings" with Mary Hendrikhovna. They
drew lots to settle who should make up her set. At Rostov's suggestion
it was agreed that whoever became "King" should have the right to kiss
Mary Hendrikhovna's hand, and that the "Booby" should go to refill and
reheat the samovar for the doctor when the latter awoke.

"Well, but supposing Mary Hendrikhovna is 'King'?" asked Ilyin.

"As it is, she is Queen, and her word is law!"

They had hardly begun to play before the doctor's disheveled head
suddenly appeared from behind Mary Hendrikhovna. He had been awake for
some time, listening to what was being said, and evidently found
nothing entertaining or amusing in what was going on. His face was sad
and depressed. Without greeting the officers, he scratched himself and
asked to be allowed to pass as they were blocking the way. As soon
as he had left the room all the officers burst into loud laughter
and Mary Hendrikhovna blushed till her eyes filled with tears and
thereby became still more attractive to them. Returning from the yard,
the doctor told his wife (who had ceased to smile so happily, and
looked at him in alarm, awaiting her sentence) that the rain had
ceased and they must go to sleep in their covered cart, or
everything in it would be stolen.

"But I'll send an orderly.... Two of them!" said Rostov. "What an
idea, doctor!"

"I'll stand guard on it myself!" said Ilyin.

"No, gentlemen, you have had your sleep, but I have not slept for
two nights," replied the doctor, and he sat down morosely beside his
wife, waiting for the game to end.

Seeing his gloomy face as he frowned at his wife, the officers
grew still merrier, and some of them could not refrain from
laughter, for which they hurriedly sought plausible pretexts. When
he had gone, taking his wife with him, and had settled down with her
in their covered cart, the officers lay down in the tavern, covering
themselves with their wet cloaks, but they did not sleep for a long
time; now they exchanged remarks, recalling the doctor's uneasiness
and his wife's delight, now they ran out into the porch and reported
what was taking place in the covered trap. Several times Rostov,
covering his head, tried to go to sleep, but some remark would
arouse him and conversation would be resumed, to the accompaniment
of unreasoning, merry, childlike laughter.





CHAPTER XIV


It was nearly three o'clock but no one was yet asleep, when the
quartermaster appeared with an order to move on to the little town
of Ostrovna. Still laughing and talking, the officers began
hurriedly getting ready and again boiled some muddy water
in the samovar. But Rostov went off to his squadron without waiting
for tea. Day was breaking, the rain had ceased, and the clouds were
dispersing. It felt damp and cold, especially in clothes that were
still moist. As they left the tavern in the twilight of the dawn,
Rostov and Ilyin both glanced under the wet and glistening leather
hood of the doctor's cart, from under the apron of which his feet were
sticking out, and in the middle of which his wife's nightcap was
visible and her sleepy breathing audible.

"She really is a dear little thing," said Rostov to Ilyin, who was
following him.

"A charming woman!" said Ilyin, with all the gravity of a boy of
sixteen.

Half an hour later the squadron was lined up on the road. The
command was heard to "mount" and the soldiers crossed themselves and
mounted. Rostov riding in front gave the order "Forward!" and the
hussars, with clanking sabers and subdued talk, their horses' hoofs
splashing in the mud, defiled in fours and moved along the broad
road planted with birch trees on each side, following the infantry and
a battery that had gone on in front.

Tattered, blue-purple clouds, reddening in the east, were scudding
before the wind. It was growing lighter and lighter. That curly
grass which always grows by country roadsides became clearly
visible, still wet with the night's rain; the drooping branches of the
birches, also wet, swayed in the wind and flung down bright drops of
water to one side. The soldiers' faces were more and more clearly
visible. Rostov, always closely followed by Ilyin, rode along the side
of the road between two rows of birch trees.

When campaigning, Rostov allowed himself the indulgence of riding
not a regimental but a Cossack horse. A judge of horses and a
sportsman, he had lately procured himself a large, fine, mettlesome,
Donets horse, dun-colored, with light mane and tail, and when he
rode it no one could outgallop him. To ride this horse was a
pleasure to him, and he thought of the horse, of the morning, of the
doctor's wife, but not once of the impending danger.

Formerly, when going into action, Rostov had felt afraid; now he had
not the least feeling of fear. He was fearless, not because he had
grown used to being under fire (one cannot grow used to danger), but
because he had learned how to manage his thoughts when in danger. He
had grown accustomed when going into action to think about anything
but what would seem most likely to interest him--the impending danger.
During the first period of his service, hard as he tried and much as
he reproached himself with cowardice, he had not been able to do this,
but with time it had come of itself. Now he rode beside Ilyin under
the birch trees, occasionally plucking leaves from a branch that met
his hand, sometimes touching his horse's side with his foot, or,
without turning round, handing a pipe he had finished to an hussar
riding behind him, with as calm and careless an air as though he
were merely out for a ride. He glanced with pity at the excited face
of Ilyin, who talked much and in great agitation. He knew from
experience the tormenting expectation of terror and death the cornet
was suffering and knew that only time could help him.

As soon as the sun appeared in a clear strip of sky beneath the
clouds, the wind fell, as if it dared not spoil the beauty of the
summer morning after the storm; drops still continued to fall, but
vertically now, and all was still. The whole sun appeared on the
horizon and disappeared behind a long narrow cloud that hung above it.
A few minutes later it reappeared brighter still from behind the top
of the cloud, tearing its edge. Everything grew bright and
glittered. And with that light, and as if in reply to it, came the
sound of guns ahead of them.

Before Rostov had had time to consider and determine the distance of
that firing, Count Ostermann-Tolstoy's adjutant came galloping from
Vitebsk with orders to advance at a trot along the road.

The squadron overtook and passed the infantry and the battery--which
had also quickened their pace--rode down a hill, and passing through
an empty and deserted village again ascended. The horses began to
lather and the men to flush.

"Halt! Dress your ranks!" the order of the regimental commander
was heard ahead. "Forward by the left. Walk, march!" came the order
from in front.

And the hussars, passing along the line of troops on the left
flank of our position, halted behind our Uhlans who were in the
front line. To the right stood our infantry in a dense column: they
were the reserve. Higher up the hill, on the very horizon, our guns
were visible through the wonderfully clear air, brightly illuminated
by slanting morning sunbeams. In front, beyond a hollow dale, could be
seen the enemy's columns and guns. Our advanced line, already in
action, could be heard briskly exchanging shots with the enemy in
the dale.

At these sounds, long unheard, Rostov's spirits rose, as at the
strains of the merriest music. Trap-ta-ta-tap! cracked the shots,
now together, now several quickly one after another. Again all was
silent and then again it sounded as if someone were walking on
detonators and exploding them.

The hussars remained in the same place for about an hour. A
cannonade began. Count Ostermann with his suite rode up behind the
squadron, halted, spoke to the commander of the regiment, and rode
up the hill to the guns.

After Ostermann had gone, a command rang out to the Uhlans.

"Form column! Prepare to charge!"

The infantry in front of them parted into platoons to allow the
cavalry to pass. The Uhlans started, the streamers on their spears
fluttering, and trotted downhill toward the French cavalry which was
seen below to the left.

As soon as the Uhlans descended the hill, the hussars were ordered
up the hill to support the battery. As they took the places vacated by
the Uhlans, bullets came from the front, whining and whistling, but
fell spent without taking effect.

The sounds, which he had not heard for so long, had an even more
pleasurable and exhilarating effect on Rostov than the previous sounds
of firing. Drawing himself up, he viewed the field of battle opening
out before him from the hill, and with his whole soul followed the
movement of the Uhlans. They swooped down close to the French
dragoons, something confused happened there amid the smoke, and five
minutes later our Uhlans were galloping back, not to the place they
had occupied but more to the left, and among the orange-colored Uhlans
on chestnut horses and behind them, in a large group, blue French
dragoons on gray horses could be seen.





CHAPTER XV


Rostov, with his keen sportsman's eye, was one of the first to catch
sight of these blue French dragoons pursuing our Uhlans. Nearer and
nearer in disorderly crowds came the Uhlans and the French dragoons
pursuing them. He could already see how these men, who looked so small
at the foot of the hill, jostled and overtook one another, waving
their arms and their sabers in the air.

Rostov gazed at what was happening before him as at a hunt. He
felt instinctively that if the hussars struck at the French dragoons
now, the latter could not withstand them, but if a charge was to be
made it must be done now, at that very moment, or it would be too
late. He looked around. A captain, standing beside him, was gazing
like himself with eyes fixed on the cavalry below them.

"Andrew Sevastyanych!" said Rostov. "You know, we could crush
them...."

"A fine thing too!" replied the captain, "and really..."

Rostov, without waiting to hear him out, touched his horse, galloped
to the front of his squadron, and before he had time to finish
giving the word of command, the whole squadron, sharing his feeling,
was following him. Rostov himself did not know how or why he did it.
He acted as he did when hunting, without reflecting or considering. He
saw the dragoons near and that they were galloping in disorder; he
knew they could not withstand an attack--knew there was only that
moment and that if he let it slip it would not return. The bullets
were whining and whistling so stimulatingly around him and his horse
was so eager to go that he could not restrain himself. He touched
his horse, gave the word of command, and immediately, hearing behind
him the tramp of the horses of his deployed squadron, rode at full
trot downhill toward the dragoons. Hardly had they reached the
bottom of the hill before their pace instinctively changed to a
gallop, which grew faster and faster as they drew nearer to our Uhlans
and the French dragoons who galloped after them. The dragoons were now
close at hand. On seeing the hussars, the foremost began to turn,
while those behind began to halt. With the same feeling with which
he had galloped across the path of a wolf, Rostov gave rein to his
Donets horse and galloped to intersect the path of the dragoons'
disordered lines. One Uhlan stopped, another who was on foot flung
himself to the ground to avoid being knocked over, and a riderless
horse fell in among the hussars. Nearly all the French dragoons were
galloping back. Rostov, picking out one on a gray horse, dashed
after him. On the way he came upon a bush, his gallant horse cleared
it, and almost before he had righted himself in his saddle he saw that
he would immediately overtake the enemy he had selected. That
Frenchman, by his uniform an officer, was going at a gallop, crouching
on his gray horse and urging it on with his saber. In another moment
Rostov's horse dashed its breast against the hindquarters of the
officer's horse, almost knocking it over, and at the same instant
Rostov, without knowing why, raised his saber and struck the Frenchman
with it.

The instant he had done this, all Rostov's animation vanished. The
officer fell, not so much from the blow--which had but slightly cut
his arm above the elbow--as from the shock to his horse and from
fright. Rostov reined in his horse, and his eyes sought his foe to see
whom he had vanquished. The French dragoon officer was hopping with
one foot on the ground, the other being caught in the stirrup. His
eyes, screwed up with fear as if he every moment expected another
blow, gazed up at Rostov with shrinking terror. His pale and
mud-stained face--fair and young, with a dimple in the chin and
light-blue eyes--was not an enemy's face at all suited to a
battlefield, but a most ordinary, homelike face. Before Rostov had
decided what to do with him, the officer cried, "I surrender!" He
hurriedly but vainly tried to get his foot out of the stirrup and
did not remove his frightened blue eyes from Rostov's face. Some
hussars who galloped up disengaged his foot and helped him into the
saddle. On all sides, the hussars were busy with the dragoons; one was
wounded, but though his face was bleeding, he would not give up his
horse; another was perched up behind an hussar with his arms round
him; a third was being helped by an hussar to mount his horse. In
front, the French infantry were firing as they ran. The hussars
galloped hastily back with their prisoners. Rostov galloped back
with the rest, aware of an unpleasant feeling of depression in his
heart. Something vague and confused, which he could not at all account
for, had come over him with the capture of that officer and the blow
he had dealt him.

Count Ostermann-Tolstoy met the returning hussars, sent for
Rostov, thanked him, and said he would report his gallant deed to
the Emperor and would recommend him for a St. George's Cross. When
sent for by Count Ostermann, Rostov, remembering that he had charged
without orders, felt sure his commander was sending for him to
punish him for breach of discipline. Ostermann's flattering words
and promise of a reward should therefore have struck him all the
more pleasantly, but he still felt that same vaguely disagreeable
feeling of moral nausea. "But what on earth is worrying me?" he
asked himself as he rode back from the general. "Ilyin? No, he's safe.
Have I disgraced myself in any way? No, that's not it." Something
else, resembling remorse, tormented him. "Yes, oh yes, that French
officer with the dimple. And I remember how my arm paused when I
raised it."

Rostov saw the prisoners being led away and galloped after them to
have a look at his Frenchman with the dimple on his chin. He was
sitting in his foreign uniform on an hussar packhorse and looked
anxiously about him; The sword cut on his arm could scarcely be called
a wound. He glanced at Rostov with a feigned smile and waved his
hand in greeting. Rostov still had the same indefinite feeling, as
of shame.

All that day and the next his friends and comrades noticed that
Rostov, without being dull or angry, was silent, thoughtful, and
preoccupied. He drank reluctantly, tried to remain alone, and kept
turning something over in his mind.

Rostov was always thinking about that brilliant exploit of his,
which to his amazement had gained him the St. George's Cross and
even given him a reputation for bravery, and there was something he
could not at all understand. "So others are even more afraid than I
am!" he thought. "So that's all there is in what is called heroism!
And heroism! And did I do it for my country's sake? And how was he
to blame, with his dimple and blue eyes? And how frightened he was! He
thought that I should kill him. Why should I kill him? My hand
trembled. And they have given me a St. George's Cross.... I can't make
it out at all."

But while Nicholas was considering these questions and still could
reach no clear solution of what puzzled him so, the wheel of fortune
in the service, as often happens, turned in his favor. After the
affair at Ostrovna he was brought into notice, received command of
an hussar battalion, and when a brave officer was needed he was
chosen.





CHAPTER XVI


On receiving news of Natasha's illness, the countess, though not
quite well yet and still weak, went to Moscow with Petya and the
rest of the household, and the whole family moved from Marya
Dmitrievna's house to their own and settled down in town.

Natasha's illness was so serious that, fortunately for her and for
her parents, the consideration of all that had caused the illness, her
conduct and the breaking off of her engagement, receded into the
background. She was so ill that it was impossible for them to consider
in how far she was to blame for what had happened. She could not eat
or sleep, grew visibly thinner, coughed, and, as the doctors made them
feel, was in danger. They could not think of anything but how to
help her. Doctors came to see her singly and in consultation, talked
much in French, German, and Latin, blamed one another, and
prescribed a great variety of medicines for all the diseases known
to them, but the simple idea never occurred to any of them that they
could not know the disease Natasha was suffering from, as no disease
suffered by a live man can be known, for every living person has his
own peculiarities and always has his own peculiar, personal, novel,
complicated disease, unknown to medicine--not a disease of the
lungs, liver, skin, heart, nerves, and so on mentioned in medical
books, but a disease consisting of one of the innumerable combinations
of the maladies of those organs. This simple thought could not occur
to the doctors (as it cannot occur to a wizard that he is unable to
work his charms) because the business of their lives was to cure,
and they received money for it and had spent the best years of their
lives on that business. But, above all, that thought was kept out of
their minds by the fact that they saw they were really useful, as in
fact they were to the whole Rostov family. Their usefulness did not
depend on making the patient swallow substances for the most part
harmful (the harm was scarcely perceptible, as they were given in
small doses), but they were useful, necessary, and indispensable
because they satisfied a mental need of the invalid and of those who
loved her--and that is why there are, and always will be,
pseudo-healers, wise women, homeopaths, and allopaths. They
satisfied that eternal human need for hope of relief, for sympathy,
and that something should be done, which is felt by those who are
suffering. They satisfied the need seen in its most elementary form in
a child, when it wants to have a place rubbed that has been hurt. A
child knocks itself and runs at once to the arms of its mother or
nurse to have the aching spot rubbed or kissed, and it feels better
when this is done. The child cannot believe that the strongest and
wisest of its people have no remedy for its pain, and the hope of
relief and the expression of its mother's sympathy while she rubs
the bump comforts it. The doctors were of use to Natasha because
they kissed and rubbed her bump, assuring her that it would soon
pass if only the coachman went to the chemist's in the Arbat and got a
powder and some pills in a pretty box of a ruble and seventy kopeks,
and if she took those powders in boiled water at intervals of
precisely two hours, neither more nor less.

What would Sonya and the count and countess have done, how would
they have looked, if nothing had been done, if there had not been
those pills to give by the clock, the warm drinks, the chicken
cutlets, and all the other details of life ordered by the doctors, the
carrying out of which supplied an occupation and consolation to the
family circle? How would the count have borne his dearly loved
daughter's illness had he not known that it was costing him a thousand
rubles, and that he would not grudge thousands more to benefit her, or
had he not known that if her illness continued he would not grudge yet
other thousands and would take her abroad for consultations there, and
had he not been able to explain the details of how Metivier and Feller
had not understood the symptoms, but Frise had, and Mudrov had
diagnosed them even better? What would the countess have done had
she not been able sometimes to scold the invalid for not strictly
obeying the doctor's orders?

"You'll never get well like that," she would say, forgetting her
grief in her vexation, "if you won't obey the doctor and take your
medicine at the right time! You mustn't trifle with it, you know, or
it may turn to pneumonia," she would go on, deriving much comfort from
the utterance of that foreign word, incomprehensible to others as well
as to herself.

What would Sonya have done without the glad consciousness that she
had not undressed during the first three nights, in order to be
ready to carry out all the doctor's injunctions with precision, and
that she still kept awake at night so as not to miss the proper time
when the slightly harmful pills in the little gilt box had to be
administered? Even to Natasha herself it was pleasant to see that so
many sacrifices were being made for her sake, and to know that she had
to take medicine at certain hours, though she declared that no
medicine would cure her and that it was all nonsense. And it was
even pleasant to be able to show, by disregarding the orders, that she
did not believe in medical treatment and did not value her life.

The doctor came every day, felt her pulse, looked at her tongue, and
regardless of her grief-stricken face joked with her. But when he
had gone into another room, to which the countess hurriedly followed
him, he assumed a grave air and thoughtfully shaking his head said
that though there was danger, he had hopes of the effect of this
last medicine and one must wait and see, that the malady was chiefly
mental, but... And the countess, trying to conceal the action from
herself and from him, slipped a gold coin into his hand and always
returned to the patient with a more tranquil mind.

The symptoms of Natasha's illness were that she ate little, slept
little, coughed, and was always low-spirited. The doctors said that
she could not get on without medical treatment, so they kept her in
the stifling atmosphere of the town, and the Rostovs did not move to
the country that summer of 1812.

In spite of the many pills she swallowed and the drops and powders
out of the little bottles and boxes of which Madame Schoss who was
fond of such things made a large collection, and in spite of being
deprived of the country life to which she was accustomed, youth
prevailed. Natasha's grief began to be overlaid by the impressions
of daily life, it ceased to press so painfully on her heart, it
gradually faded into the past, and she began to recover physically.





CHAPTER XVII


Natasha was calmer but no happier. She not merely avoided all
external forms of pleasure--balls, promenades, concerts, and theaters-
but she never laughed without a sound of tears in her laughter. She
could not sing. As soon as she began to laugh, or tried to sing by
herself, tears choked her: tears of remorse, tears at the recollection
of those pure times which could never return, tears of vexation that
she should so uselessly have ruined her young life which might have
been so happy. Laughter and singing in particular seemed to her like a
blasphemy, in face of her sorrow. Without any need of
self-restraint, no wish to coquet ever entered her head. She said
and felt at that time that no man was more to her than Nastasya
Ivanovna, the buffoon. Something stood sentinel within her and forbade
her every joy. Besides, she had lost all the old interests of her
carefree girlish life that had been so full of hope. The previous
autumn, the hunting, "Uncle," and the Christmas holidays spent with
Nicholas at Otradnoe were what she recalled oftenest and most
painfully. What would she not have given to bring back even a single
day of that time! But it was gone forever. Her presentiment at the
time had not deceived her--that that state of freedom and readiness
for any enjoyment would not return again. Yet it was necessary to live
on.

It comforted her to reflect that she was not better as she had
formerly imagined, but worse, much worse, than anybody else in the
world. But this was not enough. She knew that, and asked herself,
"What next?" But there was nothing to come. There was no joy in
life, yet life was passing. Natasha apparently tried not to be a
burden or a hindrance to anyone, but wanted nothing for herself. She
kept away from everyone in the house and felt at ease only with her
brother Petya. She liked to be with him better than with the others,
and when alone with him she sometimes laughed. She hardly ever left
the house and of those who came to see them was glad to see only one
person, Pierre. It would have been impossible to treat her with more
delicacy, greater care, and at the same time more seriously than did
Count Bezukhov. Natasha unconsciously felt this delicacy and so
found great pleasure in his society. But she was not even grateful
to him for it; nothing good on Pierre's part seemed to her to be an
effort, it seemed so natural for him to be kind to everyone that there
was no merit in his kindness. Sometimes Natasha noticed
embarrassment and awkwardness on his part in her presence,
especially when he wanted to do something to please her, or feared
that something they spoke of would awaken memories distressing to her.
She noticed this and attributed it to his general kindness and
shyness, which she imagined must be the same toward everyone as it was
to her. After those involuntary words--that if he were free he would
have asked on his knees for her hand and her love--uttered at a moment
when she was so strongly agitated, Pierre never spoke to Natasha of
his feelings; and it seemed plain to her that those words, which had
then so comforted her, were spoken as all sorts of meaningless words
are spoken to comfort a crying child. It was not because Pierre was
a married man, but because Natasha felt very strongly with him that
moral barrier the absence of which she had experienced with Kuragin
that it never entered her head that the relations between him and
herself could lead to love on her part, still less on his, or even
to the kind of tender, self-conscious, romantic friendship between a
man and a woman of which she had known several instances.

Before the end of the fast of St. Peter, Agrafena Ivanovna Belova, a
country neighbor of the Rostovs, came to Moscow to pay her devotions
at the shrines of the Moscow saints. She suggested that Natasha should
fast and prepare for Holy Communion, and Natasha gladly welcomed the
idea. Despite the doctor's orders that she should not go out early
in the morning, Natasha insisted on fasting and preparing for the
sacrament, not as they generally prepared for it in the Rostov
family by attending three services in their own house, but as Agrafena
Ivanovna did, by going to church every day for a week and not once
missing Vespers, Matins, or Mass.

The countess was pleased with Natasha's zeal; after the poor results
of the medical treatment, in the depths of her heart she hoped that
prayer might help her daughter more than medicines and, though not
without fear and concealing it from the doctor, she agreed to
Natasha's wish and entrusted her to Belova. Agrafena Ivanovna used
to come to wake Natasha at three in the morning, but generally found
her already awake. She was afraid of being late for Matins. Hastily
washing, and meekly putting on her shabbiest dress and an old
mantilla, Natasha, shivering in the fresh air, went out into the
deserted streets lit by the clear light of dawn. By Agrafena
Ivanovna's advice Natasha prepared herself not in their own parish,
but at a church where, according to the devout Agrafena Ivanovna,
the priest was a man of very severe and lofty life. There were never
many people in the church; Natasha always stood beside Belova in the
customary place before an icon of the Blessed Virgin, let into the
screen before the choir on the left side, and a feeling, new to her,
of humility before something great and incomprehensible, seized her
when at that unusual morning hour, gazing at the dark face of the
Virgin illuminated by the candles burning before it and by the morning
light falling from the window, she listened to the words of the
service which she tried to follow with understanding. When she
understood them her personal feeling became interwoven in the
prayers with shades of its own. When she did not understand, it was
sweeter still to think that the wish to understand everything is
pride, that it is impossible to understand all, that it is only
necessary to believe and to commit oneself to God, whom she felt
guiding her soul at those moments. She crossed herself, bowed low, and
when she did not understand, in horror at her own vileness, simply
asked God to forgive her everything, everything, to have mercy upon
her. The prayers to which she surrendered herself most of all were
those of repentance. On her way home at an early hour when she met
no one but bricklayers going to work or men sweeping the street, and
everybody within the houses was still asleep, Natasha experienced a
feeling new to her, a sense of the possibility of correcting her
faults, the possibility of a new, clean life, and of happiness.

During the whole week she spent in this way, that feeling grew every
day. And the happiness of taking communion, or "communing" as Agrafena
Ivanovna, joyously playing with the word, called it, seemed to Natasha
so great that she felt she should never live till that blessed Sunday.

But the happy day came, and on that memorable Sunday, when,
dressed in white muslin, she returned home after communion, for the
first time for many months she felt calm and not oppressed by the
thought of the life that lay before her.

The doctor who came to see her that day ordered her to continue
the powders he had prescribed a fortnight previously.

"She must certainly go on taking them morning and evening," said he,
evidently sincerely satisfied with his success. "Only, please be
particular about it.

"Be quite easy," he continued playfully, as he adroitly took the
gold coin in his palm. "She will soon be singing and frolicking about.
The last medicine has done her a very great deal of good. She has
freshened up very much."

The countess, with a cheerful expression on her face, looked down at
her nails and spat a little for luck as she returned to the drawing
room.





CHAPTER XVIII


At the beginning of July more and more disquieting reports about the
war began to spread in Moscow; people spoke of an appeal by the
Emperor to the people, and of his coming himself from the army to
Moscow. And as up to the eleventh of July no manifesto or appeal had
been received, exaggerated reports became current about them and about
the position of Russia. It was said that the Emperor was leaving the
army because it was in danger, it was said that Smolensk had
surrendered, that Napoleon had an army of a million and only a miracle
could save Russia.

On the eleventh of July, which was Saturday, the manifesto was
received but was not yet in print, and Pierre, who was at the
Rostovs', promised to come to dinner next day, Sunday, and bring a
copy of the manifesto and appeal, which he would obtain from Count
Rostopchin.

That Sunday, the Rostovs went to Mass at the Razumovskis' private
chapel as usual. It was a hot July day. Even at ten o'clock, when
the Rostovs got out of their carriage at the chapel, the sultry air,
the shouts of hawkers, the light and gay summer clothes of the
crowd, the dusty leaves of the trees on the boulevard, the sounds of
the band and the white trousers of a battalion marching to parade, the
rattling of wheels on the cobblestones, and the brilliant, hot
sunshine were all full of that summer languor, that content and
discontent with the present, which is most strongly felt on a
bright, hot day in town. All the Moscow notabilities, all the Rostovs'
acquaintances, were at the Razumovskis' chapel, for, as if expecting
something to happen, many wealthy families who usually left town for
their country estates had not gone away that summer. As Natasha, at
her mother's side, passed through the crowd behind a liveried
footman who cleared the way for them, she heard a young man speaking
about her in too loud a whisper.

"That's Rostova, the one who..."

"She's much thinner, but all the same she's pretty!"

She heard, or thought she heard, the names of Kuragin and Bolkonski.
But she was always imagining that. It always seemed to her that
everyone who looked at her was thinking only of what had happened to
her. With a sinking heart, wretched as she always was now when she
found herself in a crowd, Natasha in her lilac silk dress trimmed with
black lace walked--as women can walk--with the more repose and
stateliness the greater the pain and shame in her soul. She knew for
certain that she was pretty, but this no longer gave her
satisfaction as it used to. On the contrary it tormented her more than
anything else of late, and particularly so on this bright, hot
summer day in town. "It's Sunday again--another week past," she
thought, recalling that she had been here the Sunday before, "and
always the same life that is no life, and the same surroundings in
which it used to be so easy to live. I'm pretty, I'm young, and I know
that now I am good. I used to be bad, but now I know I am good," she
thought, "but yet my best years are slipping by and are no good to
anyone." She stood by her mother's side and exchanged nods with
acquaintances near her. From habit she scrutinized the ladies'
dresses, condemned the bearing of a lady standing close by who was not
crossing herself properly but in a cramped manner, and again she
thought with vexation that she was herself being judged and was
judging others, and suddenly, at the sound of the service, she felt
horrified at her own vileness, horrified that the former purity of her
soul was again lost to her.

A comely, fresh-looking old man was conducting the service with that
mild solemnity which has so elevating and soothing an effect on the
souls of the worshipers. The gates of the sanctuary screen were
closed, the curtain was slowly drawn, and from behind it a soft
mysterious voice pronounced some words. Tears, the cause of which
she herself did not understand, made Natasha's breast heave, and a
joyous but oppressive feeling agitated her.

"Teach me what I should do, how to live my life, how I may grow good
forever, forever!" she pleaded.

The deacon came out onto the raised space before the altar screen
and, holding his thumb extended, drew his long hair from under his
dalmatic and, making the sign of the cross on his breast, began in a
loud and solemn voice to recite the words of the prayer...

"In peace let us pray unto the Lord."

"As one community, without distinction of class, without enmity,
united by brotherly love--let us pray!" thought Natasha.

"For the peace that is from above, and for the salvation of our
souls."

"For the world of angels and all the spirits who dwell above us,"
prayed Natasha.

When they prayed for the warriors, she thought of her brother and
Denisov. When they prayed for all traveling by land and sea, she
remembered Prince Andrew, prayed for him, and asked God to forgive her
all the wrongs she had done him. When they prayed for those who love
us, she prayed for the members of her own family, her father and
mother and Sonya, realizing for the first time how wrongly she had
acted toward them, and feeling all the strength of her love for
them. When they prayed for those who hate us, she tried to think of
her enemies and people who hated her, in order to pray for them. She
included among her enemies the creditors and all who had business
dealings with her father, and always at the thought of enemies and
those who hated her she remembered Anatole who had done her so much
harm--and though he did not hate her she gladly prayed for him as
for an enemy. Only at prayer did she feel able to think clearly and
calmly of Prince Andrew and Anatole, as men for whom her feelings were
as nothing compared with her awe and devotion to God. When they prayed
for the Imperial family and the Synod, she bowed very low and made the
sign of the cross, saying to herself that even if she did not
understand, still she could not doubt, and at any rate loved the
governing Synod and prayed for it.

When he had finished the Litany the deacon crossed the stole over
his breast and said, "Let us commit ourselves and our whole lives to
Christ the Lord!"

"Commit ourselves to God," Natasha inwardly repeated. "Lord God, I
submit myself to Thy will!" she thought. "I want nothing, wish for
nothing; teach me what to do and how to use my will! Take me, take
me!" prayed Natasha, with impatient emotion in her heart, not crossing
herself but letting her slender arms hang down as if expecting some
invisible power at any moment to take her and deliver her from
herself, from her regrets, desires, remorse, hopes, and sins.

The countess looked round several times at her daughter's softened
face and shining eyes and prayed God to help her.

Unexpectedly, in the middle of the service, and not in the usual
order Natasha knew so well, the deacon brought out a small stool,
the one he knelt on when praying on Trinity Sunday, and placed it
before the doors of the sanctuary screen. The priest came out with his
purple velvet biretta on his head, adjusted his hair, and knelt down
with an effort. Everybody followed his example and they looked at
one another in surprise. Then came the prayer just received from the
Synod--a prayer for the deliverance of Russia from hostile invasion.

"Lord God of might, God of our salvation!" began the priest in
that voice, clear, not grandiloquent but mild, in which only the
Slav clergy read and which acts so irresistibly on a Russian heart.

"Lord God of might, God of our salvation! Look this day in mercy and
blessing on Thy humble people, and graciously hear us, spare us, and
have mercy upon us! This foe confounding Thy land, desiring to lay
waste the whole world, rises against us; these lawless men are
gathered together to overthrow Thy kingdom, to destroy Thy dear
Jerusalem, Thy beloved Russia; to defile Thy temples, to overthrow
Thine altars, and to desecrate our holy shrines. How long, O Lord, how
long shall the wicked triumph? How long shall they wield unlawful
power?

"Lord God! Hear us when we pray to Thee; strengthen with Thy might
our most gracious sovereign lord, the Emperor Alexander Pavlovich;
be mindful of his uprightness and meekness, reward him according to
his righteousness, and let it preserve us, Thy chosen Israel! Bless
his counsels, his undertakings, and his work; strengthen his kingdom
by Thine almighty hand, and give him victory over his enemy, even as
Thou gavest Moses the victory over Amalek, Gideon over Midian, and
David over Goliath. Preserve his army, put a bow of brass in the hands
of those who have armed themselves in Thy Name, and gird their loins
with strength for the fight. Take up the spear and shield and arise to
help us; confound and put to shame those who have devised evil against
us, may they be before the faces of Thy faithful warriors as dust
before the wind, and may Thy mighty Angel confound them and put them
to flight; may they be ensnared when they know it not, and may the
plots they have laid in secret be turned against them; let them fall
before Thy servants' feet and be laid low by our hosts! Lord, Thou art
able to save both great and small; Thou art God, and man cannot
prevail against Thee!

"God of our fathers! Remember Thy bounteous mercy and
loving-kindness which are from of old; turn not Thy face from us,
but be gracious to our unworthiness, and in Thy great goodness and Thy
many mercies regard not our transgressions and iniquities! Create in
us a clean heart and renew a right spirit within us, strengthen us all
in Thy faith, fortify our hope, inspire us with true love one for
another, arm us with unity of spirit in the righteous defense of the
heritage Thou gavest to us and to our fathers, and let not the scepter
of the wicked be exalted against the destiny of those Thou hast
sanctified.

"O Lord our God, in whom we believe and in whom we put our trust,
let us not be confounded in our hope of Thy mercy, and give us a token
of Thy blessing, that those who hate us and our Orthodox faith may see
it and be put to shame and perish, and may all the nations know that
Thou art the Lord and we are Thy people. Show Thy mercy upon us this
day, O Lord, and grant us Thy salvation; make the hearts of Thy
servants to rejoice in Thy mercy; smite down our enemies and destroy
them swiftly beneath the feet of Thy faithful servants! For Thou art
the defense, the succor, and the victory of them that put their
trust in Thee, and to Thee be all glory, to Father, Son, and Holy
Ghost, now and forever, world without end. Amen."

In Natasha's receptive condition of soul this prayer affected her
strongly. She listened to every word about the victory of Moses over
Amalek, of Gideon over Midian, and of David over Goliath, and about
the destruction of "Thy Jerusalem," and she prayed to God with the
tenderness and emotion with which her heart was overflowing, but
without fully understanding what she was asking of God in that prayer.
She shared with all her heart in the prayer for the spirit of
righteousness, for the strengthening of the heart by faith and hope,
and its animation by love. But she could not pray that her enemies
might be trampled under foot when but a few minutes before she had
been wishing she had more of them that she might pray for them. But
neither could she doubt the righteousness of the prayer that was being
read on bended knees. She felt in her heart a devout and tremulous awe
at the thought of the punishment that overtakes men for their sins,
and especially of her own sins, and she prayed to God to forgive
them all, and her too, and to give them all, and her too, peace and
happiness. And it seemed to her that God heard her prayer.





CHAPTER XIX


From the day when Pierre, after leaving the Rostovs' with
Natasha's grateful look fresh in his mind, had gazed at the comet that
seemed to be fixed in the sky and felt that something new was
appearing on his own horizon--from that day the problem of the
vanity and uselessness of all earthly things, that had incessantly
tormented him, no longer presented itself. That terrible question
"Why?" "Wherefore?" which had come to him amid every occupation, was
now replaced, not by another question or by a reply to the former
question, but by her image. When he listened to, or himself took
part in, trivial conversations, when he read or heard of human
baseness or folly, he was not horrified as formerly, and did not ask
himself why men struggled so about these things when all is so
transient and incomprehensible--but he remembered her as he had last
seen her, and all his doubts vanished--not because she had answered
the questions that had haunted him, but because his conception of
her transferred him instantly to another, a brighter, realm of
spiritual activity in which no one could be justified or guilty--a
realm of beauty and love which it was worth living for. Whatever
worldly baseness presented itself to him, he said to himself:

"Well, supposing N. N. swindled the country and the Tsar, and the
country and the Tsar confer honors upon him, what does that matter?
She smiled at me yesterday and asked me to come again, and I love her,
and no one will ever know it." And his soul felt calm and peaceful.

Pierre still went into society, drank as much and led the same
idle and dissipated life, because besides the hours he spent at the
Rostovs' there were other hours he had to spend somehow, and the
habits and acquaintances he had made in Moscow formed a current that
bore him along irresistibly. But latterly, when more and more
disquieting reports came from the seat of war and Natasha's health
began to improve and she no longer aroused in him the former feeling
of careful pity, an ever-increasing restlessness, which he could not
explain, took possession of him. He felt that the condition he was
in could not continue long, that a catastrophe was coming which
would change his whole life, and he impatiently sought everywhere
for signs of that approaching catastrophe. One of his brother Masons
had revealed to Pierre the following prophecy concerning Napoleon,
drawn from the Revelation of St. John.

In chapter 13, verse 18, of the Apocalypse, it is said:


Here is wisdom. Let him that hath understanding count the number
of the beast: for it is the number of a man; and his number is Six
hundred threescore and six.

And in the fifth verse of the same chapter:


And there was given unto him a mouth speaking great things and
blasphemies; and power was given unto him to continue forty and two
months.


The French alphabet, written out with the same numerical values as
the Hebrew, in which the first nine letters denote units and the
others tens, will have the following significance:

      a   b   c   d   e   f   g   h   i   k
      1   2   3   4   5   6   7   8   9   10
       l    m    n    o    p    q    r    s
      20   30   40   50   60   70   80   90
             t    u    v    w    x    y
            100  110  120  130  140  150
                        z
                       160


Writing the words L'Empereur Napoleon in numbers, it appears that
the sum of them is 666, and that Napoleon therefore the beast foretold
in the Apocalypse. Moreover, by applying the same system to the
words quarante-deux,* which was the term allowed to the beast that
"spoke great things and blasphemies," the same number 666 was
obtained; from which it followed that the limit fixed for Napoleon's
power had come in the year 1812 when the French emperor was forty-two.
This prophecy pleased Pierre very much and he often asked himself what
would put an end to the power of the beast, that is, of Napoleon,
and tried by the same system of using letters as numbers and adding
them up, to find an answer to the question that engrossed him. He
wrote the words L'Empereur Alexandre, La nation russe and added up
their numbers, but the sums were either more or less than 666. Once
when making such calculations he wrote down his own name in French,
Comte Pierre Besouhoff, but the sum of the numbers did not come right.
Then he changed the spelling, substituting a z for the s and adding de
and the article le, still without obtaining the desired result. Then
it occurred to him: if the answer to the question were contained in
his name, his nationality would also be given in the answer. So he
wrote Le russe Besuhof and adding up the numbers got 671. This was
only five too much, and five was represented by e, the very letter
elided from the article le before the word Empereur. By omitting the
e, though incorrectly, Pierre got the answer he sought. L'russe
Besuhof made 666. This discovery excited him. How, or by what means,
he was connected with the great event foretold in the Apocalypse he
did not know, but he did not doubt that connection for a moment. His
love for Natasha, Antichrist, Napoleon, the invasion, the comet,
666, L'Empereur Napoleon, and L'russe Besuhof--all this had to
mature and culminate, to lift him out of that spellbound, petty sphere
of Moscow habits in which he felt himself held captive and lead him to
a great achievement and great happiness.


*Forty-two.



On the eve of the Sunday when the special prayer was read, Pierre
had promised the Rostovs to bring them, from Count Rostopchin whom
he knew well, both the appeal to the people and the news from the
army. In the morning, when he went to call at Rostopchin's he met
there a courier fresh from the army, an acquaintance of his own, who
often danced at Moscow balls.

"Do, please, for heaven's sake, relieve me of something!" said the
courier. "I have a sackful of letters to parents."

Among these letters was one from Nicholas Rostov to his father.
Pierre took that letter, and Rostopchin also gave him the Emperor's
appeal to Moscow, which had just been printed, the last army orders,
and his own most recent bulletin. Glancing through the army orders,
Pierre found in one of them, in the lists of killed, wounded, and
rewarded, the name of Nicholas Rostov, awarded a St. George's Cross of
the Fourth Class for courage shown in the Ostrovna affair, and in
the same order the name of Prince Andrew Bolkonski, appointed to the
command of a regiment of Chasseurs. Though he did not want to remind
the Rostovs of Bolkonski, Pierre could not refrain from making them
happy by the news of their son's having received a decoration, so he
sent that printed army order and Nicholas' letter to the Rostovs,
keeping the appeal, the bulletin, and the other orders to take with
him when he went to dinner.

His conversation with Count Rostopchin and the latter's tone of
anxious hurry, the meeting with the courier who talked casually of how
badly things were going in the army, the rumors of the discovery of
spies in Moscow and of a leaflet in circulation stating that
Napoleon promised to be in both the Russian capitals by the autumn,
and the talk of the Emperor's being expected to arrive next day--all
aroused with fresh force that feeling of agitation and expectation
in Pierre which he had been conscious of ever since the appearance
of the comet, and especially since the beginning of the war.

He had long been thinking of entering the army and would have done
so had he not been hindered, first, by his membership of the Society
of Freemasons to which he was bound by oath and which preached
perpetual peace and the abolition of war, and secondly, by the fact
that when he saw the great mass of Muscovites who had donned uniform
and were talking patriotism, he somehow felt ashamed to take the step.
But the chief reason for not carrying out his intention to enter the
army lay in the vague idea that he was L'russe Besuhof who had the
number of the beast, 666; that his part in the great affair of setting
a limit to the power of the beast that spoke great and blasphemous
things had been predestined from eternity, and that therefore he ought
not to undertake anything, but wait for what was bound to come to
pass.





CHAPTER XX


A few intimate friends were dining with the Rostovs that day, as
usual on Sundays.

Pierre came early so as to find them alone.

He had grown so stout this year that he would have been abnormal had
he not been so tall, so broad of limb, and so strong that he carried
his bulk with evident ease.

He went up the stairs, puffing and muttering something. His coachman
did not even ask whether he was to wait. He knew that when his
master was at the Rostovs' he stayed till midnight. The Rostovs'
footman rushed eagerly forward to help him off with his cloak and take
his hat and stick. Pierre, from club habit, always left both hat and
stick in the anteroom.

The first person he saw in the house was Natasha. Even before he saw
her, while taking off his cloak, he heard her. She was practicing
solfa exercises in the music room. He knew that she had not sung since
her illness, and so the sound of her voice surprised and delighted
him. He opened the door softly and saw her, in the lilac dress she had
worn at church, walking about the room singing. She had her back to
him when he opened the door, but when, turning quickly, she saw his
broad, surprised face, she blushed and came rapidly up to him.

"I want to try to sing again," she said, adding as if by way of
excuse, "it is, at least, something to do."

"That's capital!"

"How glad I am you've come! I am so happy today," she said, with the
old animation Pierre had not seen in her for along time. "You know
Nicholas has received a St. George's Cross? I am so proud of him."

"Oh yes, I sent that announcement. But I don't want to interrupt
you," he added, and was about to go to the drawing room.

Natasha stopped him.

"Count, is it wrong of me to sing?" she said blushing, and fixing
her eyes inquiringly on him.

"No... Why should it be? On the contrary... But why do you ask me?"

"I don't know myself," Natasha answered quickly, "but I should not
like to do anything you disapproved of. I believe in you completely.
You don't know how important you are to me, how much you've done for
me...." She spoke rapidly and did not notice how Pierre flushed at her
words. "I saw in that same army order that he, Bolkonski" (she
whispered the name hastily), "is in Russia, and in the army again.
What do you think?"--she was speaking hurriedly, evidently afraid
her strength might fail her--"Will he ever forgive me? Will he not
always have a bitter feeling toward me? What do you think? What do you
think?"

"I think..." Pierre replied, "that he has nothing to forgive....
If I were in his place..."

By association of ideas, Pierre was at once carried back to the
day when, trying to comfort her, he had said that if he were not
himself but the best man in the world and free, he would ask on his
knees for her hand; and the same feeling of pity, tenderness, and love
took possession of him and the same words rose to his lips. But she
did not give him time to say them.

"Yes, you... you..." she said, uttering the word you rapturously-
"that's a different thing. I know no one kinder, more generous, or
better than you; nobody could be! Had you not been there then, and now
too, I don't know what would have become of me, because..."

Tears suddenly rose in her eyes, she turned away, lifted her music
before her eyes, began singing again, and again began walking up and
down the room.

Just then Petya came running in from the drawing room.

Petya was now a handsome rosy lad of fifteen with full red lips
and resembled Natasha. He was preparing to enter the university, but
he and his friend Obolenski had lately, in secret, agreed to join
the hussars.

Petya had come rushing out to talk to his namesake about this
affair. He had asked Pierre to find out whether he would be accepted
in the hussars.

Pierre walked up and down the drawing room, not listening to what
Petya was saying.

Petya pulled him by the arm to attract his attention.

"Well, what about my plan? Peter Kirilych, for heaven's sake! You
are my only hope," said Petya.

"Oh yes, your plan. To join the hussars? I'll mention it, I'll bring
it all up today."

"Well, mon cher, have you got the manifesto?" asked the old count.
"The countess has been to Mass at the Razumovskis' and heard the new
prayer. She says it's very fine."

"Yes, I've got it," said Pierre. "The Emperor is to be here
tomorrow... there's to be an Extraordinary Meeting of the nobility,
and they are talking of a levy of ten men per thousand. Oh yes, let me
congratulate you!"

"Yes, yes, thank God! Well, and what news from the army?"

"We are again retreating. They say we're already near Smolensk,"
replied Pierre.

"O Lord, O Lord!" exclaimed the count. "Where is the manifesto?"

"The Emperor's appeal? Oh yes!"

Pierre began feeling in his pockets for the papers, but could not
find them. Still slapping his pockets, he kissed the hand of the
countess who entered the room and glanced uneasily around, evidently
expecting Natasha, who had left off singing but had not yet come
into the drawing room.

"On my word, I don't know what I've done with it," he said.

"There he is, always losing everything!" remarked the countess.

Natasha entered with a softened and agitated expression of face
and sat down looking silently at Pierre. As soon as she entered,
Pierre's features, which had been gloomy, suddenly lighted up, and
while still searching for the papers he glanced at her several times.

"No, really! I'll drive home, I must have left them there. I'll
certainly..."

"But you'll be late for dinner."

"Oh! And my coachman has gone."

But Sonya, who had gone to look for the papers in the anteroom,
had found them in Pierre's hat, where he had carefully tucked them
under the lining. Pierre was about to begin reading.

"No, after dinner," said the old count, evidently expecting much
enjoyment from that reading.

At dinner, at which champagne was drunk to the health of the new
chevalier of St. George, Shinshin told them the town news, of the
illness of the old Georgian princess, of Metivier's disappearance from
Moscow, and of how some German fellow had been brought to Rostopchin
and accused of being a French "spyer" (so Count Rostopchin had told
the story), and how Rostopchin let him go and assured the people
that he was "not a spire at all, but only an old German ruin."

"People are being arrested..." said the count. "I've told the
countess she should not speak French so much. It's not the time for it
now."

"And have you heard?" Shinshin asked. "Prince Golitsyn has engaged a
master to teach him Russian. It is becoming dangerous to speak
French in the streets."

"And how about you, Count Peter Kirilych? If they call up the
militia, you too will have to mount a horse," remarked the old
count, addressing Pierre.

Pierre had been silent and preoccupied all through dinner, seeming
not to grasp what was said. He looked at the count.

"Oh yes, the war," he said. "No! What sort of warrior should I make?
And yet everything is so strange, so strange! I can't make it out. I
don't know, I am very far from having military tastes, but in these
times no one can answer for himself."

After dinner the count settled himself comfortably in an easy
chair and with a serious face asked Sonya, who was considered an
excellent reader, to read the appeal.


"To Moscow, our ancient Capital!

"The enemy has entered the borders of Russia with immense forces. He
comes to despoil our beloved country,"


Sonya read painstakingly in her high-pitched voice. The count
listened with closed eyes, heaving abrupt sighs at certain passages.

Natasha sat erect, gazing with a searching look now at her father
and now at Pierre.

Pierre felt her eyes on him and tried not to look round. The
countess shook her head disapprovingly and angrily at every solemn
expression in the manifesto. In all these words she saw only that
the danger threatening her son would not soon be over. Shinshin,
with a sarcastic smile on his lips, was evidently preparing to make
fun of anything that gave him the opportunity: Sonya's reading, any
remark of the count's, or even the manifesto itself should no better
pretext present itself.

After reading about the dangers that threatened Russia, the hopes
the Emperor placed on Moscow and especially on its illustrious
nobility, Sonya, with a quiver in her voice due chiefly to the
attention that was being paid to her, read the last words:


"We ourselves will not delay to appear among our people in that
Capital and in others parts of our realm for consultation, and for the
direction of all our levies, both those now barring the enemy's path
and those freshly formed to defeat him wherever he may appear. May the
ruin he hopes to bring upon us recoil on his own head, and may
Europe delivered from bondage glorify the name of Russia!"


"Yes, that's it!" cried the count, opening his moist eyes and
sniffing repeatedly, as if a strong vinaigrette had been held to his
nose; and he added, "Let the Emperor but say the word and we'll
sacrifice everything and begrudge nothing."

Before Shinshin had time to utter the joke he was ready to make on
the count's patriotism, Natasha jumped up from her place and ran to
her father.

"What a darling our Papa is!" she cried, kissing him, and she
again looked at Pierre with the unconscious coquetry that had returned
to her with her better spirits.

"There! Here's a patriot for you!" said Shinshin.

"Not a patriot at all, but simply..." Natasha replied in an
injured tone. "Everything seems funny to you, but this isn't at all
a joke...."

"A joke indeed!" put in the count. "Let him but say the word and
we'll all go.... We're not Germans!"

"But did you notice, it says, 'for consultation'?" said Pierre.

"Never mind what it's for...."

At this moment, Petya, to whom nobody was paying any attention, came
up to his father with a very flushed face and said in his breaking
voice that was now deep and now shrill:

"Well, Papa, I tell you definitely, and Mamma too, it's as you
please, but I say definitely that you must let me enter the army,
because I can't... that's all...."

The countess, in dismay, looked up to heaven, clasped her hands, and
turned angrily to her husband.

"That comes of your talking!" said she.

But the count had already recovered from his excitement.

"Come, come!" said he. "Here's a fine warrior! No! Nonsense! You
must study."

"It's not nonsense, Papa. Fedya Obolenski is younger than I, and
he's going too. Besides, all the same I can't study now when..." Petya
stopped short, flushed till he perspired, but still got out the words,
"when our Fatherland is in danger."

"That'll do, that'll do--nonsense...."

"But you said yourself that we would sacrifice everything."

"Petya! Be quiet, I tell you!" cried the count, with a glance at his
wife, who had turned pale and was staring fixedly at her son.

"And I tell you--Peter Kirilych here will also tell you..."

"Nonsense, I tell you. Your mother's milk has hardly dried on your
lips and you want to go into the army! There, there, I tell you,"
and the count moved to go out of the room, taking the papers, probably
to reread them in his study before having a nap.

"Well, Peter Kirilych, let's go and have a smoke," he said.

Pierre was agitated and undecided. Natasha's unwontedly brilliant
eyes, continually glancing at him with a more than cordial look, had
reduced him to this condition.

"No, I think I'll go home."

"Home? Why, you meant to spend the evening with us.... You don't
often come nowadays as it is, and this girl of mine," said the count
good-naturedly, pointing to Natasha, "only brightens up when you're
here."

"Yes, I had forgotten... I really must go home... business..."
said Pierre hurriedly.

"Well, then, au revoir!" said the count, and went out of the room.

"Why are you going? Why are you upset?" asked Natasha, and she
looked challengingly into Pierre's eyes.

"Because I love you!" was what he wanted to say, but he did not
say it, and only blushed till the tears came, and lowered his eyes.

"Because it is better for me to come less often... because... No,
simply I have business...."

"Why? No, tell me!" Natasha began resolutely and suddenly stopped.

They looked at each other with dismayed and embarrassed faces. He
tried to smile but could not: his smile expressed suffering, and he
silently kissed her hand and went out.

Pierre made up his mind not to go to the Rostovs' any more.





CHAPTER XXI


After the definite refusal he had received, Petya went to his room
and there locked himself in and wept bitterly. When he came in to tea,
silent, morose, and with tear-stained face, everybody pretended not to
notice anything.

Next day the Emperor arrived in Moscow, and several of the
Rostovs' domestic serfs begged permission to go to have a look at him.
That morning Petya was a long time dressing and arranging his hair and
collar to look like a grown-up man. He frowned before his looking
glass, gesticulated, shrugged his shoulders, and finally, without
saying a word to anyone, took his cap and left the house by the back
door, trying to avoid notice. Petya decided to go straight to where
the Emperor was and to explain frankly to some gentleman-in-waiting
(he imagined the Emperor to be always surrounded by
gentlemen-in-waiting) that he, Count Rostov, in spite of his youth
wished to serve his country; that youth could be no hindrance to
loyalty, and that he was ready to... While dressing, Petya had
prepared many fine things he meant to say to the gentleman-in-waiting.

It was on the very fact of being so young that Petya counted for
success in reaching the Emperor--he even thought how surprised
everyone would be at his youthfulness--and yet in the arrangement of
his collar and hair and by his sedate deliberate walk he wished to
appear a grown-up man. But the farther he went and the more his
attention was diverted by the ever-increasing crowds moving toward the
Kremlin, the less he remembered to walk with the sedateness and
deliberation of a man. As he approached the Kremlin he even began to
avoid being crushed and resolutely stuck out his elbows in a
menacing way. But within the Trinity Gateway he was so pressed to
the wall by people who probably were unaware of the patriotic
intentions with which he had come that in spite of all his
determination he had to give in, and stop while carriages passed in,
rumbling beneath the archway. Beside Petya stood a peasant woman, a
footman, two tradesmen, and a discharged soldier. After standing
some time in the gateway, Petya tried to move forward in front of
the others without waiting for all the carriages to pass, and he began
resolutely working his way with his elbows, but the woman just in
front of him, who was the first against whom he directed his
efforts, angrily shouted at him:

"What are you shoving for, young lordling? Don't you see we're all
standing still? Then why push?"

"Anybody can shove," said the footman, and also began working his
elbows to such effect that he pushed Petya into a very filthy corner
of the gateway.

Petya wiped his perspiring face with his hands and pulled up the
damp collar which he had arranged so well at home to seem like a
man's.

He felt that he no longer looked presentable, and feared that if
he were now to approach the gentlemen-in-waiting in that plight he
would not be admitted to the Emperor. But it was impossible to smarten
oneself up or move to another place, because of the crowd. One of
the generals who drove past was an acquaintance of the Rostovs', and
Petya thought of asking his help, but came to the conclusion that that
would not be a manly thing to do. When the carriages had all passed
in, the crowd, carrying Petya with it, streamed forward into the
Kremlin Square which was already full of people. There were people not
only in the square, but everywhere--on the slopes and on the roofs. As
soon as Petya found himself in the square he clearly heard the sound
of bells and the joyous voices of the crowd that filled the whole
Kremlin.

For a while the crowd was less dense, but suddenly all heads were
bared, and everyone rushed forward in one direction. Petya was being
pressed so that he could scarcely breathe, and everybody shouted,
"Hurrah! hurrah! hurrah!" Petya stood on tiptoe and pushed and
pinched, but could see nothing except the people about him.

All the faces bore the same expression of excitement and enthusiasm.
A tradesman's wife standing beside Petya sobbed, and the tears ran
down her cheeks.

"Father! Angel! Dear one!" she kept repeating, wiping away her tears
with her fingers.

"Hurrah!" was heard on all sides.

For a moment the crowd stood still, but then it made another rush
forward.

Quite beside himself, Petya, clinching his teeth and rolling his
eyes ferociously, pushed forward, elbowing his way and shouting
"hurrah!" as if he were prepared that instant to kill himself and
everyone else, but on both sides of him other people with similarly
ferocious faces pushed forward and everybody shouted "hurrah!"

"So this is what the Emperor is!" thought Petya. "No, I can't
petition him myself--that would be too bold." But in spite of this
he continued to struggle desperately forward, and from between the
backs of those in front he caught glimpses of an open space with a
strip of red cloth spread out on it; but just then the crowd swayed
back--the police in front were pushing back those who had pressed
too close to the procession: the Emperor was passing from the palace
to the Cathedral of the Assumption--and Petya unexpectedly received
such a blow on his side and ribs and was squeezed so hard that
suddenly everything grew dim before his eyes and he lost
consciousness. When he came to himself, a man of clerical appearance
with a tuft of gray hair at the back of his head and wearing a
shabby blue cassock--probably a church clerk and chanter--was
holding him under the arm with one hand while warding off the pressure
of the crowd with the other.

"You've crushed the young gentleman!" said the clerk. "What are
you up to? Gently!... They've crushed him, crushed him!"

The Emperor entered the Cathedral of the Assumption. The crowd
spread out again more evenly, and the clerk led Petya--pale and
breathless--to the Tsar-cannon. Several people were sorry for Petya,
and suddenly a crowd turned toward him and pressed round him. Those
who stood nearest him attended to him, unbuttoned his coat, seated him
on the raised platform of the cannon, and reproached those others
(whoever they might be) who had crushed him.

"One might easily get killed that way! What do they mean by it?
Killing people! Poor dear, he's as white as a sheet!"--various
voices were heard saying.

Petya soon came to himself, the color returned to his face, the pain
had passed, and at the cost of that temporary unpleasantness he had
obtained a place by the cannon from where he hoped to see the
Emperor who would be returning that way. Petya no longer thought of
presenting his petition. If he could only see the Emperor he would
be happy!

While the service was proceeding in the Cathedral of the Assumption-
it was a combined service of prayer on the occasion of the Emperor's
arrival and of thanksgiving for the conclusion of peace with the
Turks--the crowd outside spread out and hawkers appeared, selling
kvas, gingerbread, and poppyseed sweets (of which Petya was
particularly fond), and ordinary conversation could again be heard.
A tradesman's wife was showing a rent in her shawl and telling how
much the shawl had cost; another was saying that all silk goods had
now got dear. The clerk who had rescued Petya was talking to a
functionary about the priests who were officiating that day with the
bishop. The clerk several times used the word "plenary" (of the
service), a word Petya did not understand. Two young citizens were
joking with some serf girls who were cracking nuts. All these
conversations, especially the joking with the girls, were such as
might have had a particular charm for Petya at his age, but they did
not interest him now. He sat on his elevation--the pedestal of the
cannon--still agitated as before by the thought of the Emperor and
by his love for him. The feeling of pain and fear he had experienced
when he was being crushed, together with that of rapture, still
further intensified his sense of the importance of the occasion.

Suddenly the sound of a firing of cannon was heard from the
embankment, to celebrate the signing of peace with the Turks, and
the crowd rushed impetuously toward the embankment to watch the
firing. Petya too would have run there, but the clerk who had taken
the young gentleman under his protection stopped him. The firing was
still proceeding when officers, generals, and gentlemen-in-waiting
came running out of the cathedral, and after them others in a more
leisurely manner: caps were again raised, and those who had run to
look at the cannon ran back again. At last four men in uniforms and
sashes emerged from the cathedral doors. "Hurrah! hurrah!" shouted the
crowd again.

"Which is he? Which?" asked Petya in a tearful voice, of those
around him, but no one answered him, everybody was too excited; and
Petya, fixing on one of those four men, whom he could not clearly
see for the tears of joy that filled his eyes, concentrated all his
enthusiasm on him--though it happened not to be the Emperor-
frantically shouted "Hurrah!" and resolved that tomorrow, come what
might, he would join the army.

The crowd ran after the Emperor, followed him to the palace, and
began to disperse. It was already late, and Petya had not eaten
anything and was drenched with perspiration, yet he did not go home
but stood with that diminishing, but still considerable, crowd
before the palace while the Emperor dined--looking in at the palace
windows, expecting he knew not what, and envying alike the notables he
saw arriving at the entrance to dine with the Emperor and the court
footmen who served at table, glimpses of whom could be seen through
the windows.

While the Emperor was dining, Valuev, looking out of the window,
said:

"The people are still hoping to see Your Majesty again."

The dinner was nearly over, and the Emperor, munching a biscuit,
rose and went out onto the balcony. The people, with Petya among them,
rushed toward the balcony.

"Angel! Dear one! Hurrah! Father!..." cried the crowd, and Petya
with it, and again the women and men of weaker mold, Petya among them,
wept with joy.

A largish piece of the biscuit the Emperor was holding in his hand
broke off, fell on the balcony parapet, and then to the ground. A
coachman in a jerkin, who stood nearest, sprang forward and snatched
it up. Several people in the crowd rushed at the coachman. Seeing this
the Emperor had a plateful of biscuits brought him and began
throwing them down from the balcony. Petya's eyes grew bloodshot,
and still more excited by the danger of being crushed, he rushed at
the biscuits. He did not know why, but he had to have a biscuit from
the Tsar's hand and he felt that he must not give way. He sprang
forward and upset an old woman who was catching at a biscuit; the
old woman did not consider herself defeated though she was lying on
the ground--she grabbed at some biscuits but her hand did not reach
them. Petya pushed her hand away with his knee, seized a biscuit,
and as if fearing to be too late, again shouted "Hurrah!" with a voice
already hoarse.

The Emperor went in, and after that the greater part of the crowd
began to disperse.

"There! I said if only we waited--and so it was!" was being joyfully
said by various people.

Happy as Petya was, he felt sad at having to go home knowing that
all the enjoyment of that day was over. He did not go straight home
from the Kremlin, but called on his friend Obolenski, who was
fifteen and was also entering the regiment. On returning home Petya
announced resolutely and firmly that if he was not allowed to enter
the service he would run away. And next day, Count Ilya Rostov--though
he had not yet quite yielded--went to inquire how he could arrange for
Petya to serve where there would be least danger.





CHAPTER XXII


Two days later, on the fifteenth of July, an immense number of
carriages were standing outside the Sloboda Palace.

The great halls were full. In the first were the nobility and gentry
in their uniforms, in the second bearded merchants in full-skirted
coats of blue cloth and wearing medals. In the noblemen's hall there
was an incessant movement and buzz of voices. The chief magnates sat
on high-backed chairs at a large table under the portrait of the
Emperor, but most of the gentry were strolling about the room.

All these nobles, whom Pierre met every day at the Club or in
their own houses, were in uniform--some in that of Catherine's day,
others in that of Emperor Paul, others again in the new uniforms of
Alexander's time or the ordinary uniform of the nobility, and the
general characteristic of being in uniform imparted something
strange and fantastic to these diverse and familiar personalities,
both old and young. The old men, dim-eyed, toothless, bald, sallow,
and bloated, or gaunt and wrinkled, were especially striking. For
the most part they sat quietly in their places and were silent, or, if
they walked about and talked, attached themselves to someone
younger. On all these faces, as on the faces of the crowd Petya had
seen in the Square, there was a striking contradiction: the general
expectation of a solemn event, and at the same time the everyday
interests in a boston card party, Peter the cook, Zinaida Dmitrievna's
health, and so on.

Pierre was there too, buttoned up since early morning in a
nobleman's uniform that had become too tight for him. He was agitated;
this extraordinary gathering not only of nobles but also of the
merchant-class--les etats generaux (States-General)--evoked in him a
whole series of ideas he had long laid aside but which were deeply
graven in his soul: thoughts of the Contrat social and the French
Revolution. The words that had struck him in the Emperor's appeal-
that the sovereign was coming to the capital for consultation with his
people--strengthened this idea. And imagining that in this direction
something important which he had long awaited was drawing near, he
strolled about watching and listening to conversations, but nowhere
finding any confirmation of the ideas that occupied him.

The Emperor's manifesto was read, evoking enthusiasm, and then all
moved about discussing it. Besides the ordinary topics of
conversation, Pierre heard questions of where the marshals of the
nobility were to stand when the Emperor entered, when a ball should be
given in the Emperor's honor, whether they should group themselves
by districts or by whole provinces... and so on; but as soon as the
war was touched on, or what the nobility had been convened for, the
talk became undecided and indefinite. Then all preferred listening
to speaking.

A middle-aged man, handsome and virile, in the uniform of a
retired naval officer, was speaking in one of the rooms, and a small
crowd was pressing round him. Pierre went up to the circle that had
formed round the speaker and listened. Count Ilya Rostov, in a
military uniform of Catherine's time, was sauntering with a pleasant
smile among the crowd, with all of whom he was acquainted. He too
approached that group and listened with a kindly smile and nods of
approval, as he always did, to what the speaker was saying. The
retired naval man was speaking very boldly, as was evident from the
expression on the faces of the listeners and from the fact that some
people Pierre knew as the meekest and quietest of men walked away
disapprovingly or expressed disagreement with him. Pierre pushed his
way into the middle of the group, listened, and convinced himself that
the man was indeed a liberal, but of views quite different from his
own. The naval officer spoke in a particularly sonorous, musical,
and aristocratic baritone voice, pleasantly swallowing his r's and
generally slurring his consonants: the voice of a man calling out to
his servant, "Heah! Bwing me my pipe!" It was indicative of
dissipation and the exercise of authority.

"What if the Smolensk people have offahd to waise militia for the
Empewah? Ah we to take Smolensk as our patte'n? If the noble
awistocwacy of the pwovince of Moscow thinks fit, it can show its
loyalty to our sov'weign the Empewah in other ways. Have we
fo'gotten the waising of the militia in the yeah 'seven? All that
did was to enwich the pwiests' sons and thieves and wobbahs...."

Count Ilya Rostov smiled blandly and nodded approval.

"And was our militia of any use to the Empia? Not at all! It only
wuined our farming! Bettah have another conscwiption... o' ou' men
will wetu'n neithah soldiers no' peasants, and we'll get only
depwavity fwom them. The nobility don't gwudge theah lives--evewy
one of us will go and bwing in more wecwuits, and the sov'weign" (that
was the way he referred to the Emperor) "need only say the word and
we'll all die fo' him!" added the orator with animation.

Count Rostov's mouth watered with pleasure and he nudged Pierre, but
Pierre wanted to speak himself. He pushed forward, feeling stirred,
but not yet sure what stirred him or what he would say. Scarcely had
he opened his mouth when one of the senators, a man without a tooth in
his head, with a shrewd though angry expression, standing near the
first speaker, interrupted him. Evidently accustomed to managing
debates and to maintaining an argument, he began in low but distinct
tones:

"I imagine, sir," said he, mumbling with his toothless mouth,
"that we have been summoned here not to discuss whether it's best
for the empire at the present moment to adopt conscription or to
call out the militia. We have been summoned to reply to the appeal
with which our sovereign the Emperor has honored us. But to judge what
is best--conscription or the militia--we can leave to the supreme
authority...."

Pierre suddenly saw an outlet for his excitement. He hardened his
heart against the senator who was introducing this set and narrow
attitude into the deliberations of the nobility. Pierre stepped
forward and interrupted him. He himself did not yet know what he would
say, but he began to speak eagerly, occasionally lapsing into French
or expressing himself in bookish Russian.

"Excuse me, your excellency," he began. (He was well acquainted with
the senator, but thought it necessary on this occasion to address
him formally.) "Though I don't agree with the gentleman..." (he
hesitated: he wished to say, "Mon tres honorable preopinant"--"My very
honorable opponent") "with the gentleman... whom I have not the
honor of knowing, I suppose that the nobility have been summoned not
merely to express their sympathy and enthusiasm but also to consider
the means by which we can assist our Fatherland! I imagine," he went
on, warming to his subject, "that the Emperor himself would not be
satisfied to find in us merely owners of serfs whom we are willing
to devote to his service, and chair a canon* we are ready to make of
ourselves--and not to obtain from us any co-co-counsel."


*"Food for cannon."


Many persons withdrew from the circle, noticing the senator's
sarcastic smile and the freedom of Pierre's remarks. Only Count Rostov
was pleased with them as he had been pleased with those of the naval
officer, the senator, and in general with whatever speech he had
last heard.

"I think that before discussing these questions," Pierre
continued, "we should ask the Emperor--most respectfully ask His
Majesty--to let us know the number of our troops and the position in
which our army and our forces now are, and then..."

But scarcely had Pierre uttered these words before he was attacked
from three sides. The most vigorous attack came from an old
acquaintance, a boston player who had always been well disposed toward
him, Stepan Stepanovich Adraksin. Adraksin was in uniform, and whether
as a result of the uniform or from some other cause Pierre saw
before him quite a different man. With a sudden expression of
malevolence on his aged face, Adraksin shouted at Pierre:

"In the first place, I tell you we have no right to question the
Emperor about that, and secondly, if the Russian nobility had that
right, the Emperor could not answer such a question. The troops are
moved according to the enemy's movements and the number of men
increases and decreases..."

Another voice, that of a nobleman of medium height and about forty
years of age, whom Pierre had formerly met at the gypsies' and knew as
a bad cardplayer, and who, also transformed by his uniform, came up to
Pierre, interrupted Adraksin.

"Yes, and this is not a time for discussing," he continued, "but for
acting: there is war in Russia! The enemy is advancing to destroy
Russia, to desecrate the tombs of our fathers, to carry off our
wives and children." The nobleman smote his breast. "We will all
arise, every one of us will go, for our father the Tsar!" he
shouted, rolling his bloodshot eyes. Several approving voices were
heard in the crowd. "We are Russians and will not grudge our blood
in defense of our faith, the throne, and the Fatherland! We must cease
raving if we are sons of our Fatherland! We will show Europe how
Russia rises to the defense of Russia!"

Pierre wished to reply, but could not get in a word. He felt that
his words, apart from what meaning they conveyed, were less audible
than the sound of his opponent's voice.

Count Rostov at the back of the crowd was expressing approval;
several persons, briskly turning a shoulder to the orator at the end
of a phrase, said:

"That's right, quite right! Just so!"

Pierre wished to say that he was ready to sacrifice his money, his
serfs, or himself, only one ought to know the state of affairs in
order to be able to improve it, but he was unable to speak. Many
voices shouted and talked at the same time, so that Count Rostov had
not time to signify his approval of them all, and the group increased,
dispersed, re-formed, and then moved with a hum of talk into the
largest hall and to the big table. Not only was Pierre's attempt to
speak unsuccessful, but he was rudely interrupted, pushed aside, and
people turned away from him as from a common enemy. This happened
not because they were displeased by the substance of his speech, which
had even been forgotten after the many subsequent speeches, but to
animate it the crowd needed a tangible object to love and a tangible
object to hate. Pierre became the latter. Many other orators spoke
after the excited nobleman, and all in the same tone. Many spoke
eloquently and with originality.

Glinka, the editor of the Russian Messenger, who was recognized
(cries of "author! author!" were heard in the crowd), said that
"hell must be repulsed by hell," and that he had seen a child
smiling at lightning flashes and thunderclaps, but "we will not be
that child."

"Yes, yes, at thunderclaps!" was repeated approvingly in the back
rows of the crowd.

The crowd drew up to the large table, at which sat gray-haired or
bald seventy-year-old magnates, uniformed and besashed almost all of
whom Pierre had seen in their own homes with their buffoons, or
playing boston at the clubs. With an incessant hum of voices the crowd
advanced to the table. Pressed by the throng against the high backs of
the chairs, the orators spoke one after another and sometimes two
together. Those standing behind noticed what a speaker omitted to
say and hastened to supply it. Others in that heat and crush racked
their brains to find some thought and hastened to utter it. The old
magnates, whom Pierre knew, sat and turned to look first at one and
then at another, and their faces for the most part only expressed
the fact that they found it very hot. Pierre, however, felt excited,
and the general desire to show that they were ready to go to all
lengths--which found expression in the tones and looks more than in
the substance of the speeches--infected him too. He did not renounce
his opinions, but felt himself in some way to blame and wished to
justify himself.

"I only said that it would be more to the purpose to make sacrifices
when we know what is needed!" said he, trying to be heard above the
other voices.

One of the old men nearest to him looked round, but his attention
was immediately diverted by an exclamation at the other side of the
table.

"Yes, Moscow will be surrendered! She will be our expiation!"
shouted one man.

"He is the enemy of mankind!" cried another. "Allow me to speak...."
"Gentlemen, you are crushing me!..."





CHAPTER XXIII


At that moment Count Rostopchin with his protruding chin and alert
eyes, wearing the uniform of a general with sash over his shoulder,
entered the room, stepping briskly to the front of the crowd of
gentry.

"Our sovereign the Emperor will be here in a moment," said
Rostopchin. "I am straight from the palace. Seeing the position we are
in, I think there is little need for discussion. The Emperor has
deigned to summon us and the merchants. Millions will pour forth
from there"--he pointed to the merchants' hall--"but our business is
to supply men and not spare ourselves... That is the least we can do!"

A conference took place confined to the magnates sitting at the
table. The whole consultation passed more than quietly. After all
the preceding noise the sound of their old voices saying one after
another, "I agree," or for variety, "I too am of that opinion," and so
on had even a mournful effect.

The secretary was told to write down the resolution of the Moscow
nobility and gentry, that they would furnish ten men, fully
equipped, out of every thousand serfs, as the Smolensk gentry had
done. Their chairs made a scraping noise as the gentlemen who had
conferred rose with apparent relief, and began walking up and down,
arm in arm, to stretch their legs and converse in couples.

"The Emperor! The Emperor!" a sudden cry resounded through the halls
and the whole throng hurried to the entrance.

The Emperor entered the hall through a broad path between two
lines of nobles. Every face expressed respectful, awe-struck
curiosity. Pierre stood rather far off and could not hear all that the
Emperor said. From what he did hear he understood that the Emperor
spoke of the danger threatening the empire and of the hopes he
placed on the Moscow nobility. He was answered by a voice which
informed him of the resolution just arrived at.

"Gentlemen!" said the Emperor with a quivering voice.

There was a rustling among the crowd and it again subsided, so
that Pierre distinctly heard the pleasantly human voice of the Emperor
saying with emotion:

"I never doubted the devotion of the Russian nobles, but today it
has surpassed my expectations. I thank you in the name of the
Fatherland! Gentlemen, let us act! Time is most precious..."

The Emperor ceased speaking, the crowd began pressing round him, and
rapturous exclamations were heard from all sides.

"Yes, most precious... a royal word," said Count Rostov, with a sob.
He stood at the back, and, though he had heard hardly anything,
understood everything in his own way.

From the hall of the nobility the Emperor went to that of the
merchants. There he remained about ten minutes. Pierre was among those
who saw him come out from the merchants' hall with tears of emotion in
his eyes. As became known later, he had scarcely begun to address
the merchants before tears gushed from his eyes and he concluded in
a trembling voice. When Pierre saw the Emperor he was coming out
accompanied by two merchants, one of whom Pierre knew, a fat
otkupshchik. The other was the mayor, a man with a thin sallow face
and narrow beard. Both were weeping. Tears filled the thin man's eyes,
and the fat otkupshchik sobbed outright like a child and kept
repeating:

"Our lives and property--take them, Your Majesty!"

Pierre's one feeling at the moment was a desire to show that he
was ready to go all lengths and was prepared to sacrifice
everything. He now felt ashamed of his speech with its
constitutional tendency and sought an opportunity of effacing it.
Having heard that Count Mamonov was furnishing a regiment, Bezukhov at
once informed Rostopchin that he would give a thousand men and their
maintenance.

Old Rostov could not tell his wife of what had passed without tears,
and at once consented to Petya's request and went himself to enter his
name.

Next day the Emperor left Moscow. The assembled nobles all took
off their uniforms and settled down again in their homes and clubs,
and not without some groans gave orders to their stewards about the
enrollment, feeling amazed themselves at what they had done.





BOOK TEN: 1812





CHAPTER I


Napoleon began the war with Russia because he could not resist going
to Dresden, could not help having his head turned by the homage he
received, could not help donning a Polish uniform and yielding to
the stimulating influence of a June morning, and could not refrain
from bursts of anger in the presence of Kurakin and then of Balashev.

Alexander refused negotiations because he felt himself to be
personally insulted. Barclay de Tolly tried to command the army in the
best way, because he wished to fulfill his duty and earn fame as a
great commander. Rostov charged the French because he could not
restrain his wish for a gallop across a level field; and in the same
way the innumerable people who took part in the war acted in accord
with their personal characteristics, habits, circumstances, and
aims. They were moved by fear or vanity, rejoiced or were indignant,
reasoned, imagining that they knew what they were doing and did it
of their own free will, but they all were involuntary tools of
history, carrying on a work concealed from them but comprehensible
to us. Such is the inevitable fate of men of action, and the higher
they stand in the social hierarchy the less are they free.

The actors of 1812 have long since left the stage, their personal
interests have vanished leaving no trace, and nothing remains of
that time but its historic results.

Providence compelled all these men, striving to attain personal
aims, to further the accomplishment of a stupendous result no one of
them at all expected--neither Napoleon, nor Alexander, nor still
less any of those who did the actual fighting.

The cause of the destruction of the French army in 1812 is clear
to us now. No one will deny that that cause was, on the one hand,
its advance into the heart of Russia late in the season without any
preparation for a winter campaign and, on the other, the character
given to the war by the burning of Russian towns and the hatred of the
foe this aroused among the Russian people. But no one at the time
foresaw (what now seems so evident) that this was the only way an army
of eight hundred thousand men--the best in the world and led by the
best general--could be destroyed in conflict with a raw army of half
its numerical strength, and led by inexperienced commanders as the
Russian army was. Not only did no one see this, but on the Russian
side every effort was made to hinder the only thing that could save
Russia, while on the French side, despite Napoleon's experience and
so-called military genius, every effort was directed to pushing on
to Moscow at the end of the summer, that is, to doing the very thing
that was bound to lead to destruction.

In historical works on the year 1812 French writers are very fond of
saying that Napoleon felt the danger of extending his line, that he
sought a battle and that his marshals advised him to stop at Smolensk,
and of making similar statements to show that the danger of the
campaign was even then understood. Russian authors are still fonder of
telling us that from the commencement of the campaign a Scythian war
plan was adopted to lure Napoleon into the depths of Russia, and
this plan some of them attribute to Pfuel, others to a certain
Frenchman, others to Toll, and others again to Alexander himself-
pointing to notes, projects, and letters which contain hints of such a

line of action. But all these hints at what happened, both from the
French side and the Russian, are advanced only because they fit in
with the event. Had that event not occurred these hints would have
been forgotten, as we have forgotten the thousands and millions of
hints and expectations to the contrary which were current then but
have now been forgotten because the event falsified them. There are
always so many conjectures as to the issue of any event that however
it may end there will always be people to say: "I said then that it
would be so," quite forgetting that amid their innumerable conjectures
many were to quite the contrary effect.

Conjectures as to Napoleon's awareness of the danger of extending
his line, and (on the Russian side) as to luring the enemy into the
depths of Russia, are evidently of that kind, and only by much
straining can historians attribute such conceptions to Napoleon and
his marshals, or such plans to the Russian commanders. All the facts
are in flat contradiction to such conjectures. During the whole period
of the war not only was there no wish on the Russian side to draw
the French into the heart of the country, but from their first entry
into Russia everything was done to stop them. And not only was
Napoleon not afraid to extend his line, but he welcomed every step
forward as a triumph and did not seek battle as eagerly as in former
campaigns, but very lazily.

At the very beginning of the war our armies were divided, and our
sole aim was to unite them, though uniting the armies was no advantage
if we meant to retire and lure the enemy into the depths of the
country. Our Emperor joined the army to encourage it to defend every
inch of Russian soil and not to retreat. The enormous Drissa camp
was formed on Pfuel's plan, and there was no intention of retiring
farther. The Emperor reproached the commanders in chief for every step
they retired. He could not bear the idea of letting the enemy even
reach Smolensk, still less could he contemplate the burning of Moscow,
and when our armies did unite he was displeased that Smolensk was
abandoned and burned without a general engagement having been fought
under its walls.

So thought the Emperor, and the Russian commanders and people were
still more provoked at the thought that our forces were retreating
into the depths of the country.

Napoleon having cut our armies apart advanced far into the country
and missed several chances of forcing an engagement. In August he
was at Smolensk and thought only of how to advance farther, though
as we now see that advance was evidently ruinous to him.

The facts clearly show that Napoleon did not foresee the danger of
the advance on Moscow, nor did Alexander and the Russian commanders
then think of luring Napoleon on, but quite the contrary. The luring
of Napoleon into the depths of the country was not the result of any
plan, for no one believed it to be possible; it resulted from a most
complex interplay of intrigues, aims, and wishes among those who
took part in the war and had no perception whatever of the inevitable,
or of the one way of saving Russia. Everything came about
fortuitously. The armies were divided at the commencement of the
campaign. We tried to unite them, with the evident intention of giving
battle and checking the enemy's advance, and by this effort to unite
them while avoiding battle with a much stronger enemy, and necessarily
withdrawing the armies at an acute angle--we led the French on to
Smolensk. But we withdrew at an acute angle not only because the
French advanced between our two armies; the angle became still more
acute and we withdrew still farther, because Barclay de Tolly was an
unpopular foreigner disliked by Bagration (who would come his
command), and Bagration--being in command of the second army--tried to
postpone joining up and coming under Barclay's command as long as he
could. Bagration was slow in effecting the junction--though that was
the chief aim of all at headquarters--because, as he alleged, he
exposed his army to danger on this march, and it was best for him to
retire more to the left and more to the south, worrying the enemy from
flank and rear and securing from the Ukraine recruits for his army;
and it looks as if he planned this in order not to come under the
command of the detested foreigner Barclay, whose rank was inferior
to his own.

The Emperor was with the army to encourage it, but his presence
and ignorance of what steps to take, and the enormous number of
advisers and plans, destroyed the first army's energy and it retired.

The intention was to make a stand at the Drissa camp, but
Paulucci, aiming at becoming commander in chief, unexpectedly employed
his energy to influence Alexander, and Pfuel's whole plan was
abandoned and the command entrusted to Barclay. But as Barclay did not
inspire confidence his power was limited. The armies were divided,
there was no unity of command, and Barclay was unpopular; but from
this confusion, division, and the unpopularity of the foreign
commander in chief, there resulted on the one hand indecision and
the avoidance of a battle (which we could not have refrained from
had the armies been united and had someone else, instead of Barclay,
been in command) and on the other an ever-increasing indignation
against the foreigners and an increase in patriotic zeal.

At last the Emperor left the army, and as the most convenient and
indeed the only pretext for his departure it was decided that it was
necessary for him to inspire the people in the capitals and arouse the
nation in general to a patriotic war. And by this visit of the Emperor
to Moscow the strength of the Russian army was trebled.

He left in order not to obstruct the commander in chief's
undivided control of the army, and hoping that more decisive action
would then be taken, but the command of the armies became still more
confused and enfeebled. Bennigsen, the Tsarevich, and a swarm of
adjutants general remained with the army to keep the commander in
chief under observation and arouse his energy, and Barclay, feeling
less free than ever under the observation of all these "eyes of the
Emperor," became still more cautious of undertaking any decisive
action and avoided giving battle.

Barclay stood for caution. The Tsarevich hinted at treachery and
demanded a general engagement. Lubomirski, Bronnitski, Wlocki, and the
others of that group stirred up so much trouble that Barclay, under
pretext of sending papers to the Emperor, dispatched these Polish
adjutants general to Petersburg and plunged into an open struggle with
Bennigsen and the Tsarevich.

At Smolensk the armies at last reunited, much as Bagration
disliked it.

Bagration drove up in a carriage to to the house occupied by
Barclay. Barclay donned his sash and came out to meet and report to
his senior officer Bagration.

Despite his seniority in rank Bagration, in this contest of
magnanimity, took his orders from Barclay, but, having submitted,
agreed with him less than ever. By the Emperor's orders Bagration
reported direct to him. He wrote to Arakcheev, the Emperor's
confidant: "It must be as my sovereign pleases, but I cannot work with
the Minister (meaning Barclay). For God's sake send me somewhere
else if only in command of a regiment. I cannot stand it here.
Headquarters are so full of Germans that a Russian cannot exist and
there is no sense in anything. I thought I was really serving my
sovereign and the Fatherland, but it turns out that I am serving
Barclay. I confess I do not want to."

The swarm of Bronnitskis and Wintzingerodes and their like still
further embittered the relations between the commanders in chief,
and even less unity resulted. Preparations were made to fight the
French before Smolensk. A general was sent to survey the position.
This general, hating Barclay, rode to visit a friend of his own, a
corps commander, and, having spent the day with him, returned to
Barclay and condemned, as unsuitable from every point of view, the
battleground he had not seen.

While disputes and intrigues were going on about the future field of
battle, and while we were looking for the French--having lost touch
with them--the French stumbled upon Neverovski's division and
reached the walls of Smolensk.

It was necessary to fight an unexpected battle at Smolensk to save
our lines of communication. The battle was fought and thousands were
killed on both sides.

Smolensk was abandoned contrary to the wishes of the Emperor and
of the whole people. But Smolensk was burned by its own
inhabitants-who had been misled by their governor. And these ruined
inhabitants, setting an example to other Russians, went to Moscow
thinking only of their own losses but kindling hatred of the foe.
Napoleon advanced farther and we retired, thus arriving at the very
result which caused his destruction.





CHAPTER II


The day after his son had left, Prince Nicholas sent for Princess
Mary to come to his study.

"Well? Are you satisfied now?" said he. "You've made me quarrel with
my son! Satisfied, are you? That's all you wanted! Satisfied?... It
hurts me, it hurts. I'm old and weak and this is what you wanted. Well
then, gloat over it! Gloat over it!"

After that Princess Mary did not see her father for a whole week. He
was ill and did not leave his study.

Princess Mary noticed to her surprise that during this illness the
old prince not only excluded her from his room, but did not admit
Mademoiselle Bourienne either. Tikhon alone attended him.

At the end of the week the prince reappeared and resumed his
former way of life, devoting himself with special activity to building
operations and the arrangement of the gardens and completely
breaking off his relations with Mademoiselle Bourienne. His looks
and cold tone to his daughter seemed to say: "There, you see? You
plotted against me, you lied to Prince Andrew about my relations
with that Frenchwoman and made me quarrel with him, but you see I need
neither her nor you!"

Princess Mary spent half of every day with little Nicholas, watching
his lessons, teaching him Russian and music herself, and talking to
Dessalles; the rest of the day she spent over her books, with her
old nurse, or with "God's folk" who sometimes came by the back door to
see her.

Of the war Princess Mary thought as women do think about wars. She
feared for her brother who was in it, was horrified by and amazed at
the strange cruelty that impels men to kill one another, but she did
not understand the significance of this war, which seemed to her
like all previous wars. She did not realize the significance of this
war, though Dessalles with whom she constantly conversed was
passionately interested in its progress and tried to explain his own
conception of it to her, and though the "God's folk" who came to see
her reported, in their own way, the rumors current among the people of
an invasion by Antichrist, and though Julie (now Princess
Drubetskaya), who had resumed correspondence with her, wrote patriotic
letters from Moscow.

"I write you in Russian, my good friend," wrote Julie in her
Frenchified Russian, "because I have a detestation for all the French,
and the same for their language which I cannot support to hear
spoken.... We in Moscow are elated by enthusiasm for our adored
Emperor.

"My poor husband is enduring pains and hunger in Jewish taverns, but
the news which I have inspires me yet more.

"You heard probably of the heroic exploit of Raevski, embracing
his two sons and saying: 'I will perish with them but we will not be
shaken!' And truly though the enemy was twice stronger than we, we
were unshakable. We pass the time as we can, but in war as in war! The
princesses Aline and Sophie sit whole days with me, and we, unhappy
widows of live men, make beautiful conversations over our charpie,
only you, my friend, are missing..." and so on.

The chief reason Princess Mary did not realize the full significance
of this war was that the old prince never spoke of it, did not
recognize it, and laughed at Dessalles when he mentioned it at dinner.
The prince's tone was so calm and confident that Princess Mary
unhesitatingly believed him.

All that July the old prince was exceedingly active and even
animated. He planned another garden and began a new building for the
domestic serfs. The only thing that made Princess Mary anxious about
him was that he slept very little and, instead of sleeping in his
study as usual, changed his sleeping place every day. One day he would
order his camp bed to be set up in the glass gallery, another day he
remained on the couch or on the lounge chair in the drawing room and
dozed there without undressing, while--instead of Mademoiselle
Bourienne--a serf boy read to him. Then again he would spend a night
in the dining room.

On August 1, a second letter was received from Prince Andrew. In his
first letter which came soon after he had left home, Prince Andrew had
dutifully asked his father's forgiveness for what he had allowed
himself to say and begged to be restored to his favor. To this
letter the old prince had replied affectionately, and from that time
had kept the Frenchwoman at a distance. Prince Andrew's second letter,
written near Vitebsk after the French had occupied that town, gave a
brief account of the whole campaign, enclosed for them a plan he had
drawn and forecasts as to the further progress of the war. In this
letter Prince Andrew pointed out to his father the danger of staying
at Bald Hills, so near the theater of war and on the army's direct
line of march, and advised him to move to Moscow.

At dinner that day, on Dessalles' mentioning that the French were
said to have already entered Vitebsk, the old prince remembered his
son's letter.

"There was a letter from Prince Andrew today," he said to Princess
Mary--"Haven't you read it?"

"No, Father," she replied in a frightened voice.

She could not have read the letter as she did not even know it had
arrived.

"He writes about this war," said the prince, with the ironic smile
that had become habitual to him in speaking of the present war.

"That must be very interesting," said Dessalles. "Prince Andrew is
in a position to know..."

"Oh, very interesting!" said Mademoiselle Bourienne.

"Go and get it for me," said the old prince to Mademoiselle
Bourienne. "You know--under the paperweight on the little table."

Mademoiselle Bourienne jumped up eagerly.

"No, don't!" he exclaimed with a frown. "You go, Michael Ivanovich."

Michael Ivanovich rose and went to the study. But as soon as he
had left the room the old prince, looking uneasily round, threw down
his napkin and went himself.

"They can't do anything... always make some muddle," he muttered.

While he was away Princess Mary, Dessalles, Mademoiselle
Bourienne, and even little Nicholas exchanged looks in silence. The
old prince returned with quick steps, accompanied by Michael
Ivanovich, bringing the letter and a plan. These he put down beside
him--not letting anyone read them at dinner.

On moving to the drawing room he handed the letter to Princess
Mary and, spreading out before him the plan of the new building and
fixing his eyes upon it, told her to read the letter aloud. When she
had done so Princess Mary looked inquiringly at her father. He was
examining the plan, evidently engrossed in his own ideas.

"What do you think of it, Prince?" Dessalles ventured to ask.

"I? I?..." said the prince as if unpleasantly awakened, and not
taking his eyes from the plan of the building.

"Very possibly the theater of war will move so near to us that..."

"Ha ha ha! The theater of war!" said the prince. "I have said and
still say that the theater of war is Poland and the enemy will never
get beyond the Niemen."

Dessalles looked in amazement at the prince, who was talking of
the Niemen when the enemy was already at the Dnieper, but Princess
Mary, forgetting the geographical position of the Niemen, thought that
what her father was saying was correct.

"When the snow melts they'll sink in the Polish swamps. Only they
could fail to see it," the prince continued, evidently thinking of the
campaign of 1807 which seemed to him so recent. "Bennigsen should have
advanced into Prussia sooner, then things would have taken a different
turn..."

"But, Prince," Dessalles began timidly, "the letter mentions
Vitebsk...."

"Ah, the letter? Yes..." replied the prince peevishly. "Yes...
yes..." His face suddenly took on a morose expression. He paused.
"Yes, he writes that the French were beaten at... at... what river
is it?"

Dessalles dropped his eyes.

"The prince says nothing about that," he remarked gently.

"Doesn't he? But I didn't invent it myself."

No one spoke for a long time.

"Yes... yes... Well, Michael Ivanovich," he suddenly went on,
raising his head and pointing to the plan of the building, "tell me
how you mean to alter it...."

Michael Ivanovich went up to the plan, and the prince after speaking
to him about the building looked angrily at Princess Mary and
Dessalles and went to his own room.

Princess Mary saw Dessalles' embarrassed and astonished look fixed
on her father, noticed his silence, and was struck by the fact that
her father had forgotten his son's letter on the drawing-room table;
but she was not only afraid to speak of it and ask Dessalles the
reason of his confusion and silence, but was afraid even to think
about it.

In the evening Michael Ivanovich, sent by the prince, came to
Princess Mary for Prince Andrew's letter which had been forgotten in
the drawing room. She gave it to him and, unpleasant as it was to
her to do so, ventured to ask him what her father was doing.

"Always busy," replied Michael Ivanovich with a respectfully
ironic smile which caused Princess Mary to turn pale. "He's worrying
very much about the new building. He has been reading a little, but
now"--Michael Ivanovich went on, lowering his voice--"now he's at
his desk, busy with his will, I expect." (One of the prince's favorite
occupations of late had been the preparation of some papers he meant
to leave at his death and which he called his "will.")

"And Alpatych is being sent to Smolensk?" asked Princess Mary.

"Oh, yes, he has been waiting to start for some time."





CHAPTER III


When Michael Ivanovich returned to the study with the letter, the
old prince, with spectacles on and a shade over his eyes, was
sitting at his open bureau with screened candles, holding a paper in
his outstretched hand, and in a somewhat dramatic attitude was reading
his manuscript--his "Remarks" as he termed it--which was to be
transmitted to the Emperor after his death.

When Michael Ivanovich went in there were tears in the prince's eyes
evoked by the memory of the time when the paper he was now reading had
been written. He took the letter from Michael Ivanovich's hand, put it
in his pocket, folded up his papers, and called in Alpatych who had
long been waiting.

The prince had a list of things to be bought in Smolensk and,
walking up and down the room past Alpatych who stood by the door, he
gave his instructions.

"First, notepaper--do you hear? Eight quires, like this sample,
gilt-edged... it must be exactly like the sample. Varnish, sealing
wax, as in Michael Ivanovich's list."

He paced up and down for a while and glanced at his notes.

"Then hand to the governor in person a letter about the deed."

Next, bolts for the doors of the new building were wanted and had to
be of a special shape the prince had himself designed, and a leather
case had to be ordered to keep the "will" in.

The instructions to Alpatych took over two hours and still the
prince did not let him go. He sat down, sank into thought, closed
his eyes, and dozed off. Alpatych made a slight movement.

"Well, go, go! If anything more is wanted I'll send after you."

Alpatych went out. The prince again went to his bureau, glanced into
it, fingered his papers, closed the bureau again, and sat down at
the table to write to the governor.

It was already late when he rose after sealing the letter. He wished
to sleep, but he knew he would not be able to and that most depressing
thoughts came to him in bed. So he called Tikhon and went through
the rooms with him to show him where to set up the bed for that night.

He went about looking at every corner. Every place seemed
unsatisfactory, but worst of all was his customary couch in the study.
That couch was dreadful to him, probably because of the oppressive
thoughts he had had when lying there. It was unsatisfactory
everywhere, but the corner behind the piano in the sitting room was
better than other places: he had never slept there yet.

With the help of a footman Tikhon brought in the bedstead and
began putting it up.

"That's not right! That's not right!" cried the prince, and
himself pushed it a few inches from the corner and then closer in
again.

"Well, at last I've finished, now I'll rest," thought the prince,
and let Tikhon undress him.

Frowning with vexation at the effort necessary to divest himself
of his coat and trousers, the prince undressed, sat down heavily on
the bed, and appeared to be meditating as he looked contemptuously
at his withered yellow legs. He was not meditating, but only deferring
the moment of making the effort to lift those legs up and turn over on
the bed. "Ugh, how hard it is! Oh, that this toil might end and you
would release me!" thought he. Pressing his lips together he made that
effort for the twenty-thousandth time and lay down. But hardly had
he done so before he felt the bed rocking backwards and forwards
beneath him as if it were breathing heavily and jolting. This happened
to him almost every night. He opened his eyes as they were closing.

"No peace, damn them!" he muttered, angry he knew not with whom. "Ah
yes, there was something else important, very important, that I was
keeping till I should be in bed. The bolts? No, I told him about them.
No, it was something, something in the drawing room. Princess Mary
talked some nonsense. Dessalles, that fool, said something.
Something in my pocket--can't remember..."

"Tikhon, what did we talk about at dinner?"

"About Prince Michael..."

"Be quiet, quiet!" The prince slapped his hand on the table. "Yes, I
know, Prince Andrew's letter! Princess Mary read it. Dessalles said
something about Vitebsk. Now I'll read it."

He had the letter taken from his pocket and the table--on which
stood a glass of lemonade and a spiral wax candle--moved close to
the bed, and putting on his spectacles he began reading. Only now in
the stillness of the night, reading it by the faint light under the
green shade, did he grasp its meaning for a moment.

"The French at Vitebsk, in four days' march they may be at Smolensk;
perhaps are already there! Tikhon!" Tikhon jumped up. "No, no, I don't
want anything!" he shouted.

He put the letter under the candlestick and closed his eyes. And
there rose before him the Danube at bright noonday: reeds, the Russian
camp, and himself a young general without a wrinkle on his ruddy face,
vigorous and alert, entering Potemkin's gaily colored tent, and a
burning sense of jealousy of "the favorite" agitated him now as
strongly as it had done then. He recalled all the words spoken at that
first meeting with Potemkin. And he saw before him a plump, rather
sallow-faced, short, stout woman, the Empress Mother, with her smile
and her words at her first gracious reception of him, and then that
same face on the catafalque, and the encounter he had with Zubov
over her coffin about his right to kiss her hand.

"Oh, quicker, quicker! To get back to that time and have done with
all the present! Quicker, quicker--and that they should leave me in
peace!"





CHAPTER IV


Bald Hills, Prince Nicholas Bolkonski's estate, lay forty miles east
from Smolensk and two miles from the main road to Moscow.

The same evening that the prince gave his instructions to
Alpatych, Dessalles, having asked to see Princess Mary, told her that,
as the prince was not very well and was taking no steps to secure
his safety, though from Prince Andrew's letter it was evident that
to remain at Bald Hills might be dangerous, he respectfully advised
her to send a letter by Alpatych to the Provincial Governor at
Smolensk, asking him to let her know the state of affairs and the
extent of the danger to which Bald Hills was exposed. Dessalles
wrote this letter to the Governor for Princess Mary, she signed it,
and it was given to Alpatych with instructions to hand it to the
Governor and to come back as quickly as possible if there was danger.

Having received all his orders Alpatych, wearing a white beaver hat-
a present from the prince--and carrying a stick as the prince did,
went out accompanied by his family. Three well-fed roans stood ready
harnessed to a small conveyance with a leather hood.

The larger bell was muffled and the little bells on the harness
stuffed with paper. The prince allowed no one at Bald Hills to drive
with ringing bells; but on a long journey Alpatych liked to have them.
His satellites--the senior clerk, a countinghouse clerk, a scullery
maid, a cook, two old women, a little pageboy, the coachman, and
various domestic serfs--were seeing him off.

His daughter placed chintz-covered down cushions for him to sit on
and behind his back. His old sister-in-law popped in a small bundle,
and one of the coachmen helped him into the vehicle.

"There! There! Women's fuss! Women, women!" said Alpatych, puffing
and speaking rapidly just as the prince did, and he climbed into the
trap.

After giving the clerk orders about the work to be done, Alpatych,
not trying to imitate the prince now, lifted the hat from his bald
head and crossed himself three times.

"If there is anything... come back, Yakov Alpatych! For Christ's
sake think of us!" cried his wife, referring to the rumors of war
and the enemy.

"Women, women! Women's fuss!" muttered Alpatych to himself and
started on his journey, looking round at the fields of yellow rye
and the still-green, thickly growing oats, and at other quite black
fields just being plowed a second time.

As he went along he looked with pleasure at the year's splendid crop
of corn, scrutinized the strips of ryefield which here and there
were already being reaped, made his calculations as to the sowing
and the harvest, and asked himself whether he had not forgotten any of
the prince's orders.

Having baited the horses twice on the way, he arrived at the town
toward evening on the fourth of August.

Alpatych kept meeting and overtaking baggage trains and troops on
the road. As he approached Smolensk he heard the sounds of distant
firing, but these did not impress him. What struck him most was the
sight of a splendid field of oats in which a camp had been pitched and
which was being mown down by the soldiers, evidently for fodder.
This fact impressed Alpatych, but in thinking about his own business
he soon forgot it.

All the interests of his life for more than thirty years had been
bounded by the will of the prince, and he never went beyond that
limit. Everything not connected with the execution of the prince's
orders did not interest and did not even exist for Alpatych.

On reaching Smolensk on the evening of the fourth of August he put
up in the Gachina suburb across the Dnieper, at the inn kept by
Ferapontov, where he had been in the habit of putting up for the
last thirty years. Some thirty years ago Ferapontov, by Alpatych's
advice, had bought a wood from the prince, had begun to trade, and now
had a house, an inn, and a corn dealer's shop in that province. He was
a stout, dark, red-faced peasant in the forties, with thick lips, a
broad knob of a nose, similar knobs over his black frowning brows, and
a round belly.

Wearing a waistcoat over his cotton shirt, Ferapontov was standing
before his shop which opened onto the street. On seeing Alpatych he
went up to him.

"You're welcome, Yakov Alpatych. Folks are leaving the town, but you
have come to it," said he.

"Why are they leaving the town?" asked Alpatych.

"That's what I say. Folks are foolish! Always afraid of the French."

"Women's fuss, women's fuss!" said Alpatych.

"Just what I think, Yakov Alpatych. What I say is: orders have
been given not to let them in, so that must be right. And the peasants
are asking three rubles for carting--it isn't Christian!"

Yakov Alpatych heard without heeding. He asked for a samovar and for
hay for his horses, and when he had had his tea he went to bed.

All night long troops were moving past the inn. Next morning
Alpatych donned a jacket he wore only in town and went out on
business. It was a sunny morning and by eight o'clock it was already
hot. "A good day for harvesting," thought Alpatych.

From beyond the town firing had been heard since early morning. At
eight o'clock the booming of cannon was added to the sound of
musketry. Many people were hurrying through the streets and there were
many soldiers, but cabs were still driving about, tradesmen stood at
their shops, and service was being held in the churches as usual.
Alpatych went to the shops, to government offices, to the post office,
and to the Governor's. In the offices and shops and at the post office
everyone was talking about the army and about the enemy who was
already attacking the town, everybody was asking what should be
done, and all were trying to calm one another.

In front of the Governor's house Alpatych found a large number of
people, Cossacks, and a traveling carriage of the Governor's. At the
porch he met two of the landed gentry, one of whom he knew. This
man, an ex-captain of police, was saying angrily:

"It's no joke, you know! It's all very well if you're single. 'One
man though undone is but one,' as the proverb says, but with
thirteen in your family and all the property... They've brought us
to utter ruin! What sort of governors are they to do that? They
ought to be hanged--the brigands!..."

"Oh come, that's enough!" said the other.

"What do I care? Let him hear! We're not dogs," said the
ex-captain of police, and looking round he noticed Alpatych.

"Oh, Yakov Alpatych! What have you come for?"

"To see the Governor by his excellency's order," answered
Alpatych, lifting his head and proudly thrusting his hand into the
bosom of his coat as he always did when he mentioned the prince....
"He has ordered me to inquire into the position of affairs," he added.

"Yes, go and find out!" shouted the angry gentleman. "They've
brought things to such a pass that there are no carts or
anything!... There it is again, do you hear?" said he, pointing
in the direction whence came the sounds of firing.

"They've brought us all to ruin... the brigands!" he repeated, and
descended the porch steps.

Alpatych swayed his head and went upstairs. In the waiting room were
tradesmen, women, and officials, looking silently at one another.
The door of the Governor's room opened and they all rose and moved
forward. An official ran out, said some words to a merchant, called
a stout official with a cross hanging on his neck to follow him, and
vanished again, evidently wishing to avoid the inquiring looks and
questions addressed to him. Alpatych moved forward and next time the
official came out addressed him, one hand placed in the breast of
his buttoned coat, and handed him two letters.

"To his Honor Baron Asch, from General-in-Chief Prince Bolkonski,"
he announced with such solemnity and significance that the official
turned to him and took the letters.

A few minutes later the Governor received Alpatych and hurriedly
said to him:

"Inform the prince and princess that I knew nothing: I acted on
the highest instructions--here..." and he handed a paper to
Alpatych. "Still, as the prince is unwell my advice is that they
should go to Moscow. I am just starting myself. Inform them..."

But the Governor did not finish: a dusty perspiring officer ran into
the room and began to say something in French. The Governor's face
expressed terror.

"Go," he said, nodding his head to Alpatych, and began questioning
the officer.

Eager, frightened, helpless glances were turned on Alpatych when
he came out of the Governor's room. Involuntarily listening now to the
firing, which had drawn nearer and was increasing in strength,
Alpatych hurried to his inn. The paper handed to him by the Governor
said this:


"I assure you that the town of Smolensk is not in the slightest
danger as yet and it is unlikely that it will be threatened with
any. I from the one side and Prince Bagration from the other are
marching to unite our forces before Smolensk, which junction will be
effected on the 22nd instant, and both armies with their united forces
will defend our compatriots of the province entrusted to your care
till our efforts shall have beaten back the enemies of our Fatherland,
or till the last warrior in our valiant ranks has perished. From
this you will see that you have a perfect right to reassure the
inhabitants of Smolensk, for those defended by two such brave armies
may feel assured of victory." (Instructions from Barclay de Tolly to
Baron Asch, the civil governor of Smolensk, 1812.)


People were anxiously roaming about the streets.

Carts piled high with household utensils, chairs, and cupboards kept
emerging from the gates of the yards and moving along the streets.
Loaded carts stood at the house next to Ferapontov's and women were
wailing and lamenting as they said good-by. A small watchdog ran round
barking in front of the harnessed horses.

Alpatych entered the innyard at a quicker pace than usual and went
straight to the shed where his horses and trap were. The coachman
was asleep. He woke him up, told him to harness, and went into the
passage. From the host's room came the sounds of a child crying, the
despairing sobs of a woman, and the hoarse angry shouting of
Ferapontov. The cook began running hither and thither in the passage
like a frightened hen, just as Alpatych entered.

"He's done her to death. Killed the mistress!... Beat her... dragged
her about so!..."

"What for?" asked Alpatych.

"She kept begging to go away. She's a woman! 'Take me away,' says
she, 'don't let me perish with my little children! Folks,' she says,
'are all gone, so why,' she says, 'don't we go?' And he began
beating and pulling her about so!"

At these words Alpatych nodded as if in approval, and not wishing to
hear more went to the door of the room opposite the innkeeper's, where
he had left his purchases.

"You brute, you murderer!" screamed a thin, pale woman who, with a
baby in her arms and her kerchief torn from her head, burst through
the door at that moment and down the steps into the yard.

Ferapontov came out after her, but on seeing Alpatych adjusted his
waistcoat, smoothed his hair, yawned, and followed Alpatych into the
opposite room.

"Going already?" said he.

Alpatych, without answering or looking at his host, sorted his
packages and asked how much he owed.

"We'll reckon up! Well, have you been to the Governor's?" asked
Ferapontov. "What has been decided?"

Alpatych replied that the Governor had not told him anything
definite.

"With our business, how can we get away?" said Ferapontov. "We'd
have to pay seven rubles a cartload to Dorogobuzh and I tell them
they're not Christians to ask it! Selivanov, now, did a good stroke
last Thursday--sold flour to the army at nine rubles a sack. Will
you have some tea?" he added.

While the horses were being harnessed Alpatych and Ferapontov over
their tea talked of the price of corn, the crops, and the good weather
for harvesting.

"Well, it seems to be getting quieter," remarked Ferapontov,
finishing his third cup of tea and getting up. "Ours must have got the
best of it. The orders were not to let them in. So we're in force,
it seems.... They say the other day Matthew Ivanych Platov drove
them into the river Marina and drowned some eighteen thousand in one
day."

Alpatych collected his parcels, handed them to the coachman who
had come in, and settled up with the innkeeper. The noise of wheels,
hoofs, and bells was heard from the gateway as a little trap passed
out.

It was by now late in the afternoon. Half the street was in
shadow, the other half brightly lit by the sun. Alpatych looked out of
the window and went to the door. Suddenly the strange sound of a
far-off whistling and thud was heard, followed by a boom of cannon
blending into a dull roar that set the windows rattling.

He went out into the street: two men were running past toward the
bridge. From different sides came whistling sounds and the thud of
cannon balls and bursting shells falling on the town. But these sounds
were hardly heard in comparison with the noise of the firing outside
the town and attracted little attention from the inhabitants. The town
was being bombarded by a hundred and thirty guns which Napoleon had
ordered up after four o'clock. The people did not at once realize
the meaning of this bombardment.

At first the noise of the falling bombs and shells only aroused
curiosity. Ferapontov's wife, who till then had not ceased wailing
under the shed, became quiet and with the baby in her arms went to the
gate, listening to the sounds and looking in silence at the people.

The cook and a shop assistant came to the gate. With lively
curiosity everyone tried to get a glimpse of the projectiles as they
flew over their heads. Several people came round the corner talking
eagerly.

"What force!" remarked one. "Knocked the roof and ceiling all to
splinters!"

"Routed up the earth like a pig," said another.

"That's grand, it bucks one up!" laughed the first. "Lucky you
jumped aside, or it would have wiped you out!"

Others joined those men and stopped and told how cannon balls had
fallen on a house close to them. Meanwhile still more projectiles, now
with the swift sinister whistle of a cannon ball, now with the
agreeable intermittent whistle of a shell, flew over people's heads
incessantly, but not one fell close by, they all flew over. Alpatych
was getting into his trap. The innkeeper stood at the gate.

"What are you staring at?" he shouted to the cook, who in her red
skirt, with sleeves rolled up, swinging her bare elbows, had stepped
to the corner to listen to what was being said.

"What marvels!" she exclaimed, but hearing her master's voice she
turned back, pulling down her tucked-up skirt.

Once more something whistled, but this time quite close, swooping
downwards like a little bird; a flame flashed in the middle of the
street, something exploded, and the street was shrouded in smoke.

"Scoundrel, what are you doing?" shouted the innkeeper, rushing to
the cook.

At that moment the pitiful wailing of women was heard from different
sides, the frightened baby began to cry, and people crowded silently
with pale faces round the cook. The loudest sound in that crowd was
her wailing.

"Oh-h-h! Dear souls, dear kind souls! Don't let me die! My good
souls!..."

Five minutes later no one remained in the street. The cook, with her
thigh broken by a shell splinter, had been carried into the kitchen.
Alpatych, his coachman, Ferapontov's wife and children and the house
porter were all sitting in the cellar, listening. The roar of guns,
the whistling of projectiles, and the piteous moaning of the cook,
which rose above the other sounds, did not cease for a moment. The
mistress rocked and hushed her baby and when anyone came into the
cellar asked in a pathetic whisper what had become of her husband
who had remained in the street. A shopman who entered told her that
her husband had gone with others to the cathedral, whence they were
fetching the wonder-working icon of Smolensk.

Toward dusk the cannonade began to subside. Alpatych left the cellar
and stopped in the doorway. The evening sky that had been so clear was
clouded with smoke, through which, high up, the sickle of the new moon
shone strangely. Now that the terrible din of the guns had ceased a
hush seemed to reign over the town, broken only by the rustle of
footsteps, the moaning, the distant cries, and the crackle of fires
which seemed widespread everywhere. The cook's moans had now subsided.
On two sides black curling clouds of smoke rose and spread from the
fires. Through the streets soldiers in various uniforms walked or
ran confusedly in different directions like ants from a ruined
ant-hill. Several of them ran into Ferapontov's yard before Alpatych's
eyes. Alpatych went out to the gate. A retreating regiment,
thronging and hurrying, blocked the street.

Noticing him, an officer said: "The town is being abandoned. Get
away, get away!" and then, turning to the soldiers, shouted:

"I'll teach you to run into the yards!"

Alpatych went back to the house, called the coachman, and told him
to set off. Ferapontov's whole household came out too, following
Alpatych and the coachman. The women, who had been silent till then,
suddenly began to wail as they looked at the fires--the smoke and even
the flames of which could be seen in the failing twilight--and as if
in reply the same kind of lamentation was heard from other parts of
the street. Inside the shed Alpatych and the coachman arranged the
tangled reins and traces of their horses with trembling hands.

As Alpatych was driving out of the gate he saw some ten soldiers
in Ferapontov's open shop, talking loudly and filling their bags and
knapsacks with flour and sunflower seeds. Just then Ferapontov
returned and entered his shop. On seeing the soldiers he was about
to shout at them, but suddenly stopped and, clutching at his hair,
burst into sobs and laughter:

"Loot everything, lads! Don't let those devils get it!" he cried,
taking some bags of flour himself and throwing them into the street.

Some of the soldiers were frightened and ran away, others went on
filling their bags. On seeing Alpatych, Ferapontov turned to him:

"Russia is done for!" he cried. "Alpatych, I'll set the place on
fire myself. We're done for!..." and Ferapontov ran into the yard.

Soldiers were passing in a constant stream along the street blocking
it completely, so that Alpatych could not pass out and had to wait.
Ferapontov's wife and children were also sitting in a cart waiting
till it was possible to drive out.

Night had come. There were stars in the sky and the new moon shone
out amid the smoke that screened it. On the sloping descent to the
Dnieper Alpatych's cart and that of the innkeeper's wife, which were
slowly moving amid the rows of soldiers and of other vehicles, had
to stop. In a side street near the crossroads where the vehicles had
stopped, a house and some shops were on fire. This fire was already
burning itself out. The flames now died down and were lost in the
black smoke, now suddenly flared up again brightly, lighting up with
strange distinctness the faces of the people crowding at the
crossroads. Black figures flitted about before the fire, and through
the incessant crackling of the flames talking and shouting could be
heard. Seeing that his trap would not be able to move on for some
time, Alpatych got down and turned into the side street to look at the
fire. Soldiers were continually rushing backwards and forwards near
it, and he saw two of them and a man in a frieze coat dragging burning
beams into another yard across the street, while others carried
bundles of hay.

Alpatych went up to a large crowd standing before a high barn
which was blazing briskly. The walls were all on fire and the back
wall had fallen in, the wooden roof was collapsing, and the rafters
were alight. The crowd was evidently watching for the roof to fall in,
and Alpatych watched for it too.

"Alpatych!" a familiar voice suddenly hailed the old man.

"Mercy on us! Your excellency!" answered Alpatych, immediately
recognizing the voice of his young prince.

Prince Andrew in his riding cloak, mounted on a black horse, was
looking at Alpatych from the back of the crowd.

"Why are you here?" he asked.

"Your... your excellency," stammered Alpatych and broke into sobs.
"Are we really lost? Master!..."

"Why are you here?" Prince Andrew repeated.

At that moment the flames flared up and showed his young master's
pale worn face. Alpatych told how he had been sent there and how
difficult it was to get away.

"Are we really quite lost, your excellency?" he asked again.

Prince Andrew without replying took out a notebook and raising his
knee began writing in pencil on a page he tore out. He wrote to his
sister:


"Smolensk is being abandoned. Bald Hills will be occupied by the
enemy within a week. Set off immediately for Moscow. Let me know at
once when you will start. Send by special messenger to Usvyazh."


Having written this and given the paper to Alpatych, he told him how
to arrange for departure of the prince, the princess, his son, and the
boy's tutor, and how and where to let him know immediately. Before
he had had time to finish giving these instructions, a chief of
staff followed by a suite galloped up to him.

"You are a colonel?" shouted the chief of staff with a German
accent, in a voice familiar to Prince Andrew. "Houses are set on
fire in your presence and you stand by! What does this mean? You
will answer for it!" shouted Berg, who was now assistant to the
chief of staff of the commander of the left flank of the infantry of
the first army, a place, as Berg said, "very agreeable and well en
evidence."

Prince Andrew looked at him and without replying went on speaking to
Alpatych.

"So tell them that I shall await a reply till the tenth, and if by
the tenth I don't receive news that they have all got away I shall
have to throw up everything and come myself to Bald Hills."

"Prince," said Berg, recognizing Prince Andrew, "I only spoke
because I have to obey orders, because I always do obey exactly....
You must please excuse me," he went on apologetically.

Something cracked in the flames. The fire died down for a moment and
wreaths of black smoke rolled from under the roof. There was another
terrible crash and something huge collapsed.

"Ou-rou-rou!" yelled the crowd, echoing the crash of the
collapsing roof of the barn, the burning grain in which diffused a
cakelike aroma all around. The flames flared up again, lighting the
animated, delighted, exhausted faces of the spectators.

The man in the frieze coat raised his arms and shouted:

"It's fine, lads! Now it's raging... It's fine!"

"That's the owner himself," cried several voices.

"Well then," continued Prince Andrew to Alpatych, "report to them as
I have told you"; and not replying a word to Berg who was now mute
beside him, he touched his horse and rode down the side street.





CHAPTER V


From Smolensk the troops continued to retreat, followed by the
enemy. On the tenth of August the regiment Prince Andrew commanded was
marching along the highroad past the avenue leading to Bald Hills.
Heat and drought had continued for more than three weeks. Each day
fleecy clouds floated across the sky and occasionally veiled the
sun, but toward evening the sky cleared again and the sun set in
reddish-brown mist. Heavy night dews alone refreshed the earth. The
unreaped corn was scorched and shed its grain. The marshes dried up.
The cattle lowed from hunger, finding no food on the sun-parched
meadows. Only at night and in the forests while the dew lasted was
there any freshness. But on the road, the highroad along which the
troops marched, there was no such freshness even at night or when
the road passed through the forest; the dew was imperceptible on the
sandy dust churned up more than six inches deep. As soon as day dawned
the march began. The artillery and baggage wagons moved noiselessly
through the deep dust that rose to the very hubs of the wheels, and
the infantry sank ankle-deep in that soft, choking, hot dust that
never cooled even at night. Some of this dust was kneaded by the
feet and wheels, while the rest rose and hung like a cloud over the
troops, settling in eyes, ears, hair, and nostrils, and worst of all
in the lungs of the men and beasts as they moved along that road.
The higher the sun rose the higher rose that cloud of dust, and
through the screen of its hot fine particles one could look with naked
eye at the sun, which showed like a huge crimson ball in the unclouded
sky. There was no wind, and the men choked in that motionless
atmosphere. They marched with handkerchiefs tied over their noses
and mouths. When they passed through a village they all rushed to
the wells and fought for the water and drank it down to the mud.

Prince Andrew was in command of a regiment, and the management of
that regiment, the welfare of the men and the necessity of receiving
and giving orders, engrossed him. The burning of Smolensk and its
abandonment made an epoch in his life. A novel feeling of anger
against the foe made him forget his own sorrow. He was entirely
devoted to the affairs of his regiment and was considerate and kind to
his men and officers. In the regiment they called him "our prince,"
were proud of him and loved him. But he was kind and gentle only to
those of his regiment, to Timokhin and the like--people quite new to
him, belonging to a different world and who could not know and
understand his past. As soon as he came across a former acquaintance
or anyone from the staff, he bristled up immediately and grew
spiteful, ironical, and contemptuous. Everything that reminded him
of his past was repugnant to him, and so in his relations with that
former circle he confined himself to trying to do his duty and not
to be unfair.

In truth everything presented itself in a dark and gloomy light to
Prince Andrew, especially after the abandonment of Smolensk on the
sixth of August (he considered that it could and should have been
defended) and after his sick father had had to flee to Moscow,
abandoning to pillage his dearly beloved Bald Hills which he had built
and peopled. But despite this, thanks to his regiment, Prince Andrew
had something to think about entirely apart from general questions.
Two days previously he had received news that his father, son, and
sister had left for Moscow; and though there was nothing for him to do
at Bald Hills, Prince Andrew with a characteristic desire to foment
his own grief decided that he must ride there.

He ordered his horse to be saddled and, leaving his regiment on
the march, rode to his father's estate where he had been born and
spent his childhood. Riding past the pond where there used always to
be dozens of women chattering as they rinsed their linen or beat it
with wooden beetles, Prince Andrew noticed that there was not a soul
about and that the little washing wharf, torn from its place and
half submerged, was floating on its side in the middle of the pond. He
rode to the keeper's lodge. No one at the stone entrance gates of
the drive and the door stood open. Grass had already begun to grow
on the garden paths, and horses and calves were straying in the
English park. Prince Andrew rode up to the hothouse; some of the glass
panes were broken, and of the trees in tubs some were overturned and
others dried up. He called for Taras the gardener, but no one replied.
Having gone round the corner of the hothouse to the ornamental garden,
he saw that the carved garden fence was broken and branches of the
plum trees had been torn off with the fruit. An old peasant whom
Prince Andrew in his childhood had often seen at the gate was
sitting on a green garden seat, plaiting a bast shoe.

He was deaf and did not hear Prince Andrew ride up. He was sitting
on the seat the old prince used to like to sit on, and beside him
strips of bast were hanging on the broken and withered branch of a
magnolia.

Prince Andrew rode up to the house. Several limes in the old
garden had been cut down and a piebald mare and her foal were
wandering in front of the house among the rosebushes. The shutters
were all closed, except at one window which was open. A little serf
boy, seeing Prince Andrew, ran into the house. Alpatych, having sent
his family away, was alone at Bald Hills and was sitting indoors
reading the Lives of the Saints. On hearing that Prince Andrew had
come, he went out with his spectacles on his nose, buttoning his coat,
and, hastily stepping up, without a word began weeping and kissing
Prince Andrew's knee.

Then, vexed at his own weakness, he turned away and began to
report on the position of affairs. Everything precious and valuable
had been removed to Bogucharovo. Seventy quarters of grain had also
been carted away. The hay and the spring corn, of which Alpatych
said there had been a remarkable crop that year, had been commandeered
by the troops and mown down while still green. The peasants were
ruined; some of them too had gone to Bogucharovo, only a few remained.

Without waiting to hear him out, Prince Andrew asked:

"When did my father and sister leave?" meaning when did they leave
for Moscow.

Alpatych, understanding the question to refer to their departure for
Bogucharovo, replied that they had left on the seventh and again
went into details concerning the estate management, asking for
instructions.

"Am I to let the troops have the oats, and to take a receipt for
them? We have still six hundred quarters left," he inquired.

"What am I to say to him?" thought Prince Andrew, looking down on
the old man's bald head shining in the sun and seeing by the
expression on his face that the old man himself understood how
untimely such questions were and only asked them to allay his grief.

"Yes, let them have it," replied Prince Andrew.

"If you noticed some disorder in the garden," said Alpatych, "it was
impossible to prevent it. Three regiments have been here and spent the
night, dragoons mostly. I took down the name and rank of their
commanding officer, to hand in a complaint about it."

"Well, and what are you going to do? Will you stay here if the enemy
occupies the place?" asked Prince Andrew.

Alpatych turned his face to Prince Andrew, looked at him, and
suddenly with a solemn gesture raised his arm.

"He is my refuge! His will be done!" he exclaimed.

A group of bareheaded peasants was approaching across the meadow
toward the prince.

"Well, good-by!" said Prince Andrew, bending over to Alpatych.
"You must go away too, take away what you can and tell the serfs to go
to the Ryazan estate or to the one near Moscow."

Alpatych clung to Prince Andrew's leg and burst into sobs. Gently
disengaging himself, the prince spurred his horse and rode down the
avenue at a gallop.

The old man was still sitting in the ornamental garden, like a fly
impassive on the face of a loved one who is dead, tapping the last
on which he was making the bast shoe, and two little girls, running
out from the hot house carrying in their skirts plums they had plucked
from the trees there, came upon Prince Andrew. On seeing the young
master, the elder one frightened look clutched her younger companion
by the hand and hid with her behind a birch tree, not stopping to pick
up some green plums they had dropped.

Prince Andrew turned away with startled haste, unwilling to let them
see that they had been observed. He was sorry for the pretty
frightened little girl, was afraid of looking at her, and yet felt
an irresistible desire to do so. A new sensation of comfort and relief
came over him when, seeing these girls, he realized the existence of
other human interests entirely aloof from his own and just as
legitimate as those that occupied him. Evidently these girls
passionately desired one thing--to carry away and eat those green
plums without being caught--and Prince Andrew shared their wish for
the success of their enterprise. He could not resist looking at them
once more. Believing their danger past, they sprang from their
ambush and, chirruping something in their shrill little voices and
holding up their skirts, their bare little sunburned feet scampered
merrily and quickly across the meadow grass.

Prince Andrew was somewhat refreshed by having ridden off the
dusty highroad along which the troops were moving. But not far from
Bald Hills he again came out on the road and overtook his regiment
at its halting place by the dam of a small pond. It was past one
o'clock. The sun, a red ball through the dust, burned and scorched his
back intolerably through his black coat. The dust always hung
motionless above the buzz of talk that came from the resting troops.
There was no wind. As he crossed the dam Prince Andrew smelled the
ooze and freshness of the pond. He longed to get into that water,
however dirty it might be, and he glanced round at the pool from
whence came sounds of shrieks and laughter. The small, muddy, green
pond had risen visibly more than a foot, flooding the dam, because
it was full of the naked white bodies of soldiers with brick-red
hands, necks, and faces, who were splashing about in it. All this
naked white human flesh, laughing and shrieking, floundered about in
that dirty pool like carp stuffed into a watering can, and the
suggestion of merriment in that floundering mass rendered it specially
pathetic.

One fair-haired young soldier of the third company, whom Prince
Andrew knew and who had a strap round the calf of one leg, crossed
himself, stepped back to get a good run, and plunged into the water;
another, a dark noncommissioned officer who was always shaggy, stood
up to his waist in the water joyfully wriggling his muscular figure
and snorted with satisfaction as he poured the water over his head
with hands blackened to the wrists. There were sounds of men
slapping one another, yelling, and puffing.

Everywhere on the bank, on the dam, and in the pond, there was
healthy, white, muscular flesh. The officer, Timokhin, with his red
little nose, standing on the dam wiping himself with a towel, felt
confused at seeing the prince, but made up his mind to address him
nevertheless.

"It's very nice, your excellency! Wouldn't you like to?" said he.

"It's dirty," replied Prince Andrew, making a grimace.

"We'll clear it out for you in a minute," said Timokhin, and,
still undressed, ran off to clear the men out of the pond.

"The prince wants to bathe."

"What prince? Ours?" said many voices, and the men were in such
haste to clear out that the prince could hardly stop them. He
decided that he would rather wash himself with water in the barn.

"Flesh, bodies, cannon fodder!" he thought, and he looked at his own
naked body and shuddered, not from cold but from a sense of disgust
and horror he did not himself understand, aroused by the sight of that
immense number of bodies splashing about in the dirty pond.


On the seventh of August Prince Bagration wrote as follows from
his quarters at Mikhaylovna on the Smolensk road:


Dear Count Alexis Andreevich--(He was writing to Arakcheev but
knew that his letter would be read by the Emperor, and therefore
weighed every word in it to the best of his ability.)

I expect the Minister [Barclay de Tolly] has already reported the
abandonment of Smolensk to the enemy. It is pitiable and sad, and
the whole army is in despair that this most important place has been
wantonly abandoned. I, for my part, begged him personally most
urgently and finally wrote him, but nothing would induce him to
consent. I swear to you on my honor that Napoleon was in such a fix as
never before and might have lost half his army but could not have
taken Smolensk. Our troops fought, and are fighting, as never
before. With fifteen thousand men I held the enemy at bay for
thirty-five hours and beat him; but he would not hold out even for
fourteen hours. It is disgraceful, a stain on our army, and as for
him, he ought, it seems to me, not to live. If he reports that our
losses were great, it is not true; perhaps about four thousand, not
more, and not even that; but even were they ten thousand, that's
war! But the enemy has lost masses...

What would it have cost him to hold out for another two days? They
would have had to retire of their own accord, for they had no water
for men or horses. He gave me his word he would not retreat, but
suddenly sent instructions that he was retiring that night. We
cannot fight in this way, or we may soon bring the enemy to Moscow...

There is a rumor that you are thinking of peace. God forbid that you
should make peace after all our sacrifices and such insane retreats!
You would set all Russia against you and every one of us would feel
ashamed to wear the uniform. If it has come to this--we must fight
as long as Russia can and as long as there are men able to stand...

One man ought to be in command, and not two. Your Minister may
perhaps be good as a Minister, but as a general he is not merely bad
but execrable, yet to him is entrusted the fate of our whole
country.... I am really frantic with vexation; forgive my writing
boldly. It is clear that the man who advocates the conclusion of a
peace, and that the Minister should command the army, does not love
our sovereign and desires the ruin of us all. So I write you
frankly: call out the militia. For the Minister is leading these
visitors after him to Moscow in a most masterly way. The whole army
feels great suspicion of the Imperial aide-de-camp Wolzogen. He is
said to be more Napoleon's man than ours, and he is always advising
the Minister. I am not merely civil to him but obey him like a
corporal, though I am his senior. This is painful, but, loving my
benefactor and sovereign, I submit. Only I am sorry for the Emperor
that he entrusts our fine army to such as he. Consider that on our
retreat we have lost by fatigue and left in the hospital more than
fifteen thousand men, and had we attacked this would not have
happened. Tell me, for God's sake, what will Russia, our mother
Russia, say to our being so frightened, and why are we abandoning
our good and gallant Fatherland to such rabble and implanting feelings
of hatred and shame in all our subjects? What are we scared at and
of whom are we afraid? I am not to blame that the Minister is
vacillating, a coward, dense, dilatory, and has all bad qualities. The
whole army bewails it and calls down curses upon him...





CHAPTER VI


Among the innumerable categories applicable to the phenomena of
human life one may discriminate between those in which substance
prevails and those in which form prevails. To the latter--as
distinguished from village, country, provincial, or even Moscow
life--we may allot Petersburg life, and especially the life of its
salons. That life of the salons is unchanging. Since the year 1805
we had made peace and had again quarreled with Bonaparte and had
made constitutions and unmade them again, but the salons of Anna
Pavlovna Helene remained just as they had been--the one seven and
the other five years before. At Anna Pavlovna's they talked with
perplexity of Bonaparte's successes just as before and saw in them and
in the subservience shown to him by the European sovereigns a
malicious conspiracy, the sole object of which was to cause
unpleasantness and anxiety to the court circle of which Anna
Pavlovna was the representative. And in Helene's salon, which
Rumyantsev himself honored with his visits, regarding Helene as a
remarkably intelligent woman, they talked with the same ecstasy in
1812 as in 1808 of the "great nation" and the "great man," and
regretted our rupture with France, a rupture which, according to them,
ought to be promptly terminated by peace.

Of late, since the Emperor's return from the army, there had been
some excitement in these conflicting salon circles and some
demonstrations of hostility to one another, but each camp retained its
own tendency. In Anna Pavlovna's circle only those Frenchmen were
admitted who were deep-rooted legitimists, and patriotic views were
expressed to the effect that one ought not to go to the French theater
and that to maintain the French troupe was costing the government as
much as a whole army corps. The progress of the war was eagerly
followed, and only the reports most flattering to our army were
circulated. In the French circle of Helene and Rumyantsev the
reports of the cruelty of the enemy and of the war were contradicted
and all Napoleon's attempts at conciliation were discussed. In that
circle they discountenanced those who advised hurried preparations for
a removal to Kazan of the court and the girls' educational
establishments under the patronage of the Dowager Empress. In Helene's
circle the war in general was regarded as a series of formal
demonstrations which would very soon end in peace, and the view
prevailed expressed by Bilibin--who now in Petersburg was quite at
home in Helene's house, which every clever man was obliged to visit-
that not by gunpowder but by those who invented it would matters be
settled. In that circle the Moscow enthusiasm--news of which had
reached Petersburg simultaneously with the Emperor's return--was
ridiculed sarcastically and very cleverly, though with much caution.

Anna Pavlovna's circle on the contrary was enraptured by this
enthusiasm and spoke of it as Plutarch speaks of the deeds of the
ancients. Prince Vasili, who still occupied his former important
posts, formed a connecting link between these two circles. He
visited his "good friend Anna Pavlovna" as well as his daughter's
"diplomatic salon," and often in his constant comings and goings
between the two camps became confused and said at Helene's what he
should have said at Anna Pavlovna's and vice versa.

Soon after the Emperor's return Prince Vasili in a conversation
about the war at Anna Pavlovna's severely condemned Barclay de
Tolly, but was undecided as to who ought to be appointed commander
in chief. One of the visitors, usually spoken of as "a man of great
merit," having described how he had that day seen Kutuzov, the newly
chosen chief of the Petersburg militia, presiding over the
enrollment of recruits at the Treasury, cautiously ventured to suggest
that Kutuzov would be the man to satisfy all requirements.

Anna Pavlovna remarked with a melancholy smile that Kutuzov had done
nothing but cause the Emperor annoyance.

"I have talked and talked at the Assembly of the Nobility," Prince
Vasili interrupted, "but they did not listen to me. I told them his
election as chief of the militia would not please the Emperor. They
did not listen to me.

"It's all this mania for opposition," he went on. "And who for? It
is all because we want to ape the foolish enthusiasm of those
Muscovites," Prince Vasili continued, forgetting for a moment that
though at Helene's one had to ridicule the Moscow enthusiasm, at
Anna Pavlovna's one had to be ecstatic about it. But he retrieved
his mistake at once. "Now, is it suitable that Count Kutuzov, the
oldest general in Russia, should preside at that tribunal? He will get
nothing for his pains! How could they make a man commander in chief
who cannot mount a horse, who drops asleep at a council, and has the
very worst morals! A good reputation he made for himself at Bucharest!
I don't speak of his capacity as a general, but at a time like this
how they appoint a decrepit, blind old man, positively
blind? A fine idea to have a blind general! He can't see anything.
To play blindman's bluff? He can't see at all!"

No one replied to his remarks.

This was quite correct on the twenty-fourth of July. But on the
twenty-ninth of July Kutuzov received the title of Prince. This
might indicate a wish to get rid of him, and therefore Prince Vasili's
opinion continued to be correct though he was not now in any hurry
to express it. But on the eighth of August a committee, consisting
of Field Marshal Saltykov, Arakcheev, Vyazmitinov, Lopukhin, and
Kochubey met to consider the progress of the war. This committee
came to the conclusion that our failures were due to a want of unity
in the command and though the members of the committee were aware of
the Emperor's dislike of Kutuzov, after a short deliberation they
agreed to advise his appointment as commander in chief. That same
day Kutuzov was appointed commander in chief with full powers over the
armies and over the whole region occupied by them.

On the ninth of August Prince Vasili at Anna Pavlovna's again met
the "man of great merit." The latter was very attentive to Anna
Pavlovna because he wanted to be appointed director of one of the
educational establishments for young ladies. Prince Vasili entered the
room with the air of a happy conqueror who has attained the object
of his desires.

"Well, have you heard the great news? Prince Kutuzov is field
marshal! All dissensions are at an end! I am so glad, so delighted! At
last we have a man!" said he, glancing sternly and significantly round
at everyone in the drawing room.

The "man of great merit," despite his desire to obtain the post of
director, could not refrain from reminding Prince Vasili of his former
opinion. Though this was impolite to Prince Vasili in Anna
Pavlovna's drawing room, and also to Anna Pavlovna herself who had
received the news with delight, he could not resist the temptation.

"But, Prince, they say he is blind!" said he, reminding Prince
Vasili of his own words.

"Eh? Nonsense! He sees well enough," said Prince Vasili rapidly,
in a deep voice and with a slight cough--the voice and cough with
which he was wont to dispose of all difficulties.

"He sees well enough," he added. "And what I am so pleased about,"
he went on, "is that our sovereign has given him full powers over
all the armies and the whole region--powers no commander in chief ever
had before. He is a second autocrat," he concluded with a victorious
smile.

"God grant it! God grant it!" said Anna Pavlovna.

The "man of great merit," who was still a novice in court circles,
wishing to flatter Anna Pavlovna by defending her former position on
this question, observed:

"It is said that the Emperor was reluctant to give Kutuzov those
powers. They say he blushed like a girl to whom Joconde is read,
when he said to Kutuzov: 'Your Emperor and the Fatherland award you
this honor.'"

"Perhaps the heart took no part in that speech," said Anna Pavlovna.

"Oh, no, no!" warmly rejoined Prince Vasili, who would not now yield
Kutuzov to anyone; in his opinion Kutuzov was not only admirable
himself, but was adored by everybody. "No, that's impossible," said
he, "for our sovereign appreciated him so highly before."

"God grant only that Prince Kutuzov assumes real power and does
not allow anyone to put a spoke in his wheel," observed Anna Pavlovna.

Understanding at once to whom she alluded, Prince Vasili said in a
whisper:

"I know for a fact that Kutuzov made it an absolute condition that
the Tsarevich should not be with the army. Do you know what he said to
the Emperor?"

And Prince Vasili repeated the words supposed to have been spoken by
Kutuzov to the Emperor. "I can neither punish him if he does wrong nor
reward him if he does right."

"Oh, a very wise man is Prince Kutuzov! I have known him a long
time!"

"They even say," remarked the "man of great merit" who did not yet
possess courtly tact, "that his excellency made it an express
condition that the sovereign himself should not be with the army."

As soon as he said this both Prince Vasili and Anna Pavlovna
turned away from him and glanced sadly at one another with a sigh at
his naivete.





CHAPTER VII


While this was taking place in Petersburg the French had already
passed Smolensk and were drawing nearer and nearer to Moscow.
Napoleon's historian Thiers, like other of his historians, trying to
justify his hero says that he was drawn to the walls of Moscow against
his will. He is as right as other historians who look for the
explanation of historic events in the will of one man; he is as
right as the Russian historians who maintain that Napoleon was drawn
to Moscow by the skill of the Russian commanders. Here besides the law
of retrospection, which regards all the past as a preparation for
events that subsequently occur, the law of reciprocity comes in,
confusing the whole matter. A good chessplayer having lost a game is
sincerely convinced that his loss resulted from a mistake he made
and looks for that mistake in the opening, but forgets that at each
stage of the game there were similar mistakes and that none of his
moves were perfect. He only notices the mistake to which he pays
attention, because his opponent took advantage of it. How much more
complex than this is the game of war, which occurs under certain
limits of time, and where it is not one will that manipulates lifeless
objects, but everything results from innumerable conflicts of
various wills!

After Smolensk Napoleon sought a battle beyond Dorogobuzh at Vyazma,
and then at Tsarevo-Zaymishche, but it happened that owing to a
conjunction of innumerable circumstances the Russians could not give
battle till they reached Borodino, seventy miles from Moscow. From
Vyazma Napoleon ordered a direct advance on Moscow.

Moscou, la capitale asiatique de ce grand empire, la ville sacree
des peuples d'Alexandre, Moscou avec ses innombrables eglises en forme
de pagodes chinoises,* this Moscow gave Napoleon's imagination no
rest. On the march from Vyazma to Tsarevo-Zaymishche he rode his light
bay bobtailed ambler accompanied by his Guards, his bodyguard, his
pages, and aides-de-camp. Berthier, his chief of staff, dropped behind
to question a Russian prisoner captured by the cavalry. Followed by
Lelorgne d'Ideville, an interpreter, he overtook Napoleon at a
gallop and reined in his horse with an amused expression.


*"Moscow, the Asiatic capital of this great empire, the sacred
city of Alexander's people, Moscow with its innumerable churches
shaped like Chinese pagodas."


"Well?" asked Napoleon.

"One of Platov's Cossacks says that Platov's corps is joining up
with the main army and that Kutuzov has been appointed commander in
chief. He is a very shrewd and garrulous fellow."

Napoleon smiled and told them to give the Cossack a horse and
bring the man to him. He wished to talk to him himself. Several
adjutants galloped off, and an hour later, Lavrushka, the serf Denisov
had handed over to Rostov, rode up to Napoleon in an orderly's
jacket and on a French cavalry saddle, with a merry, and tipsy face.
Napoleon told him to ride by his side and began questioning him.

"You are a Cossack?"

"Yes, a Cossack, your Honor."

"The Cossack, not knowing in what company he was, for Napoleon's
plain appearance had nothing about it that would reveal to an Oriental
mind the presence of a monarch, talked with extreme familiarity of the
incidents of the war," says Thiers, narrating this episode. In reality
Lavrushka, having got drunk the day before and left his master
dinnerless, had been whipped and sent to the village in quest of
chickens, where he engaged in looting till the French took him
prisoner. Lavrushka was one of those coarse, bare-faced lackeys who
have seen all sorts of things, consider it necessary to do
everything in a mean and cunning way, are ready to render any sort
of service to their master, and are keen at guessing their master's
baser impulses, especially those prompted by vanity and pettiness.

Finding himself in the company of Napoleon, whose identity he had
easily and surely recognized, Lavrushka was not in the least abashed
but merely did his utmost to gain his new master's favor.

He knew very well that this was Napoleon, but Napoleon's presence
could no more intimidate him than Rostov's, or a sergeant major's with
the rods, would have done, for he had nothing that either the sergeant
major or Napoleon could deprive him of.

So he rattled on, telling all the gossip he had heard among the
orderlies. Much of it true. But when Napoleon asked him whether the
Russians thought they would beat Bonaparte or not, Lavrushka screwed
up his eyes and considered.

In this question he saw subtle cunning, as men of his type see
cunning in everything, so he frowned and did not answer immediately.

"It's like this," he said thoughtfully, "if there's a battle soon,
yours will win. That's right. But if three days pass, then after that,
well, then that same battle will not soon be over."

Lelorgne d'Ideville smilingly interpreted this speech to Napoleon
thus: "If a battle takes place within the next three days the French
will win, but if later, God knows what will happen." Napoleon did
not smile, though he was evidently in high good humor, and he
ordered these words to be repeated.

Lavrushka noticed this and to entertain him further, pretending
not to know who Napoleon was, added:

"We know that you have Bonaparte and that he has beaten everybody in
the world, but we are a different matter..."--without knowing why or
how this bit of boastful patriotism slipped out at the end.

The interpreter translated these words without the last phrase,
and Bonaparte smiled. "The young Cossack made his mighty
interlocutor smile," says Thiers. After riding a few paces in silence,
Napoleon turned to Berthier and said he wished to see how the news
that he was talking to the Emperor himself, to that very Emperor who
had written his immortally victorious name on the Pyramids, would
affect this enfant du Don.*


*"Child of the Don."


The fact was accordingly conveyed to Lavrushka.

Lavrushka, understanding that this was done to perplex him and
that Napoleon expected him to be frightened, to gratify his new
masters promptly pretended to be astonished and awe-struck, opened his
eyes wide, and assumed the expression he usually put on when taken
to be whipped. "As soon as Napoleon's interpreter had spoken," says
Thiers, "the Cossack, seized by amazement, did not utter another word,
but rode on, his eyes fixed on the conqueror whose fame had reached
him across the steppes of the East. All his loquacity was suddenly
arrested and replaced by a naive and silent feeling of admiration.
Napoleon, after making the Cossack a present, had him set free like
a bird restored to its native fields."

Napoleon rode on, dreaming of the Moscow that so appealed to his
imagination, and "the bird restored to its native fields" galloped
to our outposts, inventing on the way all that had not taken place but
that he meant to relate to his comrades. What had really taken place
he did not wish to relate because it seemed to him not worth
telling. He found the Cossacks, inquired for the regiment operating
with Platov's detachment and by evening found his master, Nicholas
Rostov, quartered at Yankovo. Rostov was just mounting to go for a
ride round the neighboring villages with Ilyin; he let Lavrushka
have another horse and took him along with him.





CHAPTER VIII


Princess Mary was not in Moscow and out of danger as Prince Andrew
supposed.

After the return of Alpatych from Smolensk the old prince suddenly
seemed to awake as from a dream. He ordered the militiamen to be
called up from the villages and armed, and wrote a letter to the
commander in chief informing him that he had resolved to remain at
Bald Hills to the last extremity and to defend it, leaving to the
commander in chief's discretion to take measures or not for the
defense of Bald Hills, where one of Russia's oldest generals would
be captured or killed, and he announced to his household that he would
remain at Bald Hills.

But while himself remaining, he gave instructions for the
departure of the princess and Dessalles with the little prince to
Bogucharovo and thence to Moscow. Princess Mary, alarmed by her
father's feverish and sleepless activity after his previous apathy,
could not bring herself to leave him alone and for the first time in
her life ventured to disobey him. She refused to go away and her
father's fury broke over her in a terrible storm. He repeated every
injustice he had ever inflicted on her. Trying to convict her, he told
her she had worn him out, had caused his quarrel with his son, had
harbored nasty suspicions of him, making it the object of her life
to poison his existence, and he drove her from his study telling her
that if she did not go away it was all the same to him. He declared
that he did not wish to remember her existence and warned her not to
dare to let him see her. The fact that he did not, as she had
feared, order her to be carried away by force but only told her not to
let him see her cheered Princess Mary. She knew it was a proof that in
the depth of his soul he was glad she was remaining at home and had
not gone away.

The morning after little Nicholas had left, the old prince donned
his full uniform and prepared to visit the commander in chief. His
caleche was already at the door. Princess Mary saw him walk out of the
house in his uniform wearing all his orders and go down the garden
to review his armed peasants and domestic serfs. She sat by the window
listening to his voice which reached her from the garden. Suddenly
several men came running up the avenue with frightened faces.

Princess Mary ran out to the porch, down the flower-bordered path,
and into the avenue. A large crowd of militiamen and domestics were
moving toward her, and in their midst several men were supporting by
the armpits and dragging along a little old man in a uniform and
decorations. She ran up to him and, in the play of the sunlight that
fell in small round spots through the shade of the lime-tree avenue,
could not be sure what change there was in his face. All she could see
was that his former stern and determined expression had altered to one
of timidity and submission. On seeing his daughter he moved his
helpless lips and made a hoarse sound. It was impossible to make out
what he wanted. He was lifted up, carried to his study, and laid on
the very couch he had so feared of late.

The doctor, who was fetched that same night, bled him and said
that the prince had had a seizure paralyzing his right side.

It was becoming more and more dangerous to remain at Bald Hills, and
next day they moved the prince to Bogucharovo, the doctor accompanying
him.

By the time they reached Bogucharovo, Dessalles and the little
prince had already left for Moscow.

For three weeks the old prince lay stricken by paralysis in the
new house Prince Andrew had built at Bogucharovo, ever in the same
state, getting neither better nor worse. He was unconscious and lay
like a distorted corpse. He muttered unceasingly, his eyebrows and
lips twitching, and it was impossible to tell whether he understood
what was going on around him or not. One thing was certain--that he
was suffering and wished to say something. But what it was, no one
could tell: it might be some caprice of a sick and half-crazy man,
or it might relate to public affairs, or possibly to family concerns.

The doctor said this restlessness did not mean anything and was
due to physical causes; but Princess Mary thought he wished to tell
her something, and the fact that her presence always increased his
restlessness confirmed her opinion.

He was evidently suffering both physically and mentally. There was
no hope of recovery. It was impossible for him to travel, it would not
do to let him die on the road. "Would it not be better if the end
did come, the very end?" Princess Mary sometimes thought. Night and
day, hardly sleeping at all, she watched him and, terrible to say,
often watched him not with hope of finding signs of improvement but
wishing to find symptoms of the approach of the end.

Strange as it was to her to acknowledge this feeling in herself, yet
there it was. And what seemed still more terrible to her was that
since her father's illness began (perhaps even sooner, when she stayed
with him expecting something to happen), all the personal desires
and hopes that had been forgotten or sleeping within her had awakened.
Thoughts that had not entered her mind for years--thoughts of a life
free from the fear of her father, and even the possibility of love and
of family happiness--floated continually in her imagination like
temptations of the devil. Thrust them aside as she would, questions
continually recurred to her as to how she would order her life now,
after that. These were temptations of the devil and Princess Mary knew
it. She knew that the sole weapon against him was prayer, and she
tried to pray. She assumed an attitude of prayer, looked at the icons,
repeated the words of a prayer, but she could not pray. She felt
that a different world had now taken possession of her--the life of
a world of strenuous and free activity, quite opposed to the spiritual
world in which till now she had been confined and in which her
greatest comfort had been prayer. She could not pray, could not
weep, and worldly cares took possession of her.

It was becoming dangerous to remain in Bogucharovo. News of the
approach of the French came from all sides, and in one village, ten
miles from Bogucharovo, a homestead had been looted by French
marauders.

The doctor insisted on the necessity of moving the prince; the
provincial Marshal of the Nobility sent an official to Princess Mary
to persuade her to get away as quickly as possible, and the head of
the rural police having come to Bogucharovo urged the same thing,
saying that the French were only some twenty-five miles away, that
French proclamations were circulating in the villages, and that if the
princess did not take her father away before the fifteenth, he could
not answer for the consequences.

The princess decided to leave on the fifteenth. The cares of
preparation and giving orders, for which everyone came to her,
occupied her all day. She spent the night of the fourteenth as
usual, without undressing, in the room next to the one where the
prince lay. Several times, waking up, she heard his groans and
muttering, the creak of his bed, and the steps of Tikhon and the
doctor when they turned him over. Several times she listened at the
door, and it seemed to her that his mutterings were louder than
usual and that they turned him over oftener. She could not sleep and
several times went to the door and listened, wishing to enter but
not deciding to do so. Though he did not speak, Princess Mary saw
and knew how unpleasant every sign of anxiety on his account was to
him. She had noticed with what dissatisfaction he turned from the look
she sometimes involuntarily fixed on him. She knew that her going in
during the night at an unusual hour would irritate him.

But never had she felt so grieved for him or so much afraid of
losing him. She recalled all her life with him and in every word and
act of his found an expression of his love of her. Occasionally amid
these memories temptations of the devil would surge into her
imagination: thoughts of how things would be after his death, and
how her new, liberated life would be ordered. But she drove these
thoughts away with disgust. Toward morning he became quiet and she
fell asleep.

She woke late. That sincerity which often comes with waking showed
her clearly what chiefly concerned her about her father's illness.
On waking she listened to what was going on behind the door and,
hearing him groan, said to herself with a sigh that things were
still the same.

"But what could have happened? What did I want? I want his death!"
she cried with a feeling of loathing for herself.

She washed, dressed, said her prayers, and went out to the porch. In
front of it stood carriages without horses and things were being
packed into the vehicles.

It was a warm, gray morning. Princess Mary stopped at the porch,
still horrified by her spiritual baseness and trying to arrange her
thoughts before going to her father. The doctor came downstairs and
went out to her.

"He is a little better today," said he. "I was looking for you.
One can make out something of what he is saying. His head is
clearer. Come in, he is asking for you..."

Princess Mary's heart beat so violently at this news that she grew
pale and leaned against the wall to keep from falling. To see him,
talk to him, feel his eyes on her now that her whole soul was
overflowing with those dreadful, wicked temptations, was a torment
of joy and terror.

"Come," said the doctor.

Princess Mary entered her father's room and went up to his bed. He
was lying on his back propped up high, and his small bony hands with
their knotted purple veins were lying on the quilt; his left eye gazed
straight before him, his right eye was awry, and his brows and lips
motionless. He seemed altogether so thin, small, and pathetic. His
face seemed to have shriveled or melted; his features had grown
smaller. Princess Mary went up and kissed his hand. His left hand
pressed hers so that she understood that he had long been waiting
for her to come. He twitched her hand, and his brows and lips quivered
angrily.

She looked at him in dismay trying to guess what he wanted of her.
When she changed her position so that his left eye could see her
face he calmed down, not taking his eyes off her for some seconds.
Then his lips and tongue moved, sounds came, and he began to speak,
gazing timidly and imploringly at her, evidently afraid that she might
not understand.

Straining all her faculties Princess Mary looked at him. The comic
efforts with which he moved his tongue made her drop her eyes and with
difficulty repress the sobs that rose to her throat. He said
something, repeating the same words several times. She could not
understand them, but tried to guess what he was saying and inquiringly
repeated the words he uttered.

"Mmm...ar...ate...ate..." he repeated several times.

It was quite impossible to understand these sounds. The doctor
thought he had guessed them, and inquiringly repeated: "Mary, are
you afraid?" The prince shook his head, again repeated the same
sounds.

"My mind, my mind aches?" questioned Princess Mary.

He made a mumbling sound in confirmation of this, took her hand, and
began pressing it to different parts of his breast as if trying to
find the right place for it.

"Always thoughts... about you... thoughts..." he then uttered much
more clearly than he had done before, now that he was sure of being
understood.

Princess Mary pressed her head against his hand, trying to hide
her sobs and tears.

He moved his hand over her hair.

"I have been calling you all night..." he brought out.

"If only I had known..." she said through her tears. "I was afraid
to come in."

He pressed her hand.

"Weren't you asleep?"

"No, I did not sleep," said Princess Mary, shaking her head.

Unconsciously imitating her father, she now tried to express herself
as he did, as much as possible by signs, and her tongue too seemed
to move with difficulty.

"Dear one... Dearest..." Princess Mary could not quite make out what
he had said, but from his look it was clear that he had uttered a
tender caressing word such as he had never used to her before. "Why
didn't you come in?"

"And I was wishing for his death!" thought Princess Mary.

He was silent awhile.

"Thank you... daughter dear!... for all, for all... forgive!...
thank you!... forgive!... thank you!..." and tears began to flow
from his eyes. "Call Andrew!" he said suddenly, and a childish,
timid expression of doubt showed itself on his face as he spoke.

He himself seemed aware that his demand was meaningless. So at least
it seemed to Princess Mary.

"I have a letter from him," she replied.

He glanced at her with timid surprise.

"Where is he?"

"He's with the army, Father, at Smolensk."

He closed his eyes and remained silent a long time. Then as if in
answer to his doubts and to confirm the fact that now he understood
and remembered everything, he nodded his head and reopened his eyes.

"Yes," he said, softly and distinctly. "Russia has perished. They've
destroyed her."

And he began to sob, and again tears flowed from his eyes.
Princess Mary could no longer restrain herself and wept while she
gazed at his face.

Again he closed his eyes. His sobs ceased, he pointed to his eyes,
and Tikhon, understanding him, wiped away the tears.

Then he again opened his eyes and said something none of them
could understand for a long time, till at last Tikhon understood and
repeated it. Princess Mary had sought the meaning of his words in
the mood in which he had just been speaking. She thought he was
speaking of Russia, or Prince Andrew, of herself, of his grandson,
or of his own death, and so she could not guess his words.

"Put on your white dress. I like it," was what he said.

Having understood this Princess Mary sobbed still louder, and the
doctor taking her arm led her out to the veranda, soothing her and
trying to persuade her to prepare for her journey. When she had left
the room the prince again began speaking about his son, about the war,
and about the Emperor, angrily twitching his brows and raising his
hoarse voice, and then he had a second and final stroke.

Princess Mary stayed on the veranda. The day had cleared, it was hot
and sunny. She could understand nothing, think of nothing and feel
nothing, except passionate love for her father, love such as she
thought she had never felt till that moment. She ran out sobbing
into the garden and as far as the pond, along the avenues of young
lime trees Prince Andrew had planted.

"Yes... I... I... I wished for his death! Yes, I wanted it to end
quicker.... I wished to be at peace.... And what will become of me?
What use will peace be when he is no longer here?" Princess Mary
murmured, pacing the garden with hurried steps and pressing her
hands to her bosom which heaved with convulsive sobs.

When she had completed the tour of the garden, which brought her
again to the house, she saw Mademoiselle Bourienne--who had remained
at Bogucharovo and did not wish to leave it--coming toward her with
a stranger. This was the Marshal of the Nobility of the district,
who had come personally to point out to the princess the necessity for
her prompt departure. Princess Mary listened without understanding
him; she led him to the house, offered him lunch, and sat down with
him. Then, excusing herself, she went to the door of the old
prince's room. The doctor came out with an agitated face and said
she could not enter.

"Go away, Princess! Go away... go away!"

She returned to the garden and sat down on the grass at the foot
of the slope by the pond, where no one could see her. She did not know
how long she had been there when she was aroused by the sound of a
woman's footsteps running along the path. She rose and saw Dunyasha
her maid, who was evidently looking for her, and who stopped
suddenly as if in alarm on seeing her mistress.

"Please come, Princess... The Prince," said Dunyasha in a breaking
voice.

"Immediately, I'm coming, I'm coming!" replied the princess
hurriedly, not giving Dunyasha time to finish what she was saying, and
trying to avoid seeing the girl she ran toward the house.

"Princess, it's God's will! You must be prepared for everything,"
said the Marshal, meeting her at the house door.

"Let me alone; it's not true!" she cried angrily to him.

The doctor tried to stop her. She pushed him aside and ran to her
father's door. "Why are these people with frightened faces stopping
me? I don't want any of them! And what are they doing here?" she
thought. She opened the door and the bright daylight in that
previously darkened room startled her. In the room were her nurse
and other women. They all drew back from the bed, making way for
her. He was still lying on the bed as before, but the stern expression
of his quiet face made Princess Mary stop short on the threshold.

"No, he's not dead--it's impossible!" she told herself and
approached him, and repressing the terror that seized her, she pressed
her lips to his cheek. But she stepped back immediately. All the force
of the tenderness she had been feeling for him vanished instantly
and was replaced by a feeling of horror at what lay there before
her. "No, he is no more! He is not, but here where he was is something
unfamiliar and hostile, some dreadful, terrifying, and repellent
mystery!" And hiding her face in her hands, Princess Mary sank into
the arms of the doctor, who held her up.


In the presence of Tikhon and the doctor the women washed what had
been the prince, tied his head up with a handkerchief that the mouth
should not stiffen while open, and with another handkerchief tied
together the legs that were already spreading apart. Then they dressed
him in uniform with his decorations and placed his shriveled little
body on a table. Heaven only knows who arranged all this and when, but
it all got done as if of its own accord. Toward night candles were
burning round his coffin, a pall was spread over it, the floor was
strewn with sprays of juniper, a printed band was tucked in under
his shriveled head, and in a corner of the room sat a chanter
reading the psalms.

Just as horses shy and snort and gather about a dead horse, so the
inmates of the house and strangers crowded into the drawing room round
the coffin--the Marshal, the village Elder, peasant women--and all
with fixed and frightened eyes, crossing themselves, bowed and
kissed the old prince's cold and stiffened hand.





CHAPTER IX


Until Prince Andrew settled in Bogucharovo its owners had always
been absentees, and its peasants were of quite a different character
from those of Bald Hills. They differed from them in speech, dress,
and disposition. They were called steppe peasants. The old prince used
to approve of them for their endurance at work when they came to
Bald Hills to help with the harvest or to dig ponds, and ditches,
but he disliked them for their boorishness.

Prince Andrew's last stay at Bogucharovo, when he introduced
hospitals and schools and reduced the quitrent the peasants had to
pay, had not softened their disposition but had on the contrary
strengthened in them the traits of character the old prince called
boorishness. Various obscure rumors were always current among them: at
one time a rumor that they would all be enrolled as Cossacks; at
another of a new religion to which they were all to be converted; then
of some proclamation of the Tsar's and of an oath to the Tsar Paul
in 1797 (in connection with which it was rumored that freedom had been
granted them but the landowners had stopped it), then of Peter
Fedorovich's return to the throne in seven years' time, when
everything would be made free and so "simple" that there would be no
restrictions. Rumors of the war with Bonaparte and his invasion were
connected in their minds with the same sort of vague notions of
Antichrist, the end of the world, and "pure freedom."

In the vicinity of Bogucharovo were large villages belonging to
the crown or to owners whose serfs paid quitrent and could work
where they pleased. There were very few resident landlords in the
neighborhood and also very few domestic or literate serfs, and in
the lives of the peasantry of those parts the mysterious undercurrents
in the life of the Russian people, the causes and meaning of which are
so baffling to contemporaries, were more clearly and strongly
noticeable than among others. One instance, which had occurred some
twenty years before, was a movement among the peasants to emigrate
to some unknown "warm rivers." Hundreds of peasants, among them the
Bogucharovo folk, suddenly began selling their cattle and moving in
whole families toward the southeast. As birds migrate to somewhere
beyond the sea, so these men with their wives and children streamed to
the southeast, to parts where none of them had ever been. They set off
in caravans, bought their freedom one by one or ran away, and drove or
walked toward the "warm rivers." Many of them were punished, some sent
to Siberia, many died of cold and hunger on the road, many returned of
their own accord, and the movement died down of itself just as it
had sprung up, without apparent reason. But such undercurrents still
existed among the people and gathered new forces ready to manifest
themselves just as strangely, unexpectedly, and at the same time
simply, naturally, and forcibly. Now in 1812, to anyone living in
close touch with these people it was apparent that these undercurrents
were acting strongly and nearing an eruption.

Alpatych, who had reached Bogucharovo shortly before the old
prince's death, noticed an agitation among the peasants, and that
contrary to what was happening in the Bald Hills district, where
over a radius of forty miles all the peasants were moving away and
leaving their villages to be devastated by the Cossacks, the
peasants in the steppe region round Bogucharovo were, it was
rumored, in touch with the French, received leaflets from them that
passed from hand to hand, and did not migrate. He learned from
domestic serfs loyal to him that the peasant Karp, who possessed great
influence in the village commune and had recently been away driving
a government transport, had returned with news that the Cossacks
were destroying deserted villages, but that the French did not harm
them. Alpatych also knew that on the previous day another peasant
had even brought from the village of Visloukhovo, which was occupied
by the French, a proclamation by a French general that no harm would
be done to the inhabitants, and if they remained they would be paid
for anything taken from them. As proof of this the peasant had brought
from Visloukhovo a hundred rubles in notes (he did not know that
they were false) paid to him in advance for hay.

More important still, Alpatych learned that on the morning of the
very day he gave the village Elder orders to collect carts to move the
princess' luggage from Bogucharovo, there had been a village meeting
at which it had been decided not to move but to wait. Yet there was no
time to waste. On the fifteenth, the day of the old prince's death,
the Marshal had insisted on Princess Mary's leaving at once, as it was
becoming dangerous. He had told her that after the sixteenth he
could not be responsible for what might happen. On the evening of
the day the old prince died the Marshal went away, promising to return
next day for the funeral. But this he was unable to do, for he
received tidings that the French had unexpectedly advanced, and had
barely time to remove his own family and valuables from his estate.

For some thirty years Bogucharovo had been managed by the village
Elder, Dron, whom the old prince called by the diminutive "Dronushka."

Dron was one of those physically and mentally vigorous peasants
who grow big beards as soon as they are of age and go on unchanged
till they are sixty or seventy, without a gray hair or the loss of a
tooth, as straight and strong at sixty as at thirty.

Soon after the migration to the "warm rivers," in which he had taken
part like the rest, Dron was made village Elder and overseer of
Bogucharovo, and had since filled that post irreproachably for
twenty-three years. The peasants feared him more than they did their
master. The masters, both the old prince and the young, and the
steward respected him and jestingly called him "the Minister."
During the whole time of his service Dron had never been drunk or ill,
never after sleepless nights or the hardest tasks had he shown the
least fatigue, and though he could not read he had never forgotten a
single money account or the number of quarters of flour in any of
the endless cartloads he sold for the prince, nor a single shock of
the whole corn crop on any single acre of the Bogucharovo fields.

Alpatych, arriving from the devastated Bald Hills estate, sent for
his Dron on the day of the prince's funeral and told him to have
twelve horses got ready for the princess' carriages and eighteen carts
for the things to be removed from Bogucharovo. Though the peasants
paid quitrent, Alpatych thought no difficulty would be made about
complying with this order, for there were two hundred and thirty
households at work in Bogucharovo and the peasants were well to do.
But on hearing the order Dron lowered his eyes and remained silent.
Alpatych named certain peasants he knew, from whom he told him to take
the carts.

Dron replied that the horses of these peasants were away carting.
Alpatych named others, but they too, according to Dron, had no
horses available: some horses were carting for the government,
others were too weak, and others had died for want of fodder. It
seemed that no horses could be had even for the carriages, much less
for the carting.

Alpatych looked intently at Dron and frowned. Just as Dron was a
model village Elder, so Alpatych had not managed the prince's
estates for twenty years in vain. He a model steward, possessing in
the highest degree the faculty of divining the needs and instincts
of those he dealt with. Having glanced at Dron he at once understood
that his answers did not express his personal views but the general
mood of the Bogucharovo commune, by which the Elder had already been
carried away. But he also knew that Dron, who had acquired property
and was hated by the commune, must be hesitating between the two
camps: the masters' and the serfs'. He noticed this hesitation in
Dron's look and therefore frowned and moved closer up to him.

"Now just listen, Dronushka," said he. "Don't talk nonsense to me.
His excellency Prince Andrew himself gave me orders to move all the
people away and not leave them with the enemy, and there is an order
from the Tsar about it too. Anyone who stays is a traitor to the Tsar.
Do you hear?"

"I hear," Dron answered without lifting his eyes.

Alpatych was not satisfied with this reply.

"Eh, Dron, it will turn out badly!" he said, shaking his head.

"The power is in your hands," Dron rejoined sadly.

"Eh, Dron, drop it!" Alpatych repeated, withdrawing his hand from
his bosom and solemnly pointing to the floor at Dron's feet. "I can
see through you and three yards into the ground under you," he
continued, gazing at the floor in front of Dron.

Dron was disconcerted, glanced furtively at Alpatych and again
lowered his eyes.

"You drop this nonsense and tell the people to get ready to leave
their homes and go to Moscow and to get carts ready for tomorrow
morning for the princess' things. And don't go to any meeting
yourself, do you hear?"

Dron suddenly fell on his knees.

"Yakov Alpatych, discharge me! Take the keys from me and discharge
me, for Christ's sake!"

"Stop that!" cried Alpatych sternly. "I see through you and three
yards under you," he repeated, knowing that his skill in beekeeping,
his knowledge of the right time to sow the oats, and the fact that
he had been able to retain the old prince's favor for twenty years had
long since gained him the reputation of being a wizard, and that the
power of seeing three yards under a man is considered an attribute
of wizards.

Dron got up and was about to say something, but Alpatych interrupted
him.

"What is it you have got into your heads, eh?... What are you
thinking of, eh?"

"What am I to do with the people?" said Dron. "They're quite
beside themselves; I have already told them..."

"'Told them,' I dare say!" said Alpatych. "Are they drinking?" he
asked abruptly.

"Quite beside themselves, Yakov Alpatych; they've fetched another
barrel."

"Well, then, listen! I'll go to the police officer, and you tell
them so, and that they must stop this and the carts must be got
ready."

"I understand."

Alpatych did not insist further. He had managed people for a long
time and knew that the chief way to make them obey is to show no
suspicion that they can possibly disobey. Having wrung a submissive "I
understand" from Dron, Alpatych contented himself with that, though he
not only doubted but felt almost certain that without the help of
troops the carts would not be forthcoming.

And so it was, for when evening came no carts had been provided.
In the village, outside the drink shop, another meeting was being
held, which decided that the horses should be driven out into the
woods and the carts should not be provided. Without saying anything of
this to the princess, Alpatych had his own belongings taken out of the
carts which had arrived from Bald Hills and had those horses got ready
for the princess' carriages. Meanwhile he went himself to the police
authorities.





CHAPTER X


After her father's funeral Princess Mary shut herself up in her room
and did not admit anyone. A maid came to the door to say that Alpatych
was asking for orders about their departure. (This was before his talk
with Dron.) Princess Mary raised herself on the sofa on which she
had been lying and replied through the closed door that she did not
mean to go away and begged to be left in peace.

The windows of the room in which she was lying looked westward.
She lay on the sofa with her face to the wall, fingering the buttons
of the leather cushion and seeing nothing but that cushion, and her
confused thoughts were centered on one subject--the irrevocability
of death and her own spiritual baseness, which she had not
suspected, but which had shown itself during her father's illness. She
wished to pray but did not dare to, dared not in her present state
of mind address herself to God. She lay for a long time in that
position.

The sun had reached the other side of the house, and its slanting
rays shone into the open window, lighting up the room and part of
the morocco cushion at which Princess Mary was looking. The flow of
her thoughts suddenly stopped. Unconsciously she sat up, smoothed
her hair, got up, and went to the window, involuntarily inhaling the
freshness of the clear but windy evening.

"Yes, you can well enjoy the evening now! He is gone and no one will
hinder you," she said to herself, and sinking into a chair she let her
head fall on the window sill.

Someone spoke her name in a soft and tender voice from the garden
and kissed her head. She looked up. It was Mademoiselle Bourienne in a
black dress and weepers. She softly approached Princess Mary,
sighed, kissed her, and immediately began to cry. The princess
looked up at her. All their former disharmony and her own jealousy
recurred to her mind. But she remembered too how he had changed of
late toward Mademoiselle Bourienne and could not bear to see her,
thereby showing how unjust were the reproaches Princess Mary had
mentally addressed to her. "Besides, is it for me, for me who
desired his death, to condemn anyone?" she thought.

Princess Mary vividly pictured to herself the position of
Mademoiselle Bourienne, whom she had of late kept at a distance, but
who yet was dependent on her and living in her house. She felt sorry
for her and held out her hand with a glance of gentle inquiry.
Mademoiselle Bourienne at once began crying again and kissed that
hand, speaking of the princess' sorrow and making herself a partner in
it. She said her only consolation was the fact that the princess
allowed her to share her sorrow, that all the old misunderstandings
should sink into nothing but this great grief; that she felt herself
blameless in regard to everyone, and that he, from above, saw her
affection and gratitude. The princess heard her, not heeding her words
but occasionally looking up at her and listening to the sound of her
voice.

"Your position is doubly terrible, dear princess," said Mademoiselle
Bourienne after a pause. "I understand that you could not, and cannot,
think of yourself, but with my love for you I must do so.... Has
Alpatych been to you? Has he spoken to you of going away?" she asked.

Princess Mary did not answer. She did not understand who was to go
or where to. "Is it possible to plan or think of anything now? Is it
not all the same?" she thought, and did not reply.

"You know, chere Marie," said Mademoiselle Bourienne, "that we are
in danger--are surrounded by the French. It would be dangerous to move
now. If we go we are almost sure to be taken prisoners, and God
knows..."

Princess Mary looked at her companion without understanding what she
was talking about.

"Oh, if anyone knew how little anything matters to me now," she
said. "Of course I would on no account wish to go away from him....
Alpatych did say something about going.... Speak to him; I can do
nothing, nothing, and don't want to...."

"I've spoken to him. He hopes we should be in time to get away
tomorrow, but I think it would now be better to stay here," said
Mademoiselle Bourienne. "Because, you will agree, chere Marie, to fall
into the hands of the soldiers or of riotous peasants would be
terrible."

Mademoiselle Bourienne took from her reticule a proclamation (not
printed on ordinary Russian paper) of General Rameau's, telling people
not to leave their homes and that the French authorities would
afford them proper protection. She handed this to the princess.

"I think it would be best to appeal to that general," she continued,
"and and am sure that all due respect would be shown you."

Princess Mary read the paper, and her face began to quiver with
stifled sobs.

"From whom did you get this?" she asked.

"They probably recognized that I am French, by my name," replied
Mademoiselle Bourienne blushing.

Princess Mary, with the paper in her hand, rose from the window
and with a pale face went out of the room and into what had been
Prince Andrew's study.

"Dunyasha, send Alpatych, or Dronushka, or somebody to me!" she
said, "and tell Mademoiselle Bourienne not to come to me," she
added, hearing Mademoiselle Bourienne's voice. "We must go at once, at
once!" she said, appalled at the thought of being left in the hands of
the French.

"If Prince Andrew heard that I was in the power of the French!
That I, the daughter of Prince Nicholas Bolkonski, asked General
Rameau for protection and accepted his favor!" This idea horrified
her, made her shudder, blush, and feel such a rush of anger and
pride as she had never experienced before. All that was distressing,
and especially all that was humiliating, in her position rose
vividly to her mind. "They, the French, would settle in this house: M.
le General Rameau would occupy Prince Andrew's study and amuse himself
by looking through and reading his letters and papers. Mademoiselle
Bourienne would do the honors of Bogucharovo for him. I should be
given a small room as a favor, the soldiers would violate my
father's newly dug grave to steal his crosses and stars, they would
tell me of their victories over the Russians, and would pretend to
sympathize with my sorrow..." thought Princess Mary, not thinking
her own thoughts but feeling bound to think like her father and her
brother. For herself she did not care where she remained or what
happened to her, but she felt herself the representative of her dead
father and of Prince Andrew. Involuntarily she thought their
thoughts and felt their feelings. What they would have said and what
they would have done she felt bound to say and do. She went into
Prince Andrew's study, trying to enter completely into his ideas,
and considered her position.

The demands of life, which had seemed to her annihilated by her
father's death, all at once rose before her with a new, previously
unknown force and took possession of her.

Agitated and flushed she paced the room, sending now for Michael
Ivanovich and now for Tikhon or Dron. Dunyasha, the nurse, and the
other maids could not say in how far Mademoiselle Bourienne's
statement was correct. Alpatych was not at home, he had gone to the
police. Neither could the architect Michael Ivanovich, who on being
sent for came in with sleepy eyes, tell Princess Mary anything. With
just the same smile of agreement with which for fifteen years he had
been accustomed to answer the old prince without expressing views of
his own, he now replied to Princess Mary, so that nothing definite
could be got from his answers. The old valet Tikhon, with sunken,
emaciated face that bore the stamp of inconsolable grief, replied:
"Yes, Princess" to all Princess Mary's questions and hardly
refrained from sobbing as he looked at her.

At length Dron, the village Elder, entered the room and with a
deep bow to Princess Mary came to a halt by the doorpost.

Princess Mary walked up and down the room and stopped in front of
him.

"Dronushka," she said, regarding as a sure friend this Dronushka who
always used to bring a special kind of gingerbread from his visit to
the fair at Vyazma every year and smilingly offer it to her,
"Dronushka, now since our misfortune..." she began, but could not go
on.

"We are all in God's hands," said he, with a sigh.

They were silent for a while.

"Dronushka, Alpatych has gone off somewhere and I have no one to
turn to. Is true, as they tell me, that I can't even go away?"

"Why shouldn't you go away, your excellency? You can go," said Dron.

"I was told it would be dangerous because of the enemy. Dear friend,
I can do nothing. I understand nothing. I have nobody! I want to go
away tonight or early tomorrow morning."

Dron paused. He looked askance at Princess Mary and said: "There are
no horses; I told Yakov Alpatych so."

"Why are there none?" asked the princess.

"It's all God's scourge," said Dron. "What horses we had have been
taken for the army or have died--this is such a year! It's not a
case of feeding horses--we may die of hunger ourselves! As it is, some
go three days without eating. We've nothing, we've been ruined."

Princess Mary listened attentively to what he told her.

"The peasants are ruined? They have no bread?" she asked.

"They're dying of hunger," said Dron. "It's not a case of carting."

"But why didn't you tell me, Dronushka? Isn't it possible to help
them? I'll do all I can...."

To Princess Mary it was strange that now, at a moment when such
sorrow was filling her soul, there could be rich people and poor,
and the rich could refrain from helping the poor. She had heard
vaguely that there was such a thing as "landlord's corn" which was
sometimes given to the peasants. She also knew that neither her father
nor her brother would refuse to help the peasants in need, she only
feared to make some mistake in speaking about the distribution of
the grain she wished to give. She was glad such cares presented
themselves, enabling her without scruple to forget her own grief.
She began asking Dron about the peasants' needs and what there was
in Bogucharovo that belonged to the landlord.

"But we have grain belonging to my brother?" she said.

"The landlord's grain is all safe," replied Dron proudly. "Our
prince did not order it to be sold."

"Give it to the peasants, let them have all they need; I give you
leave in my brother's name," said she.

Dron made no answer but sighed deeply.

"Give them that corn if there is enough of it. Distribute it all.
I give this order in my brother's name; and tell them that what is
ours is theirs. We do not grudge them anything. Tell them so."

Dron looked intently at the princess while she was speaking.

"Discharge me, little mother, for God's sake! Order the keys to be
taken from me," said he. "I have served twenty-three years and have
done no wrong. Discharge me, for God's sake!"

Princess Mary did not understand what he wanted of her or why he was
asking to be discharged. She replied that she had never doubted his
devotion and that she was ready to do anything for him and for the
peasants.





CHAPTER XI


An hour later Dunyasha came to tell the princess that Dron had come,
and all the peasants had assembled at the barn by the princess'
order and wished to have word with their mistress.

"But I never told them to come," said Princess Mary. "I only told
Dron to let them have the grain."

"Only, for God's sake, Princess dear, have them sent away and
don't go out to them. It's all a trick," said Dunyasha, "and when
Yakov Alpatych returns let us get away... and please don't..."

"What is a trick?" asked Princess Mary in surprise.

"I know it is, only listen to me for God's sake! Ask nurse too. They
say they don't agree to leave Bogucharovo as you ordered."

"You're making some mistake. I never ordered them to go away,"
said Princess Mary. "Call Dronushka."

Dron came and confirmed Dunyasha's words; the peasants had come by
the princess' order.

"But I never sent for them," declared the princess. "You must have
given my message wrong. I only said that you were to give them the
grain."

Dron only sighed in reply.

"If you order it they will go away," said he.

"No, no. I'll go out to them," said Princess Mary, and in spite of
the nurse's and Dunyasha's protests she went out into the porch; Dron,
Dunyasha, the nurse, and Michael Ivanovich following her.

"They probably think I am offering them the grain to bribe them to
remain here, while I myself go away leaving them to the mercy of the
French," thought Princess Mary. "I will offer them monthly rations and
housing at our Moscow estate. I am sure Andrew would do even more in
my place," she thought as she went out in the twilight toward the
crowd standing on the pasture by the barn.

The men crowded closer together, stirred, and rapidly took off their
hats. Princess Mary lowered her eyes and, tripping over her skirt,
came close up to them. So many different eyes, old and young, were
fixed on her, and there were so many different faces, that she could
not distinguish any of them and, feeling that she must speak to them
all at once, did not know how to do it. But again the sense that she
represented her father and her brother gave her courage, and she
boldly began her speech.

"I am very glad you have come," she said without raising her eyes,
and feeling her heart beating quickly and violently. "Dronushka
tells me that the war has ruined you. That is our common misfortune,
and I shall grudge nothing to help you. I am myself going away because
it is dangerous here... the enemy is near... because... I am giving
you everything, my friends, and I beg you to take everything, all
our grain, so that you may not suffer want! And if you have been
told that I am giving you the grain to keep you here--that is not
true. On the contrary, I ask you to go with all your belongings to our
estate near Moscow, and I promise you I will see to it that there
you shall want for nothing. You shall be given food and lodging."

The princess stopped. Sighs were the only sound heard in the crowd.

"I am not doing this on my own account," she continued, "I do it
in the name of my dead father, who was a good master to you, and of my
brother and his son."

Again she paused. No one broke the silence.

"Ours is a common misfortune and we will share it together. All that
is mine is yours," she concluded, scanning the faces before her.

All eyes were gazing at her with one and the same expression. She
could not fathom whether it was curiosity, devotion, gratitude, or
apprehension and distrust--but the expression on all the faces was
identical.

"We are all very thankful for your bounty, but it won't do for us to
take the landlord's grain," said a voice at the back of the crowd.

"But why not?" asked the princess.

No one replied and Princess Mary, looking round at the crowd,
found that every eye she met now was immediately dropped.

"But why don't you want to take it?" she asked again.

No one answered.

The silence began to oppress the princess and she tried to catch
someone's eye.

"Why don't you speak?" she inquired of a very old man who stood just
in front of her leaning on his stick. "If you think something more
is wanted, tell me! I will do anything," said she, catching his eye.

But as if this angered him, he bent his head quite low and muttered:

"Why should we agree? We don't want the grain."

"Why should we give up everything? We don't agree. Don't agree....
We are sorry for you, but we're not willing. Go away yourself,
alone..." came from various sides of the crowd.

And again all the faces in that crowd bore an identical
expression, though now it was certainly not an expression of curiosity
or gratitude, but of angry resolve.

"But you can't have understood me," said Princess Mary with a sad
smile. "Why don't you want to go? I promise to house and feed you,
while here the enemy would ruin you..."

But her voice was drowned by the voices of the crowd.

"We're not willing. Let them ruin us! We won't take your grain. We
don't agree."

Again Princess Mary tried to catch someone's eye, but not a single
eye in the crowd was turned to her; evidently they were all trying
to avoid her look. She felt strange and awkward.

"Oh yes, an artful tale! Follow her into slavery! Pull down your
houses and go into bondage! I dare say! 'I'll give you grain, indeed!'
she says," voices in the crowd were heard saying.

With drooping head Princess Mary left the crowd and went back to the
house. Having repeated her order to Dron to have horses ready for
her departure next morning, she went to her room and remained alone
with her own thoughts.





CHAPTER XII


For a long time that night Princess Mary sat by the open window of
her room hearing the sound of the peasants' voices that reached her
from the village, but it was not of them she was thinking. She felt
that she could not understand them however much she might think
about them. She thought only of one thing, her sorrow, which, after
the break caused by cares for the present, seemed already to belong to
the past. Now she could remember it and weep or pray.

After sunset the wind had dropped. The night was calm and fresh.
Toward midnight the voices began to subside, a cock crowed, the full
moon began to show from behind the lime trees, a fresh white dewy mist
began to rise, and stillness reigned over the village and the house.

Pictures of the near past--her father's illness and last moments-
rose one after another to her memory. With mournful pleasure she now
lingered over these images, repelling with horror only the last one,
the picture of his death, which she felt she could not contemplate
even in imagination at this still and mystic hour of night. And
these pictures presented themselves to her so clearly and in such
detail that they seemed now present, now past, and now future.

She vividly recalled the moment when he had his first stroke and was
being dragged along by his armpits through the garden at Bald Hills,
muttering something with his helpless tongue, twitching his gray
eyebrows and looking uneasily and timidly at her.

"Even then he wanted to tell me what he told me the day he died,"
she thought. "He had always thought what he said then." And she
recalled in all its detail the night at Bald Hills before he had the
last stroke, when with a foreboding of disaster she had remained at
home against his will. She had not slept and had stolen downstairs
on tiptoe, and going to the door of the conservatory where he slept
that night had listened at the door. In a suffering and weary voice he
was saying something to Tikhon, speaking of the Crimea and its warm
nights and of the Empress. Evidently he had wanted to talk. "And why
didn't he call me? Why didn't he let me be there instead of Tikhon?"
Princess Mary had thought and thought again now. "Now he will never
tell anyone what he had in his soul. Never will that moment return for
him or for me when he might have said all he longed to say, and not
Tikhon but I might have heard and understood him. Why didn't I enter
the room?" she thought. "Perhaps he would then have said to me what he
said the day he died. While talking to Tikhon he asked about me twice.
He wanted to see me, and I was standing close by, outside the door. It
was sad and painful for him to talk to Tikhon who did not understand
him. I remember how he began speaking to him about Lise as if she were
alive--he had forgotten she was dead--and Tikhon reminded him that she
was no more, and he shouted, 'Fool!' He was greatly depressed. From
behind the door I heard how he lay down on his bed groaning and loudly
exclaimed, 'My God!' Why didn't I go in then? What could he have
done to me? What could I have lost? And perhaps he would then have
been comforted and would have said that word to me." And Princess Mary
uttered aloud the caressing word he had said to her on the day of
his death. "Dear-est!" she repeated, and began sobbing, with tears
that relieved her soul. She now saw his face before her. And not the
face she had known ever since she could remember and had always seen
at a distance, but the timid, feeble face she had seen for the first
time quite closely, with all its wrinkles and details, when she
stooped near to his mouth to catch what he said.

"Dear-est!" she repeated again.

"What was he thinking when he uttered that word? What is he thinking
now?" This question suddenly presented itself to her, and in answer
she saw him before her with the expression that was on his face as
he lay in his coffin with his chin bound up with a white handkerchief.
And the horror that had seized her when she touched him and
convinced herself that that was not he, but something mysterious and
horrible, seized her again. She tried to think of something else and
to pray, but could do neither. With wide-open eyes she gazed at the
moonlight and the shadows, expecting every moment to see his dead
face, and she felt that the silence brooding over the house and within
it held her fast.

"Dunyasha," she whispered. "Dunyasha!" she screamed wildly, and
tearing herself out of this silence she ran to the servants'
quarters to meet her old nurse and the maidservants who came running
toward her.





CHAPTER XIII


On the seventeenth of August Rostov and Ilyin, accompanied by
Lavrushka who had just returned from captivity and by an hussar
orderly, left their quarters at Yankovo, ten miles from Bogucharovo,
and went for a ride--to try a new horse Ilyin had bought and to find
out whether there was any hay to be had in the villages.

For the last three days Bogucharovo had lain between the two hostile
armies, so that it was as easy for the Russian rearguard to get to
it as for the French vanguard; Rostov, as a careful squadron
commander, wished to take such provisions as remained at Bogucharovo
before the French could get them.

Rostov and Ilyin were in the merriest of moods. On the way to
Bogucharovo, a princely estate with a dwelling house and farm where
they hoped to find many domestic serfs and pretty girls, they
questioned Lavrushka about Napoleon and laughed at his stories, and
raced one another to try Ilyin's horse.

Rostov had no idea that the village he was entering was the property
of that very Bolkonski who had been engaged to his sister.

Rostov and Ilyin gave rein to their horses for a last race along the
incline before reaching Bogucharovo, and Rostov, outstripping Ilyin,
was the first to gallop into the village street.

"You're first!" cried Ilyin, flushed.

"Yes, always first both on the grassland and here," answered Rostov,
stroking his heated Donets horse.

"And I'd have won on my Frenchy, your excellency," said Lavrushka
from behind, alluding to his shabby cart horse, "only I didn't wish to
mortify you."

They rode at a footpace to the barn, where a large crowd of peasants
was standing.

Some of the men bared their heads, others stared at the new arrivals
without doffing their caps. Two tall old peasants with wrinkled
faces and scanty beards emerged from the tavern, smiling,
staggering, and singing some incoherent song, and approached the
officers.

"Fine fellows!" said Rostov laughing. "Is there any hay here?"

"And how like one another," said Ilyin.

"A mo-o-st me-r-r-y co-o-m-pa...!" sang one of the peasants with a
blissful smile.

One of the men came out of the crowd and went up to Rostov.

"Who do you belong to?" he asked.

"The French," replied Ilyin jestingly, "and here is Napoleon
himself"--and he pointed to Lavrushka.

"Then you are Russians?" the peasant asked again.

"And is there a large force of you here?" said another, a short man,
coming up.

"Very large," answered Rostov. "But why have you collected here?" he
added. "Is it a holiday?"

"The old men have met to talk over the business of the commune,"
replied the peasant, moving away.

At that moment, on the road leading from the big house, two women
and a man in a white hat were seen coming toward the officers.

"The one in pink is mine, so keep off!" said Ilyin on seeing
Dunyasha running resolutely toward him.

"She'll be ours!" said Lavrushka to Ilyin, winking.

"What do you want, my pretty?" said Ilyin with a smile.

"The princess ordered me to ask your regiment and your name."

"This is Count Rostov, squadron commander, and I am your humble
servant."

"Co-o-om-pa-ny!" roared the tipsy peasant with a beatific smile as
he looked at Ilyin talking to the girl. Following Dunyasha, Alpatych
advanced to Rostov, having bared his head while still at a distance.

"May I make bold to trouble your honor?" said he respectfully, but
with a shade of contempt for the youthfulness of this officer and with
a hand thrust into his bosom. "My mistress, daughter of General in
Chief Prince Nicholas Bolkonski who died on the fifteenth of this
month, finding herself in difficulties owing to the boorishness of
these people"--he pointed to the peasants--"asks you to come up to the
house.... Won't you, please, ride on a little farther," said
Alpatych with a melancholy smile, "as it is not convenient in the
presence of...?" He pointed to the two peasants who kept as close to
him as horseflies to a horse.

"Ah!... Alpatych... Ah, Yakov Alpatych... Grand! Forgive us for
Christ's sake, eh?" said the peasants, smiling joyfully at him.

Rostov looked at the tipsy peasants and smiled.

"Or perhaps they amuse your honor?" remarked Alpatych with a staid
air, as he pointed at the old men with his free hand.

"No, there's not much to be amused at here," said Rostov, and rode
on a little way. "What's the matter?" he asked.

"I make bold to inform your honor that the rude peasants here
don't wish to let the mistress leave the estate, and threaten to
unharness her horses, so that though everything has been packed up
since morning, her excellency cannot get away."

"Impossible!" exclaimed Rostov.

"I have the honor to report to you the actual truth," said Alpatych.

Rostov dismounted, gave his horse to the orderly, and followed
Alpatych to the house, questioning him as to the state of affairs.
It appeared that the princess' offer of corn to the peasants the
previous day, and her talk with Dron and at the meeting, had
actually had so bad an effect that Dron had finally given up the
keys and joined the peasants and had not appeared when Alpatych sent
for him; and that in the morning when the princess gave orders to
harness for her journey, the peasants had come in a large crowd to the
barn and sent word that they would not let her leave the village: that
there was an order not to move, and that they would unharness the
horses. Alpatych had gone out to admonish them, but was told (it was
chiefly Karp who did the talking, Dron not showing himself in the
crowd) that they could not let the princess go, that there was an
order to the contrary, but that if she stayed they would serve her
as before and obey her in everything.

At the moment when Rostov and Ilyin were galloping along the road,
Princess Mary, despite the dissuasions of Alpatych, her nurse, and the
maids, had given orders to harness and intended to start, but when the
cavalrymen were espied they were taken for Frenchmen, the coachman ran
away, and the women in the house began to wail.

"Father! Benefactor! God has sent you!" exclaimed deeply moved
voices as Rostov passed through the anteroom.

Princess Mary was sitting helpless and bewildered in the large
sitting room, when Rostov was shown in. She could not grasp who he was
and why he had come, or what was happening to her. When she saw his
Russian face, and by his walk and the first words he uttered
recognized him as a man of her own class, she glanced at him with
her deep radiant look and began speaking in a voice that faltered
and trembled with emotion. This meeting immediately struck Rostov as a
romantic event. "A helpless girl overwhelmed with grief, left to the
mercy of coarse, rioting peasants! And what a strange fate sent me
here! What gentleness and nobility there are in her features and
expression!" thought he as he looked at her and listened to her
timid story.

When she began to tell him that all this had happened the day
after her father's funeral, her voiced trembled. She turned away,
and then, as if fearing he might take her words as meant to move him
to pity, looked at him with an apprehensive glance of inquiry. There
were tears in Rostov's eyes. Princess Mary noticed this and glanced
gratefully at him with that radiant look which caused the plainness of
her face to be forgotten.

"I cannot express, Princess, how glad I am that I happened to ride
here and am able to show my readiness to serve you," said Rostov,
rising. "Go when you please, and I give you my word of honor that no
one shall dare to cause you annoyance if only you will allow me to act
as your escort." And bowing respectfully, as if to a lady of royal
blood, he moved toward the door.

Rostov's deferential tone seemed to indicate that though he would
consider himself happy to be acquainted with her, he did not wish to
take advantage of her misfortunes to intrude upon her.

Princess Mary understood this and appreciated his delicacy.

"I am very, very grateful to you," she said in French, "but I hope
it was all a misunderstanding and that no one is to blame for it." She
suddenly began to cry.

"Excuse me!" she said.

Rostov, knitting his brows, left the room with another low bow.





CHAPTER XIV


"Well, is she pretty? Ah, friend--my pink one is delicious; her
name is Dunyasha...."

But on glancing at Rostov's face Ilyin stopped short. He saw that
his hero and commander was following quite a different train of
thought.

Rostov glanced angrily at Ilyin and without replying strode off with
rapid steps to the village.

"I'll show them; I'll give it to them, the brigands!" said he to
himself.

Alpatych at a gliding trot, only just managing not to run, kept up
with him with difficulty.

"What decision have you been pleased to come to?" said he.

Rostov stopped and, clenching his fists, suddenly and sternly turned
on Alpatych.

"Decision? What decision? Old dotard!..." cried he. "What have you
been about? Eh? The peasants are rioting, and you can't manage them?
You're a traitor yourself! I know you. I'll flay you all alive!..."
And as if afraid of wasting his store of anger, he left Alpatych and
went rapidly forward. Alpatych, mastering his offended feelings,
kept pace with Rostov at a gliding gait and continued to impart his
views. He said the peasants were obdurate and that at the present
moment it would be imprudent to "overresist" them without an armed
force, and would it not be better first to send for the military?

"I'll give them armed force... I'll 'overresist' them!" uttered
Rostov meaninglessly, breathless with irrational animal fury and the
need to vent it.

Without considering what he would do he moved unconciously with
quick, resolute steps toward the crowd. And the nearer he drew to it
the more Alpatych felt that this unreasonable action might produce
good results. The peasants in the crowd were similarly impressed
when they saw Rostov's rapid, firm steps and resolute, frowning face.

After the hussars had come to the village and Rostov had gone to see
the princess, a certain confusion and dissension had arisen among
the crowd. Some of the peasants said that these new arrivals were
Russians and might take it amiss that the mistress was being detained.
Dron was of this opinion, but as soon as he expressed it Karp and
others attacked their ex-Elder.

"How many years have you been fattening on the commune?" Karp
shouted at him. "It's all one to you! You'll dig up your pot of
money and take it away with you.... What does it matter to you whether
our homes are ruined or not?"

"We've been told to keep order, and that no one is to leave their
homes or take away a single grain, and that's all about it!" cried
another.

"It was your son's turn to be conscripted, but no fear! You
begrudged your lump of a son," a little old man suddenly began
attacking Dron--"and so they took my Vanka to be shaved for a soldier!
But we all have to die."

"To be sure, we all have to die. I'm not against the commune,"
said Dron.

"That's it--not against it! You've filled your belly...."

The two tall peasants had their say. As soon as Rostov, followed
by Ilyin, Lavrushka, and Alpatych, came up to the crowd, Karp,
thrusting his fingers into his belt and smiling a little, walked to
the front. Dron on the contrary retired to the rear and the crowd drew
closer together.

"Who is your Elder here? Hey?" shouted Rostov, coming up to the
crowd with quick steps.

"The Elder? What do you want with him?..." asked Karp.

But before the words were well out of his mouth, his cap flew off
and a fierce blow jerked his head to one side.

"Caps off, traitors!" shouted Rostov in a wrathful voice. "Where's
the Elder?" he cried furiously.

"The Elder.... He wants the Elder!... Dron Zakharych, you!" meek and
flustered voices here and there were heard calling and caps began to
come off their heads.

"We don't riot, we're following the orders," declared Karp, and at
that moment several voices began speaking together.

"It's as the old men have decided--there's too many of you giving
orders."

"Arguing? Mutiny!... Brigands! Traitors!" cried Rostov unmeaningly
in a voice not his own, gripping Karp by the collar. "Bind him, bind
him!" he shouted, though there was no one to bind him but Lavrushka
and Alpatych.

Lavrushka, however, ran up to Karp and seized him by the arms from
behind.

"Shall I call up our men from beyond the hill?" he called out.

Alpatych turned to the peasants and ordered two of them by name to
come and bind Karp. The men obediently came out of the crowd and began
taking off their belts.

"Where's the Elder?" demanded Rostov in a loud voice.

With a pale and frowning face Dron stepped out of the crowd.

"Are you the Elder? Bind him, Lavrushka!" shouted Rostov, as if that
order, too, could not possibly meet with any opposition.

And in fact two more peasants began binding Dron, who took off his
own belt and handed it to them, as if to aid them.

"And you all listen to me!" said Rostov to the peasants. "Be off
to your houses at once, and don't let one of your voices be heard!"

"Why, we've not done any harm! We did it just out of foolishness.
It's all nonsense... I said then that it was not in order," voices
were heard bickering with one another.

"There! What did I say?" said Alpatych, coming into his own again.
"It's wrong, lads!"

 "All our stupidity, Yakov Alpatych," came the answers, and the
crowd began at once to disperse through the village.

The two bound men were led off to the master's house. The two
drunken peasants followed them.

"Aye, when I look at you!..." said one of them to Karp.

"How can one talk to the masters like that? What were you thinking
of, you fool?" added the other--"A real fool!"

Two hours later the carts were standing in the courtyard of the
Bogucharovo house. The peasants were briskly carrying out the
proprietor's goods and packing them on the carts, and Dron,
liberated at Princess Mary's wish from the cupboard where he had
been confined, was standing in the yard directing the men.

"Don't put it in so carelessly," said one of the peasants, a man
with a round smiling face, taking a casket from a housemaid. "You know
it has cost money! How can you chuck it in like that or shove it under
the cord where it'll get rubbed? I don't like that way of doing
things. Let it all be done properly, according to rule. Look here, put
it under the bast matting and cover it with hay--that's the way!"

"Eh, books, books!" said another peasant, bringing out Prince
Andrew's library cupboards. "Don't catch up against it! It's heavy,
lads--solid books."

"Yes, they worked all day and didn't play!" remarked the tall,
round-faced peasant gravely, pointing with a significant wink at the
dictionaries that were on the top.


Unwilling to obtrude himself on the princess, Rostov did not go back
to the house but remained in the village awaiting her departure.
When her carriage drove out of the house, he mounted and accompanied
her eight miles from Bogucharovo to where the road was occupied by our
troops. At the inn at Yankovo he respectfully took leave of her, for
the first time permitting himself to kiss her hand.

"How can you speak so!" he blushingly replied to Princess Mary's
expressions of gratitude for her deliverance, as she termed what had
occurred. "Any police officer would have done as much! If we had had
only peasants to fight, we should not have let the enemy come so far,"
said he with a sense of shame and wishing to change the subject. "I am
only happy to have had the opportunity of making your acquaintance.
Good-by, Princess. I wish you happiness and consolation and hope to
meet you again in happier circumstances. If you don't want to make
me blush, please don't thank me!"

But the princess, if she did not again thank him in words, thanked
him with the whole expression of her face, radiant with gratitude
and tenderness. She could not believe that there was nothing to
thank him for. On the contrary, it seemed to her certain that had he
not been there she would have perished at the hands of the mutineers
and of the French, and that he had exposed himself to terrible and
obvious danger to save her, and even more certain was it that he was a
man of lofty and noble soul, able to understand her position and her
sorrow. His kind, honest eyes, with the tears rising in them when
she herself had begun to cry as she spoke of her loss, did leave her
memory.

When she had taken leave of him and remained alone she suddenly felt
her eyes filling with tears, and then not for the first time the
strange question presented itself to her: did she love him?

On the rest of the way to Moscow, though the princess' position
was not a cheerful one, Dunyasha, who went with her in the carriage,
more than once noticed that her mistress leaned out of the window
and smiled at something with an expression of mingled joy and sorrow.

"Well, supposing I do love him?" thought Princess Mary.

Ashamed as she was of acknowledging to herself that she had fallen
in love with a man who would perhaps never love her, she comforted
herself with the thought that no one would ever know it and that she
would not be to blame if, without ever speaking of it to anyone, she
continued to the end of her life to love the man with whom she had
fallen in love for the first and last time in her life.

Sometimes when she recalled his looks, his sympathy, and his
words, happiness did not appear impossible to her. It was at those
moments that Dunyasha noticed her smiling as she looked out of the
carriage window.

"Was it not fate that brought him to Bogucharovo, and at that very
moment?" thought Princess Mary. "And that caused his sister to
refuse my brother?" And in all this Princess Mary saw the hand of
Providence.

The impression the princess made on Rostov was a very agreeable one.
To remember her gave him pleasure, and when his comrades, hearing of
his adventure at Bogucharovo, rallied him on having gone to look for
hay and having picked up one of the wealthiest heiresses in Russia, he
grew angry. It made him angry just because the idea of marrying the
gentle Princess Mary, who was attractive to him and had an enormous
fortune, had against his will more than once entered his head. For
himself personally Nicholas could not wish for a better wife: by
marrying her he would make the countess his mother happy, would be
able to put his father's affairs in order, and would even--he felt it-
ensure Princess Mary's happiness.

But Sonya? And his plighted word? That was why Rostov grew angry
when he was rallied about Princess Bolkonskaya.





CHAPTER XV


On receiving command of the armies Kutuzov remembered Prince
Andrew and sent an order for him to report at headquarters.

Prince Andrew arrived at Tsarevo-Zaymishche on the very day and at
the very hour that Kutuzov was reviewing the troops for the first
time. He stopped in the village at the priest's house in front of
which stood the commander in chief's carriage, and he sat down on
the bench at the gate awaiting his Serene Highness, as everyone now
called Kutuzov. From the field beyond the village came now sounds of
regimental music and now the roar of many voices shouting "Hurrah!" to
the new commander in chief. Two orderlies, a courier and a major-domo,
stood near by, some ten paces from Prince Andrew, availing
themselves of Kutuzov's absence and of the fine weather. A short,
swarthy lieutenant colonel of hussars with thick mustaches and
whiskers rode up to the gate and, glancing at Prince Andrew,
inquired whether his Serene Highness was putting up there and
whether he would soon be back.

Prince Andrew replied that he was not on his Serene Highness'
staff but was himself a new arrival. The lieutenant colonel turned
to a smart orderly, who, with the peculiar contempt with which a
commander in chief's orderly speaks to officers, replied:

"What? His Serene Highness? I expect he'll be here soon. What do you
want?"

The lieutenant colonel of hussars smiled beneath his mustache at the
orderly's tone, dismounted, gave his horse to a dispatch runner, and
approached Bolkonski with a slight bow. Bolkonski made room for him on
the bench and the lieutenant colonel sat down beside him.

"You're also waiting for the commander in chief?" said he. "They say
he weceives evewyone, thank God!... It's awful with those sausage
eaters! Ermolov had weason to ask to be pwomoted to be a German! Now
p'waps Wussians will get a look in. As it was, devil only knows what
was happening. We kept wetweating and wetweating. Did you take part in
the campaign?" he asked.

"I had the pleasure," replied Prince Andrew, "not only of taking
part in the retreat but of losing in that retreat all I held dear--not
to mention the estate and home of my birth--my father, who died of
grief. I belong to the province of Smolensk."

"Ah? You're Pwince Bolkonski? Vewy glad to make your acquaintance!
I'm Lieutenant Colonel Denisov, better known as 'Vaska,'" said
Denisov, pressing Prince Andrew's hand and looking into his face
with a particularly kindly attention. "Yes, I heard," said he
sympathetically, and after a short pause added: "Yes, it's Scythian
warfare. It's all vewy well--only not for those who get it in the
neck. So you are Pwince Andwew Bolkonski?" He swayed his head. "Vewy
pleased, Pwince, to make your acquaintance!" he repeated again,
smiling sadly, and he again pressed Prince Andrew's hand.

Prince Andrew knew Denisov from what Natasha had told him of her
first suitor. This memory carried him sadly and sweetly back to
those painful feelings of which he had not thought lately, but which
still found place in his soul. Of late he had received so many new and
very serious impressions--such as the retreat from Smolensk, his visit
to Bald Hills, and the recent news of his father's death--and had
experienced so many emotions, that for a long time past those memories
had not entered his mind, and now that they did, they did not act on
him with nearly their former strength. For Denisov, too, the
memories awakened by the name of Bolkonski belonged to a distant,
romantic past, when after supper and after Natasha's singing he had
proposed to a little girl of fifteen without realizing what he was
doing. He smiled at the recollection of that time and of his love
for Natasha, and passed at once to what now interested him
passionately and exclusively. This was a plan of campaign he had
devised while serving at the outposts during the retreat. He had
proposed that plan to Barclay de Tolly and now wished to propose it to
Kutuzov. The plan was based on the fact that the French line of
operation was too extended, and it proposed that instead of, or
concurrently with, action on the front to bar the advance of the
French, we should attack their line of communication. He began
explaining his plan to Prince Andrew.

"They can't hold all that line. It's impossible. I will undertake to
bweak thwough. Give me five hundwed men and I will bweak the line,
that's certain! There's only one way--guewilla warfare!"

Denisov rose and began gesticulating as he explained his plan to
Bolkonski. In the midst of his explanation shouts were heard from
the army, growing more incoherent and more diffused, mingling with
music and songs and coming from the field where the review was held.
Sounds of hoofs and shouts were nearing the village.

"He's coming! He's coming!" shouted a Cossack standing at the gate.

Bolkonski and Denisov moved to the gate, at which a knot of soldiers
(a guard of honor) was standing, and they saw Kutuzov coming down
the street mounted on a rather small sorrel horse. A huge suite of
generals rode behind him. Barclay was riding almost beside him, and
a crowd of officers ran after and around them shouting, "Hurrah!"

His adjutants galloped into the yard before him. Kutuzov was
impatiently urging on his horse, which ambled smoothly under his
weight, and he raised his hand to his white Horse Guard's cap with a
red band and no peak, nodding his head continually. When he came up to
the guard of honor, a fine set of Grenadiers mostly wearing
decorations, who were giving him the salute, he looked at them
silently and attentively for nearly a minute with the steady gaze of a
commander and then turned to the crowd of generals and officers
surrounding him. Suddenly his face assumed a subtle expression, he
shrugged his shoulders with an air of perplexity.

"And with such fine fellows to retreat and retreat! Well, good-by,
General," he added, and rode into the yard past Prince Andrew and
Denisov.

"Hurrah! hurrah! hurrah!" shouted those behind him.

Since Prince Andrew had last seen him Kutuzov had grown still more
corpulent, flaccid, and fat. But the bleached eyeball, the scar, and
the familiar weariness of his expression were still the same. He was
wearing the white Horse Guard's cap and a military overcoat with a
whip hanging over his shoulder by a thin strap. He sat heavily and
swayed limply on his brisk little horse.

"Whew... whew... whew!" he whistled just audibly as he rode into the
yard. His face expressed the relief of relaxed strain felt by a man
who means to rest after a ceremony. He drew his left foot out of the
stirrup and, lurching with his whole body and puckering his face
with the effort, raised it with difficulty onto the saddle, leaned
on his knee, groaned, and slipped down into the arms of the Cossacks
and adjutants who stood ready to assist him.

He pulled himself together, looked round, screwing up his eyes,
glanced at Prince Andrew, and, evidently not recognizing him, moved
with his waddling gait to the porch. "Whew... whew... whew!" he
whistled, and again glanced at Prince Andrew. As often occurs with old
men, it was only after some seconds that the impression produced by
Prince Andrew's face linked itself up with Kutuzov's remembrance of
his personality.

"Ah, how do you do, my dear prince? How do you do, my dear boy? Come
along..." said he, glancing wearily round, and he stepped onto the
porch which creaked under his weight.

He unbuttoned his coat and sat down on a bench in the porch.

"And how's your father?"

"I received news of his death, yesterday," replied Prince Andrew
abruptly.

Kutuzov looked at him with eyes wide open with dismay and then
took off his cap and crossed himself:

"May the kingdom of Heaven be his! God's will be done to us all!" He
sighed deeply, his whole chest heaving, and was silent for a while. "I
loved him and respected him, and sympathize with you with all my
heart."

He embraced Prince Andrew, pressing him to his fat breast, and for
some time did not let him go. When he released him Prince Andrew saw
that Kutuzov's flabby lips were trembling and that tears were in his
eyes. He sighed and pressed on the bench with both hands to raise
himself.

"Come! Come with me, we'll have a talk," said he.

But at that moment Denisov, no more intimidated by his superiors
than by the enemy, came with jingling spurs up the steps of the porch,
despite the angry whispers of the adjutants who tried to stop him.
Kutuzov, his hands still pressed on the seat, glanced at him glumly.
Denisov, having given his name, announced that he had to communicate
to his Serene Highness a matter of great importance for their
country's welfare. Kutuzov looked wearily at him and, lifting his
hands with a gesture of annoyance, folded them across his stomach,
repeating the words: "For our country's welfare? Well, what is it?
Speak!" Denisov blushed like a girl (it was strange to see the color
rise in that shaggy, bibulous, time-worn face) and boldly began to
expound his plan of cutting the enemy's lines of communication between
Smolensk and Vyazma. Denisov came from those parts and knew the
country well. His plan seemed decidedly a good one, especially from
the strength of conviction with which he spoke. Kutuzov looked down at
his own legs, occasionally glancing at the door of the adjoining hut
as if expecting something unpleasant to emerge from it. And from
that hut, while Denisov was speaking, a general with a portfolio under
his arm really did appear.

"What?" said Kutuzov, in the midst of Denisov's explanations, "are
you ready so soon?"

"Ready, your Serene Highness," replied the general.

Kutuzov swayed his head, as much as to say: "How is one man to
deal with it all?" and again listened to Denisov.

"I give my word of honor as a Wussian officer," said Denisov,
"that I can bweak Napoleon's line of communication!"

"What relation are you to Intendant General Kiril Andreevich
Denisov?" asked Kutuzov, interrupting him.

"He is my uncle, your Sewene Highness."

"Ah, we were friends," said Kutuzov cheerfully. "All right, all
right, friend, stay here at the staff and tomorrow we'll have a talk."

With a nod to Denisov he turned away and put out his hand for the
papers Konovnitsyn had brought him.

"Would not your Serene Highness like to come inside?" said the
general on duty in a discontented voice, "the plans must be examined
and several papers have to be signed."

An adjutant came out and announced that everything was in
readiness within. But Kutuzov evidently did not wish to enter that
room till he was disengaged. He made a grimace...

"No, tell them to bring a small table out here, my dear boy. I'll
look at them here," said he. "Don't go away," he added, turning to
Prince Andrew, who remained in the porch and listened to the general's
report.

While this was being given, Prince Andrew heard the whisper of a
woman's voice and the rustle of a silk dress behind the door.
Several times on glancing that way he noticed behind that door a
plump, rosy, handsome woman in a pink dress with a lilac silk kerchief
on her head, holding a dish and evidently awaiting the entrance of the
commander in chief. Kutuzov's adjutant whispered to Prince Andrew
that this was the wife of the priest whose home it was, and that she
intended to offer his Serene Highness bread and salt. "Her husband has
welcomed his Serene Highness with the cross at the church, and she
intends to welcome him in the house.... She's very pretty," added
the adjutant with a smile. At those words Kutuzov looked round. He was
listening to the general's report--which consisted chiefly of a
criticism of the position at Tsarevo-Zaymishche--as he had listened to
Denisov, and seven years previously had listened to the discussion
at the Austerlitz council of war. He evidently listened only because
he had ears which, though there was a piece of tow in one of them,
could not help hearing; but it was evident that nothing the general
could say would surprise or even interest him, that he knew all that
would be said beforehand, and heard it all only because he had to,
as one has to listen to the chanting of a service of prayer. All
that Denisov had said was clever and to the point. What the general
was saying was even more clever and to the point, but it was evident
that Kutuzov despised knowledge and cleverness, and knew of
something else that would decide the matter--something independent
of cleverness and knowledge. Prince Andrew watched the commander
in chief's face attentively, and the only expression he could see
there was one of boredom, curiosity as to the meaning of the
feminine whispering behind the door, and a desire to observe
propriety. It was evident that Kutuzov despised cleverness and
learning and even the patriotic feeling shown by Denisov, but despised
them not because of his own intellect, feelings, or knowledge--he
did not try to display any of these--but because of something else. He
despised them because of his old age and experience of life. The
only instruction Kutuzov gave of his own accord during that report
referred to looting by the Russian troops. At the end of the report
the general put before him for signature a paper relating to the
recovery of payment from army commanders for green oats mown down by
the soldiers, when landowners lodged petitions for compensation.

After hearing the matter, Kutuzov smacked his lips together and
shook his head.

"Into the stove... into the fire with it! I tell you once for all,
my dear fellow," said he, "into the fire with all such things! Let
them cut the crops and burn wood to their hearts' content. I don't
order it or allow it, but I don't exact compensation either. One can't
get on without it. 'When wood is chopped the chips will fly.'" He
looked at the paper again. "Oh, this German precision!" he muttered,
shaking his head.





CHAPTER XVI


"Well, that's all!" said Kutuzov as he signed the last of the
documents, and rising heavily and smoothing out the folds in his fat
white neck he moved toward the door with a more cheerful expression.

The priest's wife, flushing rosy red, caught up the dish she had
after all not managed to present at the right moment, though she had
so long been preparing for it, and with a low bow offered it to
Kutuzov.

He screwed up his eyes, smiled, lifted her chin with his hand, and
said:

"Ah, what a beauty! Thank you, sweetheart!"

He took some gold pieces from his trouser pocket and put them on the
dish for her. "Well, my dear, and how are we getting on?" he asked,
moving to the door of the room assigned to him. The priest's wife
smiled, and with dimples in her rosy cheeks followed him into the
room. The adjutant came out to the porch and asked Prince Andrew to
lunch with him. Half an hour later Prince Andrew was again called to
Kutuzov. He found him reclining in an armchair, still in the same
unbuttoned overcoat. He had in his hand a French book which he
closed as Prince Andrew entered, marking the place with a knife.
Prince Andrew saw by the cover that it was Les Chevaliers du Cygne
by Madame de Genlis.

"Well, sit down, sit down here. Let's have a talk," said Kutuzov.
"It's sad, very sad. But remember, my dear fellow, that I am a
father to you, a second father...."

Prince Andrew told Kutuzov all he knew of his father's death, and
what he had seen at Bald Hills when he passed through it.

"What... what they have brought us to!" Kutuzov suddenly cried in an
agitated voice, evidently picturing vividly to himself from Prince
Andrew's story the condition Russia was in. "But give me time, give me
time!" he said with a grim look, evidently not wishing to continue
this agitating conversation, and added: "I sent for you to keep you
with me."

"I thank your Serene Highness, but I fear I am no longer fit for the
staff," replied Prince Andrew with a smile which Kutuzov noticed.

Kutuzov glanced inquiringly at him.

"But above all," added Prince Andrew, "I have grown used to my
regiment, am fond of the officers, and I fancy the men also like me. I
should be sorry to leave the regiment. If I decline the honor of being
with you, believe me..."

A shrewd, kindly, yet subtly derisive expression lit up Kutuzov's
podgy face. He cut Bolkonski short.

"I am sorry, for I need you. But you're right, you're right! It's
not here that men are needed. Advisers are always plentiful, but men
are not. The regiments would not be what they are if the would-be
advisers served there as you do. I remember you at Austerlitz.... I
remember, yes, I remember you with the standard!" said Kutuzov, and
a flush of pleasure suffused Prince Andrew's face at this
recollection.

Taking his hand and drawing him downwards, Kutuzov offered his cheek
to be kissed, and again Prince Andrew noticed tears in the old man's
eyes. Though Prince Andrew knew that Kutuzov's tears came easily,
and that he was particularly tender to and considerate of him from a
wish to show sympathy with his loss, yet this reminder of Austerlitz
was both pleasant and flattering to him.

"Go your way and God be with you. I know your path is the path of
honor!" He paused. "I missed you at Bucharest, but I needed someone to
send." And changing the subject, Kutuzov began to speak of the Turkish
war and the peace that had been concluded. "Yes, I have been much
blamed," he said, "both for that war and the peace... but everything
came at the right time. Tout vient a point a celui qui sait attendre.*
And there were as many advisers there as here..." he went on,
returning to the subject of "advisers" which evidently occupied him.
"Ah, those advisers!" said he. "If we had listened to them all we
should not have made peace with Turkey and should not have been
through with that war. Everything in haste, but more haste, less
speed. Kamenski would have been lost if he had not died. He stormed
fortresses with thirty thousand men. It is not difficult to capture
a fortress but it is difficult to win a campaign. For that, storming
and attacking but patience and time are wanted. Kamenski sent soldiers
to Rustchuk, but I only employed these two things and took more
fortresses than Kamenski and made them but eat horseflesh!" He swayed
his head. "And the French shall too, believe me," he went on,
growing warmer and beating his chest, "I'll make them eat horseflesh!"
And tears again dimmed his eyes.


*"Everything comes in time to him who knows how to wait."


"But shan't we have to accept battle?" remarked Prince Andrew.

"We shall if everybody wants it; it can't be helped.... But
believe me, my dear boy, there is nothing stronger than those two:
patience and time, they will do it all. But the advisers n'entendent
pas de cette oreille, voila le mal.* Some want a thing--others
don't. What's one to do?" he asked, evidently expecting an answer.
"Well, what do you want us to do?" he repeated and his eye shone
with a deep, shrewd look. "I'll tell you what to do," he continued, as
Prince Andrew still did not reply: "I will tell you what to do, and
what I do. Dans le doute, mon cher," he paused, "abstiens-toi"*[2]--he
articulated the French proverb deliberately.


*"Don't see it that way, that's the trouble."

*[2] "When in doubt, my dear fellow, do nothing."


"Well, good-by, my dear fellow; remember that with all my heart I
share your sorrow, and that for you I am not a Serene Highness, nor
a prince, nor a commander in chief, but a father! If you want anything
come straight to me. Good-by, my dear boy."

Again he embraced and kissed Prince Andrew, but before the latter
had left the room Kutuzov gave a sigh of relief and went on with his
unfinished novel, Les Chevaliers du Cygne by Madame de Genlis.

Prince Andrew could not have explained how or why it was, but
after that interview with Kutuzov he went back to his regiment
reassured as to the general course of affairs and as to the man to
whom it had been entrusted. The more he realized the absence of all
personal motive in that old man--in whom there seemed to remain only
the habit of passions, and in place of an intellect (grouping events
and drawing conclusions) only the capacity calmly to contemplate the
course of events--the more reassured he was that everything would be
as it should. "He will not bring in any plan of his own. He will not
devise or undertake anything," thought Prince Andrew, "but he will
hear everything, remember everything, and put everything in its place.
He will not hinder anything useful nor allow anything harmful. He
understands that there is something stronger and more important than
his own will--the inevitable course of events, and he can see them and
grasp their significance, and seeing that significance can refrain
from meddling and renounce his personal wish directed to something
else. And above all," thought Prince Andrew, "one believes in him
because he's Russian, despite the novel by Genlis and the French
proverbs, and because his voice shook when he said: 'What they have
brought us to!' and had a sob in it when he said he would 'make them
eat horseflesh!'"

On such feelings, more or less dimly shared by all, the unanimity
and general approval were founded with which, despite court
influences, the popular choice of Kutuzov as commander in chief was
received.





CHAPTER XVII


After the Emperor had left Moscow, life flowed on there in its usual
course, and its course was so very usual that it was difficult to
remember the recent days of patriotic elation and ardor, hard to
believe that Russia was really in danger and that the members of the
English Club were also sons of the Fatherland ready to sacrifice
everything for it. The one thing that recalled the patriotic fervor
everyone had displayed during the Emperor's stay was the call for
contributions of men and money, a necessity that as soon as the
promises had been made assumed a legal, official form and became
unavoidable.

With the enemy's approach to Moscow, the Moscovites' view of their
situation did not grow more serious but on the contrary became even
more frivolous, as always happens with people who see a great danger
approaching. At the approach of danger there are always two voices
that speak with equal power in the human soul: one very reasonably
tells a man to consider the nature of the danger and the means of
escaping it; the other, still more reasonably, says that it is too
depressing and painful to think of the danger, since it is not in
man's power to foresee everything and avert the general course of
events, and it is therefore better to disregard what is painful till
it comes, and to think about what is pleasant. In solitude a man
generally listens to the first voice, but in society to the second. So
it was now with the inhabitants of Moscow. It was long since people
had been as gay in Moscow as that year.

Rostopchin's broadsheets, headed by woodcuts of a drink shop, a
potman, and a Moscow burgher called Karpushka Chigirin, "who--having
been a militiaman and having had rather too much at the pub--heard
that Napoleon wished to come to Moscow, grew angry, abused the
French in very bad language, came out of the drink shop, and, under
the sign of the eagle, began to address the assembled people," were
read and discussed, together with the latest of Vasili Lvovich
Pushkin's bouts rimes.

In the corner room at the Club, members gathered to read these
broadsheets, and some liked the way Karpushka jeered at the French,
saying: "They will swell up with Russian cabbage, burst with our
buckwheat porridge, and choke themselves with cabbage soup. They are
all dwarfs and one peasant woman will toss three of them with a
hayfork." Others did not like that tone and said it was stupid and
vulgar. It was said that Rostopchin had expelled all Frenchmen and
even all foreigners from Moscow, and that there had been some spies
and agents of Napoleon among them; but this was told chiefly to
introduce Rostopchin's witty remark on that occasion. The foreigners
were deported to Nizhni by boat, and Rostopchin had said to them in
French: "Rentrez en vousmemes; entrez dans la barque, et n'en faites
pas une barque de Charon."* There was talk of all the government
offices having been already removed from Moscow, and to this
Shinshin's witticism was added--that for that alone Moscow ought to be
grateful to Napoleon. It was said that Mamonov's regiment would cost
him eight hundred thousand rubles, and that Bezukhov had spent even
more on his, but that the best thing about Bezukhov's action was
that he himself was going to don a uniform and ride at the head of his
regiment without charging anything for the show.


*"Think it over; get into the barque, and take care not to make it a
barque of Charon."


"You don't spare anyone," said Julie Drubetskaya as she collected
and pressed together a bunch of raveled lint with her thin, beringed
fingers.

Julie was preparing to leave Moscow next day and was giving a
farewell soiree.

"Bezukhov est ridicule, but he is so kind and good-natured. What
pleasure is there to be so caustique?"

"A forfeit!" cried a young man in militia uniform whom Julie
called "mon chevalier," and who was going with her to Nizhni.

In Julie's set, as in many other circles in Moscow, it had been
agreed that they would speak nothing but Russian and that those who
made a slip and spoke French should pay fines to the Committee of
Voluntary Contributions.

"Another forfeit for a Gallicism," said a Russian writer who was
present. "'What pleasure is there to be' is not Russian!"

"You spare no one," continued Julie to the young man without heeding
the author's remark.

"For caustique--I am guilty and will pay, and I am prepared to pay
again for the pleasure of telling you the truth. For Gallicisms I
won't be responsible," she remarked, turning to the author: "I have
neither the money nor the time, like Prince Galitsyn, to engage a
master to teach me Russian!"

"Ah, here he is!" she added. "Quand on... No, no," she said to the
militia officer, "you won't catch me. Speak of the sun and you see its
rays!" and she smiled amiably at Pierre. "We were just talking of
you," she said with the facility in lying natural to a society
woman. "We were saying that your regiment would be sure to be better
than Mamonov's."

"Oh, don't talk to me of my regiment," replied Pierre, kissing his
hostess' hand and taking a seat beside her. "I am so sick of it."

"You will, of course, command it yourself?" said Julie, directing
a sly, sarcastic glance toward the militia officer.

The latter in Pierre's presence had ceased to be caustic, and his
face expressed perplexity as to what Julie's smile might mean. In
spite of his absent-mindedness and good nature, Pierre's personality
immediately checked any attempt to ridicule him to his face.

"No," said Pierre, with a laughing glance at his big, stout body. "I
should make too good a target for the French, besides I am afraid I
should hardly be able to climb onto a horse."

Among those whom Julie's guests happened to choose to gossip about
were the Rostovs.

"I hear that their affairs are in a very bad way," said Julie.
"And he is so unreasonable, the count himself I mean. The
Razumovskis wanted to buy his house and his estate near Moscow, but it
drags on and on. He asks too much."

"No, I think the sale will come off in a few days," said someone.
"Though it is madness to buy anything in Moscow now."

"Why?" asked Julie. "You don't think Moscow is in danger?"

"Then why are you leaving?"

"I? What a question! I am going because... well, because everyone is
going: and besides--I am not Joan of Arc or an Amazon."

"Well, of course, of course! Let me have some more strips of linen."

"If he manages the business properly he will be able to pay off
all his debts," said the militia officer, speaking of Rostov.

"A kindly old man but not up to much. And why do they stay on so
long in Moscow? They meant to leave for the country long ago.
Natalie is quite well again now, isn't she?" Julie asked Pierre with a
knowing smile.

"They are waiting for their younger son," Pierre replied. "He joined
Obolenski's Cossacks and went to Belaya Tserkov where the regiment
is being formed. But now they have had him transferred to my
regiment and are expecting him every day. The count wanted to leave
long ago, but the countess won't on any account leave Moscow till
her son returns."

"I met them the day before yesterday at the Arkharovs'. Natalie
has recovered her looks and is brighter. She sang a song. How easily
some people get over everything!"

"Get over what?" inquired Pierre, looking displeased.

Julie smiled.

"You know, Count, such knights as you are only found in Madame de
Souza's novels."

"What knights? What do you mean?" demanded Pierre, blushing.

"Oh, come, my dear count! C'est la fable de tout Moscou. Je vous
admire, ma parole d'honneur!"*


*"It is the talk of all Moscow. My word, I admire you!"


"Forfeit, forfeit!" cried the militia officer.

"All right, one can't talk--how tiresome!"

"What is 'the talk of all Moscow'?" Pierre asked angrily, rising
to his feet.

"Come now, Count, you know!"

"I don't know anything about it," said Pierre.

"I know you were friendly with Natalie, and so... but I was always
more friendly with Vera--that dear Vera."

"No, madame!" Pierre continued in a tone of displeasure, "I have not
taken on myself the role of Natalie Rostova's knight at all, and
have not been their house for nearly a month. But I cannot
understand the cruelty..."

"Qui s'excuse s'accuse,"* said Julie, smiling and waving the lint
triumphantly, and to have the last word she promptly changed the
subject. "Do you know what I heard today? Poor Mary Bolkonskaya
arrived in Moscow yesterday. Do you know that she has lost her
father?"


*"Who excuses himself, accuses himself."


"Really? Where is she? I should like very much to see her," said
Pierre.

"I spent the evening with her yesterday. She is going to their
estate near Moscow either today or tomorrow morning, with her nephew."

"Well, and how is she?" asked Pierre.

"She is well, but sad. But do you know who rescued her? It is
quite a romance. Nicholas Rostov! She was surrounded, and they
wanted to kill her and had wounded some of her people. He rushed in
and saved her...."

"Another romance," said the militia officer. "Really, this general
flight has been arranged to get all the old maids married off. Catiche
is one and Princess Bolkonskaya another."

"Do you know, I really believe she is un petit peu amoureuse du
jeune homme."*


*"A little bit in love with the young man."


"Forfeit, forfeit, forfeit!"

"But how could one say that in Russian?"





CHAPTER XVIII


When Pierre returned home he was handed two of Rostopchin's
broadsheets that had been brought that day.

The first declared that the report that Count Rostopchin had
forbidden people to leave Moscow was false; on the contrary he was
glad that ladies and tradesmen's wives were leaving the city. "There
will be less panic and less gossip," ran the broadsheet "but I will
stake my life on it that that will not enter Moscow." These words
showed Pierre clearly for the first time that the French would enter
Moscow. The second broadsheet stated that our headquarters were at
Vyazma, that Count Wittgenstein had defeated the French, but that as
many of the inhabitants of Moscow wished to be armed, weapons were
ready for them at the arsenal: sabers, pistols, and muskets which
could be had at a low price. The tone of the proclamation was not as
jocose as in the former Chigirin talks. Pierre pondered over these
broadsheets. Evidently the terrible stormcloud he had desired with the
whole strength of his soul but which yet aroused involuntary horror in
him was drawing near.

"Shall I join the army and enter the service, or wait?" he asked
himself for the hundredth time. He took a pack of cards that lay on
the table and began to lay them out for a game of patience.

"If this patience comes out," he said to himself after shuffling the
cards, holding them in his hand, and lifting his head, "if it comes
out, it means... what does it mean?"

He had not decided what it should mean when he heard the voice of
the eldest princess at the door asking whether she might come in.

"Then it will mean that I must go to the army," said Pierre to
himself. "Come in, come in!" he added to the princess.

Only the eldest princess, the one with the stony face and long
waist, was still living in Pierre's house. The two younger ones had
both married.

"Excuse my coming to you, cousin," she said in a reproachful and
agitated voice. "You know some decision must be come to. What is going
to happen? Everyone has left Moscow and the people are rioting. How is
it that we are staying on?"

"On the contrary, things seem satisfactory, ma cousine," said Pierre
in the bantering tone he habitually adopted toward her, always feeling
uncomfortable in the role of her benefactor.

"Satisfactory, indeed! Very satisfactory! Barbara Ivanovna told me
today how our troops are distinguishing themselves. It certainly
does them credit! And the people too are quite mutinous--they no
longer obey, even my maid has taken to being rude. At this rate they
will soon begin beating us. One can't walk in the streets. But,
above all, the French will be here any day now, so what are we waiting
for? I ask just one thing of you, cousin," she went on, "arrange for
me to be taken to Petersburg. Whatever I may be, I can't live under
Bonaparte's rule."

"Oh, come, ma cousine! Where do you get your information from? On
the contrary..."

"I won't submit to your Napoleon! Others may if they please.... If
you don't want to do this..."

"But I will, I'll give the order at once."

The princess was apparently vexed at not having anyone to be angry
with. Muttering to herself, she sat down on a chair.

"But you have been misinformed," said Pierre. "Everything is quiet
in the city and there is not the slightest danger. See! I've just been
reading..." He showed her the broadsheet. "Count Rostopchin writes
that he will stake his life on it that the enemy will not enter
Moscow."

"Oh, that count of yours!" said the princess malevolently. "He is
a hypocrite, a rascal who has himself roused the people to riot.
Didn't he write in those idiotic broadsheets that anyone, 'whoever
it might be, should be dragged to the lockup by his hair'? (How
silly!) 'And honor and glory to whoever captures him,' he says. This
is what his cajolery has brought us to! Barbara Ivanovna told me the
mob near killed her because she said something in French."

"Oh, but it's so... You take everything so to heart," said Pierre,
and began laying out his cards for patience.

Although that patience did come out, Pierre did not join the army,
but remained in deserted Moscow ever in the same state of agitation,
irresolution, and alarm, yet at the same time joyfully expecting
something terrible.

Next day toward evening the princess set off, and Pierre's head
steward came to inform him that the money needed for the equipment
of his regiment could not be found without selling one of the estates.
In general the head steward made out to Pierre that his project of
raising a regiment would ruin him. Pierre listened to him, scarcely
able to repress a smile.

"Well then, sell it," said he. "What's to be done? I can't draw back
now!"

The worse everything became, especially his own affairs, the
better was Pierre pleased and the more evident was it that the
catastrophe he expected was approaching. Hardly anyone he knew was
left in town. Julie had gone, and so had Princess Mary. Of his
intimate friends only the Rostovs remained, but he did not go to see
them.

To distract his thoughts he drove that day to the village of
Vorontsovo to see the great balloon Leppich was constructing to
destroy the foe, and a trial balloon that was to go up next day. The
balloon was not yet ready, but Pierre learned that it was being
constructed by the Emperor's desire. The Emperor had written to
Count Rostopchin as follows:


As soon as Leppich is ready, get together a crew of reliable and
intelligent men for his car and send a courier to General Kutuzov to
let him know. I have informed him of the matter.

Please impress upon Leppich to be very careful where he descends for
the first time, that he may not make a mistake and fall into the
enemy's hands. It is essential for him to combine his movements with
those of the commander in chief.


On his way home from Vorontsovo, as he was passing the Bolotnoe
Place Pierre, seeing a large crowd round the Lobnoe Place, stopped and
got out of his trap. A French cook accused of being a spy was being
flogged. The flogging was only just over, and the executioner was
releasing from the flogging bench a stout man with red whiskers, in
blue stockings and a green jacket, who was moaning piteously.
Another criminal, thin and pale, stood near. Judging by their faces
they were both Frenchmen. With a frightened and suffering look
resembling that on the thin Frenchman's face, Pierre pushed his way in
through the crowd.

"What is it? Who is it? What is it for?" he kept asking.

But the attention of the crowd--officials, burghers, shopkeepers,
peasants, and women in cloaks and in pelisses--was so eagerly centered
on what was passing in Lobnoe Place that no one answered him. The
stout man rose, frowned, shrugged his shoulders, and evidently
trying to appear firm began to pull on his jacket without looking
about him, but suddenly his lips trembled and he began to cry, in
the way full-blooded grown-up men cry, though angry with himself for
doing so. In the crowd people began talking loudly, to stifle their
feelings of pity as it seemed to Pierre.

"He's cook to some prince."

"Eh, mounseer, Russian sauce seems to be sour to a Frenchman... sets
his teeth on edge!" said a wrinkled clerk who was standing behind
Pierre, when the Frenchman began to cry.

The clerk glanced round, evidently hoping that his joke would be
appreciated. Some people began to laugh, others continued to watch
in dismay the executioner who was undressing the other man.

Pierre choked, his face puckered, and he turned hastily away, went
back to his trap muttering something to himself as he went, and took
his seat. As they drove along he shuddered and exclaimed several times
so audibly that the coachman asked him:

"What is your pleasure?"

"Where are you going?" shouted Pierre to the man, who was driving to
Lubyanka Street.

"To the Governor's, as you ordered," answered the coachman.

"Fool! Idiot!" shouted Pierre, abusing his coachman--a thing he
rarely did. "Home, I told you! And drive faster, blockhead!" "I must
get away this very day," he murmured to himself.

At the sight of the tortured Frenchman and the crowd surrounding the
Lobnoe Place, Pierre had so definitely made up his mind that he
could no longer remain in Moscow and would leave for the army that
very day that it seemed to him that either he had told the coachman
this or that the man ought to have known it for himself.

On reaching home Pierre gave orders to Evstafey--his head coachman
who knew everything, could do anything, and was known to all Moscow-
that he would leave that night for the army at Mozhaysk, and that
his saddle horses should be sent there. This could not all be arranged
that day, so on Evstafey's representation Pierre had to put off his
departure till next day to allow time for the relay horses to be
sent on in advance.

On the twenty-fourth the weather cleared up after a spell of rain,
and after dinner Pierre left Moscow. When changing horses that night
in Perkhushkovo, he learned that there had been a great battle that
evening. (This was the battle of Shevardino.) He was told that there
in Perkhushkovo the earth trembled from the firing, but nobody could
answer his questions as to who had won. At dawn next day Pierre was
approaching Mozhaysk.

Every house in Mozhaysk had soldiers quartered in it, and at the
hostel where Pierre was met by his groom and coachman there was no
room to be had. It was full of officers.

Everywhere in Mozhaysk and beyond it, troops were stationed or on
the march. Cossacks, foot and horse soldiers, wagons, caissons, and
cannon were everywhere. Pierre pushed forward as fast as he could, and
the farther he left Moscow behind and the deeper he plunged into
that sea of troops the more was he overcome by restless agitation
and a new and joyful feeling he had not experienced before. It was a
feeling akin to what he had felt at the Sloboda Palace during the
Emperor's visit--a sense of the necessity of undertaking something and
sacrificing something. He now experienced a glad consciousness that
everything that constitutes men's happiness--the comforts of life,
wealth, even life itself--is rubbish it is pleasant to throw away,
compared with something... With what? Pierre could not say, and he did
not try to determine for whom and for what he felt such particular
delight in sacrificing everything. He was not occupied with the
question of what to sacrifice for; the fact of sacrificing in itself
afforded him a new and joyous sensation.





CHAPTER XIX


On the twenty-fourth of August the battle of the Shevardino
Redoubt was fought, on the twenty-fifth not a shot was fired by either
side, and on the twenty-sixth the battle of Borodino itself took
place.

Why and how were the battles of Shevardino and Borodino given and
accepted? Why was the battle of Borodino fought? There was not the
least sense in it for either the French or the Russians. Its immediate
result for the Russians was, and was bound to be, that we were brought
nearer to the destruction of Moscow--which we feared more than
anything in the world; and for the French its immediate result was
that they were brought nearer to the destruction of their whole
army--which they feared more than anything in the world. What the
result must be was quite obvious, and yet Napoleon offered and Kutuzov
accepted that battle.

If the commanders had been guided by reason, it would seem that it
must have been obvious to Napoleon that by advancing thirteen
hundred miles and giving battle with a probability of losing a quarter
of his army, he was advancing to certain destruction, and it must have
been equally clear to Kutuzov that by accepting battle and risking the
loss of a quarter of his army he would certainly lose Moscow. For
Kutuzov this was mathematically clear, as it is that if when playing
draughts I have one man less and go on exchanging, I shall certainly
lose, and therefore should not exchange. When my opponent has
sixteen men and I have fourteen, I am only one eighth weaker than
he, but when I have exchanged thirteen more men he will be three times
as strong as I am.

Before the battle of Borodino our strength in proportion to the
French was about as five to six, but after that battle it was little
more than one to two: previously we had a hundred thousand against a
hundred and twenty thousand; afterwards little more than fifty
thousand against a hundred thousand. Yet the shrewd and experienced
Kutuzov accepted the battle, while Napoleon, who was said to be a
commander of genius, gave it, losing a quarter of his army and
lengthening his lines of communication still more. If it is said
that he expected to end the campaign by occupying Moscow as he had
ended a previous campaign by occupying Vienna, there is much
evidence to the contrary. Napoleon's historians themselves tell us
that from Smolensk onwards he wished to stop, knew the danger of his
extended position, and knew that the occupation of Moscow would not be
the end of the campaign, for he had seen at Smolensk the state in
which Russian towns were left to him, and had not received a single
reply to his repeated announcements of his wish to negotiate.

In giving and accepting battle at Borodino, Kutuzov acted
involuntarily and irrationally. But later on, to fit what had
occurred, the historians provided cunningly devised evidence of the
foresight and genius the generals who, of all the blind tools of
history were the most enslaved and involuntary.

The ancients have left us model heroic poems in which the heroes
furnish the whole interest of the story, and we are still unable to
accustom ourselves to the fact that for our epoch histories of that
kind are meaningless.

On the other question, how the battle of Borodino and the
preceding battle of Shevardino were fought, there also exists a
definite and well-known, but quite false, conception. All the
historians describe the affair as follows:

The Russian army, they say, in its retreat from Smolensk sought
out for itself the best position for a general engagement and found
such a position at Borodino.

The Russians, they say, fortified this position in advance on the
left of the highroad (from Moscow to Smolensk) and almost at a right
angle to it, from Borodino to Utitsa, at the very place where the
battle was fought.

In front of this position, they say, a fortified outpost was set
up on the Shevardino mound to observe the enemy. On the twenty-fourth,
we are told, Napoleon attacked this advanced post and took it, and, on
the twenty-sixth, attacked the whole Russian army, which was in
position on the field of Borodino.

So the histories say, and it is all quite wrong, as anyone who cares
to look into the matter can easily convince himself.

The Russians did not seek out the best position but, on the
contrary, during the retreat passed many positions better than
Borodino. They did not stop at any one of these positions because
Kutuzov did not wish to occupy a position he had not himself chosen,
because the popular demand for a battle had not yet expressed itself
strongly enough, and because Miloradovich had not yet arrived with the
militia, and for many other reasons. The fact is that other
positions they had passed were stronger, and that the position at
Borodino (the one where the battle was fought), far from being strong,
was no more a position than any other spot one might find in the
Russian Empire by sticking a pin into the map at hazard.

Not only did the Russians not fortify the position on the field of
Borodino to the left of, and at a right angle to, the highroad (that
is, the position on which the battle took place), but never till the
twenty-fifth of August, 1812, did they think that a battle might be
fought there. This was shown first by the fact that there were no
entrenchments there by the twenty fifth and that those begun on the
twenty-fifth and twenty-sixth were not completed, and secondly, by the
position of the Shevardino Redoubt. That redoubt was quite senseless
in front of the position where the battle was accepted. Why was it
more strongly fortified than any other post? And why were all
efforts exhausted and six thousand men sacrificed to defend it till
late at night on the twenty-fourth? A Cossack patrol would have
sufficed to observe the enemy. Thirdly, as proof that the position
on which the battle was fought had not been foreseen and that the
Shevardino Redoubt was not an advanced post of that position, we
have the fact that up to the twenty-fifth, Barclay de Tolly and
Bagration were convinced that the Shevardino Redoubt was the left
flank of the position, and that Kutuzov himself in his report, written
in hot haste after the battle, speaks of the Shevardino Redoubt as the
left flank of the position. It was much later, when reports on the
battle of Borodino were written at leisure, that the incorrect and
extraordinary statement was invented (probably to justify the mistakes
of a commander in chief who had to be represented as infallible)
that the Shevardino Redoubt was an advanced post--whereas in reality
it was simply a fortified point on the left flank--and that the battle
of Borodino was fought by us on an entrenched position previously
selected, where as it was fought on a quite unexpected spot which
was almost unentrenched.

The case was evidently this: a position was selected along the river
Kolocha--which crosses the highroad not at a right angle but at an
acute angle--so that the left flank was at Shevardino, the right flank
near the village of Novoe, and the center at Borodino at the
confluence of the rivers Kolocha and Voyna.

To anyone who looks at the field of Borodino without thinking of how
the battle was actually fought, this position, protected by the
river Kolocha, presents itself as obvious for an army whose object was
to prevent an enemy from advancing along the Smolensk road to Moscow.

Napoleon, riding to Valuevo on the twenty-fourth, did not see (as
the history books say he did) the position of the Russians from Utitsa
to Borodino (he could not have seen that position because it did not
exist), nor did he see an advanced post of the Russian army, but while
pursuing the Russian rearguard he came upon the left flank of the
Russian position--at the Shevardino Redoubt--and unexpectedly for
the Russians moved his army across the Kolocha. And the Russians,
not having time to begin a general engagement, withdrew their left
wing from the position they had intended to occupy and took up a new
position which had not been foreseen and was not fortified. By
crossing to the other side of the Kolocha to the left of the highroad,
Napoleon shifted the whole forthcoming battle from right to left
(looking from the Russian side) and transferred it to the plain
between Utitsa, Semenovsk, and Borodino--a plain no more
advantageous as a position than any other plain in Russia--and there
the whole battle of the twenty-sixth of August took place.

Had Napoleon not ridden out on the evening of the twenty-fourth to
the Kolocha, and had he not then ordered an immediate attack on the
redoubt but had begun the attack next morning, no one would have
doubted that the Shevardino Redoubt was the left flank of our and
the battle would have taken place where we expected it. In that case
we should probably have defended the Shevardino Redoubt--our left
flank--still more obstinately. We should have attacked Napoleon in the
center or on the right, and the engagement would have taken place on
the twenty-fifth, in the position we intended and had fortified. But
as the attack on our left flank took place in the evening after the
retreat of our rear guard (that is, immediately after the fight at
Gridneva), and as the Russian commanders did not wish, or were not
in time, to begin a general engagement then on the evening of the
twenty-fourth, the first and chief action of the battle of Borodino
was already lost on the twenty-fourth, and obviously led to the loss
of the one fought on the twenty-sixth.

After the loss of the Shevardino Redoubt, we found ourselves on
the morning of the twenty-fifth without a position for our left flank,
and were forced to bend it back and hastily entrench it where it
chanced to be.

Not only was the Russian army on the twenty-sixth defended by
weak, unfinished entrenchments, but the disadvantage of that
position was increased by the fact that the Russian commanders--not
having fully realized what had happened, namely the loss of our
position on the left flank and the shifting of the whole field of
the forthcoming battle from right to left--maintained their extended
position from the village of Novoe to Utitsa, and consequently had
to move their forces from right to left during the battle. So it
happened that throughout the whole battle the Russians opposed the
entire French army launched against our left flank with but half as
many men. (Poniatowski's action against Utitsa, and Uvarov's on the
right flank against the French, were actions distinct from the main
course of the battle.) So the battle of Borodino did not take place at
all as (in an effort to conceal our commanders' mistakes even at the
cost of diminishing the glory due to the Russian army and people) it
has been described. The battle of Borodino was not fought on a
chosen and entrenched position with forces only slightly weaker than
those of the enemy, but, as a result of the loss of the Shevardino
Redoubt, the Russians fought the battle of Borodino on an open and
almost unentrenched position, with forces only half as numerous as the
French; that is to say, under conditions in which it was not merely
unthinkable to fight for ten hours and secure an indecisive result,
but unthinkable to keep an army even from complete disintegration
and flight.





CHAPTER XX


On the morning of the twenty-fifth Pierre was leaving Mozhaysk. At
the descent of the high steep hill, down which a winding road led
out of the town past the cathedral on the right, where a service was
being held and the bells were ringing, Pierre got out of his vehicle
and proceeded on foot. Behind him a cavalry regiment was coming down
the hill preceded by its singers. Coming up toward him was a train
of carts carrying men who had been wounded in the engagement the day
before. The peasant drivers, shouting and lashing their horses, kept
crossing from side to side. The carts, in each of which three or
four wounded soldiers were lying or sitting, jolted over the stones
that had been thrown on the steep incline to make it something like
a road. The wounded, bandaged with rags, with pale cheeks,
compressed lips, and knitted brows, held on to the sides of the
carts as they were jolted against one another. Almost all of them
stared with naive, childlike curiosity at Pierre's white hat and green
swallow-tail coat.

Pierre's coachman shouted angrily at the convoy of wounded to keep
to one side of the road. The cavalry regiment, as it descended the
hill with its singers, surrounded Pierre's carriage and blocked the
road. Pierre stopped, being pressed against the side of the cutting in
which the road ran. The sunshine from behind the hill did not
penetrate into the cutting and there it was cold and damp, but above
Pierre's head was the bright August sunshine and the bells sounded
merrily. One of the carts with wounded stopped by the side of the road
close to Pierre. The driver in his bast shoes ran panting up to it,
placed a stone under one of its tireless hind wheels, and began
arranging the breech-band on his little horse.

One of the wounded, an old soldier with a bandaged arm who was
following the cart on foot, caught hold of it with his sound hand
and turned to look at Pierre.

"I say, fellow countryman! Will they set us down here or take us
on to Moscow?" he asked.

Pierre was so deep in thought that he did not hear the question.
He was looking now at the cavalry regiment that had met the convoy
of wounded, now at the cart by which he was standing, in which two
wounded men were sitting and one was lying. One of those sitting up in
the cart had probably been wounded in the cheek. His whole head was
wrapped in rags and one cheek was swollen to the size of a baby's
head. His nose and mouth were twisted to one side. This soldier was
looking at the cathedral and crossing himself. Another, a young lad, a
fair-haired recruit as white as though there was no blood in his
thin face, looked at Pierre kindly, with a fixed smile. The third
lay prone so that his face was not visible. The cavalry singers were
passing close by:

   Ah lost, quite lost... is my head so keen,
   Living in a foreign land.

they sang their soldiers' dance song.

As if responding to them but with a different sort of merriment, the
metallic sound of the bells reverberated high above and the hot rays
of the sun bathed the top of the opposite slope with yet another
sort of merriment. But beneath the slope, by the cart with the wounded
near the panting little nag where Pierre stood, it was damp, somber,
and sad.

The soldier with the swollen cheek looked angrily at the cavalry
singers.

"Oh, the coxcombs!" he muttered reproachfully.

"It's not the soldiers only, but I've seen peasants today, too....
The peasants--even they have to go," said the soldier behind the cart,
addressing Pierre with a sad smile. "No distinctions made nowadays....
They want the whole nation to fall on them--in a word, it's Moscow!
They want to make an end of it."

In spite of the obscurity of the soldier's words Pierre understood
what he wanted to say and nodded approval.

The road was clear again; Pierre descended the hill and drove on.

He kept looking to either side of the road for familiar faces, but
only saw everywhere the unfamiliar faces of various military men of
different branches of the service, who all looked with astonishment at
his white hat and green tail coat.

Having gone nearly three miles he at last met an acquaintance and
eagerly addressed him. This was one of the head army doctors. He was
driving toward Pierre in a covered gig, sitting beside a young
surgeon, and on recognizing Pierre he told the Cossack who occupied
the driver's seat to pull up.

"Count! Your excellency, how come you to be here?" asked the doctor.

"Well, you know, I wanted to see..."

"Yes, yes, there will be something to see...."

Pierre got out and talked to the doctor, explaining his intention of
taking part in a battle.

The doctor advised him to apply direct to Kutuzov.

"Why should you be God knows where out of sight, during the battle?"
he said, exchanging glances with his young companion. "Anyhow his
Serene Highness knows you and will receive you graciously. That's what
you must do."

The doctor seemed tired and in a hurry.

"You think so?... Ah, I also wanted to ask you where our position is
exactly?" said Pierre.

"The position?" repeated the doctor. "Well, that's not my line.
Drive past Tatarinova, a lot of digging is going on there. Go up the
hillock and you'll see."

"Can one see from there?... If you would..."

But the doctor interrupted him and moved toward his gig.

"I would go with you but on my honor I'm up to here"--and he pointed
to his throat. "I'm galloping to the commander of the corps. How do
matters stand?... You know, Count, there'll be a battle tomorrow.
Out of an army of a hundred thousand we must expect at least twenty
thousand wounded, and we haven't stretchers, or bunks, or dressers, or
doctors enough for six thousand. We have ten thousand carts, but we
need other things as well--we must manage as best we can!"

The strange thought that of the thousands of men, young and old, who
had stared with merry surprise at his hat (perhaps the very men he had
noticed), twenty thousand were inevitably doomed to wounds and death
amazed Pierre.

"They may die tomorrow; why are they thinking of anything but
death?" And by some latent sequence of thought the descent of the
Mozhaysk hill, the carts with the wounded, the ringing bells, the
slanting rays of the sun, and the songs of the cavalrymen vividly
recurred to his mind.

"The cavalry ride to battle and meet the wounded and do not for a
moment think of what awaits them, but pass by, winking at the wounded.
Yet from among these men twenty thousand are doomed to die, and they
wonder at my hat! Strange!" thought Pierre, continuing his way to
Tatarinova.

In front of a landowner's house to the left of the road stood
carriages, wagons, and crowds of orderlies and sentinels. The
commander in chief was putting up there, but just when Pierre
arrived he was not in and hardly any of the staff were there--they had
gone to the church service. Pierre drove on toward Gorki.

When he had ascended the hill and reached the little village street,
he saw for the first time peasant militiamen in their white shirts and
with crosses on their caps, who, talking and laughing loudly, animated
and perspiring, were at work on a huge knoll overgrown with grass to
the right of the road.

Some of them were digging, others were wheeling barrowloads of earth
along planks, while others stood about doing nothing.

Two officers were standing on the knoll, directing the men. On
seeing these peasants, who were evidently still amused by the
novelty of their position as soldiers, Pierre once more thought of the
wounded men at Mozhaysk and understood what the soldier had meant when
he said: "They want the whole nation to fall on them." The sight of
these bearded peasants at work on the battlefield, with their queer,
clumsy boots and perspiring necks, and their shirts opening from the
left toward the middle, unfastened, exposing their sunburned
collarbones, impressed Pierre more strongly with the solemnity and
importance of the moment than anything he had yet seen or heard.





CHAPTER XXI


Pierre stepped out of his carriage and, passing the toiling
militiamen, ascended the knoll from which, according to the doctor,
the battlefield could be seen.

It was about eleven o'clock. The sun shone somewhat to the left
and behind him and brightly lit up the enormous panorama which, rising
like an amphitheater, extended before him in the clear rarefied
atmosphere.

From above on the left, bisecting that amphitheater, wound the
Smolensk highroad, passing through a village with a white church
some five hundred paces in front of the knoll and below it. This was
Borodino. Below the village the road crossed the river by a bridge
and, winding down and up, rose higher and higher to the village of
Valuevo visible about four miles away, where Napoleon was then
stationed. Beyond Valuevo the road disappeared into a yellowing forest
on the horizon. Far in the distance in that birch and fir forest to
the right of the road, the cross and belfry of the Kolocha Monastery
gleamed in the sun. Here and there over the whole of that blue
expanse, to right and left of the forest and the road, smoking
campfires could be seen and indefinite masses of troops--ours and
the enemy's. The ground to the right--along the course of the
Kolocha and Moskva rivers--was broken and hilly. Between the hollows
the villages of Bezubova and Zakharino showed in the distance. On
the left the ground was more level; there were fields of grain, and
the smoking ruins of Semenovsk, which had been burned down, could be
seen.

All that Pierre saw was so indefinite that neither the left nor
the right side of the field fully satisfied his expectations.
Nowhere could he see the battlefield he had expected to find, but only
fields, meadows, troops, woods, the smoke of campfires, villages,
mounds, and streams; and try as he would he could descry no military
"position" in this place which teemed with life, nor could he even
distinguish our troops from the enemy's.

"I must ask someone who knows," he thought, and addressed an officer
who was looking with curiosity at his huge unmilitary figure.

"May I ask you," said Pierre, "what village that is in front?"

"Burdino, isn't it?" said the officer, turning to his companion.

"Borodino," the other corrected him.

The officer, evidently glad of an opportunity for a talk, moved up
to Pierre.

"Are those our men there?" Pierre inquired.

"Yes, and there, further on, are the French," said the officer.
"There they are, there... you can see them."

"Where? Where?" asked Pierre.

"One can see them with the naked eye... Why, there!"

The officer pointed with his hand to the smoke visible on the left
beyond the river, and the same stern and serious expression that
Pierre had noticed on many of the faces he had met came into his face.

"Ah, those are the French! And over there?..." Pierre pointed to a
knoll on the left, near which some troops could be seen.

"Those are ours."

"Ah, ours! And there?..." Pierre pointed to another knoll in the
distance with a big tree on it, near a village that lay in a hollow
where also some campfires were smoking and something black was
visible.

"That's his again," said the officer. (It was the Shevardino
Redoubt.) "It was ours yesterday, but now it is his."

"Then how about our position?"

"Our position?" replied the officer with a smile of satisfaction. "I
can tell you quite clearly, because I constructed nearly all our
entrenchments. There, you see? There's our center, at Borodino, just
there," and he pointed to the village in front of them with the
white church. "That's where one crosses the Kolocha. You see down
there where the rows of hay are lying in the hollow, there's the
bridge. That's our center. Our right flank is over there"--he
pointed sharply to the right, far away in the broken ground--"That's
where the Moskva River is, and we have thrown up three redoubts there,
very strong ones. The left flank..." here the officer paused. "Well,
you see, that's difficult to explain.... Yesterday our left flank
was there at Shevardino, you see, where the oak is, but now we have
withdrawn our left wing--now it is over there, do you see that village
and the smoke? That's Semenovsk, yes, there," he pointed to
Raevski's knoll. "But the battle will hardly be there. His having
moved his troops there is only a ruse; he will probably pass round
to the right of the Moskva. But wherever it may be, many a man will be
missing tomorrow!" he remarked.

An elderly sergeant who had approached the officer while he was
giving these explanations had waited in silence for him to finish
speaking, but at this point, evidently not liking the officer's
remark, interrupted him.

"Gabions must be sent for," said he sternly.

The officer appeared abashed, as though he understood that one might
think of how many men would be missing tomorrow but ought not to speak
to speak of it.

"Well, send number three company again," the officer replied
hurriedly.

"And you, are you one of the doctors?"

"No, I've come on my own," answered Pierre, and he went down the
hill again, passing the militiamen.

"Oh, those damned fellows!" muttered the officer who followed him,
holding his nose as he ran past the men at work.

"There they are... bringing her, coming... There they are... They'll
be here in a minute..." voices were suddenly heard saying; and
officers, soldiers, and militiamen began running forward along the
road.

A church procession was coming up the hill from Borodino. First
along the dusty road came the infantry in ranks, bareheaded and with
arms reversed. From behind them came the sound of church singing.

Soldiers and militiamen ran bareheaded past Pierre toward the
procession.

"They are bringing her, our Protectress!... The Iberian Mother of
God!" someone cried.

"The Smolensk Mother of God," another corrected him.

The militiamen, both those who had been in the village and those who
had been at work on the battery, threw down their spades and ran to
meet the church procession. Following the battalion that marched along
the dusty road came priests in their vestments--one little old man
in a hood with attendants and singers. Behind them soldiers and
officers bore a large, dark-faced icon with an embossed metal cover.
This was the icon that had been brought from and had since accompanied
the army. Behind, before, and on both sides, crowds of militiamen with
bared heads walked, ran, and bowed to the ground.

At the summit of the hill they stopped with the icon; the men who
had been holding it up by the linen bands attached to it were relieved
by others, the chanters relit their censers, and service began. The
hot rays of the sun beat down vertically and a fresh soft wind
played with the hair of the bared heads and with the ribbons
decorating the icon. The singing did not sound loud under the open
sky. An immense crowd of bareheaded officers, soldiers, and militiamen
surrounded the icon. Behind the priest and a chanter stood the
notabilities on a spot reserved for them. A bald general with
general with a St. George's Cross on his neck stood just behind the
priest's back, and without crossing himself (he was evidently a
German) patiently awaited the end of the service, which he
considered it necessary to hear to the end, probably to arouse the
patriotism of the Russian people. Another general stood in a martial
pose, crossing himself by shaking his hand in front of his chest while
looking about him. Standing among the crowd of peasants, Pierre
recognized several acquaintances among these notables, but did not
look at them--his whole attention was absorbed in watching the serious
expression on the faces of the crowd of soldiers and militiamen who
were all gazing eagerly at the icon. As soon as the tired chanters,
who were singing the service for the twentieth time that day, began
lazily and mechanically to sing: "Save from calamity Thy servants, O
Mother of God," and the priest and deacon chimed in: "For to Thee
under God we all flee as to an inviolable bulwark and protection,"
there again kindled in all those faces the same expression of
consciousness of the solemnity of the impending moment that Pierre had
seen on the faces at the foot of the hill at Mozhaysk and
momentarily on many and many faces he had met that morning; and
heads were bowed more frequently and hair tossed back, and sighs and
the sound men made as they crossed themselves were heard.

The crowd round the icon suddenly parted and pressed against Pierre.
Someone, a very important personage judging by the haste with which
way was made for him, was approaching the icon.

It was Kutuzov, who had been riding round the position and on his
way back to Tatarinova had stopped where the service was being held.
Pierre recognized him at once by his peculiar figure, which
distinguished him from everybody else.

With a long overcoat on his his exceedingly stout,
round-shouldered body, with uncovered white head and puffy face
showing the white ball of the eye he had lost, Kutuzov walked with
plunging, swaying gait into the crowd and stopped behind the priest.
He crossed himself with an accustomed movement, bent till he touched
the ground with his hand, and bowed his white head with a deep sigh.
Behind Kutuzov was Bennigsen and the suite. Despite the presence of
the commander in chief, who attracted the attention of all the
superior officers, the militiamen and soldiers continued their prayers
without looking at him.

When the service was over, Kutuzov stepped up to the icon, sank
heavily to his knees, bowed to the ground, and for a long time tried
vainly to rise, but could not do so on account of his weakness and
weight. His white head twitched with the effort. At last he rose,
kissed the icon as a child does with naively pouting lips, and again
bowed till he touched the ground with his hand. The other generals
followed his example, then the officers, and after them with excited
faces, pressing on one another, crowding, panting, and pushing,
scrambled the soldiers and militiamen.





CHAPTER XXII


Staggering amid the crush, Pierre looked about him.

"Count Peter Kirilovich! How did you get here?" said a voice.

Pierre looked round. Boris Drubetskoy, brushing his knees with his
hand (he had probably soiled them when he, too, had knelt before the
icon), came up to him smiling. Boris was elegantly dressed, with a
slightly martial touch appropriate to a campaign. He wore a long
coat and like Kutuzov had a whip slung across his shoulder.

Meanwhile Kutuzov had reached the village and seated himself in
the shade of the nearest house, on a bench which one Cossack had run
to fetch and another had hastily covered with a rug. An immense and
brilliant suite surrounded him.

The icon was carried further, accompanied by the throng. Pierre
stopped some thirty paces from Kutuzov, talking to Boris.

He explained his wish to be present at the battle and to see the
position.

"This is what you must do," said Boris. "I will do the honors of the
camp to you. You will see everything best from where Count Bennigsen
will be. I am in attendance on him, you know; I'll mention it to
him. But if you want to ride round the position, come along with us.
We are just going to the left flank. Then when we get back, do spend
the night with me and we'll arrange a game of cards. Of course you
know Dmitri Sergeevich? Those are his quarters," and he pointed to the
third house in the village of Gorki.

"But I should like to see the right flank. They say it's very
strong," said Pierre. "I should like to start from the Moskva River
and ride round the whole position."

"Well, you can do that later, but the chief thing is the left
flank."

"Yes, yes. But where is Prince Bolkonski's regiment? Can you point
it out to me?"

"Prince Andrew's? We shall pass it and I'll take you to him."

"What about the left flank?" asked Pierre

"To tell you the truth, between ourselves, God only knows what state
our left flank is in," said Boris confidentially lowering his voice.
"It is not at all what Count Bennigsen intended. He meant to fortify
that knoll quite differently, but..." Boris shrugged his shoulders,
"his Serene Highness would not have it, or someone persuaded him.
You see..." but Boris did not finish, for at that moment Kaysarov,
Kutuzov's adjutant, came up to Pierre. "Ah, Kaysarov!" said Boris,
addressing him with an unembarrassed smile, "I was just trying to
explain our position to the count. It is amazing how his Serene
Highness could so the intentions of the French!"

"You mean the left flank?" asked Kaysarov.


"Yes, exactly; the left flank is now extremely strong."

Though Kutuzov had dismissed all unnecessary men from the staff,
Boris had contrived to remain at headquarters after the changes. He
had established himself with Count Bennigsen, who, like all on whom
Boris had been in attendance, considered young Prince Drubetskoy an
invaluable man.

In the higher command there were two sharply defined parties:
Kutuzov's party and that of Bennigsen, the chief of staff. Boris
belonged to the latter and no one else, while showing servile
respect to Kutuzov, could so create an impression that the old
fellow was not much good and that Bennigsen managed everything. Now
the decisive moment of battle had come when Kutuzov would be destroyed
and the power pass to Bennigsen, or even if Kutuzov won the battle
it would be felt that everything was done by Bennigsen. In any case
many great rewards would have to be given for tomorrow's action, and
new men would come to the front. So Boris was full of nervous vivacity
all day.

After Kaysarov, others whom Pierre knew came up to him, and he had
not time to reply to all the questions about Moscow that were showered
upon him, or to listen to all that was told him. The faces all
expressed animation and apprehension, but it seemed to Pierre that the
cause of the excitement shown in some of these faces lay chiefly in
questions of personal success; his mind, however, was occupied by
the different expression he saw on other faces--an expression that
spoke not of personal matters but of the universal questions of life
and death. Kutuzov noticed Pierre's figure and the group gathered
round him.

"Call him to me," said Kutuzov.

An adjutant told Pierre of his Serene Highness' wish, and Pierre
went toward Kutuzov's bench. But a militiaman got there before him. It
was Dolokhov.

"How did that fellow get here?" asked Pierre.

"He's a creature that wriggles in anywhere!" was the answer. "He has
been degraded, you know. Now he wants to bob up again. He's been
proposing some scheme or other and has crawled into the enemy's picket
line at night.... He's a brave fellow."

Pierre took off his hat and bowed respectfully to Kutuzov.

"I concluded that if I reported to your Serene Highness you might
send me away or say that you knew what I was reporting, but then I
shouldn't lose anything..." Dolokhov was saying.

"Yes, yes."

"But if I were right, I should be rendering a service to my
Fatherland for which I am ready to die."

"Yes, yes."

"And should your Serene Highness require a man who will not spare
his skin, please think of me.... Perhaps I may prove useful to your
Serene Highness."

"Yes... Yes..." Kutuzov repeated, his laughing eye narrowing more
and more as he looked at Pierre.

Just then Boris, with his courtierlike adroitness, stepped up to
Pierre's side near Kutuzov and in a most natural manner, without
raising his voice, said to Pierre, as though continuing an interrupted
conversation:

"The militia have put on clean white shirts to be ready to die. What
heroism, Count!"

Boris evidently said this to Pierre in order to be overheard by
his Serene Highness. He knew Kutuzov's attention would be caught by
those words, and so it was.

"What are you saying about the militia?" he asked Boris.

"Preparing for tomorrow, your Serene Highness--for death--they
have put on clean shirts."

"Ah... a wonderful, a matchless people!" said Kutuzov; and he closed
his eyes and swayed his head. "A matchless people!" he repeated with a
sigh.

"So you want to smell gunpowder?" he said to Pierre. "Yes, it's a
pleasant smell. I have the honor to be one of your wife's adorers.
Is she well? My quarters are at your service."

And as often happens with old people, Kutuzov began looking about
absent-mindedly as if forgetting all he wanted to say or do.

Then, evidently remembering what he wanted, he beckoned to Andrew
Kaysarov, his adjutant's brother.

"Those verses... those verses of Marin's... how do they go, eh?
Those he wrote about Gerakov: 'Lectures for the corps inditing'...
Recite them, recite them!" said he, evidently preparing to laugh.

Kaysarov recited.... Kutuzov smilingly nodded his head to the rhythm
of the verses.

When Pierre had left Kutuzov, Dolokhov came up to him and took his
hand.

"I am very glad to meet you here, Count," he said aloud,
regardless of the presence of strangers and in a particularly resolute
and solemn tone. "On the eve of a day when God alone knows who of us
is fated to survive, I am glad of this opportunity to tell you that
I regret the misunderstandings that occurred between us and should
wish you not to have any ill feeling for me. I beg you to forgive me."

Pierre looked at Dolokhov with a smile, not knowing what to say to
him. With tears in his eyes Dolokhov embraced Pierre and kissed him.

Boris said a few words to his general, and Count Bennigsen turned to
Pierre and proposed that he should ride with him along the line.

"It will interest you," said he.

"Yes, very much," replied Pierre.

Half an hour later Kutuzov left for Tatarinova, and Bennigsen and
his suite, with Pierre among them, set out on their ride along the
line.





CHAPTER XXIII


From Gorki, Bennigsen descended the highroad to the bridge which,
when they had looked it from the hill, the officer had pointed out
as being the center of our position and where rows of fragrant
new-mown hay lay by the riverside. They rode across that bridge into
the village of Borodino and thence turned to the left, passing an
enormous number of troops and guns, and came to a high knoll where
militiamen were digging. This was the redoubt, as yet unnamed, which
afterwards became known as the Raevski Redoubt, or the Knoll
Battery, but Pierre paid no special attention to it. He did not know
that it would become more memorable to him than any other spot on
the plain of Borodino.

They then crossed the hollow to Semenovsk, where the soldiers were
dragging away the last logs from the huts and barns. Then they rode
downhill and uphill, across a ryefield trodden and beaten down as if
by hail, following a track freshly made by the artillery over the
furrows of the plowed land, and reached some fleches* which were still
being dug.


*A kind of entrenchment.


At the fleches Bennigsen stopped and began looking at the Shevardino
Redoubt opposite, which had been ours the day before and where several
horsemen could be descried. The officers said that either Napoleon
or Murat was there, and they all gazed eagerly at this little group of
horsemen. Pierre also looked at them, trying to guess which of the
scarcely discernible figures was Napoleon. At last those mounted men
rode away from the mound and disappeared.

Bennigsen spoke to a general who approached him, and began
explaining the whole position of our troops. Pierre listened to him,
straining each faculty to understand the essential points of the
impending battle, but was mortified to feel that his mental capacity
was inadequate for the task. He could make nothing of it. Bennigsen
stopped speaking and, noticing that Pierre was listening, suddenly
said to him:

"I don't think this interests you?"

"On the contrary it's very interesting!" replied Pierre not quite
truthfully.

From the fleches they rode still farther to the left, along a road
winding through a thick, low-growing birch wood. In the middle of
the wood a brown hare with white feet sprang out and, scared by the
tramp of the many horses, grew so confused that it leaped along the
road in front of them for some time, arousing general attention and
laughter, and only when several voices shouted at it did it dart to
one side and disappear in the thicket. After going through the wood
for about a mile and a half they came out on a glade where troops of
Tuchkov's corps were stationed to defend the left flank.

Here, at the extreme left flank, Bennigsen talked a great deal and
with much heat, and, as it seemed to Pierre, gave orders of great
military importance. In front of Tuchkov's troops was some high ground
not occupied by troops. Bennigsen loudly criticized this mistake,
saying that it was madness to leave a height which commanded the
country around unoccupied and to place troops below it. Some of the
generals expressed the same opinion. One in particular declared with
martial heat that they were put there to be slaughtered. Bennigsen
on his own authority ordered the troops to occupy the high ground.
This disposition on the left flank increased Pierre's doubt of his own
capacity to understand military matters. Listening to Bennigsen and
the generals criticizing the position of the troops behind the hill,
he quite understood them and shared their opinion, but for that very
reason he could not understand how the man who put them there behind
the hill could have made so gross and palpable a blunder.

Pierre did not know that these troops were not, as Bennigsen
supposed, put there to defend the position, but were in a concealed
position as an ambush, that they should not be seen and might be
able to strike an approaching enemy unexpectedly. Bennigsen did not
know this and moved the troops forward according to his own ideas
without mentioning the matter to the commander in chief.





CHAPTER XXIV


On that bright evening of August 25, Prince Andrew lay leaning on
his elbow in a broken-down shed in the village of Knyazkovo at the
further end of his regiment's encampment. Through a gap in the
broken wall he could see, beside the wooden fence, a row of thirty
year-old birches with their lower branches lopped off, a field on
which shocks of oats were standing, and some bushes near which rose
the smoke of campfires--the soldiers' kitchens.

Narrow and burdensome and useless to anyone as his life now seemed
to him, Prince Andrew on the eve of battle felt agitated and irritable
as he had done seven years before at Austerlitz.

He had received and given the orders for next day's battle and had
nothing more to do. But his thoughts--the simplest, clearest, and
therefore most terrible thoughts--would give him no peace. He knew
that tomorrow's battle would be the most terrible of all he had
taken part in, and for the first time in his life the possibility of
death presented itself to him--not in relation to any worldly matter
or with reference to its effect on others, but simply in relation to
himself, to his own soul--vividly, plainly, terribly, and almost as
a certainty. And from the height of this perception all that had
previously tormented and preoccupied him suddenly became illumined
by a cold white light without shadows, without perspective, without
distinction of outline. All life appeared to him like magic-lantern
pictures at which he had long been gazing by artificial light
through a glass. Now he suddenly saw those badly daubed pictures in
clear daylight and without a glass. "Yes, yes! There they are, those
false images that agitated, enraptured, and tormented me," said he
to himself, passing in review the principal pictures of the magic
lantern of life and regarding them now in the cold white daylight of
his clear perception of death. "There they are, those rudely painted
figures that once seemed splendid and mysterious. Glory, the good of
society, love of a woman, the Fatherland itself--how important these
pictures appeared to me, with what profound meaning they seemed to
be filled! And it is all so simple, pale, and crude in the cold
white light of this morning which I feel is dawning for me." The three
great sorrows of his life held his attention in particular: his love
for a woman, his father's death, and the French invasion which had
overrun half Russia. "Love... that little girl who seemed to me
brimming over with mystic forces! Yes, indeed, I loved her. I made
romantic plans of love and happiness with her! Oh, what a boy I
was!" he said aloud bitterly. "Ah me! I believed in some ideal love
which was to keep her faithful to me for the whole year of my absence!
Like the gentle dove in the fable she was to pine apart from me....
But it was much simpler really.... It was all very simple and
horrible."

"When my father built Bald Hills he thought the place was his: his
land, his air, his peasants. But Napoleon came and swept him aside,
unconscious of his existence, as he might brush a chip from his
path, and his Bald Hills and his whole life fell to pieces. Princess
Mary says it is a trial sent from above. What is the trial for, when
he is not here and will never return? He is not here! For whom then is
the trial intended? The Fatherland, the destruction of Moscow! And
tomorrow I shall be killed, perhaps not even by a Frenchman but by one
of our own men, by a soldier discharging a musket close to my ear as
one of them did yesterday, and the French will come and take me by
head and heels and fling me into a hole that I may not stink under
their noses, and new conditions of life will arise, which will seem
quite ordinary to others and about which I shall know nothing. I shall
not exist..."

He looked at the row of birches shining in the sunshine, with
their motionless green and yellow foliage and white bark. "To die...
to be killed tomorrow... That I should not exist... That all this
should still be, but no me...."

And the birches with their light and shade, the curly clouds, the
smoke of the campfires, and all that was around him changed and seemed
terrible and menacing. A cold shiver ran down his spine. He rose
quickly, went out of the shed, and began to walk about.

After he had returned, voices were heard outside the shed. "Who's
that?" he cried.

The red-nosed Captain Timokhin, formerly Dolokhov's squadron
commander, but now from lack of officers a battalion commander,

shyly entered the shed followed by an adjutant and the regimental
paymaster.

Prince Andrew rose hastily, listened to the business they had come
about, gave them some further instructions, and was about to dismiss
them when he heard a familiar, lisping, voice behind the shed.

"Devil take it!" said the voice of a man stumbling over something.

Prince Andrew looked out of the shed and saw Pierre, who had tripped
over a pole on the ground and had nearly fallen, coming his way. It
was unpleasant to Prince Andrew to meet people of his own set in
general, and Pierre especially, for he reminded him of all the painful
moments of his last visit to Moscow.

"You? What a surprise!" said he. "What brings you here? This is
unexpected!"

As he said this his eyes and face expressed more than coldness--they
expressed hostility, which Pierre noticed at once. He had approached
the shed full of animation, but on seeing Prince Andrew's face he felt
constrained and ill at ease.

"I have come... simply... you know... come... it interests me," said
Pierre, who had so often that day senselessly repeated that word
"interesting." "I wish to see the battle."

"Oh yes, and what do the Masonic brothers say about war? How would
they stop it?" said Prince Andrew sarcastically. "Well, and how's
Moscow? And my people? Have they reached Moscow at last?" he asked
seriously.

"Yes, they have. Julie Drubetskaya told me so. I went to see them,
but missed them. They have gone to your estate near Moscow."





CHAPTER XXV


The officers were about to take leave, but Prince Andrew, apparently
reluctant to be left alone with his friend, asked them to stay and
have tea. Seats were brought in and so was the tea. The officers gazed
with surprise at Pierre's huge stout figure and listened to his talk
of Moscow and the position of our army, round which he had ridden.
Prince Andrew remained silent, and his expression was so forbidding
that Pierre addressed his remarks chiefly to the good-natured
battalion commander.

"So you understand the whole position of our troops?" Prince
Andrew interrupted him.

"Yes--that is, how do you mean?" said Pierre. "Not being a
military man I can't say I have understood it fully, but I
understand the general position."

"Well, then, you know more than anyone else, be it who it may," said
Prince Andrew.

"Oh!" said Pierre, looking over his spectacles in perplexity at
Prince Andrew. "Well, and what do think of Kutuzov's appointment?"
he asked.

"I was very glad of his appointment, that's all I know," replied
Prince Andrew.

"And tell me your opinion of Barclay de Tolly. In Moscow they are
saying heaven knows what about him.... What do you think of him?"

"Ask them," replied Prince Andrew, indicating the officers.

Pierre looked at Timokhin with the condescendingly interrogative
smile with which everybody involuntarily addressed that officer.

"We see light again, since his Serenity has been appointed, your
excellency," said Timokhin timidly, and continually turning to
glance at his colonel.

"Why so?" asked Pierre.

"Well, to mention only firewood and fodder, let me inform you.
Why, when we were retreating from Sventsyani we dare not touch a stick
or a wisp of hay or anything. You see, we were going away, so he would
get it all; wasn't it so, your excellency?" and again Timokhin
turned to the prince. "But we daren't. In our regiment two officers
were court-martialed for that kind of thing. But when his Serenity
took command everything became straight forward. Now we see light..."

"Then why was it forbidden?"

Timokhin looked about in confusion, not knowing what or how to
answer such a question. Pierre put the same question to Prince Andrew.

"Why, so as not to lay waste the country we were abandoning to the
enemy," said Prince Andrew with venomous irony. "It is very sound: one
can't permit the land to be pillaged and accustom the troops to
marauding. At Smolensk too he judged correctly that the French might
outflank us, as they had larger forces. But he could not understand
this," cried Prince Andrew in a shrill voice that seemed to escape him
involuntarily: "he could not understand that there, for the first
time, we were fighting for Russian soil, and that there was a spirit
in the men such as I had never seen before, that we had held the
French for two days, and that that success had increased our
strength tenfold. He ordered us to retreat, and all our efforts and
losses went for nothing. He had no thought of betraying us, he tried
to do the best he could, he thought out everything, and that is why he
is unsuitable. He is unsuitable now, just because he plans out
everything very thoroughly and accurately as every German has to.
How can I explain?... Well, say your father has a German valet, and he
is a splendid valet and satisfies your father's requirements better
than you could, then it's all right to let him serve. But if your
father is mortally sick you'll send the valet away and attend to
your father with your own unpracticed, awkward hands, and will
soothe him better than a skilled man who is a stranger could. So it
has been with Barclay. While Russia was well, a foreigner could
serve her and be a splendid minister; but as soon as she is in
danger she needs one of her own kin. But in your Club they have been
making him out a traitor! They slander him as a traitor, and the
only result will be that afterwards, ashamed of their false
accusations, they will make him out a hero or a genius instead of a
traitor, and that will be still more unjust. He is an honest and
very punctilious German."

"And they say he's a skillful commander," rejoined Pierre.

"I don't understand what is meant by 'a skillful commander,'"
replied Prince Andrew ironically.

"A skillful commander?" replied Pierre. "Why, one who foresees all
contingencies... and foresees the adversary's intentions."

"But that's impossible," said Prince Andrew as if it were a matter
settled long ago.

Pierre looked at him in surprise.

"And yet they say that war is like a game of chess?" he remarked.

"Yes," replied Prince Andrew, "but with this little difference, that
in chess you may think over each move as long as you please and are
not limited for time, and with this difference too, that a knight is
always stronger than a pawn, and two pawns are always stronger than
one, while in war a battalion is sometimes stronger than a division
and sometimes weaker than a company. The relative strength of bodies
of troops can never be known to anyone. Believe me," he went on, "if
things depended on arrangements made by the staff, I should be there
making arrangements, but instead of that I have the honor to serve
here in the regiment with these gentlemen, and I consider that on us
tomorrow's battle will depend and not on those others.... Success
never depends, and never will depend, on position, or equipment, or
even on numbers, and least of all on position."

"But on what then?"

"On the feeling that is in me and in him," he pointed to Timokhin,
"and in each soldier."

Prince Andrew glanced at Timokhin, who looked at his commander in
alarm and bewilderment. In contrast to his former reticent taciturnity
Prince Andrew now seemed excited. He could apparently not refrain from
expressing the thoughts that had suddenly occurred to him.

"A battle is won by those who firmly resolve to win it! Why did we
lose the battle at Austerlitz? The French losses were almost equal
to ours, but very early we said to ourselves that we were losing the
battle, and we did lose it. And we said so because we had nothing to
fight for there, we wanted to get away from the battlefield as soon as
we could. 'We've lost, so let us run,' and we ran. If we had not
said that till the evening, heaven knows what might not have happened.
But tomorrow we shan't say it! You talk about our position, the left
flank weak and the right flank too extended," he went on. "That's
all nonsense, there's nothing of the kind. But what awaits us
tomorrow? A hundred million most diverse chances which will be decided
on the instant by the fact that our men or theirs run or do not run,
and that this man or that man is killed, but all that is being done at
present is only play. The fact is that those men with whom you have
ridden round the position not only do not help matters, but hinder.
They are only concerned with their own petty interests."

"At such a moment?" said Pierre reproachfully.

"At such a moment!" Prince Andrew repeated. "To them it is only a
moment affording opportunities to undermine a rival and obtain an
extra cross or ribbon. For me tomorrow means this: a Russian army of a
hundred thousand and a French army of a hundred thousand have met to
fight, and the thing is that these two hundred thousand men will fight
and the side that fights more fiercely and spares itself least will
win. And if you like I will tell you that whatever happens and
whatever muddles those at the top may make, we shall win tomorrow's
battle. Tomorrow, happen what may, we shall win!"

"There now, your excellency! That's the truth, the real truth," said
Timokhin. "Who would spare himself now? The soldiers in my
battalion, believe me, wouldn't drink their vodka! 'It's not the day
for that!' they say."

All were silent. The officers rose. Prince Andrew went out of the
shed with them, giving final orders to the adjutant. After they had
gone Pierre approached Prince Andrew and was about to start a
conversation when they heard the clatter of three horses' hoofs on the
road not far from the shed, and looking in that direction Prince
Andrew recognized Wolzogen and Clausewitz accompanied by a Cossack.
They rode close by continuing to converse, and Prince Andrew
involuntarily heard these words:

"Der Krieg muss in Raum verlegt werden. Der Ansicht kann ich nicht
genug Preis geben,"* said one of them.


*"The war must be extended widely. I cannot sufficiently commend
that view."


"Oh, ja," said the other, "der Zweck ist nur den Feind zu schwachen,
so kann man gewiss nicht den Verlust der Privat-Personen in Achtung
nehmen."*


*"Oh, yes, the only aim is to weaken the enemy, so of course one
cannot take into account the loss of private individuals."


"Oh, no," agreed the other.

"Extend widely!" said Prince Andrew with an angry snort, when they
had ridden past. "In that 'extend' were my father, son, and sister, at
Bald Hills. That's all the same to him! That's what I was saying to
you--those German gentlemen won't win the battle tomorrow but will
only make all the mess they can, because they have nothing in their
German heads but theories not worth an empty eggshell and haven't in
their hearts the one thing needed tomorrow--that which Timokhin has.
They have yielded up all Europe to him, and have now come to teach us.
Fine teachers!" and again his voice grew shrill.

"So you think we shall win tomorrow's battle?" asked Pierre.

"Yes, yes," answered Prince Andrew absently. "One thing I would do

if I had the power," he began again, "I would not take prisoners.
Why take prisoners? It's chivalry! The French have destroyed my home
and are on their way to destroy Moscow, they have outraged and are
outraging me every moment. They are my enemies. In my opinion they are
all criminals. And so thinks Timokhin and the whole army. They
should be executed! Since they are my foes they cannot be my
friends, whatever may have been said at Tilsit."

"Yes, yes," muttered Pierre, looking with shining eyes at Prince
Andrew. "I quite agree with you!"

The question that had perturbed Pierre on the Mozhaysk hill and
all that day now seemed to him quite clear and completely solved. He
now understood the whole meaning and importance of this war and of the
impending battle. All he had seen that day, all the significant and
stern expressions on the faces he had seen in passing, were lit up for
him by a new light. He understood that latent heat (as they say in
physics) of patriotism which was present in all these men he had seen,
and this explained to him why they all prepared for death calmly,
and as it were lightheartedly.

"Not take prisoners," Prince Andrew continued: "That by itself would
quite change the whole war and make it less cruel. As it is we have
played at war--that's what's vile! We play at magnanimity and all that
stuff. Such magnanimity and sensibility are like the magnanimity and
sensibility of a lady who faints when she sees a calf being killed:
she is so kind-hearted that she can't look at blood, but enjoys eating
the calf served up with sauce. They talk to us of the rules of war, of
chivalry, of flags of truce, of mercy to the unfortunate and so on.
It's all rubbish! I saw chivalry and flags of truce in 1805; they
humbugged us and we humbugged them. They plunder other people's
houses, issue false paper money, and worst of all they kill my
children and my father, and then talk of rules of war and
magnanimity to foes! Take no prisoners, but kill and be killed! He who
has come to this as I have through the same sufferings..."

Prince Andrew, who had thought it was all the same to him whether or
not Moscow was taken as Smolensk had been, was suddenly checked in his
speech by an unexpected cramp in his throat. He paced up and down a
few times in silence, but his eyes glittered feverishly and his lips
quivered as he began speaking.

"If there was none of this magnanimity in war, we should go to war
only when it was worth while going to certain death, as now. Then
there would not be war because Paul Ivanovich had offended Michael
Ivanovich. And when there was a war, like this one, it would be war!
And then the determination of the troops would be quite different.
Then all these Westphalians and Hessians whom Napoleon is leading
would not follow him into Russia, and we should not go to fight in
Austria and Prussia without knowing why. War is not courtesy but the
most horrible thing in life; and we ought to understand that and not
play at war. We ought to accept this terrible necessity sternly and
seriously. It all lies in that: get rid of falsehood and let war be
war and not a game. As it is now, war is the favorite pastime of the
idle and frivolous. The military calling is the most highly honored.

"But what is war? What is needed for success in warfare? What are
the habits of the military? The aim of war is murder; the methods of
war are spying, treachery, and their encouragement, the ruin of a
country's inhabitants, robbing them or stealing to provision the army,
and fraud and falsehood termed military craft. The habits of the
military class are the absence of freedom, that is, discipline,
idleness, ignorance, cruelty, debauchery, and drunkenness. And in
spite of all this it is the highest class, respected by everyone.
All the kings, except the Chinese, wear military uniforms, and he
who kills most people receives the highest rewards.

"They meet, as we shall meet tomorrow, to murder one another; they
kill and maim tens of thousands, and then have thanksgiving services
for having killed so many people (they even exaggerate the number),
and they announce a victory, supposing that the more people they
have killed the greater their achievement. How does God above look
at them and hear them?" exclaimed Prince Andrew in a shrill,
piercing voice. "Ah, my friend, it has of late become hard for me to
live. I see that I have begun to understand too much. And it doesn't
do for man to taste of the tree of knowledge of good and evil....
Ah, well, it's not for long!" he added.

"However, you're sleepy, and it's time for me to sleep. Go back to
Gorki!" said Prince Andrew suddenly.

"Oh no!" Pierre replied, looking at Prince Andrew with frightened,
compassionate eyes.

"Go, go! Before a battle one must have one's sleep out," repeated
Prince Andrew.

He came quickly up to Pierre and embraced and kissed him.
"Good-by, be off!" he shouted. "Whether we meet again or not..."
and turning away hurriedly he entered the shed.

It was already dark, and Pierre could not make out whether the
expression of Prince Andrew's face was angry or tender.

For some time he stood in silence considering whether he should
follow him or go away. "No, he does not want it!" Pierre concluded.
"And I know that this is our last meeting!" He sighed deeply and
rode back to Gorki.

On re-entering the shed Prince Andrew lay down on a rug, but he
could not sleep.

He closed his eyes. One picture succeeded another in his
imagination. On one of them he dwelt long and joyfully. He vividly
recalled an evening in Petersburg. Natasha with animated and excited
face was telling him how she had gone to look for mushrooms the
previous summer and had lost her way in the big forest. She
incoherently described the depths of the forest, her feelings, and a
talk with a beekeeper she met, and constantly interrupted her story to
say: "No, I can't! I'm not telling it right; no, you don't
understand," though he encouraged her by saying that he did
understand, and he really had understood all she wanted to say. But
Natasha was not satisfied with her own words: she felt that they did
not convey the passionately poetic feeling she had experienced that
day and wished to convey. "He was such a delightful old man, and it
was so dark in the forest... and he had such kind... No, I can't
describe it," she had said, flushed and excited. Prince Andrew
smiled now the same happy smile as then when he had looked into her
eyes. "I understood her," he thought. "I not only understood her,
but it was just that inner, spiritual force, that sincerity, that
frankness of soul--that very soul of hers which seemed to be
fettered by her body--it was that soul I loved in her... loved so
strongly and happily..." and suddenly he remembered how his love had
ended. "He did not need anything of that kind. He neither saw nor
understood anything of the sort. He only saw in her a pretty and fresh
young girl, with whom he did not deign to unite his fate. And I?...
and he is still alive and gay!"

Prince Andrew jumped up as if someone had burned him, and again
began pacing up and down in front of the shed.





CHAPTER XXVI


On August 25, the eve of the battle of Borodino, M. de Beausset,
prefect of the French Emperor's palace, arrived at Napoleon's quarters
at Valuevo with Colonel Fabvier, the former from Paris and the
latter from Madrid.

Donning his court uniform, M. de Beausset ordered a box he had
brought for the Emperor to be carried before him and entered the first
compartment of Napoleon's tent, where he began opening the box while
conversing with Napoleon's aides-de-camp who surrounded him.

Fabvier, not entering the tent, remained at the entrance talking
to some generals of his acquaintance.

The Emperor Napoleon had not yet left his bedroom and was
finishing his toilet. Slightly snorting and grunting, he presented now
his back and now his plump hairy chest to the brush with which his
valet was rubbing him down. Another valet, with his finger over the
mouth of a bottle, was sprinkling Eau de Cologne on the Emperor's
pampered body with an expression which seemed to say that he alone
knew where and how much Eau de Cologne should be sprinkled. Napoleon's
short hair was wet and matted on the forehead, but his face, though
puffy and yellow, expressed physical satisfaction. "Go on, harder,
go on!" he muttered to the valet who was rubbing him, slightly
twitching and grunting. An aide-de-camp, who had entered the bedroom
to report to the Emperor the number of prisoners taken in
yesterday's action, was standing by the door after delivering his
message, awaiting permission to withdraw. Napoleon, frowning, looked
at him from under his brows.

"No prisoners!" said he, repeating the aide-de-camp's words. "They
are forcing us to exterminate them. So much the worse for the
Russian army.... Go on... harder, harder!" he muttered, hunching his
back and presenting his fat shoulders.

"All right. Let Monsieur de Beausset enter, and Fabvier too," he
said, nodding to the aide-de-camp.

"Yes, sire," and the aide-de-camp disappeared through the door of
the tent.

Two valets rapidly dressed His Majesty, and wearing the blue uniform
of the Guards he went with firm quick steps to the reception room.

De Beausset's hands meanwhile were busily engaged arranging the
present he had brought from the Empress, on two chairs directly in
front of the entrance. But Napoleon had dressed and come out with such
unexpected rapidity that he had not time to finish arranging the
surprise.

Napoleon noticed at once what they were about and guessed that
they were not ready. He did not wish to deprive them of the pleasure
of giving him a surprise, so he pretended not to see de Beausset and
called Fabvier to him, listening silently and with a stern frown to
what Fabvier told him of the heroism and devotion of his troops
fighting at Salamanca, at the other end of Europe, with but one
thought--to be worthy of their Emperor--and but one fear--to fail to
please him. The result of that battle had been deplorable. Napoleon
made ironic remarks during Fabvier's account, as if he had not
expected that matters could go otherwise in his absence.

"I must make up for that in Moscow," said Napoleon. "I'll see you
later," he added, and summoned de Beausset, who by that time had
prepared the surprise, having placed something on the chairs and
covered it with a cloth.

De Beausset bowed low, with that courtly French bow which only the
old retainers of the Bourbons knew how to make, and approached him,
presenting an envelope.

Napoleon turned to him gaily and pulled his ear.

"You have hurried here. I am very glad. Well, what is Paris saying?"
he asked, suddenly changing his former stern expression for a most
cordial tone.

"Sire, all Paris regrets your absence," replied de Beausset as was
proper.

But though Napoleon knew that de Beausset had to say something of
this kind, and though in his lucid moments he knew it was untrue, he
was pleased to hear it from him. Again he honored him by touching
his ear.

"I am very sorry to have made you travel so far," said he.

"Sire, I expected nothing less than to find you at the gates of
Moscow," replied de Beausset.

Napoleon smiled and, lifting his head absentmindedly, glanced to the
right. An aide-de-camp approached with gliding steps and offered him a
gold snuffbox, which he took.

"Yes, it has happened luckily for you," he said, raising the open
snuffbox to his nose. "You are fond of travel, and in three days you
will see Moscow. You surely did not expect to see that Asiatic
capital. You will have a pleasant journey."

De Beausset bowed gratefully at this regard for his taste for travel
(of which he had not till then been aware).

"Ha, what's this?" asked Napoleon, noticing that all the courtiers
were looking at something concealed under a cloth.

With courtly adroitness de Beausset half turned and without
turning his back to the Emperor retired two steps, twitching off the
cloth at the same time, and said:

"A present to Your Majesty from the Empress."

It was a portrait, painted in bright colors by Gerard, of the son
borne to Napoleon by the daughter of the Emperor of Austria, the boy
whom for some reason everyone called "The King of Rome."

A very pretty curly-headed boy with a look of the Christ in the
Sistine Madonna was depicted playing at stick and ball. The ball
represented the terrestrial globe and the stick in his other hand a
scepter.

Though it was not clear what the artist meant to express by
depicting the so-called King of Rome spiking the earth with a stick,
the allegory apparently seemed to Napoleon, as it had done to all
who had seen it in Paris, quite clear and very pleasing.

"The King of Rome!" he said, pointing to the portrait with a
graceful gesture. "Admirable!"

With the natural capacity of an Italian for changing the
expression of his face at will, he drew nearer to the portrait and
assumed a look of pensive tenderness. He felt that what he now said
and did would be historical, and it seemed to him that it would now be
best for him--whose grandeur enabled his son to play stick and ball
with the terrestrial globe--to show, in contrast to that grandeur, the
simplest paternal tenderness. His eyes grew dim, he moved forward,
glanced round at a chair (which seemed to place itself under him), and
sat down on it before the portrait. At a single gesture from him
everyone went out on tiptoe, leaving the great man to himself and
his emotion.

Having sat still for a while he touched--himself not knowing why-
the thick spot of paint representing the highest light in the
portrait, rose, and recalled de Beausset and the officer on duty. He
ordered the portrait to be carried outside his tent, that the Old
Guard, stationed round it, might not be deprived of the pleasure of
seeing the King of Rome, the son and heir of their adored monarch.

And while he was doing M. de Beausset the honor of breakfasting with
him, they heard, as Napoleon had anticipated, the rapturous cries of
the officers and men of the Old Guard who had run up to see the
portrait.

"Vive l'Empereur! Vive le roi de Rome! Vive l'Empereur!" came
those ecstatic cries.

After breakfast Napoleon in de Beausset's presence dictated his
order of the day to the army.

"Short and energetic!" he remarked when he had read over the
proclamation which he had dictated straight off without corrections.
It ran:


Soldiers! This is the battle you have so longed for. Victory depends
on you. It is essential for us; it will give us all we need:
comfortable quarters and a speedy return to our country. Behave as you
did at Austerlitz, Friedland, Vitebsk, and Smolensk. Let our
remotest posterity recall your achievements this day with pride. Let
it be said of each of you: "He was in the great battle before Moscow!"


"Before Moscow!" repeated Napoleon, and inviting M. de Beausset, who
was so fond of travel, to accompany him on his ride, he went out of
the tent to where the horses stood saddled.

"Your Majesty is too kind!" replied de Beausset to the invitation to
accompany the Emperor; he wanted to sleep, did not know how to ride
and was afraid of doing so.

But Napoleon nodded to the traveler, and de Beausset had to mount.
When Napoleon came out of the tent the shouting of the Guards before
his son's portrait grew still louder. Napoleon frowned.

"Take him away!" he said, pointing with a gracefully majestic
gesture to the portrait. "It is too soon for him to see a field of
battle."

De Beausset closed his eyes, bowed his head, and sighed deeply, to
indicate how profoundly he valued and comprehended the Emperor's
words.





CHAPTER XXVII


On the twenty-fifth of August, so his historians tell us, Napoleon
spent the whole day on horseback inspecting the locality,
considering plans submitted to him by his marshals, and personally
giving commands to his generals.

The original line of the Russian forces along the river Kolocha
had been dislocated by the capture of the Shevardino Redoubt on the
twenty-fourth, and part of the line--the left flank--had been drawn
back. That part of the line was not entrenched and in front of it
the ground was more open and level than elsewhere. It was evident to
anyone, military or not, that it was here the French should attack. It
would seem that not much consideration was needed to reach this
conclusion, nor any particular care or trouble on the part of the
Emperor and his marshals, nor was there any need of that special and
supreme quality called genius that people are so apt to ascribe to
Napoleon; yet the historians who described the event later and the men
who then surrounded Napoleon, and he himself, thought otherwise.

Napoleon rode over the plain and surveyed the locality with a
profound air and in silence, nodded with approval or shook his head
dubiously, and without communicating to the generals around him the
profound course of ideas which guided his decisions merely gave them
his final conclusions in the form of commands. Having listened to a
suggestion from Davout, who was now called Prince d'Eckmuhl, to turn
the Russian left wing, Napoleon said it should not be done, without
explaining why not. To a proposal made by General Campan (who was to
attack the fleches) to lead his division through the woods, Napoleon
agreed, though the so-called Duke of Elchingen (Ney) ventured to
remark that a movement through the woods was dangerous and might
disorder the division.

Having inspected the country opposite the Shevardino Redoubt,
Napoleon pondered a little in silence and then indicated the spots
where two batteries should be set up by the morrow to act against
the Russian entrenchments, and the places where, in line with them,
the field artillery should be placed.

After giving these and other commands he returned to his tent, and
the dispositions for the battle were written down from his dictation.

These dispositions, of which the French historians write with
enthusiasm and other historians with profound respect, were as
follows:


At dawn the two new batteries established during the night on the
plain occupied by the Prince d'Eckmuhl will open fire on the
opposing batteries of the enemy.

At the same time the commander of the artillery of the 1st Corps,
General Pernetti, with thirty cannon of Campan's division and all
the howitzers of Dessaix's and Friant's divisions, will move
forward, open fire, and overwhelm with shellfire the enemy's
battery, against which will operate:

        24 guns of the artillery of the Guards
        30 guns of Campan's division

and      8 guns of Friant's and Dessaix's divisions
        --

in all  62 guns.


The commander of the artillery of the 3rd Corps, General Fouche,
will place the howitzers of the 3rd and 8th Corps, sixteen in all,
on the flanks of the battery that is to bombard the entrenchment on
the left, which will have forty guns in all directed against it.

General Sorbier must be ready at the first order to advance with all
the howitzers of the Guard's artillery against either one or other
of the entrenchments.

During the cannonade Prince Poniatowski is to advance through the
wood on the village and turn the enemy's position.

General Campan will move through the wood to seize the first
fortification.

After the advance has begun in this manner, orders will be given
in accordance with the enemy's movements.

The cannonade on the left flank will begin as soon as the guns of
the right wing are heard. The sharpshooters of Morand's division and
of the vice-King's division will open a heavy fire on seeing the
attack commence on the right wing.

The vice-King will occupy the village and cross by its three
bridges, advancing to the same heights as Morand's and Gibrard's
divisions, which under his leadership will be directed against the
redoubt and come into line with the rest of the forces.

All this must be done in good order (le tout se fera avec ordre et
methode) as far as possible retaining troops in reserve.
   The Imperial Camp near Mozhaysk,
   September, 6, 1812.


These dispositions, which are very obscure and confused if one
allows oneself to regard the arrangements without religious awe of his
genius, related to Napoleon's orders to deal with four points--four
different orders. Not one of these was, or could be, carried out.

In the disposition it is said first that the batteries placed on the
spot chosen by Napoleon, with the guns of Pernetti and Fouche; which
were to come in line with them, 102 guns in all, were to open fire and
shower shells on the Russian fleches and redoubts. This could not be
done, as from the spots selected by Napoleon the projectiles did not
carry to the Russian works, and those 102 guns shot into the air until
the nearest commander, contrary to Napoleon's instructions, moved them
forward.

The second order was that Poniatowski, moving to the village through
the wood, should turn the Russian left flank. This could not be done
and was not done, because Poniatowski, advancing on the village
through the wood, met Tuchkov there barring his way, and could not and
did not turn the Russian position.

The third order was: General Campan will move through the wood to
seize the first fortification. General Campan's division did not seize
the first fortification but was driven back, for on emerging from
the wood it had to reform under grapeshot, of which Napoleon was
unaware.

The fourth order was: The vice-King will occupy the village
(Borodino) and cross by its three bridges, advancing to the same
heights as Morand's and Gdrard's divisions (for whose movements no
directions are given), which under his leadership will be directed
against the redoubt and come into line with the rest of the forces.

As far as one can make out, not so much from this unintelligible
sentence as from the attempts the vice-King made to execute the orders
given him, he was to advance from the left through Borodino to the
redoubt while the divisions of Morand and Gerard were to advance
simultaneously from the front.

All this, like the other parts of the disposition, was not and could
not be executed. After passing through Borodino the vice-King was
driven back to the Kolocha and could get no farther; while the
divisions of Morand and Gerard did not take the redoubt but were
driven back, and the redoubt was only taken at the end of the battle
by the cavalry (a thing probably unforeseen and not heard of by
Napoleon). So not one of the orders in the disposition was, or could
be, executed. But in the disposition it is said that, after the
fight has commenced in this manner, orders will be given in accordance
with the enemy's movements, and so it might be supposed that all
necessary arrangements would be made by Napoleon during the battle.
But this was not and could not be done, for during the whole battle
Napoleon was so far away that, as appeared later, he could not know
the course of the battle and not one of his orders during the fight
could be executed.





CHAPTER XXVIII


Many historians say that the French did not win the battle of
Borodino because Napoleon had a cold, and that if he had not had a
cold the orders he gave before and during the battle would have been
still more full of genius and Russia would have been lost and the face
of the world have been changed. To historians who believe that
Russia was shaped by the will of one man--Peter the Great--and that
France from a republic became an empire and French armies went to
Russia at the will of one man--Napoleon--to say that Russia remained a
power because Napoleon had a bad cold on the twenty-fourth of August
may seem logical and convincing.

If it had depended on Napoleon's will to fight or not to fight the
battle of Borodino, and if this or that other arrangement depended
on his will, then evidently a cold affecting the manifestation of
his will might have saved Russia, and consequently the valet who
omitted to bring Napoleon his waterproof boots on the twenty-fourth
would have been the savior of Russia. Along that line of thought
such a deduction is indubitable, as indubitable as the deduction
Voltaire made in jest (without knowing what he was jesting at) when he
saw that the Massacre of St. Bartholomew was due to Charles IX's
stomach being deranged. But to men who do not admit that Russia was
formed by the will of one man, Peter I, or that the French Empire
was formed and the war with Russia begun by the will of one man,
Napoleon, that argument seems not merely untrue and irrational, but
contrary to all human reality. To the question of what causes historic
events another answer presents itself, namely, that the course of
human events is predetermined from on high--depends on the coincidence
of the wills of all who take part in the events, and that a Napoleon's
influence on the course of these events is purely external and
fictitious.

Strange as at first glance it may seem to suppose that the
Massacre of St. Bartholomew was not due to Charles IX's will, though
he gave the order for it and thought it was done as a result of that
order; and strange as it may seem to suppose that the slaughter of
eighty thousand men at Borodino was not due to Napoleon's will, though
he ordered the commencement and conduct of the battle and thought it
was done because he ordered it; strange as these suppositions
appear, yet human dignity--which tells me that each of us is, if not
more at least not less a man than the great Napoleon--demands the
acceptance of that solution of the question, and historic
investigation abundantly confirms it.

At the battle of Borodino Napoleon shot at no one and killed no one.
That was all done by the soldiers. Therefore it was not he who
killed people.

The French soldiers went to kill and be killed at the battle of
Borodino not because of Napoleon's orders but by their own volition.
The whole army--French, Italian, German, Polish, and Dutch--hungry,
ragged, and weary of the campaign, felt at the sight of an army
blocking their road to Moscow that the wine was drawn and must be
drunk. Had Napoleon then forbidden them to fight the Russians, they
would have killed him and have proceeded to fight the Russians because
it was inevitable.

When they heard Napoleon's proclamation offering them, as
compensation for mutilation and death, the words of posterity about
their having been in the battle before Moscow, they cried "Vive
l'Empereur!" just as they had cried "Vive l'Empereur!" at the sight of
the portrait of the boy piercing the terrestrial globe with a toy
stick, and just as they would have cried "Vive l'Empereur!" at any
nonsense that might be told them. There was nothing left for them to
do but cry "Vive l'Empereur!" and go to fight, in order to get food
and rest as conquerors in Moscow. So it was not because of
Napoleon's commands that they killed their fellow men.

And it was not Napoleon who directed the course of the battle, for
none of his orders were executed and during the battle he did not know
what was going on before him. So the way in which these people
killed one another was not decided by Napoleon's will but occurred
independently of him, in accord with the will of hundreds of thousands
of people who took part in the common action. It only seemed to
Napoleon that it all took place by his will. And so the question
whether he had or had not a cold has no more historic interest than
the cold of the least of the transport soldiers.

Moreover, the assertion made by various writers that his cold was
the cause of his dispositions not being as well planned as on former
occasions, and of his orders during the battle not being as good as
previously, is quite baseless, which again shows that Napoleon's
cold on the twenty-sixth of August was unimportant.

The dispositions cited above are not at all worse, but are even
better, than previous dispositions by which he had won victories.
His pseudo-orders during the battle were also no worse than
formerly, but much the same as usual. These dispositions and orders
only seem worse than previous ones because the battle of Borodino
was the first Napoleon did not win. The profoundest and most excellent
dispositions and orders seem very bad, and every learned militarist
criticizes them with looks of importance, when they relate to a
battle that has been lost, and the very worst dispositions and
orders seem very good, and serious people fill whole volumes to
demonstrate their merits, when they relate to a battle that has been
won.

The dispositions drawn up by Weyrother for the battle of
Austerlitz were a model of perfection for that kind of composition,
but still they were criticized--criticized for their very
perfection, for their excessive minuteness.

Napoleon at the battle of Borodino fulfilled his office as
representative of authority as well as, and even better than, at other
battles. He did nothing harmful to the progress of the battle; he
inclined to the most reasonable opinions, he made no confusion, did
not contradict himself, did not get frightened or run away from the
field of battle, but with his great tact and military experience
carried out his role of appearing to command, calmly and with dignity.





CHAPTER XXIX


On returning from a second inspection of the lines, Napoleon
remarked:

"The chessmen are set up, the game will begin tomorrow!"

Having ordered punch and summoned de Beausset, he began to talk to
him about Paris and about some changes he meant to make the Empress'
household, surprising the prefect by his memory of minute details
relating to the court.

He showed an interest in trifles, joked about de Beausset's love
of travel, and chatted carelessly, as a famous, self-confident surgeon
who knows his job does when turning up his sleeves and putting on
his apron while a patient is being strapped to the operating table.
"The matter is in my hands and is clear and definite in my head.
When the times comes to set to work I shall do it as no one else
could, but now I can jest, and the more I jest and the calmer I am the
more tranquil and confident you ought to be, and the more amazed at my
genius."

Having finished his second glass of punch, Napoleon went to rest
before the serious business which, he considered, awaited him next
day. He was so much interested in that task that he was unable to
sleep, and in spite of his cold which had grown worse from the
dampness of the evening, he went into the large division of the tent
at three o'clock in the morning, loudly blowing his nose. He asked
whether the Russians had not withdrawn, and was told that the
enemy's fires were still in the same places. He nodded approval.

The adjutant in attendance came into the tent.

"Well, Rapp, do you think we shall do good business today?" Napoleon
asked him.

"Without doubt, sire," replied Rapp.

Napoleon looked at him.

"Do you remember, sire, what you did me the honor to say at
Smolensk?" continued Rapp. "The wine is drawn and must be drunk."

Napoleon frowned and sat silent for a long time leaning his head
on his hand.

"This poor army!" he suddenly remarked. "It has diminished greatly
since Smolensk. Fortune is frankly a courtesan, Rapp. I have always
said so and I am beginning to experience it. But the Guards, Rapp, the
Guards are intact?" he remarked interrogatively.

"Yes, sire," replied Rapp.

Napoleon took a lozenge, put it in his mouth, and glanced at his
watch. He was not sleepy and it was still not nearly morning. It was
impossible to give further orders for the sake of killing time, for
the orders had all been given and were now being executed.

"Have the biscuits and rice been served out to the regiments of
the Guards?" asked Napoleon sternly.

"Yes, sire."

"The rice too?"

Rapp replied that he had given the Emperor's order about the rice,
but Napoleon shook his head in dissatisfaction as if not believing
that his order had been executed. An attendant came in with punch.
Napoleon ordered another glass to be brought for Rapp, and silently
sipped his own.

"I have neither taste nor smell," he remarked, sniffing at his
glass. "This cold is tiresome. They talk about medicine--what is the
good of medicine when it can't cure a cold! Corvisart gave me these
lozenges but they don't help at all. What can doctors cure? One
can't cure anything. Our body is a machine for living. It is organized
for that, it is its nature. Let life go on in it unhindered and let it
defend itself, it will do more than if you paralyze it by
encumbering it with remedies. Our body is like a perfect watch that
should go for a certain time; watchmaker cannot open it, he can only
adjust it by fumbling, and that blindfold.... Yes, our body is just
a machine for living, that is all."

And having entered on the path of definition, of which he was
fond, Napoleon suddenly and unexpectedly gave a new one.

"Do you know, Rapp, what military art is?" asked he. "It is the
art of being stronger than the enemy at a given moment. That's all."

Rapp made no reply.

"Tomorrow we shall have to deal with Kutuzov!" said Napoleon. "We
shall see! Do you remember at Braunau he commanded an army for three
weeks and did not once mount a horse to inspect his
entrenchments.... We shall see!"

He looked at his watch. It was still only four o'clock. He did not
feel sleepy. The punch was finished and there was still nothing to do.
He rose, walked to and fro, put on a warm overcoat and a hat, and went
out of the tent. The night was dark and damp, a scarcely perceptible
moisture was descending from above. Near by, the campfires were
dimly burning among the French Guards, and in the distance those of
the Russian line shone through the smoke. The weather was calm, and
the rustle and tramp of the French troops already beginning to move to
take up their positions were clearly audible.

Napoleon walked about in front of his tent, looked at the fires
and listened to these sounds, and as he was passing a tall guardsman
in a shaggy cap, who was standing sentinel before his tent and had
drawn himself up like a black pillar at sight of the Emperor, Napoleon
stopped in front of him.

"What year did you enter the service?" he asked with that
affectation of military bluntness and geniality with which he always
addressed the soldiers.

The man answered the question.

"Ah! One of the old ones! Has your regiment had its rice?"

"It has, Your Majesty."

Napoleon nodded and walked away.


At half-past five Napoleon rode to the village of Shevardino.

It was growing light, the sky was clearing, only a single cloud
lay in the east. The abandoned campfires were burning themselves out
in the faint morning light.

On the right a single deep report of a cannon resounded and died
away in the prevailing silence. Some minutes passed. A second and a
third report shook the air, then a fourth and a fifth boomed
solemnly near by on the right.

The first shots had not yet ceased to reverberate before others rang
out and yet more were heard mingling with and overtaking one another.

Napoleon with his suite rode up to the Shevardino Redoubt where he
dismounted. The game had begun.





CHAPTER XXX


On returning to Gorki after having seen Prince Andrew, Pierre
ordered his groom to get the horses ready and to call him early in the
morning, and then immediately fell asleep behind a partition in a
corner Boris had given up to him.

Before he was thoroughly awake next morning everybody had already
left the hut. The panes were rattling in the little windows and his
groom was shaking him.

"Your excellency! Your excellency! Your excellency!" he kept
repeating pertinaciously while he shook Pierre by the shoulder without
looking at him, having apparently lost hope of getting him to wake up.

"What? Has it begun? Is it time?" Pierre asked, waking up.

"Hear the firing," said the groom, a discharged soldier. "All the
gentlemen have gone out, and his Serene Highness himself rode past
long ago."

Pierre dressed hastily and ran out to the porch. Outside all was
bright, fresh, dewy, and cheerful. The sun, just bursting forth from
behind a cloud that had concealed it, was shining, with rays still
half broken by the clouds, over the roofs of the street opposite, on
the dew-besprinkled dust of the road, on the walls of the houses, on
the windows, the fence, and on Pierre's horses standing before the
hut. The roar of guns sounded more distinct outside. An adjutant
accompanied by a Cossack passed by at a sharp trot.

"It's time, Count; it's time!" cried the adjutant.

Telling the groom to follow him with the horses, Pierre went down
the street to the knoll from which he had looked at the field of
battle the day before. A crowd of military men was assembled there,
members of the staff could be heard conversing in French, and
Kutuzov's gray head in a white cap with a red band was visible, his
gray nape sunk between his shoulders. He was looking through a field
glass down the highroad before him.

Mounting the steps to the knoll Pierre looked at the scene before
him, spellbound by beauty. It was the same panorama he had admired
from that spot the day before, but now the whole place was full of
troops and covered by smoke clouds from the guns, and the slanting
rays of the bright sun, rising slightly to the left behind Pierre,
cast upon it through the clear morning air penetrating streaks of
rosy, golden tinted light and long dark shadows. The forest at the
farthest extremity of the panorama seemed carved in some precious
stone of a yellowish-green color; its undulating outline was
silhouetted against the horizon and was pierced beyond Valuevo by
the Smolensk highroad crowded with troops. Nearer at hand glittered
golden cornfields interspersed with copses. There were troops to be
seen everywhere, in front and to the right and left. All this was
vivid, majestic, and unexpected; but what impressed Pierre most of all
was the view of the battlefield itself, of Borodino and the hollows on
both sides of the Kolocha.

Above the Kolocha, in Borodino and on both sides of it, especially
to the left where the Voyna flowing between its marshy banks falls
into the Kolocha, a mist had spread which seemed to melt, to dissolve,
and to become translucent when the brilliant sun appeared and
magically colored and outlined everything. The smoke of the guns
mingled with this mist, and over the whole expanse and through that
mist the rays of the morning sun were reflected, flashing back like
lightning from the water, from the dew, and from the bayonets of the
troops crowded together by the riverbanks and in Borodino. A white
church could be seen through the mist, and here and there the roofs of
huts in Borodino as well as dense masses of soldiers, or green
ammunition chests and ordnance. And all this moved, or seemed to move,
as the smoke and mist spread out over the whole space. Just as in
the mist-enveloped hollow near Borodino, so along the entire line
outside and above it and especially in the woods and fields to the
left, in the valleys and on the summits of the high ground, clouds
of powder smoke seemed continually to spring up out of nothing, now
singly, now several at a time, some translucent, others dense,
which, swelling, growing, rolling, and blending, extended over the
whole expanse.

These puffs of smoke and (strange to say) the sound of
the firing produced the chief beauty of the spectacle.

"Puff!"--suddenly a round compact cloud of smoke was seen merging
from violet into gray and milky white, and "boom!" came the report a
second later.

"Puff! puff!"--and two clouds arose pushing one another and blending
together; and "boom, boom!" came the sounds confirming what the eye
had seen.

Pierre glanced round at the first cloud, which he had seen as a
round compact ball, and in its place already were balloons of smoke
floating to one side, and--"puff" (with a pause)--"puff, puff!"
three and then four more appeared and then from each, with the same
interval--"boom--boom, boom!" came the fine, firm, precise sounds in
reply. It seemed as if those smoke clouds sometimes ran and
sometimes stood still while woods, fields, and glittering bayonets ran
past them. From the left, over fields and bushes, those large balls of
smoke were continually appearing followed by their solemn reports,
while nearer still, in the hollows and woods, there burst from the
muskets small cloudlets that had no time to become balls, but had
their little echoes in just the same way. "Trakh-ta-ta-takh!" came the
frequent crackle of musketry, but it was irregular and feeble in
comparison with the reports of the cannon.

Pierre wished to be there with that smoke, those shining bayonets,
that movement, and those sounds. He turned to look at Kutuzov and
his suite, to compare his impressions with those of others. They
were all looking at the field of battle as he was, and, as it seemed
to him, with the same feelings. All their faces were now shining
with that latent warmth of feeling Pierre had noticed the day before
and had fully understood after his talk with Prince Andrew.

"Go, my dear fellow, go... and Christ be with you!" Kutuzov was
saying to a general who stood beside him, not taking his eye from
the battlefield.

Having received this order the general passed by Pierre on his way
down the knoll.

"To the crossing!" said the general coldly and sternly in reply to
one of the staff who asked where he was going.

"I'll go there too, I too!" thought Pierre, and followed the
general.

The general mounted a horse a Cossack had brought him. Pierre went
to his groom who was holding his horses and, asking which was the
quietest, clambered onto it, seized it by the mane, and turning out
his toes pressed his heels against its sides and, feeling that his
spectacles were slipping off but unable to let go of the mane and
reins, he galloped after the general, causing the staff officers to
smile as they watched him from the knoll.





CHAPTER XXXI


Having descended the hill the general after whom Pierre was
galloping turned sharply to the left, and Pierre, losing sight of him,
galloped in among some ranks of infantry marching ahead of him. He
tried to pass either in front of them or to the right or left, but
there were soldiers everywhere, all with expression and busy with some
unseen but evidently important task. They all gazed with the same
dissatisfied and inquiring expression at this stout man in a white
hat, who for some unknown reason threatened to trample them under
his horse's hoofs.

"Why ride into the middle of the battalion?" one of them shouted
at him.

Another prodded his horse with the butt end of a musket, and Pierre,
bending over his saddlebow and hardly able to control his shying
horse, galloped ahead of the soldiers where there was a free space.

There was a bridge ahead of him, where other soldiers stood
firing. Pierre rode up to them. Without being aware of it he had
come to the bridge across the Kolocha between Gorki and Borodino,
which the French (having occupied Borodino) were attacking in the
first phase of the battle. Pierre saw that there was a bridge in front
of him and that soldiers were doing something on both sides of it
and in the meadow, among the rows of new-mown hay which he had taken
no notice of amid the smoke of the campfires the day before; but
despite the incessant firing going on there he had no idea that this
was the field of battle. He did not notice the sound of the bullets
whistling from every side, or the projectiles that flew over him,
did not see the enemy on the other side of the river, and for a long
time did not notice the killed and wounded, though many fell near him.
He looked about him with a smile which did not leave his face.

"Why's that fellow in front of the line?" shouted somebody at him
again.

"To the left!... Keep to the right!" the men shouted to him.

Pierre went to the right, and unexpectedly encountered one of
Raevski's adjutants whom he knew. The adjutant looked angrily at
him, evidently also intending to shout at him, but on recognizing
him he nodded.

"How have you got here?" he said, and galloped on.

Pierre, feeling out of place there, having nothing to do, and afraid
of getting in someone's way again, galloped after the adjutant.

"What's happening here? May I come with you?" he asked.

"One moment, one moment!" replied the adjutant, and riding up to a
stout colonel who was standing in the meadow, he gave him some message
and then addressed Pierre.

"Why have you come here, Count?" he asked with a smile. "Still
inquisitive?"

"Yes, yes," assented Pierre.

But the adjutant turned his horse about and rode on.

"Here it's tolerable," said he, "but with Bagration on the left
flank they're getting it frightfully hot."

"Really?" said Pierre. "Where is that?"

"Come along with me to our knoll. We can get a view from there and
in our battery it is still bearable," said the adjutant. "Will you
come?"

"Yes, I'll come with you," replied Pierre, looking round for his
groom.

It was only now that he noticed wounded men staggering along or
being carried on stretchers. On that very meadow he had ridden over
the day before, a soldier was lying athwart the rows of scented hay,
with his head thrown awkwardly back and his shako off.

"Why haven't they carried him away?" Pierre was about to ask, but
seeing the stern expression of the adjutant who was also looking
that way, he checked himself.

Pierre did not find his groom and rode along the hollow with the
adjutant to Raevski's Redoubt. His horse lagged behind the
adjutant's and jolted him at every step.

"You don't seem to be used to riding, Count?" remarked the adjutant.

"No it's not that, but her action seems so jerky," said Pierre in
a puzzled tone.

"Why... she's wounded!" said the adjutant. "In the off foreleg above
the knee. A bullet, no doubt. I congratulate you, Count, on your
baptism of fire!"

Having ridden in the smoke past the Sixth Corps, behind the
artillery which had been moved forward and was in action, deafening
them with the noise of firing, they came to a small wood. There it was
cool and quiet, with a scent of autumn. Pierre and the adjutant
dismounted and walked up the hill on foot.

"Is the general here?" asked the adjutant on reaching the knoll.

"He was here a minute ago but has just gone that way," someone
told him, pointing to the right.

The adjutant looked at Pierre as if puzzled what to do with him now.

"Don't trouble about me," said Pierre. "I'll go up onto the knoll if
I may?"

"Yes, do. You'll see everything from there and it's less
dangerous, and I'll come for you."

Pierre went to the battery and the adjutant rode on. They did not
meet again, and only much later did Pierre learn that he lost an arm
that day.

The knoll to which Pierre ascended was that famous one afterwards
known to the Russians as the Knoll Battery or Raevski's Redoubt, and
to the French as la grande redoute, la fatale redoute, la redoute du
centre, around which tens of thousands fell, and which the French
regarded as the key to the whole position.

This redoubt consisted of a knoll, on three sides of which
trenches had been dug. Within the entrenchment stood ten guns that
were being fired through openings in the earthwork.

In line with the knoll on both sides stood other guns which also
fired incessantly. A little behind the guns stood infantry. When
ascending that knoll Pierre had no notion that this spot, on which
small trenches had been dug and from which a few guns were firing, was
the most important point of the battle.

On the contrary, just because he happened to be there he thought
it one of the least significant parts of the field.

Having reached the knoll, Pierre sat down at one end of a trench
surrounding the battery and gazed at what was going on around him with
an unconsciously happy smile. Occasionally he rose and walked about
the battery still with that same smile, trying not to obstruct the
soldiers who were loading, hauling the guns, and continually running
past him with bags and charges. The guns of that battery were being
fired continually one after another with a deafening roar,
enveloping the whole neighborhood in powder smoke.

In contrast with the dread felt by the infantrymen placed in
support, here in the battery where a small number of men busy at their
work were separated from the rest by a trench, everyone experienced
a common and as it were family feeling of animation.

The intrusion of Pierre's nonmilitary figure in a white hat made
an unpleasant impression at first. The soldiers looked askance at
him with surprise and even alarm as they went past him. The senior
artillery officer, a tall, long-legged, pockmarked man, moved over
to Pierre as if to see the action of the farthest gun and looked at
him with curiosity.

A young round-faced officer, quite a boy still and evidently only
just out of the Cadet College, who was zealously commanding the two
guns entrusted to him, addressed Pierre sternly.

"Sir," he said, "permit me to ask you to stand aside. You must not
be here."

The soldiers shook their heads disapprovingly as they looked at
Pierre. But when they had convinced themselves that this man in the
white hat was doing no harm, but either sat quietly on the slope of
the trench with a shy smile or, politely making way for the
soldiers, paced up and down the battery under fire as calmly as if
he were on a boulevard, their feeling of hostile distrust gradually
began to change into a kindly and bantering sympathy, such as soldiers
feel for their dogs, cocks, goats, and in general for the animals that
live with the regiment. The men soon accepted Pierre into their
family, adopted him, gave him a nickname ("our gentleman"), and made
kindly fun of him among themselves.

A shell tore up the earth two paces from Pierre and he looked around
with a smile as he brushed from his clothes some earth it had thrown
up.

"And how's it you're not afraid, sir, really now?" a red-faced,
broad-shouldered soldier asked Pierre, with a grin that disclosed a
set of sound, white teeth.

"Are you afraid, then?" said Pierre.

"What else do you expect?" answered the soldier. "She has no
mercy, you know! When she comes spluttering down, out go your innards.
One can't help being afraid," he said laughing.

Several of the men, with bright kindly faces, stopped beside Pierre.
They seemed not to have expected him to talk like anybody else, and
the discovery that he did so delighted them.

"It's the business of us soldiers. But in a gentleman it's
wonderful! There's a gentleman for you!"

"To your places!" cried the young officer to the men gathered
round Pierre.

The young officer was evidently exercising his duties for the
first or second time and therefore treated both his superiors and
the men with great precision and formality.

The booming cannonade and the fusillade of musketry were growing
more intense over the whole field, especially to the left where
Bagration's fleches were, but where Pierre was the smoke of the firing
made it almost impossible to distinguish anything. Moreover, his whole
attention was engrossed by watching the family circle--separated
from all else--formed by the men in the battery. His first unconscious
feeling of joyful animation produced by the sights and sounds of the
battlefield was now replaced by another, especially since he had
seen that soldier lying alone in the hayfield. Now, seated on the
slope of the trench, he observed the faces of those around him.

By ten o'clock some twenty men had already been carried away from
the battery; two guns were smashed and cannon balls fell more and more
frequently on the battery and spent bullets buzzed and whistled
around. But the men in the battery seemed not to notice this, and
merry voices and jokes were heard on all sides.

"A live one!" shouted a man as a whistling shell approached.

"Not this way! To the infantry!" added another with loud laughter,
seeing the shell fly past and fall into the ranks of the supports.

"Are you bowing to a friend, eh?" remarked another, chaffing a
peasant who ducked low as a cannon ball flew over.

Several soldiers gathered by the wall of the trench, looking out
to see what was happening in front.

"They've withdrawn the front line, it has retired," said they,
pointing over the earthwork.

"Mind your own business," an old sergeant shouted at them. "If
they've retired it's because there's work for them to do farther
back."

And the sergeant, taking one of the men by the shoulders, gave him a
shove with his knee. This was followed by a burst of laughter.

"To the fifth gun, wheel it up!" came shouts from one side.

"Now then, all together, like bargees!" rose the merry voices of
those who were moving the gun.

"Oh, she nearly knocked our gentleman's hat off!" cried the
red-faced humorist, showing his teeth chaffing Pierre. "Awkward
baggage!" he added reproachfully to a cannon ball that struck a cannon
wheel and a man's leg.

"Now then, you foxes!" said another, laughing at some militiamen
who, stooping low, entered the battery to carry away the wounded man.

"So this gruel isn't to your taste? Oh, you crows! You're scared!"
they shouted at the militiamen who stood hesitating before the man
whose leg had been torn off.

"There, lads... oh, oh!" they mimicked the peasants, "they don't
like it at all!"

Pierre noticed that after every ball that hit the redoubt, and after
every loss, the liveliness increased more and more.

As the flames of the fire hidden within come more and more vividly
and rapidly from an approaching thundercloud, so, as if in
opposition to what was taking place, the lightning of hidden fire
growing more and more intense glowed in the faces of these men.

Pierre did not look out at the battlefield and was not concerned
to know what was happening there; he was entirely absorbed in watching
this fire which burned ever more brightly and which he felt was
flaming up in the same way in his own soul.

At ten o'clock the infantry that had been among the bushes in
front of the battery and along the Kamenka streamlet retreated. From
the battery they could be seen running back past it carrying their
wounded on their muskets. A general with his suite came to the
battery, and after speaking to the colonel gave Pierre an angry look
and went away again having ordered the infantry supports behind the
battery to lie down, so as to be less exposed to fire. After this from
amid the ranks of infantry to the right of the battery came the
sound of a drum and shouts of command, and from the battery one saw
how those ranks of infantry moved forward.

Pierre looked over the wall of the trench and was particularly
struck by a pale young officer who, letting his sword hang down, was
walking backwards and kept glancing uneasily around.

The ranks of the infantry disappeared amid the smoke but their
long-drawn shout and rapid musketry firing could still be heard. A few
minutes later crowds of wounded men and stretcher-bearers came back
from that direction. Projectiles began to fall still more frequently
in the battery. Several men were lying about who had not been removed.
Around the cannon the men moved still more briskly and busily. No
one any longer took notice of Pierre. Once or twice he was shouted
at for being in the way. The senior officer moved with big, rapid
strides from one gun to another with a frowning face. The young
officer, with his face still more flushed, commanded the men more
scrupulously than ever. The soldiers handed up the charges, turned,
loaded, and did their business with strained smartness. They gave
little jumps as they walked, as though they were on springs.

The stormcloud had come upon them, and in every face the fire
which Pierre had watched kindle burned up brightly. Pierre standing
beside the commanding officer. The young officer, his hand to his
shako, ran up to his superior.

"I have the honor to report, sir, that only eight rounds are left.
Are we to continue firing?" he asked.

"Grapeshot!" the senior shouted, without answering the question,
looking over the wall of the trench.

Suddenly something happened: the young officer gave a gasp and
bending double sat down on the ground like a bird shot on the wing.
Everything became strange, confused, and misty in Pierre's eyes.

One cannon ball after another whistled by and struck the
earthwork, a soldier, or a gun. Pierre, who had not noticed these
sounds before, now heard nothing else. On the right of the battery
soldiers shouting "Hurrah!" were running not forwards but backwards,
it seemed to Pierre.

A cannon ball struck the very end of the earth work by which he
was standing, crumbling down the earth; a black ball flashed before
his eyes and at the same instant plumped into something. Some
militiamen who were entering the battery ran back.

"All with grapeshot!" shouted the officer.

The sergeant ran up to the officer and in a frightened whisper
informed him (as a butler at dinner informs his master that there is
no more of some wine asked for) that there were no more charges.

"The scoundrels! What are they doing?" shouted the officer,
turning to Pierre.

The officer's face was red and perspiring and his eyes glittered
under his frowning brow.

"Run to the reserves and bring up the ammunition boxes!" he
yelled, angrily avoiding Pierre with his eyes and speaking to his men.

"I'll go," said Pierre.

The officer, without answering him, strode across to the opposite
side.

"Don't fire.... Wait!" he shouted.

The man who had been ordered to go for ammunition stumbled against
Pierre.

"Eh, sir, this is no place for you," said he, and ran down the
slope.

Pierre ran after him, avoiding the spot where the young officer
was sitting.

One cannon ball, another, and a third flew over him, falling in
front, beside, and behind him. Pierre ran down the slope. "Where am
I going?" he suddenly asked himself when he was already near the green
ammunition wagons. He halted irresolutely, not knowing whether to
return or go on. Suddenly a terrible concussion threw him backwards to
the ground. At the same instant he was dazzled by a great flash of
flame, and immediately a deafening roar, crackling, and whistling made
his ears tingle.

When he came to himself he was sitting on the ground leaning on
his hands; the ammunition wagons he had been approaching no longer
existed, only charred green boards and rags littered the scorched
grass, and a horse, dangling fragments of its shaft behind it,
galloped past, while another horse lay, like Pierre, on the ground,
uttering prolonged and piercing cries.





CHAPTER XXXII


Beside himself with terror Pierre jumped up and ran back to the
battery, as to the only refuge from the horrors that surrounded him.

On entering the earthwork he noticed that there were men doing
something there but that no shots were being fired from the battery.
He had no time to realize who these men were. He saw the senior
officer lying on the earth wall with his back turned as if he were
examining something down below and that one of the soldiers he had
noticed before was struggling forward shouting "Brothers!" and
trying to free himself from some men who were holding him by the
arm. He also saw something else that was strange.

But he had not time to realize that the colonel had been killed,
that the soldier shouting "Brothers!" was a prisoner, and that another
man had been bayoneted in the back before his eyes, for hardly had
he run into the redoubt before a thin, sallow-faced, perspiring man in
a blue uniform rushed on him sword in hand, shouting something.
Instinctively guarding against the shock--for they had been running
together at full speed before they saw one another--Pierre put out his
hands and seized the man (a French officer) by the shoulder with one
hand and by the throat with the other. The officer, dropping his
sword, seized Pierre by his collar.

For some seconds they gazed with frightened eyes at one another's
unfamiliar faces and both were perplexed at what they had done and
what they were to do next. "Am I taken prisoner or have I taken him
prisoner?" each was thinking. But the French officer was evidently
more inclined to think he had been taken prisoner because Pierre's
strong hand, impelled by instinctive fear, squeezed his throat ever
tighter and tighter. The Frenchman was about to say something, when
just above their heads, terrible and low, a cannon ball whistled,
and it seemed to Pierre that the French officer's head had been torn
off, so swiftly had he ducked it.

Pierre too bent his head and let his hands fall. Without further
thought as to who had taken whom prisoner, the Frenchman ran back to
the battery and Pierre ran down the slope stumbling over the dead
and wounded who, it seemed to him, caught at his feet. But before he
reached the foot of the knoll he was met by a dense crowd of Russian
soldiers who, stumbling, tripping up, and shouting, ran merrily and
wildly toward the battery. (This was the attack for which Ermolov
claimed the credit, declaring that only his courage and good luck made
such a feat possible: it was the attack in which he was said to have
thrown some St. George's Crosses he had in his pocket into the battery
for the first soldiers to take who got there.)

The French who had occupied the battery fled, and our troops
shouting "Hurrah!" pursued them so far beyond the battery that it
was difficult to call them back.

The prisoners were brought down from the battery and among them
was a wounded French general, whom the officers surrounded. Crowds
of wounded--some known to Pierre and some unknown--Russians and
French, with faces distorted by suffering, walked, crawled, and were
carried on stretchers from the battery. Pierre again went up onto
the knoll where he had spent over an hour, and of that family circle
which had received him as a member he did not find a single one. There
were many dead whom he did not know, but some he recognized. The young
officer still sat in the same way, bent double, in a pool of blood
at the edge of the earth wall. The red-faced man was still
twitching, but they did not carry him away.

Pierre ran down the slope once more.

"Now they will stop it, now they will be horrified at what they have
done!" he thought, aimlessly going toward a crowd of stretcher bearers
moving from the battlefield.

But behind the veil of smoke the sun was still high, and in front
and especially to the left, near Semenovsk, something seemed to be
seething in the smoke, and the roar of cannon and musketry did not
diminish, but even increased to desperation like a man who,
straining himself, shrieks with all his remaining strength.





CHAPTER XXXIII


The chief action of the battle of Borodino was fought within the
seven thousand feet between Borodino and Bagration's fleches. Beyond
that space there was, on the one side, a demonstration made by the
Russians with Uvarov's cavalry at midday, and on the other side,
beyond Utitsa, Poniatowski's collision with Tuchkov; but these two
were detached and feeble actions in comparison with what took place in
the center of the battlefield. On the field between Borodino and the
fleches, beside the wood, the chief action of the day took place on an
open space visible from both sides and was fought in the simplest
and most artless way.

The battle began on both sides with a cannonade from several hundred
guns.

Then when the whole field was covered with smoke, two divisions,
Campan's and Dessaix's, advanced from the French right, while
Murat's troops advanced on Borodino from their left.

From the Shevardino Redoubt where Napoleon was standing the
fleches were two thirds of a mile away, and it was more than a mile as
the crow flies to Borodino, so that Napoleon could not see what was
happening there, especially as the smoke mingling with the mist hid
the whole locality. The soldiers of Dessaix's division advancing
against the fleches could only be seen till they had entered the
hollow that lay between them and the fleches. As soon as they had
descended into that hollow, the smoke of the guns and musketry on
the fleches grew so dense that it covered the whole approach on that
side of it. Through the smoke glimpses could be caught of something
black--probably men--and at times the glint of bayonets. But whether
they were moving or stationary, whether they were French or Russian,
could not be discovered from the Shevardino Redoubt.

The sun had risen brightly and its slanting rays struck straight
into Napoleon's face as, shading his eyes with his hand, he looked
at the fleches. The smoke spread out before them, and at times it
looked as if the smoke were moving, at times as if the troops moved.
Sometimes shouts were heard through the firing, but it was
impossible to tell what was being done there.

Napoleon, standing on the knoll, looked through a field glass, and
in its small circlet saw smoke and men, sometimes his own and
sometimes Russians, but when he looked again with the naked eye, he
could not tell where what he had seen was.

He descended the knoll and began walking up and down before it.

Occasionally he stopped, listened to the firing, and gazed
intently at the battlefield.

But not only was it impossible to make out what was happening from
where he was standing down below, or from the knoll above on which
some of his generals had taken their stand, but even from the
fleches themselves--in which by this time there were now Russian and
now French soldiers, alternately or together, dead, wounded, alive,
frightened, or maddened--even at those fleches themselves it was
impossible to make out what was taking place. There for several
hours amid incessant cannon and musketry fire, now Russians were
seen alone, now Frenchmen alone, now infantry, and now cavalry: they
appeared, fired, fell, collided, not knowing what to do with one
another, screamed, and ran back again.

From the battlefield adjutants he had sent out, and orderlies from
his marshals, kept galloping up to Napoleon with reports of the
progress of the action, but all these reports were false, both because
it was impossible in the heat of battle to say what was happening at
any given moment and because many of the adjutants did not go to the
actual place of conflict but reported what they had heard from others;
and also because while an adjutant was riding more than a mile to
Napoleon circumstances changed and the news he brought was already
becoming false. Thus an adjutant galloped up from Murat with tidings
that Borodino had been occupied and the bridge over the Kolocha was in
the hands of the French. The adjutant asked whether Napoleon wished
the troops to cross it? Napoleon gave orders that the troops should
form up on the farther side and wait. But before that order was given-
almost as soon in fact as the adjutant had left Borodino--the bridge
had been retaken by the Russians and burned, in the very skirmish at
which Pierre had been present at the beginning of the battle.

An adjutant galloped up from the fleches with a pale and
frightened face and reported to Napoleon that their attack had been
repulsed, Campan wounded, and Davout killed; yet at the very time
the adjutant had been told that the French had been repulsed, the
fleches had in fact been recaptured by other French troops, and Davout
was alive and only slightly bruised. On the basis of these necessarily
untrustworthy reports Napoleon gave his orders, which had either
been executed before he gave them or could not be and were not
executed.

The marshals and generals, who were nearer to the field of battle
but, like Napoleon, did not take part in the actual fighting and
only occasionally went within musket range, made their own
arrangements without asking Napoleon and issued orders where and in
what direction to fire and where cavalry should gallop and infantry
should run. But even their orders, like Napoleon's, were seldom
carried out, and then but partially. For the most part things happened
contrary to their orders. Soldiers ordered to advance ran back on
meeting grapeshot; soldiers ordered to remain where they were,
suddenly, seeing Russians unexpectedly before them, sometimes rushed
back and sometimes forward, and the cavalry dashed without orders in
pursuit of the flying Russians. In this way two cavalry regiments
galloped through the Semenovsk hollow and as soon as they reached
the top of the incline turned round and galloped full speed back
again. The infantry moved in the same way, sometimes running to
quite other places than those they were ordered to go to. All orders
as to where and when to move the guns, when to send infantry to
shoot or horsemen to ride down the Russian infantry--all such orders
were given by the officers on the spot nearest to the units concerned,
without asking either Ney, Davout, or Murat, much less Napoleon.
They did not fear getting into trouble for not fulfilling orders or
for acting on their own initiative, for in battle what is at stake
is what is dearest to man--his own life--and it sometimes seems that
safety lies in running back, sometimes in running forward; and these
men who were right in the heat of the battle acted according to the
mood of the moment. In reality, however, all these movements forward
and backward did not improve or alter the position of the troops.
All their rushing and galloping at one another did little harm, the
harm of disablement and death was caused by the balls and bullets that
flew over the fields on which these men were floundering about. As
soon as they left the place where the balls and bullets were flying
about, their superiors, located in the background, re-formed them
and brought them under discipline and under the influence of that
discipline led them back to the zone of fire, where under the
influence of fear of death they lost their discipline and rushed about
according to the chance promptings of the throng.





CHAPTER XXXIV


Napoleon's generals--Davout, Ney, and Murat, who were near that
region of fire and sometimes even entered it--repeatedly led into it
huge masses of well-ordered troops. But contrary to what had always
happened in their former battles, instead of the news they expected of
the enemy's flight, these orderly masses returned thence as
disorganized and terrified mobs. The generals re-formed them, but
their numbers constantly decreased. In the middle of the day Murat
sent his adjutant to Napoleon to demand reinforcements.

Napoleon sat at the foot of the knoll, drinking punch, when
Murat's adjutant galloped up with an assurance that the Russians would
be routed if His Majesty would let him have another division.

"Reinforcements?" said Napoleon in a tone of stern surprise, looking
at the adjutant--a handsome lad with long black curls arranged like
Murat's own--as though he did not understand his words.

"Reinforcements!" thought Napoleon to himself. "How can they need
reinforcements when they already have half the army directed against a
weak, unentrenched Russian wing?"

"Tell the King of Naples," said he sternly, "that it is not noon
yet, and I don't yet see my chessboard clearly. Go!..."

The handsome boy adjutant with the long hair sighed deeply without
removing his hand from his hat and galloped back to where men were
being slaughtered.

Napoleon rose and having summoned Caulaincourt and Berthier began
talking to them about matters unconnected with the battle.

In the midst of this conversation, which was beginning to interest
Napoleon, Berthier's eyes turned to look at a general with a suite,
who was galloping toward the knoll on a lathering horse. It was
Belliard. Having dismounted he went up to the Emperor with rapid
strides and in a loud voice began boldly demonstrating the necessity
of sending reinforcements. He swore on his honor that the Russians
were lost if the Emperor would give another division.

Napoleon shrugged his shoulders and continued to pace up and down
without replying. Belliard began talking loudly and eagerly to the
generals of the suite around him.

"You are very fiery, Belliard," said Napoleon, when he again came up
to the general. "In the heat of a battle it is easy to make a mistake.
Go and have another look and then come back to me."

Before Belliard was out of sight, a messenger from another part of
the battlefield galloped up.

"Now then, what do you want?" asked Napoleon in the tone of a man
irritated at being continually disturbed.

"Sire, the prince..." began the adjutant.

"Asks for reinforcements?" said Napoleon with an angry gesture.

The adjutant bent his head affirmatively and began to report, but
the Emperor turned from him, took a couple of steps, stopped, came
back, and called Berthier.

"We must give reserves," he said, moving his arms slightly apart.
"Who do you think should be sent there?" he asked of Berthier (whom he
subsequently termed "that gosling I have made an eagle").

"Send Claparede's division, sire," replied Berthier, who knew all
the divisions regiments, and battalions by heart.

Napoleon nodded assent.

The adjutant galloped to Claparede's division and a few minutes
later the Young Guards stationed behind the knoll moved forward.
Napoleon gazed silently in that direction.

"No!" he suddenly said to Berthier. "I can't send Claparede. Send
Friant's division."

Though there was no advantage in sending Friant's division instead
of Claparede's, and even in obvious inconvenience and delay in
stopping Claparede and sending Friant now, the order was carried out
exactly. Napoleon did not notice that in regard to his army he was
playing the part of a doctor who hinders by his medicines--a role he
so justly understood and condemned.

Friant's division disappeared as the others had done into the
smoke of the battlefield. From all sides adjutants continued to arrive
at a gallop and as if by agreement all said the same thing. They all
asked for reinforcements and all said that the Russians were holding
their positions and maintaining a hellish fire under which the
French army was melting away.

Napoleon sat on a campstool, wrapped in thought.

M. de Beausset, the man so fond of travel, having fasted since
morning, came up to the Emperor and ventured respectfully to suggest
lunch to His Majesty.

"I hope I may now congratulate Your Majesty on a victory?" said he.

Napoleon silently shook his head in negation. Assuming the
negation to refer only to the victory and not to the lunch, M. de
Beausset ventured with respectful jocularity to remark that there is
no reason for not having lunch when one can get it.

"Go away..." exclaimed Napoleon suddenly and morosely, and turned
aside.

A beatific smile of regret, repentance, and ecstasy beamed on M.
de Beausset's face and he glided away to the other generals.

Napoleon was experiencing a feeling of depression like that of an
ever-lucky gambler who, after recklessly flinging money about and
always winning, suddenly just when he has calculated all the chances
of the game, finds that the more he considers his play the more surely
he loses.

His troops were the same, his generals the same, the same
preparations had been made, the same dispositions, and the same
proclamation courte et energique, he himself was still the same: he
knew that and knew that he was now even more experienced and
skillful than before. Even the enemy was the same as at Austerlitz and
Friedland--yet the terrible stroke of his arm had supernaturally
become impotent.

All the old methods that had been unfailingly crowned with
success: the concentration of batteries on one point, an attack by
reserves to break the enemy's line, and a cavalry attack by "the men
of iron," all these methods had already been employed, yet not only
was there no victory, but from all sides came the same news of
generals killed and wounded, of reinforcements needed, of the
impossibility of driving back the Russians, and of disorganization
among his own troops.

Formerly, after he had given two or three orders and uttered a few
phrases, marshals and adjutants had come galloping up with
congratulations and happy faces, announcing the trophies taken, the
corps of prisoners, bundles of enemy eagles and standards, cannon
and stores, and Murat had only begged leave to loose the cavalry to
gather in the baggage wagons. So it had been at Lodi, Marengo, Arcola,
Jena, Austerlitz, Wagram, and so on. But now something strange was
happening to his troops.

Despite news of the capture of the fleches, Napoleon saw that this
was not the same, not at all the same, as what had happened in his
former battles. He saw that what he was feeling was felt by all the
men about him experienced in the art of war. All their faces looked
dejected, and they all shunned one another's eyes--only a de
Beausset could fail to grasp the meaning of what was happening.

But Napoleon with his long experience of war well knew the meaning
of a battle not gained by the attacking side in eight hours, after all
efforts had been expended. He knew that it was a lost battle and
that the least accident might now--with the fight balanced on such a
strained center--destroy him and his army.

When he ran his mind over the whole of this strange Russian campaign
in which not one battle had been won, and in which not a flag, or
cannon, or army corps had been captured in two months, when he
looked at the concealed depression on the faces around him and heard
reports of the Russians still holding their ground--a terrible feeling
like a nightmare took possession of him, and all the unlucky accidents
that might destroy him occurred to his mind. The Russians might fall
on his left wing, might break through his center, he himself might
be killed by a stray cannon ball. All this was possible. In former
battles he had only considered the possibilities of success, but now
innumerable unlucky chances presented themselves, and he expected them
all. Yes, it was like a dream in which a man fancies that a ruffian is
coming to attack him, and raises his arm to strike that ruffian a
terrible blow which he knows should annihilate him, but then feels
that his arm drops powerless and limp like a rag, and the horror of
unavoidable destruction seizes him in his helplessness.

The news that the Russians were attacking the left flank of the
French army aroused that horror in Napoleon. He sat silently on a
campstool below the knoll, with head bowed and elbows on his knees.
Berthier approached and suggested that they should ride along the line
to ascertain the position of affairs.

"What? What do you say?" asked Napoleon. "Yes, tell them to bring me
my horse."

He mounted and rode toward Semenovsk.

Amid the powder smoke, slowly dispersing over the whole space
through which Napoleon rode, horses and men were lying in pools of
blood, singly or in heaps. Neither Napoleon nor any of his generals
had ever before seen such horrors or so many slain in such a small
area. The roar of guns, that had not ceased for ten hours, wearied the
ear and gave a peculiar significance to the spectacle, as music does
to tableaux vivants. Napoleon rode up the high ground at Semenovsk,
and through the smoke saw ranks of men in uniforms of a color
unfamiliar to him. They were Russians.

The Russians stood in serried ranks behind Semenovsk village and its
knoll, and their guns boomed incessantly along their line and sent
forth clouds of smoke. It was no longer a battle: it was a
continuous slaughter which could be of no avail either to the French
or the Russians. Napoleon stopped his horse and again fell into the
reverie from which Berthier had aroused him. He could not stop what
was going on before him and around him and was supposed to be directed
by him and to depend on him, and from its lack of success this affair,
for the first time, seemed to him unnecessary and horrible.

One of the generals rode up to Napoleon and ventured to offer to
lead the Old Guard into action. Ney and Berthier, standing near
Napoleon, exchanged looks and smiled contemptuously at this
general's senseless offer.

Napoleon bowed his head and remained silent a long time.

"At eight hundred leagues from France, I will not have my Guard
destroyed!" he said, and turning his horse rode back to Shevardino.





CHAPTER XXXV


On the rug-covered bench where Pierre had seen him in the morning
sat Kutuzov, his gray head hanging, his heavy body relaxed. He gave no
orders, but only assented to or dissented from what others suggested.

"Yes, yes, do that," he replied to various proposals. "Yes, yes: go,
dear boy, and have a look," he would say to one or another of those
about him; or, "No, don't, we'd better wait!" He listened to the
reports that were brought him and gave directions when his
subordinates demanded that of him; but when listening to the reports
it seemed as if he were not interested in the import of the words
spoken, but rather in something else--in the expression of face and
tone of voice of those who were reporting. By long years of military
experience he knew, and with the wisdom of age understood, that it
is impossible for one man to direct hundreds of thousands of others
struggling with death, and he knew that the result of a battle is
decided not by the orders of a commander in chief, nor the place where
the troops are stationed, nor by the number of cannon or of
slaughtered men, but by that intangible force called the spirit of the
army, and he watched this force and guided it in as far as that was in
his power.

Kutuzov's general expression was one of concentrated quiet
attention, and his face wore a strained look as if he found it
difficult to master the fatigue of his old and feeble body.

At eleven o'clock they brought him news that the fleches captured by
the French had been retaken, but that Prince Bagration was wounded.
Kutuzov groaned and swayed his head.

"Ride over to Prince Peter Ivanovich and find out about it exactly,"
he said to one of his adjutants, and then turned to the Duke of
Wurttemberg who was standing behind him.

"Will Your Highness please take command of the first army?"

Soon after the duke's departure--before he could possibly have
reached Semenovsk--his adjutant came back from him and told Kutuzov
that the duke asked for more troops.

Kutuzov made a grimace and sent an order to Dokhturov to take over
the command of the first army, and a request to the duke--whom he said
he could not spare at such an important moment--to return to him. When
they brought him news that Murat had been taken prisoner, and the
staff officers congratulated him, Kutuzov smiled.

"Wait a little, gentlemen," said he. "The battle is won, and there
is nothing extraordinary in the capture of Murat. Still, it is
better to wait before we rejoice."

But he sent an adjutant to take the news round the army.

When Scherbinin came galloping from the left flank with news that
the French had captured the fleches and the village of Semenovsk,
Kutuzov, guessing by the sounds of the battle and by Scherbinin's
looks that the news was bad, rose as if to stretch his legs and,
taking Scherbinin's arm, led him aside.

"Go, my dear fellow," he said to Ermolov, "and see whether something
can't be done."

Kutuzov was in Gorki, near the center of the Russian position. The
attack directed by Napoleon against our left flank had been several
times repulsed. In the center the French had not got beyond
Borodino, and on their left flank Uvarov's cavalry had put the
French to flight.

Toward three o'clock the French attacks ceased. On the faces of
all who came from the field of battle, and of those who stood around
him, Kutuzov noticed an expression of extreme tension. He was
satisfied with the day's success--a success exceeding his
expectations, but the old man's strength was failing him. Several
times his head dropped low as if it were falling and he dozed off.
Dinner was brought him.

Adjutant General Wolzogen, the man who when riding past Prince
Andrew had said, "the war should be extended widely," and whom
Bagration so detested, rode up while Kutuzov was at dinner. Wolzogen
had come from Barclay de Tolly to report on the progress of affairs on
the left flank. The sagacious Barclay de Tolly, seeing crowds of
wounded men running back and the disordered rear of the army,
weighed all the circumstances, concluded that the battle was lost, and
sent his favorite officer to the commander in chief with that news.

Kutuzov was chewing a piece of roast chicken with difficulty and
glanced at Wolzogen with eyes that brightened under their puckering
lids.

Wolzogen, nonchalantly stretching his legs, approached Kutuzov
with a half-contemptuous smile on his lips, scarcely touching the peak
of his cap.

He treated his Serene Highness with a somewhat affected
nonchalance intended to show that, as a highly trained military man,
he left it to Russians to make an idol of this useless old man, but
that he knew whom he was dealing with. "Der alte Herr" (as in their
own set the Germans called Kutuzov) "is making himself very
comfortable," thought Wolzogen, and looking severely at the dishes
in front of Kutuzov he began to report to "the old gentleman" the
position of affairs on the left flank as Barclay had ordered him to
and as he himself had seen and understood it.

"All the points of our position are in the enemy's hands and we
cannot dislodge them for lack of troops, the men are running away
and it is impossible to stop them," he reported.

Kutuzov ceased chewing and fixed an astonished gaze on Wolzogen,
as if not understand what was said to him. Wolzogen, noticing "the old
gentleman's" agitation, said with a smile:

"I have not considered it right to conceal from your Serene Highness
what I have seen. The troops are in complete disorder..."

"You have seen? You have seen?..." Kutuzov shouted frowning, and
rising quickly he went up to Wolzogen.

"How... how dare you!..." he shouted, choking and making a
threatening gesture with his trembling arms: "How dare you, sir, say
that to me? You know nothing about it. Tell General Barclay from me
that his information is incorrect and that the real course of the
battle is better known to me, the commander in chief, than to him."

Wolzogen was about to make a rejoinder, but Kutuzov interrupted him.

"The enemy has been repulsed on the left and defeated on the right
flank. If you have seen amiss, sir, do not allow yourself to say
what you don't know! Be so good as to ride to General Barclay and
inform him of my firm intention to attack the enemy tomorrow," said
Kutuzov sternly.

All were silent, and the only sound audible was the heavy
breathing of the panting old general.

"They are repulsed everywhere, for which I thank God and our brave
army! The enemy is beaten, and tomorrow we shall drive him from the
sacred soil of Russia," said Kutuzov crossing himself, and he suddenly
sobbed as his eyes filled with tears.

Wolzogen, shrugging his shoulders and curling his lips, stepped
silently aside, marveling at "the old gentleman's" conceited
stupidity.

"Ah, here he is, my hero!" said Kutuzov to a portly, handsome,
dark-haired general who was just ascending the knoll.

This was Raevski, who had spent the whole day at the most
important part of the field of Borodino.

Raevski reported that the troops were firmly holding their ground
and that the French no longer ventured to attack.

After hearing him, Kutuzov said in French:

"Then you do not think, like some others, that we must retreat?"

"On the contrary, your Highness, in indecisive actions it is
always the most stubborn who remain victors," replied Raevski, "and in
my opinion..."

"Kaysarov!" Kutuzov called to his adjutant. "Sit down and write
out the order of the day for tomorrow. And you," he continued,
addressing another, "ride along the line and that tomorrow we attack."

While Kutuzov was talking to Raevski and dictating the order of
the day, Wolzogen returned from Barclay and said that General
Barclay wished to have written confirmation of the order the field
marshal had given.

Kutuzov, without looking at Wolzogen, gave directions for the
order to be written out which the former commander in chief, to
avoid personal responsibility, very judiciously wished to receive.

And by means of that mysterious indefinable bond which maintains
throughout an army one and the same temper, known as "the spirit of
the army," and which constitutes the sinew of war, Kutuzov's words,
his order for a battle next day, immediately became known from one end
of the army to the other.

It was far from being the same words or the same order that
reached the farthest links of that chain. The tales passing from mouth
to mouth at different ends of the army did not even resemble what
Kutuzov had said, but the sense of his words spread everywhere because
what he said was not the outcome of cunning calculations, but of a
feeling that lay in the commander in chief's soul as in that of
every Russian.

And on learning that tomorrow they were to attack the enemy, and
hearing from the highest quarters a confirmation of what they wanted
to believe, the exhausted, wavering men felt comforted and inspirited.





CHAPTER XXXVI


Prince Andrew's regiment was among the reserves which till after one
o'clock were stationed inactive behind Semenovsk, under heavy
artillery fire. Toward two o'clock the regiment, having already lost
more than two hundred men, was moved forward into a trampled
oatfield in the gap between Semenovsk and the Knoll Battery, where
thousands of men perished that day and on which an intense,
concentrated fire from several hundred enemy guns was directed between
one and two o'clock.

Without moving from that spot or firing a single shot the regiment
here lost another third of its men. From in front and especially
from the right, in the unlifting smoke the guns boomed, and out of the
mysterious domain of smoke that overlay the whole space in front,
quick hissing cannon balls and slow whistling shells flew unceasingly.
At times, as if to allow them a respite, a quarter of an hour passed
during which the cannon balls and shells all flew overhead, but
sometimes several men were torn from the regiment in a minute and
the slain were continually being dragged away and the wounded
carried off.

With each fresh blow less and less chance of life remained for those
not yet killed. The regiment stood in columns of battalion, three
hundred paces apart, but nevertheless the men were always in one and
the same mood. All alike were taciturn and morose. Talk was rarely
heard in the ranks, and it ceased altogether every time the thud of
a successful shot and the cry of "stretchers!" was heard. Most of
the time, by their officers' order, the men sat on the ground. One,
having taken off his shako, carefully loosened the gathers of its
lining and drew them tight again; another, rubbing some dry clay
between his palms, polished his bayonet; another fingered the strap
and pulled the buckle of his bandolier, while another smoothed and
refolded his leg bands and put his boots on again. Some built little
houses of the tufts in the plowed ground, or plaited baskets from
the straw in the cornfield. All seemed fully absorbed in these
pursuits. When men were killed or wounded, when rows of stretchers
went past, when some troops retreated, and when great masses of the
enemy came into view through the smoke, no one paid any attention to
these things. But when our artillery or cavalry advanced or some of
our infantry were seen to move forward, words of approval were heard
on all sides. But the liveliest attention was attracted by occurrences
quite apart from, and unconnected with, the battle. It was as if the
minds of these morally exhausted men found relief in everyday,
commonplace occurrences. A battery of artillery was passing in front
of the regiment. The horse of an ammunition cart put its leg over a
trace. "Hey, look at the trace horse!... Get her leg out! She'll
fall.... Ah, they don't see it!" came identical shouts from the
ranks all along the regiment. Another time, general attention was
attracted by a small brown dog, coming heaven knows whence, which
trotted in a preoccupied manner in front of the ranks with tail
stiffly erect till suddenly a shell fell close by, when it yelped,
tucked its tail between its legs, and darted aside. Yells and
shrieks of laughter rose from the whole regiment. But such
distractions lasted only a moment, and for eight hours the men had
been inactive, without food, in constant fear of death, and their pale
and gloomy faces grew ever paler and gloomier.

Prince Andrew, pale and gloomy like everyone in the regiment,
paced up and down from the border of one patch to another, at the edge
of the meadow beside an oatfield, with head bowed and arms behind
his back. There was nothing for him to do and no orders to be given.
Everything went on of itself. The killed were dragged from the
front, the wounded carried away, and the ranks closed up. If any
soldiers ran to the rear they returned immediately and hastily. At
first Prince Andrew, considering it his duty to rouse the courage of
the men and to set them an example, walked about among the ranks,
but he soon became convinced that this was unnecessary and that
there was nothing he could teach them. All the powers of his soul,
as of every soldier there, were unconsciously bent on avoiding the
contemplation of the horrors of their situation. He walked along the
meadow, dragging his feet, rustling the grass, and gazing at the
dust that covered his boots; now he took big strides trying to keep to
the footprints left on the meadow by the mowers, then he counted his
steps, calculating how often he must walk from one strip to another to
walk a mile, then he stripped the flowers from the wormwood that
grew along a boundary rut, rubbed them in his palms, and smelled their
pungent, sweetly bitter scent. Nothing remained of the previous
day's thoughts. He thought of nothing. He listened with weary ears
to the ever-recurring sounds, distinguishing the whistle of flying
projectiles from the booming of the reports, glanced at the tiresomely
familiar faces of the men of the first battalion, and waited. "Here it
comes... this one is coming our way again!" he thought, listening to
an approaching whistle in the hidden region of smoke. "One, another!
Again! It has hit...." He stopped and looked at the ranks. "No, it has
gone over. But this one has hit!" And again he started trying to reach
the boundary strip in sixteen paces. A whizz and a thud! Five paces
from him, a cannon ball tore up the dry earth and disappeared. A chill
ran down his back. Again he glanced at the ranks. Probably many had
been hit--a large crowd had gathered near the second battalion.

"Adjutant!" he shouted. "Order them not to crowd together."

The adjutant, having obeyed this instruction, approached Prince
Andrew. From the other side a battalion commander rode up.

"Look out!" came a frightened cry from a soldier and, like a bird
whirring in rapid flight and alighting on the ground, a shell
dropped with little noise within two steps of Prince Andrew and
close to the battalion commander's horse. The horse first,
regardless of whether it was right or wrong to show fear, snorted,
reared almost throwing the major, and galloped aside. The horse's
terror infected the men.

"Lie down!" cried the adjutant, throwing himself flat on the ground.

Prince Andrew hesitated. The smoking shell spun like a top between
him and the prostrate adjutant, near a wormwood plant between the
field and the meadow.

"Can this be death?" thought Prince Andrew, looking with a quite
new, envious glance at the grass, the wormwood, and the streamlet of
smoke that curled up from the rotating black ball. "I cannot, I do not
wish to die. I love life--I love this grass, this earth, this air...."
He thought this, and at the same time remembered that people were
looking at him.

"It's shameful, sir!" he said to the adjutant. "What..."

He did not finish speaking. At one and the same moment came the
sound of an explosion, a whistle of splinters as from a breaking
window frame, a suffocating smell of powder, and Prince Andrew started
to one side, raising his arm, and fell on his chest. Several
officers ran up to him. From the right side of his abdomen, blood
was welling out making a large stain on the grass.

The militiamen with stretchers who were called up stood behind the
officers. Prince Andrew lay on his chest with his face in the grass,
breathing heavily and noisily.

"What are you waiting for? Come along!"

The peasants went up and took him by his shoulders and legs, but
he moaned piteously and, exchanging looks, they set him down again.

"Pick him up, lift him, it's all the same!" cried someone.

They again took him by the shoulders and laid him on the stretcher.

"Ah, God! My God! What is it? The stomach? That means death! My
God!"--voices among the officers were heard saying.

"It flew a hair's breadth past my ear," said the adjutant.

The peasants, adjusting the stretcher to their shoulders, started
hurriedly along the path they had trodden down, to the dressing
station.

"Keep in step! Ah... those peasants!" shouted an officer, seizing by
their shoulders and checking the peasants, who were walking unevenly
and jolting the stretcher.

"Get into step, Fedor... I say, Fedor!" said the foremost peasant.

"Now that's right!" said the one behind joyfully, when he had got
into step.

"Your excellency! Eh, Prince!" said the trembling voice of Timokhin,
who had run up and was looking down on the stretcher.

Prince Andrew opened his eyes and looked up at the speaker from
the stretcher into which his head had sunk deep and again his
eyelids drooped.


The militiamen carried Prince Andrew to dressing station by the
wood, where wagons were stationed. The dressing station consisted of
three tents with flaps turned back, pitched at the edge of a birch
wood. In the wood, wagons and horses were standing. The horses were
eating oats from their movable troughs and sparrows flew down and
pecked the grains that fell. Some crows, scenting blood, flew among
the birch trees cawing impatiently. Around the tents, over more than
five acres, bloodstained men in various garbs stood, sat, or lay.
Around the wounded stood crowds of soldier stretcher-bearers with
dismal and attentive faces, whom the officers keeping order tried in
vain to drive from the spot. Disregarding the officers' orders, the
soldiers stood leaning against their stretchers and gazing intently,
as if trying to comprehend the difficult problem of what was taking
place before them. From the tents came now loud angry cries and now
plaintive groans. Occasionally dressers ran out to fetch water, or
to point out those who were to be brought in next. The wounded men
awaiting their turn outside the tents groaned, sighed, wept, screamed,
swore, or asked for vodka. Some were delirious. Prince Andrew's
bearers, stepping over the wounded who had not yet been bandaged, took
him, as a regimental commander, close up to one of the tents and there
stopped, awaiting instructions. Prince Andrew opened his eyes and
for a long time could not make out what was going on around him. He
remembered the meadow, the wormwood, the field, the whirling black
ball, and his sudden rush of passionate love of life. Two steps from
him, leaning against a branch and talking loudly and attracting
general attention, stood a tall, handsome, black-haired
noncommissioned officer with a bandaged head. He had been wounded in
the head and leg by bullets. Around him, eagerly listening to his
talk, a crowd of wounded and stretcher-bearers was gathered.

"We kicked him out from there so that he chucked everything, we
grabbed the King himself!" cried he, looking around him with eyes that
glittered with fever. "If only reserves had come up just then, lads,
there wouldn't have been nothing left of him! I tell you surely..."

Like all the others near the speaker, Prince Andrew looked at him
with shining eyes and experienced a sense of comfort. "But isn't it
all the same now?" thought he. "And what will be there, and what has
there been here? Why was I so reluctant to part with life? There was
something in this life I did not and do not understand."





CHAPTER XXXVII


One of the doctors came out of the tent in a bloodstained apron,
holding a cigar between the thumb and little finger of one of his
small bloodstained hands, so as not to smear it. He raised his head
and looked about him, but above the level of the wounded men. He
evidently wanted a little respite. After turning his head from right
to left for some time, he sighed and looked down.

"All right, immediately," he replied to a dresser who pointed Prince
Andrew out to him, and he told them to carry him into the tent.

Murmurs arose among the wounded who were waiting.

"It seems that even in the next world only the gentry are to have
a chance!" remarked one.

Prince Andrew was carried in and laid on a table that had only
just been cleared and which a dresser was washing down. Prince
Andrew could not make out distinctly what was in that tent. The
pitiful groans from all sides and the torturing pain in his thigh,
stomach, and back distracted him. All he saw about him merged into a
general impression of naked, bleeding human bodies that seemed to fill
the whole of the low tent, as a few weeks previously, on that hot
August day, such bodies had filled the dirty pond beside the
Smolensk road. Yes, it was the same flesh, the same chair a canon, the
sight of which had even then filled him with horror, as by a
presentiment.

There were three operating tables in the tent. Two were occupied,
and on the third they placed Prince Andrew. For a little while he
was left alone and involuntarily witnessed what was taking place on
the other two tables. On the nearest one sat a Tartar, probably a
Cossack, judging by the uniform thrown down beside him. Four
soldiers were holding him, and a spectacled doctor was cutting into
his muscular brown back.

"Ooh, ooh, ooh!" grunted the Tartar, and suddenly lifting up his
swarthy snub-nosed face with its high cheekbones, and baring his white
teeth, he began to wriggle and twitch his body and utter piercing,
ringing, and prolonged yells. On the other table, round which many
people were crowding, a tall well-fed man lay on his back with his
head thrown back. His curly hair, its color, and the shape of his head
seemed strangely familiar to Prince Andrew. Several dressers were
pressing on his chest to hold him down. One large, white, plump leg
twitched rapidly all the time with a feverish tremor. The man was
sobbing and choking convulsively. Two doctors--one of whom was pale
and trembling--were silently doing something to this man's other, gory
leg. When he had finished with the Tartar, whom they covered with an
overcoat, the spectacled doctor came up to Prince Andrew, wiping his
hands.

He glanced at Prince Andrew's face and quickly turned away.

"Undress him! What are you waiting for?" he cried angrily to the
dressers.

His very first, remotest recollections of childhood came back to
Prince Andrew's mind when the dresser with sleeves rolled up began
hastily to undo the buttons of his clothes and undressed him. The
doctor bent down over the wound, felt it, and sighed deeply. Then he
made a sign to someone, and the torturing pain in his abdomen caused
Prince Andrew to lose consciousness. When he came to himself the
splintered portions of his thighbone had been extracted, the torn
flesh cut away, and the wound bandaged. Water was being sprinkled on
his face. As soon as Prince Andrew opened his eyes, the doctor bent
over, kissed him silently on the lips, and hurried away.

After the sufferings he had been enduring, Prince Andrew enjoyed a
blissful feeling such as he had not experienced for a long time. All
the best and happiest moments of his life--especially his earliest
childhood, when he used to be undressed and put to bed, and when
leaning over him his nurse sang him to sleep and he, burying his
head in the pillow, felt happy in the mere consciousness of life-
returned to his memory, not merely as something past but as
something present.

The doctors were busily engaged with the wounded man the shape of
whose head seemed familiar to Prince Andrew: they were lifting him
up and trying to quiet him.

"Show it to me.... Oh, ooh... Oh! Oh, ooh!" his frightened moans
could be heard, subdued by suffering and broken by sobs.

Hearing those moans Prince Andrew wanted to weep.
Whether because he was dying without glory, or because he was sorry to
part with life, or because of those memories of a childhood that could
not return, or because he was suffering and others were suffering
and that man near him was groaning so piteously--he felt like
weeping childlike, kindly, and almost happy tears.

The wounded man was shown his amputated leg stained with clotted
blood and with the boot still on.

"Oh! Oh, ooh!" he sobbed, like a woman.

The doctor who had been standing beside him, preventing Prince
Andrew from seeing his face, moved away.

"My God! What is this? Why is he here?" said Prince Andrew to
himself.

In the miserable, sobbing, enfeebled man whose leg had just been
amputated, he recognized Anatole Kuragin. Men were supporting him in
their arms and offering him a glass of water, but his trembling,
swollen lips could not grasp its rim. Anatole was sobbing painfully.
"Yes, it is he! Yes, that man is somehow closely and painfully
connected with me," thought Prince Andrew, not yet clearly grasping
what he saw before him. "What is the connection of that man with my
childhood and life?" he asked himself without finding an answer. And
suddenly a new unexpected memory from that realm of pure and loving
childhood presented itself to him. He remembered Natasha as he had
seen her for the first time at the ball in 1810, with her slender neck
and arms and with a frightened happy face ready for rapture, and
love and tenderness for her, stronger and more vivid than ever,
awoke in his soul. He now remembered the connection that existed
between himself and this man who was dimly gazing at him through tears
that filled his swollen eyes. He remembered everything, and ecstatic
pity and love for that man overflowed his happy heart.

Prince Andrew could no longer restrain himself and wept tender
loving tears for his fellow men, for himself, and for his own and
their errors.

"Compassion, love of our brothers, for those who love us and for
those who hate us, love of our enemies; yes, that love which God
preached on earth and which Princess Mary taught me and I did not
understand--that is what made me sorry to part with life, that is what
remained for me had I lived. But now it is too late. I know it!"





CHAPTER XXXVIII


The terrible spectacle of the battlefield covered with dead and
wounded, together with the heaviness of his head and the news that
some twenty generals he knew personally had been killed or wounded,
and the consciousness of the impotence of his once mighty arm,
produced an unexpected impression on Napoleon who usually liked to
look at the killed and wounded, thereby, he considered, testing his
strength of mind. This day the horrible appearance of the
battlefield overcame that strength of mind which he thought
constituted his merit and his greatness. He rode hurriedly from the
battlefield and returned to the Shevardino knoll, where he sat on
his campstool, his sallow face swollen and heavy, his eyes dim, his
nose red, and his voice hoarse, involuntarily listening, with downcast
eyes, to the sounds of firing. With painful dejection he awaited the
end of this action, in which he regarded himself as a participant
and which he was unable to arrest. A personal, human feeling for a
brief moment got the better of the artificial phantasm of life he
had served so long. He felt in his own person the sufferings and death
he had witnessed on the battlefield. The heaviness of his head and
chest reminded him of the possibility of suffering and death for
himself. At that moment he did not desire Moscow, or victory, or glory
(what need had he for any more glory?). The one thing he wished for
was rest, tranquillity, and freedom. But when he had been on the
Semenovsk heights the artillery commander had proposed to him to bring
several batteries of artillery up to those heights to strengthen the
fire on the Russian troops crowded in front of Knyazkovo. Napoleon had
assented and had given orders that news should be brought to him of
the effect those batteries produced.

An adjutant came now to inform him that the fire of two hundred guns
had been concentrated on the Russians, as he had ordered, but that
they still held their ground.

"Our fire is mowing them down by rows, but still they hold on," said
the adjutant.

"They want more!..." said Napoleon in a hoarse voice.

"Sire?" asked the adjutant who had not heard the remark.

"They want more!" croaked Napoleon frowning. "Let them have it!"

Even before he gave that order the thing he did not desire, and
for which he gave the order only because he thought it was expected of
him, was being done. And he fell back into that artificial realm of
imaginary greatness, and again--as a horse walking a treadmill
thinks it is doing something for itself--he submissively fulfilled the
cruel, sad, gloomy, and inhuman role predestined for him.

And not for that day and hour alone were the mind and conscience
darkened of this man on whom the responsibility for what was happening
lay more than on all the others who took part in it. Never to the
end of his life could he understand goodness, beauty, or truth, or the
significance of his actions which were too contrary to goodness and
truth, too remote from everything human, for him ever to be able to
grasp their meaning. He could not disavow his actions, belauded as
they were by half the world, and so he had to repudiate truth,
goodness, and all humanity.

Not only on that day, as he rode over the battlefield strewn with
men killed and maimed (by his will as he believed), did he reckon as
he looked at them how many Russians there were for each Frenchman and,
deceiving himself, find reason for rejoicing in the calculation that
there were five Russians for every Frenchman. Not on that day alone
did he write in a letter to Paris that "the battle field was
superb," because fifty thousand corpses lay there, but even on the
island of St. Helena in the peaceful solitude where he said he
intended to devote his leisure to an account of the great deeds he had
done, he wrote:


The Russian war should have been the most popular war of modern
times: it was a war of good sense, for real interests, for the
tranquillity and security of all; it was purely pacific and
conservative.

It was a war for a great cause, the end of uncertainties and the
beginning of security. A new horizon and new labors were opening
out, full of well-being and prosperity for all. The European system
was already founded; all that remained was to organize it.

Satisfied on these great points and with tranquility everywhere, I
too should have had my Congress and my Holy Alliance. Those ideas were
stolen from me. In that reunion of great sovereigns we should have
discussed our interests like one family, and have rendered account
to the peoples as clerk to master.

Europe would in this way soon have been, in fact, but one people,
and anyone who traveled anywhere would have found himself always in
the common fatherland. I should have demanded the freedom of all
navigable rivers for everybody, that the seas should be common to all,
and that the great standing armies should be reduced henceforth to
mere guards for the sovereigns.

On returning to France, to the bosom of the great, strong,
magnificent, peaceful, and glorious fatherland, I should have
proclaimed her frontiers immutable; all future wars purely
defensive, all aggrandizement antinational. I should have associated
my son in the Empire; my dictatorship would have been finished, and
his constitutional reign would have begun.

Paris would have been the capital of the world, and the French the
envy of the nations!

My leisure then, and my old age, would have been devoted, in company
with the Empress and during the royal apprenticeship of my son, to
leisurely visiting, with our own horses and like a true country
couple, every corner of the Empire, receiving complaints, redressing
wrongs, and scattering public buildings and benefactions on all
sides and everywhere.


Napoleon, predestined by Providence for the gloomy role of
executioner of the peoples, assured himself that the aim of his
actions had been the peoples' welfare and that he could control the
fate of millions and by the employment of power confer benefactions.


"Of four hundred thousand who crossed the Vistula," he wrote further
of the Russian war, "half were Austrians, Prussians, Saxons, Poles,
Bavarians, Wurttembergers, Mecklenburgers, Spaniards, Italians, and
Neapolitans. The Imperial army, strictly speaking, was one third
composed of Dutch, Belgians, men from the borders of the Rhine,
Piedmontese, Swiss, Genevese, Tuscans, Romans, inhabitants of the
Thirty-second Military Division, of Bremen, of Hamburg, and so on:
it included scarcely a hundred and forty thousand who spoke French.
The Russian expedition actually cost France less than fifty thousand
men; the Russian army in its retreat from Vilna to Moscow lost in
the various battles four times more men than the French army; the
burning of Moscow cost the lives of a hundred thousand Russians who
died of cold and want in the woods; finally, in its march from
Moscow to the Oder the Russian army also suffered from the severity of
the season; so that by the the time it reached Vilna it numbered
only fifty thousand, and at Kalisch less than eighteen thousand."


He imagined that the war with Russia came about by his will, and the
horrors that occurred did not stagger his soul. He boldly took the
whole responsibility for what happened, and his darkened mind found
justification in the belief that among the hundreds of thousands who
perished there were fewer Frenchmen than Hessians and Bavarians.





CHAPTER XXXIX


Several tens of thousands of the slain lay in diverse postures and
various uniforms on the fields and meadows belonging to the Davydov
family and to the crown serfs--those fields and meadows where for
hundreds of years the peasants of Borodino, Gorki, Shevardino, and
Semenovsk had reaped their harvests and pastured their cattle. At
the dressing stations the grass and earth were soaked with blood for a
space of some three acres around. Crowds of men of various arms,
wounded and unwounded, with frightened faces, dragged themselves
back to Mozhaysk from the one army and back to Valuevo from the other.
Other crowds, exhausted and hungry, went forward led by their
officers. Others held their ground and continued to fire.

Over the whole field, previously so gaily beautiful with the glitter
of bayonets and cloudlets of smoke in the morning sun, there now
spread a mist of damp and smoke and a strange acid smell of
saltpeter and blood. Clouds gathered and drops of rain began to fall
on the dead and wounded, on the frightened, exhausted, and
hesitating men, as if to say: "Enough, men! Enough! Cease... bethink
yourselves! What are you doing?"

To the men of both sides alike, worn out by want of food and rest,
it began equally to appear doubtful whether they should continue to
slaughter one another; all the faces expressed hesitation, and the
question arose in every soul: "For what, for whom, must I kill and
be killed?... You may go and kill whom you please, but I don't want to
do so anymore!" By evening this thought had ripened in every soul.
At any moment these men might have been seized with horror at what
they were doing and might have thrown up everything and run away
anywhere.

But though toward the end of the battle the men felt all the
horror of what they were doing, though they would have been glad to
leave off, some incomprehensible, mysterious power continued to
control them, and they still brought up the charges, loaded, aimed,
and applied the match, though only one artilleryman survived out of
every three, and though they stumbled and panted with fatigue,
perspiring and stained with blood and powder. The cannon balls flew
just as swiftly and cruelly from both sides, crushing human bodies,
and that terrible work which was not done by the will of a man but
at the will of Him who governs men and worlds continued.

Anyone looking at the disorganized rear of the Russian army would
have said that, if only the French made one more slight effort, it
would disappear; and anyone looking at the rear of the French army
would have said that the Russians need only make one more slight
effort and the French would be destroyed. But neither the French nor
the Russians made that effort, and the flame of battle burned slowly
out.

The Russians did not make that effort because they were not
attacking the French. At the beginning of the battle they stood
blocking the way to Moscow and they still did so at the end of the
battle as at the beginning. But even had the aim of the Russians
been to drive the French from their positions, they could not have
made this last effort, for all the Russian troops had been broken
up, there was no part of the Russian army that had not suffered in the
battle, and though still holding their positions they had lost ONE
HALF of their army.

The French, with the memory of all their former victories during
fifteen years, with the assurance of Napoleon's invincibility, with
the consciousness that they had captured part of the battlefield and
had lost only a quarter of their men and still had their Guards
intact, twenty thousand strong, might easily have made that effort.
The French had attacked the Russian army in order to drive it from its
position ought to have made that effort, for as long as the Russians
continued to block the road to Moscow as before, the aim of the French
had not been attained and all their efforts and losses were in vain.
But the French did not make that effort. Some historians say that
Napoleon need only have used his Old Guards, who were intact, and
the battle would have been won. To speak of what would have happened
had Napoleon sent his Guards is like talking of what would happen if
autumn became spring. It could not be. Napoleon did not give his
Guards, not because he did not want to, but because it could not be
done. All the generals, officers, and soldiers of the French army knew
it could not be done, because the flagging spirit of the troops
would not permit it.

It was not Napoleon alone who had experienced that nightmare feeling
of the mighty arm being stricken powerless, but all the generals and
soldiers of his army whether they had taken part in the battle or not,
after all their experience of previous battles--when after one tenth
of such efforts the enemy had fled--experienced a similar feeling of
terror before an enemy who, after losing HALF his men, stood as
threateningly at the end as at the beginning of the battle. The
moral force of the attacking French army was exhausted. Not that
sort of victory which is defined by the capture of pieces of
material fastened to sticks, called standards, and of the ground on
which the troops had stood and were standing, but a moral victory that
convinces the enemy of the moral superiority of his opponent and of
his own impotence was gained by the Russians at Borodino. The French
invaders, like an infuriated animal that has in its onslaught received
a mortal wound, felt that they were perishing, but could not stop, any
more than the Russian army, weaker by one half, could help swerving.
By impetus gained, the French army was still able to roll forward to
Moscow, but there, without further effort on the part of the Russians,
it had to perish, bleeding from the mortal wound it had received at
Borodino. The direct consequence of the battle of Borodino was
Napoleon's senseless flight from Moscow, his retreat along the old
Smolensk road, the destruction of the invading army of five hundred
thousand men, and the downfall of Napoleonic France, on which at
Borodino for the first time the hand of an opponent of stronger spirit
had been laid.





BOOK ELEVEN: 1812





CHAPTER I


Absolute continuity of motion is not comprehensible to the human
mind. Laws of motion of any kind become comprehensible to man only
when he examines arbitrarily selected elements of that motion; but
at the same time, a large proportion of human error comes from the
arbitrary division of continuous motion into discontinuous elements.
There is a well known, so-called sophism of the ancients consisting in
this, that Achilles could never catch up with a tortoise he was
following, in spite of the fact that he traveled ten times as fast
as the tortoise. By the time Achilles has covered the distance that
separated him from the tortoise, the tortoise has covered one tenth of
that distance ahead of him: when Achilles has covered that tenth,
the tortoise has covered another one hundredth, and so on forever.
This problem seemed to the ancients insoluble. The absurd answer (that
Achilles could never overtake the tortoise) resulted from this: that
motion was arbitrarily divided into discontinuous elements, whereas
the motion both of Achilles and of the tortoise was continuous.

By adopting smaller and smaller elements of motion we only
approach a solution of the problem, but never reach it. Only when we
have admitted the conception of the infinitely small, and the
resulting geometrical progression with a common ratio of one tenth,
and have found the sum of this progression to infinity, do we reach
a solution of the problem.

A modern branch of mathematics having achieved the art of dealing
with the infinitely small can now yield solutions in other more
complex problems of motion which used to appear insoluble.

This modern branch of mathematics, unknown to the ancients, when
dealing with problems of motion admits the conception of the
infinitely small, and so conforms to the chief condition of motion
(absolute continuity) and thereby corrects the inevitable error
which the human mind cannot avoid when it deals with separate elements
of motion instead of examining continuous motion.

In seeking the laws of historical movement just the same thing
happens. The movement of humanity, arising as it does from innumerable
arbitrary human wills, is continuous.

To understand the laws of this continuous movement is the aim of
history. But to arrive at these laws, resulting from the sum of all
those human wills, man's mind postulates arbitrary and disconnected
units. The first method of history is to take an arbitrarily
selected series of continuous events and examine it apart from others,
though there is and can be no beginning to any event, for one event
always flows uninterruptedly from another.

The second method is to consider the actions of some one man--a king
or a commander--as equivalent to the sum of many individual wills;
whereas the sum of individual wills is never expressed by the activity
of a single historic personage.

Historical science in its endeavor to draw nearer to truth
continually takes smaller and smaller units for examination. But
however small the units it takes, we feel that to take any unit
disconnected from others, or to assume a beginning of any
phenomenon, or to say that the will of many men is expressed by the
actions of any one historic personage, is in itself false.

It needs no critical exertion to reduce utterly to dust any
deductions drawn from history. It is merely necessary to select some
larger or smaller unit as the subject of observation--as criticism has
every right to do, seeing that whatever unit history observes must
always be arbitrarily selected.

Only by taking infinitesimally small units for observation (the
differential of history, that is, the individual tendencies of men)
and attaining to the art of integrating them (that is, finding the sum
of these infinitesimals) can we hope to arrive at the laws of history.

The first fifteen years of the nineteenth century in Europe
present an extraordinary movement of millions of people. Men leave
their customary pursuits, hasten from one side of Europe to the other,
plunder and slaughter one another, triumph and are plunged in despair,
and for some years the whole course of life is altered and presents an
intensive movement which first increases and then slackens. What was
the cause of this movement, by what laws was it governed? asks the
mind of man.

The historians, replying to this question, lay before us the sayings
and doings of a few dozen men in a building in the city of Paris,
calling these sayings and doings "the Revolution"; then they give a
detailed biography of Napoleon and of certain people favorable or
hostile to him; tell of the influence some of these people had on
others, and say: that is why this movement took place and those are
its laws.

But the mind of man not only refuses to believe this explanation,
but plainly says that this method of explanation is fallacious,
because in it a weaker phenomenon is taken as the cause of a stronger.
The sum of human wills produced the Revolution and Napoleon, and
only the sum of those wills first tolerated and then destroyed them.

"But every time there have been conquests there have been
conquerors; every time there has been a revolution in any state
there have been great men," says history. And, indeed, human reason
replies: every time conquerors appear there have been wars, but this
does not prove that the conquerors caused the wars and that it is
possible to find the laws of a war in the personal activity of a
single man. Whenever I look at my watch and its hands point to ten,
I hear the bells of the neighboring church; but because the bells
begin to ring when the hands of the clock reach ten, I have no right
to assume that the movement of the bells is caused by the position
of the hands of the watch.

Whenever I see the movement of a locomotive I hear the whistle and
see the valves opening and wheels turning; but I have no right to
conclude that the whistling and the turning of wheels are the cause of
the movement of the engine.

The peasants say that a cold wind blows in late spring because the
oaks are budding, and really every spring cold winds do blow when
the oak is budding. But though I do not know what causes the cold
winds to blow when the oak buds unfold, I cannot agree with the
peasants that the unfolding of the oak buds is the cause of the cold
wind, for the force of the wind is beyond the influence of the buds. I
see only a coincidence of occurrences such as happens with all the
phenomena of life, and I see that however much and however carefully I
observe the hands of the watch, and the valves and wheels of the
engine, and the oak, I shall not discover the cause of the bells
ringing, the engine moving, or of the winds of spring. To that I
must entirely change my point of view and study the laws of the
movement of steam, of the bells, and of the wind. History must do
the same. And attempts in this direction have already been made.

To study the laws of history we must completely change the subject
of our observation, must leave aside kings, ministers, and generals,
and the common, infinitesimally small elements by which the masses are
moved. No one can say in how far it is possible for man to advance
in this way toward an understanding of the laws of history; but it
is evident that only along that path does the possibility of
discovering the laws of history lie, and that as yet not a millionth
part as much mental effort has been applied in this direction by
historians as has been devoted to describing the actions of various
kings, commanders, and ministers and propounding the historians' own
reflections concerning these actions.





CHAPTER II


The forces of a dozen European nations burst into Russia. The
Russian army and people avoided a collision till Smolensk was reached,
and again from Smolensk to Borodino. The French army pushed on to
Moscow, its goal, its impetus ever increasing as it neared its aim,
just as the velocity of a falling body increases as it approaches
the earth. Behind it were seven hundred miles of hunger-stricken,
hostile country; ahead were a few dozen miles separating it from its
goal. Every soldier in Napoleon's army felt this and the invasion
moved on by its own momentum.

The more the Russian army retreated the more fiercely a spirit of
hatred of the enemy flared up, and while it retreated the army
increased and consolidated. At Borodino a collision took place.
Neither army was broken up, but the Russian army retreated immediately
after the collision as inevitably as a ball recoils after colliding
with another having a greater momentum, and with equal inevitability
the ball of invasion that had advanced with such momentum rolled on
for some distance, though the collision had deprived it of all its
force.

The Russians retreated eighty miles--to beyond Moscow--and the
French reached Moscow and there came to a standstill. For five weeks
after that there was not a single battle. The French did not move.
As a bleeding, mortally wounded animal licks its wounds, they remained
inert in Moscow for five weeks, and then suddenly, with no fresh
reason, fled back: they made a dash for the Kaluga road, and (after
a victory--for at Malo-Yaroslavets the field of conflict again
remained theirs) without undertaking a single serious battle, they
fled still more rapidly back to Smolensk, beyond Smolensk, beyond
the Berezina, beyond Vilna, and farther still.

On the evening of the twenty-sixth of August, Kutuzov and the
whole Russian army were convinced that the battle of Borodino was a
victory. Kutuzov reported so to the Emperor. He gave orders to prepare
for a fresh conflict to finish the enemy and did this not to deceive
anyone, but because he knew that the enemy was beaten, as everyone who
had taken part in the battle knew it.

But all that evening and next day reports came in one after
another of unheard-of losses, of the loss of half the army, and a
fresh battle proved physically impossible.

It was impossible to give battle before information had been
collected, the wounded gathered in, the supplies of ammunition
replenished, the slain reckoned up, new officers appointed to
replace those who had been killed, and before the men had had food and
sleep. And meanwhile, the very next morning after the battle, the
French army advanced of itself upon the Russians, carried forward by
the force of its own momentum now seemingly increased in inverse
proportion to the square of the distance from its aim. Kutuzov's
wish was to attack next day, and the whole army desired to do so.
But to make an attack the wish to do so is not sufficient, there
must also be a possibility of doing it, and that possibility did not
exist. It was impossible not to retreat a day's march, and then in the
same way it was impossible not to retreat another and a third day's
march, and at last, on the first of September when the army drew
near Moscow--despite the strength of the feeling that had arisen in
all ranks--the force of circumstances compelled it to retire beyond
Moscow. And the troops retired one more, last, day's march, and
abandoned Moscow to the enemy.

For people accustomed to think that plans of campaign and battles
are made by generals--as any one of us sitting over a map in his study
may imagine how he would have arranged things in this or that
battle--the questions present themselves: Why did Kutuzov during the
retreat not do this or that? Why did he not take up a position
before reaching Fili? Why did he not retire at once by the Kaluga
road, abandoning Moscow? and so on. People accustomed to think in that
way forget, or do not know, the inevitable conditions which always
limit the activities of any commander in chief. The activity of a
commander in chief does not all resemble the activity we imagine to
ourselves when we sit at case in our studies examining some campaign
on the map, with a certain number of troops on this and that side in a
certain known locality, and begin our plans from some given moment.
A commander in chief is never dealing with the beginning of any event-
the position from which we always contemplate it. The commander in
chief is always in the midst of a series of shifting events and so
he never can at any moment consider the whole import of an event
that is occurring. Moment by moment the event is imperceptibly shaping
itself, and at every moment of this continuous, uninterrupted
shaping of events the commander in chief is in the midst of a most
complex play of intrigues, worries, contingencies, authorities,
projects, counsels, threats, and deceptions and is continually obliged
to reply to innumerable questions addressed to him, which constantly
conflict with one another.

Learned military authorities quite seriously tell us that Kutuzov
should have moved his army to the Kaluga road long before reaching
Fili, and that somebody actually submitted such a proposal to him. But
a commander in chief, especially at a difficult moment, has always
before him not one proposal but dozens simultaneously. And all these
proposals, based on strategics and tactics, contradict each other.

A commander in chief's business, it would seem, is simply to
choose one of these projects. But even that he cannot do. Events and
time do not wait. For instance, on the twenty-eighth it is suggested
to him to cross to the Kaluga road, but just then an adjutant
gallops up from Miloradovich asking whether he is to engage the French
or retire. An order must be given him at once, that instant. And the
order to retreat carries us past the turn to the Kaluga road. And
after the adjutant comes the commissary general asking where the
stores are to be taken, and the chief of the hospitals asks where
the wounded are to go, and a courier from Petersburg brings a letter
from the sovereign which does not admit of the possibility of
abandoning Moscow, and the commander in chief's rival, the man who
is undermining him (and there are always not merely one but several
such), presents a new project diametrically opposed to that of turning
to the Kaluga road, and the commander in chief himself needs sleep and
refreshment to maintain his energy and a respectable general who has
been overlooked in the distribution of rewards comes to complain,
and the inhabitants of the district pray to be defended, and an
officer sent to inspect the locality comes in and gives a report quite
contrary to what was said by the officer previously sent; and a spy, a
prisoner, and a general who has been on reconnaissance, all describe
the position of the enemy's army differently. People accustomed to
misunderstand or to forget these inevitable conditions of a
commander in chief's actions describe to us, for instance, the
position of the army at Fili and assume that the commander in chief
could, on the first of September, quite freely decide whether to
abandon Moscow or defend it; whereas, with the Russian army less
than four miles from Moscow, no such question existed. When had that
question been settled? At Drissa and at Smolensk and most palpably
of all on the twenty-fourth of August at Shevardino and on the
twenty-sixth at Borodino, and each day and hour and minute of the
retreat from Borodino to Fili.





CHAPTER III


When Ermolov, having been sent by Kutuzov to inspect the position,
told the field marshal that it was impossible to fight there before
Moscow and that they must retreat, Kutuzov looked at him in silence.

"Give me your hand," said he and, turning it over so as to feel
the pulse, added: "You are not well, my dear fellow. Think what you
are saying!"

Kutuzov could not yet admit the possibility of retreating beyond
Moscow without a battle.

On the Poklonny Hill, four miles from the Dorogomilov gate of
Moscow, Kutuzov got out of his carriage and sat down on a bench by the
roadside. A great crowd of generals gathered round him, and Count
Rostopchin, who had come out from Moscow, joined them. This
brilliant company separated into several groups who all discussed
the advantages and disadvantages of the position, the state of the
army, the plans suggested, the situation of Moscow, and military
questions generally. Though they had not been summoned for the
purpose, and though it was not so called, they all felt that this
was really a council of war. The conversations all dealt with public
questions. If anyone gave or asked for personal news, it was done in a
whisper and they immediately reverted to general matters. No jokes, or
laughter, or smiles even, were seen among all these men. They
evidently all made an effort to hold themselves at the height the
situation demanded. And all these groups, while talking among
themselves, tried to keep near the commander in chief (whose bench
formed the center of the gathering) and to speak so that he might
overhear them. The commander in chief listened to what was being
said and sometimes asked them to repeat their remarks, but did not
himself take part in the conversations or express any opinion. After
hearing what was being said by one or other of these groups he
generally turned away with an air of disappointment, as though they
were not speaking of anything he wished to hear. Some discussed the
position that had been chosen, criticizing not the position itself
so much as the mental capacity of those who had chosen it. Others
argued that a mistake had been made earlier and that a battle should
have been fought two days before. Others again spoke of the battle
of Salamanca, which was described by Crosart, a newly arrived
Frenchman in a Spanish uniform. (This Frenchman and one of the
German princes serving with the Russian army were discussing the siege
of Saragossa and considering the possibility of defending Moscow in
a similar manner.) Count Rostopchin was telling a fourth group that he
was prepared to die with the city train bands under the walls of the
capital, but that he still could not help regretting having been
left in ignorance of what was happening, and that had he known it
sooner things would have been different.... A fifth group,
displaying the profundity of their strategic perceptions, discussed
the direction the troops would now have to take. A sixth group was
talking absolute nonsense. Kutuzov's expression grew more and more
preoccupied and gloomy. From all this talk he saw only one thing: that
to defend Moscow was a physical impossibility in the full meaning of
those words, that is to say, so utterly impossible that if any
senseless commander were to give orders to fight, confusion would
result but the battle would still not take place. It would not take
place because the commanders not merely all recognized the position to
be impossible, but in their conversations were only discussing what
would happen after its inevitable abandonment. How could the
commanders lead their troops to a field of battle they considered
impossible to hold? The lower-grade officers and even the soldiers
(who too reason) also considered the position impossible and therefore
could not go to fight, fully convinced as they were of defeat. If
Bennigsen insisted on the position being defended and others still
discussed it, the question was no longer important in itself but
only as a pretext for disputes and intrigue. This Kutuzov knew well.

Bennigsen, who had chosen the position, warmly displayed his Russian
patriotism (Kutuzov could not listen to this without wincing) by
insisting that Moscow must be defended. His aim was as clear as
daylight to Kutuzov: if the defense failed, to throw the blame on
Kutuzov who had brought the army as far as the Sparrow Hills without
giving battle; if it succeeded, to claim the success as his own; or if
battle were not given, to clear himself of the crime of abandoning
Moscow. But this intrigue did not now occupy the old man's mind. One
terrible question absorbed him and to that question he heard no
reply from anyone. The question for him now was: "Have I really
allowed Napoleon to reach Moscow, and when did I do so? When was it
decided? Can it have been yesterday when I ordered Platov to
retreat, or was it the evening before, when I had a nap and told
Bennigsen to issue orders? Or was it earlier still?... When, when
was this terrible affair decided? Moscow must be abandoned. The army
must retreat and the order to do so must be given." To give that
terrible order seemed to him equivalent to resigning the command of
the army. And not only did he love power to which he was accustomed
(the honours awarded to Prince Prozorovski, under whom he had served
in Turkey, galled him), but he was convinced that he was destined to
save Russia and that that was why, against the Emperor's wish and by
the will of the people, he had been chosen commander in chief. He
was convinced that he alone could maintain command of the army in
these difficult circumstances, and that in all the world he alone
could encounter the invincible Napoleon without fear, and he was
horrified at the thought of the order he had to issue. But something
had to be decided, and these conversations around him which were
assuming too free a character must be stopped.

He called the most important generals to him.

"My head, be it good or bad, must depend on itself," said he, rising
from the bench, and he rode to Fili where his carriages were waiting.





CHAPTER IV


The Council of War began to assemble at two in the afternoon in
the better and roomier part of Andrew Savostyanov's hut. The men,
women, and children of the large peasant family crowded into the
back room across the passage. Only Malasha, Andrew's six-year-old
granddaughter whom his Serene Highness had petted and to whom he had
given a lump of sugar while drinking his tea, remained on the top of
the brick oven in the larger room. Malasha looked down from the oven
with shy delight at the faces, uniforms, and decorations of the
generals, who one after another came into the room and sat down on the
broad benches in the corner under the icons. "Granddad" himself, as
Malasha in her own mind called Kutuzov, sat apart in a dark corner
behind the oven. He sat, sunk deep in a folding armchair, and
continually cleared his throat and pulled at the collar of his coat
which, though it was unbuttoned, still seemed to pinch his neck. Those
who entered went up one by one to the field marshal; he pressed the
hands of some and nodded to others. His adjutant Kaysarov was about to
draw back the curtain of the window facing Kutuzov, but the latter
moved his hand angrily and Kaysarov understood that his Serene
Highness did not wish his face to be seen.

Round the peasant's deal table, on which lay maps, plans, pencils,
and papers, so many people gathered that the orderlies brought in
another bench and put it beside the table. Ermolov, Kaysarov, and
Toll, who had just arrived, sat down on this bench. In the foremost
place, immediately under the icons, sat Barclay de Tolly, his high
forehead merging into his bald crown. He had a St. George's Cross
round his neck and looked pale and ill. He had been feverish for two
days and was now shivering and in pain. Beside him sat Uvarov, who
with rapid gesticulations was giving him some information, speaking in
low tones as they all did. Chubby little Dokhturov was listening
attentively with eyebrows raised and arms folded on his stomach. On
the other side sat Count Ostermann-Tolstoy, seemingly absorbed in
his own thoughts. His broad head with its bold features and glittering
eyes was resting on his hand. Raevski, twitching forward the black
hair on his temples as was his habit, glanced now at Kutuzov and now
at the door with a look of impatience. Konovnitsyn's firm, handsome,
and kindly face was lit up by a tender, sly smile. His glance met
Malasha's, and the expression of his eyes caused the little girl to
smile.

They were all waiting for Bennigsen, who on the pretext of
inspecting the position was finishing his savory dinner. They waited
for him from four till six o'clock and did not begin their
deliberations all that time talked in low tones of other matters.

Only when Bennigsen had entered the hut did Kutuzov leave his corner
and draw toward the table, but not near enough for the candles that
had been placed there to light up his face.

Bennigsen opened the council with the question: "Are we to abandon
Russia's ancient and sacred capital without a struggle, or are we to
defend it?" A prolonged and general silence followed. There was a
frown on every face and only Kutuzov's angry grunts and occasional
cough broke the silence. All eyes were gazing at him. Malasha too
looked at "Granddad." She was nearest to him and saw how his face
puckered; he seemed about to cry, but this did not last long.

"Russia's ancient and sacred capital!" he suddenly said, repeating
Bennigsen's words in an angry voice and thereby drawing attention to
the false note in them. "Allow me to tell you, your excellency, that
that question has no meaning for a Russian." (He lurched his heavy
body forward.) "Such a question cannot be put; it is senseless! The
question I have asked these gentlemen to meet to discuss is a military
one. The question is that of saving Russia. Is it better to give up
Moscow without a battle, or by accepting battle to risk losing the
army as well as Moscow? That is the question on which I want your
opinion," and he sank back in his chair.

The discussion began. Bennigsen did not yet consider his game
lost. Admitting the view of Barclay and others that a defensive battle
at Fili was impossible, but imbued with Russian patriotism and the
love of Moscow, he proposed to move troops from the right to the
left flank during the night and attack the French right flank the
following day. Opinions were divided, and arguments were advanced
for and against that project. Ermolov, Dokhturov, and Raevski agreed
with Bennigsen. Whether feeling it necessary to make a sacrifice
before abandoning the capital or guided by other, personal
considerations, these generals seemed not to understand that this
council could not alter the inevitable course of events and that
Moscow was in effect already abandoned. The other generals, however,
understood it and, leaving aside the question of Moscow, of the
direction the army should take in its retreat. Malasha, who kept her
eyes fixed on what was going on before her, understood the meaning
of the council differently. It seemed to her that it was only a
personal struggle between "Granddad" and "Long-coat" as she termed
Bennigsen. She saw that they grew spiteful when they spoke to one
another, and in her heart she sided with "Granddad." In the midst of
the conversation she noticed "Granddad" give Bennigsen a quick, subtle
glance, and then to her joys he saw that "Granddad" said something
to "Long-coat" which settled him. Bennigsen suddenly reddened and
paced angrily up and down the room. What so affected him was Kutuzov's
calm and quiet comment on the advantage or disadvantage of Bennigsen's
proposal to move troops by night from the right to the left flank to
attack the French right wing.

"Gentlemen," said Kutuzov, "I cannot approve of the count's plan.
Moving troops in close proximity to an enemy is always dangerous,
and military history supports that view. For instance..." Kutuzov
seemed to reflect, searching for an example, then with a clear,
naive look at Bennigsen he added: "Oh yes; take the battle of
Friedland, which I think the count well remembers, and which was...
not fully successful, only because our troops were rearranged too near
the enemy..."

There followed a momentary pause, which seemed very long to them
all.

The discussion recommenced, but pauses frequently occurred and
they all felt that there was no more to be said.

During one of these pauses Kutuzov heaved a deep sigh as if
preparing to speak. They all looked at him.

"Well, gentlemen, I see that it is I who will have to pay for the
broken crockery," said he, and rising slowly he moved to the table.
"Gentlemen, I have heard your views. Some of you will not agree with
me. But I," he paused, "by the authority entrusted to me by my
Sovereign and country, order a retreat."

After that the generals began to disperse with the solemnity and
circumspect silence of people who are leaving, after a funeral.

Some of the generals, in low tones and in a strain very different
from the way they had spoken during the council, communicated
something to their commander in chief.

Malasha, who had long been expected for supper, climbed carefully
backwards down from the oven, her bare little feet catching at its
projections, and slipping between the legs of the generals she
darted out of the room.

When he had dismissed the generals Kutuzov sat a long time with
his elbows on the table, thinking always of the same terrible
question: "When, when did the abandonment of Moscow become inevitable?
When was that done which settled the matter? And who was to blame
for it?"

"I did not expect this," said he to his adjutant Schneider when
the latter came in late that night. "I did not expect this! I did
not think this would happen."

"You should take some rest, your Serene Highness," replied
Schneider.

"But no! They shall eat horseflesh yet, like the Turks!" exclaimed
Kutuzov without replying, striking the table with his podgy fist.
"They shall too, if only..."





CHAPTER V


At that very time, in circumstances even more important than
retreating without a battle, namely the evacuation and burning of
Moscow, Rostopchin, who is usually represented as being the instigator
of that event, acted in an altogether different manner from Kutuzov.

After the battle of Borodino the abandonment and burning of Moscow
was as inevitable as the retreat of the army beyond Moscow without
fighting.

Every Russian might have predicted it, not by reasoning but by the
feeling implanted in each of us and in our fathers.

The same thing that took place in Moscow had happened in all the
towns and villages on Russian soil beginning with Smolensk, without
the participation of Count Rostopchin and his broadsheets. The
people awaited the enemy unconcernedly, did not riot or become excited
or tear anyone to pieces, but faced its fate, feeling within it the
strength to find what it should do at that most difficult moment.
And as soon as the enemy drew near the wealthy classes went away
abandoning their property, while the poorer remained and burned and
destroyed what was left.

The consciousness that this would be so and would always be so was
and is present in the heart of every Russian. And a consciousness of
this, and a foreboding that Moscow would be taken, was present in
Russian Moscow society in 1812. Those who had quitted Moscow already
in July and at the beginning of August showed that they expected this.
Those who went away, taking what they could and abandoning their
houses and half their belongings, did so from the latent patriotism
which expresses itself not by phrases or by giving one's children to
save the fatherland and similar unnatural exploits, but unobtrusively,
simply, organically, and therefore in the way that always produces the
most powerful results.

"It is disgraceful to run away from danger; only cowards are running
away from Moscow," they were told. In his broadsheets Rostopchin
impressed on them that to leave Moscow was shameful. They were ashamed
to be called cowards, ashamed to leave, but still they left, knowing
it had to be done. Why did they go? It is impossible to suppose that
Rostopchin had scared them by his accounts of horrors Napoleon had
committed in conquered countries. The first people to go away were the
rich educated people who knew quite well that Vienna and Berlin had
remained intact and that during Napoleon's occupation the
inhabitants had spent their time pleasantly in the company of the
charming Frenchmen whom the Russians, and especially the Russian
ladies, then liked so much.

They went away because for Russians there could be no question as to
whether things would go well or ill under French rule in Moscow. It
was out of the question to be under French rule, it would be the worst
thing that could happen. They went away even before the battle of
Borodino and still more rapidly after it, despite Rostopchin's calls
to defend Moscow or the announcement of his intention to take the
wonder-working icon of the Iberian Mother of God and go to fight, or
of the balloons that were to destroy the French, and despite all the
nonsense Rostopchin wrote in his broadsheets. They knew that it was
for the army to fight, and that if it could not succeed it would not
do to take young ladies and house serfs to the Three Hills quarter
of Moscow to fight Napoleon, and that they must go away, sorry as they
were to abandon their property to destruction. They went away
without thinking of the tremendous significance of that immense and
wealthy city being given over to destruction, for a great city with
wooden buildings was certain when abandoned by its inhabitants to be
burned. They went away each on his own account, and yet it was only in
consequence of their going away that the momentous event was
accomplished that will always remain the greatest glory of the Russian
people. The lady who, afraid of being stopped by Count Rostopchin's
orders, had already in June moved with her Negroes and her women
jesters from Moscow to her Saratov estate, with a vague
consciousness that she was not Bonaparte's servant, was really,
simply, and truly carrying out the great work which saved Russia.
But Count Rostopchin, who now taunted those who left Moscow and now
had the government offices removed; now distributed quite useless
weapons to the drunken rabble; now had processions displaying the
icons, and now forbade Father Augustin to remove icons or the relics
of saints; now seized all the private carts in Moscow and on one
hundred and thirty-six of them removed the balloon that was being
constructed by Leppich; now hinted that he would burn Moscow and
related how he had set fire to his own house; now wrote a proclamation
to the French solemnly upbraiding them for having destroyed his
Orphanage; now claimed the glory of having hinted that he would burn
Moscow and now repudiated the deed; now ordered the people to catch
all spies and bring them to him, and now reproached them for doing so;
now expelled all the French residents from Moscow, and now allowed
Madame Aubert-Chalme (the center of the whole French colony in Moscow)
to remain, but ordered the venerable old postmaster Klyucharev to be
arrested and exiled for no particular offense; now assembled the
people at the Three Hills to fight the French and now, to get rid of
them, handed over to them a man to be killed and himself drove away by
a back gate; now declared that he would not survive the fall of
Moscow, and now wrote French verses in albums concerning his share
in the affair--this man did not understand the meaning of what was
happening but merely wanted to do something himself that would
astonish people, to perform some patriotically heroic feat; and like a
child he made sport of the momentous, and unavoidable event--the
abandonment and burning of Moscow--and tried with his puny hand now to
speed and now to stay the enormous, popular tide that bore him along
with it.





CHAPTER VI


Helene, having returned with the court from Vilna to Petersburg,
found herself in a difficult position.

In Petersburg she had enjoyed the special protection of a grandee
who occupied one of the highest posts in the Empire. In Vilna she
had formed an intimacy with a young foreign prince. When she
returned to Petersburg both the magnate and the prince were there, and
both claimed their rights. Helene was faced by a new problem--how to
preserve her intimacy with both without offending either.

What would have seemed difficult or even impossible to another woman
did not cause the least embarrassment to Countess Bezukhova, who
evidently deserved her reputation of being a very clever woman. Had
she attempted concealment, or tried to extricate herself from her
awkward position by cunning, she would have spoiled her case by
acknowledging herself guilty. But Helene, like a really great man
who can do whatever he pleases, at once assumed her own position to be
correct, as she sincerely believed it to be, and that everyone else
was to blame.

The first time the young foreigner allowed himself to reproach
her, she lifted her beautiful head and, half turning to him, said
firmly: "That's just like a man--selfish and cruel! I expected nothing
else. A woman sacrifices herself for you, she suffers, and this is her
reward! What right have you, monseigneur, to demand an account of my
attachments and friendships? He is a man who has been more than a
father to me!" The prince was about to say something, but Helene
interrupted him.

"Well, yes," said she, "it may be that he has other sentiments for
me than those of a father, but that is not a reason for me to shut
my door on him. I am not a man, that I should repay kindness with
ingratitude! Know, monseigneur, that in all that relates to my
intimate feelings I render account only to God and to my
conscience," she concluded, laying her hand on her beautiful, fully
expanded bosom and looking up to heaven.

"But for heaven's sake listen to me!"

"Marry me, and I will be your slave!"

"But that's impossible."

"You won't deign to demean yourself by marrying me, you..." said
Helene, beginning to cry.

The prince tried to comfort her, but Helene, as if quite distraught,
said through her tears that there was nothing to prevent her marrying,
that there were precedents (there were up to that time very few, but
she mentioned Napoleon and some other exalted personages), that she
had never been her husband's wife, and that she had been sacrificed.

"But the law, religion..." said the prince, already yielding.

"The law, religion... What have they been invented for if they can't
arrange that?" said Helene.

The prince was surprised that so simple an idea had not occurred
to him, and he applied for advice to the holy brethren of the
Society of Jesus, with whom he was on intimate terms.

A few days later at one of those enchanting fetes which Helene
gave at her country house on the Stone Island, the charming Monsieur
de Jobert, a man no longer young, with snow white hair and brilliant
black eyes, a Jesuit a robe courte* was presented to her, and in the
garden by the light of the illuminations and to the sound of music
talked to her for a long time of the love of God, of Christ, of the
Sacred Heart, and of the consolations the one true Catholic religion
affords in this world and the next. Helene was touched, and more
than once tears rose to her eyes and to those of Monsieur de Jobert
and their voices trembled. A dance, for which her partner came to seek
her, put an end to her discourse with her future directeur de
conscience, but the next evening Monsieur de Jobert came to see Helene
when she was alone, and after that often came again.


*Lay member of the Society of Jesus.


One day he took the countess to a Roman Catholic church, where she
knelt down before the altar to which she was led. The enchanting,
middle-aged Frenchman laid his hands on her head and, as she herself
afterward described it, she felt something like a fresh breeze
wafted into her soul. It was explained to her that this was la grace.

After that a long-frocked abbe was brought to her. She confessed
to him, and he absolved her from her sins. Next day she received a box
containing the Sacred Host, which was left at her house for her to
partake of. A few days later Helene learned with pleasure that she had
now been admitted to the true Catholic Church and that in a few days
the Pope himself would hear of her and would send her a certain
document.

All that was done around her and to her at this time, all the
attention devoted to her by so many clever men and expressed in such
pleasant, refined ways, and the state of dove-like purity she was
now in (she wore only white dresses and white ribbons all that time)
gave her pleasure, but her pleasure did not cause her for a moment
to forget her aim. And as it always happens in contests of cunning
that a stupid person gets the better of cleverer ones, Helene-
having realized that the main object of all these words and all this
trouble was, after converting her to Catholicism, to obtain money from
her for Jesuit institutions (as to which she received indications)-
before parting with her money insisted that the various operations
necessary to free her from her husband should be performed. In her
view the aim of every religion was merely to preserve certain
proprieties while affording satisfaction to human desires. And with
this aim, in one of her talks with her Father Confessor, she
insisted on an answer to the question, in how far was she bound by her
marriage?

They were sitting in the twilight by a window in the drawing room.
The scent of flowers came in at the window. Helene was wearing a white
dress, transparent over her shoulders and bosom. The abbe, a
well-fed man with a plump, clean-shaven chin, a pleasant firm mouth,
and white hands meekly folded on his knees, sat close to Helene and,
with a subtle smile on his lips and a peaceful look of delight at
her beauty, occasionally glanced at her face as he explained his
opinion on the subject. Helene with an uneasy smile looked at his
curly hair and his plump, clean-shaven, blackish cheeks and every
moment expected the conversation to take a fresh turn. But the abbe,
though he evidently enjoyed the beauty of his companion, was
absorbed in his mastery of the matter.

The course of the Father Confessor's arguments ran as follows:
"Ignorant of the import of what you were undertaking, you made a vow
of conjugal fidelity to a man who on his part, by entering the married
state without faith in the religious significance of marriage,
committed an act of sacrilege. That marriage lacked the dual
significance it should have had. Yet in spite of this your vow was
binding. You swerved from it. What did you commit by so acting? A
venial, or a mortal, sin? A venial sin, for you acted without evil
intention. If now you married again with the object of bearing
children, your sin might be forgiven. But the question is again a
twofold one: firstly..."

But suddenly Helene, who was getting bored, said with one of her
bewitching smiles: "But I think that having espoused the true religion
I cannot be bound by what a false religion laid upon me."

The director of her conscience was astounded at having the case
presented to him thus with the simplicity of Columbus' egg. He was
delighted at the unexpected rapidity of his pupil's progress, but
could not abandon the edifice of argument he had laboriously
constructed.

"Let us understand one another, Countess," said he with a smile, and
began refuting his spiritual daughter's arguments.





CHAPTER VII


Helene understood that the question was very simple and easy from
the ecclesiastical point of view, and that her directors were making
difficulties only because they were apprehensive as to how the
matter would be regarded by the secular authorities.

So she decided that it was necessary to prepare the opinion of
society. She provoked the jealousy of the elderly magnate and told him
what she had told her other suitor; that is, she put the matter so
that the only way for him to obtain a right over her was to marry her.
The elderly magnate was at first as much taken aback by this
suggestion of marriage with a woman whose husband was alive, as the
younger man had been, but Helene's imperturbable conviction that it
was as simple and natural as marrying a maiden had its effect on him
too. Had Helene herself shown the least sign of hesitation, shame,
or secrecy, her cause would certainly have been lost; but not only did
she show no signs of secrecy or shame, on the contrary, with
good-natured naivete she told her intimate friends (and these were all
Petersburg) that both the prince and the magnate had proposed to her
and that she loved both and was afraid of grieving either.

A rumor immediately spread in Petersburg, not that Helene wanted
to be divorced from her husband (had such a report spread many would
have opposed so illegal an intention) but simply that the
unfortunate and interesting Helene was in doubt which of the two men
she should marry. The question was no longer whether this was
possible, but only which was the better match and how the matter would
be regarded at court. There were, it is true, some rigid individuals
unable to rise to the height of such a question, who saw in the
project a desecration of the sacrament of marriage, but there were not
many such and they remained silent, while the majority were interested
in Helene's good fortune and in the question which match would be
the more advantageous. Whether it was right or wrong to remarry
while one had a husband living they did not discuss, for that question
had evidently been settled by people "wiser than you or me," as they
said, and to doubt the correctness of that decision would be to risk
exposing one's stupidity and incapacity to live in society.

Only Marya Dmitrievna Akhrosimova, had come to Petersburg that
summer to see one of her sons, allowed herself plainly to express an
opinion contrary to the general one. Meeting Helene at a ball she
stopped her in the middle of the room and, amid general silence,
said in her gruff voice: "So wives of living men have started marrying
again! Perhaps you think you have invented a novelty? You have been
forestalled, my dear! It was thought of long ago. It is done in all
the brothels," and with these words Marya Dmitrievna, turning up her
wide sleeves with her usual threatening gesture and glancing sternly
round, moved across the room.

Though people were afraid of Marya Dmitrievna she was regarded in
Petersburg as a buffoon, and so of what she had said they only
noticed, and repeated in a whisper, the one coarse word she had
used, supposing the whole sting of her remark to lie in that word.

Prince Vasili, who of late very often forgot what he had said and
repeated one and the same thing a hundred times, remarked to his
daughter whenever he chanced to see her:

"Helene, I have a word to say to you," and he would lead her
aside, drawing her hand downward. "I have heard of certain projects
concerning... you know. Well my dear child, you know how your father's
heart rejoices to know that you... You have suffered so much....
But, my dear child, consult only your own heart. That is all I have to
say," and concealing his unvarying emotion he would press his cheek
against his daughter's and move away.

Bilibin, who had not lost his reputation of an exceedingly clever
man, and who was one of the disinterested friends so
brilliant a woman as Helene always has--men friends who can never
change into lovers--once gave her his view of the matter at a small
and intimate gathering.

"Listen, Bilibin," said Helene (she always called friends of that
sort by their surnames), and she touched his coat sleeve with her
white, beringed fingers. "Tell me, as you would a sister, what I ought
to do. Which of the two?"

Bilibin wrinkled up the skin over his eyebrows and pondered, with
a smile on his lips.

"You are not taking me unawares, you know," said he. "As a true
friend, I have thought and thought again about your affair. You see,
if you marry the prince"--he meant the younger man--and he crooked one
finger, "you forever lose the chance of marrying the other, and you
will displease the court besides. (You know there is some kind of
connection.) But if you marry the old count you will make his last
days happy, and as widow of the Grand... the prince would no longer be
making a mesalliance by marrying you," and Bilibin smoothed out his
forehead.

"That's a true friend!" said Helene beaming, and again touching
Bilibin's sleeve. "But I love them, you know, and don't want to
distress either of them. I would give my life for the happiness of
them both."

Bilibin shrugged his shoulders, as much as to say that not even he
could help in that difficulty.

"Une maitresse-femme!* That's what is called putting things
squarely. She would like to be married to all three at the same time,"
thought he.


*A masterly woman.


"But tell me, how will your husband look at the matter?" Bilibin
asked, his reputation being so well established that he did not fear
to ask so naive a question. "Will he agree?"

"Oh, he loves me so!" said Helene, who for some reason imagined that
Pierre too loved her. "He will do anything for me."

Bilibin puckered his skin in preparation for something witty.

"Even divorce you?" said he.

Helene laughed.

Among those who ventured to doubt the justifiability of the proposed
marriage was Helene's mother, Princess Kuragina. She was continually
tormented by jealousy of her daughter, and now that jealousy concerned
a subject near to her own heart, she could not reconcile herself to
the idea. She consulted a Russian priest as to the possibility of
divorce and remarriage during a husband's lifetime, and the priest
told her that it was impossible, and to her delight showed her a
text in the Gospel which (as it seemed to him) plainly remarriage
while the husband is alive.

Armed with these arguments, which appeared to her unanswerable,
she drove to her daughter's early one morning so as to find her alone.

Having listened to her mother's objections, Helene smiled blandly
and ironically.

"But it says plainly: 'Whosoever shall marry her that is
divorced...'" said the old princess.

"Ah, Maman, ne dites pas de betises. Vous ne comprenez rein. Dans ma
position j'ai des devoirs,"* said Helene changing from Russian, in
which language she always felt that her case did not sound quite
clear, into French which suited it better.


*"Oh, Mamma, don't talk nonsense! You don't understand anything.
In my position I have obligations.


"But, my dear...."

"Oh, Mamma, how is it you don't understand that the Holy Father, who
has the right to grant dispensations..."

Just then the lady companion who lived with Helene came in to
announce that His Highness was in the ballroom and wished to see her.

"Non, dites-lui que je ne veux pas le voir, que je suis furieuse
contre lui, parce qu'il m' a manque parole."*


*"No, tell him I don't wish to see him, I am furious with him for
not keeping his word to me."


"Comtesse, a tout peche misericorde,"* said a fair-haired young
man with a long face and nose, as he entered the room.


*"Countess, there is mercy for every sin."


The old princess rose respectfully and curtsied. The young man who
had entered took no notice of her. The princess nodded to her daughter
and sidled out of the room.

"Yes, she is right," thought the old princess, all her convictions
dissipated by the appearance of His Highness. "She is right, but how
is it that we in our irrecoverable youth did not know it? Yet it is so
simple," she thought as she got into her carriage.


By the beginning of August Helene's affairs were clearly defined and
she wrote a letter to her husband--who, as she imagined, loved her
very much--informing him of her intention to marry N.N. and of her
having embraced the one true faith, and asking him to carry out all
the formalities necessary for a divorce, which would be explained to
him by the bearer of the letter.


And so I pray God to have you, my friend, in His holy and powerful
keeping--Your friend Helene.


This letter was brought to Pierre's house when he was on the field
of Borodino.





CHAPTER VIII


Toward the end of the battle of Borodino, Pierre, having run down
from Raevski's battery a second time, made his way through a gully
to Knyazkovo with a crowd of soldiers, reached the dressing station,
and seeing blood and hearing cries and groans hurried on, still
entangled in the crowds of soldiers.

The one thing he now desired with his whole soul was to get away
quickly from the terrible sensations amid which he had lived that
day and return to ordinary conditions of life and sleep quietly in a
room in his own bed. He felt that only in the ordinary conditions of
life would he be able to understand himself and all he had seen and
felt. But such ordinary conditions of life were nowhere to be found.

Though shells and bullets did not whistle over the road along
which he was going, still on all sides there was what there had been
on the field of battle. There were still the same suffering,
exhausted, and sometimes strangely indifferent faces, the same
blood, the same soldiers' overcoats, the same sounds of firing
which, though distant now, still aroused terror, and besides this
there were the foul air and the dust.

Having gone a couple of miles along the Mozhaysk road, Pierre sat
down by the roadside.

Dusk had fallen, and the roar of guns died away. Pierre lay
leaning on his elbow for a long time, gazing at the shadows that moved
past him in the darkness. He was continually imagining that a cannon
ball was flying toward him with a terrific whizz, and then he
shuddered and sat up. He had no idea how long he had been there. In
the middle of the night three soldiers, having brought some
firewood, settled down near him and began lighting a fire.

The soldiers, who threw sidelong glances at Pierre, got the fire
to burn and placed an iron pot on it into which they broke some
dried bread and put a little dripping. The pleasant odor of greasy
viands mingled with the smell of smoke. Pierre sat up and sighed.
The three soldiers were eating and talking among themselves, taking no
notice of him.

"And who may you be?" one of them suddenly asked Pierre, evidently
meaning what Pierre himself had in mind, namely: "If you want to eat
we'll give you some food, only let us know whether you are an honest
man."

"I, I..." said Pierre, feeling it necessary to minimize his social
position as much as possible so as to be nearer to the soldiers and
better understood by them. "By rights I am a militia officer, but my
men are not here. I came to the battle and have lost them."

"There now!" said one of the soldiers.

Another shook his head.

"Would you like a little mash?" the first soldier asked, and
handed Pierre a wooden spoon after licking it clean.

Pierre sat down by the fire and began eating the mash, as they
called the food in the cauldron, and he thought it more delicious than
any food he had ever tasted. As he sat bending greedily over it,
helping himself to large spoonfuls and chewing one after another,
his was lit up by the fire and the soldiers looked at him in silence.

"Where have you to go to? Tell us!" said one of them.

"To Mozhaysk."

"You're a gentleman, aren't you?"

"Yes."

"And what's your name?"

"Peter Kirilych."

"Well then, Peter Kirilych, come along with us, we'll take you
there."

In the total darkness the soldiers walked with Pierre to Mozhaysk.

By the time they got near Mozhaysk and began ascending the steep
hill into the town, the cocks were already crowing. Pierre went on
with the soldiers, quite forgetting that his inn was at the bottom
of the hill and that he had already passed it. He would not soon
have remembered this, such was his state of forgetfulness, had he
not halfway up the hill stumbled upon his groom, who had been to
look for him in the town and was returning to the inn. The groom
recognized Pierre in the darkness by his white hat.

"Your excellency!" he said. "Why, we were beginning to despair!
How is it you are on foot? And where are you going, please?"

"Oh, yes!" said Pierre.

The soldiers stopped.

"So you've found your folk?" said one of them. "Well, good-by, Peter
Kirilych--isn't it?"

"Good-by, Peter Kirilych!" Pierre heard the other voices repeat.

"Good-by!" he said and turned with his groom toward the inn.

"I ought to give them something!" he thought, and felt in his
pocket. "No, better not!" said another, inner voice.

There was not a room to be had at the inn, they were all occupied.
Pierre went out into the yard and, covering himself up head and all,
lay down in his carriage.





CHAPTER IX


Scarcely had Pierre laid his head on the pillow before he felt
himself falling asleep, but suddenly, almost with the distinctness
of reality, he heard the boom, boom, boom of firing, the thud of
projectiles, groans and cries, and smelled blood and powder, and a
feeling of horror and dread of death seized him. Filled with fright he
opened his eyes and lifted his head from under his cloak. All was
tranquil in the yard. Only someone's orderly passed through the
gateway, splashing through the mud, and talked to the innkeeper. Above
Pierre's head some pigeons, disturbed by the movement he had made in
sitting up, fluttered under the dark roof of the penthouse. The
whole courtyard was permeated by a strong peaceful smell of stable
yards, delightful to Pierre at that moment. He could see the clear
starry sky between the dark roofs of two penthouses.

"Thank God, there is no more of that!" he thought, covering up his
head again. "Oh, what a terrible thing is fear, and how shamefully I
yielded to it! But they... they were steady and calm all the time,
to the end..." thought he.

They, in Pierre's mind, were the soldiers, those who had been at the
battery, those who had given him food, and those who had prayed before
the icon. They, those strange men he had not previously known, stood
out clearly and sharply from everyone else.

"To be a soldier, just a soldier!" thought Pierre as he fell asleep,
"to enter communal life completely, to be imbued by what makes them
what they are. But how cast off all the superfluous, devilish burden
of my outer man? There was a time when I could have done it. I could
have run away from my father, as I wanted to. Or I might have been
sent to serve as a soldier after the duel with Dolokhov." And the
memory of the dinner at the English Club when he had challenged
Dolokhov flashed through Pierre's mind, and then he remembered his
benefactor at Torzhok. And now a picture of a solemn meeting of the
lodge presented itself to his mind. It was taking place at the English
Club and someone near and dear to him sat at the end of the table.
"Yes, that is he! It is my benefactor. But he died!" thought Pierre.
"Yes, he died, and I did not know he was alive. How sorry I am that he
died, and how glad I am that he is alive again!" On one side of the
table sat Anatole, Dolokhov, Nesvitski, Denisov, and others like
them (in his dream the category to which these men belonged was as
clearly defined in his mind as the category of those he termed
they), and he heard those people, Anatole and Dolokhov, shouting and
singing loudly; yet through their shouting the voice of his benefactor
was heard speaking all the time and the sound of his words was as
weighty and uninterrupted as the booming on the battlefield, but
pleasant and comforting. Pierre did not understand what his benefactor
was saying, but he knew (the categories of thoughts were also quite
distinct in his dream) that he was talking of goodness and the
possibility of being what they were. And they with their simple, kind,
firm faces surrounded his benefactor on all sides. But though they
were kindly they did not look at Pierre and did not know him.
Wishing to speak and to attract their attention, he got up, but at
that moment his legs grew cold and bare.

He felt ashamed, and with one arm covered his legs from which his
cloak had in fact slipped. For a moment as he was rearranging his
cloak Pierre opened his eyes and saw the same penthouse roofs,
posts, and yard, but now they were all bluish, lit up, and
glittering with frost or dew.

"It is dawn," thought Pierre. "But that's not what I want. I want to
hear and understand my benefactor's words." Again he covered himself
up with his cloak, but now neither the lodge nor his benefactor was
there. There were only thoughts clearly expressed in words, thoughts
that someone was uttering or that he himself was formulating.

Afterwards when he recalled those thoughts Pierre was convinced that
someone outside himself had spoken them, though the impressions of
that day had evoked them. He had never, it seemed to him, been able to
think and express his thoughts like that when awake.

"To endure war is the most difficult subordination of man's
freedom to the law of God," the voice had said. "Simplicity is
submission to the will of God; you cannot escape from Him. And they
are simple. They do not talk, but act. The spoken word is silver but
the unspoken is golden. Man can be master of nothing while he fears
death, but he who does not fear it possesses all. If there were no
suffering, man would not know his limitations, would not know himself.
The hardest thing [Pierre went on thinking, or hearing, in his
dream] is to be able in your soul to unite the meaning of all. To
unite all?" he asked himself. "No, not to unite. Thoughts cannot be
united, but to harness all these thoughts together is what we need!
Yes, one must harness them, must harness them!" he repeated to himself
with inward rapture, feeling that these words and they alone expressed
what he wanted to say and solved the question that tormented him.

"Yes, one must harness, it is time to harness."

"Time to harness, time to harness, your excellency! Your
excellency!" some voice was repeating. "We must harness, it is time to
harness...."

It was the voice of the groom, trying to wake him. The sun shone
straight into Pierre's face. He glanced at the dirty innyard in the
middle of which soldiers were watering their lean horses at the pump
while carts were passing out of the gate. Pierre turned away with
repugnance, and closing his eyes quickly fell back on the carriage
seat. "No, I don't want that, I don't want to see and understand that.
I want to understand what was revealing itself to me in my dream.
One second more and I should have understood it all! But what am I
to do? Harness, but how can I harness everything?" and Pierre felt
with horror that the meaning of all he had seen and thought in the
dream had been destroyed.

The groom, the coachman, and the innkeeper told Pierre that an
officer had come with news that the French were already near
Mozhaysk and that our men were leaving it.

Pierre got up and, having told them to harness and overtake him,
went on foot through the town.

The troops were moving on, leaving about ten thousand wounded behind
them. There were wounded in the yards, at the windows of the houses,
and the streets were crowded with them. In the streets, around carts
that were to take some of the wounded away, shouts, curses, and
blows could be heard. Pierre offered the use of his carriage, which
had overtaken him, to a wounded general he knew, and drove with him
to Moscow. On the way Pierre was told of the death of his
brother-in-law Anatole and of that of Prince Andrew.





CHAPTER X


On the thirteenth of August Pierre reached Moscow. Close to the
gates of the city he was met by Count Rostopchin's adjutant.

"We have been looking for you everywhere," said the adjutant. "The
count wants to see you particularly. He asks you to come to him at
once on a very important matter."

Without going home, Pierre took a cab and drove to see the Moscow
commander in chief.

Count Rostopchin had only that morning returned to town from his
summer villa at Sokolniki. The anteroom and reception room of his
house were full of officials who had been summoned or had come for
orders. Vasilchikov and Platov had already seen the count and
explained to him that it was impossible to defend Moscow and that it
would have to be surrendered. Though this news was being concealed
from the inhabitants, the officials--the heads of the various
government departments--knew that Moscow would soon be in the
enemy's hands, just as Count Rostopchin himself knew it, and to escape
personal responsibility they had all come to the governor to ask how
they were to deal with their various departments.

As Pierre was entering the reception room a courier from the army
came out of Rostopchin's private room.

In answer to questions with which he was greeted, the courier made a
despairing gesture with his hand and passed through the room.

While waiting in the reception room Pierre with weary eyes watched
the various officials, old and young, military and civilian, who
were there. They all seemed dissatisfied and uneasy. Pierre went up to
a group of men, one of whom he knew. After greeting Pierre they
continued their conversation.

"If they're sent out and brought back again later on it will do no
harm, but as things are now one can't answer for anything."

"But you see what he writes..." said another, pointing to a
printed sheet he held in his hand.

"That's another matter. That's necessary for the people," said the
first.

"What is it?" asked Pierre.

"Oh, it's a fresh broadsheet."

Pierre took it and began reading.


His Serene Highness has passed through Mozhaysk in order to join
up with the troops moving toward him and has taken up a strong
position where the enemy will not soon attack him. Forty eight guns
with ammunition have been sent him from here, and his Serene
Highness says he will defend Moscow to the last drop of blood and is
even ready to fight in the streets. Do not be upset, brothers, that
the law courts are closed; things have to be put in order, and we will
deal with villains in our own way! When the time comes I shall want
both town and peasant lads and will raise the cry a day or two
beforehand, but they are not wanted yet so I hold my peace. An ax will
be useful, a hunting spear not bad, but a three-pronged fork will be
best of all: a Frenchman is no heavier than a sheaf of rye. Tomorrow
after dinner I shall take the Iberian icon of the Mother of God to the
wounded in the Catherine Hospital where we will have some water
blessed. That will help them to get well quicker. I, too, am well now:
one of my eyes was sore but now I am on the lookout with both.


"But military men have told me that it is impossible to fight in the
town," said Pierre, "and that the position..."

"Well, of course! That's what we were saying," replied the first
speaker.

"And what does he mean by 'One of my eyes was sore but now I am on
the lookout with both'?" asked Pierre.

"The count had a sty," replied the adjutant smiling, "and was very
much upset when I told him people had come to ask what was the
matter with him. By the by, Count," he added suddenly, addressing
Pierre with a smile, "we heard that you have family troubles and
that the countess, your wife..."

"I have heard nothing," Pierre replied unconcernedly. "But what have
you heard?"

"Oh, well, you know people often invent things. I only say what I
heard."

"But what did you hear?"

"Well, they say," continued the adjutant with the same smile,
"that the countess, your wife, is preparing to go abroad. I expect
it's nonsense...."

"Possibly," remarked Pierre, looking about him absent-mindedly. "And
who is that?" he asked, indicating a short old man in a clean blue
peasant overcoat, with a big snow-white beard and eyebrows and a ruddy
face.

"He? That's a tradesman, that is to say, he's the restaurant keeper,
Vereshchagin. Perhaps you have heard of that affair with the
proclamation."

"Oh, so that is Vereshchagin!" said Pierre, looking at the firm,
calm face of the old man and seeking any indication of his being a
traitor.

"That's not he himself, that's the father of the fellow who wrote
the proclamation," said the adjutant. "The young man is in prison
and I expect it will go hard with him."

An old gentleman wearing a star and another official, a German
wearing a cross round his neck, approached the speaker.

"It's a complicated story, you know," said the adjutant. "That
proclamation appeared about two months ago. The count was informed
of it. He gave orders to investigate the matter. Gabriel Ivanovich
here made the inquiries. The proclamation had passed through exactly
sixty-three hands. He asked one, 'From whom did you get it?' 'From
so-and-so.' He went to the next one. 'From whom did you get it?' and
so on till he reached Vereshchagin, a half educated tradesman, you
know, 'a pet of a trader,'" said the adjutant smiling. "They asked
him, 'Who gave it you?' And the point is that we knew whom he had it
from. He could only have had it from the Postmaster. But evidently
they had come to some understanding. He replied: 'From no one; I
made it up myself.' They threatened and questioned him, but he stuck
to that: 'I made it up myself.' And so it was reported to the count,
who sent for the man. 'From whom did you get the proclamation?' 'I
wrote it myself.' Well, you know the count," said the adjutant
cheerfully, with a smile of pride, "he flared up dreadfully--and
just think of the fellow's audacity, lying, and obstinacy!"

 "And the count wanted him to say it was from Klyucharev? I
understand!" said Pierre.

"Not at all," rejoined the adjutant in dismay. "Klyucharev had his
own sins to answer for without that and that is why he has been
banished. But the point is that the count was much annoyed. 'How could
you have written it yourself?' said he, and he took up the Hamburg
Gazette that was lying on the table. 'Here it is! You did not write it
yourself but translated it, and translated it abominably, because
you don't even know French, you fool.' And what do you think? 'No,'
said he, 'I have not read any papers, I made it up myself.' 'If that's
so, you're a traitor and I'll have you tried, and you'll be hanged!
Say from whom you had it.' 'I have seen no papers, I made it up
myself.' And that was the end of it. The count had the father fetched,
but the fellow stuck to it. He was sent for trial and condemned to
hard labor, I believe. Now the father has come to intercede for him.
But he's a good-for-nothing lad! You know that sort of tradesman's
son, a dandy and lady-killer. He attended some lectures somewhere
and imagines that the devil is no match for him. That's the sort of
fellow he is. His father keeps a cookshop here by the Stone Bridge,
and you know there was a large icon of God Almighty painted with a
scepter in one hand and an orb in the other. Well, he took that icon
home with him for a few days and what did he do? He found some
scoundrel of a painter..."





CHAPTER XI


In the middle of this fresh tale Pierre was summoned to the
commander in chief.

When he entered the private room Count Rostopchin, puckering his
face, was rubbing his forehead and eyes with his hand. A short man was
saying something, but when Pierre entered he stopped speaking and went
out.

"Ah, how do you do, great warrior?" said Rostopchin as soon as the
short man had left the room. "We have heard of your prowess. But
that's not the point. Between ourselves, mon cher, do you belong to
the Masons?" he went on severely, as though there were something wrong
about it which he nevertheless intended to pardon. Pierre remained
silent. "I am well informed, my friend, but I am aware that there
are Masons and I hope that you are not one of those who
on pretense of saving mankind wish to ruin Russia."

"Yes, I am a Mason," Pierre replied.

"There, you see, mon cher! I expect you know that Messrs.
Speranski and Magnitski have been deported to their proper place.
Mr. Klyucharev has been treated in the same way, and so have others
who on the plea of building up the temple of Solomon have tried to
destroy the temple of their fatherland. You can understand that
there are reasons for this and that I could not have exiled the
Postmaster had he not been a harmful person. It has now come to my
knowledge that you lent him your carriage for his removal from town,
and that you have even accepted papers from him for safe custody. I
like you and don't wish you any harm and--as you are only half my age-
I advise you, as a father would, to cease all communication with men
of that stamp and to leave here as soon as possible."

"But what did Klyucharev do wrong, Count?" asked Pierre.

"That is for me to know, but not for you to ask," shouted
Rostopchin.

"If he is accused of circulating Napoleon's proclamation it is not
proved that he did so," said Pierre without looking at Rostopchin,
"and Vereshchagin..."

"There we are!" Rostopchin shouted at Pierre louder than before,
frowning suddenly. "Vereshchagin is a renegade and a traitor who
will be punished as he deserves," said he with the vindictive heat
with which people speak when recalling an insult. "But I did not
summon you to discuss my actions, but to give you advice--or an
order if you prefer it. I beg you to leave the town and break off
all communication with such men as Klyucharev. And I will knock the
nonsense out of anybody"--but probably realizing that he was
shouting at Bezukhov who so far was not guilty of anything, he
added, taking Pierre's hand in a friendly manner, "We are on the eve
of a public disaster and I haven't time to be polite to everybody
who has business with me. My head is sometimes in a whirl. Well, mon
cher, what are you doing personally?"

"Why, nothing," answered Pierre without raising his eyes or changing
the thoughtful expression of his face.

The count frowned.

"A word of friendly advice, mon cher. Be off as soon as you can,
that's all I have to tell you. Happy he who has ears to hear. Good-by,
my dear fellow. Oh, by the by!" he shouted through the doorway after
Pierre, "is it true that the countess has fallen into the clutches
of the holy fathers of the Society of Jesus?"

Pierre did not answer and left Rostopchin's room more sullen and
angry than he had ever before shown himself.

When he reached home it was already getting dark. Some eight
people had come to see him that evening: the secretary of a committee,
the colonel of his battalion, his steward, his major-domo, and various
petitioners. They all had business with Pierre and wanted decisions
from him. Pierre did not understand and was not interested in any of
these questions and only answered them in order to get rid of these
people. When left alone at last he opened and read his wife's letter.

"They, the soldiers at the battery, Prince Andrew killed... that old
man... Simplicity is submission to God. Suffering is necessary...
the meaning of all... one must harness... my wife is getting
married... One must forget and understand..." And going to his bed
he threw himself on it without undressing and immediately fell asleep.

When he awoke next morning the major-domo came to inform him that
a special messenger, a police officer, had come from Count
Rostopchin to know whether Count Bezukhov had left or was leaving
the town.

A dozen persons who had business with Pierre were awaiting him in
the drawing room. Pierre dressed hurriedly and, instead of going to
see them, went to the back porch and out through the gate.

From that time till the end of the destruction of Moscow no one of
Bezukhov's household, despite all the search they made, saw Pierre
again or knew where he was.





CHAPTER XII


The Rostovs remained in Moscow till the first of September, that is,
till the eve of the enemy's entry into the city.

After Petya had joined Obolenski's regiment of Cossacks and left for
Belaya Tserkov where that regiment was forming, the countess was
seized with terror. The thought that both her sons were at the war,
had both gone from under her wing, that today or tomorrow either or
both of them might be killed like the three sons of one of her
acquaintances, struck her that summer for the first time with cruel
clearness. She tried to get Nicholas back and wished to go herself
to join Petya, or to get him an appointment somewhere in Petersburg,
but neither of these proved possible. Petya could not return unless
his regiment did so or unless he was transferred to another regiment
on active service. Nicholas was somewhere with the army and had not
sent a word since his last letter, in which he had given a detailed
account of his meeting with Princess Mary. The countess did not
sleep at night, or when she did fall asleep dreamed that she saw her
sons lying dead. After many consultations and conversations, the count
at last devised means to tranquillize her. He got Petya transferred
from Obolenski's regiment to Bezukhov's, which was in training near
Moscow. Though Petya would remain in the service, this transfer
would give the countess the consolation of seeing at least one of
her sons under her wing, and she hoped to arrange matters for her
Petya so as not to let him go again, but always get him appointed to
places where he could not possibly take part in a battle. As long as
Nicholas alone was in danger the countess imagined that she loved
her first-born more than all her other children and even reproached
herself for it; but when her youngest: the scapegrace who had been bad
at lessons, was always breaking things in the house and making himself
a nuisance to everybody, that snub-nosed Petya with his merry black
eyes and fresh rosy cheeks where soft down was just beginning to show-
when he was thrown amid those big, dreadful, cruel men who were
fighting somewhere about something and apparently finding pleasure
in it--then his mother thought she loved him more, much more, than all
her other children. The nearer the time came for Petya to return,
the more uneasy grew the countess. She began to think she would
never live to see such happiness. The presence of Sonya, of her
beloved Natasha, or even of her husband irritated her. "What do I want
with them? I want no one but Petya," she thought.

At the end of August the Rostovs received another letter from
Nicholas. He wrote from the province of Voronezh where he had been
sent to procure remounts, but that letter did not set the countess
at ease. Knowing that one son was out of danger she became the more
anxious about Petya.

Though by the twentieth of August nearly all the Rostovs'
acquaintances had left Moscow, and though everybody tried to
persuade the countess to get away as quickly as possible, she would
not bear of leaving before her treasure, her adored Petya, returned.
On the twenty-eighth of August he arrived. The passionate tenderness
with which his mother received him did not please the sixteen-year-old
officer. Though she concealed from him her intention of keeping him
under her wing, Petya guessed her designs, and instinctively fearing
that he might give way to emotion when with her--might "become
womanish" as he termed it to himself--he treated her coldly, avoided
her, and during his stay in Moscow attached himself exclusively to
Natasha for whom he had always had a particularly brotherly
tenderness, almost lover-like.

Owing to the count's customary carelessness nothing was ready for
their departure by the twenty-eighth of August and the carts that were
to come from their Ryazan and Moscow estates to remove their household
belongings did not arrive till the thirtieth.

From the twenty-eighth till the thirty-first all Moscow was in a
bustle and commotion. Every day thousands of men wounded at Borodino
were brought in by the Dorogomilov gate and taken to various parts
of Moscow, and thousands of carts conveyed the inhabitants and their
possessions out by the other gates. In spite of Rostopchin's
broadsheets, or because of them or independently of them, the
strangest and most contradictory rumors were current in the town. Some
said that no one was to be allowed to leave the city, others on the
contrary said that all the icons had been taken out of the churches
and everybody was to be ordered to leave. Some said there had been
another battle after Borodino at which the French had been routed,
while others on the contrary reported that the Russian army bad been
destroyed. Some talked about the Moscow militia which, preceded by the
clergy, would go to the Three Hills; others whispered that Augustin
had been forbidden to leave, that traitors had been seized, that the
peasants were rioting and robbing people on their way from Moscow, and
so on. But all this was only talk; in reality (though the Council of
Fili, at which it was decided to abandon Moscow, had not yet been
held) both those who went away and those who remained behind felt,
though they did not show it, that Moscow would certainly be abandoned,
and that they ought to get away as quickly as possible and save
their belongings. It was felt that everything would suddenly break
up and change, but up to the first of September nothing had done so.
As a criminal who is being led to execution knows that he must die
immediately, but yet looks about him and straightens the cap that is
awry on his head, so Moscow involuntarily continued its wonted life,
though it knew that the time of its destruction was near when the
conditions of life to which its people were accustomed to submit would
be completely upset.

During the three days preceding the occupation of Moscow the whole
Rostov family was absorbed in various activities. The head of the
family, Count Ilya Rostov, continually drove about the city collecting
the current rumors from all sides and gave superficial and hasty
orders at home about the preparations for their departure.

The countess watched the things being packed, was dissatisfied
with everything, was constantly in pursuit of Petya who was always
running away from her, and was jealous of Natasha with whom he spent
all his time. Sonya alone directed the practical side of matters by
getting things packed. But of late Sonya had been particularly sad and
silent. Nicholas' letter in which he mentioned Princess Mary had
elicited, in her presence, joyous comments from the countess, who
saw an intervention of Providence in this meeting of the princess
and Nicholas.

"I was never pleased at Bolkonski's engagement to Natasha," said the
countess, "but I always wanted Nicholas to marry the princess, and had
a presentiment that it would happen. What a good thing it would be!"

Sonya felt that this was true: that the only possibility of
retrieving the Rostovs' affairs was by Nicholas marrying a rich woman,
and that the princess was a good match. It was very bitter for her.
But despite her grief, or perhaps just because of it, she took on
herself all the difficult work of directing the storing and packing of
their things and was busy for whole days. The count and countess
turned to her when they had any orders to give. Petya and Natasha on
the contrary, far from helping their parents, were generally a
nuisance and a hindrance to everyone. Almost all day long the house
resounded with their running feet, their cries, and their
spontaneous laughter. They laughed and were gay not because there
was any reason to laugh, but because gaiety and mirth were in their
hearts and so everything that happened was a cause for gaiety and
laughter to them. Petya was in high spirits because having left home a
boy he had returned (as everybody told him) a fine young man,
because he was at home, because he had left Belaya Tserkov where there
was no hope of soon taking part in a battle and had come to Moscow
where there was to be fighting in a few days, and chiefly because
Natasha, whose lead he always followed, was in high spirits. Natasha
was gay because she had been sad too long and now nothing reminded her
of the cause of her sadness, and because she was feeling well. She was
also happy because she had someone to adore her: the adoration of
others was a lubricant the wheels of her machine needed to make them
run freely--and Petya adored her. Above all, they were gay because
there was a war near Moscow, there would be fighting at the town
gates, arms were being given out, everybody was escaping--going away
somewhere, and in general something extraordinary was happening, and
that is always exciting, especially to the young.





CHAPTER XIII


On Saturday, the thirty-first of August, everything in the
Rostovs' house seemed topsy-turvy. All the doors were open, all the
furniture was being carried out or moved about, and the mirrors and
pictures had been taken down. There were trunks in the rooms, and hay,
wrapping paper, and ropes were scattered about. The peasants and house
serfs carrying out the things were treading heavily on the parquet
floors. The yard was crowded with peasant carts, some loaded high
and already corded up, others still empty.

The voices and footsteps of the many servants and of the peasants
who had come with the carts resounded as they shouted to one another
in the yard and in the house. The count bad been out since morning.
The countess had a headache brought on by all the noise and turmoil
and was lying down in the new sitting room with a vinegar compress
on her head. Petya was not at home, he had gone to visit a friend with
whom he meant to obtain a transfer from the militia to the active
army. Sonya was in the ballroom looking after the packing of the glass
and china. Natasha was sitting on the floor of her dismantled room
with dresses, ribbons, and scarves strewn all about her, gazing
fixedly at the floor and holding in her hands the old ball dress
(already out of fashion) which she had worn at her first Petersburg
ball.

Natasha was ashamed of doing nothing when everyone else was so busy,
and several times that morning had tried to set to work, but her heart
was not in it, and she could not and did not know how to do anything
except with all her heart and all her might. For a while she had stood
beside Sonya while the china was being packed and tried to help, but
soon gave it up and went to her room to pack her own things. At
first she found it amusing to give away dresses and ribbons to the
maids, but when that was done and what was left had still to be
packed, she found it dull.

"Dunyasha, you pack! You will, won't you, dear?" And when Dunyasha
willingly promised to do it all for her, Natasha sat down on the
floor, took her old ball dress, and fell into a reverie quite
unrelated to what ought to have occupied her thoughts now. She was
roused from her reverie by the talk of the maids in the next room
(which was theirs) and by the sound of their hurried footsteps going
to the back porch. Natasha got up and looked out of the window. An
enormously long row of carts full of wounded men had stopped in the
street.

The housekeeper, the old nurse, the cooks, coachmen, maids, footmen,
postilions, and scullions stood at the gate, staring at the wounded.

Natasha, throwing a clean pocket handkerchief over her hair and
holding an end of it in each hand, went out into the street.

The former housekeeper, old Mavra Kuzminichna, had stepped out of
the crowd by the gate, gone up to a cart with a hood constructed of
bast mats, and was speaking to a pale young officer who lay inside.
Natasha moved a few steps forward and stopped shyly, still holding her
handkerchief, and listened to what the housekeeper was saying.

"Then you have nobody in Moscow?" she was saying. "You would be more
comfortable somewhere in a house... in ours, for instance... the
family are leaving."

"I don't know if it would be allowed," replied the officer in a weak
voice. "Here is our commanding officer... ask him," and he pointed
to a stout major who was walking back along the street past the row of
carts.

Natasha glanced with frightened eyes at the face of the wounded
officer and at once went to meet the major.

"May the wounded men stay in our house?" she asked.

The major raised his hand to his cap with a smile.

"Which one do you want, Ma'am'selle?" said he, screwing up his
eyes and smiling.

Natasha quietly repeated her question, and her face and whole manner
were so serious, though she was still holding the ends of her
handkerchief, that the major ceased smiling and after some reflection-
as if considering in how far the thing was possible--replied in the
affirmative.

"Oh yes, why not? They may," he said.

With a slight inclination of her head, Natasha stepped back
quickly to Mavra Kuzminichna, who stood talking compassionately to the
officer.

"They may. He says they may!" whispered Natasha.

The cart in which the officer lay was turned into the Rostovs' yard,
and dozens of carts with wounded men began at the invitation of the
townsfolk to turn into the yards and to draw up at the entrances of
the houses in Povarskaya Street. Natasha was evidently pleased to be
dealing with new people outside the ordinary routine of her life.
She and Mavra Kuzminichna tried to get as many of the wounded as
possible into their yard.

"Your Papa must be told, though," said Mavra Kuzminichna.

"Never mind, never mind, what does it matter? For one day we can
move into the drawing room. They can have all our half of the house."

"There now, young lady, you do take things into your head! Even if
we put them into the wing, the men's room, or the nurse's room, we
must ask permission."

"Well, I'll ask."

Natasha ran into the house and went on tiptoe through the
half-open door into the sitting room, where there was a smell of
vinegar and Hoffman's drops.

"Are you asleep, Mamma?"

"Oh, what sleep-?" said the countess, waking up just as she was
dropping into a doze.

"Mamma darling!" said Natasha, kneeling by her mother and bringing
her face close to her mother's, "I am sorry, forgive me, I'll never do
it again; I woke you up! Mavra Kuzminichna has sent me: they have
brought some wounded here--officers. Will you let them come? They have
nowhere to go. I knew you'd let them come!" she said quickly all in
one breath.

"What officers? Whom have they brought? I don't understand
anything about it," said the countess.

Natasha laughed, and the countess too smiled slightly.

"I knew you'd give permission... so I'll tell them," and, having
kissed her mother, Natasha got up and went to the door.

In the hall she met her father, who had returned with bad news.

"We've stayed too long!" said the count with involuntary vexation.
"The Club is closed and the police are leaving."

"Papa, is it all right--I've invited some of the wounded into the
house?" said Natasha.

"Of course it is," he answered absently. "That's not the point. I
beg you not to indulge in trifles now, but to help to pack, and
tomorrow we must go, go, go!...."

And the count gave a similar order to the major-domo and the
servants.

At dinner Petya having returned home told them the news he had
heard. He said the people had been getting arms in the Kremlin, and
that though Rostopchin's broadsheet had said that he would sound a
call two or three days in advance, the order had certainly already
been given for everyone to go armed to the Three Hills tomorrow, and
that there would be a big battle there.

The countess looked with timid horror at her son's eager, excited
face as he said this. She realized that if she said a word about his
not going to the battle (she knew he enjoyed the thought of the
impending engagement) he would say something about men, honor, and the
fatherland--something senseless, masculine, and obstinate which
there would be no contradicting, and her plans would be spoiled; and
so, hoping to arrange to leave before then and take Petya with her
as their protector and defender, she did not answer him, but after
dinner called the count aside and implored him with tears to take
her away quickly, that very night if possible. With a woman's
involuntary loving cunning she, who till then had not shown any alarm,
said that she would die of fright if they did not leave that very
night. Without any pretense she was now afraid of everything.





CHAPTER XIV


Madame Schoss, who had been out to visit her daughter, increased the
countess' fears still more by telling what she had seen at a spirit
dealer's in Myasnitski Street. When returning by that street she had
been unable to pass because of a drunken crowd rioting in front of the
shop. She had taken a cab and driven home by a side street and the
cabman had told her that the people were breaking open the barrels
at the drink store, having received orders to do so.

After dinner the whole Rostov household set to work with
enthusiastic haste packing their belongings and preparing for their
departure. The old count, suddenly setting to work, kept passing
from the yard to the house and back again, shouting confused
instructions to the hurrying people, and flurrying them still more.
Petya directed things in the yard. Sonya, owing to the count's
contradictory orders, lost her head and did not know what to do. The
servants ran noisily about the house and yard, shouting and disputing.
Natasha, with the ardor characteristic of all she did suddenly set
to work too. At first her intervention in the business of packing
was received skeptically. Everybody expected some prank from her and
did not wish to obey her; but she resolutely and passionately demanded
obedience, grew angry and nearly cried because they did not heed
her, and at last succeeded in making them believe her. Her first
exploit, which cost her immense effort and established her
authority, was the packing of the carpets. The count had valuable
Gobelin tapestries and Persian carpets in the house. When Natasha
set to work two cases were standing open in the ballroom, one almost
full up with crockery, the other with carpets. There was also much
china standing on the tables, and still more was being brought in from
the storeroom. A third case was needed and servants had gone to
fetch it.

"Sonya, wait a bit--we'll pack everything into these," said Natasha.

"You can't, Miss, we have tried to," said the butler's assistant.

"No, wait a minute, please."

And Natasha began rapidly taking out of the case dishes and plates
wrapped in paper.

"The dishes must go in here among the carpets," said she.

"Why, it's a mercy if we can get the carpets alone into three
cases," said the butler's assistant.

"Oh, wait, please!" And Natasha began rapidly and deftly sorting out
the things. "These aren't needed," said she, putting aside some plates
of Kiev ware. "These--yes, these must go among the carpets," she said,
referring to the Saxony china dishes.

"Don't, Natasha! Leave it alone! We'll get it all packed," urged
Sonya reproachfully.

"What a young lady she is!" remarked the major-domo.

But Natasha would not give in. She turned everything out and began
quickly repacking, deciding that the inferior Russian carpets and
unnecessary crockery should not be taken at all. When everything had
been taken out of the cases, they recommenced packing, and it turned
out that when the cheaper things not worth taking had nearly all
been rejected, the valuable ones really did all go into the two cases.
Only the lid of the case containing the carpets would not shut down. A
few more things might have been taken out, but Natasha insisted on
having her own way. She packed, repacked, pressed, made the butler's
assistant and Petya--whom she had drawn into the business of
packing--press on the lid, and made desperate efforts herself.

"That's enough, Natasha," said Sonya. "I see you were right, but
just take out the top one."

"I won't!" cried Natasha, with one hand bolding back the hair that
hung over her perspiring face, while with the other she pressed down
the carpets. "Now press, Petya! Press, Vasilich, press hard!" she
cried.

The carpets yielded and the lid closed; Natasha, clapping her hands,
screamed with delight and tears fell from her eyes. But this only
lasted a moment. She at once set to work afresh and they now trusted
her completely. The count was not angry even when they told him that
Natasha had countermanded an order of his, and the servants now came
to her to ask whether a cart was sufficiently loaded, and whether it
might be corded up. Thanks to Natasha's directions the work now went
on expeditiously, unnecessary things were left, and the most
valuable packed as compactly as possible.

But hard as they all worked till quite late that night, they could
not get everything packed. The countess had fallen asleep and the
count, having put off their departure till next morning, went to bed.

Sonya and Natasha slept in the sitting room without undressing.

That night another wounded man was driven down the Povarskaya, and
Mavra Kuzminichna, who was standing at the gate, had him brought
into the Rostovs' yard. Mavra Kuzminichna concluded that he was a very
important man. He was being conveyed in a caleche with a raised
hood, and was quite covered by an apron. On the box beside the
driver sat a venerable old attendant. A doctor and two soldiers
followed the carriage in a cart.

"Please come in here. The masters are going away and the whole house
will be empty," said the old woman to the old attendant.

"Well, perhaps," said he with a sigh. "We don't expect to get him
home alive! We have a house of our own in Moscow, but it's a long
way from here, and there's nobody living in it."

"Do us the honor to come in, there's plenty of everything in the
master's house. Come in," said Mavra Kuzminichna. "Is he very ill?"
she asked.

The attendant made a hopeless gesture.

"We don't expect to get him home! We must ask the doctor."

And the old servant got down from the box and went up to the cart.

"All right!" said the doctor.

The old servant returned to the caleche, looked into it, shook his
head disconsolately, told the driver to turn into the yard, and
stopped beside Mavra Kuzminichna.

"O, Lord Jesus Christ!" she murmured.

She invited them to take the wounded man into the house.

"The masters won't object..." she said.

But they had to avoid carrying the man upstairs, and so they took
him into the wing and put him in the room that had been Madame
Schoss'.

This wounded man was Prince Andrew Bolkonski.





CHAPTER XV


Moscow's last day had come. It was a clear bright autumn day, a
Sunday. The church bells everywhere were ringing for service, just
as usual on Sundays. Nobody seemed yet to realize what awaited the
city.

Only two things indicated the social condition of Moscow--the
rabble, that is the poor people, and the price of commodities. An
enormous crowd of factory hands, house serfs, and peasants, with
whom some officials, seminarists, and gentry were mingled, had gone
early that morning to the Three Hills. Having waited there for
Rostopchin who did not turn up, they became convinced that Moscow
would be surrendered, and then dispersed all about the town to the
public houses and cookshops. Prices too that day indicated the state
of affairs. The price of weapons, of gold, of carts and horses, kept
rising, but the value of paper money and city articles kept falling,
so that by midday there were instances of carters removing valuable
goods, such as cloth, and receiving in payment a half of what they
carted, while peasant horses were fetching five hundred rubles each,
and furniture, mirrors, and bronzes were being given away for nothing.

In the Rostovs' staid old-fashioned house the dissolution of
former conditions of life was but little noticeable. As to the serfs
the only indication was that three out of their huge retinue
disappeared during the night, but nothing was stolen; and as to the
value of their possessions, the thirty peasant carts that had come
in from their estates and which many people envied proved to be
extremely valuable and they were offered enormous sums of money for
them. Not only were huge sums offered for the horses and carts, but on
the previous evening and early in the morning of the first of
September, orderlies and servants sent by wounded officers came to the
Rostovs' and wounded men dragged themselves there from the Rostovs'
and from neighboring houses where they were accommodated, entreating
the servants to try to get them a lift out of Moscow. The major-domo
to whom these entreaties were addressed, though he was sorry for the
wounded, resolutely refused, saying that he dare not even mention
the matter to the count. Pity these wounded men as one might, it was
evident that if they were given one cart there would be no reason to
refuse another, or all the carts and one's own carriages as well.
Thirty carts could not save all the wounded and in the general
catastrophe one could not disregard oneself and one's own family. So
thought the major-domo on his master's behalf.

On waking up that morning Count Ilya Rostov left his bedroom softly,
so as not to wake the countess who had fallen asleep only toward
morning, and came out to the porch in his lilac silk dressing gown. In
the yard stood the carts ready corded. The carriages were at the front
porch. The major-domo stood at the porch talking to an elderly orderly
and to a pale young officer with a bandaged arm. On seeing the count
the major-domo made a significant and stern gesture to them both to go
away.

"Well, Vasilich, is everything ready?" asked the count, and stroking
his bald head he looked good-naturedly at the officer and the
orderly and nodded to them. (He liked to see new faces.)

"We can harness at once, your excellency."

"Well, that's right. As soon as the countess wakes we'll be off, God
willing! What is it, gentlemen?" he added, turning to the officer.
"Are you staying in my house?"

The officer came nearer and suddenly his face flushed crimson.

"Count, be so good as to allow me... for God's sake, to get into
some corner of one of your carts! I have nothing here with me.... I
shall be all right on a loaded cart..."

Before the officer had finished speaking the orderly made the same
request on behalf of his master.

"Oh, yes, yes, yes!" said the count hastily. "I shall be very
pleased, very pleased. Vasilich, you'll see to it. Just unload one
or two carts. Well, what of it... do what's necessary..." said the
count, muttering some indefinite order.

But at the same moment an expression of warm gratitude on the
officer's face had already sealed the order. The count looked around
him. In the yard, at the gates, at the window of the wings, wounded
officers and their orderlies were to be seen. They were all looking at
the count and moving toward the porch.

"Please step into the gallery, your excellency," said the
major-domo. "What are your orders about the pictures?"

The count went into the house with him, repeating his order not to
refuse the wounded who asked for a lift.

"Well, never mind, some of the things can be unloaded," he added
in a soft, confidential voice, as though afraid of being overheard.

At nine o'clock the countess woke up, and Matrena Timofeevna, who
had been her lady's maid before her marriage and now performed a
sort of chief gendarme's duty for her, came to say that Madame
Schoss was much offended and the young ladies' summer dresses could
not be left behind. On inquiry, the countess learned that Madame
Schoss was offended because her trunk had been taken down from its
cart, and all the loads were being uncorded and the luggage taken
out of the carts to make room for wounded men whom the count in the
simplicity of his heart had ordered that they should take with them.
The countess sent for her husband.

"What is this, my dear? I hear that the luggage is being unloaded."

"You know, love, I wanted to tell you... Countess dear... an officer
came to me to ask for a few carts for the wounded. After all, ours are
things that can be bought but think what being left behind means to
them!... Really now, in our own yard--we asked them in ourselves and
there are officers among them.... You know, I think, my dear... let
them be taken... where's the hurry?"

The count spoke timidly, as he always did when talking of money
matters. The countess was accustomed to this tone as a precursor of
news of something detrimental to the children's interests, such as the
building of a new gallery or conservatory, the inauguration of a
private theater or an orchestra. She was accustomed always to oppose
anything announced in that timid tone and considered it her duty to do
so.

She assumed her dolefully submissive manner and said to her husband:
"Listen to me, Count, you have managed matters so that we are
getting nothing for the house, and now you wish to throw away all our-
all the children's property! You said yourself that we have a
hundred thousand rubles' worth of things in the house. I don't
consent, my dear, I don't! Do as you please! It's the government's
business to look after the wounded; they know that. Look at the
Lopukhins opposite, they cleared out everything two days ago. That's
what other people do. It's only we who are such fools. If you have
no pity on me, have some for the children."

Flourishing his arms in despair the count left the room without
replying.

"Papa, what are you doing that for?" asked Natasha, who had followed
him into her mother's room.

"Nothing! What business is it of yours?" muttered the count angrily.

"But I heard," said Natasha. "Why does Mamma object?"

"What business is it of yours?" cried the count.

Natasha stepped up to the window and pondered.

"Papa! Here's Berg coming to see us," said she, looking out of the
window.





CHAPTER XVI


Berg, the Rostovs' son-in-law, was already a colonel wearing the
orders of Vladimir and Anna, and he still filled the quiet and
agreeable post of assistant to the head of the staff of the
assistant commander of the first division of the Second Army.

On the first of September he had come to Moscow from the army.

He had nothing to do in Moscow, but he had noticed that everyone
in the army was asking for leave to visit Moscow and had something
to do there. So he considered it necessary to ask for leave of absence
for family and domestic reasons.

Berg drove up to his father-in-law's house in his spruce little trap
with a pair of sleek roans, exactly like those of a certain prince. He
looked attentively at the carts in the yard and while going up to
the porch took out a clean pocket handkerchief and tied a knot in it.

From the anteroom Berg ran with smooth though impatient steps into
the drawing room, where he embraced the count, kissed the hands of
Natasha and Sonya, and hastened to inquire after "Mamma's" health.

"Health, at a time like this?" said the count. "Come, tell us the
news! Is the army retreating or will there be another battle?"

"God Almighty alone can decide the fate of our fatherland, Papa,"
said Berg. "The army is burning with a spirit of heroism and the
leaders, so to say, have now assembled in council. No one knows what
is coming. But in general I can tell you, Papa, that such a heroic
spirit, the truly antique valor of the Russian army, which they--which
it" (he corrected himself) "has shown or displayed in the battle of
the twenty-sixth--there are no words worthy to do it justice! I tell
you, Papa" (he smote himself on the breast as a general he had heard
speaking had done, but Berg did it a trifle late for he should have
struck his breast at the words "Russian army"), "I tell you frankly
that we, the commanders, far from having to urge the men on or
anything of that kind, could hardly restrain those... those... yes,
those exploits of antique valor," he went on rapidly. "General Barclay
de Tolly risked his life everywhere at the head of the troops, I can
assure you. Our corps was stationed on a hillside. You can imagine!"

And Berg related all that he remembered of the various tales he
had heard those days. Natasha watched him with an intent gaze that
confused him, as if she were trying to find in his face the answer
to some question.

"Altogether such heroism as was displayed by the Russian warriors
cannot be imagined or adequately praised!" said Berg, glancing round
at Natasha, and as if anxious to conciliate her, replying to her
intent look with a smile. "'Russia is not in Moscow, she lives in
the hearts of her sons!' Isn't it so, Papa?" said he.

Just then the countess came in from the sitting room with a weary
and dissatisfied expression. Berg hurriedly jumped up, kissed her
hand, asked about her health, and, swaying his head from side to
side to express sympathy, remained standing beside her.

"Yes, Mamma, I tell you sincerely that these are hard and sad
times for every Russian. But why are you so anxious? You have still
time to get away...."

"I can't think what the servants are about," said the countess,
turning to her husband. "I have just been told that nothing is ready
yet. Somebody after all must see to things. One misses Mitenka at such
times. There won't be any end to it."

The count was about to say something, but evidently restrained
himself. He got up from his chair and went to the door.

At that moment Berg drew out his handkerchief as if to blow his nose
and, seeing the knot in it, pondered, shaking his head sadly and
significantly.

"And I have a great favor to ask of you, Papa," said he.

"Hm..." said the count, and stopped.

"I was driving past Yusupov's house just now," said Berg with a
laugh, "when the steward, a man I know, ran out and asked me whether I
wouldn't buy something. I went in out of curiosity, you know, and
there is a small chiffonier and a dressing table. You know how dear
Vera wanted a chiffonier like that and how we had a dispute about it."
(At the mention of the chiffonier and dressing table Berg
involuntarily changed his tone to one of pleasure at his admirable
domestic arrangements.) "And it's such a beauty! It pulls out and
has a secret English drawer, you know! And dear Vera has long wanted
one. I wish to give her a surprise, you see. I saw so many of those
peasant carts in your yard. Please let me have one, I will pay the man
well, and..."

The count frowned and coughed.

"Ask the countess, I don't give orders."

"If it's inconvenient, please don't," said Berg. "Only I so wanted
it, for dear Vera's sake."

"Oh, go to the devil, all of you! To the devil, the devil, the
devil..." cried the old count. "My head's in a whirl!"

And he left the room. The countess began to cry.

"Yes, Mamma! Yes, these are very hard times!" said Berg.

Natasha left the room with her father and, as if finding it
difficult to reach some decision, first followed him and then ran
downstairs.

Petya was in the porch, engaged in giving out weapons to the
servants who were to leave Moscow. The loaded carts were still
standing in the yard. Two of them had been uncorded and a wounded
officer was climbing into one of them helped by an orderly.

"Do you know what it's about?" Petya asked Natasha.

She understood that he meant what were their parents quarreling
about. She did not answer.

"It's because Papa wanted to give up all the carts to the
wounded," said Petya. "Vasilich told me. I consider..."

"I consider," Natasha suddenly almost shouted, turning her angry
face to Petya, "I consider it so horrid, so abominable, so... I
don't know what. Are we despicable Germans?"

Her throat quivered with convulsive sobs and, afraid of weakening
and letting the force of her anger run to waste, she turned and rushed
headlong up the stairs.

Berg was sitting beside the countess consoling her with the
respectful attention of a relative. The count, pipe in hand, was
pacing up and down the room, when Natasha, her face distorted by
anger, burst in like a tempest and approached her mother with rapid
steps.

"It's horrid! It's abominable!" she screamed. "You can't possibly
have ordered it!"

Berg and the countess looked at her, perplexed and frightened. The
count stood still at the window and listened.

"Mamma, it's impossible: see what is going on in the yard!" she
cried. "They will be left!..."

"What's the matter with you? Who are 'they'? What do you want?"

"Why, the wounded! It's impossible, Mamma. It's monstrous!... No,
Mamma darling, it's not the thing. Please forgive me, darling....
Mamma, what does it matter what we take away? Only look what is
going on in the yard... Mamma!... It's impossible!"

The count stood by the window and listened without turning round.
Suddenly he sniffed and put his face closer to the window.

The countess glanced at her daughter, saw her face full of shame for
her mother, saw her agitation, and understood why her husband did
not turn to look at her now, and she glanced round quite disconcerted.

"Oh, do as you like! Am I hindering anyone?" she said, not
surrendering at once.

"Mamma, darling, forgive me!"

But the countess pushed her daughter away and went up to her
husband.

"My dear, you order what is right.... You know I don't understand
about it," said she, dropping her eyes shamefacedly.

"The eggs... the eggs are teaching the hen," muttered the count
through tears of joy, and he embraced his wife who was glad to hide
her look of shame on his breast.

"Papa! Mamma! May I see to it? May I?..." asked Natasha. "We will
still take all the most necessary things."

The count nodded affirmatively, and Natasha, at the rapid pace at
which she used to run when playing at tag, ran through the ballroom to
the anteroom and downstairs into the yard.

The servants gathered round Natasha, but could not believe the
strange order she brought them until the count himself, in his
wife's name, confirmed the order to give up all the carts to the
wounded and take the trunks to the storerooms. When they understood
that order the servants set to work at this new task with pleasure and
zeal. It no longer seemed strange to them but on the contrary it
seemed the only thing that could be done, just as a quarter of an hour
before it had not seemed strange to anyone that the wounded should
be left behind and the goods carted away but that had seemed the
only thing to do.

The whole household, as if to atone for not having done it sooner,
set eagerly to work at the new task of placing the wounded in the
carts. The wounded dragged themselves out of their rooms and stood
with pale but happy faces round the carts. The news that carts were to
be had spread to the neighboring houses, from which wounded men
began to come into the Rostovs' yard. Many of the wounded asked them
not to unload the carts but only to let them sit on the top of the
things. But the work of unloading, once started, could not be
arrested. It seemed not to matter whether all or only half the
things were left behind. Cases full of china, bronzes, pictures, and
mirrors that had been so carefully packed the night before now lay
about the yard, and still they went on searching for and finding
possibilities of unloading this or that and letting the wounded have
another and yet another cart.

"We can take four more men," said the steward. "They can have my
trap, or else what is to become of them?"

"Let them have my wardrobe cart," said the countess. "Dunyasha can
go with me in the carriage."

They unloaded the wardrobe cart and sent it to take wounded men from
a house two doors off. The whole household, servants included, was
bright and animated. Natasha was in a state of rapturous excitement
such as she had not known for a long time.

"What could we fasten this onto?" asked the servants, trying to
fix a trunk on the narrow footboard behind a carriage. "We must keep
at least one cart."

"What's in it?" asked Natasha.

"The count's books."

"Leave it, Vasilich will put it away. It's not wanted."

The phaeton was full of people and there was a doubt as to where
Count Peter could sit.

"On the box. You'll sit on the box, won't you, Petya?" cried
Natasha.

Sonya too was busy all this time, but the aim of her efforts was
quite different from Natasha's. She was putting away the things that
had to be left behind and making a list of them as the countess
wished, and she tried to get as much taken away with them as possible.





CHAPTER XVII


Before two o'clock in the afternoon the Rostovs' four carriages,
packed full and with the horses harnessed, stood at the front door.
One by one the carts with the wounded had moved out of the yard.

The caleche in which Prince Andrew was being taken attracted Sonya's
attention as it passed the front porch. With the help of a maid she
was arranging a seat for the countess in the huge high coach that
stood at the entrance.

"Whose caleche is that?" she inquired, leaning out of the carriage
window.

"Why, didn't you know, Miss?" replied the maid. "The wounded prince:
he spent the night in our house and is going with us."

"But who is it? What's his name?"

"It's our intended that was--Prince Bolkonski himself! They say he
is dying," replied the maid with a sigh.

Sonya jumped out of the coach and ran to the countess. The countess,
tired out and already dressed in shawl and bonnet for her journey, was
pacing up and down the drawing room, waiting for the household to
assemble for the usual silent prayer with closed doors before
starting. Natasha was not in the room.

"Mamma," said Sonya, "Prince Andrew is here, mortally wounded. He is
going with us."

The countess opened her eyes in dismay and, seizing Sonya's arm,
glanced around.

"Natasha?" she murmured.

At that moment this news had only one significance for both of them.
They knew their Natasha, and alarm as to what would happen if she
heard this news stifled all sympathy for the man they both liked.

"Natasha does not know yet, but he is going with us," said Sonya.

"You say he is dying?"

Sonya nodded.

The countess put her arms around Sonya and began to cry.

"The ways of God are past finding out!" she thought, feeling that
the Almighty Hand, hitherto unseen, was becoming manifest in all
that was now taking place.

"Well, Mamma? Everything is ready. What's the matter?" asked
Natasha, as with animated face she ran into the room.

"Nothing," answered the countess. "If everything is ready let us
start."

And the countess bent over her reticule to hide her agitated face.
Sonya embraced Natasha and kissed her.

Natasha looked at her inquiringly.

"What is it? What has happened?"

"Nothing... No..."

"Is it something very bad for me? What is it?" persisted Natasha
with her quick intuition.

Sonya sighed and made no reply. The count, Petya, Madame Schoss,
Mavra Kuzminichna, and Vasilich came into the drawing room and, having
closed the doors, they all sat down and remained for some moments
silently seated without looking at one another.

The count was the first to rise, and with a loud sigh crossed
himself before the icon. All the others did the same. Then the count
embraced Mavra Kuzminichna and Vasilich, who were to remain in Moscow,
and while they caught at his hand and kissed his shoulder he patted
their backs lightly with some vaguely affectionate and comforting
words. The countess went into the oratory and there Sonya found her on
her knees before the icons that had been left here and there hanging
on the wall. (The most precious ones, with which some family tradition
was connected, were being taken with them.)

In the porch and in the yard the men whom Petya had armed with
swords and daggers, with trousers tucked inside their high boots and
with belts and girdles tightened, were taking leave of those remaining
behind.

As is always the case at a departure, much had been forgotten or put
in the wrong place, and for a long time two menservants stood one on
each side of the open door and the carriage steps waiting to help
the countess in, while maids rushed with cushions and bundles from the
house to the carriages, the caleche, the phaeton, and back again.

"They always will forget everything!" said the countess. "Don't
you know I can't sit like that?"

And Dunyasha, with clenched teeth, without replying but with an
aggrieved look on her face, hastily got into the coach to rearrange
the seat.

"Oh, those servants!" said the count, swaying his head.

Efim, the old coachman, who was the only one the countess trusted to
drive her, sat perched up high on the box and did not so much as
glance round at what was going on behind him. From thirty years'
experience he knew it would be some time yet before the order, "Be
off, in God's name!" would be given him: and he knew that even when it
was said he would be stopped once or twice more while they sent back
to fetch something that had been forgotten, and even after that he
would again be stopped and the countess herself would lean out of
the window and beg him for the love of heaven to drive carefully
down the hill. He knew all this and therefore waited calmly for what
would happen, with more patience than the horses, especially the
near one, the chestnut Falcon, who was pawing the ground and
champing his bit. At last all were seated, the carriage steps were
folded and pulled up, the door was shut, somebody was sent for a
traveling case, and the countess leaned out and said what she had to
say. Then Efim deliberately doffed his hat and began crossing himself.
The postilion and all the other servants did the same. "Off, in
God's name!" said Efim, putting on his hat. "Start!" The postilion
started the horses, the off pole horse tugged at his collar, the
high springs creaked, and the body of the coach swayed. The footman
sprang onto the box of the moving coach which jolted as it passed
out of the yard onto the uneven roadway; the other vehicles jolted
in their turn, and the procession of carriages moved up the street. In
the carriages, the caleche, and the phaeton, all crossed themselves as
they passed the church opposite the house. Those who were to remain in
Moscow walked on either side of the vehicles seeing the travelers off.

Rarely had Natasha experienced so joyful a feeling as now, sitting
in the carriage beside the countess and gazing at the slowly
receding walls of forsaken, agitated Moscow. Occasionally she leaned
out of the carriage window and looked back and then forward at the
long train of wounded in front of them. Almost at the head of the line
she could see the raised hood of Prince Andrew's caleche. She did
not know who was in it, but each time she looked at the procession her
eyes sought that caleche. She knew it was right in front.

In Kudrino, from the Nikitski, Presnya, and Podnovinsk Streets
came several other trains of vehicles similar to the Rostovs', and
as they passed along the Sadovaya Street the carriages and carts
formed two rows abreast.

As they were going round the Sukharev water tower Natasha, who was
inquisitively and alertly scrutinizing the people driving or walking
past, suddenly cried out in joyful surprise:

"Dear me! Mamma, Sonya, look, it's he!"

"Who? Who?"

"Look! Yes, on my word, it's Bezukhov!" said Natasha, putting her
head out of the carriage and staring at a tall, stout man in a
coachman's long coat, who from his manner of walking and moving was
evidently a gentleman in disguise, and who was passing under the
arch of the Sukharev tower accompanied by a small, sallow-faced,
beardless old man in a frieze coat.

"Yes, it really is Bezukhov in a coachman's coat, with a
queer-looking old boy. Really," said Natasha, "look, look!"

"No, it's not he. How can you talk such nonsense?"

"Mamma," screamed Natasha, "I'll stake my head it's he! I assure
you! Stop, stop!" she cried to the coachman.

But the coachman could not stop, for from the Meshchanski Street
came more carts and carriages, and the Rostovs were being shouted at
to move on and not block the way.

In fact, however, though now much farther off than before, the
Rostovs all saw Pierre--or someone extraordinarily like him--in a
coachman's coat, going down the street with head bent and a serious
face beside a small, beardless old man who looked like a footman. That
old man noticed a face thrust out of the carriage window gazing at
them, and respectfully touching Pierre's elbow said something to him
and pointed to the carriage. Pierre, evidently engrossed in thought,
could not at first understand him. At length when he had understood
and looked in the direction the old man indicated, he recognized
Natasha, and following his first impulse stepped instantly and rapidly
toward the coach. But having taken a dozen steps he seemed to remember
something and stopped.

Natasha's face, leaning out of the window, beamed with quizzical
kindliness.

"Peter Kirilovich, come here! We have recognized you! This is
wonderful!" she cried, holding out her hand to him. "What are you
doing? Why are you like this?"

Pierre took her outstretched hand and kissed it awkwardly as he
walked along beside her while the coach still moved on.

"What is the matter, Count?" asked the countess in a surprised and
commiserating tone.

"What? What? Why? Don't ask me," said Pierre, and looked round at
Natasha whose radiant, happy expression--of which he was conscious
without looking at her--filled him with enchantment.

"Are you remaining in Moscow, then?"

Pierre hesitated.

"In Moscow?" he said in a questioning tone. "Yes, in Moscow.
Goodby!"

"Ah, if only I were a man? I'd certainly stay with you. How
splendid!" said Natasha. "Mamma, if you'll let me, I'll stay!"

Pierre glanced absently at Natasha and was about to say something,
but the countess interrupted him.

"You were at the battle, we heard."

"Yes, I was," Pierre answered. "There will be another battle
tomorrow..." he began, but Natasha interrupted him.

"But what is the matter with you, Count? You are not like
yourself...."

"Oh, don't ask me, don't ask me! I don't know myself. Tomorrow...
But no! Good-by, good-by!" he muttered. "It's an awful time!" and
dropping behind the carriage he stepped onto the pavement.

Natasha continued to lean out of the window for a long time, beaming
at him with her kindly, slightly quizzical, happy smile.





CHAPTER XVIII


For the last two days, ever since leaving home, Pierre had been
living in the empty house of his deceased benefactor, Bazdeev. This is
how it happened.

When he woke up on the morning after his return to Moscow and his
interview with Count Rostopchin, he could not for some time make out
where he was and what was expected of him. When he was informed that
among others awaiting him in his reception room there was a
Frenchman who had brought a letter from his wife, the Countess Helene,
he felt suddenly overcome by that sense of confusion and
hopelessness to which he was apt to succumb. He felt that everything
was now at an end, all was in confusion and crumbling to pieces,
that nobody was right or wrong, the future held nothing, and there was
no escape from this position. Smiling unnaturally and muttering to
himself, he first sat down on the sofa in an attitude of despair, then
rose, went to the door of the reception room and peeped through the
crack, returned flourishing his arms, and took up a book. His
major-domo came in a second time to say that the Frenchman who had
brought the letter from the countess was very anxious to see him if
only for a minute, and that someone from Bazdeev's widow had called to
ask Pierre to take charge of her husband's books, as she herself was
leaving for the country.

"Oh, yes, in a minute; wait... or no! No, of course... go and say
I will come directly," Pierre replied to the major-domo.

But as soon as the man had left the room Pierre took up his hat
which was lying on the table and went out of his study by the other
door. There was no one in the passage. He went along the whole
length of this passage to the stairs and, frowning and rubbing his
forehead with both hands, went down as far as the first landing. The
hall porter was standing at the front door. From the landing where
Pierre stood there was a second staircase leading to the back
entrance. He went down that staircase and out into the yard. No one
had seen him. But there were some carriages waiting, and as soon as
Pierre stepped out of the gate the coachmen and the yard porter
noticed him and raised their caps to him. When he felt he was being
looked at he behaved like an ostrich which hides its head in a bush in
order not to be seen: he hung his head and quickening his pace went
down the street.

Of all the affairs awaiting Pierre that day the sorting of Joseph
Bazdeev's books and papers appeared to him the most necessary.


He hired the first cab he met and told the driver to go to the
Patriarch's Ponds, where the widow Bazdeev's house was.

Continually turning round to look at the rows of loaded carts that
were making their way from all sides out of Moscow, and balancing
his bulky body so as not to slip out of the ramshackle old vehicle,
Pierre, experiencing the joyful feeling of a boy escaping from school,
began to talk to his driver.

The man told him that arms were being distributed today at the
Kremlin and that tomorrow everyone would be sent out beyond the
Three Hills gates and a great battle would be fought there.

Having reached the Patriarch's Ponds Pierre found the Bazdeevs'
house, where he had not been for a long time past. He went up to the
gate. Gerasim, that sallow beardless old man Pierre had seen at
Torzhok five years before with Joseph Bazdeev, came out in answer to
his knock.

"At home?" asked Pierre.

"Owing to the present state of things Sophia Danilovna has gone to
the Torzhok estate with the children, your excellency."

"I will come in all the same, I have to look through the books,"
said Pierre.

"Be so good as to step in. Makar Alexeevich, the brother of my
late master--may the kingdom of heaven be his--has remained here,
but he is in a weak state as you know," said the old servant.

Pierre knew that Makar Alexeevich was Joseph Bazdeev's half-insane
brother and a hard drinker.

"Yes, yes, I know. Let us go in..." said Pierre and entered the
house.

A tall, bald-headed old man with a red nose, wearing a dressing gown
and with galoshes on his bare feet, stood in the anteroom. On seeing
Pierre he muttered something angrily and went away along the passage.

"He was a very clever man but has now grown quite feeble, as your
honor sees," said Gerasim. "Will you step into the study?" Pierre
nodded. "As it was sealed up so it has remained, but Sophia
Danilovna gave orders that if anyone should come from you they were to
have the books."

Pierre went into that gloomy study which he had entered with such
trepidation in his benefactor's lifetime. The room, dusty and
untouched since the death of Joseph Bazdeev was now even gloomier.

Gerasim opened one of the shutters and left the room on tiptoe.
Pierre went round the study, approached the cupboard in which the
manuscripts were kept, and took out what had once been one of the most
important, the holy of holies of the order. This was the authentic
Scotch Acts with Bazdeev's notes and explanations. He sat down at
the dusty writing table, and, having laid the manuscripts before
him, opened them out, closed them, finally pushed them away, and
resting his head on his hand sank into meditation.

Gerasim looked cautiously into the study several times and saw
Pierre always sitting in the same attitude.

More than two hours passed and Gerasim took the liberty of making
a slight noise at the door to attract his attention, but Pierre did
not hear him.

"Is the cabman to be discharged, your honor?"

"Oh yes!" said Pierre, rousing himself and rising hurriedly. "Look
here," he added, taking Gerasim by a button of his coat and looking
down at the old man with moist, shining, and ecstatic eyes, "I say, do
you know that there is going to be a battle tomorrow?"

"We heard so," replied the man.

"I beg you not to tell anyone who I am, and to do what I ask you."

"Yes, your excellency," replied Gerasim. "Will you have something to
eat?"

"No, but I want something else. I want peasant clothes and a
pistol," said Pierre, unexpectedly blushing.

"Yes, your excellency," said Gerasim after thinking for a moment.

All the rest of that day Pierre spent alone in his benefactor's
study, and Gerasim heard him pacing restlessly from one corner to
another and talking to himself. And he spent the night on a bed made
up for him there.

Gerasim, being a servant who in his time had seen many strange
things, accepted Pierre's taking up his residence in the house without
surprise, and seemed pleased to have someone to wait on. That same
evening--without even asking himself what they were wanted for--he
procured a coachman's coat and cap for Pierre, and promised to get him
the pistol next day. Makar Alexeevich came twice that evening
shuffling along in his galoshes as far as the door and stopped and
looked ingratiatingly at Pierre. But as soon as Pierre turned toward
him he wrapped his dressing gown around him with a shamefaced and
angry look and hurried away. It was when Pierre (wearing the
coachman's coat which Gerasim had procured for him and had disinfected
by steam) was on his way with the old man to buy the pistol at the
Sukharev market that he met the Rostovs.





CHAPTER XIX


Kutuzov's order to retreat through Moscow to the Ryazan road was
issued at night on the first of September.

The first troops started at once, and during the night they
marched slowly and steadily without hurry. At daybreak, however, those
nearing the town at the Dorogomilov bridge saw ahead of them masses of
soldiers crowding and hurrying across the bridge, ascending on the
opposite side and blocking the streets and alleys, while endless
masses of troops were bearing down on them from behind, and an
unreasoning hurry and alarm overcame them. They all rushed forward
to the bridge, onto it, and to the fords and the boats. Kutuzov
himself had driven round by side streets to the other side of Moscow.

By ten o'clock in the morning of the second of September, only the
rear guard remained in the Dorogomilov suburb, where they had ample
room. The main army was on the other side of Moscow or beyond it.

At that very time, at ten in the morning of the second of September,
Napoleon was standing among his troops on the Poklonny Hill looking at
the panorama spread out before him. From the twenty-sixth of August to
the second of September, that is from the battle of Borodino to the
entry of the French into Moscow, during the whole of that agitating,
memorable week, there had been the extraordinary autumn weather that
always comes as a surprise, when the sun hangs low and gives more heat
than in spring, when everything shines so brightly in the rare clear
atmosphere that the eyes smart, when the lungs are strengthened and
refreshed by inhaling the aromatic autumn air, when even the nights
are warm, and when in those dark warm nights, golden stars startle and
delight us continually by falling from the sky.

At ten in the morning of the second of September this weather
still held.

The brightness of the morning was magical. Moscow seen from the
Poklonny Hill lay spaciously spread out with her river, her gardens,
and her churches, and she seemed to be living her usual life, her
cupolas glittering like stars in the sunlight.

The view of the strange city with its peculiar architecture, such as
he had never seen before, filled Napoleon with the rather envious
and uneasy curiosity men feel when they see an alien form of life that
has no knowledge of them. This city was evidently living with the full
force of its own life. By the indefinite signs which, even at a
distance, distinguish a living body from a dead one, Napoleon from the
Poklonny Hill perceived the throb of life in the town and felt, as
it were, the breathing of that great and beautiful body.

Every Russian looking at Moscow feels her to be a mother; every
foreigner who sees her, even if ignorant of her significance as the
mother city, must feel her feminine character, and Napoleon felt it.

"Cette ville asiatique aux innombrables eglises, Moscou la sainte.
La voila done enfin, cette fameuse ville! Il etait temps,"* said he,
and dismounting he ordered a plan of Moscow to be spread out before
him, and summoned Lelorgne d'Ideville, the interpreter.


*"That Asiatic city of the innumerable churches, holy Moscow! Here
it is then at last, that famous city. It was high time."


"A town captured by the enemy is like a maid who has lost her
honor," thought he (he had said so to Tuchkov at Smolensk). From
that point of view he gazed at the Oriental beauty he had not seen
before. It seemed strange to him that his long-felt wish, which had
seemed unattainable, had at last been realized. In the clear morning
light he gazed now at the city and now at the plan, considering its
details, and the assurance of possessing it agitated and awed him.

"But could it be otherwise?" he thought. "Here is this capital at my
feet. Where is Alexander now, and of what is he thinking? A strange,
beautiful, and majestic city; and a strange and majestic moment! In
what light must I appear to them!" thought he, thinking of his troops.
"Here she is, the reward for all those fainthearted men," he
reflected, glancing at those near him and at the troops who were
approaching and forming up. "One word from me, one movement of my
hand, and that ancient capital of the Tsars would perish. But my
clemency is always ready to descend upon the vanquished. I must be
magnanimous and truly great. But no, it can't be true that I am in
Moscow," he suddenly thought. "Yet here she is lying at my feet,
with her golden domes and crosses scintillating and twinkling in the
sunshine. But I shall spare her. On the ancient monuments of barbarism
and despotism I will inscribe great words of justice and mercy....
It is just this which Alexander will feel most painfully, I know him."
(It seemed to Napoleon that the chief import of what was taking
place lay in the personal struggle between himself and Alexander.)
"From the height of the Kremlin--yes, there is the Kremlin, yes--I
will give them just laws; I will teach them the meaning of true
civilization, I will make generations of boyars remember their
conqueror with love. I will tell the deputation that I did not, and do
not, desire war, that I have waged war only against the false policy
of their court; that I love and respect Alexander and that in Moscow I
will accept terms of peace worthy of myself and of my people. I do not
wish to utilize the fortunes of war to humiliate an honored monarch.
'Boyars,' I will say to them, 'I do not desire war, I desire the peace
and welfare of all my subjects.' However, I know their presence will
inspire me, and I shall speak to them as I always do: clearly,
impressively, and majestically. But can it be true that I am in
Moscow? Yes, there she lies."

"Qu'on m'amene les boyars,"* said he to his suite.


*"Bring the boyars to me."


A general with a brilliant suite galloped off at once to fetch the
boyars.

Two hours passed. Napoleon had lunched and was again standing in the
same place on the Poklonny Hill awaiting the deputation. His speech to
the boyars had already taken definite shape in his imagination. That
speech was full of dignity and greatness as Napoleon understood it.

He was himself carried away by the tone of magnanimity he intended
to adopt toward Moscow. In his imagination he appointed days for
assemblies at the palace of the Tsars, at which Russian notables and
his own would mingle. He mentally appointed a governor, one who
would win the hearts of the people. Having learned that there were
many charitable institutions in Moscow he mentally decided that he
would shower favors on them all. He thought that, as in Africa he
had to put on a burnoose and sit in a mosque, so in Moscow he must
be beneficent like the Tsars. And in order finally to touch the hearts
of the Russians--and being like all Frenchmen unable to imagine
anything sentimental without a reference to ma chere, ma tendre, ma
pauvre mere* --he decided that he would place an inscription on all
these establishments in large letters: "This establishment is
dedicated to my dear mother." Or no, it should be simply: Maison de ma
Mere,*[2] he concluded. "But am I really in Moscow? Yes, here it
lies before me, but why is the deputation from the city so long in
appearing?" he wondered.


*"My dear, my tender, my poor mother."

*[2] "House of my Mother."


Meanwhile an agitated consultation was being carried on in
whispers among his generals and marshals at the rear of his suite.
Those sent to fetch the deputation had returned with the news that
Moscow was empty, that everyone had left it. The faces of those who
were not conferring together were pale and perturbed. They were not
alarmed by the fact that Moscow had been abandoned by its
inhabitants (grave as that fact seemed), but by the question how to
tell the Emperor--without putting him in the terrible position of
appearing ridiculous--that he had been awaiting the boyars so long
in vain: that there were drunken mobs left in Moscow but no one
else. Some said that a deputation of some sort must be scraped
together, others disputed that opinion and maintained that the Emperor
should first be carefully and skillfully prepared, and then told the
truth.

"He will have to be told, all the same," said some gentlemen of
the suite. "But, gentlemen..."

The position was the more awkward because the Emperor, meditating
upon his magnanimous plans, was pacing patiently up and down before
the outspread map, occasionally glancing along the road to Moscow from
under his lifted hand with a bright and proud smile.

"But it's impossible..." declared the gentlemen of the suite,
shrugging their shoulders but not venturing to utter the implied word-
le ridicule...

At last the Emperor, tired of futile expectation, his actor's
instinct suggesting to him that the sublime moment having been too
long drawn out was beginning to lose its sublimity, gave a sign with
his hand. A single report of a signaling gun followed, and the troops,
who were already spread out on different sides of Moscow, moved into
the city through Tver, Kaluga, and Dorogomilov gates. Faster and
faster, vying with one another, they moved at the double or at a trot,
vanishing amid the clouds of dust they raised and making the air
ring with a deafening roar of mingling shouts.

Drawn on by the movement of his troops Napoleon rode with them as
far as the Dorogomilov gate, but there again stopped and,
dismounting from his horse, paced for a long time by the
Kammer-Kollezski rampart, awaiting the deputation.





CHAPTER XX

Meanwhile Moscow was empty. There were still people in it, perhaps a
fiftieth part of its former inhabitants had remained, but it was
empty. It was empty in the sense that a dying queenless hive is empty.

In a queenless hive no life is left though to a superficial glance
it seems as much alive as other hives.

The bees circle round a queenless hive in the hot beams of the
midday sun as gaily as around the living hives; from a distance it
smells of honey like the others, and bees fly in and out in the same
way. But one has only to observe that hive to realize that there is no
longer any life in it. The bees do not fly in the same way, the
smell and the sound that meet the beekeeper are not the same. To the
beekeeper's tap on the wall of the sick hive, instead of the former
instant unanimous humming of tens of thousands of bees with their
abdomens threateningly compressed, and producing by the rapid
vibration of their wings an aerial living sound, the only reply is a
disconnected buzzing from different parts of the deserted hive. From
the alighting board, instead of the former spirituous fragrant smell
of honey and venom, and the warm whiffs of crowded life, comes an odor
of emptiness and decay mingling with the smell of honey. There are
no longer sentinels sounding the alarm with their abdomens raised, and
ready to die in defense of the hive. There is no longer the measured
quiet sound of throbbing activity, like the sound of boiling water,
but diverse discordant sounds of disorder. In and out of the hive long
black robber bees smeared with honey fly timidly and shiftily. They do
not sting, but crawl away from danger. Formerly only bees laden with
honey flew into the hive, and they flew out empty; now they fly out
laden. The beekeeper opens the lower part of the hive and peers in.
Instead of black, glossy bees--tamed by toil, clinging to one
another's legs and drawing out the wax, with a ceaseless hum of labor-
that used to hang in long clusters down to the floor of the hive,
drowsy shriveled bees crawl about separately in various directions
on the floor and walls of the hive. Instead of a neatly glued floor,
swept by the bees with the fanning of their wings, there is a floor
littered with bits of wax, excrement, dying bees scarcely moving their
legs, and dead ones that have not been cleared away.

The beekeeper opens the upper part of the hive and examines the
super. Instead of serried rows of bees sealing up every gap in the
combs and keeping the brood warm, he sees the skillful complex
structures of the combs, but no longer in their former state of
purity. All is neglected and foul. Black robber bees are swiftly and
stealthily prowling about the combs, and the short home bees,
shriveled and listless as if they were old, creep slowly about without
trying to hinder the robbers, having lost all motive and all sense
of life. Drones, bumblebees, wasps, and butterflies knock awkwardly
against the walls of the hive in their flight. Here and there among
the cells containing dead brood and honey an angry buzzing can
sometimes be heard. Here and there a couple of bees, by force of habit
and custom cleaning out the brood cells, with efforts beyond their
strength laboriously drag away a dead bee or bumblebee without knowing
why they do it. In another corner two old bees are languidly fighting,
or cleaning themselves, or feeding one another, without themselves
knowing whether they do it with friendly or hostile intent. In a third
place a crowd of bees, crushing one another, attack some victim and
fight and smother it, and the victim, enfeebled or killed, drops
from above slowly and lightly as a feather, among the heap of corpses.
The keeper opens the two center partitions to examine the brood cells.
In place of the former close dark circles formed by thousands of
bees sitting back to back and guarding the high mystery of generation,
he sees hundreds of dull, listless, and sleepy shells of bees. They
have almost all died unawares, sitting in the sanctuary they had
guarded and which is now no more. They reek of decay and death. Only a
few of them still move, rise, and feebly fly to settle on the
enemy's hand, lacking the spirit to die stinging him; the rest are
dead and fall as lightly as fish scales. The beekeeper closes the
hive, chalks a mark on it, and when he has time tears out its contents
and burns it clean.

So in the same way Moscow was empty when Napoleon, weary, uneasy,
and morose, paced up and down in front of the Kammer-Kollezski
rampart, awaiting what to his mind was a necessary, if but formal,
observance of the proprieties--a deputation.

In various corners of Moscow there still remained a few people
aimlessly moving about, following their old habits and hardly aware of
what they were doing.

When with due circumspection Napoleon was informed that Moscow was
empty, he looked angrily at his informant, turned away, and silently
continued to walk to and fro.

"My carriage!" he said.

He took his seat beside the aide-de-camp on duty and drove into
the suburb. "Moscow deserted!" he said to himself. "What an incredible
event!"

He did not drive into the town, but put up at an inn in the
Dorogomilov suburb.

The coup de theatre had not come off.





CHAPTER XXI


The Russian troops were passing through Moscow from two o'clock at
night till two in the afternoon and bore away with them the wounded
and the last of the inhabitants who were leaving.

The greatest crush during the movement of the troops took place at
the Stone, Moskva, and Yauza bridges.

While the troops, dividing into two parts when passing around the
Kremlin, were thronging the Moskva and the Stone bridges, a great many
soldiers, taking advantage of the stoppage and congestion, turned back
from the bridges and slipped stealthily and silently past the church
of Vasili the Beatified and under the Borovitski gate, back up the
hill to the Red Square where some instinct told them they could easily
take things not belonging to them. Crowds of the kind seen at cheap
sales filled all the passages and alleys of the Bazaar. But there were
no dealers with voices of ingratiating affability inviting customers
to enter; there were no hawkers, nor the usual motley crowd of
female purchasers--but only soldiers, in uniforms and overcoats though
without muskets, entering the Bazaar empty-handed and silently
making their way out through its passages with bundles. Tradesmen
and their assistants (of whom there were but few) moved about among
the soldiers quite bewildered. They unlocked their shops and locked
them up again, and themselves carried goods away with the help their
assistants. On the square in front of the Bazaar were drummers beating
the muster call. But the roll of the drums did not make the looting
soldiers run in the direction of the drum as formerly, but made
them, on the contrary, run farther away. Among the soldiers in the
shops and passages some men were to be seen in gray coats, with
closely shaven heads. Two officers, one with a scarf over his
uniform and mounted on a lean, dark-gray horse, the other in an
overcoat and on foot, stood at the corner of Ilyinka Street,
talking. A third officer galloped up to them.

"The general orders them all to be driven out at once, without fail.
This is outrageous! Half the men have dispersed."

"Where are you off to?... Where?..." he shouted to three infantrymen
without muskets who, holding up the skirts of their overcoats, were
slipping past him into the Bazaar passage. "Stop, you rascals!"

"But how are you going to stop them?" replied another officer.
"There is no getting them together. The army should push on before the
rest bolt, that's all!"

"How can one push on? They are stuck there, wedged on the bridge,
and don't move. Shouldn't we put a cordon round to prevent the rest
from running away?"

"Come, go in there and drive them out!" shouted the senior officer.

The officer in the scarf dismounted, called up a drummer, and went
with him into the arcade. Some soldiers started running away in a
group. A shopkeeper with red pimples on his cheeks near the nose,
and a calm, persistent, calculating expression on his plump face,
hurriedly and ostentatiously approached the officer, swinging his
arms.

"Your honor!" said he. "Be so good as to protect us! We won't grudge
trifles, you are welcome to anything--we shall be delighted!
Pray!... I'll fetch a piece of cloth at once for such an honorable
gentleman, or even two pieces with pleasure. For we feel how it is;
but what's all this--sheer robbery! If you please, could not guards be
placed if only to let us close the shop...."

Several shopkeepers crowded round the officer.

"Eh, what twaddle!" said one of them, a thin, stern-looking man.
"When one's head is gone one doesn't weep for one's hair! Take what
any of you like!" And flourishing his arm energetically he turned
sideways to the officer.

"It's all very well for you, Ivan Sidorych, to talk," said the first
tradesman angrily. "Please step inside, your honor!"

"Talk indeed!" cried the thin one. "In my three shops here I have
a hundred thousand rubles' worth of goods. Can they be saved when
the army has gone? Eh, what people! 'Against God's might our hands
can't fight.'"

"Come inside, your honor!" repeated the tradesman, bowing.

The officer stood perplexed and his face showed indecision.

"It's not my business!" he exclaimed, and strode on quickly down one
of the passages.

From one open shop came the sound of blows and vituperation, and
just as the officer came up to it a man in a gray coat with a shaven
head was flung out violently.

This man, bent double, rushed past the tradesman and the officer.
The officer pounced on the soldiers who were in the shops, but at that
moment fearful screams reached them from the huge crowd on the
Moskva bridge and the officer ran out into the square.

"What is it? What is it?" he asked, but his comrade was already
galloping off past Vasili the Beatified in the direction from which
the screams came.

The officer mounted his horse and rode after him. When he reached
the bridge he saw two unlimbered guns, the infantry crossing the
bridge, several overturned carts, and frightened and laughing faces
among the troops. Beside the cannon a cart was standing to which two
horses were harnessed. Four borzois with collars were pressing close
to the wheels. The cart was loaded high, and at the very top, beside a
child's chair with its legs in the air, sat a peasant woman uttering
piercing and desperate shrieks. He was told by his fellow officers
that the screams of the crowd and the shrieks of the woman were due to
the fact that General Ermolov, coming up to the crowd and learning
that soldiers were dispersing among the shops while crowds of
civilians blocked the bridge, had ordered two guns to be unlimbered
and made a show of firing at the bridge. The crowd, crushing one
another, upsetting carts, and shouting and squeezing desperately,
had cleared off the bridge and the troops were now moving forward.





CHAPTER XXII


Meanwhile, the city itself was deserted. There was hardly anyone
in the streets. The gates and shops were all closed, only here and
there round the taverns solitary shouts or drunken songs could be
heard. Nobody drove through the streets and footsteps were rarely
heard. The Povarskaya was quite still and deserted. The huge courtyard
of the Rostovs' house was littered with wisps of hay and with dung
from the horses, and not a soul was to be seen there. In the great
drawing room of the house, which had been left with all it
contained, were two people. They were the yard porter Ignat, and the
page boy Mishka, Vasilich's grandson who had stayed in Moscow with his
grandfather. Mishka had opened the clavichord and was strumming on
it with one finger. The yard porter, his arms akimbo, stood smiling
with satisfaction before the large mirror.

"Isn't it fine, eh, Uncle Ignat?" said the boy, suddenly beginning
to strike the keyboard with both hands.

"Only fancy!" answered Ignat, surprised at the broadening grin on
his face in the mirror.

"Impudence! Impudence!" they heard behind them the voice of Mavra
Kuzminichna who had entered silently. "How he's grinning, the fat mug!
Is that what you're here for? Nothing's cleared away down there and
Vasilich is worn out. Just you wait a bit!"

Ignat left off smiling, adjusted his belt, and went out of the
room with meekly downcast eyes.

"Aunt, I did it gently," said the boy.

"I'll give you something gently, you monkey you!" cried Mavra
Kuzminichna, raising her arm threateningly. "Go and get the samovar to
boil for your grandfather."

Mavra Kuzminichna flicked the dust off the clavichord and closed it,
and with a deep sigh left the drawing room and locked its main door.

Going out into the yard she paused to consider where she should go
next--to drink tea in the servants' wing with Vasilich, or into the
storeroom to put away what still lay about.

She heard the sound of quick footsteps in the quiet street.
Someone stopped at the gate, and the latch rattled as someone tried to
open it. Mavra Kuzminichna went to the gate.

"Who do you want?"

"The count--Count Ilya Andreevich Rostov."

"And who are you?"

"An officer, I have to see him," came the reply in a pleasant,
well-bred Russian voice.

Mavra Kuzminichna opened the gate and an officer of eighteen, with
the round face of a Rostov, entered the yard.

"They have gone away, sir. Went away yesterday at vespertime,"
said Mavra Kuzminichna cordially.

The young officer standing in the gateway, as if hesitating
whether to enter or not, clicked his tongue.

"Ah, how annoying!" he muttered. "I should have come yesterday....
Ah, what a pity."

Meanwhile, Mavra Kuzminichna was attentively and sympathetically
examining the familiar Rostov features of the young man's face, his
tattered coat and trodden-down boots.

"What did you want to see the count for?" she asked.

"Oh well... it can't be helped!" said he in a tone of vexation and
placed his hand on the gate as if to leave.

He again paused in indecision.

"You see," he suddenly said, "I am a kinsman of the count's and he
has been very kind to me. As you see" (he glanced with an amused air
and good-natured smile at his coat and boots) "my things are worn
out and I have no money, so I was going to ask the count..."

Mavra Kuzminichna did not let him finish.

"Just wait a minute, sir. One little moment," said she.

And as soon as the officer let go of the gate handle she turned and,
hurrying away on her old legs, went through the back yard to the
servants' quarters.

While Mavra Kuzminichna was running to her room the officer walked
about the yard gazing at his worn-out boots with lowered head and a
faint smile on his lips. "What a pity I've missed Uncle! What a nice
old woman! Where has she run off to? And how am I to find the
nearest way to overtake my regiment, which must by now be getting near
the Rogozhski gate?" thought he. Just then Mavra Kuzminichna
appeared from behind the corner of the house with a frightened yet
resolute look, carrying a rolled-up check kerchief in her hand.
While still a few steps from the officer she unfolded the kerchief and
took out of it a white twenty-five-ruble assignat and hastily handed
it to him.

"If his excellency had been at home, as a kinsman he would of
course... but as it is..."

Mavra Kuzminichna grew abashed and confused. The officer did not
decline, but took the note quietly and thanked her.

"If the count had been at home..." Mavra Kuzminichna went on
apologetically. "Christ be with you, sir! May God preserve you!"
said she, bowing as she saw him out.

Swaying his head and smiling as if amused at himself, the officer
ran almost at a trot through the deserted streets toward the Yauza
bridge to overtake his regiment.

But Mavra Kuzminichna stood at the closed gate for some time with
moist eyes, pensively swaying her head and feeling an unexpected
flow of motherly tenderness and pity for the unknown young officer.





CHAPTER XXIII


From an unfinished house on the Varvarka, the ground floor of
which was a dramshop, came drunken shouts and songs. On benches
round the tables in a dirty little room sat some ten factory hands.
Tipsy and perspiring, with dim eyes and wide-open mouths, they were
all laboriously singing some song or other. They were singing
discordantly, arduously, and with great effort, evidently not
because they wished to sing, but because they wanted to show they were
drunk and on a spree. One, a tall, fair-haired lad in a clean blue
coat, was standing over the others. His face with its fine straight
nose would have been handsome had it not been for his thin,
compressed, twitching lips and dull, gloomy, fixed eyes. Evidently
possessed by some idea, he stood over those who were singing, and
solemnly and jerkily flourished above their heads his white arm with
the sleeve turned up to the elbow, trying unnaturally to spread out
his dirty fingers. The sleeve of his coat kept slipping down and he
always carefully rolled it up again with his left hand, as if it
were most important that the sinewy white arm he was flourishing
should be bare. In the midst of the song cries were heard, and
fighting and blows in the passage and porch. The tall lad waved his
arm.

"Stop it!" he exclaimed peremptorily. "There's a fight, lads!"
And, still rolling up his sleeve, he went out to the porch.

The factory hands followed him. These men, who under the
leadership of the tall lad were drinking in the dramshop that morning,
had brought the publican some skins from the factory and for this
had had drink served them. The blacksmiths from a neighboring
smithy, hearing the sounds of revelry in the tavern and supposing it
to have been broken into, wished to force their way in too and a fight
in the porch had resulted.

The publican was fighting one of the smiths at the door, and when
the workmen came out the smith, wrenching himself free from the tavern
keeper, fell face downward on the pavement.

Another smith tried to enter the doorway, pressing against the
publican with his chest.

The lad with the turned-up sleeve gave the smith a blow in the
face and cried wildly: "They're fighting us, lads!"

At that moment the first smith got up and, scratching his bruised
face to make it bleed, shouted in a tearful voice: "Police! Murder!...
They've killed a man, lads!"

"Oh, gracious me, a man beaten to death--killed!..." screamed a
woman coming out of a gate close by.

A crowd gathered round the bloodstained smith.

"Haven't you robbed people enough--taking their last shirts?" said a
voice addressing the publican. "What have you killed a man for, you
thief?"

The tall lad, standing in the porch, turned his bleared eyes from
the publican to the smith and back again as if considering whom he
ought to fight now.

"Murderer!" he shouted suddenly to the publican. "Bind him, lads!"

"I daresay you would like to bind me!" shouted the publican, pushing
away the men advancing on him, and snatching his cap from his head
he flung it on the ground.

As if this action had some mysterious and menacing significance, the
workmen surrounding the publican paused in indecision.

"I know the law very well, mates! I'll take the matter to the
captain of police. You think I won't get to him? Robbery is not
permitted to anybody now a days!" shouted the publican, picking up his
cap.

"Come along then! Come along then!" the publican and the tall
young fellow repeated one after the other, and they moved up the
street together.

The bloodstained smith went beside them. The factory hands and
others followed behind, talking and shouting.

At the corner of the Moroseyka, opposite a large house with closed
shutters and bearing a bootmaker's signboard, stood a score of thin,
worn-out, gloomy-faced bootmakers, wearing overalls and long
tattered coats.

"He should pay folks off properly," a thin workingman, with frowning
brows and a straggly beard, was saying.

"But he's sucked our blood and now he thinks he's quit of us. He's
been misleading us all the week and now that he's brought us to this
pass he's made off."

On seeing the crowd and the bloodstained man the workman ceased
speaking, and with eager curiosity all the bootmakers joined the
moving crowd.

"Where are all the folks going?"

"Why, to the police, of course!"

"I say, is it true that we have been beaten?" "And what did you
think? Look what folks are saying."

Questions and answers were heard. The publican, taking advantage
of the increased crowd, dropped behind and returned to his tavern.

The tall youth, not noticing the disappearance of his foe, waved his
bare arm and went on talking incessantly, attracting general attention
to himself. It was around him that the people chiefly crowded,
expecting answers from him to the questions that occupied all their
minds.

"He must keep order, keep the law, that's what the government is
there for. Am I not right, good Christians?" said the tall youth, with
a scarcely perceptible smile. "He thinks there's no government! How
can one do without government? Or else there would be plenty who'd rob
us."

"Why talk nonsense?" rejoined voices in the crowd. "Will they give
up Moscow like this? They told you that for fun, and you believed
it! Aren't there plenty of troops on the march? Let him in, indeed!
That's what the government is for. You'd better listen to what
people are saying," said some of the mob pointing to the tall youth.

By the wall of China-Town a smaller group of people were gathered
round a man in a frieze coat who held a paper in his hand.

"An ukase, they are reading an ukase! Reading an ukase!" cried
voices in the crowd, and the people rushed toward the reader.

The man in the frieze coat was reading the broadsheet of August 31
When the crowd collected round him he seemed confused, but at the
demand of the tall lad who had pushed his way up to him, he began in a
rather tremulous voice to read the sheet from the beginning.

"Early tomorrow I shall go to his Serene Highness," he read
("Sirin Highness," said the tall fellow with a triumphant smile on his
lips and a frown on his brow), "to consult with him to act, and to aid
the army to exterminate these scoundrels. We too will take part..."
the reader went on, and then paused ("Do you see," shouted the youth
victoriously, "he's going to clear up the whole affair for
you...."), "in destroying them, and will send these visitors to the
devil. I will come back to dinner, and we'll set to work. We will
do, completely do, and undo these scoundrels."

The last words were read out in the midst of complete silence. The
tall lad hung his head gloomily. It was evident that no one had
understood the last part. In particular, the words "I will come back
to dinner," evidently displeased both reader and audience. The
people's minds were tuned to a high pitch and this was too simple
and needlessly comprehensible--it was what any one of them might
have said and therefore was what an ukase emanating from the highest
authority should not say.

They all stood despondent and silent. The tall youth moved his
lips and swayed from side to side.

"We should ask him... that's he himself?"... "Yes, ask him
indeed!... Why not? He'll explain"... voices in the rear of the
crowd were suddenly heard saying, and the general attention turned
to the police superintendent's trap which drove into the square
attended by two mounted dragoons.

The superintendent of police, who had that morning by Count
Rostopchin's orders to burn the barges and had in connection with that
matter acquired a large sum of money which was at that moment in his
pocket, on seeing a crowd bearing down upon him told his coachman to
stop.

"What people are these?" he shouted to the men, who were moving
singly and timidly in the direction of his trap.

"What people are these?" he shouted again, receiving no answer.

"Your honor..." replied the shopman in the frieze coat, "your honor,
in accord with the proclamation of his highest excellency the count,
they desire to serve, not sparing their lives, and it is not any
kind of riot, but as his highest excellence said..."

"The count has not left, he is here, and an order will be issued
concerning you," said the superintendent of police. "Go on!" he
ordered his coachman.

The crowd halted, pressing around those who had heard what the
superintendent had said, and looking at the departing trap.

The superintendent of police turned round at that moment with a
scared look, said something to his coachman, and his horses
increased their speed.

"It's a fraud, lads! Lead the way to him, himself!" shouted the tall
youth. "Don't let him go, lads! Let him answer us! Keep him!"
shouted different people and the people dashed in pursuit of the trap.

Following the superintendent of police and talking loudly the
crowd went in the direction of the Lubyanka Street.

"There now, the gentry and merchants have gone away and left us to
perish. Do they think we're dogs?" voices in the crowd were heard
saying more and more frequently.





CHAPTER XXIV


On the evening of the first of September, after his interview with
Kutuzov, Count Rostopchin had returned to Moscow mortified and
offended because he had not been invited to attend the council of war,
and because Kutuzov had paid no attention to his offer to take part in
the defense of the city; amazed also at the novel outlook revealed
to him at the camp, which treated the tranquillity of the capital
and its patriotic fervor as not merely secondary but quite
irrelevant and unimportant matters. Distressed, offended, and
surprised by all this, Rostopchin had returned to Moscow. After supper
he lay down on a sofa without undressing, and was awakened soon
after midnight by a courier bringing him a letter from Kutuzov. This
letter requested the count to send police officers to guide the troops
through the town, as the army was retreating to the Ryazan road beyond
Moscow. This was not news to Rostopchin. He had known that Moscow
would be abandoned not merely since his interview the previous day
with Kutuzov on the Poklonny Hill but ever since the battle of
Borodino, for all the generals who came to Moscow after that battle
had said unanimously that it was impossible to fight another battle,
and since then the government property had been removed every night,
and half the inhabitants had left the city with Rostopchin's own
permission. Yet all the same this information astonished and irritated
the count, coming as it did in the form of a simple note with an order
from Kutuzov, and received at night, breaking in on his beauty sleep.

When later on in his memoirs Count Rostopchin explained his
actions at this time, he repeatedly says that he was then actuated
by two important considerations: to maintain tranquillity in Moscow
and expedite the departure of the inhabitants. If one accepts this
twofold aim all Rostopchin's actions appear irreproachable. "Why
were the holy relics, the arms, ammunition, gunpowder, and stores of
corn not removed? Why were thousands of inhabitants deceived into
believing that Moscow would not be given up--and thereby ruined?"
"To presence the tranquillity of the city," explains Count Rostopchin.
"Why were bundles of useless papers from the government offices, and
Leppich's balloon and other articles removed?" "To leave the town
empty," explains Count Rostopchin. One need only admit that public
tranquillity is in danger and any action finds a justification.

All the horrors of the reign of terror were based only on solicitude
for public tranquillity.

On what, then, was Count Rostopchin's fear for the tranquillity of
Moscow based in 1812? What reason was there for assuming any
probability of an uprising in the city? The inhabitants were leaving
it and the retreating troops were filling it. Why should that cause
the masses to riot?

Neither in Moscow nor anywhere in Russia did anything resembling
an insurrection ever occur when the enemy entered a town. More than
ten thousand people were still in Moscow on the first and second of
September, and except for a mob in the governor's courtyard, assembled
there at his bidding, nothing happened. It is obvious that there would
have been even less reason to expect a disturbance among the people if
after the battle of Borodino, when the surrender of Moscow became
certain or at least probable, Rostopchin instead of exciting the
people by distributing arms and broadsheets had taken steps to
remove all the holy relics, the gunpowder, munitions, and money, and
had told the population plainly that the town would be abandoned.

Rostopchin, though he had patriotic sentiments, was a sanguine and
impulsive man who had always moved in the highest administrative
circles and had no understanding at all of the people he supposed
himself to be guiding. Ever since the enemy's entry into Smolensk he
had in imagination been playing the role of director of the popular
feeling of "the heart of Russia." Not only did it seem to him (as to
all administrators) that he controlled the external actions of
Moscow's inhabitants, but he also thought he controlled their mental
attitude by means of his broadsheets and posters, written in a
coarse tone which the people despise in their own class and do not
understand from those in authority. Rostopchin was so pleased with the
fine role of leader of popular feeling, and had grown so used to it,
that the necessity of relinquishing that role and abandoning Moscow
without any heroic display took him unawares and he suddenly felt
the ground slip away from under his feet, so that he positively did
not know what to do. Though he knew it was coming, he did not till the
last moment wholeheartedly believe that Moscow would be abandoned, and
did not prepare for it. The inhabitants left against his wishes. If
the government offices were removed, this was only done on the
demand of officials to whom the count yielded reluctantly. He was
absorbed in the role he had created for himself. As is often the
case with those gifted with an ardent imagination, though he had
long known that Moscow would be abandoned he knew it only with his
intellect, he did not believe it in his heart and did not adapt
himself mentally to this new position of affairs.

All his painstaking and energetic activity (in how far it was useful
and had any effect on the people is another question) had been
simply directed toward arousing in the masses his own feeling of
patriotic hatred of the French.

But when events assumed their true historical character, when
expressing hatred for the French in words proved insufficient, when it
was not even possible to express that hatred by fighting a battle,
when self-confidence was of no avail in relation to the one question
before Moscow, when the whole population streamed out of Moscow as one
man, abandoning their belongings and proving by that negative action
all the depth of their national feeling, then the role chosen by
Rostopchin suddenly appeared senseless. He unexpectedly felt himself
ridiculous, weak, and alone, with no ground to stand on.

When, awakened from his sleep, he received that cold, peremptory
note from Kutuzov, he felt the more irritated the more he felt himself
to blame. All that he had been specially put in charge of, the state
property which he should have removed, was still in Moscow and it
was no longer possible to take the whole of it away.

"Who is to blame for it? Who has let things come to such a pass?" he
ruminated. "Not I, of course. I had everything ready. I had Moscow
firmly in hand. And this is what they have let it come to! Villains!
Traitors!" he thought, without clearly defining who the villains and
traitors were, but feeling it necessary to hate those traitors whoever
they might be who were to blame for the false and ridiculous
position in which he found himself.

All that night Count Rostopchin issued orders, for which people came
to him from all parts of Moscow. Those about him had never seen the
count so morose and irritable.

"Your excellency, the Director of the Registrar's Department has
sent for instructions... From the Consistory, from the Senate, from
the University, from the Foundling Hospital, the Suffragan has sent...
asking for information.... What are your orders about the Fire
Brigade? From the governor of the prison... from the superintendent of
the lunatic asylum..." All night long such announcements were
continually being received by the count.

To all these inquiries he gave brief and angry replies indicating
that orders from him were not now needed, that the whole affair,
carefully prepared by him, had now been ruined by somebody, and that
that somebody would have to bear the whole responsibility for all that
might happen.

"Oh, tell that blockhead," he said in reply to the question from the
Registrar's Department, "that he should remain to guard his documents.
Now why are you asking silly questions about the Fire Brigade? They
have horses, let them be off to Vladimir, and not leave them to the
French."

"Your excellency, the superintendent of the lunatic asylum has come:
what are your commands?"

"My commands? Let them go away, that's all.... And let the
lunatics out into the town. When lunatics command our armies God
evidently means these other madmen to be free."

In reply to an inquiry about the convicts in the prison, Count
Rostopchin shouted angrily at the governor:

"Do you expect me to give you two battalions--which we have not got-
for a convoy? Release them, that's all about it!"

"Your excellency, there are some political prisoners, Meshkov,
Vereshchagin..."

"Vereshchagin! Hasn't he been hanged yet?" shouted Rostopchin.
"Bring him to me!"





CHAPTER XXV


Toward nine o'clock in the morning, when the troops were already
moving through Moscow, nobody came to the count any more for
instructions. Those who were able to get away were going of their
own accord, those who remained behind decided for themselves what they
must do.

The count ordered his carriage that he might drive to Sokolniki, and
sat in his study with folded hands, morose, sallow, and taciturn.

In quiet and untroubled times it seems to every administrator that
it is only by his efforts that the whole population under his rule
is kept going, and in this consciousness of being indispensable
every administrator finds the chief reward of his labor and efforts.
While the sea of history remains calm the ruler-administrator in his
frail bark, holding on with a boat hook to the ship of the people
and himself moving, naturally imagines that his efforts move the
ship he is holding on to. But as soon as a storm arises and the sea
begins to heave and the ship to move, such a delusion is no longer
possible. The ship moves independently with its own enormous motion,
the boat hook no longer reaches the moving vessel, and suddenly the
administrator, instead of appearing a ruler and a source of power,
becomes an insignificant, useless, feeble man.

Rostopchin felt this, and it was this which exasperated him.

The superintendent of police, whom the crowd had stopped, went in to
see him at the same time as an adjutant who informed the count that
the horses were harnessed. They were both pale, and the superintendent
of police, after reporting that he had executed the instructions he
had received, informed the count that an immense crowd had collected
in the courtyard and wished to see him.

Without saying a word Rostopchin rose and walked hastily to his
light, luxurious drawing room, went to the balcony door, took hold
of the handle, let it go again, and went to the window from which he
had a better view of the whole crowd. The tall lad was standing in
front, flourishing his arm and saying something with a stern look. The
blood stained smith stood beside him with a gloomy face. A drone of
voices was audible through the closed window.

"Is my carriage ready?" asked Rostopchin, stepping back from the
window.

"It is, your excellency," replied the adjutant.

Rostopchin went again to the balcony door.

"But what do they want?" he asked the superintendent of police.

"Your excellency, they say they have got ready, according to your
orders, to go against the French, and they shouted something about
treachery. But it is a turbulent crowd, your excellency--I hardly
managed to get away from it. Your excellency, I venture to suggest..."

"You may go. I don't need you to tell me what to do!" exclaimed
Rostopchin angrily.

He stood by the balcony door looking at the crowd.

"This is what they have done with Russia! This is what they have
done with me!" thought he, full of an irrepressible fury that welled
up within him against the someone to whom what was happening might
be attributed. As often happens with passionate people, he was
mastered by anger but was still seeking an object on which to vent it.
"Here is that mob, the dregs of the people," he thought as he gazed at
the crowd: "this rabble they have roused by their folly! They want a
victim," he thought as he looked at the tall lad flourishing his
arm. And this thought occurred to him just because he himself
desired a victim, something on which to vent his rage.

"Is the carriage ready?" he asked again.

"Yes, your excellency. What are your orders about Vereshchagin? He
is waiting at the porch," said the adjutant.

"Ah!" exclaimed Rostopchin, as if struck by an unexpected
recollection.

And rapidly opening the door he went resolutely out onto the
balcony. The talking instantly ceased, hats and caps were doffed,
and all eyes were raised to the count.

"Good morning, lads!" said the count briskly and loudly. "Thank
you for coming. I'll come out to you in a moment, but we must first
settle with the villain. We must punish the villain who has caused the
ruin of Moscow. Wait for me!"

And the count stepped as briskly back into the room and slammed
the door behind him.

A murmur of approbation and satisfaction ran through the crowd.
"He'll settle with all the villains, you'll see! And you said the
French... He'll show you what law is!" the mob were saying as if
reproving one another for their lack of confidence.

A few minutes later an officer came hurriedly out of the front door,
gave an order, and the dragoons formed up in line. The crowd moved
eagerly from the balcony toward the porch. Rostopchin, coming out
there with quick angry steps, looked hastily around as if seeking
someone.

"Where is he?" he inquired. And as he spoke he saw a young man
coming round the corner of the house between two dragoons. He had a
long thin neck, and his head, that had been half shaved, was again
covered by short hair. This young man was dressed in a threadbare blue
cloth coat lined with fox fur, that had once been smart, and dirty
hempen convict trousers, over which were pulled his thin, dirty,
trodden-down boots. On his thin, weak legs were heavy chains which
hampered his irresolute movements.

"Ah!" said Rostopchin, hurriedly turning away his eyes from the
young man in the fur-lined coat and pointing to the bottom step of the
porch. "Put him there."

The young man in his clattering chains stepped clumsily to the
spot indicated, holding away with one finger the coat collar which
chafed his neck, turned his long neck twice this way and that, sighed,
and submissively folded before him his thin hands, unused to work.

For several seconds while the young man was taking his place on
the step the silence continued. Only among the back rows of the
people, who were all pressing toward the one spot, could sighs,
groans, and the shuffling of feet be heard.

While waiting for the young man to take his place on the step
Rostopchin stood frowning and rubbing his face with his hand.

"Lads!" said he, with a metallic ring in his voice. "This man,
Vereshchagin, is the scoundrel by whose doing Moscow is perishing."

The young man in the fur-lined coat, stooping a little, stood in a
submissive attitude, his fingers clasped before him. His emaciated
young face, disfigured by the half-shaven head, hung down
hopelessly. At the count's first words he raised it slowly and
looked up at him as if wishing to say something or at least to meet
his eye. But Rostopchin did not look at him. A vein in the young man's
long thin neck swelled like a cord and went blue behind the ear, and
suddenly his face flushed.

All eyes were fixed on him. He looked at the crowd, and rendered
more hopeful by the expression he read on the faces there, he smiled
sadly and timidly, and lowering his head shifted his feet on the step.

"He has betrayed his Tsar and his country, he had gone over to
Bonaparte. He alone of all the Russians has disgraced the Russian
name, he has caused Moscow to perish," said Rostopchin in a sharp,
even voice, but suddenly he glanced down at Vereshchagin who continued
to stand in the same submissive attitude. As if inflamed by the sight,
he raised his arm and addressed the people, almost shouting:

"Deal with him as you think fit! I hand him over to you."

The crowd remained silent and only pressed closer and closer to
one another. To keep one another back, to breathe in that stifling
atmosphere, to be unable to stir, and to await something unknown,
uncomprehended, and terrible, was becoming unbearable. Those
standing in front, who had seen and heard what had taken place
before them, all stood with wide open eyes and mouths, straining
with all their strength, and held back the crowd that was pushing
behind them.

"Beat him!... Let the traitor perish and not disgrace the Russian
name!" shouted Rostopchin. "Cut him down. I command it."

Hearing not so much the words as the angry tone of Rostopchin's
voice, the crowd moaned and heaved forward, but again paused.

"Count!" exclaimed the timid yet theatrical voice of Vereshchagin in
the midst of the momentary silence that ensued, "Count! One God is
above us both...." He lifted his head and again the thick vein in
his thin neck filled with blood and the color rapidly came and went in
his face.

He did not finish what he wished to say.

"Cut him down! I command it..." shouted Rostopchin, suddenly growing
pale like Vereshchagin.

"Draw sabers!" cried the dragoon officer, drawing his own.

Another still stronger wave flowed through the crowd and reaching
the front ranks carried it swaying to the very steps of the porch. The
tall youth, with a stony look on his face, and rigid and uplifted arm,
stood beside Vereshchagin.

"Saber him!" the dragoon officer almost whispered.

And one of the soldiers, his face all at once distorted with fury,
struck Vereshchagin on the head with the blunt side of his saber.

"Ah!" cried Vereshchagin in meek surprise, looking round with a
frightened glance as if not understanding why this was done to him.
A similar moan of surprise and horror ran through the crowd. "O Lord!"
exclaimed a sorrowful voice.

But after the exclamation of surprise that had escaped from
Vereshchagin he uttered a plaintive cry of pain, and that cry was
fatal. The barrier of human feeling, strained to the utmost, that
had held the crowd in check suddenly broke. The crime had begun and
must now be completed. The plaintive moan of reproach was drowned by
the threatening and angry roar of the crowd. Like the seventh and last
wave that shatters a ship, that last irresistible wave burst from
the rear and reached the front ranks, carrying them off their feet and
engulfing them all. The dragoon was about to repeat his blow.
Vereshchagin with a cry of horror, covering his head with his hands,
rushed toward the crowd. The tall youth, against whom he stumbled,
seized his thin neck with his hands and, yelling wildly, fell with him
under the feet of the pressing, struggling crowd.

Some beat and tore at Vereshchagin, others at the tall youth. And
the screams of those that were being trampled on and of those who
tried to rescue the tall lad only increased the fury of the crowd.
It was a long time before the dragoons could extricate the bleeding
youth, beaten almost to death. And for a long time, despite the
feverish haste with which the mob tried to end the work that had
been begun, those who were hitting, throttling, and tearing at
Vereshchagin were unable to kill him, for the crowd pressed from all
sides, swaying as one mass with them in the center and rendering it
impossible for them either to kill him or let him go.

"Hit him with an ax, eh!... Crushed?... Traitor, he sold
Christ.... Still alive... tenacious... serves him right! Torture
serves a thief right. Use the hatchet!... What--still alive?"

Only when the victim ceased to struggle and his cries changed to a
long-drawn, measured death rattle did the crowd around his
prostrate, bleeding corpse begin rapidly to change places. Each one
came up, glanced at what had been done, and with horror, reproach, and
astonishment pushed back again.

"O Lord! The people are like wild beasts! How could he be alive?"
voices in the crowd could be heard saying. "Quite a young fellow
too... must have been a merchant's son. What men!... and they say he's
not the right one.... How not the right one?... O Lord! And there's
another has been beaten too--they say he's nearly done for.... Oh, the
people... Aren't they afraid of sinning?..." said the same mob now,
looking with pained distress at the dead body with its long, thin,
half-severed neck and its livid face stained with blood and dust.

A painstaking police officer, considering the presence of a corpse
in his excellency's courtyard unseemly, told the dragoons to take it
away. Two dragoons took it by its distorted legs and dragged it
along the ground. The gory, dust-stained, half-shaven head with its
long neck trailed twisting along the ground. The crowd shrank back
from it.

At the moment when Vereshchagin fell and the crowd closed in with
savage yells and swayed about him, Rostopchin suddenly turned pale
and, instead of going to the back entrance where his carriage
awaited him, went with hurried steps and bent head, not knowing
where and why, along the passage leading to the rooms on the ground
floor. The count's face was white and he could not control the
feverish twitching of his lower jaw.


"This way, your excellency... Where are you going?... This way,
please..." said a trembling, frightened voice behind him.

Count Rostopchin was unable to reply and, turning obediently, went
in the direction indicated. At the back entrance stood his caleche.
The distant roar of the yelling crowd was audible even there. He
hastily took his seat and told the coachman to drive him to his
country house in Sokolniki.

When they reached the Myasnitski Street and could no longer hear the
shouts of the mob, the count began to repent. He remembered with
dissatisfaction the agitation and fear he had betrayed before his
subordinates. "The mob is terrible--disgusting," he said to himself in
French. "They are like wolves whom nothing but flesh can appease."
"Count! One God is above us both!"--Vereshchagin's words suddenly
recurred to him, and a disagreeable shiver ran down his back. But this
was only a momentary feeling and Count Rostopchin smiled
disdainfully at himself. "I had other duties," thought he. "The people
had to be appeased. Many other victims have perished and are perishing
for the public good"--and he began thinking of his social duties to
his family and to the city entrusted to him, and of himself--not
himself as Theodore Vasilyevich Rostopchin (he fancied that Theodore
Vasilyevich Rostopchin was sacrificing himself for the public good)
but himself as governor, the representative of authority and of the
Tsar. "Had I been simply Theodore Vasilyevich my course of action
would have been quite different, but it was my duty to safeguard my
life and dignity as commander in chief."

Lightly swaying on the flexible springs of his carriage and no
longer hearing the terrible sounds of the crowd, Rostopchin grew
physically calm and, as always happens, as soon as he became
physically tranquil his mind devised reasons why he should be mentally
tranquil too. The thought which tranquillized Rostopchin was not a new
one. Since the world began and men have killed one another no one
has ever committed such a crime against his fellow man without
comforting himself with this same idea. This idea is le bien public,
the hypothetical welfare of other people.

To a man not swayed by passion that welfare is never certain, but he
who commits such a crime always knows just where that welfare lies.
And Rostopchin now knew it.

Not only did his reason not reproach him for what he had done, but
he even found cause for self-satisfaction in having so successfully
contrived to avail himself of a convenient opportunity to punish a
criminal and at the same time pacify the mob.

"Vereshchagin was tried and condemned to death," thought
Rostopchin (though the Senate had only condemned Vereshchagin to
hard labor), "he was a traitor and a spy. I could not let him go
unpunished and so I have killed two birds with one stone: to appease
the mob I gave them a victim and at the same time punished a
miscreant."

Having reached his country house and begun to give orders about
domestic arrangements, the count grew quite tranquil.

Half an hour later he was driving with his fast horses across the
Sokolniki field, no longer thinking of what had occurred but
considering what was to come. He was driving to the Yauza bridge where
he had heard that Kutuzov was. Count Rostopchin was mentally preparing
the angry and stinging reproaches he meant to address to Kutuzov for
his deception. He would make that foxy old courtier feel that the
responsibility for all the calamities that would follow the
abandonment of the city and the ruin of Russia (as Rostopchin regarded
it) would fall upon his doting old head. Planning beforehand what he
would say to Kutuzov, Rostopchin turned angrily in his caleche and
gazed sternly from side to side.

The Sokolniki field was deserted. Only at the end of it, in front of
the almshouse and the lunatic asylum, could be seen some people in
white and others like them walking singly across the field shouting
and gesticulating.

One of these was running to cross the path of Count Rostopchin's
carriage, and the count himself, his coachman, and his dragoons looked
with vague horror and curiosity at these released lunatics and
especially at the one running toward them.

Swaying from side to side on his long, thin legs in his fluttering
dressing gown, this lunatic was running impetuously, his gaze fixed on
Rostopchin, shouting something in a hoarse voice and making signs to
him to stop. The lunatic's solemn, gloomy face was thin and yellow,
with its beard growing in uneven tufts. His black, agate pupils with
saffron-yellow whites moved restlessly near the lower eyelids.

"Stop! Pull up, I tell you!" he cried in a piercing voice, and again
shouted something breathlessly with emphatic intonations and gestures.

Coming abreast of the caleche he ran beside it.

"Thrice have they slain me, thrice have I risen from the dead.
They stoned me, crucified me... I shall rise... shall rise... shall
rise. They have torn my body. The kingdom of God will be overthrown...
Thrice will I overthrow it and thrice re-establish it!" he cried,
raising his voice higher and higher.

Count Rostopchin suddenly grew pale as he had done when the crowd
closed in on Vereshchagin. He turned away. "Go fas... faster!" he
cried in a trembling voice to his coachman. The caleche flew over
the ground as fast as the horses could draw it, but for a long time
Count Rostopchin still heard the insane despairing screams growing
fainter in the distance, while his eyes saw nothing but the
astonished, frightened, bloodstained face of "the traitor" in the
fur-lined coat.

Recent as that mental picture was, Rostopchin already felt that it
had cut deep into his heart and drawn blood. Even now he felt
clearly that the gory trace of that recollection would not pass with
time, but that the terrible memory would, on the contrary, dwell in
his heart ever more cruelly and painfully to the end of his life. He
seemed still to hear the sound of his own words: "Cut him down! I
command it...."

"Why did I utter those words? It was by some accident I said
them.... I need not have said them," he thought. "And then nothing
would have happened." He saw the frightened and then infuriated face
of the dragoon who dealt the blow, the look of silent, timid
reproach that boy in the fur-lined coat had turned upon him. "But I
did not do it for my own sake. I was bound to act that way.... The
mob, the traitor... the public welfare," thought he.

Troops were still crowding at the Yauza bridge. It was hot. Kutuzov,
dejected and frowning, sat on a bench by the bridge toying with his
whip in the sand when a caleche dashed up noisily. A man in a
general's uniform with plumes in his hat went up to Kutuzov and said
something in French. It was Count Rostopchin. He told Kutuzov that
he had come because Moscow, the capital, was no more and only the army
remained.

"Things would have been different if your Serene Highness had not
told me that you would not abandon Moscow without another battle;
all this would not have happened," he said.

Kutuzov looked at Rostopchin as if, not grasping what was said to
him, he was trying to read something peculiar written at that moment
on the face of the man addressing him. Rostopchin grew confused and
became silent. Kutuzov slightly shook his head and not taking his
penetrating gaze from Rostopchin's face muttered softly:

"No! I shall not give up Moscow without a battle!"

Whether Kutuzov was thinking of something entirely different when he
spoke those words, or uttered them purposely, knowing them to be
meaningless, at any rate Rostopchin made no reply and hastily left
him. And strange to say, the Governor of Moscow, the proud Count
Rostopchin, took up a Cossack whip and went to the bridge where he
began with shouts to drive on the carts that blocked the way.





CHAPTER XXVI


Toward four o'clock in the afternoon Murat's troops were entering
Moscow. In front rode a detachment of Wurttemberg hussars and behind
them rode the King of Naples himself accompanied by a numerous suite.

About the middle of the Arbat Street, near the Church of the
Miraculous Icon of St. Nicholas, Murat halted to await news from the
advanced detachment as to the condition in which they had found the
citadel, le Kremlin.

Around Murat gathered a group of those who had remained in Moscow.
They all stared in timid bewilderment at the strange, long-haired
commander dressed up in feathers and gold.

"Is that their Tsar himself? He's not bad!" low voices could be
heard saying.

An interpreter rode up to the group.

"Take off your cap... your caps!" These words went from one to
another in the crowd. The interpreter addressed an old porter and
asked if it was far to the Kremlin. The porter, listening in
perplexity to the unfamiliar Polish accent and not realizing that
the interpreter was speaking Russian, did not understand what was
being said to him and slipped behind the others.

Murat approached the interpreter and told him to ask where the
Russian army was. One of the Russians understood what was asked and
several voices at once began answering the interpreter. A French
officer, returning from the advanced detachment, rode up to Murat
and reported that the gates of the citadel had been barricaded and
that there was probably an ambuscade there.

"Good!" said Murat and, turning to one of the gentlemen in his
suite, ordered four light guns to be moved forward to fire at the
gates.

The guns emerged at a trot from the column following Murat and
advanced up the Arbat. When they reached the end of the Vozdvizhenka
Street they halted and drew in the Square. Several French officers
superintended the placing of the guns and looked at the Kremlin
through field glasses.

The bells in the Kremlin were ringing for vespers, and this sound
troubled the French. They imagined it to be a call to arms. A few
infantrymen ran to the Kutafyev Gate. Beams and wooden screens had
been put there, and two musket shots rang out from under the gate as
soon as an officer and men began to run toward it. A general who was
standing by the guns shouted some words of command to the officer, and
the latter ran back again with his men.

The sound of three more shots came from the gate.

One shot struck a French soldier's foot, and from behind the screens
came the strange sound of a few voices shouting. Instantly as at a
word of command the expression of cheerful serenity on the faces of
the French general, officers, and men changed to one of determined
concentrated readiness for strife and suffering. To all of them from
the marshal to the least soldier, that place was not the Vozdvizhenka,
Mokhavaya, or Kutafyev Street, nor the Troitsa Gate (places familiar
in Moscow), but a new battlefield which would probably prove
sanguinary. And all made ready for that battle. The cries from the
gates ceased. The guns were advanced, the artillerymen blew the ash
off their linstocks, and an officer gave the word "Fire!" This was
followed by two whistling sounds of canister shot, one after
another. The shot rattled against the stone of the gate and upon the
wooden beams and screens, and two wavering clouds of smoke rose over
the Square.

A few instants after the echo of the reports resounding over the
stone-built Kremlin had died away the French heard a strange sound
above their head. Thousands of crows rose above the walls and
circled in the air, cawing and noisily flapping their wings.
Together with that sound came a solitary human cry from the gateway
and amid the smoke appeared the figure of a bareheaded man in a
peasant's coat. He grasped a musket and took aim at the French.
"Fire!" repeated the officer once more, and the reports of a musket
and of two cannon shots were heard simultaneously. The gate again
hidden by smoke.

Nothing more stirred behind the screens and the French infantry
soldiers and officers advanced to the gate. In the gateway lay three
wounded and four dead. Two men in peasant coats ran away at the foot
of the wall, toward the Znamenka.

"Clear that away!" said the officer, pointing to the beams and the
corpses, and the French soldiers, after dispatching the wounded, threw
the corpses over the parapet.

Who these men were nobody knew. "Clear that away!" was all that
was said of them, and they were thrown over the parapet and removed
later on that they might not stink. Thiers alone dedicates a few
eloquent lines to their memory: "These wretches had occupied the
sacred citadel, having supplied themselves with guns from the arsenal,
and fired" (the wretches) "at the French. Some of them were sabered
and the Kremlin was purged of their presence."

Murat was informed that the way had been cleared. The French entered
the gates and began pitching their camp in the Senate Square. Out of
the windows of the Senate House the soldiers threw chairs into the
Square for fuel and kindled fires there.

Other detachments passed through the Kremlin and encamped along
the Moroseyka, the Lubyanka, and Pokrovka Streets. Others quartered
themselves along the Vozdvizhenka, the Nikolski, and the Tverskoy
Streets. No masters of the houses being found anywhere, the French
were not billeted on the inhabitants as is usual in towns but lived in
it as in a camp.

Though tattered, hungry, worn out, and reduced to a third of their
original number, the French entered Moscow in good marching order.
It was a weary and famished, but still a fighting and menacing army.
But it remained an army only until its soldiers had dispersed into
their different lodgings. As soon as the men of the various
regiments began to disperse among the wealthy and deserted houses, the
army was lost forever and there came into being something nondescript,
neither citizens nor soldiers but what are known as marauders. When
five weeks later these same men left Moscow, they no longer formed
an army. They were a mob of marauders, each carrying a quantity of
articles which seemed to him valuable or useful. The aim of each man
when he left Moscow was no longer, as it had been, to conquer, but
merely to keep what he had acquired. Like a monkey which puts its
paw into the narrow neck of a jug, and having seized a handful of nuts
will not open its fist for fear of losing what it holds, and therefore
perishes, the French when they left Moscow had inevitably to perish
because they carried their loot with them, yet to abandon what they
had stolen was as impossible for them as it is for the monkey to
open its paw and let go of its nuts. Ten minutes after each regiment
had entered a Moscow district, not a soldier or officer was left.
Men in military uniforms and Hessian boots could be seen through the
windows, laughing and walking through the rooms. In cellars and
storerooms similar men were busy among the provisions, and in the
yards unlocking or breaking open coach house and stable doors,
lighting fires in kitchens and kneading and baking bread with
rolled-up sleeves, and cooking; or frightening, amusing, or
caressing women and children. There were many such men both in the
shops and houses--but there was no army.

Order after order was issued by the French commanders that day
forbidding the men to disperse about the town, sternly forbidding
any violence to the inhabitants or any looting, and announcing a
roll call for that very evening. But despite all these measures the
men, who had till then constituted an army, flowed all over the
wealthy, deserted city with its comforts and plentiful supplies. As
a hungry herd of cattle keeps well together when crossing a barren
field, but gets out of hand and at once disperses uncontrollably as
soon as it reaches rich pastures, so did the army disperse all over
the wealthy city.

No residents were left in Moscow, and the soldiers--like water
percolating through sand--spread irresistibly through the city in
all directions from the Kremlin into which they had first marched. The
cavalry, on entering a merchant's house that had been abandoned and
finding there stabling more than sufficient for their horses, went on,
all the same, to the next house which seemed to them better. Many of
them appropriated several houses, chalked their names on them, and
quarreled and even fought with other companies for them. Before they
had had time to secure quarters the soldiers ran out into the
streets to see the city and, hearing that everything had been
abandoned, rushed to places where valuables were to be had for the
taking. The officers followed to check the soldiers and were
involuntarily drawn into doing the same. In Carriage Row carriages had
been left in the shops, and generals flocked there to select
caleches and coaches for themselves. The few inhabitants who had
remained invited commanding officers to their houses, hoping thereby
to secure themselves from being plundered. There were masses of wealth
and there seemed no end to it. All around the quarters occupied by the
French were other regions still unexplored and unoccupied where,
they thought, yet greater riches might be found. And Moscow engulfed
the army ever deeper and deeper. When water is spilled on dry ground
both the dry ground and the water disappear and mud results; and in
the same way the entry of the famished army into the rich and deserted
city resulted in fires and looting and the destruction of both the
army and the wealthy city.


The French attributed the Fire of Moscow au patriotisme feroce de
Rostopchine,* the Russians to the barbarity of the French. In reality,
however, it was not, and could not be, possible to explain the burning
of Moscow by making any individual, or any group of people,
responsible for it. Moscow was burned because it found itself in a
position in which any town built of wood was bound to burn, quite
apart from whether it had, or had not, a hundred and thirty inferior
fire engines. Deserted Moscow had to burn as inevitably as a heap of
shavings has to burn on which sparks continually fall for several
days. A town built of wood, where scarcely a day passes without
conflagrations when the house owners are in residence and a police
force is present, cannot help burning when its inhabitants have left
it and it is occupied by soldiers who smoke pipes, make campfires of
the Senate chairs in the Senate Square, and cook themselves meals
twice a day. In peacetime it is only necessary to billet troops in the
villages of any district and the number of fires in that district
immediately increases. How much then must the probability of fire be
increased in an abandoned, wooden town where foreign troops are
quartered. "Le patriotisme feroce de Rostopchine" and the barbarity of
the French were not to blame in the matter. Moscow was set on fire
by the soldiers' pipes, kitchens, and campfires, and by the
carelessness of enemy soldiers occupying houses they did not own. Even
if there was any arson (which is very doubtful, for no one had any
reason to burn the houses--in any case a troublesome and dangerous
thing to do), arson cannot be regarded as the cause, for the same
thing would have happened without any incendiarism.


*To Rostopchin's ferocious patriotism.


However tempting it might be for the French to blame Rostopchin's
ferocity and for Russians to blame the scoundrel Bonaparte, or later
on to place an heroic torch in the hands of their own people, it is
impossible not to see that there could be no such direct cause of
the fire, for Moscow had to burn as every village, factory, or house
must burn which is left by its owners and in which strangers are
allowed to live and cook their porridge. Moscow was burned by its
inhabitants, it is true, but by those who had abandoned it and not
by those who remained in it. Moscow when occupied by the enemy did not
remain intact like Berlin, Vienna, and other towns, simply because its
inhabitants abandoned it and did not welcome the French with bread and
salt, nor bring them the keys of the city.





CHAPTER XXVII


The absorption of the French by Moscow, radiating starwise as it
did, only reached the quarter where Pierre was staying by the
evening of the second of September.

After the last two days spent in solitude and unusual circumstances,
Pierre was in a state bordering on insanity. He was completely
obsessed by one persistent thought. He did not know how or when this
thought had taken such possession of him, but he remembered nothing of
the past, understood nothing of the present, and all he saw and
heard appeared to him like a dream.

He had left home only to escape the intricate tangle of life's
demands that enmeshed him, and which in his present condition he was
unable to unravel. He had gone to Joseph Alexeevich's house, on the
plea of sorting the deceased's books and papers, only in search of
rest from life's turmoil, for in his mind the memory of Joseph
Alexeevich was connected with a world of eternal, solemn, and calm
thoughts, quite contrary to the restless confusion into which he
felt himself being drawn. He sought a quiet refuge, and in Joseph
Alexeevich's study he really found it. When he sat with his elbows
on the dusty writing table in the deathlike stillness of the study,
calm and significant memories of the last few days rose one after
another in his imagination, particularly of the battle of Borodino and
of that vague sense of his own insignificance and insincerity compared
with the truth, simplicity, and strength of the class of men he
mentally classed as they. When Gerasim roused him from his reverie the
idea occurred to him of taking part in the popular defense of Moscow
which he knew was projected. And with that object he had asked Gerasim
to get him a peasant's coat and a pistol, confiding to him his
intentions of remaining in Joseph Alexeevich's house and keeping his
name secret. Then during the first day spent in inaction and
solitude (he tried several times to fix his attention on the Masonic
manuscripts, but was unable to do so) the idea that had previously
occurred to him of the cabalistic significance of his name in
connection with Bonaparte's more than once vaguely presented itself.
But the idea that he, L'russe Besuhof, was destined to set a limit
to the power of the Beast was as yet only one of the fancies that
often passed through his mind and left no trace behind.

When, having bought the coat merely with the object of taking part
among the people in the defense of Moscow, Pierre had met the
Rostovs and Natasha had said to him: "Are you remaining in
Moscow?... How splendid!" the thought flashed into his mind that it
really would be a good thing, even if Moscow were taken, for him to
remain there and do what he was predestined to do.

Next day, with the sole idea of not sparing himself and not
lagging in any way behind them, Pierre went to the Three Hills gate.
But when he returned to the house convinced that Moscow would not be
defended, he suddenly felt that what before had seemed to him merely a
possibility had now become absolutely necessary and inevitable. He
must remain in Moscow, concealing his name, and must meet Napoleon and
kill him, and either perish or put an end to the misery of all Europe-
which it seemed to him was solely due to Napoleon.

Pierre knew all the details of the attempt on Bonaparte's life in
1809 by a German student in Vienna, and knew that the student had been
shot. And the risk to which he would expose his life by carrying out
his design excited him still more.

Two equally strong feelings drew Pierre irresistibly to this
purpose. The first was a feeling of the necessity of sacrifice and
suffering in view of the common calamity, the same feeling that had
caused him to go to Mozhaysk on the twenty-fifth and to make his way
to the very thick of the battle and had now caused him to run away
from his home and, in place of the luxury and comfort to which he
was accustomed, to sleep on a hard sofa without undressing and eat the
same food as Gerasim. The other was that vague and quite Russian
feeling of contempt for everything conventional, artificial, and
human--for everything the majority of men regard as the greatest
good in the world. Pierre had first experienced this strange and
fascinating feeling at the Sloboda Palace, when he had suddenly felt
that wealth, power, and life--all that men so painstakingly acquire
and guard--if it has any worth has so only by reason the joy with
which it can all be renounced.

It was the feeling that induces a volunteer recruit to spend his
last penny on drink, and a drunken man to smash mirrors or glasses for
no apparent reason and knowing that it will cost him all the money
he possesses: the feeling which causes a man to perform actions
which from an ordinary point of view are insane, to test, as it
were, his personal power and strength, affirming the existence of a
higher, nonhuman criterion of life.

From the very day Pierre had experienced this feeling for the
first time at the Sloboda Palace he had been continuously under its
influence, but only now found full satisfaction for it. Moreover, at
this moment Pierre was supported in his design and prevented from
renouncing it by what he had already done in that direction. If he
were now to leave Moscow like everyone else, his flight from home, the
peasant coat, the pistol, and his announcement to the Rostovs that
he would remain in Moscow would all become not merely meaningless
but contemptible and ridiculous, and to this Pierre was very
sensitive.

Pierre's physical condition, as is always the case, corresponded
to his mental state. The unaccustomed coarse food, the vodka he
drank during those days, the absence of wine and cigars, his dirty
unchanged linen, two almost sleepless nights passed on a short sofa
without bedding--all this kept him in a state of excitement
bordering on insanity.

It was two o'clock in the afternoon. The French had already
entered Moscow. Pierre knew this, but instead of acting he only
thought about his undertaking, going over its minutest details in
his mind. In his fancy he did not clearly picture to himself either
the striking of the blow or the death of Napoleon, but with
extraordinary vividness and melancholy enjoyment imagined his own
destruction and heroic endurance.

"Yes, alone, for the sake of all, I must do it or perish!" he
thought. "Yes, I will approach... and then suddenly... with pistol
or dagger? But that is all the same! 'It is not I but the hand of
Providence that punishes thee,' I shall say," thought he, imagining
what he would say when killing Napoleon. "Well then, take me and
execute me!" he went on, speaking to himself and bowing his head
with a sad but firm expression.

While Pierre, standing in the middle of the room, was talking to
himself in this way, the study door opened and on the threshold
appeared the figure of Makar Alexeevich, always so timid before but
now quite transformed.

His dressing gown was unfastened, his face red and distorted. He was
obviously drunk. On seeing Pierre he grew confused at first, but
noticing embarrassment on Pierre's face immediately grew bold and,
staggering on his thin legs, advanced into the middle of the room.

"They're frightened," he said confidentially in a hoarse voice. "I
say I won't surrender, I say... Am I not right, sir?"

He paused and then suddenly seeing the pistol on the table seized it
with unexpected rapidity and ran out into the corridor.

Gerasim and the porter, who had followed Makar Alexeevich, stopped
him in the vestibule and tried to take the pistol from him. Pierre,
coming out into the corridor, looked with pity and repulsion at the
half-crazy old man. Makar Alexeevich, frowning with exertion, held
on to the pistol and screamed hoarsely, evidently with some heroic
fancy in his head.

"To arms! Board them! No, you shan't get it," he yelled.

"That will do, please, that will do. Have the goodness--please, sir,
to let go! Please, sir..." pleaded Gerasim, trying carefully to
steer Makar Alexeevich by the elbows back to the door.

"Who are you? Bonaparte!..." shouted Makar Alexeevich.

"That's not right, sir. Come to your room, please, and rest. Allow
me to have the pistol."

"Be off, thou base slave! Touch me not! See this?" shouted Makar
Alexeevich, brandishing the pistol. "Board them!"

"Catch hold!" whispered Gerasim to the porter.

They seized Makar Alexeevich by the arms and dragged him to the
door.

The vestibule was filled with the discordant sounds of a struggle
and of a tipsy, hoarse voice.

Suddenly a fresh sound, a piercing feminine scream, reverberated
from the porch and the cook came running into the vestibule.

"It's them! Gracious heavens! O Lord, four of them, horsemen!" she
cried.

Gerasim and the porter let Makar Alexeevich go, and in the now
silent corridor the sound of several hands knocking at the front
door could be heard.





CHAPTER XXVIII


Pierre, having decided that until he had carried out his design he
would disclose neither his identity nor his knowledge of French, stood
at the half-open door of the corridor, intending to conceal himself as
soon as the French entered. But the French entered and still Pierre
did not retire--an irresistible curiosity kept him there.

There were two of them. One was an officer--a tall, soldierly,
handsome man--the other evidently a private or an orderly,
sunburned, short, and thin, with sunken cheeks and a dull
expression. The officer walked in front, leaning on a stick and
slightly limping. When he had advanced a few steps he stopped,
having apparently decided that these were good quarters, turned
round to the soldiers standing at the entrance, and in a loud voice of
command ordered them to put up the horses. Having done that, the
officer, lifting his elbow with a smart gesture, stroked his
mustache and lightly touched his hat.

"Bonjour, la compagnie!"* said he gaily, smiling and looking about
him.


*"Good day, everybody!"


No one gave any reply.

"Vous etes le bourgeois?"* the officer asked Gerasim.


*"Are you the master here?"


Gerasim gazed at the officer with an alarmed and inquiring look.

"Quartier, quartier, logement!" said the officer, looking down at
the little man with a condescending and good-natured smile. "Les
francais sont de bons enfants. Que diable! Voyons! Ne nous fachons
pas, mon vieux!"* added he, clapping the scared and silent Gerasim
on the shoulder. "Well, does no one speak French in this
establishment?" he asked again in French, looking around and meeting
Pierre's eyes. Pierre moved away from the door.


*"Quarters, quarters, lodgings! The French are good fellows. What
the devil! There, don't let us be cross, old fellow!"


Again the officer turned to Gerasim and asked him to show him the
rooms in the house.

"Master, not here--don't understand... me, you..." said Gerasim,
trying to render his words more comprehensible by contorting them.

Still smiling, the French officer spread out his hands before
Gerasim's nose, intimating that he did not understand him either,
and moved, limping, to the door at which Pierre was standing. Pierre
wished to go away and conceal himself, but at that moment he saw Makar
Alexeevich appearing at the open kitchen door with the pistol in his
hand. With a madman's cunning, Makar Alexeevich eyed the Frenchman,
raised his pistol, and took aim.

"Board them!" yelled the tipsy man, trying to press the trigger.
Hearing the yell the officer turned round, and at the same moment
Pierre threw himself on the drunkard. Just when Pierre snatched at and
struck up the pistol Makar Alexeevich at last got his fingers on the
trigger, there was a deafening report, and all were enveloped in a
cloud of smoke. The Frenchman turned pale and rushed to the door.

Forgetting his intention of concealing his knowledge of French,
Pierre, snatching away the pistol and throwing it down, ran up to
the officer and addressed him in French.

"You are not wounded?" he asked.

"I think not," answered the Frenchman, feeling himself over. "But
I have had a lucky escape this time," he added, pointing to the
damaged plaster of the wall. "Who is that man?" said he, looking
sternly at Pierre.

"Oh, I am really in despair at what has occurred," said Pierre
rapidly, quite forgetting the part he had intended to play. "He is
an unfortunate madman who did not know what he was doing."

The officer went up to Makar Alexeevich and took him by the collar.

Makar Alexeevich was standing with parted lips, swaying, as if about
to fall asleep, as he leaned against the wall.

"Brigand! You shall pay for this," said the Frenchman, letting go of
him. "We French are merciful after victory, but we do not pardon
traitors," he added, with a look of gloomy dignity and a fine
energetic gesture.

Pierre continued, in French, to persuade the officer not to hold
that drunken imbecile to account. The Frenchman listened in silence
with the same gloomy expression, but suddenly turned to Pierre with
a smile. For a few seconds he looked at him in silence. His handsome
face assumed a melodramatically gentle expression and he held out
his hand.

"You have saved my life. You are French," said he.

For a Frenchman that deduction was indubitable. Only a Frenchman
could perform a great deed, and to save his life--the life of M.
Ramballe, captain of the 13th Light Regiment--was undoubtedly a very
great deed.

But however indubitable that conclusion and the officer's conviction
based upon it, Pierre felt it necessary to disillusion him.

"I am Russian," he said quickly.

"Tut, tut, tut! Tell that to others," said the officer, waving his
finger before his nose and smiling. "You shall tell me all about
that presently. I am delighted to meet a compatriot. Well, and what
are we to do with this man?" he added, addressing himself to Pierre as
to a brother.

Even if Pierre were not a Frenchman, having once received that
loftiest of human appellations he could not renounce it, said the
officer's look and tone. In reply to his last question Pierre again
explained who Makar Alexeevich was and how just before their arrival
that drunken imbecile had seized the loaded pistol which they had
not had time to recover from him, and begged the officer to let the
deed go unpunished.

The Frenchman expanded his chest and made a majestic gesture with
his arm.

"You have saved my life! You are French. You ask his pardon? I grant
it you. Lead that man away!" said he quickly and energetically, and
taking the arm of Pierre whom he had promoted to be a Frenchman for
saving his life, he went with him into the room.

The soldiers in the yard, hearing the shot, came into the passage
asking what had happened, and expressed their readiness to punish
the culprits, but the officer sternly checked them.

"You will be called in when you are wanted," he said.

The soldiers went out again, and the orderly, who had meanwhile
had time to visit the kitchen, came up to his officer.

"Captain, there is soup and a leg of mutton in the kitchen," said
he. "Shall I serve them up?"

"Yes, and some wine," answered the captain.





CHAPTER XXIX


When the French officer went into the room with Pierre the latter
again thought it his duty to assure him that he was not French and
wished to go away, but the officer would not hear of it. He was so
very polite, amiable, good-natured, and genuinely grateful to Pierre
for saving his life that Pierre had not the heart to refuse, and sat
down with him in the parlor--the first room they entered. To
Pierre's assurances that he was not a Frenchman, the captain,
evidently not understanding how anyone could decline so flattering
an appellation, shrugged his shoulders and said that if Pierre
absolutely insisted on passing for a Russian let it be so, but for all
that he would be forever bound to Pierre by gratitude for saving his
life.

Had this man been endowed with the slightest capacity for perceiving
the feelings of others, and had he at all understood what Pierre's
feelings were, the latter would probably have left him, but the
man's animated obtuseness to everything other than himself disarmed
Pierre.

"A Frenchman or a Russian prince incognito," said the officer,
looking at Pierre's fine though dirty linen and at the ring on his
finger. "I owe my life to you and offer you my friendship. A Frenchman
never forgets either an insult or a service. I offer you my
friendship. That is all I can say."

There was so much good nature and nobility (in the French sense of
the word) in the officer's voice, in the expression of his face and in
his gestures, that Pierre, unconsciously smiling in response to the
Frenchman's smile, pressed the hand held out to him.

"Captain Ramballe, of the 13th Light Regiment, Chevalier of the
Legion of Honor for the affair on the seventh of September," he
introduced himself, a self-satisfied irrepressible smile puckering his
lips under his mustache. "Will you now be so good as to tell me with
whom I have the honor of conversing so pleasantly, instead of being in
the ambulance with that maniac's bullet in my body?"

Pierre replied that he could not tell him his name and, blushing,
began to try to invent a name and to say something about his reason
for concealing it, but the Frenchman hastily interrupted him.

"Oh, please!" said he. "I understand your reasons. You are an
officer... a superior officer perhaps. You have borne arms against us.
That's not my business. I owe you my life. That is enough for me. I am
quite at your service. You belong to the gentry?" he concluded with
a shade of inquiry in his tone. Pierre bent his head. "Your
baptismal name, if you please. That is all I ask. Monsieur Pierre, you
say.... That's all I want to know."

When the mutton and an omelet had been served and a samovar and
vodka brought, with some wine which the French had taken from a
Russian cellar and brought with them, Ramballe invited Pierre to share
his dinner, and himself began to eat greedily and quickly like a
healthy and hungry man, munching his food rapidly with his strong
teeth, continually smacking his lips, and repeating--"Excellent!
Delicious!" His face grew red and was covered with perspiration.
Pierre was hungry and shared the dinner with pleasure. Morel, the
orderly, brought some hot water in a saucepan and placed a bottle of
claret in it. He also brought a bottle of kvass, taken from the
kitchen for them to try. That beverage was already known to the French
and had been given a special name. They called it limonade de cochon
(pig's lemonade), and Morel spoke well of the limonade de cochon he
had found in the kitchen. But as the captain had the wine they had
taken while passing through Moscow, he left the kvass to Morel and
applied himself to the bottle of Bordeaux. He wrapped the bottle up to
its neck in a table napkin and poured out wine for himself and for
Pierre. The satisfaction of his hunger and the wine rendered the
captain still more lively and he chatted incessantly all through
dinner.

"Yes, my dear Monsieur Pierre, I owe you a fine votive candle for
saving me from that maniac.... You see, I have bullets enough in my
body already. Here is one I got at Wagram" (he touched his side)
"and a second at Smolensk"--he showed a scar on his cheek--"and this
leg which as you see does not want to march, I got that on the seventh
at the great battle of la Moskowa. Sacre Dieu! It was splendid! That
deluge of fire was worth seeing. It was a tough job you set us
there, my word! You may be proud of it! And on my honor, in spite of
the cough I caught there, I should be ready to begin again. I pity
those who did not see it."

"I was there," said Pierre.

"Bah, really? So much the better! You are certainly brave foes.
The great redoubt held out well, by my pipe!" continued the Frenchman.
"And you made us pay dear for it. I was at it three times--sure as I
sit here. Three times we reached the guns and three times we were
thrown back like cardboard figures. Oh, it was beautiful, Monsieur
Pierre! Your grenadiers were splendid, by heaven! I saw them close
up their ranks six times in succession and march as if on parade. Fine
fellows! Our King of Naples, who knows what's what, cried 'Bravo!' Ha,
ha! So you are one of us soldiers!" he added, smiling, after a
momentary pause. "So much the better, so much the better, Monsieur
Pierre! Terrible in battle... gallant... with the fair" (he winked and
smiled), "that's what the French are, Monsieur Pierre, aren't they?"

The captain was so naively and good-humoredly gay, so real, and so
pleased with himself that Pierre almost winked back as he looked
merrily at him. Probably the word "gallant" turned the captain's
thoughts to the state of Moscow.

"Apropos, tell me please, is it true that the women have all left
Moscow? What a queer idea! What had they to be afraid of?"

"Would not the French ladies leave Paris if the Russians entered
it?" asked Pierre.

"Ha, ha, ha!" The Frenchman emitted a merry, sanguine chuckle,
patting Pierre on the shoulder. "What a thing to say!" he exclaimed.
"Paris?... But Paris, Paris..."

"Paris--the capital of the world," Pierre finished his remark for
him.

The captain looked at Pierre. He had a habit of stopping short in
the middle of his talk and gazing intently with his laughing, kindly
eyes.

"Well, if you hadn't told me you were Russian, I should have wagered
that you were Parisian! You have that... I don't know what, that..."
and having uttered this compliment, he again gazed at him in silence.

"I have been in Paris. I spent years there," said Pierre.

"Oh yes, one sees that plainly. Paris!... A man who doesn't know
Paris is a savage. You can tell a Parisian two leagues off. Paris is
Talma, la Duchenois, Potier, the Sorbonne, the boulevards," and
noticing that his conclusion was weaker than what had gone before,
he added quickly: "There is only one Paris in the world. You have been
to Paris and have remained Russian. Well, I don't esteem you the
less for it."

Under the influence of the wine he had drunk, and after the days
he had spent alone with his depressing thoughts, Pierre
involuntarily enjoyed talking with this cheerful and good-natured man.

"To return to your ladies--I hear they are lovely. What a wretched
idea to go and bury themselves in the steppes when the French army
is in Moscow. What a chance those girls have missed! Your peasants,
now--that's another thing; but you civilized people, you ought to know
us better than that. We took Vienna, Berlin, Madrid, Naples, Rome,
Warsaw, all the world's capitals.... We are feared, but we are
loved. We are nice to know. And then the Emperor..." he began, but
Pierre interrupted him.

"The Emperor," Pierre repeated, and his face suddenly became sad and
embarrassed, "is the Emperor...?"

"The Emperor? He is generosity, mercy, justice, order, genius-
that's what the Emperor is! It is I, Ramballe, who tell you so.... I
assure you I was his enemy eight years ago. My father was an
emigrant count.... But that man has vanquished me. He has taken hold
of me. I could not resist the sight of the grandeur and glory with
which he has covered France. When I understood what he wanted--when
I saw that he was preparing a bed of laurels for us, you know, I
said to myself: 'That is a monarch,' and I devoted myself to him! So
there! Oh yes, mon cher, he is the greatest man of the ages past or
future."

"Is he in Moscow?" Pierre stammered with a guilty look.

The Frenchman looked at his guilty face and smiled.

"No, he will make his entry tomorrow," he replied, and continued his
talk.

Their conversation was interrupted by the cries of several voices at
the gate and by Morel, who came to say that some Wurttemberg hussars
had come and wanted to put up their horses in the yard where the
captain's horses were. This difficulty had arisen chiefly because
the hussars did not understand what was said to them in French.

The captain had their senior sergeant called in, and in a stern
voice asked him to what regiment he belonged, who was his commanding
officer, and by what right he allowed himself to claim quarters that
were already occupied. The German who knew little French, answered the
two first questions by giving the names of his regiment and of his
commanding officer, but in reply to the third question which he did
not understand said, introducing broken French into his own German,
that he was the quartermaster of the regiment and his commander had
ordered him to occupy all the houses one after another. Pierre, who
knew German, translated what the German said to the captain and gave
the captain's reply to the Wurttemberg hussar in German. When he had
understood what was said to him, the German submitted and took his men
elsewhere. The captain went out into the porch and gave some orders in
a loud voice.

When he returned to the room Pierre was sitting in the same place as
before, with his head in his hands. His face expressed suffering. He
really was suffering at that moment. When the captain went out and
he was left alone, suddenly he came to himself and realized the
position he was in. It was not that Moscow had been taken or that
the happy conquerors were masters in it and were patronizing him.
Painful as that was it was not that which tormented Pierre at the
moment. He was tormented by the consciousness of his own weakness. The
few glasses of wine he had drunk and the conversation with this
good-natured man had destroyed the mood of concentrated gloom in which
he had spent the last few days and which was essential for the
execution of his design. The pistol, dagger, and peasant coat were
ready. Napoleon was to enter the town next day. Pierre still
considered that it would be a useful and worthy action to slay the
evildoer, but now he felt that he would not do it. He did not know
why, but he felt a foreboding that he would not carry out his
intention. He struggled against the confession of his weakness but
dimly felt that he could not overcome it and that his former gloomy
frame of mind, concerning vengeance, killing, and self-sacrifice,
had been dispersed like dust by contact with the first man he met.

The captain returned to the room, limping slightly and whistling a
tune.

The Frenchman's chatter which had previously amused Pierre now
repelled him. The tune he was whistling, his gait, and the gesture
with which he twirled his mustache, all now seemed offensive. "I
will go away immediately. I won't say another word to him," thought
Pierre. He thought this, but still sat in the same place. A strange
feeling of weakness tied him to the spot; he wished to get up and go
away, but could not do so.

The captain, on the other hand, seemed very cheerful. He paced up
and down the room twice. His eyes shone and his mustache twitched as
if he were smiling to himself at some amusing thought.

"The colonel of those Wurttembergers is delightful," he suddenly
said. "He's a German, but a nice fellow all the same.... But he's a
German." He sat down facing Pierre. "By the way, you know German,
then?"

Pierre looked at him in silence.

"What is the German for 'shelter'?"

"Shelter?" Pierre repeated. "The German for shelter is Unterkunft."

"How do you say it?" the captain asked quickly and doubtfully.

"Unterkunft," Pierre repeated.

"Onterkoff," said the captain and looked at Pierre for some
seconds with laughing eyes. "These Germans are first-rate fools, don't
you think so, Monsieur Pierre?" he concluded.

"Well, let's have another bottle of this Moscow Bordeaux, shall
we? Morel will warm us up another little bottle. Morel!" he called out
gaily.

Morel brought candles and a bottle of wine. The captain looked at
Pierre by the candlelight and was evidently struck by the troubled
expression on his companion's face. Ramballe, with genuine distress
and sympathy in his face, went up to Pierre and bent over him.

"There now, we're sad," said he, touching Pierre's hand. "Have I
upset you? No, really, have you anything against me?" he asked Pierre.
"Perhaps it's the state of affairs?"

Pierre did not answer, but looked cordially into the Frenchman's
eyes whose expression of sympathy was pleasing to him.

"Honestly, without speaking of what I owe you, I feel friendship for
you. Can I do anything for you? Dispose of me. It is for life and
death. I say it with my hand on my heart!" said he, striking his
chest.

"Thank you," said Pierre.

The captain gazed intently at him as he had done when he learned
that "shelter" was Unterkunft in German, and his face suddenly
brightened.

"Well, in that case, I drink to our friendship!" he cried gaily,
filling two glasses with wine.

Pierre took one of the glasses and emptied it. Ramballe emptied
his too, again pressed Pierre's hand, and leaned his elbows on the
table in a pensive attitude.

"Yes, my dear friend," he began, "such is fortune's caprice. Who
would have said that I should be a soldier and a captain of dragoons
in the service of Bonaparte, as we used to call him? Yet here I am
in Moscow with him. I must tell you, mon cher," he continued in the
sad and measured tones of a man who intends to tell a long story,
"that our name is one of the most ancient in France."

And with a Frenchman's easy and naive frankness the captain told
Pierre the story of his ancestors, his childhood, youth, and
manhood, and all about his relations and his financial and family
affairs, "ma pauvre mere" playing of course an important part in the
story.

"But all that is only life's setting, the real thing is love-
love! Am I not right, Monsieur Pierre?" said he, growing animated.
"Another glass?"

Pierre again emptied his glass and poured himself out a third.

"Oh, women, women!" and the captain, looking with glistening eyes at
Pierre, began talking of love and of his love affairs.

There were very many of these, as one could easily believe,
looking at the officer's handsome, self-satisfied face, and noting the
eager enthusiasm with which he spoke of women. Though all Ramballe's
love stories had the sensual character which Frenchmen regard as the
special charm and poetry of love, yet he told his story with such
sincere conviction that he alone had experienced and known all the
charm of love and he described women so alluringly that Pierre
listened to him with curiosity.

It was plain that l'amour which the Frenchman was so fond of was not
that low and simple kind that Pierre had once felt for his wife, nor
was it the romantic love stimulated by himself that he experienced for
Natasha. (Ramballe despised both these kinds of love equally: the
one he considered the "love of clodhoppers" and the other the "love of
simpletons.") L'amour which the Frenchman worshiped consisted
principally in the unnaturalness of his relation to the woman and in a
combination of incongruities giving the chief charm to the feeling.

Thus the captain touchingly recounted the story of his love for a
fascinating marquise of thirty-five and at the same time for a
charming, innocent child of seventeen, daughter of the bewitching
marquise. The conflict of magnanimity between the mother and the
daughter, ending in the mother's sacrificing herself and offering
her daughter in marriage to her lover, even now agitated the
captain, though it was the memory of a distant past. Then he recounted
an episode in which the husband played the part of the lover, and
he--the lover--assumed the role of the husband, as well as several
droll incidents from his recollections of Germany, where "shelter"
is called Unterkunft and where the husbands eat sauerkraut and the
young girls are "too blonde."

Finally, the latest episode in Poland still fresh in the captain's
memory, and which he narrated with rapid gestures and glowing face,
was of how he had saved the life of a Pole (in general, the saving
of life continually occurred in the captain's stories) and the Pole
had entrusted to him his enchanting wife (parisienne de coeur) while
himself entering the French service. The captain was happy, the
enchanting Polish lady wished to elope with him, but, prompted by
magnanimity, the captain restored the wife to the husband, saying as
he did so: "I have saved your life, and I save your honor!" Having
repeated these words the captain wiped his eyes and gave himself a
shake, as if driving away the weakness which assailed him at this
touching recollection.

Listening to the captain's tales, Pierre--as often happens late in
the evening and under the influence of wine--followed all that was
told him, understood it all, and at the same time followed a train
of personal memories which, he knew not why, suddenly arose in his
mind. While listening to these love stories his own love for Natasha
unexpectedly rose to his mind, and going over the pictures of that
love in his imagination he mentally compared them with Ramballe's
tales. Listening to the story of the struggle between love and duty,
Pierre saw before his eyes every minutest detail of his last meeting
with the object of his love at the Sukharev water tower. At the time
of that meeting it had not produced an effect upon him--he had not
even once recalled it. But now it seemed to him that that meeting
had had in it something very important and poetic.

"Peter Kirilovich, come here! We have recognized you," he now seemed
to hear the words she had uttered and to see before him her eyes,
her smile, her traveling hood, and a stray lock of her hair... and
there seemed to him something pathetic and touching in all this.

Having finished his tale about the enchanting Polish lady, the
captain asked Pierre if he had ever experienced a similar impulse to
sacrifice himself for love and a feeling of envy of the legitimate
husband.

Challenged by this question Pierre raised his head and felt a need
to express the thoughts that filled his mind. He began to explain that
he understood love for a women somewhat differently. He said that in
all his life he had loved and still loved only one woman, and that she
could never be his.

"Tiens!" said the captain.

Pierre then explained that he had loved this woman from his earliest
years, but that he had not dared to think of her because she was too
young, and because he had been an illegitimate son without a name.
Afterwards when he had received a name and wealth he dared not think
of her because he loved her too well, placing her far above everything
in the world, and especially therefore above himself.

When he had reached this point, Pierre asked the captain whether
he understood that.

The captain made a gesture signifying that even if he did not
understand it he begged Pierre to continue.

"Platonic love, clouds..." he muttered.

Whether it was the wine he had drunk, or an impulse of frankness, or
the thought that this man did not, and never would, know any of
those who played a part in his story, or whether it was all these
things together, something loosened Pierre's tongue. Speaking
thickly and with a faraway look in his shining eyes, he told the whole
story of his life: his marriage, Natasha's love for his best friend,
her betrayal of him, and all his own simple relations with her.
Urged on by Ramballe's questions he also told what he had at first
concealed--his own position and even his name.

More than anything else in Pierre's story the captain was
impressed by the fact that Pierre was very rich, had two mansions in
Moscow, and that he had abandoned everything and not left the city,
but remained there concealing his name and station.

When it was late at night they went out together into the street.
The night was warm and light. To the left of the house on the Pokrovka
a fire glowed--the first of those that were beginning in Moscow. To
the right and high up in the sky was the sickle of the waning moon and
opposite to it hung that bright comet which was connected in
Pierre's heart with his love. At the gate stood Gerasim, the cook, and
two Frenchmen. Their laughter and their mutually incomprehensible
remarks in two languages could be heard. They were looking at the glow
seen in the town.

There was nothing terrible in the one small, distant fire in the
immense city.

Gazing at the high starry sky, at the moon, at the comet, and at the
glow from the fire, Pierre experienced a joyful emotion. "There now,
how good it is, what more does one need?" thought he. And suddenly
remembering his intention he grew dizzy and felt so faint that he
leaned against the fence to save himself from falling.

Without taking leave of his new friend, Pierre left the gate with
unsteady steps and returning to his room lay down on the sofa and
immediately fell asleep.





CHAPTER XXX


The glow of the first fire that began on the second of September was
watched from the various roads by the fugitive Muscovites and by the
retreating troops, with many different feelings.

The Rostov party spent the night at Mytishchi, fourteen miles from
Moscow. They had started so late on the first of September, the road
had been so blocked by vehicles and troops, so many things had been
forgotten for which servants were sent back, that they had decided
to spend that night at a place three miles out of Moscow. The next
morning they woke late and were again delayed so often that they
only got as far as Great Mytishchi. At ten o'clock that evening the
Rostov family and the wounded traveling with them were all distributed
in the yards and huts of that large village. The Rostovs' servants and
coachmen and the orderlies of the wounded officers, after attending to
their masters, had supper, fed the horses, and came out into the
porches.

In a neighboring hut lay Raevski's adjutant with a fractured
wrist. The awful pain he suffered made him moan incessantly and
piteously, and his moaning sounded terrible in the darkness of the
autumn night. He had spent the first night in the same yard as the
Rostovs. The countess said she had been unable to close her eyes on
account of his moaning, and at Mytishchi she moved into a worse hut
simply to be farther away from the wounded man.

In the darkness of the night one of the servants noticed, above
the high body of a coach standing before the porch, the small glow
of another fire. One glow had long been visible and everybody knew
that it was Little Mytishchi burning--set on fire by Mamonov's
Cossacks.

"But look here, brothers, there's another fire!" remarked an
orderly.

All turned their attention to the glow.

"But they told us Little Mytishchi had been set on fire by Mamonov's
Cossacks."

"But that's not Mytishchi, it's farther away."

"Look, it must be in Moscow!"

Two of the gazers went round to the other side of the coach and
sat down on its steps.

"It's more to the left, why, Little Mytishchi is over there, and
this is right on the other side."

Several men joined the first two.

"See how it's flaring," said one. "That's a fire in Moscow: either
in the Sushchevski or the Rogozhski quarter."

No one replied to this remark and for some time they all gazed
silently at the spreading flames of the second fire in the distance.

Old Daniel Terentich, the count's valet (as he was called), came
up to the group and shouted at Mishka.

"What are you staring at, you good-for-nothing?... The count will be
calling and there's nobody there; go and gather the clothes together."

"I only ran out to get some water," said Mishka.

"But what do you think, Daniel Terentich? Doesn't it look as if that
glow were in Moscow?" remarked one of the footmen.

Daniel Terentich made no reply, and again for a long time they
were all silent. The glow spread, rising and failing, farther and
farther still.

"God have mercy.... It's windy and dry..." said another voice.

"Just look! See what it's doing now. O Lord! You can even see the
crows flying. Lord have mercy on us sinners!"

"They'll put it out, no fear!"

"Who's to put it out?" Daniel Terentich, who had hitherto been
silent, was heard to say. His voice was calm and deliberate. "Moscow
it is, brothers," said he. "Mother Moscow, the white..." his voice
faltered, and he gave way to an old man's sob.

And it was as if they had all only waited for this to realize the
significance for them of the glow they were watching. Sighs were
heard, words of prayer, and the sobbing of the count's old valet.





CHAPTER XXXI


The valet, returning to the cottage, informed the count that
Moscow was burning. The count donned his dressing gown and went out to
look. Sonya and Madame Schoss, who had not yet undressed, went out
with him. Only Natasha and the countess remained in the room. Petya
was no longer with the family, he had gone on with his regiment
which was making for Troitsa.

The countess, on hearing that Moscow was on fire, began to cry.
Natasha, pale, with a fixed look, was sitting on the bench under the
icons just where she had sat down on arriving and paid no attention to
her father's words. She was listening to the ceaseless moaning of
the adjutant, three houses off.

"Oh, how terrible," said Sonya returning from the yard chilled and
frightened. "I believe the whole of Moscow will burn, there's an awful
glow! Natasha, do look! You can see it from the window," she said to
her cousin, evidently wishing to distract her mind.

But Natasha looked at her as if not understanding what was said to
her and again fixed her eyes on the corner of the stove. She had
been in this condition of stupor since the morning, when Sonya, to the
surprise and annoyance of the countess, had for some unaccountable
reason found it necessary to tell Natasha of Prince Andrew's wound and
of his being with their party. The countess had seldom been so angry
with anyone as she was with Sonya. Sonya had cried and begged to be
forgiven and now, as if trying to atone for her fault, paid
unceasing attention to her cousin.

"Look, Natasha, how dreadfully it is burning!" said she.

"What's burning?" asked Natasha. "Oh, yes, Moscow."

And as if in order not to offend Sonya and to get rid of her, she
turned her face to the window, looked out in such a way that it was
evident that she could not see anything, and again settled down in her
former attitude.

"But you didn't see it!"

"Yes, really I did," Natasha replied in a voice that pleaded to be
left in peace.

Both the countess and Sonya understood that, naturally, neither
Moscow nor the burning of Moscow nor anything else could seem of
importance to Natasha.

The count returned and lay down behind the partition. The countess
went up to her daughter and touched her head with the back of her hand
as she was wont to do when Natasha was ill, then touched her
forehead with her lips as if to feel whether she was feverish, and
finally kissed her.

"You are cold. You are trembling all over. You'd better lie down,"
said the countess.

"Lie down? All right, I will. I'll lie down at once," said Natasha.

When Natasha had been told that morning that Prince Andrew was
seriously wounded and was traveling with their party, she had at first
asked many questions: Where was he going? How was he wounded? Was it
serious? And could she see him? But after she had been told that she
could not see him, that he was seriously wounded but that his life was
not in danger, she ceased to ask questions or to speak at all,
evidently disbelieving what they told her, and convinced that say what
she might she would still be told the same. All the way she had sat
motionless in a corner of the coach with wide open eyes, and the
expression in them which the countess knew so well and feared so much,
and now she sat in the same way on the bench where she had seated
herself on arriving. She was planning something and either deciding or
had already decided something in her mind. The countess knew this, but
what it might be she did not know, and this alarmed and tormented her.

"Natasha, undress, darling; lie down on my bed."

A bed had been made on a bedstead for the countess only. Madame
Schoss and the two girls were to sleep on some hay on the floor.

"No, Mamma, I will lie down here on the floor," Natasha replied
irritably and she went to the window and opened it. Through the open
window the moans of the adjutant could be heard more distinctly. She
put her head out into the damp night air, and the countess saw her
slim neck shaking with sobs and throbbing against the window frame.
Natasha knew it was not Prince Andrew who was moaning. She knew Prince
Andrew was in the same yard as themselves and in a part of the hut
across the passage; but this dreadful incessant moaning made her
sob. The countess exchanged a look with Sonya.

"Lie down, darling; lie down, my pet," said the countess, softly
touching Natasha's shoulders. "Come, lie down."

"Oh, yes... I'll lie down at once," said Natasha, and began
hurriedly undressing, tugging at the tapes of her petticoat.

When she had thrown off her dress and put on a dressing jacket,
she sat down with her foot under her on the bed that had been made
up on the floor, jerked her thin and rather short plait of hair to the
front, and began replaiting it. Her long, thin, practiced fingers
rapidly unplaited, replaited, and tied up her plait. Her head moved
from side to side from habit, but her eyes, feverishly wide, looked
fixedly before her. When her toilet for the night was finished she
sank gently onto the sheet spread over the hay on the side nearest the
door.

"Natasha, you'd better lie in the middle," said Sonya.

"I'll stay here," muttered Natasha. "Do lie down," she added
crossly, and buried her face in the pillow.

The countess, Madame Schoss, and Sonya undressed hastily and lay
down. The small lamp in front of the icons was the only light left
in the room. But in the yard there was a light from the fire at Little
Mytishchi a mile and a half away, and through the night came the noise
of people shouting at a tavern Mamonov's Cossacks had set up across
the street, and the adjutant's unceasing moans could still be heard.

For a long time Natasha listened attentively to the sounds that
reached her from inside and outside the room and did not move. First
she heard her mother praying and sighing and the creaking of her bed
under her, then Madame Schoss' familiar whistling snore and Sonya's
gentle breathing. Then the countess called to Natasha. Natasha did not
answer.

"I think she's asleep, Mamma," said Sonya softly.

After short silence the countess spoke again but this time no one
replied.

Soon after that Natasha heard her mother's even breathing. Natasha
did not move, though her little bare foot, thrust out from under the
quilt, was growing cold on the bare floor.

As if to celebrate a victory over everybody, a cricket chirped in
a crack in the wall. A cock crowed far off and another replied near
by. The shouting in the tavern had died down; only the moaning of
the adjutant was heard. Natasha sat up.

"Sonya, are you asleep? Mamma?" she whispered.

No one replied. Natasha rose slowly and carefully, crossed
herself, and stepped cautiously on the cold and dirty floor with her
slim, supple, bare feet. The boards of the floor creaked. Stepping
cautiously from one foot to the other she ran like a kitten the few
steps to the door and grasped the cold door handle.

It seemed to her that something heavy was beating rhythmically
against all the walls of the room: it was her own heart, sinking
with alarm and terror and overflowing with love.

She opened the door and stepped across the threshold and onto the
cold, damp earthen floor of the passage. The cold she felt refreshed
her. With her bare feet she touched a sleeping man, stepped over
him, and opened the door into the part of the hut where Prince
Andrew lay. It was dark in there. In the farthest corner, on a bench
beside a bed on which something was lying, stood a tallow candle
with a long, thick, and smoldering wick.

From the moment she had been told that of Prince Andrew's wound
and his presence there, Natasha had resolved to see him. She did not
know why she had to, she knew the meeting would be painful, but felt
the more convinced that it was necessary.

All day she had lived only in hope of seeing him that night. But now
that the moment had come she was filled with dread of what she might
see. How was he maimed? What was left of him? Was he like that
incessant moaning of the adjutant's? Yes, he was altogether like that.
In her imagination he was that terrible moaning personified. When
she saw an indistinct shape in the corner, and mistook his knees
raised under the quilt for his shoulders, she imagined a horrible body
there, and stood still in terror. But an irresistible impulse drew her
forward. She cautiously took one step and then another, and found
herself in the middle of a small room containing baggage. Another man-
Timokhin--was lying in a corner on the benches beneath the icons,
and two others--the doctor and a valet--lay on the floor.

The valet sat up and whispered something. Timokhin, kept awake by
the pain in his wounded leg, gazed with wide-open eyes at this strange
apparition of a girl in a white chemise, dressing jacket, and
nightcap. The valet's sleepy, frightened exclamation, "What do you
want? What's the matter?" made Natasha approach more swiftly to what
was lying in the corner. Horribly unlike a man as that body looked,
she must see him. She passed the valet, the snuff fell from the candle
wick, and she saw Prince Andrew clearly with his arms outside the
quilt, and such as she had always seen him.

He was the same as ever, but the feverish color of his face, his
glittering eyes rapturously turned toward her, and especially his
neck, delicate as a child's, revealed by the turn-down collar of his
shirt, gave him a peculiarly innocent, childlike look, such as she had
never seen on him before. She went up to him and with a swift,
flexible, youthful movement dropped on her knees.

He smiled and held out his hand to her.





CHAPTER XXXII


Seven days had passed since Prince Andrew found himself in the
ambulance station on the field of Borodino. His feverish state and the
inflammation of his bowels, which were injured, were in the doctor's

opinion sure to carry him off. But on the seventh day he ate with
pleasure a piece of bread with some tea, and the doctor noticed that
his temperature was lower. He had regained consciousness that morning.
The first night after they left Moscow had been fairly warm and he had
remained in the caleche, but at Mytishchi the wounded man himself
asked to be taken out and given some tea. The pain caused by his
removal into the hut had made him groan aloud and again lose
consciousness. When he had been placed on his camp bed he lay for a
long time motionless with closed eyes. Then he opened them and
whispered softly: "And the tea?" His remembering such a small detail
of everyday life astonished the doctor. He felt Prince Andrew's pulse,
and to his surprise and dissatisfaction found it had improved. He
was dissatisfied because he knew by experience that if his patient did
not die now, he would do so a little later with greater suffering.
Timokhin, the red-nosed major of Prince Andrew's regiment, had
joined him in Moscow and was being taken along with him, having been
wounded in the leg at the battle of Borodino. They were accompanied by
a doctor, Prince Andrew's valet, his coachman, and two orderlies.

They gave Prince Andrew some tea. He drank it eagerly, looking
with feverish eyes at the door in front of him as if trying to
understand and remember something.

"I don't want any more. Is Timokhin here?" he asked.

Timokhin crept along the bench to him.

"I am here, your excellency."

"How's your wound?"

"Mine, sir? All right. But how about you?"

Prince Andrew again pondered as if trying to remember something.

"Couldn't one get a book?" he asked.

"What book?"

"The Gospels. I haven't one."

The doctor promised to procure it for him and began to ask how he
was feeling. Prince Andrew answered all his questions reluctantly
but reasonably, and then said he wanted a bolster placed under him
as he was uncomfortable and in great pain. The doctor and valet lifted
the cloak with which he was covered and, making wry faces at the
noisome smell of mortifying flesh that came from the wound, began
examining that dreadful place. The doctor was very much displeased
about something and made a change in the dressings, turning the
wounded man over so that he groaned again and grew unconscious and
delirious from the agony. He kept asking them to get him the book
and put it under him.

"What trouble would it be to you?" he said. "I have not got one.
Please get it for me and put it under for a moment," he pleaded in a
piteous voice.

The doctor went into the passage to wash his hands.

"You fellows have no conscience," said he to the valet who was
pouring water over his hands. "For just one moment I didn't look after
you... It's such pain, you know, that I wonder how he can bear it."

"By the Lord Jesus Christ, I thought we had put something under
him!" said the valet.

The first time Prince Andrew understood where he was and what was
the matter with him and remembered being wounded and how was when he
asked to be carried into the hut after his caleche had stopped at
Mytishchi. After growing confused from pain while being carried into
the hut he again regained consciousness, and while drinking tea once
more recalled all that had happened to him, and above all vividly
remembered the moment at the ambulance station when, at the sight of
the sufferings of a man he disliked, those new thoughts had come to
him which promised him happiness. And those thoughts, though now vague
and indefinite, again possessed his soul. He remembered that he had
now a new source of happiness and that this happiness had something to
do with the Gospels. That was why he asked for a copy of them. The
uncomfortable position in which they had put him and turned him over
again confused his thoughts, and when he came to himself a third
time it was in the complete stillness of the night. Everybody near him
was sleeping. A cricket chirped from across the passage; someone was
shouting and singing in the street; cockroaches rustled on the
table, on the icons, and on the walls, and a big fly flopped at the
head of the bed and around the candle beside him, the wick of which
was charred and had shaped itself like a mushroom.

His mind was not in a normal state. A healthy man usually thinks of,
feels, and remembers innumerable things simultaneously, but has the
power and will to select one sequence of thoughts or events on which
to fix his whole attention. A healthy man can tear himself away from
the deepest reflections to say a civil word to someone who comes in
and can then return again to his own thoughts. But Prince Andrew's
mind was not in a normal state in that respect. All the powers of
his mind were more active and clearer than ever, but they acted
apart from his will. Most diverse thoughts and images occupied him
simultaneously. At times his brain suddenly began to work with a
vigor, clearness, and depth it had never reached when he was in
health, but suddenly in the midst of its work it would turn to some
unexpected idea and he had not the strength to turn it back again.

"Yes, a new happiness was revealed to me of which man cannot be
deprived," he thought as he lay in the semi-darkness of the quiet hut,
gazing fixedly before him with feverish wide open eyes. "A happiness
lying beyond material forces, outside the material influences that act
on man--a happiness of the soul alone, the happiness of loving.
Every man can understand it, but to conceive it and enjoin it was
possible only for God. But how did God enjoin that law? And why was
the Son...?"

And suddenly the sequence of these thoughts broke off, and Prince
Andrew heard (without knowing whether it was a delusion or reality)
a soft whispering voice incessantly and rhythmically repeating
"piti-piti-piti," and then "titi," and then again "piti-piti-piti,"
and "ti-ti" once more. At the same time he felt that above his face,
above the very middle of it, some strange airy structure was being
erected out of slender needles or splinters, to the sound of this
whispered music. He felt that he had to balance carefully (though it
was difficult) so that this airy structure should not collapse; but
nevertheless it kept collapsing and again slowly rising to the sound
of whispered rhythmic music--"it stretches, stretches, spreading out
and stretching," said Prince Andrew to himself. While listening to
this whispering and feeling the sensation of this drawing out and
the construction of this edifice of needles, he also saw by glimpses a
red halo round the candle, and heard the rustle of the cockroaches and
the buzzing of the fly that flopped against his pillow and his face.
Each time the fly touched his face it gave him a burning sensation and
yet to his surprise it did not destroy the structure, though it
knocked against the very region of his face where it was rising. But
besides this there was something else of importance. It was
something white by the door--the statue of a sphinx, which also
oppressed him.

"But perhaps that's my shirt on the table," he thought, "and
that's my legs, and that is the door, but why is it always
stretching and drawing itself out, and 'piti-piti-piti' and 'ti-ti'
and 'piti-piti-piti'...? That's enough, please leave off!" Prince
Andrew painfully entreated someone. And suddenly thoughts and feelings
again swam to the surface of his mind with peculiar clearness and
force.

"Yes--love," he thought again quite clearly. "But not love which
loves for something, for some quality, for some purpose, or for some
reason, but the love which I--while dying--first experienced when I
saw my enemy and yet loved him. I experienced that feeling of love
which is the very essence of the soul and does not require an
object. Now again I feel that bliss. To love one's neighbors, to
love one's enemies, to love everything, to love God in all His
manifestations. It is possible to love someone dear to you with
human love, but an enemy can only be loved by divine love. That is why
I experienced such joy when I felt that I loved that man. What has
become of him? Is he alive?...

"When loving with human love one may pass from love to hatred, but
divine love cannot change. No, neither death nor anything else can
destroy it. It is the very essence of the soul. Yet how many people
have I hated in my life? And of them all, I loved and hated none as
I did her." And he vividly pictured to himself Natasha, not as he
had done in the past with nothing but her charms which gave him
delight, but for the first time picturing to himself her soul. And
he understood her feelings, her sufferings, shame, and remorse. He now
understood for the first time all the cruelty of his rejection of her,
the cruelty of his rupture with her. "If only it were possible for
me to see her once more! Just once, looking into those eyes to say..."


"Piti-piti-piti and ti-ti and piti-piti-piti boom!" flopped the
fly... And his attention was suddenly carried into another world, a
world of reality and delirium in which something particular was
happening. In that world some structure was still being erected and
did not fall, something was still stretching out, and the candle
with its red halo was still burning, and the same shirtlike sphinx lay
near the door; but besides all this something creaked, there was a
whiff of fresh air, and a new white sphinx appeared, standing at the
door. And that sphinx had the pale face and shining eyes of the very
Natasha of whom he had just been thinking.

"Oh, how oppressive this continual delirium is," thought Prince
Andrew, trying to drive that face from his imagination. But the face
remained before him with the force of reality and drew nearer.
Prince Andrew wished to return that former world of pure thought,
but he could not, and delirium drew him back into its domain. The soft
whispering voice continued its rhythmic murmur, something oppressed
him and stretched out, and the strange face was before him. Prince
Andrew collected all his strength in an effort to recover his
senses, he moved a little, and suddenly there was a ringing in his
ears, a dimness in his eyes, and like a man plunged into water he lost
consciousness. When he came to himself, Natasha, that same living
Natasha whom of all people he most longed to love with this new pure
divine love that had been revealed to him, was kneeling before him. He
realized that it was the real living Natasha, and he was not surprised
but quietly happy. Natasha, motionless on her knees (she was unable to
stir), with frightened eyes riveted on him, was restraining her
sobs. Her face was pale and rigid. Only in the lower part of it
something quivered.

Prince Andrew sighed with relief, smiled, and held out his hand.

"You?" he said. "How fortunate!"

With a rapid but careful movement Natasha drew nearer to him on
her knees and, taking his hand carefully, bent her face over it and
began kissing it, just touching it lightly with her lips.

"Forgive me!" she whispered, raising her head and glancing at him.
"Forgive me!"

"I love you," said Prince Andrew.

"Forgive...!"

"Forgive what?" he asked.

"Forgive me for what I ha-ve do-ne!" faltered Natasha in a
scarcely audible, broken whisper, and began kissing his hand more
rapidly, just touching it with her lips.

"I love you more, better than before," said Prince Andrew, lifting
her face with his hand so as to look into her eyes.

Those eyes, filled with happy tears, gazed at him timidly,
compassionately, and with joyous love. Natasha's thin pale face,
with its swollen lips, was more than plain--it was dreadful. But
Prince Andrew did not see that, he saw her shining eyes which were
beautiful. They heard the sound of voices behind them.

Peter the valet, who was now wide awake, had roused the doctor.
Timokhin, who had not slept at all because of the pain in his leg, had
long been watching all that was going on, carefully covering his
bare body with the sheet as he huddled up on his bench.

"What's this?" said the doctor, rising from his bed. "Please go
away, madam!"

At that moment a maid sent by the countess, who had noticed her
daughter's absence, knocked at the door.

Like a somnambulist aroused from her sleep Natasha went out of the
room and, returning to her hut, fell sobbing on her bed.


From that time, during all the rest of the Rostovs' journey, at
every halting place and wherever they spent a night, Natasha never
left the wounded Bolkonski, and the doctor had to admit that he had
not expected from a young girl either such firmness or such skill in
nursing a wounded man.

Dreadful as the countess imagined it would be should Prince Andrew
die in her daughter's arms during the journey--as, judging by what the
doctor said, it seemed might easily happen--she could not oppose
Natasha. Though with the intimacy now established between the
wounded man and Natasha the thought occurred that should he recover
their former engagement would be renewed, no one--least of all Natasha
and Prince Andrew--spoke of this: the unsettled question of life and
death, which hung not only over Bolkonski but over all Russia, shut
out all other considerations.





CHAPTER XXXIII


On the third of September Pierre awoke late. His head was aching,
the clothes in which he had slept without undressing felt
uncomfortable on his body, and his mind had a dim consciousness of
something shameful he had done the day before. That something shameful
was his yesterday's conversation with Captain Ramballe.

It was eleven by the clock, but it seemed peculiarly dark out of
doors. Pierre rose, rubbed his eyes, and seeing the pistol with an
engraved stock which Gerasim had replaced on the writing table, he
remembered where he was and what lay before him that very day.

"Am I not too late?" he thought. "No, probably he won't make his
entry into Moscow before noon."

Pierre did not allow himself to reflect on what lay before him,
but hastened to act.

After arranging his clothes, he took the pistol and was about to
go out. But it then occurred to him for the first time that he
certainly could not carry the weapon in his hand through the
streets. It was difficult to hide such a big pistol even under his
wide coat. He could not carry it unnoticed in his belt or under his
arm. Besides, it had been discharged, and he had not had time to
reload it. "No matter, dagger will do," he said to himself, though
when planning his design he had more than once come to the
conclusion that the chief mistake made by the student in 1809 had been
to try to kill Napoleon with a dagger. But as his chief aim
consisted not in carrying out his design, but in proving to himself
that he would not abandon his intention and was doing all he could
to achieve it, Pierre hastily took the blunt jagged dagger in a
green sheath which he had bought at the Sukharev market with the
pistol, and hid it under his waistcoat.

Having tied a girdle over his coat and pulled his cap low on his
head, Pierre went down the corridor, trying to avoid making a noise or
meeting the captain, and passed out into the street.

The conflagration, at which he had looked with so much
indifference the evening before, had greatly increased during the
night. Moscow was on fire in several places. The buildings in Carriage
Row, across the river, in the Bazaar and the Povarskoy, as well as the
barges on the Moskva River and the timber yards by the Dorogomilov
Bridge, were all ablaze.

Pierre's way led through side streets to the Povarskoy and from
there to the church of St. Nicholas on the Arbat, where he had long
before decided that the deed should should be done. The gates of
most of the houses were locked and the shutters up. The streets and
lanes were deserted. The air was full of smoke and the smell of
burning. Now and then he met Russians with anxious and timid faces,
and Frenchmen with an air not of the city but of the camp, walking
in the middle of the streets. Both the Russians and the French
looked at Pierre with surprise. Besides his height and stoutness,
and the strange morose look of suffering in his face and whole figure,
the Russians stared at Pierre because they could not make out to
what class he could belong. The French followed him with
astonishment in their eyes chiefly because Pierre, unlike all the
other Russians who gazed at the French with fear and curiosity, paid
no attention to them. At the gate of one house three Frenchmen, who
were explaining something to some Russians who did not understand
them, stopped Pierre asking if he did not know French.

Pierre shook his head and went on. In another side street a sentinel
standing beside a green caisson shouted at him, but only when the
shout was threateningly repeated and he heard the click of the man's
musket as he raised it did Pierre understand that he had to pass on
the other side of the street. He heard nothing and saw nothing of what
went on around him. He carried his resolution within himself in terror
and haste, like something dreadful and alien to him, for, after the
previous night's experience, he was afraid of losing it. But he was
not destined to bring his mood safely to his destination. And even had
he not been hindered by anything on the way, his intention could not
now have been carried out, for Napoleon had passed the Arbat more than
four hours previously on his way from the Dorogomilov suburb to the
Kremlin, and was now sitting in a very gloomy frame of mind in a royal
study in the Kremlin, giving detailed and exact orders as to
measures to be taken immediately to extinguish the fire, to prevent
looting, and to reassure the inhabitants. But Pierre did not know
this; he was entirely absorbed in what lay before him, and was
tortured--as those are who obstinately undertake a task that is
impossible for them not because of its difficulty but because of its
incompatibility with their natures--by the fear of weakening at the
decisive moment and so losing his self-esteem.

Though he heard and saw nothing around him he found his way by
instinct and did not go wrong in the side streets that led to the
Povarskoy.

As Pierre approached that street the smoke became denser and denser-
he even felt the heat of the fire. Occasionally curly tongues of flame
rose from under the roofs of the houses. He met more people in the
streets and they were more excited. But Pierre, though he felt that
something unusual was happening around him, did not realize that he
was approaching the fire. As he was going along a foot path across a
wide-open space adjoining the Povarskoy on one side and the gardens of
Prince Gruzinski's house on the other, Pierre suddenly heard the
desperate weeping of a woman close to him. He stopped as if
awakening from a dream and lifted his head.

By the side of the path, on the dusty dry grass, all sorts of
household goods lay in a heap: featherbeds, a samovar, icons, and
trunks. On the ground, beside the trunks, sat a thin woman no longer
young, with long, prominent upper teeth, and wearing a black cloak and
cap. This woman, swaying to and fro and muttering something, was
choking with sobs. Two girls of about ten and twelve, dressed in dirty
short frocks and cloaks, were staring at their mother with a look of
stupefaction on their pale frightened faces. The youngest child, a boy
of about seven, who wore an overcoat and an immense cap evidently
not his own, was crying in his old nurse's arms. A dirty, barefooted
maid was sitting on a trunk, and, having undone her pale-colored
plait, was pulling it straight and sniffing at her singed hair. The
woman's husband, a short, round-shouldered man in the undress
uniform of a civilian official, with sausage-shaped whiskers and
showing under his square-set cap the hair smoothly brushed forward
over his temples, with expressionless face was moving the trunks,
which were placed one on another, and was dragging some garments
from under them.

As soon as she saw Pierre, the woman almost threw herself at his
feet.

"Dear people, good Christians, save me, help me, dear friends...
help us, somebody," she muttered between her sobs. "My girl... My
daughter! My youngest daughter is left behind. She's burned! Ooh!
Was it for this I nursed you.... Ooh!"

"Don't, Mary Nikolievna!" said her husband to her in a low voice,
evidently only to justify himself before the stranger. "Sister must
have taken her, or else where can she be?" he added.

"Monster! Villain!" shouted the woman angrily, suddenly ceasing to
weep. "You have no heart, you don't feel for your own child! Another
man would have rescued her from the fire. But this is a monster and
neither a man nor a father! You, honored sir, are a noble man," she
went on, addressing Pierre rapidly between her sobs. "The fire broke
out alongside, and blew our way, the maid called out 'Fire!' and we
rushed to collect our things. We ran out just as we were.... This is
what we have brought away.... The icons, and my dowry bed, all the
rest is lost. We seized the children. But not Katie! Ooh! O
Lord!..." and again she began to sob. "My child, my dear one!
Burned, burned!"

"But where was she left?" asked Pierre.

From the expression of his animated face the woman saw that this man
might help her.

"Oh, dear sir!" she cried, seizing him by the legs. "My
benefactor, set my heart at ease.... Aniska, go, you horrid girl, show
him the way!" she cried to the maid, angrily opening her mouth and
still farther exposing her long teeth.

"Show me the way, show me, I... I'll do it," gasped Pierre rapidly.

The dirty maidservant stepped from behind the trunk, put up her
plait, sighed, and went on her short, bare feet along the path. Pierre
felt as if he had come back to life after a heavy swoon. He held his
head higher, his eyes shone with the light of life, and with swift
steps he followed the maid, overtook her, and came out on the
Povarskoy. The whole street was full of clouds of black smoke. Tongues
of flame here and there broke through that cloud. A great number of
people crowded in front of the conflagration. In the middle of the
street stood a French general saying something to those around him.
Pierre, accompanied by the maid, was advancing to the spot where the
general stood, but the French soldiers stopped him.

"On ne passe pas!"* cried a voice.


*"You can't pass!


"This way, uncle," cried the girl. "We'll pass through the side
street, by the Nikulins'!"

Pierre turned back, giving a spring now and then to keep up with
her. She ran across the street, turned down a side street to the left,
and, passing three houses, turned into a yard on the right.

"It's here, close by," said she and, running across the yard, opened
a gate in a wooden fence and, stopping, pointed out to him a small
wooden wing of the house, which was burning brightly and fiercely. One
of its sides had fallen in, another was on fire, and bright flames
issued from the openings of the windows and from under the roof.

As Pierre passed through the fence gate, he was enveloped by hot air
and involuntarily stopped.

"Which is it? Which is your house?" he asked.

"Ooh!" wailed the girl, pointing to the wing. "That's it, that was
our lodging. You've burned to death, our treasure, Katie, my
precious little missy! Ooh!" lamented Aniska, who at the sight of
the fire felt that she too must give expression to her feelings.

Pierre rushed to the wing, but the heat was so great that he
involuntarily passed round in a curve and came upon the large house
that was as yet burning only at one end, just below the roof, and
around which swarmed a crowd of Frenchmen. At first Pierre did not
realize what these men, who were dragging something out, were about;
but seeing before him a Frenchman hitting a peasant with a blunt saber
and trying to take from him a fox-fur coat, he vaguely understood that
looting was going on there, but he had no time to dwell on that idea.

The sounds of crackling and the din of falling walls and ceilings,
the whistle and hiss of the flames, the excited shouts of the
people, and the sight of the swaying smoke, now gathering into thick
black clouds and now soaring up with glittering sparks, with here
and there dense sheaves of flame (now red and now like golden fish
scales creeping along the walls), and the heat and smoke and
rapidity of motion, produced on Pierre the usual animating effects
of a conflagration. It had a peculiarly strong effect on him because
at the sight of the fire he felt himself suddenly freed from the ideas
that had weighed him down. He felt young, bright, adroit, and
resolute. He ran round to the other side of the lodge and was about to
dash into that part of it which was still standing, when just above
his head he heard several voices shouting and then a cracking sound
and the ring of something heavy falling close beside him.

Pierre looked up and saw at a window of the large house some
Frenchmen who had just thrown out the drawer of a chest, filled with
metal articles. Other French soldiers standing below went up to the
drawer.

"What does this fellow want?" shouted one of them referring to
Pierre.

"There's a child in that house. Haven't you seen a child?" cried
Pierre.

"What's he talking about? Get along!" said several voices, and one
of the soldiers, evidently afraid that Pierre might want to take
from them some of the plate and bronzes that were in the drawer, moved
threateningly toward him.

"A child?" shouted a Frenchman from above. "I did hear something
squealing in the garden. Perhaps it's his brat that the fellow is
looking for. After all, one must be human, you know...."

"Where is it? Where?" said Pierre.

"There! There!" shouted the Frenchman at the window, pointing to the
garden at the back of the house. "Wait a bit--I'm coming down."

And a minute or two later the Frenchman, a black-eyed fellow with
a spot on his cheek, in shirt sleeves, really did jump out of a window
on the ground floor, and clapping Pierre on the shoulder ran with
him into the garden.

"Hurry up, you others!" he called out to his comrades. "It's getting
hot."

When they reached a gravel path behind the house the Frenchman
pulled Pierre by the arm and pointed to a round, graveled space
where a three-year-old girl in a pink dress was lying under a seat.

"There is your child! Oh, a girl, so much the better!" said the
Frenchman. "Good-by, Fatty. We must be human, we are all mortal you
know!" and the Frenchman with the spot on his cheek ran back to his
comrades.

Breathless with joy, Pierre ran to the little girl and was going
to take her in his arms. But seeing a stranger the sickly,
scrofulous-looking child, unattractively like her mother, began to
yell and run away. Pierre, however, seized her and lifted her in his
arms. She screamed desperately and angrily and tried with her little
hands to pull Pierre's hands away and to bite them with her slobbering
mouth. Pierre was seized by a sense of horror and repulsion such as he
had experienced when touching some nasty little animal. But he made an
effort not to throw the child down and ran with her to the large
house. It was now, however, impossible to get back the way he had
come; the maid, Aniska, was no longer there, and Pierre with a feeling
of pity and disgust pressed the wet, painfully sobbing child to
himself as tenderly as he could and ran with her through the garden
seeking another way out.





CHAPTER XXXIV


Having run through different yards and side streets, Pierre got back
with his little burden to the Gruzinski garden at the corner of the
Povarskoy. He did not at first recognize the place from which he had
set out to look for the child, so crowded was it now with people and
goods that had been dragged out of the houses. Besides Russian
families who had taken refuge here from the fire with their
belongings, there were several French soldiers in a variety of
clothing. Pierre took no notice of them. He hurried to find the family
of that civil servant in order to restore the daughter to her mother
and go to save someone else. Pierre felt that he had still much to
do and to do quickly. Glowing with the heat and from running, he
felt at that moment more strongly than ever the sense of youth,
animation, and determination that had come on him when he ran to
save the child. She had now become quiet and, clinging with her little
hands to Pierre's coat, sat on his arm gazing about her like some
little wild animal. He glanced at her occasionally with a slight
smile. He fancied he saw something pathetically innocent in that
frightened, sickly little face.

He did not find the civil servant or his wife where he had left
them. He walked among the crowd with rapid steps, scanning the various
faces he met. Involuntarily he noticed a Georgian or Armenian family
consisting of a very handsome old man of Oriental type, wearing a new,
cloth-covered, sheepskin coat and new boots, an old woman of similar
type, and a young woman. That very young woman seemed to Pierre the
perfection of Oriental beauty, with her sharply outlined, arched,
black eyebrows and the extraordinarily soft, bright color of her long,
beautiful, expressionless face. Amid the scattered property and the
crowd on the open space, she, in her rich satin cloak with a bright
lilac shawl on her head, suggested a delicate exotic plant thrown
out onto the snow. She was sitting on some bundles a little behind the
old woman, and looked from under her long lashes with motionless,
large, almond-shaped eyes at the ground before her. Evidently she
was aware of her beauty and fearful because of it. Her face struck
Pierre and, hurrying along by the fence, he turned several times to
look at her. When he had reached the fence, still without finding
those he sought, he stopped and looked about him.

With the child in his arms his figure was now more conspicuous
than before, and a group of Russians, both men and women, gathered
about him.

"Have you lost anyone, my dear fellow? You're of the gentry
yourself, aren't you? Whose child is it?" they asked him.

Pierre replied that the child belonged to a woman in a black coat
who had been sitting there with her other children, and he asked
whether anyone knew where she had gone.

"Why, that must be the Anferovs," said an old deacon, addressing a
pockmarked peasant woman. "Lord have mercy, Lord have mercy!" he added
in his customary bass.

"The Anferovs? No," said the woman. "They left in the morning.
That must be either Mary Nikolievna's or the Ivanovs'!"

"He says 'a woman,' and Mary Nikolievna is a lady," remarked a house
serf.

"Do you know her? She's thin, with long teeth," said Pierre.

"That's Mary Nikolievna! They went inside the garden when these
wolves swooped down," said the woman, pointing to the French soldiers.

"O Lord, have mercy!" added the deacon.

"Go over that way, they're there. It's she! She kept on lamenting
and crying," continued the woman. "It's she. Here, this way!"

But Pierre was not listening to the woman. He had for some seconds
been intently watching what was going on a few steps away. He was
looking at the Armenian family and at two French soldiers who had gone
up to them. One of these, a nimble little man, was wearing a blue coat
tied round the waist with a rope. He had a nightcap on his head and
his feet were bare. The other, whose appearance particularly struck
Pierre, was a long, lank, round-shouldered, fair-haired man, slow in
his movements and with an idiotic expression of face. He wore a
woman's loose gown of frieze, blue trousers, and large torn Hessian
boots. The little barefooted Frenchman in the blue coat went up to the
Armenians and, saying something, immediately seized the old man by his
legs and the old man at once began pulling off his boots. The other in
the frieze gown stopped in front of the beautiful Armenian girl and
with his hands in his pockets stood staring at her, motionless and
silent.

"Here, take the child!" said Pierre peremptorily and hurriedly to
the woman, handing the little girl to her. "Give her back to them,
give her back!" he almost shouted, putting the child, who began
screaming, on the ground, and again looking at the Frenchman and the
Armenian family.

The old man was already sitting barefoot. The little Frenchman had
secured his second boot and was slapping one boot against the other.
The old man was saying something in a voice broken by sobs, but Pierre
caught but a glimpse of this, his whole attention was directed to
the Frenchman in the frieze gown who meanwhile, swaying slowly from
side to side, had drawn nearer to the young woman and taking his hands
from his pockets had seized her by the neck.

The beautiful Armenian still sat motionless and in the same
attitude, with her long lashes drooping as if she did not see or
feel what the soldier was doing to her.

While Pierre was running the few steps that separated him from the
Frenchman, the tall marauder in the frieze gown was already tearing
from her neck the necklace the young Armenian was wearing, and the
young woman, clutching at her neck, screamed piercingly.

"Let that woman alone!" exclaimed Pierre hoarsely in a furious
voice, seizing the soldier by his round shoulders and throwing him
aside.

The soldier fell, got up, and ran away. But his comrade, throwing
down the boots and drawing his sword, moved threateningly toward
Pierre.

"Voyons, Pas de betises!"* he cried.


*"Look here, no nonsense!"


Pierre was in such a transport of rage that he remembered nothing
and his strength increased tenfold. He rushed at the barefooted
Frenchman and, before the latter had time to draw his sword, knocked
him off his feet and hammered him with his fists. Shouts of approval
were heard from the crowd around, and at the same moment a mounted
patrol of French Uhlans appeared from round the corner. The Uhlans
came up at a trot to Pierre and the Frenchman and surrounded them.
Pierre remembered nothing of what happened after that. He only
remembered beating someone and being beaten and finally feeling that
his hands were bound and that a crowd of French soldiers stood
around him and were searching him.

"Lieutenant, he has a dagger," were the first words Pierre
understood.

"Ah, a weapon?" said the officer and turned to the barefooted
soldier who had been arrested with Pierre. "All right, you can tell
all about it at the court-martial." Then he turned to Pierre. "Do
you speak French?"

Pierre looked around him with bloodshot eyes and did not reply.
His face probably looked very terrible, for the officer said something
in a whisper and four more Uhlans left the ranks and placed themselves
on both sides of Pierre.

"Do you speak French?" the officer asked again, keeping at a
distance from Pierre. "Call the interpreter."

A little man in Russian civilian clothes rode out from the ranks,
and by his clothes and manner of speaking Pierre at once knew him to
be a French salesman from one of the Moscow shops.

"He does not look like a common man," said the interpreter, after
a searching look at Pierre.

"Ah, he looks very much like an incendiary," remarked the officer.
"And ask him who he is," he added.

"Who are you?" asked the interpreter in poor Russian. "You must
answer the chief."

"I will not tell you who I am. I am your prisoner--take me!"
Pierre suddenly replied in French.

"Ah, ah!" muttered the officer with a frown. "Well then, march!"

A crowd had collected round the Uhlans. Nearest to Pierre stood
the pockmarked peasant woman with the little girl, and when the patrol
started she moved forward.

"Where are they taking you to, you poor dear?" said she. "And the
little girl, the little girl, what am I to do with her if she's not
theirs?" said the woman.

"What does that woman want?" asked the officer.

Pierre was as if intoxicated. His elation increased at the sight
of the little girl he had saved.

"What does she want?" he murmured. "She is bringing me my daughter
whom I have just saved from the flames," said he. "Good-by!" And
without knowing how this aimless lie had escaped him, he went along
with resolute and triumphant steps between the French soldiers.

The French patrol was one of those sent out through the various
streets of Moscow by Durosnel's order to put a stop to the pillage,
and especially to catch the incendiaries who, according to the general
opinion which had that day originated among the higher French
officers, were the cause of the conflagrations. After marching through
a number of streets the patrol arrested five more Russian suspects:
a small shopkeeper, two seminary students, a peasant, and a house
serf, besides several looters. But of all these various suspected
characters, Pierre was considered to be the most suspicious of all.
When they had all been brought for the night to a large house on the
Zubov Rampart that was being used as a guardhouse, Pierre was placed
apart under strict guard.





BOOK TWELVE: 1812





CHAPTER I


In Petersburg at that time a complicated struggle was being
carried on with greater heat than ever in the highest circles, between
the parties of Rumyantsev, the French, Marya Fedorovna, the Tsarevich,
and others, drowned as usual by the buzzing of the court drones. But
the calm, luxurious life of Petersburg, concerned only about
phantoms and reflections of real life, went on in its old way and made
it hard, except by a great effort, to realize the danger and the
difficult position of the Russian people. There were the same
receptions and balls, the same French theater, the same court
interests and service interests and intrigues as usual. Only in the
very highest circles were attempts made to keep in mind the
difficulties of the actual position. Stories were whispered of how
differently the two Empresses behaved in these difficult
circumstances. The Empress Marya, concerned for the welfare of the
charitable and educational institutions under her patronage, had given
directions that they should all be removed to Kazan, and the things
belonging to these institutions had already been packed up. The
Empress Elisabeth, however, when asked what instructions she would
be pleased to give--with her characteristic Russian patriotism had
replied that she could give no directions about state institutions for
that was the affair of the sovereign, but as far as she personally was
concerned she would be the last to quit Petersburg.

At Anna Pavlovna's on the twenty-sixth of August, the very day of
the battle of Borodino, there was a soiree, the chief feature of which
was to be the reading of a letter from His Lordship the Bishop when
sending the Emperor an icon of the Venerable Sergius. It was
regarded as a model of ecclesiastical, patriotic eloquence. Prince
Vasili himself, famed for his elocution, was to read it. (He used to
read at the Empress'.) The art of his reading was supposed to lie in
rolling out the words, quite independently of their meaning, in a loud
and singsong voice alternating between a despairing wail and a
tender murmur, so that the wail fell quite at random on one word and
the murmur on another. This reading, as was always the case at Anna
Pavlovna's soirees, had a political significance. That evening she
expected several important personages who had to be made ashamed of
their visits to the French theater and aroused to a patriotic
temper. A good many people had already arrived, but Anna Pavlovna, not
yet seeing all those whom she wanted in her drawing room, did not
let the reading begin but wound up the springs of a general
conversation.

The news of the day in Petersburg was the illness of Countess
Bezukhova. She had fallen ill unexpectedly a few days previously,
had missed several gatherings of which she was usually ornament, and
was said to be receiving no one, and instead of the celebrated
Petersburg doctors who usually attended her had entrusted herself to
some Italian doctor who was treating her in some new and unusual way.

They all knew very well that the enchanting countess' illness
arose from an inconvenience resulting from marrying two husbands at
the same time, and that the Italian's cure consisted in removing
such inconvenience; but in Anna Pavlovna's presence no one dared to
think of this or even appear to know it.

"They say the poor countess is very ill. The doctor says it is
angina pectoris."

"Angina? Oh, that's a terrible illness!"

"They say that the rivals are reconciled, thanks to the angina..."
and the word angina was repeated with great satisfaction.

"The count is pathetic, they say. He cried like a child when the
doctor told him the case was dangerous."

"Oh, it would be a terrible loss, she is an enchanting woman."

"You are speaking of the poor countess?" said Anna Pavlovna,
coming up just then. "I sent to ask for news, and hear that she is a
little better. Oh, she is certainly the most charming woman in the
world," she went on, with a smile at her own enthusiasm. "We belong to
different camps, but that does not prevent my esteeming her as she
deserves. She is very unfortunate!" added Anna Pavlovna.

Supposing that by these words Anna Pavlovna was somewhat lifting the
veil from the secret of the countess' malady, an unwary young man
ventured to express surprise that well known doctors had not been
called in and that the countess was being attended by a charlatan
who might employ dangerous remedies.

"Your information maybe better than mine," Anna Pavlovna suddenly
and venomously retorted on the inexperienced young man, "but I know on
good authority that this doctor is a very learned and able man. He
is private physician to the Queen of Spain."

And having thus demolished the young man, Anna Pavlovna turned to
another group where Bilibin was talking about the Austrians: having
wrinkled up his face he was evidently preparing to smooth it out again
and utter one of his mots.

"I think it is delightful," he said, referring to a diplomatic
note that had been sent to Vienna with some Austrian banners
captured from the French by Wittgenstein, "the hero of Petropol" as he
was then called in Petersburg.

"What? What's that?" asked Anna Pavlovna, securing silence for the
mot, which she had heard before.

And Bilibin repeated the actual words of the diplomatic dispatch,
which he had himself composed.

"The Emperor returns these Austrian banners," said Bilibin,
"friendly banners gone astray and found on a wrong path," and his brow
became smooth again.

"Charming, charming!" observed Prince Vasili.

"The path to Warsaw, perhaps," Prince Hippolyte remarked loudly
and unexpectedly. Everybody looked at him, understanding what he
meant. Prince Hippolyte himself glanced around with amused surprise.
He knew no more than the others what his words meant. During his
diplomatic career he had more than once noticed that such utterances
were received as very witty, and at every opportunity he uttered in
that way the first words that entered his head. "It may turn out
very well," he thought, "but if not, they'll know how to arrange
matters." And really, during the awkward silence that ensued, that
insufficiently patriotic person entered whom Anna Pavlovna had been
waiting for and wished to convert, and she, smiling and shaking a
finger at Hippolyte, invited Prince Vasili to the table and bringing
him two candles and the manuscript begged him to begin. Everyone
became silent.


"Most Gracious Sovereign and Emperor!" Prince Vasili sternly
declaimed, looking round at his audience as if to inquire whether
anyone had anything to say to the contrary. But no one said
anything. "Moscow, our ancient capital, the New Jerusalem, receives
her Christ"--he placed a sudden emphasis on the word her--"as a mother
receives her zealous sons into her arms, and through the gathering
mists, foreseeing the brilliant glory of thy rule, sings in
exultation, 'Hosanna, blessed is he that cometh!'"


Prince Vasili pronounced these last words in a tearful voice.

Bilibin attentively examined his nails, and many of those present
appeared intimidated, as if asking in what they were to blame. Anna
Pavlovna whispered the next words in advance, like an old woman
muttering the prayer at Communion: "Let the bold and insolent
Goliath..." she whispered.

Prince Vasili continued.


"Let the bold and insolent Goliath from the borders of France
encompass the realms of Russia with death-bearing terrors; humble
Faith, the sling of the Russian David, shall suddenly smite his head
in his blood-thirsty pride. This icon of the Venerable Sergius, the
servant of God and zealous champion of old of our country's weal, is
offered to Your Imperial Majesty. I grieve that my waning strength
prevents rejoicing in the sight of your most gracious presence. I
raise fervent prayers to Heaven that the Almighty may exalt the race
of the just, and mercifully fulfill the desires of Your Majesty."


"What force! What a style!" was uttered in approval both of reader
and of author.

Animated by that address Anna Pavlovna's guests talked for a long
time of the state of the fatherland and offered various conjectures as
to the result of the battle to be fought in a few days.

"You will see," said Anna Pavlovna, "that tomorrow, on the Emperor's
birthday, we shall receive news. I have a favorable presentiment!"





CHAPTER II


Anna Pavlovna's presentiment was in fact fulfilled. Next day
during the service at the palace church in honor of the Emperor's
birthday, Prince Volkonski was called out of the church and received a
dispatch from Prince Kutuzov. It was Kutuzov's report, written from
Tatarinova on the day of the battle. Kutuzov wrote that the Russians
had not retreated a step, that the French losses were much heavier
than ours, and that he was writing in haste from the field of battle
before collecting full information. It followed that there must have
been a victory. And at once, without leaving the church, thanks were
rendered to the Creator for His help and for the victory.

Anna Pavlovna's presentiment was justified, and all that morning a
joyously festive mood reigned in the city. Everyone believed the
victory to have been complete, and some even spoke of Napoleon's
having been captured, of his deposition, and of the choice of a new
ruler for France.

It is very difficult for events to be reflected in their real
strength and completeness amid the conditions of court life and far
from the scene of action. General events involuntarily group
themselves around some particular incident. So now the courtiers'
pleasure was based as much on the fact that the news had arrived on
the Emperor's birthday as on the fact of the victory itself. It was
like a successfully arranged surprise. Mention was made in Kutuzov's
report of the Russian losses, among which figured the names of
Tuchkov, Bagration, and Kutaysov. In the Petersburg world this sad
side of the affair again involuntarily centered round a single
incident: Kutaysov's death. Everybody knew him, the Emperor liked him,
and he was young and interesting. That day everyone met with the
words:

"What a wonderful coincidence! Just during the service. But what a
loss Kutaysov is! How sorry I am!"

"What did I tell about Kutuzov?" Prince Vasili now said with a
prophet's pride. "I always said he was the only man capable of
defeating Napoleon."

But next day no news arrived from the army and the public mood
grew anxious. The courtiers suffered because of the suffering the
suspense occasioned the Emperor.

"Fancy the Emperor's position!" said they, and instead of
extolling Kutuzov as they had done the day before, they condemned
him as the cause of the Emperor's anxiety. That day Prince Vasili no
longer boasted of his protege Kutuzov, but remained silent when the
commander in chief was mentioned. Moreover, toward evening, as if
everything conspired to make Petersburg society anxious and uneasy,
a terrible piece of news was added. Countess Helene Bezukhova had
suddenly died of that terrible malady it had been so agreeable to
mention. Officially, at large gatherings, everyone said that
Countess Bezukhova had died of a terrible attack of angina pectoris,
but in intimate circles details were mentioned of how the private
physician of the Queen of Spain had prescribed small doses of a
certain drug to produce a certain effect; but Helene, tortured by
the fact that the old count suspected her and that her husband to whom
she had written (that wretched, profligate Pierre) had not replied,
had suddenly taken a very large dose of the drug, and had died in
agony before assistance could be rendered her. It was said that Prince
Vasili and the old count had turned upon the Italian, but the latter
had produced such letters from the unfortunate deceased that they
had immediately let the matter drop.

Talk in general centered round three melancholy facts: the Emperor's
lack of news, the loss of Kutuzov, and the death of Helene.

On the third day after Kutuzov's report a country gentleman
arrived from Moscow, and news of the surrender of Moscow to the French
spread through the whole town. This was terrible! What a position
for the Emperor to be in! Kutuzov was a traitor, and Prince Vasili
during the visits of condolence paid to him on the occasion of his
daughter's death said of Kutuzov, whom he had formerly praised (it was
excusable for him in his grief to forget what he had said), that it
was impossible to expect anything else from a blind and depraved old
man.

"I only wonder that the fate of Russia could have been entrusted
to such a man."

As long as this news remained unofficial it was possible to doubt
it, but the next day the following communication was received from
Count Rostopchin:


Prince Kutuzov's adjutant has brought me a letter in which he
demands police officers to guide the army to the Ryazan road. He
writes that he is regretfully abandoning Moscow. Sire! Kutuzov's
action decides the fate of the capital and of your empire! Russia will
shudder to learn of the abandonment of the city in which her greatness
is centered and in which lie the ashes of your ancestors! I shall
follow the army. I have had everything removed, and it only remains
for me to weep over the fate of my fatherland.


On receiving this dispatch the Emperor sent Prince Volkonski to
Kutuzov with the following rescript:


Prince Michael Ilarionovich! Since the twenty-ninth of August I have
received no communication from you, yet on the first of September I
received from the commander in chief of Moscow, via Yaroslavl, the sad
news that you, with the army, have decided to abandon Moscow. You
can yourself imagine the effect this news has had on me, and your
silence increases my astonishment. I am sending this by
Adjutant-General Prince Volkonski, to hear from you the situation of
the army and the reasons that have induced you to take this melancholy
decision.





CHAPTER III


Nine days after the abandonment of Moscow, a messenger from
Kutuzov reached Petersburg with the official announcement of that
event. This messenger was Michaud, a Frenchman who did not know
Russian, but who was quoique etranger, russe de coeur et d'ame,* as he
said of himself.


*Though a foreigner, Russian in heart and soul.


The Emperor at once received this messenger in his study at the
palace on Stone Island. Michaud, who had never seen Moscow before
the campaign and who did not know Russian, yet felt deeply moved (as
he wrote) when he appeared before notre tres gracieux souverain*
with the news of the burning of Moscow, dont les flammes eclairaient
sa route.*[2]


*Our most gracious sovereign.

*[2] Whose flames illumined his route.


Though the source of M. Michaud's chagrin must have been different
from that which caused Russians to grieve, he had such a sad face when
shown into the Emperor's study that the latter at once asked:

"Have you brought me sad news, Colonel?"

"Very sad, sire," replied Michaud, lowering his eyes with a sigh.
"The abandonment of Moscow."

"Have they surrendered my ancient capital without a battle?" asked
the Emperor quickly, his face suddenly flushing.

Michaud respectfully delivered the message Kutuzov had entrusted
to him, which was that it had been impossible to fight before
Moscow, and that as the only remaining choice was between losing the
army as well as Moscow, or losing Moscow alone, the field marshal
had to choose the latter.

The Emperor listened in silence, not looking at Michaud.

"Has the enemy entered the city?" he asked.

"Yes, sire, and Moscow is now in ashes. I left it all in flames,"
replied Michaud in a decided tone, but glancing at the Emperor he
was frightened by what he had done.

The Emperor began to breathe heavily and rapidly, his lower lip
trembled, and tears instantly appeared in his fine blue eyes.

But this lasted only a moment. He suddenly frowned, as if blaming
himself for his weakness, and raising his head addressed Michaud in
a firm voice:

"I see, Colonel, from all that is happening, that Providence
requires great sacrifices of us... I am ready to submit myself in
all things to His will; but tell me, Michaud, how did you leave the
army when it saw my ancient capital abandoned without a battle? Did
you not notice discouragement?..."

Seeing that his most gracious ruler was calm once more, Michaud also
grew calm, but was not immediately ready to reply to the Emperor's
direct and relevant question which required a direct answer.

"Sire, will you allow me to speak frankly as befits a loyal
soldier?" he asked to gain time.

"Colonel, I always require it," replied the Emperor. "Conceal
nothing from me, I wish to know absolutely how things are."

"Sire!" said Michaud with a subtle, scarcely perceptible smile on
his lips, having now prepared a well-phrased reply, "sire, I left
the whole army, from its chiefs to the lowest soldier, without
exception in desperate and agonized terror..."

"How is that?" the Emperor interrupted him, frowning sternly. "Would
misfortune make my Russians lose heart?... Never!"

Michaud had only waited for this to bring out the phrase he had
prepared.

"Sire," he said, with respectful playfulness, "they are only
afraid lest Your Majesty, in the goodness of your heart, should
allow yourself to be persuaded to make peace. They are burning for the
combat," declared this representative of the Russian nation, "and to
prove to Your Majesty by the sacrifice of their lives how devoted they
are...."

"Ah!" said the Emperor reassured, and with a kindly gleam in his
eyes, he patted Michaud on the shoulder. "You set me at ease,
Colonel."

He bent his head and was silent for some time.

"Well, then, go back to the army," he said, drawing himself up to
his full height and addressing Michaud with a gracious and majestic
gesture, "and tell our brave men and all my good subjects wherever you
go that when I have not a soldier left I shall put myself at the
head of my beloved nobility and my good peasants and so use the last
resources of my empire. It still offers me more than my enemies
suppose," said the Emperor growing more and more animated; "but should
it ever be ordained by Divine Providence," he continued, raising to
heaven his fine eyes shining with emotion, "that my dynasty should
cease to reign on the throne of my ancestors, then after exhausting
all the means at my command, I shall let my beard grow to here" (he
pointed halfway down his chest) "and go and eat potatoes with the
meanest of my peasants, rather than sign the disgrace of my country
and of my beloved people whose sacrifices I know how to appreciate."

Having uttered these words in an agitated voice the Emperor suddenly
turned away as if to hide from Michaud the tears that rose to his
eyes, and went to the further end of his study. Having stood there a
few moments, he strode back to Michaud and pressed his arm below the
elbow with a vigorous movement. The Emperor's mild and handsome face
was flushed and his eyes gleamed with resolution and anger.

"Colonel Michaud, do not forget what I say to you here, perhaps we
may recall it with pleasure someday... Napoleon or I," said the
Emperor, touching his breast. "We can no longer both reign together. I
have learned to know him, and he will not deceive me any more...."

And the Emperor paused, with a frown.

When he heard these words and saw the expression of firm
resolution in the Emperor's eyes, Michaud--quoique etranger, russe
de coeur et d'ame--at that solemn moment felt himself enraptured by
all that he had heard (as he used afterwards to say), and gave
expression to his own feelings and those of the Russian people whose
representative he considered himself to be, in the following words:

"Sire!" said he, "Your Majesty is at this moment signing the glory
of the nation and the salvation of Europe!"

With an inclination of the head the Emperor dismissed him.





CHAPTER IV


It is natural for us who were not living in those days to imagine
that when half Russia had been conquered and the inhabitants were
fleeing to distant provinces, and one levy after another was being
raised for the defense of the fatherland, all Russians from the
greatest to the least were solely engaged in sacrificing themselves,
saving their fatherland, or weeping over its downfall. The tales and
descriptions of that time without exception speak only of the
self-sacrifice, patriotic devotion, despair, grief, and the heroism of
the Russians. But it was not really so. It appears so to us because we
see only the general historic interest of that time and do not see all
the personal human interests that people had. Yet in reality those
personal interests of the moment so much transcend the general
interests that they always prevent the public interest from being felt
or even noticed. Most of the people at that time paid no attention
to the general progress of events but were guided only by their
private interests, and they were the very people whose activities at
that period were most useful.

Those who tried to understand the general course of events and to
take part in it by self-sacrifice and heroism were the most useless
members of society, they saw everything upside down, and all they
did for the common good turned out to be useless and foolish--like
Pierre's and Mamonov's regiments which looted Russian villages, and
the lint the young ladies prepared and that never reached the wounded,
and so on. Even those, fond of intellectual talk and of expressing
their feelings, who discussed Russia's position at the time
involuntarily introduced into their conversation either a shade of
pretense and falsehood or useless condemnation and anger directed
against people accused of actions no one could possibly be guilty
of. In historic events the rule forbidding us to eat of the fruit of
the Tree of Knowledge is specially applicable. Only unconscious action
bears fruit, and he who plays a part in an historic event never
understands its significance. If he tries to realize it his efforts
are fruitless.

The more closely a man was engaged in the events then taking place
in Russia the less did he realize their significance. In Petersburg
and in the provinces at a distance from Moscow, ladies, and
gentlemen in militia uniforms, wept for Russia and its ancient capital
and talked of self-sacrifice and so on; but in the army which
retired beyond Moscow there was little talk or thought of Moscow,
and when they caught sight of its burned ruins no one swore to be
avenged on the French, but they thought about their next pay, their
next quarters, of Matreshka the vivandiere, and like matters.

As the war had caught him in the service, Nicholas Rostov took a
close and prolonged part in the defense of his country, but did so
casually, without any aim at self-sacrifice, and he therefore looked
at what was going on in Russia without despair and without dismally
racking his brains over it. Had he been asked what he thought of the
state of Russia, he would have said that it was not his business to
think about it, that Kutuzov and others were there for that purpose,
but that he had heard that the regiments were to be made up to their
full strength, that fighting would probably go on for a long time yet,
and that things being so it was quite likely he might be in command of
a regiment in a couple of years' time.

As he looked at the matter in this way, he learned that he was being
sent to Voronezh to buy remounts for his division, not only without
regret at being prevented from taking part in the coming battle, but
with the greatest pleasure--which he did not conceal and which his
comrades fully understood.

A few days before the battle of Borodino, Nicholas received the
necessary money and warrants, and having sent some hussars on in
advance, he set out with post horses for Voronezh.

Only a man who has experienced it--that is, has passed some months
continuously in an atmosphere of campaigning and war--can understand
the delight Nicholas felt when he escaped from the region covered by
the army's foraging operations, provision trains, and hospitals. When-
free from soldiers, wagons, and the filthy traces of a camp--he saw
villages with peasants and peasant women, gentlemen's country
houses, fields where cattle were grazing, posthouses with
stationmasters asleep in them, he rejoiced as though seeing all this
for the first time. What for a long while specially surprised and
delighted him were the women, young and healthy, without a dozen
officers making up to each of them; women, too, who were pleased and
flattered that a passing officer should joke with them.

In the highest spirits Nicholas arrived at night at a hotel in
Voronezh, ordered things he had long been deprived of in camp, and
next day, very clean-shaven and in a full-dress uniform he had not
worn for a long time, went to present himself to the authorities.

The commander of the militia was a civilian general, an old man
who was evidently pleased with his military designation and rank. He
received Nicholas brusquely (imagining this to be characteristically
military) and questioned him with an important air, as if
considering the general progress of affairs and approving and
disapproving with full right to do so. Nicholas was in such good
spirits that this merely amused him.

From the commander of the militia he drove to the governor. The
governor was a brisk little man, very simple and affable. He indicated
the stud farms at which Nicholas might procure horses, recommended
to him a horse dealer in the town and a landowner fourteen miles out
of town who had the best horses, and promised to assist him in every
way.

"You are Count Ilya Rostov's son? My wife was a great friend of your
mother's. We are at home on Thursdays--today is Thursday, so please
come and see us quite informally," said the governor, taking leave
of him.

Immediately on leaving the governor's, Nicholas hired post horses
and, taking his squadron quartermaster with him, drove at a gallop
to the landowner, fourteen miles away, who had the stud. Everything
seemed to him pleasant and easy during that first part of his stay
in Voronezh and, as usually happens when a man is in a pleasant
state of mind, everything went well and easily.

The landowner to whom Nicholas went was a bachelor, an old
cavalryman, a horse fancier, a sportsman, the possessor of some
century-old brandy and some old Hungarian wine, who had a snuggery
where he smoked, and who owned some splendid horses.

In very few words Nicholas bought seventeen picked stallions for six
thousand rubles--to serve, as he said, as samples of his remounts.
After dining and taking rather too much of the Hungarian wine,
Nicholas--having exchanged kisses with the landowner, with whom he was
already on the friendliest terms--galloped back over abominable roads,
in the brightest frame of mind, continually urging on the driver so as
to be in time for the governor's party.

When he had changed, poured water over his head, and scented
himself, Nicholas arrived at the governor's rather late, but with
the phrase "better late than never" on his lips.

It was not a ball, nor had dancing been announced, but everyone knew
that Catherine Petrovna would play valses and the ecossaise on the
clavichord and that there would be dancing, and so everyone had come
as to a ball.

Provincial life in 1812 went on very much as usual, but with this
difference, that it was livelier in the towns in consequence of the
arrival of many wealthy families from Moscow, and as in everything
that went on in Russia at that time a special recklessness was
noticeable, an "in for a penny, in for a pound--who cares?" spirit,
and the inevitable small talk, instead of turning on the weather and
mutual acquaintances, now turned on Moscow, the army, and Napoleon.

The society gathered together at the governor's was the best in
Voronezh.

There were a great many ladies and some of Nicholas' Moscow
acquaintances, but there were no men who could at all vie with the
cavalier of St. George, the hussar remount officer, the good-natured
and well-bred Count Rostov. Among the men was an Italian prisoner,
an officer of the French army; and Nicholas felt that the presence
of that prisoner enhanced his own importance as a Russian hero. The
Italian was, as it were, a war trophy. Nicholas felt this, it seemed
to him that everyone regarded the Italian in the same light, and he
treated him cordially though with dignity and restraint.

As soon as Nicholas entered in his hussar uniform, diffusing
around him a fragrance of perfume and wine, and had uttered the
words "better late than never" and heard them repeated several times
by others, people clustered around him; all eyes turned on him, and he
felt at once that he had entered into his proper position in the
province--that of a universal favorite: a very pleasant position,
and intoxicatingly so after his long privations. At posting
stations, at inns, and in the landowner's snuggery, maidservants had
been flattered by his notice, and here too at the governor's party
there were (as it seemed to Nicholas) an inexhaustible number of
pretty young women, married and unmarried, impatiently awaiting his
notice. The women and girls flirted with him and, from the first
day, the people concerned themselves to get this fine young
daredevil of an hussar married and settled down. Among these was the
governor's wife herself, who welcomed Rostov as a near relative and
called him "Nicholas."

Catherine Petrovna did actually play valses and the ecossaise, and
dancing began in which Nicholas still further captivated the
provincial society by his agility. His particularly free manner of
dancing even surprised them all. Nicholas was himself rather surprised
at the way he danced that evening. He had never danced like that in
Moscow and would even have considered such a very free and easy manner
improper and in bad form, but here he felt it incumbent on him to
astonish them all by something unusual, something they would have to
accept as the regular thing in the capital though new to them in the
provinces.

All the evening Nicholas paid attention to a blue-eyed, plump and
pleasing little blonde, the wife of one of the provincial officials.
With the naive conviction of young men in a merry mood that other
men's wives were created for them, Rostov did not leave the lady's
side and treated her husband in a friendly and conspiratorial style,
as if, without speaking of it, they knew how capitally Nicholas and
the lady would get on together. The husband, however, did not seem
to share that conviction and tried to behave morosely with Rostov. But
the latter's good-natured naivete was so boundless that sometimes even
he involuntarily yielded to Nicholas' good humor. Toward the end of
the evening, however, as the wife's face grew more flushed and
animated, the husband's became more and more melancholy and solemn, as
though there were but a given amount of animation between them and
as the wife's share increased the husband's diminished.





CHAPTER V


Nicholas sat leaning slightly forward in an armchair, bending
closely over the blonde lady and paying her mythological compliments
with a smile that never left his face. Jauntily shifting the
position of his legs in their tight riding breeches, diffusing an odor
of perfume, and admiring his partner, himself, and the fine outlines
of his legs in their well-fitting Hessian boots, Nicholas told the
blonde lady that he wished to run away with a certain lady here in
Voronezh.

"Which lady?"

"A charming lady, a divine one. Her eyes" (Nicholas looked at his
partner) "are blue, her mouth coral and ivory; her figure" (he glanced
at her shoulders) "like Diana's...."

The husband came up and sullenly asked his wife what she was talking
about.

"Ah, Nikita Ivanych!" cried Nicholas, rising politely, and as if
wishing Nikita Ivanych to share his joke, he began to tell him of
his intention to elope with a blonde lady.

The husband smiled gloomily, the wife gaily. The governor's
good-natured wife came up with a look of disapproval.

"Anna Ignatyevna wants to see you, Nicholas," said she,
pronouncing the name so that Nicholas at once understood that Anna
Ignatyevna was a very important person. "Come, Nicholas! You know
you let me call you so?"

"Oh, yes, Aunt. Who is she?"

"Anna Ignatyevna Malvintseva. She has heard from her niece how you
rescued her... Can you guess?"

"I rescued such a lot of them!" said Nicholas.

"Her niece, Princess Bolkonskaya. She is here in Voronezh with her
aunt. Oho! How you blush. Why, are...?"

"Not a bit! Please don't, Aunt!"

"Very well, very well!... Oh, what a fellow you are!"

The governor's wife led him up to a tall and very stout old lady
with a blue headdress, who had just finished her game of cards with
the most important personages of the town. This was Malvintseva,
Princess Mary's aunt on her mother's side, a rich, childless widow who
always lived in Voronezh. When Rostov approached her she was
standing settling up for the game. She looked at him and, screwing
up her eyes sternly, continued to upbraid the general who had won from
her.

"Very pleased, mon cher," she then said, holding out her hand to
Nicholas. "Pray come and see me."

After a few words about Princess Mary and her late father, whom
Malvintseva had evidently not liked, and having asked what Nicholas
knew of Prince Andrew, who also was evidently no favorite of hers, the
important old lady dismissed Nicholas after repeating her invitation
to come to see her.

Nicholas promised to come and blushed again as he bowed. At the
mention of Princess Mary he experienced a feeling of shyness and
even of fear, which he himself did not understand.

When he had parted from Malvintseva Nicholas wished to return to the
dancing, but the governor's little wife placed her plump hand on his
sleeve and, saying that she wanted to have a talk with him, led him to
her sitting room, from which those who were there immediately withdrew
so as not to be in her way.

"Do you know, dear boy," began the governor's wife with a serious
expression on her kind little face, "that really would be the match
for you: would you like me to arrange it?"

"Whom do you mean, Aunt?" asked Nicholas.

"I will make a match for you with the princess. Catherine Petrovna
speaks of Lily, but I say, no--the princess! Do you want me to do
it? I am sure your mother will be grateful to me. What a charming girl
she is, really! And she is not at all so plain, either."

"Not at all," replied Nicholas as if offended at the idea. "As
befits a soldier, Aunt, I don't force myself on anyone or refuse
anything," he said before he had time to consider what he was saying.

"Well then, remember, this is not a joke!"

"Of course not!"

"Yes, yes," the governor's wife said as if talking to herself. "But,
my dear boy, among other things you are too attentive to the other,
the blonde. One is sorry for the husband, really...."

"Oh no, we are good friends with him," said Nicholas in the
simplicity of his heart; it did not enter his head that a pastime so
pleasant to himself might not be pleasant to someone else.

"But what nonsense I have been saying to the governor's wife!"
thought Nicholas suddenly at supper. "She will really begin to arrange
a match... and Soyna...?" And on taking leave of the governor's
wife, when she again smilingly said to him, "Well then, remember!"
he drew her aside.

"But see here, to tell the truth, Aunt..."

"What is it, my dear? Come, let's sit down here," said she.

Nicholas suddenly felt a desire and need to tell his most intimate
thoughts (which he would not have told to his mother, his sister, or
his friend) to this woman who was almost a stranger. When he
afterwards recalled that impulse to unsolicited and inexplicable
frankness which had very important results for him, it seemed to
him--as it seems to everyone in such cases--that it was merely some
silly whim that seized him: yet that burst of frankness, together with
other trifling events, had immense consequences for him and for all
his family.

"You see, Aunt, Mamma has long wanted me to marry an heiress, but
the very idea of marrying for money is repugnant to me."

"Oh yes, I understand," said the governor's wife.

"But Princess Bolkonskaya--that's another matter. I will tell you
the truth. In the first place I like her very much, I feel drawn to
her; and then, after I met her under such circumstances--so strangely,
the idea often occurred to me: 'This is fate.' Especially if you
remember that Mamma had long been thinking of it; but I had never
happened to meet her before, somehow it had always happened that we
did not meet. And as long as my sister Natasha was engaged to her
brother it was of course out of the question for me to think of
marrying her. And it must needs happen that I should meet her just
when Natasha's engagement had been broken off... and then
everything... So you see... I never told this to anyone and never
will, only to you."

The governor's wife pressed his elbow gratefully.

"You know Sonya, my cousin? I love her, and promised to marry her,
and will do so.... So you see there can be no question about-" said
Nicholas incoherently and blushing.

"My dear boy, what a way to look at it! You know Sonya has nothing
and you yourself say your Papa's affairs are in a very bad way. And
what about your mother? It would kill her, that's one thing. And
what sort of life would it be for Sonya--if she's a girl with a heart?
Your mother in despair, and you all ruined.... No, my dear, you and
Sonya ought to understand that."

Nicholas remained silent. It comforted him to hear these arguments.

"All the same, Aunt, it is impossible," he rejoined with a sigh,
after a short pause. "Besides, would the princess have me? And
besides, she is now in mourning. How can one think of it!"

"But you don't suppose I'm going to get you married at once? There
is always a right way of doing things," replied the governor's wife.

"What a matchmaker you are, Aunt..." said Nicholas, kissing her
plump little hand.





CHAPTER VI


On reaching Moscow after her meeting with Rostov, Princess Mary
had found her nephew there with his tutor, and a letter from Prince
Andrew giving her instructions how to get to her Aunt Malvintseva at
Voronezh. That feeling akin to temptation which had tormented her
during her father's illness, since his death, and especially since her
meeting with Rostov was smothered by arrangements for the journey,
anxiety about her brother, settling in a new house, meeting new
people, and attending to her nephew's education. She was sad. Now,
after a month passed in quiet surroundings, she felt more and more
deeply the loss of her father which was associated in her mind with
the ruin of Russia. She was agitated and incessantly tortured by the
thought of the dangers to which her brother, the only intimate
person now remaining to her, was exposed. She was worried too about
her nephew's education for which she had always felt herself
incompetent, but in the depths of her soul she felt at peace--a
peace arising from consciousness of having stifled those personal
dreams and hopes that had been on the point of awakening within her
and were related to her meeting with Rostov.

The day after her party the governor's wife came to see
Malvintseva and, after discussing her plan with the aunt, remarked
that though under present circumstances a formal betrothal was, of
course, not to be thought of, all the same the young people might be
brought together and could get to know one another. Malvintseva
expressed approval, and the governor's wife began to speak of Rostov
in Mary's presence, praising him and telling how he had blushed when
Princess Mary's name was mentioned. But Princess Mary experienced a
painful rather than a joyful feeling--her mental tranquillity was
destroyed, and desires, doubts, self-reproach, and hopes reawoke.

During the two days that elapsed before Rostov called, Princess Mary
continually thought of how she ought to behave to him. First she
decided not to come to the drawing room when he called to see her
aunt--that it would not be proper for her, in her deep mourning, to
receive visitors; then she thought this would be rude after what he
had done for her; then it occurred to her that her aunt and the
governor's wife had intentions concerning herself and Rostov--their
looks and words at times seemed to confirm this supposition--then
she told herself that only she, with her sinful nature, could think
this of them: they could not forget that situated as she was, while
still wearing deep mourning, such matchmaking would be an insult to
her and to her father's memory. Assuming that she did go down to see
him, Princess Mary imagined the words he would say to her and what she
would say to him, and these words sometimes seemed undeservedly cold
and then to mean too much. More than anything she feared lest the
confusion she felt might overwhelm her and betray her as soon as she
saw him.

But when on Sunday after church the footman announced in the drawing
room that Count Rostov had called, the princess showed no confusion,
only a slight blush suffused her cheeks and her eyes lit up with a new
and radiant light.

"You have met him, Aunt?" said she in a calm voice, unable herself
to understand that she could be outwardly so calm and natural.

When Rostov entered the room, the princess dropped her eyes for an
instant, as if to give the visitor time to greet her aunt, and then
just as Nicholas turned to her she raised her head and met his look
with shining eyes. With a movement full of dignity and grace she
half rose with a smile of pleasure, held out her slender, delicate
hand to him, and began to speak in a voice in which for the first time
new deep womanly notes vibrated. Mademoiselle Bourienne, who was in
the drawing room, looked at Princess Mary in bewildered surprise.
Herself a consummate coquette, she could not have maneuvered better on
meeting a man she wished to attract.

"Either black is particularly becoming to her or she really has
greatly improved without my having noticed it. And above all, what
tact and grace!" thought Mademoiselle Bourienne.

Had Princess Mary been capable of reflection at that moment, she
would have been more surprised than Mademoiselle Bourienne at the
change that had taken place in herself. From the moment she recognized
that dear, loved face, a new life force took possession of her and
compelled her to speak and act apart from her own will. From the
time Rostov entered, her face became suddenly transformed. It was as
if a light had been kindled in a carved and painted lantern and the
intricate, skillful, artistic work on its sides, that previously
seemed dark, coarse, and meaningless, was suddenly shown up in
unexpected and striking beauty. For the first time all that pure,
spiritual, inward travail through which she had lived appeared on
the surface. All her inward labor, her dissatisfaction with herself,
her sufferings, her strivings after goodness, her meekness, love,
and self-sacrifice--all this now shone in those radiant eyes, in her
delicate smile, and in every trait of her gentle face.

Rostov saw all this as clearly as if he had known her whole life. He
felt that the being before him was quite different from, and better
than, anyone he had met before, and above all better than himself.

Their conversation was very simple and unimportant. They spoke of
the war, and like everyone else unconsciously exaggerated their sorrow
about it; they spoke of their last meeting--Nicholas trying to
change the subject--they talked of the governor's kind wife, of
Nicholas' relations, and of Princess Mary's.

She did not talk about her brother, diverting the conversation as
soon as her aunt mentioned Andrew. Evidently she could speak of
Russia's misfortunes with a certain artificiality, but her brother was
too near her heart and she neither could nor would speak lightly of
him. Nicholas noticed this, as he noticed every shade of Princess
Mary's character with an observation unusual to him, and everything
confirmed his conviction that she was a quite unusual and
extraordinary being. Nicholas blushed and was confused when people
spoke to him about the princess (as she did when he was mentioned) and
even when he thought of her, but in her presence he felt quite at
ease, and said not at all what he had prepared, but what, quite
appropriately, occurred to him at the moment.

When a pause occurred during his short visit, Nicholas, as is
usual when there are children, turned to Prince Andrew's little son,
caressing him and asking whether he would like to be an hussar. He
took the boy on his knee, played with him, and looked round at
Princess Mary. With a softened, happy, timid look she watched the
boy she loved in the arms of the man she loved. Nicholas also
noticed that look and, as if understanding it, flushed with pleasure
and began to kiss the boy with good natured playfulness.

As she was in mourning Princess Mary did not go out into society,
and Nicholas did not think it the proper thing to visit her again; but
all the same the governor's wife went on with her matchmaking, passing
on to Nicholas the flattering things Princess Mary said of him and
vice versa, and insisting on his declaring himself to Princess Mary.
For this purpose she arranged a meeting between the young people at
the bishop's house before Mass.

Though Rostov told the governeor's wife that he would not make any
declaration to Princess Mary, he promised to go.

As at Tilsit Rostov had not allowed himself to doubt that what
everybody considered right was right, so now, after a short but
sincere struggle between his effort to arrange his life by his own
sense of justice, and in obedient submission to circumstances, he
chose the latter and yielded to the power he felt irresistibly
carrying him he knew not where. He knew that after his promise to
Sonya it would be what he deemed base to declare his feelings to
Princess Mary. And he knew that he would never act basely. But he also
knew (or rather felt at the bottom of his heart) that by resigning
himself now to the force of circumstances and to those who were
guiding him, he was not only doing nothing wrong, but was doing
something very important--more important than anything he had ever
done in his life.

After meeting Princess Mary, though the course of his life went on
externally as before, all his former amusements lost their charm for
him and he often thought about her. But he never thought about her
as he had thought of all the young ladies without exception whom he
had met in society, nor as he had for a long time, and at one time
rapturously, thought about Sonya. He had pictured each of those
young ladies as almost all honest-hearted young men do, that is, as
a possible wife, adapting her in his imagination to all the conditions
of married life: a white dressing gown, his wife at the tea table, his
wife's carriage, little ones, Mamma and Papa, their relations to
her, and so on--and these pictures of the future had given him
pleasure. But with Princess Mary, to whom they were trying to get
him engaged, he could never picture anything of future married life.
If he tried, his pictures seemed incongruous and false. It made him
afraid.





CHAPTER VII


The dreadful news of the battle of Borodino, of our losses in killed
and wounded, and the still more terrible news of the loss of Moscow
reached Voronezh in the middle of September. Princess Mary, having
learned of her brother's wound only from the Gazette and having no
definite news of him, prepared (so Nicholas heard, he had not seen her
again himself) to set off in search of Prince Andrew.

When he received the news of the battle of Borodino and the
abandonment of Moscow, Rostov was not seized with despair, anger,
the desire for vengeance, or any feeling of that kind, but
everything in Voronezh suddenly seemed to him dull and tiresome, and
he experienced an indefinite feeling of shame and awkwardness. The
conversations he heard seemed to him insincere; he did not know how to
judge all these affairs and felt that only in the regiment would
everything again become clear to him. He made haste to finish buying
the horses, and often became unreasonably angry with his servant and
squadron quartermaster.

A few days before his departure a special thanksgiving, at which
Nicholas was present, was held in the cathedral for the Russian
victory. He stood a little behind the governor and held himself with
military decorum through the service, meditating on a great variety of
subjects. When the service was over the governor's wife beckoned him
to her.

"Have you seen the princess?" she asked, indicating with a
movement of her head a lady standing on the opposite side, beyond
the choir.

Nicholas immediately recognized Princess Mary not so much by the
profile he saw under her bonnet as by the feeling of solicitude,
timidity, and pity that immediately overcame him. Princess Mary,
evidently engrossed by her thoughts, was crossing herself for the last
time before leaving the church.

Nicholas looked at her face with surprise. It was the same face he
had seen before, there was the same general expression of refined,
inner, spiritual labor, but now it was quite differently lit up. There
was a pathetic expression of sorrow, prayer, and hope in it. As had
occurred before when she was present, Nicholas went up to her
without waiting to be prompted by the governor's wife and not asking
himself whether or not it was right and proper to address her here
in church, and told her he had heard of her trouble and sympathized
with his whole soul. As soon as she heard his voice a vivid glow
kindled in her face, lighting up both her sorrow and her joy.

"There is one thing I wanted to tell you, Princess," said Rostov.
"It is that if your brother, Prince Andrew Nikolievich, were not
living, it would have been at once announced in the Gazette, as he
is a colonel."

The princess looked at him, not grasping what he was saying, but
cheered by the expression of regretful sympathy on his face.

"And I have known so many cases of a splinter wound" (the Gazette
said it was a shell) "either proving fatal at once or being very
slight," continued Nicholas. "We must hope for the best, and I am
sure..."

Princess Mary interrupted him.

"Oh, that would be so dread..." she began and, prevented by
agitation from finishing, she bent her head with a movement as
graceful as everything she did in his presence and, looking up at
him gratefully, went out, following her aunt.

That evening Nicholas did not go out, but stayed at home to settle
some accounts with the horse dealers. When he had finished that
business it was already too late to go anywhere but still too early to
go to bed, and for a long time he paced up and down the room,
reflecting on his life, a thing he rarely did.

Princess Mary had made an agreeable impression on him when he had
met her in Smolensk province. His having encountered her in such
exceptional circumstances, and his mother having at one time mentioned
her to him as a good match, had drawn his particular attention to her.
When he met her again in Voronezh the impression she made on him was
not merely pleasing but powerful. Nicholas had been struck by the
peculiar moral beauty he observed in her at this time. He was,
however, preparing to go away and it had not entered his head to
regret that he was thus depriving himself of chances of meeting her.
But that day's encounter in church had, he felt, sunk deeper than
was desirable for his peace of mind. That pale, sad, refined face,
that radiant look, those gentle graceful gestures, and especially
the deep and tender sorrow expressed in all her features agitated
him and evoked his sympathy. In men Rostov could not bear to see the
expression of a higher spiritual life (that was why he did not like
Prince Andrew) and he referred to it contemptuously as philosophy
and dreaminess, but in Princess Mary that very sorrow which revealed
the depth of a whole spiritual world foreign to him was an
irresistible attraction.

"She must be a wonderful woman. A real angel!" he said to himself.
"Why am I not free? Why was I in such a hurry with Sonya?" And he
involuntarily compared the two: the lack of spirituality in the one
and the abundance of it in the other--a spirituality he himself lacked
and therefore valued most highly. He tried to picture what would
happen were he free. How he would propose to her and how she would
become his wife. But no, he could not imagine that. He felt awed,
and no clear picture presented itself to his mind. He had long ago
pictured to himself a future with Sonya, and that was all clear and
simple just because it had all been thought out and he knew all
there was in Sonya, but it was impossible to picture a future with
Princess Mary, because he did not understand her but simply loved her.

Reveries about Sonya had had something merry and playful in them,
but to dream of Princess Mary was always difficult and a little
frightening.

"How she prayed!" he thought. "It was plain that her whole soul
was in her prayer. Yes, that was the prayer that moves mountains,
and I am sure her prayer will be answered. Why don't I pray for what I
want?" he suddenly thought. "What do I want? To be free, released from
Sonya... She was right," he thought, remembering what the governor's
wife had said: "Nothing but misfortune can come of marrying Sonya.
Muddles, grief for Mamma... business difficulties... muddles, terrible
muddles! Besides, I don't love her--not as I should. O, God! release
me from this dreadful, inextricable position!" he suddenly began to
pray. "Yes, prayer can move mountains, but one must have faith and not
pray as Natasha and I used to as children, that the snow might turn
into sugar--and then run out into the yard to see whether it had
done so. No, but I am not praying for trifles now," he thought as he
put his pipe down in a corner, and folding his hands placed himself
before the icon. Softened by memories of Princess Mary he began to
pray as he had not done for a long time. Tears were in his eyes and in
his throat when the door opened and Lavrushka came in with some
papers.

"Blockhead! Why do you come in without being called?" cried
Nicholas, quickly changing his attitude.

"From the governor," said Lavrushka in a sleepy voice. "A courier
has arrived and there's a letter for you."

"Well, all right, thanks. You can go!"

Nicholas took the two letters, one of which was from his mother
and the other from Sonya. He recognized them by the handwriting and
opened Sonya's first. He had read only a few lines when he turned pale
and his eyes opened wide with fear and joy.

"No, it's not possible!" he cried aloud.

Unable to sit still he paced up and down the room holding the letter
and reading it. He glanced through it, then read it again, and then
again, and standing still in the middle of the room he raised his
shoulders, stretching out his hands, with his mouth wide open and
his eyes fixed. What he had just been praying for with confidence that
God would hear him had come to pass; but Nicholas was as much
astonished as if it were something extraordinary and unexpected, and
as if the very fact that it had happened so quickly proved that it had
not come from God to whom he had prayed, but by some ordinary
coincidence.

This unexpected and, as it seemed to Nicholas, quite voluntary
letter from Sonya freed him from the knot that fettered him and from
which there had seemed no escape. She wrote that the last
unfortunate events--the loss of almost the whole of the Rostovs'
Moscow property--and the countess' repeatedly expressed wish that
Nicholas should marry Princess Bolkonskaya, together with his
silence and coldness of late, had all combined to make her decide to
release him from his promise and set him completely free.


It would be too painful to me to think that I might be a cause of
sorrow or discord in the family that has been so good to me (she
wrote), and my love has no aim but the happiness of those I love;
so, Nicholas, I beg you to consider yourself free, and to be assured
that, in spite of everything, no one can love you more than does

Your Sonya


Both letters were written from Troitsa. The other, from the
countess, described their last days in Moscow, their departure, the
fire, and the destruction of all their property. In this letter the
countess also mentioned that Prince Andrew was among the wounded
traveling with them; his state was very critical, but the doctor
said there was now more hope. Sonya and Natasha were nursing him.

Next day Nicholas took his mother's letter and went to see
Princess Mary. Neither he nor she said a word about what "Natasha
nursing him" might mean, but thanks to this letter Nicholas suddenly
became almost as intimate with the princess as if they were relations.

The following day he saw Princess Mary off on her journey to
Yaroslavl, and a few days later left to rejoin his regiment.





CHAPTER VIII


Sonya's letter written from Troitsa, which had come as an answer
to Nicholas' prayer, was prompted by this: the thought of getting
Nicholas married to an heiress occupied the old countess' mind more
and more. She knew that Sonya was the chief obstacle to this
happening, and Sonya's life in the countess' house had grown harder
and harder, especially after they had received a letter from
Nicholas telling of his meeting with Princess Mary in Bogucharovo. The
countess let no occasion slip of making humiliating or cruel allusions
to Sonya.

But a few days before they left Moscow, moved and excited by all
that was going on, she called Sonya to her and, instead of reproaching
and making demands on her, tearfully implored her to sacrifice herself
and repay all that the family had done for her by breaking off her
engagement with Nicholas.

"I shall not be at peace till you promise me this."

Sonya burst into hysterical tears and replied through her sobs
that she would do anything and was prepared for anything, but gave
no actual promise and could not bring herself to decide to do what was
demanded of her. She must sacrifice herself for the family that had
reared and brought her up. To sacrifice herself for others was Sonya's
habit. Her position in the house was such that only by sacrifice could
she show her worth, and she was accustomed to this and loved doing it.
But in all her former acts of self-sacrifice she had been happily
conscious that they raised her in her own esteem and in that of
others, and so made her more worthy of Nicholas whom she loved more
than anything in the world. But now they wanted her to sacrifice the
very thing that constituted the whole reward for her self-sacrifice
and the whole meaning of her life. And for the first time she felt
bitterness against those who had been her benefactors only to
torture her the more painfully; she felt jealous of Natasha who had
never experienced anything of this sort, had never needed to sacrifice
herself, but made others sacrifice themselves for her and yet was
beloved by everybody. And for the first time Sonya felt that out of
her pure, quiet love for Nicholas a passionate feeling was beginning
to grow up which was stronger than principle, virtue, or religion.
Under the influence of this feeling Sonya, whose life of dependence
had taught her involuntarily to be secretive, having answered the
countess in vague general terms, avoided talking with her and resolved
to wait till she should see Nicholas, not in order to set him free but
on the contrary at that meeting to bind him to her forever.

The bustle and terror of the Rostovs' last days in Moscow stifled
the gloomy thoughts that oppressed Sonya. She was glad to find
escape from them in practical activity. But when she heard of Prince
Andrew's presence in their house, despite her sincere pity for him and
for Natasha, she was seized by a joyful and superstitious feeling that
God did not intend her to be separated from Nicholas. She knew that
Natasha loved no one but Prince Andrew and had never ceased to love
him. She knew that being thrown together again under such terrible
circumstances they would again fall in love with one another, and that
Nicholas would then not be able to marry Princess Mary as they would
be within the prohibited degrees of affinity. Despite all the terror
of what had happened during those last days and during the first
days of their journey, this feeling that Providence was intervening in
her personal affairs cheered Sonya.

At the Troitsa monastery the Rostovs first broke their journey for a
whole day.

Three large rooms were assigned to them in the monastery hostelry,
one of which was occupied by Prince Andrew. The wounded man was much
better that day and Natasha was sitting with him. In the next room sat
the count and countess respectfully conversing with the prior, who was
calling on them as old acquaintances and benefactors of the monastery.
Sonya was there too, tormented by curiosity as to what Prince Andrew
and Natasha were talking about. She heard the sound of their voices
through the door. That door opened and Natasha came out, looking
excited. Not noticing the monk, who had risen to greet her and was
drawing back the wide sleeve on his right arm, she went up to Sonya
and took her hand.

"Natasha, what are you about? Come here!" said the countess.

Natasha went up to the monk for his blessing, and advised her to
pray for aid to God and His saint.

As soon as the prior withdrew, Natasha took her friend by the hand
and went with her into the unoccupied room.

"Sonya, will he live?" she asked. "Sonya, how happy I am, and how
unhappy!... Sonya, dovey, everything is as it used to be. If only he
lives! He cannot... because... because... of" and Natasha burst into
tears.

"Yes! I knew it! Thank God!" murmured Sonya. "He will live."

Sonya was not less agitated than her friend by the latter's fear and
grief and by her own personal feelings which she shared with no one.
Sobbing, she kissed and comforted Natasha. "If only he lives!" she
thought. Having wept, talked, and wiped away their tears, the two
friends went together to Prince Andrew's door. Natasha opened it
cautiously and glanced into the room, Sonya standing beside her at the
half-open door.

Prince Andrew was lying raised high on three pillows. His pale
face was calm, his eyes closed, and they could see his regular
breathing.

"O, Natasha!" Sonya suddenly almost screamed, catching her
companion's arm and stepping back from the door.

"What? What is it?" asked Natasha.

"It's that, that..." said Sonya, with a white face and trembling
lips.

Natasha softly closed the door and went with Sonya to the window,
not yet understanding what the latter was telling her.

"You remember," said Sonya with a solemn and frightened
expression. "You remember when I looked in the mirror for you... at
Otradnoe at Christmas? Do you remember what I saw?"

"Yes, yes!" cried Natasha opening her eyes wide, and vaguely
recalling that Sonya had told her something about Prince Andrew whom
she had seen lying down.

"You remember?" Sonya went on. "I saw it then and told everybody,
you and Dunyasha. I saw him lying on a bed," said she, making a
gesture with her hand and a lifted finger at each detail, "and that he
had his eyes closed and was covered just with a pink quilt, and that
his hands were folded," she concluded, convincing herself that the
details she had just seen were exactly what she had seen in the
mirror.

She had in fact seen nothing then but had mentioned the first
thing that came into her head, but what she had invented then seemed
to her now as real as any other recollection. She not only
remembered what she had then said--that he turned to look at her and
smiled and was covered with something red--but was firmly convinced
that she had then seen and said that he was covered with a pink
quilt and that his eyes were closed.

"Yes, yes, it really was pink!" cried Natasha, who now thought she
too remembered the word pink being used, and saw in this the most
extraordinary and mysterious part of the prediction.

"But what does it mean?" she added meditatively.

"Oh, I don't know, it is all so strange," replied Sonya, clutching
at her head.

A few minutes later Prince Andrew rang and Natasha went to him,
but Sonya, feeling unusually excited and touched, remained at the
window thinking about the strangeness of what had occurred.


They had an opportunity that day to send letters to the army, and
the countess was writing to her son.

"Sonya!" said the countess, raising her eyes from her letter as
her niece passed, "Sonya, won't you write to Nicholas?" She spoke in a
soft, tremulous voice, and in the weary eyes that looked over her
spectacles Sonya read all that the countess meant to convey with these
words. Those eyes expressed entreaty, shame at having to ask, fear
of a refusal, and readiness for relentless hatred in case of such
refusal.

Sonya went up to the countess and, kneeling down, kissed her hand.

"Yes, Mamma, I will write," said she.

Sonya was softened, excited, and touched by all that had occurred
that day, especially by the mysterious fulfillment she had just seen
of her vision. Now that she knew that the renewal of Natasha's
relations with Prince Andrew would prevent Nicholas from marrying
Princess Mary, she was joyfully conscious of a return of that
self-sacrificing spirit in which she was accustomed to live and
loved to live. So with a joyful consciousness of performing a
magnanimous deed--interrupted several times by the tears that dimmed
her velvety black eyes--she wrote that touching letter the arrival
of which had so amazed Nicholas.





CHAPTER IX


The officer and soldiers who had arrested Pierre treated him with
hostility but yet with respect, in the guardhouse to which he was
taken. In their attitude toward him could still be felt both
uncertainty as to who he might be--perhaps a very important person-
and hostility as a result of their recent personal conflict with him.

But when the guard was relieved next morning, Pierre felt that for
the new guard--both officers and men--he was not as interesting as
he had been to his captors; and in fact the guard of the second day
did not recognize in this big, stout man in a peasant coat the
vigorous person who had fought so desperately with the marauder and
the convoy and had uttered those solemn words about saving a child;
they saw in him only No. 17 of the captured Russians, arrested and
detained for some reason by order of the Higher Command. If they
noticed anything remarkable about Pierre, it was only his unabashed,
meditative concentration and thoughtfulness, and the way he spoke
French, which struck them as surprisingly good. In spite of this he
was placed that day with the other arrested suspects, as the
separate room he had occupied was required by an officer.

All the Russians confined with Pierre were men of the lowest class
and, recognizing him as a gentleman, they all avoided him, more
especially as he spoke French. Pierre felt sad at hearing them
making fun of him.

That evening he learned that all these prisoners (he, probably,
among them) were to be tried for incendiarism. On the third day he was
taken with the others to a house where a French general with a white
mustache sat with two colonels and other Frenchmen with scarves on
their arms. With the precision and definiteness customary in
addressing prisoners, and which is supposed to preclude human frailty,
Pierre like the others was questioned as to who he was, where he had
been, with what object, and so on.

These questions, like questions put at trials generally, left the
essence of the matter aside, shut out the possibility of that
essence's being revealed, and were designed only to form a channel
through which the judges wished the answers of the accused to flow
so as to lead to the desired result, namely a conviction. As soon as
Pierre began to say anything that did not fit in with that aim, the
channel was removed and the water could flow to waste. Pierre felt,
moreover, what the accused always feel at their trial, perplexity as
to why these questions were put to him. He had a feeling that it was
only out of condescension or a kind of civility that this device of
placing a channel was employed. He knew he was in these men's power,
that only by force had they brought him there, that force alone gave
them the right to demand answers to their questions, and that the sole
object of that assembly was to inculpate him. And so, as they had
the power and wish to inculpate him, this expedient of an inquiry
and trial seemed unnecessary. It was evident that any answer would
lead to conviction. When asked what he was doing when he was arrested,
Pierre replied in a rather tragic manner that he was restoring to
its parents a child he had saved from the flames. Why had he fought
the marauder? Pierre answered that he "was protecting a woman," and
that "to protect a woman who was being insulted was the duty of
every man; that..." They interrupted him, for this was not to the
point. Why was he in the yard of a burning house where witnesses had
seen him? He replied that he had gone out to see what was happening in
Moscow. Again they interrupted him: they had not asked where he was
going, but why he was found near the fire? Who was he? they asked,
repeating their first question, which he had declined to answer. Again
he replied that he could not answer it.

"Put that down, that's bad... very bad," sternly remarked the
general with the white mustache and red flushed face.


On the fourth day fires broke out on the Zubovski rampart.

Pierre and thirteen others were moved to the coach house of a
merchant's house near the Crimean bridge. On his way through the
streets Pierre felt stifled by the smoke which seemed to hang over the
whole city. Fires were visible on all sides. He did not then realize
the significance of the burning of Moscow, and looked at the fires
with horror.

He passed four days in the coach house near the Crimean bridge and
during that time learned, from the talk of the French soldiers, that
all those confined there were awaiting a decision which might come any
day from the marshal. What marshal this was, Pierre could not learn
from the soldiers. Evidently for them "the marshal" represented a very
high and rather mysterious power.

These first days, before the eighth of September when the
prisoners were had up for a second examination, were the hardest of
all for Pierre.





CHAPTER X


On the eighth of September an officer--a very important one
judging by the respect the guards showed him--entered the coach
house where the prisoners were. This officer, probably someone on
the staff, was holding a paper in his hand, and called over all the
Russians there, naming Pierre as "the man who does not give his name."
Glancing indolently and indifferently at all the prisoners, he ordered
the officer in charge to have them decently dressed and tidied up
before taking them to the marshal. An hour later a squad of soldiers
arrived and Pierre with thirteen others was led to the Virgin's Field.
It was a fine day, sunny after rain, and the air was unusually pure.
The smoke did not hang low as on the day when Pierre had been taken
from the guardhouse on the Zubovski rampart, but rose through the pure
air in columns. No flames were seen, but columns of smoke rose on
all sides, and all Moscow as far as Pierre could see was one vast
charred ruin. On all sides there were waste spaces with only stoves
and chimney stacks still standing, and here and there the blackened
walls of some brick houses. Pierre gazed at the ruins and did not
recognize districts he had known well. Here and there he could see
churches that had not been burned. The Kremlin, which was not
destroyed, gleamed white in the distance with its towers and the
belfry of Ivan the Great. The domes of the New Convent of the Virgin
glittered brightly and its bells were ringing particularly clearly.
These bells reminded Pierre that it was Sunday and the feast of the
Nativity of the Virgin. But there seemed to be no one to celebrate
this holiday: everywhere were blackened ruins, and the few Russians to
be seen were tattered and frightened people who tried to hide when
they saw the French.

It was plain that the Russian nest was ruined and destroyed, but
in place of the Russian order of life that had been destroyed,
Pierre unconsciously felt that a quite different, firm, French order
had been established over this ruined nest. He felt this in the
looks of the soldiers who, marching in regular ranks briskly and
gaily, were escorting him and the other criminals; he felt it in the
looks of an important French official in a carriage and pair driven by
a soldier, whom they met on the way. He felt it in the merry sounds of
regimental music he heard from the left side of the field, and felt
and realized it especially from the list of prisoners the French
officer had read out when he came that morning. Pierre had been
taken by one set of soldiers and led first to one and then to
another place with dozens of other men, and it seemed that they
might have forgotten him, or confused him with the others. But no: the
answers he had given when questioned had come back to him in his
designation as "the man who does not give his name," and under that
appellation, which to Pierre seemed terrible, they were now leading
him somewhere with unhesitating assurance on their faces that he and
all the other prisoners were exactly the ones they wanted and that
they were being taken to the proper place. Pierre felt himself to be
an insignificant chip fallen among the wheels of a machine whose
action he did not understand but which was working well.

He and the other prisoners were taken to the right side of the
Virgin's Field, to a large white house with an immense garden not
far from the convent. This was Prince Shcherbitov's house, where
Pierre had often been in other days, and which, as he learned from the
talk of the soldiers, was now occupied by the marshal, the Duke of
Eckmuhl (Davout).

They were taken to the entrance and led into the house one by one.
Pierre was the sixth to enter. He was conducted through a glass
gallery, an anteroom, and a hall, which were familiar to him, into a
long low study at the door of which stood an adjutant.

Davout, spectacles on nose, sat bent over a table at the further end
of the room. Pierre went close up to him, but Davout, evidently
consulting a paper that lay before him, did not look up. Without
raising his eyes, he said in a low voice:

"Who are you?"

Pierre was silent because he was incapable of uttering a word. To
him Davout was not merely a French general, but a man notorious for
his cruelty. Looking at his cold face, as he sat like a stern
schoolmaster who was prepared to wait awhile for an answer, Pierre
felt that every instant of delay might cost him his life; but he did
not know what to say. He did not venture to repeat what he had said at
his first examination, yet to disclose his rank and position was
dangerous and embarrassing. So he was silent. But before he had
decided what to do, Davout raised his head, pushed his spectacles back
on his forehead, screwed up his eyes, and looked intently at him.

"I know that man," he said in a cold, measured tone, evidently
calculated to frighten Pierre.

The chill that had been running down Pierre's back now seized his
head as in a vise.

"You cannot know me, General, I have never seen you..."

"He is a Russian spy," Davout interrupted, addressing another
general who was present, but whom Pierre had not noticed.

Davout turned away. With an unexpected reverberation in his voice
Pierre rapidly began:

"No, monseigneur," he said, suddenly remembering that Davout was a
duke. "No, monseigneur, you cannot have known me. I am a militia
officer and have not quitted Moscow."

"Your name?" asked Davout.

"Bezukhov."

"What proof have I that you are not lying?"

"Monseigneur!" exclaimed Pierre, not in an offended but in a
pleading voice.

Davout looked up and gazed intently at him. For some seconds they
looked at one another, and that look saved Pierre. Apart from
conditions of war and law, that look established human relations
between the two men. At that moment an immense number of things passed
dimly through both their minds, and they realized that they were
both children of humanity and were brothers.

At the first glance, when Davout had only raised his head from the
papers where human affairs and lives were indicated by numbers, Pierre
was merely a circumstance, and Davout could have shot him without
burdening his conscience with an evil deed, but now he saw in him a
human being. He reflected for a moment.

"How can you show me that you are telling the truth?" said Davout
coldly.

Pierre remembered Ramballe, and named him and his regiment and the
street where the house was.

"You are not what you say," returned Davout.

In a trembling, faltering voice Pierre began adducing proofs of
the truth of his statements.

But at that moment an adjutant entered and reported something to
Davout.

Davout brightened up at the news the adjutant brought, and began
buttoning up his uniform. It seemed that he had quite forgotten
Pierre.

When the adjutant reminded him of the prisoner, he jerked his head
in Pierre's direction with a frown and ordered him to be led away. But
where they were to take him Pierre did not know: back to the coach
house or to the place of execution his companions had pointed out to
him as they crossed the Virgin's Field.

He turned his head and saw that the adjutant was putting another
question to Davout.

"Yes, of course!" replied Davout, but what this "yes" meant,
Pierre did not know.

Pierre could not afterwards remember how he went, whether it was
far, or in which direction. His faculties were quite numbed, he was
stupefied, and noticing nothing around him went on moving his legs
as the others did till they all stopped and he stopped too. The only
thought in his mind at that time was: who was it that had really
sentenced him to death? Not the men on the commission that had first
examined him--not one of them wished to or, evidently, could have done
it. It was not Davout, who had looked at him in so human a way. In
another moment Davout would have realized that he was doing wrong, but
just then the adjutant had come in and interrupted him. The
adjutant, also, had evidently had no evil intent though he might
have refrained from coming in. Then who was executing him, killing
him, depriving him of life--him, Pierre, with all his memories,
aspirations, hopes, and thoughts? Who was doing this? And Pierre
felt that it was no one.

It was a system--a concurrence of circumstances.

A system of some sort was killing him--Pierre--depriving him of
life, of everything, annihilating him.





CHAPTER XI


From Prince Shcherbatov's house the prisoners were led straight down
the Virgin's Field, to the left of the nunnery, as far as a kitchen
garden in which a post had been set up. Beyond that post a fresh pit
had been dug in the ground, and near the post and the pit a large
crowd stood in a semicircle. The crowd consisted of a few Russians and
many of Napoleon's soldiers who were not on duty--Germans, Italians,
and Frenchmen, in a variety of uniforms. To the right and left of
the post stood rows of French troops in blue uniforms with red
epaulets and high boots and shakos.

The prisoners were placed in a certain order, according to the
list (Pierre was sixth), and were led to the post. Several drums
suddenly began to beat on both sides of them, and at that sound Pierre
felt as if part of his soul had been torn away. He lost the power of
thinking or understanding. He could only hear and see. And he had only
one wish--that the frightful thing that had to happen should happen
quickly. Pierre looked round at his fellow prisoners and scrutinized
them.

The two first were convicts with shaven heads. One was tall and
thin, the other dark, shaggy, and sinewy, with a flat nose. The
third was a domestic serf, about forty-five years old, with grizzled
hair and a plump, well-nourished body. The fourth was a peasant, a
very handsome man with a broad, light-brown beard and black eyes.
The fifth was a factory hand, a thin, sallow-faced lad of eighteen
in a loose coat.

Pierre heard the French consulting whether to shoot them
separately or two at a time. "In couples," replied the officer in
command in a calm voice. There was a stir in the ranks of the soldiers
and it was evident that they were all hurrying--not as men hurry to do
something they understand, but as people hurry to finish a necessary
but unpleasant and incomprehensible task.

A French official wearing a scarf came up to the right of the row of
prisoners and read out the sentence in Russian and in French.

Then two pairs of Frenchmen approached the criminals and at the
officer's command took the two convicts who stood first in the row.
The convicts stopped when they reached the post and, while sacks
were being brought, looked dumbly around as a wounded beast looks at
an approaching huntsman. One crossed himself continually, the other
scratched his back and made a movement of the lips resembling a smile.
With hurried hands the soldiers blindfolded them, drawing the sacks
over their heads, and bound them to the post.

Twelve sharpshooters with muskets stepped out of the ranks with a
firm regular tread and halted eight paces from the post. Pierre turned
away to avoid seeing what was going to happen. Suddenly a crackling,
rolling noise was heard which seemed to him louder than the most
terrific thunder, and he looked round. There was some smoke, and the
Frenchmen were doing something near the pit, with pale faces and
trembling hands. Two more prisoners were led up. In the same way and
with similar looks, these two glanced vainly at the onlookers with
only a silent appeal for protection in their eyes, evidently unable to
understand or believe what was going to happen to them. They could not
believe it because they alone knew what their life meant to them,
and so they neither understood nor believed that it could be taken
from them.

Again Pierre did not wish to look and again turned away; but again
the sound as of a frightful explosion struck his ear, and at the
same moment he saw smoke, blood, and the pale, scared faces of the
Frenchmen who were again doing something by the post, their
trembling hands impeding one another. Pierre, breathing heavily,
looked around as if asking what it meant. The same question was
expressed in all the looks that met his.

On the faces of all the Russians and of the French soldiers and
officers without exception, he read the same dismay, horror, and
conflict that were in his own heart. "But who, after all, is doing
this? They are all suffering as I am. Who then is it? Who?" flashed
for an instant through his mind.

"Sharpshooters of the 86th, forward!" shouted someone. The fifth
prisoner, the one next to Pierre, was led away--alone. Pierre did
not understand that he was saved, that he and the rest had been
brought there only to witness the execution. With ever-growing horror,
and no sense of joy or relief, he gazed at what was taking place.
The fifth man was the factory lad in the loose cloak. The moment
they laid hands on him he sprang aside in terror and clutched at
Pierre. (Pierre shuddered and shook himself free.) The lad was
unable to walk. They dragged him along, holding him up under the arms,
and he screamed. When they got him to the post he grew quiet, as if he
suddenly understood something. Whether he understood that screaming
was useless or whether he thought it incredible that men should kill
him, at any rate he took his stand at the post, waiting to be
blindfolded like the others, and like a wounded animal looked around
him with glittering eyes.

Pierre was no longer able to turn away and close his eyes. His
curiosity and agitation, like that of the whole crowd, reached the
highest pitch at this fifth murder. Like the others this fifth man
seemed calm; he wrapped his loose cloak closer and rubbed one bare
foot with the other.

When they began to blindfold him he himself adjusted the knot
which hurt the back of his head; then when they propped him against
the bloodstained post, he leaned back and, not being comfortable in
that position, straightened himself, adjusted his feet, and leaned
back again more comfortably. Pierre did not take his eyes from him and
did not miss his slightest movement.

Probably a word of command was given and was followed by the reports
of eight muskets; but try as he would Pierre could not afterwards
remember having heard the slightest sound of the shots. He only saw
how the workman suddenly sank down on the cords that held him, how
blood showed itself in two places, how the ropes slackened under the
weight of the hanging body, and how the workman sat down, his head
hanging unnaturally and one leg bent under him. Pierre ran up to the
post. No one hindered him. Pale, frightened people were doing
something around the workman. The lower jaw of an old Frenchman with a
thick mustache trembled as he untied the ropes. The body collapsed.
The soldiers dragged it awkwardly from the post and began pushing it
into the pit.

They all plainly and certainly knew that they were criminals who
must hide the traces of their guilt as quickly as possible.

Pierre glanced into the pit and saw that the factory lad was lying
with his knees close up to his head and one shoulder higher than the
other. That shoulder rose and fell rhythmically and convulsively,
but spadefuls of earth were already being thrown over the whole
body. One of the soldiers, evidently suffering, shouted gruffly and
angrily at Pierre to go back. But Pierre did not understand him and
remained near the post, and no one drove him away.

When the pit had been filled up a command was given. Pierre was
taken back to his place, and the rows of troops on both sides of the
post made a half turn and went past it at a measured pace. The
twenty-four sharpshooters with discharged muskets, standing in the
center of the circle, ran back to their places as the companies passed
by.

Pierre gazed now with dazed eyes at these sharpshooters who ran in
couples out of the circle. All but one rejoined their companies.
This one, a young soldier, his face deadly pale, his shako pushed
back, and his musket resting on the ground, still stood near the pit
at the spot from which he had fired. He swayed like a drunken man,
taking some steps forward and back to save himself from falling. An
old, noncommissioned officer ran out of the ranks and taking him by
the elbow dragged him to his company. The crowd of Russians and
Frenchmen began to disperse. They all went away silently and with
drooping heads.

"That will teach them to start fires," said one of the Frenchmen.

Pierre glanced round at the speaker and saw that it was a soldier
who was trying to find some relief after what had been done, but was
not able to do so. Without finishing what he had begun to say he
made a hopeless movement with his arm and went away.





CHAPTER XII


After the execution Pierre was separated from the rest of the
prisoners and placed alone in a small, ruined, and befouled church.

Toward evening a noncommissioned officer entered with two soldiers
and told him that he had been pardoned and would now go to the
barracks for the prisoners of war. Without understanding what was said
to him, Pierre got up and went with the soldiers. They took him to the
upper end of the field, where there were some sheds built of charred
planks, beams, and battens, and led him into one of them. In the
darkness some twenty different men surrounded Pierre. He looked at
them without understanding who they were, why they were there, or what
they wanted of him. He heard what they said, but did not understand
the meaning of the words and made no kind of deduction from or
application of them. He replied to questions they put to him, but
did not consider who was listening to his replies, nor how they
would understand them. He looked at their faces and figures, but
they all seemed to him equally meaningless.

From the moment Pierre had witnessed those terrible murders
committed by men who did not wish to commit them, it was as if the
mainspring of his life, on which everything depended and which made
everything appear alive, had suddenly been wrenched out and everything
had collapsed into a heap of meaningless rubbish. Though he did not
acknowledge it to himself, his faith in the right ordering of the
universe, in humanity, in his own soul, and in God, had been
destroyed. He had experienced this before, but never so strongly as
now. When similar doubts had assailed him before, they had been the
result of his own wrongdoing, and at the bottom of his heart he had
felt that relief from his despair and from those doubts was to be
found within himself. But now he felt that the universe had crumbled
before his eyes and only meaningless ruins remained, and this not by
any fault of his own. He felt that it was not in his power to regain
faith in the meaning of life.

Around him in the darkness men were standing and evidently something
about him interested them greatly. They were telling him something and
asking him something. Then they led him away somewhere, and at last he
found himself in a corner of the shed among men who were laughing
and talking on all sides.

"Well, then, mates... that very prince who..." some voice at the
other end of the shed was saying, with a strong emphasis on the word
who.

Sitting silent and motionless on a heap of straw against the wall,
Pierre sometimes opened and sometimes closed his eyes. But as soon
as he closed them he saw before him the dreadful face of the factory
lad--especially dreadful because of its simplicity--and the faces of
the murderers, even more dreadful because of their disquiet. And he
opened his eyes again and stared vacantly into the darkness around
him.

Beside him in a stooping position sat a small man of whose
presence he was first made aware by a strong smell of perspiration
which came from him every time he moved. This man was doing
something to his legs in the darkness, and though Pierre could not see
his face he felt that the man continually glanced at him. On growing
used to the darkness Pierre saw that the man was taking off his leg
bands, and the way he did it aroused Pierre's interest.

Having unwound the string that tied the band on one leg, he
carefully coiled it up and immediately set to work on the other leg,
glancing up at Pierre. While one hand hung up the first string the
other was already unwinding the band on the second leg. In this way,
having carefully removed the leg bands by deft circular motions of his
arm following one another uninterruptedly, the man hung the leg
bands up on some pegs fixed above his head. Then he took out a
knife, cut something, closed the knife, placed it under the head of
his bed, and, seating himself comfortably, clasped his arms round
his lifted knees and fixed his eyes on Pierre. The latter was
conscious of something pleasant, comforting, and well rounded in these
deft movements, in the man's well-ordered arrangements in his
corner, and even in his very smell, and he looked at the man without
taking his eyes from him.

"You've seen a lot of trouble, sir, eh?" the little man suddenly
said.

And there was so much kindliness and simplicity in his singsong
voice that Pierre tried to reply, but his jaw trembled and he felt
tears rising to his eyes. The little fellow, giving Pierre no time
to betray his confusion, instantly continued in the same pleasant
tones:

"Eh, lad, don't fret!" said he, in the tender singsong caressing
voice old Russian peasant women employ. "Don't fret, friend--'suffer
an hour, live for an age!' that's how it is, my dear fellow. And
here we live, thank heaven, without offense. Among these folk, too,
there are good men as well as bad," said he, and still speaking, he
turned on his knees with a supple movement, got up, coughed, and
went off to another part of the shed.

"Eh, you rascal!" Pierre heard the same kind voice saying at the
other end of the shed. "So you've come, you rascal? She remembers...
Now, now, that'll do!"

And the soldier, pushing away a little dog that was jumping up at
him, returned to his place and sat down. In his hands he had something
wrapped in a rag.

"Here, eat a bit, sir," said he, resuming his former respectful tone
as he unwrapped and offered Pierre some baked potatoes. "We had soup
for dinner and the potatoes are grand!"

Pierre had not eaten all day and the smell of the potatoes seemed
extremely pleasant to him. He thanked the soldier and began to eat.

"Well, are they all right?" said the soldier with a smile. "You
should do like this."

He took a potato, drew out his clasp knife, cut the potato into
two equal halves on the palm of his hand, sprinkled some salt on it
from the rag, and handed it to Pierre.

"The potatoes are grand!" he said once more. "Eat some like that!"

Pierre thought he had never eaten anything that tasted better.

"Oh, I'm all right," said he, "but why did they shoot those poor
fellows? The last one was hardly twenty."

"Tss, tt...!" said the little man. "Ah, what a sin... what a sin!"
he added quickly, and as if his words were always waiting ready in his
mouth and flew out involuntarily he went on: "How was it, sir, that
you stayed in Moscow?"

"I didn't think they would come so soon. I stayed accidentally,"
replied Pierre.

"And how did they arrest you, dear lad? At your house?"

"No, I went to look at the fire, and they arrested me there, and
tried me as an incendiary."

"Where there's law there's injustice," put in the little man.

"And have you been here long?" Pierre asked as he munched the last
of the potato.

"I? It was last Sunday they took me, out of a hospital in Moscow."

"Why, are you a soldier then?"

"Yes, we are soldiers of the Apsheron regiment. I was dying of
fever. We weren't told anything. There were some twenty of us lying
there. We had no idea, never guessed at all."

"And do you feel sad here?" Pierre inquired.

"How can one help it, lad? My name is Platon, and the surname is
Karataev," he added, evidently wishing to make it easier for Pierre to
address him. "They call me 'little falcon' in the regiment. How is one
to help feeling sad? Moscow--she's the mother of cities. How can one
see all this and not feel sad? But 'the maggot gnaws the cabbage,
yet dies first'; that's what the old folks used to tell us," he
added rapidly.

"What? What did you say?" asked Pierre.

"Who? I?" said Karataev. "I say things happen not as we plan but
as God judges," he replied, thinking that he was repeating what he had
said before, and immediately continued:

"Well, and you, have you a family estate, sir? And a house? So you
have abundance, then? And a housewife? And your old parents, are
they still living?" he asked.

And though it was too dark for Pierre to see, he felt that a
suppressed smile of kindliness puckered the soldier's lips as he put
these questions. He seemed grieved that Pierre had no parents,
especially that he had no mother.

"A wife for counsel, a mother-in-law for welcome, but there's none
as dear as one's own mother!" said he. "Well, and have you little
ones?" he went on asking.

Again Pierre's negative answer seemed to distress him, and he
hastened to add:

"Never mind! You're young folks yet, and please God may still have
some. The great thing is to live in harmony...."

"But it's all the same now," Pierre could not help saying.

"Ah, my dear fellow!" rejoined Karataev, "never decline a prison
or a beggar's sack!"

He seated himself more comfortably and coughed, evidently
preparing to tell a long story.

"Well, my dear fellow, I was still living at home," he began. "We
had a well-to-do homestead, plenty of land, we peasants lived well and
our house was one to thank God for. When Father and we went out mowing
there were seven of us. We lived well. We were real peasants. It so
happened..."

And Platon Karataev told a long story of how he had gone into
someone's copse to take wood, how he had been caught by the keeper,
had been tried, flogged, and sent to serve as a soldier.

"Well, lad," and a smile changed the tone of his voice "we thought
it was a misfortune but it turned out a blessing! If it had not been
for my sin, my brother would have had to go as a soldier. But he, my
younger brother, had five little ones, while I, you see, only left a
wife behind. We had a little girl, but God took her before I went as a
soldier. I come home on leave and I'll tell you how it was, I look and
see that they are living better than before. The yard full of
cattle, the women at home, two brothers away earning wages, and only
Michael the youngest, at home. Father, he says, 'All my children are
the same to me: it hurts the same whichever finger gets bitten. But if
Platon hadn't been shaved for a soldier, Michael would have had to
go.' called us all to him and, will you believe it, placed us in front
of the icons. 'Michael,' he says, 'come here and bow down to his feet;
and you, young woman, you bow down too; and you, grandchildren, also
bow down before him! Do you understand?' he says. That's how it is,
dear fellow. Fate looks for a head. But we are always judging, 'that's
not well--that's not right!' Our luck is like water in a dragnet:
you pull at it and it bulges, but when you've drawn it out it's empty!
That's how it is."

And Platon shifted his seat on the straw.

After a short silence he rose.

"Well, I think you must be sleepy," said he, and began rapidly
crossing himself and repeating:

"Lord Jesus Christ, holy Saint Nicholas, Frola and Lavra! Lord Jesus
Christ, holy Saint Nicholas, Frola and Lavra! Lord Jesus Christ,
have mercy on us and save us!" he concluded, then bowed to the ground,
got up, sighed, and sat down again on his heap of straw. "That's the
way. Lay me down like a stone, O God, and raise me up like a loaf," he
muttered as he lay down, pulling his coat over him.

"What prayer was that you were saying?" asked Pierre.

"Eh?" murmured Platon, who had almost fallen asleep. "What was I
saying? I was praying. Don't you pray?"

"Yes, I do," said Pierre. "But what was that you said: Frola and
Lavra?"

"Well, of course," replied Platon quickly, "the horses' saints.
One must pity the animals too. Eh, the rascal! Now you've curled up
and got warm, you daughter of a bitch!" said Karataev, touching the
dog that lay at his feet, and again turning over he fell asleep
immediately.

Sounds of crying and screaming came from somewhere in the distance
outside, and flames were visible through the cracks of the shed, but
inside it was quiet and dark. For a long time Pierre did not sleep,
but lay with eyes open in the darkness, listening to the regular
snoring of Platon who lay beside him, and he felt that the world
that had been shattered was once more stirring in his soul with a
new beauty and on new and unshakable foundations.





CHAPTER XIII


Twenty-three soldiers, three officers, and two officials were
confined in the shed in which Pierre had been placed and where he
remained for four weeks.

When Pierre remembered them afterwards they all seemed misty figures
to him except Platon Karataev, who always remained in his mind a
most vivid and precious memory and the personification of everything
Russian, kindly, and round. When Pierre saw his neighbor next
morning at dawn the first impression of him, as of something round,
was fully confirmed: Platon's whole figure--in a French overcoat
girdled with a cord, a soldier's cap, and bast shoes--was round. His
head was quite round, his back, chest, shoulders, and even his arms,
which he held as if ever ready to embrace something, were rounded, his
pleasant smile and his large, gentle brown eyes were also round.

Platon Karataev must have been fifty, judging by his stories of
campaigns he had been in, told as by an old soldier. He did not
himself know his age and was quite unable to determine it. But his
brilliantly white, strong teeth which showed in two unbroken
semicircles when he laughed--as he often did--were all sound and good,
there was not a gray hair in his beard or on his head, and his whole
body gave an impression of suppleness and especially of firmness and
endurance.

His face, despite its fine, rounded wrinkles, had an expression of
innocence and youth, his voice was pleasant and musical. But the chief
peculiarity of his speech was its directness and appositeness. It
was evident that he never considered what he had said or was going
to say, and consequently the rapidity and justice of his intonation
had an irresistible persuasiveness.

His physical strength and agility during the first days of his
imprisonment were such that he seemed not to know what fatigue and
sickness meant. Every night before lying down, he said: "Lord, lay
me down as a stone and raise me up as a loaf!" and every morning on
getting up, he said: "I lay down and curled up, I get up and shake
myself." And indeed he only had to lie down, to fall asleep like a
stone, and he only had to shake himself, to be ready without a
moment's delay for some work, just as children are ready to play
directly they awake. He could do everything, not very well but not
badly. He baked, cooked, sewed, planed, and mended boots. He was
always busy, and only at night allowed himself conversation--of
which he was fond--and songs. He did not sing like a trained singer
who knows he is listened to, but like the birds, evidently giving vent
to the sounds in the same way that one stretches oneself or walks
about to get rid of stiffness, and the sounds were always
high-pitched, mournful, delicate, and almost feminine, and his face at
such times was very serious.

Having been taken prisoner and allowed his beard to grow, he
seemed to have thrown off all that had been forced upon him-
everything military and alien to himself--and had returned to his
former peasant habits.

"A soldier on leave--a shirt outside breeches," he would say.

He did not like talking about his life as a soldier, though he did
not complain, and often mentioned that he had not been flogged once
during the whole of his army service. When he related anything it
was generally some old and evidently precious memory of his
"Christian" life, as he called his peasant existence. The proverbs, of
which his talk was full, were for the most part not the coarse and
indecent saws soldiers employ, but those folk sayings which taken
without a context seem so insignificant, but when used appositely
suddenly acquire a significance of profound wisdom.

He would often say the exact opposite of what he had said on a
previous occasion, yet both would be right. He liked to talk and he
talked well, adorning his speech with terms of endearment and with
folk sayings which Pierre thought he invented himself, but the chief
charm of his talk lay in the fact that the commonest events--sometimes
just such as Pierre had witnessed without taking notice of them-
assumed in Karataev's a character of solemn fitness. He liked to
hear the folk tales one of the soldiers used to tell of an evening
(they were always the same), but most of all he liked to hear
stories of real life. He would smile joyfully when listening to such
stories, now and then putting in a word or asking a question to make
the moral beauty of what he was told clear to himself. Karataev had no
attachments, friendships, or love, as Pierre understood them, but
loved and lived affectionately with everything life brought him in
contact with, particularly with man--not any particular man, but those
with whom he happened to be. He loved his dog, his comrades, the
French, and Pierre who was his neighbor, but Pierre felt that in spite
of Karataev's affectionate tenderness for him (by which he
unconsciously gave Pierre's spiritual life its due) he would not
have grieved for a moment at parting from him. And Pierre began to
feel in the same way toward Karataev.

To all the other prisoners Platon Karataev seemed a most ordinary
soldier. They called him "little falcon" or "Platosha," chaffed him
good-naturedly, and sent him on errands. But to Pierre he always
remained what he had seemed that first night: an unfathomable,
rounded, eternal personification of the spirit of simplicity and
truth.

Platon Karataev knew nothing by heart except his prayers. When he
began to speak he seemed not to know how he would conclude.

Sometimes Pierre, struck by the meaning of his words, would ask
him to repeat them, but Platon could never recall what he had said a
moment before, just as he never could repeat to Pierre the words of
his favorite song: native and birch tree and my heart is sick occurred
in it, but when spoken and not sung, no meaning could be got out of
it. He did not, and could not, understand the meaning of words apart
from their context. Every word and action of his was the manifestation
of an activity unknown to him, which was his life. But his life, as he
regarded it, had no meaning as a separate thing. It had meaning only
as part of a whole of which he was always conscious. His words and
actions flowed from him as evenly, inevitably, and spontaneously as
fragrance exhales from a flower. He could not understand the value
or significance of any word or deed taken separately.





CHAPTER XIV


When Princess Mary heard from Nicholas that her brother was with the
Rostovs at Yaroslavl she at once prepared to go there, in spite of her
aunt's efforts to dissuade her--and not merely to go herself but to
take her nephew with her. Whether it were difficult or easy,
possible or impossible, she did not ask and did not want to know: it
was her duty not only herself to be near her brother who was perhaps
dying, but to do everything possible to take his son to him, and so
she prepared to set off. That she had not heard from Prince Andrew
himself, Princess Mary attributed to his being too weak to write or to
his considering the long journey too hard and too dangerous for her
and his son.

In a few days Princess Mary was ready to start. Her equipages were
the huge family coach in which she had traveled to Voronezh, a
semiopen trap, and a baggage cart. With her traveled Mademoiselle
Bourienne, little Nicholas and his tutor, her old nurse, three
maids, Tikhon, and a young footman and courier her aunt had sent to
accompany her.

The usual route through Moscow could not be thought of, and the
roundabout way Princess Mary was obliged to take through Lipetsk,
Ryazan, Vladimir, and Shuya was very long and, as post horses were not
everywhere obtainable, very difficult, and near Ryazan where the
French were said to have shown themselves was even dangerous.

During this difficult journey Mademoiselle Bourienne, Dessalles, and
Princess Mary's servants were astonished at her energy and firmness of
spirit. She went to bed later and rose earlier than any of them, and
no difficulties daunted her. Thanks to her activity and energy,
which infected her fellow travelers, they approached Yaroslavl by
the end of the second week.

The last days of her stay in Voronezh had been the happiest of her
life. Her love for Rostov no longer tormented or agitated her. It
filled her whole soul, had become an integral part of herself, and she
no longer struggled against it. Latterly she had become convinced that
she loved and was beloved, though she never said this definitely to
herself in words. She had become convinced of it at her last interview
with Nicholas, when he had come to tell her that her brother was
with the Rostovs. Not by a single word had Nicholas alluded to the
fact that Prince Andrew's relations with Natasha might, if he
recovered, be renewed, but Princess Mary saw by his face that he
knew and thought of this.

Yet in spite of that, his relation to her--considerate, delicate,
and loving--not only remained unchanged, but it sometimes seemed to
Princess Mary that he was even glad that the family connection between
them allowed him to express his friendship more freely. She knew
that she loved for the first and only time in her life and felt that
she was beloved, and was happy in regard to it.

But this happiness on one side of her spiritual nature did not
prevent her feeling grief for her brother with full force; on the
contrary, that spiritual tranquility on the one side made it the
more possible for her to give full play to her feeling for her
brother. That feeling was so strong at the moment of leaving
Voronezh that those who saw her off, as they looked at her careworn,
despairing face, felt sure she would fall ill on the journey. But
the very difficulties and preoccupations of the journey, which she
took so actively in hand, saved her for a while from her grief and
gave her strength.

As always happens when traveling, Princess Mary thought only of
the journey itself, forgetting its object. But as she approached
Yaroslavl the thought of what might await her there--not after many
days, but that very evening--again presented itself to her and her
agitation increased to its utmost limit.

The courier who had been sent on in advance to find out where the
Rostovs were staying in Yaroslavl, and in what condition Prince Andrew
was, when he met the big coach just entering the town gates was
appalled by the terrible pallor of the princess' face that looked
out at him from the window.

"I have found out everything, your excellency: the Rostovs are
staying at the merchant Bronnikov's house, in the Square not far
from here, right above the Volga," said the courier.

Princess Mary looked at him with frightened inquiry, not
understanding why he did not reply to what she chiefly wanted to know:
how was her brother? Mademoiselle Bourienne put that question for her.

"How is the prince?" she asked.

"His excellency is staying in the same house with them."

"Then he is alive," thought Princess Mary, and asked in a low voice:
"How is he?"

"The servants say he is still the same."

What "still the same" might mean Princess Mary did not ask, but with
an unnoticed glance at little seven-year-old Nicholas, who was sitting
in front of her looking with pleasure at the town, she bowed her
head and did not raise it again till the heavy coach, rumbling,
shaking and swaying, came to a stop. The carriage steps clattered as
they were let down.

The carriage door was opened. On the left there was water--a great
river--and on the right a porch. There were people at the entrance:
servants, and a rosy girl with a large plait of black hair, smiling as
it seemed to Princess Mary in an unpleasantly affected way. (This
was Sonya.) Princess Mary ran up the steps. "This way, this way!" said
the girl, with the same artificial smile, and the princess found
herself in the hall facing an elderly woman of Oriental type, who came
rapidly to meet her with a look of emotion. This was the countess. She
embraced Princess Mary and kissed her.

"Mon enfant!" she muttered, "je vous aime et vous connais depuis
longtemps."*


*"My child! I love you and have known you a long time."

 Despite her excitement, Princess Mary realized that this was the
countess and that it was necessary to say something to her. Hardly
knowing how she did it, she contrived to utter a few polite phrases in
French in the same tone as those that had been addressed to her, and
asked: "How is he?"

"The doctor says that he is not in danger," said the countess, but
as she spoke she raised her eyes with a sigh, and her gesture conveyed
a contradiction of her words.

"Where is he? Can I see him--can I?" asked the princess.

"One moment, Princess, one moment, my dear! Is this his son?" said
the countess, turning to little Nicholas who was coming in with
Dessalles. "There will be room for everybody, this is a big house. Oh,
what a lovely boy!"

The countess took Princess Mary into the drawing room, where Sonya
was talking to Mademoiselle Bourienne. The countess caressed the
boy, and the old count came in and welcomed the princess. He had
changed very much since Princess Mary had last seen him. Then he had
been a brisk, cheerful, self-assured old man; now he seemed a pitiful,
bewildered person. While talking to Princess Mary he continually
looked round as if asking everyone whether he was doing the right
thing. After the destruction of Moscow and of his property, thrown out
of his accustomed groove he seemed to have lost the sense of his own
significance and to feel that there was no longer a place for him in
life.

In spite of her one desire to see her brother as soon as possible,
and her vexation that at the moment when all she wanted was to see him
they should be trying to entertain her and pretending to admire her
nephew, the princess noticed all that was going on around her and felt
the necessity of submitting, for a time, to this new order of things
which she had entered. She knew it to be necessary, and though it
was hard for her she was not vexed with these people.

"This is my niece," said the count, introducing Sonya--"You don't
know her, Princess?"

Princess Mary turned to Sonya and, trying to stifle the hostile
feeling that arose in her toward the girl, she kissed her. But she
felt oppressed by the fact that the mood of everyone around her was so
far from what was in her own heart.

"Where is he?" she asked again, addressing them all.

"He is downstairs. Natasha is with him," answered Sonya, flushing.
"We have sent to ask. I think you must be tired, Princess."

Tears of vexation showed themselves in Princess Mary's eyes. She
turned away and was about to ask the countess again how to go to
him, when light, impetuous, and seemingly buoyant steps were heard
at the door. The princess looked round and saw Natasha coming in,
almost running--that Natasha whom she had liked so little at their
meeting in Moscow long since.

But hardly had the princess looked at Natasha's face before she
realized that here was a real comrade in her grief, and consequently a
friend. She ran to meet her, embraced her, and began to cry on her
shoulder.

As soon as Natasha, sitting at the head of Prince Andrew's bed,
heard of Princess Mary's arrival, she softly left his room and
hastened to her with those swift steps that had sounded buoyant to
Princess Mary.

There was only one expression on her agitated face when she ran into
the drawing room--that of love--boundless love for him, for her, and
for all that was near to the man she loved; and of pity, suffering for
others, and passionate desire to give herself entirely to helping
them. It was plain that at that moment there was in Natasha's heart no
thought of herself or of her own relations with Prince Andrew.

Princess Mary, with her acute sensibility, understood all this at
the first glance at Natasha's face, and wept on her shoulder with
sorrowful pleasure.

"Come, come to him, Mary," said Natasha, leading her into the
other room.

Princess Mary raised her head, dried her eyes, and turned to
Natasha. She felt that from her she would be able to understand and
learn everything.

"How..." she began her question but stopped short.

She felt that it was impossible to ask, or to answer, in words.
Natasha's face eyes would have to tell her all more clearly
and profoundly.

Natasha was gazing at her, but seemed afraid and in doubt whether to
say all she knew or not; she seemed to feel that before those luminous
eyes which penetrated into the very depths of her heart, it was
impossible not to tell the whole truth which she saw. And suddenly,
Natasha's lips twitched, ugly wrinkles gathered round her mouth, and
covering her face with her hands she burst into sobs.

Princess Mary understood.

But she still hoped, and asked, in words she herself did not trust:

"But how is his wound? What is his general condition?"

"You, you... will see," was all Natasha could say.

They sat a little while downstairs near his room till they had
left off crying and were able to go to him with calm faces.

"How has his whole illness gone? Is it long since he grew worse?
When did this happen?" Princess Mary inquired.

Natasha told her that at first there had been danger from his
feverish condition and the pain he suffered, but at Troitsa that had
passed and the doctor had only been afraid of gangrene. That danger
had also passed. When they reached Yaroslavl the wound had begun to
fester (Natasha knew all about such things as festering) and the
doctor had said that the festering might take a normal course. Then
fever set in, but the doctor had said the fever was not very serious.

"But two days ago this suddenly happened," said Natasha,
struggling with her sobs. "I don't know why, but you will see what
he is like."

"Is he weaker? Thinner?" asked the princess.

"No, it's not that, but worse. You will see. O, Mary, he is too
good, he cannot, cannot live, because..."





CHAPTER XV


When Natasha opened Prince Andrew's door with a familiar movement
and let Princess Mary pass into the room before her, the princess felt
the sobs in her throat. Hard as she had tried to prepare herself,
and now tried to remain tranquil, she knew that she would be unable to
look at him without tears.

The princess understood what Natasha had meant by the words: "two
days ago this suddenly happened." She understood those words to mean
that he had suddenly softened and that this softening and gentleness
were signs of approaching death. As she stepped to the door she
already saw in imagination Andrew's face as she remembered it in
childhood, a gentle, mild, sympathetic face which he had rarely shown,
and which therefore affected her very strongly. She was sure he
would speak soft, tender words to her such as her father had uttered
before his death, and that she would not be able to bear it and
would burst into sobs in his presence. Yet sooner or later it had to
be, and she went in. The sobs rose higher and higher in her throat
as she more and more clearly distinguished his form and her
shortsighted eyes tried to make out his features, and then she saw his
face and met his gaze.

He was lying in a squirrel-fur dressing gown on a divan,
surrounded by pillows. He was thin and pale. In one thin,
translucently white hand he held a handkerchief, while with the
other he stroked the delicate mustache he had grown, moving his
fingers slowly. His eyes gazed at them as they entered.

On seeing his face and meeting his eyes Princess Mary's pace
suddenly slackened, she felt her tears dry up and her sobs ceased. She
suddenly felt guilty and grew timid on catching the expression of
his face and eyes.

"But in what am I to blame?" she asked herself. And his cold,
stern look replied: "Because you are alive and thinking of the living,
while I..."

In the deep gaze that seemed to look not outwards but
inwards there was an almost hostile expression as he slowly regarded
his sister and Natasha.

He kissed his sister, holding her hand in his as was their wont.

"How are you, Mary? How did you manage to get here?" said he in a
voice as calm and aloof as his look.

Had he screamed in agony, that scream would not have struck such
horror into Princess Mary's heart as the tone of his voice.

"And have you brought little Nicholas?" he asked in the same slow,
quiet manner and with an obvious effort to remember.

"How are you now?" said Princess Mary, herself surprised at what she
was saying.

"That, my dear, you must ask the doctor," he replied, and again
making an evident effort to be affectionate, he said with his lips
only (his words clearly did not correspond to his thoughts):

"Merci, chere amie, d'etre venue."*


*"Thank you for coming, my dear."


Princess Mary pressed his hand. The pressure made him wince just
perceptibly. He was silent, and she did not know what to say. She
now understood what had happened to him two days before. In his words,
his tone, and especially in that calm, almost antagonistic look
could be felt an estrangement from everything belonging to this world,
terrible in one who is alive. Evidently only with an effort did he
understand anything living; but it was obvious that he failed to
understand, not because he lacked the power to do so but because he
understood something else--something the living did not and could
not understand--and which wholly occupied his mind.

"There, you see how strangely fate has brought us together," said
he, breaking the silence and pointing to Natasha. "She looks after
me all the time."

Princess Mary heard him and did not understand how he could say such
a thing. He, the sensitive, tender Prince Andrew, how could he say
that, before her whom he loved and who loved him? Had he expected to
live he could not have said those words in that offensively cold tone.
If he had not known that he was dying, how could he have failed to
pity her and how could he speak like that in her presence? The only
explanation was that he was indifferent, because something else,
much more important, had been revealed to him.

The conversation was cold and disconnected and continually broke
off.

"Mary came by way of Ryazan," said Natasha.

Prince Andrew did not notice that she called his sister Mary, and
only after calling her so in his presence did Natasha notice it
herself.

"Really?" he asked.

"They told her that all Moscow has been burned down, and that..."

Natasha stopped. It was impossible to talk. It was plain that he was
making an effort to listen, but could not do so.

"Yes, they say it's burned," he said. "It's a great pity," and he
gazed straight before him, absently stroking his mustache with his
fingers.

"And so you have met Count Nicholas, Mary?" Prince Andrew suddenly
said, evidently wishing to speak pleasantly to them. "He wrote here
that he took a great liking to you," he went on simply and calmly,
evidently unable to understand all the complex significance his
words had for living people. "If you liked him too, it would be a good
thing for you to get married," he added rather more quickly, as if
pleased at having found words he had long been seeking.

Princess Mary heard his words but they had no meaning for her,
except as a proof of how far away he now was from everything living.

"Why talk of me?" she said quietly and glanced at Natasha.

Natasha, who felt her glance, did not look at her. All three were
again silent.

"Andrew, would you like..." Princess Mary suddenly said in a
trembling voice, "would you like to see little Nicholas? He is
always talking about you!"

Prince Andrew smiled just perceptibly and for the first time, but
Princess Mary, who knew his face so well, saw with horror that he
did not smile with pleasure or affection for his son, but with
quiet, gentle irony because he thought she was trying what she
believed to be the last means of arousing him.

"Yes, I shall be very glad to see him. Is he quite well?"

When little Nicholas was brought into Prince Andrew's room he looked
at his father with frightened eyes, but did not cry, because no one
else was crying. Prince Andrew kissed him and evidently did not know
what to say to him.

When Nicholas had been led away, Princess Mary again went up to
her brother, kissed him, and unable to restrain her tears any longer
began to cry.

He looked at her attentively.

"Is it about Nicholas?" he asked.

Princess Mary nodded her head, weeping.

"Mary, you know the Gosp..." but he broke off.

"What did you say?"

"Nothing. You mustn't cry here," he said, looking at her with the
same cold expression.


When Princess Mary began to cry, he understood that she was crying
at the thought that little Nicholas would be left without a father.
With a great effort he tried to return to life and to see things
from their point of view.

"Yes, to them it must seem sad!" he thought. "But how simple it is.

"The fowls of the air sow not, neither do they reap, yet your Father
feedeth them," he said to himself and wished to say to Princess
Mary; "but no, they will take it their own way, they won't understand!
They can't understand that all those feelings they prize so--all our
feelings, all those ideas that seem so important to us, are
unnecessary. We cannot understand one another," and he remained
silent.


Prince Andrew's little son was seven. He could scarcely read, and
knew nothing. After that day he lived through many things, gaining
knowledge, observation, and experience, but had he possessed all the
faculties he afterwards acquired, he could not have had a better or
more profound understanding of the meaning of the scene he had
witnessed between his father, Mary, and Natasha, than he had then.
He understood it completely, and, leaving the room without crying,
went silently up to Natasha who had come out with him and looked shyly
at her with his beautiful, thoughtful eyes, then his uplifted, rosy
upper lip trembled and leaning his head against her he began to cry.

After that he avoided Dessalles and the countess who caressed him
and either sat alone or came timidly to Princess Mary, or to Natasha
of whom he seemed even fonder than of his aunt, and clung to them
quietly and shyly.

When Princess Mary had left Prince Andrew she fully understood
what Natasha's face had told her. She did not speak any more to
Natasha of hopes of saving his life. She took turns with her beside
his sofa, and did not cry any more, but prayed continually, turning in
soul to that Eternal and Unfathomable, whose presence above the
dying man was now so evident.





CHAPTER XVI


Not only did Prince Andrew know he would die, but he felt that he
was dying and was already half dead. He was conscious of an
aloofness from everything earthly and a strange and joyous lightness
of existence. Without haste or agitation he awaited what was coming.
That inexorable, eternal, distant, and unknown the presence of which
he had felt continually all his life--was now near to him and, by
the strange lightness he experienced, almost comprehensible and
palpable...


Formerly he had feared the end. He had twice experienced that
terribly tormenting fear of death--the end--but now he no longer
understood that fear.

 He had felt it for the first time when the shell spun like a top
before him, and he looked at the fallow field, the bushes, and the
sky, and knew that he was face to face with death. When he came to
himself after being wounded and the flower of eternal, unfettered love
had instantly unfolded itself in his soul as if freed from the bondage
of life that had restrained it, he no longer feared death and ceased
to think about it.

During the hours of solitude, suffering, and partial delirium he
spent after he was wounded, the more deeply he penetrated into the new
principle of eternal love revealed to him, the more he unconsciously
detached himself from earthly life. To love everything and everybody
and always to sacrifice oneself for love meant not to love anyone, not
to live this earthly life. And the more imbued he became with that
principle of love, the more he renounced life and the more
completely he destroyed that dreadful barrier which--in the absence of
such love--stands between life and death. When during those first days
he remembered that he would have to die, he said to himself: "Well,
what of it? So much the better!"

But after the night in Mytishchi when, half delirious, he had seen
her for whom he longed appear before him and, having pressed her
hand to his lips, had shed gentle, happy tears, love for a
particular woman again crept unobserved into his heart and once more
bound him to life. And joyful and agitating thoughts began to occupy
his mind. Recalling the moment at the ambulance station when he had
seen Kuragin, he could not now regain the feeling he then had, but was
tormented by the question whether Kuragin was alive. And he dared
not inquire.

His illness pursued its normal physical course, but what Natasha
referred to when she said: "This suddenly happened," had occurred
two days before Princess Mary arrived. It was the last spiritual
struggle between life and death, in which death gained the victory. It
was the unexpected realization of the fact that he still valued life
as presented to him in the form of his love for Natasha, and a last,
though ultimately vanquished, attack of terror before the unknown.

It was evening. As usual after dinner he was slightly feverish,
and his thoughts were preternaturally clear. Sonya was sitting by
the table. He began to doze. Suddenly a feeling of happiness seized
him.

"Ah, she has come!" thought he.

And so it was: in Sonya's place sat Natasha who had just come in
noiselessly.

Since she had begun looking after him, he had always experienced
this physical consciousness of her nearness. She was sitting in an
armchair placed sideways, screening the light of the candle from
him, and was knitting a stocking. She had learned to knit stockings
since Prince Andrew had casually mentioned that no one nursed the sick
so well as old nurses who knit stockings, and that there is
something soothing in the knitting of stockings. The needles clicked
lightly in her slender, rapidly moving hands, and he could clearly see
the thoughtful profile of her drooping face. She moved, and the ball
rolled off her knees. She started, glanced round at him, and screening
the candle with her hand stooped carefully with a supple and exact
movement, picked up the ball, and regained her former position.

He looked at her without moving and saw that she wanted to draw a
deep breath after stooping, but refrained from doing so and breathed
cautiously.

At the Troitsa monastery they had spoken of the past, and he had
told her that if he lived he would always thank God for his wound
which had brought them together again, but after that they never spoke
of the future.

"Can it or can it not be?" he now thought as he looked at her and
listened to the light click of the steel needles. "Can fate have
brought me to her so strangely only for me to die?... Is it possible
that the truth of life has been revealed to me only to show me that
I have spent my life in falsity? I love her more than anything in
the world! But what am I to do if I love her?" he thought, and he
involuntarily groaned, from a habit acquired during his sufferings.

On hearing that sound Natasha put down the stocking, leaned nearer
to him, and suddenly, noticing his shining eyes, stepped lightly up to
him and bent over him.

"You are not asleep?"

"No, I have been looking at you a long time. I felt you come in.
No one else gives me that sense of soft tranquillity that you do...
that light. I want to weep for joy."

Natasha drew closer to him. Her face shone with rapturous joy.

"Natasha, I love you too much! More than anything in the world."

"And I!"--She turned away for an instant. "Why too much?" she asked.

"Why too much?... Well, what do you, what do you feel in your
soul, your whole soul--shall I live? What do you think?"

"I am sure of it, sure!" Natasha almost shouted, taking hold of both
his hands with a passionate movement.

He remained silent awhile.

"How good it would be!" and taking her hand he kissed it.

Natasha felt happy and agitated, but at once remembered that this
would not do and that he had to be quiet.

"But you have not slept," she said, repressing her joy. "Try to
sleep... please!"

He pressed her hand and released it, and she went back to the candle
and sat down again in her former position. Twice she turned and looked
at him, and her eyes met his beaming at her. She set herself a task on
her stocking and resolved not to turn round till it was finished.

Soon he really shut his eyes and fell asleep. He did not sleep
long and suddenly awoke with a start and in a cold perspiration.

As he fell asleep he had still been thinking of the subject that now
always occupied his mind--about life and death, and chiefly about
death. He felt himself nearer to it.

"Love? What is love?" he thought.

"Love hinders death. Love is life. All, everything that I
understand, I understand only because I love. Everything is,
everything exists, only because I love. Everything is united by it
alone. Love is God, and to die means that I, a particle of love, shall
return to the general and eternal source." These thoughts seemed to
him comforting. But they were only thoughts. Something was lacking
in them, they were not clear, they were too one-sidedly personal and
brain-spun. And there was the former agitation and obscurity. He
fell asleep.

He dreamed that he was lying in the room he really was in, but
that he was quite well and unwounded. Many various, indifferent, and
insignificant people appeared before him. He talked to them and
discussed something trivial. They were preparing to go away somewhere.
Prince Andrew dimly realized that all this was trivial and that he had
more important cares, but he continued to speak, surprising them by
empty witticisms. Gradually, unnoticed, all these persons began to
disappear and a single question, that of the closed door, superseded
all else. He rose and went to the door to bolt and lock it. Everything
depended on whether he was, or was not, in time to lock it. He went,
and tried to hurry, but his legs refused to move and he knew he
would not be in time to lock the door though he painfully strained all
his powers. He was seized by an agonizing fear. And that fear was
the fear of death. It stood behind the door. But just when he was
clumsily creeping toward the door, that dreadful something on the
other side was already pressing against it and forcing its way in.
Something not human--death--was breaking in through that door, and had
to be kept out. He seized the door, making a final effort to hold it
back--to lock it was no longer possible--but his efforts were weak and
clumsy and the door, pushed from behind by that terror, opened and
closed again.

Once again it pushed from outside. His last superhuman efforts
were vain and both halves of the door noiselessly opened. It
entered, and it was death, and Prince Andrew died.

But at the instant he died, Prince Andrew remembered that he was
asleep, and at the very instant he died, having made an effort, he
awoke.

"Yes, it was death! I died--and woke up. Yes, death is an
awakening!" And all at once it grew light in his soul and the veil
that had till then concealed the unknown was lifted from his spiritual
vision. He felt as if powers till then confined within him had been
liberated, and that strange lightness did not again leave him.

When, waking in a cold perspiration, he moved on the divan,
Natasha went up and asked him what was the matter. He did not answer
and looked at her strangely, not understanding.

That was what had happened to him two days before Princess Mary's
arrival. From that day, as the doctor expressed it, the wasting
fever assumed a malignant character, but what the doctor said did
not interest Natasha, she saw the terrible moral symptoms which to her
were more convincing.

From that day an awakening from life came to Prince Andrew
together with his awakening from sleep. And compared to the duration
of life it did not seem to him slower than an awakening from sleep
compared to the duration of a dream.

There was nothing terrible or violent in this comparatively slow
awakening.

His last days and hours passed in an ordinary and simple way. Both
Princess Mary and Natasha, who did not leave him, felt this. They
did not weep or shudder and during these last days they themselves
felt that they were not attending on him (he was no longer there, he
had left them) but on what reminded them most closely of him--his
body. Both felt this so strongly that the outward and terrible side of
death did not affect them and they did not feel it necessary to foment
their grief. Neither in his presence nor out of it did they weep,
nor did they ever talk to one another about him. They felt that they
could not express in words what they understood.

They both saw that he was sinking slowly and quietly, deeper and
deeper, away from them, and they both knew that this had to be so
and that it was right.

He confessed, and received communion: everyone came to take leave of
him. When they brought his son to him, he pressed his lips to the
boy's and turned away, not because he felt it hard and sad (Princess
Mary and Natasha understood that) but simply because he thought it was
all that was required of him, but when they told him to bless the boy,
he did what was demanded and looked round as if asking whether there
was anything else he should do.

When the last convulsions of the body, which the spirit was leaving,
occurred, Princess Mary and Natasha were present.

"Is it over?" said Princess Mary when his body had for a few minutes
lain motionless, growing cold before them. Natasha went up, looked
at the dead eyes, and hastened to close them. She closed them but
did not kiss them, but clung to that which reminded her most nearly of
him--his body.

"Where has he gone? Where is he now?..."

When the body, washed and dressed, lay in the coffin on a table,
everyone came to take leave of him and they all wept.

Little Nicholas cried because his heart was rent by painful
perplexity. The countess and Sonya cried from pity for Natasha and
because he was no more. The old count cried because he felt that
before long, he, too, must take the same terrible step.

Natasha and Princess Mary also wept now, but not because of their
own personal grief; they wept with a reverent and softening emotion
which had taken possession of their souls at the consciousness of
the simple and solemn mystery of death that had been accomplished in
their presence.





BOOK THIRTEEN: 1812





CHAPTER I


Man's mind cannot grasp the causes of events in their
completeness, but the desire to find those causes is implanted in
man's soul. And without considering the multiplicity and complexity of
the conditions any one of which taken separately may seem to be the
cause, he snatches at the first approximation to a cause that seems to
him intelligible and says: "This is the cause!" In historical events
(where the actions of men are the subject of observation) the first
and most primitive approximation to present itself was the will of the
gods and, after that, the will of those who stood in the most
prominent position--the heroes of history. But we need only
penetrate to the essence of any historic event--which lies in the
activity of the general mass of men who take part in it--to be
convinced that the will of the historic hero does not control the
actions of the mass but is itself continually controlled. It may
seem to be a matter of indifference whether we understand the
meaning of historical events this way or that; yet there is the same
difference between a man who says that the people of the West moved on
the East because Napoleon wished it and a man who says that this
happened because it had to happen, as there is between those who
declared that the earth was stationary and that the planets moved
round it and those who admitted that they did not know what upheld the
earth, but knew there were laws directing its movement and that of the
other planets. There is, and can be, no cause of an historical event
except the one cause of all causes. But there are laws directing
events, and some of these laws are known to us while we are
conscious of others we cannot comprehend. The discovery of these
laws is only possible when we have quite abandoned the
attempt to find the cause in the will of some one man, just as the
discovery of the laws of the motion of the planets was possible only
when men abandoned the conception of the fixity of the earth.

The historians consider that, next to the battle of Borodino and the
occupation of Moscow by the enemy and its destruction by fire, the
most important episode of the war of 1812 was the movement of the
Russian army from the Ryazana to the Kaluga road and to the Tarutino
camp--the so-called flank march across the Krasnaya Pakhra River. They
ascribe the glory of that achievement of genius to different men and
dispute as to whom the honor is due. Even foreign historians,
including the French, acknowledge the genius of the Russian commanders
when they speak of that flank march. But it is hard to understand
why military writers, and following them others, consider this flank
march to be the profound conception of some one man who saved Russia
and destroyed Napoleon. In the first place it is hard to understand
where the profundity and genius of this movement lay, for not much
mental effort was needed to see that the best position for an army
when it is not being attacked is where there are most provisions;
and even a dull boy of thirteen could have guessed that the best
position for an army after its retreat from Moscow in 1812 was on
the Kaluga road. So it is impossible to understand by what reasoning
the historians reach the conclusion that this maneuver was a
profound one. And it is even more difficult to understand just why
they think that this maneuver was calculated to save Russia and
destroy the French; for this flank march, had it been preceded,
accompanied, or followed by other circumstances, might have proved
ruinous to the Russians and salutary for the French. If the position
of the Russian army really began to improve from the time of that
march, it does not at all follow that the march was the cause of it.

That flank march might not only have failed to give any advantage to
the Russian army, but might in other circumstances have led to its
destruction. What would have happened had Moscow not burned down? If
Murat had not lost sight of the Russians? If Napoleon had not remained
inactive? If the Russian army at Krasnaya Pakhra had given battle as
Bennigsen and Barclay advised? What would have happened had the French
attacked the Russians while they were marching beyond the Pakhra? What
would have happened if on approaching Tarutino, Napoleon had
attacked the Russians with but a tenth of the energy he had shown when
he attacked them at Smolensk? What would have happened had the
French moved on Petersburg?... In any of these eventualities the flank
march that brought salvation might have proved disastrous.

The third and most incomprehensible thing is that people studying
history deliberately avoid seeing that this flank march cannot be
attributed to any one man, that no one ever foresaw it, and that in
reality, like the retreat from Fili, it did not suggest itself to
anyone in its entirety, but resulted--moment by moment, step by
step, event by event--from an endless number of most diverse
circumstances and was only seen in its entirety when it had been
accomplished and belonged to the past.

At the council at Fili the prevailing thought in the minds of the
Russian commanders was the one naturally suggesting itself, namely,
a direct retreat by the Nizhni road. In proof of this there is the
fact that the majority of the council voted for such a retreat, and
above all there is the well-known conversation after the council,
between the commander in chief and Lanskoy, who was in charge of the
commissariat department. Lanskoy informed the commander in chief
that the army supplies were for the most part stored along the Oka
in the Tula and Ryazan provinces, and that if they retreated on Nizhni
the army would be separated from its supplies by the broad river
Oka, which cannot be crossed early in winter. This was the first
indication of the necessity of deviating from what had previously
seemed the most natural course--a direct retreat on Nizhni-Novgorod.
The army turned more to the south, along the Ryazan road and nearer to
its supplies. Subsequently the inactivity of the French (who even
lost sight of the Russian army), concern for the safety of the arsenal
at Tula, and especially the advantages of drawing nearer to its
supplies caused the army to turn still further south to the Tula road.
Having crossed over, by a forced march, to the Tula road beyond the
Pakhra, the Russian commanders intended to remain at Podolsk and had
no thought of the Tarutino position; but innumerable circumstances and
the reappearance of French troops who had for a time lost touch with
the Russians, and projects of giving battle, and above all the
abundance of provisions in Kaluga province, obliged our army to turn
still more to the south and to cross from the Tula to the Kaluga
road and go to Tarutino, which was between the roads along which those
supplies lay. Just as it is impossible to say when it was decided to
abandon Moscow, so it is impossible to say precisely when, or by whom,
it was decided to move to Tarutino. Only when the army had got
there, as the result of innumerable and varying forces, did people
begin to assure themselves that they had desired this movement and
long ago foreseen its result.





CHAPTER II


The famous flank movement merely consisted in this: after the
advance of the French had ceased, the Russian army, which had been
continually retreating straight back from the invaders, deviated
from that direct course and, not finding itself pursued, was naturally
drawn toward the district where supplies were abundant.

If instead of imagining to ourselves commanders of genius leading
the Russian army, we picture that army without any leaders, it could
not have done anything but make a return movement toward Moscow,
describing an arc in the direction where most provisions were to be
found and where the country was richest.

That movement from the Nizhni to the Ryazan, Tula, and Kaluga
roads was so natural that even the Russian marauders moved in that
direction, and demands were sent from Petersburg for Kutuzov to take
his army that way. At Tarutino Kutuzov received what was almost a
reprimand from the Emperor for having moved his army along the
Ryazan road, and the Emperor's letter indicated to him the very
position he had already occupied near Kaluga.

Having rolled like a ball in the direction of the impetus given by
the whole campaign and by the battle of Borodino, the Russian army-
when the strength of that impetus was exhausted and no fresh push
was received--assumed the position natural to it.

Kutuzov's merit lay, not in any strategic maneuver of genius, as
it is called, but in the fact that he alone understood the
significance of what had happened. He alone then understood the
meaning of the French army's inactivity, he alone continued to
assert that the battle of Borodino had been a victory, he alone--who
as commander in chief might have been expected to be eager to
attack--employed his whole strength to restrain the Russian army
from useless engagements.

The beast wounded at Borodino was lying where the fleeing hunter had
left him; but whether he was still alive, whether he was strong and
merely lying low, the hunter did not know. Suddenly the beast was
heard to moan.

The moan of that wounded beast (the French army) which betrayed
its calamitous condition was the sending of Lauriston to Kutuzov's
camp with overtures for peace.

Napoleon, with his usual assurance that whatever entered his head
was right, wrote to Kutuzov the first words that occurred to him,
though they were meaningless.


MONSIEUR LE PRINCE KOUTOUZOV: I am sending one of my
adjutants-general to discuss several interesting questions with you. I
beg your Highness to credit what he says to you, especially when he
expresses the sentiment of esteem and special regard I have long
entertained for your person. This letter having no other object, I
pray God, monsieur le Prince Koutouzov, to keep you in His holy and
gracious protection!

NAPOLEON

MOSCOW, OCTOBER 30, 1812


Kutuzov replied: "I should be cursed by posterity were I looked on
as the initiator of a settlement of any sort. Such is the present
spirit of my nation." But he continued to exert all his powers to
restrain his troops from attacking.

During the month that the French troops were pillaging in Moscow and
the Russian troops were quietly encamped at Tarutino, a change had
taken place in the relative strength of the two armies--both in spirit
and in number--as a result of which the superiority had passed to
the Russian side. Though the condition and numbers of the French
army were unknown to the Russians, as soon as that change occurred the
need of attacking at once showed itself by countless signs. These
signs were: Lauriston's mission; the abundance of provisions at
Tarutino; the reports coming in from all sides of the inactivity and
disorder of the French; the flow of recruits to our regiments; the
fine weather; the long rest the Russian soldiers had enjoyed, and
the impatience to do what they had been assembled for, which usually
shows itself in an army that has been resting; curiosity as to what
the French army, so long lost sight of, was doing; the boldness with
which our outposts now scouted close up to the French stationed at
Tarutino; the news of easy successes gained by peasants and
guerrilla troops over the French, the envy aroused by this; the desire
for revenge that lay in the heart of every Russian as long as the
French were in Moscow, and (above all) a dim consciousness in every
soldier's mind that the relative strength of the armies had changed
and that the advantage was now on our side. There was a substantial
change in the relative strength, and an advance had become inevitable.
And at once, as a clock begins to strike and chime as soon as the
minute hand has completed a full circle, this change was shown by an
increased activity, whirring, and chiming in the higher spheres.





CHAPTER III


The Russian army was commanded by Kutuzov and his staff, and also by
the Emperor from Petersburg. Before the news of the abandonment of
Moscow had been received in Petersburg, a detailed plan of the whole
campaign had been drawn up and sent to Kutuzov for his guidance.
Though this plan had been drawn up on the supposition that Moscow
was still in our hands, it was approved by the staff and accepted as a
basis for action. Kutuzov only replied that movements arranged from
a distance were always difficult to execute. So fresh instructions
were sent for the solution of difficulties that might be
encountered, as well as fresh people who were to watch Kutuzov's
actions and report upon them.

Besides this, the whole staff of the Russian army was now
reorganized. The posts left vacant by Bagration, who had been
killed, and by Barclay, who had gone away in dudgeon, had to be
filled. Very serious consideration was given to the question whether
it would be better to put A in B's place and B in D's, or on the
contrary to put D in A's place, and so on--as if anything more than
A's or B's satisfaction depended on this.

As a result of the hostility between Kutuzov and Bennigsen, his
Chief of Staff, the presence of confidential representatives of the
Emperor, and these transfers, a more than usually complicated play
of parties was going on among the staff of the army. A was undermining
B, D was undermining C, and so on in all possible combinations and
permutations. In all these plottings the subject of intrigue was
generally the conduct of the war, which all these men believed they
were directing; but this affair of the war went on independently of
them, as it had to go: that is, never in the way people devised, but
flowing always from the essential attitude of the masses. Only in
the highest spheres did all these schemes, crossings, and
interminglings appear to be a true reflection of what had to happen.


Prince Michael Ilarionovich! (wrote the Emperor on the second of
October in a letter that reached Kutuzov after the battle at Tarutino)
Since September 2 Moscow has been in the hands of the enemy. Your last
reports were written on the twentieth, and during all this time not
only has no action been taken against the enemy or for the relief of
the ancient capital, but according to your last report you have even
retreated farther. Serpukhov is already occupied by an enemy
detachment and Tula with its famous arsenal so indispensable to the
army, is in danger. From General Wintzingerode's reports, I see that
an enemy corps of ten thousand men is moving on the Petersburg road.
Another corps of several thousand men is moving on Dmitrov. A third
has advanced along the Vladimir road, and a fourth, rather
considerable detachment is stationed between Ruza and Mozhaysk.
Napoleon himself was in Moscow as late as the twenty-fifth. In view of
all this information, when the enemy has scattered his forces in large
detachments, and with Napoleon and his Guards in Moscow, is it
possible that the enemy's forces confronting you are so considerable
as not to allow of your taking the offensive? On the contrary, he is
probably pursuing you with detachments, or at most with an army
corps much weaker than the army entrusted to you. It would seem
that, availing yourself of these circumstances, you might
advantageously attack a weaker one and annihilate him, or at least
oblige him to retreat, retaining in our hands an important part of the
provinces now occupied by the enemy, and thereby averting danger
from Tula and other towns in the interior. You will be responsible
if the enemy is able to direct a force of any size against
Petersburg to threaten this capital in which it has not been
possible to retain many troops; for with the army entrusted to you,
and acting with resolution and energy, you have ample means to avert
this fresh calamity. Remember that you have still to answer to our
offended country for the loss of Moscow. You have experienced my
readiness to reward you. That readiness will not weaken in me, but I
and Russia have a right to expect from you all the zeal, firmness, and
success which your intellect, military talent, and the courage of
the troops you command justify us in expecting.


But by the time this letter, which proved that the real relation
of the forces had already made itself felt in Petersburg, was
dispatched, Kutuzov had found himself unable any longer to restrain
the army he commanded from attacking and a battle had taken place.

On the second of October a Cossack, Shapovalov, who was out
scouting, killed one hare and wounded another. Following the wounded
hare he made his way far into the forest and came upon the left
flank of Murat's army, encamped there without any precautions. The
Cossack laughingly told his comrades how he had almost fallen into the
hands of the French. A cornet, hearing the story, informed his
commander.

The Cossack was sent for and questioned. The Cossack officers wished
to take advantage of this chance to capture some horses, but one of
the superior officers, who was acquainted with the higher authorities,
reported the incident to a general on the staff.  The state of
things on the staff had of late been exceedingly strained. Ermolov had
been to see Bennigsen a few days previously and had entreated him to
use his influence with the commander in chief to induce him to take
the offensive.

"If I did not know you I should think you did not want what you
are asking for. I need only advise anything and his Highness is sure
to do the opposite," replied Bennigsen.

The Cossack's report, confirmed by horse patrols who were sent
out, was the final proof that events had matured. The tightly coiled
spring was released, the clock began to whirr and the chimes to
play. Despite all his supposed power, his intellect, his experience,
and his knowledge of men, Kutuzov--having taken into consideration the
Cossack's report, a note from Bennigsen who sent personal reports to
the Emperor, the wishes he supposed the Emperor to hold, and the
fact that all the generals expressed the same wish--could no longer
check the inevitable movement, and gave the order to do what he
regarded as useless and harmful--gave his approval, that is, to the
accomplished fact.





CHAPTER IV


Bennigsen's note and the Cossack's information that the left flank
of the French was unguarded were merely final indications that it
was necessary to order an attack, and it was fixed for the fifth of
October.

On the morning of the fourth of October Kutuzov signed the
dispositions. Toll read them to Ermolov, asking him to attend to the
further arrangements.

"All right--all right. I haven't time just now," replied Ermolov,
and left the hut.

The dispositions drawn up by Toll were very good. As in the
Austerlitz dispositions, it was written--though not in German this
time:

"The First Column will march here and here," "the Second Column will
march there and there," and so on; and on paper, all these columns
arrived at their places at the appointed time and destroyed the enemy.
Everything had been admirably thought out as is usual in dispositions,
and as is always the case, not a single column reached its place at
the appointed time.

When the necessary number of copies of the dispositions had been
prepared, an officer was summoned and sent to deliver them to
Ermolov to deal with. A young officer of the Horse Guards, Kutuzov's
orderly, pleased at the importance of the mission entrusted to him,
went to Ermolov's quarters.

"Gone away," said Ermolov's orderly.

The officer of the Horse Guards went to a general with whom
Ermolov was often to be found.

"No, and the general's out too."

The officer, mounting his horse, rode off to someone else.

"No, he's gone out."

"If only they don't make me responsible for this delay! What a
nuisance it is!" thought the officer, and he rode round the whole
camp. One man said he had seen Ermolov ride past with some other
generals, others said he must have returned home. The officer searched
till six o'clock in the evening without even stopping to eat.
Ermolov was nowhere to be found and no one knew where he was. The
officer snatched a little food at a comrade's, and rode again to the
vanguard to find Miloradovich. Miloradovich too was away, but here
he was told that he had gone to a ball at General Kikin's and that
Ermolov was probably there too.

"But where is it?"

"Why, there, over at Echkino," said a Cossack officer, pointing to a
country house in the far distance.

"What, outside our line?"

"They've put two regiments as outposts, and they're having such a
spree there, it's awful! Two bands and three sets of singers!"

The officer rode out beyond our lines to Echkino. While still at a
distance he heard as he rode the merry sounds of a soldier's dance
song proceeding from the house.

"In the meadows... in the meadows!" he heard, accompanied by
whistling and the sound of a torban, drowned every now and then by
shouts. These sounds made his spirits rise, but at the same time he
was afraid that he would be blamed for not having executed sooner
the important order entrusted to him. It was already past eight
o'clock. He dismounted and went up into the porch of a large country
house which had remained intact between the Russian and French forces.
In the refreshment room and the hall, footmen were bustling about with
wine and viands. Groups of singers stood outside the windows. The
officer was admitted and immediately saw all the chief generals of the
army together, and among them Ermolov's big imposing figure. They
all had their coats unbuttoned and were standing in a semicircle
with flushed and animated faces, laughing loudly. In the middle of the
room a short handsome general with a red face was dancing the trepak
with much spirit and agility.

"Ha, ha, ha! Bravo, Nicholas Ivanych! Ha, ha, ha!"

The officer felt that by arriving with important orders at such a
moment he was doubly to blame, and he would have preferred to wait;
but one of the generals espied him and, hearing what he had come
about, informed Ermolov.

Ermolov came forward with a frown on his face and, hearing what
the officer had to say, took the papers from him without a word.


"You think he went off just by chance?" said a comrade, who was on
the staff that evening, to the officer of the Horse Guards,
referring to Ermolov. "It was a trick. It was done on purpose to get
Konovnitsyn into trouble. You'll see what a mess there'll be
tomorrow."





CHAPTER V


Next day the decrepit Kutuzov, having given orders to be called
early, said his prayers, dressed, and, with an unpleasant
consciousness of having to direct a battle he did not approve of,
got into his caleche and drove from Letashovka (a village three and
a half miles from Tarutino) to the place where the attacking columns
were to meet. He sat in the caleche, dozing and waking up by turns,
and listening for any sound of firing on the right as an indication
that the action had begun. But all was still quiet. A damp dull autumn
morning was just dawning. On approaching Tarutino Kutuzov noticed
cavalrymen leading their horses to water across the road along which
he was driving. Kutuzov looked at them searchingly, stopped his
carriage, and inquired what regiment they belonged to. They belonged
to a column that should have been far in front and in ambush long
before then. "It may be a mistake," thought the old commander in
chief. But a little further on he saw infantry regiments with their
arms piled and the soldiers, only partly dressed, eating their rye
porridge and carrying fuel. He sent for an officer. The officer
reported that no order to advance had been received.

"How! Not rec..." Kutuzov began, but checked himself immediately and
sent for a senior officer. Getting out of his caleche, he waited
with drooping head and breathing heavily, pacing silently up and down.
When Eykhen, the officer of the general staff whom he had summoned,
appeared, Kutuzov went purple in the face, not because that officer
was to blame for the mistake, but because he was an object of
sufficient importance for him to vent his wrath on. Trembling and
panting the old man fell into that state of fury in which he sometimes
used to roll on the ground, and he fell upon Eykhen, threatening him
with his hands, shouting and loading him with gross abuse. Another
man, Captain Brozin, who happened to turn up and who was not at all to
blame, suffered the same fate.

"What sort of another blackguard are you? I'll have you shot!
Scoundrels!" yelled Kutuzov in a hoarse voice, waving his arms and
reeling.

He was suffering physically. He, the commander in chief, a Serene
Highness who everybody said possessed powers such as no man had ever
had in Russia, to be placed in this position--made the laughingstock
of the whole army! "I needn't have been in such a hurry to pray
about today, or have kept awake thinking everything over all night,"
thought he to himself. "When I was a chit of an officer no one would
have dared to mock me so... and now!" He was in a state of physical
suffering as if from corporal punishment, and could not avoid
expressing it by cries of anger and distress. But his strength soon
began to fail him, and looking about him, conscious of having said
much that was amiss, he again got into his caleche and drove back in
silence.

His wrath, once expended, did not return, and blinking feebly he
listened to excuses and self-justifications (Ermolov did not come to
see him till the next day) and to the insistence of Bennigsen,
Konovnitsyn, and Toll that the movement that had miscarried should
be executed next day. And once more Kutuzov had to consent.





CHAPTER VI


Next day the troops assembled in their appointed places in the
evening and advanced during the night. It was an autumn night with
dark purple clouds, but no rain. The ground was damp but not muddy,
and the troops advanced noiselessly, only occasionally a jingling of
the artillery could be faintly heard. The men were forbidden to talk
out loud, to smoke their pipes, or to strike a light, and they tried
to prevent their horses neighing. The secrecy of the undertaking
heightened its charm and they marched gaily. Some columns,
supposing they had reached their destination, halted, piled arms, and
settled down on the cold ground, but the majority marched all night
and arrived at places where they evidently should not have been.

Only Count Orlov-Denisov with his Cossacks (the least important
detachment of all) got to his appointed place at the right time.
This detachment halted at the outskirts of a forest, on the path
leading from the village of Stromilova to Dmitrovsk.

Toward dawn, Count Orlov-Denisov, who had dozed off, was awakened by
a deserter from the French army being brought to him. This was a
Polish sergeant of Poniatowski's corps, who explained in Polish that
he had come over because he had been slighted in the service: that
he ought long ago to have been made an officer, that he was braver
than any of them, and so he had left them and wished to pay them
out. He said that Murat was spending the night less than a mile from
where they were, and that if they would let him have a convoy of a
hundred men he would capture him alive. Count Orlov-Denisov
consulted his fellow officers.

The offer was too tempting to be refused. Everyone volunteered to go
and everybody advised making the attempt. After much disputing and
arguing, Major-General Grekov with two Cossack regiments decided to go
with the Polish sergeant.

"Now, remember," said Count Orlov-Denisov to the sergeant at
parting, "if you have been lying I'll have you hanged like a dog;
but if it's true you shall have a hundred gold pieces!"

Without replying, the sergeant, with a resolute air, mounted and
rode away with Grekov whose men had quickly assembled. They
disappeared into the forest, and Count Orlov-Denisov, having seen
Grekov off, returned, shivering from the freshness of the early dawn
and excited by what he had undertaken on his own responsibility, and
began looking at the enemy camp, now just visible in the deceptive
light of dawn and the dying campfires. Our columns ought to have begun
to appear on an open declivity to his right. He looked in that
direction, but though the columns would have been visible quite far
off, they were not to be seen. It seemed to the count that things were
beginning to stir in the French camp, and his keen-sighted adjutant
confirmed this.

"Oh, it is really too late," said Count Orlov, looking at the camp.

As often happens when someone we have trusted is no longer before
our eyes, it suddenly seemed quite clear and obvious to him that the
sergeant was an impostor, that he had lied, and that the whole Russian
attack would be ruined by the absence of those two regiments, which he
would lead away heaven only knew where. How could one capture a
commander in chief from among such a mass of troops!

"I am sure that rascal was lying," said the count.

"They can still be called back," said one of his suite, who like
Count Orlov felt distrustful of the adventure when he looked at the
enemy's camp.

"Eh? Really... what do you think? Should we let them go on or not?"

"Will you have them fetched back?"

"Fetch them back, fetch them back!" said Count Orlov with sudden
determination, looking at his watch. "It will be too late. It is quite
light."

And the adjutant galloped through the forest after Grekov. When
Grekov returned, Count Orlov-Denisov, excited both by the abandoned
attempt and by vainly awaiting the infantry columns that still did not
appear, as well as by the proximity of the enemy, resolved to advance.
All his men felt the same excitement.

"Mount!" he commanded in a whisper. The men took their places and
crossed themselves.... "Forward, with God's aid!"

"Hurrah-ah-ah!" reverberated in the forest, and the Cossack
companies, trailing their lances and advancing one after another as if
poured out of a sack, dashed gaily across the brook toward the camp.

One desperate, frightened yell from the first French soldier who saw
the Cossacks, and all who were in the camp, undressed and only just
waking up, ran off in all directions, abandoning cannons, muskets, and
horses.

Had the Cossacks pursued the French, without heeding what was behind
and around them, they would have captured Murat and everything
there. That was what the officers desired. But it was impossible to
make the Cossacks budge when once they had got booty and prisoners.
None of them listened to orders. Fifteen hundred prisoners and
thirty-eight guns were taken on the spot, besides standards and
(what seemed most important to the Cossacks) horses, saddles,
horsecloths, and the like. All this had to be dealt with, the
prisoners and guns secured, the booty divided--not without some
shouting and even a little themselves--and it was on this that the
Cossacks all busied themselves.

The French, not being farther pursued, began to recover
themselves: they formed into detachments and began firing.
Orlov-Denisov, still waiting for the other columns to arrive, advanced
no further.

Meantime, according to the dispositions which said that "the First
Column will march" and so on, the infantry of the belated columns,
commanded by Bennigsen and directed by Toll, had started in due
order and, as always happens, had got somewhere, but not to their
appointed places. As always happens the men, starting cheerfully,
began to halt; murmurs were heard, there was a sense of confusion, and
finally a backward movement. Adjutants and generals galloped about,
shouted, grew angry, quarreled, said they had come quite wrong and
were late, gave vent to a little abuse, and at last gave it all up and
went forward, simply to get somewhere. "We shall get somewhere or
other!" And they did indeed get somewhere, though not to their right
places; a few eventually even got to their right place, but too late
to be of any use and only in time to be fired at. Toll, who in this
battle played the part of Weyrother at Austerlitz, galloped
assiduously from place to place, finding everything upside down
everywhere. Thus he stumbled on Bagovut's corps in a wood when it
was already broad daylight, though the corps should long before have
joined Orlov-Denisov. Excited and vexed by the failure and supposing
that someone must be responsible for it, Toll galloped up to the
commander of the corps and began upbraiding him severely, saying
that he ought to be shot. General Bagovut, a fighting old soldier of
placid temperament, being also upset by all the delay, confusion,
and cross-purposes, fell into a rage to everybody's surprise and quite
contrary to his usual character and said disagreeable things to Toll.

"I prefer not to take lessons from anyone, but I can die with my men
as well as anybody," he said, and advanced with a single division.

Coming out onto a field under the enemy's fire, this brave general
went straight ahead, leading his men under fire, without considering
in his agitation whether going into action now, with a single
division, would be of any use or no. Danger, cannon balls, and bullets
were just what he needed in his angry mood. One of the first bullets
killed him, and other bullets killed many of his men. And his division
remained under fire for some time quite uselessly.





CHAPTER VII


Meanwhile another column was to have attacked the French from the
front, but Kutuzov accompanied that column. He well knew that
nothing but confusion would come of this battle undertaken against his
will, and as far as was in his power held the troops back. He did
not advance.

He rode silently on his small gray horse, indolently answering
suggestions that they should attack.

"The word attack is always on your tongue, but you don't see that we
are unable to execute complicated maneuvers," said he to
Miloradovich who asked permission to advance.

"We couldn't take Murat prisoner this morning or get to the place in
time, and nothing can be done now!" he replied to someone else.

When Kutuzov was informed that at the French rear--where according
to the reports of the Cossacks there had previously been nobody--there
were now two battalions of Poles, he gave a sidelong glance at Ermolov
who was behind him and to whom he had not spoken since the previous
day.

"You see! They are asking to attack and making plans of all kinds,
but as soon as one gets to business nothing is ready, and the enemy,
forewarned, takes measures accordingly."

Ermolov screwed up his eyes and smiled faintly on hearing these
words. He understood that for him the storm had blown over, and that
Kutuzov would content himself with that hint.

"He's having a little fun at my expense," said Ermolov softly,
nudging with his knee Raevski who was at his side.

Soon after this, Ermolov moved up to Kutuzov and respectfully
remarked:

"It is not too late yet, your Highness--the enemy has not gone away-
if you were to order an attack! If not, the Guards will not so much as
see a little smoke."

Kutuzov did not reply, but when they reported to him that Murat's
troops were in retreat he ordered an advance, though at every
hundred paces he halted for three quarters of an hour.

The whole battle consisted in what Orlov-Denisov's Cossacks had
done: the rest of the army merely lost some hundreds of men uselessly.

In consequence of this battle Kutuzov received a diamond decoration,
and Bennigsen some diamonds and a hundred thousand rubles, others also
received pleasant recognitions corresponding to their various
grades, and following the battle fresh changes were made in the staff.

"That's how everything is done with us, all topsy-turvy!" said the
Russian officers and generals after the Tarutino battle, letting it be
understood that some fool there is doing things all wrong but that
we ourselves should not have done so, just as people speak today.
But people who talk like that either do not know what they are talking
about or deliberately deceive themselves. No battle--Tarutino,
Borodino, or Austerlitz--takes place as those who planned it
anticipated. That is an essential condition.

A countless number of free forces (for nowhere is man freer than
during a battle, where it is a question of life and death) influence
the course taken by the fight, and that course never can be known in
advance and never coincides with the direction of any one force.

If many simultaneously and variously directed forces act on a
given body, the direction of its motion cannot coincide with any one
of those forces, but will always be a mean--what in mechanics is
represented by the diagonal of a parallelogram of forces.

If in the descriptions given by historians, especially French
ones, we find their wars and battles carried out in accordance with
previously formed plans, the only conclusion to be drawn is that those
descriptions are false.

The battle of Tarutino obviously did not attain the aim Toll had
in view--to lead the troops into action in the order prescribed by the
dispositions; nor that which Count Orlov-Denisov may have had in view-
to take Murat prisoner; nor the result of immediately destroying the
whole corps, which Bennigsen and others may have had in view; nor
the aim of the officer who wished to go into action to distinguish
himself; nor that of the Cossack who wanted more booty than he got,
and so on. But if the aim of the battle was what actually resulted and
what all the Russians of that day desired--to drive the French out
of Russia and destroy their army--it is quite clear that the battle of
Tarutino, just because of its incongruities, was exactly what was
wanted at that stage of the campaign. It would be difficult and even
impossible to imagine any result more opportune than the actual
outcome of this battle. With a minimum of effort and insignificant
losses, despite the greatest confusion, the most important results
of the whole campaign were attained: the transition from retreat to
advance, an exposure of the weakness of the French, and the
administration of that shock which Napoleon's army had only awaited to
begin its flight.





CHAPTER VIII


Napoleon enters Moscow after the brilliant victory de la Moskowa;
there can be no doubt about the victory for the battlefield remains in
the hands of the French. The Russians retreat and abandon their
ancient capital. Moscow, abounding in provisions, arms, munitions, and
incalculable wealth, is in Napoleon's hands. The Russian army, only
half the strength of the French, does not make a single attempt to
attack for a whole month. Napoleon's position is most brilliant. He
can either fall on the Russian army with double its strength and
destroy it; negotiate an advantageous peace, or in case of a refusal
make a menacing move on Petersburg, or even, in the case of a reverse,
return to Smolensk or Vilna; or remain in Moscow; in short, no special
genius would seem to be required to retain the brilliant position
the French held at that time. For that, only very simple and easy
steps were necessary: not to allow the troops to loot, to prepare
winter clothing--of which there was sufficient in Moscow for the whole
army--and methodically to collect the provisions, of which
(according to the French historians) there were enough in Moscow to
supply the whole army for six months. Yet Napoleon, that greatest of
all geniuses, who the historians declare had control of the army, took
none of these steps.

He not merely did nothing of the kind, but on the contrary he used
his power to select the most foolish and ruinous of all the courses
open to him. Of all that Napoleon might have done: wintering in
Moscow, advancing on Petersburg or on Nizhni-Novgorod, or retiring
by a more northerly or more southerly route (say by the road Kutuzov
afterwards took), nothing more stupid or disastrous can be imagined
than what he actually did. He remained in Moscow till October, letting
the troops plunder the city; then, hesitating whether to leave a
garrison behind him, he quitted Moscow, approached Kutuzov without
joining battle, turned to the right and reached Malo-Yaroslavets,
again without attempting to break through and take the road Kutuzov
took, but retiring instead to Mozhaysk along the devastated Smolensk
road. Nothing more stupid than that could have been devised, or more
disastrous for the army, as the sequel showed. Had Napoleon's aim been
to destroy his army, the most skillful strategist could hardly have
devised any series of actions that would so completely have
accomplished that purpose, independently of anything the Russian
army might do.


Napoleon, the man of genius, did this! But to say that he
destroyed his army because he wished to, or because he was very
stupid, would be as unjust as to say that he had brought his troops to
Moscow because he wished to and because he was very clever and a
genius.

In both cases his personal activity, having no more force than the
personal activity of any soldier, merely coincided with the laws
that guided the event.

The historians quite falsely represent Napoleon's faculties as
having weakened in Moscow, and do so only because the results did
not justify his actions. He employed all his ability and strength to
do the best he could for himself and his army, as he had done
previously and as he did subsequently in 1813. His activity at that
time was no less astounding than it was in Egypt, in Italy, in
Austria, and in Prussia. We do not know for certain in how far his
genius was genuine in Egypt--where forty centuries looked down upon
his grandeur--for his great exploits there are all told us by
Frenchmen. We cannot accurately estimate his genius in Austria or
Prussia, for we have to draw our information from French or German
sources, and the incomprehensible surrender of whole corps without
fighting and of fortresses without a siege must incline Germans to
recognize his genius as the only explanation of the war carried on
in Germany. But we, thank God, have no need to recognize his genius in
order to hide our shame. We have paid for the right to look at the
matter plainly and simply, and we will not abandon that right.

His activity in Moscow was as amazing and as full of genius as
elsewhere. Order after order order and plan after plan were issued
by him from the time he entered Moscow till the time he left it. The
absence of citizens and of a deputation, and even the burning of
Moscow, did not disconcert him. He did not lose sight either of the
welfare of his army or of the doings of the enemy, or of the welfare
of the people of Russia, or of the direction of affairs in Paris, or
of diplomatic considerations concerning the terms of the anticipated
peace.





CHAPTER IX


With regard to military matters, Napoleon immediately on his entry
into Moscow gave General Sabastiani strict orders to observe the
movements of the Russian army, sent army corps out along the different
roads, and charged Murat to find Kutuzov. Then he gave careful
directions about the fortification of the Kremlin, and drew up a
brilliant plan for a future campaign over the whole map of Russia.

With regard to diplomatic questions, Napoleon summoned Captain
Yakovlev, who had been robbed and was in rags and did not know how
to get out of Moscow, minutely explained to him his whole policy and
his magnanimity, and having written a letter to the Emperor
Alexander in which he considered it his duty to inform his Friend
and Brother that Rostopchin had managed affairs badly in Moscow, he
dispatched Yakovlev to Petersburg.

Having similarly explained his views and his magnanimity to
Tutolmin, he dispatched that old man also to Petersburg to negotiate.

With regard to legal matters, immediately after the fires he gave
orders to find and execute the incendiaries. And the scoundrel
Rostopchin was punished by an order to burn down his houses.

With regard to administrative matters, Moscow was granted a
constitution. A municipality was established and the following
announcement issued:


INHABITANTS OF MOSCOW!

Your misfortunes are cruel, but His Majesty the Emperor and King
desires to arrest their course. Terrible examples have taught you
how he punishes disobedience and crime. Strict measures have been
taken to put an end to disorder and to re-establish public security. A
paternal administration, chosen from among yourselves, will form
your municipality or city government. It will take care of you, of
your needs, and of your welfare. Its members will be distinguished
by a red ribbon worn across the shoulder, and the mayor of the city
will wear a white belt as well. But when not on duty they will only
wear a red ribbon round the left arm.

The city police is established on its former footing, and better
order already prevails in consequence of its activity. The
government has appointed two commissaries general, or chiefs of
police, and twenty commissaries or captains of wards have been
appointed to the different wards of the city. You will recognize
them by the white ribbon they will wear on the left arm. Several
churches of different denominations are open, and divine service is
performed in them unhindered. Your fellow citizens are returning every
day to their homes. and orders have been given that they should find
in them the help and protection due to their misfortunes. These are
the measures the government has adopted to re-establish order and
relieve your condition. But to achieve this aim it is necessary that
you should add your efforts and should, if possible, forget the
misfortunes you have suffered, should entertain the hope of a less
cruel fate, should be certain that inevitable and ignominious death
awaits those who make any attempt on your persons or on what remains
of your property, and finally that you should not doubt that these
will be safeguarded, since such is the will of the greatest and most
just of monarchs. Soldiers and citizens, of whatever nation you may
be, re-establish public confidence, the source of the welfare of a
state, live like brothers, render mutual aid and protection one to
another, unite to defeat the intentions of the evil-minded, obey the
military and civil authorities, and your tears will soon cease to
flow!


With regard to supplies for the army, Napoleon decreed that all
the troops in turn should enter Moscow a la maraude* to obtain
provisions for themselves, so that the army might have its future
provided for.


*As looters.


With regard to religion, Napoleon ordered the priests to be
brought back and services to be again performed in the churches.

With regard to commerce and to provisioning the army, the
following was placarded everywhere:


PROCLAMATION!

You, peaceful inhabitants of Moscow, artisans and workmen whom
misfortune has driven from the city, and you scattered tillers of
the soil, still kept out in the fields by groundless fear, listen!
Tranquillity is returning to this capital and order is being
restored in it. Your fellow countrymen are emerging boldly from
their hiding places on finding that they are respected. Any violence
to them or to their property is promptly punished. His Majesty the
Emperor and King protects them, and considers no one among you his
enemy except those who disobey his orders. He desires to end your
misfortunes and restore you to your homes and families. Respond,
therefore, to his benevolent intentions and come to us without fear.
Inhabitants, return with confidence to your abodes! You will soon find
means of satisfying your needs. Craftsmen and industrious artisans,
return to your work, your houses, your shops, where the protection
of guards awaits you! You shall receive proper pay for your work.
And lastly you too, peasants, come from the forests where you are
hiding in terror, return to your huts without fear, in full
assurance that you will find protection! Markets are established in
the city where peasants can bring their surplus supplies and the
products of the soil. The government has taken the following steps
to ensure freedom of sale for them: (1) From today, peasants,
husbandmen, and those living in the neighborhood of Moscow may without
any danger bring their supplies of all kinds to two appointed markets,
of which one is on the Mokhovaya Street and the other at the Provision
Market. (2) Such supplies will be bought from them at such prices as
seller and buyer may agree on, and if a seller is unable to obtain a
fair price he will be free to take his goods back to his village and
no one may hinder him under any pretense. (3) Sunday and Wednesday
of each week are appointed as the chief market days and to that end
a sufficient number of troops will be stationed along the highroads on
Tuesdays and Saturdays at such distances from the town as to protect
the carts. (4) Similar measures will be taken that peasants with their
carts and horses may meet with no hindrance on their return journey.
(5) Steps will immediately be taken to re-establish ordinary trading.

Inhabitants of the city and villages, and you, workingmen and
artisans, to whatever nation you belong, you are called on to carry
out the paternal intentions of His Majesty the Emperor and King and to
co-operate with him for the public welfare! Lay your respect and
confidence at his feet and do not delay to unite with us!


With the object of raising the spirits of the troops and of the
people, reviews were constantly held and rewards distributed. The
Emperor rode through the streets to comfort the inhabitants, and,
despite his preoccupation with state affairs, himself visited the
theaters that were established by his order.

In regard to philanthropy, the greatest virtue of crowned heads,
Napoleon also did all in his power. He caused the words Maison de ma
Mere to be inscribed on the charitable institutions, thereby combining
tender filial affection with the majestic benevolence of a monarch. He
visited the Foundling Hospital and, allowing the orphans saved by
him to kiss his white hands, graciously conversed with Tutolmin. Then,
as Thiers eloquently recounts, he ordered his soldiers to be paid in
forged Russian money which he had prepared: "Raising the use of
these means by an act worthy of himself and of the French army, he let
relief be distributed to those who had been burned out. But as food
was too precious to be given to foreigners, who were for the most part
enemies, Napoleon preferred to supply them with money with which to
purchase food from outside, and had paper rubles distributed to them."

With reference to army discipline, orders were continually being
issued to inflict severe punishment for the nonperformance of military
duties and to suppress robbery.





CHAPTER X


But strange to say, all these measures, efforts, and plans--which
were not at all worse than others issued in similar circumstances--did
not affect the essence of the matter but, like the hands of a clock
detached from the mechanism, swung about in an arbitrary and aimless
way without engaging the cogwheels.

With reference to the military side--the plan of campaign--that work
of genius of which Thiers remarks that, "His genius never devised
anything more profound, more skillful, or more admirable," and
enters into a polemic with M. Fain to prove that this work of genius
must be referred not to the fourth but to the fifteenth of October-
that plan never was or could be executed, for it was quite out of
touch with the facts of the case. The fortifying of the Kremlin, for
which la Mosquee (as Napoleon termed the church of Basil the
Beatified) was to have been razed to the ground, proved quite useless.
The mining of the Kremlin only helped toward fulfilling Napoleon's
wish that it should be blown up when he left Moscow--as a child
wants the floor on which he has hurt himself to be beaten. The pursuit
of the Russian army, about which Napoleon was so concerned, produced
an unheard-of result. The French generals lost touch with the
Russian army of sixty thousand men, and according to Thiers it was
only eventually found, like a lost pin, by the skill--and apparently
the genius--of Murat.

With reference to diplomacy, all Napoleon's arguments as to his
magnanimity and justice, both to Tutolmin and to Yakovlev (whose chief
concern was to obtain a greatcoat and a conveyance), proved useless;
Alexander did not receive these envoys and did not reply to their
embassage.

With regard to legal matters, after the execution of the supposed
incendiaries the rest of Moscow burned down.

With regard to administrative matters, the establishment of a
municipality did not stop the robberies and was only of use to certain
people who formed part of that municipality and under pretext of
preserving order looted Moscow or saved their own property from
being looted.

With regard to religion, as to which in Egypt matters had so
easily been settled by Napoleon's visit to a mosque, no results were
achieved. Two or three priests who were found in Moscow did try to
carry out Napoleon's wish, but one of them was slapped in the face
by a French soldier while conducting service, and a French official
reported of another that: "The priest whom I found and invited to
say Mass cleaned and locked up the church. That night the doors were
again broken open, the padlocks smashed, the books mutilated, and
other disorders perpetrated."

With reference to commerce, the proclamation to industrious
workmen and to peasants evoked no response. There were no
industrious workmen, and the peasants caught the commissaries who
ventured too far out of town with the proclamation and killed them.

As to the theaters for the entertainment of the people and the
troops, these did not meet with success either. The theaters set up in
the Kremlin and in Posnyakov's house were closed again at once because
the actors and actresses were robbed.

Even philanthropy did not have the desired effect. The genuine as
well as the false paper money which flooded Moscow lost its value. The
French, collecting booty, cared only for gold. Not only was the
paper money valueless which Napoleon so graciously distributed to
the unfortunate, but even silver lost its value in relation to gold.

But the most amazing example of the ineffectiveness of the orders
given by the authorities at that time was Napoleon's attempt to stop
the looting and re-establish discipline.

This is what the army authorities were reporting:

"Looting continues in the city despite the decrees against it. Order
is not yet restored and not a single merchant is carrying on trade
in a lawful manner. The sutlers alone venture to trade, and they
sell stolen goods."

"The neighborhood of my ward continues to be pillaged by soldiers of
the 3rd Corps who, not satisfied with taking from the unfortunate
inhabitants hiding in the cellars the little they have left, even have
the ferocity to wound them with their sabers, as I have repeatedly
witnessed."

"Nothing new, except that the soldiers are robbing and pillaging-
October 9."

"Robbery and pillaging continue. There is a band of thieves in our
district who ought to be arrested by a strong force--October 11."

"The Emperor is extremely displeased that despite the strict
orders to stop pillage, parties of marauding Guards are continually
seen returning to the Kremlin. Among the Old Guard disorder and
pillage were renewed more violently than ever yesterday evening,
last night, and today. The Emperor sees with regret that the picked
soldiers appointed to guard his person, who should set an example of
discipline, carry disobedience to such a point that they break into
the cellars and stores containing army supplies. Others have disgraced
themselves to the extent of disobeying sentinels and officers, and
have abused and beaten them."

"The Grand Marshal of the palace," wrote the governor, "complains
bitterly that in spite of repeated orders, the soldiers continue to
commit nuisances in all the courtyards and even under the very windows
of the Emperor."

That army, like a herd of cattle run wild and trampling underfoot
the provender which might have saved it from starvation, disintegrated
and perished with each additional day it remained in Moscow. But it
did not go away.

It began to run away only when suddenly seized by a panic caused
by the capture of transport trains on the Smolensk road, and by the
battle of Tarutino. The news of that battle of Tarutino,
unexpectedly received by Napoleon at a review, evoked in him a
desire to punish the Russians (Thiers says), and he issued the order
for departure which the whole army was demanding.

Fleeing from Moscow the soldiers took with them everything they
had stolen. Napoleon, too, carried away his own personal tresor, but
on seeing the baggage trains that impeded the army, he was (Thiers
says) horror-struck. And yet with his experience of war he did not
order all the superfluous vehicles to be burned, as he had done with
those of a certain marshal when approaching Moscow. He gazed at the
caleches and carriages in which soldiers were riding and remarked that
it was a very good thing, as those vehicles could be used to carry
provisions, the sick, and the wounded.

The plight of the whole army resembled that of a wounded animal
which feels it is perishing and does not know what it is doing. To
study the skillful tactics and aims of Napoleon and his army from
the time it entered Moscow till it was destroyed is like studying
the dying leaps and shudders of a mortally wounded animal. Very
often a wounded animal, hearing a rustle, rushes straight at the
hunter's gun, runs forward and back again, and hastens its own end.
Napoleon, under pressure from his whole army, did the same thing.
The rustle of the battle of Tarutino frightened the beast, and it
rushed forward onto the hunter's gun, reached him, turned back, and
finally--like any wild beast--ran back along the most
disadvantageous and dangerous path, where the old scent was familiar.

During the whole of that period Napoleon, who seems to us to have
been the leader of all these movements--as the figurehead of a ship
may seem to a savage to guide the vessel--acted like a child who,
holding a couple of strings inside a carriage, thinks he is driving
it.





CHAPTER XI


Early in the morning of the sixth of October Pierre went out of
the shed, and on returning stopped by the door to play with a little
blue-gray dog, with a long body and short bandy legs, that jumped
about him. This little dog lived in their shed, sleeping beside
Karataev at night; it sometimes made excursions into the town but
always returned again. Probably it had never had an owner, and it
still belonged to nobody and had no name. The French called it Azor;
the soldier who told stories called it Femgalka; Karataev and others
called it Gray, or sometimes Flabby. Its lack of a master, a name,
or even of a breed or any definite color did not seem to trouble the
blue-gray dog in the least. Its furry tail stood up firm and round
as a plume, its bandy legs served it so well that it would often
gracefully lift a hind leg and run very easily and quickly on three
legs, as if disdaining to use all four. Everything pleased it. Now
it would roll on its back, yelping with delight, now bask in the sun
with a thoughtful air of importance, and now frolic about playing with
a chip of wood or a straw.

Pierre's attire by now consisted of a dirty torn shirt (the only
remnant of his former clothing), a pair of soldier's trousers which by
Karataev's advice he tied with string round the ankles for warmth, and
a peasant coat and cap. Physically he had changed much during this
time. He no longer seemed stout, though he still had the appearance of
solidity and strength hereditary in his family. A beard and mustache
covered the lower part of his face, and a tangle of hair, infested
with lice, curled round his head like a cap. The look of his eyes
was resolute, calm, and animatedly alert, as never before. The
former slackness which had shown itself even in his eyes was now
replaced by an energetic readiness for action and resistance. His feet
were bare.

Pierre first looked down the field across which vehicles and
horsemen were passing that morning, then into the distance across
the river, then at the dog who was pretending to be in earnest about
biting him, and then at his bare feet which he placed with pleasure in
various positions, moving his dirty thick big toes. Every time he
looked at his bare feet a smile of animated self-satisfaction
flitted across his face. The sight of them reminded him of all he
had experienced and learned during these weeks and this recollection
was pleasant to him.

For some days the weather had been calm and clear with slight frosts
in the mornings--what is called an "old wives' summer."

In the sunshine the air was warm, and that warmth was particularly
pleasant with the invigorating freshness of the morning frost still in
the air.

On everything--far and near--lay the magic crystal glitter seen only
at that time autumn. The Sparrow Hills were visible in the distance,
with the village, the church, and the large white house. The bare
trees, the sand, the bricks and roofs of the houses, the green
church spire, and the corners of the white house in the distance,
all stood out in the transparent air in most delicate outline and with
unnatural clearness. Near by could be seen the familiar ruins of a
half-burned mansion occupied by the French, with lilac bushes still
showing dark green beside the fence. And even that ruined and befouled
house--which in dull weather was repulsively ugly--seemed quietly
beautiful now, in the clear, motionless brilliance.

A French corporal, with coat unbuttoned in a homely way, a
skullcap on his head, and a short pipe in his mouth, came from
behind a corner of the shed and approached Pierre with a friendly
wink.

"What sunshine, Monsieur Kiril!" (Their name for Pierre.) "Eh?
Just like spring!"

And the corporal leaned against the door and offered Pierre his
pipe, though whenever he offered it Pierre always declined it.

"To be on the march in such weather..." he began.

Pierre inquired what was being said about leaving, and the
corporal told him that nearly all the troops were starting and there
ought to be an order about the prisoners that day. Sokolov, one of the
soldiers in the shed with Pierre, was dying, and Pierre told the
corporal that something should be done about him. The corporal replied
that Pierre need not worry about that as they had an ambulance and a
permanent hospital and arrangements would be made for the sick, and
that in general everything that could happen had been foreseen by
the authorities.

"Besides, Monsieur Kiril, you have only to say a word to the
captain, you know. He is a man who never forgets anything. Speak to
the captain when he makes his round, he will do anything for you."

(The captain of whom the corporal spoke often had long chats with
Pierre and showed him all sorts of favors.)

"'You see, St. Thomas,' he said to me the other day. 'Monsieur Kiril
is a man of education, who speaks French. He is a Russian seigneur who
has had misfortunes, but he is a man. He knows what's what.... If he
wants anything and asks me, he won't get a refusal. When one has
studied, you see, one likes education and well-bred people.' It is for
your sake I mention it, Monsieur Kiril. The other day if it had not
been for you that affair would have ended ill."

And after chatting a while longer, the corporal went away. (The
affair he had alluded to had happened a few days before--a fight
between the prisoners and the French soldiers, in which Pierre had
succeeded in pacifying his comrades.) Some of the prisoners who had
heard Pierre talking to the corporal immediately asked what the
Frenchman had said. While Pierre was repeating what he had been told
about the army leaving Moscow, a thin, sallow, tattered French soldier
came up to the door of the shed. Rapidly and timidly raising his
fingers to his forehead by way of greeting, he asked Pierre whether
the soldier Platoche to whom he had given a shirt to sew was in that
shed.

A week before the French had had boot leather and linen issued to
them, which they had given out to the prisoners to make up into
boots and shirts for them.

"Ready, ready, dear fellow!" said Karataev, coming out with a neatly
folded shirt.

Karataev, on account of the warm weather and for convenience at
work, was wearing only trousers and a tattered shirt as black as soot.
His hair was bound round, workman fashion, with a wisp of lime-tree
bast, and his round face seemed rounder and pleasanter than ever.

"A promise is own brother to performance! I said Friday and here
it is, ready," said Platon, smiling and unfolding the shirt he had
sewn.

The Frenchman glanced around uneasily and then, as if overcoming his
hesitation, rapidly threw off his uniform and put on the shirt. He had
a long, greasy, flowered silk waistcoat next to his sallow, thin
bare body, but no shirt. He was evidently afraid the prisoners looking
on would laugh at him, and thrust his head into the shirt hurriedly.
None of the prisoners said a word.

"See, it fits well!" Platon kept repeating, pulling the shirt
straight.

The Frenchman, having pushed his head and hands through, without
raising his eyes, looked down at the shirt and examined the seams.

"You see, dear man, this is not a sewing shop, and I had no proper
tools; and, as they say, one needs a tool even to kill a louse,"
said Platon with one of his round smiles, obviously pleased with his
work.

"It's good, quite good, thank you," said the Frenchman, in French,
"but there must be some linen left over.

"It will fit better still when it sets to your body," said Karataev,
still admiring his handiwork. "You'll be nice and comfortable...."

"Thanks, thanks, old fellow.... But the bits left over?" said the
Frenchman again and smiled. He took out an assignation ruble note
and gave it to Karataev. "But give me the pieces that are over."

Pierre saw that Platon did not want to understand what the Frenchman
was saying, and he looked on without interfering. Karataev thanked the
Frenchman for the money and went on admiring his own work. The
Frenchman insisted on having the pieces returned that were left over
and asked Pierre to translate what he said.

"What does he want the bits for?" said Karataev. "They'd make fine
leg bands for us. Well, never mind."

And Karataev, with a suddenly changed and saddened expression,
took a small bundle of scraps from inside his shirt and gave it to the
Frenchman without looking at him. "Oh dear!" muttered Karataev and
went away. The Frenchman looked at the linen, considered for a moment,
then looked inquiringly at Pierre and, as if Pierre's look had told
him something, suddenly blushed and shouted in a squeaky voice:

"Platoche! Eh, Platoche! Keep them yourself!" And handing back the
odd bits he turned and went out.

"There, look at that," said Karataev, swaying his head. "People said
they were not Christians, but they too have souls. It's what the old
folk used to say: 'A sweating hand's an open hand, a dry hand's
close.' He's naked, but yet he's given it back."

Karataev smiled thoughtfully and was silent awhile looking at the
pieces.

"But they'll make grand leg bands, dear friend," he said, and went
back into the shed.





CHAPTER XII


Four weeks had passed since Pierre had been taken prisoner and
though the French had offered to move him from the men's to the
officers' shed, he had stayed in the shed where he was first put.

In burned and devastated Moscow Pierre experienced almost the
extreme limits of privation a man can endure; but thanks to his
physical strength and health, of which he had till then been
unconscious, and thanks especially to the fact that the privations
came so gradually that it was impossible to say when they began, he
endured his position not only lightly but joyfully. And just at this
time he obtained the tranquillity and ease of mind he had formerly
striven in vain to reach. He had long sought in different ways that
tranquillity of mind, that inner harmony which had so impressed him in
the soldiers at the battle of Borodino. He had sought it in
philanthropy, in Freemasonry, in the dissipations of town life, in
wine, in heroic feats of self-sacrifice, and in romantic love for
Natasha; he had sought it by reasoning--and all these quests and
experiments had failed him. And now without thinking about it he had
found that peace and inner harmony only through the horror of death,
through privation, and through what he recognized in Karataev.

Those dreadful moments he had lived through at the executions had as
it were forever washed away from his imagination and memory the
agitating thoughts and feelings that had formerly seemed so important.
It did not now occur to him to think of Russia, or the war, or
politics, or Napoleon. It was plain to him that all these things
were no business of his, and that he was not called on to judge
concerning them and therefore could not do so. "Russia and summer
weather are not bound together," he thought, repeating words of
Karataev's which he found strangely consoling. His intention of
killing Napoleon and his calculations of the cabalistic number of
the beast of the Apocalypse now seemed to him meaningless and even
ridiculous. His anger with his wife and anxiety that his name should
not be smirched now seemed not merely trivial but even amusing. What
concern was it of his that somewhere or other that woman was leading
the life she preferred? What did it matter to anybody, and
especially to him, whether or not they found out that their prisoner's
name was Count Bezukhov?

He now often remembered his conversation with Prince Andrew and
quite agreed with him, though he understood Prince Andrew's thoughts
somewhat differently. Prince Andrew had thought and said that
happiness could only be negative, but had said it with a shade of
bitterness and irony as though he was really saying that all desire
for positive happiness is implanted in us merely to torment us and
never be satisfied. But Pierre believed it without any mental
reservation. The absence of suffering, the satisfaction of one's needs
and consequent freedom in the choice of one's occupation, that is,
of one's way of life, now seemed to Pierre to be indubitably man's
highest happiness. Here and now for the first time he fully
appreciated the enjoyment of eating when he wanted to eat, drinking
when he wanted to drink, sleeping when he wanted to sleep, of warmth
when he was cold, of talking to a fellow man when he wished to talk
and to hear a human voice. The satisfaction of one's needs--good food,
cleanliness, and freedom--now that he was deprived of all this, seemed
to Pierre to constitute perfect happiness; and the choice of
occupation, that is, of his way of life--now that that was so
restricted--seemed to him such an easy matter that he forgot that a
superfluity of the comforts of life destroys all joy in satisfying
one's needs, while great freedom in the choice of occupation--such
freedom as his wealth, his education, and his social position had
given him in his own life--is just what makes the choice of occupation
insolubly difficult and destroys the desire and possibility of
having an occupation.

All Pierre's daydreams now turned on the time when he would be free.
Yet subsequently, and for the rest of his life, he thought and spoke
with enthusiasm of that month of captivity, of those irrecoverable,
strong, joyful sensations, and chiefly of the complete peace of mind
and inner freedom which he experienced only during those weeks.

When on the first day he got up early, went out of the shed at dawn,
and saw the cupolas and crosses of the New Convent of the Virgin still
dark at first, the hoarfrost on the dusty grass, the Sparrow Hills,
and the wooded banks above the winding river vanishing in the purple
distance, when he felt the contact of the fresh air and heard the
noise of the crows flying from Moscow across the field, and when
afterwards light gleamed from the east and the sun's rim appeared
solemnly from behind a cloud, and the cupolas and crosses, the
hoarfrost, the distance and the river, all began to sparkle in the
glad light--Pierre felt a new joy and strength in life such as he
had never before known. And this not only stayed with him during the
whole of his imprisonment, but even grew in strength as the
hardships of his position increased.

That feeling of alertness and of readiness for anything was still
further strengthened in him by the high opinion his fellow prisoners
formed of him soon after his arrival at the shed. With his knowledge
of languages, the respect shown him by the French, his simplicity, his
readiness to give anything asked of him (he received the allowance
of three rubles a week made to officers); with his strength, which
he showed to the soldiers by pressing nails into the walls of the hut;
his gentleness to his companions, and his capacity for sitting still
and thinking without doing anything (which seemed to them
incomprehensible), he appeared to them a rather mysterious and
superior being. The very qualities that had been a hindrance, if not
actually harmful, to him in the world he had lived in--his strength,
his disdain for the comforts of life, his absent-mindedness and
simplicity--here among these people gave him almost the status of a
hero. And Pierre felt that their opinion placed responsibilities
upon him.




CHAPTER XIII


The French evacuation began on the night between the sixth and
seventh of October: kitchens and sheds were dismantled, carts
loaded, and troops and baggage trains started.

At seven in the morning a French convoy in marching trim, wearing
shakos and carrying muskets, knapsacks, and enormous sacks, stood in
front of the sheds, and animated French talk mingled with curses
sounded all along the lines.

In the shed everyone was ready, dressed, belted, shod, and only
awaited the order to start. The sick soldier, Sokolov, pale and thin
with dark shadows round his eyes, alone sat in his place barefoot
and not dressed. His eyes, prominent from the emaciation of his
face, gazed inquiringly at his comrades who were paying no attention
to him, and he moaned regularly and quietly. It was evidently not so
much his sufferings that caused him to moan (he had dysentery) as
his fear and grief at being left alone.

Pierre, girt with a rope round his waist and wearing shoes
Karataev had made for him from some leather a French soldier had
torn off a tea chest and brought to have his boots mended with, went
up to the sick man and squatted down beside him.

"You know, Sokolov, they are not all going away! They have a
hospital here. You may be better off than we others," said Pierre.

"O Lord! Oh, it will be the death of me! O Lord!" moaned the man
in a louder voice.

"I'll go and ask them again directly," said Pierre, rising and going
to the door of the shed.

Just as Pierre reached the door, the corporal who had offered him
a pipe the day before came up to it with two soldiers. The corporal
and soldiers were in marching kit with knapsacks and shakos that had
metal straps, and these changed their familiar faces.

The corporal came, according to orders, to shut the door. The
prisoners had to be counted before being let out.

"Corporal, what will they do with the sick man?..." Pierre began.

But even as he spoke he began to doubt whether this was the corporal
he knew or a stranger, so unlike himself did the corporal seem at that
moment. Moreover, just as Pierre was speaking a sharp rattle of
drums was suddenly heard from both sides. The corporal frowned at
Pierre's words and, uttering some meaningless oaths, slammed the door.
The shed became semidark, and the sharp rattle of the drums on two
sides drowned the sick man's groans.

"There it is!... It again!..." said Pierre to himself, and an
involuntary shudder ran down his spine. In the corporal's changed
face, in the sound of his voice, in the stirring and deafening noise
of the drums, he recognized that mysterious, callous force which
compelled people against their will to kill their fellow men--that
force the effect of which he had witnessed during the executions. To
fear or to try to escape that force, to address entreaties or
exhortations to those who served as its tools, was useless. Pierre
knew this now. One had to wait and endure. He did not again go to
the sick man, nor turn to look at him, but stood frowning by the
door of the hut.

When that door was opened and the prisoners, crowding against one
another like a flock of sheep, squeezed into the exit, Pierre pushed
his way forward and approached that very captain who as the corporal
had assured him was ready to do anything for him. The captain was also
in marching kit, and on his cold face appeared that same it which
Pierre had recognized in the corporal's words and in the roll of the
drums.

"Pass on, pass on!" the captain reiterated, frowning sternly, and
looking at the prisoners who thronged past him.

Pierre went up to him, though he knew his attempt would be vain.

"What now?" the officer asked with a cold look as if not recognizing
Pierre.

Pierre told him about the sick man.

"He'll manage to walk, devil take him!" said the captain. "Pass
on, pass on!" he continued without looking at Pierre.

"But he is dying," Pierre again began.

"Be so good..." shouted the captain, frowning angrily.

"Dram-da-da-dam, dam-dam..." rattled the drums, and Pierre
understood that this mysterious force completely controlled these
men and that it was now useless to say any more.

The officer prisoners were separated from the soldiers and told to
march in front. There were about thirty officers, with Pierre among
them, and about three hundred men.

The officers, who had come from the other sheds, were all
strangers to Pierre and much better dressed than he. They looked at
him and at his shoes mistrustfully, as at an alien. Not far from him
walked a fat major with a sallow, bloated, angry face, who was wearing
a Kazan dressing grown tied round with a towel, and who evidently
enjoyed the respect of his fellow prisoners. He kept one hand, in
which he clasped his tobacco pouch, inside the bosom of his dressing
gown and held the stem of his pipe firmly with the other. Panting
and puffing, the major grumbled and growled at everybody because he
thought he was being pushed and that they were all hurrying when
they had nowhere to hurry to and were all surprised at something
when there was nothing to be surprised at. Another, a thin little
officer, was speaking to everyone, conjecturing where they were now
being taken and how far they would get that day. An official in felt
boots and wearing a commissariat uniform ran round from side to side
and gazed at the ruins of Moscow, loudly announcing his observations
as to what had been burned down and what this or that part of the city
was that they could see. A third officer, who by his accent was a
Pole, disputed with the commissariat officer, arguing that he was
mistaken in his identification of the different wards of Moscow.

"What are you disputing about?" said the major angrily. "What does
it matter whether it is St. Nicholas or St. Blasius? You see it's
burned down, and there's an end of it.... What are you pushing for?
Isn't the road wide enough?" said he, turning to a man behind him
who was not pushing him at all.

"Oh, oh, oh! What have they done?" the prisoners on one side and
another were heard saying as they gazed on the charred ruins. "All
beyond the river, and Zubova, and in the Kremlin.... Just look!
There's not half of it left. Yes, I told you--the whole quarter beyond
the river, and so it is."

"Well, you know it's burned, so what's the use of talking?" said the
major.

As they passed near a church in the Khamovniki (one of the few
unburned quarters of Moscow) the whole mass of prisoners suddenly
started to one side and exclamations of horror and disgust were heard.

"Ah, the villains! What heathens! Yes; dead, dead, so he is... And
smeared with something!"

Pierre too drew near the church where the thing was that evoked
these exclamations, and dimly made out something leaning against the
palings surrounding the church. From the words of his comrades who saw
better than he did, he found that this was the body of a man, set
upright against the palings with its face smeared with soot.

"Go on! What the devil... Go on! Thirty thousand devils!..." the
convoy guards began cursing and the French soldiers, with fresh
virulence, drove away with their swords the crowd of prisoners who
were gazing at the dead man.





CHAPTER XIV


Through the cross streets of the Khamovniki quarter the prisoners
marched, followed only by their escort and the vehicles and wagons
belonging to that escort, but when they reached the supply stores they
came among a huge and closely packed train of artillery mingled with
private vehicles.

At the bridge they all halted, waiting for those in front to get
across. From the bridge they had a view of endless lines of moving
baggage trains before and behind them. To the right, where the
Kaluga road turns near Neskuchny, endless rows of troops and carts
stretched away into the distance. These were troops of Beauharnais'
corps which had started before any of the others. Behind, along the
riverside and across the Stone Bridge, were Ney's troops and
transport.

Davout's troops, in whose charge were the prisoners, were crossing
the Crimean bridge and some were already debouching into the Kaluga
road. But the baggage trains stretched out so that the last of
Beauharnais' train had not yet got out of Moscow and reached the
Kaluga road when the vanguard of Ney's army was already emerging
from the Great Ordynka Street.

When they had crossed the Crimean bridge the prisoners moved a few
steps forward, halted, and again moved on, and from all sides vehicles
and men crowded closer and closer together. They advanced the few
hundred paces that separated the bridge from the Kaluga road, taking
more than an hour to do so, and came out upon the square where the
streets of the Transmoskva ward and the Kaluga road converge, and
the prisoners jammed close together had to stand for some hours at
that crossway. From all sides, like the roar of the sea, were heard
the rattle of wheels, the tramp of feet, and incessant shouts of anger
and abuse. Pierre stood pressed against the wall of a charred house,
listening to that noise which mingled in his imagination with the roll
of the drums.

To get a better view, several officer prisoners climbed onto the
wall of the half-burned house against which Pierre was leaning.

"What crowds! Just look at the crowds!... They've loaded goods
even on the cannon! Look there, those are furs!" they exclaimed. "Just
see what the blackguards have looted.... There! See what that one
has behind in the cart.... Why, those are settings taken from some
icons, by heaven!... Oh, the rascals!... See how that fellow has
loaded himself up, he can hardly walk! Good lord, they've even grabbed
those chaises!... See that fellow there sitting on the trunks....
Heavens! They're fighting."

"That's right, hit him on the snout--on his snout! Like this, we
shan't get away before evening. Look, look there.... Why, that must be
Napoleon's own. See what horses! And the monograms with a crown!
It's like a portable house.... That fellow's dropped his sack and
doesn't see it. Fighting again... A woman with a baby, and not
bad-looking either! Yes, I dare say, that's the way they'll let you
pass... Just look, there's no end to it. Russian wenches, by heaven,
so they are! In carriages--see how comfortably they've settled
themselves!"

Again, as at the church in Khamovniki, a wave of general curiosity
bore all the prisoners forward onto the road, and Pierre, thanks to
his stature, saw over the heads of the others what so attracted
their curiosity. In three carriages involved among the munition carts,
closely squeezed together, sat women with rouged faces, dressed in
glaring colors, who were shouting something in shrill voices.

From the moment Pierre had recognized the appearance of the
mysterious force nothing had seemed to him strange or dreadful:
neither the corpse smeared with soot for fun nor these women
hurrying away nor the burned ruins of Moscow. All that he now
witnessed scarcely made an impression on him--as if his soul, making
ready for a hard struggle, refused to receive impressions that might
weaken it.

The women's vehicles drove by. Behind them came more carts,
soldiers, wagons, soldiers, gun carriages, carriages, soldiers,
ammunition carts, more soldiers, and now and then women.

Pierre did not see the people as individuals but saw their movement.

All these people and horses seemed driven forward by some
invisible power. During the hour Pierre watched them they all came
flowing from the different streets with one and the same desire to get
on quickly; they all jostled one another, began to grow angry and to
fight, white teeth gleamed, brows frowned, ever the same words of
abuse flew from side to side, and all the faces bore the same
swaggeringly resolute and coldly cruel expression that had struck
Pierre that morning on the corporal's face when the drums were
beating.

It was not till nearly evening that the officer commanding the
escort collected his men and with shouts and quarrels forced his way
in among the baggage trains, and the prisoners, hemmed in on all
sides, emerged onto the Kaluga road.

They marched very quickly, without resting, and halted only when the
sun began to set. The baggage carts drew up close together and the men
began to prepare for their night's rest. They all appeared angry and
dissatisfied. For a long time, oaths, angry shouts, and fighting could
be heard from all sides. A carriage that followed the escort ran
into one of the carts and knocked a hole in it with its pole.
Several soldiers ran toward the cart from different sides: some beat
the carriage horses on their heads, turning them aside, others
fought among themselves, and Pierre saw that one German was badly
wounded on the head by a sword.

It seemed that all these men, now that they had stopped amid
fields in the chill dusk of the autumn evening, experienced one and
the same feeling of unpleasant awakening from the hurry and
eagerness to push on that had seized them at the start. Once at a
standstill they all seemed to understand that they did not yet know
where they were going, and that much that was painful and difficult
awaited them on this journey.

During this halt the escort treated the prisoners even worse than
they had done at the start. It was here that the prisoners for the
first time received horseflesh for their meat ration.

From the officer down to the lowest soldier they showed what
seemed like personal spite against each of the prisoners, in
unexpected contrast to their former friendly relations.

This spite increased still more when, on calling over the roll of
prisoners, it was found that in the bustle of leaving Moscow one
Russian soldier, who had pretended to suffer from colic, had
escaped. Pierre saw a Frenchman beat a Russian soldier cruelly for
straying too far from the road, and heard his friend the captain
reprimand and threaten to court-martial a noncommissioned officer on
account of the escape of the Russian. To the noncommissioned officer's
excuse that the prisoner was ill and could not walk, the officer
replied that the order was to shoot those who lagged behind. Pierre
felt that that fatal force which had crushed him during the
executions, but which he had not felt during his imprisonment, now
again controlled his existence. It was terrible, but he felt that in
proportion to the efforts of that fatal force to crush him, there grew
and strengthened in his soul a power of life independent of it.

He ate his supper of buckwheat soup with horseflesh and chatted with
his comrades.

Neither Pierre nor any of the others spoke of what they had seen
in Moscow, or of the roughness of their treatment by the French, or of
the order to shoot them which had been announced to them. As if in
reaction against the worsening of their position they were all
particularly animated and gay. They spoke of personal reminiscences,
of amusing scenes they had witnessed during the campaign, and
avoided all talk of their present situation.

The sun had set long since. Bright stars shone out here and there in
the sky. A red glow as of a conflagration spread above the horizon
from the rising full moon, and that vast red ball swayed strangely
in the gray haze. It grew light. The evening was ending, but the night
had not yet come. Pierre got up and left his new companions,
crossing between the campfires to the other side of the road where
he had been told the common soldier prisoners were stationed. He
wanted to talk to them. On the road he was stopped by a French
sentinel who ordered him back.

Pierre turned back, not to his companions by the campfire, but to an
unharnessed cart where there was nobody. Tucking his legs under him
and dropping his head he sat down on the cold ground by the wheel of
the cart and remained motionless a long while sunk in thought.
Suddenly he burst out into a fit of his broad, good-natured
laughter, so loud that men from various sides turned with surprise
to see what this strange and evidently solitary laughter could mean.

"Ha-ha-ha!" laughed Pierre. And he said aloud to himself: "The
soldier did not let me pass. They took me and shut me up. They hold me
captive. What, me? Me? My immortal soul? Ha-ha-ha! Ha-ha-ha!..." and
he laughed till tears started to his eyes.

A man got up and came to see what this queer big fellow was laughing
at all by himself. Pierre stopped laughing, got up, went farther
away from the inquisitive man, and looked around him.

The huge, endless bivouac that had previously resounded with the
crackling of campfires and the voices of many men had grown quiet, the
red campfires were growing paler and dying down. High up in the
light sky hung the full moon. Forests and fields beyond the camp,
unseen before, were now visible in the distance. And farther still,
beyond those forests and fields, the bright, oscillating, limitless
distance lured one to itself. Pierre glanced up at the sky and the
twinkling stars in its faraway depths. "And all that is me, all that
is within me, and it is all I!" thought Pierre. "And they caught all
that and put it into a shed boarded up with planks!" He smiled, and
went and lay down to sleep beside his companions.





CHAPTER XV


In the early days of October another envoy came to Kutuzov with a
letter from Napoleon proposing peace and falsely dated from Moscow,
though Napoleon was already not far from Kutuzov on the old Kaluga
road. Kutuzov replied to this letter as he had done to the one
formerly brought by Lauriston, saying that there could be no
question of peace.

Soon after that a report was received from Dorokhov's guerrilla
detachment operating to the left of Tarutino that troops of
Broussier's division had been seen at Forminsk and that being
separated from the rest of the French army they might easily be
destroyed. The soldiers and officers again demanded action. Generals
on the staff, excited by the memory of the easy victory at Tarutino,
urged Kutuzov to carry out Dorokhov's suggestion. Kutuzov did not
consider any offensive necessary. The result was a compromise which
was inevitable: a small detachment was sent to Forminsk to attack
Broussier.

By a strange coincidence, this task, which turned out to be a most
difficult and important one, was entrusted to Dokhturov--that same
modest little Dokhturov whom no one had described to us as drawing
up plans of battles, dashing about in front of regiments, showering
crosses on batteries, and so on, and who was thought to be and was
spoken of as undecided and undiscerning--but whom we find commanding
wherever the position was most difficult all through the
Russo-French wars from Austerlitz to the year 1813. At Austerlitz he
remained last at the Augezd dam, rallying the regiments, saving what
was possible when all were flying and perishing and not a single
general was left in the rear guard. Ill with fever he went to Smolensk
with twenty thousand men to defend the town against Napoleon's whole
army. In Smolensk, at the Malakhov Gate, he had hardly dozed off in
a paroxysm of fever before he was awakened by the bombardment of the
town--and Smolensk held out all day long. At the battle of Borodino,
when Bagration was killed and nine tenths of the men of our left flank
had fallen and the full force of the French artillery fire was
directed against it, the man sent there was this same irresolute and
undiscerning Dokhturov--Kutuzov hastening to rectify a mistake he
had made by sending someone else there first. And the quiet little
Dokhturov rode thither, and Borodino became the greatest glory of
the Russian army. Many heroes have been described to us in verse and
prose, but of Dokhturov scarcely a word has been said.

It was Dokhturov again whom they sent to Forminsk and from there
to Malo-Yaroslavets, the place where the last battle with the French
was fought and where the obvious disintegration of the French army
began; and we are told of many geniuses and heroes of that period of
the campaign, but of Dokhturov nothing or very little is said and that
dubiously. And this silence about Dokhturov is the clearest
testimony to his merit.

It is natural for a man who does not understand the workings of a
machine to imagine that a shaving that has fallen into it by chance
and is interfering with its action and tossing about in it is its most
important part. The man who does not understand the construction of
the machine cannot conceive that the small connecting cogwheel which
revolves quietly is one of the most essential parts of the machine,
and not the shaving which merely harms and hinders the working.

On the tenth of October when Dokhturov had gone halfway to
Forminsk and stopped at the village of Aristovo, preparing
faithfully to execute the orders he had received, the whole French
army having, in its convulsive movement, reached Murat's position
apparently in order to give battle--suddenly without any reason turned
off to the left onto the new Kaluga road and began to enter
Forminsk, where only Broussier had been till then. At that time
Dokhturov had under his command, besides Dorokhov's detachment, the
two small guerrilla detachments of Figner and Seslavin.

On the evening of October 11 Seslavin came to the Aristovo
headquarters with a French guardsman he had captured. The prisoner
said that the troops that had entered Forminsk that day were the
vanguard of the whole army, that Napoleon was there and the whole army
had left Moscow four days previously. That same evening a house serf
who had come from Borovsk said he had seen an immense army entering
the town. Some Cossacks of Dokhturov's detachment reported having
sighted the French Guards marching along the road to Borovsk. From all
these reports it was evident that where they had expected to meet a
single division there was now the whole French army marching from
Moscow in an unexpected direction--along the Kaluga road. Dokhturov
was unwilling to undertake any action, as it was not clear to him
now what he ought to do. He had been ordered to attack Forminsk. But
only Broussier had been there at that time and now the whole French
army was there. Ermolov wished to act on his own judgment, but
Dokhturov insisted that he must have Kutuzov's instructions. So it was
decided to send a dispatch to the staff.

For this purpose a capable officer, Bolkhovitinov, was chosen, who
was to explain the whole affair by word of mouth, besides delivering a
written report. Toward midnight Bolkhovitinov, having received the
dispatch and verbal instructions, galloped off to the General Staff
accompanied by a Cossack with spare horses.





CHAPTER XVI


It was a warm, dark, autumn night. It had been raining for four
days. Having changed horses twice and galloped twenty miles in an hour
and a half over a sticky, muddy road, Bolkhovitinov reached Litashevka
after one o'clock at night. Dismounting at a cottage on whose wattle
fence hung a signboard, GENERAL STAFF, and throwing down his reins, he
entered a dark passage.

"The general on duty, quick! It's very important!" said he to
someone who had risen and was sniffing in the dark passage.

"He has been very unwell since the evening and this is the third
night he has not slept," said the orderly pleadingly in a whisper.
"You should wake the captain first."

"But this is very important, from General Dokhturov," said
Bolkhovitinov, entering the open door which he had found by feeling in
the dark.

The orderly had gone in before him and began waking somebody.

"Your honor, your honor! A courier."

"What? What's that? From whom?" came a sleepy voice.

"From Dokhturov and from Alexey Petrovich. Napoleon is at Forminsk,"
said Bolkhovitinov, unable to see in the dark who was speaking but
guessing by the voice that it was not Konovnitsyn.

The man who had wakened yawned and stretched himself.

"I don't like waking him," he said, fumbling for something. "He is
very ill. Perhaps this is only a rumor."

"Here is the dispatch," said Bolkhovitinov. "My orders are to give
it at once to the general on duty."

"Wait a moment, I'll light a candle. You damned rascal, where do you
always hide it?" said the voice of the man who was stretching himself,
to the orderly. (This was Shcherbinin, Konovnitsyn's adjutant.)
"I've found it, I've found it!" he added.

The orderly was striking a light and Shcherbinin was fumbling for
something on the candlestick.

"Oh, the nasty beasts!" said he with disgust.

By the light of the sparks Bolkhovitinov saw Shcherbinin's
youthful face as he held the candle, and the face of another man who
was still asleep. This was Konovnitsyn.

When the flame of the sulphur splinters kindled by the tinder burned
up, first blue and then red, Shcherbinin lit the tallow candle, from
the candlestick of which the cockroaches that had been gnawing it were
running away, and looked at the messenger. Bolkhovitinov was
bespattered all over with mud and had smeared his face by wiping it
with his sleeve.

"Who gave the report?" inquired Shcherbinin, taking the envelope.

"The news is reliable," said Bolkhovitinov. "Prisoners, Cossacks,
and the scouts all say the same thing."

"There's nothing to be done, we'll have to wake him," said
Shcherbinin, rising and going up to the man in the nightcap who lay
covered by a greatcoat. "Peter Petrovich!" said he. (Konovnitsyn did
not stir.) "To the General Staff!" he said with a smile, knowing
that those words would be sure to arouse him.

And in fact the head in the nightcap was lifted at once. On
Konovnitsyn's handsome, resolute face with cheeks flushed by fever,
there still remained for an instant a faraway dreamy expression remote
from present affairs, but then he suddenly started and his face
assumed its habitual calm and firm appearance.

"Well, what is it? From whom?" he asked immediately but without
hurry, blinking at the light.

While listening to the officer's report Konovnitsyn broke the seal
and read the dispatch. Hardly had he done so before he lowered his
legs in their woolen stockings to the earthen floor and began
putting on his boots. Then he took off his nightcap, combed his hair
over his temples, and donned his cap.

"Did you get here quickly? Let us go to his Highness."

Konovnitsyn had understood at once that the news brought was of
great importance and that no time must be lost. He did not consider or
ask himself whether the news was good or bad. That did not interest
him. He regarded the whole business of the war not with his
intelligence or his reason but by something else. There was within him
a deep unexpressed conviction that all would be well, but that one
must not trust to this and still less speak about it, but must only
attend to one's own work. And he did his work, giving his whole
strength to the task.

Peter Petrovich Konovnitsyn, like Dokhturov, seems to have been
included merely for propriety's sake in the list of the so-called
heroes of 1812--the Barclays, Raevskis, Ermolovs, Platovs, and
Miloradoviches. Like Dokhturov he had the reputation of being a man of
very limited capacity and information, and like Dokhturov he never
made plans of battle but was always found where the situation was most
difficult. Since his appointment as general on duty he had always
slept with his door open, giving orders that every messenger should be
allowed to wake him up. In battle he was always under fire, so that
Kutuzov reproved him for it and feared to send him to the front, and
like Dokhturov he was one of those unnoticed cogwheels that, without
clatter or noise, constitute the most essential part of the machine.

Coming out of the hut into the damp, dark night Konovnitsyn frowned-
partly from an increased pain in his head and partly at the unpleasant
thought that occurred to him, of how all that nest of influential
men on the staff would be stirred up by this news, especially
Bennigsen, who ever since Tarutino had been at daggers drawn with
Kutuzov; and how they would make suggestions, quarrel, issue orders,
and rescind them. And this premonition was disagreeable to him
though he knew it could not be helped.

And in fact Toll, to whom he went to communicate the news,
immediately began to expound his plans to a general sharing his
quarters, until Konovnitsyn, who listened in weary silence, reminded
him that they must go to see his Highness.





CHAPTER XVII


Kutuzov like all old people did not sleep much at night. He often
fell asleep unexpectedly in the daytime, but at night, lying on his
bed without undressing, he generally remained awake thinking.

So he lay now on his bed, supporting his large, heavy, scarred
head on his plump hand, with his one eye open, meditating and
peering into the darkness.

Since Bennigsen, who corresponded with the Emperor and had more
influence than anyone else on the staff, had begun to avoid him,
Kutuzov was more at ease as to the possibility of himself and his
troops being obliged to take part in useless aggressive movements. The
lesson of the Tarutino battle and of the day before it, which
Kutuzov remembered with pain, must, he thought, have some effect on
others too.

"They must understand that we can only lose by taking the offensive.
Patience and time are my warriors, my champions," thought Kutuzov.
He knew that an apple should not be plucked while it is green. It will
fall of itself when ripe, but if picked unripe the apple is spoiled,
the tree is harmed, and your teeth are set on edge. Like an
experienced sportsman he knew that the beast was wounded, and
wounded as only the whole strength of Russia could have wounded it,
but whether it was mortally wounded or not was still an undecided
question. Now by the fact of Lauriston and Barthelemi having been
sent, and by the reports of the guerrillas, Kutuzov was almost sure
that the wound was mortal. But he needed further proofs and it was
necessary to wait.

"They want to run to see how they have wounded it. Wait and we shall
see! Continual maneuvers, continual advances!" thought he. "What
for? Only to distinguish themselves! As if fighting were fun. They are
like children from whom one can't get any sensible account of what has
happened because they all want to show how well they can fight. But
that's not what is needed now.

"And what ingenious maneuvers they all propose to me! It seems to
them that when they have thought of two or three contingencies" (he
remembered the general plan sent him from Petersburg) "they have
foreseen everything. But the contingencies are endless."

The undecided question as to whether the wound inflicted at Borodino
was mortal or not had hung over Kutuzov's head for a whole month. On
the one hand the French had occupied Moscow. On the other Kutuzov felt
assured with all his being that the terrible blow into which he and
all the Russians had put their whole strength must have been mortal.
But in any case proofs were needed; he had waited a whole month for
them and grew more impatient the longer he waited. Lying on his bed
during those sleepless nights he did just what he reproached those
younger generals for doing. He imagined all sorts of possible
contingencies, just like the younger men, but with this difference,
that he saw thousands of contingencies instead of two or three and
based nothing on them. The longer he thought the more contingencies
presented themselves. He imagined all sorts of movements of the
Napoleonic army as a whole or in sections--against Petersburg, or
against him, or to outflank him. He thought too of the possibility
(which he feared most of all) that Napoleon might fight him with his
own weapon and remain in Moscow awaiting him. Kutuzov even imagined
that Napoleon's army might turn back through Medyn and Yukhnov, but
the one thing he could not foresee was what happened--the insane,
convulsive stampede of Napoleon's army during its first eleven days
after leaving Moscow: a stampede which made possible what Kutuzov
had not yet even dared to think of--the complete extermination of
the French. Dorokhov's report about Broussier's division, the
guerrillas' reports of distress in Napoleon's army, rumors of
preparations for leaving Moscow, all confirmed the supposition that
the French army was beaten and preparing for flight. But these were
only suppositions, which seemed important to the younger men but not
to Kutuzov. With his sixty years' experience he knew what value to
attach to rumors, knew how apt people who desire anything are to group
all news so that it appears to confirm what they desire, and he knew
how readily in such cases they omit all that makes for the contrary.
And the more he desired it the less he allowed himself to believe
it. This question absorbed all his mental powers. All else was to
him only life's customary routine. To such customary routine
belonged his conversations with the staff, the letters he wrote from
Tarutino to Madame de Stael, the reading of novels, the distribution
of awards, his correspondence with Petersburg, and so on. But the
destruction of the French, which he alone foresaw, was his heart's one
desire.

On the night of the eleventh of October he lay leaning on his arm
and thinking of that.

There was a stir in the next room and he heard the steps of Toll,
Konovnitsyn, and Bolkhovitinov.

"Eh, who's there? Come in, come in! What news?" the field marshal
called out to them.

While a footman was lighting a candle, Toll communicated the
substance of the news.

"Who brought it?" asked Kutuzov with a look which, when the candle
was lit, struck Toll by its cold severity.

"There can be no doubt about it, your Highness."

"Call him in, call him here."

Kutuzov sat up with one leg hanging down from the bed and his big
paunch resting against the other which was doubled under him. He
screwed up his seeing eye to scrutinize the messenger more
carefully, as if wishing to read in his face what preoccupied his
own mind.

"Tell me, tell me, friend," said he to Bolkhovitinov in his low,
aged voice, as he pulled together the shirt which gaped open on his
chest, "come nearer--nearer. What news have you brought me? Eh? That
Napoleon has left Moscow? Are you sure? Eh?"

Bolkhovitinov gave a detailed account from the beginning of all he
had been told to report.

"Speak quicker, quicker! Don't torture me!" Kutuzov interrupted him.

Bolkhovitinov told him everything and was then silent, awaiting
instructions. Toll was beginning to say something but Kutuzov
checked him. He tried to say something, but his face suddenly puckered
and wrinkled; he waved his arm at Toll and turned to the opposite side
of the room, to the corner darkened by the icons that hung there.

"O Lord, my Creator, Thou has heard our prayer..." said he in a
tremulous voice with folded hands. "Russia is saved. I thank Thee, O
Lord!" and he wept.





CHAPTER XVIII


From the time he received this news to the end of the campaign all
Kutuzov's activity was directed toward restraining his troops, by
authority, by guile, and by entreaty, from useless attacks, maneuvers,
or encounters with the perishing enemy. Dokhturov went to
Malo-Yaroslavets, but Kutuzov lingered with the main army and gave
orders for the evacuation of Kaluga--a retreat beyond which town
seemed to him quite possible.

Everywhere Kutuzov retreated, but the enemy without waiting for
his retreat fled in the opposite direction.

Napoleon's historians describe to us his skilled maneuvers at
Tarutino and Malo-Yaroslavets, and make conjectures as to what would
have happened had Napoleon been in time to penetrate into the rich
southern provinces.

But not to speak of the fact that nothing prevented him from
advancing into those southern provinces (for the Russian army did
not bar his way), the historians forget that nothing could have
saved his army, for then already it bore within itself the germs of
inevitable ruin. How could that army--which had found abundant
supplies in Moscow and had trampled them underfoot instead of
keeping them, and on arriving at Smolensk had looted provisions
instead of storing them--how could that army recuperate in Kaluga
province, which was inhabited by Russians such as those who lived in
Moscow, and where fire had the same property of consuming what was set
ablaze?

That army could not recover anywhere. Since the battle of Borodino
and the pillage of Moscow it had borne within itself, as it were,
the chemical elements of dissolution.

The members of what had once been an army--Napoleon himself and
all his soldiers fled--without knowing whither, each concerned only to
make his escape as quickly as possible from this position, of the
hopelessness of which they were all more or less vaguely conscious.

So it came about that at the council at Malo-Yaroslavets, when the
generals pretending to confer together expressed various opinions, all
mouths were closed by the opinion uttered by the simple-minded soldier
Mouton who, speaking last, said what they all felt: that the one thing
needful was to get away as quickly as possible; and no one, not even
Napoleon, could say anything against that truth which they all
recognized.

But though they all realized that it was necessary to get away,
there still remained a feeling of shame at admitting that they must
flee. An external shock was needed to overcome that shame, and this
shock came in due time. It was what the French called "le hourra de
l'Empereur."

The day after the council at Malo-Yaroslavets Napoleon rode out
early in the morning amid the lines of his army with his suite of
marshals and an escort, on the pretext of inspecting the army and
the scene of the previous and of the impending battle. Some Cossacks
on the prowl for booty fell in with the Emperor and very nearly
captured him. If the Cossacks did not capture Napoleon then, what
saved him was the very thing that was destroying the French army,
the booty on which the Cossacks fell. Here as at Tarutino they went
after plunder, leaving the men. Disregarding Napoleon they rushed
after the plunder and Napoleon managed to escape.

When les enfants du Don might so easily have taken the Emperor
himself in the midst of his army, it was clear that there was
nothing for it but to fly as fast as possible along the nearest,
familiar road. Napoleon with his forty-year-old stomach understood
that hint, not feeling his former agility and boldness, and under
the influence of the fright the Cossacks had given him he at once
agreed with Mouton and issued orders--as the historians tell us--to
retreat by the Smolensk road.

That Napoleon agreed with Mouton, and that the army retreated,
does not prove that Napoleon caused it to retreat, but that the forces
which influenced the whole army and directed it along the Mozhaysk
(that is, the Smolensk) road acted simultaneously on him also.





CHAPTER XIX


A man in motion always devises an aim for that motion. To be able to
go a thousand miles he must imagine that something good awaits him
at the end of those thousand miles. One must have the prospect of a
promised land to have the strength to move.

The promised land for the French during their advance had been
Moscow, during their retreat it was their native land. But that native
land was too far off, and for a man going a thousand miles it is
absolutely necessary to set aside his final goal and to say to
himself: "Today I shall get to a place twenty-five miles off where I
shall rest and spend the night," and during the first day's journey
that resting place eclipses his ultimate goal and attracts all his
hopes and desires. And the impulses felt by a single person are always
magnified in a crowd.

For the French retreating along the old Smolensk road, the final
goal--their native land--was too remote, and their immediate goal
was Smolensk, toward which all their desires and hopes, enormously
intensified in the mass, urged them on. It was not that they knew that
much food and fresh troops awaited them in Smolensk, nor that they
were told so (on the contrary their superior officers, and Napoleon
himself, knew that provisions were scarce there), but because this
alone could give them strength to move on and endure their present
privations. So both those who knew and those who did not know deceived
themselves, and pushed on to Smolensk as to a promised land.

Coming out onto the highroad the French fled with surprising
energy and unheard-of rapidity toward the goal they had fixed on.
Besides the common impulse which bound the whole crowd of French
into one mass and supplied them with a certain energy, there was
another cause binding them together--their great numbers. As with
the physical law of gravity, their enormous mass drew the individual
human atoms to itself. In their hundreds of thousands they moved
like a whole nation.

Each of them desired nothing more than to give himself up as a
prisoner to escape from all this horror and misery; but on the one
hand the force of this common attraction to Smolensk, their goal, drew
each of them in the same direction; on the other hand an army corps
could not surrender to a company, and though the French availed
themselves of every convenient opportunity to detach themselves and to
surrender on the slightest decent pretext, such pretexts did not
always occur. Their very numbers and their crowded and swift
movement deprived them of that possibility and rendered it not only
difficult but impossible for the Russians to stop this movement, to
which the French were directing all their energies. Beyond a certain
limit no mechanical disruption of the body could hasten the process of
decomposition.

A lump of snow cannot be melted instantaneously. There is a
certain limit of time in less than which no amount of heat can melt
the snow. On the contrary the greater the heat the more solidified the
remaining snow becomes.

Of the Russian commanders Kutuzov alone understood this. When the
flight of the French army along the Smolensk road became well defined,
what Konovnitsyn had foreseen on the night of the eleventh of
October began to occur. The superior officers all wanted to
distinguish themselves, to cut off, to seize, to capture, and to
overthrow the French, and all clamored for action.

Kutuzov alone used all his power (and such power is very limited
in the case of any commander in chief) to prevent an attack.

He could not tell them what we say now: "Why fight, why block the
road, losing our own men and inhumanly slaughtering unfortunate
wretches? What is the use of that, when a third of their army has
melted away on the road from Moscow to Vyazma without any battle?" But
drawing from his aged wisdom what they could understand, he told
them of the golden bridge, and they laughed at and slandered him,
flinging themselves on, rending and exulting over the dying beast.

Ermolov, Miloradovich, Platov, and others in proximity to the French
near Vyazma could not resist their desire to cut off and break up
two French corps, and by way of reporting their intention to Kutuzov
they sent him a blank sheet of paper in an envelope.

And try as Kutuzov might to restrain the troops, our men attacked,
trying to bar the road. Infantry regiments, we are told, advanced to
the attack with music and with drums beating, and killed and lost
thousands of men.

But they did not cut off or overthrow anybody and the French army,
closing up more firmly at the danger, continued, while steadily
melting away, to pursue its fatal path to Smolensk.






BOOK FOURTEEN: 1812





CHAPTER I


The Battle of Borodino, with the occupation of Moscow that
followed it and the flight of the French without further conflicts, is
one of the most instructive phenomena in history.

All historians agree that the external activity of states and
nations in their conflicts with one another is expressed in wars,
and that as a direct result of greater or less success in war the
political strength of states and nations increases or decreases.

Strange as may be the historical account of how some king or
emperor, having quarreled with another, collects an army, fights his
enemy's army, gains a victory by killing three, five, or ten
thousand men, and subjugates a kingdom and an entire nation of several
millions, all the facts of history (as far as we know it) confirm
the truth of the statement that the greater or lesser success of one
army against another is the cause, or at least an essential
indication, of an increase or decrease in the strength of the
nation--even though it is unintelligible why the defeat of an army-
a hundredth part of a nation--should oblige that whole nation to
submit. An army gains a victory, and at once the rights of the
conquering nation have increased to the detriment of the defeated.
An army has suffered defeat, and at once a people loses its rights
in proportion to the severity of the reverse, and if its army
suffers a complete defeat the nation is quite subjugated.

So according to history it has been found from the most ancient
times, and so it is to our own day. All Napoleon's wars serve to
confirm this rule. In proportion to the defeat of the Austrian army
Austria loses its rights, and the rights and the strength of France
increase. The victories of the French at Jena and Auerstadt destroy
the independent existence of Prussia.

But then, in 1812, the French gain a victory near Moscow. Moscow
is taken and after that, with no further battles, it is not Russia
that ceases to exist, but the French army of six hundred thousand, and
then Napoleonic France itself. To strain the facts to fit the rules of
history: to say that the field of battle at Borodino remained in the
hands of the Russians, or that after Moscow there were other battles
that destroyed Napoleon's army, is impossible.

After the French victory at Borodino there was no general engagement
nor any that were at all serious, yet the French army ceased to exist.
What does this mean? If it were an example taken from the history of
China, we might say that it was not an historic phenomenon (which is
the historians' usual expedient when anything does not fit their
standards); if the matter concerned some brief conflict in which
only a small number of troops took part, we might treat it as an
exception; but this event occurred before our fathers' eyes, and for
them it was a question of the life or death of their fatherland, and
it happened in the greatest of all known wars.

The period of the campaign of 1812 from the battle of Borodino to
the expulsion of the French proved that the winning of a battle does
not produce a conquest and is not even an invariable indication of
conquest; it proved that the force which decides the fate of peoples
lies not in the conquerors, nor even in armies and battles, but in
something else.

The French historians, describing the condition of the French army
before it left Moscow, affirm that all was in order in the Grand Army,
except the cavalry, the artillery, and the transport--there was no
forage for the horses or the cattle. That was a misfortune no one
could remedy, for the peasants of the district burned their hay rather
than let the French have it.

The victory gained did not bring the usual results because the
peasants Karp and Vlas (who after the French had evacuated Moscow
drove in their carts to pillage the town, and in general personally
failed to manifest any heroic feelings), and the whole innumerable
multitude of such peasants, did not bring their hay to Moscow for
the high price offered them, but burned it instead.

Let us imagine two men who have come out to fight a duel with
rapiers according to all the rules of the art of fencing. The
fencing has gone on for some time; suddenly one of the combatants,
feeling himself wounded and understanding that the matter is no joke
but concerns his life, throws down his rapier, and seizing the first
cudgel that comes to hand begins to brandish it. Then let us imagine
that the combatant who so sensibly employed the best and simplest
means to attain his end was at the same time influenced by
traditions of chivalry and, desiring to conceal the facts of the case,
insisted that he had gained his victory with the rapier according to
all the rules of art. One can imagine what confusion and obscurity
would result from such an account of the duel.

The fencer who demanded a contest according to the rules of
fencing was the French army; his opponent who threw away the rapier
and snatched up the cudgel was the Russian people; those who try to
explain the matter according to the rules of fencing are the
historians who have described the event.

After the burning of Smolensk a war began which did not follow any
previous traditions of war. The burning of towns and villages, the
retreats after battles, the blow dealt at Borodino and the renewed
retreat, the burning of Moscow, the capture of marauders, the
seizure of transports, and the guerrilla war were all departures
from the rules.

Napoleon felt this, and from the time he took up the correct fencing
attitude in Moscow and instead of his opponent's rapier saw a cudgel
raised above his head, he did not cease to complain to Kutuzov and
to the Emperor Alexander that the war was being carried on contrary to
all the rules--as if there were any rules for killing people. In spite
of the complaints of the French as to the nonobservance of the
rules, in spite of the fact that to some highly placed Russians it
seemed rather disgraceful to fight with a cudgel and they wanted to
assume a pose en quarte or en tierce according to all the rules, and
to make an adroit thrust en prime, and so on--the cudgel of the
people's war was lifted with all its menacing and majestic strength,
and without consulting anyone's tastes or rules and regardless of
anything else, it rose and fell with stupid simplicity, but
consistently, and belabored the French till the whole invasion had
perished.

And it is well for a people who do not--as the French did in 1813-
salute according to all the rules of art, and, presenting the hilt
of their rapier gracefully and politely, hand it to their
magnanimous conqueror, but at the moment of trial, without asking what
rules others have adopted in similar cases, simply and easily pick
up the first cudgel that comes to hand and strike with it till the
feeling of resentment and revenge in their soul yields to a feeling of
contempt and compassion.





CHAPTER II


One of the most obvious and advantageous departures from the
so-called laws of war is the action of scattered groups against men
pressed together in a mass. Such action always occurs in wars that
take on a national character. In such actions, instead of two crowds
opposing each other, the men disperse, attack singly, run away when
attacked by stronger forces, but again attack when opportunity offers.
This was done by the guerrillas in Spain, by the mountain tribes in
the Caucasus, and by the Russians in 1812.

People have called this kind of war "guerrilla warfare" and assume
that by so calling it they have explained its meaning. But such a
war does not fit in under any rule and is directly opposed to a
well-known rule of tactics which is accepted as infallible. That
rule says that an attacker should concentrate his forces in order to
be stronger than his opponent at the moment of conflict.

Guerrilla war (always successful, as history shows) directly
infringes that rule.

This contradiction arises from the fact that military science
assumes the strength of an army to be identical with its numbers.
Military science says that the more troops the greater the strength.
Les gros bataillons ont toujours raison.*


*Large battalions are always victorious.


For military science to say this is like defining momentum in
mechanics by reference to the mass only: stating that momenta are
equal or unequal to each other simply because the masses involved
are equal or unequal.

Momentum (quantity of motion) is the product of mass and velocity.

In military affairs the strength of an army is the product of its
mass and some unknown x.

Military science, seeing in history innumerable instances of the
fact that the size of any army does not coincide with its strength and
that small detachments defeat larger ones, obscurely admits the
existence of this unknown factor and tries to discover it--now in a
geometric formation, now in the equipment employed, now, and most
usually, in the genius of the commanders. But the assignment of
these various meanings to the factor does not yield results which
accord with the historic facts.

Yet it is only necessary to abandon the false view (adopted to
gratify the "heroes") of the efficacy of the directions issued in
wartime by commanders, in order to find this unknown quantity.

That unknown quantity is the spirit of the army, that is to say, the
greater or lesser readiness to fight and face danger felt by all the
men composing an army, quite independently of whether they are, or are
not, fighting under the command of a genius, in two--or three-line
formation, with cudgels or with rifles that repeat thirty times a
minute. Men who want to fight will always put themselves in the most
advantageous conditions for fighting.

The spirit of an army is the factor which multiplied by the mass
gives the resulting force. To define and express the significance of
this unknown factor--the spirit of an army--is a problem for science.

This problem is only solvable if we cease arbitrarily to
substitute for the unknown x itself the conditions under which that
force becomes apparent--such as the commands of the general, the
equipment employed, and so on--mistaking these for the real
significance of the factor, and if we recognize this unknown
quantity in its entirety as being the greater or lesser desire to
fight and to face danger. Only then, expressing known historic facts
by equations and comparing the relative significance of this factor,
can we hope to define the unknown.

Ten men, battalions, or divisions, fighting fifteen men, battalions,
or divisions, conquer--that is, kill or take captive--all the
others, while themselves losing four, so that on the one side four and
on the other fifteen were lost. Consequently the four were equal to
the fifteen, and therefore 4x = 15y. Consequently x/y = 15/4. This
equation does not give us the value of the unknown factor but gives us
a ratio between two unknowns. And by bringing variously selected
historic units (battles, campaigns, periods of war) into such
equations, a series of numbers could be obtained in which certain laws
should exist and might be discovered.

The tactical rule that an army should act in masses when
attacking, and in smaller groups in retreat, unconsciously confirms
the truth that the strength of an army depends on its spirit. To
lead men forward under fire more discipline (obtainable only by
movement in masses) is needed than is needed to resist attacks. But
this rule which leaves out of account the spirit of the army
continually proves incorrect and is in particularly striking
contrast to the facts when some strong rise or fall in the spirit of
the troops occurs, as in all national wars.

The French, retreating in 1812--though according to tactics they
should have separated into detachments to defend themselves-
congregated into a mass because the spirit of the army had so fallen
that only the mass held the army together. The Russians, on the
contrary, ought according to tactics to have attacked in mass, but
in fact they split up into small units, because their spirit had so
risen that separate individuals, without orders, dealt blows at the
French without needing any compulsion to induce them to expose
themselves to hardships and dangers.





CHAPTER III


The so-called partisan war began with the entry of the French into
Smolensk.

Before partisan warfare had been officially recognized by the
government, thousands of enemy stragglers, marauders, and foragers had
been destroyed by the Cossacks and the peasants, who killed them off
as instinctively as dogs worry a stray mad dog to death. Denis
Davydov, with his Russian instinct, was the first to recognize the
value of this terrible cudgel which regardless of the rules of
military science destroyed the French, and to him belongs the credit
for taking the first step toward regularizing this method of warfare.

On August 24 Davydov's first partisan detachment was formed and then
others were recognized. The further the campaign progressed the more
numerous these detachments became.

The irregulars destroyed the great army piecemeal. They gathered the
fallen leaves that dropped of themselves from that withered tree-
the French army--and sometimes shook that tree itself. By October,
when the French were fleeing toward Smolensk, there were hundreds of
such companies, of various sizes and characters. There were some
that adopted all the army methods and had infantry, artillery, staffs,
and the comforts of life. Others consisted solely of Cossack
cavalry. There were also small scratch groups of foot and horse, and
groups of peasants and landowners that remained unknown. A sacristan
commanded one party which captured several hundred prisoners in the
course of a month; and there was Vasilisa, the wife of a village
elder, who slew hundreds of the French.

The partisan warfare flamed up most fiercely in the latter days of
October. Its first period had passed: when the partisans themselves,
amazed at their own boldness, feared every minute to be surrounded and
captured by the French, and hid in the forests without unsaddling,
hardly daring to dismount and always expecting to be pursued. By the
end of October this kind of warfare had taken definite shape: it had
become clear to all what could be ventured against the French and what
could not. Now only the commanders of detachments with staffs, and
moving according to rules at a distance from the French, still
regarded many things as impossible. The small bands that had started
their activities long before and had already observed the French
closely considered things possible which the commanders of the big
detachments did not dare to contemplate. The Cossacks and peasants who
crept in among the French now considered everything possible.

On October 22, Denisov (who was one of the irregulars) was with
his group at the height of the guerrilla enthusiasm. Since early
morning he and his party had been on the move. All day long he had
been watching from the forest that skirted the highroad a large French
convoy of cavalry baggage and Russian prisoners separated from the
rest of the army, which--as was learned from spies and prisoners-
was moving under a strong escort to Smolensk. Besides Denisov and
Dolokhov (who also led a small party and moved in Denisov's vicinity),
the commanders of some large divisions with staffs also knew of this
convoy and, as Denisov expressed it, were sharpening their teeth for
it. Two of the commanders of large parties--one a Pole and the other a
German--sent invitations to Denisov almost simultaneously,
requesting him to join up with their divisions to attack the convoy.

"No, bwother, I have gwown mustaches myself," said Denisov on
reading these documents, and he wrote to the German that, despite
his heartfelt desire to serve under so valiant and renowned a general,
he had to forgo that pleasure because he was already under the command
of the Polish general. To the Polish general he replied to the same
effect, informing him that he was already under the command of the
German.

Having arranged matters thus, Denisov and Dolokhov intended, without
reporting matters to the higher command, to attack and seize that
convoy with their own small forces. On October 22 it was moving from
the village of Mikulino to that of Shamshevo. To the left of the
road between Mikulino and Shamshevo there were large forests,
extending in some places up to the road itself though in others a mile
or more back from it. Through these forests Denisov and his party rode
all day, sometimes keeping well back in them and sometimes coming to
the very edge, but never losing sight of the moving French. That
morning, Cossacks of Denisov's party had seized and carried off into
the forest two wagons loaded with cavalry saddles, which had stuck
in the mud not far from Mikulino where the forest ran close to the
road. Since then, and until evening, the party had the movements of
the French without attacking. It was necessary to let the French reach
Shamshevo quietly without alarming them and then, after joining
Dolokhov who was to come that evening to a consultation at a
watchman's hut in the forest less than a mile from Shamshevo, to
surprise the French at dawn, falling like an avalanche on their
heads from two sides, and rout and capture them all at one blow.

In their rear, more than a mile from Mikulino where the forest
came right up to the road, six Cossacks were posted to report if any
fresh columns of French should show themselves.

Beyond Shamshevo, Dolokhov was to observe the road in the same
way, to find out at what distance there were other French troops. They
reckoned that the convoy had fifteen hundred men. Denisov had two
hundred, and Dolokhov might have as many more, but the disparity of
numbers did not deter Denisov. All that he now wanted to know was what
troops these were and to learn that he had to capture a "tongue"--that
is, a man from the enemy column. That morning's attack on the wagons
had been made so hastily that the Frenchmen with the wagons had all
been killed; only a little drummer boy had been taken alive, and as he
was a straggler he could tell them nothing definite about the troops
in that column.

Denisov considered it dangerous to make a second attack for fear
of putting the whole column on the alert, so he sent Tikhon
Shcherbaty, a peasant of his party, to Shamshevo to try and seize at
least one of the French quartermasters who had been sent on in
advance.




CHAPTER IV


It was a warm rainy autumn day. The sky and the horizon were both
the color of muddy water. At times a sort of mist descended, and
then suddenly heavy slanting rain came down.

Denisov in a felt cloak and a sheepskin cap from which the rain
ran down was riding a thin thoroughbred horse with sunken sides.
Like his horse, which turned its head and laid its ears back, he
shrank from the driving rain and gazed anxiously before him. His
thin face with its short, thick black beard looked angry.

Beside Denisov rode an esaul,* Denisov's fellow worker, also in felt
cloak and sheepskin cap, and riding a large sleek Don horse.


*A captain of Cossacks.


Esaul Lovayski the Third was a tall man as straight as an arrow,
pale-faced, fair-haired, with narrow light eyes and with calm
self-satisfaction in his face and bearing. Though it was impossible to
say in what the peculiarity of the horse and rider lay, yet at first
glance at the esaul and Denisov one saw that the latter was wet and
uncomfortable and was a man mounted on a horse, while looking at the
esaul one saw that he was as comfortable and as much at ease as always
and that he was not a man who had mounted a horse, but a man who was
one with his horse, a being consequently possessed of twofold
strength.

A little ahead of them walked a peasant guide, wet to the skin and
wearing a gray peasant coat and a white knitted cap.

A little behind, on a poor, small, lean Kirghiz mount with an
enormous tail and mane and a bleeding mouth, rode a young officer in a
blue French overcoat.

Beside him rode an hussar, with a boy in a tattered French uniform
and blue cap behind him on the crupper of his horse. The boy held on
to the hussar with cold, red hands, and raising his eyebrows gazed
about him with surprise. This was the French drummer boy captured that
morning.

Behind them along the narrow, sodden, cutup forest road came hussars
in threes and fours, and then Cossacks: some in felt cloaks, some in
French greatcoats, and some with horsecloths over their heads. The
horses, being drenched by the rain, all looked black whether
chestnut or bay. Their necks, with their wet, close-clinging manes,
looked strangely thin. Steam rose from them. Clothes, saddles,
reins, were all wet, slippery, and sodden, like the ground and the
fallen leaves that strewed the road. The men sat huddled up trying not
to stir, so as to warm the water that had trickled to their bodies and
not admit the fresh cold water that was leaking in under their
seats, their knees, and at the back of their necks. In the midst of
the outspread line of Cossacks two wagons, drawn by French horses
and by saddled Cossack horses that had been hitched on in front,
rumbled over the tree stumps and branches and splashed through the
water that lay in the ruts.

Denisov's horse swerved aside to avoid a pool in the track and
bumped his rider's knee against a tree.

"Oh, the devil!" exclaimed Denisov angrily, and showing his teeth he
struck his horse three times with his whip, splashing himself and
his comrades with mud.

Denisov was out of sorts both because of the rain and also from
hunger (none of them had eaten anything since morning), and yet more
because he still had no news from Dolokhov and the man sent to capture
a "tongue" had not returned.

"There'll hardly be another such chance to fall on a transport as
today. It's too risky to attack them by oneself, and if we put it
off till another day one of the big guerrilla detachments will
snatch the prey from under our noses," thought Denisov, continually
peering forward, hoping to see a messenger from Dolokhov.

On coming to a path in the forest along which he could see far to
the right, Denisov stopped.

"There's someone coming," said he.

The esaul looked in the direction Denisov indicated.

"There are two, an officer and a Cossack. But it is not
presupposable that it is the lieutenant colonel himself," said the
esaul, who was fond of using words the Cossacks did not know.

The approaching riders having descended a decline were no longer
visible, but they reappeared a few minutes later. In front, at a weary
gallop and using his leather whip, rode an officer, disheveled and
drenched, whose trousers had worked up to above his knees. Behind him,
standing in the stirrups, trotted a Cossack. The officer, a very young
lad with a broad rosy face and keen merry eyes, galloped up to Denisov
and handed him a sodden envelope.

"From the general," said the officer. "Please excuse its not being
quite dry."

Denisov, frowning, took the envelope and opened it.

"There, they kept telling us: 'It's dangerous, it's dangerous,'"
said the officer, addressing the esaul while Denisov was reading the
dispatch. "But Komarov and I"--he pointed to the Cossack--"were
prepared. We have each of us two pistols.... But what's this?" he
asked, noticing the French drummer boy. "A prisoner? You've already
been in action? May I speak to him?"

"Wostov! Petya!" exclaimed Denisov, having run through the dispatch.
"Why didn't you say who you were?" and turning with a smile he held
out his hand to the lad.

The officer was Petya Rostov.

All the way Petya had been preparing himself to behave with
Denisov as befitted a grownup man and an officer--without hinting at
their previous acquaintance. But as soon as Denisov smiled at him
Petya brightened up, blushed with pleasure, forgot the official manner
he had been rehearsing, and began telling him how he had already
been in a battle near Vyazma and how a certain hussar had
distinguished himself there.

"Well, I am glad to see you," Denisov interrupted him, and his
face again assumed its anxious expression.

"Michael Feoklitych," said he to the esaul, "this is again fwom that
German, you know. He"--he indicated Petya--"is serving under him."

And Denisov told the esaul that the dispatch just delivered was a
repetition of the German general's demand that he should join forces
with him for an attack on the transport.

"If we don't take it tomowwow, he'll snatch it fwom under our
noses," he added.

While Denisov was talking to the esaul, Petya--abashed by
Denisov's cold tone and supposing that it was due to the condition
of his trousers--furtively tried to pull them down under his greatcoat
so that no one should notice it, while maintaining as martial an air
as possible.

"Will there be any orders, your honor?" he asked Denisov, holding
his hand at the salute and resuming the game of adjutant and general
for which he had prepared himself, "or shall I remain with your
honor?"

"Orders?" Denisov repeated thoughtfully. "But can you stay till
tomowwow?"

"Oh, please... May I stay with you?" cried Petya.

"But, just what did the genewal tell you? To weturn at once?"
asked Denisov.

Petya blushed.

"He gave me no instructions. I think I could?" he returned,
inquiringly.

"Well, all wight," said Denisov.

And turning to his men he directed a party to go on to the halting
place arranged near the watchman's hut in the forest, and told the
officer on the Kirghiz horse (who performed the duties of an adjutant)
to go and find out where Dolokhov was and whether he would come that
evening. Denisov himself intended going with the esaul and Petya to
the edge of the forest where it reached out to Shamshevo, to have a
look at the part of the French bivouac they were to attack next day.

"Well, old fellow," said he to the peasant guide, "lead us to
Shamshevo."

Denisov, Petya, and the esaul, accompanied by some Cossacks and
the hussar who had the prisoner, rode to the left across a ravine to
the edge of the forest.





CHAPTER V


The rain had stopped, and only the mist was falling and drops from
the trees. Denisov, the esaul, and Petya rode silently, following
the peasant in the knitted cap who, stepping lightly with outturned
toes and moving noiselessly in his bast shoes over the roots and wet
leaves, silently led them to the edge of the forest.

He ascended an incline, stopped, looked about him, and advanced to
where the screen of trees was less dense. On reaching a large oak tree
that had not yet shed its leaves, he stopped and beckoned mysteriously
to them with his hand.

Denisov and Petya rode up to him. From the spot where the peasant
was standing they could see the French. Immediately beyond the forest,
on a downward slope, lay a field of spring rye. To the right, beyond a
steep ravine, was a small village and a landowner's house with a
broken roof. In the village, in the house, in the garden, by the well,
by the pond, over all the rising ground, and all along the road uphill
from the bridge leading to the village, not more than five hundred
yards away, crowds of men could be seen through the shimmering mist.
Their un-Russian shouting at their horses which were straining
uphill with the carts, and their calls to one another, could be
clearly heard.

"Bwing the prisoner here," said Denisov in a low voice, not taking
his eyes off the French.

A Cossack dismounted, lifted the boy down, and took him to
Denisov. Pointing to the French troops, Denisov asked him what these
and those of them were. The boy, thrusting his cold hands into his
pockets and lifting his eyebrows, looked at Denisov in affright, but
in spite of an evident desire to say all he knew gave confused
answers, merely assenting to everything Denisov asked him. Denisov
turned away from him frowning and addressed the esaul, conveying his
own conjectures to him.

Petya, rapidly turning his head, looked now at the drummer boy,
now at Denisov, now at the esaul, and now at the French in the village
and along the road, trying not to miss anything of importance.

"Whether Dolokhov comes or not, we must seize it, eh?" said
Denisov with a merry sparkle in his eyes.

"It is a very suitable spot," said the esaul.

"We'll send the infantwy down by the swamps," Denisov continued.
"They'll cweep up to the garden; you'll wide up fwom there with the
Cossacks"--he pointed to a spot in the forest beyond the village--"and
I with my hussars fwom here. And at the signal shot..."

"The hollow is impassable--there's a swamp there," said the esaul.
"The horses would sink. We must ride round more to the left...."

While they were talking in undertones the crack of a shot sounded
from the low ground by the pond, a puff of white smoke appeared,
then another, and the sound of hundreds of seemingly merry French
voices shouting together came up from the slope. For a moment
Denisov and the esaul drew back. They were so near that they thought
they were the cause of the firing and shouting. But the firing and
shouting did not relate to them. Down below, a man wearing something
red was running through the marsh. The French were evidently firing
and shouting at him.

"Why, that's our Tikhon," said the esaul.

"So it is! It is!"

"The wascal!" said Denisov.

"He'll get away!" said the esaul, screwing up his eyes.

The man whom they called Tikhon, having run to the stream, plunged
in so that the water splashed in the air, and, having disappeared
for an instant, scrambled out on all fours, all black with the wet,
and ran on. The French who had been pursuing him stopped.

"Smart, that!" said the esaul.

"What a beast!" said Denisov with his former look of vexation. "What
has he been doing all this time?"

"Who is he?" asked Petya.

"He's our plastun. I sent him to capture a 'tongue.'"

"Oh, yes," said Petya, nodding at the first words Denisov uttered as
if he understood it all, though he really did not understand
anything of it.

Tikhon Shcherbaty was one of the most indispensable men in their
band. He was a peasant from Pokrovsk, near the river Gzhat. When
Denisov had come to Pokrovsk at the beginning of his operations and
had as usual summoned the village elder and asked him what he knew
about the French, the elder, as though shielding himself, had replied,
as all village elders did, that he had neither seen nor heard anything
of them. But when Denisov explained that his purpose was to kill the
French, and asked if no French had strayed that way, the elder replied
that some "more-orderers" had really been at their village, but that
Tikhon Shcherbaty was the only man who dealt with such matters.
Denisov had Tikhon called and, having praised him for his activity,
said a few words in the elder's presence about loyalty to the Tsar and
the country and the hatred of the French that all sons of the
fatherland should cherish.

"We don't do the French any harm," said Tikhon, evidently frightened
by Denisov's words. "We only fooled about with the lads for fun, you
know! We killed a score or so of 'more-orderers,' but we did no harm
else..."

Next day when Denisov had left Pokrovsk, having quite forgotten
about this peasant, it was reported to him that Tikhon had attached
himself to their party and asked to be allowed to remain with it.
Denisov gave orders to let him do so.

Tikhon, who at first did rough work, laying campfires, fetching
water, flaying dead horses, and so on, soon showed a great liking
and aptitude for partisan warfare. At night he would go out for
booty and always brought back French clothing and weapons, and when
told to would bring in French captives also. Denisov then relieved him
from drudgery and began taking him with him when he went out on
expeditions and had him enrolled among the Cossacks.

Tikhon did not like riding, and always went on foot, never lagging
behind the cavalry. He was armed with a musketoon (which he carried
rather as a joke), a pike and an ax, which latter he used as a wolf
uses its teeth, with equal case picking fleas out of its fur or
crunching thick bones. Tikhon with equal accuracy would split logs
with blows at arm's length, or holding the head of the ax would cut
thin little pegs or carve spoons. In Denisov's party he held a
peculiar and exceptional position. When anything particularly
difficult or nasty had to be done--to push a cart out of the mud
with one's shoulders, pull a horse out of a swamp by its tail, skin
it, slink in among the French, or walk more than thirty miles in a
day--everybody pointed laughingly at Tikhon.

"It won't hurt that devil--he's as strong as a horse!" they said
of him.

Once a Frenchman Tikhon was trying to capture fired a pistol at
him and shot him in the fleshy part of the back. That wound (which
Tikhon treated only with internal and external applications of
vodka) was the subject of the liveliest jokes by the whole detachment-
jokes in which Tikhon readily joined.

"Hallo, mate! Never again? Gave you a twist?" the Cossacks would
banter him. And Tikhon, purposely writhing and making faces, pretended
to be angry and swore at the French with the funniest curses. The only
effect of this incident on Tikhon was that after being wounded he
seldom brought in prisoners.

He was the bravest and most useful man in the party. No one found
more opportunities for attacking, no one captured or killed more
Frenchmen, and consequently he was made the buffoon of all the
Cossacks and hussars and willingly accepted that role. Now he had been
sent by Denisov overnight to Shamshevo to capture a "tongue." But
whether because he had not been content to take only one Frenchman
or because he had slept through the night, he had crept by day into
some bushes right among the French and, as Denisov had witnessed
from above, had been detected by them.





CHAPTER VI


After talking for some time with the esaul about next day's
attack, which now, seeing how near they were to the French, he
seemed to have definitely decided on, Denisov turned his horse and
rode back.

"Now, my lad, we'll go and get dwy," he said to Petya.

As they approached the watchhouse Denisov stopped, peering into
the forest. Among the trees a man with long legs and long, swinging
arms, wearing a short jacket, bast shoes, and a Kazan hat, was
approaching with long, light steps. He had a musketoon over his
shoulder and an ax stuck in his girdle. When he espied Denisov he
hastily threw something into the bushes, removed his sodden hat by its
floppy brim, and approached his commander. It was Tikhon. His wrinkled
and pockmarked face and narrow little eyes beamed with
self-satisfied merriment. He lifted his head high and gazed at Denisov
as if repressing a laugh.

"Well, where did you disappear to?" inquired Denisov.

"Where did I disappear to? I went to get Frenchmen," answered Tikhon
boldly and hurriedly, in a husky but melodious bass voice.

"Why did you push yourself in there by daylight? You ass! Well,
why haven't you taken one?"

"Oh, I took one all right," said Tikhon.

"Where is he?"

"You see, I took him first thing at dawn," Tikhon continued,
spreading out his flat feet with outturned toes in their bast shoes.
"I took him into the forest. Then I see he's no good and think I'll go
and fetch a likelier one."

"You see?... What a wogue--it's just as I thought," said Denisov
to the esaul. "Why didn't you bwing that one?"

"What was the good of bringing him?" Tikhon interrupted hastily
and angrily--"that one wouldn't have done for you. As if I don't
know what sort you want!"

"What a bwute you are!... Well?"

"I went for another one," Tikhon continued, "and I crept like this
through the wood and lay down." (He suddenly lay down on his stomach
with a supple movement to show how he had done it.) "One turned up and
I grabbed him, like this." (He jumped up quickly and lightly.)
"'Come along to the colonel,' I said. He starts yelling, and
suddenly there were four of them. They rushed at me with their
little swords. So I went for them with my ax, this way: 'What are
you up to?' says I. 'Christ be with you!'" shouted Tikhon, waving
his arms with an angry scowl and throwing out his chest.

"Yes, we saw from the hill how you took to your heels through the
puddles!" said the esaul, screwing up his glittering eyes.

Petya badly wanted to laugh, but noticed that they all refrained
from laughing. He turned his eyes rapidly from Tikhon's face to the
esaul's and Denisov's, unable to make out what it all meant.

"Don't play the fool!" said Denisov, coughing angrily. "Why didn't
you bwing the first one?"

Tikhon scratched his back with one hand and his head with the other,
then suddenly his whole face expanded into a beaming, foolish grin,
disclosing a gap where he had lost a tooth (that was why he was called
Shcherbaty--the gap-toothed). Denisov smiled, and Petya burst into a
peal of merry laughter in which Tikhon himself joined.

"Oh, but he was a regular good-for-nothing," said Tikhon. "The
clothes on him--poor stuff! How could I bring him? And so rude, your
honor! Why, he says: 'I'm a general's son myself, I won't go!' he
says."

"You are a bwute!" said Denisov. "I wanted to question..."

"But I questioned him," said Tikhon. "He said he didn't know much.
'There are a lot of us,' he says, 'but all poor stuff--only soldiers
in name,' he says. 'Shout loud at them,' he says, 'and you'll take
them all,'" Tikhon concluded, looking cheerfully and resolutely into
Denisov's eyes.

"I'll give you a hundwed sharp lashes--that'll teach you to play the
fool!" said Denisov severely.

"But why are you angry?" remonstrated Tikhon, "just as if I'd
never seen your Frenchmen! Only wait till it gets dark and I'll
fetch you any of them you want--three if you like."

"Well, let's go," said Denisov, and rode all the way to the
watchhouse in silence and frowning angrily.

Tikhon followed behind and Petya heard the Cossacks laughing with
him and at him, about some pair of boots he had thrown into the
bushes.

When the fit of laughter that had seized him at Tikhon's words and
smile had passed and Petya realized for a moment that this Tikhon
had killed a man, he felt uneasy. He looked round at the captive
drummer boy and felt a pang in his heart. But this uneasiness lasted
only a moment. He felt it necessary to hold his head higher, to
brace himself, and to question the esaul with an air of importance
about tomorrow's undertaking, that he might not be unworthy of the
company in which he found himself.

The officer who had been sent to inquire met Denisov on the way with
the news that Dolokhov was soon coming and that all was well with him.

Denisov at once cheered up and, calling Petya to him, said: "Well,
tell me about yourself."





CHAPTER VII


Petya, having left his people after their departure from Moscow,
joined his regiment and was soon taken as orderly by a general
commanding a large guerrilla detachment. From the time he received his
commission, and especially since he had joined the active army and
taken part in the battle of Vyazma, Petya had been in a constant state
of blissful excitement at being grown-up and in a perpetual ecstatic
hurry not to miss any chance to do something really heroic. He was
highly delighted with what he saw and experienced in the army, but
at the same time it always seemed to him that the really heroic
exploits were being performed just where he did not happen to be.
And he was always in a hurry to get where he was not.

When on the twenty-first of October his general expressed a wish
to send somebody to Denisov's detachment, Petya begged so piteously to
be sent that the general could not refuse. But when dispatching him he
recalled Petya's mad action at the battle of Vyazma, where instead
of riding by the road to the place to which he had been sent, he had
galloped to the advanced line under the fire of the French and had
there twice fired his pistol. So now the general explicitly forbade
his taking part in any action whatever of Denisov's. That was why
Petya had blushed and grown confused when Denisov asked him whether he
could stay. Before they had ridden to the outskirts of the forest
Petya had considered he must carry out his instructions strictly and
return at once. But when he saw the French and saw Tikhon and
learned that there would certainly be an attack that night, he
decided, with the rapidity with which young people change their views,
that the general, whom he had greatly respected till then, was a
rubbishy German, that Denisov was a hero, the esaul a hero, and Tikhon
a hero too, and that it would be shameful for him to leave them at a
moment of difficulty.

It was already growing dusk when Denisov, Petya, and the esaul
rode up to the watchhouse. In the twilight saddled horses could be
seen, and Cossacks and hussars who had rigged up rough shelters in the
glade and were kindling glowing fires in a hollow of the forest
where the French could not see the smoke. In the passage of the
small watchhouse a Cossack with sleeves rolled up was chopping some
mutton. In the room three officers of Denisov's band were converting a
door into a tabletop. Petya took off his wet clothes, gave them to
be dried, and at once began helping the officers to fix up the
dinner table.

In ten minutes the table was ready and a napkin spread on it. On the
table were vodka, a flask of rum, white bread, roast mutton, and salt.

Sitting at table with the officers and tearing the fat savory mutton
with his hands, down which the grease trickled, Petya was in an
ecstatic childish state of love for all men, and consequently of
confidence that others loved him in the same way.

"So then what do you think, Vasili Dmitrich?" said he to Denisov.
"It's all right my staying a day with you?" And not waiting for a
reply he answered his own question: "You see I was told to find out-
well, I am finding out.... Only do let me into the very... into the
chief... I don't want a reward... But I want..."

Petya clenched his teeth and looked around, throwing back his head
and flourishing his arms.

"Into the vewy chief..." Denisov repeated with a smile.

"Only, please let me command something, so that I may really
command..." Petya went on. "What would it be to you?... Oh, you want a
knife?" he said, turning to an officer who wished to cut himself a
piece of mutton.

And he handed him his clasp knife. The officer admired it.

"Please keep it. I have several like it," said Petya, blushing.
"Heavens! I was quite forgetting!" he suddenly cried. "I have some
raisins, fine ones; you know, seedless ones. We have a new sutler
and he has such capital things. I bought ten pounds. I am used to
something sweet. Would you like some?..." and Petya ran out into the
passage to his Cossack and brought back some bags which contained
about five pounds of raisins. "Have some, gentlemen, have some!"

"You want a coffeepot, don't you?" he asked the esaul. "I bought a
capital one from our sutler! He has splendid things. And he's very
honest, that's the chief thing. I'll be sure to send it to you. Or
perhaps your flints are giving out, or are worn out--that happens
sometimes, you know. I have brought some with me, here they are"-
and he showed a bag--"a hundred flints. I bought them very cheap.
Please take as many as you want, or all if you like...."

Then suddenly, dismayed lest he had said too much, Petya stopped and
blushed.

He tried to remember whether he had not done anything else that
was foolish. And running over the events of the day he remembered
the French drummer boy. "It's capital for us here, but what of him?
Where have they put him? Have they fed him? Haven't they hurt his
feelings?" he thought. But having caught himself saying too much about
the flints, he was now afraid to speak out.

"I might ask," he thought, "but they'll say: 'He's a boy himself and
so he pities the boy.' I'll show them tomorrow whether I'm a boy. Will
it seem odd if I ask?" Petya thought. "Well, never mind!" and
immediately, blushing and looking anxiously at the officers to see
if they appeared ironical, he said:

"May I call in that boy who was taken prisoner and give him
something to eat?... Perhaps..."

"Yes, he's a poor little fellow," said Denisov, who evidently saw
nothing shameful in this reminder. "Call him in. His name is Vincent
Bosse. Have him fetched."

"I'll call him," said Petya.

"Yes, yes, call him. A poor little fellow," Denisov repeated.

Petya was standing at the door when Denisov said this. He slipped in
between the officers, came close to Denisov, and said:

"Let me kiss you, dear old fellow! Oh, how fine, how splendid!"

And having kissed Denisov he ran out of the hut.

"Bosse! Vincent!" Petya cried, stopping outside the door.

"Who do you want, sir?" asked a voice in the darkness.

Petya replied that he wanted the French lad who had been captured
that day.

"Ah, Vesenny?" said a Cossack.

Vincent, the boy's name, had already been changed by the Cossacks
into Vesenny (vernal) and into Vesenya by the peasants and soldiers.
In both these adaptations the reference to spring (vesna) matched
the impression made by the young lad.

"He is warming himself there by the bonfire. Ho, Vesenya!
Vesenya!--Vesenny!" laughing voices were heard calling to one
another in the darkness.

"He's a smart lad," said an hussar standing near Petya. "We gave him
something to eat a while ago. He was awfully hungry!"

The sound of bare feet splashing through the mud was heard in the
darkness, and the drummer boy came to the door.

"Ah, c'est vous!" said Petya. "Voulez-vous manger? N'ayez pas
peur, on ne vous fera pas de mal,"* he added shyly and affectionately,
touching the boy's hand. "Entrez, entrez."*[2]


*"Ah, it's you! Do you want something to eat? Don't be afraid,
they won't hurt you."

*[2] "Come in, come in."


"Merci, monsieur,"* said the drummer boy in a trembling almost
childish voice, and he began scraping his dirty feet on the threshold.


*"Thank you, sir."


There were many things Petya wanted to say to the drummer boy, but
did not dare to. He stood irresolutely beside him in the passage. Then
in the darkness he took the boy's hand and pressed it.

"Come in, come in!" he repeated in a gentle whisper. "Oh, what can I
do for him?" he thought, and opening the door he let the boy pass in
first.

When the boy had entered the hut, Petya sat down at a distance
from him, considering it beneath his dignity to pay attention to
him. But he fingered the money in his pocket and wondered whether it
would seem ridiculous to give some to the drummer boy.





CHAPTER VIII


The arrival of Dolokhov diverted Petya's attention from the
drummer boy, to whom Denisov had had some mutton and vodka given,
and whom he had had dressed in a Russian coat so that he might be kept
with their band and not sent away with the other prisoners. Petya
had heard in the army many stories of Dolokhov's extraordinary bravery
and of his cruelty to the French, so from the moment he entered the
hut Petya did not take his eyes from him, but braced himself up more
and more and held his head high, that he might not be unworthy even of
such company.

Dolokhov's appearance amazed Petya by its simplicity.

Denisov wore a Cossack coat, had a beard, had an icon of Nicholas
the Wonder-Worker on his breast, and his way of speaking and
everything he did indicated his unusual position. But Dolokhov, who in
Moscow had worn a Persian costume, had now the appearance of a most
correct officer of the Guards. He was clean-shaven and wore a
Guardsman's padded coat with an Order of St. George at his
buttonhole and a plain forage cap set straight on his head. He took
off his wet felt cloak in a corner of the room, and without greeting
anyone went up to Denisov and began questioning him about the matter
in hand. Denisov told him of the designs the large detachments had
on the transport, of the message Petya had brought, and his own
replies to both generals. Then he told him all he knew of the French
detachment.

"That's so. But we must know what troops they are and their
numbers," said Dolokhov. "It will be necessary to go there. We can't
start the affair without knowing for certain how many there are. I
like to work accurately. Here now--wouldn't one of these gentlemen
like to ride over to the French camp with me? I have brought a spare
uniform."

"I, I... I'll go with you!" cried Petya.

"There's no need for you to go at all," said Denisov, addressing
Dolokhov, "and as for him, I won't let him go on any account."

"I like that!" exclaimed Petya. "Why shouldn't I go?"

"Because it's useless."

"Well, you must excuse me, because... because... I shall go, and
that's all. You'll take me, won't you?" he said, turning to Dolokhov.

"Why not?" Dolokhov answered absently, scrutinizing the face of
the French drummer boy. "Have you had that youngster with you long?"
he asked Denisov.

"He was taken today but he knows nothing. I'm keeping him with me."

"Yes, and where do you put the others?" inquired Dolokhov.

"Where? I send them away and take a weceipt for them," shouted
Denisov, suddenly flushing. "And I say boldly that I have not a single
man's life on my conscience. Would it be difficult for you to send
thirty or thwee hundwed men to town under escort, instead of staining-
I speak bluntly--staining the honor of a soldier?"

"That kind of amiable talk would be suitable from this young count
of sixteen," said Dolokhov with cold irony, "but it's time for you
to drop it."

"Why, I've not said anything! I only say that I'll certainly go with
you," said Petya shyly.

"But for you and me, old fellow, it's time to drop these amenities,"
continued Dolokhov, as if he found particular pleasure in speaking
of this subject which irritated Denisov. "Now, why have you kept
this lad?" he went on, swaying his head. "Because you are sorry for
him! Don't we know those 'receipts' of yours? You send a hundred men
away, and thirty get there. The rest either starve or get killed. So
isn't it all the same not to send them?"

The esaul, screwing up his light-colored eyes, nodded approvingly.

"That's not the point. I'm not going to discuss the matter. I do not
wish to take it on my conscience. You say they'll die. All wight. Only
not by my fault!"

Dolokhov began laughing.

"Who has told them not to capture me these twenty times over? But if
they did catch me they'd string me up to an aspen tree, and with all
your chivalry just the same." He paused. "However, we must get to
work. Tell the Cossack to fetch my kit. I have two French uniforms
in it. Well, are you coming with me?" he asked Petya.

"I? Yes, yes, certainly!" cried Petya, blushing almost to tears
and glancing at Denisov.

While Dolokhov had been disputing with Denisov what should be done
with prisoners, Petya had once more felt awkward and restless; but
again he had no time to grasp fully what they were talking about.
"If grown-up, distinguished men think so, it must be necessary and
right," thought he. "But above all Denisov must not dare to imagine
that I'll obey him and that he can order me about. I will certainly go
to the French camp with Dolokhov. If he can, so can I!"

And to all Denisov's persuasions, Petya replied that he too was
accustomed to do everything accurately and not just anyhow, and that
he never considered personal danger.

"For you'll admit that if we don't know for sure how many of them
there are... hundreds of lives may depend on it, while there are
only two of us. Besides, I want to go very much and certainly will go,
so don't hinder me," said he. "It will only make things worse..."





CHAPTER IX


Having put on French greatcoats and shakos, Petya and Dolokhov
rode to the clearing from which Denisov had reconnoitered the French
camp, and emerging from the forest in pitch darkness they descended
into the hollow. On reaching the bottom, Dolokhov told the Cossacks
accompanying him to await him there and rode on at a quick trot
along the road to the bridge. Petya, his heart in his mouth with
excitement, rode by his side.

"If we're caught, I won't be taken alive! I have a pistol,"
whispered he.

"Don't talk Russian," said Dolokhov in a hurried whisper, and at
that very moment they heard through the darkness the challenge: "Qui
vive?"* and the click of a musket.


*"Who goes there?"


The blood rushed to Petya's face and he grasped his pistol.

"Lanciers du 6-me,"* replied Dolokhov, neither hastening nor
slackening his horse's pace.


*"Lancers of the 6th Regiment."


The black figure of a sentinel stood on the bridge.

"Mot d'ordre."*


*"Password."


Dolokhov reined in his horse and advanced at a walk.

"Dites donc, le colonel Gerard est ici?"* he asked.


*"Tell me, is Colonel Gerard here?"


"Mot d'ordre," repeated the sentinel, barring the way and not
replying.

"Quand un officier fait sa ronde, les sentinelles ne demandent pas
le mot d'ordre..." cried Dolokhov suddenly flaring up and riding
straight at the sentinel. "Je vous demande si le colonel est ici."*


*"When an officer is making his round, sentinels don't ask him for
the password.... I am asking you if the colonel is here."


And without waiting for an answer from the sentinel, who had stepped
aside, Dolokhov rode up the incline at a walk.

Noticing the black outline of a man crossing the road, Dolokhov
stopped him and inquired where the commander and officers were. The
man, a soldier with a sack over his shoulder, stopped, came close up
to Dolokhov's horse, touched it with his hand, and explained simply
and in a friendly way that the commander and the officers were
higher up the hill to the right in the courtyard of the farm, as he
called the landowner's house.

Having ridden up the road, on both sides of which French talk
could be heard around the campfires, Dolokhov turned into the
courtyard of the landowner's house. Having ridden in, he dismounted
and approached a big blazing campfire, around which sat several men
talking noisily. Something was boiling in a small cauldron at the edge
of the fire and a soldier in a peaked cap and blue overcoat, lit up by
the fire, was kneeling beside it stirring its contents with a ramrod.

"Oh, he's a hard nut to crack," said one of the officers who was
sitting in the shadow at the other side of the fire.

"He'll make them get a move on, those fellows!" said another,
laughing.

Both fell silent, peering out through the darkness at the sound of
Dolokhov's and Petya's steps as they advanced to the fire leading
their horses.

"Bonjour, messieurs!"* said Dolokhov loudly and clearly.


*"Good day, gentlemen."


There was a stir among the officers in the shadow beyond the fire,
and one tall, long-necked officer, walking round the fire, came up
to Dolokhov.

"Is that you, Clement?" he asked. "Where the devil...?" But, noticing
his mistake, he broke off short and, with a frown, greeted Dolokhov as
a stranger, asking what he could do for him.

Dolokhov said that he and his companion were trying to overtake
their regiment, and addressing the company in general asked whether
they knew anything of the 6th Regiment. None of them knew anything,
and Petya thought the officers were beginning to look at him and
Dolokhov with hostility and suspicion. For some seconds all were
silent.

"If you were counting on the evening soup, you have come too
late," said a voice from behind the fire with a repressed laugh.

Dolokhov replied that they were not hungry and must push on
farther that night.

He handed the horses over to the soldier who was stirring the pot
and squatted down on his heels by the fire beside the officer with the
long neck. That officer did not take his eyes from Dolokhov and
again asked to what regiment he belonged. Dolokhov, as if he had not
heard the question, did not reply, but lighting a short French pipe
which he took from his pocket began asking the officer in how far
the road before them was safe from Cossacks.

"Those brigands are everywhere," replied an officer from behind
the fire.

Dolokhov remarked that the Cossacks were a danger only to stragglers
such as his companion and himself, "but probably they would not dare
to attack large detachments?" he added inquiringly. No one replied.

"Well, now he'll come away," Petya thought every moment as he
stood by the campfire listening to the talk.

But Dolokhov restarted the conversation which had dropped and
began putting direct questions as to how many men there were in the
battalion, how many battalions, and how many prisoners. Asking about
the Russian prisoners with that detachment, Dolokhov said:

"A horrid business dragging these corpses about with one! It would
be better to shoot such rabble," and burst into loud laughter, so
strange that Petya thought the French would immediately detect their
disguise, and involuntarily took a step back from the campfire.

No one replied a word to Dolokhov's laughter, and a French officer
whom they could not see (he lay wrapped in a greatcoat) rose and
whispered something to a companion. Dolokhov got up and called to
the soldier who was holding their horses.

"Will they bring our horses or not?" thought Petya, instinctively
drawing nearer to Dolokhov.

The horses were brought.

"Good evening, gentlemen," said Dolokhov.

Petya wished to say "Good night" but could not utter a word. The
officers were whispering together. Dolokhov was a long time mounting
his horse which would not stand still, then he rode out of the yard at
a footpace. Petya rode beside him, longing to look round to see
whether or no the French were running after them, but not daring to.

Coming out onto the road Dolokhov did not ride back across the
open country, but through the village. At one spot he stopped and
listened. "Do you hear?" he asked. Petya recognized the sound of
Russian voices and saw the dark figures of Russian prisoners round
their campfires. When they had descended to the bridge Petya and
Dolokhov rode past the sentinel, who without saying a word paced
morosely up and down it, then they descended into the hollow where the
Cossacks awaited them.

"Well now, good-by. Tell Denisov, 'at the first shot at
daybreak,'" said Dolokhov and was about to ride away, but Petya seized
hold of him.

"Really!" he cried, "you are such a hero! Oh, how fine, how
splendid! How I love you!"

"All right, all right!" said Dolokhov. But Petya did not let go of
him and Dolokhov saw through the gloom that Petya was bending toward
him and wanted to kiss him. Dolokhov kissed him, laughed, turned his
horse, and vanished into the darkness.





CHAPTER X


Having returned to the watchman's hut, Petya found Denisov in the
passage. He was awaiting Petya's return in a state of agitation,
anxiety, and self-reproach for having let him go.

"Thank God!" he exclaimed. "Yes, thank God!" he repeated,
listening to Petya's rapturous account. "But, devil take you, I
haven't slept because of you! Well, thank God. Now lie down. We can
still get a nap before morning."

"But... no," said Petya, "I don't want to sleep yet. Besides I
know myself, if I fall asleep it's finished. And then I am used to not
sleeping before a battle."

He sat awhile in the hut joyfully recalling the details of his
expedition and vividly picturing to himself what would happen next
day.

Then, noticing that Denisov was asleep, he rose and went out of
doors.

It was still quite dark outside. The rain was over, but drops were
still falling from the trees. Near the watchman's hut the black shapes
of the Cossacks' shanties and of horses tethered together could be
seen. Behind the hut the dark shapes of the two wagons with their
horses beside them were discernible, and in the hollow the dying
campfire gleamed red. Not all the Cossacks and hussars were asleep;
here and there, amid the sounds of falling drops and the munching of
the horses near by, could be heard low voices which seemed to be
whispering.

Petya came out, peered into the darkness, and went up to the wagons.
Someone was snoring under them, and around them stood saddled horses
munching their oats. In the dark Petya recognized his own horse, which
he called "Karabakh" though it was of Ukranian breed, and went up to
it.

"Well, Karabakh! We'll do some service tomorrow," said he,
sniffing its nostrils and kissing it.

"Why aren't you asleep, sir?" said a Cossack who was sitting under a
wagon.

"No, ah... Likhachev--isn't that your name? Do you know I have
only just come back! We've been into the French camp."

And Petya gave the Cossack a detailed account not only of his ride
but also of his object, and why he considered it better to risk his
life than to act "just anyhow."

"Well, you should get some sleep now," said the Cossack.

"No, I am used to this," said Petya. "I say, aren't the flints in
your pistols worn out? I brought some with me. Don't you want any? You
can have some."


The Cossack bent forward from under the wagon to get a closer look
at Petya.

"Because I am accustomed to doing everything accurately," said
Petya. "Some fellows do things just anyhow, without preparation, and
then they're sorry for it afterwards. I don't like that."

"Just so," said the Cossack.

"Oh yes, another thing! Please, my dear fellow, will you sharpen
my saber for me? It's got bl..." (Petya feared to tell a lie, and
the saber never had been sharpened.) "Can you do it?"

"Of course I can."

Likhachev got up, rummaged in his pack, and soon Petya heard the
warlike sound of steel on whetstone. He climbed onto the wagon and sat
on its edge. The Cossack was sharpening the saber under the wagon.

"I say! Are the lads asleep?" asked Petya.

"Some are, and some aren't--like us."

"Well, and that boy?"

"Vesenny? Oh, he's thrown himself down there in the passage. Fast
asleep after his fright. He was that glad!"

After that Petya remained silent for a long time, listening to the
sounds. He heard footsteps in the darkness and a black figure
appeared.

"What are you sharpening?" asked a man coming up to the wagon.

"Why, this gentleman's saber."

"That's right," said the man, whom Petya took to be an hussar.
"Was the cup left here?"

"There, by the wheel!"

The hussar took the cup.

"It must be daylight soon," said he, yawning, and went away.

Petya ought to have known that he was in a forest with Denisov's
guerrilla band, less than a mile from the road, sitting on a wagon
captured from the French beside which horses were tethered, that under
it Likhachev was sitting sharpening a saber for him, that the big dark
blotch to the right was the watchman's hut, and the red blotch below
to the left was the dying embers of a campfire, that the man who had
come for the cup was an hussar who wanted a drink; but he neither knew
nor waited to know anything of all this. He was in a fairy kingdom
where nothing resembled reality. The big dark blotch might really be
the watchman's hut or it might be a cavern leading to the very
depths of the earth. Perhaps the red spot was a fire, or it might be
the eye of an enormous monster. Perhaps he was really sitting on a
wagon, but it might very well be that he was not sitting on a wagon
but on a terribly high tower from which, if he fell, he would have
to fall for a whole day or a whole month, or go on falling and never
reach the bottom. Perhaps it was just the Cossack, Likhachev, who
was sitting under the wagon, but it might be the kindest, bravest,
most wonderful, most splendid man in the world, whom no one knew of.
It might really have been that the hussar came for water and went back
into the hollow, but perhaps he had simply vanished--disappeared
altogether and dissolved into nothingness.

Nothing Petya could have seen now would have surprised him. He was
in a fairy kingdom where everything was possible.

He looked up at the sky. And the sky was a fairy realm like the
earth. It was clearing, and over the tops of the trees clouds were
swiftly sailing as if unveiling the stars. Sometimes it looked as if
the clouds were passing, and a clear black sky appeared. Sometimes
it seemed as if the black spaces were clouds. Sometimes the sky seemed
to be rising high, high overhead, and then it seemed to sink so low
that one could touch it with one's hand.

Petya's eyes began to close and he swayed a little.

The trees were dripping. Quiet talking was heard. The horses neighed
and jostled one another. Someone snored.

"Ozheg-zheg, Ozheg-zheg..." hissed the saber against the
whetstone, and suddenly Petya heard an harmonious orchestra playing
some unknown, sweetly solemn hymn. Petya was as musical as Natasha and
more so than Nicholas, but had never learned music or thought about
it, and so the melody that unexpectedly came to his mind seemed to him
particularly fresh and attractive. The music became more and more
audible. The melody grew and passed from one instrument to another.
And what was played was a fugue--though Petya had not the least
conception of what a fugue is. Each instrument--now resembling a
violin and now a horn, but better and clearer than violin or horn-
played its own part, and before it had finished the melody merged with
another instrument that began almost the same air, and then with a
third and a fourth; and they all blended into one and again became
separate and again blended, now into solemn church music, now into
something dazzlingly brilliant and triumphant.

"Oh--why, that was in a dream!" Petya said to himself, as he lurched
forward. "It's in my ears. But perhaps it's music of my own. Well,
go on, my music! Now!..."

He closed his eyes, and, from all sides as if from a distance,
sounds fluttered, grew into harmonies, separated, blended, and again
all mingled into the same sweet and solemn hymn. "Oh, this is
delightful! As much as I like and as I like!" said Petya to himself.
He tried to conduct that enormous orchestra.

"Now softly, softly die away!" and the sounds obeyed him. "Now
fuller, more joyful. Still more and more joyful!" And from an
unknown depth rose increasingly triumphant sounds. "Now voices join
in!" ordered Petya. And at first from afar he heard men's voices and
then women's. The voices grew in harmonious triumphant strength, and
Petya listened to their surpassing beauty in awe and joy.

With a solemn triumphal march there mingled a song, the drip from
the trees, and the hissing of the saber, "Ozheg-zheg-zheg..." and
again the horses jostled one another and neighed, not disturbing the
choir but joining in it.

Petya did not know how long this lasted: he enjoyed himself all
the time, wondered at his enjoyment and regretted that there was no
one to share it. He was awakened by Likhachev's kindly voice.

"It's ready, your honor; you can split a Frenchman in half with it!"

Petya woke up.

"It's getting light, it's really getting light!" he exclaimed.

The horses that had previously been invisible could now be seen to
their very tails, and a watery light showed itself through the bare
branches. Petya shook himself, jumped up, took a ruble from his pocket
and gave it to Likhachev; then he flourished the saber, tested it, and
sheathed it. The Cossacks were untying their horses and tightening
their saddle girths.

"And here's the commander," said Likhachev.

Denisov came out of the watchman's hut and, having called Petya,
gave orders to get ready.




CHAPTER XI


The men rapidly picked out their horses in the semidarkness,
tightened their saddle girths, and formed companies. Denisov stood
by the watchman's hut giving final orders. The infantry of the
detachment passed along the road and quickly disappeared amid the
trees in the mist of early dawn, hundreds of feet splashing through
the mud. The esaul gave some orders to his men. Petya held his horse
by the bridle, impatiently awaiting the order to mount. His face,
having been bathed in cold water, was all aglow, and his eyes were
particularly brilliant. Cold shivers ran down his spine and his
whole body pulsed rhythmically.

"Well, is ev'wything weady?" asked Denisov. "Bwing the horses."

The horses were brought. Denisov was angry with the Cossack
because the saddle girths were too slack, reproved him, and mounted.
Petya put his foot in the stirrup. His horse by habit made as if to
nip his leg, but Petya leaped quickly into the saddle unconscious of
his own weight and, turning to look at the hussars starting in the
darkness behind him, rode up to Denisov.

"Vasili Dmitrich, entrust me with some commission! Please... for
God's sake...!" said he.

Denisov seemed to have forgotten Petya's very existence. He turned
to glance at him.

"I ask one thing of you," he said sternly, "to obey me and not shove
yourself forward anywhere."

He did not say another word to Petya but rode in silence all the
way. When they had come to the edge of the forest it was noticeably
growing light over the field. Denisov talked in whispers with the
esaul and the Cossacks rode past Petya and Denisov. When they had
all ridden by, Denisov touched his horse and rode down the hill.
Slipping onto their haunches and sliding, the horses descended with
their riders into the ravine. Petya rode beside Denisov, the pulsation
of his body constantly increasing. It was getting lighter and lighter,
but the mist still hid distant objects. Having reached the valley,
Denisov looked back and nodded to a Cossack beside him.

"The signal!" said he.

The Cossack raised his arm and a shot rang out. In an instant the
tramp of horses galloping forward was heard, shouts came from
various sides, and then more shots.

At the first sound of trampling hoofs and shouting, Petya lashed his
horse and loosening his rein galloped forward, not heeding Denisov who
shouted at him. It seemed to Petya that at the moment the shot was
fired it suddenly became as bright as noon. He galloped to the bridge.
Cossacks were galloping along the road in front of him. On the
bridge he collided with a Cossack who had fallen behind, but he
galloped on. In front of him soldiers, probably Frenchmen, were
running from right to left across the road. One of them fell in the
mud under his horse's feet.

Cossacks were crowding about a hut, busy with something. From the
midst of that crowd terrible screams arose. Petya galloped up, and the
first thing he saw was the pale face and trembling jaw of a Frenchman,
clutching the handle of a lance that had been aimed at him.

"Hurrah!... Lads!... ours!" shouted Petya, and giving rein to his
excited horse he galloped forward along the village street.

He could hear shooting ahead of him. Cossacks, hussars, and ragged
Russian prisoners, who had come running from both sides of the road,
were shouting something loudly and incoherently. A gallant-looking
Frenchman, in a blue overcoat, capless, and with a frowning red
face, had been defending himself against the hussars. When Petya
galloped up the Frenchman had already fallen. "Too late again!"
flashed through Petya's mind and he galloped on to the place from
which the rapid firing could be heard. The shots came from the yard of
the landowner's house he had visited the night before with Dolokhov.
The French were making a stand there behind a wattle fence in a garden
thickly overgrown with bushes and were firing at the Cossacks who
crowded at the gateway. Through the smoke, as he approached the
gate, Petya saw Dolokhov, whose face was of a pale-greenish tint,
shouting to his men. "Go round! Wait for the infantry!" he exclaimed
as Petya rode up to him.

"Wait?... Hurrah-ah-ah!" shouted Petya, and without pausing a moment
galloped to the place whence came the sounds of firing and where the
smoke was thickest.

A volley was heard, and some bullets whistled past, while others
plashed against something. The Cossacks and Dolokhov galloped after
Petya into the gateway of the courtyard. In the dense wavering smoke
some of the French threw down their arms and ran out of the bushes
to meet the Cossacks, while others ran down the hill toward the
pond. Petya was galloping along the courtyard, but instead of
holding the reins he waved both his arms about rapidly and
strangely, slipping farther and farther to one side in his saddle. His
horse, having galloped up to a campfire that was smoldering in the
morning light, stopped suddenly, and Petya fell heavily on to the
wet ground. The Cossacks saw that his arms and legs jerked rapidly
though his head was quite motionless. A bullet had pierced his skull.

After speaking to the senior French officer, who came out of the
house with a white handkerchief tied to his sword and announced that
they surrendered, Dolokhov dismounted and went up to Petya, who lay
motionless with outstretched arms.

"Done for!" he said with a frown, and went to the gate to meet
Denisov who was riding toward him.

"Killed?" cried Denisov, recognizing from a distance the
unmistakably lifeless attitude--very familiar to him--in which Petya's
body was lying.

"Done for!" repeated Dolokhov as if the utterance of these words
afforded him pleasure, and he went quickly up to the prisoners, who
were surrounded by Cossacks who had hurried up. "We won't take
them!" he called out to Denisov.

Denisov did not reply; he rode up to Petya, dismounted, and with
trembling hands turned toward himself the bloodstained,
mud-bespattered face which had already gone white.

"I am used to something sweet. Raisins, fine ones... take them all!"
he recalled Petya's words. And the Cossacks looked round in surprise
at the sound, like the yelp of a dog, with which Denisov turned
away, walked to the wattle fence, and seized hold of it.

Among the Russian prisoners rescued by Denisov and Dolokhov was
Pierre Bezukhov.





CHAPTER XII

During the whole of their march from Moscow no fresh orders had been
issued by the French authorities concerning the party of prisoners
among whom was Pierre. On the twenty-second of October that party
was no longer with the same troops and baggage trains with which it
had left Moscow. Half the wagons laden with hardtack that had traveled
the first stages with them had been captured by Cossacks, the other
half had gone on ahead. Not one of those dismounted cavalrymen who had
marched in front of the prisoners was left; they had all
disappeared. The artillery the prisoners had seen in front of them
during the first days was now replaced by Marshal Junot's enormous
baggage train, convoyed by Westphalians. Behind the prisoners came a
cavalry baggage train.

From Vyazma onwards the French army, which had till then moved in
three columns, went on as a single group. The symptoms of disorder
that Pierre had noticed at their first halting place after leaving
Moscow had now reached the utmost limit.

The road along which they moved was bordered on both sides by dead
horses; ragged men who had fallen behind from various regiments
continually changed about, now joining the moving column, now again
lagging behind it.

Several times during the march false alarms had been given and the
soldiers of the escort had raised their muskets, fired, and run
headlong, crushing one another, but had afterwards reassembled and
abused each other for their causeless panic.

These three groups traveling together--the cavalry stores, the
convoy of prisoners, and Junot's baggage train--still constituted a
separate and united whole, though each of the groups was rapidly
melting away.

Of the artillery baggage train which had consisted of a hundred
and twenty wagons, not more than sixty now remained; the rest had been
captured or left behind. Some of Junot's wagons also had been captured
or abandoned. Three wagons had been raided and robbed by stragglers
from Davout's corps. From the talk of the Germans Pierre learned
that a larger guard had been allotted to that baggage train than to
the prisoners, and that one of their comrades, a German soldier, had
been shot by the marshal's own order because a silver spoon
belonging to the marshal had been found in his possession.

The group of prisoners had melted away most of all. Of the three
hundred and thirty men who had set out from Moscow fewer than a
hundred now remained. The prisoners were more burdensome to the escort
than even the cavalry saddles or Junot's baggage. They understood that
the saddles and Junot's spoon might be of some use, but that cold
and hungry soldiers should have to stand and guard equally cold and
hungry Russians who froze and lagged behind on the road (in which case
the order was to shoot them) was not merely incomprehensible but
revolting. And the escort, as if afraid, in the grievous condition
they themselves were in, of giving way to the pity they felt for the
prisoners and so rendering their own plight still worse, treated
them with particular moroseness and severity.

At Dorogobuzh while the soldiers of the convoy, after locking the
prisoners in a stable, had gone off to pillage their own stores,
several of the soldier prisoners tunneled under the wall and ran away,
but were recaptured by the French and shot.

The arrangement adopted when they started, that the officer
prisoners should be kept separate from the rest, had long since been
abandoned. All who could walk went together, and after the third stage
Pierre had rejoined Karataev and the gray-blue bandy-legged dog that
had chosen Karataev for its master.

On the third day after leaving Moscow Karataev again fell ill with
the fever he had suffered from in the hospital in Moscow, and as he
grew gradually weaker Pierre kept away from him. Pierre did not know
why, but since Karataev had begun to grow weaker it had cost him an
effort to go near him. When he did so and heard the subdued moaning
with which Karataev generally lay down at the halting places, and when
he smelled the odor emanating from him which was now stronger than
before, Pierre moved farther away and did not think about him.

While imprisoned in the shed Pierre had learned not with his
intellect but with his whole being, by life itself, that man is
created for happiness, that happiness is within him, in the
satisfaction of simple human needs, and that all unhappiness arises
not from privation but from superfluity. And now during these last
three weeks of the march he had learned still another new, consolatory
truth--that nothing in this world is terrible. He had learned that
as there is no condition in which man can be happy and entirely
free, so there is no condition in which he need be unhappy and lack
freedom. He learned that suffering and freedom have their limits and
that those limits are very near together; that the person in a bed
of roses with one crumpled petal suffered as keenly as he now,
sleeping on the bare damp earth with one side growing chilled while
the other was warming; and that when he had put on tight dancing shoes
he had suffered just as he did now when he walked with bare feet
that were covered with sores--his footgear having long since fallen to
pieces. He discovered that when he had married his wife--of his own
free will as it had seemed to him--he had been no more free than now
when they locked him up at night in a stable. Of all that he himself
subsequently termed his sufferings, but which at the time he
scarcely felt, the worst was the state of his bare, raw, and
scab-covered feet. (The horseflesh was appetizing and nourishing,
the saltpeter flavor of the gunpowder they used instead of salt was
even pleasant; there was no great cold, it was always warm walking
in the daytime, and at night there were the campfires; the lice that
devoured him warmed his body.) The one thing that was at first hard to
bear was his feet.

After the second day's march Pierre, having examined his feet by the
campfire, thought it would be impossible to walk on them; but when
everybody got up he went along, limping, and, when he had warmed up,
walked without feeling the pain, though at night his feet were more
terrible to look at than before. However, he did not look at them now,
but thought of other things.

Only now did Pierre realize the full strength of life in man and the
saving power he has of transferring his attention from one thing to
another, which is like the safety valve of a boiler that allows
superfluous steam to blow off when the pressure exceeds a certain
limit.

He did not see and did not hear how they shot the prisoners who
lagged behind, though more than a hundred perished in that way. He did
not think of Karataev who grew weaker every day and evidently would
soon have to share that fate. Still less did Pierre think about
himself. The harder his position became and the more terrible the
future, the more independent of that position in which he found
himself were the joyful and comforting thoughts, memories, and
imaginings that came to him.





CHAPTER XIII


At midday on the twenty-second of October Pierre was going uphill
along the muddy, slippery road, looking at his feet and at the
roughness of the way. Occasionally he glanced at the familiar crowd
around him and then again at his feet. The former and the latter
were alike familiar and his own. The blue-gray bandy legged dog ran
merrily along the side of the road, sometimes in proof of its
agility and self-satisfaction lifting one hind leg and hopping along
on three, and then again going on all four and rushing to bark at
the crows that sat on the carrion. The dog was merrier and sleeker
than it had been in Moscow. All around lay the flesh of different
animals--from men to horses--in various stages of decomposition; and
as the wolves were kept off by the passing men the dog could eat all
it wanted.

It had been raining since morning and had seemed as if at any moment
it might cease and the sky clear, but after a short break it began
raining harder than before. The saturated road no longer absorbed
the water, which ran along the ruts in streams.

Pierre walked along, looking from side to side, counting his steps
in threes, and reckoning them off on his fingers. Mentally
addressing the rain, he repeated: "Now then, now then, go on! Pelt
harder!"

It seemed to him that he was thinking of nothing, but far down and
deep within him his soul was occupied with something important and
comforting. This something was a most subtle spiritual deduction
from a conversation with Karataev the day before.

At their yesterday's halting place, feeling chilly by a dying
campfire, Pierre had got up and gone to the next one, which was
burning better. There Platon Karataev was sitting covered up--head and
all--with his greatcoat as if it were a vestment, telling the soldiers
in his effective and pleasant though now feeble voice a story Pierre
knew. It was already past midnight, the hour when Karataev was usually
free of his fever and particularly lively. When Pierre reached the
fire and heard Platon's voice enfeebled by illness, and saw his
pathetic face brightly lit up by the blaze, he felt a painful prick at
his heart. His feeling of pity for this man frightened him and he
wished to go away, but there was no other fire, and Pierre sat down,
trying not to look at Platon.

"Well, how are you?" he asked.

"How am I? If we grumble at sickness, God won't grant us death,"
replied Platon, and at once resumed the story he had begun.

"And so, brother," he continued, with a smile on his pale
emaciated face and a particularly happy light in his eyes, "you
see, brother..."

Pierre had long been familiar with that story. Karataev had told
it to him alone some half-dozen times and always with a specially
joyful emotion. But well as he knew it, Pierre now listened to that
tale as to something new, and the quiet rapture Karataev evidently
felt as he told it communicated itself also to Pierre. The story was
of an old merchant who lived a good and God-fearing life with his
family, and who went once to the Nizhni fair with a companion--a
rich merchant.

Having put up at an inn they both went to sleep, and next morning
his companion was found robbed and with his throat cut. A bloodstained
knife was found under the old merchant's pillow. He was tried,
knouted, and his nostrils having been torn off, "all in due form" as
Karataev put it, he was sent to hard labor in Siberia.

"And so, brother" (it was at this point that Pierre came up), "ten
years or more passed by. The old man was living as a convict,
submitting as he should and doing no wrong. Only he prayed to God
for death. Well, one night the convicts were gathered just as we
are, with the old man among them. And they began telling what each was
suffering for, and how they had sinned against God. One told how he
had taken a life, another had taken two, a third had set a house on
fire, while another had simply been a vagrant and had done nothing. So
they asked the old man: 'What are you being punished for, Daddy?'--'I,
my dear brothers,' said he, 'am being punished for my own and other
men's sins. But I have not killed anyone or taken anything that was
not mine, but have only helped my poorer brothers. I was a merchant,
my dear brothers, and had much property. 'And he went on to tell
them all about it in due order. 'I don't grieve for myself,' he
says, 'God, it seems, has chastened me. Only I am sorry for my old
wife and the children,' and the old man began to weep. Now it happened
that in the group was the very man who had killed the other
merchant. 'Where did it happen, Daddy?' he said. 'When, and in what
month?' He asked all about it and his heart began to ache. So he comes
up to the old man like this, and falls down at his feet! 'You are
perishing because of me, Daddy,' he says. 'It's quite true, lads, that
this man,' he says, 'is being tortured innocently and for nothing! I,'
he says, 'did that deed, and I put the knife under your head while you
were asleep. Forgive me, Daddy,' he says, 'for Christ's sake!'"

Karataev paused, smiling joyously as he gazed into the fire, and
he drew the logs together.

"And the old man said, 'God will forgive you, we are all sinners
in His sight. I suffer for my own sins,' and he wept bitter tears.
Well, and what do you think, dear friends?" Karataev continued, his
face brightening more and more with a rapturous smile as if what he
now had to tell contained the chief charm and the whole meaning of his
story: "What do you think, dear fellows? That murderer confessed to
the authorities. 'I have taken six lives,' he says (he was a great
sinner), 'but what I am most sorry for is this old man. Don't let
him suffer because of me.' So he confessed and it was all written down
and the papers sent off in due form. The place was a long way off, and
while they were judging, what with one thing and another, filling in
the papers all in due form--the authorities I mean--time passed. The
affair reached the Tsar. After a while the Tsar's decree came: to
set the merchant free and give him a compensation that had been
awarded. The paper arrived and they began to look for the old man.
'Where is the old man who has been suffering innocently and in vain? A
paper has come from the Tsar!' so they began looking for him," here
Karataev's lower jaw trembled, "but God had already forgiven him--he
was dead! That's how it was, dear fellows!" Karataev concluded and sat
for a long time silent, gazing before him with a smile.

And Pierre's soul was dimly but joyfully filled not by the story
itself but by its mysterious significance: by the rapturous joy that
lit up Karataev's face as he told it, and the mystic significance of
that joy.





CHAPTER XIV


"A vos places!"* suddenly cried a voice.


*"To your places."


A pleasant feeling of excitement and an expectation of something
joyful and solemn was aroused among the soldiers of the convoy and the
prisoners. From all sides came shouts of command, and from the left
came smartly dressed cavalrymen on good horses, passing the
prisoners at a trot. The expression on all faces showed the tension
people feel at the approach of those in authority. The prisoners
thronged together and were pushed off the road. The convoy formed up.

"The Emperor! The Emperor! The Marshal! The Duke!" and hardly had
the sleek cavalry passed, before a carriage drawn by six gray horses
rattled by. Pierre caught a glimpse of a man in a three-cornered hat
with a tranquil look on his handsome, plump, white face. It was one of
the marshals. His eye fell on Pierre's large and striking figure,
and in the expression with which he frowned and looked away Pierre
thought he detected sympathy and a desire to conceal that sympathy.

The general in charge of the stores galloped after the carriage with
a red and frightened face, whipping up his skinny horse. Several
officers formed a group and some soldiers crowded round them. Their
faces all looked excited and worried.

"What did he say? What did he say?" Pierre heard them ask.

While the marshal was passing, the prisoners had huddled together in
a crowd, and Pierre saw Karataev whom he had not yet seen that
morning. He sat in his short overcoat leaning against a birch tree. On
his face, besides the look of joyful emotion it had worn yesterday
while telling the tale of the merchant who suffered innocently,
there was now an expression of quiet solemnity.

Karataev looked at Pierre with his kindly round eyes now filled with
tears, evidently wishing him to come near that he might say
something to him. But Pierre was not sufficiently sure of himself.
He made as if he did not notice that look and moved hastily away.

When the prisoners again went forward Pierre looked round.
Karataev was still sitting at the side of the road under the birch
tree and two Frenchmen were talking over his head. Pierre did not look
round again but went limping up the hill.

From behind, where Karataev had been sitting, came the sound of a
shot. Pierre heard it plainly, but at that moment he remembered that
he had not yet finished reckoning up how many stages still remained to
Smolensk--a calculation he had begun before the marshal went by. And
he again started reckoning. Two French soldiers ran past Pierre, one
of whom carried a lowered and smoking gun. They both looked pale,
and in the expression on their faces--one of them glanced timidly at
Pierre--there was something resembling what he had seen on the face of
the young soldier at the execution. Pierre looked at the soldier and
remembered that, two days before, that man had burned his shirt
while drying it at the fire and how they had laughed at him.

Behind him, where Karataev had been sitting, the dog began to
howl. "What a stupid beast! Why is it howling?" thought Pierre.

His comrades, the prisoner soldiers walking beside him, avoided
looking back at the place where the shot had been fired and the dog
was howling, just as Pierre did, but there was a set look on all their
faces.





CHAPTER XV


The stores, the prisoners, and the marshal's baggage train stopped
at the village of Shamshevo. The men crowded together round the
campfires. Pierre went up to the fire, ate some roast horseflesh,
lay down with his back to the fire, and immediately fell asleep. He
again slept as he had done at Mozhaysk after the battle of Borodino.

Again real events mingled with dreams and again someone, he or
another, gave expression to his thoughts, and even to the same
thoughts that had been expressed in his dream at Mozhaysk.

"Life is everything. Life is God. Everything changes and moves and
that movement is God. And while there is life there is joy in
consciousness of the divine. To love life is to love God. Harder and
more blessed than all else is to love this life in one's sufferings,
in innocent sufferings."

"Karataev!" came to Pierre's mind.

And suddenly he saw vividly before him a long-forgotten, kindly
old man who had given him geography lessons in Switzerland. "Wait a
bit," said the old man, and showed Pierre a globe. This globe was
alive--a vibrating ball without fixed dimensions. Its whole surface
consisted of drops closely pressed together, and all these drops moved
and changed places, sometimes several of them merging into one,
sometimes one dividing into many. Each drop tried to spread out and
occupy as much space as possible, but others striving to do the same
compressed it, sometimes destroyed it, and sometimes merged with it.

"That is life," said the old teacher.

"How simple and clear it is," thought Pierre. "How is it I did not
know it before?"

"God is in the midst, and each drop tries to expand so as to reflect
Him to the greatest extent. And it grows, merges, disappears from
the surface, sinks to the depths, and again emerges. There now,
Karataev has spread out and disappeared. Do you understand, my child?"
said the teacher.

"Do you understand, damn you?" shouted a voice, and Pierre woke up.

He lifted himself and sat up. A Frenchman who had just pushed a
Russian soldier away was squatting by the fire, engaged in roasting
a piece of meat stuck on a ramrod. His sleeves were rolled up and
his sinewy, hairy, red hands with their short fingers deftly turned
the ramrod. His brown morose face with frowning brows was clearly
visible by the glow of the charcoal.

"It's all the same to him," he muttered, turning quickly to a
soldier who stood behind him. "Brigand! Get away!"

And twisting the ramrod he looked gloomily at Pierre, who turned
away and gazed into the darkness. A prisoner, the Russian soldier
the Frenchman had pushed away, was sitting near the fire patting
something with his hand. Looking more closely Pierre recognized the
blue-gray dog, sitting beside the soldier, wagging its tail.

"Ah, he's come?" said Pierre. "And Plat-" he began, but did not
finish.

Suddenly and simultaneously a crowd of memories awoke in his
fancy--of the look Platon had given him as he sat under the tree, of
the shot heard from that spot, of the dog's howl, of the guilty
faces of the two Frenchmen as they ran past him, of the lowered and
smoking gun, and of Karataev's absence at this halt--and he was on the
point of realizing that Karataev had been killed, but just at that
instant, he knew not why, the recollection came to his mind of a
summer evening he had spent with a beautiful Polish lady on the
veranda of his house in Kiev. And without linking up the events of the
day or drawing a conclusion from them, Pierre closed his eyes,
seeing a vision of the country in summertime mingled with memories
of bathing and of the liquid, vibrating globe, and he sank into
water so that it closed over his head.

Before sunrise he was awakened by shouts and loud and rapid
firing. French soldiers were running past him.

"The Cossacks!" one of them shouted, and a moment later a crowd of
Russians surrounded Pierre.

For a long time he could not understand what was happening to him.
All around he heard his comrades sobbing with joy.

"Brothers! Dear fellows! Darlings!" old soldiers exclaimed, weeping,
as they embraced Cossacks and hussars.

The hussars and Cossacks crowded round the prisoners; one offered
them clothes, another boots, and a third bread. Pierre sobbed as he
sat among them and could not utter a word. He hugged the first soldier
who approached him, and kissed him, weeping.

Dolokhov stood at the gate of the ruined house, letting a crowd of
disarmed Frenchmen pass by. The French, excited by all that had
happened, were talking loudly among themselves, but as they passed
Dolokhov who gently switched his boots with his whip and watched
them with cold glassy eyes that boded no good, they became silent.
On the opposite side stood Dolokhov's Cossack, counting the
prisoners and marking off each hundred with a chalk line on the gate.

"How many?" Dolokhov asked the Cossack.

"The second hundred," replied the Cossack.

"Filez, filez!"* Dolokhov kept saying, having adopted this
expression from the French, and when his eyes met those of the
prisoners they flashed with a cruel light.


*"Get along, get along!"


Denisov, bareheaded and with a gloomy face, walked behind some
Cossacks who were carrying the body of Petya Rostov to a hole that had
been dug in the garden.





CHAPTER XVI


After the twenty-eighth of October when the frosts began, the flight
of the French assumed a still more tragic character, with men
freezing, or roasting themselves to death at the campfires, while
carriages with people dressed in furs continued to drive past,
carrying away the property that had been stolen by the Emperor, kings,
and dukes; but the process of the flight and disintegration of the
French army went on essentially as before.

From Moscow to Vyazma the French army of seventy-three thousand
men not reckoning the Guards (who did nothing during the whole war but
pillage) was reduced to thirty-six thousand, though not more than five
thousand had fallen in battle. From this beginning the succeeding
terms of the progression could be determined mathematically. The
French army melted away and perished at the same rate from Moscow to
Vyazma, from Vyazma to Smolensk, from Smolensk to the Berezina, and
from the Berezina to Vilna--independently of the greater or lesser
intensity of the cold, the pursuit, the barring of the way, or any
other particular conditions. Beyond Vyazma the French army instead
of moving in three columns huddled together into one mass, and so went
on to the end. Berthier wrote to his Emperor (we know how far
commanding officers allow themselves to diverge from the truth in
describing the condition of an army) and this is what he said:


I deem it my duty to report to Your Majesty the condition of the
various corps I have had occasion to observe during different stages
of the last two or three days' march. They are almost disbanded.
Scarcely a quarter of the soldiers remain with the standards of
their regiments, the others go off by themselves in different
directions hoping to find food and escape discipline. In general
they regard Smolensk as the place where they hope to recover. During
the last few days many of the men have been seen to throw away their
cartridges and their arms. In such a state of affairs, whatever your
ultimate plans may be, the interest of Your Majesty's service
demands that the army should be rallied at Smolensk and should first
of all be freed from ineffectives, such as dismounted cavalry,
unnecessary baggage, and artillery material that is no longer in
proportion to the present forces. The soldiers, who are worn out
with hunger and fatigue, need these supplies as well as a few days'
rest. Many have died last days on the road or at the bivouacs. This
state of things is continually becoming worse and makes one fear
that unless a prompt remedy is applied the troops will no longer be
under control in case of an engagement.

November 9: twenty miles from Smolensk.


After staggering into Smolensk which seemed to them a promised land,
the French, searching for food, killed one another, sacked their own
stores, and when everything had been plundered fled farther.

They all went without knowing whither or why they were going.
Still less did that genius, Napoleon, know it, for no one issued any
orders to him. But still he and those about him retained their old
habits: wrote commands, letters, reports, and orders of the day;
called one another sire, mon cousin, prince d'Eckmuhl, roi de
Naples, and so on. But these orders and reports were only on paper,
nothing in them was acted upon for they could not be carried out,
and though they entitled one another Majesties, Highnesses, or
Cousins, they all felt that they were miserable wretches who had
done much evil for which they had now to pay. And though they
pretended to be concerned about the army, each was thinking only of
himself and of how to get away quickly and save himself.




CHAPTER XVII


The movements of the Russian and French armies during the campaign
from Moscow back to the Niemen were like those in a game of Russian
blindman's bluff, in which two players are blindfolded and one of them
occasionally rings a little bell to inform the catcher of his
whereabouts. First he rings his bell fearlessly, but when he gets into
a tight place he runs away as quietly as he can, and often thinking to
escape runs straight into his opponent's arms.

At first while they were still moving along the Kaluga road,
Napoleon's armies made their presence known, but later when they
reached the Smolensk road they ran holding the clapper of their bell
tight--and often thinking they were escaping ran right into the
Russians.

Owing to the rapidity of the French flight and the Russian pursuit
and the consequent exhaustion of the horses, the chief means of
approximately ascertaining the enemy's position--by cavalry
scouting--was not available. Besides, as a result of the frequent
and rapid change of position by each army, even what information was
obtained could not be delivered in time. If news was received one
day that the enemy had been in a certain position the day before, by
the third day when something could have been done, that army was
already two days' march farther on and in quite another position.

One army fled and the other pursued. Beyond Smolensk there were
several different roads available for the French, and one would have
thought that during their stay of four days they might have learned
where the enemy was, might have arranged some more advantageous plan
and undertaken something new. But after a four days' halt the mob,
with no maneuvers or plans, again began running along the beaten
track, neither to the right nor to the left but along the old--the
worst--road, through Krasnoe and Orsha.

Expecting the enemy from behind and not in front, the French
separated in their flight and spread out over a distance of
twenty-four hours. In front of them all fled the Emperor, then the
kings, then the dukes. The Russian army, expecting Napoleon to take
the road to the right beyond the Dnieper--which was the only
reasonable thing for him to do--themselves turned to the right and
came out onto the highroad at Krasnoe. And here as in a game of
blindman's buff the French ran into our vanguard. Seeing their enemy
unexpectedly the French fell into confusion and stopped short from the
sudden fright, but then they resumed their flight, abandoning their
comrades who were farther behind. Then for three days separate
portions of the French army--first Murat's (the vice-king's), then
Davout's, and then Ney's--ran, as it were, the gauntlet of the Russian
army. They abandoned one another, abandoned all their heavy baggage,
their artillery, and half their men, and fled, getting past the
Russians by night by making semicircles to the right.

Ney, who came last, had been busying himself blowing up the walls of
Smolensk which were in nobody's way, because despite the unfortunate
plight of the French or because of it, they wished to punish the floor
against which they had hurt themselves. Ney, who had had a corps of
ten thousand men, reached Napoleon at Orsha with only one thousand men
left, having abandoned all the rest and all his cannon, and having
crossed the Dnieper at night by stealth at a wooded spot.

From Orsha they fled farther along the road to Vilna, still
playing at blindman's buff with the pursuing army. At the Berezina
they again became disorganized, many were drowned and many
surrendered, but those who got across the river fled farther. Their
supreme chief donned a fur coat and, having seated himself in a
sleigh, galloped on alone, abandoning his companions. The others who
could do so drove away too, leaving those who could not to surrender
or die.





CHAPTER XVIII


This campaign consisted in a flight of the French during which
they did all they could to destroy themselves. From the time they
turned onto the Kaluga road to the day their leader fled from the
army, none of the movements of the crowd had any sense. So one might
have thought that regarding this period of the campaign the
historians, who attributed the actions of the mass to the will of
one man, would have found it impossible to make the story of the
retreat fit their theory. But no! Mountains of books have been written
by the historians about this campaign, and everywhere are described
Napoleon's arrangements, the maneuvers, and his profound plans which
guided the army, as well as the military genius shown by his marshals.

The retreat from Malo-Yaroslavets when he had a free road into a
well-supplied district and the parallel road was open to him along
which Kutuzov afterwards pursued him--this unnecessary retreat along a
devastated road--is explained to us as being due to profound
considerations. Similarly profound considerations are given for his
retreat from Smolensk to Orsha. Then his heroism at Krasnoe is
described, where he is reported to have been prepared to accept battle
and take personal command, and to have walked about with a birch stick
and said:

"J'ai assez fait l'empereur; il est temps de faire le general,"* but
nevertheless immediately ran away again, abandoning to its fate the
scattered fragments of the army he left behind.


*"I have acted the Emperor long enough; it is time to act the
general."


Then we are told of the greatness of soul of the marshals,
especially of Ney--a greatness of soul consisting in this: that he
made his way by night around through the forest and across the Dnieper
and escaped to Orsha, abandoning standards, artillery, and nine tenths
of his men.

And lastly, the final departure of the great Emperor from his heroic
army is presented to us by the historians as something great and
characteristic of genius. Even that final running away, described in
ordinary language as the lowest depth of baseness which every child is
taught to be ashamed of--even that act finds justification in the
historians' language.

When it is impossible to stretch the very elastic threads of
historical ratiocination any farther, when actions are clearly
contrary to all that humanity calls right or even just, the historians
produce a saving conception of "greatness." "Greatness," it seems,
excludes the standards of right and wrong. For the "great" man nothing
is wrong, there is no atrocity for which a "great" man can be blamed.

"C'est grand!"* say the historians, and there no longer exists
either good or evil but only "grand" and "not grand." Grand is good,
not grand is bad. Grand is the characteristic, in their conception, of
some special animals called "heroes." And Napoleon, escaping home in a
warm fur coat and leaving to perish those who were not merely his
comrades but were (in his opinion) men he had brought there, feels que
c'est grand,*[2] and his soul is tranquil.


*"It is great."

*[2] That it is great.


"Du sublime (he saw something sublime in himself) au ridicule il n'y
a qu'un pas,"* said he. And the whole world for fifty years has been
repeating: "Sublime! Grand! Napoleon le Grand!" Du sublime au ridicule
il n'y a qu'un pas.


*"From the sublime to the ridiculous is but a step."


And it occurs to no one that to admit a greatness not
commensurable with the standard of right and wrong is merely to
admit one's own nothingness and immeasurable meanness.

For us with the standard of good and evil given us by Christ, no
human actions are incommensurable. And there is no greatness where
simplicity, goodness, and truth are absent.





CHAPTER XIX


What Russian, reading the account of the last part of the campaign
of 1812, has not experienced an uncomfortable feeling of regret,
dissatisfaction, and perplexity? Who has not asked himself how it is
that the French were not all captured or destroyed when our three
armies surrounded them in superior numbers, when the disordered
French, hungry and freezing, surrendered in crowds, and when (as the
historians relate) the aim of the Russians was to stop the French,
to cut them off, and capture them all?

How was it that the Russian army, which when numerically weaker than
the French had given battle at Borodino, did not achieve its purpose
when it had surrounded the French on three sides and when its aim
was to capture them? Can the French be so enormously superior to us
that when we had surrounded them with superior forces we could not
beat them? How could that happen?

History (or what is called by that name) replying to these questions
says that this occurred because Kutuzov and Tormasov and Chichagov,
and this man and that man, did not execute such and such maneuvers...

But why did they not execute those maneuvers? And why if they were
guilty of not carrying out a prearranged plan were they not tried
and punished? But even if we admitted that Kutuzov, Chichagov, and
others were the cause of the Russian failures, it is still
incomprehensible why, the position of the Russian army being what it
was at Krasnoe and at the Berezina (in both cases we had superior
forces), the French army with its marshals, kings, and Emperor was not
captured, if that was what the Russians aimed at.

The explanation of this strange fact given by Russian military
historians (to the effect that Kutuzov hindered an attack) is
unfounded, for we know that he could not restrain the troops from
attacking at Vyazma and Tarutino.

Why was the Russian army--which with inferior forces had withstood
the enemy in full strength at Borodino--defeated at Krasnoe and the
Berezina by the disorganized crowds of the French when it was
numerically superior?

If the aim of the Russians consisted in cutting off and capturing
Napoleon and his marshals--and that aim was not merely frustrated
but all attempts to attain it were most shamefully baffled--then
this last period of the campaign is quite rightly considered by the
French to be a series of victories, and quite wrongly considered
victorious by Russian historians.

The Russian military historians in so far as they submit to claims
of logic must admit that conclusion, and in spite of their lyrical
rhapsodies about valor, devotion, and so forth, must reluctantly admit
that the French retreat from Moscow was a series of victories for
Napoleon and defeats for Kutuzov.

But putting national vanity entirely aside one feels that such a
conclusion involves a contradiction, since the series of French
victories brought the French complete destruction, while the series of
Russian defeats led to the total destruction of their enemy and the
liberation of their country.

The source of this contradiction lies in the fact that the
historians studying the events from the letters of the sovereigns
and the generals, from memoirs, reports, projects, and so forth,
have attributed to this last period of the war of 1812 an aim that
never existed, namely that of cutting off and capturing Napoleon
with his marshals and his army.

There never was or could have been such an aim, for it would have
been senseless and its attainment quite impossible.

It would have been senseless, first because Napoleon's
disorganized army was flying from Russia with all possible speed, that
is to say, was doing just what every Russian desired. So what was
the use of performing various operations on the French who were
running away as fast as they possibly could?

Secondly, it would have been senseless to block the passage of men
whose whole energy was directed to flight.

Thirdly, it would have been senseless to sacrifice one's own
troops in order to destroy the French army, which without external
interference was destroying itself at such a rate that, though its
path was not blocked, it could not carry across the frontier more than
it actually did in December, namely a hundredth part of the original
army.

Fourthly, it would have been senseless to wish to take captive the
Emperor, kings, and dukes--whose capture would have been in the
highest degree embarrassing for the Russians, as the most adroit
diplomatists of the time (Joseph de Maistre and others) recognized.
Still more senseless would have been the wish to capture army corps of
the French, when our own army had melted away to half before
reaching Krasnoe and a whole division would have been needed to convoy
the corps of prisoners, and when our men were not always getting
full rations and the prisoners already taken were perishing of hunger.

All the profound plans about cutting off and capturing Napoleon
and his army were like the plan of a market gardener who, when driving
out of his garden a cow that had trampled down the beds he had
planted, should run to the gate and hit the cow on the head. The
only thing to be said in excuse of that gardener would be that he
was very angry. But not even that could be said for those who drew
up this project, for it was not they who had suffered from the
trampled beds.

But besides the fact that cutting off Napoleon with his army would
have been senseless, it was impossible.

It was impossible first because--as experience shows that a
three-mile movement of columns on a battlefield never coincides with
the plans--the probability of Chichagov, Kutuzov, and Wittgenstein
effecting a junction on time at an appointed place was so remote as to
be tantamount to impossibility, as in fact thought Kutuzov, who when
he received the plan remarked that diversions planned over great
distances do not yield the desired results.

Secondly it was impossible, because to paralyze the momentum with
which Napoleon's army was retiring, incomparably greater forces than
the Russians possessed would have been required.

Thirdly it was impossible, because the military term "to cut off"
has no meaning. One can cut off a slice of bread, but not an army.
To cut off an army--to bar its road--is quite impossible, for there is
always plenty of room to avoid capture and there is the night when
nothing can be seen, as the military scientists might convince
themselves by the example of Krasnoe and of the Berezina. It is only
possible to capture prisoners if they agree to be captured, just as it
is only possible to catch a swallow if it settles on one's hand. Men
can only be taken prisoners if they surrender according to the rules
of strategy and tactics, as the Germans did. But the French troops
quite rightly did not consider that this suited them, since death by
hunger and cold awaited them in flight or captivity alike.

Fourthly and chiefly it was impossible, because never since the
world began has a war been fought under such conditions as those
that obtained in 1812, and the Russian army in its pursuit of the
French strained its strength to the utmost and could not have done
more without destroying itself.

During the movement of the Russian army from Tarutino to Krasnoe
it lost fifty thousand sick or stragglers, that is a number equal to
the population of a large provincial town. Half the men fell out of
the army without a battle.

And it is of this period of the campaign--when the army lacked boots
and sheepskin coats, was short of provisions and without vodka, and
was camping out at night for months in the snow with fifteen degrees
of frost, when there were only seven or eight hours of daylight and
the rest was night in which the influence of discipline cannot be
maintained, when men were taken into that region of death where
discipline fails, not for a few hours only as in a battle, but for
months, where they were every moment fighting death from hunger and
cold, when half the army perished in a single month--it is of this
period of the campaign that the historians tell us how Miloradovich
should have made a flank march to such and such a place, Tormasov to
another place, and Chichagov should have crossed (more than
knee-deep in snow) to somewhere else, and how so-and-so "routed" and
"cut off" the French and so on and so on.

The Russians, half of whom died, did all that could and should
have been done to attain an end worthy of the nation, and they are not
to blame because other Russians, sitting in warm rooms, proposed
that they should do what was impossible.

All that strange contradiction now difficult to understand between
the facts and the historical accounts only arises because the
historians dealing with the matter have written the history of the
beautiful words and sentiments of various generals, and not the
history of the events.

To them the words of Miloradovich seem very interesting, and so do
their surmises and the rewards this or that general received; but
the question of those fifty thousand men who were left in hospitals
and in graves does not even interest them, for it does not come within
the range of their investigation.

Yet one need only discard the study of the reports and general plans
and consider the movement of those hundreds of thousands of men who
took a direct part in the events, and all the questions that seemed
insoluble easily and simply receive an immediate and certain solution.

The aim of cutting off Napoleon and his army never existed except in
the imaginations of a dozen people. It could not exist because it
was senseless and unattainable.

The people had a single aim: to free their land from invasion.
That aim was attained in the first place of itself, as the French
ran away, and so it was only necessary not to stop their flight.
Secondly it was attained by the guerrilla warfare which was destroying
the French, and thirdly by the fact that a large Russian army was
following the French, ready to use its strength in case their movement
stopped.

The Russian army had to act like a whip to a running animal. And the
experienced driver knew it was better to hold the whip raised as a
menace than to strike the running animal on the head.





BOOK FIFTEEN: 1812 --13





CHAPTER I


When seeing a dying animal a man feels a sense of horror:
substance similar to his own is perishing before his eyes. But when it
is a beloved and intimate human being that is dying, besides this
horror at the extinction of life there is a severance, a spiritual
wound, which like a physical wound is sometimes fatal and sometimes
heals, but always aches and shrinks at any external irritating touch.

After Prince Andrew's death Natasha and Princess Mary alike felt
this. Drooping in spirit and closing their eyes before the menacing
cloud of death that overhung them, they dared not look life in the
face. They carefully guarded their open wounds from any rough and
painful contact. Everything: a carriage passing rapidly in the street,
a summons to dinner, the maid's inquiry what dress to prepare, or
worse still any word of insincere or feeble sympathy, seemed an
insult, painfully irritated the wound, interrupting that necessary
quiet in which they both tried to listen to the stern and dreadful
choir that still resounded in their imagination, and hindered their
gazing into those mysterious limitless vistas that for an instant
had opened out before them.

Only when alone together were they free from such outrage and
pain. They spoke little even to one another, and when they did it
was of very unimportant matters.

Both avoided any allusion to the future. To admit the possibility of
a future seemed to them to insult his memory. Still more carefully did
they avoid anything relating to him who was dead. It seemed to them
that what they had lived through and experienced could not be
expressed in words, and that any reference to the details of his
life infringed the majesty and sacredness of the mystery that had been
accomplished before their eyes.

Continued abstention from speech, and constant avoidance of
everything that might lead up to the subject--this halting on all
sides at the boundary of what they might not mention--brought before
their minds with still greater purity and clearness what they were
both feeling.

But pure and complete sorrow is as impossible as pure and complete
joy. Princess Mary, in her position as absolute and independent
arbiter of her own fate and guardian and instructor of her nephew, was
the first to be called back to life from that realm of sorrow in which
she had dwelt for the first fortnight. She received letters from her
relations to which she had to reply; the room in which little Nicholas
had been put was damp and he began to cough; Alpatych came to
Yaroslavl with reports on the state of their affairs and with advice
and suggestions that they should return to Moscow to the house on
the Vozdvizhenka Street, which had remained uninjured and needed
only slight repairs. Life did not stand still and it was necessary
to live. Hard as it was for Princess Mary to emerge from the realm
of secluded contemplation in which she had lived till then, and
sorry and almost ashamed as she felt to leave Natasha alone, yet the
cares of life demanded her attention and she involuntarily yielded
to them. She went through the accounts with Alpatych, conferred with
Dessalles about her nephew, and gave orders and made preparations
for the journey to Moscow.

Natasha remained alone and, from the time Princess Mary began making
preparations for departure, held aloof from her too.

Princess Mary asked the countess to let Natasha go with her to
Moscow, and both parents gladly accepted this offer, for they saw
their daughter losing strength every day and thought that a change
of scene and the advice of Moscow doctors would be good for her.

"I am not going anywhere," Natasha replied when this was proposed to
her. "Do please just leave me alone!" And she ran out of the room,
with difficulty refraining from tears of vexation and irritation
rather than of sorrow.

After she felt herself deserted by Princes Mary and alone in her
grief, Natasha spent most of the time in her room by herself,
sitting huddled up feet and all in the corner of the sofa, tearing and
twisting something with her slender nervous fingers and gazing
intently and fixedly at whatever her eyes chanced to fall on. This
solitude exhausted and tormented her but she was in absolute need of
it. As soon as anyone entered she got up quickly, changed her position
and expression, and picked up a book or some sewing, evidently waiting
impatiently for the intruder to go.

She felt all the time as if she might at any moment penetrate that
on which--with a terrible questioning too great for her strength-
her spiritual gaze was fixed.

One day toward the end of December Natasha, pale and thin, dressed
in a black woolen gown, her plaited hair negligently twisted into a
knot, was crouched feet and all in the corner of her sofa, nervously
crumpling and smoothing out the end of her sash while she looked at
a corner of the door.

She was gazing in the direction in which he had gone--to the other
side of life. And that other side of life, of which she had never
before thought and which had formerly seemed to her so far away and
improbable, was now nearer and more akin and more comprehensible
than this side of life, where everything was either emptiness and
desolation or suffering and indignity.

She was gazing where she knew him to be; but she could not imagine
him otherwise than as he had been here. She now saw him again as he
had been at Mytishchi, at Troitsa, and at Yaroslavl.

She saw his face, heard his voice, repeated his words and her own,
and sometimes devised other words they might have spoken.

There he is lying back in an armchair in his velvet cloak, leaning
his head on his thin pale hand. His chest is dreadfully hollow and his
shoulders raised. His lips are firmly closed, his eyes glitter, and
a wrinkle comes and goes on his pale forehead. One of his legs
twitches just perceptibly, but rapidly. Natasha knows that he is
struggling with terrible pain. "What is that pain like? Why does he
have that pain? What does he feel? How does it hurt him?" thought
Natasha. He noticed her watching him, raised his eyes, and began to
speak seriously:

"One thing would be terrible," said he: "to bind oneself forever
to a suffering man. It would be continual torture." And he looked
searchingly at her. Natasha as usual answered before she had time to
think what she would say. She said: "This can't go on--it won't. You
will get well--quite well."

She now saw him from the commencement of that scene and relived what
she had then felt. She recalled his long sad and severe look at
those words and understood the meaning of the rebuke and despair in
that protracted gaze.

"I agreed," Natasha now said to herself, "that it would be
dreadful if he always continued to suffer. I said it then only because
it would have been dreadful for him, but he understood it differently.
He thought it would be dreadful for me. He then still wished to live
and feared death. And I said it so awkwardly and stupidly! I did not
say what I meant. I thought quite differently. Had I said what I
thought, I should have said: even if he had to go on dying, to die
continually before my eyes, I should have been happy compared with
what I am now. Now there is nothing... nobody. Did he know that? No,
he did not and never will know it. And now it will never, never be
possible to put it right." And now he again seemed to be saying the
same words to her, only in her imagination Natasha this time gave
him a different answer. She stopped him and said: "Terrible for you,
but not for me! You know that for me there is nothing in life but you,
and to suffer with you is the greatest happiness for me," and he
took her hand and pressed it as he had pressed it that terrible
evening four days before his death. And in her imagination she said
other tender and loving words which she might have said then but
only spoke now: "I love thee!... thee! I love, love..." she said,
convulsively pressing her hands and setting her teeth with a desperate
effort...

She was overcome by sweet sorrow and tears were already rising in
her eyes; then she suddenly asked herself to whom she was saying this.
Again everything was shrouded in hard, dry perplexity, and again
with a strained frown she peered toward the world where he was. And
now, now it seemed to her she was penetrating the mystery.... But at
the instant when it seemed that the incomprehensible was revealing
itself to her a loud rattle of the door handle struck painfully on her
ears. Dunyasha, her maid, entered the room quickly and abruptly with a
frightened look on her face and showing no concern for her mistress.

"Come to your Papa at once, please!" said she with a strange,
excited look. "A misfortune... about Peter Ilynich... a letter," she
finished with a sob.





CHAPTER II


Besides a feeling of aloofness from everybody Natasha was feeling
a special estrangement from the members of her own family. All of
them--her father, mother, and Sonya--were so near to her, so familiar,
so commonplace, that all their words and feelings seemed an insult
to the world in which she had been living of late, and she felt not
merely indifferent to them but regarded them with hostility. She heard
Dunyasha's words about Peter Ilynich and a misfortune, but did not
grasp them.

"What misfortune? What misfortune can happen to them? They just live
their own old, quiet, and commonplace life," thought Natasha.

As she entered the ballroom her father was hurriedly coming out of
her mother's room. His face was puckered up and wet with tears. He had
evidently run out of that room to give vent to the sobs that were
choking him. When he saw Natasha he waved his arms despairingly and
burst into convulsively painful sobs that distorted his soft round
face.

"Pe... Petya... Go, go, she... is calling..." and weeping like a
child and quickly shuffling on his feeble legs to a chair, he almost
fell into it, covering his face with his hands.

Suddenly an electric shock seemed to run through Natasha's whole
being. Terrible anguish struck her heart, she felt a dreadful ache
as if something was being torn inside her and she were dying. But
the pain was immediately followed by a feeling of release from the
oppressive constraint that had prevented her taking part in life.
The sight of her father, the terribly wild cries of her mother that
she heard through the door, made her immediately forget herself and
her own grief.

She ran to her father, but he feebly waved his arm, pointing to
her mother's door. Princess Mary, pale and with quivering chin, came
out from that room and taking Natasha by the arm said something to
her. Natasha neither saw nor heard her. She went in with rapid
steps, pausing at the door for an instant as if struggling with
herself, and then ran to her mother.

The countess was lying in an armchair in a strange and awkward
position, stretching out and beating her head against the wall.
Sonya and the maids were holding her arms.

"Natasha! Natasha!..." cried the countess. "It's not true... it's
not true... He's lying... Natasha!" she shrieked, pushing those around
her away. "Go away, all of you; it's not true! Killed!... ha, ha,
ha!... It's not true!"

Natasha put one knee on the armchair, stooped over her mother,
embraced her, and with unexpected strength raised her, turned her face
toward herself, and clung to her.

"Mummy!... darling!... I am here, my dearest Mummy," she kept on
whispering, not pausing an instant.

She did not let go of her mother but struggled tenderly with her,
demanded a pillow and hot water, and unfastened and tore open her
mother's dress.

"My dearest darling... Mummy, my precious!..." she whispered
incessantly, kissing her head, her hands, her face, and feeling her
own irrepressible and streaming tears tickling her nose and cheeks.

The countess pressed her daughter's hand, closed her eyes, and
became quiet for a moment. Suddenly she sat up with unaccustomed
swiftness, glanced vacantly around her, and seeing Natasha began to
press her daughter's head with all her strength. Then she turned
toward her daughter's face which was wincing with pain and gazed
long at it.

"Natasha, you love me?" she said in a soft trustful whisper.
"Natasha, you would not deceive me? You'll tell me the whole truth?"

Natasha looked at her with eyes full of tears and in her look
there was nothing but love and an entreaty for forgiveness.

"My darling Mummy!" she repeated, straining all the power of her
love to find some way of taking on herself the excess of grief that
crushed her mother.

And again in a futile struggle with reality her mother, refusing
to believe that she could live when her beloved boy was killed in
the bloom of life, escaped from reality into a world of delirium.

Natasha did not remember how that day passed nor that night, nor the
next day and night. She did not sleep and did not leave her mother.
Her persevering and patient love seemed completely to surround the
countess every moment, not explaining or consoling, but recalling
her to life.

During the third night the countess kept very quiet for a few
minutes, and Natasha rested her head on the arm of her chair and
closed her eyes, but opened them again on hearing the bedstead
creak. The countess was sitting up in bed and speaking softly.

"How glad I am you have come. You are tired. Won't you have some
tea?" Natasha went up to her. "You have improved in looks and grown
more manly," continued the countess, taking her daughter's hand.

"Mamma! What are you saying..."

"Natasha, he is no more, no more!"

And embracing her daughter, the countess began to weep for the first
time.





CHAPTER III


Princess Mary postponed her departure. Sonya and the count tried
to replace Natasha but could not. They saw that she alone was able
to restrain her mother from unreasoning despair. For three weeks
Natasha remained constantly at her mother's side, sleeping on a lounge
chair in her room, making her eat and drink, and talking to her
incessantly because the mere sound of her tender, caressing tones
soothed her mother.

The mother's wounded spirit could not heal. Petya's
death had torn from her half her life. When the news of Petya's
death had come she had been a fresh and vigorous woman of fifty, but a
month later she left her room a listless old woman taking no
interest in life. But the same blow that almost killed the countess,
this second blow, restored Natasha to life.

A spiritual wound produced by a rending of the spiritual body is
like a physical wound and, strange as it may seem, just as a deep
wound may heal and its edges join, physical and spiritual wounds alike
can yet heal completely only as the result of a vital force from
within.

Natasha's wound healed in that way. She thought her life was
ended, but her love for her mother unexpectedly showed her that the
essence of life--love--was still active within her. Love awoke and
so did life.

Prince Andrew's last days had bound Princess Mary and Natasha
together; this new sorrow brought them still closer to one another.
Princess Mary put off her departure, and for three weeks looked
after Natasha as if she had been a sick child. The last weeks passed
in her mother's bedroom had strained Natasha's physical strength.

One afternoon noticing Natasha shivering with fever, Princess Mary
took her to her own room and made her lie down on the bed. Natasha lay
down, but when Princess Mary had drawn the blinds and was going away
she called her back.

"I don't want to sleep, Mary, sit by me a little."

"You are tired--try to sleep."

"No, no. Why did you bring me away? She will be asking for me."

"She is much better. She spoke so well today," said Princess Mary.

Natasha lay on the bed and in the semidarkness of the room scanned
Princess Mary's face.

"Is she like him?" thought Natasha. "Yes, like and yet not like. But
she is quite original, strange, new, and unknown. And she loves me.
What is in her heart? All that is good. But how? What is her mind
like? What does she think about me? Yes, she is splendid!"

"Mary," she said timidly, drawing Princess Mary's hand to herself,
"Mary, you mustn't think me wicked. No? Mary darling, how I love
you! Let us be quite, quite friends."

And Natasha, embracing her, began kissing her face and hands, making
Princess Mary feel shy but happy by this demonstration of her
feelings.

From that day a tender and passionate friendship such as exists only
between women was established between Princess Mary and Natasha.
They were continually kissing and saying tender things to one
another and spent most of their time together. When one went out the
other became restless and hastened to rejoin her. Together they felt
more in harmony with one another than either of them felt with herself
when alone. A feeling stronger than friendship sprang up between them;
an exclusive feeling of life being possible only in each other's
presence.

Sometimes they were silent for hours; sometimes after they were
already in bed they would begin talking and go on till morning. They
spoke most of what was long past. Princess Mary spoke of her
childhood, of her mother, her father, and her daydreams; and
Natasha, who with a passive lack of understanding had formerly
turned away from that life of devotion, submission, and the poetry
of Christian self-sacrifice, now feeling herself bound to Princess
Mary by affection, learned to love her past too and to understand a
side of life previously incomprehensible to her. She did not think
of applying submission and self-abnegation to her own life, for she
was accustomed to seek other joys, but she understood and loved in
another those previously incomprehensible virtues. For Princess
Mary, listening to Natasha's tales of childhood and early youth, there
also opened out a new and hitherto uncomprehended side of life: belief
in life and its enjoyment.

Just as before, they never mentioned him so as not to lower (as they
thought) their exalted feelings by words; but this silence about him
had the effect of making them gradually begin to forget him without
being conscious of it.

Natasha had grown thin and pale and physically so weak that they all
talked about her health, and this pleased her. But sometimes she was
suddenly overcome by fear not only of death but of sickness, weakness,
and loss of good looks, and involuntarily she examined her bare arm
carefully, surprised at its thinness, and in the morning noticed her
drawn and, as it seemed to her, piteous face in her glass. It seemed
to her that things must be so, and yet it was dreadfully sad.

One day she went quickly upstairs and found herself out of breath.
Unconsciously she immediately invented a reason for going down, and
then, testing her strength, ran upstairs again, observing the result.

Another time when she called Dunyasha her voice trembled, so she
called again--though she could hear Dunyasha coming--called her in the
deep chest tones in which she had been wont to sing, sing, and
listened attentively to herself.

She did not know and would not have believed it, but beneath the
layer of slime that covered her soul and seemed to her impenetrable,
delicate young shoots of grass were already sprouting, which taking
root would so cover with their living verdure the grief that weighed
her down that it would soon no longer be seen or noticed. The wound
had begun to heal from within.

At the end of January Princess Mary left for Moscow, and the count
insisted on Natasha's going with her to consult the doctors.





CHAPTER IV


After the encounter at Vyazma, where Kutuzov had been unable to hold
back his troops in their anxiety to overwhelm and cut off the enemy
and so on, the farther movement of the fleeing French, and of the
Russians who pursued them, continued as far as Krasnoe without a
battle. The flight was so rapid that the Russian army pursuing the
French could not keep up with them; cavalry and artillery horses broke
down, and the information received of the movements of the French
was never reliable.

The men in the Russian army were so worn out by this continuous
marching at the rate of twenty-seven miles a day that they could not
go any faster.

To realize the degree of exhaustion of the Russian army it is only
necessary to grasp clearly the meaning of the fact that, while not
losing more than five thousand killed and wounded after Tarutino and
less than a hundred prisoners, the Russian army which left that
place a hundred thousand strong reached Krasnoe with only fifty
thousand.

The rapidity of the Russian pursuit was just as destructive to our
army as the flight of the French was to theirs. The only difference
was that the Russian army moved voluntarily, with no such threat of
destruction as hung over the French, and that the sick Frenchmen
were left behind in enemy hands while the sick Russians left behind
were among their own people. The chief cause of the wastage of
Napoleon's army was the rapidity of its movement, and a convincing
proof of this is the corresponding decrease of the Russian army.

Kutuzov as far as was in his power, instead of trying to check the
movement of the French as was desired in Petersburg and by the Russian
army generals, directed his whole activity here, as he had done at
Tarutino and Vyazma, to hastening it on while easing the movement of
our army.

But besides this, since the exhaustion and enormous diminution of
the army caused by the rapidity of the advance had become evident,
another reason for slackening the pace and delaying presented itself
to Kutuzov. The aim of the Russian army was to pursue the French.
The road the French would take was unknown, and so the closer our
troops trod on their heels the greater distance they had to cover.
Only by following at some distance could one cut across the zigzag
path of the French. All the artful maneuvers suggested by our generals
meant fresh movements of the army and a lengthening of its marches,
whereas the only reasonable aim was to shorten those marches. To
that end Kutuzov's activity was directed during the whole campaign
from Moscow to Vilna--not casually or intermittently but so
consistently that he never once deviated from it.

Kutuzov felt and knew--not by reasoning or science but with the
whole of his Russian being--what every Russian soldier felt: that
the French were beaten, that the enemy was flying and must be driven
out; but at the same time he like the soldiers realized all the
hardship of this march, the rapidity of which was unparalleled for
such a time of the year.

But to the generals, especially the foreign ones in the Russian
army, who wished to distinguish themselves, to astonish somebody,
and for some reason to capture a king or a duke--it seemed that now-
when any battle must be horrible and senseless--was the very time to
fight and conquer somebody. Kutuzov merely shrugged his shoulders when
one after another they presented projects of maneuvers to be made with
those soldiers--ill-shod, insufficiently clad, and half starved--who
within a month and without fighting a battle had dwindled to half
their number, and who at the best if the flight continued would have
to go a greater distance than they had already traversed, before
they reached the frontier.

This longing to distinguish themselves, to maneuver, to overthrow,
and to cut off showed itself particularly whenever the Russians
stumbled on the French army.

So it was at Krasnoe, where they expected to find one of the three
French columns and stumbled instead on Napoleon himself with sixteen
thousand men. Despite all Kutuzov's efforts to avoid that ruinous
encounter and to preserve his troops, the massacre of the broken mob
of French soldiers by worn-out Russians continued at Krasnoe for three
days.

Toll wrote a disposition: "The first column will march to so and
so," etc. And as usual nothing happened in accord with the
disposition. Prince Eugene of Wurttemberg fired from a hill over the
French crowds that were running past, and demanded reinforcements
which did not arrive. The French, avoiding the Russians, dispersed and
hid themselves in the forest by night, making their way round as
best they could, and continued their flight.

Miloradovich, who said he did not want to know anything about the
commissariat affairs of his detachment, and could never be found
when he was wanted--that chevalier sans peur et sans reproche* as he
styled himself--who was fond of parleys with the French, sent envoys
demanding their surrender, wasted time, and did not do what he was
ordered to do.


*Knight without fear and without reproach.


"I give you that column, lads," he said, riding up to the troops and
pointing out the French to the cavalry.

And the cavalry, with spurs and sabers urging on horses that could
scarcely move, trotted with much effort to the column presented to
them--that is to say, to a crowd of Frenchmen stark with cold,
frost-bitten, and starving--and the column that had been presented
to them threw down its arms and surrendered as it had long been
anxious to do.

At Krasnoe they took twenty-six thousand prisoners, several
hundred cannon, and a stick called a "marshal's staff," and disputed
as to who had distinguished himself and were pleased with their
achievement--though they much regretted not having taken Napoleon,
or at least a marshal or a hero of some sort, and reproached one
another and especially Kutuzov for having failed to do so.

These men, carried away by their passions, were but blind tools of
the most melancholy law of necessity, but considered themselves heroes
and imagined that they were accomplishing a most noble and honorable
deed. They blamed Kutuzov and said that from the very beginning of the
campaign he had prevented their vanquishing Napoleon, that he
thought nothing but satisfying his passions and would not advance from
the Linen Factories because he was comfortable there, that at
Krasnoe he checked the advance because on learning that Napoleon was
there he had quite lost his head, and that it was probable that he had
an understanding with Napoleon and had been bribed by him, and so
on, and so on.

Not only did his contemporaries, carried away by their passions,
talk in this way, but posterity and history have acclaimed Napoleon as
grand, while Kutuzov is described by foreigners as a crafty,
dissolute, weak old courtier, and by Russians as something indefinite-
a sort of puppet useful only because he had a Russian name.





CHAPTER V


In 1812 and 1813 Kutuzov was openly accused of blundering. The
Emperor was dissatisfied with him. And in a history recently written
by order of the Highest Authorities it is said that Kutuzov was a
cunning court liar, frightened of the name of Napoleon, and that by
his blunders at Krasnoe and the Berezina he deprived the Russian
army of the glory of complete victory over the French.*


*History of the year 1812. The character of Kutuzov and
reflections on the unsatisfactory results of the battles at Krasnoe,
by Bogdanovich.


Such is the fate not of great men (grands hommes) whom the Russian
mind does not acknowledge, but of those rare and always solitary
individuals who, discerning the will of Providence, submit their
personal will to it. The hatred and contempt of the crowd punish
such men for discerning the higher laws.

For Russian historians, strange and terrible to say, Napoleon-
that most insignificant tool of history who never anywhere, even in
exile, showed human dignity--Napoleon is the object of adulation and
enthusiasm; he is grand. But Kutuzov--the man who from the beginning
to the end of his activity in 1812, never once swerving by word or
deed from Borodino to Vilna, presented an example exceptional in
history of self-sacrifice and a present consciousness of the future
importance of what was happening--Kutuzov seems to them something
indefinite and pitiful, and when speaking of him and of the year
1812 they always seem a little ashamed.

And yet it is difficult to imagine an historical character whose
activity was so unswervingly directed to a single aim; and it would be
difficult to imagine any aim more worthy or more consonant with the
will of the whole people. Still more difficult would it be to find
an instance in history of the aim of an historical personage being
so completely accomplished as that to which all Kutuzov's efforts were
directed in 1812.

Kutuzov never talked of "forty centuries looking down from the
Pyramids," of the sacrifices he offered for the fatherland, or of what
he intended to accomplish or had accomplished; in general he said
nothing about himself, adopted no prose, always appeared to be the
simplest and most ordinary of men, and said the simplest and most
ordinary things. He wrote letters to his daughters and to Madame de
Stael, read novels, liked the society of pretty women, jested with
generals, officers, and soldiers, and never contradicted those who
tried to prove anything to him. When Count Rostopchin at the Yauza
bridge galloped up to Kutuzov with personal reproaches for having
caused the destruction of Moscow, and said: "How was it you promised
not to abandon Moscow without a battle?" Kutuzov replied: "And I shall
not abandon Moscow without a battle," though Moscow was then already
abandoned. When Arakcheev, coming to him from the Emperor, said that
Ermolov ought to be appointed chief of the artillery, Kutuzov replied:
"Yes, I was just saying so myself," though a moment before he had said
quite the contrary. What did it matter to him--who then alone amid a
senseless crowd understood the whole tremendous significance of what
was happening--what did it matter to him whether Rostopchin attributed
the calamities of Moscow to him or to himself? Still less could it
matter to him who was appointed chief of the artillery.

Not merely in these cases but continually did that old man--who by
experience of life had reached the conviction that thoughts and the
words serving as their expression are not what move people--use
quite meaningless words that happened to enter his head.

But that man, so heedless of his words, did not once during the
whole time of his activity utter one word inconsistent with the single
aim toward which he moved throughout the whole war. Obviously in spite
of himself, in very diverse circumstances, he repeatedly expressed his
real thoughts with the bitter conviction that he would not be
understood. Beginning with the battle of Borodino, from which time his
disagreement with those about him began, he alone said that the battle
of Borodino was a victory, and repeated this both verbally and in
his dispatches and reports up to the time of his death. He alone
said that the loss of Moscow is not the loss of Russia. In reply to
Lauriston's proposal of peace, he said: There can be no peace, for
such is the people's will. He alone during the retreat of the French
said that all our maneuvers are useless, everything is being
accomplished of itself better than we could desire; that the enemy
must be offered "a golden bridge"; that neither the Tarutino, the
Vyazma, nor the Krasnoe battles were necessary; that we must keep some
force to reach the frontier with, and that he would not sacrifice a
single Russian for ten Frenchmen.

And this courtier, as he is described to us, who lies to Arakcheev
to please the Emperor, he alone--incurring thereby the Emperor's
displeasure--said in Vilna that to carry the war beyond the frontier
is useless and harmful.

Nor do words alone prove that only he understood the meaning of
the events. His actions--without the smallest deviation--were all
directed to one and the same threefold end: (1) to brace all his
strength for conflict with the French, (2) to defeat them, and (3)
to drive them out of Russia, minimizing as far as possible the
sufferings of our people and of our army.

This procrastinator Kutuzov, whose motto was "Patience and Time,"
this enemy of decisive action, gave battle at Borodino, investing
the preparations for it with unparalleled solemnity. This Kutuzov
who before the battle of Austerlitz began said that it would be
lost, he alone, in contradiction to everyone else, declared till his
death that Borodino was a victory, despite the assurance of generals
that the battle was lost and despite the fact that for an army to have
to retire after winning a battle was unprecedented. He alone during
the whole retreat insisted that battles, which were useless then,
should not be fought, and that a new war should not be begun nor the
frontiers of Russia crossed.

It is easy now to understand the significance of these events--if
only we abstain from attributing to the activity of the mass aims that
existed only in the heads of a dozen individuals--for the events and
results now lie before us.

But how did that old man, alone, in opposition to the general
opinion, so truly discern the importance of the people's view of the
events that in all his activity he was never once untrue to it?

The source of that extraordinary power of penetrating the meaning of
the events then occuring lay in the national feeling which he
possessed in full purity and strength.

Only the recognition of the fact that he possessed this feeling
caused the people in so strange a manner, contrary to the Tsar's wish,
to select him--an old man in disfavor--to be their representative in
the national war. And only that feeling placed him on that highest
human pedestal from which he, the commander in chief, devoted all
his powers not to slaying and destroying men but to saving and showing
pity on them.

That simple, modest, and therefore truly great, figure could not
be cast in the false mold of a European hero--the supposed ruler of
men--that history has invented.

To a lackey no man can be great, for a lackey has his own conception
of greatness.





CHAPTER VI


The fifth of November was the first day of what is called the battle
of Krasnoe. Toward evening--after much disputing and many mistakes
made by generals who did not go to their proper places, and after
adjutants had been sent about with counterorders--when it had become
plain that the enemy was everywhere in flight and that there could and
would be no battle, Kutuzov left Krasnoe and went to Dobroe whither
his headquarters had that day been transferred.

The day was clear and frosty. Kutuzov rode to Dobroe on his plump
little white horse, followed by an enormous suite of discontented
generals who whispered among themselves behind his back. All along the
road groups of French prisoners captured that day (there were seven
thousand of them) were crowding to warm themselves at campfires.
Near Dobroe an immense crowd of tattered prisoners, buzzing with
talk and wrapped and bandaged in anything they had been able to get
hold of, were standing in the road beside a long row of unharnessed
French guns. At the approach of the commander in chief the buzz of
talk ceased and all eyes were fixed on Kutuzov who, wearing a white
cap with a red band and a padded overcoat that bulged on his round
shoulders, moved slowly along the road on his white horse. One of
the generals was reporting to him where the guns and prisoners had
been captured.

Kutuzov seemed preoccupied and did not listen to what the general
was saying. He screwed up his eyes with a dissatisfied look as he
gazed attentively and fixedly at these prisoners, who presented a
specially wretched appearance. Most of them were disfigured by
frost-bitten noses and cheeks, and nearly all had red, swollen and
festering eyes.

One group of the French stood close to the road, and two of them,
one of whom had his face covered with sores, were tearing a piece of
raw flesh with their hands. There was something horrible and bestial
in the fleeting glance they threw at the riders and in the
malevolent expression with which, after a glance at Kutuzov, the
soldier with the sores immediately turned away and went on with what
he was doing.

Kutuzov looked long and intently at these two soldiers. He
puckered his face, screwed up his eyes, and pensively swayed his head.
At another spot he noticed a Russian soldier laughingly patting a
Frenchman on the shoulder, saying something to him in a friendly
manner, and Kutuzov with the same expression on his face again
swayed his head.

"What were you saying?" he asked the general, who continuing his
report directed the commander in chief's attention to some standards
captured from the French and standing in front of the Preobrazhensk
regiment.

"Ah, the standards!" said Kutuzov, evidently detaching himself
with difficulty from the thoughts that preoccupied him.

He looked about him absently. Thousands of eyes were looking at
him from all sides awaiting a word from him.

He stopped in front of the Preobrazhensk regiment, sighed deeply,
and closed his eyes. One of his suite beckoned to the soldiers
carrying the standards to advance and surround the commander in
chief with them. Kutuzov was silent for a few seconds and then,
submitting with evident reluctance to the duty imposed by his
position, raised his head and began to speak. A throng of officers
surrounded him. He looked attentively around at the circle of
officers, recognizing several of them.

"I thank you all!" he said, addressing the soldiers and then again
the officers. In the stillness around him his slowly uttered words
were distinctly heard. "I thank you all for your hard and faithful
service. The victory is complete and Russia will not forget you! Honor
to you forever."

He paused and looked around.

"Lower its head, lower it!" he said to a soldier who had
accidentally lowered the French eagle he was holding before the
Preobrazhensk standards. "Lower, lower, that's it. Hurrah lads!" he
added, addressing the men with a rapid movement of his chin.

"Hur-r-rah!" roared thousands of voices.

While the soldiers were shouting Kutuzov leaned forward in his
saddle and bowed his head, and his eye lit up with a mild and
apparently ironic gleam.

"You see, brothers..." said he when the shouts had ceased... and all
at once his voice and the expression of his face changed. It was no
longer the commander in chief speaking but an ordinary old man who
wanted to tell his comrades something very important.

There was a stir among the throng of officers and in the ranks of
the soldiers, who moved that they might hear better what he was
going to say.

"You see, brothers, I know it's hard for you, but it can't be
helped! Bear up; it won't be for long now! We'll see our visitors
off and then we'll rest. The Tsar won't forget your service. It is
hard for you, but still you are at home while they--you see what
they have come to," said he, pointing to the prisoners. "Worse off
than our poorest beggars. While they were strong we didn't spare
ourselves, but now we may even pity them. They are human beings too.
Isn't it so, lads?"

He looked around, and in the direct, respectful, wondering gaze
fixed upon him he read sympathy with what he had said. His face grew
brighter and brighter with an old man's mild smile, which drew the
corners of his lips and eyes into a cluster of wrinkles. He ceased
speaking and bowed his head as if in perplexity.

"But after all who asked them here? Serves them right, the bloody
bastards!" he cried, suddenly lifting his head.

And flourishing his whip he rode off at a gallop for the first
time during the whole campaign, and left the broken ranks of the
soldiers laughing joyfully and shouting "Hurrah!"

Kutuzov's words were hardly understood by the troops. No one could
have repeated the field marshal's address, begun solemnly and then
changing into an old man's simplehearted talk; but the hearty
sincerity of that speech, the feeling of majestic triumph combined
with pity for the foe and consciousness of the justice of our cause,
exactly expressed by that old man's good-natured expletives, was not
merely understood but lay in the soul of every soldier and found
expression in their joyous and long-sustained shouts. Afterwards
when one of the generals addressed Kutuzov asking whether he wished
his caleche to be sent for, Kutuzov in answering unexpectedly gave a
sob, being evidently greatly moved.





CHAPTER VII


When the troops reached their night's halting place on the eighth of
November, the last day of the Krasnoe battles, it was already
growing dusk. All day it had been calm and frosty with occasional
lightly falling snow and toward evening it began to clear. Through the
falling snow a purple-black and starry sky showed itself and the frost
grew keener.

An infantry regiment which had left Tarutino three thousand strong
but now numbered only nine hundred was one of the first to arrive that
night at its halting place--a village on the highroad. The
quartermasters who met the regiment announced that all the huts were
full of sick and dead Frenchmen, cavalrymen, and members of the staff.
There was only one hut available for the regimental commander.

The commander rode up to his hut. The regiment passed through the
village and stacked its arms in front of the last huts.

Like some huge many-limbed animal, the regiment began to prepare its
lair and its food. One part of it dispersed and waded knee-deep
through the snow into a birch forest to the right of the village,
and immediately the sound of axes and swords, the crashing of
branches, and merry voices could be heard from there. Another
section amid the regimental wagons and horses which were standing in a
group was busy getting out caldrons and rye biscuit, and feeding the
horses. A third section scattered through the village arranging
quarters for the staff officers, carrying out the French corpses
that were in the huts, and dragging away boards, dry wood, and
thatch from the roofs, for the campfires, or wattle fences to serve
for shelter.

Some fifteen men with merry shouts were shaking down the high wattle
wall of a shed, the roof of which had already been removed.

"Now then, all together--shove!" cried the voices, and the huge
surface of the wall, sprinkled with snow and creaking with frost,
was seen swaying in the gloom of the night. The lower stakes cracked
more and more and at last the wall fell, and with it the men who had
been pushing it. Loud, coarse laughter and joyous shouts ensued.

"Now then, catch hold in twos! Hand up the lever! That's it... Where
are you shoving to?"

"Now, all together! But wait a moment, boys... With a song!"

All stood silent, and a soft, pleasant velvety voice began to
sing. At the end of the third verse as the last note died away, twenty
voices roared out at once: "Oo-oo-oo-oo! That's it. All together!
Heave away, boys!..." but despite their united efforts the wattle
hardly moved, and in the silence that followed the heavy breathing
of the men was audible.

"Here, you of the Sixth Company! Devils that you are! Lend a hand...
will you? You may want us one of these days."

Some twenty men of the Sixth Company who were on their way into
the village joined the haulers, and the wattle wall, which was about
thirty-five feet long and seven feet high, moved forward along the
village street, swaying, pressing upon and cutting the shoulders of
the gasping men.

"Get along... Falling? What are you stopping for? There now..."

Merry senseless words of abuse flowed freely.

"What are you up to?" suddenly came the authoritative voice of a
sergeant major who came upon the men who were hauling their burden.
"There are gentry here; the general himself is in that hut, and you
foul-mouthed devils, you brutes, I'll give it to you!" shouted he,
hitting the first man who came in his way a swinging blow on the back.
"Can't you make less noise?"

The men became silent. The soldier who had been struck groaned and
wiped his face, which had been scratched till it bled by his falling
against the wattle.

"There, how that devil hits out! He's made my face all bloody," said
he in a frightened whisper when the sergeant major had passed on.

"Don't you like it?" said a laughing voice, and moderating their
tones the men moved forward.

When they were out of the village they began talking again as loud
as before, interlarding their talk with the same aimless expletives.

In the hut which the men had passed, the chief officers had gathered
and were in animated talk over their tea about the events of the day
and the maneuvers suggested for tomorrow. It was proposed to make a
flank march to the left, cut off the Vice-King (Murat) and capture
him.

By the time the soldiers had dragged the wattle fence to its place
the campfires were blazing on all sides ready for cooking, the wood
crackled, the snow was melting, and black shadows of soldiers
flitted to and fro all over the occupied space where the snow had been
trodden down.

Axes and choppers were plied all around. Everything was done without
any orders being given. Stores of wood were brought for the night,
shelters were rigged up for the officers, caldrons were being
boiled, and muskets and accouterments put in order.

The wattle wall the men had brought was set up in a semicircle by
the Eighth Company as a shelter from the north, propped up by musket
rests, and a campfire was built before it. They beat the tattoo,
called the roll, had supper, and settled down round the fires for
the night--some repairing their footgear, some smoking pipes, and some
stripping themselves naked to steam the lice out of their shirts.





CHAPTER VIII


One would have thought that under the almost incredibly wretched
conditions the Russian soldiers were in at that time--lacking warm
boots and sheepskin coats, without a roof over their heads, in the
snow with eighteen degrees of frost, and without even full rations
(the commissariat did not always keep up with the troops)--they
would have presented a very sad and depressing spectacle.

On the contrary, the army had never under the best material
conditions presented a more cheerful and animated aspect. This was
because all who began to grow depressed or who lost strength were
sifted out of the army day by day. All the physically or morally
weak had long since been left behind and only the flower of the
army--physically and mentally--remained.

More men collected behind the wattle fence of the Eighth Company
than anywhere else. Two sergeants major were sitting with them and
their campfire blazed brighter than others. For leave to sit by
their wattle they demanded contributions of fuel.

"Eh, Makeev! What has become of you, you son of a bitch? Are you
lost or have the wolves eaten you? Fetch some more wood!" shouted a
red-haired and red-faced man, screwing up his eyes and blinking
because of the smoke but not moving back from the fire. "And you,
Jackdaw, go and fetch some wood!" said he to another soldier.

This red-haired man was neither a sergeant nor a corporal, but being
robust he ordered about those weaker than himself. The soldier they
called "Jackdaw," a thin little fellow with a sharp nose, rose
obediently and was about to go but at that instant there came into the
light of the fire the slender, handsome figure of a young soldier
carrying a load of wood.

"Bring it here--that's fine!"

They split up the wood, pressed it down on the fire, blew at it with
their mouths, and fanned it with the skirts of their greatcoats,
making the flames hiss and crackle. The men drew nearer and lit
their pipes. The handsome young soldier who had brought the wood,
setting his arms akimbo, began stamping his cold feet rapidly and
deftly on the spot where he stood.

"Mother! The dew is cold but clear.... It's well that I'm a
musketeer..." he sang, pretending to hiccough after each syllable.

"Look out, your soles will fly off!" shouted the red-haired man,
noticing that the sole of the dancer's boot was hanging loose. "What a
fellow you are for dancing!"

The dancer stopped, pulled off the loose piece of leather, and threw
it on the fire.

"Right enough, friend," said he, and, having sat down, took out of
his knapsack a scrap of blue French cloth, and wrapped it round his
foot. "It's the steam that spoils them," he added, stretching out
his feet toward the fire.

"They'll soon be issuing us new ones. They say that when we've
finished hammering them, we're to receive double kits!"

"And that son of a bitch Petrov has lagged behind after all, it
seems," said one sergeant major.

"I've had an eye on him this long while," said the other.

"Well, he's a poor sort of soldier..."

"But in the Third Company they say nine men were missing yesterday."

"Yes, it's all very well, but when a man's feet are frozen how can
he walk?"

"Eh? Don't talk nonsense!" said a sergeant major.

"Do you want to be doing the same?" said an old soldier, turning
reproachfully to the man who had spoken of frozen feet.

"Well, you know," said the sharp-nosed man they called Jackdaw in
a squeaky and unsteady voice, raising himself at the other side of the
fire, "a plump man gets thin, but for a thin one it's death. Take
me, now! I've got no strength left," he added, with sudden
resolution turning to the sergeant major. "Tell them to send me to

hospital; I'm aching all over; anyway I shan't be able to keep up."

"That'll do, that'll do!" replied the sergeant major quietly.

The soldier said no more and the talk went on.

"What a lot of those Frenchies were taken today, and the fact is
that not one of them had what you might call real boots on," said a
soldier, starting a new theme. "They were no more than make-believes."

"The Cossacks have taken their boots. They were clearing the hut for
the colonel and carried them out. It was pitiful to see them, boys,"
put in the dancer. "As they turned them over one seemed still alive
and, would you believe it, he jabbered something in their lingo."

"But they're a clean folk, lads," the first man went on; "he was
white--as white as birchbark--and some of them are such fine
fellows, you might think they were nobles."

"Well, what do you think? They make soldiers of all classes there."

"But they don't understand our talk at all," said the dancer with
a puzzled smile. "I asked him whose subject he was, and he jabbered in
his own way. A queer lot!"

"But it's strange, friends," continued the man who had wondered at
their whiteness, "the peasants at Mozhaysk were saying that when
they began burying the dead--where the battle was you know--well,
those dead had been lying there for nearly a month, and says the
peasant, 'they lie as white as paper, clean, and not as much smell
as a puff of powder smoke.'"

"Was it from the cold?" asked someone.

"You're a clever fellow! From the cold indeed! Why, it was hot. If
it had been from the cold, ours would not have rotted either. 'But,'
he says, 'go up to ours and they are all rotten and maggoty. So,' he
says, 'we tie our faces up with kerchiefs and turn our heads away as
we drag them off: we can hardly do it. But theirs,' he says, 'are
white as paper and not so much smell as a whiff of gunpowder.'"

All were silent.

"It must be from their food," said the sergeant major. "They used to
gobble the same food as the gentry."

No one contradicted him.

"That peasant near Mozhaysk where the battle was said the men were
all called up from ten villages around and they carted for twenty days
and still didn't finish carting the dead away. And as for the
wolves, he says..."

"That was a real battle," said an old soldier. "It's the only one
worth remembering; but since that... it's only been tormenting folk."

"And do you know, Daddy, the day before yesterday we ran at them
and, my word, they didn't let us get near before they just threw
down their muskets and went on their knees. 'Pardon!' they say. That's
only one case. They say Platov took 'Poleon himself twice. But he
didn't know the right charm. He catches him and catches him--no
good! He turns into a bird in his hands and flies away. And there's no
way of killing him either."

"You're a first-class liar, Kiselev, when I come to look at you!"

"Liar, indeed! It's the real truth."

"If he fell into my hands, when I'd caught him I'd bury him in the
ground with an aspen stake to fix him down. What a lot of men he's
ruined!"

"Well, anyhow we're going to end it. He won't come here again,"
remarked the old soldier, yawning.

The conversation flagged, and the soldiers began settling down to
sleep.

"Look at the stars. It's wonderful how they shine! You would think
the women had spread out their linen," said one of the men, gazing
with admiration at the Milky Way.

"That's a sign of a good harvest next year."

"We shall want some more wood."

"You warm your back and your belly gets frozen. That's queer."

"O Lord!"

"What are you pushing for? Is the fire only for you? Look how he's
sprawling!"

In the silence that ensued, the snoring of those who had fallen
asleep could be heard. Others turned over and warmed themselves, now
and again exchanging a few words. From a campfire a hundred paces
off came a sound of general, merry laughter.

"Hark at them roaring there in the Fifth Company!" said one of the
soldiers, "and what a lot of them there are!"

One of the men got up and went over to the Fifth Company.

"They're having such fun," said he, coming back. "Two Frenchies have
turned up. One's quite frozen and the other's an awful swaggerer. He's
singing songs...."

"Oh, I'll go across and have a look...."

And several of the men went over to the Fifth Company.





CHAPTER IX


The fifth company was bivouacking at the very edge of the forest.
A huge campfire was blazing brightly in the midst of the snow,
lighting up the branches of trees heavy with hoarfrost.

About midnight they heard the sound of steps in the snow of the
forest, and the crackling of dry branches.

"A bear, lads," said one of the men.

They all raised their heads to listen, and out of the forest into
the bright firelight stepped two strangely clad human figures clinging
to one another.

These were two Frenchmen who had been hiding in the forest. They
came up to the fire, hoarsely uttering something in a language our
soldiers did not understand. One was taller than the other; he wore an
officer's hat and seemed quite exhausted. On approaching the fire he
had been going to sit down, but fell. The other, a short sturdy
soldier with a shawl tied round his head, was stronger. He raised
his companion and said something, pointing to his mouth. The
soldiers surrounded the Frenchmen, spread a greatcoat on the ground
for the sick man, and brought some buckwheat porridge and vodka for
both of them.

The exhausted French officer was Ramballe and the man with his
head wrapped in the shawl was Morel, his orderly.

When Morel had drunk some vodka and finished his bowl of porridge he
suddenly became unnaturally merry and chattered incessantly to the
soldiers, who could not understand him. Ramballe refused food and
resting his head on his elbow lay silent beside the campfire,
looking at the Russian soldiers with red and vacant eyes. Occasionally
he emitted a long-drawn groan and then again became silent. Morel,
pointing to his shoulders, tried to impress on the soldiers the fact
that Ramballe was an officer and ought to be warmed. A Russian officer
who had come up to the fire sent to ask his colonel whether he would
not take a French officer into his hut to warm him, and when the
messenger returned and said that the colonel wished the officer to
be brought to him, Ramballe was told to go. He rose and tried to walk,
but staggered and would have fallen had not a soldier standing by held
him up.

"You won't do it again, eh?" said one of the soldiers, winking and
turning mockingly to Ramballe.

"Oh, you fool! Why talk rubbish, lout that you are--a real peasant!"
came rebukes from all sides addressed to the jesting soldier.

They surrounded Ramballe, lifted him on the crossed arms of two
soldiers, and carried him to the hut. Ramballe put his arms around
their necks while they carried him and began wailing plaintively:

"Oh, you fine fellows, my kind, kind friends! These are men! Oh,
my brave, kind friends," and he leaned his head against the shoulder
of one of the men like a child.

Meanwhile Morel was sitting in the best place by the fire,
surrounded by the soldiers.

Morel, a short sturdy Frenchman with inflamed and streaming eyes,
was wearing a woman's cloak and had a shawl tied woman fashion round
his head over his cap. He was evidently tipsy, and was singing a
French song in a hoarse broken voice, with an arm thrown round the
nearest soldier. The soldiers simply held their sides as they
watched him.

"Now then, now then, teach us how it goes! I'll soon pick it up. How
is it?" said the man--a singer and a wag--whom Morel was embracing.

"Vive Henri Quatre! Vive ce roi valiant!" sang Morel, winking. "Ce
diable a quatre..."*


*"Long live Henry the Fourth, that valiant king! That rowdy devil."


"Vivarika! Vif-seruvaru! Sedyablyaka!" repeated the soldier,
flourishing his arm and really catching the tune.

"Bravo! Ha, ha, ha!" rose their rough, joyous laughter from all
sides.

Morel, wrinkling up his face, laughed too.

"Well, go on, go on!"

    "Qui eut le triple talent,
    De boire, de battre,
    Et d'etre un vert galant."*


*Who had a triple talent

 For drinking, for fighting,

 And for being a gallant old boy...


"It goes smoothly, too. Well, now, Zaletaev!"

"Ke..." Zaletaev, brought out with effort: "ke-e-e-e," he drawled,
laboriously pursing his lips, "le-trip-ta-la-de-bu-de-ba, e
de-tra-va-ga-la" he sang.

"Fine! Just like the Frenchie! Oh, ho ho! Do you want some more to
eat?"

"Give him some porridge: it takes a long time to get filled up after
starving."

They gave him some more porridge and Morel with a laugh set to
work on his third bowl. All the young soldiers smiled gaily as they
watched him. The older men, who thought it undignified to amuse
themselves with such nonsense, continued to lie at the opposite side
of the fire, but one would occasionally raise himself on an elbow
and glance at Morel with a smile.

"They are men too," said one of them as he wrapped himself up in his
coat. "Even wormwood grows on its own root."

"O Lord, O Lord! How starry it is! Tremendous! That means a hard
frost...."

They all grew silent. The stars, as if knowing that no one was
looking at them, began to disport themselves in the dark sky: now
flaring up, now vanishing, now trembling, they were busy whispering
something gladsome and mysterious to one another.





CHAPTER X


The French army melted away at the uniform rate of a mathematical
progression; and that crossing of the Berezina about which so much has
been written was only one intermediate stage in its destruction, and
not at all the decisive episode of the campaign. If so much has been
and still is written about the Berezina, on the French side this is
only because at the broken bridge across that river the calamities
their army had been previously enduring were suddenly concentrated
at one moment into a tragic spectacle that remained in every memory,
and on the Russian side merely because in Petersburg--far from the
seat of war--a plan (again one of Pfuel's) had been devised to catch
Napoleon in a strategic trap at the Berezina River. Everyone assured
himself that all would happen according to plan, and therefore
insisted that it was just the crossing of the Berezina that
destroyed the French army. In reality the results of the crossing were
much less disastrous to the French--in guns and men lost--than Krasnoe
had been, as the figures show.

The sole importance of the crossing of the Berezina lies in the fact
that it plainly and indubitably proved the fallacy of all the plans
for cutting off the enemy's retreat and the soundness of the only
possible line of action--the one Kutuzov and the general mass of the
army demanded--namely, simply to follow the enemy up. The French crowd
fled at a continually increasing speed and all its energy was directed
to reaching its goal. It fled like a wounded animal and it was
impossible to block its path. This was shown not so much by the
arrangements it made for crossing as by what took place at the
bridges. When the bridges broke down, unarmed soldiers, people from
Moscow and women with children who were with the French transport,
all--carried on by vis inertiae--pressed forward into boats and into
the ice-covered water and did not, surrender.

That impulse was reasonable. The condition of fugitives and of
pursuers was equally bad. As long as they remained with their own
people each might hope for help from his fellows and the definite
place he held among them. But those who surrendered, while remaining
in the same pitiful plight, would be on a lower level to claim a share
in the necessities of life. The French did not need to be informed
of the fact that half the prisoners--with whom the Russians did not
know what to do--perished of cold and hunger despite their captors'
desire to save them; they felt that it could not be otherwise. The
most compassionate Russian commanders, those favorable to the
French--and even the Frenchmen in the Russian service--could do
nothing for the prisoners. The French perished from the conditions
to which the Russian army was itself exposed. It was impossible to
take bread and clothes from our hungry and indispensable soldiers to
give to the French who, though not harmful, or hated, or guilty,
were simply unnecessary. Some Russians even did that, but they were
exceptions.

Certain destruction lay behind the French but in front there was
hope. Their ships had been burned, there was no salvation save in
collective flight, and on that the whole strength of the French was
concentrated.

The farther they fled the more wretched became the plight of the
remnant, especially after the Berezina, on which (in consequence of
the Petersburg plan) special hopes had been placed by the Russians,
and the keener grew the passions of the Russian commanders, blamed one
another and Kutuzov most of all. Anticipation that the failure of
the Petersburg Berezina plan would be attributed to Kutuzov led to
dissatisfaction, contempt, and ridicule, more and more strongly
expressed. The ridicule and contempt were of course expressed in a
respectful form, making it impossible for him to ask wherein he was to
blame. They did not talk seriously to him; when reporting to him or
asking for his sanction they appeared to be fulfilling a regrettable
formality, but they winked behind his back and tried to mislead him at
every turn.

Because they could not understand him all these people assumed
that it was useless to talk to the old man; that he would never
grasp the profundity of their plans, that he would answer with his
phrases (which they thought were mere phrases) about a "golden
bridge," about the impossibility of crossing the frontier with a crowd
of tatterdemalions, and so forth. They had heard all that before.
And all he said--that it was necessary to await provisions, or that
the men had no boots--was so simple, while what they proposed was so
complicated and clever, that it was evident that he was old and stupid
and that they, though not in power, were commanders of genius.

After the junction with the army of the brilliant admiral and
Petersburg hero Wittgenstein, this mood and the gossip of the staff
reached their maximum. Kutuzov saw this and merely sighed and shrugged
his shoulders. Only once, after the affair of the Berezina, did he get
angry and write to Bennigsen (who reported separately to the
Emperor) the following letter:

"On account of your spells of ill health, will your excellency
please be so good as to set off for Kaluga on receipt of this, and
there await further commands and appointments from His Imperial
Majesty."

But after Bennigsen's departure, the Grand Duke Tsarevich
Constantine Pavlovich joined the army. He had taken part in the
beginning of the campaign but had subsequently been removed from the
army by Kutuzov. Now having come to the army, he informed Kutuzov of
the Emperor's displeasure at the poor success of our forces and the
slowness of their advance. The Emperor intended to join the army
personally in a few days' time.

The old man, experienced in court as well as in military affairs-
this same Kutuzov who in August had been chosen commander in chief
against the sovereign's wishes and who had removed the Grand Duke
and heir--apparent from the army--who on his own authority and
contrary to the Emperor's will had decided on the abandonment of
Moscow, now realized at once that his day was over, that his part
was played, and that the power he was supposed to hold was no longer
his. And he understood this not merely from the attitude of the court.
He saw on the one hand that the military business in which he had
played his part was ended and felt that his mission was
accomplished; and at the same time he began to be conscious of the
physical weariness of his aged body and of the necessity of physical
rest.

On the twenty-ninth of November Kutuzov entered Vilna--his "dear
Vilna" as he called it. Twice during his career Kutuzov had been
governor of Vilna. In that wealthy town, which had not been injured,
he found old friends and associations, besides the comforts of life of
which he had so long been deprived. And he suddenly turned from the
cares of army and state and, as far as the passions that seethed
around him allowed, immersed himself in the quiet life to which he had
formerly been accustomed, as if all that was taking place and all that
had still to be done in the realm of history did not concern him at
all.

Chichagov, one of the most zealous "cutters-off" and
"breakers-up," who had first wanted to effect a diversion in Greece
and then in Warsaw but never wished to go where he was sent:
Chichagov, noted for the boldness with which he spoke to the
Emperor, and who considered Kutuzov to be under an obligation to him
because when he was sent to make peace with Turkey in 1811
independently of Kutuzov, and found that peace had already been
concluded, he admitted to the Emperor that the merit of securing
that peace was really Kutuzov's; this Chichagov was the first to
meet Kutuzov at the castle where the latter was to stay. In undress
naval uniform, with a dirk, and holding his cap under his arm, he
handed Kutuzov a garrison report and the keys of the town. The
contemptuously respectful attitude of the younger men to the old man
in his dotage was expressed in the highest degree by the behavior of
Chichagov, who knew of the accusations that were being directed
against Kutuzov.

When speaking to Chichagov, Kutuzov incidentally mentioned that
the vehicles packed with china that had been captured from him at
Borisov had been recovered and would be restored to him.

"You mean to imply that I have nothing to eat out of.... On the
contrary, I can supply you with everything even if you want to give
dinner parties," warmly replied Chichagov, who tried by every word
he spoke to prove his own rectitude and therefore imagined Kutuzov
to be animated by the same desire.

Kutuzov, shrugging his shoulders, replied with his subtle
penetrating smile: "I meant merely to say what I said."

Contrary to the Emperor's wish Kutuzov detained the greater part
of the army at Vilna. Those about him said that he became
extraordinarily slack and physically feeble during his stay in that
town. He attended to army affairs reluctantly, left everything to
his generals, and while awaiting the Emperor's arrival led a
dissipated life.

Having left Petersburg on the seventh of December with his suite-
Count Tolstoy, Prince Volkonski, Arakcheev, and others--the Emperor
reached Vilna on the eleventh, and in his traveling sleigh drove
straight to the castle. In spite of the severe frost some hundred
generals and staff officers in full parade uniform stood in front of
the castle, as well as a guard of honor of the Semenov regiment.

A courier who galloped to the castle in advance, in a troyka with
three foam-flecked horses, shouted "Coming!" and Konovnitsyn rushed
into the vestibule to inform Kutuzov, who was waiting in the hall
porter's little lodge.

A minute later the old man's large stout figure in full-dress
uniform, his chest covered with orders and a scarf drawn round his
stomach, waddled out into the porch. He put on his hat with its
peaks to the sides and, holding his gloves in his hand and walking
with an effort sideways down the steps to the level of the street,
took in his hand the report he had prepared for the Emperor.

There was running to and fro and whispering; another troyka
furiously up, and then all eyes were turned on an approaching sleigh
in which the figures of the Emperor and Volkonski could already be
descried.

From the habit of fifty years all this had a physically agitating
effect on the old general. He carefully and hastily felt himself all
over, readjusted his hat, and pulling himself together drew himself up
and, at the very moment when the Emperor, having alighted from the
sleigh, lifted his eyes to him, handed him the report and began
speaking in his smooth, ingratiating voice.

The Emperor with a rapid glance scanned Kutuzov from head to foot,
frowned for an instant, but immediately mastering himself went up to
the old man, extended his arms and embraced him. And this embrace too,
owing to a long-standing impression related to his innermost feelings,
had its usual effect on Kutuzov and he gave a sob.

The Emperor greeted the officers and the Semenov guard, and again
pressing the old man's hand went with him into the castle.

When alone with the field marshal the Emperor expressed his
dissatisfaction at the slowness of the pursuit and at the mistakes
made at Krasnoe and the Berezina, and informed him of his intentions
for a future campaign abroad. Kutuzov made no rejoinder or remark. The
same submissive, expressionless look with which he had listened to the
Emperor's commands on the field of Austerlitz seven years before
settled on his face now.

When Kutuzov came out of the study and with lowered head was
crossing the ballroom with his heavy waddling gait, he was arrested by
someone's voice saying:

"Your Serene Highness!"

Kutuzov raised his head and looked for a long while into the eyes of
Count Tolstoy, who stood before him holding a silver salver on which
lay a small object. Kutuzov seemed not to understand what was expected
of him.

Suddenly he seemed to remember; a scarcely perceptible smile flashed
across his puffy face, and bowing low and respectfully he took the
object that lay on the salver. It was the Order of St. George of the
First Class.





CHAPTER XI


Next day the field marshal gave a dinner and ball which the
Emperor honored by his presence. Kutuzov had received the Order of St.
George of the First Class and the Emperor showed him the highest
honors, but everyone knew of the imperial dissatisfaction with him.
The proprieties were observed and the Emperor was the first to set
that example, but everybody understood that the old man was
blameworthy and good-for-nothing. When Kutuzov, conforming to a custom
of Catherine's day, ordered the standards that had been captured to be
lowered at the Emperor's feet on his entering the ballroom, the
Emperor made a wry face and muttered something in which some people
caught the words, "the old comedian."

The Emperor's displeasure with Kutuzov was specially increased at
Vilna by the fact that Kutuzov evidently could not or would not
understand the importance of the coming campaign.

When on the following morning the Emperor said to the officers
assembled about him: "You have not only saved Russia, you have saved
Europe!" they all understood that the war was not ended.

Kutuzov alone would not see this and openly expressed his opinion
that no fresh war could improve the position or add to the glory of
Russia, but could only spoil and lower the glorious position that
Russia had gained. He tried to prove to the Emperor the
impossibility of levying fresh troops, spoke of the hardships
already endured by the people, of the possibility of failure and so
forth.

This being the field marshal's frame of mind he was naturally
regarded as merely a hindrance and obstacle to the impending war.

To avoid unpleasant encounters with the old man, the natural
method was to do what had been done with him at Austerlitz and with
Barclay at the beginning of the Russian campaign--to transfer the
authority to the Emperor himself, thus cutting the ground from under
the commander in chief's feet without upsetting the old man by
informing him of the change.

With this object his staff was gradually reconstructed and its
real strength removed and transferred to the Emperor. Toll,
Konovnitsyn, and Ermolov received fresh appointments. Everyone spoke
loudly of the field marshal's great weakness and failing health.

His health had to be bad for his place to be taken away and given to
another. And in fact his health was poor.

So naturally, simply, and gradually--just as he had come from Turkey
to the Treasury in Petersburg to recruit the militia, and then to
the army when he was needed there--now when his part was played out,
Kutuzov's place was taken by a new and necessary performer.

The war 1812, besides its national significance dear to every
Russian heart, was now to assume another, a European, significance.

The movement of peoples from west to east was to be succeeded by a
movement of peoples from east to west, and for this fresh war
another leader was necessary, having qualities and views differing
from Kutuzov's and animated by different motives.

Alexander I was as necessary for the movement of the peoples from
east to west and for the refixing of national frontiers as Kutuzov had
been for the salvation and glory of Russia.

Kutuzov did not understand what Europe, the balance of power, or
Napoleon meant. He could not understand it. For the representative
of the Russian people, after the enemy had been destroyed and Russia
had been liberated and raised to the summit of her glory, there was
nothing left to do as a Russian. Nothing remained for the
representative of the national war but to die, and Kutuzov died.





CHAPTER XII


As generally happens, Pierre did not feel the full effects of the
physical privation and strain he had suffered as prisoner until
after they were over. After his liberation he reached Orel, and on the
third day there, when preparing to go to Kiev, he fell ill and was
laid up for three months. He had what the doctors termed "bilious
fever." But despite the fact that the doctors treated him, bled him,
and gave him medicines to drink, he recovered.

Scarcely any impression was left on Pierre's mind by all that
happened to him from the time of his rescue till his illness. He
remembered only the dull gray weather now rainy and now snowy,
internal physical distress, and pains in his feet and side. He
remembered a general impression of the misfortunes and sufferings of
people and of being worried by the curiosity of officers and
generals who questioned him, he also remembered his difficulty in
procuring a conveyance and horses, and above all he remembered his
incapacity to think and feel all that time. On the day of his rescue
he had seen the body of Petya Rostov. That same day he had learned
that Prince Andrew, after surviving the battle of Borodino for more
than a month had recently died in the Rostovs' house at Yaroslavl, and
Denisov who told him this news also mentioned Helene's death,
supposing that Pierre had heard of it long before. All this at the
time seemed merely strange to Pierre: he felt he could not grasp its
significance. Just then he was only anxious to get away as quickly
as possible from places where people were killing one another, to some
peaceful refuge where he could recover himself, rest, and think over
all the strange new facts he had learned; but on reaching Orel he
immediately fell ill. When he came to himself after his illness he saw
in attendance on him two of his servants, Terenty and Vaska, who had
come from Moscow; and also his cousin the eldest princess, who had
been living on his estate at Elets and hearing of his rescue and
illness had come to look after him.

It was only gradually during his convalescence that Pierre lost
the impressions he had become accustomed to during the last few months
and got used to the idea that no one would oblige him to go anywhere
tomorrow, that no one would deprive him of his warm bed, and that he
would be sure to get his dinner, tea, and supper. But for a long
time in his dreams he still saw himself in the conditions of
captivity. In the same way little by little he came to understand
the news he had been told after his rescue, about the death of
Prince Andrew, the death of his wife, and the destruction of the
French.

A joyous feeling of freedom--that complete inalienable freedom
natural to man which he had first experienced at the first halt
outside Moscow--filled Pierre's soul during his convalescence. He
was surprised to find that this inner freedom, which was independent
of external conditions, now had as it were an additional setting of
external liberty. He was alone in a strange town, without
acquaintances. No one demanded anything of him or sent him anywhere.
He had all he wanted: the thought of his wife which had been a
continual torment to him was no longer there, since she was no more.

"Oh, how good! How splendid!" said he to himself when a cleanly laid
table was moved up to him with savory beef tea, or when he lay down
for the night on a soft clean bed, or when he remembered that the
French had gone and that his wife was no more. "Oh, how good, how
splendid!"

And by old habit he asked himself the question: "Well, and what
then? What am I going to do?" And he immediately gave himself the
answer: "Well, I shall live. Ah, how splendid!"

The very question that had formerly tormented him, the thing he
had continually sought to find--the aim of life--no longer existed for
him now. That search for the aim of life had not merely disappeared
temporarily--he felt that it no longer existed for him and could not
present itself again. And this very absence of an aim gave him the
complete, joyous sense of freedom which constituted his happiness at
this time.

He could not see an aim, for he now had faith--not faith in any kind
of rule, or words, or ideas, but faith in an ever-living,
ever-manifest God. Formerly he had sought Him in aims he set
himself. That search for an aim had been simply a search for God,
and suddenly in his captivity he had learned not by words or reasoning
but by direct feeling what his nurse had told him long ago: that God
is here and everywhere. In his captivity he had learned that in
Karataev God was greater, more infinite and unfathomable than in the
Architect of the Universe recognized by the Freemasons. He felt like a
man who after straining his eyes to see into the far distance finds
what he sought at his very feet. All his life he had looked over the
heads of the men around him, when he should have merely looked in
front of him without straining his eyes.

In the past he had never been able to find that great inscrutable
infinite something. He had only felt that it must exist somewhere
and had looked for it. In everything near and comprehensible he had
only what was limited, petty, commonplace, and senseless. He had
equipped himself with a mental telescope and looked into remote space,
where petty worldliness hiding itself in misty distance had seemed
to him great and infinite merely because it was not clearly seen.
And such had European life, politics, Freemasonry, philosophy, and
philanthropy seemed to him. But even then, at moments of weakness as
he had accounted them, his mind had penetrated to those distances
and he had there seen the same pettiness, worldliness, and
senselessness. Now, however, he had learned to see the great, eternal,
and infinite in everything, and therefore--to see it and enjoy its
contemplation--he naturally threw away the telescope through which
he had till now gazed over men's heads, and gladly regarded the
ever-changing, eternally great, unfathomable, and infinite life around
him. And the closer he looked the more tranquil and happy he became.
That dreadful question, "What for?" which had formerly destroyed all
his mental edifices, no longer existed for him. To that question,
"What for?" a simple answer was now always ready in his soul: "Because
there is a God, that God without whose will not one hair falls from
a man's head."





CHAPTER XIII


In external ways Pierre had hardly changed at all. In appearance
he was just what he used to be. As before he was absent-minded and
seemed occupied not with what was before his eyes but with something
special of his own. The difference between his former and present self
was that formerly when he did not grasp what lay before him or was
said to him, he had puckered his forehead painfully as if vainly
seeking to distinguish something at a distance. At present he still
forgot what was said to him and still did not see what was before
his eyes, but he now looked with a scarcely perceptible and
seemingly ironic smile at what was before him and listened to what was
said, though evidently seeing and hearing something quite different.
Formerly he had appeared to be a kindhearted but unhappy man, and so
people had been inclined to avoid him. Now a smile at the joy of
life always played round his lips, and sympathy for others, shone in
his eyes with a questioning look as to whether they were as
contented as he was, and people felt pleased by his presence.

Previously he had talked a great deal, grew excited when he
talked, and seldom listened; now he was seldom carried away in
conversation and knew how to listen so that people readily told him
their most intimate secrets.

The princess, who had never liked Pierre and had been particularly
hostile to him since she had felt herself under obligations to him
after the old count's death, now after staying a short time in Orel-
where she had come intending to show Pierre that in spite of his
ingratitude she considered it her duty to nurse him--felt to her
surprise and vexation that she had become fond of him. Pierre did
not in any way seek her approval, he merely studied her with interest.
Formerly she had felt that he regarded her with indifference and
irony, and so had shrunk into herself as she did with others and had
shown him only the combative side of her nature; but now he seemed
to be trying to understand the most intimate places of her heart, and,
mistrustfully at first but afterwards gratefully, she let him see
the hidden, kindly sides of her character.

The most cunning man could not have crept into her confidence more
successfully, evoking memories of the best times of her youth and
showing sympathy with them. Yet Pierre's cunning consisted simply in
finding pleasure in drawing out the human qualities of the embittered,
hard, and (in her own way) proud princess.

"Yes, he is a very, very kind man when he is not under the influence
of bad people but of people such as myself," thought she.

His servants too--Terenty and Vaska--in their own way noticed the
change that had taken place in Pierre. They considered that he had
become much "simpler." Terenty, when he had helped him undress and
wished him good night, often lingered with his master's boots in his
hands and clothes over his arm, to see whether he would not start a
talk. And Pierre, noticing that Terenty wanted a chat, generally
kept him there.

"Well, tell me... now, how did you get food?" he would ask.

And Terenty would begin talking of the destruction of Moscow, and of
the old count, and would stand for a long time holding the clothes and
talking, or sometimes listening to Pierre's stories, and then would go
out into the hall with a pleasant sense of intimacy with his master
and affection for him.

The doctor who attended Pierre and visited him every day, though
he considered it his duty as a doctor to pose as a man whose every
moment was of value to suffering humanity, would sit for hours with
Pierre telling him his favorite anecdotes and his observations on
the characters of his patients in general, and especially of the
ladies.

"It's a pleasure to talk to a man like that; he is not like our
provincials," he would say.

There were several prisoners from the French army in Orel, and the
doctor brought one of them, a young Italian, to see Pierre.

This officer began visiting Pierre, and the princess used to make
fun of the tenderness the Italian expressed for him.

The Italian seemed happy only when he could come to see Pierre, talk
with him, tell him about his past, his life at home, and his love, and
pour out to him his indignation against the French and especially
against Napoleon.

"If all Russians are in the least like you, it is sacrilege to fight
such a nation," he said to Pierre. "You, who have suffered so from the
French, do not even feel animosity toward them."

Pierre had evoked the passionate affection of the Italian merely
by evoking the best side of his nature and taking a pleasure in so
doing.

During the last days of Pierre's stay in Orel his old Masonic
acquaintance Count Willarski, who had introduced him to the lodge in
1807, came to see him. Willarski was married to a Russian heiress
who had a large estate in Orel province, and he occupied a temporary
post in the commissariat department in that town.

Hearing that Bezukhov was in Orel, Willarski, though they had
never been intimate, came to him with the professions of friendship
and intimacy that people who meet in a desert generally express for
one another. Willarski felt dull in Orel and was pleased to meet a man
of his own circle and, as he supposed, of similar interests.

But to his surprise Willarski soon noticed that Pierre had lagged
much behind the times, and had sunk, as he expressed it to himself,
into apathy and egotism.

"You are letting yourself go, my dear fellow," he said.

But for all that Willarski found it pleasanter now than it had
been formerly to be with Pierre, and came to see him every day. To
Pierre as he looked at and listened to Willarski, it seemed strange to
think that he had been like that himself but a short time before.

Willarski was a married man with a family, busy with his family
affairs, his wife's affairs, and his official duties. He regarded
all these occupations as hindrances to life, and considered that
they were all contemptible because their aim was the welfare of
himself and his family. Military, administrative, political, and
Masonic interests continually absorbed his attention. And Pierre,
without trying to change the other's views and without condemning him,
but with the quiet, joyful, and amused smile now habitual to him,
was interested in this strange though very familiar phenomenon.

There was a new feature in Pierre's relations with Willarski, with
the princess, with the doctor, and with all the people he now met,
which gained for him the general good will. This was his
acknowledgment of the impossibility of changing a man's convictions by
words, and his recognition of the possibility of everyone thinking,
feeling, and seeing things each from his own point of view. This
legitimate peculiarity of each individual which used to excite and
irritate Pierre now became a basis of the sympathy he felt for, and
the interest he took in, other people. The difference, and sometimes
complete contradiction, between men's opinions and their lives, and
between one man and another, pleased him and drew from him an amused
and gentle smile.

In practical matters Pierre unexpectedly felt within himself a
center of gravity he had previously lacked. Formerly all pecuniary
questions, especially requests for money to which, as an extremely
wealthy man, he was very exposed, produced in him a state of
hopeless agitation and perplexity. "To give or not to give?" he had
asked himself. "I have it and he needs it. But someone else needs it
still more. Who needs it most? And perhaps they are both impostors?"
In the old days he had been unable to find a way out of all these
surmises and had given to all who asked as long as he had anything
to give. Formerly he had been in a similar state of perplexity with
regard to every question concerning his property, when one person
advised one thing and another something else.

Now to his surprise he found that he no longer felt either doubt
or perplexity about these questions. There was now within him a
judge who by some rule unknown to him decided what should or should
not be done.

He was as indifferent as heretofore to money matters, but now he
felt certain of what ought and what ought not to be done. The first
time he had recourse to his new judge was when a French prisoner, a
colonel, came to him and, after talking a great deal about his
exploits, concluded by making what amounted to a demand that Pierre
should give him four thousand francs to send to his wife and children.
Pierre refused without the least difficulty or effort, and was
afterwards surprised how simple and easy had been what used to
appear so insurmountably difficult. At the same time that he refused
the colonel's demand he made up his mind that he must have recourse to
artifice when leaving Orel, to induce the Italian officer to accept
some money of which he was evidently in need. A further proof to
Pierre of his own more settled outlook on practical matters was
furnished by his decision with regard to his wife's debts and to the
rebuilding of his houses in and near Moscow.

His head steward came to him at Orel and Pierre reckoned up with him
his diminished income. The burning of Moscow had cost him, according
to the head steward's calculation, about two million rubles.

To console Pierre for these losses the head steward gave him an
estimate showing that despite these losses his income would not be
diminished but would even be increased if he refused to pay his wife's
debts which he was under no obligation to meet, and did not rebuild
his Moscow house and the country house on his Moscow estate, which had
cost him eighty thousand rubles a year and brought in nothing.

"Yes, of course that's true," said Pierre with a cheerful smile.
"I don't need all that at all. By being ruined I have become much
richer."

But in January Savelich came from Moscow and gave him an account
of the state of things there, and spoke of the estimate an architect
had made of the cost of rebuilding the town and country houses,
speaking of this as of a settled matter. About the same time he
received letters from Prince Vasili and other Petersburg acquaintances
speaking of his wife's debts. And Pierre decided that the steward's
proposals which had so pleased him were wrong and that he must go to
Petersburg and settle his wife's affairs and must rebuild in Moscow.
Why this was necessary he did not know, but he knew for certain that
it was necessary. His income would be reduced by three fourths, but he
felt it must be done.

Willarski was going to Moscow and they agreed to travel together.

During the whole time of his convalescence in Orel Pierre had
experienced a feeling of joy, freedom, and life; but when during his
journey he found himself in the open world and saw hundreds of new
faces, that feeling was intensified. Throughout his journey he felt
like a schoolboy on holiday. Everyone--the stagecoach driver, the
post-house overseers, the peasants on the roads and in the villages-
had a new significance for him. The presence and remarks of
Willarski who continually deplored the ignorance and poverty of Russia
and its backwardness compared with Europe only heightened Pierre's
pleasure. Where Willarski saw deadness Pierre saw an extraordinary
strength and vitality--the strength which in that vast space amid
the snows maintained the life of this original, peculiar, and unique
people. He did not contradict Willarski and even seemed to agree
with him--an apparent agreement being the simplest way to avoid
discussions that could lead to nothing--and he smiled joyfully as he
listened to him.





CHAPTER XIV


It would be difficult to explain why and whither ants whose heap has
been destroyed are hurrying: some from the heap dragging bits of
rubbish, larvae, and corpses, others back to the heap, or why they
jostle, overtake one another, and fight, and it would be equally
difficult to explain what caused the Russians after the departure of
the French to throng to the place that had formerly been Moscow. But
when we watch the ants round their ruined heap, the tenacity,
energy, and immense number of the delving insects prove that despite
the destruction of the heap, something indestructible, which though
intangible is the real strength of the colony, still exists; and
similarly, though in Moscow in the month of October there was no
government no churches, shrines, riches, or houses--it was still the
Moscow it had been in August. All was destroyed, except something
intangible yet powerful and indestructible.

The motives of those who thronged from all sides to Moscow after
it had been cleared of the enemy were most diverse and personal, and
at first for the most part savage and brutal. One motive only they all
had in common: a desire to get to the place that had been called
Moscow, to apply their activities there.

Within a week Moscow already had fifteen thousand inhabitants, in
a fortnight twenty-five thousand, and so on. By the autumn of 1813 the
number, ever increasing and increasing, exceeded what it had been in
1812.

The first Russians to enter Moscow were the Cossacks of
Wintzingerode's detachment, peasants from the adjacent villages, and
residents who had fled from Moscow and had been hiding in its
vicinity. The Russians who entered Moscow, finding it plundered,
plundered it in their turn. They continued what the French had
begun. Trains of peasant carts came to Moscow to carry off to the
villages what had been abandoned in the ruined houses and the streets.
The Cossacks carried off what they could to their camps, and the
householders seized all they could find in other houses and moved it
to their own, pretending that it was their property.

But the first plunderers were followed by a second and a third
contingent, and with increasing numbers plundering became more and
more difficult and assumed more definite forms.

The French found Moscow abandoned but with all the organizations
of regular life, with diverse branches of commerce and
craftsmanship, with luxury, and governmental and religious
institutions. These forms were lifeless but still existed. There
were bazaars, shops, warehouses, market stalls, granaries--for the
most part still stocked with goods--and there were factories and
workshops, palaces and wealthy houses filled with luxuries, hospitals,
prisons, government offices, churches, and cathedrals. The longer
the French remained the more these forms of town life perished,
until finally all was merged into one confused, lifeless scene of
plunder.

The more the plundering by the French continued, the more both the
wealth of Moscow and the strength of its plunderers was destroyed. But
plundering by the Russians, with which the reoccupation of the city
began, had an opposite effect: the longer it continued and the greater
the number of people taking part in it the more rapidly was the wealth
of the city and its regular life restored.

Besides the plunderers, very various people, some drawn by
curiosity, some by official duties, some by self-interest--house
owners, clergy, officials of all kinds, tradesmen, artisans, and
peasants--streamed into Moscow as blood flows to the heart.

Within a week the peasants who came with empty carts to carry off
plunder were stopped by the authorities and made to cart the corpses
out of the town. Other peasants, having heard of their comrades'
discomfiture, came to town bringing rye, oats, and hay, and beat
down one another's prices to below what they had been in former
days. Gangs of carpenters hoping for high pay arrived in Moscow
every day, and on all sides logs were being hewn, new houses built,
and old, charred ones repaired. Tradesmen began trading in booths.
Cookshops and taverns were opened in partially burned houses. The
clergy resumed the services in many churches that had not been burned.
Donors contributed Church property that had been stolen. Government
clerks set up their baize-covered tables and their pigeonholes of
documents in small rooms. The higher authorities and the police
organized the distribution of goods left behind by the French. The
owners of houses in which much property had been left, brought there
from other houses, complained of the injustice of taking everything to
the Faceted Palace in the Kremlin; others insisted that as the
French had gathered things from different houses into this or that
house, it would be unfair to allow its owner to keep all that was
found there. They abused the police and bribed them, made out
estimates at ten times their value for government stores that had
perished in the fire, and demanded relief. And Count Rostopchin
wrote proclamations.





CHAPTER XV


At the end of January Pierre went to Moscow and stayed in an annex
of his house which had not been burned. He called on Count
Rostopchin and on some acquaintances who were back in Moscow, and he
intended to leave for Petersburg two days later. Everybody was
celebrating the victory, everything was bubbling with life in the
ruined but reviving city. Everyone was pleased to see Pierre, everyone
wished to meet him, and everyone questioned him about what he had
seen. Pierre felt particularly well disposed toward them all, but
was now instinctively on his guard for fear of binding himself in
any way. To all questions put to him--whether important or quite
trifling--such as: Where would he live? Was he going to rebuild?
When was he going to Petersburg and would he mind taking a parcel
for someone?--he replied: "Yes, perhaps," or, "I think so," and so on.

He had heard that the Rostovs were at Kostroma but the thought of
Natasha seldom occurred to him. If it did it was only as a pleasant
memory of the distant past. He felt himself not only free from
social obligations but also from that feeling which, it seemed to him,
he had aroused in himself.

On the third day after his arrival he heard from the Drubetskoys
that Princess Mary was in Moscow. The death, sufferings, and last days
of Prince Andrew had often occupied Pierre's thoughts and now recurred
to him with fresh vividness. Having heard at dinner that Princess Mary
was in Moscow and living in her house--which had not been burned--in
Vozdvizhenka Street, he drove that same evening to see her.

On his way to the house Pierre kept thinking of Prince Andrew, of
their friendship, of his various meetings with him, and especially
of the last one at Borodino.

"Is it possible that he died in the bitter frame of mind he was then
in? Is it possible that the meaning of life was not disclosed to him
before he died?" thought Pierre. He recalled Karataev and his death
and involuntarily began to compare these two men, so different, and
yet so similar in that they had both lived and both died and in the
love he felt for both of them.

Pierre drove up to the house of the old prince in a most serious
mood. The house had escaped the fire; it showed signs of damage but
its general aspect was unchanged. The old footman, who met Pierre with
a stern face as if wishing to make the visitor feel that the absence
of the old prince had not disturbed the order of things in the
house, informed him that the princess had gone to her own
apartments, and that she received on Sundays.

"Announce me. Perhaps she will see me," said Pierre.

"Yes, sir," said the man. "Please step into the portrait gallery."

A few minutes later the footman returned with Dessalles, who brought
word from the princess that she would be very glad to see Pierre if he
would excuse her want of ceremony and come upstairs to her apartment.

In a rather low room lit by one candle sat the princess and with her
another person dressed in black. Pierre remembered that the princess
always had lady companions, but who they were and what they were
like he never knew or remembered. "This must be one of her
companions," he thought, glancing at the lady in the black dress.

The princess rose quickly to meet him and held out her hand.

"Yes," she said, looking at his altered face after he had kissed her
hand, "so this is how we meet again. He spoke of you even at the
very last," she went on, turning her eyes from Pierre to her companion
with a shyness that surprised him for an instant.

"I was so glad to hear of your safety. It was the first piece of
good news we had received for a long time."

Again the princess glanced round at her companion with even more
uneasiness in her manner and was about to add something, but Pierre
interrupted her.

"Just imagine--I knew nothing about him!" said he. "I thought he had
been killed. All I know I heard at second hand from others. I only
know that he fell in with the Rostovs.... What a strange coincidence!"

Pierre spoke rapidly and with animation. He glanced once at the
companion's face, saw her attentive and kindly gaze fixed on him, and,
as often happens when one is talking, felt somehow that this companion
in the black dress was a good, kind, excellent creature who would
not hinder his conversing freely with Princess Mary.

But when he mentioned the Rostovs, Princess Mary's face expressed
still greater embarrassment. She again glanced rapidly from Pierre's
face to that of the lady in the black dress and said:

"Do you really not recognize her?"

Pierre looked again at the companion's pale, delicate face with
its black eyes and peculiar mouth, and something near to him, long
forgotten and more than sweet, looked at him from those attentive
eyes.

"But no, it can't be!" he thought. "This stern, thin, pale face that
looks so much older! It cannot be she. It merely reminds me of her."
But at that moment Princess Mary said, "Natasha!" And with difficulty,
effort, and stress, like the opening of a door grown rusty on its
hinges, a smile appeared on the face with the attentive eyes, and from
that opening door came a breath of fragrance which suffused Pierre
with a happiness he had long forgotten and of which he had not even
been thinking--especially at that moment. It suffused him, seized him,
and enveloped him completely. When she smiled doubt was no longer
possible, it was Natasha and he loved her.

At that moment Pierre involuntarily betrayed to her, to Princess
Mary, and above all to himself, a secret of which he himself had
been unaware. He flushed joyfully yet with painful distress. He
tried to hide his agitation. But the more he tried to hide it the more
clearly--clearer than any words could have done--did he betray to
himself, to her, and to Princess Mary that he loved her.

"No, it's only the unexpectedness of it," thought Pierre. But as
soon as he tried to continue the conversation he had begun with
Princess Mary he again glanced at Natasha, and a still-deeper flush
suffused his face and a still-stronger agitation of mingled joy and
fear seized his soul. He became confused in his speech and stopped
in the middle of what he was saying.

Pierre had failed to notice Natasha because he did not at all expect
to see her there, but he had failed to recognize her because the
change in her since he last saw her was immense. She had grown thin
and pale, but that was not what made her unrecognizable; she was
unrecognizable at the moment he entered because on that face whose
eyes had always shone with a suppressed smile of the joy of life,
now when he first entered and glanced at her there was not the least
shadow of a smile: only her eyes were kindly attentive and sadly
interrogative.

Pierre's confusion was not reflected by any confusion on Natasha's
part, but only by the pleasure that just perceptibly lit up her
whole face.





CHAPTER XVI


"She has come to stay with me," said Princess Mary. "The count and
countess will be here in a few days. The countess is in a dreadful
state; but it was necessary for Natasha herself to see a doctor.
They insisted on her coming with me."

"Yes, is there a family free from sorrow now?" said Pierre,
addressing Natasha. "You know it happened the very day we were
rescued. I saw him. What a delightful boy he was!"

Natasha looked at him, and by way of answer to his words her eyes
widened and lit up.

"What can one say or think of as a consolation?" said Pierre.
"Nothing! Why had such a splendid boy, so full of life, to die?"

"Yes, in these days it would be hard to live without faith..."
remarked Princess Mary.

"Yes, yes, that is really true," Pierre hastily interrupted her.

"Why is it true?" Natasha asked, looking attentively into Pierre's
eyes.

"How can you ask why?" said Princess Mary. "The thought alone of
what awaits..."

Natasha without waiting for Princess Mary to finish again looked
inquiringly at Pierre.

"And because," Pierre continued, "only one who believes that there
is a God ruling us can bear a loss such as hers and... yours."

Natasha had already opened her mouth to speak but suddenly
stopped. Pierre hurriedly turned away from her and again addressed
Princess Mary, asking about his friend's last days.

Pierre's confusion had now almost vanished, but at the same time
he felt that his freedom had also completely gone. He felt that
there was now a judge of his every word and action whose judgment
mattered more to him than that of all the rest of the world. As he
spoke now he was considering what impression his words would make on
Natasha. He did not purposely say things to please her, but whatever
he was saying he regarded from her standpoint.

Princess Mary--reluctantly as is usual in such cases--began
telling of the condition in which she had found Prince Andrew. But
Pierre's face quivering with emotion, his questions and his eager
restless expression, gradually compelled her to go into details
which she feared to recall for her own sake.

"Yes, yes, and so...?" Pierre kept saying as he leaned toward her
with his whole body and eagerly listened to her story. "Yes, yes... so
he grew tranquil and softened? With all his soul he had always
sought one thing--to be perfectly good--so he could not be afraid of
death. The faults he had--if he had any--were not of his making. So he
did soften?... What a happy thing that he saw you again," he added,
suddenly turning to Natasha and looking at her with eyes full of
tears.

Natasha's face twitched. She frowned and lowered her eyes for a
moment. She hesitated for an instant whether to speak or not.

"Yes, that was happiness," she then said in her quiet voice with its
deep chest notes. "For me it certainly was happiness." She paused.
"And he... he... he said he was wishing for it at the very moment I
entered the room...."

Natasha's voice broke. She blushed, pressed her clasped hands on her
knees, and then controlling herself with an evident effort lifted
her head and began to speak rapidly.

"We knew nothing of it when we started from Moscow. I did not dare
to ask about him. Then suddenly Sonya told me he was traveling with
us. I had no idea and could not imagine what state he was in, all I
wanted was to see him and be with him," she said, trembling, and
breathing quickly.

And not letting them interrupt her she went on to tell what she
had never yet mentioned to anyone--all she had lived through during
those three weeks of their journey and life at Yaroslavl.

Pierre listened to her with lips parted and eyes fixed upon her full
of tears. As he listened he did not think of Prince Andrew, nor of
death, nor of what she was telling. He listened to her and felt only
pity for her, for what she was suffering now while she was speaking.

Princess Mary, frowning in her effort to hold back her tears, sat
beside Natasha, and heard for the first time the story of those last
days of her brother's and Natasha's love.

Evidently Natasha needed to tell that painful yet joyful tale.

She spoke, mingling most trifling details with the intimate
secrets of her soul, and it seemed as if she could never finish.
Several times she repeated the same thing twice.

Dessalles' voice was heard outside the door asking whether little
Nicholas might come in to say good night.

"Well, that's all--everything," said Natasha.

She got up quickly just as Nicholas entered, almost ran to the
door which was hidden by curtains, struck her head against it, and
rushed from the room with a moan either of pain or sorrow.

Pierre gazed at the door through which she had disappeared and did
not understand why he suddenly felt all alone in the world.

Princess Mary roused him from his abstraction by drawing his
attention to her nephew who had entered the room.

At that moment of emotional tenderness young Nicholas' face, which
resembled his father's, affected Pierre so much that when he had
kissed the boy he got up quickly, took out his handkerchief, and
went to the window. He wished to take leave of Princess Mary, but
she would not let him go.

"No, Natasha and I sometimes don't go to sleep till after two, so
please don't go. I will order supper. Go downstairs, we will come
immediately."

Before Pierre left the room Princess Mary told him: "This is the
first time she has talked of him like that."





CHAPTER XVII


Pierre was shown into the large, brightly lit dining room; a few
minutes later he heard footsteps and Princess Mary entered with
Natasha. Natasha was calm, though a severe and grave expression had
again settled on her face. They all three of them now experienced that
feeling of awkwardness which usually follows after a serious and
heartfelt talk. It is impossible to go back to the same
conversation, to talk of trifles is awkward, and yet the desire to
speak is there and silence seems like affectation. They went
silently to table. The footmen drew back the chairs and pushed them up
again. Pierre unfolded his cold table napkin and, resolving to break
the silence, looked at Natasha and at Princess Mary. They had
evidently both formed the same resolution; the eyes of both shone with
satisfaction and a confession that besides sorrow life also has joy.

"Do you take vodka, Count?" asked Princess Mary, and those words
suddenly banished the shadows of the past. "Now tell us about
yourself," said she. "One hears such improbable wonders about you."

"Yes," replied Pierre with the smile of mild irony now habitual to
him. "They even tell me wonders I myself never dreamed of! Mary
Abramovna invited me to her house and kept telling me what had
happened, or ought to have happened, to me. Stepan Stepanych also
instructed me how I ought to tell of my experiences. In general I have
noticed that it is very easy to be an interesting man (I am an
interesting man now); people invite me out and tell me all about
myself."

Natasha smiled and was on the point of speaking.

"We have been told," Princess Mary interrupted her, "that you lost
two millions in Moscow. Is that true?"

"But I am three times as rich as before," returned Pierre.

Though the position was now altered by his decision to pay his
wife's debts and to rebuild his houses, Pierre still maintained that
he had become three times as rich as before.

"What I have certainly gained is freedom," he began seriously, but
did not continue, noticing that this theme was too egotistic.

"And are you building?"

"Yes. Savelich says I must!"

"Tell me, you did not know of the countess' death when you decided
to remain in Moscow?" asked Princess Mary and immediately blushed,
noticing that her question, following his mention of freedom, ascribed
to his words a meaning he had perhaps not intended.

"No," answered Pierre, evidently not considering awkward the meaning
Princess Mary had given to his words. "I heard of it in Orel and you
cannot imagine how it shocked me. We were not an exemplary couple," he
added quickly, glancing at Natasha and noticing on her face
curiosity as to how he would speak of his wife, "but her death shocked
me terribly. When two people quarrel they are always both in fault,
and one's own guilt suddenly becomes terribly serious when the other
is no longer alive. And then such a death... without friends and
without consolation! I am very, very sorry for her," he concluded, and
was pleased to notice a look of glad approval on Natasha's face.

"Yes, and so you are once more an eligible bachelor," said
Princess Mary.

Pierre suddenly flushed crimson and for a long time tried not to
look at Natasha. When he ventured to glance her way again her face was
cold, stern, and he fancied even contemptuous.

"And did you really see and speak to Napoleon, as we have been
told?" said Princess Mary.

Pierre laughed.

"No, not once! Everybody seems to imagine that being taken
prisoner means being Napoleon's guest. Not only did I never see him
but I heard nothing about him--I was in much lower company!"

Supper was over, and Pierre who at first declined to speak about his
captivity was gradually led on to do so.

"But it's true that you remained in Moscow to kill Napoleon?"
Natasha asked with a slight smile. "I guessed it then when we met at
the Sukharev tower, do you remember?"

Pierre admitted that it was true, and from that was gradually led by
Princess Mary's questions and especially by Natasha's into giving a
detailed account of his adventures.

At first he spoke with the amused and mild irony now customary
with him toward everybody and especially toward himself, but when he
came to describe the horrors and sufferings he had witnessed he was
unconsciously carried away and began speaking with the suppressed
emotion of a man re-experiencing in recollection strong impressions he
has lived through.

Princess Mary with a gentle smile looked now at Pierre and now at
Natasha. In the whole narrative she saw only Pierre and his
goodness. Natasha, leaning on her elbow, the expression of her face
constantly changing with the narrative, watched Pierre with an
attention that never wandered--evidently herself experiencing all that
he described. Not only her look, but her exclamations and the brief
questions she put, showed Pierre that she understood just what he
wished to convey. It was clear that she understood not only what he
said but also what he wished to, but could not, express in words.
The account Pierre gave of the incident with the child and the woman
for protecting whom he was arrested was this: "It was an awful
sight--children abandoned, some in the flames... One was snatched
out before my eyes... and there were women who had their things
snatched off and their earrings torn out..." he flushed and grew
confused. "Then a patrol arrived and all the men--all those who were

not looting, that is--were arrested, and I among them."

"I am sure you're not telling us everything; I am sure you did
something..." said Natasha and pausing added, "something fine?"

Pierre continued. When he spoke of the execution he wanted to pass
over the horrible details, but Natasha insisted that he should not
omit anything.

Pierre began to tell about Karataev, but paused. By this time he had
risen from the table and was pacing the room, Natasha following him
with her eyes. Then he added:

"No, you can't understand what I learned from that illiterate man-
that simple fellow."

"Yes, yes, go on!" said Natasha. "Where is he?"

"They killed him almost before my eyes."

And Pierre, his voice trembling continually, went on to tell of
the last days of their retreat, of Karataev's illness and his death.

He told of his adventures as he had never yet recalled them. He now,
as it were, saw a new meaning in all he had gone through. Now that
he was telling it all to Natasha he experienced that pleasure which
a man has when women listen to him--not clever women who when
listening either try to remember what they hear to enrich their
minds and when opportunity offers to retell it, or who wish to adopt
it to some thought of their own and promptly contribute their own
clever comments prepared in their little mental workshop--but the
pleasure given by real women gifted with a capacity to select and
absorb the very best a man shows of himself. Natasha without knowing
it was all attention: she did not lose a word, no single quiver in
Pierre's voice, no look, no twitch of a muscle in his face, nor a
single gesture. She caught the unfinished word in its flight and
took it straight into her open heart, divining the secret meaning of
all Pierre's mental travail.

Princess Mary understood his story and sympathized with him, but she
now saw something else that absorbed all her attention. She saw the
possibility of love and happiness between Natasha and Pierre, and
the first thought of this filled her heart with gladness.

It was three o'clock in the morning. The footmen came in with sad
and stern faces to change the candles, but no one noticed them.

Pierre finished his story. Natasha continued to look at him intently
with bright, attentive, and animated eyes, as if trying to
understand something more which he had perhaps left untold. Pierre
in shamefaced and happy confusion glanced occasionally at her, and
tried to think what to say next to introduce a fresh subject. Princess
Mary was silent. It occurred to none of them that it was three o'clock
and time to go to bed.

"People speak of misfortunes and sufferings," remarked Pierre,
"but if at this moment I were asked: 'Would you rather be what you
were before you were taken prisoner, or go through all this again?'
then for heaven's sake let me again have captivity and horseflesh!
We imagine that when we are thrown out of our usual ruts all is
lost, but it is only then that what is new and good begins. While
there is life there is happiness. There is much, much before us. I say
this to you," he added, turning to Natasha.

"Yes, yes," she said, answering something quite different. "I too
should wish nothing but to relive it all from the beginning."

Pierre looked intently at her.

"Yes, and nothing more." said Natasha.

"It's not true, not true!" cried Pierre. "I am not to blame for
being alive and wishing to live--nor you either."

Suddenly Natasha bent her head, covered her face with her hands, and
began to cry.

"What is it, Natasha?" said Princess Mary.

"Nothing, nothing." She smiled at Pierre through her tears. "Good
night! It is time for bed."

Pierre rose and took his leave.


Princess Mary and Natasha met as usual in the bedroom. They talked
of what Pierre had told them. Princess Mary did not express her
opinion of Pierre nor did Natasha speak of him.

"Well, good night, Mary!" said Natasha. "Do you know, I am often
afraid that by not speaking of him" (she meant Prince Andrew) "for
fear of not doing justice to our feelings, we forget him."

Princess Mary sighed deeply and thereby acknowledged the justice
of Natasha's remark, but she did not express agreement in words.

"Is it possible to forget?" said she.

"It did me so much good to tell all about it today. It was hard
and painful, but good, very good!" said Natasha. "I am sure he
really loved him. That is why I told him... Was it all right?" she
added, suddenly blushing.

"To tell Pierre? Oh, yes. What a splendid man he is!" said
Princess Mary.

"Do you know, Mary..." Natasha suddenly said with a mischievous
smile such as Princess Mary had not seen on her face for a long
time, "he has somehow grown so clean, smooth, and fresh--as if he
had just come out of a Russian bath; do you understand? Out of a moral
bath. Isn't it true?"

"Yes," replied Princess Mary. "He has greatly improved."

"With a short coat and his hair cropped; just as if, well, just as
if he had come straight from the bath... Papa used to..."

"I understand why he" (Prince Andrew) "liked no one so much as him,"
said Princess Mary.

"Yes, and yet he is quite different. They say men are friends when
they are quite different. That must be true. Really he is quite unlike
him--in everything."

"Yes, but he's wonderful."

"Well, good night," said Natasha.

And the same mischievous smile lingered for a long time on her
face as if it had been forgotten there.




CHAPTER XVIII


It was a long time before Pierre could fall asleep that night. He
paced up and down his room, now turning his thoughts on a difficult
problem and frowning, now suddenly shrugging his shoulders and
wincing, and now smiling happily.

He was thinking of Prince Andrew, of Natasha, and of their love,
at one moment jealous of her past, then reproaching himself for that
feeling. It was already six in the morning and he still paced up and
down the room.

"Well, what's to be done if it cannot be avoided? What's to be done?
Evidently it has to be so," said he to himself, and hastily undressing
he got into bed, happy and agitated but free from hesitation or
indecision.

"Strange and impossible as such happiness seems, I must do
everything that she and I may be man and wife," he told himself.

A few days previously Pierre had decided to go to Petersburg on
the Friday. When he awoke on the Thursday, Savelich came to ask him
about packing for the journey.

"What, to Petersburg? What is Petersburg? Who is there in
Petersburg?" he asked involuntarily, though only to himself. "Oh, yes,
long ago before this happened I did for some reason mean to go to
Petersburg," he reflected. "Why? But perhaps I shall go. What a good
fellow he is and how attentive, and how he remembers everything," he
thought, looking at Savelich's old face, "and what a pleasant smile he
has!"

"Well, Savelich, do you still not wish to accept your freedom?"
Pierre asked him.

"What's the good of freedom to me, your excellency? We lived under
the late count--the kingdom of heaven be his!--and we have lived under
you too, without ever being wronged."

"And your children?"

"The children will live just the same. With such masters one can
live."

"But what about my heirs?" said Pierre. "Supposing I suddenly
marry... it might happen," he added with an involuntary smile.

"If I may take the liberty, your excellency, it would be a good
thing."

"How easy he thinks it," thought Pierre. "He doesn't know how
terrible it is and how dangerous. Too soon or too late... it is
terrible!"

"So what are your orders? Are you starting tomorrow?" asked
Savelich.

"No, I'll put it off for a bit. I'll tell you later. You must
forgive the trouble I have put you to," said Pierre, and seeing
Savelich smile, he thought: "But how strange it is that he should
not know that now there is no Petersburg for me, and that that must be
settled first of all! But probably he knows it well enough and is only
pretending. Shall I have a talk with him and see what he thinks?"
Pierre reflected. "No, another time."

At breakfast Pierre told the princess, his cousin, that he had
been to see Princess Mary the day before and had there met--"Whom do
you think? Natasha Rostova!"

The princess seemed to see nothing more extraordinary in that than
if he had seen Anna Semenovna.

"Do you know her?" asked Pierre.

"I have seen the princess," she replied. "I heard that they were
arranging a match for her with young Rostov. It would be a very good
thing for the Rostovs, they are said to be utterly ruined."

"No; I mean do you know Natasha Rostova?"

"I heard about that affair of hers at the time. It was a great
pity."

"No, she either doesn't understand or is pretending," thought
Pierre. "Better not say anything to her either."

The princess too had prepared provisions for Pierre's journey.

"How kind they all are," thought Pierre. "What is surprising is that
they should trouble about these things now when it can no longer be of
interest to them. And all for me!"

On the same day the Chief of Police came to Pierre, inviting him
to send a representative to the Faceted Palace to recover things
that were to be returned to their owners that day.

"And this man too," thought Pierre, looking into the face of the
Chief of Police. "What a fine, good-looking officer and how kind.
Fancy bothering about such trifies now! And they actually say he is
not honest and takes bribes. What nonsense! Besides, why shouldn't
he take bribes? That's the way he was brought up, and everybody does
it. But what a kind, pleasant face and how he smiles as he looks at
me."

Pierre went to Princess Mary's to dinner.

As he drove through the streets past the houses that had been burned
down, he was surprised by the beauty of those ruins. The
picturesqueness of the chimney stacks and tumble-down walls of the
burned-out quarters of the town, stretching out and concealing one
another, reminded him of the Rhine and the Colosseum. The cabmen he
met and their passengers, the carpenters cutting the timber for new
houses with axes, the women hawkers, and the shopkeepers, all looked
at him with cheerful beaming eyes that seemed to say: "Ah, there he
is! Let's see what will come of it!"

At the entrance to Princess Mary's house Pierre felt doubtful
whether he had really been there the night before and really seen
Natasha and talked to her. "Perhaps I imagined it; perhaps I shall
go in and find no one there." But he had hardly entered the room
before he felt her presence with his whole being by the loss of his
sense of freedom. She was in the same black dress with soft folds
and her hair was done the same way as the day before, yet she was
quite different. Had she been like this when he entered the day before
he could not for a moment have failed to recognize her.

She was as he had known her almost as a child and later on as Prince
Andrew's fiancee. A bright questioning light shone in her eyes, and on
her face was a friendly and strangely roguish expression.

Pierre dined with them and would have spent the whole evening there,
but Princess Mary was going to vespers and Pierre left the house
with her.

Next day he came early, dined, and stayed the whole evening.
Though Princess Mary and Natasha were evidently glad to see their
visitor and though all Pierre's interest was now centered in that
house, by the evening they had talked over everything and the
conversation passed from one trivial topic to another and repeatedly
broke off. He stayed so long that Princess Mary and Natasha
exchanged glances, evidently wondering when he would go. Pierre
noticed this but could not go. He felt uneasy and embarrassed, but sat
on because he simply could not get up and take his leave.

Princess Mary, foreseeing no end to this, rose first, and
complaining of a headache began to say good night.

"So you are going to Petersburg tomorrow?" she asked.

"No, I am not going," Pierre replied hastily, in a surprised tone
and as though offended. "Yes... no... to Petersburg? Tomorrow--but I
won't say good-by yet. I will call round in case you have any
commissions for me," said he, standing before Princess Mary and
turning red, but not taking his departure.

Natasha gave him her hand and went out. Princess Mary on the other
hand instead of going away sank into an armchair, and looked sternly
and intently at him with her deep, radiant eyes. The weariness she had
plainly shown before had now quite passed off. With a deep and
long-drawn sigh she seemed to be prepared for a lengthy talk.

When Natasha left the room Pierre's confusion and awkwardness
immediately vanished and were replaced by eager excitement. He quickly
moved an armchair toward Princess Mary.

"Yes, I wanted to tell you," said he, answering her look as if she
had spoken. "Princess, help me! What am I to do? Can I hope? Princess,
my dear friend, listen! I know it all. I know I am not worthy of
her, I know it's impossible to speak of it now. But I want to be a
brother to her. No, not that, I don't, I can't..."

He paused and rubbed his face and eyes with his hands.

"Well," he went on with an evident effort at self-control and
coherence. "I don't know when I began to love her, but I have loved
her and her alone all my life, and I love her so that I cannot imagine
life without her. I cannot propose to her at present, but the
thought that perhaps she might someday be my wife and that I may be
missing that possibility... that possibility... is terrible. Tell
me, can I hope? Tell me what I am to do, dear princess!" he added
after a pause, and touched her hand as she did not reply.

"I am thinking of what you have told me," answered Princess Mary.
"This is what I will say. You are right that to speak to her of love
at present..."

Princess Mary stopped. She was going to say that to speak of love
was impossible, but she stopped because she had seen by the sudden
change in Natasha two days before that she would not only not be
hurt if Pierre spoke of his love, but that it was the very thing she
wished for.

"To speak to her now wouldn't do," said the princess all the same.

"But what am I to do?"

"Leave it to me," said Princess Mary. "I know..."

Pierre was looking into Princess Mary's eyes.

"Well?... Well?..." he said.

"I know that she loves... will love you," Princess Mary corrected
herself.

Before her words were out, Pierre had sprung up and with a
frightened expression seized Princess Mary's hand.

"What makes you think so? You think I may hope? You think...?"

"Yes, I think so," said Princess Mary with a smile. "Write to her
parents, and leave it to me. I will tell her when I can. I wish it
to happen and my heart tells me it will."

"No, it cannot be! How happy I am! But it can't be.... How happy I
am! No, it can't be!" Pierre kept saying as he kissed Princess
Mary's hands.

"Go to Petersburg, that will be best. And I will write to you,"
she said.

"To Petersburg? Go there? Very well, I'll go. But I may come again
tomorrow?"

Next day Pierre came to say good-by. Natasha was less animated
than she had been the day before; but that day as he looked at her
Pierre sometimes felt as if he was vanishing and that neither he nor
she existed any longer, that nothing existed but happiness. "Is it
possible? No, it can't be," he told himself at every look, gesture,
and word that filled his soul with joy.

When on saying good-by he took her thin, slender hand, he could
not help holding it a little longer in his own.

"Is it possible that this hand, that face, those eyes, all this
treasure of feminine charm so strange to me now, is it possible that
it will one day be mine forever, as familiar to me as I am to
myself?... No, that's impossible!..."

"Good-by, Count," she said aloud. "I shall look forward very much to
your return," she added in a whisper.

And these simple words, her look, and the expression on her face
which accompanied them, formed for two months the subject of
inexhaustible memories, interpretations, and happy meditations for
Pierre. "'I shall look forward very much to your return....' Yes, yes,
how did she say it? Yes, 'I shall look forward very much to your
return.' Oh, how happy I am! What is happening to me? How happy I am!"
said Pierre to himself.





CHAPTER XIX


There was nothing in Pierre's soul now at all like what had troubled
it during his courtship of Helene.

He did not repeat to himself with a sickening feeling of shame the
words he had spoken, or say: "Oh, why did I not say that?" and,
"Whatever made me say 'Je vous aime'?" On the contrary, he now
repeated in imagination every word that he or Natasha had spoken and
pictured every detail of her face and smile, and did not wish to
diminish or add anything, but only to repeat it again and again. There
was now not a shadow of doubt in his mind as to whether what he had
undertaken was right or wrong. Only one terrible doubt sometimes
crossed his mind: "Wasn't it all a dream? Isn't Princess Mary
mistaken? Am I not too conceited and self-confident? I believe all
this--and suddenly Princess Mary will tell her, and she will be sure
to smile and say: 'How strange! He must be deluding himself. Doesn't
he know that he is a man, just a man, while I...? I am something
altogether different and higher.'"

That was the only doubt often troubling Pierre. He did not now
make any plans. The happiness before him appeared so inconceivable
that if only he could attain it, it would be the end of all things.
Everything ended with that.

A joyful, unexpected frenzy, of which he had thought himself
incapable, possessed him. The whole meaning of life--not for him alone
but for the whole world--seemed to him centered in his love and the
possibility of being loved by her. At times everybody seemed to him to
be occupied with one thing only--his future happiness. Sometimes it
seemed to him that other people were all as pleased as he was
himself and merely tried to hide that pleasure by pretending to be
busy with other interests. In every word and gesture he saw
allusions to his happiness. He often surprised those he met by his
significantly happy looks and smiles which seemed to express a
secret understanding between him and them. And when he realized that
people might not be aware of his happiness, he pitied them with his
whole heart and felt a desire somehow to explain to them that all that
occupied them was a mere frivolous trifle unworthy of attention.

When it was suggested to him that he should enter the civil service,
or when the war or any general political affairs were discussed on the
assumption that everybody's welfare depended on this or that issue
of events, he would listen with a mild and pitying smile and
surprise people by his strange comments. But at this time he saw
everybody--both those who, as he imagined, understood the real meaning
of life (that is, what he was feeling) and those unfortunates who
evidently did not understand it--in the bright light of the emotion
that shone within himself, and at once without any effort saw in
everyone he met everything that was good and worthy of being loved.

When dealing with the affairs and papers of his dead wife, her
memory aroused in him no feeling but pity that she had not known the
bliss he now knew. Prince Vasili, who having obtained a new post and
some fresh decorations was particularly proud at this time, seemed
to him a pathetic, kindly old man much to be pitied.

Often in afterlife Pierre recalled this period of blissful insanity.
All the views he formed of men and circumstances at this time remained
true for him always. He not only did not renounce them subsequently,
but when he was in doubt or inwardly at variance, he referred to the
views he had held at this time of his madness and they always proved
correct.

"I may have appeared strange and queer then," he thought, "but I was
not so mad as I seemed. On the contrary I was then wiser and had
more insight than at any other time, and understood all that is
worth understanding in life, because... because I was happy."

Pierre's insanity consisted in not waiting, as he used to do, to
discover personal attributes which he termed "good qualities" in
people before loving them; his heart was now overflowing with love,
and by loving people without cause he discovered indubitable causes
for loving them.





CHAPTER XX


After Pierre's departure that first evening, when Natasha had said
to Princess Mary with a gaily mocking smile: "He looks just, yes, just
as if he had come out of a Russian bath--in a short coat and with
his hair cropped," something hidden and unknown to herself, but
irrepressible, awoke in Natasha's soul.

Everything: her face, walk, look, and voice, was suddenly altered.
To her own surprise a power of life and hope of happiness rose to
the surface and demanded satisfaction. From that evening she seemed to
have forgotten all that had happened to her. She no longer
complained of her position, did not say a word about the past, and
no longer feared to make happy plans for the future. She spoke
little of Pierre, but when Princess Mary mentioned him a
long-extinguished light once more kindled in her eyes and her lips
curved with a strange smile.

The change that took place in Natasha at first surprised Princess
Mary; but when she understood its meaning it grieved her. "Can she
have loved my brother so little as to be able to forget him so
soon?" she thought when she reflected on the change. But when she
was with Natasha she was not vexed with her and did not reproach
her. The reawakened power of life that had seized Natasha was so
evidently irrepressible and unexpected by her that in her presence
Princess Mary felt that she had no right to reproach her even in her
heart.

 Natasha gave herself up so fully and frankly to this new feeling
that she did not try to hide the fact that she was no longer sad,
but bright and cheerful.

When Princess Mary returned to her room after her nocturnal talk
with Pierre, Natasha met her on the threshold.

"He has spoken? Yes? He has spoken?" she repeated.

And a joyful yet pathetic expression which seemed to beg forgiveness
for her joy settled on Natasha's face.

"I wanted to listen at the door, but I knew you would tell me."

Understandable and touching as the look with which Natasha gazed
at her seemed to Princess Mary, and sorry as she was to see her
agitation, these words pained her for a moment. She remembered her
brother and his love.

"But what's to be done? She can't help it," thought the princess.

And with a sad and rather stern look she told Natasha all that
Pierre had said. On hearing that he was going to Petersburg Natasha
was astounded.

"To Petersburg!" she repeated as if unable to understand.

But noticing the grieved expression on Princess Mary's face she
guessed the reason of that sadness and suddenly began to cry.

"Mary," said she, "tell me what I should do! I am afraid of being
bad. Whatever you tell me, I will do. Tell me...."

"You love him?"

"Yes," whispered Natasha.

"Then why are you crying? I am happy for your sake," said Princess
Mary, who because of those tears quite forgave Natasha's joy.

"It won't be just yet--someday. Think what fun it will be when I
am his wife and you marry Nicholas!"

"Natasha, I have asked you not to speak of that. Let us talk about
you."

They were silent awhile.

"But why go to Petersburg?" Natasha suddenly asked, and hastily
replied to her own question. "But no, no, he must... Yes, Mary, He
must...."






FIRST EPILOGUE: 1813 --20





CHAPTER I


Seven years had passed. The storm-tossed sea of European history had
subsided within its shores and seemed to have become calm. But the
mysterious forces that move humanity (mysterious because the laws of
their motion are unknown to us) continued to operate.

Though the surface of the sea of history seemed motionless, the
movement of humanity went on as unceasingly as the flow of time.
Various groups of people formed and dissolved, the coming formation
and dissolution of kingdoms and displacement of peoples was in
course of preparation.

The sea of history was not driven spasmodically from shore to
shore as previously. It was seething in its depths. Historic figures
were not borne by the waves from one shore to another as before.
They now seemed to rotate on one spot. The historical figures at the
head of armies, who formerly reflected the movement of the masses by
ordering wars, campaigns, and battles, now reflected the restless
movement by political and diplomatic combinations, laws, and treaties.

The historians call this activity of the historical figures "the
reaction."

In dealing with this period they sternly condemn the historical
personages who, in their opinion, caused what they describe as the
reaction. All the well-known people of that period, from Alexander and
Napoleon to Madame de Stael, Photius, Schelling, Fichte,
Chateaubriand, and the rest, pass before their stern judgment seat and
are acquitted or condemned according to whether they conduced to
progress or to reaction.

According to their accounts a reaction took place at that time in
Russia also, and the chief culprit was Alexander I, the same man who
according to them was the chief cause of the liberal movement at the
commencement of his reign, being the savior of Russia.

There is no one in Russian literature now, from schoolboy essayist
to learned historian, who does not throw his little stone at Alexander
for things he did wrong at this period of his reign.

"He ought to have acted in this way and in that way. In this case he
did well and in that case badly. He behaved admirably at the beginning
of his reign and during 1812, but acted badly by giving a constitution
to Poland, forming the Holy Alliance, entrusting power to Arakcheev,
favoring Golitsyn and mysticism, and afterwards Shishkov and
Photius. He also acted badly by concerning himself with the active
army and disbanding the Semenov regiment."

It would take a dozen pages to enumerate all the reproaches the
historians address to him, based on their knowledge of what is good
for humanity.

What do these reproaches mean?

Do not the very actions for which the historians praise Alexander
I (the liberal attempts at the beginning of his reign, his struggle
with Napoleon, the firmness he displayed in 1812 and the campaign of
1813) flow from the same sources--the circumstances of his birth,
education, and life--that made his personality what it was and from
which the actions for which they blame him (the Holy Alliance, the
restoration of Poland, and the reaction of 1820 and later) also
flowed?

In what does the substance of those reproaches lie?

It lies in the fact that an historic character like Alexander I,
standing on the highest possible pinnacle of human power with the
blinding light of history focused upon him; a character exposed to
those strongest of all influences: the intrigues, flattery, and
self-deception inseparable from power; a character who at every moment
of his life felt a responsibility for all that was happening in
Europe; and not a fictitious but a live character who like every man
had his personal habits, passions, and impulses toward goodness,
beauty, and truth--that this character--though not lacking in virtue
(the historians do not accuse him of that)--had not the same
conception of the welfare of humanity fifty years ago as a present-day
professor who from his youth upwards has been occupied with
learning: that is, with books and lectures and with taking notes
from them.

But even if we assume that fifty years ago Alexander I was
mistaken in his view of what was good for the people, we must
inevitably assume that the historian who judges Alexander will also
after the lapse of some time turn out to be mistaken in his view of
what is good for humanity. This assumption is all the more natural and
inevitable because, watching the movement of history, we see that
every year and with each new writer, opinion as to what is good for
mankind changes; so that what once seemed good, ten years later
seems bad, and vice versa. And what is more, we find at one and the
same time quite contradictory views as to what is bad and what is good
in history: some people regard giving a constitution to Poland and
forming the Holy Alliance as praiseworthy in Alexander, while others
regard it as blameworthy.

The activity of Alexander or of Napoleon cannot be called useful
or harmful, for it is impossible to say for what it was useful or
harmful. If that activity displeases somebody, this is only because it
does not agree with his limited understanding of what is good. Whether
the preservation of my father's house in Moscow, or the glory of the
Russian arms, or the prosperity of the Petersburg and other
universities, or the freedom of Poland or the greatness of Russia,
or the balance of power in Europe, or a certain kind of European
culture called "progress" appear to me to be good or bad, I must admit
that besides these things the action of every historic character has
other more general purposes inaccessible to me.

But let us assume that what is called science can harmonize all
contradictions and possesses an unchanging standard of good and bad by
which to try historic characters and events; let us say that Alexander
could have done everything differently; let us say that with
guidance from those who blame him and who profess to know the ultimate
aim of the movement of humanity, he might have arranged matters
according to the program his present accusers would have given him--of
nationality, freedom, equality, and progress (these, I think, cover
the ground). Let us assume that this program was possible and had then
been formulated, and that Alexander had acted on it. What would then
have become of the activity of all those who opposed the tendency that
then prevailed in the government--an activity that in the opinion of
the historians was good and beneficent? Their activity would not
have existed: there would have been no life, there would have been
nothing.

If we admit that human life can be ruled by reason, the
possibility of life is destroyed.





CHAPTER II


If we assume as the historians do that great men lead humanity to
the attainment of certain ends--the greatness of Russia or of
France, the balance of power in Europe, the diffusion of the ideas
of the Revolution general progress or anything else--then it is
impossible to explain the facts of history without introducing the
conceptions of chance and genius.

If the aim of the European wars at the beginning of the nineteenth
century had been the aggrandizement of Russia, that aim might have
been accomplished without all the preceding wars and without the
invasion. If the aim was the aggrandizement of France, that might have
been attained without the Revolution and without the Empire. If the
aim was the dissemination of ideas, the printing press could have
accomplished that much better than warfare. If the aim was the
progress of civilization, it is easy to see that there are other
ways of diffusing civilization more expedient than by the
destruction of wealth and of human lives.

Why did it happen in this and not in some other way?

Because it happened so! "Chance created the situation; genius
utilized it," says history.

But what is chance? What is genius?

The words chance and genius do not denote any really existing
thing and therefore cannot be defined. Those words only denote a
certain stage of understanding of phenomena. I do not know why a
certain event occurs; I think that I cannot know it; so I do not try
to know it and I talk about chance. I see a force producing effects
beyond the scope of ordinary human agencies; I do not understand why
this occurs and I talk of genius.

To a herd of rams, the ram the herdsman drives each evening into a
special enclosure to feed and that becomes twice as fat as the
others must seem to be a genius. And it must appear an astonishing
conjunction of genius with a whole series of extraordinary chances
that this ram, who instead of getting into the general fold every
evening goes into a special enclosure where there are oats--that
this very ram, swelling with fat, is killed for meat.

But the rams need only cease to suppose that all that happens to
them happens solely for the attainment of their sheepish aims; they
need only admit that what happens to them may also have purposes
beyond their ken, and they will at once perceive a unity and coherence
in what happened to the ram that was fattened. Even if they do not
know for what purpose they are fattened, they will at least know
that all that happened to the ram did not happen accidentally, and
will no longer need the conceptions of chance or genius.

Only by renouncing our claim to discern a purpose immediately
intelligible to us, and admitting the ultimate purpose to be beyond
our ken, may we discern the sequence of experiences in the lives of
historic characters and perceive the cause of the effect they
produce (incommensurable with ordinary human capabilities), and then
the words chance and genius become superfluous.

We need only confess that we do not know the purpose of the European
convulsions and that we know only the facts--that is, the murders,
first in France, then in Italy, in Africa, in Prussia, in Austria,
in Spain, and in Russia--and that the movements from the west to the
east and from the east to the west form the essence and purpose of
these events, and not only shall we have no need to see exceptional
ability and genius in Napoleon and Alexander, but we shall be unable
to consider them to be anything but like other men, and we shall not
be obliged to have recourse to chance for an explanation of those
small events which made these people what they were, but it will be
clear that all those small events were inevitable.

By discarding a claim to knowledge of the ultimate purpose, we shall
clearly perceive that just as one cannot imagine a blossom or seed for
any single plant better suited to it than those it produces, so it
is impossible to imagine any two people more completely adapted down
to the smallest detail for the purpose they had to fulfill, than
Napoleon and Alexander with all their antecedents.





CHAPTER III


The fundamental and essential significance of the European events of
the beginning of the nineteenth century lies in the movement of the
mass of the European peoples from west to east and afterwards from
east to west. The commencement of that movement was the movement
from west to east. For the peoples of the west to be able to make
their warlike movement to Moscow it was necessary: (1) that they
should form themselves into a military group of a size able to
endure a collision with the warlike military group of the east, (2)
that they should abandon all established traditions and customs, and
(3) that during their military movement they should have at their head
a man who could justify to himself and to them the deceptions,
robberies, and murders which would have to be committed during that
movement.

And beginning with the French Revolution the old inadequately
large group was destroyed, as well as the old habits and traditions,
and step by step a group was formed of larger dimensions with new
customs and traditions, and a man was produced who would stand at
the head of the coming movement and bear the responsibility for all
that had to be done.

A man without convictions, without habits, without traditions,
without a name, and not even a Frenchman, emerges--by what seem the
strangest chances--from among all the seething French parties, and
without joining any one of them is borne forward to a prominent
position.

The ignorance of his colleagues, the weakness and insignificance
of his opponents, the frankness of his falsehoods, and the dazzling
and self-confident limitations of this man raise him to the head of
the army. The brilliant qualities of the soldiers of the army sent
to Italy, his opponents' reluctance to fight, and his own childish
audacity and self-confidence secure him military fame. Innumerable
so called chances accompany him everywhere. The disfavor into which he
falls with the rulers of France turns to his advantage. His attempts
to avoid his predestined path are unsuccessful: he is not received
into the Russian service, and the appointment he seeks in Turkey comes
to nothing. During the war in Italy he is several times on the verge
of destruction and each time is saved in an unexpected manner. Owing
to various diplomatic considerations the Russian armies--just those
which might have destroyed his prestige--do not appear upon the
scene till he is no longer there.

On his return from Italy he finds the government in Paris in a
process of dissolution in which all those who are in it are inevitably
wiped out and destroyed. And by chance an escape from this dangerous
position presents itself in the form of an aimless and senseless
expedition to Africa. Again so-called chance accompanies him.
Impregnable Malta surrenders without a shot; his most reckless schemes
are crowned with success. The enemy's fleet, which subsequently did
not let a single boat pass, allows his entire army to elude it. In
Africa a whole series of outrages are committed against the almost
unarmed inhabitants. And the men who commit these crimes, especially
their leader, assure themselves that this is admirable, this is glory-
it resembles Caesar and Alexander the Great and is therefore good.

This ideal of glory and grandeur--which consists not merely in
considering nothing wrong that one does but in priding oneself on
every crime one commits, ascribing to it an incomprehensible
supernatural significance--that ideal, destined to guide this man
and his associates, had scope for its development in Africa.
Whatever he does succeeds. The plague does not touch him. The
cruelty of murdering prisoners is not imputed to him as a fault. His
childishly rash, uncalled-for, and ignoble departure from Africa,
leaving his comrades in distress, is set down to his credit, and again
the enemy's fleet twice lets him slip past. When, intoxicated by the
crimes he has committed so successfully, he reaches Paris, the
dissolution of the republican government, which a year earlier might
have ruined him, has reached its extreme limit, and his presence there
now as a newcomer free from party entanglements can only serve to
exalt him--and though he himself has no plan, he is quite ready for
his new role.

He had no plan, he was afraid of everything, but the parties
snatched at him and demanded his participation.

He alone--with his ideal of glory and grandeur developed in Italy
and Egypt, his insane self-adulation, his boldness in crime and
frankness in lying--he alone could justify what had to be done.

He is needed for the place that awaits him, and so almost apart from
his will and despite his indecision, his lack of a plan, and all his
mistakes, he is drawn into a conspiracy that aims at seizing power and
the conspiracy is crowned with success.

He is pushed into a meeting of the legislature. In alarm he wishes
to flee, considering himself lost. He pretends to fall into a swoon
and says senseless things that should have ruined him. But the once
proud and shrewd rulers of France, feeling that their part is played
out, are even more bewildered than he, and do not say the words they
should have said to destroy him and retain their power.

Chance, millions of chances, give him power, and all men as if by
agreement co-operate to confirm that power. Chance forms the
characters of the rulers of France, who submit to him; chance forms
the character of Paul I of Russia who recognizes his government;
chance contrives a plot against him which not only fails to harm him
but confirms his power. Chance puts the Duc d'Enghien in his hands and
unexpectedly causes him to kill him--thereby convincing the mob more
forcibly than in any other way that he had the right, since he had the
might. Chance contrives that though he directs all his efforts to
prepare an expedition against England (which would inevitably have
ruined him) he never carries out that intention, but unexpectedly
falls upon Mack and the Austrians, who surrender without a battle.
Chance and genius give him the victory at Austerlitz; and by chance
all men, not only the French but all Europe--except England which does
not take part in the events about to happen--despite their former
horror and detestation of his crimes, now recognize his authority, the
title he has given himself, and his ideal of grandeur and glory, which
seems excellent and reasonable to them all.

As if measuring themselves and preparing for the coming movement,
the western forces push toward the east several times in 1805, 1806,
1807, and 1809, gaining strength and growing. In 1811 the group of
people that had formed in France unites into one group with the
peoples of Central Europe. The strength of the justification of the
man who stands at the head of the movement grows with the increased
size of the group. During the ten-year preparatory period this man had
formed relations with all the crowned heads of Europe. The discredited
rulers of the world can oppose no reasonable ideal to the insensate
Napoleonic ideal of glory and grandeur. One after another they
hasten to display their insignificance before him. The King of Prussia
sends his wife to seek the great man's mercy; the Emperor of Austria
considers it a favor that this man receives a daughter the Caesars
into his bed; the Pope, the guardian of all that the nations hold
sacred, utilizes religion for the aggrandizement of the great man.
It is not Napoleon who prepares himself for the accomplishment of
his role, so much as all those round him who prepare him to take on
himself the whole responsibility for what is happening and has to
happen. There is no step, no crime or petty fraud he commits, which in
the mouths of those around him is not at once represented as a great
deed. The most suitable fete the Germans can devise for him is a
celebration of Jena and Auerstadt. Not only is he great, but so are
his ancestors, his brothers, his stepsons, and his brothers-in-law.
Everything is done to deprive him of the remains of his reason and
to prepare him for his terrible part. And when he is ready so too
are the forces.

The invasion pushes eastward and reaches its final goal--Moscow.
That city is taken; the Russian army suffers heavier losses than the
opposing armies had suffered in the former war from Austerlitz to
Wagram. But suddenly instead of those chances and that genius which
hitherto had so consistently led him by an uninterrupted series of
successes to the predestined goal, an innumerable sequence of
inverse chances occur--from the cold in his head at Borodino to the
sparks which set Moscow on fire, and the frosts--and instead of
genius, stupidity and immeasurable baseness become evident.

The invaders flee, turn back, flee again, and all the chances are
now not for Napoleon but always against him.

A countermovement is then accomplished from east to west with a
remarkable resemblance to the preceding movement from west to east.
Attempted drives from east to west--similar to the contrary
movements of 1805, 1807, and 1809--precede the great westward
movement; there is the same coalescence into a group of enormous
dimensions; the same adhesion of the people of Central Europe to the
movement; the same hesitation midway, and the same increasing rapidity
as the goal is approached.

Paris, the ultimate goal, is reached. The Napoleonic government
and army are destroyed. Napoleon himself is no longer of any
account; all his actions are evidently pitiful and mean, but again
an inexplicable chance occurs. The allies detest Napoleon whom they
regard as the cause of their sufferings. Deprived of power and
authority, his crimes and his craft exposed, he should have appeared
to them what he appeared ten years previously and one year later--an
outlawed brigand. But by some strange chance no one perceives this.
His part is not yet ended. The man who ten years before and a year
later was considered an outlawed brigand is sent to an island two
days' sail from France, which for some reason is presented to him as
his dominion, and guards are given to him and millions of money are
paid him.





CHAPTER IV


The flood of nations begins to subside into its normal channels. The
waves of the great movement abate, and on the calm surface eddies
are formed in which float the diplomatists, who imagine that they have
caused the floods to abate.

But the smooth sea again suddenly becomes disturbed. The
diplomatists think that their disagreements are the cause of this
fresh pressure of natural forces; they anticipate war between their
sovereigns; the position seems to them insoluble. But the wave they
feel to be rising does not come from the quarter they expect. It rises
again from the same point as before--Paris. The last backwash of the
movement from the west occurs: a backwash which serves to solve the
apparently insuperable diplomatic difficulties and ends the military
movement of that period of history.

The man who had devastated France returns to France alone, without
any conspiracy and without soldiers. Any guard might arrest him, but
by strange chance no one does so and all rapturously greet the man
they cursed the day before and will curse again a month later.

This man is still needed to justify the final collective act.

That act is performed.

The last role is played. The actor is bidden to disrobe and wash off
his powder and paint: he will not be wanted any more.

And some years pass during which he plays a pitiful comedy to
himself in solitude on his island, justifying his actions by intrigues
and lies when the justification is no longer needed, and displaying to
the whole world what it was that people had mistaken for strength as
long as an unseen hand directed his actions.

The manager having brought the drama to a close and stripped the
actor shows him to us.

"See what you believed in! This is he! Do you now see that it was
not he but I who moved you?"

But dazed by the force of the movement, it was long before people
understood this.

Still greater coherence and inevitability is seen in the life of
Alexander I, the man who stood at the head of the countermovement from
east to west.

What was needed for him who, overshadowing others, stood at the head
of that movement from east to west?

What was needed was a sense of justice and a sympathy with
European affairs, but a remote sympathy not dulled by petty interests;
a moral superiority over those sovereigns of the day who co-operated
with him; a mild and attractive personality; and a personal
grievance against Napoleon. And all this was found in Alexander I; all
this had been prepared by innumerable so-called chances in his life:
his education, his early liberalism, the advisers who surrounded
him, and by Austerlitz, and Tilsit, and Erfurt.

During the national war he was inactive because he was not needed.
But as soon as the necessity for a general European war presented
itself he appeared in his place at the given moment and, uniting the
nations of Europe, led them to the goal.

The goal is reached. After the final war of 1815 Alexander possesses
all possible power. How does he use it?

Alexander I--the pacifier of Europe, the man who from his early
years had striven only for his people's welfare, the originator of the
liberal innovations in his fatherland--now that he seemed to possess
the utmost power and therefore to have the possibility of bringing
about the welfare of his peoples--at the time when Napoleon in exile
was drawing up childish and mendacious plans of how he would have made
mankind happy had he retained power--Alexander I, having fulfilled his
mission and feeling the hand of God upon him, suddenly recognizes
the insignificance of that supposed power, turns away from it, and
gives it into the hands of contemptible men whom he despises, saying
only:

"Not unto us, not unto us, but unto Thy Name!... I too am a man like
the rest of you. Let me live like a man and think of my soul and of
God."

As the sun and each atom of ether is a sphere complete in itself,
and yet at the same time only a part of a whole too immense for man to
comprehend, so each individual has within himself his own aims and yet
has them to serve a general purpose incomprehensible to man.

A bee settling on a flower has stung a child. And the child is
afraid of bees and declares that bees exist to sting people. A poet
admires the bee sucking from the chalice of a flower and says it
exists to suck the fragrance of flowers. A beekeeper, seeing the bee
collect pollen from flowers and carry it to the hive, says that it
exists to gather honey. Another beekeeper who has studied the life
of the hive more closely says that the bee gathers pollen dust to feed
the young bees and rear a queen, and that it exists to perpetuate
its race. A botanist notices that the bee flying with the pollen of
a male flower to a pistil fertilizes the latter, and sees in this
the purpose of the bee's existence. Another, observing the migration
of plants, notices that the bee helps in this work, and may say that
in this lies the purpose of the bee. But the ultimate purpose of the
bee is not exhausted by the first, the second, or any of the processes
the human mind can discern. The higher the human intellect rises in
the discovery of these purposes, the more obvious it becomes, that the
ultimate purpose is beyond our comprehension.

All that is accessible to man is the relation of the life of the bee
to other manifestations of life. And so it is with the purpose of
historic characters and nations.





CHAPTER V


Natasha's wedding to Bezukhov, which took place in 1813, was the
last happy event in the family of the old Rostovs. Count Ilya Rostov
died that same year and, as always happens, after the father's death
the family group broke up.

The events of the previous year: the burning of Moscow and the
flight from it, the death of Prince Andrew, Natasha's despair, Petya's
death, and the old countess' grief fell blow after blow on the old
count's head. He seemed to be unable to understand the meaning of
all these events, and bowed his old head in a spiritual sense as if
expecting and inviting further blows which would finish him. He seemed
now frightened and distraught and now unnaturally animated and
enterprising.

The arrangements for Natasha's marriage occupied him for a while. He
ordered dinners and suppers and obviously tried to appear cheerful,
but his cheerfulness was not infectious as it used to be: on the
contrary it evoked the compassion of those who knew and liked him.

When Pierre and his wife had left, he grew very quiet and began to
complain of depression. A few days later he fell ill and took to his
bed. He realized from the first that he would not get up again,
despite the doctor's encouragement. The countess passed a fortnight in
an armchair by his pillow without undressing. Every time she gave
him his medicine he sobbed and silently kissed her hand. On his last
day, sobbing, he asked her and his absent son to forgive him for
having dissipated their property--that being the chief fault of
which he was conscious. After receiving communion and unction he
quietly died; and next day a throng of acquaintances who came to pay
their last respects to the deceased filled the house rented by the
Rostovs. All these acquaintances, who had so often dined and danced at
his house and had so often laughed at him, now said, with a common
feeling of self-reproach and emotion, as if justifying themselves:
"Well, whatever he may have been he was a most worthy man. You don't
meet such men nowadays.... And which of us has not weaknesses of his
own?"

It was just when the count's affairs had become so involved that
it was impossible to say what would happen if he lived another year
that he unexpectedly died.

Nicholas was with the Russian army in Paris when the news of his
father's death reached him. He at once resigned his commission, and
without waiting for it to be accepted took leave of absence and went
to Moscow. The state of the count's affairs became quite obvious a
month after his death, surprising everyone by the immense total of
small debts the existence of which no one had suspected. The debts
amounted to double the value of the property.

Friends and relations advised Nicholas to decline the inheritance.
But he regarded such a refusal as a slur on his father's memory, which
he held sacred, and therefore would not hear of refusing and
accepted the inheritance together with the obligation to pay the
debts.

The creditors who had so long been silent, restrained by a vague but
powerful influence exerted on them while he lived by the count's
careless good nature, all proceeded to enforce their claims at once.
As always happens in such cases rivalry sprang up as to which should
get paid first, and those who like Mitenka held promissory notes given
them as presents now became the most exacting of the creditors.
Nicholas was allowed no respite and no peace, and those who had seemed
to pity the old man--the cause of their losses (if they were
losses)--now remorselessly pursued the young heir who had
voluntarily undertaken the debts and was obviously not guilty of
contracting them.

Not one of the plans Nicholas tried succeeded; the estate was sold
by auction for half its value, and half the debts still remained
unpaid. Nicholas accepted thirty thousand rubles offered him by his
brother-in-law Bezukhov to pay off debts he regarded as genuinely
due for value received. And to avoid being imprisoned for the
remainder, as the creditors threatened, he re-entered the government
service.

He could not rejoin the army where he would have been made colonel
at the next vacancy, for his mother now clung to him as her one hold
on life; and so despite his reluctance to remain in Moscow among people
who had known him before, and despite his abhorrence of the civil
service, he accepted a post in Moscow in that service, doffed the
uniform of which he was so fond, and moved with his mother and Sonya
to a small house on the Sivtsev Vrazhek.

Natasha and Pierre were living in Petersburg at the time and had
no clear idea of Nicholas' circumstances. Having borrowed money from
his brother-in-law, Nicholas tried to hide his wretched condition from
him. His position was the more difficult because with his salary of
twelve hundred rubles he had not only to keep himself, his mother, and
Sonya, but had to shield his mother from knowledge of their poverty.
The countess could not conceive of life without the luxurious
conditions she had been used to from childhood and, unable to
realize how hard it was for her son, kept demanding now a carriage
(which they did not keep) to send for a friend, now some expensive
article of food for herself, or wine for her son, or money to buy a
present as a surprise for Natasha or Sonya, or for Nicholas himself.

Sonya kept house, attended on her aunt, read to her, put up with her
whims and secret ill-will, and helped Nicholas to conceal their
poverty from the old countess. Nicholas felt himself irredeemably
indebted to Sonya for all she was doing for his mother and greatly
admired her patience and devotion, but tried to keep aloof from her.

He seemed in his heart to reproach her for being too perfect, and
because there was nothing to reproach her with. She had all that
people are valued for, but little that could have made him love her.
He felt that the more he valued her the less he loved her. He had
taken her at her word when she wrote giving him his freedom and now
behaved as if all that had passed between them had been long forgotten
and could never in any case be renewed.

Nicholas' position became worse and worse. The idea of putting
something aside out of his salary proved a dream. Not only did he
not save anything, but to comply with his mother's demands he even
incurred some small debts. He could see no way out of this
situation. The idea of marrying some rich woman, which was suggested
to him by his female relations, was repugnant to him. The other way
out--his mother's death--never entered his head. He wished for nothing
and hoped for nothing, and deep in his heart experienced a gloomy
and stern satisfaction in an uncomplaining endurance of his
position. He tried to avoid his old acquaintances with their
commiseration and offensive offers of assistance; he avoided all
distraction and recreation, and even at home did nothing but play
cards with his mother, pace silently up and down the room, and smoke
one pipe after another. He seemed carefully to cherish within
himself the gloomy mood which alone enabled him to endure his
position.





CHAPTER VI


At the beginning of winter Princess Mary came to Moscow. From
reports current in town she learned how the Rostovs were situated, and
how "the son has sacrificed himself for his mother," as people were
saying.

"I never expected anything else of him," said Princess Mary to
herself, feeling a joyous sense of her love for him. Remembering her
friendly relations with all the Rostovs which had made her almost a
member of the family, she thought it her duty to go to see them. But
remembering her relations with Nicholas in Voronezh she was shy
about doing so. Making a great effort she did however go to call on
them a few weeks after her arrival in Moscow.

Nicholas was the first to meet her, as the countess' room could only
be reached through his. But instead of being greeted with pleasure
as she had expected, at his first glance at her his face assumed a
cold, stiff, proud expression she had not seen on it before. He
inquired about her health, led the way to his mother, and having sat
there for five minutes left the room.

When the princess came out of the countess' room Nicholas met her
again, and with marked solemnity and stiffness accompanied her to
the anteroom. To her remarks about his mother's health he made no
reply. "What's that to you? Leave me in peace," his looks seemed to
say.

"Why does she come prowling here? What does she want? I can't bear
these ladies and all these civilities!" said he aloud in Sonya's
presence, evidently unable to repress his vexation, after the
princess' carriage had disappeared.

"Oh, Nicholas, how can you talk like that?" cried Sonya, hardly able
to conceal her delight. "She is so kind and Mamma is so fond of her!"

Nicholas did not reply and tried to avoid speaking of the princess
any more. But after her visit the old countess spoke of her several
times a day.

She sang her praises, insisted that her son must call on her,
expressed a wish to see her often, but yet always became ill-humored
when she began to talk about her.

Nicholas tried to keep silence when his mother spoke of the
princess, but his silence irritated her.

"She is a very admirable and excellent young woman," said she,
"and you must go and call on her. You would at least be seeing
somebody, and I think it must be dull for you only seeing us."

"But I don't in the least want to, Mamma."

"You used to want to, and now you don't. Really I don't understand
you, my dear. One day you are dull, and the next you refuse to see
anyone."

"But I never said I was dull."

"Why, you said yourself you don't want even to see her. She is a
very admirable young woman and you always liked her, but now
suddenly you have got some notion or other in your head. You hide
everything from me."

"Not at all, Mamma."

"If I were asking you to do something disagreeable now--but I only
ask you to return a call. One would think mere politeness required
it.... Well, I have asked you, and now I won't interfere any more
since you have secrets from your mother."

"Well, then, I'll go if you wish it."

"It doesn't matter to me. I only wish it for your sake."

Nicholas sighed, bit his mustache, and laid out the cards for a
patience, trying to divert his mother's attention to another topic.

The same conversation was repeated next day and the day after, and
the day after that.

After her visit to the Rostovs and her unexpectedly chilly reception
by Nicholas, Princess Mary confessed to herself that she had been
right in not wishing to be the first to call.

"I expected nothing else," she told herself, calling her pride to
her aid. "I have nothing to do with him and I only wanted to see the
old lady, who was always kind to me and to whom I am under many
obligations."

But she could not pacify herself with these reflections; a feeling
akin to remorse troubled her when she thought of her visit. Though she
had firmly resolved not to call on the Rostovs again and to forget the
whole matter, she felt herself all the time in an awkward position.
And when she asked herself what distressed her, she had to admit
that it was her relation to Rostov. His cold, polite manner did not
express his feeling for her (she knew that) but it concealed
something, and until she could discover what that something was, she
felt that she could not be at ease.

One day in midwinter when sitting in the schoolroom attending to her
nephew's lessons, she was informed that Rostov had called. With a firm
resolution not to betray herself and not show her agitation, she
sent for Mademoiselle Bourienne and went with her to the drawing room.

Her first glance at Nicholas' face told her that he had only come to
fulfill the demands of politeness, and she firmly resolved to maintain
the tone in which he addressed her.

They spoke of the countess' health, of their mutual friends, of
the latest war news, and when the ten minutes required by propriety
had elapsed after which a visitor may rise, Nicholas got up to say
good-by.

With Mademoiselle Bourienne's help the princess had maintained the
conversation very well, but at the very last moment, just when he
rose, she was so tired of talking of what did not interest her, and
her mind was so full of the question why she alone was granted so
little happiness in life, that in a fit of absent-mindedness she sat
still, her luminous eyes gazing fixedly before her, not noticing
that he had risen.

Nicholas glanced at her and, wishing to appear not to notice her
abstraction, made some remark to Mademoiselle Bourienne and then again
looked at the princess. She still sat motionless with a look of
suffering on her gentle face. He suddenly felt sorry for her and was
vaguely conscious that he might be the cause of the sadness her face
expressed. He wished to help her and say something pleasant, but could
think of nothing to say.

"Good-by, Princess!" said he.

She started, flushed, and sighed deeply.

"Oh, I beg your pardon," she said as if waking up. "Are you going
already, Count? Well then, good-by! Oh, but the cushion for the
countess!"

"Wait a moment, I'll fetch it," said Mademoiselle Bourienne, and she
left the room.

They both sat silent, with an occasional glance at one another.

"Yes, Princess," said Nicholas at last with a sad smile, "it doesn't
seem long ago since we first met at Bogucharovo, but how much water
has flowed since then! In what distress we all seemed to be then,
yet I would give much to bring back that time... but there's no
bringing it back."

Princess Mary gazed intently into his eyes with her own luminous
ones as he said this. She seemed to be trying to fathom the hidden
meaning of his words which would explain his feeling for her.

"Yes, yes," said she, "but you have no reason to regret the past,
Count. As I understand your present life, I think you will always
recall it with satisfaction, because the self-sacrifice that fills
it now..."

"I cannot accept your praise," he interrupted her hurriedly. "On the
contrary I continually reproach myself.... But this is not at all an
interesting or cheerful subject."

His face again resumed its former stiff and cold expression. But the
princess had caught a glimpse of the man she had known and loved,
and it was to him that she now spoke.

"I thought you would allow me to tell you this," she said. "I had
come so near to you... and to all your family that I thought you would
not consider my sympathy misplaced, but I was mistaken," and
suddenly her voice trembled. "I don't know why," she continued,
recovering herself, "but you used to be different, and..."

"There are a thousand reasons why," laying special emphasis on the
why. "Thank you, Princess," he added softly. "Sometimes it is hard."

"So that's why! That's why!" a voice whispered in Princess Mary's
soul. "No, it was not only that gay, kind, and frank look, not only
that handsome exterior, that I loved in him. I divined his noble,
resolute, self-sacrificing spirit too," she said to herself. "Yes,
he is poor now and I am rich.... Yes, that's the only reason....
Yes, were it not for that..." And remembering his former tenderness,
and looking now at his kind, sorrowful face, she suddenly understood
the cause of his coldness.

"But why, Count, why?" she almost cried, unconsciously moving closer
to him. "Why? Tell me. You must tell me!"

He was silent.

"I don't understand your why, Count," she continued, "but it's
hard for me... I confess it. For some reason you wish to deprive me of
our former friendship. And that hurts me." There were tears in her
eyes and in her voice. "I have had so little happiness in life that
every loss is hard for me to bear.... Excuse me, good-by!" and
suddenly she began to cry and was hurrying from the room.

"Princess, for God's sake!" he exclaimed, trying to stop her.
"Princess!"

She turned round. For a few seconds they gazed silently into one
another's eyes--and what had seemed impossible and remote suddenly
became possible, inevitable, and very near.





CHAPTER VII


In the winter of 1813 Nicholas married Princess Mary and moved to
Bald Hills with his wife, his mother, and Sonya.

Within four years he had paid off all his remaining debts without
selling any of his wife's property, and having received a small
inheritance on the death of a cousin he paid his debt to Pierre as
well.

In another three years, by 1820, he had so managed his affairs
that he was able to buy a small estate adjoining Bald Hills and was
negotiating to buy back Otradnoe--that being his pet dream.

Having started farming from necessity, he soon grew so devoted to it
that it became his favorite and almost his sole occupation. Nicholas
was a plain farmer: he did not like innovations, especially the
English ones then coming into vogue. He laughed at theoretical
treatises on estate management, disliked factories, the raising of
expensive products, and the buying of expensive seed corn, and did not
make a hobby of any particular part of the work on his estate. He
always had before his mind's eye the estate as a whole and not any
particular part of it. The chief thing in his eyes was not the
nitrogen in the soil, nor the oxygen in the air, nor manures, nor
special plows, but that most important agent by which nitrogen,
oxygen, manure, and plow were made effective--the peasant laborer.
When Nicholas first began farming and began to understand its
different branches, it was the serf who especially attracted his
attention. The peasant seemed to him not merely a tool, but also a
judge of farming and an end in himself. At first he watched the serfs,
trying to understand their aims and what they considered good and bad,
and only pretended to direct them and give orders while in reality
learning from them their methods, their manner of speech, and their
judgment of what was good and bad. Only when he had understood the
peasants' tastes and aspirations, had learned to talk their
language, to grasp the hidden meaning of their words, and felt akin to
them did he begin boldly to manage his serfs, that is, to perform
toward them the duties demanded of him. And Nicholas' management
produced very brilliant results.

Guided by some gift of insight, on taking up the management of the
estates he at once unerringly appointed as bailiff, village elder, and
delegate, the very men the serfs would themselves have chosen had they
had the right to choose, and these posts never changed hands. Before
analyzing the properties of manure, before entering into the debit and
credit (as he ironically called it), he found out how many cattle
the peasants had and increased the number by all possible means. He
kept the peasant families together in the largest groups possible, not
allowing the family groups to divide into separate households. He
was hard alike on the lazy, the depraved, and the weak, and tried to
get them expelled from the commune.

He was as careful of the sowing and reaping of the peasants' hay and
corn as of his own, and few landowners had their crops sown and
harvested so early and so well, or got so good a return, as did
Nicholas.

He disliked having anything to do with the domestic serfs--the
"drones" as he called them--and everyone said he spoiled them by his
laxity. When a decision had to be taken regarding a domestic serf,
especially if one had to be punished, he always felt undecided and
consulted everybody in the house; but when it was possible to have a
domestic serf conscripted instead of a land worker he did so without
the least hesitation. He never felt any hesitation in dealing with the
peasants. He knew that his every decision would be approved by them
all with very few exceptions.

He did not allow himself either to be hard on or punish a man, or to
make things easy for or reward anyone, merely because he felt inclined
to do so. He could not have said by what standard he judged what he
should or should not do, but the standard was quite firm and
definite in his own mind.

Often, speaking with vexation of some failure or irregularity, he
would say: "What can one do with our Russian peasants?" and imagined
that he could not bear them.

Yet he loved "our Russian peasants" and their way of life with his
whole soul, and for that very reason had understood and assimilated
the one way and manner of farming which produced good results.

Countess Mary was jealous of this passion of her husband's and
regretted that she could not share it; but she could not understand
the joys and vexations he derived from that world, to her so remote
and alien. She could not understand why he was so particularly
animated and happy when, after getting up at daybreak and spending the
whole morning in the fields or on the threshing floor, he returned
from the sowing or mowing or reaping to have tea with her. She did not
understand why he spoke with such admiration and delight of the
farming of the thrifty and well-to-do peasant Matthew Ermishin, who
with his family had carted corn all night; or of the fact that his
(Nicholas') sheaves were already stacked before anyone else had his
harvest in. She did not understand why he stepped out from the
window to the veranda and smiled under his mustache and winked so
joyfully, when warm steady rain began to fall on the dry and thirsty
shoots of the young oats, or why when the wind carried away a
threatening cloud during the hay harvest he would return from the
barn, flushed, sunburned, and perspiring, with a smell of wormwood and
gentian in his hair and, gleefully rubbing his hands, would say:
"Well, one more day and my grain and the peasants' will all be under
cover."

Still less did she understand why he, kindhearted and always ready
to anticipate her wishes, should become almost desperate when she
brought him a petition from some peasant men or women who had appealed
to her to be excused some work; why he, that kind Nicholas, should
obstinately refuse her, angrily asking her not to interfere in what
was not her business. She felt he had a world apart, which he loved
passionately and which had laws she had not fathomed.

Sometimes when, trying to understand him, she spoke of the good work
he was doing for his serfs, he would be vexed and reply: "Not in the
least; it never entered my head and I wouldn't do that for their good!
That's all poetry and old wives' talk--all that doing good to one's
neighbor! What I want is that our children should not have to go
begging. I must put our affairs in order while I am alive, that's all.
And to do that, order and strictness are essential.... That's all
about it!" said he, clenching his vigorous fist. "And fairness, of
course," he added, "for if the peasant is naked and hungry and has
only one miserable horse, he can do no good either for himself or
for me."

And all Nicholas did was fruitful--probably just because he
refused to allow himself to think that he was doing good to others for
virtue's sake. His means increased rapidly; serfs from neighboring
estates came to beg him to buy them, and long after his death the
memory of his administration was devoutly preserved among the serfs.
"He was a master... the peasants' affairs first and then his own. Of
course he was not to be trifled with either--in a word, he was a
real master!"





CHAPTER VIII

One matter connected with his management sometimes worried Nicholas,
and that was his quick temper together with his old hussar habit of
making free use of his fists. At first he saw nothing reprehensible in
this, but in the second year of his marriage his view of that form
of punishment suddenly changed.

Once in summer he had sent for the village elder from Bogucharovo, a
man who had succeeded to the post when Dron died and who was accused
of dishonesty and various irregularities. Nicholas went out into the
porch to question him, and immediately after the elder had given a few
replies the sound of cries and blows were heard. On returning to lunch
Nicholas went up to his wife, who sat with her head bent low over
her embroidery frame, and as usual began to tell her what he had
been doing that morning. Among other things he spoke of the
Bogucharovo elder. Countess Mary turned red and then pale, but
continued to sit with head bowed and lips compressed and gave her
husband no reply.

"Such an insolent scoundrel!" he cried, growing hot again at the
mere recollection of him. "If he had told me he was drunk and did
not see... But what is the matter with you, Mary?" he suddenly asked.

Countess Mary raised her head and tried to speak, but hastily looked
down again and her lips puckered.

"Why, whatever is the matter, my dearest?"

The looks of the plain Countess Mary always improved when she was in
tears. She never cried from pain or vexation, but always from sorrow
or pity, and when she wept her radiant eyes acquired an irresistible
charm.

The moment Nicholas took her hand she could no longer restrain
herself and began to cry.

"Nicholas, I saw it... he was to blame, but why do you... Nicholas!"
and she covered her face with her hands.

Nicholas said nothing. He flushed crimson, left her side, and
paced up and down the room. He understood what she was weeping
about, but could not in his heart at once agree with her that what
he had regarded from childhood as quite an everyday event was wrong.
"Is it just sentimentality, old wives' tales, or is she right?" he
asked himself. Before he had solved that point he glanced again at her
face filled with love and pain, and he suddenly realized that she
was right and that he had long been sinning against himself.

"Mary," he said softly, going up to her, "it will never happen
again; I give you my word. Never," he repeated in a trembling voice
like a boy asking for forgiveness.

The tears flowed faster still from the countess' eyes. She took
his hand and kissed it.

"Nicholas, when did you break your cameo?" she asked to change the
subject, looking at his finger on which he wore a ring with a cameo
of Laocoon's head.

"Today--it was the same affair. Oh, Mary, don't remind me of it!"
and again he flushed. "I give you my word of honor it shan't occur
again, and let this always be a reminder to me," and he pointed to the
broken ring.

After that, when in discussions with his village elders or
stewards the blood rushed to his face and his fists began to clench,
Nicholas would turn the broken ring on his finger and would drop his
eyes before the man who was making him angry. But he did forget
himself once or twice within a twelvemonth, and then he would go and
confess to his wife, and would again promise that this should really
be the very last time.

"Mary, you must despise me!" he would say. "I deserve it."

"You should go, go away at once, if you don't feel strong enough
to control yourself," she would reply sadly, trying to comfort her
husband.

Among the gentry of the province Nicholas was respected but not
liked. He did not concern himself with the interests of his own class,
and consequently some thought him proud and others thought him stupid.
The whole summer, from spring sowing to harvest, he was busy with
the work on his farm. In autumn he gave himself up to hunting with the
same business like seriousness--leaving home for a month, or even two,
with his hunt. In winter he visited his other villages or spent his
time reading. The books he read were chiefly historical, and on
these he spent a certain sum every year. He was collecting, as he
said, a serious library, and he made it a rule to read through all the
books he bought. He would sit in his study with a grave air,
reading--a task he first imposed upon himself as a duty, but which
afterwards became a habit affording him a special kind of pleasure and
a consciousness of being occupied with serious matters. In winter,
except for business excursions, he spent most of his time at home
making himself one with his family and entering into all the details
of his children's relations with their mother. The harmony between him
and his wife grew closer and closer and he daily discovered fresh
spiritual treasures in her.

From the time of his marriage Sonya had lived in his house. Before
that, Nicholas had told his wife all that had passed between himself
and Sonya, blaming himself and commending her. He had asked Princess
Mary to be gentle and kind to his cousin. She thoroughly realized
the wrong he had done Sonya, felt herself to blame toward her, and
imagined that her wealth had influenced Nicholas' choice. She could
not find fault with Sonya in any way and tried to be fond of her,
but often felt ill-will toward her which she could not overcome.

Once she had a talk with her friend Natasha about Sonya and about
her own injustice toward her.

"You know," said Natasha, "you have read the Gospels a great deal-
there is a passage in them that just fits Sonya."

"What?" asked Countess Mary, surprised.

"'To him that hath shall be given, and from him that hath not
shall be taken away.' You remember? She is one that hath not; why, I
don't know. Perhaps she lacks egotism, I don't know, but from her is
taken away, and everything has been taken away. Sometimes I am
dreadfully sorry for her. Formerly I very much wanted Nicholas to
marry her, but I always had a sort of presentiment that it would not
come off. She is a sterile flower, you know--like some strawberry
blossoms. Sometimes I am sorry for her, and sometimes I think she
doesn't feel it as you or I would."

Though Countess Mary told Natasha that those words in the Gospel
must be understood differently, yet looking at Sonya she agreed with
Natasha's explanation. It really seemed that Sonya did not feel her
position trying, and had grown quite reconciled to her lot as a
sterile flower. She seemed to be fond not so much of individuals as of
the family as a whole. Like a cat, she had attached herself not to the
people but to the home. She waited on the old countess, petted and
spoiled the children, was always ready to render the small services
for which she had a gift, and all this was unconsciously accepted from
her with insufficient gratitude.

The country seat at Bald Hills had been rebuilt, though not on the
same scale as under the old prince.

The buildings, begun under straitened circumstances, were more
than simple. The immense house on the old stone foundations was of
wood, plastered only inside. It had bare deal floors and was furnished
with very simple hard sofas, armchairs, tables, and chairs made by
their own serf carpenters out of their own birchwood. The house was
spacious and had rooms for the house serfs and apartments for
visitors. Whole families of the Rostovs' and Bolkonskis' relations
sometimes came to Bald Hills with sixteen horses and dozens of
servants and stayed for months. Besides that, four times a year, on
the name days and birthdays of the hosts, as many as a hundred
visitors would gather there for a day or two. The rest of the year
life pursued its unbroken routine with its ordinary occupations, and
its breakfasts, lunches, dinners, and suppers, provided out of the
produce of the estate.





CHAPTER IX


It was the eve of St. Nicholas, the fifth of December, 1820. Natasha
had been staying at her brother's with her husband and children
since early autumn. Pierre had gone to Petersburg on business of his
own for three weeks as he said, but had remained there nearly seven
weeks and was expected back every minute.

Besides the Bezukhov family, Nicholas' old friend the retired
General Vasili Dmitrich Denisov was staying with the Rostovs this
fifth of December.

On the sixth, which was his name day when the house would be full of
visitors, Nicholas knew he would have to exchange his Tartar tunic for
a tail coat, and put on narrow boots with pointed toes, and drive to
the new church he had built, and then receive visitors who would
come to congratulate him, offer them refreshments, and talk about
the elections of the nobility; but he considered himself entitled to
spend the eve of that day in his usual way. He examined the
bailiff's accounts of the village in Ryazan which belonged to his
wife's nephew, wrote two business letters, and walked over to the
granaries, cattle yards and stables before dinner. Having taken
precautions against the general drunkenness to be expected on the
morrow because it was a great saint's day, he returned to dinner,
and without having time for a private talk with his wife sat down at
the long table laid for twenty persons, at which the whole household
had assembled. At that table were his mother, his mother's old lady
companion Belova, his wife, their three children with their
governess and tutor, his wife's nephew with his tutor, Sonya, Denisov,
Natasha, her three children, their governess, and old Michael
Ivanovich, the late prince's architect, who was living on in
retirement at Bald Hills.

Countess Mary sat at the other end of the table. When her husband
took his place she concluded, from the rapid manner in which after
taking up his table napkin he pushed back the tumbler and wineglass
standing before him, that he was out of humor, as was sometimes the
case when he came in to dinner straight from the farm--especially
before the soup. Countess Mary well knew that mood of his, and when
she herself was in a good frame of mind quietly waited till he had had
his soup and then began to talk to him and make him admit that there
was no cause for his ill-humor. But today she quite forgot that and
was hurt that he should be angry with her without any reason, and
she felt unhappy. She asked him where he had been. He replied. She
again inquired whether everything was going well on the farm. Her
unnatural tone made him wince unpleasantly and he replied hastily.

"Then I'm not mistaken," thought Countess Mary. "Why is he cross
with me?" She concluded from his tone that he was vexed with her and
wished to end the conversation. She knew her remarks sounded
unnatural, but could not refrain from asking some more questions.

Thanks to Denisov the conversation at table soon became general
and lively, and she did not talk to her husband. When they left the
table and went as usual to thank the old countess, Countess Mary
held out her hand and kissed her husband, and asked him why he was
angry with her.

"You always have such strange fancies! I didn't even think of
being angry," he replied.

But the word always seemed to her to imply: "Yes, I am angry but I
won't tell you why."

Nicholas and his wife lived together so happily that even Sonya
and the old countess, who felt jealous and would have liked them to
disagree, could find nothing to reproach them with; but even they
had their moments of antagonism. Occasionally, and it was always
just after they had been happiest together, they suddenly had a
feeling of estrangement and hostility, which occurred most
frequently during Countess Mary's pregnancies, and this was such a
time.

"Well, messieurs et mesdames," said Nicholas loudly and with
apparent cheerfulness (it seemed to Countess Mary that he did it on
purpose to vex her), "I have been on my feet since six this morning.
Tomorrow I shall have to suffer, so today I'll go and rest."

And without a word to his wife he went to the little sitting room
and lay down on the sofa.

"That's always the way," thought Countess Mary. "He talks to
everyone except me. I see... I see that I am repulsive to him,
especially when I am in this condition." She looked down at her
expanded figure and in the glass at her pale, sallow, emaciated face
in which her eyes now looked larger than ever.

And everything annoyed her--Denisov's shouting and laughter,
Natasha's talk, and especially a quick glance Sonya gave her.

Sonya was always the first excuse Countess Mary found for feeling
irritated.

Having sat awhile with her visitors without understanding anything
of what they were saying, she softly left the room and went to the
nursery.

The children were playing at "going to Moscow" in a carriage made of
chairs and invited her to go with them. She sat down and played with
them a little, but the thought of her husband and his unreasonable
crossness worried her. She got up and, walking on tiptoe with
difficulty, went to the small sitting room.

"Perhaps he is not asleep; I'll have an explanation with him," she
said to herself. Little Andrew, her eldest boy, imitating his
mother, followed her on tiptoe. She not notice him.

"Mary, dear, I think he is asleep--he was so tired," said Sonya,
meeting her in the large sitting room (it seemed to Countess Mary that
she crossed her path everywhere). "Andrew may wake him."

Countess Mary looked round, saw little Andrew following her, felt
that Sonya was right, and for that very reason flushed and with
evident difficulty refrained from saying something harsh. She made
no reply, but to avoid obeying Sonya beckoned to Andrew to follow
her quietly and went to the door. Sonya went away by another door.
From the room in which Nicholas was sleeping came the sound of his
even breathing, every slightest tone of which was familiar to his
wife. As she listened to it she saw before her his smooth handsome
forehead, his mustache, and his whole face, as she had so often seen
it in the stillness of the night when he slept. Nicholas suddenly
moved and cleared his throat. And at that moment little Andrew shouted
from outside the door: "Papa! Mamma's standing here!" Countess Mary
turned pale with fright and made signs to the boy. He grew silent, and
quiet ensued for a moment, terrible to Countess Mary. She knew how
Nicholas disliked being waked. Then through the door she heard
Nicholas clearing his throat again and stirring, and his voice said
crossly:

"I can't get a moment's peace.... Mary, is that you? Why did you
bring him here?"

"I only came in to look and did not notice... forgive me..."

Nicholas coughed and said no more. Countess Mary moved away from the
door and took the boy back to the nursery. Five minutes later little
black-eyed three-year-old Natasha, her father's pet, having learned
from her brother that Papa was asleep and Mamma was in the sitting
room, ran to her father unobserved by her mother. The dark-eyed little
girl boldly opened the creaking door, went up to the sofa with
energetic steps of her sturdy little legs, and having examined the
position of her father, who was asleep with his back to her, rose on
tiptoe and kissed the hand which lay under his head. Nicholas turned
with a tender smile on his face.

"Natasha, Natasha!" came Countess Mary's frightened whisper from the
door. "Papa wants to sleep."

"No, Mamma, he doesn't want to sleep," said little Natasha with
conviction. "He's laughing."

Nicholas lowered his legs, rose, and took his daughter in his arms.

"Come in, Mary," he said to his wife.

She went in and sat down by her husband.

"I did not notice him following me," she said timidly. "I just
looked in."

Holding his little girl with one arm, Nicholas glanced at his wife
and, seeing her guilty expression, put his other arm around her and
kissed her hair.

"May I kiss Mamma?" he asked Natasha.

Natasha smiled bashfully.

"Again!" she commanded, pointing with a peremptory gesture to the
spot where Nicholas had placed the kiss.

"I don't know why you think I am cross," said Nicholas, replying
to the question he knew was in his wife's mind.

"You have no idea how unhappy, how lonely, I feel when you are
like that. It always seems to me... "

"Mary, don't talk nonsense. You ought to be ashamed of yourself!" he
said gaily.

"It seems to be that you can't love me, that I am so plain...
always... and now... in this cond..."

"Oh, how absurd you are! It is not beauty that endears, it's love
that makes us see beauty. It is only Malvinas and women of that kind
who are loved for their beauty. But do I love my wife? I don't love
her, but... I don't know how to put it. Without you, or when something
comes between us like this, I seem lost and can't do anything. Now
do I love my finger? I don't love it, but just try to cut it off!"

"I'm not like that myself, but I understand. So you're not angry
with me?"

"Awfully angry!" he said, smiling and getting up. And smoothing
his hair he began to pace the room.

"Do you know, Mary, what I've been thinking?" he began,
immediately thinking aloud in his wife's presence now that they had
made it up.

He did not ask if she was ready to listen to him. He did not care. A
thought had occurred to him and so it belonged to her also. And he
told her of his intention to persuade Pierre to stay with them till
spring.

Countess Mary listened till he had finished, made some remark, and
in her turn began thinking aloud. Her thoughts were about the
children.

"You can see the woman in her already," she said in French, pointing
to little Natasha. "You reproach us women with being illogical. Here
is our logic. I say: 'Papa wants to sleep!' but she says, 'No, he's
laughing.' And she was right," said Countess Mary with a happy smile.

"Yes, yes." And Nicholas, taking his little daughter in his strong
hand, lifted her high, placed her on his shoulder, held her by the
legs, and paced the room with her. There was an expression of carefree
happiness on the faces of both father and daughter.

"But you know you may be unfair. You are too fond of this one,"
his wife whispered in French.

"Yes, but what am I to do?... I try not to show..."

At that moment they heard the sound of the door pulley and footsteps
in the hall and anteroom, as if someone had arrived.

"Somebody has come."

"I am sure it is Pierre. I will go and see," said Countess Mary
and left the room.

In her absence Nicholas allowed himself to give his little
daughter a gallop round the room. Out of breath, he took the
laughing child quickly from his shoulder and pressed her to his heart.
His capers reminded him of dancing, and looking at the child's round
happy little face he thought of what she would be like when he was
an old man, taking her into society and dancing the mazurka with her
as his old father had danced Daniel Cooper with his daughter.

"It is he, it is he, Nicholas!" said Countess Mary, re-entering
the room a few minutes later. "Now our Natasha has come to life. You
should have seen her ecstasy, and how he caught it for having stayed
away so long. Well, come along now, quick, quick! It's time you two
were parted," she added, looking smilingly at the little girl who
clung to her father.

Nicholas went out holding the child by the hand.

Countess Mary remained in the sitting room.

"I should never, never have believed that one could be so happy,"
she whispered to herself. A smile lit up her face but at the same time
she sighed, and her deep eyes expressed a quiet sadness as though
she felt, through her happiness, that there is another sort of
happiness unattainable in this life and of which she involuntarily
thought at that instant.





CHAPTER X


Natasha had married in the early spring of 1813, and in 1820 already
had three daughters besides a son for whom she had longed and whom she
was now nursing. She had grown stouter and broader, so that it was
difficult to recognize in this robust, motherly woman the slim, lively
Natasha of former days. Her features were more defined and had a calm,
soft, and serene expression. In her face there was none of the
ever-glowing animation that had formerly burned there and
constituted its charm. Now her face and body were of all that one saw,
and her soul was not visible at all. All that struck the eye was a
strong, handsome, and fertile woman. The old fire very rarely
kindled in her face now. That happened only when, as was the case that
day, her husband returned home, or a sick child was convalescent, or
when she and Countess Mary spoke of Prince Andrew (she never mentioned
him to her husband, who she imagined was jealous of Prince Andrew's
memory), or on the rare occasions when something happened to induce
her to sing, a practice she had quite abandoned since her marriage. At
the rare moments when the old fire did kindle in her handsome, fully
developed body she was even more attractive than in former days.

Since their marriage Natasha and her husband had lived in Moscow, in
Petersburg, on their estate near Moscow, or with her mother, that is
to say, in Nicholas' house. The young Countess Bezukhova was not often
seen in society, and those who met her there were not pleased with her
and found her neither attractive nor amiable. Not that Natasha liked
solitude--she did not know whether she liked it or not, she even
thought that she did not--but with her pregnancies, her
confinements, the nursing of her children, and sharing every moment of
her husband's life, she had demands on her time which could be
satisfied only by renouncing society. All who had known Natasha before
her marriage wondered at the change in her as at something
extraordinary. Only the old countess with her maternal instinct had
realized that all Natasha's outbursts had been due to her need of
children and a husband--as she herself had once exclaimed at
Otradnoe not so much in fun as in earnest--and her mother was now
surprised at the surprise expressed by those who had never
understood Natasha, and she kept saying that she had always known that
Natasha would make an exemplary wife and mother.

"Only she lets her love of her husband and children overflow all
bounds," said the countess, "so that it even becomes absurd."

Natasha did not follow the golden rule advocated by clever folk,
especially by the French, which says that a girl should not let
herself go when she marries, should not neglect her accomplishments,
should be even more careful of her appearance than when she was
unmarried, and should fascinate her husband as much as she did
before he became her husband. Natasha on the contrary had at once
abandoned all her witchery, of which her singing had been an unusually
powerful part. She gave it up just because it was so powerfully
seductive. She took no pains with her manners or with of speech, or
with her toilet, or to show herself to her husband in her most
becoming attitudes, or to avoid inconveniencing him by being too
exacting. She acted in contradiction to all those rules. She felt that
the allurements instinct had formerly taught her to use would now be
merely ridiculous in the eyes of her husband, to whom she had from the
first moment given herself up entirely--that is, with her whole
soul, leaving no corner of it hidden from him. She felt that her unity
with her husband was not maintained by the poetic feelings that had
attracted him to her, but by something else--indefinite but firm as
the bond between her own body and soul.

To fluff out her curls, put on fashionable dresses, and sing
romantic songs to fascinate her husband would have seemed as strange
as to adorn herself to attract herself. To adorn herself for others
might perhaps have been agreeable--she did not know--but she had no
time at all for it. The chief reason for devoting no time either to
singing, to dress, or to choosing her words was that she really had no
time to spare for these things.

We know that man has the faculty of becoming completely absorbed
in a subject however trivial it may be, and that there is no subject
so trivial that it will not grow to infinite proportions if one's
entire attention is devoted to it.

The subject which wholly engrossed Natasha's attention was her
family: that is, her husband whom she had to keep so that he should
belong entirely to her and to the home, and the children whom she
had to bear, bring into the world, nurse, and bring up.

And the deeper she penetrated, not with her mind only but with her
whole soul, her whole being, into the subject that absorbed her, the
larger did that subject grow and the weaker and more inadequate did
her powers appear, so that she concentrated them wholly on that one
thing and yet was unable to accomplish all that she considered
necessary.

There were then as now conversations and discussions about women's
rights, the relations of husband and wife and their freedom and
rights, though these themes were not yet termed questions as they
are now; but these topics were not merely uninteresting to Natasha,
she positively did not understand them.

These questions, then as now, existed only for those who see nothing
in marriage but the pleasure married people get from one another, that
is, only the beginnings of marriage and not its whole significance,
which lies in the family.

Discussions and questions of that kind, which are like the
question of how to get the greatest gratification from one's dinner,
did not then and do not now exist for those for whom the purpose of
a dinner is the nourishment it affords; and the purpose of marriage is
the family.

If the purpose of dinner is to nourish the body, a man who eats
two dinners at once may perhaps get more enjoyment but will not attain
his purpose, for his stomach will not digest the two dinners.

If the purpose of marriage is the family, the person who wishes to
have many wives or husbands may perhaps obtain much pleasure, but in
that case will not have a family.

If the purpose of food is nourishment and the purpose of marriage is
the family, the whole question resolves itself into not eating more
than one can digest, and not having more wives or husbands than are
needed for the family--that is, one wife or one husband. Natasha
needed a husband. A husband was given her and he gave her a family.
And she not only saw no need of any other or better husband, but as
all the powers of her soul were intent on serving that husband and
family, she could not imagine and saw no interest in imagining how
it would be if things were different.

Natasha did not care for society in general, but prized the more the
society of her relatives--Countess Mary, and her brother, her
mother, and Sonya. She valued the company of those to whom she could
come striding disheveled from the nursery in her dressing gown, and
with joyful face show a yellow instead of a green stain on baby's
napkin, and from whom she could hear reassuring words to the effect
that baby was much better.

To such an extent had Natasha let herself go that the way she
dressed and did her hair, her ill-chosen words, and her jealousy-
she was jealous of Sonya, of the governess, and of every woman, pretty
or plain--were habitual subjects of jest to those about her. The
general opinion was that Pierre was under his wife's thumb, which
was really true. From the very first days of their married life
Natasha had announced her demands. Pierre was greatly surprised by his
wife's view, to him a perfectly novel one, that every moment of his
life belonged to her and to the family. His wife's demands
astonished him, but they also flattered him, and he submitted to them.

Pierre's subjection consisted in the fact that he not only dared not
flirt with, but dared not even speak smilingly to, any other woman;
did not dare dine at the Club as a pastime, did not dare spend money a
whim, and did not dare absent himself for any length of time, except
on business--in which his wife included his intellectual pursuits,
which she did not in the least understand but to which she
attributed great importance. To make up for this, at home Pierre had
the right to regulate his life and that of the whole family exactly as
he chose. At home Natasha placed herself in the position of a slave to
her husband, and the whole household went on tiptoe when he was
occupied--that is, was reading or writing in his study. Pierre had but
to show a partiality for anything to get just what he liked done
always. He had only to express a wish and Natasha would jump up and
run to fulfill it.

The entire household was governed according to Pierre's supposed
orders, that is, by his wishes which Natasha tried to guess. Their way
of life and place of residence, their acquaintances and ties,
Natasha's occupations, the children's upbringing, were all selected
not merely with regard to Pierre's expressed wishes, but to what
Natasha from the thoughts he expressed in conversation supposed his
wishes to be. And she deduced the essentials of his wishes quite
correctly, and having once arrived at them clung to them
tenaciously. When Pierre himself wanted to change his mind she would
fight him with his own weapons.

Thus in a time of trouble ever memorable to him after the birth of
their first child who was delicate, when they had to change the wet
nurse three times and Natasha fell ill from despair, Pierre one day
told her of Rousseau's view, with which he quite agreed, that to
have a wet nurse is unnatural and harmful. When her next baby was
born, despite the opposition of her mother, the doctors, and even of
her husband himself--who were all vigorously opposed to her nursing
her baby herself, a thing then unheard of and considered injurious-
she insisted on having her own way, and after that nursed all her
babies herself.

It very often happened that in a moment of irritation husband and
wife would have a dispute, but long afterwards Pierre to his
surprise and delight would find in his wife's ideas and actions the
very thought against which she had argued, but divested of
everything superfluous that in the excitement of the dispute he had
added when expressing his opinion.

After seven years of marriage Pierre had the joyous and firm
consciousness that he was not a bad man, and he felt this because he
saw himself reflected in his wife. He felt the good and bad within
himself inextricably mingled and overlapping. But only what was really
good in him was reflected in his wife, all that was not quite good was
rejected. And this was not the result of logical reasoning but was a
direct and mysterious reflection.





CHAPTER XI


Two months previously when Pierre was already staying with the
Rostovs he had received a letter from Prince Theodore, asking him to
come to Petersburg to confer on some important questions that were
being discussed there by a society of which Pierre was one of the
principal founders.

On reading that letter (she always read her husband's letters)
Natasha herself suggested that he should go to Petersburg, though
she would feel his absence very acutely. She attributed immense
importance to all her husband's intellectual and abstract interests
though she did not understand them, and she always dreaded being a
hindrance to him in such matters. To Pierre's timid look of inquiry
after reading the letter she replied by asking him to go, but to fix a
definite date for his return. He was given four weeks' leave of
absence.

Ever since that leave of absence had expired, more than a
fortnight before, Natasha had been in a constant state of alarm,
depression, and irritability.

Denisov, now a general on the retired list and much dissatisfied
with the present state of affairs, had arrived during that
fortnight. He looked at Natasha with sorrow and surprise as at a bad
likeness of a person once dear. A dull, dejected look, random replies,
and talk about the nursery was all he saw and heard from his former
enchantress.

Natasha was sad and irritable all that time, especially when her
mother, her brother, Sonya, or Countess Mary in their efforts to
console her tried to excuse Pierre and suggested reasons for his delay
in returning.

"It's all nonsense, all rubbish--those discussions which lead to
nothing and all those idiotic societies!" Natasha declared of the very
affairs in the immense importance of which she firmly believed.

And she would go to the nursery to nurse Petya, her only boy. No one
else could tell her anything so comforting or so reasonable as this
little three-month-old creature when he lay at her breast and she
was conscious of the movement of his lips and the snuffling of his
little nose. That creature said: "You are angry, you are jealous,
you would like to pay him out, you are afraid--but here am I! And I am
he..." and that was unanswerable. It was more than true.

During that fortnight of anxiety Natasha resorted to the baby for
comfort so often, and fussed over him so much, that she overfed him
and he fell ill. She was terrified by his illness, and yet that was
just what she needed. While attending to him she bore the anxiety
about her husband more easily.

She was nursing her boy when the sound of Pierre's sleigh was
heard at the front door, and the old nurse--knowing how to please
her mistress--entered the room inaudibly but hurriedly and with a
beaming face.

"Has he come?" Natasha asked quickly in a whisper, afraid to move
lest she should rouse the dozing baby.

"He's come, ma'am," whispered the nurse.

The blood rushed to Natasha's face and her feet involuntarily moved,
but she could not jump up and run out. The baby again opened his
eyes and looked at her. "You're here?" he seemed to be saying, and
again lazily smacked his lips.

Cautiously withdrawing her breast, Natasha rocked him a little,
handed him to the nurse, and went with rapid steps toward the door.
But at the door she stopped as if her conscience reproached her for
having in her joy left the child too soon, and she glanced round.
The nurse with raised elbows was lifting the infant over the rail of
his cot.

"Go, ma'am! Don't worry, go!" she whispered, smiling, with the
kind of familiarity that grows up between a nurse and her mistress.

Natasha ran with light footsteps to the anteroom.

Denisov, who had come out of the study into the dancing room with
his pipe, now for the first time recognized the old Natasha. A flood
of brilliant, joyful light poured from her transfigured face.

"He's come!" she exclaimed as she ran past, and Denisov felt that he
too was delighted that Pierre, whom he did not much care for, had
returned.

On reaching the vestibule Natasha saw a tall figure in a fur coat
unwinding his scarf. "It's he! It's really he! He has come!" she
said to herself, and rushing at him embraced him, pressed his head
to her breast, and then pushed him back and gazed at his ruddy,
happy face, covered with hoarfrost. "Yes, it is he, happy and
contented..."

Then all at once she remembered the tortures of suspense she had
experienced for the last fortnight, and the joy that had lit up her
face vanished; she frowned and overwhelmed Pierre with a torrent of
reproaches and angry words.

"Yes, it's all very well for you. You are pleased, you've had a good
time.... But what about me? You might at least have shown
consideration for the children. I am nursing and my milk was
spoiled.... Petya was at death's door. But you were enjoying yourself.
Yes, enjoying..."

Pierre knew he was not to blame, for he could not have come
sooner; he knew this outburst was unseemly and would blow over in a
minute or two; above all he knew that he himself was bright and happy.
He wanted to smile but dared not even think of doing so. He made a
piteous, frightened face and bent down.

"I could not, on my honor. But how is Petya?"

"All right now. Come along! I wonder you're not ashamed! If only you
could see what I was like without you, how I suffered!"

"You are well?"

"Come, come!" she said, not letting go of his arm. And they went
to their rooms.

When Nicholas and his wife came to look for Pierre he was in the
nursery holding his baby son, who was again awake, on his huge right
palm and dandling him. A blissful bright smile was fixed on the baby's
broad face with its toothless open mouth. The storm was long since
over and there was bright, joyous sunshine on Natasha's face as she
gazed tenderly at her husband and child.

"And have you talked everything well over with Prince Theodore?" she
asked.

"Yes, capitally."

"You see, he holds it up." (She meant the baby's head.) "But how
he did frighten me... You've seen the princess? Is it true she's in
love with that..."

"Yes, just fancy..."

At that moment Nicholas and Countess Mary came in. Pierre with the
baby on his hand stooped, kissed them, and replied to their inquiries.
But in spite of much that was interesting and had to be discussed, the
baby with the little cap on its unsteady head evidently absorbed all
his attention.

"How sweet!" said Countess Mary, looking at and playing with the
baby. "Now, Nicholas," she added, turning to her husband, "I can't
understand how it is you don't see the charm of these delicious
marvels."

"I don't and can't," replied Nicholas, looking coldly at the baby.
"A lump of flesh. Come along, Pierre!"

"And yet he's such an affectionate father," said Countess Mary,
vindicating her husband, "but only after they are a year old or so..."

"Now, Pierre nurses them splendidly," said Natasha. "He says his
hand is just made for a baby's seat. Just look!"

"Only not for this..." Pierre suddenly exclaimed with a laugh, and
shifting the baby he gave him to the nurse.





CHAPTER XII


As in every large household, there were at Bald Hills several
perfectly distinct worlds which merged into one harmonious whole,
though each retained its own peculiarities and made concessions to the
others. Every event, joyful or sad, that took place in that house
was important to all these worlds, but each had its own special
reasons to rejoice or grieve over that occurrence independently of the
others.

For instance, Pierre's return was a joyful and important event and
they all felt it to be so.

The servants--the most reliable judges of their masters because they
judge not by their conversation or expressions of feeling but by their
acts and way of life--were glad of Pierre's return because they knew
that when he was there Count Nicholas would cease going every day
to attend to the estate, and would be in better spirits and temper,
and also because they would all receive handsome presents for the
holidays.

The children and their governesses were glad of Pierre's return
because no one else drew them into the social life of the household as
he did. He alone could play on the clavichord that ecossaise (his only
piece) to which, as he said, all possible dances could be danced,
and they felt sure he had brought presents for them all.

Young Nicholas, now a slim lad of fifteen, delicate and intelligent,
with curly light-brown hair and beautiful eyes, was delighted
because Uncle Pierre as he called him was the object of his
rapturous and passionate affection. No one had instilled into him this
love for Pierre whom he saw only occasionally. Countess Mary who had
brought him up had done her utmost to make him love her husband as she
loved him, and little Nicholas did love his uncle, but loved him
with just a shade of contempt. Pierre, however, he adored. He did
not want to be an hussar or a Knight of St. George like his uncle
Nicholas; he wanted to be learned, wise, and kind like Pierre. In
Pierre's presence his face always shone with pleasure and he flushed
and was breathless when Pierre spoke to him. He did not miss a
single word he uttered, and would afterwards, with Dessalles or by
himself, recall and reconsider the meaning of everything Pierre had
said. Pierre's past life and his unhappiness prior to 1812 (of which
young Nicholas had formed a vague poetic picture from some words he
had overheard), his adventures in Moscow, his captivity, Platon
Karataev (of whom he had heard from Pierre), his love for Natasha
(of whom the lad was also particularly fond), and especially
Pierre's friendship with the father whom Nicholas could not
remember--all this made Pierre in his eyes a hero and a saint.

From broken remarks about Natasha and his father, from the emotion
with which Pierre spoke of that dead father, and from the careful,
reverent tenderness with which Natasha spoke of him, the boy, who
was only just beginning to guess what love is, derived the notion that
his father had loved Natasha and when dying had left her to his
friend. But the father whom the boy did not remember appeared to him a
divinity who could not be pictured, and of whom he never thought
without a swelling heart and tears of sadness and rapture. So the
boy also was happy that Pierre had arrived.

The guests welcomed Pierre because he always helped to enliven and
unite any company he was in.

The grown-up members of the family, not to mention his wife, were
pleased to have back a friend whose presence made life run more
smoothly and peacefully.

The old ladies were pleased with the presents he brought them, and
especially that Natasha would now be herself again.

Pierre felt the different outlooks of these various worlds and
made haste to satisfy all their expectations.

Though the most absent-minded and forgetful of men, Pierre, with the
aid of a list his wife drew up, had now bought everything, not
forgetting his mother--and brother-in-law's commissions, nor the dress
material for a present to Belova, nor toys for his wife's nephews.
In the early days of his marriage it had seemed strange to him that
his wife should expect him not to forget to procure all the things
he undertook to buy, and he had been taken aback by her serious
annoyance when on his first trip he forgot everything. But in time
he grew used to this demand. Knowing that Natasha asked nothing for
herself, and gave him commissions for others only when he himself
had offered to undertake them, he now found an unexpected and
childlike pleasure in this purchase of presents for everyone in the
house, and never forgot anything. If he now incurred Natasha's censure
it was only for buying too many and too expensive things. To her other
defects (as most people thought them, but which to Pierre were
qualities) of untidiness and neglect of herself, she now added
stinginess.

From the time that Pierre began life as a family man on a footing
entailing heavy expenditure, he had noticed to his surprise that he
spent only half as much as before, and that his affairs--which had
been in disorder of late, chiefly because of his first wife's debts-
had begun to improve.

Life was cheaper because it was circumscribed: that most expensive
luxury, the kind of life that can be changed at any moment, was no
longer his nor did he wish for it. He felt that his way of life had
now been settled once for all till death and that to change it was not
in his power, and so that way of life proved economical.

With a merry, smiling face Pierre was sorting his purchases.

"What do you think of this?" said he, unrolling a piece of stuff
like a shopman.

Natasha, who was sitting opposite to him with her eldest daughter on
her lap, turned her sparkling eyes swiftly from her husband to the
things he showed her.

"That's for Belova? Excellent!" She felt the quality of the
material. "It was a ruble an arshin, I suppose?"

Pierre told her the price.

"Too dear!" Natasha remarked. "How pleased the children will be
and Mamma too! Only you need not have bought me this," she added,
unable to suppress a smile as she gazed admiringly at a gold comb
set with pearls, of a kind then just coming into fashion.

"Adele tempted me: she kept on telling me to buy it," returned
Pierre.

"When am I to wear it?" and Natasha stuck it in her coil of hair.
"When I take little Masha into society? Perhaps they will be
fashionable again by then. Well, let's go now."

And collecting the presents they went first to the nursery and
then to the old countess' rooms.

The countess was sitting with her companion Belova, playing
grand-patience as usual, when Pierre and Natasha came into the drawing
room with parcels under their arms.

The countess was now over sixty, was quite gray, and wore a cap with
a frill that surrounded her face. Her face had shriveled, her upper
lip had sunk in, and her eyes were dim.

After the deaths of her son and husband in such rapid succession,
she felt herself a being accidentally forgotten in this world and left
without aim or object for her existence. She ate, drank, slept, or
kept awake, but did not live. Life gave her no new impressions. She
wanted nothing from life but tranquillity, and that tranquillity
only death could give her. But until death came she had to go on
living, that is, to use her vital forces. A peculiarity one sees in
very young children and very old people was particularly evident in
her. Her life had no external aims--only a need to exercise her
various functions and inclinations was apparent. She had to eat,
sleep, think, speak, weep, work, give vent to her anger, and so on,
merely because she had a stomach, a brain, muscles, nerves, and a
liver. She did these things not under any external impulse as people
in the full vigor of life do, when behind the purpose for which they
strive that of exercising their functions remains unnoticed. She
talked only because she physically needed to exercise her tongue and
lungs. She cried as a child does, because her nose had to be
cleared, and so on. What for people in their full vigor is an aim
was for her evidently merely a pretext.

Thus in the morning--especially if she had eaten anything rich the
day before--she felt a need of being angry and would choose as the
handiest pretext Belova's deafness.

She would begin to say something to her in a low tone from the other
end of the room.

"It seems a little warmer today, my dear," she would murmur.

And when Belova replied: "Oh yes, they've come," she would mutter
angrily: "O Lord! How stupid and deaf she is!"

Another pretext would be her snuff, which would seem too dry or
too damp or not rubbed fine enough. After these fits of irritability
her face would grow yellow, and her maids knew by infallible
symptoms when Belova would again be deaf, the snuff damp, and the
countess' face yellow. Just as she needed to work off her spleen so
she had sometimes to exercise her still-existing faculty of
thinking--and the pretext for that was a game of patience. When she
needed to cry, the deceased count would be the pretext. When she
wanted to be agitated, Nicholas and his health would be the pretext,
and when she felt a need to speak spitefully, the pretext would be
Countess Mary. When her vocal organs needed exercise, which was
usually toward seven o'clock when she had had an after-dinner rest
in a darkened room, the pretext would be the retelling of the same
stories over and over again to the same audience.

The old lady's condition was understood by the whole household
though no one ever spoke of it, and they all made every possible
effort to satisfy her needs. Only by a rare glance exchanged with a
sad smile between Nicholas, Pierre, Natasha, and Countess Mary was the
common understanding of her condition expressed.

But those glances expressed something more: they said that she had
played her part in life, that what they now saw was not her whole
self, that we must all become like her, and that they were glad to
yield to her, to restrain themselves for this once precious being
formerly as full of life as themselves, but now so much to be
pitied. "Memento mori," said these glances.

Only the really heartless, the stupid ones of that household, and
the little children failed to understand this and avoided her.





CHAPTER XIII


When Pierre and his wife entered the drawing room the countess was
in one of her customary states in which she needed the mental exertion
of playing patience, and so--though by force of habit she greeted
him with the words she always used when Pierre or her son returned
after an absence: "High time, my dear, high time! We were all weary of
waiting for you. Well, thank God!" and received her presents with
another customary remark: "It's not the gift that's precious, my dear,
but that you give it to me, an old woman..."--yet it was evident
that she was not pleased by Pierre's arrival at that moment when it
diverted her attention from the unfinished game.

She finished her game of patience and only then examined the
presents. They consisted of a box for cards, of splendid
workmanship, a bright-blue Sevres tea cup with shepherdesses
depicted on it and with a lid, and a gold snuffbox with the count's
portrait on the lid which Pierre had had done by a miniaturist in
Petersburg. The countess had long wished for such a box, but as she
did not want to cry just then she glanced indifferently at the
portrait and gave her attention chiefly to the box for cards.

"Thank you, my dear, you have cheered me up," said she as she always
did. "But best of all you have brought yourself back--for I never
saw anything like it, you ought to give your wife a scolding! What are
we to do with her? She is like a mad woman when you are away.
Doesn't see anything, doesn't remember anything," she went on,
repeating her usual phrases. "Look, Anna Timofeevna," she added to her
companion, "see what a box for cards my son has brought us!"

Belova admired the presents and was delighted with her dress
material.

Though Pierre, Natasha, Nicholas, Countess Mary, and Denisov had
much to talk about that they could not discuss before the old
countess--not that anything was hidden from her, but because she had
dropped so far behindhand in many things that had they begun to
converse in her presence they would have had to answer inopportune
questions and to repeat what they had already told her many times:
that so-and-so was dead and so-and-so was married, which she would
again be unable to remember--yet they sat at tea round the samovar
in the drawing room from habit, and Pierre answered the countess'
questions as to whether Prince Vasili had aged and whether Countess
Mary Alexeevna had sent greetings and still thought of them, and other
matters that interested no one and to which she herself was
indifferent.

Conversation of this kind, interesting to no one yet unavoidable,
continued all through teatime. All the grown-up members of the
family were assembled near the round tea table at which Sonya presided
beside the samovar. The children with their tutors and governesses had
had tea and their voices were audible from the next room. At tea all
sat in their accustomed places: Nicholas beside the stove at a small
table where his tea was handed to him; Milka, the old gray borzoi
bitch (daughter of the first Milka), with a quite gray face and
large black eyes that seemed more prominent than ever, lay on the
armchair beside him; Denisov, whose curly hair, mustache, and whiskers
had turned half gray, sat beside countess Mary with his general's
tunic unbuttoned; Pierre sat between his wife and the old countess. He
spoke of what he knew might interest the old lady and that she could
understand. He told her of external social events and of the people
who had formed the circle of her contemporaries and had once been a
real, living, and distinct group, but who were now for the most part
scattered about the world and like herself were garnering the last
ears of the harvests they had sown in earlier years. But to the old
countess those contemporaries of hers seemed to be the only serious
and real society. Natasha saw by Pierre's animation that his visit had
been interesting and that he had much to tell them but dare not say it
before the old countess. Denisov, not being a member of the family,
did not understand Pierre's caution and being, as a malcontent, much
interested in what was occurring in Petersburg, kept urging Pierre
to tell them about what had happened in the Semenovsk regiment, then
about Arakcheev, and then about the Bible Society. Once or twice
Pierre was carried away and began to speak of these things, but
Nicholas and Natasha always brought him back to the health of Prince
Ivan and Countess Mary Alexeevna.

"Well, and all this idiocy--Gossner and Tatawinova?" Denisov
asked. "Is that weally still going on?"

"Going on?" Pierre exclaimed. "Why more than ever! The Bible Society
is the whole government now!"

 "What is that, mon cher ami?" asked the countess, who had
finished her tea and evidently needed a pretext for being angry
after her meal. "What are you saying about the government? I don't
understand."

"Well, you know, Maman," Nicholas interposed, knowing how to
translate things into his mother's language, "Prince Alexander
Golitsyn has founded a society and in consequence has great influence,
they say."

"Arakcheev and Golitsyn," incautiously remarked Pierre, "are now the
whole government! And what a government! They see treason everywhere
and are afraid of everything."

"Well, and how is Prince Alexander to blame? He is a most
estimable man. I used to meet him at Mary Antonovna's," said the
countess in an offended tone; and still more offended that they all
remained silent, she went on: "Nowadays everyone finds fault. A Gospel
Society! Well, and what harm is there in that?" and she rose
(everybody else got up too) and with a severe expression sailed back
to her table in the sitting room.

The melancholy silence that followed was broken by the sounds of the
children's voices and laughter from the next room. Evidently some
jolly excitement was going on there.

"Finished, finished!" little Natasha's gleeful yell rose above
them all.

Pierre exchanged glances with Countess Mary and Nicholas (Natasha he
never lost sight of) and smiled happily.

"That's delightful music!" said he.

"It means that Anna Makarovna has finished her stocking," said
Countess Mary.

"Oh, I'll go and see," said Pierre, jumping up. "You know," he
added, stopping at the door, "why I'm especially fond of that music?
It is always the first thing that tells me all is well. When I was
driving here today, the nearer I got to the house the more anxious I
grew. As I entered the anteroom I heard Andrusha's peals of laughter
and that meant that all was well."

"I know! I know that feeling," said Nicholas. "But I mustn't go
there--those stockings are to be a surprise for me."

Pierre went to the children, and the shouting and laughter grew
still louder.

"Come, Anna Makarovna," Pierre's voice was heard saying, "come
here into the middle of the room and at the word of command, 'One,
two,' and when I say 'three'... You stand here, and you in my arms-
well now! One, two!..." said Pierre, and a silence followed:
"three!" and a rapturously breathless cry of children's voices
filled the room. "Two, two!" they shouted.

This meant two stockings, which by a secret process known only to
herself Anna Makarovna used to knit at the same time on the same
needles, and which, when they were ready, she always triumphantly
drew, one out of the other, in the children's presence.





CHAPTER XIV


Soon after this the children came in to say good night. They
kissed everyone, the tutors and governesses made their bows, and
they went out. Only young Nicholas and his tutor remained. Dessalles
whispered to the boy to come downstairs.

"No, Monsieur Dessalles, I will ask my aunt to let me stay," replied
Nicholas Bolkonski also in a whisper.

"Ma tante, please let me stay," said he, going up to his aunt.

His face expressed entreaty, agitation, and ecstasy. Countess Mary
glanced at him and turned to Pierre.

"When you are here he can't tear himself away," she said.

"I will bring him to you directly, Monsieur Dessalles. Good
night!" said Pierre, giving his hand to the Swiss tutor, and he turned
to young Nicholas with a smile. "You and I haven't seen anything of
one another yet... How like he is growing, Mary!" he added, addressing
Countess Mary.

"Like my father?" asked the boy, flushing crimson and looking up
at Pierre with bright, ecstatic eyes.

Pierre nodded, and went on with what he had been saying when the
children had interrupted. Countess Mary sat down doing woolwork;
Natasha did not take her eyes off her husband. Nicholas and Denisov
rose, asked for their pipes, smoked, went to fetch more tea from
Sonya--who sat weary but resolute at the samovar--and questioned
Pierre. The curly-headed, delicate boy sat with shining eyes unnoticed
in a corner, starting every now and then and muttering something to
himself, and evidently experiencing a new and powerful emotion as he
turned his curly head, with his thin neck exposed by his turn-down
collar, toward the place where Pierre sat.

The conversation turned on the contemporary gossip about those in
power, in which most people see the chief interest of home politics.
Denisov, dissatisfied with the government on account of his own
disappointments in the service, heard with pleasure of the things done
in Petersburg which seemed to him stupid, and made forcible and
sharp comments on what Pierre told them.

"One used to have to be a German--now one must dance with Tatawinova
and Madame Kwudener, and wead Ecka'tshausen and the bwethwen. Oh, they
should let that fine fellow Bonaparte lose--he'd knock all this
nonsense out of them! Fancy giving the command of the Semenov wegiment
to a fellow like that Schwa'tz!" he cried.

Nicholas, though free from Denisov's readiness to find fault with
everything, also thought that discussion of the government was a
very serious and weighty matter, and the fact that A had been
appointed Minister of This and B Governor General of That, and that
the Emperor had said so-and-so and this minister so-and-so, seemed
to him very important. And so he thought it necessary to take an
interest in these things and to question Pierre. The questions put
by these two kept the conversation from changing its ordinary
character of gossip about the higher government circles.

But Natasha, knowing all her husband's ways and ideas, saw that he
had long been wishing but had been unable to divert the conversation
to another channel and express his own deeply felt idea for the sake
of which he had gone to Petersburg to consult with his new friend
Prince Theodore, and she helped him by asking how his affairs with
Prince Theodore had gone.

"What was it about?" asked Nicholas.

"Always the same thing," said Pierre, looking round at his
listeners. "Everybody sees that things are going so badly that they
cannot be allowed to go on so and that it is the duty of all decent
men to counteract it as far as they can."

"What can decent men do?" Nicholas inquired, frowning slightly.
"What can be done?"

"Why, this..."

"Come into my study," said Nicholas.

Natasha, who had long expected to be fetched to nurse her baby,
now heard the nurse calling her and went to the nursery. Countess Mary
followed her. The men went into the study and little Nicholas
Bolkonski followed them unnoticed by his uncle and sat down at the
writing table in a shady corner by the window.

"Well, what would you do?" asked Denisov.

"Always some fantastic schemes," said Nicholas.

"Why this," began Pierre, not sitting down but pacing the room,
sometimes stopping short, gesticulating, and lisping: "the position in
Petersburg is this: the Emperor does not look into anything. He has
abandoned himself altogether to this mysticism" (Pierre could not
tolerate mysticism in anyone now). "He seeks only for peace, and
only these people sans foi ni loi* can give it him--people who
recklessly hack at and strangle everything--Magnitski, Arakcheev,
and tutti quanti.... You will agree that if you did not look after
your estates yourself but only wanted a quiet life, the harsher your
steward was the more readily your object might be attained," he said
to Nicholas.


*Without faith or law.


"Well, what does that lead up to?" said Nicholas.

"Well, everything is going to ruin! Robbery in the law courts, in
the army nothing but flogging, drilling, and Military Settlements; the
people are tortured, enlightenment is suppressed. All that is young
and honest is crushed! Everyone sees that this cannot go on.
Everything is strained to such a degree that it will certainly break,"
said Pierre (as those who examine the actions of any government have
always said since governments began). "I told them just one thing in
Petersburg."

"Told whom?"

"Well, you know whom," said Pierre, with a meaning glance from under
his brows. "Prince Theodore and all those. To encourage culture and
philanthropy is all very well of course. The aim is excellent but in
the present circumstances something else is needed."

At that moment Nicholas noticed the presence of his nephew. His face
darkened and he went up to the boy.

"Why are you here?"

"Why? Let him be," said Pierre, taking Nicholas by the arm and
continuing. "That is not enough, I told them. Something else is
needed. When you stand expecting the overstrained string to snap at
any moment, when everyone is expecting the inevitable catastrophe,
as many as possible must join hands as closely as they can to
withstand the general calamity. Everything that is young and strong is
being enticed away and depraved. One is lured by women, another by
honors, a third by ambition or money, and they go over to that camp.
No independent men, such as you or I, are left. What I say is widen
the scope of our society, let the mot d'ordre be not virtue alone
but independence and action as well!"

Nicholas, who had left his nephew, irritably pushed up an
armchair, sat down in it, and listened to Pierre, coughing
discontentedly and frowning more and more.

"But action with what aim?" he cried. "And what position will you
adopt toward the government?"

"Why, the position of assistants. The society need not be secret
if the government allows it. Not merely is it not hostile to
government, but it is a society of true conservatives--a society of
gentlemen in the full meaning of that word. It is only to prevent some
Pugachev or other from killing my children and yours, and Arakcheev
from sending me off to some Military Settlement. We join hands only
for the public welfare and the general safety."

"Yes, but it's a secret society and therefore a hostile and
harmful one which can only cause harm."

"Why? Did the Tugendbund which saved Europe" (they did not then
venture to suggest that Russia had saved Europe) "do any harm? The
Tugendbund is an alliance of virtue: it is love, mutual help... it
is what Christ preached on the Cross."

Natasha, who had come in during the conversation, looked joyfully at
her husband. It was not what he was saying that pleased her--that
did not even interest her, for it seemed to her that was all extremely
simple and that she had known it a long time (it seemed so to her
because she knew that it sprang from Pierre's whole soul), but it
was his animated and enthusiastic appearance that made her glad.

The boy with the thin neck stretching out from the turn-down collar-
whom everyone had forgotten--gazed at Pierre with even greater and
more rapturous joy. Every word of Pierre's burned into his heart,
and with a nervous movement of his fingers he unconsciously broke
the sealing wax and quill pens his hands came upon on his uncle's
table.

"It is not at all what you suppose; but that is what the German
Tugendbund was, and what I am proposing."

"No, my fwiend! The Tugendbund is all vewy well for the sausage
eaters, but I don't understand it and can't even pwonounce it,"
interposed Denisov in a loud and resolute voice. "I agwee that
evewything here is wotten and howwible, but the Tugendbund I don't
understand. If we're not satisfied, let us have a bunt of our own.
That's all wight. Je suis vot'e homme!"*


*"I'm your man."


Pierre smiled, Natasha began to laugh, but Nicholas knitted his
brows still more and began proving to Pierre that there was no
prospect of any great change and that all the danger he spoke of
existed only in his imagination. Pierre maintained the contrary, and
as his mental faculties were greater and more resourceful, Nicholas
felt himself cornered. This made him still angrier, for he was fully
convinced, not by reasoning but by something within him stronger
than reason, of the justice of his opinion.

"I will tell you this," he said, rising and trying with nervously
twitching fingers to prop up his pipe in a corner, but finally
abandoning the attempt. "I can't prove it to you. You say that
everything here is rotten and that an overthrow is coming: I don't see
it. But you also say that our oath of allegiance is a conditional
matter, and to that I reply: 'You are my best friend, as you know, but
if you formed a secret society and began working against the
government--be it what it may--I know it is my duty to obey the
government. And if Arakcheev ordered me to lead a squadron against you
and cut you down, I should not hesitate an instant, but should do it.'
And you may argue about that as you like!"

An awkward silence followed these words. Natasha was the first to
speak, defending her husband and attacking her brother. Her defense
was weak and inapt but she attained her object. The conversation was
resumed, and no longer in the unpleasantly hostile tone of Nicholas'
last remark.

When they all got up to go in to supper, little Nicholas Bolkonski
went up to Pierre, pale and with shining, radiant eyes.

"Uncle Pierre, you... no... If Papa were alive... would he agree
with you?" he asked.

And Pierre suddenly realized what a special, independent, complex,
and powerful process of thought and feeling must have been going on in
this boy during that conversation, and remembering all he had said
he regretted that the lad should have heard him. He had, however, to
give him an answer.

"Yes, I think so," he said reluctantly, and left the study.

The lad looked down and seemed now for the first time to notice what
he had done to the things on the table. He flushed and went up to
Nicholas.

"Uncle, forgive me, I did that... unintentionally," he said,
pointing to the broken sealing wax and pens.

Nicholas started angrily.

"All right, all right," he said, throwing the bits under the table.

And evidently suppressing his vexation with difficulty, he turned
away from the boy.

"You ought not to have been here at all," he said.





CHAPTER XV


The conversation at supper was not about politics or societies,
but turned on the subject Nicholas liked best--recollections of
1812. Denisov started these and Pierre was particularly agreeable
and amusing about them. The family separated on the most friendly
terms.

After supper Nicholas, having undressed in his study and given
instructions to the steward who had been waiting for him, went to
the bedroom in his dressing gown, where he found his wife still at her
table, writing.

"What are you writing, Mary?" Nicholas asked.

Countess Mary blushed. She was afraid that what she was writing
would not be understood or approved by her husband.

She had wanted to conceal what she was writing from him, but at
the same time was glad he had surprised her at it and that she would
now have to tell him.

"A diary, Nicholas," she replied, handing him a blue exercise book
filled with her firm, bold writing.

"A diary?" Nicholas repeated with a shade of irony, and he took up
the book.

It was in French.


December 4. Today when Andrusha (her eldest boy) woke up he did
not wish to dress and Mademoiselle Louise sent for me. He was
naughty and obstinate. I tried threats, but he only grew angrier. Then
I took the matter in hand: I left him alone and began with nurse's
help to get the other children up, telling him that I did not love
him. For a long time he was silent, as if astonished, then he jumped
out of bed, ran to me in his shirt, and sobbed so that I could not
calm him for a long time. It was plain that what troubled him most was
that he had grieved me. Afterwards in the evening when I gave him
his ticket, he again began crying piteously and kissing me. One can do
anything with him by tenderness.


"What is a 'ticket'?" Nicholas inquired.

"I have begun giving the elder ones marks every evening, showing how
they have behaved."

Nicholas looked into the radiant eyes that were gazing at him, and
continued to turn over the pages and read. In the diary was set down
everything in the children's lives that seemed noteworthy to their
mother as showing their characters or suggesting general reflections
on educational methods. They were for the most part quite
insignificant trifles, but did not seem so to the mother or to the
father either, now that he read this diary about his children for
the first time.

Under the date "5" was entered:


Mitya was naughty at table. Papa said he was to have no pudding.
He had none, but looked so unhappily and greedily at the others
while they were eating! I think that punishment by depriving
children of sweets only develops their greediness. Must tell
Nicholas this.


Nicholas put down the book and looked at his wife. The radiant
eyes gazed at him questioningly: would he approve or disapprove of her
diary? There could be no doubt not only of his approval but also of
his admiration for his wife.

Perhaps it need not be done so pedantically, thought Nicholas, or
even done at all, but this untiring, continual spiritual effort of
which the sole aim was the children's moral welfare delighted him. Had
Nicholas been able to analyze his feelings he would have found that
his steady, tender, and proud love of his wife rested on his feeling
of wonder at her spirituality and at the lofty moral world, almost
beyond his reach, in which she had her being.

He was proud of her intelligence and goodness, recognized his own
insignificance beside her in the spiritual world, and rejoiced all the
more that she with such a soul not only belonged to him but was part
of himself.

"I quite, quite approve, my dearest!" said he with a significant
look, and after a short pause he added: "And I behaved badly today.
You weren't in the study. We began disputing--Pierre and I--and I lost
my temper. But he is impossible: such a child! I don't know what would
become of him if Natasha didn't keep him in hand.... Have you any idea
why he went to Petersburg? They have formed..."

"Yes, I know," said Countess Mary. "Natasha told me."

"Well, then, you know," Nicholas went on, growing hot at the mere
recollection of their discussion, "he wanted to convince me that it is
every honest man's duty to go against the government, and that the
oath of allegiance and duty... I am sorry you weren't there. They
all fell on me--Denisov and Natasha... Natasha is absurd. How she
rules over him! And yet there need only be a discussion and she has no
words of her own but only repeats his sayings..." added Nicholas,
yielding to that irresistible inclination which tempts us to judge
those nearest and dearest to us. He forgot that what he was saying
about Natasha could have been applied word for word to himself in
relation to his wife.

"Yes, I have noticed that," said Countess Mary.

"When I told him that duty and the oath were above everything, he
started proving goodness knows what! A pity you were not there--what
would you have said?"

"As I see it you were quite right, and I told Natasha so. Pierre
says everybody is suffering, tortured, and being corrupted, and that
it is our duty to help our neighbor. Of course he is right there,"
said Countess Mary, "but he forgets that we have other duties nearer
to us, duties indicated to us by God Himself, and that though we might
expose ourselves to risks we must not risk our children."

"Yes, that's it! That's just what I said to him," put in Nicholas,
who fancied he really had said it. "But they insisted on their own
view: love of one's neighbor and Christianity--and all this in the
presence of young Nicholas, who had gone into my study and broke all
my things."

"Ah, Nicholas, do you know I am often troubled about little
Nicholas," said Countess Mary. "He is such an exceptional boy. I am
afraid I neglect him in favor of my own: we all have children and
relations while he has no one. He is constantly alone with his
thoughts."

"Well, I don't think you need reproach yourself on his account.
All that the fondest mother could do for her son you have done and are
doing for him, and of course I am glad of it. He is a fine lad, a fine
lad! This evening he listened to Pierre in a sort of trance, and
fancy--as we were going in to supper I looked and he had broken
everything on my table to bits, and he told me of it himself at
once! I never knew him to tell an untruth. A fine lad, a fine lad!"
repeated Nicholas, who at heart was not fond of Nicholas Bolkonski but
was always anxious to recognize that he was a fine lad.

"Still, I am not the same as his own mother," said Countess Mary. "I
feel I am not the same and it troubles me. A wonderful boy, but I am
dreadfully afraid for him. It would be good for him to have
companions."

"Well it won't be for long. Next summer I'll take him to
Petersburg," said Nicholas. "Yes, Pierre always was a dreamer and
always will be," he continued, returning to the talk in the study
which had evidently disturbed him. "Well, what business is it of
mine what goes on there--whether Arakcheev is bad, and all that?
What business was it of mine when I married and was so deep in debt
that I was threatened with prison, and had a mother who could not
see or understand it? And then there are you and the children and
our affairs. Is it for my own pleasure that I am at the farm or in the
office from morning to night? No, but I know I must work to comfort my
mother, to repay you, and not to leave the children such beggars as
I was."

Countess Mary wanted to tell him that man does not live by bread
alone and that he attached too much importance to these matters. But
she knew she must not say this and that it would be useless to do
so. She only took his hand and kissed it. He took this as a sign of
approval and a confirmation of his thoughts, and after a few
minutes' reflection continued to think aloud.

"You know, Mary, today Elias Mitrofanych" (this was his overseer)
"came back from the Tambov estate and told me they are already
offering eighty thousand rubles for the forest."

And with an eager face Nicholas began to speak of the possibility of
repurchasing Otradnoe before long, and added: "Another ten years of
life and I shall leave the children... in an excellent position."

Countess Mary listened to her husband and understood all that he
told her. She knew that when he thought aloud in this way he would
sometimes ask her what he had been saying, and be vexed if he
noticed that she had been thinking about something else. But she had
to force herself to attend, for what he was saying did not interest
her at all. She looked at him and did not think, but felt, about
something different. She felt a submissive tender love for this man
who would never understand all that she understood, and this seemed to
make her love for him still stronger and added a touch of passionate
tenderness. Besides this feeling which absorbed her altogether and
hindered her from following the details of her husband's plans,
thoughts that had no connection with what he was saying flitted
through her mind. She thought of her nephew. Her husband's account
of the boy's agitation while Pierre was speaking struck her
forcibly, and various traits of his gentle, sensitive character
recurred to her mind; and while thinking of her nephew she thought
also of her own children. She did not compare them with him, but
compared her feeling for them with her feeling for him, and felt
with regret that there was something lacking in her feeling for
young Nicholas.

Sometimes it seemed to her that this difference arose from the
difference in their ages, but she felt herself to blame toward him and
promised in her heart to do better and to accomplish the impossible-
in this life to love her husband, her children, little Nicholas, and
all her neighbors, as Christ loved mankind. Countess Mary's soul
always strove toward the infinite, the eternal, and the absolute,
and could therefore never be at peace. A stern expression of the
lofty, secret suffering of a soul burdened by the body appeared on her
face. Nicholas gazed at her. "O God! What will become of us if she
dies, as I always fear when her face is like that?" thought he, and
placing himself before the icon he began to say his evening prayers.





CHAPTER XVI


Natasha and Pierre, left alone, also began to talk as only a husband
and wife can talk, that is, with extraordinary clearness and rapidity,
understanding and expressing each other's thoughts in ways contrary to
all rules of logic, without premises, deductions, or conclusions,
and in a quite peculiar way. Natasha was so used to this kind of
talk with her husband that for her it was the surest sign of something
being wrong between them if Pierre followed a line of logical
reasoning. When he began proving anything, or talking
argumentatively and calmly and she, led on by his example, began to do
the same, she knew that they were on the verge of a quarrel.

From the moment they were alone and Natasha came up to him with
wide-open happy eyes, and quickly seizing his head pressed it to her
bosom, saying: "Now you are all mine, mine! You won't escape!"--from
that moment this conversation began, contrary to all the laws of logic
and contrary to them because quite different subjects were talked
about at one and the same time. This simultaneous discussion of many
topics did not prevent a clear understanding but on the contrary was
the surest sign that they fully understood one another.

Just as in a dream when all is uncertain, unreasoning, and
contradictory, except the feeling that guides the dream, so in this
intercourse contrary to all laws of reason, the words themselves
were not consecutive and clear but only the feeling that prompted
them.

Natasha spoke to Pierre about her brother's life and doings, of
how she had suffered and lacked life during his own absence, and of
how she was fonder than ever of Mary, and how Mary was in every way
better than herself. In saying this Natasha was sincere in
acknowledging Mary's superiority, but at the same time by saying it
she made a demand on Pierre that he should, all the same, prefer her
to Mary and to all other women, and that now, especially after
having seen many women in Petersburg, he should tell her so afresh.

Pierre, answering Natasha's words, told her how intolerable it had
been for him to meet ladies at dinners and balls in Petersburg.

"I have quite lost the knack of talking to ladies," he said. "It was
simply dull. Besides, I was very busy."

Natasha looked intently at him and went on:

"Mary is so splendid," she said. "How she understands children! It
is as if she saw straight into their souls. Yesterday, for instance,
Mitya was naughty..."

"How like his father he is," Pierre interjected.

Natasha knew why he mentioned Mitya's likeness to Nicholas: the
recollection of his dispute with his brother-in-law was unpleasant and
he wanted to know what Natasha thought of it.

"Nicholas has the weakness of never agreeing with anything not
generally accepted. But I understand that you value what opens up a
fresh line," said she, repeating words Pierre had once uttered.

"No, the chief point is that to Nicholas ideas and discussions are
an amusement--almost a pastime," said Pierre. "For instance, he is
collecting a library and has made it a rule not to buy a new book till
he has read what he had already bought--Sismondi and Rousseau and
Montesquieu," he added with a smile. "You know how much I..." he began
to soften down what he had said; but Natasha interrupted him to show
that this was unnecessary.

"So you say ideas are an amusement to him...."

"Yes, and for me nothing else is serious. All the time in Petersburg
I saw everyone as in a dream. When I am taken up by a thought, all
else is mere amusement."

"Ah, I'm so sorry I wasn't there when you met the children," said
Natasha. "Which was most delighted? Lisa, I'm sure."

"Yes," Pierre replied, and went on with what was in his mind.
"Nicholas says we ought not to think. But I can't help it. Besides,
when I was in Petersburg I felt (I can this to you) that the whole
affair would go to pieces without me--everyone was pulling his own
way. But I succeeded in uniting them all; and then my idea is so clear
and simple. You see, I don't say that we ought to oppose this and
that. We may be mistaken. What I say is: 'Join hands, you who love the
right, and let there be but one banner--that of active virtue.' Prince
Sergey is a fine fellow and clever."

Natasha would have had no doubt as to the greatness of Pierre's
idea, but one thing disconcerted her. "Can a man so important and
necessary to society be also my husband? How did this happen?" She
wished to express this doubt to him. "Now who could decide whether
he is really cleverer than all the others?" she asked herself, and
passed in review all those whom Pierre most respected. Judging by what
he had said there was no one he had respected so highly as Platon
Karataev.

"Do you know what I am thinking about?" she asked. "About Platon
Karataev. Would he have approved of you now, do you think?"

Pierre was not at all surprised at this question. He understood
his wife's line of thought.

"Platon Karataev?" he repeated, and pondered, evidently sincerely
trying to imagine Karataev's opinion on the subject. "He would not
have understood... yet perhaps he would."

"I love you awfully!" Natasha suddenly said. "Awfully, awfully!"

"No, he would not have approved," said Pierre, after reflection.
"What he would have approved of is our family life. He was always so
anxious to find seemliness, happiness, and peace in everything, and
I should have been proud to let him see us. There now--you talk of
my absence, but you wouldn't believe what a special feeling I have for
you after a separation...."

"Yes, I should think..." Natasha began.

"No, it's not that. I never leave off loving you. And one couldn't
love more, but this is something special.... Yes, of course-" he did
not finish because their eyes meeting said the rest.

"What nonsense it is," Natasha suddenly exclaimed, "about
honeymoons, and that the greatest happiness is at first! On the
contrary, now is the best of all. If only you did not go away! Do
you remember how we quarreled? And it was always my fault. Always
mine. And what we quarreled about--I don't even remember!"

"Always about the same thing," said Pierre with a smile. "Jealo..."

"Don't say it! I can't bear it!" Natasha cried, and her eyes
glittered coldly and vindictively. "Did you see her?" she added, after
a pause.

"No, and if I had I shouldn't have recognized her."

They were silent for a while.

"Oh, do you know? While you were talking in the study I was
looking at you," Natasha began, evidently anxious to disperse the
cloud that had come over them. "You are as like him as two peas-
like the boy." (She meant her little son.) "Oh, it's time to go to
him.... The milk's come.... But I'm sorry to leave you."

They were silent for a few seconds. Then suddenly turning to one
another at the same time they both began to speak. Pierre began with
self-satisfaction and enthusiasm, Natasha with a quiet, happy smile.
Having interrupted one another they both stopped to let the other
continue.

"No. What did you say? Go on, go on."

"No, you go on, I was talking nonsense," said Natasha.

Pierre finished what he had begun. It was the sequel to his
complacent reflections on his success in Petersburg. At that moment it
seemed to him that he was chosen to give a new direction to the
whole of Russian society and to the whole world.

"I only wished to say that ideas that have great results are
always simple ones. My whole idea is that if vicious people are united
and constitute a power, then honest folk must do the same. Now
that's simple enough."

"Yes."

"And what were you going to say?"

"I? Only nonsense."

"But all the same?"

"Oh nothing, only a trifle," said Natasha, smilingly still more
brightly. "I only wanted to tell you about Petya: today nurse was
coming to take him from me, and he laughed, shut his eyes, and clung
to me. I'm sure he thought he was hiding. Awfully sweet! There, now
he's crying. Well, good-by!" and she left the room.


Meanwhile downstairs in young Nicholas Bolkonski's bedroom a
little lamp was burning as usual. (The boy was afraid of the dark
and they could not cure him of it.) Dessalles slept propped up on four
pillows and his Roman nose emitted sounds of rhythmic snoring.
Little Nicholas, who had just waked up in a cold perspiration, sat
up in bed and gazed before him with wide-open eyes. He had awaked from
a terrible dream. He had dreamed that he and Uncle Pierre, wearing
helmets such as were depicted in his Plutarch, were leading a huge
army. The army was made up of white slanting lines that filled the air
like the cobwebs that float about in autumn and which Dessalles called
les fils de la Vierge. In front was Glory, which was similar to
those threads but rather thicker. He and Pierre were borne along
lightly and joyously, nearer and nearer to their goal. Suddenly the
threads that moved them began to slacken and become entangled and it
grew difficult to move. And Uncle Nicholas stood before them in a
stern and threatening attitude.

"Have you done this?" he said, pointing to some broken sealing wax
and pens. "I loved you, but I have orders from Arakcheev and will kill
the first of you who moves forward." Little Nicholas turned to look at
Pierre but Pierre was no longer there. In his place was his father-
Prince Andrew--and his father had neither shape nor form, but he
existed, and when little Nicholas perceived him he grew faint with
love: he felt himself powerless, limp, and formless. His father
caressed and pitied him. But Uncle Nicholas came nearer and nearer
to them. Terror seized young Nicholas and he awoke.

"My father!" he thought. (Though there were two good portraits of
Prince Andrew in the house, Nicholas never imagined him in human
form.) "My father has been with me and caressed me. He approved of
me and of Uncle Pierre. Whatever he may tell me, I will do it.
Mucius Scaevola burned his hand. Why should not the same sort of thing
happen to me? I know they want me to learn. And I will learn. But
someday I shall have finished learning, and then I will do
something. I only pray God that something may happen to me such as
happened to Plutarch's men, and I will act as they did. I will do
better. Everyone shall know me, love me, and be delighted with me!"
And suddenly his bosom heaved with sobs and he began to cry.

"Are you ill?" he heard Dessalles' voice asking.

"No," answered Nicholas, and lay back on his pillow.

"He is good and kind and I am fond of him!" he thought of Dessalles.
"But Uncle Pierre! Oh, what a wonderful man he is! And my father?
Oh, Father, Father! Yes, I will do something with which even he
would be satisfied...."







SECOND EPILOGUE





CHAPTER I


History is the life of nations and of humanity. To seize and put
into words, to describe directly the life of humanity or even of a
single nation, appears impossible.

The ancient historians all employed one and the same method to
describe and seize the apparently elusive--the life of a people.
They described the activity of individuals who ruled the people, and
regarded the activity of those men as representing the activity of the
whole nation.

The question: how did individuals make nations act as they wished
and by what was the will of these individuals themselves guided? the
ancients met by recognizing a divinity which subjected the nations
to the will of a chosen man, and guided the will of that chosen man so
as to accomplish ends that were predestined.

For the ancients these questions were solved by a belief in the
direct participation of the Deity in human affairs.

Modern history, in theory, rejects both these principles.

It would seem that having rejected the belief of the ancients in
man's subjection to the Deity and in a predetermined aim toward
which nations are led, modern history should study not the
manifestations of power but the causes that produce it. But modern
history has not done this. Having in theory rejected the view held
by the ancients, it still follows them in practice.

Instead of men endowed with divine authority and directly guided
by the will of God, modern history has given us either heroes
endowed with extraordinary, superhuman capacities, or simply men of
very various kinds, from monarchs to journalists, who lead the masses.
Instead of the former divinely appointed aims of the Jewish, Greek, or
Roman nations, which ancient historians regarded as representing the
progress of humanity, modern history has postulated its own aims-
the welfare of the French, German, or English people, or, in its
highest abstraction, the welfare and civilization of humanity in
general, by which is usually meant that of the peoples occupying a
small northwesterly portion of a large continent.

Modern history has rejected the beliefs of the ancients without
replacing them by a new conception, and the logic of the situation has
obliged the historians, after they had apparently rejected the
divine authority of the kings and the "fate" of the ancients, to reach
the same conclusion by another road, that is, to recognize (1) nations
guided by individual men, and (2) the existence of a known aim to
which these nations and humanity at large are tending.

At the basis of the works of all the modern historians from Gibbon
to Buckle, despite their seeming disagreements and the apparent
novelty of their outlooks, lie those two old, unavoidable assumptions.

In the first place the historian describes the activity of
individuals who in his opinion have directed humanity (one historian
considers only monarchs, generals, and ministers as being such men,
while another includes also orators, learned men, reformers,
philosophers, and poets). Secondly, it is assumed that the goal toward
which humanity is being led is known to the historians: to one of them
this goal is the greatness of the Roman, Spanish, or French realm;
to another it is liberty, equality, and a certain kind of civilization
of a small corner of the world called Europe.

In 1789 a ferment arises in Paris; it grows, spreads, and is
expressed by a movement of peoples from west to east. Several times it
moves eastward and collides with a countermovement from the east
westward. In 1812 it reaches its extreme limit, Moscow, and then, with
remarkable symmetry, a countermovement occurs from east to west,
attracting to it, as the first movement had done, the nations of
middle Europe. The counter movement reaches the starting point of
the first movement in the west--Paris--and subsides.

During that twenty-year period an immense number of fields were left
untilled, houses were burned, trade changed its direction, millions of
men migrated, were impoverished, or were enriched, and millions of
Christian men professing the law of love of their fellows slew one
another.

What does all this mean? Why did it happen? What made those people
burn houses and slay their fellow men? What were the causes of these
events? What force made men act so? These are the instinctive,
plain, and most legitimate questions humanity asks itself when it
encounters the monuments and tradition of that period.

For a reply to these questions the common sense of mankind turns
to the science of history, whose aim is to enable nations and humanity
to know themselves.

If history had retained the conception of the ancients it would have
said that God, to reward or punish his people, gave Napoleon power and
directed his will to the fulfillment of the divine ends, and that
reply, would have been clear and complete. One might believe or
disbelieve in the divine significance of Napoleon, but for anyone
believing in it there would have been nothing unintelligible in the
history of that period, nor would there have been any contradictions.

But modern history cannot give that reply. Science does not admit
the conception of the ancients as to the direct participation of the
Deity in human affairs, and therefore history ought to give other
answers.

Modern history replying to these questions says: you want to know
what this movement means, what caused it, and what force produced
these events? Then listen:

"Louis XIV was a very proud and self-confident man; he had such
and such mistresses and such and such ministers and he ruled France
badly. His descendants were weak men and they too ruled France
badly. And they had such and such favorites and such and such
mistresses. Moreover, certain men wrote some books at that time. At
the end of the eighteenth century there were a couple of dozen men
in Paris who began to talk about all men being free and equal. This
caused people all over France to begin to slash at and drown one
another. They killed the king and many other people. At that time
there was in France a man of genius--Napoleon. He conquered
everybody everywhere--that is, he killed many people because he was
a great genius. And for some reason he went to kill Africans, and
killed them so well and was so cunning and wise that when he
returned to France he ordered everybody to obey him, and they all
obeyed him. Having become an Emperor he again went out to kill
people in Italy, Austria, and Prussia. And there too he killed a great
many. In Russia there was an Emperor, Alexander, who decided to
restore order in Europe and therefore fought against Napoleon. In 1807
he suddenly made friends with him, but in 1811 they again quarreled
and again began killing many people. Napoleon led six hundred thousand
men into Russia and captured Moscow; then he suddenly ran away from
Moscow, and the Emperor Alexander, helped by the advice of Stein and
others, united Europe to arm against the disturber of its peace. All
Napoleon's allies suddenly became his enemies and their forces
advanced against the fresh forces he raised. The Allies defeated
Napoleon, entered Paris, forced Napoleon to abdicate, and sent him
to the island of Elba, not depriving him of the title of Emperor and
showing him every respect, though five years before and one year later
they all regarded him as an outlaw and a brigand. Then Louis XVIII,
who till then had been the laughingstock both of the French and the
Allies, began to reign. And Napoleon, shedding tears before his Old
Guards, renounced the throne and went into exile. Then the skillful
statesmen and diplomatists (especially Talleyrand, who managed to
sit down in a particular chair before anyone else and thereby extended
the frontiers of France) talked in Vienna and by these conversations
made the nations happy or unhappy. Suddenly the diplomatists and
monarchs nearly quarreled and were on the point of again ordering
their armies to kill one another, but just then Napoleon arrived in
France with a battalion, and the French, who had been hating him,
immediately all submitted to him. But the Allied monarchs were angry
at this and went to fight the French once more. And they defeated
the genius Napoleon and, suddenly recognizing him as a brigand, sent
him to the island of St. Helena. And the exile, separated from the
beloved France so dear to his heart, died a lingering death on that
rock and bequeathed his great deeds to posterity. But in Europe a
reaction occurred and the sovereigns once again all began to oppress
their subjects."

It would be a mistake to think that this is ironic--a caricature
of the historical accounts. On the contrary it is a very mild
expression of the contradictory replies, not meeting the questions,
which all the historians give, from the compilers of memoirs and the
histories of separate states to the writers of general histories and
the new histories of the culture of that period.

The strangeness and absurdity of these replies arise from the fact
that modern history, like a deaf man, answers questions no one has
asked.

If the purpose of history be to give a description of the movement
of humanity and of the peoples, the first question--in the absence
of a reply to which all the rest will be incomprehensible--is: what is
the power that moves peoples? To this, modern history laboriously
replies either that Napoleon was a great genius, or that Louis XIV was
very proud, or that certain writers wrote certain books.

All that may be so and mankind is ready to agree with it, but it
is not what was asked. All that would be interesting if we
recognized a divine power based on itself and always consistently
directing its nations through Napoleons, Louis-es, and writers; but we
do not acknowledge such a power, and therefore before speaking about
Napoleons, Louis-es, and authors, we ought to be shown the
connection existing between these men and the movement of the nations.

If instead of a divine power some other force has appeared, it
should be explained in what this new force consists, for the whole
interest of history lies precisely in that force.

History seems to assume that this force is self-evident and known to
everyone. But in spite of every desire to regard it as known, anyone
reading many historical works cannot help doubting whether this new
force, so variously understood by the historians themselves, is really
quite well known to everybody.





CHAPTER II


What force moves the nations?

Biographical historians and historians of separate nations
understand this force as a power inherent in heroes and rulers. In
their narration events occur solely by the will of a Napoleon, and
Alexander, or in general of the persons they describe. The answers
given by this kind of historian to the question of what force causes
events to happen are satisfactory only as long as there is but one
historian to each event. As soon as historians of different
nationalities and tendencies begin to describe the same event, the
replies they give immediately lose all meaning, for this force is
understood by them all not only differently but often in quite
contradictory ways. One historian says that an event was produced by
Napoleon's power, another that it was produced by Alexander's, a third
that it was due to the power of some other person. Besides this,
historians of that kind contradict each other even in their
statement as to the force on which the authority of some particular
person was based. Thiers, a Bonapartist, says that Napoleon's power
was based on his virtue and genius. Lanfrey, a Republican, says it was
based on his trickery and deception of the people. So the historians
of this class, by mutually destroying one another's positions, destroy
the understanding of the force which produces events, and furnish no
reply to history's essential question.

Writers of universal history who deal with all the nations seem to
recognize how erroneous is the specialist historians' view of the
force which produces events. They do not recognize it as a power
inherent in heroes and rulers, but as the resultant of a
multiplicity of variously directed forces. In describing a war or
the subjugation of a people, a general historian looks for the cause
of the event not in the power of one man, but in the interaction of
many persons connected with the event.

According to this view the power of historical personages,
represented as the product of many forces, can no longer, it would
seem, be regarded as a force that itself produces events. Yet in
most cases universal historians still employ the conception of power
as a force that itself produces events, and treat it as their cause.
In their exposition, an historic character is first the product of his
time, and his power only the resultant of various forces, and then his
power is itself a force producing events. Gervinus, Schlosser, and
others, for instance, at one time prove Napoleon to be a product of
the Revolution, of the ideas of 1789 and so forth, and at another
plainly say that the campaign of 1812 and other things they do not
like were simply the product of Napoleon's misdirected will, and
that the very ideas of 1789 were arrested in their development by
Napoleon's caprice. The ideas of the Revolution and the general temper
of the age produced Napoleon's power. But Napoleon's power
suppressed the ideas of the Revolution and the general temper of the
age.

This curious contradiction is not accidental. Not only does it occur
at every step, but the universal historians' accounts are all made
up of a chain of such contradictions. This contradiction occurs
because after entering the field of analysis the universal
historians stop halfway.

To find component forces equal to the composite or resultant
force, the sum of the components must equal the resultant. This
condition is never observed by the universal historians, and so to
explain the resultant forces they are obliged to admit, in addition to
the insufficient components, another unexplained force affecting the
resultant action.

Specialist historians describing the campaign of 1813 or the
restoration of the Bourbons plainly assert that these events were
produced by the will of Alexander. But the universal historian
Gervinus, refuting this opinion of the specialist historian, tries
to prove that the campaign of 1813 and the restoration of the Bourbons
were due to other things beside Alexander's will--such as the activity
of Stein, Metternich, Madame de Stael, Talleyrand, Fichte
Chateaubriand, and others. The historian evidently decomposes
Alexander's power into the components: Talleyrand, Chateaubriand,
and the rest--but the sum of the components, that is, the interactions
of Chateaubriand, Talleyrand, Madame de Stael, and the others,
evidently does not equal the resultant, namely the phenomenon of
millions of Frenchmen submitting to the Bourbons. That
Chateaubriand, Madame de Stael, and others spoke certain words to
one another only affected their mutual relations but does not
account for the submission of millions. And therefore to explain how
from these relations of theirs the submission of millions of people
resulted--that is, how component forces equal to one A gave a
resultant equal to a thousand times A--the historian is again
obliged to fall back on power--the force he had denied--and to
recognize it as the resultant of the forces, that is, he has to
admit an unexplained force acting on the resultant. And that is just
what the universal historians do, and consequently they not only
contradict the specialist historians but contradict themselves.

Peasants having no clear idea of the cause of rain, say, according
to whether they want rain or fine weather: "The wind has blown the
clouds away," or, "The wind has brought up the clouds." And in the
same way the universal historians sometimes, when it pleases them
and fits in with their theory, say that power is the result of events,
and sometimes, when they want to prove something else, say that
power produces events.

A third class of historians--the so-called historians of culture-
following the path laid down by the universal historians who sometimes
accept writers and ladies as forces producing events--again take
that force to be something quite different. They see it in what is
called culture--in mental activity.

The historians of culture are quite consistent in regard to their
progenitors, the writers of universal histories, for if historical
events may be explained by the fact that certain persons treated one
another in such and such ways, why not explain them by the fact that
such and such people wrote such and such books? Of the immense
number of indications accompanying every vital phenomenon, these
historians select the indication of intellectual activity and say that
this indication is the cause. But despite their endeavors to prove
that the cause of events lies in intellectual activity, only by a
great stretch can one admit that there is any connection between
intellectual activity and the movement of peoples, and in no case
can one admit that intellectual activity controls people's actions,
for that view is not confirmed by such facts as the very cruel murders
of the French Revolution resulting from the doctrine of the equality
of man, or the very cruel wars and executions resulting from the
preaching of love.

But even admitting as correct all the cunningly devised arguments
with which these histories are filled--admitting that nations are
governed by some undefined force called an idea--history's essential
question still remains unanswered, and to the former power of monarchs
and to the influence of advisers and other people introduced by the
universal historians, another, newer force--the idea--is added, the
connection of which with the masses needs explanation. It is
possible to understand that Napoleon had power and so events occurred;
with some effort one may even conceive that Napoleon together with
other influences was the cause of an event; but how a book, Le Contrat
social, had the effect of making Frenchmen begin to drown one
another cannot be understood without an explanation of the causal
nexus of this new force with the event.

Undoubtedly some relation exists between all who live
contemporaneously, and so it is possible to find some connection
between the intellectual activity of men and their historical
movements, just as such a connection may be found between the
movements of humanity and commerce, handicraft, gardening, or anything
else you please. But why intellectual activity is considered by the
historians of culture to be the cause or expression of the whole
historical movement is hard to understand. Only the following
considerations can have led the historians to such a conclusion: (1)
that history is written by learned men, and so it is natural and
agreeable for them to think that the activity of their class
supplies the basis of the movement of all humanity, just as a
similar belief is natural and agreeable to traders, agriculturists,
and soldiers (if they do not express it, that is merely because
traders and soldiers do not write history), and (2) that spiritual
activity, enlightenment, civilization, culture, ideas, are all
indistinct, indefinite conceptions under whose banner it is very
easy to use words having a still less definite meaning, and which
can therefore be readily introduced into any theory.

But not to speak of the intrinsic quality of histories of this
kind (which may possibly even be of use to someone for something)
the histories of culture, to which all general histories tend more and
more to approximate, are significant from the fact that after
seriously and minutely examining various religious, philosophic, and
political doctrines as causes of events, as soon as they have to
describe an actual historic event such as the campaign of 1812 for
instance, they involuntarily describe it as resulting from an exercise
of power--and say plainly that that was the result of Napoleon's will.
Speaking so, the historians of culture involuntarily contradict
themselves, and show that the new force they have devised does not
account for what happens in history, and that history can only be
explained by introducing a power which they apparently do not
recognize.





CHAPTER III


A locomotive is moving. Someone asks: "What moves it?" A peasant
says the devil moves it. Another man says the locomotive moves because
its wheels go round. A third asserts that the cause of its movement
lies in the smoke which the wind carries away.

The peasant is irrefutable. He has devised a complete explanation.
To refute him someone would have to prove to him that there is no
devil, or another peasant would have to explain to him that it is
not the devil but a German, who moves the locomotive. Only then, as
a result of the contradiction, will they see that they are both wrong.
But the man who says that the movement of the wheels is the cause
refutes himself, for having once begun to analyze he ought to go on
and explain further why the wheels go round; and till he has reached
the ultimate cause of the movement of the locomotive in the pressure
of steam in the boiler, he has no right to stop in his search for
the cause. The man who explains the movement of the locomotive by
the smoke that is carried back has noticed that the wheels do not
supply an explanation and has taken the first sign that occurs to
him and in his turn has offered that as an explanation.

The only conception that can explain the movement of the
locomotive is that of a force commensurate with the movement observed.

The only conception that can explain the movement of the peoples
is that of some force commensurate with the whole movement of the
peoples.

Yet to supply this conception various historians take forces of
different kinds, all of which are incommensurate with the movement
observed. Some see it as a force directly inherent in heroes, as the
peasant sees the devil in the locomotive; others as a force
resulting from several other forces, like the movement of the
wheels; others again as an intellectual influence, like the smoke that
is blown away.

So long as histories are written of separate individuals, whether
Caesars, Alexanders, Luthers, or Voltaires, and not the histories of
all, absolutely all those who take part in an event, it is quite
impossible to describe the movement of humanity without the conception
of a force compelling men to direct their activity toward a certain
end. And the only such conception known to historians is that of
power.

This conception is the one handle by means of which the material
of history, as at present expounded, can be dealt with, and anyone who
breaks that handle off, as Buckle did, without finding some other
method of treating historical material, merely deprives himself of the
one possible way of dealing with it. The necessity of the conception
of power as an explanation of historical events is best demonstrated
by the universal historians and historians of culture themselves,
for they professedly reject that conception but inevitably have
recourse to it at every step.

In dealing with humanity's inquiry, the science of history up to now
is like money in circulation--paper money and coin. The biographies
and special national histories are like paper money. They can be
used and can circulate and fulfill their purpose without harm to
anyone and even advantageously, as long as no one asks what is the
security behind them. You need only forget to ask how the will of
heroes produces events, and such histories as Thiers' will be
interesting and instructive and may perhaps even possess a tinge of
poetry. But just as doubts of the real value of paper money arise
either because, being easy to make, too much of it gets made or
because people try to exchange it for gold, so also doubts
concerning the real value of such histories arise either because too
many of them are written or because in his simplicity of heart someone
inquires: by what force did Napoleon do this?--that is, wants to
exchange the current paper money for the real gold of actual
comprehension.

The writers of universal histories and of the history of culture are
like people who, recognizing the defects of paper money, decide to
substitute for it money made of metal that has not the specific
gravity of gold. It may indeed make jingling coin, but will do no more
than that. Paper money may deceive the ignorant, but nobody is
deceived by tokens of base metal that have no value but merely jingle.
As gold is gold only if it is serviceable not merely for exchange
but also for use, so universal historians will be valuable only when
they can reply to history's essential question: what is power? The
universal historians give contradictory replies to that question,
while the historians of culture evade it and answer something quite
different. And as counters of imitation gold can be used only among
a group of people who agree to accept them as gold, or among those who
do not know the nature of gold, so universal historians and historians
of culture, not answering humanity's essential question, serve as
currency for some purposes of their own, only in universities and
among the mass of readers who have a taste for what they call "serious
reading."





CHAPTER IV


Having abandoned the conception of the ancients as to the divine
subjection of the will of a nation to some chosen man and the
subjection of that man's will to the Deity, history cannot without
contradictions take a single step till it has chosen one of two
things: either a return to the former belief in the direct
intervention of the Deity in human affairs or a definite explanation
of the meaning of the force producing historical events and termed
"power."

A return to the first is impossible, the belief has been
destroyed; and so it is essential to explain what is meant by power.

Napoleon ordered an army to be raised and go to war. We are so
accustomed to that idea and have become so used to it that the
question: why did six hundred thousand men go to fight when Napoleon
uttered certain words, seems to us senseless. He had the power and
so what he ordered was done.

This reply is quite satisfactory if we believe that the power was
given him by God. But as soon as we do not admit that, it becomes
essential to determine what is this power of one man over others.

It cannot be the direct physical power of a strong man over a weak
one--a domination based on the application or threat of physical
force, like the power of Hercules; nor can it be based on the effect
of moral force, as in their simplicity some historians think who say
that the leading figures in history are heroes, that is, men gifted
with a special strength of soul and mind called genius. This power
cannot be based on the predominance of moral strength, for, not to
mention heroes such as Napoleon about whose moral qualities opinions
differ widely, history shows us that neither a Louis XI nor a
Metternich, who ruled over millions of people, had any particular
moral qualities, but on the contrary were generally morally weaker
than any of the millions they ruled over.

If the source of power lies neither in the physical nor in the moral
qualities of him who possesses it, it must evidently be looked for
elsewhere--in the relation to the people of the man who wields the
power.

And that is how power is understood by the science of jurisprudence,
that exchange bank of history which offers to exchange history's
understanding of power for true gold.

Power is the collective will of the people transferred, by expressed
or tacit consent, to their chosen rulers.

In the domain of jurisprudence, which consists of discussions of how
a state and power might be arranged were it possible for all that to
be arranged, it is all very clear; but when applied to history that
definition of power needs explanation.

The science of jurisprudence regards the state and power as the
ancients regarded fire--namely, as something existing absolutely.
But for history, the state and power are merely phenomena, just as for
modern physics fire is not an element but a phenomenon.

From this fundamental difference between the view held by history
and that held by jurisprudence, it follows that jurisprudence can tell
minutely how in its opinion power should be constituted and what
power--existing immutably outside time--is, but to history's questions
about the meaning of the mutations of power in time it can answer
nothing.

If power be the collective will of the people transferred to their
ruler, was Pugachev a representative of the will of the people? If
not, then why was Napoleon I? Why was Napoleon III a criminal when
he was taken prisoner at Boulogne, and why, later on, were those
criminals whom he arrested?

Do palace revolutions--in which sometimes only two or three people
take part--transfer the will of the people to a new ruler? In
international relations, is the will of the people also transferred to
their conqueror? Was the will of the Confederation of the Rhine
transferred to Napoleon in 1806? Was the will of the Russian people
transferred to Napoleon in 1809, when our army in alliance with the
French went to fight the Austrians?

To these questions three answers are possible:

Either to assume (1) that the will of the people is always
unconditionally transferred to the ruler or rulers they have chosen,
and that therefore every emergence of a new power, every struggle
against the power once appointed, should be absolutely regarded as
an infringement of the real power; or (2) that the will of the
people is transferred to the rulers conditionally, under definite
and known conditions, and to show that all limitations, conflicts, and
even destructions of power result from a nonobservance by the rulers
of the conditions under which their power was entrusted to them; or
(3) that the will of the people is delegated to the rulers
conditionally, but that the conditions are unknown and indefinite, and
that the appearance of several authorities, their struggles and
their falls, result solely from the greater or lesser fulfillment by
the rulers of these unknown conditions on which the will of the people
is transferred from some people to others.

And these are the three ways in which the historians do explain
the relation of the people to their rulers.

Some historians--those biographical and specialist historians
already referred to--in their simplicity failing to understand the
question of the meaning of power, seem to consider that the collective
will of the people is unconditionally transferred to historical
persons, and therefore when describing some single state they assume
that particular power to be the one absolute and real power, and
that any other force opposing this is not a power but a violation of
power--mere violence.

Their theory, suitable for primitive and peaceful periods of
history, has the inconvenience--in application to complex and stormy
periods in the life of nations during which various powers arise
simultaneously and struggle with one another--that a Legitimist
historian will prove that the National Convention, the Directory,
and Bonaparte were mere infringers of the true power, while a
Republican and a Bonapartist will prove: the one that the Convention
and the other that the Empire was the real power, and that all the
others were violations of power. Evidently the explanations
furnished by these historians being mutually contradictory can only
satisfy young children.

Recognizing the falsity of this view of history, another set of
historians say that power rests on a conditional delegation of the
will of the people to their rulers, and that historical leaders have
power only conditionally on carrying out the program that the will
of the people has by tacit agreement prescribed to them. But what this
program consists in these historians do not say, or if they do they
continually contradict one another.

Each historian, according to his view of what constitutes a nation's
progress, looks for these conditions in the greatness, wealth,
freedom, or enlightenment of citizens of France or some other country.
But not to mention the historians' contradictions as to the nature
of this program--or even admitting that some one general program of
these conditions exists--the facts of history almost always contradict
that theory. If the conditions under which power is entrusted
consist in the wealth, freedom, and enlightenment of the people, how
is it that Louis XIV and Ivan the Terrible end their reigns
tranquilly, while Louis XVI and Charles I are executed by their
people? To this question historians reply that Louis XIV's activity,
contrary to the program, reacted on Louis XVI. But why did it not
react on Louis XIV or on Louis XV--why should it react just on Louis
XVI? And what is the time limit for such reactions? To these questions
there are and can be no answers. Equally little does this view explain
why for several centuries the collective will is not withdrawn from
certain rulers and their heirs, and then suddenly during a period of
fifty years is transferred to the Convention, to the Directory, to
Napoleon, to Alexander, to Louis XVIII, to Napoleon again, to
Charles X, to Louis Philippe, to a Republican government, and to
Napoleon III. When explaining these rapid transfers of the people's
will from one individual to another, especially in view of
international relations, conquests, and alliances, the historians
are obliged to admit that some of these transfers are not normal
delegations of the people's will but are accidents dependent on
cunning, on mistakes, on craft, or on the weakness of a diplomatist, a
ruler, or a party leader. So that the greater part of the events of
history--civil wars, revolutions, and conquests--are presented by
these historians not as the results of free transferences of the
people's will, but as results of the ill-directed will of one or
more individuals, that is, once again, as usurpations of power. And so
these historians also see and admit historical events which are
exceptions to the theory.

These historians resemble a botanist who, having noticed that some
plants grow from seeds producing two cotyledons, should insist that
all that grows does so by sprouting into two leaves, and that the
palm, the mushroom, and even the oak, which blossom into full growth
and no longer resemble two leaves, are deviations from the theory.

Historians of the third class assume that the will of the people
is transferred to historic personages conditionally, but that the
conditions are unknown to us. They say that historical personages have
power only because they fulfill the will of the people which has
been delegated to them.

But in that case, if the force that moves nations lies not in the
historic leaders but in the nations themselves, what significance have
those leaders?

The leaders, these historians tell us, express the will of the
people: the activity of the leaders represents the activity of the
people.

But in that case the question arises whether all the activity of the
leaders serves as an expression of the people's will or only some part
of it. If the whole activity of the leaders serves as the expression
of the people's will, as some historians suppose, then all the details
of the court scandals contained in the biographies of a Napoleon or
a Catherine serve to express the life of the nation, which is
evident nonsense; but if it is only some particular side of the
activity of an historical leader which serves to express the
people's life, as other so-called "philosophical" historians
believe, then to determine which side of the activity of a leader
expresses the nation's life, we have first of all to know in what
the nation's life consists.

Met by this difficulty historians of that class devise some most
obscure, impalpable, and general abstraction which can cover all
conceivable occurrences, and declare this abstraction to be the aim of
humanity's movement. The most usual generalizations adopted by
almost all the historians are: freedom, equality, enlightenment,
progress, civilization, and culture. Postulating some generalization
as the goal of the movement of humanity, the historians study the
men of whom the greatest number of monuments have remained: kings,
ministers, generals, authors, reformers, popes, and journalists, to
the extent to which in their opinion these persons have promoted or
hindered that abstraction. But as it is in no way proved that the
aim of humanity does consist in freedom, equality, enlightenment, or
civilization, and as the connection of the people with the rulers
and enlighteners of humanity is only based on the arbitrary assumption
that the collective will of the people is always transferred to the
men whom we have noticed, it happens that the activity of the millions
who migrate, burn houses, abandon agriculture, and destroy one another
never is expressed in the account of the activity of some dozen people
who did not burn houses, practice agriculture, or slay their fellow
creatures.

History proves this at every turn. Is the ferment of the peoples
of the west at the end of the eighteenth century and their drive
eastward explained by the activity of Louis XIV, XV, and XVI, their
mistresses and ministers, and by the lives of Napoleon, Rousseau,
Diderot, Beaumarchais, and others?

Is the movement of the Russian people eastward to Kazan and
Siberia expressed by details of the morbid character of Ivan the
Terrible and by his correspondence with Kurbski?

Is the movement of the peoples at the time of the Crusades explained
by the life and activity of the Godfreys and the Louis-es and their
ladies? For us that movement of the peoples from west to east, without
leaders, with a crowd of vagrants, and with Peter the Hermit,
remains incomprehensible. And yet more incomprehensible is the
cessation of that movement when a rational and sacred aim for the
Crusade--the deliverance of Jerusalem--had been clearly defined by
historic leaders. Popes, kings, and knights incited the peoples to
free the Holy Land; but the people did not go, for the unknown cause
which had previously impelled them to go no longer existed. The
history of the Godfreys and the Minnesingers can evidently not cover
the life of the peoples. And the history of the Godfreys and the
Minnesingers has remained the history of Godfreys and Minnesingers,
but the history of the life of the peoples and their impulses has
remained unknown.

Still less does the history of authors and reformers explain to us
the life of the peoples.

The history of culture explains to us the impulses and conditions of
life and thought of a writer or a reformer. We learn that Luther had a
hot temper and said such and such things; we learn that Rousseau was
suspicious and wrote such and such books; but we do not learn why
after the Reformation the peoples massacred one another, nor why
during the French Revolution they guillotined one another.

If we unite both these kinds of history, as is done by the newest
historians, we shall have the history of monarchs and writers, but not
the history of the life of the peoples.





CHAPTER V


The life of the nations is not contained in the lives of a few
men, for the connection between those men and the nations has not been
found. The theory that this connection is based on the transference of
the collective will of a people to certain historical personages is an
hypothesis unconfirmed by the experience of history.

The theory of the transference of the collective will of the
people to historic persons may perhaps explain much in the domain of
jurisprudence and be essential for its purposes, but in its
application to history, as soon as revolutions, conquests, or civil
wars occur--that is, as soon as history begins--that theory explains
nothing.

The theory seems irrefutable just because the act of transference of
the people's will cannot be verified, for it never occurred.

Whatever happens and whoever may stand at the head of affairs, the
theory can always say that such and such a person took the lead
because the collective will was transferred to him.

The replies this theory gives to historical questions are like the
replies of a man who, watching the movements of a herd of cattle and
paying no attention to the varying quality of the pasturage in
different parts of the field, or to the driving of the herdsman,
should attribute the direction the herd takes to what animal happens
to be at its head.

"The herd goes in that direction because the animal in front leads
it and the collective will of all the other animals is vested in
that leader." This is what historians of the first class say--those
who assume the unconditional transference of the people's will.

"If the animals leading the herd change, this happens because the
collective will of all the animals is transferred from one leader to
another, according to whether the animal is or is not leading them
in the direction selected by the whole herd." Such is the reply
historians who assume that the collective will of the people is
delegated to rulers under conditions which they regard as known. (With
this method of observation it often happens that the observer,
influenced by the direction he himself prefers, regards those as
leaders who, owing to the people's change of direction, are no
longer in front, but on one side, or even in the rear.)

"If the animals in front are continually changing and the
direction of the whole herd is constantly altered, this is because
in order to follow a given direction the animals transfer their will
to the animals that have attracted our attention, and to study the
movements of the herd we must watch the movements of all the prominent
animals moving on all sides of the herd." So say the third class of
historians who regard all historical persons, from monarchs to
journalists, as the expression of their age.

The theory of the transference of the will of the people to historic
persons is merely a paraphrase--a restatement of the question in other
words.

What causes historical events? Power. What is power? Power is the
collective will of the people transferred to one person. Under what
condition is the will of the people delegated to one person? On
condition that that person expresses the will of the whole people.
That is, power is power: in other words, power is a word the meaning
of which we do not understand.


If the realm of human knowledge were confined to abstract reasoning,
then having subjected to criticism the explanation of "power" that
juridical science gives us, humanity would conclude that power is
merely a word and has no real existence. But to understand phenomena
man has, besides abstract reasoning, experience by which he verifies
his reflections. And experience tells us that power is not merely a
word but an actually existing phenomenon.

Not to speak of the fact that no description of the collective
activity of men can do without the conception of power, the
existence of power is proved both by history and by observing
contemporary events.

Whenever an event occurs a man appears or men appear, by whose
will the event seems to have taken place. Napoleon III issues a decree
and the French go to Mexico. The King of Prussia and Bismarck issue
decrees and an army enters Bohemia. Napoleon I issues a decree and
an army enters Russia. Alexander I gives a command and the French
submit to the Bourbons. Experience shows us that whatever event occurs
it is always related to the will of one or of several men who have
decreed it.

The historians, in accord with the old habit of acknowledging divine
intervention in human affairs, want to see the cause of events in
the expression of the will of someone endowed with power, but that
supposition is not confirmed either by reason or by experience.

On the one side reflection shows that the expression of a man's
will--his words--are only part of the general activity expressed in an
event, as for instance in a war or a revolution, and so without
assuming an incomprehensible, supernatural force--a miracle--one
cannot admit that words can be the immediate cause of the movements of
millions of men. On the other hand, even if we admitted that words
could be the cause of events, history shows that the expression of the
will of historical personages does not in most cases produce any
effect, that is to say, their commands are often not executed, and
sometimes the very opposite of what they order occurs.

Without admitting divine intervention in the affairs of humanity
we cannot regard "power" as the cause of events.

Power, from the standpoint of experience, is merely the relation
that exists between the expression of someone's will and the execution
of that will by others.

To explain the conditions of that relationship we must first
establish a conception of the expression of will, referring it to
man and not to the Deity.

If the Deity issues a command, expresses His will, as ancient
history tells us, the expression of that will is independent of time
and is not caused by anything, for the Divinity is not controlled by
an event. But speaking of commands that are the expression of the will
of men acting in time and in relation to one another, to explain the
connection of commands with events we must restore: (1) the
condition of all that takes place: the continuity of movement in
time both of the events and of the person who commands, and (2) the
inevitability of the connection between the person commanding and
those who execute his command.





CHAPTER VI


Only the expression of the will of the Deity, not dependent on time,
can relate to a whole series of events occurring over a period of
years or centuries, and only the Deity, independent of everything, can
by His sole will determine the direction of humanity's movement; but
man acts in time and himself takes part in what occurs.

Reinstating the first condition omitted, that of time, we see that
no command can be executed without some preceding order having been
given rendering the execution of the last command possible.

No command ever appears spontaneously, or itself covers a whole
series of occurrences; but each command follows from another, and
never refers to a whole series of events but always to one moment only
of an event.

When, for instance, we say that Napoleon ordered armies to go to
war, we combine in one simultaneous expression a whole series of
consecutive commands dependent one on another. Napoleon could not have
commanded an invasion of Russia and never did so. Today he ordered
such and such papers to be written to Vienna, to Berlin, and to
Petersburg; tomorrow such and such decrees and orders to the army, the
fleet, the commissariat, and so on and so on--millions of commands,
which formed a whole series corresponding to a series of events
which brought the French armies into Russia.

If throughout his reign Napoleon gave commands concerning an
invasion of England and expended on no other undertaking so much
time and effort, and yet during his whole reign never once attempted
to execute that design but undertook an expedition into Russia, with
which country he considered it desirable to be in alliance (a
conviction he repeatedly expressed)--this came about because his
commands did not correspond to the course of events in the first case,
but did so correspond in the latter.

For an order to be certainly executed, it is necessary that a man
should order what can be executed. But to know what can and what
cannot be executed is impossible, not only in the case of Napoleon's
invasion of Russia in which millions participated, but even in the
simplest event, for in either case millions of obstacles may arise
to prevent its execution. Every order executed is always one of an
immense number unexecuted. All the impossible orders inconsistent with
the course of events remain unexecuted. Only the possible ones get
linked up with a consecutive series of commands corresponding to a
series of events, and are executed.

Our false conception that an event is caused by a command which
precedes it is due to the fact that when the event has taken place and
out of thousands of others those few commands which were consistent
with that event have been executed, we forget about the others that
were not executed because they could not be. Apart from that, the
chief source of our error in this matter is due to the fact that in
the historical accounts a whole series of innumerable, diverse, and
petty events, such for instance as all those which led the French
armies to Russia, is generalized into one event in accord with the
result produced by that series of events, and corresponding with
this generalization the whole series of commands is also generalized
into a single expression of will.

We say that Napoleon wished to invade Russia and invaded it. In
reality in all Napoleon's activity we never find anything resembling
an expression of that wish, but find a series of orders, or
expressions of his will, very variously and indefinitely directed.
Amid a long series of unexecuted orders of Napoleon's one series,
for the campaign of 1812, was carried out--not because those orders
differed in any way from the other, unexecuted orders but because they
coincided with the course of events that led the French army into
Russia; just as in stencil work this or that figure comes out not
because the color was laid on from this side or in that way, but
because it was laid on from all sides over the figure cut in the
stencil.

So that examining the relation in time of the commands to the
events, we find that a command can never be the cause of the event,
but that a certain definite dependence exists between the two.

To understand in what this dependence consists it is necessary to
reinstate another omitted condition of every command proceeding not
from the Deity but from a man, which is, that the man who gives the
command himself takes part in.

This relation of the commander to those he commands is just what
is called power. This relation consists in the following:

For common action people always unite in certain combinations, in
which regardless of the difference of the aims set for the common
action, the relation between those taking part in it is always the
same.

Men uniting in these combinations always assume such relations
toward one another that the larger number take a more direct share,
and the smaller number a less direct share, in the collective action
for which they have combined.

Of all the combinations in which men unite for collective action one
of the most striking and definite examples is an army.

Every army is composed of lower grades of the service--the rank
and file--of whom there are always the greatest number; of the next
higher military rank--corporals and noncommissioned officers of whom
there are fewer, and of still-higher officers of whom there are
still fewer, and so on to the highest military command which is
concentrated in one person.

A military organization may be quite correctly compared to a cone,
of which the base with the largest diameter consists of the rank and
file; the next higher and smaller section of the cone consists of
the next higher grades of the army, and so on to the apex, the point
of which will represent the commander in chief.

The soldiers, of whom there are the most, form the lower section
of the cone and its base. The soldier himself does the stabbing,
hacking, burning, and pillaging, and always receives orders for
these actions from men above him; he himself never gives an order. The
noncommissioned officers (of whom there are fewer) perform the
action itself less frequently than the soldiers, but they already give
commands. An officer still less often acts directly himself, but
commands still more frequently. A general does nothing but command the
troops, indicates the objective, and hardly ever uses a weapon
himself. The commander in chief never takes direct part in the
action itself, but only gives general orders concerning the movement
of the mass of the troops. A similar relation of people to one another
is seen in every combination of men for common activity--in
agriculture, trade, and every administration.

And so without particularly analyzing all the contiguous sections of
a cone and of the ranks of an army, or the ranks and positions in
any administrative or public business whatever from the lowest to
the highest, we see a law by which men, to take associated action,
combine in such relations that the more directly they participate in
performing the action the less they can command and the more
numerous they are, while the less their direct participation in the
action itself, the more they command and the fewer of them there
are; rising in this way from the lowest ranks to the man at the top,
who takes the least direct share in the action and directs his
activity chiefly to commanding.

This relation of the men who command to those they command is what
constitutes the essence of the conception called power.

Having restored the condition of time under which all events
occur, find that a command is executed only when it is related to a
corresponding series of events. Restoring the essential condition of
relation between those who command and those who execute, we find that
by the very nature of the case those who command take the smallest
part in the action itself and that their activity is exclusively
directed to commanding.





CHAPTER VII


When an event is taking place people express their opinions and
wishes about it, and as the event results from the collective activity
of many people, some one of the opinions or wishes expressed is sure
to be fulfilled if but approximately. When one of the opinions
expressed is fulfilled, that opinion gets connected with the event
as a command preceding it.

Men are hauling a log. Each of them expresses his opinion as to
how and where to haul it. They haul the log away, and it happens
that this is done as one of them said. He ordered it. There we have
command and power in their primary form. The man who worked most
with his hands could not think so much about what he was doing, or
reflect on or command what would result from the common activity;
while the man who commanded more would evidently work less with his
hands on account of his greater verbal activity.

When some larger concourse of men direct their activity to a
common aim there is a yet sharper division of those who, because their
activity is given to directing and commanding, take less less part
in the direct work.

When a man works alone he always has a certain set of reflections
which as it seems to him directed his past activity, justify his
present activity, and guide him in planning his future actions. Just
the same is done by a concourse of people, allowing those who do not
take a direct part in the activity to devise considerations,
justifications, and surmises concerning their collective activity.

For reasons known or unknown to us the French began to drown and
kill one another. And corresponding to the event its justification
appears in people's belief that this was necessary for the welfare
of France, for liberty, and for equality. People ceased to kill one
another, and this event was accompanied by its justification in the
necessity for a centralization of power, resistance to Europe, and
so on. Men went from the west to the east killing their fellow men,
and the event was accompanied by phrases about the glory of France,
the baseness of England, and so on. History shows us that these
justifications of the events have no common sense and are all
contradictory, as in the case of killing a man as the result of
recognizing his rights, and the killing of millions in Russia for
the humiliation of England. But these justifications have a very
necessary significance in their own day.

These justifications release those who produce the events from moral
responsibility. These temporary aims are like the broom fixed in front
of a locomotive to clear the snow from the rails in front: they
clear men's moral responsibilities from their path.

Without such justification there would be no reply to the simplest
question that presents itself when examining each historical event.
How is it that millions of men commit collective crimes--make war,
commit murder, and so on?

With the present complex forms of political and social life in
Europe can any event that is not prescribed, decreed, or ordered by
monarchs, ministers, parliaments, or newspapers be imagined? Is
there any collective action which cannot find its justification in
political unity, in patriotism, in the balance of power, or in
civilization? So that every event that occurs inevitably coincides
with some expressed wish and, receiving a justification, presents
itself as the result of the will of one man or of several men.

In whatever direction a ship moves, the flow of the waves it cuts
will always be noticeable ahead of it. To those on board the ship
the movement of those waves will be the only perceptible motion.

Only by watching closely moment by moment the movement of that
flow and comparing it with the movement of the ship do we convince
ourselves that every bit of it is occasioned by the forward movement
of the ship, and that we were led into error by the fact that we
ourselves were imperceptibly moving.

We see the same if we watch moment by moment the movement of
historical characters (that is, re-establish the inevitable
condition of all that occurs--the continuity of movement in time)
and do not lose sight of the essential connection of historical
persons with the masses.

When the ship moves in one direction there is one and the same
wave ahead of it, when it turns frequently the wave ahead of it also
turns frequently. But wherever it may turn there always will be the
wave anticipating its movement.

Whatever happens it always appears that just that event was foreseen
and decreed. Wherever the ship may go, the rush of water which neither
directs nor increases its movement foams ahead of it, and at a
distance seems to us not merely to move of itself but to govern the
ship's movement also.


Examining only those expressions of the will of historical persons
which, as commands, were related to events, historians have assumed
that the events depended on those commands. But examining the events
themselves and the connection in which the historical persons stood to
the people, we have found that they and their orders were dependent on
events. The incontestable proof of this deduction is that, however
many commands were issued, the event does not take place unless
there are other causes for it, but as soon as an event occurs--be it
what it may--then out of all the continually expressed wishes of
different people some will always be found which by their meaning
and their time of utterance are related as commands to the events.

Arriving at this conclusion we can reply directly and positively
to these two essential questions of history:

(1) What is power?

(2) What force produces the movement of the nations?

(1) Power is the relation of a given person to other individuals, in
which the more this person expresses opinions, predictions, and
justifications of the collective action that is performed, the less is
his participation in that action.

(2) The movement of nations is caused not by power, nor by
intellectual activity, nor even by a combination of the two as
historians have supposed, but by the activity of all the people who
participate in the events, and who always combine in such a way that
those taking the largest direct share in the event take on
themselves the least responsibility and vice versa.

Morally the wielder of power appears to cause the event;
physically it is those who submit to the power. But as the moral
activity is inconceivable without the physical, the cause of the event
is neither in the one nor in the other but in the union of the two.

Or in other words, the conception of a cause is inapplicable to
the phenomena we are examining.

In the last analysis we reach the circle of infinity--that final
limit to which in every domain of thought man's reason arrives if it
is not playing with the subject. Electricity produces heat, heat
produces electricity. Atoms attract each other and atoms repel one
another.

Speaking of the interaction of heat and electricity and of atoms, we
cannot say why this occurs, and we say that it is so because it is
inconceivable otherwise, because it must be so and that it is a law.
The same applies to historical events. Why war and revolution occur we
do not know. We only know that to produce the one or the other action,
people combine in a certain formation in which they all take part, and
we say that this is so because it is unthinkable otherwise, or in
other words that it is a law.





CHAPTER VIII


If history dealt only with external phenomena, the establishment
of this simple and obvious law would suffice and we should have
finished our argument. But the law of history relates to man. A
particle of matter cannot tell us that it does not feel the law of
attraction or repulsion and that that law is untrue, but man, who is
the subject of history, says plainly: I am free and am therefore not
subject to the law.

The presence of the problem of man's free will, though
unexpressed, is felt at every step of history.

All seriously thinking historians have involuntarily encountered
this question. All the contradictions and obscurities of history and
the false path historical science has followed are due solely to the
lack of a solution of that question.

If the will of every man were free, that is, if each man could act
as he pleased, all history would be a series of disconnected
incidents.

If in a thousand years even one man in a million could act freely,
that is, as he chose, it is evident that one single free act of that
man's in violation of the laws governing human action would destroy
the possibility of the existence of any laws for the whole of
humanity.

If there be a single law governing the actions of men, free will
cannot exist, for then man's will is subject to that law.

In this contradiction lies the problem of free will, which from most
ancient times has occupied the best human minds and from most
ancient times has been presented in its whole tremendous significance.

The problem is that regarding man as a subject of observation from
whatever point of view--theological, historical, ethical, or
philosophic--we find a general law of necessity to which he (like
all that exists) is subject. But regarding him from within ourselves
as what we are conscious of, we feel ourselves to be free.

This consciousness is a source of self-cognition quite apart from
and independent of reason. Through his reason man observes himself,
but only through consciousness does he know himself.

Apart from consciousness of self no observation or application of
reason is conceivable.

To understand, observe, and draw conclusions, man must first of
all be conscious of himself as living. A man is only conscious of
himself as a living being by the fact that he wills, that is, is
conscious of his volition. But his will--which forms the essence of
his life--man recognizes (and can but recognize) as free.

If, observing himself, man sees that his will is always directed
by one and the same law (whether he observes the necessity of taking
food, using his brain, or anything else) he cannot recognize this
never-varying direction of his will otherwise than as a limitation
of it. Were it not free it could not be limited. A man's will seems to
him to be limited just because he is not conscious of it except as
free.

You say: I am not and am not free. But I have lifted my hand and let
it fall. Everyone understands that this illogical reply is an
irrefutable demonstration of freedom.

That reply is the expression of a consciousness that is not
subject to reason.

If the consciousness of freedom were not a separate and
independent source of self-consciousness it would be subject to
reasoning and to experience, but in fact such subjection does not
exist and is inconceivable.

A series of experiments and arguments proves to every man that he,
as an object of observation, is subject to certain laws, and man
submits to them and never resists the laws of gravity or
impermeability once he has become acquainted with them. But the same
series of experiments and arguments proves to him that the complete
freedom of which he is conscious in himself is impossible, and that
his every action depends on his organization, his character, and the
motives acting upon him; yet man never submits to the deductions of
these experiments and arguments. Having learned from experiment and
argument that a stone falls downwards, a man indubitably believes this
and always expects the law that he has learned to be fulfilled.

But learning just as certainly that his will is subject to laws,
he does not and cannot believe this.

However often experiment and reasoning may show a man that under the
same conditions and with the same character he will do the same
thing as before, yet when under the same conditions and with the
same character he approaches for the thousandth time the action that
always ends in the same way, he feels as certainly convinced as before
the experiment that he can act as he pleases. Every man, savage or
sage, however incontestably reason and experiment may prove to him
that it is impossible to imagine two different courses of action in
precisely the same conditions, feels that without this irrational
conception (which constitutes the essence of freedom) he cannot
imagine life. He feels that however impossible it may be, it is so,
for without this conception of freedom not only would he be unable
to understand life, but he would be unable to live for a single
moment.

He could not live, because all man's efforts, all his impulses to
life, are only efforts to increase freedom. Wealth and poverty, fame
and obscurity, power and subordination, strength and weakness,
health and disease, culture and ignorance, work and leisure, repletion
and hunger, virtue and vice, are only greater or lesser degrees of
freedom.

A man having no freedom cannot be conceived of except as deprived of
life.

If the conception of freedom appears to reason to be a senseless
contradiction like the possibility of performing two actions at one
and the same instant of time, or of an effect without a cause, that
only proves that consciousness is not subject to reason.

This unshakable, irrefutable consciousness of freedom,
uncontrolled by experiment or argument, recognized by all thinkers and
felt by everyone without exception, this consciousness without which
no conception of man is possible constitutes the other side of the
question.

Man is the creation of an all-powerful, all-good, and all-seeing
God. What is sin, the conception of which arises from the
consciousness of man's freedom? That is a question for theology.

The actions of men are subject to general immutable laws expressed
in statistics. What is man's responsibility to society, the conception
of which results from the conception of freedom? That is a question
for jurisprudence.

Man's actions proceed from his innate character and the motives
acting upon him. What is conscience and the perception of right and
wrong in actions that follows from the consciousness of freedom?
That is a question for ethics.

Man in connection with the general life of humanity appears
subject to laws which determine that life. But the same man apart from
that connection appears to free. How should the past life of nations
and of humanity be regarded--as the result of the free, or as the
result of the constrained, activity of man? That is a question for
history.

Only in our self-confident day of the popularization of knowledge-
thanks to that most powerful engine of ignorance, the diffusion of
printed matter--has the question of the freedom of will been put on
a level on which the question itself cannot exist. In our time the
majority of so-called advanced people--that is, the crowd of
ignoramuses--have taken the work of the naturalists who deal with
one side of the question for a solution of the whole problem.

They say and write and print that the soul and freedom do not exist,
for the life of man is expressed by muscular movements and muscular
movements are conditioned by the activity of the nerves; the soul
and free will do not exist because at an unknown period of time we
sprang from the apes. They say this, not at all suspecting that
thousands of years ago that same law of necessity which with such
ardor they are now trying to prove by physiology and comparative
zoology was not merely acknowledged by all the religions and all the
thinkers, but has never been denied. They do not see that the role
of the natural sciences in this matter is merely to serve as an
instrument for the illumination of one side of it. For the fact
that, from the point of view of observation, reason and the will are
merely secretions of the brain, and that man following the general law
may have developed from lower animals at some unknown period of
time, only explains from a fresh side the truth admitted thousands
of years ago by all the religious and philosophic theories--that
from the point of view of reason man is subject to the law of
necessity; but it does not advance by a hair's breadth the solution of
the question, which has another, opposite, side, based on the
consciousness of freedom.

If men descended from the apes at an unknown period of time, that is
as comprehensible as that they were made from a handful of earth at
a certain period of time (in the first case the unknown quantity is
the time, in the second case it is the origin); and the question of
how man's consciousness of freedom is to be reconciled with the law of
necessity to which he is subject cannot be solved by comparative
physiology and zoology, for in a frog, a rabbit, or an ape, we can
observe only the muscular nervous activity, but in man we observe
consciousness as well as the muscular and nervous activity.

The naturalists and their followers, thinking they can solve this
question, are like plasterers set to plaster one side of the walls
of a church who, availing themselves of the absence of the chief
superintendent of the work, should in an access of zeal plaster over
the windows, icons, woodwork, and still unbuttressed walls, and should
be delighted that from their point of view as plasterers, everything
is now so smooth and regular.





CHAPTER IX


For the solution of the question of free will or inevitability,
history has this advantage over other branches of knowledge in which
the question is dealt with, that for history this question does not
refer to the essence of man's free will but its manifestation in the
past and under certain conditions.

In regard to this question, history stands to the other sciences
as experimental science stands to abstract science.

The subject for history is not man's will itself but our
presentation of it.

And so for history, the insoluble mystery presented by the
incompatibility of free will and inevitability does not exist as it
does for theology, ethics, and philosophy. History surveys a
presentation of man's life in which the union of these two
contradictions has already taken place.

In actual life each historic event, each human action, is very
clearly and definitely understood without any sense of
contradiction, although each event presents itself as partly free
and partly compulsory.

To solve the question of how freedom and necessity are combined
and what constitutes the essence of these two conceptions, the
philosophy of history can and should follow a path contrary to that
taken by other sciences. Instead of first defining the conceptions
of freedom and inevitability in themselves, and then ranging the
phenomena of life under those definitions, history should deduce a
definition of the conception of freedom and inevitability themselves
from the immense quantity of phenomena of which it is cognizant and
that always appear dependent on these two elements.

Whatever presentation of the activity of many men or of an
individual we may consider, we always regard it as the result partly
of man's free will and partly of the law of inevitability.

Whether we speak of the migration of the peoples and the
incursions of the barbarians, or of the decrees of Napoleon III, or of
someone's action an hour ago in choosing one direction out of
several for his walk, we are unconscious of any contradiction. The
degree of freedom and inevitability governing the actions of these
people is clearly defined for us.

Our conception of the degree of freedom often varies according to
differences in the point of view from which we regard the event, but
every human action appears to us as a certain combination of freedom
and inevitability. In every action we examine we see a certain measure
of freedom and a certain measure of inevitability. And always the more
freedom we see in any action the less inevitability do we perceive,
and the more inevitability the less freedom.

The proportion of freedom to inevitability decreases and increases
according to the point of view from which the action is regarded,
but their relation is always one of inverse proportion.

A sinking man who clutches at another and drowns him; or a hungry
mother exhausted by feeding her baby, who steals some food; or a man
trained to discipline who on duty at the word of command kills a
defenseless man--seem less guilty, that is, less free and more subject
to the law of necessity, to one who knows the circumstances in which
these people were placed, and more free to one who does not know
that the man was himself drowning, that the mother was hungry, that
the soldier was in the ranks, and so on. Similarly a man who committed
a murder twenty years ago and has since lived peaceably and harmlessly
in society seems less guilty and his action more due to the law of
inevitability, to someone who considers his action after twenty
years have elapsed than to one who examined it the day after it was
committed. And in the same way every action of an insane, intoxicated,
or highly excited man appears less free and more inevitable to one who
knows the mental condition of him who committed the action, and
seems more free and less inevitable to one who does not know it. In
all these cases the conception of freedom is increased or diminished
and the conception of compulsion is correspondingly decreased or
increased, according to the point of view from which the action is
regarded. So that the greater the conception of necessity the
smaller the conception of freedom and vice versa.

Religion, the common sense of mankind, the science of jurisprudence,
and history itself understand alike this relation between necessity
and freedom.

All cases without exception in which our conception of freedom and
necessity is increased and diminished depend on three considerations:

(1) The relation to the external world of the man who commits the
deeds.

(2) His relation to time.

(3) His relation to the causes leading to the action.

The first consideration is the clearness of our perception of the
man's relation to the external world and the greater or lesser
clearness of our understanding of the definite position occupied by
the man in relation to everything coexisting with him. This is what
makes it evident that a drowning man is less free and more subject
to necessity than one standing on dry ground, and that makes the
actions of a man closely connected with others in a thickly
populated district, or of one bound by family, official, or business
duties, seem certainly less free and more subject to necessity than
those of a man living in solitude and seclusion.

If we consider a man alone, apart from his relation to everything
around him, each action of his seems to us free. But if we see his
relation to anything around him, if we see his connection with
anything whatever--with a man who speaks to him, a book he reads,
the work on which he is engaged, even with the air he breathes or
the light that falls on the things about him--we see that each of
these circumstances has an influence on him and controls at least some
side of his activity. And the more we perceive of these influences the
more our conception of his freedom diminishes and the more our
conception of the necessity that weighs on him increases.

The second consideration is the more or less evident time relation
of the man to the world and the clearness of our perception of the
place the man's action occupies in time. That is the ground which
makes the fall of the first man, resulting in the production of the
human race, appear evidently less free than a man's entry into
marriage today. It is the reason why the life and activity of people
who lived centuries ago and are connected with me in time cannot
seem to me as free as the life of a contemporary, the consequences
of which are still unknown to me.

The degree of our conception of freedom or inevitability depends
in this respect on the greater or lesser lapse of time between the
performance of the action and our judgment of it.

If I examine an act I performed a moment ago in approximately the
same circumstances as those I am in now, my action appears to me
undoubtedly free. But if I examine an act performed a month ago,
then being in different circumstances, I cannot help recognizing
that if that act had not been committed much that resulted from it-
good, agreeable, and even essential--would not have taken place. If
I reflect on an action still more remote, ten years ago or more,
then the consequences of my action are still plainer to me and I
find it hard to imagine what would have happened had that action not
been performed. The farther I go back in memory, or what is the same
thing the farther I go forward in my judgment, the more doubtful
becomes my belief in the freedom of my action.

In history we find a very similar progress of conviction
concerning the part played by free will in the general affairs of
humanity. A contemporary event seems to us to be indubitably the doing
of all the known participants, but with a more remote event we already
see its inevitable results which prevent our considering anything else
possible. And the farther we go back in examining events the less
arbitrary do they appear.

The Austro-Prussian war appears to us undoubtedly the result of
the crafty conduct of Bismarck, and so on. The Napoleonic wars still
seem to us, though already questionably, to be the outcome of their
heroes' will. But in the Crusades we already see an event occupying
its definite place in history and without which we cannot imagine
the modern history of Europe, though to the chroniclers of the
Crusades that event appeared as merely due to the will of certain
people. In regard to the migration of the peoples it does not enter
anyone's head today to suppose that the renovation of the European
world depended on Attila's caprice. The farther back in history the
object of our observation lies, the more doubtful does the free will
of those concerned in the event become and the more manifest the law
of inevitability.

The third consideration is the degree to which we apprehend that
endless chain of causation inevitably demanded by reason, in which
each phenomenon comprehended, and therefore man's every action, must
have its definite place as a result of what has gone before and as a
cause of what will follow.

The better we are acquainted with the physiological,
psychological, and historical laws deduced by observation and by which
man is controlled, and the more correctly we perceive the
physiological, psychological, and historical causes of the action, and
the simpler the action we are observing and the less complex the
character and mind of the man in question, the more subject to
inevitability and the less free do our actions and those of others
appear.

When we do not at all understand the cause of an action, whether a
crime, a good action, or even one that is simply nonmoral, we
ascribe a greater amount of freedom to it. In the case of a crime we
most urgently demand the punishment for such an act; in the case of
a virtuous act we rate its merit most highly. In an indifferent case
we recognize in it more individuality, originality, and
independence. But if even one of the innumerable causes of the act
is known to us we recognize a certain element of necessity and are
less insistent on punishment for the crime, or the acknowledgment of
the merit of the virtuous act, or the freedom of the apparently
original action. That a criminal was reared among male factors
mitigates his fault in our eyes. The self-sacrifice of a father or
mother, or self-sacrifice with the possibility of a reward, is more
comprehensible than gratuitous self-sacrifice, and therefore seems
less deserving of sympathy and less the result of free will. The
founder of a sect or party, or an inventor, impresses us less when
we know how or by what the way was prepared for his activity. If we
have a large range of examples, if our observation is constantly
directed to seeking the correlation of cause and effect in people's
actions, their actions appear to us more under compulsion and less
free the more correctly we connect the effects with the causes. If
we examined simple actions and had a vast number of such actions under
observation, our conception of their inevitability would be still
greater. The dishonest conduct of the son of a dishonest father, the
misconduct of a woman who had fallen into bad company, a drunkard's
relapse into drunkenness, and so on are actions that seem to us less
free the better we understand their cause. If the man whose actions we
are considering is on a very low stage of mental development, like a
child, a madman, or a simpleton--then, knowing the causes of the act
and the simplicity of the character and intelligence in question, we
see so large an element of necessity and so little free will that as
soon as we know the cause prompting the action we can foretell the
result.

On these three considerations alone is based the conception of
irresponsibility for crimes and the extenuating circumstances admitted
by all legislative codes. The responsibility appears greater or less
according to our greater or lesser knowledge of the circumstances in
which the man was placed whose action is being judged, and according
to the greater or lesser interval of time between the commission of
the action and its investigation, and according to the greater or
lesser understanding of the causes that led to the action.





CHAPTER X


Thus our conception of free will and inevitability gradually
diminishes or increases according to the greater or lesser
connection with the external world, the greater or lesser remoteness
of time, and the greater or lesser dependence on the causes in
relation to which we contemplate a man's life.

So that if we examine the case of a man whose connection with the
external world is well known, where the time between the action and
its examination is great, and where the causes of the action are
most accessible, we get the conception of a maximum of inevitability
and a minimum of free will. If we examine a man little dependent on
external conditions, whose action was performed very recently, and the
causes of whose action are beyond our ken, we get the conception of
a minimum of inevitability and a maximum of freedom.

In neither case--however we may change our point of view, however
plain we may make to ourselves the connection between the man and
the external world, however inaccessible it may be to us, however long
or short the period of time, however intelligible or
incomprehensible the causes of the action may be--can we ever conceive
either complete freedom or complete necessity.

(1) To whatever degree we may imagine a man to be exempt from the
influence of the external world, we never get a conception of
freedom in space. Every human action is inevitably conditioned by what
surrounds him and by his own body. I lift my arm and let it fall. My
action seems to me free; but asking myself whether I could raise my
arm in every direction, I see that I raised it in the direction in
which there was least obstruction to that action either from things
around me or from the construction of my own body. I chose one out
of all the possible directions because in it there were fewest
obstacles. For my action to be free it was necessary that it should
encounter no obstacles. To conceive of a man being free we must
imagine him outside space, which is evidently impossible.

(2) However much we approximate the time of judgment to the time
of the deed, we never get a conception of freedom in time. For if I
examine an action committed a second ago I must still recognize it
as not being free, for it is irrevocably linked to the moment at which
it was committed. Can I lift my arm? I lift it, but ask myself:
could I have abstained from lifting my arm at the moment that has
already passed? To convince myself of this I do not lift it the next
moment. But I am not now abstaining from doing so at the first
moment when I asked the question. Time has gone by which I could not
detain, the arm I then lifted is no longer the same as the arm I now
refrain from lifting, nor is the air in which I lifted it the same
that now surrounds me. The moment in which the first movement was made
is irrevocable, and at that moment I could make only one movement, and
whatever movement I made would be the only one. That I did not lift my
arm a moment later does not prove that I could have abstained from
lifting it then. And since I could make only one movement at that
single moment of time, it could not have been any other. To imagine it
as free, it is necessary to imagine it in the present, on the boundary
between the past and the future--that is, outside time, which is
impossible.

(3) However much the difficulty of understanding the causes may be
increased, we never reach a conception of complete freedom, that is,
an absence of cause. However inaccessible to us may be the cause of
the expression of will in any action, our own or another's, the
first demand of reason is the assumption of and search for a cause,
for without a cause no phenomenon is conceivable. I raise my arm to
perform an action independently of any cause, but my wish to perform
an action without a cause is the cause of my action.

But even if--imagining a man quite exempt from all influences,
examining only his momentary action in the present, unevoked by any
cause--we were to admit so infinitely small a remainder of
inevitability as equaled zero, we should even then not have arrived at
the conception of complete freedom in man, for a being uninfluenced by
the external world, standing outside of time and independent of cause,
is no longer a man.

In the same way we can never imagine the action of a man quite
devoid of freedom and entirely subject to the law of inevitability.

(1) However we may increase our knowledge of the conditions of space
in which man is situated, that knowledge can never be complete, for
the number of those conditions is as infinite as the infinity of
space. And therefore so long as not all the conditions influencing men
are defined, there is no complete inevitability but a certain
measure of freedom remains.

(2) However we may prolong the period of time between the action
we are examining and the judgment upon it, that period will be finite,
while time is infinite, and so in this respect too there can never
be absolute inevitability.

(3) However accessible may be the chain of causation of any
action, we shall never know the whole chain since it is endless, and
so again we never reach absolute inevitability.

But besides this, even if, admitting the remaining minimum of
freedom to equal zero, we assumed in some given case--as for
instance in that of a dying man, an unborn babe, or an idiot--complete
absence of freedom, by so doing we should destroy the very
conception of man in the case we are examining, for as soon as there
is no freedom there is also no man. And so the conception of the
action of a man subject solely to the law of inevitability without any
element of freedom is just as impossible as the conception of a
man's completely free action.

And so to imagine the action of a man entirely subject to the law of
inevitability without any freedom, we must assume the knowledge of
an infinite number of space relations, an infinitely long period of
time, and an infinite series of causes.

To imagine a man perfectly free and not subject to the law of
inevitability, we must imagine him all alone, beyond space, beyond
time, and free from dependence on cause.

In the first case, if inevitability were possible without freedom we
should have reached a definition of inevitability by the laws of
inevitability itself, that is, a mere form without content.

In the second case, if freedom were possible without inevitability
we should have arrived at unconditioned freedom beyond space, time,
and cause, which by the fact of its being unconditioned and
unlimited would be nothing, or mere content without form.

We should in fact have reached those two fundamentals of which man's
whole outlook on the universe is constructed--the incomprehensible
essence of life, and the laws defining that essence.

Reason says: (1) space with all the forms of matter that give it
visibility is infinite, and cannot be imagined otherwise. (2) Time
is infinite motion without a moment of rest and is unthinkable
otherwise. (3) The connection between cause and effect has no
beginning and can have no end.

Consciousness says: (1) I alone am, and all that exists is but me,
consequently I include space. (2) I measure flowing time by the
fixed moment of the present in which alone I am conscious of myself as
living, consequently I am outside time. (3) I am beyond cause, for I
feel myself to be the cause of every manifestation of my life.

Reason gives expression to the laws of inevitability.
Consciousness gives expression to the essence of freedom.

Freedom not limited by anything is the essence of life, in man's
consciousness. Inevitability without content is man's reason in its
three forms.

Freedom is the thing examined. Inevitability is what examines.
Freedom is the content. Inevitability is the form.

Only by separating the two sources of cognition, related to one
another as form to content, do we get the mutually exclusive and
separately incomprehensible conceptions of freedom and inevitability.

Only by uniting them do we get a clear conception of man's life.

Apart from these two concepts which in their union mutually define
one another as form and content, no conception of life is possible.

All that we know of the life of man is merely a certain relation
of free will to inevitability, that is, of consciousness to the laws
of reason.

All that we know of the external world of nature is only a certain
relation of the forces of nature to inevitability, or of the essence
of life to the laws of reason.

The great natural forces lie outside us and we are not conscious
of them; we call those forces gravitation, inertia, electricity,
animal force, and so on, but we are conscious of the force of life
in man and we call that freedom.

But just as the force of gravitation, incomprehensible in itself but
felt by every man, is understood by us only to the extent to which
we know the laws of inevitability to which it is subject (from the
first knowledge that all bodies have weight, up to Newton's law), so
too the force of free will, incomprehensible in itself but of which
everyone is conscious, is intelligible to us only in as far as we know
the laws of inevitability to which it is subject (from the fact that
every man dies, up to the knowledge of the most complex economic and
historic laws).

All knowledge is merely a bringing of this essence of life under the
laws of reason.

Man's free will differs from every other force in that man is
directly conscious of it, but in the eyes of reason it in no way
differs from any other force. The forces of gravitation,
electricity, or chemical affinity are only distinguished from one
another in that they are differently defined by reason. Just so the
force of man's free will is distinguished by reason from the other
forces of nature only by the definition reason gives it. Freedom,
apart from necessity, that is, apart from the laws of reason that
define it, differs in no way from gravitation, or heat, or the force
that makes things grow; for reason, it is only a momentary undefinable
sensation of life.

And as the undefinable essence of the force moving the heavenly
bodies, the undefinable essence of the forces of heat and electricity,
or of chemical affinity, or of the vital force, forms the content of
astronomy, physics, chemistry, botany, zoology, and so on, just in the
same way does the force of free will form the content of history.
But just as the subject of every science is the manifestation of
this unknown essence of life while that essence itself can only be the
subject of metaphysics, even the manifestation of the force of free
will in human beings in space, in time, and in dependence on cause
forms the subject of history, while free will itself is the subject of
metaphysics.

In the experimental sciences what we know we call the laws of
inevitability, what is unknown to us we call vital force. Vital
force is only an expression for the unknown remainder over and above
what we know of the essence of life.

So also in history what is known to us we call laws of
inevitability, what is unknown we call free will. Free will is for
history only an expression for the unknown remainder of what we know
about the laws of human life.





CHAPTER XI


History examines the manifestations of man's free will in connection
with the external world in time and in dependence on cause, that is,
it defines this freedom by the laws of reason, and so history is a
science only in so far as this free will is defined by those laws.

The recognition of man's free will as something capable of
influencing historical events, that is, as not subject to laws, is the
same for history as the recognition of a free force moving the
heavenly bodies would be for astronomy.

That assumption would destroy the possibility of the existence of
laws, that is, of any science whatever. If there is even a single body
moving freely, then the laws of Kepler and Newton are negatived and no
conception of the movement of the heavenly bodies any longer exists.
If any single action is due to free will, then not a single historical
law can exist, nor any conception of historical events.

For history, lines exist of the movement of human wills, one end
of which is hidden in the unknown but at the other end of which a
consciousness of man's will in the present moves in space, time, and
dependence on cause.

The more this field of motion spreads out before our eyes, the
more evident are the laws of that movement. To discover and define
those laws is the problem of history.

From the standpoint from which the science of history now regards
its subject on the path it now follows, seeking the causes of events
in man's freewill, a scientific enunciation of those laws is
impossible, for however man's free will may be restricted, as soon
as we recognize it as a force not subject to law, the existence of law
becomes impossible.

Only by reducing this element of free will to the infinitesimal,
that is, by regarding it as an infinitely small quantity, can we
convince ourselves of the absolute inaccessibility of the causes,
and then instead of seeking causes, history will take the discovery of
laws as its problem.

The search for these laws has long been begun and the new methods of
thought which history must adopt are being worked out simultaneously
with the self-destruction toward which--ever dissecting and dissecting
the causes of phenomena--the old method of history is moving.

All human sciences have traveled along that path. Arriving at
infinitesimals, mathematics, the most exact of sciences, abandons
the process of analysis and enters on the new process of the
integration of unknown, infinitely small, quantities. Abandoning the
conception of cause, mathematics seeks law, that is, the property
common to all unknown, infinitely small, elements.

In another form but along the same path of reflection the other
sciences have proceeded. When Newton enunciated the law of gravity
he did not say that the sun or the earth had a property of attraction;
he said that all bodies from the largest to the smallest have the
property of attracting one another, that is, leaving aside the
question of the cause of the movement of the bodies, he expressed
the property common to all bodies from the infinitely large to the
infinitely small. The same is done by the natural sciences: leaving
aside the question of cause, they seek for laws. History stands on the
same path. And if history has for its object the study of the movement
of the nations and of humanity and not the narration of episodes in
the lives of individuals, it too, setting aside the conception of
cause, should seek the laws common to all the inseparably
interconnected infinitesimal elements of free will.





CHAPTER XII


From the time the law of Copernicus was discovered and proved, the
mere recognition of the fact that it was not the sun but the earth
that moves sufficed to destroy the whole cosmography of the
ancients. By disproving that law it might have been possible to retain
the old conception of the movements of the bodies, but without
disproving it, it would seem impossible to continue studying the
Ptolemaic worlds. But even after the discovery of the law of
Copernicus the Ptolemaic worlds were still studied for a long time.

From the time the first person said and proved that the number of
births or of crimes is subject to mathematical laws, and that this
or that mode of government is determined by certain geographical and
economic conditions, and that certain relations of population to
soil produce migrations of peoples, the foundations on which history
had been built were destroyed in their essence.

By refuting these new laws the former view of history might have
been retained; but without refuting them it would seem impossible to
continue studying historic events as the results of man's free will.
For if a certain mode of government was established or certain
migrations of peoples took place in consequence of such and such
geographic, ethnographic, or economic conditions, then the free will
of those individuals who appear to us to have established that mode of
government or occasioned the migrations can no longer be regarded as
the cause.

And yet the former history continues to be studied side by side with
the laws of statistics, geography, political economy, comparative
philology, and geology, which directly contradict its assumptions.

The struggle between the old views and the new was long and
stubbornly fought out in physical philosophy. Theology stood on
guard for the old views and accused the new of violating revelation.
But when truth conquered, theology established itself just as firmly
on the new foundation.

Just as prolonged and stubborn is the struggle now proceeding
between the old and the new conception of history, and theology in the
same way stands on guard for the old view, and accuses the new view of
subverting revelation.

In the one case as in the other, on both sides the struggle provokes
passion and stifles truth. On the one hand there is fear and regret
for the loss of the whole edifice constructed through the ages, on the
other is the passion for destruction.

To the men who fought against the rising truths of physical
philosophy, it seemed that if they admitted that truth it would
destroy faith in God, in the creation of the firmament, and in the
miracle of Joshua the son of Nun. To the defenders of the laws of
Copernicus and Newton, to Voltaire for example, it seemed that the
laws of astronomy destroyed religion, and he utilized the law of
gravitation as a weapon against religion.

Just so it now seems as if we have only to admit the law of
inevitability, to destroy the conception of the soul, of good and
evil, and all the institutions of state and church that have been
built up on those conceptions.

So too, like Voltaire in his time, uninvited defenders of the law of
inevitability today use that law as a weapon against religion,
though the law of inevitability in history, like the law of Copernicus
in astronomy, far from destroying, even strengthens the foundation
on which the institutions of state and church are erected.

As in the question of astronomy then, so in the question of
history now, the whole difference of opinion is based on the
recognition or nonrecognition of something absolute, serving as the
measure of visible phenomena. In astronomy it was the immovability
of the earth, in history it is the independence of personality--free
will.

As with astronomy the difficulty of recognizing the motion of the
earth lay in abandoning the immediate sensation of the earth's
fixity and of the motion of the planets, so in history the
difficulty of recognizing the subjection of personality to the laws of
space, time, and cause lies in renouncing the direct feeling of the
independence of one's own personality. But as in astronomy the new
view said: "It is true that we do not feel the movement of the
earth, but by admitting its immobility we arrive at absurdity, while
by admitting its motion (which we do not feel) we arrive at laws,"
so also in history the new view says: "It is true that we are not
conscious of our dependence, but by admitting our free will we
arrive at absurdity, while by admitting our dependence on the external
world, on time, and on cause, we arrive at laws."

In the first case it was necessary to renounce the consciousness
of an unreal immobility in space and to recognize a motion we did
not feel; in the present case it is similarly necessary to renounce
a freedom that does not exist, and to recognize a dependence of
which we are not conscious.




*** END OF THE PROJECT GUTENBERG EBOOK, WAR AND PEACE ***

This file should be named wrnpc11.txt or wrnpc11.zip
Corrected EDITIONS of our eBooks get a new NUMBER, wrnpc12.txt
VERSIONS based on separate sources get new LETTER, wrnpc11a.txt

Project Gutenberg eBooks are often created from several printed
editions, all of which are confirmed as Public Domain in the US
unless a copyright notice is included.  Thus, we usually do not
keep eBooks in compliance with any particular paper edition.

We are now trying to release all our eBooks one year in advance
of the official release dates, leaving time for better editing.
Please be encouraged to tell us about any error or corrections,
even years after the official publication date.

Please note neither this listing nor its contents are final til
midnight of the last day of the month of any such announcement.
The official release date of all Project Gutenberg eBooks is at
Midnight, Central Time, of the last day of the stated month.  A
preliminary version may often be posted for suggestion, comment
and editing by those who wish to do so.

Most people start at our Web sites at:
http://gutenberg.net or
http://promo.net/pg

These Web sites include award-winning information about Project
Gutenberg, including how to donate, how to help produce our new
eBooks, and how to subscribe to our email newsletter (free!).


Those of you who want to download any eBook before announcement
can get to them as follows, and just download by date.  This is
also a good way to get them instantly upon announcement, as the
indexes our cataloguers produce obviously take a while after an
announcement goes out in the Project Gutenberg Newsletter.

http://www.ibiblio.org/gutenberg/etext05 or
ftp://ftp.ibiblio.org/pub/docs/books/gutenberg/etext05

Or /etext04, 03, 02, 01, 00, 99, 98, 97, 96, 95, 94, 93, 92, 92,
91 or 90

Just search by the first five letters of the filename you want,
as it appears in our Newsletters.


Information about Project Gutenberg (one page)

We produce about two million dollars for each hour we work.  The
time it takes us, a rather conservative estimate, is fifty hours
to get any eBook selected, entered, proofread, edited, copyright
searched and analyzed, the copyright letters written, etc.   Our
projected audience is one hundred million readers.  If the value
per text is nominally estimated at one dollar then we produce $2
million dollars per hour in 2002 as we release over 100 new text
files per month:  1240 more eBooks in 2001 for a total of 4000+
We are already on our way to trying for 2000 more eBooks in 2002
If they reach just 1-2% of the world's population then the total
will reach over half a trillion eBooks given away by year's end.

The Goal of Project Gutenberg is to Give Away 1 Trillion eBooks!
This is ten thousand titles each to one hundred million readers,
which is only about 4% of the present number of computer users.

Here is the briefest record of our progress (* means estimated):

eBooks Year Month

    1  1971 July
   10  1991 January
  100  1994 January
 1000  1997 August
 1500  1998 October
 2000  1999 December
 2500  2000 December
 3000  2001 November
 4000  2001 October/November
 6000  2002 December*
 9000  2003 November*
10000  2004 January*


The Project Gutenberg Literary Archive Foundation has been created
to secure a future for Project Gutenberg into the next millennium.

We need your donations more than ever!

As of February, 2002, contributions are being solicited from people
and organizations in: Alabama, Alaska, Arkansas, Connecticut,
Delaware, District of Columbia, Florida, Georgia, Hawaii, Illinois,
Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Massachusetts,
Michigan, Mississippi, Missouri, Montana, Nebraska, Nevada, New
Hampshire, New Jersey, New Mexico, New York, North Carolina, Ohio,
Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South
Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West
Virginia, Wisconsin, and Wyoming.

We have filed in all 50 states now, but these are the only ones
that have responded.

As the requirements for other states are met, additions to this list
will be made and fund raising will begin in the additional states.
Please feel free to ask to check the status of your state.

In answer to various questions we have received on this:

We are constantly working on finishing the paperwork to legally
request donations in all 50 states.  If your state is not listed and
you would like to know if we have added it since the list you have,
just ask.

While we cannot solicit donations from people in states where we are
not yet registered, we know of no prohibition against accepting
donations from donors in these states who approach us with an offer to
donate.

International donations are accepted, but we don't know ANYTHING about
how to make them tax-deductible, or even if they CAN be made
deductible, and don't have the staff to handle it even if there are
ways.

Donations by check or money order may be sent to:

 PROJECT GUTENBERG LITERARY ARCHIVE FOUNDATION
 809 North 1500 West
 Salt Lake City, UT 84116

Contact us if you want to arrange for a wire transfer or payment
method other than by check or money order.

The Project Gutenberg Literary Archive Foundation has been approved by
the US Internal Revenue Service as a 501(c)(3) organization with EIN
[Employee Identification Number] 64-622154.  Donations are
tax-deductible to the maximum extent permitted by law.  As fund-raising
requirements for other states are met, additions to this list will be
made and fund-raising will begin in the additional states.

We need your donations more than ever!

You can get up to date donation information online at:

http://www.gutenberg.net/donation.html


***

If you can't reach Project Gutenberg,
you can always email directly to:

Michael S. Hart <hart@pobox.com>

Prof. Hart will answer or forward your message.

We would prefer to send you information by email.


**The Legal Small Print**


(Three Pages)

***START**THE SMALL PRINT!**FOR PUBLIC DOMAIN EBOOKS**START***
Why is this "Small Print!" statement here? You know: lawyers.
They tell us you might sue us if there is something wrong with
your copy of this eBook, even if you got it for free from
someone other than us, and even if what's wrong is not our
fault. So, among other things, this "Small Print!" statement
disclaims most of our liability to you. It also tells you how
you may distribute copies of this eBook if you want to.

*BEFORE!* YOU USE OR READ THIS EBOOK
By using or reading any part of this PROJECT GUTENBERG-tm
eBook, you indicate that you understand, agree to and accept
this "Small Print!" statement. If you do not, you can receive
a refund of the money (if any) you paid for this eBook by
sending a request within 30 days of receiving it to the person
you got it from. If you received this eBook on a physical
medium (such as a disk), you must return it with your request.

ABOUT PROJECT GUTENBERG-TM EBOOKS
This PROJECT GUTENBERG-tm eBook, like most PROJECT GUTENBERG-tm eBooks,
is a "public domain" work distributed by Professor Michael S. Hart
through the Project Gutenberg Association (the "Project").
Among other things, this means that no one owns a United States copyright
on or for this work, so the Project (and you!) can copy and
distribute it in the United States without permission and
without paying copyright royalties. Special rules, set forth
below, apply if you wish to copy and distribute this eBook
under the "PROJECT GUTENBERG" trademark.

Please do not use the "PROJECT GUTENBERG" trademark to market
any commercial products without permission.

To create these eBooks, the Project expends considerable
efforts to identify, transcribe and proofread public domain
works. Despite these efforts, the Project's eBooks and any
medium they may be on may contain "Defects". Among other
things, Defects may take the form of incomplete, inaccurate or
corrupt data, transcription errors, a copyright or other
intellectual property infringement, a defective or damaged
disk or other eBook medium, a computer virus, or computer
codes that damage or cannot be read by your equipment.

LIMITED WARRANTY; DISCLAIMER OF DAMAGES
But for the "Right of Replacement or Refund" described below,
[1] Michael Hart and the Foundation (and any other party you may
receive this eBook from as a PROJECT GUTENBERG-tm eBook) disclaims
all liability to you for damages, costs and expenses, including
legal fees, and [2] YOU HAVE NO REMEDIES FOR NEGLIGENCE OR
UNDER STRICT LIABILITY, OR FOR BREACH OF WARRANTY OR CONTRACT,
INCLUDING BUT NOT LIMITED TO INDIRECT, CONSEQUENTIAL, PUNITIVE
OR INCIDENTAL DAMAGES, EVEN IF YOU GIVE NOTICE OF THE
POSSIBILITY OF SUCH DAMAGES.

If you discover a Defect in this eBook within 90 days of
receiving it, you can receive a refund of the money (if any)
you paid for it by sending an explanatory note within that
time to the person you received it from. If you received it
on a physical medium, you must return it with your note, and
such person may choose to alternatively give you a replacement
copy. If you received it electronically, such person may
choose to alternatively give you a second opportunity to
receive it electronically.

THIS EBOOK IS OTHERWISE PROVIDED TO YOU "AS-IS". NO OTHER
WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, ARE MADE TO YOU AS
TO THE EBOOK OR ANY MEDIUM IT MAY BE ON, INCLUDING BUT NOT
LIMITED TO WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A
PARTICULAR PURPOSE.

Some states do not allow disclaimers of implied warranties or
the exclusion or limitation of consequential damages, so the
above disclaimers and exclusions may not apply to you, and you
may have other legal rights.

INDEMNITY
You will indemnify and hold Michael Hart, the Foundation,
and its trustees and agents, and any volunteers associated
with the production and distribution of Project Gutenberg-tm
texts harmless, from all liability, cost and expense, including
legal fees, that arise directly or indirectly from any of the
following that you do or cause:  [1] distribution of this eBook,
[2] alteration, modification, or addition to the eBook,
or [3] any Defect.

DISTRIBUTION UNDER "PROJECT GUTENBERG-tm"
You may distribute copies of this eBook electronically, or by
disk, book or any other medium if you either delete this
"Small Print!" and all other references to Project Gutenberg,
or:

[1]  Only give exact copies of it.  Among other things, this
     requires that you do not remove, alter or modify the
     eBook or this "small print!" statement.  You may however,
     if you wish, distribute this eBook in machine readable
     binary, compressed, mark-up, or proprietary form,
     including any form resulting from conversion by word
     processing or hypertext software, but only so long as
     *EITHER*:

     [*]  The eBook, when displayed, is clearly readable, and
          does *not* contain characters other than those
          intended by the author of the work, although tilde
          (~), asterisk (*) and underline (_) characters may
          be used to convey punctuation intended by the
          author, and additional characters may be used to
          indicate hypertext links; OR

     [*]  The eBook may be readily converted by the reader at
          no expense into plain ASCII, EBCDIC or equivalent
          form by the program that displays the eBook (as is
          the case, for instance, with most word processors);
          OR

     [*]  You provide, or agree to also provide on request at
          no additional cost, fee or expense, a copy of the
          eBook in its original plain ASCII form (or in EBCDIC
          or other equivalent proprietary form).

[2]  Honor the eBook refund and replacement provisions of this
     "Small Print!" statement.

[3]  Pay a trademark license fee to the Foundation of 20% of the
     gross profits you derive calculated using the method you
     already use to calculate your applicable taxes.  If you
     don't derive profits, no royalty is due.  Royalties are
     payable to "Project Gutenberg Literary Archive Foundation"
     the 60 days following each date you prepare (or were
     legally required to prepare) your annual (or equivalent
     periodic) tax return.  Please contact us beforehand to
     let us know your plans and to work out the details.

WHAT IF YOU *WANT* TO SEND MONEY EVEN IF YOU DON'T HAVE TO?
Project Gutenberg is dedicated to increasing the number of
public domain and licensed works that can be freely distributed
in machine readable form.

The Project gratefully accepts contributions of money, time,
public domain materials, or royalty free copyright licenses.
Money should be paid to the:
"Project Gutenberg Literary Archive Foundation."

If you are interested in contributing scanning equipment or
software or other items, please contact Michael Hart at:
hart@pobox.com

[Portions of this eBook's header and trailer may be reprinted only
when distributed free of all fees.  Copyright (C) 2001, 2002 by
Michael S. Hart.  Project Gutenberg is a TradeMark and may not be
used in any sales of Project Gutenberg eBooks or other materials be
they hardware or software or any other related product without
express permission.]

*END THE SMALL PRINT! FOR PUBLIC DOMAIN EBOOKS*Ver.02/11/02*END*

 the
 be
 of
 and
 a
 in
 to
 have
 it
 to
 for
 i
 that
 you
 he
 on
 with
 do
 at
 by
 not
 this
 but
 from
 they
 his
 that
 she
 or
 which
 as
 we
 an
 say
 will
 would
 can
 if
 their
 go
 what
 there
 all
 get
 her
 make
 who
 as
 out
 up
 see
 know
 time
 take
 them
 some
 could
 so
 him
 year
 into
 its
 then
 think
 my
 come
 than
 more
 about
 now
 last
 your
 me
 no
 other
 give
 just
 should
 these
 people
 also
 well
 any
 only
 new
 very
 when
 may
 way
 look
 like
 use
 her
 such
 how
 because
 when
 as
 good
 find
 man
 our
 want
 day
 between
 even
 there
 many
 those
 one
 after
 down
 yeah
 so
 thing
 tell
 through
 back
 still
 must
 child
 here
 over
 too
 put
 own
 on
 no
 work
 become
 more
 old
 government
 mean
 part
 leave
 life
 great
 where
 case
 woman
 over
 seem
 same
 us
 work
 need
 feel
 system
 each
 might
 may
 much
 ask
 group
 number
 yes
 however
 another
 again
 world
 area
 show
 course
 company
 shall
 under
 problem
 against
 never
 all
 most
 service
 try
 call
 hand
 party
 high
 about
 something
 school
 in
 small
 place
 before
 why
 while
 away
 keep
 point
 house
 different
 country
 really
 provide
 week
 hold
 large
 member
 off
 always
 next
 follow
 without
 turn
 end
 within
 local
 where
 during
 bring
 most
 word
 begin
 although
 example
 next
 family
 rather
 fact
 like
 social
 write
 state
 percent
 quite
 both
 start
 run
 long
 right
 set
 help
 every
 home
 month
 side
 night
 important
 eye
 head
 information
 question
 business
 play
 power
 money
 change
 move
 interest
 order
 book
 often
 development
 young
 national
 pay
 hear
 room
 whether
 water
 form
 car
 other
 yet
 perhaps
 meet
 level
 until
 though
 policy
 include
 believe
 council
 already
 possible
 nothing
 line
 allow
 need
 effect
 big
 use
 lead
 stand
 idea
 study
 lot
 live
 job
 since
 name
 result
 body
 happen
 friend
 right
 least
 right
 almost
 much
 carry
 authority
 long
 early
 view
 himself
 public
 together
 talk
 report
 after
 only
 before
 bit
 face
 sit
 market
 appear
 continue
 able
 political
 later
 hour
 rate
 law
 door
 court
 office
 let
 war
 produce
 reason
 less
 minister
 subject
 person
 term
 particular
 full
 involve
 sort
 require
 suggest
 far
 towards
 anything
 period
 consider
 read
 change
 society
 process
 mother
 offer
 late
 voice
 both
 once
 police
 kind
 lose
 add
 probably
 expect
 ever
 available
 no
 price
 little
 action
 issue
 far
 remember
 position
 low
 cost
 little
 matter
 community
 remain
 figure
 type
 research
 actually
 education
 fall
 speak
 few
 today
 enough
 open
 bad
 buy
 programme
 minute
 moment
 girl
 age
 centre
 stop
 control
 value
 send
 health
 decide
 main
 win
 understand
 decision
 develop
 class
 industry
 receive
 back
 several
 return
 build
 spend
 force
 condition
 itself
 paper
 themselves
 off
 major
 describe
 agree
 economic
 increase
 upon
 learn
 general
 century
 therefore
 father
 section
 patient
 around
 activity
 road
 table
 including
 church
 reach
 real
 lie
 mind
 likely
 among
 team
 experience
 death
 soon
 act
 sense
 staff
 certain
 student
 half
 around
 language
 walk
 die
 special
 difficult
 international
 particularly
 department
 management
 morning
 draw
 hope
 across
 plan
 product
 city
 early
 committee
 ground
 letter
 create
 evidence
 foot
 clear
 boy
 game
 food
 role
 practice
 bank
 else
 support
 sell
 event
 building
 range
 behind
 sure
 report
 pass
 black
 stage
 meeting
 sometimes
 thus
 accept
 town
 art
 further
 club
 cause
 arm
 history
 parent
 land
 trade
 watch
 white
 situation
 whose
 ago
 teacher
 record
 manager
 relation
 common
 strong
 whole
 field
 free
 break
 yesterday
 support
 window
 account
 explain
 stay
 few
 wait
 usually
 difference
 material
 air
 wife
 cover
 apply
 project
 raise
 sale
 relationship
 indeed
 light
 claim
 form
 base
 care
 someone
 everything
 certainly
 rule
 home
 cut
 grow
 similar
 story
 quality
 tax
 worker
 nature
 structure
 data
 necessary
 pound
 method
 unit
 central
 bed
 union
 movement
 board
 true
 well
 simply
 contain
 especially
 open
 short
 personal
 detail
 model
 bear
 single
 join
 reduce
 establish
 herself
 wall
 face
 easy
 private
 computer
 former
 hospital
 chapter
 scheme
 theory
 choose
 wish
 property
 achieve
 financial
 poor
 officer
 up
 charge
 director
 drive
 deal
 place
 approach
 chance
 application
 seek
 cos
 foreign
 along
 top
 amount
 son
 operation
 fail
 human
 opportunity
 simple
 leader
 look
 share
 production
 recent
 firm
 picture
 source
 security
 serve
 according
 end
 contract
 wide
 occur
 agreement
 better
 kill
 act
 site
 either
 labour
 plan
 various
 since
 test
 eat
 loss
 close
 represent
 love
 colour
 clearly
 shop
 benefit
 animal
 heart
 election
 purpose
 standard
 due
 secretary
 rise
 date
 hard
 music
 hair
 prepare
 factor
 other
 anyone
 pattern
 manage
 piece
 discuss
 prove
 front
 evening
 royal
 tree
 population
 fine
 plant
 pressure
 response
 catch
 street
 pick
 performance
 knowledge
 despite
 design
 page
 enjoy
 individual
 suppose
 rest
 instead
 wear
 basis
 size
 environment
 per
 fire
 series
 success
 natural
 wrong
 near
 round
 thought
 list
 argue
 final
 future
 introduce
 analysis
 enter
 space
 arrive
 ensure
 demand
 statement
 to
 attention
 love
 principle
 pull
 set
 doctor
 choice
 refer
 feature
 couple
 step
 following
 thank
 machine
 income
 training
 present
 association
 film
 region
 effort
 player
 everyone
 present
 award
 village
 control
 organisation
 whatever
 news
 nice
 difficulty
 modern
 cell
 close
 current
 legal
 energy
 finally
 degree
 mile
 means
 growth
 whom
 treatment
 sound
 above
 task
 provision
 affect
 please
 red
 happy
 behaviour
 concerned
 point
 function
 identify
 resource
 defence
 garden
 floor
 technology
 style
 feeling
 science
 relate
 doubt
 horse
 force
 answer
 compare
 suffer
 individual
 forward
 announce
 user
 fund
 character
 risk
 normal
 myself
 nor
 dog
 obtain
 quickly
 army
 indicate
 forget
 station
 glass
 cup
 previous
 husband
 recently
 publish
 serious
 anyway
 visit
 capital
 either
 note
 season
 argument
 listen
 show
 responsibility
 significant
 deal
 prime
 economy
 element
 finish
 duty
 fight
 train
 maintain
 attempt
 leg
 investment
 save
 throughout
 design
 suddenly
 brother
 improve
 avoid
 wonder
 tend
 title
 hotel
 aspect
 increase
 help
 industrial
 express
 summer
 determine
 generally
 daughter
 exist
 used
 share
 baby
 nearly
 smile
 sorry
 sea
 skill
 claim
 treat
 remove
 concern
 university
 labour
 left
 dead
 discussion
 specific
 customer
 box
 outside
 state
 conference
 whole
 total
 profit
 division
 throw
 procedure
 fill
 king
 assume
 image
 oil
 obviously
 unless
 appropriate
 circumstance
 military
 proposal
 mention
 client
 sector
 direction
 admit
 though
 replace
 basic
 hard
 instance
 sign
 original
 successful
 okay
 reflect
 aware
 measure
 attitude
 yourself
 disease
 exactly
 above
 commission
 intend
 beyond
 seat
 president
 encourage
 addition
 goal
 round
 miss
 popular
 affair
 technique
 respect
 drop
 professional
 less
 once
 item
 fly
 reveal
 version
 maybe
 ability
 operate
 good
 campaign
 heavy
 advice
 institution
 top
 discover
 surface
 library
 pupil
 record
 refuse
 prevent
 advantage
 dark
 teach
 memory
 culture
 blood
 cost
 majority
 answer
 variety
 press
 depend
 bill
 competition
 ready
 general
 access
 hit
 stone
 useful
 extent
 employment
 regard
 apart
 present
 appeal
 text
 parliament
 cause
 terms
 bar
 attack
 effective
 mouth
 down
 result
 fish
 future
 visit
 little
 easily
 attempt
 enable
 trouble
 traditional
 payment
 best
 post
 county
 lady
 holiday
 realise
 importance
 chair
 facility
 complete
 article
 object
 context
 survey
 notice
 complete
 turn
 direct
 immediately
 collection
 reference
 card
 interesting
 considerable
 television
 extend
 communication
 agency
 physical
 except
 check
 sun
 species
 possibility
 official
 chairman
 speaker
 second
 career
 laugh
 weight
 sound
 responsible
 base
 document
 solution
 return
 medical
 hot
 recognise
 talk
 budget
 river
 fit
 organization
 existing
 start
 push
 tomorrow
 requirement
 cold
 edge
 opposition
 opinion
 drug
 quarter
 option
 sign
 worth
 call
 define
 stock
 influence
 occasion
 eventually
 software
 highly
 exchange
 lack
 shake
 study
 concept
 blue
 star
 radio
 no
 arrangement
 examine
 bird
 green
 band
 sex
 finger
 past
 independent
 equipment
 north
 mind
 move
 message
 fear
 afternoon
 drink
 fully
 race
 gain
 strategy
 extra
 scene
 slightly
 kitchen
 speech
 arise
 network
 tea
 peace
 failure
 employee
 ahead
 scale
 hardly
 attend
 shoulder
 otherwise
 railway
 directly
 supply
 expression
 owner
 associate
 corner
 past
 match
 sport
 status
 beautiful
 offer
 marriage
 hang
 civil
 perform
 sentence
 crime
 ball
 marry
 wind
 truth
 protect
 safety
 partner
 completely
 copy
 balance
 sister
 reader
 below
 trial
 rock
 damage
 adopt
 newspaper
 meaning
 light
 essential
 obvious
 nation
 confirm
 south
 length
 branch
 deep
 none
 planning
 trust
 working
 pain
 studio
 positive
 spirit
 college
 accident
 star
 hope
 mark
 works
 league
 clear
 imagine
 through
 cash
 normally
 play
 strength
 train
 travel
 target
 very
 pair
 male
 gas
 issue
 contribution
 complex
 supply
 beat
 artist
 agent
 presence
 along
 environmental
 strike
 contact
 protection
 beginning
 demand
 media
 relevant
 employ
 shoot
 executive
 slowly
 relatively
 aid
 huge
 late
 speed
 review
 test
 order
 route
 consequence
 telephone
 release
 proportion
 primary
 consideration
 reform
 driver
 annual
 nuclear
 latter
 practical
 commercial
 rich
 emerge
 apparently
 ring
 distance
 exercise
 key
 close
 skin
 island
 separate
 aim
 danger
 credit
 usual
 link
 candidate
 track
 safe
 interested
 assessment
 path
 merely
 plus
 district
 regular
 reaction
 impact
 collect
 debate
 lay
 rise
 belief
 conclusion
 shape
 vote
 aim
 politics
 reply
 press
 approach
 file
 western
 earth
 public
 survive
 estate
 boat
 prison
 additional
 settle
 largely
 wine
 observe
 limit
 deny
 for
 straight
 somebody
 writer
 weekend
 clothes
 active
 sight
 video
 reality
 hall
 nevertheless
 regional
 vehicle
 worry
 powerful
 possibly
 cross
 colleague
 charge
 lead
 farm
 respond
 employer
 carefully
 understanding
 connection
 comment
 grant
 concentrate
 ignore
 phone
 hole
 insurance
 content
 confidence
 sample
 transport
 objective
 alone
 flower
 injury
 lift
 stick
 front
 mainly
 battle
 generation
 currently
 winter
 inside
 impossible
 somewhere
 arrange
 will
 sleep
 progress
 volume
 ship
 legislation
 commitment
 enough
 conflict
 bag
 fresh
 entry
 smile
 fair
 promise
 introduction
 senior
 manner
 background
 key
 touch
 vary
 sexual
 ordinary
 cabinet
 painting
 entirely
 engine
 previously
 administration
 tonight
 adult
 prefer
 author
 actual
 song
 investigation
 debt
 visitor
 forest
 repeat
 wood
 contrast
 extremely
 wage
 domestic
 commit
 threat
 bus
 warm
 sir
 regulation
 drink
 relief
 internal
 strange
 excellent
 run
 fairly
 technical
 tradition
 measure
 insist
 his
 farmer
 until
 traffic
 dinner
 consumer
 meal
 warn
 living
 package
 half
 increasingly
 description
 soft
 stuff
 award
 existence
 improvement
 coffee
 appearance
 standard
 attack
 sheet
 category
 distribution
 equally
 session
 cultural
 loan
 bind
 museum
 conversation
 threaten
 link
 launch
 proper
 victim
 audience
 famous
 master
 lip
 religious
 joint
 cry
 potential
 broad
 exhibition
 experience
 judge
 formal
 housing
 past
 concern
 freedom
 gentleman
 attract
 explanation
 appoint
 note
 chief
 total
 lovely
 official
 date
 demonstrate
 construction
 middle
 yard
 unable
 acquire
 surely
 crisis
 propos
 west
 impose
 market
 care
 god
 favour
 before
 name
 equal
 capacity
 flat
 selection
 alone
 football
 victory
 factory
 rural
 twice
 sing
 whereas
 own
 head
 examination
 deliver
 nobody
 substantial
 invite
 intention
 egg
 reasonable
 onto
 retain
 aircraft
 decade
 cheap
 quiet
 bright
 contribute
 row
 search
 limit
 definition
 unemployment
 spread
 mark
 flight
 account
 output
 last
 tour
 address
 immediate
 reduction
 interview
 assess
 promote
 everybody
 suitable
 ought
 growing
 nod
 reject
 while
 high
 dream
 vote
 divide
 declare
 handle
 detailed
 challenge
 notice
 rain
 destroy
 mountain
 concentration
 limited
 finance
 pension
 influence
 afraid
 murder
 neck
 weapon
 hide
 offence
 absence
 error
 representative
 enterprise
 criticism
 average
 quick
 sufficient
 appointment
 match
 transfer
 acid
 spring
 birth
 ear
 recognize
 recommend
 module
 instruction
 democratic
 park
 weather
 bottle
 address
 bedroom
 kid
 pleasure
 realize
 assembly
 expensive
 select
 teaching
 desire
 whilst
 contact
 implication
 combine
 temperature
 wave
 magazine
 totally
 mental
 used
 store
 scientific
 frequently
 thanks
 beside
 settlement
 absolutely
 critical
 recognition
 touch
 consist
 below
 silence
 expenditure
 institute
 dress
 dangerous
 familiar
 asset
 belong
 educational
 sum
 publication
 partly
 block
 seriously
 youth
 tape
 elsewhere
 cover
 fee
 program
 treaty
 necessarily
 unlikely
 properly
 guest
 code
 hill
 screen
 household
 sequence
 correct
 female
 phase
 crowd
 welcome
 metal
 human
 widely
 undertake
 cut
 sky
 brain
 expert
 experiment
 tiny
 perfect
 disappear
 initiative
 assumption
 photograph
 ministry
 congress
 transfer
 reading
 scientist
 fast
 fast
 closely
 thin
 solicitor
 secure
 plate
 pool
 gold
 emphasis
 recall
 shout
 generate
 location
 display
 heat
 gun
 shut
 journey
 imply
 violence
 dry
 historical
 step
 curriculum
 noise
 lunch
 fear
 succeed
 fall
 bottom
 initial
 theme
 characteristic
 pretty
 empty
 display
 combination
 interpretation
 rely
 escape
 score
 justice
 upper
 tooth
 organise
 cat
 tool
 spot
 bridge
 double
 direct
 conclude
 relative
 soldier
 climb
 breath
 afford
 urban
 nurse
 narrow
 liberal
 coal
 priority
 wild
 revenue
 membership
 grant
 approve
 tall
 apparent
 faith
 under
 fix
 slow
 troop
 motion
 leading
 component
 bloody
 literature
 conservative
 variation
 remind
 inform
 alternative
 neither
 outside
 mass
 busy
 chemical
 careful
 investigate
 roll
 instrument
 guide
 criterion
 pocket
 suggestion
 aye
 entitle
 tone
 attractive
 wing
 surprise
 male
 ring
 pub
 fruit
 passage
 illustrate
 pay
 ride
 foundation
 restaurant
 vital
 alternative
 burn
 map
 united
 device
 jump
 estimate
 conduct
 derive
 comment
 east
 advise
 advance
 motor
 satisfy
 hell
 winner
 effectively
 mistake
 incident
 focus
 exercise
 representation
 release
 leaf
 border
 wash
 prospect
 blow
 trip
 observation
 gather
 ancient
 brief
 gate
 elderly
 persuade
 overall
 rare
 index
 hand
 circle
 creation
 drawing
 anybody
 flow
 matter
 external
 capable
 recover
 shot
 request
 impression
 neighbour
 theatre
 beneath
 hurt
 mechanism
 potential
 lean
 defendant
 atmosphere
 slip
 chain
 accompany
 wonderful
 earn
 enemy
 desk
 engineering
 panel
 distinction
 deputy
 discipline
 strike
 married
 plenty
 establishment
 fashion
 roof
 milk
 entire
 tear
 secondary
 finding
 welfare
 increased
 attach
 typical
 meanwhile
 leadership
 walk
 negotiation
 clean
 religion
 count
 grey
 hence
 alright
 first
 fuel
 mine
 appeal
 servant
 liability
 constant
 hate
 shoe
 expense
 vast
 soil
 writing
 nose
 origin
 lord
 rest
 drive
 ticket
 editor
 switch
 provided
 northern
 significance
 channel
 convention
 damage
 funny
 bone
 severe
 search
 iron
 vision
 via
 somewhat
 inside
 trend
 revolution
 terrible
 knee
 dress
 unfortunately
 steal
 criminal
 signal
 notion
 comparison
 academic
 outcome
 lawyer
 strongly
 surround
 explore
 achievement
 odd
 expectation
 corporate
 prisoner
 question
 rapidly
 deep
 southern
 amongst
 withdraw
 afterwards
 paint
 judge
 citizen
 permanent
 weak
 separate
 ourselves
 plastic
 connect
 fundamental
 plane
 height
 opening
 lesson
 similarly
 shock
 rail
 tenant
 owe
 originally
 middle
 somehow
 minor
 negative
 knock
 root
 pursue
 inner
 crucial
 occupy
 that
 independence
 column
 proceeding
 female
 beauty
 perfectly
 struggle
 gap
 house
 database
 stretch
 stress
 passenger
 boundary
 easy
 view
 manufacturer
 sharp
 formation
 queen
 waste
 virtually
 expand
 contemporary
 politician
 back
 territory
 championship
 exception
 thick
 inquiry
 topic
 resident
 transaction
 parish
 supporter
 massive
 light
 unique
 challenge
 inflation
 assistance
 list
 identity
 suit
 parliamentary
 unknown
 preparation
 elect
 badly
 moreover
 tie
 cancer
 champion
 exclude
 review
 licence
 breakfast
 minority
 appreciate
 fan
 chief
 accommodation
 subsequent
 democracy
 brown
 taste
 crown
 permit
 buyer
 gift
 resolution
 angry
 metre
 wheel
 clause
 break
 tank
 benefit
 engage
 alive
 complaint
 inch
 firm
 abandon
 blame
 clean
 quote
 yours
 quantity
 rule
 guilty
 prior
 round
 eastern
 coat
 involvement
 tension
 diet
 enormous
 score
 rarely
 prize
 remaining
 significantly
 glance
 dominate
 trust
 naturally
 interpret
 land
 frame
 extension
 mix
 spokesman
 friendly
 acknowledge
 register
 regime
 fault
 mine
 dispute
 grass
 quietly
 decline
 dismiss
 delivery
 complain
 conservative
 shift
 port
 beach
 string
 depth
 unusual
 travel
 pilot
 obligation
 gene
 yellow
 republic
 shadow
 dear
 analyse
 anywhere
 average
 phrase
 long
 crew
 lucky
 restore
 convince
 coast
 engineer
 heavily
 extensive
 glad
 charity
 oppose
 defend
 alter
 warning
 arrest
 framework
 approval
 bother
 novel
 accuse
 surprised
 currency
 restrict
 possess
 moral
 protein
 distinguish
 gently
 reckon
 incorporate
 proceed
 assist
 sure
 stress
 justify
 behalf
 councillor
 setting
 command
 maintenance
 stair
 poem
 chest
 like
 secret
 restriction
 efficient
 suspect
 hat
 tough
 firmly
 willing
 healthy
 focus
 construct
 occasionally
 mode
 saving
 comfortable
 camp
 trade
 export
 wake
 partnership
 daily
 abroad
 profession
 load
 countryside
 boot
 mostly
 sudden
 implement
 reputation
 print
 calculate
 keen
 guess
 recommendation
 autumn
 conventional
 cope
 constitute
 poll
 voluntary
 valuable
 recovery
 cast
 premise
 resolve
 regularly
 solve
 plaintiff
 critic
 agriculture
 ice
 constitution
 communist
 layer
 recession
 slight
 dramatic
 golden
 temporary
 suit
 shortly
 initially
 arrival
 protest
 resistance
 silent
 presentation
 soul
 self
 judgment
 feed
 muscle
 shareholder
 opposite
 pollution
 wealth
 video
 kingdom
 bread
 perspective
 camera
 prince
 illness
 cake
 meat
 submit
 ideal
 relax
 penalty
 purchase
 tired
 beer
 specify
 short
 monitor
 electricity
 specifically
 bond
 statutory
 laboratory
 federal
 captain
 deeply
 pour
 boss
 creature
 urge
 locate
 being
 struggle
 lifespan
 flat
 valley
 like
 guard
 emergency
 dark
 bomb
 dollar
 efficiency
 mood
 convert
 possession
 marketing
 please
 habit
 subsequently
 round
 purchase
 sort
 outside
 gradually
 expansion
 competitive
 co
 acceptable
 angle
 cook
 net
 sensitive
 ratio
 kiss
 amount
 sleep
 finance
 essentially
 fund
 preserve
 wedding
 personality
 bishop
 dependent
 landscape
 pure
 mirror
 lock
 symptom
 promotion
 global
 aside
 tendency
 conservation
 reply
 estimate
 qualification
 pack
 governor
 expected
 invest
 cycle
 alright
 philosophy
 gallery
 sad
 intervention
 emotional
 advertising
 regard
 dance
 cigarette
 predict
 adequate
 variable
 net
 retire
 sugar
 pale
 frequency
 guy
 feature
 furniture
 administrative
 wooden
 input
 phenomenon
 surprising
 jacket
 actor
 kick
 producer
 hearing
 chip
 equation
 certificate
 hello
 remarkable
 alliance
 smoke
 awareness
 throat
 discovery
 festival
 dance
 promise
 rose
 principal
 brilliant
 proposed
 coach
 absolute
 drama
 recording
 precisely
 bath
 celebrate
 substance
 swing
 for
 rapid
 rough
 investor
 fire
 rank
 compete
 sweet
 decline
 rent
 dealer
 bend
 solid
 cloud
 across
 level
 enquiry
 fight
 abuse
 golf
 guitar
 electronic
 cottage
 scope
 pause
 mixture
 emotion
 comprehensive
 shirt
 allowance
 retirement
 breach
 infection
 resist
 qualify
 paragraph
 sick
 near
 researcher
 consent
 written
 literary
 ill
 wet
 lake
 entrance
 peak
 successfully
 sand
 breathe
 cold
 cheek
 platform
 interaction
 need
 watch
 borrow
 birthday
 knife
 extreme
 core
 peasant
 armed
 permission
 supreme
 overcome
 greatly
 visual
 lad
 genuine
 personnel
 judgement
 exciting
 stream
 perception
 guarantee
 disaster
 darkness
 bid
 sake
 organize
 tourist
 policeman
 castle
 figure
 race
 demonstration
 anger
 briefly
 presumably
 clock
 hero
 expose
 custom
 maximum
 wish
 earning
 priest
 resign
 store
 widespread
 comprise
 chamber
 acquisition
 involved
 confident
 circuit
 radical
 detect
 stupid
 grand
 consumption
 hold
 zone
 mean
 altogether
 rush
 numerous
 sink
 everywhere
 classical
 respectively
 distinct
 mad
 honour
 statistics
 false
 square
 differ
 disk
 truly
 survival
 proud
 tower
 deposit
 pace
 compensation
 adviser
 consultant
 drag
 advanced
 landlord
 whenever
 delay
 green
 car
 holder
 secret
 edition
 occupation
 agricultural
 intelligence
 empire
 definitely
 negotiate
 host
 relative
 mass
 helpful
 fellow
 sweep
 poet
 journalist
 defeat
 unlike
 primarily
 tight
 indication
 dry
 cricket
 whisper
 routine
 print
 anxiety
 witness
 concerning
 mill
 gentle
 curtain
 mission
 supplier
 basically
 assure
 poverty
 snow
 prayer
 pipe
 deserve
 shift
 split
 near
 consistent
 carpet
 ownership
 joke
 fewer
 workshop
 salt
 aged
 symbol
 slide
 cross
 anxious
 tale
 preference
 inevitably
 mere
 behave
 gain
 nervous
 guide
 remark
 pleased
 province
 steel
 practise
 flow
 holy
 dose
 alcohol
 guidance
 constantly
 climate
 enhance
 reasonably
 waste
 smooth
 dominant
 conscious
 formula
 tail
 ha
 electric
 sheep
 medicine
 strategic
 disabled
 smell
 operator
 mount
 advance
 remote
 measurement
 favour
 neither
 architecture
 worth
 tie
 barrier
 practitioner
 outstanding
 enthusiasm
 theoretical
 implementation
 worried
 pitch
 drop
 phone
 shape
 clinical
 lane
 apple
 catalogue
 tip
 publisher
 opponent
 live
 burden
 tackle
 historian
 bury
 stomach
 percentage
 evaluation
 outline
 talent
 lend
 silver
 pack
 fun
 democrat
 fortune
 storage
 professional
 reserve
 interval
 dimension
 honest
 awful
 manufacture
 confusion
 pink
 impressive
 satisfaction
 visible
 vessel
 stand
 curve
 pot
 replacement
 accurate
 mortgage
 salary
 impress
 constitutional
 emphasise
 developing
 proof
 furthermore
 dish
 interview
 considerably
 distant
 lower
 favourite
 tear
 fixed
 by
 luck
 count
 precise
 determination
 bite
 dear
 consultation
 range
 residential
 conduct
 capture
 ultimately
 cheque
 economics
 sustain
 secondly
 silly
 merchant
 lecture
 musical
 leisure
 check
 cheese
 lift
 participate
 fabric
 distribute
 lover
 childhood
 cool
 ban
 supposed
 mouse
 strain
 specialist
 consult
 minimum
 approximately
 participant
 monetary
 confuse
 dare
 smoke
 movie
 seed
 cease
 open
 journal
 shopping
 equivalent
 palace
 exceed
 isolated
 poetry
 perceive
 lack
 strengthen
 snap
 readily
 spite
 conviction
 corridor
 behind
 ward
 profile
 fat
 comfort
 bathroom
 shell
 reward
 deliberately
 automatically
 vegetable
 imagination
 junior
 unemployed
 mystery
 pose
 violent
 march
 found
 dig
 dirty
 straight
 psychological
 grab
 pleasant
 surgery
 inevitable
 transform
 bell
 announcement
 draft
 unity
 airport
 upset
 pretend
 plant
 till
 known
 admission
 tissue
 magistrate
 joy
 free
 pretty
 operating
 headquarters
 grateful
 classroom
 turnover
 project
 shrug
 sensible
 limitation
 specialist
 newly
 tongue
 refugee
 delay
 dream
 composition
 alongside
 ceiling
 highlight
 stick
 favourite
 tap
 universe
 request
 label
 confine
 scream
 rid
 acceptance
 detective
 sail
 adjust
 designer
 running
 summit
 participation
 weakness
 block
 so
 adapt
 absorb
 encounter
 defeat
 excitement
 brick
 blind
 wire
 crop
 square
 transition
 thereby
 protest
 roll
 stop
 assistant
 deaf
 constituency
 continuous
 concert
 breast
 extraordinary
 squad
 wonder
 cream
 tennis
 personally
 communicate
 pride
 bowl
 file
 expertise
 govern
 leather
 observer
 margin
 uncertainty
 reinforce
 ideal
 injure
 holding
 universal
 evident
 dust
 overseas
 desperate
 swim
 occasional
 trouser
 surprisingly
 register
 album
 guideline
 disturb
 amendment
 architect
 objection
 chart
 cattle
 doubt
 react
 consciousness
 right
 purely
 tin
 tube
 fulfil
 commonly
 sufficiently
 coin
 frighten
 grammar
 diary
 flesh
 summary
 infant
 stir
 storm
 mail
 rugby
 virtue
 specimen
 psychology
 paint
 constraint
 trace
 privilege
 completion
 progress
 hers
 grade
 exploit
 import
 potato
 repair
 passion
 seize
 low
 underlying
 heaven
 nerve
 park
 collapse
 win
 printer
 coalition
 button
 pray
 ultimate
 venture
 timber
 companion
 horror
 gesture
 moon
 remark
 clever
 van
 consequently
 raw
 glance
 broken
 jury
 gaze
 burst
 charter
 feminist
 discourse
 reflection
 carbon
 sophisticated
 ban
 taxation
 prosecution
 softly
 asleep
 aids
 publicity
 departure
 welcome
 sharply
 reception
 cousin
 relieve
 linguistic
 vat
 forward
 blue
 multiple
 pass
 outer
 vulnerable
 patient
 evolution
 allocate
 creative
 potentially
 just
 out
 judicial
 risk
 ideology
 smell
 agenda
 transport
 illegal
 chicken
 plain
 innovation
 opera
 lock
 grin
 shelf
 pole
 punishment
 strict
 wave
 inside
 carriage
 fit
 conversion
 hurry
 essay
 integration
 resignation
 treasury
 traveller
 chocolate
 assault
 schedule
 undoubtedly
 twin
 format
 murder
 sigh
 seller
 lease
 bitter
 double
 ally
 stake
 processing
 informal
 flexible
 cap
 stable
 till
 sympathy
 tunnel
 pen
 instal
 suspend
 blow
 wander
 notably
 disappoint
 wipe
 folk
 attraction
 disc
 inspire
 machinery
 undergo
 nowhere
 inspector
 wise
 balance
 purchaser
 resort
 pop
 organ
 ease
 friendship
 deficit
 dear
 convey
 reserve
 planet
 frequent
 loose
 intense
 retail
 wind
 lost
 grain
 particle
 destruction
 witness
 pit
 registration
 conception
 steady
 rival
 steam
 back
 chancellor
 crash
 belt
 logic
 premium
 confront
 precede
 experimental
 alarm
 rational
 incentive
 roughly
 bench
 wrap
 regarding
 inadequate
 ambition
 since
 fate
 vendor
 stranger
 spiritual
 increasing
 anticipate
 logical
 fibre
 attribute
 sense
 black
 petrol
 maker
 generous
 allocation
 depression
 declaration
 spot
 modest
 bottom
 dividend
 devote
 condemn
 integrate
 pile
 identification
 acute
 barely
 providing
 directive
 bet
 modify
 bare
 swear
 final
 accordingly
 valid
 wherever
 mortality
 medium
 silk
 funeral
 depending
 cow
 correspond
 cite
 classic
 inspection
 calculation
 rubbish
 minimum
 hypothesis
 youngster
 slope
 patch
 invitation
 ethnic
 federation
 duke
 wholly
 closure
 dictionary
 withdrawal
 automatic
 liable
 cry
 slow
 borough
 well
 suspicion
 portrait
 local
 jew
 fragment
 revolutionary
 evaluate
 competitor
 sole
 reliable
 weigh
 medieval
 clinic
 shine
 knit
 complexity
 remedy
 fence
 bike
 freeze
 eliminate
 interior
 intellectual
 established
 voter
 garage
 era
 pregnant
 plot
 greet
 electrical
 lie
 disorder
 formally
 excuse
 socialist
 cancel
 harm
 excess
 exact
 oblige
 accountant
 mutual
 fat
 volunteer
 laughter
 trick
 load
 disposal
 taxi
 murmur
 tonne
 spell
 clerk
 curious
 satisfactory
 identical
 applicant
 removal
 processor
 cotton
 reverse
 hesitate
 professor
 admire
 namely
 electoral
 delight
 urgent
 prompt
 mate
 exposure
 server
 distinctive
 marginal
 structural
 rope
 miner
 entertainment
 acre
 pig
 encouraging
 guarantee
 gear
 anniversary
 past
 ceremony
 rub
 monopoly
 left
 flee
 yield
 discount
 above
 uncle
 audit
 advertisement
 explosion
 contrary
 tribunal
 swallow
 typically
 fun
 rat
 cloth
 cable
 interrupt
 crash
 flame
 controversy
 rabbit
 everyday
 allegation
 strip
 stability
 tide
 illustration
 insect
 correspondent
 devise
 determined
 brush
 adjustment
 controversial
 organic
 escape
 thoroughly
 interface
 historic
 collapse
 temple
 shade
 craft
 nursery
 piano
 desirable
 assurance
 jurisdiction
 advertise
 bay
 specification
 disability
 presidential
 arrest
 unexpected
 switch
 penny
 respect
 celebration
 gross
 aid
 superb
 process
 innocent
 leap
 colony
 wound
 hardware
 satellite
 float
 bible
 statistical
 marked
 hire
 cathedral
 motive
 correct
 gastric
 raid
 comply
 accommodate
 mutter
 induce
 trap
 invasion
 humour
 bulk
 traditionally
 commission
 upstairs
 translate
 rhythm
 emission
 collective
 transformation
 battery
 stimulus
 naked
 white
 menu
 toilet
 butter
 surprise
 needle
 effectiveness
 accordance
 molecule
 fiction
 learning
 statute
 reluctant
 overlook
 junction
 necessity
 nearby
 experienced
 lorry
 exclusive
 graphics
 stimulate
 warmth
 therapy
 convenient
 cinema
 domain
 tournament
 doctrine
 sheer
 proposition
 grip
 widow
 discrimination
 bloody
 ruling
 fit
 nonetheless
 myth
 episode
 drift
 assert
 terrace
 uncertain
 twist
 insight
 undermine
 tragedy
 enforce
 criticise
 march
 leaflet
 fellow
 object
 pond
 adventure
 diplomatic
 mixed
 rebel
 equity
 literally
 magnificent
 loyalty
 tremendous
 airline
 shore
 restoration
 physically
 render
 institutional
 emphasize
 mess
 commander
 straightforward
 singer
 squeeze
 full
 breed
 successor
 triumph
 heading
 mathematics
 laugh
 clue
 still
 ease
 specially
 biological
 forgive
 trustee
 photo
 fraction
 chase
 whereby
 mud
 pensioner
 functional
 copy
 strictly
 desperately
 await
 coverage
 wildlife
 indicator
 lightly
 hierarchy
 evolve
 mechanical
 expert
 creditor
 capitalist
 essence
 compose
 mentally
 gaze
 seminar
 target
 label
 fig
 continent
 chap
 flexibility
 verse
 minute
 whisky
 equivalent
 recruit
 echo
 unfair
 launch
 cupboard
 bush
 shortage
 prominent
 merger
 command
 subtle
 capital
 gang
 fish
 unhappy
 lifetime
 elite
 refusal
 finish
 aggressive
 superior
 landing
 exchange
 debate
 educate
 separation
 productivity
 initiate
 probability
 virus
 reporter
 fool
 pop
 capitalism
 painful
 correctly
 complex
 rumour
 imperial
 justification
 availability
 spectacular
 remain
 ocean
 cliff
 sociology
 sadly
 missile
 situate
 artificial
 apartment
 provoke
 oral
 maximum
 angel
 spare
 shame
 intelligent
 discretion
 businessman
 explicit
 book
 uniform
 push
 counter
 subject
 objective
 hungry
 clothing
 ride
 romantic
 attendance
 part
 trace
 backing
 sensation
 carrier
 interest
 classification
 classic
 beg
 appendix
 doorway
 density
 working
 legislative
 hint
 shower
 current
 succession
 nasty
 duration
 desert
 receipt
 native
 chapel
 amazing
 hopefully
 fleet
 comparable
 oxygen
 installation
 developer
 disadvantage
 recipe
 crystal
 modification
 schedule
 midnight
 successive
 formerly
 loud
 value
 physics
 truck
 stroke
 kiss
 envelope
 speculation
 canal
 unionist
 directory
 receiver
 isolation
 fade
 chemistry
 unnecessary
 hit
 defender
 stance
 sin
 realistic
 socialist
 subsidy
 content
 toy
 darling
 decent
 liberty
 forever
 skirt
 coordinate
 tactic
 influential
 import
 accent
 compound
 bastard
 ingredient
 dull
 cater
 scholar
 faint
 ghost
 sculpture
 ridiculous
 diagnosis
 delegate
 neat
 kit
 lion
 dialogue
 repair
 tray
 fantasy
 leave
 export
 forth
 lamp
 allege
 pavement
 brand
 constable
 compromise
 flag
 filter
 reign
 execute
 pity
 merit
 diagram
 wool
 organism
 elegant
 red
 undertaking
 lesser
 reach
 marvellous
 improved
 locally
 entity
 rape
 secure
 descend
 backwards
 peer
 excuse
 genetic
 fold
 portfolio
 consensus
 thesis
 shop
 nest
 frown
 builder
 administer
 tip
 lung
 delegation
 outside
 heating
 like
 instinct
 teenager
 lonely
 residence
 radiation
 extract
 concession
 autonomy
 norm
 musician
 graduate
 glory
 bear
 persist
 rescue
 equip
 partial
 officially
 capability
 worry
 liberation
 hunt
 daily
 heel
 contract
 update
 assign
 spring
 single
 commons
 weekly
 stretch
 pregnancy
 happily
 spectrum
 interfere
 suicide
 panic
 invent
 intensive
 damp
 simultaneously
 giant
 casual
 sphere
 precious
 sword
 envisage
 bean
 time
 crazy
 changing
 primary
 concede
 besides
 unite
 severely
 separately
 instruct
 insert
 go
 exhibit
 brave
 tutor
 tune
 debut
 continued
 bid
 incidence
 downstairs
 cafe
 regret
 killer
 delicate
 subsidiary
 gender
 entertain
 cling
 vertical
 fetch
 strip
 plead
 duck
 breed
 assistant
 pint
 abolish
 translation
 princess
 line
 excessive
 digital
 steep
 jet
 hey
 grave
 exceptional
 boost
 random
 correlation
 outline
 intervene
 packet
 motivation
 safely
 harsh
 spell
 spread
 draw
 concrete
 complicated
 alleged
 redundancy
 progressive
 intensity
 crack
 fly
 fancy
 alternatively
 waiting
 scandal
 resemble
 parameter
 fierce
 tropical
 colour
 ours
 engagement
 contest
 edit
 courage
 hip
 delighted
 sponsor
 carer
 crack
 substantially
 occupational
 trainer
 remainder
 related
 inherit
 resume
 assignment
 conceal
 disclose
 exclusively
 working
 mild
 chronic
 splendid
 function
 rider
 clay
 firstly
 conceive
 politically
 terminal
 accuracy
 coup
 ambulance
 living
 offender
 similarity
 orchestra
 brush
 systematic
 striker
 guard
 casualty
 steadily
 painter
 opt
 handsome
 banking
 sensitivity
 navy
 fascinating
 disappointment
 auditor
 hostility
 spending
 scarcely
 compulsory
 photographer
 ok
 neighbourhood
 ideological
 wide
 pardon
 double
 criticize
 supervision
 guilt
 deck
 payable
 execution
 suite
 elected
 solely
 moral
 collector
 questionnaire
 flavour
 couple
 faculty
 tour
 basket
 mention
 kick
 horizon
 drain
 happiness
 fighter
 estimated
 copper
 legend
 relevance
 decorate
 continental
 ship
 operational
 incur
 parallel
 divorce
 opposed
 equilibrium
 trader
 ton
 can
 juice
 forum
 spin
 research
 hostile
 consistently
 technological
 nightmare
 medal
 diamond
 speed
 peaceful
 accounting
 scatter
 monster
 horrible
 nonsense
 chaos
 accessible
 humanity
 frustration
 chin
 bureau
 advocate
 polytechnic
 inhabitant
 evil
 slave
 reservation
 slam
 handle
 provincial
 fishing
 facilitate
 yield
 elbow
 bye
 warm
 sleeve
 exploration
 creep
 adjacent
 theft
 round
 grace
 predecessor
 supermarket
 smart
 sergeant
 regulate
 clash
 assemble
 arrow
 nowadays
 giant
 waiting
 tap
 shit
 sandwich
 vanish
 commerce
 pursuit
 post
 will
 waste
 collar
 socialism
 skill
 rice
 exclusion
 upwards
 transmission
 instantly
 forthcoming
 appointed
 geographical
 fist
 abstract
 embrace
 dynamic
 drawer
 dismissal
 magic
 endless
 definite
 broadly
 affection
 dawn
 principal
 bloke
 organiser
 trap
 communist
 competence
 complicate
 neutral
 fortunately
 commonwealth
 breakdown
 combined
 candle
 venue
 supper
 analyst
 vague
 publicly
 marine
 fair
 pause
 notable
 freely
 counterpart
 lively
 script
 sue
 legitimate
 geography
 reproduce
 moving
 lamb
 gay
 contemplate
 terror
 stable
 founder
 utility
 signal
 shelter
 poster
 hitherto
 mature
 cooking
 head
 wealthy
 fucking
 confess
 age
 miracle
 magic
 jaw
 pan
 coloured
 tent
 telephone
 reduced
 tumour
 super
 funding
 dump
 stitch
 shared
 ladder
 keeper
 endorse
 invariably
 smash
 shield
 heat
 surgeon
 centre
 orange
 explode
 comedy
 classify
 artistic
 ruler
 biscuit
 workstation
 prey
 manual
 cure
 overall
 tighten
 tax
 pope
 manufacturing
 adult
 rush
 blanket
 republican
 referendum
 palm
 nearby
 mix
 devil
 adoption
 workforce
 segment
 regardless
 contractor
 portion
 differently
 deposit
 cook
 prediction
 oven
 matrix
 liver
 fraud
 beam
 signature
 limb
 verdict
 dramatically
 container
 aunt
 dock
 submission
 arm
 odd
 certainty
 boring
 electron
 drum
 wisdom
 antibody
 unlike
 terrorist
 post
 circulation
 alteration
 fluid
 ambitious
 socially
 riot
 petition
 fox
 recruitment
 well
 top
 service
 flood
 taste
 memorial
 helicopter
 correspondence
 ye
 beef
 overall
 lighting
 harbour
 empirical
 shallow
 seal
 decrease
 constituent
 exam
 toe
 reward
 thrust
 bureaucracy
 wrist
 nut
 plain
 magnetic
 evil
 widen
 hazard
 dispose
 dealing
 absent
 reassure
 model
 inn
 initial
 suspension
 respondent
 over
 naval
 monthly
 log
 advisory
 fitness
 blank
 indirect
 tile
 rally
 economist
 vein
 strand
 disturbance
 stuff
 seldom
 coming
 cab
 grandfather
 flash
 destination
 actively
 regiment
 closed
 boom
 handful
 remarkably
 encouragement
 awkward
 required
 flood
 defect
 surplus
 champagne
 liquid
 shed
 welcome
 rejection
 discipline
 halt
 electronics
 administrator
 sentence
 ill
 contradiction
 nail
 senior
 lacking
 colonial
 primitive
 whoever
 lap
 commodity
 planned
 intellectual
 imprisonment
 coincide
 sympathetic
 atom
 tempt
 sanction
 praise
 favourable
 dissolve
 tightly
 surrounding
 soup
 encounter
 abortion
 grasp
 custody
 composer
 charm
 short
 metropolitan
 waist
 equality
 tribute
 bearing
 auction
 standing
 manufacture
 horn
 barn
 mayor
 emperor
 rescue
 integrated
 conscience
 commence
 grandmother
 discharge
 profound
 takeover
 nationalist
 effect
 dolphin
 fortnight
 elephant
 seal
 spoil
 plea
 forwards
 breeze
 prevention
 mineral
 runner
 pin
 integrity
 thereafter
 quid
 owl
 rigid
 orange
 draft
 reportedly
 hedge
 formulate
 associated
 position
 thief
 tomato
 exhaust
 evidently
 eagle
 specified
 resulting
 blade
 peculiar
 killing
 desktop
 bowel
 long
 ugly
 expedition
 saint
 variable
 supplement
 stamp
 slide
 faction
 enthusiastic
 enquire
 brass
 inequality
 eager
 bold
 neglect
 saying
 ridge
 earl
 yacht
 suck
 missing
 extended
 valuation
 delight
 beat
 worship
 fossil
 diminish
 taxpayer
 corruption
 accurately
 honour
 depict
 pencil
 drown
 stem
 lump
 applicable
 rate
 mobility
 immense
 goodness
 price
 preliminary
 graph
 referee
 calm
 onwards
 omit
 genuinely
 excite
 dreadful
 cave
 revelation
 grief
 erect
 tuck
 meantime
 barrel
 lawn
 hut
 swing
 subject
 ruin
 slice
 transmit
 thigh
 practically
 dedicate
 mistake
 corresponding
 albeit
 sound
 nurse
 discharge
 comparative
 cluster
 propose
 obstacle
 motorway
 heritage
 counselling
 breeding
 characteristic
 bucket
 migration
 campaign
 ritual
 originate
 hunting
 crude
 protocol
 prejudice
 inspiration
 dioxide
 chemical
 uncomfortable
 worthy
 inspect
 summon
 parallel
 outlet
 okay
 collaboration
 booking
 salad
 productive
 charming
 polish
 oak
 access
 tourism
 independently
 cruel
 diversity
 accused
 supplement
 fucking
 forecast
 amend
 soap
 ruling
 interference
 executive
 mining
 minimal
 clarify
 strain
 novel
 try
 coastal
 rising
 quota
 minus
 kilometre
 characterise
 suspicious
 pet
 beneficial
 fling
 deprive
 covenant
 bias
 trophy
 verb
 honestly
 extract
 straw
 stem
 eyebrow
 noble
 mask
 lecturer
 girlfriend
 forehead
 timetable
 symbolic
 farming
 lid
 librarian
 injection
 sexuality
 irrelevant
 bonus
 abuse
 thumb
 survey
 ankle
 psychologist
 occurrence
 profitable
 deliberate
 bow
 tribe
 rightly
 representative
 code
 validity
 marble
 bow
 plunge
 maturity
 hidden
 contrast
 tobacco
 middle
 grip
 clergy
 trading
 passive
 decoration
 racial
 well
 embarrassment
 sauce
 fatal
 banker
 compensate
 make
 seat
 popularity
 interior
 eligible
 continuity
 bunch
 hook
 wicket
 pronounce
 ballet
 heir
 positively
 insufficient
 substitute
 mysterious
 dancer
 trail
 caution
 donation
 added
 weaken
 tyre
 sufferer
 managerial
 elaborate
 restraint
 renew
 gardener
 dilemma
 configuration
 rear
 embark
 misery
 importantly
 continually
 appreciation
 radical
 diverse
 revive
 trip
 lounge
 dwelling
 parental
 loyal
 privatisation
 outsider
 forbid
 yep
 prospective
 manuscript
 inherent
 deem
 telecommunication
 intermediate
 worthwhile
 calendar
 basin
 utterly
 rebuild
 pulse
 suppress
 predator
 width
 stiff
 spine
 betray
 punish
 stall
 lifestyle
 compile
 arouse
 partially
 headline
 divine
 unpleasant
 sacred
 useless
 cool
 tremble
 statue
 obey
 drunk
 tender
 molecular
 circulate
 exploitation
 explicitly
 utterance
 linear
 chat
 revision
 distress
 spill
 steward
 knight
 sum
 semantic
 selective
 learner
 dignity
 senate
 grid
 fiscal
 activate
 rival
 fortunate
 jeans
 select
 fitting
 commentator
 weep
 handicap
 crush
 towel
 stay
 skilled
 repeatedly
 defensive
 calm
 temporarily
 rain
 pin
 villa
 rod
 frontier
 enforcement
 protective
 philosophical
 lordship
 disagree
 boyfriend
 activist
 viewer
 slim
 this
 textile
 mist
 harmony
 deed
 merge
 invention
 commissioner
 caravan
 bolt
 ending
 publishing
 gut
 stamp
 map
 loud
 stroke
 shock
 rug
 picture
 slip
 praise
 fine
 monument
 material
 garment
 toward
 realm
 melt
 reproduction
 reactor
 furious
 distinguished
 characterize
 alike
 pump
 probe
 feedback
 aspiration
 suspect
 solar
 fare
 carve
 qualified
 membrane
 dependence
 convict
 bacteria
 trading
 ambassador
 wound
 drug
 conjunction
 cabin
 trail
 shaft
 treasure
 inappropriate
 half
 attribute
 liquid
 embassy
 terribly
 exemption
 array
 tablet
 sack
 erosion
 bull
 warehouse
 unfortunate
 promoter
 compel
 motivate
 burning
 vitamin
 sail
 lemon
 foreigner
 powder
 persistent
 bat
 ancestor
 predominantly
 mathematical
 compliance
 arch
 woodland
 serum
 overnight
 doubtful
 doing
 coach
 binding
 surrounding
 peer
 ozone
 mid
 invisible
 depart
 brigade
 manipulate
 consume
 temptation
 intact
 glove
 aggression
 emergence
 stag
 coffin
 beautifully
 clutch
 wit
 underline
 trainee
 scrutiny
 neatly
 follower
 sterling
 tariff
 bee
 relaxation
 negligence
 sunlight
 penetrate
 knot
 temper
 skull
 openly
 grind
 whale
 throne
 supervise
 sickness
 package
 intake
 within
 inland
 beast
 rear
 morality
 competent
 sink
 uniform
 reminder
 permanently
 optimistic
 bargain
 seemingly
 respective
 horizontal
 decisive
 bless
 bile
 spatial
 bullet
 respectable
 overseas
 convincing
 unacceptable
 confrontation
 swiftly
 paid
 joke
 instant
 illusion
 cheer
 congregation
 worldwide
 winning
 wake
 toss
 medium
 jewellery
 fond
 alarm
 guerrilla
 dive
 desire
 cooperation
 thread
 prescribe
 calcium
 redundant
 marker
 chemist
 mammal
 legacy
 debtor
 testament
 tragic
 silver
 grin
 spectacle
 inheritance
 heal
 sovereignty
 enzyme
 host
 neighbouring
 corn
 layout
 dictate
 rip
 regain
 probable
 inclusion
 booklet
 bar
 privately
 laser
 fame
 bronze
 mobile
 metaphor
 complication
 narrow
 old
 chop
 synthesis
 diameter
 bomb
 silently
 shed
 fusion
 trigger
 printing
 onion
 dislike
 embody
 curl
 sunshine
 sponsorship
 rage
 loop
 halt
 cop
 bang
 toxic
 thinking
 orientation
 likelihood
 wee
 up
 polite
 apology
 exile
 brow
 miserable
 outbreak
 comparatively
 pump
 fuck
 forecast
 timing
 headmaster
 terrify
 sigh
 premier
 joint
 incredible
 gravity
 regulatory
 cylinder
 curiosity
 resident
 narrative
 cognitive
 lengthy
 gothic
 dip
 adverse
 accountability
 hydrogen
 gravel
 willingness
 inhibit
 attain
 specialise
 steer
 selected
 like
 confer
 usage
 portray
 planner
 manual
 boast
 unconscious
 jail
 fertility
 documentation
 wolf
 patent
 exit
 corps
 proclaim
 multiply
 brochure
 screen
 orthodox
 locomotive
 considering
 unaware
 syndrome
 reform
 confirmation
 printed
 curve
 costly
 underground
 territorial
 designate
 comfort
 plot
 misleading
 weave
 scratch
 echo
 ideally
 endure
 verbal
 stride
 nursing
 exert
 compatible
 causal
 mosaic
 manor
 implicit
 following
 fashionable
 valve
 proceed
 sofa
 snatch
 jazz
 patron
 provider
 interim
 intent
 chosen
 applied
 shiver
 pie
 fury
 abolition
 soccer
 corpse
 accusation
 kind
 dead
 nursing
 contempt
 prevail
 murderer
 liberal
 gathering
 adequately
 subjective
 disagreement
 cleaner
 boil
 static
 scent
 civilian
 monk
 abruptly
 keyboard
 hammer
 despair
 controller
 yell
 entail
 cheerful
 reconstruction
 patience
 legally
 habitat
 queue
 spectator
 given
 purple
 outlook
 genius
 dual
 canvas
 grave
 pepper
 conform
 cautious
 dot
 conspiracy
 butterfly
 sponsor
 sincerely
 rating
 weird
 teenage
 salmon
 recorder
 postpone
 maid
 furnish
 ethical
 bicycle
 sick
 sack
 renaissance
 luxury
 gasp
 wardrobe
 native
 fringe
 adaptation
 quotation
 hunger
 enclose
 disastrous
 choir
 overwhelming
 glimpse
 divorce
 circular
 locality
 ferry
 balcony
 sailor
 precision
 desert
 dancing
 alert
 surrender
 archive
 jump
 philosopher
 revival
 presume
 node
 fantastic
 herb
 assertion
 thorough
 quit
 grim
 fair
 broadcast
 annoy
 divert
 accelerate
 polymer
 sweat
 survivor
 subscription
 repayment
 anonymous
 summarise
 punch
 lodge
 landowner
 ignorance
 discourage
 bride
 likewise
 depressed
 abbey
 quarry
 archbishop
 sock
 large
 glare
 descent
 stumble
 mistress
 empty
 prosperity
 harm
 formulation
 atomic
 agreed
 wicked
 threshold
 lobby
 repay
 varying
 track
 crawl
 tolerate
 salvation
 pudding
 counter
 propaganda
 cage
 broker
 ashamed
 scan
 document
 apparatus
 theology
 analogy
 efficiently
 bitterly
 performer
 individually
 amid
 squadron
 sentiment
 making
 exotic
 dominance
 coherent
 placement
 flick
 colourful
 mercy
 angrily
 amuse
 mainstream
 appraisal
 annually
 torch
 intimate
 gold
 arbitrary
 venture
 preservation
 shy
 disclosure
 lace
 inability
 motif
 listener
 hunt
 delicious
 term
 substitute
 highway
 haul
 dragon
 chair
 accumulate
 unchanged
 sediment
 sample
 exclaim
 fan
 volunteer
 root
 parcel
 psychiatric
 delightful
 confidential
 calorie
 flash
 crowd
 aggregate
 scholarship
 monitor
 disciplinary
 rock
 hatred
 pill
 noisy
 feather
 lexical
 staircase
 autonomous
 viewpoint
 projection
 offensive
 controlled
 flush
 racism
 flourish
 resentment
 pillow
 courtesy
 photography
 monkey
 glorious
 evolutionary
 gradual
 bankruptcy
 sacrifice
 uphold
 sketch
 presidency
 formidable
 differentiate
 continuing
 cart
 stadium
 dense
 catch
 beyond
 immigration
 clarity
 worm
 slot
 rifle
 screw
 harvest
 foster
 academic
 impulse
 guardian
 ambiguity
 triangle
 terminate
 retreat
 pony
 outdoor
 deficiency
 decree
 apologise
 yarn
 staff
 renewal
 rebellion
 incidentally
 flour
 developed
 chorus
 ballot
 appetite
 stain
 notebook
 loudly
 homeless
 census
 bizarre
 striking
 greenhouse
 part
 burial
 embarrassed
 ash
 actress
 cassette
 privacy
 fridge
 feed
 excess
 calf
 associate
 ruin
 jointly
 drill
 photograph
 devoted
 indirectly
 driving
 memorandum
 default
 costume
 variant
 shatter
 methodology
 frame
 allegedly
 swell
 investigator
 imaginative
 bored
 bin
 awake
 recycle
 group
 enjoyment
 contemporary
 texture
 donor
 bacon
 sunny
 stool
 prosecute
 commentary
 bass
 theirs
 sniff
 repetition
 eventual
 credit
 suburb
 organisational
 newcomer
 romance
 film
 experiment
 daylight
 warrant
 fur
 parking
 nuisance
 civilian
 foolish
 bulb
 balloon
 vivid
 surveyor
 spontaneous
 biology
 injunction
 appalling
 amusement
 aesthetic
 vegetation
 stab
 rude
 offset
 thinking
 mainframe
 flock
 amateur
 academy
 shilling
 reluctance
 velocity
 spare
 wartime
 soak
 rib
 mighty
 shocked
 vocational
 spit
 gall
 bowl
 prescription
 fever
 axis
 reservoir
 magnitude
 rape
 cutting
 bracket
 agony
 strive
 strangely
 pledge
 recipient
 moor
 invade
 dairy
 chord
 shrink
 poison
 pillar
 washing
 warrior
 supervisor
 outfit
 innovative
 dressing
 dispute
 jungle
 brewery
 adjective
 straighten
 restrain
 monarchy
 trunk
 herd
 deadline
 tiger
 supporting
 moderate
 kneel
 ego
 sexually
 ministerial
 bitch
 wheat
 stagger
 snake
 ribbon
 mainland
 fisherman
 economically
 unwilling
 nationalism
 knitting
 irony
 handling
 desired
 bomber
 voltage
 unusually
 toast
 feel
 suffering
 polish
 technically
 meaningful
 aloud
 waiter
 tease
 opposite
 goat
 conceptual
 ant
 inflict
 bowler
 roar
 drain
 wrong
 galaxy
 aluminium
 receptor
 preach
 parade
 opposite
 critique
 query
 outset
 integral
 grammatical
 testing
 patrol
 pad
 unreasonable
 sausage
 criminal
 constructive
 worldwide
 highlight
 doll
 frightened
 biography
 vocabulary
 offend
 accumulation
 linen
 fairy
 disco
 hint
 versus
 ray
 pottery
 immune
 retreat
 master
 injured
 holly
 battle
 solidarity
 embarrassing
 cargo
 theorist
 reluctantly
 preferred
 dash
 total
 reconcile
 drill
 credibility
 copyright
 beard
 bang
 vigorous
 vaguely
 punch
 prevalence
 uneasy
 boost
 scrap
 ironically
 fog
 faithful
 bounce
 batch
 smooth
 sleeping
 poorly
 accord
 vice
 duly
 blast
 square
 prohibit
 brake
 asylum
 obscure
 nun
 heap
 smoothly
 rhetoric
 privileged
 liaison
 jockey
 concrete
 allied
 rob
 indulge
 except
 distort
 whatsoever
 viable
 nucleus
 exaggerate
 compact
 nationality
 direct
 cast
 altar
 refuge
 presently
 mandatory
 authorise
 accomplish
 startle
 indigenous
 worse
 retailer
 compound
 admiration
 absurd
 coincidence
 principally
 passport
 depot
 soften
 secretion
 invoke
 dirt
 scared
 mug
 convenience
 calm
 optional
 unsuccessful
 consistency
 umbrella
 solo
 hemisphere
 extreme
 brandy
 belly
 attachment
 wash
 uncover
 treat
 repeated
 pine
 offspring
 communism
 nominate
 soar
 geological
 frog
 donate
 co
 nicely
 innocence
 housewife
 disguise
 demolish
 counsel
 cord
 semi
 reasoning
 litre
 inclined
 evoke
 courtyard
 arena
 simplicity
 inhibition
 frozen
 vacuum
 immigrant
 bet
 revenge
 jail
 helmet
 unclear
 jerk
 disruption
 attainment
 sip
 program
 lunchtime
 cult
 chat
 accord
 supposedly
 offering
 broadcast
 secular
 overwhelm
 momentum
 infinite
 manipulation
 inquest
 decrease
 cellar
 counsellor
 avenue
 rubber
 labourer
 lab
 damn
 comfortably
 tense
 socket
 par
 thrust
 scenario
 frankly
 slap
 recreation
 rank
 spy
 filter
 clearance
 blessing
 embryo
 varied
 predictable
 mutation
 equal
 can
 burst
 retrieve
 elder
 rehearsal
 optical
 hurry
 conflict
 combat
 absorption
 ion
 wrong
 heroin
 bake
 x
 vector
 stolen
 sacrifice
 robbery
 probe
 organizational
 chalk
 bourgeois
 villager
 morale
 express
 climb
 notify
 jam
 bureaucratic
 literacy
 frustrate
 freight
 clearing
 aviation
 legislature
 curiously
 banana
 deploy
 passionate
 monastery
 kettle
 enjoyable
 diagnose
 quantitative
 distortion
 monarch
 kindly
 glow
 acquaintance
 unexpectedly
 handy
 deprivation
 attacker
 assault
 screening
 retired
 quick
 portable
 hostage
 underneath
 jealous
 proportional
 gown
 chimney
 bleak
 seasonal
 plasma
 stunning
 spray
 referral
 promptly
 fluctuation
 decorative
 unrest
 resent
 plaster
 chew
 grouping
 gospel
 distributor
 differentiation
 blonde
 aquarium
 witch
 renewed
 jar
 approved
 advocate
 worrying
 minimise
 footstep
 delete
 underneath
 lone
 level
 exceptionally
 drift
 spider
 hectare
 colonel
 swimming
 realism
 insider
 hobby
 computing
 infrastructure
 co
 burn
 cereal
 fold
 compromise
 boxing
 rear
 lick
 constrain
 clerical
 hire
 contend
 amateur
 instrumental
 terminal
 electorate
 congratulate
 balanced
 manufacturing
 split
 domination
 blink
 bleed
 unlawful
 precedent
 notorious
 indoor
 upgrade
 trench
 therapist
 illuminate
 bargain
 warranty
 scar
 consortium
 anger
 insure
 extensively
 appropriately
 spoon
 sideways
 enhanced
 disrupt
 satisfied
 precaution
 kite
 instant
 gig
 continuously
 consolidate
 fountain
 graduate
 gloom
 bite
 structure
 noun
 nomination
 armchair
 virtual
 unprecedented
 tumble
 ski
 architectural
 violation
 rocket
 inject
 departmental
 row
 luxury
 fax
 deer
 climber
 photographic
 haunt
 fiercely
 dining
 sodium
 gossip
 bundle
 bend
 recruit
 hen
 fragile
 deteriorate
 dependency
 swift
 scramble
 overview
 imprison
 trolley
 rotation
 denial
 boiler
 amp
 trivial
 shout
 overtake
 make
 hunter
 guess
 doubtless
 syllable
 obscure
 mould
 limestone
 leak
 beneficiary
 veteran
 surplus
 manifestation
 vicar
 textbook
 novelist
 halfway
 contractual
 swap
 guild
 ulcer
 slab
 detector
 detection
 cough
 whichever
 spelling
 lender
 glow
 raised
 prolonged
 voucher
 t
 linger
 humble
 honey
 scream
 postcard
 managing
 alien
 trouble
 reverse
 odour
 fundamentally
 discount
 blast
 syntactic
 scrape
 residue
 procession
 pioneer
 intercourse
 deter
 deadly
 complement
 restrictive
 nitrogen
 citizenship
 pedestrian
 detention
 wagon
 microphone
 hastily
 fixture
 choke
 wet
 weed
 programming
 power
 nationally
 dozen
 carrot
 bulletin
 wording
 vicious
 urgency
 spoken
 skeleton
 motorist
 interactive
 compute
 whip
 urgently
 telly
 shrub
 porter
 ethics
 banner
 velvet
 omission
 hook
 gallon
 financially
 superintendent
 plug
 continuation
 reliance
 justified
 fool
 detain
 damaging
 orbit
 mains
 discard
 dine
 compartment
 revised
 privatization
 memorable
 lately
 distributed
 disperse
 blame
 basement
 slump
 puzzle
 monitoring
 talented
 nominal
 mushroom
 instructor
 fork
 board
 want
 disposition
 cemetery
 attempted
 nephew
 magical
 ivory
 hospitality
 besides
 astonishing
 tract
 proprietor
 license
 differential
 affinity
 talking
 royalty
 neglect
 irrespective
 whip
 sticky
 regret
 incapable
 franchise
 dentist
 contrary
 profitability
 enthusiast
 crop
 utter
 pile
 pier
 dome
 bubble
 treasurer
 stocking
 sanctuary
 ascertain
 arc
 quest
 mole
 marathon
 feast
 crouch
 storm
 hardship
 entitlement
 circular
 walking
 strap
 sore
 complementary
 understandable
 noticeable
 mankind
 majesty
 course
 pigeon
 goalkeeper
 ambiguous
 walker
 virgin
 prestige
 preoccupation
 upset
 municipal
 groan
 craftsman
 anticipation
 revise
 knock
 infect
 denounce
 confession
 turkey
 toll
 pal
 transcription
 sulphur
 provisional
 hug
 particular
 intent
 fascinate
 conductor
 feasible
 vacant
 trait
 meadow
 creed
 unfamiliar
 optimism
 wary
 twist
 sweet
 substantive
 excavation
 destiny
 thick
 pasture
 archaeological
 tick
 profit
 pat
 papal
 cultivate
 awake
 trained
 civic
 voyage
 siege
 enormously
 distract
 stroll
 jewel
 immediately
 honourable
 helpless
 hay
 expel
 eternal
 demonstrator
 correction
 civilization
 ample
 retention
 rehabilitation
 premature
 encompass
 distinctly
 diplomat
 articulate
 restricted
 prop
 intensify
 deviation
 contest
 workplace
 lazy
 kidney
 insistence
 whisper
 multimedia
 forestry
 excited
 decay
 screw
 rally
 pest
 invaluable
 homework
 harmful
 bump
 bodily
 grasp
 finished
 facade
 cushion
 conversely
 urge
 tune
 solvent
 slogan
 petty
 perceived
 install
 fuss
 rack
 imminent
 short
 revert
 ram
 contraction
 tread
 supplementary
 ham
 defy
 athlete
 sociological
 physician
 crossing
 bail
 unwanted
 tight
 plausible
 midfield
 alert
 feminine
 drainage
 cruelty
 abnormal
 relate
 poison
 symmetry
 stake
 rotten
 prone
 marsh
 litigation
 curl
 urine
 latin
 hover
 greeting
 chase
 spouse
 produce
 forge
 salon
 handicapped
 sway
 homosexual
 handicap
 colon
 upstairs
 stimulation
 spray
 original
 lay
 garlic
 suitcase
 skipper
 moan
 manpower
 manifest
 incredibly
 historically
 decision
 wildly
 reformer
 quantum
 considering

the  of  and  to  in  I  that  was  his  he  it  with  is  for  as  had  you  not  be  her  on  at  by  which  have  or  from  this  him  but  all  she  they  were  my  are  me  one  their  so  an  said  them  we  who  would  been  will  no  when  there  if  more  out  up  into  do  any  your  what  has  man  could  other  than  our  some  very  time  upon  about  may  its  only  now  like  little  then  can  should  made  did  us  such  a  great  before  must  two  these  see  know  over  much  down  after  first  mr  good  men  

 

own  never  most  old  shall  day  where  those  came  come  himself  way  work  life  without  go  make  well  through  being  long  say  might  how  am  too  even  def  again  many  back  here  think  every  people  went  same  last  thought  away  under  take  found  hand  eyes  still  place  while  just  also  young  yet  though  against  things  get  ever  give  god  years  off  face  nothing  right  once  another  left  part  saw  house  world  head  three  took  new  love  always  mrs  put  night  each  king  between  tell  mind  heart  few  because  thing  whom  far  seemed  looked  called  whole  de  set  both  got  find  

 

done  heard  look  name  days  told  let  lord  country  asked  going  seen  better  p  having  home  knew  side  something  moment  father  among  course  hands  woman  enough  words  mother  soon  full  end  gave  room  almost  small  thou  cannot  water  want  however  light  quite  brought  nor  word  whose  given  door  best  turned  taken  does  use  morning  myself  gutenberg  felt  until  since  power  themselves  used  rather  began  present  voice  others  white  works  less  money  next  poor  death  stood  form  within  together  till  thy  large  matter  kind  often  certain  herself  year  friend  half  order  round  true  anything  keep  sent  wife  means  believe  passed  feet  

 

near  public  state  son  hundred  children  thus  hope  alone  above  case  dear  thee  says  person  high  read  city  already  received  fact  gone  girl  known  hear  times  least  perhaps  sure  indeed  english  open  body  itself  along  land  return  leave  air  nature  answered  either  law  help  lay  point  child  letter  four  wish  fire  cried   women  speak  number  therefore  hour  friends  held  free  war  during  several  business  whether  er  manner  second  reason  replied  united  call  general  why  behind  became  john  become  dead  earth  boy  lost  forth  thousand  looking  i'll  family  soul  feel  coming  england  spirit  question  care  truth  ground  really  rest  mean  


 

different  making  possible  fell  towards  human  kept  short  town  following  need  cause  met  evening  returned  five  strong  able  french  live  lady  subject  sn  answer  sea  fear  understand  hard  terms  doubt  around  ask  arms  turn  sense  seems  black  bring  followed  beautiful  close  dark  hold  character  sort  sight  ten  show  party  fine  ye  ready  story  common  book  electronic  talk  account  mark  interest  written  can't  bed  necessary  age  else  force  idea  longer  art  spoke  across  brother  early  ought  sometimes  line  saying  table  appeared  river  continued  eye  ety  sun  information  later  everything  reached  suddenly  past  hours  strange  deep  change  miles  feeling  act  meet  paid  

 

further  purpose  happy  added  seem  taking  blood  rose  south  beyond  cold  neither  forward  view  i've  position  sound  none  entered  clear  road  late  stand  suppose  la  daughter  real  nearly  mine  laws  knowledge  comes  toward  bad  cut  copy  husband  six  france  living  peace  didn't  low  north  remember  effect  natural  pretty  fall  fair  service  below  except  american  hair  london  laid  pass  led  copyright  doing  army  run  horse  future  opened  pleasure  history  west  pay  red  an'   hath  note  although  wanted  gold  makes  desire  play  master  office  tried  front  big  dr  lived  certainly  wind  receive  attention  government  unto  church  strength  length  company  placed  paper  

 

letters  probably  glad  important  especially  greater  yourself  fellow  bear  opinion  window  ran  faith  ago  agreement  charge  beauty  lips  remained  arm  latter  duty  send  distance  silence  foot  wild  object  die  save  gentleman  trees  green  trouble  smile  books  wrong  various  sleep  persons  blockquote  happened  particular  drew  minutes  hardly  walked  chief  chance  according  beginning  action  deal  loved  visit  thinking  follow  standing  knows  try  presence  heavy  sweet  plain  donations  immediately  wrote  mouth  rich  thoughts  months  u  won't  afraid  paris  single  joy  enemy  broken  unless  states  ship  condition  carry  exclaimed  including  filled  seeing  influence  write  boys  appear  outside  secret  parts  please  appearance  evil  march  george  

 

whatever  slowly  tears  horses  places  caught  stay  instead  struck  blue  york  impossible  period  sister  battle  school  mary  raised  occasion  married  man's  former  food  youth  learned  merely  reach  system  twenty  dinner  quiet  easily  moved  afterwards  giving  walk  stopped  laughed  language  expression  week  hall  danger  property  wonder  usual  figure  born  court  generally  grew  showed  getting  ancient  respect  third  worth  simple  tree  leaving  remain  society  fight  wall  result  heaven  william  started  command  tone  regard  expected  mere  month  beside  silent  perfect  experience  street  writing  goes  circumstances  entirely  fresh  duke  covered  bound  east  wood  stone  quickly  notice  bright  christ  boat  noble  meant  somewhat  sudden  value  

 

c  direction  chair  due  support  tom  date  waiting  christian  village  lives  reading  agree  lines  considered  field  observed  scarcely  wished  wait  greatest  permission  success  piece  british  ex  charles  formed  speaking  trying  conversation  proper  hill  music  opportunity  that's  german  afternoon  cry  cost  allowed  girls  considerable  c  broke  honour  seven  private  sit  news  top  scene  discovered  marriage  step  garden  race  begin  per  individual  sitting  learn  political  difficult  bit  speech  henry  lie  cast  eat  authority  etc  floor  ill  ways  officers  offered  original  happiness  flowers  produced  summer  provide  study  religion  picture  walls  personal  america  watch  pleased  leaves  declared  hot  understood  effort  prepared  escape  attempt  supposed  


 

killed  fast  author  indian  brown  determined  pain  spring  takes  drawn  soldiers  houses  beneath  talking  turning  century  steps  intended  soft  straight  matters  likely  corner  trademark  justice  simply  produce  trust  appears  rome  laugh  forget  europe  passage  eight  closed  ourselves  gives  dress  passing  terrible  required  medium  efforts  sake  breath  wise  ladies  possession  pleasant  perfectly  o'  memory  usually  grave  fixed  modern  spot  troops  rise  break  fifty  island  meeting  camp  nation  existence  reply  i'd  copies  sky  touch  equal  fortune  v  shore  domain  named  situation  looks  promise  orders  degree  middle  winter  plan  spent  allow  pale  conduct  running  religious  surprise  minute  roman  cases  shot  lead  move  names  

 

stop  higher  et  father's  threw  worse  built  spoken  glass  board  vain  affairs  instance  safe  loss  doctor  offer  class  complete  access  lower  wouldn't  repeated  forms  darkness  military  warm  drink  passion  ones  physical  example  ears  questions  start  lying  smiled  keeping  spite  shown  directly  james  hart  serious  hat  dog  silver  sufficient  main  mentioned  servant  pride  crowd  train  wonderful  moral  instant  associated  path  greek  meaning  fit  ordered  lot  he's  proved  obliged  enter  rule  sword  attack  seat  game  health  paragraph  statement  social  refund  sorry  courage  members  grace  official  dream  worthy  rock  jack  provided  special  shook  request  mighty  glance  heads  movement  fee  share  expect  couldn't  dollars  

 

spread  opposite  glory  twelve  space  engaged  peter  wine  ordinary  mountains  taste  iron  isn't  distribute  trade  consider  greatly  accepted  forced  advantage  ideas  decided  using  officer  rate  clothes  sign  feelings  native  promised  judge  difference  working  anxious  marry  captain  finished  extent  watched  curious  foreign  besides  method  excellent  confidence  marked  'em  jesus  exactly  importance  finally  bill  vast  prove  fancy  quick  yes  sought  prevent  neck  hearts  liberty  interesting  sides  legal  gentlemen  dry  serve  aside  pure  concerning  forgotten  lose  powers  possessed  thrown  evidence  distant  michael  progress  similar  narrow  altogether  building  page  particularly  knowing  weeks  settled  holding  mountain  search  sad  sin  lies  proud  pieces  clearly  price  ships  

 

thirty  sick  honest  shut  talked  bank  fate  dropped  judgment  conditions  king's  accept  hills  removed  forest  measure  species  seek  highest  otherwise  stream  honor  carefully  obtained  ear  bread  bottom  additional  presented  aid  fingers  q  remembered  choose  agreed  animal  events  there's  fully  delight  rights  amount  obtain  tax  servants  sons  cross  shoulders  thick  points  stranger  woods  facts  dare  grow  creature  hung  rain  false  tall  gate  nations  created  refused  quietly  surface  freely  holy  streets  blow  july  regarded  fashion  report  coast  daily  file  shoulder  surprised  faces  succeeded  birds  distribution  royal  song  wealth  comfort  failed  freedom  peculiar  anyone  advance  gentle  surely  animals  waited  secure  desired  grass  touched  


 

occupied  draw  stage  portion  expressed  opening  june  spirits  fish  tongue  capital  angry  growing  served  carriage  weather  breast  presently  snow  david  papers  necessity  practice  claim  hast  education  sharp  prince  permitted  group  enemies  robert  played  throughout  pity  expense  yours  million  add  pray  taught  explained  tired  leading  kill  shadow  companion  weight  mass  established  suffered  gray  brave  thin  satisfied  check  virtue  golden  numerous  frequently  famous  telling  powerful  alive  waters  national  weak  divine  material  principal  gathered  suggested  frank  valley  guess  finding  yellow  heat  remains  bent  seized  guard  equally  naturally  box  remarkable  gods  moon  slight  style  pointed  saved  windows  crossed  louis  pounds  ain't  evidently  principle  immediate  

 

willing  consequence  richard  principles  characters  paul  season  remarked  science  tender  worked  grown  whispered  interested  quarter  midst  liked  advanced  apparently  bore  pwh  active  noticed  aware  thomas  uncle  list  dangerous  august  calm  genius  sacred  kingdom  entire  popular  unknown  nice  habit  spanish  familiar  reader  published  direct  handsome  you'll  joined  actually  kings  sd  posted  approach  washington  hearing  needed  increased  walking  twice  throw  intellectual  appointed  wisdom  ceased  truly  numbers  demanded  priest  wounded  sorrow  drive  fault  listened  palace  affair  contact  distinguished  station  beat  distributed  e  listen  italy  fool  becomes  watching  hurt  wants  express  occurred  favour  height  size  edge  subjects  task  follows  interests  nine  sympathy  burst  putting  


 

dressed  lifted  hopes  suffer  noise  smiling  rode  tells  minds  farther  literature  vessel  affection  suffering  proceeded  flesh  advice  grand  carrying  legs  spain  post  collection  empty  rank  storm  god's  imagine  wore  duties  admitted  countries  pocket  arrival  imagination  driven  loud  sentence  lovely  extraordinary  november  december  happen  absence  breakfast  population  thank  rules  inhabitants  series  laughing  address  relief  bird  owner  impression  satisfaction  coat  prepare  relations  shape  birth  rapidly  smoke  january  mother's  machine  content  consideration  accompanied  regular  moving  stands  wholly  teeth  busy  treated  burning  shame  quality  bay  discover  inside  brain  soil  completely  message  ring  resolved  calling  phrase  acts  mention  square  pair  won  title  understanding  sunday  fruit  

 

mad  forces  included  tea  rocks  nearer  slaves  falling  absolutely  slow  bearing  mercy  larger  explain  contain  grief  soldier  wasn't  countenance  previous  explanation  welcome  proposed  prayer  stars  germany  belief  informed  moments  poetry  constant  buy  final  faithful  ride  policy  supper  drawing  excitement  dying  demand  fighting  fields  drove  upper  sum  philip  motion  assistance  forty  april  stones  edward  fees  kindly  dignity  catch  october  seated  knees  amongst  current  sending  parties  objects  gained  bitter  possibly  slave  separate  loose  text  receiving  worst  sold  don  credit  chosen  hoped  printed  terror  features  fond  control  capable  fifteen  doesn't  firm  superior  cruel  spiritual  harry  splendid  proof  pressed  sooner  join  process  crime  dust  

 

instantly  lands  relation  doors  concerned  deeply  practical  colour  sing  destroy  anger  distributing  results  increase  reasons  nose  friendly  entrance  rooms  admit  supply  clean  useful  yesterday  delicate  fail  continue  remove  addressed  choice  huge  needs  wear  blind  unable  cover  double  victory  dozen  constantly  level  india  release  rough  ended  shows  fly  praise  devil  ahead  smith  connected  degrees  gain  addition  committed  chamber  notes  italian  gradually  acquaintance  bought  souls  mission  sacrifice  cities  mistake  exercise  conscience  based  car  buried  theory  commanded  nobody  minister  closely  energy  dick  bare  fought  partly  mistress  hate  arose  playing  color  lake  safety  provisions  description  asleep  centre  faint  thinks  parents  escaped  careful  enjoy  drop  

 

brilliant  brief  bringing  worship  goods  tale  skin  roof  grey  highly  crown  castle  excited  throne  stated  despair  ease  attached  total  kindness  mile  citizens  circle  dull  extreme  clouds  figures  intention  prison  term  assured  hidden  thoroughly  cup  member  civil  apply  labor  everywhere  intelligence  strike  fairly  comply  fellows  haven't  event  gently  connection  protection  conscious  edition  directed  pulled  flight  evident  surrounded  wishes  yards  voices  weary  couple  variety  whilst  volume  details  older  requirements  custom  apart  bow  awful  everybody  labour  asking  lover  showing  introduced  suit  becoming  composed  plans  rendered  pictures  lest  volunteers  singing  eager  precious  paused  require  meat  whenever  milk  dogs  successful  plants  vision  rare  granted  raise  

 

egypt  manners  cousin  you've  development  arthur  obs  cool  trial  learning  approached  bridge  abroad  devoted  paying  literary  writer  fn  israel  disappeared  interrupted  stock  readers  dreadful  female  protect  accustomed  virginia  type  recognized  salt  destroyed  signs  innocent  temper  plenty  pope  avoid  hurried  represented  favor  mental  attitude  returning  admiration  brothers  anxiety  queen  teach  count  curiosity  solemn  causes  vessels  compelled  dance  hotel  wicked  fled  kissed  guns  fill  visible  younger  guide  earnest  actual  companions  prisoner  miserable  lad  harm  views  irish  utterly  ends  shop  stairs  pardon  gay  beg  seldom  kinds  record  fat  sand  violent  branches  inquired  iv  september  worn  ireland  flat  departure  delivered  gift  ruin  skill  cattle  

 

equipment  temple  calls  earlier  license  visited  en  consent  sufficiently  natives  wound  laughter  contained  perceived  scattered  whence  rushed  chiefly  bold  anywhere  witness  foolish  helped  kitchen  sell  anybody  self  extremely  treatment  throat  dreams  patient  speed  growth  quantity  latin  immense  conclusion  computer  affected  severe  excuse  triumph  origin  joseph  slept  eternal  thine  audience  pages  sounds  swift  limited  wings  stepped  services  library  remaining  containing  base  confusion  win  maid  charming  editions  attended  softly  reality  performed  glorious  likewise  site  sail  frightened  acquainted  unhappy  feared  article  prisoners  store  adopted  shalt  remark  cook  thousands  pause  inclined  convinced  band  valuable  hence  desert  effects  kiss  plant  ice  ball  stick  absolute  readily  


 

behold  fierce  argument  observe  blessed  bosom  rage  striking  discovery  creatures  shouted  guilty  related  setting  forgot  punishment  gun  slightly  articles  police  mysterious  extended  confess  shade  murder  emotion  destruction  wondered  increasing  hide  expedition  horror  local  expenses  ignorant  doctrine  generous  range  host  wet  cloud  mystery  ed  waste  changes  possess  consciousness  february  trembling  disease  formerly  spend  production  source  mankind  universal  deck  sees  habits  estate  aunt  reign  humble  compliance  delay  shining  reported  hers  unfortunate  midnight  listening  flower  hero  accomplished  doth  classes  thanks  banks  philosophy  belong  finger  comfortable  market  cap  waves  woman's  glanced  troubled  difficulties  picked  european  purposes  somewhere  delighted  pushed  press  household  fleet  baby  region  


 

lately  uttered  exact  image  ages  murmured  melancholy  suspicion  bowed  refuse  elizabeth  staff  liability  we'll  enjoyed  stretched  gaze  belonged  ashamed  reward  meal  blame  nodded  status  opinions  indicate  poem  savage  arise  voyage  misery  guests  painted  attend  afford  donate  job  proceed  loves  forehead  regret  plainly  risk  ad  lighted  angel  rapid  distinct  doubtless  properly  wit  fame  singular  error  utmost  methods  reputation  appeal  she's  w  strongly  margaret  lack  breaking  dawn  violence  fatal  render  career  design  displayed  gets  commercial  forgive  lights  agreeable  suggestion  utter  sheep  resolution  spare  patience  domestic  concluded  'tis  farm  reference  chinese  exist  corn  approaching  alike  mounted  jane  issue  key  providing  majority  measures  towns  

 

flame  boston  dared  ignorance  reduced  occasionally  y  weakness  furnished  china  priests  flying  cloth  gazed  profit  fourth  bell  hitherto  benefit  movements  eagerly  acted  urged  ascii  disposed  electronically  atmosphere  chapter  begged  helen  hole  invited  borne  departed  catholic  files  reasonable  sugar  replacement  sigh  humanity  thrust  frame  opposition  disk  haste  lonely  artist  knight  quarters  charm  substance  rolled  email  flung  celebrated  division  slavery  verse  decision  probable  painful  governor  forever  turns  branch  ocean  rear  leader  delightful  stared  boats  keen  disposition  senses  occasions  readable  beloved  inches  bones  enthusiasm  materials  luck  derived  managed  community  apparent  preserved  magnificent  hurry  scheme  oil  thence  reaching  dim  wretched  hanging  pipe  useless  nevertheless  

 

print  smooth  solid  pursued  necessarily  build  attempted  centuries  eggs  equivalent  hastily  burned  you'd  recent  oh  travel  cries  noon  crying  generations  located  cabin  announcement  britain  compared  handed  cease  smaller  circumstance  tent  frequent  alarm  nervous  beast  what's  aloud  independent  gates  distinction  essential  observation  stronger  recovered  belonging  loving  masters  writers  cf  permanent  mortal  stern  gratitude  preserve  burden  aspect  millions  merry  knife  dread  clever  applicable  district  shadows  jim  silk  failure  links  cent  sentiment  amid  profits  agent  finds  russia  bade  russian  desperate  union  imagined  contempt  raising  lords  hell  separated  grant  seriously  tribes  hit  enormous  defective  conviction  secured  mixed  insisted  wooden  prefer  prayers  fever  selected  daughters  

 

treat  warning  flew  speaks  developed  impulse  slipped  ours  johnson  mistaken  damages  ambition  resumed  christmas  yield  ideal  schools  confirmed  descended  rush  falls  deny  calculated  correct  perform  hadn't  somehow  accordingly  stayed  acquired  counsel  distress  sins  notion  discussion  constitution  anne  hundreds  instrument  firmly  actions  steady  remarks  empire  elements  idle  pen  entering  online  africa  permit  th'  tide  vol  leaned  college  maintain  sovereign  tail  generation  crowded  fears  nights  limitation  tied  horrible  cat  displaying  port  male  experienced  opposed  treaty  contents  rested  mode  poured  les  occur  seeking  practically  abandoned  reports  eleven  sank  begins  founded  brings  trace  instinct  collected  scotland  characteristic  chose  cheerful  tribe  costs  threatened  arrangement  western  


 

sang  beings  sam  pressure  politics  sorts  shelter  rude  scientific  revealed  winds  riding  scenes  shake  industry  claims  pp  merit  profession  lamp  interview  territory  sleeping  sex  coffee  devotion  thereof  creation  trail  romans  supported  requires  fathers  prospect  obey  alexander  shone  operation  northern  nurse  profound  hungry  scott  sisters  assure  exceedingly  match  wrath  continually  rest  gifts  folly  chain  uniform  debt  teaching  venture  execution  shoes  mood  crew  perceive  accounts  eating  multitude  declare  yard  o'er  astonishment  version  vague  odd  grateful  nearest  infinite  elsewhere  copying  apartment  activity  wives  parted  security  cared  sensible  owing  martin  saturday  cottage  jews  leaning  capacity  joe  settle  referred  francis  holder  involved  sunshine  dutch  council  

 

princes  ate  examination  steel  strangers  beheld  test  noted  slightest  widow  charity  realized  element  shed  errors  communication  reflection  attacked  organization  maintained  restored  folks  concealed  accordance  heavens  star  examined  deeds  wordforms  somebody  incident  oath  guest  bar  row  poverty  bottle  prevented  bless  stir  intense  completed  quarrel  touching  inner  available  fix  resistance  unusual  deed  derive  hollow  suspected  contains  sighed  province  deserted  establishment  vote  muttered  thither  oxford  cavalry  lofty  endure  succeed  leg  bid  alice  hated  civilization  u s  acting  landed  christians  passions  interior  scarce  lightly  disturbed  rev  supreme  hang  notwithstanding  shock  exception  offering  display  strain  drank  confined  o  exhausted  poets  sounded  aim  critical  jerusalem  directions  negro  


 

fearful  standard  studied  bag  n  buildings  consequences  commenced  deeper  repeat  driving  beasts  track  rid  holds  residence  steadily  intimate  drinking  swear  treasure  fun  throwing  apt  enterprise  queer  seed  tower  runs  defend  favourite  desires  heavily  assembled  existed  depends  poems  hesitated  stuff  section  settlement  staring  sole  roads  plate  mexico  overcome  pains  performing  dwell  grounds  taxes  marble  recently  tones  ability  awake  walter  wave  shaking  folk  possibility  butter  fury  marched  moses  writes  issued  sailed  instructions  hatred  pursuit  pull  furniture  additions  hid  rope  vi  adventure  royalty  vanished  arts  elder  signal  wanting  supplied  feast  safely  burn  describe  references  lesson  annual  card  passes  application  intelligent  county  beaten  presents  

 

format  flow  sixty  scale  damage  marks  obtaining  moreover  commerce  startled  southern  consequently  outer  belongs  ben  wrought  average  naked  conducted  rivers  songs  obvious  foundation  concern  ceremony  magic  campaign  hunting  carolina  liberal  whisper  largely  commonly  torn  exists  contributions  hunt  teacher  christianity  lawyer  operations  detail  shortly  caesar  wondering  leaders  blessing  princess  he'd  altar  tenderness  tiny  web  cardinal  sharply  regiment  chest  distinctly  purple  creating  gather  depth  indignation  performance  election  prosperity  gloomy  conception  clerk  decide  drunk  victim  reflected  pour  preceding  individuals  gazing  absurd  lift  gesture  armies  limbs  manage  brethren  hugh  plays  hastened  dragged  motive  whatsoever  pointing  verses  pronounced  exchange  definite  emperor  tendency  remote  finish  flag  

 

boots  enabled  administration  denied  churches  rarely  earnestly  considering  previously  ugly  bears  signed  genuine  harmless  mingled  obedience  walks  training  badly  feed  central  contrast  relieved  romance  mississippi  structure  payment  pace  passages  succession  persuaded  sources  inquiry  inspired  angels  roll  wilt  inch  troubles  perfection  lee  wherever  owe  handle  advantages  trip  shoot  fortunate  newspaper  employment  fitted  refuge  misfortune  providence  owns  cutting  beard  stirred  tear  dan  resist  bob  depths  maiden  determine  commission  merchant  whereas  crossing  independence  lively  breeze  provinces  jean  virtues  conceived  relative  solitary  smell  wandering  thereby  eighteen  locked  provision  courts  eaten  historical  regarding  florence  preferred  pick  ruined  wherein  vanity  condemned  deliver  unexpected  desk  gross  lane  

 

happens  represent  billy  root  holland  mud  respectable  cleared  feels  fruits  testimony  milton  existing  bride  rang  ranks  responsibility  beating  disappointed  suitable  depend  judges  giant  grasp  arrive  simplicity  autumn  absent  legally  veil  gloom  doubtful  suspect  weapons  limits  determination  feeble  prophet  shak  gathering  basis  examine  corrupt  payments  returns  laying  prize  instances  greeks  d  they're  theatre  purchase  comparison  composition  rival  someone  realize  defeat  demands  foe  shared  consists  studies  balance  intercourse  id  forming  slender  coach  criminal  knocked  silly  humour  masses  indifferent  recall  occupation  discourse  keeps  regions  intervals  assist  novel  intellect  leads  hither  tales  sale  revenge  lucy  yonder  resources  jealous  we're  wheel  invitation  narrative  risen  burnt  

 

sentiments  inferior  amusement  marie  flash  recognize  swiftly  portrait  create  summoned  suggest  induced  conflict  fed  curse  disappointment  helpless  preparing  construction  lincoln  zeal  responsible  indicated  groups  positive  germans  attracted  vengeance  fort  club  cure  stout  missed  gracious  include  flood  satisfy  agony  respects  ventured  implied  maria  stupid  seas  spaniards  grain  enjoyment  wearing  indifference  conceal  horizon  pleasures  therein  precisely  canada  day's  assume  registered  estimate  steep  route  gardens  visitor  closer  harmony  non  thunder  wire  graceful  crept  greece  childhood  knee  saddle  supplies  weeping  mostly  paragraphs  unconscious  mutual  scorn  grows  external  agents  software  institutions  losing  universe  clock  attempts  instruction  injury  roots  receipt  jumped  dearest  sore  earliest  finest  enable  

 

discipline  motives  fastened  introduction  converted  wilderness  confused  fancied  offices  slip  revolution  wedding  girl's  farmer  silently  fires  wept  behalf  reckon  responded  uncertain  neglected  stroke  exquisite  engagement  dirty  rolling  platform  messenger  privilege  admirable  offers  mischief  physician  imposed  organized  covering  student  daring  cave  wars  convey  he'll  sincere  tradition  gravely  combined  gallant  sensation  travelling  charges  submit  tragedy  specific  commander  inn  stiff  accompany  score  virgin  farewell  paradise  villages  hunger  trembled  favorite  criticism  proprietary  customs  cotton  ruth  hospital  restrictions  outward  impressed  blows  plains  flashed  rent  prey  owed  longing  musical  satisfactory  ridiculous  sheet  disgrace  colored  shouldn't  originally  samuel  wages  papa  gas  inevitable  extensive  leisure  deadly  chin  claimed  

 

glow  husband's  emotions  adam  jealousy  leaf  publication  englishman  allah  jones  hostile  wandered  railway  translation  procession  betrayed  pound  admired  elected  pierre  sunk  ruins  eastern  roses  citizen  reminded  deceived  tables  beach  starting  funeral  arrested  flour  feature  correspondence  consisted  counted  reserve  proceedings  roar  romantic  twenty five  hut  strangely  absorbed  propose  seats  bark  reception  pleasing  attained  wake  research  prayed  monarch  clothing  dollar  illness  calmly  obeyed  heartily  pressing  daylight  warriors  jest  abruptly  washed  comment  metal  preparations  nerves  solution  pretended  sixteen  assembly  tobacco  entity  dwelling  depart  swung  bitterly  alteration  colony  disclaimers  wing  peaceful  lion  opportunities  alarmed  furnish  resting  accused  culture  writings  dwelt  conquered  trick  trusted  column  financial  

 

cunning  preparation  drama  joke  entertained  mist  hypertext  shell  medicine  proofread  nest  reverence  situated  yielded  conceive  appointment  lessons  fetch  tomb  candle  offence  coarse  heap  mixture  homes  model  men's  defect  destined  occasional  fourteen  hint  knights  solicit  dreamed  objection  craft  acid  namely  asia  neglect  data  weapon  confessed  arrangements  repose  complying  copied  pink  user  heels  grandfather  other's  income  i e  regards  streams  vigorous  accepting  bishop  lightning  authors  flames  observations  compressed  sport  powder  beds  orange  painting  shout  austria  bath  careless  chap  derivative  roused  primitive  doorway  climbed  volumes  vulgar  arguments  st  sunset  convenient  mail  recalled  wrapped  abode  planted  paint  surrender  establish  mild  promptly  appearing  department  parish  stephen  

 

nay  lit  handkerchief  basket  easier  deserve  quit  assurance  mirror  plot  yer  upward  sadly  secretary  adding  modest  dish  cares  straw  net  advised  heavenly  largest  proceeding  impatient  wounds  warmth  certainty  restless  meantime  rays  salvation  lovers  experiment  shores  today  tremendous  afforded  moonlight  intend  california  cultivated  flushed  shakespeare  newspapers  rocky  pious  wont  steam  improvement  garments  ned  treasury  merchants  perpetual  trained  products  affectionate  dispute  visitors  poison  proposition  maybe  rifle  warned  parting  shield  erected  employ  prevailed  talent  rises  climate  chairs  searched  unlike  recover  mate  arrange  fortunes  puzzled  committee  aged  ohio  ashes  ghost  b  promises  bushes  effective  distinguish  manifest  comparatively  esteem  blew  revelation  wash  recognition  confession  clay  

 

nonsense  trunk  management  undoubtedly  dried  dorothy  chiefs  coal  stolen  earthly  restore  indirectly  lasted  selfish  renewed  canoe  protest  vice  races  deemed  temporary  pile  frederick  chapel  moderate  spell  massachusetts  upright  quoted  area  bone  solitude  instruments  formal  students  greatness  struggling  monday  reproach  altered  grim  leaped  venice  federal  questioned  editor  desirable  acknowledge  motionless  remedy  bestowed  pursue  representative  pole  gladly  linen  vital  sink  pacific  hopeless  dangers  gratefully  president  travelled  ward  nephew  ms  cheer  bloody  siege  commands  justified  atlantic  stomach  improved  admire  openly  sailors  abide  advancing  forests  records  polly  recorded  modification  dramatic  statements  upstairs  varied  letting  wilson  comrades  sets  descent  whither  envy  load  pretend  folded  brass  

 

internal  furious  curtain  healthy  obscure  summit  alas  fifth  center  faced  cheap  saints  colonel  egyptian  contest  owned  adventures  exclusion  seize  chances  springs  alter  landing  fence  leagues  glimpse  statue  contract  luxury  artillery  doubts  saving  fro  string  combination  awakened  faded  arrest  protected  temperature  strict  contented  professional  intent  brother's  injured  neighborhood  andrew  abundance  smoking  yourselves  medical  garrison  likes  corps  heroic  inform  wife's  retained  agitation  nobles  prominent  institution  judged  embrace  wheels  closing  damaged  pack  affections  eldest  anguish  surrounding  obviously  strictly  capture  drops  inquire  ample  remainder  justly  recollection  deer  answers  bedroom  purely  bush  plunged  thyself  joint  refer  expecting  madam  railroad  spake  respecting  jan  columns  weep  identify  

 

discharge  bench  ralph  heir  oak  rescue  limit  unpleasant  anxiously  innocence  awoke  expectation  incomplete  program  reserved  secretly  we've  invention  faults  disagreeable  piano  defeated  charms  purse  persuade  deprived  electric  endless  interval  chase  heroes  invisible  well known  occupy  jacob  gown  cruelty  lock  lowest  hesitation  withdrew  proposal  destiny  recognised  commons  foul  loaded  amidst  titles  ancestors  types  commanding  madness  happily  assigned  declined  temptation  lady's  subsequent  jewels  breathed  willingly  youthful  bells  spectacle  uneasy  shine  formidable  stately  machinery  fragments  rushing  attractive  product  economic  sickness  uses  dashed  engine  ashore  dates  theirs  adv  clasped  international  leather  spared  crushed  interfere  subtle  waved  slope  floating  worry  effected  passengers  violently  donation  steamer  witnesses  

 

specified  learnt  stores  designed  guessed  roger  timber  talents  heed  jackson  murdered  vivid  woe  calculate  killing  laura  savages  wasted  trifle  funny  pockets  philosopher  insult  den  representation  incapable  eloquence  dine  temples  ann  sensitive  robin  appetite  wishing  picturesque  douglas  courtesy  flowing  remembrance  lawyers  sphere  murmur  elegant  honourable  stopping  guilt  welfare  avoided  fishing  perish  sober  steal  delicious  infant  lip  norman  offended  dost  memories  wheat  japanese  humor  exhibited  encounter  footsteps  marquis  smiles  amiable  twilight  arrows  consisting  park  retire  economy  sufferings  secrets  na  halted  govern  favourable  colors  translated  stretch  formation  immortal  gallery  parallel  lean  tempted  frontier  continent  knock  impatience  unity  dealing  prohibition  decent  fiery  images  tie  

 

punished  submitted  julia  albert  rejoined  speedily  consented  major  preliminary  cell  void  placing  prudence  egg  amazement  border  artificial  hereafter  fanny  crimes  breathe  exempt  anchor  chicago  sits  purchased  eminent  neighbors  glowing  sunlight  examples  exercised  wealthy  seeming  bonaparte  shouting  thanked  illustrious  curiously  inspiration  seeds  naval  foes  everyone  longed  abundant  doubted  painter  greeted  erect  glasses  meanwhile  shooting  athens  wagon  lend  lent  crisis  undertake  particulars  eh  veins  polite  anna  experiences  seal  header  clergy  mount  array  corners  magazine  loudly  bitterness  texas  guardian  searching  rejected  harsh  includes  boldly  maurice  kate  lunch  pine  shells  seconds  despite  hoping  injustice  expressions  flies  push  tight  problems  landscape  sue  protested  scarlet  abandon  


 

artistic  mainly  measured  loyal  boiling  desirous  suited  alliance  advise  waist  sinking  apprehension  stable  gregory  maximum  commit  hideous  hamilton  sweetness  dismissed  tore  affect  shaken  evils  unworthy  significance  modified  miracle  lieu  peasant  considerably  observing  conveyed  resemblance  extend  riches  personally  morality  rebellion  thread  dumb  inclination  forbidden  copper  differences  sailor  requested  alfred  response  promoting  imperial  blank  purity  victor  bending  solemnly  twenty four  minor  del  crimson  republic  teachers  ma'am  danced  bargain  dealt  fatigue  telephone  cents  whip  adams  dislike  witnessed  infantry  acres  checked  countrymen  enemy's  companies  normal  shirt  addresses  introduce  sofa  mothers  sweep  conversion  sketch  african  deserved  answering  virtuous  persian  anyway  thief  driver  retain  constructed  daniel  ut  

 

philadelphia  conspicuous  channel  nobility  edith  berlin  editing  cambridge  declaration  guards  personality  smallest  excess  separation  disgust  ha  accomplish  speeches  herbert  convent  rightly  suspended  reform  mob  thirst  unnecessary  treasures  asks  viewed  designs  gleam  threatening  palm  missouri  filling  quoth  fur  fortnight  holes  addressing  frightful  encourage  speaker  tribute  procure  frankly  recommended  relieve  intentions  unjust  legislation  project  threshold  merits  morrow  traces  induce  spear  inward  pupils  corresponding  fairy  conclude  clung  neat  lucky  lap  session  torture  damp  ridge  spoil  liable  swords  hearty  bc  abraham  thoughtful  traveller  chains  favorable  tin  imp  strongest  horace  dependent  couch  bills  warrant  complaint  endeavour  sails  dined  convention  guarded  angle  widely  illinois  charlotte  endeavoured  


 

ardent  cow  mill  victims  prejudice  foremost  map  probability  porch  lieutenant  surprising  fountain  sustained  appropriate  ford  clara  assisted  lewis  rejoice  extending  marvellous  clothed  jew  collar  bands  confident  hasty  nigh  organ  prose  privileges  selection  inquiries  codes  replace  saint  districts  deliberately  awe  beforehand  strife  released  compare  beer  retorted  relate  cheerfully  pistol  presume  velvet  wretch  susan  pennsylvania  stirring  righteousness  missing  fain  facing  fashionable  producing  peoples  positively  reasoning  gravity  disturb  sermon  exchanged  partner  brains  lowered  association  estates  abuse  flock  niece  languages  asserted  bodily  notions  oliver  faculty  cannon  thirteen  sailing  rings  smart  possessions  disciples  petty  widest  divisions  prudent  caution  justify  awhile  boxes  manuscript  cigar  warrior  impressions  

 

aught  lifting  inaccurate  tidings  friday  liquid  staying  concept  creek  lo  brush  download  specially  cream  meetings  jump  unwilling  adapted  practised  combat  subdued  jewish  innumerable  blowing  extra  civilized  invented  japan  pitch  cliff  crowned  portions  awkward  horrid  pulling  appreciate  communicated  kentucky  jury  encountered  attacks  monster  simon  maintaining  sites  frozen  invariably  dies  survive  literally  consolation  m  phenomena  pot  ellen  briefly  rice  planned  barbara  respected  sublime  dropping  guy  behaviour  desolate  penny  adopt  replaced  revenue  formats  hired  regularly  infringement  curtains  eagerness  helping  investigation  constitutional  insist  occurs  fools  inheritance  latest  leap  games  apple  visiting  travellers  experiments  hasn't  pupil  enjoying  totally  twisted  discuss  firing  background  subscribe  tenderly  transcribe  

 

descend  differ  majesty's  avail  disaster  bet  periodic  bull  entertainment  computers  cursed  raw  fulfilled  georgia  virus  log  skies  scotch  embraced  hospitality  faintly  solomon  robbed  cart  influences  ascended  incidents  childish  robe  aboard  resembling  reflect  dominion  dreary  serving  complexion  engage  tents  herd  attain  collect  disclaims  pan  relatives  borrowed  convert  outline  blown  comprehend  peasants  opera  assault  deceive  doctrines  representatives  dedicated  struggled  officials  hiding  paths  backs  prominently  prices  procured  mourning  compliment  heights  approval  gasped  breadth  withdraw  tune  compassion  polished  latitude  dishes  parent  contrived  delicacy  projected  akin  f  betray  traced  resentment  indemnify  pseud  sacrifices  disguise  transcription  document  neighbour  squire  punish  bars  glittering  tossed  block  lots  worldly  

 

muscles  elbow  obligation  trifling  decline  attachment  ambitious  filename  artists  bloom  holiday  brute  repair  fist  recollect  eagle  honorable  significant  barren  functions  guided  dense  fiction  viz  adds  rows  recommend  suspicious  resulting  seventy  shillings  educational  duly  governed  scripture  upwards  sworn  nicholas  horn  brook  fund  vienna  lodge  infinitely  clergyman  marshal  ruled  fiercely  portuguese  costume  pit  disorder  sheer  exalted  fare  applause  chaucer  remind  binary  packed  pillow  jersey  abbey  nowhere  anyhow  agitated  marching  catching  el  grasped  arrow  tend  carved  fitting  bonds  instructed  elaborate  corpse  bewildered  essence  positions  emily  edited  continues  harold  elevation  realm  debts  glancing  shops  complained  loyalty  coin  clad  staircase  documents  interpreted  th  extremity  accord  

 

sally  lace  tremble  exile  gospel  mechanical  successfully  scholar  wonders  arab  temperament  expressing  fred  trap  spots  awaiting  potatoes  likeness  harbour  proofs  jolly  contributed  wits  generosity  ruler  lawrence  cake  lamps  crazy  sincerity  entertain  madame  sir  faculties  hesitate  deepest  seventeen  lordship  greeting  feminine  monstrous  tongues  barely  d  mansion  facility  praised  warranties  sarah  happier  indicating  rob  gigantic  honey  ladder  ending  wales  swallowed  sunny  knelt  tyranny  decree  stake  divide  dreaming  proclaimed  dignified  tread  mines  viewing  defense  oldest  incredible  bidding  brick  arch  everlasting  elect  sprung  harder  winding  deductible  magistrate  respective  liquor  imitation  shy  perished  prime  studying  eighty  hebrew  unfortunately  licensed  fog  coloured  bits  consult  moves  r  


 

warn  taylor  vile  depended  phil  legend  locations  shallow  doom  dreaded  encouragement  impatiently  scent  varieties  irregular  battles  compass  neighbouring  bliss  harvest  promotion  stove  faithfully  anthony  excellence  transfer  awaited  heathen  poetic  consulted  illustrated  gilbert  br  fundamental  bundle  rebel  cultivation  joys  rigid  tragic  review  representing  flowed  brows  whereupon  terribly  melted  venerable  towers  cooking  mustn't  suspicions  old fashioned  oppressed  australia  friend's  revolt  swell  improve  williams  describes  goddess  wreck  tennessee  convince  sentences  bowl  radiant  prussia  westward  indignant  refined  unseen  illustration  pertaining  swamp  austrian  saxon  congregation  nerve  undertaking  disclaimer  characteristics  stare  specimens  ascertain  pledge  earn  warfare  supposing  subsequently  attending  angrily  select  animated  industrial  hurriedly  manhood  quantities  interpretation  

 

dressing  rejoiced  edinburgh  catherine  challenge  produces  forbid  gang  boiled  shouts  so called  theme  thankful  admission  enters  elevated  frenchman  pool  terrified  lads  persisted  conference  equality  genus  didst  newly  generals  surroundings  sorrows  occasioned  invasion  workmen  monks  sends  turkish  discretion  pattern  reveal  endured  resolve  columbia  preach  exceeding  ringing  triumphant  defiance  errand  woke  grandmother  weighed  wool  orleans  communicate  strikes  promising  scenery  righteous  essentially  oppose  joyous  specimen  doctors  eloquent  manager  organs  sticks  drag  haunted  chorus  rational  crop  processing  accurate  wolf  adorned  sheets  resort  refusal  bond  vicinity  preacher  sympathetic  casting  opens  prophets  horns  warmly  salary  continuous  satan  continual  defended  breaks  workers  lantern  balls  rod  blaze  examining  naples  

 

peculiarly  vegetables  ingenious  excite  howard  horseback  re use  louisiana  farmers  wildly  mouths  carpet  sadness  customary  circles  aren't  wonderfully  max  juan  successor  allied  ceiling  confirmation  glances  diamonds  goal  representations  cash  vacant  antiquity  despise  lawn  they'll  appealed  turkey  texts  neighbor  spreading  discharged  phrases  ultimate  tastes  submission  entry  rachel  blush  monument  hardy  thorough  ein  ecclesiastical  fertile  exciting  captive  severity  considerations  shew  faster  louise  grandeur  winning  solely  globe  malice  echoed  lodging  conservative  throng  prosperous  whistle  floated  transferred  declaring  reckoned  cheese  bite  thoughtfully  breach  enthusiastic  cars  downstairs  allowing  invite  adjoining  dusk  cathedral  truths  plague  sandy  boil  caroline  beautifully  inhabited  tomorrow  exclamation  finishing  shocked  escort  forgetting  hanged  

 

hats  mirth  uncomfortable  connecticut  bows  pierced  harbor  tricks  rubbed  apparatus  mysteries  honesty  negroes  concerns  wander  assert  ceremonies  sacrificed  utterance  dismay  fright  rail  reflections  crops  pushing  proves  jimmy  pathetic  imperfect  haughty  navy  fortress  hurrying  x  blessings  attempting  insects  selling  appreciation  suppressed  acquire  offensive  ripe  dresses  reigned  coldly  candles  km  sixth  blazing  youngest  mask  florida  lecture  parlor  decidedly  whereby  gordon  reverend  successive  perception  buffalo  sire  quitted  keys  develop  function  morals  damned  vexed  d  pouring  bullet  excessive  bind  identical  cliffs  tools  byron  mexican  piety  superstition  git  substantial  bulk  prevail  wiser  preaching  prolonged  annoyed  westminster  splendour  remembering  richmond  upset  cab  bunch  pencil  subjected  vegetable  

 

exhibit  emerged  cooked  hay  kansas  gale  preached  arnold  trousers  debate  dated  tumult  corruption  summons  comrade  eternity  hears  lingered  propriety  stillness  partial  welcomed  cabinet  proceeds  vow  quaint  soup  beef  rests  slay  surgeon  irresistible  sealed  repeating  needn't  allowance  undertaken  treachery  posts  borders  attendant  unite  murderer  owners  nm  sweeping  unconsciously  blade  saviour  theories  graham  behaved  pleaded  spy  possesses  lawful  tommy  seasons  withdrawn  reckless  factory  shades  gossip  seventh  attendance  robes  journal  systems  dryden  maine  token  intimacy  abstract  machines  bestow  chanced  locks  honestly  legitimate  accent  symptoms  votes  ragged  thursday  manifested  fidelity  swinging  descending  sincerely  bred  whereof  indies  novels  league  failing  succeeding  santa  approve  cautiously  miller  


 

afflicted  lodgings  petition  traffic  sparkling  limb  architecture  disposal  carriages  crack  kindred  naught  ornament  slew  steward  fantastic  evolution  patiently  reverse  survey  dug  amuse  stretching  isaac  forthwith  contemporary  foliage  receives  scandal  donors  deliberate  influenced  intolerable  hearth  symbol  governments  repaired  pleasantly  homage  victorious  columbus  recovery  defined  attendants  modesty  diana  washing  pavement  unnatural  decisive  wisely  precise  negative  occurrence  snatched  shaft  linked  festival  exclusively  jove  wickedness  visions  maggie  rosy  carelessly  stem  corporation  dec  feeding  allen  cows  schemes  preference  urge  husbands  labours  shrill  exercises  sovereignty  reduce  distressed  clearing  removal  dean  scottish  assertion  accessible  comedy  flush  code  philosophers  adequate  vaguely  treason  hunter  chambers  split  yielding  newsletter  snake  

 

pub  historian  ass  intensity  democracy  battery  draws  netherlands  creed  liking  luke  tyrant  strove  attraction  slaughter  dismal  deposited  assent  cups  concert  downward  canal  evenings  wax  detective  fancies  spoiled  revolver  murray  earned  analysis  finer  paces  roaring  prompt  paperwork  wherefore  emphasis  sharing  delayed  inherited  bronze  waking  garment  redistributing  wholesome  remorse  plato  morris  stooped  dew  monk  thrill  hue  exclusive  funds  porter  uncommon  dash  strained  confounded  swim  strip  middle aged  ultimately  team  missionary  esteemed  tracks  envelope  whoever  expensive  headquarters  cherished  brandy  startling  homer  talks  acute  cigarette  motor  embarrassed  janet  volunteer  offspring  network  reaches  indispensable  plane  reaction  regiments  g  sums  partially  prejudices  proudly  baggage  terrace  deaf  allusion  

 

grip  juice  isabel  resigned  humility  benjamin  blast  ministry  sexual  nile  diameter  troop  onward  crowds  marrying  tightly  sullen  brutal  axe  holmes  penalty  tops  diamond  boards  corridor  endowed  strengthened  cells  proportions  alternate  echo  restraint  trials  reads  identity  headed  softened  quivering  stages  sway  poetical  objected  screen  professed  dirt  ascertained  era  wider  ambassador  constituted  breed  interference  eyebrows  shapes  afar  consist  acceptance  displays  flashing  hunted  beauties  lazy  shrewd  extravagant  momentary  cordial  engineer  rapidity  nov  halt  alternative  devils  stamp  compact  whites  breathless  encoding  drift  disappear  roared  revived  counter  venus  imaginary  diminished  honoured  th  despatched  objections  ray  climbing  attract  astonishing  competition  suggestions  ink  oft  crystal  shower  diseases  

 

ferdinand  obedient  draught  wondrous  await  armour  massive  bottles  kin  cellar  falsehood  pillars  edgar  philosophical  martha  worlds  memorable  jacques  detected  stealing  noisy  henceforth  cicero  laden  frost  device  glare  touches  senate  lasting  communion  transport  constantinople  coffin  eventually  johnny  enclosed  forgiveness  awfully  clinging  darkened  contemplation  termed  manufacture  swallow  commonplace  nancy  resembled  she'd  labors  contracted  inscription  comfortably  indulge  indulgence  bravely  kneeling  yea  keenly  exhibition  agricultural  enlightened  quest  compliments  crest  extension  uneasiness  constitute  inflicted  lakes  swing  meadow  noblest  downloading  complex  controversy  freed  resignation  tempest  guidance  prospects  humbly  lined  serene  shrugged  honours  roughly  checks  remarkably  dainty  overhead  commencement  singularly  brightness  oppression  repeatedly  conspiracy  restrain  splendor  preservation  

 

pub  pepper  basin  creeping  matthew  publicly  percy  continuing  grove  calamity  pony  vigour  melody  profitable  descendants  hire  speculation  discoveries  accepts  drunken  candidate  principally  worried  obstinate  hasten  foreigners  elderly  overwhelmed  instincts  telegraph  russell  university  ghastly  patron  varying  barbarous  celestial  t'  patriotism  modify  earnestness  exertion  fox  refusing  horsemen  inspection  stations  grieved  louder  bursting  regretted  mournful  pursuing  traitor  associations  cautious  foundations  stamped  prior  undertook  telegram  beggar  chimney  complicated  davis  striving  magistrates  converse  graces  wiped  oars  apology  scared  imprisonment  eastward  substitute  yahweh  handful  usage  lodged  of  villain  banished  restoration  serpent  hedge  k  jurisdiction  captains  settlers  gaining  valiant  primary  storms  beam  victoria  tour  prophecy  spectacles  obsolete  

 

buying  shepherd  wells  harriet  exaggerated  heated  penetrated  travels  earl  hereditary  ali  supernatural  competent  piled  hostess  agriculture  boughs  urgent  gratified  suffice  ports  drifted  accuracy  deceased  circular  securing  possibilities  rhine  alert  neighboring  democratic  quebec  bud  accounted  aided  augustus  blanket  hail  pretence  beams  andy  pig  shaped  oven  rounded  ivory  northward  isolated  policeman  aug  conventional  babylon  dusty  bishops  complaints  stripped  plead  hinder  vo  cord  flows  personage  classical  alongside  wrongs  extract  rewarded  lungs  lighter  kisses  serves  pint  forgiven  sternly  proclamation  realised  pipes  arising  pitched  tube  observer  smote  avenue  elephant  burke  footing  statesman  rebels  nails  wears  doomed  edges  esther  indiana  affecting  stormy  bee  bury  efficient  mix  

 

supporting  actor  disturbance  sweat  executive  seemingly  tenth  blossoms  ethel  folds  painfully  polish  shudder  oe  roofs  comparative  begging  imposing  notable  invested  imprisoned  mute  amy  cage  esq  pg  cured  cargo  prof  negotiations  assented  jail  skilful  ideals  conferred  resulted  illusion  torment  troublesome  crowns  feb  repentance  blankets  proprietor  uncertainty  concentrated  mediterranean  covers  scream  compromise  respectful  chariot  ammunition  bonnet  secondary  persia  persecution  lesser  assistant  saluted  fits  indulged  springing  cane  fold  boundary  valued  she'll  rugged  aloft  thieves  parlour  indebted  tons  processes  dave  moore  argue  dearly  logic  panic  restrained  lb  vainly  weariness  enlarged  franklin  tasted  rural  torrent  resolute  refrain  kissing  gorgeous  meets  circulation  passionately  inasmuch  unexpectedly  stress  


 

consumption  groan  suits  sustain  hosts  crash  resemble  epoch  quote  lacking  nominally  choked  aristocracy  granite  gradual  delights  hurled  joyful  sack  slumber  detached  snapped  shadowy  accompanying  annoyance  crush  needle  repent  phenomenon  execute  canst  smoked  greet  monarchy  behave  richly  controlled  strive  endeavor  barrier  canadian  curve  politeness  flora  rely  flank  convenience  courteous  logs  lamb  effectually  robinson  logical  shan't  dimly  withered  diet  praises  fulfil  mantle  ne'er  discussing  chicken  judicial  consistent  ridicule  as  reins  barrel  distrust  trunks  verily  hunters  feather  desperately  goodly  habitual  voluntary  luncheon  eighteenth  exertions  expert  coolly  mistakes  tedious  contemplated  clark  jacket  gleaming  shrank  swimming  kent  perplexed  impressive  universally  displeasure  maids  rates  underneath  expedient  

 

emma  impress  bees  bounded  worshipped  resisted  provincial  popularity  baker  shattered  merciful  olive  tramp  compensation  ernest  martial  genial  syria  conjecture  van  waiter  detained  items  promote  delaware  covenant  nought  interposed  seizing  sinner  vigor  devote  decorated  sentimental  yoke  properties  warlike  perilous  threats  kindled  lays  hostility  dragging  mare  regulations  obstacle  sage  destitute  pays  sleepy  dublin  jonathan  posterity  they'd  nod  mason  patriotic  plantation  pitiful  foster  requisite  expose  oxen  patch  anderson  stuart  interruption  lance  payable  definition  birthday  thumb  wolves  hammer  overwhelming  intensely  revolutionary  fragrant  bleeding  sheltered  circuit  dominions  sales  energetic  insignificant  repetition  we'd  amazing  trains  skirts  tip  trivial  kick  tended  rejoicing  dig  pet  skull  lectures  ness  

 

threat  legislature  plunder  removing  jungle  ghosts  numbered  famine  palaces  sorrowful  improvements  coleridge  fuller  asp  blocks  darted  shrine  heel  typical  throws  fortunately  recognise  fuel  th  tranquil  frown  destination  plunge  moor  pin  mars  associate  here's  owen  th  arabic  vicious  framed  banquet  expressive  instinctively  lighting  scanning  subordinate  jaws  patent  courtyard  gulf  destroying  detailed  regulating  closet  compel  inland  excepting  pretext  legislative  stationed  rash  margin  champion  settling  billion  shorter  betwixt  admiring  morgan  nick  chemical  chapters  worthless  aristocratic  nan  especial  hon  attentive  maintenance  charlie  explanatory  differently  furiously  pulse  scanty  flee  admiral  clause  resume  compound  pilot  growled  charmed  imitate  happening  knot  rags  mock  majestic  messages  prussian  suspense  


 

clare  relationship  skirt  agency  arisen  grin  unusually  michigan  hoarse  mills  intently  dining  demonstration  depression  lain  expectations  joining  weekly  trenches  technical  vehicle  aimed  borrow  flattering  portugal  prodigious  scope  vegetation  switzerland  arkansas  swelling  fortified  favoured  salute  topic  blushed  superb  strengthen  confidential  crow  shawl  sunrise  sings  coats  sturdy  dissolved  lifetime  dispersed  sergeant  contribute  strode  brigade  verdict  they've  honors  panting  females  richest  attribute  brighter  hook  discontent  orderly  airs  tiger  messengers  penetrate  sabbath  identification  holiness  crooked  housekeeper  productions  prescribed  rector  spark  sleeve  honored  tame  highway  alabama  edmund  militia  nobleman  energies  spacious  tearing  affliction  photograph  ally  hampshire  ascent  ditch  fishes  jupiter  rubbing  tract  standards  afore  ribbon  

 

cecilia  oregon  integrity  plus  transparent  farms  pulpit  ropes  nineteen  rescued  counting  perfume  socrates  hounds  solicited  bother  fascinating  qualified  desolation  essay  rains  renew  odious  assuredly  suggests  rider  loneliness  pond  activities  dazzling  leaping  squadron  bowing  novelty  wrist  keeper  homeward  alexandria  finely  li  efficiency  marvel  tranquillity  agnes  charities  spenser  condemn  elephants  elders  julian  tries  nd  sweetly  endurance  bags  reared  jaw  unique  navigation  inevitably  admirably  sect  drum  poles  verge  piercing  sanction  russians  forlorn  approbation  organic  stanley  allegiance  bin  expressly  ingenuity  dispose  stained  theology  withal  duration  fundraising  adj  collecting  weigh  sweetest  float  consul  monastery  raging  publish  knocking  precaution  privately  aaron  endeavored  insight  definitely  stature  troy  

 

miriam  judah  oblige  urging  shift  mould  courses  countless  associates  hymn  rapture  tonight  trumpet  parker  entrusted  firmness  comic  breeding  ken  questioning  factor  monuments  loveliness  handled  communities  saloon  stumbled  witch  confronted  traveling  seamen  backed  profoundly  gladness  pomp  mess  practise  sanctuary  superstitious  casual  iowa  analyzed  historic  bored  shrink  judging  treating  expenditure  encouraging  diplomatic  forcing  studio  exposure  crude  compilation  vermont  eve  ascend  unbroken  apollo  countess  binding  exceed  frail  hans  champagne  shuddered  carter  mule  inserted  parson  rascal  inspire  banner  divorce  treacherous  nineteenth  invalid  weaker  organizations  bolt  ticket  backwards  captivity  lame  provoked  vein  lists  gallop  communications  dagger  passive  shoe  thrice  corrected  mystic  infancy  foam  keith  tavern  

 

fraud  th  cradle  rifles  vigorously  censure  gentleness  jr  sobbing  monotonous  explosion  catastrophe  respectfully  wearied  cats  blamed  needful  fireplace  gravel  affords  discovering  jar  selfishness  tolerably  clerks  ark  moist  wid  sauce  prompted  exceptions  bullets  writ  bruce  insolent  moisture  thompson  furnace  healing  fewer  deem  apron  humiliation  punctuation  rolls  doe  rotten  richer  swiss  behavior  nowadays  pamphlet  loan  beads  divers  unreasonable  realise  lust  ah  annually  detach  gaily  shares  gifted  planet  feverish  resurrection  saul  consecrated  enforced  vincent  shelf  fan  fluid  brightly  damsel  gabriel  kid  frantic  neatly  anon  ascribed  insane  tropical  th  milan  hardened  overthrow  phase  achievement  immortality  obscurity  assumption  discern  hopeful  humorous  composure  turf  poland  dame  


 

missionaries  orator  perpetually  arbitrary  ecstasy  retirement  pronounce  authorized  familiarity  nl  hastings  clubs  reconciled  grievous  mercury  elegance  chivalry  luminous  beseech  benevolent  confided  dances  perplexity  escaping  terrific  companionship  commence  daisy  parliament  th  creep  pleading  disdain  pm  sympathies  guides  emergency  parcel  suicide  replies  drawer  contribution  supposition  vii  weren't  link  homely  pluck  ruling  patrick  statesmen  hannah  printing  joshua  synonymous  sinister  advocate  destructive  environment  blossom  bridle  yon  waistcoat  extends  confirm  listing  solemnity  projects  reporter  deprive  detachment  infernal  traversed  moss  skilled  announce  hateful  fugitive  gothic  coolness  insurrection  cum  med  coachman  expend  stepping  julius  resign  despatch  excluded  reject  tough  plea  roy  fragment  lacked  wordsworth  balcony  darker  mac  

 

nevada  christopher  fork  flatter  iniquity  meditation  disastrous  stain  patches  hints  ordained  drinks  whipped  burial  matt  employee  employer  hypothesis  steed  width  sweden  transaction  victories  devout  outrage  vary  attorney  rouse  doubled  sidney  schooner  flaming  offend  sheriff  encamped  magnificence  vent  politely  vines  flags  italians  necessities  austin  nobler  accusation  impulses  packet  shabby  irritated  dakota  industrious  classic  ranch  ascending  cruelly  happiest  antonio  accuse  insulted  bridges  players  sixteenth  solicitation  embarked  idol  odds  aims  illuminated  enchanted  adversary  pie  reflecting  pension  luxurious  pigs  choir  tumbled  conqueror  irritation  verb  monkey  acceptable  dynasty  accurately  divinity  signature  heretofore  hazard  dora  sq  stead  attire  fling  marine  occupations  soothing  devised  singer  spaces  emerson  

 

disguised  antique  orthodox  poisoned  dove  gratification  sydney  electricity  alien  sorely  cracked  supremacy  summon  depressed  sexes  offerings  pledged  irony  recourse  tortured  thickly  correspondent  sounding   sombre  brushed  reasonably  th  duel  reluctantly  implies  cable  ridden  acre  grieve  inquiring  colonists  addison  republican  illustrate  tim  liverpool  gilded  clumsy  satin  displeased  odor  clearer  prairie  hudson  feudal  flint  easter  freshness  nursery  explanations  adoption  reluctance  crosses  blushing  imported  notorious  equipped  sinful  starving  eugene  bedside  sovereigns  abrupt  excused  injure  incessant  correctly  drooping  adored  embroidered  pasture  pillar  import  founder  torch  vault  worm  ay  bravery  confinement  trusting  butler  rattle  transported  estimation  edit  gotten  cuts  headlong  outfit  insolence  secrecy  thereupon  unlucky  

 

eighth  valour  grammar  relaxed  mentions  adjacent  knives  attacking  exceptional  recollections  deposit  establishing  muddy  arches  aspects  senior  fragrance  colonial  penetrating  refinement  te  yacht  intelligible  stray  forcibly  jenny  superficial  tends  identified  wan  choosing  frighten  grotesque  reprinted  tutor  contributing  welsh  gaiety  besieged  robbery  transmitted  swam  consequential  slid  stony  donald  gratify  heavier  confidently  mabel  demon  treatise  mechanically  batteries  trading  cock  pilgrimage  extinct  idleness  sicily  merrily  excursion  handling  utah  eminence  lump  boyhood  montana  superfluous  wee  dome  shivering  accidental  thickness  darwin  continuance  fixing  harris  rustic  cheered  vernon  premises  delivery  nodding  snowy  curved  productive  discouraged  variations  shilling  swollen  miraculous  stubborn  belgium  drives  jerome  orchard  persuasion  invaded  alps  

 

ungrateful  insensible  muscle  madrid  flanders  cultivate  involuntarily  speedy  variation  marian  harp  peaks  daybreak  magnitude  precautions  rub  requiring  coral  grapes  fairest  locality  opponent  bondage  beans  cowardly  grandson  leo  gertrude  nail  protecting  hospitable  proving  benevolence  brussels  civilisation  mounting  desiring  rushes  precision  watchful  harness  perchance  forbade  channels  indication  zealous  tact  seventeenth  theodore  stating  toast  dreadfully  judith  asterisk  virgil  edifice  swelled  accomplishment  sundry  reckoning  mouse  prostrate  helm  slim  whistling  syllable  handwriting  commissioners  lime  spur  unfit  gen  relish  reduction  sown  venetian  cordially  hush  breasts  slipping  pat  arabian  dialogue  forwards  entreat  fascination  belly  neutral  grasping  diligence  disgusted  retiring  strokes  sob  vine  compose  valentine  harvey  icy  inconvenience  

 

v  pots  dimensions  abused  armor  detect  contradiction  banker  infamous  powerless  passenger  crust  historians  disclaim  norway  peculiarities  sting  simultaneously  watches  cong  episode  achieve  populace  sherman  incense  rebecca  jordan  persistent  wisconsin  ho  ta  fruitful  scoundrel  coasts  starve  denmark  scots  consultation  habitation  goat  howling  tailor  flourish  trifles  dashing  disappearance  sour  practicable  shameful  inviting  criminals  leisurely  accumulated  audible  topics  expends  radiance  underline  parade  spoils  helmet  consternation  expenditures  impose  originator  pa  unequal  wooded  enduring  ox  valet  proclaim  carl  impossibility  lydia  territories  deference  ravine  geoffrey  blanche  accommodation  boyish  spray  theological  anonymous  injurious  formally  sports  ab  scales  wyoming  discontinue  calf  manual  disturbing  potent  anticipation  melt  tilde  thames  

 

grade  mischievous  pang  pathos  alternately  brisk  stool  justification  foreigner  endeavouring  satire  al  delete  masculine  spies  umbrella  transportation  yell  remnant  boot  ignored  thrilling  ale  mineral  goose  nebraska  truce  lastly  airy  sketches  groves  col  th  comprehension  cling  duck  abyss  alaska  baffled  planning  abominable  aversion  drawings  customers  weird  stewart  traveled  alan  incessantly  flattery  director  improbable  moderation  awakening  males  pairs  temporal  con  nicely  lapse  vitality  soap  patriot  malicious  eyed  pirates  enforce  doll  briskly  sez  skeleton  comprehensive  buttons  crushing  personages  threaten  nuts  undone  wright  frankness  hides  progressive  rogers  villa  aristotle  resource  irs  confine  sewing  co  congratulate  walt  reconcile  insurance  terminated  dusky  appoint  pearl  thrilled  gains  

 

interrupt  extravagance  jokes  suppress  quod  signify  layer  clue  kettle  contemplate  aforesaid  tooth  sensibility  boldness  mature  cuba  tolerable  rabbit  befallen  needless  yankee  awaken  clasp  lets  blinded  conductor  dependence  guarantee  affectionately  player  wires  thicket  walker  outstretched  procedure  wheeled  aye  oneself  recommendation  projecting  shriek  futile  cheerfulness  deity  fifteenth  gap  muscular  dripping  insect  values  brooding  restaurant  baptism  imaginative  rhyme  exhaustion  intrigue  senseless  hercules  yearly  baron  occupying  imply  absurdity  launched  resolutely  vowed  attach  characterized  fellowship  posture  caps  leon  demanding  owl  beset  ensuring  suite  tennyson  thereto  heaped  jewel  regained  voluntarily  longitude  permanently  jumping  babe  secondly  violin  rogue  rainy  reconciliation  emotional  radical  accursed  tendencies  concrete  resident  lustre  

 

hull  ominous  overboard  uproar  cavern  combine  respectively  menace  pilgrims  jeff  peak  currency  silken  violet  khan  mastery  objective  plucked  litter  memorial  bids  fondly  clapped  tariff  beneficial  unsolicited  reluctant  separately  patronage  revenues  dragon  zeus  mike  ranges  vexation  indicates  overheard  tray  raymond  thereafter  exporting  mound  taxation  frenzy  horizontal  thirsty  disputed  charter  redistribution  boasted  item  moscow  termination  eminently  suggestive  linger  shady  calculation  expansion  mast  confer  sophia  commanders  pitied  twist  traditional  involve  interfered  achilles  wanton  repay  brother in law  routine  son in law  gaul  groom  solve  grassy  tempt  unsuccessful  witty  politician  yearning  lid  noticing  courtiers  cheering  bounty  consequent  renown  regulation  fowl  mayor  wrinkled  defy  threads  violation  junction  boss  particles  

 

glories  signifies  constrained  paternal  piles  hardware  engaging  e g  peer  counties  mocking  ch  avoiding  rebuke  abolished  cheers  idiot  rd  morbid  wrung  e mail  outcome  gilt  coldness  applying  strand  renowned  fishermen  creative  circus  moustache  proverb  lowering  biggest  sly  nursing  boon  weighing  oklahoma  brink  degraded  avenge  hum  minority  spaniard  ridges  perils  larry  merchandise  aloof  despairing  acquisition  asylum  chickens  placid  affirm  trod  gardener  schedule  calmness  protector  concealment  trench  fore  accession  h  dey  connexion  cairo  mend  considers  twenty one  municipal  achievements  cherish  deserving  exert  riot  veteran  advancement  inventor  meek  cameron  hopelessly  judicious  tending  testify  governess  orchestra  garb  condemnation  foregoing  bacon  maternal  wasting  australian  strata  hushed  maryland  sculpture  


 

miniature  corrections  tangled  completion  regulated  athenian  flavor  brand  intimately  unlimited  dipped  luggage  inconsistent  forsaken  feebly  woven  lloyd  rubbish  tool  spirited  christendom  chaos  twinkling  muffled  accents  accidentally  degradation  emancipation  prosecution  cleveland  outbreak  defending  dwarf  abundantly  turner  disadvantage  abolition  disregard  deliberation  filthy  ak  notifies  dealings  demonstrated  paced  tense  drums  interpreter  vanish  astray  hen  workman  asunder  baked  baltimore  bustle  winged  mentioning  pastoral  fabric  trim  musician  twenty two  patty  mentally  wrecked  discreet  godfrey  apostle  ledge  roast  accessed  preface  convincing  quiver  stocks  mourn  commented  redistribute  precipice  outdated  juliet  dialect  elementary  freight  cowardice  wipe  deserts  shelves  denial  b  traits  denounced  eric  underground  phantom  whirling  pecuniary  dire  hostilities  

 

gait  it'll  vividly  instruct  dickens  puritan  clutched  acknowledgment  conjunction  oppressive  intermediate  formula  hungary  sneer  ore  plentiful  plump  combinations  purest  cheat  doubly  inadequate  leslie  blest  forbear  haunt  treaties  fearless  constable  enveloped  enmity  watson  bridegroom  curate  developing  frock  mining  audacity  improper  motto  parisian  faction  architect  melting  delicately  register  heroine  indefinite  console  defensive  perceptible  fruitless  ransom  surplus  solicitude  effectual  shiver  gal  wed  contemptuous  plough  snakes  felicity  reef  outset  constitutes  lament  tissue  draft  impelled  epic  fisherman  hawaii  obstinacy  ulysses  lemon  voltaire  hound  measuring  conscientious  robber  toy  impart  statute  barry  girdle  basil  rebellious  stair  biting  consulting  perseverance  manila  massacre  cough  blazed  claude  transition  button  headache  

 

tenant  burns  harmonious  dreamy  burgundy  collections  unkind  inscribed  cushions  programme  din  laborious  manufacturing  markets  zone  humane  ac  fertility  languid  ninth  curses  introducing  alcohol  impending  declining  advantageous  heal  millennium  karl  ft  staid  planting  theatrical  spectator  winchester  greedy  commonwealth  suffrage  tremulous  commodities  stuffed  admitting  aching  ninety  discomfort  imperative  montreal  bobby  bachelor  geographical  longest  courageous  carpenter  sundays  concluding  danish  steer  influential  surround  random  ounce  afresh  dictated  ruddy  rusty  drown  irving  slide  sow  appalling  profess  sickly  rides  spoon  imminent  dominant  leadership  pinch  wearily  ducks  diary  duchess  regain  rum  churchyard  fondness  apprehend  ordinarily  quicker  thereon  ni  balloon  individuality  securely  connecting  celebrate  bluff  dawned  amiss  chalk  

 

sticking  fuss  dazed  deputy  forsake  automobile  discussions  harrison  refreshment  amendment  appealing  eden  vertical  insufficient  manchester  hem  gorge  baptized  damn  silvery  pastor  inherent  preventing  inference  advertisement  mutton  packing  enclosure  theft  publisher  spontaneous  otto  rats  apparition  refreshing  irene  sweetheart  renounce  lifeless  adore  vinegar  normandy  uncovered  utility  orphan  symbols  gracefully  mightily  peculiarity  ash  floods  partake  contemptible  deities  profane  foreseen  ti  conceit  commend  twelfth  bristol  manifestation  revive  prone  connect  princely  overtake  improving  downwards  ferocious  intervention  subsistence  susceptible  tunnel  disciple  revival  twins  ivy  puzzle  citadel  temporarily  despotism  internet  mechanism  stoop  directors  mathematics  raft  fade  soothe  pork  substituted  physically  brilliancy  dot  loaf  expanse  shocking  rudely  isle  

 

balanced  extracted  fable  matches  index  gerard  cigars  liver  transmit  dispatch  onto  veranda  dip  inexplicable  liar  diminish  dungeon  unit  pagan  phillips  brig  monopoly  rim  sordid  complaining  temperate  chat  gambling  maps  amber  trot  howl  shipping  ton  magazines  bricks  submarine  roberts  cumberland  cecil  semblance  palestine  perpendicular  regardless  fervent  sane  wreath  animation  earthquake  sloping  smoothly  tension  intrigues  fearfully  macaulay  laboratory  cork  comments  whale  wedded  whiteness  convicted  deception  paved  scruple  paintings  therewith  religions  governing  colleagues  shrinking  tickets  prophetic  undergo  hare  haze  poisonous  omit  beware  sagacity  concession  worker  ted  incline  caste  leapt  dissatisfied  hardest  self control  toilet  buddha  offense  woodland  gentry  starvation  grudge  penance  tips  rooted  outburst  

 

fortitude  turk  devour  malignant  accorded  brandon  anticipate  speechless  inquisition  eccentric  anecdote  annals  scrutiny  burroughs  rhythm  discord  marius  diversion  archie  rat  knit  correspond  detain  dis  esp  interpret  vehement  soda  naughty  salon  operate  idly  imperious  peru  candid  whig  blooming  wharf  disgraceful  stunned  redemption  drain  wage  cooper  embassy  unfinished  nasty  impetuous  cemetery  oblivion  prohibited  breeches  abound  christine  frivolous  hugo  essays  plaster  tap  chairman  dismiss  katherine  provoke  reside  deficient  decoration  heroism  toe  wade  apparel  hazel  inability  farthest  invent  knave  twain  carelessness  affectation  connections  climax  avowed  industries  brood  tempting  define  antwerp  forefathers  stretches  gratifying  plight  restricted  cupboard  ludicrous  alms  colossal  stupidity  monotony  stimulus  vigilance  digest  

 

vale  overcoat  colorado  wink  nous  rack  incomprehensible  antagonist  methinks  barley  plateau  superintendent  indescribable  expanded  presentation  archbishop  devise  rubber  adieu  exclude  carts  lone  whisky  abuses  inflict  nightfall  counts  chocolate  privileged  hermit  exultation  overtook  coincidence  scratch  screw  caravan  divert  eliza  comparing  hood  explore  glove  chaste  whirl  adventurous  skipper  tiresome  implements  recompense  plank  insure  laboured  exaggeration  mi  shepherds  lilies  ballad  befall  cylinder  teddy  summary  daresay  photographs  colleges  dissolution  geneva  marches  instituted  seals  vehemence  chaplain  knots  wail  kneel  unlikely  deceit  challenged  geography  herald  lowly  peep  swarm  clarke  joyfully  engraved  ll  bowels  purposely  blindness  systematic  virtually  conformity  remedies  maxim  indexes  marshall  baking  invincible  impertinent  bust  


 

visage  intuition  mingle  bathing  arched  investment  tabernacle   client  ghostly  furs  catalogue  dock  tenor  arouse  verbal  excessively  brazil  strenuous  irishman  recess  unclean  psalms  analogy  chemistry  peninsula  infer  maritime  secular  hawk  rein  averted  bake  constantine  oracle  alley  softness  pierce  spinning  snatch  manufactured  launch  psychology  worms  regulate  farming  fasten  actress  etiquette  theater  thanksgiving  valor  untouched  tactics  drug  adverse  gaunt  conducting  veritable  overtaken  distorted  rosa  nina  quart  caprice  candy  obliging  planets  soothed  sic  opium  pavilion  strait  sanguine  cords  odour  trout  paste  regularity  metallic  scrap  convict  instructive  investigate  celtic  package  pirate  fiend  moan  revealing  trades  rounds  accomplishments  crawl  aft  prevalent  role  dose  evans  hypocrisy  

 

l  salmon  snap  alma  magical  tire  hetty  impenetrable  geese  madly  manifold  noticeable  pudding  volcanic  locke  magnetic  deals  core  decency  observance  durst  scratched  predecessor  diplomacy  wert  impartial  disinterested  wig  pump  swedish  norfolk  reigns  similarly  reap  dam  facilities  slippery  transformation  oxygen  suburbs  dares  ornamental  pondered  fringe  raiment  henrietta  wellington  foreman  feat  thirteenth  sultan  certificate  rue  heresy  arabia  medal  location  ether  ruby  heading  subdue  adorn  ancestor  warmer  cluster  quotation  fullest  exposition  custody  thermometer  plausible  toss  desperation  rhetoric  scornful  bailey  rung  civility  dingy  scaffold  concentration  avarice  scrape  pools  oar  flutter  martyr  handy  montague  bait  login  commotion  congenial  drawers  telescope  deposits  edwards  craving  bureau  oscar  


 

speculative  huddled  diverse  slice  renaissance  angelo  meg  murderous  serenity  perspiration  coventry  impudent  ardor  necklace  alight  stimulated  clifford  steadfast  genoa  anglo saxon  courier  inflamed  xi  drill  spelling  respond  seriousness  fourteenth  womb  literal  singers  usefulness  cloudy  mortality  profusion  fleeting  twentieth  maturity  surf  weed  phases  overcame  womanhood  envious  tapped  latent  whiskey  relatively  forbidding  cleopatra  willow  mathematical  sojourn  booty  camel  implore  amateur  morally  qualifications  gasp   gliding  tested  racing  brightest  joel  extremes  damascus  labored  peggy  exit  originality  humming  isolation  sometime  glee  adult  solace  biography  ff  hardship  lied  donkey  trader  rumour  amply  confide  favors  perspective  belgian  withstand  robust  pro  val  eats  snare  monthly  wines  ignore  envoy  

 

flown  reverie  jehovah  contrive  chatter  judas  nourishment  reforms  clatter  adrian  allude  corrupted  thorn  junior  tony  calcutta  re  holt  psychological  constancy  misunderstood  signals  drying  harshly  distressing  novelist  cyril  editors  intricate  limestone  forty five  collision  pebbles  willie  knitting  ordeal  foresee  peas  repast  supplying  clan  abject  dart  berth  bridal  indirect  unnoticed  tint  insults  precedent  twisting  bully  vacation  'll  canon  aisle  click  inspiring  oval  impracticable  delirium  cedar  contradict  ingratitude  soften  bewilderment  servitude  comely  stump  redeem  spun  elastic  poultry  horseman  dictionary  prettiest  adoration  icel  wager  involving  pathway  essex  wistful  advent  gear  celebration  conceivable  drowning  faintest  acquiring  befell  good looking  wares  rendezvous  snug  watery  accompaniment  chaps  crawling  lumber  

 

publishing  customer  mediaeval  prints  lavish  md  genesis  rug  analogous  eleventh  noah  galley  partition  blunder  glasgow  fanciful  ham  rainbow  sentinel  hereby  outlook  smitten  unmarried  mice  installed  vivacity  marking  aesthetic  consume  resent  pose  contentment  sterling  veneration  p m  barking  bower  organism  unintelligible  emphatic  occurring  factors  guise  editorial  impudence  midday  corporal  sg  aright  nigger  lily  noun  scout  spit  cursing  friedrich  manifestly  marco  battalion  heritage  brotherhood  nun  wad  folding  discerned  powerfully  mitchell  helpful  persist  ellis  frigate  spotted  atoms  curves  outlet  erroneous  violated  withheld  fairies  inherit  sledge  taller  supervision  butt  handsomely  tank  velocity  arctic  colleague  pins  butcher  drowsy  butterfly  chart  twin  sunken  exasperated  narrowly  collins  insulting  

 

deficiency  operating  overthrown  gallows  diligent  hindu  blunt  omen  bleak  vehemently  wretchedness  e'er  ensure  denotes  sentenced  unfair  encampment  possessor  absorbing  descendant  sub  drugs  engineers  independently  bucket  clerical  ache  glitter  ordinance  bamboo  amsterdam  vocation  admirer  limp  pallid  mildly  organisation  timothy  dealer  yorkshire  auspicious  deuce  emblem  gibson  primarily  reducing  ritual  decorations  thigh  groaning  scant  fiscal  mien  charging  cor  railing  peers  inferred  sanctity  accumulation  cynical  inspector  wardrobe  jesuit  texture  adjustment  epistle  adventurer  priesthood  seaman  turbulent  chant  marsh  palmer  unaware  vase  ty  initial  baths  weighty  minimum  correction  morsel  overlook  meagre  unanimous  magician  mystical  twenty three  inhabit  shaggy  unaccountable  nightmare  carbon  coil  lawless  stairway  willingness  sarcasm  crisp  

 

jerk  tout  vocabulary  stroll  poorly  composing  parliamentary  controlling  fitness  thoughtless  soames  temperance  illumination  translations  martyrdom  mellow  nationality  jam  austere  shoots  casually  pensive  flavour  nets  dice  satisfactorily  shrunk  administer  ante  swine  baptist  listener  unimportant  genera  contrivance  deplorable  museum  benefactor  tints  alphabet  rout  scatter  boer  ftp  steve  extant  bohemia  misunderstanding  universities  dexterity  rag  inseparable  punch  brazen  economical  pernicious  craig  mythology  drained  bolted  abel  stride  circumference  meddle  axis  gum  las  kinder  closes  ferocity  giddy  secluded  resisting  satisfying  reliable  disgusting  thirty six  ethical  raleigh  crouching  lash  recital  buddhist  collapse  unsatisfactory  lore  varies  mainland  scot  repute  cushion  confound  scrub  myth  flights  oats  layers  ownership  cape  glimmer  


 

scare  waked  bengal  scrupulous  equals  redress  brake  nut  stability  crafty  kirk  bough  momentous  albeit  enlarge  hardness  civilised  dotted  defiant  timidity  solar  heartless  thomson  mat  shun  raid  disclose  suppression  puff  juncture  beak  unjustly  foresaw  rot  aggressive  predicted  quaker  grate  lease  ponderous  maketh  repaid  charcoal  chilly  arrogance  friction  participation  pier  stale  intoxicated  commissioned  ratio   comb  masterpiece  wholesale  embraces  trodden  ephraim  shaw  translate  mortar  recreation  rite  truthful  cavalier  caress  si  curling  rivalry  whim  abreast  thebes  faust  peg  wilhelm  pestilence  ceremonial  receiver  sample  distinctive  consummate  matron  claiming  plural  initiative  inexhaustible  a m  spider  reed  streak  blocked  titus  smashed  populous  baronet  commodore  jelly  advocates  dinah  

 

salutation  mutiny  chronicles  comforting  serviceable  parchment  playful  potato  transient  administrative  anarchy  barber  revision  operated  farce  germ  profile  provides  noting  disordered  menacing  heightened  finance  averse  azure  bathe  campaigns  lessen  slate  acquaint  gin  humiliating  cleft  conveyance  chivalrous  capricious  tribune  pilgrim  entreaty  womanly  paltry  sporting  maker  digestion  bart  infamy  lambs  gaping  periodical  standpoint  amorous  tub  luxuriant  basic  mutually  chris  greed  premature  extinction  boiler  intimation  scandalous  separating  oratory  banish  electrical  herb  multiply  prosper  friar  nightly  ole  monkeys  interminable  enjoys  similarity  riddle  cleaning  subscription  copious  exclaim  forged  voting  scourge  darkly  privacy  arena  bearded  vera  alacrity  sensual  spin  neutrality  flannel  fasting  trailer  avert  trustworthy  jamaica  unchanged  

 

traveler  unfamiliar  puffed  mirrors  phoebe  father in law  conform  particle  railways  stupendous  paddle  innate  reformation  volley  statistics  agrees  simpler  padre  congratulations  lids  muse  inhabitant  ishmael  rustle  clump  calendar  flute  inaccessible  yore  jay  repulsive  fray  po  nomination  conclusive  peaceable  beth  inconceivable  e'en  emerald  lava  trillion  uppermost  arduous  lyric  downright  reproduction  foresight  consistency  ape  senators  pallor  span  salad  snuff  drooped  greetings  chestnut  inquisitive  vicar  noel  attic  savings  affirmative  ills  applications  t  dye  gloucester  nominal  demonstrate  dispense  dissatisfaction  merciless  trusty  coloring  perusal  plaintive  discarded  precarious  infection  ruinous  bolts  arithmetic  considerate  lark  ethics  conventions  stumbling  pitcher  slips  seine  officially  danube  annoy  glide  impunity  amends  sol  conveying  

 

abandonment  mane  tinge  brim  forenoon  seventy five  sparkle  syllables  shrug  enchantment  franz  trait  bribe  composer  preparatory  audacious  outskirts  soiled  fiddle  football  isaiah  partnership  continuation  pioneer  vest  bass  derby  quarry  rigging  dizzy  abnormal  omission  idolatry  sequence  squeeze  cabbage  canopy  athletic  shirley  drunkenness  intrusion  'cause  assign  tackle  dreamt  sceptre  exacting  parched  eddy  percentage  twinkle  curb  sandstone  invaluable  fathom  preferable  adelaide  advertising  scraps  lever  muster  cavity  barbarian  sleepless  fried  abstraction  forefinger  spade  erection  scorned  pail  withdrawal  senator  mortgage  ancestral  succour  ma  forbearance  repress  spouse  valid  witchcraft  workmanship  legacy  proximity  bombay  paula  incorporated  muzzle  reuben  clusters  valve  compelling  dissipated  flickering  guinea  sup  tarry  derision  vehicles  

 

accommodate  glossy  iris  relic  ant  heath  bug  vocal  downfall  construct  undue  vapor  bat  whimsical  contradictory  unlocked  foretold  automatic  explicit  indolent  mates  artful  downcast  well being  winston  ordinances  catharine  effectively  missions  stalk  indistinct  pregnant  reddish  coveted  fret  peeping  buck  sumptuous  indefinitely  reliance  panama  cocked  dad  everyday  intoxication  aghast  subterranean  turmoil  forfeit  chasm  inspect  perverse  precipitate  dover  ambush  evermore  mass  blot  nook  verdure  parapet  jake  cessation  ankle  classification  fervently  oddly  haul  saxony  embarrassing  hairy  northwest  disabled  laurel  preston  arrogant  hurts  demonstrations  splash  curl  livelihood  wary  scattering  brace  converts  detestable   abandoning  somerset  weakly  clothe  gem  tremor  surveying  variable  anniversary  thirty two  wrap  curly  diversity  


 

prestige  desertion  freezing  heedless  sentry  believer  ram  rowing  negligence  self  sulphur  discrimination  cooling  millionaire  flowering  meridian  wins  awed  beastly  nuisance  abstain  continental  stanza  target  unwonted  whit  jason  stall  sham  dictate  empress  gout  jobs  manure  nigel  sidewalk  sate  grievance  axes  bony  invest  birmingham  ebb  rabble  restlessness  cruise  rally  rumor  hysterical  girlish  actively  shortest  marseilles  cheque  disregarded  retort  rocking  emerge  perch  flask  ka  countryman  lonesome  manned  unarmed  wast  frog  twenty eight  unscrupulous  yarn  victuals  outrageous  appropriation  foolishness  quickness  adversity  parma  diseased  iliad  salutary  smelt  territorial  hurricane  irons  canyon  jeremiah  brooklyn  indulging  vapour  disobedience  atrocious  leaps  tapestry  provocation  twenty six  impotent  smite  acquitted  os  tumultuous  

 

barge  palpable  apprentice  lances  compartment  godly  sarcastic  therefrom  specifically  uniformity  emerging  atonement  whereabouts  davy  framework  sponge  mountainous  annoying  cot  squirrel  wand  grind  bang  unreal  blacksmith  injunction  scarcity  withhold  outright  bavaria  cement  growl  aggregate  fraction  exaltation  inexorable  jug  purer  sap  illegal  sister in law  presses  stealthily  dissolve  volcano  hungarian  equilibrium  obstinately  sullenly  assassination  commissions  respectability  bases  maxwell  resounded  closest  embroidery  gunpowder  reproof  yale  combining  weaving  earnings  hamburg  indoors  manufacturers  pitiless  scarf  picnic  misled  pompous  brian  respite  exploit  tracing  geological  passport  confines  dishonour  executioner  township  vacancy  acquiescence  cornwall  crumbling  three quarters  exploration  needy  stationary  disconcerted  wanderer  beaver  lookout  onion  depicted  boisterous  couples  speakers  woollen  lightness  

 

bitten  aux  toleration  lucia  scar  bohemian  vested  affinity  carlo  sous  penitent  simpson  abiding  ca  immoral  dishonest  yawning  mustache  supplement  whirlwind  clash  terence  lamentable  bennett  farthing  speck  biscuit  appellation  gdp  reserves  uncouth  birch  armchair  judy  greasy  leaden  dough  lining  cleverness  ascetic  clutch  krishna  embark  quotations  friendliness  liberally  trance  untrue  rejection  grating  hanover  inexperienced  mon  wintry  stalwart  meats  stamping  variance  apiece  firmament  absorption  apprehensive  terminate  wilful  conveniently  'n'  cleanliness  collective  angela  filth  philippines  timely  herein  ignoble  canton  lamentations  moslem  ware  adjective  glen  invade  livid  buggy  prolong  weaken  folio  dismissal  quay  enchanting  heave  purified  syrian  significantly  experimental  film  repressed  cooperation  sequel  wench  calves  
Retrieved from "http //en wiktionary org/wiki/Wiktionary Frequency_lists/PG/ / / "

def g():
  global big
  big = file('big.txt').read()
  N = len(big)
  s = set()
  for i in xrange(6, N):
    c = big[i]
    if ord(c) > 127 and c not in s:
        print i, c, ord(c), big[max(0, i-10):min(N, i+10)]
        s.add(c)
  print s
  print [ord(c) for c in s]

I433
L610
LD637K
I122K
Rank190K
Summary reportDiagnosisDensity00n/a`;